(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.cH.D0 === region.cw.D0)
	{
		return 'on line ' + region.cH.D0;
	}
	return 'on lines ' + region.cH.D0 + ' through ' + region.cw.D0;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.CY,
		impl.GR,
		impl.Gl,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	result = init(result.a);
	var model = result.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		result = A2(update, msg, model);
		stepper(model = result.a, viewMetadata);
		_Platform_enqueueEffects(managers, result.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, result.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS
//
// For some reason, tabs can appear in href protocols and it still works.
// So '\tjava\tSCRIPT:alert("!!!")' and 'javascript:alert("!!!")' are the same
// in practice. That is why _VirtualDom_RE_js and _VirtualDom_RE_js_html look
// so freaky.
//
// Pulling the regular expressions out to the top level gives a slight speed
// boost in small benchmarks (4-10%) but hoisting values to reduce allocation
// can be unpredictable in large programs where JIT may have a harder time with
// functions are not fully self-contained. The benefit is more that the js and
// js_html ones are so weird that I prefer to see them near each other.


var _VirtualDom_RE_script = /^script$/i;
var _VirtualDom_RE_on_formAction = /^(on|formAction$)/i;
var _VirtualDom_RE_js = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
var _VirtualDom_RE_js_html = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;


function _VirtualDom_noScript(tag)
{
	return _VirtualDom_RE_script.test(tag) ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return _VirtualDom_RE_on_formAction.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return _VirtualDom_RE_js.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return _VirtualDom_RE_js_html.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlJson(value)
{
	return (typeof _Json_unwrap(value) === 'string' && _VirtualDom_RE_js_html.test(_Json_unwrap(value)))
		? _Json_wrap(
			/**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		) : value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		Eh: func(record.Eh),
		Gj: record.Gj,
		Fo: record.Fo
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.Eh;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.Gj;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.Fo) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.CY,
		impl.GR,
		impl.Gl,
		function(sendToApp, initialModel) {
			var view = impl.G4;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.CY,
		impl.GR,
		impl.Gl,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.v7 && impl.v7(sendToApp)
			var view = impl.G4;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.getElementById('elm-root');
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('div')(_List_Nil)(doc.sY);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.Gy) && (_VirtualDom_doc.title = title = doc.Gy);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.EQ;
	var onUrlRequest = impl.ER;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		v7: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.Ft === next.Ft
							&& curr.t0 === next.t0
							&& curr.Fk.a === next.Fk.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		CY: function(flags)
		{
			return A3(impl.CY, flags, _Browser_getUrl(), key);
		},
		G4: impl.G4,
		GR: impl.GR,
		Gl: impl.Gl
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { CQ: 'hidden', Bv: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { CQ: 'mozHidden', Bv: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { CQ: 'msHidden', Bv: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { CQ: 'webkitHidden', Bv: 'webkitvisibilitychange' }
		: { CQ: 'hidden', Bv: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		FT: _Browser_getScene(),
		AM: {
			AS: _Browser_window.pageXOffset,
			AT: _Browser_window.pageYOffset,
			AR: _Browser_doc.documentElement.clientWidth,
			CO: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		AR: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		CO: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			FT: {
				AR: node.scrollWidth,
				CO: node.scrollHeight
			},
			AM: {
				AS: node.scrollLeft,
				AT: node.scrollTop,
				AR: node.clientWidth,
				CO: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			FT: _Browser_getScene(),
			AM: {
				AS: x,
				AT: y,
				AR: _Browser_doc.documentElement.clientWidth,
				CO: _Browser_doc.documentElement.clientHeight
			},
			Cn: {
				AS: x + rect.left,
				AT: y + rect.top,
				AR: rect.width,
				CO: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});


// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.Eo) { flags += 'm'; }
	if (options.Bu) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}



// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.Cy.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.Cy.b, xhr)); });
		$elm$core$Maybe$isJust(request.GL) && _Http_track(router, xhr, request.GL.a);

		try {
			xhr.open(request.my, request.GT, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.GT));
		}

		_Http_configureRequest(xhr, request);

		request.sY.a && xhr.setRequestHeader('Content-Type', request.sY.a);
		xhr.send(request.sY.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.CN; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.nE.a || 0;
	xhr.responseType = request.Cy.d;
	xhr.withCredentials = request.A5;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		GT: xhr.responseURL,
		wp: xhr.status,
		wq: xhr.statusText,
		CN: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			F_: event.loaded,
			we: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			Fx: event.loaded,
			we: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}

// BYTES

function _Bytes_width(bytes)
{
	return bytes.byteLength;
}

var _Bytes_getHostEndianness = F2(function(le, be)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(new Uint8Array(new Uint32Array([1]))[0] === 1 ? le : be));
	});
});


// ENCODERS

function _Bytes_encode(encoder)
{
	var mutableBytes = new DataView(new ArrayBuffer($elm$bytes$Bytes$Encode$getWidth(encoder)));
	$elm$bytes$Bytes$Encode$write(encoder)(mutableBytes)(0);
	return mutableBytes;
}


// SIGNED INTEGERS

var _Bytes_write_i8  = F3(function(mb, i, n) { mb.setInt8(i, n); return i + 1; });
var _Bytes_write_i16 = F4(function(mb, i, n, isLE) { mb.setInt16(i, n, isLE); return i + 2; });
var _Bytes_write_i32 = F4(function(mb, i, n, isLE) { mb.setInt32(i, n, isLE); return i + 4; });


// UNSIGNED INTEGERS

var _Bytes_write_u8  = F3(function(mb, i, n) { mb.setUint8(i, n); return i + 1 ;});
var _Bytes_write_u16 = F4(function(mb, i, n, isLE) { mb.setUint16(i, n, isLE); return i + 2; });
var _Bytes_write_u32 = F4(function(mb, i, n, isLE) { mb.setUint32(i, n, isLE); return i + 4; });


// FLOATS

var _Bytes_write_f32 = F4(function(mb, i, n, isLE) { mb.setFloat32(i, n, isLE); return i + 4; });
var _Bytes_write_f64 = F4(function(mb, i, n, isLE) { mb.setFloat64(i, n, isLE); return i + 8; });


// BYTES

var _Bytes_write_bytes = F3(function(mb, offset, bytes)
{
	for (var i = 0, len = bytes.byteLength, limit = len - 4; i <= limit; i += 4)
	{
		mb.setUint32(offset + i, bytes.getUint32(i));
	}
	for (; i < len; i++)
	{
		mb.setUint8(offset + i, bytes.getUint8(i));
	}
	return offset + len;
});


// STRINGS

function _Bytes_getStringWidth(string)
{
	for (var width = 0, i = 0; i < string.length; i++)
	{
		var code = string.charCodeAt(i);
		width +=
			(code < 0x80) ? 1 :
			(code < 0x800) ? 2 :
			(code < 0xD800 || 0xDBFF < code) ? 3 : (i++, 4);
	}
	return width;
}

var _Bytes_write_string = F3(function(mb, offset, string)
{
	for (var i = 0; i < string.length; i++)
	{
		var code = string.charCodeAt(i);
		offset +=
			(code < 0x80)
				? (mb.setUint8(offset, code)
				, 1
				)
				:
			(code < 0x800)
				? (mb.setUint16(offset, 0xC080 /* 0b1100000010000000 */
					| (code >>> 6 & 0x1F /* 0b00011111 */) << 8
					| code & 0x3F /* 0b00111111 */)
				, 2
				)
				:
			(code < 0xD800 || 0xDBFF < code)
				? (mb.setUint16(offset, 0xE080 /* 0b1110000010000000 */
					| (code >>> 12 & 0xF /* 0b00001111 */) << 8
					| code >>> 6 & 0x3F /* 0b00111111 */)
				, mb.setUint8(offset + 2, 0x80 /* 0b10000000 */
					| code & 0x3F /* 0b00111111 */)
				, 3
				)
				:
			(code = (code - 0xD800) * 0x400 + string.charCodeAt(++i) - 0xDC00 + 0x10000
			, mb.setUint32(offset, 0xF0808080 /* 0b11110000100000001000000010000000 */
				| (code >>> 18 & 0x7 /* 0b00000111 */) << 24
				| (code >>> 12 & 0x3F /* 0b00111111 */) << 16
				| (code >>> 6 & 0x3F /* 0b00111111 */) << 8
				| code & 0x3F /* 0b00111111 */)
			, 4
			);
	}
	return offset;
});


// DECODER

var _Bytes_decode = F2(function(decoder, bytes)
{
	try {
		return $elm$core$Maybe$Just(A2(decoder, bytes, 0).b);
	} catch(e) {
		return $elm$core$Maybe$Nothing;
	}
});

var _Bytes_read_i8  = F2(function(      bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getInt8(offset)); });
var _Bytes_read_i16 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getInt16(offset, isLE)); });
var _Bytes_read_i32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getInt32(offset, isLE)); });
var _Bytes_read_u8  = F2(function(      bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getUint8(offset)); });
var _Bytes_read_u16 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getUint16(offset, isLE)); });
var _Bytes_read_u32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getUint32(offset, isLE)); });
var _Bytes_read_f32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getFloat32(offset, isLE)); });
var _Bytes_read_f64 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 8, bytes.getFloat64(offset, isLE)); });

var _Bytes_read_bytes = F3(function(len, bytes, offset)
{
	return _Utils_Tuple2(offset + len, new DataView(bytes.buffer, bytes.byteOffset + offset, len));
});

var _Bytes_read_string = F3(function(len, bytes, offset)
{
	var string = '';
	var end = offset + len;
	for (; offset < end;)
	{
		var byte = bytes.getUint8(offset++);
		string +=
			(byte < 128)
				? String.fromCharCode(byte)
				:
			((byte & 0xE0 /* 0b11100000 */) === 0xC0 /* 0b11000000 */)
				? String.fromCharCode((byte & 0x1F /* 0b00011111 */) << 6 | bytes.getUint8(offset++) & 0x3F /* 0b00111111 */)
				:
			((byte & 0xF0 /* 0b11110000 */) === 0xE0 /* 0b11100000 */)
				? String.fromCharCode(
					(byte & 0xF /* 0b00001111 */) << 12
					| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 6
					| bytes.getUint8(offset++) & 0x3F /* 0b00111111 */
				)
				:
				(byte =
					((byte & 0x7 /* 0b00000111 */) << 18
						| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 12
						| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 6
						| bytes.getUint8(offset++) & 0x3F /* 0b00111111 */
					) - 0x10000
				, String.fromCharCode(Math.floor(byte / 0x400) + 0xD800, byte % 0x400 + 0xDC00)
				);
	}
	return _Utils_Tuple2(offset, string);
});

var _Bytes_decodeFailure = F2(function() { throw 0; });



// DECODER

var _File_decoder = _Json_decodePrim(function(value) {
	// NOTE: checks if `File` exists in case this is run on node
	return (typeof File !== 'undefined' && value instanceof File)
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FILE', value);
});


// METADATA

function _File_name(file) { return file.name; }
function _File_mime(file) { return file.type; }
function _File_size(file) { return file.size; }

function _File_lastModified(file)
{
	return $elm$time$Time$millisToPosix(file.lastModified);
}


// DOWNLOAD

var _File_downloadNode;

function _File_getDownloadNode()
{
	return _File_downloadNode || (_File_downloadNode = document.createElement('a'));
}

var _File_download = F3(function(name, mime, content)
{
	return _Scheduler_binding(function(callback)
	{
		var blob = new Blob([content], {type: mime});

		// for IE10+
		if (navigator.msSaveOrOpenBlob)
		{
			navigator.msSaveOrOpenBlob(blob, name);
			return;
		}

		// for HTML5
		var node = _File_getDownloadNode();
		var objectUrl = URL.createObjectURL(blob);
		node.href = objectUrl;
		node.download = name;
		_File_click(node);
		URL.revokeObjectURL(objectUrl);
	});
});

function _File_downloadUrl(href)
{
	return _Scheduler_binding(function(callback)
	{
		var node = _File_getDownloadNode();
		node.href = href;
		node.download = '';
		node.origin === location.origin || (node.target = '_blank');
		_File_click(node);
	});
}


// IE COMPATIBILITY

function _File_makeBytesSafeForInternetExplorer(bytes)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/10
	// all other browsers can just run `new Blob([bytes])` directly with no problem
	//
	return new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
}

function _File_click(node)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/11
	// all other browsers have MouseEvent and do not need this conditional stuff
	//
	if (typeof MouseEvent === 'function')
	{
		node.dispatchEvent(new MouseEvent('click'));
	}
	else
	{
		var event = document.createEvent('MouseEvents');
		event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		document.body.appendChild(node);
		node.dispatchEvent(event);
		document.body.removeChild(node);
	}
}


// UPLOAD

var _File_node;

function _File_uploadOne(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			callback(_Scheduler_succeed(event.target.files[0]));
		});
		_File_click(_File_node);
	});
}

function _File_uploadOneOrMore(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.multiple = true;
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			var elmFiles = _List_fromArray(event.target.files);
			callback(_Scheduler_succeed(_Utils_Tuple2(elmFiles.a, elmFiles.b)));
		});
		_File_click(_File_node);
	});
}


// CONTENT

function _File_toString(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsText(blob);
		return function() { reader.abort(); };
	});
}

function _File_toBytes(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(new DataView(reader.result)));
		});
		reader.readAsArrayBuffer(blob);
		return function() { reader.abort(); };
	});
}

function _File_toUrl(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsDataURL(blob);
		return function() { reader.abort(); };
	});
}

var $author$project$Msg$LinkClicked = function (a) {
	return {$: 9, a: a};
};
var $author$project$Msg$SetRoute = function (a) {
	return {$: 62, a: a};
};
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.dt) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.eQ),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.eQ);
		} else {
			var treeLen = builder.dt * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.fe) : builder.fe;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.dt);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.eQ) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.eQ);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{fe: nodeList, dt: (len / $elm$core$Array$branchFactor) | 0, eQ: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {oD: fragment, t0: host, pm: path, Fk: port_, Ft: protocol, r1: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$json$Json$Decode$field = _Json_decodeField;
var $author$project$Page$Blank = {$: 0};
var $author$project$Main$NotLoading = {$: 0};
var $author$project$Msg$OnCurrentTimeUpdate = function (a) {
	return {$: 8, a: a};
};
var $author$project$Msg$OnRenew = F2(
	function (a, b) {
		return {$: 64, a: a, b: b};
	});
var $author$project$Msg$SessionMsg = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $author$project$Model$Session$GotTimezone = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$Session$LocalStorageMsg = function (a) {
	return {$: 4, a: a};
};
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$here = _Time_here(0);
var $author$project$Model$LocalStorage$Model = $elm$core$Basics$identity;
var $author$project$Model$LocalStorage$lastOrganizationKey = 'lastOrganization';
var $author$project$Model$LocalStorage$superUserFeaturesHiddenKey = 'superUserFeaturesHidden';
var $author$project$Model$LocalStorage$themeKey = 'displayTheme';
var $author$project$Model$LocalStorage$allKeys = _List_fromArray(
	[$author$project$Model$LocalStorage$lastOrganizationKey, $author$project$Model$LocalStorage$superUserFeaturesHiddenKey, $author$project$Model$LocalStorage$themeKey]);
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Ports$requestLocalStorage = _Platform_outgoingPort('requestLocalStorage', $elm$json$Json$Encode$string);
var $author$project$Misc$with = F2(
	function (b, a) {
		return _Utils_Tuple2(a, b);
	});
var $author$project$Model$LocalStorage$init = A2(
	$author$project$Misc$with,
	$elm$core$Platform$Cmd$batch(
		A2($elm$core$List$map, $author$project$Ports$requestLocalStorage, $author$project$Model$LocalStorage$allKeys)),
	$elm$core$Dict$empty);
var $author$project$Model$Session$Session = $elm$core$Basics$identity;
var $author$project$Protected$State = $elm$core$Basics$identity;
var $author$project$Protected$empty = $elm$core$Maybe$Nothing;
var $author$project$Model$BuildPlannerCache$BuildPlannerCache = $elm$core$Basics$identity;
var $author$project$Model$BuildPlannerCache$init = {jI: $elm$core$Dict$empty, od: $elm$core$Dict$empty};
var $author$project$Views$NotificationsGlobal$Notifications = $elm$core$Basics$identity;
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $author$project$Views$NotificationsGlobal$init = {
	cF: $elm$time$Time$millisToPosix(0),
	oK: 0,
	mN: _List_Nil
};
var $author$project$Model$Session$getCreds = function (_v0) {
	var session = _v0;
	return session.tu;
};
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $simonh1000$elm_jwt$Jwt$TokenDecodeError = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $simonh1000$elm_jwt$Jwt$TokenHeaderError = {$: 2};
var $simonh1000$elm_jwt$Jwt$TokenProcessingError = function (a) {
	return {$: 0, a: a};
};
var $truqu$elm_base64$Base64$Decode$pad = function (input) {
	var _v0 = $elm$core$String$length(input) % 4;
	switch (_v0) {
		case 3:
			return input + '=';
		case 2:
			return input + '==';
		default:
			return input;
	}
};
var $truqu$elm_base64$Base64$Decode$charToInt = function (_char) {
	switch (_char) {
		case 'A':
			return 0;
		case 'B':
			return 1;
		case 'C':
			return 2;
		case 'D':
			return 3;
		case 'E':
			return 4;
		case 'F':
			return 5;
		case 'G':
			return 6;
		case 'H':
			return 7;
		case 'I':
			return 8;
		case 'J':
			return 9;
		case 'K':
			return 10;
		case 'L':
			return 11;
		case 'M':
			return 12;
		case 'N':
			return 13;
		case 'O':
			return 14;
		case 'P':
			return 15;
		case 'Q':
			return 16;
		case 'R':
			return 17;
		case 'S':
			return 18;
		case 'T':
			return 19;
		case 'U':
			return 20;
		case 'V':
			return 21;
		case 'W':
			return 22;
		case 'X':
			return 23;
		case 'Y':
			return 24;
		case 'Z':
			return 25;
		case 'a':
			return 26;
		case 'b':
			return 27;
		case 'c':
			return 28;
		case 'd':
			return 29;
		case 'e':
			return 30;
		case 'f':
			return 31;
		case 'g':
			return 32;
		case 'h':
			return 33;
		case 'i':
			return 34;
		case 'j':
			return 35;
		case 'k':
			return 36;
		case 'l':
			return 37;
		case 'm':
			return 38;
		case 'n':
			return 39;
		case 'o':
			return 40;
		case 'p':
			return 41;
		case 'q':
			return 42;
		case 'r':
			return 43;
		case 's':
			return 44;
		case 't':
			return 45;
		case 'u':
			return 46;
		case 'v':
			return 47;
		case 'w':
			return 48;
		case 'x':
			return 49;
		case 'y':
			return 50;
		case 'z':
			return 51;
		case '0':
			return 52;
		case '1':
			return 53;
		case '2':
			return 54;
		case '3':
			return 55;
		case '4':
			return 56;
		case '5':
			return 57;
		case '6':
			return 58;
		case '7':
			return 59;
		case '8':
			return 60;
		case '9':
			return 61;
		case '+':
			return 62;
		case '/':
			return 63;
		default:
			return 0;
	}
};
var $elm$core$Bitwise$or = _Bitwise_or;
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Char$fromCode = _Char_fromCode;
var $truqu$elm_base64$Base64$Decode$intToString = A2($elm$core$Basics$composeR, $elm$core$Char$fromCode, $elm$core$String$fromChar);
var $truqu$elm_base64$Base64$Decode$add = F2(
	function (_char, _v0) {
		var curr = _v0.a;
		var need = _v0.b;
		var res = _v0.c;
		var shiftAndAdd = function (_int) {
			return (63 & _int) | (curr << 6);
		};
		return (!need) ? ((!(128 & _char)) ? _Utils_Tuple3(
			0,
			0,
			_Utils_ap(
				res,
				$truqu$elm_base64$Base64$Decode$intToString(_char))) : (((224 & _char) === 192) ? _Utils_Tuple3(31 & _char, 1, res) : (((240 & _char) === 224) ? _Utils_Tuple3(15 & _char, 2, res) : _Utils_Tuple3(7 & _char, 3, res)))) : ((need === 1) ? _Utils_Tuple3(
			0,
			0,
			_Utils_ap(
				res,
				$truqu$elm_base64$Base64$Decode$intToString(
					shiftAndAdd(_char)))) : _Utils_Tuple3(
			shiftAndAdd(_char),
			need - 1,
			res));
	});
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $truqu$elm_base64$Base64$Decode$toUTF16 = F2(
	function (_char, acc) {
		return _Utils_Tuple3(
			0,
			0,
			A2(
				$truqu$elm_base64$Base64$Decode$add,
				255 & (_char >>> 0),
				A2(
					$truqu$elm_base64$Base64$Decode$add,
					255 & (_char >>> 8),
					A2($truqu$elm_base64$Base64$Decode$add, 255 & (_char >>> 16), acc))));
	});
var $truqu$elm_base64$Base64$Decode$chomp = F2(
	function (char_, _v0) {
		var curr = _v0.a;
		var cnt = _v0.b;
		var utf8ToUtf16 = _v0.c;
		var _char = $truqu$elm_base64$Base64$Decode$charToInt(char_);
		if (cnt === 3) {
			return A2($truqu$elm_base64$Base64$Decode$toUTF16, curr | _char, utf8ToUtf16);
		} else {
			return _Utils_Tuple3((_char << ((3 - cnt) * 6)) | curr, cnt + 1, utf8ToUtf16);
		}
	});
var $elm$core$String$foldl = _String_foldl;
var $truqu$elm_base64$Base64$Decode$initial = _Utils_Tuple3(
	0,
	0,
	_Utils_Tuple3(0, 0, ''));
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$core$String$dropRight = F2(
	function (n, string) {
		return (n < 1) ? string : A3($elm$core$String$slice, 0, -n, string);
	});
var $elm$core$String$endsWith = _String_endsWith;
var $truqu$elm_base64$Base64$Decode$stripNulls = F2(
	function (input, output) {
		return A2($elm$core$String$endsWith, '==', input) ? A2($elm$core$String$dropRight, 2, output) : (A2($elm$core$String$endsWith, '=', input) ? A2($elm$core$String$dropRight, 1, output) : output);
	});
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {j$: index, o0: match, m: number, wu: submatches};
	});
var $elm$regex$Regex$contains = _Regex_contains;
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{Bu: false, Eo: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $truqu$elm_base64$Base64$Decode$validBase64Regex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^([A-Za-z0-9\\/+]{4})*([A-Za-z0-9\\/+]{2}[A-Za-z0-9\\/+=]{2})?$'));
var $truqu$elm_base64$Base64$Decode$validate = function (input) {
	return A2($elm$regex$Regex$contains, $truqu$elm_base64$Base64$Decode$validBase64Regex, input) ? $elm$core$Result$Ok(input) : $elm$core$Result$Err('Invalid base64');
};
var $truqu$elm_base64$Base64$Decode$wrapUp = function (_v0) {
	var _v1 = _v0.c;
	var need = _v1.b;
	var res = _v1.c;
	return (need > 0) ? $elm$core$Result$Err('Invalid UTF-16') : $elm$core$Result$Ok(res);
};
var $truqu$elm_base64$Base64$Decode$validateAndDecode = function (input) {
	return A2(
		$elm$core$Result$map,
		$truqu$elm_base64$Base64$Decode$stripNulls(input),
		A2(
			$elm$core$Result$andThen,
			A2(
				$elm$core$Basics$composeR,
				A2($elm$core$String$foldl, $truqu$elm_base64$Base64$Decode$chomp, $truqu$elm_base64$Base64$Decode$initial),
				$truqu$elm_base64$Base64$Decode$wrapUp),
			$truqu$elm_base64$Base64$Decode$validate(input)));
};
var $truqu$elm_base64$Base64$Decode$decode = A2($elm$core$Basics$composeR, $truqu$elm_base64$Base64$Decode$pad, $truqu$elm_base64$Base64$Decode$validateAndDecode);
var $truqu$elm_base64$Base64$decode = $truqu$elm_base64$Base64$Decode$decode;
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $elm$core$Basics$modBy = _Basics_modBy;
var $simonh1000$elm_jwt$Jwt$fixlength = function (s) {
	var _v0 = A2(
		$elm$core$Basics$modBy,
		4,
		$elm$core$String$length(s));
	switch (_v0) {
		case 0:
			return $elm$core$Result$Ok(s);
		case 2:
			return $elm$core$Result$Ok(
				$elm$core$String$concat(
					_List_fromArray(
						[s, '=='])));
		case 3:
			return $elm$core$Result$Ok(
				$elm$core$String$concat(
					_List_fromArray(
						[s, '='])));
		default:
			return $elm$core$Result$Err(
				$simonh1000$elm_jwt$Jwt$TokenProcessingError('Wrong length'));
	}
};
var $elm$core$Result$map2 = F3(
	function (func, ra, rb) {
		if (ra.$ === 1) {
			var x = ra.a;
			return $elm$core$Result$Err(x);
		} else {
			var a = ra.a;
			if (rb.$ === 1) {
				var x = rb.a;
				return $elm$core$Result$Err(x);
			} else {
				var b = rb.a;
				return $elm$core$Result$Ok(
					A2(func, a, b));
			}
		}
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$core$String$map = _String_map;
var $simonh1000$elm_jwt$Jwt$unurl = function () {
	var fix = function (c) {
		switch (c) {
			case '-':
				return '+';
			case '_':
				return '/';
			default:
				return c;
		}
	};
	return $elm$core$String$map(fix);
}();
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $simonh1000$elm_jwt$Jwt$getTokenParts = function (token) {
	var verifyJson = F2(
		function (errorHandler, str) {
			return A2(
				$elm$core$Result$mapError,
				errorHandler,
				A2(
					$elm$core$Result$map,
					function (_v9) {
						return str;
					},
					A2($elm$json$Json$Decode$decodeString, $elm$json$Json$Decode$value, str)));
		});
	var processor = A2(
		$elm$core$Basics$composeR,
		$simonh1000$elm_jwt$Jwt$unurl,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$String$split('.'),
			$elm$core$List$map($simonh1000$elm_jwt$Jwt$fixlength)));
	var _v0 = processor(token);
	_v0$1:
	while (true) {
		if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.b.b)) {
			if (!_v0.a.$) {
				if (!_v0.b.a.$) {
					var header = _v0.a.a;
					var _v1 = _v0.b;
					var body = _v1.a.a;
					var _v2 = _v1.b;
					var header_ = A2(
						$elm$core$Result$andThen,
						verifyJson(
							function (_v4) {
								return $simonh1000$elm_jwt$Jwt$TokenHeaderError;
							}),
						A2(
							$elm$core$Result$mapError,
							function (_v3) {
								return $simonh1000$elm_jwt$Jwt$TokenHeaderError;
							},
							$truqu$elm_base64$Base64$decode(header)));
					var body_ = A2(
						$elm$core$Result$andThen,
						verifyJson($simonh1000$elm_jwt$Jwt$TokenDecodeError),
						A2(
							$elm$core$Result$mapError,
							$simonh1000$elm_jwt$Jwt$TokenProcessingError,
							$truqu$elm_base64$Base64$decode(body)));
					return A3(
						$elm$core$Result$map2,
						F2(
							function (a, b) {
								return _Utils_Tuple2(a, b);
							}),
						header_,
						body_);
				} else {
					break _v0$1;
				}
			} else {
				if (_v0.b.a.$ === 1) {
					break _v0$1;
				} else {
					var err = _v0.a.a;
					var _v7 = _v0.b;
					var _v8 = _v7.b;
					return $elm$core$Result$Err(err);
				}
			}
		} else {
			return $elm$core$Result$Err(
				$simonh1000$elm_jwt$Jwt$TokenProcessingError('Token has invalid shape'));
		}
	}
	var _v5 = _v0.b;
	var err = _v5.a.a;
	var _v6 = _v5.b;
	return $elm$core$Result$Err(err);
};
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $simonh1000$elm_jwt$Jwt$decodeToken = F2(
	function (dec, token) {
		return A2(
			$elm$core$Result$andThen,
			A2(
				$elm$core$Basics$composeR,
				$elm$json$Json$Decode$decodeString(dec),
				$elm$core$Result$mapError($simonh1000$elm_jwt$Jwt$TokenDecodeError)),
			A2(
				$elm$core$Result$map,
				$elm$core$Tuple$second,
				$simonh1000$elm_jwt$Jwt$getTokenParts(token)));
	});
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$Basics$neq = _Utils_notEqual;
var $elm$json$Json$Decode$string = _Json_decodeString;
var $elm$core$Result$toMaybe = function (result) {
	if (!result.$) {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Protected$isImpersonating = function (_v0) {
	var creds = _v0;
	return !_Utils_eq(
		$elm$core$Maybe$Nothing,
		A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				$simonh1000$elm_jwt$Jwt$decodeToken(
					A2($elm$json$Json$Decode$field, 'original_uid', $elm$json$Json$Decode$string)),
				$elm$core$Result$toMaybe),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.GI;
				},
				creds)));
};
var $author$project$Model$Session$isImpersonating = function (session) {
	return $author$project$Protected$isImpersonating(
		$author$project$Model$Session$getCreds(session));
};
var $elm$json$Json$Encode$bool = _Json_wrap;
var $author$project$Ports$setIsImpersonating = _Platform_outgoingPort('setIsImpersonating', $elm$json$Json$Encode$bool);
var $author$project$Model$Session$initInternal = F3(
	function (flags, localTimezone, localStorage) {
		var newSession = {s$: $author$project$Model$BuildPlannerCache$init, tu: $author$project$Protected$empty, tI: false, qV: $elm$core$Dict$empty, qX: flags, tY: $elm$core$Maybe$Nothing, t3: false, jb: _List_Nil, fu: localStorage, rp: localTimezone, mN: $author$project$Views$NotificationsGlobal$init, vH: false, gS: $elm$core$Maybe$Nothing};
		return A2(
			$author$project$Misc$with,
			$author$project$Ports$setIsImpersonating(
				$author$project$Model$Session$isImpersonating(newSession)),
			newSession);
	});
var $elm$core$Platform$Cmd$map = _Platform_map;
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $author$project$Model$Session$init = function (flags) {
	var _v0 = $author$project$Model$LocalStorage$init;
	var localStorage = _v0.a;
	var localStorageCmd = _v0.b;
	var _v1 = A3($author$project$Model$Session$initInternal, flags, $elm$time$Time$utc, localStorage);
	var session = _v1.a;
	var internalCmd = _v1.b;
	var cmd = $elm$core$Platform$Cmd$batch(
		_List_fromArray(
			[
				A2($elm$core$Task$perform, $author$project$Model$Session$GotTimezone, $elm$time$Time$here),
				A2($elm$core$Platform$Cmd$map, $author$project$Model$Session$LocalStorageMsg, localStorageCmd),
				internalCmd
			]));
	return A2($author$project$Misc$with, cmd, session);
};
var $author$project$PageState$Loaded = function (a) {
	return {$: 0, a: a};
};
var $author$project$PageState$init = F2(
	function (currentPage, currentRoute) {
		return $author$project$PageState$Loaded(
			{jK: currentPage, jL: currentRoute});
	});
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $author$project$Model$Route$NotFound = {$: 6};
var $author$project$Model$Route$ActivateMembership = function (a) {
	return {$: 11, a: a};
};
var $author$project$Model$Route$ActivateMembershipDeprecated = function (a) {
	return {$: 12, a: a};
};
var $author$project$Model$Route$ActivateMembershipDeprecatedParams = F4(
	function (orgName, inviteCode, email, newUser) {
		return {lJ: email, fs: inviteCode, zn: newUser, ix: orgName};
	});
var $author$project$Model$Route$ActivateMembershipParams = F3(
	function (inviteCode, email, newUser) {
		return {lJ: email, fs: inviteCode, zn: newUser};
	});
var $author$project$Model$Route$Admin = function (a) {
	return {$: 16, a: a};
};
var $author$project$Model$Route$AuthorizeDevice = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$Route$AuthorizeDeviceParams = F2(
	function (userCode, deviceID) {
		return {x0: deviceID, GV: userCode};
	});
var $author$project$Model$Route$CheckEmail = {$: 2};
var $author$project$Model$Route$Checkout = function (a) {
	return {$: 21, a: a};
};
var $author$project$Model$Route$CheckoutParams = F6(
	function (isTrial, isNewUser, nextRoute, tier, orgName, skipSelection) {
		return {jc: isNewUser, up: isTrial, dg: nextRoute, ix: orgName, Ab: skipSelection, dc: tier};
	});
var $author$project$Model$Route$ConnectAccount = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$Route$ConnectAccountParams = F3(
	function (inviteCode, nextRoute, errorType) {
		return {lP: errorType, fs: inviteCode, dg: nextRoute};
	});
var $author$project$Model$Route$CreateAccount = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$Route$CreateAccountParams = F8(
	function (email, inviteCode, source, content, cliInstructionsPlatform, nextRoute, googleAnalyticsParams, autoProjectParams) {
		return {h3: autoProjectParams, g$: cliInstructionsPlatform, dH: content, lJ: email, hx: googleAnalyticsParams, fs: inviteCode, dg: nextRoute, o: source};
	});
var $author$project$Model$Route$CreateOrgProjectParams = F2(
	function (orgName, createProjectParams) {
		return {B2: createProjectParams, ix: orgName};
	});
var $author$project$Model$Route$CreateOrganization = function (a) {
	return {$: 10, a: a};
};
var $author$project$Model$Route$CreateOrganizationParams = F2(
	function (nextRoute, autoProjectParams) {
		return {h3: autoProjectParams, dg: nextRoute};
	});
var $author$project$Model$Route$CreateProject = function (a) {
	return {$: 18, a: a};
};
var $author$project$Model$Route$CreateProjectFromCommit = function (a) {
	return {$: 22, a: a};
};
var $author$project$Model$Route$CreateProjectFromCommitParams = F2(
	function (commitID, projectName) {
		return {BR: commitID, vT: projectName};
	});
var $author$project$Model$Route$CreateProjectRedirect = function (a) {
	return {$: 17, a: a};
};
var $author$project$Model$Route$FinishSetup = function (a) {
	return {$: 24, a: a};
};
var $author$project$Model$Route$FinishSetupParams = function (nextRoute) {
	return {dg: nextRoute};
};
var $author$project$Model$Route$ForgotPassword = {$: 4};
var $author$project$Model$Route$Home = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$Route$HomeParams = function (signupSource) {
	return {wd: signupSource};
};
var $author$project$Model$Route$ImportProject = function (a) {
	return {$: 19, a: a};
};
var $author$project$Model$Route$ImportProjectParams = function (orgName) {
	return {ix: orgName};
};
var $author$project$Model$Route$Login = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$Route$LoginParams = F9(
	function (reset, email, inviteCode, source, content, cliInstructionsPlatform, nextRoute, errorType, googleAnalyticsParams) {
		return {g$: cliInstructionsPlatform, dH: content, lJ: email, lP: errorType, hx: googleAnalyticsParams, fs: inviteCode, dg: nextRoute, pC: reset, o: source};
	});
var $author$project$Model$Route$Logout = {$: 0};
var $author$project$Model$Route$Org = function (a) {
	return {$: 14, a: a};
};
var $author$project$Model$Route$OrgParams = F2(
	function (orgName, orgRoute) {
		return {ix: orgName, vI: orgRoute};
	});
var $author$project$Model$Route$Orgs = {$: 15};
var $author$project$Model$Route$OutOfCompliance = {$: 23};
var $author$project$Model$Route$PreferenceDeleteAccount = {$: 9};
var $author$project$Model$Route$PreferenceEmail = {$: 5};
var $author$project$Model$Route$PreferenceIndex = {$: 3};
var $author$project$Model$Route$PreferenceLinkedAccounts = function (a) {
	return {$: 6, a: a};
};
var $author$project$Model$Route$PreferenceLinkedAccountsParams = F2(
	function (linkingError, service) {
		return {D3: linkingError, F$: service};
	});
var $author$project$Model$Route$PreferenceOrganization = {$: 8};
var $author$project$Model$Route$PreferencePassword = function (a) {
	return {$: 7, a: a};
};
var $author$project$Model$Route$PreferencePasswordParams = function (mode) {
	return {El: mode};
};
var $author$project$Model$Route$PreferenceTwoFactor = {$: 4};
var $author$project$Model$Route$ProjectOverview = function (a) {
	return {$: 12, a: a};
};
var $author$project$Model$Route$ProjectOverviewParams = F7(
	function (orgName, projectName, maybeCommitID, cliInstructionsPlatform, isNewProject, maybeBranchName, isShareModalOpen) {
		return {g$: cliInstructionsPlatform, uk: isNewProject, DD: isShareModalOpen, fO: maybeBranchName, gr: maybeCommitID, ix: orgName, vT: projectName};
	});
var $author$project$Model$Route$ProjectPreview = function (a) {
	return {$: 11, a: a};
};
var $author$project$Model$Route$Protected = function (a) {
	return {$: 7, a: a};
};
var $author$project$Model$Route$PublicProjects = {$: 10};
var $author$project$Model$Route$ResetPassword = function (a) {
	return {$: 5, a: a};
};
var $author$project$Model$Route$Sample = {$: 0};
var $author$project$Model$Route$StateToolCheatSheet = {$: 9};
var $author$project$Model$Route$SupplementalLicenseTerms = function (a) {
	return {$: 13, a: a};
};
var $author$project$Model$Route$Support = {$: 8};
var $author$project$Model$Route$Upgrade = function (a) {
	return {$: 20, a: a};
};
var $author$project$Model$Route$UpgradeParams = F2(
	function (isNewUser, nextRoute) {
		return {jc: isNewUser, dg: nextRoute};
	});
var $author$project$Model$Route$VerifyEmail = function (a) {
	return {$: 13, a: a};
};
var $author$project$Model$Route$VerifyEmailParams = F3(
	function (email, code, nextRoute) {
		return {xD: code, lJ: email, dg: nextRoute};
	});
var $author$project$Model$Route$AdminCreateOrganization = {$: 4};
var $author$project$Model$Route$AdminFeatures = {$: 6};
var $author$project$Model$Route$AdminFork = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Model$Route$AdminIconomicon = {$: 7};
var $author$project$Model$Route$AdminOrganization = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$Route$AdminOrganizations = {$: 0};
var $author$project$Model$Route$AdminUser = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$Route$AdminUsers = function (a) {
	return {$: 2, a: a};
};
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {jW: frag, E5: params, jB: unvisited, kH: value, kI: visited};
	});
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.kI;
		var unvisited = _v0.jB;
		var params = _v0.E5;
		var frag = _v0.jW;
		var value = _v0.kH;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.kI;
			var unvisited = _v1.jB;
			var params = _v1.E5;
			var frag = _v1.jW;
			var value = _v1.kH;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $elm$url$Url$Parser$query = function (_v0) {
	var queryParser = _v0;
	return function (_v1) {
		var visited = _v1.kI;
		var unvisited = _v1.jB;
		var params = _v1.E5;
		var frag = _v1.jW;
		var value = _v1.kH;
		return _List_fromArray(
			[
				A5(
				$elm$url$Url$Parser$State,
				visited,
				unvisited,
				params,
				frag,
				value(
					queryParser(params)))
			]);
	};
};
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0;
		var parseAfter = _v1;
		return function (state) {
			return A2(
				$elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var $elm$url$Url$Parser$questionMark = F2(
	function (parser, queryParser) {
		return A2(
			$elm$url$Url$Parser$slash,
			parser,
			$elm$url$Url$Parser$query(queryParser));
	});
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.kI;
		var unvisited = _v0.jB;
		var params = _v0.E5;
		var frag = _v0.jW;
		var value = _v0.kH;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return function (_v0) {
			var visited = _v0.kI;
			var unvisited = _v0.jB;
			var params = _v0.E5;
			var frag = _v0.jW;
			var value = _v0.kH;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				var _v2 = stringToSomething(next);
				if (!_v2.$) {
					var nextValue = _v2.a;
					return _List_fromArray(
						[
							A5(
							$elm$url$Url$Parser$State,
							A2($elm$core$List$cons, next, visited),
							rest,
							params,
							frag,
							value(nextValue))
						]);
				} else {
					return _List_Nil;
				}
			}
		};
	});
var $elm$url$Url$Parser$string = A2($elm$url$Url$Parser$custom, 'STRING', $elm$core$Maybe$Just);
var $elm$url$Url$Parser$Internal$Parser = $elm$core$Basics$identity;
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$url$Url$Parser$Query$custom = F2(
	function (key, func) {
		return function (dict) {
			return func(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Dict$get, key, dict)));
		};
	});
var $elm$url$Url$Parser$Query$string = function (key) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		key,
		function (stringList) {
			if (stringList.b && (!stringList.b.b)) {
				var str = stringList.a;
				return $elm$core$Maybe$Just(str);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
};
var $author$project$Routing$adminRouteMatcher = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Model$Route$AdminOrganizations,
			$elm$url$Url$Parser$s('organizations')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Model$Route$AdminOrganization,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('organizations'),
				$elm$url$Url$Parser$string)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Model$Route$AdminUsers,
			A2(
				$elm$url$Url$Parser$questionMark,
				$elm$url$Url$Parser$s('users'),
				$elm$url$Url$Parser$Query$string('orgName'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Model$Route$AdminUser,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('users'),
				$elm$url$Url$Parser$string)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Model$Route$AdminCreateOrganization,
			$elm$url$Url$Parser$s('create-organization')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Model$Route$AdminFork,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('organizations'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$string,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('fork'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Model$Route$AdminFeatures,
			$elm$url$Url$Parser$s('features')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Model$Route$AdminIconomicon,
			$elm$url$Url$Parser$s('iconomicon'))
		]));
var $elm$url$Url$Parser$Query$map = F2(
	function (func, _v0) {
		var a = _v0;
		return function (dict) {
			return func(
				a(dict));
		};
	});
var $author$project$Model$Route$BuildPythonAd = 1;
var $author$project$Model$Route$Default = 2;
var $author$project$Model$Route$PythonDisplay = 0;
var $author$project$Routing$stringToContentType = function (string) {
	_v0$2:
	while (true) {
		if (!string.$) {
			switch (string.a) {
				case 'python-display':
					return 0;
				case 'build-python':
					return 1;
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return 2;
};
var $author$project$Routing$authContentParamParser = function (param) {
	return A2(
		$elm$url$Url$Parser$Query$map,
		$author$project$Routing$stringToContentType,
		$elm$url$Url$Parser$Query$string(param));
};
var $author$project$Model$Route$AutoProjectParams = F2(
	function (language, version) {
		return {aC: language, aI: version};
	});
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $elm$url$Url$Parser$Query$map2 = F3(
	function (func, _v0, _v1) {
		var a = _v0;
		var b = _v1;
		return function (dict) {
			return A2(
				func,
				a(dict),
				b(dict));
		};
	});
var $author$project$Routing$autoProjectQueryParamsParser = A3(
	$elm$url$Url$Parser$Query$map2,
	$elm$core$Maybe$map2($author$project$Model$Route$AutoProjectParams),
	$elm$url$Url$Parser$Query$string('project_language'),
	$elm$url$Url$Parser$Query$string('project_version'));
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$String$toLower = _String_toLower;
var $author$project$Routing$boolParamHelp = function (maybeValues) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		$elm$core$List$head(
			A2(
				$elm$core$List$map,
				$elm$core$Basics$eq('true'),
				A2($elm$core$List$map, $elm$core$String$toLower, maybeValues))));
};
var $author$project$Routing$boolParam = function (bool) {
	return A2($elm$url$Url$Parser$Query$custom, bool, $author$project$Routing$boolParamHelp);
};
var $author$project$Model$Route$CreateProjectParams = F6(
	function (languageName, languageVersion, maybeOSName, maybeNextAction, isNewUser, autoCreate) {
		return {A9: autoCreate, jc: isNewUser, DQ: languageName, DS: languageVersion, ru: maybeNextAction, rv: maybeOSName};
	});
var $elm$url$Url$Parser$Query$map6 = F7(
	function (func, _v0, _v1, _v2, _v3, _v4, _v5) {
		var a = _v0;
		var b = _v1;
		var c = _v2;
		var d = _v3;
		var e = _v4;
		var f = _v5;
		return function (dict) {
			return A6(
				func,
				a(dict),
				b(dict),
				c(dict),
				d(dict),
				e(dict),
				f(dict));
		};
	});
var $author$project$Routing$createProjectParamsQueryParser = A7(
	$elm$url$Url$Parser$Query$map6,
	$author$project$Model$Route$CreateProjectParams,
	$elm$url$Url$Parser$Query$string('language'),
	$elm$url$Url$Parser$Query$string('version'),
	$elm$url$Url$Parser$Query$string('os'),
	$elm$url$Url$Parser$Query$string('nextAction'),
	$author$project$Routing$boolParam('newUser'),
	$author$project$Routing$boolParam('autoCreate'));
var $author$project$Misc$getSingle = function (list) {
	if (list.b && (!list.b.b)) {
		var single = list.a;
		return $elm$core$Maybe$Just(single);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$Route$GoogleAnalyticsParams = F4(
	function (utm_source, utm_medium, utm_campaign, utm_content) {
		return {AF: utm_campaign, AG: utm_content, AH: utm_medium, AI: utm_source};
	});
var $elm$core$Maybe$map4 = F5(
	function (func, ma, mb, mc, md) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				if (mc.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var c = mc.a;
					if (md.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var d = md.a;
						return $elm$core$Maybe$Just(
							A4(func, a, b, c, d));
					}
				}
			}
		}
	});
var $elm$url$Url$Parser$Query$map4 = F5(
	function (func, _v0, _v1, _v2, _v3) {
		var a = _v0;
		var b = _v1;
		var c = _v2;
		var d = _v3;
		return function (dict) {
			return A4(
				func,
				a(dict),
				b(dict),
				c(dict),
				d(dict));
		};
	});
var $author$project$Routing$googleAnalyticsParamsParser = A5(
	$elm$url$Url$Parser$Query$map4,
	$elm$core$Maybe$map4($author$project$Model$Route$GoogleAnalyticsParams),
	$elm$url$Url$Parser$Query$string('utm_source'),
	$elm$url$Url$Parser$Query$string('utm_medium'),
	$elm$url$Url$Parser$Query$string('utm_campaign'),
	$elm$url$Url$Parser$Query$string('utm_content'));
var $author$project$Model$NonEmptyString$NonEmptyString = $elm$core$Basics$identity;
var $author$project$Model$NonEmptyString$fromString = function (s) {
	return (s === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(s);
};
var $author$project$Routing$nonEmptyString = A2($elm$url$Url$Parser$custom, 'NON_EMPTY_STRING', $author$project$Model$NonEmptyString$fromString);
var $author$project$Routing$nonEmptyStringQuery = function (key) {
	return A2(
		$elm$url$Url$Parser$Query$map,
		$elm$core$Maybe$andThen($author$project$Model$NonEmptyString$fromString),
		$elm$url$Url$Parser$Query$string(key));
};
var $author$project$Model$Route$OrgDependencies = {$: 8};
var $author$project$Model$Route$OrgIndex = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$Route$OrgMembers = {$: 1};
var $author$project$Model$Route$OrgPolicy = {$: 2};
var $author$project$Model$Route$OrgProject = function (a) {
	return {$: 7, a: a};
};
var $author$project$Model$Route$OrgProjectParams = F2(
	function (projectName, projectRoute) {
		return {vT: projectName, zL: projectRoute};
	});
var $author$project$Model$Route$OrgRemediation = {$: 3};
var $author$project$Model$Route$OrgScan = {$: 5};
var $author$project$Model$Route$OrgSecurity = {$: 6};
var $author$project$Model$Route$OrgSettings = {$: 4};
var $author$project$Model$Route$ProjectAutoFork = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Model$Route$ProjectConfig = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$Route$ProjectConfigAdvanced = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$Route$ProjectConfigAdvancedParams = F2(
	function (maybeCommitID, maybeBranchName) {
		return {fO: maybeBranchName, gr: maybeCommitID};
	});
var $author$project$Model$Route$ProjectConfigParams = F7(
	function (maybeCommitID, isNewProject, maybeBranchName, isFromCommit, focusOnAddPackages, showAddPackagesModal, showImportPackagesModal) {
		return {yo: focusOnAddPackages, yJ: isFromCommit, uk: isNewProject, fO: maybeBranchName, gr: maybeCommitID, z6: showAddPackagesModal, z7: showImportPackagesModal};
	});
var $author$project$Model$Route$ProjectDownloads = F4(
	function (a, b, c, d) {
		return {$: 5, a: a, b: b, c: c, d: d};
	});
var $author$project$Model$Route$ProjectFork = function (a) {
	return {$: 8, a: a};
};
var $author$project$Model$Route$ProjectHistory = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Model$Route$ProjectImpactReport = function (a) {
	return {$: 7, a: a};
};
var $author$project$Model$Route$ProjectImpactReportParams = F8(
	function (oldAtTime, newAtTime, oldBuildExpr, newBuildExpr, oldCommitID, newCommitID, oldVcsRef, newVcsRef) {
		return {uJ: newAtTime, uK: newBuildExpr, uL: newCommitID, uN: newVcsRef, uS: oldAtTime, uT: oldBuildExpr, uU: oldCommitID, uW: oldVcsRef};
	});
var $author$project$Model$Route$ProjectSettings = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Model$Route$ProjectSettingsBranches = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$Route$ProjectSettingsHAR = function (a) {
	return {$: 4, a: a};
};
var $author$project$Model$Route$ProjectSettingsParams = F2(
	function (maybeBranchName, maybeCommitID) {
		return {fO: maybeBranchName, gr: maybeCommitID};
	});
var $elm$url$Url$Parser$fragment = function (toFrag) {
	return function (_v0) {
		var visited = _v0.kI;
		var unvisited = _v0.jB;
		var params = _v0.E5;
		var frag = _v0.jW;
		var value = _v0.kH;
		return _List_fromArray(
			[
				A5(
				$elm$url$Url$Parser$State,
				visited,
				unvisited,
				params,
				frag,
				value(
					toFrag(frag)))
			]);
	};
};
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $author$project$Model$Route$ChangeName = 0;
var $author$project$Model$Route$SelectAnOrg = 1;
var $author$project$Model$Route$requiredActionFromString = function (reason) {
	var _v0 = $elm$core$String$toLower(reason);
	switch (_v0) {
		case 'change_name':
			return $elm$core$Result$Ok(0);
		case 'select_an_org':
			return $elm$core$Result$Ok(1);
		default:
			return $elm$core$Result$Err('cannot recognize reason');
	}
};
var $author$project$Model$Route$requiredActionParam = function (key) {
	var unpackList = function (queryValues) {
		return A2(
			$elm$core$List$filterMap,
			A2($elm$core$Basics$composeR, $author$project$Model$Route$requiredActionFromString, $elm$core$Result$toMaybe),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					$elm$core$String$split(','),
					queryValues)));
	};
	return A2(
		$elm$url$Url$Parser$Query$map,
		unpackList,
		$elm$url$Url$Parser$Query$string(key));
};
var $danyx23$elm_uuid$Uuid$Uuid = $elm$core$Basics$identity;
var $danyx23$elm_uuid$Uuid$Barebones$uuidRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^[0-9A-Fa-f]{8,8}-[0-9A-Fa-f]{4,4}-[1-5][0-9A-Fa-f]{3,3}-[8-9A-Ba-b][0-9A-Fa-f]{3,3}-[0-9A-Fa-f]{12,12}$'));
var $danyx23$elm_uuid$Uuid$Barebones$isValidUuid = function (uuidAsString) {
	return A2($elm$regex$Regex$contains, $danyx23$elm_uuid$Uuid$Barebones$uuidRegex, uuidAsString);
};
var $danyx23$elm_uuid$Uuid$fromString = function (text) {
	return $danyx23$elm_uuid$Uuid$Barebones$isValidUuid(text) ? $elm$core$Maybe$Just(
		$elm$core$String$toLower(text)) : $elm$core$Maybe$Nothing;
};
var $author$project$Routing$uuidQuery = function (key) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		key,
		A2(
			$elm$core$Basics$composeR,
			$author$project$Misc$getSingle,
			$elm$core$Maybe$andThen($danyx23$elm_uuid$Uuid$fromString)));
};
var $author$project$Routing$projectRouteMatcher = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Model$Route$ProjectConfig,
			A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$ProjectConfigParams,
				A2(
					$elm$url$Url$Parser$questionMark,
					A2(
						$elm$url$Url$Parser$questionMark,
						A2(
							$elm$url$Url$Parser$questionMark,
							A2(
								$elm$url$Url$Parser$questionMark,
								A2(
									$elm$url$Url$Parser$questionMark,
									A2(
										$elm$url$Url$Parser$questionMark,
										A2(
											$elm$url$Url$Parser$questionMark,
											$elm$url$Url$Parser$s('customize'),
											$author$project$Routing$uuidQuery('commitID')),
										$author$project$Routing$boolParam('new_project')),
									$elm$url$Url$Parser$Query$string('branch')),
								$author$project$Routing$boolParam('from_commit')),
							$author$project$Routing$boolParam('focus_add_packages')),
						$author$project$Routing$boolParam('show_add_packages')),
					$author$project$Routing$boolParam('show_import_packages')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Model$Route$ProjectConfigAdvanced,
			A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$ProjectConfigAdvancedParams,
				A2(
					$elm$url$Url$Parser$questionMark,
					A2(
						$elm$url$Url$Parser$questionMark,
						$elm$url$Url$Parser$s('advanced'),
						$author$project$Routing$uuidQuery('commitID')),
					$elm$url$Url$Parser$Query$string('branch')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Model$Route$ProjectDownloads,
			A2(
				$elm$url$Url$Parser$questionMark,
				A2(
					$elm$url$Url$Parser$questionMark,
					A2(
						$elm$url$Url$Parser$questionMark,
						A2(
							$elm$url$Url$Parser$questionMark,
							$elm$url$Url$Parser$s('distributions'),
							$author$project$Routing$uuidQuery('commitID')),
						$elm$url$Url$Parser$Query$string('platformID')),
					$author$project$Routing$boolParam('new_project')),
				$elm$url$Url$Parser$Query$string('branch'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Model$Route$ProjectSettings,
			A2(
				$elm$url$Url$Parser$slash,
				A2(
					$elm$url$Url$Parser$questionMark,
					$elm$url$Url$Parser$s('settings'),
					$elm$url$Url$Parser$Query$string('branch')),
				$elm$url$Url$Parser$fragment($elm$core$Basics$identity))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Model$Route$ProjectSettingsBranches,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('settings'),
				A2(
					$elm$url$Url$Parser$questionMark,
					$elm$url$Url$Parser$s('branches'),
					$elm$url$Url$Parser$Query$string('branch')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Model$Route$ProjectSettingsHAR,
			A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$ProjectSettingsParams,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('settings'),
					A2(
						$elm$url$Url$Parser$questionMark,
						A2(
							$elm$url$Url$Parser$questionMark,
							$elm$url$Url$Parser$s('har'),
							$elm$url$Url$Parser$Query$string('branch')),
						$author$project$Routing$uuidQuery('commitID'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Model$Route$ProjectHistory,
			A2(
				$elm$url$Url$Parser$questionMark,
				A2(
					$elm$url$Url$Parser$questionMark,
					$elm$url$Url$Parser$s('releases'),
					$author$project$Routing$uuidQuery('commitID')),
				$elm$url$Url$Parser$Query$string('branch'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Model$Route$ProjectImpactReport,
			A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$ProjectImpactReportParams,
				A2(
					$elm$url$Url$Parser$questionMark,
					A2(
						$elm$url$Url$Parser$questionMark,
						A2(
							$elm$url$Url$Parser$questionMark,
							A2(
								$elm$url$Url$Parser$questionMark,
								A2(
									$elm$url$Url$Parser$questionMark,
									A2(
										$elm$url$Url$Parser$questionMark,
										A2(
											$elm$url$Url$Parser$questionMark,
											A2(
												$elm$url$Url$Parser$questionMark,
												$elm$url$Url$Parser$s('impact-report'),
												$elm$url$Url$Parser$Query$string('oldAtTime')),
											$elm$url$Url$Parser$Query$string('newAtTime')),
										$elm$url$Url$Parser$Query$string('oldBuildExpr')),
									$elm$url$Url$Parser$Query$string('newBuildExpr')),
								$author$project$Routing$uuidQuery('oldCommitID')),
							$author$project$Routing$uuidQuery('newCommitID')),
						$elm$url$Url$Parser$Query$string('oldVcsRef')),
					$elm$url$Url$Parser$Query$string('newVcsRef')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Model$Route$ProjectFork,
			A2(
				$elm$url$Url$Parser$questionMark,
				$elm$url$Url$Parser$s('fork'),
				$author$project$Model$Route$requiredActionParam('actions'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Model$Route$ProjectAutoFork,
			A2(
				$elm$url$Url$Parser$questionMark,
				A2(
					$elm$url$Url$Parser$questionMark,
					$elm$url$Url$Parser$s('auto-fork'),
					$elm$url$Url$Parser$Query$string('cli-instructions')),
				$author$project$Routing$authContentParamParser('content')))
		]));
var $elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var $author$project$Routing$orgRouteMatcher = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Model$Route$OrgIndex,
			A2(
				$elm$url$Url$Parser$questionMark,
				$elm$url$Url$Parser$top,
				$elm$url$Url$Parser$Query$string('signupSource'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Model$Route$OrgMembers,
			$elm$url$Url$Parser$s('members')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Model$Route$OrgSettings,
			$elm$url$Url$Parser$s('settings')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Model$Route$OrgScan,
			$elm$url$Url$Parser$s('scan')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Model$Route$OrgSecurity,
			$elm$url$Url$Parser$s('security')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Model$Route$OrgPolicy,
			$elm$url$Url$Parser$s('policy')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Model$Route$OrgRemediation,
			$elm$url$Url$Parser$s('remediation')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Model$Route$OrgProject,
			A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$OrgProjectParams,
				A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $author$project$Routing$projectRouteMatcher))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Model$Route$OrgDependencies,
			$elm$url$Url$Parser$s('dependencies'))
		]));
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.jB;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.kH);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.kH);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.pm),
					$elm$url$Url$Parser$prepareQuery(url.r1),
					url.oD,
					$elm$core$Basics$identity)));
	});
var $author$project$Model$Route$EmailAddressTaken = function (a) {
	return {$: 4, a: a};
};
var $author$project$Model$Route$IdentifierTaken = {$: 0};
var $author$project$Model$Route$NotVerified = {$: 2};
var $author$project$Model$Route$OtherError = function (a) {
	return {$: 5, a: a};
};
var $author$project$Model$Route$UserDeclined = {$: 3};
var $author$project$Model$Route$UsernameTaken = {$: 1};
var $author$project$Routing$stringToErrorType = function (errorType) {
	switch (errorType) {
		case 'identifier-taken':
			return $author$project$Model$Route$IdentifierTaken;
		case 'username-taken':
			return $author$project$Model$Route$UsernameTaken;
		case 'not-verified':
			return $author$project$Model$Route$NotVerified;
		case 'user-declined':
			return $author$project$Model$Route$UserDeclined;
		default:
			var message = errorType;
			var _v1 = A2($elm$core$String$split, ':', message);
			if (_v1.b && (_v1.a === 'email-address-taken')) {
				var rest = _v1.b;
				return $author$project$Model$Route$EmailAddressTaken(
					A2($elm$core$String$join, ':', rest));
			} else {
				return $author$project$Model$Route$OtherError(message);
			}
	}
};
var $author$project$Model$Route$ForProject = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$Route$supplementalLicenseTermsParams = F3(
	function (orgID, projectID, commitID) {
		return $author$project$Model$Route$ForProject(
			{BR: commitID, zv: orgID, zK: projectID});
	});
var $elm_community$maybe_extra$Maybe$Extra$filter = F2(
	function (f, m) {
		var _v0 = A2($elm$core$Maybe$map, f, m);
		if ((!_v0.$) && _v0.a) {
			return m;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Model$Tier$isSelfServeUpgradable = function (simpleTier) {
	switch (simpleTier.$) {
		case 2:
			return true;
		case 3:
			return true;
		default:
			return false;
	}
};
var $author$project$Model$Tier$Unknown = {$: 8};
var $author$project$Model$Tier$simpleTierToMaybe = function (simpleTier) {
	return _Utils_eq(simpleTier, $author$project$Model$Tier$Unknown) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(simpleTier);
};
var $author$project$Model$Tier$Business = {$: 4};
var $author$project$Model$Tier$Coder = {$: 1};
var $author$project$Model$Tier$Enterprise = {$: 5};
var $author$project$Model$Tier$EnterpriseEval = {$: 6};
var $author$project$Model$Tier$Free = {$: 0};
var $author$project$Model$Tier$PlatformTrial = {$: 7};
var $author$project$Model$Tier$Pro = {$: 2};
var $author$project$Model$Tier$Team = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$Tier$stringToSimpleTier = function (tierName) {
	switch (tierName) {
		case 'enterprise':
			return $author$project$Model$Tier$Enterprise;
		case 'enterprise_evaluation':
			return $author$project$Model$Tier$EnterpriseEval;
		case 'enterprise_legacy':
			return $author$project$Model$Tier$Enterprise;
		case 'business_legacy':
			return $author$project$Model$Tier$Business;
		case 'team':
			return $author$project$Model$Tier$Team(false);
		case 'team_trial':
			return $author$project$Model$Tier$Team(true);
		case 'team_legacy':
			return $author$project$Model$Tier$Team(false);
		case 'pro':
			return $author$project$Model$Tier$Pro;
		case 'coder_legacy':
			return $author$project$Model$Tier$Coder;
		case 'free':
			return $author$project$Model$Tier$Free;
		case 'free_legacy':
			return $author$project$Model$Tier$Free;
		case 'platform_trial_evaluation':
			return $author$project$Model$Tier$PlatformTrial;
		default:
			return $author$project$Model$Tier$Unknown;
	}
};
var $author$project$Routing$tierParam = function () {
	var parser = A2(
		$elm$core$Basics$composeR,
		$elm$core$List$head,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($author$project$Model$Tier$stringToSimpleTier),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$andThen($author$project$Model$Tier$simpleTierToMaybe),
				$elm_community$maybe_extra$Maybe$Extra$filter($author$project$Model$Tier$isSelfServeUpgradable))));
	return A2($elm$url$Url$Parser$Query$custom, 'tier', parser);
}();
var $author$project$Routing$uuid = A2($elm$url$Url$Parser$custom, 'UUID', $danyx23$elm_uuid$Uuid$fromString);
var $author$project$Routing$loginParamsParser = function (stem) {
	return A2(
		$elm$url$Url$Parser$map,
		$author$project$Model$Route$LoginParams,
		A2(
			$elm$url$Url$Parser$questionMark,
			A2(
				$elm$url$Url$Parser$questionMark,
				A2(
					$elm$url$Url$Parser$questionMark,
					A2(
						$elm$url$Url$Parser$questionMark,
						A2(
							$elm$url$Url$Parser$questionMark,
							A2(
								$elm$url$Url$Parser$questionMark,
								A2(
									$elm$url$Url$Parser$questionMark,
									A2(
										$elm$url$Url$Parser$questionMark,
										A2(
											$elm$url$Url$Parser$questionMark,
											$elm$url$Url$Parser$s(stem),
											$author$project$Routing$boolParam('reset')),
										$elm$url$Url$Parser$Query$string('email')),
									$author$project$Routing$nonEmptyStringQuery('inviteCode')),
								$elm$url$Url$Parser$Query$string('source')),
							$author$project$Routing$authContentParamParser('content')),
						$elm$url$Url$Parser$Query$string('cli-instructions')),
					$author$project$Routing$queryRouteParser('nextRoute')),
				$elm$url$Url$Parser$Query$string('errorType')),
			$author$project$Routing$googleAnalyticsParamsParser));
};
var $author$project$Routing$queryRouteParser = function (paramName) {
	var emptyUrl = {oD: $elm$core$Maybe$Nothing, t0: '', pm: '', Fk: $elm$core$Maybe$Nothing, Ft: 1, r1: $elm$core$Maybe$Nothing};
	return A2(
		$elm$url$Url$Parser$Query$custom,
		paramName,
		A2(
			$elm$core$Basics$composeR,
			$author$project$Misc$getSingle,
			$elm$core$Maybe$andThen(
				function (routeStringPath) {
					var urlParts = A2($elm$core$String$split, '?', routeStringPath);
					var dummyUrl = function () {
						_v0$2:
						while (true) {
							if (urlParts.b) {
								if (urlParts.b.b) {
									if (!urlParts.b.b.b) {
										var path = urlParts.a;
										var _v1 = urlParts.b;
										var query = _v1.a;
										return _Utils_update(
											emptyUrl,
											{
												pm: path,
												r1: $elm$core$Maybe$Just(query)
											});
									} else {
										break _v0$2;
									}
								} else {
									var path = urlParts.a;
									return _Utils_update(
										emptyUrl,
										{pm: path});
								}
							} else {
								break _v0$2;
							}
						}
						return _Utils_update(
							emptyUrl,
							{pm: routeStringPath});
					}();
					return A2(
						$elm$url$Url$Parser$parse,
						$author$project$Routing$cyclic$matchers(),
						dummyUrl);
				})));
};
function $author$project$Routing$cyclic$matchers() {
	return $elm$url$Url$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$Logout,
				$elm$url$Url$Parser$s('logout')),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$Login,
				$author$project$Routing$loginParamsParser('sign-in')),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$Login,
				$author$project$Routing$loginParamsParser('signin')),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$ForgotPassword,
				$elm$url$Url$Parser$s('forgot-password')),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$ConnectAccount,
				A2(
					$elm$url$Url$Parser$map,
					$author$project$Model$Route$ConnectAccountParams,
					A2(
						$elm$url$Url$Parser$questionMark,
						A2(
							$elm$url$Url$Parser$questionMark,
							A2(
								$elm$url$Url$Parser$questionMark,
								$elm$url$Url$Parser$s('connect-account'),
								$author$project$Routing$nonEmptyStringQuery('inviteCode')),
							$author$project$Routing$queryRouteParser('nextRoute')),
						A2(
							$elm$url$Url$Parser$Query$map,
							$elm$core$Maybe$map($author$project$Routing$stringToErrorType),
							$elm$url$Url$Parser$Query$string('errorType'))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$ResetPassword,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('reset-password'),
					$elm$url$Url$Parser$string)),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$CreateAccount,
				A2(
					$elm$url$Url$Parser$map,
					$author$project$Model$Route$CreateAccountParams,
					A2(
						$elm$url$Url$Parser$questionMark,
						A2(
							$elm$url$Url$Parser$questionMark,
							A2(
								$elm$url$Url$Parser$questionMark,
								A2(
									$elm$url$Url$Parser$questionMark,
									A2(
										$elm$url$Url$Parser$questionMark,
										A2(
											$elm$url$Url$Parser$questionMark,
											A2(
												$elm$url$Url$Parser$questionMark,
												A2(
													$elm$url$Url$Parser$questionMark,
													$elm$url$Url$Parser$s('create-account'),
													$elm$url$Url$Parser$Query$string('email')),
												$author$project$Routing$nonEmptyStringQuery('inviteCode')),
											$elm$url$Url$Parser$Query$string('source')),
										$author$project$Routing$authContentParamParser('content')),
									$elm$url$Url$Parser$Query$string('cli-instructions')),
								$author$project$Routing$queryRouteParser('nextRoute')),
							$author$project$Routing$googleAnalyticsParamsParser),
						$author$project$Routing$autoProjectQueryParamsParser))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$Support,
				$elm$url$Url$Parser$s('support')),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$ProjectPreview,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('commit'),
					$author$project$Routing$uuid)),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$StateToolCheatSheet,
				$elm$url$Url$Parser$s('state-tool-cheat-sheet')),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$PublicProjects,
				$elm$url$Url$Parser$s('featured-projects')),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$SupplementalLicenseTerms,
				A2(
					$elm$url$Url$Parser$map,
					$author$project$Model$Route$supplementalLicenseTermsParams,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$string,
								$elm$url$Url$Parser$s('supplemental-license-terms')))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$SupplementalLicenseTerms($author$project$Model$Route$Sample),
				$elm$url$Url$Parser$s('supplemental-license-terms')),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$Protected,
				$author$project$Routing$cyclic$protectedRouteMatcher()),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$ProjectOverview,
				A2(
					$elm$url$Url$Parser$map,
					$author$project$Model$Route$ProjectOverviewParams,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						A2(
							$elm$url$Url$Parser$questionMark,
							A2(
								$elm$url$Url$Parser$questionMark,
								A2(
									$elm$url$Url$Parser$questionMark,
									A2(
										$elm$url$Url$Parser$questionMark,
										A2(
											$elm$url$Url$Parser$questionMark,
											$elm$url$Url$Parser$string,
											$author$project$Routing$uuidQuery('commitID')),
										$elm$url$Url$Parser$Query$string('cli-instructions')),
									$author$project$Routing$boolParam('new_project')),
								$elm$url$Url$Parser$Query$string('branch')),
							$author$project$Routing$boolParam('share')))))
			]));
}
function $author$project$Routing$cyclic$protectedRouteMatcher() {
	return $elm$url$Url$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$Home,
				A2(
					$elm$url$Url$Parser$map,
					$author$project$Model$Route$HomeParams,
					A2(
						$elm$url$Url$Parser$questionMark,
						$elm$url$Url$Parser$top,
						$elm$url$Url$Parser$Query$string('signupSource')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$OutOfCompliance,
				$elm$url$Url$Parser$s('out-of-compliance')),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$AuthorizeDevice,
				A2(
					$elm$url$Url$Parser$map,
					$author$project$Model$Route$AuthorizeDeviceParams,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('authorize'),
						A2(
							$elm$url$Url$Parser$questionMark,
							A2(
								$elm$url$Url$Parser$questionMark,
								$elm$url$Url$Parser$s('device'),
								$elm$url$Url$Parser$Query$string('user-code')),
							$elm$url$Url$Parser$Query$string('deviceCode'))))),
				$author$project$Routing$cyclic$checkoutRouteMatcher(),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$CheckEmail,
				$elm$url$Url$Parser$s('check-email')),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$PreferenceIndex,
				$elm$url$Url$Parser$s('preferences')),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$PreferenceIndex,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('preferences'),
					$elm$url$Url$Parser$s('account-settings'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$PreferenceTwoFactor,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('preferences'),
					$elm$url$Url$Parser$s('twofactor'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$PreferenceEmail,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('preferences'),
					$elm$url$Url$Parser$s('email'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$PreferenceLinkedAccounts,
				A2(
					$elm$url$Url$Parser$map,
					$author$project$Model$Route$PreferenceLinkedAccountsParams,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('preferences'),
						A2(
							$elm$url$Url$Parser$questionMark,
							A2(
								$elm$url$Url$Parser$questionMark,
								$elm$url$Url$Parser$s('linked-accounts'),
								$elm$url$Url$Parser$Query$string('error')),
							$elm$url$Url$Parser$Query$string('service'))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$PreferencePassword,
				A2(
					$elm$url$Url$Parser$map,
					$author$project$Model$Route$PreferencePasswordParams,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('preferences'),
						A2(
							$elm$url$Url$Parser$questionMark,
							$elm$url$Url$Parser$s('password'),
							$elm$url$Url$Parser$Query$string('mode'))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$PreferenceOrganization,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('preferences'),
					$elm$url$Url$Parser$s('organizations'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$PreferenceDeleteAccount,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('preferences'),
					$elm$url$Url$Parser$s('delete-account'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$CreateOrganization,
				A2(
					$elm$url$Url$Parser$map,
					$author$project$Model$Route$CreateOrganizationParams,
					A2(
						$elm$url$Url$Parser$questionMark,
						A2(
							$elm$url$Url$Parser$questionMark,
							$elm$url$Url$Parser$s('create-organization'),
							$author$project$Routing$queryRouteParser('nextRoute')),
						$author$project$Routing$autoProjectQueryParamsParser))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$ActivateMembership,
				A2(
					$elm$url$Url$Parser$map,
					$author$project$Model$Route$ActivateMembershipParams,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('activate'),
						A2(
							$elm$url$Url$Parser$questionMark,
							A2(
								$elm$url$Url$Parser$questionMark,
								$author$project$Routing$nonEmptyString,
								$elm$url$Url$Parser$Query$string('email')),
							$author$project$Routing$boolParam('newUser'))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$ActivateMembershipDeprecated,
				A2(
					$elm$url$Url$Parser$map,
					$author$project$Model$Route$ActivateMembershipDeprecatedParams,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('activate'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							A2(
								$elm$url$Url$Parser$questionMark,
								A2(
									$elm$url$Url$Parser$questionMark,
									$author$project$Routing$nonEmptyString,
									$elm$url$Url$Parser$Query$string('email')),
								$author$project$Routing$boolParam('newUser')))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$VerifyEmail,
				A2(
					$elm$url$Url$Parser$map,
					$author$project$Model$Route$VerifyEmailParams,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('verify'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							A2(
								$elm$url$Url$Parser$questionMark,
								$elm$url$Url$Parser$string,
								$author$project$Routing$queryRouteParser('nextRoute')))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$Admin,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('admin'),
					$author$project$Routing$adminRouteMatcher)),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$CreateProjectFromCommit,
				A2(
					$elm$url$Url$Parser$map,
					$author$project$Model$Route$CreateProjectFromCommitParams,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('create-project'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('from-commit'),
							A2(
								$elm$url$Url$Parser$questionMark,
								$author$project$Routing$uuid,
								$elm$url$Url$Parser$Query$string('projectName')))))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$CreateProjectRedirect,
				A2(
					$elm$url$Url$Parser$questionMark,
					$elm$url$Url$Parser$s('create-project'),
					$author$project$Routing$createProjectParamsQueryParser)),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$ImportProject,
				A2(
					$elm$url$Url$Parser$map,
					$author$project$Model$Route$ImportProjectParams($elm$core$Maybe$Nothing),
					$elm$url$Url$Parser$s('import-project'))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$Orgs,
				$elm$url$Url$Parser$s('organizations')),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$CreateProject,
				A2(
					$elm$url$Url$Parser$map,
					$author$project$Model$Route$CreateOrgProjectParams,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						A2(
							$elm$url$Url$Parser$questionMark,
							$elm$url$Url$Parser$s('create-project'),
							$author$project$Routing$createProjectParamsQueryParser)))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$ImportProject,
				A2(
					$elm$url$Url$Parser$map,
					A2($elm$core$Basics$composeL, $author$project$Model$Route$ImportProjectParams, $elm$core$Maybe$Just),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('import-project')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$FinishSetup,
				A2(
					$elm$url$Url$Parser$map,
					$author$project$Model$Route$FinishSetupParams,
					A2(
						$elm$url$Url$Parser$questionMark,
						$elm$url$Url$Parser$s('finish-setup'),
						$author$project$Routing$queryRouteParser('nextRoute')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$Org,
				A2(
					$elm$url$Url$Parser$map,
					$author$project$Model$Route$OrgParams,
					A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $author$project$Routing$orgRouteMatcher)))
			]));
}
function $author$project$Routing$cyclic$checkoutRouteMatcher() {
	return $elm$url$Url$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$Checkout,
				A2(
					$elm$url$Url$Parser$map,
					$author$project$Model$Route$CheckoutParams(false),
					A2(
						$elm$url$Url$Parser$questionMark,
						A2(
							$elm$url$Url$Parser$questionMark,
							A2(
								$elm$url$Url$Parser$questionMark,
								A2(
									$elm$url$Url$Parser$questionMark,
									A2(
										$elm$url$Url$Parser$questionMark,
										$elm$url$Url$Parser$s('checkout'),
										$author$project$Routing$boolParam('newUser')),
									$author$project$Routing$queryRouteParser('nextRoute')),
								$author$project$Routing$tierParam),
							$elm$url$Url$Parser$Query$string('orgUrl')),
						$author$project$Routing$boolParam('skipSelection')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$Checkout,
				A2(
					$elm$url$Url$Parser$map,
					$author$project$Model$Route$CheckoutParams(true),
					A2(
						$elm$url$Url$Parser$questionMark,
						A2(
							$elm$url$Url$Parser$questionMark,
							A2(
								$elm$url$Url$Parser$questionMark,
								A2(
									$elm$url$Url$Parser$questionMark,
									A2(
										$elm$url$Url$Parser$questionMark,
										$elm$url$Url$Parser$s('trial-checkout'),
										$author$project$Routing$boolParam('newUser')),
									$author$project$Routing$queryRouteParser('nextRoute')),
								$author$project$Routing$tierParam),
							$elm$url$Url$Parser$Query$string('orgUrl')),
						$author$project$Routing$boolParam('skipSelection')))),
				A2(
				$elm$url$Url$Parser$map,
				$author$project$Model$Route$Upgrade,
				A2(
					$elm$url$Url$Parser$map,
					$author$project$Model$Route$UpgradeParams,
					A2(
						$elm$url$Url$Parser$questionMark,
						A2(
							$elm$url$Url$Parser$questionMark,
							$elm$url$Url$Parser$s('upgrade'),
							$author$project$Routing$boolParam('newUser')),
						$author$project$Routing$queryRouteParser('nextRoute'))))
			]));
}
var $author$project$Routing$matchers = $author$project$Routing$cyclic$matchers();
$author$project$Routing$cyclic$matchers = function () {
	return $author$project$Routing$matchers;
};
var $author$project$Routing$protectedRouteMatcher = $author$project$Routing$cyclic$protectedRouteMatcher();
$author$project$Routing$cyclic$protectedRouteMatcher = function () {
	return $author$project$Routing$protectedRouteMatcher;
};
var $author$project$Routing$checkoutRouteMatcher = $author$project$Routing$cyclic$checkoutRouteMatcher();
$author$project$Routing$cyclic$checkoutRouteMatcher = function () {
	return $author$project$Routing$checkoutRouteMatcher;
};
var $author$project$Routing$parseLocation = function (location) {
	var _v0 = A2($elm$url$Url$Parser$parse, $author$project$Routing$matchers, location);
	if (_v0.$ === 1) {
		return $author$project$Model$Route$NotFound;
	} else {
		var route = _v0.a;
		return route;
	}
};
var $author$project$Model$Environment$Development = 1;
var $author$project$Model$Environment$DoesNotMatch = 4;
var $author$project$Model$Environment$ExpectingDigits = 3;
var $author$project$Model$Environment$ExpectingFirstDigit = 2;
var $author$project$Model$Environment$ExpectingP = 0;
var $author$project$Model$Environment$ExpectingR = 1;
var $author$project$Model$Environment$Production = 2;
var $author$project$Model$Environment$Unknown = 0;
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $elm$core$String$trim = _String_trim;
var $author$project$Model$Environment$parseRollbarEnv = function (rollbarEnv) {
	var normalized = $elm$core$String$toLower(
		$elm$core$String$trim(rollbarEnv));
	switch (normalized) {
		case 'production':
			return 2;
		case 'staging':
			return 1;
		case 'development':
			return 1;
		default:
			var isPREnv = A3(
				$elm$core$List$foldl,
				F2(
					function (c, acc) {
						var _v1 = _Utils_Tuple2(c, acc);
						switch (_v1.b) {
							case 4:
								var _v2 = _v1.b;
								return 4;
							case 0:
								if ('p' === _v1.a) {
									var _v3 = _v1.b;
									return 1;
								} else {
									var _v4 = _v1.b;
									return 4;
								}
							case 1:
								if ('r' === _v1.a) {
									var _v5 = _v1.b;
									return 2;
								} else {
									var _v6 = _v1.b;
									return 4;
								}
							case 2:
								switch (_v1.a) {
									case '0':
										var _v7 = _v1.b;
										return 3;
									case '1':
										var _v8 = _v1.b;
										return 3;
									case '2':
										var _v9 = _v1.b;
										return 3;
									case '3':
										var _v10 = _v1.b;
										return 3;
									case '4':
										var _v11 = _v1.b;
										return 3;
									case '5':
										var _v12 = _v1.b;
										return 3;
									case '6':
										var _v13 = _v1.b;
										return 3;
									case '7':
										var _v14 = _v1.b;
										return 3;
									case '8':
										var _v15 = _v1.b;
										return 3;
									case '9':
										var _v16 = _v1.b;
										return 3;
									default:
										var _v17 = _v1.b;
										return 4;
								}
							default:
								switch (_v1.a) {
									case '0':
										var _v18 = _v1.b;
										return 3;
									case '1':
										var _v19 = _v1.b;
										return 3;
									case '2':
										var _v20 = _v1.b;
										return 3;
									case '3':
										var _v21 = _v1.b;
										return 3;
									case '4':
										var _v22 = _v1.b;
										return 3;
									case '5':
										var _v23 = _v1.b;
										return 3;
									case '6':
										var _v24 = _v1.b;
										return 3;
									case '7':
										var _v25 = _v1.b;
										return 3;
									case '8':
										var _v26 = _v1.b;
										return 3;
									case '9':
										var _v27 = _v1.b;
										return 3;
									default:
										var _v28 = _v1.b;
										return 4;
								}
						}
					}),
				0,
				$elm$core$String$toList(normalized)) === 3;
			return isPREnv ? 1 : 0;
	}
};
var $author$project$Http$Extra$None = {$: 0};
var $author$project$Model$JWT$JWT = F2(
	function (token, user) {
		return {GI: token, gS: user};
	});
var $author$project$Model$User$User = function (userID) {
	return function (added) {
		return function (lastLogin) {
			return function (eulaAccepted) {
				return function (username) {
					return function (email) {
						return function (organizations) {
							return function (timezone) {
								return function (datetimeFormat) {
									return function (expires) {
										return function (totpEnabled) {
											return function (verifiedEmail) {
												return function (acl) {
													return function (isPaidUser) {
														return function (canUnlinkAccount) {
															return function (linkedAccounts) {
																return function (noncomplianceStatus) {
																	return function (everStartedTrial) {
																		return function (isEligibleForTrial) {
																			return function (isUsernameAutogenerated) {
																				return {qa: acl, ak: added, Bp: canUnlinkAccount, xS: datetimeFormat, lJ: email, tM: eulaAccepted, Ct: everStartedTrial, yi: expires, De: isEligibleForTrial, un: isPaidUser, DJ: isUsernameAutogenerated, yZ: lastLogin, D2: linkedAccounts, EC: noncomplianceStatus, mX: organizations, eR: timezone, Aw: totpEnabled, wV: userID, AE: username, w1: verifiedEmail};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $author$project$Model$Compliance$ComplianceBanner = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$Compliance$ComplianceBlock = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$Compliance$ComplianceRecord = F2(
	function (companyName, variant) {
		return {tg: companyName, eX: variant};
	});
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $author$project$Model$Compliance$decodeComplianceRecord = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Model$Compliance$ComplianceRecord,
	A2($elm$json$Json$Decode$field, 'companyName', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$int));
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $author$project$Model$Compliance$decode = function () {
	var recToType = function (rec) {
		var _v0 = rec.eX;
		switch (_v0) {
			case 0:
				return $elm$core$Maybe$Just(
					$author$project$Model$Compliance$ComplianceBlock(rec.tg));
			case 1:
				return $elm$core$Maybe$Just(
					$author$project$Model$Compliance$ComplianceBanner(rec.tg));
			default:
				return $elm$core$Maybe$Nothing;
		}
	};
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, recToType, $author$project$Model$Compliance$decodeComplianceRecord),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
}();
var $author$project$Model$Membership$Membership = F6(
	function (urlName, organizationID, role, tier, created, joined) {
		return {ts: created, DM: joined, zw: organizationID, FO: role, dc: tier, AC: urlName};
	});
var $elm$json$Json$Decode$fail = _Json_fail;
var $author$project$Model$Role$Admin = 2;
var $author$project$Model$Role$Editor = 1;
var $author$project$Model$Role$Reader = 0;
var $author$project$Model$Role$fromString = function (role) {
	switch (role) {
		case 'admin':
			return $elm$core$Maybe$Just(2);
		case 'editor':
			return $elm$core$Maybe$Just(1);
		case 'reader':
			return $elm$core$Maybe$Just(0);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$Role$decode = function () {
	var decodeRoleString = A2(
		$elm$core$Basics$composeR,
		$author$project$Model$Role$fromString,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($elm$json$Json$Decode$succeed),
			$elm$core$Maybe$withDefault(
				$elm$json$Json$Decode$fail('Invalid role, expected (admin, editor, reader).'))));
	return A2($elm$json$Json$Decode$andThen, decodeRoleString, $elm$json$Json$Decode$string);
}();
var $elm$parser$Parser$deadEndsToString = function (deadEnds) {
	return 'TODO deadEndsToString';
};
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {xG: col, BY: contextStack, Fp: problem, hP: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.hP, s.xG, x, s.bL));
	});
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.fG),
			s.uR) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.fG);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.uR, offset) < 0,
					0,
					{xG: col, bL: s0.bL, cy: s0.cy, uR: offset, hP: row, fG: s0.fG});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.uR, s.hP, s.xG, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.uR, s1.uR, s0.fG),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $elm$core$Basics$round = _Basics_round;
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $elm$core$String$toFloat = _String_toFloat;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = A2(
	$elm$parser$Parser$andThen,
	function (str) {
		if ($elm$core$String$length(str) <= 9) {
			var _v0 = $elm$core$String$toFloat('0.' + str);
			if (!_v0.$) {
				var floatVal = _v0.a;
				return $elm$parser$Parser$succeed(
					$elm$core$Basics$round(floatVal * 1000));
			} else {
				return $elm$parser$Parser$problem('Invalid float: \"' + (str + '\"'));
			}
		} else {
			return $elm$parser$Parser$problem(
				'Expected at most 9 digits, but got ' + $elm$core$String$fromInt(
					$elm$core$String$length(str)));
		}
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(
	function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
		return $elm$time$Time$millisToPosix((((monthYearDayMs + (((hour * 60) * 60) * 1000)) + (((minute - utcOffsetMinutes) * 60) * 1000)) + (second * 1000)) + ms);
	});
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$core$String$append = _String_append;
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.uR, s.fG);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{xG: 1, bL: s.bL, cy: s.cy, uR: s.uR + 1, hP: s.hP + 1, fG: s.fG}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{xG: s.xG + 1, bL: s.bL, cy: s.cy, uR: newOffset, hP: s.hP, fG: s.fG}));
		};
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0;
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
	var helper = function (str) {
		if (_Utils_eq(
			$elm$core$String$length(str),
			quantity)) {
			var _v0 = $elm$core$String$toInt(str);
			if (!_v0.$) {
				var intVal = _v0.a;
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$Done,
					$elm$parser$Parser$succeed(intVal));
			} else {
				return $elm$parser$Parser$problem('Invalid integer: \"' + (str + '\"'));
			}
		} else {
			return A2(
				$elm$parser$Parser$map,
				function (nextChar) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$String$append, str, nextChar));
				},
				$elm$parser$Parser$getChompedString(
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
		}
	};
	return A2($elm$parser$Parser$loop, '', helper);
};
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$core$Basics$not = _Basics_not;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.uR, s.hP, s.xG, s.fG);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{xG: newCol, bL: s.bL, cy: s.cy, uR: newOffset, hP: newRow, fG: s.fG});
	};
};
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
	return $elm$parser$Parser$problem(
		'Invalid day: ' + $elm$core$String$fromInt(day));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
	return (!A2($elm$core$Basics$modBy, 4, year)) && ((!(!A2($elm$core$Basics$modBy, 100, year))) || (!A2($elm$core$Basics$modBy, 400, year)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
	var y = y1 - 1;
	return (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_v0) {
	var year = _v0.a;
	var month = _v0.b;
	var dayInMonth = _v0.c;
	if (dayInMonth < 0) {
		return $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
	} else {
		var succeedWith = function (extraMs) {
			var yearMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
			var days = ((month < 3) || (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year))) ? (dayInMonth - 1) : dayInMonth;
			var dayMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + ($rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore($rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
			return $elm$parser$Parser$succeed((extraMs + yearMs) + dayMs);
		};
		switch (month) {
			case 1:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
			case 2:
				return ((dayInMonth > 29) || ((dayInMonth === 29) && (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year)))) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
			case 3:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
			case 4:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
			case 5:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
			case 6:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
			case 7:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
			case 8:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
			case 9:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
			case 10:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
			case 11:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
			case 12:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
			default:
				return $elm$parser$Parser$problem(
					'Invalid month: \"' + ($elm$core$String$fromInt(month) + '\"'));
		}
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2(
	$elm$parser$Parser$andThen,
	$rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F3(
						function (year, month, day) {
							return _Utils_Tuple3(year, month, day);
						})),
				$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed($elm$core$Basics$identity),
							$elm$parser$Parser$symbol('-')),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
					]))),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Basics$identity),
						$elm$parser$Parser$symbol('-')),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
				]))));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes = function () {
	var utcOffsetMinutesFromParts = F3(
		function (multiplier, hours, minutes) {
			return (multiplier * (hours * 60)) + minutes;
		});
	return A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$map,
					function (_v0) {
						return 0;
					},
					$elm$parser$Parser$symbol('Z')),
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed(utcOffsetMinutesFromParts),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$map,
										function (_v1) {
											return 1;
										},
										$elm$parser$Parser$symbol('+')),
										A2(
										$elm$parser$Parser$map,
										function (_v2) {
											return -1;
										},
										$elm$parser$Parser$symbol('-'))
									]))),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$ignorer,
									$elm$parser$Parser$succeed($elm$core$Basics$identity),
									$elm$parser$Parser$symbol(':')),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
								$elm$parser$Parser$succeed(0)
							]))),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(0),
					$elm$parser$Parser$end)
				])));
}();
var $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2(
	$elm$parser$Parser$andThen,
	function (datePart) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed(
											$rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)),
										$elm$parser$Parser$symbol('T')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$elm$parser$Parser$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$keeper,
											A2(
												$elm$parser$Parser$ignorer,
												$elm$parser$Parser$succeed($elm$core$Basics$identity),
												$elm$parser$Parser$symbol(':')),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
										]))),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$keeper,
										A2(
											$elm$parser$Parser$ignorer,
											$elm$parser$Parser$succeed($elm$core$Basics$identity),
											$elm$parser$Parser$symbol(':')),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
									]))),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$symbol('.')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs),
									$elm$parser$Parser$succeed(0)
								]))),
					A2($elm$parser$Parser$ignorer, $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes, $elm$parser$Parser$end)),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A6($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts, datePart, 0, 0, 0, 0, 0)),
					$elm$parser$Parser$end)
				]));
	},
	$rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {xG: col, Fp: problem, hP: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.hP, p.xG, p.Fp);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{xG: 1, bL: _List_Nil, cy: 1, uR: 0, hP: 1, fG: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
	return A2($elm$parser$Parser$run, $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		var _v0 = $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(str);
		if (_v0.$ === 1) {
			var deadEnds = _v0.a;
			return $elm$json$Json$Decode$fail(
				$elm$parser$Parser$deadEndsToString(deadEnds));
		} else {
			var time = _v0.a;
			return $elm$json$Json$Decode$succeed(time);
		}
	},
	$elm$json$Json$Decode$string);
var $danyx23$elm_uuid$Uuid$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		var _v0 = $danyx23$elm_uuid$Uuid$fromString(string);
		if (!_v0.$) {
			var uuid = _v0.a;
			return $elm$json$Json$Decode$succeed(uuid);
		} else {
			return $elm$json$Json$Decode$fail('Not a valid UUID');
		}
	},
	$elm$json$Json$Decode$string);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$Model$Membership$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'joined',
	$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'created',
		$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'tier',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'role',
				$author$project$Model$Role$decode,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'organizationID',
					$danyx23$elm_uuid$Uuid$decoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'URLname',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Model$Membership$Membership)))))));
var $author$project$Model$OAuth$GitHub = 0;
var $author$project$Model$OAuth$Google = 1;
var $author$project$Model$OAuth$decodeService = function (service) {
	var _v0 = $elm$core$String$toLower(service);
	switch (_v0) {
		case 'github':
			return $elm$json$Json$Decode$succeed(0);
		case 'google':
			return $elm$json$Json$Decode$succeed(1);
		default:
			return $elm$json$Json$Decode$fail('Could not decode service name ' + service);
	}
};
var $author$project$Model$OAuth$decode = A2($elm$json$Json$Decode$andThen, $author$project$Model$OAuth$decodeService, $elm$json$Json$Decode$string);
var $author$project$Model$ACL$Privileges = $elm$core$Basics$identity;
var $author$project$Model$ACL$SuperReader = 1;
var $author$project$Model$ACL$SuperUser = 0;
var $author$project$Model$ACL$privilegeFromString = function (str) {
	var _v0 = $elm$core$String$toLower(str);
	switch (_v0) {
		case 'superuser':
			return $elm$core$Maybe$Just(0);
		case 'superuser-readonly':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$ACL$privilegeFromStringIfGranted = function (_v0) {
	var privilege = _v0.a;
	var granted = _v0.b;
	return granted ? $author$project$Model$ACL$privilegeFromString(privilege) : $elm$core$Maybe$Nothing;
};
var $elm_community$maybe_extra$Maybe$Extra$cons = F2(
	function (item, list) {
		if (!item.$) {
			var v = item.a;
			return A2($elm$core$List$cons, v, list);
		} else {
			return list;
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$values = A2($elm$core$List$foldr, $elm_community$maybe_extra$Maybe$Extra$cons, _List_Nil);
var $author$project$Model$ACL$decodePrivileges = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$map($author$project$Model$ACL$privilegeFromStringIfGranted),
	A2(
		$elm$core$Basics$composeR,
		$elm_community$maybe_extra$Maybe$Extra$values,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$succeed)));
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $author$project$Model$ACL$ACL = $elm$core$Basics$identity;
var $author$project$Model$ACL$newACL = $elm$core$Basics$identity;
var $author$project$Model$ACL$decodeACL = A2(
	$elm$json$Json$Decode$map,
	$author$project$Model$ACL$newACL,
	A2(
		$elm$json$Json$Decode$andThen,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$withDefault(_List_Nil),
			$author$project$Model$ACL$decodePrivileges),
		$elm$json$Json$Decode$maybe(
			$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$bool))));
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (pathDecoder, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2($elm$json$Json$Decode$decodeValue, pathDecoder, input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					var finalErr = _v1.a;
					return $elm$json$Json$Decode$fail(
						$elm$json$Json$Decode$errorToString(finalErr));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				A2($elm$json$Json$Decode$field, key, $elm$json$Json$Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$Json$Decode$Pipeline$Extra$decodeMaybe = F2(
	function (key, decoder) {
		return A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			key,
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
			$elm$core$Maybe$Nothing);
	});
var $elm$json$Json$Decode$list = _Json_decodeList;
var $author$project$Model$ACL$fromList = A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $elm$core$Basics$identity);
var $author$project$Model$ACL$noPrivileges = $author$project$Model$ACL$fromList(_List_Nil);
var $author$project$Model$User$decode = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'isUsernameAutogenerated',
	$elm$json$Json$Decode$bool,
	false,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'isEligibleForTrial',
		$elm$json$Json$Decode$bool,
		false,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'everStartedTrial',
			$elm$json$Json$Decode$bool,
			false,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'noncomplianceStatus',
				$author$project$Model$Compliance$decode,
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'linkedAccounts',
					$elm$json$Json$Decode$list($author$project$Model$OAuth$decode),
					_List_Nil,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'canUnlinkAccount',
						$elm$json$Json$Decode$bool,
						false,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'isPaidUser',
							$elm$json$Json$Decode$bool,
							false,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'acl',
								$author$project$Model$ACL$decodeACL,
								$author$project$Model$ACL$noPrivileges,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'verifiedEmail',
									$elm$json$Json$Decode$bool,
									false,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'TOTPEnabled',
										$elm$json$Json$Decode$bool,
										false,
										A3(
											$author$project$Json$Decode$Pipeline$Extra$decodeMaybe,
											'expires',
											$elm$json$Json$Decode$string,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'datetimeFormat',
												$elm$json$Json$Decode$string,
												'MMM D YYYY [at] hh:mm:ss A',
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'timezone',
													$elm$json$Json$Decode$string,
													'America/Vancouver',
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'organizations',
														$elm$json$Json$Decode$list($author$project$Model$Membership$decode),
														_List_Nil,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'email',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'username',
																$elm$json$Json$Decode$string,
																A3(
																	$author$project$Json$Decode$Pipeline$Extra$decodeMaybe,
																	'EULAAccepted',
																	$elm$json$Json$Decode$string,
																	A3(
																		$author$project$Json$Decode$Pipeline$Extra$decodeMaybe,
																		'lastLogin',
																		$elm$json$Json$Decode$string,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'added',
																			$elm$json$Json$Decode$string,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'userID',
																				$elm$json$Json$Decode$string,
																				$elm$json$Json$Decode$succeed($author$project$Model$User$User)))))))))))))))))))));
var $author$project$Model$JWT$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'user',
	$author$project$Model$User$decode,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'token',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Model$JWT$JWT)));
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $author$project$Http$Extra$emptyBody = $elm$http$Http$emptyBody;
var $author$project$Protected$getToken = function (_v0) {
	var creds = _v0;
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.GI;
			},
			creds));
};
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $author$project$Http$Extra$authToHeaders = function (auth) {
	var token = function () {
		switch (auth.$) {
			case 0:
				return '';
			case 1:
				var creds = auth.a;
				return $author$project$Protected$getToken(creds);
			default:
				var creds = auth.a;
				return $author$project$Protected$getToken(creds);
		}
	}();
	return $elm$core$String$isEmpty(token) ? _List_Nil : _List_fromArray(
		[
			A2($elm$http$Http$header, 'Authorization', 'Bearer ' + token)
		]);
};
var $author$project$Http$Extra$urlBase = '/api/v1';
var $author$project$Http$Extra$authToUrlBase = function (auth) {
	switch (auth.$) {
		case 0:
			return '';
		case 1:
			return '';
		default:
			return $author$project$Http$Extra$urlBase;
	}
};
var $author$project$Http$Extra$BadPayload = function (a) {
	return {$: 4, a: a};
};
var $author$project$Http$Extra$Error = F2(
	function (url, kind) {
		return {mp: kind, GT: url};
	});
var $author$project$Http$Extra$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $author$project$Http$Extra$BadUrl = {$: 0};
var $author$project$Http$Extra$NetworkError = {$: 2};
var $author$project$Http$Extra$Timeout = {$: 1};
var $author$project$Http$Extra$metadataToResponse = F2(
	function (metadata, body) {
		return {sY: body, CN: metadata.CN, wp: metadata.wp, wq: metadata.wq};
	});
var $author$project$Http$Extra$responseToResultRaw = F2(
	function (url_, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					A2($author$project$Http$Extra$Error, url, $author$project$Http$Extra$BadUrl));
			case 1:
				return $elm$core$Result$Err(
					A2($author$project$Http$Extra$Error, url_, $author$project$Http$Extra$Timeout));
			case 2:
				return $elm$core$Result$Err(
					A2($author$project$Http$Extra$Error, url_, $author$project$Http$Extra$NetworkError));
			case 3:
				var metadata = response.a;
				var body = response.b;
				return $elm$core$Result$Err(
					A2(
						$author$project$Http$Extra$Error,
						url_,
						$author$project$Http$Extra$BadStatus(
							A2($author$project$Http$Extra$metadataToResponse, metadata, body))));
			default:
				var bodyRaw = response.b;
				return $elm$core$Result$Ok(bodyRaw);
		}
	});
var $author$project$Http$Extra$responseToResult = F3(
	function (url, decoder, response) {
		var _v0 = A2($author$project$Http$Extra$responseToResultRaw, url, response);
		if (!_v0.$) {
			var bodyRaw = _v0.a;
			var body = $elm$core$String$isEmpty(bodyRaw) ? 'null' : bodyRaw;
			var _v1 = A2($elm$json$Json$Decode$decodeString, decoder, body);
			if (!_v1.$) {
				var value = _v1.a;
				return $elm$core$Result$Ok(value);
			} else {
				var decodeError = _v1.a;
				return $elm$core$Result$Err(
					A2(
						$author$project$Http$Extra$Error,
						url,
						$author$project$Http$Extra$BadPayload(
							$elm$json$Json$Decode$errorToString(decodeError))));
			}
		} else {
			var err = _v0.a;
			return $elm$core$Result$Err(err);
		}
	});
var $elm$http$Http$stringResolver = A2(_Http_expect, '', $elm$core$Basics$identity);
var $elm$core$Task$fail = _Scheduler_fail;
var $elm$http$Http$resultToTask = function (result) {
	if (!result.$) {
		var a = result.a;
		return $elm$core$Task$succeed(a);
	} else {
		var x = result.a;
		return $elm$core$Task$fail(x);
	}
};
var $elm$http$Http$task = function (r) {
	return A3(
		_Http_toTask,
		0,
		$elm$http$Http$resultToTask,
		{A5: false, sY: r.sY, Cy: r.nj, CN: r.CN, my: r.my, nE: r.nE, GL: $elm$core$Maybe$Nothing, GT: r.GT});
};
var $elm_community$basics_extra$Basics$Extra$uncurry = F2(
	function (f, _v0) {
		var a = _v0.a;
		var b = _v0.b;
		return A2(f, a, b);
	});
var $author$project$Http$Extra$get = function (_v0) {
	var url = _v0.GT;
	var body = _v0.sY;
	var decoder = _v0.qN;
	var auth = _v0.iO;
	var headers = _v0.CN;
	return $elm$http$Http$task(
		{
			sY: body,
			CN: _Utils_ap(
				$author$project$Http$Extra$authToHeaders(auth),
				A2(
					$elm$core$List$map,
					$elm_community$basics_extra$Basics$Extra$uncurry($elm$http$Http$header),
					headers)),
			my: 'GET',
			nj: $elm$http$Http$stringResolver(
				A2($author$project$Http$Extra$responseToResult, url, decoder)),
			nE: $elm$core$Maybe$Nothing,
			GT: _Utils_ap(
				$author$project$Http$Extra$authToUrlBase(auth),
				url)
		});
};
var $author$project$Request$User$renew = $author$project$Http$Extra$get(
	{iO: $author$project$Http$Extra$None, sY: $author$project$Http$Extra$emptyBody, qN: $author$project$Model$JWT$decode, CN: _List_Nil, GT: $author$project$Http$Extra$urlBase + '/renew'});
var $author$project$Main$init = F3(
	function (flags, location, key) {
		var route = $author$project$Routing$parseLocation(location);
		var _v0 = $author$project$Model$Session$init(flags);
		var session = _v0.a;
		var sessionCmd = _v0.b;
		var model = {
			cF: $elm$core$Maybe$Nothing,
			ot: $author$project$Model$Environment$parseRollbarEnv(flags.zU),
			Y: key,
			cz: $author$project$Main$NotLoading,
			fD: location,
			u: A2($author$project$PageState$init, $author$project$Page$Blank, route),
			l: session,
			hS: $elm$core$Maybe$Nothing,
			hT: $elm$core$Maybe$Nothing
		};
		return A2(
			$author$project$Misc$with,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Msg$OnCurrentTimeUpdate, $elm$time$Time$now),
						A2(
						$elm$core$Task$attempt,
						$author$project$Msg$OnRenew(
							$elm$core$Maybe$Just(route)),
						$author$project$Request$User$renew),
						A2($elm$core$Platform$Cmd$map, $author$project$Msg$SessionMsg, sessionCmd)
					])),
			model);
	});
var $author$project$Msg$AuthHeaderCopiedToClipboard = function (a) {
	return {$: 7, a: a};
};
var $author$project$Msg$DoRenew = {$: 63};
var $author$project$Msg$ToggleDropDown = {$: 2};
var $author$project$Msg$ToggleOrgDropDown = {$: 4};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $author$project$Ports$copyStatus = _Platform_incomingPort(
	'copyStatus',
	A2(
		$elm$json$Json$Decode$andThen,
		function (status) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (copyID) {
					return $elm$json$Json$Decode$succeed(
						{xN: copyID, L: status});
				},
				A2($elm$json$Json$Decode$field, 'copyID', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$bool)));
var $author$project$Views$SiteWrapper$dropdownToggleId = 'dropdown-toggle';
var $elm$time$Time$Every = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$State = F2(
	function (taggers, processes) {
		return {zJ: processes, Am: taggers};
	});
var $elm$time$Time$init = $elm$core$Task$succeed(
	A2($elm$time$Time$State, $elm$core$Dict$empty, $elm$core$Dict$empty));
var $elm$time$Time$addMySub = F2(
	function (_v0, state) {
		var interval = _v0.a;
		var tagger = _v0.b;
		var _v1 = A2($elm$core$Dict$get, interval, state);
		if (_v1.$ === 1) {
			return A3(
				$elm$core$Dict$insert,
				interval,
				_List_fromArray(
					[tagger]),
				state);
		} else {
			var taggers = _v1.a;
			return A3(
				$elm$core$Dict$insert,
				interval,
				A2($elm$core$List$cons, tagger, taggers),
				state);
		}
	});
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$time$Time$setInterval = _Time_setInterval;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$time$Time$spawnHelp = F3(
	function (router, intervals, processes) {
		if (!intervals.b) {
			return $elm$core$Task$succeed(processes);
		} else {
			var interval = intervals.a;
			var rest = intervals.b;
			var spawnTimer = $elm$core$Process$spawn(
				A2(
					$elm$time$Time$setInterval,
					interval,
					A2($elm$core$Platform$sendToSelf, router, interval)));
			var spawnRest = function (id) {
				return A3(
					$elm$time$Time$spawnHelp,
					router,
					rest,
					A3($elm$core$Dict$insert, interval, id, processes));
			};
			return A2($elm$core$Task$andThen, spawnRest, spawnTimer);
		}
	});
var $elm$time$Time$onEffects = F3(
	function (router, subs, _v0) {
		var processes = _v0.zJ;
		var rightStep = F3(
			function (_v6, id, _v7) {
				var spawns = _v7.a;
				var existing = _v7.b;
				var kills = _v7.c;
				return _Utils_Tuple3(
					spawns,
					existing,
					A2(
						$elm$core$Task$andThen,
						function (_v5) {
							return kills;
						},
						$elm$core$Process$kill(id)));
			});
		var newTaggers = A3($elm$core$List$foldl, $elm$time$Time$addMySub, $elm$core$Dict$empty, subs);
		var leftStep = F3(
			function (interval, taggers, _v4) {
				var spawns = _v4.a;
				var existing = _v4.b;
				var kills = _v4.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, interval, spawns),
					existing,
					kills);
			});
		var bothStep = F4(
			function (interval, taggers, id, _v3) {
				var spawns = _v3.a;
				var existing = _v3.b;
				var kills = _v3.c;
				return _Utils_Tuple3(
					spawns,
					A3($elm$core$Dict$insert, interval, id, existing),
					kills);
			});
		var _v1 = A6(
			$elm$core$Dict$merge,
			leftStep,
			bothStep,
			rightStep,
			newTaggers,
			processes,
			_Utils_Tuple3(
				_List_Nil,
				$elm$core$Dict$empty,
				$elm$core$Task$succeed(0)));
		var spawnList = _v1.a;
		var existingDict = _v1.b;
		var killTask = _v1.c;
		return A2(
			$elm$core$Task$andThen,
			function (newProcesses) {
				return $elm$core$Task$succeed(
					A2($elm$time$Time$State, newTaggers, newProcesses));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$time$Time$spawnHelp, router, spawnList, existingDict);
				},
				killTask));
	});
var $elm$time$Time$onSelfMsg = F3(
	function (router, interval, state) {
		var _v0 = A2($elm$core$Dict$get, interval, state.Am);
		if (_v0.$ === 1) {
			return $elm$core$Task$succeed(state);
		} else {
			var taggers = _v0.a;
			var tellTaggers = function (time) {
				return $elm$core$Task$sequence(
					A2(
						$elm$core$List$map,
						function (tagger) {
							return A2(
								$elm$core$Platform$sendToApp,
								router,
								tagger(time));
						},
						taggers));
			};
			return A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$succeed(state);
				},
				A2($elm$core$Task$andThen, tellTaggers, $elm$time$Time$now));
		}
	});
var $elm$time$Time$subMap = F2(
	function (f, _v0) {
		var interval = _v0.a;
		var tagger = _v0.b;
		return A2(
			$elm$time$Time$Every,
			interval,
			A2($elm$core$Basics$composeL, f, tagger));
	});
_Platform_effectManagers['Time'] = _Platform_createManager($elm$time$Time$init, $elm$time$Time$onEffects, $elm$time$Time$onSelfMsg, 0, $elm$time$Time$subMap);
var $elm$time$Time$subscription = _Platform_leaf('Time');
var $elm$time$Time$every = F2(
	function (interval, tagger) {
		return $elm$time$Time$subscription(
			A2($elm$time$Time$Every, interval, tagger));
	});
var $author$project$Model$Session$getDropdownOpen = function (_v0) {
	var session = _v0;
	return session.tI;
};
var $author$project$Model$Session$getOrgDropdownOpen = function (_v0) {
	var session = _v0;
	return session.vH;
};
var $author$project$PageState$getPage = function (pageState) {
	if (!pageState.$) {
		var currentPage = pageState.a.jK;
		return currentPage;
	} else {
		var currentPage = pageState.a.jK;
		return currentPage;
	}
};
var $elm$core$Platform$Sub$map = _Platform_map;
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $elm$browser$Browser$Events$Document = 0;
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {zG: pids, Aj: subs};
	});
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (!node) {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {yg: event, Y: key};
	});
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (!node) {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.zG,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var key = _v0.Y;
		var event = _v0.yg;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.Aj);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$onMouseUp = A2($elm$browser$Browser$Events$on, 0, 'mouseup');
var $elm$json$Json$Decode$lazy = function (thunk) {
	return A2(
		$elm$json$Json$Decode$andThen,
		thunk,
		$elm$json$Json$Decode$succeed(0));
};
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $author$project$Misc$isInsideElements = function (elementIds) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (mid) {
			var anyIdMatches = function () {
				if (!mid.$) {
					var id = mid.a;
					return A2($elm$core$List$member, id, elementIds);
				} else {
					return false;
				}
			}();
			return anyIdMatches ? $elm$json$Json$Decode$succeed(true) : A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$withDefault(false),
				A3(
					$author$project$Json$Decode$Pipeline$Extra$decodeMaybe,
					'parentNode',
					$elm$json$Json$Decode$lazy(
						function (_v0) {
							return $author$project$Misc$isInsideElements(elementIds);
						}),
					$elm$json$Json$Decode$succeed($elm$core$Basics$identity)));
		},
		A3(
			$author$project$Json$Decode$Pipeline$Extra$decodeMaybe,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($elm$core$Basics$identity)));
};
var $author$project$Misc$onOutsideElements = F2(
	function (elementIds, onOutsideMsg) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (inside) {
				return inside ? $elm$json$Json$Decode$fail('inside') : $elm$json$Json$Decode$succeed(onOutsideMsg);
			},
			A2(
				$elm$json$Json$Decode$field,
				'target',
				$author$project$Misc$isInsideElements(elementIds)));
	});
var $author$project$Misc$onOutsideElement = F2(
	function (elementId, onOutsideMsg) {
		return A2(
			$author$project$Misc$onOutsideElements,
			_List_fromArray(
				[elementId]),
			onOutsideMsg);
	});
var $author$project$Msg$AdminOrganizationMsg = function (a) {
	return {$: 76, a: a};
};
var $author$project$Msg$AdminOrganizationsMsg = function (a) {
	return {$: 70, a: a};
};
var $author$project$Msg$AdminUserMsg = function (a) {
	return {$: 74, a: a};
};
var $author$project$Msg$AdminUsersMsg = function (a) {
	return {$: 73, a: a};
};
var $author$project$Msg$AuthorizeDeviceMsg = function (a) {
	return {$: 101, a: a};
};
var $author$project$Msg$ConnectAccountMsg = function (a) {
	return {$: 58, a: a};
};
var $author$project$Msg$CreateAccountMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Msg$CreateProjectMsg = function (a) {
	return {$: 82, a: a};
};
var $author$project$Msg$LoginMsg = function (a) {
	return {$: 55, a: a};
};
var $author$project$Msg$NotFoundMsg = function (a) {
	return {$: 90, a: a};
};
var $author$project$Msg$OrgDependenciesMsg = function (a) {
	return {$: 29, a: a};
};
var $author$project$Msg$OrgIndexMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Msg$OrgRemediationMsg = function (a) {
	return {$: 23, a: a};
};
var $author$project$Msg$OrgScanMsg = function (a) {
	return {$: 25, a: a};
};
var $author$project$Msg$OrgSecurityMsg = function (a) {
	return {$: 28, a: a};
};
var $author$project$Msg$PreferenceLinkedAccountsMsg = function (a) {
	return {$: 30, a: a};
};
var $author$project$Msg$PreferenceTwoFactorMsg = function (a) {
	return {$: 34, a: a};
};
var $author$project$Msg$ProjectConfigAdvancedMsg = function (a) {
	return {$: 41, a: a};
};
var $author$project$Msg$ProjectConfigMsg = function (a) {
	return {$: 40, a: a};
};
var $author$project$Msg$ProjectDownloadsMsg = function (a) {
	return {$: 44, a: a};
};
var $author$project$Msg$ProjectHistoryMsg = function (a) {
	return {$: 45, a: a};
};
var $author$project$Msg$ProjectImpactReportMsg = function (a) {
	return {$: 46, a: a};
};
var $author$project$Msg$ProjectOverviewMsg = function (a) {
	return {$: 42, a: a};
};
var $author$project$Msg$ProjectSettingsBranchesMsg = function (a) {
	return {$: 52, a: a};
};
var $author$project$Msg$ProjectSettingsHARMsg = function (a) {
	return {$: 50, a: a};
};
var $author$project$Msg$StateToolCheatSheetMsg = function (a) {
	return {$: 88, a: a};
};
var $author$project$Pages$AdminOrganization$CopyStatusMsg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$AdminOrganization$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$copyStatus($author$project$Pages$AdminOrganization$CopyStatusMsg)
			]));
};
var $author$project$Pages$AdminOrganizations$CopyStatusMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$AdminOrganizations$DoSearch = function (a) {
	return {$: 7, a: a};
};
var $author$project$Misc$decoderEnterKey = A2(
	$elm$json$Json$Decode$field,
	'key',
	A2(
		$elm$json$Json$Decode$andThen,
		function (x) {
			return (x === 'Enter') ? $elm$json$Json$Decode$succeed(0) : $elm$json$Json$Decode$fail('Not an Enter key');
		},
		$elm$json$Json$Decode$string));
var $elm$browser$Browser$Events$onKeyPress = A2($elm$browser$Browser$Events$on, 0, 'keypress');
var $author$project$Pages$AdminOrganizations$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$copyStatus($author$project$Pages$AdminOrganizations$CopyStatusMsg),
				$elm$browser$Browser$Events$onKeyPress(
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Basics$always(
						$author$project$Pages$AdminOrganizations$DoSearch($elm$core$Basics$identity)),
					$author$project$Misc$decoderEnterKey))
			]));
};
var $author$project$Pages$AdminUser$CopyStatusMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$AdminUser$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$copyStatus($author$project$Pages$AdminUser$CopyStatusMsg)
			]));
};
var $author$project$Pages$AdminUsers$CopyStatusMsg = function (a) {
	return {$: 21, a: a};
};
var $author$project$Pages$AdminUsers$DoOrgSearch = {$: 9};
var $author$project$Pages$AdminUsers$DoUserEmailSearch = {$: 5};
var $author$project$Pages$AdminUsers$DoUsernameSearch = {$: 1};
var $author$project$Pages$AdminUsers$DoVerifyEmail = {$: 16};
var $author$project$Pages$AdminUsers$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$copyStatus($author$project$Pages$AdminUsers$CopyStatusMsg),
				function () {
				var msg = function () {
					var _v0 = model.El;
					switch (_v0) {
						case 1:
							return $author$project$Pages$AdminUsers$DoUserEmailSearch;
						case 0:
							return $author$project$Pages$AdminUsers$DoUsernameSearch;
						case 2:
							return $author$project$Pages$AdminUsers$DoOrgSearch;
						default:
							return $author$project$Pages$AdminUsers$DoVerifyEmail;
					}
				}();
				return $elm$browser$Browser$Events$onKeyPress(
					A2(
						$elm$json$Json$Decode$map,
						$elm$core$Basics$always(msg),
						$author$project$Misc$decoderEnterKey));
			}()
			]));
};
var $author$project$Pages$AuthorizeDevice$CopyStatusMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$AuthorizeDevice$subscriptions = $elm$core$Platform$Sub$batch(
	_List_fromArray(
		[
			$author$project$Ports$copyStatus($author$project$Pages$AuthorizeDevice$CopyStatusMsg)
		]));
var $author$project$Pages$ConnectAccount$CSRFCookieSet = function (a) {
	return {$: 8, a: a};
};
var $author$project$Ports$csrfCookieSet = _Platform_incomingPort('csrfCookieSet', $elm$json$Json$Decode$string);
var $author$project$Pages$ConnectAccount$subscriptions = function (_v0) {
	return $author$project$Ports$csrfCookieSet($author$project$Pages$ConnectAccount$CSRFCookieSet);
};
var $author$project$Pages$CreateAccount$CSRFCookieSet = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$CreateAccount$TimePassed = {$: 14};
var $author$project$Pages$CreateAccount$timeInterval = 100;
var $author$project$Pages$CreateAccount$subscriptions = function (model) {
	var timeSub = function () {
		var _v0 = model.lq;
		if (!_v0.$) {
			return A2(
				$elm$time$Time$every,
				$author$project$Pages$CreateAccount$timeInterval,
				$elm$core$Basics$always($author$project$Pages$CreateAccount$TimePassed));
		} else {
			return $elm$core$Platform$Sub$none;
		}
	}();
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$csrfCookieSet($author$project$Pages$CreateAccount$CSRFCookieSet),
				timeSub
			]));
};
var $author$project$Pages$CreateProject$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Login$CSRFCookieSet = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Login$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$csrfCookieSet($author$project$Pages$Login$CSRFCookieSet)
			]));
};
var $author$project$Pages$NotFound$ShowModal = 2;
var $author$project$Pages$NotFound$Unseen = 0;
var $author$project$Pages$NotFound$subscriptions = function (model) {
	return (!model.j8) ? A2(
		$elm$time$Time$every,
		2000,
		function (_v0) {
			return 2;
		}) : $elm$core$Platform$Sub$none;
};
var $author$project$Pages$OrgDependencies$ToggleFilterDropdown = {$: 3};
var $author$project$Pages$OrgDependencies$filterButtonId = 'org-dependency-button-id';
var $author$project$Pages$OrgDependencies$filterDropdownId = 'org-dependency-dropdown-id';
var $author$project$Pages$OrgDependencies$subscriptions = function (model) {
	return model.lW ? $elm$browser$Browser$Events$onMouseUp(
		A2(
			$author$project$Misc$onOutsideElements,
			_List_fromArray(
				[$author$project$Pages$OrgDependencies$filterButtonId, $author$project$Pages$OrgDependencies$filterDropdownId]),
			$author$project$Pages$OrgDependencies$ToggleFilterDropdown)) : $elm$core$Platform$Sub$none;
};
var $author$project$Pages$OrgIndex$DismissModal = {$: 0};
var $author$project$Pages$OrgIndex$SetOpenedProjectQuickMenu = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$OrgIndex$ToggleSortDropdown = {$: 10};
var $author$project$Misc$decoderEscapeKey = A2(
	$elm$json$Json$Decode$field,
	'key',
	A2(
		$elm$json$Json$Decode$andThen,
		function (x) {
			return (x === 'Escape') ? $elm$json$Json$Decode$succeed(0) : $elm$json$Json$Decode$fail('Not an Esc key');
		},
		$elm$json$Json$Decode$string));
var $elm$browser$Browser$Events$onKeyDown = A2($elm$browser$Browser$Events$on, 0, 'keydown');
var $danyx23$elm_uuid$Uuid$toString = function (_v0) {
	var internalString = _v0;
	return internalString;
};
var $author$project$Views$ProjectList$quickMenuDropdownId = function (projectId) {
	return 'project-quick-menu-dropdown-' + $danyx23$elm_uuid$Uuid$toString(projectId);
};
var $author$project$Views$ProjectList$sortMenuButtonId = 'project-list-sort-menu-dropdown-button';
var $author$project$Views$ProjectList$sortMenuDropdownId = 'project-list-sort-menu-dropdown';
var $author$project$Pages$OrgIndex$subscriptions = function (model) {
	var sortMenuSub = model.ky ? $elm$browser$Browser$Events$onMouseUp(
		A2(
			$author$project$Misc$onOutsideElements,
			_List_fromArray(
				[$author$project$Views$ProjectList$sortMenuDropdownId, $author$project$Views$ProjectList$sortMenuButtonId]),
			$author$project$Pages$OrgIndex$ToggleSortDropdown)) : $elm$core$Platform$Sub$none;
	var projectMenuSub = function () {
		var _v0 = model.js;
		if (!_v0.$) {
			var projectId = _v0.a;
			return $elm$browser$Browser$Events$onMouseUp(
				A2(
					$author$project$Misc$onOutsideElement,
					$author$project$Views$ProjectList$quickMenuDropdownId(projectId),
					$author$project$Pages$OrgIndex$SetOpenedProjectQuickMenu($elm$core$Maybe$Nothing)));
		} else {
			return $elm$core$Platform$Sub$none;
		}
	}();
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				projectMenuSub,
				sortMenuSub,
				$elm$browser$Browser$Events$onKeyDown(
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Basics$always($author$project$Pages$OrgIndex$DismissModal),
					$author$project$Misc$decoderEscapeKey))
			]));
};
var $author$project$Pages$OrgRemediation$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$OrgScan$CopyStatusMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$OrgScan$subscriptions = $elm$core$Platform$Sub$batch(
	_List_fromArray(
		[
			$author$project$Ports$copyStatus($author$project$Pages$OrgScan$CopyStatusMsg)
		]));
var $author$project$Pages$OrgSecurity$ToggleFilterDropdown = {$: 3};
var $author$project$Pages$OrgSecurity$ToggleTray = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$OrgSecurity$detailsTrayId = 'org-security-details-tray-id';
var $author$project$Pages$OrgSecurity$filterButtonId = 'org-security-button-id';
var $author$project$Pages$OrgSecurity$filterDropdownId = 'org-security-dropdown-id';
var $author$project$Pages$OrgSecurity$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				model.lW ? $elm$browser$Browser$Events$onMouseUp(
				A2(
					$author$project$Misc$onOutsideElements,
					_List_fromArray(
						[$author$project$Pages$OrgSecurity$filterButtonId, $author$project$Pages$OrgSecurity$filterDropdownId]),
					$author$project$Pages$OrgSecurity$ToggleFilterDropdown)) : $elm$core$Platform$Sub$none,
				$elm$browser$Browser$Events$onKeyDown(
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Basics$always(
						$author$project$Pages$OrgSecurity$ToggleTray($elm$core$Maybe$Nothing)),
					$author$project$Misc$decoderEscapeKey)),
				$elm$browser$Browser$Events$onMouseUp(
				A2(
					$author$project$Misc$onOutsideElements,
					_List_fromArray(
						[$author$project$Pages$OrgSecurity$detailsTrayId]),
					$author$project$Pages$OrgSecurity$ToggleTray($elm$core$Maybe$Nothing)))
			]));
};
var $author$project$Pages$PreferenceLinkedAccounts$CSRFCookieSet = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$PreferenceLinkedAccounts$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$csrfCookieSet($author$project$Pages$PreferenceLinkedAccounts$CSRFCookieSet)
			]));
};
var $author$project$Pages$PreferenceTwoFactor$Animate = function (a) {
	return {$: 9, a: a};
};
var $mdgriffith$elm_style_animation$Animation$Model$Tick = $elm$core$Basics$identity;
var $mdgriffith$elm_style_animation$Animation$isRunning = function (_v0) {
	var model = _v0;
	return model.se;
};
var $elm$browser$Browser$AnimationManager$Time = function (a) {
	return {$: 0, a: a};
};
var $elm$browser$Browser$AnimationManager$State = F3(
	function (subs, request, oldTime) {
		return {uV: oldTime, zR: request, Aj: subs};
	});
var $elm$browser$Browser$AnimationManager$init = $elm$core$Task$succeed(
	A3($elm$browser$Browser$AnimationManager$State, _List_Nil, $elm$core$Maybe$Nothing, 0));
var $elm$browser$Browser$AnimationManager$now = _Browser_now(0);
var $elm$browser$Browser$AnimationManager$rAF = _Browser_rAF(0);
var $elm$browser$Browser$AnimationManager$onEffects = F3(
	function (router, subs, _v0) {
		var request = _v0.zR;
		var oldTime = _v0.uV;
		var _v1 = _Utils_Tuple2(request, subs);
		if (_v1.a.$ === 1) {
			if (!_v1.b.b) {
				var _v2 = _v1.a;
				return $elm$browser$Browser$AnimationManager$init;
			} else {
				var _v4 = _v1.a;
				return A2(
					$elm$core$Task$andThen,
					function (pid) {
						return A2(
							$elm$core$Task$andThen,
							function (time) {
								return $elm$core$Task$succeed(
									A3(
										$elm$browser$Browser$AnimationManager$State,
										subs,
										$elm$core$Maybe$Just(pid),
										time));
							},
							$elm$browser$Browser$AnimationManager$now);
					},
					$elm$core$Process$spawn(
						A2(
							$elm$core$Task$andThen,
							$elm$core$Platform$sendToSelf(router),
							$elm$browser$Browser$AnimationManager$rAF)));
			}
		} else {
			if (!_v1.b.b) {
				var pid = _v1.a.a;
				return A2(
					$elm$core$Task$andThen,
					function (_v3) {
						return $elm$browser$Browser$AnimationManager$init;
					},
					$elm$core$Process$kill(pid));
			} else {
				return $elm$core$Task$succeed(
					A3($elm$browser$Browser$AnimationManager$State, subs, request, oldTime));
			}
		}
	});
var $elm$browser$Browser$AnimationManager$onSelfMsg = F3(
	function (router, newTime, _v0) {
		var subs = _v0.Aj;
		var oldTime = _v0.uV;
		var send = function (sub) {
			if (!sub.$) {
				var tagger = sub.a;
				return A2(
					$elm$core$Platform$sendToApp,
					router,
					tagger(
						$elm$time$Time$millisToPosix(newTime)));
			} else {
				var tagger = sub.a;
				return A2(
					$elm$core$Platform$sendToApp,
					router,
					tagger(newTime - oldTime));
			}
		};
		return A2(
			$elm$core$Task$andThen,
			function (pid) {
				return A2(
					$elm$core$Task$andThen,
					function (_v1) {
						return $elm$core$Task$succeed(
							A3(
								$elm$browser$Browser$AnimationManager$State,
								subs,
								$elm$core$Maybe$Just(pid),
								newTime));
					},
					$elm$core$Task$sequence(
						A2($elm$core$List$map, send, subs)));
			},
			$elm$core$Process$spawn(
				A2(
					$elm$core$Task$andThen,
					$elm$core$Platform$sendToSelf(router),
					$elm$browser$Browser$AnimationManager$rAF)));
	});
var $elm$browser$Browser$AnimationManager$Delta = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$AnimationManager$subMap = F2(
	function (func, sub) {
		if (!sub.$) {
			var tagger = sub.a;
			return $elm$browser$Browser$AnimationManager$Time(
				A2($elm$core$Basics$composeL, func, tagger));
		} else {
			var tagger = sub.a;
			return $elm$browser$Browser$AnimationManager$Delta(
				A2($elm$core$Basics$composeL, func, tagger));
		}
	});
_Platform_effectManagers['Browser.AnimationManager'] = _Platform_createManager($elm$browser$Browser$AnimationManager$init, $elm$browser$Browser$AnimationManager$onEffects, $elm$browser$Browser$AnimationManager$onSelfMsg, 0, $elm$browser$Browser$AnimationManager$subMap);
var $elm$browser$Browser$AnimationManager$subscription = _Platform_leaf('Browser.AnimationManager');
var $elm$browser$Browser$AnimationManager$onAnimationFrame = function (tagger) {
	return $elm$browser$Browser$AnimationManager$subscription(
		$elm$browser$Browser$AnimationManager$Time(tagger));
};
var $elm$browser$Browser$Events$onAnimationFrame = $elm$browser$Browser$AnimationManager$onAnimationFrame;
var $mdgriffith$elm_style_animation$Animation$subscription = F2(
	function (msg, states) {
		return A2($elm$core$List$any, $mdgriffith$elm_style_animation$Animation$isRunning, states) ? A2(
			$elm$core$Platform$Sub$map,
			msg,
			$elm$browser$Browser$Events$onAnimationFrame($elm$core$Basics$identity)) : $elm$core$Platform$Sub$none;
	});
var $author$project$Pages$PreferenceTwoFactor$subscriptions = function (model) {
	return A2(
		$mdgriffith$elm_style_animation$Animation$subscription,
		$author$project$Pages$PreferenceTwoFactor$Animate,
		_List_fromArray(
			[model.hW]));
};
var $author$project$Pages$ProjectConfig$AddPackagesModalMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$ProjectConfig$BranchPickerViewMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$ProjectConfig$CopyStatusMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$ProjectConfig$DismissAddPackageFocus = {$: 11};
var $author$project$Pages$ProjectConfig$KeyDownEsc = {$: 14};
var $author$project$Pages$ProjectConfig$PackageVersionSelectorMsg = F2(
	function (a, b) {
		return {$: 26, a: a, b: b};
	});
var $author$project$Pages$ProjectConfig$ToggleBreakingChanges = function (a) {
	return {$: 49, a: a};
};
var $author$project$Pages$ProjectConfig$ToggleSetAllDropdown = {$: 47};
var $author$project$Pages$ProjectConfig$breakingChangesDialogId = 'breaking-changes-dialog';
var $author$project$Misc$concatIf = F3(
	function (yes, b, bs) {
		return yes ? A2(
			$elm$core$List$append,
			bs,
			_List_fromArray(
				[b])) : bs;
	});
var $author$project$Pages$ProjectConfig$focusTooltipId = 'focus-tooltip';
var $author$project$Pages$ProjectConfig$packagesDropdownButtonId = 'packages-dropdown-button';
var $author$project$Pages$ProjectConfig$packagesDropdownId = 'packages-dropdown';
var $author$project$Views$AddPackagesModal$PackageVersionSelectorMsg = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Views$PackageVersionSelector$ClickedOutside = {$: 10};
var $author$project$Views$PackageVersionSelector$KeyDownEsc = {$: 11};
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $author$project$Model$Namespace$cssString = function (_v0) {
	var namespace = _v0.a;
	var name = _v0.b;
	return A3($elm$core$String$replace, '/', '-', namespace + ('-' + name));
};
var $author$project$Views$PackageVersionSelector$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$elm$browser$Browser$Events$onMouseUp(
				A2(
					$author$project$Misc$onOutsideElement,
					$author$project$Model$Namespace$cssString(model.Y),
					$author$project$Views$PackageVersionSelector$ClickedOutside)),
				$elm$browser$Browser$Events$onKeyDown(
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Basics$always($author$project$Views$PackageVersionSelector$KeyDownEsc),
					$author$project$Misc$decoderEscapeKey))
			]));
};
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$Views$PackageVersionSelector$subscriptionsFromDict = function (msg) {
	var sub = function (model) {
		return A2(
			$elm$core$Platform$Sub$map,
			msg(model),
			$author$project$Views$PackageVersionSelector$subscriptions(model));
	};
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Dict$values,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$map(sub),
			$elm$core$Platform$Sub$batch));
};
var $author$project$Views$AddPackagesModal$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($author$project$Views$PackageVersionSelector$subscriptionsFromDict, $author$project$Views$AddPackagesModal$PackageVersionSelectorMsg, model.hY)
			]));
};
var $author$project$Views$BranchPicker$DismissMenu = function (a) {
	return {$: 2, a: a};
};
var $author$project$Views$BranchPicker$dropdownToggleId = 'branch-dropdown-toggle';
var $author$project$Views$BranchPicker$subscriptions = function (maybeModel) {
	if (!maybeModel.$) {
		var model = maybeModel.a;
		return model.Du ? $elm$browser$Browser$Events$onMouseUp(
			A2(
				$author$project$Misc$onOutsideElement,
				$author$project$Views$BranchPicker$dropdownToggleId,
				$author$project$Views$BranchPicker$DismissMenu(model))) : $elm$core$Platform$Sub$none;
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Pages$ProjectConfig$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		A3(
			$author$project$Misc$concatIf,
			!_Utils_eq(model.kZ, $elm$core$Maybe$Nothing),
			$elm$browser$Browser$Events$onMouseUp(
				A2(
					$author$project$Misc$onOutsideElements,
					_List_fromArray(
						[$author$project$Pages$ProjectConfig$breakingChangesDialogId]),
					$author$project$Pages$ProjectConfig$ToggleBreakingChanges($elm$core$Maybe$Nothing))),
			A3(
				$author$project$Misc$concatIf,
				model.oP,
				$elm$browser$Browser$Events$onMouseUp(
					A2(
						$author$project$Misc$onOutsideElements,
						_List_fromArray(
							[$author$project$Pages$ProjectConfig$packagesDropdownButtonId, $author$project$Pages$ProjectConfig$packagesDropdownId]),
						$author$project$Pages$ProjectConfig$ToggleSetAllDropdown)),
				A3(
					$author$project$Misc$concatIf,
					model.yo,
					$elm$browser$Browser$Events$onMouseUp(
						A2($author$project$Misc$onOutsideElement, $author$project$Pages$ProjectConfig$focusTooltipId, $author$project$Pages$ProjectConfig$DismissAddPackageFocus)),
					_List_fromArray(
						[
							$author$project$Ports$copyStatus($author$project$Pages$ProjectConfig$CopyStatusMsg),
							A2(
							$elm$core$Platform$Sub$map,
							$author$project$Pages$ProjectConfig$BranchPickerViewMsg,
							$author$project$Views$BranchPicker$subscriptions(model.fJ)),
							A2(
							$elm$core$Platform$Sub$map,
							$author$project$Pages$ProjectConfig$AddPackagesModalMsg,
							$author$project$Views$AddPackagesModal$subscriptions(model.iM)),
							A2($author$project$Views$PackageVersionSelector$subscriptionsFromDict, $author$project$Pages$ProjectConfig$PackageVersionSelectorMsg, model.hb),
							$elm$browser$Browser$Events$onKeyDown(
							A2(
								$elm$json$Json$Decode$map,
								$elm$core$Basics$always($author$project$Pages$ProjectConfig$KeyDownEsc),
								$author$project$Misc$decoderEscapeKey))
						])))));
};
var $author$project$Pages$ProjectConfigAdvanced$BranchPickerViewMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$ProjectConfigAdvanced$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$ProjectConfigAdvanced$BranchPickerViewMsg,
		$author$project$Views$BranchPicker$subscriptions(model.fJ));
};
var $author$project$Pages$ProjectDownloads$BranchPickerViewMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$ProjectDownloads$CopyStatusMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$ProjectDownloads$ReceivedBuildLogStreamerEvent = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$ProjectDownloads$Tick = function (a) {
	return {$: 10, a: a};
};
var $author$project$Model$BuildLogStreamerEvent$BuildPrintLineEvent = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Model$BuildLogStreamerEvent$BuildProgressEvent_ = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Model$BuildLogStreamerEvent$HeartbeatEvent = {$: 2};
var $author$project$Model$BuildLogStreamerEvent$UnimplementedByClient = {$: 3};
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $author$project$Model$BuildPlanner$BuildLogId$AltLogId = 1;
var $author$project$Model$BuildPlanner$BuildLogId$BuildLogId = F3(
	function (type_, platformId, id) {
		return {l6: id, Fe: platformId, gR: type_};
	});
var $author$project$Model$BuildPlanner$BuildLogId$altLogId = A2($author$project$Model$BuildPlanner$BuildLogId$BuildLogId, 1, '');
var $author$project$Model$BuildLogStreamerEvent$buildRequestIdDecoder = A2($elm$json$Json$Decode$field, 'build_request_id', $elm$json$Json$Decode$string);
var $author$project$Model$BuildPlanner$BuildLogId$CamelLogId = 0;
var $author$project$Model$BuildPlanner$BuildLogId$camelLogId = $author$project$Model$BuildPlanner$BuildLogId$BuildLogId(0);
var $author$project$Model$BuildLogStreamerEvent$recipeIdDecoder = A2($elm$json$Json$Decode$field, 'recipe_id', $elm$json$Json$Decode$string);
var $author$project$Model$BuildLogStreamerEvent$buildLogIdDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (value) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					$author$project$Model$BuildPlanner$BuildLogId$camelLogId(''),
					$author$project$Model$BuildLogStreamerEvent$buildRequestIdDecoder),
					A2($elm$json$Json$Decode$map, $author$project$Model$BuildPlanner$BuildLogId$altLogId, $author$project$Model$BuildLogStreamerEvent$recipeIdDecoder),
					$elm$json$Json$Decode$fail(
					'BuildProgressEvent needs to provide either \'build_request_id\' (camel) or \'recipe_id\' (alt/headchef): ' + A2($elm$json$Json$Encode$encode, 0, value))
				]));
	},
	$elm$json$Json$Decode$value);
var $author$project$Model$BuildLogStreamerEvent$BuildProgressEventAlt_ = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$BuildLogStreamerEvent$BuildProgressEventCamel_ = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$BuildLogStreamerEvent$AltArtifactFailed = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$Model$BuildLogStreamerEvent$AltArtifactSkipped = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Model$BuildLogStreamerEvent$AltArtifactStarted = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Model$BuildLogStreamerEvent$AltArtifactSucceeded = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$map3 = _Json_map3;
var $author$project$Model$BuildLogStreamerEvent$timestampDecoder = A2($elm$json$Json$Decode$field, 'timestamp', $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder);
var $author$project$Model$BuildLogStreamerEvent$buildProgressEventAltDecoder = function (type_) {
	switch (type_) {
		case 'artifact_started':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$Model$BuildLogStreamerEvent$AltArtifactStarted,
				A2($elm$json$Json$Decode$field, 'artifact_id', $elm$json$Json$Decode$string),
				$author$project$Model$BuildLogStreamerEvent$timestampDecoder);
		case 'artifact_succeeded':
			return A4(
				$elm$json$Json$Decode$map3,
				F3(
					function (artifactID, downloadURL, endTime) {
						return $author$project$Model$BuildLogStreamerEvent$AltArtifactSucceeded(
							{xf: artifactID, x8: downloadURL, yc: endTime});
					}),
				A2($elm$json$Json$Decode$field, 'artifact_id', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'artifact_download_uri', $elm$json$Json$Decode$string),
				$author$project$Model$BuildLogStreamerEvent$timestampDecoder);
		case 'artifact_skipped':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$Model$BuildLogStreamerEvent$AltArtifactSkipped,
				A2($elm$json$Json$Decode$field, 'artifact_id', $elm$json$Json$Decode$string),
				$author$project$Model$BuildLogStreamerEvent$timestampDecoder);
		case 'artifact_failed':
			return A4(
				$elm$json$Json$Decode$map3,
				$author$project$Model$BuildLogStreamerEvent$AltArtifactFailed,
				A2($elm$json$Json$Decode$field, 'artifact_id', $elm$json$Json$Decode$string),
				A2(
					$elm$json$Json$Decode$map,
					function (error) {
						return $elm$core$String$isEmpty(error) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(error);
					},
					A2($elm$json$Json$Decode$field, 'error_message', $elm$json$Json$Decode$string)),
				$author$project$Model$BuildLogStreamerEvent$timestampDecoder);
		default:
			return $elm$json$Json$Decode$fail('Unknown response from the build-log-streamer');
	}
};
var $author$project$Model$BuildLogStreamerEvent$CamelBuildComplete = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$BuildLogStreamerEvent$CamelBuildErrored = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Model$BuildLogStreamerEvent$CamelBuildStarted = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$BuildLogStreamerEvent$CamelPackageCompleted = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Model$BuildLogStreamerEvent$CamelPackageFailed = function (a) {
	return {$: 5, a: a};
};
var $author$project$Model$BuildLogStreamerEvent$CamelPackageStarted = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Model$BuildLogStreamerEvent$buildProgressEventCamelDecoder = function (type_) {
	switch (type_) {
		case 'build_started':
			return A2($elm$json$Json$Decode$map, $author$project$Model$BuildLogStreamerEvent$CamelBuildStarted, $author$project$Model$BuildLogStreamerEvent$timestampDecoder);
		case 'build_failed':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$Model$BuildLogStreamerEvent$CamelBuildErrored,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['body', 'message']),
					$elm$json$Json$Decode$string),
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['body', 'errors']),
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
								$elm$json$Json$Decode$null(_List_Nil)
							]))));
		case 'build_completed':
			return A2($elm$json$Json$Decode$map, $author$project$Model$BuildLogStreamerEvent$CamelBuildComplete, $author$project$Model$BuildLogStreamerEvent$timestampDecoder);
		case 'pkg_build_started':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$Model$BuildLogStreamerEvent$CamelPackageStarted,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['body', 'ingredient_id']),
					$elm$json$Json$Decode$string),
				$author$project$Model$BuildLogStreamerEvent$timestampDecoder);
		case 'pkg_build_completed':
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$Model$BuildLogStreamerEvent$CamelPackageCompleted,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['body', 'ingredient_id']),
					$elm$json$Json$Decode$string),
				$author$project$Model$BuildLogStreamerEvent$timestampDecoder);
		case 'pkg_build_failed':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Model$BuildLogStreamerEvent$CamelPackageFailed,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['body', 'ingredient_id']),
					$elm$json$Json$Decode$string));
		default:
			return A3(
				$elm$json$Json$Decode$map2,
				$author$project$Model$BuildLogStreamerEvent$CamelBuildErrored,
				$elm$json$Json$Decode$succeed('Unknown response from the builder API'),
				$elm$json$Json$Decode$succeed(
					_List_fromArray(
						['Unknown response from the builder API'])));
	}
};
var $author$project$Model$BuildLogStreamerEvent$buildProgressEventDecoder = F2(
	function (type_, buildLogType) {
		if (!buildLogType) {
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Model$BuildLogStreamerEvent$BuildProgressEventCamel_,
				$author$project$Model$BuildLogStreamerEvent$buildProgressEventCamelDecoder(type_));
		} else {
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Model$BuildLogStreamerEvent$BuildProgressEventAlt_,
				$author$project$Model$BuildLogStreamerEvent$buildProgressEventAltDecoder(type_));
		}
	});
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $author$project$Model$BuildLogStreamerEvent$typeDecoder = A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string);
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $author$project$Model$BuildLogStreamerEvent$unimplementedEventTypes = $elm$core$Set$fromList(
	_List_fromArray(
		['log_general', 'pkg_build_skipped', 'task_completed', 'task_failed', 'task_scheduled', 'task_skipped', 'task_started']));
var $author$project$Model$BuildLogStreamerEvent$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (type_) {
		switch (type_) {
			case 'artifact_progress':
				return A3(
					$elm$json$Json$Decode$map2,
					$author$project$Model$BuildLogStreamerEvent$BuildPrintLineEvent,
					A2($elm$json$Json$Decode$field, 'artifact_id', $elm$json$Json$Decode$string),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['body', 'msg']),
						$elm$json$Json$Decode$string));
			case 'heartbeat':
				return $elm$json$Json$Decode$succeed($author$project$Model$BuildLogStreamerEvent$HeartbeatEvent);
			default:
				return A2($elm$core$Set$member, type_, $author$project$Model$BuildLogStreamerEvent$unimplementedEventTypes) ? $elm$json$Json$Decode$succeed($author$project$Model$BuildLogStreamerEvent$UnimplementedByClient) : A2(
					$elm$json$Json$Decode$andThen,
					function (buildLogId) {
						var _v1 = _Utils_Tuple2(buildLogId.gR, type_);
						_v1$3:
						while (true) {
							if (_v1.a === 1) {
								switch (_v1.b) {
									case 'build_started':
										var _v2 = _v1.a;
										return $elm$json$Json$Decode$succeed($author$project$Model$BuildLogStreamerEvent$UnimplementedByClient);
									case 'build_succeeded':
										var _v3 = _v1.a;
										return $elm$json$Json$Decode$succeed($author$project$Model$BuildLogStreamerEvent$UnimplementedByClient);
									case 'build_failed':
										var _v4 = _v1.a;
										return $elm$json$Json$Decode$succeed($author$project$Model$BuildLogStreamerEvent$UnimplementedByClient);
									default:
										break _v1$3;
								}
							} else {
								break _v1$3;
							}
						}
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$Model$BuildLogStreamerEvent$BuildProgressEvent_(buildLogId),
							A2($author$project$Model$BuildLogStreamerEvent$buildProgressEventDecoder, type_, buildLogId.gR));
					},
					$author$project$Model$BuildLogStreamerEvent$buildLogIdDecoder);
		}
	},
	$author$project$Model$BuildLogStreamerEvent$typeDecoder);
var $author$project$Ports$receiveBuildLogStreamerEvent = _Platform_incomingPort('receiveBuildLogStreamerEvent', $elm$json$Json$Decode$string);
var $author$project$Model$BuildLogStreamerEvent$subscriptions = $author$project$Ports$receiveBuildLogStreamerEvent(
	function (str) {
		return A2(
			$elm$core$Result$mapError,
			function (err) {
				return A2(
					$elm$core$String$join,
					'\n',
					_List_fromArray(
						[
							'MESSAGE: ' + str,
							'------------------------------',
							'ERROR: ' + $elm$json$Json$Decode$errorToString(err)
						]));
			},
			A2($elm$json$Json$Decode$decodeString, $author$project$Model$BuildLogStreamerEvent$decoder, str));
	});
var $author$project$Pages$ProjectDownloads$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$core$Platform$Sub$map, $author$project$Pages$ProjectDownloads$ReceivedBuildLogStreamerEvent, $author$project$Model$BuildLogStreamerEvent$subscriptions),
				A2($elm$time$Time$every, 1000, $author$project$Pages$ProjectDownloads$Tick),
				$author$project$Ports$copyStatus($author$project$Pages$ProjectDownloads$CopyStatusMsg),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$ProjectDownloads$BranchPickerViewMsg,
				$author$project$Views$BranchPicker$subscriptions(model.fJ))
			]));
};
var $author$project$Pages$ProjectHistory$BranchPickerViewMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$ProjectHistory$CopyStatusMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$ProjectHistory$KeyDownEsc = {$: 6};
var $author$project$Pages$ProjectHistory$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$elm$browser$Browser$Events$onKeyDown(
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Basics$always($author$project$Pages$ProjectHistory$KeyDownEsc),
					$author$project$Misc$decoderEscapeKey)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$ProjectHistory$BranchPickerViewMsg,
				$author$project$Views$BranchPicker$subscriptions(model.fJ)),
				$author$project$Ports$copyStatus($author$project$Pages$ProjectHistory$CopyStatusMsg)
			]));
};
var $author$project$Pages$ProjectImpactReport$CopyStatusMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$ProjectImpactReport$subscriptions = $elm$core$Platform$Sub$batch(
	_List_fromArray(
		[
			$author$project$Ports$copyStatus($author$project$Pages$ProjectImpactReport$CopyStatusMsg)
		]));
var $author$project$Pages$ProjectOverview$CloseShareModal = {$: 15};
var $author$project$Pages$ProjectOverview$CopyStatusMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$ProjectOverview$DismissCLIInstructionsModal = {$: 10};
var $author$project$Pages$ProjectOverview$DismissPerlModal = {$: 17};
var $author$project$Pages$ProjectOverview$KeyDownEsc = {$: 4};
var $elm_community$maybe_extra$Maybe$Extra$isJust = function (m) {
	if (m.$ === 1) {
		return false;
	} else {
		return true;
	}
};
var $author$project$Views$PerlNagModal$modalId = 'perl-nag-modal';
var $author$project$Views$ShareProjectModal$modalId = 'share-modal';
var $elm$browser$Browser$Events$onMouseDown = A2($elm$browser$Browser$Events$on, 0, 'mousedown');
var $author$project$Views$StateTool$viewInstallInstructionsModalID = 'modal-download-and-install-runtime';
var $author$project$Pages$ProjectOverview$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$copyStatus($author$project$Pages$ProjectOverview$CopyStatusMsg),
				$elm$browser$Browser$Events$onKeyDown(
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Basics$always($author$project$Pages$ProjectOverview$KeyDownEsc),
					$author$project$Misc$decoderEscapeKey)),
				$elm_community$maybe_extra$Maybe$Extra$isJust(model.fM) ? $elm$browser$Browser$Events$onMouseDown(
				A2($author$project$Misc$onOutsideElement, $author$project$Views$StateTool$viewInstallInstructionsModalID, $author$project$Pages$ProjectOverview$DismissCLIInstructionsModal)) : $elm$core$Platform$Sub$none,
				model.DD ? $elm$browser$Browser$Events$onMouseDown(
				A2($author$project$Misc$onOutsideElement, $author$project$Views$ShareProjectModal$modalId, $author$project$Pages$ProjectOverview$CloseShareModal)) : $elm$core$Platform$Sub$none,
				model.oQ ? $elm$browser$Browser$Events$onMouseDown(
				A2($author$project$Misc$onOutsideElement, $author$project$Views$PerlNagModal$modalId, $author$project$Pages$ProjectOverview$DismissPerlModal)) : $elm$core$Platform$Sub$none
			]));
};
var $author$project$Pages$ProjectSettingsBranches$KeyDownEsc = {$: 9};
var $author$project$Pages$ProjectSettingsBranches$subscriptions = $elm$browser$Browser$Events$onKeyDown(
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Basics$always($author$project$Pages$ProjectSettingsBranches$KeyDownEsc),
		$author$project$Misc$decoderEscapeKey));
var $author$project$Pages$ProjectSettingsHAR$CopyStatusMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$ProjectSettingsHAR$Tick = {$: 15};
var $author$project$Pages$ProjectSettingsHAR$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$copyStatus($author$project$Pages$ProjectSettingsHAR$CopyStatusMsg),
				A2(
				$elm$time$Time$every,
				5000,
				$elm$core$Basics$always($author$project$Pages$ProjectSettingsHAR$Tick))
			]));
};
var $author$project$Pages$StateToolCheatSheet$CopyStatusMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$StateToolCheatSheet$subscriptions = $elm$core$Platform$Sub$batch(
	_List_fromArray(
		[
			$author$project$Ports$copyStatus($author$project$Pages$StateToolCheatSheet$CopyStatusMsg)
		]));
var $author$project$Main$pageSubscriptions = function (page) {
	switch (page.$) {
		case 0:
			return $elm$core$Platform$Sub$none;
		case 1:
			var model = page.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Msg$NotFoundMsg,
				$author$project$Pages$NotFound$subscriptions(model));
		case 2:
			var model = page.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Msg$LoginMsg,
				$author$project$Pages$Login$subscriptions(model));
		case 8:
			return $elm$core$Platform$Sub$none;
		case 9:
			var model = page.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Msg$ConnectAccountMsg,
				$author$project$Pages$ConnectAccount$subscriptions(model));
		case 10:
			return $elm$core$Platform$Sub$none;
		case 7:
			return $elm$core$Platform$Sub$none;
		case 5:
			return $elm$core$Platform$Sub$none;
		case 6:
			return $elm$core$Platform$Sub$none;
		case 3:
			var model = page.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Msg$CreateAccountMsg,
				$author$project$Pages$CreateAccount$subscriptions(model));
		case 4:
			return $elm$core$Platform$Sub$none;
		case 11:
			var model = page.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Msg$PreferenceTwoFactorMsg,
				$author$project$Pages$PreferenceTwoFactor$subscriptions(model));
		case 12:
			return $elm$core$Platform$Sub$none;
		case 13:
			return $elm$core$Platform$Sub$none;
		case 14:
			var model = page.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Msg$PreferenceLinkedAccountsMsg,
				$author$project$Pages$PreferenceLinkedAccounts$subscriptions(model));
		case 15:
			return $elm$core$Platform$Sub$none;
		case 16:
			var model = page.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Msg$OrgIndexMsg,
				$author$project$Pages$OrgIndex$subscriptions(model));
		case 17:
			return $elm$core$Platform$Sub$none;
		case 19:
			return $elm$core$Platform$Sub$none;
		case 23:
			return $elm$core$Platform$Sub$none;
		case 24:
			var model = page.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Msg$OrgRemediationMsg,
				$author$project$Pages$OrgRemediation$subscriptions(model));
		case 20:
			return $elm$core$Platform$Sub$none;
		case 21:
			return A2($elm$core$Platform$Sub$map, $author$project$Msg$OrgScanMsg, $author$project$Pages$OrgScan$subscriptions);
		case 22:
			var model = page.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Msg$OrgDependenciesMsg,
				$author$project$Pages$OrgDependencies$subscriptions(model));
		case 18:
			var model = page.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Msg$OrgSecurityMsg,
				$author$project$Pages$OrgSecurity$subscriptions(model));
		case 25:
			var model = page.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Msg$ProjectConfigMsg,
				$author$project$Pages$ProjectConfig$subscriptions(model));
		case 26:
			var model = page.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Msg$ProjectConfigAdvancedMsg,
				$author$project$Pages$ProjectConfigAdvanced$subscriptions(model));
		case 27:
			var model = page.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Msg$ProjectOverviewMsg,
				$author$project$Pages$ProjectOverview$subscriptions(model));
		case 28:
			var model = page.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Msg$ProjectDownloadsMsg,
				$author$project$Pages$ProjectDownloads$subscriptions(model));
		case 29:
			var model = page.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Msg$ProjectHistoryMsg,
				$author$project$Pages$ProjectHistory$subscriptions(model));
		case 30:
			return A2($elm$core$Platform$Sub$map, $author$project$Msg$ProjectImpactReportMsg, $author$project$Pages$ProjectImpactReport$subscriptions);
		case 31:
			return $elm$core$Platform$Sub$none;
		case 32:
			var model = page.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Msg$ProjectSettingsHARMsg,
				$author$project$Pages$ProjectSettingsHAR$subscriptions(model));
		case 33:
			return A2($elm$core$Platform$Sub$map, $author$project$Msg$ProjectSettingsBranchesMsg, $author$project$Pages$ProjectSettingsBranches$subscriptions);
		case 34:
			return $elm$core$Platform$Sub$none;
		case 35:
			return $elm$core$Platform$Sub$none;
		case 36:
			var model = page.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Msg$AdminOrganizationsMsg,
				$author$project$Pages$AdminOrganizations$subscriptions(model));
		case 37:
			var model = page.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Msg$AdminOrganizationMsg,
				$author$project$Pages$AdminOrganization$subscriptions(model));
		case 38:
			var model = page.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Msg$AdminUsersMsg,
				$author$project$Pages$AdminUsers$subscriptions(model));
		case 39:
			var model = page.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Msg$AdminUserMsg,
				$author$project$Pages$AdminUser$subscriptions(model));
		case 41:
			return $elm$core$Platform$Sub$none;
		case 40:
			return $elm$core$Platform$Sub$none;
		case 42:
			return $elm$core$Platform$Sub$none;
		case 43:
			return $elm$core$Platform$Sub$none;
		case 44:
			return A2($elm$core$Platform$Sub$map, $author$project$Msg$StateToolCheatSheetMsg, $author$project$Pages$StateToolCheatSheet$subscriptions);
		case 45:
			var model = page.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Msg$CreateProjectMsg,
				$author$project$Pages$CreateProject$subscriptions(model));
		case 46:
			return $elm$core$Platform$Sub$none;
		case 47:
			return $elm$core$Platform$Sub$none;
		case 48:
			return $elm$core$Platform$Sub$none;
		case 49:
			return $elm$core$Platform$Sub$none;
		case 50:
			return $elm$core$Platform$Sub$none;
		case 51:
			return $elm$core$Platform$Sub$none;
		case 52:
			return $elm$core$Platform$Sub$none;
		case 53:
			return A2($elm$core$Platform$Sub$map, $author$project$Msg$AuthorizeDeviceMsg, $author$project$Pages$AuthorizeDevice$subscriptions);
		case 54:
			return $elm$core$Platform$Sub$none;
		default:
			return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Model$Session$GotExperimentValue = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$Session$GotGoogleAnalyticsData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$Session$GotHubSpotChatLoaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$Analytics$GoogleAnalyticsData = $elm$core$Basics$identity;
var $author$project$Model$Analytics$createGoogleAnalytics = function (gad) {
	return gad;
};
var $author$project$Ports$googleAnalyticsReady = _Platform_incomingPort(
	'googleAnalyticsReady',
	A2(
		$elm$json$Json$Decode$andThen,
		function (clientId) {
			return $elm$json$Json$Decode$succeed(
				{BH: clientId});
		},
		A2($elm$json$Json$Decode$field, 'clientId', $elm$json$Json$Decode$string)));
var $author$project$Ports$hubSpotChatLoaded = _Platform_incomingPort('hubSpotChatLoaded', $elm$json$Json$Decode$bool);
var $author$project$Ports$receiveExperimentValue = _Platform_incomingPort(
	'receiveExperimentValue',
	A2(
		$elm$json$Json$Decode$andThen,
		function (variation) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (id) {
					return $elm$json$Json$Decode$succeed(
						{l6: id, AK: variation});
				},
				A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'variation', $elm$json$Json$Decode$int)));
var $author$project$Model$LocalStorage$ReceiveLocalStorage = $elm$core$Basics$identity;
var $author$project$Ports$receiveLocalStorage = _Platform_incomingPort(
	'receiveLocalStorage',
	A2(
		$elm$json$Json$Decode$andThen,
		function (value) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (key) {
					return $elm$json$Json$Decode$succeed(
						{Y: key, kH: value});
				},
				A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'value', $elm$json$Json$Decode$string)));
var $author$project$Model$LocalStorage$subscriptions = function (_v0) {
	return $author$project$Ports$receiveLocalStorage($elm$core$Basics$identity);
};
var $author$project$Model$Session$subscriptions = function (_v0) {
	var session = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$hubSpotChatLoaded($author$project$Model$Session$GotHubSpotChatLoaded),
				$author$project$Ports$googleAnalyticsReady(
				A2($elm$core$Basics$composeR, $author$project$Model$Analytics$createGoogleAnalytics, $author$project$Model$Session$GotGoogleAnalyticsData)),
				$author$project$Ports$receiveExperimentValue($author$project$Model$Session$GotExperimentValue),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Model$Session$LocalStorageMsg,
				$author$project$Model$LocalStorage$subscriptions(session.fu))
			]));
};
var $author$project$Main$subscriptions = function (model) {
	var orgDropdownSub = $author$project$Model$Session$getOrgDropdownOpen(model.l) ? $elm$browser$Browser$Events$onMouseUp(
		A2(
			$author$project$Misc$onOutsideElements,
			_List_fromArray(
				['org-dropdown', 'org-list']),
			$author$project$Msg$ToggleOrgDropDown)) : $elm$core$Platform$Sub$none;
	var mouseSub = $author$project$Model$Session$getDropdownOpen(model.l) ? $elm$browser$Browser$Events$onMouseUp(
		A2($author$project$Misc$onOutsideElement, $author$project$Views$SiteWrapper$dropdownToggleId, $author$project$Msg$ToggleDropDown)) : $elm$core$Platform$Sub$none;
	var minute = 60 * 1000;
	var defaultSubs = _List_fromArray(
		[
			A2(
			$elm$core$Platform$Sub$map,
			$author$project$Msg$SessionMsg,
			$author$project$Model$Session$subscriptions(model.l)),
			$author$project$Main$pageSubscriptions(
			$author$project$PageState$getPage(model.u)),
			A2($elm$time$Time$every, minute, $author$project$Msg$OnCurrentTimeUpdate),
			A2(
			$elm$time$Time$every,
			minute * 10,
			$elm$core$Basics$always($author$project$Msg$DoRenew)),
			$author$project$Ports$copyStatus($author$project$Msg$AuthHeaderCopiedToClipboard)
		]);
	return $elm$core$Platform$Sub$batch(
		A2(
			$elm$core$List$cons,
			orgDropdownSub,
			A2($elm$core$List$cons, mouseSub, defaultSubs)));
};
var $author$project$Page$ActivateMembership = function (a) {
	return {$: 6, a: a};
};
var $author$project$Msg$ActivateMembershipMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Page$AdminCreateOrganization = function (a) {
	return {$: 41, a: a};
};
var $author$project$Msg$AdminCreateOrganizationMsg = function (a) {
	return {$: 77, a: a};
};
var $author$project$Page$AdminFeatures = function (a) {
	return {$: 40, a: a};
};
var $author$project$Msg$AdminFeaturesMsg = function (a) {
	return {$: 65, a: a};
};
var $author$project$Page$AdminFork = function (a) {
	return {$: 49, a: a};
};
var $author$project$Msg$AdminForkMsg = function (a) {
	return {$: 96, a: a};
};
var $author$project$Page$AdminIconomicon = function (a) {
	return {$: 35, a: a};
};
var $author$project$Msg$AdminIconomiconMsg = function (a) {
	return {$: 67, a: a};
};
var $author$project$Page$AdminOrganization = function (a) {
	return {$: 37, a: a};
};
var $author$project$Page$AdminOrganizations = function (a) {
	return {$: 36, a: a};
};
var $author$project$Page$AdminUser = function (a) {
	return {$: 39, a: a};
};
var $author$project$Page$AdminUsers = function (a) {
	return {$: 38, a: a};
};
var $author$project$Page$AuthorizeDevice = function (a) {
	return {$: 53, a: a};
};
var $author$project$Page$AutoFork = function (a) {
	return {$: 48, a: a};
};
var $author$project$Msg$AutoForkMsg = function (a) {
	return {$: 94, a: a};
};
var $author$project$Page$CheckEmail = function (a) {
	return {$: 7, a: a};
};
var $author$project$Msg$CheckEmailMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Page$Checkout = function (a) {
	return {$: 50, a: a};
};
var $author$project$Msg$CheckoutMsg = function (a) {
	return {$: 97, a: a};
};
var $author$project$Page$ConnectAccount = function (a) {
	return {$: 9, a: a};
};
var $author$project$Page$CreateAccount = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$CreateOrganization = function (a) {
	return {$: 4, a: a};
};
var $author$project$Msg$CreateOrganizationMsg = function (a) {
	return {$: 79, a: a};
};
var $author$project$Page$CreateProject = function (a) {
	return {$: 45, a: a};
};
var $author$project$Page$CreateProjectFromCommit = {$: 52};
var $author$project$Page$FinishSetup = function (a) {
	return {$: 55, a: a};
};
var $author$project$Msg$FinishSetupMsg = function (a) {
	return {$: 109, a: a};
};
var $author$project$Page$ForgotPassword = function (a) {
	return {$: 8, a: a};
};
var $author$project$Msg$ForgotPasswordMsg = function (a) {
	return {$: 56, a: a};
};
var $author$project$Page$ForkProject = function (a) {
	return {$: 47, a: a};
};
var $author$project$Msg$ForkProjectMsg = function (a) {
	return {$: 92, a: a};
};
var $author$project$Page$ImportProject = function (a) {
	return {$: 46, a: a};
};
var $author$project$Msg$ImportProjectMsg = function (a) {
	return {$: 84, a: a};
};
var $author$project$Msg$LoadUrl = function (a) {
	return {$: 100, a: a};
};
var $author$project$Page$Login = function (a) {
	return {$: 2, a: a};
};
var $author$project$Msg$NoOp = {$: 0};
var $author$project$Page$NotFound = function (a) {
	return {$: 1, a: a};
};
var $author$project$Msg$OnInvitationEvent = function (a) {
	return {$: 106, a: a};
};
var $author$project$Page$OrgDependencies = function (a) {
	return {$: 22, a: a};
};
var $author$project$Page$OrgIndex = function (a) {
	return {$: 16, a: a};
};
var $author$project$Page$OrgMembers = function (a) {
	return {$: 19, a: a};
};
var $author$project$Msg$OrgMembersMsg = function (a) {
	return {$: 20, a: a};
};
var $author$project$Page$OrgPolicy = function (a) {
	return {$: 23, a: a};
};
var $author$project$Msg$OrgPolicyMsg = function (a) {
	return {$: 22, a: a};
};
var $author$project$Page$OrgRemediation = function (a) {
	return {$: 24, a: a};
};
var $author$project$Page$OrgScan = function (a) {
	return {$: 21, a: a};
};
var $author$project$Page$OrgSecurity = function (a) {
	return {$: 18, a: a};
};
var $author$project$Page$OrgSettings = function (a) {
	return {$: 20, a: a};
};
var $author$project$Msg$OrgSettingsMsg = function (a) {
	return {$: 24, a: a};
};
var $author$project$Page$Orgs = function (a) {
	return {$: 17, a: a};
};
var $author$project$Msg$OrgsMsg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Page$OutOfCompliance = function (a) {
	return {$: 54, a: a};
};
var $author$project$Page$PreferenceDeleteAccount = function (a) {
	return {$: 15, a: a};
};
var $author$project$Msg$PreferenceDeleteAccountMsg = function (a) {
	return {$: 35, a: a};
};
var $author$project$Page$PreferenceEmail = function (a) {
	return {$: 12, a: a};
};
var $author$project$Msg$PreferenceEmailMsg = function (a) {
	return {$: 32, a: a};
};
var $author$project$Page$PreferenceLinkedAccounts = function (a) {
	return {$: 14, a: a};
};
var $author$project$Page$PreferencePassword = function (a) {
	return {$: 13, a: a};
};
var $author$project$Msg$PreferencePasswordMsg = function (a) {
	return {$: 33, a: a};
};
var $author$project$Page$PreferenceTwoFactor = function (a) {
	return {$: 11, a: a};
};
var $author$project$Page$ProjectConfig = function (a) {
	return {$: 25, a: a};
};
var $author$project$Page$ProjectConfigAdvanced = function (a) {
	return {$: 26, a: a};
};
var $author$project$Page$ProjectDownloads = function (a) {
	return {$: 28, a: a};
};
var $author$project$Page$ProjectHistory = function (a) {
	return {$: 29, a: a};
};
var $author$project$Page$ProjectImpactReport = function (a) {
	return {$: 30, a: a};
};
var $author$project$Page$ProjectOverview = function (a) {
	return {$: 27, a: a};
};
var $author$project$Page$ProjectSettings = function (a) {
	return {$: 31, a: a};
};
var $author$project$Page$ProjectSettingsBranches = function (a) {
	return {$: 33, a: a};
};
var $author$project$Page$ProjectSettingsHAR = function (a) {
	return {$: 32, a: a};
};
var $author$project$Msg$ProjectSettingsMsg = function (a) {
	return {$: 48, a: a};
};
var $author$project$Page$PublicProjects = function (a) {
	return {$: 42, a: a};
};
var $author$project$Page$ResetPassword = function (a) {
	return {$: 10, a: a};
};
var $author$project$Msg$ResetPasswordMsg = function (a) {
	return {$: 59, a: a};
};
var $author$project$Page$StateToolCheatSheet = function (a) {
	return {$: 44, a: a};
};
var $author$project$Page$SupplementalLicenseTerms = function (a) {
	return {$: 34, a: a};
};
var $author$project$Msg$SupplementalLicenseTermsMsg = function (a) {
	return {$: 54, a: a};
};
var $author$project$Page$Support = function (a) {
	return {$: 43, a: a};
};
var $author$project$Msg$SupportMsg = function (a) {
	return {$: 86, a: a};
};
var $author$project$Model$Session$getUser = function (_v0) {
	var session = _v0;
	return session.gS;
};
var $author$project$Model$Session$setUser = F2(
	function (user, _v0) {
		var session = _v0;
		return _Utils_update(
			session,
			{gS: user});
	});
var $author$project$Model$Session$addMembership = F2(
	function (membership, session) {
		var userFn = function (user) {
			var organizations = $elm$core$Dict$values(
				A3(
					$elm$core$Dict$insert,
					membership.AC,
					membership,
					$elm$core$Dict$fromList(
						A2(
							$elm$core$List$map,
							function (org) {
								return _Utils_Tuple2(org.AC, org);
							},
							user.mX))));
			return _Utils_update(
				user,
				{mX: organizations});
		};
		return A2(
			$author$project$Model$Session$setUser,
			A2(
				$elm$core$Maybe$map,
				userFn,
				$author$project$Model$Session$getUser(session)),
			session);
	});
var $author$project$Model$Session$NotificationsMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Views$NotificationsGlobal$OnAddNotification = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Views$NotificationsGlobal$add = F2(
	function (notification, _v0) {
		var internal = _v0;
		return A2(
			$author$project$Misc$with,
			A2(
				$elm$core$Task$perform,
				A2($author$project$Views$NotificationsGlobal$OnAddNotification, internal.oK, notification),
				$elm$time$Time$now),
			_Utils_update(
				internal,
				{oK: internal.oK + 1}));
	});
var $author$project$Model$Session$addNotification = F2(
	function (notification, _v0) {
		var session = _v0;
		var _v1 = A2($author$project$Views$NotificationsGlobal$add, notification, session.mN);
		var newNotifications = _v1.a;
		var notificationsCmd = _v1.b;
		return A2(
			$author$project$Misc$with,
			A2($elm$core$Platform$Cmd$map, $author$project$Model$Session$NotificationsMsg, notificationsCmd),
			_Utils_update(
				session,
				{mN: newNotifications}));
	});
var $author$project$Main$authTokenCopyID = 'auth-header-copyID';
var $author$project$Model$Compliance$block = function (c) {
	if (c.$ === 1) {
		return false;
	} else {
		return true;
	}
};
var $author$project$Model$User$isMember = F2(
	function (user, orgUrlName) {
		return A2(
			$elm$core$List$any,
			function (membership) {
				return _Utils_eq(
					$elm$core$String$toLower(membership.AC),
					$elm$core$String$toLower(orgUrlName));
			},
			user.mX);
	});
var $author$project$Model$Session$isMember = function (orgUrlName) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Model$Session$getUser,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map(
				function (user) {
					return A2($author$project$Model$User$isMember, user, orgUrlName);
				}),
			$elm$core$Maybe$withDefault(false)));
};
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $elm$browser$Browser$Navigation$replaceUrl = _Browser_replaceUrl;
var $author$project$Model$Route$URLPieces = F3(
	function (paths, queryParams, fragment) {
		return {oD: fragment, rT: paths, r2: queryParams};
	});
var $author$project$Model$Route$path = function (paths) {
	return A3($author$project$Model$Route$URLPieces, paths, _List_Nil, $elm$core$Maybe$Nothing);
};
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $author$project$Model$Route$stringQueryParam = F2(
	function (name, value) {
		return A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string(name),
			value);
	});
var $author$project$Model$Route$urlPieces = F2(
	function (paths, queryParams) {
		return A3($author$project$Model$Route$URLPieces, paths, queryParams, $elm$core$Maybe$Nothing);
	});
var $author$project$Model$Route$adminRouteToString = function (page) {
	switch (page.$) {
		case 7:
			return $author$project$Model$Route$path(
				_List_fromArray(
					['iconomicon']));
		case 0:
			return $author$project$Model$Route$path(
				_List_fromArray(
					['organizations']));
		case 1:
			var orgName = page.a;
			return $author$project$Model$Route$path(
				_List_fromArray(
					['organizations', orgName]));
		case 2:
			var maybeOrgName = page.a;
			return A2(
				$author$project$Model$Route$urlPieces,
				_List_fromArray(
					['users']),
				_List_fromArray(
					[
						A2($author$project$Model$Route$stringQueryParam, 'orgName', maybeOrgName)
					]));
		case 3:
			var username = page.a;
			return $author$project$Model$Route$path(
				_List_fromArray(
					['users', username]));
		case 4:
			return $author$project$Model$Route$path(
				_List_fromArray(
					['create-organization']));
		case 5:
			var orgName = page.a;
			var projectName = page.b;
			return $author$project$Model$Route$path(
				_List_fromArray(
					['organizations', orgName, projectName, 'fork']));
		default:
			return $author$project$Model$Route$path(
				_List_fromArray(
					['features']));
	}
};
var $author$project$Model$Route$authContentQueryParam = F2(
	function (name, value) {
		var val = function () {
			switch (value) {
				case 0:
					return $elm$core$Maybe$Just('python-display');
				case 1:
					return $elm$core$Maybe$Just('build-python');
				default:
					return $elm$core$Maybe$Nothing;
			}
		}();
		return A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string(name),
			val);
	});
var $author$project$Model$Route$autoProjectQueryParams = function (params) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (_v0) {
				var language = _v0.aC;
				var version = _v0.aI;
				return _List_fromArray(
					[
						A2(
						$author$project$Model$Route$stringQueryParam,
						'project_language',
						$elm$core$Maybe$Just(language)),
						A2(
						$author$project$Model$Route$stringQueryParam,
						'project_version',
						$elm$core$Maybe$Just(version))
					]);
			},
			params));
};
var $author$project$Model$Route$boolQueryParam = F2(
	function (name, val) {
		return val ? $elm$core$Maybe$Just(
			A2($elm$url$Url$Builder$string, name, 'true')) : $elm$core$Maybe$Nothing;
	});
var $author$project$Model$Route$createProjectQueryParams = function (_v0) {
	var languageName = _v0.DQ;
	var maybeOSName = _v0.rv;
	var isNewUser = _v0.jc;
	var languageVersion = _v0.DS;
	var autoCreate = _v0.A9;
	var maybeNextAction = _v0.ru;
	return _List_fromArray(
		[
			A2($author$project$Model$Route$stringQueryParam, 'language', languageName),
			A2($author$project$Model$Route$stringQueryParam, 'version', languageVersion),
			A2($author$project$Model$Route$stringQueryParam, 'os', maybeOSName),
			A2($author$project$Model$Route$stringQueryParam, 'nextAction', maybeNextAction),
			A2($author$project$Model$Route$boolQueryParam, 'newUser', isNewUser),
			A2($author$project$Model$Route$boolQueryParam, 'autoCreate', autoCreate)
		]);
};
var $author$project$Model$Route$gaQueryParams = function (gaParams) {
	if (!gaParams.$) {
		var utm_source = gaParams.a.AI;
		var utm_medium = gaParams.a.AH;
		var utm_campaign = gaParams.a.AF;
		var utm_content = gaParams.a.AG;
		return _List_fromArray(
			[
				A2(
				$author$project$Model$Route$stringQueryParam,
				'utm_source',
				$elm$core$Maybe$Just(utm_source)),
				A2(
				$author$project$Model$Route$stringQueryParam,
				'utm_medium',
				$elm$core$Maybe$Just(utm_medium)),
				A2(
				$author$project$Model$Route$stringQueryParam,
				'utm_campaign',
				$elm$core$Maybe$Just(utm_campaign)),
				A2(
				$author$project$Model$Route$stringQueryParam,
				'utm_content',
				$elm$core$Maybe$Just(utm_content))
			]);
	} else {
		return _List_Nil;
	}
};
var $elm_community$maybe_extra$Maybe$Extra$or = F2(
	function (ma, mb) {
		if (ma.$ === 1) {
			return mb;
		} else {
			return ma;
		}
	});
var $author$project$Model$Route$mergePieces = F2(
	function (fst, snd) {
		return A3(
			$author$project$Model$Route$URLPieces,
			_Utils_ap(fst.rT, snd.rT),
			_Utils_ap(fst.r2, snd.r2),
			A2($elm_community$maybe_extra$Maybe$Extra$or, fst.oD, snd.oD));
	});
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Model$Route$reasonForRedirectToString = function (reason) {
	if (!reason) {
		return 'change_name';
	} else {
		return 'select_an_org';
	}
};
var $author$project$Model$Route$uuidParam = function (name) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map($danyx23$elm_uuid$Uuid$toString),
		$author$project$Model$Route$stringQueryParam(name));
};
var $author$project$Model$Route$projectRouteToString = function (page) {
	var commitIDParam = $author$project$Model$Route$uuidParam('commitID');
	switch (page.$) {
		case 0:
			var args = page.a;
			return A2(
				$author$project$Model$Route$urlPieces,
				_List_fromArray(
					['customize']),
				_List_fromArray(
					[
						commitIDParam(args.gr),
						A2($author$project$Model$Route$boolQueryParam, 'new_project', args.uk),
						A2($author$project$Model$Route$stringQueryParam, 'branch', args.fO),
						A2($author$project$Model$Route$boolQueryParam, 'from_commit', args.yJ),
						A2($author$project$Model$Route$boolQueryParam, 'focus_add_packages', args.yo),
						A2($author$project$Model$Route$boolQueryParam, 'show_add_packages', args.z6),
						A2($author$project$Model$Route$boolQueryParam, 'show_import_packages', args.z7)
					]));
		case 1:
			var args = page.a;
			return A2(
				$author$project$Model$Route$urlPieces,
				_List_fromArray(
					['advanced']),
				_List_fromArray(
					[
						commitIDParam(args.gr),
						A2($author$project$Model$Route$stringQueryParam, 'branch', args.fO)
					]));
		case 5:
			var maybeCommitID = page.a;
			var maybePlatformID = page.b;
			var newProject = page.c;
			var branchName = page.d;
			return A2(
				$author$project$Model$Route$urlPieces,
				_List_fromArray(
					['distributions']),
				_List_fromArray(
					[
						commitIDParam(maybeCommitID),
						A2($author$project$Model$Route$stringQueryParam, 'platformID', maybePlatformID),
						A2($author$project$Model$Route$boolQueryParam, 'new_project', newProject),
						A2($author$project$Model$Route$stringQueryParam, 'branch', branchName)
					]));
		case 2:
			var maybeBranchName = page.a;
			var fragment = page.b;
			return A3(
				$author$project$Model$Route$URLPieces,
				_List_fromArray(
					['settings']),
				_List_fromArray(
					[
						A2($author$project$Model$Route$stringQueryParam, 'branch', maybeBranchName)
					]),
				fragment);
		case 3:
			var maybeBranchName = page.a;
			return A2(
				$author$project$Model$Route$urlPieces,
				_List_fromArray(
					['settings', 'branches']),
				_List_fromArray(
					[
						A2($author$project$Model$Route$stringQueryParam, 'branch', maybeBranchName)
					]));
		case 4:
			var maybeBranchName = page.a.fO;
			var maybeCommitID = page.a.gr;
			return A2(
				$author$project$Model$Route$urlPieces,
				_List_fromArray(
					['settings', 'har']),
				_List_fromArray(
					[
						A2($author$project$Model$Route$stringQueryParam, 'branch', maybeBranchName),
						commitIDParam(maybeCommitID)
					]));
		case 6:
			var maybeCommitID = page.a;
			var branchName = page.b;
			return A2(
				$author$project$Model$Route$urlPieces,
				_List_fromArray(
					['releases']),
				_List_fromArray(
					[
						commitIDParam(maybeCommitID),
						A2($author$project$Model$Route$stringQueryParam, 'branch', branchName)
					]));
		case 7:
			var oldCommitID = page.a.uU;
			var oldAtTime = page.a.uS;
			var oldBuildExpr = page.a.uT;
			var oldVcsRef = page.a.uW;
			var newCommitID = page.a.uL;
			var newAtTime = page.a.uJ;
			var newBuildExpr = page.a.uK;
			var newVcsRef = page.a.uN;
			return A2(
				$author$project$Model$Route$urlPieces,
				_List_fromArray(
					['impact-report']),
				_List_fromArray(
					[
						A2($author$project$Model$Route$uuidParam, 'oldCommitID', oldCommitID),
						A2($author$project$Model$Route$stringQueryParam, 'oldAtTime', oldAtTime),
						A2($author$project$Model$Route$stringQueryParam, 'oldBuildExpr', oldBuildExpr),
						A2($author$project$Model$Route$stringQueryParam, 'oldVcsRef', oldVcsRef),
						A2($author$project$Model$Route$uuidParam, 'newCommitID', newCommitID),
						A2($author$project$Model$Route$stringQueryParam, 'newAtTime', newAtTime),
						A2($author$project$Model$Route$stringQueryParam, 'newBuildExpr', newBuildExpr),
						A2($author$project$Model$Route$stringQueryParam, 'newVcsRef', newVcsRef)
					]));
		case 8:
			var reasonsForRedirect = page.a;
			var reasons = $elm$core$List$isEmpty(reasonsForRedirect) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				A2(
					$elm$core$String$join,
					',',
					A2($elm$core$List$map, $author$project$Model$Route$reasonForRedirectToString, reasonsForRedirect)));
			return A2(
				$author$project$Model$Route$urlPieces,
				_List_fromArray(
					['fork']),
				_List_fromArray(
					[
						A2($author$project$Model$Route$stringQueryParam, 'actions', reasons)
					]));
		default:
			var cliInstructionsPlatform = page.a;
			var content = page.b;
			return A2(
				$author$project$Model$Route$urlPieces,
				_List_fromArray(
					['auto-fork']),
				_List_fromArray(
					[
						A2($author$project$Model$Route$stringQueryParam, 'cli-instructions', cliInstructionsPlatform),
						A2($author$project$Model$Route$authContentQueryParam, 'content', content)
					]));
	}
};
var $author$project$Model$Route$orgRouteToString = function (page) {
	switch (page.$) {
		case 0:
			var maybeSignupSource = page.a;
			return A2(
				$author$project$Model$Route$urlPieces,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Model$Route$stringQueryParam, 'signupSource', maybeSignupSource)
					]));
		case 1:
			return $author$project$Model$Route$path(
				_List_fromArray(
					['members']));
		case 2:
			return $author$project$Model$Route$path(
				_List_fromArray(
					['policy']));
		case 3:
			return $author$project$Model$Route$path(
				_List_fromArray(
					['remediation']));
		case 7:
			var projectName = page.a.vT;
			var projectRoute = page.a.zL;
			return A2(
				$author$project$Model$Route$mergePieces,
				$author$project$Model$Route$path(
					_List_fromArray(
						[projectName])),
				$author$project$Model$Route$projectRouteToString(projectRoute));
		case 4:
			return $author$project$Model$Route$path(
				_List_fromArray(
					['settings']));
		case 5:
			return $author$project$Model$Route$path(
				_List_fromArray(
					['scan']));
		case 6:
			return $author$project$Model$Route$path(
				_List_fromArray(
					['security']));
		default:
			return $author$project$Model$Route$path(
				_List_fromArray(
					['dependencies']));
	}
};
var $author$project$Model$Tier$simpleTierToString = function (tier) {
	switch (tier.$) {
		case 5:
			return 'enterprise';
		case 6:
			return 'enterprise_evaluation';
		case 4:
			return 'business_legacy';
		case 3:
			if (!tier.a) {
				return 'team';
			} else {
				return 'team_trial';
			}
		case 2:
			return 'pro';
		case 1:
			return 'coder_legacy';
		case 0:
			return 'free';
		case 7:
			return 'platform_trial_evaluation';
		default:
			return 'unknown';
	}
};
var $author$project$Model$Route$tierQueryParam = F2(
	function (name, tier) {
		return A2(
			$author$project$Model$Route$stringQueryParam,
			name,
			A2($elm$core$Maybe$map, $author$project$Model$Tier$simpleTierToString, tier));
	});
var $author$project$Model$NonEmptyString$toString = function (_v0) {
	var s = _v0;
	return s;
};
var $elm$url$Url$Builder$Absolute = {$: 0};
var $elm$url$Url$Builder$rootToPrePath = function (root) {
	switch (root.$) {
		case 0:
			return '/';
		case 1:
			return '';
		default:
			var prePath = root.a;
			return prePath + '/';
	}
};
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$custom = F4(
	function (root, pathSegments, parameters, maybeFragment) {
		var fragmentless = _Utils_ap(
			$elm$url$Url$Builder$rootToPrePath(root),
			_Utils_ap(
				A2($elm$core$String$join, '/', pathSegments),
				$elm$url$Url$Builder$toQuery(parameters)));
		if (maybeFragment.$ === 1) {
			return fragmentless;
		} else {
			var fragment = maybeFragment.a;
			return fragmentless + ('#' + fragment);
		}
	});
var $author$project$Model$Route$urlPiecesToString = function (pieces) {
	return A4(
		$elm$url$Url$Builder$custom,
		$elm$url$Url$Builder$Absolute,
		pieces.rT,
		A2($elm$core$List$filterMap, $elm$core$Basics$identity, pieces.r2),
		pieces.oD);
};
var $author$project$Model$Route$protectedRouteToString = function (page) {
	switch (page.$) {
		case 0:
			var signupSource = page.a.wd;
			return A2(
				$author$project$Model$Route$urlPieces,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Model$Route$stringQueryParam, 'signupSource', signupSource)
					]));
		case 23:
			return A2(
				$author$project$Model$Route$urlPieces,
				_List_fromArray(
					['out-of-compliance']),
				_List_Nil);
		case 1:
			var userCode = page.a.GV;
			var deviceID = page.a.x0;
			return A2(
				$author$project$Model$Route$urlPieces,
				_List_fromArray(
					['authorize', 'device']),
				_List_fromArray(
					[
						A2($author$project$Model$Route$stringQueryParam, 'user-code', userCode),
						A2($author$project$Model$Route$stringQueryParam, 'device-id', deviceID)
					]));
		case 2:
			return $author$project$Model$Route$path(
				_List_fromArray(
					['check-email']));
		case 3:
			return $author$project$Model$Route$path(
				_List_fromArray(
					['preferences']));
		case 4:
			return $author$project$Model$Route$path(
				_List_fromArray(
					['preferences', 'twofactor']));
		case 5:
			return $author$project$Model$Route$path(
				_List_fromArray(
					['preferences', 'email']));
		case 7:
			var mode = page.a.El;
			return A2(
				$author$project$Model$Route$urlPieces,
				_List_fromArray(
					['preferences', 'password']),
				_List_fromArray(
					[
						A2($author$project$Model$Route$stringQueryParam, 'mode', mode)
					]));
		case 8:
			return $author$project$Model$Route$path(
				_List_fromArray(
					['preferences', 'organizations']));
		case 6:
			var linkingError = page.a.D3;
			var service = page.a.F$;
			return A2(
				$author$project$Model$Route$urlPieces,
				_List_fromArray(
					['preferences', 'linked-accounts']),
				_List_fromArray(
					[
						A2($author$project$Model$Route$stringQueryParam, 'error', linkingError),
						A2($author$project$Model$Route$stringQueryParam, 'service', service)
					]));
		case 9:
			return $author$project$Model$Route$path(
				_List_fromArray(
					['preferences', 'delete-account']));
		case 10:
			var nextRoute = page.a.dg;
			var autoProjectParams = page.a.h3;
			return A2(
				$author$project$Model$Route$urlPieces,
				_List_fromArray(
					['create-organization']),
				A2(
					$elm$core$List$cons,
					A2($author$project$Model$Route$routeQueryParam, 'nextRoute', nextRoute),
					$author$project$Model$Route$autoProjectQueryParams(autoProjectParams)));
		case 11:
			var inviteCode = page.a.fs;
			var email = page.a.lJ;
			var newUser = page.a.zn;
			return A2(
				$author$project$Model$Route$urlPieces,
				_List_fromArray(
					[
						'activate',
						$author$project$Model$NonEmptyString$toString(inviteCode)
					]),
				_List_fromArray(
					[
						A2($author$project$Model$Route$stringQueryParam, 'email', email),
						A2($author$project$Model$Route$boolQueryParam, 'newUser', newUser)
					]));
		case 12:
			var orgName = page.a.ix;
			var inviteCode = page.a.fs;
			var email = page.a.lJ;
			var newUser = page.a.zn;
			return A2(
				$author$project$Model$Route$urlPieces,
				_List_fromArray(
					[
						'activate',
						orgName,
						$author$project$Model$NonEmptyString$toString(inviteCode)
					]),
				_List_fromArray(
					[
						A2($author$project$Model$Route$stringQueryParam, 'email', email),
						A2($author$project$Model$Route$boolQueryParam, 'newUser', newUser)
					]));
		case 13:
			var email = page.a.lJ;
			var code = page.a.xD;
			var nextRoute = page.a.dg;
			return A2(
				$author$project$Model$Route$urlPieces,
				_List_fromArray(
					['verify', email, code]),
				_List_fromArray(
					[
						A2($author$project$Model$Route$routeQueryParam, 'nextRoute', nextRoute)
					]));
		case 16:
			var subRoute = page.a;
			return A2(
				$author$project$Model$Route$mergePieces,
				$author$project$Model$Route$path(
					_List_fromArray(
						['admin'])),
				$author$project$Model$Route$adminRouteToString(subRoute));
		case 14:
			var orgName = page.a.ix;
			var orgRoute = page.a.vI;
			return A2(
				$author$project$Model$Route$mergePieces,
				$author$project$Model$Route$path(
					_List_fromArray(
						[orgName])),
				$author$project$Model$Route$orgRouteToString(orgRoute));
		case 15:
			return A2(
				$author$project$Model$Route$urlPieces,
				_List_fromArray(
					['organizations']),
				_List_Nil);
		case 17:
			var params = page.a;
			return A2(
				$author$project$Model$Route$urlPieces,
				_List_fromArray(
					['create-project']),
				$author$project$Model$Route$createProjectQueryParams(params));
		case 18:
			var orgName = page.a.ix;
			var createProjectParams = page.a.B2;
			return A2(
				$author$project$Model$Route$urlPieces,
				_List_fromArray(
					[orgName, 'create-project']),
				$author$project$Model$Route$createProjectQueryParams(createProjectParams));
		case 19:
			var orgName = page.a.ix;
			if (orgName.$ === 1) {
				return A2(
					$author$project$Model$Route$urlPieces,
					_List_fromArray(
						['import-project']),
					_List_Nil);
			} else {
				var orgNameStr = orgName.a;
				return A2(
					$author$project$Model$Route$urlPieces,
					_List_fromArray(
						[orgNameStr, 'import-project']),
					_List_Nil);
			}
		case 20:
			var isNewUser = page.a.jc;
			var nextRoute = page.a.dg;
			var queryParams = _List_fromArray(
				[
					A2($author$project$Model$Route$boolQueryParam, 'newUser', isNewUser),
					A2($author$project$Model$Route$routeQueryParam, 'nextRoute', nextRoute)
				]);
			return A2(
				$author$project$Model$Route$urlPieces,
				_List_fromArray(
					['upgrade']),
				queryParams);
		case 21:
			var isTrial = page.a.up;
			var isNewUser = page.a.jc;
			var nextRoute = page.a.dg;
			var tier = page.a.dc;
			var orgName = page.a.ix;
			var skipSelection = page.a.Ab;
			var queryParams = _List_fromArray(
				[
					A2($author$project$Model$Route$boolQueryParam, 'newUser', isNewUser),
					A2($author$project$Model$Route$tierQueryParam, 'tier', tier),
					A2($author$project$Model$Route$routeQueryParam, 'nextRoute', nextRoute),
					A2($author$project$Model$Route$stringQueryParam, 'orgUrl', orgName),
					A2($author$project$Model$Route$boolQueryParam, 'skipSelection', skipSelection)
				]);
			return isTrial ? A2(
				$author$project$Model$Route$urlPieces,
				_List_fromArray(
					['trial-checkout']),
				queryParams) : A2(
				$author$project$Model$Route$urlPieces,
				_List_fromArray(
					['checkout']),
				queryParams);
		case 22:
			var commitID = page.a.BR;
			var projectName = page.a.vT;
			return A2(
				$author$project$Model$Route$urlPieces,
				_List_fromArray(
					[
						'create-project',
						'from-commit',
						$danyx23$elm_uuid$Uuid$toString(commitID)
					]),
				_List_fromArray(
					[
						A2($author$project$Model$Route$stringQueryParam, 'projectName', projectName)
					]));
		default:
			var nextRoute = page.a.dg;
			var nextRouteParam = A2($author$project$Model$Route$routeQueryParam, 'nextRoute', nextRoute);
			var queryParams = _List_fromArray(
				[nextRouteParam]);
			return A2(
				$author$project$Model$Route$urlPieces,
				_List_fromArray(
					['finish-setup']),
				queryParams);
	}
};
var $author$project$Model$Route$routeQueryParam = F2(
	function (name, route) {
		return A2(
			$author$project$Model$Route$stringQueryParam,
			name,
			A2($elm$core$Maybe$map, $author$project$Model$Route$routeToString, route));
	});
var $author$project$Model$Route$routeToPieces = function (route) {
	switch (route.$) {
		case 0:
			return A2(
				$author$project$Model$Route$urlPieces,
				_List_fromArray(
					['logout']),
				_List_Nil);
		case 1:
			var reset = route.a.pC;
			var email = route.a.lJ;
			var inviteCode = route.a.fs;
			var source = route.a.o;
			var content = route.a.dH;
			var cliInstructionsPlatform = route.a.g$;
			var nextRoute = route.a.dg;
			var googleAnalyticsParams = route.a.hx;
			var sourceParam = A2($author$project$Model$Route$stringQueryParam, 'source', source);
			var resetParam = A2($author$project$Model$Route$boolQueryParam, 'reset', reset);
			var nextRouteParam = A2($author$project$Model$Route$routeQueryParam, 'nextRoute', nextRoute);
			var inviteCodeParam = A2(
				$author$project$Model$Route$stringQueryParam,
				'inviteCode',
				A2($elm$core$Maybe$map, $author$project$Model$NonEmptyString$toString, inviteCode));
			var emailParam = A2($author$project$Model$Route$stringQueryParam, 'email', email);
			var contentParam = A2($author$project$Model$Route$authContentQueryParam, 'content', content);
			var cliInstructionsPlatformParam = A2($author$project$Model$Route$stringQueryParam, 'cli-instructions', cliInstructionsPlatform);
			var queryParams = _Utils_ap(
				_List_fromArray(
					[resetParam, emailParam, inviteCodeParam, sourceParam, contentParam, cliInstructionsPlatformParam, nextRouteParam]),
				$author$project$Model$Route$gaQueryParams(googleAnalyticsParams));
			var base = _List_fromArray(
				['sign-in']);
			return A2($author$project$Model$Route$urlPieces, base, queryParams);
		case 6:
			return A2(
				$author$project$Model$Route$urlPieces,
				_List_fromArray(
					['not_found']),
				_List_Nil);
		case 4:
			return A2(
				$author$project$Model$Route$urlPieces,
				_List_fromArray(
					['forgot-password']),
				_List_Nil);
		case 3:
			var inviteCode = route.a.fs;
			var nextRoute = route.a.dg;
			var errorType = route.a.lP;
			var nextRouteParam = A2($author$project$Model$Route$routeQueryParam, 'nextRoute', nextRoute);
			var inviteCodeParam = A2(
				$author$project$Model$Route$stringQueryParam,
				'inviteCode',
				A2($elm$core$Maybe$map, $author$project$Model$NonEmptyString$toString, inviteCode));
			var errorTypeParam = function () {
				var serialize = function (et) {
					switch (et.$) {
						case 0:
							return 'identifier-taken';
						case 1:
							return 'username-taken';
						case 2:
							return 'not-verified';
						case 3:
							return 'user-declined';
						case 4:
							var takenEmail = et.a;
							return 'email-address-taken:' + takenEmail;
						default:
							var err = et.a;
							return err;
					}
				};
				return A2(
					$author$project$Model$Route$stringQueryParam,
					'errorType',
					A2($elm$core$Maybe$map, serialize, errorType));
			}();
			var queryParams = _List_fromArray(
				[inviteCodeParam, nextRouteParam, errorTypeParam]);
			var base = 'connect-account';
			return A2(
				$author$project$Model$Route$urlPieces,
				_List_fromArray(
					[base]),
				queryParams);
		case 5:
			var code = route.a;
			return A2(
				$author$project$Model$Route$urlPieces,
				_List_fromArray(
					['reset-password', code]),
				_List_Nil);
		case 2:
			var inviteCode = route.a.fs;
			var source = route.a.o;
			var content = route.a.dH;
			var nextRoute = route.a.dg;
			var googleAnalyticsParams = route.a.hx;
			var email = route.a.lJ;
			var autoProjectParams = route.a.h3;
			var sourceParam = A2($author$project$Model$Route$stringQueryParam, 'source', source);
			var nextRouteParam = A2($author$project$Model$Route$routeQueryParam, 'nextRoute', nextRoute);
			var inviteCodeParam = A2(
				$author$project$Model$Route$stringQueryParam,
				'inviteCode',
				A2($elm$core$Maybe$map, $author$project$Model$NonEmptyString$toString, inviteCode));
			var contentParam = A2($author$project$Model$Route$authContentQueryParam, 'content', content);
			var queryParams = _Utils_ap(
				_List_fromArray(
					[inviteCodeParam, sourceParam, contentParam, nextRouteParam]),
				_Utils_ap(
					$author$project$Model$Route$gaQueryParams(googleAnalyticsParams),
					_Utils_ap(
						$author$project$Model$Route$autoProjectQueryParams(autoProjectParams),
						_List_fromArray(
							[
								A2($author$project$Model$Route$stringQueryParam, 'email', email)
							]))));
			var base = 'create-account';
			return A2(
				$author$project$Model$Route$urlPieces,
				_List_fromArray(
					[base]),
				queryParams);
		case 7:
			var _protected = route.a;
			return $author$project$Model$Route$protectedRouteToString(_protected);
		case 8:
			return $author$project$Model$Route$path(
				_List_fromArray(
					['support']));
		case 9:
			return $author$project$Model$Route$path(
				_List_fromArray(
					['state-tool-cheat-sheet']));
		case 10:
			return $author$project$Model$Route$path(
				_List_fromArray(
					['featured-projects']));
		case 11:
			var commitID = route.a;
			return A2(
				$author$project$Model$Route$urlPieces,
				_List_fromArray(
					[
						'commit',
						$danyx23$elm_uuid$Uuid$toString(commitID)
					]),
				_List_Nil);
		case 12:
			var args = route.a;
			var commitIDParam = $author$project$Model$Route$uuidParam('commitID');
			return A2(
				$author$project$Model$Route$urlPieces,
				_List_fromArray(
					[args.ix, args.vT]),
				_List_fromArray(
					[
						commitIDParam(args.gr),
						A2($author$project$Model$Route$stringQueryParam, 'cli-instructions', args.g$),
						A2($author$project$Model$Route$boolQueryParam, 'new_project', args.uk),
						A2($author$project$Model$Route$stringQueryParam, 'branch', args.fO),
						A2($author$project$Model$Route$boolQueryParam, 'share', args.DD)
					]));
		default:
			if (!route.a.$) {
				var _v2 = route.a;
				return A2(
					$author$project$Model$Route$urlPieces,
					_List_fromArray(
						['supplemental-license-terms']),
					_List_Nil);
			} else {
				var ids = route.a.a;
				return A2(
					$author$project$Model$Route$urlPieces,
					_List_fromArray(
						[ids.zv, ids.zK, ids.BR, 'supplemental-license-terms']),
					_List_Nil);
			}
	}
};
var $author$project$Model$Route$routeToString = function (route) {
	return $author$project$Model$Route$urlPiecesToString(
		$author$project$Model$Route$routeToPieces(route));
};
var $author$project$Routing$replaceUrl = F2(
	function (key, route) {
		return A2(
			$elm$browser$Browser$Navigation$replaceUrl,
			key,
			$author$project$Model$Route$routeToString(route));
	});
var $author$project$Pages$ActivateMembership$cmds = F2(
	function (session, model) {
		return A2($author$project$Model$Session$isMember, model.ix, session) ? A2($author$project$Routing$replaceUrl, model.Y, model.vI) : $elm$core$Platform$Cmd$none;
	});
var $author$project$Pages$AutoFork$Auto = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$AutoFork$Manual = function (a) {
	return {$: 1, a: a};
};
var $mgold$elm_nonempty_list$List$Nonempty$Nonempty = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Pages$AutoFork$OnFork = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $author$project$Http$Extra$Creds = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$ForkedFrom$NotForked = {$: 1};
var $author$project$Model$Project$Project = $elm$core$Basics$identity;
var $author$project$Model$Project$ProjectInternals = function (name) {
	return function (description) {
		return function (added) {
			return function (projectID) {
				return function (organizationId) {
					return function (_private) {
						return function (defaultBranch) {
							return function (branches) {
								return function (managed) {
									return function (lastEdited) {
										return function (forkedFrom) {
											return function (repoUrl) {
												return function (tags) {
													return function (distributionOnly) {
														return {ak: added, fZ: branches, tA: defaultBranch, bP: description, x5: distributionOnly, yp: forkedFrom, DT: lastEdited, b4: managed, w: name, zx: organizationId, cd: _private, zK: projectID, zP: repoUrl, Gt: tags};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Model$Branch$Branch = $elm$core$Basics$identity;
var $author$project$Model$Branch$Internals = F9(
	function (branchID, projectID, commitID, _default, name, tracks, trackingType, upstreamCommitID, forkedFrom) {
		return {xq: branchID, BR: commitID, xW: _default, yp: forkedFrom, w: name, zK: projectID, GM: trackingType, cq: tracks, AB: upstreamCommitID};
	});
var $author$project$Model$ForkedFrom$Unknown = {$: 0};
var $author$project$Model$Branch$AutoUpdate = 1;
var $author$project$Model$Branch$Ignore = 0;
var $author$project$Model$Branch$Notify = 2;
var $author$project$Model$Branch$stringToTrackingType = function (s) {
	switch (s) {
		case 'ignore':
			return $elm$json$Json$Decode$succeed(0);
		case 'auto_update':
			return $elm$json$Json$Decode$succeed(1);
		case 'notify':
			return $elm$json$Json$Decode$succeed(2);
		default:
			return $elm$json$Json$Decode$fail('Got an unexpected type, ' + (s + ', when I was expecting one of [ignore, auto_update, notify]'));
	}
};
var $author$project$Model$Branch$decodeTrackingType = A2($elm$json$Json$Decode$andThen, $author$project$Model$Branch$stringToTrackingType, $elm$json$Json$Decode$string);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded = A2($elm$core$Basics$composeR, $elm$json$Json$Decode$succeed, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom);
var $author$project$Model$Branch$decode = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
		$author$project$Model$ForkedFrom$Unknown,
		A3(
			$author$project$Json$Decode$Pipeline$Extra$decodeMaybe,
			'upstream_commit_id',
			$danyx23$elm_uuid$Uuid$decoder,
			A3(
				$author$project$Json$Decode$Pipeline$Extra$decodeMaybe,
				'tracking_type',
				$author$project$Model$Branch$decodeTrackingType,
				A3(
					$author$project$Json$Decode$Pipeline$Extra$decodeMaybe,
					'tracks',
					$danyx23$elm_uuid$Uuid$decoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'label',
						$elm$json$Json$Decode$string,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'default',
							$elm$json$Json$Decode$bool,
							false,
							A3(
								$author$project$Json$Decode$Pipeline$Extra$decodeMaybe,
								'commitID',
								$danyx23$elm_uuid$Uuid$decoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'projectID',
									$danyx23$elm_uuid$Uuid$decoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'branchID',
										$danyx23$elm_uuid$Uuid$decoder,
										$elm$json$Json$Decode$succeed($author$project$Model$Branch$Internals)))))))))),
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Model$ForkedFrom$Forked = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$ForkedFrom$ForkedFromData = F3(
	function (project, organization, latestCommitID) {
		return {DU: latestCommitID, c3: organization, c5: project};
	});
var $author$project$Model$ForkedFrom$decodeForkedFromData = A2(
	$elm$json$Json$Decode$map,
	$author$project$Model$ForkedFrom$Forked,
	A3(
		$author$project$Json$Decode$Pipeline$Extra$decodeMaybe,
		'commit_id',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'organization',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'project',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Model$ForkedFrom$ForkedFromData)))));
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $author$project$Model$ForkedFrom$decode = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Maybe$withDefault($author$project$Model$ForkedFrom$NotForked),
	$elm$json$Json$Decode$nullable($author$project$Model$ForkedFrom$decodeForkedFromData));
var $author$project$Model$Tag$Tag = $elm$core$Basics$identity;
var $author$project$Model$Tag$TagMeta = F3(
	function (commitID, label, tagID) {
		return {BR: commitID, b2: label, Gr: tagID};
	});
var $author$project$Model$Tag$decode = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'tagID',
		$danyx23$elm_uuid$Uuid$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'label',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'commitID',
				$danyx23$elm_uuid$Uuid$decoder,
				$elm$json$Json$Decode$succeed($author$project$Model$Tag$TagMeta)))));
var $author$project$Model$Project$defaultBranchHelp = function (branch) {
	if (branch.$ === 1) {
		return $elm$json$Json$Decode$fail('Project does not have a default branch');
	} else {
		var b = branch.a;
		return $elm$json$Json$Decode$succeed(b);
	}
};
var $elm_community$list_extra$List$Extra$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var $author$project$Model$Branch$isDefault = function (_v0) {
	var branch = _v0;
	return branch.xW;
};
var $author$project$Model$Project$defaultBranchDecoder = A2(
	$elm$json$Json$Decode$andThen,
	$author$project$Model$Project$defaultBranchHelp,
	A2(
		$elm$json$Json$Decode$map,
		$elm_community$list_extra$List$Extra$find($author$project$Model$Branch$isDefault),
		$elm$json$Json$Decode$list($author$project$Model$Branch$decode)));
var $author$project$Model$Project$decode = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'distributionOnly',
		$elm$json$Json$Decode$bool,
		false,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'tags',
			$elm$json$Json$Decode$list($author$project$Model$Tag$decode),
			_List_Nil,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'repoUrl',
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'forkedFrom',
					$author$project$Model$ForkedFrom$decode,
					$author$project$Model$ForkedFrom$NotForked,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'lastEdited',
						$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'managed',
							$elm$json$Json$Decode$bool,
							false,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'branches',
								$elm$json$Json$Decode$list($author$project$Model$Branch$decode),
								_List_Nil,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'branches',
									$author$project$Model$Project$defaultBranchDecoder,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'private',
										$elm$json$Json$Decode$bool,
										false,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'organizationID',
											$danyx23$elm_uuid$Uuid$decoder,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'projectID',
												$danyx23$elm_uuid$Uuid$decoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'added',
													$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'description',
														$elm$json$Json$Decode$string,
														'',
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'name',
															$elm$json$Json$Decode$string,
															$elm$json$Json$Decode$succeed($author$project$Model$Project$ProjectInternals))))))))))))))));
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $author$project$Model$ProjectFork$encode = function (_v0) {
	var organizationName = _v0.vJ;
	var name = _v0.w;
	var managed = _v0.b4;
	var _private = _v0.cd;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'organizationName',
				$elm$json$Json$Encode$string(organizationName)),
				_Utils_Tuple2(
				'projectName',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, name))),
				_Utils_Tuple2(
				'managed',
				$elm$json$Json$Encode$bool(managed)),
				_Utils_Tuple2(
				'private',
				$elm$json$Json$Encode$bool(_private))
			]));
};
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $author$project$Http$Extra$jsonBody = $elm$http$Http$jsonBody;
var $author$project$Http$Extra$post = function (_v0) {
	var url = _v0.GT;
	var body = _v0.sY;
	var decoder = _v0.qN;
	var auth = _v0.iO;
	var headers = _v0.CN;
	return $elm$http$Http$task(
		{
			sY: body,
			CN: _Utils_ap(
				$author$project$Http$Extra$authToHeaders(auth),
				A2(
					$elm$core$List$map,
					$elm_community$basics_extra$Basics$Extra$uncurry($elm$http$Http$header),
					headers)),
			my: 'POST',
			nj: $elm$http$Http$stringResolver(
				A2($author$project$Http$Extra$responseToResult, url, decoder)),
			nE: $elm$core$Maybe$Nothing,
			GT: _Utils_ap(
				$author$project$Http$Extra$authToUrlBase(auth),
				url)
		});
};
var $elm$url$Url$Builder$relative = F2(
	function (pathSegments, parameters) {
		return _Utils_ap(
			A2($elm$core$String$join, '/', pathSegments),
			$elm$url$Url$Builder$toQuery(parameters));
	});
var $author$project$Request$Project$urlPathOrgProject = F2(
	function (orgName, projectName) {
		return A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				['/organizations', orgName, 'projects', projectName]),
			_List_Nil);
	});
var $author$project$Request$Project$fork = F4(
	function (creds, originOrg, originProject, projectFork) {
		return $author$project$Http$Extra$post(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$jsonBody(
					$author$project$Model$ProjectFork$encode(projectFork)),
				qN: $author$project$Model$Project$decode,
				CN: _List_Nil,
				GT: A2(
					$elm$url$Url$Builder$relative,
					_List_fromArray(
						[
							A2($author$project$Request$Project$urlPathOrgProject, originOrg, originProject),
							'fork'
						]),
					_List_Nil)
			});
	});
var $mgold$elm_nonempty_list$List$Nonempty$fromList = function (ys) {
	if (ys.b) {
		var x = ys.a;
		var xs = ys.b;
		return $elm$core$Maybe$Just(
			A2($mgold$elm_nonempty_list$List$Nonempty$Nonempty, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$Project$getName = function (_v0) {
	var project = _v0;
	return project.w;
};
var $author$project$Pages$AutoFork$homeRoute = $author$project$Model$Route$Protected(
	$author$project$Model$Route$Home(
		{wd: $elm$core$Maybe$Nothing}));
var $author$project$Model$ProjectFork$new = F4(
	function (orgName, managed, _private, maybeName) {
		return {b4: managed, w: maybeName, vJ: orgName, cd: _private};
	});
var $mgold$elm_nonempty_list$List$Nonempty$toList = function (_v0) {
	var x = _v0.a;
	var xs = _v0.b;
	return A2($elm$core$List$cons, x, xs);
};
var $author$project$Pages$AutoFork$cmds = F2(
	function (session, model) {
		var projectHasNameClash = function (project) {
			return A2(
				$elm$core$List$member,
				$author$project$Model$Project$getName(project),
				A2($elm$core$List$map, $author$project$Model$Project$getName, model.wX));
		};
		var navigateToForkPage = F2(
			function (project, actions) {
				return A2(
					$author$project$Routing$replaceUrl,
					model.Y,
					$author$project$Model$Route$Protected(
						$author$project$Model$Route$Org(
							A2(
								$author$project$Model$Route$OrgParams,
								model.pR,
								$author$project$Model$Route$OrgProject(
									{
										vT: $author$project$Model$Project$getName(project),
										zL: $author$project$Model$Route$ProjectFork(actions)
									})))));
			});
		var navigateHome = A2($author$project$Routing$replaceUrl, model.Y, $author$project$Pages$AutoFork$homeRoute);
		var method = F2(
			function (user, project) {
				var maybeFork = A2(
					$elm$core$Maybe$andThen,
					function (single) {
						return $elm$core$Maybe$Just(
							A4($author$project$Model$ProjectFork$new, single.AC, false, false, $elm$core$Maybe$Nothing));
					},
					$author$project$Misc$getSingle(user.mX));
				var basicReasons = A2(
					$elm$core$List$map,
					$elm$core$Tuple$first,
					A2(
						$elm$core$List$filter,
						$elm$core$Tuple$second,
						_List_fromArray(
							[
								_Utils_Tuple2(
								0,
								projectHasNameClash(project))
							])));
				if (!maybeFork.$) {
					var fork = maybeFork.a;
					var _v5 = $mgold$elm_nonempty_list$List$Nonempty$fromList(basicReasons);
					if (!_v5.$) {
						var reasons = _v5.a;
						return $author$project$Pages$AutoFork$Manual(reasons);
					} else {
						return $author$project$Pages$AutoFork$Auto(fork);
					}
				} else {
					return $author$project$Pages$AutoFork$Manual(
						A2($mgold$elm_nonempty_list$List$Nonempty$Nonempty, 1, basicReasons));
				}
			});
		var creds = $author$project$Model$Session$getCreds(session);
		var forkProject = F2(
			function (fork, project) {
				var projectName = $author$project$Model$Project$getName(project);
				return A2(
					$elm$core$Task$attempt,
					$author$project$Pages$AutoFork$OnFork(fork.vJ),
					A4($author$project$Request$Project$fork, creds, model.pR, projectName, fork));
			});
		var _v0 = _Utils_Tuple2(
			model.hU,
			$author$project$Model$Session$getUser(session));
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var project = _v0.a.a;
				var user = _v0.b.a;
				var _v1 = A2(method, user, project);
				if (!_v1.$) {
					var fork = _v1.a;
					return A2(forkProject, fork, project);
				} else {
					var listReasons = _v1.a;
					return A2(
						navigateToForkPage,
						project,
						$mgold$elm_nonempty_list$List$Nonempty$toList(listReasons));
				}
			} else {
				var project = _v0.a.a;
				var _v2 = _v0.b;
				return A2(navigateToForkPage, project, _List_Nil);
			}
		} else {
			var _v3 = _v0.a;
			return navigateHome;
		}
	});
var $author$project$Pages$CheckEmail$OnEmailVerified = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$Email$Email = F3(
	function (email, verified, preferred) {
		return {lJ: email, Fn: preferred, AL: verified};
	});
var $author$project$Model$Email$decode = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'preferred',
	$elm$json$Json$Decode$bool,
	false,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'verified',
		$elm$json$Json$Decode$bool,
		false,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'email',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Model$Email$Email))));
var $elm$http$Http$stringBody = _Http_pair;
var $author$project$Http$Extra$emptyJsonBody = A2($elm$http$Http$stringBody, 'application/json', '');
var $author$project$Protected$username = function (_v0) {
	var creds = _v0;
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.AE;
			},
			creds));
};
var $author$project$Request$Email$postVerification = F2(
	function (verification, creds) {
		return $author$project$Http$Extra$post(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$emptyJsonBody,
				qN: $author$project$Model$Email$decode,
				CN: _List_Nil,
				GT: '/users/' + ($author$project$Protected$username(creds) + ('/emails/' + (verification.lJ + ('/verification/check?verifyCode=' + verification.xD))))
			});
	});
var $author$project$Pages$CheckEmail$cmds = F2(
	function (session, model) {
		var input = {xD: model.xD, lJ: model.lJ};
		var creds = $author$project$Model$Session$getCreds(session);
		return A2(
			$elm$core$Task$attempt,
			$author$project$Pages$CheckEmail$OnEmailVerified,
			A2($author$project$Request$Email$postVerification, input, creds));
	});
var $author$project$Pages$CreateOrganization$NoOp = {$: 0};
var $author$project$Model$Analytics$categoryPageView = 'Page View';
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $author$project$Model$Session$isGithubLinked = function (session) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.D2;
				},
				$elm$core$List$any(
					$elm$core$Basics$eq(0))),
			$author$project$Model$Session$getUser(session)));
};
var $author$project$Model$Analytics$newEvent = function (name) {
	return {sO: '', xA: '', ty: _List_Nil, b2: '', w: name, kH: 0, w$: 0};
};
var $elm$json$Json$Encode$int = _Json_wrap;
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$Ports$sendAnalyticsEvent = _Platform_outgoingPort(
	'sendAnalyticsEvent',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'action',
					$elm$json$Json$Encode$string($.sO)),
					_Utils_Tuple2(
					'category',
					$elm$json$Json$Encode$string($.xA)),
					_Utils_Tuple2(
					'customValues',
					$elm$json$Json$Encode$list(
						function ($) {
							var a = $.a;
							var b = $.b;
							return A2(
								$elm$json$Json$Encode$list,
								$elm$core$Basics$identity,
								_List_fromArray(
									[
										$elm$json$Json$Encode$string(a),
										$elm$json$Json$Encode$string(b)
									]));
						})($.ty)),
					_Utils_Tuple2(
					'label',
					$elm$json$Json$Encode$string($.b2)),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string($.w)),
					_Utils_Tuple2(
					'value',
					$elm$json$Json$Encode$int($.kH)),
					_Utils_Tuple2(
					'value2',
					$elm$json$Json$Encode$int($.w$))
				]));
	});
var $Chadtech$elm_bool_extra$Bool$Extra$toString = function (bool) {
	return bool ? 'True' : 'False';
};
var $author$project$Model$Analytics$withAction = F2(
	function (action, event) {
		return _Utils_update(
			event,
			{sO: action});
	});
var $author$project$Model$Analytics$withCategory = F2(
	function (category, event) {
		return _Utils_update(
			event,
			{xA: category});
	});
var $author$project$Model$Analytics$withCustomValues = F2(
	function (customValues, event) {
		return _Utils_update(
			event,
			{ty: customValues});
	});
var $author$project$Model$Analytics$withLabel = F2(
	function (label, event) {
		return _Utils_update(
			event,
			{b2: label});
	});
var $author$project$Pages$CreateOrganization$cmds = F2(
	function (session, model) {
		var creatOrgPageviewEvent = $author$project$Ports$sendAnalyticsEvent(
			($author$project$Model$Session$isGithubLinked(session) ? $author$project$Model$Analytics$withCustomValues(
				_List_fromArray(
					[
						_Utils_Tuple2('userType', 'GitHub')
					])) : $author$project$Model$Analytics$withCustomValues(
				_List_fromArray(
					[
						_Utils_Tuple2('userType', 'Email')
					])))(
				A2(
					$author$project$Model$Analytics$withLabel,
					'isEligibleForTrial: ' + $Chadtech$elm_bool_extra$Bool$Extra$toString(model.jT.De),
					A2(
						$author$project$Model$Analytics$withAction,
						'Pageview - Create Organization',
						A2(
							$author$project$Model$Analytics$withCategory,
							$author$project$Model$Analytics$categoryPageView,
							$author$project$Model$Analytics$newEvent('Pageview - Create Organization'))))));
		return $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$Task$attempt,
					$elm$core$Basics$always($author$project$Pages$CreateOrganization$NoOp),
					$elm$browser$Browser$Dom$focus('org-urlname')),
					creatOrgPageviewEvent
				]));
	});
var $author$project$Pages$CreateProject$InstallRuntime = 0;
var $author$project$Pages$CreateProject$ProjectCreated = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$packagersInit = {A8: _List_Nil, Cj: _List_Nil, D4: _List_Nil, vX: _List_Nil, w4: _List_Nil};
var $author$project$Model$Editor$getFields = function (_v0) {
	var internal = _v0;
	return internal.g5;
};
var $author$project$Model$Editor$getField = function (getter) {
	return A2($elm$core$Basics$composeR, $author$project$Model$Editor$getFields, getter);
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$getAllPackagers = $author$project$Model$Editor$getField(
	function ($) {
		return $.E2;
	});
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$packagersSetter = F2(
	function (packagers, fields) {
		return _Utils_update(
			fields,
			{E2: packagers});
	});
var $author$project$Model$Editor$Editor = $elm$core$Basics$identity;
var $author$project$Model$Editor$setField = F3(
	function (setter, value, _v0) {
		var internal = _v0;
		return _Utils_update(
			internal,
			{
				g5: A2(setter, value, internal.g5)
			});
	});
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$setAllPackagers = $author$project$Model$Editor$setField($author$project$Model$BuildPlanner$BuildExprEditor$Simple$packagersSetter);
var $author$project$Model$BuildPlanner$SolveLegacyEditor$setBuildExprPlatformPackagersEditor = F2(
	function (func, editor) {
		return A2(
			$author$project$Model$BuildPlanner$BuildExprEditor$Simple$setAllPackagers,
			func(
				$author$project$Model$BuildPlanner$BuildExprEditor$Simple$getAllPackagers(editor)),
			editor);
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$addPackagerAuthenticodeSignature = function (platformID) {
	var add = function (packagers) {
		return _Utils_update(
			packagers,
			{
				A8: _List_fromArray(
					[
						{}
					])
			});
	};
	return $author$project$Model$BuildPlanner$SolveLegacyEditor$setBuildExprPlatformPackagersEditor(
		A2(
			$elm$core$Dict$update,
			platformID,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$withDefault($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$packagersInit),
				A2($elm$core$Basics$composeR, add, $elm$core$Maybe$Just))));
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$addPackagerDocker = function (platformID) {
	var add = function (packagers) {
		return _Utils_update(
			packagers,
			{
				Cj: _List_fromArray(
					[
						{jE: $elm$core$Maybe$Nothing, Bd: 'docker.com/ubuntu', Cr: $elm$core$Set$empty, uC: $elm$core$Maybe$Nothing, w: platformID}
					])
			});
	};
	return $author$project$Model$BuildPlanner$SolveLegacyEditor$setBuildExprPlatformPackagersEditor(
		A2(
			$elm$core$Dict$update,
			platformID,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$withDefault($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$packagersInit),
				A2($elm$core$Basics$composeR, add, $elm$core$Maybe$Just))));
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$addPackagerLinuxInstaller = function (platformID) {
	var add = function (packagers) {
		return _Utils_update(
			packagers,
			{
				D4: _List_fromArray(
					[
						{jE: $elm$core$Maybe$Nothing, uC: $elm$core$Maybe$Nothing, w: platformID}
					])
			});
	};
	return $author$project$Model$BuildPlanner$SolveLegacyEditor$setBuildExprPlatformPackagersEditor(
		A2(
			$elm$core$Dict$update,
			platformID,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$withDefault($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$packagersInit),
				A2($elm$core$Basics$composeR, add, $elm$core$Maybe$Just))));
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$addPackagerRelocateAndZip = function (platformID) {
	var add = function (packagers) {
		return _Utils_update(
			packagers,
			{
				vX: _List_fromArray(
					[
						{w: platformID}
					])
			});
	};
	return $author$project$Model$BuildPlanner$SolveLegacyEditor$setBuildExprPlatformPackagersEditor(
		A2(
			$elm$core$Dict$update,
			platformID,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$withDefault($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$packagersInit),
				A2($elm$core$Basics$composeR, add, $elm$core$Maybe$Just))));
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$addPackagerWindowsInstaller = function (platformID) {
	var add = function (packagers) {
		return _Utils_update(
			packagers,
			{
				w4: _List_fromArray(
					[
						{jE: $elm$core$Maybe$Nothing, uC: $elm$core$Maybe$Nothing, w: platformID}
					])
			});
	};
	return $author$project$Model$BuildPlanner$SolveLegacyEditor$setBuildExprPlatformPackagersEditor(
		A2(
			$elm$core$Dict$update,
			platformID,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$withDefault($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$packagersInit),
				A2($elm$core$Basics$composeR, add, $elm$core$Maybe$Just))));
};
var $author$project$Views$NotificationsInline$Notifications = $elm$core$Basics$identity;
var $author$project$Views$NotificationsInline$init = $elm$core$Maybe$Nothing;
var $author$project$Views$NotificationsInline$clear = function (model) {
	return _Utils_update(
		model,
		{mN: $author$project$Views$NotificationsInline$init});
};
var $author$project$Model$BuildPlanner$BuildPlannerError$AlreadyExistsError = function (a) {
	return {$: 1, a: a};
};
var $author$project$GraphQL$Utils$BuildPlanner = 4;
var $author$project$Model$BuildPlanner$BuildPlannerError$ForbiddenError = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$BuildPlanner$BuildPlannerError$InvalidInputError = function (a) {
	return {$: 9, a: a};
};
var $author$project$Model$BuildPlanner$BuildPlannerError$NotFoundError = function (a) {
	return {$: 5, a: a};
};
var $author$project$Model$BuildPlanner$BuildPlannerError$ParseError = function (a) {
	return {$: 6, a: a};
};
var $author$project$Model$BuildPlanner$BuildPlannerError$ValidationError = function (a) {
	return {$: 8, a: a};
};
var $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent = {$: 1};
var $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $author$project$Model$BuildPlanner$BuildExpr$App$encode = F2(
	function (encodeValue, _v0) {
		var name = _v0.w;
		var args = _v0.kO;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					name,
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$map,
							$elm$core$Tuple$mapSecond(encodeValue),
							$elm$core$Dict$toList(args))))
				]));
	});
var $author$project$Model$BuildPlanner$BuildExpr$Let$encode = F2(
	function (encodeValue, _v0) {
		var body = _v0.sY;
		var vars = _v0.w0;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'let',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$map,
							$elm$core$Tuple$mapSecond(encodeValue),
							$elm$core$Dict$toList(
								A3($elm$core$Dict$insert, 'in', body, vars)))))
				]));
	});
var $author$project$Model$BuildPlanner$BuildExpr$Var$encode = function (_v0) {
	var name = _v0;
	return $elm$json$Json$Encode$string('$' + name);
};
var $elm$json$Json$Encode$float = _Json_wrap;
var $author$project$Model$BuildPlanner$BuildExpr$encode = function (buildExpr) {
	switch (buildExpr.$) {
		case 0:
			return $elm$json$Json$Encode$null;
		case 1:
			var bool = buildExpr.a;
			return $elm$json$Json$Encode$bool(bool);
		case 2:
			var _int = buildExpr.a;
			return $elm$json$Json$Encode$int(_int);
		case 3:
			var _float = buildExpr.a;
			return $elm$json$Json$Encode$float(_float);
		case 4:
			var string = buildExpr.a;
			return $elm$json$Json$Encode$string(string);
		case 5:
			var _var = buildExpr.a;
			return $author$project$Model$BuildPlanner$BuildExpr$Var$encode(_var);
		case 6:
			var list = buildExpr.a;
			return A2($elm$json$Json$Encode$list, $author$project$Model$BuildPlanner$BuildExpr$encode, list);
		case 7:
			var let_ = buildExpr.a;
			return A2($author$project$Model$BuildPlanner$BuildExpr$Let$encode, $author$project$Model$BuildPlanner$BuildExpr$encode, let_);
		default:
			var app_ = buildExpr.a;
			return A2($author$project$Model$BuildPlanner$BuildExpr$App$encode, $author$project$Model$BuildPlanner$BuildExpr$encode, app_);
	}
};
var $author$project$Request$BuildPlanner$convertCreateProjectInput = function (input) {
	return {
		jE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
		bP: $elm$core$String$isEmpty(input.c) ? $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent : $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(input.c),
		cG: $author$project$Model$BuildPlanner$BuildExpr$encode(input.k$),
		c3: input.ix,
		cd: input.cd,
		c5: input.vT,
		m8: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent
	};
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool = function (value) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json(
		$elm$json$Json$Encode$bool(value));
};
var $author$project$Model$AtTime$Dynamic = {$: 1};
var $author$project$Model$AtTime$Now = {$: 2};
var $author$project$Model$AtTime$Timestamp = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$AtTime$parse = function (s) {
	var _v0 = $elm$core$String$trim(
		$elm$core$String$toLower(s));
	switch (_v0) {
		case 'dynamic':
			return $elm$core$Result$Ok($author$project$Model$AtTime$Dynamic);
		case 'now':
			return $elm$core$Result$Ok($author$project$Model$AtTime$Now);
		default:
			return A2(
				$elm$core$Result$mapError,
				$elm$core$Basics$always(0),
				A2(
					$elm$core$Result$map,
					$author$project$Model$AtTime$Timestamp,
					$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(s)));
	}
};
var $author$project$Model$AtTime$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		var _v0 = $author$project$Model$AtTime$parse(s);
		if (!_v0.$) {
			var atTime = _v0.a;
			return $elm$json$Json$Decode$succeed(atTime);
		} else {
			return $elm$json$Json$Decode$fail('Trying to decode at time, but \"' + (s + '\" is not supported.'));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Scalar$Codecs = $elm$core$Basics$identity;
var $author$project$BuildPlanner$Scalar$defineCodecs = function (definitions) {
	return definitions;
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth = function (month) {
	switch (month) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.cH, posixMinutes) < 0) {
					return posixMinutes + era.uR;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$core$Basics$ge = _Utils_ge;
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		xT: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		zg: month,
		AU: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).xT;
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $elm$time$Time$toMillis = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			1000,
			$elm$time$Time$posixToMillis(time));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$May = 4;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).zg;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString = F2(
	function (digits, time) {
		return A3(
			$elm$core$String$padLeft,
			digits,
			'0',
			$elm$core$String$fromInt(time));
	});
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).AU;
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime = function (time) {
	return A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		4,
		A2($elm$time$Time$toYear, $elm$time$Time$utc, time)) + ('-' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		$rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth(
			A2($elm$time$Time$toMonth, $elm$time$Time$utc, time))) + ('-' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toDay, $elm$time$Time$utc, time)) + ('T' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toHour, $elm$time$Time$utc, time)) + (':' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toMinute, $elm$time$Time$utc, time)) + (':' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toSecond, $elm$time$Time$utc, time)) + ('.' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		3,
		A2($elm$time$Time$toMillis, $elm$time$Time$utc, time)) + 'Z'))))))))))));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$encode = A2($elm$core$Basics$composeR, $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime, $elm$json$Json$Encode$string);
var $author$project$Model$AtTime$encode = function (atTime) {
	switch (atTime.$) {
		case 0:
			var posix = atTime.a;
			return $rtfeldman$elm_iso8601_date_strings$Iso8601$encode(posix);
		case 1:
			return $elm$json$Json$Encode$string('dynamic');
		default:
			return $elm$json$Json$Encode$string('now');
	}
};
var $danyx23$elm_uuid$Uuid$encode = A2($elm$core$Basics$composeR, $danyx23$elm_uuid$Uuid$toString, $elm$json$Json$Encode$string);
var $author$project$BuildPlannerScalarCodecs$codecs = $author$project$BuildPlanner$Scalar$defineCodecs(
	{
		BK: {qN: $elm$json$Json$Decode$value, lN: $elm$core$Basics$identity},
		BL: {qN: $author$project$Model$AtTime$decoder, lN: $author$project$Model$AtTime$encode},
		k8: {qN: $elm$json$Json$Decode$value, lN: $elm$core$Basics$identity},
		xE: {qN: $elm$json$Json$Decode$value, lN: $elm$core$Basics$identity},
		qE: {qN: $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder, lN: $rtfeldman$elm_iso8601_date_strings$Iso8601$encode},
		BM: {qN: $elm$json$Json$Decode$string, lN: $elm$json$Json$Encode$string},
		oc: {qN: $danyx23$elm_uuid$Uuid$decoder, lN: $danyx23$elm_uuid$Uuid$encode},
		BO: {qN: $elm$json$Json$Decode$string, lN: $elm$json$Json$Encode$string},
		BQ: {qN: $elm$json$Json$Decode$string, lN: $elm$json$Json$Encode$string},
		xF: {qN: $elm$json$Json$Decode$string, lN: $elm$json$Json$Encode$string}
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$Object = function (a) {
	return {$: 3, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject = function (maybeValues) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Object(
		A2(
			$elm$core$List$filterMap,
			function (_v0) {
				var key = _v0.a;
				var value = _v0.b;
				return A2(
					$elm$core$Maybe$andThen,
					function (actualValue) {
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(key, actualValue));
					},
					value);
			},
			maybeValues));
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$null = $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json($elm$json$Json$Encode$null);
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$optional = F2(
	function (optionalValue, toValue) {
		switch (optionalValue.$) {
			case 0:
				var value = optionalValue.a;
				return $elm$core$Maybe$Just(
					toValue(value));
			case 1:
				return $elm$core$Maybe$Nothing;
			default:
				return $elm$core$Maybe$Just($dillonkearns$elm_graphql$Graphql$Internal$Encode$null);
		}
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$string = function (value) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json(
		$elm$json$Json$Encode$string(value));
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$fromJson = function (jsonValue) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json(jsonValue);
};
var $author$project$BuildPlanner$Scalar$unwrapEncoder = F2(
	function (getter, _v0) {
		var unwrappedCodecs = _v0;
		return A2(
			$elm$core$Basics$composeR,
			getter(unwrappedCodecs).lN,
			$dillonkearns$elm_graphql$Graphql$Internal$Encode$fromJson);
	});
var $author$project$BuildPlanner$InputObject$encodeCreateProjectInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'organization',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.c3))),
				_Utils_Tuple2(
				'project',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.c5))),
				_Utils_Tuple2(
				'private',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$bool(input____.cd))),
				_Utils_Tuple2(
				'expr',
				$elm$core$Maybe$Just(
					A2(
						$author$project$BuildPlanner$Scalar$unwrapEncoder,
						function ($) {
							return $.k8;
						},
						$author$project$BuildPlannerScalarCodecs$codecs)(input____.cG))),
				_Utils_Tuple2(
				'atTime',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.jE,
					A2(
						$author$project$BuildPlanner$Scalar$unwrapEncoder,
						function ($) {
							return $.qE;
						},
						$author$project$BuildPlannerScalarCodecs$codecs))),
				_Utils_Tuple2(
				'description',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bP, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'projectDescription',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.m8, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))
			]));
};
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$Argument = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required = F3(
	function (fieldName, raw, encode) {
		return A2(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$Argument,
			fieldName,
			encode(raw));
	});
var $dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$RawField$Composite = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$composite = F3(
	function (fieldName, args, fields) {
		return A3($dillonkearns$elm_graphql$Graphql$RawField$Composite, fieldName, args, fields);
	});
var $dillonkearns$elm_graphql$Graphql$Document$Hash$HashData = F4(
	function (shift, seed, hash, charsProcessed) {
		return {k7: charsProcessed, l3: hash, ku: seed, nu: shift};
	});
var $dillonkearns$elm_graphql$Graphql$Document$Hash$c1 = 3432918353;
var $dillonkearns$elm_graphql$Graphql$Document$Hash$c2 = 461845907;
var $dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy = F2(
	function (b, a) {
		return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
	});
var $dillonkearns$elm_graphql$Graphql$Document$Hash$rotlBy = F2(
	function (b, a) {
		return (a << b) | (a >>> (32 - b));
	});
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $dillonkearns$elm_graphql$Graphql$Document$Hash$finalize = function (data) {
	var acc = (!(!data.l3)) ? (data.ku ^ A2(
		$dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy,
		$dillonkearns$elm_graphql$Graphql$Document$Hash$c2,
		A2(
			$dillonkearns$elm_graphql$Graphql$Document$Hash$rotlBy,
			15,
			A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, $dillonkearns$elm_graphql$Graphql$Document$Hash$c1, data.l3)))) : data.ku;
	var h0 = acc ^ data.k7;
	var h1 = A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
	var h2 = A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
	return (h2 ^ (h2 >>> 16)) >>> 0;
};
var $dillonkearns$elm_graphql$Graphql$Document$Hash$mix = F2(
	function (h1, k1) {
		return A2(
			$dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy,
			5,
			A2(
				$dillonkearns$elm_graphql$Graphql$Document$Hash$rotlBy,
				13,
				h1 ^ A2(
					$dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy,
					$dillonkearns$elm_graphql$Graphql$Document$Hash$c2,
					A2(
						$dillonkearns$elm_graphql$Graphql$Document$Hash$rotlBy,
						15,
						A2($dillonkearns$elm_graphql$Graphql$Document$Hash$multiplyBy, $dillonkearns$elm_graphql$Graphql$Document$Hash$c1, k1))))) + 3864292196;
	});
var $dillonkearns$elm_graphql$Graphql$Document$Hash$hashFold = F2(
	function (c, data) {
		var res = data.l3 | ((255 & $elm$core$Char$toCode(c)) << data.nu);
		var _v0 = data.nu;
		if (_v0 === 24) {
			return {
				k7: data.k7 + 1,
				l3: 0,
				ku: A2($dillonkearns$elm_graphql$Graphql$Document$Hash$mix, data.ku, res),
				nu: 0
			};
		} else {
			return {k7: data.k7 + 1, l3: res, ku: data.ku, nu: data.nu + 8};
		}
	});
var $dillonkearns$elm_graphql$Graphql$Document$Hash$hashString = F2(
	function (seed, str) {
		return $dillonkearns$elm_graphql$Graphql$Document$Hash$finalize(
			A3(
				$elm$core$String$foldl,
				$dillonkearns$elm_graphql$Graphql$Document$Hash$hashFold,
				A4($dillonkearns$elm_graphql$Graphql$Document$Hash$HashData, 0, seed, 0, 0),
				str));
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$List = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize = function (value) {
	var serializeJson = function (json) {
		var decoder = $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					A2(
						$elm$core$Basics$composeL,
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$List,
						$elm$core$List$map($dillonkearns$elm_graphql$Graphql$Internal$Encode$Json)),
					$elm$json$Json$Decode$list($elm$json$Json$Decode$value)),
					A2(
					$elm$json$Json$Decode$map,
					A2(
						$elm$core$Basics$composeL,
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$Object,
						$elm$core$List$map(
							$elm$core$Tuple$mapSecond($dillonkearns$elm_graphql$Graphql$Internal$Encode$Json))),
					$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$value))
				]));
		var _v2 = A2($elm$json$Json$Decode$decodeValue, decoder, json);
		if (!_v2.$) {
			var v = _v2.a;
			return $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize(v);
		} else {
			return A2($elm$json$Json$Encode$encode, 0, json);
		}
	};
	switch (value.$) {
		case 0:
			var enumValue = value.a;
			return enumValue;
		case 1:
			var json = value.a;
			return serializeJson(json);
		case 2:
			var values = value.a;
			return '[' + (A2(
				$elm$core$String$join,
				', ',
				A2($elm$core$List$map, $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize, values)) + ']');
		default:
			var keyValuePairs = value.a;
			return '{' + (A2(
				$elm$core$String$join,
				', ',
				A2(
					$elm$core$List$map,
					function (_v1) {
						var key = _v1.a;
						var objectValue = _v1.b;
						return key + (': ' + $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize(objectValue));
					},
					keyValuePairs)) + '}');
	}
};
var $dillonkearns$elm_graphql$Graphql$Document$Argument$argToString = function (_v0) {
	var name = _v0.a;
	var value = _v0.b;
	return name + (': ' + $dillonkearns$elm_graphql$Graphql$Internal$Encode$serialize(value));
};
var $dillonkearns$elm_graphql$Graphql$Document$Argument$serialize = function (args) {
	if (!args.b) {
		return '';
	} else {
		var nonemptyArgs = args;
		return '(' + (A2(
			$elm$core$String$join,
			', ',
			A2($elm$core$List$map, $dillonkearns$elm_graphql$Graphql$Document$Argument$argToString, nonemptyArgs)) + ')');
	}
};
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$maybeAliasHash = function (field) {
	return A2(
		$elm$core$Maybe$map,
		$dillonkearns$elm_graphql$Graphql$Document$Hash$hashString(0),
		function () {
			if (!field.$) {
				var name = field.a;
				var _arguments = field.b;
				var children = field.c;
				return $elm$core$List$isEmpty(_arguments) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(_arguments));
			} else {
				var typeString = field.a.GP;
				var fieldName = field.a.yk;
				var _arguments = field.b;
				return (fieldName === '__typename') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$elm$core$String$concat(
						A2(
							$elm$core$List$append,
							_List_fromArray(
								[typeString]),
							$elm$core$List$singleton(
								$dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(_arguments)))));
			}
		}());
};
var $dillonkearns$elm_graphql$Graphql$RawField$name = function (field) {
	if (!field.$) {
		var fieldName = field.a;
		var argumentList = field.b;
		var fieldList = field.c;
		return fieldName;
	} else {
		var typeString = field.a.GP;
		var fieldName = field.a.yk;
		var argumentList = field.b;
		return fieldName;
	}
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$alias = function (field) {
	return A2(
		$elm$core$Maybe$map,
		function (aliasHash) {
			return _Utils_ap(
				$dillonkearns$elm_graphql$Graphql$RawField$name(field),
				$elm$core$String$fromInt(aliasHash));
		},
		$dillonkearns$elm_graphql$Graphql$Document$Field$maybeAliasHash(field));
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName = function (field) {
	return A2(
		$elm$core$Maybe$withDefault,
		$dillonkearns$elm_graphql$Graphql$RawField$name(field),
		$dillonkearns$elm_graphql$Graphql$Document$Field$alias(field));
};
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField = F4(
	function (fieldName, args, _v0, decoderTransform) {
		var fields = _v0.a;
		var decoder = _v0.b;
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$composite, fieldName, args, fields)
				]),
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$json$Json$Decode$field,
						fieldName,
						decoderTransform(decoder)),
						A2(
						$elm$json$Json$Decode$field,
						$dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName(
							A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$composite, fieldName, args, fields)),
						decoderTransform(decoder))
					])));
	});
var $author$project$BuildPlanner$Mutation$createProject = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'createProject',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.$7, $author$project$BuildPlanner$InputObject$encodeCreateProjectInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $dillonkearns$elm_graphql$Graphql$SelectionSet$FragmentSelectionSet = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment = F2(
	function (fragmentTypeName, _v0) {
		var fields = _v0.a;
		var decoder = _v0.b;
		return A3($dillonkearns$elm_graphql$Graphql$SelectionSet$FragmentSelectionSet, fragmentTypeName, fields, decoder);
	});
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $lukewestby$elm_string_interpolate$String$Interpolate$applyInterpolation = F2(
	function (replacements, _v0) {
		var match = _v0.o0;
		var ordinalString = A2(
			$elm$core$Basics$composeL,
			$elm$core$String$dropLeft(1),
			$elm$core$String$dropRight(1))(match);
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$andThen,
				function (value) {
					return A2($elm$core$Array$get, value, replacements);
				},
				$elm$core$String$toInt(ordinalString)));
	});
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{fe: nodeList, dt: nodeListSize, eQ: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $lukewestby$elm_string_interpolate$String$Interpolate$interpolationRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('\\{\\d+\\}'));
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $lukewestby$elm_string_interpolate$String$Interpolate$interpolate = F2(
	function (string, args) {
		var asArray = $elm$core$Array$fromList(args);
		return A3(
			$elm$regex$Regex$replace,
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolationRegex,
			$lukewestby$elm_string_interpolate$String$Interpolate$applyInterpolation(asArray),
			string);
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFailureMessage = F2(
	function (typeSpecificSelections, typeName) {
		return A2(
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
			'Unhandled type `{0}` in exhaustive fragment handling. The following types had handlers registered to handle them: [{1}]. This happens if you are parsing either a Union or Interface. Do you need to rerun the `@dillonkearns/elm-graphql` command line tool?',
			_List_fromArray(
				[
					typeName,
					A2(
					$elm$core$String$join,
					', ',
					A2(
						$elm$core$List$map,
						function (_v0) {
							var fragmentType = _v0.a;
							var fields = _v0.b;
							var decoder = _v0.c;
							return fragmentType;
						},
						typeSpecificSelections))
				]));
	});
var $dillonkearns$elm_graphql$Graphql$RawField$Leaf = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$RawField$typename = A2(
	$dillonkearns$elm_graphql$Graphql$RawField$Leaf,
	{yk: '__typename', GP: ''},
	_List_Nil);
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection = function (typeSpecificSelections) {
	var selections = A2(
		$elm$core$List$map,
		function (_v1) {
			var typeName = _v1.a;
			var fields = _v1.b;
			var decoder = _v1.c;
			return A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$composite, '...on ' + typeName, _List_Nil, fields);
		},
		typeSpecificSelections);
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
		A2($elm$core$List$cons, $dillonkearns$elm_graphql$Graphql$RawField$typename, selections),
		A2(
			$elm$json$Json$Decode$andThen,
			function (typeName) {
				return A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Decode$fail(
						A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFailureMessage, typeSpecificSelections, typeName)),
					A2(
						$elm$core$Dict$get,
						typeName,
						$elm$core$Dict$fromList(
							A2(
								$elm$core$List$map,
								function (_v0) {
									var thisTypeName = _v0.a;
									var fields = _v0.b;
									var decoder = _v0.c;
									return _Utils_Tuple2(thisTypeName, decoder);
								},
								typeSpecificSelections))));
			},
			A2(
				$elm$json$Json$Decode$field,
				$dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName($dillonkearns$elm_graphql$Graphql$RawField$typename),
				$elm$json$Json$Decode$string)));
};
var $author$project$BuildPlanner$Union$CreateProjectResult$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ProjectCreated', selections____.vu),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'AlreadyExists', selections____.uX),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'NotFound', selections____.vp),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ParseError', selections____.vq),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ValidationError', selections____.vC),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Forbidden', selections____.vc),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInput', selections____.vj)
			]));
};
var $dillonkearns$elm_graphql$Graphql$SelectionSet$map = F2(
	function (mapFunction, _v0) {
		var selectionFields = _v0.a;
		var selectionDecoder = _v0.b;
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			selectionFields,
			A2($elm$json$Json$Decode$map, mapFunction, selectionDecoder));
	});
var $author$project$GraphQL$Utils$BadRequest = 0;
var $author$project$GraphQL$Utils$apiToUrl = function (apiType) {
	switch (apiType) {
		case 0:
			return '/graphql/v1/graphql';
		case 1:
			return '/sv/hasura-inventory/v1/graphql';
		case 2:
			return '/sv/hasura-analytics/v1/graphql';
		case 3:
			return '/v13s/v1/graphql';
		default:
			return '/sv/buildplanner/graphql';
	}
};
var $author$project$GraphQL$Utils$dummyResponse = {sY: '', CN: $elm$core$Dict$empty, wp: 200, wq: ''};
var $author$project$GraphQL$Utils$graphqHttpErrorToHttpError = F2(
	function (url, graphqlHttpError) {
		switch (graphqlHttpError.$) {
			case 0:
				return A2($author$project$Http$Extra$Error, url, $author$project$Http$Extra$BadUrl);
			case 1:
				return A2($author$project$Http$Extra$Error, url, $author$project$Http$Extra$Timeout);
			case 2:
				return A2($author$project$Http$Extra$Error, url, $author$project$Http$Extra$NetworkError);
			case 3:
				var metadata = graphqlHttpError.a;
				var body = graphqlHttpError.b;
				return A2(
					$author$project$Http$Extra$Error,
					url,
					$author$project$Http$Extra$BadStatus(
						A2($author$project$Http$Extra$metadataToResponse, metadata, body)));
			default:
				var decodeError = graphqlHttpError.a;
				return A2(
					$author$project$Http$Extra$Error,
					url,
					$author$project$Http$Extra$BadPayload(
						$elm$json$Json$Decode$errorToString(decodeError)));
		}
	});
var $author$project$GraphQL$Utils$graphqlErrorToHttpError = F3(
	function (mode, url, rawErr) {
		if (rawErr.$ === 1) {
			var err = rawErr.a;
			if (err.$ === 4) {
				var decodeError = err.a;
				return A2(
					$elm$core$String$contains,
					'mapOrFail',
					$elm$json$Json$Decode$errorToString(decodeError)) ? A2(
					$author$project$Http$Extra$Error,
					url,
					$author$project$Http$Extra$BadStatus(
						_Utils_update(
							$author$project$GraphQL$Utils$dummyResponse,
							{
								sY: $elm$json$Json$Decode$errorToString(decodeError),
								wp: function () {
									if (!mode) {
										return 400;
									} else {
										return 404;
									}
								}(),
								wq: ''
							}))) : A2($author$project$GraphQL$Utils$graphqHttpErrorToHttpError, url, err);
			} else {
				var httpErr = err;
				return A2($author$project$GraphQL$Utils$graphqHttpErrorToHttpError, url, httpErr);
			}
		} else {
			var errors = rawErr.b;
			var errorMsgs = A2(
				$elm$core$String$join,
				', ',
				A2(
					$elm$core$List$map,
					function ($) {
						return $.Eh;
					},
					errors));
			var message = 'Graphql query failed: ' + errorMsgs;
			return A2(
				$author$project$Http$Extra$Error,
				url,
				$author$project$Http$Extra$BadStatus(
					_Utils_update(
						$author$project$GraphQL$Utils$dummyResponse,
						{sY: message, wp: 400, wq: ''})));
		}
	});
var $elm$core$Task$mapError = F2(
	function (convert, task) {
		return A2(
			$elm$core$Task$onError,
			A2($elm$core$Basics$composeL, $elm$core$Task$fail, convert),
			task);
	});
var $dillonkearns$elm_graphql$Graphql$Http$HttpError = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$Http$failTaskOnHttpSuccessWithErrors = function (successOrError) {
	if (!successOrError.$) {
		var value = successOrError.a;
		return $elm$core$Task$succeed(value);
	} else {
		var _v1 = successOrError.a;
		var possiblyParsedData = _v1.a;
		var graphqlErrorGraphqlErrorList = _v1.b;
		return $elm$core$Task$fail(
			A2($dillonkearns$elm_graphql$Graphql$Http$GraphqlError, possiblyParsedData, graphqlErrorGraphqlErrorList));
	}
};
var $dillonkearns$elm_graphql$Graphql$Http$BadPayload = function (a) {
	return {$: 4, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$BadStatus = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$NetworkError = {$: 2};
var $dillonkearns$elm_graphql$Graphql$Http$Timeout = {$: 1};
var $dillonkearns$elm_graphql$Graphql$Http$jsonResolver = function (decoder) {
	return $elm$http$Http$stringResolver(
		function (response) {
			switch (response.$) {
				case 0:
					var url = response.a;
					return $elm$core$Result$Err(
						$dillonkearns$elm_graphql$Graphql$Http$BadUrl(url));
				case 1:
					return $elm$core$Result$Err($dillonkearns$elm_graphql$Graphql$Http$Timeout);
				case 2:
					return $elm$core$Result$Err($dillonkearns$elm_graphql$Graphql$Http$NetworkError);
				case 3:
					var metadata = response.a;
					var body = response.b;
					return $elm$core$Result$Err(
						A2($dillonkearns$elm_graphql$Graphql$Http$BadStatus, metadata, body));
				default:
					var metadata = response.a;
					var body = response.b;
					var _v1 = A2($elm$json$Json$Decode$decodeString, decoder, body);
					if (!_v1.$) {
						var value = _v1.a;
						return $elm$core$Result$Ok(value);
					} else {
						var err = _v1.a;
						return $elm$core$Result$Err(
							$dillonkearns$elm_graphql$Graphql$Http$BadPayload(err));
					}
			}
		});
};
var $dillonkearns$elm_graphql$Graphql$Http$QueryHelper$Get = 0;
var $dillonkearns$elm_graphql$Graphql$Http$QueryHelper$Post = 1;
var $dillonkearns$elm_graphql$Graphql$Http$QueryHelper$maxLength = 2000;
var $j_maas$elm_ordered_containers$OrderedDict$OrderedDict = $elm$core$Basics$identity;
var $j_maas$elm_ordered_containers$OrderedDict$empty = {dl: $elm$core$Dict$empty, vD: _List_Nil};
var $j_maas$elm_ordered_containers$OrderedDict$get = F2(
	function (key, _v0) {
		var orderedDict = _v0;
		return A2($elm$core$Dict$get, key, orderedDict.dl);
	});
var $j_maas$elm_ordered_containers$OrderedDict$insert = F3(
	function (key, value, _v0) {
		var orderedDict = _v0;
		var filteredOrder = A2($elm$core$Dict$member, key, orderedDict.dl) ? A2(
			$elm$core$List$filter,
			function (k) {
				return !_Utils_eq(k, key);
			},
			orderedDict.vD) : orderedDict.vD;
		var newOrder = _Utils_ap(
			filteredOrder,
			_List_fromArray(
				[key]));
		return {
			dl: A3($elm$core$Dict$insert, key, value, orderedDict.dl),
			vD: newOrder
		};
	});
var $j_maas$elm_ordered_containers$OrderedDict$remove = F2(
	function (key, _v0) {
		var orderedDict = _v0;
		return {
			dl: A2($elm$core$Dict$remove, key, orderedDict.dl),
			vD: A2($elm$core$Dict$member, key, orderedDict.dl) ? A2(
				$elm$core$List$filter,
				function (k) {
					return !_Utils_eq(k, key);
				},
				orderedDict.vD) : orderedDict.vD
		};
	});
var $j_maas$elm_ordered_containers$OrderedDict$update = F3(
	function (key, alter, original) {
		var orderedDict = original;
		var _v0 = A2($elm$core$Dict$get, key, orderedDict.dl);
		if (!_v0.$) {
			var oldItem = _v0.a;
			var _v1 = alter(
				$elm$core$Maybe$Just(oldItem));
			if (!_v1.$) {
				var newItem = _v1.a;
				return {
					dl: A3(
						$elm$core$Dict$update,
						key,
						$elm$core$Basics$always(
							$elm$core$Maybe$Just(newItem)),
						orderedDict.dl),
					vD: orderedDict.vD
				};
			} else {
				return A2($j_maas$elm_ordered_containers$OrderedDict$remove, key, original);
			}
		} else {
			var _v2 = alter($elm$core$Maybe$Nothing);
			if (!_v2.$) {
				var newItem = _v2.a;
				return A3($j_maas$elm_ordered_containers$OrderedDict$insert, key, newItem, original);
			} else {
				return original;
			}
		}
	});
var $dillonkearns$elm_graphql$Graphql$Document$Field$canAllowHashing = function (rawFields) {
	var fieldCounts = A3(
		$elm$core$List$foldl,
		F2(
			function (fld, acc) {
				return A3(
					$j_maas$elm_ordered_containers$OrderedDict$update,
					fld,
					function (val) {
						return $elm$core$Maybe$Just(
							function () {
								if (val.$ === 1) {
									return 0;
								} else {
									var count = val.a;
									return count + 1;
								}
							}());
					},
					acc);
			}),
		$j_maas$elm_ordered_containers$OrderedDict$empty,
		A2($elm$core$List$map, $dillonkearns$elm_graphql$Graphql$RawField$name, rawFields));
	return A2(
		$elm$core$List$map,
		function (field) {
			return _Utils_Tuple2(
				field,
				(!A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$j_maas$elm_ordered_containers$OrderedDict$get,
						$dillonkearns$elm_graphql$Graphql$RawField$name(field),
						fieldCounts))) ? $elm$core$Maybe$Nothing : $dillonkearns$elm_graphql$Graphql$Document$Field$alias(field));
		},
		rawFields);
};
var $dillonkearns$elm_graphql$Graphql$Document$Indent$generate = function (indentationLevel) {
	return A2($elm$core$String$repeat, indentationLevel, '  ');
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$mergeFields = function (rawFields) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (field, mergedSoFar) {
				if (!field.$) {
					var newChildren = field.c;
					return A3(
						$j_maas$elm_ordered_containers$OrderedDict$update,
						$dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName(field),
						function (maybeChildrenSoFar) {
							if (maybeChildrenSoFar.$ === 1) {
								return $elm$core$Maybe$Just(field);
							} else {
								if (!maybeChildrenSoFar.a.$) {
									var _v2 = maybeChildrenSoFar.a;
									var existingFieldName = _v2.a;
									var existingArgs = _v2.b;
									var existingChildren = _v2.c;
									return $elm$core$Maybe$Just(
										A3(
											$dillonkearns$elm_graphql$Graphql$RawField$Composite,
											existingFieldName,
											existingArgs,
											_Utils_ap(existingChildren, newChildren)));
								} else {
									return $elm$core$Maybe$Just(field);
								}
							}
						},
						mergedSoFar);
				} else {
					return A3(
						$j_maas$elm_ordered_containers$OrderedDict$update,
						$dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName(field),
						function (maybeChildrenSoFar) {
							return $elm$core$Maybe$Just(
								A2($elm$core$Maybe$withDefault, field, maybeChildrenSoFar));
						},
						mergedSoFar);
				}
			}),
		$j_maas$elm_ordered_containers$OrderedDict$empty,
		rawFields);
};
var $j_maas$elm_ordered_containers$OrderedDict$values = function (_v0) {
	var orderedDict = _v0;
	return A2(
		$elm$core$List$filterMap,
		function (key) {
			return A2($elm$core$Dict$get, key, orderedDict.dl);
		},
		orderedDict.vD);
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$mergedFields = function (children) {
	return $j_maas$elm_ordered_containers$OrderedDict$values(
		$dillonkearns$elm_graphql$Graphql$Document$Field$mergeFields(children));
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$nonemptyChildren = function (children) {
	return $elm$core$List$isEmpty(children) ? A2($elm$core$List$cons, $dillonkearns$elm_graphql$Graphql$RawField$typename, children) : children;
};
var $dillonkearns$elm_graphql$Graphql$Document$Field$serialize = F3(
	function (aliasName, mIndentationLevel, field) {
		var prefix = function () {
			if (!aliasName.$) {
				var aliasName_ = aliasName.a;
				return _Utils_ap(
					aliasName_,
					function () {
						if (!mIndentationLevel.$) {
							return ': ';
						} else {
							return ':';
						}
					}());
			} else {
				return '';
			}
		}();
		return A2(
			$elm$core$Maybe$map,
			function (string) {
				return _Utils_ap(
					$dillonkearns$elm_graphql$Graphql$Document$Indent$generate(
						A2($elm$core$Maybe$withDefault, 0, mIndentationLevel)),
					_Utils_ap(prefix, string));
			},
			function () {
				if (!field.$) {
					var fieldName = field.a;
					var args = field.b;
					var children = field.c;
					if (mIndentationLevel.$ === 1) {
						return $elm$core$Maybe$Just(
							(fieldName + ($dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(args) + ('{' + A2($dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren, $elm$core$Maybe$Nothing, children)))) + '}');
					} else {
						var indentationLevel = mIndentationLevel.a;
						return $elm$core$Maybe$Just(
							(fieldName + ($dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(args) + (' {\n' + A2(
								$dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren,
								$elm$core$Maybe$Just(indentationLevel),
								children)))) + ('\n' + ($dillonkearns$elm_graphql$Graphql$Document$Indent$generate(indentationLevel) + '}')));
					}
				} else {
					var fieldName = field.a.yk;
					var args = field.b;
					return $elm$core$Maybe$Just(
						_Utils_ap(
							fieldName,
							$dillonkearns$elm_graphql$Graphql$Document$Argument$serialize(args)));
				}
			}());
	});
var $dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren = F2(
	function (indentationLevel, children) {
		return A2(
			$elm$core$String$join,
			function () {
				if (!indentationLevel.$) {
					return '\n';
				} else {
					return ' ';
				}
			}(),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				A2(
					$elm$core$List$map,
					function (_v0) {
						var field = _v0.a;
						var maybeAlias = _v0.b;
						return A3(
							$dillonkearns$elm_graphql$Graphql$Document$Field$serialize,
							maybeAlias,
							A2(
								$elm$core$Maybe$map,
								$elm$core$Basics$add(1),
								indentationLevel),
							field);
					},
					$dillonkearns$elm_graphql$Graphql$Document$Field$canAllowHashing(
						$dillonkearns$elm_graphql$Graphql$Document$Field$nonemptyChildren(
							$dillonkearns$elm_graphql$Graphql$Document$Field$mergedFields(children))))));
	});
var $dillonkearns$elm_graphql$Graphql$Document$serialize = F2(
	function (operationType, queries) {
		return A2(
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
			'{0} {\n{1}\n}',
			_List_fromArray(
				[
					operationType,
					A2(
					$dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren,
					$elm$core$Maybe$Just(0),
					queries)
				]));
	});
var $dillonkearns$elm_graphql$Graphql$Document$serializeQuery = function (_v0) {
	var fields = _v0.a;
	var decoder_ = _v0.b;
	return A2($dillonkearns$elm_graphql$Graphql$Document$serialize, 'query', fields);
};
var $dillonkearns$elm_graphql$Graphql$Document$serializeQueryForUrl = function (_v0) {
	var fields = _v0.a;
	var decoder_ = _v0.b;
	return '{' + (A2($dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren, $elm$core$Maybe$Nothing, fields) + '}');
};
var $dillonkearns$elm_graphql$Graphql$Document$serializeQueryForUrlWithOperationName = F2(
	function (operationName, _v0) {
		var fields = _v0.a;
		var decoder_ = _v0.b;
		return 'query ' + (operationName + (' {' + (A2($dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren, $elm$core$Maybe$Nothing, fields) + '}')));
	});
var $dillonkearns$elm_graphql$Graphql$Document$serializeWithOperationName = F3(
	function (operationType, operationName, queries) {
		return A2(
			$lukewestby$elm_string_interpolate$String$Interpolate$interpolate,
			'{0} {1} {\n{2}\n}',
			_List_fromArray(
				[
					operationType,
					operationName,
					A2(
					$dillonkearns$elm_graphql$Graphql$Document$Field$serializeChildren,
					$elm$core$Maybe$Just(0),
					queries)
				]));
	});
var $dillonkearns$elm_graphql$Graphql$Document$serializeQueryWithOperationName = F2(
	function (operationName, _v0) {
		var fields = _v0.a;
		var decoder_ = _v0.b;
		return A3($dillonkearns$elm_graphql$Graphql$Document$serializeWithOperationName, 'query', operationName, fields);
	});
var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$replace = F2(
	function (old, _new) {
		return A2(
			$elm$core$Basics$composeR,
			$elm$core$String$split(old),
			$elm$core$String$join(_new));
	});
var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryEscape = A2(
	$elm$core$Basics$composeR,
	$elm$url$Url$percentEncode,
	A2($dillonkearns$elm_graphql$Graphql$Http$QueryParams$replace, '%20', '+'));
var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryEscape(key) + ('=' + $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryEscape(value));
};
var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$joinUrlEncoded = function (args) {
	return A2(
		$elm$core$String$join,
		'&',
		A2($elm$core$List$map, $dillonkearns$elm_graphql$Graphql$Http$QueryParams$queryPair, args));
};
var $dillonkearns$elm_graphql$Graphql$Http$QueryParams$urlWithQueryParams = F2(
	function (queryParams, url) {
		return $elm$core$List$isEmpty(queryParams) ? url : (url + ('?' + $dillonkearns$elm_graphql$Graphql$Http$QueryParams$joinUrlEncoded(queryParams)));
	});
var $dillonkearns$elm_graphql$Graphql$Http$QueryHelper$build = F5(
	function (forceMethod, url, queryParams, maybeOperationName, queryDocument) {
		var _v0 = function () {
			if (!maybeOperationName.$) {
				var operationName = maybeOperationName.a;
				return _Utils_Tuple2(
					A2($dillonkearns$elm_graphql$Graphql$Document$serializeQueryForUrlWithOperationName, operationName, queryDocument),
					_List_fromArray(
						[
							_Utils_Tuple2('operationName', operationName)
						]));
			} else {
				return _Utils_Tuple2(
					$dillonkearns$elm_graphql$Graphql$Document$serializeQueryForUrl(queryDocument),
					_List_Nil);
			}
		}();
		var serializedQueryForGetRequest = _v0.a;
		var operationNameParamForGetRequest = _v0.b;
		var urlForGetRequest = A2(
			$dillonkearns$elm_graphql$Graphql$Http$QueryParams$urlWithQueryParams,
			_Utils_ap(
				queryParams,
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2('query', serializedQueryForGetRequest),
					operationNameParamForGetRequest)),
			url);
		if (_Utils_eq(
			forceMethod,
			$elm$core$Maybe$Just(1)) || ((_Utils_cmp(
			$elm$core$String$length(urlForGetRequest),
			$dillonkearns$elm_graphql$Graphql$Http$QueryHelper$maxLength) > -1) && (!_Utils_eq(
			forceMethod,
			$elm$core$Maybe$Just(0))))) {
			var _v2 = function () {
				if (!maybeOperationName.$) {
					var operationName = maybeOperationName.a;
					return _Utils_Tuple2(
						A2($dillonkearns$elm_graphql$Graphql$Document$serializeQueryWithOperationName, operationName, queryDocument),
						_List_fromArray(
							[
								_Utils_Tuple2(
								'operationName',
								$elm$json$Json$Encode$string(operationName))
							]));
				} else {
					return _Utils_Tuple2(
						$dillonkearns$elm_graphql$Graphql$Document$serializeQuery(queryDocument),
						_List_Nil);
				}
			}();
			var serializedQuery = _v2.a;
			var operationNameParamForPostRequest = _v2.b;
			return {
				sY: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'query',
								$elm$json$Json$Encode$string(serializedQuery)),
							operationNameParamForPostRequest))),
				my: 1,
				GT: A2($dillonkearns$elm_graphql$Graphql$Http$QueryParams$urlWithQueryParams, queryParams, url)
			};
		} else {
			return {sY: $elm$http$Http$emptyBody, my: 0, GT: urlForGetRequest};
		}
	});
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$ParsedData = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$UnparsedData = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$GraphqlError = F3(
	function (message, locations, details) {
		return {qQ: details, D7: locations, Eh: message};
	});
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$Location = F2(
	function (line, column) {
		return {hp: column, D0: line};
	});
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$locationDecoder = A3(
	$elm$json$Json$Decode$map2,
	$dillonkearns$elm_graphql$Graphql$Http$GraphqlError$Location,
	A2($elm$json$Json$Decode$field, 'line', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'column', $elm$json$Json$Decode$int));
var $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$decoder = A2(
	$elm$json$Json$Decode$field,
	'errors',
	$elm$json$Json$Decode$list(
		A4(
			$elm$json$Json$Decode$map3,
			$dillonkearns$elm_graphql$Graphql$Http$GraphqlError$GraphqlError,
			A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string),
			$elm$json$Json$Decode$maybe(
				A2(
					$elm$json$Json$Decode$field,
					'locations',
					$elm$json$Json$Decode$list($dillonkearns$elm_graphql$Graphql$Http$GraphqlError$locationDecoder))),
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Dict$remove('locations'),
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Dict$remove('message'),
					$elm$json$Json$Decode$dict($elm$json$Json$Decode$value))))));
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $dillonkearns$elm_graphql$Graphql$Http$decodeErrorWithData = function (data) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Result$Err,
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Tuple$pair(data),
			$dillonkearns$elm_graphql$Graphql$Http$GraphqlError$decoder));
};
var $dillonkearns$elm_graphql$Graphql$Http$nullJsonValue = function (a) {
	nullJsonValue:
	while (true) {
		var _v0 = A2($elm$json$Json$Decode$decodeString, $elm$json$Json$Decode$value, 'null');
		if (!_v0.$) {
			var value = _v0.a;
			return value;
		} else {
			var $temp$a = 0;
			a = $temp$a;
			continue nullJsonValue;
		}
	}
};
var $dillonkearns$elm_graphql$Graphql$Http$errorDecoder = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$andThen,
				$dillonkearns$elm_graphql$Graphql$Http$decodeErrorWithData,
				A2($elm$json$Json$Decode$map, $dillonkearns$elm_graphql$Graphql$Http$GraphqlError$ParsedData, decoder)),
				A2(
				$elm$json$Json$Decode$andThen,
				$dillonkearns$elm_graphql$Graphql$Http$decodeErrorWithData,
				A2(
					$elm$json$Json$Decode$map,
					$dillonkearns$elm_graphql$Graphql$Http$GraphqlError$UnparsedData,
					A2($elm$json$Json$Decode$field, 'data', $elm$json$Json$Decode$value))),
				A2(
				$elm$json$Json$Decode$andThen,
				$dillonkearns$elm_graphql$Graphql$Http$decodeErrorWithData,
				$elm$json$Json$Decode$succeed(
					$dillonkearns$elm_graphql$Graphql$Http$GraphqlError$UnparsedData(
						$dillonkearns$elm_graphql$Graphql$Http$nullJsonValue(0))))
			]));
};
var $dillonkearns$elm_graphql$Graphql$Http$decoderOrError = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$dillonkearns$elm_graphql$Graphql$Http$errorDecoder(decoder),
				A2($elm$json$Json$Decode$map, $elm$core$Result$Ok, decoder)
			]));
};
var $dillonkearns$elm_graphql$Graphql$Document$serializeMutation = function (_v0) {
	var fields = _v0.a;
	var decoder_ = _v0.b;
	return A2($dillonkearns$elm_graphql$Graphql$Document$serialize, 'mutation', fields);
};
var $dillonkearns$elm_graphql$Graphql$Document$serializeMutationWithOperationName = F2(
	function (operationName, _v0) {
		var fields = _v0.a;
		var decoder_ = _v0.b;
		return A3($dillonkearns$elm_graphql$Graphql$Document$serializeWithOperationName, 'mutation', operationName, fields);
	});
var $dillonkearns$elm_graphql$Graphql$Http$toReadyRequest = function (_v0) {
	var request = _v0;
	var _v1 = request.qQ;
	if (!_v1.$) {
		var forcedRequestMethod = _v1.a;
		var querySelectionSet = _v1.b;
		var queryRequestDetails = A5(
			$dillonkearns$elm_graphql$Graphql$Http$QueryHelper$build,
			function () {
				if (!forcedRequestMethod.$) {
					if (!forcedRequestMethod.a) {
						var _v4 = forcedRequestMethod.a;
						return $elm$core$Maybe$Just(0);
					} else {
						var _v5 = forcedRequestMethod.a;
						return $elm$core$Maybe$Nothing;
					}
				} else {
					return $elm$core$Maybe$Just(1);
				}
			}(),
			request.n5,
			request.r2,
			request.kj,
			querySelectionSet);
		return {
			sY: queryRequestDetails.sY,
			qN: $dillonkearns$elm_graphql$Graphql$Http$decoderOrError(request.Cy),
			CN: request.CN,
			my: function () {
				var _v2 = queryRequestDetails.my;
				if (!_v2) {
					return 'GET';
				} else {
					return 'Post';
				}
			}(),
			nE: request.nE,
			GT: queryRequestDetails.GT
		};
	} else {
		var mutationSelectionSet = _v1.a;
		var serializedMutation = function () {
			var _v7 = request.kj;
			if (!_v7.$) {
				var operationName = _v7.a;
				return A2($dillonkearns$elm_graphql$Graphql$Document$serializeMutationWithOperationName, operationName, mutationSelectionSet);
			} else {
				return $dillonkearns$elm_graphql$Graphql$Document$serializeMutation(mutationSelectionSet);
			}
		}();
		return {
			sY: $elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					A2(
						$elm$core$List$append,
						_List_fromArray(
							[
								_Utils_Tuple2(
								'query',
								$elm$json$Json$Encode$string(serializedMutation))
							]),
						function () {
							var _v6 = request.kj;
							if (!_v6.$) {
								var operationName = _v6.a;
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'operationName',
										$elm$json$Json$Encode$string(operationName))
									]);
							} else {
								return _List_Nil;
							}
						}()))),
			qN: $dillonkearns$elm_graphql$Graphql$Http$decoderOrError(request.Cy),
			CN: request.CN,
			my: 'POST',
			nE: request.nE,
			GT: A2($dillonkearns$elm_graphql$Graphql$Http$QueryParams$urlWithQueryParams, request.r2, request.n5)
		};
	}
};
var $dillonkearns$elm_graphql$Graphql$Http$resolver = function (request) {
	return $dillonkearns$elm_graphql$Graphql$Http$jsonResolver(
		$dillonkearns$elm_graphql$Graphql$Http$toReadyRequest(request).qN);
};
var $elm$http$Http$riskyTask = function (r) {
	return A3(
		_Http_toTask,
		0,
		$elm$http$Http$resultToTask,
		{A5: true, sY: r.sY, Cy: r.nj, CN: r.CN, my: r.my, nE: r.nE, GL: $elm$core$Maybe$Nothing, GT: r.GT});
};
var $dillonkearns$elm_graphql$Graphql$Http$toTask = function (fullRequest) {
	var request = fullRequest;
	return A2(
		$elm$core$Task$andThen,
		$dillonkearns$elm_graphql$Graphql$Http$failTaskOnHttpSuccessWithErrors,
		A2(
			$elm$core$Task$mapError,
			$dillonkearns$elm_graphql$Graphql$Http$HttpError,
			function (readyRequest) {
				return (request.kK ? $elm$http$Http$riskyTask : $elm$http$Http$task)(
					{
						sY: readyRequest.sY,
						CN: readyRequest.CN,
						my: readyRequest.my,
						nj: $dillonkearns$elm_graphql$Graphql$Http$resolver(fullRequest),
						nE: readyRequest.nE,
						GT: readyRequest.GT
					});
			}(
				$dillonkearns$elm_graphql$Graphql$Http$toReadyRequest(fullRequest))));
};
var $dillonkearns$elm_graphql$Graphql$Http$Request = $elm$core$Basics$identity;
var $dillonkearns$elm_graphql$Graphql$Http$withHeader = F3(
	function (key, value, _v0) {
		var request = _v0;
		return _Utils_update(
			request,
			{
				CN: A2(
					$elm$core$List$cons,
					A2($elm$http$Http$header, key, value),
					request.CN)
			});
	});
var $dillonkearns$elm_graphql$Graphql$Http$withOperationName = F2(
	function (operationName, _v0) {
		var request = _v0;
		return _Utils_update(
			request,
			{
				kj: $elm$core$Maybe$Just(operationName)
			});
	});
var $dillonkearns$elm_graphql$Graphql$Http$withQueryParams = F2(
	function (additionalQueryParams, _v0) {
		var request = _v0;
		return _Utils_update(
			request,
			{
				r2: _Utils_ap(request.r2, additionalQueryParams)
			});
	});
var $author$project$GraphQL$Utils$makeRequest = F7(
	function (requestHelper, mode, creds, apiType, headers, operationName, query) {
		var token = $author$project$Protected$getToken(creds);
		var setHeaders = function (request) {
			return A3(
				$elm$core$List$foldr,
				$elm_community$basics_extra$Basics$Extra$uncurry($dillonkearns$elm_graphql$Graphql$Http$withHeader),
				request,
				function () {
					if (token === '') {
						return headers;
					} else {
						var t = token;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2('authorization', 'Bearer ' + t),
							headers);
					}
				}());
		};
		return A2(
			$elm$core$Task$mapError,
			A2(
				$author$project$GraphQL$Utils$graphqlErrorToHttpError,
				mode,
				$author$project$GraphQL$Utils$apiToUrl(apiType)),
			$dillonkearns$elm_graphql$Graphql$Http$toTask(
				A2(
					$dillonkearns$elm_graphql$Graphql$Http$withQueryParams,
					_List_fromArray(
						[
							_Utils_Tuple2('operation', operationName)
						]),
					A2(
						$dillonkearns$elm_graphql$Graphql$Http$withOperationName,
						operationName,
						setHeaders(
							A2(
								requestHelper,
								$author$project$GraphQL$Utils$apiToUrl(apiType),
								query))))));
	});
var $dillonkearns$elm_graphql$Graphql$Http$Mutation = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Document$decoder = function (_v0) {
	var fields = _v0.a;
	var decoder_ = _v0.b;
	return A2($elm$json$Json$Decode$field, 'data', decoder_);
};
var $dillonkearns$elm_graphql$Graphql$Http$mutationRequest = F2(
	function (baseUrl, mutationSelectionSet) {
		return {
			n5: baseUrl,
			qQ: $dillonkearns$elm_graphql$Graphql$Http$Mutation(mutationSelectionSet),
			Cy: $dillonkearns$elm_graphql$Graphql$Document$decoder(mutationSelectionSet),
			CN: _List_Nil,
			kj: $elm$core$Maybe$Nothing,
			r2: _List_Nil,
			nE: $elm$core$Maybe$Nothing,
			kK: false
		};
	});
var $author$project$GraphQL$Utils$mutationRequest = A2($author$project$GraphQL$Utils$makeRequest, $dillonkearns$elm_graphql$Graphql$Http$mutationRequest, 0);
var $author$project$Model$BuildPlanner$Error$AlreadyExistsError$AlreadyExistsError = $elm$core$Basics$identity;
var $author$project$Model$BuildPlanner$Error$AlreadyExistsError$Data = F3(
	function (type_, resource, message) {
		return {Eh: message, gB: resource, gR: type_};
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$leaf = F2(
	function (details, args) {
		return A2($dillonkearns$elm_graphql$Graphql$RawField$Leaf, details, args);
	});
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField = F4(
	function (typeString, fieldName, args, decoder) {
		var newLeaf = A2(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$leaf,
			{yk: fieldName, GP: typeString},
			args);
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			_List_fromArray(
				[newLeaf]),
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2($elm$json$Json$Decode$field, fieldName, decoder),
						A2(
						$elm$json$Json$Decode$field,
						$dillonkearns$elm_graphql$Graphql$Document$Field$hashedAliasName(newLeaf),
						decoder)
					])));
	});
var $author$project$BuildPlanner$Object$AlreadyExists$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$AlreadyExists$resource = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'resource', _List_Nil, $elm$json$Json$Decode$string);
var $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed = function (constructor) {
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
		_List_Nil,
		$elm$json$Json$Decode$succeed(constructor));
};
var $author$project$BuildPlanner$Object$AlreadyExists$type_ = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'type', _List_Nil, $elm$json$Json$Decode$string);
var $dillonkearns$elm_graphql$Graphql$SelectionSet$with = F2(
	function (_v0, _v1) {
		var selectionFields1 = _v0.a;
		var selectionDecoder1 = _v0.b;
		var selectionFields2 = _v1.a;
		var selectionDecoder2 = _v1.b;
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			_Utils_ap(selectionFields1, selectionFields2),
			A3($elm$json$Json$Decode$map2, $elm$core$Basics$apR, selectionDecoder1, selectionDecoder2));
	});
var $author$project$Model$BuildPlanner$Error$AlreadyExistsError$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$elm$core$Basics$identity,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$AlreadyExists$message,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$BuildPlanner$Object$AlreadyExists$resource,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$BuildPlanner$Object$AlreadyExists$type_,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$Error$AlreadyExistsError$Data)))));
var $author$project$Model$BuildPlanner$Error$ForbiddenError$Data = F3(
	function (operation, resource, message) {
		return {Eh: message, EX: operation, gB: resource};
	});
var $author$project$Model$BuildPlanner$Error$ForbiddenError$ForbiddenError = $elm$core$Basics$identity;
var $author$project$BuildPlanner$Object$Forbidden$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$Forbidden$operation = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'operation', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$Forbidden$resource = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'resource', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Model$BuildPlanner$Error$ForbiddenError$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$elm$core$Basics$identity,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$Forbidden$message,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$BuildPlanner$Object$Forbidden$resource,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$BuildPlanner$Object$Forbidden$operation,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$Error$ForbiddenError$Data)))));
var $author$project$Model$BuildPlanner$Error$InvalidInputError$Data = function (message) {
	return {Eh: message};
};
var $author$project$Model$BuildPlanner$Error$InvalidInputError$InvalidInputError = $elm$core$Basics$identity;
var $author$project$BuildPlanner$Object$InvalidInput$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Model$BuildPlanner$Error$InvalidInputError$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$elm$core$Basics$identity,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$InvalidInput$message,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$Error$InvalidInputError$Data)));
var $author$project$Model$BuildPlanner$Error$NotFoundError$Data = F4(
	function (type_, resource, message, mayNeedAuthentication) {
		return {Ed: mayNeedAuthentication, Eh: message, gB: resource, gR: type_};
	});
var $author$project$Model$BuildPlanner$Error$NotFoundError$NotFoundError = $elm$core$Basics$identity;
var $author$project$BuildPlanner$Object$NotFound$mayNeedAuthentication = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'mayNeedAuthentication', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$BuildPlanner$Object$NotFound$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$NotFound$resource = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'resource', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$NotFound$type_ = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'type', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Model$BuildPlanner$Error$NotFoundError$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$elm$core$Basics$identity,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$NotFound$mayNeedAuthentication,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$BuildPlanner$Object$NotFound$message,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$BuildPlanner$Object$NotFound$resource,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$BuildPlanner$Object$NotFound$type_,
					$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$Error$NotFoundError$Data))))));
var $author$project$Model$BuildPlanner$Error$ParseError$Data = F2(
	function (path, message) {
		return {Eh: message, pm: path};
	});
var $author$project$Model$BuildPlanner$Error$ParseError$ParseError = $elm$core$Basics$identity;
var $author$project$BuildPlanner$Object$ParseError$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$ParseError$path = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'path', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Model$BuildPlanner$Error$ParseError$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$elm$core$Basics$identity,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$ParseError$message,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$BuildPlanner$Object$ParseError$path,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$Error$ParseError$Data))));
var $author$project$Model$BuildPlanner$Error$ValidationError$Data = function (message) {
	return {Eh: message};
};
var $author$project$Model$BuildPlanner$Error$ValidationError$ValidationError = $elm$core$Basics$identity;
var $author$project$BuildPlanner$Object$ValidationError$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Model$BuildPlanner$Error$ValidationError$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$elm$core$Basics$identity,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$ValidationError$message,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$Error$ValidationError$Data)));
var $author$project$Model$BuildPlanner$BuildPlannerError$HttpError = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$BuildPlanner$BuildPlannerError$simplifyTask = A2(
	$elm$core$Basics$composeR,
	$elm$core$Task$mapError($author$project$Model$BuildPlanner$BuildPlannerError$HttpError),
	$elm$core$Task$andThen(
		function (res) {
			if (res.$ === 1) {
				var err = res.a;
				return $elm$core$Task$fail(err);
			} else {
				var ok = res.a;
				return $elm$core$Task$succeed(ok);
			}
		}));
var $author$project$Request$BuildPlanner$createProject = F2(
	function (creds, input) {
		var selectionSetOnCreateProjectResult = $author$project$BuildPlanner$Union$CreateProjectResult$fragments(
			{
				uX: A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Model$BuildPlanner$BuildPlannerError$AlreadyExistsError),
					$author$project$Model$BuildPlanner$Error$AlreadyExistsError$selectionSet),
				vc: A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Model$BuildPlanner$BuildPlannerError$ForbiddenError),
					$author$project$Model$BuildPlanner$Error$ForbiddenError$selectionSet),
				vj: A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Model$BuildPlanner$BuildPlannerError$InvalidInputError),
					$author$project$Model$BuildPlanner$Error$InvalidInputError$selectionSet),
				vp: A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Model$BuildPlanner$BuildPlannerError$NotFoundError),
					$author$project$Model$BuildPlanner$Error$NotFoundError$selectionSet),
				vq: A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Model$BuildPlanner$BuildPlannerError$ParseError),
					$author$project$Model$BuildPlanner$Error$ParseError$selectionSet),
				vu: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(
					$elm$core$Result$Ok(0)),
				vC: A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Model$BuildPlanner$BuildPlannerError$ValidationError),
					$author$project$Model$BuildPlanner$Error$ValidationError$selectionSet)
			});
		return $author$project$Model$BuildPlanner$BuildPlannerError$simplifyTask(
			A5(
				$author$project$GraphQL$Utils$mutationRequest,
				creds,
				4,
				_List_Nil,
				'CreateProject',
				A2(
					$author$project$BuildPlanner$Mutation$createProject,
					{
						$7: $author$project$Request$BuildPlanner$convertCreateProjectInput(input)
					},
					selectionSetOnCreateProjectResult)));
	});
var $author$project$Pages$CreateProject$NoOp = {$: 0};
var $author$project$Pages$CreateProject$focusNameField = A2(
	$elm$core$Task$attempt,
	$elm$core$Basics$always($author$project$Pages$CreateProject$NoOp),
	$elm$browser$Browser$Dom$focus('project-name'));
var $elm$core$Maybe$destruct = F3(
	function (_default, func, maybe) {
		if (!maybe.$) {
			var a = maybe.a;
			return func(a);
		} else {
			return _default;
		}
	});
var $author$project$Ports$scrollIntoView = _Platform_outgoingPort(
	'scrollIntoView',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'location',
					function ($) {
						return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, $);
					}($.fD)),
					_Utils_Tuple2(
					'selector',
					$elm$json$Json$Encode$string($.z0))
				]));
	});
var $author$project$Pages$CreateProject$focusPlatformField = $author$project$Ports$scrollIntoView(
	{fD: $elm$core$Maybe$Nothing, z0: '#platform-selector'});
var $elm$core$Set$foldl = F3(
	function (func, initialState, _v0) {
		var dict = _v0;
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (key, _v1, state) {
					return A2(func, key, state);
				}),
			initialState,
			dict);
	});
var $author$project$Validation$alphaNumericAndDotsHyphens = _List_fromArray(
	[
		_Utils_Tuple2('[^.A-Za-z0-9]+', '-'),
		_Utils_Tuple2('-$', ''),
		_Utils_Tuple2('^-', '')
	]);
var $author$project$Validation$applyRegex = F2(
	function (_v0, name) {
		var match = _v0.a;
		var replace = _v0.b;
		var _v1 = $elm$regex$Regex$fromString(match);
		if (_v1.$ === 1) {
			return name;
		} else {
			var regex = _v1.a;
			return A3(
				$elm$regex$Regex$replace,
				regex,
				$elm$core$Basics$always(replace),
				name);
		}
	});
var $author$project$Validation$formatProjectName = function (name) {
	return A3($elm$core$List$foldl, $author$project$Validation$applyRegex, name, $author$project$Validation$alphaNumericAndDotsHyphens);
};
var $author$project$Model$Editor$getFieldsOriginal = function (_v0) {
	var internal = _v0;
	return internal.jl;
};
var $author$project$Model$Editor$getFieldOriginal = function (getter) {
	return A2($elm$core$Basics$composeR, $author$project$Model$Editor$getFieldsOriginal, getter);
};
var $author$project$Model$Editor$getFieldEditor = F2(
	function (getter, editor) {
		return {
			g5: A2($author$project$Model$Editor$getField, getter, editor),
			jl: A2($author$project$Model$Editor$getFieldOriginal, getter, editor)
		};
	});
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$getSolve = $author$project$Model$Editor$getFieldEditor(
	function ($) {
		return $.sr;
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$getBuildExprSolveEditor = F2(
	function (func, editor) {
		return func(
			$author$project$Model$BuildPlanner$BuildExprEditor$Simple$getSolve(editor));
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$languagesGetter = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.FF;
	},
	function ($) {
		return $.aM;
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$getLanguages = $author$project$Model$BuildPlanner$SolveLegacyEditor$getBuildExprSolveEditor(
	$author$project$Model$Editor$getField($author$project$Model$BuildPlanner$SolveLegacyEditor$languagesGetter));
var $author$project$Model$BuildPlanner$SolveLegacyEditor$getPlatforms = $author$project$Model$BuildPlanner$SolveLegacyEditor$getBuildExprSolveEditor(
	$author$project$Model$Editor$getField(
		function ($) {
			return $.Fh;
		}));
var $author$project$Views$PlatformSelectorSimple$platformNameToString = function (name) {
	switch (name) {
		case 2:
			return 'MacOS';
		case 1:
			return 'Linux';
		default:
			return 'Windows';
	}
};
var $author$project$Views$PlatformSelectorSimple$generateNames = function (_v0) {
	var windows = _v0.hZ;
	var macos = _v0.gq;
	var linux = _v0.hz;
	return A2(
		$elm$core$String$join,
		'-',
		A2(
			$elm$core$List$concatMap,
			function (_v1) {
				var name = _v1.a;
				var distro = _v1.b;
				var selected = _v1.d;
				if (selected) {
					var distroSuffix = function () {
						if (name === 1) {
							return _List_fromArray(
								[distro]);
						} else {
							return _List_Nil;
						}
					}();
					return A2(
						$elm$core$List$cons,
						$author$project$Views$PlatformSelectorSimple$platformNameToString(name),
						distroSuffix);
				} else {
					return _List_Nil;
				}
			},
			_List_fromArray(
				[windows, macos, linux])));
};
var $author$project$Validation$maxProjectNameLength = 40;
var $elm_community$string_extra$String$Extra$changeCase = F2(
	function (mutator, word) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var head = _v0.a;
					var tail = _v0.b;
					return A2(
						$elm$core$String$cons,
						mutator(head),
						tail);
				},
				$elm$core$String$uncons(word)));
	});
var $elm$core$Char$toUpper = _Char_toUpper;
var $elm_community$string_extra$String$Extra$toSentenceCase = function (word) {
	return A2($elm_community$string_extra$String$Extra$changeCase, $elm$core$Char$toUpper, word);
};
var $author$project$Pages$CreateProject$generateProjectTitle = F2(
	function (platformSelection, editor) {
		var platformsString = $author$project$Views$PlatformSelectorSimple$generateNames(platformSelection);
		var constraintSuffix = function (constraint) {
			if (constraint.$ === 1) {
				var version = constraint.a;
				return '-' + version;
			} else {
				return '';
			}
		};
		var languagesString = A2(
			$elm$core$String$join,
			'-',
			A2(
				$elm$core$List$map,
				function (_v0) {
					var name = _v0.a;
					var constraint = _v0.b;
					return _Utils_ap(
						$elm_community$string_extra$String$Extra$toSentenceCase(name),
						constraintSuffix(constraint));
				},
				$elm$core$Dict$toList(
					$author$project$Model$BuildPlanner$SolveLegacyEditor$getLanguages(editor))));
		var projectName = A2(
			$elm$core$String$join,
			'-',
			_List_fromArray(
				[languagesString, platformsString]));
		var title = A2(
			$elm$core$String$left,
			$author$project$Validation$maxProjectNameLength,
			$author$project$Validation$formatProjectName(projectName));
		return (title === '') ? 'New-Project' : title;
	});
var $author$project$Pages$CreateProject$getProjectNameOrGenerated = function (model) {
	var _v0 = model.vT;
	if (!_v0.$) {
		var projectName = _v0.a;
		return projectName;
	} else {
		return A2($author$project$Pages$CreateProject$generateProjectTitle, model.hK, model.qR);
	}
};
var $author$project$Model$Organization$getUrlName = function ($) {
	return $.AC;
};
var $author$project$Model$BuildPlanner$BuildExpr$PackagerKind$LinuxInstaller = 1;
var $author$project$Model$BuildPlanner$BuildExpr$PackagerKind$WindowsInstaller = 2;
var $elm_community$dict_extra$Dict$Extra$filterMap = F2(
	function (f, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, acc) {
					var _v0 = A2(f, k, v);
					if (!_v0.$) {
						var newVal = _v0.a;
						return A3($elm$core$Dict$insert, k, newVal, acc);
					} else {
						return acc;
					}
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $elm_community$basics_extra$Basics$Extra$flip = F3(
	function (f, b, a) {
		return A2(f, a, b);
	});
var $author$project$Misc$memberOf = $elm_community$basics_extra$Basics$Extra$flip($elm$core$List$member);
var $author$project$Model$BuildPlanner$BuildExpr$PackagerKind$AuthenticodeSignature = 4;
var $author$project$Model$BuildPlanner$BuildExpr$PackagerKind$Docker = 0;
var $author$project$Model$BuildPlanner$BuildExpr$PackagerKind$RelocateAndZip = 3;
var $author$project$Model$BuildPlanner$BuildExpr$PackagerKind$optionsByPlatform = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'7c998ec2-7491-4e75-be4d-8885800ef5f2',
			_List_fromArray(
				[0, 1])),
			_Utils_Tuple2(
			'0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a',
			_List_fromArray(
				[1])),
			_Utils_Tuple2(
			'1a44e57a-cdb2-5631-8c94-1eb83401038e',
			_List_fromArray(
				[2, 3, 4])),
			_Utils_Tuple2(
			'78977bc8-0f32-519d-80f3-9043f059398c',
			_List_fromArray(
				[2, 3, 4]))
		]));
var $author$project$Model$BuildPlanner$BuildExpr$PackagerKind$installerByPlatform = A2(
	$elm_community$dict_extra$Dict$Extra$filterMap,
	F2(
		function (_v0, kinds) {
			return A2(
				$elm_community$list_extra$List$Extra$find,
				$author$project$Misc$memberOf(
					_List_fromArray(
						[1, 2])),
				kinds);
		}),
	$author$project$Model$BuildPlanner$BuildExpr$PackagerKind$optionsByPlatform);
var $elm$core$Dict$isEmpty = function (dict) {
	if (dict.$ === -2) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Set$isEmpty = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$isEmpty(dict);
};
var $author$project$Model$Visibility$Private = 0;
var $author$project$Model$Visibility$isPrivate = function (visibility) {
	return !visibility;
};
var $author$project$Model$LanguageVersions$getName = function (_v0) {
	var contents = _v0;
	return contents.w;
};
var $author$project$Views$LanguageSelectorSimple$languageName = function (selectedLanguages) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$author$project$Model$LanguageVersions$getName,
			$elm$core$List$head(selectedLanguages)));
};
var $author$project$Model$Language$C = 4;
var $author$project$Model$Language$Go = 5;
var $author$project$Model$Language$Java = 6;
var $author$project$Model$Language$Perl = 0;
var $author$project$Model$Language$Python = 1;
var $author$project$Model$Language$Ruby = 3;
var $author$project$Model$Language$Tcl = 2;
var $author$project$Model$Language$fromString = function (language) {
	var _v0 = $elm$core$String$toLower(language);
	switch (_v0) {
		case 'perl':
			return $elm$core$Maybe$Just(0);
		case 'python':
			return $elm$core$Maybe$Just(1);
		case 'tcl':
			return $elm$core$Maybe$Just(2);
		case 'ruby':
			return $elm$core$Maybe$Just(3);
		case 'c':
			return $elm$core$Maybe$Just(4);
		case 'java':
			return $elm$core$Maybe$Just(6);
		case 'go':
			return $elm$core$Maybe$Just(5);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$Language$supportsInstaller = function (languageName) {
	var _v0 = $author$project$Model$Language$fromString(languageName);
	_v0$3:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 1:
					var _v1 = _v0.a;
					return true;
				case 0:
					var _v2 = _v0.a;
					return true;
				case 3:
					var _v3 = _v0.a;
					return true;
				default:
					break _v0$3;
			}
		} else {
			break _v0$3;
		}
	}
	return false;
};
var $author$project$Model$BuildPlanner$BuildExpr$BuildExprLet = function (a) {
	return {$: 7, a: a};
};
var $author$project$Model$BuildPlanner$BuildExpr$BuildExprVar = function (a) {
	return {$: 5, a: a};
};
var $author$project$Model$BuildPlanner$BuildExpr$Var$Var = $elm$core$Basics$identity;
var $author$project$Pipeline$run = F2(
	function (_v0, ctx) {
		var impl = _v0;
		return impl(ctx);
	});
var $author$project$Pipeline$Pipeline = $elm$core$Basics$identity;
var $author$project$Pipeline$andThen = F2(
	function (func, pA) {
		return function (ctx0) {
			var _v0 = A2($author$project$Pipeline$run, pA, ctx0);
			var ctx1 = _v0.a;
			var res = _v0.b;
			if (res.$ === 1) {
				var err = res.a;
				return _Utils_Tuple2(
					ctx1,
					$elm$core$Result$Err(err));
			} else {
				var a = res.a;
				return A2(
					$author$project$Pipeline$run,
					func(a),
					ctx1);
			}
		};
	});
var $author$project$Pipeline$andThen2 = F3(
	function (func, pA, pB) {
		return A2(
			$author$project$Pipeline$andThen,
			function (a) {
				return A2(
					$author$project$Pipeline$andThen,
					func(a),
					pB);
			},
			pA);
	});
var $author$project$Pipeline$andThen3 = F4(
	function (func, pA, pB, pC) {
		return A3(
			$author$project$Pipeline$andThen2,
			F2(
				function (a, b) {
					return A2(
						$author$project$Pipeline$andThen,
						A2(func, a, b),
						pC);
				}),
			pA,
			pB);
	});
var $author$project$Pipeline$andThen4 = F5(
	function (func, pA, pB, pC, pD) {
		return A4(
			$author$project$Pipeline$andThen3,
			F3(
				function (a, b, c) {
					return A2(
						$author$project$Pipeline$andThen,
						A3(func, a, b, c),
						pD);
				}),
			pA,
			pB,
			pC);
	});
var $author$project$Pipeline$succeed = function (value) {
	return function (ctx) {
		return _Utils_Tuple2(
			ctx,
			$elm$core$Result$Ok(value));
	};
};
var $author$project$Pipeline$map4 = function (func) {
	return $author$project$Pipeline$andThen4(
		F4(
			function (a, b, c, d) {
				return $author$project$Pipeline$succeed(
					A4(func, a, b, c, d));
			}));
};
var $author$project$Model$BuildPlanner$BuildExpr$BuildExprApp = function (a) {
	return {$: 8, a: a};
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$AddMissingSources$uneval = F2(
	function (src, dest) {
		return $author$project$Model$BuildPlanner$BuildExpr$BuildExprApp(
			{
				kO: $elm$core$Dict$fromList(
					_List_fromArray(
						[
							_Utils_Tuple2('src', src),
							_Utils_Tuple2('dest', dest)
						])),
				w: 'add_missing_sources'
			});
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$CommunityArtifacts$uneval = function (src) {
	return $author$project$Model$BuildPlanner$BuildExpr$BuildExprApp(
		{
			kO: $elm$core$Dict$fromList(
				_List_fromArray(
					[
						_Utils_Tuple2('src', src)
					])),
			w: 'community_artifacts'
		});
};
var $author$project$Model$BuildPlanner$BuildExpr$BuildExprList = function (a) {
	return {$: 6, a: a};
};
var $author$project$Model$BuildPlanner$BuildExpr$BuildExprString = function (a) {
	return {$: 4, a: a};
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$DependencyLink$uneval = function (dependencyLink) {
	return $author$project$Model$BuildPlanner$BuildExpr$BuildExprApp(
		{
			kO: $elm$core$Dict$fromList(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'purl',
						$author$project$Model$BuildPlanner$BuildExpr$BuildExprString(dependencyLink.k)),
						_Utils_Tuple2(
						'depends_on_purl',
						$author$project$Model$BuildPlanner$BuildExpr$BuildExprString(dependencyLink.Ce)),
						_Utils_Tuple2(
						'type',
						$author$project$Model$BuildPlanner$BuildExpr$BuildExprString(dependencyLink.gR))
					])),
			w: 'DependencyLink'
		});
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$unevalAtTime = function (maybeAtTime) {
	if (maybeAtTime.$ === 1) {
		return $author$project$Model$BuildPlanner$BuildExpr$BuildExprVar('at_time');
	} else {
		var atTime = maybeAtTime.a;
		return $author$project$Model$BuildPlanner$BuildExpr$BuildExprString(
			$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(atTime));
	}
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$GenericSBOM$uneval = function (genericSBOM) {
	return $author$project$Model$BuildPlanner$BuildExpr$BuildExprApp(
		{
			kO: $elm$core$Dict$fromList(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'at_time',
						$author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$unevalAtTime(genericSBOM.jE)),
						_Utils_Tuple2(
						'name',
						$author$project$Model$BuildPlanner$BuildExpr$BuildExprString(genericSBOM.w)),
						_Utils_Tuple2(
						'url',
						$author$project$Model$BuildPlanner$BuildExpr$BuildExprString(genericSBOM.GT)),
						_Utils_Tuple2(
						'contents',
						$author$project$Model$BuildPlanner$BuildExpr$BuildExprList(
							A2($elm$core$List$map, $author$project$Model$BuildPlanner$BuildExpr$BuildExprString, genericSBOM.xM))),
						_Utils_Tuple2(
						'dependency_links',
						$author$project$Model$BuildPlanner$BuildExpr$BuildExprList(
							A2($elm$core$List$map, $author$project$Model$BuildPlanner$BuildExpr$Eval$DependencyLink$uneval, genericSBOM.Cd)))
					])),
			w: 'generic_sbom'
		});
};
var $author$project$Model$BuildPlanner$BuildExpr$BuildExprInt = function (a) {
	return {$: 2, a: a};
};
var $elm_community$maybe_extra$Maybe$Extra$toList = function (m) {
	if (m.$ === 1) {
		return _List_Nil;
	} else {
		var x = m.a;
		return _List_fromArray(
			[x]);
	}
};
var $author$project$Misc$encodeOptionalField = F3(
	function (encoder, name, value) {
		return $elm_community$maybe_extra$Maybe$Extra$toList(
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					encoder,
					$elm$core$Tuple$pair(name)),
				value));
	});
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$And = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$Constraint = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ConstraintAny = {$: 0};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$Eq = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$Gt = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$Gte = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$Lt = function (a) {
	return {$: 4, a: a};
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$Lte = function (a) {
	return {$: 5, a: a};
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$Ne = function (a) {
	return {$: 6, a: a};
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$fromVersionRequirement = function (_v0) {
	var comparator = _v0.h;
	var version = _v0.aI;
	var _v1 = $elm$core$String$toLower(comparator);
	switch (_v1) {
		case 'eq':
			return $elm$core$Maybe$Just(
				$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$Eq(version));
		case 'gt':
			return $elm$core$Maybe$Just(
				$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$Gt(version));
		case 'gte':
			return $elm$core$Maybe$Just(
				$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$Gte(version));
		case 'lt':
			return $elm$core$Maybe$Just(
				$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$Lt(version));
		case 'lte':
			return $elm$core$Maybe$Just(
				$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$Lte(version));
		case 'ne':
			return $elm$core$Maybe$Just(
				$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$Ne(version));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$fromVersionRequirements = function (versionRequirements) {
	var _v0 = $elm$core$List$reverse(
		A2($elm$core$List$filterMap, $author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$fromVersionRequirement, versionRequirements));
	if (!_v0.b) {
		return $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ConstraintAny;
	} else {
		var last = _v0.a;
		var init = _v0.b;
		return $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$Constraint(
			A3($elm$core$List$foldl, $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$And, last, init));
	}
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Req$fromRequirement = function (req) {
	return {
		w: req.w,
		aE: req.aE,
		aI: $author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$fromVersionRequirements(req.gW)
	};
};
var $author$project$Model$BuildPlanner$BuildExpr$Solve$Requirement$KeyAndConstraint = F2(
	function (key, constraint) {
		return {bK: constraint, Y: key};
	});
var $author$project$Model$Namespace$getName = $elm$core$Tuple$second;
var $author$project$Model$Namespace$getNamespace = $elm$core$Tuple$first;
var $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$getPinned = function (constraint) {
	if (constraint.$ === 3) {
		var ingredientVersion = constraint.a;
		return $elm$core$Maybe$Just(ingredientVersion);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$toVersionRequirements = function (constraint) {
	switch (constraint.$) {
		case 0:
			return _List_Nil;
		case 1:
			var version = constraint.a;
			return _List_fromArray(
				[
					{h: 'eq', aI: version}
				]);
		case 2:
			var first = constraint.a;
			var others = constraint.b;
			return A2($elm$core$List$cons, first, others);
		default:
			return _List_Nil;
	}
};
var $author$project$Model$BuildPlanner$BuildExpr$Solve$Requirement$fromKeyAndConstraint = function (_v0) {
	var key = _v0.Y;
	var constraint = _v0.bK;
	return {
		CX: $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$getPinned(constraint),
		w: $author$project$Model$Namespace$getName(key),
		aE: $author$project$Model$Namespace$getNamespace(key),
		gW: $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$toVersionRequirements(constraint)
	};
};
var $author$project$Model$Namespace$language = 'language';
var $author$project$Model$BuildPlanner$BuildExpr$SolveEditor$requirementsToList = function (requirements) {
	var accumKeyConstraint = F3(
		function (key, constraint, acc) {
			return A2(
				$elm$core$List$cons,
				$author$project$Model$BuildPlanner$BuildExpr$Solve$Requirement$fromKeyAndConstraint(
					A2($author$project$Model$BuildPlanner$BuildExpr$Solve$Requirement$KeyAndConstraint, key, constraint)),
				acc);
		});
	var accumLanguage = F2(
		function (name, version) {
			return A2(
				accumKeyConstraint,
				_Utils_Tuple2($author$project$Model$Namespace$language, name),
				version);
		});
	return A3(
		$elm_community$basics_extra$Basics$Extra$flip,
		$elm$core$Dict$foldr(accumLanguage),
		requirements.aM,
		A3(
			$elm_community$basics_extra$Basics$Extra$flip,
			$elm$core$Dict$foldr(accumKeyConstraint),
			requirements.k5,
			A3(
				$elm_community$basics_extra$Basics$Extra$flip,
				$elm$core$Dict$foldr(accumKeyConstraint),
				requirements.mY,
				A3(
					$elm_community$basics_extra$Basics$Extra$flip,
					$elm$core$Dict$foldr(accumKeyConstraint),
					requirements.oI,
					_List_Nil))));
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$unevalPred = function (pred) {
	var _v0 = function () {
		switch (pred.$) {
			case 0:
				var left = pred.a;
				var right = pred.b;
				return _Utils_Tuple2(
					'And',
					_List_fromArray(
						[
							_Utils_Tuple2(
							'left',
							$author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$unevalPred(left)),
							_Utils_Tuple2(
							'right',
							$author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$unevalPred(right))
						]));
			case 1:
				var value = pred.a;
				return _Utils_Tuple2(
					'Eq',
					_List_fromArray(
						[
							_Utils_Tuple2(
							'value',
							$author$project$Model$BuildPlanner$BuildExpr$BuildExprString(value))
						]));
			case 2:
				var value = pred.a;
				return _Utils_Tuple2(
					'Gt',
					_List_fromArray(
						[
							_Utils_Tuple2(
							'value',
							$author$project$Model$BuildPlanner$BuildExpr$BuildExprString(value))
						]));
			case 3:
				var value = pred.a;
				return _Utils_Tuple2(
					'Gte',
					_List_fromArray(
						[
							_Utils_Tuple2(
							'value',
							$author$project$Model$BuildPlanner$BuildExpr$BuildExprString(value))
						]));
			case 4:
				var value = pred.a;
				return _Utils_Tuple2(
					'Lt',
					_List_fromArray(
						[
							_Utils_Tuple2(
							'value',
							$author$project$Model$BuildPlanner$BuildExpr$BuildExprString(value))
						]));
			case 5:
				var value = pred.a;
				return _Utils_Tuple2(
					'Lte',
					_List_fromArray(
						[
							_Utils_Tuple2(
							'value',
							$author$project$Model$BuildPlanner$BuildExpr$BuildExprString(value))
						]));
			case 6:
				var value = pred.a;
				return _Utils_Tuple2(
					'Ne',
					_List_fromArray(
						[
							_Utils_Tuple2(
							'value',
							$author$project$Model$BuildPlanner$BuildExpr$BuildExprString(value))
						]));
			default:
				var left = pred.a;
				var right = pred.b;
				return _Utils_Tuple2(
					'Or',
					_List_fromArray(
						[
							_Utils_Tuple2(
							'left',
							$author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$unevalPred(left)),
							_Utils_Tuple2(
							'right',
							$author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$unevalPred(right))
						]));
		}
	}();
	var name = _v0.a;
	var args = _v0.b;
	return $author$project$Model$BuildPlanner$BuildExpr$BuildExprApp(
		{
			kO: $elm$core$Dict$fromList(args),
			w: name
		});
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$unevalConstraint = function (constraint) {
	if (!constraint.$) {
		return $author$project$Model$BuildPlanner$BuildExpr$BuildExprApp(
			{kO: $elm$core$Dict$empty, w: 'Any'});
	} else {
		var pred = constraint.a;
		return $author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$unevalPred(pred);
	}
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Req$uneval = function (req) {
	return $author$project$Model$BuildPlanner$BuildExpr$BuildExprApp(
		{
			kO: $elm$core$Dict$fromList(
				_Utils_ap(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'name',
							$author$project$Model$BuildPlanner$BuildExpr$BuildExprString(req.w)),
							_Utils_Tuple2(
							'namespace',
							$author$project$Model$BuildPlanner$BuildExpr$BuildExprString(req.aE))
						]),
					A3(
						$author$project$Misc$encodeOptionalField,
						$author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$unevalConstraint,
						'version',
						A2(
							$elm_community$maybe_extra$Maybe$Extra$filter,
							$elm$core$Basics$neq($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ConstraintAny),
							$elm$core$Maybe$Just(req.aI))))),
			w: 'Req'
		});
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Solve$uneval = function (solve) {
	var name = solve.ya ? 'dynamic_solve' : 'solve';
	return $author$project$Model$BuildPlanner$BuildExpr$BuildExprApp(
		{
			kO: $elm$core$Dict$fromList(
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'at_time',
						$author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$unevalAtTime(solve.wG)),
					_Utils_ap(
						A3($author$project$Misc$encodeOptionalField, $author$project$Model$BuildPlanner$BuildExpr$BuildExprInt, 'solver_version', solve.Ga),
						_List_fromArray(
							[
								_Utils_Tuple2(
								'platforms',
								$author$project$Model$BuildPlanner$BuildExpr$BuildExprList(
									A2(
										$elm$core$List$map,
										$author$project$Model$BuildPlanner$BuildExpr$BuildExprString,
										$elm$core$Set$toList(solve.Fh)))),
								_Utils_Tuple2(
								'requirements',
								$author$project$Model$BuildPlanner$BuildExpr$BuildExprList(
									A2(
										$elm$core$List$map,
										A2($elm$core$Basics$composeR, $author$project$Model$BuildPlanner$BuildExpr$Eval$Req$fromRequirement, $author$project$Model$BuildPlanner$BuildExpr$Eval$Req$uneval),
										$author$project$Model$BuildPlanner$BuildExpr$SolveEditor$requirementsToList(solve.FF))))
							])))),
			w: name
		});
};
var $author$project$Model$BuildPlanner$BuildExpr$BuildFlagsDict$buildFlagFromNameAndValue = F2(
	function (name, value) {
		return {
			w: name,
			kH: $elm$core$String$isEmpty(value) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(value)
		};
	});
var $author$project$Model$BuildPlanner$BuildExpr$BuildFlagsDict$toList = A2(
	$elm$core$Dict$foldr,
	function (name) {
		return A2(
			$elm$core$Basics$composeL,
			$elm$core$List$cons,
			$author$project$Model$BuildPlanner$BuildExpr$BuildFlagsDict$buildFlagFromNameAndValue(name));
	},
	_List_Nil);
var $author$project$Model$BuildPlanner$BuildExpr$Eval$BuildFlag$uneval = function (buildFlag) {
	return $author$project$Model$BuildPlanner$BuildExpr$BuildExprApp(
		{
			kO: $elm$core$Dict$fromList(
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'name',
						$author$project$Model$BuildPlanner$BuildExpr$BuildExprString(buildFlag.w)),
					$elm_community$maybe_extra$Maybe$Extra$toList(
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeL,
								$elm$core$Tuple$pair('value'),
								$author$project$Model$BuildPlanner$BuildExpr$BuildExprString),
							buildFlag.kH)))),
			w: 'BuildFlag'
		});
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$StateToolArtifacts$uneval = F2(
	function (src, stateToolArtifacts) {
		return $author$project$Model$BuildPlanner$BuildExpr$BuildExprApp(
			{
				kO: $elm$core$Dict$fromList(
					_List_fromArray(
						[
							_Utils_Tuple2('src', src),
							_Utils_Tuple2(
							'build_flags',
							$author$project$Model$BuildPlanner$BuildExpr$BuildExprList(
								A2(
									$elm$core$List$map,
									$author$project$Model$BuildPlanner$BuildExpr$Eval$BuildFlag$uneval,
									$author$project$Model$BuildPlanner$BuildExpr$BuildFlagsDict$toList(stateToolArtifacts.xs))))
						])),
				w: 'state_tool_artifacts'
			});
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$WheelArtifacts$uneval = function (src) {
	return $author$project$Model$BuildPlanner$BuildExpr$BuildExprApp(
		{
			kO: $elm$core$Dict$fromList(
				_List_fromArray(
					[
						_Utils_Tuple2('src', src)
					])),
			w: 'wheel_artifacts'
		});
};
var $author$project$Pipeline$updateCtx = function (func) {
	return function (ctx) {
		return _Utils_Tuple2(
			func(ctx),
			$elm$core$Result$Ok(0));
	};
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Unsimplifier$setAddMissingSources = F4(
	function (genericSBOM, solve, communityOrWheel, stateToolArtifacts) {
		return $author$project$Pipeline$updateCtx(
			function (ctx) {
				var _v0 = _Utils_Tuple3(
					'sbom',
					_Utils_Tuple2('sources', 'artifacts'),
					_Utils_Tuple2('runtime', 'merged_runtime'));
				var sbom = _v0.a;
				var _v1 = _v0.b;
				var sources = _v1.a;
				var artifacts = _v1.b;
				var _v2 = _v0.c;
				var runtime = _v2.a;
				var mergedRuntime = _v2.b;
				var _v3 = _Utils_Tuple3(
					$author$project$Model$BuildPlanner$BuildExpr$BuildExprVar(sbom),
					$author$project$Model$BuildPlanner$BuildExpr$BuildExprVar(sources),
					_Utils_Tuple2(
						$author$project$Model$BuildPlanner$BuildExpr$BuildExprVar(artifacts),
						$author$project$Model$BuildPlanner$BuildExpr$BuildExprVar(runtime)));
				var sbomVar = _v3.a;
				var sourcesVar = _v3.b;
				var _v4 = _v3.c;
				var artifactsVar = _v4.a;
				var runtimeVar = _v4.b;
				var _v5 = function () {
					switch (communityOrWheel) {
						case 0:
							return _Utils_Tuple2(
								runtimeVar,
								_List_fromArray(
									[
										_Utils_Tuple2(
										runtime,
										A2($author$project$Model$BuildPlanner$BuildExpr$Eval$StateToolArtifacts$uneval, sourcesVar, stateToolArtifacts))
									]));
						case 1:
							return _Utils_Tuple2(
								runtimeVar,
								_List_fromArray(
									[
										_Utils_Tuple2(
										artifacts,
										$author$project$Model$BuildPlanner$BuildExpr$Eval$CommunityArtifacts$uneval(sourcesVar)),
										_Utils_Tuple2(
										runtime,
										A2($author$project$Model$BuildPlanner$BuildExpr$Eval$StateToolArtifacts$uneval, artifactsVar, stateToolArtifacts))
									]));
						default:
							return _Utils_Tuple2(
								runtimeVar,
								_List_fromArray(
									[
										_Utils_Tuple2(
										artifacts,
										$author$project$Model$BuildPlanner$BuildExpr$Eval$WheelArtifacts$uneval(sourcesVar)),
										_Utils_Tuple2(
										runtime,
										A2($author$project$Model$BuildPlanner$BuildExpr$Eval$StateToolArtifacts$uneval, artifactsVar, stateToolArtifacts))
									]));
					}
				}();
				var destVar = _v5.a;
				var artifactsRuntimeVarsRev = _v5.b;
				return _Utils_update(
					ctx,
					{
						fb: mergedRuntime,
						dw: A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								sbom,
								$author$project$Model$BuildPlanner$BuildExpr$Eval$GenericSBOM$uneval(genericSBOM)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									sources,
									$author$project$Model$BuildPlanner$BuildExpr$Eval$Solve$uneval(solve)),
								_Utils_ap(
									artifactsRuntimeVarsRev,
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(
											mergedRuntime,
											A2($author$project$Model$BuildPlanner$BuildExpr$Eval$AddMissingSources$uneval, sbomVar, destVar)),
										ctx.dw))))
					});
			});
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Merge$uneval = function (_v0) {
	var left = _v0.uv;
	var right = _v0.v0;
	return $author$project$Model$BuildPlanner$BuildExpr$BuildExprApp(
		{
			kO: $elm$core$Dict$fromList(
				_List_fromArray(
					[
						_Utils_Tuple2('left', left),
						_Utils_Tuple2('right', right)
					])),
			w: 'merge'
		});
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Unsimplifier$accumMerge = F2(
	function (first, second) {
		var helper = F2(
			function (_var, acc) {
				return {
					uv: $author$project$Model$BuildPlanner$BuildExpr$Eval$Merge$uneval(acc),
					v0: $author$project$Model$BuildPlanner$BuildExpr$BuildExprVar(_var)
				};
			});
		return A2(
			$elm$core$List$foldl,
			helper,
			{
				uv: $author$project$Model$BuildPlanner$BuildExpr$BuildExprVar(first),
				v0: $author$project$Model$BuildPlanner$BuildExpr$BuildExprVar(second)
			});
	});
var $author$project$Model$BuildPlanner$BuildExprEditor$Unsimplifier$toAuthenticodeSignatureVarName = F2(
	function (platform, idx) {
		return 'authenticode_signature_' + ($elm$core$String$fromInt(idx) + ('_' + A3(
			$elm$core$String$replace,
			'-',
			'_',
			$danyx23$elm_uuid$Uuid$toString(platform))));
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$AuthenticodeSignature$uneval = F3(
	function (src, platformID, _v0) {
		return $author$project$Model$BuildPlanner$BuildExpr$BuildExprApp(
			{
				kO: $elm$core$Dict$fromList(
					_List_fromArray(
						[
							_Utils_Tuple2('src', src),
							_Utils_Tuple2(
							'platform',
							$author$project$Model$BuildPlanner$BuildExpr$BuildExprString(
								$danyx23$elm_uuid$Uuid$toString(platformID)))
						])),
				w: 'authenticode_signature'
			});
	});
var $author$project$Model$BuildPlanner$BuildExprEditor$Unsimplifier$setAuthenticodeSignatures = function (allPackagers) {
	return $author$project$Pipeline$updateCtx(
		function (ctx) {
			var src = $author$project$Model$BuildPlanner$BuildExpr$BuildExprVar(ctx.fb);
			var pairs = A2(
				$elm$core$List$indexedMap,
				F2(
					function (idx, _v4) {
						var platform = _v4.a;
						return _Utils_Tuple2(
							A2($author$project$Model$BuildPlanner$BuildExprEditor$Unsimplifier$toAuthenticodeSignatureVarName, platform, idx),
							A3(
								$author$project$Model$BuildPlanner$BuildExpr$Eval$AuthenticodeSignature$uneval,
								src,
								platform,
								{}));
					}),
				A2(
					$elm$core$List$filterMap,
					function (_v3) {
						var k = _v3.a;
						var v = _v3.b;
						return A3(
							$elm$core$Maybe$map2,
							$elm$core$Tuple$pair,
							$danyx23$elm_uuid$Uuid$fromString(k),
							$elm$core$List$head(v.A8));
					},
					$elm$core$Dict$toList(allPackagers)));
			var vars = A2(
				$elm$core$List$map,
				A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $elm$core$Basics$identity),
				pairs);
			var _v0 = function () {
				if (!vars.b) {
					return _Utils_Tuple2(ctx.fb, $elm$core$Maybe$Nothing);
				} else {
					if (!vars.b.b) {
						var _var = vars.a;
						return _Utils_Tuple2(_var, $elm$core$Maybe$Nothing);
					} else {
						var first = vars.a;
						var _v2 = vars.b;
						var second = _v2.a;
						var others = _v2.b;
						var mergeVarName = 'authenticode_signature_merged';
						var merge = A3($author$project$Model$BuildPlanner$BuildExprEditor$Unsimplifier$accumMerge, first, second, others);
						return _Utils_Tuple2(
							mergeVarName,
							$elm$core$Maybe$Just(
								_Utils_Tuple2(
									mergeVarName,
									$author$project$Model$BuildPlanner$BuildExpr$Eval$Merge$uneval(merge))));
					}
				}
			}();
			var lastVar = _v0.a;
			var mmerge = _v0.b;
			return _Utils_update(
				ctx,
				{
					fb: lastVar,
					dw: _Utils_ap(
						$elm_community$maybe_extra$Maybe$Extra$toList(mmerge),
						_Utils_ap(
							$elm$core$List$reverse(pairs),
							ctx.dw))
				});
		});
};
var $author$project$Pipeline$Done = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pipeline$Next = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pipeline$loop = F2(
	function (initAcc, func) {
		var helper = F2(
			function (acc, ctx) {
				helper:
				while (true) {
					var _v0 = A2(
						$author$project$Pipeline$run,
						func(acc),
						ctx);
					var ctx1 = _v0.a;
					var res = _v0.b;
					if (res.$ === 1) {
						var err = res.a;
						return _Utils_Tuple2(
							ctx1,
							$elm$core$Result$Err(err));
					} else {
						var step = res.a;
						if (step.$ === 1) {
							var a = step.a;
							return _Utils_Tuple2(
								ctx1,
								$elm$core$Result$Ok(a));
						} else {
							var acc1 = step.a;
							var $temp$acc = acc1,
								$temp$ctx = ctx1;
							acc = $temp$acc;
							ctx = $temp$ctx;
							continue helper;
						}
					}
				}
			});
		return helper(initAcc);
	});
var $author$project$Pipeline$map = function (func) {
	return $author$project$Pipeline$andThen(
		function (a) {
			return $author$project$Pipeline$succeed(
				func(a));
		});
};
var $author$project$Pipeline$foldl = F3(
	function (func, initAcc, list) {
		return A2(
			$author$project$Pipeline$loop,
			_Utils_Tuple2(initAcc, list),
			function (_v0) {
				var acc = _v0.a;
				var elems = _v0.b;
				if (!elems.b) {
					return $author$project$Pipeline$succeed(
						$author$project$Pipeline$Done(acc));
				} else {
					var elem = elems.a;
					var elems_ = elems.b;
					return A2(
						$author$project$Pipeline$map,
						function (acc_) {
							return $author$project$Pipeline$Next(
								_Utils_Tuple2(acc_, elems_));
						},
						A2(func, elem, acc));
				}
			});
	});
var $author$project$Pipeline$forEach = F2(
	function (values, func) {
		var helper = F2(
			function (a, acc) {
				return A2(
					$author$project$Pipeline$map,
					A2($elm_community$basics_extra$Basics$Extra$flip, $elm$core$List$cons, acc),
					func(a));
			});
		return A2(
			$author$project$Pipeline$map,
			$elm$core$List$reverse,
			A3($author$project$Pipeline$foldl, helper, _List_Nil, values));
	});
var $author$project$Pipeline$map2 = function (func) {
	return $author$project$Pipeline$andThen2(
		F2(
			function (a, b) {
				return $author$project$Pipeline$succeed(
					A2(func, a, b));
			}));
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$ScannedImage$uneval = function (scannedImage) {
	return $author$project$Model$BuildPlanner$BuildExpr$BuildExprApp(
		{
			kO: $elm$core$Dict$fromList(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'at_time',
						$author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$unevalAtTime(scannedImage.jE)),
						_Utils_Tuple2(
						'registry',
						$author$project$Model$BuildPlanner$BuildExpr$BuildExprString(scannedImage.Fz)),
						_Utils_Tuple2(
						'based_on',
						$author$project$Model$BuildPlanner$BuildExpr$BuildExprString(scannedImage.Be)),
						_Utils_Tuple2(
						'image_name',
						$author$project$Model$BuildPlanner$BuildExpr$BuildExprString(scannedImage.CT)),
						_Utils_Tuple2(
						'manifest_digest',
						$author$project$Model$BuildPlanner$BuildExpr$BuildExprString(scannedImage.D9)),
						_Utils_Tuple2(
						'os_arch',
						$author$project$Model$BuildPlanner$BuildExpr$BuildExprString(scannedImage.E$)),
						_Utils_Tuple2(
						'tags',
						$author$project$Model$BuildPlanner$BuildExpr$BuildExprList(
							A2($elm$core$List$map, $author$project$Model$BuildPlanner$BuildExpr$BuildExprString, scannedImage.Gt))),
						_Utils_Tuple2(
						'contents',
						$author$project$Model$BuildPlanner$BuildExpr$BuildExprList(
							A2($elm$core$List$map, $author$project$Model$BuildPlanner$BuildExpr$BuildExprString, scannedImage.xM))),
						_Utils_Tuple2(
						'scan_uri',
						$author$project$Model$BuildPlanner$BuildExpr$BuildExprString(scannedImage.FS))
					])),
			w: 'scanned_image'
		});
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$MergeSet$uneval = function (_v0) {
	var set = _v0.F0;
	return $author$project$Model$BuildPlanner$BuildExpr$BuildExprApp(
		{
			kO: $elm$core$Dict$fromList(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'set',
						$author$project$Model$BuildPlanner$BuildExpr$BuildExprList(
							A2($elm$core$List$map, $author$project$Model$BuildPlanner$BuildExpr$Eval$ScannedImage$uneval, set)))
					])),
			w: 'merge_set'
		});
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$ReplaceImage$uneval = F2(
	function (src, replaceImage) {
		return $author$project$Model$BuildPlanner$BuildExpr$BuildExprApp(
			{
				kO: $elm$core$Dict$fromList(
					_List_fromArray(
						[
							_Utils_Tuple2('src', src),
							_Utils_Tuple2(
							'at_time',
							$author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$unevalAtTime(replaceImage.jE)),
							_Utils_Tuple2(
							'namespace',
							$author$project$Model$BuildPlanner$BuildExpr$BuildExprString(replaceImage.aE)),
							_Utils_Tuple2(
							'name',
							$author$project$Model$BuildPlanner$BuildExpr$BuildExprString(replaceImage.w)),
							_Utils_Tuple2(
							'version',
							$author$project$Model$BuildPlanner$BuildExpr$BuildExprString(replaceImage.aI)),
							_Utils_Tuple2(
							'manifests',
							$author$project$Model$BuildPlanner$BuildExpr$BuildExprList(
								A2($elm$core$List$map, $author$project$Model$BuildPlanner$BuildExpr$BuildExprString, replaceImage.Ea)))
						])),
				w: 'replace_image'
			});
	});
var $author$project$Model$BuildPlanner$BuildExprEditor$Unsimplifier$setImages = F2(
	function (replaceImages, scannedImages) {
		var initPipeline = function () {
			var varName = 'scanned_images';
			return $author$project$Pipeline$updateCtx(
				function (ctx) {
					return _Utils_update(
						ctx,
						{
							fb: varName,
							dw: A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									varName,
									$author$project$Model$BuildPlanner$BuildExpr$Eval$MergeSet$uneval(
										{F0: scannedImages})),
								ctx.dw)
						});
				});
		}();
		var indexedRevReplaceImages = A2(
			$elm$core$List$indexedMap,
			$elm$core$Tuple$pair,
			$elm$core$List$reverse(replaceImages));
		return A3(
			$author$project$Pipeline$map2,
			$elm$core$Basics$always,
			initPipeline,
			A2(
				$author$project$Pipeline$forEach,
				indexedRevReplaceImages,
				function (_v0) {
					var idx = _v0.a;
					var replaceImage = _v0.b;
					var varName = 'new_images' + ((idx <= 0) ? '' : ('_' + $elm$core$String$fromInt(idx)));
					return $author$project$Pipeline$updateCtx(
						function (ctx) {
							return _Utils_update(
								ctx,
								{
									fb: varName,
									dw: A2(
										$elm$core$List$cons,
										_Utils_Tuple2(
											varName,
											A2(
												$author$project$Model$BuildPlanner$BuildExpr$Eval$ReplaceImage$uneval,
												$author$project$Model$BuildPlanner$BuildExpr$BuildExprVar(ctx.fb),
												replaceImage)),
										ctx.dw)
								});
						});
				}));
	});
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$MarkersNone = {$: 7};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Camel$uneval = F2(
	function (src, camel) {
		return $author$project$Model$BuildPlanner$BuildExpr$BuildExprApp(
			{
				kO: $elm$core$Dict$fromList(
					_List_fromArray(
						[
							_Utils_Tuple2('src', src),
							_Utils_Tuple2(
							'camel_flags',
							$author$project$Model$BuildPlanner$BuildExpr$BuildExprList(
								A2(
									$elm$core$List$map,
									$author$project$Model$BuildPlanner$BuildExpr$BuildExprString,
									$elm$core$Set$toList(camel.Bn))))
						])),
				w: 'camel'
			});
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$PrePlatformInstaller$uneval = function (src) {
	return $author$project$Model$BuildPlanner$BuildExpr$BuildExprApp(
		{
			kO: $elm$core$Dict$fromList(
				_List_fromArray(
					[
						_Utils_Tuple2('src', src)
					])),
			w: 'pre_platform_installer'
		});
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$StateToolArtifactsV1$uneval = F2(
	function (src, stateToolArtifactsV1) {
		return $author$project$Model$BuildPlanner$BuildExpr$BuildExprApp(
			{
				kO: $elm$core$Dict$fromList(
					_List_fromArray(
						[
							_Utils_Tuple2('src', src),
							_Utils_Tuple2(
							'build_flags',
							$author$project$Model$BuildPlanner$BuildExpr$BuildExprList(
								A2(
									$elm$core$List$map,
									$author$project$Model$BuildPlanner$BuildExpr$Eval$BuildFlag$uneval,
									$author$project$Model$BuildPlanner$BuildExpr$BuildFlagsDict$toList(stateToolArtifactsV1.xs))))
						])),
				w: 'state_tool_artifacts_v1'
			});
	});
var $author$project$Model$BuildPlanner$BuildExprEditor$Unsimplifier$setMarkers = function (markers) {
	return _Utils_eq(markers, $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$MarkersNone) ? $author$project$Pipeline$updateCtx($elm$core$Basics$identity) : $author$project$Pipeline$updateCtx(
		function (ctx) {
			var varName = 'runtime';
			var src = $author$project$Model$BuildPlanner$BuildExpr$BuildExprVar(ctx.fb);
			var varsRev = function () {
				switch (markers.$) {
					case 0:
						var camel = markers.a;
						return _List_fromArray(
							[
								_Utils_Tuple2(
								varName,
								A2($author$project$Model$BuildPlanner$BuildExpr$Eval$Camel$uneval, src, camel))
							]);
					case 1:
						return _List_fromArray(
							[
								_Utils_Tuple2(
								varName,
								$author$project$Model$BuildPlanner$BuildExpr$Eval$PrePlatformInstaller$uneval(src))
							]);
					case 2:
						switch (markers.a) {
							case 1:
								var _v1 = markers.a;
								var stateToolArtifacts = markers.b;
								var artifactsVarName = 'artifacts';
								return _List_fromArray(
									[
										_Utils_Tuple2(
										varName,
										A2(
											$author$project$Model$BuildPlanner$BuildExpr$Eval$StateToolArtifacts$uneval,
											$author$project$Model$BuildPlanner$BuildExpr$BuildExprVar(artifactsVarName),
											stateToolArtifacts)),
										_Utils_Tuple2(
										artifactsVarName,
										$author$project$Model$BuildPlanner$BuildExpr$Eval$CommunityArtifacts$uneval(src))
									]);
							case 2:
								var _v2 = markers.a;
								var stateToolArtifacts = markers.b;
								var artifactsVarName = 'artifacts';
								return _List_fromArray(
									[
										_Utils_Tuple2(
										varName,
										A2(
											$author$project$Model$BuildPlanner$BuildExpr$Eval$StateToolArtifacts$uneval,
											$author$project$Model$BuildPlanner$BuildExpr$BuildExprVar(artifactsVarName),
											stateToolArtifacts)),
										_Utils_Tuple2(
										artifactsVarName,
										$author$project$Model$BuildPlanner$BuildExpr$Eval$WheelArtifacts$uneval(src))
									]);
							default:
								var _v3 = markers.a;
								var stateToolArtifacts = markers.b;
								return _List_fromArray(
									[
										_Utils_Tuple2(
										varName,
										A2($author$project$Model$BuildPlanner$BuildExpr$Eval$StateToolArtifacts$uneval, src, stateToolArtifacts))
									]);
						}
					case 3:
						var stateToolArtifactsV1 = markers.a;
						return _List_fromArray(
							[
								_Utils_Tuple2(
								varName,
								A2($author$project$Model$BuildPlanner$BuildExpr$Eval$StateToolArtifactsV1$uneval, src, stateToolArtifactsV1))
							]);
					case 4:
						return _List_Nil;
					case 5:
						return _List_Nil;
					case 6:
						return _List_Nil;
					default:
						return _List_Nil;
				}
			}();
			return _Utils_update(
				ctx,
				{
					fb: varName,
					dw: _Utils_ap(varsRev, ctx.dw)
				});
		});
};
var $elm$core$Tuple$mapBoth = F3(
	function (funcA, funcB, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			funcA(x),
			funcB(y));
	});
var $author$project$Pipeline$getCtx = function (ctx) {
	return _Utils_Tuple2(
		ctx,
		$elm$core$Result$Ok(ctx));
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Unsimplifier$toMergeVarName = function (platform) {
	return 'merge_' + A3(
		$elm$core$String$replace,
		'-',
		'_',
		$danyx23$elm_uuid$Uuid$toString(platform));
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Unsimplifier$setPlatformVars = F2(
	function (platform, pairs) {
		return $author$project$Pipeline$updateCtx(
			function (ctx) {
				var vars = A2(
					$elm$core$List$map,
					A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $elm$core$Basics$identity),
					pairs);
				var _v0 = function () {
					if (!vars.b) {
						return _Utils_Tuple2(ctx.fb, $elm$core$Maybe$Nothing);
					} else {
						if (!vars.b.b) {
							var _var = vars.a;
							return _Utils_Tuple2(_var, $elm$core$Maybe$Nothing);
						} else {
							var first = vars.a;
							var _v2 = vars.b;
							var second = _v2.a;
							var others = _v2.b;
							var mergeVarName = $author$project$Model$BuildPlanner$BuildExprEditor$Unsimplifier$toMergeVarName(platform);
							var merge = A3($author$project$Model$BuildPlanner$BuildExprEditor$Unsimplifier$accumMerge, first, second, others);
							return _Utils_Tuple2(
								mergeVarName,
								$elm$core$Maybe$Just(
									_Utils_Tuple2(
										mergeVarName,
										$author$project$Model$BuildPlanner$BuildExpr$Eval$Merge$uneval(merge))));
						}
					}
				}();
				var lastVar = _v0.a;
				var mmerge = _v0.b;
				return _Utils_update(
					ctx,
					{
						fb: lastVar,
						dw: _Utils_ap(
							$elm_community$maybe_extra$Maybe$Extra$toList(mmerge),
							_Utils_ap(
								$elm$core$List$reverse(pairs),
								ctx.dw))
					});
			});
	});
var $author$project$Model$BuildPlanner$BuildExprEditor$Unsimplifier$toPackagerVarName = F3(
	function (platform, kind, idx) {
		return kind + ('_' + ($elm$core$String$fromInt(idx) + ('_' + A3(
			$elm$core$String$replace,
			'-',
			'_',
			$danyx23$elm_uuid$Uuid$toString(platform)))));
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Docker$uneval = F3(
	function (src, platformID, docker) {
		return $author$project$Model$BuildPlanner$BuildExpr$BuildExprApp(
			{
				kO: $elm$core$Dict$fromList(
					_Utils_ap(
						_List_fromArray(
							[
								_Utils_Tuple2('src', src),
								_Utils_Tuple2(
								'at_time',
								$author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$unevalAtTime(docker.jE)),
								_Utils_Tuple2(
								'base_image',
								$author$project$Model$BuildPlanner$BuildExpr$BuildExprString(docker.Bd)),
								_Utils_Tuple2(
								'env',
								$author$project$Model$BuildPlanner$BuildExpr$BuildExprList(
									A2(
										$elm$core$List$map,
										$author$project$Model$BuildPlanner$BuildExpr$BuildExprString,
										$elm$core$Set$toList(docker.Cr))))
							]),
						_Utils_ap(
							A3($author$project$Misc$encodeOptionalField, $author$project$Model$BuildPlanner$BuildExpr$BuildExprInt, 'memory', docker.uC),
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$author$project$Model$BuildPlanner$BuildExpr$BuildExprString(docker.w)),
									_Utils_Tuple2(
									'platform',
									$author$project$Model$BuildPlanner$BuildExpr$BuildExprString(
										$danyx23$elm_uuid$Uuid$toString(platformID)))
								])))),
				w: 'docker'
			});
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$LinuxInstaller$uneval = F3(
	function (src, platformID, linuxInstaller) {
		return $author$project$Model$BuildPlanner$BuildExpr$BuildExprApp(
			{
				kO: $elm$core$Dict$fromList(
					_Utils_ap(
						_List_fromArray(
							[
								_Utils_Tuple2('src', src),
								_Utils_Tuple2(
								'at_time',
								$author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$unevalAtTime(linuxInstaller.jE))
							]),
						_Utils_ap(
							A3($author$project$Misc$encodeOptionalField, $author$project$Model$BuildPlanner$BuildExpr$BuildExprInt, 'memory', linuxInstaller.uC),
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$author$project$Model$BuildPlanner$BuildExpr$BuildExprString(linuxInstaller.w)),
									_Utils_Tuple2(
									'platform',
									$author$project$Model$BuildPlanner$BuildExpr$BuildExprString(
										$danyx23$elm_uuid$Uuid$toString(platformID)))
								])))),
				w: 'linux_installer'
			});
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$RelocateAndZip$uneval = F3(
	function (src, platformID, relocateAndZip) {
		return $author$project$Model$BuildPlanner$BuildExpr$BuildExprApp(
			{
				kO: $elm$core$Dict$fromList(
					_List_fromArray(
						[
							_Utils_Tuple2('src', src),
							_Utils_Tuple2(
							'name',
							$author$project$Model$BuildPlanner$BuildExpr$BuildExprString(relocateAndZip.w)),
							_Utils_Tuple2(
							'platform',
							$author$project$Model$BuildPlanner$BuildExpr$BuildExprString(
								$danyx23$elm_uuid$Uuid$toString(platformID)))
						])),
				w: 'relocate_and_zip'
			});
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$WindowsInstaller$uneval = F3(
	function (src, platformID, windowsInstaller) {
		return $author$project$Model$BuildPlanner$BuildExpr$BuildExprApp(
			{
				kO: $elm$core$Dict$fromList(
					_Utils_ap(
						_List_fromArray(
							[
								_Utils_Tuple2('src', src),
								_Utils_Tuple2(
								'at_time',
								$author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$unevalAtTime(windowsInstaller.jE))
							]),
						_Utils_ap(
							A3($author$project$Misc$encodeOptionalField, $author$project$Model$BuildPlanner$BuildExpr$BuildExprInt, 'memory', windowsInstaller.uC),
							_List_fromArray(
								[
									_Utils_Tuple2(
									'name',
									$author$project$Model$BuildPlanner$BuildExpr$BuildExprString(windowsInstaller.w)),
									_Utils_Tuple2(
									'platform',
									$author$project$Model$BuildPlanner$BuildExpr$BuildExprString(
										$danyx23$elm_uuid$Uuid$toString(platformID)))
								])))),
				w: 'windows_installer'
			});
	});
var $author$project$Model$BuildPlanner$BuildExprEditor$Unsimplifier$setPlatformPackagers = F2(
	function (platform, packagers) {
		return A2(
			$author$project$Pipeline$andThen,
			function (ctx) {
				var src = $author$project$Model$BuildPlanner$BuildExpr$BuildExprVar(ctx.fb);
				var toPair = F4(
					function (mkNode, kind, idx, packager) {
						return _Utils_Tuple2(
							A3($author$project$Model$BuildPlanner$BuildExprEditor$Unsimplifier$toPackagerVarName, platform, kind, idx),
							A3(mkNode, src, platform, packager));
					});
				var pairs = _Utils_ap(
					A2(
						$elm$core$List$indexedMap,
						A2(toPair, $author$project$Model$BuildPlanner$BuildExpr$Eval$Docker$uneval, 'docker'),
						packagers.Cj),
					_Utils_ap(
						A2(
							$elm$core$List$indexedMap,
							A2(toPair, $author$project$Model$BuildPlanner$BuildExpr$Eval$LinuxInstaller$uneval, 'linux_installer'),
							packagers.D4),
						_Utils_ap(
							A2(
								$elm$core$List$indexedMap,
								A2(toPair, $author$project$Model$BuildPlanner$BuildExpr$Eval$WindowsInstaller$uneval, 'windows_installer'),
								packagers.w4),
							A2(
								$elm$core$List$indexedMap,
								A2(toPair, $author$project$Model$BuildPlanner$BuildExpr$Eval$RelocateAndZip$uneval, 'relocate_and_zip'),
								packagers.vX))));
				return A2($author$project$Model$BuildPlanner$BuildExprEditor$Unsimplifier$setPlatformVars, platform, pairs);
			},
			$author$project$Pipeline$getCtx);
	});
var $author$project$Model$BuildPlanner$BuildExprEditor$Unsimplifier$setPackagers = function (packagersDict) {
	var packagersList = A2(
		$elm$core$List$filterMap,
		A2(
			$elm$core$Basics$composeR,
			A2($elm$core$Tuple$mapBoth, $danyx23$elm_uuid$Uuid$fromString, $elm$core$Maybe$Just),
			$elm_community$basics_extra$Basics$Extra$uncurry(
				$elm$core$Maybe$map2($elm$core$Tuple$pair))),
		$elm$core$Dict$toList(packagersDict));
	return A2(
		$author$project$Pipeline$map,
		function (_v0) {
			return 0;
		},
		A2(
			$author$project$Pipeline$forEach,
			packagersList,
			$elm_community$basics_extra$Basics$Extra$uncurry($author$project$Model$BuildPlanner$BuildExprEditor$Unsimplifier$setPlatformPackagers)));
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$FindRoots$uneval = F2(
	function (findRoots, src) {
		return $author$project$Model$BuildPlanner$BuildExpr$BuildExprApp(
			{
				kO: $elm$core$Dict$fromList(
					_List_fromArray(
						[
							_Utils_Tuple2('src', src),
							_Utils_Tuple2(
							'closure',
							$author$project$Model$BuildPlanner$BuildExpr$BuildExprString(findRoots.BJ))
						])),
				w: 'find_roots'
			});
	});
var $author$project$Model$BuildPlanner$BuildExprEditor$Unsimplifier$setSBOM = F2(
	function (findRoots, genericSBOM) {
		return $author$project$Pipeline$updateCtx(
			function (ctx) {
				var _v0 = _Utils_Tuple2('sbom', 'sbom_roots');
				var sbom = _v0.a;
				var sbomRoots = _v0.b;
				var _v1 = _Utils_Tuple2(
					sbomRoots,
					_List_fromArray(
						[
							_Utils_Tuple2(
							sbom,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$GenericSBOM$uneval(genericSBOM)),
							_Utils_Tuple2(
							sbomRoots,
							A2(
								$author$project$Model$BuildPlanner$BuildExpr$Eval$FindRoots$uneval,
								findRoots,
								$author$project$Model$BuildPlanner$BuildExpr$BuildExprVar(sbom)))
						]));
				var lastVar = _v1.a;
				var varsRev = _v1.b;
				return _Utils_update(
					ctx,
					{
						fb: lastVar,
						dw: _Utils_ap(varsRev, ctx.dw)
					});
			});
	});
var $author$project$Model$BuildPlanner$BuildExprEditor$Unsimplifier$setSolve = function (solve) {
	return $author$project$Pipeline$updateCtx(
		function (ctx) {
			var varName = 'sources';
			return _Utils_update(
				ctx,
				{
					fb: varName,
					dw: A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							varName,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$Solve$uneval(solve)),
						ctx.dw)
				});
		});
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Unsimplifier$setFields = function (fields) {
	var _v0 = fields.Ec;
	switch (_v0.$) {
		case 4:
			var replaceImages = _v0.a;
			var scannedImages = _v0.b;
			return A2($author$project$Model$BuildPlanner$BuildExprEditor$Unsimplifier$setImages, replaceImages, scannedImages);
		case 5:
			var findRoots = _v0.a;
			var genericSBOM = _v0.b;
			return A2($author$project$Model$BuildPlanner$BuildExprEditor$Unsimplifier$setSBOM, findRoots, genericSBOM);
		case 6:
			var genericSBOM = _v0.a;
			var communityOrWheel = _v0.b;
			var stateToolArtifacts = _v0.c;
			return A4($author$project$Model$BuildPlanner$BuildExprEditor$Unsimplifier$setAddMissingSources, genericSBOM, fields.sr, communityOrWheel, stateToolArtifacts);
		default:
			return A5(
				$author$project$Pipeline$map4,
				F4(
					function (_v1, _v2, _v3, _v4) {
						return 0;
					}),
				$author$project$Model$BuildPlanner$BuildExprEditor$Unsimplifier$setSolve(fields.sr),
				$author$project$Model$BuildPlanner$BuildExprEditor$Unsimplifier$setMarkers(fields.Ec),
				$author$project$Model$BuildPlanner$BuildExprEditor$Unsimplifier$setAuthenticodeSignatures(fields.E2),
				$author$project$Model$BuildPlanner$BuildExprEditor$Unsimplifier$setPackagers(fields.E2));
	}
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Unsimplifier$run = function (fields) {
	var initCtx = {fb: '', dw: _List_Nil};
	var finalCtx = A2(
		$author$project$Pipeline$run,
		$author$project$Model$BuildPlanner$BuildExprEditor$Unsimplifier$setFields(fields),
		initCtx).a;
	return $author$project$Model$BuildPlanner$BuildExpr$BuildExprLet(
		{
			sY: $author$project$Model$BuildPlanner$BuildExpr$BuildExprVar(finalCtx.fb),
			w0: $elm$core$Dict$fromList(
				$elm$core$List$reverse(finalCtx.dw))
		});
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$toBuildExpr = A2($elm$core$Basics$composeR, $author$project$Model$Editor$getFields, $author$project$Model$BuildPlanner$BuildExprEditor$Unsimplifier$run);
var $author$project$Validation$isLongerThan = F2(
	function (limit, str) {
		return _Utils_cmp(
			$elm$core$String$length(str),
			limit) > 0;
	});
var $author$project$Validation$isShorterThan = F2(
	function (limit, str) {
		return _Utils_cmp(
			$elm$core$String$length(str),
			limit) < 0;
	});
var $author$project$Validation$minProjectNameLength = 3;
var $author$project$Validation$runValidations = F2(
	function (validationFns, field) {
		var _v0 = A2(
			$elm$core$List$filter,
			function (_v1) {
				var pred = _v1.a;
				return pred(field);
			},
			validationFns);
		if (!_v0.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var x = _v0.a;
			return $elm$core$Maybe$Just(x.b);
		}
	});
var $author$project$Validation$validateProjectName = $author$project$Validation$runValidations(
	_List_fromArray(
		[
			_Utils_Tuple2($elm$core$String$isEmpty, 'Please provide a name'),
			_Utils_Tuple2(
			$author$project$Validation$isShorterThan($author$project$Validation$minProjectNameLength),
			'Must be at least ' + ($elm$core$String$fromInt($author$project$Validation$minProjectNameLength) + ' characters long')),
			_Utils_Tuple2(
			$author$project$Validation$isLongerThan($author$project$Validation$maxProjectNameLength),
			'Must be no more than ' + ($elm$core$String$fromInt($author$project$Validation$maxProjectNameLength) + ' characters long'))
		]));
var $author$project$Pages$CreateProject$createProject = F3(
	function (session, model, nextAction) {
		var projectName = $author$project$Validation$formatProjectName(
			$author$project$Pages$CreateProject$getProjectNameOrGenerated(model));
		var languageName = $author$project$Views$LanguageSelectorSimple$languageName(model.fg);
		var hasNameError = !_Utils_eq(
			$author$project$Validation$validateProjectName(projectName),
			$elm$core$Maybe$Nothing);
		var editorWithPackagers = (model.kM && $author$project$Model$Language$supportsInstaller(languageName)) ? A3(
			$elm$core$Set$foldl,
			function (platformID) {
				var _v1 = A2($elm$core$Dict$get, platformID, $author$project$Model$BuildPlanner$BuildExpr$PackagerKind$installerByPlatform);
				if (!_v1.$) {
					switch (_v1.a) {
						case 0:
							var _v2 = _v1.a;
							return $author$project$Model$BuildPlanner$SolveLegacyEditor$addPackagerDocker(platformID);
						case 1:
							var _v3 = _v1.a;
							return $author$project$Model$BuildPlanner$SolveLegacyEditor$addPackagerLinuxInstaller(platformID);
						case 2:
							var _v4 = _v1.a;
							return $author$project$Model$BuildPlanner$SolveLegacyEditor$addPackagerWindowsInstaller(platformID);
						case 3:
							var _v5 = _v1.a;
							return $author$project$Model$BuildPlanner$SolveLegacyEditor$addPackagerRelocateAndZip(platformID);
						default:
							var _v6 = _v1.a;
							return $author$project$Model$BuildPlanner$SolveLegacyEditor$addPackagerAuthenticodeSignature(platformID);
					}
				} else {
					return $elm$core$Basics$identity;
				}
			},
			model.qR,
			$author$project$Model$BuildPlanner$SolveLegacyEditor$getPlatforms(model.qR)) : model.qR;
		var hasLanguageError = $elm$core$Dict$isEmpty(
			$author$project$Model$BuildPlanner$SolveLegacyEditor$getLanguages(editorWithPackagers));
		var hasPlatformError = $elm$core$Set$isEmpty(
			$author$project$Model$BuildPlanner$SolveLegacyEditor$getPlatforms(editorWithPackagers));
		var creds = $author$project$Model$Session$getCreds(session);
		var _v0 = hasPlatformError ? _Utils_Tuple2(false, $author$project$Pages$CreateProject$focusPlatformField) : (hasNameError ? _Utils_Tuple2(false, $author$project$Pages$CreateProject$focusNameField) : (hasLanguageError ? _Utils_Tuple2(false, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
			true,
			A2(
				$elm$core$Task$attempt,
				A2($author$project$Pages$CreateProject$ProjectCreated, nextAction, projectName),
				A2(
					$author$project$Request$BuildPlanner$createProject,
					creds,
					{
						k$: $author$project$Model$BuildPlanner$BuildExprEditor$Simple$toBuildExpr(editorWithPackagers),
						c: model.bP,
						ix: $author$project$Model$Organization$getUrlName(model.c3),
						cd: $author$project$Model$Visibility$isPrivate(model.p9),
						vT: projectName
					})))));
		var canSubmit = _v0.a;
		var cmd = _v0.b;
		return A2(
			$author$project$Misc$with,
			cmd,
			$author$project$Views$NotificationsInline$clear(
				_Utils_update(
					model,
					{jV: canSubmit, m1: hasPlatformError})));
	});
var $author$project$Pages$CreateProject$cmds = function (model) {
	var _v0 = model.A9;
	if (!_v0.$) {
		var session = _v0.a;
		return A3(
			$author$project$Pages$CreateProject$createProject,
			session,
			model,
			A2($elm$core$Maybe$withDefault, 0, model.uO)).b;
	} else {
		return $elm$core$Platform$Cmd$none;
	}
};
var $author$project$Model$LocalStorage$get = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$get, key, dict);
	});
var $author$project$Model$Session$getLocalStorage = F2(
	function (name, _v0) {
		var session = _v0;
		return A2($author$project$Model$LocalStorage$get, name, session.fu);
	});
var $author$project$Model$Session$getUsername = function (session) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.AE;
			},
			$author$project$Model$Session$getUser(session)));
};
var $author$project$Pages$CreateProjectFromCommit$username = function (session) {
	return $author$project$Model$Session$getUsername(session);
};
var $author$project$Pages$CreateProjectFromCommit$orgName = function (session) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Pages$CreateProjectFromCommit$username(session),
		A2($author$project$Model$Session$getLocalStorage, $author$project$Model$LocalStorage$lastOrganizationKey, session));
};
var $author$project$Model$Route$projectConfig = F2(
	function (_v0, params) {
		var orgName = _v0.ix;
		var projectName = _v0.vT;
		return $author$project$Model$Route$Protected(
			$author$project$Model$Route$Org(
				A2(
					$author$project$Model$Route$OrgParams,
					orgName,
					$author$project$Model$Route$OrgProject(
						A2(
							$author$project$Model$Route$OrgProjectParams,
							projectName,
							$author$project$Model$Route$ProjectConfig(params))))));
	});
var $author$project$Model$Route$projectConfigParams = {yo: false, yJ: false, uk: false, fO: $elm$core$Maybe$Nothing, gr: $elm$core$Maybe$Nothing, z6: false, z7: false};
var $author$project$Model$Route$withIsFromCommit = F2(
	function (isFromCommit, args) {
		return _Utils_update(
			args,
			{yJ: isFromCommit});
	});
var $author$project$Pages$CreateProjectFromCommit$cmds = F2(
	function (session, model) {
		var route = A2(
			$author$project$Model$Route$projectConfig,
			{
				ix: $author$project$Pages$CreateProjectFromCommit$orgName(session),
				vT: $author$project$Model$Project$getName(model.c5)
			},
			A2($author$project$Model$Route$withIsFromCommit, true, $author$project$Model$Route$projectConfigParams));
		return A2($author$project$Routing$replaceUrl, model.Y, route);
	});
var $author$project$Model$User$hasAcceptedEula = function (user) {
	return !_Utils_eq(user.tM, $elm$core$Maybe$Nothing);
};
var $author$project$Misc$isAny = F2(
	function (predicates, a) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (p, acc) {
					return (!acc) ? p(a) : acc;
				}),
			false,
			predicates);
	});
var $author$project$Model$User$isForcedToVerifyEmail = function (user) {
	return !user.w1;
};
var $author$project$Model$Session$needsToFinishSetup = function (session) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$author$project$Misc$isAny(
				_List_fromArray(
					[
						A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Model$User$hasAcceptedEula),
						$author$project$Model$User$isForcedToVerifyEmail,
						function ($) {
						return $.DJ;
					}
					])),
			$author$project$Model$Session$getUser(session)));
};
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $author$project$Routing$pushUrl = F2(
	function (key, route) {
		return A2(
			$elm$browser$Browser$Navigation$pushUrl,
			key,
			$author$project$Model$Route$routeToString(route));
	});
var $author$project$Pages$FinishSetup$nextRouteCmd = function (model) {
	var route = function () {
		var _v0 = model.dg;
		if (_v0.$ === 1) {
			return $author$project$Model$Route$Protected(
				$author$project$Model$Route$Home(
					{wd: $elm$core$Maybe$Nothing}));
		} else {
			var r = _v0.a;
			return r;
		}
	}();
	return A2($author$project$Routing$pushUrl, model.Y, route);
};
var $author$project$Pages$FinishSetup$cmds = F2(
	function (session, model) {
		return $author$project$Model$Session$needsToFinishSetup(session) ? $elm$core$Platform$Cmd$none : $author$project$Pages$FinishSetup$nextRouteCmd(model);
	});
var $author$project$Pages$ImportProject$cmds = function (_v0) {
	return $elm$core$Platform$Cmd$none;
};
var $author$project$Pages$Orgs$NoOp = {$: 0};
var $author$project$Views$InlineSearchBar$searchBarId = 'inline-search-bar';
var $author$project$Views$InlineSearchBar$focusSearchBar = function (msg) {
	return A2(
		$elm$core$Task$attempt,
		function (_v0) {
			return msg;
		},
		$elm$browser$Browser$Dom$focus($author$project$Views$InlineSearchBar$searchBarId));
};
var $author$project$Pages$Orgs$cmds = function (_v0) {
	return $author$project$Views$InlineSearchBar$focusSearchBar($author$project$Pages$Orgs$NoOp);
};
var $author$project$Pages$ProjectOverview$SoftRefreshComplete = function (a) {
	return {$: 11, a: a};
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getUnknownAps = function (err) {
	if (!err.$) {
		return _List_Nil;
	} else {
		var kind = err.a;
		return _List_fromArray(
			[kind]);
	}
};
var $author$project$Model$BuildPlanner$BuildExpr$UnknownAp$toString = function (unknown) {
	if (!unknown.$) {
		var ruleName = unknown.a;
		return ruleName;
	} else {
		var ruleName = unknown.a;
		return ruleName;
	}
};
var $author$project$Pages$ProjectOverview$cmds = function (model) {
	var triggerSoftRefreshComplete = A2(
		$elm$core$Task$attempt,
		$author$project$Pages$ProjectOverview$SoftRefreshComplete,
		$elm$core$Task$succeed(model));
	var analyticsCommand = $author$project$Ports$sendAnalyticsEvent(
		A2(
			$author$project$Model$Analytics$withCategory,
			$author$project$Model$Analytics$categoryPageView,
			$author$project$Model$Analytics$newEvent('Project Overview')));
	var analyticsAnalyticsFactory = function (label) {
		return $author$project$Ports$sendAnalyticsEvent(
			A2(
				$author$project$Model$Analytics$withLabel,
				label,
				A2(
					$author$project$Model$Analytics$withCategory,
					'Unsupported Project',
					$author$project$Model$Analytics$newEvent($author$project$Model$Analytics$categoryPageView))));
	};
	var allUnknownBuildExprAnalytics = $elm$core$Platform$Cmd$batch(
		A2(
			$elm$core$List$map,
			analyticsAnalyticsFactory,
			A2(
				$elm$core$List$map,
				$author$project$Model$BuildPlanner$BuildExpr$UnknownAp$toString,
				A2(
					$elm$core$List$concatMap,
					$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getUnknownAps,
					$elm_community$maybe_extra$Maybe$Extra$toList(model.AA)))));
	return $elm$core$Platform$Cmd$batch(
		_List_fromArray(
			[allUnknownBuildExprAnalytics, analyticsCommand, triggerSoftRefreshComplete]));
};
var $author$project$Model$Route$addDescriptionFragment = 'add-description';
var $author$project$Model$Route$deleteProjectFragment = 'delete-project';
var $author$project$Model$Route$moveProjectFragment = 'move-project';
var $author$project$Model$Route$projectVisibilityFragment = 'project-visibility';
var $author$project$Pages$ProjectSettings$cmds = function (model) {
	var elementId = function () {
		var _v1 = model.oD;
		switch (_v1) {
			case 0:
				return $elm$core$Maybe$Nothing;
			case 1:
				return $elm$core$Maybe$Just($author$project$Model$Route$addDescriptionFragment);
			case 2:
				return $elm$core$Maybe$Just($author$project$Model$Route$moveProjectFragment);
			case 3:
				return $elm$core$Maybe$Just($author$project$Model$Route$projectVisibilityFragment);
			default:
				return $elm$core$Maybe$Just($author$project$Model$Route$deleteProjectFragment);
		}
	}();
	if (!elementId.$) {
		var id = elementId.a;
		return $author$project$Ports$scrollIntoView(
			{fD: $elm$core$Maybe$Nothing, z0: '#' + id});
	} else {
		return $elm$core$Platform$Cmd$none;
	}
};
var $author$project$Pages$ProjectSettingsHAR$BuildStarted = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Model$BuildPlannerCache$toComparableKey = function (_v0) {
	var orgName = _v0.ix;
	var projectName = _v0.vT;
	var commitID = _v0.BR;
	return _Utils_Tuple3(
		orgName,
		projectName,
		$danyx23$elm_uuid$Uuid$toString(commitID));
};
var $author$project$Model$BuildPlannerCache$getBuildPlan = F2(
	function (key, _v0) {
		var fields = _v0;
		return A2(
			$elm$core$Dict$get,
			$author$project$Model$BuildPlannerCache$toComparableKey(key),
			fields.jI);
	});
var $author$project$Model$Session$getBuildPlannerCache = function (_v0) {
	var session = _v0;
	return session.s$;
};
var $author$project$Model$BuildPlannerCache$getCommitAndBuildExpr = F2(
	function (key, _v0) {
		var fields = _v0;
		return A2(
			$elm$core$Dict$get,
			$author$project$Model$BuildPlannerCache$toComparableKey(key),
			fields.od);
	});
var $dillonkearns$elm_graphql$Graphql$Http$Query = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_graphql$Graphql$Http$queryRequest = F2(
	function (baseUrl, query) {
		return {
			n5: baseUrl,
			qQ: A2($dillonkearns$elm_graphql$Graphql$Http$Query, $elm$core$Maybe$Nothing, query),
			Cy: $dillonkearns$elm_graphql$Graphql$Document$decoder(query),
			CN: _List_Nil,
			kj: $elm$core$Maybe$Nothing,
			r2: _List_Nil,
			nE: $elm$core$Maybe$Nothing,
			kK: false
		};
	});
var $author$project$GraphQL$Utils$queryRequestCustom = function (mode) {
	return A2($author$project$GraphQL$Utils$makeRequest, $dillonkearns$elm_graphql$Graphql$Http$queryRequest, mode);
};
var $author$project$GraphQL$Utils$queryRequest = $author$project$GraphQL$Utils$queryRequestCustom(0);
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional = F3(
	function (fieldName, maybeValue, toValue) {
		switch (maybeValue.$) {
			case 0:
				var value = maybeValue.a;
				return $elm$core$Maybe$Just(
					A2(
						$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$Argument,
						fieldName,
						toValue(value)));
			case 1:
				return $elm$core$Maybe$Nothing;
			default:
				return $elm$core$Maybe$Just(
					A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$Argument, fieldName, $dillonkearns$elm_graphql$Graphql$Internal$Encode$null));
		}
	});
var $author$project$BuildPlanner$Object$Project$commit = F2(
	function (fillInOptionals____, object____) {
		var filledInOptionals____ = fillInOptionals____(
			{nL: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs____ = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'vcsRef', filledInOptionals____.nL, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)
				]));
		return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'commit', optionalArgs____, object____, $elm$core$Basics$identity);
	});
var $author$project$BuildPlanner$Union$CommitResult$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Commit', selections____.u7),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'NotFound', selections____.vp)
			]));
};
var $author$project$BuildPlanner$Union$ProjectResult$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Project', selections____.vt),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'NotFound', selections____.vp)
			]));
};
var $author$project$BuildPlanner$Query$project = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'project',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'organization', requiredArgs____.c3, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'project', requiredArgs____.c5, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $dillonkearns$elm_graphql$Graphql$SelectionSet$mapOrFail = F2(
	function (mapFunction, _v0) {
		var field = _v0.a;
		var decoder = _v0.b;
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			field,
			A2(
				$elm$json$Json$Decode$andThen,
				function (result) {
					if (!result.$) {
						var value = result.a;
						return $elm$json$Json$Decode$succeed(value);
					} else {
						var errorMessage = result.a;
						return $elm$json$Json$Decode$fail('Check your code for calls to mapOrFail, your map function returned an `Err` with the message: ' + errorMessage);
					}
				},
				A2($elm$json$Json$Decode$map, mapFunction, decoder)));
	});
var $author$project$BuildPlannerScalarCodecs$selectionSetFail = function (str) {
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$mapOrFail,
		function (_v0) {
			return $elm$core$Result$Err(str);
		},
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(0));
};
var $author$project$Request$BuildPlanner$selectionSetProjectCommit = F2(
	function (_v0, onCommit) {
		var orgName = _v0.ix;
		var projectName = _v0.vT;
		var commitID = _v0.BR;
		var commitIdStr = $danyx23$elm_uuid$Uuid$toString(commitID);
		var selectionSetProject = A2(
			$author$project$BuildPlanner$Object$Project$commit,
			function (opts) {
				return _Utils_update(
					opts,
					{
						nL: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(commitIdStr)
					});
			},
			$author$project$BuildPlanner$Union$CommitResult$fragments(
				{
					u7: onCommit,
					vp: $author$project$BuildPlannerScalarCodecs$selectionSetFail('Commit not found: ' + commitIdStr)
				}));
		return A2(
			$author$project$BuildPlanner$Query$project,
			{c3: orgName, c5: projectName},
			$author$project$BuildPlanner$Union$ProjectResult$fragments(
				{
					vp: $author$project$BuildPlannerScalarCodecs$selectionSetFail('Project not found: ' + (orgName + (' / ' + projectName))),
					vt: selectionSetProject
				}));
	});
var $author$project$Request$BuildPlanner$getByCommit = F2(
	function (session, args) {
		var buildPlannerCache = $author$project$Model$Session$getBuildPlannerCache(session);
		var cachedBuildPlannerValue = A3(
			$elm$core$Maybe$map2,
			$elm$core$Basics$apR,
			A2($author$project$Model$BuildPlannerCache$getBuildPlan, args.Y, buildPlannerCache),
			args.ke);
		var maybeCachedCommitAndBuildValue = A3(
			$elm$core$Maybe$map2,
			$elm$core$Basics$apR,
			A2($author$project$Model$BuildPlannerCache$getCommitAndBuildExpr, args.Y, buildPlannerCache),
			args.kf);
		var _v0 = _Utils_Tuple2(maybeCachedCommitAndBuildValue, cachedBuildPlannerValue);
		if (!_v0.a.$) {
			var cachedCommitAndBuildExprValue = _v0.a.a;
			return $elm$core$Task$succeed(cachedCommitAndBuildExprValue);
		} else {
			if (!_v0.b.$) {
				var cachedBuildPlanValue = _v0.b.a;
				return $elm$core$Task$succeed(cachedBuildPlanValue);
			} else {
				var creds = $author$project$Model$Session$getCreds(session);
				return A5(
					$author$project$GraphQL$Utils$queryRequest,
					creds,
					4,
					_List_Nil,
					args.kj,
					A2($author$project$Request$BuildPlanner$selectionSetProjectCommit, args.Y, args.ki));
			}
		}
	});
var $author$project$Model$BuildPlanner$BuildPlan$BuildFailure = 1;
var $author$project$Model$BuildPlanner$BuildPlan$BuildInProgress = 2;
var $author$project$Model$BuildPlanner$BuildPlan$BuildSuccess = 0;
var $author$project$Model$BuildPlanner$Node$artifact = function (node) {
	if (!node.$) {
		var a = node.a;
		return $elm$core$Maybe$Just(a);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$BuildPlanner$Object$Commit$build = F2(
	function (fillInOptionals____, object____) {
		var filledInOptionals____ = fillInOptionals____(
			{nC: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs____ = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'target', filledInOptionals____.nC, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)
				]));
		return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'build', optionalArgs____, object____, $elm$core$Basics$identity);
	});
var $author$project$BuildPlanner$Union$BuildResult$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BuildPlanning', selections____.u4),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BuildPlanned', selections____.u3),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BuildStarted', selections____.u5),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BuildCompleted', selections____.u2),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PlanningError', selections____.vr)
			]));
};
var $author$project$Model$BuildPlanner$Artifact$isFailed = function (a) {
	if (a.$ === 3) {
		return true;
	} else {
		return false;
	}
};
var $author$project$BuildPlanner$Object$BuildCompleted$nodes = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'nodes',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Model$BuildPlanner$Node$ArtifactNode = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$BuildPlanner$Node$MissingSourceNode = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$BuildPlanner$Node$SourceNode = function (a) {
	return {$: 1, a: a};
};
var $author$project$BuildPlanner$Union$Node$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Source', selections____.vA),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'MissingSource', selections____.vm),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ArtifactSucceeded', selections____.u$),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ArtifactUnbuilt', selections____.u1),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ArtifactStarted', selections____.u_),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ArtifactTransientlyFailed', selections____.u0),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ArtifactPermanentlyFailed', selections____.uZ)
			]));
};
var $author$project$Model$BuildPlanner$MissingSource$Data = F5(
	function (targetId, namespace, name, version, relatesTo) {
		return {w: name, aE: namespace, FA: relatesTo, Ap: targetId, aI: version};
	});
var $author$project$Model$BuildPlanner$MissingSource$MissingSource = $elm$core$Basics$identity;
var $author$project$BuildPlanner$Object$MissingSource$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$MissingSource$namespace = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'namespace', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Scalar$unwrapCodecs = function (_v0) {
	var unwrappedCodecs = _v0;
	return unwrappedCodecs;
};
var $author$project$BuildPlanner$Object$MissingSource$nodeId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'BuildPlannerScalarCodecs.Id',
	'nodeId',
	_List_Nil,
	$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).oc.qN);
var $author$project$BuildPlanner$Object$MissingSource$relatesTo = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'relatesTo',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Model$BuildPlanner$ComponentRelationship$ComponentRelationship = $elm$core$Basics$identity;
var $author$project$Model$BuildPlanner$ComponentRelationship$Data = F2(
	function (type_, componentId) {
		return {xJ: componentId, gR: type_};
	});
var $author$project$BuildPlanner$Object$ComponentRelationship$componentId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'BuildPlannerScalarCodecs.Id',
	'componentId',
	_List_Nil,
	$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).oc.qN);
var $author$project$BuildPlanner$Enum$ComponentRelationshipType$Direct = 0;
var $author$project$BuildPlanner$Enum$ComponentRelationshipType$ProvidedByBuildNode = 1;
var $author$project$BuildPlanner$Enum$ComponentRelationshipType$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'DIRECT':
				return $elm$json$Json$Decode$succeed(0);
			case 'PROVIDED_BY_BUILD_NODE':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Invalid ComponentRelationshipType type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$ComponentRelationship$type_ = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.ComponentRelationshipType.ComponentRelationshipType', 'type', _List_Nil, $author$project$BuildPlanner$Enum$ComponentRelationshipType$decoder);
var $author$project$Model$BuildPlanner$ComponentRelationship$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$elm$core$Basics$identity,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$ComponentRelationship$componentId,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$BuildPlanner$Object$ComponentRelationship$type_,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$ComponentRelationship$Data))));
var $author$project$BuildPlanner$Object$MissingSource$version = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'version', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Model$BuildPlanner$MissingSource$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$elm$core$Basics$identity,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$MissingSource$relatesTo($author$project$Model$BuildPlanner$ComponentRelationship$selectionSet),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$BuildPlanner$Object$MissingSource$version,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$BuildPlanner$Object$MissingSource$name,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$BuildPlanner$Object$MissingSource$namespace,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$BuildPlanner$Object$MissingSource$nodeId,
						$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$MissingSource$Data)))))));
var $author$project$Model$BuildPlanner$Source$Data = function (targetID) {
	return function (url) {
		return function (mimetype) {
			return function (checksum) {
				return function (namespace) {
					return function (name) {
						return function (version) {
							return function (revision) {
								return function (isIndemnified) {
									return function (licenses) {
										return function (relatesTo) {
											return {dE: checksum, Dm: isIndemnified, go: licenses, je: mimetype, w: name, aE: namespace, FA: relatesTo, ac: revision, Ao: targetID, GT: url, aI: version};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Model$BuildPlanner$Source$Source = $elm$core$Basics$identity;
var $author$project$BuildPlanner$Object$Source$checksum = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'checksum', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$Source$isIndemnified = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'isIndemnified', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$BuildPlanner$Object$Source$licenses = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(List String)',
	'licenses',
	_List_Nil,
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string));
var $author$project$BuildPlanner$Object$Source$mimeType = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'mimeType', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$Source$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$Source$namespace = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'namespace', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$Source$nodeId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'BuildPlannerScalarCodecs.Id',
	'nodeId',
	_List_Nil,
	$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).oc.qN);
var $author$project$Misc$isBoth = F3(
	function (predicateA, predicateB, a) {
		return predicateA(a) && predicateB(a);
	});
var $author$project$Model$IngredientVersion$licenseUnknown = 'unknown';
var $author$project$Model$IngredientVersion$splitLicences = function (license) {
	return A2(
		$elm$core$List$concatMap,
		$elm$core$String$split('OR'),
		A2(
			$elm$core$String$split,
			',',
			A3(
				$elm$core$String$replace,
				')',
				'',
				A3($elm$core$String$replace, '(', '', license))));
};
var $elm_community$list_extra$List$Extra$uniqueHelp = F4(
	function (f, existing, remaining, accumulator) {
		uniqueHelp:
		while (true) {
			if (!remaining.b) {
				return $elm$core$List$reverse(accumulator);
			} else {
				var first = remaining.a;
				var rest = remaining.b;
				var computedFirst = f(first);
				if (A2($elm$core$List$member, computedFirst, existing)) {
					var $temp$f = f,
						$temp$existing = existing,
						$temp$remaining = rest,
						$temp$accumulator = accumulator;
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				} else {
					var $temp$f = f,
						$temp$existing = A2($elm$core$List$cons, computedFirst, existing),
						$temp$remaining = rest,
						$temp$accumulator = A2($elm$core$List$cons, first, accumulator);
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$unique = function (list) {
	return A4($elm_community$list_extra$List$Extra$uniqueHelp, $elm$core$Basics$identity, _List_Nil, list, _List_Nil);
};
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $author$project$Model$IngredientVersion$parseLicenses = function (licenseStrs) {
	var parseLicenseField = function (licenseStr) {
		var licenseList = A2($elm$core$String$contains, '[', licenseStr) ? A2(
			$elm$core$Result$withDefault,
			_List_Nil,
			A2(
				$elm$json$Json$Decode$decodeString,
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
				licenseStr)) : _List_fromArray(
			[licenseStr]);
		return A2(
			$elm$core$List$filter,
			A2(
				$author$project$Misc$isBoth,
				A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not),
				A2(
					$elm$core$Basics$composeR,
					$elm$core$String$toLower,
					$elm$core$Basics$neq($author$project$Model$IngredientVersion$licenseUnknown))),
			A2(
				$elm$core$List$map,
				$elm$core$String$trim,
				A2($elm$core$List$concatMap, $author$project$Model$IngredientVersion$splitLicences, licenseList)));
	};
	return $elm_community$list_extra$List$Extra$unique(
		A2($elm$core$List$concatMap, parseLicenseField, licenseStrs));
};
var $author$project$BuildPlanner$Object$Source$relatesTo = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'relatesTo',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$BuildPlanner$Object$Source$revision = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'revision', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$BuildPlanner$Object$Source$url = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'BuildPlannerScalarCodecs.Uri',
	'url',
	_List_Nil,
	$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).BQ.qN);
var $author$project$BuildPlanner$Object$Source$version = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'version', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Model$BuildPlanner$Source$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$elm$core$Basics$identity,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$Source$relatesTo($author$project$Model$BuildPlanner$ComponentRelationship$selectionSet),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Model$IngredientVersion$parseLicenses, $author$project$BuildPlanner$Object$Source$licenses),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$BuildPlanner$Object$Source$isIndemnified,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$BuildPlanner$Object$Source$revision,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$BuildPlanner$Object$Source$version,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$BuildPlanner$Object$Source$name,
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$BuildPlanner$Object$Source$namespace,
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$BuildPlanner$Object$Source$checksum,
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$BuildPlanner$Object$Source$mimeType,
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											$author$project$BuildPlanner$Object$Source$url,
											A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
												$author$project$BuildPlanner$Object$Source$nodeId,
												$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$Source$Data)))))))))))));
var $author$project$Model$BuildPlanner$Artifact$Building = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$BuildPlanner$Artifact$BuildingData = F6(
	function (nodeId, displayName, mimetype, runtimeDependencies, status, startedAt) {
		return {i$: displayName, je: mimetype, rE: nodeId, jv: runtimeDependencies, Ae: startedAt, L: status};
	});
var $author$project$BuildPlanner$Object$ArtifactStarted$displayName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'displayName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$ArtifactStarted$mimeType = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'mimeType', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$ArtifactStarted$nodeId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'BuildPlannerScalarCodecs.Id',
	'nodeId',
	_List_Nil,
	$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).oc.qN);
var $author$project$BuildPlanner$Object$ArtifactStarted$runtimeDependencies = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(List BuildPlannerScalarCodecs.Id)',
	'runtimeDependencies',
	_List_Nil,
	$elm$json$Json$Decode$list(
		$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).oc.qN));
var $author$project$BuildPlanner$Object$ArtifactStarted$startedAt = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'BuildPlannerScalarCodecs.DateTime',
	'startedAt',
	_List_Nil,
	$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).qE.qN);
var $author$project$BuildPlanner$Enum$ArtifactStatus$Blocked = 1;
var $author$project$BuildPlanner$Enum$ArtifactStatus$FailedPermanently = 2;
var $author$project$BuildPlanner$Enum$ArtifactStatus$FailedTransiently = 3;
var $author$project$BuildPlanner$Enum$ArtifactStatus$NotSubmitted = 0;
var $author$project$BuildPlanner$Enum$ArtifactStatus$Ready = 4;
var $author$project$BuildPlanner$Enum$ArtifactStatus$Skipped = 5;
var $author$project$BuildPlanner$Enum$ArtifactStatus$Started = 6;
var $author$project$BuildPlanner$Enum$ArtifactStatus$Succeeded = 7;
var $author$project$BuildPlanner$Enum$ArtifactStatus$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'NOT_SUBMITTED':
				return $elm$json$Json$Decode$succeed(0);
			case 'BLOCKED':
				return $elm$json$Json$Decode$succeed(1);
			case 'FAILED_PERMANENTLY':
				return $elm$json$Json$Decode$succeed(2);
			case 'FAILED_TRANSIENTLY':
				return $elm$json$Json$Decode$succeed(3);
			case 'READY':
				return $elm$json$Json$Decode$succeed(4);
			case 'SKIPPED':
				return $elm$json$Json$Decode$succeed(5);
			case 'STARTED':
				return $elm$json$Json$Decode$succeed(6);
			case 'SUCCEEDED':
				return $elm$json$Json$Decode$succeed(7);
			default:
				return $elm$json$Json$Decode$fail('Invalid ArtifactStatus type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$ArtifactStarted$status = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.ArtifactStatus.ArtifactStatus', 'status', _List_Nil, $author$project$BuildPlanner$Enum$ArtifactStatus$decoder);
var $author$project$Model$BuildPlanner$Artifact$selectionSetBuilding = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$author$project$Model$BuildPlanner$Artifact$Building,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$ArtifactStarted$startedAt,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$BuildPlanner$Object$ArtifactStarted$status,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$BuildPlanner$Object$ArtifactStarted$runtimeDependencies,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$BuildPlanner$Object$ArtifactStarted$mimeType,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$BuildPlanner$Object$ArtifactStarted$displayName,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$BuildPlanner$Object$ArtifactStarted$nodeId,
							$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$Artifact$BuildingData))))))));
var $author$project$Model$BuildPlanner$Artifact$Failed = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$BuildPlanner$Artifact$FailedData = F9(
	function (nodeId, displayName, mimetype, runtimeDependencies, status, lastBuildTimestamp, buildDurationMillis, logURL, errors) {
		return {sZ: buildDurationMillis, i$: displayName, yf: errors, yY: lastBuildTimestamp, rq: logURL, je: mimetype, rE: nodeId, jv: runtimeDependencies, L: status};
	});
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $author$project$BuildPlanner$Object$ArtifactPermanentlyFailed$buildDuration = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Float', 'buildDuration', _List_Nil, $elm$json$Json$Decode$float);
var $author$project$BuildPlanner$Object$ArtifactPermanentlyFailed$displayName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'displayName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$ArtifactPermanentlyFailed$errors = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(List String)',
	'errors',
	_List_Nil,
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string));
var $author$project$BuildPlanner$Object$ArtifactPermanentlyFailed$lastBuildFinishedAt = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'BuildPlannerScalarCodecs.DateTime',
	'lastBuildFinishedAt',
	_List_Nil,
	$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).qE.qN);
var $author$project$BuildPlanner$Object$ArtifactPermanentlyFailed$logURL = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe BuildPlannerScalarCodecs.Uri)',
	'logURL',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).BQ.qN));
var $author$project$BuildPlanner$Object$ArtifactPermanentlyFailed$mimeType = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'mimeType', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$ArtifactPermanentlyFailed$nodeId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'BuildPlannerScalarCodecs.Id',
	'nodeId',
	_List_Nil,
	$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).oc.qN);
var $author$project$BuildPlanner$Object$ArtifactPermanentlyFailed$runtimeDependencies = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(List BuildPlannerScalarCodecs.Id)',
	'runtimeDependencies',
	_List_Nil,
	$elm$json$Json$Decode$list(
		$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).oc.qN));
var $author$project$BuildPlanner$Object$ArtifactPermanentlyFailed$status = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.ArtifactStatus.ArtifactStatus', 'status', _List_Nil, $author$project$BuildPlanner$Enum$ArtifactStatus$decoder);
var $author$project$Model$BuildPlanner$Artifact$toMillis = $dillonkearns$elm_graphql$Graphql$SelectionSet$map(
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Basics$mul(1000.0),
		$elm$core$Basics$round));
var $author$project$Model$BuildPlanner$Artifact$selectionSetPermanentlyFailed = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$author$project$Model$BuildPlanner$Artifact$Failed,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$ArtifactPermanentlyFailed$errors,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$BuildPlanner$Object$ArtifactPermanentlyFailed$logURL,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Model$BuildPlanner$Artifact$toMillis($author$project$BuildPlanner$Object$ArtifactPermanentlyFailed$buildDuration),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$BuildPlanner$Object$ArtifactPermanentlyFailed$lastBuildFinishedAt,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$BuildPlanner$Object$ArtifactPermanentlyFailed$status,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$BuildPlanner$Object$ArtifactPermanentlyFailed$runtimeDependencies,
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$BuildPlanner$Object$ArtifactPermanentlyFailed$mimeType,
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$BuildPlanner$Object$ArtifactPermanentlyFailed$displayName,
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$BuildPlanner$Object$ArtifactPermanentlyFailed$nodeId,
										$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$Artifact$FailedData)))))))))));
var $author$project$Model$BuildPlanner$Artifact$Succeeded = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$BuildPlanner$Artifact$SucceededData = function (nodeId) {
	return function (displayName) {
		return function (mimetype) {
			return function (runtimeDependencies) {
				return function (status) {
					return function (lastBuildTimestamp) {
						return function (buildDurationMillis) {
							return function (logURL) {
								return function (url) {
									return function (checksum) {
										return function (relatesTo) {
											return {sZ: buildDurationMillis, dE: checksum, i$: displayName, yY: lastBuildTimestamp, rq: logURL, je: mimetype, rE: nodeId, FA: relatesTo, jv: runtimeDependencies, L: status, GT: url};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$BuildPlanner$Object$ArtifactSucceeded$buildDuration = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Float', 'buildDuration', _List_Nil, $elm$json$Json$Decode$float);
var $author$project$BuildPlanner$Object$ArtifactSucceeded$checksum = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'checksum', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$ArtifactSucceeded$displayName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'displayName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$ArtifactSucceeded$lastBuildFinishedAt = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'BuildPlannerScalarCodecs.DateTime',
	'lastBuildFinishedAt',
	_List_Nil,
	$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).qE.qN);
var $author$project$BuildPlanner$Object$ArtifactSucceeded$logURL = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe BuildPlannerScalarCodecs.Uri)',
	'logURL',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).BQ.qN));
var $author$project$BuildPlanner$Object$ArtifactSucceeded$mimeType = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'mimeType', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$ArtifactSucceeded$nodeId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'BuildPlannerScalarCodecs.Id',
	'nodeId',
	_List_Nil,
	$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).oc.qN);
var $author$project$BuildPlanner$Object$ArtifactSucceeded$relatesTo = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'relatesTo',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$BuildPlanner$Object$ArtifactSucceeded$runtimeDependencies = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(List BuildPlannerScalarCodecs.Id)',
	'runtimeDependencies',
	_List_Nil,
	$elm$json$Json$Decode$list(
		$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).oc.qN));
var $author$project$BuildPlanner$Object$ArtifactSucceeded$status = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.ArtifactStatus.ArtifactStatus', 'status', _List_Nil, $author$project$BuildPlanner$Enum$ArtifactStatus$decoder);
var $author$project$BuildPlanner$Object$ArtifactSucceeded$url = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'BuildPlannerScalarCodecs.Uri',
	'url',
	_List_Nil,
	$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).BQ.qN);
var $author$project$Model$BuildPlanner$Artifact$selectionSetSucceeded = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$author$project$Model$BuildPlanner$Artifact$Succeeded,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$ArtifactSucceeded$relatesTo($author$project$Model$BuildPlanner$ComponentRelationship$selectionSet),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$BuildPlanner$Object$ArtifactSucceeded$checksum,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$BuildPlanner$Object$ArtifactSucceeded$url,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$BuildPlanner$Object$ArtifactSucceeded$logURL,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Model$BuildPlanner$Artifact$toMillis($author$project$BuildPlanner$Object$ArtifactSucceeded$buildDuration),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$BuildPlanner$Object$ArtifactSucceeded$lastBuildFinishedAt,
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$BuildPlanner$Object$ArtifactSucceeded$status,
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$BuildPlanner$Object$ArtifactSucceeded$runtimeDependencies,
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$BuildPlanner$Object$ArtifactSucceeded$mimeType,
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											$author$project$BuildPlanner$Object$ArtifactSucceeded$displayName,
											A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
												$author$project$BuildPlanner$Object$ArtifactSucceeded$nodeId,
												$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$Artifact$SucceededData)))))))))))));
var $author$project$BuildPlanner$Object$ArtifactTransientlyFailed$buildDuration = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Float', 'buildDuration', _List_Nil, $elm$json$Json$Decode$float);
var $author$project$BuildPlanner$Object$ArtifactTransientlyFailed$displayName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'displayName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$ArtifactTransientlyFailed$errors = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(List String)',
	'errors',
	_List_Nil,
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string));
var $author$project$BuildPlanner$Object$ArtifactTransientlyFailed$lastBuildFinishedAt = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'BuildPlannerScalarCodecs.DateTime',
	'lastBuildFinishedAt',
	_List_Nil,
	$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).qE.qN);
var $author$project$BuildPlanner$Object$ArtifactTransientlyFailed$logURL = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe BuildPlannerScalarCodecs.Uri)',
	'logURL',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).BQ.qN));
var $author$project$BuildPlanner$Object$ArtifactTransientlyFailed$mimeType = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'mimeType', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$ArtifactTransientlyFailed$nodeId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'BuildPlannerScalarCodecs.Id',
	'nodeId',
	_List_Nil,
	$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).oc.qN);
var $author$project$BuildPlanner$Object$ArtifactTransientlyFailed$runtimeDependencies = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(List BuildPlannerScalarCodecs.Id)',
	'runtimeDependencies',
	_List_Nil,
	$elm$json$Json$Decode$list(
		$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).oc.qN));
var $author$project$BuildPlanner$Object$ArtifactTransientlyFailed$status = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.ArtifactStatus.ArtifactStatus', 'status', _List_Nil, $author$project$BuildPlanner$Enum$ArtifactStatus$decoder);
var $author$project$Model$BuildPlanner$Artifact$selectionSetTransientlyFailed = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$author$project$Model$BuildPlanner$Artifact$Failed,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$ArtifactTransientlyFailed$errors,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$BuildPlanner$Object$ArtifactTransientlyFailed$logURL,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Model$BuildPlanner$Artifact$toMillis($author$project$BuildPlanner$Object$ArtifactTransientlyFailed$buildDuration),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$BuildPlanner$Object$ArtifactTransientlyFailed$lastBuildFinishedAt,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$BuildPlanner$Object$ArtifactTransientlyFailed$status,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$BuildPlanner$Object$ArtifactTransientlyFailed$runtimeDependencies,
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$BuildPlanner$Object$ArtifactTransientlyFailed$mimeType,
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$BuildPlanner$Object$ArtifactTransientlyFailed$displayName,
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$BuildPlanner$Object$ArtifactTransientlyFailed$nodeId,
										$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$Artifact$FailedData)))))))))));
var $author$project$Model$BuildPlanner$Artifact$Unbuilt = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$BuildPlanner$Artifact$UnbuiltData = F5(
	function (nodeId, displayName, mimetype, runtimeDependencies, status) {
		return {i$: displayName, je: mimetype, rE: nodeId, jv: runtimeDependencies, L: status};
	});
var $author$project$BuildPlanner$Object$ArtifactUnbuilt$displayName = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'displayName', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$ArtifactUnbuilt$mimeType = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'mimeType', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$ArtifactUnbuilt$nodeId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'BuildPlannerScalarCodecs.Id',
	'nodeId',
	_List_Nil,
	$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).oc.qN);
var $author$project$BuildPlanner$Object$ArtifactUnbuilt$runtimeDependencies = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(List BuildPlannerScalarCodecs.Id)',
	'runtimeDependencies',
	_List_Nil,
	$elm$json$Json$Decode$list(
		$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).oc.qN));
var $author$project$BuildPlanner$Object$ArtifactUnbuilt$status = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.ArtifactStatus.ArtifactStatus', 'status', _List_Nil, $author$project$BuildPlanner$Enum$ArtifactStatus$decoder);
var $author$project$Model$BuildPlanner$Artifact$selectionSetUnbuilt = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$author$project$Model$BuildPlanner$Artifact$Unbuilt,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$ArtifactUnbuilt$status,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$BuildPlanner$Object$ArtifactUnbuilt$runtimeDependencies,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$BuildPlanner$Object$ArtifactUnbuilt$mimeType,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$BuildPlanner$Object$ArtifactUnbuilt$displayName,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$BuildPlanner$Object$ArtifactUnbuilt$nodeId,
						$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$Artifact$UnbuiltData)))))));
var $author$project$Model$BuildPlanner$Node$selectionSet = $author$project$BuildPlanner$Union$Node$fragments(
	{
		uZ: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Model$BuildPlanner$Node$ArtifactNode, $author$project$Model$BuildPlanner$Artifact$selectionSetPermanentlyFailed),
		u_: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Model$BuildPlanner$Node$ArtifactNode, $author$project$Model$BuildPlanner$Artifact$selectionSetBuilding),
		u$: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Model$BuildPlanner$Node$ArtifactNode, $author$project$Model$BuildPlanner$Artifact$selectionSetSucceeded),
		u0: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Model$BuildPlanner$Node$ArtifactNode, $author$project$Model$BuildPlanner$Artifact$selectionSetTransientlyFailed),
		u1: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Model$BuildPlanner$Node$ArtifactNode, $author$project$Model$BuildPlanner$Artifact$selectionSetUnbuilt),
		vm: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Model$BuildPlanner$Node$MissingSourceNode, $author$project$Model$BuildPlanner$MissingSource$selectionSet),
		vA: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Model$BuildPlanner$Node$SourceNode, $author$project$Model$BuildPlanner$Source$selectionSet)
	});
var $author$project$Model$BuildPlanner$BuildPlan$selectionSetBuildResult = A2(
	$author$project$BuildPlanner$Object$Commit$build,
	$elm$core$Basics$identity,
	$author$project$BuildPlanner$Union$BuildResult$fragments(
		{
			u2: A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
				function (nodes) {
					return A2(
						$elm$core$List$any,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Model$BuildPlanner$Node$artifact,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$map($author$project$Model$BuildPlanner$Artifact$isFailed),
								$elm$core$Maybe$withDefault(false))),
						nodes) ? 1 : 0;
				},
				$author$project$BuildPlanner$Object$BuildCompleted$nodes($author$project$Model$BuildPlanner$Node$selectionSet)),
			u3: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(2),
			u4: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(2),
			u5: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(2),
			vr: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(1)
		}));
var $author$project$Request$BuildPlanner$getBuildResult = F2(
	function (session, key) {
		return A2(
			$author$project$Request$BuildPlanner$getByCommit,
			session,
			{Y: key, ke: $elm$core$Maybe$Nothing, kf: $elm$core$Maybe$Nothing, ki: $author$project$Model$BuildPlanner$BuildPlan$selectionSetBuildResult, kj: 'GetBuildStatus'});
	});
var $author$project$Pages$ProjectSettingsHAR$fieldMeta = function (field) {
	if (!field.$) {
		var f = field.a;
		return f;
	} else {
		var f = field.a;
		return f;
	}
};
var $author$project$Pages$ProjectSettingsHAR$getFieldValue = A2(
	$elm$core$Basics$composeR,
	$author$project$Pages$ProjectSettingsHAR$fieldMeta,
	function ($) {
		return $.kH;
	});
var $author$project$Pages$ProjectSettingsHAR$getTagFormFromState = function (ts) {
	if (!ts.$) {
		var tf = ts.a;
		return tf;
	} else {
		var tf = ts.a;
		return tf;
	}
};
var $author$project$Pages$ProjectSettingsHAR$buildStatusCmdFromTagEx = F3(
	function (session, model, tagState) {
		var _v0 = $danyx23$elm_uuid$Uuid$fromString(
			$author$project$Pages$ProjectSettingsHAR$getFieldValue(
				$author$project$Pages$ProjectSettingsHAR$getTagFormFromState(tagState).BR));
		if (_v0.$ === 1) {
			return $elm$core$Platform$Cmd$none;
		} else {
			var commitID = _v0.a;
			var key = {
				BR: commitID,
				ix: $author$project$Model$Organization$getUrlName(model.c3),
				vT: $author$project$Model$Project$getName(model.c5)
			};
			return A2(
				$elm$core$Task$attempt,
				$author$project$Pages$ProjectSettingsHAR$BuildStarted(tagState),
				A2($author$project$Request$BuildPlanner$getBuildResult, session, key));
		}
	});
var $author$project$Pages$ProjectSettingsHAR$isNewTag = function (ts) {
	if (!ts.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pages$ProjectSettingsHAR$cmds = F2(
	function (session, model) {
		return $elm$core$Platform$Cmd$batch(
			A2(
				$elm$core$List$map,
				function (tagEx) {
					return A3($author$project$Pages$ProjectSettingsHAR$buildStatusCmdFromTagEx, session, model, tagEx);
				},
				A2(
					$elm$core$List$filter,
					A2($elm$core$Basics$composeR, $author$project$Pages$ProjectSettingsHAR$isNewTag, $elm$core$Basics$not),
					model.Gt)));
	});
var $author$project$Model$Compliance$companyName = function (c) {
	if (c.$ === 1) {
		var orgName = c.a;
		return orgName;
	} else {
		var orgName = c.a;
		return orgName;
	}
};
var $author$project$Ports$copyToClipboard = _Platform_outgoingPort(
	'copyToClipboard',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'copyID',
					$elm$json$Json$Encode$string($.xN)),
					_Utils_Tuple2(
					'text',
					$elm$json$Json$Encode$string($.Gv))
				]));
	});
var $author$project$Model$Notification$Text = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$Notification$Warning = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$Message$Message = F2(
	function (code, message) {
		return {xD: code, Eh: message};
	});
var $author$project$Model$Message$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'message',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'code',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Model$Message$Message)));
var $author$project$Model$Message$fromString = $elm$json$Json$Decode$decodeString($author$project$Model$Message$decode);
var $author$project$Model$Message$responseToReasonWithCode = function (response) {
	var _v0 = function () {
		var _v1 = $author$project$Model$Message$fromString(response.sY);
		if (!_v1.$) {
			var msg = _v1.a;
			return _Utils_Tuple2(
				msg.Eh,
				$elm$core$Maybe$Just(msg.xD));
		} else {
			return _Utils_Tuple2(
				function () {
					var _v2 = response.wq;
					if (_v2 === '') {
						return response.sY;
					} else {
						return response.wq;
					}
				}(),
				$elm$core$Maybe$Nothing);
		}
	}();
	var rawMessage = _v0.a;
	var messageCode = _v0.b;
	var normalized = $elm$core$String$toLower(
		$elm$core$String$trim(rawMessage));
	var message = (A2($elm$core$String$startsWith, '<html', normalized) || A2($elm$core$String$startsWith, '<!doctype html', normalized)) ? ('HTTP error: ' + $elm$core$String$fromInt(response.wp)) : rawMessage;
	return {mx: messageCode, cg: message};
};
var $author$project$Model$Message$reasonWithCode = function (err) {
	var _v0 = err.mp;
	switch (_v0.$) {
		case 2:
			return {mx: $elm$core$Maybe$Nothing, cg: 'Network Error'};
		case 1:
			return {mx: $elm$core$Maybe$Nothing, cg: 'Timeout'};
		case 3:
			var resp = _v0.a;
			return $author$project$Model$Message$responseToReasonWithCode(resp);
		case 0:
			return {mx: $elm$core$Maybe$Nothing, cg: 'Invalid url: ' + err.GT};
		default:
			var failedReason = _v0.a;
			return {mx: $elm$core$Maybe$Nothing, cg: 'Server gave an unexpected response: ' + failedReason};
	}
};
var $author$project$Model$Message$reason = function (err) {
	return $author$project$Model$Message$reasonWithCode(err).cg;
};
var $author$project$Model$Notification$fromError = function (err) {
	return $author$project$Model$Notification$Warning(
		_List_fromArray(
			[
				$author$project$Model$Notification$Text(
				$author$project$Model$Message$reason(err))
			]));
};
var $author$project$Model$LocalStorage$superUserFeaturesHiddenValue = 'hidden';
var $author$project$Model$Session$getSuperUserFeaturesVisible = function (_v0) {
	var session = _v0;
	return !_Utils_eq(
		A2($author$project$Model$LocalStorage$get, $author$project$Model$LocalStorage$superUserFeaturesHiddenKey, session.fu),
		$elm$core$Maybe$Just($author$project$Model$LocalStorage$superUserFeaturesHiddenValue));
};
var $author$project$Url$Extra$corporateSiteDomain = 'https://www.activestate.com';
var $elm$url$Url$Builder$crossOrigin = F3(
	function (prePath, pathSegments, parameters) {
		return prePath + ('/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters)));
	});
var $author$project$Url$Extra$createUrl = F3(
	function (base, path, queryParams) {
		return A3(
			$elm$url$Url$Builder$crossOrigin,
			base,
			path,
			A2(
				$elm$core$List$map,
				function (_v0) {
					var key = _v0.a;
					var value = _v0.b;
					return A2($elm$url$Url$Builder$string, key, value);
				},
				queryParams));
	});
var $author$project$Url$Extra$contactSales = function (queryParams) {
	return A3(
		$author$project$Url$Extra$createUrl,
		$author$project$Url$Extra$corporateSiteDomain,
		_List_fromArray(
			['solutions', 'contact-sales']),
		queryParams);
};
var $author$project$Url$Extra$eula = function (queryParams) {
	return A3(
		$author$project$Url$Extra$createUrl,
		$author$project$Url$Extra$corporateSiteDomain,
		_List_fromArray(
			['support', 'eulas']),
		queryParams);
};
var $author$project$Pages$OutOfCompliance$init = function (companyName) {
	return {
		tg: companyName,
		tN: $author$project$Url$Extra$eula(
			_List_fromArray(
				[
					_Utils_Tuple2('platform', 'compliance')
				])),
		sh: $author$project$Url$Extra$contactSales(
			_List_fromArray(
				[
					_Utils_Tuple2('platform', 'compliance')
				]))
	};
};
var $author$project$Msg$ReceivedInvitations = function (a) {
	return {$: 107, a: a};
};
var $author$project$Model$Invitation$Invitation = F7(
	function (added, changed, email, invitedBy, inviteCode, organization, isExpired) {
		return {ak: added, g: changed, lJ: email, fs: inviteCode, C1: invitedBy, Dg: isExpired, c3: organization};
	});
var $author$project$Model$NonEmptyString$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		var _v0 = $author$project$Model$NonEmptyString$fromString(s);
		if (!_v0.$) {
			var nonEmpty = _v0.a;
			return $elm$json$Json$Decode$succeed(nonEmpty);
		} else {
			return $elm$json$Json$Decode$fail('Got an empty string when decoding a NonEmptyString');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$Organization$None = {$: 4};
var $author$project$Model$Organization$Organization = function (added) {
	return function (addOns) {
		return function (billingDate) {
			return function (displayName) {
				return function (hasEverHadTrial) {
					return function (memberCount) {
						return function (organizationID) {
							return function (subscription) {
								return function (tier) {
									return function (urlName) {
										return function (beenOnTrialTier) {
											return function (trialEnds) {
												return {sP: addOns, ak: added, Bf: beenOnTrialTier, xn: billingDate, i$: displayName, CM: hasEverHadTrial, Eg: memberCount, zw: organizationID, wv: subscription, dc: tier, Ay: trialEnds, AC: urlName};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Model$AddOns$AddOn = F5(
	function (enabled, description, name, category, is_default) {
		return {xA: category, bP: description, Cp: enabled, yQ: is_default, w: name};
	});
var $author$project$Model$AddOns$decodeAddOn = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'isDefault',
	$elm$json$Json$Decode$bool,
	true,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'category',
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'name',
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'description',
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'enabled',
					$elm$json$Json$Decode$bool,
					false,
					$elm$json$Json$Decode$succeed($author$project$Model$AddOns$AddOn))))));
var $author$project$Model$AddOns$decode = $elm$json$Json$Decode$dict($author$project$Model$AddOns$decodeAddOn);
var $author$project$Model$Organization$Active = {$: 0};
var $author$project$Model$Organization$Cancelled = {$: 1};
var $author$project$Model$Organization$Expired = {$: 2};
var $author$project$Model$Organization$Trial = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$Organization$decodeSubscriptionString = function (str) {
	switch (str) {
		case 'active':
			return $author$project$Model$Organization$Active;
		case 'cancelled':
			return $author$project$Model$Organization$Cancelled;
		case 'expired':
			return $author$project$Model$Organization$Expired;
		case 'active_trial':
			return $author$project$Model$Organization$Trial($author$project$Model$Organization$Active);
		case 'cancelled_trial':
			return $author$project$Model$Organization$Trial($author$project$Model$Organization$Cancelled);
		default:
			return $author$project$Model$Organization$None;
	}
};
var $author$project$Model$Organization$decode = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'trialEnds',
	$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
	$elm$time$Time$millisToPosix(0),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'beenOnTrialTier',
		$elm$json$Json$Decode$bool,
		false,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'URLname',
			$elm$json$Json$Decode$string,
			'missing',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'tier',
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'subscriptionStatus',
					A2($elm$json$Json$Decode$map, $author$project$Model$Organization$decodeSubscriptionString, $elm$json$Json$Decode$string),
					$author$project$Model$Organization$None,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'organizationID',
						$danyx23$elm_uuid$Uuid$decoder,
						A3(
							$author$project$Json$Decode$Pipeline$Extra$decodeMaybe,
							'memberCount',
							$elm$json$Json$Decode$int,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'hasEverHadTrial',
								$elm$json$Json$Decode$bool,
								false,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'displayName',
									$elm$json$Json$Decode$string,
									A3(
										$author$project$Json$Decode$Pipeline$Extra$decodeMaybe,
										'billingDate',
										$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'addOns',
											$author$project$Model$AddOns$decode,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'added',
												$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
												$elm$json$Json$Decode$succeed($author$project$Model$Organization$Organization)))))))))))));
var $author$project$Model$Invitation$decode = function (expectEmail) {
	var emailDecoder = expectEmail ? A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'email', $elm$json$Json$Decode$string) : $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded('');
	return A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'isExpired',
		$elm$json$Json$Decode$bool,
		false,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'organization',
			$author$project$Model$Organization$decode,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'inviteCode',
				$elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Model$NonEmptyString$decode),
							$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
						])),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'invitedBy',
					$elm$json$Json$Decode$string,
					emailDecoder(
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'changed',
							$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'added',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Model$Invitation$Invitation))))))));
};
var $author$project$Request$Invitation$getAll = function (creds) {
	return $author$project$Http$Extra$get(
		{
			iO: $author$project$Http$Extra$Creds(creds),
			sY: $author$project$Http$Extra$emptyBody,
			qN: $elm$json$Json$Decode$list(
				$author$project$Model$Invitation$decode(true)),
			CN: _List_Nil,
			GT: '/invitations'
		});
};
var $author$project$Main$invitationsCmd = function (session) {
	return A2(
		$elm$core$Task$attempt,
		$author$project$Msg$ReceivedInvitations,
		A2(
			$elm$core$Task$onError,
			function (err) {
				var _v0 = err.mp;
				if (_v0.$ === 3) {
					var response = _v0.a;
					return (response.wp === 404) ? $elm$core$Task$succeed(_List_Nil) : $elm$core$Task$fail(err);
				} else {
					return $elm$core$Task$fail(err);
				}
			},
			A2(
				$elm$core$Task$map,
				$elm$core$List$filter(
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Basics$not,
						function ($) {
							return $.Dg;
						})),
				$author$project$Request$Invitation$getAll(
					$author$project$Model$Session$getCreds(session)))));
};
var $author$project$PageState$isPageLoading = function (pageState) {
	if (!pageState.$) {
		return false;
	} else {
		return true;
	}
};
var $author$project$Model$User$isPaidUser = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map(
		function ($) {
			return $.un;
		}),
	$elm$core$Maybe$withDefault(false));
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $author$project$PageState$load = F2(
	function (pageState, newPage) {
		if (!pageState.$) {
			var state = pageState.a;
			return $author$project$PageState$Loaded(
				_Utils_update(
					state,
					{jK: newPage}));
		} else {
			var nextRoute = pageState.a.dg;
			return $author$project$PageState$Loaded(
				{jK: newPage, jL: nextRoute});
		}
	});
var $author$project$Ports$loadHubSpotChat = _Platform_outgoingPort(
	'loadHubSpotChat',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Model$Route$emptyLoginParams = {g$: $elm$core$Maybe$Nothing, dH: 2, lJ: $elm$core$Maybe$Nothing, lP: $elm$core$Maybe$Nothing, hx: $elm$core$Maybe$Nothing, fs: $elm$core$Maybe$Nothing, dg: $elm$core$Maybe$Nothing, pC: false, o: $elm$core$Maybe$Nothing};
var $author$project$Model$Route$login = $author$project$Model$Route$Login($author$project$Model$Route$emptyLoginParams);
var $author$project$Request$User$logout = $author$project$Http$Extra$get(
	{
		iO: $author$project$Http$Extra$None,
		sY: $author$project$Http$Extra$emptyBody,
		qN: $elm$json$Json$Decode$succeed(0),
		CN: _List_Nil,
		GT: $author$project$Http$Extra$urlBase + '/logout'
	});
var $author$project$Model$Route$orgIndex = F2(
	function (orgName, maybeSingupSource) {
		return $author$project$Model$Route$Protected(
			$author$project$Model$Route$Org(
				A2(
					$author$project$Model$Route$OrgParams,
					orgName,
					$author$project$Model$Route$OrgIndex(maybeSingupSource))));
	});
var $author$project$Ports$removeHubSpotChat = _Platform_outgoingPort(
	'removeHubSpotChat',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Model$Session$getInvitations = function (_v0) {
	var session = _v0;
	return session.jb;
};
var $author$project$Model$Session$setInviations = F2(
	function (_v0, invites) {
		var session = _v0;
		return _Utils_update(
			session,
			{jb: invites});
	});
var $author$project$Model$Session$removeInvitesForOrg = F2(
	function (orgUrlName, session) {
		return A2(
			$author$project$Model$Session$setInviations,
			session,
			A2(
				$elm$core$List$filter,
				function (i) {
					return !_Utils_eq(i.c3.AC, orgUrlName);
				},
				$author$project$Model$Session$getInvitations(session)));
	});
var $author$project$Model$Session$reset = function (_v0) {
	var session = _v0;
	return A3($author$project$Model$Session$initInternal, session.qX, session.rp, session.fu);
};
var $NoRedInk$elm_rollbar$Rollbar$Error = 1;
var $NoRedInk$elm_rollbar$Rollbar$Warning = 2;
var $NoRedInk$elm_rollbar$Rollbar$CodeVersion = $elm$core$Basics$identity;
var $NoRedInk$elm_rollbar$Rollbar$codeVersion = $elm$core$Basics$identity;
var $author$project$Misc$consMaybe = F2(
	function (maybe, xs) {
		if (!maybe.$) {
			var x = maybe.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $author$project$Model$Role$toInternalString = function (role) {
	switch (role) {
		case 2:
			return 'admin';
		case 1:
			return 'editor';
		default:
			return 'reader';
	}
};
var $author$project$Model$Role$encode = A2($elm$core$Basics$composeR, $author$project$Model$Role$toInternalString, $elm$json$Json$Encode$string);
var $author$project$Model$Membership$encode = function (m) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'URLname',
				$elm$json$Json$Encode$string(m.AC)),
				_Utils_Tuple2(
				'organizationID',
				$danyx23$elm_uuid$Uuid$encode(m.zw)),
				_Utils_Tuple2(
				'role',
				$author$project$Model$Role$encode(m.FO)),
				_Utils_Tuple2(
				'tier',
				$elm$json$Json$Encode$string(m.dc)),
				_Utils_Tuple2(
				'created',
				$rtfeldman$elm_iso8601_date_strings$Iso8601$encode(m.ts)),
				_Utils_Tuple2(
				'joined',
				$rtfeldman$elm_iso8601_date_strings$Iso8601$encode(m.ts))
			]));
};
var $author$project$Model$ACL$toList = function (_v0) {
	var l = _v0;
	return l;
};
var $author$project$Model$ACL$has = F2(
	function (priv, acl) {
		return A2(
			$elm$core$List$member,
			priv,
			$author$project$Model$ACL$toList(acl));
	});
var $author$project$Model$ACL$encodeACL = function (acl) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'superuser',
				$elm$json$Json$Encode$bool(
					A2($author$project$Model$ACL$has, 0, acl))),
				_Utils_Tuple2(
				'superuser-readonly',
				$elm$json$Json$Encode$bool(
					A2($author$project$Model$ACL$has, 1, acl)))
			]));
};
var $author$project$Model$User$encodeForRollbar = function (u) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'userID',
				$elm$json$Json$Encode$string(u.wV)),
				_Utils_Tuple2(
				'added',
				$elm$json$Json$Encode$string(u.ak)),
				_Utils_Tuple2(
				'lastLogin',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, u.yZ))),
				_Utils_Tuple2(
				'EULAAccepted',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, u.tM))),
				_Utils_Tuple2(
				'username',
				$elm$json$Json$Encode$string(u.AE)),
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(u.lJ)),
				_Utils_Tuple2(
				'organizations',
				A2($elm$json$Json$Encode$list, $author$project$Model$Membership$encode, u.mX)),
				_Utils_Tuple2(
				'timezone',
				$elm$json$Json$Encode$string(u.eR)),
				_Utils_Tuple2(
				'datetimeFormat',
				$elm$json$Json$Encode$string(u.xS)),
				_Utils_Tuple2(
				'expires',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, u.yi))),
				_Utils_Tuple2(
				'TOTPEnabled',
				$elm$json$Json$Encode$bool(u.Aw)),
				_Utils_Tuple2(
				'verifiedEmail',
				$elm$json$Json$Encode$bool(u.w1)),
				_Utils_Tuple2(
				'acl',
				$author$project$Model$ACL$encodeACL(u.qa)),
				_Utils_Tuple2(
				'isPaidUser',
				$elm$json$Json$Encode$bool(u.un)),
				_Utils_Tuple2(
				'isUsernameAutogenerated',
				$elm$json$Json$Encode$bool(u.DJ))
			]));
};
var $NoRedInk$elm_rollbar$Rollbar$Environment = $elm$core$Basics$identity;
var $NoRedInk$elm_rollbar$Rollbar$environment = $elm$core$Basics$identity;
var $author$project$Model$Session$getFlags = function (_v0) {
	var session = _v0;
	return session.qX;
};
var $NoRedInk$elm_rollbar$Rollbar$Scope = $elm$core$Basics$identity;
var $NoRedInk$elm_rollbar$Rollbar$scope = $elm$core$Basics$identity;
var $NoRedInk$elm_rollbar$Rollbar$endpointUrl = 'https://api.rollbar.com/api/1/item/';
var $NoRedInk$elm_rollbar$Rollbar$levelToString = function (report) {
	switch (report) {
		case 0:
			return 'critical';
		case 4:
			return 'debug';
		case 1:
			return 'error';
		case 3:
			return 'info';
		default:
			return 'warning';
	}
};
var $NoRedInk$elm_rollbar$Rollbar$Internal$version = '2.0.0';
var $NoRedInk$elm_rollbar$Rollbar$toJsonBody = F8(
	function (_v0, _v1, _v2, _v3, level, message, uuid, metadata) {
		var vtoken = _v0;
		var vscope = _v1;
		var vcodeVersion = _v2;
		var venvironment = _v3;
		return $elm$http$Http$jsonBody(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'access_token',
						$elm$json$Json$Encode$string(vtoken)),
						_Utils_Tuple2(
						'data',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'environment',
									$elm$json$Json$Encode$string(venvironment)),
									_Utils_Tuple2(
									'context',
									$elm$json$Json$Encode$string(vscope)),
									_Utils_Tuple2(
									'uuid',
									$danyx23$elm_uuid$Uuid$encode(uuid)),
									_Utils_Tuple2(
									'client',
									$elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'elm',
												$elm$json$Json$Encode$object(
													_List_fromArray(
														[
															_Utils_Tuple2(
															'code_version',
															$elm$json$Json$Encode$string(vcodeVersion))
														])))
											]))),
									_Utils_Tuple2(
									'notifier',
									$elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'name',
												$elm$json$Json$Encode$string('elm-rollbar')),
												_Utils_Tuple2(
												'version',
												$elm$json$Json$Encode$string($NoRedInk$elm_rollbar$Rollbar$Internal$version))
											]))),
									_Utils_Tuple2(
									'level',
									$elm$json$Json$Encode$string(
										$NoRedInk$elm_rollbar$Rollbar$levelToString(level))),
									_Utils_Tuple2(
									'endpoint',
									$elm$json$Json$Encode$string($NoRedInk$elm_rollbar$Rollbar$endpointUrl)),
									_Utils_Tuple2(
									'platform',
									$elm$json$Json$Encode$string('browser')),
									_Utils_Tuple2(
									'language',
									$elm$json$Json$Encode$string('Elm')),
									_Utils_Tuple2(
									'body',
									$elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'message',
												$elm$json$Json$Encode$object(
													A2(
														$elm$core$List$cons,
														_Utils_Tuple2(
															'body',
															$elm$json$Json$Encode$string(message)),
														$elm$core$Dict$toList(metadata))))
											])))
								])))
					])));
	});
var $NoRedInk$elm_rollbar$Rollbar$tokenHeader = function (_v0) {
	var vtoken = _v0;
	return A2($elm$http$Http$header, 'X-Rollbar-Access-Token', vtoken);
};
var $elm$json$Json$Encode$dict = F3(
	function (toKey, toValue, dictionary) {
		return _Json_wrap(
			A3(
				$elm$core$Dict$foldl,
				F3(
					function (key, value, obj) {
						return A3(
							_Json_addField,
							toKey(key),
							toValue(value),
							obj);
					}),
				_Json_emptyObject(0),
				dictionary));
	});
var $NoRedInk$elm_rollbar$Murmur3$HashData = F4(
	function (shift, seed, hash, charsProcessed) {
		return {k7: charsProcessed, l3: hash, ku: seed, nu: shift};
	});
var $NoRedInk$elm_rollbar$Murmur3$c1 = 3432918353;
var $NoRedInk$elm_rollbar$Murmur3$c2 = 461845907;
var $NoRedInk$elm_rollbar$Murmur3$multiplyBy = F2(
	function (b, a) {
		return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
	});
var $NoRedInk$elm_rollbar$Murmur3$rotlBy = F2(
	function (b, a) {
		return (a << b) | (a >>> (32 - b));
	});
var $NoRedInk$elm_rollbar$Murmur3$finalize = function (data) {
	var acc = (!(!data.l3)) ? (data.ku ^ A2(
		$NoRedInk$elm_rollbar$Murmur3$multiplyBy,
		$NoRedInk$elm_rollbar$Murmur3$c2,
		A2(
			$NoRedInk$elm_rollbar$Murmur3$rotlBy,
			15,
			A2($NoRedInk$elm_rollbar$Murmur3$multiplyBy, $NoRedInk$elm_rollbar$Murmur3$c1, data.l3)))) : data.ku;
	var h0 = acc ^ data.k7;
	var h1 = A2($NoRedInk$elm_rollbar$Murmur3$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
	var h2 = A2($NoRedInk$elm_rollbar$Murmur3$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
	return (h2 ^ (h2 >>> 16)) >>> 0;
};
var $NoRedInk$elm_rollbar$Murmur3$mix = F2(
	function (h1, k1) {
		return A2(
			$NoRedInk$elm_rollbar$Murmur3$multiplyBy,
			5,
			A2(
				$NoRedInk$elm_rollbar$Murmur3$rotlBy,
				13,
				h1 ^ A2(
					$NoRedInk$elm_rollbar$Murmur3$multiplyBy,
					$NoRedInk$elm_rollbar$Murmur3$c2,
					A2(
						$NoRedInk$elm_rollbar$Murmur3$rotlBy,
						15,
						A2($NoRedInk$elm_rollbar$Murmur3$multiplyBy, $NoRedInk$elm_rollbar$Murmur3$c1, k1))))) + 3864292196;
	});
var $NoRedInk$elm_rollbar$Murmur3$hashFold = F2(
	function (c, data) {
		var res = data.l3 | ((255 & $elm$core$Char$toCode(c)) << data.nu);
		var _v0 = data.nu;
		if (_v0 === 24) {
			return {
				k7: data.k7 + 1,
				l3: 0,
				ku: A2($NoRedInk$elm_rollbar$Murmur3$mix, data.ku, res),
				nu: 0
			};
		} else {
			return {k7: data.k7 + 1, l3: res, ku: data.ku, nu: data.nu + 8};
		}
	});
var $NoRedInk$elm_rollbar$Murmur3$hashString = F2(
	function (seed, str) {
		return $NoRedInk$elm_rollbar$Murmur3$finalize(
			A3(
				$elm$core$String$foldl,
				$NoRedInk$elm_rollbar$Murmur3$hashFold,
				A4($NoRedInk$elm_rollbar$Murmur3$HashData, 0, seed, 0, 0),
				str));
	});
var $elm$random$Random$Seed = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$random$Random$next = function (_v0) {
	var state0 = _v0.a;
	var incr = _v0.b;
	return A2($elm$random$Random$Seed, ((state0 * 1664525) + incr) >>> 0, incr);
};
var $elm$random$Random$initialSeed = function (x) {
	var _v0 = $elm$random$Random$next(
		A2($elm$random$Random$Seed, 0, 1013904223));
	var state1 = _v0.a;
	var incr = _v0.b;
	var state2 = (state1 + x) >>> 0;
	return $elm$random$Random$next(
		A2($elm$random$Random$Seed, state2, incr));
};
var $elm$random$Random$step = F2(
	function (_v0, seed) {
		var generator = _v0;
		return generator(seed);
	});
var $elm$random$Random$Generator = $elm$core$Basics$identity;
var $elm$random$Random$map = F2(
	function (func, _v0) {
		var genA = _v0;
		return function (seed0) {
			var _v1 = genA(seed0);
			var a = _v1.a;
			var seed1 = _v1.b;
			return _Utils_Tuple2(
				func(a),
				seed1);
		};
	});
var $elm$random$Random$peel = function (_v0) {
	var state = _v0.a;
	var word = (state ^ (state >>> ((state >>> 28) + 4))) * 277803737;
	return ((word >>> 22) ^ word) >>> 0;
};
var $elm$random$Random$int = F2(
	function (a, b) {
		return function (seed0) {
			var _v0 = (_Utils_cmp(a, b) < 0) ? _Utils_Tuple2(a, b) : _Utils_Tuple2(b, a);
			var lo = _v0.a;
			var hi = _v0.b;
			var range = (hi - lo) + 1;
			if (!((range - 1) & range)) {
				return _Utils_Tuple2(
					(((range - 1) & $elm$random$Random$peel(seed0)) >>> 0) + lo,
					$elm$random$Random$next(seed0));
			} else {
				var threshhold = (((-range) >>> 0) % range) >>> 0;
				var accountForBias = function (seed) {
					accountForBias:
					while (true) {
						var x = $elm$random$Random$peel(seed);
						var seedN = $elm$random$Random$next(seed);
						if (_Utils_cmp(x, threshhold) < 0) {
							var $temp$seed = seedN;
							seed = $temp$seed;
							continue accountForBias;
						} else {
							return _Utils_Tuple2((x % range) + lo, seedN);
						}
					}
				};
				return accountForBias(seed0);
			}
		};
	});
var $danyx23$elm_uuid$Uuid$Barebones$hexGenerator = A2($elm$random$Random$int, 0, 15);
var $elm$random$Random$listHelp = F4(
	function (revList, n, gen, seed) {
		listHelp:
		while (true) {
			if (n < 1) {
				return _Utils_Tuple2(revList, seed);
			} else {
				var _v0 = gen(seed);
				var value = _v0.a;
				var newSeed = _v0.b;
				var $temp$revList = A2($elm$core$List$cons, value, revList),
					$temp$n = n - 1,
					$temp$gen = gen,
					$temp$seed = newSeed;
				revList = $temp$revList;
				n = $temp$n;
				gen = $temp$gen;
				seed = $temp$seed;
				continue listHelp;
			}
		}
	});
var $elm$random$Random$list = F2(
	function (n, _v0) {
		var gen = _v0;
		return function (seed) {
			return A4($elm$random$Random$listHelp, _List_Nil, n, gen, seed);
		};
	});
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$String$fromList = _String_fromList;
var $danyx23$elm_uuid$Uuid$Barebones$limitDigitRange8ToB = function (digit) {
	return (digit & 3) | 8;
};
var $danyx23$elm_uuid$Uuid$Barebones$hexDigits = function () {
	var mapChars = F2(
		function (offset, digit) {
			return $elm$core$Char$fromCode(digit + offset);
		});
	return $elm$core$Array$fromList(
		_Utils_ap(
			A2(
				$elm$core$List$map,
				mapChars(48),
				A2($elm$core$List$range, 0, 9)),
			A2(
				$elm$core$List$map,
				mapChars(97),
				A2($elm$core$List$range, 0, 5))));
}();
var $danyx23$elm_uuid$Uuid$Barebones$mapToHex = function (index) {
	var maybeResult = A2($elm$core$Array$get, index, $danyx23$elm_uuid$Uuid$Barebones$hexDigits);
	if (maybeResult.$ === 1) {
		return 'x';
	} else {
		var result = maybeResult.a;
		return result;
	}
};
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $danyx23$elm_uuid$Uuid$Barebones$toUuidString = function (thirtyOneHexDigits) {
	return $elm$core$String$concat(
		_List_fromArray(
			[
				$elm$core$String$fromList(
				A2(
					$elm$core$List$map,
					$danyx23$elm_uuid$Uuid$Barebones$mapToHex,
					A2($elm$core$List$take, 8, thirtyOneHexDigits))),
				'-',
				$elm$core$String$fromList(
				A2(
					$elm$core$List$map,
					$danyx23$elm_uuid$Uuid$Barebones$mapToHex,
					A2(
						$elm$core$List$take,
						4,
						A2($elm$core$List$drop, 8, thirtyOneHexDigits)))),
				'-',
				'4',
				$elm$core$String$fromList(
				A2(
					$elm$core$List$map,
					$danyx23$elm_uuid$Uuid$Barebones$mapToHex,
					A2(
						$elm$core$List$take,
						3,
						A2($elm$core$List$drop, 12, thirtyOneHexDigits)))),
				'-',
				$elm$core$String$fromList(
				A2(
					$elm$core$List$map,
					$danyx23$elm_uuid$Uuid$Barebones$mapToHex,
					A2(
						$elm$core$List$map,
						$danyx23$elm_uuid$Uuid$Barebones$limitDigitRange8ToB,
						A2(
							$elm$core$List$take,
							1,
							A2($elm$core$List$drop, 15, thirtyOneHexDigits))))),
				$elm$core$String$fromList(
				A2(
					$elm$core$List$map,
					$danyx23$elm_uuid$Uuid$Barebones$mapToHex,
					A2(
						$elm$core$List$take,
						3,
						A2($elm$core$List$drop, 16, thirtyOneHexDigits)))),
				'-',
				$elm$core$String$fromList(
				A2(
					$elm$core$List$map,
					$danyx23$elm_uuid$Uuid$Barebones$mapToHex,
					A2(
						$elm$core$List$take,
						12,
						A2($elm$core$List$drop, 19, thirtyOneHexDigits))))
			]));
};
var $danyx23$elm_uuid$Uuid$Barebones$uuidStringGenerator = A2(
	$elm$random$Random$map,
	$danyx23$elm_uuid$Uuid$Barebones$toUuidString,
	A2($elm$random$Random$list, 31, $danyx23$elm_uuid$Uuid$Barebones$hexGenerator));
var $danyx23$elm_uuid$Uuid$uuidGenerator = A2($elm$random$Random$map, $elm$core$Basics$identity, $danyx23$elm_uuid$Uuid$Barebones$uuidStringGenerator);
var $NoRedInk$elm_rollbar$Rollbar$uuidFrom = F7(
	function (_v0, _v1, _v2, level, message, metadata, time) {
		var vtoken = _v0;
		var vscope = _v1;
		var venvironment = _v2;
		var ms = $elm$time$Time$posixToMillis(time);
		var hash = A2(
			$NoRedInk$elm_rollbar$Murmur3$hashString,
			ms,
			A2(
				$elm$json$Json$Encode$encode,
				0,
				A2(
					$elm$json$Json$Encode$list,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$elm$json$Json$Encode$string(
							$NoRedInk$elm_rollbar$Rollbar$levelToString(level)),
							$elm$json$Json$Encode$string(message),
							$elm$json$Json$Encode$string(vtoken),
							$elm$json$Json$Encode$string(vscope),
							$elm$json$Json$Encode$string(venvironment),
							A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $elm$core$Basics$identity, metadata)
						]))));
		var combinedSeed = $elm$core$Basics$floor(ms) ^ hash;
		return A2(
			$elm$random$Random$step,
			$danyx23$elm_uuid$Uuid$uuidGenerator,
			$elm$random$Random$initialSeed(combinedSeed)).a;
	});
var $NoRedInk$elm_rollbar$Rollbar$retries = {
	lr: 60,
	zi: $elm$time$Time$millisToPosix(1000)
};
var $elm$core$Process$sleep = _Process_sleep;
var $NoRedInk$elm_rollbar$Rollbar$withRetry = F2(
	function (maxRetryAttempts, task) {
		var retry = function (httpError) {
			if (maxRetryAttempts > 0) {
				if (httpError.$ === 3) {
					var statusCode = httpError.a;
					return (statusCode === 429) ? A2(
						$elm$core$Task$andThen,
						function (_v1) {
							return A2($NoRedInk$elm_rollbar$Rollbar$withRetry, maxRetryAttempts - 1, task);
						},
						$elm$core$Process$sleep(
							$elm$time$Time$posixToMillis($NoRedInk$elm_rollbar$Rollbar$retries.zi))) : $elm$core$Task$fail(httpError);
				} else {
					return $elm$core$Task$fail(httpError);
				}
			} else {
				return $elm$core$Task$fail(httpError);
			}
		};
		return A2($elm$core$Task$onError, retry, task);
	});
var $NoRedInk$elm_rollbar$Rollbar$sendWithTime = F9(
	function (vtoken, vcodeVersion, vscope, venvironment, maxRetryAttempts, level, message, metadata, time) {
		var uuid = A7($NoRedInk$elm_rollbar$Rollbar$uuidFrom, vtoken, vscope, venvironment, level, message, metadata, time);
		var body = A8($NoRedInk$elm_rollbar$Rollbar$toJsonBody, vtoken, vscope, vcodeVersion, venvironment, level, message, uuid, metadata);
		return A2(
			$NoRedInk$elm_rollbar$Rollbar$withRetry,
			maxRetryAttempts,
			A2(
				$elm$core$Task$map,
				function (_v1) {
					return uuid;
				},
				$elm$http$Http$task(
					{
						sY: body,
						CN: _List_fromArray(
							[
								$NoRedInk$elm_rollbar$Rollbar$tokenHeader(vtoken)
							]),
						my: 'POST',
						nj: $elm$http$Http$stringResolver(
							function (_v0) {
								return $elm$core$Result$Ok(0);
							}),
						nE: $elm$core$Maybe$Nothing,
						GT: $NoRedInk$elm_rollbar$Rollbar$endpointUrl
					})));
	});
var $NoRedInk$elm_rollbar$Rollbar$send = F8(
	function (vtoken, vcodeVersion, vscope, venvironment, maxRetryAttempts, level, message, metadata) {
		return A2(
			$elm$core$Task$andThen,
			A8($NoRedInk$elm_rollbar$Rollbar$sendWithTime, vtoken, vcodeVersion, vscope, venvironment, maxRetryAttempts, level, message, metadata),
			$elm$time$Time$now);
	});
var $NoRedInk$elm_rollbar$Rollbar$Token = $elm$core$Basics$identity;
var $NoRedInk$elm_rollbar$Rollbar$token = $elm$core$Basics$identity;
var $author$project$Model$RollbarClient$create = F2(
	function (toMsg, page) {
		var send = F4(
			function (level, metadata, message, session) {
				var flags = $author$project$Model$Session$getFlags(session);
				return A2(
					$elm$core$Task$attempt,
					$elm$core$Basics$always(toMsg),
					A8(
						$NoRedInk$elm_rollbar$Rollbar$send,
						$NoRedInk$elm_rollbar$Rollbar$token(flags.FP),
						$NoRedInk$elm_rollbar$Rollbar$codeVersion('v1.0.0'),
						$NoRedInk$elm_rollbar$Rollbar$scope(page),
						$NoRedInk$elm_rollbar$Rollbar$environment(flags.zU),
						60,
						level,
						message,
						metadata));
			});
		return {
			FZ: F3(
				function (source, err, session) {
					var statusCode = function () {
						var _v1 = err.mp;
						if (_v1.$ === 3) {
							var resp = _v1.a;
							return $elm$core$Maybe$Just(resp.wp);
						} else {
							return $elm$core$Maybe$Nothing;
						}
					}();
					var sendError = A2(
						$elm$core$Maybe$withDefault,
						true,
						A2(
							$elm$core$Maybe$map,
							function (code) {
								return (code === 500) || ((code === 501) || (code >= 505));
							},
							statusCode));
					if (!sendError) {
						return $elm$core$Platform$Cmd$none;
					} else {
						var userValue = A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Encode$null,
							A2(
								$elm$core$Maybe$map,
								$author$project$Model$User$encodeForRollbar,
								$author$project$Model$Session$getUser(session)));
						var _v0 = $author$project$Model$Message$reasonWithCode(err);
						var reason = _v0.cg;
						var messageCode = _v0.mx;
						var metadata = $elm$core$Dict$fromList(
							A2(
								$author$project$Misc$consMaybe,
								A2(
									$elm$core$Maybe$map,
									function (code) {
										return _Utils_Tuple2(
											'messageCode',
											$elm$json$Json$Encode$int(code));
									},
									messageCode),
								A2(
									$author$project$Misc$consMaybe,
									A2(
										$elm$core$Maybe$map,
										function (code) {
											return _Utils_Tuple2(
												'statusCode',
												$elm$json$Json$Encode$int(code));
										},
										statusCode),
									_List_fromArray(
										[
											_Utils_Tuple2('person', userValue),
											_Utils_Tuple2(
											'page',
											$elm$json$Json$Encode$string(page)),
											_Utils_Tuple2(
											'source',
											$elm$json$Json$Encode$string(source)),
											_Utils_Tuple2(
											'url',
											$elm$json$Json$Encode$string(err.GT))
										]))));
						var message = _Utils_ap(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									function (code) {
										return $elm$core$String$fromInt(code) + ' - ';
									},
									messageCode)),
							reason);
						return A4(send, 1, metadata, message, session);
					}
				}),
			sk: A2(send, 2, $elm$core$Dict$empty)
		};
	});
var $author$project$Main$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Msg$NoOp, 'Main.elm');
var $author$project$Model$Session$setCreds = F2(
	function (creds, _v0) {
		var session = _v0;
		return _Utils_update(
			session,
			{tu: creds});
	});
var $author$project$Model$Session$setDropdownOpen = F2(
	function (dropdownState, _v0) {
		var session = _v0;
		return _Utils_update(
			session,
			{tI: dropdownState});
	});
var $elm_community$list_extra$List$Extra$minimumBy = F2(
	function (f, ls) {
		var minBy = F2(
			function (x, _v1) {
				var y = _v1.a;
				var fy = _v1.b;
				var fx = f(x);
				return (_Utils_cmp(fx, fy) < 0) ? _Utils_Tuple2(x, fx) : _Utils_Tuple2(y, fy);
			});
		if (ls.b) {
			if (!ls.b.b) {
				var l_ = ls.a;
				return $elm$core$Maybe$Just(l_);
			} else {
				var l_ = ls.a;
				var ls_ = ls.b;
				return $elm$core$Maybe$Just(
					A3(
						$elm$core$List$foldl,
						minBy,
						_Utils_Tuple2(
							l_,
							f(l_)),
						ls_).a);
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Model$Tier$tierToRank = function (simpleTier) {
	switch (simpleTier.$) {
		case 5:
			return 1;
		case 6:
			return 2;
		case 7:
			return 3;
		case 4:
			return 4;
		case 3:
			return 5;
		case 2:
			return 6;
		case 1:
			return 7;
		case 0:
			return 8;
		default:
			return 9;
	}
};
var $author$project$Model$User$getHighestTier = function (maybeUser) {
	if (!maybeUser.$) {
		var user = maybeUser.a;
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Model$Tier$Free,
			A2(
				$elm_community$list_extra$List$Extra$minimumBy,
				$author$project$Model$Tier$tierToRank,
				A2(
					$elm$core$List$map,
					$author$project$Model$Tier$stringToSimpleTier,
					$elm$core$Set$toList(
						$elm$core$Set$fromList(
							A2(
								$elm$core$List$map,
								function ($) {
									return $.dc;
								},
								user.mX))))));
	} else {
		return $author$project$Model$Tier$Free;
	}
};
var $author$project$Model$Tier$simpleTierDisplayString = function (tier) {
	switch (tier.$) {
		case 8:
			return 'Unknown';
		case 0:
			return 'Free';
		case 1:
			return 'Coder';
		case 2:
			return 'Pro';
		case 3:
			var onTrial = tier.a;
			return 'Team' + (onTrial ? ' (Trial)' : '');
		case 4:
			return 'Business';
		case 5:
			return 'Enterprise';
		case 6:
			return 'Enterprise Evaluation';
		default:
			return 'Platform Trial';
	}
};
var $author$project$Model$RecordUserPayload$create = F2(
	function (isImpersonating, user) {
		return {
			ak: user.ak,
			lJ: user.lJ,
			yv: $author$project$Model$Tier$simpleTierDisplayString(
				$author$project$Model$User$getHighestTier(
					$elm$core$Maybe$Just(user))),
			yK: isImpersonating,
			un: user.un,
			w: user.AE,
			eR: user.eR,
			wV: user.wV
		};
	});
var $author$project$Ports$recordUser = _Platform_outgoingPort(
	'recordUser',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'added',
					$elm$json$Json$Encode$string($.ak)),
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string($.lJ)),
					_Utils_Tuple2(
					'highestTier',
					$elm$json$Json$Encode$string($.yv)),
					_Utils_Tuple2(
					'isImpersonating',
					$elm$json$Json$Encode$bool($.yK)),
					_Utils_Tuple2(
					'isPaidUser',
					$elm$json$Json$Encode$bool($.un)),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string($.w)),
					_Utils_Tuple2(
					'timezone',
					$elm$json$Json$Encode$string($.eR)),
					_Utils_Tuple2(
					'userID',
					$elm$json$Json$Encode$string($.wV))
				]));
	});
var $author$project$Protected$withCreds = F2(
	function (creds, _v0) {
		return $elm$core$Maybe$Just(creds);
	});
var $author$project$Model$Session$setJWT = F2(
	function (jwt, session) {
		var creds = A2(
			$author$project$Protected$withCreds,
			{GI: jwt.GI, AE: jwt.gS.AE},
			$author$project$Model$Session$getCreds(session));
		var cmd = (!$author$project$Model$Session$isImpersonating(session)) ? $author$project$Ports$recordUser(
			A2($author$project$Model$RecordUserPayload$create, false, jwt.gS)) : $author$project$Ports$setIsImpersonating(true);
		return A2(
			$author$project$Misc$with,
			cmd,
			A2(
				$author$project$Model$Session$setCreds,
				creds,
				A2(
					$author$project$Model$Session$setUser,
					$elm$core$Maybe$Just(jwt.gS),
					session)));
	});
var $author$project$Ports$setLocalStorage = _Platform_outgoingPort(
	'setLocalStorage',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'key',
					$elm$json$Json$Encode$string($.Y)),
					_Utils_Tuple2(
					'value',
					$elm$json$Json$Encode$string($.kH))
				]));
	});
var $author$project$Model$LocalStorage$set = F2(
	function (input, _v0) {
		var dict = _v0;
		return A2(
			$author$project$Misc$with,
			$author$project$Ports$setLocalStorage(input),
			A3($elm$core$Dict$insert, input.Y, input.kH, dict));
	});
var $author$project$Model$Session$setLocalStorage = F2(
	function (input, _v0) {
		var session = _v0;
		var _v1 = A2($author$project$Model$LocalStorage$set, input, session.fu);
		var newLocalStorage = _v1.a;
		var localStorageCmd = _v1.b;
		return A2(
			$author$project$Misc$with,
			localStorageCmd,
			_Utils_update(
				session,
				{fu: newLocalStorage}));
	});
var $author$project$Model$Session$setOrgDropdownOpen = F2(
	function (dropdownState, _v0) {
		var session = _v0;
		return _Utils_update(
			session,
			{vH: dropdownState});
	});
var $author$project$Page$Error = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Login$OneFactor = 0;
var $author$project$Model$Credentials$empty = {fs: $elm$core$Maybe$Nothing, ey: '', wM: '', AE: ''};
var $author$project$Pages$Login$AutoForking = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Login$CreateProject = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Login$FromCommit = {$: 5};
var $author$project$Pages$Login$Invited = {$: 1};
var $author$project$Pages$Login$PerlBypass = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Login$PythonAd = {$: 4};
var $author$project$Pages$Login$Regular = {$: 0};
var $author$project$Misc$duple = function (x) {
	return _Utils_Tuple2(x, x);
};
var $author$project$Model$Route$isAutoForking = function (route) {
	if (((!route.$) && (route.a.$ === 7)) && (route.a.a.$ === 14)) {
		var orgRoute = route.a.a.a.vI;
		if (orgRoute.$ === 7) {
			var projectRoute = orgRoute.a.zL;
			if (projectRoute.$ === 9) {
				return true;
			} else {
				return false;
			}
		} else {
			return false;
		}
	} else {
		return false;
	}
};
var $author$project$Model$Route$isCreateProject = function (route) {
	_v0$2:
	while (true) {
		if ((!route.$) && (route.a.$ === 7)) {
			switch (route.a.a.$) {
				case 17:
					return true;
				case 18:
					return true;
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return false;
};
var $author$project$Model$Route$isInvited = function (route) {
	_v0$2:
	while (true) {
		if ((!route.$) && (route.a.$ === 7)) {
			switch (route.a.a.$) {
				case 11:
					return true;
				case 12:
					return true;
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return false;
};
var $author$project$Model$Route$isProjectFromCommit = function (route) {
	if (((!route.$) && (route.a.$ === 7)) && (route.a.a.$ === 22)) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $author$project$Model$Route$nextRouteLanguageName = function (nextRoute) {
	if (((!nextRoute.$) && (nextRoute.a.$ === 7)) && (nextRoute.a.a.$ === 17)) {
		var languageName = nextRoute.a.a.a.DQ;
		return A2($elm$core$Maybe$map, $elm$core$String$toLower, languageName);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$Route$nextRouteLanguageVersion = function (nextRoute) {
	if (((!nextRoute.$) && (nextRoute.a.$ === 7)) && (nextRoute.a.a.$ === 17)) {
		var languageVersion = nextRoute.a.a.a.DS;
		return A2($elm$core$Maybe$map, $elm$core$String$toLower, languageVersion);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$Route$nextRouteProjectName = function (nextRoute) {
	if (((!nextRoute.$) && (nextRoute.a.$ === 7)) && (nextRoute.a.a.$ === 14)) {
		var orgRoute = nextRoute.a.a.a.vI;
		if (orgRoute.$ === 7) {
			var projectName = orgRoute.a.vT;
			return $elm$core$Maybe$Just(projectName);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Login$getAuthContext = F2(
	function (nextRoute, content) {
		if ($author$project$Model$Route$isInvited(nextRoute)) {
			return $author$project$Pages$Login$Invited;
		} else {
			if ($author$project$Model$Route$isCreateProject(nextRoute)) {
				var _v0 = $author$project$Model$Route$nextRouteLanguageName(nextRoute);
				if ((!_v0.$) && (_v0.a === 'perl')) {
					return $author$project$Pages$Login$PerlBypass(
						$author$project$Model$Route$nextRouteLanguageVersion(nextRoute));
				} else {
					return A2(
						$elm_community$basics_extra$Basics$Extra$uncurry,
						$author$project$Pages$Login$CreateProject,
						A2(
							$elm$core$Tuple$mapFirst,
							$elm$core$Maybe$andThen($author$project$Model$Language$fromString),
							A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Model$Route$nextRouteLanguageName,
								$author$project$Model$Route$nextRouteLanguageVersion,
								$author$project$Misc$duple(nextRoute))));
				}
			} else {
				if ($author$project$Model$Route$isAutoForking(nextRoute)) {
					return A2(
						$elm$core$Maybe$withDefault,
						$author$project$Pages$Login$Regular,
						A2(
							$elm$core$Maybe$map,
							$author$project$Pages$Login$AutoForking,
							$author$project$Model$Route$nextRouteProjectName(nextRoute)));
				} else {
					if (content === 1) {
						return $author$project$Pages$Login$PythonAd;
					} else {
						if ($author$project$Model$Route$isProjectFromCommit(nextRoute)) {
							return $author$project$Pages$Login$FromCommit;
						} else {
							return $author$project$Pages$Login$Regular;
						}
					}
				}
			}
		}
	});
var $author$project$Views$NotificationsInline$setInternal = F2(
	function (notification, model) {
		return _Utils_update(
			model,
			{
				mN: $elm$core$Maybe$Just(notification)
			});
	});
var $author$project$Views$NotificationsInline$set = F2(
	function (notification, model) {
		return A2($author$project$Views$NotificationsInline$setInternal, notification, model);
	});
var $author$project$Model$Notification$Success = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$Notification$textSuccess = function (message) {
	return $author$project$Model$Notification$Success(
		_List_fromArray(
			[
				$author$project$Model$Notification$Text(message)
			]));
};
var $author$project$Views$NotificationsInline$setSuccessText = function (str) {
	return $author$project$Views$NotificationsInline$set(
		$author$project$Model$Notification$textSuccess(str));
};
var $author$project$Model$Credentials$withInviteCode = F2(
	function (inviteCode, creds) {
		return _Utils_update(
			creds,
			{fs: inviteCode});
	});
var $author$project$Model$Credentials$withUsername = F2(
	function (username, creds) {
		return _Utils_update(
			creds,
			{AE: username});
	});
var $author$project$Pages$Login$init = F2(
	function (key, _v0) {
		var reset = _v0.pC;
		var email = _v0.lJ;
		var inviteCode = _v0.fs;
		var source = _v0.o;
		var content = _v0.dH;
		var cliInstructionsPlatform = _v0.g$;
		var nextRoute = _v0.dg;
		var errorType = _v0.lP;
		var googleAnalyticsParams = _v0.hx;
		return (reset ? $author$project$Views$NotificationsInline$setSuccessText('Password successfully updated. Use it to sign in below.') : $elm$core$Basics$identity)(
			{
				qm: A2($author$project$Pages$Login$getAuthContext, nextRoute, content),
				g$: cliInstructionsPlatform,
				dH: content,
				dI: A2(
					$author$project$Model$Credentials$withInviteCode,
					inviteCode,
					A3(
						$elm$core$Basics$apR,
						A2($elm$core$Maybe$map, $author$project$Model$Credentials$withUsername, email),
						$elm$core$Maybe$withDefault($elm$core$Basics$identity),
						$author$project$Model$Credentials$empty)),
				lJ: email,
				lP: errorType,
				lX: false,
				tW: googleAnalyticsParams,
				Y: key,
				mv: $elm$core$Basics$identity,
				j6: 0,
				dg: nextRoute,
				mN: $author$project$Views$NotificationsInline$init,
				pC: reset,
				nI: source,
				p_: $elm$core$Maybe$Nothing
			});
	});
var $author$project$Pages$NotFound$Sad = 1;
var $author$project$Pages$NotFound$init = function (key) {
	return {qS: 1, Y: key, j8: 0};
};
var $author$project$Main$loadPageFromErr = F2(
	function (model, err) {
		var _v0 = err.mp;
		if (_v0.$ === 3) {
			var resp = _v0.a;
			var _v1 = resp.wp;
			switch (_v1) {
				case 404:
					return $author$project$Page$NotFound(
						$author$project$Pages$NotFound$init(model.Y));
				case 498:
					return $author$project$Page$Login(
						A2($author$project$Pages$Login$init, model.Y, $author$project$Model$Route$emptyLoginParams));
				default:
					return $author$project$Page$Error(err);
			}
		} else {
			return $author$project$Page$Error(err);
		}
	});
var $elm$browser$Browser$Dom$setViewport = _Browser_setViewport;
var $author$project$Misc$scrollToTop = function (msg) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$always(msg),
		A2($elm$browser$Browser$Dom$setViewport, 0, 0));
};
var $author$project$Main$setPageWithCmd = F5(
	function (model, mkPage, result, cmds, toMsg) {
		if (!result.$) {
			var subModel = result.a;
			var _v1 = cmds(subModel);
			var newSubModel = _v1.a;
			var cmd = _v1.b;
			return A2(
				$author$project$Misc$with,
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2($elm$core$Platform$Cmd$map, toMsg, cmd),
							$author$project$Misc$scrollToTop($author$project$Msg$NoOp)
						])),
				_Utils_update(
					model,
					{
						u: A2(
							$author$project$PageState$load,
							model.u,
							mkPage(newSubModel))
					}));
		} else {
			var err = result.a;
			return A2(
				$author$project$Misc$with,
				$elm$core$Platform$Cmd$none,
				_Utils_update(
					model,
					{
						u: A2(
							$author$project$PageState$load,
							model.u,
							A2($author$project$Main$loadPageFromErr, model, err))
					}));
		}
	});
var $author$project$Main$setPageWithCmdOnly = F5(
	function (model, mkPage, result, cmds, toMsg) {
		return A5(
			$author$project$Main$setPageWithCmd,
			model,
			mkPage,
			result,
			function (m) {
				return _Utils_Tuple2(
					m,
					cmds(m));
			},
			toMsg);
	});
var $author$project$Main$setPage = F3(
	function (model, mkPage, result) {
		return A5(
			$author$project$Main$setPageWithCmdOnly,
			model,
			mkPage,
			result,
			$elm$core$Basics$always($elm$core$Platform$Cmd$none),
			$elm$core$Basics$never);
	});
var $author$project$Pages$SupplementalLicenseTerms$ForProject = function (a) {
	return {$: 1, a: a};
};
var $author$project$Msg$ForgotPasswordLoaded = function (a) {
	return {$: 57, a: a};
};
var $author$project$Msg$LoadingMsg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Main$LoadingProjectPreview = function (a) {
	return {$: 7, a: a};
};
var $author$project$Msg$OnLogout = {$: 61};
var $author$project$Msg$ProjectOverviewLoaded = function (a) {
	return {$: 43, a: a};
};
var $author$project$Msg$ProjectPreviewLoadingMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Msg$PublicProjectsLoaded = function (a) {
	return {$: 85, a: a};
};
var $author$project$Msg$ResetPasswordLoaded = function (a) {
	return {$: 60, a: a};
};
var $author$project$Pages$SupplementalLicenseTerms$Sample = {$: 0};
var $author$project$Msg$StateToolCheatSheetLoaded = function (a) {
	return {$: 89, a: a};
};
var $author$project$Msg$SupplementalLicenseTermsLoaded = function (a) {
	return {$: 53, a: a};
};
var $author$project$Msg$SupportLoaded = function (a) {
	return {$: 87, a: a};
};
var $author$project$Pages$CreateAccount$cmds = F2(
	function (_v0, _v1) {
		return $elm$core$Platform$Cmd$none;
	});
var $author$project$Pages$Login$cmds = F2(
	function (_v0, _v1) {
		return $elm$core$Platform$Cmd$none;
	});
var $author$project$Model$Route$withNewUser = function (params) {
	return _Utils_update(
		params,
		{jc: true});
};
var $author$project$Pages$CreateAccount$createProjectRedirect = function (params) {
	return $author$project$Model$Route$Protected(
		$author$project$Model$Route$CreateProjectRedirect(
			$author$project$Model$Route$withNewUser(params)));
};
var $author$project$Model$Route$emptyCreateProjectParams = {A9: false, jc: false, DQ: $elm$core$Maybe$Nothing, DS: $elm$core$Maybe$Nothing, ru: $elm$core$Maybe$Nothing, rv: $elm$core$Maybe$Nothing};
var $author$project$Pages$CreateAccount$getNextRoute = F2(
	function (maybeUser, _v0) {
		var email = _v0.lJ;
		var inviteCode = _v0.fs;
		var nextRoute = _v0.dg;
		var userHasAnOrg = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.mX;
					},
					A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not)),
				maybeUser));
		var overrideNextRoute = function () {
			_v1$3:
			while (true) {
				if (nextRoute.$ === 1) {
					return $author$project$Pages$CreateAccount$createProjectRedirect($author$project$Model$Route$emptyCreateProjectParams);
				} else {
					if (nextRoute.a.$ === 7) {
						switch (nextRoute.a.a.$) {
							case 0:
								return $author$project$Pages$CreateAccount$createProjectRedirect($author$project$Model$Route$emptyCreateProjectParams);
							case 18:
								var createProjectParams = nextRoute.a.a.a.B2;
								return $author$project$Pages$CreateAccount$createProjectRedirect(createProjectParams);
							default:
								break _v1$3;
						}
					} else {
						break _v1$3;
					}
				}
			}
			var r = nextRoute.a;
			return r;
		}();
		var maybeOverwriteWithCreateOrgRoute = userHasAnOrg ? overrideNextRoute : $author$project$Model$Route$Protected(
			$author$project$Model$Route$CreateOrganization(
				{
					h3: $elm$core$Maybe$Nothing,
					dg: $elm$core$Maybe$Just(overrideNextRoute)
				}));
		var activateRoute = A2(
			$elm$core$Maybe$map,
			function (code) {
				return $author$project$Model$Route$Protected(
					$author$project$Model$Route$ActivateMembership(
						{lJ: email, fs: code, zn: false}));
			},
			inviteCode);
		return A2($elm$core$Maybe$withDefault, maybeOverwriteWithCreateOrgRoute, activateRoute);
	});
var $author$project$Pages$Login$getNextRoute = function (_v0) {
	var source = _v0.o;
	var email = _v0.lJ;
	var inviteCode = _v0.fs;
	var nextRoute = _v0.dg;
	var activateRoute = A2(
		$elm$core$Maybe$map,
		function (code) {
			return $author$project$Model$Route$Protected(
				$author$project$Model$Route$ActivateMembership(
					{lJ: email, fs: code, zn: false}));
		},
		inviteCode);
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Model$Route$Protected(
			$author$project$Model$Route$Home(
				{wd: source})),
		A2($elm_community$maybe_extra$Maybe$Extra$or, activateRoute, nextRoute));
};
var $author$project$Pages$ConnectAccount$OneFactor = 0;
var $author$project$Pages$ConnectAccount$Signup = 0;
var $author$project$Pages$ConnectAccount$init = F4(
	function (key, inviteCode, route, errorType) {
		return {
			n0: 0,
			dI: A2($author$project$Model$Credentials$withInviteCode, inviteCode, $author$project$Model$Credentials$empty),
			lP: errorType,
			lX: false,
			Y: key,
			j6: 0,
			dg: route,
			mN: $author$project$Views$NotificationsInline$init,
			p_: $elm$core$Maybe$Nothing
		};
	});
var $author$project$Pages$CreateAccount$Email = 0;
var $author$project$Pages$CreateAccount$Empty = {$: 0};
var $author$project$Pages$CreateAccount$Invalid = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$CreateAccount$Locked = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$CreateAccount$ReadyToSubmit = 0;
var $author$project$Pages$CreateAccount$ValidationFailed = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$CreateAccount$Visible = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$Email$validEmailRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	A2(
		$elm$regex$Regex$fromStringWith,
		{Bu: true, Eo: false},
		'^.+@.+\\..+$'));
var $author$project$Model$Email$isValid = $elm$regex$Regex$contains($author$project$Model$Email$validEmailRegex);
var $author$project$Validation$validateEmail = $author$project$Validation$runValidations(
	_List_fromArray(
		[
			_Utils_Tuple2(
			A2($elm$core$Basics$composeR, $author$project$Model$Email$isValid, $elm$core$Basics$not),
			'Please provide a valid email')
		]));
var $author$project$Pages$CreateAccount$init = F2(
	function (key, _v0) {
		var inviteCode = _v0.fs;
		var source = _v0.o;
		var content = _v0.dH;
		var cliInstructionsPlatform = _v0.g$;
		var nextRoute = _v0.dg;
		var googleAnalyticsParams = _v0.hx;
		var email = _v0.lJ;
		var autoProjectParams = _v0.h3;
		var emailField = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Pages$CreateAccount$Empty,
			A2(
				$elm$core$Maybe$map,
				function (address) {
					var _v1 = $author$project$Validation$validateEmail(address);
					if (!_v1.$) {
						var error = _v1.a;
						return A2(
							$author$project$Pages$CreateAccount$Invalid,
							address,
							$author$project$Pages$CreateAccount$Visible(
								$author$project$Pages$CreateAccount$ValidationFailed(error)));
					} else {
						return $author$project$Pages$CreateAccount$Locked(address);
					}
				},
				email));
		return {
			qm: A2($author$project$Pages$Login$getAuthContext, nextRoute, content),
			kP: 0,
			h3: autoProjectParams,
			g$: cliInstructionsPlatform,
			dH: content,
			lq: $elm$core$Maybe$Nothing,
			i0: emailField,
			lL: true,
			tM: false,
			ou: $elm$core$Maybe$Nothing,
			ge: 0,
			tW: googleAnalyticsParams,
			fs: inviteCode,
			Y: key,
			dg: nextRoute,
			mN: $author$project$Views$NotificationsInline$init,
			jp: $author$project$Pages$CreateAccount$Empty,
			pl: false,
			nI: source,
			fz: $author$project$Pages$CreateAccount$Empty
		};
	});
var $author$project$Pages$ForgotPassword$init = $elm$core$Task$succeed(
	{lJ: '', yd: $elm$core$Maybe$Nothing, jV: false, mN: $author$project$Views$NotificationsInline$init});
var $author$project$Views$CreateSBOM$NotLoaded = {$: 0};
var $author$project$Views$StateTool$ScriptInstall = 0;
var $author$project$Model$Platform$Windows = 0;
var $author$project$Model$Platform$Linux = 1;
var $author$project$Model$Platform$Mac = 2;
var $author$project$Model$Platform$detectPlatformType = function (platformName) {
	var formattedPlatformName = $elm$core$String$toLower(platformName);
	return (A2($elm$core$String$startsWith, 'linux', formattedPlatformName) || (formattedPlatformName === 'centos')) ? $elm$core$Maybe$Just(1) : (A2($elm$core$String$startsWith, 'mac', formattedPlatformName) ? $elm$core$Maybe$Just(2) : (A2($elm$core$String$startsWith, 'win', formattedPlatformName) ? $elm$core$Maybe$Just(0) : $elm$core$Maybe$Nothing));
};
var $author$project$Model$CopyStatus$empty = {xN: '', L: false};
var $author$project$Task$Pipeline$fetch = F2(
	function (taskA, taskF) {
		return A3($elm$core$Task$map2, $elm$core$Basics$apL, taskF, taskA);
	});
var $author$project$Model$Editor$init = function (fields) {
	return {g5: fields, jl: fields};
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ThunkExpr = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pipeline$dictForEach = F2(
	function (dict, func) {
		var helper = F2(
			function (_v0, acc) {
				var k = _v0.a;
				var v = _v0.b;
				return A2(
					$author$project$Pipeline$map,
					A2(
						$elm_community$basics_extra$Basics$Extra$flip,
						$elm$core$Dict$insert(k),
						acc),
					A2(func, k, v));
			});
		return A3(
			$author$project$Pipeline$foldl,
			helper,
			$elm$core$Dict$empty,
			$elm$core$Dict$toList(dict));
	});
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueBool = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueFloat = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueInt = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueList = function (a) {
	return {$: 6, a: a};
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueNil = {$: 0};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueString = function (a) {
	return {$: 4, a: a};
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalUnknownAp = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$Or = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueAddMissingSources = function (a) {
	return {$: 23, a: a};
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValuePred = function (a) {
	return {$: 10, a: a};
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getType = function (value) {
	getType:
	while (true) {
		switch (value.$) {
			case 0:
				return 'nil';
			case 1:
				return 'bool';
			case 2:
				return 'int';
			case 3:
				return 'float';
			case 4:
				return 'string';
			case 5:
				return 'datetime';
			case 6:
				return 'list';
			case 7:
				return 'solve';
			case 8:
				return 'Req';
			case 9:
				var constraint = value.a;
				if (!constraint.$) {
					return 'Any';
				} else {
					var pred = constraint.a;
					var $temp$value = $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValuePred(pred);
					value = $temp$value;
					continue getType;
				}
			case 10:
				var pred = value.a;
				switch (pred.$) {
					case 0:
						return 'And';
					case 1:
						return 'Eq';
					case 2:
						return 'Gt';
					case 3:
						return 'Gte';
					case 4:
						return 'Lt';
					case 5:
						return 'Lte';
					case 6:
						return 'Ne';
					default:
						return 'Or';
				}
			case 11:
				return 'community_artifacts';
			case 12:
				return 'wheel_artifacts';
			case 13:
				var markers = value.a.Ec;
				switch (markers.$) {
					case 0:
						return 'camel';
					case 1:
						return 'pre_platform_installer';
					case 2:
						return 'state_tool_artifacts';
					case 3:
						return 'state_tool_artifacts_v1';
					case 4:
						var replaceImages = markers.a;
						var images = markers.b;
						var _v4 = _Utils_Tuple2(replaceImages, images);
						if (_v4.a.b) {
							var _v5 = _v4.a;
							return 'replace_image';
						} else {
							if (_v4.b.b && _v4.b.b.b) {
								var _v6 = _v4.b;
								var _v7 = _v6.b;
								return 'merge_set';
							} else {
								return 'scanned_image';
							}
						}
					case 5:
						return 'observable_sbom';
					case 6:
						return 'editable_sbom';
					default:
						return 'MarkersNone';
				}
			case 14:
				return 'authenticode_signature';
			case 15:
				return 'BuildFlag';
			case 16:
				var acc = value.a;
				return acc.gR;
			case 17:
				return 'scanned_image';
			case 18:
				return 'merge_set';
			case 19:
				return 'replace_image';
			case 20:
				return 'DependencyLink';
			case 21:
				return 'generic_sbom';
			case 22:
				return 'find_roots';
			default:
				return 'add_missing_sources';
		}
	}
};
var $author$project$Pipeline$problem = function (err) {
	return function (ctx) {
		return _Utils_Tuple2(
			ctx,
			$elm$core$Result$Err(err));
	};
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$AddMissingSources$eval = function (_v0) {
	var src = _v0.fG;
	var dest = _v0.Cf;
	if (src.$ === 21) {
		var genericSBOMFields = src.a;
		if (dest.$ === 13) {
			var markers = dest.a;
			var _v3 = markers.Ec;
			if (_v3.$ === 2) {
				var communityOrWheel = _v3.a;
				var stateToolArtifactsFields = _v3.b;
				return $author$project$Pipeline$succeed(
					$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueAddMissingSources(
						{tf: communityOrWheel, sr: markers.sr, fG: genericSBOMFields, wn: stateToolArtifactsFields}));
			} else {
				return $author$project$Pipeline$problem(
					$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr(
						'\'add_missing_sources\' function must take a \'state_tool_artifacts\' (of a \'solve\') in its \'dest\' argument, but got: ' + $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getType(dest)));
			}
		} else {
			return $author$project$Pipeline$problem(
				$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr(
					'\'add_missing_sources\' function must take a \'state_tool_artifacts\' (of a \'solve\') in its \'dest\' argument, but got: ' + $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getType(dest)));
		}
	} else {
		return $author$project$Pipeline$problem(
			$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr(
				'\'add_missing_sources\' function must take a \'genric_sbom\' in its \'src\' argument, but got: ' + $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getType(src)));
	}
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueAuthenticodeSignature = function (a) {
	return {$: 14, a: a};
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$appendPackagers = F2(
	function (left, right) {
		return {
			A8: _Utils_ap(left.A8, right.A8),
			Cj: _Utils_ap(left.Cj, right.Cj),
			D4: _Utils_ap(left.D4, right.D4),
			vX: _Utils_ap(left.vX, right.vX),
			w4: _Utils_ap(left.w4, right.w4)
		};
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$insertPackagers = F3(
	function (platformID, packagers, fields) {
		var func = A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map(
				$author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$appendPackagers(packagers)),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$withDefault(packagers),
				$elm$core$Maybe$Just));
		return _Utils_update(
			fields,
			{
				E2: A3($elm$core$Dict$update, platformID, func, fields.E2)
			});
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$AuthenticodeSignature$eval = function (authenticodeSignature) {
	var _v0 = authenticodeSignature.fG;
	if (_v0.$ === 13) {
		var fields = _v0.a;
		var packagers = _Utils_update(
			$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$packagersInit,
			{
				A8: _List_fromArray(
					[
						{}
					])
			});
		return $author$project$Pipeline$succeed(
			$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueAuthenticodeSignature(
				A3(
					$author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$insertPackagers,
					$danyx23$elm_uuid$Uuid$toString(authenticodeSignature.po),
					packagers,
					fields)));
	} else {
		return $author$project$Pipeline$problem(
			$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr(
				'\'authenticode_signaturer\' function must take a \'state_tool_artifacts\' or \'state_tool_artifacts_v1\' in its \'src\' argument, but got: ' + $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getType(authenticodeSignature.fG)));
	}
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueBuildFlag = function (a) {
	return {$: 15, a: a};
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$BuildFlag$eval = function (buildFlag) {
	return $author$project$Pipeline$succeed(
		$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueBuildFlag(buildFlag));
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$MarkersCamel = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueMarkers = function (a) {
	return {$: 13, a: a};
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Camel$eval = function (_v0) {
	var src = _v0.fG;
	var camelFlags = _v0.Bn;
	if (src.$ === 7) {
		var solve = src.a;
		return $author$project$Pipeline$succeed(
			$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueMarkers(
				{
					Ec: $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$MarkersCamel(
						{Bn: camelFlags}),
					E2: $elm$core$Dict$empty,
					sr: solve
				}));
	} else {
		return $author$project$Pipeline$problem(
			$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr(
				'\'camel\' function must take a \'solve\' in its \'src\' argument, but got: ' + $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getType(src)));
	}
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueCommunityArtifacts = function (a) {
	return {$: 11, a: a};
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$CommunityArtifacts$eval = function (_v0) {
	var src = _v0.fG;
	if (src.$ === 7) {
		var solve = src.a;
		return $author$project$Pipeline$succeed(
			$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueCommunityArtifacts(solve));
	} else {
		return $author$project$Pipeline$problem(
			$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr(
				'\'community_artifacts\' function must take a \'solve\' in its \'src\' argument, but got: ' + $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getType(src)));
	}
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueDependencyLink = function (a) {
	return {$: 20, a: a};
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$DependencyLink$eval = function (dependencyLink) {
	return $author$project$Pipeline$succeed(
		$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueDependencyLink(dependencyLink));
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValuePackagers = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalPackager = F4(
	function (type_, initPackagers, platformID, src) {
		var acc = {E2: initPackagers, m0: platformID, gR: type_};
		switch (src.$) {
			case 13:
				var fields = src.a;
				return $author$project$Pipeline$succeed(
					A2($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValuePackagers, acc, fields));
			case 14:
				var fields = src.a;
				return $author$project$Pipeline$succeed(
					A2($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValuePackagers, acc, fields));
			case 16:
				var srcAcc = src.a;
				var fields = src.b;
				return _Utils_eq(srcAcc.m0, platformID) ? $author$project$Pipeline$problem(
					$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr('Packagers for the same platform must be merged. Platform: \'' + (platformID + '\''))) : $author$project$Pipeline$succeed(
					A2(
						$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValuePackagers,
						acc,
						A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$insertPackagers, srcAcc.m0, srcAcc.E2, fields)));
			default:
				return $author$project$Pipeline$problem(
					$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr(
						'\'' + (type_ + ('\' function must take a \'camel\', \'state_tool_artifacts\' or \'state_tool_artifacts_v1\' in its \'src\' argument, but got: ' + $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getType(src)))));
		}
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Docker$eval = function (docker) {
	return A4(
		$author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalPackager,
		'docker',
		_Utils_update(
			$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$packagersInit,
			{
				Cj: _List_fromArray(
					[
						{jE: docker.jE, Bd: docker.Bd, Cr: docker.Cr, uC: docker.uC, w: docker.w}
					])
			}),
		$danyx23$elm_uuid$Uuid$toString(docker.po),
		docker.fG);
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Fail$eval = function (_v0) {
	var message = _v0.Eh;
	return $author$project$Pipeline$problem(
		$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr('fail: ' + message));
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueFindRoots = F2(
	function (a, b) {
		return {$: 22, a: a, b: b};
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$FindRoots$eval = function (_v0) {
	var closure = _v0.BJ;
	var src = _v0.fG;
	if (src.$ === 21) {
		var genericSBOM = src.a;
		return $author$project$Pipeline$succeed(
			A2(
				$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueFindRoots,
				{BJ: closure},
				genericSBOM));
	} else {
		return $author$project$Pipeline$problem(
			$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr(
				'\'find_roots\' function must take a \'generic_sbom\' in its \'src\' argument, but got: ' + $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getType(src)));
	}
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueGenericSBOM = function (a) {
	return {$: 21, a: a};
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$GenericSBOM$eval = function (genericSBOM) {
	return $author$project$Pipeline$succeed(
		$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueGenericSBOM(genericSBOM));
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$LinuxInstaller$eval = function (linuxInstaller) {
	return A4(
		$author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalPackager,
		'linux_installer',
		_Utils_update(
			$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$packagersInit,
			{
				D4: _List_fromArray(
					[
						{jE: linuxInstaller.jE, uC: linuxInstaller.uC, w: linuxInstaller.w}
					])
			}),
		$danyx23$elm_uuid$Uuid$toString(linuxInstaller.po),
		linuxInstaller.fG);
};
var $elm$core$Dict$filter = F2(
	function (isGood, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, d) {
					return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $elm$core$Dict$intersect = F2(
	function (t1, t2) {
		return A2(
			$elm$core$Dict$filter,
			F2(
				function (k, _v0) {
					return A2($elm$core$Dict$member, k, t2);
				}),
			t1);
	});
var $elm$core$Set$intersect = F2(
	function (_v0, _v1) {
		var dict1 = _v0;
		var dict2 = _v1;
		return A2($elm$core$Dict$intersect, dict1, dict2);
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Merge$eval = function (_v0) {
	var left = _v0.uv;
	var right = _v0.v0;
	var _v1 = _Utils_Tuple2(left, right);
	_v1$2:
	while (true) {
		switch (_v1.a.$) {
			case 16:
				if (_v1.b.$ === 16) {
					var _v2 = _v1.a;
					var accLeft = _v2.a;
					var fieldsLeft = _v2.b;
					var _v3 = _v1.b;
					var accRight = _v3.a;
					var fieldsRight = _v3.b;
					if (!_Utils_eq(accLeft.m0, accRight.m0)) {
						return $author$project$Pipeline$problem(
							$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr('Packagers to merge must have the same \'platform\'. Got left: \'' + (accLeft.m0 + ('\', right: \'' + (accRight.m0 + '\'')))));
					} else {
						if (!_Utils_eq(fieldsLeft, fieldsRight)) {
							return $author$project$Pipeline$problem(
								$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr(
									'Packagers to merge must have the same \'src\'. Got left: \'' + ($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getType(left) + ('\', right: \'' + ($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getType(right) + '\'')))));
						} else {
							var acc_ = {
								E2: {
									A8: _Utils_ap(accLeft.E2.A8, accRight.E2.A8),
									Cj: _Utils_ap(accLeft.E2.Cj, accRight.E2.Cj),
									D4: _Utils_ap(accLeft.E2.D4, accRight.E2.D4),
									vX: _Utils_ap(accLeft.E2.vX, accRight.E2.vX),
									w4: _Utils_ap(accLeft.E2.w4, accRight.E2.w4)
								},
								m0: accLeft.m0,
								gR: 'merge'
							};
							return $author$project$Pipeline$succeed(
								A2($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValuePackagers, acc_, fieldsLeft));
						}
					}
				} else {
					break _v1$2;
				}
			case 14:
				if (_v1.b.$ === 14) {
					var fieldsLeft = _v1.a.a;
					var fieldsRight = _v1.b.a;
					var platformIdsRight = $elm$core$Dict$keys(fieldsRight.E2);
					var platformIdsLeft = $elm$core$Dict$keys(fieldsLeft.E2);
					return (!$elm$core$Set$isEmpty(
						A2(
							$elm$core$Set$intersect,
							$elm$core$Set$fromList(platformIdsLeft),
							$elm$core$Set$fromList(platformIdsRight)))) ? $author$project$Pipeline$problem(
						$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr(
							'Authenticode signatures to merge must have a DISTINCT \'platform\'. Got left: \'' + (A2($elm$core$String$join, ',', platformIdsLeft) + ('\'; right: \'' + (A2($elm$core$String$join, ',', platformIdsRight) + '\''))))) : (((!_Utils_eq(fieldsLeft.Ec, fieldsRight.Ec)) || (!_Utils_eq(fieldsLeft.sr, fieldsRight.sr))) ? $author$project$Pipeline$problem(
						$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr(
							'Authenticode signatures to merge must have the same \'src\'. Got left: \'' + ($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getType(left) + ('\', right: \'' + ($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getType(right) + '\''))))) : $author$project$Pipeline$succeed(
						$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueAuthenticodeSignature(
							_Utils_update(
								fieldsLeft,
								{
									E2: A2($elm$core$Dict$union, fieldsLeft.E2, fieldsRight.E2)
								}))));
				} else {
					break _v1$2;
				}
			default:
				break _v1$2;
		}
	}
	return $author$project$Pipeline$problem(
		$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr(
			'Can only merge two packagers (or two authenticode_signatures). Got left: \'' + ($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getType(left) + ('\', right: \'' + ($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getType(right) + '\'')))));
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueMergeSet = function (a) {
	return {$: 18, a: a};
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$MergeSet$eval = function (fields) {
	return $author$project$Pipeline$succeed(
		$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueMergeSet(fields));
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$MarkersPrePlatformInstaller = {$: 1};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$PrePlatformInstaller$eval = function (_v0) {
	var src = _v0.fG;
	if (src.$ === 7) {
		var solve = src.a;
		return $author$project$Pipeline$succeed(
			$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueMarkers(
				{Ec: $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$MarkersPrePlatformInstaller, E2: $elm$core$Dict$empty, sr: solve}));
	} else {
		return $author$project$Pipeline$problem(
			$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr(
				'\'pre_platform_installer\' function must take a \'solve\' in its \'src\' argument, but got: ' + $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getType(src)));
	}
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$RelocateAndZip$eval = function (relocateAndZip) {
	return A4(
		$author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalPackager,
		'relocate_and_zip',
		_Utils_update(
			$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$packagersInit,
			{
				vX: _List_fromArray(
					[
						{w: relocateAndZip.w}
					])
			}),
		$danyx23$elm_uuid$Uuid$toString(relocateAndZip.po),
		relocateAndZip.fG);
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueReplaceImage = F2(
	function (a, b) {
		return {$: 19, a: a, b: b};
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$ReplaceImage$eval = function (replaceImage) {
	var replaceImage_ = {jE: replaceImage.jE, Ea: replaceImage.Ea, w: replaceImage.w, aE: replaceImage.aE, aI: replaceImage.aI};
	var _v0 = replaceImage.fG;
	switch (_v0.$) {
		case 17:
			var scannedImage = _v0.a;
			return $author$project$Pipeline$succeed(
				A2(
					$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueReplaceImage,
					_List_fromArray(
						[replaceImage_]),
					_List_fromArray(
						[scannedImage])));
		case 18:
			var set = _v0.a.F0;
			return $author$project$Pipeline$succeed(
				A2(
					$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueReplaceImage,
					_List_fromArray(
						[replaceImage_]),
					set));
		case 19:
			var replaceImages = _v0.a;
			var scannedImages = _v0.b;
			return $author$project$Pipeline$succeed(
				A2(
					$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueReplaceImage,
					A2($elm$core$List$cons, replaceImage_, replaceImages),
					scannedImages));
		default:
			return $author$project$Pipeline$problem(
				$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr(
					'\'replace_image\' function must take a \'scanned_image\', \'merge_set\' or another \'replace_image\' in its \'src\' argument, but got: ' + $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getType(replaceImage.fG)));
	}
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueReq = function (a) {
	return {$: 8, a: a};
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Req$eval = function (req) {
	return $author$project$Pipeline$succeed(
		$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueReq(req));
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueScannedImage = function (a) {
	return {$: 17, a: a};
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$ScannedImage$eval = function (scannedImage) {
	return $author$project$Pipeline$succeed(
		$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueScannedImage(scannedImage));
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueSolve = function (a) {
	return {$: 7, a: a};
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Solve$eval = function (solve) {
	return $author$project$Pipeline$succeed(
		$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueSolve(solve));
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$Community = 1;
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$MarkersStateToolArtifacts = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$Neither = 0;
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$Wheel = 2;
var $author$project$Model$BuildPlanner$BuildExpr$Eval$StateToolArtifacts$eval = function (_v0) {
	var src = _v0.fG;
	var buildFlags = _v0.xs;
	var stateToolArtifacts = {xs: buildFlags};
	switch (src.$) {
		case 7:
			var solve = src.a;
			return $author$project$Pipeline$succeed(
				$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueMarkers(
					{
						Ec: A2($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$MarkersStateToolArtifacts, 0, stateToolArtifacts),
						E2: $elm$core$Dict$empty,
						sr: solve
					}));
		case 11:
			var solve = src.a;
			return $author$project$Pipeline$succeed(
				$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueMarkers(
					{
						Ec: A2($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$MarkersStateToolArtifacts, 1, stateToolArtifacts),
						E2: $elm$core$Dict$empty,
						sr: solve
					}));
		case 12:
			var solve = src.a;
			return $author$project$Pipeline$succeed(
				$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueMarkers(
					{
						Ec: A2($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$MarkersStateToolArtifacts, 2, stateToolArtifacts),
						E2: $elm$core$Dict$empty,
						sr: solve
					}));
		default:
			return $author$project$Pipeline$problem(
				$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr(
					'\'state_tool_artifacts\' function must take a \'solve\', \'community_artifacts\' or \'wheel_artifacts\' in its \'src\' argument, but got: ' + $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getType(src)));
	}
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$MarkersStateToolArtifactsV1 = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$StateToolArtifactsV1$eval = function (_v0) {
	var src = _v0.fG;
	var buildFlags = _v0.xs;
	var stateToolArtifactsV1 = {xs: buildFlags};
	if (src.$ === 7) {
		var solve = src.a;
		return $author$project$Pipeline$succeed(
			$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueMarkers(
				{
					Ec: $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$MarkersStateToolArtifactsV1(stateToolArtifactsV1),
					E2: $elm$core$Dict$empty,
					sr: solve
				}));
	} else {
		return $author$project$Pipeline$problem(
			$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr(
				'\'state_tool_artifacts_v1\' function must take a \'solve\' in its \'src\' argument, but got: ' + $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getType(src)));
	}
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueWheelArtifacts = function (a) {
	return {$: 12, a: a};
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$WheelArtifacts$eval = function (_v0) {
	var src = _v0.fG;
	if (src.$ === 7) {
		var solve = src.a;
		return $author$project$Pipeline$succeed(
			$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueWheelArtifacts(solve));
	} else {
		return $author$project$Pipeline$problem(
			$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr(
				'\'wheel_artifacts\' function must take a \'solve\' in its \'src\' argument, but got: ' + $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getType(src)));
	}
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$WindowsInstaller$eval = function (windowsInstaller) {
	return A4(
		$author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalPackager,
		'windows_installer',
		_Utils_update(
			$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$packagersInit,
			{
				w4: _List_fromArray(
					[
						{jE: windowsInstaller.jE, uC: windowsInstaller.uC, w: windowsInstaller.w}
					])
			}),
		$danyx23$elm_uuid$Uuid$toString(windowsInstaller.po),
		windowsInstaller.fG);
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$AddMissingSources$AddMissingSourcesArgs = F2(
	function (src, dest) {
		return {Cf: dest, fG: src};
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalValue = F3(
	function (funcName, argName, args) {
		var _v0 = A2($elm$core$Dict$get, argName, args);
		if (_v0.$ === 1) {
			return $author$project$Pipeline$problem(
				$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr('type mismatch for \'' + (funcName + ('\' argument \'' + (argName + '\', expected a value')))));
		} else {
			var src = _v0.a;
			return $author$project$Pipeline$succeed(src);
		}
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalSrc = F2(
	function (funcName, args) {
		return A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalValue, funcName, 'src', args);
	});
var $author$project$Pipeline$with = F2(
	function (pA, pFunc) {
		return A2(
			$author$project$Pipeline$andThen,
			function (func) {
				return A2($author$project$Pipeline$map, func, pA);
			},
			pFunc);
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$AddMissingSources$evalArgs = function (args) {
	return A2(
		$author$project$Pipeline$with,
		A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalValue, 'add_missing_sources', 'dest', args),
		A2(
			$author$project$Pipeline$with,
			A2($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalSrc, 'add_missing_sources', args),
			$author$project$Pipeline$succeed($author$project$Model$BuildPlanner$BuildExpr$Eval$AddMissingSources$AddMissingSourcesArgs)));
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$AuthenticodeSignature$AuthenticodeSignatureArgs = F2(
	function (src, platform) {
		return {po: platform, fG: src};
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalUuid = F3(
	function (funcName, argName, args) {
		var _v0 = A2($elm$core$Dict$get, argName, args);
		if (_v0.$ === 1) {
			return $author$project$Pipeline$problem(
				$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr('type mismatch for \'' + (funcName + ('\' argument \'' + (argName + '\', expected a uuid string')))));
		} else {
			if (_v0.a.$ === 4) {
				var str = _v0.a.a;
				var _v1 = $danyx23$elm_uuid$Uuid$fromString(str);
				if (_v1.$ === 1) {
					return $author$project$Pipeline$problem(
						$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr('type mismatch for \'' + (funcName + ('\' argument \'' + (argName + ('\', expected a uuid string, got: ' + str))))));
				} else {
					var uuid = _v1.a;
					return $author$project$Pipeline$succeed(uuid);
				}
			} else {
				var value = _v0.a;
				return $author$project$Pipeline$problem(
					$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr(
						'type mismatch for \'' + (funcName + ('\' argument \'' + (argName + ('\', expected a uuid string, got: ' + $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getType(value)))))));
			}
		}
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$AuthenticodeSignature$evalArgs = function (args) {
	return A2(
		$author$project$Pipeline$with,
		A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalUuid, 'authenticode_signature', 'platform', args),
		A2(
			$author$project$Pipeline$with,
			A2($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalSrc, 'authenticode_signature', args),
			$author$project$Pipeline$succeed($author$project$Model$BuildPlanner$BuildExpr$Eval$AuthenticodeSignature$AuthenticodeSignatureArgs)));
};
var $author$project$Model$BuildPlanner$BuildExpr$BuildFlag$BuildFlag = F2(
	function (name, value) {
		return {w: name, kH: value};
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalString = F3(
	function (funcName, argName, args) {
		var _v0 = A2($elm$core$Dict$get, argName, args);
		if (_v0.$ === 1) {
			return $author$project$Pipeline$problem(
				$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr('type mismatch for \'' + (funcName + ('\' argument \'' + (argName + '\', expected a string')))));
		} else {
			if (_v0.a.$ === 4) {
				var str = _v0.a.a;
				return $author$project$Pipeline$succeed(str);
			} else {
				var value = _v0.a;
				return $author$project$Pipeline$problem(
					$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr(
						'type mismatch for \'' + (funcName + ('\' argument \'' + (argName + ('\', expected a string, got: ' + $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getType(value)))))));
			}
		}
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalStringOptional = F3(
	function (funcName, argName, args) {
		var _v0 = A2($elm$core$Dict$get, argName, args);
		if (_v0.$ === 1) {
			return $author$project$Pipeline$succeed($elm$core$Maybe$Nothing);
		} else {
			switch (_v0.a.$) {
				case 0:
					var _v1 = _v0.a;
					return $author$project$Pipeline$succeed($elm$core$Maybe$Nothing);
				case 4:
					var str = _v0.a.a;
					return $author$project$Pipeline$succeed(
						$elm$core$Maybe$Just(str));
				default:
					var value = _v0.a;
					return $author$project$Pipeline$problem(
						$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr(
							'type mismatch for \'' + (funcName + ('\' argument \'' + (argName + ('\', expected a string, got: ' + $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getType(value)))))));
			}
		}
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$BuildFlag$evalArgs = function (args) {
	return A2(
		$author$project$Pipeline$with,
		A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalStringOptional, 'BuildFlag', 'value', args),
		A2(
			$author$project$Pipeline$with,
			A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalString, 'BuildFlag', 'name', args),
			$author$project$Pipeline$succeed($author$project$Model$BuildPlanner$BuildExpr$BuildFlag$BuildFlag)));
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Camel$CamelArgs = F2(
	function (src, camelFlags) {
		return {Bn: camelFlags, fG: src};
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalStrings = F3(
	function (funcName, argName, args) {
		var _v0 = A2($elm$core$Dict$get, argName, args);
		if (_v0.$ === 1) {
			return $author$project$Pipeline$succeed(_List_Nil);
		} else {
			if (_v0.a.$ === 6) {
				var values = _v0.a.a;
				return A2(
					$author$project$Pipeline$forEach,
					values,
					function (value) {
						if (value.$ === 4) {
							var str = value.a;
							return $author$project$Pipeline$succeed(str);
						} else {
							return $author$project$Pipeline$problem(
								$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr(
									'type mismatch for \'' + (funcName + ('\' argument \'' + (argName + ('\', expected a list of `strings`, got: ' + $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getType(value)))))));
						}
					});
			} else {
				var value = _v0.a;
				return $author$project$Pipeline$problem(
					$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr(
						'type mismatch for \'' + (funcName + ('\' argument \'' + (argName + ('\', expected a `list` of strings, got: ' + $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getType(value)))))));
			}
		}
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Camel$evalArgs = function (args) {
	return A2(
		$author$project$Pipeline$with,
		A2(
			$author$project$Pipeline$map,
			$elm$core$Set$fromList,
			A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalStrings, 'camel', 'camel_flags', args)),
		A2(
			$author$project$Pipeline$with,
			A2($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalSrc, 'camel', args),
			$author$project$Pipeline$succeed($author$project$Model$BuildPlanner$BuildExpr$Eval$Camel$CamelArgs)));
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$CommunityArtifacts$CommunityArtifactsArgs = function (src) {
	return {fG: src};
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$CommunityArtifacts$evalArgs = function (args) {
	return A2(
		$author$project$Pipeline$with,
		A2($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalSrc, 'community_artifacts', args),
		$author$project$Pipeline$succeed($author$project$Model$BuildPlanner$BuildExpr$Eval$CommunityArtifacts$CommunityArtifactsArgs));
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$DependencyLinkFields = F3(
	function (purl, dependsOnPurl, type_) {
		return {Ce: dependsOnPurl, k: purl, gR: type_};
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$DependencyLink$evalArgs = function (args) {
	return A2(
		$author$project$Pipeline$with,
		A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalString, 'DependencyLink', 'type', args),
		A2(
			$author$project$Pipeline$with,
			A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalString, 'DependencyLink', 'depends_on_purl', args),
			A2(
				$author$project$Pipeline$with,
				A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalString, 'DependencyLink', 'purl', args),
				$author$project$Pipeline$succeed($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$DependencyLinkFields))));
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Docker$DockerArgs = F7(
	function (src, atTime, baseImage, env, memory, name, platform) {
		return {jE: atTime, Bd: baseImage, Cr: env, uC: memory, w: name, po: platform, fG: src};
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalAtTime = F2(
	function (funcName, args) {
		var _v0 = A2($elm$core$Dict$get, 'at_time', args);
		if (_v0.$ === 1) {
			return $author$project$Pipeline$succeed($elm$core$Maybe$Nothing);
		} else {
			switch (_v0.a.$) {
				case 0:
					var _v1 = _v0.a;
					return $author$project$Pipeline$succeed($elm$core$Maybe$Nothing);
				case 4:
					var str = _v0.a.a;
					var _v2 = $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(str);
					if (_v2.$ === 1) {
						return $author$project$Pipeline$problem(
							$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr('type mismatch for \'' + (funcName + ('\' argument \'at_time\', expected a timestamp string, or \'$at_time\', got: ' + str))));
					} else {
						var posix = _v2.a;
						return $author$project$Pipeline$succeed(
							$elm$core$Maybe$Just(posix));
					}
				case 5:
					var _v3 = _v0.a;
					return $author$project$Pipeline$succeed($elm$core$Maybe$Nothing);
				default:
					var value = _v0.a;
					return $author$project$Pipeline$problem(
						$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr(
							'type mismatch for \'' + (funcName + ('\' argument \'at_time\', expected a timestamp string, or \'$at_time\', got: ' + $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getType(value)))));
			}
		}
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalIntOptional = F3(
	function (funcName, argName, args) {
		var _v0 = A2($elm$core$Dict$get, argName, args);
		if (_v0.$ === 1) {
			return $author$project$Pipeline$succeed($elm$core$Maybe$Nothing);
		} else {
			switch (_v0.a.$) {
				case 0:
					var _v1 = _v0.a;
					return $author$project$Pipeline$succeed($elm$core$Maybe$Nothing);
				case 2:
					var _int = _v0.a.a;
					return $author$project$Pipeline$succeed(
						$elm$core$Maybe$Just(_int));
				default:
					var value = _v0.a;
					return $author$project$Pipeline$problem(
						$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr(
							'type mismatch for \'' + (funcName + ('\' argument \'' + (argName + ('\', expected an integer, got: ' + $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getType(value)))))));
			}
		}
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Docker$evalArgs = function (args) {
	return A2(
		$author$project$Pipeline$with,
		A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalUuid, 'docker', 'platform', args),
		A2(
			$author$project$Pipeline$with,
			A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalString, 'docker', 'name', args),
			A2(
				$author$project$Pipeline$with,
				A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalIntOptional, 'docker', 'memory', args),
				A2(
					$author$project$Pipeline$with,
					A2(
						$author$project$Pipeline$map,
						$elm$core$Set$fromList,
						A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalStrings, 'docker', 'env', args)),
					A2(
						$author$project$Pipeline$with,
						A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalString, 'docker', 'base_image', args),
						A2(
							$author$project$Pipeline$with,
							A2($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalAtTime, 'docker', args),
							A2(
								$author$project$Pipeline$with,
								A2($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalSrc, 'docker', args),
								$author$project$Pipeline$succeed($author$project$Model$BuildPlanner$BuildExpr$Eval$Docker$DockerArgs))))))));
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Fail$evalArgs = function (args) {
	var _v0 = A2($elm$core$Dict$get, 'message', args);
	if (_v0.$ === 1) {
		return $author$project$Pipeline$problem(
			$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr('type mismatch for \'fail\' argument \'message\', expected a string'));
	} else {
		if (_v0.a.$ === 4) {
			var message = _v0.a.a;
			return $author$project$Pipeline$succeed(
				{Eh: message});
		} else {
			var value = _v0.a;
			return $author$project$Pipeline$problem(
				$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr(
					'type mismatch for \'fail\' argument \'message\', expected a string, got: ' + $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getType(value)));
		}
	}
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$FindRoots$FindRootsArgs = F2(
	function (closure, src) {
		return {BJ: closure, fG: src};
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$FindRoots$evalArgs = function (args) {
	return A2(
		$author$project$Pipeline$with,
		A2($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalSrc, 'find_roots', args),
		A2(
			$author$project$Pipeline$with,
			A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalString, 'find_roots', 'closure', args),
			$author$project$Pipeline$succeed($author$project$Model$BuildPlanner$BuildExpr$Eval$FindRoots$FindRootsArgs)));
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$GenericSBOMFields = F5(
	function (atTime, name, url, contents, dependencyLinks) {
		return {jE: atTime, xM: contents, Cd: dependencyLinks, w: name, GT: url};
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalValues = F3(
	function (funcName, argName, args) {
		var _v0 = A2($elm$core$Dict$get, argName, args);
		if (_v0.$ === 1) {
			return $author$project$Pipeline$succeed(_List_Nil);
		} else {
			if (_v0.a.$ === 6) {
				var values = _v0.a.a;
				return $author$project$Pipeline$succeed(values);
			} else {
				var value = _v0.a;
				return $author$project$Pipeline$problem(
					$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr(
						'type mismatch for \'' + (funcName + ('\' argument \'' + (argName + ('\', expected a list of values, got: ' + $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getType(value)))))));
			}
		}
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$GenericSBOM$evalArgs = function (args) {
	return A2(
		$author$project$Pipeline$with,
		A2(
			$author$project$Pipeline$andThen,
			function (values) {
				return A2(
					$author$project$Pipeline$forEach,
					values,
					function (value) {
						if (value.$ === 20) {
							var dependencyLinkFields = value.a;
							return $author$project$Pipeline$succeed(dependencyLinkFields);
						} else {
							return $author$project$Pipeline$problem(
								$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr(
									'\'generic_sbom\' function must take \'DependencyLink\'s in its \'dependency_links\' argument, but got: ' + $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getType(value)));
						}
					});
			},
			A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalValues, 'generic_sbom', 'dependency_links', args)),
		A2(
			$author$project$Pipeline$with,
			A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalStrings, 'generic_sbom', 'contents', args),
			A2(
				$author$project$Pipeline$with,
				A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalString, 'generic_sbom', 'url', args),
				A2(
					$author$project$Pipeline$with,
					A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalString, 'generic_sbom', 'name', args),
					A2(
						$author$project$Pipeline$with,
						A2($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalAtTime, 'generic_sbom', args),
						$author$project$Pipeline$succeed($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$GenericSBOMFields))))));
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$LinuxInstaller$LinuxInstallerArgs = F5(
	function (src, atTime, memory, name, platform) {
		return {jE: atTime, uC: memory, w: name, po: platform, fG: src};
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$LinuxInstaller$evalArgs = function (args) {
	return A2(
		$author$project$Pipeline$with,
		A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalUuid, 'linux_installer', 'platform', args),
		A2(
			$author$project$Pipeline$with,
			A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalString, 'linux_installer', 'name', args),
			A2(
				$author$project$Pipeline$with,
				A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalIntOptional, 'linux_installer', 'memory', args),
				A2(
					$author$project$Pipeline$with,
					A2($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalAtTime, 'linux_installer', args),
					A2(
						$author$project$Pipeline$with,
						A2($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalSrc, 'linux_installer', args),
						$author$project$Pipeline$succeed($author$project$Model$BuildPlanner$BuildExpr$Eval$LinuxInstaller$LinuxInstallerArgs))))));
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Merge$evalArgs = function (args) {
	var _v0 = A2($elm$core$Dict$get, 'left', args);
	if (_v0.$ === 1) {
		return $author$project$Pipeline$problem(
			$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr('type mismatch for \'merge\' argument \'left\', expected a value'));
	} else {
		var left = _v0.a;
		var _v1 = A2($elm$core$Dict$get, 'right', args);
		if (_v1.$ === 1) {
			return $author$project$Pipeline$problem(
				$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr('type mismatch for \'merge\' argument \'right\', expected a value'));
		} else {
			var right = _v1.a;
			return $author$project$Pipeline$succeed(
				{uv: left, v0: right});
		}
	}
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$MergeSetFields = function (set) {
	return {F0: set};
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$MergeSet$evalArgs = function (args) {
	return A2(
		$author$project$Pipeline$with,
		A2(
			$author$project$Pipeline$andThen,
			function (values) {
				return A2(
					$author$project$Pipeline$forEach,
					values,
					function (value) {
						if (value.$ === 17) {
							var scannedImage = value.a;
							return $author$project$Pipeline$succeed(scannedImage);
						} else {
							return $author$project$Pipeline$problem(
								$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr(
									'\'merge_set\' function must take scanned_images, but got: ' + $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getType(value)));
						}
					});
			},
			A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalValues, 'merge_set', 'set', args)),
		$author$project$Pipeline$succeed($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$MergeSetFields));
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$PrePlatformInstaller$PrePlatformInstallerArgs = function (src) {
	return {fG: src};
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$PrePlatformInstaller$evalArgs = function (args) {
	return A2(
		$author$project$Pipeline$with,
		A2($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalSrc, 'pre_platform_installer', args),
		$author$project$Pipeline$succeed($author$project$Model$BuildPlanner$BuildExpr$Eval$PrePlatformInstaller$PrePlatformInstallerArgs));
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$RelocateAndZip$RelocateAndZipArgs = F3(
	function (src, name, platform) {
		return {w: name, po: platform, fG: src};
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$RelocateAndZip$evalArgs = function (args) {
	return A2(
		$author$project$Pipeline$with,
		A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalUuid, 'relocate_and_zip', 'platform', args),
		A2(
			$author$project$Pipeline$with,
			A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalString, 'relocate_and_zip', 'name', args),
			A2(
				$author$project$Pipeline$with,
				A2($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalSrc, 'relocate_and_zip', args),
				$author$project$Pipeline$succeed($author$project$Model$BuildPlanner$BuildExpr$Eval$RelocateAndZip$RelocateAndZipArgs))));
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$ReplaceImage$ReplaceImageArgs = F6(
	function (src, atTime, namespace, name, version, manifests) {
		return {jE: atTime, Ea: manifests, w: name, aE: namespace, fG: src, aI: version};
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$ReplaceImage$evalArgs = function (args) {
	return A2(
		$author$project$Pipeline$with,
		A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalStrings, 'replace_image', 'manifests', args),
		A2(
			$author$project$Pipeline$with,
			A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalString, 'replace_image', 'version', args),
			A2(
				$author$project$Pipeline$with,
				A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalString, 'replace_image', 'name', args),
				A2(
					$author$project$Pipeline$with,
					A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalString, 'replace_image', 'namespace', args),
					A2(
						$author$project$Pipeline$with,
						A2($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalAtTime, 'replace_image', args),
						A2(
							$author$project$Pipeline$with,
							A2($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalSrc, 'replace_image', args),
							$author$project$Pipeline$succeed($author$project$Model$BuildPlanner$BuildExpr$Eval$ReplaceImage$ReplaceImageArgs)))))));
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$Req = F3(
	function (name, namespace, version) {
		return {w: name, aE: namespace, aI: version};
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Req$evalArgs = function (args) {
	return A2(
		$author$project$Pipeline$with,
		function () {
			var _v0 = A2($elm$core$Dict$get, 'version', args);
			if (_v0.$ === 1) {
				return $author$project$Pipeline$succeed($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ConstraintAny);
			} else {
				switch (_v0.a.$) {
					case 9:
						var constraint = _v0.a.a;
						return $author$project$Pipeline$succeed(constraint);
					case 10:
						var pred = _v0.a.a;
						return $author$project$Pipeline$succeed(
							$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$Constraint(pred));
					default:
						var value = _v0.a;
						return $author$project$Pipeline$problem(
							$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr(
								'type mismatch for \'Req\' argument \'version\', expected a constraint, but got: ' + $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getType(value)));
				}
			}
		}(),
		A2(
			$author$project$Pipeline$with,
			A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalString, 'Req', 'namespace', args),
			A2(
				$author$project$Pipeline$with,
				A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalString, 'Req', 'name', args),
				$author$project$Pipeline$succeed($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$Req))));
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ScannedImageFields = F9(
	function (atTime, registry, basedOn, imageName, manifestDigest, osArch, tags, contents, scanUri) {
		return {jE: atTime, Be: basedOn, xM: contents, CT: imageName, D9: manifestDigest, E$: osArch, Fz: registry, FS: scanUri, Gt: tags};
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$ScannedImage$evalArgs = function (args) {
	return A2(
		$author$project$Pipeline$with,
		A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalString, 'scanned_image', 'scan_uri', args),
		A2(
			$author$project$Pipeline$with,
			A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalStrings, 'scanned_image', 'contents', args),
			A2(
				$author$project$Pipeline$with,
				A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalStrings, 'scanned_image', 'tags', args),
				A2(
					$author$project$Pipeline$with,
					A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalString, 'scanned_image', 'os_arch', args),
					A2(
						$author$project$Pipeline$with,
						A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalString, 'scanned_image', 'manifest_digest', args),
						A2(
							$author$project$Pipeline$with,
							A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalString, 'scanned_image', 'image_name', args),
							A2(
								$author$project$Pipeline$with,
								A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalString, 'scanned_image', 'based_on', args),
								A2(
									$author$project$Pipeline$with,
									A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalString, 'scanned_image', 'registry', args),
									A2(
										$author$project$Pipeline$with,
										A2($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalAtTime, 'scanned_image', args),
										$author$project$Pipeline$succeed($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ScannedImageFields))))))))));
};
var $author$project$Model$BuildPlanner$BuildExpr$SolveEditor$Fields = F6(
	function (timestamp, timestampExplicit, solverVersion, platforms, requirements, dynamic) {
		return {ya: dynamic, Fh: platforms, FF: requirements, Ga: solverVersion, wG: timestamp, Gx: timestampExplicit};
	});
var $author$project$Model$BuildPlanner$BuildExpr$SolveEditor$initRequirements = {k5: $elm$core$Dict$empty, oI: $elm$core$Dict$empty, aM: $elm$core$Dict$empty, mY: $elm$core$Dict$empty};
var $author$project$Model$Namespace$BuildFlags = 1;
var $author$project$Model$Namespace$Bundle = 0;
var $author$project$Model$Namespace$CamelFlags = 2;
var $author$project$Model$Namespace$Hidden = 3;
var $author$project$Model$Namespace$Language = 4;
var $author$project$Model$Namespace$Package = 5;
var $author$project$Model$Namespace$Platform = 6;
var $author$project$Model$Namespace$buildFlags = 'build-flags';
var $author$project$Model$Namespace$camelFlags = 'camel-flags';
var $author$project$Model$Namespace$bundlesPrefix = 'bundles/';
var $author$project$Model$Namespace$hasBundlesPrefix = function (string) {
	return A2($elm$core$String$startsWith, $author$project$Model$Namespace$bundlesPrefix, string);
};
var $author$project$Model$Namespace$internalNamespaces = _List_fromArray(
	['builder', 'builder-lib', 'internal']);
var $author$project$Model$Namespace$isHidden = function (namespace) {
	if (A2($elm$core$List$member, namespace, $author$project$Model$Namespace$internalNamespaces)) {
		return true;
	} else {
		var _v0 = A2($elm$core$String$split, '/', namespace);
		if ((((_v0.b && (_v0.a === 'vendor')) && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.b.b)) {
			var _v1 = _v0.b;
			var _v2 = _v1.b;
			return true;
		} else {
			return false;
		}
	}
};
var $author$project$Model$Namespace$platform = 'platform';
var $author$project$Model$Namespace$kindFromString = function (namespace) {
	return $author$project$Model$Namespace$hasBundlesPrefix(namespace) ? 0 : (_Utils_eq(namespace, $author$project$Model$Namespace$buildFlags) ? 1 : (_Utils_eq(namespace, $author$project$Model$Namespace$camelFlags) ? 2 : ($author$project$Model$Namespace$isHidden(namespace) ? 3 : (_Utils_eq(namespace, $author$project$Model$Namespace$language) ? 4 : (_Utils_eq(namespace, $author$project$Model$Namespace$platform) ? 6 : 5)))));
};
var $author$project$Model$Namespace$kind = A2($elm$core$Basics$composeR, $author$project$Model$Namespace$getNamespace, $author$project$Model$Namespace$kindFromString);
var $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$Pinned = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$Auto = {$: 0};
var $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$Custom = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$Exact = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$fromVersionRequirements = function (versionRequirements) {
	if (!versionRequirements.b) {
		return $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$Auto;
	} else {
		var first = versionRequirements.a;
		var others = versionRequirements.b;
		var _v1 = _Utils_Tuple2(first.h, others);
		if ((_v1.a === 'eq') && (!_v1.b.b)) {
			return $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$Exact(first.aI);
		} else {
			return A2($author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$Custom, first, others);
		}
	}
};
var $author$project$Model$Namespace$key = function (_v0) {
	var namespace = _v0.aE;
	var name = _v0.w;
	return _Utils_Tuple2(namespace, name);
};
var $author$project$Model$BuildPlanner$BuildExpr$Solve$Requirement$toKeyAndConstraint = function (requirement) {
	return A2(
		$author$project$Model$BuildPlanner$BuildExpr$Solve$Requirement$KeyAndConstraint,
		$author$project$Model$Namespace$key(requirement),
		function () {
			var _v0 = requirement.CX;
			if (!_v0.$) {
				var ingredientVersion = _v0.a;
				return $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$Pinned(ingredientVersion);
			} else {
				return $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$fromVersionRequirements(requirement.gW);
			}
		}());
};
var $author$project$Model$BuildPlanner$BuildExpr$SolveEditor$requirementsFromList = function (requirements) {
	var accumRequirement = F2(
		function (req, acc) {
			var _v0 = $author$project$Model$BuildPlanner$BuildExpr$Solve$Requirement$toKeyAndConstraint(req);
			var key = _v0.Y;
			var constraint = _v0.bK;
			var name = $author$project$Model$Namespace$getName(key);
			var _v1 = $author$project$Model$Namespace$kind(key);
			switch (_v1) {
				case 0:
					return _Utils_update(
						acc,
						{
							k5: A3($elm$core$Dict$insert, key, constraint, acc.k5)
						});
				case 1:
					return acc;
				case 2:
					return acc;
				case 3:
					return _Utils_update(
						acc,
						{
							oI: A3($elm$core$Dict$insert, key, constraint, acc.oI)
						});
				case 4:
					return _Utils_update(
						acc,
						{
							aM: A3($elm$core$Dict$insert, name, constraint, acc.aM)
						});
				case 5:
					return _Utils_update(
						acc,
						{
							mY: A3($elm$core$Dict$insert, key, constraint, acc.mY)
						});
				default:
					return acc;
			}
		});
	return A3($elm$core$List$foldl, accumRequirement, $author$project$Model$BuildPlanner$BuildExpr$SolveEditor$initRequirements, requirements);
};
var $mgold$elm_nonempty_list$List$Nonempty$append = F2(
	function (_v0, _v1) {
		var x = _v0.a;
		var xs = _v0.b;
		var y = _v1.a;
		var ys = _v1.b;
		return A2(
			$mgold$elm_nonempty_list$List$Nonempty$Nonempty,
			x,
			_Utils_ap(
				xs,
				A2($elm$core$List$cons, y, ys)));
	});
var $mgold$elm_nonempty_list$List$Nonempty$singleton = function (x) {
	return A2($mgold$elm_nonempty_list$List$Nonempty$Nonempty, x, _List_Nil);
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$toVersionRequirement = function (pred) {
	switch (pred.$) {
		case 0:
			var left = pred.a;
			var right = pred.b;
			return A2(
				$mgold$elm_nonempty_list$List$Nonempty$append,
				$author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$toVersionRequirement(left),
				$author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$toVersionRequirement(right));
		case 1:
			var value = pred.a;
			return $mgold$elm_nonempty_list$List$Nonempty$singleton(
				{h: 'eq', aI: value});
		case 2:
			var value = pred.a;
			return $mgold$elm_nonempty_list$List$Nonempty$singleton(
				{h: 'gt', aI: value});
		case 3:
			var value = pred.a;
			return $mgold$elm_nonempty_list$List$Nonempty$singleton(
				{h: 'gte', aI: value});
		case 4:
			var value = pred.a;
			return $mgold$elm_nonempty_list$List$Nonempty$singleton(
				{h: 'lt', aI: value});
		case 5:
			var value = pred.a;
			return $mgold$elm_nonempty_list$List$Nonempty$singleton(
				{h: 'lte', aI: value});
		case 6:
			var value = pred.a;
			return $mgold$elm_nonempty_list$List$Nonempty$singleton(
				{h: 'ne', aI: value});
		default:
			var left = pred.a;
			var right = pred.b;
			return A2(
				$mgold$elm_nonempty_list$List$Nonempty$append,
				$author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$toVersionRequirement(left),
				$author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$toVersionRequirement(right));
	}
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$toVersionRequirements = function (constraint) {
	if (!constraint.$) {
		return _List_Nil;
	} else {
		var pred = constraint.a;
		return $mgold$elm_nonempty_list$List$Nonempty$toList(
			$author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$toVersionRequirement(pred));
	}
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Req$toRequirement = function (req) {
	return {
		CX: $elm$core$Maybe$Nothing,
		w: req.w,
		aE: req.aE,
		gW: $author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$toVersionRequirements(req.aI)
	};
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Solve$evalArgs = F2(
	function (isDynamic, args) {
		var name = isDynamic ? 'dynamic_solve' : 'solve';
		return A2(
			$author$project$Pipeline$with,
			$author$project$Pipeline$succeed(isDynamic),
			A2(
				$author$project$Pipeline$with,
				A2(
					$author$project$Pipeline$map,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$map($author$project$Model$BuildPlanner$BuildExpr$Eval$Req$toRequirement),
						$author$project$Model$BuildPlanner$BuildExpr$SolveEditor$requirementsFromList),
					A2(
						$author$project$Pipeline$andThen,
						function (values) {
							return A2(
								$author$project$Pipeline$forEach,
								values,
								function (value) {
									if (value.$ === 8) {
										var req = value.a;
										return $author$project$Pipeline$succeed(req);
									} else {
										return $author$project$Pipeline$problem(
											$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr(
												'type mismatch for \'' + (name + ('\' argument \'requirements\', expected a list of Reqs, but got: ' + $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getType(value)))));
									}
								});
						},
						A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalValues, name, 'requirements', args))),
				A2(
					$author$project$Pipeline$with,
					A2(
						$author$project$Pipeline$map,
						$elm$core$Set$fromList,
						A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalStrings, name, 'platforms', args)),
					A2(
						$author$project$Pipeline$with,
						A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalIntOptional, name, 'solver_version', args),
						A2(
							$author$project$Pipeline$with,
							$author$project$Pipeline$succeed(false),
							A2(
								$author$project$Pipeline$with,
								A2($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalAtTime, name, args),
								$author$project$Pipeline$succeed($author$project$Model$BuildPlanner$BuildExpr$SolveEditor$Fields)))))));
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$StateToolArtifacts$StateToolArtifactsArgs = F2(
	function (src, buildFlags) {
		return {xs: buildFlags, fG: src};
	});
var $author$project$Model$BuildPlanner$BuildExpr$BuildFlagsDict$buildFlagToNameAndValue = function (buildFlag) {
	return _Utils_Tuple2(
		buildFlag.w,
		A2($elm$core$Maybe$withDefault, '', buildFlag.kH));
};
var $author$project$Model$BuildPlanner$BuildExpr$BuildFlagsDict$fromList = A2(
	$elm$core$List$foldl,
	A2(
		$elm$core$Basics$composeL,
		$elm_community$basics_extra$Basics$Extra$uncurry($elm$core$Dict$insert),
		$author$project$Model$BuildPlanner$BuildExpr$BuildFlagsDict$buildFlagToNameAndValue),
	$elm$core$Dict$empty);
var $author$project$Model$BuildPlanner$BuildExpr$Eval$StateToolArtifacts$evalArgs = function (args) {
	return A2(
		$author$project$Pipeline$with,
		A2(
			$author$project$Pipeline$map,
			$author$project$Model$BuildPlanner$BuildExpr$BuildFlagsDict$fromList,
			A2(
				$author$project$Pipeline$andThen,
				function (values) {
					return A2(
						$author$project$Pipeline$forEach,
						values,
						function (value) {
							if (value.$ === 15) {
								var buildFlag = value.a;
								return $author$project$Pipeline$succeed(buildFlag);
							} else {
								return $author$project$Pipeline$problem(
									$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr(
										'\'state_tool_artifacts\' function must take a list of \'BuildFlag\' in its \'build_flags\' argument, but got: ' + $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getType(value)));
							}
						});
				},
				A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalValues, 'state_tool_artifacts', 'build_flags', args))),
		A2(
			$author$project$Pipeline$with,
			A2($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalSrc, 'state_tool_artifacts', args),
			$author$project$Pipeline$succeed($author$project$Model$BuildPlanner$BuildExpr$Eval$StateToolArtifacts$StateToolArtifactsArgs)));
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$StateToolArtifactsV1$StateToolArtifactsV1Args = F2(
	function (src, buildFlags) {
		return {xs: buildFlags, fG: src};
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$StateToolArtifactsV1$evalArgs = function (args) {
	return A2(
		$author$project$Pipeline$with,
		A2(
			$author$project$Pipeline$map,
			$author$project$Model$BuildPlanner$BuildExpr$BuildFlagsDict$fromList,
			A2(
				$author$project$Pipeline$andThen,
				function (values) {
					return A2(
						$author$project$Pipeline$forEach,
						values,
						function (value) {
							if (value.$ === 15) {
								var buildFlag = value.a;
								return $author$project$Pipeline$succeed(buildFlag);
							} else {
								return $author$project$Pipeline$problem(
									$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr(
										'\'state_tool_artifacts_v1\' function must take a list of \'BuildFlag\' functions in its \'build_flags\' argument, but got: ' + $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getType(value)));
							}
						});
				},
				A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalValues, 'state_tool_artifacts_v1', 'build_flags', args))),
		A2(
			$author$project$Pipeline$with,
			A2($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalSrc, 'state_tool_artifacts_v1', args),
			$author$project$Pipeline$succeed($author$project$Model$BuildPlanner$BuildExpr$Eval$StateToolArtifactsV1$StateToolArtifactsV1Args)));
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$WheelArtifacts$WheelArtifactsArgs = function (src) {
	return {fG: src};
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$WheelArtifacts$evalArgs = function (args) {
	return A2(
		$author$project$Pipeline$with,
		A2($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalSrc, 'wheel_artifacts', args),
		$author$project$Pipeline$succeed($author$project$Model$BuildPlanner$BuildExpr$Eval$WheelArtifacts$WheelArtifactsArgs));
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$WindowsInstaller$WindowsInstallerArgs = F5(
	function (src, atTime, memory, name, platform) {
		return {jE: atTime, uC: memory, w: name, po: platform, fG: src};
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$WindowsInstaller$evalArgs = function (args) {
	return A2(
		$author$project$Pipeline$with,
		A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalUuid, 'windows_installer', 'platform', args),
		A2(
			$author$project$Pipeline$with,
			A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalString, 'windows_installer', 'name', args),
			A2(
				$author$project$Pipeline$with,
				A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalIntOptional, 'windows_installer', 'memory', args),
				A2(
					$author$project$Pipeline$with,
					A2($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalAtTime, 'windows_installer', args),
					A2(
						$author$project$Pipeline$with,
						A2($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalSrc, 'windows_installer', args),
						$author$project$Pipeline$succeed($author$project$Model$BuildPlanner$BuildExpr$Eval$WindowsInstaller$WindowsInstallerArgs))))));
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$evalBinary = F2(
	function (constraint, _v0) {
		var left = _v0.uv;
		var right = _v0.v0;
		return $author$project$Pipeline$succeed(
			$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValuePred(
				A2(constraint, left, right)));
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$evalBinaryArgs = F2(
	function (funcName, args) {
		var _v0 = A2($elm$core$Dict$get, 'left', args);
		if (_v0.$ === 1) {
			return $author$project$Pipeline$problem(
				$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr('type mismatch for \'' + (funcName + '\' argument \'left\', expected a predicate')));
		} else {
			if (_v0.a.$ === 10) {
				var left = _v0.a.a;
				var _v1 = A2($elm$core$Dict$get, 'right', args);
				if (_v1.$ === 1) {
					return $author$project$Pipeline$problem(
						$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr('type mismatch for \'' + (funcName + '\' argument \'right\', expected a predicate')));
				} else {
					if (_v1.a.$ === 10) {
						var right = _v1.a.a;
						return $author$project$Pipeline$succeed(
							{uv: left, v0: right});
					} else {
						var value = _v1.a;
						return $author$project$Pipeline$problem(
							$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr(
								'type mismatch for \'' + (funcName + ('\' argument \'right\', expected a predicate, got: ' + $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getType(value)))));
					}
				}
			} else {
				var value = _v0.a;
				return $author$project$Pipeline$problem(
					$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr(
						'type mismatch for \'' + (funcName + ('\' argument \'left\', expected a predicate, got: ' + $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getType(value)))));
			}
		}
	});
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueConstraint = function (a) {
	return {$: 9, a: a};
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$evalEmpty = F2(
	function (constraint, _v0) {
		return $author$project$Pipeline$succeed(
			$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueConstraint(constraint));
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$EmptyArgs = {};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$evalEmptyArgs = function (_v0) {
	return $author$project$Pipeline$succeed($author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$EmptyArgs);
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$evalUnary = F2(
	function (constraint, _v0) {
		var value = _v0.kH;
		return $author$project$Pipeline$succeed(
			$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValuePred(
				constraint(value)));
	});
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$UnaryArgs = function (value) {
	return {kH: value};
};
var $author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$evalUnaryArgs = F2(
	function (funcName, args) {
		return A2(
			$author$project$Pipeline$with,
			A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$evalString, funcName, 'value', args),
			$author$project$Pipeline$succeed($author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$UnaryArgs));
	});
var $author$project$Model$BuildPlanner$BuildExpr$UnknownAp$PyPIPublisher = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$BuildPlanner$BuildExpr$UnknownAp$Unknown = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$BuildPlanner$BuildExpr$UnknownAp$fromString = function (str) {
	if (str === 'pypi_publisher') {
		return $author$project$Model$BuildPlanner$BuildExpr$UnknownAp$PyPIPublisher(str);
	} else {
		return $author$project$Model$BuildPlanner$BuildExpr$UnknownAp$Unknown(str);
	}
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simplifier$evalApp = F2(
	function (rec, _v0) {
		var name = _v0.w;
		var args = _v0.kO;
		return A2(
			$author$project$Pipeline$andThen,
			function (args_) {
				switch (name) {
					case 'And':
						return A2(
							$author$project$Pipeline$andThen,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$evalBinary($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$And),
							A2($author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$evalBinaryArgs, name, args_));
					case 'Any':
						return A2(
							$author$project$Pipeline$andThen,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$evalEmpty($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ConstraintAny),
							$author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$evalEmptyArgs(args_));
					case 'BuildFlag':
						return A2(
							$author$project$Pipeline$andThen,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$BuildFlag$eval,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$BuildFlag$evalArgs(args_));
					case 'DependencyLink':
						return A2(
							$author$project$Pipeline$andThen,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$DependencyLink$eval,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$DependencyLink$evalArgs(args_));
					case 'Eq':
						return A2(
							$author$project$Pipeline$andThen,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$evalUnary($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$Eq),
							A2($author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$evalUnaryArgs, name, args_));
					case 'Gt':
						return A2(
							$author$project$Pipeline$andThen,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$evalUnary($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$Gt),
							A2($author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$evalUnaryArgs, name, args_));
					case 'Gte':
						return A2(
							$author$project$Pipeline$andThen,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$evalUnary($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$Gte),
							A2($author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$evalUnaryArgs, name, args_));
					case 'Lt':
						return A2(
							$author$project$Pipeline$andThen,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$evalUnary($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$Lt),
							A2($author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$evalUnaryArgs, name, args_));
					case 'Lte':
						return A2(
							$author$project$Pipeline$andThen,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$evalUnary($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$Lte),
							A2($author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$evalUnaryArgs, name, args_));
					case 'Ne':
						return A2(
							$author$project$Pipeline$andThen,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$evalUnary($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$Ne),
							A2($author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$evalUnaryArgs, name, args_));
					case 'Or':
						return A2(
							$author$project$Pipeline$andThen,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$evalBinary($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$Or),
							A2($author$project$Model$BuildPlanner$BuildExpr$Eval$Constraint$evalBinaryArgs, name, args_));
					case 'Req':
						return A2(
							$author$project$Pipeline$andThen,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$Req$eval,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$Req$evalArgs(args_));
					case 'add_missing_sources':
						return A2(
							$author$project$Pipeline$andThen,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$AddMissingSources$eval,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$AddMissingSources$evalArgs(args_));
					case 'authenticode_signature':
						return A2(
							$author$project$Pipeline$andThen,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$AuthenticodeSignature$eval,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$AuthenticodeSignature$evalArgs(args_));
					case 'camel':
						return A2(
							$author$project$Pipeline$andThen,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$Camel$eval,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$Camel$evalArgs(args_));
					case 'community_artifacts':
						return A2(
							$author$project$Pipeline$andThen,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$CommunityArtifacts$eval,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$CommunityArtifacts$evalArgs(args_));
					case 'docker':
						return A2(
							$author$project$Pipeline$andThen,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$Docker$eval,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$Docker$evalArgs(args_));
					case 'dynamic_solve':
						return A2(
							$author$project$Pipeline$andThen,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$Solve$eval,
							A2($author$project$Model$BuildPlanner$BuildExpr$Eval$Solve$evalArgs, true, args_));
					case 'fail':
						return A2(
							$author$project$Pipeline$andThen,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$Fail$eval,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$Fail$evalArgs(args_));
					case 'find_roots':
						return A2(
							$author$project$Pipeline$andThen,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$FindRoots$eval,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$FindRoots$evalArgs(args_));
					case 'generic_sbom':
						return A2(
							$author$project$Pipeline$andThen,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$GenericSBOM$eval,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$GenericSBOM$evalArgs(args_));
					case 'linux_installer':
						return A2(
							$author$project$Pipeline$andThen,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$LinuxInstaller$eval,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$LinuxInstaller$evalArgs(args_));
					case 'merge':
						return A2(
							$author$project$Pipeline$andThen,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$Merge$eval,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$Merge$evalArgs(args_));
					case 'merge_set':
						return A2(
							$author$project$Pipeline$andThen,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$MergeSet$eval,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$MergeSet$evalArgs(args_));
					case 'pre_platform_installer':
						return A2(
							$author$project$Pipeline$andThen,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$PrePlatformInstaller$eval,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$PrePlatformInstaller$evalArgs(args_));
					case 'relocate_and_zip':
						return A2(
							$author$project$Pipeline$andThen,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$RelocateAndZip$eval,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$RelocateAndZip$evalArgs(args_));
					case 'replace_image':
						return A2(
							$author$project$Pipeline$andThen,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$ReplaceImage$eval,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$ReplaceImage$evalArgs(args_));
					case 'scanned_image':
						return A2(
							$author$project$Pipeline$andThen,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$ScannedImage$eval,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$ScannedImage$evalArgs(args_));
					case 'solve':
						return A2(
							$author$project$Pipeline$andThen,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$Solve$eval,
							A2($author$project$Model$BuildPlanner$BuildExpr$Eval$Solve$evalArgs, false, args_));
					case 'state_tool_artifacts':
						return A2(
							$author$project$Pipeline$andThen,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$StateToolArtifacts$eval,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$StateToolArtifacts$evalArgs(args_));
					case 'state_tool_artifacts_v1':
						return A2(
							$author$project$Pipeline$andThen,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$StateToolArtifactsV1$eval,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$StateToolArtifactsV1$evalArgs(args_));
					case 'wheel_artifacts':
						return A2(
							$author$project$Pipeline$andThen,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$WheelArtifacts$eval,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$WheelArtifacts$evalArgs(args_));
					case 'windows_installer':
						return A2(
							$author$project$Pipeline$andThen,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$WindowsInstaller$eval,
							$author$project$Model$BuildPlanner$BuildExpr$Eval$WindowsInstaller$evalArgs(args_));
					default:
						return $author$project$Pipeline$problem(
							$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalUnknownAp(
								$author$project$Model$BuildPlanner$BuildExpr$UnknownAp$fromString(name)));
				}
			},
			A2(
				$author$project$Pipeline$dictForEach,
				args,
				$elm$core$Basics$always(rec)));
	});
var $author$project$Model$BuildPlanner$BuildExprEditor$Simplifier$evalList = F2(
	function (rec, list) {
		return A2($author$project$Pipeline$forEach, list, rec);
	});
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ThunkValue = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueAtTime = {$: 5};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simplifier$evalVar = F2(
	function (rec, _v0) {
		var varName = _v0;
		return (varName === 'at_time') ? $author$project$Pipeline$succeed($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueAtTime) : A2(
			$author$project$Pipeline$andThen,
			function (ctx0) {
				if (A2($elm$core$List$member, varName, ctx0.E7)) {
					return $author$project$Pipeline$problem(
						$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr('Cycle while evaluating variable \'' + (varName + '\'')));
				} else {
					var _v1 = A2($elm$core$Dict$get, varName, ctx0.Gw);
					if (_v1.$ === 1) {
						return $author$project$Pipeline$problem(
							$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr('Undefined variable \'' + (varName + '\'')));
					} else {
						if (!_v1.a.$) {
							var value = _v1.a.a;
							return $author$project$Pipeline$succeed(value);
						} else {
							var expr = _v1.a.a;
							return A2(
								$author$project$Pipeline$andThen,
								function (_v2) {
									var value = _v2.b;
									return A2(
										$author$project$Pipeline$map,
										function (_v3) {
											return value;
										},
										$author$project$Pipeline$updateCtx(
											function (ctx) {
												return _Utils_update(
													ctx,
													{
														E7: ctx0.E7,
														Gw: A3(
															$elm$core$Dict$insert,
															varName,
															$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ThunkValue(value),
															ctx.Gw)
													});
											}));
								},
								A3(
									$author$project$Pipeline$map2,
									$elm$core$Tuple$pair,
									$author$project$Pipeline$updateCtx(
										function (ctx) {
											return _Utils_update(
												ctx,
												{
													E7: A2($elm$core$List$cons, varName, ctx.E7)
												});
										}),
									rec(expr)));
						}
					}
				}
			},
			$author$project$Pipeline$getCtx);
	});
var $author$project$Model$BuildPlanner$BuildExprEditor$Simplifier$eval = function (expr) {
	switch (expr.$) {
		case 0:
			return $author$project$Pipeline$succeed($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueNil);
		case 1:
			var bool = expr.a;
			return $author$project$Pipeline$succeed(
				$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueBool(bool));
		case 2:
			var _int = expr.a;
			return $author$project$Pipeline$succeed(
				$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueInt(_int));
		case 3:
			var _float = expr.a;
			return $author$project$Pipeline$succeed(
				$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueFloat(_float));
		case 4:
			var string = expr.a;
			return $author$project$Pipeline$succeed(
				$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueString(string));
		case 5:
			var _var = expr.a;
			return A2($author$project$Model$BuildPlanner$BuildExprEditor$Simplifier$evalVar, $author$project$Model$BuildPlanner$BuildExprEditor$Simplifier$eval, _var);
		case 6:
			var list = expr.a;
			return A2(
				$author$project$Pipeline$map,
				$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ValueList,
				A2($author$project$Model$BuildPlanner$BuildExprEditor$Simplifier$evalList, $author$project$Model$BuildPlanner$BuildExprEditor$Simplifier$eval, list));
		case 7:
			return $author$project$Pipeline$problem(
				$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr('Build expression must not contain nested \'let\' expressions'));
		default:
			var app = expr.a;
			return A2($author$project$Model$BuildPlanner$BuildExprEditor$Simplifier$evalApp, $author$project$Model$BuildPlanner$BuildExprEditor$Simplifier$eval, app);
	}
};
var $elm$core$Dict$map = F2(
	function (func, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				A2(func, key, value),
				A2($elm$core$Dict$map, func, left),
				A2($elm$core$Dict$map, func, right));
		}
	});
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$MarkersSBOMEditable = F3(
	function (a, b, c) {
		return {$: 6, a: a, b: b, c: c};
	});
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$fromAddMissingSources = function (_v0) {
	var src = _v0.fG;
	var communityOrWheel = _v0.tf;
	var solve = _v0.sr;
	var stateToolArtifacts = _v0.wn;
	return {
		Ec: A3($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$MarkersSBOMEditable, src, communityOrWheel, stateToolArtifacts),
		E2: $elm$core$Dict$empty,
		sr: solve
	};
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$MarkersImages = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Model$BuildPlanner$BuildExpr$SolveEditor$init = function (timestamp) {
	return {ya: false, Fh: $elm$core$Set$empty, FF: $author$project$Model$BuildPlanner$BuildExpr$SolveEditor$initRequirements, Ga: $elm$core$Maybe$Nothing, wG: timestamp, Gx: false};
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$fromImages = F2(
	function (replaceImages, scannedImages) {
		return {
			Ec: A2($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$MarkersImages, replaceImages, scannedImages),
			E2: $elm$core$Dict$empty,
			sr: $author$project$Model$BuildPlanner$BuildExpr$SolveEditor$init($elm$core$Maybe$Nothing)
		};
	});
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$MarkersSBOM = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$fromSBOM = F2(
	function (genericSBOM, findRoots) {
		return {
			Ec: A2($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$MarkersSBOM, findRoots, genericSBOM),
			E2: $elm$core$Dict$empty,
			sr: $author$project$Model$BuildPlanner$BuildExpr$SolveEditor$init($elm$core$Maybe$Nothing)
		};
	});
var $author$project$Model$BuildPlanner$BuildExprEditor$Simplifier$toFields = function (value) {
	switch (value.$) {
		case 13:
			var fields = value.a;
			return $elm$core$Result$Ok(fields);
		case 14:
			var fields = value.a;
			return $elm$core$Result$Ok(fields);
		case 16:
			var acc = value.a;
			var fields = value.b;
			return $elm$core$Result$Ok(
				A3($author$project$Model$BuildPlanner$BuildExpr$Eval$Utils$insertPackagers, acc.m0, acc.E2, fields));
		case 18:
			var set = value.a.F0;
			return $elm$core$Result$Ok(
				A2($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$fromImages, _List_Nil, set));
		case 19:
			var replaceImages = value.a;
			var scannedImages = value.b;
			return $elm$core$Result$Ok(
				A2($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$fromImages, replaceImages, scannedImages));
		case 22:
			var findRoots = value.a;
			var genericSBOM = value.b;
			return $elm$core$Result$Ok(
				A2($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$fromSBOM, genericSBOM, findRoots));
		case 23:
			var addMissingSources = value.a;
			return $elm$core$Result$Ok(
				$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$fromAddMissingSources(addMissingSources));
		default:
			return $elm$core$Result$Err(
				$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr('Build expression must contain a \'sources\' and a \'runtime\''));
	}
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simplifier$run = function (root) {
	if (root.$ === 7) {
		var body = root.a.sY;
		var vars = root.a.w0;
		var pipeline = A2(
			$author$project$Pipeline$andThen,
			function (_v1) {
				var bodyValue = _v1.a;
				var ctx = _v1.b;
				return A3(
					$author$project$Pipeline$map2,
					$elm$core$Basics$always,
					$author$project$Pipeline$succeed(bodyValue),
					A2(
						$author$project$Pipeline$dictForEach,
						ctx.Gw,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Basics$identity,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Model$BuildPlanner$BuildExpr$BuildExprVar,
								A2($elm$core$Basics$composeR, $author$project$Model$BuildPlanner$BuildExprEditor$Simplifier$eval, $elm$core$Basics$always)))));
			},
			A3(
				$author$project$Pipeline$map2,
				$elm$core$Tuple$pair,
				$author$project$Model$BuildPlanner$BuildExprEditor$Simplifier$eval(body),
				$author$project$Pipeline$getCtx));
		var initCtx = {
			E7: _List_Nil,
			Gw: A2(
				$elm$core$Dict$map,
				$elm$core$Basics$always($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$ThunkExpr),
				vars)
		};
		return A2(
			$elm$core$Result$andThen,
			$author$project$Model$BuildPlanner$BuildExprEditor$Simplifier$toFields,
			A2($author$project$Pipeline$run, pipeline, initCtx).b);
	} else {
		return $elm$core$Result$Err(
			$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$BuildExprEvalErr('Build expression must be a \'let\' at top-level'));
	}
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$fromBuildExpr = A2(
	$elm$core$Basics$composeR,
	$author$project$Model$BuildPlanner$BuildExprEditor$Simplifier$run,
	$elm$core$Result$map($author$project$Model$Editor$init));
var $author$project$Model$BuildPlanner$BuildExpr$BuildFlagsDict$init = $elm$core$Dict$empty;
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$init = function (timestamp) {
	return {
		Ec: A2(
			$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$MarkersStateToolArtifacts,
			0,
			{xs: $author$project$Model$BuildPlanner$BuildExpr$BuildFlagsDict$init}),
		E2: $elm$core$Dict$empty,
		sr: $author$project$Model$BuildPlanner$BuildExpr$SolveEditor$init(timestamp)
	};
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$fromBuildExprWithFallback = function (buildExpr) {
	var _v0 = $author$project$Model$BuildPlanner$BuildExprEditor$Simple$fromBuildExpr(buildExpr);
	if (!_v0.$) {
		var editor = _v0.a;
		return editor;
	} else {
		return $author$project$Model$Editor$init(
			$author$project$Model$BuildPlanner$BuildExprEditor$Simple$init($elm$core$Maybe$Nothing));
	}
};
var $author$project$Request$ProjectOverview$Response = F4(
	function (org, project, branches, mainBranch) {
		return {fZ: branches, o_: mainBranch, pd: org, c5: project};
	});
var $dillonkearns$elm_graphql$Graphql$SelectionSet$map2 = F3(
	function (combine, _v0, _v1) {
		var selectionFields1 = _v0.a;
		var selectionDecoder1 = _v0.b;
		var selectionFields2 = _v1.a;
		var selectionDecoder2 = _v1.b;
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			_Utils_ap(selectionFields1, selectionFields2),
			A3($elm$json$Json$Decode$map2, combine, selectionDecoder1, selectionDecoder2));
	});
var $dillonkearns$elm_graphql$Graphql$SelectionSet$foldl = F3(
	function (mapFn, initialValue, selections) {
		return A3(
			$elm$core$List$foldl,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$map2(mapFn),
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(initialValue),
			selections);
	});
var $author$project$Model$BuildPlanner$BuildExpr$BuildExprBool = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$BuildPlanner$BuildExpr$BuildExprFloat = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$BuildPlanner$BuildExpr$BuildExprNil = {$: 0};
var $author$project$Model$BuildPlanner$BuildExpr$App$decode = function (decodeValue) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (nameAndArgs) {
			if (nameAndArgs.b && (!nameAndArgs.b.b)) {
				var _v1 = nameAndArgs.a;
				var name = _v1.a;
				var args = _v1.b;
				return $elm$json$Json$Decode$succeed(
					{
						kO: $elm$core$Dict$fromList(args),
						w: name
					});
			} else {
				return $elm$json$Json$Decode$fail('App: must look like: { \'name\':{ \'arg1\':<expr1>, ... } }');
			}
		},
		$elm$json$Json$Decode$keyValuePairs(
			$elm$json$Json$Decode$keyValuePairs(decodeValue)));
};
var $author$project$Model$BuildPlanner$BuildExpr$Let$decode = function (decodeValue) {
	return A2(
		$elm$json$Json$Decode$field,
		'let',
		A2(
			$elm$json$Json$Decode$andThen,
			function (allVarsList) {
				var allVars = $elm$core$Dict$fromList(allVarsList);
				var _v0 = A2($elm$core$Dict$get, 'in', allVars);
				if (_v0.$ === 1) {
					return $elm$json$Json$Decode$fail('Let: Missing field \'in\'');
				} else {
					var body = _v0.a;
					return $elm$json$Json$Decode$succeed(
						{
							sY: body,
							w0: A2($elm$core$Dict$remove, 'in', allVars)
						});
				}
			},
			$elm$json$Json$Decode$keyValuePairs(decodeValue)));
};
var $author$project$Model$BuildPlanner$BuildExpr$Var$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		return A2($elm$core$String$startsWith, '$', str) ? $elm$json$Json$Decode$succeed(
			A2($elm$core$String$dropLeft, 1, str)) : $elm$json$Json$Decode$fail('Invalid var: must start with \'$\': ' + str);
	},
	$elm$json$Json$Decode$string);
function $author$project$Model$BuildPlanner$BuildExpr$cyclic$decode() {
	var rec = $elm$json$Json$Decode$lazy(
		function (_v0) {
			return $author$project$Model$BuildPlanner$BuildExpr$cyclic$decode();
		});
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($author$project$Model$BuildPlanner$BuildExpr$BuildExprNil),
				A2($elm$json$Json$Decode$map, $author$project$Model$BuildPlanner$BuildExpr$BuildExprBool, $elm$json$Json$Decode$bool),
				A2($elm$json$Json$Decode$map, $author$project$Model$BuildPlanner$BuildExpr$BuildExprInt, $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$map, $author$project$Model$BuildPlanner$BuildExpr$BuildExprFloat, $elm$json$Json$Decode$float),
				A2($elm$json$Json$Decode$map, $author$project$Model$BuildPlanner$BuildExpr$BuildExprVar, $author$project$Model$BuildPlanner$BuildExpr$Var$decode),
				A2($elm$json$Json$Decode$map, $author$project$Model$BuildPlanner$BuildExpr$BuildExprString, $elm$json$Json$Decode$string),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Model$BuildPlanner$BuildExpr$BuildExprList,
				$elm$json$Json$Decode$list(rec)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Model$BuildPlanner$BuildExpr$BuildExprLet,
				$author$project$Model$BuildPlanner$BuildExpr$Let$decode(rec)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Model$BuildPlanner$BuildExpr$BuildExprApp,
				$author$project$Model$BuildPlanner$BuildExpr$App$decode(rec))
			]));
}
var $author$project$Model$BuildPlanner$BuildExpr$decode = $author$project$Model$BuildPlanner$BuildExpr$cyclic$decode();
$author$project$Model$BuildPlanner$BuildExpr$cyclic$decode = function () {
	return $author$project$Model$BuildPlanner$BuildExpr$decode;
};
var $author$project$BuildPlanner$Object$Commit$expr = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe BuildPlannerScalarCodecs.BuildExpr)',
	'expr',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).k8.qN));
var $elm$core$Result$fromMaybe = F2(
	function (err, maybe) {
		if (!maybe.$) {
			var v = maybe.a;
			return $elm$core$Result$Ok(v);
		} else {
			return $elm$core$Result$Err(err);
		}
	});
var $author$project$BuildPlannerScalarCodecs$selectionSetJson = function (decoder) {
	return A2(
		$elm$core$Basics$composeR,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map(
			$elm$json$Json$Decode$decodeValue(decoder)),
		$dillonkearns$elm_graphql$Graphql$SelectionSet$mapOrFail(
			$elm$core$Result$mapError($elm$json$Json$Decode$errorToString)));
};
var $author$project$Model$BuildPlanner$BuildExpr$selectionSet = A2(
	$author$project$BuildPlannerScalarCodecs$selectionSetJson,
	$author$project$Model$BuildPlanner$BuildExpr$decode,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$mapOrFail,
		$elm$core$Result$fromMaybe('Build-planner returned a null build expr (most likely caused by an internal server error)'),
		$author$project$BuildPlanner$Object$Commit$expr));
var $author$project$Request$BuildPlanner$getBuildExprs = F2(
	function (session, response) {
		var selectionSetOne = function (commitID) {
			var commitIdStr = $danyx23$elm_uuid$Uuid$toString(commitID);
			return A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
				$elm$core$Tuple$pair(commitID),
				A2(
					$author$project$BuildPlanner$Object$Project$commit,
					function (opts) {
						return _Utils_update(
							opts,
							{
								nL: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(commitIdStr)
							});
					},
					$author$project$BuildPlanner$Union$CommitResult$fragments(
						{
							u7: $author$project$Model$BuildPlanner$BuildExpr$selectionSet,
							vp: $author$project$BuildPlannerScalarCodecs$selectionSetFail('Commit not found: ' + commitIdStr)
						})));
		};
		var selectionSetMany = A3(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$map2,
			A2($author$project$Request$ProjectOverview$Response, response.pd, response.c5),
			A3(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$foldl,
				$elm_community$basics_extra$Basics$Extra$uncurry($elm$core$Dict$insert),
				$elm$core$Dict$empty,
				A2(
					$elm$core$List$map,
					function (_v0) {
						var branchName = _v0.a;
						var commitID = _v0.b;
						return A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
							$elm$core$Tuple$pair(branchName),
							selectionSetOne(commitID));
					},
					$elm$core$Dict$toList(response.fZ))),
			selectionSetOne(response.o_));
		var projectName = $author$project$Model$Project$getName(response.c5);
		var orgName = $author$project$Model$Organization$getUrlName(response.pd);
		var creds = $author$project$Model$Session$getCreds(session);
		return A5(
			$author$project$GraphQL$Utils$queryRequest,
			creds,
			4,
			_List_Nil,
			'GetBuildExprs',
			A2(
				$author$project$BuildPlanner$Query$project,
				{c3: orgName, c5: projectName},
				$author$project$BuildPlanner$Union$ProjectResult$fragments(
					{
						vp: $author$project$BuildPlannerScalarCodecs$selectionSetFail('Project not found: ' + (orgName + (' / ' + projectName))),
						vt: selectionSetMany
					})));
	});
var $author$project$Model$Project$getDefaultBranch = function (_v0) {
	var project = _v0;
	return project.tA;
};
var $author$project$Model$Project$getIsPrivate = function (_v0) {
	var project = _v0;
	return project.cd;
};
var $author$project$Model$Session$getPlatform = function (_v0) {
	var session = _v0;
	return session.qX.po;
};
var $author$project$Model$Platform$AIX = 4;
var $author$project$Model$Platform$HPUX = 3;
var $author$project$Model$Platform$Solaris = 5;
var $author$project$Model$Platform$getPlatformType = function (_v0) {
	var platform = _v0;
	return ((platform.ml === 'Windows') || (platform.ha === 'Windows')) ? 0 : ((platform.ml === 'Linux') ? 1 : (((platform.ml === 'Darwin') || (platform.ha === 'macOS')) ? 2 : ((platform.ha === 'HP-UX') ? 3 : ((platform.ha === 'AIX') ? 4 : ((platform.ha === 'Solaris') ? 5 : 1)))));
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$fromBuildExpr = $author$project$Model$BuildPlanner$BuildExprEditor$Simple$fromBuildExpr;
var $author$project$Model$BuildPlanner$SolveLegacyEditor$getUnsupportedReason = function (buildExpr) {
	var _v0 = $author$project$Model$BuildPlanner$SolveLegacyEditor$fromBuildExpr(buildExpr);
	if (!_v0.$) {
		return $elm$core$Maybe$Nothing;
	} else {
		var err = _v0.a;
		return $elm$core$Maybe$Just(err);
	}
};
var $author$project$Misc$getWithFallback = F2(
	function (element, list) {
		return A2($elm$core$List$member, element, list) ? element : A2(
			$elm$core$Maybe$withDefault,
			element,
			$elm$core$List$head(list));
	});
var $author$project$Model$NormsAndVulns$Model = $elm$core$Basics$identity;
var $author$project$Model$NormsAndVulns$init = {mo: $elm$core$Dict$empty, mM: $elm$core$Dict$empty, pw: $elm$core$Dict$empty};
var $krisajenkins$remotedata$RemoteData$Loading = {$: 1};
var $author$project$Model$Project$getBranches = function (_v0) {
	var project = _v0;
	return project.fZ;
};
var $author$project$Model$Branch$getName = function (_v0) {
	var branch = _v0;
	return branch.w;
};
var $elm_community$dict_extra$Dict$Extra$keepOnly = F2(
	function (set, dict) {
		return A3(
			$elm$core$Set$foldl,
			F2(
				function (k, acc) {
					return A2(
						$elm$core$Maybe$withDefault,
						acc,
						A2(
							$elm$core$Maybe$map,
							function (v) {
								return A3($elm$core$Dict$insert, k, v, acc);
							},
							A2($elm$core$Dict$get, k, dict)));
				}),
			$elm$core$Dict$empty,
			set);
	});
var $author$project$Views$BranchDownloadsView$init = F6(
	function (session, org, project, allPlatforms, mainBranchEditor, editors) {
		var toBuildData = F2(
			function (_v0, branch) {
				var commitID = _v0.a;
				var editor = _v0.b;
				return {
					h4: branch,
					n6: $krisajenkins$remotedata$RemoteData$Loading,
					BR: commitID,
					qR: editor,
					ff: $elm$core$Dict$empty,
					z$: $elm$core$Dict$values(
						A2(
							$elm_community$dict_extra$Dict$Extra$keepOnly,
							$author$project$Model$BuildPlanner$SolveLegacyEditor$getPlatforms(editor),
							allPlatforms))
				};
			});
		var mainBranchBuildData = A2(
			toBuildData,
			mainBranchEditor,
			$author$project$Model$Project$getDefaultBranch(project));
		var branchNameToBuildData = A2(
			$elm_community$dict_extra$Dict$Extra$filterMap,
			F2(
				function (branchName, editor) {
					return A2(
						$elm$core$Maybe$map,
						toBuildData(editor),
						A2(
							$elm_community$list_extra$List$Extra$find,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Model$Branch$getName,
								$elm$core$Basics$eq(branchName)),
							$author$project$Model$Project$getBranches(project)));
				}),
			editors);
		return {
			qq: branchNameToBuildData,
			oi: $author$project$Model$CopyStatus$empty,
			hA: mainBranchBuildData,
			c3: org,
			c5: project,
			wN: $elm$core$Maybe$Nothing,
			gS: $author$project$Model$Session$getUser(session)
		};
	});
var $elm_community$maybe_extra$Maybe$Extra$isNothing = function (m) {
	if (m.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $krisajenkins$remotedata$RemoteData$NotAsked = {$: 0};
var $author$project$Views$CVESummary$new = {qM: $elm$core$Maybe$Nothing, ng: $krisajenkins$remotedata$RemoteData$NotAsked};
var $elm$url$Url$Builder$absolute = F2(
	function (pathSegments, parameters) {
		return '/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters));
	});
var $author$project$Request$Ingredient$addPosix = F3(
	function (key, maybeValue, queryParams) {
		if (maybeValue.$ === 1) {
			return queryParams;
		} else {
			var value = maybeValue.a;
			return _Utils_ap(
				queryParams,
				_List_fromArray(
					[
						A2(
						$elm$url$Url$Builder$string,
						key,
						$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(value))
					]));
		}
	});
var $author$project$Request$Ingredient$baseUrl = 'sv/inventory-api-v1/v1/';
var $author$project$Model$Platform$Internals = F8(
	function (displayName, platformID, osName, osVersion, kernelName, libcVersion, processor, isUserVisible) {
		return {i$: displayName, uq: isUserVisible, ml: kernelName, rm: libcVersion, ha: osName, rL: osVersion, m0: platformID, r_: processor};
	});
var $author$project$Model$Platform$Platform = $elm$core$Basics$identity;
var $author$project$Model$Platform$Processor = F2(
	function (bitWidth, cpuType) {
		return {kT: bitWidth, oj: cpuType};
	});
var $author$project$Model$Platform$decodeProcessor = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$author$project$Json$Decode$Pipeline$Extra$decodeMaybe,
		'bit_width',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Model$Platform$Processor)));
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt = F4(
	function (path, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				A2($elm$json$Json$Decode$at, path, $elm$json$Json$Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt = F3(
	function (path, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$at, path, valDecoder),
			decoder);
	});
var $author$project$Model$Platform$decode = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'is_user_visible',
		$elm$json$Json$Decode$bool,
		false,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'cpu_architecture',
			$author$project$Model$Platform$decodeProcessor,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
				_List_fromArray(
					['libc_version', 'version']),
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
					_List_fromArray(
						['kernel', 'name']),
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
						_List_fromArray(
							['operating_system_version', 'version']),
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
							_List_fromArray(
								['operating_system', 'name']),
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'platform_id',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'display_name',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Model$Platform$Internals))))))))));
var $elm_community$dict_extra$Dict$Extra$fromListBy = F2(
	function (keyfn, xs) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (x, acc) {
					return A3(
						$elm$core$Dict$insert,
						keyfn(x),
						x,
						acc);
				}),
			$elm$core$Dict$empty,
			xs);
	});
var $author$project$Model$Platform$id = function (_v0) {
	var platform = _v0;
	return platform.m0;
};
var $author$project$Request$Ingredient$platforms = function (maybeAtTime) {
	return A2(
		$elm$core$Task$map,
		$elm_community$dict_extra$Dict$Extra$fromListBy($author$project$Model$Platform$id),
		$author$project$Http$Extra$get(
			{
				iO: $author$project$Http$Extra$None,
				sY: $author$project$Http$Extra$emptyBody,
				qN: A2(
					$elm$json$Json$Decode$field,
					'platforms',
					$elm$json$Json$Decode$list($author$project$Model$Platform$decode)),
				CN: _List_Nil,
				GT: A2(
					$elm$url$Url$Builder$absolute,
					_List_fromArray(
						[$author$project$Request$Ingredient$baseUrl, 'platforms']),
					A3(
						$author$project$Request$Ingredient$addPosix,
						'state_at',
						maybeAtTime,
						_List_fromArray(
							[
								A2($elm$url$Url$Builder$string, 'limit', '10000')
							])))
			}));
};
var $author$project$GraphQL$Utils$Hasura = 0;
var $author$project$GraphQL$Utils$NotFound = 1;
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$list = F2(
	function (toValue, value) {
		return $dillonkearns$elm_graphql$Graphql$Internal$Encode$List(
			A2($elm$core$List$map, toValue, value));
	});
var $author$project$Builder$InputObject$encodeBoolean_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_eq',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aW, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_gt',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aY, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_gte',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aZ, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$bool))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lt',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a0, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lte',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_neq',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a4, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)))
			]));
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$int = function (value) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$Json(
		$elm$json$Json$Encode$int(value));
};
var $author$project$Builder$InputObject$encodeInt_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_eq',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aW, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)),
				_Utils_Tuple2(
				'_gt',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aY, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)),
				_Utils_Tuple2(
				'_gte',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aZ, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$int))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lt',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a0, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)),
				_Utils_Tuple2(
				'_lte',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)),
				_Utils_Tuple2(
				'_neq',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a4, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$int)))
			]));
};
var $author$project$Builder$InputObject$encodeString_array_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_contained_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.le,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string))),
				_Utils_Tuple2(
				'_contains',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.lf,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string))),
				_Utils_Tuple2(
				'_eq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aW,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string))),
				_Utils_Tuple2(
				'_gt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aY,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string))),
				_Utils_Tuple2(
				'_gte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aZ,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string))),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string)))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a0,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string))),
				_Utils_Tuple2(
				'_lte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a1,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string))),
				_Utils_Tuple2(
				'_neq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a4,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string))),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string))))
			]));
};
var $author$project$Builder$InputObject$encodeString_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_eq',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aW, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_gt',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aY, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_gte',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aZ, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_ilike',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.l7, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string))),
				_Utils_Tuple2(
				'_iregex',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mj, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_like',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mt, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_lt',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a0, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_lte',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_neq',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a4, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_nilike',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mI, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string))),
				_Utils_Tuple2(
				'_niregex',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mJ, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_nlike',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mK, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_nregex',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mO, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_nsimilar',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mP, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_regex',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.nd, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_similar',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.nv, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))
			]));
};
var $author$project$Model$BuildPlanner$BuildExpr$Solve$VersionRequirement$VersionRequirement = F2(
	function (comparator, version) {
		return {h: comparator, aI: version};
	});
var $author$project$Model$BuildPlanner$BuildExpr$Solve$VersionRequirement$decodeLegacy = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'version',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'comparator',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Model$BuildPlanner$BuildExpr$Solve$VersionRequirement$VersionRequirement)));
var $author$project$Builder$Scalar$Bigint = $elm$core$Basics$identity;
var $author$project$Builder$Scalar$Bytea = $elm$core$Basics$identity;
var $author$project$Builder$Scalar$Curation_status = $elm$core$Basics$identity;
var $author$project$Builder$Scalar$Date = $elm$core$Basics$identity;
var $author$project$Builder$Scalar$Float8 = $elm$core$Basics$identity;
var $author$project$Builder$Scalar$Jsonb = $elm$core$Basics$identity;
var $author$project$Builder$Scalar$Milestone_status = $elm$core$Basics$identity;
var $author$project$Builder$Scalar$Numeric = $elm$core$Basics$identity;
var $author$project$Builder$Scalar$Timestamp = $elm$core$Basics$identity;
var $author$project$Builder$Scalar$Timestamptz = $elm$core$Basics$identity;
var $author$project$Builder$Scalar$Tracking_type = $elm$core$Basics$identity;
var $author$project$Builder$Scalar$Uuid = $elm$core$Basics$identity;
var $elm$core$String$fromFloat = _String_fromNumber;
var $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			$elm$json$Json$Decode$string,
			A2($elm$json$Json$Decode$map, $elm$core$String$fromFloat, $elm$json$Json$Decode$float),
			A2($elm$json$Json$Decode$map, $elm$core$String$fromInt, $elm$json$Json$Decode$int),
			A2(
			$elm$json$Json$Decode$map,
			function (bool) {
				return bool ? 'true' : 'false';
			},
			$elm$json$Json$Decode$bool)
		]));
var $author$project$Builder$Scalar$defaultCodecs = {
	dk: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v0) {
			var raw = _v0;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	ia: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v1) {
			var raw = _v1;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	g0: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v2) {
			var raw = _v2;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	ic: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v3) {
			var raw = _v3;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	fL: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v4) {
			var raw = _v4;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	g1: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v5) {
			var raw = _v5;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	iV: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v6) {
			var raw = _v6;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	ho: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v7) {
			var raw = _v7;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	bC: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v8) {
			var raw = _v8;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	il: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v9) {
			var raw = _v9;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	im: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v10) {
			var raw = _v10;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	aq: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v11) {
			var raw = _v11;
			return $elm$json$Json$Encode$string(raw);
		}
	}
};
var $author$project$Builder$Scalar$Codecs = $elm$core$Basics$identity;
var $author$project$Builder$Scalar$defineCodecs = function (definitions) {
	return definitions;
};
var $author$project$Model$BuildPlanner$BuildExpr$Solve$VersionRequirement$encodeLegacy = function (_v0) {
	var comparator = _v0.h;
	var version = _v0.aI;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'comparator',
				$elm$json$Json$Encode$string(comparator)),
				_Utils_Tuple2(
				'version',
				$elm$json$Json$Encode$string(version))
			]));
};
var $author$project$CustomScalarCodecs$codecs = $author$project$Builder$Scalar$defineCodecs(
	{
		dk: $author$project$Builder$Scalar$defaultCodecs.dk,
		ia: $author$project$Builder$Scalar$defaultCodecs.ia,
		g0: $author$project$Builder$Scalar$defaultCodecs.g0,
		ic: {qN: $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder, lN: $rtfeldman$elm_iso8601_date_strings$Iso8601$encode},
		fL: $author$project$Builder$Scalar$defaultCodecs.fL,
		g1: {
			qN: $elm$json$Json$Decode$list($author$project$Model$BuildPlanner$BuildExpr$Solve$VersionRequirement$decodeLegacy),
			lN: $elm$json$Json$Encode$list($author$project$Model$BuildPlanner$BuildExpr$Solve$VersionRequirement$encodeLegacy)
		},
		iV: $author$project$Builder$Scalar$defaultCodecs.iV,
		ho: {qN: $elm$json$Json$Decode$float, lN: $elm$json$Json$Encode$float},
		bC: {qN: $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder, lN: $rtfeldman$elm_iso8601_date_strings$Iso8601$encode},
		il: $author$project$Builder$Scalar$defaultCodecs.il,
		im: $author$project$Builder$Scalar$defaultCodecs.im,
		aq: {qN: $danyx23$elm_uuid$Uuid$decoder, lN: $danyx23$elm_uuid$Uuid$encode}
	});
var $author$project$Builder$Scalar$unwrapEncoder = F2(
	function (getter, _v0) {
		var unwrappedCodecs = _v0;
		return A2(
			$elm$core$Basics$composeR,
			getter(unwrappedCodecs).lN,
			$dillonkearns$elm_graphql$Graphql$Internal$Encode$fromJson);
	});
var $author$project$Builder$InputObject$encodeUuid_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_eq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aW,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.aq;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aY,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.aq;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aZ,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.aq;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Builder$Scalar$unwrapEncoder,
							function ($) {
								return $.aq;
							},
							$author$project$CustomScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a0,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.aq;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_lte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a1,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.aq;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_neq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a4,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.aq;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Builder$Scalar$unwrapEncoder,
							function ($) {
								return $.aq;
							},
							$author$project$CustomScalarCodecs$codecs))))
			]));
};
var $author$project$Builder$InputObject$encodeTiers_bool_exp = function (_v0) {
	var input____ = _v0;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Builder$InputObject$encodeTiers_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Builder$InputObject$encodeTiers_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Builder$InputObject$encodeTiers_bool_exp))),
				_Utils_Tuple2(
				'name',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.w, $author$project$Builder$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'tier_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aP, $author$project$Builder$InputObject$encodeUuid_comparison_exp))
			]));
};
var $author$project$Builder$InputObject$encodeTimestamp_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_eq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aW,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.bC;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aY,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.bC;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aZ,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.bC;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Builder$Scalar$unwrapEncoder,
							function ($) {
								return $.bC;
							},
							$author$project$CustomScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a0,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.bC;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_lte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a1,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.bC;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_neq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a4,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.bC;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Builder$Scalar$unwrapEncoder,
							function ($) {
								return $.bC;
							},
							$author$project$CustomScalarCodecs$codecs))))
			]));
};
var $author$project$Builder$InputObject$encodeTracking_type_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_eq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aW,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.im;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aY,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.im;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aZ,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.im;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Builder$Scalar$unwrapEncoder,
							function ($) {
								return $.im;
							},
							$author$project$CustomScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a0,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.im;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_lte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a1,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.im;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_neq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a4,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.im;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Builder$Scalar$unwrapEncoder,
							function ($) {
								return $.im;
							},
							$author$project$CustomScalarCodecs$codecs))))
			]));
};
var $author$project$Builder$InputObject$encodeUuid_array_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_contained_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.le,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Builder$Scalar$unwrapEncoder,
							function ($) {
								return $.aq;
							},
							$author$project$CustomScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_contains',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.lf,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Builder$Scalar$unwrapEncoder,
							function ($) {
								return $.aq;
							},
							$author$project$CustomScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_eq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aW,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Builder$Scalar$unwrapEncoder,
							function ($) {
								return $.aq;
							},
							$author$project$CustomScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_gt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aY,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Builder$Scalar$unwrapEncoder,
							function ($) {
								return $.aq;
							},
							$author$project$CustomScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_gte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aZ,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Builder$Scalar$unwrapEncoder,
							function ($) {
								return $.aq;
							},
							$author$project$CustomScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
							A2(
								$author$project$Builder$Scalar$unwrapEncoder,
								function ($) {
									return $.aq;
								},
								$author$project$CustomScalarCodecs$codecs))))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a0,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Builder$Scalar$unwrapEncoder,
							function ($) {
								return $.aq;
							},
							$author$project$CustomScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_lte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a1,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Builder$Scalar$unwrapEncoder,
							function ($) {
								return $.aq;
							},
							$author$project$CustomScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_neq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a4,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Builder$Scalar$unwrapEncoder,
							function ($) {
								return $.aq;
							},
							$author$project$CustomScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
							A2(
								$author$project$Builder$Scalar$unwrapEncoder,
								function ($) {
									return $.aq;
								},
								$author$project$CustomScalarCodecs$codecs)))))
			]));
};
var $author$project$Builder$InputObject$encodeEmpty_build_exprs_with_child_ids_bool_exp = function (_v0) {
	var input____ = _v0;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Builder$InputObject$encodeEmpty_build_exprs_with_child_ids_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Builder$InputObject$encodeEmpty_build_exprs_with_child_ids_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Builder$InputObject$encodeEmpty_build_exprs_with_child_ids_bool_exp))),
				_Utils_Tuple2(
				'build_expr_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cK, $author$project$Builder$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'children',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aT, $author$project$Builder$InputObject$encodeUuid_array_comparison_exp)),
				_Utils_Tuple2(
				'expr_type',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aX, $author$project$Builder$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'value',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.kH, $author$project$Builder$InputObject$encodeString_comparison_exp))
			]));
};
var $author$project$Builder$InputObject$encodeTimestamptz_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_eq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aW,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.il;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aY,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.il;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aZ,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.il;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Builder$Scalar$unwrapEncoder,
							function ($) {
								return $.il;
							},
							$author$project$CustomScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a0,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.il;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_lte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a1,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.il;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_neq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a4,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.il;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Builder$Scalar$unwrapEncoder,
							function ($) {
								return $.il;
							},
							$author$project$CustomScalarCodecs$codecs))))
			]));
};
var $author$project$Builder$InputObject$encodeBytea_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_eq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aW,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.ia;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aY,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.ia;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aZ,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.ia;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Builder$Scalar$unwrapEncoder,
							function ($) {
								return $.ia;
							},
							$author$project$CustomScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a0,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.ia;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_lte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a1,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.ia;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_neq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a4,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.ia;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Builder$Scalar$unwrapEncoder,
							function ($) {
								return $.ia;
							},
							$author$project$CustomScalarCodecs$codecs))))
			]));
};
var $author$project$Builder$InputObject$encodeUsers_bool_exp = function (_v0) {
	var input____ = _v0;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Builder$InputObject$encodeUsers_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Builder$InputObject$encodeUsers_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Builder$InputObject$encodeUsers_bool_exp))),
				_Utils_Tuple2(
				'added',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ak, $author$project$Builder$InputObject$encodeTimestamp_comparison_exp)),
				_Utils_Tuple2(
				'changed',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.g, $author$project$Builder$InputObject$encodeTimestamp_comparison_exp)),
				_Utils_Tuple2(
				'datetime_format',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dQ, $author$project$Builder$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'deleted',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.z, $author$project$Builder$InputObject$encodeTimestamp_comparison_exp)),
				_Utils_Tuple2(
				'eula_accepted',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dW, $author$project$Builder$InputObject$encodeTimestamp_comparison_exp)),
				_Utils_Tuple2(
				'lastlogin',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ep, $author$project$Builder$InputObject$encodeTimestamp_comparison_exp)),
				_Utils_Tuple2(
				'name',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.w, $author$project$Builder$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'password',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ey, $author$project$Builder$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'send_marketing_communication',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.eJ, $author$project$Builder$InputObject$encodeBoolean_comparison_exp)),
				_Utils_Tuple2(
				'timezone',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.eR, $author$project$Builder$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'totp_data',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.eU, $author$project$Builder$InputObject$encodeBytea_comparison_exp)),
				_Utils_Tuple2(
				'totp_enabled',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.eV, $author$project$Builder$InputObject$encodeBoolean_comparison_exp)),
				_Utils_Tuple2(
				'user_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aH, $author$project$Builder$InputObject$encodeUuid_comparison_exp))
			]));
};
var $author$project$Builder$InputObject$encodeJsonb_cast_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'String',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.nA, $author$project$Builder$InputObject$encodeString_comparison_exp))
			]));
};
var $author$project$Builder$InputObject$encodeJsonb_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_cast',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.k6, $author$project$Builder$InputObject$encodeJsonb_cast_exp)),
				_Utils_Tuple2(
				'_contained_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.le,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.g1;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_contains',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.lf,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.g1;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_eq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aW,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.g1;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aY,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.g1;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aZ,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.g1;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_has_key',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.l0, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_has_keys_all',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.l1,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string))),
				_Utils_Tuple2(
				'_has_keys_any',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.l2,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string))),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Builder$Scalar$unwrapEncoder,
							function ($) {
								return $.g1;
							},
							$author$project$CustomScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a0,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.g1;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_lte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a1,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.g1;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_neq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a4,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.g1;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Builder$Scalar$unwrapEncoder,
							function ($) {
								return $.g1;
							},
							$author$project$CustomScalarCodecs$codecs))))
			]));
};
var $author$project$Builder$InputObject$encodeVcs_checkpoints_bool_exp = function (_v0) {
	var input____ = _v0;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Builder$InputObject$encodeVcs_checkpoints_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Builder$InputObject$encodeVcs_checkpoints_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Builder$InputObject$encodeVcs_checkpoints_bool_exp))),
				_Utils_Tuple2(
				'commit_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.P, $author$project$Builder$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'constraint_json',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dG, $author$project$Builder$InputObject$encodeJsonb_comparison_exp)),
				_Utils_Tuple2(
				'namespace',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aE, $author$project$Builder$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'requirement',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ci, $author$project$Builder$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'version_constraint',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cv, $author$project$Builder$InputObject$encodeString_comparison_exp))
			]));
};
var $author$project$Builder$InputObject$encodeVcs_commits_bool_exp = function (_v0) {
	var input____ = _v0;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Builder$InputObject$encodeVcs_commits_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Builder$InputObject$encodeVcs_commits_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Builder$InputObject$encodeVcs_commits_bool_exp))),
				_Utils_Tuple2(
				'added',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ak, $author$project$Builder$InputObject$encodeTimestamp_comparison_exp)),
				_Utils_Tuple2(
				'at_time',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dB, $author$project$Builder$InputObject$encodeTimestamptz_comparison_exp)),
				_Utils_Tuple2(
				'build_expr',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.k1, $author$project$Builder$InputObject$encodeEmpty_build_exprs_with_child_ids_bool_exp)),
				_Utils_Tuple2(
				'commit_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.P, $author$project$Builder$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'message',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Eh, $author$project$Builder$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'previous_commit_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.eC, $author$project$Builder$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'requirements',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.FF, $author$project$Builder$InputObject$encodeVcs_checkpoints_bool_exp)),
				_Utils_Tuple2(
				'user',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gS, $author$project$Builder$InputObject$encodeUsers_bool_exp)),
				_Utils_Tuple2(
				'user_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aH, $author$project$Builder$InputObject$encodeUuid_comparison_exp))
			]));
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$EnumValue = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_graphql$Graphql$Internal$Encode$enum = F2(
	function (enumToString, value) {
		return $dillonkearns$elm_graphql$Graphql$Internal$Encode$EnumValue(
			enumToString(value));
	});
var $author$project$Builder$Enum$Vcs_branches_select_column$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'added';
		case 1:
			return 'branch_id';
		case 2:
			return 'changed';
		case 3:
			return 'commit_id';
		case 4:
			return 'label';
		case 5:
			return 'main';
		case 6:
			return 'project_id';
		case 7:
			return 'tracking_type';
		case 8:
			return 'tracks';
		default:
			return 'upstream_commit_id';
	}
};
var $author$project$Builder$Enum$Vcs_branches_select_column_vcs_branches_aggregate_bool_exp_bool_and_arguments_columns$toString = function (enum____) {
	return 'main';
};
var $author$project$Builder$Enum$Vcs_branches_select_column_vcs_branches_aggregate_bool_exp_bool_or_arguments_columns$toString = function (enum____) {
	return 'main';
};
var $author$project$Builder$Enum$Vcs_tags_select_column$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'changed';
		case 1:
			return 'commit_id';
		case 2:
			return 'label';
		case 3:
			return 'project_id';
		default:
			return 'tag_id';
	}
};
var $author$project$Builder$InputObject$encodeOrganizations_bool_exp = function (_v9) {
	var input____ = _v9;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Builder$InputObject$encodeOrganizations_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Builder$InputObject$encodeOrganizations_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Builder$InputObject$encodeOrganizations_bool_exp))),
				_Utils_Tuple2(
				'add_ons',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.fV, $author$project$Builder$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'added',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ak, $author$project$Builder$InputObject$encodeTimestamp_comparison_exp)),
				_Utils_Tuple2(
				'changed',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.g, $author$project$Builder$InputObject$encodeTimestamp_comparison_exp)),
				_Utils_Tuple2(
				'deleted',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.z, $author$project$Builder$InputObject$encodeTimestamp_comparison_exp)),
				_Utils_Tuple2(
				'display_name',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bt, $author$project$Builder$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'organization_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.E, $author$project$Builder$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'projects',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gx, $author$project$Builder$InputObject$encodeProjects_bool_exp)),
				_Utils_Tuple2(
				'tier',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dc, $author$project$Builder$InputObject$encodeTiers_bool_exp)),
				_Utils_Tuple2(
				'tier_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aP, $author$project$Builder$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'url_name',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ct, $author$project$Builder$InputObject$encodeString_comparison_exp))
			]));
};
var $author$project$Builder$InputObject$encodeProjects_bool_exp = function (_v8) {
	var input____ = _v8;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Builder$InputObject$encodeProjects_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Builder$InputObject$encodeProjects_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Builder$InputObject$encodeProjects_bool_exp))),
				_Utils_Tuple2(
				'added',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ak, $author$project$Builder$InputObject$encodeTimestamp_comparison_exp)),
				_Utils_Tuple2(
				'branches',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.fZ, $author$project$Builder$InputObject$encodeVcs_branches_bool_exp)),
				_Utils_Tuple2(
				'branches_aggregate',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cJ, $author$project$Builder$InputObject$encodeVcs_branches_aggregate_bool_exp)),
				_Utils_Tuple2(
				'changed',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.g, $author$project$Builder$InputObject$encodeTimestamp_comparison_exp)),
				_Utils_Tuple2(
				'created_by',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aJ, $author$project$Builder$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'deleted',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.z, $author$project$Builder$InputObject$encodeTimestamp_comparison_exp)),
				_Utils_Tuple2(
				'description',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bP, $author$project$Builder$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'distribution_only',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dT, $author$project$Builder$InputObject$encodeBoolean_comparison_exp)),
				_Utils_Tuple2(
				'forked_from',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aL, $author$project$Builder$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'forked_project',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gd, $author$project$Builder$InputObject$encodeProjects_bool_exp)),
				_Utils_Tuple2(
				'languages',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aM, $author$project$Builder$InputObject$encodeString_array_comparison_exp)),
				_Utils_Tuple2(
				'managed',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b4, $author$project$Builder$InputObject$encodeBoolean_comparison_exp)),
				_Utils_Tuple2(
				'name',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.w, $author$project$Builder$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'organization',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c3, $author$project$Builder$InputObject$encodeOrganizations_bool_exp)),
				_Utils_Tuple2(
				'organization_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.E, $author$project$Builder$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'platforms',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Fh, $author$project$Builder$InputObject$encodeString_array_comparison_exp)),
				_Utils_Tuple2(
				'private',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cd, $author$project$Builder$InputObject$encodeBoolean_comparison_exp)),
				_Utils_Tuple2(
				'project_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.s, $author$project$Builder$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'repo_url',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aN, $author$project$Builder$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'tags',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Gt, $author$project$Builder$InputObject$encodeVcs_tags_bool_exp)),
				_Utils_Tuple2(
				'tags_aggregate',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.da, $author$project$Builder$InputObject$encodeVcs_tags_aggregate_bool_exp))
			]));
};
var $author$project$Builder$InputObject$encodeVcs_branches_aggregate_bool_exp = function (_v7) {
	var input____ = _v7;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'bool_and',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.kU, $author$project$Builder$InputObject$encodeVcs_branches_aggregate_bool_exp_bool_and)),
				_Utils_Tuple2(
				'bool_or',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.kV, $author$project$Builder$InputObject$encodeVcs_branches_aggregate_bool_exp_bool_or)),
				_Utils_Tuple2(
				'count',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cO, $author$project$Builder$InputObject$encodeVcs_branches_aggregate_bool_exp_count))
			]));
};
var $author$project$Builder$InputObject$encodeVcs_branches_aggregate_bool_exp_bool_and = function (_v6) {
	var input____ = _v6;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'arguments',
				$elm$core$Maybe$Just(
					A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Builder$Enum$Vcs_branches_select_column_vcs_branches_aggregate_bool_exp_bool_and_arguments_columns$toString, input____.di))),
				_Utils_Tuple2(
				'distinct',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cR, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'filter',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cT, $author$project$Builder$InputObject$encodeVcs_branches_bool_exp)),
				_Utils_Tuple2(
				'predicate',
				$elm$core$Maybe$Just(
					$author$project$Builder$InputObject$encodeBoolean_comparison_exp(input____.dq)))
			]));
};
var $author$project$Builder$InputObject$encodeVcs_branches_aggregate_bool_exp_bool_or = function (_v5) {
	var input____ = _v5;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'arguments',
				$elm$core$Maybe$Just(
					A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Builder$Enum$Vcs_branches_select_column_vcs_branches_aggregate_bool_exp_bool_or_arguments_columns$toString, input____.di))),
				_Utils_Tuple2(
				'distinct',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cR, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'filter',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cT, $author$project$Builder$InputObject$encodeVcs_branches_bool_exp)),
				_Utils_Tuple2(
				'predicate',
				$elm$core$Maybe$Just(
					$author$project$Builder$InputObject$encodeBoolean_comparison_exp(input____.dq)))
			]));
};
var $author$project$Builder$InputObject$encodeVcs_branches_aggregate_bool_exp_count = function (_v4) {
	var input____ = _v4;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'arguments',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.di,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Vcs_branches_select_column$toString)))),
				_Utils_Tuple2(
				'distinct',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cR, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'filter',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cT, $author$project$Builder$InputObject$encodeVcs_branches_bool_exp)),
				_Utils_Tuple2(
				'predicate',
				$elm$core$Maybe$Just(
					$author$project$Builder$InputObject$encodeInt_comparison_exp(input____.dq)))
			]));
};
var $author$project$Builder$InputObject$encodeVcs_branches_bool_exp = function (_v3) {
	var input____ = _v3;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Builder$InputObject$encodeVcs_branches_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Builder$InputObject$encodeVcs_branches_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Builder$InputObject$encodeVcs_branches_bool_exp))),
				_Utils_Tuple2(
				'added',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ak, $author$project$Builder$InputObject$encodeTimestamp_comparison_exp)),
				_Utils_Tuple2(
				'branch_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.t, $author$project$Builder$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'changed',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.g, $author$project$Builder$InputObject$encodeTimestamp_comparison_exp)),
				_Utils_Tuple2(
				'commit',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cM, $author$project$Builder$InputObject$encodeVcs_commits_bool_exp)),
				_Utils_Tuple2(
				'commit_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.P, $author$project$Builder$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'label',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b2, $author$project$Builder$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'main',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.eu, $author$project$Builder$InputObject$encodeBoolean_comparison_exp)),
				_Utils_Tuple2(
				'project',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c5, $author$project$Builder$InputObject$encodeProjects_bool_exp)),
				_Utils_Tuple2(
				'project_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.s, $author$project$Builder$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'tracking_branch',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gQ, $author$project$Builder$InputObject$encodeVcs_branches_bool_exp)),
				_Utils_Tuple2(
				'tracking_type',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cp, $author$project$Builder$InputObject$encodeTracking_type_comparison_exp)),
				_Utils_Tuple2(
				'tracks',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cq, $author$project$Builder$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'upstream_commit_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cs, $author$project$Builder$InputObject$encodeUuid_comparison_exp))
			]));
};
var $author$project$Builder$InputObject$encodeVcs_tags_aggregate_bool_exp = function (_v2) {
	var input____ = _v2;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'count',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cO, $author$project$Builder$InputObject$encodeVcs_tags_aggregate_bool_exp_count))
			]));
};
var $author$project$Builder$InputObject$encodeVcs_tags_aggregate_bool_exp_count = function (_v1) {
	var input____ = _v1;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'arguments',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.di,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Vcs_tags_select_column$toString)))),
				_Utils_Tuple2(
				'distinct',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cR, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'filter',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cT, $author$project$Builder$InputObject$encodeVcs_tags_bool_exp)),
				_Utils_Tuple2(
				'predicate',
				$elm$core$Maybe$Just(
					$author$project$Builder$InputObject$encodeInt_comparison_exp(input____.dq)))
			]));
};
var $author$project$Builder$InputObject$encodeVcs_tags_bool_exp = function (_v0) {
	var input____ = _v0;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Builder$InputObject$encodeVcs_tags_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Builder$InputObject$encodeVcs_tags_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Builder$InputObject$encodeVcs_tags_bool_exp))),
				_Utils_Tuple2(
				'changed',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.g, $author$project$Builder$InputObject$encodeTimestamp_comparison_exp)),
				_Utils_Tuple2(
				'commit',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cM, $author$project$Builder$InputObject$encodeVcs_commits_bool_exp)),
				_Utils_Tuple2(
				'commit_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.P, $author$project$Builder$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'label',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b2, $author$project$Builder$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'project',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c5, $author$project$Builder$InputObject$encodeProjects_bool_exp)),
				_Utils_Tuple2(
				'project_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.s, $author$project$Builder$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'tag_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.co, $author$project$Builder$InputObject$encodeUuid_comparison_exp))
			]));
};
var $author$project$Builder$Enum$Order_by$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'asc';
		case 1:
			return 'asc_nulls_first';
		case 2:
			return 'asc_nulls_last';
		case 3:
			return 'desc';
		case 4:
			return 'desc_nulls_first';
		default:
			return 'desc_nulls_last';
	}
};
var $author$project$Builder$InputObject$encodeProjects_max_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'added',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ak,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'changed',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.g,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'created_by',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aJ,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'deleted',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.z,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'description',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bP,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'forked_from',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aL,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'languages',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aM,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'name',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.w,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'organization_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.E,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'platforms',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.Fh,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'project_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.s,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'repo_url',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aN,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString)))
			]));
};
var $author$project$Builder$InputObject$encodeProjects_min_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'added',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ak,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'changed',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.g,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'created_by',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aJ,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'deleted',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.z,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'description',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bP,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'forked_from',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aL,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'languages',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aM,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'name',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.w,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'organization_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.E,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'platforms',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.Fh,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'project_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.s,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'repo_url',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aN,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString)))
			]));
};
var $author$project$Builder$InputObject$encodeProjects_aggregate_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'count',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cO,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'max',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c1, $author$project$Builder$InputObject$encodeProjects_max_order_by)),
				_Utils_Tuple2(
				'min',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c2, $author$project$Builder$InputObject$encodeProjects_min_order_by))
			]));
};
var $author$project$Builder$InputObject$encodeTiers_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.w,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'tier_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aP,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString)))
			]));
};
var $author$project$Builder$InputObject$encodeOrganizations_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'add_ons',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.fV,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'added',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ak,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'changed',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.g,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'deleted',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.z,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'display_name',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bt,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'organization_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.E,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'projects_aggregate',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gy, $author$project$Builder$InputObject$encodeProjects_aggregate_order_by)),
				_Utils_Tuple2(
				'tier',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dc, $author$project$Builder$InputObject$encodeTiers_order_by)),
				_Utils_Tuple2(
				'tier_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aP,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'url_name',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ct,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString)))
			]));
};
var $author$project$Builder$InputObject$encodeVcs_branches_max_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'added',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ak,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'branch_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.t,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'changed',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.g,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'commit_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.P,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'label',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b2,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'project_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.s,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'tracking_type',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cp,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'tracks',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cq,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'upstream_commit_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cs,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString)))
			]));
};
var $author$project$Builder$InputObject$encodeVcs_branches_min_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'added',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ak,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'branch_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.t,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'changed',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.g,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'commit_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.P,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'label',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b2,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'project_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.s,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'tracking_type',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cp,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'tracks',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cq,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'upstream_commit_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cs,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString)))
			]));
};
var $author$project$Builder$InputObject$encodeVcs_branches_aggregate_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'count',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cO,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'max',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c1, $author$project$Builder$InputObject$encodeVcs_branches_max_order_by)),
				_Utils_Tuple2(
				'min',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c2, $author$project$Builder$InputObject$encodeVcs_branches_min_order_by))
			]));
};
var $author$project$Builder$InputObject$encodeVcs_tags_max_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'changed',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.g,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'commit_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.P,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'label',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b2,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'project_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.s,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'tag_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.co,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString)))
			]));
};
var $author$project$Builder$InputObject$encodeVcs_tags_min_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'changed',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.g,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'commit_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.P,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'label',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b2,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'project_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.s,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'tag_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.co,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString)))
			]));
};
var $author$project$Builder$InputObject$encodeVcs_tags_aggregate_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'count',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cO,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'max',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c1, $author$project$Builder$InputObject$encodeVcs_tags_max_order_by)),
				_Utils_Tuple2(
				'min',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c2, $author$project$Builder$InputObject$encodeVcs_tags_min_order_by))
			]));
};
var $author$project$Builder$InputObject$encodeProjects_order_by = function (_v0) {
	var input____ = _v0;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'added',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ak,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'branches_aggregate',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cJ, $author$project$Builder$InputObject$encodeVcs_branches_aggregate_order_by)),
				_Utils_Tuple2(
				'changed',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.g,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'created_by',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aJ,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'deleted',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.z,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'description',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bP,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'distribution_only',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.dT,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'forked_from',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aL,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'forked_project',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gd, $author$project$Builder$InputObject$encodeProjects_order_by)),
				_Utils_Tuple2(
				'languages',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aM,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'managed',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b4,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'name',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.w,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'organization',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c3, $author$project$Builder$InputObject$encodeOrganizations_order_by)),
				_Utils_Tuple2(
				'organization_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.E,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'platforms',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.Fh,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'private',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cd,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'project_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.s,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'repo_url',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aN,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'tags_aggregate',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.da, $author$project$Builder$InputObject$encodeVcs_tags_aggregate_order_by))
			]));
};
var $author$project$Builder$InputObject$encodeEmpty_build_exprs_with_child_ids_max_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'build_expr_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cK,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'children',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aT,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'expr_type',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aX,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'value',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.kH,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString)))
			]));
};
var $author$project$Builder$InputObject$encodeEmpty_build_exprs_with_child_ids_min_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'build_expr_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cK,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'children',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aT,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'expr_type',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aX,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'value',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.kH,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString)))
			]));
};
var $author$project$Builder$InputObject$encodeEmpty_build_exprs_with_child_ids_aggregate_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'count',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cO,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'max',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c1, $author$project$Builder$InputObject$encodeEmpty_build_exprs_with_child_ids_max_order_by)),
				_Utils_Tuple2(
				'min',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c2, $author$project$Builder$InputObject$encodeEmpty_build_exprs_with_child_ids_min_order_by))
			]));
};
var $author$project$Builder$InputObject$encodeUsers_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'added',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ak,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'changed',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.g,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'datetime_format',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.dQ,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'deleted',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.z,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'eula_accepted',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.dW,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'lastlogin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ep,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'name',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.w,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'password',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ey,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'send_marketing_communication',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.eJ,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'timezone',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.eR,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'totp_data',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.eU,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'totp_enabled',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.eV,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'user_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aH,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString)))
			]));
};
var $author$project$Builder$InputObject$encodeVcs_checkpoints_max_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'commit_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.P,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'namespace',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'requirement',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ci,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'version_constraint',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cv,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString)))
			]));
};
var $author$project$Builder$InputObject$encodeVcs_checkpoints_min_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'commit_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.P,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'namespace',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'requirement',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ci,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'version_constraint',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cv,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString)))
			]));
};
var $author$project$Builder$InputObject$encodeVcs_checkpoints_aggregate_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'count',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cO,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'max',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c1, $author$project$Builder$InputObject$encodeVcs_checkpoints_max_order_by)),
				_Utils_Tuple2(
				'min',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c2, $author$project$Builder$InputObject$encodeVcs_checkpoints_min_order_by))
			]));
};
var $author$project$Builder$InputObject$encodeVcs_commits_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'added',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ak,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'at_time',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.dB,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'build_expr_aggregate',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.k2, $author$project$Builder$InputObject$encodeEmpty_build_exprs_with_child_ids_aggregate_order_by)),
				_Utils_Tuple2(
				'commit_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.P,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'message',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.Eh,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'previous_commit_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.eC,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'requirements_aggregate',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ni, $author$project$Builder$InputObject$encodeVcs_checkpoints_aggregate_order_by)),
				_Utils_Tuple2(
				'user',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gS, $author$project$Builder$InputObject$encodeUsers_order_by)),
				_Utils_Tuple2(
				'user_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aH,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString)))
			]));
};
var $author$project$Builder$InputObject$encodeVcs_branches_order_by = function (_v0) {
	var input____ = _v0;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'added',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ak,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'branch_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.t,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'changed',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.g,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'commit',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cM, $author$project$Builder$InputObject$encodeVcs_commits_order_by)),
				_Utils_Tuple2(
				'commit_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.P,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'label',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b2,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'main',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.eu,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'project',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c5, $author$project$Builder$InputObject$encodeProjects_order_by)),
				_Utils_Tuple2(
				'project_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.s,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'tracking_branch',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gQ, $author$project$Builder$InputObject$encodeVcs_branches_order_by)),
				_Utils_Tuple2(
				'tracking_type',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cp,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'tracks',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cq,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'upstream_commit_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cs,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString)))
			]));
};
var $author$project$Builder$Object$Projects$branches = F2(
	function (fillInOptionals____, object____) {
		var filledInOptionals____ = fillInOptionals____(
			{tE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ux: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, uR: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, vE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ao: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs____ = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'distinct_on',
					filledInOptionals____.tE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Vcs_branches_select_column$toString))),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'limit', filledInOptionals____.ux, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'offset', filledInOptionals____.uR, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'order_by',
					filledInOptionals____.vE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Builder$InputObject$encodeVcs_branches_order_by)),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'where', filledInOptionals____.ao, $author$project$Builder$InputObject$encodeVcs_branches_bool_exp)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'branches',
			optionalArgs____,
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
	});
var $author$project$Request$ProjectOverview$MiniBranch = F3(
	function (label, commitID, isMain) {
		return {BR: commitID, yM: isMain, b2: label};
	});
var $author$project$Builder$Object$Vcs_branches$commit = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'commit',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Builder$Scalar$unwrapCodecs = function (_v0) {
	var unwrappedCodecs = _v0;
	return unwrappedCodecs;
};
var $author$project$Builder$Object$Vcs_commits$commit_id = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'CustomScalarCodecs.Uuid',
	'commit_id',
	_List_Nil,
	$author$project$Builder$Scalar$unwrapCodecs($author$project$CustomScalarCodecs$codecs).aq.qN);
var $author$project$Request$ProjectOverview$fromCommit = $author$project$Builder$Object$Vcs_commits$commit_id;
var $author$project$Builder$Object$Vcs_branches$isMain = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe Bool)',
	'main',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool));
var $author$project$Builder$Object$Vcs_branches$label = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'label',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $dillonkearns$elm_graphql$Graphql$SelectionSet$map3 = F4(
	function (combine, _v0, _v1, _v2) {
		var selectionFields1 = _v0.a;
		var selectionDecoder1 = _v0.b;
		var selectionFields2 = _v1.a;
		var selectionDecoder2 = _v1.b;
		var selectionFields3 = _v2.a;
		var selectionDecoder3 = _v2.b;
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			$elm$core$List$concat(
				_List_fromArray(
					[selectionFields1, selectionFields2, selectionFields3])),
			A4($elm$json$Json$Decode$map3, combine, selectionDecoder1, selectionDecoder2, selectionDecoder3));
	});
var $dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault = function (_default) {
	return $dillonkearns$elm_graphql$Graphql$SelectionSet$map(
		$elm$core$Maybe$withDefault(_default));
};
var $author$project$Request$ProjectOverview$fromBranches = A4(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map3,
	$author$project$Request$ProjectOverview$MiniBranch,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$Builder$Object$Vcs_branches$label),
	$author$project$Builder$Object$Vcs_branches$commit($author$project$Request$ProjectOverview$fromCommit),
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, false, $author$project$Builder$Object$Vcs_branches$isMain));
var $author$project$Request$ProjectOverview$bBranchNameWithCommitIDs = function () {
	var finish = A2(
		$elm$core$Basics$composeR,
		$elm$core$List$filterMap(
			function (_v0) {
				var label = _v0.b2;
				var commitID = _v0.BR;
				return A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair(label),
					commitID);
			}),
		$elm$core$Dict$fromList);
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
		finish,
		A2($author$project$Builder$Object$Projects$branches, $elm$core$Basics$identity, $author$project$Request$ProjectOverview$fromBranches));
}();
var $author$project$Misc$isEither = F3(
	function (predicateA, predicateB, a) {
		return predicateA(a) || predicateB(a);
	});
var $author$project$Model$User$role = F2(
	function (orgUrlName, user) {
		return A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.FO;
			},
			A2(
				$elm_community$list_extra$List$Extra$find,
				function (membership) {
					return _Utils_eq(
						$elm$core$String$toLower(membership.AC),
						$elm$core$String$toLower(orgUrlName));
				},
				user.mX));
	});
var $author$project$Model$Permissions$isOneOf = F3(
	function (roles, org, user) {
		if (!user.$) {
			var u = user.a;
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					$author$project$Misc$memberOf(roles),
					A2($author$project$Model$User$role, org, u)));
		} else {
			return false;
		}
	});
var $author$project$Model$ACL$isSuperUser = $author$project$Model$ACL$has(0);
var $author$project$Model$ACL$isSuperReader = function (acl) {
	return $author$project$Model$ACL$isSuperUser(acl) || A2($author$project$Model$ACL$has, 1, acl);
};
var $author$project$Model$User$isSuperReader = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map(
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.qa;
			},
			$author$project$Model$ACL$isSuperReader)),
	$elm$core$Maybe$withDefault(false));
var $author$project$Model$Permissions$canViewOrgPrivateInfo = function (org) {
	return A2(
		$author$project$Misc$isEither,
		A2(
			$author$project$Model$Permissions$isOneOf,
			_List_fromArray(
				[2, 1, 0]),
			org),
		$author$project$Model$User$isSuperReader);
};
var $elm$json$Json$Decode$map4 = _Json_map4;
var $dillonkearns$elm_graphql$Graphql$SelectionSet$map4 = F5(
	function (combine, _v0, _v1, _v2, _v3) {
		var selectionFields1 = _v0.a;
		var selectionDecoder1 = _v0.b;
		var selectionFields2 = _v1.a;
		var selectionDecoder2 = _v1.b;
		var selectionFields3 = _v2.a;
		var selectionDecoder3 = _v2.b;
		var selectionFields4 = _v3.a;
		var selectionDecoder4 = _v3.b;
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			$elm$core$List$concat(
				_List_fromArray(
					[selectionFields1, selectionFields2, selectionFields3, selectionFields4])),
			A5($elm$json$Json$Decode$map4, combine, selectionDecoder1, selectionDecoder2, selectionDecoder3, selectionDecoder4));
	});
var $author$project$Builder$InputObject$Projects_bool_exp = $elm$core$Basics$identity;
var $author$project$Builder$InputObject$buildProjects_bool_exp = function (fillOptionals____) {
	var optionals____ = fillOptionals____(
		{ak: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, y: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, fZ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, cJ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, g: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aJ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, z: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, bP: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, dT: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aL: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, gd: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aM: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, b4: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, w: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, B: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, D: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, c3: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, E: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, Fh: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, cd: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, s: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aN: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, Gt: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, da: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
	return {ak: optionals____.ak, y: optionals____.y, fZ: optionals____.fZ, cJ: optionals____.cJ, g: optionals____.g, aJ: optionals____.aJ, z: optionals____.z, bP: optionals____.bP, dT: optionals____.dT, aL: optionals____.aL, gd: optionals____.gd, aM: optionals____.aM, b4: optionals____.b4, w: optionals____.w, B: optionals____.B, D: optionals____.D, c3: optionals____.c3, E: optionals____.E, Fh: optionals____.Fh, cd: optionals____.cd, s: optionals____.s, aN: optionals____.aN, Gt: optionals____.Gt, da: optionals____.da};
};
var $author$project$Builder$InputObject$buildString_comparison_exp = function (fillOptionals____) {
	var optionals____ = fillOptionals____(
		{aW: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aY: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aZ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, l7: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a_: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, mj: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, mt: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a0: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a4: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, mI: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a5: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, mJ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, mK: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, mO: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, mP: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, nd: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, nv: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
	return {aW: optionals____.aW, aY: optionals____.aY, aZ: optionals____.aZ, l7: optionals____.l7, a_: optionals____.a_, mj: optionals____.mj, a$: optionals____.a$, mt: optionals____.mt, a0: optionals____.a0, a1: optionals____.a1, a4: optionals____.a4, mI: optionals____.mI, a5: optionals____.a5, mJ: optionals____.mJ, mK: optionals____.mK, mO: optionals____.mO, mP: optionals____.mP, nd: optionals____.nd, nv: optionals____.nv};
};
var $author$project$Request$ProjectOverview$equalToStr = function (str) {
	return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
		$author$project$Builder$InputObject$buildString_comparison_exp(
			function (args) {
				return _Utils_update(
					args,
					{
						aW: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(str)
					});
			}));
};
var $author$project$Builder$InputObject$buildTimestamp_comparison_exp = function (fillOptionals____) {
	var optionals____ = fillOptionals____(
		{aW: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aY: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aZ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a_: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a0: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a4: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a5: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
	return {aW: optionals____.aW, aY: optionals____.aY, aZ: optionals____.aZ, a_: optionals____.a_, a$: optionals____.a$, a0: optionals____.a0, a1: optionals____.a1, a4: optionals____.a4, a5: optionals____.a5};
};
var $author$project$Request$ProjectOverview$isNull = function (wantNull) {
	return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
		$author$project$Builder$InputObject$buildTimestamp_comparison_exp(
			function (args) {
				return _Utils_update(
					args,
					{
						a$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(wantNull)
					});
			}));
};
var $author$project$Builder$InputObject$Organizations_bool_exp = $elm$core$Basics$identity;
var $author$project$Builder$InputObject$buildOrganizations_bool_exp = function (fillOptionals____) {
	var optionals____ = fillOptionals____(
		{fV: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ak: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, y: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, g: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, z: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, bt: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, B: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, D: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, E: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, gx: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, dc: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aP: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ct: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
	return {fV: optionals____.fV, ak: optionals____.ak, y: optionals____.y, g: optionals____.g, z: optionals____.z, bt: optionals____.bt, B: optionals____.B, D: optionals____.D, E: optionals____.E, gx: optionals____.gx, dc: optionals____.dc, aP: optionals____.aP, ct: optionals____.ct};
};
var $author$project$Request$ProjectOverview$urlNameIs = function (urlName) {
	return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
		$author$project$Builder$InputObject$buildOrganizations_bool_exp(
			function (args) {
				return _Utils_update(
					args,
					{
						ct: $author$project$Request$ProjectOverview$equalToStr(urlName)
					});
			}));
};
var $author$project$Request$ProjectOverview$nameIs = F2(
	function (orgName, projectName) {
		return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
			$author$project$Builder$InputObject$buildProjects_bool_exp(
				function (args) {
					return _Utils_update(
						args,
						{
							z: $author$project$Request$ProjectOverview$isNull(true),
							w: $author$project$Request$ProjectOverview$equalToStr(projectName),
							c3: $author$project$Request$ProjectOverview$urlNameIs(orgName)
						});
				}));
	});
var $author$project$Builder$Object$Projects$organization = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'organization',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Builder$Enum$Projects_select_column$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'added';
		case 1:
			return 'changed';
		case 2:
			return 'created_by';
		case 3:
			return 'deleted';
		case 4:
			return 'description';
		case 5:
			return 'distribution_only';
		case 6:
			return 'forked_from';
		case 7:
			return 'languages';
		case 8:
			return 'managed';
		case 9:
			return 'name';
		case 10:
			return 'organization_id';
		case 11:
			return 'platforms';
		case 12:
			return 'private';
		case 13:
			return 'project_id';
		default:
			return 'repo_url';
	}
};
var $author$project$Builder$Query$projects = F2(
	function (fillInOptionals____, object____) {
		var filledInOptionals____ = fillInOptionals____(
			{tE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ux: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, uR: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, vE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ao: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs____ = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'distinct_on',
					filledInOptionals____.tE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Projects_select_column$toString))),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'limit', filledInOptionals____.ux, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'offset', filledInOptionals____.uR, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'order_by',
					filledInOptionals____.vE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Builder$InputObject$encodeProjects_order_by)),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'where', filledInOptionals____.ao, $author$project$Builder$InputObject$encodeProjects_bool_exp)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'projects',
			optionalArgs____,
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
	});
var $author$project$GraphQL$Utils$selectFirst = function (errMsg) {
	return $dillonkearns$elm_graphql$Graphql$SelectionSet$mapOrFail(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$head,
			$elm$core$Result$fromMaybe(errMsg)));
};
var $author$project$Model$Organization$OrganizationViaHasura = F6(
	function (added, addOns, displayName, organizationID, tier, urlName) {
		return {sP: addOns, ak: added, i$: displayName, zw: organizationID, dc: tier, AC: urlName};
	});
var $author$project$Builder$Object$Organizations$add_ons = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'add_ons',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Builder$Object$Organizations$added = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'CustomScalarCodecs.Timestamp',
	'added',
	_List_Nil,
	$author$project$Builder$Scalar$unwrapCodecs($author$project$CustomScalarCodecs$codecs).bC.qN);
var $author$project$Builder$Object$Organizations$display_name = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'display_name',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded = F2(
	function (constant, _v0) {
		var objectFields = _v0.a;
		var objectDecoder = _v0.b;
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$SelectionSet,
			objectFields,
			A3(
				$elm$json$Json$Decode$map2,
				$elm$core$Basics$apR,
				$elm$json$Json$Decode$succeed(constant),
				objectDecoder));
	});
var $author$project$Builder$Object$Tiers$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Builder$Object$Organizations$organization_id = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'CustomScalarCodecs.Uuid',
	'organization_id',
	_List_Nil,
	$author$project$Builder$Scalar$unwrapCodecs($author$project$CustomScalarCodecs$codecs).aq.qN);
var $author$project$Builder$Object$Organizations$tier = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'tier', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Builder$Object$Organizations$url_name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'url_name', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Model$Organization$selectionSet = function (getAddOns) {
	var dictToAddOns = F2(
		function (name, addon) {
			return _Utils_update(
				addon,
				{xA: '', bP: '', yQ: false, w: name});
		});
	var decodeAddOn = $elm$json$Json$Decode$dict($author$project$Model$AddOns$decodeAddOn);
	var decodeAddOns = A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(
			$elm$json$Json$Decode$decodeString(decodeAddOn)),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$andThen($elm$core$Result$toMaybe),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$withDefault($elm$core$Dict$empty),
				$elm$core$Dict$map(dictToAddOns))));
	var maybeGetAddOns = getAddOns ? $dillonkearns$elm_graphql$Graphql$SelectionSet$with(
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, decodeAddOns, $author$project$Builder$Object$Organizations$add_ons)) : $dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded($elm$core$Dict$empty);
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Builder$Object$Organizations$url_name,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Builder$Object$Organizations$tier($author$project$Builder$Object$Tiers$name),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Builder$Object$Organizations$organization_id,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
						$elm$core$Maybe$withDefault(''),
						$author$project$Builder$Object$Organizations$display_name),
					maybeGetAddOns(
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Builder$Object$Organizations$added,
							$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$Organization$OrganizationViaHasura)))))));
};
var $author$project$Builder$Object$Projects$added = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'CustomScalarCodecs.Timestamp',
	'added',
	_List_Nil,
	$author$project$Builder$Scalar$unwrapCodecs($author$project$CustomScalarCodecs$codecs).bC.qN);
var $author$project$Builder$Object$Projects$changed = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'CustomScalarCodecs.Timestamp',
	'changed',
	_List_Nil,
	$author$project$Builder$Scalar$unwrapCodecs($author$project$CustomScalarCodecs$codecs).bC.qN);
var $author$project$Builder$Object$Projects$description = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'description',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Builder$Object$Projects$distribution_only = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'distribution_only', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$GraphQL$Utils$listFind = F2(
	function (errMsg, filterFn) {
		return $dillonkearns$elm_graphql$Graphql$SelectionSet$mapOrFail(
			A2(
				$elm$core$Basics$composeR,
				$elm_community$list_extra$List$Extra$find(filterFn),
				$elm$core$Result$fromMaybe(errMsg)));
	});
var $author$project$Builder$Object$Projects$managed = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'managed', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Builder$Object$Projects$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Builder$Object$Projects$organization_id = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'CustomScalarCodecs.Uuid',
	'organization_id',
	_List_Nil,
	$author$project$Builder$Scalar$unwrapCodecs($author$project$CustomScalarCodecs$codecs).aq.qN);
var $author$project$Builder$Object$Projects$private = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'private', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Builder$Object$Projects$project_id = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'CustomScalarCodecs.Uuid',
	'project_id',
	_List_Nil,
	$author$project$Builder$Scalar$unwrapCodecs($author$project$CustomScalarCodecs$codecs).aq.qN);
var $author$project$Builder$Object$Projects$repo_url = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'repo_url',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Builder$Object$Vcs_branches$branch_id = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe CustomScalarCodecs.Uuid)',
	'branch_id',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$Builder$Scalar$unwrapCodecs($author$project$CustomScalarCodecs$codecs).aq.qN));
var $author$project$Builder$Object$Vcs_branches$commit_id = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe CustomScalarCodecs.Uuid)',
	'commit_id',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$Builder$Scalar$unwrapCodecs($author$project$CustomScalarCodecs$codecs).aq.qN));
var $author$project$Builder$Object$Vcs_branches$project_id = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe CustomScalarCodecs.Uuid)',
	'project_id',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$Builder$Scalar$unwrapCodecs($author$project$CustomScalarCodecs$codecs).aq.qN));
var $author$project$Request$Branch$TrackedBranch = F2(
	function (project, commitID) {
		return {BR: commitID, c5: project};
	});
var $author$project$Builder$Object$Vcs_branches$project = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'project',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Request$Branch$TrackedProject = F3(
	function (name, organization, id) {
		return {l6: id, w: name, c3: organization};
	});
var $author$project$Request$Branch$TrackedOrganization = function (url_name) {
	return {ct: url_name};
};
var $author$project$Request$Branch$trackedOrganization = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Builder$Object$Organizations$url_name,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Request$Branch$TrackedOrganization));
var $author$project$Request$Branch$trackedProject = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$Builder$Object$Projects$project_id,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Builder$Object$Projects$organization($author$project$Request$Branch$trackedOrganization),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Builder$Object$Projects$name,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Request$Branch$TrackedProject))));
var $author$project$Request$Branch$trackedBranchToForkedFrom = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$elm$core$Maybe$withDefault($author$project$Model$ForkedFrom$NotForked),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
		function (branch) {
			return A2(
				$elm$core$Maybe$andThen,
				function (project) {
					return A2(
						$elm$core$Maybe$map,
						function (org) {
							return $author$project$Model$ForkedFrom$Forked(
								{
									DU: A2($elm$core$Maybe$map, $danyx23$elm_uuid$Uuid$toString, branch.BR),
									c3: org.ct,
									c5: project.w
								});
						},
						project.c3);
				},
				branch.c5);
		},
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Builder$Object$Vcs_branches$commit_id,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Builder$Object$Vcs_branches$project($author$project$Request$Branch$trackedProject),
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Request$Branch$TrackedBranch)))));
var $author$project$Builder$Object$Vcs_branches$tracking_branch = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'tracking_branch',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Builder$Object$Vcs_branches$tracks = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe CustomScalarCodecs.Uuid)',
	'tracks',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$Builder$Scalar$unwrapCodecs($author$project$CustomScalarCodecs$codecs).aq.qN));
var $author$project$Builder$Object$Vcs_branches$upstream_commit_id = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe CustomScalarCodecs.Uuid)',
	'upstream_commit_id',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$Builder$Scalar$unwrapCodecs($author$project$CustomScalarCodecs$codecs).aq.qN));
var $author$project$Model$Branch$selectionSet = function () {
	var mapValue = F2(
		function (fn, errMsg) {
			return $dillonkearns$elm_graphql$Graphql$SelectionSet$mapOrFail(
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Maybe$map(fn),
					$elm$core$Result$fromMaybe(errMsg)));
		});
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
		$elm$core$Basics$identity,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
				$elm$core$Maybe$withDefault($author$project$Model$ForkedFrom$NotForked),
				$author$project$Builder$Object$Vcs_branches$tracking_branch($author$project$Request$Branch$trackedBranchToForkedFrom)),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Builder$Object$Vcs_branches$upstream_commit_id,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
					$elm$core$Maybe$Nothing,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Builder$Object$Vcs_branches$tracks,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
								$elm$core$Maybe$withDefault(''),
								$author$project$Builder$Object$Vcs_branches$label),
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
									$elm$core$Maybe$withDefault(false),
									$author$project$Builder$Object$Vcs_branches$isMain),
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$Builder$Object$Vcs_branches$commit_id,
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										A3(mapValue, $elm$core$Basics$identity, 'Missing project_id', $author$project$Builder$Object$Vcs_branches$project_id),
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											A3(mapValue, $elm$core$Basics$identity, 'Missing branch_id', $author$project$Builder$Object$Vcs_branches$branch_id),
											$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$Branch$Internals)))))))))));
}();
var $author$project$Builder$Object$Vcs_tags$commit_id = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe CustomScalarCodecs.Uuid)',
	'commit_id',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$Builder$Scalar$unwrapCodecs($author$project$CustomScalarCodecs$codecs).aq.qN));
var $author$project$Builder$Object$Vcs_tags$label = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'label',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Builder$Object$Vcs_tags$tag_id = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe CustomScalarCodecs.Uuid)',
	'tag_id',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$Builder$Scalar$unwrapCodecs($author$project$CustomScalarCodecs$codecs).aq.qN));
var $author$project$Model$Tag$selectionSet = function () {
	var mapValue = F2(
		function (fn, errMsg) {
			return $dillonkearns$elm_graphql$Graphql$SelectionSet$mapOrFail(
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Maybe$map(fn),
					$elm$core$Result$fromMaybe(errMsg)));
		});
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
		$elm$core$Basics$identity,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A3(mapValue, $elm$core$Basics$identity, 'Missing tag_id', $author$project$Builder$Object$Vcs_tags$tag_id),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A3(mapValue, $elm$core$Basics$identity, 'Missing label', $author$project$Builder$Object$Vcs_tags$label),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					A3(mapValue, $elm$core$Basics$identity, 'Missing commit_id', $author$project$Builder$Object$Vcs_tags$commit_id),
					$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$Tag$TagMeta)))));
}();
var $author$project$Builder$InputObject$encodeVcs_tags_order_by = function (_v0) {
	var input____ = _v0;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'changed',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.g,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'commit',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cM, $author$project$Builder$InputObject$encodeVcs_commits_order_by)),
				_Utils_Tuple2(
				'commit_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.P,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'label',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b2,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'project',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c5, $author$project$Builder$InputObject$encodeProjects_order_by)),
				_Utils_Tuple2(
				'project_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.s,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'tag_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.co,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString)))
			]));
};
var $author$project$Builder$Object$Projects$tags = F2(
	function (fillInOptionals____, object____) {
		var filledInOptionals____ = fillInOptionals____(
			{tE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ux: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, uR: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, vE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ao: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs____ = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'distinct_on',
					filledInOptionals____.tE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Vcs_tags_select_column$toString))),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'limit', filledInOptionals____.ux, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'offset', filledInOptionals____.uR, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'order_by',
					filledInOptionals____.vE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Builder$InputObject$encodeVcs_tags_order_by)),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'where', filledInOptionals____.ao, $author$project$Builder$InputObject$encodeVcs_tags_bool_exp)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'tags',
			optionalArgs____,
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
	});
var $author$project$Model$Project$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$elm$core$Basics$identity,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Builder$Object$Projects$distribution_only,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($author$project$Builder$Object$Projects$tags, $elm$core$Basics$identity, $author$project$Model$Tag$selectionSet),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					$elm$core$Maybe$withDefault(''),
					$author$project$Builder$Object$Projects$repo_url),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
					$author$project$Model$ForkedFrom$Unknown,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Builder$Object$Projects$changed,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Builder$Object$Projects$managed,
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								A2($author$project$Builder$Object$Projects$branches, $elm$core$Basics$identity, $author$project$Model$Branch$selectionSet),
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									A3(
										$author$project$GraphQL$Utils$listFind,
										'Missing branches',
										function (b) {
											return $author$project$Model$Branch$isDefault(b);
										},
										A2($author$project$Builder$Object$Projects$branches, $elm$core$Basics$identity, $author$project$Model$Branch$selectionSet)),
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$Builder$Object$Projects$private,
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											$author$project$Builder$Object$Projects$organization_id,
											A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
												$author$project$Builder$Object$Projects$project_id,
												A2(
													$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
													$author$project$Builder$Object$Projects$added,
													A2(
														$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
														A2(
															$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
															$elm$core$Maybe$withDefault(''),
															$author$project$Builder$Object$Projects$description),
														A2(
															$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
															$author$project$Builder$Object$Projects$name,
															$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$Project$ProjectInternals))))))))))))))));
var $author$project$Request$ProjectOverview$selectionSetMainBranchCommitID = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$mapOrFail,
	$elm$core$Result$fromMaybe('Missing Main Branch Commit'),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
		function ($) {
			return $.BR;
		},
		A3(
			$author$project$GraphQL$Utils$listFind,
			'Missing Main Branch',
			function ($) {
				return $.yM;
			},
			A2($author$project$Builder$Object$Projects$branches, $elm$core$Basics$identity, $author$project$Request$ProjectOverview$fromBranches))));
var $author$project$Request$ProjectOverview$responseSelectionSet = F3(
	function (session, orgName, projectName) {
		var getAddOns = A2(
			$author$project$Model$Permissions$canViewOrgPrivateInfo,
			orgName,
			$author$project$Model$Session$getUser(session));
		return A2(
			$author$project$GraphQL$Utils$selectFirst,
			'Missing Response',
			A2(
				$author$project$Builder$Query$projects,
				function (args) {
					return _Utils_update(
						args,
						{
							ao: A2($author$project$Request$ProjectOverview$nameIs, orgName, projectName)
						});
				},
				A5(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map4,
					$author$project$Request$ProjectOverview$Response,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$mapOrFail,
						$elm$core$Result$fromMaybe('Missing org'),
						$author$project$Builder$Object$Projects$organization(
							$author$project$Model$Organization$selectionSet(getAddOns))),
					$author$project$Model$Project$selectionSet,
					$author$project$Request$ProjectOverview$bBranchNameWithCommitIDs,
					$author$project$Request$ProjectOverview$selectionSetMainBranchCommitID)));
	});
var $author$project$Request$ProjectOverview$queryProject = F3(
	function (session, orgName, projectName) {
		return A6(
			$author$project$GraphQL$Utils$queryRequestCustom,
			1,
			$author$project$Model$Session$getCreds(session),
			0,
			_List_Nil,
			'GetProjectOverview',
			A3($author$project$Request$ProjectOverview$responseSelectionSet, session, orgName, projectName));
	});
var $author$project$Pages$ProjectOverview$init = F8(
	function (session, key, orgName, projectName, cliInstructionsPlatformParam, isNewProject, maybeBranchName, isShareModalOpen) {
		var queryProjectTask = A2(
			$elm$core$Task$andThen,
			function (response) {
				var toSolveLegacyEditor = $elm$core$Tuple$mapSecond($author$project$Model$BuildPlanner$SolveLegacyEditor$fromBuildExprWithFallback);
				var mainBuildExpr = response.o_.b;
				return $elm$core$Task$succeed(
					{
						fZ: A2(
							$elm$core$Dict$map,
							$elm$core$Basics$always(toSolveLegacyEditor),
							response.fZ),
						o_: toSolveLegacyEditor(response.o_),
						o$: mainBuildExpr,
						pd: response.pd,
						c5: response.c5,
						AA: $author$project$Model$BuildPlanner$SolveLegacyEditor$getUnsupportedReason(mainBuildExpr)
					});
			},
			A2(
				$elm$core$Task$andThen,
				$author$project$Request$BuildPlanner$getBuildExprs(session),
				A3($author$project$Request$ProjectOverview$queryProject, session, orgName, projectName)));
		var finishModel = F2(
			function (_v2, allPlatforms) {
				var org = _v2.pd;
				var project = _v2.c5;
				var branches = _v2.fZ;
				var mainBranch = _v2.o_;
				var mainBuildExpr = _v2.o$;
				var unsupportedReason = _v2.AA;
				var userPlatform = $author$project$Model$Platform$detectPlatformType(
					$author$project$Model$Session$getPlatform(session));
				var defaultBranch = $author$project$Model$Project$getDefaultBranch(project);
				var browserPlatformType = A2(
					$elm$core$Maybe$withDefault,
					0,
					$author$project$Model$Platform$detectPlatformType(
						$author$project$Model$Session$getPlatform(session)));
				var branchesModel = A6($author$project$Views$BranchDownloadsView$init, session, org, project, allPlatforms, mainBranch, branches);
				var isPerlModalOpen = (!$author$project$Model$Project$getIsPrivate(project)) && (A2(
					$elm$core$Dict$member,
					'perl',
					$author$project$Model$BuildPlanner$SolveLegacyEditor$getLanguages(branchesModel.hA.qR)) && $elm_community$maybe_extra$Maybe$Extra$isNothing(
					$author$project$Model$Session$getUser(session)));
				var allSelectedPlatforms = $elm$core$List$concat(
					A2(
						$elm$core$List$map,
						function (_v1) {
							var editor = _v1.b;
							return $elm$core$Dict$values(
								A2(
									$elm_community$dict_extra$Dict$Extra$keepOnly,
									$author$project$Model$BuildPlanner$SolveLegacyEditor$getPlatforms(editor),
									allPlatforms));
						},
						$elm$core$Dict$values(branches)));
				var platformsInProject = A2($elm$core$List$map, $author$project$Model$Platform$getPlatformType, allSelectedPlatforms);
				var downloadInstructionsModal = function () {
					var progressInformation = $elm$core$Maybe$Nothing;
					var _v0 = _Utils_Tuple2(cliInstructionsPlatformParam, userPlatform);
					if (!_v0.a.$) {
						if ((_v0.a.a === 'true') && (!_v0.b.$)) {
							var platform = _v0.b.a;
							return A2($elm$core$List$member, platform, platformsInProject) ? $elm$core$Maybe$Just(
								{h4: defaultBranch, ln: 0, rW: platform, pr: progressInformation, wa: false}) : $elm$core$Maybe$Nothing;
						} else {
							var param = _v0.a.a;
							return A2(
								$elm$core$Maybe$map,
								function (platform) {
									return {h4: defaultBranch, ln: 0, rW: platform, pr: progressInformation, wa: false};
								},
								$author$project$Model$Platform$detectPlatformType(param));
						}
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}();
				var platformType = A2($author$project$Misc$getWithFallback, browserPlatformType, platformsInProject);
				return {qf: _List_Nil, qg: allPlatforms, qh: platformsInProject, Bi: maybeBranchName, dj: branchesModel, k_: _List_Nil, oi: $author$project$Model$CopyStatus$empty, i_: $author$project$Views$CVESummary$new, fM: downloadInstructionsModal, q$: platformType, uk: isNewProject, ul: false, oQ: isPerlModalOpen, DD: isShareModalOpen, Y: key, o$: mainBuildExpr, rF: $author$project$Model$NormsAndVulns$init, c3: org, rW: platformType, c5: project, nm: $author$project$Views$CreateSBOM$NotLoaded, nn: $author$project$Views$CreateSBOM$NotLoaded, z$: allSelectedPlatforms, AA: unsupportedReason, kE: $elm$core$Maybe$Nothing};
			});
		return A2(
			$author$project$Task$Pipeline$fetch,
			$author$project$Request$Ingredient$platforms($elm$core$Maybe$Nothing),
			A2(
				$author$project$Task$Pipeline$fetch,
				queryProjectTask,
				$elm$core$Task$succeed(finishModel)));
	});
var $author$project$Task$Parallel$Extra$DownloadUpdated3 = function (a) {
	return {$: 0, a: a};
};
var $0ui$elm_task_parallel$Task$Parallel$FailedToLoad3 = function (a) {
	return {$: 3, a: a};
};
var $0ui$elm_task_parallel$Task$Parallel$LoadedA3 = function (a) {
	return {$: 0, a: a};
};
var $0ui$elm_task_parallel$Task$Parallel$LoadedB3 = function (a) {
	return {$: 1, a: a};
};
var $0ui$elm_task_parallel$Task$Parallel$LoadedC3 = function (a) {
	return {$: 2, a: a};
};
var $0ui$elm_task_parallel$Task$Parallel$State3 = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $0ui$elm_task_parallel$Task$Parallel$routeTo = F2(
	function (successMsg, failureMsg) {
		return A2(
			$elm$core$Basics$composeR,
			$elm$core$Task$andThen(
				A2($elm$core$Basics$composeL, $elm$core$Task$succeed, $elm$core$Result$Ok)),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Task$onError(
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, $elm$core$Result$Err)),
				$elm$core$Task$perform(
					function (result) {
						if (!result.$) {
							var data = result.a;
							return successMsg(data);
						} else {
							var err = result.a;
							return failureMsg(err);
						}
					})));
	});
var $0ui$elm_task_parallel$Task$Parallel$attempt3 = F4(
	function (updateMsg, task1, task2, task3) {
		return _Utils_Tuple2(
			A3($0ui$elm_task_parallel$Task$Parallel$State3, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3(
						$0ui$elm_task_parallel$Task$Parallel$routeTo,
						A2($elm$core$Basics$composeL, updateMsg, $0ui$elm_task_parallel$Task$Parallel$LoadedA3),
						A2($elm$core$Basics$composeL, updateMsg, $0ui$elm_task_parallel$Task$Parallel$FailedToLoad3),
						task1),
						A3(
						$0ui$elm_task_parallel$Task$Parallel$routeTo,
						A2($elm$core$Basics$composeL, updateMsg, $0ui$elm_task_parallel$Task$Parallel$LoadedB3),
						A2($elm$core$Basics$composeL, updateMsg, $0ui$elm_task_parallel$Task$Parallel$FailedToLoad3),
						task2),
						A3(
						$0ui$elm_task_parallel$Task$Parallel$routeTo,
						A2($elm$core$Basics$composeL, updateMsg, $0ui$elm_task_parallel$Task$Parallel$LoadedC3),
						A2($elm$core$Basics$composeL, updateMsg, $0ui$elm_task_parallel$Task$Parallel$FailedToLoad3),
						task3)
					])));
	});
var $author$project$BuildPlanner$Query$commit = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'commit',
			_List_fromArray(
				[
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required,
					'commitId',
					requiredArgs____.fk,
					A2(
						$author$project$BuildPlanner$Scalar$unwrapEncoder,
						function ($) {
							return $.oc;
						},
						$author$project$BuildPlannerScalarCodecs$codecs))
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Request$BuildPlanner$getBuildExprForProjectlessCommit = F2(
	function (session, commitId) {
		var creds = $author$project$Model$Session$getCreds(session);
		return A5(
			$author$project$GraphQL$Utils$queryRequest,
			creds,
			4,
			_List_Nil,
			'GetBuildExprForProjectlessCommitID',
			A2(
				$author$project$BuildPlanner$Query$commit,
				{fk: commitId},
				$author$project$BuildPlanner$Union$CommitResult$fragments(
					{
						u7: $author$project$Model$BuildPlanner$BuildExpr$selectionSet,
						vp: $author$project$BuildPlannerScalarCodecs$selectionSetFail(
							'Commit not found: ' + $danyx23$elm_uuid$Uuid$toString(commitId))
					})));
	});
var $author$project$Pages$ProjectPreview$init = F2(
	function (session, commitID) {
		var _v0 = A4(
			$0ui$elm_task_parallel$Task$Parallel$attempt3,
			$author$project$Task$Parallel$Extra$DownloadUpdated3,
			$elm$core$Task$succeed(commitID),
			A2($author$project$Request$BuildPlanner$getBuildExprForProjectlessCommit, session, commitID),
			$author$project$Request$Ingredient$platforms($elm$core$Maybe$Nothing));
		var downloadState = _v0.a;
		var downloadCmd = _v0.b;
		return _Utils_Tuple2(
			{x7: downloadState},
			downloadCmd);
	});
var $author$project$Pages$PublicProjects$communityEditionProjects = _List_fromArray(
	[
		{
		fW: 'ActiveState',
		bP: 'Accelerate your data science and software development with a production-ready, secure and supported Python distribution.',
		i$: 'ActivePython 3.8',
		gf: 'python-full',
		aC: 'Python 3.8',
		aM: _List_fromArray(
			['Python']),
		gp: _List_fromArray(
			[
				_Utils_Tuple2('windows', 'ActivePython-3.8'),
				_Utils_Tuple2('linux', 'ActivePython-3.8')
			]),
		Fh: _List_fromArray(
			['windows', 'linux']),
		vT: 'ActivePython-3.8',
		aI: '3.8'
	},
		{
		fW: 'ActiveState',
		bP: 'Support your mission-critical applications with the world’s most trusted Perl distribution.',
		i$: 'ActivePerl 5.28',
		gf: 'perl-full',
		aC: 'Perl 5.28',
		aM: _List_fromArray(
			['Perl']),
		gp: _List_fromArray(
			[
				_Utils_Tuple2('windows', 'ActivePerl-5.28'),
				_Utils_Tuple2('linux', 'ActivePerl-5.28'),
				_Utils_Tuple2('mac', 'ActivePerl-5.28-macOS')
			]),
		Fh: _List_fromArray(
			['windows', 'linux', 'mac']),
		vT: 'ActivePerl-5.28',
		aI: '5.28'
	},
		{
		fW: 'ActiveState',
		bP: 'Support your need for rapid prototyping, scripted applications and GUI creation with the industry\'s only general-purpose Tcl distribution.',
		i$: 'ActiveTcl 8.6',
		gf: 'tcl-full',
		aC: 'Tcl 8.6',
		aM: _List_fromArray(
			['Tcl']),
		gp: _List_fromArray(
			[
				_Utils_Tuple2('windows', 'ActiveTcl-8.6'),
				_Utils_Tuple2('linux', 'ActiveTcl-8.6')
			]),
		Fh: _List_fromArray(
			['windows', 'linux']),
		vT: 'ActiveTcl-8.6',
		aI: '8.6'
	}
	]);
var $author$project$Pages$PublicProjects$curatedProjects = _List_fromArray(
	[
		{
		fW: 'ActiveState',
		bP: 'Contains key packages for migrating from Python 2 to Python 3.',
		i$: 'Python 2 - 3 Migration',
		gf: 'python-2-3',
		aC: 'Python 3.6',
		aM: _List_fromArray(
			['Python']),
		gp: _List_fromArray(
			[
				_Utils_Tuple2('windows', 'Migrating-2-to-3'),
				_Utils_Tuple2('linux', 'Migrating-2-to-3'),
				_Utils_Tuple2('mac', 'Migrating-2-to-3')
			]),
		Fh: _List_fromArray(
			['windows', 'linux', 'mac']),
		vT: 'Migrating-2-to-3',
		aI: '3.6'
	},
		{
		fW: 'ActiveState',
		bP: 'Includes most of the popular Perl modules for manipulating text. Appropriate for doing everything from parse & extract routines to Web scraping to XML transformations.',
		i$: 'Text Processing Runtime',
		gf: 'text-processing',
		aC: 'Perl 5.28',
		aM: _List_fromArray(
			['Perl']),
		gp: _List_fromArray(
			[
				_Utils_Tuple2('windows', 'Perl-Text-Processing'),
				_Utils_Tuple2('linux', 'Perl-Text-Processing')
			]),
		Fh: _List_fromArray(
			['windows', 'linux']),
		vT: 'Perl-Text-Processing',
		aI: '5.28'
	},
		{
		fW: 'ActiveState',
		bP: 'Includes most of the popular packages for Machine Learning and Data Science, pre-compiled and ready to for use in projects ranging from recommendation engines to dashboards.',
		i$: 'ML-Mini-Runtime',
		gf: 'ml-mini-runtime',
		aC: 'Python 3.6',
		aM: _List_fromArray(
			['Python']),
		gp: _List_fromArray(
			[
				_Utils_Tuple2('windows', 'ML-Mini-Runtime-Win'),
				_Utils_Tuple2('linux', 'ML-Mini-Runtime-Linux')
			]),
		Fh: _List_fromArray(
			['windows', 'linux']),
		vT: 'ML-Mini-Runtime',
		aI: '3.6'
	},
		{
		fW: 'ActiveState',
		bP: 'Python runtime environment for web application development that contains all the popular frameworks, tools and utilities you\'ll need.',
		i$: 'Python WebDev Environment',
		gf: 'python-web-dev',
		aC: 'Python 3.6',
		aM: _List_fromArray(
			['Python']),
		gp: _List_fromArray(
			[
				_Utils_Tuple2('windows', 'Python-for-WebDev'),
				_Utils_Tuple2('linux', 'Python-for-WebDev'),
				_Utils_Tuple2('mac', 'Python-for-WebDev')
			]),
		Fh: _List_fromArray(
			['windows', 'linux', 'mac']),
		vT: 'Python-WebDev-Environment',
		aI: '3.6'
	},
		{
		fW: 'ActiveState',
		bP: 'Includes all the most popular frameworks, including Dancer, Mojolicious and Catalyst. Use it if you want to test out and compare the different frameworks.',
		i$: 'Perl WebDev Environment',
		gf: 'perl-web-dev',
		aC: 'Perl 5.28',
		aM: _List_fromArray(
			['Perl']),
		gp: _List_fromArray(
			[
				_Utils_Tuple2('windows', 'Perl-for-WebDev'),
				_Utils_Tuple2('linux', 'Perl-for-WebDev')
			]),
		Fh: _List_fromArray(
			['windows', 'linux']),
		vT: 'Perl-WebDev-Environment',
		aI: '5.28'
	},
		{
		fW: 'ActiveState',
		bP: 'WebDev runtime featuring the Dancer2 framework and many of its most popular plugins.',
		i$: 'Dancer for Perl WebDev',
		gf: 'dancer-web-dev',
		aC: 'Perl 5.28',
		aM: _List_fromArray(
			['Perl']),
		gp: _List_fromArray(
			[
				_Utils_Tuple2('windows', 'Perl-for-WebDev-Dancer'),
				_Utils_Tuple2('linux', 'Perl-for-WebDev-Dancer')
			]),
		Fh: _List_fromArray(
			['windows', 'linux']),
		vT: 'Dancer-WebDev-Environment',
		aI: '5.28'
	},
		{
		fW: 'ActiveState',
		bP: 'WebDev runtime featuring the Catalyst framework and many of its most popular plugins.',
		i$: 'Catalyst for Perl WebDev',
		gf: 'catalyst-web-dev',
		aC: 'Perl 5.28',
		aM: _List_fromArray(
			['Perl']),
		gp: _List_fromArray(
			[
				_Utils_Tuple2('windows', 'Perl-for-WebDev-Catalyst'),
				_Utils_Tuple2('linux', 'Perl-for-WebDev-Catalyst')
			]),
		Fh: _List_fromArray(
			['windows', 'linux']),
		vT: 'Catalyst-WebDev-Environment',
		aI: '5.28'
	},
		{
		fW: 'ActiveState',
		bP: 'WebDev runtime featuring the Mojolicious framework and many of its most popular plugins',
		i$: 'Mojolicious for Perl WebDev',
		gf: 'mojolicious-web-dev',
		aC: 'Perl 5.28',
		aM: _List_fromArray(
			['Perl']),
		gp: _List_fromArray(
			[
				_Utils_Tuple2('windows', 'Perl-for-WebDev-Mojo'),
				_Utils_Tuple2('linux', 'Perl-for-WebDev-Mojo')
			]),
		Fh: _List_fromArray(
			['windows', 'linux']),
		vT: 'Mojolicious-WebDev-Environment',
		aI: '5.28'
	},
		{
		fW: 'ActiveState',
		bP: 'Perl has a huge set of great testing tools that come with the base language. This runtime is designed to provide you with many of the best third party test tools, as well.',
		i$: 'Perl Testing Tools',
		gf: 'perl-testing-tools',
		aC: 'Perl 5.28',
		aM: _List_fromArray(
			['Perl']),
		gp: _List_fromArray(
			[
				_Utils_Tuple2('windows', 'Perl-Testing-Tools'),
				_Utils_Tuple2('linux', 'Perl-Testing-Tools')
			]),
		Fh: _List_fromArray(
			['windows', 'linux']),
		vT: 'Perl-Testing-Tools',
		aI: '5.28'
	}
	]);
var $author$project$Pages$PublicProjects$init = F2(
	function (_v0, key) {
		var _new = {te: $author$project$Pages$PublicProjects$communityEditionProjects, tw: $author$project$Pages$PublicProjects$curatedProjects, Y: key};
		return $elm$core$Task$succeed(_new);
	});
var $author$project$Pages$ResetPassword$init = F2(
	function (key, code) {
		return $elm$core$Task$succeed(
			{xD: code, Y: key, mN: $author$project$Views$NotificationsInline$init, ey: '', km: '', mZ: $elm$core$Maybe$Nothing, pk: $elm$core$Maybe$Nothing});
	});
var $author$project$Pages$StateToolCheatSheet$init = function (key) {
	var _new = {oi: $author$project$Model$CopyStatus$empty, Y: key};
	return $elm$core$Task$succeed(_new);
};
var $author$project$Pages$SupplementalLicenseTerms$init = function (model) {
	return $elm$core$Task$succeed(model);
};
var $author$project$Pages$Support$init = F2(
	function (session, key) {
		var highestTier = $author$project$Model$User$getHighestTier(
			$author$project$Model$Session$getUser(session));
		var _new = {yv: highestTier, Y: key};
		return $elm$core$Task$succeed(_new);
	});
var $author$project$Msg$ActivateMembershipLoaded = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$AuthorizeDevice$AuthorizeDevice = function (a) {
	return {$: 0, a: a};
};
var $author$project$Msg$AutoForkLoaded = function (a) {
	return {$: 93, a: a};
};
var $author$project$Msg$CheckEmailLoaded = function (a) {
	return {$: 11, a: a};
};
var $author$project$Msg$CheckoutLoaded = function (a) {
	return {$: 98, a: a};
};
var $author$project$Msg$CreateOrganizationLoaded = function (a) {
	return {$: 80, a: a};
};
var $author$project$Msg$CreateProjectFromCommitLoaded = function (a) {
	return {$: 99, a: a};
};
var $author$project$Msg$CreateProjectLoaded = function (a) {
	return {$: 81, a: a};
};
var $author$project$Msg$FinishSetupLoaded = function (a) {
	return {$: 108, a: a};
};
var $author$project$Msg$ForkProjectLoaded = function (a) {
	return {$: 91, a: a};
};
var $author$project$Msg$ImportProjectLoaded = function (a) {
	return {$: 83, a: a};
};
var $author$project$Main$LoadingOrgDependencies = function (a) {
	return {$: 9, a: a};
};
var $author$project$Main$LoadingOrgIndex = function (a) {
	return {$: 1, a: a};
};
var $author$project$Main$LoadingOrgPolicy = function (a) {
	return {$: 10, a: a};
};
var $author$project$Main$LoadingOrgRemediation = function (a) {
	return {$: 11, a: a};
};
var $author$project$Main$LoadingOrgSecurity = function (a) {
	return {$: 8, a: a};
};
var $author$project$Main$LoadingProjectConfig = function (a) {
	return {$: 2, a: a};
};
var $author$project$Main$LoadingProjectConfigAdvanced = function (a) {
	return {$: 3, a: a};
};
var $author$project$Main$LoadingProjectDownloads = function (a) {
	return {$: 4, a: a};
};
var $author$project$Main$LoadingProjectHistory = function (a) {
	return {$: 5, a: a};
};
var $author$project$Main$LoadingProjectImpactReport = function (a) {
	return {$: 6, a: a};
};
var $author$project$Msg$OrgDependenciesLoadingMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Msg$OrgIndexLoadingMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Msg$OrgMembersLoaded = function (a) {
	return {$: 21, a: a};
};
var $author$project$Msg$OrgPolicyLoadingMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Msg$OrgRemediationLoadingMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Msg$OrgScanLoaded = function (a) {
	return {$: 27, a: a};
};
var $author$project$Msg$OrgSecurityLoadingMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Msg$OrgSettingsLoaded = function (a) {
	return {$: 26, a: a};
};
var $author$project$Msg$OrgsLoaded = function (a) {
	return {$: 18, a: a};
};
var $author$project$Msg$PreferenceDeleteAccountLoaded = function (a) {
	return {$: 39, a: a};
};
var $author$project$Msg$PreferenceEmailLoaded = function (a) {
	return {$: 36, a: a};
};
var $author$project$Msg$PreferenceLinkedAccountsLoaded = function (a) {
	return {$: 31, a: a};
};
var $author$project$Msg$PreferencePasswordLoaded = function (a) {
	return {$: 37, a: a};
};
var $author$project$Msg$PreferenceTwoFactorLoaded = function (a) {
	return {$: 38, a: a};
};
var $author$project$Msg$ProjectConfigAdvancedLoadingMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Msg$ProjectConfigLoadingMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Msg$ProjectDownloadsLoadingMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Msg$ProjectHistoryLoadingMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Msg$ProjectImpactReportLoadingMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Msg$ProjectSettingsBranchesLoaded = function (a) {
	return {$: 51, a: a};
};
var $author$project$Msg$ProjectSettingsHARLoaded = function (a) {
	return {$: 49, a: a};
};
var $author$project$Msg$ProjectSettingsLoaded = function (a) {
	return {$: 47, a: a};
};
var $author$project$Model$User$isSuperUser = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map(
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.qa;
			},
			$author$project$Model$ACL$isSuperUser)),
	$elm$core$Maybe$withDefault(false));
var $author$project$Model$Permissions$canChangeOrgSettings = function (org) {
	return A2(
		$author$project$Misc$isEither,
		A2(
			$author$project$Model$Permissions$isOneOf,
			_List_fromArray(
				[2]),
			org),
		$author$project$Model$User$isSuperUser);
};
var $elm$core$List$sortBy = _List_sortBy;
var $author$project$Model$User$getLastCreatedOrg = function (user) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$sortBy,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.ts;
				},
				A2(
					$elm$core$Basics$composeR,
					$elm$time$Time$posixToMillis,
					$elm$core$Basics$mul(-1))),
			user.mX));
};
var $author$project$Model$Session$getDefaultOrgUrlName = function (session) {
	var _v0 = A2(
		$elm$core$Maybe$andThen,
		A2(
			$elm$core$Basics$composeR,
			$author$project$Model$User$getLastCreatedOrg,
			$elm$core$Maybe$map(
				function ($) {
					return $.AC;
				})),
		$author$project$Model$Session$getUser(session));
	if (!_v0.$) {
		var lastCreatedOrgName = _v0.a;
		var _v1 = A2($author$project$Model$Session$getLocalStorage, $author$project$Model$LocalStorage$lastOrganizationKey, session);
		if (!_v1.$) {
			var lastVisiteOrgName = _v1.a;
			return A2($author$project$Model$Session$isMember, lastVisiteOrgName, session) ? $elm$core$Maybe$Just(lastVisiteOrgName) : $elm$core$Maybe$Just(lastCreatedOrgName);
		} else {
			return $elm$core$Maybe$Just(lastCreatedOrgName);
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Url$Extra$hostWithPort = function (url) {
	var _v0 = url.Fk;
	if (!_v0.$) {
		var p = _v0.a;
		return url.t0 + (':' + $elm$core$String$fromInt(p));
	} else {
		return url.t0;
	}
};
var $author$project$Request$Invitation$get = F2(
	function (inviteCode, creds) {
		return $author$project$Http$Extra$get(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$emptyBody,
				qN: $author$project$Model$Invitation$decode(false),
				CN: _List_Nil,
				GT: '/invitations/code/' + $author$project$Model$NonEmptyString$toString(inviteCode)
			});
	});
var $author$project$Pages$ActivateMembership$init = F3(
	function (session, key, inviteCode) {
		return A3(
			$elm$core$Task$map2,
			F2(
				function (invitation, now) {
					return {
						fs: inviteCode,
						Y: key,
						uQ: now,
						ix: invitation.c3.AC,
						vI: $author$project$Model$Route$Protected(
							$author$project$Model$Route$Org(
								{
									ix: invitation.c3.AC,
									vI: $author$project$Model$Route$OrgIndex($elm$core$Maybe$Nothing)
								})),
						zw: invitation.c3.zw
					};
				}),
			A2(
				$author$project$Request$Invitation$get,
				inviteCode,
				$author$project$Model$Session$getCreds(session)),
			$elm$time$Time$now);
	});
var $author$project$Pages$AuthorizeDevice$init = F3(
	function (_v0, authPage, key) {
		return {oi: $author$project$Model$CopyStatus$empty, Y: key, pi: authPage, iG: 1};
	});
var $author$project$Request$Project$get = F3(
	function (creds, orgName, projectName) {
		return $author$project$Http$Extra$get(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$emptyBody,
				qN: $author$project$Model$Project$decode,
				CN: _List_Nil,
				GT: A2($author$project$Request$Project$urlPathOrgProject, orgName, projectName)
			});
	});
var $author$project$Model$Project$decodeList = $elm$json$Json$Decode$list($author$project$Model$Project$decode);
var $author$project$Request$Project$list = F2(
	function (creds, orgName) {
		return $author$project$Http$Extra$get(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$emptyBody,
				qN: $author$project$Model$Project$decodeList,
				CN: _List_Nil,
				GT: A2($author$project$Request$Project$urlPathOrgProject, orgName, '')
			});
	});
var $author$project$Task$Pipeline$resolve = $elm$core$Task$andThen($elm$core$Basics$identity);
var $author$project$Http$Extra$toMaybe = function () {
	var on404Nothing = function (err) {
		var _v0 = err.mp;
		if (_v0.$ === 3) {
			var resp = _v0.a;
			return (resp.wp === 404) ? $elm$core$Task$succeed($elm$core$Maybe$Nothing) : $elm$core$Task$fail(err);
		} else {
			return $elm$core$Task$fail(err);
		}
	};
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Task$map($elm$core$Maybe$Just),
		$elm$core$Task$onError(on404Nothing));
}();
var $author$project$Pages$AutoFork$init = F6(
	function (session, orgName, projectName, cliInstructionsPlatform, _v0, key) {
		var finish = F2(
			function (scopedProject, projectList) {
				return $elm$core$Task$succeed(
					{g$: cliInstructionsPlatform, Y: key, pR: orgName, hU: scopedProject, wX: projectList});
			});
		var creds = $author$project$Model$Session$getCreds(session);
		var project = $author$project$Http$Extra$toMaybe(
			A3($author$project$Request$Project$get, creds, orgName, projectName));
		var userProjects = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Task$succeed(_List_Nil),
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.AE;
					},
					$author$project$Request$Project$list(creds)),
				$author$project$Model$Session$getUser(session)));
		return $author$project$Task$Pipeline$resolve(
			A2(
				$author$project$Task$Pipeline$fetch,
				userProjects,
				A2(
					$author$project$Task$Pipeline$fetch,
					project,
					$elm$core$Task$succeed(finish))));
	});
var $author$project$Pages$CheckEmail$init = F4(
	function (key, email, code, nextRoute) {
		return $elm$core$Task$succeed(
			{xD: code, lJ: email, Y: key, D6: true, dg: nextRoute, mN: $author$project$Views$NotificationsInline$init});
	});
var $author$project$Pages$Checkout$BillingDetails = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Checkout$SpecifyOrg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Http$Extra$Response = F4(
	function (statusCode, statusText, headers, body) {
		return {sY: body, CN: headers, wp: statusCode, wq: statusText};
	});
var $author$project$Http$Extra$generic404 = A2(
	$author$project$Http$Extra$Error,
	'',
	$author$project$Http$Extra$BadStatus(
		A4($author$project$Http$Extra$Response, 404, '', $elm$core$Dict$empty, '')));
var $author$project$Model$Tier$TierWithPricing = F4(
	function (tier, tierPrice, pricePerRuntime, includedRuntimeCount) {
		return {yC: includedRuntimeCount, zI: pricePerRuntime, dc: tier, wF: tierPrice};
	});
var $author$project$Model$Tier$Data = F8(
	function (name, description, requiresPayment, isDefault, userSelectable, limitMinimumUsers, limitNodeUsersThreshold, limitNodesPerThreshold) {
		return {bP: description, Da: isDefault, DY: limitMinimumUsers, DZ: limitNodeUsersThreshold, D_: limitNodesPerThreshold, w: name, zS: requiresPayment, AD: userSelectable};
	});
var $author$project$Model$Tier$Tier = $elm$core$Basics$identity;
var $author$project$Model$Tier$decode = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'limitNodesPerThreshold',
		$elm$json$Json$Decode$int,
		0,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'limitNodeUsersThreshold',
			$elm$json$Json$Decode$int,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'limitMinimumUsers',
				$elm$json$Json$Decode$int,
				0,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'userSelectable',
					$elm$json$Json$Decode$bool,
					false,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'isDefault',
						$elm$json$Json$Decode$bool,
						false,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'requiresPayment',
							$elm$json$Json$Decode$bool,
							false,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'description',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'name',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Model$Tier$Data))))))))));
var $author$project$Model$Tier$decodeWithPricing = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'includedRuntimeCount',
	$elm$json$Json$Decode$int,
	0,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'pricePerRuntime',
		$elm$json$Json$Decode$float,
		0,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'tierPrice',
			$elm$json$Json$Decode$float,
			0,
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				$author$project$Model$Tier$decode,
				$elm$json$Json$Decode$succeed($author$project$Model$Tier$TierWithPricing)))));
var $author$project$Request$Tier$getTiersWithPricing = function (creds) {
	return $author$project$Http$Extra$get(
		{
			iO: $author$project$Http$Extra$Creds(creds),
			sY: $author$project$Http$Extra$emptyBody,
			qN: $elm$json$Json$Decode$list($author$project$Model$Tier$decodeWithPricing),
			CN: _List_Nil,
			GT: '/tiers/pricing'
		});
};
var $author$project$Pages$Checkout$BillingDetails$NotCalculated = {$: 0};
var $jinjor$elm_debounce$Debounce$Debounce = $elm$core$Basics$identity;
var $jinjor$elm_debounce$Debounce$init = {$7: _List_Nil, oZ: false};
var $author$project$Views$BillingForm$WriteOnly = {$: 0};
var $author$project$Model$Countries$emptyCountryInfo = {xc: '', w: ''};
var $author$project$Model$AddressInfo$empty = {qd: '', sQ: '', qB: '', qK: $author$project$Model$Countries$emptyCountryInfo, lJ: '', w: '', bB: '', sM: ''};
var $author$project$Views$BillingForm$reset = function (model) {
	var addressOrEmpty = function (fn) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Model$AddressInfo$empty,
			A2($elm$core$Maybe$andThen, fn, model.qp));
	};
	return {
		xm: addressOrEmpty(
			function ($) {
				return $.xm;
			}),
		qp: model.qp,
		Bs: addressOrEmpty(
			function ($) {
				return $.Bs;
			}),
		iT: false,
		iW: false,
		io: false,
		oe: model.oe,
		x2: false,
		tD: false,
		yf: _List_Nil,
		jU: model.jU,
		D6: false,
		Fa: $elm$core$Maybe$Nothing,
		z4: addressOrEmpty(
			function ($) {
				return $.z4;
			})
	};
};
var $author$project$Views$BillingForm$newWriteOnly = F2(
	function (billingInfo, confirmText) {
		return $author$project$Views$BillingForm$reset(
			{qp: billingInfo, oe: confirmText, jU: $author$project$Views$BillingForm$WriteOnly});
	});
var $author$project$Pages$Checkout$BillingDetails$init = F5(
	function (confirmText, orgs, selectedOrg, now, runtimes) {
		return {
			lp: $jinjor$elm_debounce$Debounce$init,
			lH: false,
			jT: A2($author$project$Views$BillingForm$newWriteOnly, $elm$core$Maybe$Nothing, confirmText),
			mN: $author$project$Views$NotificationsInline$init,
			uQ: now,
			rJ: orgs,
			FV: selectedOrg,
			iH: runtimes,
			gP: $author$project$Pages$Checkout$BillingDetails$NotCalculated
		};
	});
var $author$project$Pages$Checkout$SpecifyOrg$SpecifyOrgCreation = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Checkout$SpecifyOrg$SpecifyOrgSelection = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$Permissions$canUpgradeOrg = function (org) {
	return A2(
		$author$project$Misc$isEither,
		A2(
			$author$project$Model$Permissions$isOneOf,
			_List_fromArray(
				[2]),
			org),
		$author$project$Model$User$isSuperUser);
};
var $author$project$Model$Organization$hasEverHadTrial = function ($) {
	return $.CM;
};
var $author$project$Model$Organization$isFreeTier = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.dc;
	},
	A2(
		$elm$core$Basics$composeR,
		$author$project$Model$Tier$stringToSimpleTier,
		$elm$core$Basics$eq($author$project$Model$Tier$Free)));
var $author$project$Model$Organization$isEligibleForUpgrade = F2(
	function (forTrial, org) {
		return $author$project$Model$Organization$isFreeTier(org) && ((!forTrial) || (!$author$project$Model$Organization$hasEverHadTrial(org)));
	});
var $author$project$Pages$Checkout$SpecifyOrg$eligibleOrgs = F2(
	function (maybeUser, forTrial) {
		return $elm$core$List$filter(
			function (org) {
				return A2($author$project$Model$Permissions$canUpgradeOrg, org.AC, maybeUser) && A2($author$project$Model$Organization$isEligibleForUpgrade, forTrial, org);
			});
	});
var $author$project$Pages$Checkout$SpecifyOrg$defaultOrgByUrlName = F4(
	function (maybeUser, isTrial, urlName, orgs) {
		return A2(
			$elm$core$Maybe$andThen,
			function (name) {
				return A2(
					$elm_community$list_extra$List$Extra$find,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.AC;
						},
						$elm$core$Basics$eq(name)),
					A3($author$project$Pages$Checkout$SpecifyOrg$eligibleOrgs, maybeUser, isTrial, orgs));
			},
			urlName);
	});
var $elm_community$list_extra$List$Extra$last = function (items) {
	last:
	while (true) {
		if (!items.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!items.b.b) {
				var x = items.a;
				return $elm$core$Maybe$Just(x);
			} else {
				var rest = items.b;
				var $temp$items = rest;
				items = $temp$items;
				continue last;
			}
		}
	}
};
var $author$project$Pages$Checkout$SpecifyOrg$defaultSelectedOrg = F2(
	function (maybeUser, isTrial) {
		return A2(
			$elm$core$Basics$composeR,
			A2($author$project$Pages$Checkout$SpecifyOrg$eligibleOrgs, maybeUser, isTrial),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$sortBy(
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.ak;
						},
						$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime)),
				$elm_community$list_extra$List$Extra$last));
	});
var $author$project$Pages$Checkout$SpecifyOrg$eligibleOrgsExist = F2(
	function (maybeUser, forTrial) {
		return A2(
			$elm$core$Basics$composeR,
			A2($author$project$Pages$Checkout$SpecifyOrg$eligibleOrgs, maybeUser, forTrial),
			A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not));
	});
var $elm_community$maybe_extra$Maybe$Extra$oneOf = F2(
	function (fmbs, a) {
		oneOf:
		while (true) {
			if (!fmbs.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var fmb = fmbs.a;
				var rest = fmbs.b;
				var _v1 = fmb(a);
				if (!_v1.$) {
					var b = _v1.a;
					return $elm$core$Maybe$Just(b);
				} else {
					var $temp$fmbs = rest,
						$temp$a = a;
					fmbs = $temp$fmbs;
					a = $temp$a;
					continue oneOf;
				}
			}
		}
	});
var $author$project$Pages$Checkout$SpecifyOrg$init = F5(
	function (session, isTrial, orgs, now, orgUrlName) {
		var sortedOrgs = A2(
			$elm$core$List$sortBy,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.i$;
				},
				$elm$core$String$toLower),
			orgs);
		var maybeUser = $author$project$Model$Session$getUser(session);
		return {
			gZ: A3($author$project$Pages$Checkout$SpecifyOrg$eligibleOrgsExist, maybeUser, isTrial, orgs) ? $author$project$Pages$Checkout$SpecifyOrg$SpecifyOrgSelection(
				{
					FV: A2(
						$elm_community$maybe_extra$Maybe$Extra$oneOf,
						_List_fromArray(
							[
								A3($author$project$Pages$Checkout$SpecifyOrg$defaultOrgByUrlName, maybeUser, isTrial, orgUrlName),
								A2($author$project$Pages$Checkout$SpecifyOrg$defaultSelectedOrg, maybeUser, isTrial)
							]),
						orgs),
					nt: false
				}) : $author$project$Pages$Checkout$SpecifyOrg$SpecifyOrgCreation(
				{qY: '', AC: '', p2: $elm$core$Maybe$Nothing}),
			uQ: now,
			rJ: sortedOrgs
		};
	});
var $author$project$Task$Pipeline$into = $elm$core$Task$succeed;
var $author$project$Model$Tier$requiresPayment = function (_v0) {
	var t = _v0;
	return t.zS;
};
var $author$project$Model$Tier$isEligibleAsSubscription = $author$project$Model$Tier$requiresPayment;
var $author$project$Model$Tier$name = function (_v0) {
	var t = _v0;
	return t.w;
};
var $author$project$Pages$Checkout$isTier = function (tier) {
	return A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.dc;
		},
		A2(
			$elm$core$Basics$composeR,
			$author$project$Model$Tier$name,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Model$Tier$stringToSimpleTier,
				$elm$core$Basics$eq(tier))));
};
var $author$project$Model$Organization$decodeList = $elm$json$Json$Decode$list($author$project$Model$Organization$decode);
var $author$project$Request$Organization$list = function (creds) {
	return $author$project$Http$Extra$get(
		{
			iO: $author$project$Http$Extra$Creds(creds),
			sY: $author$project$Http$Extra$emptyBody,
			qN: $author$project$Model$Organization$decodeList,
			CN: _List_Nil,
			GT: '/organizations'
		});
};
var $author$project$Model$Runtimes$Runtimes = $elm$core$Basics$identity;
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $author$project$Model$Runtimes$maxRuntimes = 75;
var $author$project$Model$Runtimes$minRuntimes = 3;
var $author$project$Misc$stepBy = F2(
	function (step, number) {
		return number - (number % step);
	});
var $author$project$Model$Runtimes$stepRuntimes = 3;
var $author$project$Model$Runtimes$toRuntimes = function (num) {
	return A3(
		$elm$core$Basics$clamp,
		$author$project$Model$Runtimes$minRuntimes,
		$author$project$Model$Runtimes$maxRuntimes,
		A2($author$project$Misc$stepBy, $author$project$Model$Runtimes$stepRuntimes, num));
};
var $author$project$Pages$Checkout$selectedRuntimes = A2(
	$elm$core$Basics$composeL,
	$author$project$Model$Runtimes$toRuntimes,
	function ($) {
		return $.yC;
	});
var $author$project$Model$Tier$userSelectable = function (_v0) {
	var t = _v0;
	return t.AD;
};
var $author$project$Pages$Checkout$init = F3(
	function (session, key, _v0) {
		var isTrial = _v0.up;
		var isNewUser = _v0.jc;
		var maybeNextRoute = _v0.Ee;
		var host = _v0.t0;
		var tier = _v0.dc;
		var skipSelectionOptions = _v0.F9;
		var getOrgByName = F2(
			function (name, orgs) {
				return A2(
					$elm_community$list_extra$List$Extra$find,
					function (o) {
						return _Utils_eq(o.AC, name);
					},
					orgs);
			});
		var foundTier = isTrial ? $author$project$Model$Tier$Pro : A2(
			$elm$core$Maybe$withDefault,
			$author$project$Model$Tier$Team(false),
			tier);
		var creds = $author$project$Model$Session$getCreds(session);
		var orgsTask = $author$project$Request$Organization$list(creds);
		var tierTask = A2(
			$elm$core$Task$andThen,
			function (tiersWithPricing) {
				var isValidTier = function (t) {
					return $author$project$Model$Tier$isEligibleAsSubscription(t.dc) && ($author$project$Model$Tier$userSelectable(t.dc) && A2($author$project$Pages$Checkout$isTier, foundTier, t));
				};
				var _v5 = A2($elm_community$list_extra$List$Extra$find, isValidTier, tiersWithPricing);
				if (_v5.$ === 1) {
					return $elm$core$Task$fail($author$project$Http$Extra$generic404);
				} else {
					var t = _v5.a;
					return $elm$core$Task$succeed(t);
				}
			},
			$author$project$Request$Tier$getTiersWithPricing(creds));
		var _v1 = function () {
			if (!skipSelectionOptions.$) {
				var _v3 = skipSelectionOptions.a;
				var on = _v3.a;
				var ss = _v3.b;
				return _Utils_Tuple2(on, ss);
			} else {
				return _Utils_Tuple2('', false);
			}
		}();
		var orgName = _v1.a;
		var skipSelection = _v1.b;
		var checkoutState = F3(
			function (orgs, tierInfo, now) {
				if (skipSelection) {
					var _v4 = A2(getOrgByName, orgName, orgs);
					if (!_v4.$) {
						var org = _v4.a;
						return $author$project$Pages$Checkout$BillingDetails(
							A5(
								$author$project$Pages$Checkout$BillingDetails$init,
								'Complete Checkout',
								orgs,
								org,
								now,
								$author$project$Pages$Checkout$selectedRuntimes(tierInfo)));
					} else {
						return $author$project$Pages$Checkout$SpecifyOrg(
							A5(
								$author$project$Pages$Checkout$SpecifyOrg$init,
								session,
								isTrial,
								orgs,
								now,
								$elm$core$Maybe$Just(orgName)));
					}
				} else {
					return $author$project$Pages$Checkout$SpecifyOrg(
						A5(
							$author$project$Pages$Checkout$SpecifyOrg$init,
							session,
							isTrial,
							orgs,
							now,
							$elm$core$Maybe$Just(orgName)));
				}
			});
		var finishModel = F3(
			function (orgs, tierInfo, now) {
				return {
					iU: A3(checkoutState, orgs, tierInfo, now),
					t0: host,
					jc: isNewUser,
					up: isTrial,
					Y: key,
					Ee: maybeNextRoute,
					uQ: now,
					sC: tierInfo
				};
			});
		return A2(
			$author$project$Task$Pipeline$fetch,
			$elm$time$Time$now,
			A2(
				$author$project$Task$Pipeline$fetch,
				tierTask,
				A2(
					$author$project$Task$Pipeline$fetch,
					orgsTask,
					$author$project$Task$Pipeline$into(finishModel))));
	});
var $author$project$Request$Organization$isNameAvailable = F2(
	function (orgName, creds) {
		return $author$project$Http$Extra$get(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$emptyBody,
				qN: $elm$json$Json$Decode$bool,
				CN: _List_Nil,
				GT: '/organizations/unique/' + orgName
			});
	});
var $author$project$Views$CreateOrgForm$Available = 2;
var $author$project$Views$CreateOrgForm$NotRequested = 0;
var $author$project$Validation$alphaNumericAndHyphens = _List_fromArray(
	[
		_Utils_Tuple2('[^A-Za-z0-9]+', '-'),
		_Utils_Tuple2('-$', ''),
		_Utils_Tuple2('^-', '')
	]);
var $author$project$Validation$formatUsername = function (name) {
	var usernameValidations = $author$project$Validation$alphaNumericAndHyphens;
	return A3($elm$core$List$foldl, $author$project$Validation$applyRegex, name, usernameValidations);
};
var $author$project$Views$CreateOrgForm$new = F4(
	function (key, host, defaultOrgName, _v0) {
		var isEligibleForTrial = _v0.De;
		var _v1 = function () {
			var _v2 = _Utils_Tuple2(
				defaultOrgName,
				A2($elm$core$Maybe$map, $author$project$Validation$formatUsername, defaultOrgName));
			if ((!_v2.a.$) && (!_v2.b.$)) {
				var input = _v2.a.a;
				var formatted = _v2.b.a;
				return _Utils_Tuple3(input, formatted, 2);
			} else {
				return _Utils_Tuple3('', '', 0);
			}
		}();
		var initialUserInput = _v1.a;
		var formattedOrgName = _v1.b;
		var nameCheckStatus = _v1.c;
		return {lp: $jinjor$elm_debounce$Debounce$init, De: isEligibleForTrial, ri: false, Y: key, g8: nameCheckStatus, ix: formattedOrgName, gv: $elm$core$Maybe$Nothing, jk: formattedOrgName, kv: $author$project$Model$Tier$Free, iI: false, wU: host + '/', p3: initialUserInput};
	});
var $author$project$Pages$CreateOrganization$init = F5(
	function (session, key, host, nextRoute, autoProjectParams) {
		var username = $author$project$Model$Session$getUsername(session);
		var possibleOrgName = username + '-org';
		var isEligibleForTrial = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.De;
				},
				$author$project$Model$Session$getUser(session)));
		var creds = $author$project$Model$Session$getCreds(session);
		return A2(
			$elm$core$Task$map,
			function (orgNameAvailable) {
				var defaultOrgName = orgNameAvailable ? $elm$core$Maybe$Just(possibleOrgName) : $elm$core$Maybe$Nothing;
				return {
					h3: autoProjectParams,
					jT: A4(
						$author$project$Views$CreateOrgForm$new,
						key,
						host,
						defaultOrgName,
						{De: isEligibleForTrial}),
					Y: key,
					dg: nextRoute
				};
			},
			A2(
				$elm$core$Task$onError,
				$elm$core$Basics$always(
					$elm$core$Task$succeed(false)),
				A2($author$project$Request$Organization$isNameAvailable, possibleOrgName, creds)));
	});
var $author$project$Pages$CreateProject$AddPackages = 1;
var $author$project$Pages$CreateProject$ImportPackages = 2;
var $author$project$Model$Visibility$Public = 1;
var $krisajenkins$remotedata$RemoteData$Success = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$Namespace$addBundlesPrefix = function (string) {
	return $author$project$Model$Namespace$hasBundlesPrefix(string) ? string : _Utils_ap($author$project$Model$Namespace$bundlesPrefix, string);
};
var $author$project$Model$Language$toString = function (language) {
	switch (language) {
		case 0:
			return 'perl';
		case 1:
			return 'python';
		case 2:
			return 'tcl';
		case 3:
			return 'ruby';
		case 4:
			return 'c';
		case 6:
			return 'java';
		default:
			return 'go';
	}
};
var $author$project$Model$Language$asBundlesNamespace = A2($elm$core$Basics$composeR, $author$project$Model$Language$toString, $author$project$Model$Namespace$addBundlesPrefix);
var $author$project$Model$IngredientSearchResult$SearchResult = F2(
	function (ingredient, versions) {
		return {cW: ingredient, e$: versions};
	});
var $author$project$Model$IngredientSearchResult$Simple = $elm$core$Basics$identity;
var $author$project$Model$IngredientSearchResult$SimpleInfo = F6(
	function (allowWithExperimentalAccess, isIndemnified, link, key, version, licenses) {
		return {xb: allowWithExperimentalAccess, Dm: isIndemnified, Y: key, go: licenses, D1: link, aI: version};
	});
var $author$project$Model$Ingredient$Ingredient = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Model$IngredientVersion$IngredientVersion = $elm$core$Basics$identity;
var $author$project$Model$IngredientVersion$Metadata = F7(
	function (ingredientId, key, version, isIndemnified, licenses, dependencies, features) {
		return {lt: dependencies, lT: features, uf: ingredientId, Dm: isIndemnified, Y: key, go: licenses, aI: version};
	});
var $author$project$Model$IngredientVersion$Dependency = F2(
	function (namespace, feature) {
		return {d: feature, aE: namespace};
	});
var $author$project$Model$IngredientVersion$decodeDependency = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'feature',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'namespace',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Model$IngredientVersion$Dependency)));
var $author$project$Model$IngredientVersion$Feature = F2(
	function (namespace, feature) {
		return {d: feature, aE: namespace};
	});
var $author$project$Model$IngredientVersion$decodeFeature = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'feature',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'namespace',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Model$IngredientVersion$Feature)));
var $author$project$Model$IngredientVersion$decodeFeatures = A2(
	$elm$json$Json$Decode$map,
	$elm_community$dict_extra$Dict$Extra$fromListBy(
		function ($) {
			return $.d;
		}),
	$elm$json$Json$Decode$list($author$project$Model$IngredientVersion$decodeFeature));
var $author$project$Model$IngredientVersion$decodeLicenses = A2(
	$elm$json$Json$Decode$map,
	$author$project$Model$IngredientVersion$parseLicenses,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'scanner_license_expression',
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'license_expression',
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'activestate_license_expression',
				$elm$json$Json$Decode$string,
				'',
				$elm$json$Json$Decode$succeed(
					F3(
						function (a, b, c) {
							return _List_fromArray(
								[a, b, c]);
						}))))));
var $author$project$Model$IngredientVersion$decode = function (key) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Basics$identity,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'provided_features',
			$author$project$Model$IngredientVersion$decodeFeatures,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'dependencies',
				$elm$json$Json$Decode$list($author$project$Model$IngredientVersion$decodeDependency),
				_List_Nil,
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
					$author$project$Model$IngredientVersion$decodeLicenses,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'is_indemnified',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'version',
							$elm$json$Json$Decode$string,
							A2(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
								key,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'ingredient_id',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Model$IngredientVersion$Metadata)))))))));
};
var $author$project$Model$Ingredient$Metadata = F5(
	function (ingredient_id, name, website_uri, description, namespace) {
		return {bP: description, bT: ingredient_id, w: name, aE: namespace, G9: website_uri};
	});
var $author$project$Model$Ingredient$decodeMetadata = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'primary_namespace',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'description',
		$elm$json$Json$Decode$string,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'website',
			$elm$json$Json$Decode$string,
			'',
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'normalized_name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'ingredient_id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Model$Ingredient$Metadata))))));
var $author$project$Model$Ingredient$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (metadata) {
		return A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'latest_version',
			$author$project$Model$IngredientVersion$decode(
				$author$project$Model$Namespace$key(metadata)),
			$elm$json$Json$Decode$succeed(
				$author$project$Model$Ingredient$Ingredient(metadata)));
	},
	A2($elm$json$Json$Decode$field, 'ingredient', $author$project$Model$Ingredient$decodeMetadata));
var $author$project$Model$PagedResult$tuple5 = F5(
	function (v, w, x, y, z) {
		return _Utils_Tuple3(
			v,
			w,
			_Utils_Tuple3(x, y, z));
	});
var $author$project$Model$PagedResult$decodeLinks = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'self',
	$elm$json$Json$Decode$string,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'previous',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'next',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'last',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'first',
					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					$elm$json$Json$Decode$succeed($author$project$Model$PagedResult$tuple5))))));
var $author$project$Model$PagedResult$tuple4 = F4(
	function (w, x, y, z) {
		return _Utils_Tuple3(
			w,
			x,
			_Utils_Tuple2(y, z));
	});
var $author$project$Model$PagedResult$decodePaging = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'offset',
	$elm$json$Json$Decode$int,
	0,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'limit',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'item_count',
			$elm$json$Json$Decode$int,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'available_count',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$int),
				$elm$core$Maybe$Nothing,
				$elm$json$Json$Decode$succeed($author$project$Model$PagedResult$tuple4)))));
var $author$project$Model$PagedResult$tuple3 = F3(
	function (x, y, z) {
		return _Utils_Tuple3(x, y, z);
	});
var $author$project$Model$PagedResult$decodePagedResult = F2(
	function (payloadFieldName, payloadDecoder) {
		return A2(
			$elm$json$Json$Decode$map,
			function (_v0) {
				var links = _v0.a;
				var paging = _v0.b;
				var payloadList = _v0.c;
				var _v1 = links;
				var first = _v1.a;
				var last = _v1.b;
				var _v2 = _v1.c;
				var next = _v2.a;
				var previous = _v2.b;
				var self = _v2.c;
				var _v3 = paging;
				var available_count = _v3.a;
				var item_count = _v3.b;
				var _v4 = _v3.c;
				var limit = _v4.a;
				var offset = _v4.b;
				return {xi: available_count, ym: first, yS: item_count, y_: last, ux: limit, zo: next, uR: offset, vQ: payloadList, zH: previous, z1: self};
			},
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				payloadFieldName,
				$elm$json$Json$Decode$list(payloadDecoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'paging',
					$author$project$Model$PagedResult$decodePaging,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'links',
						$author$project$Model$PagedResult$decodeLinks,
						$elm$json$Json$Decode$succeed($author$project$Model$PagedResult$tuple3)))));
	});
var $author$project$Model$Ingredient$key = function (_v0) {
	var ingredient = _v0.a;
	return _Utils_Tuple2(ingredient.aE, ingredient.w);
};
var $author$project$Model$IngredientSearchResult$decode = function () {
	var decodeSimpleVersion = function (key) {
		return A2(
			$elm$json$Json$Decode$map,
			$elm$core$Basics$identity,
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				$author$project$Model$IngredientVersion$decodeLicenses,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'version',
					$elm$json$Json$Decode$string,
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
						key,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'link',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'is_indemnified',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'allow_with_experimental_access',
									$elm$json$Json$Decode$bool,
									$elm$json$Json$Decode$succeed($author$project$Model$IngredientSearchResult$SimpleInfo))))))));
	};
	var decodeSingle = A2(
		$elm$json$Json$Decode$andThen,
		function (ingredient) {
			var key = $author$project$Model$Ingredient$key(ingredient);
			return A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'versions',
				$elm$json$Json$Decode$list(
					decodeSimpleVersion(key)),
				$elm$json$Json$Decode$succeed(
					$author$project$Model$IngredientSearchResult$SearchResult(ingredient)));
		},
		$author$project$Model$Ingredient$decode);
	return A2($author$project$Model$PagedResult$decodePagedResult, 'ingredients', decodeSingle);
}();
var $author$project$Model$IngredientSearchResult$dictFromSearch = function (results) {
	return A2(
		$elm_community$dict_extra$Dict$Extra$fromListBy,
		$author$project$Model$Ingredient$key,
		A2(
			$elm$core$List$map,
			function ($) {
				return $.cW;
			},
			results.vQ));
};
var $author$project$Request$Ingredient$bundles = F2(
	function (maybeAtTime, language) {
		return $author$project$Http$Extra$get(
			{
				iO: $author$project$Http$Extra$None,
				sY: $author$project$Http$Extra$emptyBody,
				qN: A2($elm$json$Json$Decode$map, $author$project$Model$IngredientSearchResult$dictFromSearch, $author$project$Model$IngredientSearchResult$decode),
				CN: _List_Nil,
				GT: A2(
					$elm$url$Url$Builder$absolute,
					_List_fromArray(
						[$author$project$Request$Ingredient$baseUrl, 'ingredients', 'search']),
					A3(
						$author$project$Request$Ingredient$addPosix,
						'state_at',
						maybeAtTime,
						_List_fromArray(
							[
								A2($elm$url$Url$Builder$string, 'limit', '100'),
								A2(
								$elm$url$Url$Builder$string,
								'namespaces',
								$author$project$Model$Language$asBundlesNamespace(language))
							])))
			});
	});
var $author$project$Model$Session$isSuperUser = A2($elm$core$Basics$composeR, $author$project$Model$Session$getUser, $author$project$Model$User$isSuperUser);
var $author$project$Model$Session$isSuperUserWithFeaturesVisible = function (session) {
	return $author$project$Model$Session$isSuperUser(session) && $author$project$Model$Session$getSuperUserFeaturesVisible(session);
};
var $author$project$Model$AddOns$isEnabled = F2(
	function (addonName, addons) {
		var _v0 = A2($elm$core$Dict$get, addonName, addons);
		if (!_v0.$) {
			var addon = _v0.a;
			return addon.Cp;
		} else {
			return false;
		}
	});
var $author$project$Model$Organization$addOnEnabled = F2(
	function (addOn, org) {
		return A2($author$project$Model$AddOns$isEnabled, addOn, org.sP);
	});
var $author$project$Model$Permissions$orgCanAccessAS47039PatchedPerl = $author$project$Model$Organization$addOnEnabled('as_cve_47039_47039_patched_perl');
var $author$project$Model$Permissions$orgCanAccessASPatchedPerl = $author$project$Model$Organization$addOnEnabled('as_patched_perl');
var $author$project$Model$Permissions$orgCanAccessASPatchedPython27 = $author$project$Model$Organization$addOnEnabled('as_patched_python');
var $author$project$Model$Permissions$orgCanAccessASPatchedPython37 = $author$project$Model$Organization$addOnEnabled('as_patched_python_37');
var $author$project$Model$Permissions$orgCanAccessASPatchedTcl = $author$project$Model$Organization$addOnEnabled('as_patched_tcl');
var $author$project$Model$Permissions$orgCanAccessCommunityEolVersions = function (language) {
	var addOn = function () {
		switch (language) {
			case 0:
				return 'community_eol_perl';
			case 1:
				return 'community_eol_python';
			case 3:
				return 'community_eol_ruby';
			case 2:
				return 'community_eol_tcl';
			default:
				return 'no_dice';
		}
	}();
	return $author$project$Model$Organization$addOnEnabled(addOn);
};
var $author$project$Model$Permissions$orgCanAccessExperimentalLanguageFeatures = $author$project$Model$Organization$addOnEnabled('experimental_language_features');
var $author$project$Model$Permissions$orgCanAccessPaidTierVersions = $author$project$Model$Organization$addOnEnabled('paid_tier_language_versions');
var $author$project$Model$LanguageVersions$createAccessModel = F2(
	function (session, org) {
		return {
			xy: $author$project$Model$Permissions$orgCanAccessAS47039PatchedPerl(org),
			s1: $author$project$Model$Permissions$orgCanAccessASPatchedPerl(org),
			s2: $author$project$Model$Permissions$orgCanAccessASPatchedPython27(org),
			s3: $author$project$Model$Permissions$orgCanAccessASPatchedPython37(org),
			s4: $author$project$Model$Permissions$orgCanAccessASPatchedTcl(org),
			s5: A2($author$project$Model$Permissions$orgCanAccessCommunityEolVersions, 0, org),
			s6: A2($author$project$Model$Permissions$orgCanAccessCommunityEolVersions, 1, org),
			s7: A2($author$project$Model$Permissions$orgCanAccessCommunityEolVersions, 3, org),
			s8: A2($author$project$Model$Permissions$orgCanAccessCommunityEolVersions, 2, org),
			s9: $author$project$Model$Permissions$orgCanAccessExperimentalLanguageFeatures(org),
			qx: $author$project$Model$Permissions$orgCanAccessPaidTierVersions(org),
			rj: $author$project$Model$Session$isSuperUser(session),
			oS: $author$project$Model$Session$isSuperUserWithFeaturesVisible(session),
			dc: $author$project$Model$Tier$stringToSimpleTier(org.dc)
		};
	});
var $author$project$Views$PlatformSelectorSimple$Linux = 1;
var $author$project$Views$PlatformSelectorSimple$MacOS = 2;
var $author$project$Views$PlatformSelectorSimple$PlatformChoice = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $author$project$Views$PlatformSelectorSimple$PlatformSelection = $elm$core$Basics$identity;
var $author$project$Views$PlatformSelectorSimple$Windows = 0;
var $author$project$Model$LanguageVersions$forbiddenOnMac = _List_fromArray(
	[2]);
var $author$project$Model$LanguageVersions$isMacAllowed = function (_v0) {
	var language = _v0.a;
	return !A2($elm$core$List$member, language, $author$project$Model$LanguageVersions$forbiddenOnMac);
};
var $author$project$Views$PlatformSelectorSimple$default = F2(
	function (languageSelection, userPlatform) {
		var macAvailable = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Model$LanguageVersions$isMacAllowed, languageSelection));
		return {
			hz: A4($author$project$Views$PlatformSelectorSimple$PlatformChoice, 1, 'Ubuntu', '20.10 groovy', userPlatform === 1),
			gq: A4($author$project$Views$PlatformSelectorSimple$PlatformChoice, 2, 'MacOS', '13 Ventura', (userPlatform === 2) && macAvailable),
			hZ: A4($author$project$Views$PlatformSelectorSimple$PlatformChoice, 0, 'Windows', '10', !userPlatform)
		};
	});
var $author$project$Request$Organization$getOrg = F3(
	function (orgIdentifier, identifierType, creds) {
		return $author$project$Http$Extra$get(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$emptyBody,
				qN: $author$project$Model$Organization$decode,
				CN: _List_Nil,
				GT: '/organizations/' + (orgIdentifier + ('?identifierType=' + identifierType))
			});
	});
var $author$project$Request$Organization$get = F2(
	function (orgName, creds) {
		return A3($author$project$Request$Organization$getOrg, orgName, 'URLname', creds);
	});
var $author$project$Request$Ingredient$latestTimestamp = $author$project$Http$Extra$get(
	{
		iO: $author$project$Http$Extra$None,
		sY: $author$project$Http$Extra$emptyBody,
		qN: A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'timestamp',
			$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
			$elm$json$Json$Decode$succeed($elm$core$Basics$identity)),
		CN: _List_Nil,
		GT: A2(
			$elm$url$Url$Builder$absolute,
			_List_fromArray(
				[$author$project$Request$Ingredient$baseUrl, 'latest-timestamp']),
			_List_Nil)
	});
var $author$project$Task$IngredientLatestTimestamp$getLatestTimestamp = A2(
	$elm$core$Task$onError,
	$elm$core$Basics$always($elm$time$Time$now),
	$author$project$Request$Ingredient$latestTimestamp);
var $author$project$Model$LanguageVersions$LanguageVersions = $elm$core$Basics$identity;
var $author$project$Model$IngredientVersion$version = function (_v0) {
	var m = _v0;
	return m.aI;
};
var $author$project$Model$Ingredient$getVersion = function (_v0) {
	var version = _v0.b;
	return $author$project$Model$IngredientVersion$version(version);
};
var $author$project$Model$Ingredient$id = function (_v0) {
	var ingredient = _v0.a;
	return ingredient.bT;
};
var $author$project$Model$Ingredient$name = function (_v0) {
	var ingredient = _v0.a;
	return ingredient.w;
};
var $author$project$Model$LanguageVersions$decode = function () {
	var mapSingle = function (_v0) {
		var ingredient = _v0.cW;
		var versions = _v0.e$;
		return {
			l6: $author$project$Model$Ingredient$id(ingredient),
			y8: $author$project$Model$Language$fromString(
				$author$project$Model$Ingredient$name(ingredient)),
			w: $author$project$Model$Ingredient$name(ingredient),
			jw: $author$project$Model$Ingredient$getVersion(ingredient),
			e$: versions
		};
	};
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$List$map(mapSingle),
		A2(
			$elm$json$Json$Decode$map,
			function ($) {
				return $.vQ;
			},
			$author$project$Model$IngredientSearchResult$decode));
}();
var $author$project$Request$Ingredient$languages = function (maybeAtTime) {
	return $author$project$Http$Extra$get(
		{
			iO: $author$project$Http$Extra$None,
			sY: $author$project$Http$Extra$emptyBody,
			qN: $author$project$Model$LanguageVersions$decode,
			CN: _List_Nil,
			GT: A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[$author$project$Request$Ingredient$baseUrl, 'ingredients', 'search']),
				A3(
					$author$project$Request$Ingredient$addPosix,
					'state_at',
					maybeAtTime,
					_List_fromArray(
						[
							A2($elm$url$Url$Builder$string, 'limit', '100'),
							A2($elm$url$Url$Builder$string, 'namespaces', $author$project$Model$Namespace$language)
						])))
		});
};
var $author$project$Model$Permissions$orgCanCreatePrivateProject = $author$project$Model$Organization$addOnEnabled('private_projects');
var $author$project$Model$Permissions$orgCanPackageInstaller = $author$project$Model$Organization$addOnEnabled('self_serve_installers');
var $author$project$Model$IngredientSearchResult$getVersion = function (resultVersion) {
	var info = resultVersion;
	return info.aI;
};
var $author$project$Model$LanguageVersions$getVersion = F2(
	function (contents, version) {
		return A2(
			$elm_community$list_extra$List$Extra$find,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Model$IngredientSearchResult$getVersion,
				$elm$core$Basics$eq(version)),
			contents.e$);
	});
var $author$project$Model$LanguageVersions$getVersionsRaw = function (contents) {
	return A2($elm$core$List$map, $author$project$Model$IngredientSearchResult$getVersion, contents.e$);
};
var $author$project$Model$VersionString$Version = F4(
	function (major, minor, patch, activePatch) {
		return {A_: activePatch, y5: major, Ej: minor, gw: patch};
	});
var $author$project$Model$VersionString$new = F3(
	function (a, b, c) {
		return A4($author$project$Model$VersionString$Version, a, b, c, $elm$core$Maybe$Nothing);
	});
var $author$project$Model$LanguageVersions$Perl$supportDict = {
	qk: $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				['5.36.3.3', '5.36.3.2', '5.34.3.3', '5.34.3.2']),
				_List_fromArray(
				['5.32.1.2', '5.32.1.1']),
				_List_fromArray(
				['5.28.3.2', '5.26.3.1']),
				_List_fromArray(
				['5.34.0', '5.34.1', '5.34.3']),
				_List_fromArray(
				['5.36.0', '5.36.1', '5.36.3']),
				_List_fromArray(
				['5.38.0', '5.38.2', '5.38.3', '5.38.4']),
				_List_fromArray(
				['5.40.0', '5.40.1', '5.40.2', '5.40.4']),
				_List_fromArray(
				['5.42.2'])
			])),
	E3: _List_fromArray(
		['5.36.1']),
	hO: A3($author$project$Model$VersionString$new, 5, 42, 3),
	sy: $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				['5.36.3.4', '5.36.3.3', '5.36.3.2', '5.34.3.4', '5.34.3.3', '5.34.3.2']),
				_List_fromArray(
				['5.32.1.2', '5.32.1.1']),
				_List_fromArray(
				['5.28.3.2', '5.26.3.1']),
				_List_fromArray(
				['5.34.0', '5.34.1', '5.34.3']),
				_List_fromArray(
				['5.36.0', '5.36.1', '5.36.3']),
				_List_fromArray(
				['5.38.0', '5.38.2', '5.38.3', '5.38.4', '5.38.5']),
				_List_fromArray(
				['5.40.0', '5.40.1', '5.40.2', '5.40.4', '5.40.5']),
				_List_fromArray(
				['5.42.2', '5.42.3']),
				_List_fromArray(
				['5.44.0'])
			])),
	sG: _List_Nil,
	sH: $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				['5.24.3.1', '5.22.4.1']),
				_List_fromArray(
				['5.8.0', '5.8.1', '5.8.2', '5.8.3', '5.8.4', '5.8.5', '5.8.6', '5.8.7', '5.8.8', '5.8.9']),
				_List_fromArray(
				['5.10.1']),
				_List_fromArray(
				['5.12.0', '5.12.1', '5.12.2', '5.12.3', '5.12.4', '5.12.5']),
				_List_fromArray(
				['5.14.4', '5.16.3', '5.18.4', '5.20.3', '5.22.4', '5.24.3', '5.26.2'])
			]))
};
var $author$project$Model$LanguageVersions$Python$supportDict = {
	qk: $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				['2.7.18.7', '2.7.18.8', '2.7.18.9', '2.7.18.10', '2.7.18.11', '2.7.18.13']),
				_List_fromArray(
				['3.7.17.3', '3.7.17.5', '3.7.17.6']),
				_List_fromArray(
				['2.7.18']),
				_List_fromArray(
				['3.8.2', '3.8.7', '3.8.8', '3.8.9', '3.8.10', '3.8.11', '3.8.12', '3.8.13', '3.8.14', '3.8.15', '3.8.16', '3.8.17', '3.8.18', '3.8.19', '3.8.20', '3.8.21']),
				_List_fromArray(
				['3.9.2', '3.9.4', '3.9.5', '3.9.6', '3.9.7', '3.9.9', '3.9.10', '3.9.12', '3.9.13', '3.9.14', '3.9.15', '3.9.16', '3.9.17', '3.9.18', '3.9.19', '3.9.20', '3.9.21', '3.9.22']),
				_List_fromArray(
				['3.10.0', '3.10.1', '3.10.2', '3.10.4', '3.10.5', '3.10.6', '3.10.7', '3.10.8', '3.10.10', '3.10.11', '3.10.12', '3.10.13', '3.10.14', '3.10.15', '3.10.16', '3.10.17', '3.10.20']),
				_List_fromArray(
				['3.11.0', '3.11.1', '3.11.2', '3.11.3', '3.11.4', '3.11.5', '3.11.6', '3.11.7', '3.11.8', '3.11.9', '3.11.10', '3.11.11', '3.11.12', '3.11.15']),
				_List_fromArray(
				['3.12.0', '3.12.3', '3.12.4', '3.12.6', '3.12.7', '3.12.8', '3.12.10', '3.12.13']),
				_List_fromArray(
				['3.13.0', '3.13.3'])
			])),
	E3: _List_fromArray(
		['3.8.10', '3.8.21', '3.9.25', '3.10.21', '3.11.16', '3.11.18', '3.12.7']),
	hO: A3($author$project$Model$VersionString$new, 3, 13, 18),
	sy: $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				['2.7.18.6', '2.7.18.7', '2.7.18.8', '2.7.18.9', '2.7.18.10', '2.7.18.11', '2.7.18.13', '2.7.18.14']),
				_List_fromArray(
				['3.7.17.3', '3.7.17.5', '3.7.17.6', '3.7.17.7']),
				_List_fromArray(
				['3.8.20.1', '3.8.20.2']),
				_List_fromArray(
				['2.7.18']),
				_List_fromArray(
				['3.8.2', '3.8.7', '3.8.8', '3.8.9', '3.8.10', '3.8.11', '3.8.12', '3.8.13', '3.8.14', '3.8.15', '3.8.16', '3.8.17', '3.8.18', '3.8.19', '3.8.20', '3.8.21']),
				_List_fromArray(
				['3.9.2', '3.9.4', '3.9.5', '3.9.6', '3.9.7', '3.9.9', '3.9.10', '3.9.12', '3.9.13', '3.9.14', '3.9.15', '3.9.16', '3.9.17', '3.9.18', '3.9.19', '3.9.20', '3.9.21', '3.9.22', '3.9.25']),
				_List_fromArray(
				['3.10.0', '3.10.1', '3.10.2', '3.10.4', '3.10.5', '3.10.6', '3.10.7', '3.10.8', '3.10.10', '3.10.11', '3.10.12', '3.10.13', '3.10.14', '3.10.15', '3.10.16', '3.10.17', '3.10.20', '3.10.21']),
				_List_fromArray(
				['3.11.0', '3.11.1', '3.11.2', '3.11.3', '3.11.4', '3.11.5', '3.11.6', '3.11.7', '3.11.8', '3.11.9', '3.11.10', '3.11.11', '3.11.12', '3.11.15', '3.11.16', '3.11.18']),
				_List_fromArray(
				['3.12.0', '3.12.3', '3.12.4', '3.12.6', '3.12.7', '3.12.8', '3.12.10', '3.12.13', '3.12.14', '3.12.16']),
				_List_fromArray(
				['3.13.0', '3.13.3', '3.13.13', '3.13.14', '3.13.15', '3.13.18']),
				_List_fromArray(
				['3.14.4', '3.14.7', '3.14.10'])
			])),
	sG: _List_Nil,
	sH: $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				['2.7.14', '2.7.16', '2.7.17']),
				_List_fromArray(
				['3.4.0', '3.4.1', '3.4.2', '3.4.3', '3.4.4', '3.4.5', '3.4.6', '3.4.7', '3.4.8']),
				_List_fromArray(
				['3.5.4', '3.6.6']),
				_List_fromArray(
				['3.7.0', '3.7.1', '3.7.4'])
			]))
};
var $author$project$Model$LanguageVersions$Ruby$supportDict = {
	qk: $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				['3.1.1', '3.1.2', '3.1.3', '3.1.4']),
				_List_fromArray(
				['3.2.0', '3.2.1', '3.2.2', '3.2.3']),
				_List_fromArray(
				['3.3.0'])
			])),
	E3: $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				['3.1.0', '3.1.1', '3.1.2', '3.1.3', '3.1.4', '3.1.5', '3.1.6', '3.1.7', '3.1.8', '3.1.9', '3.1.10', '3.1.11', '3.1.12', '3.1.13', '3.1.14', '3.1.15']),
				_List_fromArray(
				['3.2.0', '3.2.1', '3.2.2', '3.2.3', '3.2.4', '3.2.5', '3.2.6', '3.2.7', '3.2.8', '3.2.9', '3.2.10', '3.2.11', '3.2.12', '3.2.13', '3.2.14', '3.2.15'])
			])),
	hO: A3($author$project$Model$VersionString$new, 3, 3, 1),
	sy: $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				['3.1.0', '3.1.1', '3.1.2', '3.1.3', '3.1.4', '3.1.5']),
				_List_fromArray(
				['3.2.0', '3.2.1', '3.2.2', '3.2.3', '3.2.4']),
				_List_fromArray(
				['3.3.0', '3.3.1'])
			])),
	sG: _List_Nil,
	sH: _List_fromArray(
		['2.7.5', '2.7.6', '2.7.7', '2.7.8'])
};
var $author$project$Model$LanguageVersions$Tcl$supportDict = {
	qk: _List_Nil,
	E3: _List_fromArray(
		['8.6.11', '8.6.12', '8.6.13']),
	hO: A3($author$project$Model$VersionString$new, 8, 6, 14),
	sy: $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				['8.6.11.1']),
				_List_fromArray(
				['8.6.10', '8.6.11', '8.6.12', '8.6.13', '8.6.14'])
			])),
	sG: _List_Nil,
	sH: $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				['8.4.0', '8.4.1', '8.4.2', '8.4.3', '8.4.4', '8.4.5', '8.4.6', '8.4.7', '8.4.8', '8.4.9', '8.4.10', '8.4.11', '8.4.12', '8.4.13', '8.4.14', '8.4.15', '8.4.16', '8.4.17', '8.4.18', '8.4.19', '8.4.20']),
				_List_fromArray(
				['8.5.18', '8.5.19']),
				_List_fromArray(
				['8.6.6', '8.6.8', '8.6.9', '8.6.10'])
			]))
};
var $author$project$Model$VersionString$toString = function (v) {
	return A2(
		$elm$core$String$join,
		'.',
		A2(
			$elm$core$List$filterMap,
			$elm$core$Maybe$map($elm$core$String$fromInt),
			_List_fromArray(
				[
					$elm$core$Maybe$Just(v.y5),
					$elm$core$Maybe$Just(v.Ej),
					$elm$core$Maybe$Just(v.gw),
					v.A_
				])));
};
var $author$project$Model$LanguageVersions$recommendedVersions = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'perl',
			$author$project$Model$VersionString$toString($author$project$Model$LanguageVersions$Perl$supportDict.hO)),
			_Utils_Tuple2(
			'python',
			$author$project$Model$VersionString$toString($author$project$Model$LanguageVersions$Python$supportDict.hO)),
			_Utils_Tuple2(
			'tcl',
			$author$project$Model$VersionString$toString($author$project$Model$LanguageVersions$Tcl$supportDict.hO)),
			_Utils_Tuple2(
			'ruby',
			$author$project$Model$VersionString$toString($author$project$Model$LanguageVersions$Ruby$supportDict.hO))
		]));
var $author$project$Model$LanguageVersions$defaultVersion = function (_v0) {
	var languageVersions = _v0;
	var _default = A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$core$List$head(
			$author$project$Model$LanguageVersions$getVersionsRaw(languageVersions)));
	var newSelected = A2(
		$elm$core$Maybe$withDefault,
		_default,
		A2(
			$elm$core$Maybe$map,
			$author$project$Model$IngredientSearchResult$getVersion,
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Model$LanguageVersions$getVersion(languageVersions),
				A2($elm$core$Dict$get, languageVersions.w, $author$project$Model$LanguageVersions$recommendedVersions))));
	return _Utils_update(
		languageVersions,
		{jw: newSelected});
};
var $author$project$Model$LanguageVersions$SupportDict$requiresPaid = F2(
	function (dict, version) {
		return A2($elm$core$List$member, version, dict.E3);
	});
var $author$project$Model$LanguageVersions$hasPaidEnough = F3(
	function (accessModel, languageVerSupportDic, version) {
		return accessModel.qx || (!A2($author$project$Model$LanguageVersions$SupportDict$requiresPaid, languageVerSupportDic, version));
	});
var $author$project$Model$VersionString$int = A2(
	$elm$parser$Parser$andThen,
	function (value) {
		var _v0 = $elm$core$String$toInt(value);
		if (!_v0.$) {
			var v = _v0.a;
			return $elm$parser$Parser$succeed(v);
		} else {
			return $elm$parser$Parser$problem('I expected to see a digit here');
		}
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
var $elm$parser$Parser$ExpectingInt = {$: 1};
var $elm$parser$Parser$Advanced$consumeBase = _Parser_consumeBase;
var $elm$parser$Parser$Advanced$consumeBase16 = _Parser_consumeBase16;
var $elm$parser$Parser$Advanced$bumpOffset = F2(
	function (newOffset, s) {
		return {xG: s.xG + (newOffset - s.uR), bL: s.bL, cy: s.cy, uR: newOffset, hP: s.hP, fG: s.fG};
	});
var $elm$parser$Parser$Advanced$chompBase10 = _Parser_chompBase10;
var $elm$parser$Parser$Advanced$isAsciiCode = _Parser_isAsciiCode;
var $elm$parser$Parser$Advanced$consumeExp = F2(
	function (offset, src) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 101, offset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 69, offset, src)) {
			var eOffset = offset + 1;
			var expOffset = (A3($elm$parser$Parser$Advanced$isAsciiCode, 43, eOffset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 45, eOffset, src)) ? (eOffset + 1) : eOffset;
			var newOffset = A2($elm$parser$Parser$Advanced$chompBase10, expOffset, src);
			return _Utils_eq(expOffset, newOffset) ? (-newOffset) : newOffset;
		} else {
			return offset;
		}
	});
var $elm$parser$Parser$Advanced$consumeDotAndExp = F2(
	function (offset, src) {
		return A3($elm$parser$Parser$Advanced$isAsciiCode, 46, offset, src) ? A2(
			$elm$parser$Parser$Advanced$consumeExp,
			A2($elm$parser$Parser$Advanced$chompBase10, offset + 1, src),
			src) : A2($elm$parser$Parser$Advanced$consumeExp, offset, src);
	});
var $elm$parser$Parser$Advanced$finalizeInt = F5(
	function (invalid, handler, startOffset, _v0, s) {
		var endOffset = _v0.a;
		var n = _v0.b;
		if (handler.$ === 1) {
			var x = handler.a;
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A2($elm$parser$Parser$Advanced$fromState, s, x));
		} else {
			var toValue = handler.a;
			return _Utils_eq(startOffset, endOffset) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				_Utils_cmp(s.uR, startOffset) < 0,
				A2($elm$parser$Parser$Advanced$fromState, s, invalid)) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				toValue(n),
				A2($elm$parser$Parser$Advanced$bumpOffset, endOffset, s));
		}
	});
var $elm$parser$Parser$Advanced$fromInfo = F4(
	function (row, col, x, context) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, row, col, x, context));
	});
var $elm$parser$Parser$Advanced$finalizeFloat = F6(
	function (invalid, expecting, intSettings, floatSettings, intPair, s) {
		var intOffset = intPair.a;
		var floatOffset = A2($elm$parser$Parser$Advanced$consumeDotAndExp, intOffset, s.fG);
		if (floatOffset < 0) {
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A4($elm$parser$Parser$Advanced$fromInfo, s.hP, s.xG - (floatOffset + s.uR), invalid, s.bL));
		} else {
			if (_Utils_eq(s.uR, floatOffset)) {
				return A2(
					$elm$parser$Parser$Advanced$Bad,
					false,
					A2($elm$parser$Parser$Advanced$fromState, s, expecting));
			} else {
				if (_Utils_eq(intOffset, floatOffset)) {
					return A5($elm$parser$Parser$Advanced$finalizeInt, invalid, intSettings, s.uR, intPair, s);
				} else {
					if (floatSettings.$ === 1) {
						var x = floatSettings.a;
						return A2(
							$elm$parser$Parser$Advanced$Bad,
							true,
							A2($elm$parser$Parser$Advanced$fromState, s, invalid));
					} else {
						var toValue = floatSettings.a;
						var _v1 = $elm$core$String$toFloat(
							A3($elm$core$String$slice, s.uR, floatOffset, s.fG));
						if (_v1.$ === 1) {
							return A2(
								$elm$parser$Parser$Advanced$Bad,
								true,
								A2($elm$parser$Parser$Advanced$fromState, s, invalid));
						} else {
							var n = _v1.a;
							return A3(
								$elm$parser$Parser$Advanced$Good,
								true,
								toValue(n),
								A2($elm$parser$Parser$Advanced$bumpOffset, floatOffset, s));
						}
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$number = function (c) {
	return function (s) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 48, s.uR, s.fG)) {
			var zeroOffset = s.uR + 1;
			var baseOffset = zeroOffset + 1;
			return A3($elm$parser$Parser$Advanced$isAsciiCode, 120, zeroOffset, s.fG) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.C0,
				c.CP,
				baseOffset,
				A2($elm$parser$Parser$Advanced$consumeBase16, baseOffset, s.fG),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 111, zeroOffset, s.fG) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.C0,
				c.zt,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 8, baseOffset, s.fG),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 98, zeroOffset, s.fG) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.C0,
				c.xo,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 2, baseOffset, s.fG),
				s) : A6(
				$elm$parser$Parser$Advanced$finalizeFloat,
				c.C0,
				c.yh,
				c.yI,
				c.yn,
				_Utils_Tuple2(zeroOffset, 0),
				s)));
		} else {
			return A6(
				$elm$parser$Parser$Advanced$finalizeFloat,
				c.C0,
				c.yh,
				c.yI,
				c.yn,
				A3($elm$parser$Parser$Advanced$consumeBase, 10, s.uR, s.fG),
				s);
		}
	};
};
var $elm$parser$Parser$Advanced$int = F2(
	function (expecting, invalid) {
		return $elm$parser$Parser$Advanced$number(
			{
				xo: $elm$core$Result$Err(invalid),
				yh: expecting,
				yn: $elm$core$Result$Err(invalid),
				CP: $elm$core$Result$Err(invalid),
				yI: $elm$core$Result$Ok($elm$core$Basics$identity),
				C0: invalid,
				zt: $elm$core$Result$Err(invalid)
			});
	});
var $elm$parser$Parser$int = A2($elm$parser$Parser$Advanced$int, $elm$parser$Parser$ExpectingInt, $elm$parser$Parser$ExpectingInt);
var $author$project$Model$VersionString$parser = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed($author$project$Model$VersionString$Version),
				A2(
					$elm$parser$Parser$ignorer,
					$author$project$Model$VersionString$int,
					$elm$parser$Parser$symbol('.'))),
			A2(
				$elm$parser$Parser$ignorer,
				$author$project$Model$VersionString$int,
				$elm$parser$Parser$symbol('.'))),
		$author$project$Model$VersionString$int),
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Maybe$Just),
						$elm$parser$Parser$symbol('.')),
					$elm$parser$Parser$int),
					$elm$parser$Parser$succeed($elm$core$Maybe$Nothing)
				])),
		$elm$parser$Parser$end));
var $author$project$Model$VersionString$parse = $elm$parser$Parser$run($author$project$Model$VersionString$parser);
var $author$project$Model$VersionString$toVersion = A2($elm$core$Basics$composeR, $author$project$Model$VersionString$parse, $elm$core$Result$toMaybe);
var $author$project$Model$VersionString$isASPatched = function (version) {
	var _v0 = $author$project$Model$VersionString$toVersion(version);
	if (!_v0.$) {
		var activePatch = _v0.a.A_;
		return $elm_community$maybe_extra$Maybe$Extra$isJust(activePatch);
	} else {
		return false;
	}
};
var $author$project$Model$VersionPredicates$Perl$isEol = A2(
	$elm$core$Basics$composeR,
	$author$project$Model$VersionString$parse,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Result$map(
			function (v) {
				return v.Ej <= 32;
			}),
		$elm$core$Result$withDefault(false)));
var $author$project$Model$VersionPredicates$Python$isEol = A2(
	$elm$core$Basics$composeR,
	$author$project$Model$VersionString$parse,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Result$map(
			function (v) {
				return (v.y5 === 2) || ((v.y5 === 3) && (v.Ej <= 7));
			}),
		$elm$core$Result$withDefault(false)));
var $author$project$Model$VersionPredicates$Ruby$isEol = A2(
	$elm$core$Basics$composeR,
	$author$project$Model$VersionString$parse,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Result$map(
			function (v) {
				return v.Ej < 1;
			}),
		$elm$core$Result$withDefault(false)));
var $author$project$Model$VersionPredicates$Tcl$isEol = A2(
	$elm$core$Basics$composeR,
	$author$project$Model$VersionString$parse,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Result$map(
			function (v) {
				return (v.y5 < 8) || (((v.y5 === 8) && (v.Ej < 6)) || ((v.Ej === 6) && (v.gw <= 10)));
			}),
		$elm$core$Result$withDefault(false)));
var $author$project$Model$LanguageVersions$exposable = function (language) {
	switch (language) {
		case 0:
			return A2(
				$elm$core$List$filter,
				function (v) {
					return !A2($elm$core$List$member, v, $author$project$Model$LanguageVersions$Perl$supportDict.qk);
				},
				$author$project$Model$LanguageVersions$Perl$supportDict.sy);
		case 1:
			return A2(
				$elm$core$List$filter,
				function (v) {
					return !A2($elm$core$List$member, v, $author$project$Model$LanguageVersions$Python$supportDict.qk);
				},
				$author$project$Model$LanguageVersions$Python$supportDict.sy);
		case 3:
			return A2(
				$elm$core$List$filter,
				function (v) {
					return !A2($elm$core$List$member, v, $author$project$Model$LanguageVersions$Ruby$supportDict.qk);
				},
				$author$project$Model$LanguageVersions$Ruby$supportDict.sy);
		case 2:
			return A2(
				$elm$core$List$filter,
				function (v) {
					return !A2($elm$core$List$member, v, $author$project$Model$LanguageVersions$Tcl$supportDict.qk);
				},
				$author$project$Model$LanguageVersions$Tcl$supportDict.sy);
		default:
			return _List_Nil;
	}
};
var $author$project$Model$LanguageVersions$unsupportedLanguageVersions = function (maybeLanguage) {
	_v0$4:
	while (true) {
		if (!maybeLanguage.$) {
			switch (maybeLanguage.a) {
				case 0:
					var _v1 = maybeLanguage.a;
					return $author$project$Model$LanguageVersions$Perl$supportDict.sH;
				case 1:
					var _v2 = maybeLanguage.a;
					return $author$project$Model$LanguageVersions$Python$supportDict.sH;
				case 2:
					var _v3 = maybeLanguage.a;
					return $author$project$Model$LanguageVersions$Tcl$supportDict.sH;
				case 3:
					var _v4 = maybeLanguage.a;
					return $author$project$Model$LanguageVersions$Ruby$supportDict.sH;
				default:
					break _v0$4;
			}
		} else {
			break _v0$4;
		}
	}
	return _List_Nil;
};
var $author$project$Model$LanguageVersions$isExposable = F2(
	function (maybeLanguage, version) {
		var unsupportedVersions = $author$project$Model$LanguageVersions$unsupportedLanguageVersions(maybeLanguage);
		if (!maybeLanguage.$) {
			var language = maybeLanguage.a;
			return A2($elm$core$List$member, version, unsupportedVersions) ? false : A2(
				$elm$core$List$member,
				version,
				$author$project$Model$LanguageVersions$exposable(language));
		} else {
			return false;
		}
	});
var $author$project$Model$LanguageVersions$unstable = function (language) {
	switch (language) {
		case 0:
			return $author$project$Model$LanguageVersions$Perl$supportDict.sG;
		case 1:
			return $author$project$Model$LanguageVersions$Python$supportDict.sG;
		case 3:
			return $author$project$Model$LanguageVersions$Ruby$supportDict.sG;
		case 2:
			return $author$project$Model$LanguageVersions$Tcl$supportDict.sG;
		default:
			return _List_Nil;
	}
};
var $author$project$Model$LanguageVersions$isUnstable = F2(
	function (maybeLanguage, version) {
		if (!maybeLanguage.$) {
			var language = maybeLanguage.a;
			return A2(
				$elm$core$List$member,
				version,
				$author$project$Model$LanguageVersions$unstable(language)) ? true : false;
		} else {
			return false;
		}
	});
var $author$project$Model$IngredientSearchResult$shouldAllowWithExperimentalAccess = function (resultVersion) {
	var info = resultVersion;
	return info.xb;
};
var $author$project$Model$LanguageVersions$isShowable = F3(
	function (accessModel, languageVersions, versionString) {
		var shouldShowBecauseExperimental = F2(
			function (contents, version) {
				return accessModel.s9 && A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						$author$project$Model$IngredientSearchResult$shouldAllowWithExperimentalAccess,
						A2($author$project$Model$LanguageVersions$getVersion, contents, version)));
			});
		var isAllowedWhenTcl = function (version) {
			return A3($author$project$Model$LanguageVersions$hasPaidEnough, accessModel, $author$project$Model$LanguageVersions$Tcl$supportDict, version) && function () {
				var _v11 = _Utils_Tuple2(
					$author$project$Model$VersionPredicates$Tcl$isEol(version),
					$author$project$Model$VersionString$isASPatched(version));
				if (_v11.b) {
					return accessModel.s4;
				} else {
					if (_v11.a) {
						return accessModel.s8;
					} else {
						return true;
					}
				}
			}();
		};
		var isAllowedWhenRuby = function (version) {
			return A3($author$project$Model$LanguageVersions$hasPaidEnough, accessModel, $author$project$Model$LanguageVersions$Ruby$supportDict, version) && ($author$project$Model$VersionPredicates$Ruby$isEol(version) ? accessModel.s7 : true);
		};
		var isAllowedWhenPython = function (version) {
			return (version === '2.7.18') ? false : (A3($author$project$Model$LanguageVersions$hasPaidEnough, accessModel, $author$project$Model$LanguageVersions$Python$supportDict, version) && function () {
				var _v9 = _Utils_Tuple2(
					$author$project$Model$VersionPredicates$Python$isEol(version),
					$author$project$Model$VersionString$isASPatched(version));
				if (_v9.b) {
					return A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							function (v) {
								var _v10 = _Utils_Tuple2(v.y5, v.Ej);
								_v10$2:
								while (true) {
									if (_v10.b === 7) {
										switch (_v10.a) {
											case 2:
												return accessModel.s2;
											case 3:
												return accessModel.s3;
											default:
												break _v10$2;
										}
									} else {
										break _v10$2;
									}
								}
								return true;
							},
							$author$project$Model$VersionString$toVersion(version)));
				} else {
					if (_v9.a) {
						return accessModel.s6;
					} else {
						return true;
					}
				}
			}());
		};
		var isAllowedWhenPerl = function (version) {
			return A3($author$project$Model$LanguageVersions$hasPaidEnough, accessModel, $author$project$Model$LanguageVersions$Perl$supportDict, version) && function () {
				var _v8 = _Utils_Tuple2(
					$author$project$Model$VersionPredicates$Perl$isEol(version),
					$author$project$Model$VersionString$isASPatched(version));
				if (_v8.b) {
					return accessModel.s1;
				} else {
					if (_v8.a) {
						return accessModel.s5;
					} else {
						return true;
					}
				}
			}();
		};
		var hasPaid = accessModel.qx;
		var isAllowedUnderToSLAs = F2(
			function (maybeLanguage, version) {
				return !(hasPaid && A2($author$project$Model$LanguageVersions$isUnstable, maybeLanguage, version));
			});
		return accessModel.oS || (A2(shouldShowBecauseExperimental, languageVersions, versionString) || (A2($author$project$Model$LanguageVersions$isExposable, languageVersions.y8, versionString) && (function () {
			var _v0 = languageVersions.y8;
			if (!_v0.$) {
				switch (_v0.a) {
					case 0:
						var _v1 = _v0.a;
						return isAllowedWhenPerl(versionString);
					case 1:
						var _v2 = _v0.a;
						return isAllowedWhenPython(versionString);
					case 3:
						var _v3 = _v0.a;
						return isAllowedWhenRuby(versionString);
					case 2:
						var _v4 = _v0.a;
						return isAllowedWhenTcl(versionString);
					case 5:
						var _v5 = _v0.a;
						return false;
					case 6:
						var _v6 = _v0.a;
						return false;
					default:
						var _v7 = _v0.a;
						return false;
				}
			} else {
				return true;
			}
		}() && A2(isAllowedUnderToSLAs, languageVersions.y8, versionString))));
	});
var $author$project$Model$LanguageVersions$pruneLanguage = F2(
	function (accessModel, _v0) {
		var languageVersions = _v0;
		var versionIsShowable = A2($author$project$Model$LanguageVersions$isShowable, accessModel, languageVersions);
		var newLanguageVersions = _Utils_update(
			languageVersions,
			{
				e$: A2(
					$elm$core$List$filter,
					A2($elm$core$Basics$composeR, $author$project$Model$IngredientSearchResult$getVersion, versionIsShowable),
					languageVersions.e$)
			});
		return versionIsShowable(languageVersions.jw) ? newLanguageVersions : $author$project$Model$LanguageVersions$defaultVersion(newLanguageVersions);
	});
var $author$project$Model$LanguageVersions$prune = F2(
	function (accessModel, languages) {
		return A2(
			$elm$core$List$map,
			$author$project$Model$LanguageVersions$defaultVersion,
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeL,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$List$isEmpty),
						$author$project$Model$LanguageVersions$getVersionsRaw),
					function (_v0) {
						var contents = _v0;
						return contents;
					}),
				A2(
					$elm$core$List$map,
					$author$project$Model$LanguageVersions$pruneLanguage(accessModel),
					languages)));
	});
var $author$project$Model$LanguageVersions$select = F2(
	function (newVersion, _v0) {
		var language = _v0;
		return A2(
			$elm$core$List$member,
			newVersion,
			$author$project$Model$LanguageVersions$getVersionsRaw(language)) ? $elm$core$Maybe$Just(
			_Utils_update(
				language,
				{jw: newVersion})) : $elm$core$Maybe$Nothing;
	});
var $author$project$Model$Editor$addKeyDict = F5(
	function (getter, setter, key, value, editor) {
		var current = A2($author$project$Model$Editor$getField, getter, editor);
		return A3(
			$author$project$Model$Editor$setField,
			setter,
			A3($elm$core$Dict$insert, key, value, current),
			editor);
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$bundlesGetter = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.FF;
	},
	function ($) {
		return $.k5;
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$bundlesSetter = F2(
	function (bundles, fields) {
		var requirements = fields.FF;
		return _Utils_update(
			fields,
			{
				FF: _Utils_update(
					requirements,
					{k5: bundles})
			});
	});
var $author$project$Model$Editor$setFieldEditor = F3(
	function (setter, fieldEditor, editor) {
		return {
			g5: A2(
				setter,
				$author$project$Model$Editor$getFields(fieldEditor),
				$author$project$Model$Editor$getFields(editor)),
			jl: A2(
				setter,
				$author$project$Model$Editor$getFieldsOriginal(fieldEditor),
				$author$project$Model$Editor$getFieldsOriginal(editor))
		};
	});
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$solveSetter = F2(
	function (solve, fields) {
		return _Utils_update(
			fields,
			{sr: solve});
	});
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$setSolve = $author$project$Model$Editor$setFieldEditor($author$project$Model$BuildPlanner$BuildExprEditor$Simple$solveSetter);
var $author$project$Model$BuildPlanner$SolveLegacyEditor$setBuildExprSolveEditor = F2(
	function (func, editor) {
		return A2(
			$author$project$Model$BuildPlanner$BuildExprEditor$Simple$setSolve,
			A2($author$project$Model$BuildPlanner$SolveLegacyEditor$getBuildExprSolveEditor, func, editor),
			editor);
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$addBundle = function (key) {
	return A2(
		$elm$core$Basics$composeL,
		$author$project$Model$BuildPlanner$SolveLegacyEditor$setBuildExprSolveEditor,
		A3($author$project$Model$Editor$addKeyDict, $author$project$Model$BuildPlanner$SolveLegacyEditor$bundlesGetter, $author$project$Model$BuildPlanner$SolveLegacyEditor$bundlesSetter, key));
};
var $author$project$Pages$CreateProject$defaultSelectedBundleNames = _List_fromArray(
	[
		_Utils_Tuple2(
		$author$project$Model$Language$asBundlesNamespace(0),
		'Utilities')
	]);
var $author$project$Model$BuildExprEditorUtils$fromIngredientVersion = function (ingredient) {
	return A2(
		$author$project$Model$BuildPlanner$BuildExpr$Solve$Requirement$KeyAndConstraint,
		$author$project$Model$Ingredient$key(ingredient),
		$author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$Exact(
			$author$project$Model$Ingredient$getVersion(ingredient)));
};
var $author$project$Pages$CreateProject$selectDefaultBundles = F2(
	function (bundleMetadata, editor) {
		return A3(
			$elm$core$List$foldl,
			function (req) {
				return A2($author$project$Model$BuildPlanner$SolveLegacyEditor$addBundle, req.Y, req.bK);
			},
			editor,
			A2(
				$elm$core$List$map,
				$author$project$Model$BuildExprEditorUtils$fromIngredientVersion,
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Model$Ingredient$key,
						$author$project$Misc$memberOf($author$project$Pages$CreateProject$defaultSelectedBundleNames)),
					$elm$core$Dict$values(bundleMetadata))));
	});
var $author$project$Views$PlatformSelectorSimple$getIsSelected = function (_v0) {
	var selected = _v0.d;
	return selected;
};
var $author$project$PlatformMapping$distribution = function (_v0) {
	var data = _v0;
	return data.dS;
};
var $elm_community$dict_extra$Dict$Extra$groupBy = F2(
	function (keyfn, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A3(
						$elm$core$Dict$update,
						keyfn(x),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$map(
								$elm$core$List$cons(x)),
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$withDefault(
									_List_fromArray(
										[x])),
								$elm$core$Maybe$Just)),
						acc);
				}),
			$elm$core$Dict$empty,
			list);
	});
var $author$project$PlatformMapping$kernel = function (_v0) {
	var data = _v0;
	return data.gk;
};
var $author$project$PlatformMapping$PlatformMappingData = $elm$core$Basics$identity;
var $author$project$PlatformMapping$platformChoicesList = A2(
	$elm$core$List$map,
	$elm$core$Basics$identity,
	_List_fromArray(
		[
			{
			dS: 'Ubuntu',
			gk: 'Linux',
			m0: '7c998ec2-7491-4e75-be4d-8885800ef5f2',
			F: true,
			G: _List_fromArray(
				['7c998ec2-7491-4e75-be4d-8885800ef5f2', '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '20.10 groovy',
			H: 1
		},
			{
			dS: 'Ubuntu',
			gk: 'Linux',
			m0: '7c998ec2-7491-4e75-be4d-8885800ef5f2',
			F: true,
			G: _List_fromArray(
				['7c998ec2-7491-4e75-be4d-8885800ef5f2', '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '20.04 LTS focal',
			H: 2
		},
			{
			dS: 'Ubuntu',
			gk: 'Linux',
			m0: '7c998ec2-7491-4e75-be4d-8885800ef5f2',
			F: true,
			G: _List_fromArray(
				['7c998ec2-7491-4e75-be4d-8885800ef5f2', '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '19.10 eoan',
			H: 3
		},
			{
			dS: 'Ubuntu',
			gk: 'Linux',
			m0: '7c998ec2-7491-4e75-be4d-8885800ef5f2',
			F: true,
			G: _List_fromArray(
				['7c998ec2-7491-4e75-be4d-8885800ef5f2', '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '19.04 disco',
			H: 4
		},
			{
			dS: 'Ubuntu',
			gk: 'Linux',
			m0: '7c998ec2-7491-4e75-be4d-8885800ef5f2',
			F: true,
			G: _List_fromArray(
				['7c998ec2-7491-4e75-be4d-8885800ef5f2', '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '18.10 cosmic',
			H: 5
		},
			{
			dS: 'Ubuntu',
			gk: 'Linux',
			m0: '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a',
			F: true,
			G: _List_fromArray(
				['0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '18.04 LTS bionic',
			H: 6
		},
			{
			dS: 'Ubuntu',
			gk: 'Linux',
			m0: '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a',
			F: true,
			G: _List_fromArray(
				['0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '17.10 artful',
			H: 7
		},
			{
			dS: 'Ubuntu',
			gk: 'Linux',
			m0: '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a',
			F: true,
			G: _List_fromArray(
				['0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '17.04 zesty',
			H: 8
		},
			{
			dS: 'Ubuntu',
			gk: 'Linux',
			m0: '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a',
			F: true,
			G: _List_fromArray(
				['0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '16.10 yakkety',
			H: 9
		},
			{
			dS: 'Ubuntu',
			gk: 'Linux',
			m0: '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a',
			F: true,
			G: _List_fromArray(
				['0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '16.04 LTS xenial',
			H: 10
		},
			{
			dS: 'Ubuntu',
			gk: 'Linux',
			m0: '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a',
			F: true,
			G: _List_fromArray(
				['0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '15.10 wily',
			H: 11
		},
			{
			dS: 'Ubuntu',
			gk: 'Linux',
			m0: '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a',
			F: true,
			G: _List_fromArray(
				['0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '15.04 vivid',
			H: 12
		},
			{
			dS: 'Ubuntu',
			gk: 'Linux',
			m0: '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a',
			F: true,
			G: _List_fromArray(
				['0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '14.10 utopic',
			H: 13
		},
			{
			dS: 'Ubuntu',
			gk: 'Linux',
			m0: '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a',
			F: true,
			G: _List_fromArray(
				['0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '14.04 LTS trusty',
			H: 14
		},
			{
			dS: 'Ubuntu',
			gk: 'Linux',
			m0: '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a',
			F: true,
			G: _List_fromArray(
				['0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '13.10 saucy',
			H: 15
		},
			{
			dS: 'Ubuntu',
			gk: 'Linux',
			m0: '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a',
			F: true,
			G: _List_fromArray(
				['0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '13.04 raring',
			H: 16
		},
			{
			dS: 'Ubuntu',
			gk: 'Linux',
			m0: '681d5381-518c-5f4c-b367-df05c8d525e2',
			F: false,
			G: _List_fromArray(
				['681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '12.10 quantal',
			H: 17
		},
			{
			dS: 'Ubuntu',
			gk: 'Linux',
			m0: '681d5381-518c-5f4c-b367-df05c8d525e2',
			F: false,
			G: _List_fromArray(
				['681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '12.04 LTS precise',
			H: 18
		},
			{
			dS: 'Ubuntu',
			gk: 'Linux',
			m0: '681d5381-518c-5f4c-b367-df05c8d525e2',
			F: false,
			G: _List_fromArray(
				['681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '11.10 oneiric',
			H: 19
		},
			{
			dS: 'Ubuntu',
			gk: 'Linux',
			m0: '681d5381-518c-5f4c-b367-df05c8d525e2',
			F: false,
			G: _List_fromArray(
				['681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '11.04 natty',
			H: 20
		},
			{
			dS: 'Ubuntu',
			gk: 'Linux',
			m0: '681d5381-518c-5f4c-b367-df05c8d525e2',
			F: false,
			G: _List_fromArray(
				['681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '10.10 maverick',
			H: 21
		},
			{
			dS: 'Centos',
			gk: 'Linux',
			m0: '7c998ec2-7491-4e75-be4d-8885800ef5f2',
			F: true,
			G: _List_fromArray(
				['7c998ec2-7491-4e75-be4d-8885800ef5f2', '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '8',
			H: 22
		},
			{
			dS: 'Centos',
			gk: 'Linux',
			m0: '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a',
			F: true,
			G: _List_fromArray(
				['0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '7',
			H: 23
		},
			{
			dS: 'Centos',
			gk: 'Linux',
			m0: '681d5381-518c-5f4c-b367-df05c8d525e2',
			F: false,
			G: _List_fromArray(
				['681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '6.9',
			H: 24
		},
			{
			dS: 'Fedora',
			gk: 'Linux',
			m0: '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a',
			F: true,
			G: _List_fromArray(
				['0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: 'rawhide',
			H: 25
		},
			{
			dS: 'Fedora',
			gk: 'Linux',
			m0: '7c998ec2-7491-4e75-be4d-8885800ef5f2',
			F: true,
			G: _List_fromArray(
				['7c998ec2-7491-4e75-be4d-8885800ef5f2', '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '30',
			H: 26
		},
			{
			dS: 'Fedora',
			gk: 'Linux',
			m0: '7c998ec2-7491-4e75-be4d-8885800ef5f2',
			F: true,
			G: _List_fromArray(
				['7c998ec2-7491-4e75-be4d-8885800ef5f2', '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '29',
			H: 27
		},
			{
			dS: 'Fedora',
			gk: 'Linux',
			m0: '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a',
			F: true,
			G: _List_fromArray(
				['0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '28',
			H: 28
		},
			{
			dS: 'Fedora',
			gk: 'Linux',
			m0: '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a',
			F: true,
			G: _List_fromArray(
				['0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '27',
			H: 29
		},
			{
			dS: 'Fedora',
			gk: 'Linux',
			m0: '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a',
			F: true,
			G: _List_fromArray(
				['0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '26',
			H: 30
		},
			{
			dS: 'Fedora',
			gk: 'Linux',
			m0: '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a',
			F: true,
			G: _List_fromArray(
				['0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '25',
			H: 31
		},
			{
			dS: 'Fedora',
			gk: 'Linux',
			m0: '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a',
			F: true,
			G: _List_fromArray(
				['0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '24',
			H: 32
		},
			{
			dS: 'Fedora',
			gk: 'Linux',
			m0: '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a',
			F: true,
			G: _List_fromArray(
				['0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '23',
			H: 33
		},
			{
			dS: 'Fedora',
			gk: 'Linux',
			m0: '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a',
			F: true,
			G: _List_fromArray(
				['0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '22',
			H: 34
		},
			{
			dS: 'Fedora',
			gk: 'Linux',
			m0: '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a',
			F: true,
			G: _List_fromArray(
				['0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '21',
			H: 35
		},
			{
			dS: 'Fedora',
			gk: 'Linux',
			m0: '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a',
			F: true,
			G: _List_fromArray(
				['0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '20 heisenbug',
			H: 36
		},
			{
			dS: 'Fedora',
			gk: 'Linux',
			m0: '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a',
			F: true,
			G: _List_fromArray(
				['0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '19 schrodingers',
			H: 37
		},
			{
			dS: 'Fedora',
			gk: 'Linux',
			m0: '681d5381-518c-5f4c-b367-df05c8d525e2',
			F: false,
			G: _List_fromArray(
				['681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '18 spherical',
			H: 38
		},
			{
			dS: 'Fedora',
			gk: 'Linux',
			m0: '681d5381-518c-5f4c-b367-df05c8d525e2',
			F: false,
			G: _List_fromArray(
				['681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '17 beefy',
			H: 39
		},
			{
			dS: 'Fedora',
			gk: 'Linux',
			m0: '681d5381-518c-5f4c-b367-df05c8d525e2',
			F: false,
			G: _List_fromArray(
				['681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '16 verne',
			H: 40
		},
			{
			dS: 'Fedora',
			gk: 'Linux',
			m0: '681d5381-518c-5f4c-b367-df05c8d525e2',
			F: false,
			G: _List_fromArray(
				['681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '15 lovelock',
			H: 41
		},
			{
			dS: 'Fedora',
			gk: 'Linux',
			m0: '681d5381-518c-5f4c-b367-df05c8d525e2',
			F: false,
			G: _List_fromArray(
				['681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '14 laughlin',
			H: 42
		},
			{
			dS: 'Fedora',
			gk: 'Linux',
			m0: '681d5381-518c-5f4c-b367-df05c8d525e2',
			F: false,
			G: _List_fromArray(
				['681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '13 goddard',
			H: 43
		},
			{
			dS: 'Debian',
			gk: 'Linux',
			m0: '7c998ec2-7491-4e75-be4d-8885800ef5f2',
			F: true,
			G: _List_fromArray(
				['7c998ec2-7491-4e75-be4d-8885800ef5f2', '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '10 - Buster',
			H: 44
		},
			{
			dS: 'Debian',
			gk: 'Linux',
			m0: '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a',
			F: true,
			G: _List_fromArray(
				['0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '9 - Stretch',
			H: 45
		},
			{
			dS: 'Debian',
			gk: 'Linux',
			m0: '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a',
			F: true,
			G: _List_fromArray(
				['0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '8.0 - Jessie',
			H: 46
		},
			{
			dS: 'Debian',
			gk: 'Linux',
			m0: '681d5381-518c-5f4c-b367-df05c8d525e2',
			F: false,
			G: _List_fromArray(
				['681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '7.0 - Wheezy',
			H: 47
		},
			{
			dS: 'RedHat',
			gk: 'Linux',
			m0: '7c998ec2-7491-4e75-be4d-8885800ef5f2',
			F: true,
			G: _List_fromArray(
				['7c998ec2-7491-4e75-be4d-8885800ef5f2', '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: 'RHEL-8.0',
			H: 48
		},
			{
			dS: 'RedHat',
			gk: 'Linux',
			m0: '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a',
			F: true,
			G: _List_fromArray(
				['0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: 'RHEL-7.5',
			H: 49
		},
			{
			dS: 'RedHat',
			gk: 'Linux',
			m0: '681d5381-518c-5f4c-b367-df05c8d525e2',
			F: false,
			G: _List_fromArray(
				['681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: 'RHEL-6.9',
			H: 50
		},
			{
			dS: 'Windows',
			gk: 'Windows',
			m0: '78977bc8-0f32-519d-80f3-9043f059398c',
			F: true,
			G: _List_fromArray(
				['78977bc8-0f32-519d-80f3-9043f059398c']),
			aI: 'Server 2012',
			H: 8
		},
			{
			dS: 'Windows',
			gk: 'Windows',
			m0: '78977bc8-0f32-519d-80f3-9043f059398c',
			F: true,
			G: _List_fromArray(
				['78977bc8-0f32-519d-80f3-9043f059398c']),
			aI: 'Server 2016',
			H: 7
		},
			{
			dS: 'Windows',
			gk: 'Windows',
			m0: '78977bc8-0f32-519d-80f3-9043f059398c',
			F: true,
			G: _List_fromArray(
				['78977bc8-0f32-519d-80f3-9043f059398c']),
			aI: 'Server 2019',
			H: 6
		},
			{
			dS: 'Windows',
			gk: 'Windows',
			m0: '78977bc8-0f32-519d-80f3-9043f059398c',
			F: true,
			G: _List_fromArray(
				['78977bc8-0f32-519d-80f3-9043f059398c']),
			aI: 'Server 2022',
			H: 5
		},
			{
			dS: 'Windows',
			gk: 'Windows',
			m0: '78977bc8-0f32-519d-80f3-9043f059398c',
			F: true,
			G: _List_fromArray(
				['78977bc8-0f32-519d-80f3-9043f059398c']),
			aI: '11',
			H: 1
		},
			{
			dS: 'Windows',
			gk: 'Windows',
			m0: '78977bc8-0f32-519d-80f3-9043f059398c',
			F: true,
			G: _List_fromArray(
				['78977bc8-0f32-519d-80f3-9043f059398c']),
			aI: '10',
			H: 2
		},
			{
			dS: 'Windows',
			gk: 'Windows',
			m0: '78977bc8-0f32-519d-80f3-9043f059398c',
			F: true,
			G: _List_fromArray(
				['78977bc8-0f32-519d-80f3-9043f059398c']),
			aI: '8',
			H: 4
		},
			{
			dS: 'Windows',
			gk: 'Windows',
			m0: '78977bc8-0f32-519d-80f3-9043f059398c',
			F: true,
			G: _List_fromArray(
				['78977bc8-0f32-519d-80f3-9043f059398c']),
			aI: '8.1',
			H: 3
		},
			{
			dS: 'Windows',
			gk: 'Windows',
			m0: '1a44e57a-cdb2-5631-8c94-1eb83401038e',
			F: false,
			G: _List_fromArray(
				['1a44e57a-cdb2-5631-8c94-1eb83401038e']),
			aI: '7',
			H: 10
		},
			{
			dS: 'openSUSE',
			gk: 'Linux',
			m0: '7c998ec2-7491-4e75-be4d-8885800ef5f2',
			F: true,
			G: _List_fromArray(
				['7c998ec2-7491-4e75-be4d-8885800ef5f2', '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: 'tumbleweed',
			H: 51
		},
			{
			dS: 'openSUSE',
			gk: 'Linux',
			m0: '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a',
			F: true,
			G: _List_fromArray(
				['0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '15.2',
			H: 52
		},
			{
			dS: 'openSUSE',
			gk: 'Linux',
			m0: '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a',
			F: true,
			G: _List_fromArray(
				['0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '15',
			H: 53
		},
			{
			dS: 'openSUSE',
			gk: 'Linux',
			m0: '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a',
			F: true,
			G: _List_fromArray(
				['0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '42.3',
			H: 54
		},
			{
			dS: 'openSUSE',
			gk: 'Linux',
			m0: '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a',
			F: true,
			G: _List_fromArray(
				['0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '42.2',
			H: 55
		},
			{
			dS: 'openSUSE',
			gk: 'Linux',
			m0: '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a',
			F: true,
			G: _List_fromArray(
				['0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '42.1',
			H: 56
		},
			{
			dS: 'openSUSE',
			gk: 'Linux',
			m0: '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a',
			F: true,
			G: _List_fromArray(
				['0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '13.2',
			H: 57
		},
			{
			dS: 'openSUSE',
			gk: 'Linux',
			m0: '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a',
			F: true,
			G: _List_fromArray(
				['0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '13.1',
			H: 58
		},
			{
			dS: 'openSUSE',
			gk: 'Linux',
			m0: '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a',
			F: true,
			G: _List_fromArray(
				['0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '12.3',
			H: 59
		},
			{
			dS: 'openSUSE',
			gk: 'Linux',
			m0: '681d5381-518c-5f4c-b367-df05c8d525e2',
			F: false,
			G: _List_fromArray(
				['681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '12.2',
			H: 60
		},
			{
			dS: 'openSUSE',
			gk: 'Linux',
			m0: '681d5381-518c-5f4c-b367-df05c8d525e2',
			F: false,
			G: _List_fromArray(
				['681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: '12.1',
			H: 61
		},
			{
			dS: 'Windows',
			gk: 'Windows',
			m0: 'ff8f9715-d3b9-54a7-9d1a-60bdc7fd622a',
			F: false,
			G: _List_fromArray(
				['ff8f9715-d3b9-54a7-9d1a-60bdc7fd622a']),
			aI: 'Server 2012 (32 bit)',
			H: 11
		},
			{
			dS: 'Windows',
			gk: 'Windows',
			m0: 'ff8f9715-d3b9-54a7-9d1a-60bdc7fd622a',
			F: false,
			G: _List_fromArray(
				['ff8f9715-d3b9-54a7-9d1a-60bdc7fd622a']),
			aI: 'Server 2016 (32 bit)',
			H: 12
		},
			{
			dS: 'Windows',
			gk: 'Windows',
			m0: 'ff8f9715-d3b9-54a7-9d1a-60bdc7fd622a',
			F: false,
			G: _List_fromArray(
				['ff8f9715-d3b9-54a7-9d1a-60bdc7fd622a']),
			aI: 'Server 2019 (32 bit)',
			H: 13
		},
			{
			dS: 'Windows',
			gk: 'Windows',
			m0: 'ff8f9715-d3b9-54a7-9d1a-60bdc7fd622a',
			F: false,
			G: _List_fromArray(
				['ff8f9715-d3b9-54a7-9d1a-60bdc7fd622a']),
			aI: '10 (32 bit)',
			H: 14
		},
			{
			dS: 'Windows',
			gk: 'Windows',
			m0: 'ff8f9715-d3b9-54a7-9d1a-60bdc7fd622a',
			F: false,
			G: _List_fromArray(
				['ff8f9715-d3b9-54a7-9d1a-60bdc7fd622a']),
			aI: '8 (32 bit)',
			H: 15
		},
			{
			dS: 'Windows',
			gk: 'Windows',
			m0: 'ff8f9715-d3b9-54a7-9d1a-60bdc7fd622a',
			F: false,
			G: _List_fromArray(
				['ff8f9715-d3b9-54a7-9d1a-60bdc7fd622a']),
			aI: '8.1 (32 bit)',
			H: 16
		},
			{
			dS: 'Windows',
			gk: 'Windows',
			m0: 'c5f334c4-4471-5a8a-ab0d-ace3c0f544ab',
			F: false,
			G: _List_fromArray(
				['c5f334c4-4471-5a8a-ab0d-ace3c0f544ab']),
			aI: '7 (32 bit)',
			H: 17
		},
			{
			dS: 'MacOS',
			gk: 'MacOS',
			m0: '96b7e6f2-bebf-564c-bc1c-f04482398f38',
			F: false,
			G: _List_fromArray(
				['96b7e6f2-bebf-564c-bc1c-f04482398f38']),
			aI: '10.15 Catalina',
			H: 10
		},
			{
			dS: 'MacOS',
			gk: 'MacOS',
			m0: '96b7e6f2-bebf-564c-bc1c-f04482398f38',
			F: false,
			G: _List_fromArray(
				['96b7e6f2-bebf-564c-bc1c-f04482398f38']),
			aI: '10.14 Mojave',
			H: 11
		},
			{
			dS: 'MacOS',
			gk: 'MacOS',
			m0: '96b7e6f2-bebf-564c-bc1c-f04482398f38',
			F: false,
			G: _List_fromArray(
				['96b7e6f2-bebf-564c-bc1c-f04482398f38']),
			aI: '10.13 High Sierra',
			H: 12
		},
			{
			dS: 'MacOS',
			gk: 'MacOS',
			m0: '96b7e6f2-bebf-564c-bc1c-f04482398f38',
			F: false,
			G: _List_fromArray(
				['96b7e6f2-bebf-564c-bc1c-f04482398f38']),
			aI: '10.12 Sierra',
			H: 13
		},
			{
			dS: 'MacOS',
			gk: 'MacOS',
			m0: '96b7e6f2-bebf-564c-bc1c-f04482398f38',
			F: false,
			G: _List_fromArray(
				['96b7e6f2-bebf-564c-bc1c-f04482398f38']),
			aI: '10.11 El Capitan',
			H: 14
		},
			{
			dS: 'MacOS',
			gk: 'MacOS',
			m0: '96b7e6f2-bebf-564c-bc1c-f04482398f38',
			F: false,
			G: _List_fromArray(
				['96b7e6f2-bebf-564c-bc1c-f04482398f38']),
			aI: '10.10 Yosemite',
			H: 15
		},
			{
			dS: 'MacOS',
			gk: 'MacOS',
			m0: '96b7e6f2-bebf-564c-bc1c-f04482398f38',
			F: false,
			G: _List_fromArray(
				['96b7e6f2-bebf-564c-bc1c-f04482398f38']),
			aI: '10.9 Mavericks',
			H: 16
		},
			{
			dS: 'MacOS',
			gk: 'MacOS',
			m0: '46a5b48f-226a-4696-9746-ba4d50d661c2',
			F: true,
			G: _List_fromArray(
				['46a5b48f-226a-4696-9746-ba4d50d661c2']),
			aI: '11 Big Sur',
			H: 3
		},
			{
			dS: 'MacOS',
			gk: 'MacOS',
			m0: '46a5b48f-226a-4696-9746-ba4d50d661c2',
			F: true,
			G: _List_fromArray(
				['46a5b48f-226a-4696-9746-ba4d50d661c2']),
			aI: '12 Monterey',
			H: 2
		},
			{
			dS: 'MacOS',
			gk: 'MacOS',
			m0: '46a5b48f-226a-4696-9746-ba4d50d661c2',
			F: true,
			G: _List_fromArray(
				['46a5b48f-226a-4696-9746-ba4d50d661c2']),
			aI: '13 Ventura',
			H: 1
		},
			{
			dS: 'SUSE (SLES)',
			gk: 'Linux',
			m0: '7c998ec2-7491-4e75-be4d-8885800ef5f2',
			F: true,
			G: _List_fromArray(
				['7c998ec2-7491-4e75-be4d-8885800ef5f2', '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: 'Enterprise Server 15 SP 6',
			H: 1
		},
			{
			dS: 'SUSE (SLES)',
			gk: 'Linux',
			m0: '7c998ec2-7491-4e75-be4d-8885800ef5f2',
			F: true,
			G: _List_fromArray(
				['7c998ec2-7491-4e75-be4d-8885800ef5f2', '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: 'Enterprise Server 15 SP5, SP4',
			H: 2
		},
			{
			dS: 'SUSE (SLES)',
			gk: 'Linux',
			m0: '7c998ec2-7491-4e75-be4d-8885800ef5f2',
			F: true,
			G: _List_fromArray(
				['7c998ec2-7491-4e75-be4d-8885800ef5f2', '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: 'Enterprise Server 15 SP3',
			H: 3
		},
			{
			dS: 'SUSE (SLES)',
			gk: 'Linux',
			m0: '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a',
			F: true,
			G: _List_fromArray(
				['0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: 'Enterprise Server 12 SP5',
			H: 4
		},
			{
			dS: 'SUSE (SLES)',
			gk: 'Linux',
			m0: '0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a',
			F: true,
			G: _List_fromArray(
				['0fa42e8c-ac7b-5dd7-9407-8aa15f9b993a', '681d5381-518c-5f4c-b367-df05c8d525e2']),
			aI: 'Enterprise Server 12 SP4',
			H: 5
		}
		]));
var $author$project$PlatformMapping$platformID = function (_v0) {
	var data = _v0;
	return data.m0;
};
var $author$project$PlatformMapping$selfServiceNonSuperuser = function (_v0) {
	var data = _v0;
	return data.F;
};
var $author$project$PlatformMapping$version = function (_v0) {
	var data = _v0;
	return data.aI;
};
var $author$project$PlatformMapping$versionOrder = function (_v0) {
	var data = _v0;
	return data.H;
};
var $author$project$Views$PlatformSelectorSimple$choices = A2(
	$elm$core$Dict$map,
	F2(
		function (_v0, v1) {
			return A2(
				$elm$core$Dict$map,
				F2(
					function (_v1, v2) {
						return A2(
							$elm$core$Dict$map,
							F2(
								function (_v2, v3) {
									return {
										vD: $author$project$PlatformMapping$versionOrder(v3),
										m0: $author$project$PlatformMapping$platformID(v3),
										F: $author$project$PlatformMapping$selfServiceNonSuperuser(v3)
									};
								}),
							A2($elm_community$dict_extra$Dict$Extra$fromListBy, $author$project$PlatformMapping$version, v2));
					}),
				A2($elm_community$dict_extra$Dict$Extra$groupBy, $author$project$PlatformMapping$distribution, v1));
		}),
	A2($elm_community$dict_extra$Dict$Extra$groupBy, $author$project$PlatformMapping$kernel, $author$project$PlatformMapping$platformChoicesList));
var $author$project$Views$PlatformSelectorSimple$getPlatformID = function (_v0) {
	var name = _v0.a;
	var distro = _v0.b;
	var version = _v0.c;
	return A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.m0;
		},
		A2(
			$elm$core$Maybe$andThen,
			$elm$core$Dict$get(version),
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$Dict$get(distro),
				A2(
					$elm$core$Dict$get,
					$author$project$Views$PlatformSelectorSimple$platformNameToString(name),
					$author$project$Views$PlatformSelectorSimple$choices))));
};
var $author$project$Views$PlatformSelectorSimple$platformIDs = function (_v0) {
	var windows = _v0.hZ;
	var macos = _v0.gq;
	var linux = _v0.hz;
	var platforms = _List_fromArray(
		[windows, macos, linux]);
	return A2(
		$elm$core$List$filterMap,
		function (choice) {
			return $author$project$Views$PlatformSelectorSimple$getIsSelected(choice) ? $author$project$Views$PlatformSelectorSimple$getPlatformID(choice) : $elm$core$Maybe$Nothing;
		},
		platforms);
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$platformsSetter = F2(
	function (platforms, fields) {
		return _Utils_update(
			fields,
			{Fh: platforms});
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$setPlatforms = A2(
	$elm$core$Basics$composeL,
	$author$project$Model$BuildPlanner$SolveLegacyEditor$setBuildExprSolveEditor,
	$author$project$Model$Editor$setField($author$project$Model$BuildPlanner$SolveLegacyEditor$platformsSetter));
var $author$project$Pages$CreateProject$selectPlatforms = F3(
	function (platforms, selection, editor) {
		var platformIDs = $elm$core$Set$fromList(
			A2(
				$elm$core$List$filter,
				function (id) {
					return A2($elm$core$Dict$member, id, platforms);
				},
				$author$project$Views$PlatformSelectorSimple$platformIDs(selection)));
		return A2($author$project$Model$BuildPlanner$SolveLegacyEditor$setPlatforms, platformIDs, editor);
	});
var $author$project$Model$LanguageVersions$selectedLanguageAndVersion = function (selectedLanguages) {
	return A2(
		$elm$core$Maybe$andThen,
		function (_v0) {
			var maybeLanguage = _v0.y8;
			var selected = _v0.jw;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Misc$with(
					$author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$Exact(selected)),
				maybeLanguage);
		},
		$elm$core$List$head(selectedLanguages));
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$languagesSetter = F2(
	function (languages, fields) {
		var requirements = fields.FF;
		return _Utils_update(
			fields,
			{
				FF: _Utils_update(
					requirements,
					{aM: languages})
			});
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$setLanguages = A2(
	$elm$core$Basics$composeL,
	$author$project$Model$BuildPlanner$SolveLegacyEditor$setBuildExprSolveEditor,
	$author$project$Model$Editor$setField($author$project$Model$BuildPlanner$SolveLegacyEditor$languagesSetter));
var $author$project$Model$LanguageVersions$getSelected = function (_v0) {
	var contents = _v0;
	return contents.jw;
};
var $author$project$Model$BuildExprEditorUtils$toLanguageConstraint = function (x) {
	return _Utils_Tuple2(
		$author$project$Model$LanguageVersions$getName(x),
		$author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$Exact(
			$author$project$Model$LanguageVersions$getSelected(x)));
};
var $author$project$Model$BuildExprEditorUtils$toLanguagesDict = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$map($author$project$Model$BuildExprEditorUtils$toLanguageConstraint),
	$elm$core$Dict$fromList);
var $author$project$Pages$CreateProject$init = function (_v0) {
	var session = _v0.l;
	var key = _v0.Y;
	var host = _v0.t0;
	var orgName = _v0.ix;
	var maybeLanguage = _v0.y8;
	var maybeOSName = _v0.rv;
	var maybeNextAction = _v0.ru;
	var isNewUser = _v0.jc;
	var autoCreate = _v0.A9;
	var nextAction = function () {
		_v5$3:
		while (true) {
			if (!maybeNextAction.$) {
				switch (maybeNextAction.a) {
					case 'add-packages':
						return $elm$core$Maybe$Just(1);
					case 'import-packages':
						return $elm$core$Maybe$Just(2);
					case 'install':
						return $elm$core$Maybe$Just(0);
					default:
						break _v5$3;
				}
			} else {
				break _v5$3;
			}
		}
		return $elm$core$Maybe$Nothing;
	}();
	var defaultLanguage = $author$project$Model$Language$fromString(
		A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.w;
				},
				maybeLanguage)));
	var getBundleMetadata = function () {
		if (defaultLanguage.$ === 1) {
			return $elm$core$Task$succeed($elm$core$Dict$empty);
		} else {
			var lang = defaultLanguage.a;
			return A2($author$project$Request$Ingredient$bundles, $elm$core$Maybe$Nothing, lang);
		}
	}();
	var selectDefaultLanguage = function (languages) {
		var languageString = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Maybe$map, $author$project$Model$Language$toString, defaultLanguage));
		var getLanguage = function (searchTerm) {
			return A2(
				$elm$core$List$filter,
				function (language) {
					return _Utils_eq(
						$author$project$Model$LanguageVersions$getName(language),
						$elm$core$String$toLower(searchTerm));
				},
				languages);
		};
		return getLanguage(languageString);
	};
	var creds = $author$project$Model$Session$getCreds(session);
	return A2(
		$author$project$Task$Pipeline$fetch,
		getBundleMetadata,
		A2(
			$author$project$Task$Pipeline$fetch,
			$author$project$Request$Ingredient$platforms($elm$core$Maybe$Nothing),
			A2(
				$author$project$Task$Pipeline$fetch,
				$author$project$Request$Ingredient$languages($elm$core$Maybe$Nothing),
				A2(
					$author$project$Task$Pipeline$fetch,
					A2($author$project$Request$Organization$get, orgName, creds),
					A2(
						$author$project$Task$Pipeline$fetch,
						$author$project$Task$IngredientLatestTimestamp$getLatestTimestamp,
						$elm$core$Task$succeed(
							F5(
								function (latestTimestamp, org, rawLanguages, platforms, bundleMetadata) {
									var visibility = $author$project$Model$Permissions$orgCanCreatePrivateProject(org) ? 0 : 1;
									var userPlatform = A2(
										$elm$core$Maybe$withDefault,
										0,
										$author$project$Model$Platform$detectPlatformType(
											$author$project$Model$Session$getPlatform(session)));
									var unprunedLanguages = function () {
										var _v3 = A2(
											$elm$core$Maybe$andThen,
											function ($) {
												return $.aI;
											},
											maybeLanguage);
										if (_v3.$ === 1) {
											return rawLanguages;
										} else {
											var vstr = _v3.a;
											return A2(
												$elm$core$List$map,
												function (langver) {
													return A2(
														$elm$core$Maybe$withDefault,
														langver,
														A2($author$project$Model$LanguageVersions$select, vstr, langver));
												},
												rawLanguages);
										}
									}();
									var queryParamPlatform = function () {
										if (!maybeOSName.$) {
											var osName = maybeOSName.a;
											return $author$project$Model$Platform$detectPlatformType(osName);
										} else {
											return $elm$core$Maybe$Nothing;
										}
									}();
									var prunedLanguages = A2(
										$author$project$Model$LanguageVersions$prune,
										A2($author$project$Model$LanguageVersions$createAccessModel, session, org),
										unprunedLanguages);
									var initialLanguageSelection = selectDefaultLanguage(prunedLanguages);
									var initialPlatformSelection = function () {
										if (!queryParamPlatform.$) {
											var platformName = queryParamPlatform.a;
											return A2(
												$author$project$Views$PlatformSelectorSimple$default,
												$author$project$Model$LanguageVersions$selectedLanguageAndVersion(initialLanguageSelection),
												platformName);
										} else {
											return A2(
												$author$project$Views$PlatformSelectorSimple$default,
												$author$project$Model$LanguageVersions$selectedLanguageAndVersion(initialLanguageSelection),
												userPlatform);
										}
									}();
									var editorWithLanguages = A2(
										$author$project$Model$BuildPlanner$SolveLegacyEditor$setLanguages,
										$author$project$Model$BuildExprEditorUtils$toLanguagesDict(initialLanguageSelection),
										$author$project$Model$Editor$init(
											$author$project$Model$BuildPlanner$BuildExprEditor$Simple$init($elm$core$Maybe$Nothing)));
									var editor = A2(
										$author$project$Pages$CreateProject$selectDefaultBundles,
										bundleMetadata,
										A3($author$project$Pages$CreateProject$selectPlatforms, platforms, initialPlatformSelection, editorWithLanguages));
									var bundlesMetadata = _Utils_eq(defaultLanguage, $elm$core$Maybe$Nothing) ? $krisajenkins$remotedata$RemoteData$NotAsked : $krisajenkins$remotedata$RemoteData$Success(bundleMetadata);
									return {
										kM: $author$project$Model$Permissions$orgCanPackageInstaller(org),
										A9: autoCreate ? $elm$core$Maybe$Just(session) : $elm$core$Maybe$Nothing,
										n4: platforms,
										n9: $elm$core$Set$empty,
										iS: bundlesMetadata,
										bP: '',
										qR: editor,
										jV: false,
										t0: host,
										jc: isNewUser,
										Y: key,
										y$: latestTimestamp,
										uO: nextAction,
										mN: $author$project$Views$NotificationsInline$init,
										c3: org,
										m1: false,
										hK: initialPlatformSelection,
										vT: $elm$core$Maybe$Nothing,
										pt: $elm$core$Maybe$Nothing,
										fg: initialLanguageSelection,
										sn: !isNewUser,
										hT: $elm$core$Maybe$Nothing,
										wS: unprunedLanguages,
										wW: userPlatform,
										p9: visibility
									};
								})))))));
};
var $author$project$Model$Branch$getID = function (_v0) {
	var branch = _v0;
	return branch.xq;
};
var $author$project$Http$Extra$put = function (_v0) {
	var url = _v0.GT;
	var body = _v0.sY;
	var decoder = _v0.qN;
	var auth = _v0.iO;
	var headers = _v0.CN;
	return $elm$http$Http$task(
		{
			sY: body,
			CN: _Utils_ap(
				$author$project$Http$Extra$authToHeaders(auth),
				A2(
					$elm$core$List$map,
					$elm_community$basics_extra$Basics$Extra$uncurry($elm$http$Http$header),
					headers)),
			my: 'PUT',
			nj: $elm$http$Http$stringResolver(
				A2($author$project$Http$Extra$responseToResult, url, decoder)),
			nE: $elm$core$Maybe$Nothing,
			GT: _Utils_ap(
				$author$project$Http$Extra$authToUrlBase(auth),
				url)
		});
};
var $author$project$Request$VCS$putBranch = F3(
	function (creds, branchID, body) {
		return $author$project$Http$Extra$put(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$jsonBody(body),
				qN: $author$project$Model$Branch$decode,
				CN: _List_Nil,
				GT: '/vcs/branch/' + $danyx23$elm_uuid$Uuid$toString(branchID)
			});
	});
var $author$project$Request$VCS$commitToBranch = F2(
	function (creds, _v0) {
		var commitID = _v0.BR;
		var branch = _v0.h4;
		return A3(
			$author$project$Request$VCS$putBranch,
			creds,
			$author$project$Model$Branch$getID(branch),
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'commitID',
						$danyx23$elm_uuid$Uuid$encode(commitID))
					])));
	});
var $elm_community$dict_extra$Dict$Extra$find = F2(
	function (predicate, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, acc) {
					if (!acc.$) {
						return acc;
					} else {
						return A2(predicate, k, v) ? $elm$core$Maybe$Just(
							_Utils_Tuple2(k, v)) : $elm$core$Maybe$Nothing;
					}
				}),
			$elm$core$Maybe$Nothing,
			dict);
	});
var $author$project$Pages$CreateProjectFromCommit$maxAttempts = 10;
var $author$project$Request$Project$post = F3(
	function (creds, orgName, project) {
		return $author$project$Http$Extra$post(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$jsonBody(
					function () {
						var requiredPairs = _List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(project.w)),
								_Utils_Tuple2(
								'description',
								A2(
									$elm$core$Maybe$withDefault,
									$elm$json$Json$Encode$null,
									A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, project.bP))),
								_Utils_Tuple2(
								'private',
								$elm$json$Json$Encode$bool(project.cd)),
								_Utils_Tuple2(
								'managed',
								$elm$json$Json$Encode$bool(project.b4))
							]);
						var pairs = function () {
							var _v0 = project.x5;
							if (!_v0.$) {
								var distributionOnly = _v0.a;
								return A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										'distributionOnly',
										$elm$json$Json$Encode$bool(distributionOnly)),
									requiredPairs);
							} else {
								return requiredPairs;
							}
						}();
						return $elm$json$Json$Encode$object(pairs);
					}()),
				qN: $author$project$Model$Project$decode,
				CN: _List_Nil,
				GT: A2($author$project$Request$Project$urlPathOrgProject, orgName, '')
			});
	});
var $elm_community$string_extra$String$Extra$regexFromString = A2(
	$elm$core$Basics$composeR,
	$elm$regex$Regex$fromString,
	$elm$core$Maybe$withDefault($elm$regex$Regex$never));
var $elm_community$string_extra$String$Extra$toTitleCase = function (ws) {
	var uppercaseMatch = A2(
		$elm$regex$Regex$replace,
		$elm_community$string_extra$String$Extra$regexFromString('\\w+'),
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.o0;
			},
			$elm_community$string_extra$String$Extra$toSentenceCase));
	return A3(
		$elm$regex$Regex$replace,
		$elm_community$string_extra$String$Extra$regexFromString('^([a-z])|\\s+([a-z])'),
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.o0;
			},
			uppercaseMatch),
		ws);
};
var $author$project$Pages$CreateProjectFromCommit$init = F4(
	function (session, key, commitID, maybeProjectName) {
		var generateOrderFromCommitIDTask = A2(
			$elm$core$Task$map,
			$author$project$Model$BuildPlanner$SolveLegacyEditor$fromBuildExprWithFallback,
			A2($author$project$Request$BuildPlanner$getBuildExprForProjectlessCommit, session, commitID));
		var creds = $author$project$Model$Session$getCreds(session);
		var updateBranchTask = F2(
			function (id, branch) {
				return A2(
					$author$project$Request$VCS$commitToBranch,
					creds,
					{h4: branch, BR: id});
			});
		var createProjectTask = F2(
			function (attempt, pName) {
				var lenAttemptStr = 1 + $elm$core$String$length(
					$elm$core$String$fromInt(attempt));
				var projectNameTrimmed = A2($elm$core$String$left, $author$project$Validation$maxProjectNameLength - lenAttemptStr, pName);
				var is409 = function (err) {
					var _v0 = err.mp;
					if (_v0.$ === 3) {
						var resp = _v0.a;
						return resp.wp === 409;
					} else {
						return false;
					}
				};
				return A2(
					$elm$core$Task$onError,
					function (err) {
						return (is409(err) && (_Utils_cmp(attempt, $author$project$Pages$CreateProjectFromCommit$maxAttempts) < 1)) ? A2(
							createProjectTask,
							attempt + 1,
							projectNameTrimmed + ('-' + $elm$core$String$fromInt(attempt))) : $elm$core$Task$fail(err);
					},
					A3(
						$author$project$Request$Project$post,
						creds,
						$author$project$Pages$CreateProjectFromCommit$orgName(session),
						{bP: $elm$core$Maybe$Nothing, x5: $elm$core$Maybe$Nothing, b4: false, w: pName, cd: false}));
			});
		var constraintSuffix = function (constraint) {
			if (constraint.$ === 1) {
				var version = constraint.a;
				return '-' + version;
			} else {
				return '';
			}
		};
		var projectName = function (editor) {
			return $author$project$Validation$formatProjectName(
				A2(
					$elm$core$Maybe$withDefault,
					$author$project$Pages$CreateProjectFromCommit$username(session),
					A2(
						$elm_community$maybe_extra$Maybe$Extra$or,
						maybeProjectName,
						A2(
							$elm$core$Maybe$map,
							function (_v3) {
								var name = _v3.a;
								var version = _v3.b;
								return _Utils_ap(
									$elm_community$string_extra$String$Extra$toTitleCase(name),
									constraintSuffix(version));
							},
							A2(
								$elm_community$dict_extra$Dict$Extra$find,
								F2(
									function (_v1, _v2) {
										return true;
									}),
								$author$project$Model$BuildPlanner$SolveLegacyEditor$getLanguages(editor))))));
		};
		return A2(
			$elm$core$Task$andThen,
			function (order) {
				return A2(
					$elm$core$Task$andThen,
					function (project) {
						return A2(
							$elm$core$Task$map,
							$elm$core$Basics$always(
								{Y: key, c5: project}),
							A2(
								updateBranchTask,
								commitID,
								$author$project$Model$Project$getDefaultBranch(project)));
					},
					A2(
						createProjectTask,
						1,
						projectName(order)));
			},
			generateOrderFromCommitIDTask);
	});
var $author$project$Pages$FinishSetup$Blank = {$: 3};
var $author$project$Pages$FinishSetup$init = F3(
	function (_v0, key, nextRoute) {
		return $elm$core$Task$succeed(
			{lp: $jinjor$elm_debounce$Debounce$init, ge: $author$project$Pages$FinishSetup$Blank, Y: key, kc: '', dg: nextRoute});
	});
var $author$project$Pages$ForkProject$init = F6(
	function (session, key, orgName, projectName, requiredActions, destOrgUrlName) {
		var finishModel = function (project) {
			return {
				jQ: destOrgUrlName,
				op: $author$project$Model$Project$getName(project),
				jV: false,
				j0: $author$project$Model$Project$getName(project),
				Y: key,
				b4: false,
				mN: $author$project$Views$NotificationsInline$init,
				cd: $author$project$Model$Project$getIsPrivate(project),
				pt: $author$project$Validation$validateProjectName(
					$author$project$Model$Project$getName(project)),
				r9: requiredActions,
				sm: false,
				pR: orgName,
				hU: project,
				GM: 2
			};
		};
		var creds = $author$project$Model$Session$getCreds(session);
		var getProject = A3($author$project$Request$Project$get, creds, orgName, projectName);
		return A2(
			$author$project$Task$Pipeline$fetch,
			getProject,
			$elm$core$Task$succeed(finishModel));
	});
var $author$project$Pages$ImportProject$ChooseRepo = 0;
var $author$project$Pages$ImportProject$defaultLanguage = 1;
var $author$project$Model$MonoGit$Login$getLogin = function (_v0) {
	var l = _v0;
	return l.rr;
};
var $author$project$Model$LanguageVersions$getMaybeLanguage = function (_v0) {
	var contents = _v0;
	return contents.y8;
};
var $author$project$Request$Organization$getTier = F2(
	function (orgName, creds) {
		return $author$project$Http$Extra$get(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$emptyBody,
				qN: $author$project$Model$Tier$decode,
				CN: _List_Nil,
				GT: '/organizations/' + (orgName + '/tier')
			});
	});
var $author$project$Model$MonoGit$Login$Data = $elm$core$Basics$identity;
var $author$project$Model$MonoGit$Login$LoginInternal = F2(
	function (login, repositories) {
		return {rr: login, r8: repositories};
	});
var $author$project$Model$MonoGit$Repository$Repo = $elm$core$Basics$identity;
var $author$project$Model$MonoGit$Repository$RepoInternal = F4(
	function (name, url, languages, importable) {
		return {yB: importable, aM: languages, w: name, GT: url};
	});
var $author$project$Model$Language$importFileFormats = function (importableLanguage) {
	switch (importableLanguage) {
		case 0:
			return $elm$core$Maybe$Just(
				A2(
					$mgold$elm_nonempty_list$List$Nonempty$Nonempty,
					'cpanfile',
					_List_fromArray(
						['META.json'])));
		case 1:
			return $elm$core$Maybe$Just(
				A2(
					$mgold$elm_nonempty_list$List$Nonempty$Nonempty,
					'requirements.txt',
					_List_fromArray(
						['requirements.txt', 'Pipfile', 'Pipfile.lock', 'pyproject.toml', 'poetry.lock'])));
		case 3:
			return $elm$core$Maybe$Just(
				$mgold$elm_nonempty_list$List$Nonempty$singleton('Gemfile.lock'));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$Language$supportsImporting = function (languageName) {
	return $elm_community$maybe_extra$Maybe$Extra$isJust(
		A2(
			$elm$core$Maybe$andThen,
			$author$project$Model$Language$importFileFormats,
			$author$project$Model$Language$fromString(languageName)));
};
var $author$project$Model$MonoGit$Repository$decodeIsImportable = A2(
	$elm$json$Json$Decode$map,
	$elm$core$List$any($author$project$Model$Language$supportsImporting),
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string));
var $author$project$Model$MonoGit$Repository$decode = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'languages',
		$author$project$Model$MonoGit$Repository$decodeIsImportable,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'languages',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'url',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'name',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Model$MonoGit$Repository$RepoInternal))))));
var $author$project$Model$MonoGit$Login$decode = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'repositories',
		$elm$json$Json$Decode$list($author$project$Model$MonoGit$Repository$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Model$MonoGit$Login$LoginInternal))));
var $author$project$Request$MonoGit$getUsersRepos = function (creds) {
	return $author$project$Http$Extra$get(
		{
			iO: $author$project$Http$Extra$Creds(creds),
			sY: $author$project$Http$Extra$emptyBody,
			qN: $elm$json$Json$Decode$list($author$project$Model$MonoGit$Login$decode),
			CN: _List_Nil,
			GT: '/git/repos'
		});
};
var $elm$core$List$partition = F2(
	function (pred, list) {
		var step = F2(
			function (x, _v0) {
				var trues = _v0.a;
				var falses = _v0.b;
				return pred(x) ? _Utils_Tuple2(
					A2($elm$core$List$cons, x, trues),
					falses) : _Utils_Tuple2(
					trues,
					A2($elm$core$List$cons, x, falses));
			});
		return A3(
			$elm$core$List$foldr,
			step,
			_Utils_Tuple2(_List_Nil, _List_Nil),
			list);
	});
var $author$project$Pages$ImportProject$selectPlatforms = F3(
	function (platforms, selection, editor) {
		var platformIDs = $elm$core$Set$fromList(
			A2(
				$elm$core$List$filter,
				function (id) {
					return A2($elm$core$Dict$member, id, platforms);
				},
				$author$project$Views$PlatformSelectorSimple$platformIDs(selection)));
		return A2($author$project$Model$BuildPlanner$SolveLegacyEditor$setPlatforms, platformIDs, editor);
	});
var $elm$core$Dict$singleton = F2(
	function (key, value) {
		return A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
	});
var $elm$core$Set$singleton = function (key) {
	return A2($elm$core$Dict$singleton, key, 0);
};
var $author$project$Model$MonoGit$Login$sortRepos = F2(
	function (sortFn, _v0) {
		var l = _v0;
		return {
			rr: l.rr,
			r8: sortFn(l.r8)
		};
	});
var $author$project$Model$MonoGit$Repository$isImportable = function (_v0) {
	var r = _v0;
	return r.yB;
};
var $author$project$Model$MonoGit$Repository$name = function (_v0) {
	var r = _v0;
	return r.w;
};
var $author$project$Model$MonoGit$Repository$sortReposByImportableThenName = function (repos) {
	var sortByNameLower = $elm$core$List$sortBy(
		A2($elm$core$Basics$composeR, $author$project$Model$MonoGit$Repository$name, $elm$core$String$toLower));
	return A2(
		$elm_community$basics_extra$Basics$Extra$uncurry,
		$elm$core$Basics$append,
		A3(
			$elm$core$Tuple$mapBoth,
			sortByNameLower,
			sortByNameLower,
			A2($elm$core$List$partition, $author$project$Model$MonoGit$Repository$isImportable, repos)));
};
var $author$project$Pages$ImportProject$init = F3(
	function (session, key, orgName) {
		var selectDefaultLanguage = $elm$core$List$filter(
			A2(
				$elm$core$Basics$composeR,
				$author$project$Model$LanguageVersions$getMaybeLanguage,
				$elm$core$Basics$eq(
					$elm$core$Maybe$Just($author$project$Pages$ImportProject$defaultLanguage))));
		var creds = $author$project$Model$Session$getCreds(session);
		return A2(
			$author$project$Task$Pipeline$fetch,
			$author$project$Request$MonoGit$getUsersRepos(creds),
			A2(
				$author$project$Task$Pipeline$fetch,
				$author$project$Request$Ingredient$platforms($elm$core$Maybe$Nothing),
				A2(
					$author$project$Task$Pipeline$fetch,
					$author$project$Request$Ingredient$languages($elm$core$Maybe$Nothing),
					A2(
						$author$project$Task$Pipeline$fetch,
						A2($author$project$Request$Organization$get, orgName, creds),
						A2(
							$author$project$Task$Pipeline$fetch,
							A2($author$project$Request$Organization$getTier, orgName, creds),
							A2(
								$author$project$Task$Pipeline$fetch,
								$author$project$Task$IngredientLatestTimestamp$getLatestTimestamp,
								$elm$core$Task$succeed(
									F6(
										function (latestTimestamp, tier, org, languages, platforms, repos) {
											var userPlatform = A2(
												$elm$core$Maybe$withDefault,
												0,
												$author$project$Model$Platform$detectPlatformType(
													$author$project$Model$Session$getPlatform(session)));
											var sortedRepos = function () {
												var _v0 = A2(
													$elm$core$List$partition,
													A2(
														$elm$core$Basics$composeR,
														$author$project$Model$MonoGit$Login$getLogin,
														$elm$core$Basics$eq(
															$author$project$Model$Session$getUsername(session))),
													repos);
												var userOnly = _v0.a;
												var nonUserOnly = _v0.b;
												return A2(
													$elm$core$List$map,
													$author$project$Model$MonoGit$Login$sortRepos($author$project$Model$MonoGit$Repository$sortReposByImportableThenName),
													A2(
														$elm$core$List$append,
														userOnly,
														A2(
															$elm$core$List$sortBy,
															A2($elm$core$Basics$composeR, $author$project$Model$MonoGit$Login$getLogin, $elm$core$String$toLower),
															nonUserOnly)));
											}();
											var prunedLanguages = A2(
												$author$project$Model$LanguageVersions$prune,
												A2($author$project$Model$LanguageVersions$createAccessModel, session, org),
												languages);
											var initialLanguageSelection = selectDefaultLanguage(prunedLanguages);
											var initialPlatformSelection = A2(
												$author$project$Views$PlatformSelectorSimple$default,
												$author$project$Model$LanguageVersions$selectedLanguageAndVersion(initialLanguageSelection),
												userPlatform);
											var editorWithLanguages = A2(
												$author$project$Model$BuildPlanner$SolveLegacyEditor$setLanguages,
												$author$project$Model$BuildExprEditorUtils$toLanguagesDict(initialLanguageSelection),
												$author$project$Model$Editor$init(
													$author$project$Model$BuildPlanner$BuildExprEditor$Simple$init($elm$core$Maybe$Nothing)));
											var editor = A3($author$project$Pages$ImportProject$selectPlatforms, platforms, initialPlatformSelection, editorWithLanguages);
											return {
												hk: 0,
												jF: prunedLanguages,
												n4: platforms,
												kR: sortedRepos,
												f1: 0,
												bP: '',
												qR: editor,
												i1: $elm$core$Set$singleton(
													$author$project$Model$Session$getUsername(session)),
												jV: false,
												Y: key,
												y$: latestTimestamp,
												mN: $author$project$Views$NotificationsInline$init,
												c3: org,
												m1: false,
												hK: initialPlatformSelection,
												vT: '',
												ps: false,
												pt: $elm$core$Maybe$Nothing,
												fx: $elm$core$Dict$empty,
												hd: '',
												gA: $elm$core$Maybe$Nothing,
												pB: $elm$core$Maybe$Nothing,
												fg: initialLanguageSelection,
												dc: tier,
												wW: userPlatform,
												p9: 1
											};
										}))))))));
	});
var $author$project$Task$Parallel$Extra$DownloadUpdated2 = function (a) {
	return {$: 0, a: a};
};
var $0ui$elm_task_parallel$Task$Parallel$FailedToLoad2 = function (a) {
	return {$: 2, a: a};
};
var $0ui$elm_task_parallel$Task$Parallel$LoadedA2 = function (a) {
	return {$: 0, a: a};
};
var $0ui$elm_task_parallel$Task$Parallel$LoadedB2 = function (a) {
	return {$: 1, a: a};
};
var $0ui$elm_task_parallel$Task$Parallel$State2 = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $0ui$elm_task_parallel$Task$Parallel$attempt2 = F3(
	function (updateMsg, task1, task2) {
		return _Utils_Tuple2(
			A2($0ui$elm_task_parallel$Task$Parallel$State2, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3(
						$0ui$elm_task_parallel$Task$Parallel$routeTo,
						A2($elm$core$Basics$composeL, updateMsg, $0ui$elm_task_parallel$Task$Parallel$LoadedA2),
						A2($elm$core$Basics$composeL, updateMsg, $0ui$elm_task_parallel$Task$Parallel$FailedToLoad2),
						task1),
						A3(
						$0ui$elm_task_parallel$Task$Parallel$routeTo,
						A2($elm$core$Basics$composeL, updateMsg, $0ui$elm_task_parallel$Task$Parallel$LoadedB2),
						A2($elm$core$Basics$composeL, updateMsg, $0ui$elm_task_parallel$Task$Parallel$FailedToLoad2),
						task2)
					])));
	});
var $author$project$Model$Member$Member = F5(
	function (user, role, listed, pending, joined) {
		return {DM: joined, D5: listed, Fb: pending, FO: role, gS: user};
	});
var $author$project$Model$Member$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'joined',
	$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
		false,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'listed',
			$elm$json$Json$Decode$bool,
			false,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'role',
				$author$project$Model$Role$decode,
				0,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'user',
					$author$project$Model$User$decode,
					$elm$json$Json$Decode$succeed($author$project$Model$Member$Member))))));
var $author$project$Request$Member$list = F2(
	function (orgId, creds) {
		return $author$project$Http$Extra$get(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$emptyBody,
				qN: $elm$json$Json$Decode$list($author$project$Model$Member$decode),
				CN: _List_Nil,
				GT: '/organizations/' + (orgId + '/members')
			});
	});
var $author$project$Pages$OrgDependencies$init = F2(
	function (session, orgName) {
		var creds = $author$project$Model$Session$getCreds(session);
		var getMembers = A2($author$project$Request$Member$list, orgName, creds);
		var getOrganization = A2($author$project$Request$Organization$get, orgName, creds);
		var _v0 = A3($0ui$elm_task_parallel$Task$Parallel$attempt2, $author$project$Task$Parallel$Extra$DownloadUpdated2, getOrganization, getMembers);
		var downloadState = _v0.a;
		var downloadCmd = _v0.b;
		return _Utils_Tuple2(
			{x7: downloadState},
			downloadCmd);
	});
var $author$project$Task$Parallel$Extra$DownloadUpdated4 = function (a) {
	return {$: 0, a: a};
};
var $0ui$elm_task_parallel$Task$Parallel$FailedToLoad4 = function (a) {
	return {$: 4, a: a};
};
var $0ui$elm_task_parallel$Task$Parallel$LoadedA4 = function (a) {
	return {$: 0, a: a};
};
var $0ui$elm_task_parallel$Task$Parallel$LoadedB4 = function (a) {
	return {$: 1, a: a};
};
var $0ui$elm_task_parallel$Task$Parallel$LoadedC4 = function (a) {
	return {$: 2, a: a};
};
var $0ui$elm_task_parallel$Task$Parallel$LoadedD4 = function (a) {
	return {$: 3, a: a};
};
var $0ui$elm_task_parallel$Task$Parallel$State4 = F4(
	function (a, b, c, d) {
		return {$: 1, a: a, b: b, c: c, d: d};
	});
var $0ui$elm_task_parallel$Task$Parallel$attempt4 = F5(
	function (updateMsg, task1, task2, task3, task4) {
		return _Utils_Tuple2(
			A4($0ui$elm_task_parallel$Task$Parallel$State4, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3(
						$0ui$elm_task_parallel$Task$Parallel$routeTo,
						A2($elm$core$Basics$composeL, updateMsg, $0ui$elm_task_parallel$Task$Parallel$LoadedA4),
						A2($elm$core$Basics$composeL, updateMsg, $0ui$elm_task_parallel$Task$Parallel$FailedToLoad4),
						task1),
						A3(
						$0ui$elm_task_parallel$Task$Parallel$routeTo,
						A2($elm$core$Basics$composeL, updateMsg, $0ui$elm_task_parallel$Task$Parallel$LoadedB4),
						A2($elm$core$Basics$composeL, updateMsg, $0ui$elm_task_parallel$Task$Parallel$FailedToLoad4),
						task2),
						A3(
						$0ui$elm_task_parallel$Task$Parallel$routeTo,
						A2($elm$core$Basics$composeL, updateMsg, $0ui$elm_task_parallel$Task$Parallel$LoadedC4),
						A2($elm$core$Basics$composeL, updateMsg, $0ui$elm_task_parallel$Task$Parallel$FailedToLoad4),
						task3),
						A3(
						$0ui$elm_task_parallel$Task$Parallel$routeTo,
						A2($elm$core$Basics$composeL, updateMsg, $0ui$elm_task_parallel$Task$Parallel$LoadedD4),
						A2($elm$core$Basics$composeL, updateMsg, $0ui$elm_task_parallel$Task$Parallel$FailedToLoad4),
						task4)
					])));
	});
var $author$project$Pages$OrgIndex$init = F3(
	function (session, orgName, signupSource) {
		var creds = $author$project$Model$Session$getCreds(session);
		var fetchMembers = A2(
			$elm$core$Task$onError,
			$elm$core$Basics$always(
				$elm$core$Task$succeed(_List_Nil)),
			A2($author$project$Request$Member$list, orgName, creds));
		var fetchOrganization = A2($author$project$Request$Organization$get, orgName, creds);
		var _v0 = A5($0ui$elm_task_parallel$Task$Parallel$attempt4, $author$project$Task$Parallel$Extra$DownloadUpdated4, $elm$time$Time$here, fetchOrganization, fetchMembers, $elm$time$Time$now);
		var downloadState = _v0.a;
		var downloadCmd = _v0.b;
		return _Utils_Tuple2(
			{x7: downloadState, wd: signupSource},
			downloadCmd);
	});
var $author$project$Model$Organization$AutoInviteInfo = F2(
	function (domain, role) {
		return {tF: domain, FO: role};
	});
var $author$project$Model$Organization$decodeAutoInviteDomain = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'role',
	$author$project$Model$Role$decode,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'domain',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Model$Organization$AutoInviteInfo)));
var $author$project$Model$Organization$decodeAutoInviteDomains = $elm$json$Json$Decode$list($author$project$Model$Organization$decodeAutoInviteDomain);
var $author$project$Request$Organization$autoInviteDomains = F2(
	function (orgName, creds) {
		return $author$project$Http$Extra$get(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$emptyBody,
				qN: $author$project$Model$Organization$decodeAutoInviteDomains,
				CN: _List_Nil,
				GT: '/organizations/' + (orgName + '/autoinvite')
			});
	});
var $author$project$Model$Organization$getAutoInviteDomain = function (domainInfo) {
	return domainInfo.tF;
};
var $author$project$Pages$OrgMembers$determineSelectedDomain = F2(
	function (autoInviteDomains, eligibleDomains) {
		return $elm$core$List$isEmpty(autoInviteDomains) ? ($elm$core$List$isEmpty(eligibleDomains) ? $elm$core$Maybe$Nothing : $elm$core$List$head(eligibleDomains)) : A2(
			$elm$core$Maybe$map,
			$author$project$Model$Organization$getAutoInviteDomain,
			$elm$core$List$head(autoInviteDomains));
	});
var $author$project$Model$Organization$getAutoInviteRole = function (domainInfo) {
	return domainInfo.FO;
};
var $author$project$Pages$OrgMembers$determineSelectedRole = function (domainList) {
	return A2(
		$elm$core$Maybe$withDefault,
		1,
		A2(
			$elm$core$Maybe$map,
			$author$project$Model$Organization$getAutoInviteRole,
			$elm$core$List$head(domainList)));
};
var $author$project$Request$Email$list = F2(
	function (username, creds) {
		return $author$project$Http$Extra$get(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$emptyBody,
				qN: $elm$json$Json$Decode$list($author$project$Model$Email$decode),
				CN: _List_Nil,
				GT: '/users/' + (username + '/emails')
			});
	});
var $author$project$Request$Invitation$list = F2(
	function (orgId, creds) {
		return $author$project$Http$Extra$get(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$emptyBody,
				qN: $elm$json$Json$Decode$list(
					$author$project$Model$Invitation$decode(true)),
				CN: _List_Nil,
				GT: '/organizations/' + (orgId + '/invitations')
			});
	});
var $author$project$Request$User$verifiedDomains = F2(
	function (username, creds) {
		return $author$project$Http$Extra$get(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$emptyBody,
				qN: $elm$json$Json$Decode$list($elm$json$Json$Decode$string),
				CN: _List_Nil,
				GT: '/users/' + (username + '/domains')
			});
	});
var $author$project$Pages$OrgMembers$init = F2(
	function (session, orgName) {
		var username = $author$project$Model$Session$getUsername(session);
		var userName = $author$project$Model$Session$getUsername(session);
		var creds = $author$project$Model$Session$getCreds(session);
		var eligibleDomainsTask = A2(
			$elm$core$Task$onError,
			$elm$core$Basics$always(
				$elm$core$Task$succeed(_List_Nil)),
			A2($author$project$Request$User$verifiedDomains, userName, creds));
		var invitationsTask = A2(
			$elm$core$Task$map,
			$elm$core$List$filter(
				A2(
					$elm$core$Basics$composeL,
					$elm$core$Basics$not,
					function ($) {
						return $.Dg;
					})),
			A2($author$project$Request$Invitation$list, orgName, creds));
		var membersTask = A2($author$project$Request$Member$list, orgName, creds);
		var organizationTask = A2($author$project$Request$Organization$get, orgName, creds);
		var userEmailsTask = A2($author$project$Request$Email$list, username, creds);
		var autoInviteDomainTask = A2(
			$elm$core$Task$onError,
			$elm$core$Basics$always(
				$elm$core$Task$succeed(_List_Nil)),
			A2($author$project$Request$Organization$autoInviteDomains, orgName, creds));
		return A2(
			$author$project$Task$Pipeline$fetch,
			userEmailsTask,
			A2(
				$author$project$Task$Pipeline$fetch,
				autoInviteDomainTask,
				A2(
					$author$project$Task$Pipeline$fetch,
					eligibleDomainsTask,
					A2(
						$author$project$Task$Pipeline$fetch,
						invitationsTask,
						A2(
							$author$project$Task$Pipeline$fetch,
							membersTask,
							A2(
								$author$project$Task$Pipeline$fetch,
								organizationTask,
								$elm$core$Task$succeed(
									F6(
										function (organization, members, invitations, domainsInfo, autoInviteInfo, userEmailInfo) {
											return {
												iP: autoInviteInfo,
												h1: false,
												g_: domainsInfo,
												h2: A2($author$project$Pages$OrgMembers$determineSelectedDomain, autoInviteInfo, domainsInfo),
												n3: $author$project$Pages$OrgMembers$determineSelectedRole(autoInviteInfo),
												lK: false,
												jb: invitations,
												ui: '',
												hB: members,
												kb: '',
												mF: 1,
												c3: organization,
												hR: '',
												sJ: userEmailInfo
											};
										}))))))));
	});
var $author$project$Pages$OrgPolicy$OrganizationBundle = F2(
	function (organization, projects) {
		return {c3: organization, gx: projects};
	});
var $author$project$BuildPlanner$Query$policy = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'policy',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'organization', requiredArgs____.c3, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)
				]),
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$BuildPlanner$Union$PolicyResult$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Policy', selections____.vs),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'NotFound', selections____.vp)
			]));
};
var $author$project$Model$Policy$Policies$OrgPolicy = F4(
	function (policyId, userId, added, expr) {
		return {ak: added, cG: expr, Fj: policyId, GW: userId};
	});
var $author$project$BuildPlanner$Object$Policy$added = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'BuildPlannerScalarCodecs.DateTime',
	'added',
	_List_Nil,
	$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).qE.qN);
var $author$project$Model$Policy$Policy$addName = F2(
	function (name, _v0) {
		var description = _v0.bP;
		var rules = _v0.ks;
		return {bP: description, w: name, ks: rules};
	});
var $author$project$Model$Policy$LetIn$LetIn = $elm$core$Basics$identity;
var $author$project$Model$Policy$LetIn$decode = function (decodeExpr) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (pairs) {
			var _v0 = A2(
				$elm$core$Tuple$mapFirst,
				$elm$core$List$head,
				A2(
					$elm$core$List$partition,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$first,
						$elm$core$Basics$eq('in')),
					pairs));
			if (!_v0.a.$) {
				var _v1 = _v0.a.a;
				var mainExpr = _v1.b;
				var rest = _v0.b;
				return $elm$json$Json$Decode$succeed(
					{
						lS: $elm$core$Dict$fromList(rest),
						eu: mainExpr
					});
			} else {
				var _v2 = _v0.a;
				return $elm$json$Json$Decode$fail('\"in\" field was missing in let-in expression!');
			}
		},
		A2(
			$elm$json$Json$Decode$field,
			'let',
			$elm$json$Json$Decode$keyValuePairs(decodeExpr)));
};
var $author$project$Model$Policy$Policy$NamelessPolicy = F2(
	function (description, rules) {
		return {bP: description, ks: rules};
	});
var $author$project$Model$Policy$Policy$PolicyExprAnd = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$Policy$Policy$PolicyExprLanguage = function (a) {
	return {$: 4, a: a};
};
var $author$project$Model$Policy$Policy$PolicyExprLet = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$Policy$Policy$PolicyExprLicense = function (a) {
	return {$: 5, a: a};
};
var $author$project$Model$Policy$Policy$PolicyExprNot = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$Policy$Policy$PolicyExprOr = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$Policy$Policy$PolicyExprPackage = function (a) {
	return {$: 6, a: a};
};
var $author$project$Model$Policy$Policy$PolicyExprPolicy = function (a) {
	return {$: 7, a: a};
};
var $author$project$Model$Policy$Policy$PolicyExprProject = function (a) {
	return {$: 8, a: a};
};
var $author$project$Model$Policy$Policy$PolicyExprUnknown = function (a) {
	return {$: 10, a: a};
};
var $author$project$Model$Policy$Policy$PolicyExprVulnerability = function (a) {
	return {$: 9, a: a};
};
var $author$project$Model$Policy$Policy$andDecode = function (decodeValue) {
	return A2(
		$elm$json$Json$Decode$field,
		'and',
		A2(
			$elm$json$Json$Decode$field,
			'children',
			$elm$json$Json$Decode$list(decodeValue)));
};
var $author$project$Model$Policy$Policy$LanguageAttribute = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$Policy$Policy$LanguageName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$Policy$Policy$LanguageNameAndVersion = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Model$Policy$LanguageStatus$EOL = 2;
var $author$project$Model$Policy$LanguageStatus$LTS = 1;
var $author$project$Model$Policy$LanguageStatus$Stable = 0;
var $author$project$Model$Policy$LanguageStatus$fromString = function (s) {
	var _v0 = $elm$core$String$toLower(s);
	switch (_v0) {
		case 'stable':
			return $elm$core$Result$Ok(0);
		case 'lts':
			return $elm$core$Result$Ok(1);
		case 'eol':
			return $elm$core$Result$Ok(2);
		default:
			return $elm$core$Result$Err('\"' + (s + '\" is not a valid status'));
	}
};
var $author$project$Model$Policy$Policy$languageStatusDecode = A2(
	$elm$json$Json$Decode$andThen,
	function (languageStatusString) {
		var _v0 = $author$project$Model$Policy$LanguageStatus$fromString(languageStatusString);
		if (!_v0.$) {
			var languageStatus = _v0.a;
			return $elm$json$Json$Decode$succeed(languageStatus);
		} else {
			var error = _v0.a;
			return $elm$json$Json$Decode$fail(error);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$Policy$Policy$languageDecode = function () {
	var nameDecoder = A2(
		$elm$json$Json$Decode$map,
		$author$project$Model$Policy$Policy$LanguageName,
		A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string));
	var nameAndConstraintDecoder = A3(
		$elm$json$Json$Decode$map2,
		$author$project$Model$Policy$Policy$LanguageNameAndVersion,
		A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'version', $elm$json$Json$Decode$string));
	var attributeDecoder = A2(
		$elm$json$Json$Decode$map,
		$author$project$Model$Policy$Policy$LanguageAttribute,
		A2($elm$json$Json$Decode$field, 'attribute', $author$project$Model$Policy$Policy$languageStatusDecode));
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, 'Language.name', nameDecoder),
				A2($elm$json$Json$Decode$field, 'Language.nameAndVersion', nameAndConstraintDecoder),
				A2($elm$json$Json$Decode$field, 'Language.attribute', attributeDecoder)
			]));
}();
var $author$project$Model$Policy$Policy$letDecode = function (decodeValue) {
	return $author$project$Model$Policy$LetIn$decode(decodeValue);
};
var $author$project$Model$Policy$Policy$LicenseCategory = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$Policy$Policy$LicenseNameAny = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$Policy$LicenseCategory$CopyLeft = 0;
var $author$project$Model$Policy$LicenseCategory$Permissive = 2;
var $author$project$Model$Policy$LicenseCategory$Unknown = 1;
var $author$project$Model$Policy$LicenseCategory$fromString = function (s) {
	switch (s) {
		case 'copyleft':
			return $elm$core$Result$Ok(0);
		case 'unknown':
			return $elm$core$Result$Ok(1);
		case 'permissive':
			return $elm$core$Result$Ok(2);
		default:
			return $elm$core$Result$Err('Invalid LicenseCategory: \"' + (s + '\"'));
	}
};
var $author$project$Model$Policy$LicenseCategory$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		var _v0 = $author$project$Model$Policy$LicenseCategory$fromString(str);
		if (!_v0.$) {
			var category = _v0.a;
			return $elm$json$Json$Decode$succeed(category);
		} else {
			var err = _v0.a;
			return $elm$json$Json$Decode$fail(err);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$Policy$Policy$licenseDecode = function () {
	var nameAnyDecoder = A2(
		$elm$json$Json$Decode$map,
		$author$project$Model$Policy$Policy$LicenseNameAny,
		A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string));
	var categoryAllDecoder = A2(
		$elm$json$Json$Decode$map,
		$author$project$Model$Policy$Policy$LicenseCategory,
		A2($elm$json$Json$Decode$field, 'category', $author$project$Model$Policy$LicenseCategory$decode));
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, 'License.nameAny', nameAnyDecoder),
				A2($elm$json$Json$Decode$field, 'License.category', categoryAllDecoder)
			]));
}();
var $author$project$Model$Policy$Policy$notDecode = function (decodeValue) {
	return A2(
		$elm$json$Json$Decode$field,
		'not',
		A2($elm$json$Json$Decode$field, 'child', decodeValue));
};
var $author$project$Model$Policy$Policy$orDecode = function (decodeValue) {
	return A2(
		$elm$json$Json$Decode$field,
		'or',
		A2(
			$elm$json$Json$Decode$field,
			'children',
			$elm$json$Json$Decode$list(decodeValue)));
};
var $author$project$Model$Policy$Policy$PackageName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$Policy$Policy$PackageNameAndConstraint = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Model$Policy$Policy$packageDecode = function () {
	var nameDecoder = A2(
		$elm$json$Json$Decode$map,
		$author$project$Model$Policy$Policy$PackageName,
		A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string));
	var nameAndConstraintDecoder = A3(
		$elm$json$Json$Decode$map2,
		$author$project$Model$Policy$Policy$PackageNameAndConstraint,
		A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'constraint', $elm$json$Json$Decode$string));
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, 'Package.name', nameDecoder),
				A2($elm$json$Json$Decode$field, 'Package.nameAndConstraint', nameAndConstraintDecoder)
			]));
}();
var $author$project$Model$Policy$Policy$PolicyName = $elm$core$Basics$identity;
var $author$project$Model$Policy$Policy$policyDecode = function () {
	var nameDecoder = A2(
		$elm$json$Json$Decode$map,
		$elm$core$Basics$identity,
		A2(
			$elm$json$Json$Decode$andThen,
			function (rawName) {
				var stripped = A2($elm$core$String$dropLeft, 1, rawName);
				return (A2($elm$core$String$startsWith, '$', rawName) && ((!A2($elm$core$String$startsWith, '$', stripped)) && (stripped !== ''))) ? $elm$json$Json$Decode$succeed(stripped) : $elm$json$Json$Decode$fail('Invalid policy name: \"' + (rawName + '\"'));
			},
			A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string)));
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, 'Policy.passes', nameDecoder)
			]));
}();
var $author$project$Model$Policy$Policy$ProjectName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$Policy$Policy$ProjectVisibility = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$Visibility$fromString = function (visibilityString) {
	var _v0 = $elm$core$String$toLower(visibilityString);
	switch (_v0) {
		case 'private':
			return $elm$core$Result$Ok(0);
		case 'public':
			return $elm$core$Result$Ok(1);
		default:
			return $elm$core$Result$Err('\"' + (visibilityString + '\" is not a valid visibility'));
	}
};
var $author$project$Model$Policy$Policy$visibilityDecode = A2(
	$elm$json$Json$Decode$andThen,
	function (visibilityString) {
		var _v0 = $author$project$Model$Visibility$fromString(visibilityString);
		if (!_v0.$) {
			var visibility = _v0.a;
			return $elm$json$Json$Decode$succeed(visibility);
		} else {
			var error = _v0.a;
			return $elm$json$Json$Decode$fail(error);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$Policy$Policy$projectDecode = function () {
	var visibilityDecoder = A2(
		$elm$json$Json$Decode$map,
		$author$project$Model$Policy$Policy$ProjectVisibility,
		A2($elm$json$Json$Decode$field, 'visibility', $author$project$Model$Policy$Policy$visibilityDecode));
	var nameDecoder = A2(
		$elm$json$Json$Decode$map,
		$author$project$Model$Policy$Policy$ProjectName,
		A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string));
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, 'Project.name', nameDecoder),
				A2($elm$json$Json$Decode$field, 'Project.visibility', visibilityDecoder)
			]));
}();
var $author$project$Model$Policy$Policy$VulnerabilityCVEIDAny = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$Policy$Policy$VulnerabilitySeverityLTAll = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$Policy$Policy$VulnerabilitySeverityLTAllWithAgeInDays = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Model$Comparator$Eq = 2;
var $author$project$Model$Comparator$Gt = 0;
var $author$project$Model$Comparator$Gte = 1;
var $author$project$Model$Comparator$Lt = 4;
var $author$project$Model$Comparator$Lte = 5;
var $author$project$Model$Comparator$Ne = 3;
var $author$project$Model$Comparator$fromString = function (s) {
	switch (s) {
		case '>':
			return $elm$core$Result$Ok(0);
		case '>=':
			return $elm$core$Result$Ok(1);
		case '==':
			return $elm$core$Result$Ok(2);
		case '=':
			return $elm$core$Result$Ok(2);
		case '!=':
			return $elm$core$Result$Ok(3);
		case '<':
			return $elm$core$Result$Ok(4);
		case '<=':
			return $elm$core$Result$Ok(5);
		default:
			return $elm$core$Result$Err('\"' + (s + '\" is not a valid comparator'));
	}
};
var $author$project$Model$Policy$Policy$comparatorDecode = A2(
	$elm$json$Json$Decode$andThen,
	function (comparatorString) {
		var _v0 = $author$project$Model$Comparator$fromString(comparatorString);
		if (!_v0.$) {
			var comparator = _v0.a;
			return $elm$json$Json$Decode$succeed(comparator);
		} else {
			var error = _v0.a;
			return $elm$json$Json$Decode$fail(error);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$Policy$Policy$daysDecode = $elm$json$Json$Decode$int;
var $author$project$Model$Severity$Critical = 4;
var $author$project$Model$Severity$High = 3;
var $author$project$Model$Severity$Low = 1;
var $author$project$Model$Severity$Medium = 2;
var $author$project$Model$Severity$Unscored = 0;
var $author$project$Model$Severity$fromString = function (severity) {
	var _v0 = $elm$core$String$toLower(severity);
	switch (_v0) {
		case 'critical':
			return 4;
		case 'high':
			return 3;
		case 'medium':
			return 2;
		case 'moderate':
			return 2;
		case 'low':
			return 1;
		default:
			return 0;
	}
};
var $author$project$Model$Policy$Policy$vulnerabilityDecode = function () {
	var severityDecoder = A2($elm$json$Json$Decode$map, $author$project$Model$Severity$fromString, $elm$json$Json$Decode$string);
	var severityLTDecoder = A2(
		$elm$json$Json$Decode$map,
		$author$project$Model$Policy$Policy$VulnerabilitySeverityLTAll,
		A2($elm$json$Json$Decode$field, 'severity', severityDecoder));
	var severityLTWithAgeInDaysDecoder = A4(
		$elm$json$Json$Decode$map3,
		$author$project$Model$Policy$Policy$VulnerabilitySeverityLTAllWithAgeInDays,
		A2($elm$json$Json$Decode$field, 'severity', severityDecoder),
		A2($elm$json$Json$Decode$field, 'comparator', $author$project$Model$Policy$Policy$comparatorDecode),
		A2($elm$json$Json$Decode$field, 'days', $author$project$Model$Policy$Policy$daysDecode));
	var cveIDDecoder = A2(
		$elm$json$Json$Decode$map,
		$author$project$Model$Policy$Policy$VulnerabilityCVEIDAny,
		A2($elm$json$Json$Decode$field, 'cveID', $elm$json$Json$Decode$string));
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, 'Vulnerability.cveIDAny', cveIDDecoder),
				A2($elm$json$Json$Decode$field, 'Vulnerability.severityLTAll', severityLTDecoder),
				A2($elm$json$Json$Decode$field, 'Vulnerability.severityLTAllWithAgeInDays', severityLTWithAgeInDaysDecoder)
			]));
}();
function $author$project$Model$Policy$Policy$cyclic$decodeExpr() {
	var rec = $elm$json$Json$Decode$lazy(
		function (_v0) {
			return $author$project$Model$Policy$Policy$cyclic$decodeExpr();
		});
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Model$Policy$Policy$PolicyExprLet,
				$author$project$Model$Policy$Policy$letDecode(rec)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Model$Policy$Policy$PolicyExprAnd,
				$author$project$Model$Policy$Policy$andDecode(rec)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Model$Policy$Policy$PolicyExprOr,
				$author$project$Model$Policy$Policy$orDecode(rec)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Model$Policy$Policy$PolicyExprNot,
				$author$project$Model$Policy$Policy$notDecode(rec)),
				A2($elm$json$Json$Decode$map, $author$project$Model$Policy$Policy$PolicyExprLanguage, $author$project$Model$Policy$Policy$languageDecode),
				A2($elm$json$Json$Decode$map, $author$project$Model$Policy$Policy$PolicyExprLicense, $author$project$Model$Policy$Policy$licenseDecode),
				A2($elm$json$Json$Decode$map, $author$project$Model$Policy$Policy$PolicyExprPackage, $author$project$Model$Policy$Policy$packageDecode),
				A2($elm$json$Json$Decode$map, $author$project$Model$Policy$Policy$PolicyExprPolicy, $author$project$Model$Policy$Policy$policyDecode),
				A2($elm$json$Json$Decode$map, $author$project$Model$Policy$Policy$PolicyExprProject, $author$project$Model$Policy$Policy$projectDecode),
				A2($elm$json$Json$Decode$map, $author$project$Model$Policy$Policy$PolicyExprVulnerability, $author$project$Model$Policy$Policy$vulnerabilityDecode),
				A2($elm$json$Json$Decode$map, $author$project$Model$Policy$Policy$PolicyExprUnknown, $elm$json$Json$Decode$value)
			]));
}
var $author$project$Model$Policy$Policy$decodeExpr = $author$project$Model$Policy$Policy$cyclic$decodeExpr();
$author$project$Model$Policy$Policy$cyclic$decodeExpr = function () {
	return $author$project$Model$Policy$Policy$decodeExpr;
};
var $author$project$Model$Policy$PolicyRules$And = {$: 1};
var $author$project$Model$Policy$PolicyRules$AnyLicensesAreNamed = function (a) {
	return {$: 8, a: a};
};
var $author$project$Model$Policy$PolicyRules$HasCVE = function (a) {
	return {$: 14, a: a};
};
var $author$project$Model$Policy$PolicyRules$LanguageName = function (a) {
	return {$: 4, a: a};
};
var $author$project$Model$Policy$PolicyRules$LanguageNameAndVersion = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Model$Policy$PolicyRules$LanguageStatus = function (a) {
	return {$: 6, a: a};
};
var $author$project$Model$Policy$PolicyRules$Let = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$Policy$PolicyRules$LicensesAre = function (a) {
	return {$: 7, a: a};
};
var $author$project$Model$Policy$PolicyRules$Not = {$: 3};
var $author$project$Model$Policy$PolicyRules$Or = {$: 2};
var $author$project$Model$Policy$PolicyRules$PackageMatches = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Model$Policy$PolicyRules$PackageNameIs = function (a) {
	return {$: 9, a: a};
};
var $author$project$Model$Policy$PolicyRules$PassesPolicy = function (a) {
	return {$: 11, a: a};
};
var $author$project$Model$Policy$PolicyRules$ProjectIs = function (a) {
	return {$: 12, a: a};
};
var $author$project$Model$Policy$PolicyRules$ProjectVisibility = function (a) {
	return {$: 13, a: a};
};
var $author$project$Model$Policy$PolicyRules$Unknown = function (a) {
	return {$: 17, a: a};
};
var $author$project$Model$Policy$PolicyRules$VulnsAreAllLessThan = function (a) {
	return {$: 15, a: a};
};
var $author$project$Model$Policy$PolicyRules$VulnsAreAllLessThanWithAgeInDays = F3(
	function (a, b, c) {
		return {$: 16, a: a, b: b, c: c};
	});
var $author$project$Model$Policy$LetIn$mainName = 'main';
var $author$project$Model$Policy$LetIn$map = F2(
	function (mapper, _v0) {
		var main = _v0.eu;
		var exprs = _v0.lS;
		return {
			lS: A2($elm$core$Dict$map, mapper, exprs),
			eu: A2(mapper, $author$project$Model$Policy$LetIn$mainName, main)
		};
	});
var $zwilias$elm_rosetree$Tree$Tree = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $zwilias$elm_rosetree$Tree$singleton = function (v) {
	return A2($zwilias$elm_rosetree$Tree$Tree, v, _List_Nil);
};
var $zwilias$elm_rosetree$Tree$tree = $zwilias$elm_rosetree$Tree$Tree;
var $author$project$Model$Policy$Policy$exprToRules = function (expr) {
	switch (expr.$) {
		case 0:
			var exprs = expr.a;
			return $zwilias$elm_rosetree$Tree$singleton(
				$author$project$Model$Policy$PolicyRules$Let(
					A2(
						$author$project$Model$Policy$LetIn$map,
						$elm$core$Basics$always($author$project$Model$Policy$Policy$exprToRules),
						exprs)));
		case 1:
			var subExprs = expr.a;
			return A2(
				$zwilias$elm_rosetree$Tree$tree,
				$author$project$Model$Policy$PolicyRules$And,
				A2($elm$core$List$map, $author$project$Model$Policy$Policy$exprToRules, subExprs));
		case 2:
			var subExprs = expr.a;
			return A2(
				$zwilias$elm_rosetree$Tree$tree,
				$author$project$Model$Policy$PolicyRules$Or,
				A2($elm$core$List$map, $author$project$Model$Policy$Policy$exprToRules, subExprs));
		case 3:
			var subExpr = expr.a;
			return A2(
				$zwilias$elm_rosetree$Tree$tree,
				$author$project$Model$Policy$PolicyRules$Not,
				_List_fromArray(
					[
						$author$project$Model$Policy$Policy$exprToRules(subExpr)
					]));
		case 4:
			var rule = expr.a;
			switch (rule.$) {
				case 0:
					var name = rule.a;
					return $zwilias$elm_rosetree$Tree$singleton(
						$author$project$Model$Policy$PolicyRules$LanguageName(name));
				case 1:
					var name = rule.a;
					var version = rule.b;
					return $zwilias$elm_rosetree$Tree$singleton(
						A2($author$project$Model$Policy$PolicyRules$LanguageNameAndVersion, name, version));
				default:
					var status = rule.a;
					return $zwilias$elm_rosetree$Tree$singleton(
						$author$project$Model$Policy$PolicyRules$LanguageStatus(status));
			}
		case 5:
			var rule = expr.a;
			if (!rule.$) {
				var name = rule.a;
				return $zwilias$elm_rosetree$Tree$singleton(
					$author$project$Model$Policy$PolicyRules$AnyLicensesAreNamed(name));
			} else {
				var category = rule.a;
				return $zwilias$elm_rosetree$Tree$singleton(
					$author$project$Model$Policy$PolicyRules$LicensesAre(category));
			}
		case 6:
			var rule = expr.a;
			if (!rule.$) {
				var name = rule.a;
				return $zwilias$elm_rosetree$Tree$singleton(
					$author$project$Model$Policy$PolicyRules$PackageNameIs(name));
			} else {
				var name = rule.a;
				var version = rule.b;
				return $zwilias$elm_rosetree$Tree$singleton(
					A2($author$project$Model$Policy$PolicyRules$PackageMatches, name, version));
			}
		case 7:
			var rule = expr.a;
			var policyName = rule;
			return $zwilias$elm_rosetree$Tree$singleton(
				$author$project$Model$Policy$PolicyRules$PassesPolicy(policyName));
		case 8:
			var rule = expr.a;
			if (!rule.$) {
				var name = rule.a;
				return $zwilias$elm_rosetree$Tree$singleton(
					$author$project$Model$Policy$PolicyRules$ProjectIs(name));
			} else {
				var visibility = rule.a;
				return $zwilias$elm_rosetree$Tree$singleton(
					$author$project$Model$Policy$PolicyRules$ProjectVisibility(visibility));
			}
		case 9:
			var rule = expr.a;
			switch (rule.$) {
				case 0:
					var cveID = rule.a;
					return $zwilias$elm_rosetree$Tree$singleton(
						$author$project$Model$Policy$PolicyRules$HasCVE(cveID));
				case 1:
					var severity = rule.a;
					return $zwilias$elm_rosetree$Tree$singleton(
						$author$project$Model$Policy$PolicyRules$VulnsAreAllLessThan(severity));
				default:
					var severity = rule.a;
					var comparator = rule.b;
					var days = rule.c;
					return $zwilias$elm_rosetree$Tree$singleton(
						A3(
							$author$project$Model$Policy$PolicyRules$VulnsAreAllLessThanWithAgeInDays,
							severity,
							comparator,
							$elm$core$String$fromInt(days)));
			}
		default:
			var value = expr.a;
			return $zwilias$elm_rosetree$Tree$singleton(
				$author$project$Model$Policy$PolicyRules$Unknown(value));
	}
};
var $author$project$Model$Policy$Policy$decodeNameless = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Model$Policy$Policy$NamelessPolicy,
	A2($elm$json$Json$Decode$field, 'description', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'expr',
		A2($elm$json$Json$Decode$map, $author$project$Model$Policy$Policy$exprToRules, $author$project$Model$Policy$Policy$decodeExpr)));
var $author$project$Model$Policy$Policies$decode = A2(
	$elm$json$Json$Decode$map,
	$author$project$Model$Policy$LetIn$map($author$project$Model$Policy$Policy$addName),
	$author$project$Model$Policy$LetIn$decode(
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['policy']),
			$author$project$Model$Policy$Policy$decodeNameless)));
var $author$project$BuildPlanner$Object$Policy$expr = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'BuildPlannerScalarCodecs.BuildExpr',
	'expr',
	_List_Nil,
	$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).k8.qN);
var $author$project$BuildPlanner$Object$Policy$policyID = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'BuildPlannerScalarCodecs.Id',
	'policyID',
	_List_Nil,
	$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).oc.qN);
var $author$project$BuildPlanner$Object$Policy$userID = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'BuildPlannerScalarCodecs.Id',
	'userID',
	_List_Nil,
	$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).oc.qN);
var $author$project$Model$Policy$Policies$selectionSetOrgPolicy = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($author$project$BuildPlannerScalarCodecs$selectionSetJson, $author$project$Model$Policy$Policies$decode, $author$project$BuildPlanner$Object$Policy$expr),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$Policy$added,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$BuildPlanner$Object$Policy$userID,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$BuildPlanner$Object$Policy$policyID,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$Policy$Policies$OrgPolicy)))));
var $author$project$Model$Policy$Policies$selectionSetGetResult = function (orgUrlName) {
	return $author$project$BuildPlanner$Union$PolicyResult$fragments(
		{
			vp: $author$project$BuildPlannerScalarCodecs$selectionSetFail('Organization or policyexpr not found when fetching policy: ' + orgUrlName),
			vs: $author$project$Model$Policy$Policies$selectionSetOrgPolicy
		});
};
var $author$project$Request$BuildPlanner$getPolicy = F2(
	function (session, orgUrlName) {
		var creds = $author$project$Model$Session$getCreds(session);
		return A5(
			$author$project$GraphQL$Utils$queryRequest,
			creds,
			4,
			_List_Nil,
			'GetPolicy',
			A2(
				$author$project$BuildPlanner$Query$policy,
				{c3: orgUrlName},
				$author$project$Model$Policy$Policies$selectionSetGetResult(orgUrlName)));
	});
var $author$project$Builder$InputObject$buildUuid_comparison_exp = function (fillOptionals____) {
	var optionals____ = fillOptionals____(
		{aW: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aY: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aZ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a_: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a0: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a4: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a5: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
	return {aW: optionals____.aW, aY: optionals____.aY, aZ: optionals____.aZ, a_: optionals____.a_, a$: optionals____.a$, a0: optionals____.a0, a1: optionals____.a1, a4: optionals____.a4, a5: optionals____.a5};
};
var $author$project$Request$Project$getProjectsByOrgs = F2(
	function (creds, orgID) {
		var uuidEq = $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
			$author$project$Builder$InputObject$buildUuid_comparison_exp(
				function (args) {
					return _Utils_update(
						args,
						{
							aW: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(orgID)
						});
				}));
		var orgIDEq = $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
			$author$project$Builder$InputObject$buildOrganizations_bool_exp(
				function (args) {
					return _Utils_update(
						args,
						{E: uuidEq});
				}));
		var organizationOrgIDEq = $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
			$author$project$Builder$InputObject$buildProjects_bool_exp(
				function (args) {
					return _Utils_update(
						args,
						{c3: orgIDEq});
				}));
		var projectsOptionalArgument = function (optionalArgs) {
			return _Utils_update(
				optionalArgs,
				{ao: organizationOrgIDEq});
		};
		return A5(
			$author$project$GraphQL$Utils$queryRequest,
			creds,
			0,
			_List_Nil,
			'GetProjectsByOrgIds',
			A2($author$project$Builder$Query$projects, projectsOptionalArgument, $author$project$Model$Project$selectionSet));
	});
var $author$project$Pages$OrgPolicy$init = F3(
	function (session, _v0, orgName) {
		var getPolicies = A2($author$project$Request$BuildPlanner$getPolicy, session, orgName);
		var creds = $author$project$Model$Session$getCreds(session);
		var getMembers = A2($author$project$Request$Member$list, orgName, creds);
		var getOrganizationBundle = A2(
			$elm$core$Task$andThen,
			function (org) {
				return A2(
					$elm$core$Task$map,
					$author$project$Pages$OrgPolicy$OrganizationBundle(org),
					A2($author$project$Request$Project$getProjectsByOrgs, creds, org.zw));
			},
			A2($author$project$Request$Organization$get, orgName, creds));
		var _v1 = A4($0ui$elm_task_parallel$Task$Parallel$attempt3, $author$project$Task$Parallel$Extra$DownloadUpdated3, getOrganizationBundle, getMembers, getPolicies);
		var downloadState = _v1.a;
		var downloadCmd = _v1.b;
		return _Utils_Tuple2(
			{x7: downloadState},
			downloadCmd);
	});
var $author$project$Pages$OrgRemediation$OrgAndProjects = F2(
	function (organization, projects) {
		return {c3: organization, gx: projects};
	});
var $author$project$Pages$OrgRemediation$init = F3(
	function (session, _v0, orgName) {
		var fetchTimestamp = $elm$time$Time$now;
		var creds = $author$project$Model$Session$getCreds(session);
		var fetchMembers = A2($author$project$Request$Member$list, orgName, creds);
		var fetchOrgAndProjects = A2(
			$elm$core$Task$andThen,
			function (org) {
				return A2(
					$elm$core$Task$map,
					$author$project$Pages$OrgRemediation$OrgAndProjects(org),
					A2($author$project$Request$Project$getProjectsByOrgs, creds, org.zw));
			},
			A2($author$project$Request$Organization$get, orgName, creds));
		var _v1 = A4($0ui$elm_task_parallel$Task$Parallel$attempt3, $author$project$Task$Parallel$Extra$DownloadUpdated3, fetchOrgAndProjects, fetchMembers, fetchTimestamp);
		var downloadState = _v1.a;
		var downloadCmd = _v1.b;
		return _Utils_Tuple2(
			{x7: downloadState},
			downloadCmd);
	});
var $author$project$Request$Tier$getTiers = function (creds) {
	return $author$project$Http$Extra$get(
		{
			iO: $author$project$Http$Extra$Creds(creds),
			sY: $author$project$Http$Extra$emptyBody,
			qN: $elm$json$Json$Decode$list($author$project$Model$Tier$decode),
			CN: _List_Nil,
			GT: '/tiers'
		});
};
var $author$project$Pages$OrgScan$init = F4(
	function (session, key, host, orgName) {
		var getTierFromList = F2(
			function (tiers, org) {
				return A2(
					$elm_community$list_extra$List$Extra$find,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Model$Tier$name,
						$elm$core$Basics$eq(org.dc)),
					tiers);
			});
		var finishModel = F3(
			function (loadedOrg, loadedMembers, tiers) {
				return {
					oi: $author$project$Model$CopyStatus$empty,
					Y: key,
					hB: loadedMembers,
					c3: loadedOrg,
					dc: A2(getTierFromList, tiers, loadedOrg),
					wU: host + '/'
				};
			});
		var creds = $author$project$Model$Session$getCreds(session);
		var getMembers = A2($author$project$Request$Member$list, orgName, creds);
		var getOrganization = A2($author$project$Request$Organization$get, orgName, creds);
		var allTiers = $author$project$Request$Tier$getTiers(creds);
		return A2(
			$author$project$Task$Pipeline$fetch,
			allTiers,
			A2(
				$author$project$Task$Pipeline$fetch,
				getMembers,
				A2(
					$author$project$Task$Pipeline$fetch,
					getOrganization,
					$elm$core$Task$succeed(finishModel))));
	});
var $author$project$Pages$OrgSecurity$init = F2(
	function (session, orgName) {
		var creds = $author$project$Model$Session$getCreds(session);
		var getMembers = A2($author$project$Request$Member$list, orgName, creds);
		var getOrganization = A2($author$project$Request$Organization$get, orgName, creds);
		var _v0 = A3($0ui$elm_task_parallel$Task$Parallel$attempt2, $author$project$Task$Parallel$Extra$DownloadUpdated2, getOrganization, getMembers);
		var downloadState = _v0.a;
		var downloadCmd = _v0.b;
		return _Utils_Tuple2(
			{x7: downloadState},
			downloadCmd);
	});
var $author$project$Model$BillingInfo$BillingInfo = function (billingAddress) {
	return function (shippingAddress) {
		return function (cardAddress) {
			return function (cardInfo) {
				return function (email) {
					return function (isStripeCustomer) {
						return function (customerID) {
							return function (selfServe) {
								return function (resellerManaged) {
									return function (externalURL) {
										return function (hasEverHadTrial) {
											return {xm: billingAddress, Bs: cardAddress, Bt: cardInfo, B8: customerID, lJ: email, CB: externalURL, CM: hasEverHadTrial, DH: isStripeCustomer, FH: resellerManaged, FY: selfServe, z4: shippingAddress};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Model$AddressInfo$AddressInfo = F8(
	function (name, email, address1, address2, city, country, state, zip) {
		return {qd: address1, sQ: address2, qB: city, qK: country, lJ: email, w: name, bB: state, sM: zip};
	});
var $author$project$Model$Countries$decoder = F2(
	function (fn, val) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Decode$fail('Unknown country ' + val),
			A2(
				$elm$core$Maybe$map,
				$elm$json$Json$Decode$succeed,
				fn(val)));
	});
var $author$project$Model$Countries$countries = _List_fromArray(
	[
		{xc: 'AF', w: 'Afghanistan'},
		{xc: 'AX', w: 'Åland Islands'},
		{xc: 'AL', w: 'Albania'},
		{xc: 'DZ', w: 'Algeria'},
		{xc: 'AS', w: 'American Samoa'},
		{xc: 'AD', w: 'Andorra'},
		{xc: 'AO', w: 'Angola'},
		{xc: 'AI', w: 'Anguilla'},
		{xc: 'AQ', w: 'Antarctica'},
		{xc: 'AG', w: 'Antigua and Barbuda'},
		{xc: 'AR', w: 'Argentina'},
		{xc: 'AM', w: 'Armenia'},
		{xc: 'AW', w: 'Aruba'},
		{xc: 'AU', w: 'Australia'},
		{xc: 'AT', w: 'Austria'},
		{xc: 'AZ', w: 'Azerbaijan'},
		{xc: 'BS', w: 'Bahamas'},
		{xc: 'BH', w: 'Bahrain'},
		{xc: 'BD', w: 'Bangladesh'},
		{xc: 'BB', w: 'Barbados'},
		{xc: 'BY', w: 'Belarus'},
		{xc: 'BE', w: 'Belgium'},
		{xc: 'BZ', w: 'Belize'},
		{xc: 'BJ', w: 'Benin'},
		{xc: 'BM', w: 'Bermuda'},
		{xc: 'BT', w: 'Bhutan'},
		{xc: 'BO', w: 'Bolivia, Plurinational State of'},
		{xc: 'BQ', w: 'Bonaire, Sint Eustatius and Saba'},
		{xc: 'BA', w: 'Bosnia and Herzegovina'},
		{xc: 'BW', w: 'Botswana'},
		{xc: 'BV', w: 'Bouvet Island'},
		{xc: 'BR', w: 'Brazil'},
		{xc: 'IO', w: 'British Indian Ocean Territory'},
		{xc: 'BN', w: 'Brunei Darussalam'},
		{xc: 'BG', w: 'Bulgaria'},
		{xc: 'BF', w: 'Burkina Faso'},
		{xc: 'BI', w: 'Burundi'},
		{xc: 'KH', w: 'Cambodia'},
		{xc: 'CM', w: 'Cameroon'},
		{xc: 'CA', w: 'Canada'},
		{xc: 'CV', w: 'Cape Verde'},
		{xc: 'KY', w: 'Cayman Islands'},
		{xc: 'CF', w: 'Central African Republic'},
		{xc: 'TD', w: 'Chad'},
		{xc: 'CL', w: 'Chile'},
		{xc: 'CN', w: 'China'},
		{xc: 'CX', w: 'Christmas Island'},
		{xc: 'CC', w: 'Cocos (Keeling), Islands'},
		{xc: 'CO', w: 'Colombia'},
		{xc: 'KM', w: 'Comoros'},
		{xc: 'CG', w: 'Congo'},
		{xc: 'CD', w: 'Congo, the Democratic Republic of the'},
		{xc: 'CK', w: 'Cook Islands'},
		{xc: 'CR', w: 'Costa Rica'},
		{xc: 'CI', w: 'Côte d\'Ivoire'},
		{xc: 'HR', w: 'Croatia'},
		{xc: 'CU', w: 'Cuba'},
		{xc: 'CW', w: 'Curaçao'},
		{xc: 'CY', w: 'Cyprus'},
		{xc: 'CZ', w: 'Czech Republic'},
		{xc: 'DK', w: 'Denmark'},
		{xc: 'DJ', w: 'Djibouti'},
		{xc: 'DM', w: 'Dominica'},
		{xc: 'DO', w: 'Dominican Republic'},
		{xc: 'EC', w: 'Ecuador'},
		{xc: 'EG', w: 'Egypt'},
		{xc: 'SV', w: 'El Salvador'},
		{xc: 'GQ', w: 'Equatorial Guinea'},
		{xc: 'ER', w: 'Eritrea'},
		{xc: 'EE', w: 'Estonia'},
		{xc: 'ET', w: 'Ethiopia'},
		{xc: 'FK', w: 'Falkland Islands (Malvinas),'},
		{xc: 'FO', w: 'Faroe Islands'},
		{xc: 'FJ', w: 'Fiji'},
		{xc: 'FI', w: 'Finland'},
		{xc: 'FR', w: 'France'},
		{xc: 'GF', w: 'French Guiana'},
		{xc: 'PF', w: 'French Polynesia'},
		{xc: 'TF', w: 'French Southern Territories'},
		{xc: 'GA', w: 'Gabon'},
		{xc: 'GM', w: 'Gambia'},
		{xc: 'GE', w: 'Georgia'},
		{xc: 'DE', w: 'Germany'},
		{xc: 'GH', w: 'Ghana'},
		{xc: 'GI', w: 'Gibraltar'},
		{xc: 'GR', w: 'Greece'},
		{xc: 'GL', w: 'Greenland'},
		{xc: 'GD', w: 'Grenada'},
		{xc: 'GP', w: 'Guadeloupe'},
		{xc: 'GU', w: 'Guam'},
		{xc: 'GT', w: 'Guatemala'},
		{xc: 'GG', w: 'Guernsey'},
		{xc: 'GN', w: 'Guinea'},
		{xc: 'GW', w: 'Guinea-Bissau'},
		{xc: 'GY', w: 'Guyana'},
		{xc: 'HT', w: 'Haiti'},
		{xc: 'HM', w: 'Heard Island and McDonald Islands'},
		{xc: 'VA', w: 'Holy See (Vatican City State),'},
		{xc: 'HN', w: 'Honduras'},
		{xc: 'HK', w: 'Hong Kong'},
		{xc: 'HU', w: 'Hungary'},
		{xc: 'IS', w: 'Iceland'},
		{xc: 'IN', w: 'India'},
		{xc: 'ID', w: 'Indonesia'},
		{xc: 'IR', w: 'Iran, Islamic Republic of'},
		{xc: 'IQ', w: 'Iraq'},
		{xc: 'IE', w: 'Ireland'},
		{xc: 'IM', w: 'Isle of Man'},
		{xc: 'IL', w: 'Israel'},
		{xc: 'IT', w: 'Italy'},
		{xc: 'JM', w: 'Jamaica'},
		{xc: 'JP', w: 'Japan'},
		{xc: 'JE', w: 'Jersey'},
		{xc: 'JO', w: 'Jordan'},
		{xc: 'KZ', w: 'Kazakhstan'},
		{xc: 'KE', w: 'Kenya'},
		{xc: 'KI', w: 'Kiribati'},
		{xc: 'KP', w: 'Korea, Democratic People\'s Republic of'},
		{xc: 'KR', w: 'Korea, Republic of'},
		{xc: 'KW', w: 'Kuwait'},
		{xc: 'KG', w: 'Kyrgyzstan'},
		{xc: 'LA', w: 'Lao People\'s Democratic Republic'},
		{xc: 'LV', w: 'Latvia'},
		{xc: 'LB', w: 'Lebanon'},
		{xc: 'LS', w: 'Lesotho'},
		{xc: 'LR', w: 'Liberia'},
		{xc: 'LY', w: 'Libya'},
		{xc: 'LI', w: 'Liechtenstein'},
		{xc: 'LT', w: 'Lithuania'},
		{xc: 'LU', w: 'Luxembourg'},
		{xc: 'MO', w: 'Macao'},
		{xc: 'MK', w: 'Macedonia, the Former Yugoslav Republic of'},
		{xc: 'MG', w: 'Madagascar'},
		{xc: 'MW', w: 'Malawi'},
		{xc: 'MY', w: 'Malaysia'},
		{xc: 'MV', w: 'Maldives'},
		{xc: 'ML', w: 'Mali'},
		{xc: 'MT', w: 'Malta'},
		{xc: 'MH', w: 'Marshall Islands'},
		{xc: 'MQ', w: 'Martinique'},
		{xc: 'MR', w: 'Mauritania'},
		{xc: 'MU', w: 'Mauritius'},
		{xc: 'YT', w: 'Mayotte'},
		{xc: 'MX', w: 'Mexico'},
		{xc: 'FM', w: 'Micronesia, Federated States of'},
		{xc: 'MD', w: 'Moldova, Republic of'},
		{xc: 'MC', w: 'Monaco'},
		{xc: 'MN', w: 'Mongolia'},
		{xc: 'ME', w: 'Montenegro'},
		{xc: 'MS', w: 'Montserrat'},
		{xc: 'MA', w: 'Morocco'},
		{xc: 'MZ', w: 'Mozambique'},
		{xc: 'MM', w: 'Myanmar'},
		{xc: 'NA', w: 'Namibia'},
		{xc: 'NR', w: 'Nauru'},
		{xc: 'NP', w: 'Nepal'},
		{xc: 'NL', w: 'Netherlands'},
		{xc: 'NC', w: 'New Caledonia'},
		{xc: 'NZ', w: 'New Zealand'},
		{xc: 'NI', w: 'Nicaragua'},
		{xc: 'NE', w: 'Niger'},
		{xc: 'NG', w: 'Nigeria'},
		{xc: 'NU', w: 'Niue'},
		{xc: 'NF', w: 'Norfolk Island'},
		{xc: 'MP', w: 'Northern Mariana Islands'},
		{xc: 'NO', w: 'Norway'},
		{xc: 'OM', w: 'Oman'},
		{xc: 'PK', w: 'Pakistan'},
		{xc: 'PW', w: 'Palau'},
		{xc: 'PS', w: 'Palestine, State of'},
		{xc: 'PA', w: 'Panama'},
		{xc: 'PG', w: 'Papua New Guinea'},
		{xc: 'PY', w: 'Paraguay'},
		{xc: 'PE', w: 'Peru'},
		{xc: 'PH', w: 'Philippines'},
		{xc: 'PN', w: 'Pitcairn'},
		{xc: 'PL', w: 'Poland'},
		{xc: 'PT', w: 'Portugal'},
		{xc: 'PR', w: 'Puerto Rico'},
		{xc: 'QA', w: 'Qatar'},
		{xc: 'RE', w: 'Réunion'},
		{xc: 'RO', w: 'Romania'},
		{xc: 'RU', w: 'Russian Federation'},
		{xc: 'RW', w: 'Rwanda'},
		{xc: 'BL', w: 'Saint Barthélemy'},
		{xc: 'SH', w: 'Saint Helena, Ascension and Tristan da Cunha'},
		{xc: 'KN', w: 'Saint Kitts and Nevis'},
		{xc: 'LC', w: 'Saint Lucia'},
		{xc: 'MF', w: 'Saint Martin (French part),'},
		{xc: 'PM', w: 'Saint Pierre and Miquelon'},
		{xc: 'VC', w: 'Saint Vincent and the Grenadines'},
		{xc: 'WS', w: 'Samoa'},
		{xc: 'SM', w: 'San Marino'},
		{xc: 'ST', w: 'Sao Tome and Principe'},
		{xc: 'SA', w: 'Saudi Arabia'},
		{xc: 'SN', w: 'Senegal'},
		{xc: 'RS', w: 'Serbia'},
		{xc: 'SC', w: 'Seychelles'},
		{xc: 'SL', w: 'Sierra Leone'},
		{xc: 'SG', w: 'Singapore'},
		{xc: 'SX', w: 'Sint Maarten (Dutch part),'},
		{xc: 'SK', w: 'Slovakia'},
		{xc: 'SI', w: 'Slovenia'},
		{xc: 'SB', w: 'Solomon Islands'},
		{xc: 'SO', w: 'Somalia'},
		{xc: 'ZA', w: 'South Africa'},
		{xc: 'GS', w: 'South Georgia and the South Sandwich Islands'},
		{xc: 'SS', w: 'South Sudan'},
		{xc: 'ES', w: 'Spain'},
		{xc: 'LK', w: 'Sri Lanka'},
		{xc: 'SD', w: 'Sudan'},
		{xc: 'SR', w: 'Suriname'},
		{xc: 'SJ', w: 'Svalbard and Jan Mayen'},
		{xc: 'SZ', w: 'Swaziland'},
		{xc: 'SE', w: 'Sweden'},
		{xc: 'CH', w: 'Switzerland'},
		{xc: 'SY', w: 'Syrian Arab Republic'},
		{xc: 'TW', w: 'Taiwan, Province of China'},
		{xc: 'TJ', w: 'Tajikistan'},
		{xc: 'TZ', w: 'Tanzania, United Republic of'},
		{xc: 'TH', w: 'Thailand'},
		{xc: 'TL', w: 'Timor-Leste'},
		{xc: 'TG', w: 'Togo'},
		{xc: 'TK', w: 'Tokelau'},
		{xc: 'TO', w: 'Tonga'},
		{xc: 'TT', w: 'Trinidad and Tobago'},
		{xc: 'TN', w: 'Tunisia'},
		{xc: 'TR', w: 'Turkey'},
		{xc: 'TM', w: 'Turkmenistan'},
		{xc: 'TC', w: 'Turks and Caicos Islands'},
		{xc: 'TV', w: 'Tuvalu'},
		{xc: 'UG', w: 'Uganda'},
		{xc: 'UA', w: 'Ukraine'},
		{xc: 'AE', w: 'United Arab Emirates'},
		{xc: 'GB', w: 'United Kingdom'},
		{xc: 'US', w: 'United States'},
		{xc: 'UM', w: 'United States Minor Outlying Islands'},
		{xc: 'UY', w: 'Uruguay'},
		{xc: 'UZ', w: 'Uzbekistan'},
		{xc: 'VU', w: 'Vanuatu'},
		{xc: 'VE', w: 'Venezuela, Bolivarian Republic of'},
		{xc: 'VN', w: 'Viet Nam'},
		{xc: 'VG', w: 'Virgin Islands, British'},
		{xc: 'VI', w: 'Virgin Islands, U.S.'},
		{xc: 'WF', w: 'Wallis and Futuna'},
		{xc: 'EH', w: 'Western Sahara'},
		{xc: 'YE', w: 'Yemen'},
		{xc: 'ZM', w: 'Zambia'},
		{xc: 'ZW', w: 'Zimbabwe'}
	]);
var $author$project$Model$Countries$maybeInfoFromAlpha2Code = function (alpha2Code) {
	return A2(
		$elm_community$list_extra$List$Extra$find,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.xc;
			},
			$elm$core$Basics$eq(alpha2Code)),
		$author$project$Model$Countries$countries);
};
var $author$project$Model$Countries$decodeAlpha2Code = A2(
	$elm$json$Json$Decode$andThen,
	$author$project$Model$Countries$decoder($author$project$Model$Countries$maybeInfoFromAlpha2Code),
	$elm$json$Json$Decode$string);
var $author$project$Model$Countries$maybeInfoFromName = function (name) {
	return A2(
		$elm_community$list_extra$List$Extra$find,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.w;
			},
			$elm$core$Basics$eq(name)),
		$author$project$Model$Countries$countries);
};
var $author$project$Model$Countries$decodeName = A2(
	$elm$json$Json$Decode$andThen,
	$author$project$Model$Countries$decoder($author$project$Model$Countries$maybeInfoFromName),
	$elm$json$Json$Decode$string);
var $author$project$Model$Countries$decode = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			$author$project$Model$Countries$decodeName,
			$author$project$Model$Countries$decodeAlpha2Code,
			$elm$json$Json$Decode$succeed($author$project$Model$Countries$emptyCountryInfo)
		]));
var $author$project$Model$AddressInfo$decode = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'zip',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'state',
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'country',
			$author$project$Model$Countries$decode,
			$author$project$Model$Countries$emptyCountryInfo,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'city',
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'address2',
					$elm$json$Json$Decode$string,
					'',
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'address1',
						$elm$json$Json$Decode$string,
						'',
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'email',
							$elm$json$Json$Decode$string,
							'',
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'name',
								$elm$json$Json$Decode$string,
								'',
								$elm$json$Json$Decode$succeed($author$project$Model$AddressInfo$AddressInfo)))))))));
var $author$project$Model$BillingInfo$CardInfo = F3(
	function (last4, expMonth, expYear) {
		return {Cw: expMonth, Cx: expYear, yX: last4};
	});
var $author$project$Model$BillingInfo$decodeCard = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'ccExpYear',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'ccExpMonth',
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'ccLast4',
			$elm$json$Json$Decode$string,
			'',
			$elm$json$Json$Decode$succeed($author$project$Model$BillingInfo$CardInfo))));
var $author$project$Model$BillingInfo$validateCard = function (card) {
	return $elm$core$String$isEmpty(card.yX) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(card);
};
var $author$project$Model$BillingInfo$decode = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'hasEverHadTrial',
	$elm$json$Json$Decode$bool,
	false,
	A3(
		$author$project$Json$Decode$Pipeline$Extra$decodeMaybe,
		'externalURL',
		$elm$json$Json$Decode$string,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'resellerManaged',
			$elm$json$Json$Decode$bool,
			false,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'selfServe',
				$elm$json$Json$Decode$bool,
				false,
				A3(
					$author$project$Json$Decode$Pipeline$Extra$decodeMaybe,
					'customerID',
					$elm$json$Json$Decode$string,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'isStripeCustomer',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
						$elm$core$Maybe$Just(false),
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'email',
							$elm$json$Json$Decode$string,
							'',
							A2(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
								A2($elm$json$Json$Decode$map, $author$project$Model$BillingInfo$validateCard, $author$project$Model$BillingInfo$decodeCard),
								A3(
									$author$project$Json$Decode$Pipeline$Extra$decodeMaybe,
									'cardAddress',
									$author$project$Model$AddressInfo$decode,
									A3(
										$author$project$Json$Decode$Pipeline$Extra$decodeMaybe,
										'shippingAddress',
										$author$project$Model$AddressInfo$decode,
										A3(
											$author$project$Json$Decode$Pipeline$Extra$decodeMaybe,
											'address',
											$author$project$Model$AddressInfo$decode,
											$elm$json$Json$Decode$succeed($author$project$Model$BillingInfo$BillingInfo))))))))))));
var $author$project$Request$Organization$getBilling = F2(
	function (orgName, creds) {
		return $author$project$Http$Extra$get(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$emptyBody,
				qN: $author$project$Model$BillingInfo$decode,
				CN: _List_Nil,
				GT: '/organizations/' + (orgName + '/billing')
			});
	});
var $author$project$Model$Limits$LimitsInfo = F3(
	function (usersLimit, nodesLimit, activeRuntimesLimit) {
		return {A0: activeRuntimesLimit, EB: nodesLimit, GZ: usersLimit};
	});
var $author$project$Model$Limits$decode = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'activeRuntimesLimit',
	$elm$json$Json$Decode$int,
	0,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'nodesLimit',
		$elm$json$Json$Decode$int,
		0,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'usersLimit',
			$elm$json$Json$Decode$int,
			0,
			$elm$json$Json$Decode$succeed($author$project$Model$Limits$LimitsInfo))));
var $author$project$Request$Organization$limits = F2(
	function (orgName, creds) {
		return $author$project$Http$Extra$get(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$emptyBody,
				qN: $author$project$Model$Limits$decode,
				CN: _List_Nil,
				GT: '/organizations/' + (orgName + '/limits')
			});
	});
var $author$project$Pages$OrgSettings$init = F3(
	function (session, key, orgName) {
		var getTierFromList = F2(
			function (tiers, org) {
				return A2(
					$elm_community$list_extra$List$Extra$find,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Model$Tier$name,
						$elm$core$Basics$eq(org.dc)),
					tiers);
			});
		var finishModel = F5(
			function (loadedOrg, loadedMembers, loadedLimits, tiers, loadedBillingInfo) {
				return {
					qp: loadedBillingInfo,
					fB: $elm$core$Maybe$Nothing,
					Y: key,
					D$: loadedLimits,
					hB: loadedMembers,
					c3: loadedOrg,
					fw: false,
					dc: A2(getTierFromList, tiers, loadedOrg)
				};
			});
		var creds = $author$project$Model$Session$getCreds(session);
		var getMembers = A2($author$project$Request$Member$list, orgName, creds);
		var getOrganization = A2($author$project$Request$Organization$get, orgName, creds);
		var loadLimits = A2($author$project$Request$Organization$limits, orgName, creds);
		var billingInfo = $author$project$Http$Extra$toMaybe(
			A2($author$project$Request$Organization$getBilling, orgName, creds));
		var allTiers = $author$project$Request$Tier$getTiers(creds);
		return A2(
			$author$project$Task$Pipeline$fetch,
			billingInfo,
			A2(
				$author$project$Task$Pipeline$fetch,
				allTiers,
				A2(
					$author$project$Task$Pipeline$fetch,
					loadLimits,
					A2(
						$author$project$Task$Pipeline$fetch,
						getMembers,
						A2(
							$author$project$Task$Pipeline$fetch,
							getOrganization,
							$elm$core$Task$succeed(finishModel))))));
	});
var $author$project$Pages$Orgs$init = function (session) {
	var creds = $author$project$Model$Session$getCreds(session);
	var orgsTask = $author$project$Request$Organization$list(creds);
	var createModel = function (orgs) {
		return {BV: $elm$core$Maybe$Nothing, jJ: $elm$core$Maybe$Nothing, mN: $author$project$Views$NotificationsInline$init, mX: orgs, vO: '', np: '', pO: $elm$core$Maybe$Nothing};
	};
	return A2(
		$author$project$Task$Pipeline$fetch,
		orgsTask,
		$elm$core$Task$succeed(createModel));
};
var $author$project$Pages$PreferenceDeleteAccount$Initial = 0;
var $author$project$Pages$PreferenceDeleteAccount$init = F2(
	function (key, username) {
		return $elm$core$Task$succeed(
			{jU: 0, Y: key, AE: username});
	});
var $author$project$Pages$PreferenceEmail$init = function (session) {
	var _new = function (emails) {
		return {ir: emails, oC: $elm$core$Maybe$Nothing, ka: ''};
	};
	var creds = $author$project$Model$Session$getCreds(session);
	var loadEmails = A2(
		$author$project$Request$Email$list,
		$author$project$Protected$username(creds),
		creds);
	return A2($elm$core$Task$map, _new, loadEmails);
};
var $author$project$Pages$PreferenceLinkedAccounts$FailedToLink = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$PreferenceLinkedAccounts$Linked = {$: 0};
var $author$project$Pages$PreferenceLinkedAccounts$Registered = {$: 2};
var $author$project$Model$OAuth$title = function (service) {
	if (!service) {
		return 'GitHub';
	} else {
		return 'Google';
	}
};
var $author$project$Model$OAuth$key = A2($elm$core$Basics$composeR, $author$project$Model$OAuth$title, $elm$core$String$toLower);
var $author$project$Pages$PreferenceLinkedAccounts$init = F3(
	function (session, maybeError, maybeServiceString) {
		var maybeService = A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				$elm$json$Json$Decode$decodeString($author$project$Model$OAuth$decode),
				$elm$core$Result$toMaybe),
			maybeServiceString);
		var error = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				A2($elm$core$String$replace, '+', ' '),
				maybeError));
		var canUnlink = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Bp;
				},
				$author$project$Model$Session$getUser(session)));
		var linkingStatus = canUnlink ? $author$project$Pages$PreferenceLinkedAccounts$Linked : $author$project$Pages$PreferenceLinkedAccounts$Registered;
		var status = function () {
			if (!maybeService.$) {
				var service = maybeService.a;
				return A2(
					$elm$core$Dict$insert,
					$author$project$Model$OAuth$key(service),
					$author$project$Pages$PreferenceLinkedAccounts$FailedToLink(error));
			} else {
				return $elm$core$Basics$identity;
			}
		}()(
			A3(
				$elm$core$List$foldl,
				function (service) {
					return A2(
						$elm$core$Dict$insert,
						$author$project$Model$OAuth$key(service),
						linkingStatus);
				},
				$elm$core$Dict$empty,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.D2;
						},
						$author$project$Model$Session$getUser(session)))));
		return $elm$core$Task$succeed(
			{ro: $elm$core$Maybe$Nothing, L: status});
	});
var $author$project$Pages$PreferencePassword$ChangePassword = 1;
var $author$project$Pages$PreferencePassword$SetPassword = 0;
var $author$project$Pages$PreferencePassword$init = F2(
	function (maybeMode, key) {
		var mode = function () {
			if ((!maybeMode.$) && (maybeMode.a === 'setpassword')) {
				return 0;
			} else {
				return 1;
			}
		}();
		return $elm$core$Task$succeed(
			{xP: '', Y: key, El: mode, zk: '', mG: '', o6: $elm$core$Maybe$Nothing, mH: $elm$core$Maybe$Nothing, mN: $author$project$Views$NotificationsInline$init});
	});
var $mdgriffith$elm_style_animation$Animation$Model$Property = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $mdgriffith$elm_style_animation$Animation$Model$Spring = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_style_animation$Animation$initMotion = F2(
	function (position, unit) {
		return {
			mi: $mdgriffith$elm_style_animation$Animation$Model$Spring(
				{xR: 26, Af: 170}),
			C$: $elm$core$Maybe$Nothing,
			Fl: position,
			nC: position,
			GQ: unit,
			G$: 0
		};
	});
var $mdgriffith$elm_style_animation$Animation$custom = F3(
	function (name, value, unit) {
		return A2(
			$mdgriffith$elm_style_animation$Animation$Model$Property,
			name,
			A2($mdgriffith$elm_style_animation$Animation$initMotion, value, unit));
	});
var $mdgriffith$elm_style_animation$Animation$opacity = function (val) {
	return A3($mdgriffith$elm_style_animation$Animation$custom, 'opacity', val, '');
};
var $mdgriffith$elm_style_animation$Animation$Model$Animation = $elm$core$Basics$identity;
var $mdgriffith$elm_style_animation$Animation$initialState = function (current) {
	return {
		uh: _List_Nil,
		se: false,
		Gi: _List_Nil,
		hW: current,
		As: {
			g5: $elm$time$Time$millisToPosix(0),
			Cm: $elm$time$Time$millisToPosix(0)
		}
	};
};
var $mdgriffith$elm_style_animation$Animation$Model$Easing = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$pi = _Basics_pi;
var $mdgriffith$elm_style_animation$Animation$Model$AtSpeed = function (a) {
	return {$: 2, a: a};
};
var $mdgriffith$elm_style_animation$Animation$speed = function (speedValue) {
	return $mdgriffith$elm_style_animation$Animation$Model$AtSpeed(speedValue);
};
var $mdgriffith$elm_style_animation$Animation$defaultInterpolationByProperty = function (prop) {
	var linear = function (duration) {
		return $mdgriffith$elm_style_animation$Animation$Model$Easing(
			{tJ: duration, tK: $elm$core$Basics$identity, Fq: 1, cH: 0});
	};
	var defaultSpring = $mdgriffith$elm_style_animation$Animation$Model$Spring(
		{xR: 26, Af: 170});
	switch (prop.$) {
		case 0:
			return defaultSpring;
		case 1:
			return linear(
				$elm$time$Time$millisToPosix(400));
		case 2:
			return defaultSpring;
		case 3:
			return defaultSpring;
		case 4:
			return defaultSpring;
		case 5:
			var name = prop.a;
			return (name === 'rotate3d') ? $mdgriffith$elm_style_animation$Animation$speed(
				{zF: $elm$core$Basics$pi}) : defaultSpring;
		case 6:
			return defaultSpring;
		case 7:
			return $mdgriffith$elm_style_animation$Animation$speed(
				{zF: $elm$core$Basics$pi});
		case 8:
			return defaultSpring;
		default:
			return defaultSpring;
	}
};
var $mdgriffith$elm_style_animation$Animation$Model$AngleProperty = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $mdgriffith$elm_style_animation$Animation$Model$ColorProperty = F5(
	function (a, b, c, d, e) {
		return {$: 1, a: a, b: b, c: c, d: d, e: e};
	});
var $mdgriffith$elm_style_animation$Animation$Model$ExactProperty = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_style_animation$Animation$Model$Path = function (a) {
	return {$: 9, a: a};
};
var $mdgriffith$elm_style_animation$Animation$Model$Points = function (a) {
	return {$: 8, a: a};
};
var $mdgriffith$elm_style_animation$Animation$Model$Property2 = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $mdgriffith$elm_style_animation$Animation$Model$Property3 = F4(
	function (a, b, c, d) {
		return {$: 5, a: a, b: b, c: c, d: d};
	});
var $mdgriffith$elm_style_animation$Animation$Model$Property4 = F5(
	function (a, b, c, d, e) {
		return {$: 6, a: a, b: b, c: c, d: d, e: e};
	});
var $mdgriffith$elm_style_animation$Animation$Model$ShadowProperty = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $mdgriffith$elm_style_animation$Animation$Model$AntiClockwiseArc = function (a) {
	return {$: 17, a: a};
};
var $mdgriffith$elm_style_animation$Animation$Model$ClockwiseArc = function (a) {
	return {$: 16, a: a};
};
var $mdgriffith$elm_style_animation$Animation$Model$Close = {$: 18};
var $mdgriffith$elm_style_animation$Animation$Model$Curve = function (a) {
	return {$: 8, a: a};
};
var $mdgriffith$elm_style_animation$Animation$Model$CurveTo = function (a) {
	return {$: 9, a: a};
};
var $mdgriffith$elm_style_animation$Animation$Model$Horizontal = function (a) {
	return {$: 4, a: a};
};
var $mdgriffith$elm_style_animation$Animation$Model$HorizontalTo = function (a) {
	return {$: 5, a: a};
};
var $mdgriffith$elm_style_animation$Animation$Model$Line = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $mdgriffith$elm_style_animation$Animation$Model$LineTo = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $mdgriffith$elm_style_animation$Animation$Model$Move = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_style_animation$Animation$Model$MoveTo = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $mdgriffith$elm_style_animation$Animation$Model$Quadratic = function (a) {
	return {$: 10, a: a};
};
var $mdgriffith$elm_style_animation$Animation$Model$QuadraticTo = function (a) {
	return {$: 11, a: a};
};
var $mdgriffith$elm_style_animation$Animation$Model$Smooth = function (a) {
	return {$: 14, a: a};
};
var $mdgriffith$elm_style_animation$Animation$Model$SmoothQuadratic = function (a) {
	return {$: 12, a: a};
};
var $mdgriffith$elm_style_animation$Animation$Model$SmoothQuadraticTo = function (a) {
	return {$: 13, a: a};
};
var $mdgriffith$elm_style_animation$Animation$Model$SmoothTo = function (a) {
	return {$: 15, a: a};
};
var $mdgriffith$elm_style_animation$Animation$Model$Vertical = function (a) {
	return {$: 6, a: a};
};
var $mdgriffith$elm_style_animation$Animation$Model$VerticalTo = function (a) {
	return {$: 7, a: a};
};
var $mdgriffith$elm_style_animation$Animation$Model$mapPathMotion = F2(
	function (fn, cmd) {
		var mapCoords = function (coords) {
			return A2(
				$elm$core$List$map,
				function (_v1) {
					var x = _v1.a;
					var y = _v1.b;
					return _Utils_Tuple2(
						fn(x),
						fn(y));
				},
				coords);
		};
		switch (cmd.$) {
			case 0:
				var m1 = cmd.a;
				var m2 = cmd.b;
				return A2(
					$mdgriffith$elm_style_animation$Animation$Model$Move,
					fn(m1),
					fn(m2));
			case 1:
				var m1 = cmd.a;
				var m2 = cmd.b;
				return A2(
					$mdgriffith$elm_style_animation$Animation$Model$MoveTo,
					fn(m1),
					fn(m2));
			case 2:
				var m1 = cmd.a;
				var m2 = cmd.b;
				return A2(
					$mdgriffith$elm_style_animation$Animation$Model$Line,
					fn(m1),
					fn(m2));
			case 3:
				var m1 = cmd.a;
				var m2 = cmd.b;
				return A2(
					$mdgriffith$elm_style_animation$Animation$Model$LineTo,
					fn(m1),
					fn(m2));
			case 4:
				var motion = cmd.a;
				return $mdgriffith$elm_style_animation$Animation$Model$Horizontal(
					fn(motion));
			case 5:
				var motion = cmd.a;
				return $mdgriffith$elm_style_animation$Animation$Model$HorizontalTo(
					fn(motion));
			case 6:
				var motion = cmd.a;
				return $mdgriffith$elm_style_animation$Animation$Model$Vertical(
					fn(motion));
			case 7:
				var motion = cmd.a;
				return $mdgriffith$elm_style_animation$Animation$Model$VerticalTo(
					fn(motion));
			case 8:
				var control1 = cmd.a.og;
				var control2 = cmd.a.oh;
				var point = cmd.a.hL;
				return $mdgriffith$elm_style_animation$Animation$Model$Curve(
					{
						og: _Utils_Tuple2(
							fn(control1.a),
							fn(control1.b)),
						oh: _Utils_Tuple2(
							fn(control2.a),
							fn(control2.b)),
						hL: _Utils_Tuple2(
							fn(point.a),
							fn(point.b))
					});
			case 9:
				var control1 = cmd.a.og;
				var control2 = cmd.a.oh;
				var point = cmd.a.hL;
				return $mdgriffith$elm_style_animation$Animation$Model$CurveTo(
					{
						og: _Utils_Tuple2(
							fn(control1.a),
							fn(control1.b)),
						oh: _Utils_Tuple2(
							fn(control2.a),
							fn(control2.b)),
						hL: _Utils_Tuple2(
							fn(point.a),
							fn(point.b))
					});
			case 10:
				var control = cmd.a.of;
				var point = cmd.a.hL;
				return $mdgriffith$elm_style_animation$Animation$Model$Quadratic(
					{
						of: _Utils_Tuple2(
							fn(control.a),
							fn(control.b)),
						hL: _Utils_Tuple2(
							fn(point.a),
							fn(point.b))
					});
			case 11:
				var control = cmd.a.of;
				var point = cmd.a.hL;
				return $mdgriffith$elm_style_animation$Animation$Model$QuadraticTo(
					{
						of: _Utils_Tuple2(
							fn(control.a),
							fn(control.b)),
						hL: _Utils_Tuple2(
							fn(point.a),
							fn(point.b))
					});
			case 12:
				var coords = cmd.a;
				return $mdgriffith$elm_style_animation$Animation$Model$SmoothQuadratic(
					mapCoords(coords));
			case 13:
				var coords = cmd.a;
				return $mdgriffith$elm_style_animation$Animation$Model$SmoothQuadraticTo(
					mapCoords(coords));
			case 14:
				var coords = cmd.a;
				return $mdgriffith$elm_style_animation$Animation$Model$Smooth(
					mapCoords(coords));
			case 15:
				var coords = cmd.a;
				return $mdgriffith$elm_style_animation$Animation$Model$SmoothTo(
					mapCoords(coords));
			case 16:
				var arc = cmd.a;
				return $mdgriffith$elm_style_animation$Animation$Model$ClockwiseArc(
					function () {
						var y = arc.AT;
						var x = arc.AS;
						var startAngle = arc.pS;
						var radius = arc.pz;
						var endAngle = arc.os;
						return _Utils_update(
							arc,
							{
								os: fn(endAngle),
								pz: fn(radius),
								pS: fn(startAngle),
								AS: fn(x),
								AT: fn(y)
							});
					}());
			case 17:
				var arc = cmd.a;
				return $mdgriffith$elm_style_animation$Animation$Model$AntiClockwiseArc(
					function () {
						var y = arc.AT;
						var x = arc.AS;
						var startAngle = arc.pS;
						var radius = arc.pz;
						var endAngle = arc.os;
						return _Utils_update(
							arc,
							{
								os: fn(endAngle),
								pz: fn(radius),
								pS: fn(startAngle),
								AS: fn(x),
								AT: fn(y)
							});
					}());
			default:
				return $mdgriffith$elm_style_animation$Animation$Model$Close;
		}
	});
var $mdgriffith$elm_style_animation$Animation$Model$mapToMotion = F2(
	function (fn, prop) {
		switch (prop.$) {
			case 0:
				var name = prop.a;
				var value = prop.b;
				return A2($mdgriffith$elm_style_animation$Animation$Model$ExactProperty, name, value);
			case 1:
				var name = prop.a;
				var m1 = prop.b;
				var m2 = prop.c;
				var m3 = prop.d;
				var m4 = prop.e;
				return A5(
					$mdgriffith$elm_style_animation$Animation$Model$ColorProperty,
					name,
					fn(m1),
					fn(m2),
					fn(m3),
					fn(m4));
			case 2:
				var name = prop.a;
				var inset = prop.b;
				var shadow = prop.c;
				var size = shadow.we;
				var red = shadow.vW;
				var offsetY = shadow.hG;
				var offsetX = shadow.hF;
				var green = shadow.tZ;
				var blur = shadow.hm;
				var blue = shadow.sX;
				var alpha = shadow.kN;
				return A3(
					$mdgriffith$elm_style_animation$Animation$Model$ShadowProperty,
					name,
					inset,
					{
						kN: fn(alpha),
						sX: fn(blue),
						hm: fn(blur),
						tZ: fn(green),
						hF: fn(offsetX),
						hG: fn(offsetY),
						vW: fn(red),
						we: fn(size)
					});
			case 3:
				var name = prop.a;
				var m1 = prop.b;
				return A2(
					$mdgriffith$elm_style_animation$Animation$Model$Property,
					name,
					fn(m1));
			case 4:
				var name = prop.a;
				var m1 = prop.b;
				var m2 = prop.c;
				return A3(
					$mdgriffith$elm_style_animation$Animation$Model$Property2,
					name,
					fn(m1),
					fn(m2));
			case 5:
				var name = prop.a;
				var m1 = prop.b;
				var m2 = prop.c;
				var m3 = prop.d;
				return A4(
					$mdgriffith$elm_style_animation$Animation$Model$Property3,
					name,
					fn(m1),
					fn(m2),
					fn(m3));
			case 6:
				var name = prop.a;
				var m1 = prop.b;
				var m2 = prop.c;
				var m3 = prop.d;
				var m4 = prop.e;
				return A5(
					$mdgriffith$elm_style_animation$Animation$Model$Property4,
					name,
					fn(m1),
					fn(m2),
					fn(m3),
					fn(m4));
			case 7:
				var name = prop.a;
				var m1 = prop.b;
				return A2(
					$mdgriffith$elm_style_animation$Animation$Model$AngleProperty,
					name,
					fn(m1));
			case 8:
				var ms = prop.a;
				return $mdgriffith$elm_style_animation$Animation$Model$Points(
					A2(
						$elm$core$List$map,
						function (_v1) {
							var x = _v1.a;
							var y = _v1.b;
							return _Utils_Tuple2(
								fn(x),
								fn(y));
						},
						ms));
			default:
				var cmds = prop.a;
				return $mdgriffith$elm_style_animation$Animation$Model$Path(
					A2(
						$elm$core$List$map,
						$mdgriffith$elm_style_animation$Animation$Model$mapPathMotion(fn),
						cmds));
		}
	});
var $mdgriffith$elm_style_animation$Animation$setDefaultInterpolation = function (prop) {
	var interp = $mdgriffith$elm_style_animation$Animation$defaultInterpolationByProperty(prop);
	return A2(
		$mdgriffith$elm_style_animation$Animation$Model$mapToMotion,
		function (m) {
			return _Utils_update(
				m,
				{mi: interp});
		},
		prop);
};
var $mdgriffith$elm_style_animation$Animation$Render$dropWhile = F2(
	function (predicate, list) {
		dropWhile:
		while (true) {
			if (!list.b) {
				return _List_Nil;
			} else {
				var x = list.a;
				var xs = list.b;
				if (predicate(x)) {
					var $temp$predicate = predicate,
						$temp$list = xs;
					predicate = $temp$predicate;
					list = $temp$list;
					continue dropWhile;
				} else {
					return list;
				}
			}
		}
	});
var $mdgriffith$elm_style_animation$Animation$Render$takeWhile = function (predicate) {
	var takeWhileMemo = F2(
		function (memo, list) {
			takeWhileMemo:
			while (true) {
				if (!list.b) {
					return $elm$core$List$reverse(memo);
				} else {
					var x = list.a;
					var xs = list.b;
					if (predicate(x)) {
						var $temp$memo = A2($elm$core$List$cons, x, memo),
							$temp$list = xs;
						memo = $temp$memo;
						list = $temp$list;
						continue takeWhileMemo;
					} else {
						return $elm$core$List$reverse(memo);
					}
				}
			}
		});
	return takeWhileMemo(_List_Nil);
};
var $mdgriffith$elm_style_animation$Animation$Render$span = F2(
	function (p, xs) {
		return _Utils_Tuple2(
			A2($mdgriffith$elm_style_animation$Animation$Render$takeWhile, p, xs),
			A2($mdgriffith$elm_style_animation$Animation$Render$dropWhile, p, xs));
	});
var $mdgriffith$elm_style_animation$Animation$Render$groupWhile = F2(
	function (eq, xs_) {
		if (!xs_.b) {
			return _List_Nil;
		} else {
			var x = xs_.a;
			var xs = xs_.b;
			var _v1 = A2(
				$mdgriffith$elm_style_animation$Animation$Render$span,
				eq(x),
				xs);
			var ys = _v1.a;
			var zs = _v1.b;
			return A2(
				$elm$core$List$cons,
				A2($elm$core$List$cons, x, ys),
				A2($mdgriffith$elm_style_animation$Animation$Render$groupWhile, eq, zs));
		}
	});
var $mdgriffith$elm_style_animation$Animation$Model$propertyName = function (prop) {
	switch (prop.$) {
		case 0:
			var name = prop.a;
			return name;
		case 1:
			var name = prop.a;
			return name;
		case 2:
			var name = prop.a;
			return name;
		case 3:
			var name = prop.a;
			return name;
		case 4:
			var name = prop.a;
			return name;
		case 5:
			var name = prop.a;
			return name;
		case 6:
			var name = prop.a;
			return name;
		case 7:
			var name = prop.a;
			return name;
		case 8:
			return 'points';
		default:
			return 'path';
	}
};
var $mdgriffith$elm_style_animation$Animation$Render$isTransformation = function (prop) {
	return A2(
		$elm$core$List$member,
		$mdgriffith$elm_style_animation$Animation$Model$propertyName(prop),
		_List_fromArray(
			['rotate', 'rotateX', 'rotateY', 'rotateZ', 'rotate3d', 'translate', 'translate3d', 'scale', 'scale3d']));
};
var $elm$core$List$sort = function (xs) {
	return A2($elm$core$List$sortBy, $elm$core$Basics$identity, xs);
};
var $mdgriffith$elm_style_animation$Animation$Render$warnForDoubleListedProperties = function (props) {
	var _v0 = A2(
		$elm$core$List$map,
		function (propGroup) {
			var _v1 = $elm$core$List$head(propGroup);
			if (_v1.$ === 1) {
				return '';
			} else {
				var name = _v1.a;
				return ($elm$core$List$length(propGroup) > 1) ? '' : '';
			}
		},
		A2(
			$mdgriffith$elm_style_animation$Animation$Render$groupWhile,
			$elm$core$Basics$eq,
			$elm$core$List$sort(
				A2(
					$elm$core$List$map,
					$mdgriffith$elm_style_animation$Animation$Model$propertyName,
					A2(
						$elm$core$List$filter,
						function (prop) {
							return !$mdgriffith$elm_style_animation$Animation$Render$isTransformation(prop);
						},
						props)))));
	return props;
};
var $mdgriffith$elm_style_animation$Animation$style = function (props) {
	return $mdgriffith$elm_style_animation$Animation$initialState(
		A2(
			$elm$core$List$map,
			$mdgriffith$elm_style_animation$Animation$setDefaultInterpolation,
			$mdgriffith$elm_style_animation$Animation$Render$warnForDoubleListedProperties(props)));
};
var $author$project$Pages$PreferenceTwoFactor$init = $elm$core$Task$succeed(
	{
		hW: $mdgriffith$elm_style_animation$Animation$style(
			_List_fromArray(
				[
					$mdgriffith$elm_style_animation$Animation$opacity(0)
				])),
		jz: $krisajenkins$remotedata$RemoteData$NotAsked,
		kD: ''
	});
var $author$project$Task$Parallel$Extra$DownloadUpdated5 = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$ProjectConfig$PageInitData = F4(
	function (project, maybeBranchName, commit, buildExpr) {
		return {k$: buildExpr, cM: commit, fO: maybeBranchName, c5: project};
	});
var $0ui$elm_task_parallel$Task$Parallel$FailedToLoad5 = function (a) {
	return {$: 5, a: a};
};
var $0ui$elm_task_parallel$Task$Parallel$LoadedA5 = function (a) {
	return {$: 0, a: a};
};
var $0ui$elm_task_parallel$Task$Parallel$LoadedB5 = function (a) {
	return {$: 1, a: a};
};
var $0ui$elm_task_parallel$Task$Parallel$LoadedC5 = function (a) {
	return {$: 2, a: a};
};
var $0ui$elm_task_parallel$Task$Parallel$LoadedD5 = function (a) {
	return {$: 3, a: a};
};
var $0ui$elm_task_parallel$Task$Parallel$LoadedE5 = function (a) {
	return {$: 4, a: a};
};
var $0ui$elm_task_parallel$Task$Parallel$State5 = F5(
	function (a, b, c, d, e) {
		return {$: 1, a: a, b: b, c: c, d: d, e: e};
	});
var $0ui$elm_task_parallel$Task$Parallel$attempt5 = F6(
	function (updateMsg, task1, task2, task3, task4, task5) {
		return _Utils_Tuple2(
			A5($0ui$elm_task_parallel$Task$Parallel$State5, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3(
						$0ui$elm_task_parallel$Task$Parallel$routeTo,
						A2($elm$core$Basics$composeL, updateMsg, $0ui$elm_task_parallel$Task$Parallel$LoadedA5),
						A2($elm$core$Basics$composeL, updateMsg, $0ui$elm_task_parallel$Task$Parallel$FailedToLoad5),
						task1),
						A3(
						$0ui$elm_task_parallel$Task$Parallel$routeTo,
						A2($elm$core$Basics$composeL, updateMsg, $0ui$elm_task_parallel$Task$Parallel$LoadedB5),
						A2($elm$core$Basics$composeL, updateMsg, $0ui$elm_task_parallel$Task$Parallel$FailedToLoad5),
						task2),
						A3(
						$0ui$elm_task_parallel$Task$Parallel$routeTo,
						A2($elm$core$Basics$composeL, updateMsg, $0ui$elm_task_parallel$Task$Parallel$LoadedC5),
						A2($elm$core$Basics$composeL, updateMsg, $0ui$elm_task_parallel$Task$Parallel$FailedToLoad5),
						task3),
						A3(
						$0ui$elm_task_parallel$Task$Parallel$routeTo,
						A2($elm$core$Basics$composeL, updateMsg, $0ui$elm_task_parallel$Task$Parallel$LoadedD5),
						A2($elm$core$Basics$composeL, updateMsg, $0ui$elm_task_parallel$Task$Parallel$FailedToLoad5),
						task4),
						A3(
						$0ui$elm_task_parallel$Task$Parallel$routeTo,
						A2($elm$core$Basics$composeL, updateMsg, $0ui$elm_task_parallel$Task$Parallel$LoadedE5),
						A2($elm$core$Basics$composeL, updateMsg, $0ui$elm_task_parallel$Task$Parallel$FailedToLoad5),
						task5)
					])));
	});
var $author$project$Model$Project$getBranchByName = F2(
	function (_v0, name) {
		var project = _v0;
		return A2(
			$elm_community$list_extra$List$Extra$find,
			function (b) {
				return _Utils_eq(
					name,
					$author$project$Model$Branch$getName(b));
			},
			project.fZ);
	});
var $author$project$Model$Branch$getCommitID = function (_v0) {
	var branch = _v0;
	return branch.BR;
};
var $author$project$Model$Commit$Commit = $elm$core$Basics$identity;
var $author$project$Model$Commit$Metadata = F5(
	function (commitID, parentCommitID, message, added, atTime) {
		return {ak: added, jE: atTime, BR: commitID, Eh: message, zD: parentCommitID};
	});
var $author$project$BuildPlanner$Object$Commit$added = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'BuildPlannerScalarCodecs.DateTime',
	'added',
	_List_Nil,
	$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).qE.qN);
var $author$project$BuildPlanner$Object$Commit$atTime = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'BuildPlannerScalarCodecs.DateTime',
	'atTime',
	_List_Nil,
	$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).qE.qN);
var $author$project$BuildPlanner$Object$Commit$commitId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'BuildPlannerScalarCodecs.Id',
	'commitId',
	_List_Nil,
	$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).oc.qN);
var $author$project$BuildPlanner$Object$Commit$description = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'description', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$Commit$parentId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe BuildPlannerScalarCodecs.Id)',
	'parentId',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).oc.qN));
var $author$project$Model$Commit$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$elm$core$Basics$identity,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$Commit$atTime,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Maybe$Just, $author$project$BuildPlanner$Object$Commit$added),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$BuildPlanner$Object$Commit$description,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$BuildPlanner$Object$Commit$parentId,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$BuildPlanner$Object$Commit$commitId,
						$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$Commit$Metadata)))))));
var $author$project$Request$BuildPlanner$getCommitAndBuildExpr = F2(
	function (session, key) {
		return A2(
			$author$project$Request$BuildPlanner$getByCommit,
			session,
			{
				Y: key,
				ke: $elm$core$Maybe$Nothing,
				kf: $elm$core$Maybe$Just($elm$core$Basics$identity),
				ki: A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Model$BuildPlanner$BuildExpr$selectionSet,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Model$Commit$selectionSet,
						$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Tuple$pair))),
				kj: 'GetCommitAndBuildExpr'
			});
	});
var $author$project$Pages$ProjectConfig$getRefreshDataTask = F4(
	function (session, orgName, projectName, commitID) {
		return A2(
			$author$project$Request$BuildPlanner$getCommitAndBuildExpr,
			session,
			{BR: commitID, ix: orgName, vT: projectName});
	});
var $author$project$Model$Platform$isUserVisible = function (_v0) {
	var platform = _v0;
	return platform.uq;
};
var $author$project$Model$Platform$userVisiblePlatforms = $elm$core$Dict$filter(
	$elm$core$Basics$always($author$project$Model$Platform$isUserVisible));
var $author$project$Pages$ProjectConfig$init = function (session) {
	return function (orgName) {
		return function (projectName) {
			return function (maybeCommitID) {
				return function (isNewProject) {
					return function (maybeBranchName) {
						return function (isFromCommit) {
							return function (focusOnAddPackages) {
								return function (showAddPackagesModal) {
									return function (showImportPackagesModal) {
										var languagesTask = A2(
											$elm$core$Task$map,
											$elm_community$dict_extra$Dict$Extra$fromListBy($author$project$Model$LanguageVersions$getName),
											$author$project$Request$Ingredient$languages($elm$core$Maybe$Nothing));
										var findCommitID = function (project) {
											if (!maybeCommitID.$) {
												var commitID = maybeCommitID.a;
												return $elm$core$Maybe$Just(commitID);
											} else {
												var _v2 = A2(
													$elm$core$Maybe$andThen,
													$author$project$Model$Branch$getCommitID,
													A2(
														$elm$core$Maybe$andThen,
														$author$project$Model$Project$getBranchByName(project),
														maybeBranchName));
												if (!_v2.$) {
													var commitID = _v2.a;
													return $elm$core$Maybe$Just(commitID);
												} else {
													return $author$project$Model$Branch$getCommitID(
														$author$project$Model$Project$getDefaultBranch(project));
												}
											}
										};
										var err = A2(
											$author$project$Http$Extra$Error,
											'ProjectConfig.elm',
											$author$project$Http$Extra$BadStatus(
												{sY: 'No commit ID available', CN: $elm$core$Dict$empty, wp: 500, wq: 'Internal Server Error'}));
										var loadPageInitData = function (project) {
											return A2(
												$elm$core$Task$map,
												$elm_community$basics_extra$Basics$Extra$uncurry(
													A2($author$project$Pages$ProjectConfig$PageInitData, project, maybeBranchName)),
												A2(
													$elm$core$Task$andThen,
													A3($author$project$Pages$ProjectConfig$getRefreshDataTask, session, orgName, projectName),
													A2(
														$elm$core$Maybe$withDefault,
														$elm$core$Task$fail(err),
														A2(
															$elm$core$Maybe$map,
															$elm$core$Task$succeed,
															findCommitID(project)))));
										};
										var creds = $author$project$Model$Session$getCreds(session);
										var _v0 = A6(
											$0ui$elm_task_parallel$Task$Parallel$attempt5,
											$author$project$Task$Parallel$Extra$DownloadUpdated5,
											$author$project$Task$IngredientLatestTimestamp$getLatestTimestamp,
											A2($author$project$Request$Organization$get, orgName, creds),
											A2(
												$elm$core$Task$andThen,
												loadPageInitData,
												A3($author$project$Request$Project$get, creds, orgName, projectName)),
											languagesTask,
											A2(
												$elm$core$Task$map,
												$author$project$Model$Platform$userVisiblePlatforms,
												$author$project$Request$Ingredient$platforms($elm$core$Maybe$Nothing)));
										var downloadState = _v0.a;
										var downloadCmd = _v0.b;
										return _Utils_Tuple2(
											{x7: downloadState, yo: focusOnAddPackages, yJ: isFromCommit, uk: isNewProject, z6: showAddPackagesModal, z7: showImportPackagesModal},
											$elm$core$Platform$Cmd$batch(
												_List_fromArray(
													[downloadCmd])));
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$ProjectConfigAdvanced$PageInitData = F4(
	function (project, maybeBranchName, commit, buildExpr) {
		return {k$: buildExpr, cM: commit, fO: maybeBranchName, c5: project};
	});
var $author$project$Pages$ProjectConfigAdvanced$getRefreshDataTask = F4(
	function (session, orgName, projectName, commitID) {
		return A2(
			$author$project$Request$BuildPlanner$getCommitAndBuildExpr,
			session,
			{BR: commitID, ix: orgName, vT: projectName});
	});
var $author$project$Pages$ProjectConfigAdvanced$init = F5(
	function (session, orgName, projectName, maybeCommitID, maybeBranchName) {
		var findCommitID = function (project) {
			if (!maybeCommitID.$) {
				var commitID = maybeCommitID.a;
				return $elm$core$Maybe$Just(commitID);
			} else {
				var _v2 = A2(
					$elm$core$Maybe$andThen,
					$author$project$Model$Branch$getCommitID,
					A2(
						$elm$core$Maybe$andThen,
						$author$project$Model$Project$getBranchByName(project),
						maybeBranchName));
				if (!_v2.$) {
					var commitID = _v2.a;
					return $elm$core$Maybe$Just(commitID);
				} else {
					return $author$project$Model$Branch$getCommitID(
						$author$project$Model$Project$getDefaultBranch(project));
				}
			}
		};
		var err = A2(
			$author$project$Http$Extra$Error,
			'ProjectConfig.elm',
			$author$project$Http$Extra$BadStatus(
				{sY: 'No commit ID available', CN: $elm$core$Dict$empty, wp: 500, wq: 'Internal Server Error'}));
		var loadPageInitData = function (project) {
			return A2(
				$elm$core$Task$map,
				$elm_community$basics_extra$Basics$Extra$uncurry(
					A2($author$project$Pages$ProjectConfigAdvanced$PageInitData, project, maybeBranchName)),
				A2(
					$elm$core$Task$andThen,
					A3($author$project$Pages$ProjectConfigAdvanced$getRefreshDataTask, session, orgName, projectName),
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Task$fail(err),
						A2(
							$elm$core$Maybe$map,
							$elm$core$Task$succeed,
							findCommitID(project)))));
		};
		var creds = $author$project$Model$Session$getCreds(session);
		var _v0 = A5(
			$0ui$elm_task_parallel$Task$Parallel$attempt4,
			$author$project$Task$Parallel$Extra$DownloadUpdated4,
			$author$project$Task$IngredientLatestTimestamp$getLatestTimestamp,
			A2($author$project$Request$Organization$get, orgName, creds),
			A2(
				$elm$core$Task$andThen,
				loadPageInitData,
				A3($author$project$Request$Project$get, creds, orgName, projectName)),
			A2(
				$elm$core$Task$map,
				$author$project$Model$Platform$userVisiblePlatforms,
				$author$project$Request$Ingredient$platforms($elm$core$Maybe$Nothing)));
		var downloadState = _v0.a;
		var downloadCmd = _v0.b;
		return _Utils_Tuple2(
			{x7: downloadState},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[downloadCmd])));
	});
var $author$project$Request$BuildPlanner$BuildPlannerKey = F3(
	function (orgName, projectName, commitID) {
		return {BR: commitID, ix: orgName, vT: projectName};
	});
var $author$project$Pages$ProjectDownloads$PageInitData = F2(
	function (project, commit) {
		return {cM: commit, c5: project};
	});
var $author$project$Request$BuildPlanner$getCommit = F2(
	function (session, key) {
		return A2(
			$author$project$Request$BuildPlanner$getByCommit,
			session,
			{
				Y: key,
				ke: $elm$core$Maybe$Nothing,
				kf: $elm$core$Maybe$Just($elm$core$Tuple$first),
				ki: $author$project$Model$Commit$selectionSet,
				kj: 'GetCommit'
			});
	});
var $author$project$Pages$ProjectDownloads$refreshTask = F2(
	function (session, input) {
		return A2($author$project$Request$BuildPlanner$getCommit, session, input);
	});
var $author$project$Pages$ProjectDownloads$init = F8(
	function (session, orgName, projectName, maybeCommitID, maybePlatformID, maybeBranchName, isNewProject, buildLogSocket) {
		var findCommitID = function (project) {
			if (!maybeCommitID.$) {
				var commitID = maybeCommitID.a;
				return $elm$core$Maybe$Just(commitID);
			} else {
				var _v2 = A2(
					$elm$core$Maybe$andThen,
					$author$project$Model$Branch$getCommitID,
					A2(
						$elm$core$Maybe$andThen,
						$author$project$Model$Project$getBranchByName(project),
						maybeBranchName));
				if (!_v2.$) {
					var commitID = _v2.a;
					return $elm$core$Maybe$Just(commitID);
				} else {
					return $author$project$Model$Branch$getCommitID(
						$author$project$Model$Project$getDefaultBranch(project));
				}
			}
		};
		var err = A2(
			$author$project$Http$Extra$Error,
			'ProjectDownloads',
			$author$project$Http$Extra$BadStatus(
				{sY: 'No commit ID available', CN: $elm$core$Dict$empty, wp: 500, wq: 'No commit ID available'}));
		var loadPageInitData = function (project) {
			return A2(
				$elm$core$Task$map,
				$author$project$Pages$ProjectDownloads$PageInitData(project),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						$author$project$Pages$ProjectDownloads$refreshTask(session),
						A2($author$project$Request$BuildPlanner$BuildPlannerKey, orgName, projectName)),
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Task$fail(err),
						A2(
							$elm$core$Maybe$map,
							$elm$core$Task$succeed,
							findCommitID(project)))));
		};
		var creds = $author$project$Model$Session$getCreds(session);
		var _v0 = A6(
			$0ui$elm_task_parallel$Task$Parallel$attempt5,
			$author$project$Task$Parallel$Extra$DownloadUpdated5,
			$elm$time$Time$now,
			A2($author$project$Request$Organization$get, orgName, creds),
			A2(
				$elm$core$Task$andThen,
				loadPageInitData,
				A3($author$project$Request$Project$get, creds, orgName, projectName)),
			$author$project$Request$Ingredient$languages($elm$core$Maybe$Nothing),
			$author$project$Request$Ingredient$platforms($elm$core$Maybe$Nothing));
		var downloadState = _v0.a;
		var downloadCmd = _v0.b;
		return _Utils_Tuple2(
			{
				x7: downloadState,
				CZ: {jH: buildLogSocket, uk: isNewProject, fO: maybeBranchName, Ef: maybePlatformID}
			},
			downloadCmd);
	});
var $author$project$Pages$ProjectHistory$PageInitData = F4(
	function (project, maybeBranchName, commit, history) {
		return {cM: commit, q9: history, fO: maybeBranchName, c5: project};
	});
var $author$project$Pages$ProjectHistory$commitsPerPage = 10;
var $author$project$Model$CommitHistory$CommitHistory = F2(
	function (commits, totalCommits) {
		return {BS: commits, GJ: totalCommits};
	});
var $author$project$Model$CommitHistorical$CommitHistorical = $elm$core$Basics$identity;
var $author$project$Model$CommitHistorical$Metadata = F7(
	function (commitID, parentCommitID, message, added, atTime, username, changes) {
		return {ak: added, jE: atTime, xB: changes, BR: commitID, Eh: message, zD: parentCommitID, AE: username};
	});
var $author$project$Model$Change$Change = F4(
	function (namespace, name, operation, versionRequirements) {
		return {w: name, aE: namespace, EX: operation, gW: versionRequirements};
	});
var $author$project$Model$Operation$Add = 0;
var $author$project$Model$Operation$Remove = 2;
var $author$project$Model$Operation$Update = 1;
var $author$project$Model$Operation$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'added':
				return $elm$json$Json$Decode$succeed(0);
			case 'updated':
				return $elm$json$Json$Decode$succeed(1);
			case 'removed':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Invalid operation, expected \"added\", \"updated\", or \"removed\", but got \"' + (str + '\"'));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Model$BuildPlanner$BuildExpr$Solve$VersionRequirement$decodeManyLegacy = $elm$json$Json$Decode$list($author$project$Model$BuildPlanner$BuildExpr$Solve$VersionRequirement$decodeLegacy);
var $author$project$Model$Change$decode = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'version_constraints',
	$author$project$Model$BuildPlanner$BuildExpr$Solve$VersionRequirement$decodeManyLegacy,
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'operation',
		$author$project$Model$Operation$decode,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'requirement',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'namespace',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Model$Change$Change)))));
var $author$project$Model$CommitHistorical$decode = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'changeset',
		A2(
			$elm$json$Json$Decode$map,
			$elm_community$dict_extra$Dict$Extra$fromListBy($author$project$Model$Namespace$key),
			$elm$json$Json$Decode$list($author$project$Model$Change$decode)),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'username',
			$elm$json$Json$Decode$string,
			'',
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'atTime',
				$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
				A3(
					$author$project$Json$Decode$Pipeline$Extra$decodeMaybe,
					'added',
					$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'message',
						$elm$json$Json$Decode$string,
						'',
						A3(
							$author$project$Json$Decode$Pipeline$Extra$decodeMaybe,
							'parentCommitID',
							$danyx23$elm_uuid$Uuid$decoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'commitID',
								$danyx23$elm_uuid$Uuid$decoder,
								$elm$json$Json$Decode$succeed($author$project$Model$CommitHistorical$Metadata)))))))));
var $author$project$Model$CommitHistory$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'totalCommits',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'commits',
		$elm$json$Json$Decode$list($author$project$Model$CommitHistorical$decode),
		$elm$json$Json$Decode$succeed($author$project$Model$CommitHistory$CommitHistory)));
var $author$project$Request$VCS$getCommitHistory = F4(
	function (creds, commitID, offset, limit) {
		return $author$project$Http$Extra$get(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$emptyBody,
				qN: $author$project$Model$CommitHistory$decode,
				CN: _List_Nil,
				GT: '/vcs/history/' + ($danyx23$elm_uuid$Uuid$toString(commitID) + ('?offset=' + ($elm$core$String$fromInt(offset) + ('&limit=' + $elm$core$String$fromInt(limit)))))
			});
	});
var $author$project$Pages$ProjectHistory$getCommitTask = F4(
	function (session, orgName, projectName, commitID) {
		return A2(
			$author$project$Request$BuildPlanner$getCommit,
			session,
			{BR: commitID, ix: orgName, vT: projectName});
	});
var $author$project$Pages$ProjectHistory$init = F5(
	function (session, orgName, projectName, maybeCommitID, maybeBranchName) {
		var findCommitID = function (project) {
			if (!maybeCommitID.$) {
				var commitID = maybeCommitID.a;
				return $elm$core$Maybe$Just(commitID);
			} else {
				var _v2 = A2(
					$elm$core$Maybe$andThen,
					$author$project$Model$Branch$getCommitID,
					A2(
						$elm$core$Maybe$andThen,
						$author$project$Model$Project$getBranchByName(project),
						maybeBranchName));
				if (!_v2.$) {
					var commitID = _v2.a;
					return $elm$core$Maybe$Just(commitID);
				} else {
					return $author$project$Model$Branch$getCommitID(
						$author$project$Model$Project$getDefaultBranch(project));
				}
			}
		};
		var err = A2(
			$author$project$Http$Extra$Error,
			'ProjectHistory',
			$author$project$Http$Extra$BadStatus(
				{sY: 'No commit ID available', CN: $elm$core$Dict$empty, wp: 500, wq: 'No commit ID available'}));
		var creds = $author$project$Model$Session$getCreds(session);
		var orgTask = A2($author$project$Request$Organization$get, orgName, creds);
		var projectTask = A3($author$project$Request$Project$get, creds, orgName, projectName);
		var commitAndHistoryTask = function (project) {
			return A2(
				$elm$core$Task$andThen,
				function (commitID) {
					return A3(
						$elm$core$Task$map2,
						A2($author$project$Pages$ProjectHistory$PageInitData, project, maybeBranchName),
						A4($author$project$Pages$ProjectHistory$getCommitTask, session, orgName, projectName, commitID),
						A4($author$project$Request$VCS$getCommitHistory, creds, commitID, 0, $author$project$Pages$ProjectHistory$commitsPerPage));
				},
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Task$fail(err),
					A2(
						$elm$core$Maybe$map,
						$elm$core$Task$succeed,
						findCommitID(project))));
		};
		var _v0 = A5(
			$0ui$elm_task_parallel$Task$Parallel$attempt4,
			$author$project$Task$Parallel$Extra$DownloadUpdated4,
			$elm$time$Time$here,
			orgTask,
			A2($elm$core$Task$andThen, commitAndHistoryTask, projectTask),
			$author$project$Request$Ingredient$platforms($elm$core$Maybe$Nothing));
		var downloadState = _v0.a;
		var downloadCmd = _v0.b;
		return _Utils_Tuple2(
			{x7: downloadState},
			downloadCmd);
	});
var $author$project$Pages$ProjectImpactReport$init = F5(
	function (session, orgName, projectName, params, host) {
		var creds = $author$project$Model$Session$getCreds(session);
		var orgTask = A2($author$project$Request$Organization$get, orgName, creds);
		var projectTask = A3($author$project$Request$Project$get, creds, orgName, projectName);
		var _v0 = A3($0ui$elm_task_parallel$Task$Parallel$attempt2, $author$project$Task$Parallel$Extra$DownloadUpdated2, orgTask, projectTask);
		var downloadState = _v0.a;
		var downloadCmd = _v0.b;
		return A2(
			$author$project$Misc$with,
			downloadCmd,
			{x7: downloadState, t0: host, E5: params});
	});
var $author$project$Pages$ProjectSettings$Delete = 0;
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $Chadtech$elm_bool_extra$Bool$Extra$all = $elm$core$List$all($elm$core$Basics$identity);
var $author$project$Model$Permissions$canEditProjects = function (org) {
	return A2(
		$author$project$Misc$isEither,
		A2(
			$author$project$Model$Permissions$isOneOf,
			_List_fromArray(
				[2, 1]),
			org),
		$author$project$Model$User$isSuperUser);
};
var $author$project$Request$Project$getGraphQL = F3(
	function (creds, orgName, projectName) {
		var isNull = function (wantNull) {
			return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
				$author$project$Builder$InputObject$buildTimestamp_comparison_exp(
					function (args) {
						return _Utils_update(
							args,
							{
								a$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(wantNull)
							});
					}));
		};
		var equalToStr = function (str) {
			return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
				$author$project$Builder$InputObject$buildString_comparison_exp(
					function (args) {
						return _Utils_update(
							args,
							{
								aW: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(str)
							});
					}));
		};
		var urlNameIs = function (urlName) {
			return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
				$author$project$Builder$InputObject$buildOrganizations_bool_exp(
					function (args) {
						return _Utils_update(
							args,
							{
								ct: equalToStr(urlName)
							});
					}));
		};
		var nameIs = F2(
			function (on, pn) {
				return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					$author$project$Builder$InputObject$buildProjects_bool_exp(
						function (args) {
							return _Utils_update(
								args,
								{
									z: isNull(true),
									w: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
										$author$project$Builder$InputObject$buildString_comparison_exp(
											function (optional) {
												return _Utils_update(
													optional,
													{
														aW: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(pn)
													});
											})),
									c3: urlNameIs(on)
								});
						}));
			});
		var projectsOptionalArgument = function (optionalArgs) {
			return _Utils_update(
				optionalArgs,
				{
					ao: A2(nameIs, orgName, projectName)
				});
		};
		return A5(
			$author$project$GraphQL$Utils$queryRequest,
			creds,
			0,
			_List_Nil,
			'GetProjectByName',
			A2(
				$author$project$GraphQL$Utils$selectFirst,
				'Project not found',
				A2($author$project$Builder$Query$projects, projectsOptionalArgument, $author$project$Model$Project$selectionSet)));
	});
var $author$project$Model$Project$getDescription = function (_v0) {
	var project = _v0;
	return project.bP;
};
var $author$project$Model$Branch$getForkedFrom = function (_v0) {
	var branch = _v0;
	return branch.yp;
};
var $author$project$Model$Project$getForkedFrom = function (_v0) {
	var project = _v0;
	var _v1 = project.yp;
	if (!_v1.$) {
		return $author$project$Model$Branch$getForkedFrom(project.tA);
	} else {
		return project.yp;
	}
};
var $author$project$Pages$ProjectSettings$getForkedFromOrgAndProject = function (project) {
	var _v0 = $author$project$Model$Project$getForkedFrom(project);
	if (_v0.$ === 2) {
		var data = _v0.a;
		return _Utils_Tuple2(data.c3, data.c5);
	} else {
		return _Utils_Tuple2('', '');
	}
};
var $author$project$Model$Project$getIsDistributionOnly = function (_v0) {
	var project = _v0;
	return project.x5;
};
var $author$project$Model$Project$getIsManaged = function (_v0) {
	var project = _v0;
	return project.b4;
};
var $author$project$Model$Project$getRepoUrl = function (_v0) {
	var project = _v0;
	return project.zP;
};
var $author$project$Pages$ProjectSettings$initFormFields = function (project) {
	var _v0 = $author$project$Pages$ProjectSettings$getForkedFromOrgAndProject(project);
	var forkedFromOrganization = _v0.a;
	var forkedFromProject = _v0.b;
	return {
		bP: $author$project$Model$Project$getDescription(project),
		is: forkedFromOrganization,
		it: forkedFromProject,
		iu: $author$project$Model$Project$getIsDistributionOnly(project),
		j2: $author$project$Model$Project$getIsManaged(project),
		Dy: $author$project$Model$Project$getIsPrivate(project),
		w: $author$project$Model$Project$getName(project),
		nf: $author$project$Model$Project$getRepoUrl(project)
	};
};
var $author$project$Pages$ProjectSettings$init = F5(
	function (session, key, orgName, projectName, fragment) {
		var user = $author$project$Model$Session$getUser(session);
		var userCanEdit = A2($author$project$Model$Permissions$canEditProjects, orgName, user);
		var finishModel = F3(
			function (org, tier, project) {
				var _v0 = _Utils_Tuple2(userCanEdit, user);
				if (_v0.a && (!_v0.b.$)) {
					var u = _v0.b.a;
					return $elm$core$Task$succeed(
						{
							oo: 0,
							bD: $author$project$Pages$ProjectSettings$initFormFields(project),
							oD: fragment,
							oO: false,
							Y: key,
							o3: $elm$core$Maybe$Nothing,
							c3: org,
							vK: A2(
								$elm$core$List$filter,
								function (o) {
									return $Chadtech$elm_bool_extra$Bool$Extra$all(
										_List_fromArray(
											[
												A2($author$project$Model$Permissions$canEditProjects, o, user),
												!_Utils_eq(o, orgName)
											]));
								},
								A2(
									$elm$core$List$map,
									function (membership) {
										return membership.AC;
									},
									u.mX)),
							c5: project,
							dc: tier
						});
				} else {
					return $elm$core$Task$fail($author$project$Http$Extra$generic404);
				}
			});
		var creds = $author$project$Model$Session$getCreds(session);
		var orgTask = A2($author$project$Request$Organization$get, orgName, creds);
		var projectTask = A3($author$project$Request$Project$getGraphQL, creds, orgName, projectName);
		var tierTask = A2($author$project$Request$Organization$getTier, orgName, creds);
		return $author$project$Task$Pipeline$resolve(
			A2(
				$author$project$Task$Pipeline$fetch,
				projectTask,
				A2(
					$author$project$Task$Pipeline$fetch,
					tierTask,
					A2(
						$author$project$Task$Pipeline$fetch,
						orgTask,
						$elm$core$Task$succeed(finishModel)))));
	});
var $author$project$Pages$ProjectSettingsBranches$init = F4(
	function (session, key, orgName, projectName) {
		var hasPermissions = A2(
			$author$project$Model$Permissions$canEditProjects,
			orgName,
			$author$project$Model$Session$getUser(session));
		var finishModel = F2(
			function (org, project) {
				return hasPermissions ? $elm$core$Task$succeed(
					{h5: $elm$core$Maybe$Nothing, kW: $elm$core$Maybe$Nothing, Y: key, oY: $elm$core$Maybe$Nothing, c3: org, c5: project}) : $elm$core$Task$fail($author$project$Http$Extra$generic404);
			});
		var creds = $author$project$Model$Session$getCreds(session);
		var orgTask = A2($author$project$Request$Organization$get, orgName, creds);
		var projectTask = A3($author$project$Request$Project$get, creds, orgName, projectName);
		return $author$project$Task$Pipeline$resolve(
			A2(
				$author$project$Task$Pipeline$fetch,
				projectTask,
				A2(
					$author$project$Task$Pipeline$fetch,
					orgTask,
					$elm$core$Task$succeed(finishModel))));
	});
var $author$project$Pages$ProjectSettingsHAR$Viewing = 0;
var $author$project$Model$Tag$commitID = function (_v0) {
	var tag = _v0;
	return tag.BR;
};
var $author$project$Pages$ProjectSettingsHAR$CommitIDField = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$ProjectSettingsHAR$LabelField = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$ProjectSettingsHAR$New = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$ProjectSettingsHAR$NotStarted = {$: 0};
var $author$project$Pages$ProjectSettingsHAR$Saved = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$ProjectSettingsHAR$createTagState = F4(
	function (isNew, fieldState, commitID, label) {
		var meta = {
			h7: $author$project$Pages$ProjectSettingsHAR$NotStarted,
			BR: $author$project$Pages$ProjectSettingsHAR$CommitIDField(
				{
					lY: $danyx23$elm_uuid$Uuid$toString(commitID),
					jm: $danyx23$elm_uuid$Uuid$toString(commitID),
					bB: fieldState,
					kH: $danyx23$elm_uuid$Uuid$toString(commitID)
				}),
			b2: $author$project$Pages$ProjectSettingsHAR$LabelField(
				{lY: label, jm: label, bB: fieldState, kH: label}),
			dv: _List_Nil
		};
		return isNew ? $author$project$Pages$ProjectSettingsHAR$New(meta) : $author$project$Pages$ProjectSettingsHAR$Saved(meta);
	});
var $author$project$Model$Project$getTags = function (_v0) {
	var project = _v0;
	return project.Gt;
};
var $author$project$Model$Tag$label = function (_v0) {
	var tag = _v0;
	return tag.b2;
};
var $author$project$Pages$ProjectSettingsHAR$sortTags = F2(
	function (a, b) {
		var _v0 = _Utils_Tuple2(a, b);
		if (_v0.a.$ === 1) {
			if (!_v0.b.$) {
				return 2;
			} else {
				var va = _v0.a.a;
				var vb = _v0.b.a;
				return (_Utils_cmp(
					$author$project$Pages$ProjectSettingsHAR$getFieldValue(va.b2),
					$author$project$Pages$ProjectSettingsHAR$getFieldValue(vb.b2)) > 0) ? 2 : (_Utils_eq(va.b2, vb.b2) ? 1 : 0);
			}
		} else {
			if (_v0.b.$ === 1) {
				return 0;
			} else {
				var va = _v0.a.a;
				var vb = _v0.b.a;
				return (_Utils_cmp(
					$author$project$Pages$ProjectSettingsHAR$getFieldValue(va.b2),
					$author$project$Pages$ProjectSettingsHAR$getFieldValue(vb.b2)) > 0) ? 2 : (_Utils_eq(va.b2, vb.b2) ? 1 : 0);
			}
		}
	});
var $elm$core$List$sortWith = _List_sortWith;
var $author$project$Pages$ProjectSettingsHAR$init = F5(
	function (session, orgName, projectName, maybeBranchName, maybeCommitID) {
		var populateTags = function (project) {
			return A2(
				$elm$core$List$sortWith,
				$author$project$Pages$ProjectSettingsHAR$sortTags,
				A2(
					$elm$core$List$map,
					function (tag) {
						return A4(
							$author$project$Pages$ProjectSettingsHAR$createTagState,
							false,
							0,
							$author$project$Model$Tag$commitID(tag),
							$author$project$Model$Tag$label(tag));
					},
					$author$project$Model$Project$getTags(project)));
		};
		var getDefaultCommitID = function (project) {
			return $author$project$Model$Branch$getCommitID(
				$author$project$Model$Project$getDefaultBranch(project));
		};
		var makeModel = F2(
			function (org, project) {
				return {
					oi: $author$project$Model$CopyStatus$empty,
					fO: maybeBranchName,
					uA: getDefaultCommitID(project),
					iw: $elm$core$Maybe$Nothing,
					uB: maybeCommitID,
					c3: org,
					c5: project,
					Gt: populateTags(project)
				};
			});
		var creds = $author$project$Model$Session$getCreds(session);
		var orgTask = A2($author$project$Request$Organization$get, orgName, creds);
		var projectGQLTask = A3($author$project$Request$Project$getGraphQL, creds, orgName, projectName);
		return A2(
			$author$project$Task$Pipeline$fetch,
			projectGQLTask,
			A2(
				$author$project$Task$Pipeline$fetch,
				orgTask,
				$elm$core$Task$succeed(makeModel)));
	});
var $author$project$Model$Route$isHome = function (route) {
	if (((!route.$) && (route.a.$ === 7)) && (!route.a.a.$)) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Model$Route$AddDescription = 1;
var $author$project$Model$Route$DeleteProject = 4;
var $author$project$Model$Route$MoveProject = 2;
var $author$project$Model$Route$ProjectVisibility = 3;
var $author$project$Model$Route$UnknownOrAbsentFragment = 0;
var $author$project$Model$Route$parseProjectSettingsFragment = function (maybeFragment) {
	if (!maybeFragment.$) {
		var fragment = maybeFragment.a;
		return _Utils_eq(fragment, $author$project$Model$Route$addDescriptionFragment) ? 1 : (_Utils_eq(fragment, $author$project$Model$Route$moveProjectFragment) ? 2 : (_Utils_eq(fragment, $author$project$Model$Route$projectVisibilityFragment) ? 3 : (_Utils_eq(fragment, $author$project$Model$Route$deleteProjectFragment) ? 4 : 0)));
	} else {
		return 0;
	}
};
var $author$project$Msg$AdminCreateOrganizationLoaded = function (a) {
	return {$: 78, a: a};
};
var $author$project$Msg$AdminFeaturesLoaded = function (a) {
	return {$: 66, a: a};
};
var $author$project$Msg$AdminForkLoaded = function (a) {
	return {$: 95, a: a};
};
var $author$project$Msg$AdminIconomiconLoaded = function (a) {
	return {$: 68, a: a};
};
var $author$project$Msg$AdminOrganizationLoaded = function (a) {
	return {$: 75, a: a};
};
var $author$project$Msg$AdminOrganizationsLoaded = function (a) {
	return {$: 69, a: a};
};
var $author$project$Msg$AdminUserLoaded = function (a) {
	return {$: 72, a: a};
};
var $author$project$Msg$AdminUsersLoaded = function (a) {
	return {$: 71, a: a};
};
var $author$project$Pages$AdminCreateOrganization$init = F2(
	function (key, host) {
		return $elm$core$Task$succeed(
			{
				jT: A4(
					$author$project$Views$CreateOrgForm$new,
					key,
					host,
					$elm$core$Maybe$Nothing,
					{De: false}),
				Y: key
			});
	});
var $author$project$Pages$AdminFeatures$NotAcknowledged = 0;
var $author$project$Model$AddOnDefaultsByTier$decode = function () {
	var decodeMetadata = A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'addOns',
		$elm$json$Json$Decode$list($author$project$Model$AddOns$decodeAddOn),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'tier',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($elm$core$Tuple$pair)));
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$list(decodeMetadata));
}();
var $author$project$Request$AddOns$getAddOnDefaultsByTier = function (creds) {
	return $author$project$Http$Extra$get(
		{
			iO: $author$project$Http$Extra$Creds(creds),
			sY: $author$project$Http$Extra$emptyBody,
			qN: $author$project$Model$AddOnDefaultsByTier$decode,
			CN: _List_Nil,
			GT: '/addons/'
		});
};
var $author$project$Pages$AdminFeatures$init = F2(
	function (session, _v0) {
		var getAvailableTiersTask = $author$project$Request$Tier$getTiers(
			$author$project$Model$Session$getCreds(session));
		var getAddOnDefaultsByTierTask = $author$project$Request$AddOns$getAddOnDefaultsByTier(
			$author$project$Model$Session$getCreds(session));
		var currentTier = A2(
			$elm$core$Basics$composeR,
			$elm$core$Dict$keys,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$head,
				$elm$core$Maybe$withDefault('Team')));
		var adminFeaturesModel = F2(
			function (addOnDefaultsByTier, tiers) {
				return {
					kL: 0,
					jD: addOnDefaultsByTier,
					xL: '',
					jM: currentTier(addOnDefaultsByTier),
					Ar: tiers
				};
			});
		return A2(
			$author$project$Task$Pipeline$fetch,
			getAvailableTiersTask,
			A2(
				$author$project$Task$Pipeline$fetch,
				getAddOnDefaultsByTierTask,
				$author$project$Task$Pipeline$into(adminFeaturesModel)));
	});
var $author$project$TimeUtils$compare = F2(
	function (a, b) {
		return A2(
			$elm$core$Basics$compare,
			$elm$time$Time$posixToMillis(a),
			$elm$time$Time$posixToMillis(b));
	});
var $author$project$Pages$AdminFork$SingleBranch = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$AdminFork$defaultMode = $author$project$Pages$AdminFork$SingleBranch(1);
var $author$project$Model$Commit$getAdded = function (_v0) {
	var commit = _v0;
	return commit.ak;
};
var $author$project$Model$Commit$getCommitID = function (_v0) {
	var commit = _v0;
	return commit.BR;
};
var $author$project$Request$BuildPlanner$getCommits = F2(
	function (session, _v0) {
		var orgName = _v0.ix;
		var projectName = _v0.vT;
		var branches = _v0.fZ;
		var selectionSetOne = function (commitID) {
			var commitIdStr = $danyx23$elm_uuid$Uuid$toString(commitID);
			return A2(
				$author$project$BuildPlanner$Object$Project$commit,
				function (opts) {
					return _Utils_update(
						opts,
						{
							nL: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(commitIdStr)
						});
				},
				$author$project$BuildPlanner$Union$CommitResult$fragments(
					{
						u7: $author$project$Model$Commit$selectionSet,
						vp: $author$project$BuildPlannerScalarCodecs$selectionSetFail('Commit not found: ' + commitIdStr)
					}));
		};
		var selectionSetMany = A3(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$foldl,
			$elm_community$basics_extra$Basics$Extra$uncurry($elm$core$Dict$insert),
			$elm$core$Dict$empty,
			A2(
				$elm$core$List$map,
				function (_v1) {
					var branchName = _v1.a;
					var commitID = _v1.b;
					return A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
						$elm$core$Tuple$pair(branchName),
						selectionSetOne(commitID));
				},
				$elm$core$Dict$toList(branches)));
		var creds = $author$project$Model$Session$getCreds(session);
		return A5(
			$author$project$GraphQL$Utils$queryRequest,
			creds,
			4,
			_List_Nil,
			'GetCommits',
			A2(
				$author$project$BuildPlanner$Query$project,
				{c3: orgName, c5: projectName},
				$author$project$BuildPlanner$Union$ProjectResult$fragments(
					{
						vp: $author$project$BuildPlannerScalarCodecs$selectionSetFail('Project not found: ' + (orgName + (' / ' + projectName))),
						vt: selectionSetMany
					})));
	});
var $author$project$Misc$reverseOrder = function (order) {
	switch (order) {
		case 0:
			return 2;
		case 1:
			return 1;
		default:
			return 0;
	}
};
var $author$project$Pages$AdminFork$init = F4(
	function (session, key, orgName, projectName) {
		var finishModel = F2(
			function (scopedProject, commits) {
				var latestCommit = A2(
					$elm$core$Maybe$map,
					function (_v3) {
						var branchName = _v3.a;
						var commit = _v3.b;
						return {
							ak: $author$project$Model$Commit$getAdded(commit),
							Bi: branchName,
							BR: $author$project$Model$Commit$getCommitID(commit)
						};
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$sortWith,
							F2(
								function (_v1, _v2) {
									var commit1 = _v1.b;
									var commit2 = _v2.b;
									return $author$project$Misc$reverseOrder(
										A2(
											$elm$core$Maybe$withDefault,
											0,
											A3(
												$elm$core$Maybe$map2,
												$author$project$TimeUtils$compare,
												$author$project$Model$Commit$getAdded(commit1),
												$author$project$Model$Commit$getAdded(commit2))));
								}),
							$elm$core$Dict$toList(commits))));
				return {
					Y: key,
					uu: latestCommit,
					El: $author$project$Pages$AdminFork$defaultMode,
					pR: orgName,
					hU: scopedProject,
					nD: '',
					kC: $author$project$Model$Project$getName(scopedProject)
				};
			});
		var fetchProject = A3(
			$author$project$Request$Project$get,
			$author$project$Model$Session$getCreds(session),
			orgName,
			projectName);
		var fetchCommits = function (project) {
			var branches = A3(
				$elm$core$List$foldl,
				F2(
					function (branch, acc) {
						var _v0 = $author$project$Model$Branch$getCommitID(branch);
						if (!_v0.$) {
							var commitID = _v0.a;
							return A3(
								$elm$core$Dict$insert,
								$author$project$Model$Branch$getName(branch),
								commitID,
								acc);
						} else {
							return acc;
						}
					}),
				$elm$core$Dict$empty,
				$author$project$Model$Project$getBranches(project));
			return A2(
				$author$project$Request$BuildPlanner$getCommits,
				session,
				{fZ: branches, ix: orgName, vT: projectName});
		};
		return A2(
			$elm$core$Task$andThen,
			function (project) {
				return A2(
					$elm$core$Task$map,
					finishModel(project),
					fetchCommits(project));
			},
			fetchProject);
	});
var $author$project$Icon$ActivestatePropeller = 0;
var $author$project$Icon$Aix = 1;
var $author$project$Icon$ArrowLeft = 2;
var $author$project$Icon$ArrowRight = 3;
var $author$project$Icon$BranchesAlt = 4;
var $author$project$Icon$Calendar = 5;
var $author$project$Icon$Call = 6;
var $author$project$Icon$Change = 7;
var $author$project$Icon$Chat = 8;
var $author$project$Icon$Checklist = 9;
var $author$project$Icon$Checkmark = 10;
var $author$project$Icon$CheckmarkCircle = 11;
var $author$project$Icon$ChevronDown = 12;
var $author$project$Icon$ChevronRight = 13;
var $author$project$Icon$ChevronUp = 14;
var $author$project$Icon$Collab = 15;
var $author$project$Icon$Collaboration = 16;
var $author$project$Icon$Copy = 17;
var $author$project$Icon$Dashboard = 18;
var $author$project$Icon$Dismiss = 19;
var $author$project$Icon$Docker = 20;
var $author$project$Icon$Download = 21;
var $author$project$Icon$Edit = 22;
var $author$project$Icon$Email = 23;
var $author$project$Icon$EmailVerification = 24;
var $author$project$Icon$External = 25;
var $author$project$Icon$Filter = 26;
var $author$project$Icon$Flag = 27;
var $author$project$Icon$Forbidden = 28;
var $author$project$Icon$Fork = 29;
var $author$project$Icon$Gear = 30;
var $author$project$Icon$Github = 31;
var $author$project$Icon$History = 32;
var $author$project$Icon$House = 33;
var $author$project$Icon$HpUx = 34;
var $author$project$Icon$InfoCircle = 35;
var $author$project$Icon$Install = 36;
var $author$project$Icon$Kubernetes = 37;
var $author$project$Icon$LegalShield = 38;
var $author$project$Icon$LegalShieldDisabled = 39;
var $author$project$Icon$Lightning = 40;
var $author$project$Icon$Link = 41;
var $author$project$Icon$Linux = 42;
var $author$project$Icon$Lock = 43;
var $author$project$Icon$LockDotLocked = 44;
var $author$project$Icon$LockDotUnlocked = 45;
var $author$project$Icon$LockKey = 46;
var $author$project$Icon$LockUnlocked = 47;
var $author$project$Icon$Mac = 48;
var $author$project$Icon$Members = 49;
var $author$project$Icon$Minus = 50;
var $author$project$Icon$Moon = 51;
var $author$project$Icon$MoreInfo = 52;
var $author$project$Icon$Move = 53;
var $author$project$Icon$MultiOs = 54;
var $author$project$Icon$Observability = 55;
var $author$project$Icon$Organization = 56;
var $author$project$Icon$Package = 57;
var $author$project$Icon$PackageAdd = 58;
var $author$project$Icon$Pencil = 59;
var $author$project$Icon$Perl = 60;
var $author$project$Icon$Plus = 61;
var $author$project$Icon$Python = 62;
var $author$project$Icon$Rbac = 63;
var $author$project$Icon$Remediation = 64;
var $author$project$Icon$Ruby = 65;
var $author$project$Icon$RuntimeSharing = 66;
var $author$project$Icon$Safe = 67;
var $author$project$Icon$Scales = 68;
var $author$project$Icon$Search = 69;
var $author$project$Icon$Share = 70;
var $author$project$Icon$ShieldLock = 71;
var $author$project$Icon$SideBar = 72;
var $author$project$Icon$SignOut = 73;
var $author$project$Icon$Spaceship = 74;
var $author$project$Icon$Spinner = 75;
var $author$project$Icon$Sun = 76;
var $author$project$Icon$Sunglasses = 77;
var $author$project$Icon$Support = 78;
var $author$project$Icon$Tcl = 79;
var $author$project$Icon$Transfer = 80;
var $author$project$Icon$Trash = 81;
var $author$project$Icon$UserProfile = 82;
var $author$project$Icon$Warning = 83;
var $author$project$Icon$Windows = 84;
var $author$project$Icon$Wrench = 85;
var $author$project$Icon$XCircle = 86;
var $author$project$Icon$all = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86]);
var $avh4$elm_color$Color$RgbaSpace = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $avh4$elm_color$Color$black = A4($avh4$elm_color$Color$RgbaSpace, 0 / 255, 0 / 255, 0 / 255, 1.0);
var $author$project$Style$defaultColor = $avh4$elm_color$Color$black;
var $author$project$Pages$AdminIconomicon$init = F2(
	function (_v0, key) {
		return $elm$core$Task$succeed(
			{t4: $author$project$Icon$all, Y: key, rZ: $author$project$Style$defaultColor, jr: 64, r1: ''});
	});
var $author$project$Pages$AdminOrganization$AddOrUpdate = 0;
var $author$project$Pages$AdminOrganization$Delete = 0;
var $author$project$Pages$AdminOrganization$Details = 0;
var $author$project$Pages$AdminOrganization$categoriesForAddOnDefaultsByTier = A2(
	$elm$core$Basics$composeR,
	$elm$core$Dict$values,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$concat,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$map(
				function ($) {
					return $.xA;
				}),
			$elm_community$list_extra$List$Extra$unique)));
var $author$project$Model$AdminMetadata$AdminMetadata = function (belongsToActivator) {
	return {Bg: belongsToActivator};
};
var $author$project$Model$AdminMetadata$decode = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'belongsToActivator',
	$elm$json$Json$Decode$bool,
	false,
	$elm$json$Json$Decode$succeed($author$project$Model$AdminMetadata$AdminMetadata));
var $author$project$Request$AdminMetadata$get = F3(
	function (identifierType, identifier, creds) {
		return $author$project$Http$Extra$get(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$emptyBody,
				qN: $author$project$Model$AdminMetadata$decode,
				CN: _List_Nil,
				GT: '/admin/metadata/' + (identifier + ('?identifierType=' + identifierType))
			});
	});
var $author$project$Request$AdminMetadata$getByOrgUrlName = F2(
	function (urlName, creds) {
		return A3($author$project$Request$AdminMetadata$get, 'URLname', urlName, creds);
	});
var $author$project$Pages$AdminOrganization$OrgData = F3(
	function (nextMutationID, organization, limitsInfo) {
		return {D$: limitsInfo, Es: nextMutationID, c3: organization};
	});
var $author$project$Request$Organization$nextMutationID = F2(
	function (orgName, creds) {
		return $author$project$Http$Extra$get(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$emptyBody,
				qN: $elm$json$Json$Decode$string,
				CN: _List_Nil,
				GT: '/organizations/' + (orgName + '/nextMutationID')
			});
	});
var $author$project$Pages$AdminOrganization$getOrgDataTask = F3(
	function (hasWriteAccess, orgName, creds) {
		var org = A2($author$project$Request$Organization$get, orgName, creds);
		var nextMutationID = hasWriteAccess ? A2($author$project$Request$Organization$nextMutationID, orgName, creds) : $elm$core$Task$succeed('');
		var limits = A2($author$project$Request$Organization$limits, orgName, creds);
		return A2(
			$author$project$Task$Pipeline$fetch,
			limits,
			A2(
				$author$project$Task$Pipeline$fetch,
				org,
				A2(
					$author$project$Task$Pipeline$fetch,
					nextMutationID,
					$author$project$Task$Pipeline$into($author$project$Pages$AdminOrganization$OrgData))));
	});
var $author$project$Pages$AdminOrganization$init = F3(
	function (session, key, orgName) {
		var hasWriteAccess = $author$project$Model$Session$isSuperUser(session);
		var finishModel = F4(
			function (orgData, availableTiers, addOnDefaultsByTier, adminMetadata) {
				return {
					jD: addOnDefaultsByTier,
					iN: adminMetadata,
					h$: 0,
					h0: '',
					n3: 1,
					Ba: availableTiers,
					oi: $author$project$Model$CopyStatus$empty,
					ol: A2(
						$elm$core$Maybe$withDefault,
						'Unknown',
						$elm$core$List$head(
							$author$project$Pages$AdminOrganization$categoriesForAddOnDefaultsByTier(addOnDefaultsByTier))),
					jP: 0,
					q9: _List_Nil,
					Y: key,
					El: 0,
					o5: orgData.c3.i$,
					Er: orgData.c3.AC,
					dp: orgData,
					kv: orgData.c3.dc
				};
			});
		var creds = $author$project$Model$Session$getCreds(session);
		var orgAdminMetadataTask = A2($author$project$Request$AdminMetadata$getByOrgUrlName, orgName, creds);
		var availableTiersTask = $author$project$Request$Tier$getTiers(creds);
		var addOnDefaultsByTierTask = $author$project$Request$AddOns$getAddOnDefaultsByTier(creds);
		return A2(
			$author$project$Task$Pipeline$fetch,
			orgAdminMetadataTask,
			A2(
				$author$project$Task$Pipeline$fetch,
				addOnDefaultsByTierTask,
				A2(
					$author$project$Task$Pipeline$fetch,
					availableTiersTask,
					A2(
						$author$project$Task$Pipeline$fetch,
						A3($author$project$Pages$AdminOrganization$getOrgDataTask, hasWriteAccess, orgName, creds),
						$author$project$Task$Pipeline$into(finishModel)))));
	});
var $author$project$Pages$AdminOrganizations$ID = 0;
var $author$project$Pages$AdminOrganizations$init = function (key) {
	return $elm$core$Task$succeed(
		{
			oi: $author$project$Model$CopyStatus$empty,
			Y: key,
			El: 0,
			mT: {lQ: false, wb: true},
			mX: $krisajenkins$remotedata$RemoteData$NotAsked,
			iE: ''
		});
};
var $author$project$Pages$AdminUser$Delete = 0;
var $author$project$Request$User$get = F2(
	function (username, creds) {
		return $author$project$Http$Extra$get(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$emptyBody,
				qN: $author$project$Model$User$decode,
				CN: _List_Nil,
				GT: '/users/' + username
			});
	});
var $author$project$Pages$AdminUser$init = F3(
	function (session, key, username) {
		var finishModel = F2(
			function (user, orgs) {
				return {oi: $author$project$Model$CopyStatus$empty, jP: 0, Y: key, kc: username, rJ: orgs, rK: $elm$core$Maybe$Nothing, gS: user};
			});
		var creds = $author$project$Model$Session$getCreds(session);
		var orgsTask = A2(
			$elm$core$Task$onError,
			function (_v0) {
				return $elm$core$Task$succeed(_List_Nil);
			},
			A2(
				$elm$core$Task$map,
				function ($) {
					return $.mX;
				},
				A2($author$project$Request$User$get, username, creds)));
		var userTask = A2($author$project$Request$User$get, username, creds);
		return A2(
			$author$project$Task$Pipeline$fetch,
			orgsTask,
			A2(
				$author$project$Task$Pipeline$fetch,
				userTask,
				$author$project$Task$Pipeline$into(finishModel)));
	});
var $author$project$Pages$AdminUsers$OrganizationSearch = 2;
var $author$project$Pages$AdminUsers$UserEmailSearch = 1;
var $author$project$Request$Organization$members = F2(
	function (orgName, creds) {
		return $author$project$Http$Extra$get(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$emptyBody,
				qN: $elm$json$Json$Decode$list($author$project$Model$Member$decode),
				CN: _List_Nil,
				GT: '/organizations/' + (orgName + '/members')
			});
	});
var $author$project$Pages$AdminUsers$sortUsers = function (users) {
	return A2(
		$elm$core$List$sortBy,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.AE;
			},
			$elm$core$String$toLower),
		users);
};
var $author$project$Pages$AdminUsers$init = F3(
	function (session, key, maybeOrgName) {
		var finishModel = function (members) {
			return {
				oi: $author$project$Model$CopyStatus$empty,
				lM: _List_Nil,
				Y: key,
				El: $elm$core$List$isEmpty(members) ? 1 : 2,
				kl: A2($elm$core$Maybe$withDefault, '', maybeOrgName),
				mV: false,
				mW: $author$project$Pages$AdminUsers$sortUsers(
					A2(
						$elm$core$List$map,
						function ($) {
							return $.gS;
						},
						members)),
				jC: '',
				nJ: false,
				kG: '',
				nK: false,
				p4: _List_Nil,
				nM: '',
				nN: ''
			};
		};
		var creds = $author$project$Model$Session$getCreds(session);
		var defaultQuery = function () {
			if (maybeOrgName.$ === 1) {
				return $elm$core$Task$succeed(_List_Nil);
			} else {
				var orgname = maybeOrgName.a;
				return A2($author$project$Request$Organization$members, orgname, creds);
			}
		}();
		return A2(
			$author$project$Task$Pipeline$fetch,
			defaultQuery,
			$author$project$Task$Pipeline$into(finishModel));
	});
var $author$project$PageState$Transitioning = function (a) {
	return {$: 1, a: a};
};
var $author$project$PageState$transitionTo = F2(
	function (pageState, nextRoute) {
		if (!pageState.$) {
			var currentPage = pageState.a.jK;
			var currentRoute = pageState.a.jL;
			return $author$project$PageState$Transitioning(
				{jK: currentPage, jL: currentRoute, dg: nextRoute});
		} else {
			var state = pageState.a;
			return $author$project$PageState$Transitioning(
				_Utils_update(
					state,
					{dg: nextRoute}));
		}
	});
var $author$project$Main$setAdminRoute = F3(
	function (route, subRoute, model) {
		var transition = F2(
			function (toMsg, task) {
				return A2(
					$author$project$Misc$with,
					A2($elm$core$Task$attempt, toMsg, task),
					_Utils_update(
						model,
						{
							u: A2($author$project$PageState$transitionTo, model.u, route)
						}));
			});
		switch (subRoute.$) {
			case 7:
				return A2(
					transition,
					$author$project$Msg$AdminIconomiconLoaded,
					A2($author$project$Pages$AdminIconomicon$init, model.l, model.Y));
			case 0:
				return A2(
					transition,
					$author$project$Msg$AdminOrganizationsLoaded,
					$author$project$Pages$AdminOrganizations$init(model.Y));
			case 1:
				var orgName = subRoute.a;
				return A2(
					transition,
					$author$project$Msg$AdminOrganizationLoaded,
					A3($author$project$Pages$AdminOrganization$init, model.l, model.Y, orgName));
			case 2:
				var maybeOrgName = subRoute.a;
				return A2(
					transition,
					$author$project$Msg$AdminUsersLoaded,
					A3($author$project$Pages$AdminUsers$init, model.l, model.Y, maybeOrgName));
			case 3:
				var username = subRoute.a;
				return A2(
					transition,
					$author$project$Msg$AdminUserLoaded,
					A3($author$project$Pages$AdminUser$init, model.l, model.Y, username));
			case 4:
				return A2(
					transition,
					$author$project$Msg$AdminCreateOrganizationLoaded,
					A2(
						$author$project$Pages$AdminCreateOrganization$init,
						model.Y,
						$author$project$Url$Extra$hostWithPort(model.fD)));
			case 5:
				var orgName = subRoute.a;
				var projectName = subRoute.b;
				return A2(
					transition,
					$author$project$Msg$AdminForkLoaded,
					A4($author$project$Pages$AdminFork$init, model.l, model.Y, orgName, projectName));
			default:
				return A2(
					transition,
					$author$project$Msg$AdminFeaturesLoaded,
					A2($author$project$Pages$AdminFeatures$init, model.l, model.Y));
		}
	});
var $author$project$Main$setProtectedRoute = F2(
	function (route, model) {
		var transition = F2(
			function (toMsg, task) {
				return A2(
					$author$project$Misc$with,
					A2($elm$core$Task$attempt, toMsg, task),
					_Utils_update(
						model,
						{
							u: A2(
								$author$project$PageState$transitionTo,
								model.u,
								$author$project$Model$Route$Protected(route))
						}));
			});
		var _v0 = $author$project$Model$Session$getUser(model.l);
		if (_v0.$ === 1) {
			switch (route.$) {
				case 11:
					var inviteCode = route.a.fs;
					var email = route.a.lJ;
					var newUser = route.a.zn;
					if (newUser) {
						var createAccountModel = A2(
							$author$project$Pages$CreateAccount$init,
							model.Y,
							{
								h3: $elm$core$Maybe$Nothing,
								g$: $elm$core$Maybe$Nothing,
								dH: 2,
								lJ: email,
								hx: $elm$core$Maybe$Nothing,
								fs: $elm$core$Maybe$Just(inviteCode),
								dg: $elm$core$Maybe$Just(
									$author$project$Model$Route$Protected(route)),
								o: $elm$core$Maybe$Nothing
							});
						return A2(
							$author$project$Misc$with,
							A2($author$project$Pages$CreateAccount$cmds, model.l, createAccountModel),
							_Utils_update(
								model,
								{
									u: A2(
										$author$project$PageState$load,
										model.u,
										$author$project$Page$CreateAccount(createAccountModel))
								}));
					} else {
						var loginModel = A2(
							$author$project$Pages$Login$init,
							model.Y,
							{
								g$: $elm$core$Maybe$Nothing,
								dH: 2,
								lJ: email,
								lP: $elm$core$Maybe$Nothing,
								hx: $elm$core$Maybe$Nothing,
								fs: $elm$core$Maybe$Just(inviteCode),
								dg: $elm$core$Maybe$Just(
									$author$project$Model$Route$Protected(route)),
								pC: false,
								o: $elm$core$Maybe$Nothing
							});
						return A2(
							$author$project$Misc$with,
							A2($author$project$Pages$Login$cmds, model.l, loginModel),
							_Utils_update(
								model,
								{
									u: A2(
										$author$project$PageState$load,
										model.u,
										$author$project$Page$Login(loginModel))
								}));
					}
				case 12:
					var inviteCode = route.a.fs;
					var email = route.a.lJ;
					var newUser = route.a.zn;
					var createAccountModel = A2(
						$author$project$Pages$CreateAccount$init,
						model.Y,
						{
							h3: $elm$core$Maybe$Nothing,
							g$: $elm$core$Maybe$Nothing,
							dH: 2,
							lJ: email,
							hx: $elm$core$Maybe$Nothing,
							fs: $elm$core$Maybe$Just(inviteCode),
							dg: $elm$core$Maybe$Just(
								$author$project$Model$Route$Protected(route)),
							o: $elm$core$Maybe$Nothing
						});
					if (newUser) {
						return A2(
							$author$project$Misc$with,
							A2($author$project$Pages$CreateAccount$cmds, model.l, createAccountModel),
							_Utils_update(
								model,
								{
									u: A2(
										$author$project$PageState$load,
										model.u,
										$author$project$Page$CreateAccount(createAccountModel))
								}));
					} else {
						var loginModel = A2(
							$author$project$Pages$Login$init,
							model.Y,
							{
								g$: $elm$core$Maybe$Nothing,
								dH: 2,
								lJ: email,
								lP: $elm$core$Maybe$Nothing,
								hx: $elm$core$Maybe$Nothing,
								fs: $elm$core$Maybe$Just(inviteCode),
								dg: $elm$core$Maybe$Just(
									$author$project$Model$Route$Protected(route)),
								pC: false,
								o: $elm$core$Maybe$Nothing
							});
						return A2(
							$author$project$Misc$with,
							A2($author$project$Pages$Login$cmds, model.l, loginModel),
							_Utils_update(
								model,
								{
									u: A2(
										$author$project$PageState$load,
										model.u,
										$author$project$Page$Login(loginModel))
								}));
					}
				case 14:
					var orgRoute = route.a.vI;
					if (orgRoute.$ === 7) {
						var projectRoute = orgRoute.a.zL;
						if (projectRoute.$ === 9) {
							var cliInstructionsPlatform = projectRoute.a;
							var content = projectRoute.b;
							var createAccountModel = A2(
								$author$project$Pages$CreateAccount$init,
								model.Y,
								{
									h3: $elm$core$Maybe$Nothing,
									g$: cliInstructionsPlatform,
									dH: content,
									lJ: $elm$core$Maybe$Nothing,
									hx: $elm$core$Maybe$Nothing,
									fs: $elm$core$Maybe$Nothing,
									dg: $elm$core$Maybe$Just(
										$author$project$Model$Route$Protected(route)),
									o: $elm$core$Maybe$Nothing
								});
							return A2(
								$author$project$Misc$with,
								A2($author$project$Pages$CreateAccount$cmds, model.l, createAccountModel),
								_Utils_update(
									model,
									{
										u: A2(
											$author$project$PageState$load,
											model.u,
											$author$project$Page$CreateAccount(createAccountModel))
									}));
						} else {
							var loginModel = A2(
								$author$project$Pages$Login$init,
								model.Y,
								{
									g$: $elm$core$Maybe$Nothing,
									dH: 2,
									lJ: $elm$core$Maybe$Nothing,
									lP: $elm$core$Maybe$Nothing,
									hx: $elm$core$Maybe$Nothing,
									fs: $elm$core$Maybe$Nothing,
									dg: $author$project$Model$Route$isHome(
										$elm$core$Maybe$Just(
											$author$project$Model$Route$Protected(route))) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
										$author$project$Model$Route$Protected(route)),
									pC: false,
									o: $elm$core$Maybe$Nothing
								});
							return A2(
								$author$project$Misc$with,
								A2($author$project$Pages$Login$cmds, model.l, loginModel),
								_Utils_update(
									model,
									{
										u: A2(
											$author$project$PageState$load,
											model.u,
											$author$project$Page$Login(loginModel))
									}));
						}
					} else {
						var loginModel = A2(
							$author$project$Pages$Login$init,
							model.Y,
							{
								g$: $elm$core$Maybe$Nothing,
								dH: 2,
								lJ: $elm$core$Maybe$Nothing,
								lP: $elm$core$Maybe$Nothing,
								hx: $elm$core$Maybe$Nothing,
								fs: $elm$core$Maybe$Nothing,
								dg: $author$project$Model$Route$isHome(
									$elm$core$Maybe$Just(
										$author$project$Model$Route$Protected(route))) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
									$author$project$Model$Route$Protected(route)),
								pC: false,
								o: $elm$core$Maybe$Nothing
							});
						return A2(
							$author$project$Misc$with,
							A2($author$project$Pages$Login$cmds, model.l, loginModel),
							_Utils_update(
								model,
								{
									u: A2(
										$author$project$PageState$load,
										model.u,
										$author$project$Page$Login(loginModel))
								}));
					}
				case 21:
					var createAccountModel = A2(
						$author$project$Pages$CreateAccount$init,
						model.Y,
						{
							h3: $elm$core$Maybe$Nothing,
							g$: $elm$core$Maybe$Nothing,
							dH: 2,
							lJ: $elm$core$Maybe$Nothing,
							hx: $elm$core$Maybe$Nothing,
							fs: $elm$core$Maybe$Nothing,
							dg: $elm$core$Maybe$Just(
								$author$project$Model$Route$Protected(route)),
							o: $elm$core$Maybe$Nothing
						});
					return A2(
						$author$project$Misc$with,
						A2($author$project$Pages$CreateAccount$cmds, model.l, createAccountModel),
						_Utils_update(
							model,
							{
								u: A2(
									$author$project$PageState$load,
									model.u,
									$author$project$Page$CreateAccount(createAccountModel))
							}));
				case 22:
					var createAccountModel = A2(
						$author$project$Pages$CreateAccount$init,
						model.Y,
						{
							h3: $elm$core$Maybe$Nothing,
							g$: $elm$core$Maybe$Nothing,
							dH: 2,
							lJ: $elm$core$Maybe$Nothing,
							hx: $elm$core$Maybe$Nothing,
							fs: $elm$core$Maybe$Nothing,
							dg: $elm$core$Maybe$Just(
								$author$project$Model$Route$Protected(route)),
							o: $elm$core$Maybe$Just('HeadlessCommit')
						});
					return A2(
						$author$project$Misc$with,
						A2($author$project$Pages$CreateAccount$cmds, model.l, createAccountModel),
						_Utils_update(
							model,
							{
								u: A2(
									$author$project$PageState$load,
									model.u,
									$author$project$Page$CreateAccount(createAccountModel))
							}));
				default:
					var loginModel = A2(
						$author$project$Pages$Login$init,
						model.Y,
						{
							g$: $elm$core$Maybe$Nothing,
							dH: 2,
							lJ: $elm$core$Maybe$Nothing,
							lP: $elm$core$Maybe$Nothing,
							hx: $elm$core$Maybe$Nothing,
							fs: $elm$core$Maybe$Nothing,
							dg: $author$project$Model$Route$isHome(
								$elm$core$Maybe$Just(
									$author$project$Model$Route$Protected(route))) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
								$author$project$Model$Route$Protected(route)),
							pC: false,
							o: $elm$core$Maybe$Nothing
						});
					return A2(
						$author$project$Misc$with,
						A2($author$project$Pages$Login$cmds, model.l, loginModel),
						_Utils_update(
							model,
							{
								u: A2(
									$author$project$PageState$load,
									model.u,
									$author$project$Page$Login(loginModel))
							}));
			}
		} else {
			var user = _v0.a;
			if ($author$project$Model$Session$needsToFinishSetup(model.l)) {
				switch (route.$) {
					case 24:
						var nextRoute = route.a.dg;
						return A2(
							transition,
							$author$project$Msg$FinishSetupLoaded,
							A3($author$project$Pages$FinishSetup$init, model.l, model.Y, nextRoute));
					case 3:
						return A2(
							$author$project$Misc$with,
							A2(
								$author$project$Routing$replaceUrl,
								model.Y,
								$author$project$Model$Route$Protected($author$project$Model$Route$PreferenceEmail)),
							model);
					case 5:
						return A2(
							transition,
							$author$project$Msg$PreferenceEmailLoaded,
							$author$project$Pages$PreferenceEmail$init(model.l));
					case 9:
						return A2(
							transition,
							$author$project$Msg$PreferenceDeleteAccountLoaded,
							A2($author$project$Pages$PreferenceDeleteAccount$init, model.Y, user.AE));
					case 13:
						var email = route.a.lJ;
						var code = route.a.xD;
						var nextRoute = route.a.dg;
						return A2(
							transition,
							$author$project$Msg$CheckEmailLoaded,
							A4($author$project$Pages$CheckEmail$init, model.Y, email, code, nextRoute));
					default:
						return A2(
							$author$project$Misc$with,
							A2(
								$author$project$Routing$replaceUrl,
								model.Y,
								$author$project$Model$Route$Protected(
									$author$project$Model$Route$FinishSetup(
										{
											dg: $elm$core$Maybe$Just(
												$author$project$Model$Route$Protected(route))
										}))),
							model);
				}
			} else {
				switch (route.$) {
					case 23:
						var companyName = 'Fake Company';
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									u: A2(
										$author$project$PageState$load,
										model.u,
										$author$project$Page$OutOfCompliance(
											$author$project$Pages$OutOfCompliance$init(companyName)))
								}),
							$elm$core$Platform$Cmd$none);
					case 16:
						var subRoute = route.a;
						return A2($elm$core$Basics$composeL, $author$project$Model$User$isSuperReader, $elm$core$Maybe$Just)(user) ? A3(
							$author$project$Main$setAdminRoute,
							$author$project$Model$Route$Protected(route),
							subRoute,
							model) : A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{
									u: A2(
										$author$project$PageState$load,
										model.u,
										$author$project$Page$NotFound(
											$author$project$Pages$NotFound$init(model.Y)))
								}));
					case 0:
						var _v6 = $author$project$Model$Session$getDefaultOrgUrlName(model.l);
						if (!_v6.$) {
							var orgUrlName = _v6.a;
							return A2(
								$author$project$Misc$with,
								A2(
									$author$project$Routing$replaceUrl,
									model.Y,
									$author$project$Model$Route$Protected(
										$author$project$Model$Route$Org(
											{
												ix: orgUrlName,
												vI: $author$project$Model$Route$OrgIndex($elm$core$Maybe$Nothing)
											}))),
								model);
						} else {
							return A2(
								$author$project$Misc$with,
								A2(
									$author$project$Routing$replaceUrl,
									model.Y,
									$author$project$Model$Route$Protected(
										$author$project$Model$Route$CreateOrganization(
											{h3: $elm$core$Maybe$Nothing, dg: $elm$core$Maybe$Nothing}))),
								model);
						}
					case 1:
						var userCode = route.a.GV;
						var authPage = $author$project$Pages$AuthorizeDevice$AuthorizeDevice(userCode);
						return A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{
									u: A2(
										$author$project$PageState$load,
										model.u,
										$author$project$Page$AuthorizeDevice(
											A3($author$project$Pages$AuthorizeDevice$init, model.l, authPage, model.Y)))
								}));
					case 2:
						return A2(
							$author$project$Misc$with,
							A2(
								$author$project$Routing$replaceUrl,
								model.Y,
								$author$project$Model$Route$Protected(
									$author$project$Model$Route$Home(
										{wd: $elm$core$Maybe$Nothing}))),
							model);
					case 14:
						var orgName = route.a.ix;
						var orgRoute = route.a.vI;
						switch (orgRoute.$) {
							case 0:
								var maybeSignupSource = orgRoute.a;
								var _v8 = A3($author$project$Pages$OrgIndex$init, model.l, orgName, maybeSignupSource);
								var loadingModel = _v8.a;
								var loadingCmd = _v8.b;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											cz: $author$project$Main$LoadingOrgIndex(loadingModel),
											u: A2(
												$author$project$PageState$transitionTo,
												model.u,
												$author$project$Model$Route$Protected(route))
										}),
									A2(
										$elm$core$Platform$Cmd$map,
										A2($elm$core$Basics$composeL, $author$project$Msg$LoadingMsg, $author$project$Msg$OrgIndexLoadingMsg),
										loadingCmd));
							case 1:
								return A2(
									transition,
									$author$project$Msg$OrgMembersLoaded,
									A2($author$project$Pages$OrgMembers$init, model.l, orgName));
							case 2:
								if (A2(
									$author$project$Model$Permissions$canViewOrgPrivateInfo,
									orgName,
									$elm$core$Maybe$Just(user))) {
									var _v9 = A3($author$project$Pages$OrgPolicy$init, model.l, model.Y, orgName);
									var loadingModel = _v9.a;
									var loadingCmd = _v9.b;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{
												cz: $author$project$Main$LoadingOrgPolicy(loadingModel),
												u: A2(
													$author$project$PageState$transitionTo,
													model.u,
													$author$project$Model$Route$Protected(route))
											}),
										A2(
											$elm$core$Platform$Cmd$map,
											A2($elm$core$Basics$composeL, $author$project$Msg$LoadingMsg, $author$project$Msg$OrgPolicyLoadingMsg),
											loadingCmd));
								} else {
									return A2(
										$author$project$Misc$with,
										$elm$core$Platform$Cmd$none,
										_Utils_update(
											model,
											{
												u: A2(
													$author$project$PageState$load,
													model.u,
													$author$project$Page$NotFound(
														$author$project$Pages$NotFound$init(model.Y)))
											}));
								}
							case 3:
								if (A2(
									$author$project$Model$Permissions$canViewOrgPrivateInfo,
									orgName,
									$elm$core$Maybe$Just(user))) {
									var _v10 = A3($author$project$Pages$OrgRemediation$init, model.l, model.Y, orgName);
									var loadingModel = _v10.a;
									var loadingCmd = _v10.b;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{
												cz: $author$project$Main$LoadingOrgRemediation(loadingModel),
												u: A2(
													$author$project$PageState$transitionTo,
													model.u,
													$author$project$Model$Route$Protected(route))
											}),
										A2(
											$elm$core$Platform$Cmd$map,
											A2($elm$core$Basics$composeL, $author$project$Msg$LoadingMsg, $author$project$Msg$OrgRemediationLoadingMsg),
											loadingCmd));
								} else {
									return A2(
										$author$project$Misc$with,
										$elm$core$Platform$Cmd$none,
										_Utils_update(
											model,
											{
												u: A2(
													$author$project$PageState$load,
													model.u,
													$author$project$Page$NotFound(
														$author$project$Pages$NotFound$init(model.Y)))
											}));
								}
							case 7:
								var projectName = orgRoute.a.vT;
								var projectRoute = orgRoute.a.zL;
								switch (projectRoute.$) {
									case 0:
										var args = projectRoute.a;
										var _v12 = $author$project$Pages$ProjectConfig$init(model.l)(orgName)(projectName)(args.gr)(args.uk)(args.fO)(args.yJ)(args.yo)(args.z6)(args.z7);
										var loadingModel = _v12.a;
										var loadingCmd = _v12.b;
										return _Utils_Tuple2(
											_Utils_update(
												model,
												{
													cz: $author$project$Main$LoadingProjectConfig(loadingModel),
													u: A2(
														$author$project$PageState$transitionTo,
														model.u,
														$author$project$Model$Route$Protected(route))
												}),
											A2(
												$elm$core$Platform$Cmd$map,
												A2($elm$core$Basics$composeL, $author$project$Msg$LoadingMsg, $author$project$Msg$ProjectConfigLoadingMsg),
												loadingCmd));
									case 1:
										var args = projectRoute.a;
										var _v13 = A5($author$project$Pages$ProjectConfigAdvanced$init, model.l, orgName, projectName, args.gr, args.fO);
										var loadingModel = _v13.a;
										var loadingCmd = _v13.b;
										return _Utils_Tuple2(
											_Utils_update(
												model,
												{
													cz: $author$project$Main$LoadingProjectConfigAdvanced(loadingModel),
													u: A2(
														$author$project$PageState$transitionTo,
														model.u,
														$author$project$Model$Route$Protected(route))
												}),
											A2(
												$elm$core$Platform$Cmd$map,
												A2($elm$core$Basics$composeL, $author$project$Msg$LoadingMsg, $author$project$Msg$ProjectConfigAdvancedLoadingMsg),
												loadingCmd));
									case 5:
										var commitID = projectRoute.a;
										var maybePlatformID = projectRoute.b;
										var isNewProject = projectRoute.c;
										var maybeBranchName = projectRoute.d;
										var websocketProtocol = (!model.fD.Ft) ? 'ws://' : 'wss://';
										var buildLogSocket = websocketProtocol + ($author$project$Url$Extra$hostWithPort(model.fD) + '/sv/build-log-streamer/');
										var _v14 = A8($author$project$Pages$ProjectDownloads$init, model.l, orgName, projectName, commitID, maybePlatformID, maybeBranchName, isNewProject, buildLogSocket);
										var loadingModel = _v14.a;
										var loadingCmd = _v14.b;
										return _Utils_Tuple2(
											_Utils_update(
												model,
												{
													cz: $author$project$Main$LoadingProjectDownloads(loadingModel),
													u: A2(
														$author$project$PageState$transitionTo,
														model.u,
														$author$project$Model$Route$Protected(route))
												}),
											A2(
												$elm$core$Platform$Cmd$map,
												A2($elm$core$Basics$composeL, $author$project$Msg$LoadingMsg, $author$project$Msg$ProjectDownloadsLoadingMsg),
												loadingCmd));
									case 6:
										var commitID = projectRoute.a;
										var maybeBranchName = projectRoute.b;
										var _v15 = A5($author$project$Pages$ProjectHistory$init, model.l, orgName, projectName, commitID, maybeBranchName);
										var loadingModel = _v15.a;
										var loadingCmd = _v15.b;
										return _Utils_Tuple2(
											_Utils_update(
												model,
												{
													cz: $author$project$Main$LoadingProjectHistory(loadingModel),
													u: A2(
														$author$project$PageState$transitionTo,
														model.u,
														$author$project$Model$Route$Protected(route))
												}),
											A2(
												$elm$core$Platform$Cmd$map,
												A2($elm$core$Basics$composeL, $author$project$Msg$LoadingMsg, $author$project$Msg$ProjectHistoryLoadingMsg),
												loadingCmd));
									case 7:
										var params = projectRoute.a;
										var _v16 = A5(
											$author$project$Pages$ProjectImpactReport$init,
											model.l,
											orgName,
											projectName,
											params,
											$author$project$Url$Extra$hostWithPort(model.fD));
										var loadingModel = _v16.a;
										var loadingCmd = _v16.b;
										return _Utils_Tuple2(
											_Utils_update(
												model,
												{
													cz: $author$project$Main$LoadingProjectImpactReport(loadingModel),
													u: A2(
														$author$project$PageState$transitionTo,
														model.u,
														$author$project$Model$Route$Protected(route))
												}),
											A2(
												$elm$core$Platform$Cmd$map,
												A2($elm$core$Basics$composeL, $author$project$Msg$LoadingMsg, $author$project$Msg$ProjectImpactReportLoadingMsg),
												loadingCmd));
									case 2:
										var maybeFragment = projectRoute.b;
										return A2(
											transition,
											$author$project$Msg$ProjectSettingsLoaded,
											A5(
												$author$project$Pages$ProjectSettings$init,
												model.l,
												model.Y,
												orgName,
												projectName,
												$author$project$Model$Route$parseProjectSettingsFragment(maybeFragment)));
									case 3:
										return A2(
											transition,
											$author$project$Msg$ProjectSettingsBranchesLoaded,
											A4($author$project$Pages$ProjectSettingsBranches$init, model.l, model.Y, orgName, projectName));
									case 4:
										var maybeBranchName = projectRoute.a.fO;
										var maybeCommitID = projectRoute.a.gr;
										return A2(
											transition,
											$author$project$Msg$ProjectSettingsHARLoaded,
											A5($author$project$Pages$ProjectSettingsHAR$init, model.l, orgName, projectName, maybeBranchName, maybeCommitID));
									case 8:
										var actions = projectRoute.a;
										var _v17 = $author$project$Model$Session$getDefaultOrgUrlName(model.l);
										if (_v17.$ === 1) {
											var nextRoute = $elm$core$Maybe$Just(
												$author$project$Model$Route$Protected(route));
											return A2(
												$author$project$Misc$with,
												A2(
													$author$project$Routing$replaceUrl,
													model.Y,
													$author$project$Model$Route$Protected(
														$author$project$Model$Route$CreateOrganization(
															{h3: $elm$core$Maybe$Nothing, dg: nextRoute}))),
												model);
										} else {
											var destOrgUrlName = _v17.a;
											return A2(
												transition,
												$author$project$Msg$ForkProjectLoaded,
												A6($author$project$Pages$ForkProject$init, model.l, model.Y, orgName, projectName, actions, destOrgUrlName));
										}
									default:
										var cliInstructionsPlatform = projectRoute.a;
										var content = projectRoute.b;
										return A2(
											transition,
											$author$project$Msg$AutoForkLoaded,
											A6($author$project$Pages$AutoFork$init, model.l, orgName, projectName, cliInstructionsPlatform, content, model.Y));
								}
							case 4:
								return A2(
									$author$project$Model$Permissions$canChangeOrgSettings,
									orgName,
									$elm$core$Maybe$Just(user)) ? A2(
									transition,
									$author$project$Msg$OrgSettingsLoaded,
									A3($author$project$Pages$OrgSettings$init, model.l, model.Y, orgName)) : A2(
									$author$project$Misc$with,
									$elm$core$Platform$Cmd$none,
									_Utils_update(
										model,
										{
											u: A2(
												$author$project$PageState$load,
												model.u,
												$author$project$Page$NotFound(
													$author$project$Pages$NotFound$init(model.Y)))
										}));
							case 5:
								return A2(
									$author$project$Model$Permissions$canChangeOrgSettings,
									orgName,
									$elm$core$Maybe$Just(user)) ? A2(
									transition,
									$author$project$Msg$OrgScanLoaded,
									A4(
										$author$project$Pages$OrgScan$init,
										model.l,
										model.Y,
										$author$project$Url$Extra$hostWithPort(model.fD),
										orgName)) : A2(
									$author$project$Misc$with,
									$elm$core$Platform$Cmd$none,
									_Utils_update(
										model,
										{
											u: A2(
												$author$project$PageState$load,
												model.u,
												$author$project$Page$NotFound(
													$author$project$Pages$NotFound$init(model.Y)))
										}));
							case 6:
								if (A2(
									$author$project$Model$Permissions$canViewOrgPrivateInfo,
									orgName,
									$elm$core$Maybe$Just(user))) {
									var _v18 = A2($author$project$Pages$OrgSecurity$init, model.l, orgName);
									var loadingModel = _v18.a;
									var loadingCmd = _v18.b;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{
												cz: $author$project$Main$LoadingOrgSecurity(loadingModel),
												u: A2(
													$author$project$PageState$transitionTo,
													model.u,
													$author$project$Model$Route$Protected(route))
											}),
										A2(
											$elm$core$Platform$Cmd$map,
											A2($elm$core$Basics$composeL, $author$project$Msg$LoadingMsg, $author$project$Msg$OrgSecurityLoadingMsg),
											loadingCmd));
								} else {
									return A2(
										$author$project$Misc$with,
										$elm$core$Platform$Cmd$none,
										_Utils_update(
											model,
											{
												u: A2(
													$author$project$PageState$load,
													model.u,
													$author$project$Page$NotFound(
														$author$project$Pages$NotFound$init(model.Y)))
											}));
								}
							default:
								if (A2(
									$author$project$Model$Permissions$canViewOrgPrivateInfo,
									orgName,
									$elm$core$Maybe$Just(user))) {
									var _v19 = A2($author$project$Pages$OrgDependencies$init, model.l, orgName);
									var loadingModel = _v19.a;
									var loadingCmd = _v19.b;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{
												cz: $author$project$Main$LoadingOrgDependencies(loadingModel),
												u: A2(
													$author$project$PageState$transitionTo,
													model.u,
													$author$project$Model$Route$Protected(route))
											}),
										A2(
											$elm$core$Platform$Cmd$map,
											A2($elm$core$Basics$composeL, $author$project$Msg$LoadingMsg, $author$project$Msg$OrgDependenciesLoadingMsg),
											loadingCmd));
								} else {
									return A2(
										$author$project$Misc$with,
										$elm$core$Platform$Cmd$none,
										_Utils_update(
											model,
											{
												u: A2(
													$author$project$PageState$load,
													model.u,
													$author$project$Page$NotFound(
														$author$project$Pages$NotFound$init(model.Y)))
											}));
								}
						}
					case 15:
						return A2(
							transition,
							$author$project$Msg$OrgsLoaded,
							$author$project$Pages$Orgs$init(model.l));
					case 3:
						return A2(
							$author$project$Misc$with,
							A2(
								$author$project$Routing$replaceUrl,
								model.Y,
								$author$project$Model$Route$Protected($author$project$Model$Route$PreferenceEmail)),
							model);
					case 5:
						return A2(
							transition,
							$author$project$Msg$PreferenceEmailLoaded,
							$author$project$Pages$PreferenceEmail$init(model.l));
					case 7:
						var mode = route.a.El;
						return A2(
							transition,
							$author$project$Msg$PreferencePasswordLoaded,
							A2($author$project$Pages$PreferencePassword$init, mode, model.Y));
					case 8:
						return A2(
							$author$project$Misc$with,
							A2(
								$author$project$Routing$replaceUrl,
								model.Y,
								$author$project$Model$Route$Protected($author$project$Model$Route$Orgs)),
							model);
					case 10:
						var nextRoute = route.a.dg;
						var autoProjectParams = route.a.h3;
						return A2(
							transition,
							$author$project$Msg$CreateOrganizationLoaded,
							A5(
								$author$project$Pages$CreateOrganization$init,
								model.l,
								model.Y,
								$author$project$Url$Extra$hostWithPort(model.fD),
								nextRoute,
								autoProjectParams));
					case 4:
						return A2(transition, $author$project$Msg$PreferenceTwoFactorLoaded, $author$project$Pages$PreferenceTwoFactor$init);
					case 6:
						var linkingError = route.a.D3;
						var service = route.a.F$;
						return A2(
							transition,
							$author$project$Msg$PreferenceLinkedAccountsLoaded,
							A3(
								$author$project$Pages$PreferenceLinkedAccounts$init,
								model.l,
								linkingError,
								A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeR,
										$elm$json$Json$Encode$string,
										$elm$json$Json$Encode$encode(0)),
									service)));
					case 9:
						return A2(
							transition,
							$author$project$Msg$PreferenceDeleteAccountLoaded,
							A2($author$project$Pages$PreferenceDeleteAccount$init, model.Y, user.AE));
					case 13:
						var nextRoute = route.a.dg;
						var email = route.a.lJ;
						var code = route.a.xD;
						return A2(
							transition,
							$author$project$Msg$CheckEmailLoaded,
							A4($author$project$Pages$CheckEmail$init, model.Y, email, code, nextRoute));
					case 11:
						var inviteCode = route.a.fs;
						return A2(
							transition,
							$author$project$Msg$ActivateMembershipLoaded,
							A3($author$project$Pages$ActivateMembership$init, model.l, model.Y, inviteCode));
					case 12:
						var inviteCode = route.a.fs;
						return A2(
							transition,
							$author$project$Msg$ActivateMembershipLoaded,
							A3($author$project$Pages$ActivateMembership$init, model.l, model.Y, inviteCode));
					case 17:
						var languageName = route.a.DQ;
						var isNewUser = route.a.jc;
						var languageVersion = route.a.DS;
						var maybeOSName = route.a.rv;
						var autoCreate = route.a.A9;
						var maybeNextAction = route.a.ru;
						var _v20 = $author$project$Model$Session$getDefaultOrgUrlName(model.l);
						if (_v20.$ === 1) {
							var nextRoute = $elm$core$Maybe$Just(
								$author$project$Model$Route$Protected(route));
							return A2(
								$author$project$Misc$with,
								A2(
									$author$project$Routing$replaceUrl,
									model.Y,
									$author$project$Model$Route$Protected(
										$author$project$Model$Route$CreateOrganization(
											{h3: $elm$core$Maybe$Nothing, dg: nextRoute}))),
								model);
						} else {
							var orgUrlName = _v20.a;
							return A2(
								transition,
								$author$project$Msg$CreateProjectLoaded,
								$author$project$Pages$CreateProject$init(
									{
										A9: autoCreate,
										t0: $author$project$Url$Extra$hostWithPort(model.fD),
										jc: isNewUser,
										Y: model.Y,
										y8: A2(
											$elm$core$Maybe$map,
											function (name) {
												return {w: name, aI: languageVersion};
											},
											languageName),
										ru: maybeNextAction,
										rv: maybeOSName,
										ix: orgUrlName,
										l: model.l
									}));
						}
					case 18:
						var orgName = route.a.ix;
						var createProjectParams = route.a.B2;
						return A2(
							transition,
							$author$project$Msg$CreateProjectLoaded,
							$author$project$Pages$CreateProject$init(
								{
									A9: createProjectParams.A9,
									t0: $author$project$Url$Extra$hostWithPort(model.fD),
									jc: createProjectParams.jc,
									Y: model.Y,
									y8: A2(
										$elm$core$Maybe$map,
										function (name) {
											return {w: name, aI: createProjectParams.DS};
										},
										createProjectParams.DQ),
									ru: createProjectParams.ru,
									rv: createProjectParams.rv,
									ix: orgName,
									l: model.l
								}));
					case 19:
						var orgName = route.a.ix;
						var orgname = A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm_community$maybe_extra$Maybe$Extra$or,
								orgName,
								$author$project$Model$Session$getDefaultOrgUrlName(model.l)));
						return A2(
							transition,
							$author$project$Msg$ImportProjectLoaded,
							A3($author$project$Pages$ImportProject$init, model.l, model.Y, orgname));
					case 21:
						var isTrial = route.a.up;
						var isNewUser = route.a.jc;
						var nextRoute = route.a.dg;
						var tier = route.a.dc;
						var orgName = route.a.ix;
						var skipSelection = route.a.Ab;
						return A2(
							transition,
							$author$project$Msg$CheckoutLoaded,
							A3(
								$author$project$Pages$Checkout$init,
								model.l,
								model.Y,
								{
									t0: $author$project$Url$Extra$hostWithPort(model.fD),
									jc: isNewUser,
									up: isTrial,
									Ee: nextRoute,
									F9: A2(
										$elm$core$Maybe$map,
										function (orgUrlName) {
											return A2($elm$core$Tuple$pair, orgUrlName, skipSelection);
										},
										orgName),
									dc: tier
								}));
					case 20:
						var isNewUser = route.a.jc;
						var nextRoute = route.a.dg;
						return A2(
							$author$project$Misc$with,
							A2(
								$author$project$Routing$replaceUrl,
								model.Y,
								$author$project$Model$Route$Protected(
									$author$project$Model$Route$Checkout(
										{jc: isNewUser, up: true, dg: nextRoute, ix: $elm$core$Maybe$Nothing, Ab: false, dc: $elm$core$Maybe$Nothing}))),
							model);
					case 22:
						var commitID = route.a.BR;
						var projectName = route.a.vT;
						return A2(
							transition,
							$author$project$Msg$CreateProjectFromCommitLoaded,
							A4($author$project$Pages$CreateProjectFromCommit$init, model.l, model.Y, commitID, projectName));
					default:
						var nextRoute = route.a.dg;
						return A2(
							transition,
							$author$project$Msg$FinishSetupLoaded,
							A3($author$project$Pages$FinishSetup$init, model.l, model.Y, nextRoute));
				}
			}
		}
	});
var $author$project$Main$setRoute = F2(
	function (route, model) {
		var transition = F2(
			function (toMsg, task) {
				return A2(
					$author$project$Misc$with,
					A2($elm$core$Task$attempt, toMsg, task),
					_Utils_update(
						model,
						{
							u: A2($author$project$PageState$transitionTo, model.u, route)
						}));
			});
		switch (route.$) {
			case 6:
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					_Utils_update(
						model,
						{
							u: A2(
								$author$project$PageState$load,
								model.u,
								$author$project$Page$NotFound(
									$author$project$Pages$NotFound$init(model.Y)))
						}));
			case 0:
				return A2(
					$author$project$Misc$with,
					A2(
						$elm$core$Task$perform,
						$elm$core$Basics$always($author$project$Msg$OnLogout),
						$elm$core$Task$succeed(0)),
					model);
			case 2:
				var routeParams = route.a;
				var _v1 = $author$project$Model$Session$getUser(model.l);
				if (!_v1.$) {
					var user = _v1.a;
					var nextRoute = A2(
						$author$project$Pages$CreateAccount$getNextRoute,
						$elm$core$Maybe$Just(user),
						routeParams);
					return A2(
						$author$project$Misc$with,
						A2($author$project$Routing$replaceUrl, model.Y, nextRoute),
						model);
				} else {
					var createAccountModel = A2($author$project$Pages$CreateAccount$init, model.Y, routeParams);
					return A2(
						$author$project$Misc$with,
						A2($author$project$Pages$CreateAccount$cmds, model.l, createAccountModel),
						_Utils_update(
							model,
							{
								u: A2(
									$author$project$PageState$load,
									model.u,
									$author$project$Page$CreateAccount(createAccountModel))
							}));
				}
			case 1:
				var loginRouteParams = route.a;
				var _v2 = $author$project$Model$Session$getUser(model.l);
				if (!_v2.$) {
					var nextRoute = $author$project$Pages$Login$getNextRoute(loginRouteParams);
					return A2(
						$author$project$Misc$with,
						A2($author$project$Routing$replaceUrl, model.Y, nextRoute),
						model);
				} else {
					var loginModel = A2($author$project$Pages$Login$init, model.Y, loginRouteParams);
					return A2(
						$author$project$Misc$with,
						A2($author$project$Pages$Login$cmds, model.l, loginModel),
						_Utils_update(
							model,
							{
								u: A2(
									$author$project$PageState$load,
									model.u,
									$author$project$Page$Login(loginModel))
							}));
				}
			case 4:
				return A2(transition, $author$project$Msg$ForgotPasswordLoaded, $author$project$Pages$ForgotPassword$init);
			case 3:
				var inviteCode = route.a.fs;
				var nextRoute = route.a.dg;
				var errorType = route.a.lP;
				var next = A2(
					$elm$core$Maybe$withDefault,
					$author$project$Model$Route$Protected(
						$author$project$Model$Route$Home(
							{wd: $elm$core$Maybe$Nothing})),
					nextRoute);
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					_Utils_update(
						model,
						{
							u: A2(
								$author$project$PageState$load,
								model.u,
								$author$project$Page$ConnectAccount(
									A4($author$project$Pages$ConnectAccount$init, model.Y, inviteCode, next, errorType)))
						}));
			case 5:
				var code = route.a;
				return A2(
					transition,
					$author$project$Msg$ResetPasswordLoaded,
					A2($author$project$Pages$ResetPassword$init, model.Y, code));
			case 7:
				var _protected = route.a;
				return A2($author$project$Main$setProtectedRoute, _protected, model);
			case 8:
				return A2(
					transition,
					$author$project$Msg$SupportLoaded,
					A2($author$project$Pages$Support$init, model.l, model.Y));
			case 9:
				return A2(
					transition,
					$author$project$Msg$StateToolCheatSheetLoaded,
					$author$project$Pages$StateToolCheatSheet$init(model.Y));
			case 10:
				return A2(
					transition,
					$author$project$Msg$PublicProjectsLoaded,
					A2($author$project$Pages$PublicProjects$init, model.l, model.Y));
			case 12:
				var args = route.a;
				return A2(
					transition,
					$author$project$Msg$ProjectOverviewLoaded,
					A8($author$project$Pages$ProjectOverview$init, model.l, model.Y, args.ix, args.vT, args.g$, args.uk, args.fO, args.DD));
			case 13:
				var args = route.a;
				var initParams = function () {
					if (!args.$) {
						return $author$project$Pages$SupplementalLicenseTerms$Sample;
					} else {
						var ids = args.a;
						return $author$project$Pages$SupplementalLicenseTerms$ForProject(ids);
					}
				}();
				return A2(
					transition,
					$author$project$Msg$SupplementalLicenseTermsLoaded,
					$author$project$Pages$SupplementalLicenseTerms$init(initParams));
			default:
				var commitID = route.a;
				var _v4 = A2($author$project$Pages$ProjectPreview$init, model.l, commitID);
				var loadingModel = _v4.a;
				var loadingCmd = _v4.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cz: $author$project$Main$LoadingProjectPreview(loadingModel),
							u: A2($author$project$PageState$transitionTo, model.u, route)
						}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Msg$LoadingMsg, $author$project$Msg$ProjectPreviewLoadingMsg),
						loadingCmd));
		}
	});
var $author$project$Ports$clearLocalStorage = _Platform_outgoingPort('clearLocalStorage', $elm$json$Json$Encode$string);
var $author$project$Model$LocalStorage$clear = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2(
			$author$project$Misc$with,
			$author$project$Ports$clearLocalStorage(key),
			A2($elm$core$Dict$remove, key, dict));
	});
var $author$project$Model$Session$setSuperUserFeaturesVisible = F2(
	function (superUserFeaturesVisible, _v0) {
		var session = _v0;
		var _v1 = superUserFeaturesVisible ? A2($author$project$Model$LocalStorage$clear, $author$project$Model$LocalStorage$superUserFeaturesHiddenKey, session.fu) : A2(
			$author$project$Model$LocalStorage$set,
			{Y: $author$project$Model$LocalStorage$superUserFeaturesHiddenKey, kH: $author$project$Model$LocalStorage$superUserFeaturesHiddenValue},
			session.fu);
		var newLocalStorage = _v1.a;
		var localStorageCmd = _v1.b;
		return A2(
			$author$project$Misc$with,
			localStorageCmd,
			_Utils_update(
				session,
				{fu: newLocalStorage}));
	});
var $author$project$Model$Theme$themeToValue = function (theme) {
	switch (theme) {
		case 0:
			return 'dark';
		case 1:
			return 'light';
		default:
			return 'unset';
	}
};
var $author$project$Model$Session$setTheme = F2(
	function (theme, _v0) {
		var session = _v0;
		var _v1 = A2(
			$author$project$Model$LocalStorage$set,
			{
				Y: $author$project$Model$LocalStorage$themeKey,
				kH: $author$project$Model$Theme$themeToValue(theme)
			},
			session.fu);
		var newLocalStorage = _v1.a;
		var localStorageCmd = _v1.b;
		return A2(
			$author$project$Misc$with,
			localStorageCmd,
			_Utils_update(
				session,
				{fu: newLocalStorage}));
	});
var $author$project$Ports$stopRecordingUser = _Platform_outgoingPort(
	'stopRecordingUser',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 1) {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + $elm$core$String$fromInt(port_));
		}
	});
var $elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 1) {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var $elm$url$Url$toString = function (url) {
	var http = function () {
		var _v0 = url.Ft;
		if (!_v0) {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		$elm$url$Url$addPrefixed,
		'#',
		url.oD,
		A3(
			$elm$url$Url$addPrefixed,
			'?',
			url.r1,
			_Utils_ap(
				A2(
					$elm$url$Url$addPort,
					url.Fk,
					_Utils_ap(http, url.t0)),
				url.pm)));
};
var $author$project$Model$Experiments$Experiments$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$LocalStorage$update = F2(
	function (msg, model) {
		var dict = model;
		var key = msg.Y;
		var value = msg.kH;
		return (value === 'undefined') ? model : A3($elm$core$Dict$insert, key, value, dict);
	});
var $author$project$TimeUtils$add = F2(
	function (point, duration) {
		return $elm$time$Time$millisToPosix(
			$elm$time$Time$posixToMillis(point) + duration);
	});
var $author$project$Views$NotificationsGlobal$animationDurationSecs = 5;
var $author$project$TimeUtils$millisPerSec = 1000;
var $author$project$Views$NotificationsGlobal$animationDurationMillis = $author$project$Views$NotificationsGlobal$animationDurationSecs * $author$project$TimeUtils$millisPerSec;
var $author$project$Misc$tripleFirst = function (_v0) {
	var x = _v0.a;
	return x;
};
var $author$project$Views$NotificationsGlobal$update = F2(
	function (msg, _v0) {
		var internal = _v0;
		var incr = msg.a;
		var notification = msg.b;
		var currentTime = msg.c;
		var minNotificationTime = A2($author$project$TimeUtils$add, currentTime, -$author$project$Views$NotificationsGlobal$animationDurationMillis);
		var isStillRecentEnough = function (notificationTime) {
			return !(!A2($author$project$TimeUtils$compare, notificationTime, minNotificationTime));
		};
		var nextNotifications = A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeR, $author$project$Misc$tripleFirst, isStillRecentEnough),
			A2(
				$elm$core$List$cons,
				_Utils_Tuple3(currentTime, incr, notification),
				internal.mN));
		return A2(
			$author$project$Misc$with,
			$elm$core$Platform$Cmd$none,
			_Utils_update(
				internal,
				{cF: currentTime, mN: nextNotifications}));
	});
var $author$project$Model$Session$update = F2(
	function (msg, _v0) {
		var session = _v0;
		switch (msg.$) {
			case 0:
				var localTimezone = msg.a;
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					_Utils_update(
						session,
						{rp: localTimezone}));
			case 1:
				var hubSpotChatLoaded = msg.a;
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					_Utils_update(
						session,
						{t3: hubSpotChatLoaded}));
			case 2:
				var googleAnalyticsData = msg.a;
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					_Utils_update(
						session,
						{
							tY: $elm$core$Maybe$Just(googleAnalyticsData)
						}));
			case 3:
				var expData = msg.a;
				var id = expData.l6;
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					_Utils_update(
						session,
						{
							qV: A3(
								$elm$core$Dict$insert,
								id,
								$author$project$Model$Experiments$Experiments$Loaded(expData),
								session.qV)
						}));
			case 4:
				var localStorageMsg = msg.a;
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					_Utils_update(
						session,
						{
							fu: A2($author$project$Model$LocalStorage$update, localStorageMsg, session.fu)
						}));
			default:
				var notificationsMsg = msg.a;
				var _v2 = A2($author$project$Views$NotificationsGlobal$update, notificationsMsg, session.mN);
				var newNotifications = _v2.a;
				var cmd = _v2.b;
				return A2(
					$author$project$Misc$with,
					A2($elm$core$Platform$Cmd$map, $author$project$Model$Session$NotificationsMsg, cmd),
					_Utils_update(
						session,
						{mN: newNotifications}));
		}
	});
var $author$project$External$AddMembership = function (a) {
	return {$: 5, a: a};
};
var $author$project$External$AddNotification = function (a) {
	return {$: 8, a: a};
};
var $author$project$External$NoOp = {$: 0};
var $author$project$Pages$ActivateMembership$OnActivatedOrgInfo = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$ActivateMembership$OnMemberActivated = function (a) {
	return {$: 2, a: a};
};
var $author$project$External$RemoveInvitesForOrg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Request$Member$put = F3(
	function (organizationName, inviteCode, creds) {
		return $author$project$Http$Extra$put(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: A2(
					$elm$core$Maybe$withDefault,
					$author$project$Http$Extra$emptyJsonBody,
					A2(
						$elm$core$Maybe$map,
						function (code) {
							return $author$project$Http$Extra$jsonBody(
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'inviteCode',
											$elm$json$Json$Encode$string(
												$author$project$Model$NonEmptyString$toString(code)))
										])));
						},
						inviteCode)),
				qN: $elm$json$Json$Decode$list($author$project$Model$Member$decode),
				CN: _List_Nil,
				GT: '/organizations/' + (organizationName + ('/members/' + $author$project$Protected$username(creds)))
			});
	});
var $author$project$Pages$ActivateMembership$NoOp = {$: 0};
var $author$project$Pages$ActivateMembership$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Pages$ActivateMembership$NoOp, 'Pages/ActivateMembership.elm');
var $author$project$Pages$ActivateMembership$update = F3(
	function (session, msg, model) {
		var creds = $author$project$Model$Session$getCreds(session);
		switch (msg.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
			case 1:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$ActivateMembership$OnMemberActivated,
							A3(
								$author$project$Request$Member$put,
								model.ix,
								$elm$core$Maybe$Just(model.fs),
								creds)),
						model));
			case 2:
				if (!msg.a.$) {
					var members = msg.a.a;
					var newMember = A2(
						$elm_community$list_extra$List$Extra$find,
						function (m) {
							return _Utils_eq(
								$elm$core$Maybe$Just(m.gS.AE),
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.AE;
									},
									$author$project$Model$Session$getUser(session)));
						},
						members);
					var getOrg = function (member) {
						return A2(
							$elm$core$Task$attempt,
							$author$project$Pages$ActivateMembership$OnActivatedOrgInfo(member),
							A2($author$project$Request$Organization$get, model.ix, creds));
					};
					var cmd = A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Cmd$none,
						A2($elm$core$Maybe$map, getOrg, newMember));
					return A2(
						$author$project$Misc$with,
						$author$project$External$RemoveInvitesForOrg(model.ix),
						A2($author$project$Misc$with, cmd, model));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$ActivateMembership$rollbar.FZ, 'OnMemberActivated (Err err)', err, session),
							model));
				}
			default:
				if (!msg.b.$) {
					var userMember = msg.a;
					var org = msg.b.a;
					var newMembership = {ts: org.ak, DM: model.uQ, zw: model.zw, FO: userMember.FO, dc: org.dc, AC: model.ix};
					var eventArgs = A2(
						$author$project$Model$Analytics$withAction,
						'Accepted invite',
						A2(
							$author$project$Model$Analytics$withCategory,
							'Organizations',
							$author$project$Model$Analytics$newEvent('Accepted invite')));
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddMembership(newMembership),
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Ports$sendAnalyticsEvent(eventArgs),
										A2($author$project$Routing$replaceUrl, model.Y, model.vI)
									])),
							model));
				} else {
					var err = msg.b.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$ActivateMembership$rollbar.FZ, 'OnActivatedOrgInfo _ (Err err)', err, session),
							model));
				}
		}
	});
var $author$project$Pages$AdminCreateOrganization$CreateOrgFormMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$AdminCreateOrganization$OnCreateOrganization = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$Route$adminOrganization = function (orgName) {
	return $author$project$Model$Route$Protected(
		$author$project$Model$Route$Admin(
			$author$project$Model$Route$AdminOrganization(orgName)));
};
var $author$project$Views$CreateOrgForm$getFields = function (model) {
	return {ix: model.ix, E_: model.jk};
};
var $author$project$Model$OrganizationEditable$encode = function (_v0) {
	var displayName = _v0.i$;
	var urlName = _v0.AC;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'displayName',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, displayName))),
				_Utils_Tuple2(
				'URLname',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, urlName)))
			]));
};
var $author$project$Request$Organization$post = F2(
	function (org, creds) {
		return $author$project$Http$Extra$post(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$jsonBody(
					$author$project$Model$OrganizationEditable$encode(org)),
				qN: $author$project$Model$Organization$decode,
				CN: _List_Nil,
				GT: '/organizations'
			});
	});
var $author$project$Pages$AdminCreateOrganization$NoOp = {$: 0};
var $author$project$Pages$AdminCreateOrganization$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Pages$AdminCreateOrganization$NoOp, 'Pages/AdminCreateOrganization.elm');
var $author$project$Views$CreateOrgForm$setNotSubmitting = function (model) {
	return _Utils_update(
		model,
		{ri: false});
};
var $author$project$Views$CreateOrgForm$Requested = 1;
var $author$project$Views$CreateOrgForm$Unavailable = 3;
var $author$project$Views$CreateOrgForm$GotOrgNameAvailability = function (a) {
	return {$: 3, a: a};
};
var $author$project$Views$CreateOrgForm$checkNameAvailabilityCmd = function (_v0) {
	var name = _v0.w;
	var isValid = _v0.ur;
	var session = _v0.l;
	return isValid ? A2(
		$elm$core$Task$attempt,
		$author$project$Views$CreateOrgForm$GotOrgNameAvailability,
		A2(
			$author$project$Request$Organization$isNameAvailable,
			name,
			$author$project$Model$Session$getCreds(session))) : $elm$core$Platform$Cmd$none;
};
var $author$project$Views$CreateOrgForm$DebounceMsg = function (a) {
	return {$: 2, a: a};
};
var $jinjor$elm_debounce$Debounce$Later = function (a) {
	return {$: 2, a: a};
};
var $jinjor$elm_debounce$Debounce$later = $jinjor$elm_debounce$Debounce$Later;
var $author$project$Views$CreateOrgForm$debounceConfig = {
	eO: $jinjor$elm_debounce$Debounce$later(500),
	GN: $author$project$Views$CreateOrgForm$DebounceMsg
};
var $author$project$Validation$minOrgNameLength = 3;
var $jinjor$elm_debounce$Debounce$Flush = function (a) {
	return {$: 1, a: a};
};
var $jinjor$elm_debounce$Debounce$SendIfLengthNotChangedFrom = function (a) {
	return {$: 2, a: a};
};
var $jinjor$elm_debounce$Debounce$delayCmd = F2(
	function (delay, msg) {
		return A2(
			$elm$core$Task$perform,
			function (_v0) {
				return msg;
			},
			$elm$core$Process$sleep(delay));
	});
var $jinjor$elm_debounce$Debounce$length = function (_v0) {
	var input = _v0.$7;
	return $elm$core$List$length(input);
};
var $jinjor$elm_debounce$Debounce$push = F3(
	function (config, a, _v0) {
		var d = _v0;
		var newDebounce = _Utils_update(
			d,
			{
				$7: A2($elm$core$List$cons, a, d.$7)
			});
		var selfCmd = function () {
			var _v1 = config.eO;
			switch (_v1.$) {
				case 0:
					var offset = _v1.a;
					return d.oZ ? $elm$core$Platform$Cmd$none : A2(
						$jinjor$elm_debounce$Debounce$delayCmd,
						offset,
						$jinjor$elm_debounce$Debounce$Flush($elm$core$Maybe$Nothing));
				case 1:
					var offset = _v1.a;
					var delay = _v1.b;
					return d.oZ ? $elm$core$Platform$Cmd$none : A2(
						$jinjor$elm_debounce$Debounce$delayCmd,
						offset,
						$jinjor$elm_debounce$Debounce$Flush(
							$elm$core$Maybe$Just(delay)));
				default:
					var delay = _v1.a;
					return A2(
						$jinjor$elm_debounce$Debounce$delayCmd,
						delay,
						$jinjor$elm_debounce$Debounce$SendIfLengthNotChangedFrom(
							$jinjor$elm_debounce$Debounce$length(newDebounce)));
			}
		}();
		return _Utils_Tuple2(
			newDebounce,
			A2($elm$core$Platform$Cmd$map, config.GN, selfCmd));
	});
var $author$project$Views$CreateOrgForm$NoOp = {$: 5};
var $author$project$Views$CreateOrgForm$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Views$CreateOrgForm$NoOp, 'Pages/ProjectConfig.elm');
var $jinjor$elm_debounce$Debounce$takeLast = F3(
	function (send, head, tail) {
		return _Utils_Tuple2(
			_List_Nil,
			send(head));
	});
var $jinjor$elm_debounce$Debounce$update = F4(
	function (config, send, msg, _v0) {
		var d = _v0;
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(d, $elm$core$Platform$Cmd$none);
			case 1:
				var tryAgainAfter = msg.a;
				var _v2 = d.$7;
				if (_v2.b) {
					var head = _v2.a;
					var tail = _v2.b;
					var selfCmd = function () {
						if (!tryAgainAfter.$) {
							var delay = tryAgainAfter.a;
							return A2(
								$jinjor$elm_debounce$Debounce$delayCmd,
								delay,
								$jinjor$elm_debounce$Debounce$Flush(
									$elm$core$Maybe$Just(delay)));
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					var _v3 = A2(send, head, tail);
					var input = _v3.a;
					var sendCmd = _v3.b;
					return _Utils_Tuple2(
						_Utils_update(
							d,
							{$7: input, oZ: true}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									sendCmd,
									A2($elm$core$Platform$Cmd$map, config.GN, selfCmd)
								])));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							d,
							{oZ: false}),
						$elm$core$Platform$Cmd$none);
				}
			default:
				var lastInputLength = msg.a;
				var _v5 = _Utils_Tuple2(
					_Utils_cmp(
						$elm$core$List$length(d.$7),
						lastInputLength) < 1,
					d.$7);
				if (_v5.a && _v5.b.b) {
					var _v6 = _v5.b;
					var head = _v6.a;
					var tail = _v6.b;
					var _v7 = A2(send, head, tail);
					var input = _v7.a;
					var cmd = _v7.b;
					return _Utils_Tuple2(
						_Utils_update(
							d,
							{$7: input}),
						cmd);
				} else {
					return _Utils_Tuple2(d, $elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Validation$maxUsernameLength = 40;
var $author$project$Validation$minUsernameLength = 3;
var $author$project$Validation$validateUsername = $author$project$Validation$runValidations(
	_List_fromArray(
		[
			_Utils_Tuple2($elm$core$String$isEmpty, 'Please provide a value'),
			_Utils_Tuple2(
			function (x) {
				return A2($elm$core$String$startsWith, '-', x) || A2($elm$core$String$endsWith, '-', x);
			},
			'Your name cannot start or end with a dash'),
			_Utils_Tuple2(
			$author$project$Validation$isShorterThan($author$project$Validation$minUsernameLength),
			'Must be at least ' + ($elm$core$String$fromInt($author$project$Validation$minUsernameLength) + ' characters long')),
			_Utils_Tuple2(
			$author$project$Validation$isLongerThan($author$project$Validation$maxUsernameLength),
			'Must be no more than ' + ($elm$core$String$fromInt($author$project$Validation$maxUsernameLength) + ' characters long')),
			_Utils_Tuple2(
			$elm$regex$Regex$contains(
				A2(
					$elm$core$Maybe$withDefault,
					$elm$regex$Regex$never,
					$elm$regex$Regex$fromString('--+'))),
			'Your name may not contain more than one hyphen in a row'),
			_Utils_Tuple2(
			$elm$regex$Regex$contains(
				A2(
					$elm$core$Maybe$withDefault,
					$elm$regex$Regex$never,
					$elm$regex$Regex$fromString('[^a-zA-Z0-9-]'))),
			'Your name may only contain numbers, letters, and hyphens')
		]));
var $author$project$Views$CreateOrgForm$update = F3(
	function (session, action, model) {
		switch (action.$) {
			case 0:
				var orgUrlName = action.a;
				var orgUrlNameFormatted = $author$project$Validation$formatUsername(orgUrlName);
				var orgUrlNameError = $author$project$Validation$validateUsername(orgUrlNameFormatted);
				var _v1 = (_Utils_cmp(
					$elm$core$String$length(orgUrlNameFormatted),
					$author$project$Validation$minOrgNameLength) < 0) ? _Utils_Tuple2(model.lp, $elm$core$Platform$Cmd$none) : A3(
					$jinjor$elm_debounce$Debounce$push,
					$author$project$Views$CreateOrgForm$debounceConfig,
					{
						ur: (orgUrlNameFormatted !== '') && $elm_community$maybe_extra$Maybe$Extra$isNothing(orgUrlNameError),
						w: orgUrlNameFormatted,
						l: session
					},
					model.lp);
				var newDebounce = _v1.a;
				var debouncedCmd = _v1.b;
				return A2(
					$author$project$Misc$with,
					false,
					A2(
						$author$project$Misc$with,
						debouncedCmd,
						_Utils_update(
							model,
							{lp: newDebounce, g8: 0, ix: orgUrlNameFormatted, gv: orgUrlNameError, jk: orgUrlNameFormatted, iI: false, p3: orgUrlName})));
			case 2:
				var debounceMsg = action.a;
				var _v2 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Views$CreateOrgForm$debounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast($author$project$Views$CreateOrgForm$checkNameAvailabilityCmd),
					debounceMsg,
					model.lp);
				var debounce = _v2.a;
				var cmd = _v2.b;
				return A2(
					$author$project$Misc$with,
					false,
					A2(
						$author$project$Misc$with,
						cmd,
						_Utils_update(
							model,
							{
								lp: debounce,
								g8: function () {
									var _v3 = model.gv;
									if (!_v3.$) {
										return model.g8;
									} else {
										return 1;
									}
								}()
							})));
			case 3:
				if (!action.a.$) {
					var isAvailable = action.a.a;
					var _v4 = function () {
						if (isAvailable) {
							return _Utils_Tuple2(2, $elm$core$Maybe$Nothing);
						} else {
							var _v5 = model.gv;
							if (!_v5.$) {
								return _Utils_Tuple2(0, model.gv);
							} else {
								return _Utils_Tuple2(
									3,
									$elm$core$Maybe$Just('This name is already in use.'));
							}
						}
					}();
					var status = _v4.a;
					var maybeError = _v4.b;
					return A2(
						$author$project$Misc$with,
						false,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{g8: status, gv: maybeError, iI: !isAvailable})));
				} else {
					var err = action.a.a;
					return A2(
						$author$project$Misc$with,
						false,
						A2(
							$author$project$Misc$with,
							A3($author$project$Views$CreateOrgForm$rollbar.FZ, 'GotOrgNameAvailability (Err err)', err, session),
							_Utils_update(
								model,
								{
									g8: 3,
									gv: $elm$core$Maybe$Just('Failed to check availability. You can still try to create the organization'),
									iI: true
								})));
				}
			case 1:
				var tier = action.a;
				var canSubmit = _Utils_eq(model.gv, $elm$core$Maybe$Nothing);
				return A2(
					$author$project$Misc$with,
					canSubmit,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{ri: canSubmit, kv: tier, iI: true})));
			case 4:
				return A2(
					$author$project$Misc$with,
					false,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								g8: (_Utils_cmp(
									$elm$core$String$length(model.jk),
									$author$project$Validation$minOrgNameLength) < 0) ? 0 : model.g8,
								iI: true
							})));
			default:
				return _Utils_Tuple2(
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
					false);
		}
	});
var $author$project$Pages$AdminCreateOrganization$update = F3(
	function (session, action, model) {
		switch (action.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
			case 2:
				var msg = action.a;
				var _v1 = A3($author$project$Views$CreateOrgForm$update, session, msg, model.jT);
				var _v2 = _v1.a;
				var form = _v2.a;
				var cmd = _v2.b;
				var submitted = _v1.b;
				var newModel = _Utils_update(
					model,
					{jT: form});
				if (submitted) {
					var fields = $author$project$Views$CreateOrgForm$getFields(form);
					var postData = {
						i$: $elm$core$Maybe$Just(fields.ix),
						AC: $elm$core$Maybe$Just(fields.E_)
					};
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							A2(
								$elm$core$Task$attempt,
								$author$project$Pages$AdminCreateOrganization$OnCreateOrganization,
								A2(
									$author$project$Request$Organization$post,
									postData,
									$author$project$Model$Session$getCreds(session))),
							newModel));
				} else {
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$AdminCreateOrganization$CreateOrgFormMsg, cmd),
							newModel));
				}
			default:
				if (!action.a.$) {
					var org = action.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							A2(
								$author$project$Routing$replaceUrl,
								model.Y,
								$author$project$Model$Route$adminOrganization(org.AC)),
							model));
				} else {
					var err = action.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$AdminCreateOrganization$rollbar.FZ, 'OnCreateOrganization (Err err)', err, session),
							_Utils_update(
								model,
								{
									jT: $author$project$Views$CreateOrgForm$setNotSubmitting(model.jT)
								})));
				}
		}
	});
var $author$project$Pages$AdminFeatures$UpdateAddOn = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$AddOns$empty = {xA: '', bP: '', Cp: false, yQ: true, w: ''};
var $author$project$Pages$AdminFeatures$NoOp = {$: 0};
var $author$project$Pages$AdminFeatures$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Pages$AdminFeatures$NoOp, 'Pages/AdminFeatures.elm');
var $author$project$Model$AddOns$encodeAddOn = function (_v0) {
	var enabled = _v0.Cp;
	var description = _v0.bP;
	var name = _v0.w;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'enabled',
				$elm$json$Json$Encode$bool(enabled)),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(description)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(name))
			]));
};
var $author$project$Request$AddOns$setAddOnDefault = F3(
	function (tierName, addOn, creds) {
		var url = A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				['/addons', tierName]),
			_List_Nil);
		return $author$project$Http$Extra$post(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$jsonBody(
					$author$project$Model$AddOns$encodeAddOn(addOn)),
				qN: $author$project$Model$Message$decode,
				CN: _List_Nil,
				GT: url
			});
	});
var $author$project$Model$AddOnDefaultsByTier$updateAddOnsState = F3(
	function (addOnName, state, addOns) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$List$map(
				function (a) {
					return _Utils_eq(a.w, addOnName) ? _Utils_update(
						a,
						{Cp: state}) : a;
				}),
			addOns);
	});
var $author$project$Model$AddOnDefaultsByTier$updateAddOnStateForTier = F4(
	function (tierName, addOnName, state, addOns) {
		return A3(
			$elm$core$Dict$update,
			tierName,
			A2($author$project$Model$AddOnDefaultsByTier$updateAddOnsState, addOnName, state),
			addOns);
	});
var $author$project$Pages$AdminFeatures$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
			case 1:
				var tier = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{jM: tier})));
			case 2:
				var tierID = msg.a;
				var addOnName = msg.b;
				var state = msg.c;
				var _v1 = A2($elm$core$Dict$get, tierID, model.jD);
				if (!_v1.$) {
					var updatedAddOnDefaultsByTier = A4($author$project$Model$AddOnDefaultsByTier$updateAddOnStateForTier, tierID, addOnName, state, model.jD);
					var addOn = A2(
						$elm$core$Maybe$withDefault,
						$author$project$Model$AddOns$empty,
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.w;
									},
									$elm$core$Basics$eq(addOnName)),
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2($elm$core$Dict$get, tierID, updatedAddOnDefaultsByTier)))));
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							A2(
								$elm$core$Task$attempt,
								$author$project$Pages$AdminFeatures$UpdateAddOn,
								A3(
									$author$project$Request$AddOns$setAddOnDefault,
									tierID,
									addOn,
									$author$project$Model$Session$getCreds(session))),
							_Utils_update(
								model,
								{jD: updatedAddOnDefaultsByTier})));
				} else {
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
				}
			case 3:
				if (!msg.a.$) {
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$textSuccess('Feature successfully updated!')),
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$AdminFeatures$rollbar.FZ, 'UpdateAddOn (Err err)', err, session),
							model));
				}
			default:
				var acknowledgement = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{kL: acknowledgement})));
		}
	});
var $author$project$Pages$AdminFork$OnForked = function (a) {
	return {$: 5, a: a};
};
var $author$project$Model$Branch$trackingTypeToString = function (trackingType) {
	switch (trackingType) {
		case 0:
			return 'ignore';
		case 1:
			return 'auto_update';
		default:
			return 'notify';
	}
};
var $author$project$Model$Branch$encodeTrackingType = A2($elm$core$Basics$composeR, $author$project$Model$Branch$trackingTypeToString, $elm$json$Json$Encode$string);
var $author$project$Request$VCS$forkBranch = F2(
	function (creds, _v0) {
		var from = _v0.qZ;
		var trackingType = _v0.GM;
		var to = _v0.Gz;
		return A3(
			$author$project$Request$VCS$putBranch,
			creds,
			$author$project$Model$Branch$getID(to),
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'tracks',
						A2($elm$core$Basics$composeR, $author$project$Model$Branch$getID, $danyx23$elm_uuid$Uuid$encode)(from)),
						_Utils_Tuple2(
						'tracking_type',
						$author$project$Model$Branch$encodeTrackingType(trackingType))
					])));
	});
var $author$project$Pages$AdminFork$update = F3(
	function (session, msg, model) {
		var creds = $author$project$Model$Session$getCreds(session);
		switch (msg.$) {
			case 0:
				var cmd = function () {
					var _v1 = model.El;
					if (!_v1.$) {
						return A2(
							$elm$core$Task$attempt,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Result$map(
									$elm$core$Basics$always(0)),
								$author$project$Pages$AdminFork$OnForked),
							A4(
								$author$project$Request$Project$fork,
								creds,
								model.pR,
								$author$project$Model$Project$getName(model.hU),
								{
									b4: true,
									w: $elm$core$Maybe$Just(model.kC),
									vJ: model.nD,
									cd: true
								}));
					} else {
						var trackingType = _v1.a;
						return A2(
							$elm$core$Task$attempt,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Result$map(
									$elm$core$Basics$always(0)),
								$author$project$Pages$AdminFork$OnForked),
							A2(
								$elm$core$Task$andThen,
								function (project) {
									return A2(
										$author$project$Request$VCS$forkBranch,
										creds,
										{
											qZ: $author$project$Model$Project$getDefaultBranch(model.hU),
											Gz: $author$project$Model$Project$getDefaultBranch(project),
											GM: trackingType
										});
								},
								A3(
									$author$project$Request$Project$post,
									creds,
									model.nD,
									{
										bP: $elm$core$Maybe$Nothing,
										x5: $elm$core$Maybe$Just(
											$author$project$Model$Project$getIsDistributionOnly(model.hU)),
										b4: true,
										w: model.kC,
										cd: true
									})));
					}
				}();
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, cmd, model));
			case 1:
				var value = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{nD: value})));
			case 2:
				var value = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{kC: value})));
			case 3:
				var mode = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{El: mode})));
			case 4:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$author$project$Routing$replaceUrl,
							model.Y,
							A2(
								$author$project$Model$Route$projectConfig,
								{
									ix: model.pR,
									vT: $author$project$Model$Project$getName(model.hU)
								},
								$author$project$Model$Route$projectConfigParams)),
						model));
			default:
				if (!msg.a.$) {
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							A2(
								$author$project$Routing$replaceUrl,
								model.Y,
								A2(
									$author$project$Model$Route$projectConfig,
									{ix: model.nD, vT: model.kC},
									$author$project$Model$Route$projectConfigParams)),
							model));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
				}
		}
	});
var $elm$core$Basics$pow = _Basics_pow;
var $rtfeldman$elm_hex$Hex$fromStringHelp = F3(
	function (position, chars, accumulated) {
		fromStringHelp:
		while (true) {
			if (!chars.b) {
				return $elm$core$Result$Ok(accumulated);
			} else {
				var _char = chars.a;
				var rest = chars.b;
				switch (_char) {
					case '0':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated;
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '1':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + A2($elm$core$Basics$pow, 16, position);
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '2':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (2 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '3':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (3 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '4':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (4 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '5':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (5 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '6':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (6 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '7':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (7 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '8':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (8 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '9':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (9 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'a':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (10 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'b':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (11 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'c':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (12 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'd':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (13 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'e':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (14 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'f':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (15 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					default:
						var nonHex = _char;
						return $elm$core$Result$Err(
							$elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
				}
			}
		}
	});
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $rtfeldman$elm_hex$Hex$fromString = function (str) {
	if ($elm$core$String$isEmpty(str)) {
		return $elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
	} else {
		var result = function () {
			if (A2($elm$core$String$startsWith, '-', str)) {
				var list = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm$core$List$tail(
						$elm$core$String$toList(str)));
				return A2(
					$elm$core$Result$map,
					$elm$core$Basics$negate,
					A3(
						$rtfeldman$elm_hex$Hex$fromStringHelp,
						$elm$core$List$length(list) - 1,
						list,
						0));
			} else {
				return A3(
					$rtfeldman$elm_hex$Hex$fromStringHelp,
					$elm$core$String$length(str) - 1,
					$elm$core$String$toList(str),
					0);
			}
		}();
		var formatError = function (err) {
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
		};
		return A2($elm$core$Result$mapError, formatError, result);
	}
};
var $author$project$Icon$name = function (kind) {
	switch (kind) {
		case 0:
			return 'ActivestatePropeller';
		case 1:
			return 'Aix';
		case 2:
			return 'ArrowLeft';
		case 3:
			return 'ArrowRight';
		case 4:
			return 'BranchesAlt';
		case 5:
			return 'Calendar';
		case 6:
			return 'Call';
		case 7:
			return 'Change';
		case 8:
			return 'Chat';
		case 9:
			return 'Checklist';
		case 10:
			return 'Checkmark';
		case 11:
			return 'CheckmarkCircle';
		case 12:
			return 'ChevronDown';
		case 13:
			return 'ChevronRight';
		case 14:
			return 'ChevronUp';
		case 15:
			return 'Collab';
		case 16:
			return 'Collaboration';
		case 17:
			return 'Copy';
		case 18:
			return 'Dashboard';
		case 19:
			return 'Dismiss';
		case 20:
			return 'Docker';
		case 21:
			return 'Download';
		case 22:
			return 'Edit';
		case 23:
			return 'Email';
		case 24:
			return 'EmailVerification';
		case 25:
			return 'External';
		case 26:
			return 'Filter';
		case 27:
			return 'Flag';
		case 28:
			return 'Forbidden';
		case 29:
			return 'Fork';
		case 30:
			return 'Gear';
		case 31:
			return 'Github';
		case 32:
			return 'History';
		case 33:
			return 'House';
		case 34:
			return 'HpUx';
		case 35:
			return 'InfoCircle';
		case 36:
			return 'Install';
		case 37:
			return 'Kubernetes';
		case 38:
			return 'LegalShield';
		case 39:
			return 'LegalShieldDisabled';
		case 40:
			return 'Lightning';
		case 41:
			return 'Link';
		case 42:
			return 'Linux';
		case 43:
			return 'Lock';
		case 44:
			return 'LockDotLocked';
		case 45:
			return 'LockDotUnlocked';
		case 46:
			return 'LockKey';
		case 47:
			return 'LockUnlocked';
		case 48:
			return 'Mac';
		case 49:
			return 'Members';
		case 50:
			return 'Minus';
		case 51:
			return 'Moon';
		case 52:
			return 'MoreInfo';
		case 53:
			return 'Move';
		case 54:
			return 'MultiOs';
		case 55:
			return 'Observability';
		case 56:
			return 'Organization';
		case 57:
			return 'Package';
		case 58:
			return 'PackageAdd';
		case 59:
			return 'Pencil';
		case 60:
			return 'Perl';
		case 61:
			return 'Plus';
		case 62:
			return 'Python';
		case 63:
			return 'Rbac';
		case 64:
			return 'Remediation';
		case 65:
			return 'Ruby';
		case 66:
			return 'RuntimeSharing';
		case 67:
			return 'Safe';
		case 68:
			return 'Scales';
		case 69:
			return 'Search';
		case 70:
			return 'Share';
		case 71:
			return 'ShieldLock';
		case 72:
			return 'SideBar';
		case 73:
			return 'SignOut';
		case 74:
			return 'Spaceship';
		case 75:
			return 'Spinner';
		case 76:
			return 'Sun';
		case 77:
			return 'Sunglasses';
		case 78:
			return 'Support';
		case 79:
			return 'Tcl';
		case 80:
			return 'Transfer';
		case 81:
			return 'Trash';
		case 82:
			return 'UserProfile';
		case 83:
			return 'Warning';
		case 84:
			return 'Windows';
		case 85:
			return 'Wrench';
		default:
			return 'XCircle';
	}
};
var $avh4$elm_color$Color$scaleFrom255 = function (c) {
	return c / 255;
};
var $avh4$elm_color$Color$rgb255 = F3(
	function (r, g, b) {
		return A4(
			$avh4$elm_color$Color$RgbaSpace,
			$avh4$elm_color$Color$scaleFrom255(r),
			$avh4$elm_color$Color$scaleFrom255(g),
			$avh4$elm_color$Color$scaleFrom255(b),
			1.0);
	});
var $author$project$Pages$AdminIconomicon$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var query = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{r1: query})));
			case 1:
				var size = msg.a;
				var newSize = A2(
					$elm$core$Maybe$withDefault,
					model.jr,
					$elm$core$String$toInt(size));
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{jr: newSize})));
			case 2:
				var color = msg.a;
				var rgbHexComponent = F2(
					function (x, c) {
						return A2(
							$elm$core$Result$withDefault,
							0,
							$rtfeldman$elm_hex$Hex$fromString(
								A3($elm$core$String$slice, (2 * x) + 1, (2 * x) + 3, c)));
					});
				var _v1 = _Utils_Tuple3(
					A2(rgbHexComponent, 0, color),
					A2(rgbHexComponent, 1, color),
					A2(rgbHexComponent, 2, color));
				var r = _v1.a;
				var g = _v1.b;
				var b = _v1.c;
				var newColor = A3($avh4$elm_color$Color$rgb255, r, g, b);
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{rZ: newColor})));
			default:
				var icon = msg.a;
				var name = $author$project$Icon$name(icon);
				return A2(
					$author$project$Misc$with,
					$author$project$External$AddNotification(
						$author$project$Model$Notification$textSuccess('\"' + (name + '\" copied!'))),
					A2(
						$author$project$Misc$with,
						$author$project$Ports$copyToClipboard(
							{xN: name, Gv: name}),
						model));
		}
	});
var $author$project$External$Batch = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$AdminOrganization$ConfirmOrCancel = 1;
var $author$project$Pages$AdminOrganization$History = 1;
var $author$project$Pages$AdminOrganization$Loading = 2;
var $author$project$Pages$AdminOrganization$NoOp = {$: 0};
var $author$project$Pages$AdminOrganization$OnAutoInviteUpdate = F2(
	function (a, b) {
		return {$: 26, a: a, b: b};
	});
var $author$project$Pages$AdminOrganization$OnDelete = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$AdminOrganization$OnGetHistory = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$AdminOrganization$OnTierUpdate = function (a) {
	return {$: 21, a: a};
};
var $author$project$Pages$AdminOrganization$OnUpdate = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$AdminOrganization$OnUpdateAdminMetadata = function (a) {
	return {$: 29, a: a};
};
var $author$project$Pages$AdminOrganization$OnUpdateFeatures = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$AdminOrganization$OnUrlUpdate = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$External$RenameOrg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Model$Tier$preventsOrgDeletion = $author$project$Model$Tier$requiresPayment;
var $author$project$Pages$AdminOrganization$cannotDelete = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$author$project$Model$Tier$preventsOrgDeletion,
			A2(
				$elm_community$list_extra$List$Extra$find,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Model$Tier$name,
					$elm$core$Basics$eq(model.dp.c3.dc)),
				model.Ba)));
};
var $author$project$Http$Extra$delete = function (_v0) {
	var url = _v0.GT;
	var body = _v0.sY;
	var decoder = _v0.qN;
	var auth = _v0.iO;
	var headers = _v0.CN;
	return $elm$http$Http$task(
		{
			sY: body,
			CN: _Utils_ap(
				$author$project$Http$Extra$authToHeaders(auth),
				A2(
					$elm$core$List$map,
					$elm_community$basics_extra$Basics$Extra$uncurry($elm$http$Http$header),
					headers)),
			my: 'DELETE',
			nj: $elm$http$Http$stringResolver(
				A2($author$project$Http$Extra$responseToResult, url, decoder)),
			nE: $elm$core$Maybe$Nothing,
			GT: _Utils_ap(
				$author$project$Http$Extra$authToUrlBase(auth),
				url)
		});
};
var $author$project$Request$Organization$delete = F2(
	function (orgName, creds) {
		return $author$project$Http$Extra$delete(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$emptyJsonBody,
				qN: $author$project$Model$Message$decode,
				CN: _List_Nil,
				GT: '/organizations/' + orgName
			});
	});
var $author$project$Request$Organization$edit = F3(
	function (orgName, org, creds) {
		return $author$project$Http$Extra$post(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$jsonBody(
					$author$project$Model$OrganizationEditable$encode(org)),
				qN: $author$project$Model$Organization$decode,
				CN: _List_Nil,
				GT: '/organizations/' + orgName
			});
	});
var $author$project$Model$OrganizationEditable$empty = {i$: $elm$core$Maybe$Nothing, AC: $elm$core$Maybe$Nothing};
var $author$project$Model$Mutation$Mutation = function (organizationID) {
	return function (added) {
		return function (userName) {
			return function (tierName) {
				return function (subscriptionStatus) {
					return function (activeRuntimesDelta) {
						return function (activeRuntimesOverrideDelta) {
							return function (staticRuntimesDelta) {
								return function (staticRuntimesOverrideDelta) {
									return function (usersDelta) {
										return function (nodesDelta) {
											return function (billingDateDelta) {
												return function (addOnsDelta) {
													return function (notes) {
														return function (resellerID) {
															return function (invoiceID) {
																return function (poNumber) {
																	return function (trialEndsDelta) {
																		return {A$: activeRuntimesDelta, A1: activeRuntimesOverrideDelta, A3: addOnsDelta, ak: added, Bh: billingDateDelta, C2: invoiceID, EA: nodesDelta, EE: notes, zw: organizationID, Fi: poNumber, FG: resellerID, Gd: staticRuntimesDelta, Gf: staticRuntimesOverrideDelta, Gk: subscriptionStatus, Aq: tierName, GO: trialEndsDelta, GX: userName, GY: usersDelta};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Model$Mutation$decode = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'trialEndsDelta',
	$elm$json$Json$Decode$int,
	0,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'poNumber',
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'invoiceID',
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'resellerID',
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'notes',
					$elm$json$Json$Decode$string,
					'',
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'addOnsDelta',
						$elm$json$Json$Decode$list($author$project$Model$AddOns$decodeAddOn),
						_List_Nil,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'billingDateDelta',
							$elm$json$Json$Decode$int,
							0,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'nodesDelta',
								$elm$json$Json$Decode$int,
								0,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'usersDelta',
									$elm$json$Json$Decode$int,
									0,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'staticRuntimesOverrideDelta',
										$elm$json$Json$Decode$int,
										0,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'staticRuntimesDelta',
											$elm$json$Json$Decode$int,
											0,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'activeRuntimesOverrideDelta',
												$elm$json$Json$Decode$int,
												0,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'activeRuntimesDelta',
													$elm$json$Json$Decode$int,
													0,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'subscriptionStatus',
														$elm$json$Json$Decode$string,
														'',
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'tierName',
															$elm$json$Json$Decode$string,
															'',
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'userName',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'added',
																	$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'organizationID',
																		$elm$json$Json$Decode$string,
																		$elm$json$Json$Decode$succeed($author$project$Model$Mutation$Mutation)))))))))))))))))));
var $author$project$Request$Organization$mutations = F2(
	function (orgName, creds) {
		return $author$project$Http$Extra$get(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$emptyBody,
				qN: $elm$json$Json$Decode$list($author$project$Model$Mutation$decode),
				CN: _List_Nil,
				GT: '/organizations/' + (orgName + '/mutations')
			});
	});
var $author$project$Pages$AdminOrganization$modelAddOns = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.dp;
	},
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.c3;
		},
		function ($) {
			return $.sP;
		}));
var $author$project$Pages$AdminOrganization$overriddenAddOns = A2(
	$elm$core$Basics$composeR,
	$author$project$Pages$AdminOrganization$modelAddOns,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Dict$values,
		$elm$core$List$filter(
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.yQ;
				},
				$elm$core$Basics$not))));
var $author$project$Json$Encode$Extra$maybe = function (encoder) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(encoder),
		$elm$core$Maybe$withDefault($elm$json$Json$Encode$null));
};
var $author$project$Model$AdminMetadataEditable$encode = function (editable) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'belongsToActivator',
				A2($author$project$Json$Encode$Extra$maybe, $elm$json$Json$Encode$bool, editable.Bg))
			]));
};
var $author$project$Request$AdminMetadata$putById = F3(
	function (id, editable, creds) {
		return $author$project$Http$Extra$put(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$jsonBody(
					$author$project$Model$AdminMetadataEditable$encode(editable)),
				qN: $author$project$Model$AdminMetadata$decode,
				CN: _List_Nil,
				GT: '/admin/metadata/' + ($danyx23$elm_uuid$Uuid$toString(id) + '?identifierType=organizationID')
			});
	});
var $author$project$Request$Organization$removeAutoInviteDomain = F3(
	function (orgName, domainName, creds) {
		return $author$project$Http$Extra$delete(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$emptyJsonBody,
				qN: $author$project$Model$Organization$decodeAutoInviteDomains,
				CN: _List_Nil,
				GT: '/organizations/' + (orgName + ('/autoinvite/' + domainName))
			});
	});
var $author$project$Pages$AdminOrganization$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Pages$AdminOrganization$NoOp, 'Pages/AdminOrganization.elm');
var $author$project$Model$AddOnsEditable$empty = _List_Nil;
var $author$project$Model$OrganizationMutationEditable$empty = {A3: $author$project$Model$AddOnsEditable$empty, Bh: 0, uI: '', EA: 0, EE: '', FH: $elm$core$Maybe$Nothing, Aq: '', GY: 0};
var $author$project$Model$AddOnEditable$encode = function (_v0) {
	var enabled = _v0.Cp;
	var name = _v0.w;
	var enabledState = function () {
		if (!enabled.$) {
			var state = enabled.a;
			return $elm$json$Json$Encode$bool(state);
		} else {
			return $elm$json$Json$Encode$null;
		}
	}();
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2('enabled', enabledState),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(name))
			]));
};
var $author$project$Model$AddOnsEditable$encode = $elm$json$Json$Encode$list($author$project$Model$AddOnEditable$encode);
var $author$project$Model$OrganizationMutationEditable$encode = function (_v0) {
	var mutationID = _v0.uI;
	var tierName = _v0.Aq;
	var billingDateDelta = _v0.Bh;
	var usersDelta = _v0.GY;
	var nodesDelta = _v0.EA;
	var notes = _v0.EE;
	var resellerManaged = _v0.FH;
	var addOnsDelta = _v0.A3;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'mutationID',
				$elm$json$Json$Encode$string(mutationID)),
				_Utils_Tuple2(
				'tierName',
				$elm$json$Json$Encode$string(tierName)),
				_Utils_Tuple2(
				'billingDateDelta',
				$elm$json$Json$Encode$int(billingDateDelta)),
				_Utils_Tuple2(
				'usersDelta',
				$elm$json$Json$Encode$int(usersDelta)),
				_Utils_Tuple2(
				'nodesDelta',
				$elm$json$Json$Encode$int(nodesDelta)),
				_Utils_Tuple2(
				'notes',
				$elm$json$Json$Encode$string(notes)),
				_Utils_Tuple2(
				'resellerManaged',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$bool, resellerManaged))),
				_Utils_Tuple2(
				'addOnsDelta',
				$author$project$Model$AddOnsEditable$encode(addOnsDelta))
			]));
};
var $author$project$Request$Organization$mutate = F3(
	function (orgName, mutation, creds) {
		return $author$project$Http$Extra$post(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$jsonBody(
					$author$project$Model$OrganizationMutationEditable$encode(mutation)),
				qN: $author$project$Model$Organization$decode,
				CN: _List_Nil,
				GT: '/organizations/' + (orgName + '/mutations')
			});
	});
var $author$project$Request$Organization$setAddOn = F3(
	function (orgName, addOnsSet, creds) {
		var emptyMutation = $author$project$Model$OrganizationMutationEditable$empty;
		var addOns = A2(
			$elm$core$List$map,
			function (_v0) {
				var name = _v0.a;
				var enabled = _v0.b;
				return {Cp: enabled, w: name};
			},
			addOnsSet);
		var mutation = _Utils_update(
			emptyMutation,
			{A3: addOns, EE: 'Add-ons updated from Organization Admin Page'});
		return A3($author$project$Request$Organization$mutate, orgName, mutation, creds);
	});
var $author$project$Request$Organization$setTier = F3(
	function (orgName, tierName, creds) {
		var emptyMutation = $author$project$Model$OrganizationMutationEditable$empty;
		var mutation = _Utils_update(
			emptyMutation,
			{EE: 'Tier updated from Organization Admin Page', Aq: tierName});
		return A3($author$project$Request$Organization$mutate, orgName, mutation, creds);
	});
var $author$project$Model$Organization$encodeAutoInviteInfo = function (_v0) {
	var domain = _v0.tF;
	var role = _v0.FO;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'domain',
				$elm$json$Json$Encode$string(domain)),
				_Utils_Tuple2(
				'role',
				$elm$json$Json$Encode$string(
					$author$project$Model$Role$toInternalString(role)))
			]));
};
var $author$project$Request$Organization$updateAutoInviteDomain = F3(
	function (orgName, autoInviteDetails, creds) {
		return $author$project$Http$Extra$post(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$jsonBody(
					$author$project$Model$Organization$encodeAutoInviteInfo(autoInviteDetails)),
				qN: $author$project$Model$Organization$decodeAutoInviteDomains,
				CN: _List_Nil,
				GT: '/organizations/' + (orgName + '/autoinvite')
			});
	});
var $author$project$Pages$AdminOrganization$update = F3(
	function (session, msg, model) {
		var urlName = model.dp.c3.AC;
		var scrollToTop = $author$project$Misc$scrollToTop($author$project$Pages$AdminOrganization$NoOp);
		var currentOrgData = model.dp;
		var creds = $author$project$Model$Session$getCreds(session);
		switch (msg.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
			case 1:
				var mode = msg.a;
				var getHistory = A2(
					$elm$core$Task$attempt,
					$author$project$Pages$AdminOrganization$OnGetHistory,
					A2($author$project$Request$Organization$mutations, urlName, creds));
				var _v1 = _Utils_Tuple2(mode, model.El);
				if ((_v1.a === 1) && (!_v1.b)) {
					var _v2 = _v1.a;
					var _v3 = _v1.b;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2($author$project$Misc$with, getHistory, model));
				} else {
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{El: mode})));
				}
			case 2:
				if (!msg.a.$) {
					var history = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{q9: history, El: 1})));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A3($author$project$Pages$AdminOrganization$rollbar.FZ, 'OnGetHistory (Err err)', err, session),
										scrollToTop
									])),
							model));
				}
			case 3:
				var name = msg.a;
				var enabled = msg.b;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$AdminOrganization$OnUpdateFeatures,
							A3(
								$author$project$Request$Organization$setAddOn,
								urlName,
								_List_fromArray(
									[
										_Utils_Tuple2(
										name,
										$elm$core$Maybe$Just(enabled))
									]),
								creds)),
						model));
			case 4:
				var withAddOn = msg.a;
				var addOns = function () {
					if (withAddOn.$ === 1) {
						return A2(
							$elm$core$List$map,
							function (a) {
								return _Utils_Tuple2(a.w, $elm$core$Maybe$Nothing);
							},
							$author$project$Pages$AdminOrganization$overriddenAddOns(model));
					} else {
						var addOn = withAddOn.a;
						return _List_fromArray(
							[
								_Utils_Tuple2(addOn.w, $elm$core$Maybe$Nothing)
							]);
					}
				}();
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$AdminOrganization$OnUpdateFeatures,
							A3($author$project$Request$Organization$setAddOn, urlName, addOns, creds)),
						model));
			case 5:
				var name = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{o5: name})));
			case 6:
				var empty = $author$project$Model$OrganizationEditable$empty;
				var data = _Utils_update(
					empty,
					{
						i$: $elm$core$Maybe$Just(model.o5)
					});
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$AdminOrganization$OnUpdate,
							A3($author$project$Request$Organization$edit, urlName, data, creds)),
						model));
			case 8:
				if (!msg.a.$) {
					var organization = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$textSuccess('Saved succesfully')),
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{
									dp: _Utils_update(
										currentOrgData,
										{c3: organization})
								})));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A3($author$project$Pages$AdminOrganization$rollbar.FZ, 'OnUpdateFeatures (Err err)', err, session),
										scrollToTop
									])),
							model));
				}
			case 7:
				if (!msg.a.$) {
					var organization = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$textSuccess('Saved succesfully')),
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{
									dp: _Utils_update(
										currentOrgData,
										{c3: organization})
								})));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A3($author$project$Pages$AdminOrganization$rollbar.FZ, 'OnUpdate (Err err)', err, session),
										scrollToTop
									])),
							model));
				}
			case 9:
				var name = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{Er: name})));
			case 10:
				var task = function () {
					var empty = $author$project$Model$OrganizationEditable$empty;
					var data = _Utils_update(
						empty,
						{
							AC: $elm$core$Maybe$Just(model.Er)
						});
					return A2(
						$elm$core$Task$map,
						$elm$core$Basics$always(0),
						A3($author$project$Request$Organization$edit, urlName, data, creds));
				}();
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$AdminOrganization$OnUrlUpdate(
								{Er: model.Er, EG: urlName}),
							task),
						model));
			case 11:
				if (!msg.b.$) {
					var oldUrlName = msg.a.EG;
					var newUrlName = msg.a.Er;
					var org = model.dp.c3;
					var newOrg = _Utils_update(
						org,
						{AC: newUrlName});
					return A2(
						$author$project$Misc$with,
						$author$project$External$Batch(
							_List_fromArray(
								[
									$author$project$External$RenameOrg(
									{Er: newUrlName, EG: oldUrlName}),
									$author$project$External$AddNotification(
									$author$project$Model$Notification$textSuccess('Renamed successfully'))
								])),
						A2(
							$author$project$Misc$with,
							A2(
								$author$project$Routing$replaceUrl,
								model.Y,
								$author$project$Model$Route$adminOrganization(newUrlName)),
							_Utils_update(
								model,
								{
									dp: _Utils_update(
										currentOrgData,
										{c3: newOrg})
								})));
				} else {
					var err = msg.b.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A3($author$project$Pages$AdminOrganization$rollbar.FZ, 'OnUrlUpdate _ (Err err)', err, session),
										scrollToTop
									])),
							model));
				}
			case 12:
				var showConfirmationModalModel = $author$project$Pages$AdminOrganization$cannotDelete(model) ? model : _Utils_update(
					model,
					{jP: 1});
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, showConfirmationModalModel));
			case 13:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{jP: 0})));
			case 14:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$AdminOrganization$OnDelete,
							A2($author$project$Request$Organization$delete, urlName, creds)),
						_Utils_update(
							model,
							{jP: 2})));
			case 15:
				if (!msg.a.$) {
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$textSuccess('\"' + (urlName + '\" was successfully deleted.'))),
						A2(
							$author$project$Misc$with,
							A2(
								$author$project$Routing$replaceUrl,
								model.Y,
								$author$project$Model$Route$Protected(
									$author$project$Model$Route$Admin($author$project$Model$Route$AdminOrganizations))),
							model));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$AdminOrganization$rollbar.FZ, 'OnDelete (Err err)', err, session),
							_Utils_update(
								model,
								{jP: 0})));
				}
			case 16:
				var input = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$author$project$Ports$copyToClipboard(input),
						_Utils_update(
							model,
							{oi: $author$project$Model$CopyStatus$empty})));
			case 17:
				var portCopyStatus = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{oi: portCopyStatus})));
			case 18:
				var category = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{ol: category})));
			case 19:
				var newTier = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{kv: newTier})));
			case 20:
				return _Utils_eq(model.kv, model.dp.c3.dc) ? A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model)) : A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$AdminOrganization$OnTierUpdate,
							A3($author$project$Request$Organization$setTier, urlName, model.kv, creds)),
						model));
			case 21:
				if (!msg.a.$) {
					var organization = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$textSuccess('Tier updated successfully')),
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{
									dp: _Utils_update(
										currentOrgData,
										{c3: organization})
								})));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A3($author$project$Pages$AdminOrganization$rollbar.FZ, 'OnTierUpdate (Err err)', err, session),
										scrollToTop
									])),
							model));
				}
			case 22:
				var domain = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{h0: domain})));
			case 23:
				var action = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{h$: action})));
			case 24:
				var role = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{n3: role})));
			case 25:
				var domain = A2($elm$core$String$contains, '@', model.h0) ? model.h0 : ('@' + model.h0);
				var request = function () {
					var _v5 = model.h$;
					if (!_v5) {
						var autoInviteInfo = {tF: domain, FO: model.n3};
						return A3($author$project$Request$Organization$updateAutoInviteDomain, urlName, autoInviteInfo, creds);
					} else {
						return A3($author$project$Request$Organization$removeAutoInviteDomain, urlName, domain, creds);
					}
				}();
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$AdminOrganization$OnAutoInviteUpdate(model.h$),
							request),
						model));
			case 26:
				if (!msg.b.$) {
					var action = msg.a;
					var successNotificationText = function () {
						if (!action) {
							return 'The automatic invite was successfully added/updated.';
						} else {
							return 'The automatic invite was successfully removed.';
						}
					}();
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$textSuccess(successNotificationText)),
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
				} else {
					var err = msg.b.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
				}
			case 27:
				var adminMetadata = model.iN;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								iN: _Utils_update(
									adminMetadata,
									{Bg: !model.iN.Bg})
							})));
			case 28:
				var editable = {
					Bg: $elm$core$Maybe$Just(model.iN.Bg)
				};
				var request = A3($author$project$Request$AdminMetadata$putById, model.dp.c3.zw, editable, creds);
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2($elm$core$Task$attempt, $author$project$Pages$AdminOrganization$OnUpdateAdminMetadata, request),
						model));
			default:
				if (!msg.a.$) {
					var newAdminMetadata = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$textSuccess('Admin Metadata updated successfully')),
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{iN: newAdminMetadata})));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
				}
		}
	});
var $author$project$Pages$AdminOrganizations$NoOp = {$: 0};
var $author$project$Pages$AdminOrganizations$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Pages$AdminOrganizations$NoOp, 'Pages/AdminOrganizations.elm');
var $author$project$Pages$AdminOrganizations$OnSearchResult = function (a) {
	return {$: 4, a: a};
};
var $krisajenkins$remotedata$RemoteData$Failure = function (a) {
	return {$: 2, a: a};
};
var $krisajenkins$remotedata$RemoteData$fromResult = function (result) {
	if (result.$ === 1) {
		var e = result.a;
		return $krisajenkins$remotedata$RemoteData$Failure(e);
	} else {
		var x = result.a;
		return $krisajenkins$remotedata$RemoteData$Success(x);
	}
};
var $author$project$Request$Organization$getByID = F2(
	function (orgID, creds) {
		return A3($author$project$Request$Organization$getOrg, orgID, 'organizationID', creds);
	});
var $author$project$Pages$AdminOrganizations$nameSearchMinLength = 3;
var $author$project$Pages$AdminOrganizations$getSearchStringError = function (_v0) {
	var mode = _v0.El;
	var searchString = _v0.iE;
	var _v1 = _Utils_Tuple3(
		mode,
		_Utils_cmp(
			$elm$core$String$length(searchString),
			$author$project$Pages$AdminOrganizations$nameSearchMinLength) < 0,
		$danyx23$elm_uuid$Uuid$fromString(searchString));
	_v1$2:
	while (true) {
		if (_v1.a === 1) {
			if (_v1.b) {
				var _v2 = _v1.a;
				return $elm$core$Maybe$Just(
					'Enter at least ' + ($elm$core$String$fromInt($author$project$Pages$AdminOrganizations$nameSearchMinLength) + ' characters to search'));
			} else {
				break _v1$2;
			}
		} else {
			if (_v1.c.$ === 1) {
				var _v3 = _v1.a;
				var _v4 = _v1.c;
				return $elm$core$Maybe$Just('Enter a valid UUID');
			} else {
				break _v1$2;
			}
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Builder$Enum$Order_by$Asc = 0;
var $author$project$Builder$InputObject$buildOrganizations_order_by = function (fillOptionals____) {
	var optionals____ = fillOptionals____(
		{fV: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ak: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, g: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, z: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, bt: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, E: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, gy: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, dc: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aP: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ct: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
	return {fV: optionals____.fV, ak: optionals____.ak, g: optionals____.g, z: optionals____.z, bt: optionals____.bt, E: optionals____.E, gy: optionals____.gy, dc: optionals____.dc, aP: optionals____.aP, ct: optionals____.ct};
};
var $author$project$Builder$InputObject$Tiers_bool_exp = $elm$core$Basics$identity;
var $author$project$Builder$InputObject$buildTiers_bool_exp = function (fillOptionals____) {
	var optionals____ = fillOptionals____(
		{y: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, w: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, B: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, D: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aP: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
	return {y: optionals____.y, w: optionals____.w, B: optionals____.B, D: optionals____.D, aP: optionals____.aP};
};
var $author$project$Request$AdminOrganizations$OrgPartial = F4(
	function (organizationID, urlName, displayName, tier) {
		return {i$: displayName, zw: organizationID, dc: tier, AC: urlName};
	});
var $author$project$Request$AdminOrganizations$decodeOrgPartial = function () {
	var finish = F4(
		function (orgID, urlName, displayName, tierName) {
			return A4(
				$author$project$Request$AdminOrganizations$OrgPartial,
				$danyx23$elm_uuid$Uuid$toString(orgID),
				urlName,
				A2($elm$core$Maybe$withDefault, urlName, displayName),
				tierName);
		});
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Builder$Object$Organizations$tier($author$project$Builder$Object$Tiers$name),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Builder$Object$Organizations$display_name,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Builder$Object$Organizations$url_name,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Builder$Object$Organizations$organization_id,
					$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(finish)))));
}();
var $author$project$Builder$Enum$Organizations_select_column$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'added';
		case 1:
			return 'changed';
		case 2:
			return 'deleted';
		case 3:
			return 'display_name';
		case 4:
			return 'organization_id';
		case 5:
			return 'tier_id';
		default:
			return 'url_name';
	}
};
var $author$project$Builder$Query$organizations = F2(
	function (fillInOptionals____, object____) {
		var filledInOptionals____ = fillInOptionals____(
			{tE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ux: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, uR: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, vE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ao: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs____ = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'distinct_on',
					filledInOptionals____.tE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Organizations_select_column$toString))),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'limit', filledInOptionals____.ux, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'offset', filledInOptionals____.uR, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'order_by',
					filledInOptionals____.vE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Builder$InputObject$encodeOrganizations_order_by)),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'where', filledInOptionals____.ao, $author$project$Builder$InputObject$encodeOrganizations_bool_exp)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'organizations',
			optionalArgs____,
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
	});
var $author$project$Request$AdminOrganizations$queryMaxSize = 500;
var $author$project$Request$AdminOrganizations$query = F2(
	function (urlNameInfixStr, _v0) {
		var exact = _v0.lQ;
		var showFreeOrgs = _v0.wb;
		var urlNamePred = function () {
			var urlNameInfixStrEscaped = A3(
				$elm$core$String$replace,
				'_',
				'\\_',
				A3($elm$core$String$replace, '%', '\\%', urlNameInfixStr));
			var urlNamePattern = exact ? urlNameInfixStrEscaped : ('%' + (urlNameInfixStrEscaped + '%'));
			return $author$project$Builder$InputObject$buildString_comparison_exp(
				function (args) {
					return _Utils_update(
						args,
						{
							l7: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(urlNamePattern)
						});
				});
		}();
		var tierPred = $author$project$Builder$InputObject$buildTiers_bool_exp(
			function (args) {
				return _Utils_update(
					args,
					{
						w: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
							$author$project$Builder$InputObject$buildString_comparison_exp(
								function (nameArgs) {
									return _Utils_update(
										nameArgs,
										{
											a4: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present('free')
										});
								}))
					});
			});
		var whereClause = $author$project$Builder$InputObject$buildOrganizations_bool_exp(
			function (topArgs) {
				return _Utils_update(
					topArgs,
					{
						y: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
							_List_fromArray(
								[
									$author$project$Builder$InputObject$buildOrganizations_bool_exp(
									function (args) {
										return _Utils_update(
											args,
											{
												ct: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(urlNamePred)
											});
									}),
									$author$project$Builder$InputObject$buildOrganizations_bool_exp(
									function (args) {
										return _Utils_update(
											args,
											{
												dc: showFreeOrgs ? $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent : $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(tierPred)
											});
									})
								]))
					});
			});
		var orderByClause = _List_fromArray(
			[
				$author$project$Builder$InputObject$buildOrganizations_order_by(
				function (args) {
					return _Utils_update(
						args,
						{
							ct: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(0)
						});
				})
			]);
		return A2(
			$author$project$Builder$Query$organizations,
			function (orgsArgs) {
				return _Utils_update(
					orgsArgs,
					{
						ux: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Request$AdminOrganizations$queryMaxSize + 1),
						vE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(orderByClause),
						ao: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(whereClause)
					});
			},
			$author$project$Request$AdminOrganizations$decodeOrgPartial);
	});
var $author$project$Model$Organization$idString = function (org) {
	return $danyx23$elm_uuid$Uuid$toString(org.zw);
};
var $author$project$Pages$AdminOrganizations$toOrgRow = function (org) {
	return {
		i$: org.i$,
		zw: $author$project$Model$Organization$idString(org),
		dc: org.dc,
		AC: org.AC
	};
};
var $author$project$Pages$AdminOrganizations$searchOrg = F2(
	function (session, model) {
		var _v0 = $author$project$Pages$AdminOrganizations$getSearchStringError(model);
		if (!_v0.$) {
			return A2(
				$author$project$Misc$with,
				$author$project$External$NoOp,
				A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
		} else {
			var task = function () {
				var _v1 = model.El;
				if (_v1 === 1) {
					return A5(
						$author$project$GraphQL$Utils$queryRequest,
						$author$project$Model$Session$getCreds(session),
						0,
						_List_Nil,
						'AdminOrgSearch',
						A2($author$project$Request$AdminOrganizations$query, model.iE, model.mT));
				} else {
					return A2(
						$elm$core$Task$onError,
						function (err) {
							var _v2 = err.mp;
							if (_v2.$ === 3) {
								var resp = _v2.a;
								var _v3 = resp.wp;
								if (_v3 === 404) {
									return $elm$core$Task$succeed(_List_Nil);
								} else {
									return $elm$core$Task$fail(err);
								}
							} else {
								return $elm$core$Task$fail(err);
							}
						},
						A2(
							$elm$core$Task$map,
							$elm$core$List$singleton,
							A2(
								$elm$core$Task$map,
								$author$project$Pages$AdminOrganizations$toOrgRow,
								A2(
									$author$project$Request$Organization$getByID,
									model.iE,
									$author$project$Model$Session$getCreds(session)))));
				}
			}();
			return A2(
				$author$project$Misc$with,
				$author$project$External$NoOp,
				A2(
					$author$project$Misc$with,
					A2(
						$elm$core$Task$attempt,
						A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Pages$AdminOrganizations$OnSearchResult),
						task),
					_Utils_update(
						model,
						{mX: $krisajenkins$remotedata$RemoteData$Loading})));
		}
	});
var $author$project$Pages$AdminOrganizations$update = F3(
	function (session, msg, model) {
		var cleanShinyModel = _Utils_update(
			model,
			{oi: $author$project$Model$CopyStatus$empty, mX: $krisajenkins$remotedata$RemoteData$NotAsked, iE: ''});
		switch (msg.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
			case 1:
				var mode = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							cleanShinyModel,
							{El: mode})));
			case 2:
				var searchString = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								iE: $elm$core$String$trim(searchString)
							})));
			case 3:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, cleanShinyModel));
			case 4:
				var organizations = msg.a;
				var newModel = _Utils_update(
					model,
					{mX: organizations});
				if (organizations.$ === 2) {
					var err = organizations.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$AdminOrganizations$rollbar.FZ, 'OnSearchResult organizations', err, session),
							newModel));
				} else {
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, newModel));
				}
			case 5:
				var input = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$author$project$Ports$copyToClipboard(input),
						_Utils_update(
							model,
							{oi: $author$project$Model$CopyStatus$empty})));
			case 6:
				var portCopyStatus = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{oi: portCopyStatus})));
			default:
				var f = msg.a;
				return A2(
					$author$project$Pages$AdminOrganizations$searchOrg,
					session,
					_Utils_update(
						model,
						{
							mT: f(model.mT)
						}));
		}
	});
var $author$project$Pages$AdminUser$ConfirmOrCancel = 1;
var $author$project$Pages$AdminUser$Loading = 2;
var $author$project$Pages$AdminUser$NoOp = {$: 0};
var $author$project$Pages$AdminUser$OnDelete = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$AdminUser$OnUsernameUpdate = function (a) {
	return {$: 3, a: a};
};
var $author$project$External$RenameUser = function (a) {
	return {$: 9, a: a};
};
var $author$project$Model$Route$adminUser = function (username) {
	return $author$project$Model$Route$Protected(
		$author$project$Model$Route$Admin(
			$author$project$Model$Route$AdminUser(username)));
};
var $author$project$Model$Route$adminUsers = function (orgName) {
	return $author$project$Model$Route$Protected(
		$author$project$Model$Route$Admin(
			$author$project$Model$Route$AdminUsers(orgName)));
};
var $author$project$Request$User$delete = F2(
	function (username, creds) {
		return $author$project$Http$Extra$delete(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$emptyJsonBody,
				qN: $author$project$Model$Message$decode,
				CN: _List_Nil,
				GT: '/users/' + username
			});
	});
var $author$project$Request$User$postChangeUsername = F3(
	function (currentUsername, newUsername, creds) {
		return $author$project$Http$Extra$post(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'username',
								$elm$json$Json$Encode$string(newUsername))
							]))),
				qN: $elm$json$Json$Decode$succeed(0),
				CN: _List_Nil,
				GT: '/users/' + currentUsername
			});
	});
var $author$project$Pages$AdminUser$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Pages$AdminUser$NoOp, 'Pages/AdminUser.elm');
var $author$project$Pages$AdminUser$update = F3(
	function (session, msg, model) {
		var user = model.gS;
		var scrollToTop = $author$project$Misc$scrollToTop($author$project$Pages$AdminUser$NoOp);
		var creds = $author$project$Model$Session$getCreds(session);
		switch (msg.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
			case 1:
				var name = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{kc: name})));
			case 2:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$AdminUser$OnUsernameUpdate,
							A2(
								$elm$core$Task$map,
								$elm$core$Basics$always(0),
								A3($author$project$Request$User$postChangeUsername, user.AE, model.kc, creds))),
						model));
			case 3:
				if (!msg.a.$) {
					var externalMsg = _Utils_eq(
						$author$project$Model$Session$getUsername(session),
						user.AE) ? $author$project$External$RenameUser(model.kc) : $author$project$External$NoOp;
					var cmd = A2(
						$author$project$Routing$replaceUrl,
						model.Y,
						$author$project$Model$Route$adminUser(model.kc));
					return A2(
						$author$project$Misc$with,
						externalMsg,
						A2($author$project$Misc$with, cmd, model));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A3($author$project$Pages$AdminUser$rollbar.FZ, 'OnUsernameUpdate (Err err)', err, session),
										scrollToTop
									])),
							model));
				}
			case 4:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{jP: 1})));
			case 5:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{jP: 0})));
			case 6:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$AdminUser$OnDelete,
							A2($author$project$Request$User$delete, user.AE, creds)),
						_Utils_update(
							model,
							{jP: 2})));
			case 7:
				if (!msg.a.$) {
					var notificationMessage = '\"' + (user.AE + '\" was successfully deleted.');
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$textSuccess(notificationMessage)),
						A2(
							$author$project$Misc$with,
							A2(
								$author$project$Routing$replaceUrl,
								model.Y,
								$author$project$Model$Route$adminUsers($elm$core$Maybe$Nothing)),
							model));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$AdminUser$rollbar.FZ, 'OnDelete (Err err)', err, session),
							_Utils_update(
								model,
								{jP: 0})));
				}
			case 8:
				var input = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$author$project$Ports$copyToClipboard(input),
						_Utils_update(
							model,
							{oi: $author$project$Model$CopyStatus$empty})));
			case 9:
				var portCopyStatus = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{oi: portCopyStatus})));
			default:
				var role = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								rK: $elm$core$Maybe$Just(role)
							})));
		}
	});
var $author$project$Pages$AdminUsers$OnLoginAsUser = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$AdminUsers$OnOrgNameSearch = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$AdminUsers$OnUserEmailSearch = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$AdminUsers$OnUsernameSearch = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$AdminUsers$OnVerifyEmailLink = function (a) {
	return {$: 18, a: a};
};
var $author$project$External$SetJWT = function (a) {
	return {$: 2, a: a};
};
var $author$project$Request$Email$getVerificationLink = F2(
	function (email, creds) {
		return $author$project$Http$Extra$get(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$emptyBody,
				qN: $elm$json$Json$Decode$string,
				CN: _List_Nil,
				GT: '/users/verification/' + email
			});
	});
var $author$project$Request$User$loginAs = F2(
	function (username, creds) {
		return $author$project$Http$Extra$post(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$emptyJsonBody,
				qN: $author$project$Model$JWT$decode,
				CN: _List_Nil,
				GT: '/login/' + username
			});
	});
var $author$project$Pages$AdminUsers$NoOp = {$: 0};
var $author$project$Pages$AdminUsers$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Pages$AdminUsers$NoOp, 'Pages/AdminUsers.elm');
var $author$project$Request$User$doSearch = F3(
	function (endpoint, searchQuery, creds) {
		return $author$project$Http$Extra$post(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'query',
								$elm$json$Json$Encode$string(searchQuery))
							]))),
				qN: $elm$json$Json$Decode$list($author$project$Model$User$decode),
				CN: _List_Nil,
				GT: endpoint
			});
	});
var $author$project$Request$User$searchEmails = F2(
	function (searchQuery, creds) {
		return A3($author$project$Request$User$doSearch, '/users/search_emails', searchQuery, creds);
	});
var $author$project$Request$User$searchUsernames = F2(
	function (searchQuery, creds) {
		return A3($author$project$Request$User$doSearch, '/users/search_usernames', searchQuery, creds);
	});
var $author$project$Pages$AdminUsers$update = F3(
	function (session, msg, model) {
		var creds = $author$project$Model$Session$getCreds(session);
		switch (msg.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
			case 1:
				return (!$elm$core$String$isEmpty(model.kG)) ? A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$AdminUsers$OnUsernameSearch,
							A2($author$project$Request$User$searchUsernames, model.kG, creds)),
						_Utils_update(
							model,
							{nK: false}))) : A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
			case 2:
				var query = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{kG: query})));
			case 3:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{kG: '', nK: false, p4: _List_Nil})));
			case 4:
				if (!msg.a.$) {
					var users = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{
									nK: true,
									p4: $author$project$Pages$AdminUsers$sortUsers(users)
								})));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$AdminUsers$rollbar.FZ, 'OnUsernameSearch (Err err)', err, session),
							model));
				}
			case 5:
				return (!$elm$core$String$isEmpty(model.jC)) ? A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$AdminUsers$OnUserEmailSearch,
							A2($author$project$Request$User$searchEmails, model.jC, creds)),
						_Utils_update(
							model,
							{nJ: false}))) : A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{lM: _List_Nil})));
			case 6:
				var query = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{jC: query})));
			case 7:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{lM: _List_Nil, jC: '', nJ: false})));
			case 8:
				if (!msg.a.$) {
					var users = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{
									lM: $author$project$Pages$AdminUsers$sortUsers(users),
									nJ: true
								})));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$AdminUsers$rollbar.FZ, 'OnUserEmailSearch (Err err)', err, session),
							model));
				}
			case 9:
				return (!$elm$core$String$isEmpty(model.kl)) ? A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$AdminUsers$OnOrgNameSearch,
							A2($author$project$Request$Organization$members, model.kl, creds)),
						_Utils_update(
							model,
							{mV: false}))) : A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{mW: _List_Nil})));
			case 10:
				var query = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{kl: query})));
			case 11:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{kl: '', mV: false, mW: _List_Nil})));
			case 12:
				if (!msg.a.$) {
					var members = msg.a.a;
					var orgUsers = A2(
						$elm$core$List$map,
						function ($) {
							return $.gS;
						},
						members);
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{
									mV: true,
									mW: $author$project$Pages$AdminUsers$sortUsers(orgUsers)
								})));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$AdminUsers$rollbar.FZ, 'OnOrgNameSearch (Err err)', err, session),
							model));
				}
			case 13:
				var user = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$AdminUsers$OnLoginAsUser,
							A2($author$project$Request$User$loginAs, user.AE, creds)),
						model));
			case 14:
				if (!msg.a.$) {
					var jwt = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$SetJWT(jwt),
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2(
										$author$project$Routing$replaceUrl,
										model.Y,
										$author$project$Model$Route$Protected(
											$author$project$Model$Route$Home(
												{wd: $elm$core$Maybe$Nothing}))),
										$author$project$Ports$setIsImpersonating(true),
										$author$project$Ports$stopRecordingUser(0)
									])),
							model));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$AdminUsers$rollbar.FZ, 'OnLoginAsUser (Err err)', err, session),
							model));
				}
			case 19:
				var mode = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{oi: $author$project$Model$CopyStatus$empty, El: mode})));
			case 15:
				var email = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{nN: email})));
			case 16:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$AdminUsers$OnVerifyEmailLink,
							A2($author$project$Request$Email$getVerificationLink, model.nN, creds)),
						model));
			case 17:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{nM: '', nN: ''})));
			case 18:
				if (!msg.a.$) {
					var link = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{nM: link})));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
				}
			case 20:
				var input = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$author$project$Ports$copyToClipboard(input),
						_Utils_update(
							model,
							{oi: $author$project$Model$CopyStatus$empty})));
			default:
				var portCopyStatus = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{oi: portCopyStatus})));
		}
	});
var $author$project$Pages$AuthorizeDevice$AuthorizationCompleted = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$AuthorizeDevice$AuthorizeDeviceComplete = {$: 1};
var $author$project$Pages$AuthorizeDevice$AuthorizeDeviceFailure = function (a) {
	return {$: 2, a: a};
};
var $elm$http$Http$expectBytesResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'arraybuffer',
			_Http_toDataView,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.wp));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectWhatever = function (toMsg) {
	return A2(
		$elm$http$Http$expectBytesResponse,
		toMsg,
		$elm$http$Http$resolve(
			function (_v0) {
				return $elm$core$Result$Ok(0);
			}));
};
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {zQ: reqs, Aj: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.GL;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.zQ));
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.Aj)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					A5: r.A5,
					sY: r.sY,
					Cy: A2(_Http_mapExpect, func, r.Cy),
					CN: r.CN,
					my: r.my,
					nE: r.nE,
					GL: r.GL,
					GT: r.GT
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{A5: false, sY: r.sY, Cy: r.Cy, CN: r.CN, my: r.my, nE: r.nE, GL: r.GL, GT: r.GT}));
};
var $author$project$Request$Authorize$attemptAuth = F3(
	function (creds, params, msg) {
		return $elm$http$Http$request(
			{
				sY: $elm$http$Http$emptyBody,
				Cy: $elm$http$Http$expectWhatever(msg),
				CN: _List_fromArray(
					[
						A2(
						$elm$http$Http$header,
						'Authorization',
						'Bearer ' + $author$project$Protected$getToken(creds))
					]),
				my: 'PUT',
				nE: $elm$core$Maybe$Nothing,
				GL: $elm$core$Maybe$Nothing,
				GT: A2(
					$elm$url$Url$Builder$absolute,
					_List_fromArray(
						['api/v1/oauth/authorize/device']),
					_List_fromArray(
						[
							A2($elm$url$Url$Builder$string, 'user_code', params.GV)
						]))
			});
	});
var $author$project$Pages$AuthorizeDevice$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 0:
				var userCode = msg.a;
				return A2(
					$author$project$Misc$with,
					A3(
						$author$project$Request$Authorize$attemptAuth,
						$author$project$Model$Session$getCreds(session),
						{GV: userCode},
						$author$project$Pages$AuthorizeDevice$AuthorizationCompleted),
					model);
			case 1:
				if (!msg.a.$) {
					return A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{pi: $author$project$Pages$AuthorizeDevice$AuthorizeDeviceComplete}));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								pi: $author$project$Pages$AuthorizeDevice$AuthorizeDeviceFailure(err)
							}));
				}
			case 2:
				var input = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$Ports$copyToClipboard(input),
					_Utils_update(
						model,
						{oi: $author$project$Model$CopyStatus$empty}));
			case 3:
				var portCopyStatus = msg.a;
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					_Utils_update(
						model,
						{oi: portCopyStatus}));
			default:
				var language = msg.a;
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					_Utils_update(
						model,
						{iG: language}));
		}
	});
var $author$project$Model$Route$projectOverview = function (args) {
	return $author$project$Model$Route$ProjectOverview(args);
};
var $author$project$Pages$AutoFork$update = F2(
	function (msg, model) {
		var toOverview = F2(
			function (destOrgUrlName, project) {
				return $author$project$Model$Route$projectOverview(
					{
						g$: model.g$,
						uk: false,
						DD: false,
						fO: $elm$core$Maybe$Nothing,
						gr: $elm$core$Maybe$Nothing,
						ix: destOrgUrlName,
						vT: $author$project$Model$Project$getName(project)
					});
			});
		if (!msg.b.$) {
			var destOrgUrlName = msg.a;
			return A2(
				$author$project$Misc$with,
				$author$project$External$NoOp,
				A2(
					$author$project$Misc$with,
					A2(
						$author$project$Routing$replaceUrl,
						model.Y,
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$Pages$AutoFork$homeRoute,
							A2(
								$elm$core$Maybe$map,
								toOverview(destOrgUrlName),
								model.hU))),
					model));
		} else {
			var err = msg.b.a;
			return A2(
				$author$project$Misc$with,
				$author$project$External$AddNotification(
					$author$project$Model$Notification$fromError(err)),
				A2(
					$author$project$Misc$with,
					A2($author$project$Routing$replaceUrl, model.Y, $author$project$Pages$AutoFork$homeRoute),
					model));
		}
	});
var $author$project$Pages$CheckEmail$OnResendActivationEmail = function (a) {
	return {$: 3, a: a};
};
var $author$project$External$RenewJWT = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$Analytics$categoryAuthentication = 'Authentication';
var $author$project$Pages$CheckEmail$getEmail = function (session) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.lJ;
			},
			$author$project$Model$Session$getUser(session)));
};
var $author$project$Model$Session$getDefaultNextRoute = function (session) {
	var _v0 = A2(
		$elm$core$Maybe$andThen,
		$author$project$Model$User$getLastCreatedOrg,
		$author$project$Model$Session$getUser(session));
	if (_v0.$ === 1) {
		return $elm$core$Maybe$Just(
			$author$project$Model$Route$Protected(
				$author$project$Model$Route$CreateOrganization(
					{h3: $elm$core$Maybe$Nothing, dg: $elm$core$Maybe$Nothing})));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Request$Email$postResendActivation = F3(
	function (session, address, nextRouteParam) {
		var nextRoute = function () {
			if (nextRouteParam.$ === 1) {
				return $author$project$Model$Session$getDefaultNextRoute(session);
			} else {
				var nr = nextRouteParam.a;
				return $elm$core$Maybe$Just(nr);
			}
		}();
		var params = function () {
			if (!nextRoute.$) {
				var route = nextRoute.a;
				return _List_fromArray(
					[
						A2(
						$elm$url$Url$Builder$string,
						'nextRoute',
						$author$project$Model$Route$routeToString(route))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var creds = $author$project$Model$Session$getCreds(session);
		var path = _List_fromArray(
			[
				'users',
				$author$project$Protected$username(creds),
				'emails',
				address,
				'verification',
				'send'
			]);
		return $author$project$Http$Extra$post(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$emptyJsonBody,
				qN: $author$project$Model$Message$decode,
				CN: _List_Nil,
				GT: A2($elm$url$Url$Builder$absolute, path, params)
			});
	});
var $author$project$Pages$CheckEmail$NoOp = {$: 0};
var $author$project$Pages$CheckEmail$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Pages$CheckEmail$NoOp, 'Pages/CheckEmail.elm');
var $author$project$Views$NotificationsInline$setError = function (err) {
	return $author$project$Views$NotificationsInline$set(
		$author$project$Model$Notification$fromError(err));
};
var $author$project$Pages$CheckEmail$update = F3(
	function (session, msg, model) {
		var nextRoute = function () {
			var _v1 = model.dg;
			if (!_v1.$) {
				var route = _v1.a;
				return route;
			} else {
				return $author$project$Model$Route$Protected(
					$author$project$Model$Route$Home(
						{wd: $elm$core$Maybe$Nothing}));
			}
		}();
		switch (msg.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
			case 1:
				if (!msg.a.$) {
					var analyticsCmd = $author$project$Ports$sendAnalyticsEvent(
						A2(
							$author$project$Model$Analytics$withAction,
							'Email address verified',
							A2(
								$author$project$Model$Analytics$withCategory,
								$author$project$Model$Analytics$categoryAuthentication,
								$author$project$Model$Analytics$newEvent('Email address verified'))));
					return A2(
						$author$project$Misc$with,
						$author$project$External$RenewJWT(
							$elm$core$Maybe$Just(nextRoute)),
						A2($author$project$Misc$with, analyticsCmd, model));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							A2(
								$author$project$Views$NotificationsInline$setError,
								err,
								_Utils_update(
									model,
									{D6: false}))));
				}
			case 2:
				var email = $author$project$Pages$CheckEmail$getEmail(session);
				var cmd = A2(
					$elm$core$Task$attempt,
					$author$project$Pages$CheckEmail$OnResendActivationEmail,
					A3($author$project$Request$Email$postResendActivation, session, email, model.dg));
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						cmd,
						$author$project$Views$NotificationsInline$clear(model)));
			default:
				if (!msg.a.$) {
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							A2($author$project$Views$NotificationsInline$setSuccessText, 'We re-sent your invite.', model)));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$CheckEmail$rollbar.FZ, 'OnResendActivationEmail (Err err)', err, session),
							A2($author$project$Views$NotificationsInline$setError, err, model)));
				}
		}
	});
var $author$project$Pages$Checkout$BillingDetailsMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Checkout$NoOp = {$: 0};
var $author$project$Pages$Checkout$SpecifyOrgMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Checkout$BillingDetails$Calculated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Checkout$BillingDetails$Calculating = {$: 1};
var $author$project$Pages$Checkout$BillingDetails$NoOp = {$: 0};
var $author$project$Pages$Checkout$BillingDetails$OnCreateInvoice = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Pages$Checkout$BillingDetails$OnTaxes = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Checkout$BillingDetails$CalculateTaxesLater = {$: 5};
var $author$project$Pages$Checkout$BillingDetails$calculateTaxesLater = A2(
	$elm$core$Task$perform,
	$elm$core$Basics$always($author$project$Pages$Checkout$BillingDetails$CalculateTaxesLater),
	$elm$core$Task$succeed(0));
var $author$project$Pages$Checkout$BillingDetails$CalculateTaxesNow = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Checkout$BillingDetails$calculateTaxesNow = function (bform) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$always(
			$author$project$Pages$Checkout$BillingDetails$CalculateTaxesNow(bform)),
		$elm$core$Task$succeed(0));
};
var $author$project$Model$Analytics$categoryCheckout = 'Checkout';
var $author$project$Http$Extra$reason = function (error) {
	var _v0 = error.mp;
	switch (_v0.$) {
		case 0:
			return 'BadUrl';
		case 1:
			return 'Timeout';
		case 2:
			return 'NetworkError';
		case 3:
			var response = _v0.a;
			return $elm$core$String$fromInt(response.wp) + (' - ' + response.sY);
		default:
			var str = _v0.a;
			return str;
	}
};
var $elm$core$Basics$truncate = _Basics_truncate;
var $author$project$Misc$toCents = A2(
	$elm$core$Basics$composeR,
	$elm$core$Basics$mul(100),
	$elm$core$Basics$truncate);
var $author$project$Model$Analytics$withValue = F2(
	function (value, event) {
		return _Utils_update(
			event,
			{kH: value});
	});
var $author$project$Pages$Checkout$BillingDetails$checkoutAnalyticsEvent = function (_v0) {
	var isTrial = _v0.up;
	var resultOp = _v0.v$;
	var tier = _v0.dc;
	var total = _v0.wL;
	var organization = _v0.c3;
	var setValue = function () {
		if (resultOp.$ === 1) {
			return $elm$core$Basics$identity;
		} else {
			return $author$project$Model$Analytics$withValue(
				$author$project$Misc$toCents(total));
		}
	}();
	var result = function () {
		if (resultOp.$ === 1) {
			return 'Failure';
		} else {
			return 'Success';
		}
	}();
	var label = function () {
		if (resultOp.$ === 1) {
			var err = resultOp.a;
			return organization.AC + (' - ' + $author$project$Http$Extra$reason(err));
		} else {
			return organization.AC;
		}
	}();
	var kind = isTrial ? 'Trial' : 'Purchase';
	return $author$project$Ports$sendAnalyticsEvent(
		setValue(
			A2(
				$author$project$Model$Analytics$withLabel,
				label,
				A2(
					$author$project$Model$Analytics$withAction,
					kind + (' ' + (result + (' - ' + $author$project$Model$Tier$name(tier.dc)))),
					A2(
						$author$project$Model$Analytics$withCategory,
						$author$project$Model$Analytics$categoryCheckout,
						$author$project$Model$Analytics$newEvent('Checkout - ' + result))))));
};
var $author$project$Model$Tier$annualCost = F2(
	function (tier, runtimeCount) {
		return tier.wF + (A2($elm$core$Basics$max, 0, runtimeCount - tier.yC) * tier.zI);
	});
var $author$project$Model$Tier$Annual = 1;
var $author$project$Model$Tier$Monthly = 0;
var $author$project$Model$Tier$billingPeriod = function (_v0) {
	var tier = _v0.dc;
	var _v1 = $author$project$Model$Tier$stringToSimpleTier(
		$author$project$Model$Tier$name(tier));
	if (_v1.$ === 2) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Model$Tier$costWithTaxes = F3(
	function (runtimeCount, taxes, tier) {
		var annualTotal = A2($author$project$Model$Tier$annualCost, tier, runtimeCount);
		var _v0 = $author$project$Model$Tier$billingPeriod(tier);
		if (!_v0) {
			return _Utils_Tuple2(annualTotal / 12, taxes / 12);
		} else {
			return _Utils_Tuple2(annualTotal, taxes);
		}
	});
var $author$project$Model$AddressInfo$encode = function (address) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(address.w)),
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(address.lJ)),
				_Utils_Tuple2(
				'address1',
				$elm$json$Json$Encode$string(address.qd)),
				_Utils_Tuple2(
				'address2',
				$elm$json$Json$Encode$string(address.sQ)),
				_Utils_Tuple2(
				'city',
				$elm$json$Json$Encode$string(address.qB)),
				_Utils_Tuple2(
				'country',
				$elm$json$Json$Encode$string(address.qK.xc)),
				_Utils_Tuple2(
				'state',
				$elm$json$Json$Encode$string(address.bB)),
				_Utils_Tuple2(
				'zip',
				$elm$json$Json$Encode$string(address.sM))
			]));
};
var $author$project$Model$AddressInfo$encodeEmail = A2(
	$elm$core$Basics$composeL,
	$elm$json$Json$Encode$string,
	function ($) {
		return $.lJ;
	});
var $author$project$Model$InvoiceInfo$encode = function (_v0) {
	var tierName = _v0.Aq;
	var activeRuntimes = _v0.w7;
	var stripeToken = _v0.Ah;
	var billingAddress = _v0.xm;
	var shippingAddress = _v0.z4;
	var isTrial = _v0.up;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'email',
				$author$project$Model$AddressInfo$encodeEmail(billingAddress)),
				_Utils_Tuple2(
				'tierName',
				$elm$json$Json$Encode$string(tierName)),
				_Utils_Tuple2(
				'activeRuntimes',
				$elm$json$Json$Encode$int(activeRuntimes)),
				_Utils_Tuple2(
				'stripeToken',
				$elm$json$Json$Encode$string(stripeToken)),
				_Utils_Tuple2(
				'billingAddress',
				$author$project$Model$AddressInfo$encode(billingAddress)),
				_Utils_Tuple2(
				'shippingAddress',
				$author$project$Model$AddressInfo$encode(shippingAddress)),
				_Utils_Tuple2(
				'isTrial',
				$elm$json$Json$Encode$bool(isTrial))
			]));
};
var $author$project$Request$Invoice$create = F4(
	function (identifierType, orgIdentifier, invoiceInfo, creds) {
		return $author$project$Http$Extra$post(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$jsonBody(
					$author$project$Model$InvoiceInfo$encode(invoiceInfo)),
				qN: $elm$json$Json$Decode$string,
				CN: _List_Nil,
				GT: '/organizations/' + (orgIdentifier + ('/invoices?identifierType=' + identifierType))
			});
	});
var $author$project$Request$Invoice$createByOrgUrlName = F3(
	function (urlName, invoiceInfo, creds) {
		return A4($author$project$Request$Invoice$create, 'URLname', urlName, invoiceInfo, creds);
	});
var $author$project$Pages$Checkout$BillingDetails$DebounceMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Checkout$BillingDetails$debounceConfig = {
	eO: $jinjor$elm_debounce$Debounce$later(1000),
	GN: $author$project$Pages$Checkout$BillingDetails$DebounceMsg
};
var $author$project$Model$Tier$description = function (_v0) {
	var t = _v0;
	return t.bP;
};
var $author$project$Pages$Checkout$BillingDetails$generalFormError = 'There was a problem with some of the information you provided, please check below for details.';
var $author$project$Views$BillingForm$getBillingInfo = function (model) {
	return {
		xm: model.xm,
		Fa: model.Fa,
		z4: model.io ? model.z4 : model.xm
	};
};
var $author$project$Request$Invoice$getTax = F5(
	function (address, tierName, activeRuntimes, orgUrlName, creds) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'shippingAddress',
					$author$project$Model$AddressInfo$encode(address)),
					_Utils_Tuple2(
					'tierName',
					$elm$json$Json$Encode$string(tierName)),
					_Utils_Tuple2(
					'activeRuntimes',
					$elm$json$Json$Encode$int(activeRuntimes)),
					_Utils_Tuple2(
					'orgURLName',
					$elm$json$Json$Encode$string(orgUrlName))
				]));
		return $author$project$Http$Extra$post(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$jsonBody(body),
				qN: $elm$json$Json$Decode$float,
				CN: _List_Nil,
				GT: '/taxes'
			});
	});
var $author$project$Model$Notification$prefix = F2(
	function (pre, notification) {
		if (!notification.$) {
			var content = notification.a;
			return $author$project$Model$Notification$Success(
				A2(
					$elm$core$List$cons,
					$author$project$Model$Notification$Text(pre),
					content));
		} else {
			var content = notification.a;
			return $author$project$Model$Notification$Warning(
				A2(
					$elm$core$List$cons,
					$author$project$Model$Notification$Text(pre),
					content));
		}
	});
var $author$project$Pages$Checkout$BillingDetails$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Pages$Checkout$BillingDetails$NoOp, 'Pages/Checkout/BillingDetails.elm');
var $author$project$Model$Runtimes$runtimesInt = function (_v0) {
	var x = _v0;
	return x;
};
var $author$project$Model$Notification$textWarning = function (message) {
	return $author$project$Model$Notification$Warning(
		_List_fromArray(
			[
				$author$project$Model$Notification$Text(message)
			]));
};
var $author$project$Views$NotificationsInline$setErrorText = function (str) {
	return $author$project$Views$NotificationsInline$set(
		$author$project$Model$Notification$textWarning(str));
};
var $author$project$Views$BillingForm$setLoading = function (billingForm) {
	return _Utils_update(
		billingForm,
		{D6: true});
};
var $author$project$Views$BillingForm$unsetLoading = function (billingForm) {
	return _Utils_update(
		billingForm,
		{D6: false});
};
var $author$project$Views$BillingForm$Cancel = {$: 3};
var $author$project$Views$BillingForm$CardImmutable = 1;
var $author$project$Views$BillingForm$CardMutable = 0;
var $author$project$Views$BillingForm$CardReadOnly = 0;
var $author$project$Views$BillingForm$CardReadToggleable = 1;
var $author$project$Views$BillingForm$CardWriteToggleable = 2;
var $author$project$Views$BillingForm$CreditCard = {$: 3};
var $author$project$Views$BillingForm$FormError = function (a) {
	return {$: 6, a: a};
};
var $author$project$Views$BillingForm$MajorAction = {$: 1};
var $author$project$Views$BillingForm$None = {$: 0};
var $author$project$Views$BillingForm$ReadToggleable = function (a) {
	return {$: 1, a: a};
};
var $author$project$Views$BillingForm$ShippingAddressChanged = {$: 4};
var $author$project$Views$BillingForm$SuccessfulSubmit = {$: 5};
var $author$project$Views$BillingForm$ValidationErrors = {$: 2};
var $author$project$Views$BillingForm$WriteToggleable = function (a) {
	return {$: 2, a: a};
};
var $author$project$Views$BillingForm$DisplayErrors = function (a) {
	return {$: 1, a: a};
};
var $author$project$Views$BillingForm$Ignore = {$: 0};
var $author$project$Views$BillingForm$ReturnSuccess = {$: 3};
var $author$project$Views$BillingForm$TokenizeCard = {$: 2};
var $author$project$Views$BillingForm$BillingField = function (a) {
	return {$: 0, a: a};
};
var $author$project$Views$BillingForm$CardField = function (a) {
	return {$: 2, a: a};
};
var $author$project$Views$BillingForm$ShippingField = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$AddressInfo$Address1 = 2;
var $author$project$Model$AddressInfo$City = 3;
var $author$project$Model$AddressInfo$Country = 4;
var $author$project$Model$AddressInfo$Email = 1;
var $author$project$Model$AddressInfo$Name = 0;
var $author$project$Model$AddressInfo$State = 5;
var $author$project$Model$AddressInfo$Zip = 6;
var $author$project$Model$AddressInfo$validate = F2(
	function (address, isEmailRequired) {
		var isBlank = function (getField) {
			return $elm$core$String$isEmpty(
				$elm$core$String$trim(
					getField(address)));
		};
		var fromMaybeError = F4(
			function (condition, errorField, error, errors) {
				var _v0 = _Utils_Tuple2(condition, error);
				if (_v0.a && (!_v0.b.$)) {
					var err = _v0.b.a;
					return A2(
						$elm$core$List$cons,
						_Utils_Tuple2(errorField, err),
						errors);
				} else {
					return errors;
				}
			});
		var addErrorIf = F3(
			function (condition, errorTuple, errors) {
				return condition ? A2($elm$core$List$cons, errorTuple, errors) : errors;
			});
		return A3(
			addErrorIf,
			isBlank(
				function ($) {
					return $.sM;
				}),
			_Utils_Tuple2(6, 'Please provide a zip/postal code'),
			A3(
				addErrorIf,
				isBlank(
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.qK;
						},
						function ($) {
							return $.xc;
						})),
				_Utils_Tuple2(4, 'Please select a country'),
				A3(
					addErrorIf,
					isBlank(
						function ($) {
							return $.bB;
						}),
					_Utils_Tuple2(5, 'Please provide a state/province'),
					A3(
						addErrorIf,
						isBlank(
							function ($) {
								return $.qB;
							}),
						_Utils_Tuple2(3, 'Please provide a city'),
						A3(
							addErrorIf,
							isBlank(
								function ($) {
									return $.qd;
								}),
							_Utils_Tuple2(2, 'Please provide an address'),
							A4(
								fromMaybeError,
								isEmailRequired,
								1,
								$author$project$Validation$validateEmail(address.lJ),
								A3(
									addErrorIf,
									isEmailRequired && isBlank(
										function ($) {
											return $.lJ;
										}),
									_Utils_Tuple2(1, 'Please provide an email address'),
									A3(
										addErrorIf,
										isBlank(
											function ($) {
												return $.w;
											}),
										_Utils_Tuple2(0, 'Please provide a name'),
										_List_Nil))))))));
	});
var $author$project$Views$BillingForm$formErrors = function (model) {
	var wrapErrorFields = function (formField) {
		return $elm$core$List$map(
			$elm$core$Tuple$mapFirst(formField));
	};
	var shippingAddressErrors = model.io ? A2(
		wrapErrorFields,
		$author$project$Views$BillingForm$ShippingField,
		A2($author$project$Model$AddressInfo$validate, model.z4, false)) : _List_Nil;
	var cardAddressErrors = model.iW ? A2(
		wrapErrorFields,
		$author$project$Views$BillingForm$CardField,
		A2($author$project$Model$AddressInfo$validate, model.Bs, false)) : _List_Nil;
	var billingAddressErrors = A2(
		wrapErrorFields,
		$author$project$Views$BillingForm$BillingField,
		A2($author$project$Model$AddressInfo$validate, model.xm, true));
	return _Utils_ap(
		billingAddressErrors,
		_Utils_ap(shippingAddressErrors, cardAddressErrors));
};
var $author$project$Views$BillingForm$Read = 0;
var $author$project$Views$BillingForm$Write = 1;
var $author$project$Views$BillingForm$getCardReadWrite = function (formState) {
	_v0$2:
	while (true) {
		switch (formState.$) {
			case 0:
				return 1;
			case 2:
				if (formState.a === 2) {
					var _v1 = formState.a;
					return 1;
				} else {
					break _v0$2;
				}
			default:
				break _v0$2;
		}
	}
	return 0;
};
var $author$project$Views$BillingForm$getSubmitAction = function (model) {
	if (model.D6) {
		return $author$project$Views$BillingForm$Ignore;
	} else {
		var errors = $author$project$Views$BillingForm$formErrors(model);
		var haveErrors = !$elm$core$List$isEmpty(errors);
		if (haveErrors) {
			return $author$project$Views$BillingForm$DisplayErrors(errors);
		} else {
			var _v0 = $author$project$Views$BillingForm$getCardReadWrite(model.jU);
			if (!_v0) {
				return $author$project$Views$BillingForm$ReturnSuccess;
			} else {
				return $author$project$Views$BillingForm$TokenizeCard;
			}
		}
	}
};
var $author$project$Model$Countries$getInfoFromName = A2(
	$elm$core$Basics$composeR,
	$author$project$Model$Countries$maybeInfoFromName,
	$elm$core$Maybe$withDefault($author$project$Model$Countries$emptyCountryInfo));
var $author$project$Views$BillingForm$updateAddress = F3(
	function (address, field, value) {
		switch (field) {
			case 0:
				return _Utils_update(
					address,
					{w: value});
			case 1:
				return _Utils_update(
					address,
					{lJ: value});
			case 2:
				return _Utils_update(
					address,
					{qd: value});
			case 3:
				return _Utils_update(
					address,
					{qB: value});
			case 4:
				return _Utils_update(
					address,
					{
						qK: $author$project$Model$Countries$getInfoFromName(value)
					});
			case 5:
				return _Utils_update(
					address,
					{bB: value});
			default:
				return _Utils_update(
					address,
					{sM: value});
		}
	});
var $author$project$Views$BillingForm$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var _v1 = $author$project$Views$BillingForm$getSubmitAction(model);
				switch (_v1.$) {
					case 0:
						return A2($author$project$Misc$with, $author$project$Views$BillingForm$None, model);
					case 1:
						var errors = _v1.a;
						return A2(
							$author$project$Misc$with,
							$author$project$Views$BillingForm$ValidationErrors,
							_Utils_update(
								model,
								{iT: false, yf: errors, Fa: $elm$core$Maybe$Nothing}));
					case 2:
						return A2(
							$author$project$Misc$with,
							$author$project$Views$BillingForm$MajorAction,
							_Utils_update(
								model,
								{iT: true, yf: _List_Nil, D6: true}));
					default:
						return A2(
							$author$project$Misc$with,
							$author$project$Views$BillingForm$SuccessfulSubmit,
							_Utils_update(
								model,
								{yf: _List_Nil, D6: true}));
				}
			case 1:
				var set = function (formState) {
					return $author$project$Views$BillingForm$reset(
						_Utils_update(
							model,
							{jU: formState}));
				};
				var _v2 = model.jU;
				switch (_v2.$) {
					case 0:
						return A2($author$project$Misc$with, $author$project$Views$BillingForm$Cancel, model);
					case 1:
						if (!_v2.a) {
							var _v3 = _v2.a;
							return A2(
								$author$project$Misc$with,
								$author$project$Views$BillingForm$MajorAction,
								set(
									$author$project$Views$BillingForm$WriteToggleable(1)));
						} else {
							var _v4 = _v2.a;
							return A2(
								$author$project$Misc$with,
								$author$project$Views$BillingForm$MajorAction,
								set(
									$author$project$Views$BillingForm$WriteToggleable(0)));
						}
					default:
						if (!_v2.a) {
							var _v5 = _v2.a;
							return A2(
								$author$project$Misc$with,
								$author$project$Views$BillingForm$Cancel,
								set(
									$author$project$Views$BillingForm$ReadToggleable(1)));
						} else {
							return A2(
								$author$project$Misc$with,
								$author$project$Views$BillingForm$Cancel,
								set(
									$author$project$Views$BillingForm$ReadToggleable(0)));
						}
				}
			case 2:
				var set = function (formState) {
					return _Utils_update(
						model,
						{
							iT: false,
							yf: A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Tuple$first,
									$elm$core$Basics$neq($author$project$Views$BillingForm$CreditCard)),
								model.yf),
							jU: formState,
							Fa: $elm$core$Maybe$Nothing
						});
				};
				var _v6 = model.jU;
				_v6$2:
				while (true) {
					if (_v6.$ === 2) {
						switch (_v6.a) {
							case 1:
								var _v7 = _v6.a;
								return A2(
									$author$project$Misc$with,
									$author$project$Views$BillingForm$None,
									set(
										$author$project$Views$BillingForm$WriteToggleable(2)));
							case 2:
								var _v8 = _v6.a;
								return A2(
									$author$project$Misc$with,
									$author$project$Views$BillingForm$None,
									set(
										$author$project$Views$BillingForm$WriteToggleable(1)));
							default:
								break _v6$2;
						}
					} else {
						break _v6$2;
					}
				}
				return A2($author$project$Misc$with, $author$project$Views$BillingForm$None, model);
			case 4:
				var token = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$Views$BillingForm$SuccessfulSubmit,
					_Utils_update(
						model,
						{
							iT: false,
							Fa: $elm$core$Maybe$Just(token)
						}));
			case 5:
				var error = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$Views$BillingForm$None,
					_Utils_update(
						model,
						{
							iT: false,
							yf: A2(
								$elm$core$List$cons,
								_Utils_Tuple2($author$project$Views$BillingForm$CreditCard, error),
								model.yf),
							D6: false,
							Fa: $elm$core$Maybe$Nothing
						}));
			case 3:
				var field = msg.a;
				var value = msg.b;
				var newModel = function () {
					switch (field.$) {
						case 0:
							var addressField = field.a;
							return _Utils_update(
								model,
								{
									xm: A3($author$project$Views$BillingForm$updateAddress, model.xm, addressField, value)
								});
						case 1:
							var addressField = field.a;
							return _Utils_update(
								model,
								{
									z4: A3($author$project$Views$BillingForm$updateAddress, model.z4, addressField, value)
								});
						case 2:
							var addressField = field.a;
							return _Utils_update(
								model,
								{
									Bs: A3($author$project$Views$BillingForm$updateAddress, model.Bs, addressField, value)
								});
						default:
							return model;
					}
				}();
				var message = function () {
					switch (field.$) {
						case 0:
							return model.io ? $author$project$Views$BillingForm$None : $author$project$Views$BillingForm$ShippingAddressChanged;
						case 1:
							return $author$project$Views$BillingForm$ShippingAddressChanged;
						default:
							return $author$project$Views$BillingForm$None;
					}
				}();
				return A2($author$project$Misc$with, message, newModel);
			case 6:
				return A2(
					$author$project$Misc$with,
					$author$project$Views$BillingForm$ShippingAddressChanged,
					_Utils_update(
						model,
						{io: !model.io}));
			case 8:
				return A2(
					$author$project$Misc$with,
					$author$project$Views$BillingForm$None,
					_Utils_update(
						model,
						{iW: !model.iW}));
			default:
				var err = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$Views$BillingForm$FormError(err),
					model);
		}
	});
var $author$project$Views$BillingForm$validateForTaxes = function (billingForm) {
	var errors = $author$project$Views$BillingForm$formErrors(billingForm);
	return A2(
		$author$project$Misc$with,
		$elm$core$List$isEmpty(errors),
		_Utils_update(
			billingForm,
			{yf: errors}));
};
var $author$project$Pages$Checkout$BillingDetails$update = F4(
	function (session, _v0, msg, model) {
		var key = _v0.Y;
		var tierInfo = _v0.sC;
		var isTrial = _v0.up;
		var maybeNextRoute = _v0.Ee;
		var tierName = A3(
			$elm$core$Basics$composeR,
			$author$project$Model$Tier$name,
			A2($elm$core$Basics$composeR, $author$project$Model$Tier$stringToSimpleTier, $author$project$Model$Tier$simpleTierToString),
			tierInfo.dc);
		var scrollToTop = $author$project$Misc$scrollToTop($author$project$Pages$Checkout$BillingDetails$NoOp);
		var creds = $author$project$Model$Session$getCreds(session);
		switch (msg.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
			case 1:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{lH: !model.lH})));
			case 2:
				var value = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$author$project$Pages$Checkout$BillingDetails$calculateTaxesLater,
						_Utils_update(
							model,
							{
								iH: $author$project$Model$Runtimes$toRuntimes(value)
							})));
			case 3:
				var form = msg.a;
				var _v2 = A2($author$project$Views$BillingForm$update, form, model.jT);
				var newForm = _v2.a;
				var formMsg = _v2.b;
				switch (formMsg.$) {
					case 5:
						var calculatedTaxes = function () {
							var _v4 = model.gP;
							if (_v4.$ === 2) {
								var tax = _v4.a;
								return tax;
							} else {
								return 0;
							}
						}();
						var total = A2(
							$elm_community$basics_extra$Basics$Extra$uncurry,
							$elm$core$Basics$add,
							A3(
								$author$project$Model$Tier$costWithTaxes,
								$author$project$Model$Runtimes$runtimesInt(model.iH),
								calculatedTaxes,
								tierInfo));
						var billingInfo = $author$project$Views$BillingForm$getBillingInfo(newForm);
						var stripeToken = A2($elm$core$Maybe$withDefault, '', billingInfo.Fa);
						var invoiceInfo = {
							w7: $author$project$Model$Runtimes$runtimesInt(model.iH),
							xm: billingInfo.xm,
							up: isTrial,
							z4: billingInfo.z4,
							Ah: stripeToken,
							Aq: tierName
						};
						var cmd = A2(
							$elm$core$Task$attempt,
							$author$project$Pages$Checkout$BillingDetails$OnCreateInvoice(total),
							A3($author$project$Request$Invoice$createByOrgUrlName, model.FV.AC, invoiceInfo, creds));
						return A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2(
								$author$project$Misc$with,
								cmd,
								$author$project$Views$NotificationsInline$clear(
									_Utils_update(
										model,
										{
											jT: $author$project$Views$BillingForm$setLoading(newForm)
										}))));
					case 2:
						return A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2(
								$author$project$Misc$with,
								scrollToTop,
								A2(
									$author$project$Views$NotificationsInline$setErrorText,
									$author$project$Pages$Checkout$BillingDetails$generalFormError,
									_Utils_update(
										model,
										{jT: newForm}))));
					case 3:
						return A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2(
								$author$project$Misc$with,
								A2(
									$author$project$Routing$replaceUrl,
									key,
									$author$project$Model$Route$Protected(
										$author$project$Model$Route$Home(
											{wd: $elm$core$Maybe$Nothing}))),
								model));
					case 4:
						return A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2(
								$author$project$Misc$with,
								$author$project$Pages$Checkout$BillingDetails$calculateTaxesLater,
								_Utils_update(
									model,
									{jT: newForm, gP: $author$project$Pages$Checkout$BillingDetails$NotCalculated})));
					case 1:
						return A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2(
								$author$project$Misc$with,
								$elm$core$Platform$Cmd$none,
								$author$project$Views$NotificationsInline$clear(
									_Utils_update(
										model,
										{jT: newForm}))));
					case 0:
						return A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2(
								$author$project$Misc$with,
								$elm$core$Platform$Cmd$none,
								_Utils_update(
									model,
									{jT: newForm})));
					default:
						var str = formMsg.a;
						return A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2(
								$author$project$Misc$with,
								A2($author$project$Pages$Checkout$BillingDetails$rollbar.sk, str, session),
								model));
				}
			case 4:
				var debounceMsg = msg.a;
				var _v5 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Pages$Checkout$BillingDetails$debounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast($author$project$Pages$Checkout$BillingDetails$calculateTaxesNow),
					debounceMsg,
					model.lp);
				var debounce = _v5.a;
				var cmd = _v5.b;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						cmd,
						_Utils_update(
							model,
							{lp: debounce})));
			case 5:
				var _v6 = $author$project$Views$BillingForm$validateForTaxes(model.jT);
				var newForm = _v6.a;
				var formValid = _v6.b;
				if (formValid) {
					var _v7 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Pages$Checkout$BillingDetails$debounceConfig, newForm, model.lp);
					var newDebounce = _v7.a;
					var cmd = _v7.b;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							cmd,
							_Utils_update(
								model,
								{lp: newDebounce})));
				} else {
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
				}
			case 6:
				var form = msg.a;
				var _v8 = $author$project$Views$BillingForm$validateForTaxes(form);
				var newForm = _v8.a;
				var formValid = _v8.b;
				if (formValid) {
					var shippingAddress = $author$project$Views$BillingForm$getBillingInfo(newForm).z4;
					var activeRuntimes = $author$project$Model$Runtimes$runtimesInt(model.iH);
					var getTaxCmd = A2(
						$elm$core$Task$attempt,
						$author$project$Pages$Checkout$BillingDetails$OnTaxes,
						A5($author$project$Request$Invoice$getTax, shippingAddress, tierName, activeRuntimes, model.FV.AC, creds));
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							getTaxCmd,
							$author$project$Views$NotificationsInline$clear(
								_Utils_update(
									model,
									{jT: newForm, gP: $author$project$Pages$Checkout$BillingDetails$Calculating}))));
				} else {
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							scrollToTop,
							A2(
								$author$project$Views$NotificationsInline$setErrorText,
								$author$project$Pages$Checkout$BillingDetails$generalFormError,
								_Utils_update(
									model,
									{jT: newForm, gP: $author$project$Pages$Checkout$BillingDetails$NotCalculated}))));
				}
			case 7:
				if (!msg.a.$) {
					var taxes = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{
									gP: $author$project$Pages$Checkout$BillingDetails$Calculated(taxes)
								})));
				} else {
					var err = msg.a.a;
					var notification = A2(
						$author$project$Model$Notification$prefix,
						'There is a problem with your shipping address: ',
						$author$project$Model$Notification$fromError(err));
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							A2(
								$author$project$Views$NotificationsInline$set,
								notification,
								_Utils_update(
									model,
									{gP: $author$project$Pages$Checkout$BillingDetails$NotCalculated}))));
				}
			default:
				if (!msg.b.$) {
					var total = msg.a;
					var tierDescription = $author$project$Model$Tier$description(tierInfo.dc);
					var org = model.FV;
					var notificationText = A2(
						$elm$core$String$join,
						' ',
						_List_fromArray(
							[
								'This organization is now on a',
								tierDescription,
								isTrial ? ' trial subscription.' : 'subscription.'
							]));
					var nextRoute = A2(
						$elm$core$Maybe$withDefault,
						A2($author$project$Model$Route$orgIndex, org.AC, $elm$core$Maybe$Nothing),
						maybeNextRoute);
					return A2(
						$author$project$Misc$with,
						$author$project$External$Batch(
							_List_fromArray(
								[
									$author$project$External$AddNotification(
									$author$project$Model$Notification$textSuccess(notificationText)),
									$author$project$External$AddMembership(
									{
										ts: org.ak,
										DM: model.uQ,
										zw: org.zw,
										FO: 2,
										dc: $author$project$Model$Tier$name(tierInfo.dc),
										AC: org.AC
									})
								])),
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Checkout$BillingDetails$checkoutAnalyticsEvent(
										{
											up: isTrial,
											c3: model.FV,
											v$: $elm$core$Result$Ok(0),
											dc: tierInfo,
											wL: total
										}),
										A2($author$project$Routing$replaceUrl, key, nextRoute)
									])),
							model));
				} else {
					var total = msg.a;
					var err = msg.b.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Checkout$BillingDetails$checkoutAnalyticsEvent(
										{
											up: isTrial,
											c3: model.FV,
											v$: $elm$core$Result$Err(err),
											dc: tierInfo,
											wL: total
										}),
										A3($author$project$Pages$Checkout$BillingDetails$rollbar.FZ, 'OnCreateInvoice total (Err err)', err, session),
										$author$project$Misc$scrollToTop($author$project$Pages$Checkout$BillingDetails$NoOp)
									])),
							A2(
								$author$project$Views$NotificationsInline$setError,
								err,
								_Utils_update(
									model,
									{
										jT: $author$project$Views$BillingForm$unsetLoading(model.jT)
									}))));
				}
		}
	});
var $author$project$Pages$Checkout$SpecifyOrg$GoToBillingDetails = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Checkout$SpecifyOrg$NoOp = {$: 0};
var $author$project$Pages$Checkout$SpecifyOrg$None = {$: 0};
var $author$project$Pages$Checkout$SpecifyOrg$OnOrgCreated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Checkout$SpecifyOrg$OnRenew = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Checkout$SpecifyOrg$orgCreationInputId = 'create-org-input';
var $author$project$Pages$Checkout$SpecifyOrg$update = F4(
	function (session, parentModel, msg, model) {
		var scrollToTop = $author$project$Misc$scrollToTop($author$project$Pages$Checkout$SpecifyOrg$NoOp);
		var maybeUser = $author$project$Model$Session$getUser(session);
		var creds = $author$project$Model$Session$getCreds(session);
		var _v0 = _Utils_Tuple2(msg, model.gZ);
		_v0$9:
		while (true) {
			switch (_v0.a.$) {
				case 1:
					if (!_v0.b.$) {
						var urlName = _v0.a.a;
						var state = _v0.b.a;
						return A2(
							$author$project$Misc$with,
							$author$project$Pages$Checkout$SpecifyOrg$None,
							A2(
								$author$project$Misc$with,
								$author$project$External$NoOp,
								A2(
									$author$project$Misc$with,
									$elm$core$Platform$Cmd$none,
									_Utils_update(
										model,
										{
											gZ: $author$project$Pages$Checkout$SpecifyOrg$SpecifyOrgCreation(
												_Utils_update(
													state,
													{
														qY: $author$project$Validation$formatUsername(urlName),
														AC: urlName,
														p2: $author$project$Validation$validateUsername(urlName)
													}))
										}))));
					} else {
						break _v0$9;
					}
				case 2:
					if (!_v0.b.$) {
						var res = _v0.a.a;
						var state = _v0.b.a;
						if (!res.$) {
							var org = res.a;
							return A2(
								$author$project$Misc$with,
								$author$project$Pages$Checkout$SpecifyOrg$GoToBillingDetails(org),
								A2(
									$author$project$Misc$with,
									$author$project$External$AddMembership(
										{ts: org.ak, DM: model.uQ, zw: org.zw, FO: 2, dc: org.dc, AC: org.AC}),
									A2(
										$author$project$Misc$with,
										$elm$core$Platform$Cmd$batch(
											_List_fromArray(
												[
													scrollToTop,
													A2($elm$core$Task$attempt, $author$project$Pages$Checkout$SpecifyOrg$OnRenew, $author$project$Request$User$renew)
												])),
										model)));
						} else {
							var err = res.a;
							return A2(
								$author$project$Misc$with,
								$author$project$Pages$Checkout$SpecifyOrg$None,
								A2(
									$author$project$Misc$with,
									$author$project$External$AddNotification(
										$author$project$Model$Notification$fromError(err)),
									A2(
										$author$project$Misc$with,
										$elm$core$Platform$Cmd$none,
										_Utils_update(
											model,
											{
												gZ: $author$project$Pages$Checkout$SpecifyOrg$SpecifyOrgCreation(state)
											}))));
						}
					} else {
						break _v0$9;
					}
				case 3:
					if (!_v0.b.$) {
						var _v2 = _v0.a;
						return A2(
							$author$project$Misc$with,
							$author$project$Pages$Checkout$SpecifyOrg$None,
							A2(
								$author$project$Misc$with,
								$author$project$External$NoOp,
								A2(
									$author$project$Misc$with,
									$elm$core$Platform$Cmd$none,
									_Utils_update(
										model,
										{
											gZ: $author$project$Pages$Checkout$SpecifyOrg$SpecifyOrgSelection(
												{
													FV: A3($author$project$Pages$Checkout$SpecifyOrg$defaultSelectedOrg, maybeUser, parentModel.up, model.rJ),
													nt: false
												})
										}))));
					} else {
						var _v3 = _v0.a;
						return A2(
							$author$project$Misc$with,
							$author$project$Pages$Checkout$SpecifyOrg$None,
							A2(
								$author$project$Misc$with,
								$author$project$External$NoOp,
								A2(
									$author$project$Misc$with,
									A2(
										$elm$core$Task$attempt,
										$elm$core$Basics$always($author$project$Pages$Checkout$SpecifyOrg$NoOp),
										$elm$browser$Browser$Dom$focus($author$project$Pages$Checkout$SpecifyOrg$orgCreationInputId)),
									_Utils_update(
										model,
										{
											gZ: $author$project$Pages$Checkout$SpecifyOrg$SpecifyOrgCreation(
												{qY: '', AC: '', p2: $elm$core$Maybe$Nothing})
										}))));
					}
				case 4:
					if (_v0.b.$ === 1) {
						var open = _v0.a.a;
						var state = _v0.b.a;
						return A2(
							$author$project$Misc$with,
							$author$project$Pages$Checkout$SpecifyOrg$None,
							A2(
								$author$project$Misc$with,
								$author$project$External$NoOp,
								A2(
									$author$project$Misc$with,
									$elm$core$Platform$Cmd$none,
									_Utils_update(
										model,
										{
											gZ: $author$project$Pages$Checkout$SpecifyOrg$SpecifyOrgSelection(
												_Utils_update(
													state,
													{nt: open}))
										}))));
					} else {
						break _v0$9;
					}
				case 5:
					if (_v0.b.$ === 1) {
						var org = _v0.a.a;
						var state = _v0.b.a;
						return A2(
							$author$project$Misc$with,
							$author$project$Pages$Checkout$SpecifyOrg$None,
							A2(
								$author$project$Misc$with,
								$author$project$External$NoOp,
								A2(
									$author$project$Misc$with,
									$elm$core$Platform$Cmd$none,
									_Utils_update(
										model,
										{
											gZ: $author$project$Pages$Checkout$SpecifyOrg$SpecifyOrgSelection(
												_Utils_update(
													state,
													{
														FV: $elm$core$Maybe$Just(org),
														nt: false
													}))
										}))));
					} else {
						break _v0$9;
					}
				case 6:
					if (!_v0.b.$) {
						var _v4 = _v0.a;
						var state = _v0.b.a;
						var _v5 = state.AC;
						if (_v5 === '') {
							return A2(
								$author$project$Misc$with,
								$author$project$Pages$Checkout$SpecifyOrg$None,
								A2(
									$author$project$Misc$with,
									$author$project$External$NoOp,
									A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model)));
						} else {
							var urlName = _v5;
							var postData = {
								i$: $elm$core$Maybe$Just(urlName),
								AC: $elm$core$Maybe$Just(urlName)
							};
							return A2(
								$author$project$Misc$with,
								$author$project$Pages$Checkout$SpecifyOrg$None,
								A2(
									$author$project$Misc$with,
									$author$project$External$NoOp,
									A2(
										$author$project$Misc$with,
										A2(
											$elm$core$Task$attempt,
											$author$project$Pages$Checkout$SpecifyOrg$OnOrgCreated,
											A2($author$project$Request$Organization$post, postData, creds)),
										_Utils_update(
											model,
											{
												gZ: $author$project$Pages$Checkout$SpecifyOrg$SpecifyOrgCreation(state)
											}))));
						}
					} else {
						var _v6 = _v0.a;
						var state = _v0.b.a;
						var _v7 = state.FV;
						if (!_v7.$) {
							var selectedOrg = _v7.a;
							return A2(
								$author$project$Misc$with,
								$author$project$Pages$Checkout$SpecifyOrg$GoToBillingDetails(selectedOrg),
								A2(
									$author$project$Misc$with,
									$author$project$External$NoOp,
									A2($author$project$Misc$with, scrollToTop, model)));
						} else {
							return A2(
								$author$project$Misc$with,
								$author$project$Pages$Checkout$SpecifyOrg$None,
								A2(
									$author$project$Misc$with,
									$author$project$External$NoOp,
									A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model)));
						}
					}
				case 7:
					var res = _v0.a.a;
					if (!res.$) {
						var newJWT = res.a;
						return A2(
							$author$project$Misc$with,
							$author$project$Pages$Checkout$SpecifyOrg$None,
							A2(
								$author$project$Misc$with,
								$author$project$External$SetJWT(newJWT),
								A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model)));
					} else {
						return A2(
							$author$project$Misc$with,
							$author$project$Pages$Checkout$SpecifyOrg$None,
							A2(
								$author$project$Misc$with,
								$author$project$External$NoOp,
								A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model)));
					}
				default:
					break _v0$9;
			}
		}
		return A2(
			$author$project$Misc$with,
			$author$project$Pages$Checkout$SpecifyOrg$None,
			A2(
				$author$project$Misc$with,
				$author$project$External$NoOp,
				A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model)));
	});
var $author$project$Pages$Checkout$update = F3(
	function (session, msg, model) {
		var tier = model.sC;
		var scrollToTop = $author$project$Misc$scrollToTop($author$project$Pages$Checkout$NoOp);
		var checkoutButtonLabel = model.up ? 'Start My Free Trial' : 'Complete Checkout';
		var _v0 = _Utils_Tuple2(msg, model.iU);
		_v0$2:
		while (true) {
			if (_v0.b.$ === 1) {
				if (_v0.a.$ === 2) {
					var billingDetailsMsg = _v0.a.a;
					var billingDetailsModel = _v0.b.a;
					var _v1 = A4($author$project$Pages$Checkout$BillingDetails$update, session, model, billingDetailsMsg, billingDetailsModel);
					var _v2 = _v1.a;
					var newBillingDetailsModel = _v2.a;
					var billingDetailsCmd = _v2.b;
					var newSession = _v1.b;
					return A2(
						$author$project$Misc$with,
						newSession,
						A2(
							$author$project$Misc$with,
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Checkout$BillingDetailsMsg, billingDetailsCmd),
							_Utils_update(
								model,
								{
									iU: $author$project$Pages$Checkout$BillingDetails(newBillingDetailsModel)
								})));
				} else {
					break _v0$2;
				}
			} else {
				if (_v0.a.$ === 1) {
					var specifyOrgMsg = _v0.a.a;
					var specifyOrgModel = _v0.b.a;
					var _v3 = A4($author$project$Pages$Checkout$SpecifyOrg$update, session, model, specifyOrgMsg, specifyOrgModel);
					var _v4 = _v3.a;
					var _v5 = _v4.a;
					var newSpecifyOrgModel = _v5.a;
					var specifyOrgCmd = _v5.b;
					var newSession = _v4.b;
					var specifyOrgExternal = _v3.b;
					if (!specifyOrgExternal.$) {
						return A2(
							$author$project$Misc$with,
							newSession,
							A2(
								$author$project$Misc$with,
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Checkout$SpecifyOrgMsg, specifyOrgCmd),
								_Utils_update(
									model,
									{
										iU: $author$project$Pages$Checkout$SpecifyOrg(newSpecifyOrgModel)
									})));
					} else {
						var org = specifyOrgExternal.a;
						return A2(
							$author$project$Misc$with,
							newSession,
							A2(
								$author$project$Misc$with,
								scrollToTop,
								_Utils_update(
									model,
									{
										iU: $author$project$Pages$Checkout$BillingDetails(
											A5(
												$author$project$Pages$Checkout$BillingDetails$init,
												checkoutButtonLabel,
												specifyOrgModel.rJ,
												org,
												model.uQ,
												$author$project$Pages$Checkout$selectedRuntimes(tier)))
									})));
					}
				} else {
					break _v0$2;
				}
			}
		}
		return A2(
			$author$project$Misc$with,
			$author$project$External$NoOp,
			A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
	});
var $author$project$Pages$ConnectAccount$Link = 1;
var $author$project$Pages$ConnectAccount$OnLoginThen = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$ConnectAccount$SwitchFocus = function (a) {
	return {$: 6, a: a};
};
var $author$project$Views$AuthButton$getGithubOauthPath = F5(
	function (endpoint, csrfToken, nextRoute, inviteCode, email) {
		var path = _List_fromArray(
			['api', 'v1', 'oauth', 'github', endpoint]);
		var params = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$author$project$Model$Route$stringQueryParam,
					'state',
					$elm$core$Maybe$Just(csrfToken)),
					A2(
					$author$project$Model$Route$stringQueryParam,
					'inviteCode',
					A2($elm$core$Maybe$map, $author$project$Model$NonEmptyString$toString, inviteCode)),
					A2($author$project$Model$Route$stringQueryParam, 'email', email),
					A2(
					$author$project$Model$Route$stringQueryParam,
					'nextRoute',
					A2($elm$core$Maybe$map, $author$project$Model$Route$routeToString, nextRoute))
				]));
		return A2($elm$url$Url$Builder$absolute, path, params);
	});
var $author$project$Views$AuthButton$getLinkPath = function (csrfToken) {
	return A5(
		$author$project$Views$AuthButton$getGithubOauthPath,
		'link',
		csrfToken,
		$elm$core$Maybe$Just(
			$author$project$Model$Route$Protected(
				$author$project$Model$Route$PreferenceLinkedAccounts(
					{D3: $elm$core$Maybe$Nothing, F$: $elm$core$Maybe$Nothing}))),
		$elm$core$Maybe$Nothing,
		$elm$core$Maybe$Nothing);
};
var $author$project$Pages$ConnectAccount$TwoFactor = 1;
var $author$project$Pages$ConnectAccount$getLoginMode = F2(
	function (err, loginMode) {
		if (loginMode === 1) {
			return 1;
		} else {
			var _v0 = err.mp;
			if (_v0.$ === 3) {
				var resp = _v0.a;
				var _v1 = resp.wp;
				if (_v1 === 449) {
					return 1;
				} else {
					return 0;
				}
			} else {
				return 0;
			}
		}
	});
var $author$project$Views$AuthButton$getSignupPath = F4(
	function (csrfToken, nextRoute, inviteCode, email) {
		return A5($author$project$Views$AuthButton$getGithubOauthPath, 'signup', csrfToken, nextRoute, inviteCode, email);
	});
var $author$project$Http$Extra$statusCode = function (err) {
	var _v0 = err.mp;
	if (_v0.$ === 3) {
		var resp = _v0.a;
		return $elm$core$String$fromInt(resp.wp);
	} else {
		return 'No bad response code.';
	}
};
var $author$project$Http$Extra$is4xxErr = function (err) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (code) {
				return code < 500;
			},
			$elm$core$String$toInt(
				$author$project$Http$Extra$statusCode(err))));
};
var $author$project$Model$Credentials$encode = function (_v0) {
	var username = _v0.AE;
	var password = _v0.ey;
	var totp = _v0.wM;
	var inviteCode = _v0.fs;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'username',
				$elm$json$Json$Encode$string(username)),
				_Utils_Tuple2(
				'password',
				$elm$json$Json$Encode$string(password)),
				_Utils_Tuple2(
				'totp',
				$elm$json$Json$Encode$string(totp)),
				_Utils_Tuple2(
				'inviteCode',
				$elm$json$Json$Encode$string(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Maybe$map, $author$project$Model$NonEmptyString$toString, inviteCode))))
			]));
};
var $author$project$Request$User$login = function (creds) {
	return $author$project$Http$Extra$post(
		{
			iO: $author$project$Http$Extra$None,
			sY: $author$project$Http$Extra$jsonBody(
				$author$project$Model$Credentials$encode(creds)),
			qN: $author$project$Model$JWT$decode,
			CN: _List_Nil,
			GT: $author$project$Http$Extra$urlBase + '/login'
		});
};
var $author$project$Pages$ConnectAccount$NoOp = {$: 0};
var $author$project$Pages$ConnectAccount$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Pages$ConnectAccount$NoOp, 'Pages/ConnectAccount.elm');
var $author$project$Ports$setCSRFCookie = _Platform_outgoingPort(
	'setCSRFCookie',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Pages$ConnectAccount$twoFactorId = 'two-factor';
var $author$project$Pages$ConnectAccount$update = F3(
	function (session, msg, model) {
		var onLoginWorkflow = function (jwt) {
			var maybeHubspotChat = $author$project$Model$User$isPaidUser(
				$elm$core$Maybe$Just(jwt.gS)) ? $author$project$Ports$loadHubSpotChat(0) : $author$project$Ports$removeHubSpotChat(0);
			var analyticsCmd = $author$project$Ports$sendAnalyticsEvent(
				A2(
					$author$project$Model$Analytics$withLabel,
					'Email',
					A2(
						$author$project$Model$Analytics$withAction,
						'Sign in - success',
						A2(
							$author$project$Model$Analytics$withCategory,
							$author$project$Model$Analytics$categoryAuthentication,
							$author$project$Model$Analytics$newEvent('Sign in - success')))));
			return A2(
				$author$project$Misc$with,
				$author$project$External$SetJWT(jwt),
				A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								analyticsCmd,
								maybeHubspotChat,
								$author$project$Ports$setCSRFCookie(0)
							])),
					_Utils_update(
						model,
						{n0: 1})));
		};
		var loginWorkflow = F2(
			function (creds, nextMsg) {
				var _v4 = _Utils_Tuple2(model.j6, creds.wM);
				if ((_v4.a === 1) && (_v4.b === '')) {
					var _v5 = _v4.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{
									p_: $elm$core$Maybe$Just('Please enter your code')
								})));
				} else {
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							A2(
								$elm$core$Task$attempt,
								nextMsg,
								$author$project$Request$User$login(creds)),
							$author$project$Views$NotificationsInline$clear(
								_Utils_update(
									model,
									{lX: true, p_: $elm$core$Maybe$Nothing}))));
				}
			});
		switch (msg.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
			case 7:
				var analyticsCmd = $author$project$Ports$sendAnalyticsEvent(
					A2(
						$author$project$Model$Analytics$withLabel,
						'GitHub',
						A2(
							$author$project$Model$Analytics$withAction,
							'Create account - attempt',
							A2(
								$author$project$Model$Analytics$withCategory,
								$author$project$Model$Analytics$categoryAuthentication,
								$author$project$Model$Analytics$newEvent('Create account - attempt')))));
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									analyticsCmd,
									$author$project$Ports$setCSRFCookie(0)
								])),
						_Utils_update(
							model,
							{n0: 0})));
			case 8:
				var token = msg.a;
				var _v1 = model.n0;
				if (!_v1) {
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$browser$Browser$Navigation$load(
								A4(
									$author$project$Views$AuthButton$getSignupPath,
									token,
									$elm$core$Maybe$Just(model.dg),
									model.dI.fs,
									$elm$core$Maybe$Just(model.dI.AE))),
							model));
				} else {
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$browser$Browser$Navigation$load(
								$author$project$Views$AuthButton$getLinkPath(token)),
							model));
				}
			case 1:
				var creds = msg.a;
				return A2(loginWorkflow, creds, $author$project$Pages$ConnectAccount$OnLoginThen);
			case 2:
				if (!msg.a.$) {
					var jwt = msg.a.a;
					return onLoginWorkflow(jwt);
				} else {
					var error = msg.a.a;
					var loginMode = A2($author$project$Pages$ConnectAccount$getLoginMode, error, model.j6);
					var logToRollbar = A3($author$project$Pages$ConnectAccount$rollbar.FZ, 'OnLoginThen (Err error)', error, session);
					var credentials = model.dI;
					var credsWithoutTwoFactor = _Utils_update(
						credentials,
						{wM: ''});
					var cmd = function () {
						if (!loginMode) {
							return $author$project$Http$Extra$is4xxErr(error) ? $elm$core$Platform$Cmd$none : logToRollbar;
						} else {
							return A2(
								$elm$core$Task$attempt,
								$author$project$Pages$ConnectAccount$SwitchFocus,
								$elm$browser$Browser$Dom$focus($author$project$Pages$ConnectAccount$twoFactorId));
						}
					}();
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							cmd,
							A2(
								$author$project$Views$NotificationsInline$setError,
								error,
								_Utils_update(
									model,
									{dI: credsWithoutTwoFactor, lX: false, j6: loginMode}))));
				}
			case 3:
				var username = msg.a;
				var creds = model.dI;
				var newCreds = _Utils_update(
					creds,
					{AE: username});
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{dI: newCreds})));
			case 4:
				var password = msg.a;
				var creds = model.dI;
				var newCreds = _Utils_update(
					creds,
					{ey: password});
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{dI: newCreds})));
			case 5:
				var twofactor = msg.a;
				var creds = model.dI;
				var newCreds = _Utils_update(
					creds,
					{wM: twofactor});
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{dI: newCreds})));
			default:
				if (!msg.a.$) {
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
				} else {
					var domError = msg.a.a;
					var cmd = function () {
						var e = domError;
						return A2($author$project$Pages$ConnectAccount$rollbar.sk, e, session);
					}();
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							cmd,
							A2($author$project$Views$NotificationsInline$setErrorText, 'Could not show 2-factor auth field.  Please refresh page.  If the problem persist, contact support', model)));
				}
		}
	});
var $author$project$Pages$CreateAccount$CheckUsernameTaken = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$CreateAccount$OnAccountCreated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$CreateAccount$Submitting = 2;
var $author$project$Pages$CreateAccount$Taken = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$CreateAccount$Unvalidated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$CreateAccount$UsernameTaken = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$CreateAccount$Valid = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$CreateAccount$Waiting = 1;
var $author$project$Pages$CreateAccount$WaitingOnServer = function (a) {
	return {$: 5, a: a};
};
var $author$project$Request$User$create = F4(
	function (session, user, createOrg, nextRouteParam) {
		var payload = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'username',
					$elm$json$Json$Encode$string(user.AE)),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(user.w)),
					_Utils_Tuple2(
					'inviteCode',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $author$project$Model$NonEmptyString$toString, $elm$json$Json$Encode$string),
							user.fs))),
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string(user.lJ)),
					_Utils_Tuple2(
					'password',
					$elm$json$Json$Encode$string(user.ey)),
					_Utils_Tuple2(
					'sendMarketingEmail',
					$elm$json$Json$Encode$bool(user.EY)),
					_Utils_Tuple2(
					'eulaAccepted',
					$elm$json$Json$Encode$bool(user.tM))
				]));
		var nextRoute = function () {
			if (nextRouteParam.$ === 1) {
				return $author$project$Model$Session$getDefaultNextRoute(session);
			} else {
				var nr = nextRouteParam.a;
				return $elm$core$Maybe$Just(nr);
			}
		}();
		return $author$project$Http$Extra$post(
			{
				iO: $author$project$Http$Extra$None,
				sY: $author$project$Http$Extra$jsonBody(payload),
				qN: $author$project$Model$JWT$decode,
				CN: _List_Nil,
				GT: _Utils_ap(
					$author$project$Http$Extra$urlBase,
					A2(
						$elm$url$Url$Builder$absolute,
						_List_fromArray(
							['users']),
						A2(
							$author$project$Misc$consMaybe,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Model$Route$routeToString,
									$elm$url$Url$Builder$string('nextRoute')),
								nextRoute),
							_List_fromArray(
								[
									A2(
									$elm$url$Url$Builder$string,
									'createOrganization',
									$Chadtech$elm_bool_extra$Bool$Extra$toString(createOrg))
								]))))
			});
	});
var $author$project$Pages$CreateAccount$extractIfKnownValid = function (field) {
	switch (field.$) {
		case 6:
			var val = field.a;
			return $elm$core$Maybe$Just(val);
		case 2:
			var val = field.a;
			return $elm$core$Maybe$Just(val);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$CreateAccount$formFieldValue = function (formField) {
	switch (formField.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			var value = formField.a;
			return $elm$core$Maybe$Just(value);
		case 2:
			var value = formField.a;
			return $elm$core$Maybe$Just(value);
		case 3:
			var value = formField.a;
			return $elm$core$Maybe$Just(value);
		case 6:
			var value = formField.a;
			return $elm$core$Maybe$Just(value);
		case 4:
			var value = formField.a;
			return $elm$core$Maybe$Just(value);
		default:
			var value = formField.a;
			return $elm$core$Maybe$Just(value);
	}
};
var $author$project$Pages$CreateAccount$fieldToText = function (field) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		$author$project$Pages$CreateAccount$formFieldValue(field));
};
var $author$project$Pages$CreateAccount$Hidden = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$CreateAccount$hideInvalidReason = function (field) {
	if ((field.$ === 3) && (field.b.$ === 1)) {
		var val = field.a;
		var reason = field.b.a;
		return A2(
			$author$project$Pages$CreateAccount$Invalid,
			val,
			$author$project$Pages$CreateAccount$Hidden(reason));
	} else {
		return field;
	}
};
var $author$project$Pages$CreateAccount$maybeLocked = function (field) {
	if (field.$ === 2) {
		var value = field.a;
		return $elm$core$Maybe$Just(value);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$CreateAccount$removeEulaErrorInModel = function (model) {
	return _Utils_update(
		model,
		{ou: $elm$core$Maybe$Nothing});
};
var $author$project$Pages$CreateAccount$NoOp = {$: 0};
var $author$project$Pages$CreateAccount$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Pages$CreateAccount$NoOp, 'Pages/CreateAccount.elm');
var $author$project$Pages$CreateAccount$setEulaErrorInModel = function (model) {
	return _Utils_update(
		model,
		{
			ou: $elm$core$Maybe$Just('You must accept the ActiveState terms of use and service before creating an account')
		});
};
var $author$project$Pages$CreateAccount$stringFromReason = function (reasonDetails) {
	if (!reasonDetails.$) {
		var reasonText = reasonDetails.a;
		return reasonText;
	} else {
		var reasonText = reasonDetails.a;
		return reasonText;
	}
};
var $author$project$Pages$CreateAccount$summarizeFieldErrors = function (formFields) {
	return A2(
		$elm$core$String$join,
		' + ',
		A2(
			$elm$core$List$filterMap,
			function (field) {
				switch (field.$) {
					case 3:
						if (field.b.$ === 1) {
							var reasonDetails = field.b.a;
							return $elm$core$Maybe$Just(
								$author$project$Pages$CreateAccount$stringFromReason(reasonDetails));
						} else {
							var reasonDetails = field.b.a;
							return $elm$core$Maybe$Just(
								$author$project$Pages$CreateAccount$stringFromReason(reasonDetails));
						}
					case 4:
						return $elm$core$Maybe$Just('Field is debounced.');
					case 5:
						return $elm$core$Maybe$Just('Field is waiting on server.');
					default:
						return $elm$core$Maybe$Nothing;
				}
			},
			formFields));
};
var $author$project$Request$User$usernameAvailable = function (username) {
	return $author$project$Http$Extra$get(
		{iO: $author$project$Http$Extra$None, sY: $author$project$Http$Extra$emptyBody, qN: $author$project$Model$Message$decode, CN: _List_Nil, GT: $author$project$Http$Extra$urlBase + ('/users/uniqueUsername/' + username)});
};
var $author$project$Pages$CreateAccount$validateField = F2(
	function (field, validator) {
		switch (field.$) {
			case 1:
				var val = field.a;
				var _v1 = validator(val);
				if (!_v1.$) {
					var error = _v1.a;
					return A2(
						$author$project$Pages$CreateAccount$Invalid,
						val,
						$author$project$Pages$CreateAccount$Visible(
							$author$project$Pages$CreateAccount$ValidationFailed(error)));
				} else {
					return $author$project$Pages$CreateAccount$Valid(val);
				}
			case 2:
				return field;
			case 0:
				var _v2 = validator('');
				if (!_v2.$) {
					var error = _v2.a;
					return A2(
						$author$project$Pages$CreateAccount$Invalid,
						'',
						$author$project$Pages$CreateAccount$Visible(
							$author$project$Pages$CreateAccount$ValidationFailed(error)));
				} else {
					return $author$project$Pages$CreateAccount$Valid('');
				}
			case 3:
				if (!field.b.$) {
					var val = field.a;
					var errorText = field.b.a;
					return A2(
						$author$project$Pages$CreateAccount$Invalid,
						val,
						$author$project$Pages$CreateAccount$Visible(errorText));
				} else {
					return field;
				}
			case 4:
				return field;
			case 5:
				return field;
			default:
				return field;
		}
	});
var $author$project$Validation$maxPasswordLength = 72;
var $author$project$Validation$minPasswordLength = 15;
var $author$project$Validation$validatePassword = $author$project$Validation$runValidations(
	_List_fromArray(
		[
			_Utils_Tuple2($elm$core$String$isEmpty, 'Please provide a password'),
			_Utils_Tuple2(
			$author$project$Validation$isShorterThan($author$project$Validation$minPasswordLength),
			'Please make your password at least ' + ($elm$core$String$fromInt($author$project$Validation$minPasswordLength) + ' characters long')),
			_Utils_Tuple2(
			$author$project$Validation$isLongerThan($author$project$Validation$maxPasswordLength),
			'Must be no more than ' + ($elm$core$String$fromInt($author$project$Validation$maxPasswordLength) + ' characters long'))
		]));
var $author$project$Pages$CreateAccount$Debounced = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$CreateAccount$validateUsername = F2(
	function (field, validator) {
		_v0$3:
		while (true) {
			switch (field.$) {
				case 1:
					var val = field.a;
					var formattedName = $author$project$Validation$formatUsername(val);
					var _v1 = validator(formattedName);
					if (!_v1.$) {
						var error = _v1.a;
						return A2(
							$author$project$Pages$CreateAccount$Invalid,
							val,
							$author$project$Pages$CreateAccount$Visible(
								$author$project$Pages$CreateAccount$ValidationFailed(error)));
					} else {
						return $author$project$Pages$CreateAccount$Debounced(val);
					}
				case 3:
					if (!field.b.$) {
						var val = field.a;
						var errorText = field.b.a;
						return A2(
							$author$project$Pages$CreateAccount$Invalid,
							val,
							$author$project$Pages$CreateAccount$Visible(errorText));
					} else {
						break _v0$3;
					}
				case 0:
					var _v2 = validator('');
					if (!_v2.$) {
						var error = _v2.a;
						return A2(
							$author$project$Pages$CreateAccount$Invalid,
							'',
							$author$project$Pages$CreateAccount$Visible(
								$author$project$Pages$CreateAccount$ValidationFailed(error)));
					} else {
						return $author$project$Pages$CreateAccount$Valid('');
					}
				default:
					break _v0$3;
			}
		}
		return field;
	});
var $author$project$Pages$CreateAccount$update = F3(
	function (session, msg, model) {
		var nextRoute = A2(
			$author$project$Pages$CreateAccount$getNextRoute,
			$elm$core$Maybe$Nothing,
			{
				lJ: $author$project$Pages$CreateAccount$maybeLocked(model.i0),
				fs: model.fs,
				dg: model.dg
			});
		switch (msg.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
			case 3:
				var username = msg.a;
				var validatedUsernameField = $author$project$Pages$CreateAccount$hideInvalidReason(
					A2(
						$author$project$Pages$CreateAccount$validateUsername,
						$author$project$Pages$CreateAccount$Unvalidated(username),
						$author$project$Validation$validateUsername));
				var _v1 = function () {
					if (validatedUsernameField.$ === 4) {
						var name = validatedUsernameField.a;
						return _Utils_Tuple2(
							$elm$core$Maybe$Just(
								_Utils_Tuple2(name, 300)),
							1);
					} else {
						return _Utils_Tuple2($elm$core$Maybe$Nothing, 0);
					}
				}();
				var debouncing = _v1.a;
				var formStatus = _v1.b;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{lq: debouncing, ge: formStatus, fz: validatedUsernameField})));
			case 4:
				var username = msg.a;
				var usernameField = $author$project$Pages$CreateAccount$WaitingOnServer(username);
				var usernameAvailableCheck = A2(
					$elm$core$Task$attempt,
					$author$project$Pages$CreateAccount$UsernameTaken(username),
					$author$project$Request$User$usernameAvailable(
						$author$project$Validation$formatUsername(username)));
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						usernameAvailableCheck,
						_Utils_update(
							model,
							{fz: usernameField})));
			case 5:
				if (!msg.b.$) {
					var username = msg.a;
					var usernameField = function () {
						var _v3 = model.fz;
						if (_v3.$ === 5) {
							var name = _v3.a;
							return _Utils_eq(
								$author$project$Validation$formatUsername(name),
								$author$project$Validation$formatUsername(username)) ? $author$project$Pages$CreateAccount$Valid(name) : model.fz;
						} else {
							return model.fz;
						}
					}();
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{ge: 0, fz: usernameField})));
				} else {
					var username = msg.a;
					var err = msg.b.a;
					var errorText = function () {
						var _v5 = err.mp;
						if (_v5.$ === 3) {
							var resp = _v5.a;
							var _v6 = resp.wp;
							if (_v6 === 409) {
								return 'This username is already in use.';
							} else {
								return 'Something went wrong - please try a different username.';
							}
						} else {
							return 'Something went wrong - please try a different username.';
						}
					}();
					var usernameField = function () {
						var _v4 = model.fz;
						if (_v4.$ === 5) {
							var name = _v4.a;
							return _Utils_eq(
								$author$project$Validation$formatUsername(name),
								$author$project$Validation$formatUsername(username)) ? A2(
								$author$project$Pages$CreateAccount$Invalid,
								name,
								$author$project$Pages$CreateAccount$Visible(
									$author$project$Pages$CreateAccount$Taken(errorText))) : model.fz;
						} else {
							return model.fz;
						}
					}();
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{ge: 0, fz: usernameField})));
				}
			case 6:
				var password = msg.a;
				var validatedPasswordField = $author$project$Pages$CreateAccount$hideInvalidReason(
					A2(
						$author$project$Pages$CreateAccount$validateField,
						$author$project$Pages$CreateAccount$Unvalidated(password),
						$author$project$Validation$validatePassword));
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{jp: validatedPasswordField})));
			case 7:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{pl: !model.pl})));
			case 8:
				var email = msg.a;
				var validatedEmailField = $author$project$Pages$CreateAccount$hideInvalidReason(
					A2(
						$author$project$Pages$CreateAccount$validateField,
						$author$project$Pages$CreateAccount$Unvalidated(email),
						$author$project$Validation$validateEmail));
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{i0: validatedEmailField})));
			case 10:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{lL: !model.lL})));
			case 11:
				var isDisabling = model.tM;
				var newModel = isDisabling ? $author$project$Pages$CreateAccount$setEulaErrorInModel(model) : $author$project$Pages$CreateAccount$removeEulaErrorInModel(model);
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							newModel,
							{tM: !model.tM})));
			case 9:
				var mode = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{kP: mode})));
			case 1:
				var usernameField = A2($author$project$Pages$CreateAccount$validateUsername, model.fz, $author$project$Validation$validateUsername);
				var passwordField = A2($author$project$Pages$CreateAccount$validateField, model.jp, $author$project$Validation$validatePassword);
				var newModel = (!model.tM) ? $author$project$Pages$CreateAccount$setEulaErrorInModel(model) : $author$project$Pages$CreateAccount$removeEulaErrorInModel(model);
				var emailField = A2($author$project$Pages$CreateAccount$validateField, model.i0, $author$project$Validation$validateEmail);
				var _v7 = function () {
					var _v8 = _Utils_Tuple2(
						$author$project$Pages$CreateAccount$extractIfKnownValid(emailField),
						_Utils_Tuple3(
							$author$project$Pages$CreateAccount$extractIfKnownValid(usernameField),
							$author$project$Pages$CreateAccount$extractIfKnownValid(passwordField),
							newModel.tM));
					if ((((!_v8.a.$) && (!_v8.b.a.$)) && (!_v8.b.b.$)) && _v8.b.c) {
						var email = _v8.a.a;
						var _v9 = _v8.b;
						var name = _v9.a.a;
						var password = _v9.b.a;
						var newUser = {
							lJ: email,
							tM: model.tM,
							fs: model.fs,
							w: $author$project$Validation$formatUsername(name),
							EY: model.lL,
							ey: password,
							AE: $author$project$Validation$formatUsername(name)
						};
						return _Utils_Tuple2(
							A2(
								$elm$core$Task$attempt,
								$author$project$Pages$CreateAccount$OnAccountCreated,
								A4($author$project$Request$User$create, session, newUser, false, model.dg)),
							2);
					} else {
						var combinedFormErrors = $author$project$Pages$CreateAccount$summarizeFieldErrors(
							_List_fromArray(
								[passwordField, emailField, usernameField]));
						var analyticsCmd = $author$project$Ports$sendAnalyticsEvent(
							A2(
								$author$project$Model$Analytics$withLabel,
								'Email - Form validation error(s) - ' + combinedFormErrors,
								A2(
									$author$project$Model$Analytics$withAction,
									'Create account - failure',
									A2(
										$author$project$Model$Analytics$withCategory,
										$author$project$Model$Analytics$categoryAuthentication,
										$author$project$Model$Analytics$newEvent('Create account - failure')))));
						return _Utils_Tuple2(
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										analyticsCmd,
										$author$project$Ports$scrollIntoView(
										{
											fD: $elm$core$Maybe$Just('center'),
											z0: '.email-form-wrapper'
										})
									])),
							model.ge);
					}
				}();
				var cmd = _v7.a;
				var formStatus = _v7.b;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						cmd,
						$author$project$Views$NotificationsInline$clear(
							_Utils_update(
								newModel,
								{i0: emailField, ge: formStatus, jp: passwordField, fz: usernameField}))));
			case 2:
				if (!msg.a.$) {
					var accountCreatedEventCmd = $author$project$Ports$sendAnalyticsEvent(
						A2(
							$author$project$Model$Analytics$withLabel,
							'Email',
							A2(
								$author$project$Model$Analytics$withAction,
								'Create account - success',
								A2(
									$author$project$Model$Analytics$withCategory,
									$author$project$Model$Analytics$categoryAuthentication,
									$author$project$Model$Analytics$newEvent('Create account - success')))));
					return A2(
						$author$project$Misc$with,
						$author$project$External$RenewJWT(
							$elm$core$Maybe$Just(nextRoute)),
						A2($author$project$Misc$with, accountCreatedEventCmd, model));
				} else {
					var err = msg.a.a;
					var newModel = function () {
						var _v10 = err.mp;
						if (_v10.$ === 3) {
							var response = _v10.a;
							if (response.wp === 400) {
								var message = $author$project$Model$Message$reason(err);
								return _Utils_update(
									model,
									{
										jp: A2(
											$author$project$Pages$CreateAccount$Invalid,
											$author$project$Pages$CreateAccount$fieldToText(model.jp),
											$author$project$Pages$CreateAccount$Visible(
												$author$project$Pages$CreateAccount$ValidationFailed(message)))
									});
							} else {
								return A2($author$project$Views$NotificationsInline$setError, err, model);
							}
						} else {
							return A2($author$project$Views$NotificationsInline$setError, err, model);
						}
					}();
					var analyticsCmd = $author$project$Ports$sendAnalyticsEvent(
						A2(
							$author$project$Model$Analytics$withLabel,
							'Email - ' + $author$project$Model$Message$reason(err),
							A2(
								$author$project$Model$Analytics$withAction,
								'Create account - failure',
								A2(
									$author$project$Model$Analytics$withCategory,
									$author$project$Model$Analytics$categoryAuthentication,
									$author$project$Model$Analytics$newEvent('Create account - failure')))));
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										analyticsCmd,
										A3($author$project$Pages$CreateAccount$rollbar.FZ, 'OnAccountCreated (Err err)', err, session),
										$author$project$Ports$scrollIntoView(
										{
											fD: $elm$core$Maybe$Just('center'),
											z0: '.email-form-wrapper'
										})
									])),
							_Utils_update(
								newModel,
								{ge: 0})));
				}
			case 12:
				var analyticsCmd = $author$project$Ports$sendAnalyticsEvent(
					A2(
						$author$project$Model$Analytics$withLabel,
						'GitHub',
						A2(
							$author$project$Model$Analytics$withAction,
							'Create account - attempt',
							A2(
								$author$project$Model$Analytics$withCategory,
								$author$project$Model$Analytics$categoryAuthentication,
								$author$project$Model$Analytics$newEvent('Create account - attempt')))));
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									analyticsCmd,
									$author$project$Ports$setCSRFCookie(0)
								])),
						model));
			case 13:
				var token = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$browser$Browser$Navigation$load(
							A4(
								$author$project$Views$AuthButton$getSignupPath,
								token,
								$elm$core$Maybe$Just(nextRoute),
								model.fs,
								$elm$core$Maybe$Nothing)),
						model));
			default:
				var _v11 = function () {
					var _v12 = model.lq;
					if (!_v12.$) {
						var _v13 = _v12.a;
						var username = _v13.a;
						var time = _v13.b;
						return (time <= 0) ? _Utils_Tuple2(
							$elm$core$Maybe$Nothing,
							A2(
								$elm$core$Task$perform,
								$elm$core$Basics$always(
									$author$project$Pages$CreateAccount$CheckUsernameTaken(username)),
								$elm$core$Task$succeed(0))) : _Utils_Tuple2(
							$elm$core$Maybe$Just(
								_Utils_Tuple2(username, time - $author$project$Pages$CreateAccount$timeInterval)),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
					}
				}();
				var debouncing = _v11.a;
				var cmd = _v11.b;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						cmd,
						_Utils_update(
							model,
							{lq: debouncing})));
		}
	});
var $author$project$Pages$CreateOrganization$CreateOrgFormMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$CreateOrganization$OnOrganizationCreated = function (a) {
	return {$: 1, a: a};
};
var $author$project$External$SetLocalStorage = function (a) {
	return {$: 11, a: a};
};
var $author$project$Model$Route$mapProtected = F2(
	function (f, route) {
		if (route.$ === 7) {
			var protectedRoute = route.a;
			return $author$project$Model$Route$Protected(
				f(protectedRoute));
		} else {
			return route;
		}
	});
var $author$project$Model$Route$mapCreateProject = function (f) {
	return $author$project$Model$Route$mapProtected(
		function (protectedRoute) {
			switch (protectedRoute.$) {
				case 18:
					var orgName = protectedRoute.a.ix;
					var createProjectParams = protectedRoute.a.B2;
					return $author$project$Model$Route$CreateProject(
						{
							B2: f(createProjectParams),
							ix: orgName
						});
				case 17:
					var params = protectedRoute.a;
					return $author$project$Model$Route$CreateProjectRedirect(
						f(params));
				default:
					var x = protectedRoute;
					return x;
			}
		});
};
var $author$project$AutoCreateProject$injectNextRoute = function (params) {
	return $author$project$Model$Route$mapCreateProject(
		function (routeParams) {
			return _Utils_update(
				routeParams,
				{
					A9: true,
					DQ: $elm$core$Maybe$Just(params.aC),
					DS: $elm$core$Maybe$Just(params.aI)
				});
		});
};
var $author$project$Pages$CreateOrganization$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Pages$CreateOrganization$NoOp, 'Pages/CreateOrganization.elm');
var $author$project$Pages$CreateOrganization$update = F3(
	function (session, action, model) {
		var creds = $author$project$Model$Session$getCreds(session);
		switch (action.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
			case 2:
				var msg = action.a;
				var _v1 = A3($author$project$Views$CreateOrgForm$update, session, msg, model.jT);
				var _v2 = _v1.a;
				var form = _v2.a;
				var cmd = _v2.b;
				var canSubmit = _v1.b;
				var newModel = _Utils_update(
					model,
					{jT: form});
				if (canSubmit) {
					var fields = $author$project$Views$CreateOrgForm$getFields(form);
					var postData = {
						i$: $elm$core$Maybe$Just(fields.ix),
						AC: $elm$core$Maybe$Just(fields.E_)
					};
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							A2(
								$elm$core$Task$attempt,
								$author$project$Pages$CreateOrganization$OnOrganizationCreated,
								A2($author$project$Request$Organization$post, postData, creds)),
							newModel));
				} else {
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$CreateOrganization$CreateOrgFormMsg, cmd),
							newModel));
				}
			default:
				if (!action.a.$) {
					var org = action.a.a;
					var nextRouteBasedOnSelectedTier = function () {
						var _v7 = model.jT.kv;
						if (_v7.$ === 3) {
							return $author$project$Model$Route$Protected(
								$author$project$Model$Route$Checkout(
									{
										jc: true,
										up: false,
										dg: $elm$core$Maybe$Nothing,
										ix: $elm$core$Maybe$Just(org.AC),
										Ab: true,
										dc: $elm$core$Maybe$Just(
											$author$project$Model$Tier$Team(false))
									}));
						} else {
							return $author$project$Model$Route$Protected(
								$author$project$Model$Route$Org(
									{
										ix: org.AC,
										vI: $author$project$Model$Route$OrgIndex($elm$core$Maybe$Nothing)
									}));
						}
					}();
					var eventArgs = ($author$project$Model$Session$isGithubLinked(session) ? $author$project$Model$Analytics$withCustomValues(
						_List_fromArray(
							[
								_Utils_Tuple2('userType', 'GitHub')
							])) : $author$project$Model$Analytics$withCustomValues(
						_List_fromArray(
							[
								_Utils_Tuple2('userType', 'Email')
							])))(
						A2(
							$author$project$Model$Analytics$withLabel,
							'Tier: ' + org.dc,
							A2(
								$author$project$Model$Analytics$withAction,
								'Created organization',
								A2(
									$author$project$Model$Analytics$withCategory,
									'Organizations',
									$author$project$Model$Analytics$newEvent('Created organization')))));
					var effectiveNextRoute = function () {
						var _v4 = _Utils_Tuple2(model.dg, model.h3);
						if (!_v4.a.$) {
							if (!_v4.b.$) {
								var nextRoute = _v4.a.a;
								var autoParams = _v4.b.a;
								return A2($author$project$AutoCreateProject$injectNextRoute, autoParams, nextRoute);
							} else {
								var nextRoute = _v4.a.a;
								var _v5 = _v4.b;
								return nextRoute;
							}
						} else {
							var _v6 = _v4.a;
							return nextRouteBasedOnSelectedTier;
						}
					}();
					var finalNextRoute = function () {
						var _v3 = $author$project$Model$Tier$stringToSimpleTier(org.dc);
						if (_v3.$ === 7) {
							return $author$project$Model$Route$Protected(
								$author$project$Model$Route$Org(
									{
										ix: org.AC,
										vI: $author$project$Model$Route$OrgIndex($elm$core$Maybe$Nothing)
									}));
						} else {
							return effectiveNextRoute;
						}
					}();
					var externalMsg = $author$project$External$Batch(
						_List_fromArray(
							[
								$author$project$External$RenewJWT(
								$elm$core$Maybe$Just(finalNextRoute)),
								$author$project$External$SetLocalStorage(
								{Y: $author$project$Model$LocalStorage$lastOrganizationKey, kH: org.AC}),
								$author$project$External$AddNotification(
								$author$project$Model$Notification$textSuccess('Organization created successfully'))
							]));
					return A2(
						$author$project$Misc$with,
						externalMsg,
						A2(
							$author$project$Misc$with,
							$author$project$Ports$sendAnalyticsEvent(eventArgs),
							_Utils_update(
								model,
								{
									jT: $author$project$Views$CreateOrgForm$setNotSubmitting(model.jT)
								})));
				} else {
					var err = action.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$CreateOrganization$rollbar.FZ, 'OnOrganizationCreated (Err err)', err, session),
							_Utils_update(
								model,
								{
									jT: $author$project$Views$CreateOrgForm$setNotSubmitting(model.jT)
								})));
				}
		}
	});
var $author$project$External$ToggleOrgDropDown = {$: 16};
var $author$project$External$UpdateLastUsedOrg = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$Views$PlatformSelectorSimple$platformName = function (_v0) {
	var name = _v0.a;
	return name;
};
var $author$project$Views$PlatformSelectorSimple$choose = F2(
	function (choice, _v0) {
		var selection = _v0;
		var _v1 = $author$project$Views$PlatformSelectorSimple$platformName(choice);
		switch (_v1) {
			case 2:
				return _Utils_update(
					selection,
					{gq: choice});
			case 0:
				return _Utils_update(
					selection,
					{hZ: choice});
			default:
				return _Utils_update(
					selection,
					{hz: choice});
		}
	});
var $author$project$Views$PlatformSelectorSimple$chooseOne = F2(
	function (choice, _v0) {
		var selection = _v0;
		var deselect = function (_v2) {
			var a = _v2.a;
			var b = _v2.b;
			var c = _v2.c;
			return A4($author$project$Views$PlatformSelectorSimple$PlatformChoice, a, b, c, false);
		};
		var noneSelected = _Utils_update(
			selection,
			{
				hz: deselect(selection.hz),
				gq: deselect(selection.gq),
				hZ: deselect(selection.hZ)
			});
		var _v1 = $author$project$Views$PlatformSelectorSimple$platformName(choice);
		switch (_v1) {
			case 2:
				return _Utils_update(
					noneSelected,
					{gq: choice});
			case 0:
				return _Utils_update(
					noneSelected,
					{hZ: choice});
			default:
				return _Utils_update(
					noneSelected,
					{hz: choice});
		}
	});
var $author$project$Views$PlatformSelectorSimple$platformDistro = function (_v0) {
	var distro = _v0.b;
	return distro;
};
var $author$project$Views$PlatformSelectorSimple$platformVersion = function (_v0) {
	var version = _v0.c;
	return version;
};
var $author$project$Views$PlatformSelectorSimple$filterByLanguage = F2(
	function (languageSelection, platformSelection) {
		var selection = platformSelection;
		var macAvailable = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Model$LanguageVersions$isMacAllowed, languageSelection));
		return macAvailable ? platformSelection : _Utils_update(
			selection,
			{
				hz: selection.hz,
				gq: A4(
					$author$project$Views$PlatformSelectorSimple$PlatformChoice,
					$author$project$Views$PlatformSelectorSimple$platformName(selection.gq),
					$author$project$Views$PlatformSelectorSimple$platformDistro(selection.gq),
					$author$project$Views$PlatformSelectorSimple$platformVersion(selection.gq),
					false),
				hZ: selection.hZ
			});
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$getBundles = $author$project$Model$BuildPlanner$SolveLegacyEditor$getBuildExprSolveEditor(
	$author$project$Model$Editor$getField($author$project$Model$BuildPlanner$SolveLegacyEditor$bundlesGetter));
var $author$project$Pages$CreateProject$OnBundlesMetadata = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Pages$CreateProject$getBundlesMetadataCmd = function (selectedLanguages) {
	var getBundlesForLanguage = function (selectedLanguage) {
		if (!selectedLanguage.$) {
			var language = selectedLanguage.a;
			return A2(
				$elm$core$Task$attempt,
				A2(
					$elm$core$Basics$composeR,
					$krisajenkins$remotedata$RemoteData$fromResult,
					$author$project$Pages$CreateProject$OnBundlesMetadata(language)),
				A2($author$project$Request$Ingredient$bundles, $elm$core$Maybe$Nothing, language));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	};
	return $elm$core$Platform$Cmd$batch(
		A2(
			$elm$core$List$map,
			A2($elm$core$Basics$composeR, $author$project$Model$LanguageVersions$getMaybeLanguage, getBundlesForLanguage),
			selectedLanguages));
};
var $author$project$Model$BuildPlanner$Error$AlreadyExistsError$message = function (_v0) {
	var data = _v0;
	return data.Eh;
};
var $author$project$Model$BuildPlanner$Error$FastForwardError$message = function (_v0) {
	var data = _v0;
	return data.Eh;
};
var $author$project$Model$BuildPlanner$Error$ForbiddenError$message = function (_v0) {
	var data = _v0;
	return data.Eh;
};
var $author$project$Model$BuildPlanner$Error$HeadOnBranchMovedError$message = function (_v0) {
	var data = _v0;
	return data.Eh;
};
var $author$project$Model$BuildPlanner$Error$InvalidInputError$message = function (_v0) {
	var data = _v0;
	return data.Eh;
};
var $author$project$Model$BuildPlanner$Error$MergeConflictError$message = function (_v0) {
	var data = _v0;
	return data.Eh;
};
var $author$project$Model$BuildPlanner$Error$NoChangesSinceLastCommitError$message = function (_v0) {
	var data = _v0;
	return data.Eh;
};
var $author$project$Model$BuildPlanner$Error$NoUpstreamBranchError$message = function (_v0) {
	var data = _v0;
	return data.Eh;
};
var $author$project$Model$BuildPlanner$Error$NotFoundError$message = function (_v0) {
	var data = _v0;
	return data.Eh;
};
var $author$project$Model$BuildPlanner$Error$ParseError$message = function (_v0) {
	var data = _v0;
	return data.Eh;
};
var $author$project$Model$BuildPlanner$Error$PlanningError$message = function (_v0) {
	var data = _v0;
	return data.Eh;
};
var $author$project$Model$BuildPlanner$Error$ValidationError$message = function (_v0) {
	var data = _v0;
	return data.Eh;
};
var $author$project$Model$BuildPlanner$BuildPlannerError$message = function (buildPlannerError) {
	switch (buildPlannerError.$) {
		case 0:
			return 'There was an error processing your request. Please try again later.';
		case 1:
			var error = buildPlannerError.a;
			return 'Already exists: ' + $author$project$Model$BuildPlanner$Error$AlreadyExistsError$message(error);
		case 2:
			var error = buildPlannerError.a;
			return 'Forbidden: ' + $author$project$Model$BuildPlanner$Error$ForbiddenError$message(error);
		case 3:
			var error = buildPlannerError.a;
			return 'Head on branch moved: ' + $author$project$Model$BuildPlanner$Error$HeadOnBranchMovedError$message(error);
		case 4:
			var error = buildPlannerError.a;
			return 'No changes since last commit: ' + $author$project$Model$BuildPlanner$Error$NoChangesSinceLastCommitError$message(error);
		case 5:
			var error = buildPlannerError.a;
			return 'Not found: ' + $author$project$Model$BuildPlanner$Error$NotFoundError$message(error);
		case 6:
			var error = buildPlannerError.a;
			return 'Parse error: ' + $author$project$Model$BuildPlanner$Error$ParseError$message(error);
		case 7:
			var error = buildPlannerError.a;
			return 'Planning error: ' + $author$project$Model$BuildPlanner$Error$PlanningError$message(error);
		case 8:
			var error = buildPlannerError.a;
			return 'Validation error: ' + $author$project$Model$BuildPlanner$Error$ValidationError$message(error);
		case 9:
			var error = buildPlannerError.a;
			return 'Invalid input error: ' + $author$project$Model$BuildPlanner$Error$InvalidInputError$message(error);
		case 10:
			var error = buildPlannerError.a;
			return 'Merge conflict: ' + $author$project$Model$BuildPlanner$Error$MergeConflictError$message(error);
		case 11:
			var error = buildPlannerError.a;
			return 'Fast forward error: ' + $author$project$Model$BuildPlanner$Error$FastForwardError$message(error);
		default:
			var error = buildPlannerError.a;
			return 'No upstream branch error: ' + $author$project$Model$BuildPlanner$Error$NoUpstreamBranchError$message(error);
	}
};
var $author$project$Pages$CreateProject$getSimplifiedErrorMessage = function (buildPlannerError) {
	switch (buildPlannerError.$) {
		case 1:
			return 'A project with that name already exists';
		case 5:
			return 'Not found';
		case 2:
			return 'Forbidden';
		default:
			return $author$project$Model$BuildPlanner$BuildPlannerError$message(buildPlannerError);
	}
};
var $author$project$Model$Permissions$orgHasUnlimitedOSAddon = $author$project$Model$Organization$addOnEnabled('unlimited_os');
var $author$project$Model$Route$projectOverviewParams = function (_v0) {
	var orgName = _v0.ix;
	var projectName = _v0.vT;
	return {g$: $elm$core$Maybe$Nothing, uk: false, DD: false, fO: $elm$core$Maybe$Nothing, gr: $elm$core$Maybe$Nothing, ix: orgName, vT: projectName};
};
var $author$project$Model$Editor$removeKeyDict = F4(
	function (getter, setter, key, editor) {
		var current = A2($author$project$Model$Editor$getField, getter, editor);
		return A3(
			$author$project$Model$Editor$setField,
			setter,
			A2($elm$core$Dict$remove, key, current),
			editor);
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$removeBundle = A2(
	$elm$core$Basics$composeL,
	$author$project$Model$BuildPlanner$SolveLegacyEditor$setBuildExprSolveEditor,
	A2($author$project$Model$Editor$removeKeyDict, $author$project$Model$BuildPlanner$SolveLegacyEditor$bundlesGetter, $author$project$Model$BuildPlanner$SolveLegacyEditor$bundlesSetter));
var $author$project$Pages$CreateProject$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Pages$CreateProject$NoOp, 'Pages/CreateProject.elm');
var $author$project$Model$LanguageVersions$getId = function (_v0) {
	var contents = _v0;
	return contents.l6;
};
var $author$project$Model$LanguageVersions$matches = F2(
	function (a, b) {
		return _Utils_eq(
			$author$project$Model$LanguageVersions$getId(a),
			$author$project$Model$LanguageVersions$getId(b));
	});
var $author$project$Model$LanguageVersions$selectFromMultiple = F2(
	function (languageVersions, version) {
		return $elm$core$List$map(
			function (curLanguageVersions) {
				return A2($author$project$Model$LanguageVersions$matches, curLanguageVersions, languageVersions) ? A2(
					$elm$core$Maybe$withDefault,
					curLanguageVersions,
					A2($author$project$Model$LanguageVersions$select, version, curLanguageVersions)) : curLanguageVersions;
			});
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$setBundles = A2(
	$elm$core$Basics$composeL,
	$author$project$Model$BuildPlanner$SolveLegacyEditor$setBuildExprSolveEditor,
	$author$project$Model$Editor$setField($author$project$Model$BuildPlanner$SolveLegacyEditor$bundlesSetter));
var $elm$core$Set$remove = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$remove, key, dict);
	});
var $author$project$Misc$toggle = F2(
	function (key, set) {
		return A2($elm$core$Set$member, key, set) ? A2($elm$core$Set$remove, key, set) : A2($elm$core$Set$insert, key, set);
	});
var $author$project$Model$Route$withCliInstructionsPlatform = F2(
	function (cliInstructionsPlatform, args) {
		return _Utils_update(
			args,
			{g$: cliInstructionsPlatform});
	});
var $krisajenkins$remotedata$RemoteData$withDefault = F2(
	function (_default, data) {
		if (data.$ === 3) {
			var x = data.a;
			return x;
		} else {
			return _default;
		}
	});
var $author$project$Model$Route$withShowAddPackagesModal = F2(
	function (showAddPackagesModal, args) {
		return _Utils_update(
			args,
			{z6: showAddPackagesModal});
	});
var $author$project$Model$Route$withShowImportPackagesModal = F2(
	function (showImportPackagesModal, args) {
		return _Utils_update(
			args,
			{z7: showImportPackagesModal});
	});
var $author$project$Pages$CreateProject$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
			case 3:
				var newName = msg.a;
				var projectNameError = $author$project$Validation$validateProjectName(
					$author$project$Validation$formatProjectName(newName));
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								vT: $elm$core$Maybe$Just(newName),
								pt: projectNameError
							})));
			case 4:
				var _new = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{bP: _new})));
			case 5:
				var v = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{p9: v})));
			case 6:
				var key = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								n9: A2($author$project$Misc$toggle, key, model.n9)
							})));
			case 7:
				var bundle = msg.a;
				var key = $author$project$Model$Ingredient$key(bundle);
				var isSelected = A2(
					$elm$core$Dict$member,
					key,
					$author$project$Model$BuildPlanner$SolveLegacyEditor$getBundles(model.qR));
				var operation = function () {
					if (isSelected) {
						return $author$project$Model$BuildPlanner$SolveLegacyEditor$removeBundle(key);
					} else {
						var requirement = $author$project$Model$BuildExprEditorUtils$fromIngredientVersion(bundle);
						return A2($author$project$Model$BuildPlanner$SolveLegacyEditor$addBundle, requirement.Y, requirement.bK);
					}
				}();
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								qR: operation(model.qR)
							})));
			case 10:
				var language = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						var metadata = response.a;
						var isMatchingLanguage = A2(
							$elm$core$List$member,
							$elm$core$Maybe$Just(language),
							A2($elm$core$List$map, $author$project$Model$LanguageVersions$getMaybeLanguage, model.fg));
						var editor = A2($author$project$Pages$CreateProject$selectDefaultBundles, metadata, model.qR);
						return isMatchingLanguage ? A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2(
								$author$project$Misc$with,
								$elm$core$Platform$Cmd$none,
								_Utils_update(
									model,
									{iS: response, qR: editor}))) : A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
					case 2:
						var err = response.a;
						return A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2(
								$author$project$Misc$with,
								A3($author$project$Pages$CreateProject$rollbar.FZ, 'OnBundlesMetadata language response', err, session),
								_Utils_update(
									model,
									{iS: response})));
					default:
						return A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2(
								$author$project$Misc$with,
								$elm$core$Platform$Cmd$none,
								_Utils_update(
									model,
									{iS: response})));
				}
			case 8:
				var editor = A3(
					$elm$core$List$foldl,
					function (req) {
						return A2($author$project$Model$BuildPlanner$SolveLegacyEditor$addBundle, req.Y, req.bK);
					},
					model.qR,
					A2(
						$elm$core$List$map,
						$author$project$Model$BuildExprEditorUtils$fromIngredientVersion,
						$elm$core$Dict$values(
							A2($krisajenkins$remotedata$RemoteData$withDefault, $elm$core$Dict$empty, model.iS))));
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{qR: editor})));
			case 9:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								qR: A2($author$project$Model$BuildPlanner$SolveLegacyEditor$setBundles, $elm$core$Dict$empty, model.qR)
							})));
			case 11:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$author$project$Routing$replaceUrl,
							model.Y,
							$author$project$Model$Route$Protected(
								$author$project$Model$Route$Home(
									{wd: $elm$core$Maybe$Nothing}))),
						model));
			case 14:
				var language = msg.a;
				var withoutBundles = A2($author$project$Model$BuildPlanner$SolveLegacyEditor$setBundles, $elm$core$Dict$empty, model.qR);
				var selectedLanguages = _List_fromArray(
					[language]);
				var newSelectedLanguages = _List_fromArray(
					[language]);
				var isInitialLanguageSelection = function () {
					var _v2 = $author$project$Model$LanguageVersions$selectedLanguageAndVersion(model.fg);
					if (!_v2.$) {
						return false;
					} else {
						return true;
					}
				}();
				var newPlatformSelection = isInitialLanguageSelection ? A2(
					$author$project$Views$PlatformSelectorSimple$default,
					$author$project$Model$LanguageVersions$selectedLanguageAndVersion(newSelectedLanguages),
					model.wW) : A2(
					$author$project$Views$PlatformSelectorSimple$filterByLanguage,
					$author$project$Model$LanguageVersions$selectedLanguageAndVersion(newSelectedLanguages),
					model.hK);
				var editorWithLanguage = A2(
					$author$project$Model$BuildPlanner$SolveLegacyEditor$setLanguages,
					$author$project$Model$BuildExprEditorUtils$toLanguagesDict(newSelectedLanguages),
					withoutBundles);
				var newEditor = A3($author$project$Pages$CreateProject$selectPlatforms, model.n4, newPlatformSelection, editorWithLanguage);
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$author$project$Pages$CreateProject$getBundlesMetadataCmd(selectedLanguages),
						_Utils_update(
							model,
							{iS: $krisajenkins$remotedata$RemoteData$Loading, qR: newEditor, hK: newPlatformSelection, fg: selectedLanguages})));
			case 13:
				var language = msg.a;
				var version = msg.b;
				var newSelectedLanguages = A3($author$project$Model$LanguageVersions$selectFromMultiple, language, version, model.fg);
				var newPlatformSelection = A2(
					$author$project$Views$PlatformSelectorSimple$filterByLanguage,
					$author$project$Model$LanguageVersions$selectedLanguageAndVersion(newSelectedLanguages),
					model.hK);
				var newEditor = A2(
					$author$project$Model$BuildPlanner$SolveLegacyEditor$setLanguages,
					$author$project$Model$BuildExprEditorUtils$toLanguagesDict(newSelectedLanguages),
					model.qR);
				var newEditorWithPlatformCheck = A3($author$project$Pages$CreateProject$selectPlatforms, model.n4, newPlatformSelection, newEditor);
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{qR: newEditorWithPlatformCheck, hK: newPlatformSelection, fg: newSelectedLanguages})));
			case 15:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{kM: !model.kM})));
			case 1:
				var nextAction = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A3($author$project$Pages$CreateProject$createProject, session, model, nextAction));
			case 2:
				if (!msg.c.$) {
					var nextAction = msg.a;
					var projectName = msg.b;
					var gotoNextRouteCmd = A2(
						$author$project$Routing$pushUrl,
						model.Y,
						function () {
							var projectRouteArgs = {
								ix: $author$project$Model$Organization$getUrlName(model.c3),
								vT: projectName
							};
							switch (nextAction) {
								case 1:
									return A2(
										$author$project$Model$Route$projectConfig,
										projectRouteArgs,
										A2($author$project$Model$Route$withShowAddPackagesModal, true, $author$project$Model$Route$projectConfigParams));
								case 2:
									return A2(
										$author$project$Model$Route$projectConfig,
										projectRouteArgs,
										A2($author$project$Model$Route$withShowImportPackagesModal, true, $author$project$Model$Route$projectConfigParams));
								default:
									return $author$project$Model$Route$projectOverview(
										A2(
											$author$project$Model$Route$withCliInstructionsPlatform,
											$elm$core$Maybe$Nothing,
											$author$project$Model$Route$projectOverviewParams(projectRouteArgs)));
							}
						}());
					var eventLabel = model.jc ? 'In an organization (new user flow)' : 'In an organization';
					var sendAnalyticsEventCmd = $author$project$Ports$sendAnalyticsEvent(
						A2(
							$author$project$Model$Analytics$withLabel,
							eventLabel,
							A2(
								$author$project$Model$Analytics$withAction,
								'Created project',
								A2(
									$author$project$Model$Analytics$withCategory,
									'Project management',
									$author$project$Model$Analytics$newEvent('Created project')))));
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[sendAnalyticsEventCmd, gotoNextRouteCmd])),
							model));
				} else {
					if (!msg.c.a.$) {
						var err = msg.c.a.a;
						return A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2(
								$author$project$Misc$with,
								A3($author$project$Pages$CreateProject$rollbar.FZ, 'ProjectCreated _ _ (Err (HttpError err))', err, session),
								A2(
									$author$project$Views$NotificationsInline$setError,
									err,
									_Utils_update(
										model,
										{A9: $elm$core$Maybe$Nothing, jV: false}))));
					} else {
						var err = msg.c.a;
						return A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2(
								$author$project$Misc$with,
								$author$project$Pages$CreateProject$focusNameField,
								_Utils_update(
									model,
									{
										A9: $elm$core$Maybe$Nothing,
										jV: false,
										pt: $elm$core$Maybe$Just(
											$author$project$Pages$CreateProject$getSimplifiedErrorMessage(err)),
										sn: true
									})));
					}
				}
			case 12:
				var choice = msg.a;
				var newPlatformSelection = A2(
					(!$author$project$Model$Permissions$orgHasUnlimitedOSAddon(model.c3)) ? $author$project$Views$PlatformSelectorSimple$chooseOne : $author$project$Views$PlatformSelectorSimple$choose,
					choice,
					model.hK);
				var newEditor = A3($author$project$Pages$CreateProject$selectPlatforms, model.n4, newPlatformSelection, model.qR);
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{qR: newEditor, m1: false, hK: newPlatformSelection})));
			case 16:
				var id = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								hT: $elm$core$Maybe$Just(id)
							}),
						$elm$core$Platform$Cmd$none));
			case 17:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					_Utils_Tuple2(
						_Utils_update(
							model,
							{hT: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none));
			case 18:
				return A2(
					$author$project$Misc$with,
					$author$project$External$ToggleOrgDropDown,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
			default:
				var orgName = msg.a;
				var route = $elm$core$Maybe$Just(
					$author$project$Model$Route$Protected(
						$author$project$Model$Route$CreateProject(
							{B2: $author$project$Model$Route$emptyCreateProjectParams, ix: orgName})));
				return A2(
					$author$project$Misc$with,
					A2($author$project$External$UpdateLastUsedOrg, orgName, route),
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
		}
	});
var $author$project$Pages$FinishSetup$Checking = {$: 1};
var $author$project$Pages$FinishSetup$Error = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$FinishSetup$OnAcceptTermsOfService = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$FinishSetup$OnResendEmailVerificationLink = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$FinishSetup$OnUsernameUpdate = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$FinishSetup$Ready = {$: 0};
var $author$project$External$SetUser = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$FinishSetup$UsernameTaken = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$FinishSetup$checkUsername = function (username) {
	return A2(
		$elm$core$Task$attempt,
		$author$project$Pages$FinishSetup$UsernameTaken(username),
		$author$project$Request$User$usernameAvailable(
			$author$project$Validation$formatUsername(username)));
};
var $author$project$Pages$FinishSetup$DebounceMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$FinishSetup$debounceConfig = {
	eO: $jinjor$elm_debounce$Debounce$later(1000),
	GN: $author$project$Pages$FinishSetup$DebounceMsg
};
var $author$project$Request$User$postAcceptTermsOfService = F2(
	function (username, creds) {
		return $author$project$Http$Extra$post(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'eulaAccepted',
								$elm$json$Json$Encode$bool(true))
							]))),
				qN: $author$project$Model$User$decode,
				CN: _List_Nil,
				GT: '/users/' + username
			});
	});
var $author$project$Pages$FinishSetup$NoOp = {$: 9};
var $author$project$Pages$FinishSetup$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Pages$FinishSetup$NoOp, 'Pages/FinishSetup.elm');
var $author$project$Model$Notification$verificationEmailSent = function (address) {
	return $author$project$Model$Notification$textSuccess('We sent a verification email to \"' + (address + '\".'));
};
var $author$project$Pages$FinishSetup$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 9:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
			case 1:
				if (!msg.a.$) {
					var user = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$Batch(
							_List_fromArray(
								[
									$author$project$External$AddNotification(
									$author$project$Model$Notification$textSuccess('Terms of Service accepted successfully')),
									$author$project$External$SetUser(
									$elm$core$Maybe$Just(user))
								])),
						A2(
							$author$project$Misc$with,
							$author$project$Pages$FinishSetup$nextRouteCmd(model),
							model));
				} else {
					var error = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(error)),
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
				}
			case 0:
				var cmd = function () {
					var _v1 = A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.AE;
						},
						$author$project$Model$Session$getUser(session));
					if (!_v1.$) {
						var username = _v1.a;
						return A2(
							$elm$core$Task$attempt,
							$author$project$Pages$FinishSetup$OnAcceptTermsOfService,
							A2(
								$author$project$Request$User$postAcceptTermsOfService,
								username,
								$author$project$Model$Session$getCreds(session)));
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, cmd, model));
			case 3:
				if (!msg.a.$) {
					var external = function () {
						var _v2 = A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.lJ;
							},
							$author$project$Model$Session$getUser(session));
						if (!_v2.$) {
							var address = _v2.a;
							return $author$project$External$AddNotification(
								$author$project$Model$Notification$verificationEmailSent(address));
						} else {
							return $author$project$External$NoOp;
						}
					}();
					return A2(
						$author$project$Misc$with,
						external,
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
				} else {
					var error = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(error)),
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
				}
			case 2:
				var cmd = function () {
					var _v3 = A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.lJ;
						},
						$author$project$Model$Session$getUser(session));
					if (!_v3.$) {
						var email = _v3.a;
						return A2(
							$elm$core$Task$attempt,
							$author$project$Pages$FinishSetup$OnResendEmailVerificationLink,
							A3($author$project$Request$Email$postResendActivation, session, email, model.dg));
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, cmd, model));
			case 4:
				var newUsername = msg.a;
				var _v4 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Pages$FinishSetup$debounceConfig, newUsername, model.lp);
				var debounce = _v4.a;
				var cmd = _v4.b;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						cmd,
						_Utils_update(
							model,
							{lp: debounce})));
			case 6:
				var msg_ = msg.a;
				var _v5 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Pages$FinishSetup$debounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast($author$project$Pages$FinishSetup$checkUsername),
					msg_,
					model.lp);
				var debounce = _v5.a;
				var cmd = _v5.b;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						cmd,
						_Utils_update(
							model,
							{lp: debounce, ge: $author$project$Pages$FinishSetup$Checking})));
			case 5:
				if (!msg.b.$) {
					var username = msg.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{ge: $author$project$Pages$FinishSetup$Ready, kc: username})));
				} else {
					var username = msg.a;
					var err = msg.b.a;
					var errorText = function () {
						var _v6 = err.mp;
						if (_v6.$ === 3) {
							var resp = _v6.a;
							var _v7 = resp.wp;
							if (_v7 === 409) {
								return 'This username is already in use.';
							} else {
								return 'Something went wrong - please try a different username.';
							}
						} else {
							return 'Something went wrong - please try a different username.';
						}
					}();
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{
									ge: $author$project$Pages$FinishSetup$Error(errorText),
									kc: username
								})));
				}
			case 7:
				var oldUser = msg.a;
				var cmd = A2(
					$elm$core$Task$attempt,
					$author$project$Pages$FinishSetup$OnUsernameUpdate,
					A2(
						$elm$core$Task$map,
						$elm$core$Basics$always(0),
						A3(
							$author$project$Request$User$postChangeUsername,
							oldUser.AE,
							model.kc,
							$author$project$Model$Session$getCreds(session))));
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, cmd, model));
			default:
				if (!msg.a.$) {
					var newUser = A2(
						$elm$core$Maybe$map,
						function (user) {
							return _Utils_update(
								user,
								{DJ: false});
						},
						$author$project$Model$Session$getUser(session));
					return A2(
						$author$project$Misc$with,
						$author$project$External$Batch(
							_List_fromArray(
								[
									$author$project$External$AddNotification(
									$author$project$Model$Notification$textSuccess('Username changed successfully')),
									$author$project$External$RenameUser(model.kc),
									$author$project$External$SetUser(newUser)
								])),
						A2(
							$author$project$Misc$with,
							$author$project$Pages$FinishSetup$nextRouteCmd(model),
							model));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A3($author$project$Pages$FinishSetup$rollbar.FZ, 'OnUsernameUpdate (Err err)', err, session)
									])),
							model));
				}
		}
	});
var $author$project$Pages$ForgotPassword$OnRequestPasswordReset = function (a) {
	return {$: 1, a: a};
};
var $author$project$Request$User$postRequestPasswordReset = function (address) {
	return $author$project$Http$Extra$post(
		{iO: $author$project$Http$Extra$None, sY: $author$project$Http$Extra$emptyJsonBody, qN: $author$project$Model$Message$decode, CN: _List_Nil, GT: $author$project$Http$Extra$urlBase + ('/request-reset/' + address)});
};
var $author$project$Pages$ForgotPassword$NoOp = {$: 0};
var $author$project$Pages$ForgotPassword$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Pages$ForgotPassword$NoOp, 'Pages/ForgotPassword.elm');
var $author$project$Ports$setUrlParameter = _Platform_outgoingPort(
	'setUrlParameter',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$string(a),
					$elm$json$Json$Encode$string(b)
				]));
	});
var $author$project$Routing$setQueryParam = F2(
	function (key, value) {
		return $author$project$Ports$setUrlParameter(
			_Utils_Tuple2(key, value));
	});
var $author$project$Pages$ForgotPassword$validateEmail = function (email) {
	return $elm$core$String$isEmpty(email) ? $elm$core$Maybe$Just('Please provide an email address') : $elm$core$Maybe$Nothing;
};
var $author$project$Pages$ForgotPassword$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 0:
				return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
			case 3:
				var error = $author$project$Pages$ForgotPassword$validateEmail(model.lJ);
				var analyticsCmd = $author$project$Ports$sendAnalyticsEvent(
					A2(
						$author$project$Model$Analytics$withAction,
						'Forgot password',
						A2(
							$author$project$Model$Analytics$withCategory,
							$author$project$Model$Analytics$categoryAuthentication,
							$author$project$Model$Analytics$newEvent('Forgot password'))));
				if (error.$ === 1) {
					return A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									$elm$core$Task$attempt,
									$author$project$Pages$ForgotPassword$OnRequestPasswordReset,
									$author$project$Request$User$postRequestPasswordReset(model.lJ)),
									analyticsCmd,
									A2($author$project$Routing$setQueryParam, 'email', model.lJ)
								])),
						$author$project$Views$NotificationsInline$clear(
							_Utils_update(
								model,
								{lJ: '', yd: error, jV: true})));
				} else {
					return A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{yd: error}));
				}
			case 1:
				if (!msg.a.$) {
					var message = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						A2(
							$author$project$Views$NotificationsInline$setSuccessText,
							message.Eh,
							_Utils_update(
								model,
								{jV: false})));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$Misc$with,
						A3($author$project$Pages$ForgotPassword$rollbar.FZ, 'OnRequestPasswordReset (Err err)', err, session),
						A2(
							$author$project$Views$NotificationsInline$setError,
							err,
							_Utils_update(
								model,
								{jV: false})));
				}
			default:
				var newEmail = msg.a;
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					_Utils_update(
						model,
						{lJ: newEmail}));
		}
	});
var $author$project$Pages$ForkProject$NoOp = {$: 0};
var $author$project$Pages$ForkProject$OnForked = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$ForkProject$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Pages$ForkProject$NoOp, 'Pages/ForkProject.elm');
var $author$project$Pages$ForkProject$update = F3(
	function (session, msg, model) {
		var creds = $author$project$Model$Session$getCreds(session);
		switch (msg.$) {
			case 0:
				return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
			case 1:
				var _v1 = (_Utils_eq(model.pt, $elm$core$Maybe$Nothing) && (!model.jV)) ? _Utils_Tuple2(
					A2(
						$elm$core$Task$attempt,
						$author$project$Pages$ForkProject$OnForked,
						A4(
							$author$project$Request$Project$fork,
							creds,
							model.pR,
							$author$project$Model$Project$getName(model.hU),
							A4(
								$author$project$Model$ProjectFork$new,
								model.jQ,
								model.b4,
								model.cd,
								$elm$core$Maybe$Just(model.op)))),
					true) : _Utils_Tuple2($elm$core$Platform$Cmd$none, false);
				var forkProjectRequest = _v1.a;
				var formSubmitting = _v1.b;
				return A2(
					$author$project$Misc$with,
					forkProjectRequest,
					$author$project$Views$NotificationsInline$clear(
						_Utils_update(
							model,
							{jV: formSubmitting, sm: true})));
			case 2:
				var newName = msg.a;
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					$author$project$Views$NotificationsInline$clear(
						_Utils_update(
							model,
							{
								op: $author$project$Validation$formatProjectName(newName),
								j0: newName,
								pt: $author$project$Validation$validateProjectName(
									$author$project$Validation$formatProjectName(newName))
							})));
			case 3:
				return _Utils_Tuple2(
					model,
					A2(
						$author$project$Routing$replaceUrl,
						model.Y,
						A2(
							$author$project$Model$Route$projectConfig,
							{
								ix: model.pR,
								vT: $author$project$Model$Project$getName(model.hU)
							},
							$author$project$Model$Route$projectConfigParams)));
			case 4:
				if (!msg.a.$) {
					return _Utils_Tuple2(
						model,
						A2(
							$author$project$Routing$replaceUrl,
							model.Y,
							A2(
								$author$project$Model$Route$projectConfig,
								{ix: model.jQ, vT: model.op},
								$author$project$Model$Route$projectConfigParams)));
				} else {
					var err = msg.a.a;
					var newModel = _Utils_update(
						model,
						{jV: false});
					var _v2 = ($author$project$Http$Extra$statusCode(err) === '409') ? A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						A2($author$project$Views$NotificationsInline$setErrorText, 'A project with this name already exists in the ' + (model.jQ + ' organization.'), newModel)) : A2(
						$author$project$Misc$with,
						A3($author$project$Pages$ForkProject$rollbar.FZ, 'OnForked (Err err)', err, session),
						A2($author$project$Views$NotificationsInline$setError, err, newModel));
					var finalModel = _v2.a;
					var cmd = _v2.b;
					return A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Misc$scrollToTop($author$project$Pages$ForkProject$NoOp),
									cmd
								])),
						finalModel);
				}
			case 6:
				var bool = msg.a;
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					_Utils_update(
						model,
						{cd: bool}));
			case 7:
				var tracking = msg.a;
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					_Utils_update(
						model,
						{GM: tracking}));
			default:
				var destOrgUrlName = msg.a;
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					_Utils_update(
						model,
						{jQ: destOrgUrlName}));
		}
	});
var $author$project$Model$PackageImport$Formatted = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$ImportProject$NoOp = {$: 0};
var $author$project$Pages$ImportProject$OnImport = F3(
	function (a, b, c) {
		return {$: 18, a: a, b: b, c: c};
	});
var $author$project$Pages$ImportProject$ProjectCreated = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$ImportProject$ReviewPackages = 1;
var $author$project$Model$Analytics$categoryConfiguration = 'Project Configuration';
var $author$project$Pages$ImportProject$repoSourceToURL = function (repoSource) {
	if (!repoSource.$) {
		var repoURL = repoSource.a;
		return repoURL;
	} else {
		var repoURL = repoSource.a;
		return repoURL;
	}
};
var $author$project$Pages$ImportProject$generateProjectName = F2(
	function (model, repoURL) {
		var newName = function () {
			if (model.ps) {
				return model.vT;
			} else {
				var _v0 = $elm$core$List$head(
					$elm$core$List$reverse(
						A2(
							$elm$core$String$split,
							'/',
							$author$project$Pages$ImportProject$repoSourceToURL(repoURL))));
				if (!_v0.$) {
					var repoName = _v0.a;
					return repoName + '-runtime';
				} else {
					return 'github-repo-runtime';
				}
			}
		}();
		var nameError = $author$project$Validation$validateProjectName(
			$author$project$Validation$formatProjectName(newName));
		return _Utils_update(
			model,
			{vT: newName, pt: nameError});
	});
var $krisajenkins$remotedata$RemoteData$isLoading = function (data) {
	if (data.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pages$ImportProject$isRepoTextInput = function (s) {
	if (!s.$) {
		return false;
	} else {
		return true;
	}
};
var $krisajenkins$remotedata$RemoteData$map = F2(
	function (f, data) {
		switch (data.$) {
			case 3:
				var value = data.a;
				return $krisajenkins$remotedata$RemoteData$Success(
					f(value));
			case 1:
				return $krisajenkins$remotedata$RemoteData$Loading;
			case 0:
				return $krisajenkins$remotedata$RemoteData$NotAsked;
			default:
				var error = data.a;
				return $krisajenkins$remotedata$RemoteData$Failure(error);
		}
	});
var $krisajenkins$remotedata$RemoteData$toMaybe = A2(
	$elm$core$Basics$composeR,
	$krisajenkins$remotedata$RemoteData$map($elm$core$Maybe$Just),
	$krisajenkins$remotedata$RemoteData$withDefault($elm$core$Maybe$Nothing));
var $author$project$Pages$ImportProject$getImportErrors = function (selectedRepo) {
	var someErrors = A2(
		$elm$core$List$any,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.mY;
			},
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.yf;
				},
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$length,
					$elm$core$Basics$neq(0)))),
		A2($elm$core$List$filterMap, $krisajenkins$remotedata$RemoteData$toMaybe, selectedRepo.fm));
	var successWithErrors = someErrors && A2(
		$elm$core$List$any,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.mY;
			},
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.CV;
				},
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$length,
					$elm$core$Basics$neq(0)))),
		A2($elm$core$List$filterMap, $krisajenkins$remotedata$RemoteData$toMaybe, selectedRepo.fm));
	var noSupportedLanguages = (!$author$project$Pages$ImportProject$isRepoTextInput(selectedRepo.kr)) && ($elm$core$List$length(selectedRepo.aM) <= 0);
	var missingReqsFile = ($elm$core$List$length(selectedRepo.fm) <= 0) && (A2(
		$elm$core$List$all,
		A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$isLoading, $elm$core$Basics$not),
		selectedRepo.fm) && (!(!$elm$core$List$length(selectedRepo.aM))));
	var missingLangsOrReqsFiles = $author$project$Pages$ImportProject$isRepoTextInput(selectedRepo.kr) && ($elm$core$List$length(selectedRepo.fm) <= 0);
	return {ry: missingLangsOrReqsFiles, rz: missingReqsFile, o9: noSupportedLanguages, sw: successWithErrors};
};
var $author$project$Model$Analytics$withValue2 = F2(
	function (value2, event) {
		return _Utils_update(
			event,
			{w$: value2});
	});
var $author$project$Pages$ImportProject$getImportAnalyticsCmd = F2(
	function (repoURL, model) {
		if (model.hk > 0) {
			return $elm$core$Platform$Cmd$none;
		} else {
			var _v0 = A2($elm$core$Dict$get, repoURL, model.fx);
			if (_v0.$ === 1) {
				return $elm$core$Platform$Cmd$none;
			} else {
				var repo = _v0.a;
				var addSuccessAndFailure = F2(
					function (_v2, _v3) {
						var importedPackages = _v2.CV;
						var errors = _v2.yf;
						var nbrSuccessAcc = _v3.a;
						var nbrFailureAcc = _v3.b;
						return _Utils_Tuple2(
							$elm$core$List$length(importedPackages) + nbrSuccessAcc,
							$elm$core$List$length(errors) + nbrFailureAcc);
					});
				var _v1 = A3(
					$elm$core$List$foldl,
					addSuccessAndFailure,
					_Utils_Tuple2(0, 0),
					A2(
						$elm$core$List$map,
						function ($) {
							return $.mY;
						},
						A2($elm$core$List$filterMap, $krisajenkins$remotedata$RemoteData$toMaybe, repo.fm)));
				var nbrSuccess = _v1.a;
				var nbrFailure = _v1.b;
				var importErrors = $author$project$Pages$ImportProject$getImportErrors(repo);
				var baseEvent = A2(
					$author$project$Model$Analytics$withLabel,
					repoURL,
					A2(
						$author$project$Model$Analytics$withCategory,
						'Project management',
						$author$project$Model$Analytics$newEvent('Create a project - GitHub import error')));
				return importErrors.rz ? $author$project$Ports$sendAnalyticsEvent(
					A2($author$project$Model$Analytics$withAction, 'GitHub import error - no file', baseEvent)) : (importErrors.o9 ? $author$project$Ports$sendAnalyticsEvent(
					A2($author$project$Model$Analytics$withAction, 'GitHub import error - no supported language', baseEvent)) : ($elm_community$maybe_extra$Maybe$Extra$isJust(repo.yd) ? $author$project$Ports$sendAnalyticsEvent(
					A2($author$project$Model$Analytics$withAction, 'GitHub import API error', baseEvent)) : (importErrors.ry ? $author$project$Ports$sendAnalyticsEvent(
					A2($author$project$Model$Analytics$withAction, 'GitHub import error (custom repo URL) - no supported language and no file', baseEvent)) : (importErrors.sw ? $author$project$Ports$sendAnalyticsEvent(
					A2(
						$author$project$Model$Analytics$withValue2,
						nbrSuccess + nbrFailure,
						A2(
							$author$project$Model$Analytics$withValue,
							nbrFailure,
							A2($author$project$Model$Analytics$withAction, 'GitHub import error - parse file', baseEvent)))) : $author$project$Ports$sendAnalyticsEvent(
					A2(
						$author$project$Model$Analytics$withValue,
						nbrSuccess,
						A2(
							$author$project$Model$Analytics$withLabel,
							repoURL,
							A2(
								$author$project$Model$Analytics$withAction,
								'GitHub import success',
								A2(
									$author$project$Model$Analytics$withCategory,
									'Project management',
									$author$project$Model$Analytics$newEvent('Create a project - GitHub import success'))))))))));
			}
		}
	});
var $author$project$Model$MonoGit$RepositoryRequirement$getRepoReqs = function (_v0) {
	var rr = _v0;
	return rr.FF;
};
var $author$project$Model$MonoGit$RepositoryRequirement$getReqLanguage = function (_v0) {
	var rr = _v0;
	return rr.aC;
};
var $author$project$Pages$ImportProject$getSimplifiedErrorMessage = function (buildPlannerError) {
	switch (buildPlannerError.$) {
		case 1:
			return 'A project with that name already exists';
		case 5:
			return 'Not found';
		case 2:
			return 'Forbidden';
		default:
			return $author$project$Model$BuildPlanner$BuildPlannerError$message(buildPlannerError);
	}
};
var $author$project$Model$PackageImport$Changeset = F2(
	function (importedPackages, errors) {
		return {yf: errors, CV: importedPackages};
	});
var $author$project$Model$PackageImport$ImportError = F2(
	function (errorText, packageText) {
		return {ye: errorText, zB: packageText};
	});
var $author$project$Model$PackageImport$decodeError = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'packageText',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'errorText',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Model$PackageImport$ImportError)));
var $author$project$Model$PackageImport$decodeKeyAndConstraint = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Model$BuildPlanner$BuildExpr$Solve$Requirement$KeyAndConstraint,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'requirement',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'namespace',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($elm$core$Tuple$pair))),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'version_constraints',
		$elm$json$Json$Decode$list($author$project$Model$BuildPlanner$BuildExpr$Solve$VersionRequirement$decodeLegacy),
		_List_Nil,
		$elm$json$Json$Decode$succeed($author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$fromVersionRequirements)));
var $author$project$Model$PackageImport$decodeChangeset = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'errors',
	$elm$json$Json$Decode$list($author$project$Model$PackageImport$decodeError),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'changeset',
		$elm$json$Json$Decode$list($author$project$Model$PackageImport$decodeKeyAndConstraint),
		$elm$json$Json$Decode$succeed($author$project$Model$PackageImport$Changeset)));
var $author$project$Request$PackageImport$encodeRequestBody = F2(
	function (language, importText) {
		var _v0 = function () {
			if (importText.$ === 1) {
				var t = importText.a;
				return _Utils_Tuple2(t, true);
			} else {
				var t = importText.a;
				return _Utils_Tuple2(t, false);
			}
		}();
		var text = _v0.a;
		var unformatted = _v0.b;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'requirements',
					$elm$json$Json$Encode$string(text)),
					_Utils_Tuple2(
					'language',
					$elm$json$Json$Encode$string(
						$author$project$Model$Language$toString(language))),
					_Utils_Tuple2(
					'unformatted',
					$elm$json$Json$Encode$bool(unformatted))
				]));
	});
var $author$project$Request$PackageImport$importPackages = F3(
	function (_v0, language, importText) {
		return $author$project$Http$Extra$post(
			{
				iO: $author$project$Http$Extra$None,
				sY: $author$project$Http$Extra$jsonBody(
					A2($author$project$Request$PackageImport$encodeRequestBody, language, importText)),
				qN: $author$project$Model$PackageImport$decodeChangeset,
				CN: _List_Nil,
				GT: '/sv/reqsvc/reqs'
			});
	});
var $author$project$Pages$ImportProject$onUrlUpdate = F2(
	function (model, repoInfo) {
		var url = $author$project$Pages$ImportProject$repoSourceToURL(repoInfo.kr);
		var repoImportData = A2($elm$core$Dict$member, url, model.fx) ? model.fx : A3($elm$core$Dict$insert, url, repoInfo, model.fx);
		return _Utils_update(
			model,
			{
				fx: repoImportData,
				gA: $elm$core$Maybe$Just(repoInfo.kr),
				pB: $elm$core$Maybe$Nothing
			});
	});
var $author$project$Pages$ImportProject$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Pages$ImportProject$NoOp, 'Pages/ImportProject.elm');
var $author$project$Pages$ImportProject$OnRepoReqs = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Model$MonoGit$RepositoryRequirement$RepoRequirements = $elm$core$Basics$identity;
var $author$project$Model$MonoGit$RepositoryRequirement$RepoRequirementsInternal = F2(
	function (language, requirements) {
		return {aC: language, FF: requirements};
	});
var $author$project$Model$MonoGit$RepositoryRequirement$decode = $elm$json$Json$Decode$list(
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Basics$identity,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'requirements',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'language',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Model$MonoGit$RepositoryRequirement$RepoRequirementsInternal)))));
var $author$project$Request$MonoGit$getReposReqsStr = F2(
	function (creds, repoURL) {
		return $author$project$Http$Extra$get(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$emptyBody,
				qN: $author$project$Model$MonoGit$RepositoryRequirement$decode,
				CN: _List_Nil,
				GT: A2(
					$elm$url$Url$Builder$absolute,
					_List_fromArray(
						[
							'git',
							'repo',
							'requirements',
							$elm$url$Url$percentEncode(repoURL)
						]),
					_List_Nil)
			});
	});
var $author$project$Pages$ImportProject$scanRepoCmd = F3(
	function (model, creds, repoSourceURL) {
		var repoURL = $author$project$Pages$ImportProject$repoSourceToURL(repoSourceURL);
		var alreadyQueried = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.fm;
					},
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$length,
						$elm$core$Basics$neq(0))),
				A2($elm$core$Dict$get, repoURL, model.fx)));
		return (!alreadyQueried) ? A2(
			$elm$core$Task$attempt,
			$author$project$Pages$ImportProject$OnRepoReqs(repoSourceURL),
			A2($author$project$Request$MonoGit$getReposReqsStr, creds, repoURL)) : $elm$core$Platform$Cmd$none;
	});
var $author$project$Model$MonoGit$Login$repositories = function (_v0) {
	var l = _v0;
	return l.r8;
};
var $author$project$Pages$ImportProject$filterRepos = F2(
	function (repoURLFilter, gitRepo) {
		var repoURLFilterLower = $elm$core$String$toLower(repoURLFilter);
		return A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Model$MonoGit$Repository$name,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$String$toLower,
					$elm$core$String$contains(repoURLFilterLower))),
			$author$project$Model$MonoGit$Login$repositories(gitRepo));
	});
var $author$project$Model$MonoGit$Repository$url = function (_v0) {
	var r = _v0;
	return r.GT;
};
var $author$project$Pages$ImportProject$isSelected = F2(
	function (repoURLInput, repo) {
		if ((!repoURLInput.$) && (!repoURLInput.a.$)) {
			var repoURL = repoURLInput.a.a;
			return _Utils_eq(
				repoURL,
				$author$project$Model$MonoGit$Repository$url(repo));
		} else {
			return false;
		}
	});
var $author$project$Pages$ImportProject$updateExpandedLogins = function (model) {
	var isFilteredOrSelected = function (login) {
		return (!$elm$core$List$isEmpty(
			A2($author$project$Pages$ImportProject$filterRepos, model.hd, login))) || A2(
			$elm$core$List$any,
			$author$project$Pages$ImportProject$isSelected(model.gA),
			$author$project$Model$MonoGit$Login$repositories(login));
	};
	return _Utils_update(
		model,
		{
			i1: $elm$core$String$isEmpty(model.hd) ? model.i1 : $elm$core$Set$fromList(
				A2(
					$elm$core$List$map,
					$author$project$Model$MonoGit$Login$getLogin,
					A2($elm$core$List$filter, isFilteredOrSelected, model.kR)))
		});
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$packagesGetter = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.FF;
	},
	function ($) {
		return $.mY;
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$packagesSetter = F2(
	function (packages, fields) {
		var requirements = fields.FF;
		return _Utils_update(
			fields,
			{
				FF: _Utils_update(
					requirements,
					{mY: packages})
			});
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$addPackage = function (key) {
	return A2(
		$elm$core$Basics$composeL,
		$author$project$Model$BuildPlanner$SolveLegacyEditor$setBuildExprSolveEditor,
		A3($author$project$Model$Editor$addKeyDict, $author$project$Model$BuildPlanner$SolveLegacyEditor$packagesGetter, $author$project$Model$BuildPlanner$SolveLegacyEditor$packagesSetter, key));
};
var $author$project$Pages$ImportProject$packagesFromChangeset = F2(
	function (selectedLanguages, repoImportData) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (x, a) {
					var newPackages = A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.mY;
						},
						function ($) {
							return $.CV;
						});
					var languageName = A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.aC;
						},
						$elm$core$String$toLower);
					var isIncluded = function (repoImport) {
						return $elm$core$List$length(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Model$LanguageVersions$getName,
									$elm$core$Basics$eq(
										languageName(repoImport))),
								selectedLanguages)) > 0;
					};
					if (x.$ === 3) {
						var repoImport = x.a;
						return isIncluded(repoImport) ? A2(
							$elm$core$List$append,
							a,
							newPackages(repoImport)) : a;
					} else {
						return a;
					}
				}),
			_List_Nil,
			repoImportData);
	});
var $author$project$Pages$ImportProject$updateLanguageData = F2(
	function (model, language) {
		var newSelectedLanguages = _List_fromArray(
			[language]);
		var isInitialLanguageSelection = _Utils_eq(
			$author$project$Model$LanguageVersions$selectedLanguageAndVersion(model.fg),
			$elm$core$Maybe$Nothing);
		var newPlatformSelection = isInitialLanguageSelection ? A2(
			$author$project$Views$PlatformSelectorSimple$default,
			$author$project$Model$LanguageVersions$selectedLanguageAndVersion(newSelectedLanguages),
			model.wW) : A2(
			$author$project$Views$PlatformSelectorSimple$filterByLanguage,
			$author$project$Model$LanguageVersions$selectedLanguageAndVersion(newSelectedLanguages),
			model.hK);
		var importedPackages = function () {
			var getReqs = function (repoURL) {
				return A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.fm;
							},
							$author$project$Pages$ImportProject$packagesFromChangeset(newSelectedLanguages)),
						A2($elm$core$Dict$get, repoURL, model.fx)));
			};
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.kr;
						},
						A2($elm$core$Basics$composeR, $author$project$Pages$ImportProject$repoSourceToURL, getReqs)),
					A2(
						$elm$core$Maybe$andThen,
						function (repoSource) {
							return A2(
								$elm$core$Dict$get,
								$author$project$Pages$ImportProject$repoSourceToURL(repoSource),
								model.fx);
						},
						model.gA)));
		}();
		var editorWithLanguage = A2(
			$author$project$Model$BuildPlanner$SolveLegacyEditor$setLanguages,
			$author$project$Model$BuildExprEditorUtils$toLanguagesDict(newSelectedLanguages),
			$author$project$Model$Editor$init(
				$author$project$Model$BuildPlanner$BuildExprEditor$Simple$init($elm$core$Maybe$Nothing)));
		var newEditor = A3($author$project$Pages$ImportProject$selectPlatforms, model.n4, newPlatformSelection, editorWithLanguage);
		var editorWithImportedPackages = A3(
			$elm$core$List$foldl,
			function (req) {
				return A2($author$project$Model$BuildPlanner$SolveLegacyEditor$addPackage, req.Y, req.bK);
			},
			newEditor,
			importedPackages);
		var newModel = _Utils_update(
			model,
			{qR: editorWithImportedPackages, hK: newPlatformSelection, fg: newSelectedLanguages});
		return newModel;
	});
var $author$project$Validation$validateGithubRepoUrl = function () {
	var urlParts = function (url) {
		return A2($elm$core$String$split, '/', url);
	};
	var urlSegmentsLength = function (url) {
		return $elm$core$List$length(
			urlParts(url));
	};
	var urlFormatMsg = 'GitHub url must be of the format \'https://github.com/{org|username}/{reponame}\'';
	var removeTrailingSlash = function (url) {
		return A2($elm$core$String$endsWith, '/', url) ? A2($elm$core$String$dropRight, 1, url) : url;
	};
	return $author$project$Validation$runValidations(
		_List_fromArray(
			[
				_Utils_Tuple2($elm$core$String$isEmpty, 'Please provide a URL: ' + urlFormatMsg),
				_Utils_Tuple2(
				A2(
					$elm$core$Basics$composeL,
					$elm$core$Basics$not,
					$elm$core$String$contains('https://github.com')),
				'Invalid Repo Url: ' + urlFormatMsg),
				_Utils_Tuple2(
				A2(
					$elm$core$Basics$composeL,
					A2(
						$elm$core$Basics$composeL,
						A2(
							$elm$core$Basics$composeL,
							$elm$core$Basics$not,
							$elm$core$Basics$eq(5)),
						urlSegmentsLength),
					removeTrailingSlash),
				'Invalid Repo Url: ' + urlFormatMsg)
			]));
}();
var $author$project$Pages$ImportProject$update = F3(
	function (session, msg, model) {
		var focusNameField = A2(
			$elm$core$Task$attempt,
			$elm$core$Basics$always($author$project$Pages$ImportProject$NoOp),
			$elm$browser$Browser$Dom$focus('project-name'));
		var creds = $author$project$Model$Session$getCreds(session);
		switch (msg.$) {
			case 0:
				return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
			case 3:
				var newName = msg.a;
				var newModel = _Utils_update(
					model,
					{vT: newName, ps: true});
				return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, newModel);
			case 4:
				var _new = msg.a;
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					_Utils_update(
						model,
						{bP: _new}));
			case 6:
				var v = msg.a;
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					_Utils_update(
						model,
						{p9: v}));
			case 5:
				var nameError = $author$project$Validation$validateProjectName(
					$author$project$Validation$formatProjectName(model.vT));
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					_Utils_update(
						model,
						{
							vT: $author$project$Validation$formatProjectName(model.vT),
							ps: true,
							pt: nameError
						}));
			case 8:
				return A2(
					$author$project$Misc$with,
					A2(
						$author$project$Routing$replaceUrl,
						model.Y,
						$author$project$Model$Route$Protected(
							$author$project$Model$Route$Org(
								{
									ix: model.c3.AC,
									vI: $author$project$Model$Route$OrgIndex($elm$core$Maybe$Nothing)
								}))),
					model);
			case 11:
				var language = msg.a;
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					A2($author$project$Pages$ImportProject$updateLanguageData, model, language));
			case 12:
				var repoURLFilter = msg.a;
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					$author$project$Pages$ImportProject$updateExpandedLogins(
						_Utils_update(
							model,
							{
								hd: $elm$core$String$trim(repoURLFilter)
							})));
			case 13:
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					$author$project$Pages$ImportProject$updateExpandedLogins(
						_Utils_update(
							model,
							{hd: ''})));
			case 14:
				var login = msg.a;
				var toggleExpanded = A2($elm$core$Set$member, login, model.i1) ? $elm$core$Set$remove : $elm$core$Set$insert;
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					_Utils_update(
						model,
						{
							i1: A2(toggleExpanded, login, model.i1)
						}));
			case 15:
				var repoSource = msg.a;
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					A2($author$project$Pages$ImportProject$onUrlUpdate, model, repoSource));
			case 16:
				var repoSource = msg.a;
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					A2($author$project$Pages$ImportProject$onUrlUpdate, model, repoSource));
			case 10:
				var language = msg.a;
				var version = msg.b;
				var newSelectedLanguages = A3($author$project$Model$LanguageVersions$selectFromMultiple, language, version, model.fg);
				var newPlatformSelection = A2(
					$author$project$Views$PlatformSelectorSimple$filterByLanguage,
					$author$project$Model$LanguageVersions$selectedLanguageAndVersion(newSelectedLanguages),
					model.hK);
				var newEditor = A2(
					$author$project$Model$BuildPlanner$SolveLegacyEditor$setLanguages,
					$author$project$Model$BuildExprEditorUtils$toLanguagesDict(newSelectedLanguages),
					model.qR);
				var newEditorWithPlatformCheck = A3($author$project$Pages$ImportProject$selectPlatforms, model.n4, newPlatformSelection, newEditor);
				var newAvailableLanguages = A3($author$project$Model$LanguageVersions$selectFromMultiple, language, version, model.jF);
				var newModel = _Utils_update(
					model,
					{jF: newAvailableLanguages, qR: newEditorWithPlatformCheck, hK: newPlatformSelection, fg: newSelectedLanguages});
				return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, newModel);
			case 19:
				var previousStep = function () {
					var _v1 = model.f1;
					switch (_v1) {
						case 0:
							return 0;
						case 1:
							return 0;
						default:
							return 1;
					}
				}();
				return A2(
					$author$project$Misc$with,
					$author$project$Misc$scrollToTop($author$project$Pages$ImportProject$NoOp),
					_Utils_update(
						model,
						{f1: previousStep}));
			case 7:
				var nextStep = msg.a;
				switch (nextStep) {
					case 1:
						var _v3 = function () {
							var _v4 = model.gA;
							if (!_v4.$) {
								var repoInput = _v4.a;
								var url = $author$project$Pages$ImportProject$repoSourceToURL(repoInput);
								var validationError = $author$project$Validation$validateGithubRepoUrl(url);
								var hasValidURL = $elm_community$maybe_extra$Maybe$Extra$isNothing(validationError);
								if (hasValidURL) {
									var queryCmd = A3($author$project$Pages$ImportProject$scanRepoCmd, model, creds, repoInput);
									var analyticsCmd = $author$project$Ports$sendAnalyticsEvent(
										A2(
											$author$project$Model$Analytics$withLabel,
											url,
											A2(
												$author$project$Model$Analytics$withAction,
												'GitHub repository scanned',
												A2(
													$author$project$Model$Analytics$withCategory,
													$author$project$Model$Analytics$categoryConfiguration,
													$author$project$Model$Analytics$newEvent('GitHub repository scanned')))));
									return A2(
										$author$project$Misc$with,
										$elm$core$Platform$Cmd$batch(
											_List_fromArray(
												[
													queryCmd,
													$author$project$Misc$scrollToTop($author$project$Pages$ImportProject$NoOp),
													analyticsCmd
												])),
										_Utils_update(
											model,
											{hk: model.hk + 1, f1: 1}));
								} else {
									return A2(
										$author$project$Misc$with,
										$elm$core$Platform$Cmd$none,
										_Utils_update(
											model,
											{f1: 0, pB: validationError}));
								}
							} else {
								return A2(
									$author$project$Misc$with,
									$elm$core$Platform$Cmd$none,
									_Utils_update(
										model,
										{f1: 0}));
							}
						}();
						var newModel = _v3.a;
						var cmd = _v3.b;
						return A2($author$project$Misc$with, cmd, newModel);
					case 2:
						var modelWithName = A2(
							$elm$core$Maybe$withDefault,
							model,
							A2(
								$elm$core$Maybe$map,
								$author$project$Pages$ImportProject$generateProjectName(model),
								model.gA));
						return A2(
							$author$project$Misc$with,
							$author$project$Misc$scrollToTop($author$project$Pages$ImportProject$NoOp),
							_Utils_update(
								modelWithName,
								{f1: nextStep}));
					default:
						return A2(
							$author$project$Misc$with,
							$author$project$Misc$scrollToTop($author$project$Pages$ImportProject$NoOp),
							model);
				}
			case 1:
				var hasPlatformError = $elm$core$Set$isEmpty(
					$author$project$Model$BuildPlanner$SolveLegacyEditor$getPlatforms(model.qR));
				var hasLanguageError = $elm$core$Dict$isEmpty(
					$author$project$Model$BuildPlanner$SolveLegacyEditor$getLanguages(model.qR));
				var formattedProjectName = $author$project$Validation$formatProjectName(model.vT);
				var hasNameError = !_Utils_eq(
					$author$project$Validation$validateProjectName(formattedProjectName),
					$elm$core$Maybe$Nothing);
				var _v5 = hasNameError ? _Utils_Tuple2(focusNameField, false) : ((hasLanguageError || hasPlatformError) ? _Utils_Tuple2($elm$core$Platform$Cmd$none, false) : _Utils_Tuple2(
					A2(
						$elm$core$Task$attempt,
						$author$project$Pages$ImportProject$ProjectCreated(formattedProjectName),
						A2(
							$author$project$Request$BuildPlanner$createProject,
							creds,
							{
								k$: $author$project$Model$BuildPlanner$BuildExprEditor$Simple$toBuildExpr(model.qR),
								c: 'Project created from GitHub repository scan',
								ix: $author$project$Model$Organization$getUrlName(model.c3),
								cd: $author$project$Model$Visibility$isPrivate(model.p9),
								vT: formattedProjectName
							})),
					true));
				var cmd = _v5.a;
				var formSubmitting = _v5.b;
				return A2(
					$author$project$Misc$with,
					cmd,
					$author$project$Views$NotificationsInline$clear(
						_Utils_update(
							model,
							{jV: formSubmitting, m1: hasPlatformError})));
			case 2:
				if (!msg.b.$) {
					var projectName = msg.a;
					return A2(
						$author$project$Misc$with,
						A2(
							$author$project$Routing$replaceUrl,
							model.Y,
							A2(
								$author$project$Model$Route$projectConfig,
								{ix: model.c3.AC, vT: projectName},
								$author$project$Model$Route$projectConfigParams)),
						model);
				} else {
					if (!msg.b.a.$) {
						var err = msg.b.a.a;
						return A2(
							$author$project$Misc$with,
							A3($author$project$Pages$ImportProject$rollbar.FZ, 'ProjectCreated _ (Err (HttpError err))', err, session),
							A2(
								$author$project$Views$NotificationsInline$setError,
								err,
								_Utils_update(
									model,
									{jV: false})));
					} else {
						var err = msg.b.a;
						return A2(
							$author$project$Misc$with,
							focusNameField,
							_Utils_update(
								model,
								{
									jV: false,
									pt: $elm$core$Maybe$Just(
										$author$project$Pages$ImportProject$getSimplifiedErrorMessage(err))
								}));
					}
				}
			case 9:
				var choice = msg.a;
				var newPlatformSelection = A2($author$project$Views$PlatformSelectorSimple$choose, choice, model.hK);
				var newEditor = A3($author$project$Pages$ImportProject$selectPlatforms, model.n4, newPlatformSelection, model.qR);
				var newModel = _Utils_update(
					model,
					{qR: newEditor, m1: false, hK: newPlatformSelection});
				return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, newModel);
			case 17:
				var repoSourceURL = msg.a;
				var langsAndReqsResp = msg.b;
				var reqCmd = F2(
					function (maybeLang, importText) {
						return A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$Maybe$map,
								function (lang) {
									return A2(
										$elm$core$Task$attempt,
										A2(
											$elm$core$Basics$composeR,
											$krisajenkins$remotedata$RemoteData$fromResult,
											A2(
												$author$project$Pages$ImportProject$OnImport,
												repoSourceURL,
												$author$project$Model$Language$toString(lang))),
										A3(
											$author$project$Request$PackageImport$importPackages,
											creds,
											lang,
											$author$project$Model$PackageImport$Formatted(importText)));
								},
								maybeLang));
					});
				var repoURL = $author$project$Pages$ImportProject$repoSourceToURL(repoSourceURL);
				var error = function () {
					if (langsAndReqsResp.$ === 1) {
						var e = langsAndReqsResp.a;
						return $elm$core$Maybe$Just(e);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}();
				var updateRepoInfo = function (maybeRepoInfo) {
					return A2(
						$elm$core$Maybe$map,
						function (r) {
							return _Utils_update(
								r,
								{yd: error});
						},
						maybeRepoInfo);
				};
				var repoImportData = A3($elm$core$Dict$update, repoURL, updateRepoInfo, model.fx);
				var _v6 = function () {
					if (!langsAndReqsResp.$) {
						var langsAndReqs = langsAndReqsResp.a;
						var language = function (foundRequirements) {
							return $author$project$Model$Language$fromString(
								$elm$core$String$toLower(
									$author$project$Model$MonoGit$RepositoryRequirement$getReqLanguage(foundRequirements)));
						};
						return A2(
							$elm$core$Tuple$pair,
							$elm$core$List$length(langsAndReqs),
							A2(
								$elm$core$List$map,
								function (reqs) {
									return A2(
										reqCmd,
										language(reqs),
										$author$project$Model$MonoGit$RepositoryRequirement$getRepoReqs(reqs));
								},
								langsAndReqs));
					} else {
						var err = langsAndReqsResp.a;
						return _Utils_Tuple2(
							0,
							_List_fromArray(
								[
									A3($author$project$Pages$ImportProject$rollbar.FZ, 'OnRepoReqs repoSourceURL langsAndReqsResp', err, session)
								]));
					}
				}();
				var jobCount = _v6.a;
				var reqCmds = _v6.b;
				var nextModel = _Utils_update(
					model,
					{hk: (model.hk - 1) + jobCount, fx: repoImportData});
				var analyticsCmd = A2($author$project$Pages$ImportProject$getImportAnalyticsCmd, repoURL, nextModel);
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$batch(
						A2($elm$core$List$cons, analyticsCmd, reqCmds)),
					nextModel);
			default:
				var repoSourceURL = msg.a;
				var language = msg.b;
				var importDataResp = msg.c;
				var updatedRepoInfo = function (maybeRepoInfo) {
					var repoImport = function (change) {
						return {aC: language, mY: change};
					};
					return A2(
						$elm$core$Maybe$map,
						function (repoInfo) {
							return _Utils_update(
								repoInfo,
								{
									fm: A2(
										$elm$core$List$cons,
										A2($krisajenkins$remotedata$RemoteData$map, repoImport, importDataResp),
										repoInfo.fm)
								});
						},
						maybeRepoInfo);
				};
				var repoURL = $author$project$Pages$ImportProject$repoSourceToURL(repoSourceURL);
				var queriedLanguageVersion = A2(
					$elm_community$list_extra$List$Extra$find,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Model$LanguageVersions$getName,
						$elm$core$Basics$eq(
							$elm$core$String$toLower(language))),
					model.jF);
				var modelWithUpdatedRepoData = _Utils_update(
					model,
					{
						fx: A3($elm$core$Dict$update, repoURL, updatedRepoInfo, model.fx)
					});
				var newModel = function () {
					if (importDataResp.$ === 3) {
						return A2(
							$elm$core$Maybe$withDefault,
							modelWithUpdatedRepoData,
							A2(
								$elm$core$Maybe$map,
								$author$project$Pages$ImportProject$updateLanguageData(modelWithUpdatedRepoData),
								queriedLanguageVersion));
					} else {
						return modelWithUpdatedRepoData;
					}
				}();
				var nextModel = _Utils_update(
					newModel,
					{hk: newModel.hk - 1});
				return A2(
					$author$project$Misc$with,
					A2($author$project$Pages$ImportProject$getImportAnalyticsCmd, repoURL, nextModel),
					nextModel);
		}
	});
var $author$project$Pages$Login$OnLogin = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Login$SwitchFocus = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Login$TwoFactor = 1;
var $author$project$Pages$Login$getLoginMode = F2(
	function (err, loginMode) {
		var twoFactorEnabled = loginMode === 1;
		if (twoFactorEnabled) {
			return 1;
		} else {
			var _v0 = err.mp;
			if (_v0.$ === 3) {
				var resp = _v0.a;
				var _v1 = resp.wp;
				if (_v1 === 449) {
					return 1;
				} else {
					return 0;
				}
			} else {
				return 0;
			}
		}
	});
var $author$project$Views$AuthButton$getLoginPath = F3(
	function (csrfToken, nextRoute, inviteCode) {
		return A5($author$project$Views$AuthButton$getGithubOauthPath, 'login', csrfToken, nextRoute, inviteCode, $elm$core$Maybe$Nothing);
	});
var $author$project$Pages$Login$NoOp = {$: 0};
var $author$project$Pages$Login$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Pages$Login$NoOp, 'Pages/Index.elm');
var $author$project$Pages$Login$twoFactorId = 'two-factor';
var $author$project$Pages$Login$update = F3(
	function (session, msg, model) {
		var onLoginWorkflow = function (jwt) {
			var maybeHubspotChat = $author$project$Model$User$isPaidUser(
				$elm$core$Maybe$Just(jwt.gS)) ? $author$project$Ports$loadHubSpotChat(0) : $author$project$Ports$removeHubSpotChat(0);
			var analyticsCmd = $author$project$Ports$sendAnalyticsEvent(
				A2(
					$author$project$Model$Analytics$withLabel,
					'Email',
					A2(
						$author$project$Model$Analytics$withAction,
						'Sign in - success',
						A2(
							$author$project$Model$Analytics$withCategory,
							$author$project$Model$Analytics$categoryAuthentication,
							$author$project$Model$Analytics$newEvent('Sign in - success')))));
			return A2(
				$author$project$Misc$with,
				$author$project$External$RenewJWT(
					$elm$core$Maybe$Just(
						$author$project$Pages$Login$getNextRoute(
							{lJ: model.lJ, fs: model.dI.fs, dg: model.dg, o: model.nI}))),
				A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[analyticsCmd, maybeHubspotChat])),
					model));
		};
		var loginWorkflow = F2(
			function (creds, nextMsg) {
				var _v4 = _Utils_Tuple2(model.j6, creds.wM);
				if ((_v4.a === 1) && (_v4.b === '')) {
					var _v5 = _v4.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{
									p_: $elm$core$Maybe$Just('Please enter your code')
								})));
				} else {
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							A2(
								$elm$core$Task$attempt,
								nextMsg,
								$author$project$Request$User$login(creds)),
							$author$project$Views$NotificationsInline$clear(
								_Utils_update(
									model,
									{lX: true, p_: $elm$core$Maybe$Nothing}))));
				}
			});
		switch (msg.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
			case 1:
				var creds = msg.a;
				return A2(loginWorkflow, creds, $author$project$Pages$Login$OnLogin);
			case 2:
				if (!msg.a.$) {
					var jwt = msg.a.a;
					return onLoginWorkflow(jwt);
				} else {
					var error = msg.a.a;
					var loginMode = A2($author$project$Pages$Login$getLoginMode, error, model.j6);
					var logToRollbar = $author$project$Http$Extra$is4xxErr(error) ? _List_Nil : _List_fromArray(
						[
							A3($author$project$Pages$Login$rollbar.FZ, 'OnLogin (Err error)', error, session)
						]);
					var credentials = model.dI;
					var credsWithoutTwoFactor = _Utils_update(
						credentials,
						{wM: ''});
					var cmd = function () {
						if (!loginMode) {
							return $elm$core$Platform$Cmd$batch(logToRollbar);
						} else {
							return $elm$core$Platform$Cmd$batch(
								A2(
									$elm$core$List$cons,
									A2(
										$elm$core$Task$attempt,
										$author$project$Pages$Login$SwitchFocus,
										$elm$browser$Browser$Dom$focus($author$project$Pages$Login$twoFactorId)),
									logToRollbar));
						}
					}();
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							cmd,
							A2(
								$author$project$Views$NotificationsInline$setError,
								error,
								_Utils_update(
									model,
									{dI: credsWithoutTwoFactor, lX: false, j6: loginMode}))));
				}
			case 3:
				var username = msg.a;
				var newCreds = A2($author$project$Model$Credentials$withUsername, username, model.dI);
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{dI: newCreds})));
			case 4:
				var password = msg.a;
				var creds = model.dI;
				var newCreds = _Utils_update(
					creds,
					{ey: password});
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{dI: newCreds})));
			case 5:
				var twofactor = msg.a;
				var creds = model.dI;
				var newCreds = _Utils_update(
					creds,
					{wM: twofactor});
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{dI: newCreds})));
			case 6:
				if (!msg.a.$) {
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
				} else {
					var domError = msg.a.a;
					var cmd = function () {
						var e = domError;
						return A2($author$project$Pages$Login$rollbar.sk, e, session);
					}();
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							cmd,
							A2($author$project$Views$NotificationsInline$setErrorText, 'Could not show 2-factor auth field.  Please refresh page.  If the problem persist, contact support', model)));
				}
			case 7:
				var analyticsCmd = $author$project$Ports$sendAnalyticsEvent(
					A2(
						$author$project$Model$Analytics$withLabel,
						'GitHub',
						A2(
							$author$project$Model$Analytics$withAction,
							'Sign in - attempt',
							A2(
								$author$project$Model$Analytics$withCategory,
								$author$project$Model$Analytics$categoryAuthentication,
								$author$project$Model$Analytics$newEvent('Sign in - attempt')))));
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									analyticsCmd,
									$author$project$Ports$setCSRFCookie(0)
								])),
						_Utils_update(
							model,
							{
								mv: function (token) {
									return A3($author$project$Views$AuthButton$getLoginPath, token, model.dg, model.dI.fs);
								}
							})));
			case 8:
				var analyticsCmd = $author$project$Ports$sendAnalyticsEvent(
					A2(
						$author$project$Model$Analytics$withLabel,
						'SSO',
						A2(
							$author$project$Model$Analytics$withAction,
							'Sign in - attempt',
							A2(
								$author$project$Model$Analytics$withCategory,
								$author$project$Model$Analytics$categoryAuthentication,
								$author$project$Model$Analytics$newEvent('Sign in - attempt')))));
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									analyticsCmd,
									$author$project$Ports$setCSRFCookie(0)
								])),
						_Utils_update(
							model,
							{
								mv: function (_v3) {
									return '/api/v1/oauth/idp/login';
								}
							})));
			case 9:
				var analyticsCmd = $author$project$Ports$sendAnalyticsEvent(
					A2(
						$author$project$Model$Analytics$withLabel,
						'GitHub',
						A2(
							$author$project$Model$Analytics$withAction,
							'Create account - attempt',
							A2(
								$author$project$Model$Analytics$withCategory,
								$author$project$Model$Analytics$categoryAuthentication,
								$author$project$Model$Analytics$newEvent('Create account - attempt')))));
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									analyticsCmd,
									$author$project$Ports$setCSRFCookie(0)
								])),
						_Utils_update(
							model,
							{
								mv: function (token) {
									return A4(
										$author$project$Views$AuthButton$getSignupPath,
										token,
										model.dg,
										model.dI.fs,
										$elm$core$Maybe$Just(model.dI.AE));
								}
							})));
			default:
				var token = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$browser$Browser$Navigation$load(
							model.mv(token)),
						model));
		}
	});
var $author$project$Pages$NotFound$Dismissed = 2;
var $author$project$Pages$NotFound$Happy = 0;
var $author$project$Pages$NotFound$HideModal = 1;
var $author$project$Pages$NotFound$Visible = 1;
var $author$project$Pages$NotFound$update = F3(
	function (_v0, msg, model) {
		switch (msg) {
			case 0:
				return A2(
					$author$project$Misc$with,
					A2(
						$elm$core$Task$perform,
						function (_v2) {
							return 1;
						},
						$elm$core$Process$sleep(500)),
					_Utils_update(
						model,
						{qS: 0}));
			case 1:
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					_Utils_update(
						model,
						{j8: 2}));
			default:
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					_Utils_update(
						model,
						{j8: 1}));
		}
	});
var $author$project$Pages$OrgDependencies$Ascending = 0;
var $author$project$Pages$OrgDependencies$Descending = 1;
var $author$project$Pages$OrgDependencies$Failure = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$OrgDependencies$NoOp = {$: 11};
var $author$project$Pages$OrgDependencies$Success = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$OrgDependencies$defaultSortDireciton = 0;
var $author$project$Pages$OrgDependencies$takeIncrement = 250;
var $author$project$Model$Analytics$Fact$Dependencies$component = function (_v0) {
	var data = _v0;
	return data.cW;
};
var $author$project$Model$Analytics$DIM$Purl$purl = function (_v0) {
	var data = _v0;
	return data.k;
};
var $author$project$Model$Analytics$DIM$Purl$version = function (_v0) {
	var data = _v0;
	return data.aI;
};
var $author$project$Model$Analytics$Fact$Dependencies$cveKeyFromDep = function (_v0) {
	var data = _v0;
	return A3(
		$elm$core$Maybe$map2,
		$elm$core$Tuple$pair,
		$author$project$Model$Analytics$DIM$Purl$purl(data.cW),
		$author$project$Model$Analytics$DIM$Purl$version(data.cW));
};
var $author$project$Model$SeverityHistogram$SeverityHistogram = $elm$core$Basics$identity;
var $author$project$Model$SeverityHistogram$empty = $elm$core$Dict$empty;
var $author$project$Model$Severity$sortKey = function (severity) {
	switch (severity) {
		case 4:
			return 0;
		case 3:
			return 1;
		case 2:
			return 2;
		case 1:
			return 3;
		default:
			return 4;
	}
};
var $author$project$Model$SeverityHistogram$getCountForSeverity = F2(
	function (severity, _v0) {
		var dict = _v0;
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Dict$get,
				$author$project$Model$Severity$sortKey(severity),
				dict));
	});
var $author$project$Model$Analytics$DIM$Purl$language = function (_v0) {
	var data = _v0;
	return data.aC;
};
var $author$project$Model$Language$toDisplayString = function (language) {
	switch (language) {
		case 0:
			return 'Perl';
		case 1:
			return 'Python';
		case 2:
			return 'TCL';
		case 3:
			return 'Ruby';
		case 4:
			return 'C';
		case 6:
			return 'Java';
		default:
			return 'Go';
	}
};
var $author$project$Model$Analytics$DIM$Purl$languageDisplayString = function (lang) {
	if (!lang.$) {
		var l = lang.a;
		return $author$project$Model$Language$toDisplayString(l);
	} else {
		var l = lang.a;
		return $elm_community$string_extra$String$Extra$toTitleCase(l);
	}
};
var $author$project$Model$Analytics$DIM$Purl$name = function (_v0) {
	var data = _v0;
	return data.w;
};
var $author$project$Model$Analytics$Fact$Dependencies$projectName = function (_v0) {
	var data = _v0;
	return data.c5;
};
var $author$project$Pages$OrgDependencies$toRows = F2(
	function (histograms, dependencies) {
		var toDependencyRow = function (_v2) {
			var cveKey = _v2.a;
			var purl = cveKey.a;
			var version = cveKey.b;
			var acc = _v2.b;
			var histogram = A2(
				$elm$core$Maybe$withDefault,
				$author$project$Model$SeverityHistogram$empty,
				A2($elm$core$Dict$get, cveKey, histograms));
			var hasUnscored = A2($author$project$Model$SeverityHistogram$getCountForSeverity, 0, histogram) > 0;
			var hasMedium = A2($author$project$Model$SeverityHistogram$getCountForSeverity, 2, histogram) > 0;
			var hasLow = A2($author$project$Model$SeverityHistogram$getCountForSeverity, 1, histogram) > 0;
			var hasHigh = A2($author$project$Model$SeverityHistogram$getCountForSeverity, 3, histogram) > 0;
			var hasCritical = A2($author$project$Model$SeverityHistogram$getCountForSeverity, 4, histogram) > 0;
			return {
				q0: hasCritical,
				q1: hasHigh,
				q2: hasLow,
				q3: hasMedium,
				q4: (!hasCritical) && ((!hasHigh) && ((!hasMedium) && ((!hasLow) && (!hasUnscored)))),
				q5: hasUnscored,
				aC: acc.aC,
				w: acc.w,
				gx: $elm$core$Set$toList(acc.gx),
				k: purl,
				F2: histogram,
				aI: version
			};
		};
		var accumDep = function (dep) {
			var project = $author$project$Model$Analytics$Fact$Dependencies$projectName(dep);
			var ingredient = $author$project$Model$Analytics$Fact$Dependencies$component(dep);
			var addProject = function (maybeAcc) {
				if (maybeAcc.$ === 1) {
					return $elm$core$Maybe$Just(
						{
							aC: $author$project$Model$Analytics$DIM$Purl$languageDisplayString(
								$author$project$Model$Analytics$DIM$Purl$language(ingredient)),
							w: $author$project$Model$Analytics$DIM$Purl$name(ingredient),
							gx: $elm$core$Set$singleton(project)
						});
				} else {
					var acc = maybeAcc.a;
					return $elm$core$Maybe$Just(
						_Utils_update(
							acc,
							{
								gx: A2($elm$core$Set$insert, project, acc.gx)
							}));
				}
			};
			var _v0 = $author$project$Model$Analytics$Fact$Dependencies$cveKeyFromDep(dep);
			if (!_v0.$) {
				var cveKey = _v0.a;
				return A2($elm$core$Dict$update, cveKey, addProject);
			} else {
				return $elm$core$Basics$identity;
			}
		};
		return A2(
			$elm$core$List$map,
			toDependencyRow,
			$elm$core$Dict$toList(
				A3($elm$core$List$foldl, accumDep, $elm$core$Dict$empty, dependencies)));
	});
var $author$project$Model$SeverityHistogram$insertCount = F2(
	function (_v0, _v1) {
		var severity = _v0.ck;
		var count = _v0.cO;
		var dict = _v1;
		return (count > 0) ? A3(
			$elm$core$Dict$update,
			$author$project$Model$Severity$sortKey(severity),
			function (prev) {
				if (prev.$ === 1) {
					return $elm$core$Maybe$Just(count);
				} else {
					var n = prev.a;
					return $elm$core$Maybe$Just(n + count);
				}
			},
			dict) : dict;
	});
var $author$project$Model$SeverityHistogram$fromSeverityCounts = function (list) {
	return A3($elm$core$List$foldl, $author$project$Model$SeverityHistogram$insertCount, $author$project$Model$SeverityHistogram$empty, list);
};
var $author$project$Model$SeverityCount$singleton = function (severity) {
	return {cO: 1, ck: severity};
};
var $author$project$Model$SeverityHistogram$fromSeverities = function (list) {
	return $author$project$Model$SeverityHistogram$fromSeverityCounts(
		A2($elm$core$List$map, $author$project$Model$SeverityCount$singleton, list));
};
var $author$project$Pages$OrgDependencies$toSeverityHistograms = function (vulnsDict) {
	var accumCVE = F2(
		function (key, vulns) {
			return A2(
				$elm$core$Dict$update,
				key,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Maybe$withDefault(_List_Nil),
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Basics$append(
							A2(
								$elm$core$List$map,
								function ($) {
									return $.ck;
								},
								vulns)),
						$elm$core$Maybe$Just)));
		});
	return A2(
		$elm$core$Dict$map,
		function (_v0) {
			return $author$project$Model$SeverityHistogram$fromSeverities;
		},
		A3($elm$core$Dict$foldl, accumCVE, $elm$core$Dict$empty, vulnsDict));
};
var $author$project$Pages$OrgDependencies$update = F2(
	function (action, model) {
		switch (action.$) {
			case 11:
				return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
			case 0:
				var sortBy = action.a;
				var sortDirection = function () {
					var _v1 = _Utils_Tuple2(
						_Utils_eq(sortBy, model.nx),
						model.ny);
					if (!_v1.a) {
						return $author$project$Pages$OrgDependencies$defaultSortDireciton;
					} else {
						if (!_v1.b) {
							var _v2 = _v1.b;
							return 1;
						} else {
							var _v3 = _v1.b;
							return 0;
						}
					}
				}();
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					_Utils_update(
						model,
						{nx: sortBy, ny: sortDirection}));
			case 1:
				var searchInputValue = action.a;
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					_Utils_update(
						model,
						{kt: searchInputValue}));
			case 2:
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					_Utils_update(
						model,
						{kt: ''}));
			case 3:
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					_Utils_update(
						model,
						{lW: !model.lW}));
			case 4:
				var depsLanguages = function () {
					var _v4 = model.lx;
					if (_v4.$ === 2) {
						var depsData = _v4.a;
						return $elm$core$Set$fromList(depsData.aM);
					} else {
						return $elm$core$Set$empty;
					}
				}();
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					_Utils_update(
						model,
						{i2: true, i3: true, hw: depsLanguages, i4: true, i5: true, i6: true, jS: true}));
			case 5:
				var severity = action.a;
				var newModel = function () {
					switch (severity) {
						case 4:
							return _Utils_update(
								model,
								{i2: !model.i2});
						case 3:
							return _Utils_update(
								model,
								{i3: !model.i3});
						case 2:
							return _Utils_update(
								model,
								{i5: !model.i5});
						case 1:
							return _Utils_update(
								model,
								{i4: !model.i4});
						default:
							return _Utils_update(
								model,
								{jS: !model.jS});
					}
				}();
				return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, newModel);
			case 6:
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					_Utils_update(
						model,
						{i6: !model.i6}));
			case 7:
				var language = action.a;
				var func = A2($elm$core$Set$member, language, model.hw) ? $elm$core$Set$remove : $elm$core$Set$insert;
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					_Utils_update(
						model,
						{
							hw: A2(func, language, model.hw)
						}));
			case 8:
				if (action.a.$ === 1) {
					var err = action.a.a;
					return A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								lx: $author$project$Pages$OrgDependencies$Failure(err)
							}));
				} else {
					var data = action.a.a;
					var histograms = $author$project$Pages$OrgDependencies$toSeverityHistograms(
						A2(
							$elm$core$Dict$map,
							$elm$core$Basics$always(
								$elm$core$List$map(
									function ($) {
										return $.gY;
									})),
							data.G8));
					var depRows = _Utils_ap(
						A2($author$project$Pages$OrgDependencies$toRows, $elm$core$Dict$empty, data.l8),
						A2($author$project$Pages$OrgDependencies$toRows, histograms, data.qP));
					var languagesSet = A3(
						$elm$core$List$foldl,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.aC;
							},
							$elm$core$Set$insert),
						$elm$core$Set$empty,
						depRows);
					return A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								lx: $author$project$Pages$OrgDependencies$Success(
									{
										qP: depRows,
										aM: $elm$core$Set$toList(languagesSet)
									}),
								hw: languagesSet
							}));
				}
			case 9:
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					_Utils_update(
						model,
						{jy: model.jy + $author$project$Pages$OrgDependencies$takeIncrement}));
			default:
				return A2(
					$author$project$Misc$with,
					$author$project$Misc$scrollToTop($author$project$Pages$OrgDependencies$NoOp),
					model);
		}
	});
var $author$project$Pages$OrgIndex$ImportSBOMMsg = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Pages$OrgIndex$Loaded = 1;
var $author$project$Pages$OrgIndex$OrgOverviewMsg = function (a) {
	return {$: 9, a: a};
};
var $elm_community$string_extra$String$Extra$clean = function (string) {
	return $elm$core$String$trim(
		A3(
			$elm$regex$Regex$replace,
			$elm_community$string_extra$String$Extra$regexFromString('\\s\\s+'),
			$elm$core$Basics$always(' '),
			string));
};
var $author$project$Views$CreateProjectFromSBOM$DoSlowCreate = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Views$CreateProjectFromSBOM$OnProjectCreated = F3(
	function (a, b, c) {
		return {$: 8, a: a, b: b, c: c};
	});
var $author$project$Http$Extra$HeaderOnly = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$bytesBody = _Http_pair;
var $folkertdev$elm_flate$Flate$Dynamic = function (a) {
	return {$: 1, a: a};
};
var $folkertdev$elm_flate$Flate$WithWindowSize = function (a) {
	return {$: 1, a: a};
};
var $elm$bytes$Bytes$LE = 0;
var $elm$bytes$Bytes$Encode$Bytes = function (a) {
	return {$: 10, a: a};
};
var $elm$bytes$Bytes$Encode$bytes = $elm$bytes$Bytes$Encode$Bytes;
var $elm$bytes$Bytes$BE = 1;
var $elm$bytes$Bytes$Decode$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$bytes$Bytes$Decode$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$bytes$Bytes$Decode$Decoder = $elm$core$Basics$identity;
var $elm$bytes$Bytes$Decode$map = F2(
	function (func, _v0) {
		var decodeA = _v0;
		return F2(
			function (bites, offset) {
				var _v1 = A2(decodeA, bites, offset);
				var aOffset = _v1.a;
				var a = _v1.b;
				return _Utils_Tuple2(
					aOffset,
					func(a));
			});
	});
var $elm$bytes$Bytes$Decode$map2 = F3(
	function (func, _v0, _v1) {
		var decodeA = _v0;
		var decodeB = _v1;
		return F2(
			function (bites, offset) {
				var _v2 = A2(decodeA, bites, offset);
				var aOffset = _v2.a;
				var a = _v2.b;
				var _v3 = A2(decodeB, bites, aOffset);
				var bOffset = _v3.a;
				var b = _v3.b;
				return _Utils_Tuple2(
					bOffset,
					A2(func, a, b));
			});
	});
var $folkertdev$elm_flate$Checksum$Crc32$tinf_crc32case = function (i) {
	switch (i) {
		case 0:
			return 0;
		case 1:
			return 498536548;
		case 2:
			return 997073096;
		case 3:
			return 651767980;
		case 4:
			return 1994146192;
		case 5:
			return 1802195444;
		case 6:
			return 1303535960;
		case 7:
			return 1342533948;
		case 8:
			return 3988292384;
		case 9:
			return 4027552580;
		case 10:
			return 3604390888;
		case 11:
			return 3412177804;
		case 12:
			return 2607071920;
		case 13:
			return 2262029012;
		case 14:
			return 2685067896;
		default:
			return 3183342108;
	}
};
var $folkertdev$elm_flate$Checksum$Crc32$step = F2(
	function (_byte, crc) {
		var a = (crc ^ _byte) >>> 0;
		var b = ((a >>> 4) ^ $folkertdev$elm_flate$Checksum$Crc32$tinf_crc32case(a & 15)) >>> 0;
		var c = (b >>> 4) ^ $folkertdev$elm_flate$Checksum$Crc32$tinf_crc32case(b & 15);
		return c;
	});
var $elm$bytes$Bytes$Decode$succeed = function (a) {
	return F2(
		function (_v0, offset) {
			return _Utils_Tuple2(offset, a);
		});
};
var $elm$bytes$Bytes$Encode$getWidth = function (builder) {
	switch (builder.$) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 4;
		case 3:
			return 1;
		case 4:
			return 2;
		case 5:
			return 4;
		case 6:
			return 4;
		case 7:
			return 8;
		case 8:
			var w = builder.a;
			return w;
		case 9:
			var w = builder.a;
			return w;
		default:
			var bs = builder.a;
			return _Bytes_width(bs);
	}
};
var $elm$bytes$Bytes$Encode$write = F3(
	function (builder, mb, offset) {
		switch (builder.$) {
			case 0:
				var n = builder.a;
				return A3(_Bytes_write_i8, mb, offset, n);
			case 1:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_i16, mb, offset, n, !e);
			case 2:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_i32, mb, offset, n, !e);
			case 3:
				var n = builder.a;
				return A3(_Bytes_write_u8, mb, offset, n);
			case 4:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_u16, mb, offset, n, !e);
			case 5:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_u32, mb, offset, n, !e);
			case 6:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_f32, mb, offset, n, !e);
			case 7:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_f64, mb, offset, n, !e);
			case 8:
				var bs = builder.b;
				return A3($elm$bytes$Bytes$Encode$writeSequence, bs, mb, offset);
			case 9:
				var s = builder.b;
				return A3(_Bytes_write_string, mb, offset, s);
			default:
				var bs = builder.a;
				return A3(_Bytes_write_bytes, mb, offset, bs);
		}
	});
var $elm$bytes$Bytes$Encode$writeSequence = F3(
	function (builders, mb, offset) {
		writeSequence:
		while (true) {
			if (!builders.b) {
				return offset;
			} else {
				var b = builders.a;
				var bs = builders.b;
				var $temp$builders = bs,
					$temp$mb = mb,
					$temp$offset = A3($elm$bytes$Bytes$Encode$write, b, mb, offset);
				builders = $temp$builders;
				mb = $temp$mb;
				offset = $temp$offset;
				continue writeSequence;
			}
		}
	});
var $elm$bytes$Bytes$Decode$unsignedInt32 = function (endianness) {
	return _Bytes_read_u32(!endianness);
};
var $elm$bytes$Bytes$Decode$unsignedInt8 = _Bytes_read_u8;
var $folkertdev$elm_flate$Checksum$Crc32$crc32Help = function (_v0) {
	var remaining = _v0.r4;
	var crc = _v0.qL;
	return (remaining >= 8) ? A3(
		$elm$bytes$Bytes$Decode$map2,
		F2(
			function (word1, word2) {
				var byte8 = 255 & word2;
				var byte7 = 255 & (word2 >>> 8);
				var byte6 = 255 & (word2 >>> 16);
				var byte5 = 255 & (word2 >>> 24);
				var byte4 = 255 & word1;
				var byte3 = 255 & (word1 >>> 8);
				var byte2 = 255 & (word1 >>> 16);
				var byte1 = 255 & (word1 >>> 24);
				return $elm$bytes$Bytes$Decode$Loop(
					{
						qL: A2(
							$folkertdev$elm_flate$Checksum$Crc32$step,
							byte8,
							A2(
								$folkertdev$elm_flate$Checksum$Crc32$step,
								byte7,
								A2(
									$folkertdev$elm_flate$Checksum$Crc32$step,
									byte6,
									A2(
										$folkertdev$elm_flate$Checksum$Crc32$step,
										byte5,
										A2(
											$folkertdev$elm_flate$Checksum$Crc32$step,
											byte4,
											A2(
												$folkertdev$elm_flate$Checksum$Crc32$step,
												byte3,
												A2(
													$folkertdev$elm_flate$Checksum$Crc32$step,
													byte2,
													A2($folkertdev$elm_flate$Checksum$Crc32$step, byte1, crc)))))))),
						r4: remaining - 8
					});
			}),
		$elm$bytes$Bytes$Decode$unsignedInt32(1),
		$elm$bytes$Bytes$Decode$unsignedInt32(1)) : ((remaining > 0) ? A2(
		$elm$bytes$Bytes$Decode$map,
		function (_byte) {
			return $elm$bytes$Bytes$Decode$Loop(
				{
					qL: A2($folkertdev$elm_flate$Checksum$Crc32$step, _byte, crc),
					r4: remaining - 1
				});
		},
		$elm$bytes$Bytes$Decode$unsignedInt8) : $elm$bytes$Bytes$Decode$succeed(
		$elm$bytes$Bytes$Decode$Done((crc ^ 4294967295) >>> 0)));
};
var $elm$bytes$Bytes$Decode$decode = F2(
	function (_v0, bs) {
		var decoder = _v0;
		return A2(_Bytes_decode, decoder, bs);
	});
var $elm$bytes$Bytes$Decode$loopHelp = F4(
	function (state, callback, bites, offset) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var decoder = _v0;
			var _v1 = A2(decoder, bites, offset);
			var newOffset = _v1.a;
			var step = _v1.b;
			if (!step.$) {
				var newState = step.a;
				var $temp$state = newState,
					$temp$callback = callback,
					$temp$bites = bites,
					$temp$offset = newOffset;
				state = $temp$state;
				callback = $temp$callback;
				bites = $temp$bites;
				offset = $temp$offset;
				continue loopHelp;
			} else {
				var result = step.a;
				return _Utils_Tuple2(newOffset, result);
			}
		}
	});
var $elm$bytes$Bytes$Decode$loop = F2(
	function (state, callback) {
		return A2($elm$bytes$Bytes$Decode$loopHelp, state, callback);
	});
var $elm$bytes$Bytes$width = _Bytes_width;
var $folkertdev$elm_flate$Checksum$Crc32$tinf_crc32 = function (buffer) {
	var length = $elm$bytes$Bytes$width(buffer);
	var initialCrc = 4294967295;
	return (!length) ? 0 : A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm$bytes$Bytes$Decode$decode,
			A2(
				$elm$bytes$Bytes$Decode$loop,
				{qL: initialCrc, r4: length},
				$folkertdev$elm_flate$Checksum$Crc32$crc32Help),
			buffer));
};
var $folkertdev$elm_flate$Checksum$Crc32$crc32 = $folkertdev$elm_flate$Checksum$Crc32$tinf_crc32;
var $elm$bytes$Bytes$Decode$bytes = function (n) {
	return _Bytes_read_bytes(n);
};
var $folkertdev$elm_flate$Deflate$Internal$chunksHelp = F2(
	function (chunkSize, _v0) {
		var sizeRemaining = _v0.a;
		var accum = _v0.b;
		return (!sizeRemaining) ? $elm$bytes$Bytes$Decode$succeed(
			$elm$bytes$Bytes$Decode$Done(_List_Nil)) : ((_Utils_cmp(chunkSize, sizeRemaining) > -1) ? A2(
			$elm$bytes$Bytes$Decode$map,
			function (_new) {
				return $elm$bytes$Bytes$Decode$Done(
					$elm$core$List$reverse(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(true, _new),
							accum)));
			},
			$elm$bytes$Bytes$Decode$bytes(sizeRemaining)) : A2(
			$elm$bytes$Bytes$Decode$map,
			function (_new) {
				return $elm$bytes$Bytes$Decode$Loop(
					_Utils_Tuple2(
						sizeRemaining - chunkSize,
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(false, _new),
							accum)));
			},
			$elm$bytes$Bytes$Decode$bytes(chunkSize)));
	});
var $elm$bytes$Bytes$Encode$encode = _Bytes_encode;
var $elm$bytes$Bytes$Encode$Seq = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$getWidths = F2(
	function (width, builders) {
		getWidths:
		while (true) {
			if (!builders.b) {
				return width;
			} else {
				var b = builders.a;
				var bs = builders.b;
				var $temp$width = width + $elm$bytes$Bytes$Encode$getWidth(b),
					$temp$builders = bs;
				width = $temp$width;
				builders = $temp$builders;
				continue getWidths;
			}
		}
	});
var $elm$bytes$Bytes$Encode$sequence = function (builders) {
	return A2(
		$elm$bytes$Bytes$Encode$Seq,
		A2($elm$bytes$Bytes$Encode$getWidths, 0, builders),
		builders);
};
var $folkertdev$elm_flate$Deflate$Internal$chunks = F2(
	function (chunkSize, buffer) {
		var _v0 = A2(
			$elm$bytes$Bytes$Decode$decode,
			A2(
				$elm$bytes$Bytes$Decode$loop,
				_Utils_Tuple2(
					$elm$bytes$Bytes$width(buffer),
					_List_Nil),
				$folkertdev$elm_flate$Deflate$Internal$chunksHelp(chunkSize)),
			buffer);
		if (_v0.$ === 1) {
			return _List_fromArray(
				[
					_Utils_Tuple2(
					true,
					$elm$bytes$Bytes$Encode$encode(
						$elm$bytes$Bytes$Encode$sequence(_List_Nil)))
				]);
		} else {
			if (!_v0.a.b) {
				return _List_fromArray(
					[
						_Utils_Tuple2(
						true,
						$elm$bytes$Bytes$Encode$encode(
							$elm$bytes$Bytes$Encode$sequence(_List_Nil)))
					]);
			} else {
				var value = _v0.a;
				return value;
			}
		}
	});
var $folkertdev$elm_flate$Deflate$Internal$default_block_size = 1024 * 1024;
var $folkertdev$elm_flate$Deflate$BitWriter$empty = {hl: 0, hv: _List_Nil, wB: 0};
var $folkertdev$elm_flate$Deflate$Symbol$code = function (symbol) {
	switch (symbol.$) {
		case 1:
			var _byte = symbol.a;
			return _byte;
		case 0:
			return 256;
		default:
			var length = symbol.a;
			return ((length >= 3) && (length <= 10)) ? ((257 + length) - 3) : (((length >= 11) && (length <= 18)) ? (265 + (((length - 11) / 2) | 0)) : (((length >= 19) && (length <= 34)) ? (269 + (((length - 19) / 4) | 0)) : (((length >= 35) && (length <= 66)) ? (273 + (((length - 35) / 8) | 0)) : (((length >= 67) && (length <= 130)) ? (277 + (((length - 67) / 16) | 0)) : (((length >= 131) && (length <= 257)) ? (281 + (((length - 131) / 32) | 0)) : ((length === 258) ? 285 : (-1)))))));
	}
};
var $folkertdev$elm_flate$Deflate$Symbol$distance = function (symbol) {
	if (symbol.$ === 2) {
		var distance_ = symbol.b;
		if (distance_ <= 4) {
			return $elm$core$Maybe$Just(
				_Utils_Tuple3(distance_ - 1, 0, 0));
		} else {
			var go = F3(
				function (extraBits, code_, base) {
					go:
					while (true) {
						if (_Utils_cmp(base * 2, distance_) < 0) {
							var $temp$extraBits = extraBits + 1,
								$temp$code_ = code_ + 2,
								$temp$base = base * 2;
							extraBits = $temp$extraBits;
							code_ = $temp$code_;
							base = $temp$base;
							continue go;
						} else {
							return _Utils_Tuple3(extraBits, code_, base);
						}
					}
				});
			var _v1 = A3(go, 1, 4, 4);
			var extraBits = _v1.a;
			var code_ = _v1.b;
			var base = _v1.c;
			var delta = (distance_ - base) - 1;
			var half = (base / 2) | 0;
			return (_Utils_cmp(distance_, base + half) < 1) ? $elm$core$Maybe$Just(
				_Utils_Tuple3(
					code_,
					extraBits,
					A2($elm$core$Basics$modBy, half, delta))) : $elm$core$Maybe$Just(
				_Utils_Tuple3(
					code_ + 1,
					extraBits,
					A2($elm$core$Basics$modBy, half, delta)));
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
var $elm$core$Array$setHelp = F4(
	function (shift, index, value, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
		if (!_v0.$) {
			var subTree = _v0.a;
			var newSub = A4($elm$core$Array$setHelp, shift - $elm$core$Array$shiftStep, index, value, subTree);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$SubTree(newSub),
				tree);
		} else {
			var values = _v0.a;
			var newLeaf = A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, values);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$Leaf(newLeaf),
				tree);
		}
	});
var $elm$core$Array$set = F3(
	function (index, value, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? array : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			tree,
			A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, tail)) : A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A4($elm$core$Array$setHelp, startShift, index, value, tree),
			tail));
	});
var $folkertdev$elm_flate$Deflate$Symbol$update = F3(
	function (index, tagger, array) {
		var _v0 = A2($elm$core$Array$get, index, array);
		if (_v0.$ === 1) {
			return array;
		} else {
			var value = _v0.a;
			return A3(
				$elm$core$Array$set,
				index,
				tagger(value),
				array);
		}
	});
var $folkertdev$elm_flate$Deflate$Symbol$dynamicFindFrequencies = F2(
	function (symbol, _v0) {
		var literalCounts = _v0.a;
		var distanceCounts = _v0.b;
		var emptyDistanceCount = _v0.c;
		var _v1 = $folkertdev$elm_flate$Deflate$Symbol$distance(symbol);
		if (_v1.$ === 1) {
			return _Utils_Tuple3(
				A3(
					$folkertdev$elm_flate$Deflate$Symbol$update,
					$folkertdev$elm_flate$Deflate$Symbol$code(symbol),
					function (v) {
						return v + 1;
					},
					literalCounts),
				distanceCounts,
				emptyDistanceCount);
		} else {
			var _v2 = _v1.a;
			var d = _v2.a;
			return _Utils_Tuple3(
				A3(
					$folkertdev$elm_flate$Deflate$Symbol$update,
					$folkertdev$elm_flate$Deflate$Symbol$code(symbol),
					function (v) {
						return v + 1;
					},
					literalCounts),
				A3(
					$folkertdev$elm_flate$Deflate$Symbol$update,
					d,
					function (v) {
						return v + 1;
					},
					distanceCounts),
				false);
		}
	});
var $elm$core$Elm$JsArray$foldl = _JsArray_foldl;
var $elm$core$Array$foldl = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldl, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldl, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldl,
			func,
			A3($elm$core$Elm$JsArray$foldl, helper, baseCase, tree),
			tail);
	});
var $folkertdev$elm_flate$Huffman$calcOptimalMaxBitWidth = function (frequencies) {
	var heapModificationLoop = function (heap) {
		heapModificationLoop:
		while (true) {
			if (!heap.b) {
				return 0;
			} else {
				if (!heap.b.b) {
					var _v1 = heap.a;
					var value = _v1.b;
					return A2($elm$core$Basics$max, 1, value);
				} else {
					var _v2 = heap.a;
					var weight1 = _v2.a;
					var width1 = _v2.b;
					var _v3 = heap.b;
					var _v4 = _v3.a;
					var weight2 = _v4.a;
					var width2 = _v4.b;
					var rest = _v3.b;
					var $temp$heap = A2(
						$elm$core$List$sortWith,
						F2(
							function (a, b) {
								return A2($elm$core$Basics$compare, b, a);
							}),
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								weight1 + weight2,
								1 + A2($elm$core$Basics$max, width1, width2)),
							rest));
					heap = $temp$heap;
					continue heapModificationLoop;
				}
			}
		}
	};
	var createHeapFolder = F2(
		function (freq, heap) {
			return (freq > 0) ? A2(
				$elm$core$List$cons,
				_Utils_Tuple2(-freq, 0),
				heap) : heap;
		});
	var createHeap = A3($elm$core$Array$foldl, createHeapFolder, _List_Nil, frequencies);
	return heapModificationLoop(createHeap);
};
var $elm$core$Array$filter = F2(
	function (isGood, array) {
		return $elm$core$Array$fromList(
			A3(
				$elm$core$Array$foldr,
				F2(
					function (x, xs) {
						return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
					}),
				_List_Nil,
				array));
	});
var $elm$core$Elm$JsArray$indexedMap = _JsArray_indexedMap;
var $elm$core$Array$indexedMap = F2(
	function (func, _v0) {
		var len = _v0.a;
		var tree = _v0.c;
		var tail = _v0.d;
		var initialBuilder = {
			fe: _List_Nil,
			dt: 0,
			eQ: A3(
				$elm$core$Elm$JsArray$indexedMap,
				func,
				$elm$core$Array$tailIndex(len),
				tail)
		};
		var helper = F2(
			function (node, builder) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldl, helper, builder, subTree);
				} else {
					var leaf = node.a;
					var offset = builder.dt * $elm$core$Array$branchFactor;
					var mappedLeaf = $elm$core$Array$Leaf(
						A3($elm$core$Elm$JsArray$indexedMap, func, offset, leaf));
					return {
						fe: A2($elm$core$List$cons, mappedLeaf, builder.fe),
						dt: builder.dt + 1,
						eQ: builder.eQ
					};
				}
			});
		return A2(
			$elm$core$Array$builderToArray,
			true,
			A3($elm$core$Elm$JsArray$foldl, helper, initialBuilder, tree));
	});
var $elm$core$Array$length = function (_v0) {
	var len = _v0.a;
	return len;
};
var $elm$core$Elm$JsArray$map = _JsArray_map;
var $elm$core$Array$map = F2(
	function (func, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = function (node) {
			if (!node.$) {
				var subTree = node.a;
				return $elm$core$Array$SubTree(
					A2($elm$core$Elm$JsArray$map, helper, subTree));
			} else {
				var values = node.a;
				return $elm$core$Array$Leaf(
					A2($elm$core$Elm$JsArray$map, func, values));
			}
		};
		return A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A2($elm$core$Elm$JsArray$map, helper, tree),
			A2($elm$core$Elm$JsArray$map, func, tail));
	});
var $elm$core$Elm$JsArray$appendN = _JsArray_appendN;
var $elm$core$Elm$JsArray$slice = _JsArray_slice;
var $elm$core$Array$appendHelpBuilder = F2(
	function (tail, builder) {
		var tailLen = $elm$core$Elm$JsArray$length(tail);
		var notAppended = ($elm$core$Array$branchFactor - $elm$core$Elm$JsArray$length(builder.eQ)) - tailLen;
		var appended = A3($elm$core$Elm$JsArray$appendN, $elm$core$Array$branchFactor, builder.eQ, tail);
		return (notAppended < 0) ? {
			fe: A2(
				$elm$core$List$cons,
				$elm$core$Array$Leaf(appended),
				builder.fe),
			dt: builder.dt + 1,
			eQ: A3($elm$core$Elm$JsArray$slice, notAppended, tailLen, tail)
		} : ((!notAppended) ? {
			fe: A2(
				$elm$core$List$cons,
				$elm$core$Array$Leaf(appended),
				builder.fe),
			dt: builder.dt + 1,
			eQ: $elm$core$Elm$JsArray$empty
		} : {fe: builder.fe, dt: builder.dt, eQ: appended});
	});
var $elm$core$Elm$JsArray$push = _JsArray_push;
var $elm$core$Elm$JsArray$singleton = _JsArray_singleton;
var $elm$core$Array$insertTailInTree = F4(
	function (shift, index, tail, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		if (_Utils_cmp(
			pos,
			$elm$core$Elm$JsArray$length(tree)) > -1) {
			if (shift === 5) {
				return A2(
					$elm$core$Elm$JsArray$push,
					$elm$core$Array$Leaf(tail),
					tree);
			} else {
				var newSub = $elm$core$Array$SubTree(
					A4($elm$core$Array$insertTailInTree, shift - $elm$core$Array$shiftStep, index, tail, $elm$core$Elm$JsArray$empty));
				return A2($elm$core$Elm$JsArray$push, newSub, tree);
			}
		} else {
			var value = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!value.$) {
				var subTree = value.a;
				var newSub = $elm$core$Array$SubTree(
					A4($elm$core$Array$insertTailInTree, shift - $elm$core$Array$shiftStep, index, tail, subTree));
				return A3($elm$core$Elm$JsArray$unsafeSet, pos, newSub, tree);
			} else {
				var newSub = $elm$core$Array$SubTree(
					A4(
						$elm$core$Array$insertTailInTree,
						shift - $elm$core$Array$shiftStep,
						index,
						tail,
						$elm$core$Elm$JsArray$singleton(value)));
				return A3($elm$core$Elm$JsArray$unsafeSet, pos, newSub, tree);
			}
		}
	});
var $elm$core$Array$unsafeReplaceTail = F2(
	function (newTail, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		var originalTailLen = $elm$core$Elm$JsArray$length(tail);
		var newTailLen = $elm$core$Elm$JsArray$length(newTail);
		var newArrayLen = len + (newTailLen - originalTailLen);
		if (_Utils_eq(newTailLen, $elm$core$Array$branchFactor)) {
			var overflow = _Utils_cmp(newArrayLen >>> $elm$core$Array$shiftStep, 1 << startShift) > 0;
			if (overflow) {
				var newShift = startShift + $elm$core$Array$shiftStep;
				var newTree = A4(
					$elm$core$Array$insertTailInTree,
					newShift,
					len,
					newTail,
					$elm$core$Elm$JsArray$singleton(
						$elm$core$Array$SubTree(tree)));
				return A4($elm$core$Array$Array_elm_builtin, newArrayLen, newShift, newTree, $elm$core$Elm$JsArray$empty);
			} else {
				return A4(
					$elm$core$Array$Array_elm_builtin,
					newArrayLen,
					startShift,
					A4($elm$core$Array$insertTailInTree, startShift, len, newTail, tree),
					$elm$core$Elm$JsArray$empty);
			}
		} else {
			return A4($elm$core$Array$Array_elm_builtin, newArrayLen, startShift, tree, newTail);
		}
	});
var $elm$core$Array$appendHelpTree = F2(
	function (toAppend, array) {
		var len = array.a;
		var tree = array.c;
		var tail = array.d;
		var itemsToAppend = $elm$core$Elm$JsArray$length(toAppend);
		var notAppended = ($elm$core$Array$branchFactor - $elm$core$Elm$JsArray$length(tail)) - itemsToAppend;
		var appended = A3($elm$core$Elm$JsArray$appendN, $elm$core$Array$branchFactor, tail, toAppend);
		var newArray = A2($elm$core$Array$unsafeReplaceTail, appended, array);
		if (notAppended < 0) {
			var nextTail = A3($elm$core$Elm$JsArray$slice, notAppended, itemsToAppend, toAppend);
			return A2($elm$core$Array$unsafeReplaceTail, nextTail, newArray);
		} else {
			return newArray;
		}
	});
var $elm$core$Array$builderFromArray = function (_v0) {
	var len = _v0.a;
	var tree = _v0.c;
	var tail = _v0.d;
	var helper = F2(
		function (node, acc) {
			if (!node.$) {
				var subTree = node.a;
				return A3($elm$core$Elm$JsArray$foldl, helper, acc, subTree);
			} else {
				return A2($elm$core$List$cons, node, acc);
			}
		});
	return {
		fe: A3($elm$core$Elm$JsArray$foldl, helper, _List_Nil, tree),
		dt: (len / $elm$core$Array$branchFactor) | 0,
		eQ: tail
	};
};
var $elm$core$Array$append = F2(
	function (a, _v0) {
		var aTail = a.d;
		var bLen = _v0.a;
		var bTree = _v0.c;
		var bTail = _v0.d;
		if (_Utils_cmp(bLen, $elm$core$Array$branchFactor * 4) < 1) {
			var foldHelper = F2(
				function (node, array) {
					if (!node.$) {
						var tree = node.a;
						return A3($elm$core$Elm$JsArray$foldl, foldHelper, array, tree);
					} else {
						var leaf = node.a;
						return A2($elm$core$Array$appendHelpTree, leaf, array);
					}
				});
			return A2(
				$elm$core$Array$appendHelpTree,
				bTail,
				A3($elm$core$Elm$JsArray$foldl, foldHelper, a, bTree));
		} else {
			var foldHelper = F2(
				function (node, builder) {
					if (!node.$) {
						var tree = node.a;
						return A3($elm$core$Elm$JsArray$foldl, foldHelper, builder, tree);
					} else {
						var leaf = node.a;
						return A2($elm$core$Array$appendHelpBuilder, leaf, builder);
					}
				});
			return A2(
				$elm$core$Array$builderToArray,
				true,
				A2(
					$elm$core$Array$appendHelpBuilder,
					bTail,
					A3(
						$elm$core$Elm$JsArray$foldl,
						foldHelper,
						$elm$core$Array$builderFromArray(a),
						bTree)));
		}
	});
var $elm$core$Array$push = F2(
	function (a, array) {
		var tail = array.d;
		return A2(
			$elm$core$Array$unsafeReplaceTail,
			A2($elm$core$Elm$JsArray$push, a, tail),
			array);
	});
var $folkertdev$elm_flate$LengthLimitedHuffmanCodes$mergeLoop = F3(
	function (xarr, yarr, accum) {
		mergeLoop:
		while (true) {
			var _v0 = _Utils_Tuple2(xarr, yarr);
			if (!_v0.a.b) {
				return A2(
					$elm$core$Array$append,
					accum,
					$elm$core$Array$fromList(yarr));
			} else {
				if (!_v0.b.b) {
					return A2(
						$elm$core$Array$append,
						accum,
						$elm$core$Array$fromList(xarr));
				} else {
					var _v1 = _v0.a;
					var x = _v1.a;
					var xrest = _v1.b;
					var _v2 = _v0.b;
					var y = _v2.a;
					var yrest = _v2.b;
					if (_Utils_cmp(x.nW, y.nW) < 0) {
						var $temp$xarr = xrest,
							$temp$yarr = yarr,
							$temp$accum = A2($elm$core$Array$push, x, accum);
						xarr = $temp$xarr;
						yarr = $temp$yarr;
						accum = $temp$accum;
						continue mergeLoop;
					} else {
						var $temp$xarr = xarr,
							$temp$yarr = yrest,
							$temp$accum = A2($elm$core$Array$push, y, accum);
						xarr = $temp$xarr;
						yarr = $temp$yarr;
						accum = $temp$accum;
						continue mergeLoop;
					}
				}
			}
		}
	});
var $folkertdev$elm_flate$LengthLimitedHuffmanCodes$merge = F2(
	function (x, y) {
		return A3(
			$folkertdev$elm_flate$LengthLimitedHuffmanCodes$mergeLoop,
			$elm$core$Array$toList(x),
			$elm$core$Array$toList(y),
			$elm$core$Array$empty);
	});
var $folkertdev$elm_flate$LengthLimitedHuffmanCodes$mergeNodes = F2(
	function (node1, node2) {
		return {
			kA: A2($elm$core$Array$append, node1.kA, node2.kA),
			nW: node1.nW + node2.nW
		};
	});
var $folkertdev$elm_flate$LengthLimitedHuffmanCodes$package = function (nodes) {
	if ($elm$core$Array$length(nodes) >= 2) {
		var newLen = ($elm$core$Array$length(nodes) / 2) | 0;
		var loop = F2(
			function (currentNodes, accum) {
				loop:
				while (true) {
					if (currentNodes.b && currentNodes.b.b) {
						var self = currentNodes.a;
						var _v1 = currentNodes.b;
						var other = _v1.a;
						var rest = _v1.b;
						var $temp$currentNodes = rest,
							$temp$accum = A2(
							$elm$core$List$cons,
							A2($folkertdev$elm_flate$LengthLimitedHuffmanCodes$mergeNodes, self, other),
							accum);
						currentNodes = $temp$currentNodes;
						accum = $temp$accum;
						continue loop;
					} else {
						return $elm$core$Array$fromList(
							$elm$core$List$reverse(accum));
					}
				}
			});
		return A2(
			loop,
			$elm$core$Array$toList(nodes),
			_List_Nil);
	} else {
		return nodes;
	}
};
var $elm$core$Array$repeat = F2(
	function (n, e) {
		return A2(
			$elm$core$Array$initialize,
			n,
			function (_v0) {
				return e;
			});
	});
var $folkertdev$elm_flate$LengthLimitedHuffmanCodes$singletonNode = F2(
	function (symbol, weight) {
		return {
			kA: A2($elm$core$Array$repeat, 1, symbol),
			nW: weight
		};
	});
var $elm_community$list_extra$List$Extra$stableSortWith = F2(
	function (pred, list) {
		var predWithIndex = F2(
			function (_v1, _v2) {
				var a1 = _v1.a;
				var i1 = _v1.b;
				var a2 = _v2.a;
				var i2 = _v2.b;
				var result = A2(pred, a1, a2);
				if (result === 1) {
					return A2($elm$core$Basics$compare, i1, i2);
				} else {
					return result;
				}
			});
		var listWithIndex = A2(
			$elm$core$List$indexedMap,
			F2(
				function (i, a) {
					return _Utils_Tuple2(a, i);
				}),
			list);
		return A2(
			$elm$core$List$map,
			$elm$core$Tuple$first,
			A2($elm$core$List$sortWith, predWithIndex, listWithIndex));
	});
var $folkertdev$elm_flate$LengthLimitedHuffmanCodes$update = F3(
	function (index, tagger, array) {
		var _v0 = A2($elm$core$Array$get, index, array);
		if (_v0.$ === 1) {
			return array;
		} else {
			var value = _v0.a;
			return A3(
				$elm$core$Array$set,
				index,
				tagger(value),
				array);
		}
	});
var $folkertdev$elm_flate$LengthLimitedHuffmanCodes$calculate = F2(
	function (maxBitWidth, frequencies) {
		var source = $elm$core$Array$fromList(
			A2(
				$elm_community$list_extra$List$Extra$stableSortWith,
				F2(
					function (a, b) {
						return A2($elm$core$Basics$compare, a.nW, b.nW);
					}),
				$elm$core$Array$toList(
					A2(
						$elm$core$Array$map,
						function (_v3) {
							var symbol = _v3.a;
							var weight = _v3.b;
							return A2($folkertdev$elm_flate$LengthLimitedHuffmanCodes$singletonNode, symbol, weight);
						},
						A2(
							$elm$core$Array$filter,
							function (_v2) {
								var f = _v2.b;
								return f > 0;
							},
							A2($elm$core$Array$indexedMap, $elm$core$Tuple$pair, frequencies))))));
		var weighted = A3(
			$elm$core$List$foldl,
			F2(
				function (_v1, w) {
					return A2(
						$folkertdev$elm_flate$LengthLimitedHuffmanCodes$merge,
						$folkertdev$elm_flate$LengthLimitedHuffmanCodes$package(w),
						source);
				}),
			source,
			A2($elm$core$List$range, 0, maxBitWidth - 2));
		var loop = F2(
			function (symbols, accum) {
				loop:
				while (true) {
					if (!symbols.b) {
						return accum;
					} else {
						var symbol = symbols.a;
						var rest = symbols.b;
						var $temp$symbols = rest,
							$temp$accum = A3(
							$folkertdev$elm_flate$LengthLimitedHuffmanCodes$update,
							symbol,
							function (v) {
								return v + 1;
							},
							accum);
						symbols = $temp$symbols;
						accum = $temp$accum;
						continue loop;
					}
				}
			});
		var allSymbols = A2(
			$elm$core$List$concatMap,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.kA;
				},
				$elm$core$Array$toList),
			$elm$core$Array$toList(
				$folkertdev$elm_flate$LengthLimitedHuffmanCodes$package(weighted)));
		return A2(
			loop,
			allSymbols,
			A2(
				$elm$core$Array$repeat,
				$elm$core$Array$length(frequencies),
				0));
	});
var $folkertdev$elm_flate$Huffman$Tree = $elm$core$Basics$identity;
var $folkertdev$elm_flate$Huffman$Code = $elm$core$Basics$identity;
var $folkertdev$elm_flate$Huffman$codeFromRecord = $elm$core$Basics$identity;
var $folkertdev$elm_flate$Huffman$new = function (n) {
	return A2(
		$elm$core$Array$repeat,
		n,
		$folkertdev$elm_flate$Huffman$codeFromRecord(
			{jG: 0, AR: 0}));
};
var $folkertdev$elm_flate$Huffman$inverseEndianLoop = F4(
	function (i, limit, f, t) {
		inverseEndianLoop:
		while (true) {
			if (_Utils_cmp(i, limit) < 0) {
				var $temp$i = i + 1,
					$temp$limit = limit,
					$temp$f = f >> 1,
					$temp$t = (f & 1) | (t << 1);
				i = $temp$i;
				limit = $temp$limit;
				f = $temp$f;
				t = $temp$t;
				continue inverseEndianLoop;
			} else {
				return t;
			}
		}
	});
var $folkertdev$elm_flate$Huffman$inverseEndian = function (_v0) {
	var width = _v0.AR;
	var bits = _v0.jG;
	var inverseBits = A4($folkertdev$elm_flate$Huffman$inverseEndianLoop, 0, width, bits, 0);
	return {jG: inverseBits, AR: width};
};
var $folkertdev$elm_flate$Huffman$setMapping = F3(
	function (symbol, code, _v0) {
		var array = _v0;
		return A3(
			$elm$core$Array$set,
			symbol,
			$folkertdev$elm_flate$Huffman$inverseEndian(code),
			array);
	});
var $folkertdev$elm_flate$Huffman$restoreCanonicalHuffmanCodes = F2(
	function (bitWidths, tree) {
		var symbols = A2(
			$elm_community$list_extra$List$Extra$stableSortWith,
			F2(
				function (_v4, _v5) {
					var a = _v4.b;
					var b = _v5.b;
					return A2($elm$core$Basics$compare, a, b);
				}),
			$elm$core$Array$toList(
				A2(
					$elm$core$Array$filter,
					function (_v3) {
						var codeBitWidth = _v3.b;
						return codeBitWidth > 0;
					},
					A2($elm$core$Array$indexedMap, $elm$core$Tuple$pair, bitWidths))));
		var loop = F2(
			function (_v1, _v2) {
				var symbol = _v1.a;
				var bitWidth = _v1.b;
				var code = _v2.a;
				var prevWidth = _v2.b;
				var currentTree = _v2.c;
				var newBits = code << (bitWidth - prevWidth);
				var nextCode = {jG: newBits, AR: bitWidth};
				return _Utils_Tuple3(
					newBits + 1,
					bitWidth,
					A3($folkertdev$elm_flate$Huffman$setMapping, symbol, nextCode, currentTree));
			});
		return function (_v0) {
			var x = _v0.c;
			return x;
		}(
			A3(
				$elm$core$List$foldl,
				loop,
				_Utils_Tuple3(0, 0, tree),
				symbols));
	});
var $folkertdev$elm_flate$Huffman$fromBitWidths = function (bitWidths) {
	var symbolCount = function (v) {
		return v + 1;
	}(
		A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$first,
				function (a) {
					return A2(
						$elm$core$Array$get,
						$elm$core$Array$length(a) - 1,
						a);
				}(
					A2(
						$elm$core$Array$filter,
						function (e) {
							return e.b > 0;
						},
						A2($elm$core$Array$indexedMap, $elm$core$Tuple$pair, bitWidths))))));
	return A2(
		$folkertdev$elm_flate$Huffman$restoreCanonicalHuffmanCodes,
		bitWidths,
		$folkertdev$elm_flate$Huffman$new(symbolCount));
};
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $folkertdev$elm_flate$Huffman$fromFrequencies = F2(
	function (symbolFrequencies, maxBitWidth_) {
		var maxBitWidth = A2(
			$elm$core$Basics$min,
			maxBitWidth_,
			$folkertdev$elm_flate$Huffman$calcOptimalMaxBitWidth(symbolFrequencies));
		var codeBitWidhts = A2($folkertdev$elm_flate$LengthLimitedHuffmanCodes$calculate, maxBitWidth, symbolFrequencies);
		return $folkertdev$elm_flate$Huffman$fromBitWidths(codeBitWidhts);
	});
var $folkertdev$elm_flate$Deflate$Symbol$buildDynamicHuffmanCodec = function (symbols) {
	var _v0 = A3(
		$elm$core$Array$foldl,
		$folkertdev$elm_flate$Deflate$Symbol$dynamicFindFrequencies,
		_Utils_Tuple3(
			A2($elm$core$Array$repeat, 286, 0),
			A2($elm$core$Array$repeat, 30, 0),
			true),
		symbols);
	var literalCounts = _v0.a;
	var distanceCounts = _v0.b;
	var emptyDistanceCount = _v0.c;
	return {
		jR: emptyDistanceCount ? A2(
			$folkertdev$elm_flate$Huffman$fromFrequencies,
			A3($elm$core$Array$set, 0, 1, distanceCounts),
			15) : A2($folkertdev$elm_flate$Huffman$fromFrequencies, distanceCounts, 15),
		j4: A2($folkertdev$elm_flate$Huffman$fromFrequencies, literalCounts, 15)
	};
};
var $folkertdev$elm_flate$Deflate$Symbol$EndOfBlock = {$: 0};
var $folkertdev$elm_flate$Deflate$Symbol$Literal = function (a) {
	return {$: 1, a: a};
};
var $folkertdev$elm_flate$Deflate$Symbol$Share = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $folkertdev$elm_flate$Deflate$Internal$codeToSymbol = function (code) {
	if (!code.$) {
		var v = code.a;
		return $folkertdev$elm_flate$Deflate$Symbol$Literal(v);
	} else {
		var length = code.a;
		var backwardDistance = code.b;
		return A2($folkertdev$elm_flate$Deflate$Symbol$Share, length, backwardDistance);
	}
};
var $folkertdev$elm_flate$LZ77$Literal = function (a) {
	return {$: 0, a: a};
};
var $folkertdev$elm_flate$LZ77$Pointer = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $folkertdev$elm_flate$PrefixTable$Small = function (a) {
	return {$: 0, a: a};
};
var $folkertdev$elm_flate$PrefixTable$Large = function (a) {
	return {$: 1, a: a};
};
var $folkertdev$elm_flate$PrefixTable$LargePrefixTable = $elm$core$Basics$identity;
var $folkertdev$elm_flate$PrefixTable$insertInList = F6(
	function (i, array, p2, position, remaining, accum) {
		insertInList:
		while (true) {
			if (!remaining.b) {
				var newPositions = A2(
					$elm$core$List$cons,
					_Utils_Tuple2(p2, position),
					accum);
				return _Utils_Tuple2(
					$folkertdev$elm_flate$PrefixTable$Large(
						A3($elm$core$Array$set, i, newPositions, array)),
					$elm$core$Maybe$Nothing);
			} else {
				var current = remaining.a;
				var key = current.a;
				var oldValue = current.b;
				var rest = remaining.b;
				if (!(key - p2)) {
					var newPositions = _Utils_ap(
						accum,
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(key, position),
							rest));
					return _Utils_Tuple2(
						$folkertdev$elm_flate$PrefixTable$Large(
							A3($elm$core$Array$set, i, newPositions, array)),
						$elm$core$Maybe$Just(oldValue));
				} else {
					var $temp$i = i,
						$temp$array = array,
						$temp$p2 = p2,
						$temp$position = position,
						$temp$remaining = rest,
						$temp$accum = A2($elm$core$List$cons, current, accum);
					i = $temp$i;
					array = $temp$array;
					p2 = $temp$p2;
					position = $temp$position;
					remaining = $temp$remaining;
					accum = $temp$accum;
					continue insertInList;
				}
			}
		}
	});
var $folkertdev$elm_flate$PrefixTable$insert = F3(
	function (_v0, position, ptable) {
		var prefix_ = _v0;
		var prefix = 16777215 & (prefix_ >>> 0);
		if (!ptable.$) {
			var dict = ptable.a;
			var _v2 = A2($elm$core$Dict$get, prefix, dict);
			if (_v2.$ === 1) {
				return _Utils_Tuple2(
					$folkertdev$elm_flate$PrefixTable$Small(
						A3($elm$core$Dict$insert, prefix, position, dict)),
					$elm$core$Maybe$Nothing);
			} else {
				var oldValue = _v2.a;
				return _Utils_Tuple2(
					$folkertdev$elm_flate$PrefixTable$Small(
						A3($elm$core$Dict$insert, prefix, position, dict)),
					$elm$core$Maybe$Just(oldValue));
			}
		} else {
			var array = ptable.a;
			var index = prefix >> 8;
			var _v3 = A2($elm$core$Array$get, index, array);
			if (_v3.$ === 1) {
				return _Utils_Tuple2(ptable, $elm$core$Maybe$Nothing);
			} else {
				var positions = _v3.a;
				return A6($folkertdev$elm_flate$PrefixTable$insertInList, index, array, 255 & prefix, position, positions, _List_Nil);
			}
		}
	});
var $folkertdev$elm_flate$Experimental$ByteArray$length = function (_v0) {
	var array = _v0.a;
	var finalSize = _v0.b;
	var finalBytes = _v0.c;
	var _v1 = $elm$core$Array$length(array) * 4;
	if (!_v1) {
		return finalSize;
	} else {
		var l = _v1;
		return l + finalSize;
	}
};
var $folkertdev$elm_flate$Experimental$ByteArray$get = F2(
	function (index, _v0) {
		var array = _v0.a;
		var finalSize = _v0.b;
		var finalBytes = _v0.c;
		var offset = index % 4;
		if (_Utils_cmp(
			index,
			($elm$core$Array$length(array) * 4) + finalSize) > -1) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (_Utils_cmp(
				index,
				$elm$core$Array$length(array) * 4) > -1) {
				return $elm$core$Maybe$Just(255 & (finalBytes >>> (8 * (3 - offset))));
			} else {
				var internalIndex = (index / 4) | 0;
				var _v1 = A2($elm$core$Array$get, internalIndex, array);
				if (_v1.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var int32 = _v1.a;
					return $elm$core$Maybe$Just(255 & (int32 >>> (8 * (3 - offset))));
				}
			}
		}
	});
var $folkertdev$elm_flate$LZ77$longestCommonPrefixLoop = F5(
	function (i, j, limit, accum, array) {
		longestCommonPrefixLoop:
		while (true) {
			if (_Utils_cmp(i, limit) < 0) {
				var _v0 = A2($folkertdev$elm_flate$Experimental$ByteArray$get, i, array);
				if (_v0.$ === 1) {
					return accum;
				} else {
					var value1 = _v0.a;
					var _v1 = A2($folkertdev$elm_flate$Experimental$ByteArray$get, j, array);
					if (_v1.$ === 1) {
						return accum;
					} else {
						var value2 = _v1.a;
						if (!(value1 - value2)) {
							var $temp$i = i + 1,
								$temp$j = j + 1,
								$temp$limit = limit,
								$temp$accum = accum + 1,
								$temp$array = array;
							i = $temp$i;
							j = $temp$j;
							limit = $temp$limit;
							accum = $temp$accum;
							array = $temp$array;
							continue longestCommonPrefixLoop;
						} else {
							return accum;
						}
					}
				}
			} else {
				return accum;
			}
		}
	});
var $folkertdev$elm_flate$LZ77$max_length = 258;
var $folkertdev$elm_flate$LZ77$longestCommonPrefix = F3(
	function (i, j, array) {
		var remaining = A2(
			$elm$core$Basics$min,
			$folkertdev$elm_flate$LZ77$max_length - 3,
			$folkertdev$elm_flate$Experimental$ByteArray$length(array) - j);
		return A5($folkertdev$elm_flate$LZ77$longestCommonPrefixLoop, i, j, i + remaining, 0, array);
	});
var $folkertdev$elm_flate$PrefixTable$OutOfBounds = {$: 3};
var $folkertdev$elm_flate$PrefixTable$Prefix = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $folkertdev$elm_flate$PrefixTable$PrefixCode = $elm$core$Basics$identity;
var $folkertdev$elm_flate$PrefixTable$Trailing1 = function (a) {
	return {$: 1, a: a};
};
var $folkertdev$elm_flate$PrefixTable$Trailing2 = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $folkertdev$elm_flate$Experimental$ByteArray$getInt32 = F2(
	function (index, _v0) {
		var array = _v0.a;
		var finalBytes = _v0.c;
		var size = $elm$core$Array$length(array);
		return (!(index - size)) ? $elm$core$Maybe$Just(finalBytes) : A2($elm$core$Array$get, index, array);
	});
var $folkertdev$elm_flate$PrefixTable$prefixAt = F2(
	function (k, input) {
		var size = $folkertdev$elm_flate$Experimental$ByteArray$length(input);
		if (_Utils_cmp(k + 2, size) > -1) {
			if (_Utils_cmp(k, size) > -1) {
				return $folkertdev$elm_flate$PrefixTable$OutOfBounds;
			} else {
				if (_Utils_cmp(k + 1, size) > -1) {
					var _v0 = A2($folkertdev$elm_flate$Experimental$ByteArray$get, k, input);
					if (_v0.$ === 1) {
						return $folkertdev$elm_flate$PrefixTable$OutOfBounds;
					} else {
						var value = _v0.a;
						return $folkertdev$elm_flate$PrefixTable$Trailing1(value);
					}
				} else {
					var _v1 = A2($folkertdev$elm_flate$Experimental$ByteArray$get, k, input);
					if (_v1.$ === 1) {
						return $folkertdev$elm_flate$PrefixTable$OutOfBounds;
					} else {
						var v1 = _v1.a;
						var _v2 = A2($folkertdev$elm_flate$Experimental$ByteArray$get, k + 1, input);
						if (_v2.$ === 1) {
							return $folkertdev$elm_flate$PrefixTable$OutOfBounds;
						} else {
							var v2 = _v2.a;
							return A2($folkertdev$elm_flate$PrefixTable$Trailing2, v1, v2);
						}
					}
				}
			}
		} else {
			var offset = k % 4;
			var internalIndex = (k / 4) | 0;
			switch (offset) {
				case 0:
					var _v4 = A2($folkertdev$elm_flate$Experimental$ByteArray$getInt32, internalIndex, input);
					if (_v4.$ === 1) {
						return $folkertdev$elm_flate$PrefixTable$OutOfBounds;
					} else {
						var int32 = _v4.a;
						var first = 255 & ((int32 >> 24) >>> 0);
						var code = int32 >> 8;
						return A2($folkertdev$elm_flate$PrefixTable$Prefix, first, code);
					}
				case 1:
					var _v5 = A2($folkertdev$elm_flate$Experimental$ByteArray$getInt32, internalIndex, input);
					if (_v5.$ === 1) {
						return $folkertdev$elm_flate$PrefixTable$OutOfBounds;
					} else {
						var int32 = _v5.a;
						var first = 255 & ((255 & (int32 >> 16)) >>> 0);
						var code = 16777215 & int32;
						return A2($folkertdev$elm_flate$PrefixTable$Prefix, first, code);
					}
				case 2:
					var _v6 = A2($folkertdev$elm_flate$Experimental$ByteArray$getInt32, internalIndex, input);
					if (_v6.$ === 1) {
						return $folkertdev$elm_flate$PrefixTable$OutOfBounds;
					} else {
						var int32 = _v6.a;
						var _v7 = A2($folkertdev$elm_flate$Experimental$ByteArray$getInt32, internalIndex + 1, input);
						if (_v7.$ === 1) {
							return $folkertdev$elm_flate$PrefixTable$OutOfBounds;
						} else {
							var nextInt32 = _v7.a;
							var first = 255 & ((255 & (int32 >> 8)) >>> 0);
							var code = 16777215 & (((255 & (nextInt32 >> 24)) | ((65535 & int32) << 8)) >>> 0);
							return A2($folkertdev$elm_flate$PrefixTable$Prefix, first, code);
						}
					}
				default:
					var _v8 = A2($folkertdev$elm_flate$Experimental$ByteArray$getInt32, internalIndex, input);
					if (_v8.$ === 1) {
						return $folkertdev$elm_flate$PrefixTable$OutOfBounds;
					} else {
						var int32 = _v8.a;
						var _v9 = A2($folkertdev$elm_flate$Experimental$ByteArray$getInt32, internalIndex + 1, input);
						if (_v9.$ === 1) {
							return $folkertdev$elm_flate$PrefixTable$OutOfBounds;
						} else {
							var nextInt32 = _v9.a;
							var first = 255 & ((255 & int32) >>> 0);
							var code = (65535 & (nextInt32 >> 16)) | ((255 & int32) << 16);
							return A2($folkertdev$elm_flate$PrefixTable$Prefix, first, code);
						}
					}
			}
		}
	});
var $folkertdev$elm_flate$LZ77$updatePrefixTableLoop = F4(
	function (k, limit, buffer, prefixTable) {
		updatePrefixTableLoop:
		while (true) {
			if (_Utils_cmp(k, limit) < 0) {
				var _v0 = A2($folkertdev$elm_flate$PrefixTable$prefixAt, k, buffer);
				if (!_v0.$) {
					var code = _v0.b;
					var _v1 = A3($folkertdev$elm_flate$PrefixTable$insert, code, k, prefixTable);
					var newPrefixTable = _v1.a;
					var $temp$k = k + 1,
						$temp$limit = limit,
						$temp$buffer = buffer,
						$temp$prefixTable = newPrefixTable;
					k = $temp$k;
					limit = $temp$limit;
					buffer = $temp$buffer;
					prefixTable = $temp$prefixTable;
					continue updatePrefixTableLoop;
				} else {
					return prefixTable;
				}
			} else {
				return prefixTable;
			}
		}
	});
var $folkertdev$elm_flate$LZ77$flushLoop = F5(
	function (i, windowSize, buffer, prefixTable, encoders) {
		flushLoop:
		while (true) {
			var _v0 = A2($folkertdev$elm_flate$PrefixTable$prefixAt, i, buffer);
			switch (_v0.$) {
				case 3:
					return encoders;
				case 1:
					var p1 = _v0.a;
					return A2(
						$elm$core$Array$push,
						$folkertdev$elm_flate$LZ77$Literal(p1),
						encoders);
				case 2:
					var p1 = _v0.a;
					var p2 = _v0.b;
					return A2(
						$elm$core$Array$push,
						$folkertdev$elm_flate$LZ77$Literal(p2),
						A2(
							$elm$core$Array$push,
							$folkertdev$elm_flate$LZ77$Literal(p1),
							encoders));
				default:
					var p1 = _v0.a;
					var key = _v0.b;
					var _v1 = A3($folkertdev$elm_flate$PrefixTable$insert, key, i, prefixTable);
					var newPrefixTable = _v1.a;
					var matched = _v1.b;
					if (!matched.$) {
						var j = matched.a;
						var distance = i - j;
						if ((distance - windowSize) <= 0) {
							var length = 3 + A3($folkertdev$elm_flate$LZ77$longestCommonPrefix, i + 3, j + 3, buffer);
							var newEncoders = A2(
								$elm$core$Array$push,
								A2($folkertdev$elm_flate$LZ77$Pointer, length, distance),
								encoders);
							var newerPrefixTable = A4($folkertdev$elm_flate$LZ77$updatePrefixTableLoop, i + 1, i + length, buffer, newPrefixTable);
							var $temp$i = i + length,
								$temp$windowSize = windowSize,
								$temp$buffer = buffer,
								$temp$prefixTable = newerPrefixTable,
								$temp$encoders = newEncoders;
							i = $temp$i;
							windowSize = $temp$windowSize;
							buffer = $temp$buffer;
							prefixTable = $temp$prefixTable;
							encoders = $temp$encoders;
							continue flushLoop;
						} else {
							var $temp$i = i + 1,
								$temp$windowSize = windowSize,
								$temp$buffer = buffer,
								$temp$prefixTable = newPrefixTable,
								$temp$encoders = A2(
								$elm$core$Array$push,
								$folkertdev$elm_flate$LZ77$Literal(p1),
								encoders);
							i = $temp$i;
							windowSize = $temp$windowSize;
							buffer = $temp$buffer;
							prefixTable = $temp$prefixTable;
							encoders = $temp$encoders;
							continue flushLoop;
						}
					} else {
						var $temp$i = i + 1,
							$temp$windowSize = windowSize,
							$temp$buffer = buffer,
							$temp$prefixTable = newPrefixTable,
							$temp$encoders = A2(
							$elm$core$Array$push,
							$folkertdev$elm_flate$LZ77$Literal(p1),
							encoders);
						i = $temp$i;
						windowSize = $temp$windowSize;
						buffer = $temp$buffer;
						prefixTable = $temp$prefixTable;
						encoders = $temp$encoders;
						continue flushLoop;
					}
			}
		}
	});
var $folkertdev$elm_flate$PrefixTable$max_distance = 32768;
var $folkertdev$elm_flate$PrefixTable$max_window_size = $folkertdev$elm_flate$PrefixTable$max_distance;
var $folkertdev$elm_flate$PrefixTable$newLargePrefixTable = A2($elm$core$Array$repeat, 65535, _List_Nil);
var $folkertdev$elm_flate$PrefixTable$new = function (nbytes) {
	return (_Utils_cmp(nbytes, $folkertdev$elm_flate$PrefixTable$max_window_size) < 0) ? $folkertdev$elm_flate$PrefixTable$Small($elm$core$Dict$empty) : $folkertdev$elm_flate$PrefixTable$Large($folkertdev$elm_flate$PrefixTable$newLargePrefixTable);
};
var $folkertdev$elm_flate$LZ77$flush = F2(
	function (windowSize, buffer) {
		var codes = A5(
			$folkertdev$elm_flate$LZ77$flushLoop,
			0,
			windowSize,
			buffer,
			$folkertdev$elm_flate$PrefixTable$new(
				$folkertdev$elm_flate$Experimental$ByteArray$length(buffer)),
			$elm$core$Array$empty);
		return codes;
	});
var $folkertdev$elm_flate$Experimental$ByteArray$ByteArray = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $folkertdev$elm_flate$Experimental$ByteArray$empty = A3($folkertdev$elm_flate$Experimental$ByteArray$ByteArray, $elm$core$Array$empty, 0, 0);
var $elm$bytes$Bytes$Decode$andThen = F2(
	function (callback, _v0) {
		var decodeA = _v0;
		return F2(
			function (bites, offset) {
				var _v1 = A2(decodeA, bites, offset);
				var newOffset = _v1.a;
				var a = _v1.b;
				var _v2 = callback(a);
				var decodeB = _v2;
				return A2(decodeB, bites, newOffset);
			});
	});
var $elm$bytes$Bytes$Decode$map5 = F6(
	function (func, _v0, _v1, _v2, _v3, _v4) {
		var decodeA = _v0;
		var decodeB = _v1;
		var decodeC = _v2;
		var decodeD = _v3;
		var decodeE = _v4;
		return F2(
			function (bites, offset) {
				var _v5 = A2(decodeA, bites, offset);
				var aOffset = _v5.a;
				var a = _v5.b;
				var _v6 = A2(decodeB, bites, aOffset);
				var bOffset = _v6.a;
				var b = _v6.b;
				var _v7 = A2(decodeC, bites, bOffset);
				var cOffset = _v7.a;
				var c = _v7.b;
				var _v8 = A2(decodeD, bites, cOffset);
				var dOffset = _v8.a;
				var d = _v8.b;
				var _v9 = A2(decodeE, bites, dOffset);
				var eOffset = _v9.a;
				var e = _v9.b;
				return _Utils_Tuple2(
					eOffset,
					A5(func, a, b, c, d, e));
			});
	});
var $elm$bytes$Bytes$Decode$unsignedInt16 = function (endianness) {
	return _Bytes_read_u16(!endianness);
};
var $folkertdev$elm_flate$Experimental$ByteArray$fromBytesHelp = function (_v0) {
	var remaining = _v0.a;
	var array = _v0.b;
	if (remaining >= 40) {
		return A2(
			$elm$bytes$Bytes$Decode$andThen,
			$elm$core$Basics$identity,
			A6(
				$elm$bytes$Bytes$Decode$map5,
				F5(
					function (a, b, c, d, e) {
						return A6(
							$elm$bytes$Bytes$Decode$map5,
							F5(
								function (f, g, h, i, j) {
									return $elm$bytes$Bytes$Decode$Loop(
										_Utils_Tuple2(
											remaining - 40,
											A2(
												$elm$core$Array$append,
												array,
												$elm$core$Array$fromList(
													_List_fromArray(
														[a, b, c, d, e, f, g, h, i, j])))));
								}),
							$elm$bytes$Bytes$Decode$unsignedInt32(1),
							$elm$bytes$Bytes$Decode$unsignedInt32(1),
							$elm$bytes$Bytes$Decode$unsignedInt32(1),
							$elm$bytes$Bytes$Decode$unsignedInt32(1),
							$elm$bytes$Bytes$Decode$unsignedInt32(1));
					}),
				$elm$bytes$Bytes$Decode$unsignedInt32(1),
				$elm$bytes$Bytes$Decode$unsignedInt32(1),
				$elm$bytes$Bytes$Decode$unsignedInt32(1),
				$elm$bytes$Bytes$Decode$unsignedInt32(1),
				$elm$bytes$Bytes$Decode$unsignedInt32(1)));
	} else {
		if (remaining >= 20) {
			return A6(
				$elm$bytes$Bytes$Decode$map5,
				F5(
					function (a, b, c, d, e) {
						return $elm$bytes$Bytes$Decode$Loop(
							_Utils_Tuple2(
								remaining - 20,
								A2(
									$elm$core$Array$push,
									e,
									A2(
										$elm$core$Array$push,
										d,
										A2(
											$elm$core$Array$push,
											c,
											A2(
												$elm$core$Array$push,
												b,
												A2($elm$core$Array$push, a, array)))))));
					}),
				$elm$bytes$Bytes$Decode$unsignedInt32(1),
				$elm$bytes$Bytes$Decode$unsignedInt32(1),
				$elm$bytes$Bytes$Decode$unsignedInt32(1),
				$elm$bytes$Bytes$Decode$unsignedInt32(1),
				$elm$bytes$Bytes$Decode$unsignedInt32(1));
		} else {
			if (remaining >= 4) {
				return A2(
					$elm$bytes$Bytes$Decode$map,
					function (a) {
						return $elm$bytes$Bytes$Decode$Loop(
							_Utils_Tuple2(
								remaining - 4,
								A2($elm$core$Array$push, a, array)));
					},
					$elm$bytes$Bytes$Decode$unsignedInt32(1));
			} else {
				switch (remaining) {
					case 0:
						return $elm$bytes$Bytes$Decode$succeed(
							$elm$bytes$Bytes$Decode$Done(
								_Utils_Tuple3(0, 0, array)));
					case 1:
						return A2(
							$elm$bytes$Bytes$Decode$map,
							function (_byte) {
								return $elm$bytes$Bytes$Decode$Done(
									_Utils_Tuple3(1, _byte << 24, array));
							},
							$elm$bytes$Bytes$Decode$unsignedInt8);
					case 2:
						return A2(
							$elm$bytes$Bytes$Decode$map,
							function (_byte) {
								return $elm$bytes$Bytes$Decode$Done(
									_Utils_Tuple3(2, _byte << 16, array));
							},
							$elm$bytes$Bytes$Decode$unsignedInt16(1));
					default:
						return A3(
							$elm$bytes$Bytes$Decode$map2,
							F2(
								function (bytes, _byte) {
									return $elm$bytes$Bytes$Decode$Done(
										_Utils_Tuple3(3, (bytes << 16) | (_byte << 8), array));
								}),
							$elm$bytes$Bytes$Decode$unsignedInt16(1),
							$elm$bytes$Bytes$Decode$unsignedInt8);
				}
			}
		}
	}
};
var $folkertdev$elm_flate$Experimental$ByteArray$fromBytes = function (buffer) {
	var _v0 = A2(
		$elm$bytes$Bytes$Decode$decode,
		A2(
			$elm$bytes$Bytes$Decode$loop,
			_Utils_Tuple2(
				$elm$bytes$Bytes$width(buffer),
				$elm$core$Array$empty),
			$folkertdev$elm_flate$Experimental$ByteArray$fromBytesHelp),
		buffer);
	if (_v0.$ === 1) {
		return $folkertdev$elm_flate$Experimental$ByteArray$empty;
	} else {
		var _v1 = _v0.a;
		var finalSize = _v1.a;
		var finalBytes = _v1.b;
		var array = _v1.c;
		return A3($folkertdev$elm_flate$Experimental$ByteArray$ByteArray, array, finalSize, finalBytes);
	}
};
var $folkertdev$elm_flate$LZ77$encodeWithOptions = F2(
	function (_v0, buffer) {
		var windowSize = _v0.Hc;
		return A2(
			$folkertdev$elm_flate$LZ77$flush,
			windowSize,
			$folkertdev$elm_flate$Experimental$ByteArray$fromBytes(buffer));
	});
var $folkertdev$elm_flate$ByteArray$decodeByteArrayHelp = function (_v0) {
	var remaining = _v0.a;
	var accum = _v0.b;
	return (remaining >= 4) ? A2(
		$elm$bytes$Bytes$Decode$map,
		function (_new) {
			var byte4 = 255 & (_new >>> 0);
			var byte3 = 255 & ((_new >> 8) >>> 0);
			var byte2 = 255 & ((_new >> 16) >>> 0);
			var byte1 = 255 & ((_new >> 24) >>> 0);
			var newAccum = A2(
				$elm$core$Array$push,
				byte4,
				A2(
					$elm$core$Array$push,
					byte3,
					A2(
						$elm$core$Array$push,
						byte2,
						A2($elm$core$Array$push, byte1, accum))));
			return $elm$bytes$Bytes$Decode$Loop(
				_Utils_Tuple2(remaining - 4, newAccum));
		},
		$elm$bytes$Bytes$Decode$unsignedInt32(1)) : ((remaining > 0) ? A2(
		$elm$bytes$Bytes$Decode$map,
		function (_new) {
			return $elm$bytes$Bytes$Decode$Loop(
				_Utils_Tuple2(
					remaining - 1,
					A2($elm$core$Array$push, _new, accum)));
		},
		$elm$bytes$Bytes$Decode$unsignedInt8) : $elm$bytes$Bytes$Decode$succeed(
		$elm$bytes$Bytes$Decode$Done(accum)));
};
var $folkertdev$elm_flate$ByteArray$decoder = function (n) {
	return A2(
		$elm$bytes$Bytes$Decode$loop,
		_Utils_Tuple2(n, $elm$core$Array$empty),
		$folkertdev$elm_flate$ByteArray$decodeByteArrayHelp);
};
var $folkertdev$elm_flate$ByteArray$fromBytes = function (buffer) {
	var _v0 = A2(
		$elm$bytes$Bytes$Decode$decode,
		$folkertdev$elm_flate$ByteArray$decoder(
			$elm$bytes$Bytes$width(buffer)),
		buffer);
	if (_v0.$ === 1) {
		return $elm$core$Array$empty;
	} else {
		var value = _v0.a;
		return value;
	}
};
var $folkertdev$elm_flate$Deflate$Internal$compress = F2(
	function (maybeWindowSize, buf) {
		if (maybeWindowSize.$ === 1) {
			return A2(
				$elm$core$Array$push,
				$folkertdev$elm_flate$Deflate$Symbol$EndOfBlock,
				A2(
					$elm$core$Array$map,
					$folkertdev$elm_flate$Deflate$Symbol$Literal,
					$folkertdev$elm_flate$ByteArray$fromBytes(buf)));
		} else {
			var windowSize = maybeWindowSize.a;
			return A2(
				$elm$core$Array$push,
				$folkertdev$elm_flate$Deflate$Symbol$EndOfBlock,
				A2(
					$elm$core$Array$map,
					$folkertdev$elm_flate$Deflate$Internal$codeToSymbol,
					A2(
						$folkertdev$elm_flate$LZ77$encodeWithOptions,
						{Hc: windowSize},
						buf)));
		}
	});
var $elm$bytes$Bytes$Encode$U16 = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$unsignedInt16 = $elm$bytes$Bytes$Encode$U16;
var $folkertdev$elm_flate$Deflate$BitWriter$flushIfNeeded = F3(
	function (tag, bitsWritten, encoders) {
		return (bitsWritten >= 16) ? {
			hl: bitsWritten - 16,
			hv: A2(
				$elm$core$List$cons,
				A2($elm$bytes$Bytes$Encode$unsignedInt16, 0, tag),
				encoders),
			wB: tag >> 16
		} : {hl: bitsWritten, hv: encoders, wB: tag};
	});
var $folkertdev$elm_flate$Deflate$BitWriter$writeBits = F3(
	function (bitwidth, bits, state) {
		return A3($folkertdev$elm_flate$Deflate$BitWriter$flushIfNeeded, state.wB | (bits << state.hl), state.hl + bitwidth, state.hv);
	});
var $folkertdev$elm_flate$Huffman$encode = F2(
	function (symbol, _v0) {
		var table = _v0;
		var _v1 = A2($elm$core$Array$get, symbol, table);
		if (_v1.$ === 1) {
			return A2($folkertdev$elm_flate$Deflate$BitWriter$writeBits, 0, 0);
		} else {
			var width = _v1.a.AR;
			var bits = _v1.a.jG;
			return A2($folkertdev$elm_flate$Deflate$BitWriter$writeBits, width, bits);
		}
	});
var $folkertdev$elm_flate$Deflate$Symbol$extraLength = function (symbol) {
	if (symbol.$ === 2) {
		var length = symbol.a;
		return (((length >= 3) && (length <= 10)) || (length === 258)) ? $elm$core$Maybe$Nothing : (((length >= 11) && (length <= 18)) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(
				1,
				A2($elm$core$Basics$modBy, 2, length - 11))) : (((length >= 19) && (length <= 34)) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(
				2,
				A2($elm$core$Basics$modBy, 4, length - 19))) : (((length >= 35) && (length <= 66)) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(
				3,
				A2($elm$core$Basics$modBy, 8, length - 35))) : (((length >= 67) && (length <= 130)) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(
				4,
				A2($elm$core$Basics$modBy, 16, length - 67))) : (((length >= 131) && (length <= 257)) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(
				5,
				A2($elm$core$Basics$modBy, 32, length - 131))) : $elm$core$Maybe$Nothing)))));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $folkertdev$elm_flate$Deflate$Symbol$encode = F3(
	function (symbol, htrees, bitWriter) {
		var maybeExtra = function () {
			var _v2 = $folkertdev$elm_flate$Deflate$Symbol$extraLength(symbol);
			if (_v2.$ === 1) {
				return $elm$core$Basics$identity;
			} else {
				var _v3 = _v2.a;
				var bits = _v3.a;
				var extra = _v3.b;
				return A2($folkertdev$elm_flate$Deflate$BitWriter$writeBits, bits, extra);
			}
		}();
		var maybeDistance = function () {
			var _v0 = $folkertdev$elm_flate$Deflate$Symbol$distance(symbol);
			if (_v0.$ === 1) {
				return $elm$core$Basics$identity;
			} else {
				var _v1 = _v0.a;
				var code_ = _v1.a;
				var bits = _v1.b;
				var extra = _v1.c;
				return A2(
					$elm$core$Basics$composeR,
					A2($folkertdev$elm_flate$Huffman$encode, code_, htrees.jR),
					(bits > 0) ? A2($folkertdev$elm_flate$Deflate$BitWriter$writeBits, bits, extra) : $elm$core$Basics$identity);
			}
		}();
		return maybeDistance(
			maybeExtra(
				A3(
					$folkertdev$elm_flate$Huffman$encode,
					$folkertdev$elm_flate$Deflate$Symbol$code(symbol),
					htrees.j4,
					bitWriter)));
	});
var $folkertdev$elm_flate$Deflate$Symbol$bitwidth_code_order = _List_fromArray(
	[16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
var $folkertdev$elm_flate$Deflate$Symbol$calculateCodes = function (runLengths) {
	var loop2 = F3(
		function (r, c, codes) {
			loop2:
			while (true) {
				if (c >= 3) {
					var n = A2($elm$core$Basics$min, 6, c);
					var $temp$r = r,
						$temp$c = c - n,
						$temp$codes = A2(
						$elm$core$Array$push,
						_Utils_Tuple3(16, 2, n - 3),
						codes);
					r = $temp$r;
					c = $temp$c;
					codes = $temp$codes;
					continue loop2;
				} else {
					return A2(
						$elm$core$Array$append,
						codes,
						A2(
							$elm$core$Array$repeat,
							c,
							_Utils_Tuple3(r.kH, 0, 0)));
				}
			}
		});
	var loop1 = F2(
		function (c, codes) {
			loop1:
			while (true) {
				if (c >= 11) {
					var n = A2($elm$core$Basics$min, 138, c);
					var $temp$c = c - n,
						$temp$codes = A2(
						$elm$core$Array$push,
						_Utils_Tuple3(18, 7, n - 11),
						codes);
					c = $temp$c;
					codes = $temp$codes;
					continue loop1;
				} else {
					if (c >= 3) {
						return A2(
							$elm$core$Array$push,
							_Utils_Tuple3(17, 3, c - 3),
							codes);
					} else {
						return A2(
							$elm$core$Array$append,
							codes,
							A2(
								$elm$core$Array$repeat,
								c,
								_Utils_Tuple3(0, 0, 0)));
					}
				}
			}
		});
	var folder = F2(
		function (r, codes) {
			return (!r.kH) ? A2(loop1, r.cO, codes) : A3(
				loop2,
				r,
				r.cO - 1,
				A2(
					$elm$core$Array$push,
					_Utils_Tuple3(r.kH, 0, 0),
					codes));
		});
	return A3($elm$core$Array$foldl, folder, $elm$core$Array$empty, runLengths);
};
var $folkertdev$elm_flate$Huffman$getWidth = function (_v0) {
	var width = _v0.AR;
	return width;
};
var $folkertdev$elm_flate$Huffman$lookup = F2(
	function (symbol, _v0) {
		var array = _v0;
		return A2($elm$core$Array$get, symbol, array);
	});
var $folkertdev$elm_flate$Deflate$Symbol$calculateRunLengths = F2(
	function (lengths, accum) {
		calculateRunLengths:
		while (true) {
			if (!lengths.b) {
				return A3($elm$core$List$foldr, $elm$core$Array$push, $elm$core$Array$empty, accum);
			} else {
				var _v1 = lengths.a;
				var e = _v1.a;
				var size = _v1.b;
				var rest = lengths.b;
				var list = A2(
					$elm$core$List$indexedMap,
					$elm$core$Tuple$pair,
					A2(
						$elm$core$List$map,
						function (x) {
							return A2(
								$elm$core$Maybe$withDefault,
								0,
								A2(
									$elm$core$Maybe$map,
									$folkertdev$elm_flate$Huffman$getWidth,
									A2($folkertdev$elm_flate$Huffman$lookup, x, e)));
						},
						A2($elm$core$List$range, 0, size - 1)));
				var folder = F2(
					function (_v3, runLengths) {
						var i = _v3.a;
						var c = _v3.b;
						if (!runLengths.b) {
							return A2(
								$elm$core$List$cons,
								{cO: 1, kH: c},
								runLengths);
						} else {
							var last = runLengths.a;
							var remaining = runLengths.b;
							return _Utils_eq(last.kH, c) ? A2(
								$elm$core$List$cons,
								{cO: last.cO + 1, kH: last.kH},
								remaining) : A2(
								$elm$core$List$cons,
								{cO: 1, kH: c},
								runLengths);
						}
					});
				var $temp$lengths = rest,
					$temp$accum = A3($elm$core$List$foldl, folder, accum, list);
				lengths = $temp$lengths;
				accum = $temp$accum;
				continue calculateRunLengths;
			}
		}
	});
var $folkertdev$elm_flate$Deflate$Symbol$buildBitWidthCodes = F3(
	function (literalCodeCount, distanceCodeCount, trees) {
		var runLengths = A2(
			$folkertdev$elm_flate$Deflate$Symbol$calculateRunLengths,
			_List_fromArray(
				[
					_Utils_Tuple2(trees.j4, literalCodeCount),
					_Utils_Tuple2(trees.jR, distanceCodeCount)
				]),
			_List_Nil);
		return $folkertdev$elm_flate$Deflate$Symbol$calculateCodes(runLengths);
	});
var $folkertdev$elm_flate$Deflate$Symbol$positionLoop = F3(
	function (predicate, i, elements) {
		positionLoop:
		while (true) {
			if (!elements.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var x = elements.a;
				var xs = elements.b;
				if (predicate(x)) {
					return $elm$core$Maybe$Just(i);
				} else {
					var $temp$predicate = predicate,
						$temp$i = i + 1,
						$temp$elements = xs;
					predicate = $temp$predicate;
					i = $temp$i;
					elements = $temp$elements;
					continue positionLoop;
				}
			}
		}
	});
var $folkertdev$elm_flate$Deflate$Symbol$position = F2(
	function (predicate, elements) {
		return A3($folkertdev$elm_flate$Deflate$Symbol$positionLoop, predicate, 0, elements);
	});
var $folkertdev$elm_flate$Huffman$positionFromTheEnd = F2(
	function (predicated, array) {
		var folder = F2(
			function (element, _v1) {
				var index = _v1.a;
				var accum = _v1.b;
				if (!accum.$) {
					return _Utils_Tuple2(index, accum);
				} else {
					return predicated(element) ? _Utils_Tuple2(
						index,
						$elm$core$Maybe$Just(index)) : _Utils_Tuple2(index - 1, $elm$core$Maybe$Nothing);
				}
			});
		var finalIndex = $elm$core$Array$length(array) - 1;
		return A2(
			$elm$core$Maybe$map,
			function (v) {
				return finalIndex - v;
			},
			A3(
				$elm$core$Array$foldr,
				folder,
				_Utils_Tuple2(finalIndex, $elm$core$Maybe$Nothing),
				array).b);
	});
var $folkertdev$elm_flate$Huffman$usedMaxSymbol = function (_v0) {
	var array = _v0;
	return A2(
		$elm$core$Maybe$map,
		function (trailingZeros) {
			return ($elm$core$Array$length(array) - 1) - trailingZeros;
		},
		A2(
			$folkertdev$elm_flate$Huffman$positionFromTheEnd,
			function (_v1) {
				var value = _v1;
				return value.AR > 0;
			},
			array));
};
var $folkertdev$elm_flate$Deflate$Symbol$writeDynamicHuffmanCodec = F2(
	function (trees, bitWriter) {
		var literal_code_count = A2(
			$elm$core$Basics$max,
			257,
			A2(
				$elm$core$Maybe$withDefault,
				0,
				$folkertdev$elm_flate$Huffman$usedMaxSymbol(trees.j4)) + 1);
		var distance_code_count = A2(
			$elm$core$Basics$max,
			1,
			A2(
				$elm$core$Maybe$withDefault,
				0,
				$folkertdev$elm_flate$Huffman$usedMaxSymbol(trees.jR)) + 1);
		var codes = A3(
			$folkertdev$elm_flate$Deflate$Symbol$buildBitWidthCodes,
			literal_code_count,
			distance_code_count,
			{jR: trees.jR, j4: trees.j4});
		var codeCounts = A3(
			$elm$core$Array$foldl,
			function (_v2) {
				var i = _v2.a;
				return A2(
					$folkertdev$elm_flate$Deflate$Symbol$update,
					i,
					function (v) {
						return v + 1;
					});
			},
			A2($elm$core$Array$repeat, 19, 0),
			codes);
		var bitWidthEncoder = A2($folkertdev$elm_flate$Huffman$fromFrequencies, codeCounts, 7);
		var bitwidthCodeCount = A2(
			$elm$core$Basics$max,
			4,
			A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Maybe$map,
					function (trailingZeros) {
						return 19 - trailingZeros;
					},
					A2(
						$folkertdev$elm_flate$Deflate$Symbol$position,
						function (i) {
							var _v1 = A2($folkertdev$elm_flate$Huffman$lookup, i, bitWidthEncoder);
							if (_v1.$ === 1) {
								return false;
							} else {
								var value = _v1.a;
								return $folkertdev$elm_flate$Huffman$getWidth(value) > 0;
							}
						},
						$elm$core$List$reverse($folkertdev$elm_flate$Deflate$Symbol$bitwidth_code_order)))));
		var v1 = function (writer) {
			return A3(
				$elm$core$List$foldl,
				F2(
					function (i, current) {
						var width = _Utils_eq(
							A2($elm$core$Array$get, i, codeCounts),
							$elm$core$Maybe$Just(0)) ? 0 : A2(
							$elm$core$Maybe$withDefault,
							0,
							A2(
								$elm$core$Maybe$map,
								$folkertdev$elm_flate$Huffman$getWidth,
								A2($folkertdev$elm_flate$Huffman$lookup, i, bitWidthEncoder)));
						return A3($folkertdev$elm_flate$Deflate$BitWriter$writeBits, 3, width, current);
					}),
				writer,
				A2($elm$core$List$take, bitwidthCodeCount, $folkertdev$elm_flate$Deflate$Symbol$bitwidth_code_order));
		};
		var v2 = function (writer) {
			return A3(
				$elm$core$Array$foldl,
				F2(
					function (_v0, current) {
						var code_ = _v0.a;
						var bits = _v0.b;
						var extra = _v0.c;
						return (bits > 0) ? A3(
							$folkertdev$elm_flate$Deflate$BitWriter$writeBits,
							bits,
							extra,
							A3($folkertdev$elm_flate$Huffman$encode, code_, bitWidthEncoder, current)) : A3($folkertdev$elm_flate$Huffman$encode, code_, bitWidthEncoder, current);
					}),
				writer,
				codes);
		};
		return v2(
			v1(
				A3(
					$folkertdev$elm_flate$Deflate$BitWriter$writeBits,
					4,
					bitwidthCodeCount - 4,
					A3(
						$folkertdev$elm_flate$Deflate$BitWriter$writeBits,
						5,
						distance_code_count - 1,
						A3($folkertdev$elm_flate$Deflate$BitWriter$writeBits, 5, literal_code_count - 257, bitWriter)))));
	});
var $folkertdev$elm_flate$Deflate$Internal$encodeCompressDynamic = F3(
	function (maybeWindowSize, buf, bitWriter) {
		var compressed = A2($folkertdev$elm_flate$Deflate$Internal$compress, maybeWindowSize, buf);
		var huffmanTree = $folkertdev$elm_flate$Deflate$Symbol$buildDynamicHuffmanCodec(compressed);
		var huffmanTreeWriter = A2($folkertdev$elm_flate$Deflate$Symbol$writeDynamicHuffmanCodec, huffmanTree, bitWriter);
		return A3(
			$elm$core$Array$foldl,
			F2(
				function (symbol, first) {
					return A3($folkertdev$elm_flate$Deflate$Symbol$encode, symbol, huffmanTree, first);
				}),
			huffmanTreeWriter,
			compressed);
	});
var $folkertdev$elm_flate$Deflate$BitWriter$writeBit = function (b) {
	if (!b) {
		return A2($folkertdev$elm_flate$Deflate$BitWriter$writeBits, 1, 0);
	} else {
		return A2($folkertdev$elm_flate$Deflate$BitWriter$writeBits, 1, 1);
	}
};
var $folkertdev$elm_flate$Deflate$Internal$encodeDynamicBlock = F3(
	function (windowSize, _v0, bitWriter) {
		var isLastBlock = _v0.a;
		var buffer = _v0.b;
		return A3(
			$folkertdev$elm_flate$Deflate$Internal$encodeCompressDynamic,
			windowSize,
			buffer,
			A3(
				$folkertdev$elm_flate$Deflate$BitWriter$writeBits,
				2,
				2,
				A2($folkertdev$elm_flate$Deflate$BitWriter$writeBit, isLastBlock, bitWriter)));
	});
var $elm$bytes$Bytes$Encode$U8 = function (a) {
	return {$: 3, a: a};
};
var $elm$bytes$Bytes$Encode$unsignedInt8 = $elm$bytes$Bytes$Encode$U8;
var $folkertdev$elm_flate$Deflate$BitWriter$flushLoop = F3(
	function (tag, bitsWritten, encoders) {
		flushLoop:
		while (true) {
			if (bitsWritten > 0) {
				var $temp$tag = tag >> 8,
					$temp$bitsWritten = A2($elm$core$Basics$max, 0, bitsWritten - 8),
					$temp$encoders = A2(
					$elm$core$List$cons,
					$elm$bytes$Bytes$Encode$unsignedInt8(tag),
					encoders);
				tag = $temp$tag;
				bitsWritten = $temp$bitsWritten;
				encoders = $temp$encoders;
				continue flushLoop;
			} else {
				return {hl: bitsWritten, hv: encoders, wB: tag};
			}
		}
	});
var $folkertdev$elm_flate$Deflate$BitWriter$flush = function (state) {
	return A3($folkertdev$elm_flate$Deflate$BitWriter$flushLoop, state.wB, state.hl, state.hv);
};
var $folkertdev$elm_flate$Deflate$BitWriter$run = function (state) {
	return $elm$core$List$reverse(state.hv);
};
var $folkertdev$elm_flate$Deflate$Internal$encodeDynamic = F2(
	function (windowSize, buffer) {
		var encodedChunks = A2(
			$elm$core$List$map,
			$folkertdev$elm_flate$Deflate$Internal$encodeDynamicBlock(windowSize),
			A2($folkertdev$elm_flate$Deflate$Internal$chunks, $folkertdev$elm_flate$Deflate$Internal$default_block_size, buffer));
		return $elm$bytes$Bytes$Encode$encode(
			$elm$bytes$Bytes$Encode$sequence(
				$folkertdev$elm_flate$Deflate$BitWriter$run(
					$folkertdev$elm_flate$Deflate$BitWriter$flush(
						A3(
							$elm$core$List$foldl,
							F2(
								function (chunk, first) {
									return chunk(first);
								}),
							$folkertdev$elm_flate$Deflate$BitWriter$empty,
							encodedChunks)))));
	});
var $elm$core$Bitwise$complement = _Bitwise_complement;
var $folkertdev$elm_flate$Deflate$Internal$max_non_compressed_block_size = 65535;
var $elm$core$Array$sliceLeft = F2(
	function (from, array) {
		var len = array.a;
		var tree = array.c;
		var tail = array.d;
		if (!from) {
			return array;
		} else {
			if (_Utils_cmp(
				from,
				$elm$core$Array$tailIndex(len)) > -1) {
				return A4(
					$elm$core$Array$Array_elm_builtin,
					len - from,
					$elm$core$Array$shiftStep,
					$elm$core$Elm$JsArray$empty,
					A3(
						$elm$core$Elm$JsArray$slice,
						from - $elm$core$Array$tailIndex(len),
						$elm$core$Elm$JsArray$length(tail),
						tail));
			} else {
				var skipNodes = (from / $elm$core$Array$branchFactor) | 0;
				var helper = F2(
					function (node, acc) {
						if (!node.$) {
							var subTree = node.a;
							return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
						} else {
							var leaf = node.a;
							return A2($elm$core$List$cons, leaf, acc);
						}
					});
				var leafNodes = A3(
					$elm$core$Elm$JsArray$foldr,
					helper,
					_List_fromArray(
						[tail]),
					tree);
				var nodesToInsert = A2($elm$core$List$drop, skipNodes, leafNodes);
				if (!nodesToInsert.b) {
					return $elm$core$Array$empty;
				} else {
					var head = nodesToInsert.a;
					var rest = nodesToInsert.b;
					var firstSlice = from - (skipNodes * $elm$core$Array$branchFactor);
					var initialBuilder = {
						fe: _List_Nil,
						dt: 0,
						eQ: A3(
							$elm$core$Elm$JsArray$slice,
							firstSlice,
							$elm$core$Elm$JsArray$length(head),
							head)
					};
					return A2(
						$elm$core$Array$builderToArray,
						true,
						A3($elm$core$List$foldl, $elm$core$Array$appendHelpBuilder, initialBuilder, rest));
				}
			}
		}
	});
var $elm$core$Array$fetchNewTail = F4(
	function (shift, end, treeEnd, tree) {
		fetchNewTail:
		while (true) {
			var pos = $elm$core$Array$bitMask & (treeEnd >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var sub = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$end = end,
					$temp$treeEnd = treeEnd,
					$temp$tree = sub;
				shift = $temp$shift;
				end = $temp$end;
				treeEnd = $temp$treeEnd;
				tree = $temp$tree;
				continue fetchNewTail;
			} else {
				var values = _v0.a;
				return A3($elm$core$Elm$JsArray$slice, 0, $elm$core$Array$bitMask & end, values);
			}
		}
	});
var $elm$core$Array$hoistTree = F3(
	function (oldShift, newShift, tree) {
		hoistTree:
		while (true) {
			if ((_Utils_cmp(oldShift, newShift) < 1) || (!$elm$core$Elm$JsArray$length(tree))) {
				return tree;
			} else {
				var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, 0, tree);
				if (!_v0.$) {
					var sub = _v0.a;
					var $temp$oldShift = oldShift - $elm$core$Array$shiftStep,
						$temp$newShift = newShift,
						$temp$tree = sub;
					oldShift = $temp$oldShift;
					newShift = $temp$newShift;
					tree = $temp$tree;
					continue hoistTree;
				} else {
					return tree;
				}
			}
		}
	});
var $elm$core$Array$sliceTree = F3(
	function (shift, endIdx, tree) {
		var lastPos = $elm$core$Array$bitMask & (endIdx >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, lastPos, tree);
		if (!_v0.$) {
			var sub = _v0.a;
			var newSub = A3($elm$core$Array$sliceTree, shift - $elm$core$Array$shiftStep, endIdx, sub);
			return (!$elm$core$Elm$JsArray$length(newSub)) ? A3($elm$core$Elm$JsArray$slice, 0, lastPos, tree) : A3(
				$elm$core$Elm$JsArray$unsafeSet,
				lastPos,
				$elm$core$Array$SubTree(newSub),
				A3($elm$core$Elm$JsArray$slice, 0, lastPos + 1, tree));
		} else {
			return A3($elm$core$Elm$JsArray$slice, 0, lastPos, tree);
		}
	});
var $elm$core$Array$sliceRight = F2(
	function (end, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		if (_Utils_eq(end, len)) {
			return array;
		} else {
			if (_Utils_cmp(
				end,
				$elm$core$Array$tailIndex(len)) > -1) {
				return A4(
					$elm$core$Array$Array_elm_builtin,
					end,
					startShift,
					tree,
					A3($elm$core$Elm$JsArray$slice, 0, $elm$core$Array$bitMask & end, tail));
			} else {
				var endIdx = $elm$core$Array$tailIndex(end);
				var depth = $elm$core$Basics$floor(
					A2(
						$elm$core$Basics$logBase,
						$elm$core$Array$branchFactor,
						A2($elm$core$Basics$max, 1, endIdx - 1)));
				var newShift = A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep);
				return A4(
					$elm$core$Array$Array_elm_builtin,
					end,
					newShift,
					A3(
						$elm$core$Array$hoistTree,
						startShift,
						newShift,
						A3($elm$core$Array$sliceTree, startShift, endIdx, tree)),
					A4($elm$core$Array$fetchNewTail, startShift, end, endIdx, tree));
			}
		}
	});
var $elm$core$Array$translateIndex = F2(
	function (index, _v0) {
		var len = _v0.a;
		var posIndex = (index < 0) ? (len + index) : index;
		return (posIndex < 0) ? 0 : ((_Utils_cmp(posIndex, len) > 0) ? len : posIndex);
	});
var $elm$core$Array$slice = F3(
	function (from, to, array) {
		var correctTo = A2($elm$core$Array$translateIndex, to, array);
		var correctFrom = A2($elm$core$Array$translateIndex, from, array);
		return (_Utils_cmp(correctFrom, correctTo) > 0) ? $elm$core$Array$empty : A2(
			$elm$core$Array$sliceLeft,
			correctFrom,
			A2($elm$core$Array$sliceRight, correctTo, array));
	});
var $elm$bytes$Bytes$Encode$U32 = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$unsignedInt32 = $elm$bytes$Bytes$Encode$U32;
var $folkertdev$elm_flate$ByteArray$fasterEncodeFolderR = F2(
	function (_byte, _v0) {
		var bytesOnAccum = _v0.a;
		var accum = _v0.b;
		var encoders = _v0.c;
		switch (bytesOnAccum) {
			case 0:
				var value = 255 & _byte;
				return _Utils_Tuple3(1, value, encoders);
			case 1:
				var value = accum | ((255 & _byte) << 8);
				return _Utils_Tuple3(2, value, encoders);
			case 2:
				var value = accum | ((255 & _byte) << 16);
				return _Utils_Tuple3(3, value, encoders);
			default:
				var value = accum | ((255 & _byte) << 24);
				return _Utils_Tuple3(
					0,
					0,
					A2(
						$elm$core$List$cons,
						A2($elm$bytes$Bytes$Encode$unsignedInt32, 1, value),
						encoders));
		}
	});
var $folkertdev$elm_flate$ByteArray$fasterEncodeR = function (_v0) {
	var bytesOnAccum = _v0.a;
	var accum = _v0.b;
	var otherEncoders = _v0.c;
	var encoders = function () {
		switch (bytesOnAccum) {
			case 0:
				return otherEncoders;
			case 1:
				return A2(
					$elm$core$List$cons,
					$elm$bytes$Bytes$Encode$unsignedInt8(accum),
					otherEncoders);
			case 2:
				return A2(
					$elm$core$List$cons,
					A2($elm$bytes$Bytes$Encode$unsignedInt16, 1, accum),
					otherEncoders);
			default:
				var otherBytes = accum >> 8;
				var firstByte = 255 & accum;
				return A2(
					$elm$core$List$cons,
					A2($elm$bytes$Bytes$Encode$unsignedInt16, 1, otherBytes),
					A2(
						$elm$core$List$cons,
						$elm$bytes$Bytes$Encode$unsignedInt8(firstByte),
						otherEncoders));
		}
	}();
	return encoders;
};
var $folkertdev$elm_flate$ByteArray$toBytes = function (array) {
	return $elm$bytes$Bytes$Encode$encode(
		$elm$bytes$Bytes$Encode$sequence(
			$folkertdev$elm_flate$ByteArray$fasterEncodeR(
				A3(
					$elm$core$Array$foldr,
					$folkertdev$elm_flate$ByteArray$fasterEncodeFolderR,
					_Utils_Tuple3(0, 0, _List_Nil),
					array))));
};
var $folkertdev$elm_flate$Deflate$BitWriter$writeEncoder = F2(
	function (encoder, state) {
		return {
			hl: state.hl,
			hv: A2($elm$core$List$cons, encoder, state.hv),
			wB: state.wB
		};
	});
var $folkertdev$elm_flate$Deflate$Internal$encodeRawBlock = F2(
	function (_v0, bitWriter) {
		var isLastBlock = _v0.a;
		var buffer = _v0.b;
		var byteArray = $folkertdev$elm_flate$ByteArray$fromBytes(buffer);
		var size = A2(
			$elm$core$Basics$min,
			$elm$core$Array$length(byteArray),
			$folkertdev$elm_flate$Deflate$Internal$max_non_compressed_block_size);
		var sliced = A3($elm$core$Array$slice, 0, size, byteArray);
		return A2(
			$folkertdev$elm_flate$Deflate$BitWriter$writeEncoder,
			$elm$bytes$Bytes$Encode$bytes(
				$folkertdev$elm_flate$ByteArray$toBytes(sliced)),
			A2(
				$folkertdev$elm_flate$Deflate$BitWriter$writeEncoder,
				A2($elm$bytes$Bytes$Encode$unsignedInt16, 0, ~size),
				A2(
					$folkertdev$elm_flate$Deflate$BitWriter$writeEncoder,
					A2($elm$bytes$Bytes$Encode$unsignedInt16, 0, size),
					$folkertdev$elm_flate$Deflate$BitWriter$flush(
						A3(
							$folkertdev$elm_flate$Deflate$BitWriter$writeBits,
							2,
							0,
							A2($folkertdev$elm_flate$Deflate$BitWriter$writeBit, isLastBlock, bitWriter))))));
	});
var $folkertdev$elm_flate$Deflate$Internal$encodeRaw = function (buffer) {
	return $elm$bytes$Bytes$Encode$encode(
		$elm$bytes$Bytes$Encode$sequence(
			$folkertdev$elm_flate$Deflate$BitWriter$run(
				A3(
					$elm$core$List$foldl,
					F2(
						function (chunk, first) {
							return A2($folkertdev$elm_flate$Deflate$Internal$encodeRawBlock, chunk, first);
						}),
					$folkertdev$elm_flate$Deflate$BitWriter$empty,
					A2(
						$folkertdev$elm_flate$Deflate$Internal$chunks,
						A2($elm$core$Basics$min, $folkertdev$elm_flate$Deflate$Internal$max_non_compressed_block_size, $folkertdev$elm_flate$Deflate$Internal$default_block_size),
						buffer)))));
};
var $folkertdev$elm_flate$Huffman$fromList = A2(
	$elm$core$Basics$composeL,
	A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $elm$core$Array$fromList),
	$elm$core$List$map($folkertdev$elm_flate$Huffman$codeFromRecord));
var $folkertdev$elm_flate$Huffman$hardcodedStaticHuffmanTree = {
	jR: $folkertdev$elm_flate$Huffman$fromList(
		_List_fromArray(
			[
				{jG: 0, AR: 5},
				{jG: 16, AR: 5},
				{jG: 8, AR: 5},
				{jG: 24, AR: 5},
				{jG: 4, AR: 5},
				{jG: 20, AR: 5},
				{jG: 12, AR: 5},
				{jG: 28, AR: 5},
				{jG: 2, AR: 5},
				{jG: 18, AR: 5},
				{jG: 10, AR: 5},
				{jG: 26, AR: 5},
				{jG: 6, AR: 5},
				{jG: 22, AR: 5},
				{jG: 14, AR: 5},
				{jG: 30, AR: 5},
				{jG: 1, AR: 5},
				{jG: 17, AR: 5},
				{jG: 9, AR: 5},
				{jG: 25, AR: 5},
				{jG: 5, AR: 5},
				{jG: 21, AR: 5},
				{jG: 13, AR: 5},
				{jG: 29, AR: 5},
				{jG: 3, AR: 5},
				{jG: 19, AR: 5},
				{jG: 11, AR: 5},
				{jG: 27, AR: 5},
				{jG: 7, AR: 5},
				{jG: 23, AR: 5}
			])),
	j4: $folkertdev$elm_flate$Huffman$fromList(
		_List_fromArray(
			[
				{jG: 12, AR: 8},
				{jG: 140, AR: 8},
				{jG: 76, AR: 8},
				{jG: 204, AR: 8},
				{jG: 44, AR: 8},
				{jG: 172, AR: 8},
				{jG: 108, AR: 8},
				{jG: 236, AR: 8},
				{jG: 28, AR: 8},
				{jG: 156, AR: 8},
				{jG: 92, AR: 8},
				{jG: 220, AR: 8},
				{jG: 60, AR: 8},
				{jG: 188, AR: 8},
				{jG: 124, AR: 8},
				{jG: 252, AR: 8},
				{jG: 2, AR: 8},
				{jG: 130, AR: 8},
				{jG: 66, AR: 8},
				{jG: 194, AR: 8},
				{jG: 34, AR: 8},
				{jG: 162, AR: 8},
				{jG: 98, AR: 8},
				{jG: 226, AR: 8},
				{jG: 18, AR: 8},
				{jG: 146, AR: 8},
				{jG: 82, AR: 8},
				{jG: 210, AR: 8},
				{jG: 50, AR: 8},
				{jG: 178, AR: 8},
				{jG: 114, AR: 8},
				{jG: 242, AR: 8},
				{jG: 10, AR: 8},
				{jG: 138, AR: 8},
				{jG: 74, AR: 8},
				{jG: 202, AR: 8},
				{jG: 42, AR: 8},
				{jG: 170, AR: 8},
				{jG: 106, AR: 8},
				{jG: 234, AR: 8},
				{jG: 26, AR: 8},
				{jG: 154, AR: 8},
				{jG: 90, AR: 8},
				{jG: 218, AR: 8},
				{jG: 58, AR: 8},
				{jG: 186, AR: 8},
				{jG: 122, AR: 8},
				{jG: 250, AR: 8},
				{jG: 6, AR: 8},
				{jG: 134, AR: 8},
				{jG: 70, AR: 8},
				{jG: 198, AR: 8},
				{jG: 38, AR: 8},
				{jG: 166, AR: 8},
				{jG: 102, AR: 8},
				{jG: 230, AR: 8},
				{jG: 22, AR: 8},
				{jG: 150, AR: 8},
				{jG: 86, AR: 8},
				{jG: 214, AR: 8},
				{jG: 54, AR: 8},
				{jG: 182, AR: 8},
				{jG: 118, AR: 8},
				{jG: 246, AR: 8},
				{jG: 14, AR: 8},
				{jG: 142, AR: 8},
				{jG: 78, AR: 8},
				{jG: 206, AR: 8},
				{jG: 46, AR: 8},
				{jG: 174, AR: 8},
				{jG: 110, AR: 8},
				{jG: 238, AR: 8},
				{jG: 30, AR: 8},
				{jG: 158, AR: 8},
				{jG: 94, AR: 8},
				{jG: 222, AR: 8},
				{jG: 62, AR: 8},
				{jG: 190, AR: 8},
				{jG: 126, AR: 8},
				{jG: 254, AR: 8},
				{jG: 1, AR: 8},
				{jG: 129, AR: 8},
				{jG: 65, AR: 8},
				{jG: 193, AR: 8},
				{jG: 33, AR: 8},
				{jG: 161, AR: 8},
				{jG: 97, AR: 8},
				{jG: 225, AR: 8},
				{jG: 17, AR: 8},
				{jG: 145, AR: 8},
				{jG: 81, AR: 8},
				{jG: 209, AR: 8},
				{jG: 49, AR: 8},
				{jG: 177, AR: 8},
				{jG: 113, AR: 8},
				{jG: 241, AR: 8},
				{jG: 9, AR: 8},
				{jG: 137, AR: 8},
				{jG: 73, AR: 8},
				{jG: 201, AR: 8},
				{jG: 41, AR: 8},
				{jG: 169, AR: 8},
				{jG: 105, AR: 8},
				{jG: 233, AR: 8},
				{jG: 25, AR: 8},
				{jG: 153, AR: 8},
				{jG: 89, AR: 8},
				{jG: 217, AR: 8},
				{jG: 57, AR: 8},
				{jG: 185, AR: 8},
				{jG: 121, AR: 8},
				{jG: 249, AR: 8},
				{jG: 5, AR: 8},
				{jG: 133, AR: 8},
				{jG: 69, AR: 8},
				{jG: 197, AR: 8},
				{jG: 37, AR: 8},
				{jG: 165, AR: 8},
				{jG: 101, AR: 8},
				{jG: 229, AR: 8},
				{jG: 21, AR: 8},
				{jG: 149, AR: 8},
				{jG: 85, AR: 8},
				{jG: 213, AR: 8},
				{jG: 53, AR: 8},
				{jG: 181, AR: 8},
				{jG: 117, AR: 8},
				{jG: 245, AR: 8},
				{jG: 13, AR: 8},
				{jG: 141, AR: 8},
				{jG: 77, AR: 8},
				{jG: 205, AR: 8},
				{jG: 45, AR: 8},
				{jG: 173, AR: 8},
				{jG: 109, AR: 8},
				{jG: 237, AR: 8},
				{jG: 29, AR: 8},
				{jG: 157, AR: 8},
				{jG: 93, AR: 8},
				{jG: 221, AR: 8},
				{jG: 61, AR: 8},
				{jG: 189, AR: 8},
				{jG: 125, AR: 8},
				{jG: 253, AR: 8},
				{jG: 19, AR: 9},
				{jG: 275, AR: 9},
				{jG: 147, AR: 9},
				{jG: 403, AR: 9},
				{jG: 83, AR: 9},
				{jG: 339, AR: 9},
				{jG: 211, AR: 9},
				{jG: 467, AR: 9},
				{jG: 51, AR: 9},
				{jG: 307, AR: 9},
				{jG: 179, AR: 9},
				{jG: 435, AR: 9},
				{jG: 115, AR: 9},
				{jG: 371, AR: 9},
				{jG: 243, AR: 9},
				{jG: 499, AR: 9},
				{jG: 11, AR: 9},
				{jG: 267, AR: 9},
				{jG: 139, AR: 9},
				{jG: 395, AR: 9},
				{jG: 75, AR: 9},
				{jG: 331, AR: 9},
				{jG: 203, AR: 9},
				{jG: 459, AR: 9},
				{jG: 43, AR: 9},
				{jG: 299, AR: 9},
				{jG: 171, AR: 9},
				{jG: 427, AR: 9},
				{jG: 107, AR: 9},
				{jG: 363, AR: 9},
				{jG: 235, AR: 9},
				{jG: 491, AR: 9},
				{jG: 27, AR: 9},
				{jG: 283, AR: 9},
				{jG: 155, AR: 9},
				{jG: 411, AR: 9},
				{jG: 91, AR: 9},
				{jG: 347, AR: 9},
				{jG: 219, AR: 9},
				{jG: 475, AR: 9},
				{jG: 59, AR: 9},
				{jG: 315, AR: 9},
				{jG: 187, AR: 9},
				{jG: 443, AR: 9},
				{jG: 123, AR: 9},
				{jG: 379, AR: 9},
				{jG: 251, AR: 9},
				{jG: 507, AR: 9},
				{jG: 7, AR: 9},
				{jG: 263, AR: 9},
				{jG: 135, AR: 9},
				{jG: 391, AR: 9},
				{jG: 71, AR: 9},
				{jG: 327, AR: 9},
				{jG: 199, AR: 9},
				{jG: 455, AR: 9},
				{jG: 39, AR: 9},
				{jG: 295, AR: 9},
				{jG: 167, AR: 9},
				{jG: 423, AR: 9},
				{jG: 103, AR: 9},
				{jG: 359, AR: 9},
				{jG: 231, AR: 9},
				{jG: 487, AR: 9},
				{jG: 23, AR: 9},
				{jG: 279, AR: 9},
				{jG: 151, AR: 9},
				{jG: 407, AR: 9},
				{jG: 87, AR: 9},
				{jG: 343, AR: 9},
				{jG: 215, AR: 9},
				{jG: 471, AR: 9},
				{jG: 55, AR: 9},
				{jG: 311, AR: 9},
				{jG: 183, AR: 9},
				{jG: 439, AR: 9},
				{jG: 119, AR: 9},
				{jG: 375, AR: 9},
				{jG: 247, AR: 9},
				{jG: 503, AR: 9},
				{jG: 15, AR: 9},
				{jG: 271, AR: 9},
				{jG: 143, AR: 9},
				{jG: 399, AR: 9},
				{jG: 79, AR: 9},
				{jG: 335, AR: 9},
				{jG: 207, AR: 9},
				{jG: 463, AR: 9},
				{jG: 47, AR: 9},
				{jG: 303, AR: 9},
				{jG: 175, AR: 9},
				{jG: 431, AR: 9},
				{jG: 111, AR: 9},
				{jG: 367, AR: 9},
				{jG: 239, AR: 9},
				{jG: 495, AR: 9},
				{jG: 31, AR: 9},
				{jG: 287, AR: 9},
				{jG: 159, AR: 9},
				{jG: 415, AR: 9},
				{jG: 95, AR: 9},
				{jG: 351, AR: 9},
				{jG: 223, AR: 9},
				{jG: 479, AR: 9},
				{jG: 63, AR: 9},
				{jG: 319, AR: 9},
				{jG: 191, AR: 9},
				{jG: 447, AR: 9},
				{jG: 127, AR: 9},
				{jG: 383, AR: 9},
				{jG: 255, AR: 9},
				{jG: 511, AR: 9},
				{jG: 0, AR: 7},
				{jG: 64, AR: 7},
				{jG: 32, AR: 7},
				{jG: 96, AR: 7},
				{jG: 16, AR: 7},
				{jG: 80, AR: 7},
				{jG: 48, AR: 7},
				{jG: 112, AR: 7},
				{jG: 8, AR: 7},
				{jG: 72, AR: 7},
				{jG: 40, AR: 7},
				{jG: 104, AR: 7},
				{jG: 24, AR: 7},
				{jG: 88, AR: 7},
				{jG: 56, AR: 7},
				{jG: 120, AR: 7},
				{jG: 4, AR: 7},
				{jG: 68, AR: 7},
				{jG: 36, AR: 7},
				{jG: 100, AR: 7},
				{jG: 20, AR: 7},
				{jG: 84, AR: 7},
				{jG: 52, AR: 7},
				{jG: 116, AR: 7},
				{jG: 3, AR: 8},
				{jG: 131, AR: 8},
				{jG: 67, AR: 8},
				{jG: 195, AR: 8},
				{jG: 35, AR: 8},
				{jG: 163, AR: 8},
				{jG: 99, AR: 8},
				{jG: 227, AR: 8}
			]))
};
var $folkertdev$elm_flate$Deflate$Internal$encodeCompressStatic = F3(
	function (maybeWindowSize, buf, bitWriter) {
		var huffmanTrees = $folkertdev$elm_flate$Huffman$hardcodedStaticHuffmanTree;
		var compressed = A2($folkertdev$elm_flate$Deflate$Internal$compress, maybeWindowSize, buf);
		return A3(
			$elm$core$Array$foldl,
			F2(
				function (symbol, first) {
					return A3($folkertdev$elm_flate$Deflate$Symbol$encode, symbol, huffmanTrees, first);
				}),
			bitWriter,
			compressed);
	});
var $folkertdev$elm_flate$Deflate$Internal$encodeStaticBlock = F3(
	function (windowSize, _v0, bitWriter) {
		var isLastBlock = _v0.a;
		var buffer = _v0.b;
		return A3(
			$folkertdev$elm_flate$Deflate$Internal$encodeCompressStatic,
			windowSize,
			buffer,
			A3(
				$folkertdev$elm_flate$Deflate$BitWriter$writeBits,
				2,
				1,
				A2($folkertdev$elm_flate$Deflate$BitWriter$writeBit, isLastBlock, bitWriter)));
	});
var $folkertdev$elm_flate$Deflate$Internal$encodeStatic = F2(
	function (windowSize, buffer) {
		return $elm$bytes$Bytes$Encode$encode(
			$elm$bytes$Bytes$Encode$sequence(
				$folkertdev$elm_flate$Deflate$BitWriter$run(
					$folkertdev$elm_flate$Deflate$BitWriter$flush(
						A3(
							$elm$core$List$foldl,
							F2(
								function (chunk, first) {
									return A3($folkertdev$elm_flate$Deflate$Internal$encodeStaticBlock, windowSize, chunk, first);
								}),
							$folkertdev$elm_flate$Deflate$BitWriter$empty,
							A2($folkertdev$elm_flate$Deflate$Internal$chunks, $folkertdev$elm_flate$Deflate$Internal$default_block_size, buffer))))));
	});
var $folkertdev$elm_flate$Flate$deflateWithOptions = F2(
	function (encoding, buffer) {
		switch (encoding.$) {
			case 0:
				return $folkertdev$elm_flate$Deflate$Internal$encodeRaw(buffer);
			case 2:
				if (!encoding.a.$) {
					var _v1 = encoding.a;
					return A2($folkertdev$elm_flate$Deflate$Internal$encodeStatic, $elm$core$Maybe$Nothing, buffer);
				} else {
					var w = encoding.a.a;
					return A2(
						$folkertdev$elm_flate$Deflate$Internal$encodeStatic,
						$elm$core$Maybe$Just(w),
						buffer);
				}
			default:
				if (!encoding.a.$) {
					var _v2 = encoding.a;
					return A2($folkertdev$elm_flate$Deflate$Internal$encodeDynamic, $elm$core$Maybe$Nothing, buffer);
				} else {
					var w = encoding.a.a;
					return A2(
						$folkertdev$elm_flate$Deflate$Internal$encodeDynamic,
						$elm$core$Maybe$Just(w),
						buffer);
				}
		}
	});
var $folkertdev$elm_flate$Flate$deflateGZipWithOptions = F2(
	function (encoding, buffer) {
		var encodedTrailer = _List_fromArray(
			[
				A2(
				$elm$bytes$Bytes$Encode$unsignedInt32,
				0,
				$folkertdev$elm_flate$Checksum$Crc32$crc32(buffer)),
				A2(
				$elm$bytes$Bytes$Encode$unsignedInt32,
				0,
				A2(
					$elm$core$Basics$modBy,
					4294967296,
					$elm$bytes$Bytes$width(buffer)))
			]);
		var encodedHeader = _List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(31),
				$elm$bytes$Bytes$Encode$unsignedInt8(139),
				$elm$bytes$Bytes$Encode$unsignedInt8(8),
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				A2($elm$bytes$Bytes$Encode$unsignedInt32, 0, 0),
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$elm$bytes$Bytes$Encode$unsignedInt8(255)
			]);
		var data = A2($folkertdev$elm_flate$Flate$deflateWithOptions, encoding, buffer);
		return $elm$bytes$Bytes$Encode$encode(
			$elm$bytes$Bytes$Encode$sequence(
				_Utils_ap(
					encodedHeader,
					_Utils_ap(
						_List_fromArray(
							[
								$elm$bytes$Bytes$Encode$bytes(data)
							]),
						encodedTrailer))));
	});
var $folkertdev$elm_flate$LZ77$max_distance = 32768;
var $folkertdev$elm_flate$LZ77$maxWindowSize = $folkertdev$elm_flate$LZ77$max_distance;
var $folkertdev$elm_flate$Flate$deflateGZip = $folkertdev$elm_flate$Flate$deflateGZipWithOptions(
	$folkertdev$elm_flate$Flate$Dynamic(
		$folkertdev$elm_flate$Flate$WithWindowSize($folkertdev$elm_flate$LZ77$maxWindowSize)));
var $author$project$Request$SBOMIngestion$createProject = F2(
	function (creds, args) {
		var _v0 = function () {
			var _v1 = args.sY;
			if (_v1.$ === 1) {
				var bytes = _v1.a;
				return _Utils_Tuple2(
					A2(
						$elm$http$Http$bytesBody,
						'application/json',
						$folkertdev$elm_flate$Flate$deflateGZip(bytes)),
					_List_fromArray(
						[
							_Utils_Tuple2('Content-Encoding', 'gzip')
						]));
			} else {
				var value = _v1.a;
				return _Utils_Tuple2(
					$author$project$Http$Extra$jsonBody(value),
					_List_Nil);
			}
		}();
		var body = _v0.a;
		var headers = _v0.b;
		return $author$project$Http$Extra$post(
			{
				iO: $author$project$Http$Extra$HeaderOnly(creds),
				sY: body,
				qN: $elm$json$Json$Decode$succeed(0),
				CN: headers,
				GT: '/sv/scans/organizations/' + (args.E_ + ('/projects/' + (args.vT + '/init')))
			});
	});
var $author$project$Request$SBOMIngestion$Bytes = function (a) {
	return {$: 1, a: a};
};
var $author$project$Request$SBOMIngestion$Value = function (a) {
	return {$: 0, a: a};
};
var $author$project$Request$SBOMIngestion$compressAbove = $elm$core$Basics$round((3.5 * 1024) * 1024);
var $author$project$Request$SBOMIngestion$encodeInputSBOM = function (sbom) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'filename',
				$elm$json$Json$Encode$string(sbom.CG)),
				_Utils_Tuple2(
				'data',
				$elm$json$Json$Encode$string(sbom.hu)),
				_Utils_Tuple2(
				'key',
				$elm$json$Json$Encode$string(sbom.Y))
			]));
};
var $author$project$Request$SBOMIngestion$encodeInputBody = function (input) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'private',
				$elm$json$Json$Encode$bool(input.cd)),
				_Utils_Tuple2(
				'sboms',
				A2($elm$json$Json$Encode$list, $author$project$Request$SBOMIngestion$encodeInputSBOM, input.zX))
			]));
};
var $elm$bytes$Bytes$Encode$Utf8 = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$string = function (str) {
	return A2(
		$elm$bytes$Bytes$Encode$Utf8,
		_Bytes_getStringWidth(str),
		str);
};
var $author$project$Request$SBOMIngestion$createProjectArgs = function (input) {
	var value = $author$project$Request$SBOMIngestion$encodeInputBody(input);
	var bytes = $elm$bytes$Bytes$Encode$encode(
		$elm$bytes$Bytes$Encode$string(
			A2($elm$json$Json$Encode$encode, 0, value)));
	return {
		sY: (_Utils_cmp(
			$elm$bytes$Bytes$width(bytes),
			$author$project$Request$SBOMIngestion$compressAbove) > 0) ? $author$project$Request$SBOMIngestion$Bytes(bytes) : $author$project$Request$SBOMIngestion$Value(value),
		E_: input.E_,
		vT: input.vT
	};
};
var $danfishgold$base64_bytes$Decode$lowest6BitsMask = 63;
var $danfishgold$base64_bytes$Decode$unsafeToChar = function (n) {
	if (n <= 25) {
		return $elm$core$Char$fromCode(65 + n);
	} else {
		if (n <= 51) {
			return $elm$core$Char$fromCode(97 + (n - 26));
		} else {
			if (n <= 61) {
				return $elm$core$Char$fromCode(48 + (n - 52));
			} else {
				switch (n) {
					case 62:
						return '+';
					case 63:
						return '/';
					default:
						return '\u0000';
				}
			}
		}
	}
};
var $danfishgold$base64_bytes$Decode$bitsToChars = F2(
	function (bits, missing) {
		var s = $danfishgold$base64_bytes$Decode$unsafeToChar(bits & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
		var r = $danfishgold$base64_bytes$Decode$unsafeToChar((bits >>> 6) & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
		var q = $danfishgold$base64_bytes$Decode$unsafeToChar((bits >>> 12) & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
		var p = $danfishgold$base64_bytes$Decode$unsafeToChar(bits >>> 18);
		switch (missing) {
			case 0:
				return A2(
					$elm$core$String$cons,
					p,
					A2(
						$elm$core$String$cons,
						q,
						A2(
							$elm$core$String$cons,
							r,
							$elm$core$String$fromChar(s))));
			case 1:
				return A2(
					$elm$core$String$cons,
					p,
					A2(
						$elm$core$String$cons,
						q,
						A2($elm$core$String$cons, r, '=')));
			case 2:
				return A2(
					$elm$core$String$cons,
					p,
					A2($elm$core$String$cons, q, '=='));
			default:
				return '';
		}
	});
var $danfishgold$base64_bytes$Decode$bitsToCharSpecialized = F4(
	function (bits1, bits2, bits3, accum) {
		var z = $danfishgold$base64_bytes$Decode$unsafeToChar((bits3 >>> 6) & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
		var y = $danfishgold$base64_bytes$Decode$unsafeToChar((bits3 >>> 12) & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
		var x = $danfishgold$base64_bytes$Decode$unsafeToChar(bits3 >>> 18);
		var w = $danfishgold$base64_bytes$Decode$unsafeToChar(bits3 & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
		var s = $danfishgold$base64_bytes$Decode$unsafeToChar(bits1 & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
		var r = $danfishgold$base64_bytes$Decode$unsafeToChar((bits1 >>> 6) & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
		var q = $danfishgold$base64_bytes$Decode$unsafeToChar((bits1 >>> 12) & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
		var p = $danfishgold$base64_bytes$Decode$unsafeToChar(bits1 >>> 18);
		var d = $danfishgold$base64_bytes$Decode$unsafeToChar(bits2 & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
		var c = $danfishgold$base64_bytes$Decode$unsafeToChar((bits2 >>> 6) & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
		var b = $danfishgold$base64_bytes$Decode$unsafeToChar((bits2 >>> 12) & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
		var a = $danfishgold$base64_bytes$Decode$unsafeToChar(bits2 >>> 18);
		return A2(
			$elm$core$String$cons,
			x,
			A2(
				$elm$core$String$cons,
				y,
				A2(
					$elm$core$String$cons,
					z,
					A2(
						$elm$core$String$cons,
						w,
						A2(
							$elm$core$String$cons,
							a,
							A2(
								$elm$core$String$cons,
								b,
								A2(
									$elm$core$String$cons,
									c,
									A2(
										$elm$core$String$cons,
										d,
										A2(
											$elm$core$String$cons,
											p,
											A2(
												$elm$core$String$cons,
												q,
												A2(
													$elm$core$String$cons,
													r,
													A2($elm$core$String$cons, s, accum))))))))))));
	});
var $danfishgold$base64_bytes$Decode$decode18Help = F5(
	function (a, b, c, d, e) {
		var combined6 = ((255 & d) << 16) | e;
		var combined5 = d >>> 8;
		var combined4 = 16777215 & c;
		var combined3 = ((65535 & b) << 8) | (c >>> 24);
		var combined2 = ((255 & a) << 16) | (b >>> 16);
		var combined1 = a >>> 8;
		return A4(
			$danfishgold$base64_bytes$Decode$bitsToCharSpecialized,
			combined3,
			combined2,
			combined1,
			A4($danfishgold$base64_bytes$Decode$bitsToCharSpecialized, combined6, combined5, combined4, ''));
	});
var $danfishgold$base64_bytes$Decode$u16BE = $elm$bytes$Bytes$Decode$unsignedInt16(1);
var $danfishgold$base64_bytes$Decode$u32BE = $elm$bytes$Bytes$Decode$unsignedInt32(1);
var $danfishgold$base64_bytes$Decode$decode18Bytes = A6($elm$bytes$Bytes$Decode$map5, $danfishgold$base64_bytes$Decode$decode18Help, $danfishgold$base64_bytes$Decode$u32BE, $danfishgold$base64_bytes$Decode$u32BE, $danfishgold$base64_bytes$Decode$u32BE, $danfishgold$base64_bytes$Decode$u32BE, $danfishgold$base64_bytes$Decode$u16BE);
var $elm$bytes$Bytes$Decode$map3 = F4(
	function (func, _v0, _v1, _v2) {
		var decodeA = _v0;
		var decodeB = _v1;
		var decodeC = _v2;
		return F2(
			function (bites, offset) {
				var _v3 = A2(decodeA, bites, offset);
				var aOffset = _v3.a;
				var a = _v3.b;
				var _v4 = A2(decodeB, bites, aOffset);
				var bOffset = _v4.a;
				var b = _v4.b;
				var _v5 = A2(decodeC, bites, bOffset);
				var cOffset = _v5.a;
				var c = _v5.b;
				return _Utils_Tuple2(
					cOffset,
					A3(func, a, b, c));
			});
	});
var $danfishgold$base64_bytes$Decode$loopHelp = function (_v0) {
	var remaining = _v0.r4;
	var string = _v0.nA;
	if (remaining >= 18) {
		return A2(
			$elm$bytes$Bytes$Decode$map,
			function (result) {
				return $elm$bytes$Bytes$Decode$Loop(
					{
						r4: remaining - 18,
						nA: _Utils_ap(string, result)
					});
			},
			$danfishgold$base64_bytes$Decode$decode18Bytes);
	} else {
		if (remaining >= 3) {
			var helper = F3(
				function (a, b, c) {
					var combined = ((a << 16) | (b << 8)) | c;
					return $elm$bytes$Bytes$Decode$Loop(
						{
							r4: remaining - 3,
							nA: _Utils_ap(
								string,
								A2($danfishgold$base64_bytes$Decode$bitsToChars, combined, 0))
						});
				});
			return A4($elm$bytes$Bytes$Decode$map3, helper, $elm$bytes$Bytes$Decode$unsignedInt8, $elm$bytes$Bytes$Decode$unsignedInt8, $elm$bytes$Bytes$Decode$unsignedInt8);
		} else {
			if (!remaining) {
				return $elm$bytes$Bytes$Decode$succeed(
					$elm$bytes$Bytes$Decode$Done(string));
			} else {
				if (remaining === 2) {
					var helper = F2(
						function (a, b) {
							var combined = (a << 16) | (b << 8);
							return $elm$bytes$Bytes$Decode$Done(
								_Utils_ap(
									string,
									A2($danfishgold$base64_bytes$Decode$bitsToChars, combined, 1)));
						});
					return A3($elm$bytes$Bytes$Decode$map2, helper, $elm$bytes$Bytes$Decode$unsignedInt8, $elm$bytes$Bytes$Decode$unsignedInt8);
				} else {
					return A2(
						$elm$bytes$Bytes$Decode$map,
						function (a) {
							return $elm$bytes$Bytes$Decode$Done(
								_Utils_ap(
									string,
									A2($danfishgold$base64_bytes$Decode$bitsToChars, a << 16, 2)));
						},
						$elm$bytes$Bytes$Decode$unsignedInt8);
				}
			}
		}
	}
};
var $danfishgold$base64_bytes$Decode$decoder = function (width) {
	return A2(
		$elm$bytes$Bytes$Decode$loop,
		{r4: width, nA: ''},
		$danfishgold$base64_bytes$Decode$loopHelp);
};
var $danfishgold$base64_bytes$Decode$fromBytes = function (bytes) {
	return A2(
		$elm$bytes$Bytes$Decode$decode,
		$danfishgold$base64_bytes$Decode$decoder(
			$elm$bytes$Bytes$width(bytes)),
		bytes);
};
var $danfishgold$base64_bytes$Base64$fromBytes = $danfishgold$base64_bytes$Decode$fromBytes;
var $author$project$Views$CreateProjectFromSBOM$getSubmittableFile = function (model) {
	var _v0 = _Utils_Tuple3(
		model.lU,
		$elm$core$String$isEmpty(model.vT),
		model.pt);
	if (((!_v0.a.$) && (!_v0.b)) && (_v0.c.$ === 1)) {
		var _v1 = _v0.a.a;
		var file = _v1.a;
		var contents = _v1.b;
		var _v2 = _v0.c;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(file, contents));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$file$File$name = _File_name;
var $author$project$Request$SBOMIngestion$needsCompression = function (args) {
	var _v0 = args.sY;
	if (_v0.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Views$CreateProjectFromSBOM$createProject = F2(
	function (session, model) {
		var _v0 = $author$project$Views$CreateProjectFromSBOM$getSubmittableFile(model);
		if (_v0.$ === 1) {
			return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
		} else {
			var _v1 = _v0.a;
			var file = _v1.a;
			var contents = _v1.b;
			var data = A2(
				$elm$core$Maybe$withDefault,
				'',
				$danfishgold$base64_bytes$Base64$fromBytes(
					$elm$bytes$Bytes$Encode$encode(
						$elm$bytes$Bytes$Encode$string(contents))));
			var creds = $author$project$Model$Session$getCreds(session);
			var args = $author$project$Request$SBOMIngestion$createProjectArgs(
				{
					E_: $author$project$Model$Organization$getUrlName(model.c3),
					cd: !model.p9,
					vT: $author$project$Validation$formatProjectName(model.vT),
					zX: _List_fromArray(
						[
							{
							hu: data,
							CG: $elm$file$File$name(file),
							Y: 'sbom'
						}
						])
				});
			var cmd = $author$project$Request$SBOMIngestion$needsCompression(args) ? A2(
				$elm$core$Task$perform,
				$author$project$Views$CreateProjectFromSBOM$DoSlowCreate(file),
				A2(
					$elm$core$Task$andThen,
					$elm$core$Basics$always(
						$elm$core$Task$succeed(args)),
					$elm$core$Process$sleep(5))) : A2(
				$elm$core$Task$attempt,
				A2($author$project$Views$CreateProjectFromSBOM$OnProjectCreated, file, args.vT),
				A2($author$project$Request$SBOMIngestion$createProject, creds, args));
			return A2(
				$author$project$Misc$with,
				cmd,
				_Utils_update(
					model,
					{jV: true}));
		}
	});
var $author$project$Views$CreateProjectFromSBOM$init = F2(
	function (organization, host) {
		return {
			lU: $elm$core$Maybe$Nothing,
			jV: false,
			t0: host,
			mN: $author$project$Views$NotificationsInline$init,
			c3: organization,
			vT: '',
			pt: $elm$core$Maybe$Nothing,
			p9: $author$project$Model$Permissions$orgCanCreatePrivateProject(organization) ? 0 : 1
		};
	});
var $elm_community$list_extra$List$Extra$reverseAppend = F2(
	function (list1, list2) {
		return A3($elm$core$List$foldl, $elm$core$List$cons, list2, list1);
	});
var $elm_community$list_extra$List$Extra$removeHelp = F4(
	function (list, x, xs, previousElements) {
		removeHelp:
		while (true) {
			if (!xs.b) {
				return list;
			} else {
				var y = xs.a;
				var ys = xs.b;
				if (_Utils_eq(x, y)) {
					return A2($elm_community$list_extra$List$Extra$reverseAppend, previousElements, ys);
				} else {
					var $temp$list = list,
						$temp$x = x,
						$temp$xs = ys,
						$temp$previousElements = A2($elm$core$List$cons, y, previousElements);
					list = $temp$list;
					x = $temp$x;
					xs = $temp$xs;
					previousElements = $temp$previousElements;
					continue removeHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$remove = F2(
	function (x, xs) {
		return A4($elm_community$list_extra$List$Extra$removeHelp, xs, x, xs, _List_Nil);
	});
var $author$project$Views$CreateProjectFromSBOM$None = {$: 0};
var $author$project$Views$CreateProjectFromSBOM$OnSBOMRead = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Views$CreateProjectFromSBOM$OnSBOMSelected = function (a) {
	return {$: 5, a: a};
};
var $author$project$Views$CreateProjectFromSBOM$ProjectCreated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$Analytics$categorySBOM = 'SBOM Upload';
var $author$project$Http$Extra$errorBody = function (err) {
	var _v0 = err.mp;
	if (_v0.$ === 3) {
		var response = _v0.a;
		return $elm$core$Maybe$Just(response.sY);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$file$File$Select$file = F2(
	function (mimes, toMsg) {
		return A2(
			$elm$core$Task$perform,
			toMsg,
			_File_uploadOne(mimes));
	});
var $elm$file$File$size = _File_size;
var $elm$file$File$toString = _File_toString;
var $author$project$Views$CreateProjectFromSBOM$update = F3(
	function (session, model, msg) {
		switch (msg.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$author$project$Views$CreateProjectFromSBOM$None,
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model)));
			case 1:
				var newName = msg.a;
				var projectNameError = $author$project$Validation$validateProjectName(
					$author$project$Validation$formatProjectName(newName));
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$author$project$Views$CreateProjectFromSBOM$None,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{vT: newName, pt: projectNameError}))));
			case 2:
				var visibility = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$author$project$Views$CreateProjectFromSBOM$None,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{p9: visibility}))));
			case 3:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$author$project$Views$CreateProjectFromSBOM$None,
						A2(
							$author$project$Misc$with,
							A2($elm$file$File$Select$file, _List_Nil, $author$project$Views$CreateProjectFromSBOM$OnSBOMSelected),
							model)));
			case 4:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$author$project$Views$CreateProjectFromSBOM$None,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{lU: $elm$core$Maybe$Nothing, vT: ''}))));
			case 5:
				var file = msg.a;
				var cmd = A2(
					$elm$core$Task$perform,
					$author$project$Views$CreateProjectFromSBOM$OnSBOMRead(file),
					$elm$file$File$toString(file));
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$author$project$Views$CreateProjectFromSBOM$None,
						A2($author$project$Misc$with, cmd, model)));
			case 6:
				var file = msg.a;
				var contents = msg.b;
				var newProjectName = $elm$core$String$isEmpty(model.vT) ? $elm$file$File$name(file) : model.vT;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$author$project$Views$CreateProjectFromSBOM$None,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{
									lU: $elm$core$Maybe$Just(
										_Utils_Tuple2(file, contents)),
									vT: newProjectName
								}))));
			case 7:
				var file = msg.a;
				var args = msg.b;
				var cmd = A2(
					$elm$core$Task$attempt,
					A2($author$project$Views$CreateProjectFromSBOM$OnProjectCreated, file, args.vT),
					A2(
						$author$project$Request$SBOMIngestion$createProject,
						$author$project$Model$Session$getCreds(session),
						args));
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$author$project$Views$CreateProjectFromSBOM$None,
						A2($author$project$Misc$with, cmd, model)));
			default:
				if (!msg.c.$) {
					var file = msg.a;
					var projectName = msg.b;
					var eventArgs = A2(
						$author$project$Model$Analytics$withValue,
						$elm$file$File$size(file),
						A2(
							$author$project$Model$Analytics$withLabel,
							$elm$file$File$name(file),
							A2(
								$author$project$Model$Analytics$withAction,
								'SBOM Upload - Success',
								A2(
									$author$project$Model$Analytics$withCategory,
									$author$project$Model$Analytics$categorySBOM,
									$author$project$Model$Analytics$newEvent('SBOM Upload - Success')))));
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$author$project$Views$CreateProjectFromSBOM$ProjectCreated(projectName),
							A2(
								$author$project$Misc$with,
								$author$project$Ports$sendAnalyticsEvent(eventArgs),
								model)));
				} else {
					var file = msg.a;
					var err = msg.c.a;
					var _v1 = function () {
						var _v2 = $author$project$Http$Extra$errorBody(err);
						if (!_v2.$) {
							if (_v2.a === '') {
								return _Utils_Tuple2(
									$author$project$Model$Notification$fromError(err),
									$author$project$Model$Message$reason(err));
							} else {
								var plainError = _v2.a;
								return _Utils_Tuple2(
									$author$project$Model$Notification$textWarning(plainError),
									plainError);
							}
						} else {
							return _Utils_Tuple2(
								$author$project$Model$Notification$fromError(err),
								$author$project$Model$Message$reason(err));
						}
					}();
					var notification = _v1.a;
					var errorStr = _v1.b;
					var eventArgs = A2(
						$author$project$Model$Analytics$withValue,
						$elm$file$File$size(file),
						A2(
							$author$project$Model$Analytics$withLabel,
							$elm$file$File$name(file) + ('; ' + errorStr),
							A2(
								$author$project$Model$Analytics$withAction,
								'SBOM Upload - Failure',
								A2(
									$author$project$Model$Analytics$withCategory,
									$author$project$Model$Analytics$categorySBOM,
									$author$project$Model$Analytics$newEvent('SBOM Upload - Failure')))));
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(notification),
						A2(
							$author$project$Misc$with,
							$author$project$Views$CreateProjectFromSBOM$None,
							A2(
								$author$project$Misc$with,
								$author$project$Ports$sendAnalyticsEvent(eventArgs),
								_Utils_update(
									model,
									{jV: false}))));
				}
		}
	});
var $elm_community$list_extra$List$Extra$gatherWith = F2(
	function (testFn, list) {
		var helper = F2(
			function (scattered, gathered) {
				helper:
				while (true) {
					if (!scattered.b) {
						return $elm$core$List$reverse(gathered);
					} else {
						var toGather = scattered.a;
						var population = scattered.b;
						var _v1 = A2(
							$elm$core$List$partition,
							testFn(toGather),
							population);
						var gathering = _v1.a;
						var remaining = _v1.b;
						var $temp$scattered = remaining,
							$temp$gathered = A2(
							$elm$core$List$cons,
							_Utils_Tuple2(toGather, gathering),
							gathered);
						scattered = $temp$scattered;
						gathered = $temp$gathered;
						continue helper;
					}
				}
			});
		return A2(helper, list, _List_Nil);
	});
var $author$project$Views$OrgOverview$computeMetadata = function (deps) {
	var languages = A2(
		$elm$core$List$map,
		A2($elm$core$Basics$composeR, $author$project$Model$Analytics$Fact$Dependencies$component, $author$project$Model$Analytics$DIM$Purl$language),
		deps);
	var languageCounts = A2(
		$elm$core$List$map,
		function (_v0) {
			var head = _v0.a;
			var tail = _v0.b;
			return _Utils_Tuple2(
				$author$project$Model$Analytics$DIM$Purl$languageDisplayString(head),
				$elm$core$List$length(tail) + 1);
		},
		A2($elm_community$list_extra$List$Extra$gatherWith, $elm$core$Basics$eq, languages));
	var totalLanguages = A2(
		$elm$core$Basics$max,
		1,
		A3(
			$elm$core$List$foldl,
			A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$Basics$add),
			0,
			languageCounts));
	var ensure100PercentTotal = function (k) {
		ensure100PercentTotal:
		while (true) {
			var denom = totalLanguages + k;
			var languagePercentages = function () {
				var num = function (n) {
					return (100 * n) + k;
				};
				return A2(
					$elm$core$List$map,
					$elm$core$Tuple$mapSecond(
						function (n) {
							return $elm$core$Basics$ceiling(
								num(n) / denom);
						}),
					languageCounts);
			}();
			var totalLanguagePercentage = A3(
				$elm$core$List$foldl,
				A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$Basics$add),
				0,
				languagePercentages);
			if ((k < 1000) && (totalLanguagePercentage > 100)) {
				var $temp$k = k + 1;
				k = $temp$k;
				continue ensure100PercentTotal;
			} else {
				return languagePercentages;
			}
		}
	};
	return {
		us: ensure100PercentTotal(0),
		Av: $elm$core$List$length(deps)
	};
};
var $elm$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			if (dict.$ === -2) {
				return n;
			} else {
				var left = dict.d;
				var right = dict.e;
				var $temp$n = A2($elm$core$Dict$sizeHelp, n + 1, right),
					$temp$dict = left;
				n = $temp$n;
				dict = $temp$dict;
				continue sizeHelp;
			}
		}
	});
var $elm$core$Dict$size = function (dict) {
	return A2($elm$core$Dict$sizeHelp, 0, dict);
};
var $elm$core$Set$size = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$size(dict);
};
var $author$project$Views$OrgOverview$update = F2(
	function (model, msg) {
		if (msg.$ === 1) {
			var err = msg.a;
			return A2(
				$author$project$Misc$with,
				$elm$core$Platform$Cmd$none,
				_Utils_update(
					model,
					{
						lt: $krisajenkins$remotedata$RemoteData$Failure(err),
						E4: $krisajenkins$remotedata$RemoteData$Failure(err),
						F2: $krisajenkins$remotedata$RemoteData$Failure(err)
					}));
		} else {
			var data = msg.a;
			var projectCount = $elm$core$Set$size(
				A3(
					$elm$core$List$foldl,
					function (dep) {
						return $elm$core$Set$insert(
							$author$project$Model$Analytics$Fact$Dependencies$projectName(dep));
					},
					$elm$core$Set$empty,
					_Utils_ap(data.qP, data.l8)));
			var dependencies = _Utils_ap(data.l8, data.qP);
			var severityHistogram = $author$project$Model$SeverityHistogram$fromSeverities(
				A2(
					$elm$core$List$concatMap,
					function (dep) {
						return A2(
							$elm$core$List$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.gY;
								},
								function ($) {
									return $.ck;
								}),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$andThen,
									function (cveKey) {
										return A2($elm$core$Dict$get, cveKey, data.G8);
									},
									$author$project$Model$Analytics$Fact$Dependencies$cveKeyFromDep(dep))));
					},
					dependencies));
			return A2(
				$author$project$Misc$with,
				$elm$core$Platform$Cmd$none,
				_Utils_update(
					model,
					{
						lt: $krisajenkins$remotedata$RemoteData$Success(
							_Utils_Tuple2(dependencies, projectCount)),
						j7: $author$project$Views$OrgOverview$computeMetadata(dependencies),
						E4: $krisajenkins$remotedata$RemoteData$Success(data),
						F2: $krisajenkins$remotedata$RemoteData$Success(severityHistogram)
					}));
		}
	});
var $author$project$Pages$OrgIndex$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{i9: $elm$core$Maybe$Nothing, si: false, pN: false})));
			case 2:
				var searchTerm = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								nq: $elm_community$string_extra$String$Extra$clean(
									$elm$core$String$toLower(searchTerm)),
								nr: searchTerm
							})));
			case 3:
				var tag = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								iF: A2($elm$core$List$member, tag, model.iF) ? A2($elm_community$list_extra$List$Extra$remove, tag, model.iF) : A2(
									$elm$core$List$append,
									model.iF,
									_List_fromArray(
										[tag]))
							})));
			case 4:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{iF: _List_Nil, nq: '', nr: ''})));
			case 6:
				var sortBy = msg.a;
				var sortDirection = msg.b;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{nx: sortBy, ny: sortDirection})));
			case 5:
				var orgId = msg.a;
				var projectSelection = msg.b;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								nR: A3(
									$elm$core$Dict$insert,
									$danyx23$elm_uuid$Uuid$toString(orgId),
									projectSelection,
									model.nR)
							})));
			case 1:
				var projectsResult = msg.a;
				if (!projectsResult.$) {
					var projectList = projectsResult.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{gx: projectList, pu: 1})));
				} else {
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{gx: _List_Nil, pu: 1})));
				}
			case 7:
				var maybeUsageRemoteData = msg.a;
				var _v2 = function () {
					if (maybeUsageRemoteData.$ === 2) {
						var err = maybeUsageRemoteData.a;
						return A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							A2(
								$author$project$Views$NotificationsInline$setErrorText,
								'Could not retrieve state tool usage data',
								_Utils_update(
									model,
									{
										pH: $krisajenkins$remotedata$RemoteData$Failure(err)
									})));
					} else {
						return A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{pH: maybeUsageRemoteData}));
					}
				}();
				var newModel = _v2.a;
				var cmd = _v2.b;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, cmd, newModel));
			case 8:
				var quickMenuOpenedProjectId = msg.a;
				var newModel = ((!_Utils_eq(quickMenuOpenedProjectId, $elm$core$Maybe$Nothing)) && _Utils_eq(quickMenuOpenedProjectId, model.js)) ? _Utils_update(
					model,
					{js: $elm$core$Maybe$Nothing}) : _Utils_update(
					model,
					{js: quickMenuOpenedProjectId});
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, newModel));
			case 9:
				var overviewMsg = msg.a;
				var maybePair = A2(
					$elm$core$Maybe$map,
					function (overviewModel) {
						return A2($author$project$Views$OrgOverview$update, overviewModel, overviewMsg);
					},
					model.mU);
				var _v4 = function () {
					if (maybePair.$ === 1) {
						return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
					} else {
						var _v6 = maybePair.a;
						var overviewModel = _v6.a;
						var cmd = _v6.b;
						return _Utils_Tuple2(
							$elm$core$Maybe$Just(overviewModel),
							cmd);
					}
				}();
				var newOverviewModel = _v4.a;
				var overviewCmd = _v4.b;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$OrgIndex$OrgOverviewMsg, overviewCmd),
						_Utils_update(
							model,
							{mU: newOverviewModel})));
			case 10:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{ky: !model.ky})));
			case 11:
				var modal = msg.a;
				var innerMsg = msg.b;
				var _v7 = A3($author$project$Views$CreateProjectFromSBOM$update, session, modal, innerMsg);
				var _v8 = _v7.a;
				var _v9 = _v8.a;
				var newModal = _v9.a;
				var modalCmd = _v9.b;
				var modalMsg = _v8.b;
				var external = _v7.b;
				var cmd = function () {
					if (modalMsg.$ === 1) {
						var projectName = modalMsg.a;
						return A2(
							$author$project$Routing$pushUrl,
							model.Y,
							A2(
								$author$project$Model$Route$projectConfig,
								{
									ix: $author$project$Model$Organization$getUrlName(model.c3),
									vT: projectName
								},
								$author$project$Model$Route$projectConfigParams));
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				var cmds = $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Pages$OrgIndex$ImportSBOMMsg(newModal),
							modalCmd),
							cmd
						]));
				return A2(
					$author$project$Misc$with,
					external,
					A2(
						$author$project$Misc$with,
						cmds,
						_Utils_update(
							model,
							{
								i9: $elm$core$Maybe$Just(newModal)
							})));
			case 12:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								i9: $elm$core$Maybe$Just(
									A2($author$project$Views$CreateProjectFromSBOM$init, model.c3, model.t0))
							})));
			default:
				var _v11 = model.i9;
				if (_v11.$ === 1) {
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
				} else {
					var importSBOMModal = _v11.a;
					var _v12 = A2($author$project$Views$CreateProjectFromSBOM$createProject, session, importSBOMModal);
					var newImportSBOMModal = _v12.a;
					var cmd = _v12.b;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							A2(
								$elm$core$Platform$Cmd$map,
								$author$project$Pages$OrgIndex$ImportSBOMMsg(newImportSBOMModal),
								cmd),
							_Utils_update(
								model,
								{
									i9: $elm$core$Maybe$Just(newImportSBOMModal)
								})));
				}
		}
	});
var $author$project$Pages$OrgMembers$ChangedDomain = 1;
var $author$project$Pages$OrgMembers$ChangedRole = 0;
var $author$project$Pages$OrgMembers$Disabled = 3;
var $author$project$Pages$OrgMembers$Enabled = 2;
var $author$project$Pages$OrgMembers$OnAutoInviteUpdate = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Pages$OrgMembers$OnCancel = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Pages$OrgMembers$OnInvitationsUpdate = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$OrgMembers$OnMembersUpdate = function (a) {
	return {$: 5, a: a};
};
var $author$project$External$RemoveMembership = function (a) {
	return {$: 6, a: a};
};
var $author$project$Request$Invitation$delete = F3(
	function (orgName, email, creds) {
		return $author$project$Http$Extra$delete(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$emptyJsonBody,
				qN: $author$project$Model$Message$decode,
				CN: _List_Nil,
				GT: '/organizations/' + (orgName + ('/invitations/' + email))
			});
	});
var $author$project$Request$Member$delete = F3(
	function (orgName, memberName, creds) {
		return $author$project$Http$Extra$delete(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$emptyJsonBody,
				qN: $elm$json$Json$Decode$list($author$project$Model$Member$decode),
				CN: _List_Nil,
				GT: '/organizations/' + (orgName + ('/members/' + memberName))
			});
	});
var $author$project$Model$Email$isVerifiedDomain = F2(
	function (emails, domain) {
		return A2(
			$elm$core$List$any,
			function (emailInfo) {
				var isVerified = emailInfo.AL;
				var emailDomain = A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$append('@'),
					$elm$core$List$head(
						$elm$core$List$reverse(
							A2($elm$core$String$split, '@', emailInfo.lJ))));
				var isMatching = _Utils_eq(
					emailDomain,
					$elm$core$Maybe$Just(domain));
				return isVerified && isMatching;
			},
			emails);
	});
var $author$project$Model$MemberEditable$encode = function (_v0) {
	var role = _v0.FO;
	var listed = _v0.D5;
	var encodedRole = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (r) {
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'role',
						$author$project$Model$Role$encode(r))
					]);
			},
			role));
	var encodedListed = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (l) {
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'listed',
						$elm$json$Json$Encode$bool(l))
					]);
			},
			listed));
	return $elm$json$Json$Encode$object(
		_Utils_ap(encodedRole, encodedListed));
};
var $author$project$Http$Extra$patch = function (_v0) {
	var url = _v0.GT;
	var body = _v0.sY;
	var decoder = _v0.qN;
	var auth = _v0.iO;
	var headers = _v0.CN;
	return $elm$http$Http$task(
		{
			sY: body,
			CN: _Utils_ap(
				$author$project$Http$Extra$authToHeaders(auth),
				A2(
					$elm$core$List$map,
					$elm_community$basics_extra$Basics$Extra$uncurry($elm$http$Http$header),
					headers)),
			my: 'PATCH',
			nj: $elm$http$Http$stringResolver(
				A2($author$project$Http$Extra$responseToResult, url, decoder)),
			nE: $elm$core$Maybe$Nothing,
			GT: _Utils_ap(
				$author$project$Http$Extra$authToUrlBase(auth),
				url)
		});
};
var $author$project$Request$Member$patch = F4(
	function (orgName, memberName, memberAttrs, creds) {
		return $author$project$Http$Extra$patch(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$jsonBody(
					$author$project$Model$MemberEditable$encode(memberAttrs)),
				qN: $elm$json$Json$Decode$list($author$project$Model$Member$decode),
				CN: _List_Nil,
				GT: '/organizations/' + (orgName + ('/members/' + memberName))
			});
	});
var $author$project$Request$Invitation$post = F2(
	function (invitation, creds) {
		return $author$project$Http$Extra$post(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: function () {
					var _v0 = invitation.FO;
					if (_v0.$ === 1) {
						return $author$project$Http$Extra$emptyJsonBody;
					} else {
						var role = _v0.a;
						return $author$project$Http$Extra$jsonBody(
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'role',
										$author$project$Model$Role$encode(role))
									])));
					}
				}(),
				qN: $elm$json$Json$Decode$list(
					$author$project$Model$Invitation$decode(true)),
				CN: _List_Nil,
				GT: '/organizations/' + (invitation.ix + ('/invitations/' + invitation.CS))
			});
	});
var $author$project$Pages$OrgMembers$remove = function (identifier) {
	return $elm$core$List$filter(
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.gS;
			},
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.AE;
				},
				$elm$core$Basics$neq(identifier))));
};
var $author$project$Pages$OrgMembers$NoOp = {$: 0};
var $author$project$Pages$OrgMembers$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Pages$OrgMembers$NoOp, 'Pages/OrgMembers.elm');
var $author$project$Pages$OrgMembers$update = F3(
	function (session, action, model) {
		var creds = $author$project$Model$Session$getCreds(session);
		var updateAutoInviteRequest = function (domainInfo) {
			return A3($author$project$Request$Organization$updateAutoInviteDomain, model.c3.AC, domainInfo, creds);
		};
		switch (action.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
			case 1:
				var orgName = action.a.ix;
				var identifier = action.a.CS;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$OrgMembers$OnMembersUpdate,
							A3($author$project$Request$Member$delete, orgName, identifier, creds)),
						_Utils_update(
							model,
							{
								hB: A2($author$project$Pages$OrgMembers$remove, identifier, model.hB)
							})));
			case 10:
				var input = action.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{hR: input})));
			case 11:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{hR: ''})));
			case 2:
				var invitation = {
					CS: model.kb,
					ix: model.c3.AC,
					FO: $elm$core$Maybe$Just(model.mF)
				};
				return ((!$elm$core$String$length(invitation.CS)) || (!A2($elm$core$String$contains, '@', invitation.CS))) ? A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{lK: true}))) : A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$OrgMembers$OnInvitationsUpdate(invitation),
							A2(
								$elm$core$Task$map,
								$elm$core$List$filter(
									A2(
										$elm$core$Basics$composeL,
										$elm$core$Basics$not,
										function ($) {
											return $.Dg;
										})),
								A2($author$project$Request$Invitation$post, invitation, creds))),
						_Utils_update(
							model,
							{lK: false, ui: model.kb, hR: ''})));
			case 3:
				var member = action.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$OrgMembers$OnInvitationsUpdate(member),
							A2(
								$elm$core$Task$map,
								$elm$core$List$filter(
									A2(
										$elm$core$Basics$composeL,
										$elm$core$Basics$not,
										function ($) {
											return $.Dg;
										})),
								A2($author$project$Request$Invitation$post, member, creds))),
						model));
			case 4:
				if (!action.b.$) {
					var invitation = action.a;
					var invitations = action.b.a;
					var eventArgs = function () {
						var _v1 = invitation.FO;
						if (!_v1.$) {
							var role = _v1.a;
							return A2(
								$author$project$Model$Analytics$withLabel,
								$author$project$Model$Role$toInternalString(role),
								A2(
									$author$project$Model$Analytics$withAction,
									'Invited member',
									A2(
										$author$project$Model$Analytics$withCategory,
										'Organizations',
										$author$project$Model$Analytics$newEvent('Invited member'))));
						} else {
							return A2(
								$author$project$Model$Analytics$withAction,
								'Re-invited member',
								A2(
									$author$project$Model$Analytics$withCategory,
									'Organizations',
									$author$project$Model$Analytics$newEvent('Re-invited member')));
						}
					}();
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$textSuccess('We sent an invite to \"' + (invitation.CS + '\"'))),
						A2(
							$author$project$Misc$with,
							$author$project$Ports$sendAnalyticsEvent(eventArgs),
							_Utils_update(
								model,
								{jb: invitations, kb: '', mF: 1})));
				} else {
					var err = action.b.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$OrgMembers$rollbar.FZ, 'OnInvitationsUpdate _ (Err err)', err, session),
							model));
				}
			case 5:
				if (!action.a.$) {
					var newMembers = action.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$Batch(
							_List_fromArray(
								[
									$author$project$External$RemoveMembership(model.c3.AC),
									$author$project$External$AddNotification(
									$author$project$Model$Notification$textSuccess('Member settings updated.'))
								])),
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{hB: newMembers})));
				} else {
					var err = action.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$OrgMembers$rollbar.FZ, 'OnMembersUpdate (Err err)', err, session),
							model));
				}
			case 6:
				var cancellation = action.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$OrgMembers$OnCancel(cancellation.CS),
							A3($author$project$Request$Invitation$delete, cancellation.ix, cancellation.CS, creds)),
						model));
			case 8:
				var newRole = action.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{mF: newRole})));
			case 9:
				var string = action.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{kb: string})));
			case 12:
				if (!action.b.$) {
					var email = action.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{
									jb: A2(
										$elm$core$List$filter,
										function (i) {
											return !_Utils_eq(i.lJ, email);
										},
										model.jb)
								})));
				} else {
					var err = action.b.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$OrgMembers$rollbar.FZ, 'OnCancel _ (Err err)', err, session),
							model));
				}
			case 7:
				var username = action.a;
				var role = action.b;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$OrgMembers$OnMembersUpdate,
							A4(
								$author$project$Request$Member$patch,
								model.c3.AC,
								username,
								{
									D5: $elm$core$Maybe$Nothing,
									FO: $author$project$Model$Role$fromString(role)
								},
								creds)),
						model));
			case 13:
				var _v2 = model.iP;
				if (_v2.b) {
					var firstDomain = _v2.a;
					var domainToDisable = $author$project$Model$Organization$getAutoInviteDomain(firstDomain);
					var isUserVerifiedDomain = A2($author$project$Model$Email$isVerifiedDomain, model.sJ, domainToDisable);
					var updatedAutoInviteEligibleDomains = isUserVerifiedDomain ? $elm_community$list_extra$List$Extra$unique(
						A2($elm$core$List$cons, domainToDisable, model.g_)) : model.g_;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							A2(
								$elm$core$Task$attempt,
								$author$project$Pages$OrgMembers$OnAutoInviteUpdate(3),
								A3($author$project$Request$Organization$removeAutoInviteDomain, model.c3.AC, domainToDisable, creds)),
							_Utils_update(
								model,
								{h1: true, g_: updatedAutoInviteEligibleDomains})));
				} else {
					var _v3 = _Utils_Tuple2(model.h2, model.n3);
					if (!_v3.a.$) {
						var domain = _v3.a.a;
						var role = _v3.b;
						var updatedDomainInfo = A2($author$project$Model$Organization$AutoInviteInfo, domain, role);
						return A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2(
								$author$project$Misc$with,
								A2(
									$elm$core$Task$attempt,
									$author$project$Pages$OrgMembers$OnAutoInviteUpdate(2),
									updateAutoInviteRequest(updatedDomainInfo)),
								_Utils_update(
									model,
									{h1: true})));
					} else {
						return A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
					}
				}
			case 16:
				if (!action.b.$) {
					var updateType = action.a;
					var response = action.b.a;
					var successNotificationText = function () {
						switch (updateType) {
							case 0:
								return 'The automatic invite role was successfully updated.';
							case 1:
								return 'The automatic invite domain was successfully updated.';
							case 2:
								return 'Automatic invites have been enabled.';
							default:
								return 'Automatic invites have been disabled.';
						}
					}();
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$textSuccess(successNotificationText)),
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{
									iP: response,
									h1: false,
									h2: A2($author$project$Pages$OrgMembers$determineSelectedDomain, response, model.g_),
									n3: $author$project$Pages$OrgMembers$determineSelectedRole(response)
								})));
				} else {
					var error = action.b.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(error)),
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{h1: false})));
				}
			case 14:
				var domain = action.a;
				var _v5 = model.iP;
				if (_v5.b) {
					var updatedDomainInfo = A2($author$project$Model$Organization$AutoInviteInfo, domain, model.n3);
					var updateTask = updateAutoInviteRequest(updatedDomainInfo);
					var selectedDomain = A2($elm$core$Maybe$withDefault, '', model.h2);
					var removeTask = A3($author$project$Request$Organization$removeAutoInviteDomain, model.c3.AC, selectedDomain, creds);
					var updateDomainCommand = A2(
						$elm$core$Task$attempt,
						$author$project$Pages$OrgMembers$OnAutoInviteUpdate(1),
						A2(
							$elm$core$Task$andThen,
							function (_v6) {
								return updateTask;
							},
							removeTask));
					var isUserVerifiedDomain = A2($author$project$Model$Email$isVerifiedDomain, model.sJ, selectedDomain);
					var updatedAutoInviteEligibleDomains = isUserVerifiedDomain ? $elm_community$list_extra$List$Extra$unique(
						A2($elm$core$List$cons, selectedDomain, model.g_)) : model.g_;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							updateDomainCommand,
							_Utils_update(
								model,
								{
									h1: true,
									g_: updatedAutoInviteEligibleDomains,
									h2: $elm$core$Maybe$Just(domain)
								})));
				} else {
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{
									h2: $elm$core$Maybe$Just(domain)
								})));
				}
			default:
				var role = action.a;
				var _v7 = model.iP;
				if (_v7.b) {
					var firstDomain = _v7.a;
					var updatedDomain = A2(
						$author$project$Model$Organization$AutoInviteInfo,
						$author$project$Model$Organization$getAutoInviteDomain(firstDomain),
						role);
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							A2(
								$elm$core$Task$attempt,
								$author$project$Pages$OrgMembers$OnAutoInviteUpdate(0),
								updateAutoInviteRequest(updatedDomain)),
							_Utils_update(
								model,
								{h1: true})));
				} else {
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{n3: role})));
				}
		}
	});
var $author$project$Views$PolicyEditor$ReadOnlyNameWriteOtherwise = 2;
var $author$project$Views$PolicyEditor$ReadWrite = 0;
var $author$project$Model$Policy$LetIn$allNames = function (_v0) {
	var exprs = _v0.lS;
	return A2(
		$elm$core$List$cons,
		$author$project$Model$Policy$LetIn$mainName,
		$elm$core$Dict$keys(exprs));
};
var $author$project$Model$Policy$Policies$allNames = $author$project$Model$Policy$LetIn$allNames;
var $author$project$Model$Policy$LetIn$get = F2(
	function (key, _v0) {
		var main = _v0.eu;
		var exprs = _v0.lS;
		return _Utils_eq(key, $author$project$Model$Policy$LetIn$mainName) ? $elm$core$Maybe$Just(main) : A2($elm$core$Dict$get, key, exprs);
	});
var $author$project$Model$Policy$Policies$get = function (name) {
	return $author$project$Model$Policy$LetIn$get(name);
};
var $author$project$Pages$OrgPolicy$getSimplifiedErrorMessage = function (error) {
	switch (error.$) {
		case 5:
			return 'Not found';
		case 2:
			return 'Forbidden';
		default:
			return $author$project$Model$BuildPlanner$BuildPlannerError$message(error);
	}
};
var $author$project$Model$Policy$LetIn$init = F3(
	function (setName, _default, rawDict) {
		var main = A2(
			$elm$core$Maybe$withDefault,
			_default,
			A2($elm$core$Dict$get, $author$project$Model$Policy$LetIn$mainName, rawDict));
		return {
			lS: A2($elm$core$Dict$remove, $author$project$Model$Policy$LetIn$mainName, rawDict),
			eu: A2(setName, $author$project$Model$Policy$LetIn$mainName, main)
		};
	});
var $author$project$Model$Policy$PolicyRules$defaultRule = $author$project$Model$Policy$PolicyRules$And;
var $author$project$Model$Policy$PolicyRules$init = A2($zwilias$elm_rosetree$Tree$tree, $author$project$Model$Policy$PolicyRules$defaultRule, _List_Nil);
var $author$project$Model$Policy$Policy$init = {bP: '', w: '', ks: $author$project$Model$Policy$PolicyRules$init};
var $author$project$Model$Policy$Policy$setName = F2(
	function (name, policy) {
		return _Utils_update(
			policy,
			{w: name});
	});
var $author$project$Model$Policy$Policies$init = A2($author$project$Model$Policy$LetIn$init, $author$project$Model$Policy$Policy$setName, $author$project$Model$Policy$Policy$init);
var $author$project$Model$Policy$Policies$default = $author$project$Model$Policy$Policies$init($elm$core$Dict$empty);
var $author$project$Pages$OrgPolicy$hasChangesToPush = function (model) {
	return !_Utils_eq(
		model.m2,
		A2(
			$elm$core$Maybe$withDefault,
			$author$project$Model$Policy$Policies$default,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.cG;
				},
				model.hc)));
};
var $author$project$Views$PolicyEditor$AsUI = 1;
var $author$project$Views$PolicyEditor$init = function (_v0) {
	var uiMode = _v0.wQ;
	var policy = _v0.rX;
	var projectNames = _v0.vU;
	var policyNames = _v0.vR;
	var isNew = _v0.uj;
	return {
		uj: isNew,
		pf: A2(
			$elm$core$List$filter,
			$elm$core$Basics$neq(policy.w),
			policyNames),
		rX: isNew ? _Utils_update(
			policy,
			{w: ''}) : policy,
		vU: projectNames,
		wQ: uiMode,
		p8: 1
	};
};
var $author$project$Model$Policy$LetIn$isMain = F2(
	function (getName, expr) {
		return _Utils_eq(
			getName(expr),
			$author$project$Model$Policy$LetIn$mainName);
	});
var $author$project$Model$Policy$Policies$isMain = $author$project$Model$Policy$LetIn$isMain(
	function ($) {
		return $.w;
	});
var $author$project$Views$PolicyEditor$ReadOnly = 1;
var $author$project$Model$Policy$LetIn$getMain = function (_v0) {
	var main = _v0.eu;
	return main;
};
var $author$project$Model$Policy$Policies$getMain = $author$project$Model$Policy$LetIn$getMain;
var $author$project$Pages$OrgPolicy$mainPolicyEditorInit = F2(
	function (projects, policies) {
		return {
			ga: $author$project$Views$PolicyEditor$init(
				{
					uj: false,
					rX: $author$project$Model$Policy$Policies$getMain(policies),
					vR: $author$project$Model$Policy$Policies$allNames(policies),
					vU: A2($elm$core$List$map, $author$project$Model$Project$getName, projects),
					wQ: 1
				}),
			pe: $elm$core$Maybe$Nothing
		};
	});
var $author$project$Pages$OrgPolicy$OnPushPoliciesResult = function (a) {
	return {$: 8, a: a};
};
var $author$project$Model$Policy$LetIn$allPairs = function (_v0) {
	var main = _v0.eu;
	var exprs = _v0.lS;
	return A2(
		$elm$core$List$cons,
		_Utils_Tuple2($author$project$Model$Policy$LetIn$mainName, main),
		$elm$core$Dict$toList(exprs));
};
var $author$project$Model$Policy$LetIn$encode = F2(
	function (encodeExpr, letIn) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'let',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$map,
							function (_v0) {
								var name = _v0.a;
								var expr = _v0.b;
								return _Utils_Tuple2(
									_Utils_eq(name, $author$project$Model$Policy$LetIn$mainName) ? 'in' : name,
									encodeExpr(expr));
							},
							$author$project$Model$Policy$LetIn$allPairs(letIn))))
				]));
	});
var $author$project$Model$Policy$LanguageStatus$toString = function (visibility) {
	switch (visibility) {
		case 0:
			return 'Stable';
		case 1:
			return 'LTS';
		default:
			return 'EOL';
	}
};
var $author$project$Model$Policy$Policy$languageStatusEncode = function (languageStatus) {
	return $elm$json$Json$Encode$string(
		$author$project$Model$Policy$LanguageStatus$toString(languageStatus));
};
var $author$project$Model$Policy$Policy$languageEncode = function (rule) {
	var object = function () {
		switch (rule.$) {
			case 0:
				var name = rule.a;
				return _Utils_Tuple2(
					'Language.name',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(name))
							])));
			case 1:
				var name = rule.a;
				var version = rule.b;
				return _Utils_Tuple2(
					'Language.nameAndVersion',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(name)),
								_Utils_Tuple2(
								'version',
								$elm$json$Json$Encode$string(version))
							])));
			default:
				var attribute = rule.a;
				return _Utils_Tuple2(
					'Language.attribute',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'attribute',
								$author$project$Model$Policy$Policy$languageStatusEncode(attribute))
							])));
		}
	}();
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[object]));
};
var $author$project$Model$Policy$LicenseCategory$toString = function (ruleKind) {
	switch (ruleKind) {
		case 0:
			return 'copyleft';
		case 1:
			return 'unknown';
		default:
			return 'permissive';
	}
};
var $author$project$Model$Policy$LicenseCategory$encode = A2($elm$core$Basics$composeR, $author$project$Model$Policy$LicenseCategory$toString, $elm$json$Json$Encode$string);
var $author$project$Model$Policy$Policy$licenseEncode = function (rule) {
	var object = function () {
		if (!rule.$) {
			var name = rule.a;
			return _Utils_Tuple2(
				'License.nameAny',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'name',
							$elm$json$Json$Encode$string(name))
						])));
		} else {
			var category = rule.a;
			return _Utils_Tuple2(
				'License.category',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'category',
							$author$project$Model$Policy$LicenseCategory$encode(category))
						])));
		}
	}();
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[object]));
};
var $author$project$Model$Policy$Policy$packageEncode = function (rule) {
	var object = function () {
		if (!rule.$) {
			var name = rule.a;
			return _Utils_Tuple2(
				'Package.name',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'name',
							$elm$json$Json$Encode$string(name))
						])));
		} else {
			var name = rule.a;
			var constraint = rule.b;
			return _Utils_Tuple2(
				'Package.nameAndConstraint',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'name',
							$elm$json$Json$Encode$string(name)),
							_Utils_Tuple2(
							'constraint',
							$elm$json$Json$Encode$string(constraint))
						])));
		}
	}();
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[object]));
};
var $author$project$Model$Policy$Policy$policyEncode = function (rule) {
	var object = function () {
		var name = rule;
		return _Utils_Tuple2(
			'Policy.passes',
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'name',
						$elm$json$Json$Encode$string('$' + name))
					])));
	}();
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[object]));
};
var $author$project$Model$Visibility$toString = function (visibility) {
	if (!visibility) {
		return 'private';
	} else {
		return 'public';
	}
};
var $author$project$Model$Policy$Policy$visibilityEncode = function (visibility) {
	return $elm$json$Json$Encode$string(
		$author$project$Model$Visibility$toString(visibility));
};
var $author$project$Model$Policy$Policy$projectEncode = function (rule) {
	var object = function () {
		if (!rule.$) {
			var name = rule.a;
			return _Utils_Tuple2(
				'Project.name',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'name',
							$elm$json$Json$Encode$string(name))
						])));
		} else {
			var visibility = rule.a;
			return _Utils_Tuple2(
				'Project.visibility',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'visibility',
							$author$project$Model$Policy$Policy$visibilityEncode(visibility))
						])));
		}
	}();
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[object]));
};
var $author$project$Model$Comparator$toString = function (comparator) {
	switch (comparator) {
		case 0:
			return '>';
		case 1:
			return '>=';
		case 2:
			return '==';
		case 3:
			return '!=';
		case 4:
			return '<';
		default:
			return '<=';
	}
};
var $author$project$Model$Policy$Policy$comparatorEncode = function (comparator) {
	return $elm$json$Json$Encode$string(
		$author$project$Model$Comparator$toString(comparator));
};
var $author$project$Model$Policy$Policy$daysEncode = $elm$json$Json$Encode$int;
var $author$project$Model$Severity$toString = function (severity) {
	switch (severity) {
		case 4:
			return 'critical';
		case 3:
			return 'high';
		case 2:
			return 'medium';
		case 1:
			return 'low';
		default:
			return 'unscored';
	}
};
var $author$project$Model$Policy$Policy$vulnerabilityEncode = function (rule) {
	var severityEncoder = A2($elm$core$Basics$composeR, $author$project$Model$Severity$toString, $elm$json$Json$Encode$string);
	var object = function () {
		switch (rule.$) {
			case 0:
				var cveID = rule.a;
				return _Utils_Tuple2(
					'Vulnerability.cveIDAny',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'cveID',
								$elm$json$Json$Encode$string(cveID))
							])));
			case 1:
				var severity = rule.a;
				return _Utils_Tuple2(
					'Vulnerability.severityLTAll',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'severity',
								severityEncoder(severity))
							])));
			default:
				var severity = rule.a;
				var comparator = rule.b;
				var days = rule.c;
				return _Utils_Tuple2(
					'Vulnerability.severityLTAllWithAgeInDays',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'severity',
								severityEncoder(severity)),
								_Utils_Tuple2(
								'comparator',
								$author$project$Model$Policy$Policy$comparatorEncode(comparator)),
								_Utils_Tuple2(
								'days',
								$author$project$Model$Policy$Policy$daysEncode(days))
							])));
		}
	}();
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[object]));
};
var $author$project$Model$Policy$Policy$encodeExpr = function (expr) {
	switch (expr.$) {
		case 0:
			var dict = expr.a;
			return $author$project$Model$Policy$Policy$letEncode(dict);
		case 1:
			var children = expr.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'and',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'children',
									A2($elm$json$Json$Encode$list, $author$project$Model$Policy$Policy$encodeExpr, children))
								])))
					]));
		case 2:
			var children = expr.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'or',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'children',
									A2($elm$json$Json$Encode$list, $author$project$Model$Policy$Policy$encodeExpr, children))
								])))
					]));
		case 3:
			var child = expr.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'not',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'child',
									$author$project$Model$Policy$Policy$encodeExpr(child))
								])))
					]));
		case 4:
			var rule = expr.a;
			return $author$project$Model$Policy$Policy$languageEncode(rule);
		case 5:
			var rule = expr.a;
			return $author$project$Model$Policy$Policy$licenseEncode(rule);
		case 6:
			var rule = expr.a;
			return $author$project$Model$Policy$Policy$packageEncode(rule);
		case 7:
			var rule = expr.a;
			return $author$project$Model$Policy$Policy$policyEncode(rule);
		case 8:
			var rule = expr.a;
			return $author$project$Model$Policy$Policy$projectEncode(rule);
		case 9:
			var rule = expr.a;
			return $author$project$Model$Policy$Policy$vulnerabilityEncode(rule);
		default:
			var value = expr.a;
			return value;
	}
};
var $author$project$Model$Policy$Policy$letEncode = function (letIn) {
	return A2($author$project$Model$Policy$LetIn$encode, $author$project$Model$Policy$Policy$encodeExpr, letIn);
};
var $zwilias$elm_rosetree$Tree$children = function (_v0) {
	var c = _v0.b;
	return c;
};
var $zwilias$elm_rosetree$Tree$label = function (_v0) {
	var v = _v0.a;
	return v;
};
var $author$project$Model$Policy$Policy$rulesToExpr = function (rules) {
	var _v0 = $zwilias$elm_rosetree$Tree$label(rules);
	switch (_v0.$) {
		case 0:
			var letIn = _v0.a;
			return $author$project$Model$Policy$Policy$PolicyExprLet(
				A2(
					$author$project$Model$Policy$LetIn$map,
					$elm$core$Basics$always($author$project$Model$Policy$Policy$rulesToExpr),
					letIn));
		case 1:
			return $author$project$Model$Policy$Policy$PolicyExprAnd(
				A2(
					$elm$core$List$map,
					$author$project$Model$Policy$Policy$rulesToExpr,
					$zwilias$elm_rosetree$Tree$children(rules)));
		case 2:
			return $author$project$Model$Policy$Policy$PolicyExprOr(
				A2(
					$elm$core$List$map,
					$author$project$Model$Policy$Policy$rulesToExpr,
					$zwilias$elm_rosetree$Tree$children(rules)));
		case 3:
			return $author$project$Model$Policy$Policy$PolicyExprNot(
				A2(
					$elm$core$Maybe$withDefault,
					$author$project$Model$Policy$Policy$PolicyExprAnd(_List_Nil),
					A2(
						$elm$core$Maybe$map,
						$author$project$Model$Policy$Policy$rulesToExpr,
						$elm$core$List$head(
							$zwilias$elm_rosetree$Tree$children(rules)))));
		case 4:
			var name = _v0.a;
			return $author$project$Model$Policy$Policy$PolicyExprLanguage(
				$author$project$Model$Policy$Policy$LanguageName(name));
		case 5:
			var name = _v0.a;
			var constraint = _v0.b;
			return $author$project$Model$Policy$Policy$PolicyExprLanguage(
				A2($author$project$Model$Policy$Policy$LanguageNameAndVersion, name, constraint));
		case 6:
			var status = _v0.a;
			return $author$project$Model$Policy$Policy$PolicyExprLanguage(
				$author$project$Model$Policy$Policy$LanguageAttribute(status));
		case 7:
			var category = _v0.a;
			return $author$project$Model$Policy$Policy$PolicyExprLicense(
				$author$project$Model$Policy$Policy$LicenseCategory(category));
		case 8:
			var name = _v0.a;
			return $author$project$Model$Policy$Policy$PolicyExprLicense(
				$author$project$Model$Policy$Policy$LicenseNameAny(name));
		case 9:
			var name = _v0.a;
			return $author$project$Model$Policy$Policy$PolicyExprPackage(
				$author$project$Model$Policy$Policy$PackageName(name));
		case 13:
			var visibility = _v0.a;
			return $author$project$Model$Policy$Policy$PolicyExprProject(
				$author$project$Model$Policy$Policy$ProjectVisibility(visibility));
		case 10:
			var name = _v0.a;
			var constraint = _v0.b;
			return $author$project$Model$Policy$Policy$PolicyExprPackage(
				A2($author$project$Model$Policy$Policy$PackageNameAndConstraint, name, constraint));
		case 11:
			var policyName = _v0.a;
			return $author$project$Model$Policy$Policy$PolicyExprPolicy(policyName);
		case 12:
			var name = _v0.a;
			return $author$project$Model$Policy$Policy$PolicyExprProject(
				$author$project$Model$Policy$Policy$ProjectName(name));
		case 14:
			var cveID = _v0.a;
			return $author$project$Model$Policy$Policy$PolicyExprVulnerability(
				$author$project$Model$Policy$Policy$VulnerabilityCVEIDAny(cveID));
		case 15:
			var severity = _v0.a;
			return $author$project$Model$Policy$Policy$PolicyExprVulnerability(
				$author$project$Model$Policy$Policy$VulnerabilitySeverityLTAll(severity));
		case 16:
			var severity = _v0.a;
			var comparator = _v0.b;
			var daysStr = _v0.c;
			var days = A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(daysStr));
			return $author$project$Model$Policy$Policy$PolicyExprVulnerability(
				A3($author$project$Model$Policy$Policy$VulnerabilitySeverityLTAllWithAgeInDays, severity, comparator, days));
		default:
			var value = _v0.a;
			return $author$project$Model$Policy$Policy$PolicyExprUnknown(value);
	}
};
var $author$project$Model$Policy$Policy$encodeNameless = function (policy) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(policy.bP)),
				_Utils_Tuple2(
				'expr',
				$author$project$Model$Policy$Policy$encodeExpr(
					$author$project$Model$Policy$Policy$rulesToExpr(policy.ks)))
			]));
};
var $author$project$Model$Policy$Policies$encode = function (policies) {
	return A2(
		$author$project$Model$Policy$LetIn$encode,
		function (p) {
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'policy',
						$author$project$Model$Policy$Policy$encodeNameless(p))
					]));
		},
		policies);
};
var $dillonkearns$elm_graphql$Graphql$OptionalArgument$Null = {$: 2};
var $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybeWithNull = function (maybeValue) {
	if (!maybeValue.$) {
		var value = maybeValue.a;
		return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(value);
	} else {
		return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Null;
	}
};
var $author$project$BuildPlanner$InputObject$encodePushPolicyInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'organization',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.c3))),
				_Utils_Tuple2(
				'previousPolicyID',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.m7,
					A2(
						$author$project$BuildPlanner$Scalar$unwrapEncoder,
						function ($) {
							return $.oc;
						},
						$author$project$BuildPlannerScalarCodecs$codecs))),
				_Utils_Tuple2(
				'expr',
				$elm$core$Maybe$Just(
					A2(
						$author$project$BuildPlanner$Scalar$unwrapEncoder,
						function ($) {
							return $.k8;
						},
						$author$project$BuildPlannerScalarCodecs$codecs)(input____.cG)))
			]));
};
var $author$project$BuildPlanner$Mutation$pushPolicy = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'pushPolicy',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.$7, $author$project$BuildPlanner$InputObject$encodePushPolicyInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$BuildPlanner$Union$PushPolicyResult$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Policy', selections____.vs),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'NotFound', selections____.vp),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Forbidden', selections____.vc),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ParseError', selections____.vq),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInput', selections____.vj)
			]));
};
var $author$project$Model$Policy$Policies$selectionSetPushResult = $author$project$BuildPlanner$Union$PushPolicyResult$fragments(
	{
		vc: A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
			A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Model$BuildPlanner$BuildPlannerError$ForbiddenError),
			$author$project$Model$BuildPlanner$Error$ForbiddenError$selectionSet),
		vj: A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
			A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Model$BuildPlanner$BuildPlannerError$InvalidInputError),
			$author$project$Model$BuildPlanner$Error$InvalidInputError$selectionSet),
		vp: A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
			A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Model$BuildPlanner$BuildPlannerError$NotFoundError),
			$author$project$Model$BuildPlanner$Error$NotFoundError$selectionSet),
		vq: A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
			A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Model$BuildPlanner$BuildPlannerError$ParseError),
			$author$project$Model$BuildPlanner$Error$ParseError$selectionSet),
		vs: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Result$Ok, $author$project$Model$Policy$Policies$selectionSetOrgPolicy)
	});
var $author$project$Request$BuildPlanner$pushPolicy = F4(
	function (session, orgUrlName, previousPolicyId, policies) {
		var input = {
			cG: $elm$json$Json$Encode$string(
				A2(
					$elm$json$Json$Encode$encode,
					0,
					$author$project$Model$Policy$Policies$encode(policies))),
			c3: orgUrlName,
			m7: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybeWithNull(previousPolicyId)
		};
		var creds = $author$project$Model$Session$getCreds(session);
		return $author$project$Model$BuildPlanner$BuildPlannerError$simplifyTask(
			A5(
				$author$project$GraphQL$Utils$mutationRequest,
				creds,
				4,
				_List_Nil,
				'PushPolicy',
				A2(
					$author$project$BuildPlanner$Mutation$pushPolicy,
					{$7: input},
					$author$project$Model$Policy$Policies$selectionSetPushResult)));
	});
var $author$project$Pages$OrgPolicy$pushPolicies = F2(
	function (session, model) {
		var previousPolicyId = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.Fj;
			},
			model.hc);
		var orgUrlName = $author$project$Model$Organization$getUrlName(model.c3);
		return A2(
			$elm$core$Task$attempt,
			$author$project$Pages$OrgPolicy$OnPushPoliciesResult,
			A4($author$project$Request$BuildPlanner$pushPolicy, session, orgUrlName, previousPolicyId, model.m2));
	});
var $author$project$Model$Policy$LetIn$remove = F2(
	function (name, _v0) {
		var data = _v0;
		return _Utils_update(
			data,
			{
				lS: A2($elm$core$Dict$remove, name, data.lS)
			});
	});
var $author$project$Model$Policy$Policies$remove = $author$project$Model$Policy$LetIn$remove;
var $author$project$Pages$OrgPolicy$NoOp = {$: 0};
var $author$project$Pages$OrgPolicy$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Pages$OrgPolicy$NoOp, 'Pages/OrgPolicy.elm');
var $author$project$Model$Policy$LetIn$set = F5(
	function (getName, setName, oldName, expr, _v0) {
		var main = _v0.eu;
		var exprs = _v0.lS;
		return _Utils_eq(oldName, $author$project$Model$Policy$LetIn$mainName) ? {
			lS: exprs,
			eu: A2(setName, $author$project$Model$Policy$LetIn$mainName, expr)
		} : {
			lS: (_Utils_eq(
				getName(expr),
				oldName) ? $elm$core$Basics$identity : $elm$core$Dict$remove(oldName))(
				A3(
					$elm$core$Dict$insert,
					getName(expr),
					expr,
					exprs)),
			eu: main
		};
	});
var $author$project$Model$Policy$Policies$set = A2(
	$author$project$Model$Policy$LetIn$set,
	function ($) {
		return $.w;
	},
	$author$project$Model$Policy$Policy$setName);
var $author$project$Views$PolicyEditor$setReadOnly = function (model) {
	return _Utils_update(
		model,
		{wQ: 1});
};
var $author$project$Views$PolicyEditor$NoOp = {$: 0};
var $zwilias$elm_rosetree$Tree$appendChild = F2(
	function (c, _v0) {
		var v = _v0.a;
		var cs = _v0.b;
		return A2(
			$zwilias$elm_rosetree$Tree$Tree,
			v,
			_Utils_ap(
				cs,
				_List_fromArray(
					[c])));
	});
var $zwilias$elm_rosetree$Tree$mapAccumulateHelp = F4(
	function (f, state, acc, stack) {
		mapAccumulateHelp:
		while (true) {
			var _v0 = acc.eS;
			if (!_v0.b) {
				var node = A2(
					$zwilias$elm_rosetree$Tree$Tree,
					acc.b2,
					$elm$core$List$reverse(acc.bF));
				if (!stack.b) {
					return _Utils_Tuple2(state, node);
				} else {
					var top = stack.a;
					var rest = stack.b;
					var $temp$f = f,
						$temp$state = state,
						$temp$acc = _Utils_update(
						top,
						{
							bF: A2($elm$core$List$cons, node, top.bF)
						}),
						$temp$stack = rest;
					f = $temp$f;
					state = $temp$state;
					acc = $temp$acc;
					stack = $temp$stack;
					continue mapAccumulateHelp;
				}
			} else {
				if (!_v0.a.b.b) {
					var _v2 = _v0.a;
					var d = _v2.a;
					var rest = _v0.b;
					var _v3 = A2(f, state, d);
					var state_ = _v3.a;
					var label_ = _v3.b;
					var $temp$f = f,
						$temp$state = state_,
						$temp$acc = _Utils_update(
						acc,
						{
							bF: A2(
								$elm$core$List$cons,
								A2($zwilias$elm_rosetree$Tree$Tree, label_, _List_Nil),
								acc.bF),
							eS: rest
						}),
						$temp$stack = stack;
					f = $temp$f;
					state = $temp$state;
					acc = $temp$acc;
					stack = $temp$stack;
					continue mapAccumulateHelp;
				} else {
					var _v4 = _v0.a;
					var d = _v4.a;
					var cs = _v4.b;
					var rest = _v0.b;
					var _v5 = A2(f, state, d);
					var state_ = _v5.a;
					var label_ = _v5.b;
					var $temp$f = f,
						$temp$state = state_,
						$temp$acc = {bF: _List_Nil, b2: label_, eS: cs},
						$temp$stack = A2(
						$elm$core$List$cons,
						_Utils_update(
							acc,
							{eS: rest}),
						stack);
					f = $temp$f;
					state = $temp$state;
					acc = $temp$acc;
					stack = $temp$stack;
					continue mapAccumulateHelp;
				}
			}
		}
	});
var $zwilias$elm_rosetree$Tree$mapAccumulate = F3(
	function (f, s, _v0) {
		var d = _v0.a;
		var cs = _v0.b;
		var _v1 = A2(f, s, d);
		var s_ = _v1.a;
		var d_ = _v1.b;
		return A4(
			$zwilias$elm_rosetree$Tree$mapAccumulateHelp,
			f,
			s_,
			{bF: _List_Nil, b2: d_, eS: cs},
			_List_Nil);
	});
var $zwilias$elm_rosetree$Tree$map = F2(
	function (f, t) {
		return A3(
			$zwilias$elm_rosetree$Tree$mapAccumulate,
			F2(
				function (_v0, e) {
					return _Utils_Tuple2(
						0,
						f(e));
				}),
			0,
			t).b;
	});
var $zwilias$elm_rosetree$Tree$Zipper$Zipper = $elm$core$Basics$identity;
var $zwilias$elm_rosetree$Tree$Zipper$previousSibling = function (_v0) {
	var zipper = _v0;
	var _v1 = zipper.xl;
	if (!_v1.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var previous = _v1.a;
		var rest = _v1.b;
		return $elm$core$Maybe$Just(
			{
				w9: A2($elm$core$List$cons, zipper.dm, zipper.w9),
				xl: rest,
				fl: zipper.fl,
				dm: previous
			});
	}
};
var $zwilias$elm_rosetree$Tree$Zipper$firstSibling = function (zipper) {
	firstSibling:
	while (true) {
		var _v0 = $zwilias$elm_rosetree$Tree$Zipper$previousSibling(zipper);
		if (_v0.$ === 1) {
			return zipper;
		} else {
			var z = _v0.a;
			var $temp$zipper = z;
			zipper = $temp$zipper;
			continue firstSibling;
		}
	}
};
var $zwilias$elm_rosetree$Tree$Zipper$reconstruct = F4(
	function (focus, before, after, l) {
		return A2(
			$zwilias$elm_rosetree$Tree$tree,
			l,
			_Utils_ap(
				$elm$core$List$reverse(before),
				_Utils_ap(
					_List_fromArray(
						[focus]),
					after)));
	});
var $zwilias$elm_rosetree$Tree$Zipper$parent = function (_v0) {
	var zipper = _v0;
	var _v1 = zipper.fl;
	if (!_v1.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var crumb = _v1.a;
		var rest = _v1.b;
		return $elm$core$Maybe$Just(
			{
				w9: crumb.w9,
				xl: crumb.xl,
				fl: rest,
				dm: A4($zwilias$elm_rosetree$Tree$Zipper$reconstruct, zipper.dm, zipper.xl, zipper.w9, crumb.b2)
			});
	}
};
var $zwilias$elm_rosetree$Tree$Zipper$root = function (zipper) {
	root:
	while (true) {
		var _v0 = $zwilias$elm_rosetree$Tree$Zipper$parent(zipper);
		if (_v0.$ === 1) {
			return $zwilias$elm_rosetree$Tree$Zipper$firstSibling(zipper);
		} else {
			var z = _v0.a;
			var $temp$zipper = z;
			zipper = $temp$zipper;
			continue root;
		}
	}
};
var $zwilias$elm_rosetree$Tree$Zipper$tree = function (_v0) {
	var focus = _v0.dm;
	return focus;
};
var $zwilias$elm_rosetree$Tree$Zipper$toTree = A2($elm$core$Basics$composeL, $zwilias$elm_rosetree$Tree$Zipper$tree, $zwilias$elm_rosetree$Tree$Zipper$root);
var $author$project$Views$PolicyEditor$backToTree = A2(
	$elm$core$Basics$composeR,
	$zwilias$elm_rosetree$Tree$Zipper$toTree,
	$zwilias$elm_rosetree$Tree$map(
		function (_v0) {
			var rule = _v0.b;
			return rule;
		}));
var $author$project$Views$PolicyEditor$invalidID = -1;
var $zwilias$elm_rosetree$Tree$Zipper$label = function (zipper) {
	return $zwilias$elm_rosetree$Tree$label(
		$zwilias$elm_rosetree$Tree$Zipper$tree(zipper));
};
var $zwilias$elm_rosetree$Tree$Zipper$find = F3(
	function (predicate, move, zipper) {
		find:
		while (true) {
			var _v0 = move(zipper);
			if (!_v0.$) {
				var next = _v0.a;
				if (predicate(
					$zwilias$elm_rosetree$Tree$Zipper$label(next))) {
					return $elm$core$Maybe$Just(next);
				} else {
					var $temp$predicate = predicate,
						$temp$move = move,
						$temp$zipper = next;
					predicate = $temp$predicate;
					move = $temp$move;
					zipper = $temp$zipper;
					continue find;
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	});
var $zwilias$elm_rosetree$Tree$Zipper$firstChild = function (_v0) {
	var zipper = _v0;
	var _v1 = $zwilias$elm_rosetree$Tree$children(zipper.dm);
	if (!_v1.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var c = _v1.a;
		var cs = _v1.b;
		return $elm$core$Maybe$Just(
			{
				w9: cs,
				xl: _List_Nil,
				fl: A2(
					$elm$core$List$cons,
					{
						w9: zipper.w9,
						xl: zipper.xl,
						b2: $zwilias$elm_rosetree$Tree$label(zipper.dm)
					},
					zipper.fl),
				dm: c
			});
	}
};
var $zwilias$elm_rosetree$Tree$Zipper$firstOf = F2(
	function (options, v) {
		firstOf:
		while (true) {
			if (!options.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var option = options.a;
				var rest = options.b;
				var _v1 = option(v);
				if (!_v1.$) {
					var r = _v1.a;
					return $elm$core$Maybe$Just(r);
				} else {
					var $temp$options = rest,
						$temp$v = v;
					options = $temp$options;
					v = $temp$v;
					continue firstOf;
				}
			}
		}
	});
var $zwilias$elm_rosetree$Tree$Zipper$nextSibling = function (_v0) {
	var zipper = _v0;
	var _v1 = zipper.w9;
	if (!_v1.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var next = _v1.a;
		var rest = _v1.b;
		return $elm$core$Maybe$Just(
			{
				w9: rest,
				xl: A2($elm$core$List$cons, zipper.dm, zipper.xl),
				fl: zipper.fl,
				dm: next
			});
	}
};
var $zwilias$elm_rosetree$Tree$Zipper$nextSiblingOfAncestor = function (zipper) {
	nextSiblingOfAncestor:
	while (true) {
		var _v0 = $zwilias$elm_rosetree$Tree$Zipper$parent(zipper);
		if (_v0.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var parent_ = _v0.a;
			var _v1 = $zwilias$elm_rosetree$Tree$Zipper$nextSibling(parent_);
			if (_v1.$ === 1) {
				var $temp$zipper = parent_;
				zipper = $temp$zipper;
				continue nextSiblingOfAncestor;
			} else {
				var s = _v1.a;
				return $elm$core$Maybe$Just(s);
			}
		}
	}
};
var $zwilias$elm_rosetree$Tree$Zipper$forward = function (zipper) {
	return A2(
		$zwilias$elm_rosetree$Tree$Zipper$firstOf,
		_List_fromArray(
			[$zwilias$elm_rosetree$Tree$Zipper$firstChild, $zwilias$elm_rosetree$Tree$Zipper$nextSibling, $zwilias$elm_rosetree$Tree$Zipper$nextSiblingOfAncestor]),
		zipper);
};
var $zwilias$elm_rosetree$Tree$Zipper$findNext = F2(
	function (f, zipper) {
		return A3($zwilias$elm_rosetree$Tree$Zipper$find, f, $zwilias$elm_rosetree$Tree$Zipper$forward, zipper);
	});
var $zwilias$elm_rosetree$Tree$Zipper$findFromRoot = F2(
	function (f, zipper) {
		var r = $zwilias$elm_rosetree$Tree$Zipper$root(zipper);
		return f(
			$zwilias$elm_rosetree$Tree$Zipper$label(r)) ? $elm$core$Maybe$Just(r) : A2($zwilias$elm_rosetree$Tree$Zipper$findNext, f, r);
	});
var $zwilias$elm_rosetree$Tree$Zipper$fromTree = function (t) {
	return {w9: _List_Nil, xl: _List_Nil, fl: _List_Nil, dm: t};
};
var $zwilias$elm_rosetree$Tree$indexedMap = F2(
	function (f, t) {
		return A3(
			$zwilias$elm_rosetree$Tree$mapAccumulate,
			F2(
				function (idx, elem) {
					return _Utils_Tuple2(
						idx + 1,
						A2(f, idx, elem));
				}),
			0,
			t).b;
	});
var $author$project$Views$PolicyEditor$andThenTargetRule = F4(
	function (missingTargetError, andThenStep, targetRuleID, rules) {
		var isTarget = function (_v0) {
			var id = _v0.a;
			return _Utils_eq(id, targetRuleID);
		};
		var indexedTree = A2(
			$zwilias$elm_rosetree$Tree$indexedMap,
			F2(
				function (id, rule) {
					return _Utils_Tuple2(id, rule);
				}),
			rules);
		return A2(
			$elm$core$Result$andThen,
			andThenStep,
			A2(
				$elm$core$Result$fromMaybe,
				missingTargetError,
				A2(
					$zwilias$elm_rosetree$Tree$Zipper$findFromRoot,
					isTarget,
					$zwilias$elm_rosetree$Tree$Zipper$fromTree(indexedTree))));
	});
var $author$project$Views$PolicyEditor$mapTargetRule = F2(
	function (missingTargetError, mapper) {
		return A2(
			$author$project$Views$PolicyEditor$andThenTargetRule,
			missingTargetError,
			A2($elm$core$Basics$composeR, mapper, $elm$core$Result$Ok));
	});
var $zwilias$elm_rosetree$Tree$Zipper$mapTree = F2(
	function (f, _v0) {
		var zipper = _v0;
		return _Utils_update(
			zipper,
			{
				dm: f(zipper.dm)
			});
	});
var $author$project$Views$PolicyEditor$addRule = function () {
	var newRule = _Utils_Tuple2(
		$author$project$Views$PolicyEditor$invalidID,
		$author$project$Model$Policy$PolicyRules$LicensesAre(2));
	return A2(
		$author$project$Views$PolicyEditor$mapTargetRule,
		'Could not find where to add rule',
		A2(
			$elm$core$Basics$composeR,
			$zwilias$elm_rosetree$Tree$Zipper$mapTree(
				$zwilias$elm_rosetree$Tree$appendChild(
					$zwilias$elm_rosetree$Tree$singleton(newRule))),
			$author$project$Views$PolicyEditor$backToTree));
}();
var $author$project$Model$Policy$Policy$Policy = F3(
	function (name, description, rules) {
		return {bP: description, w: name, ks: rules};
	});
var $author$project$Model$Policy$Policy$decode = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Model$Policy$Policy$Policy,
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'description', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'expr',
		A2($elm$json$Json$Decode$map, $author$project$Model$Policy$Policy$exprToRules, $author$project$Model$Policy$Policy$decodeExpr)));
var $author$project$Model$Policy$Policy$fromJson = A2(
	$elm$core$Basics$composeR,
	$elm$json$Json$Decode$decodeString($author$project$Model$Policy$Policy$decode),
	$elm$core$Result$toMaybe);
var $author$project$Model$Policy$RuleKind$And = 0;
var $author$project$Model$Policy$RuleKind$AnyLicensesAreNamed = 7;
var $author$project$Model$Policy$RuleKind$HasCVE = 13;
var $author$project$Model$Policy$RuleKind$LanguageName = 3;
var $author$project$Model$Policy$RuleKind$LanguageNameAndVersion = 4;
var $author$project$Model$Policy$RuleKind$LanguageStatus = 5;
var $author$project$Model$Policy$RuleKind$LicensesAre = 6;
var $author$project$Model$Policy$RuleKind$Not = 2;
var $author$project$Model$Policy$RuleKind$Or = 1;
var $author$project$Model$Policy$RuleKind$PackageMatches = 9;
var $author$project$Model$Policy$RuleKind$PackageNameIs = 8;
var $author$project$Model$Policy$RuleKind$PassesPolicy = 10;
var $author$project$Model$Policy$RuleKind$ProjectIs = 11;
var $author$project$Model$Policy$RuleKind$ProjectVisibility = 12;
var $author$project$Model$Policy$RuleKind$VulnsAreAllLessThan = 14;
var $author$project$Model$Policy$RuleKind$VulnsAreAllLessThanWithAgeInDays = 15;
var $author$project$Model$Policy$RuleKind$fromString = function (s) {
	switch (s) {
		case 'And':
			return $elm$core$Result$Ok(0);
		case 'Or':
			return $elm$core$Result$Ok(1);
		case 'Not':
			return $elm$core$Result$Ok(2);
		case 'Language name':
			return $elm$core$Result$Ok(3);
		case 'Language name and version':
			return $elm$core$Result$Ok(4);
		case 'Language status':
			return $elm$core$Result$Ok(5);
		case 'Licenses are':
			return $elm$core$Result$Ok(6);
		case 'Any licenses are named':
			return $elm$core$Result$Ok(7);
		case 'Package name is':
			return $elm$core$Result$Ok(8);
		case 'Package matches':
			return $elm$core$Result$Ok(9);
		case 'Passes policy':
			return $elm$core$Result$Ok(10);
		case 'Project is':
			return $elm$core$Result$Ok(11);
		case 'Project visibility':
			return $elm$core$Result$Ok(12);
		case 'Has CVE':
			return $elm$core$Result$Ok(13);
		case 'Vulnerabilities are all less than':
			return $elm$core$Result$Ok(14);
		case 'Vulnerabilities are all less than with age in days':
			return $elm$core$Result$Ok(15);
		default:
			return $elm$core$Result$Err('Invalid RuleKind: \"' + (s + '\"'));
	}
};
var $zwilias$elm_rosetree$Tree$mapChildren = F2(
	function (f, _v0) {
		var v = _v0.a;
		var cs = _v0.b;
		return A2(
			$zwilias$elm_rosetree$Tree$Tree,
			v,
			f(cs));
	});
var $author$project$Views$PolicyEditor$removeRule = F2(
	function (targetRuleID, rules) {
		var isTarget = function (_v1) {
			var id = _v1.a;
			return _Utils_eq(id, targetRuleID);
		};
		return A4(
			$author$project$Views$PolicyEditor$mapTargetRule,
			'Could not find where to remove rule',
			function (zipper) {
				var _v0 = $zwilias$elm_rosetree$Tree$Zipper$parent(zipper);
				if (!_v0.$) {
					var parent = _v0.a;
					return $author$project$Views$PolicyEditor$backToTree(
						A2(
							$zwilias$elm_rosetree$Tree$Zipper$mapTree,
							$zwilias$elm_rosetree$Tree$mapChildren(
								$elm$core$List$filter(
									A2(
										$elm$core$Basics$composeR,
										$zwilias$elm_rosetree$Tree$label,
										A2($elm$core$Basics$composeR, isTarget, $elm$core$Basics$not)))),
							parent));
				} else {
					return $author$project$Model$Policy$PolicyRules$init;
				}
			},
			targetRuleID,
			rules);
	});
var $author$project$Model$Policy$PolicyRules$Multiple = 2;
var $author$project$Model$Policy$PolicyRules$One = 1;
var $author$project$Model$Policy$PolicyRules$Zero = 0;
var $author$project$Model$Policy$PolicyRules$childrenSupported = function (rule) {
	switch (rule.$) {
		case 1:
			return 2;
		case 2:
			return 2;
		case 3:
			return 1;
		default:
			return 0;
	}
};
var $zwilias$elm_rosetree$Tree$replaceChildren = F2(
	function (cs, _v0) {
		var v = _v0.a;
		return A2($zwilias$elm_rosetree$Tree$Tree, v, cs);
	});
var $zwilias$elm_rosetree$Tree$restructureHelp = F4(
	function (fLabel, fTree, acc, stack) {
		restructureHelp:
		while (true) {
			var _v0 = acc.eS;
			if (!_v0.b) {
				var node = A2(
					fTree,
					acc.b2,
					$elm$core$List$reverse(acc.bF));
				if (!stack.b) {
					return node;
				} else {
					var top = stack.a;
					var rest = stack.b;
					var $temp$fLabel = fLabel,
						$temp$fTree = fTree,
						$temp$acc = _Utils_update(
						top,
						{
							bF: A2($elm$core$List$cons, node, top.bF)
						}),
						$temp$stack = rest;
					fLabel = $temp$fLabel;
					fTree = $temp$fTree;
					acc = $temp$acc;
					stack = $temp$stack;
					continue restructureHelp;
				}
			} else {
				if (!_v0.a.b.b) {
					var _v2 = _v0.a;
					var l = _v2.a;
					var rest = _v0.b;
					var $temp$fLabel = fLabel,
						$temp$fTree = fTree,
						$temp$acc = _Utils_update(
						acc,
						{
							bF: A2(
								$elm$core$List$cons,
								A2(
									fTree,
									fLabel(l),
									_List_Nil),
								acc.bF),
							eS: rest
						}),
						$temp$stack = stack;
					fLabel = $temp$fLabel;
					fTree = $temp$fTree;
					acc = $temp$acc;
					stack = $temp$stack;
					continue restructureHelp;
				} else {
					var _v3 = _v0.a;
					var l = _v3.a;
					var cs = _v3.b;
					var rest = _v0.b;
					var $temp$fLabel = fLabel,
						$temp$fTree = fTree,
						$temp$acc = {
						bF: _List_Nil,
						b2: fLabel(l),
						eS: cs
					},
						$temp$stack = A2(
						$elm$core$List$cons,
						_Utils_update(
							acc,
							{eS: rest}),
						stack);
					fLabel = $temp$fLabel;
					fTree = $temp$fTree;
					acc = $temp$acc;
					stack = $temp$stack;
					continue restructureHelp;
				}
			}
		}
	});
var $zwilias$elm_rosetree$Tree$restructure = F3(
	function (convertLabel, convertTree, _v0) {
		var l = _v0.a;
		var c = _v0.b;
		return A4(
			$zwilias$elm_rosetree$Tree$restructureHelp,
			convertLabel,
			convertTree,
			{
				bF: _List_Nil,
				b2: convertLabel(l),
				eS: c
			},
			_List_Nil);
	});
var $author$project$Model$Policy$PolicyRules$ensureChildrenNumbers = F3(
	function (toRule, _default, tree) {
		return A3(
			$zwilias$elm_rosetree$Tree$restructure,
			$elm$core$Basics$identity,
			F2(
				function (label, children) {
					return A3(
						$author$project$Model$Policy$PolicyRules$ensureChildrenNumbersOnce,
						toRule,
						_default,
						A2($zwilias$elm_rosetree$Tree$tree, label, children));
				}),
			tree);
	});
var $author$project$Model$Policy$PolicyRules$ensureChildrenNumbersOnce = F3(
	function (toRule, _default, tree) {
		var _v0 = $author$project$Model$Policy$PolicyRules$childrenSupported(
			toRule(
				$zwilias$elm_rosetree$Tree$label(tree)));
		switch (_v0) {
			case 0:
				return A2($zwilias$elm_rosetree$Tree$replaceChildren, _List_Nil, tree);
			case 1:
				var newChildren = function () {
					var _v1 = A2(
						$elm$core$List$take,
						1,
						$zwilias$elm_rosetree$Tree$children(tree));
					if (!_v1.b) {
						return _List_fromArray(
							[
								A3(
								$author$project$Model$Policy$PolicyRules$ensureChildrenNumbers,
								toRule,
								_default,
								$zwilias$elm_rosetree$Tree$singleton(_default))
							]);
					} else {
						var otherwise = _v1;
						return otherwise;
					}
				}();
				return A2($zwilias$elm_rosetree$Tree$replaceChildren, newChildren, tree);
			default:
				return tree;
		}
	});
var $zwilias$elm_rosetree$Tree$mapLabel = F2(
	function (f, _v0) {
		var v = _v0.a;
		var cs = _v0.b;
		return A2(
			$zwilias$elm_rosetree$Tree$Tree,
			f(v),
			cs);
	});
var $zwilias$elm_rosetree$Tree$Zipper$mapLabel = F2(
	function (f, zipper) {
		return A2(
			$zwilias$elm_rosetree$Tree$Zipper$mapTree,
			$zwilias$elm_rosetree$Tree$mapLabel(f),
			zipper);
	});
var $zwilias$elm_rosetree$Tree$Zipper$replaceLabel = F2(
	function (l, zipper) {
		return A2(
			$zwilias$elm_rosetree$Tree$Zipper$mapLabel,
			$elm$core$Basics$always(l),
			zipper);
	});
var $author$project$Views$PolicyEditor$transformOrError = F3(
	function (transformFunc, targetRuleID, rules) {
		var transformResult = A4(
			$author$project$Views$PolicyEditor$andThenTargetRule,
			'Target node was missing during transformation',
			function (zipper) {
				return A2(
					$elm$core$Result$map,
					function (newElem) {
						return $author$project$Views$PolicyEditor$backToTree(
							A2(
								$zwilias$elm_rosetree$Tree$Zipper$replaceLabel,
								_Utils_Tuple2($author$project$Views$PolicyEditor$invalidID, newElem),
								zipper));
					},
					transformFunc(
						function (_v1) {
							var rule = _v1.b;
							return rule;
						}(
							$zwilias$elm_rosetree$Tree$Zipper$label(zipper))));
			},
			targetRuleID,
			rules);
		var correctedChildrenResult = A2(
			$elm$core$Result$andThen,
			A3(
				$author$project$Views$PolicyEditor$mapTargetRule,
				'Target node was missing when ensuring right number of children',
				A2(
					$elm$core$Basics$composeR,
					$zwilias$elm_rosetree$Tree$Zipper$mapTree(
						A2(
							$author$project$Model$Policy$PolicyRules$ensureChildrenNumbersOnce,
							function (_v0) {
								var rule = _v0.b;
								return rule;
							},
							_Utils_Tuple2($author$project$Views$PolicyEditor$invalidID, $author$project$Model$Policy$PolicyRules$defaultRule))),
					$author$project$Views$PolicyEditor$backToTree),
				targetRuleID),
			transformResult);
		return correctedChildrenResult;
	});
var $author$project$Views$PolicyEditor$setComparator = function (comparator) {
	return $author$project$Views$PolicyEditor$transformOrError(
		function (rule) {
			if (rule.$ === 16) {
				var severity = rule.a;
				var days = rule.c;
				return $elm$core$Result$Ok(
					A3($author$project$Model$Policy$PolicyRules$VulnsAreAllLessThanWithAgeInDays, severity, comparator, days));
			} else {
				return $elm$core$Result$Err('Expected target rule to contain a comparator');
			}
		});
};
var $author$project$Views$PolicyEditor$setConstraint = function (constraint) {
	return $author$project$Views$PolicyEditor$transformOrError(
		function (rule) {
			switch (rule.$) {
				case 10:
					var packageName = rule.a;
					return $elm$core$Result$Ok(
						A2($author$project$Model$Policy$PolicyRules$PackageMatches, packageName, constraint));
				case 5:
					var languageName = rule.a;
					return $elm$core$Result$Ok(
						A2($author$project$Model$Policy$PolicyRules$LanguageNameAndVersion, languageName, constraint));
				default:
					return $elm$core$Result$Err('Expected target rule to contain a version constraint');
			}
		});
};
var $author$project$Views$PolicyEditor$setCveId = function (cveId) {
	return $author$project$Views$PolicyEditor$transformOrError(
		function (rule) {
			if (rule.$ === 14) {
				return $elm$core$Result$Ok(
					$author$project$Model$Policy$PolicyRules$HasCVE(cveId));
			} else {
				return $elm$core$Result$Err('Expected target rule to contain a CVE ID');
			}
		});
};
var $author$project$Views$PolicyEditor$setDays = function (days) {
	return $author$project$Views$PolicyEditor$transformOrError(
		function (rule) {
			if (rule.$ === 16) {
				var severity = rule.a;
				var comparator = rule.b;
				return $elm$core$Result$Ok(
					A3($author$project$Model$Policy$PolicyRules$VulnsAreAllLessThanWithAgeInDays, severity, comparator, days));
			} else {
				return $elm$core$Result$Err('Expected target rule to contain a days value');
			}
		});
};
var $author$project$Views$PolicyEditor$setLanguageName = function (languageName) {
	return $author$project$Views$PolicyEditor$transformOrError(
		function (rule) {
			switch (rule.$) {
				case 4:
					return $elm$core$Result$Ok(
						$author$project$Model$Policy$PolicyRules$LanguageName(languageName));
				case 5:
					var constraint = rule.b;
					return $elm$core$Result$Ok(
						A2($author$project$Model$Policy$PolicyRules$LanguageNameAndVersion, languageName, constraint));
				default:
					return $elm$core$Result$Err('Expected target rule to contain a language name');
			}
		});
};
var $author$project$Views$PolicyEditor$setLanguageStatus = function (languageStatus) {
	return $author$project$Views$PolicyEditor$transformOrError(
		function (rule) {
			if (rule.$ === 6) {
				return $elm$core$Result$Ok(
					$author$project$Model$Policy$PolicyRules$LanguageStatus(languageStatus));
			} else {
				return $elm$core$Result$Err('Expected target rule to contain a language status');
			}
		});
};
var $author$project$Views$PolicyEditor$setLicense = function (licenseName) {
	return $author$project$Views$PolicyEditor$transformOrError(
		function (rule) {
			if (rule.$ === 8) {
				return $elm$core$Result$Ok(
					$author$project$Model$Policy$PolicyRules$AnyLicensesAreNamed(licenseName));
			} else {
				return $elm$core$Result$Err('Expected target rule to contain a license name');
			}
		});
};
var $author$project$Views$PolicyEditor$setLicenseCategory = function (category) {
	return $author$project$Views$PolicyEditor$transformOrError(
		function (rule) {
			if (rule.$ === 7) {
				return $elm$core$Result$Ok(
					$author$project$Model$Policy$PolicyRules$LicensesAre(category));
			} else {
				return $elm$core$Result$Err('Expected target rule to contain a license category');
			}
		});
};
var $author$project$Views$PolicyEditor$setPackage = function (packageName) {
	return $author$project$Views$PolicyEditor$transformOrError(
		function (rule) {
			switch (rule.$) {
				case 9:
					return $elm$core$Result$Ok(
						$author$project$Model$Policy$PolicyRules$PackageNameIs(packageName));
				case 10:
					var constraint = rule.b;
					return $elm$core$Result$Ok(
						A2($author$project$Model$Policy$PolicyRules$PackageMatches, packageName, constraint));
				default:
					return $elm$core$Result$Err('Expected target rule to contain a package name');
			}
		});
};
var $author$project$Views$PolicyEditor$setPolicyName = function (policyName) {
	return $author$project$Views$PolicyEditor$transformOrError(
		function (rule) {
			if (rule.$ === 11) {
				return $elm$core$Result$Ok(
					$author$project$Model$Policy$PolicyRules$PassesPolicy(policyName));
			} else {
				return $elm$core$Result$Err('Expected target rule to contain a policy name');
			}
		});
};
var $author$project$Views$PolicyEditor$setProjectName = function (projectName) {
	return $author$project$Views$PolicyEditor$transformOrError(
		function (rule) {
			if (rule.$ === 12) {
				return $elm$core$Result$Ok(
					$author$project$Model$Policy$PolicyRules$ProjectIs(projectName));
			} else {
				return $elm$core$Result$Err('Expected target rule to contain a project name');
			}
		});
};
var $author$project$Views$PolicyEditor$defaultRuleFromKind = F2(
	function (model, kind) {
		switch (kind) {
			case 0:
				return $author$project$Model$Policy$PolicyRules$And;
			case 1:
				return $author$project$Model$Policy$PolicyRules$Or;
			case 2:
				return $author$project$Model$Policy$PolicyRules$Not;
			case 3:
				return $author$project$Model$Policy$PolicyRules$LanguageName('');
			case 4:
				return A2($author$project$Model$Policy$PolicyRules$LanguageNameAndVersion, '', '');
			case 5:
				return $author$project$Model$Policy$PolicyRules$LanguageStatus(0);
			case 6:
				return $author$project$Model$Policy$PolicyRules$LicensesAre(2);
			case 7:
				return $author$project$Model$Policy$PolicyRules$AnyLicensesAreNamed('');
			case 8:
				return $author$project$Model$Policy$PolicyRules$PackageNameIs('');
			case 9:
				return A2($author$project$Model$Policy$PolicyRules$PackageMatches, '', '');
			case 10:
				return $author$project$Model$Policy$PolicyRules$PassesPolicy(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						$elm$core$List$head(model.pf)));
			case 11:
				return $author$project$Model$Policy$PolicyRules$ProjectIs(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						$elm$core$List$head(model.vU)));
			case 12:
				return $author$project$Model$Policy$PolicyRules$ProjectVisibility(0);
			case 13:
				return $author$project$Model$Policy$PolicyRules$HasCVE('');
			case 14:
				return $author$project$Model$Policy$PolicyRules$VulnsAreAllLessThan(4);
			default:
				return A3($author$project$Model$Policy$PolicyRules$VulnsAreAllLessThanWithAgeInDays, 4, 0, '');
		}
	});
var $author$project$Views$PolicyEditor$setRuleKind = F2(
	function (model, ruleKind) {
		return $author$project$Views$PolicyEditor$transformOrError(
			function (_v0) {
				return $elm$core$Result$Ok(
					A2($author$project$Views$PolicyEditor$defaultRuleFromKind, model, ruleKind));
			});
	});
var $author$project$Views$PolicyEditor$setSeverity = function (severity) {
	return $author$project$Views$PolicyEditor$transformOrError(
		function (rule) {
			switch (rule.$) {
				case 15:
					return $elm$core$Result$Ok(
						$author$project$Model$Policy$PolicyRules$VulnsAreAllLessThan(severity));
				case 16:
					var comparator = rule.b;
					var days = rule.c;
					return $elm$core$Result$Ok(
						A3($author$project$Model$Policy$PolicyRules$VulnsAreAllLessThanWithAgeInDays, severity, comparator, days));
				default:
					return $elm$core$Result$Err('Expected target rule to contain a severity');
			}
		});
};
var $author$project$Views$PolicyEditor$setVisibility = function (visibility) {
	return $author$project$Views$PolicyEditor$transformOrError(
		function (rule) {
			if (rule.$ === 13) {
				return $elm$core$Result$Ok(
					$author$project$Model$Policy$PolicyRules$ProjectVisibility(visibility));
			} else {
				return $elm$core$Result$Err('Expected target rule to contain a visibility');
			}
		});
};
var $author$project$Views$PolicyEditor$UpdateError = function (a) {
	return {$: 1, a: a};
};
var $author$project$Views$PolicyEditor$updateRules = F2(
	function (model, result) {
		if (!result.$) {
			var rules = result.a;
			var policy = model.rX;
			return A2(
				$author$project$Misc$with,
				$author$project$Views$PolicyEditor$NoOp,
				_Utils_update(
					model,
					{
						rX: _Utils_update(
							policy,
							{ks: rules})
					}));
		} else {
			var e = result.a;
			return A2(
				$author$project$Misc$with,
				$author$project$Views$PolicyEditor$UpdateError(e),
				model);
		}
	});
var $author$project$Views$PolicyEditor$validProjectNameFromString = F2(
	function (projectNames, inputString) {
		return A2($elm$core$List$member, inputString, projectNames) ? $elm$core$Result$Ok(inputString) : $elm$core$Result$Err('\"' + (inputString + '\" is not a project you have access to'));
	});
var $author$project$Views$PolicyEditor$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var ruleID = msg.a;
				var inputString = msg.b;
				return A2(
					$author$project$Views$PolicyEditor$updateRules,
					model,
					A2(
						$elm$core$Result$andThen,
						function (category) {
							return A3($author$project$Views$PolicyEditor$setLicenseCategory, category, ruleID, model.rX.ks);
						},
						$author$project$Model$Policy$LicenseCategory$fromString(inputString)));
			case 1:
				var ruleID = msg.a;
				var inputString = msg.b;
				return A2(
					$author$project$Views$PolicyEditor$updateRules,
					model,
					A2(
						$elm$core$Result$andThen,
						function (ruleKind) {
							return A4($author$project$Views$PolicyEditor$setRuleKind, model, ruleKind, ruleID, model.rX.ks);
						},
						$author$project$Model$Policy$RuleKind$fromString(inputString)));
			case 2:
				var ruleID = msg.a;
				var inputString = msg.b;
				return A2(
					$author$project$Views$PolicyEditor$updateRules,
					model,
					A2(
						$elm$core$Result$andThen,
						function (comparator) {
							return A3($author$project$Views$PolicyEditor$setComparator, comparator, ruleID, model.rX.ks);
						},
						$author$project$Model$Comparator$fromString(inputString)));
			case 3:
				var ruleID = msg.a;
				var inputString = msg.b;
				return A2(
					$author$project$Views$PolicyEditor$updateRules,
					model,
					A3($author$project$Views$PolicyEditor$setDays, inputString, ruleID, model.rX.ks));
			case 4:
				var ruleID = msg.a;
				var inputString = msg.b;
				return A2(
					$author$project$Views$PolicyEditor$updateRules,
					model,
					A3($author$project$Views$PolicyEditor$setLanguageName, inputString, ruleID, model.rX.ks));
			case 5:
				var ruleID = msg.a;
				var inputString = msg.b;
				return A2(
					$author$project$Views$PolicyEditor$updateRules,
					model,
					A2(
						$elm$core$Result$andThen,
						function (languageStatus) {
							return A3($author$project$Views$PolicyEditor$setLanguageStatus, languageStatus, ruleID, model.rX.ks);
						},
						$author$project$Model$Policy$LanguageStatus$fromString(inputString)));
			case 6:
				var ruleID = msg.a;
				var inputString = msg.b;
				return A2(
					$author$project$Views$PolicyEditor$updateRules,
					model,
					A3($author$project$Views$PolicyEditor$setLicense, inputString, ruleID, model.rX.ks));
			case 7:
				var ruleID = msg.a;
				var inputString = msg.b;
				return A2(
					$author$project$Views$PolicyEditor$updateRules,
					model,
					A3($author$project$Views$PolicyEditor$setPackage, inputString, ruleID, model.rX.ks));
			case 8:
				var ruleID = msg.a;
				var inputString = msg.b;
				return A2(
					$author$project$Views$PolicyEditor$updateRules,
					model,
					A3($author$project$Views$PolicyEditor$setPolicyName, inputString, ruleID, model.rX.ks));
			case 9:
				var ruleID = msg.a;
				var inputString = msg.b;
				return A2(
					$author$project$Views$PolicyEditor$updateRules,
					model,
					A3($author$project$Views$PolicyEditor$setConstraint, inputString, ruleID, model.rX.ks));
			case 10:
				var ruleID = msg.a;
				var inputString = msg.b;
				return A2(
					$author$project$Views$PolicyEditor$updateRules,
					model,
					A2(
						$elm$core$Result$andThen,
						function (projectName) {
							return A3($author$project$Views$PolicyEditor$setProjectName, projectName, ruleID, model.rX.ks);
						},
						A2($author$project$Views$PolicyEditor$validProjectNameFromString, model.vU, inputString)));
			case 11:
				var ruleID = msg.a;
				var inputString = msg.b;
				return A2(
					$author$project$Views$PolicyEditor$updateRules,
					model,
					function (severity) {
						return A3($author$project$Views$PolicyEditor$setSeverity, severity, ruleID, model.rX.ks);
					}(
						$author$project$Model$Severity$fromString(inputString)));
			case 12:
				var ruleID = msg.a;
				var inputString = msg.b;
				return A2(
					$author$project$Views$PolicyEditor$updateRules,
					model,
					A3($author$project$Views$PolicyEditor$setCveId, inputString, ruleID, model.rX.ks));
			case 13:
				var ruleID = msg.a;
				var inputString = msg.b;
				return A2(
					$author$project$Views$PolicyEditor$updateRules,
					model,
					A2(
						$elm$core$Result$andThen,
						function (visibility) {
							return A3($author$project$Views$PolicyEditor$setVisibility, visibility, ruleID, model.rX.ks);
						},
						$author$project$Model$Visibility$fromString(inputString)));
			case 14:
				var ruleID = msg.a;
				return A2(
					$author$project$Views$PolicyEditor$updateRules,
					model,
					A2($author$project$Views$PolicyEditor$addRule, ruleID, model.rX.ks));
			case 15:
				var ruleID = msg.a;
				return A2(
					$author$project$Views$PolicyEditor$updateRules,
					model,
					A2($author$project$Views$PolicyEditor$removeRule, ruleID, model.rX.ks));
			case 16:
				var name = msg.a;
				var policy = model.rX;
				return A2(
					$author$project$Misc$with,
					$author$project$Views$PolicyEditor$NoOp,
					_Utils_update(
						model,
						{
							rX: _Utils_update(
								policy,
								{w: name})
						}));
			case 17:
				var description = msg.a;
				var policy = model.rX;
				return A2(
					$author$project$Misc$with,
					$author$project$Views$PolicyEditor$NoOp,
					_Utils_update(
						model,
						{
							rX: _Utils_update(
								policy,
								{bP: description})
						}));
			case 18:
				var code = msg.a;
				var newModel = function () {
					var _v1 = $author$project$Model$Policy$Policy$fromJson(code);
					if (!_v1.$) {
						var policy = _v1.a;
						return _Utils_update(
							model,
							{rX: policy});
					} else {
						return model;
					}
				}();
				return A2($author$project$Misc$with, $author$project$Views$PolicyEditor$NoOp, newModel);
			default:
				var mode = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$Views$PolicyEditor$NoOp,
					_Utils_update(
						model,
						{p8: mode}));
		}
	});
var $author$project$Pages$OrgPolicy$update = F3(
	function (session, msg, model) {
		var projectNames = A2($elm$core$List$map, $author$project$Model$Project$getName, model.gx);
		switch (msg.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
			case 1:
				var whichEditor = msg.a;
				var policyEditorMsg = msg.b;
				var currentEditor = function () {
					var _v4 = _Utils_Tuple2(whichEditor, model.hC);
					if (!_v4.a) {
						var _v5 = _v4.a;
						return model.iv;
					} else {
						if (!_v4.b.$) {
							var _v6 = _v4.a;
							var editor = _v4.b.a;
							return editor;
						} else {
							return model.iv;
						}
					}
				}();
				var _v1 = A2($author$project$Views$PolicyEditor$update, policyEditorMsg, currentEditor.ga);
				var newEditorModel = _v1.a;
				var policyMsg = _v1.b;
				var newEditor = _Utils_update(
					currentEditor,
					{ga: newEditorModel});
				var newModel = function () {
					if (!whichEditor) {
						return _Utils_update(
							model,
							{iv: newEditor});
					} else {
						return _Utils_update(
							model,
							{
								hC: $elm$core$Maybe$Just(newEditor)
							});
					}
				}();
				var external = function () {
					if (!policyMsg.$) {
						return $author$project$External$NoOp;
					} else {
						var err = policyMsg.a;
						return $author$project$External$AddNotification(
							$author$project$Model$Notification$textWarning(err));
					}
				}();
				return A2(
					$author$project$Misc$with,
					external,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, newModel));
			case 2:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								hC: $elm$core$Maybe$Just(
									{
										ga: $author$project$Views$PolicyEditor$init(
											{
												uj: true,
												rX: $author$project$Model$Policy$Policy$init,
												vR: $author$project$Model$Policy$Policies$allNames(model.m2),
												vU: projectNames,
												wQ: 0
											}),
										pe: $elm$core$Maybe$Nothing
									})
							})));
			case 3:
				var policy = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								hC: $elm$core$Maybe$Just(
									{
										ga: $author$project$Views$PolicyEditor$init(
											{
												uj: false,
												rX: policy,
												vR: $author$project$Model$Policy$Policies$allNames(model.m2),
												vU: projectNames,
												wQ: $author$project$Model$Policy$Policies$isMain(policy) ? 2 : 0
											}),
										pe: $elm$core$Maybe$Just(policy)
									})
							})));
			case 4:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{ls: $elm$core$Maybe$Nothing, hC: $elm$core$Maybe$Nothing})));
			case 5:
				var editor = msg.a;
				var savedPolicy = editor.ga.rX;
				var oldName = A2(
					$elm$core$Maybe$withDefault,
					savedPolicy.w,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.w;
						},
						editor.pe));
				var newPolicies = A3($author$project$Model$Policy$Policies$set, oldName, savedPolicy, model.m2);
				var newMainEditor = $author$project$Model$Policy$Policies$isMain(savedPolicy) ? _Utils_update(
					editor,
					{
						ga: $author$project$Views$PolicyEditor$setReadOnly(editor.ga)
					}) : model.iv;
				var hasChanges = $author$project$Pages$OrgPolicy$hasChangesToPush(
					{m2: newPolicies, hc: model.hc});
				return hasChanges ? A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$author$project$Pages$OrgPolicy$pushPolicies,
							session,
							{c3: model.c3, m2: newPolicies, hc: model.hc}),
						_Utils_update(
							model,
							{hN: true}))) : A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{iv: newMainEditor, hC: $elm$core$Maybe$Nothing, m2: newPolicies})));
			case 6:
				var policy = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								ls: A2($author$project$Model$Policy$Policies$get, policy.w, model.m2)
							})));
			case 7:
				var policy = msg.a;
				var newPolicies = A2($author$project$Model$Policy$Policies$remove, policy.w, model.m2);
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$author$project$Pages$OrgPolicy$pushPolicies,
							session,
							{c3: model.c3, m2: newPolicies, hc: model.hc}),
						_Utils_update(
							model,
							{hN: true})));
			default:
				if (!msg.a.$) {
					var orgPolicy = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{
									ls: $elm$core$Maybe$Nothing,
									iv: A2($author$project$Pages$OrgPolicy$mainPolicyEditorInit, model.gx, orgPolicy.cG),
									hC: $elm$core$Maybe$Nothing,
									m2: orgPolicy.cG,
									hc: $elm$core$Maybe$Just(orgPolicy),
									hN: false
								})));
				} else {
					var err = msg.a.a;
					var message = $author$project$Pages$OrgPolicy$getSimplifiedErrorMessage(err);
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$textWarning(message)),
						A2(
							$author$project$Misc$with,
							A2($author$project$Pages$OrgPolicy$rollbar.sk, message, session),
							_Utils_update(
								model,
								{hN: false})));
				}
		}
	});
var $author$project$Request$BuildPlanner$BuildExpr = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$OrgRemediation$BuildExprs = 2;
var $author$project$Request$BuildPlanner$CommitID = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$OrgRemediation$Finished = 4;
var $author$project$GraphQL$Utils$HasuraAnalytics = 2;
var $author$project$Pages$OrgRemediation$ImpactReportMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$OrgRemediation$ImpactReports = 3;
var $author$project$Pages$OrgRemediation$Ingredients = 1;
var $author$project$Pages$OrgRemediation$OnBuildExprs = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$OrgRemediation$OnImpactReports = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$OrgRemediation$OnIngredients = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$OrgRemediation$OnPushCommitResult = F3(
	function (a, b, c) {
		return {$: 6, a: a, b: b, c: c};
	});
var $author$project$Pages$OrgRemediation$OnUpdateAnalyticsResult = F3(
	function (a, b, c) {
		return {$: 7, a: a, b: b, c: c};
	});
var $author$project$Analytics$Scalar$Uuid = $elm$core$Basics$identity;
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$getMarkers = $author$project$Model$Editor$getField(
	function ($) {
		return $.Ec;
	});
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$getImages = function (editor) {
	var _v0 = $author$project$Model$BuildPlanner$BuildExprEditor$Simple$getMarkers(editor);
	if (_v0.$ === 4) {
		var replaceImages = _v0.a;
		var scannedImages = _v0.b;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(replaceImages, scannedImages));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$markersSetter = F2(
	function (markers, fields) {
		return _Utils_update(
			fields,
			{Ec: markers});
	});
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$setImages = F2(
	function (replaceImages, scannedImages) {
		return A2(
			$author$project$Model$Editor$setField,
			$author$project$Model$BuildPlanner$BuildExprEditor$Simple$markersSetter,
			A2($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$MarkersImages, replaceImages, scannedImages));
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$addReplaceImage = F2(
	function (replaceImage, editor) {
		var _v0 = $author$project$Model$BuildPlanner$BuildExprEditor$Simple$getImages(editor);
		if (_v0.$ === 1) {
			return editor;
		} else {
			var _v1 = _v0.a;
			var replaceImages = _v1.a;
			var images = _v1.b;
			return A3(
				$author$project$Model$BuildPlanner$BuildExprEditor$Simple$setImages,
				A2($elm$core$List$cons, replaceImage, replaceImages),
				images,
				editor);
		}
	});
var $author$project$Pages$OrgRemediation$findReplaceImages = F2(
	function (buildPlans, ingredients) {
		return A3(
			$elm$core$Dict$foldl,
			F2(
				function (projectName, buildPlanImages) {
					var improvements = A2(
						$elm$core$List$filterMap,
						function (image) {
							return A2(
								$elm$core$Maybe$andThen,
								function (latest) {
									return (_Utils_eq(image.aI, latest.G7.aI) || _Utils_eq(image.tC, latest.dE)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
										{
											jE: $elm$core$Maybe$Nothing,
											Ea: _List_fromArray(
												[image.tC]),
											w: $author$project$Model$Namespace$getName(image.Y),
											aE: $author$project$Model$Namespace$getNamespace(image.Y),
											aI: latest.G7.aI
										});
								},
								A2(
									$elm$core$Maybe$andThen,
									$elm$core$List$head,
									A2($elm$core$Dict$get, image.Y, ingredients)));
						},
						buildPlanImages.l8);
					return $elm$core$List$isEmpty(improvements) ? $elm$core$Basics$identity : A2($elm$core$Dict$insert, projectName, improvements);
				}),
			$elm$core$Dict$empty,
			buildPlans);
	});
var $author$project$GraphQL$Utils$HasuraInventory = 1;
var $author$project$Request$AvailableVersions$VersionAndRevisions = F2(
	function (version, revisions) {
		return {bc: revisions, aI: version};
	});
var $author$project$Request$AvailableVersions$Revision = F3(
	function (isIndemnified, status, checksum) {
		return {dE: checksum, Dm: isIndemnified, L: status};
	});
var $author$project$Inventory$Object$Ingredient_version_revision$is_indemnified = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'is_indemnified', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Model$RevisionStatus$Deleted = {$: 2};
var $author$project$Model$RevisionStatus$Deprecated = {$: 3};
var $author$project$Model$RevisionStatus$Stable = {$: 0};
var $author$project$Model$RevisionStatus$Unknown = function (a) {
	return {$: 4, a: a};
};
var $author$project$Model$RevisionStatus$Unstable = {$: 1};
var $author$project$Model$RevisionStatus$decode = A2(
	$elm$json$Json$Decode$map,
	function (str) {
		switch (str) {
			case 'stable':
				return $author$project$Model$RevisionStatus$Stable;
			case 'unstable':
				return $author$project$Model$RevisionStatus$Unstable;
			case 'deleted':
				return $author$project$Model$RevisionStatus$Deleted;
			case 'deprecated':
				return $author$project$Model$RevisionStatus$Deprecated;
			default:
				return $author$project$Model$RevisionStatus$Unknown(str);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Inventory$Scalar$Bigint = $elm$core$Basics$identity;
var $author$project$Inventory$Scalar$Bit_width = $elm$core$Basics$identity;
var $author$project$Inventory$Scalar$Build_flag_comparator_operator = $elm$core$Basics$identity;
var $author$project$Inventory$Scalar$Citext = $elm$core$Basics$identity;
var $author$project$Inventory$Scalar$Comparator_operator = $elm$core$Basics$identity;
var $author$project$Inventory$Scalar$Date = $elm$core$Basics$identity;
var $author$project$Inventory$Scalar$Dependency_type = $elm$core$Basics$identity;
var $author$project$Inventory$Scalar$Float8 = $elm$core$Basics$identity;
var $author$project$Inventory$Scalar$Image_type = $elm$core$Basics$identity;
var $author$project$Inventory$Scalar$Ingredient_option_set_usage_type = $elm$core$Basics$identity;
var $author$project$Inventory$Scalar$Ingredient_version_revision_reason = $elm$core$Basics$identity;
var $author$project$Inventory$Scalar$Jsonb = $elm$core$Basics$identity;
var $author$project$Inventory$Scalar$Name_normalization_algorithm_name = $elm$core$Basics$identity;
var $author$project$Inventory$Scalar$Non_empty_citext = $elm$core$Basics$identity;
var $author$project$Inventory$Scalar$Non_empty_citext_ = $elm$core$Basics$identity;
var $author$project$Inventory$Scalar$Non_empty_text = $elm$core$Basics$identity;
var $author$project$Inventory$Scalar$Numeric_ = $elm$core$Basics$identity;
var $author$project$Inventory$Scalar$Package_import_state = $elm$core$Basics$identity;
var $author$project$Inventory$Scalar$Package_version_import_state = $elm$core$Basics$identity;
var $author$project$Inventory$Scalar$Revision_status = $elm$core$Basics$identity;
var $author$project$Inventory$Scalar$Timestamptz = $elm$core$Basics$identity;
var $author$project$Inventory$Scalar$Uuid = $elm$core$Basics$identity;
var $author$project$Inventory$Scalar$Version_parsing_algorithm_name = $elm$core$Basics$identity;
var $author$project$Inventory$Scalar$defaultCodecs = {
	dk: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v0) {
			var raw = _v0;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	h8: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v1) {
			var raw = _v1;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	h9: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v2) {
			var raw = _v2;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	cL: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v3) {
			var raw = _v3;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	fA: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v4) {
			var raw = _v4;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	ic: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v5) {
			var raw = _v5;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	id: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v6) {
			var raw = _v6;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	fL: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v7) {
			var raw = _v7;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	ie: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v8) {
			var raw = _v8;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	$8: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v9) {
			var raw = _v9;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	ig: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v10) {
			var raw = _v10;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	g1: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v11) {
			var raw = _v11;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	ii: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v12) {
			var raw = _v12;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	hn: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v13) {
			var raw = _v13;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	BN: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v14) {
			var raw = _v14;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	g2: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v15) {
			var raw = _v15;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	dn: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v16) {
			var raw = _v16;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	ij: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v17) {
			var raw = _v17;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	ik: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v18) {
			var raw = _v18;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	g3: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v19) {
			var raw = _v19;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	il: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v20) {
			var raw = _v20;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	aq: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v21) {
			var raw = _v21;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	$9: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v22) {
			var raw = _v22;
			return $elm$json$Json$Encode$string(raw);
		}
	}
};
var $author$project$Inventory$Scalar$Codecs = $elm$core$Basics$identity;
var $author$project$Inventory$Scalar$defineCodecs = function (definitions) {
	return definitions;
};
var $author$project$Model$RevisionStatus$encode = function (status) {
	return $elm$json$Json$Encode$string(
		function () {
			switch (status.$) {
				case 0:
					return 'stable';
				case 1:
					return 'unstable';
				case 2:
					return 'deleted';
				case 3:
					return 'deprecated';
				default:
					var str = status.a;
					return str;
			}
		}());
};
var $author$project$InventoryScalarCodecs$codecs = $author$project$Inventory$Scalar$defineCodecs(
	{
		dk: $author$project$Inventory$Scalar$defaultCodecs.dk,
		h8: $author$project$Inventory$Scalar$defaultCodecs.h8,
		h9: $author$project$Inventory$Scalar$defaultCodecs.h9,
		cL: {qN: $elm$json$Json$Decode$string, lN: $elm$json$Json$Encode$string},
		fA: $author$project$Inventory$Scalar$defaultCodecs.fA,
		ic: $author$project$Inventory$Scalar$defaultCodecs.ic,
		id: $author$project$Inventory$Scalar$defaultCodecs.id,
		fL: $author$project$Inventory$Scalar$defaultCodecs.fL,
		ie: $author$project$Inventory$Scalar$defaultCodecs.ie,
		$8: $author$project$Inventory$Scalar$defaultCodecs.$8,
		ig: $author$project$Inventory$Scalar$defaultCodecs.ig,
		g1: $author$project$Inventory$Scalar$defaultCodecs.g1,
		ii: $author$project$Inventory$Scalar$defaultCodecs.ii,
		hn: $author$project$Inventory$Scalar$defaultCodecs.hn,
		BN: $author$project$Inventory$Scalar$defaultCodecs.BN,
		g2: $author$project$Inventory$Scalar$defaultCodecs.g2,
		dn: {
			qN: $elm$json$Json$Decode$list($elm$json$Json$Decode$float),
			lN: $elm$json$Json$Encode$list($elm$json$Json$Encode$float)
		},
		ij: $author$project$Inventory$Scalar$defaultCodecs.ij,
		ik: $author$project$Inventory$Scalar$defaultCodecs.ik,
		g3: {qN: $author$project$Model$RevisionStatus$decode, lN: $author$project$Model$RevisionStatus$encode},
		il: $author$project$Inventory$Scalar$defaultCodecs.il,
		aq: $author$project$Inventory$Scalar$defaultCodecs.aq,
		$9: $author$project$Inventory$Scalar$defaultCodecs.$9
	});
var $author$project$Inventory$Scalar$unwrapCodecs = function (_v0) {
	var unwrappedCodecs = _v0;
	return unwrappedCodecs;
};
var $author$project$Inventory$Object$Ingredient_version_revision$source_checksum = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe InventoryScalarCodecs.Citext)',
	'source_checksum',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$Inventory$Scalar$unwrapCodecs($author$project$InventoryScalarCodecs$codecs).cL.qN));
var $author$project$Inventory$Object$Ingredient_version_revision$status = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'InventoryScalarCodecs.Revision_status',
	'status',
	_List_Nil,
	$author$project$Inventory$Scalar$unwrapCodecs($author$project$InventoryScalarCodecs$codecs).g3.qN);
var $author$project$Request$AvailableVersions$revisionSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$Inventory$Object$Ingredient_version_revision$source_checksum),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Inventory$Object$Ingredient_version_revision$status,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Inventory$Object$Ingredient_version_revision$is_indemnified,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Request$AvailableVersions$Revision))));
var $author$project$Inventory$Scalar$unwrapEncoder = F2(
	function (getter, _v0) {
		var unwrappedCodecs = _v0;
		return A2(
			$elm$core$Basics$composeR,
			getter(unwrappedCodecs).lN,
			$dillonkearns$elm_graphql$Graphql$Internal$Encode$fromJson);
	});
var $author$project$Inventory$InputObject$encodeBigint_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_eq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aW,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.dk;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aY,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.dk;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aZ,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.dk;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Inventory$Scalar$unwrapEncoder,
							function ($) {
								return $.dk;
							},
							$author$project$InventoryScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a0,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.dk;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_lte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a1,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.dk;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_neq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a4,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.dk;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Inventory$Scalar$unwrapEncoder,
							function ($) {
								return $.dk;
							},
							$author$project$InventoryScalarCodecs$codecs))))
			]));
};
var $author$project$Inventory$InputObject$encodeBoolean_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_eq',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aW, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_gt',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aY, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_gte',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aZ, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$bool))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lt',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a0, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lte',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_neq',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a4, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)))
			]));
};
var $author$project$Inventory$InputObject$encodeCitext_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_eq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aW,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.cL;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aY,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.cL;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aZ,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.cL;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_ilike',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.l7,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.cL;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Inventory$Scalar$unwrapEncoder,
							function ($) {
								return $.cL;
							},
							$author$project$InventoryScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_iregex',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.mj,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.cL;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_like',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.mt,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.cL;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_lt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a0,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.cL;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_lte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a1,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.cL;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_neq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a4,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.cL;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_nilike',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.mI,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.cL;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Inventory$Scalar$unwrapEncoder,
							function ($) {
								return $.cL;
							},
							$author$project$InventoryScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_niregex',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.mJ,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.cL;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_nlike',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.mK,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.cL;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_nregex',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.mO,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.cL;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_nsimilar',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.mP,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.cL;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_regex',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.nd,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.cL;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_similar',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.nv,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.cL;
						},
						$author$project$InventoryScalarCodecs$codecs)))
			]));
};
var $author$project$Inventory$InputObject$encodeComparator_operator_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_eq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aW,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.fA;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aY,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.fA;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aZ,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.fA;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Inventory$Scalar$unwrapEncoder,
							function ($) {
								return $.fA;
							},
							$author$project$InventoryScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a0,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.fA;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_lte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a1,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.fA;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_neq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a4,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.fA;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Inventory$Scalar$unwrapEncoder,
							function ($) {
								return $.fA;
							},
							$author$project$InventoryScalarCodecs$codecs))))
			]));
};
var $author$project$Inventory$InputObject$encodeDependency_type_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_eq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aW,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.id;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aY,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.id;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aZ,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.id;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Inventory$Scalar$unwrapEncoder,
							function ($) {
								return $.id;
							},
							$author$project$InventoryScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a0,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.id;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_lte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a1,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.id;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_neq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a4,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.id;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Inventory$Scalar$unwrapEncoder,
							function ($) {
								return $.id;
							},
							$author$project$InventoryScalarCodecs$codecs))))
			]));
};
var $author$project$Inventory$InputObject$encodeFloat8_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_eq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aW,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.fL;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aY,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.fL;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aZ,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.fL;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Inventory$Scalar$unwrapEncoder,
							function ($) {
								return $.fL;
							},
							$author$project$InventoryScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a0,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.fL;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_lte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a1,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.fL;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_neq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a4,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.fL;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Inventory$Scalar$unwrapEncoder,
							function ($) {
								return $.fL;
							},
							$author$project$InventoryScalarCodecs$codecs))))
			]));
};
var $author$project$Inventory$InputObject$encodeString_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_eq',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aW, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_gt',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aY, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_gte',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aZ, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_ilike',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.l7, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string))),
				_Utils_Tuple2(
				'_iregex',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mj, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_like',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mt, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_lt',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a0, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_lte',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_neq',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a4, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_nilike',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mI, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string))),
				_Utils_Tuple2(
				'_niregex',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mJ, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_nlike',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mK, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_nregex',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mO, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_nsimilar',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mP, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_regex',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.nd, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_similar',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.nv, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))
			]));
};
var $author$project$Inventory$InputObject$encodeUuid_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_eq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aW,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.aq;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aY,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.aq;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aZ,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.aq;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Inventory$Scalar$unwrapEncoder,
							function ($) {
								return $.aq;
							},
							$author$project$InventoryScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a0,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.aq;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_lte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a1,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.aq;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_neq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a4,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.aq;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Inventory$Scalar$unwrapEncoder,
							function ($) {
								return $.aq;
							},
							$author$project$InventoryScalarCodecs$codecs))))
			]));
};
var $author$project$Inventory$InputObject$encodeHost_attribute_bool_exp = function (_v0) {
	var input____ = _v0;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeHost_attribute_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Inventory$InputObject$encodeHost_attribute_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeHost_attribute_bool_exp))),
				_Utils_Tuple2(
				'host_attribute_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bQ, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'ingredient_option_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.K, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'name',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.w, $author$project$Inventory$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'value',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.kH, $author$project$Inventory$InputObject$encodeString_comparison_exp))
			]));
};
var $author$project$Inventory$InputObject$encodeBuild_flag_comparator_operator_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_eq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aW,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.h9;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aY,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.h9;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aZ,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.h9;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Inventory$Scalar$unwrapEncoder,
							function ($) {
								return $.h9;
							},
							$author$project$InventoryScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a0,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.h9;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_lte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a1,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.h9;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_neq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a4,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.h9;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Inventory$Scalar$unwrapEncoder,
							function ($) {
								return $.h9;
							},
							$author$project$InventoryScalarCodecs$codecs))))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_option_build_flag_condition_bool_exp = function (_v0) {
	var input____ = _v0;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeIngredient_option_build_flag_condition_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Inventory$InputObject$encodeIngredient_option_build_flag_condition_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeIngredient_option_build_flag_condition_bool_exp))),
				_Utils_Tuple2(
				'comparator',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.h, $author$project$Inventory$InputObject$encodeBuild_flag_comparator_operator_comparison_exp)),
				_Utils_Tuple2(
				'ingredient_option_build_flag_condition_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bU, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'ingredient_option_condition_set_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.J, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'name',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.w, $author$project$Inventory$InputObject$encodeCitext_comparison_exp)),
				_Utils_Tuple2(
				'value',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.kH, $author$project$Inventory$InputObject$encodeCitext_comparison_exp))
			]));
};
var $author$project$Inventory$InputObject$encodeNumeric_comparison_exp_ = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_eq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aW,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.dn;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aY,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.dn;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aZ,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.dn;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Inventory$Scalar$unwrapEncoder,
							function ($) {
								return $.dn;
							},
							$author$project$InventoryScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a0,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.dn;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_lte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a1,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.dn;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_neq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a4,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.dn;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Inventory$Scalar$unwrapEncoder,
							function ($) {
								return $.dn;
							},
							$author$project$InventoryScalarCodecs$codecs))))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_option_condition_requirement_bool_exp = function (_v0) {
	var input____ = _v0;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeIngredient_option_condition_requirement_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Inventory$InputObject$encodeIngredient_option_condition_requirement_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeIngredient_option_condition_requirement_bool_exp))),
				_Utils_Tuple2(
				'comparator',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.h, $author$project$Inventory$InputObject$encodeComparator_operator_comparison_exp)),
				_Utils_Tuple2(
				'ingredient_option_condition_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ay, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'ingredient_option_condition_requirement_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bV, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'sortable_version',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gE, $author$project$Inventory$InputObject$encodeNumeric_comparison_exp_)),
				_Utils_Tuple2(
				'version',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aI, $author$project$Inventory$InputObject$encodeCitext_comparison_exp))
			]));
};
var $author$project$Inventory$InputObject$encodeName_normalization_algorithm_name_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_eq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aW,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.ii;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aY,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.ii;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aZ,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.ii;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Inventory$Scalar$unwrapEncoder,
							function ($) {
								return $.ii;
							},
							$author$project$InventoryScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a0,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.ii;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_lte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a1,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.ii;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_neq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a4,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.ii;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Inventory$Scalar$unwrapEncoder,
							function ($) {
								return $.ii;
							},
							$author$project$InventoryScalarCodecs$codecs))))
			]));
};
var $author$project$Inventory$InputObject$encodeNamespace_type_bool_exp = function (_v0) {
	var input____ = _v0;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeNamespace_type_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Inventory$InputObject$encodeNamespace_type_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeNamespace_type_bool_exp))),
				_Utils_Tuple2(
				'description',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bP, $author$project$Inventory$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'name',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.w, $author$project$Inventory$InputObject$encodeCitext_comparison_exp)),
				_Utils_Tuple2(
				'namespace_type_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.by, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'requires_language',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.eG, $author$project$Inventory$InputObject$encodeBoolean_comparison_exp))
			]));
};
var $author$project$Inventory$InputObject$encodeVersion_parsing_algorithm_name_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_eq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aW,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.$9;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aY,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.$9;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aZ,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.$9;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Inventory$Scalar$unwrapEncoder,
							function ($) {
								return $.$9;
							},
							$author$project$InventoryScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a0,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.$9;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_lte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a1,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.$9;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_neq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a4,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.$9;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Inventory$Scalar$unwrapEncoder,
							function ($) {
								return $.$9;
							},
							$author$project$InventoryScalarCodecs$codecs))))
			]));
};
var $author$project$Inventory$InputObject$encodeNamespace_bool_exp = function (_v0) {
	var input____ = _v0;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeNamespace_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Inventory$InputObject$encodeNamespace_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeNamespace_bool_exp))),
				_Utils_Tuple2(
				'for_language',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dX, $author$project$Inventory$InputObject$encodeCitext_comparison_exp)),
				_Utils_Tuple2(
				'is_public',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ek, $author$project$Inventory$InputObject$encodeBoolean_comparison_exp)),
				_Utils_Tuple2(
				'name_normalization_algorithm',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ev, $author$project$Inventory$InputObject$encodeName_normalization_algorithm_name_comparison_exp)),
				_Utils_Tuple2(
				'namespace',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aE, $author$project$Inventory$InputObject$encodeCitext_comparison_exp)),
				_Utils_Tuple2(
				'namespace_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'namespace_type_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.by, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'owner_platform_organization_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ex, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'type',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gR, $author$project$Inventory$InputObject$encodeNamespace_type_bool_exp)),
				_Utils_Tuple2(
				'version_parsing_algorithm',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.e_, $author$project$Inventory$InputObject$encodeVersion_parsing_algorithm_name_comparison_exp))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_option_condition_bool_exp = function (_v0) {
	var input____ = _v0;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeIngredient_option_condition_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Inventory$InputObject$encodeIngredient_option_condition_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeIngredient_option_condition_bool_exp))),
				_Utils_Tuple2(
				'feature',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d, $author$project$Inventory$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'ingredient_option_condition_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ay, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'ingredient_option_condition_set_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.J, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'namespace',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aE, $author$project$Inventory$InputObject$encodeNamespace_bool_exp)),
				_Utils_Tuple2(
				'namespace_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'requirements',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.FF, $author$project$Inventory$InputObject$encodeIngredient_option_condition_requirement_bool_exp))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_option_condition_set_bool_exp = function (_v0) {
	var input____ = _v0;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeIngredient_option_condition_set_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Inventory$InputObject$encodeIngredient_option_condition_set_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeIngredient_option_condition_set_bool_exp))),
				_Utils_Tuple2(
				'build_flag_conditions',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.k3, $author$project$Inventory$InputObject$encodeIngredient_option_build_flag_condition_bool_exp)),
				_Utils_Tuple2(
				'conditions',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ld, $author$project$Inventory$InputObject$encodeIngredient_option_condition_bool_exp)),
				_Utils_Tuple2(
				'ingredient_option_condition_set_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.J, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'ingredient_option_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.K, $author$project$Inventory$InputObject$encodeUuid_comparison_exp))
			]));
};
var $author$project$Inventory$InputObject$encodeInt_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_eq',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aW, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)),
				_Utils_Tuple2(
				'_gt',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aY, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)),
				_Utils_Tuple2(
				'_gte',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aZ, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$int))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lt',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a0, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)),
				_Utils_Tuple2(
				'_lte',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)),
				_Utils_Tuple2(
				'_neq',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a4, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$int)))
			]));
};
var $author$project$Inventory$InputObject$encodeNon_empty_text_array_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_contained_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.le,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Inventory$Scalar$unwrapEncoder,
							function ($) {
								return $.g2;
							},
							$author$project$InventoryScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_contains',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.lf,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Inventory$Scalar$unwrapEncoder,
							function ($) {
								return $.g2;
							},
							$author$project$InventoryScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_eq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aW,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Inventory$Scalar$unwrapEncoder,
							function ($) {
								return $.g2;
							},
							$author$project$InventoryScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_gt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aY,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Inventory$Scalar$unwrapEncoder,
							function ($) {
								return $.g2;
							},
							$author$project$InventoryScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_gte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aZ,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Inventory$Scalar$unwrapEncoder,
							function ($) {
								return $.g2;
							},
							$author$project$InventoryScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
							A2(
								$author$project$Inventory$Scalar$unwrapEncoder,
								function ($) {
									return $.g2;
								},
								$author$project$InventoryScalarCodecs$codecs))))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a0,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Inventory$Scalar$unwrapEncoder,
							function ($) {
								return $.g2;
							},
							$author$project$InventoryScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_lte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a1,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Inventory$Scalar$unwrapEncoder,
							function ($) {
								return $.g2;
							},
							$author$project$InventoryScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_neq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a4,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Inventory$Scalar$unwrapEncoder,
							function ($) {
								return $.g2;
							},
							$author$project$InventoryScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
							A2(
								$author$project$Inventory$Scalar$unwrapEncoder,
								function ($) {
									return $.g2;
								},
								$author$project$InventoryScalarCodecs$codecs)))))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_option_bool_exp = function (_v0) {
	var input____ = _v0;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeIngredient_option_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Inventory$InputObject$encodeIngredient_option_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeIngredient_option_bool_exp))),
				_Utils_Tuple2(
				'command_line_args',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bJ, $author$project$Inventory$InputObject$encodeNon_empty_text_array_comparison_exp)),
				_Utils_Tuple2(
				'condition_sets',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.lb, $author$project$Inventory$InputObject$encodeIngredient_option_condition_set_bool_exp)),
				_Utils_Tuple2(
				'cpus',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.T, $author$project$Inventory$InputObject$encodeFloat8_comparison_exp)),
				_Utils_Tuple2(
				'host_attributes',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.l4, $author$project$Inventory$InputObject$encodeHost_attribute_bool_exp)),
				_Utils_Tuple2(
				'ingredient_option_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.K, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'ingredient_option_set_revision_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.az, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'memory_mb',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aa, $author$project$Inventory$InputObject$encodeInt_comparison_exp)),
				_Utils_Tuple2(
				'sequence_number',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f, $author$project$Inventory$InputObject$encodeInt_comparison_exp))
			]));
};
var $author$project$Inventory$InputObject$encodeRevision_status_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_eq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aW,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.g3;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aY,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.g3;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aZ,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.g3;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Inventory$Scalar$unwrapEncoder,
							function ($) {
								return $.g3;
							},
							$author$project$InventoryScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a0,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.g3;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_lte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a1,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.g3;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_neq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a4,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.g3;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Inventory$Scalar$unwrapEncoder,
							function ($) {
								return $.g3;
							},
							$author$project$InventoryScalarCodecs$codecs))))
			]));
};
var $author$project$Inventory$InputObject$encodeTimestamptz_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_eq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aW,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.il;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aY,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.il;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aZ,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.il;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Inventory$Scalar$unwrapEncoder,
							function ($) {
								return $.il;
							},
							$author$project$InventoryScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a0,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.il;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_lte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a1,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.il;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_neq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a4,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.il;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Inventory$Scalar$unwrapEncoder,
							function ($) {
								return $.il;
							},
							$author$project$InventoryScalarCodecs$codecs))))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_option_set_revision_bool_exp = function (_v0) {
	var input____ = _v0;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeIngredient_option_set_revision_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Inventory$InputObject$encodeIngredient_option_set_revision_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeIngredient_option_set_revision_bool_exp))),
				_Utils_Tuple2(
				'author_platform_user_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'comment',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c, $author$project$Inventory$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'creation_timestamp',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $author$project$Inventory$InputObject$encodeTimestamptz_comparison_exp)),
				_Utils_Tuple2(
				'ingredient_option_set_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.W, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'ingredient_option_set_revision_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.az, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'ingredient_options',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mc, $author$project$Inventory$InputObject$encodeIngredient_option_bool_exp)),
				_Utils_Tuple2(
				'revision',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ac, $author$project$Inventory$InputObject$encodeInt_comparison_exp)),
				_Utils_Tuple2(
				'status',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.L, $author$project$Inventory$InputObject$encodeRevision_status_comparison_exp))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_option_set_bool_exp = function (_v0) {
	var input____ = _v0;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeIngredient_option_set_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Inventory$InputObject$encodeIngredient_option_set_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeIngredient_option_set_bool_exp))),
				_Utils_Tuple2(
				'group_name',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dZ, $author$project$Inventory$InputObject$encodeCitext_comparison_exp)),
				_Utils_Tuple2(
				'ingredient_option_set_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.W, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'revisions',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bc, $author$project$Inventory$InputObject$encodeIngredient_option_set_revision_bool_exp))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_option_set_usage_type_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_eq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aW,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.$8;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aY,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.$8;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aZ,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.$8;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Inventory$Scalar$unwrapEncoder,
							function ($) {
								return $.$8;
							},
							$author$project$InventoryScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a0,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.$8;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_lte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a1,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.$8;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_neq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a4,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.$8;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Inventory$Scalar$unwrapEncoder,
							function ($) {
								return $.$8;
							},
							$author$project$InventoryScalarCodecs$codecs))))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_ingredient_option_set_bool_exp = function (_v0) {
	var input____ = _v0;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeIngredient_version_revision_ingredient_option_set_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Inventory$InputObject$encodeIngredient_version_revision_ingredient_option_set_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeIngredient_version_revision_ingredient_option_set_bool_exp))),
				_Utils_Tuple2(
				'ingredient_option_set_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.W, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'ingredient_version_revision_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b$, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'option_set',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gu, $author$project$Inventory$InputObject$encodeIngredient_option_set_bool_exp)),
				_Utils_Tuple2(
				'sequence_number',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f, $author$project$Inventory$InputObject$encodeInt_comparison_exp)),
				_Utils_Tuple2(
				'usage_type',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cu, $author$project$Inventory$InputObject$encodeIngredient_option_set_usage_type_comparison_exp))
			]));
};
var $author$project$Inventory$InputObject$encodePatch_condition_requirement_bool_exp = function (_v0) {
	var input____ = _v0;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodePatch_condition_requirement_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Inventory$InputObject$encodePatch_condition_requirement_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodePatch_condition_requirement_bool_exp))),
				_Utils_Tuple2(
				'comparator',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.h, $author$project$Inventory$InputObject$encodeComparator_operator_comparison_exp)),
				_Utils_Tuple2(
				'patch_condition_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aG, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'patch_condition_requirement_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ca, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'sortable_version',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gE, $author$project$Inventory$InputObject$encodeNumeric_comparison_exp_)),
				_Utils_Tuple2(
				'version',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aI, $author$project$Inventory$InputObject$encodeCitext_comparison_exp))
			]));
};
var $author$project$Inventory$InputObject$encodePatch_condition_bool_exp = function (_v0) {
	var input____ = _v0;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodePatch_condition_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Inventory$InputObject$encodePatch_condition_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodePatch_condition_bool_exp))),
				_Utils_Tuple2(
				'feature',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d, $author$project$Inventory$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'namespace',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aE, $author$project$Inventory$InputObject$encodeNamespace_bool_exp)),
				_Utils_Tuple2(
				'namespace_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'patch_condition_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aG, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'patch_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ab, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'requirements',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.FF, $author$project$Inventory$InputObject$encodePatch_condition_requirement_bool_exp))
			]));
};
var $author$project$Inventory$InputObject$encodePatch_bool_exp = function (_v0) {
	var input____ = _v0;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodePatch_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Inventory$InputObject$encodePatch_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodePatch_bool_exp))),
				_Utils_Tuple2(
				'conditions',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ld, $author$project$Inventory$InputObject$encodePatch_condition_bool_exp)),
				_Utils_Tuple2(
				'content',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dH, $author$project$Inventory$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'creation_timestamp',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $author$project$Inventory$InputObject$encodeTimestamptz_comparison_exp)),
				_Utils_Tuple2(
				'description',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bP, $author$project$Inventory$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'patch_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ab, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'source_checksum',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.be, $author$project$Inventory$InputObject$encodeCitext_comparison_exp))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_patch_bool_exp = function (_v0) {
	var input____ = _v0;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeIngredient_version_revision_patch_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Inventory$InputObject$encodeIngredient_version_revision_patch_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeIngredient_version_revision_patch_bool_exp))),
				_Utils_Tuple2(
				'ingredient_version_revision_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b$, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'patch',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gw, $author$project$Inventory$InputObject$encodePatch_bool_exp)),
				_Utils_Tuple2(
				'patch_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ab, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'sequence_number',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f, $author$project$Inventory$InputObject$encodeInt_comparison_exp))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_reason_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_eq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aW,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.ig;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aY,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.ig;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aZ,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.ig;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Inventory$Scalar$unwrapEncoder,
							function ($) {
								return $.ig;
							},
							$author$project$InventoryScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a0,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.ig;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_lte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a1,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.ig;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_neq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a4,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.ig;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Inventory$Scalar$unwrapEncoder,
							function ($) {
								return $.ig;
							},
							$author$project$InventoryScalarCodecs$codecs))))
			]));
};
var $author$project$Inventory$InputObject$encodeJsonb_cast_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'String',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.nA, $author$project$Inventory$InputObject$encodeString_comparison_exp))
			]));
};
var $author$project$Inventory$InputObject$encodeJsonb_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_cast',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.k6, $author$project$Inventory$InputObject$encodeJsonb_cast_exp)),
				_Utils_Tuple2(
				'_contained_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.le,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.g1;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_contains',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.lf,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.g1;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_eq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aW,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.g1;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aY,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.g1;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aZ,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.g1;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_has_key',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.l0, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_has_keys_all',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.l1,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string))),
				_Utils_Tuple2(
				'_has_keys_any',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.l2,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string))),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Inventory$Scalar$unwrapEncoder,
							function ($) {
								return $.g1;
							},
							$author$project$InventoryScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a0,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.g1;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_lte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a1,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.g1;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_neq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a4,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.g1;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Inventory$Scalar$unwrapEncoder,
							function ($) {
								return $.g1;
							},
							$author$project$InventoryScalarCodecs$codecs))))
			]));
};
var $author$project$Inventory$Enum$Ingredient_version_revision_select_column$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'activestate_license_expression';
		case 1:
			return 'author_platform_user_id';
		case 2:
			return 'camel_extras';
		case 3:
			return 'comment';
		case 4:
			return 'creation_timestamp';
		case 5:
			return 'ingredient_version_id';
		case 6:
			return 'ingredient_version_revision_id';
		case 7:
			return 'is_indemnified';
		case 8:
			return 'is_stable_release';
		case 9:
			return 'license_manifest_uri';
		case 10:
			return 'platform_source_uri';
		case 11:
			return 'reason';
		case 12:
			return 'revision';
		case 13:
			return 'scanner_license_expression';
		case 14:
			return 'source_checksum';
		default:
			return 'status';
	}
};
var $author$project$Inventory$Enum$Ingredient_version_revision_select_column_ingredient_version_revision_aggregate_bool_exp_bool_and_arguments_columns$toString = function (enum____) {
	if (!enum____) {
		return 'is_indemnified';
	} else {
		return 'is_stable_release';
	}
};
var $author$project$Inventory$Enum$Ingredient_version_revision_select_column_ingredient_version_revision_aggregate_bool_exp_bool_or_arguments_columns$toString = function (enum____) {
	if (!enum____) {
		return 'is_indemnified';
	} else {
		return 'is_stable_release';
	}
};
var $author$project$Inventory$InputObject$encodeDependency_bool_exp = function (_v19) {
	var input____ = _v19;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeDependency_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Inventory$InputObject$encodeDependency_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeDependency_bool_exp))),
				_Utils_Tuple2(
				'conditions',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ld, $author$project$Inventory$InputObject$encodeDependency_condition_bool_exp)),
				_Utils_Tuple2(
				'dependency_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.q, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'dependency_to_requirements',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.lv, $author$project$Inventory$InputObject$encodeDependency_to_requirement_bool_exp)),
				_Utils_Tuple2(
				'description',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bP, $author$project$Inventory$InputObject$encodeCitext_comparison_exp)),
				_Utils_Tuple2(
				'feature',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d, $author$project$Inventory$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'ingredient_version_revision',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bw, $author$project$Inventory$InputObject$encodeIngredient_version_revision_bool_exp)),
				_Utils_Tuple2(
				'ingredient_version_revision_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b$, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'namespace',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aE, $author$project$Inventory$InputObject$encodeNamespace_bool_exp)),
				_Utils_Tuple2(
				'namespace_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'original_requirement',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b9, $author$project$Inventory$InputObject$encodeCitext_comparison_exp)),
				_Utils_Tuple2(
				'requirements',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.FF, $author$project$Inventory$InputObject$encodeDependency_requirement_bool_exp)),
				_Utils_Tuple2(
				'type',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gR, $author$project$Inventory$InputObject$encodeDependency_type_comparison_exp))
			]));
};
var $author$project$Inventory$InputObject$encodeDependency_condition_bool_exp = function (_v18) {
	var input____ = _v18;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeDependency_condition_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Inventory$InputObject$encodeDependency_condition_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeDependency_condition_bool_exp))),
				_Utils_Tuple2(
				'dependency',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bs, $author$project$Inventory$InputObject$encodeDependency_bool_exp)),
				_Utils_Tuple2(
				'dependency_condition_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.at, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'dependency_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.q, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'feature',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d, $author$project$Inventory$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'namespace',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aE, $author$project$Inventory$InputObject$encodeNamespace_bool_exp)),
				_Utils_Tuple2(
				'namespace_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'original_condition',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b8, $author$project$Inventory$InputObject$encodeCitext_comparison_exp)),
				_Utils_Tuple2(
				'requirements',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.FF, $author$project$Inventory$InputObject$encodeDependency_condition_requirement_bool_exp))
			]));
};
var $author$project$Inventory$InputObject$encodeDependency_condition_requirement_bool_exp = function (_v17) {
	var input____ = _v17;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeDependency_condition_requirement_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Inventory$InputObject$encodeDependency_condition_requirement_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeDependency_condition_requirement_bool_exp))),
				_Utils_Tuple2(
				'comparator',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.h, $author$project$Inventory$InputObject$encodeComparator_operator_comparison_exp)),
				_Utils_Tuple2(
				'dependency_condition',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f3, $author$project$Inventory$InputObject$encodeDependency_condition_bool_exp)),
				_Utils_Tuple2(
				'dependency_condition_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.at, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'dependency_condition_requirement_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bN, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'sortable_version',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gE, $author$project$Inventory$InputObject$encodeNumeric_comparison_exp_)),
				_Utils_Tuple2(
				'version',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aI, $author$project$Inventory$InputObject$encodeCitext_comparison_exp))
			]));
};
var $author$project$Inventory$InputObject$encodeDependency_requirement_bool_exp = function (_v16) {
	var input____ = _v16;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeDependency_requirement_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Inventory$InputObject$encodeDependency_requirement_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeDependency_requirement_bool_exp))),
				_Utils_Tuple2(
				'comparator',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.h, $author$project$Inventory$InputObject$encodeComparator_operator_comparison_exp)),
				_Utils_Tuple2(
				'dependency',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bs, $author$project$Inventory$InputObject$encodeDependency_bool_exp)),
				_Utils_Tuple2(
				'dependency_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.q, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'dependency_requirement_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bO, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'sortable_version',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gE, $author$project$Inventory$InputObject$encodeNumeric_comparison_exp_)),
				_Utils_Tuple2(
				'version',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aI, $author$project$Inventory$InputObject$encodeCitext_comparison_exp))
			]));
};
var $author$project$Inventory$InputObject$encodeDependency_to_requirement_bool_exp = function (_v15) {
	var input____ = _v15;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeDependency_to_requirement_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Inventory$InputObject$encodeDependency_to_requirement_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeDependency_to_requirement_bool_exp))),
				_Utils_Tuple2(
				'dependency',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bs, $author$project$Inventory$InputObject$encodeDependency_bool_exp)),
				_Utils_Tuple2(
				'dependency_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.q, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'requirement',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ci, $author$project$Inventory$InputObject$encodeRequirement_bool_exp)),
				_Utils_Tuple2(
				'requirement_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ba, $author$project$Inventory$InputObject$encodeUuid_comparison_exp))
			]));
};
var $author$project$Inventory$InputObject$encodeFeature_bool_exp = function (_v14) {
	var input____ = _v14;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeFeature_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Inventory$InputObject$encodeFeature_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeFeature_bool_exp))),
				_Utils_Tuple2(
				'feature',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d, $author$project$Inventory$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'feature_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.e, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'namespace',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aE, $author$project$Inventory$InputObject$encodeNamespace_bool_exp)),
				_Utils_Tuple2(
				'namespace_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.i, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'provided_by',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.m9, $author$project$Inventory$InputObject$encodeIngredient_version_revision_feature_bool_exp)),
				_Utils_Tuple2(
				'sortable_version',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gE, $author$project$Inventory$InputObject$encodeNumeric_comparison_exp_)),
				_Utils_Tuple2(
				'version',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aI, $author$project$Inventory$InputObject$encodeCitext_comparison_exp))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_annotation_bool_exp = function (_v13) {
	var input____ = _v13;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeIngredient_annotation_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Inventory$InputObject$encodeIngredient_annotation_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeIngredient_annotation_bool_exp))),
				_Utils_Tuple2(
				'creation_timestamp',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $author$project$Inventory$InputObject$encodeTimestamptz_comparison_exp)),
				_Utils_Tuple2(
				'ingredient',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cW, $author$project$Inventory$InputObject$encodeIngredient_bool_exp)),
				_Utils_Tuple2(
				'ingredient_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bT, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'key',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Y, $author$project$Inventory$InputObject$encodeCitext_comparison_exp)),
				_Utils_Tuple2(
				'value',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.kH, $author$project$Inventory$InputObject$encodeJsonb_comparison_exp))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_bool_exp = function (_v12) {
	var input____ = _v12;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeIngredient_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Inventory$InputObject$encodeIngredient_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeIngredient_bool_exp))),
				_Utils_Tuple2(
				'annotations',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dz, $author$project$Inventory$InputObject$encodeIngredient_annotation_bool_exp)),
				_Utils_Tuple2(
				'creation_timestamp',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $author$project$Inventory$InputObject$encodeTimestamptz_comparison_exp)),
				_Utils_Tuple2(
				'description',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bP, $author$project$Inventory$InputObject$encodeCitext_comparison_exp)),
				_Utils_Tuple2(
				'ingredient_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bT, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'name',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.w, $author$project$Inventory$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'namespace',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aE, $author$project$Inventory$InputObject$encodeNamespace_bool_exp)),
				_Utils_Tuple2(
				'normalized_name',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b7, $author$project$Inventory$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'primary_namespace_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.eE, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'versions',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.e$, $author$project$Inventory$InputObject$encodeIngredient_version_bool_exp)),
				_Utils_Tuple2(
				'website',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bk, $author$project$Inventory$InputObject$encodeCitext_comparison_exp))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_annotation_bool_exp = function (_v11) {
	var input____ = _v11;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeIngredient_version_annotation_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Inventory$InputObject$encodeIngredient_version_annotation_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeIngredient_version_annotation_bool_exp))),
				_Utils_Tuple2(
				'creation_timestamp',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $author$project$Inventory$InputObject$encodeTimestamptz_comparison_exp)),
				_Utils_Tuple2(
				'ingredient_version',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cZ, $author$project$Inventory$InputObject$encodeIngredient_version_bool_exp)),
				_Utils_Tuple2(
				'ingredient_version_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bY, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'key',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Y, $author$project$Inventory$InputObject$encodeCitext_comparison_exp)),
				_Utils_Tuple2(
				'value',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.kH, $author$project$Inventory$InputObject$encodeJsonb_comparison_exp))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_bool_exp = function (_v10) {
	var input____ = _v10;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeIngredient_version_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Inventory$InputObject$encodeIngredient_version_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeIngredient_version_bool_exp))),
				_Utils_Tuple2(
				'annotations',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dz, $author$project$Inventory$InputObject$encodeIngredient_version_annotation_bool_exp)),
				_Utils_Tuple2(
				'copyright_text',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bp, $author$project$Inventory$InputObject$encodeCitext_comparison_exp)),
				_Utils_Tuple2(
				'creation_timestamp',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $author$project$Inventory$InputObject$encodeTimestamptz_comparison_exp)),
				_Utils_Tuple2(
				'documentation_uri',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bu, $author$project$Inventory$InputObject$encodeCitext_comparison_exp)),
				_Utils_Tuple2(
				'ingredient',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cW, $author$project$Inventory$InputObject$encodeIngredient_bool_exp)),
				_Utils_Tuple2(
				'ingredient_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bT, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'ingredient_version_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bY, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'is_binary_only',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d4, $author$project$Inventory$InputObject$encodeBoolean_comparison_exp)),
				_Utils_Tuple2(
				'license_expression',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bx, $author$project$Inventory$InputObject$encodeCitext_comparison_exp)),
				_Utils_Tuple2(
				'release_timestamp',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ch, $author$project$Inventory$InputObject$encodeTimestamptz_comparison_exp)),
				_Utils_Tuple2(
				'revisions',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bc, $author$project$Inventory$InputObject$encodeIngredient_version_revision_bool_exp)),
				_Utils_Tuple2(
				'revisions_aggregate',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aO, $author$project$Inventory$InputObject$encodeIngredient_version_revision_aggregate_bool_exp)),
				_Utils_Tuple2(
				'sortable_version',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gE, $author$project$Inventory$InputObject$encodeNumeric_comparison_exp_)),
				_Utils_Tuple2(
				'source_uri',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cl, $author$project$Inventory$InputObject$encodeCitext_comparison_exp)),
				_Utils_Tuple2(
				'version',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aI, $author$project$Inventory$InputObject$encodeCitext_comparison_exp))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_aggregate_bool_exp = function (_v9) {
	var input____ = _v9;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'bool_and',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.kU, $author$project$Inventory$InputObject$encodeIngredient_version_revision_aggregate_bool_exp_bool_and)),
				_Utils_Tuple2(
				'bool_or',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.kV, $author$project$Inventory$InputObject$encodeIngredient_version_revision_aggregate_bool_exp_bool_or)),
				_Utils_Tuple2(
				'count',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cO, $author$project$Inventory$InputObject$encodeIngredient_version_revision_aggregate_bool_exp_count))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_aggregate_bool_exp_bool_and = function (_v8) {
	var input____ = _v8;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'arguments',
				$elm$core$Maybe$Just(
					A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Inventory$Enum$Ingredient_version_revision_select_column_ingredient_version_revision_aggregate_bool_exp_bool_and_arguments_columns$toString, input____.di))),
				_Utils_Tuple2(
				'distinct',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cR, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'filter',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cT, $author$project$Inventory$InputObject$encodeIngredient_version_revision_bool_exp)),
				_Utils_Tuple2(
				'predicate',
				$elm$core$Maybe$Just(
					$author$project$Inventory$InputObject$encodeBoolean_comparison_exp(input____.dq)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_aggregate_bool_exp_bool_or = function (_v7) {
	var input____ = _v7;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'arguments',
				$elm$core$Maybe$Just(
					A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$enum, $author$project$Inventory$Enum$Ingredient_version_revision_select_column_ingredient_version_revision_aggregate_bool_exp_bool_or_arguments_columns$toString, input____.di))),
				_Utils_Tuple2(
				'distinct',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cR, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'filter',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cT, $author$project$Inventory$InputObject$encodeIngredient_version_revision_bool_exp)),
				_Utils_Tuple2(
				'predicate',
				$elm$core$Maybe$Just(
					$author$project$Inventory$InputObject$encodeBoolean_comparison_exp(input____.dq)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_aggregate_bool_exp_count = function (_v6) {
	var input____ = _v6;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'arguments',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.di,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Ingredient_version_revision_select_column$toString)))),
				_Utils_Tuple2(
				'distinct',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cR, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'filter',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cT, $author$project$Inventory$InputObject$encodeIngredient_version_revision_bool_exp)),
				_Utils_Tuple2(
				'predicate',
				$elm$core$Maybe$Just(
					$author$project$Inventory$InputObject$encodeInt_comparison_exp(input____.dq)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_annotation_bool_exp = function (_v5) {
	var input____ = _v5;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeIngredient_version_revision_annotation_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Inventory$InputObject$encodeIngredient_version_revision_annotation_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeIngredient_version_revision_annotation_bool_exp))),
				_Utils_Tuple2(
				'creation_timestamp',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $author$project$Inventory$InputObject$encodeTimestamptz_comparison_exp)),
				_Utils_Tuple2(
				'ingredient_version_revision',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bw, $author$project$Inventory$InputObject$encodeIngredient_version_revision_bool_exp)),
				_Utils_Tuple2(
				'ingredient_version_revision_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b$, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'key',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.Y, $author$project$Inventory$InputObject$encodeCitext_comparison_exp)),
				_Utils_Tuple2(
				'value',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.kH, $author$project$Inventory$InputObject$encodeJsonb_comparison_exp))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_bool_exp = function (_v4) {
	var input____ = _v4;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeIngredient_version_revision_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Inventory$InputObject$encodeIngredient_version_revision_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeIngredient_version_revision_bool_exp))),
				_Utils_Tuple2(
				'activestate_license_expression',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bH, $author$project$Inventory$InputObject$encodeCitext_comparison_exp)),
				_Utils_Tuple2(
				'annotations',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dz, $author$project$Inventory$InputObject$encodeIngredient_version_revision_annotation_bool_exp)),
				_Utils_Tuple2(
				'author_platform_user_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'camel_extras',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dD, $author$project$Inventory$InputObject$encodeJsonb_comparison_exp)),
				_Utils_Tuple2(
				'comment',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c, $author$project$Inventory$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'creation_timestamp',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a, $author$project$Inventory$InputObject$encodeTimestamptz_comparison_exp)),
				_Utils_Tuple2(
				'dependencies',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.lt, $author$project$Inventory$InputObject$encodeDependency_bool_exp)),
				_Utils_Tuple2(
				'ingredient_version',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cZ, $author$project$Inventory$InputObject$encodeIngredient_version_bool_exp)),
				_Utils_Tuple2(
				'ingredient_version_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bY, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'ingredient_version_revision_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b$, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'is_indemnified',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d8, $author$project$Inventory$InputObject$encodeBoolean_comparison_exp)),
				_Utils_Tuple2(
				'is_stable_release',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.el, $author$project$Inventory$InputObject$encodeBoolean_comparison_exp)),
				_Utils_Tuple2(
				'license_manifest_uri',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b3, $author$project$Inventory$InputObject$encodeCitext_comparison_exp)),
				_Utils_Tuple2(
				'option_sets',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mR, $author$project$Inventory$InputObject$encodeIngredient_version_revision_ingredient_option_set_bool_exp)),
				_Utils_Tuple2(
				'patches',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.m_, $author$project$Inventory$InputObject$encodeIngredient_version_revision_patch_bool_exp)),
				_Utils_Tuple2(
				'platform_source_uri',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cb, $author$project$Inventory$InputObject$encodeCitext_comparison_exp)),
				_Utils_Tuple2(
				'provided_features',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.nb, $author$project$Inventory$InputObject$encodeIngredient_version_revision_feature_bool_exp)),
				_Utils_Tuple2(
				'reason',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cg, $author$project$Inventory$InputObject$encodeIngredient_version_revision_reason_comparison_exp)),
				_Utils_Tuple2(
				'resources',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.nk, $author$project$Inventory$InputObject$encodeIngredient_version_revision_resource_bool_exp)),
				_Utils_Tuple2(
				'revision',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ac, $author$project$Inventory$InputObject$encodeInt_comparison_exp)),
				_Utils_Tuple2(
				'scanner_license_expression',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cj, $author$project$Inventory$InputObject$encodeCitext_comparison_exp)),
				_Utils_Tuple2(
				'source_checksum',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.be, $author$project$Inventory$InputObject$encodeCitext_comparison_exp)),
				_Utils_Tuple2(
				'status',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.L, $author$project$Inventory$InputObject$encodeRevision_status_comparison_exp))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_feature_bool_exp = function (_v3) {
	var input____ = _v3;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeIngredient_version_revision_feature_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Inventory$InputObject$encodeIngredient_version_revision_feature_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeIngredient_version_revision_feature_bool_exp))),
				_Utils_Tuple2(
				'feature',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d, $author$project$Inventory$InputObject$encodeFeature_bool_exp)),
				_Utils_Tuple2(
				'feature_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.e, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'ingredient_version_revision_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b$, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'revision',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ac, $author$project$Inventory$InputObject$encodeIngredient_version_revision_bool_exp))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_resource_bool_exp = function (_v2) {
	var input____ = _v2;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeIngredient_version_revision_resource_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Inventory$InputObject$encodeIngredient_version_revision_resource_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeIngredient_version_revision_resource_bool_exp))),
				_Utils_Tuple2(
				'ingredient_version_revision',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bw, $author$project$Inventory$InputObject$encodeIngredient_version_revision_bool_exp)),
				_Utils_Tuple2(
				'ingredient_version_revision_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b$, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'resource',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gB, $author$project$Inventory$InputObject$encodeResource_bool_exp)),
				_Utils_Tuple2(
				'resource_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bb, $author$project$Inventory$InputObject$encodeUuid_comparison_exp))
			]));
};
var $author$project$Inventory$InputObject$encodeRequirement_bool_exp = function (_v1) {
	var input____ = _v1;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeRequirement_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Inventory$InputObject$encodeRequirement_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeRequirement_bool_exp))),
				_Utils_Tuple2(
				'comparator',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.h, $author$project$Inventory$InputObject$encodeComparator_operator_comparison_exp)),
				_Utils_Tuple2(
				'requirement_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ba, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'requirements',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.FF, $author$project$Inventory$InputObject$encodeDependency_to_requirement_bool_exp)),
				_Utils_Tuple2(
				'sortable_version',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gE, $author$project$Inventory$InputObject$encodeNumeric_comparison_exp_)),
				_Utils_Tuple2(
				'version',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aI, $author$project$Inventory$InputObject$encodeCitext_comparison_exp))
			]));
};
var $author$project$Inventory$InputObject$encodeResource_bool_exp = function (_v0) {
	var input____ = _v0;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeResource_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Inventory$InputObject$encodeResource_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeResource_bool_exp))),
				_Utils_Tuple2(
				'checksum',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dE, $author$project$Inventory$InputObject$encodeCitext_comparison_exp)),
				_Utils_Tuple2(
				'downloaded',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dU, $author$project$Inventory$InputObject$encodeBoolean_comparison_exp)),
				_Utils_Tuple2(
				'ingredient_version_revision_resources',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.me, $author$project$Inventory$InputObject$encodeIngredient_version_revision_resource_bool_exp)),
				_Utils_Tuple2(
				'platform_uri',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ez, $author$project$Inventory$InputObject$encodeCitext_comparison_exp)),
				_Utils_Tuple2(
				'resource_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bb, $author$project$Inventory$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'size_bytes',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.eL, $author$project$Inventory$InputObject$encodeBigint_comparison_exp)),
				_Utils_Tuple2(
				'type',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gR, $author$project$Inventory$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'uri',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.eW, $author$project$Inventory$InputObject$encodeCitext_comparison_exp)),
				_Utils_Tuple2(
				'variant',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.eX, $author$project$Inventory$InputObject$encodeString_comparison_exp))
			]));
};
var $author$project$Inventory$Enum$Order_by$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'asc';
		case 1:
			return 'asc_nulls_first';
		case 2:
			return 'asc_nulls_last';
		case 3:
			return 'desc';
		case 4:
			return 'desc_nulls_first';
		default:
			return 'desc_nulls_last';
	}
};
var $author$project$Inventory$InputObject$encodeDependency_max_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'dependency_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.q,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'description',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bP,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'feature',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.d,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_version_revision_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b$,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'namespace_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.i,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'original_requirement',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b9,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'type',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.gR,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeDependency_min_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'dependency_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.q,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'description',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bP,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'feature',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.d,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_version_revision_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b$,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'namespace_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.i,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'original_requirement',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b9,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'type',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.gR,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeDependency_aggregate_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'count',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cO,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'max',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c1, $author$project$Inventory$InputObject$encodeDependency_max_order_by)),
				_Utils_Tuple2(
				'min',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c2, $author$project$Inventory$InputObject$encodeDependency_min_order_by))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_annotation_max_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'creation_timestamp',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bT,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'key',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.Y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_annotation_min_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'creation_timestamp',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bT,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'key',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.Y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_annotation_aggregate_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'count',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cO,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'max',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c1, $author$project$Inventory$InputObject$encodeIngredient_annotation_max_order_by)),
				_Utils_Tuple2(
				'min',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c2, $author$project$Inventory$InputObject$encodeIngredient_annotation_min_order_by))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_max_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'copyright_text',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bp,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'creation_timestamp',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'documentation_uri',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bu,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bT,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_version_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bY,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'license_expression',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bx,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'release_timestamp',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ch,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'source_uri',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cl,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'version',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aI,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_min_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'copyright_text',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bp,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'creation_timestamp',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'documentation_uri',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bu,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bT,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_version_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bY,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'license_expression',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bx,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'release_timestamp',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ch,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'source_uri',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cl,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'version',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aI,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_aggregate_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'count',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cO,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'max',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c1, $author$project$Inventory$InputObject$encodeIngredient_version_max_order_by)),
				_Utils_Tuple2(
				'min',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c2, $author$project$Inventory$InputObject$encodeIngredient_version_min_order_by))
			]));
};
var $author$project$Inventory$InputObject$encodeNamespace_type_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'description',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bP,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'name',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.w,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'namespace_type_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.by,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'requires_language',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.eG,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeNamespace_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'for_language',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.dX,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'is_public',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ek,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'name_normalization_algorithm',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ev,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'namespace',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'namespace_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.i,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'namespace_type_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.by,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'owner_platform_organization_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ex,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'type',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gR, $author$project$Inventory$InputObject$encodeNamespace_type_order_by)),
				_Utils_Tuple2(
				'version_parsing_algorithm',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.e_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'annotations_aggregate',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dA, $author$project$Inventory$InputObject$encodeIngredient_annotation_aggregate_order_by)),
				_Utils_Tuple2(
				'creation_timestamp',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'description',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bP,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bT,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'name',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.w,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'namespace',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aE, $author$project$Inventory$InputObject$encodeNamespace_order_by)),
				_Utils_Tuple2(
				'normalized_name',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b7,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'primary_namespace_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.eE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'versions_aggregate',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.e0, $author$project$Inventory$InputObject$encodeIngredient_version_aggregate_order_by)),
				_Utils_Tuple2(
				'website',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bk,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_annotation_max_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'creation_timestamp',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_version_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bY,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'key',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.Y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_annotation_min_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'creation_timestamp',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_version_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bY,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'key',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.Y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_annotation_aggregate_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'count',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cO,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'max',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c1, $author$project$Inventory$InputObject$encodeIngredient_version_annotation_max_order_by)),
				_Utils_Tuple2(
				'min',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c2, $author$project$Inventory$InputObject$encodeIngredient_version_annotation_min_order_by))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_avg_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'revision',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ac,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_max_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'activestate_license_expression',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bH,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'author_platform_user_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'comment',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.c,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'creation_timestamp',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_version_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bY,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_version_revision_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b$,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'license_manifest_uri',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b3,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'platform_source_uri',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cb,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'reason',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cg,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'revision',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ac,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'scanner_license_expression',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cj,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'source_checksum',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.be,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'status',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.L,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_min_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'activestate_license_expression',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bH,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'author_platform_user_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'comment',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.c,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'creation_timestamp',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_version_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bY,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_version_revision_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b$,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'license_manifest_uri',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b3,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'platform_source_uri',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cb,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'reason',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cg,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'revision',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ac,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'scanner_license_expression',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cj,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'source_checksum',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.be,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'status',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.L,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_stddev_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'revision',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ac,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_stddev_pop_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'revision',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ac,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_stddev_samp_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'revision',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ac,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_sum_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'revision',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ac,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_var_pop_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'revision',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ac,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_var_samp_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'revision',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ac,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_variance_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'revision',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ac,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_aggregate_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'avg',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.fX, $author$project$Inventory$InputObject$encodeIngredient_version_revision_avg_order_by)),
				_Utils_Tuple2(
				'count',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cO,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'max',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c1, $author$project$Inventory$InputObject$encodeIngredient_version_revision_max_order_by)),
				_Utils_Tuple2(
				'min',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c2, $author$project$Inventory$InputObject$encodeIngredient_version_revision_min_order_by)),
				_Utils_Tuple2(
				'stddev',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gL, $author$project$Inventory$InputObject$encodeIngredient_version_revision_stddev_order_by)),
				_Utils_Tuple2(
				'stddev_pop',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gM, $author$project$Inventory$InputObject$encodeIngredient_version_revision_stddev_pop_order_by)),
				_Utils_Tuple2(
				'stddev_samp',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gN, $author$project$Inventory$InputObject$encodeIngredient_version_revision_stddev_samp_order_by)),
				_Utils_Tuple2(
				'sum',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gO, $author$project$Inventory$InputObject$encodeIngredient_version_revision_sum_order_by)),
				_Utils_Tuple2(
				'var_pop',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gT, $author$project$Inventory$InputObject$encodeIngredient_version_revision_var_pop_order_by)),
				_Utils_Tuple2(
				'var_samp',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gU, $author$project$Inventory$InputObject$encodeIngredient_version_revision_var_samp_order_by)),
				_Utils_Tuple2(
				'variance',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gV, $author$project$Inventory$InputObject$encodeIngredient_version_revision_variance_order_by))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'annotations_aggregate',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dA, $author$project$Inventory$InputObject$encodeIngredient_version_annotation_aggregate_order_by)),
				_Utils_Tuple2(
				'copyright_text',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bp,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'creation_timestamp',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'documentation_uri',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bu,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cW, $author$project$Inventory$InputObject$encodeIngredient_order_by)),
				_Utils_Tuple2(
				'ingredient_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bT,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_version_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bY,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'is_binary_only',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.d4,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'license_expression',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bx,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'release_timestamp',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ch,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'revisions_aggregate',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aO, $author$project$Inventory$InputObject$encodeIngredient_version_revision_aggregate_order_by)),
				_Utils_Tuple2(
				'sortable_version',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.gE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'source_uri',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cl,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'version',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aI,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_annotation_max_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'creation_timestamp',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_version_revision_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b$,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'key',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.Y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_annotation_min_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'creation_timestamp',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_version_revision_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b$,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'key',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.Y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_annotation_aggregate_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'count',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cO,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'max',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c1, $author$project$Inventory$InputObject$encodeIngredient_version_revision_annotation_max_order_by)),
				_Utils_Tuple2(
				'min',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c2, $author$project$Inventory$InputObject$encodeIngredient_version_revision_annotation_min_order_by))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_feature_max_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'feature_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.e,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_version_revision_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b$,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_feature_min_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'feature_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.e,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_version_revision_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b$,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_feature_aggregate_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'count',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cO,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'max',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c1, $author$project$Inventory$InputObject$encodeIngredient_version_revision_feature_max_order_by)),
				_Utils_Tuple2(
				'min',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c2, $author$project$Inventory$InputObject$encodeIngredient_version_revision_feature_min_order_by))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_ingredient_option_set_avg_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'sequence_number',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.f,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_ingredient_option_set_max_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'ingredient_option_set_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.W,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_version_revision_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b$,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'sequence_number',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.f,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'usage_type',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cu,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_ingredient_option_set_min_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'ingredient_option_set_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.W,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_version_revision_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b$,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'sequence_number',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.f,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'usage_type',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cu,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_ingredient_option_set_stddev_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'sequence_number',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.f,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_ingredient_option_set_stddev_pop_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'sequence_number',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.f,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_ingredient_option_set_stddev_samp_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'sequence_number',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.f,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_ingredient_option_set_sum_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'sequence_number',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.f,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_ingredient_option_set_var_pop_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'sequence_number',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.f,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_ingredient_option_set_var_samp_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'sequence_number',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.f,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_ingredient_option_set_variance_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'sequence_number',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.f,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_ingredient_option_set_aggregate_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'avg',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.fX, $author$project$Inventory$InputObject$encodeIngredient_version_revision_ingredient_option_set_avg_order_by)),
				_Utils_Tuple2(
				'count',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cO,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'max',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c1, $author$project$Inventory$InputObject$encodeIngredient_version_revision_ingredient_option_set_max_order_by)),
				_Utils_Tuple2(
				'min',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c2, $author$project$Inventory$InputObject$encodeIngredient_version_revision_ingredient_option_set_min_order_by)),
				_Utils_Tuple2(
				'stddev',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gL, $author$project$Inventory$InputObject$encodeIngredient_version_revision_ingredient_option_set_stddev_order_by)),
				_Utils_Tuple2(
				'stddev_pop',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gM, $author$project$Inventory$InputObject$encodeIngredient_version_revision_ingredient_option_set_stddev_pop_order_by)),
				_Utils_Tuple2(
				'stddev_samp',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gN, $author$project$Inventory$InputObject$encodeIngredient_version_revision_ingredient_option_set_stddev_samp_order_by)),
				_Utils_Tuple2(
				'sum',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gO, $author$project$Inventory$InputObject$encodeIngredient_version_revision_ingredient_option_set_sum_order_by)),
				_Utils_Tuple2(
				'var_pop',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gT, $author$project$Inventory$InputObject$encodeIngredient_version_revision_ingredient_option_set_var_pop_order_by)),
				_Utils_Tuple2(
				'var_samp',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gU, $author$project$Inventory$InputObject$encodeIngredient_version_revision_ingredient_option_set_var_samp_order_by)),
				_Utils_Tuple2(
				'variance',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gV, $author$project$Inventory$InputObject$encodeIngredient_version_revision_ingredient_option_set_variance_order_by))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_patch_avg_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'sequence_number',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.f,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_patch_max_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'ingredient_version_revision_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b$,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'patch_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ab,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'sequence_number',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.f,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_patch_min_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'ingredient_version_revision_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b$,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'patch_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ab,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'sequence_number',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.f,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_patch_stddev_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'sequence_number',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.f,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_patch_stddev_pop_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'sequence_number',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.f,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_patch_stddev_samp_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'sequence_number',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.f,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_patch_sum_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'sequence_number',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.f,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_patch_var_pop_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'sequence_number',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.f,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_patch_var_samp_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'sequence_number',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.f,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_patch_variance_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'sequence_number',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.f,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_patch_aggregate_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'avg',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.fX, $author$project$Inventory$InputObject$encodeIngredient_version_revision_patch_avg_order_by)),
				_Utils_Tuple2(
				'count',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cO,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'max',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c1, $author$project$Inventory$InputObject$encodeIngredient_version_revision_patch_max_order_by)),
				_Utils_Tuple2(
				'min',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c2, $author$project$Inventory$InputObject$encodeIngredient_version_revision_patch_min_order_by)),
				_Utils_Tuple2(
				'stddev',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gL, $author$project$Inventory$InputObject$encodeIngredient_version_revision_patch_stddev_order_by)),
				_Utils_Tuple2(
				'stddev_pop',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gM, $author$project$Inventory$InputObject$encodeIngredient_version_revision_patch_stddev_pop_order_by)),
				_Utils_Tuple2(
				'stddev_samp',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gN, $author$project$Inventory$InputObject$encodeIngredient_version_revision_patch_stddev_samp_order_by)),
				_Utils_Tuple2(
				'sum',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gO, $author$project$Inventory$InputObject$encodeIngredient_version_revision_patch_sum_order_by)),
				_Utils_Tuple2(
				'var_pop',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gT, $author$project$Inventory$InputObject$encodeIngredient_version_revision_patch_var_pop_order_by)),
				_Utils_Tuple2(
				'var_samp',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gU, $author$project$Inventory$InputObject$encodeIngredient_version_revision_patch_var_samp_order_by)),
				_Utils_Tuple2(
				'variance',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gV, $author$project$Inventory$InputObject$encodeIngredient_version_revision_patch_variance_order_by))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_resource_max_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'ingredient_version_revision_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b$,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'resource_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bb,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_resource_min_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'ingredient_version_revision_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b$,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'resource_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bb,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_resource_aggregate_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'count',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cO,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'max',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c1, $author$project$Inventory$InputObject$encodeIngredient_version_revision_resource_max_order_by)),
				_Utils_Tuple2(
				'min',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c2, $author$project$Inventory$InputObject$encodeIngredient_version_revision_resource_min_order_by))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'activestate_license_expression',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bH,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'annotations_aggregate',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dA, $author$project$Inventory$InputObject$encodeIngredient_version_revision_annotation_aggregate_order_by)),
				_Utils_Tuple2(
				'author_platform_user_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'camel_extras',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.dD,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'comment',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.c,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'creation_timestamp',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'dependencies_aggregate',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.lu, $author$project$Inventory$InputObject$encodeDependency_aggregate_order_by)),
				_Utils_Tuple2(
				'ingredient_version',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cZ, $author$project$Inventory$InputObject$encodeIngredient_version_order_by)),
				_Utils_Tuple2(
				'ingredient_version_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bY,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_version_revision_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b$,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'is_indemnified',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.d8,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'is_stable_release',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.el,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'license_manifest_uri',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b3,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'option_sets_aggregate',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mS, $author$project$Inventory$InputObject$encodeIngredient_version_revision_ingredient_option_set_aggregate_order_by)),
				_Utils_Tuple2(
				'patches_aggregate',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.m$, $author$project$Inventory$InputObject$encodeIngredient_version_revision_patch_aggregate_order_by)),
				_Utils_Tuple2(
				'platform_source_uri',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cb,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'provided_features_aggregate',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.nc, $author$project$Inventory$InputObject$encodeIngredient_version_revision_feature_aggregate_order_by)),
				_Utils_Tuple2(
				'reason',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cg,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'resources_aggregate',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.nl, $author$project$Inventory$InputObject$encodeIngredient_version_revision_resource_aggregate_order_by)),
				_Utils_Tuple2(
				'revision',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ac,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'scanner_license_expression',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cj,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'source_checksum',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.be,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'status',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.L,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$Object$Ingredient_version$revisions = F2(
	function (fillInOptionals____, object____) {
		var filledInOptionals____ = fillInOptionals____(
			{tE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ux: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, uR: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, vE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ao: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs____ = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'distinct_on',
					filledInOptionals____.tE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Ingredient_version_revision_select_column$toString))),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'limit', filledInOptionals____.ux, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'offset', filledInOptionals____.uR, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'order_by',
					filledInOptionals____.vE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeIngredient_version_revision_order_by)),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'where', filledInOptionals____.ao, $author$project$Inventory$InputObject$encodeIngredient_version_revision_bool_exp)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'revisions',
			optionalArgs____,
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
	});
var $author$project$Inventory$Enum$Order_by$Desc = 3;
var $author$project$Inventory$InputObject$Ingredient_version_revision_bool_exp = $elm$core$Basics$identity;
var $author$project$Inventory$InputObject$buildIngredient_version_revision_bool_exp = function (fillOptionals____) {
	var optionals____ = fillOptionals____(
		{bH: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, y: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, dz: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, b: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, dD: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, c: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, lt: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, cZ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, bY: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, b$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, d8: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, el: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, b3: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, B: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, mR: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, D: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, m_: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, cb: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, nb: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, cg: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, nk: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ac: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, cj: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, be: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, L: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
	return {bH: optionals____.bH, y: optionals____.y, dz: optionals____.dz, b: optionals____.b, dD: optionals____.dD, c: optionals____.c, a: optionals____.a, lt: optionals____.lt, cZ: optionals____.cZ, bY: optionals____.bY, b$: optionals____.b$, d8: optionals____.d8, el: optionals____.el, b3: optionals____.b3, B: optionals____.B, mR: optionals____.mR, D: optionals____.D, m_: optionals____.m_, cb: optionals____.cb, nb: optionals____.nb, cg: optionals____.cg, nk: optionals____.nk, ac: optionals____.ac, cj: optionals____.cj, be: optionals____.be, L: optionals____.L};
};
var $author$project$Inventory$InputObject$buildIngredient_version_revision_order_by = function (fillOptionals____) {
	var optionals____ = fillOptionals____(
		{bH: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, dA: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, b: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, dD: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, c: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, lu: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, cZ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, bY: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, b$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, d8: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, el: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, b3: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, mS: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, m$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, cb: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, nc: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, cg: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, nl: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ac: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, cj: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, be: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, L: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
	return {bH: optionals____.bH, dA: optionals____.dA, b: optionals____.b, dD: optionals____.dD, c: optionals____.c, a: optionals____.a, lu: optionals____.lu, cZ: optionals____.cZ, bY: optionals____.bY, b$: optionals____.b$, d8: optionals____.d8, el: optionals____.el, b3: optionals____.b3, mS: optionals____.mS, m$: optionals____.m$, cb: optionals____.cb, nc: optionals____.nc, cg: optionals____.cg, nl: optionals____.nl, ac: optionals____.ac, cj: optionals____.cj, be: optionals____.be, L: optionals____.L};
};
var $author$project$Inventory$InputObject$buildRevision_status_comparison_exp = function (fillOptionals____) {
	var optionals____ = fillOptionals____(
		{aW: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aY: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aZ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a_: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a0: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a4: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a5: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
	return {aW: optionals____.aW, aY: optionals____.aY, aZ: optionals____.aZ, a_: optionals____.a_, a$: optionals____.a$, a0: optionals____.a0, a1: optionals____.a1, a4: optionals____.a4, a5: optionals____.a5};
};
var $author$project$Inventory$InputObject$buildTimestamptz_comparison_exp = function (fillOptionals____) {
	var optionals____ = fillOptionals____(
		{aW: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aY: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aZ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a_: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a0: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a4: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a5: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
	return {aW: optionals____.aW, aY: optionals____.aY, aZ: optionals____.aZ, a_: optionals____.a_, a$: optionals____.a$, a0: optionals____.a0, a1: optionals____.a1, a4: optionals____.a4, a5: optionals____.a5};
};
var $author$project$Request$AvailableVersions$creationTimestampAndStatus = F2(
	function (atTime, args) {
		var atTimeStr = $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(atTime);
		return _Utils_update(
			args,
			{
				a: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					$author$project$Inventory$InputObject$buildTimestamptz_comparison_exp(
						function (args_) {
							return _Utils_update(
								args_,
								{
									a1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(atTimeStr)
								});
						})),
				L: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					$author$project$Inventory$InputObject$buildRevision_status_comparison_exp(
						function (args_) {
							return _Utils_update(
								args_,
								{
									a4: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Model$RevisionStatus$Unstable)
								});
						}))
			});
	});
var $author$project$Request$AvailableVersions$revisionsWhereAndOrderBy = F2(
	function (atTime, args) {
		return _Utils_update(
			args,
			{
				ux: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(1),
				vE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					_List_fromArray(
						[
							$author$project$Inventory$InputObject$buildIngredient_version_revision_order_by(
							function (args_) {
								return _Utils_update(
									args_,
									{
										ac: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(3)
									});
							})
						])),
				ao: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					$author$project$Inventory$InputObject$buildIngredient_version_revision_bool_exp(
						$author$project$Request$AvailableVersions$creationTimestampAndStatus(atTime)))
			});
	});
var $author$project$Inventory$Object$Ingredient_version$version = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'InventoryScalarCodecs.Citext',
	'version',
	_List_Nil,
	$author$project$Inventory$Scalar$unwrapCodecs($author$project$InventoryScalarCodecs$codecs).cL.qN);
var $author$project$Request$AvailableVersions$ingredientVersionSelectionSet = function (atTime) {
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2(
			$author$project$Inventory$Object$Ingredient_version$revisions,
			$author$project$Request$AvailableVersions$revisionsWhereAndOrderBy(atTime),
			$author$project$Request$AvailableVersions$revisionSelectionSet),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Inventory$Object$Ingredient_version$version,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Request$AvailableVersions$VersionAndRevisions)));
};
var $author$project$Inventory$InputObject$Ingredient_version_bool_exp = $elm$core$Basics$identity;
var $author$project$Inventory$InputObject$buildIngredient_version_bool_exp = function (fillOptionals____) {
	var optionals____ = fillOptionals____(
		{y: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, dz: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, bp: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, bu: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, cW: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, bT: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, bY: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, d4: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, bx: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, B: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, D: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ch: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, bc: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aO: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, gE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, cl: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aI: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
	return {y: optionals____.y, dz: optionals____.dz, bp: optionals____.bp, a: optionals____.a, bu: optionals____.bu, cW: optionals____.cW, bT: optionals____.bT, bY: optionals____.bY, d4: optionals____.d4, bx: optionals____.bx, B: optionals____.B, D: optionals____.D, ch: optionals____.ch, bc: optionals____.bc, aO: optionals____.aO, gE: optionals____.gE, cl: optionals____.cl, aI: optionals____.aI};
};
var $author$project$Inventory$InputObject$buildIngredient_version_order_by = function (fillOptionals____) {
	var optionals____ = fillOptionals____(
		{dA: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, bp: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, bu: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, cW: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, bT: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, bY: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, d4: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, bx: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ch: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aO: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, gE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, cl: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aI: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
	return {dA: optionals____.dA, bp: optionals____.bp, a: optionals____.a, bu: optionals____.bu, cW: optionals____.cW, bT: optionals____.bT, bY: optionals____.bY, d4: optionals____.d4, bx: optionals____.bx, ch: optionals____.ch, aO: optionals____.aO, gE: optionals____.gE, cl: optionals____.cl, aI: optionals____.aI};
};
var $author$project$Inventory$InputObject$Ingredient_bool_exp = $elm$core$Basics$identity;
var $author$project$Inventory$InputObject$buildIngredient_bool_exp = function (fillOptionals____) {
	var optionals____ = fillOptionals____(
		{y: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, dz: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, bP: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, bT: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, w: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, b7: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, B: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, D: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, eE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, e$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, bk: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
	return {y: optionals____.y, dz: optionals____.dz, a: optionals____.a, bP: optionals____.bP, bT: optionals____.bT, w: optionals____.w, aE: optionals____.aE, b7: optionals____.b7, B: optionals____.B, D: optionals____.D, eE: optionals____.eE, e$: optionals____.e$, bk: optionals____.bk};
};
var $author$project$Inventory$InputObject$Namespace_bool_exp = $elm$core$Basics$identity;
var $author$project$Inventory$InputObject$buildNamespace_bool_exp = function (fillOptionals____) {
	var optionals____ = fillOptionals____(
		{y: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, dX: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ek: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ev: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, i: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, by: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, B: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, D: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ex: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, gR: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, e_: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
	return {y: optionals____.y, dX: optionals____.dX, ek: optionals____.ek, ev: optionals____.ev, aE: optionals____.aE, i: optionals____.i, by: optionals____.by, B: optionals____.B, D: optionals____.D, ex: optionals____.ex, gR: optionals____.gR, e_: optionals____.e_};
};
var $author$project$Inventory$InputObject$buildString_comparison_exp = function (fillOptionals____) {
	var optionals____ = fillOptionals____(
		{aW: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aY: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aZ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, l7: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a_: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, mj: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, mt: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a0: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a4: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, mI: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a5: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, mJ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, mK: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, mO: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, mP: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, nd: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, nv: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
	return {aW: optionals____.aW, aY: optionals____.aY, aZ: optionals____.aZ, l7: optionals____.l7, a_: optionals____.a_, mj: optionals____.mj, a$: optionals____.a$, mt: optionals____.mt, a0: optionals____.a0, a1: optionals____.a1, a4: optionals____.a4, mI: optionals____.mI, a5: optionals____.a5, mJ: optionals____.mJ, mK: optionals____.mK, mO: optionals____.mO, mP: optionals____.mP, nd: optionals____.nd, nv: optionals____.nv};
};
var $author$project$Inventory$InputObject$buildCitext_comparison_exp = function (fillOptionals____) {
	var optionals____ = fillOptionals____(
		{aW: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aY: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aZ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, l7: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a_: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, mj: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, mt: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a0: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a4: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, mI: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a5: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, mJ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, mK: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, mO: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, mP: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, nd: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, nv: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
	return {aW: optionals____.aW, aY: optionals____.aY, aZ: optionals____.aZ, l7: optionals____.l7, a_: optionals____.a_, mj: optionals____.mj, a$: optionals____.a$, mt: optionals____.mt, a0: optionals____.a0, a1: optionals____.a1, a4: optionals____.a4, mI: optionals____.mI, a5: optionals____.a5, mJ: optionals____.mJ, mK: optionals____.mK, mO: optionals____.mO, mP: optionals____.mP, nd: optionals____.nd, nv: optionals____.nv};
};
var $author$project$Request$AvailableVersions$setNamespaceEq = F2(
	function (namespace, args) {
		return _Utils_update(
			args,
			{
				aE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					$author$project$Inventory$InputObject$buildCitext_comparison_exp(
						function (args_) {
							return _Utils_update(
								args_,
								{
									aW: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(namespace)
								});
						}))
			});
	});
var $author$project$Request$AvailableVersions$namespaceAndNormalizedName = F2(
	function (key, args) {
		var namespace = $author$project$Model$Namespace$getNamespace(key);
		var name = $author$project$Model$Namespace$getName(key);
		return _Utils_update(
			args,
			{
				aE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					$author$project$Inventory$InputObject$buildNamespace_bool_exp(
						$author$project$Request$AvailableVersions$setNamespaceEq(namespace))),
				b7: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					$author$project$Inventory$InputObject$buildString_comparison_exp(
						function (args_) {
							return _Utils_update(
								args_,
								{
									aW: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(name)
								});
						}))
			});
	});
var $author$project$Request$AvailableVersions$ingredientWhereAndOrderBy = F2(
	function (key, args) {
		return _Utils_update(
			args,
			{
				cW: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					$author$project$Inventory$InputObject$buildIngredient_bool_exp(
						$author$project$Request$AvailableVersions$namespaceAndNormalizedName(key)))
			});
	});
var $author$project$Request$AvailableVersions$ingredientVersionWhereAndOrderBy = F2(
	function (key, args) {
		return _Utils_update(
			args,
			{
				vE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					_List_fromArray(
						[
							$author$project$Inventory$InputObject$buildIngredient_version_order_by(
							function (args_) {
								return _Utils_update(
									args_,
									{
										gE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(3)
									});
							})
						])),
				ao: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					$author$project$Inventory$InputObject$buildIngredient_version_bool_exp(
						$author$project$Request$AvailableVersions$ingredientWhereAndOrderBy(key)))
			});
	});
var $author$project$Inventory$Enum$Ingredient_version_select_column$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'copyright_text';
		case 1:
			return 'creation_timestamp';
		case 2:
			return 'documentation_uri';
		case 3:
			return 'ingredient_id';
		case 4:
			return 'ingredient_version_id';
		case 5:
			return 'is_binary_only';
		case 6:
			return 'license_expression';
		case 7:
			return 'release_timestamp';
		case 8:
			return 'sortable_version';
		case 9:
			return 'source_uri';
		default:
			return 'version';
	}
};
var $author$project$Inventory$Query$ingredient_version = F2(
	function (fillInOptionals____, object____) {
		var filledInOptionals____ = fillInOptionals____(
			{tE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ux: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, uR: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, vE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ao: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs____ = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'distinct_on',
					filledInOptionals____.tE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Ingredient_version_select_column$toString))),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'limit', filledInOptionals____.ux, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'offset', filledInOptionals____.uR, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'order_by',
					filledInOptionals____.vE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeIngredient_version_order_by)),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'where', filledInOptionals____.ao, $author$project$Inventory$InputObject$encodeIngredient_version_bool_exp)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'ingredient_version',
			optionalArgs____,
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
	});
var $author$project$Model$Vulnerability$fromNamespaceKey = F2(
	function (namespaceKey, versionStr) {
		return {
			w: $author$project$Model$Namespace$getName(namespaceKey),
			aE: $author$project$Model$Namespace$getNamespace(namespaceKey),
			aI: versionStr
		};
	});
var $author$project$Request$AvailableVersions$toAvailableVersion = F2(
	function (key, input) {
		return A2(
			$elm$core$Maybe$andThen,
			function (revision) {
				return _Utils_eq(revision.L, $author$project$Model$RevisionStatus$Deleted) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					{
						dE: revision.dE,
						Dm: revision.Dm,
						G7: A2($author$project$Model$Vulnerability$fromNamespaceKey, key, input.aI)
					});
			},
			$elm$core$List$head(input.bc));
	});
var $author$project$Request$AvailableVersions$getAvailableVersionsForList = F3(
	function (creds, atTime, keys) {
		var toPair = function (key) {
			return A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
				$elm$core$Tuple$pair(key),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					$elm$core$List$filterMap(
						$author$project$Request$AvailableVersions$toAvailableVersion(key)),
					A2(
						$author$project$Inventory$Query$ingredient_version,
						$author$project$Request$AvailableVersions$ingredientVersionWhereAndOrderBy(key),
						$author$project$Request$AvailableVersions$ingredientVersionSelectionSet(atTime))));
		};
		var combine = function (_v0) {
			var key = _v0.a;
			var value = _v0.b;
			return A2($elm$core$Dict$insert, key, value);
		};
		return A5(
			$author$project$GraphQL$Utils$queryRequest,
			creds,
			1,
			_List_Nil,
			'GetIngredientVersions',
			A3(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$foldl,
				combine,
				$elm$core$Dict$empty,
				A2($elm$core$List$map, toPair, keys)));
	});
var $author$project$Request$BuildPlanner$getBuildExpr = F2(
	function (session, key) {
		return $author$project$Model$BuildPlanner$BuildPlannerError$simplifyTask(
			A2(
				$elm$core$Task$map,
				$elm$core$Result$Ok,
				A2(
					$author$project$Request$BuildPlanner$getByCommit,
					session,
					{
						Y: key,
						ke: $elm$core$Maybe$Nothing,
						kf: $elm$core$Maybe$Just($elm$core$Tuple$second),
						ki: $author$project$Model$BuildPlanner$BuildExpr$selectionSet,
						kj: 'GetBuildExpr'
					})));
	});
var $author$project$Request$BuildPlanner$HttpError = function (a) {
	return {$: 0, a: a};
};
var $author$project$Request$BuildPlanner$ImpactReportError = function (a) {
	return {$: 1, a: a};
};
var $author$project$BuildPlanner$InputObject$buildBuildExprOrCommitInput = function (fillOptionals____) {
	var optionals____ = fillOptionals____(
		{jE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, k$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, fk: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, nL: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
	return {jE: optionals____.jE, k$: optionals____.k$, fk: optionals____.fk, nL: optionals____.nL};
};
var $author$project$BuildPlanner$Union$ImpactReportResult$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ImpactReport', selections____.vg),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ImpactReportError', selections____.vh)
			]));
};
var $author$project$BuildPlanner$InputObject$encodeBuildExprOrCommitInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'buildExpr',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.k$,
					A2(
						$author$project$BuildPlanner$Scalar$unwrapEncoder,
						function ($) {
							return $.k8;
						},
						$author$project$BuildPlannerScalarCodecs$codecs))),
				_Utils_Tuple2(
				'atTime',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.jE,
					A2(
						$author$project$BuildPlanner$Scalar$unwrapEncoder,
						function ($) {
							return $.qE;
						},
						$author$project$BuildPlannerScalarCodecs$codecs))),
				_Utils_Tuple2(
				'commitId',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.fk,
					A2(
						$author$project$BuildPlanner$Scalar$unwrapEncoder,
						function ($) {
							return $.oc;
						},
						$author$project$BuildPlannerScalarCodecs$codecs))),
				_Utils_Tuple2(
				'vcsRef',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.nL, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))
			]));
};
var $author$project$BuildPlanner$InputObject$encodeImpactReportInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'organization',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.c3))),
				_Utils_Tuple2(
				'project',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.c5))),
				_Utils_Tuple2(
				'buildExprOrCommit',
				$elm$core$Maybe$Just(
					$author$project$BuildPlanner$InputObject$encodeBuildExprOrCommitInput(input____.n7)))
			]));
};
var $author$project$BuildPlanner$Query$impactReport = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'impactReport',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'before', requiredArgs____.xl, $author$project$BuildPlanner$InputObject$encodeImpactReportInput),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'after', requiredArgs____.w9, $author$project$BuildPlanner$InputObject$encodeImpactReportInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Model$BuildPlanner$Error$ImpactReportError$isPlanning = function (_v0) {
	var data = _v0;
	var _v1 = _Utils_Tuple2(data.xl, data.w9);
	_v1$1:
	while (true) {
		_v1$2:
		while (true) {
			switch (_v1.a.$) {
				case 2:
					return false;
				case 1:
					switch (_v1.b.$) {
						case 2:
							break _v1$1;
						case 1:
							break _v1$2;
						default:
							break _v1$2;
					}
				default:
					switch (_v1.b.$) {
						case 2:
							break _v1$1;
						case 1:
							var _v3 = _v1.b;
							return true;
						default:
							return false;
					}
			}
		}
		var _v2 = _v1.a;
		return true;
	}
	return false;
};
var $author$project$Http$Extra$isPossiblyTransient = function (err) {
	var _v0 = err.mp;
	switch (_v0.$) {
		case 0:
			return false;
		case 1:
			return true;
		case 2:
			return true;
		case 3:
			var response = _v0.a;
			return (response.wp === 502) || (response.wp === 503);
		default:
			return false;
	}
};
var $author$project$Model$BuildPlanner$Error$GenericSolverError$isPossiblyTransient = function (_v0) {
	var data = _v0;
	return data.yP;
};
var $author$project$Model$BuildPlanner$Error$RemediableSolveError$isPossiblyTransient = function (_v0) {
	var data = _v0;
	return data.yP;
};
var $author$project$Model$BuildPlanner$Error$BuildExprError$isPossiblyTransient = function (buildExprError) {
	switch (buildExprError.$) {
		case 0:
			var error = buildExprError.a;
			return $author$project$Model$BuildPlanner$Error$GenericSolverError$isPossiblyTransient(error);
		case 2:
			return false;
		case 1:
			return false;
		case 3:
			var error = buildExprError.a;
			return $author$project$Model$BuildPlanner$Error$RemediableSolveError$isPossiblyTransient(error);
		default:
			return false;
	}
};
var $author$project$Model$BuildPlanner$Error$PlanningError$isPossiblyTransient = function (_v0) {
	var data = _v0;
	return A2($elm$core$List$any, $author$project$Model$BuildPlanner$Error$BuildExprError$isPossiblyTransient, data.wt);
};
var $author$project$Model$BuildPlanner$BuildPlannerError$isPossiblyTransient = function (buildPlannerError) {
	switch (buildPlannerError.$) {
		case 0:
			var error = buildPlannerError.a;
			return $author$project$Http$Extra$isPossiblyTransient(error);
		case 7:
			var error = buildPlannerError.a;
			return $author$project$Model$BuildPlanner$Error$PlanningError$isPossiblyTransient(error);
		default:
			return false;
	}
};
var $author$project$Model$BuildPlanner$Error$ImpactReportError$isPossiblyTransient = function (_v0) {
	var data = _v0;
	var _v1 = _Utils_Tuple2(data.xl, data.w9);
	if (_v1.a.$ === 2) {
		if (_v1.b.$ === 2) {
			var e1 = _v1.a.a;
			var e2 = _v1.b.a;
			return $author$project$Model$BuildPlanner$BuildPlannerError$isPossiblyTransient(e1) || $author$project$Model$BuildPlanner$BuildPlannerError$isPossiblyTransient(e2);
		} else {
			var e = _v1.a.a;
			return $author$project$Model$BuildPlanner$BuildPlannerError$isPossiblyTransient(e);
		}
	} else {
		if (_v1.b.$ === 2) {
			var e = _v1.b.a;
			return $author$project$Model$BuildPlanner$BuildPlannerError$isPossiblyTransient(e);
		} else {
			return false;
		}
	}
};
var $author$project$Model$BuildPlanner$Error$ImpactReportError$BuildPlan = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$BuildPlanner$Error$ImpactReportError$BuildPlannerError = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$BuildPlanner$Error$ImpactReportError$BuildPlanning = {$: 1};
var $author$project$Model$BuildPlanner$Error$ImpactReportError$Data = F3(
	function (message, before, after) {
		return {w9: after, xl: before, Eh: message};
	});
var $author$project$Model$BuildPlanner$Error$ImpactReportError$ImpactReportError = $elm$core$Basics$identity;
var $author$project$Model$BuildPlanner$BuildPlannerError$PlanningError = function (a) {
	return {$: 7, a: a};
};
var $author$project$BuildPlanner$Object$ImpactReportError$buildAfter = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'buildAfter', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$BuildPlanner$Object$ImpactReportError$buildBefore = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'buildBefore', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$BuildPlanner$Union$ImpactReportBuildResult$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BuildPlanned', selections____.u3),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BuildPlanning', selections____.u4),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ParseError', selections____.vq),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ValidationError', selections____.vC),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PlanningError', selections____.vr),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'NotFound', selections____.vp),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInput', selections____.vj)
			]));
};
var $author$project$BuildPlanner$Object$ImpactReportError$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Model$BuildPlanner$Error$PlanningError$Data = F2(
	function (message, subErrors) {
		return {Eh: message, wt: subErrors};
	});
var $author$project$Model$BuildPlanner$Error$PlanningError$PlanningError = $elm$core$Basics$identity;
var $author$project$BuildPlanner$Object$PlanningError$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Model$BuildPlanner$Error$BuildExprError$GenericBuildExprError = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$BuildPlanner$Error$BuildExprError$GenericSolverError = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$BuildPlanner$Error$BuildExprError$RemediableError = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$BuildPlanner$Error$BuildExprError$RemediableSolveError = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$BuildPlanner$Error$BuildExprError$TargetNotFound = function (a) {
	return {$: 4, a: a};
};
var $author$project$BuildPlanner$Interface$BuildExprError$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'SolveError', selections____.vx),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericBuildExprError', selections____.vd),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericSolveError', selections____.ve),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RemediableError', selections____.vv),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RemediableSolveError', selections____.vw),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'TargetNotFound', selections____.vB)
			]));
};
var $author$project$BuildPlanner$Interface$SolveError$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'GenericSolveError', selections____.ve),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'RemediableSolveError', selections____.vw)
			]));
};
var $author$project$Model$BuildPlanner$Error$GenericBuildExprError$Data = F2(
	function (buildExprPath, message) {
		return {Bk: buildExprPath, Eh: message};
	});
var $author$project$Model$BuildPlanner$Error$GenericBuildExprError$GenericBuildExprError = $elm$core$Basics$identity;
var $author$project$BuildPlanner$Object$GenericBuildExprError$buildExprPath = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(List String)',
	'buildExprPath',
	_List_Nil,
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string));
var $author$project$BuildPlanner$Object$GenericBuildExprError$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Model$BuildPlanner$Error$GenericBuildExprError$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$elm$core$Basics$identity,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$GenericBuildExprError$message,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$BuildPlanner$Object$GenericBuildExprError$buildExprPath,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$Error$GenericBuildExprError$Data))));
var $author$project$Model$BuildPlanner$Error$GenericSolverError$Data = F4(
	function (path, message, isTransient, validationErrors) {
		return {yP: isTransient, Eh: message, pm: path, AJ: validationErrors};
	});
var $author$project$Model$BuildPlanner$Error$GenericSolverError$GenericSolverError = $elm$core$Basics$identity;
var $author$project$BuildPlanner$Object$GenericSolveError$isTransient = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'isTransient', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$BuildPlanner$Object$GenericSolveError$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$GenericSolveError$path = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'path', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Model$BuildPlanner$Error$SolveErrorValidationError$Data = F2(
	function (jsonPath, error) {
		return {yd: error, DN: jsonPath};
	});
var $author$project$Model$BuildPlanner$Error$SolveErrorValidationError$SolveErrorValidationError = $elm$core$Basics$identity;
var $author$project$BuildPlanner$Object$SolveErrorValidationError$error = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'error', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$SolveErrorValidationError$jsonPath = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'jsonPath',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Model$BuildPlanner$Error$SolveErrorValidationError$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$elm$core$Basics$identity,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$SolveErrorValidationError$error,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$BuildPlanner$Object$SolveErrorValidationError$jsonPath,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$Error$SolveErrorValidationError$Data))));
var $author$project$BuildPlanner$Object$GenericSolveError$validationErrors = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'validationErrors',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Model$BuildPlanner$Error$GenericSolverError$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$elm$core$Basics$identity,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$GenericSolveError$validationErrors($author$project$Model$BuildPlanner$Error$SolveErrorValidationError$selectionSet),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$BuildPlanner$Object$GenericSolveError$isTransient,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$BuildPlanner$Object$GenericSolveError$message,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$BuildPlanner$Object$GenericSolveError$path,
					$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$Error$GenericSolverError$Data))))));
var $author$project$Model$BuildPlanner$Error$RemediableError$Data = F2(
	function (buildExprPath, message) {
		return {Bk: buildExprPath, Eh: message};
	});
var $author$project$Model$BuildPlanner$Error$RemediableError$RemediableError = $elm$core$Basics$identity;
var $author$project$BuildPlanner$Object$RemediableError$buildExprPath = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(List String)',
	'buildExprPath',
	_List_Nil,
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string));
var $author$project$BuildPlanner$Object$RemediableError$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Model$BuildPlanner$Error$RemediableError$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$elm$core$Basics$identity,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$RemediableError$message,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$BuildPlanner$Object$RemediableError$buildExprPath,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$Error$RemediableError$Data))));
var $author$project$Model$BuildPlanner$Error$RemediableSolveError$Data = F7(
	function (path, message, isTransient, errorType, incompatibilities, suggestedRemediations, validationErrors) {
		return {lP: errorType, yD: incompatibilities, yP: isTransient, Eh: message, pm: path, Ak: suggestedRemediations, AJ: validationErrors};
	});
var $author$project$Model$BuildPlanner$Error$RemediableSolveError$RemediableSolveError = $elm$core$Basics$identity;
var $author$project$BuildPlanner$Enum$SolveErrorType$NoBuildImageForPlatform = 10;
var $author$project$BuildPlanner$Enum$SolveErrorType$RequirementConflictsWithPlatform = 8;
var $author$project$BuildPlanner$Enum$SolveErrorType$RequirementConflictsWithTransitiveDependency = 6;
var $author$project$BuildPlanner$Enum$SolveErrorType$RequirementUnavailable = 1;
var $author$project$BuildPlanner$Enum$SolveErrorType$RequirementUnavailableAtTimestamp = 0;
var $author$project$BuildPlanner$Enum$SolveErrorType$RequirementVersionUnavailable = 3;
var $author$project$BuildPlanner$Enum$SolveErrorType$RequirementVersionUnavailableAtTimestamp = 2;
var $author$project$BuildPlanner$Enum$SolveErrorType$RequirementsConflictOnTransitiveDependency = 7;
var $author$project$BuildPlanner$Enum$SolveErrorType$TransitiveDependencyUnavailable = 5;
var $author$project$BuildPlanner$Enum$SolveErrorType$TransitiveDependencyUnavailableAtTimestamp = 4;
var $author$project$BuildPlanner$Enum$SolveErrorType$TransitivityDependencyConflictsWithPlatform = 9;
var $author$project$BuildPlanner$Enum$SolveErrorType$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'REQUIREMENT_UNAVAILABLE_AT_TIMESTAMP':
				return $elm$json$Json$Decode$succeed(0);
			case 'REQUIREMENT_UNAVAILABLE':
				return $elm$json$Json$Decode$succeed(1);
			case 'REQUIREMENT_VERSION_UNAVAILABLE_AT_TIMESTAMP':
				return $elm$json$Json$Decode$succeed(2);
			case 'REQUIREMENT_VERSION_UNAVAILABLE':
				return $elm$json$Json$Decode$succeed(3);
			case 'TRANSITIVE_DEPENDENCY_UNAVAILABLE_AT_TIMESTAMP':
				return $elm$json$Json$Decode$succeed(4);
			case 'TRANSITIVE_DEPENDENCY_UNAVAILABLE':
				return $elm$json$Json$Decode$succeed(5);
			case 'REQUIREMENT_CONFLICTS_WITH_TRANSITIVE_DEPENDENCY':
				return $elm$json$Json$Decode$succeed(6);
			case 'REQUIREMENTS_CONFLICT_ON_TRANSITIVE_DEPENDENCY':
				return $elm$json$Json$Decode$succeed(7);
			case 'REQUIREMENT_CONFLICTS_WITH_PLATFORM':
				return $elm$json$Json$Decode$succeed(8);
			case 'TRANSITIVITY_DEPENDENCY_CONFLICTS_WITH_PLATFORM':
				return $elm$json$Json$Decode$succeed(9);
			case 'NO_BUILD_IMAGE_FOR_PLATFORM':
				return $elm$json$Json$Decode$succeed(10);
			default:
				return $elm$json$Json$Decode$fail('Invalid SolveErrorType type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$RemediableSolveError$errorType = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.SolveErrorType.SolveErrorType', 'errorType', _List_Nil, $author$project$BuildPlanner$Enum$SolveErrorType$decoder);
var $author$project$BuildPlanner$Object$RemediableSolveError$incompatibilities = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'incompatibilities',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$BuildPlanner$Object$RemediableSolveError$isTransient = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'isTransient', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$BuildPlanner$Object$RemediableSolveError$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$RemediableSolveError$path = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'path', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Model$BuildPlanner$Error$SolveErrorRemediation$SolveErrorRemediation = $elm$core$Basics$identity;
var $author$project$BuildPlanner$Object$SolveErrorRemediation$command = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'command', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Model$BuildPlanner$Error$SolveErrorRemediation$Data = F3(
	function (remediationType, command, parameters) {
		return {xH: command, zC: parameters, FB: remediationType};
	});
var $author$project$Model$BuildPlanner$Error$SolveErrorRemediation$ParametersAdvanceTimestamp = {$: 2};
var $author$project$Model$BuildPlanner$Error$SolveErrorRemediation$ParametersRemovePlatform = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$BuildPlanner$Error$SolveErrorRemediation$ParametersRemoveRequirement = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$BuildPlanner$Error$SolveErrorRemediation$ParametersUnimplementedByClient = {$: 3};
var $author$project$BuildPlanner$Enum$SolveErrorRemediationType$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'ADVANCE_TIMESTAMP';
		case 1:
			return 'REMOVE_REQUIREMENT';
		case 2:
			return 'REQUEST_PACKAGE_IMPORT';
		case 3:
			return 'CHANGE_REQUIREMENT_NAME';
		case 4:
			return 'CHANGE_REQUIREMENT_VERSION';
		default:
			return 'REMOVE_PLATFORM';
	}
};
var $author$project$Model$BuildPlanner$Error$SolveErrorRemediation$decodeParametersWith = F3(
	function (type_, mvalue, decoder) {
		if (mvalue.$ === 1) {
			return $elm$core$Result$Err(
				'Remediation type \'' + ($author$project$BuildPlanner$Enum$SolveErrorRemediationType$toString(type_) + '\' requires field \'parameters\''));
		} else {
			var value = mvalue.a;
			return A2(
				$elm$core$Result$mapError,
				$elm$json$Json$Decode$errorToString,
				A2($elm$json$Json$Decode$decodeValue, decoder, value));
		}
	});
var $author$project$Model$BuildPlanner$Error$SolveErrorRemediation$decodeParameters = F2(
	function (type_, mparameters) {
		switch (type_) {
			case 1:
				return A3(
					$author$project$Model$BuildPlanner$Error$SolveErrorRemediation$decodeParametersWith,
					type_,
					mparameters,
					A2(
						$elm$json$Json$Decode$map,
						$author$project$Model$BuildPlanner$Error$SolveErrorRemediation$ParametersRemoveRequirement,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'feature',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'namespace',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($elm$core$Tuple$pair)))));
			case 5:
				return A3(
					$author$project$Model$BuildPlanner$Error$SolveErrorRemediation$decodeParametersWith,
					type_,
					mparameters,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'platform_id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Model$BuildPlanner$Error$SolveErrorRemediation$ParametersRemovePlatform)));
			case 0:
				return $elm$core$Result$Ok($author$project$Model$BuildPlanner$Error$SolveErrorRemediation$ParametersAdvanceTimestamp);
			default:
				return $elm$core$Result$Ok($author$project$Model$BuildPlanner$Error$SolveErrorRemediation$ParametersUnimplementedByClient);
		}
	});
var $author$project$Model$BuildPlanner$Error$SolveErrorRemediation$decodeData = F3(
	function (type_, command_, mparameters) {
		return A2(
			$elm$core$Result$map,
			A2($author$project$Model$BuildPlanner$Error$SolveErrorRemediation$Data, type_, command_),
			A2($author$project$Model$BuildPlanner$Error$SolveErrorRemediation$decodeParameters, type_, mparameters));
	});
var $author$project$BuildPlanner$Object$SolveErrorRemediation$parameters = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe BuildPlannerScalarCodecs.Any)',
	'parameters',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).BK.qN));
var $author$project$BuildPlanner$Enum$SolveErrorRemediationType$AdvanceTimestamp = 0;
var $author$project$BuildPlanner$Enum$SolveErrorRemediationType$ChangeRequirementName = 3;
var $author$project$BuildPlanner$Enum$SolveErrorRemediationType$ChangeRequirementVersion = 4;
var $author$project$BuildPlanner$Enum$SolveErrorRemediationType$RemovePlatform = 5;
var $author$project$BuildPlanner$Enum$SolveErrorRemediationType$RemoveRequirement = 1;
var $author$project$BuildPlanner$Enum$SolveErrorRemediationType$RequestPackageImport = 2;
var $author$project$BuildPlanner$Enum$SolveErrorRemediationType$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'ADVANCE_TIMESTAMP':
				return $elm$json$Json$Decode$succeed(0);
			case 'REMOVE_REQUIREMENT':
				return $elm$json$Json$Decode$succeed(1);
			case 'REQUEST_PACKAGE_IMPORT':
				return $elm$json$Json$Decode$succeed(2);
			case 'CHANGE_REQUIREMENT_NAME':
				return $elm$json$Json$Decode$succeed(3);
			case 'CHANGE_REQUIREMENT_VERSION':
				return $elm$json$Json$Decode$succeed(4);
			case 'REMOVE_PLATFORM':
				return $elm$json$Json$Decode$succeed(5);
			default:
				return $elm$json$Json$Decode$fail('Invalid SolveErrorRemediationType type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$SolveErrorRemediation$remediationType = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.SolveErrorRemediationType.SolveErrorRemediationType', 'remediationType', _List_Nil, $author$project$BuildPlanner$Enum$SolveErrorRemediationType$decoder);
var $author$project$Model$BuildPlanner$Error$SolveErrorRemediation$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$elm$core$Basics$identity,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$mapOrFail,
		$elm$core$Basics$identity,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$BuildPlanner$Object$SolveErrorRemediation$parameters,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$BuildPlanner$Object$SolveErrorRemediation$command,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$BuildPlanner$Object$SolveErrorRemediation$remediationType,
					$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$Error$SolveErrorRemediation$decodeData))))));
var $author$project$BuildPlanner$Interface$SolveErrorIncompatibility$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'SolveErrorPackageIncompatibility', selections____.vy),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'SolveErrorPlatformIncompatibility', selections____.vz)
			]));
};
var $author$project$Model$BuildPlanner$Error$RemediableSolveError$PackageIncompatibility = function (a) {
	return {$: 0, a: a};
};
var $author$project$BuildPlanner$Object$SolveErrorPackageIncompatibility$feature = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'feature', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$SolveErrorPackageIncompatibility$namespace = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'namespace', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Model$BuildPlanner$Error$RemediableSolveError$selectionSetPackageIncompatibility = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$author$project$Model$BuildPlanner$Error$RemediableSolveError$PackageIncompatibility,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$SolveErrorPackageIncompatibility$feature,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$BuildPlanner$Object$SolveErrorPackageIncompatibility$namespace,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Tuple$pair))));
var $author$project$Model$BuildPlanner$Error$RemediableSolveError$PlatformIncompatibility = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$BuildPlanner$Error$RemediableSolveError$PlatformIncompatibilityData = F2(
	function (platformID, platformKernel) {
		return {m0: platformID, Ff: platformKernel};
	});
var $author$project$BuildPlanner$Object$SolveErrorPlatformIncompatibility$platformId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'BuildPlannerScalarCodecs.Id',
	'platformId',
	_List_Nil,
	$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).oc.qN);
var $author$project$BuildPlanner$Object$SolveErrorPlatformIncompatibility$platformKernel = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'platformKernel', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Model$BuildPlanner$Error$RemediableSolveError$selectionSetPlatformIncompatibility = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$author$project$Model$BuildPlanner$Error$RemediableSolveError$PlatformIncompatibility,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$SolveErrorPlatformIncompatibility$platformKernel,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$BuildPlanner$Object$SolveErrorPlatformIncompatibility$platformId,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$Error$RemediableSolveError$PlatformIncompatibilityData))));
var $author$project$Model$BuildPlanner$Error$RemediableSolveError$selectionSetIncompatibility = $author$project$BuildPlanner$Interface$SolveErrorIncompatibility$fragments(
	{vy: $author$project$Model$BuildPlanner$Error$RemediableSolveError$selectionSetPackageIncompatibility, vz: $author$project$Model$BuildPlanner$Error$RemediableSolveError$selectionSetPlatformIncompatibility});
var $author$project$BuildPlanner$Object$RemediableSolveError$suggestedRemediations = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'suggestedRemediations',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$BuildPlanner$Object$RemediableSolveError$validationErrors = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'validationErrors',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Model$BuildPlanner$Error$RemediableSolveError$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$elm$core$Basics$identity,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$RemediableSolveError$validationErrors($author$project$Model$BuildPlanner$Error$SolveErrorValidationError$selectionSet),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$BuildPlanner$Object$RemediableSolveError$suggestedRemediations($author$project$Model$BuildPlanner$Error$SolveErrorRemediation$selectionSet),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$BuildPlanner$Object$RemediableSolveError$incompatibilities($author$project$Model$BuildPlanner$Error$RemediableSolveError$selectionSetIncompatibility),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$BuildPlanner$Object$RemediableSolveError$errorType,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$BuildPlanner$Object$RemediableSolveError$isTransient,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$BuildPlanner$Object$RemediableSolveError$message,
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$BuildPlanner$Object$RemediableSolveError$path,
								$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$Error$RemediableSolveError$Data)))))))));
var $author$project$Model$BuildPlanner$Error$TargetNotFound$Data = F4(
	function (message, buildExprPath, requestedTarget, possibleTargets) {
		return {Bk: buildExprPath, Eh: message, Fm: possibleTargets, FE: requestedTarget};
	});
var $author$project$Model$BuildPlanner$Error$TargetNotFound$TargetNotFound = $elm$core$Basics$identity;
var $author$project$BuildPlanner$Object$TargetNotFound$buildExprPath = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(List String)',
	'buildExprPath',
	_List_Nil,
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string));
var $author$project$BuildPlanner$Object$TargetNotFound$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$TargetNotFound$possibleTargets = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(List String)',
	'possibleTargets',
	_List_Nil,
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string));
var $author$project$BuildPlanner$Object$TargetNotFound$requestedTarget = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'requestedTarget', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Model$BuildPlanner$Error$TargetNotFound$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$elm$core$Basics$identity,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$TargetNotFound$possibleTargets,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$BuildPlanner$Object$TargetNotFound$requestedTarget,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$BuildPlanner$Object$TargetNotFound$buildExprPath,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$BuildPlanner$Object$TargetNotFound$message,
					$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$Error$TargetNotFound$Data))))));
var $author$project$Model$BuildPlanner$Error$BuildExprError$selectionSet = $author$project$BuildPlanner$Interface$BuildExprError$fragments(
	{
		vd: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Model$BuildPlanner$Error$BuildExprError$GenericBuildExprError, $author$project$Model$BuildPlanner$Error$GenericBuildExprError$selectionSet),
		ve: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Model$BuildPlanner$Error$BuildExprError$GenericSolverError, $author$project$Model$BuildPlanner$Error$GenericSolverError$selectionSet),
		vv: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Model$BuildPlanner$Error$BuildExprError$RemediableError, $author$project$Model$BuildPlanner$Error$RemediableError$selectionSet),
		vw: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Model$BuildPlanner$Error$BuildExprError$RemediableSolveError, $author$project$Model$BuildPlanner$Error$RemediableSolveError$selectionSet),
		vx: $author$project$BuildPlanner$Interface$SolveError$fragments(
			{
				ve: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Model$BuildPlanner$Error$BuildExprError$GenericSolverError, $author$project$Model$BuildPlanner$Error$GenericSolverError$selectionSet),
				vw: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Model$BuildPlanner$Error$BuildExprError$RemediableSolveError, $author$project$Model$BuildPlanner$Error$RemediableSolveError$selectionSet)
			}),
		vB: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Model$BuildPlanner$Error$BuildExprError$TargetNotFound, $author$project$Model$BuildPlanner$Error$TargetNotFound$selectionSet)
	});
var $author$project$BuildPlanner$Object$PlanningError$subErrors = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'subErrors',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Model$BuildPlanner$Error$PlanningError$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$elm$core$Basics$identity,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$PlanningError$subErrors($author$project$Model$BuildPlanner$Error$BuildExprError$selectionSet),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$BuildPlanner$Object$PlanningError$message,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$Error$PlanningError$Data))));
var $author$project$Model$BuildPlanner$BuildPlan$BuildPlan = F7(
	function (state, nodes, steps, terminals, resolvedRequirements, components, sessionId) {
		return {hr: components, g9: nodes, pD: resolvedRequirements, v6: sessionId, bB: state, Gi: steps, Gu: terminals};
	});
var $author$project$Model$BuildPlanner$BuildPlan$BuildPlanned = {$: 1};
var $author$project$BuildPlanner$Object$BuildPlanned$components = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'components',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$BuildPlanner$Object$BuildPlanned$nodes = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'nodes',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$BuildPlanner$Object$BuildPlanned$resolvedRequirements = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'resolvedRequirements',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Model$BuildPlanner$Component$Component = $elm$core$Basics$identity;
var $author$project$Model$BuildPlanner$Component$Data = F6(
	function (componentId, purl, namespace, name, version, relatesTo) {
		return {xJ: componentId, w: name, aE: namespace, k: purl, FA: relatesTo, aI: version};
	});
var $author$project$BuildPlanner$Object$Component$componentId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'BuildPlannerScalarCodecs.Id',
	'componentId',
	_List_Nil,
	$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).oc.qN);
var $author$project$BuildPlanner$Object$Component$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$Component$namespace = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'namespace', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$Component$purl = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'BuildPlannerScalarCodecs.PackageURL',
	'purl',
	_List_Nil,
	$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).BO.qN);
var $author$project$BuildPlanner$Object$Component$relatesTo = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'relatesTo',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Model$BuildPlanner$BuildRelationship$BuildRelationship = $elm$core$Basics$identity;
var $author$project$Model$BuildPlanner$BuildRelationship$Data = F2(
	function (type_, nodeId) {
		return {rE: nodeId, gR: type_};
	});
var $author$project$BuildPlanner$Object$BuildRelationship$nodeId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'BuildPlannerScalarCodecs.Id',
	'nodeId',
	_List_Nil,
	$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).oc.qN);
var $author$project$BuildPlanner$Object$BuildRelationship$type_ = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.ComponentRelationshipType.ComponentRelationshipType', 'type', _List_Nil, $author$project$BuildPlanner$Enum$ComponentRelationshipType$decoder);
var $author$project$Model$BuildPlanner$BuildRelationship$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$elm$core$Basics$identity,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$BuildRelationship$nodeId,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$BuildPlanner$Object$BuildRelationship$type_,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$BuildRelationship$Data))));
var $author$project$BuildPlanner$Object$Component$version = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'version', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Model$BuildPlanner$Component$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$elm$core$Basics$identity,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$Component$relatesTo($author$project$Model$BuildPlanner$BuildRelationship$selectionSet),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$BuildPlanner$Object$Component$version,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$BuildPlanner$Object$Component$name,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$BuildPlanner$Object$Component$namespace,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$BuildPlanner$Object$Component$purl,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$BuildPlanner$Object$Component$componentId,
							$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$Component$Data))))))));
var $author$project$Model$BuildPlanner$ResolvedRequirement$ResolvedRequirement = F3(
	function (path, requirement, resolvedSource) {
		return {pm: path, ci: requirement, FI: resolvedSource};
	});
var $author$project$BuildPlanner$Object$ResolvedRequirement$path = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'path', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$ResolvedRequirement$requirement = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'requirement', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$BuildPlanner$Object$ResolvedRequirement$resolvedSource = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'BuildPlannerScalarCodecs.Id',
	'resolvedSource',
	_List_Nil,
	$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).oc.qN);
var $author$project$Model$BuildPlanner$BuildExpr$Solve$Requirement$Requirement = F4(
	function (name, namespace, versionRequirements, ingredientVersion) {
		return {CX: ingredientVersion, w: name, aE: namespace, gW: versionRequirements};
	});
var $author$project$BuildPlanner$Object$Requirement$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$Requirement$namespace = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'namespace', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Enum$Comparator$Eq = 0;
var $author$project$BuildPlanner$Enum$Comparator$Gt = 1;
var $author$project$BuildPlanner$Enum$Comparator$Gte = 2;
var $author$project$BuildPlanner$Enum$Comparator$Lt = 3;
var $author$project$BuildPlanner$Enum$Comparator$Lte = 4;
var $author$project$BuildPlanner$Enum$Comparator$Ne = 5;
var $author$project$BuildPlanner$Enum$Comparator$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'EQ':
				return $elm$json$Json$Decode$succeed(0);
			case 'GT':
				return $elm$json$Json$Decode$succeed(1);
			case 'GTE':
				return $elm$json$Json$Decode$succeed(2);
			case 'LT':
				return $elm$json$Json$Decode$succeed(3);
			case 'LTE':
				return $elm$json$Json$Decode$succeed(4);
			case 'NE':
				return $elm$json$Json$Decode$succeed(5);
			default:
				return $elm$json$Json$Decode$fail('Invalid Comparator type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$VersionRequirement$comparator = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.Comparator.Comparator', 'comparator', _List_Nil, $author$project$BuildPlanner$Enum$Comparator$decoder);
var $author$project$BuildPlanner$Enum$Comparator$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'EQ';
		case 1:
			return 'GT';
		case 2:
			return 'GTE';
		case 3:
			return 'LT';
		case 4:
			return 'LTE';
		default:
			return 'NE';
	}
};
var $author$project$BuildPlanner$Object$VersionRequirement$version = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'version', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Model$BuildPlanner$BuildExpr$Solve$VersionRequirement$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$BuildPlanner$Object$VersionRequirement$version,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$BuildPlanner$Enum$Comparator$toString, $author$project$BuildPlanner$Object$VersionRequirement$comparator),
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$BuildExpr$Solve$VersionRequirement$VersionRequirement)));
var $author$project$BuildPlanner$Object$Requirement$versionRequirements = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'versionRequirements',
		_List_Nil,
		object____,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, $elm$json$Json$Decode$list, $elm$json$Json$Decode$nullable)));
};
var $author$project$Model$BuildPlanner$BuildExpr$Solve$Requirement$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Maybe$Nothing),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
			$elm$core$Maybe$withDefault(_List_Nil),
			$author$project$BuildPlanner$Object$Requirement$versionRequirements($author$project$Model$BuildPlanner$BuildExpr$Solve$VersionRequirement$selectionSet)),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$BuildPlanner$Object$Requirement$namespace,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$BuildPlanner$Object$Requirement$name,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$BuildExpr$Solve$Requirement$Requirement)))));
var $author$project$Model$BuildPlanner$ResolvedRequirement$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$BuildPlanner$Object$ResolvedRequirement$resolvedSource,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$ResolvedRequirement$requirement($author$project$Model$BuildPlanner$BuildExpr$Solve$Requirement$selectionSet),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$BuildPlanner$Object$ResolvedRequirement$path,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$ResolvedRequirement$ResolvedRequirement))));
var $author$project$Model$BuildPlanner$Step$Data = F4(
	function (stepId, name, inputs, outputs) {
		return {yH: inputs, w: name, zz: outputs, Gh: stepId};
	});
var $author$project$Model$BuildPlanner$Step$Step = $elm$core$Basics$identity;
var $author$project$BuildPlanner$Object$Step$inputs = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'inputs',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$BuildPlanner$Object$Step$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$Step$outputs = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(List BuildPlannerScalarCodecs.Id)',
	'outputs',
	_List_Nil,
	$elm$json$Json$Decode$list(
		$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).oc.qN));
var $author$project$Model$BuildPlanner$TaggedNodes$Data = F2(
	function (tag_, nodeIds_) {
		return {zs: nodeIds_, Al: tag_};
	});
var $author$project$BuildPlanner$Object$TaggedNodes$nodeIds = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(List BuildPlannerScalarCodecs.Id)',
	'nodeIds',
	_List_Nil,
	$elm$json$Json$Decode$list(
		$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).oc.qN));
var $author$project$BuildPlanner$Object$TaggedNodes$tag = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'tag', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Model$BuildPlanner$TaggedNodes$BuildDep = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$BuildPlanner$TaggedNodes$Builder = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$BuildPlanner$TaggedNodes$Orphans = {$: 4};
var $author$project$Model$BuildPlanner$TaggedNodes$Platform = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Model$BuildPlanner$TaggedNodes$Src = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$BuildPlanner$TaggedNodes$typedTag = function (_v0) {
	var tag_ = _v0.Al;
	var nodeIds_ = _v0.zs;
	switch (tag_) {
		case 'src':
			return $elm$core$Result$Ok(
				$author$project$Model$BuildPlanner$TaggedNodes$Src(nodeIds_));
		case 'deps':
			return $elm$core$Result$Ok(
				$author$project$Model$BuildPlanner$TaggedNodes$BuildDep(nodeIds_));
		case 'builder':
			return $elm$core$Result$Ok(
				$author$project$Model$BuildPlanner$TaggedNodes$Builder(nodeIds_));
		case 'orphans':
			return $elm$core$Result$Ok($author$project$Model$BuildPlanner$TaggedNodes$Orphans);
		default:
			var _v2 = A2($elm$core$String$split, ':', tag_);
			if (((_v2.b && (_v2.a === 'platform')) && _v2.b.b) && (!_v2.b.b.b)) {
				var _v3 = _v2.b;
				var id = _v3.a;
				return $elm$core$Result$Ok(
					A2($author$project$Model$BuildPlanner$TaggedNodes$Platform, id, nodeIds_));
			} else {
				return $elm$core$Result$Err('Unknown TaggedNode tag: ' + tag_);
			}
	}
};
var $author$project$Model$BuildPlanner$TaggedNodes$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$mapOrFail,
	$author$project$Model$BuildPlanner$TaggedNodes$typedTag,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$TaggedNodes$nodeIds,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$BuildPlanner$Object$TaggedNodes$tag,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$TaggedNodes$Data))));
var $author$project$BuildPlanner$Object$Step$stepId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'BuildPlannerScalarCodecs.Id',
	'stepId',
	_List_Nil,
	$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).oc.qN);
var $author$project$Model$BuildPlanner$Step$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$elm$core$Basics$identity,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$Step$outputs,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$BuildPlanner$Object$Step$inputs($author$project$Model$BuildPlanner$TaggedNodes$selectionSet),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$BuildPlanner$Object$Step$name,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$BuildPlanner$Object$Step$stepId,
					$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$Step$Data))))));
var $author$project$BuildPlanner$Object$BuildPlanned$sessionId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe BuildPlannerScalarCodecs.Id)',
	'sessionId',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).oc.qN));
var $author$project$BuildPlanner$Object$BuildPlanned$steps = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'steps',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$BuildPlanner$Object$BuildPlanned$terminals = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'terminals',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Model$BuildPlanner$BuildPlan$selectionSetPlanned = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$BuildPlanner$Object$BuildPlanned$sessionId,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$BuildPlanned$components($author$project$Model$BuildPlanner$Component$selectionSet),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$BuildPlanner$Object$BuildPlanned$resolvedRequirements($author$project$Model$BuildPlanner$ResolvedRequirement$selectionSet),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$BuildPlanner$Object$BuildPlanned$terminals($author$project$Model$BuildPlanner$TaggedNodes$selectionSet),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$BuildPlanner$Object$BuildPlanned$steps($author$project$Model$BuildPlanner$Step$selectionSet),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$BuildPlanner$Object$BuildPlanned$nodes($author$project$Model$BuildPlanner$Node$selectionSet),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
							$author$project$Model$BuildPlanner$BuildPlan$BuildPlanned,
							$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$BuildPlan$BuildPlan))))))));
var $author$project$Model$BuildPlanner$Error$ImpactReportError$selectionSet = function () {
	var result = $author$project$BuildPlanner$Union$ImpactReportBuildResult$fragments(
		{
			u3: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Model$BuildPlanner$Error$ImpactReportError$BuildPlan, $author$project$Model$BuildPlanner$BuildPlan$selectionSetPlanned),
			u4: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$Error$ImpactReportError$BuildPlanning),
			vj: A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
				A2($elm$core$Basics$composeL, $author$project$Model$BuildPlanner$Error$ImpactReportError$BuildPlannerError, $author$project$Model$BuildPlanner$BuildPlannerError$InvalidInputError),
				$author$project$Model$BuildPlanner$Error$InvalidInputError$selectionSet),
			vp: A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
				A2($elm$core$Basics$composeL, $author$project$Model$BuildPlanner$Error$ImpactReportError$BuildPlannerError, $author$project$Model$BuildPlanner$BuildPlannerError$NotFoundError),
				$author$project$Model$BuildPlanner$Error$NotFoundError$selectionSet),
			vq: A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
				A2($elm$core$Basics$composeL, $author$project$Model$BuildPlanner$Error$ImpactReportError$BuildPlannerError, $author$project$Model$BuildPlanner$BuildPlannerError$ParseError),
				$author$project$Model$BuildPlanner$Error$ParseError$selectionSet),
			vr: A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
				A2($elm$core$Basics$composeL, $author$project$Model$BuildPlanner$Error$ImpactReportError$BuildPlannerError, $author$project$Model$BuildPlanner$BuildPlannerError$PlanningError),
				$author$project$Model$BuildPlanner$Error$PlanningError$selectionSet),
			vC: A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
				A2($elm$core$Basics$composeL, $author$project$Model$BuildPlanner$Error$ImpactReportError$BuildPlannerError, $author$project$Model$BuildPlanner$BuildPlannerError$ValidationError),
				$author$project$Model$BuildPlanner$Error$ValidationError$selectionSet)
		});
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
		$elm$core$Basics$identity,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$BuildPlanner$Object$ImpactReportError$buildAfter(result),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$BuildPlanner$Object$ImpactReportError$buildBefore(result),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$BuildPlanner$Object$ImpactReportError$message,
					$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$Error$ImpactReportError$Data)))));
}();
var $author$project$Model$BuildPlanner$ImpactReport$CVEDiff = F4(
	function (cveID, description, severity, status) {
		return {B9: cveID, bP: description, ck: severity, L: status};
	});
var $author$project$Model$BuildPlanner$ImpactReport$CommonState = F2(
	function (version, kind) {
		return {mp: kind, aI: version};
	});
var $author$project$Model$BuildPlanner$ImpactReport$ComponentDiff = F4(
	function (namespace, name, before, after) {
		return {w9: after, xl: before, w: name, aE: namespace};
	});
var $author$project$Model$BuildPlanner$ImpactReport$Dependency = 2;
var $author$project$Model$BuildPlanner$ImpactReport$ImpactReport = F2(
	function (components, cves) {
		return {hr: components, xQ: cves};
	});
var $author$project$Model$BuildPlanner$ImpactReport$RequestedPackage = 0;
var $author$project$BuildPlanner$Object$ComponentDiff$after = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'after',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$BuildPlanner$Object$ComponentDiff$before = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'before',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$BuildPlanner$Object$ImpactReport$components = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'components',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$BuildPlanner$Object$CVEDiff$cveID = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'cveID', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$ImpactReport$cves = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'cves',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$BuildPlanner$Object$CVEDiff$description = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'description', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Union$ComponentDiffState$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ComponentState', selections____.u9),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'IngredientState', selections____.vi)
			]));
};
var $author$project$BuildPlanner$Object$IngredientState$isRequirement = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'isRequirement', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$BuildPlanner$Object$ComponentDiff$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$ComponentDiff$namespace = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'namespace', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$CVEDiff$severity = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'severity', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Enum$CVEDiffStatus$Added = 0;
var $author$project$BuildPlanner$Enum$CVEDiffStatus$Removed = 1;
var $author$project$BuildPlanner$Enum$CVEDiffStatus$Unchanged = 2;
var $author$project$BuildPlanner$Enum$CVEDiffStatus$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'ADDED':
				return $elm$json$Json$Decode$succeed(0);
			case 'REMOVED':
				return $elm$json$Json$Decode$succeed(1);
			case 'UNCHANGED':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Invalid CVEDiffStatus type, ' + (string + ' try re-running the @dillonkearns/elm-graphql CLI '));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$CVEDiff$status = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Enum.CVEDiffStatus.CVEDiffStatus', 'status', _List_Nil, $author$project$BuildPlanner$Enum$CVEDiffStatus$decoder);
var $author$project$BuildPlanner$Object$ComponentState$version = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'version', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuildPlanner$Object$IngredientState$version = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'version', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Model$BuildPlanner$ImpactReport$selectionSet = function () {
	var kind = A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
		function (isRequirement) {
			return isRequirement ? 0 : 2;
		},
		$author$project$BuildPlanner$Object$IngredientState$isRequirement);
	var ingredientStateSelection = A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		kind,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$BuildPlanner$Object$IngredientState$version,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$ImpactReport$CommonState)));
	var cveSelection = A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$CVEDiff$status,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Model$Severity$fromString, $author$project$BuildPlanner$Object$CVEDiff$severity),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$BuildPlanner$Object$CVEDiff$description,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$BuildPlanner$Object$CVEDiff$cveID,
					$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$ImpactReport$CVEDiff)))));
	var componentStateSelection = A3(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map2,
		$author$project$Model$BuildPlanner$ImpactReport$CommonState,
		$author$project$BuildPlanner$Object$ComponentState$version,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(2));
	var componentDiffStateSelection = $author$project$BuildPlanner$Union$ComponentDiffState$fragments(
		{u9: componentStateSelection, vi: ingredientStateSelection});
	var componentSelection = A5(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map4,
		$author$project$Model$BuildPlanner$ImpactReport$ComponentDiff,
		$author$project$BuildPlanner$Object$ComponentDiff$namespace,
		$author$project$BuildPlanner$Object$ComponentDiff$name,
		$author$project$BuildPlanner$Object$ComponentDiff$before(componentDiffStateSelection),
		$author$project$BuildPlanner$Object$ComponentDiff$after(componentDiffStateSelection));
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$ImpactReport$cves(cveSelection),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$BuildPlanner$Object$ImpactReport$components(componentSelection),
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$ImpactReport$ImpactReport)));
}();
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $elm$core$Task$map3 = F4(
	function (func, taskA, taskB, taskC) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return A2(
							$elm$core$Task$andThen,
							function (c) {
								return $elm$core$Task$succeed(
									A3(func, a, b, c));
							},
							taskC);
					},
					taskB);
			},
			taskA);
	});
var $author$project$Request$BuildPlanner$pollingIntervalMillis = 5000;
var $author$project$Request$BuildPlanner$pollingMaxRetries = 2;
var $author$project$Misc$triple = F3(
	function (a, b, c) {
		return _Utils_Tuple3(a, b, c);
	});
var $author$project$Request$BuildPlanner$withActivePollingHelper = F4(
	function (previousTries, isPlanning, isPossiblyTransient, task) {
		return A2(
			$elm$core$Task$onError,
			function (error) {
				return ((_Utils_cmp(previousTries, $author$project$Request$BuildPlanner$pollingMaxRetries) < 0) && isPossiblyTransient(error)) ? A4($author$project$Request$BuildPlanner$withActivePollingHelper, previousTries + 1, isPlanning, isPossiblyTransient, task) : $elm$core$Task$fail(error);
			},
			A2(
				$elm$core$Task$andThen,
				function (_v0) {
					var timeBefore = _v0.a;
					var value = _v0.b;
					var timeAfter = _v0.c;
					if (isPlanning(value)) {
						var taskDurationMillis = $elm$core$Basics$abs(
							$elm$time$Time$posixToMillis(timeAfter) - $elm$time$Time$posixToMillis(timeBefore));
						var sleepDurationMillis = A2($elm$core$Basics$max, 0, $author$project$Request$BuildPlanner$pollingIntervalMillis - taskDurationMillis);
						return A2(
							$elm$core$Task$andThen,
							function (_v1) {
								return A4($author$project$Request$BuildPlanner$withActivePollingHelper, previousTries, isPlanning, isPossiblyTransient, task);
							},
							$elm$core$Process$sleep(sleepDurationMillis));
					} else {
						return $elm$core$Task$succeed(value);
					}
				},
				A4($elm$core$Task$map3, $author$project$Misc$triple, $elm$time$Time$now, task, $elm$time$Time$now)));
	});
var $author$project$Request$BuildPlanner$withActivePolling = F3(
	function (isPlanning, isPossiblyTransient, task) {
		return A4($author$project$Request$BuildPlanner$withActivePollingHelper, 0, isPlanning, isPossiblyTransient, task);
	});
var $author$project$Request$BuildPlanner$getImpactReport = F3(
	function (creds, before, after) {
		var resultToTask = function (result) {
			if (!result.$) {
				var ok = result.a;
				return $elm$core$Task$succeed(ok);
			} else {
				var err = result.a;
				return $elm$core$Task$fail(err);
			}
		};
		var isPossiblyTransient = function (error) {
			if (!error.$) {
				var e = error.a;
				return $author$project$Http$Extra$isPossiblyTransient(e);
			} else {
				var e = error.a;
				return $author$project$Model$BuildPlanner$Error$ImpactReportError$isPossiblyTransient(e);
			}
		};
		var isPlanning = function (result) {
			if ((result.$ === 1) && (result.a.$ === 1)) {
				var err = result.a.a;
				return $author$project$Model$BuildPlanner$Error$ImpactReportError$isPlanning(err);
			} else {
				return false;
			}
		};
		var fragments = $author$project$BuildPlanner$Union$ImpactReportResult$fragments(
			{
				vg: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Result$Ok, $author$project$Model$BuildPlanner$ImpactReport$selectionSet),
				vh: A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Request$BuildPlanner$ImpactReportError),
					$author$project$Model$BuildPlanner$Error$ImpactReportError$selectionSet)
			});
		var convertSpec = function (s) {
			return $author$project$BuildPlanner$InputObject$buildBuildExprOrCommitInput(
				function () {
					switch (s.$) {
						case 0:
							var id = s.a;
							return function (o) {
								return _Utils_update(
									o,
									{
										fk: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(id)
									});
							};
						case 1:
							var atTime = s.a.jE;
							var buildExpr = s.a.k$;
							return function (o) {
								return _Utils_update(
									o,
									{
										jE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(atTime),
										k$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
											$author$project$Model$BuildPlanner$BuildExpr$encode(buildExpr))
									});
							};
						default:
							var ref = s.a;
							return function (o) {
								return _Utils_update(
									o,
									{
										nL: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(ref)
									});
							};
					}
				}());
		};
		var convertInput = function (i) {
			return {
				n7: convertSpec(i.Gc),
				c3: i.c3,
				c5: i.c5
			};
		};
		var args = {
			w9: convertInput(after),
			xl: convertInput(before)
		};
		return A2(
			$elm$core$Task$andThen,
			resultToTask,
			A3(
				$author$project$Request$BuildPlanner$withActivePolling,
				isPlanning,
				isPossiblyTransient,
				A2(
					$elm$core$Task$mapError,
					$author$project$Request$BuildPlanner$HttpError,
					A5(
						$author$project$GraphQL$Utils$queryRequest,
						creds,
						4,
						_List_Nil,
						'GetImpactReport',
						A2($author$project$BuildPlanner$Query$impactReport, args, fragments)))));
	});
var $author$project$Model$Project$getOrganizationId = function (_v0) {
	var project = _v0;
	return project.zx;
};
var $author$project$Model$Project$id = function (_v0) {
	var project = _v0;
	return project.zK;
};
var $author$project$Model$BuildPlanner$Source$checksum = function (_v0) {
	var data = _v0;
	return data.dE;
};
var $author$project$Model$Namespace$imagePrefix = 'oci-image/';
var $author$project$Model$Namespace$isImageKey = A2(
	$elm$core$Basics$composeR,
	$author$project$Model$Namespace$getNamespace,
	$elm$core$String$startsWith($author$project$Model$Namespace$imagePrefix));
var $author$project$Model$BuildPlanner$MissingSource$name = function (_v0) {
	var data = _v0;
	return data.w;
};
var $author$project$Model$BuildPlanner$MissingSource$namespace = function (_v0) {
	var data = _v0;
	return data.aE;
};
var $author$project$Model$BuildPlanner$MissingSource$namespaceKey = function (source) {
	return $author$project$Model$Namespace$key(
		{
			w: $author$project$Model$BuildPlanner$MissingSource$name(source),
			aE: $author$project$Model$BuildPlanner$MissingSource$namespace(source)
		});
};
var $author$project$Model$BuildPlanner$Source$name = function (_v0) {
	var data = _v0;
	return data.w;
};
var $author$project$Model$BuildPlanner$Source$namespace = function (_v0) {
	var data = _v0;
	return data.aE;
};
var $author$project$Model$BuildPlanner$Source$namespaceKey = function (source) {
	return $author$project$Model$Namespace$key(
		{
			w: $author$project$Model$BuildPlanner$Source$name(source),
			aE: $author$project$Model$BuildPlanner$Source$namespace(source)
		});
};
var $author$project$Model$BuildPlanner$MissingSource$relatesTo = function (_v0) {
	var data = _v0;
	return data.FA;
};
var $author$project$Model$BuildPlanner$Source$relatesTo = function (_v0) {
	var data = _v0;
	return data.FA;
};
var $author$project$Model$BuildPlanner$MissingSource$version = function (_v0) {
	var data = _v0;
	return data.aI;
};
var $author$project$Model$BuildPlanner$Source$version = function (_v0) {
	var data = _v0;
	return data.aI;
};
var $author$project$Model$BuildPlanner$Node$sourceImage = function (node) {
	switch (node.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			var s = node.a;
			var key = $author$project$Model$BuildPlanner$Source$namespaceKey(s);
			return $author$project$Model$Namespace$isImageKey(key) ? $elm$core$Maybe$Just(
				{
					tC: $author$project$Model$BuildPlanner$Source$checksum(s),
					Y: key,
					FA: $author$project$Model$BuildPlanner$Source$relatesTo(s),
					aI: $author$project$Model$BuildPlanner$Source$version(s)
				}) : $elm$core$Maybe$Nothing;
		default:
			var s = node.a;
			var key = $author$project$Model$BuildPlanner$MissingSource$namespaceKey(s);
			return $author$project$Model$Namespace$isImageKey(key) ? $elm$core$Maybe$Just(
				{
					tC: $author$project$Model$BuildPlanner$MissingSource$version(s),
					Y: key,
					FA: $author$project$Model$BuildPlanner$MissingSource$relatesTo(s),
					aI: $author$project$Model$BuildPlanner$MissingSource$version(s)
				}) : $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$BuildPlanner$BuildPlan$images = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.g9;
	},
	$elm$core$List$filterMap($author$project$Model$BuildPlanner$Node$sourceImage));
var $author$project$Views$ImpactReport$Dependencies = 0;
var $author$project$Views$ImpactReport$init = function (args) {
	return {kZ: $elm$core$Maybe$Nothing, BT: args.BT, oi: $author$project$Model$CopyStatus$empty, jX: false, t0: args.t0, ma: args.ma, c3: args.c3, vT: args.vT, pA: false, FQ: args.FQ, ns: $elm$core$Maybe$Nothing, pP: false, F7: args.F7, kB: 0};
};
var $author$project$Analytics$Object$Truthy$is_true = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Bool', 'is_true', _List_Nil, $elm$json$Json$Decode$bool);
var $author$project$Pages$OrgRemediation$panoramaRemediation = _List_fromArray(
	[
		{xq: '92603aa8-3cf5-48c5-b127-5a588213df60', BR: 'c92b9050-db0b-4587-a4ed-3b029af61220', bP: 'Redis is the world’s fastest data platform.', l6: 'c7e4fd05-7c08-4e45-9c4e-3787a4346788', jZ: '/img/docker-image-icons/redis.png', w: 'redis', zv: '474a5054-4edc-44c7-ace8-5cc7406bdafe', E_: 'create-rem-commits', aI: '7.4.1'},
		{xq: 'e6671683-094c-4e0a-bd14-edbe30099697', BR: '19eb2d06-9921-446b-8086-6d069265ec2c', bP: 'Python is an interpreted, interactive, object-oriented, open-source programming language.', l6: 'b67d9962-3355-4a76-9312-6fa586bb84c6', jZ: '/img/docker-image-icons/python.png', w: 'python', zv: '474a5054-4edc-44c7-ace8-5cc7406bdafe', E_: 'create-rem-commits', aI: '3.12.7'},
		{xq: 'c1474884-a6d9-4d59-afe1-f69c68397d8e', BR: '165f8628-2175-4e33-8092-c29b0e60f010', bP: 'nginx is an HTTP web server, reverse proxy, content cache, load balancer, TCP/UDP proxy server, and mail proxy server.', l6: '234e1136-da54-4b63-b285-4b6fa5edc008', jZ: '/img/docker-image-icons/nginx.png', w: 'nginx', zv: '474a5054-4edc-44c7-ace8-5cc7406bdafe', E_: 'create-rem-commits', aI: '1.27.1'},
		{xq: 'a368c922-9b3c-4579-8316-36943a023db6', BR: '6ed6a8cb-2271-42c4-8eaa-9f4152d9046f', bP: 'Prometheus is a systems and service monitoring system. Long-term versions maintained by Canonical.', l6: '3dc5e84f-5285-4cf3-b4dc-befbab14fec3', jZ: '/img/docker-image-icons/prometheus.png', w: 'prometheus', zv: '474a5054-4edc-44c7-ace8-5cc7406bdafe', E_: 'create-rem-commits', aI: '2.55.1'},
		{xq: 'c6206a45-1595-40f2-84c7-1f8201dae094', BR: '93c0f681-affc-46af-af32-673596e4146f', bP: 'Kibana gives shape to any kind of data — structured and unstructured — indexed in Elasticsearch.', l6: '0d8d83a9-3633-421d-8543-e9e497822bb2', jZ: '/img/docker-image-icons/kibana.svg', w: 'kibana', zv: '474a5054-4edc-44c7-ace8-5cc7406bdafe', E_: 'create-rem-commits', aI: '8.15.2'},
		{xq: 'f39ded2c-2856-4b4e-9264-73cf0321f82e', BR: 'c02be2a2-109a-4f03-9b3c-3cee686d68f6', bP: 'The PostgreSQL object-relational database system provides reliability and data integrity.', l6: 'ff7872b6-f436-4a5c-90a5-03d8f6043c48', jZ: '/img/docker-image-icons/postgres.png', w: 'postgres', zv: '474a5054-4edc-44c7-ace8-5cc7406bdafe', E_: 'create-rem-commits', aI: '13.16'}
	]);
var $author$project$Model$BuildPlanner$BuildPlannerError$HeadOnBranchMovedError = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$BuildPlanner$BuildPlannerError$NoChangesSinceLastCommitError = function (a) {
	return {$: 4, a: a};
};
var $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe = function (maybeValue) {
	if (!maybeValue.$) {
		var value = maybeValue.a;
		return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(value);
	} else {
		return $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent;
	}
};
var $author$project$Request$BuildPlanner$convertPushCommitInput = function (input) {
	return {
		jE: A2(
			$elm$core$Maybe$withDefault,
			$dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
			A2($elm$core$Maybe$map, $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present, input.jE)),
		fY: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(
			A2($elm$core$Maybe$map, $danyx23$elm_uuid$Uuid$toString, input.xq)),
		bP: $elm$core$String$isEmpty(input.c) ? $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent : $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(input.c),
		cG: $author$project$Model$BuildPlanner$BuildExpr$encode(input.k$),
		c3: input.ix,
		fn: input.BR,
		c5: input.vT
	};
};
var $author$project$BuildPlanner$Union$PushCommitResult$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Commit', selections____.u7),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'NotFound', selections____.vp),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ParseError', selections____.vq),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ValidationError', selections____.vC),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Forbidden', selections____.vc),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'HeadOnBranchMoved', selections____.vf),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'NoChangeSinceLastCommit', selections____.vn),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInput', selections____.vj)
			]));
};
var $author$project$BuildPlanner$InputObject$encodePushCommitInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'organization',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.c3))),
				_Utils_Tuple2(
				'project',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.c5))),
				_Utils_Tuple2(
				'parentCommitId',
				$elm$core$Maybe$Just(
					A2(
						$author$project$BuildPlanner$Scalar$unwrapEncoder,
						function ($) {
							return $.oc;
						},
						$author$project$BuildPlannerScalarCodecs$codecs)(input____.fn))),
				_Utils_Tuple2(
				'expr',
				$elm$core$Maybe$Just(
					A2(
						$author$project$BuildPlanner$Scalar$unwrapEncoder,
						function ($) {
							return $.k8;
						},
						$author$project$BuildPlannerScalarCodecs$codecs)(input____.cG))),
				_Utils_Tuple2(
				'atTime',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.jE,
					A2(
						$author$project$BuildPlanner$Scalar$unwrapEncoder,
						function ($) {
							return $.BL;
						},
						$author$project$BuildPlannerScalarCodecs$codecs))),
				_Utils_Tuple2(
				'branchRef',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.fY, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'description',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bP, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))
			]));
};
var $author$project$BuildPlanner$Mutation$pushCommit = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'pushCommit',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.$7, $author$project$BuildPlanner$InputObject$encodePushCommitInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Model$BuildPlanner$Error$HeadOnBranchMovedError$Data = F3(
	function (commitID, branchID, message) {
		return {xq: branchID, BR: commitID, Eh: message};
	});
var $author$project$Model$BuildPlanner$Error$HeadOnBranchMovedError$HeadOnBranchMovedError = $elm$core$Basics$identity;
var $author$project$BuildPlanner$Object$HeadOnBranchMoved$branchId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'BuildPlannerScalarCodecs.Id',
	'branchId',
	_List_Nil,
	$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).oc.qN);
var $author$project$BuildPlanner$Object$HeadOnBranchMoved$commitId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'BuildPlannerScalarCodecs.Id',
	'commitId',
	_List_Nil,
	$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).oc.qN);
var $author$project$BuildPlanner$Object$HeadOnBranchMoved$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Model$BuildPlanner$Error$HeadOnBranchMovedError$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$elm$core$Basics$identity,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$HeadOnBranchMoved$message,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$BuildPlanner$Object$HeadOnBranchMoved$branchId,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$BuildPlanner$Object$HeadOnBranchMoved$commitId,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$Error$HeadOnBranchMovedError$Data)))));
var $author$project$Model$BuildPlanner$Error$NoChangesSinceLastCommitError$Data = F2(
	function (commitID, message) {
		return {BR: commitID, Eh: message};
	});
var $author$project$Model$BuildPlanner$Error$NoChangesSinceLastCommitError$NoChangesSinceLastCommitError = $elm$core$Basics$identity;
var $author$project$BuildPlanner$Object$NoChangeSinceLastCommit$commitId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'BuildPlannerScalarCodecs.Id',
	'commitId',
	_List_Nil,
	$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).oc.qN);
var $author$project$BuildPlanner$Object$NoChangeSinceLastCommit$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Model$BuildPlanner$Error$NoChangesSinceLastCommitError$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$elm$core$Basics$identity,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$NoChangeSinceLastCommit$message,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$BuildPlanner$Object$NoChangeSinceLastCommit$commitId,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$Error$NoChangesSinceLastCommitError$Data))));
var $author$project$Request$BuildPlanner$pushCommit = F2(
	function (creds, input) {
		var selectionSetOnCommitResult = $author$project$BuildPlanner$Union$PushCommitResult$fragments(
			{
				u7: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Result$Ok, $author$project$Model$Commit$selectionSet),
				vc: A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Model$BuildPlanner$BuildPlannerError$ForbiddenError),
					$author$project$Model$BuildPlanner$Error$ForbiddenError$selectionSet),
				vf: A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Model$BuildPlanner$BuildPlannerError$HeadOnBranchMovedError),
					$author$project$Model$BuildPlanner$Error$HeadOnBranchMovedError$selectionSet),
				vj: A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Model$BuildPlanner$BuildPlannerError$InvalidInputError),
					$author$project$Model$BuildPlanner$Error$InvalidInputError$selectionSet),
				vn: A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Model$BuildPlanner$BuildPlannerError$NoChangesSinceLastCommitError),
					$author$project$Model$BuildPlanner$Error$NoChangesSinceLastCommitError$selectionSet),
				vp: A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Model$BuildPlanner$BuildPlannerError$NotFoundError),
					$author$project$Model$BuildPlanner$Error$NotFoundError$selectionSet),
				vq: A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Model$BuildPlanner$BuildPlannerError$ParseError),
					$author$project$Model$BuildPlanner$Error$ParseError$selectionSet),
				vC: A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Model$BuildPlanner$BuildPlannerError$ValidationError),
					$author$project$Model$BuildPlanner$Error$ValidationError$selectionSet)
			});
		return $author$project$Model$BuildPlanner$BuildPlannerError$simplifyTask(
			A5(
				$author$project$GraphQL$Utils$mutationRequest,
				creds,
				4,
				_List_Nil,
				'PushCommit',
				A2(
					$author$project$BuildPlanner$Mutation$pushCommit,
					{
						$7: $author$project$Request$BuildPlanner$convertPushCommitInput(input)
					},
					selectionSetOnCommitResult)));
	});
var $author$project$Views$ImpactReport$BreakingChanges = 3;
var $author$project$Views$ImpactReport$BreakingChangesMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Views$ImpactReport$None = 0;
var $author$project$Model$Namespace$languagePrefix = $author$project$Model$Namespace$language + '/';
var $author$project$Model$Namespace$addLanguagePrefix = function (string) {
	return A2($elm$core$String$startsWith, $author$project$Model$Namespace$languagePrefix, string) ? string : _Utils_ap($author$project$Model$Namespace$languagePrefix, string);
};
var $author$project$Model$Language$toPackageNamespace = A2($elm$core$Basics$composeR, $author$project$Model$Language$toString, $author$project$Model$Namespace$addLanguagePrefix);
var $author$project$Views$ImpactReport$allowedBreakingChangeNamespaces = _List_fromArray(
	[
		$author$project$Model$Language$toPackageNamespace(1),
		$author$project$Model$Language$toPackageNamespace(0)
	]);
var $author$project$Views$ImpactReport$Added = {$: 0};
var $author$project$Views$ImpactReport$Blank = {$: 0};
var $author$project$Views$ImpactReport$ChangedFrom = function (a) {
	return {$: 2, a: a};
};
var $author$project$Views$ImpactReport$Filled = function (a) {
	return {$: 1, a: a};
};
var $author$project$Views$ImpactReport$Removed = {$: 1};
var $author$project$Views$ImpactReport$Unchanged = {$: 3};
var $author$project$Model$BuildPlanner$ImpactReport$Image = 1;
var $author$project$Views$ImpactReport$augmentKind = F2(
	function (key, kind) {
		return $author$project$Model$Namespace$isImageKey(key) ? 1 : kind;
	});
var $author$project$Views$ImpactReport$isLanguage = function (ingredient) {
	return 4 === $author$project$Model$Namespace$kindFromString(ingredient.aE);
};
var $author$project$Views$ImpactReport$separateIngredients = function (hideUnchanged) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$List$filter(
			A2($elm$core$Basics$composeR, $author$project$Views$ImpactReport$isLanguage, $elm$core$Basics$not)),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$sortBy(
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.w;
					},
					$elm$core$String$toLower)),
			A2(
				$elm$core$List$foldr,
				F2(
					function (ingredient, acc) {
						var key = $author$project$Model$Namespace$key(ingredient);
						var _v0 = _Utils_Tuple2(ingredient.xl, ingredient.w9);
						if (!_v0.a.$) {
							if (_v0.b.$ === 1) {
								var version = _v0.a.a.aI;
								var kind = _v0.a.a.mp;
								var _v3 = _v0.b;
								var _v4 = A2($author$project$Views$ImpactReport$augmentKind, key, kind);
								switch (_v4) {
									case 0:
										return _Utils_update(
											acc,
											{
												cx: A2($elm$core$List$cons, $author$project$Views$ImpactReport$Blank, acc.cx),
												cE: A2(
													$elm$core$List$cons,
													$author$project$Views$ImpactReport$Filled(
														{Y: key, L: $author$project$Views$ImpactReport$Removed, aI: version}),
													acc.cE)
											});
									case 1:
										return _Utils_update(
											acc,
											{
												cB: A2($elm$core$List$cons, $author$project$Views$ImpactReport$Blank, acc.cB),
												cD: A2(
													$elm$core$List$cons,
													$author$project$Views$ImpactReport$Filled(
														{Y: key, L: $author$project$Views$ImpactReport$Removed, aI: version}),
													acc.cD)
											});
									default:
										return _Utils_update(
											acc,
											{
												cA: A2($elm$core$List$cons, $author$project$Views$ImpactReport$Blank, acc.cA),
												cC: A2(
													$elm$core$List$cons,
													$author$project$Views$ImpactReport$Filled(
														{Y: key, L: $author$project$Views$ImpactReport$Removed, aI: version}),
													acc.cC)
											});
								}
							} else {
								var before = _v0.a.a;
								var after = _v0.b.a;
								if (_Utils_eq(before.aI, after.aI)) {
									var _v5 = _Utils_Tuple2(
										A2($author$project$Views$ImpactReport$augmentKind, key, before.mp),
										A2($author$project$Views$ImpactReport$augmentKind, key, after.mp));
									switch (_v5.a) {
										case 0:
											switch (_v5.b) {
												case 0:
													var _v6 = _v5.a;
													var _v7 = _v5.b;
													return hideUnchanged ? acc : _Utils_update(
														acc,
														{
															cx: A2(
																$elm$core$List$cons,
																$author$project$Views$ImpactReport$Filled(
																	{Y: key, L: $author$project$Views$ImpactReport$Unchanged, aI: after.aI}),
																acc.cx),
															cE: A2(
																$elm$core$List$cons,
																$author$project$Views$ImpactReport$Filled(
																	{Y: key, L: $author$project$Views$ImpactReport$Unchanged, aI: before.aI}),
																acc.cE)
														});
												case 1:
													var _v8 = _v5.a;
													var _v9 = _v5.b;
													return _Utils_update(
														acc,
														{
															cB: A2(
																$elm$core$List$cons,
																$author$project$Views$ImpactReport$Filled(
																	{Y: key, L: $author$project$Views$ImpactReport$Added, aI: after.aI}),
																acc.cB),
															cx: A2($elm$core$List$cons, $author$project$Views$ImpactReport$Blank, acc.cx),
															cD: A2($elm$core$List$cons, $author$project$Views$ImpactReport$Blank, acc.cD),
															cE: A2(
																$elm$core$List$cons,
																$author$project$Views$ImpactReport$Filled(
																	{Y: key, L: $author$project$Views$ImpactReport$Removed, aI: before.aI}),
																acc.cE)
														});
												default:
													var _v10 = _v5.a;
													var _v11 = _v5.b;
													return _Utils_update(
														acc,
														{
															cA: A2(
																$elm$core$List$cons,
																$author$project$Views$ImpactReport$Filled(
																	{Y: key, L: $author$project$Views$ImpactReport$Added, aI: after.aI}),
																acc.cA),
															cx: A2($elm$core$List$cons, $author$project$Views$ImpactReport$Blank, acc.cx),
															cC: A2($elm$core$List$cons, $author$project$Views$ImpactReport$Blank, acc.cC),
															cE: A2(
																$elm$core$List$cons,
																$author$project$Views$ImpactReport$Filled(
																	{Y: key, L: $author$project$Views$ImpactReport$Removed, aI: before.aI}),
																acc.cE)
														});
											}
										case 1:
											switch (_v5.b) {
												case 0:
													var _v12 = _v5.a;
													var _v13 = _v5.b;
													return _Utils_update(
														acc,
														{
															cB: A2($elm$core$List$cons, $author$project$Views$ImpactReport$Blank, acc.cB),
															cx: A2(
																$elm$core$List$cons,
																$author$project$Views$ImpactReport$Filled(
																	{Y: key, L: $author$project$Views$ImpactReport$Added, aI: after.aI}),
																acc.cx),
															cD: A2(
																$elm$core$List$cons,
																$author$project$Views$ImpactReport$Filled(
																	{Y: key, L: $author$project$Views$ImpactReport$Removed, aI: before.aI}),
																acc.cD),
															cE: A2($elm$core$List$cons, $author$project$Views$ImpactReport$Blank, acc.cE)
														});
												case 1:
													var _v14 = _v5.a;
													var _v15 = _v5.b;
													return hideUnchanged ? acc : _Utils_update(
														acc,
														{
															cB: A2(
																$elm$core$List$cons,
																$author$project$Views$ImpactReport$Filled(
																	{Y: key, L: $author$project$Views$ImpactReport$Unchanged, aI: after.aI}),
																acc.cB),
															cD: A2(
																$elm$core$List$cons,
																$author$project$Views$ImpactReport$Filled(
																	{Y: key, L: $author$project$Views$ImpactReport$Unchanged, aI: before.aI}),
																acc.cD)
														});
												default:
													var _v16 = _v5.a;
													var _v17 = _v5.b;
													return _Utils_update(
														acc,
														{
															cA: A2($elm$core$List$cons, $author$project$Views$ImpactReport$Blank, acc.cA),
															cB: A2(
																$elm$core$List$cons,
																$author$project$Views$ImpactReport$Filled(
																	{Y: key, L: $author$project$Views$ImpactReport$Added, aI: after.aI}),
																acc.cB),
															cC: A2(
																$elm$core$List$cons,
																$author$project$Views$ImpactReport$Filled(
																	{Y: key, L: $author$project$Views$ImpactReport$Removed, aI: before.aI}),
																acc.cC),
															cD: A2($elm$core$List$cons, $author$project$Views$ImpactReport$Blank, acc.cD)
														});
											}
										default:
											switch (_v5.b) {
												case 0:
													var _v18 = _v5.a;
													var _v19 = _v5.b;
													return _Utils_update(
														acc,
														{
															cA: A2($elm$core$List$cons, $author$project$Views$ImpactReport$Blank, acc.cA),
															cx: A2(
																$elm$core$List$cons,
																$author$project$Views$ImpactReport$Filled(
																	{Y: key, L: $author$project$Views$ImpactReport$Added, aI: after.aI}),
																acc.cx),
															cC: A2(
																$elm$core$List$cons,
																$author$project$Views$ImpactReport$Filled(
																	{Y: key, L: $author$project$Views$ImpactReport$Removed, aI: before.aI}),
																acc.cC),
															cE: A2($elm$core$List$cons, $author$project$Views$ImpactReport$Blank, acc.cE)
														});
												case 1:
													var _v20 = _v5.a;
													var _v21 = _v5.b;
													return _Utils_update(
														acc,
														{
															cA: A2($elm$core$List$cons, $author$project$Views$ImpactReport$Blank, acc.cA),
															cB: A2(
																$elm$core$List$cons,
																$author$project$Views$ImpactReport$Filled(
																	{Y: key, L: $author$project$Views$ImpactReport$Added, aI: after.aI}),
																acc.cB),
															cC: A2(
																$elm$core$List$cons,
																$author$project$Views$ImpactReport$Filled(
																	{Y: key, L: $author$project$Views$ImpactReport$Removed, aI: before.aI}),
																acc.cC),
															cD: A2($elm$core$List$cons, $author$project$Views$ImpactReport$Blank, acc.cD)
														});
												default:
													var _v22 = _v5.a;
													var _v23 = _v5.b;
													return hideUnchanged ? acc : _Utils_update(
														acc,
														{
															cA: A2(
																$elm$core$List$cons,
																$author$project$Views$ImpactReport$Filled(
																	{Y: key, L: $author$project$Views$ImpactReport$Unchanged, aI: after.aI}),
																acc.cA),
															cC: A2(
																$elm$core$List$cons,
																$author$project$Views$ImpactReport$Filled(
																	{Y: key, L: $author$project$Views$ImpactReport$Unchanged, aI: before.aI}),
																acc.cC)
														});
											}
									}
								} else {
									var _v24 = _Utils_Tuple2(
										A2($author$project$Views$ImpactReport$augmentKind, key, before.mp),
										A2($author$project$Views$ImpactReport$augmentKind, key, after.mp));
									switch (_v24.a) {
										case 0:
											switch (_v24.b) {
												case 0:
													var _v25 = _v24.a;
													var _v26 = _v24.b;
													return _Utils_update(
														acc,
														{
															cx: A2(
																$elm$core$List$cons,
																$author$project$Views$ImpactReport$Filled(
																	{
																		Y: key,
																		L: $author$project$Views$ImpactReport$ChangedFrom(before.aI),
																		aI: after.aI
																	}),
																acc.cx),
															cE: A2(
																$elm$core$List$cons,
																$author$project$Views$ImpactReport$Filled(
																	{
																		Y: key,
																		L: $author$project$Views$ImpactReport$ChangedFrom(before.aI),
																		aI: before.aI
																	}),
																acc.cE)
														});
												case 1:
													var _v27 = _v24.a;
													var _v28 = _v24.b;
													return _Utils_update(
														acc,
														{
															cB: A2(
																$elm$core$List$cons,
																$author$project$Views$ImpactReport$Filled(
																	{Y: key, L: $author$project$Views$ImpactReport$Added, aI: after.aI}),
																acc.cB),
															cx: A2($elm$core$List$cons, $author$project$Views$ImpactReport$Blank, acc.cx),
															cD: A2($elm$core$List$cons, $author$project$Views$ImpactReport$Blank, acc.cD),
															cE: A2(
																$elm$core$List$cons,
																$author$project$Views$ImpactReport$Filled(
																	{Y: key, L: $author$project$Views$ImpactReport$Removed, aI: before.aI}),
																acc.cE)
														});
												default:
													var _v29 = _v24.a;
													var _v30 = _v24.b;
													return _Utils_update(
														acc,
														{
															cA: A2(
																$elm$core$List$cons,
																$author$project$Views$ImpactReport$Filled(
																	{Y: key, L: $author$project$Views$ImpactReport$Added, aI: after.aI}),
																acc.cA),
															cx: A2($elm$core$List$cons, $author$project$Views$ImpactReport$Blank, acc.cx),
															cC: A2($elm$core$List$cons, $author$project$Views$ImpactReport$Blank, acc.cC),
															cE: A2(
																$elm$core$List$cons,
																$author$project$Views$ImpactReport$Filled(
																	{Y: key, L: $author$project$Views$ImpactReport$Removed, aI: before.aI}),
																acc.cE)
														});
											}
										case 1:
											switch (_v24.b) {
												case 0:
													var _v31 = _v24.a;
													var _v32 = _v24.b;
													return _Utils_update(
														acc,
														{
															cB: A2($elm$core$List$cons, $author$project$Views$ImpactReport$Blank, acc.cB),
															cx: A2(
																$elm$core$List$cons,
																$author$project$Views$ImpactReport$Filled(
																	{Y: key, L: $author$project$Views$ImpactReport$Added, aI: after.aI}),
																acc.cx),
															cD: A2(
																$elm$core$List$cons,
																$author$project$Views$ImpactReport$Filled(
																	{Y: key, L: $author$project$Views$ImpactReport$Removed, aI: before.aI}),
																acc.cD),
															cE: A2($elm$core$List$cons, $author$project$Views$ImpactReport$Blank, acc.cE)
														});
												case 1:
													var _v33 = _v24.a;
													var _v34 = _v24.b;
													return _Utils_update(
														acc,
														{
															cB: A2(
																$elm$core$List$cons,
																$author$project$Views$ImpactReport$Filled(
																	{
																		Y: key,
																		L: $author$project$Views$ImpactReport$ChangedFrom(before.aI),
																		aI: after.aI
																	}),
																acc.cB),
															cD: A2(
																$elm$core$List$cons,
																$author$project$Views$ImpactReport$Filled(
																	{
																		Y: key,
																		L: $author$project$Views$ImpactReport$ChangedFrom(before.aI),
																		aI: before.aI
																	}),
																acc.cD)
														});
												default:
													var _v35 = _v24.a;
													var _v36 = _v24.b;
													return _Utils_update(
														acc,
														{
															cA: A2($elm$core$List$cons, $author$project$Views$ImpactReport$Blank, acc.cA),
															cB: A2(
																$elm$core$List$cons,
																$author$project$Views$ImpactReport$Filled(
																	{Y: key, L: $author$project$Views$ImpactReport$Added, aI: after.aI}),
																acc.cB),
															cC: A2(
																$elm$core$List$cons,
																$author$project$Views$ImpactReport$Filled(
																	{Y: key, L: $author$project$Views$ImpactReport$Removed, aI: before.aI}),
																acc.cC),
															cD: A2($elm$core$List$cons, $author$project$Views$ImpactReport$Blank, acc.cD)
														});
											}
										default:
											switch (_v24.b) {
												case 0:
													var _v37 = _v24.a;
													var _v38 = _v24.b;
													return _Utils_update(
														acc,
														{
															cA: A2($elm$core$List$cons, $author$project$Views$ImpactReport$Blank, acc.cA),
															cx: A2(
																$elm$core$List$cons,
																$author$project$Views$ImpactReport$Filled(
																	{Y: key, L: $author$project$Views$ImpactReport$Added, aI: after.aI}),
																acc.cx),
															cC: A2(
																$elm$core$List$cons,
																$author$project$Views$ImpactReport$Filled(
																	{Y: key, L: $author$project$Views$ImpactReport$Removed, aI: before.aI}),
																acc.cC),
															cE: A2($elm$core$List$cons, $author$project$Views$ImpactReport$Blank, acc.cE)
														});
												case 1:
													var _v39 = _v24.a;
													var _v40 = _v24.b;
													return _Utils_update(
														acc,
														{
															cA: A2($elm$core$List$cons, $author$project$Views$ImpactReport$Blank, acc.cA),
															cB: A2(
																$elm$core$List$cons,
																$author$project$Views$ImpactReport$Filled(
																	{Y: key, L: $author$project$Views$ImpactReport$Added, aI: after.aI}),
																acc.cB),
															cC: A2(
																$elm$core$List$cons,
																$author$project$Views$ImpactReport$Filled(
																	{Y: key, L: $author$project$Views$ImpactReport$Removed, aI: before.aI}),
																acc.cC),
															cD: A2($elm$core$List$cons, $author$project$Views$ImpactReport$Blank, acc.cD)
														});
												default:
													var _v41 = _v24.a;
													var _v42 = _v24.b;
													return _Utils_update(
														acc,
														{
															cA: A2(
																$elm$core$List$cons,
																$author$project$Views$ImpactReport$Filled(
																	{
																		Y: key,
																		L: $author$project$Views$ImpactReport$ChangedFrom(before.aI),
																		aI: after.aI
																	}),
																acc.cA),
															cC: A2(
																$elm$core$List$cons,
																$author$project$Views$ImpactReport$Filled(
																	{
																		Y: key,
																		L: $author$project$Views$ImpactReport$ChangedFrom(before.aI),
																		aI: before.aI
																	}),
																acc.cC)
														});
											}
									}
								}
							}
						} else {
							if (!_v0.b.$) {
								var _v1 = _v0.a;
								var version = _v0.b.a.aI;
								var kind = _v0.b.a.mp;
								var _v2 = A2($author$project$Views$ImpactReport$augmentKind, key, kind);
								switch (_v2) {
									case 0:
										return _Utils_update(
											acc,
											{
												cx: A2(
													$elm$core$List$cons,
													$author$project$Views$ImpactReport$Filled(
														{Y: key, L: $author$project$Views$ImpactReport$Added, aI: version}),
													acc.cx),
												cE: A2($elm$core$List$cons, $author$project$Views$ImpactReport$Blank, acc.cE)
											});
									case 1:
										return _Utils_update(
											acc,
											{
												cB: A2(
													$elm$core$List$cons,
													$author$project$Views$ImpactReport$Filled(
														{Y: key, L: $author$project$Views$ImpactReport$Added, aI: version}),
													acc.cB),
												cD: A2($elm$core$List$cons, $author$project$Views$ImpactReport$Blank, acc.cD)
											});
									default:
										return _Utils_update(
											acc,
											{
												cA: A2(
													$elm$core$List$cons,
													$author$project$Views$ImpactReport$Filled(
														{Y: key, L: $author$project$Views$ImpactReport$Added, aI: version}),
													acc.cA),
												cC: A2($elm$core$List$cons, $author$project$Views$ImpactReport$Blank, acc.cC)
											});
								}
							} else {
								var _v43 = _v0.a;
								var _v44 = _v0.b;
								return acc;
							}
						}
					}),
				{cA: _List_Nil, cB: _List_Nil, cx: _List_Nil, cC: _List_Nil, cD: _List_Nil, cE: _List_Nil})));
};
var $author$project$Views$ImpactReport$changedRequestedPackages = function (_v0) {
	var impactReport = _v0.ma;
	var hideUnchanged = _v0.jX;
	return A2(
		$elm_community$dict_extra$Dict$Extra$fromListBy,
		function ($) {
			return $.Y;
		},
		A2(
			$elm$core$List$filterMap,
			function (row) {
				if (!row.$) {
					return $elm$core$Maybe$Nothing;
				} else {
					var ingredient = row.a;
					var _v2 = ingredient.L;
					if (_v2.$ === 2) {
						var oldVersion = _v2.a;
						return A2(
							$elm$core$List$member,
							$author$project$Model$Namespace$getNamespace(ingredient.Y),
							$author$project$Views$ImpactReport$allowedBreakingChangeNamespaces) ? $elm$core$Maybe$Just(
							{Y: ingredient.Y, rD: ingredient.aI, rG: oldVersion}) : $elm$core$Maybe$Nothing;
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}
			},
			A2($author$project$Views$ImpactReport$separateIngredients, hideUnchanged, impactReport.hr).cx));
};
var $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$getExact = function (constraint) {
	if (constraint.$ === 1) {
		var version = constraint.a;
		return $elm$core$Maybe$Just(version);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$BreakingChanges$init = function (args) {
	return A3(
		$elm$core$Maybe$map2,
		F2(
			function (versionCurrent, versionNew) {
				return {mw: '', jo: args.jo, pv: args.pv, st: '', pT: args.pT, nO: versionCurrent, nP: versionNew};
			}),
		$author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$getExact(args.nO),
		$author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$getExact(args.nP));
};
var $author$project$Views$ImpactReport$sortedChangedRequestedPackages = A2(
	$elm$core$Basics$composeR,
	$elm$core$Dict$values,
	$elm$core$List$sortBy(
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.Y;
			},
			$author$project$Model$Namespace$getName)));
var $author$project$Components$BreakingChanges$NoOp = {$: 2};
var $elm$browser$Browser$Dom$getViewportOf = _Browser_getViewportOf;
var $elm$browser$Browser$Dom$setViewportOf = _Browser_setViewportOf;
var $author$project$Components$BreakingChanges$statusDomId = $elm$core$Basics$always('breaking-changes-status');
var $author$project$Components$BreakingChanges$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var content = msg.a;
				var id = $author$project$Components$BreakingChanges$statusDomId(model);
				var cmd = A2(
					$elm$core$Task$attempt,
					$elm$core$Basics$always($author$project$Components$BreakingChanges$NoOp),
					A2(
						$elm$core$Task$andThen,
						function (viewport) {
							return A3($elm$browser$Browser$Dom$setViewportOf, id, 0, viewport.FT.CO);
						},
						$elm$browser$Browser$Dom$getViewportOf(id)));
				return A2(
					$author$project$Misc$with,
					cmd,
					_Utils_update(
						model,
						{st: content}));
			case 1:
				var content = msg.a;
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					_Utils_update(
						model,
						{mw: content}));
			default:
				return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
		}
	});
var $author$project$Views$ImpactReport$update = F2(
	function (msg, model) {
		var selectBreakingChange = F2(
			function (newModel, change) {
				var args = {
					jo: change.Y,
					pv: $elm$core$Maybe$Nothing,
					pT: true,
					nO: $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$Exact(change.rG),
					nP: $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$Exact(change.rD)
				};
				return _Utils_update(
					newModel,
					{
						kZ: $author$project$Components$BreakingChanges$init(args),
						ns: $elm$core$Maybe$Just(change.Y)
					});
			});
		switch (msg.$) {
			case 0:
				var tab = msg.a;
				var newModel = ((tab === 3) && _Utils_eq(model.ns, $elm$core$Maybe$Nothing)) ? A2(
					$elm$core$Maybe$withDefault,
					model,
					A2(
						$elm$core$Maybe$map,
						selectBreakingChange(model),
						$elm$core$List$head(
							$author$project$Views$ImpactReport$sortedChangedRequestedPackages(
								$author$project$Views$ImpactReport$changedRequestedPackages(model))))) : model;
				return A2(
					$author$project$Misc$with,
					0,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							newModel,
							{kB: tab})));
			case 1:
				var change = msg.a;
				return A2(
					$author$project$Misc$with,
					0,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						A2(selectBreakingChange, model, change)));
			case 2:
				var innerMsg = msg.a;
				var _v1 = model.kZ;
				if (!_v1.$) {
					var modal = _v1.a;
					var _v2 = A2($author$project$Components$BreakingChanges$update, innerMsg, modal);
					var breakingChangesModal = _v2.a;
					var cmd = _v2.b;
					return A2(
						$author$project$Misc$with,
						0,
						A2(
							$author$project$Misc$with,
							A2($elm$core$Platform$Cmd$map, $author$project$Views$ImpactReport$BreakingChangesMsg, cmd),
							_Utils_update(
								model,
								{
									kZ: $elm$core$Maybe$Just(breakingChangesModal)
								})));
				} else {
					return A2(
						$author$project$Misc$with,
						0,
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
				}
			case 3:
				return A2(
					$author$project$Misc$with,
					0,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{pP: !model.pP})));
			case 4:
				var input = msg.a;
				return A2(
					$author$project$Misc$with,
					0,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Ports$copyToClipboard(input)
								])),
						_Utils_update(
							model,
							{oi: $author$project$Model$CopyStatus$empty})));
			default:
				var hideUnchanged = msg.a;
				return A2(
					$author$project$Misc$with,
					0,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{jX: hideUnchanged})));
		}
	});
var $author$project$Analytics$InputObject$encodeBoolean_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_eq',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aW, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_gt',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aY, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_gte',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aZ, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$bool))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lt',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a0, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lte',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_neq',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a4, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)))
			]));
};
var $author$project$Analytics$InputObject$encodeTruthy_bool_exp = function (_v0) {
	var input____ = _v0;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Analytics$InputObject$encodeTruthy_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Analytics$InputObject$encodeTruthy_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Analytics$InputObject$encodeTruthy_bool_exp))),
				_Utils_Tuple2(
				'is_true',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.em, $author$project$Analytics$InputObject$encodeBoolean_comparison_exp))
			]));
};
var $author$project$Analytics$Enum$Order_by$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'asc';
		case 1:
			return 'asc_nulls_first';
		case 2:
			return 'asc_nulls_last';
		case 3:
			return 'desc';
		case 4:
			return 'desc_nulls_first';
		default:
			return 'desc_nulls_last';
	}
};
var $author$project$Analytics$InputObject$encodeTruthy_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'is_true',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.em,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString)))
			]));
};
var $author$project$Analytics$Scalar$Float8 = $elm$core$Basics$identity;
var $author$project$Analytics$Scalar$License_restriction_types = $elm$core$Basics$identity;
var $author$project$Analytics$Scalar$Text_ = $elm$core$Basics$identity;
var $author$project$Analytics$Scalar$Timestamp = $elm$core$Basics$identity;
var $author$project$Analytics$Scalar$defaultCodecs = {
	fL: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v0) {
			var raw = _v0;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	ih: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v1) {
			var raw = _v1;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	BP: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v2) {
			var raw = _v2;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	bC: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v3) {
			var raw = _v3;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	aq: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v4) {
			var raw = _v4;
			return $elm$json$Json$Encode$string(raw);
		}
	}
};
var $author$project$Analytics$Scalar$Codecs = $elm$core$Basics$identity;
var $author$project$Analytics$Scalar$defineCodecs = function (definitions) {
	return definitions;
};
var $author$project$Analytics$ScalarCodecs$codecs = $author$project$Analytics$Scalar$defineCodecs(
	{fL: $author$project$Analytics$Scalar$defaultCodecs.fL, ih: $author$project$Analytics$Scalar$defaultCodecs.ih, BP: $author$project$Analytics$Scalar$defaultCodecs.BP, bC: $author$project$Analytics$Scalar$defaultCodecs.bC, aq: $author$project$Analytics$Scalar$defaultCodecs.aq});
var $author$project$Analytics$Scalar$unwrapEncoder = F2(
	function (getter, _v0) {
		var unwrappedCodecs = _v0;
		return A2(
			$elm$core$Basics$composeR,
			getter(unwrappedCodecs).lN,
			$dillonkearns$elm_graphql$Graphql$Internal$Encode$fromJson);
	});
var $author$project$Analytics$InputObject$encodeUpdate_remediation_cube_args = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'dest_branch_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.f4,
					A2(
						$author$project$Analytics$Scalar$unwrapEncoder,
						function ($) {
							return $.aq;
						},
						$author$project$Analytics$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'dest_commit_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ly,
					A2(
						$author$project$Analytics$Scalar$unwrapEncoder,
						function ($) {
							return $.aq;
						},
						$author$project$Analytics$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'dest_org_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.f5,
					A2(
						$author$project$Analytics$Scalar$unwrapEncoder,
						function ($) {
							return $.aq;
						},
						$author$project$Analytics$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'dest_org_name',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f6, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'dest_project_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.f7,
					A2(
						$author$project$Analytics$Scalar$unwrapEncoder,
						function ($) {
							return $.aq;
						},
						$author$project$Analytics$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'src_branch_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.gF,
					A2(
						$author$project$Analytics$Scalar$unwrapEncoder,
						function ($) {
							return $.aq;
						},
						$author$project$Analytics$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'src_commit_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.nz,
					A2(
						$author$project$Analytics$Scalar$unwrapEncoder,
						function ($) {
							return $.aq;
						},
						$author$project$Analytics$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'src_org_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.gG,
					A2(
						$author$project$Analytics$Scalar$unwrapEncoder,
						function ($) {
							return $.aq;
						},
						$author$project$Analytics$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'src_project_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.gH,
					A2(
						$author$project$Analytics$Scalar$unwrapEncoder,
						function ($) {
							return $.aq;
						},
						$author$project$Analytics$ScalarCodecs$codecs)))
			]));
};
var $author$project$Analytics$Enum$Truthy_select_column$toString = function (enum____) {
	return 'is_true';
};
var $author$project$Analytics$Query$update_remediation_cube = F3(
	function (fillInOptionals____, requiredArgs____, object____) {
		var filledInOptionals____ = fillInOptionals____(
			{tE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ux: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, uR: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, vE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ao: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs____ = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'distinct_on',
					filledInOptionals____.tE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Truthy_select_column$toString))),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'limit', filledInOptionals____.ux, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'offset', filledInOptionals____.uR, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'order_by',
					filledInOptionals____.vE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Analytics$InputObject$encodeTruthy_order_by)),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'where', filledInOptionals____.ao, $author$project$Analytics$InputObject$encodeTruthy_bool_exp)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'update_remediation_cube',
			_Utils_ap(
				optionalArgs____,
				_List_fromArray(
					[
						A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'args', requiredArgs____.kO, $author$project$Analytics$InputObject$encodeUpdate_remediation_cube_args)
					])),
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
	});
var $author$project$Pages$OrgRemediation$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var tuples = msg.a.a;
					var buildPlans = $elm$core$Dict$fromList(
						A2(
							$elm$core$List$filterMap,
							function (_v1) {
								var projectName = _v1.a;
								var buildPlan = _v1.b;
								var images = $author$project$Model$BuildPlanner$BuildPlan$images(buildPlan);
								return $elm$core$List$isEmpty(images) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
									_Utils_Tuple2(
										projectName,
										{xt: buildPlan, l8: images}));
							},
							tuples));
					var getImageIngredients = A2(
						$elm$core$Task$attempt,
						$author$project$Pages$OrgRemediation$OnIngredients,
						A3(
							$author$project$Request$AvailableVersions$getAvailableVersionsForList,
							$author$project$Model$Session$getCreds(session),
							model.pq,
							A2(
								$elm$core$List$map,
								function ($) {
									return $.Y;
								},
								A2(
									$elm$core$List$concatMap,
									function ($) {
										return $.l8;
									},
									$elm$core$Dict$values(buildPlans)))));
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							getImageIngredients,
							_Utils_update(
								model,
								{jI: buildPlans, fC: 1})));
				} else {
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$textWarning('Failed to load build plans')),
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{fC: 4})));
				}
			case 1:
				if (!msg.a.$) {
					var ingredientDict = msg.a.a;
					var replacements = A2($author$project$Pages$OrgRemediation$findReplaceImages, model.jI, ingredientDict);
					var remediatedBuildExprEditorsTask = $elm$core$Task$sequence(
						A2(
							$elm$core$List$filterMap,
							function (_v2) {
								var project = _v2.a;
								var commitID = _v2.b;
								return A2(
									$elm$core$Maybe$map,
									function (replaceImages) {
										return A2(
											$elm$core$Task$map,
											function (buildExpr) {
												return {
													k$: buildExpr,
													c5: _Utils_Tuple2(project, commitID),
													v_: replaceImages
												};
											},
											A2(
												$author$project$Request$BuildPlanner$getBuildExpr,
												session,
												{
													BR: commitID,
													ix: $author$project$Model$Organization$getUrlName(model.c3),
													vT: $author$project$Model$Project$getName(project)
												}));
									},
									A2(
										$elm$core$Dict$get,
										$author$project$Model$Project$getName(project),
										replacements));
							},
							model.qi));
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							A2($elm$core$Task$attempt, $author$project$Pages$OrgRemediation$OnBuildExprs, remediatedBuildExprEditorsTask),
							_Utils_update(
								model,
								{ug: ingredientDict, fC: 2})));
				} else {
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$textWarning('Failed to load ingredients')),
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{fC: 4})));
				}
			case 2:
				if (!msg.a.$) {
					var projectBundles = msg.a.a;
					var projectExprs = A2(
						$elm$core$List$filterMap,
						function (_v5) {
							var project = _v5.c5;
							var replaceImages = _v5.v_;
							var buildExpr = _v5.k$;
							var _v6 = $author$project$Model$BuildPlanner$BuildExprEditor$Simple$fromBuildExpr(buildExpr);
							if (_v6.$ === 1) {
								return $elm$core$Maybe$Nothing;
							} else {
								var editor = _v6.a;
								var remediatedBuildExprEditor = A3($elm$core$List$foldl, $author$project$Model$BuildPlanner$SolveLegacyEditor$addReplaceImage, editor, replaceImages);
								return $elm$core$Maybe$Just(
									_Utils_Tuple2(project, remediatedBuildExprEditor));
							}
						},
						projectBundles);
					var creds = $author$project$Model$Session$getCreds(session);
					var impactReportsTask = $elm$core$Task$sequence(
						A2(
							$elm$core$List$map,
							function (_v3) {
								var _v4 = _v3.a;
								var project = _v4.a;
								var commitID = _v4.b;
								var remediatedBuildExprEditor = _v3.b;
								var input = function (spec) {
									return {
										c3: $author$project$Model$Organization$getUrlName(model.c3),
										c5: $author$project$Model$Project$getName(project),
										Gc: spec
									};
								};
								var before = $author$project$Request$BuildPlanner$CommitID(commitID);
								var after = $author$project$Request$BuildPlanner$BuildExpr(
									{
										jE: model.pq,
										k$: $author$project$Model$BuildPlanner$BuildExprEditor$Simple$toBuildExpr(remediatedBuildExprEditor)
									});
								return A2(
									$elm$core$Task$map,
									function (report) {
										return {
											BR: commitID,
											ma: $author$project$Views$ImpactReport$init(
												{
													BT: $elm$core$Maybe$Nothing,
													t0: '',
													ma: report,
													c3: model.c3,
													vT: $author$project$Model$Project$getName(project),
													FQ: $elm$core$Maybe$Nothing,
													F7: true
												}),
											c5: project,
											vZ: remediatedBuildExprEditor
										};
									},
									A3(
										$author$project$Request$BuildPlanner$getImpactReport,
										creds,
										input(before),
										input(after)));
							},
							projectExprs));
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							A2($elm$core$Task$attempt, $author$project$Pages$OrgRemediation$OnImpactReports, impactReportsTask),
							_Utils_update(
								model,
								{fC: 3})));
				} else {
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$textWarning('Failed to load build exprs')),
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{fC: 4})));
				}
			case 3:
				if (!msg.a.$) {
					var remediations = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{
									h_: $elm$core$List$head(remediations),
									fC: 4,
									ne: remediations
								})));
				} else {
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$textWarning('Failed to load impact reports')),
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{fC: 4})));
				}
			case 4:
				var remediation = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								h_: $elm$core$Maybe$Just(remediation)
							})));
			case 5:
				var remediation = msg.a;
				var projectName = $author$project$Model$Project$getName(remediation.c5);
				var maybeUpstreamProject = A2(
					$elm_community$list_extra$List$Extra$find,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.w;
						},
						$elm$core$Basics$eq(projectName)),
					$author$project$Pages$OrgRemediation$panoramaRemediation);
				if (!maybeUpstreamProject.$) {
					var p = maybeUpstreamProject.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							A2(
								$elm$core$Task$attempt,
								A2($author$project$Pages$OrgRemediation$OnPushCommitResult, p, remediation.c5),
								A2(
									$author$project$Request$BuildPlanner$pushCommit,
									$author$project$Model$Session$getCreds(session),
									{
										jE: A2(
											$elm$core$Maybe$map,
											$author$project$Model$AtTime$Timestamp,
											$elm$core$Maybe$Just(model.pq)),
										xq: $elm$core$Maybe$Nothing,
										k$: $author$project$Model$BuildPlanner$BuildExprEditor$Simple$toBuildExpr(remediation.vZ),
										c: 'Applying remediation plan',
										BR: remediation.BR,
										ix: $author$project$Model$Organization$getUrlName(model.c3),
										vT: projectName
									})),
							_Utils_update(
								model,
								{
									fI: A3($elm$core$Dict$insert, projectName, $krisajenkins$remotedata$RemoteData$Loading, model.fI)
								})));
				} else {
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$textWarning('Missing remediate project ' + projectName)),
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{
									fI: A3(
										$elm$core$Dict$insert,
										projectName,
										$krisajenkins$remotedata$RemoteData$Failure(
											$author$project$Model$BuildPlanner$BuildPlannerError$HttpError(
												{
													mp: $author$project$Http$Extra$BadPayload('Missing remediate project ' + projectName),
													GT: 'nada'
												})),
										model.fI)
								})));
				}
			case 6:
				if (!msg.c.$) {
					var upstreamProject = msg.a;
					var project = msg.b;
					var commit = msg.c.a;
					var updateCube = A2(
						$elm$core$Task$attempt,
						A2($author$project$Pages$OrgRemediation$OnUpdateAnalyticsResult, project, commit),
						A5(
							$author$project$GraphQL$Utils$queryRequest,
							$author$project$Model$Session$getCreds(session),
							2,
							_List_Nil,
							'UpdateRemediationCube',
							A3(
								$author$project$Analytics$Query$update_remediation_cube,
								$elm$core$Basics$identity,
								{
									kO: {
										f4: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
											A2(
												$elm$core$Basics$composeR,
												$author$project$Model$Project$getDefaultBranch,
												A2($elm$core$Basics$composeR, $author$project$Model$Branch$getID, $danyx23$elm_uuid$Uuid$toString))(project)),
										ly: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
											A3(
												$elm$core$Basics$composeR,
												$danyx23$elm_uuid$Uuid$toString,
												$elm$core$Basics$identity,
												$author$project$Model$Commit$getCommitID(commit))),
										f5: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
											A2($elm$core$Basics$composeR, $author$project$Model$Project$getOrganizationId, $danyx23$elm_uuid$Uuid$toString)(project)),
										f6: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
											$author$project$Model$Organization$getUrlName(model.c3)),
										f7: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
											A2($elm$core$Basics$composeR, $author$project$Model$Project$id, $danyx23$elm_uuid$Uuid$toString)(project)),
										gF: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(upstreamProject.xq),
										nz: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(upstreamProject.BR),
										gG: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(upstreamProject.zv),
										gH: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(upstreamProject.l6)
									}
								},
								$author$project$Analytics$Object$Truthy$is_true)));
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2($author$project$Misc$with, updateCube, model));
				} else {
					var project = msg.b;
					var err = msg.c.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$textWarning(
								'Failed to remediate project ' + $author$project$Model$Project$getName(project))),
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{
									fI: A3(
										$elm$core$Dict$insert,
										$author$project$Model$Project$getName(project),
										$krisajenkins$remotedata$RemoteData$Failure(err),
										model.fI)
								})));
				}
			case 7:
				if (!msg.c.$) {
					var project = msg.a;
					var commit = msg.b;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{
									fI: A3(
										$elm$core$Dict$insert,
										$author$project$Model$Project$getName(project),
										$krisajenkins$remotedata$RemoteData$Success(commit),
										model.fI)
								})));
				} else {
					var project = msg.a;
					var err = msg.c.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$textWarning(
								'Failed to remediate project ' + $author$project$Model$Project$getName(project))),
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{
									fI: A3(
										$elm$core$Dict$insert,
										$author$project$Model$Project$getName(project),
										$krisajenkins$remotedata$RemoteData$Failure(
											$author$project$Model$BuildPlanner$BuildPlannerError$HttpError(err)),
										model.fI)
								})));
				}
			default:
				var innerMsg = msg.a;
				var _v8 = model.h_;
				if (!_v8.$) {
					var remediation = _v8.a;
					var _v9 = A2($author$project$Views$ImpactReport$update, innerMsg, remediation.ma);
					var _v10 = _v9.a;
					var innerModel = _v10.a;
					var cmd = _v10.b;
					var newRemediation = _Utils_update(
						remediation,
						{ma: innerModel});
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$OrgRemediation$ImpactReportMsg, cmd),
							_Utils_update(
								model,
								{
									h_: $elm$core$Maybe$Just(newRemediation)
								})));
				} else {
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
				}
		}
	});
var $author$project$Pages$OrgScan$update = F3(
	function (_v0, action, model) {
		if (!action.$) {
			var input = action.a;
			return A2(
				$author$project$Misc$with,
				$author$project$External$NoOp,
				A2(
					$author$project$Misc$with,
					$author$project$Ports$copyToClipboard(input),
					_Utils_update(
						model,
						{oi: $author$project$Model$CopyStatus$empty})));
		} else {
			var portCopyStatus = action.a;
			return A2(
				$author$project$Misc$with,
				$author$project$External$NoOp,
				A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					_Utils_update(
						model,
						{oi: portCopyStatus})));
		}
	});
var $author$project$Pages$OrgSecurity$Ascending = 0;
var $author$project$Pages$OrgSecurity$Descending = 1;
var $author$project$Pages$OrgSecurity$Failure = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$OrgSecurity$Success = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$OrgSecurity$SeverityCritical = 0;
var $author$project$Pages$OrgSecurity$SeverityFlag = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$OrgSecurity$SeverityHigh = 1;
var $author$project$Pages$OrgSecurity$SeverityLow = 3;
var $author$project$Pages$OrgSecurity$SeverityMedium = 2;
var $author$project$Pages$OrgSecurity$SeverityUnscored = 4;
var $author$project$Pages$OrgSecurity$VisibilityPrivate = {$: 2};
var $author$project$Pages$OrgSecurity$VisibilityPublic = {$: 1};
var $author$project$Pages$OrgSecurity$allFlagTypes = _List_fromArray(
	[
		$author$project$Pages$OrgSecurity$SeverityFlag(0),
		$author$project$Pages$OrgSecurity$SeverityFlag(1),
		$author$project$Pages$OrgSecurity$SeverityFlag(2),
		$author$project$Pages$OrgSecurity$SeverityFlag(3),
		$author$project$Pages$OrgSecurity$SeverityFlag(4),
		$author$project$Pages$OrgSecurity$VisibilityPrivate,
		$author$project$Pages$OrgSecurity$VisibilityPublic
	]);
var $author$project$Pages$OrgSecurity$getFlagBit = function (flagName) {
	switch (flagName.$) {
		case 0:
			var sevFlag = flagName.a;
			switch (sevFlag) {
				case 0:
					return A2($elm$core$Basics$pow, 2, 0);
				case 1:
					return A2($elm$core$Basics$pow, 2, 1);
				case 2:
					return A2($elm$core$Basics$pow, 2, 2);
				case 3:
					return A2($elm$core$Basics$pow, 2, 3);
				default:
					return A2($elm$core$Basics$pow, 2, 4);
			}
		case 1:
			return A2($elm$core$Basics$pow, 2, 5);
		default:
			return A2($elm$core$Basics$pow, 2, 6);
	}
};
var $author$project$Pages$OrgSecurity$allFilters = A3(
	$elm$core$List$foldl,
	F2(
		function (bit, acc) {
			return A2(
				$elm$core$Basics$composeR,
				$author$project$Pages$OrgSecurity$getFlagBit,
				$elm$core$Bitwise$or(acc))(bit);
		}),
	0,
	$author$project$Pages$OrgSecurity$allFlagTypes);
var $author$project$Pages$OrgSecurity$defaultSortDireciton = 0;
var $author$project$Uuid$Dict$UuidDict = $elm$core$Basics$identity;
var $author$project$Uuid$Dict$fromList = function (uuids) {
	return $elm$core$Dict$fromList(
		A2(
			$elm$core$List$map,
			$elm$core$Tuple$mapFirst($danyx23$elm_uuid$Uuid$toString),
			uuids));
};
var $author$project$Model$OrgSecurityProject$fromProject = function (p) {
	return {
		w: $author$project$Model$Project$getName(p),
		cd: $author$project$Model$Project$getIsPrivate(p),
		zK: $author$project$Model$Project$id(p)
	};
};
var $author$project$Pages$OrgSecurity$flagToSeverity = function (s) {
	switch (s) {
		case 0:
			return 4;
		case 1:
			return 3;
		case 2:
			return 2;
		case 3:
			return 1;
		default:
			return 0;
	}
};
var $author$project$Uuid$Dict$get = F2(
	function (uuid, _v0) {
		var dict = _v0;
		return A2(
			$elm$core$Dict$get,
			$danyx23$elm_uuid$Uuid$toString(uuid),
			dict);
	});
var $author$project$Pages$OrgSecurity$isFlagSet = F2(
	function (currentFilter, flagName) {
		var flagV = $author$project$Pages$OrgSecurity$getFlagBit(flagName);
		return _Utils_eq(currentFilter & flagV, flagV);
	});
var $author$project$Model$OrgSecurityRow$packageNames = function (row) {
	return A2(
		$elm$core$List$concatMap,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Tuple$second,
			$elm$core$List$map(
				function ($) {
					return $.w;
				})),
		row.hJ);
};
var $author$project$Model$OrgSecurityRow$projectIDs = function (row) {
	return A2($elm$core$List$map, $elm$core$Tuple$first, row.hJ);
};
var $author$project$Model$OrgSecurityRow$projectNames = F2(
	function (projects, projectIds) {
		return A2(
			$elm$core$List$sortBy,
			$elm$core$String$toLower,
			A2(
				$elm$core$List$filterMap,
				function (id) {
					return A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.w;
						},
						A2($author$project$Uuid$Dict$get, id, projects));
				},
				projectIds));
	});
var $author$project$Pages$OrgSecurity$rowContains = F3(
	function (projects, search, row) {
		return (search === '') || function () {
			var lowerSearch = $elm$core$String$toLower(search);
			var contains = function (haystack) {
				return A2(
					$elm$core$String$contains,
					lowerSearch,
					$elm$core$String$toLower(haystack));
			};
			return contains(row.B9) || (contains(
				$author$project$Model$Severity$toString(row.ck)) || (contains(row.bP) || (A2(
				$elm$core$List$any,
				contains,
				$author$project$Model$OrgSecurityRow$packageNames(row)) || A2(
				$elm$core$List$any,
				contains,
				A2(
					$author$project$Model$OrgSecurityRow$projectNames,
					projects,
					$author$project$Model$OrgSecurityRow$projectIDs(row))))));
		}();
	});
var $author$project$Pages$OrgSecurity$isSeverityFlag = function (flagName) {
	if (!flagName.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pages$OrgSecurity$severityFlagTypes = A2($elm$core$List$filter, $author$project$Pages$OrgSecurity$isSeverityFlag, $author$project$Pages$OrgSecurity$allFlagTypes);
var $author$project$Pages$OrgSecurity$sortByName = function (row) {
	return row.B9;
};
var $author$project$Pages$OrgSecurity$withLengthFirst = function (list) {
	return _Utils_Tuple2(
		$elm$core$List$length(list),
		list);
};
var $author$project$Pages$OrgSecurity$sortByProjectsAffected = F2(
	function (projects, row) {
		return $author$project$Pages$OrgSecurity$withLengthFirst(
			A2(
				$elm$core$List$map,
				$elm$core$String$toLower,
				A2(
					$author$project$Model$OrgSecurityRow$projectNames,
					projects,
					$author$project$Model$OrgSecurityRow$projectIDs(row))));
	});
var $author$project$Pages$OrgSecurity$sortBySeverity = function (row) {
	return $author$project$Model$Severity$sortKey(row.ck);
};
var $author$project$Pages$OrgSecurity$currentRows = F2(
	function (model, cveData) {
		var sortBy = function () {
			var _v4 = model.ny;
			if (!_v4) {
				return $elm$core$List$sortBy;
			} else {
				return function (extract) {
					return $elm$core$List$sortWith(
						F2(
							function (a, b) {
								return $author$project$Misc$reverseOrder(
									A2(
										$elm$core$Basics$compare,
										extract(a),
										extract(b)));
							}));
				};
			}
		}();
		var filteredRows = A2(
			$elm$core$List$filter,
			A2($author$project$Pages$OrgSecurity$rowContains, cveData.ko, model.kt),
			A2(
				$elm$core$List$filterMap,
				function (row) {
					var publicAllowed = A2($author$project$Pages$OrgSecurity$isFlagSet, model.cT, $author$project$Pages$OrgSecurity$VisibilityPublic);
					var privateAllowed = A2($author$project$Pages$OrgSecurity$isFlagSet, model.cT, $author$project$Pages$OrgSecurity$VisibilityPrivate);
					var packagesByProjectId = A2(
						$elm$core$List$filter,
						function (_v2) {
							var id = _v2.a;
							return A2(
								$elm$core$Maybe$withDefault,
								true,
								A2(
									$elm$core$Maybe$map,
									function (_v3) {
										var _private = _v3.cd;
										return (publicAllowed && (!_private)) || (privateAllowed && _private);
									},
									A2($author$project$Uuid$Dict$get, id, cveData.ko)));
						},
						row.hJ);
					return ($elm$core$List$length(packagesByProjectId) > 0) ? $elm$core$Maybe$Just(
						_Utils_update(
							row,
							{hJ: packagesByProjectId})) : $elm$core$Maybe$Nothing;
				},
				A2(
					$elm$core$List$filter,
					function (row) {
						var alowedBySeverity = A2(
							$elm$core$List$any,
							function (flag) {
								if (!flag.$) {
									var f = flag.a;
									return A2($author$project$Pages$OrgSecurity$isFlagSet, model.cT, flag) && _Utils_eq(
										row.ck,
										$author$project$Pages$OrgSecurity$flagToSeverity(f));
								} else {
									return false;
								}
							},
							$author$project$Pages$OrgSecurity$severityFlagTypes);
						return alowedBySeverity;
					},
					cveData.sc)));
		var _v0 = model.nx;
		switch (_v0) {
			case 0:
				return A2(sortBy, $author$project$Pages$OrgSecurity$sortBySeverity, filteredRows);
			case 1:
				return A2(sortBy, $author$project$Pages$OrgSecurity$sortByName, filteredRows);
			default:
				return A2(
					sortBy,
					$author$project$Pages$OrgSecurity$sortByProjectsAffected(cveData.ko),
					filteredRows);
		}
	});
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $BrianHicks$elm_csv$Csv$Encode$encodeItems = F2(
	function (encoder, rows) {
		if (!encoder.$) {
			var convert = encoder.a;
			var _v1 = A3(
				$elm$core$List$foldr,
				F2(
					function (row, _v2) {
						var converted_ = _v2.a;
						var names = _v2.b;
						var convertedRow = convert(row);
						return _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								$elm$core$Dict$fromList(convertedRow),
								converted_),
							A3(
								$elm$core$List$foldl,
								F2(
									function (_v3, _v4) {
										var name = _v3.a;
										var soFar = _v4.a;
										var column = _v4.b;
										return _Utils_Tuple2(
											A3(
												$elm$core$Dict$update,
												name,
												function (value) {
													if (!value.$) {
														var columns = value.a;
														return $elm$core$Maybe$Just(
															A2($elm$core$List$cons, column, columns));
													} else {
														return $elm$core$Maybe$Just(
															_List_fromArray(
																[column]));
													}
												},
												soFar),
											column + 1);
									}),
								_Utils_Tuple2(names, 0),
								convertedRow).a);
					}),
				_Utils_Tuple2(_List_Nil, $elm$core$Dict$empty),
				rows);
			var converted = _v1.a;
			var namePositions = _v1.b;
			var ordering = A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2(
					$elm$core$List$sortBy,
					$elm$core$Tuple$second,
					$elm$core$Dict$toList(
						A2(
							$elm$core$Dict$map,
							F2(
								function (_v6, positions) {
									return $elm$core$List$sum(positions) / $elm$core$List$length(positions);
								}),
							namePositions))));
			return A2(
				$elm$core$List$cons,
				ordering,
				A2(
					$elm$core$List$map,
					function (row) {
						return A2(
							$elm$core$List$map,
							function (field) {
								return A2(
									$elm$core$Maybe$withDefault,
									'',
									A2($elm$core$Dict$get, field, row));
							},
							ordering);
					},
					converted));
		} else {
			var convert = encoder.a;
			return A2($elm$core$List$map, convert, rows);
		}
	});
var $BrianHicks$elm_csv$Csv$Encode$quoteIfNecessary = F2(
	function (fieldSeparator, value) {
		return (A2($elm$core$String$contains, '\"', value) || (A2($elm$core$String$contains, fieldSeparator, value) || (A2($elm$core$String$contains, '\u000D\n', value) || A2($elm$core$String$contains, '\n', value)))) ? ('\"' + (A3($elm$core$String$replace, '\"', '\"\"', value) + '\"')) : value;
	});
var $BrianHicks$elm_csv$Csv$Encode$encode = F2(
	function (_v0, items) {
		var encoder = _v0.lN;
		var fieldSeparator = _v0.CE;
		var fieldSeparatorString = $elm$core$String$fromChar(fieldSeparator);
		return A2(
			$elm$core$String$join,
			'\u000D\n',
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeL,
					$elm$core$String$join(fieldSeparatorString),
					$elm$core$List$map(
						$BrianHicks$elm_csv$Csv$Encode$quoteIfNecessary(fieldSeparatorString))),
				A2($BrianHicks$elm_csv$Csv$Encode$encodeItems, encoder, items)));
	});
var $author$project$Model$OrgSecurityRow$toSingleCombinationRows = function (projects) {
	return $elm$core$List$concatMap(
		function (row) {
			return A2(
				$elm$core$List$concatMap,
				function (_v1) {
					var project = _v1.a;
					var pkgNames = _v1.b;
					return A2(
						$elm$core$List$map,
						function (packageName) {
							return _Utils_Tuple3(row, project, packageName);
						},
						pkgNames);
				},
				A2(
					$elm$core$List$filterMap,
					function (_v0) {
						var id = _v0.a;
						var pkgNames = _v0.b;
						return A2(
							$elm$core$Maybe$map,
							function (project) {
								return _Utils_Tuple2(project, pkgNames);
							},
							A2($author$project$Uuid$Dict$get, id, projects));
					},
					row.hJ));
		});
};
var $BrianHicks$elm_csv$Csv$Encode$WithFieldNames = function (a) {
	return {$: 0, a: a};
};
var $BrianHicks$elm_csv$Csv$Encode$withFieldNames = $BrianHicks$elm_csv$Csv$Encode$WithFieldNames;
var $author$project$Pages$OrgSecurity$generateReportCSV = F2(
	function (model, unfilteredData) {
		var projects = unfilteredData.ko;
		var encoderStep = function (_v0) {
			var row = _v0.a;
			var project = _v0.b;
			var _package = _v0.c;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'Severity',
					$elm_community$string_extra$String$Extra$toTitleCase(
						$author$project$Model$Severity$toString(row.ck))),
					_Utils_Tuple2('Name', row.B9),
					_Utils_Tuple2('Project Name', project.w),
					_Utils_Tuple2(
					'Is Project Private',
					project.cd ? 'true' : 'false'),
					_Utils_Tuple2('Package Name', _package.w)
				]);
		};
		var dataRows = A2(
			$author$project$Model$OrgSecurityRow$toSingleCombinationRows,
			projects,
			A2($author$project$Pages$OrgSecurity$currentRows, model, unfilteredData));
		return A2(
			$BrianHicks$elm_csv$Csv$Encode$encode,
			{
				lN: $BrianHicks$elm_csv$Csv$Encode$withFieldNames(encoderStep),
				CE: ','
			},
			dataRows);
	});
var $author$project$Model$OrgSecurityRow$instanceFromVulnerability = F4(
	function (projectID, purl, version, vulnMatch) {
		var vuln = vulnMatch.gY;
		return {B9: vuln.B9, bP: vuln.bP, vL: purl, vM: version, zK: projectID, ck: vuln.ck, o: vuln.o, G0: vulnMatch.G0, G1: vulnMatch.G1, G2: vulnMatch.G2, G3: vulnMatch.G3};
	});
var $author$project$Model$Analytics$Fact$Dependencies$projectID = function (_v0) {
	var data = _v0;
	return data.zK;
};
var $author$project$Ports$promptToDownload = _Platform_outgoingPort(
	'promptToDownload',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'mediaType',
					$elm$json$Json$Encode$string($.rw)),
					_Utils_Tuple2(
					'payload',
					$elm$json$Json$Encode$string($.vQ)),
					_Utils_Tuple2(
					'suggestedFilename',
					function ($) {
						return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, $);
					}($.sx))
				]));
	});
var $author$project$Pages$OrgSecurity$severityToFlag = function (s) {
	switch (s) {
		case 4:
			return 0;
		case 3:
			return 1;
		case 2:
			return 2;
		case 1:
			return 3;
		default:
			return 4;
	}
};
var $author$project$Pages$OrgSecurity$toggleFilter = F2(
	function (currentFilter, flagName) {
		return currentFilter ^ $author$project$Pages$OrgSecurity$getFlagBit(flagName);
	});
var $author$project$Pages$OrgSecurity$allSeverityFilters = A3(
	$elm$core$List$foldl,
	F2(
		function (bit, acc) {
			return A2(
				$elm$core$Basics$composeR,
				$author$project$Pages$OrgSecurity$getFlagBit,
				$elm$core$Bitwise$or(acc))(bit);
		}),
	0,
	$author$project$Pages$OrgSecurity$severityFlagTypes);
var $author$project$Pages$OrgSecurity$toggleSingleSeverity = F2(
	function (currentFilter, flag) {
		var otherSeverityFlagBits = function (flagName) {
			return A2(
				$elm$core$List$filter,
				function (i) {
					if (!i.$) {
						var a = i.a;
						return !_Utils_eq(a, flagName);
					} else {
						return false;
					}
				},
				$author$project$Pages$OrgSecurity$allFlagTypes);
		};
		var nonSeverityFilters = $author$project$Pages$OrgSecurity$getFlagBit($author$project$Pages$OrgSecurity$VisibilityPrivate) | $author$project$Pages$OrgSecurity$getFlagBit($author$project$Pages$OrgSecurity$VisibilityPublic);
		var flagFilter = $author$project$Pages$OrgSecurity$getFlagBit(
			$author$project$Pages$OrgSecurity$SeverityFlag(flag));
		var anyOtherSevSet = A2(
			$elm$core$List$any,
			function (i) {
				return A2($author$project$Pages$OrgSecurity$isFlagSet, currentFilter, i);
			},
			otherSeverityFlagBits(flag));
		var newFilter = (!anyOtherSevSet) ? (currentFilter | $author$project$Pages$OrgSecurity$allSeverityFilters) : (flagFilter | (nonSeverityFilters & currentFilter));
		return newFilter;
	});
var $author$project$Uuid$Dict$empty = $elm$core$Dict$empty;
var $author$project$Uuid$Dict$insert = F3(
	function (uuid, value, _v0) {
		var dict = _v0;
		return A3(
			$elm$core$Dict$insert,
			$danyx23$elm_uuid$Uuid$toString(uuid),
			value,
			dict);
	});
var $author$project$Uuid$Dict$singleton = F2(
	function (uuid, value) {
		return A3($author$project$Uuid$Dict$insert, uuid, value, $author$project$Uuid$Dict$empty);
	});
var $author$project$Uuid$Dict$toList = function (_v0) {
	var dict = _v0;
	return A2(
		$elm$core$List$filterMap,
		function (_v1) {
			var key = _v1.a;
			var payload = _v1.b;
			return A2(
				$elm$core$Maybe$map,
				function (id) {
					return _Utils_Tuple2(id, payload);
				},
				$danyx23$elm_uuid$Uuid$fromString(key));
		},
		$elm$core$Dict$toList(dict));
};
var $author$project$Misc$tripleDropFirst = function (_v0) {
	var x = _v0.b;
	var y = _v0.c;
	return _Utils_Tuple2(x, y);
};
var $author$project$Misc$tripleSecond = function (_v0) {
	var y = _v0.b;
	return y;
};
var $elm_community$list_extra$List$Extra$uniqueBy = F2(
	function (f, list) {
		return A4($elm_community$list_extra$List$Extra$uniqueHelp, f, _List_Nil, list, _List_Nil);
	});
var $author$project$Uuid$Dict$update = F3(
	function (uuid, step, _v0) {
		var dict = _v0;
		return A3(
			$elm$core$Dict$update,
			$danyx23$elm_uuid$Uuid$toString(uuid),
			step,
			dict);
	});
var $author$project$Model$OrgSecurityRow$vulnPackageFromInstance = function (vuln) {
	return {w: vuln.vL, aI: vuln.vM, G0: vuln.G0, G1: vuln.G1, G2: vuln.G2, G3: vuln.G3};
};
var $author$project$Model$OrgSecurityRow$vulnerabilitiesToRows = F2(
	function (projects, vulnerabilities) {
		var projectIDSorter = function (id) {
			return A2(
				$elm$core$List$map,
				$elm$core$String$toLower,
				A2(
					$author$project$Model$OrgSecurityRow$projectNames,
					projects,
					_List_fromArray(
						[id])));
		};
		var dict = A3(
			$elm$core$List$foldl,
			function (vulnerability) {
				return A2(
					$elm$core$Dict$update,
					vulnerability.B9,
					function (maybePreviousRow) {
						if (maybePreviousRow.$ === 1) {
							return $elm$core$Maybe$Just(
								{
									B9: vulnerability.B9,
									bP: A2(
										$elm$core$Maybe$withDefault,
										'[No Description Provided]',
										A2($elm$core$Maybe$map, $elm$core$String$trim, vulnerability.bP)),
									hJ: A2(
										$author$project$Uuid$Dict$singleton,
										vulnerability.zK,
										_List_fromArray(
											[
												$author$project$Model$OrgSecurityRow$vulnPackageFromInstance(vulnerability)
											])),
									ck: vulnerability.ck,
									o: vulnerability.o
								});
						} else {
							var previousRow = maybePreviousRow.a;
							var packagesByProjectId = A3(
								$author$project$Uuid$Dict$update,
								vulnerability.zK,
								function (previous) {
									if (previous.$ === 1) {
										return $elm$core$Maybe$Just(
											_List_fromArray(
												[
													$author$project$Model$OrgSecurityRow$vulnPackageFromInstance(vulnerability)
												]));
									} else {
										var previousNames = previous.a;
										return $elm$core$Maybe$Just(
											A2(
												$elm$core$List$cons,
												$author$project$Model$OrgSecurityRow$vulnPackageFromInstance(vulnerability),
												previousNames));
									}
								},
								previousRow.hJ);
							return $elm$core$Maybe$Just(
								_Utils_update(
									previousRow,
									{hJ: packagesByProjectId}));
						}
					});
			},
			$elm$core$Dict$empty,
			vulnerabilities);
		return A2(
			$elm$core$List$map,
			function (row) {
				var packagesByProjectId = A2(
					$elm$core$List$sortBy,
					A2($elm$core$Basics$composeR, $author$project$Misc$tripleSecond, projectIDSorter),
					A2(
						$elm$core$List$map,
						function (_v0) {
							var id = _v0.a;
							var packages = _v0.b;
							return _Utils_Tuple3(
								$elm$core$List$length(packages),
								id,
								A2(
									$elm$core$List$sortBy,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.w;
										},
										$elm$core$String$toLower),
									A2(
										$elm_community$list_extra$List$Extra$uniqueBy,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.w;
											},
											$elm$core$String$toLower),
										packages)));
						},
						$author$project$Uuid$Dict$toList(row.hJ)));
				return {
					B9: row.B9,
					bP: row.bP,
					hJ: A2($elm$core$List$map, $author$project$Misc$tripleDropFirst, packagesByProjectId),
					ck: row.ck,
					v8: $elm$core$List$sum(
						A2($elm$core$List$map, $author$project$Misc$tripleFirst, packagesByProjectId)),
					o: row.o
				};
			},
			$elm$core$Dict$values(dict));
	});
var $author$project$Model$PromptToDownload$csv = 'text/csv';
var $author$project$Model$PromptToDownload$vulnerabilityReportModel = function (_v0) {
	var orgUrlName = _v0.E_;
	var payload = _v0.vQ;
	return {
		rw: $author$project$Model$PromptToDownload$csv,
		vQ: payload,
		sx: $elm$core$Maybe$Just(orgUrlName + '-vulnerability-report.csv')
	};
};
var $author$project$Pages$OrgSecurity$update = F2(
	function (action, model) {
		switch (action.$) {
			case 0:
				var sortBy = action.a;
				var sortDirection = function () {
					var _v1 = _Utils_Tuple2(
						_Utils_eq(sortBy, model.nx),
						model.ny);
					if (!_v1.a) {
						return $author$project$Pages$OrgSecurity$defaultSortDireciton;
					} else {
						if (!_v1.b) {
							var _v2 = _v1.b;
							return 1;
						} else {
							var _v3 = _v1.b;
							return 0;
						}
					}
				}();
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					_Utils_update(
						model,
						{nx: sortBy, ny: sortDirection}));
			case 1:
				var searchInputValue = action.a;
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					_Utils_update(
						model,
						{kt: searchInputValue}));
			case 2:
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					_Utils_update(
						model,
						{kt: ''}));
			case 3:
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					_Utils_update(
						model,
						{lW: !model.lW}));
			case 4:
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					_Utils_update(
						model,
						{cT: $author$project$Pages$OrgSecurity$allFilters}));
			case 5:
				var flagName = action.a;
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					_Utils_update(
						model,
						{
							cT: A2($author$project$Pages$OrgSecurity$toggleFilter, model.cT, flagName)
						}));
			case 6:
				if (action.a.$ === 1) {
					var err = action.a.a;
					return A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								lo: $author$project$Pages$OrgSecurity$Failure(err)
							}));
				} else {
					var _v4 = action.a.a;
					var loadedProjects = _v4.a;
					var data = _v4.b;
					var vulns = A2(
						$elm$core$List$concatMap,
						function (dep) {
							var projectID = $author$project$Model$Analytics$Fact$Dependencies$projectID(dep);
							var maybeVulns = A2(
								$elm$core$Maybe$andThen,
								function (cveKey) {
									return A2($elm$core$Dict$get, cveKey, data.G8);
								},
								$author$project$Model$Analytics$Fact$Dependencies$cveKeyFromDep(dep));
							var maybeVersion = $author$project$Model$Analytics$DIM$Purl$version(
								$author$project$Model$Analytics$Fact$Dependencies$component(dep));
							var maybePurl = $author$project$Model$Analytics$DIM$Purl$purl(
								$author$project$Model$Analytics$Fact$Dependencies$component(dep));
							return A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A3(
									$elm$core$Maybe$map2,
									F2(
										function (purl, v) {
											return A2(
												$elm$core$List$map,
												A3($author$project$Model$OrgSecurityRow$instanceFromVulnerability, projectID, purl, maybeVersion),
												v);
										}),
									maybePurl,
									maybeVulns));
						},
						data.qP);
					var projects = $author$project$Uuid$Dict$fromList(
						A2(
							$elm$core$List$map,
							function (p) {
								return _Utils_Tuple2(
									$author$project$Model$Project$id(p),
									$author$project$Model$OrgSecurityProject$fromProject(p));
							},
							loadedProjects));
					return A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								lo: $author$project$Pages$OrgSecurity$Success(
									{
										ko: projects,
										sc: A2($author$project$Model$OrgSecurityRow$vulnerabilitiesToRows, projects, vulns)
									})
							}));
				}
			case 7:
				var cveData = action.a;
				return A2(
					$author$project$Misc$with,
					$author$project$Ports$promptToDownload(
						$author$project$Model$PromptToDownload$vulnerabilityReportModel(
							{
								E_: model.c3.AC,
								vQ: A2($author$project$Pages$OrgSecurity$generateReportCSV, model, cveData)
							})),
					model);
			case 8:
				var severity = action.a;
				var newFilter = function () {
					var _v5 = model.lo;
					if (_v5.$ === 2) {
						var cveData = _v5.a;
						var severityCount = $elm$core$List$length(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.ck;
									},
									$elm$core$Basics$eq(severity)),
								cveData.sc));
						return (severityCount >= 1) ? A2(
							$author$project$Pages$OrgSecurity$toggleSingleSeverity,
							model.cT,
							$author$project$Pages$OrgSecurity$severityToFlag(severity)) : model.cT;
					} else {
						return model.cT;
					}
				}();
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					_Utils_update(
						model,
						{cT: newFilter}));
			default:
				var maybeRow = action.a;
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					_Utils_update(
						model,
						{sj: maybeRow}));
		}
	});
var $author$project$Pages$OrgSettings$OnDeleteOrg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$OrgSettings$OnEndSubscription = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$OrgSettings$OnEndSubscriptionReload = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Pages$OrgSettings$OnLeaveOrg = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Request$Invoice$cancelTrial = F3(
	function (identifierType, orgIdentifier, creds) {
		return $author$project$Http$Extra$post(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$emptyJsonBody,
				qN: $elm$json$Json$Decode$string,
				CN: _List_Nil,
				GT: '/organizations/' + (orgIdentifier + ('/invoices/cancel?identifierType=' + identifierType))
			});
	});
var $author$project$Request$Invoice$cancelTrialByUrlName = F2(
	function (urlName, creds) {
		return A3($author$project$Request$Invoice$cancelTrial, 'URLname', urlName, creds);
	});
var $author$project$Pages$OrgSettings$confirmIdDeleteOrg = 'delete-org';
var $author$project$Pages$OrgSettings$confirmIdEndSubscription = 'end-subscription';
var $author$project$Pages$OrgSettings$confirmIdLeaveOrg = 'leave-org';
var $author$project$Model$User$getMembership = F2(
	function (orgUrlName, user) {
		return A2(
			$elm_community$list_extra$List$Extra$find,
			function (ms) {
				return _Utils_eq(
					$elm$core$String$toLower(ms.AC),
					$elm$core$String$toLower(orgUrlName));
			},
			user.mX);
	});
var $author$project$Model$Organization$isInTrial = function (_v0) {
	var subscription = _v0.wv;
	if (subscription.$ === 3) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pages$OrgSettings$organization = function (model) {
	return model.c3;
};
var $author$project$Pages$OrgSettings$NoOp = {$: 0};
var $author$project$Pages$OrgSettings$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Pages$OrgSettings$NoOp, 'Pages/OrgSettings.elm');
var $author$project$Model$Tier$tierNameAsSimpleTierString = A2($elm$core$Basics$composeR, $author$project$Model$Tier$stringToSimpleTier, $author$project$Model$Tier$simpleTierDisplayString);
var $author$project$Pages$OrgSettings$update = F3(
	function (session, action, model) {
		var creds = $author$project$Model$Session$getCreds(session);
		switch (action.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
			case 1:
				var confirmed = action.a;
				return confirmed ? A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$OrgSettings$OnDeleteOrg,
							A2($author$project$Request$Organization$delete, model.c3.AC, creds)),
						_Utils_update(
							model,
							{fw: true}))) : A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								fB: $elm$core$Maybe$Just($author$project$Pages$OrgSettings$confirmIdDeleteOrg)
							})));
			case 2:
				var confirmed = action.a;
				return confirmed ? A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$OrgSettings$OnLeaveOrg(model.c3.AC),
							A3(
								$author$project$Request$Member$delete,
								model.c3.AC,
								$author$project$Protected$username(creds),
								creds)),
						_Utils_update(
							model,
							{fw: true}))) : A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								fB: $elm$core$Maybe$Just($author$project$Pages$OrgSettings$confirmIdLeaveOrg)
							})));
			case 3:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{fB: $elm$core$Maybe$Nothing})));
			case 4:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{fB: $elm$core$Maybe$Nothing})));
			case 5:
				if (!action.b.$) {
					var orgUrlName = action.a;
					var notificationText = A2(
						$elm$core$String$join,
						' ',
						_List_fromArray(
							['You have left the', orgUrlName, 'organization.']));
					return A2(
						$author$project$Misc$with,
						$author$project$External$Batch(
							_List_fromArray(
								[
									$author$project$External$RemoveMembership(model.c3.AC),
									$author$project$External$AddNotification(
									$author$project$Model$Notification$textSuccess(notificationText))
								])),
						A2(
							$author$project$Misc$with,
							A2(
								$author$project$Routing$replaceUrl,
								model.Y,
								$author$project$Model$Route$Protected(
									$author$project$Model$Route$Home(
										{wd: $elm$core$Maybe$Nothing}))),
							_Utils_update(
								model,
								{fw: false})));
				} else {
					var err = action.b.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$OrgSettings$rollbar.FZ, 'OnLeaveOrg _ (Err err)', err, session),
							_Utils_update(
								model,
								{fw: false})));
				}
			case 6:
				if (!action.a.$) {
					var notificationText = A2(
						$elm$core$String$join,
						' ',
						_List_fromArray(
							['Organization', model.c3.AC, 'was successfully deleted.']));
					return A2(
						$author$project$Misc$with,
						$author$project$External$Batch(
							_List_fromArray(
								[
									$author$project$External$RemoveMembership(model.c3.AC),
									$author$project$External$AddNotification(
									$author$project$Model$Notification$textSuccess(notificationText))
								])),
						A2(
							$author$project$Misc$with,
							A2(
								$author$project$Routing$replaceUrl,
								model.Y,
								$author$project$Model$Route$Protected($author$project$Model$Route$Orgs)),
							model));
				} else {
					var err = action.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$OrgSettings$rollbar.FZ, 'OnDeleteOrg (Err err)', err, session),
							_Utils_update(
								model,
								{fw: false})));
				}
			case 7:
				var confirmed = action.a;
				return confirmed ? A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$OrgSettings$OnEndSubscription,
							A2($author$project$Request$Invoice$cancelTrialByUrlName, model.c3.AC, creds)),
						_Utils_update(
							model,
							{fw: true}))) : A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								fB: $elm$core$Maybe$Just($author$project$Pages$OrgSettings$confirmIdEndSubscription)
							})));
			case 8:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{fB: $elm$core$Maybe$Nothing})));
			case 9:
				if (!action.a.$) {
					var org = $author$project$Pages$OrgSettings$organization(model);
					var tierName = $author$project$Model$Tier$tierNameAsSimpleTierString(org.dc) + (' Tier' + ($author$project$Model$Organization$isInTrial(org) ? ' Trial' : ''));
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							A2(
								$elm$core$Task$attempt,
								$author$project$Pages$OrgSettings$OnEndSubscriptionReload(tierName),
								A3($author$project$Pages$OrgSettings$init, session, model.Y, org.AC)),
							model));
				} else {
					var err = action.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$OrgSettings$rollbar.FZ, 'OnEndSubscription (Err err)', err, session),
							_Utils_update(
								model,
								{fw: false})));
				}
			default:
				if (!action.b.$) {
					var cancelledTierName = action.a;
					var newModel = action.b.a;
					var org = newModel.c3;
					var updatedMembership = A2(
						$elm$core$Maybe$map,
						function (ms) {
							return _Utils_update(
								ms,
								{dc: org.dc});
						},
						A2(
							$elm$core$Maybe$andThen,
							$author$project$Model$User$getMembership(org.AC),
							$author$project$Model$Session$getUser(session)));
					return A2(
						$author$project$Misc$with,
						$author$project$External$Batch(
							_List_fromArray(
								[
									A2(
									$elm$core$Maybe$withDefault,
									$author$project$External$NoOp,
									A2($elm$core$Maybe$map, $author$project$External$AddMembership, updatedMembership)),
									$author$project$External$AddNotification(
									$author$project$Model$Notification$textSuccess('Your ' + (cancelledTierName + ' subscription was successfully cancelled.')))
								])),
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								newModel,
								{fw: false})));
				} else {
					var err = action.b.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$OrgSettings$rollbar.FZ, 'OnEndSubscriptionReload _ (Err err)', err, session),
							_Utils_update(
								model,
								{fw: false})));
				}
		}
	});
var $author$project$Model$Notification$Anchor = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$Notification$LineBreak = {$: 2};
var $author$project$Pages$Orgs$OnInvitationEvent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Orgs$OnLeaveOrg = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Model$Message$UserLastAdmin = 0;
var $author$project$Model$Message$Unknown = 1;
var $author$project$Model$Message$error = function (message) {
	var _v0 = message.xD;
	if (_v0 === 40001) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Model$Message$fromHttpError = function (err) {
	return A2(
		$elm$core$Maybe$andThen,
		A2($elm$core$Basics$composeR, $author$project$Model$Message$fromString, $elm$core$Result$toMaybe),
		$author$project$Http$Extra$errorBody(err));
};
var $author$project$Model$Route$orgMembers = function (orgName) {
	return $author$project$Model$Route$Protected(
		$author$project$Model$Route$Org(
			A2($author$project$Model$Route$OrgParams, orgName, $author$project$Model$Route$OrgMembers)));
};
var $author$project$Pages$Orgs$removeOrg = function (orgUrlName) {
	return $elm$core$List$filter(
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.AC;
			},
			$elm$core$Basics$neq(orgUrlName)));
};
var $author$project$Pages$Orgs$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Pages$Orgs$NoOp, 'Pages/Orgs.elm');
var $author$project$Views$Invitations$InviteAccepted = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Views$Invitations$InviteDeclined = function (a) {
	return {$: 2, a: a};
};
var $author$project$Views$Invitations$InviteError = function (a) {
	return {$: 3, a: a};
};
var $author$project$Views$Invitations$NoOp = {$: 0};
var $author$project$Views$Invitations$OnAcceptedInvite = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Views$Invitations$OnDeclinedInvite = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Views$Invitations$RollbarSent = {$: 0};
var $author$project$Views$Invitations$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Views$Invitations$RollbarSent, 'Views/Invitations.elm');
var $author$project$Views$Invitations$update = F2(
	function (session, msg) {
		var creds = $author$project$Model$Session$getCreds(session);
		switch (msg.$) {
			case 0:
				return A2($author$project$Misc$with, $author$project$Views$Invitations$NoOp, $elm$core$Platform$Cmd$none);
			case 1:
				var input = msg.a;
				var orgName = input.ix;
				var inviteCode = input.fs;
				return A2(
					$author$project$Misc$with,
					$author$project$Views$Invitations$NoOp,
					A2(
						$elm$core$Task$attempt,
						$author$project$Views$Invitations$OnAcceptedInvite(input),
						A4(
							$elm$core$Task$map3,
							F3(
								function (a, b, c) {
									return {hB: a, uQ: c, pd: b};
								}),
							A3($author$project$Request$Member$put, orgName, inviteCode, creds),
							A2($author$project$Request$Organization$get, orgName, creds),
							$elm$time$Time$now)));
			case 2:
				if (!msg.b.$) {
					var input = msg.a;
					var members = msg.b.a.hB;
					var org = msg.b.a.pd;
					var now = msg.b.a.uQ;
					var currentUsername = A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.AE;
						},
						$author$project$Model$Session$getUser(session));
					var newMember = A2(
						$elm_community$list_extra$List$Extra$find,
						function (m) {
							return _Utils_eq(
								$elm$core$Maybe$Just(m.gS.AE),
								currentUsername);
						},
						members);
					var externalMsg = function () {
						if (!newMember.$) {
							var member = newMember.a;
							var newMembership = {ts: org.ak, DM: now, zw: org.zw, FO: member.FO, dc: org.dc, AC: input.ix};
							return A2($author$project$Views$Invitations$InviteAccepted, newMembership, org);
						} else {
							return $author$project$Views$Invitations$NoOp;
						}
					}();
					var cmd = $author$project$Ports$sendAnalyticsEvent(
						A2(
							$author$project$Model$Analytics$withAction,
							'Accepted invite',
							A2(
								$author$project$Model$Analytics$withCategory,
								'Organizations',
								$author$project$Model$Analytics$newEvent('Accepted invite'))));
					return A2($author$project$Misc$with, externalMsg, cmd);
				} else {
					var err = msg.b.a;
					return A2(
						$author$project$Misc$with,
						$author$project$Views$Invitations$InviteError(err),
						A3($author$project$Views$Invitations$rollbar.FZ, 'OnAcceptedInvite _ (Err err)', err, session));
				}
			case 3:
				var input = msg.a;
				var orgName = input.ix;
				var email = input.lJ;
				return A2(
					$author$project$Misc$with,
					$author$project$Views$Invitations$NoOp,
					A2(
						$elm$core$Task$attempt,
						$author$project$Views$Invitations$OnDeclinedInvite(input),
						A3($author$project$Request$Invitation$delete, orgName, email, creds)));
			default:
				if (!msg.b.$) {
					var orgName = msg.a.ix;
					return A2(
						$author$project$Misc$with,
						$author$project$Views$Invitations$InviteDeclined(orgName),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.b.a;
					return A2(
						$author$project$Misc$with,
						$author$project$Views$Invitations$InviteError(err),
						A3($author$project$Views$Invitations$rollbar.FZ, 'OnDeclinedInvite _ (Err err)', err, session));
				}
		}
	});
var $author$project$Pages$Orgs$update = F3(
	function (session, msg, model) {
		var creds = $author$project$Model$Session$getCreds(session);
		switch (msg.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
			case 1:
				var invitationMsg = msg.a;
				var _v1 = A2($author$project$Views$Invitations$update, session, invitationMsg);
				var cmd = _v1.a;
				var invitationExtMsg = _v1.b;
				var _v2 = function () {
					switch (invitationExtMsg.$) {
						case 1:
							var newMembership = invitationExtMsg.a;
							var newOrg = invitationExtMsg.b;
							return _Utils_Tuple2(
								A2(
									$author$project$Views$NotificationsInline$setSuccessText,
									'You have successfully joined ' + newOrg.AC,
									_Utils_update(
										model,
										{
											mX: A2(
												$elm$core$List$append,
												model.mX,
												_List_fromArray(
													[newOrg]))
										})),
								$author$project$External$Batch(
									_List_fromArray(
										[
											$author$project$External$RemoveInvitesForOrg(newOrg.AC),
											$author$project$External$AddMembership(newMembership)
										])));
						case 2:
							var orgName = invitationExtMsg.a;
							return _Utils_Tuple2(
								A2($author$project$Views$NotificationsInline$setSuccessText, 'You declined invite to ' + orgName, model),
								$author$project$External$RemoveInvitesForOrg(orgName));
						case 3:
							var err = invitationExtMsg.a;
							return A2(
								$author$project$Misc$with,
								$author$project$External$NoOp,
								A2($author$project$Views$NotificationsInline$setError, err, model));
						default:
							return _Utils_Tuple2(model, $author$project$External$NoOp);
					}
				}();
				var newModel = _v2.a;
				var externalMsg = _v2.b;
				return A2(
					$author$project$Misc$with,
					externalMsg,
					A2(
						$author$project$Misc$with,
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Orgs$OnInvitationEvent, cmd),
						newModel));
			case 2:
				var text = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{np: text})));
			case 3:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{np: ''})));
			case 4:
				var id = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								pO: $elm$core$Maybe$Just(id)
							})));
			case 5:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{pO: $elm$core$Maybe$Nothing})));
			case 6:
				var orgUrlName = msg.a;
				var confirmed = msg.b;
				return confirmed ? A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$Orgs$OnLeaveOrg(orgUrlName),
							A3(
								$author$project$Request$Member$delete,
								orgUrlName,
								$author$project$Protected$username(creds),
								creds)),
						$author$project$Views$NotificationsInline$clear(
							_Utils_update(
								model,
								{jJ: $elm$core$Maybe$Nothing})))) : A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								jJ: $elm$core$Maybe$Just(orgUrlName)
							})));
			case 7:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						$author$project$Views$NotificationsInline$clear(
							_Utils_update(
								model,
								{jJ: $elm$core$Maybe$Nothing}))));
			default:
				if (!msg.b.$) {
					var orgUrlName = msg.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{
									mX: A2($author$project$Pages$Orgs$removeOrg, orgUrlName, model.mX)
								})));
				} else {
					var orgUrlName = msg.a;
					var err = msg.b.a;
					var markups = function () {
						var _v4 = $author$project$Model$Message$fromHttpError(err);
						if (_v4.$ === 1) {
							return _List_fromArray(
								[
									$author$project$Model$Notification$Text(
									$author$project$Model$Message$reason(err))
								]);
						} else {
							var m = _v4.a;
							return (!$author$project$Model$Message$error(m)) ? _List_fromArray(
								[
									$author$project$Model$Notification$Text(m.Eh),
									$author$project$Model$Notification$LineBreak,
									$author$project$Model$Notification$Anchor(
									{
										Gv: 'Click here to manage the organization\'s members',
										Gz: $author$project$Model$Route$routeToString(
											$author$project$Model$Route$orgMembers(orgUrlName))
									})
								]) : _List_fromArray(
								[
									$author$project$Model$Notification$Text(m.Eh)
								]);
						}
					}();
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Misc$scrollToTop($author$project$Pages$Orgs$NoOp),
										A3($author$project$Pages$Orgs$rollbar.FZ, 'OnLeaveOrg orgUrlName (Err err)', err, session)
									])),
							A2(
								$author$project$Views$NotificationsInline$set,
								$author$project$Model$Notification$Warning(markups),
								model)));
				}
		}
	});
var $author$project$Pages$PreferenceDeleteAccount$Confirm = 1;
var $author$project$Pages$PreferenceDeleteAccount$Deleting = 2;
var $author$project$Pages$PreferenceDeleteAccount$OnDelete = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$PreferenceDeleteAccount$NoOp = {$: 0};
var $author$project$Pages$PreferenceDeleteAccount$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Pages$PreferenceDeleteAccount$NoOp, 'Pages/PreferenceDeleteAccount.elm');
var $author$project$Pages$PreferenceDeleteAccount$update = F3(
	function (session, action, model) {
		var creds = $author$project$Model$Session$getCreds(session);
		switch (action.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
			case 1:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{jU: 1})));
			case 2:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{jU: 0})));
			case 3:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$PreferenceDeleteAccount$OnDelete,
							A2($author$project$Request$User$delete, model.AE, creds)),
						_Utils_update(
							model,
							{jU: 2})));
			default:
				if (!action.a.$) {
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							A2($author$project$Routing$replaceUrl, model.Y, $author$project$Model$Route$Logout),
							model));
				} else {
					var err = action.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$PreferenceDeleteAccount$rollbar.FZ, 'OnDelete (Err err)', err, session),
							_Utils_update(
								model,
								{jU: 0})));
				}
		}
	});
var $author$project$Pages$PreferenceEmail$OnEmailAdd = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$PreferenceEmail$OnPromote = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$PreferenceEmail$OnRemoveEmail = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$PreferenceEmail$OnResendActivationEmail = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Pages$PreferenceEmail$append = F2(
	function (email, emails) {
		return A2(
			$elm$core$List$sortBy,
			function ($) {
				return $.lJ;
			},
			A2($elm$core$List$cons, email, emails));
	});
var $author$project$Request$Email$delete = F2(
	function (address, creds) {
		return $author$project$Http$Extra$delete(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'email',
								$elm$json$Json$Encode$string(address))
							]))),
				qN: $author$project$Model$Message$decode,
				CN: _List_Nil,
				GT: '/users/' + ($author$project$Protected$username(creds) + '/emails/')
			});
	});
var $author$project$Request$Email$patchPreferred = F2(
	function (address, creds) {
		return $author$project$Http$Extra$patch(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$emptyJsonBody,
				qN: $author$project$Model$Email$decode,
				CN: _List_Nil,
				GT: '/users/' + ($author$project$Protected$username(creds) + ('/emails/' + (address + '/preferred')))
			});
	});
var $author$project$Request$Email$post = F2(
	function (address, creds) {
		return $author$project$Http$Extra$post(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'email',
								$elm$json$Json$Encode$string(address))
							]))),
				qN: $author$project$Model$Email$decode,
				CN: _List_Nil,
				GT: '/users/' + ($author$project$Protected$username(creds) + '/emails')
			});
	});
var $author$project$Pages$PreferenceEmail$promote = function (address) {
	return $elm$core$List$map(
		function (e) {
			return _Utils_update(
				e,
				{
					Fn: _Utils_eq(e.lJ, address)
				});
		});
};
var $author$project$Pages$PreferenceEmail$remove = function (address) {
	return $elm$core$List$filter(
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.lJ;
			},
			$elm$core$Basics$neq(address)));
};
var $author$project$Pages$PreferenceEmail$NoOp = {$: 0};
var $author$project$Pages$PreferenceEmail$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Pages$PreferenceEmail$NoOp, 'Pages/PreferenceEmail.elm');
var $author$project$Pages$PreferenceEmail$update = F3(
	function (session, action, model) {
		var creds = $author$project$Model$Session$getCreds(session);
		switch (action.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
			case 1:
				var trimmed = $elm$core$String$trim(model.ka);
				return $author$project$Model$Email$isValid(trimmed) ? A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$PreferenceEmail$OnEmailAdd,
							A2($author$project$Request$Email$post, trimmed, creds)),
						_Utils_update(
							model,
							{oC: $elm$core$Maybe$Nothing}))) : A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								oC: $elm$core$Maybe$Just('Please provide a valid Email Address')
							})));
			case 2:
				var address = action.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$PreferenceEmail$OnRemoveEmail(address),
							A2($author$project$Request$Email$delete, address, creds)),
						model));
			case 4:
				if (!action.a.$) {
					var res = action.a.a;
					var emails = A2($author$project$Pages$PreferenceEmail$append, res, model.ir);
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$textSuccess('We sent a verification email to \"' + (model.ka + '\".'))),
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{ir: emails, ka: ''})));
				} else {
					var err = action.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$PreferenceEmail$rollbar.FZ, 'OnEmailAdd (Err err)', err, session),
							model));
				}
			case 6:
				if (!action.a.$) {
					var email = action.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{
									ir: A2($author$project$Pages$PreferenceEmail$promote, email.lJ, model.ir)
								})));
				} else {
					var err = action.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$PreferenceEmail$rollbar.FZ, 'OnPromote (Err err)', err, session),
							model));
				}
			case 3:
				if (!action.b.$) {
					var address = action.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{
									ir: A2($author$project$Pages$PreferenceEmail$remove, address, model.ir)
								})));
				} else {
					var err = action.b.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$PreferenceEmail$rollbar.FZ, 'OnRemoveEmail _ (Err err)', err, session),
							model));
				}
			case 5:
				var address = action.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$PreferenceEmail$OnPromote,
							A2($author$project$Request$Email$patchPreferred, address, creds)),
						model));
			case 7:
				var address = action.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{ka: address})));
			case 8:
				var address = action.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$PreferenceEmail$OnResendActivationEmail(address),
							A3($author$project$Request$Email$postResendActivation, session, address, $elm$core$Maybe$Nothing)),
						model));
			default:
				if (!action.b.$) {
					var address = action.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$verificationEmailSent(address)),
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
				} else {
					var err = action.b.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$PreferenceEmail$rollbar.FZ, 'OnResendActivationEmail _ (Err err)', err, session),
							model));
				}
		}
	});
var $author$project$Pages$PreferenceLinkedAccounts$NotLinked = {$: 1};
var $author$project$Pages$PreferenceLinkedAccounts$UnlinkingResponse = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Request$OAuth$gitHubLink = $author$project$Views$AuthButton$getLinkPath;
var $author$project$Request$OAuth$linkAccountToService = F2(
	function (service, token) {
		return $author$project$Request$OAuth$gitHubLink(token);
	});
var $author$project$Pages$PreferenceLinkedAccounts$mapStatus = F2(
	function (fn, m) {
		return _Utils_update(
			m,
			{
				L: fn(m.L)
			});
	});
var $author$project$Pages$PreferenceLinkedAccounts$NoOp = {$: 0};
var $author$project$Pages$PreferenceLinkedAccounts$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Pages$PreferenceLinkedAccounts$NoOp, 'Pages/PreferenceLinkedAccounts.elm');
var $author$project$Request$OAuth$gitHubUnlink = '/api/v1/oauth/github/unlink';
var $author$project$Request$OAuth$unlinkAccountFromService = function (service) {
	return $author$project$Request$OAuth$gitHubUnlink;
};
var $author$project$Request$OAuth$unlinkAccountFrom = F2(
	function (creds, service) {
		return $author$project$Http$Extra$post(
			{
				iO: $author$project$Http$Extra$HeaderOnly(creds),
				sY: $author$project$Http$Extra$emptyBody,
				qN: $elm$json$Json$Decode$succeed(''),
				CN: _List_Nil,
				GT: $author$project$Request$OAuth$unlinkAccountFromService(service)
			});
	});
var $author$project$Pages$PreferenceLinkedAccounts$withLinking = F2(
	function (l, m) {
		return _Utils_update(
			m,
			{ro: l});
	});
var $author$project$Pages$PreferenceLinkedAccounts$update = F3(
	function (session, msg, model) {
		var key = $author$project$Model$OAuth$key;
		switch (msg.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
			case 1:
				var service = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$author$project$Ports$setCSRFCookie(0),
						A2(
							$author$project$Pages$PreferenceLinkedAccounts$withLinking,
							$elm$core$Maybe$Just(service),
							model)));
			case 2:
				var service = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$PreferenceLinkedAccounts$UnlinkingResponse(service),
							A2(
								$author$project$Request$OAuth$unlinkAccountFrom,
								$author$project$Model$Session$getCreds(session),
								service)),
						A2(
							$author$project$Pages$PreferenceLinkedAccounts$withLinking,
							$elm$core$Maybe$Just(service),
							model)));
			case 4:
				var token = msg.a;
				var command = function () {
					var _v1 = model.ro;
					if (!_v1.$) {
						var service = _v1.a;
						return $elm$browser$Browser$Navigation$load(
							A2($author$project$Request$OAuth$linkAccountToService, service, token));
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, command, model));
			default:
				if (!msg.b.$) {
					var service = msg.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$textSuccess(
								$author$project$Model$OAuth$title(service) + ' account unlinked')),
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							A2(
								$author$project$Pages$PreferenceLinkedAccounts$mapStatus,
								A2(
									$elm$core$Dict$insert,
									key(service),
									$author$project$Pages$PreferenceLinkedAccounts$NotLinked),
								model)));
				} else {
					var service = msg.a;
					var err = msg.b.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$PreferenceLinkedAccounts$rollbar.FZ, 'UnlinkingResponse service (Err err)', err, session),
							A2(
								$author$project$Pages$PreferenceLinkedAccounts$mapStatus,
								A2(
									$elm$core$Dict$insert,
									key(service),
									$author$project$Pages$PreferenceLinkedAccounts$FailedToLink(
										$author$project$Model$Message$reason(err))),
								model)));
				}
		}
	});
var $author$project$Pages$PreferencePassword$OnSaveChanges = function (a) {
	return {$: 5, a: a};
};
var $author$project$Model$User$encodePasswordChange = function (_v0) {
	var currentPassword = _v0.xP;
	var newPassword = _v0.zk;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'currentPassword',
				$elm$json$Json$Encode$string(currentPassword)),
				_Utils_Tuple2(
				'newPassword',
				$elm$json$Json$Encode$string(newPassword))
			]));
};
var $author$project$Request$User$postChangePassword = F2(
	function (creds, passwordChange) {
		return $author$project$Http$Extra$post(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$jsonBody(
					$author$project$Model$User$encodePasswordChange(passwordChange)),
				qN: $author$project$Model$Message$decode,
				CN: _List_Nil,
				GT: '/change-password/'
			});
	});
var $author$project$Pages$PreferencePassword$NoOp = {$: 0};
var $author$project$Pages$PreferencePassword$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Pages$PreferencePassword$NoOp, 'Pages/PreferencePassword.elm');
var $author$project$Validation$validatePasswordConfirmation = F2(
	function (password, passwordConfirmation) {
		return _Utils_eq(password, passwordConfirmation) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('Your passwords must match');
	});
var $author$project$Pages$PreferencePassword$update = F3(
	function (session, msg, model) {
		var creds = $author$project$Model$Session$getCreds(session);
		switch (msg.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
			case 1:
				var password = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{xP: password})));
			case 2:
				var password = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{zk: password})));
			case 3:
				var password = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{mG: password})));
			case 4:
				var passwordError = $author$project$Validation$validatePassword(model.zk);
				var passwordConfirmationError = A2($author$project$Validation$validatePasswordConfirmation, model.zk, model.mG);
				var validations = _List_fromArray(
					[passwordError, passwordConfirmationError]);
				var passwordChange = {xP: model.xP, zk: model.zk};
				return A2(
					$elm$core$List$all,
					$elm$core$Basics$eq($elm$core$Maybe$Nothing),
					validations) ? A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$PreferencePassword$OnSaveChanges,
							A2($author$project$Request$User$postChangePassword, creds, passwordChange)),
						_Utils_update(
							model,
							{o6: $elm$core$Maybe$Nothing, mH: $elm$core$Maybe$Nothing}))) : A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{o6: passwordConfirmationError, mH: passwordError})));
			default:
				if (!msg.a.$) {
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							A2(
								$author$project$Views$NotificationsInline$setSuccessText,
								'Password was changed successfully.',
								_Utils_update(
									model,
									{xP: '', El: 1, zk: '', mG: ''}))));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$PreferencePassword$rollbar.FZ, 'OnSaveChanges (Err err)', err, session),
							model));
				}
		}
	});
var $author$project$Pages$PreferenceTwoFactor$CancelTwoFactor = {$: 6};
var $author$project$Pages$PreferenceTwoFactor$OnTOTPKey = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$PreferenceTwoFactor$OnUser = function (a) {
	return {$: 2, a: a};
};
var $author$project$Request$TOTPKey$delete = function (creds) {
	return $author$project$Http$Extra$delete(
		{
			iO: $author$project$Http$Extra$Creds(creds),
			sY: $author$project$Http$Extra$emptyJsonBody,
			qN: $author$project$Model$User$decode,
			CN: _List_Nil,
			GT: '/totp'
		});
};
var $author$project$Model$TOTPKey$TOTPKey = F3(
	function (qrCode, contentType, secret) {
		return {BX: contentType, Fu: qrCode, FU: secret};
	});
var $author$project$Model$TOTPKey$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'secret',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'contentType',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'QRCode',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Model$TOTPKey$TOTPKey))));
var $author$project$Request$TOTPKey$get = function (creds) {
	return $author$project$Http$Extra$get(
		{
			iO: $author$project$Http$Extra$Creds(creds),
			sY: $author$project$Http$Extra$emptyBody,
			qN: $author$project$Model$TOTPKey$decode,
			CN: _List_Nil,
			GT: '/totp'
		});
};
var $mdgriffith$elm_style_animation$Animation$extractInitialWait = function (steps) {
	var _v0 = $elm$core$List$head(steps);
	if (_v0.$ === 1) {
		return _Utils_Tuple2(
			$elm$time$Time$millisToPosix(0),
			_List_Nil);
	} else {
		var step = _v0.a;
		if (step.$ === 4) {
			var till = step.a;
			var _v2 = $mdgriffith$elm_style_animation$Animation$extractInitialWait(
				A2($elm$core$List$drop, 1, steps));
			var additionalTime = _v2.a;
			var remainingSteps = _v2.b;
			return _Utils_Tuple2(
				$elm$time$Time$millisToPosix(
					$elm$time$Time$posixToMillis(till) + $elm$time$Time$posixToMillis(additionalTime)),
				remainingSteps);
		} else {
			return _Utils_Tuple2(
				$elm$time$Time$millisToPosix(0),
				steps);
		}
	}
};
var $mdgriffith$elm_style_animation$Animation$interrupt = F2(
	function (steps, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				uh: A2(
					$elm$core$List$cons,
					$mdgriffith$elm_style_animation$Animation$extractInitialWait(steps),
					model.uh),
				se: true
			});
	});
var $author$project$Request$TOTPKey$post = F2(
	function (code, creds) {
		return $author$project$Http$Extra$post(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$emptyJsonBody,
				qN: $author$project$Model$User$decode,
				CN: _List_Nil,
				GT: '/totp?code=' + code
			});
	});
var $author$project$Pages$PreferenceTwoFactor$NoOp = {$: 0};
var $author$project$Pages$PreferenceTwoFactor$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Pages$PreferenceTwoFactor$NoOp, 'Pages/PreferenceTwoFactor.elm');
var $mdgriffith$elm_style_animation$Animation$Model$Send = function (a) {
	return {$: 5, a: a};
};
var $mdgriffith$elm_style_animation$Animation$Messenger$send = function (msg) {
	return $mdgriffith$elm_style_animation$Animation$Model$Send(msg);
};
var $mdgriffith$elm_style_animation$Animation$Model$To = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_style_animation$Animation$to = function (props) {
	return $mdgriffith$elm_style_animation$Animation$Model$To(props);
};
var $mdgriffith$elm_style_animation$Animation$Model$refreshTiming = F2(
	function (now, timing) {
		var dt = $elm$time$Time$posixToMillis(now) - $elm$time$Time$posixToMillis(timing.g5);
		return {
			g5: now,
			Cm: ((dt > 34) || (!$elm$time$Time$posixToMillis(timing.g5))) ? $elm$time$Time$millisToPosix(
				$elm$core$Basics$round(16.666)) : $elm$time$Time$millisToPosix(dt)
		};
	});
var $mdgriffith$elm_style_animation$Animation$Model$Loop = function (a) {
	return {$: 7, a: a};
};
var $mdgriffith$elm_style_animation$Animation$Model$Repeat = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $mdgriffith$elm_style_animation$Animation$Model$Step = {$: 0};
var $mdgriffith$elm_style_animation$Animation$Model$Wait = function (a) {
	return {$: 4, a: a};
};
var $mdgriffith$elm_style_animation$Animation$Model$isCmdDone = function (cmd) {
	var motionDone = function (motion) {
		return (!motion.G$) && _Utils_eq(motion.Fl, motion.nC);
	};
	switch (cmd.$) {
		case 0:
			var m1 = cmd.a;
			var m2 = cmd.b;
			return motionDone(m1) && motionDone(m2);
		case 1:
			var m1 = cmd.a;
			var m2 = cmd.b;
			return motionDone(m1) && motionDone(m2);
		case 2:
			var m1 = cmd.a;
			var m2 = cmd.b;
			return motionDone(m1) && motionDone(m2);
		case 3:
			var m1 = cmd.a;
			var m2 = cmd.b;
			return motionDone(m1) && motionDone(m2);
		case 4:
			var motion = cmd.a;
			return motionDone(motion);
		case 5:
			var motion = cmd.a;
			return motionDone(motion);
		case 6:
			var motion = cmd.a;
			return motionDone(motion);
		case 7:
			var motion = cmd.a;
			return motionDone(motion);
		case 8:
			var control1 = cmd.a.og;
			var control2 = cmd.a.oh;
			var point = cmd.a.hL;
			return motionDone(control1.a) && (motionDone(control1.b) && (motionDone(control2.a) && (motionDone(control2.b) && (motionDone(point.a) && motionDone(point.b)))));
		case 9:
			var control1 = cmd.a.og;
			var control2 = cmd.a.oh;
			var point = cmd.a.hL;
			return motionDone(control1.a) && (motionDone(control1.b) && (motionDone(control2.a) && (motionDone(control2.b) && (motionDone(point.a) && motionDone(point.b)))));
		case 10:
			var control = cmd.a.of;
			var point = cmd.a.hL;
			return motionDone(control.a) && (motionDone(control.b) && (motionDone(point.a) && motionDone(point.b)));
		case 11:
			var control = cmd.a.of;
			var point = cmd.a.hL;
			return motionDone(control.a) && (motionDone(control.b) && (motionDone(point.a) && motionDone(point.b)));
		case 12:
			var coords = cmd.a;
			return A2(
				$elm$core$List$all,
				function (_v1) {
					var x = _v1.a;
					var y = _v1.b;
					return motionDone(x) && motionDone(y);
				},
				coords);
		case 13:
			var coords = cmd.a;
			return A2(
				$elm$core$List$all,
				function (_v2) {
					var x = _v2.a;
					var y = _v2.b;
					return motionDone(x) && motionDone(y);
				},
				coords);
		case 14:
			var coords = cmd.a;
			return A2(
				$elm$core$List$all,
				function (_v3) {
					var x = _v3.a;
					var y = _v3.b;
					return motionDone(x) && motionDone(y);
				},
				coords);
		case 15:
			var coords = cmd.a;
			return A2(
				$elm$core$List$all,
				function (_v4) {
					var x = _v4.a;
					var y = _v4.b;
					return motionDone(x) && motionDone(y);
				},
				coords);
		case 16:
			var arc = cmd.a;
			return motionDone(arc.AS) && (motionDone(arc.AT) && (motionDone(arc.pz) && (motionDone(arc.pS) && motionDone(arc.os))));
		case 17:
			var arc = cmd.a;
			return motionDone(arc.AS) && (motionDone(arc.AT) && (motionDone(arc.pz) && (motionDone(arc.pS) && motionDone(arc.os))));
		default:
			return true;
	}
};
var $mdgriffith$elm_style_animation$Animation$Model$isDone = function (property) {
	var motionDone = function (motion) {
		var runningInterpolation = A2($elm$core$Maybe$withDefault, motion.mi, motion.C$);
		switch (runningInterpolation.$) {
			case 0:
				return (!motion.G$) && _Utils_eq(motion.Fl, motion.nC);
			case 1:
				var eased = runningInterpolation.a;
				return (eased.Fq === 1) || ((!eased.Fq) && _Utils_eq(motion.Fl, motion.nC));
			default:
				var speed = runningInterpolation.a;
				return _Utils_eq(motion.Fl, motion.nC);
		}
	};
	switch (property.$) {
		case 0:
			return true;
		case 1:
			var m1 = property.b;
			var m2 = property.c;
			var m3 = property.d;
			var m4 = property.e;
			return A2(
				$elm$core$List$all,
				motionDone,
				_List_fromArray(
					[m1, m2, m3, m4]));
		case 2:
			var shadow = property.c;
			return A2(
				$elm$core$List$all,
				motionDone,
				_List_fromArray(
					[shadow.hF, shadow.hG, shadow.we, shadow.hm, shadow.vW, shadow.tZ, shadow.sX, shadow.kN]));
		case 3:
			var m1 = property.b;
			return motionDone(m1);
		case 4:
			var m1 = property.b;
			var m2 = property.c;
			return motionDone(m1) && motionDone(m2);
		case 5:
			var m1 = property.b;
			var m2 = property.c;
			var m3 = property.d;
			return A2(
				$elm$core$List$all,
				motionDone,
				_List_fromArray(
					[m1, m2, m3]));
		case 6:
			var m1 = property.b;
			var m2 = property.c;
			var m3 = property.d;
			var m4 = property.e;
			return A2(
				$elm$core$List$all,
				motionDone,
				_List_fromArray(
					[m1, m2, m3, m4]));
		case 7:
			var m1 = property.b;
			return motionDone(m1);
		case 8:
			var ms = property.a;
			return A2(
				$elm$core$List$all,
				function (_v1) {
					var x = _v1.a;
					var y = _v1.b;
					return motionDone(x) && motionDone(y);
				},
				ms);
		default:
			var cmds = property.a;
			return A2($elm$core$List$all, $mdgriffith$elm_style_animation$Animation$Model$isCmdDone, cmds);
	}
};
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $mdgriffith$elm_style_animation$Animation$Model$matchPoints = F2(
	function (points1, points2) {
		var diff = $elm$core$List$length(points1) - $elm$core$List$length(points2);
		if (diff > 0) {
			var _v0 = $elm$core$List$head(
				$elm$core$List$reverse(points2));
			if (_v0.$ === 1) {
				return _Utils_Tuple2(points1, points2);
			} else {
				var last2 = _v0.a;
				return _Utils_Tuple2(
					points1,
					_Utils_ap(
						points2,
						A2(
							$elm$core$List$repeat,
							$elm$core$Basics$abs(diff),
							last2)));
			}
		} else {
			if (diff < 0) {
				var _v1 = $elm$core$List$head(
					$elm$core$List$reverse(points1));
				if (_v1.$ === 1) {
					return _Utils_Tuple2(points1, points2);
				} else {
					var last1 = _v1.a;
					return _Utils_Tuple2(
						_Utils_ap(
							points1,
							A2(
								$elm$core$List$repeat,
								$elm$core$Basics$abs(diff),
								last1)),
						points2);
				}
			} else {
				return _Utils_Tuple2(points1, points2);
			}
		}
	});
var $mdgriffith$elm_style_animation$Animation$Model$setPathTarget = F2(
	function (cmd, targetCmd) {
		var setMotionTarget = F2(
			function (motion, targetMotion) {
				var _v27 = motion.mi;
				if (_v27.$ === 1) {
					var ease = _v27.a;
					return _Utils_update(
						motion,
						{
							mi: $mdgriffith$elm_style_animation$Animation$Model$Easing(
								_Utils_update(
									ease,
									{cH: motion.Fl})),
							nC: targetMotion.Fl
						});
				} else {
					return _Utils_update(
						motion,
						{nC: targetMotion.Fl});
				}
			});
		switch (cmd.$) {
			case 0:
				var m1 = cmd.a;
				var m2 = cmd.b;
				if (!targetCmd.$) {
					var t1 = targetCmd.a;
					var t2 = targetCmd.b;
					return A2(
						$mdgriffith$elm_style_animation$Animation$Model$Move,
						A2(setMotionTarget, m1, t1),
						A2(setMotionTarget, m2, t2));
				} else {
					return cmd;
				}
			case 1:
				var m1 = cmd.a;
				var m2 = cmd.b;
				if (targetCmd.$ === 1) {
					var t1 = targetCmd.a;
					var t2 = targetCmd.b;
					return A2(
						$mdgriffith$elm_style_animation$Animation$Model$MoveTo,
						A2(setMotionTarget, m1, t1),
						A2(setMotionTarget, m2, t2));
				} else {
					return cmd;
				}
			case 2:
				var m1 = cmd.a;
				var m2 = cmd.b;
				if (targetCmd.$ === 2) {
					var t1 = targetCmd.a;
					var t2 = targetCmd.b;
					return A2(
						$mdgriffith$elm_style_animation$Animation$Model$Line,
						A2(setMotionTarget, m1, t1),
						A2(setMotionTarget, m2, t2));
				} else {
					return cmd;
				}
			case 3:
				var m1 = cmd.a;
				var m2 = cmd.b;
				if (targetCmd.$ === 3) {
					var t1 = targetCmd.a;
					var t2 = targetCmd.b;
					return A2(
						$mdgriffith$elm_style_animation$Animation$Model$LineTo,
						A2(setMotionTarget, m1, t1),
						A2(setMotionTarget, m2, t2));
				} else {
					return cmd;
				}
			case 4:
				var m1 = cmd.a;
				if (targetCmd.$ === 4) {
					var t1 = targetCmd.a;
					return $mdgriffith$elm_style_animation$Animation$Model$Horizontal(
						A2(setMotionTarget, m1, t1));
				} else {
					return cmd;
				}
			case 5:
				var m1 = cmd.a;
				if (targetCmd.$ === 5) {
					var t1 = targetCmd.a;
					return $mdgriffith$elm_style_animation$Animation$Model$HorizontalTo(
						A2(setMotionTarget, m1, t1));
				} else {
					return cmd;
				}
			case 6:
				var m1 = cmd.a;
				if (targetCmd.$ === 6) {
					var t1 = targetCmd.a;
					return $mdgriffith$elm_style_animation$Animation$Model$Vertical(
						A2(setMotionTarget, m1, t1));
				} else {
					return cmd;
				}
			case 7:
				var m1 = cmd.a;
				if (targetCmd.$ === 7) {
					var t1 = targetCmd.a;
					return $mdgriffith$elm_style_animation$Animation$Model$VerticalTo(
						A2(setMotionTarget, m1, t1));
				} else {
					return cmd;
				}
			case 8:
				var points = cmd.a;
				if (targetCmd.$ === 8) {
					var targets = targetCmd.a;
					return $mdgriffith$elm_style_animation$Animation$Model$Curve(
						{
							og: _Utils_Tuple2(
								A2(setMotionTarget, points.og.a, targets.og.a),
								A2(setMotionTarget, points.og.b, targets.og.b)),
							oh: _Utils_Tuple2(
								A2(setMotionTarget, points.oh.a, targets.oh.a),
								A2(setMotionTarget, points.oh.b, targets.oh.b)),
							hL: _Utils_Tuple2(
								A2(setMotionTarget, points.hL.a, targets.hL.a),
								A2(setMotionTarget, points.hL.b, targets.hL.b))
						});
				} else {
					return cmd;
				}
			case 9:
				var points = cmd.a;
				if (targetCmd.$ === 9) {
					var targets = targetCmd.a;
					return $mdgriffith$elm_style_animation$Animation$Model$CurveTo(
						{
							og: _Utils_Tuple2(
								A2(setMotionTarget, points.og.a, targets.og.a),
								A2(setMotionTarget, points.og.b, targets.og.b)),
							oh: _Utils_Tuple2(
								A2(setMotionTarget, points.oh.a, targets.oh.a),
								A2(setMotionTarget, points.oh.b, targets.oh.b)),
							hL: _Utils_Tuple2(
								A2(setMotionTarget, points.hL.a, targets.hL.a),
								A2(setMotionTarget, points.hL.b, targets.hL.b))
						});
				} else {
					return cmd;
				}
			case 10:
				var points = cmd.a;
				if (targetCmd.$ === 10) {
					var targets = targetCmd.a;
					return $mdgriffith$elm_style_animation$Animation$Model$Quadratic(
						{
							of: _Utils_Tuple2(
								A2(setMotionTarget, points.of.a, targets.of.a),
								A2(setMotionTarget, points.of.b, targets.of.b)),
							hL: _Utils_Tuple2(
								A2(setMotionTarget, points.hL.a, targets.hL.a),
								A2(setMotionTarget, points.hL.b, targets.hL.b))
						});
				} else {
					return cmd;
				}
			case 11:
				var points = cmd.a;
				if (targetCmd.$ === 11) {
					var targets = targetCmd.a;
					return $mdgriffith$elm_style_animation$Animation$Model$QuadraticTo(
						{
							of: _Utils_Tuple2(
								A2(setMotionTarget, points.of.a, targets.of.a),
								A2(setMotionTarget, points.of.b, targets.of.b)),
							hL: _Utils_Tuple2(
								A2(setMotionTarget, points.hL.a, targets.hL.a),
								A2(setMotionTarget, points.hL.b, targets.hL.b))
						});
				} else {
					return cmd;
				}
			case 12:
				var coords = cmd.a;
				if (targetCmd.$ === 12) {
					var targetCoords = targetCmd.a;
					return $mdgriffith$elm_style_animation$Animation$Model$SmoothQuadratic(
						A3(
							$elm$core$List$map2,
							F2(
								function (_v14, _v15) {
									var x1 = _v14.a;
									var y1 = _v14.b;
									var x2 = _v15.a;
									var y2 = _v15.b;
									return _Utils_Tuple2(
										A2(setMotionTarget, x1, x2),
										A2(setMotionTarget, y1, y2));
								}),
							coords,
							targetCoords));
				} else {
					return cmd;
				}
			case 13:
				var coords = cmd.a;
				if (targetCmd.$ === 13) {
					var targetCoords = targetCmd.a;
					return $mdgriffith$elm_style_animation$Animation$Model$SmoothQuadraticTo(
						A3(
							$elm$core$List$map2,
							F2(
								function (_v17, _v18) {
									var x1 = _v17.a;
									var y1 = _v17.b;
									var x2 = _v18.a;
									var y2 = _v18.b;
									return _Utils_Tuple2(
										A2(setMotionTarget, x1, x2),
										A2(setMotionTarget, y1, y2));
								}),
							coords,
							targetCoords));
				} else {
					return cmd;
				}
			case 14:
				var coords = cmd.a;
				if (targetCmd.$ === 14) {
					var targetCoords = targetCmd.a;
					return $mdgriffith$elm_style_animation$Animation$Model$Smooth(
						A3(
							$elm$core$List$map2,
							F2(
								function (_v20, _v21) {
									var x1 = _v20.a;
									var y1 = _v20.b;
									var x2 = _v21.a;
									var y2 = _v21.b;
									return _Utils_Tuple2(
										A2(setMotionTarget, x1, x2),
										A2(setMotionTarget, y1, y2));
								}),
							coords,
							targetCoords));
				} else {
					return cmd;
				}
			case 15:
				var coords = cmd.a;
				if (targetCmd.$ === 15) {
					var targetCoords = targetCmd.a;
					return $mdgriffith$elm_style_animation$Animation$Model$SmoothTo(
						A3(
							$elm$core$List$map2,
							F2(
								function (_v23, _v24) {
									var x1 = _v23.a;
									var y1 = _v23.b;
									var x2 = _v24.a;
									var y2 = _v24.b;
									return _Utils_Tuple2(
										A2(setMotionTarget, x1, x2),
										A2(setMotionTarget, y1, y2));
								}),
							coords,
							targetCoords));
				} else {
					return cmd;
				}
			case 16:
				var arc = cmd.a;
				if (targetCmd.$ === 16) {
					var target = targetCmd.a;
					return $mdgriffith$elm_style_animation$Animation$Model$ClockwiseArc(
						function () {
							var y = arc.AT;
							var x = arc.AS;
							var startAngle = arc.pS;
							var radius = arc.pz;
							var endAngle = arc.os;
							return _Utils_update(
								arc,
								{
									os: A2(setMotionTarget, endAngle, target.os),
									pz: A2(setMotionTarget, radius, target.pz),
									pS: A2(setMotionTarget, startAngle, target.pS),
									AS: A2(setMotionTarget, x, target.AS),
									AT: A2(setMotionTarget, y, target.AT)
								});
						}());
				} else {
					return cmd;
				}
			case 17:
				var arc = cmd.a;
				if (targetCmd.$ === 17) {
					var target = targetCmd.a;
					return $mdgriffith$elm_style_animation$Animation$Model$AntiClockwiseArc(
						function () {
							var y = arc.AT;
							var x = arc.AS;
							var startAngle = arc.pS;
							var radius = arc.pz;
							var endAngle = arc.os;
							return _Utils_update(
								arc,
								{
									os: A2(setMotionTarget, endAngle, target.os),
									pz: A2(setMotionTarget, radius, target.pz),
									pS: A2(setMotionTarget, startAngle, target.pS),
									AS: A2(setMotionTarget, x, target.AS),
									AT: A2(setMotionTarget, y, target.AT)
								});
						}());
				} else {
					return cmd;
				}
			default:
				return $mdgriffith$elm_style_animation$Animation$Model$Close;
		}
	});
var $mdgriffith$elm_style_animation$Animation$Model$setTarget = F3(
	function (overrideInterpolation, current, newTarget) {
		var setMotionTarget = F2(
			function (motion, targetMotion) {
				var newMotion = overrideInterpolation ? _Utils_update(
					motion,
					{
						C$: $elm$core$Maybe$Just(targetMotion.mi)
					}) : motion;
				var _v13 = newMotion.C$;
				if (_v13.$ === 1) {
					var _v14 = newMotion.mi;
					if (_v14.$ === 1) {
						var ease = _v14.a;
						return _Utils_update(
							newMotion,
							{
								mi: $mdgriffith$elm_style_animation$Animation$Model$Easing(
									_Utils_update(
										ease,
										{Fq: 0, cH: motion.Fl})),
								nC: targetMotion.Fl
							});
					} else {
						return _Utils_update(
							newMotion,
							{nC: targetMotion.Fl});
					}
				} else {
					var override = _v13.a;
					if (override.$ === 1) {
						var ease = override.a;
						return _Utils_update(
							newMotion,
							{
								C$: $elm$core$Maybe$Just(
									$mdgriffith$elm_style_animation$Animation$Model$Easing(
										_Utils_update(
											ease,
											{Fq: 0, cH: motion.Fl}))),
								nC: targetMotion.Fl
							});
					} else {
						return _Utils_update(
							newMotion,
							{nC: targetMotion.Fl});
					}
				}
			});
		switch (current.$) {
			case 0:
				var name = current.a;
				var value = current.b;
				return A2($mdgriffith$elm_style_animation$Animation$Model$ExactProperty, name, value);
			case 1:
				var name = current.a;
				var m1 = current.b;
				var m2 = current.c;
				var m3 = current.d;
				var m4 = current.e;
				if (newTarget.$ === 1) {
					var t1 = newTarget.b;
					var t2 = newTarget.c;
					var t3 = newTarget.d;
					var t4 = newTarget.e;
					return A5(
						$mdgriffith$elm_style_animation$Animation$Model$ColorProperty,
						name,
						A2(setMotionTarget, m1, t1),
						A2(setMotionTarget, m2, t2),
						A2(setMotionTarget, m3, t3),
						A2(setMotionTarget, m4, t4));
				} else {
					return current;
				}
			case 2:
				var name = current.a;
				var inset = current.b;
				var shadow = current.c;
				if (newTarget.$ === 2) {
					var targetShadow = newTarget.c;
					return A3(
						$mdgriffith$elm_style_animation$Animation$Model$ShadowProperty,
						name,
						inset,
						{
							kN: A2(setMotionTarget, shadow.kN, targetShadow.kN),
							sX: A2(setMotionTarget, shadow.sX, targetShadow.sX),
							hm: A2(setMotionTarget, shadow.hm, targetShadow.hm),
							tZ: A2(setMotionTarget, shadow.tZ, targetShadow.tZ),
							hF: A2(setMotionTarget, shadow.hF, targetShadow.hF),
							hG: A2(setMotionTarget, shadow.hG, targetShadow.hG),
							vW: A2(setMotionTarget, shadow.vW, targetShadow.vW),
							we: A2(setMotionTarget, shadow.we, targetShadow.we)
						});
				} else {
					return current;
				}
			case 3:
				var name = current.a;
				var m1 = current.b;
				if (newTarget.$ === 3) {
					var t1 = newTarget.b;
					return A2(
						$mdgriffith$elm_style_animation$Animation$Model$Property,
						name,
						A2(setMotionTarget, m1, t1));
				} else {
					return current;
				}
			case 4:
				var name = current.a;
				var m1 = current.b;
				var m2 = current.c;
				if (newTarget.$ === 4) {
					var t1 = newTarget.b;
					var t2 = newTarget.c;
					return A3(
						$mdgriffith$elm_style_animation$Animation$Model$Property2,
						name,
						A2(setMotionTarget, m1, t1),
						A2(setMotionTarget, m2, t2));
				} else {
					return current;
				}
			case 5:
				var name = current.a;
				var m1 = current.b;
				var m2 = current.c;
				var m3 = current.d;
				if (newTarget.$ === 5) {
					var t1 = newTarget.b;
					var t2 = newTarget.c;
					var t3 = newTarget.d;
					return A4(
						$mdgriffith$elm_style_animation$Animation$Model$Property3,
						name,
						A2(setMotionTarget, m1, t1),
						A2(setMotionTarget, m2, t2),
						A2(setMotionTarget, m3, t3));
				} else {
					return current;
				}
			case 6:
				var name = current.a;
				var m1 = current.b;
				var m2 = current.c;
				var m3 = current.d;
				var m4 = current.e;
				if (newTarget.$ === 6) {
					var t1 = newTarget.b;
					var t2 = newTarget.c;
					var t3 = newTarget.d;
					var t4 = newTarget.e;
					return A5(
						$mdgriffith$elm_style_animation$Animation$Model$Property4,
						name,
						A2(setMotionTarget, m1, t1),
						A2(setMotionTarget, m2, t2),
						A2(setMotionTarget, m3, t3),
						A2(setMotionTarget, m4, t4));
				} else {
					return current;
				}
			case 7:
				var name = current.a;
				var m1 = current.b;
				if (newTarget.$ === 7) {
					var t1 = newTarget.b;
					return A2(
						$mdgriffith$elm_style_animation$Animation$Model$AngleProperty,
						name,
						A2(setMotionTarget, m1, t1));
				} else {
					return current;
				}
			case 8:
				var currentPts = current.a;
				if (newTarget.$ === 8) {
					var targetPts = newTarget.a;
					var _v9 = A2($mdgriffith$elm_style_animation$Animation$Model$matchPoints, currentPts, targetPts);
					var m1s = _v9.a;
					var m2s = _v9.b;
					return $mdgriffith$elm_style_animation$Animation$Model$Points(
						A3(
							$elm$core$List$map2,
							F2(
								function (_v10, _v11) {
									var x1 = _v10.a;
									var y1 = _v10.b;
									var x2 = _v11.a;
									var y2 = _v11.b;
									return _Utils_Tuple2(
										A2(setMotionTarget, x1, x2),
										A2(setMotionTarget, y1, y2));
								}),
							m1s,
							m2s));
				} else {
					return current;
				}
			default:
				var cmds = current.a;
				if (newTarget.$ === 9) {
					var targets = newTarget.a;
					return $mdgriffith$elm_style_animation$Animation$Model$Path(
						A3($elm$core$List$map2, $mdgriffith$elm_style_animation$Animation$Model$setPathTarget, cmds, targets));
				} else {
					return current;
				}
		}
	});
var $mdgriffith$elm_style_animation$Animation$Model$zipPropertiesGreedy = F2(
	function (initialProps, newTargetProps) {
		var propertyMatch = F2(
			function (prop1, prop2) {
				return _Utils_eq(
					$mdgriffith$elm_style_animation$Animation$Model$propertyName(prop1),
					$mdgriffith$elm_style_animation$Animation$Model$propertyName(prop2));
			});
		var _v0 = A3(
			$elm$core$List$foldl,
			F2(
				function (_v1, _v2) {
					var stackA = _v2.a;
					var stackB = _v2.b;
					var result = _v2.c;
					var _v3 = $elm$core$List$head(stackA);
					if (_v3.$ === 1) {
						return _Utils_Tuple3(stackA, stackB, result);
					} else {
						var a = _v3.a;
						var _v4 = A2(
							$elm$core$List$partition,
							propertyMatch(a),
							stackB);
						var matchingBs = _v4.a;
						var nonMatchingBs = _v4.b;
						return _Utils_Tuple3(
							A2($elm$core$List$drop, 1, stackA),
							function () {
								if (!matchingBs.b) {
									return nonMatchingBs;
								} else {
									var b = matchingBs.a;
									var remainingBs = matchingBs.b;
									return _Utils_ap(remainingBs, nonMatchingBs);
								}
							}(),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									a,
									$elm$core$List$head(matchingBs)),
								result));
					}
				}),
			_Utils_Tuple3(initialProps, newTargetProps, _List_Nil),
			A2(
				$elm$core$List$repeat,
				$elm$core$List$length(initialProps),
				0));
		var warnings = _v0.b;
		var props = _v0.c;
		var _v6 = warnings;
		return $elm$core$List$reverse(props);
	});
var $mdgriffith$elm_style_animation$Animation$Model$startTowards = F3(
	function (overrideInterpolation, current, target) {
		return A2(
			$elm$core$List$filterMap,
			function (propPair) {
				if (!propPair.b.$) {
					var cur = propPair.a;
					var to = propPair.b.a;
					return $elm$core$Maybe$Just(
						A3($mdgriffith$elm_style_animation$Animation$Model$setTarget, overrideInterpolation, cur, to));
				} else {
					var prop = propPair.a;
					var _v1 = propPair.b;
					return $elm$core$Maybe$Just(prop);
				}
			},
			A2($mdgriffith$elm_style_animation$Animation$Model$zipPropertiesGreedy, current, target));
	});
var $mdgriffith$elm_style_animation$Animation$Model$tolerance = 0.01;
var $mdgriffith$elm_style_animation$Animation$Model$vTolerance = 0.1;
var $mdgriffith$elm_style_animation$Animation$Model$stepInterpolation = F2(
	function (posix, motion) {
		var interpolationToUse = A2($elm$core$Maybe$withDefault, motion.mi, motion.C$);
		var dtms = $elm$time$Time$posixToMillis(posix);
		switch (interpolationToUse.$) {
			case 2:
				var perSecond = interpolationToUse.a.zF;
				var _v1 = function () {
					if (_Utils_cmp(motion.Fl, motion.nC) < 0) {
						var _new = motion.Fl + (perSecond * (dtms / 1000));
						return _Utils_Tuple2(
							_new,
							_Utils_cmp(_new, motion.nC) > -1);
					} else {
						var _new = motion.Fl - (perSecond * (dtms / 1000));
						return _Utils_Tuple2(
							_new,
							_Utils_cmp(_new, motion.nC) < 1);
					}
				}();
				var newPos = _v1.a;
				var finished = _v1.b;
				return finished ? _Utils_update(
					motion,
					{Fl: motion.nC, G$: 0.0}) : _Utils_update(
					motion,
					{Fl: newPos, G$: perSecond * 1000});
			case 0:
				var stiffness = interpolationToUse.a.Af;
				var damping = interpolationToUse.a.xR;
				var fspring = stiffness * (motion.nC - motion.Fl);
				var fdamper = ((-1) * damping) * motion.G$;
				var dt = dtms / 1000;
				var a = fspring + fdamper;
				var newVelocity = motion.G$ + (a * dt);
				var newPos = motion.Fl + (newVelocity * dt);
				var dx = $elm$core$Basics$abs(motion.nC - newPos);
				return ((_Utils_cmp(dx, $mdgriffith$elm_style_animation$Animation$Model$tolerance) < 0) && (_Utils_cmp(
					$elm$core$Basics$abs(newVelocity),
					$mdgriffith$elm_style_animation$Animation$Model$vTolerance) < 0)) ? _Utils_update(
					motion,
					{Fl: motion.nC, G$: 0.0}) : _Utils_update(
					motion,
					{Fl: newPos, G$: newVelocity});
			default:
				var progress = interpolationToUse.a.Fq;
				var duration = interpolationToUse.a.tJ;
				var ease = interpolationToUse.a.tK;
				var start = interpolationToUse.a.cH;
				var durationMs = $elm$time$Time$posixToMillis(duration);
				var newProgress = (((dtms / durationMs) + progress) < 1) ? ((dtms / durationMs) + progress) : 1;
				var eased = ease(newProgress);
				var distance = motion.nC - start;
				var newPos = ((((eased * distance) + start) * 10000) | 0) / 10000;
				var newVelocity = (newProgress === 1) ? 0 : ((newPos - motion.Fl) / dtms);
				var _v2 = motion.C$;
				if (_v2.$ === 1) {
					return _Utils_update(
						motion,
						{
							mi: $mdgriffith$elm_style_animation$Animation$Model$Easing(
								{tJ: duration, tK: ease, Fq: newProgress, cH: start}),
							Fl: newPos,
							G$: newVelocity
						});
				} else {
					var override = _v2.a;
					return _Utils_update(
						motion,
						{
							C$: $elm$core$Maybe$Just(
								$mdgriffith$elm_style_animation$Animation$Model$Easing(
									{tJ: duration, tK: ease, Fq: newProgress, cH: start})),
							Fl: newPos,
							G$: newVelocity
						});
				}
		}
	});
var $mdgriffith$elm_style_animation$Animation$Model$stepPath = F2(
	function (dt, cmd) {
		var stepCoords = function (coords) {
			return A2(
				$elm$core$List$map,
				function (_v1) {
					var x = _v1.a;
					var y = _v1.b;
					return _Utils_Tuple2(
						A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, x),
						A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, y));
				},
				coords);
		};
		switch (cmd.$) {
			case 0:
				var m1 = cmd.a;
				var m2 = cmd.b;
				return A2(
					$mdgriffith$elm_style_animation$Animation$Model$Move,
					A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, m1),
					A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, m2));
			case 1:
				var m1 = cmd.a;
				var m2 = cmd.b;
				return A2(
					$mdgriffith$elm_style_animation$Animation$Model$MoveTo,
					A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, m1),
					A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, m2));
			case 2:
				var m1 = cmd.a;
				var m2 = cmd.b;
				return A2(
					$mdgriffith$elm_style_animation$Animation$Model$Line,
					A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, m1),
					A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, m2));
			case 3:
				var m1 = cmd.a;
				var m2 = cmd.b;
				return A2(
					$mdgriffith$elm_style_animation$Animation$Model$LineTo,
					A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, m1),
					A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, m2));
			case 4:
				var motion = cmd.a;
				return $mdgriffith$elm_style_animation$Animation$Model$Horizontal(
					A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, motion));
			case 5:
				var motion = cmd.a;
				return $mdgriffith$elm_style_animation$Animation$Model$HorizontalTo(
					A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, motion));
			case 6:
				var motion = cmd.a;
				return $mdgriffith$elm_style_animation$Animation$Model$Vertical(
					A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, motion));
			case 7:
				var motion = cmd.a;
				return $mdgriffith$elm_style_animation$Animation$Model$VerticalTo(
					A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, motion));
			case 8:
				var control1 = cmd.a.og;
				var control2 = cmd.a.oh;
				var point = cmd.a.hL;
				return $mdgriffith$elm_style_animation$Animation$Model$Curve(
					{
						og: _Utils_Tuple2(
							A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, control1.a),
							A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, control1.b)),
						oh: _Utils_Tuple2(
							A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, control2.a),
							A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, control2.b)),
						hL: _Utils_Tuple2(
							A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, point.a),
							A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, point.b))
					});
			case 9:
				var control1 = cmd.a.og;
				var control2 = cmd.a.oh;
				var point = cmd.a.hL;
				return $mdgriffith$elm_style_animation$Animation$Model$CurveTo(
					{
						og: _Utils_Tuple2(
							A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, control1.a),
							A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, control1.b)),
						oh: _Utils_Tuple2(
							A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, control2.a),
							A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, control2.b)),
						hL: _Utils_Tuple2(
							A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, point.a),
							A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, point.b))
					});
			case 10:
				var control = cmd.a.of;
				var point = cmd.a.hL;
				return $mdgriffith$elm_style_animation$Animation$Model$Quadratic(
					{
						of: _Utils_Tuple2(
							A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, control.a),
							A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, control.b)),
						hL: _Utils_Tuple2(
							A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, point.a),
							A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, point.b))
					});
			case 11:
				var control = cmd.a.of;
				var point = cmd.a.hL;
				return $mdgriffith$elm_style_animation$Animation$Model$QuadraticTo(
					{
						of: _Utils_Tuple2(
							A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, control.a),
							A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, control.b)),
						hL: _Utils_Tuple2(
							A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, point.a),
							A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, point.b))
					});
			case 12:
				var coords = cmd.a;
				return $mdgriffith$elm_style_animation$Animation$Model$SmoothQuadratic(
					stepCoords(coords));
			case 13:
				var coords = cmd.a;
				return $mdgriffith$elm_style_animation$Animation$Model$SmoothQuadraticTo(
					stepCoords(coords));
			case 14:
				var coords = cmd.a;
				return $mdgriffith$elm_style_animation$Animation$Model$Smooth(
					stepCoords(coords));
			case 15:
				var coords = cmd.a;
				return $mdgriffith$elm_style_animation$Animation$Model$SmoothTo(
					stepCoords(coords));
			case 16:
				var arc = cmd.a;
				return $mdgriffith$elm_style_animation$Animation$Model$ClockwiseArc(
					_Utils_update(
						arc,
						{
							os: A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, arc.os),
							pz: A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, arc.pz),
							pS: A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, arc.pS),
							AS: A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, arc.AS),
							AT: A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, arc.AT)
						}));
			case 17:
				var arc = cmd.a;
				return $mdgriffith$elm_style_animation$Animation$Model$AntiClockwiseArc(
					_Utils_update(
						arc,
						{
							os: A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, arc.os),
							pz: A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, arc.pz),
							pS: A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, arc.pS),
							AS: A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, arc.AS),
							AT: A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, arc.AT)
						}));
			default:
				return $mdgriffith$elm_style_animation$Animation$Model$Close;
		}
	});
var $mdgriffith$elm_style_animation$Animation$Model$step = F2(
	function (dt, props) {
		var stepProp = function (property) {
			switch (property.$) {
				case 0:
					var name = property.a;
					var value = property.b;
					return A2($mdgriffith$elm_style_animation$Animation$Model$ExactProperty, name, value);
				case 3:
					var name = property.a;
					var motion = property.b;
					return A2(
						$mdgriffith$elm_style_animation$Animation$Model$Property,
						name,
						A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, motion));
				case 4:
					var name = property.a;
					var motion1 = property.b;
					var motion2 = property.c;
					return A3(
						$mdgriffith$elm_style_animation$Animation$Model$Property2,
						name,
						A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, motion1),
						A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, motion2));
				case 5:
					var name = property.a;
					var motion1 = property.b;
					var motion2 = property.c;
					var motion3 = property.d;
					return A4(
						$mdgriffith$elm_style_animation$Animation$Model$Property3,
						name,
						A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, motion1),
						A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, motion2),
						A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, motion3));
				case 6:
					var name = property.a;
					var motion1 = property.b;
					var motion2 = property.c;
					var motion3 = property.d;
					var motion4 = property.e;
					return A5(
						$mdgriffith$elm_style_animation$Animation$Model$Property4,
						name,
						A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, motion1),
						A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, motion2),
						A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, motion3),
						A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, motion4));
				case 7:
					var name = property.a;
					var motion = property.b;
					return A2(
						$mdgriffith$elm_style_animation$Animation$Model$AngleProperty,
						name,
						A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, motion));
				case 1:
					var name = property.a;
					var red = property.b;
					var green = property.c;
					var blue = property.d;
					var alpha = property.e;
					return A5(
						$mdgriffith$elm_style_animation$Animation$Model$ColorProperty,
						name,
						A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, red),
						A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, green),
						A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, blue),
						A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, alpha));
				case 2:
					var name = property.a;
					var inset = property.b;
					var shadow = property.c;
					return A3(
						$mdgriffith$elm_style_animation$Animation$Model$ShadowProperty,
						name,
						inset,
						{
							kN: A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, shadow.kN),
							sX: A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, shadow.sX),
							hm: A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, shadow.hm),
							tZ: A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, shadow.tZ),
							hF: A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, shadow.hF),
							hG: A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, shadow.hG),
							vW: A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, shadow.vW),
							we: A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, shadow.we)
						});
				case 8:
					var points = property.a;
					return $mdgriffith$elm_style_animation$Animation$Model$Points(
						A2(
							$elm$core$List$map,
							function (_v1) {
								var x = _v1.a;
								var y = _v1.b;
								return _Utils_Tuple2(
									A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, x),
									A2($mdgriffith$elm_style_animation$Animation$Model$stepInterpolation, dt, y));
							},
							points));
				default:
					var cmds = property.a;
					return $mdgriffith$elm_style_animation$Animation$Model$Path(
						A2(
							$elm$core$List$map,
							$mdgriffith$elm_style_animation$Animation$Model$stepPath(dt),
							cmds));
			}
		};
		return A2($elm$core$List$map, stepProp, props);
	});
var $mdgriffith$elm_style_animation$Animation$Model$alreadyThere = F2(
	function (current, target) {
		return A2(
			$elm$core$List$all,
			$mdgriffith$elm_style_animation$Animation$Model$isDone,
			A2(
				$mdgriffith$elm_style_animation$Animation$Model$step,
				$elm$time$Time$millisToPosix(0),
				A3($mdgriffith$elm_style_animation$Animation$Model$startTowards, false, current, target)));
	});
var $mdgriffith$elm_style_animation$Animation$Model$replaceProps = F2(
	function (props, replacements) {
		var replacementNames = A2($elm$core$List$map, $mdgriffith$elm_style_animation$Animation$Model$propertyName, replacements);
		var removed = A2(
			$elm$core$List$filter,
			function (prop) {
				return !A2(
					$elm$core$List$member,
					$mdgriffith$elm_style_animation$Animation$Model$propertyName(prop),
					replacementNames);
			},
			props);
		return _Utils_ap(removed, replacements);
	});
var $mdgriffith$elm_style_animation$Animation$Model$resolveSteps = F3(
	function (currentStyle, steps, dt) {
		resolveSteps:
		while (true) {
			var _v0 = $elm$core$List$head(steps);
			if (_v0.$ === 1) {
				return _Utils_Tuple3(currentStyle, _List_Nil, _List_Nil);
			} else {
				var currentStep = _v0.a;
				switch (currentStep.$) {
					case 4:
						var n = currentStep.a;
						if ($elm$time$Time$posixToMillis(n) <= 0) {
							var $temp$currentStyle = currentStyle,
								$temp$steps = A2($elm$core$List$drop, 1, steps),
								$temp$dt = dt;
							currentStyle = $temp$currentStyle;
							steps = $temp$steps;
							dt = $temp$dt;
							continue resolveSteps;
						} else {
							return _Utils_Tuple3(
								currentStyle,
								_List_Nil,
								A2(
									$elm$core$List$cons,
									$mdgriffith$elm_style_animation$Animation$Model$Wait(
										$elm$time$Time$millisToPosix(
											$elm$time$Time$posixToMillis(n) - $elm$time$Time$posixToMillis(dt))),
									A2($elm$core$List$drop, 1, steps)));
						}
					case 5:
						var msg = currentStep.a;
						var _v2 = A3(
							$mdgriffith$elm_style_animation$Animation$Model$resolveSteps,
							currentStyle,
							A2($elm$core$List$drop, 1, steps),
							dt);
						var newStyle = _v2.a;
						var msgs = _v2.b;
						var remainingSteps = _v2.c;
						return _Utils_Tuple3(
							newStyle,
							A2($elm$core$List$cons, msg, msgs),
							remainingSteps);
					case 1:
						var target = currentStep.a;
						if (A2($mdgriffith$elm_style_animation$Animation$Model$alreadyThere, currentStyle, target)) {
							return _Utils_Tuple3(
								currentStyle,
								_List_Nil,
								A2($elm$core$List$drop, 1, steps));
						} else {
							var $temp$currentStyle = A3($mdgriffith$elm_style_animation$Animation$Model$startTowards, false, currentStyle, target),
								$temp$steps = A2(
								$elm$core$List$cons,
								$mdgriffith$elm_style_animation$Animation$Model$Step,
								A2($elm$core$List$drop, 1, steps)),
								$temp$dt = dt;
							currentStyle = $temp$currentStyle;
							steps = $temp$steps;
							dt = $temp$dt;
							continue resolveSteps;
						}
					case 2:
						var target = currentStep.a;
						if (A2($mdgriffith$elm_style_animation$Animation$Model$alreadyThere, currentStyle, target)) {
							return _Utils_Tuple3(
								currentStyle,
								_List_Nil,
								A2($elm$core$List$drop, 1, steps));
						} else {
							var $temp$currentStyle = A3($mdgriffith$elm_style_animation$Animation$Model$startTowards, true, currentStyle, target),
								$temp$steps = A2(
								$elm$core$List$cons,
								$mdgriffith$elm_style_animation$Animation$Model$Step,
								A2($elm$core$List$drop, 1, steps)),
								$temp$dt = dt;
							currentStyle = $temp$currentStyle;
							steps = $temp$steps;
							dt = $temp$dt;
							continue resolveSteps;
						}
					case 3:
						var props = currentStep.a;
						var $temp$currentStyle = A2($mdgriffith$elm_style_animation$Animation$Model$replaceProps, currentStyle, props),
							$temp$steps = A2($elm$core$List$drop, 1, steps),
							$temp$dt = dt;
						currentStyle = $temp$currentStyle;
						steps = $temp$steps;
						dt = $temp$dt;
						continue resolveSteps;
					case 0:
						var stepped = A2($mdgriffith$elm_style_animation$Animation$Model$step, dt, currentStyle);
						return A2($elm$core$List$all, $mdgriffith$elm_style_animation$Animation$Model$isDone, stepped) ? _Utils_Tuple3(
							A2(
								$elm$core$List$map,
								$mdgriffith$elm_style_animation$Animation$Model$mapToMotion(
									function (m) {
										return _Utils_update(
											m,
											{C$: $elm$core$Maybe$Nothing});
									}),
								stepped),
							_List_Nil,
							A2($elm$core$List$drop, 1, steps)) : _Utils_Tuple3(stepped, _List_Nil, steps);
					case 7:
						var substeps = currentStep.a;
						var $temp$currentStyle = currentStyle,
							$temp$steps = _Utils_ap(
							substeps,
							_List_fromArray(
								[
									$mdgriffith$elm_style_animation$Animation$Model$Loop(substeps)
								])),
							$temp$dt = dt;
						currentStyle = $temp$currentStyle;
						steps = $temp$steps;
						dt = $temp$dt;
						continue resolveSteps;
					default:
						var n = currentStep.a;
						var substeps = currentStep.b;
						if (n <= 0) {
							var $temp$currentStyle = currentStyle,
								$temp$steps = A2($elm$core$List$drop, 1, steps),
								$temp$dt = dt;
							currentStyle = $temp$currentStyle;
							steps = $temp$steps;
							dt = $temp$dt;
							continue resolveSteps;
						} else {
							var $temp$currentStyle = currentStyle,
								$temp$steps = _Utils_ap(
								substeps,
								_Utils_ap(
									_List_fromArray(
										[
											A2($mdgriffith$elm_style_animation$Animation$Model$Repeat, n - 1, substeps)
										]),
									A2($elm$core$List$drop, 1, steps))),
								$temp$dt = dt;
							currentStyle = $temp$currentStyle;
							steps = $temp$steps;
							dt = $temp$dt;
							continue resolveSteps;
						}
				}
			}
		}
	});
var $mdgriffith$elm_style_animation$Animation$Model$updateAnimation = F2(
	function (_v0, _v1) {
		var now = _v0;
		var model = _v1;
		var timing = A2($mdgriffith$elm_style_animation$Animation$Model$refreshTiming, now, model.As);
		var _v2 = A2(
			$elm$core$List$partition,
			function (_v4) {
				var wait = _v4.a;
				var mySteps = _v4.b;
				return $elm$time$Time$posixToMillis(wait) <= 0;
			},
			A2(
				$elm$core$List$map,
				function (_v3) {
					var wait = _v3.a;
					var mySteps = _v3.b;
					return _Utils_Tuple2(
						$elm$time$Time$millisToPosix(
							$elm$time$Time$posixToMillis(wait) - $elm$time$Time$posixToMillis(timing.Cm)),
						mySteps);
				},
				model.uh));
		var readyInterruption = _v2.a;
		var queuedInterruptions = _v2.b;
		var _v5 = function () {
			var _v6 = $elm$core$List$head(readyInterruption);
			if (!_v6.$) {
				var _v7 = _v6.a;
				var wait = _v7.a;
				var interrupt = _v7.b;
				return _Utils_Tuple2(
					interrupt,
					A2(
						$elm$core$List$map,
						$mdgriffith$elm_style_animation$Animation$Model$mapToMotion(
							function (m) {
								return _Utils_update(
									m,
									{C$: $elm$core$Maybe$Nothing});
							}),
						model.hW));
			} else {
				return _Utils_Tuple2(model.Gi, model.hW);
			}
		}();
		var steps = _v5.a;
		var style = _v5.b;
		var _v8 = A3($mdgriffith$elm_style_animation$Animation$Model$resolveSteps, style, steps, timing.Cm);
		var revisedStyle = _v8.a;
		var sentMessages = _v8.b;
		var revisedSteps = _v8.c;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					uh: queuedInterruptions,
					se: (!(!$elm$core$List$length(revisedSteps))) || (!(!$elm$core$List$length(queuedInterruptions))),
					Gi: revisedSteps,
					hW: revisedStyle,
					As: timing
				}),
			$elm$core$Platform$Cmd$batch(
				A2(
					$elm$core$List$map,
					function (m) {
						return A2(
							$elm$core$Task$perform,
							$elm$core$Basics$identity,
							$elm$core$Task$succeed(m));
					},
					sentMessages)));
	});
var $mdgriffith$elm_style_animation$Animation$Messenger$update = F2(
	function (tick, animation) {
		return A2($mdgriffith$elm_style_animation$Animation$Model$updateAnimation, tick, animation);
	});
var $author$project$Pages$PreferenceTwoFactor$validateCode = function (code) {
	return !$elm$core$String$isEmpty(code);
};
var $mdgriffith$elm_style_animation$Animation$wait = function (till) {
	return $mdgriffith$elm_style_animation$Animation$Model$Wait(till);
};
var $author$project$Pages$PreferenceTwoFactor$update = F3(
	function (session, action, model) {
		var creds = $author$project$Model$Session$getCreds(session);
		switch (action.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
			case 1:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$PreferenceTwoFactor$OnTOTPKey,
							$author$project$Request$TOTPKey$get(creds)),
						_Utils_update(
							model,
							{jz: $krisajenkins$remotedata$RemoteData$Loading})));
			case 3:
				var response = action.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								hW: A2(
									$mdgriffith$elm_style_animation$Animation$interrupt,
									_List_fromArray(
										[
											$mdgriffith$elm_style_animation$Animation$wait(
											$elm$time$Time$millisToPosix(200)),
											$mdgriffith$elm_style_animation$Animation$to(
											_List_fromArray(
												[
													$mdgriffith$elm_style_animation$Animation$opacity(1)
												]))
										]),
									model.hW),
								jz: $krisajenkins$remotedata$RemoteData$fromResult(response)
							})));
			case 4:
				var newCode = action.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{kD: newCode})));
			case 2:
				if (!action.a.$) {
					var user = action.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$SetUser(
							$elm$core$Maybe$Just(user)),
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{jz: $krisajenkins$remotedata$RemoteData$NotAsked})));
				} else {
					var err = action.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$PreferenceTwoFactor$rollbar.FZ, 'OnUser (Err err)', err, session),
							model));
				}
			case 5:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								hW: A2(
									$mdgriffith$elm_style_animation$Animation$interrupt,
									_List_fromArray(
										[
											$mdgriffith$elm_style_animation$Animation$to(
											_List_fromArray(
												[
													$mdgriffith$elm_style_animation$Animation$opacity(0)
												])),
											$mdgriffith$elm_style_animation$Animation$Messenger$send($author$project$Pages$PreferenceTwoFactor$CancelTwoFactor)
										]),
									model.hW)
							})));
			case 6:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{jz: $krisajenkins$remotedata$RemoteData$NotAsked})));
			case 7:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$PreferenceTwoFactor$OnUser,
							$author$project$Request$TOTPKey$delete(creds)),
						model));
			case 8:
				var sendRequestIfValidCode = $author$project$Pages$PreferenceTwoFactor$validateCode(model.kD) ? A2(
					$elm$core$Task$attempt,
					$author$project$Pages$PreferenceTwoFactor$OnUser,
					A2($author$project$Request$TOTPKey$post, model.kD, creds)) : $elm$core$Platform$Cmd$none;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, sendRequestIfValidCode, model));
			default:
				var animMsg = action.a;
				var _v1 = A2($mdgriffith$elm_style_animation$Animation$Messenger$update, animMsg, model.hW);
				var newStyle = _v1.a;
				var animationCommands = _v1.b;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						animationCommands,
						_Utils_update(
							model,
							{hW: newStyle})));
		}
	});
var $author$project$Model$AtTime$DynamicStart = 2;
var $author$project$Model$AtTime$New = 0;
var $author$project$Model$BuildPlanner$SolveLegacyEditor$ResetChanges = 1;
var $author$project$Model$BuildPlanner$SolveLegacyEditor$SolveRequired = 2;
var $author$project$Pages$ProjectConfig$OnBuildData = F3(
	function (a, b, c) {
		return {$: 20, a: a, b: b, c: c};
	});
var $author$project$Pages$ProjectConfig$packageLimit = 5;
var $author$project$Pages$ProjectConfig$analyticsEventFromPackageLimitKind = F2(
	function (pkgCount, kind) {
		if (!kind) {
			return $author$project$Ports$sendAnalyticsEvent(
				A2(
					$author$project$Model$Analytics$withValue,
					pkgCount,
					A2(
						$author$project$Model$Analytics$withLabel,
						'Limit = ' + $elm$core$String$fromInt($author$project$Pages$ProjectConfig$packageLimit),
						A2(
							$author$project$Model$Analytics$withAction,
							'Package limit reached',
							A2(
								$author$project$Model$Analytics$withCategory,
								'Project configuration',
								$author$project$Model$Analytics$newEvent('Package limit reached'))))));
		} else {
			return $author$project$Ports$sendAnalyticsEvent(
				A2(
					$author$project$Model$Analytics$withValue,
					pkgCount,
					A2(
						$author$project$Model$Analytics$withLabel,
						'Limit = ' + $elm$core$String$fromInt($author$project$Pages$ProjectConfig$packageLimit),
						A2(
							$author$project$Model$Analytics$withAction,
							'Package limit exceeded',
							A2(
								$author$project$Model$Analytics$withCategory,
								'Project configuration',
								$author$project$Model$Analytics$newEvent('Package limit exceeded'))))));
		}
	});
var $author$project$BuildPlanner$Object$Project$evaluate = F3(
	function (fillInOptionals____, requiredArgs____, object____) {
		var filledInOptionals____ = fillInOptionals____(
			{jE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, v6: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, nC: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs____ = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'atTime',
					filledInOptionals____.jE,
					A2(
						$author$project$BuildPlanner$Scalar$unwrapEncoder,
						function ($) {
							return $.BL;
						},
						$author$project$BuildPlannerScalarCodecs$codecs)),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'target', filledInOptionals____.nC, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string),
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'sessionId',
					filledInOptionals____.v6,
					A2(
						$author$project$BuildPlanner$Scalar$unwrapEncoder,
						function ($) {
							return $.oc;
						},
						$author$project$BuildPlannerScalarCodecs$codecs))
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'evaluate',
			_Utils_ap(
				optionalArgs____,
				_List_fromArray(
					[
						A3(
						$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required,
						'expr',
						requiredArgs____.cG,
						A2(
							$author$project$BuildPlanner$Scalar$unwrapEncoder,
							function ($) {
								return $.k8;
							},
							$author$project$BuildPlannerScalarCodecs$codecs))
					])),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$BuildPlanner$Union$EvaluateResult$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BuildPlanning', selections____.u4),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'BuildPlanned', selections____.u3),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ParseError', selections____.vq),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ValidationError', selections____.vC),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'PlanningError', selections____.vr),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInput', selections____.vj)
			]));
};
var $author$project$Model$BuildPlanner$BuildPlan$isPlanningState = function (state) {
	if (!state.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Request$BuildPlanner$isPlanningState = function (buildPlan) {
	return $author$project$Model$BuildPlanner$BuildPlan$isPlanningState(buildPlan.bB);
};
var $author$project$Model$BuildPlanner$BuildPlan$BuildPlanning = {$: 0};
var $author$project$BuildPlanner$Object$BuildPlanning$components = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'components',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$BuildPlanner$Object$BuildPlanning$nodes = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'nodes',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$BuildPlanner$Object$BuildPlanning$resolvedRequirements = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'resolvedRequirements',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$BuildPlanner$Object$BuildPlanning$sessionId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe BuildPlannerScalarCodecs.Id)',
	'sessionId',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).oc.qN));
var $author$project$BuildPlanner$Object$BuildPlanning$steps = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'steps',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$BuildPlanner$Object$BuildPlanning$terminals = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'terminals',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Model$BuildPlanner$BuildPlan$selectionSetPlanning = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$BuildPlanner$Object$BuildPlanning$sessionId,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$BuildPlanning$components($author$project$Model$BuildPlanner$Component$selectionSet),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$BuildPlanner$Object$BuildPlanning$resolvedRequirements($author$project$Model$BuildPlanner$ResolvedRequirement$selectionSet),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$BuildPlanner$Object$BuildPlanning$terminals($author$project$Model$BuildPlanner$TaggedNodes$selectionSet),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$BuildPlanner$Object$BuildPlanning$steps($author$project$Model$BuildPlanner$Step$selectionSet),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$BuildPlanner$Object$BuildPlanning$nodes($author$project$Model$BuildPlanner$Node$selectionSet),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$hardcoded,
							$author$project$Model$BuildPlanner$BuildPlan$BuildPlanning,
							$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$BuildPlan$BuildPlan))))))));
var $author$project$Request$BuildPlanner$evaluate = F2(
	function (session, _v0) {
		var orgName = _v0.ix;
		var projectName = _v0.vT;
		var buildExpr = _v0.k$;
		var atTime = _v0.jE;
		var isDynamicImports = function () {
			if (atTime.$ === 1) {
				return false;
			} else {
				switch (atTime.a.$) {
					case 0:
						return false;
					case 1:
						var _v2 = atTime.a;
						return true;
					default:
						var _v3 = atTime.a;
						return true;
				}
			}
		}();
		var creds = $author$project$Model$Session$getCreds(session);
		var request = function (mSessionId) {
			return $author$project$Model$BuildPlanner$BuildPlannerError$simplifyTask(
				A5(
					$author$project$GraphQL$Utils$queryRequest,
					creds,
					4,
					_List_Nil,
					'Evaluate',
					A2(
						$author$project$BuildPlanner$Query$project,
						{c3: orgName, c5: projectName},
						$author$project$BuildPlanner$Union$ProjectResult$fragments(
							{
								vp: A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
									A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Model$BuildPlanner$BuildPlannerError$NotFoundError),
									$author$project$Model$BuildPlanner$Error$NotFoundError$selectionSet),
								vt: A3(
									$author$project$BuildPlanner$Object$Project$evaluate,
									function (args) {
										return _Utils_update(
											args,
											{
												jE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(atTime),
												v6: $dillonkearns$elm_graphql$Graphql$OptionalArgument$fromMaybe(mSessionId)
											});
									},
									{
										cG: $author$project$Model$BuildPlanner$BuildExpr$encode(buildExpr)
									},
									$author$project$BuildPlanner$Union$EvaluateResult$fragments(
										{
											u3: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Result$Ok, $author$project$Model$BuildPlanner$BuildPlan$selectionSetPlanned),
											u4: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Result$Ok, $author$project$Model$BuildPlanner$BuildPlan$selectionSetPlanning),
											vj: A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
												A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Model$BuildPlanner$BuildPlannerError$InvalidInputError),
												$author$project$Model$BuildPlanner$Error$InvalidInputError$selectionSet),
											vq: A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
												A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Model$BuildPlanner$BuildPlannerError$ParseError),
												$author$project$Model$BuildPlanner$Error$ParseError$selectionSet),
											vr: A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
												A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Model$BuildPlanner$BuildPlannerError$PlanningError),
												$author$project$Model$BuildPlanner$Error$PlanningError$selectionSet),
											vC: A2(
												$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
												A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Model$BuildPlanner$BuildPlannerError$ValidationError),
												$author$project$Model$BuildPlanner$Error$ValidationError$selectionSet)
										}))
							}))));
		};
		return isDynamicImports ? A2(
			$elm$core$Task$andThen,
			function (buildPlan) {
				return A3(
					$author$project$Request$BuildPlanner$withActivePolling,
					$author$project$Request$BuildPlanner$isPlanningState,
					$author$project$Model$BuildPlanner$BuildPlannerError$isPossiblyTransient,
					request(buildPlan.v6));
			},
			request($elm$core$Maybe$Nothing)) : A3(
			$author$project$Request$BuildPlanner$withActivePolling,
			$author$project$Request$BuildPlanner$isPlanningState,
			$author$project$Model$BuildPlanner$BuildPlannerError$isPossiblyTransient,
			request($elm$core$Maybe$Nothing));
	});
var $author$project$Model$BuildPlanner$BuildPlan$BuildCompleted = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$BuildPlanner$BuildPlan$CompletedData = F3(
	function (startedAt, finishedAt, buildLogIds) {
		return {s_: buildLogIds, yl: finishedAt, Ae: startedAt};
	});
var $author$project$BuildPlanner$Object$BuildCompleted$buildLogIds = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'buildLogIds',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$BuildPlanner$Object$BuildCompleted$components = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'components',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$BuildPlanner$Object$BuildCompleted$finishedAt = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'BuildPlannerScalarCodecs.DateTime',
	'finishedAt',
	_List_Nil,
	$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).qE.qN);
var $author$project$BuildPlanner$Object$BuildCompleted$resolvedRequirements = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'resolvedRequirements',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$BuildPlanner$Union$BuildLogId$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'CamelBuildId', selections____.u6),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'AltBuildId', selections____.uY)
			]));
};
var $author$project$BuildPlanner$Object$AltBuildId$id = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'BuildPlannerScalarCodecs.Id',
	'id',
	_List_Nil,
	$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).oc.qN);
var $author$project$BuildPlanner$Object$CamelBuildId$id = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'BuildPlannerScalarCodecs.Id',
	'id',
	_List_Nil,
	$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).oc.qN);
var $author$project$BuildPlanner$Object$CamelBuildId$platformId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'BuildPlannerScalarCodecs.Id',
	'platformId',
	_List_Nil,
	$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).oc.qN);
var $author$project$Model$BuildPlanner$BuildLogId$selectionSet = function () {
	var toStr = $dillonkearns$elm_graphql$Graphql$SelectionSet$map($danyx23$elm_uuid$Uuid$toString);
	return $author$project$BuildPlanner$Union$BuildLogId$fragments(
		{
			uY: A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				toStr($author$project$BuildPlanner$Object$AltBuildId$id),
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$BuildLogId$altLogId)),
			u6: A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				toStr($author$project$BuildPlanner$Object$CamelBuildId$id),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					toStr($author$project$BuildPlanner$Object$CamelBuildId$platformId),
					$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$BuildLogId$camelLogId)))
		});
}();
var $author$project$BuildPlanner$Object$BuildCompleted$sessionId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe BuildPlannerScalarCodecs.Id)',
	'sessionId',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).oc.qN));
var $author$project$BuildPlanner$Object$BuildCompleted$startedAt = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'BuildPlannerScalarCodecs.DateTime',
	'startedAt',
	_List_Nil,
	$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).qE.qN);
var $author$project$BuildPlanner$Object$BuildCompleted$steps = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'steps',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$BuildPlanner$Object$BuildCompleted$terminals = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'terminals',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Model$BuildPlanner$BuildPlan$selectionSetCompleted = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$BuildPlanner$Object$BuildCompleted$sessionId,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$BuildCompleted$components($author$project$Model$BuildPlanner$Component$selectionSet),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$BuildPlanner$Object$BuildCompleted$resolvedRequirements($author$project$Model$BuildPlanner$ResolvedRequirement$selectionSet),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$BuildPlanner$Object$BuildCompleted$terminals($author$project$Model$BuildPlanner$TaggedNodes$selectionSet),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$BuildPlanner$Object$BuildCompleted$steps($author$project$Model$BuildPlanner$Step$selectionSet),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$BuildPlanner$Object$BuildCompleted$nodes($author$project$Model$BuildPlanner$Node$selectionSet),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
								$author$project$Model$BuildPlanner$BuildPlan$BuildCompleted,
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$BuildPlanner$Object$BuildCompleted$buildLogIds($author$project$Model$BuildPlanner$BuildLogId$selectionSet),
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$BuildPlanner$Object$BuildCompleted$finishedAt,
										A2(
											$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
											$author$project$BuildPlanner$Object$BuildCompleted$startedAt,
											$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$BuildPlan$CompletedData))))),
							$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$BuildPlan$BuildPlan))))))));
var $author$project$Model$BuildPlanner$BuildPlan$BuildStarted = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$BuildPlanner$BuildPlan$StartedData = F2(
	function (startedAt, buildLogIds) {
		return {s_: buildLogIds, Ae: startedAt};
	});
var $author$project$BuildPlanner$Object$BuildStarted$buildLogIds = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'buildLogIds',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$BuildPlanner$Object$BuildStarted$components = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'components',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$BuildPlanner$Object$BuildStarted$nodes = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'nodes',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$BuildPlanner$Object$BuildStarted$resolvedRequirements = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'resolvedRequirements',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$BuildPlanner$Object$BuildStarted$sessionId = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe BuildPlannerScalarCodecs.Id)',
	'sessionId',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).oc.qN));
var $author$project$BuildPlanner$Object$BuildStarted$startedAt = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'BuildPlannerScalarCodecs.DateTime',
	'startedAt',
	_List_Nil,
	$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).qE.qN);
var $author$project$BuildPlanner$Object$BuildStarted$steps = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'steps',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$BuildPlanner$Object$BuildStarted$terminals = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'terminals',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
};
var $author$project$Model$BuildPlanner$BuildPlan$selectionSetStarted = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$BuildPlanner$Object$BuildStarted$sessionId,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$BuildStarted$components($author$project$Model$BuildPlanner$Component$selectionSet),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$BuildPlanner$Object$BuildStarted$resolvedRequirements($author$project$Model$BuildPlanner$ResolvedRequirement$selectionSet),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$BuildPlanner$Object$BuildStarted$terminals($author$project$Model$BuildPlanner$TaggedNodes$selectionSet),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$BuildPlanner$Object$BuildStarted$steps($author$project$Model$BuildPlanner$Step$selectionSet),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$BuildPlanner$Object$BuildStarted$nodes($author$project$Model$BuildPlanner$Node$selectionSet),
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
								$author$project$Model$BuildPlanner$BuildPlan$BuildStarted,
								A2(
									$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
									$author$project$BuildPlanner$Object$BuildStarted$buildLogIds($author$project$Model$BuildPlanner$BuildLogId$selectionSet),
									A2(
										$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
										$author$project$BuildPlanner$Object$BuildStarted$startedAt,
										$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$BuildPlan$StartedData)))),
							$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$BuildPlan$BuildPlan))))))));
var $author$project$Model$BuildPlanner$BuildPlan$selectionSet = A2(
	$author$project$BuildPlanner$Object$Commit$build,
	$elm$core$Basics$identity,
	$author$project$BuildPlanner$Union$BuildResult$fragments(
		{
			u2: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Result$Ok, $author$project$Model$BuildPlanner$BuildPlan$selectionSetCompleted),
			u3: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Result$Ok, $author$project$Model$BuildPlanner$BuildPlan$selectionSetPlanned),
			u4: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Result$Ok, $author$project$Model$BuildPlanner$BuildPlan$selectionSetPlanning),
			u5: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Result$Ok, $author$project$Model$BuildPlanner$BuildPlan$selectionSetStarted),
			vr: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Result$Err, $author$project$Model$BuildPlanner$Error$PlanningError$selectionSet)
		}));
var $author$project$Request$BuildPlanner$getBuildPlan = F3(
	function (session, withPolling, key) {
		var pollingFunc = withPolling ? A2($author$project$Request$BuildPlanner$withActivePolling, $author$project$Request$BuildPlanner$isPlanningState, $author$project$Model$BuildPlanner$BuildPlannerError$isPossiblyTransient) : $elm$core$Basics$identity;
		return pollingFunc(
			$author$project$Model$BuildPlanner$BuildPlannerError$simplifyTask(
				A2(
					$elm$core$Task$map,
					$elm$core$Result$mapError($author$project$Model$BuildPlanner$BuildPlannerError$PlanningError),
					A2(
						$author$project$Request$BuildPlanner$getByCommit,
						session,
						{
							Y: key,
							ke: $elm$core$Maybe$Just($elm$core$Result$Ok),
							kf: $elm$core$Maybe$Nothing,
							ki: $author$project$Model$BuildPlanner$BuildPlan$selectionSet,
							kj: 'GetBuildPlan'
						}))));
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$getPackages = $author$project$Model$BuildPlanner$SolveLegacyEditor$getBuildExprSolveEditor(
	$author$project$Model$Editor$getField($author$project$Model$BuildPlanner$SolveLegacyEditor$packagesGetter));
var $author$project$Model$BuildPlanner$SolveLegacyEditor$getTimestamp = $author$project$Model$BuildPlanner$SolveLegacyEditor$getBuildExprSolveEditor(
	$author$project$Model$Editor$getField(
		function ($) {
			return $.wG;
		}));
var $author$project$Pages$ProjectConfig$At = 0;
var $author$project$Pages$ProjectConfig$Over = 1;
var $author$project$Pages$ProjectConfig$reachedPackageLimit = function (pkgCount) {
	return _Utils_eq(pkgCount, $author$project$Pages$ProjectConfig$packageLimit) ? $elm$core$Maybe$Just(0) : ((_Utils_cmp(pkgCount, $author$project$Pages$ProjectConfig$packageLimit) > 0) ? $elm$core$Maybe$Just(1) : $elm$core$Maybe$Nothing);
};
var $author$project$Pages$ProjectConfig$packageLimitReached = F2(
	function (pkgCount, org) {
		var _v0 = _Utils_Tuple2(
			$author$project$Pages$ProjectConfig$reachedPackageLimit(pkgCount),
			$author$project$Model$Organization$isFreeTier(org));
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$removeMarkers = A2($author$project$Model$Editor$setField, $author$project$Model$BuildPlanner$BuildExprEditor$Simple$markersSetter, $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$MarkersNone);
var $author$project$Model$Editor$setFields = F2(
	function (fields, _v0) {
		var internal = _v0;
		return _Utils_update(
			internal,
			{g5: fields});
	});
var $author$project$Pages$ProjectConfig$fetchBuildDataCmd = F3(
	function (model, session, type_) {
		var projectName = $author$project$Model$Project$getName(model.c5);
		var pkgCount = $elm$core$Dict$size(
			$author$project$Model$BuildPlanner$SolveLegacyEditor$getBundles(model.qR)) + $elm$core$Dict$size(
			$author$project$Model$BuildPlanner$SolveLegacyEditor$getPackages(model.qR));
		var orgName = $author$project$Model$Organization$getUrlName(model.c3);
		var commit = model.f0;
		var commitID = $author$project$Model$Commit$getCommitID(commit);
		var buildPlanCmd = function () {
			switch (type_) {
				case 0:
					return A2(
						$elm$core$Task$attempt,
						A2($author$project$Pages$ProjectConfig$OnBuildData, type_, model.qR),
						A2(
							$author$project$Request$BuildPlanner$evaluate,
							session,
							{
								jE: A2(
									$elm$core$Maybe$map,
									$author$project$Model$AtTime$Timestamp,
									$author$project$Model$BuildPlanner$SolveLegacyEditor$getTimestamp(model.qR)),
								k$: $author$project$Model$BuildPlanner$BuildExprEditor$Simple$toBuildExpr(model.qR),
								ix: orgName,
								vT: projectName
							}));
				case 1:
					return A2(
						$elm$core$Task$attempt,
						A2($author$project$Pages$ProjectConfig$OnBuildData, type_, model.qR),
						A3(
							$author$project$Request$BuildPlanner$getBuildPlan,
							session,
							true,
							{BR: commitID, ix: orgName, vT: projectName}));
				case 2:
					var editor = $author$project$Model$BuildPlanner$BuildExprEditor$Simple$getSolve(model.qR);
					var fields = $author$project$Model$Editor$getFields(editor);
					var newEditor = A2(
						$author$project$Model$Editor$setFields,
						_Utils_update(
							fields,
							{ya: true}),
						editor);
					return A2(
						$elm$core$Task$attempt,
						A2($author$project$Pages$ProjectConfig$OnBuildData, type_, model.qR),
						A2(
							$author$project$Request$BuildPlanner$evaluate,
							session,
							{
								jE: $elm$core$Maybe$Just($author$project$Model$AtTime$Dynamic),
								k$: $author$project$Model$BuildPlanner$BuildExprEditor$Simple$toBuildExpr(
									$author$project$Model$BuildPlanner$BuildExprEditor$Simple$removeMarkers(
										A2($author$project$Model$BuildPlanner$BuildExprEditor$Simple$setSolve, newEditor, model.qR))),
								ix: orgName,
								vT: projectName
							}));
				default:
					return $elm$core$Platform$Cmd$none;
			}
		}();
		var analyticsCmd = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Platform$Cmd$none,
			A2(
				$elm$core$Maybe$map,
				$author$project$Pages$ProjectConfig$analyticsEventFromPackageLimitKind(pkgCount),
				A2($author$project$Pages$ProjectConfig$packageLimitReached, pkgCount, model.c3)));
		return $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[buildPlanCmd, analyticsCmd]));
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$NoChanges = 0;
var $author$project$Model$BuildPlanner$SolveLegacyEditor$ChangedItemBuildFlag = function (a) {
	return {$: 6, a: a};
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$ChangedItemBundle = function (a) {
	return {$: 8, a: a};
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$ChangedItemCamelFlag = function (a) {
	return {$: 5, a: a};
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$ChangedItemHidden = function (a) {
	return {$: 10, a: a};
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$ChangedItemLanguage = function (a) {
	return {$: 7, a: a};
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$ChangedItemMarkerKind = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$ChangedItemPackage = function (a) {
	return {$: 9, a: a};
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$ChangedItemPackager = function (a) {
	return {$: 4, a: a};
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$ChangedItemPlatform = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$ChangedItemSolverVersion = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$ChangedItemTimestamp = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$Editor$fromOriginalAndCurrent = F2(
	function (original, current) {
		return {g5: current, jl: original};
	});
var $author$project$Model$Editor$toOriginalAndCurrent = function (_v0) {
	var internal = _v0;
	return _Utils_Tuple2(internal.jl, internal.g5);
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$getStateToolArtifacts = function (editor) {
	var _v0 = A3(
		$elm$core$Tuple$mapBoth,
		function ($) {
			return $.Ec;
		},
		function ($) {
			return $.Ec;
		},
		$author$project$Model$Editor$toOriginalAndCurrent(editor));
	if (_v0.a.$ === 2) {
		if (_v0.b.$ === 2) {
			var _v1 = _v0.a;
			var original = _v1.b;
			var _v2 = _v0.b;
			var current = _v2.b;
			return $elm$core$Maybe$Just(
				A2($author$project$Model$Editor$fromOriginalAndCurrent, original, current));
		} else {
			var _v3 = _v0.a;
			var original = _v3.b;
			return $elm$core$Maybe$Just(
				A2(
					$author$project$Model$Editor$fromOriginalAndCurrent,
					original,
					{xs: $author$project$Model$BuildPlanner$BuildExpr$BuildFlagsDict$init}));
		}
	} else {
		if (_v0.b.$ === 2) {
			var _v4 = _v0.b;
			var current = _v4.b;
			return $elm$core$Maybe$Just(
				A2(
					$author$project$Model$Editor$fromOriginalAndCurrent,
					{xs: $author$project$Model$BuildPlanner$BuildExpr$BuildFlagsDict$init},
					current));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$getStateToolArtifactsV1 = function (editor) {
	var _v0 = A3(
		$elm$core$Tuple$mapBoth,
		function ($) {
			return $.Ec;
		},
		function ($) {
			return $.Ec;
		},
		$author$project$Model$Editor$toOriginalAndCurrent(editor));
	if (_v0.a.$ === 3) {
		if (_v0.b.$ === 3) {
			var original = _v0.a.a;
			var current = _v0.b.a;
			return $elm$core$Maybe$Just(
				A2($author$project$Model$Editor$fromOriginalAndCurrent, original, current));
		} else {
			var original = _v0.a.a;
			return $elm$core$Maybe$Just(
				A2(
					$author$project$Model$Editor$fromOriginalAndCurrent,
					original,
					{xs: $author$project$Model$BuildPlanner$BuildExpr$BuildFlagsDict$init}));
		}
	} else {
		if (_v0.b.$ === 3) {
			var current = _v0.b.a;
			return $elm$core$Maybe$Just(
				A2(
					$author$project$Model$Editor$fromOriginalAndCurrent,
					{xs: $author$project$Model$BuildPlanner$BuildExpr$BuildFlagsDict$init},
					current));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$getBuildExprStateToolArtifactsEditor = F2(
	function (_v0, editor) {
		var func = _v0.i8;
		var funcV1 = _v0.lZ;
		var _default = _v0.xW;
		var _v1 = _Utils_Tuple2(
			$author$project$Model$BuildPlanner$BuildExprEditor$Simple$getStateToolArtifacts(editor),
			$author$project$Model$BuildPlanner$BuildExprEditor$Simple$getStateToolArtifactsV1(editor));
		if (!_v1.a.$) {
			var stateToolArtifactsEditor = _v1.a.a;
			return func(stateToolArtifactsEditor);
		} else {
			if (!_v1.b.$) {
				var stateToolArtifactsV1Editor = _v1.b.a;
				return funcV1(stateToolArtifactsV1Editor);
			} else {
				return _default;
			}
		}
	});
var $author$project$Model$Editor$Added = {$: 0};
var $author$project$Model$Editor$Removed = {$: 2};
var $author$project$Model$Editor$Unchanged = {$: 3};
var $author$project$Model$Editor$UpdatedFrom = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$Editor$maybesToStatus = F2(
	function (original, current) {
		var _v0 = _Utils_Tuple2(original, current);
		if (_v0.a.$ === 1) {
			if (_v0.b.$ === 1) {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				return $author$project$Model$Editor$Unchanged;
			} else {
				var _v3 = _v0.a;
				return $author$project$Model$Editor$Added;
			}
		} else {
			if (!_v0.b.$) {
				var o = _v0.a.a;
				var c = _v0.b.a;
				return (!_Utils_eq(o, c)) ? $author$project$Model$Editor$UpdatedFrom(o) : $author$project$Model$Editor$Unchanged;
			} else {
				var _v4 = _v0.b;
				return $author$project$Model$Editor$Removed;
			}
		}
	});
var $author$project$Model$Editor$getItemsDict = F3(
	function (getter, toItemValue, editor) {
		var original = A2($author$project$Model$Editor$getFieldOriginal, getter, editor);
		var current = A2($author$project$Model$Editor$getField, getter, editor);
		var accumItem = F5(
			function (key, value, originalValue, currentValue, revAcc) {
				return A2(
					$elm$core$List$cons,
					{
						L: A2(
							$author$project$Model$Editor$maybesToStatus,
							A2(
								$elm$core$Maybe$map,
								toItemValue(key),
								originalValue),
							A2(
								$elm$core$Maybe$map,
								toItemValue(key),
								currentValue)),
						kH: A2(toItemValue, key, value)
					},
					revAcc);
			});
		var _v0 = _Utils_Tuple3(
			F2(
				function (key, x) {
					return A4(
						accumItem,
						key,
						x,
						$elm$core$Maybe$Just(x),
						$elm$core$Maybe$Nothing);
				}),
			F3(
				function (key, x, y) {
					return A4(
						accumItem,
						key,
						y,
						$elm$core$Maybe$Just(x),
						$elm$core$Maybe$Just(y));
				}),
			F2(
				function (key, y) {
					return A4(
						accumItem,
						key,
						y,
						$elm$core$Maybe$Nothing,
						$elm$core$Maybe$Just(y));
				}));
		var inOriginalOnly = _v0.a;
		var inBoth = _v0.b;
		var inCurrentOnly = _v0.c;
		return $elm$core$List$reverse(
			A6($elm$core$Dict$merge, inOriginalOnly, inBoth, inCurrentOnly, original, current, _List_Nil));
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$getBuildFlagItems = $author$project$Model$BuildPlanner$SolveLegacyEditor$getBuildExprStateToolArtifactsEditor(
	{
		xW: _List_Nil,
		i8: A2(
			$author$project$Model$Editor$getItemsDict,
			function ($) {
				return $.xs;
			},
			$author$project$Model$BuildPlanner$BuildExpr$BuildFlagsDict$buildFlagFromNameAndValue),
		lZ: A2(
			$author$project$Model$Editor$getItemsDict,
			function ($) {
				return $.xs;
			},
			$author$project$Model$BuildPlanner$BuildExpr$BuildFlagsDict$buildFlagFromNameAndValue)
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$getBundleItems = $author$project$Model$BuildPlanner$SolveLegacyEditor$getBuildExprSolveEditor(
	A2($author$project$Model$Editor$getItemsDict, $author$project$Model$BuildPlanner$SolveLegacyEditor$bundlesGetter, $author$project$Model$BuildPlanner$BuildExpr$Solve$Requirement$KeyAndConstraint));
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$getCamel = function (editor) {
	var _v0 = A3(
		$elm$core$Tuple$mapBoth,
		function ($) {
			return $.Ec;
		},
		function ($) {
			return $.Ec;
		},
		$author$project$Model$Editor$toOriginalAndCurrent(editor));
	if (!_v0.a.$) {
		if (!_v0.b.$) {
			var original = _v0.a.a;
			var current = _v0.b.a;
			return $elm$core$Maybe$Just(
				A2($author$project$Model$Editor$fromOriginalAndCurrent, original, current));
		} else {
			var original = _v0.a.a;
			return $elm$core$Maybe$Just(
				A2(
					$author$project$Model$Editor$fromOriginalAndCurrent,
					original,
					{Bn: $elm$core$Set$empty}));
		}
	} else {
		if (!_v0.b.$) {
			var current = _v0.b.a;
			return $elm$core$Maybe$Just(
				A2(
					$author$project$Model$Editor$fromOriginalAndCurrent,
					{Bn: $elm$core$Set$empty},
					current));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$getBuildExprCamelEditor = F2(
	function (_v0, editor) {
		var func = _v0.i8;
		var _default = _v0.xW;
		return A2(
			$elm$core$Maybe$withDefault,
			_default,
			A2(
				$elm$core$Maybe$map,
				func,
				$author$project$Model$BuildPlanner$BuildExprEditor$Simple$getCamel(editor)));
	});
var $elm$core$Set$foldr = F3(
	function (func, initialState, _v0) {
		var dict = _v0;
		return A3(
			$elm$core$Dict$foldr,
			F3(
				function (key, _v1, state) {
					return A2(func, key, state);
				}),
			initialState,
			dict);
	});
var $author$project$Model$Editor$membersToStatus = F2(
	function (inOriginal, inCurrent) {
		var _v0 = _Utils_Tuple2(inOriginal, inCurrent);
		_v0$2:
		while (true) {
			if (!_v0.a) {
				if (_v0.b) {
					return $author$project$Model$Editor$Added;
				} else {
					break _v0$2;
				}
			} else {
				if (!_v0.b) {
					return $author$project$Model$Editor$Removed;
				} else {
					break _v0$2;
				}
			}
		}
		return $author$project$Model$Editor$Unchanged;
	});
var $elm$core$Set$union = F2(
	function (_v0, _v1) {
		var dict1 = _v0;
		var dict2 = _v1;
		return A2($elm$core$Dict$union, dict1, dict2);
	});
var $author$project$Model$Editor$getItemsSet = F2(
	function (getter, editor) {
		var original = A2($author$project$Model$Editor$getFieldOriginal, getter, editor);
		var current = A2($author$project$Model$Editor$getField, getter, editor);
		var all = A2($elm$core$Set$union, original, current);
		var accum = F2(
			function (key, acc) {
				return A2(
					$elm$core$List$cons,
					{
						L: A2(
							$author$project$Model$Editor$membersToStatus,
							A2($elm$core$Set$member, key, original),
							A2($elm$core$Set$member, key, current)),
						kH: key
					},
					acc);
			});
		return A3($elm$core$Set$foldr, accum, _List_Nil, all);
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$getCamelFlagItems = $author$project$Model$BuildPlanner$SolveLegacyEditor$getBuildExprCamelEditor(
	{
		xW: _List_Nil,
		i8: $author$project$Model$Editor$getItemsSet(
			function ($) {
				return $.Bn;
			})
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$hiddensGetter = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.FF;
	},
	function ($) {
		return $.oI;
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$getHiddenItems = $author$project$Model$BuildPlanner$SolveLegacyEditor$getBuildExprSolveEditor(
	A2($author$project$Model$Editor$getItemsDict, $author$project$Model$BuildPlanner$SolveLegacyEditor$hiddensGetter, $author$project$Model$BuildPlanner$BuildExpr$Solve$Requirement$KeyAndConstraint));
var $author$project$Model$BuildPlanner$BuildExpr$SolveEditor$LanguageNameAndVersion = F2(
	function (name, version) {
		return {w: name, aI: version};
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$getLanguageItems = $author$project$Model$BuildPlanner$SolveLegacyEditor$getBuildExprSolveEditor(
	A2($author$project$Model$Editor$getItemsDict, $author$project$Model$BuildPlanner$SolveLegacyEditor$languagesGetter, $author$project$Model$BuildPlanner$BuildExpr$SolveEditor$LanguageNameAndVersion));
var $author$project$Model$Editor$Item = F2(
	function (value, status) {
		return {L: status, kH: value};
	});
var $elm_community$maybe_extra$Maybe$Extra$orElse = F2(
	function (ma, mb) {
		if (mb.$ === 1) {
			return ma;
		} else {
			return mb;
		}
	});
var $author$project$Model$Editor$getItemMaybe = F2(
	function (getter, editor) {
		var original = A2($author$project$Model$Editor$getFieldOriginal, getter, editor);
		var current = A2($author$project$Model$Editor$getField, getter, editor);
		return A2(
			$elm$core$Maybe$map,
			A2(
				$elm_community$basics_extra$Basics$Extra$flip,
				$author$project$Model$Editor$Item,
				A2($author$project$Model$Editor$maybesToStatus, original, current)),
			A2($elm_community$maybe_extra$Maybe$Extra$orElse, original, current));
	});
var $author$project$Model$BuildPlanner$BuildExpr$MarkerKind$Camel = 0;
var $author$project$Model$BuildPlanner$BuildExpr$MarkerKind$StateToolArtifacts = 2;
var $author$project$Model$BuildPlanner$BuildExpr$MarkerKind$StateToolArtifactsV1 = 1;
var $author$project$Model$BuildPlanner$BuildExpr$MarkerKind$StateToolArtifactsWithCommunityArtifacts = 3;
var $author$project$Model$BuildPlanner$BuildExpr$MarkerKind$StateToolArtifactsWithWheelArtifacts = 4;
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$markersToMarkerKind = function (markers) {
	switch (markers.$) {
		case 0:
			return $elm$core$Maybe$Just(0);
		case 1:
			return $elm$core$Maybe$Nothing;
		case 2:
			switch (markers.a) {
				case 0:
					var _v1 = markers.a;
					return $elm$core$Maybe$Just(2);
				case 1:
					var _v2 = markers.a;
					return $elm$core$Maybe$Just(3);
				default:
					var _v3 = markers.a;
					return $elm$core$Maybe$Just(4);
			}
		case 3:
			return $elm$core$Maybe$Just(1);
		case 4:
			return $elm$core$Maybe$Nothing;
		case 5:
			return $elm$core$Maybe$Nothing;
		case 6:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$getMarkerItem = $author$project$Model$Editor$getItemMaybe(
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.Ec;
		},
		$author$project$Model$BuildPlanner$BuildExprEditor$Simple$markersToMarkerKind));
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$getMarkerItems = A2($elm$core$Basics$composeR, $author$project$Model$BuildPlanner$BuildExprEditor$Simple$getMarkerItem, $elm_community$maybe_extra$Maybe$Extra$toList);
var $author$project$Model$BuildPlanner$SolveLegacyEditor$getPackageItems = $author$project$Model$BuildPlanner$SolveLegacyEditor$getBuildExprSolveEditor(
	A2($author$project$Model$Editor$getItemsDict, $author$project$Model$BuildPlanner$SolveLegacyEditor$packagesGetter, $author$project$Model$BuildPlanner$BuildExpr$Solve$Requirement$KeyAndConstraint));
var $author$project$Model$BuildPlanner$BuildExpr$PackagerKind$all = _List_fromArray(
	[0, 1, 2, 3, 4]);
var $author$project$Model$Editor$getItemsMaybe = function (getter) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Model$Editor$getItemMaybe(getter),
		$elm_community$maybe_extra$Maybe$Extra$toList);
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$getPackagers = F2(
	function (platformID, editor) {
		var getter = A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.E2;
			},
			$elm$core$Dict$get(platformID));
		var _v0 = A3(
			$elm$core$Tuple$mapBoth,
			getter,
			getter,
			$author$project$Model$Editor$toOriginalAndCurrent(editor));
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var original = _v0.a.a;
				var current = _v0.b.a;
				return $elm$core$Maybe$Just(
					A2($author$project$Model$Editor$fromOriginalAndCurrent, original, current));
			} else {
				var original = _v0.a.a;
				return $elm$core$Maybe$Just(
					A2($author$project$Model$Editor$fromOriginalAndCurrent, original, $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$packagersInit));
			}
		} else {
			if (!_v0.b.$) {
				var current = _v0.b.a;
				return $elm$core$Maybe$Just(
					A2($author$project$Model$Editor$fromOriginalAndCurrent, $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$packagersInit, current));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	});
var $author$project$Model$Editor$itemMapStatus = F2(
	function (func, status) {
		switch (status.$) {
			case 0:
				return $author$project$Model$Editor$Added;
			case 1:
				var v = status.a;
				return $author$project$Model$Editor$UpdatedFrom(
					func(v));
			case 2:
				return $author$project$Model$Editor$Removed;
			default:
				return $author$project$Model$Editor$Unchanged;
		}
	});
var $author$project$Model$Editor$itemMapValue = F2(
	function (func, item) {
		var value = item.kH;
		return {
			L: A2($author$project$Model$Editor$itemMapStatus, func, item.L),
			kH: func(value)
		};
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$getPackagerItemsForPlatform = F2(
	function (platformID, editor) {
		var getPackagersItems = function (packagersEditor) {
			return A2(
				$elm$core$List$concatMap,
				function (kind) {
					switch (kind) {
						case 0:
							return A2(
								$elm$core$List$map,
								$author$project$Model$Editor$itemMapValue(
									$elm$core$Basics$always(kind)),
								A2(
									$author$project$Model$Editor$getItemsMaybe,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.Cj;
										},
										$elm$core$List$head),
									packagersEditor));
						case 1:
							return A2(
								$elm$core$List$map,
								$author$project$Model$Editor$itemMapValue(
									$elm$core$Basics$always(kind)),
								A2(
									$author$project$Model$Editor$getItemsMaybe,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.D4;
										},
										$elm$core$List$head),
									packagersEditor));
						case 2:
							return A2(
								$elm$core$List$map,
								$author$project$Model$Editor$itemMapValue(
									$elm$core$Basics$always(kind)),
								A2(
									$author$project$Model$Editor$getItemsMaybe,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.w4;
										},
										$elm$core$List$head),
									packagersEditor));
						case 3:
							return A2(
								$elm$core$List$map,
								$author$project$Model$Editor$itemMapValue(
									$elm$core$Basics$always(kind)),
								A2(
									$author$project$Model$Editor$getItemsMaybe,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.vX;
										},
										$elm$core$List$head),
									packagersEditor));
						default:
							return A2(
								$elm$core$List$map,
								$author$project$Model$Editor$itemMapValue(
									$elm$core$Basics$always(kind)),
								A2(
									$author$project$Model$Editor$getItemsMaybe,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.A8;
										},
										$elm$core$List$head),
									packagersEditor));
					}
				},
				$author$project$Model$BuildPlanner$BuildExpr$PackagerKind$all);
		};
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				getPackagersItems,
				A2($author$project$Model$BuildPlanner$BuildExprEditor$Simple$getPackagers, platformID, editor)));
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$getPackagerItems = function (editor) {
	var getPlatformIDs = function (_v0) {
		var packagers = _v0.E2;
		return $elm$core$Set$fromList(
			$elm$core$Dict$keys(packagers));
	};
	return A2(
		$elm$core$List$concatMap,
		function (platformStr) {
			return A2($author$project$Model$BuildPlanner$SolveLegacyEditor$getPackagerItemsForPlatform, platformStr, editor);
		},
		$elm$core$Set$toList(
			A2(
				$elm_community$basics_extra$Basics$Extra$uncurry,
				$elm$core$Set$union,
				A3(
					$elm$core$Tuple$mapBoth,
					getPlatformIDs,
					getPlatformIDs,
					$author$project$Model$Editor$toOriginalAndCurrent(editor)))));
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$getPlatformItems = $author$project$Model$BuildPlanner$SolveLegacyEditor$getBuildExprSolveEditor(
	$author$project$Model$Editor$getItemsSet(
		function ($) {
			return $.Fh;
		}));
var $author$project$Model$BuildPlanner$SolveLegacyEditor$getSolverVersionItems = $author$project$Model$BuildPlanner$SolveLegacyEditor$getBuildExprSolveEditor(
	$author$project$Model$Editor$getItemsMaybe(
		function ($) {
			return $.Ga;
		}));
var $author$project$Model$BuildPlanner$BuildExpr$SolveEditor$getTimestampItems = $author$project$Model$Editor$getItemsMaybe(
	function (solve) {
		return A2(
			$elm$core$Maybe$map,
			function (timestamp) {
				return _Utils_Tuple2(timestamp, solve.Gx);
			},
			solve.wG);
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$getTimestampItems = $author$project$Model$BuildPlanner$SolveLegacyEditor$getBuildExprSolveEditor($author$project$Model$BuildPlanner$BuildExpr$SolveEditor$getTimestampItems);
var $author$project$Model$BuildPlanner$SolveLegacyEditor$isExplicitTimestamp = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.kH;
	},
	$elm$core$Tuple$second);
var $author$project$Model$Editor$Change = F2(
	function (value, op) {
		return {ES: op, kH: value};
	});
var $author$project$Model$Editor$statusToOperation = function (status) {
	switch (status.$) {
		case 0:
			return $elm$core$Maybe$Just(0);
		case 1:
			return $elm$core$Maybe$Just(1);
		case 2:
			return $elm$core$Maybe$Just(2);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$Editor$itemToChange = function (_v0) {
	var value = _v0.kH;
	var status = _v0.L;
	return A2(
		$elm$core$Maybe$map,
		$author$project$Model$Editor$Change(value),
		$author$project$Model$Editor$statusToOperation(status));
};
var $author$project$Model$Editor$itemsToChanges = $elm$core$List$filterMap($author$project$Model$Editor$itemToChange);
var $author$project$Model$BuildPlanner$SolveLegacyEditor$getChangedItems = function (editor) {
	return $author$project$Model$Editor$itemsToChanges(
		_Utils_ap(
			A2(
				$elm$core$List$map,
				$author$project$Model$Editor$itemMapValue($author$project$Model$BuildPlanner$SolveLegacyEditor$ChangedItemMarkerKind),
				$author$project$Model$BuildPlanner$BuildExprEditor$Simple$getMarkerItems(editor)),
			_Utils_ap(
				A2(
					$elm$core$List$map,
					$author$project$Model$Editor$itemMapValue($author$project$Model$BuildPlanner$SolveLegacyEditor$ChangedItemSolverVersion),
					$author$project$Model$BuildPlanner$SolveLegacyEditor$getSolverVersionItems(editor)),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						$author$project$Model$Editor$itemMapValue($author$project$Model$BuildPlanner$SolveLegacyEditor$ChangedItemTimestamp),
						A2(
							$elm$core$List$filter,
							$author$project$Model$BuildPlanner$SolveLegacyEditor$isExplicitTimestamp,
							$author$project$Model$BuildPlanner$SolveLegacyEditor$getTimestampItems(editor))),
					_Utils_ap(
						A2(
							$elm$core$List$map,
							$author$project$Model$Editor$itemMapValue($author$project$Model$BuildPlanner$SolveLegacyEditor$ChangedItemPlatform),
							$author$project$Model$BuildPlanner$SolveLegacyEditor$getPlatformItems(editor)),
						_Utils_ap(
							A2(
								$elm$core$List$map,
								$author$project$Model$Editor$itemMapValue($author$project$Model$BuildPlanner$SolveLegacyEditor$ChangedItemPackager),
								$author$project$Model$BuildPlanner$SolveLegacyEditor$getPackagerItems(editor)),
							_Utils_ap(
								A2(
									$elm$core$List$map,
									$author$project$Model$Editor$itemMapValue($author$project$Model$BuildPlanner$SolveLegacyEditor$ChangedItemCamelFlag),
									$author$project$Model$BuildPlanner$SolveLegacyEditor$getCamelFlagItems(editor)),
								_Utils_ap(
									A2(
										$elm$core$List$map,
										$author$project$Model$Editor$itemMapValue($author$project$Model$BuildPlanner$SolveLegacyEditor$ChangedItemBuildFlag),
										$author$project$Model$BuildPlanner$SolveLegacyEditor$getBuildFlagItems(editor)),
									_Utils_ap(
										A2(
											$elm$core$List$map,
											$author$project$Model$Editor$itemMapValue($author$project$Model$BuildPlanner$SolveLegacyEditor$ChangedItemLanguage),
											$author$project$Model$BuildPlanner$SolveLegacyEditor$getLanguageItems(editor)),
										_Utils_ap(
											A2(
												$elm$core$List$map,
												$author$project$Model$Editor$itemMapValue($author$project$Model$BuildPlanner$SolveLegacyEditor$ChangedItemBundle),
												$author$project$Model$BuildPlanner$SolveLegacyEditor$getBundleItems(editor)),
											_Utils_ap(
												A2(
													$elm$core$List$map,
													$author$project$Model$Editor$itemMapValue($author$project$Model$BuildPlanner$SolveLegacyEditor$ChangedItemPackage),
													$author$project$Model$BuildPlanner$SolveLegacyEditor$getPackageItems(editor)),
												A2(
													$elm$core$List$map,
													$author$project$Model$Editor$itemMapValue($author$project$Model$BuildPlanner$SolveLegacyEditor$ChangedItemHidden),
													$author$project$Model$BuildPlanner$SolveLegacyEditor$getHiddenItems(editor)))))))))))));
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$getChangesComparedTo = function (_v0) {
	var old = _v0.zu;
	var _new = _v0.rC;
	var newChanges = $author$project$Model$BuildPlanner$SolveLegacyEditor$getChangedItems(_new);
	return _Utils_eq(
		newChanges,
		$author$project$Model$BuildPlanner$SolveLegacyEditor$getChangedItems(old)) ? 0 : ($elm$core$List$isEmpty(newChanges) ? 1 : 2);
};
var $author$project$External$AddBuildPlan = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$External$AddCommitAndBuildExpr = F3(
	function (a, b, c) {
		return {$: 14, a: a, b: b, c: c};
	});
var $author$project$Pages$ProjectConfig$BreakingChangesMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$ProjectConfig$CustomRequirementInputMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$ProjectConfig$DependenciesMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Model$AtTime$DynamicCommit = 3;
var $author$project$Model$AtTime$DynamicImports = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$AtTime$Existing = 1;
var $author$project$Pages$ProjectConfig$GenericSBOM = F2(
	function (a, b) {
		return {$: 53, a: a, b: b};
	});
var $author$project$Pages$ProjectConfig$ImportPackage = 1;
var $author$project$Pages$ProjectConfig$ImportPackagesModalMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$ProjectConfig$LanguageSelectionModalMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$NormsAndVulns$Namespaced = $elm$core$Basics$identity;
var $author$project$Model$NormsAndVulns$NamespacedVulnKey = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$ProjectConfig$NoOp = {$: 17};
var $author$project$Pages$ProjectConfig$None = {$: 0};
var $author$project$Pages$ProjectConfig$NormsAndVulnsMsg = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$ProjectConfig$OnBranchReloaded = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$ProjectConfig$OnBundlesMetadata = function (a) {
	return {$: 21, a: a};
};
var $author$project$Pages$ProjectConfig$OnCommitSaved = F2(
	function (a, b) {
		return {$: 22, a: a, b: b};
	});
var $author$project$Pages$ProjectConfig$OnConvertedToRuntime = F3(
	function (a, b, c) {
		return {$: 52, a: a, b: b, c: c};
	});
var $author$project$Pages$ProjectConfig$OnTaggedCommit = function (a) {
	return {$: 23, a: a};
};
var $author$project$Pages$ProjectConfig$Open = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$ProjectConfig$PlatformSelectionModalMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$ProjectConfig$PopularPackagesMsg = function (a) {
	return {$: 27, a: a};
};
var $author$project$Model$NormsAndVulns$PurlVulnKey = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$AtTime$Standard = {$: 0};
var $author$project$Pages$ProjectConfig$TimestampMsg = function (a) {
	return {$: 44, a: a};
};
var $author$project$Views$UpdateForkModal$UpdateBranch = 1;
var $author$project$Pages$ProjectConfig$UpdateForkModalMsg = function (a) {
	return {$: 46, a: a};
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$hiddensSetter = F2(
	function (hiddens, fields) {
		var requirements = fields.FF;
		return _Utils_update(
			fields,
			{
				FF: _Utils_update(
					requirements,
					{oI: hiddens})
			});
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$addHidden = function (key) {
	return A2(
		$elm$core$Basics$composeL,
		$author$project$Model$BuildPlanner$SolveLegacyEditor$setBuildExprSolveEditor,
		A3($author$project$Model$Editor$addKeyDict, $author$project$Model$BuildPlanner$SolveLegacyEditor$hiddensGetter, $author$project$Model$BuildPlanner$SolveLegacyEditor$hiddensSetter, key));
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$addLanguage = function (language) {
	return A2(
		$elm$core$Basics$composeL,
		$author$project$Model$BuildPlanner$SolveLegacyEditor$setBuildExprSolveEditor,
		A3($author$project$Model$Editor$addKeyDict, $author$project$Model$BuildPlanner$SolveLegacyEditor$languagesGetter, $author$project$Model$BuildPlanner$SolveLegacyEditor$languagesSetter, language));
};
var $author$project$Model$Editor$addKeySet = F4(
	function (getter, setter, key, editor) {
		var current = A2($author$project$Model$Editor$getField, getter, editor);
		return A3(
			$author$project$Model$Editor$setField,
			setter,
			A2($elm$core$Set$insert, key, current),
			editor);
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$addPlatform = A2(
	$elm$core$Basics$composeL,
	$author$project$Model$BuildPlanner$SolveLegacyEditor$setBuildExprSolveEditor,
	A2(
		$author$project$Model$Editor$addKeySet,
		function ($) {
			return $.Fh;
		},
		$author$project$Model$BuildPlanner$SolveLegacyEditor$platformsSetter));
var $author$project$Model$Tag$encodeTagEditable = function (tag) {
	var commitIDString = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $danyx23$elm_uuid$Uuid$toString, tag.BR));
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'commitID',
				$elm$json$Json$Encode$string(commitIDString)),
				_Utils_Tuple2(
				'label',
				$elm$json$Json$Encode$string(tag.b2))
			]));
};
var $author$project$Request$Project$addTag = F4(
	function (creds, orgName, projectName, tag) {
		return $author$project$Http$Extra$post(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$jsonBody(
					$author$project$Model$Tag$encodeTagEditable(tag)),
				qN: $author$project$Model$Tag$decode,
				CN: _List_Nil,
				GT: A2(
					$elm$url$Url$Builder$relative,
					_List_fromArray(
						[
							A2($author$project$Request$Project$urlPathOrgProject, orgName, projectName),
							'tags'
						]),
					_List_Nil)
			});
	});
var $elm_community$dict_extra$Dict$Extra$any = F2(
	function (predicate, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, acc) {
					return acc ? acc : (A2(predicate, k, v) ? true : false);
				}),
			false,
			dict);
	});
var $author$project$Model$Editor$commit = function (_v0) {
	var internal = _v0;
	return $author$project$Model$Editor$init(internal.g5);
};
var $author$project$Model$BuildPlanner$Error$SolveErrorValidationError$error = function (_v0) {
	var data = _v0;
	return data.yd;
};
var $author$project$Model$BuildPlanner$Error$GenericSolverError$errorMessages = function (_v0) {
	var data = _v0;
	return A2(
		$elm$core$List$cons,
		data.Eh,
		A2($elm$core$List$map, $author$project$Model$BuildPlanner$Error$SolveErrorValidationError$error, data.AJ));
};
var $author$project$Model$BuildPlanner$Error$GenericBuildExprError$message = function (_v0) {
	var data = _v0;
	return data.Eh;
};
var $author$project$Model$BuildPlanner$Error$RemediableError$message = function (_v0) {
	var data = _v0;
	return data.Eh;
};
var $author$project$Model$BuildPlanner$Error$RemediableSolveError$message = function (_v0) {
	var data = _v0;
	return data.Eh;
};
var $author$project$Model$BuildPlanner$Error$TargetNotFound$message = function (_v0) {
	var data = _v0;
	return data.Eh;
};
var $author$project$Model$BuildPlanner$Error$RemediableSolveError$validationErrors = function (_v0) {
	var data = _v0;
	return data.AJ;
};
var $author$project$Model$BuildPlanner$Error$BuildExprError$errorMessages = function (buildExprError) {
	switch (buildExprError.$) {
		case 0:
			var error = buildExprError.a;
			return $author$project$Model$BuildPlanner$Error$GenericSolverError$errorMessages(error);
		case 1:
			var error = buildExprError.a;
			return _List_fromArray(
				[
					$author$project$Model$BuildPlanner$Error$RemediableError$message(error)
				]);
		case 2:
			var error = buildExprError.a;
			return _List_fromArray(
				[
					$author$project$Model$BuildPlanner$Error$GenericBuildExprError$message(error)
				]);
		case 3:
			var error = buildExprError.a;
			return A2(
				$elm$core$List$cons,
				$author$project$Model$BuildPlanner$Error$RemediableSolveError$message(error),
				A2(
					$elm$core$List$map,
					$author$project$Model$BuildPlanner$Error$SolveErrorValidationError$error,
					$author$project$Model$BuildPlanner$Error$RemediableSolveError$validationErrors(error)));
		default:
			var error = buildExprError.a;
			return _List_fromArray(
				[
					$author$project$Model$BuildPlanner$Error$TargetNotFound$message(error)
				]);
	}
};
var $author$project$Model$BuildPlanner$Error$PlanningError$subErrors = function (_v0) {
	var data = _v0;
	return data.wt;
};
var $author$project$Pages$ProjectConfig$errorToAnalyticsMessage = function (error) {
	switch (error.$) {
		case 0:
			var err = error.a;
			return $author$project$Http$Extra$reason(err);
		case 7:
			var planningError = error.a;
			var subErrors = A2(
				$elm$core$List$concatMap,
				$author$project$Model$BuildPlanner$Error$BuildExprError$errorMessages,
				$author$project$Model$BuildPlanner$Error$PlanningError$subErrors(planningError));
			return A2(
				$elm$core$String$join,
				'|',
				A2(
					$elm$core$List$cons,
					$author$project$Model$BuildPlanner$Error$PlanningError$message(planningError),
					A2($elm$core$List$take, 1, subErrors)));
		default:
			return $author$project$Model$BuildPlanner$BuildPlannerError$message(error);
	}
};
var $mgold$elm_nonempty_list$List$Nonempty$head = function (_v0) {
	var x = _v0.a;
	var xs = _v0.b;
	return x;
};
var $author$project$Model$BuildDataSource$getLanguageResolvedVersion = F2(
	function (languageName, _v0) {
		var cached = _v0.df;
		return A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.e$;
				},
				A2(
					$elm$core$Basics$composeR,
					$mgold$elm_nonempty_list$List$Nonempty$head,
					function ($) {
						return $.sL;
					})),
			A2(
				$elm$core$Dict$get,
				_Utils_Tuple2($author$project$Model$Namespace$language, languageName),
				cached.pa));
	});
var $author$project$Views$LanguageVersionWarning$fromLanguageItem = F2(
	function (buildDataSource, languageItem) {
		var name = languageItem.kH.w;
		var constraintToSemver = function (constraint) {
			var _v0 = _Utils_Tuple2(
				constraint,
				A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Model$BuildDataSource$getLanguageResolvedVersion(name),
					buildDataSource));
			if (_v0.a.$ === 1) {
				var version = _v0.a.a;
				return $author$project$Model$VersionString$toVersion(version);
			} else {
				if ((_v0.b.$ === 3) && (!_v0.b.a.$)) {
					var version = _v0.b.a.a;
					return $author$project$Model$VersionString$toVersion(version);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		};
		return A3(
			$elm$core$Maybe$map2,
			$elm$core$Tuple$pair,
			$author$project$Model$Language$fromString(name),
			constraintToSemver(languageItem.kH.aI));
	});
var $author$project$Model$BuildPlanner$BuildExpr$MarkerKind$fromString = function (str) {
	switch (str) {
		case 'camel':
			return $elm$core$Maybe$Just(0);
		case 'state tool artifacts (V1)':
			return $elm$core$Maybe$Just(1);
		case 'state tool artifacts':
			return $elm$core$Maybe$Just(2);
		case 'state tool + community artifacts':
			return $elm$core$Maybe$Just(3);
		case 'state tool + wheel artifacts':
			return $elm$core$Maybe$Just(4);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$Namespace$languagePrefixLength = $elm$core$String$length($author$project$Model$Namespace$languagePrefix);
var $author$project$Model$Namespace$removeLanguagePrefix = function (string) {
	return A2($elm$core$String$startsWith, $author$project$Model$Namespace$languagePrefix, string) ? A2($elm$core$String$dropLeft, $author$project$Model$Namespace$languagePrefixLength, string) : string;
};
var $author$project$Model$Language$fromPackageNamespace = A2($elm$core$Basics$composeR, $author$project$Model$Namespace$removeLanguagePrefix, $author$project$Model$Language$fromString);
var $author$project$Model$BuildExprEditorUtils$getCategory = function (key) {
	var _v0 = $author$project$Model$Namespace$kind(key);
	switch (_v0) {
		case 0:
			return 'Bundles';
		case 4:
			return 'Languages';
		default:
			var _v1 = $author$project$Model$Namespace$getNamespace(key);
			if (_v1 === 'shared') {
				return 'Shared';
			} else {
				var namespace = _v1;
				return A2(
					$elm$core$Maybe$withDefault,
					'Other',
					A2(
						$elm$core$Maybe$map,
						A2($elm$core$Basics$composeR, $author$project$Model$Language$toString, $elm_community$string_extra$String$Extra$toTitleCase),
						$author$project$Model$Language$fromPackageNamespace(namespace)));
			}
	}
};
var $author$project$Pages$ProjectConfig$generatePackageIdFromKey = function (key) {
	return $author$project$Model$BuildExprEditorUtils$getCategory(key) + ('-' + $author$project$Model$Namespace$getName(key));
};
var $author$project$Model$Language$compare = F2(
	function (l1, l2) {
		var _v0 = _Utils_Tuple2(l1, l2);
		_v0$1:
		while (true) {
			_v0$2:
			while (true) {
				_v0$3:
				while (true) {
					_v0$4:
					while (true) {
						_v0$5:
						while (true) {
							_v0$6:
							while (true) {
								_v0$7:
								while (true) {
									_v0$8:
									while (true) {
										_v0$9:
										while (true) {
											_v0$10:
											while (true) {
												switch (_v0.a) {
													case 1:
														var _v1 = _v0.a;
														return 0;
													case 0:
														switch (_v0.b) {
															case 1:
																break _v0$1;
															case 0:
																break _v0$2;
															case 3:
																break _v0$2;
															case 4:
																break _v0$2;
															case 5:
																break _v0$2;
															case 6:
																break _v0$2;
															default:
																break _v0$2;
														}
													case 3:
														switch (_v0.b) {
															case 1:
																break _v0$1;
															case 0:
																break _v0$3;
															case 3:
																break _v0$4;
															case 4:
																break _v0$4;
															case 5:
																break _v0$4;
															case 6:
																break _v0$4;
															default:
																break _v0$4;
														}
													case 4:
														switch (_v0.b) {
															case 1:
																break _v0$1;
															case 0:
																break _v0$3;
															case 3:
																break _v0$5;
															case 4:
																break _v0$6;
															case 5:
																break _v0$7;
															case 6:
																break _v0$7;
															default:
																break _v0$7;
														}
													case 5:
														switch (_v0.b) {
															case 1:
																break _v0$1;
															case 0:
																break _v0$3;
															case 3:
																break _v0$5;
															case 4:
																break _v0$6;
															case 5:
																break _v0$8;
															case 6:
																break _v0$9;
															default:
																break _v0$9;
														}
													case 6:
														switch (_v0.b) {
															case 1:
																break _v0$1;
															case 0:
																break _v0$3;
															case 3:
																break _v0$5;
															case 4:
																break _v0$6;
															case 5:
																break _v0$8;
															case 6:
																break _v0$10;
															default:
																var _v12 = _v0.a;
																return 0;
														}
													default:
														switch (_v0.b) {
															case 1:
																break _v0$1;
															case 0:
																break _v0$3;
															case 3:
																break _v0$5;
															case 4:
																break _v0$6;
															case 5:
																break _v0$8;
															case 6:
																break _v0$10;
															default:
																var _v13 = _v0.a;
																return 2;
														}
												}
											}
											var _v11 = _v0.b;
											return 2;
										}
										var _v10 = _v0.a;
										return 0;
									}
									var _v9 = _v0.b;
									return 2;
								}
								var _v8 = _v0.a;
								return 0;
							}
							var _v7 = _v0.b;
							return 2;
						}
						var _v6 = _v0.b;
						return 2;
					}
					var _v5 = _v0.a;
					return 0;
				}
				var _v4 = _v0.b;
				return 2;
			}
			var _v3 = _v0.a;
			return 0;
		}
		var _v2 = _v0.b;
		return 2;
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$getAllLanguages = function (editor) {
	return A2(
		$elm$core$List$sortWith,
		$author$project$Model$Language$compare,
		A2(
			$elm$core$List$filterMap,
			$author$project$Model$Language$fromString,
			$elm$core$Dict$keys(
				$author$project$Model$BuildPlanner$SolveLegacyEditor$getLanguages(editor))));
};
var $author$project$Model$BuildDataSource$getAllVulnerabilityKeys = function (_v0) {
	var cached = _v0.df;
	return cached.w2;
};
var $author$project$Model$BuildPlanner$BuildExpr$Solve$VersionRequirement$comparatorToPythonSyntax = function (comparator) {
	switch (comparator) {
		case 'gt':
			return '>';
		case 'gte':
			return '>=';
		case 'lt':
			return '<';
		case 'lte':
			return '<=';
		case 'eq':
			return '==';
		case 'ne':
			return '!=';
		default:
			return '?';
	}
};
var $author$project$Model$BuildPlanner$BuildExpr$Solve$VersionRequirement$toPythonSyntax = function (_v0) {
	var comparator = _v0.h;
	var version = _v0.aI;
	return _Utils_ap(
		$author$project$Model$BuildPlanner$BuildExpr$Solve$VersionRequirement$comparatorToPythonSyntax(comparator),
		version);
};
var $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$toPythonSyntax = F2(
	function (first, others) {
		return A2(
			$elm$core$String$join,
			',',
			A2(
				$elm$core$List$map,
				$author$project$Model$BuildPlanner$BuildExpr$Solve$VersionRequirement$toPythonSyntax,
				A2($elm$core$List$cons, first, others)));
	});
var $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$getHumanReadableString = function (constraint) {
	switch (constraint.$) {
		case 0:
			return 'Auto';
		case 1:
			var version = constraint.a;
			return version;
		case 2:
			var first = constraint.a;
			var others = constraint.b;
			return 'Custom (' + (A2($author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$toPythonSyntax, first, others) + ')');
		default:
			return 'Manually Pinned';
	}
};
var $author$project$Model$BuildExprEditorUtils$getAnalyticsLabel = F2(
	function (key, constraint) {
		return $author$project$Model$BuildExprEditorUtils$getCategory(key) + (' - ' + ($author$project$Model$Namespace$getName(key) + (' ' + $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$getHumanReadableString(constraint))));
	});
var $author$project$Model$BuildDataSource$getNodesByKey = function (_v0) {
	var cached = _v0.df;
	return cached.pa;
};
var $author$project$Model$BuildDataSource$getBundleAndPackageBuildComponentsByKey = A2(
	$elm$core$Basics$composeR,
	$author$project$Model$BuildDataSource$getNodesByKey,
	$elm$core$Dict$filter(
		$elm$core$Basics$always(
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.j9;
				},
				A2(
					$elm$core$Basics$composeR,
					$author$project$Model$Namespace$kind,
					function (kind) {
						return (!kind) || ((kind === 5) || (kind === 4));
					})))));
var $author$project$Model$BuildDataSource$getBuildDataSourceEditor = F2(
	function (originalBuildData, currentBuildData) {
		var _v0 = function () {
			var _v1 = _Utils_Tuple2(
				A2($krisajenkins$remotedata$RemoteData$map, $author$project$Model$BuildDataSource$getBundleAndPackageBuildComponentsByKey, originalBuildData),
				A2($krisajenkins$remotedata$RemoteData$map, $author$project$Model$BuildDataSource$getBundleAndPackageBuildComponentsByKey, currentBuildData));
			if (_v1.a.$ === 3) {
				if (_v1.b.$ === 3) {
					var original = _v1.a.a;
					var current = _v1.b.a;
					return _Utils_Tuple2(original, current);
				} else {
					var original = _v1.a.a;
					return _Utils_Tuple2(original, original);
				}
			} else {
				if (_v1.b.$ === 3) {
					var current = _v1.b.a;
					return _Utils_Tuple2(current, current);
				} else {
					return _Utils_Tuple2($elm$core$Dict$empty, $elm$core$Dict$empty);
				}
			}
		}();
		var originalBuildComponentsByKey = _v0.a;
		var currentBuildComponentsByKey = _v0.b;
		return A2($author$project$Model$Editor$fromOriginalAndCurrent, originalBuildComponentsByKey, currentBuildComponentsByKey);
	});
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$getBuildFlagsDict = function (editor) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Model$BuildPlanner$BuildExpr$BuildFlagsDict$init,
		A2(
			$elm_community$maybe_extra$Maybe$Extra$or,
			A2(
				$elm$core$Maybe$map,
				$author$project$Model$Editor$getField(
					function ($) {
						return $.xs;
					}),
				$author$project$Model$BuildPlanner$BuildExprEditor$Simple$getStateToolArtifactsV1(editor)),
			A2(
				$elm$core$Maybe$map,
				$author$project$Model$Editor$getField(
					function ($) {
						return $.xs;
					}),
				$author$project$Model$BuildPlanner$BuildExprEditor$Simple$getStateToolArtifacts(editor))));
};
var $author$project$Model$BuildDataSource$getBuildPlan = function (_v0) {
	var buildPlan = _v0.xt;
	return buildPlan;
};
var $author$project$Pages$ProjectConfig$getChangeCount = function (model) {
	return $elm$core$List$length(
		$author$project$Model$BuildPlanner$SolveLegacyEditor$getChangedItems(model.qR));
};
var $author$project$Model$BuildDataSource$getComponentPurlVulnKeys = function (_v0) {
	var cached = _v0.df;
	return cached.ti;
};
var $author$project$Model$BuildDataSource$getComponentVulnerabilityKeys = function (_v0) {
	var cached = _v0.df;
	return cached.tj;
};
var $author$project$Views$BranchPicker$getSelectedBranch = function (model) {
	return model.fR;
};
var $author$project$Pages$ProjectConfig$getCurrentBranch = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Model$Project$getDefaultBranch(model.c5),
		A2($elm$core$Maybe$map, $author$project$Views$BranchPicker$getSelectedBranch, model.fJ));
};
var $author$project$Model$BuildDataSource$getNodeItems = function (editor) {
	return A3(
		$author$project$Model$Editor$getItemsDict,
		$elm$core$Basics$identity,
		$elm$core$Basics$always($elm$core$Basics$identity),
		editor);
};
var $author$project$Model$ResolvedRequirements$getByNodeId = F2(
	function (nodeId, _v0) {
		var resolvedRequirements = _v0;
		return A2($elm$core$Dict$get, nodeId, resolvedRequirements.qw);
	});
var $author$project$Model$BuildDataSource$isRequirementOrScannedImage = F2(
	function (_v0, key) {
		var cached = _v0.df;
		if (A2($elm$core$Dict$member, key, cached.v4)) {
			return true;
		} else {
			var _v1 = A2($elm$core$Dict$get, key, cached.pa);
			if (!_v1.$) {
				var component = _v1.a;
				return $elm_community$maybe_extra$Maybe$Extra$isJust(
					A2($author$project$Model$ResolvedRequirements$getByNodeId, component.rE, cached.pD));
			} else {
				return false;
			}
		}
	});
var $author$project$Views$Dependencies$showComponentItem = F3(
	function (existingBuildPlan, newBuildPlan, item) {
		var _v0 = _Utils_Tuple2(
			function () {
				var _v1 = item.L;
				if (_v1.$ === 1) {
					var value = _v1.a;
					return A2($author$project$Model$BuildDataSource$isRequirementOrScannedImage, existingBuildPlan, value.j9);
				} else {
					return false;
				}
			}(),
			A2($author$project$Model$BuildDataSource$isRequirementOrScannedImage, newBuildPlan, item.kH.j9));
		if (_v0.b) {
			return false;
		} else {
			if (!_v0.a) {
				return true;
			} else {
				return !_Utils_eq(item.L, $author$project$Model$Editor$Removed);
			}
		}
	});
var $author$project$Views$Dependencies$shouldShow = F2(
	function (_v0, item) {
		var existingBuildData = _v0.Cu;
		var newBuildData = _v0.Ep;
		var _v1 = _Utils_Tuple2(existingBuildData, newBuildData);
		if (_v1.a.$ === 3) {
			if (_v1.b.$ === 3) {
				var existingBuildPlan = _v1.a.a;
				var newBuildPlan = _v1.b.a;
				return A3($author$project$Views$Dependencies$showComponentItem, existingBuildPlan, newBuildPlan, item);
			} else {
				var existingBuildPlan = _v1.a.a;
				return !A2($author$project$Model$BuildDataSource$isRequirementOrScannedImage, existingBuildPlan, item.kH.j9);
			}
		} else {
			if (_v1.b.$ === 3) {
				var newBuildPlan = _v1.b.a;
				return !A2($author$project$Model$BuildDataSource$isRequirementOrScannedImage, newBuildPlan, item.kH.j9);
			} else {
				return false;
			}
		}
	});
var $author$project$Views$Dependencies$getDependencies = function (remoteBuildData) {
	var existingBuildData = remoteBuildData.Cu;
	var newBuildData = remoteBuildData.Ep;
	return A2(
		$elm$core$List$filter,
		$author$project$Views$Dependencies$shouldShow(remoteBuildData),
		$author$project$Model$BuildDataSource$getNodeItems(
			A2($author$project$Model$BuildDataSource$getBuildDataSourceEditor, existingBuildData, newBuildData)));
};
var $author$project$Views$PackageVersionSelector$getKey = function ($) {
	return $.Y;
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$getMarkers = $author$project$Model$BuildPlanner$BuildExprEditor$Simple$getMarkers;
var $author$project$Model$BuildPlanner$BuildExpr$SolveEditor$getTimestampItem = $author$project$Model$Editor$getItemMaybe(
	function (solve) {
		return A2(
			$elm$core$Maybe$map,
			function (timestamp) {
				return _Utils_Tuple2(timestamp, solve.Gx);
			},
			solve.wG);
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$getTimestampItem = $author$project$Model$BuildPlanner$SolveLegacyEditor$getBuildExprSolveEditor($author$project$Model$BuildPlanner$BuildExpr$SolveEditor$getTimestampItem);
var $author$project$Model$BuildExprEditorUtils$nextTimestamp = F2(
	function (platformTimestamp, solveTimestamp) {
		var _v0 = A2($author$project$TimeUtils$compare, platformTimestamp, solveTimestamp);
		if (!_v0) {
			return solveTimestamp;
		} else {
			return platformTimestamp;
		}
	});
var $author$project$Model$BuildExprEditorUtils$getNextTimestamp = F2(
	function (platformTimestamp, editor) {
		var timestampItem = A2(
			$elm$core$Maybe$withDefault,
			{
				L: $author$project$Model$Editor$Unchanged,
				kH: _Utils_Tuple2(platformTimestamp, false)
			},
			$author$project$Model$BuildPlanner$SolveLegacyEditor$getTimestampItem(editor));
		var currentTimestamp = timestampItem.kH.a;
		var _v0 = timestampItem.L;
		switch (_v0.$) {
			case 0:
				return currentTimestamp;
			case 1:
				return currentTimestamp;
			case 2:
				return currentTimestamp;
			default:
				return A2($author$project$Model$BuildExprEditorUtils$nextTimestamp, platformTimestamp, currentTimestamp);
		}
	});
var $author$project$Model$BuildDataSource$getNodeKeys = function (_v0) {
	var cached = _v0.df;
	return cached.uP;
};
var $author$project$Model$Commit$getAtTime = function (_v0) {
	var commit = _v0;
	return commit.jE;
};
var $author$project$Pages$ProjectConfig$getPushCommitAtTime = function (model) {
	var _v0 = $author$project$Model$BuildPlanner$SolveLegacyEditor$getTimestampItem(model.qR);
	if (!_v0.$) {
		return A2($author$project$Model$BuildExprEditorUtils$getNextTimestamp, model.pq, model.qR);
	} else {
		return A2(
			$author$project$Model$BuildExprEditorUtils$nextTimestamp,
			model.pq,
			$author$project$Model$Commit$getAtTime(model.f0));
	}
};
var $author$project$Model$BuildDataSource$getScannedImages = function (_v0) {
	var cached = _v0.df;
	return cached.v3;
};
var $author$project$Pages$ProjectConfig$getSimplifiedErrorMessage = function (error) {
	switch (error.$) {
		case 5:
			return 'Not found';
		case 2:
			return 'Forbidden';
		case 3:
			return 'Head on branch moved';
		case 4:
			return 'No change since last commit';
		default:
			return $author$project$Model$BuildPlanner$BuildPlannerError$message(error);
	}
};
var $author$project$Model$BuildDataSource$BuildDataSource = $elm$core$Basics$identity;
var $author$project$Model$BuildDataSource$BuildLanguage = F2(
	function (value, version) {
		return {kH: value, aI: version};
	});
var $author$project$Model$BuildDataSource$BuildDep = 1;
var $elm_community$graph$Graph$Edge = F3(
	function (from, to, label) {
		return {qZ: from, b2: label, Gz: to};
	});
var $elm_community$graph$Graph$Node = F2(
	function (id, label) {
		return {l6: id, b2: label};
	});
var $author$project$Model$BuildDataSource$RuntimeDep = 2;
var $author$project$Model$BuildDataSource$Src = 0;
var $elm_community$intdict$IntDict$foldr = F3(
	function (f, acc, dict) {
		foldr:
		while (true) {
			switch (dict.$) {
				case 0:
					return acc;
				case 1:
					var l = dict.a;
					return A3(f, l.Y, l.kH, acc);
				default:
					var i = dict.a;
					var $temp$f = f,
						$temp$acc = A3($elm_community$intdict$IntDict$foldr, f, acc, i.v0),
						$temp$dict = i.uv;
					f = $temp$f;
					acc = $temp$acc;
					dict = $temp$dict;
					continue foldr;
			}
		}
	});
var $elm_community$intdict$IntDict$keys = function (dict) {
	return A3(
		$elm_community$intdict$IntDict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm_community$graph$Graph$alongOutgoingEdges = function (ctx) {
	return $elm_community$intdict$IntDict$keys(ctx.rM);
};
var $elm_community$intdict$IntDict$highestBitSet = function (n) {
	var shiftOr = F2(
		function (i, shift) {
			return i | (i >>> shift);
		});
	var n1 = A2(shiftOr, n, 1);
	var n2 = A2(shiftOr, n1, 2);
	var n3 = A2(shiftOr, n2, 4);
	var n4 = A2(shiftOr, n3, 8);
	var n5 = A2(shiftOr, n4, 16);
	return n5 & (~(n5 >>> 1));
};
var $elm_community$intdict$IntDict$signBit = $elm_community$intdict$IntDict$highestBitSet(-1);
var $elm_community$intdict$IntDict$isBranchingBitSet = function (p) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Bitwise$xor($elm_community$intdict$IntDict$signBit),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Bitwise$and(p.kY),
			$elm$core$Basics$neq(0)));
};
var $elm_community$intdict$IntDict$higherBitMask = function (branchingBit) {
	return branchingBit ^ (~(branchingBit - 1));
};
var $elm_community$intdict$IntDict$prefixMatches = F2(
	function (p, n) {
		return _Utils_eq(
			n & $elm_community$intdict$IntDict$higherBitMask(p.kY),
			p.hM);
	});
var $elm_community$intdict$IntDict$get = F2(
	function (key, dict) {
		get:
		while (true) {
			switch (dict.$) {
				case 0:
					return $elm$core$Maybe$Nothing;
				case 1:
					var l = dict.a;
					return _Utils_eq(l.Y, key) ? $elm$core$Maybe$Just(l.kH) : $elm$core$Maybe$Nothing;
				default:
					var i = dict.a;
					if (!A2($elm_community$intdict$IntDict$prefixMatches, i.cc, key)) {
						return $elm$core$Maybe$Nothing;
					} else {
						if (A2($elm_community$intdict$IntDict$isBranchingBitSet, i.cc, key)) {
							var $temp$key = key,
								$temp$dict = i.v0;
							key = $temp$key;
							dict = $temp$dict;
							continue get;
						} else {
							var $temp$key = key,
								$temp$dict = i.uv;
							key = $temp$key;
							dict = $temp$dict;
							continue get;
						}
					}
			}
		}
	});
var $elm_community$graph$Graph$unGraph = function (graph) {
	var rep = graph;
	return rep;
};
var $elm_community$graph$Graph$get = function (nodeId) {
	return A2(
		$elm$core$Basics$composeR,
		$elm_community$graph$Graph$unGraph,
		$elm_community$intdict$IntDict$get(nodeId));
};
var $elm_community$intdict$IntDict$findMax = function (dict) {
	findMax:
	while (true) {
		switch (dict.$) {
			case 0:
				return $elm$core$Maybe$Nothing;
			case 1:
				var l = dict.a;
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(l.Y, l.kH));
			default:
				var i = dict.a;
				var $temp$dict = i.v0;
				dict = $temp$dict;
				continue findMax;
		}
	}
};
var $elm_community$intdict$IntDict$findMin = function (dict) {
	findMin:
	while (true) {
		switch (dict.$) {
			case 0:
				return $elm$core$Maybe$Nothing;
			case 1:
				var l = dict.a;
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(l.Y, l.kH));
			default:
				var i = dict.a;
				var $temp$dict = i.uv;
				dict = $temp$dict;
				continue findMin;
		}
	}
};
var $elm_community$graph$Graph$nodeIdRange = function (graph) {
	return A2(
		$elm$core$Maybe$andThen,
		function (_v0) {
			var min = _v0.a;
			return A2(
				$elm$core$Maybe$andThen,
				function (_v1) {
					var max = _v1.a;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(min, max));
				},
				$elm_community$intdict$IntDict$findMax(
					$elm_community$graph$Graph$unGraph(graph)));
		},
		$elm_community$intdict$IntDict$findMin(
			$elm_community$graph$Graph$unGraph(graph)));
};
var $elm_community$graph$Graph$Graph = $elm$core$Basics$identity;
var $elm_community$intdict$IntDict$foldl = F3(
	function (f, acc, dict) {
		foldl:
		while (true) {
			switch (dict.$) {
				case 0:
					return acc;
				case 1:
					var l = dict.a;
					return A3(f, l.Y, l.kH, acc);
				default:
					var i = dict.a;
					var $temp$f = f,
						$temp$acc = A3($elm_community$intdict$IntDict$foldl, f, acc, i.uv),
						$temp$dict = i.v0;
					f = $temp$f;
					acc = $temp$acc;
					dict = $temp$dict;
					continue foldl;
			}
		}
	});
var $elm_community$intdict$IntDict$Empty = {$: 0};
var $elm_community$intdict$IntDict$empty = $elm_community$intdict$IntDict$Empty;
var $elm_community$intdict$IntDict$Inner = function (a) {
	return {$: 2, a: a};
};
var $elm_community$intdict$IntDict$size = function (dict) {
	switch (dict.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		default:
			var i = dict.a;
			return i.we;
	}
};
var $elm_community$intdict$IntDict$inner = F3(
	function (p, l, r) {
		var _v0 = _Utils_Tuple2(l, r);
		if (!_v0.a.$) {
			var _v1 = _v0.a;
			return r;
		} else {
			if (!_v0.b.$) {
				var _v2 = _v0.b;
				return l;
			} else {
				return $elm_community$intdict$IntDict$Inner(
					{
						uv: l,
						cc: p,
						v0: r,
						we: $elm_community$intdict$IntDict$size(l) + $elm_community$intdict$IntDict$size(r)
					});
			}
		}
	});
var $elm_community$intdict$IntDict$lcp = F2(
	function (x, y) {
		var branchingBit = $elm_community$intdict$IntDict$highestBitSet(x ^ y);
		var mask = $elm_community$intdict$IntDict$higherBitMask(branchingBit);
		var prefixBits = x & mask;
		return {kY: branchingBit, hM: prefixBits};
	});
var $elm_community$intdict$IntDict$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm_community$intdict$IntDict$leaf = F2(
	function (k, v) {
		return $elm_community$intdict$IntDict$Leaf(
			{Y: k, kH: v});
	});
var $elm_community$intdict$IntDict$update = F3(
	function (key, alter, dict) {
		var join = F2(
			function (_v2, _v3) {
				var k1 = _v2.a;
				var l = _v2.b;
				var k2 = _v3.a;
				var r = _v3.b;
				var prefix = A2($elm_community$intdict$IntDict$lcp, k1, k2);
				return A2($elm_community$intdict$IntDict$isBranchingBitSet, prefix, k2) ? A3($elm_community$intdict$IntDict$inner, prefix, l, r) : A3($elm_community$intdict$IntDict$inner, prefix, r, l);
			});
		var alteredNode = function (mv) {
			var _v1 = alter(mv);
			if (!_v1.$) {
				var v = _v1.a;
				return A2($elm_community$intdict$IntDict$leaf, key, v);
			} else {
				return $elm_community$intdict$IntDict$empty;
			}
		};
		switch (dict.$) {
			case 0:
				return alteredNode($elm$core$Maybe$Nothing);
			case 1:
				var l = dict.a;
				return _Utils_eq(l.Y, key) ? alteredNode(
					$elm$core$Maybe$Just(l.kH)) : A2(
					join,
					_Utils_Tuple2(
						key,
						alteredNode($elm$core$Maybe$Nothing)),
					_Utils_Tuple2(l.Y, dict));
			default:
				var i = dict.a;
				return A2($elm_community$intdict$IntDict$prefixMatches, i.cc, key) ? (A2($elm_community$intdict$IntDict$isBranchingBitSet, i.cc, key) ? A3(
					$elm_community$intdict$IntDict$inner,
					i.cc,
					i.uv,
					A3($elm_community$intdict$IntDict$update, key, alter, i.v0)) : A3(
					$elm_community$intdict$IntDict$inner,
					i.cc,
					A3($elm_community$intdict$IntDict$update, key, alter, i.uv),
					i.v0)) : A2(
					join,
					_Utils_Tuple2(
						key,
						alteredNode($elm$core$Maybe$Nothing)),
					_Utils_Tuple2(i.cc.hM, dict));
		}
	});
var $elm_community$graph$Graph$applyEdgeDiff = F3(
	function (nodeId, diff, graphRep) {
		var updateOutgoingEdge = F2(
			function (upd, node) {
				return _Utils_update(
					node,
					{
						rM: A3($elm_community$intdict$IntDict$update, nodeId, upd, node.rM)
					});
			});
		var updateIncomingEdge = F2(
			function (upd, node) {
				return _Utils_update(
					node,
					{
						rc: A3($elm_community$intdict$IntDict$update, nodeId, upd, node.rc)
					});
			});
		var flippedFoldl = F3(
			function (f, dict, acc) {
				return A3($elm_community$intdict$IntDict$foldl, f, acc, dict);
			});
		var edgeUpdateToMaybe = function (edgeUpdate) {
			if (!edgeUpdate.$) {
				var lbl = edgeUpdate.a;
				return $elm$core$Maybe$Just(lbl);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		var updateAdjacency = F3(
			function (updateEdge, updatedId, edgeUpdate) {
				var updateLbl = updateEdge(
					$elm$core$Basics$always(
						edgeUpdateToMaybe(edgeUpdate)));
				return A2(
					$elm_community$intdict$IntDict$update,
					updatedId,
					$elm$core$Maybe$map(updateLbl));
			});
		return A3(
			flippedFoldl,
			updateAdjacency(updateOutgoingEdge),
			diff.rM,
			A3(
				flippedFoldl,
				updateAdjacency(updateIncomingEdge),
				diff.rc,
				graphRep));
	});
var $elm_community$graph$Graph$Insert = function (a) {
	return {$: 0, a: a};
};
var $elm_community$graph$Graph$Remove = function (a) {
	return {$: 1, a: a};
};
var $elm_community$graph$Graph$crashHack = function (msg) {
	crashHack:
	while (true) {
		var $temp$msg = msg;
		msg = $temp$msg;
		continue crashHack;
	}
};
var $elm_community$graph$Graph$emptyDiff = {rc: $elm_community$intdict$IntDict$empty, rM: $elm_community$intdict$IntDict$empty};
var $elm_community$graph$Graph$computeEdgeDiff = F2(
	function (old, _new) {
		var collectUpdates = F3(
			function (edgeUpdate, updatedId, label) {
				var replaceUpdate = function (old_) {
					var _v5 = _Utils_Tuple2(
						old_,
						edgeUpdate(label));
					if (!_v5.a.$) {
						if (_v5.a.a.$ === 1) {
							if (!_v5.b.$) {
								var oldLbl = _v5.a.a.a;
								var newLbl = _v5.b.a;
								return _Utils_eq(oldLbl, newLbl) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
									$elm_community$graph$Graph$Insert(newLbl));
							} else {
								return $elm_community$graph$Graph$crashHack('Graph.computeEdgeDiff: Collected two removals for the same edge. This is an error in the implementation of Graph and you should file a bug report!');
							}
						} else {
							return $elm_community$graph$Graph$crashHack('Graph.computeEdgeDiff: Collected inserts before removals. This is an error in the implementation of Graph and you should file a bug report!');
						}
					} else {
						var _v6 = _v5.a;
						var eu = _v5.b;
						return $elm$core$Maybe$Just(eu);
					}
				};
				return A2($elm_community$intdict$IntDict$update, updatedId, replaceUpdate);
			});
		var collect = F3(
			function (edgeUpdate, adj, updates) {
				return A3(
					$elm_community$intdict$IntDict$foldl,
					collectUpdates(edgeUpdate),
					updates,
					adj);
			});
		var _v0 = _Utils_Tuple2(old, _new);
		if (_v0.a.$ === 1) {
			if (_v0.b.$ === 1) {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				return $elm_community$graph$Graph$emptyDiff;
			} else {
				var _v4 = _v0.a;
				var ins = _v0.b.a;
				return {
					rc: A3(collect, $elm_community$graph$Graph$Insert, ins.rM, $elm_community$intdict$IntDict$empty),
					rM: A3(collect, $elm_community$graph$Graph$Insert, ins.rc, $elm_community$intdict$IntDict$empty)
				};
			}
		} else {
			if (_v0.b.$ === 1) {
				var rem = _v0.a.a;
				var _v3 = _v0.b;
				return {
					rc: A3(collect, $elm_community$graph$Graph$Remove, rem.rM, $elm_community$intdict$IntDict$empty),
					rM: A3(collect, $elm_community$graph$Graph$Remove, rem.rc, $elm_community$intdict$IntDict$empty)
				};
			} else {
				var rem = _v0.a.a;
				var ins = _v0.b.a;
				return _Utils_eq(rem, ins) ? $elm_community$graph$Graph$emptyDiff : {
					rc: A3(
						collect,
						$elm_community$graph$Graph$Insert,
						ins.rM,
						A3(collect, $elm_community$graph$Graph$Remove, rem.rM, $elm_community$intdict$IntDict$empty)),
					rM: A3(
						collect,
						$elm_community$graph$Graph$Insert,
						ins.rc,
						A3(collect, $elm_community$graph$Graph$Remove, rem.rc, $elm_community$intdict$IntDict$empty))
				};
			}
		}
	});
var $elm_community$intdict$IntDict$insert = F3(
	function (key, value, dict) {
		return A3(
			$elm_community$intdict$IntDict$update,
			key,
			$elm$core$Basics$always(
				$elm$core$Maybe$Just(value)),
			dict);
	});
var $elm_community$intdict$IntDict$filter = F2(
	function (predicate, dict) {
		var add = F3(
			function (k, v, d) {
				return A2(predicate, k, v) ? A3($elm_community$intdict$IntDict$insert, k, v, d) : d;
			});
		return A3($elm_community$intdict$IntDict$foldl, add, $elm_community$intdict$IntDict$empty, dict);
	});
var $elm_community$intdict$IntDict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm_community$intdict$IntDict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $elm_community$graph$Graph$update = F2(
	function (nodeId, updater) {
		var wrappedUpdater = function (rep) {
			var old = A2($elm_community$intdict$IntDict$get, nodeId, rep);
			var filterInvalidEdges = function (ctx) {
				return $elm_community$intdict$IntDict$filter(
					F2(
						function (id, _v0) {
							return _Utils_eq(id, ctx.mL.l6) || A2($elm_community$intdict$IntDict$member, id, rep);
						}));
			};
			var cleanUpEdges = function (ctx) {
				return _Utils_update(
					ctx,
					{
						rc: A2(filterInvalidEdges, ctx, ctx.rc),
						rM: A2(filterInvalidEdges, ctx, ctx.rM)
					});
			};
			var _new = A2(
				$elm$core$Maybe$map,
				cleanUpEdges,
				updater(old));
			var diff = A2($elm_community$graph$Graph$computeEdgeDiff, old, _new);
			return A3(
				$elm_community$intdict$IntDict$update,
				nodeId,
				$elm$core$Basics$always(_new),
				A3($elm_community$graph$Graph$applyEdgeDiff, nodeId, diff, rep));
		};
		return A2(
			$elm$core$Basics$composeR,
			$elm_community$graph$Graph$unGraph,
			A2($elm$core$Basics$composeR, wrappedUpdater, $elm$core$Basics$identity));
	});
var $elm_community$graph$Graph$remove = F2(
	function (nodeId, graph) {
		return A3(
			$elm_community$graph$Graph$update,
			nodeId,
			$elm$core$Basics$always($elm$core$Maybe$Nothing),
			graph);
	});
var $elm_community$graph$Graph$fold = F3(
	function (f, acc, graph) {
		var go = F2(
			function (acc1, graph1) {
				go:
				while (true) {
					var maybeContext = A2(
						$elm$core$Maybe$andThen,
						function (id) {
							return A2($elm_community$graph$Graph$get, id, graph);
						},
						A2(
							$elm$core$Maybe$map,
							$elm$core$Tuple$first,
							$elm_community$graph$Graph$nodeIdRange(graph1)));
					if (!maybeContext.$) {
						var ctx = maybeContext.a;
						var $temp$acc1 = A2(f, ctx, acc1),
							$temp$graph1 = A2($elm_community$graph$Graph$remove, ctx.mL.l6, graph1);
						acc1 = $temp$acc1;
						graph1 = $temp$graph1;
						continue go;
					} else {
						return acc1;
					}
				}
			});
		return A2(go, acc, graph);
	});
var $elm_community$intdict$IntDict$isEmpty = function (dict) {
	if (!dict.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Model$BuildDataSource$findRootIDs = function (graph) {
	return A3(
		$elm_community$graph$Graph$fold,
		F2(
			function (ctx, acc) {
				return $elm_community$intdict$IntDict$isEmpty(ctx.rc) ? A2($elm$core$List$cons, ctx.mL.l6, acc) : acc;
			}),
		_List_Nil,
		graph);
};
var $elm_community$graph$Graph$NodeContext = F3(
	function (node, incoming, outgoing) {
		return {rc: incoming, mL: node, rM: outgoing};
	});
var $elm_community$graph$Graph$fromNodesAndEdges = F2(
	function (nodes_, edges_) {
		var nodeRep = A3(
			$elm$core$List$foldl,
			function (n) {
				return A2(
					$elm_community$intdict$IntDict$insert,
					n.l6,
					A3($elm_community$graph$Graph$NodeContext, n, $elm_community$intdict$IntDict$empty, $elm_community$intdict$IntDict$empty));
			},
			$elm_community$intdict$IntDict$empty,
			nodes_);
		var addEdge = F2(
			function (edge, rep) {
				var updateOutgoing = function (ctx) {
					return _Utils_update(
						ctx,
						{
							rM: A3($elm_community$intdict$IntDict$insert, edge.Gz, edge.b2, ctx.rM)
						});
				};
				var updateIncoming = function (ctx) {
					return _Utils_update(
						ctx,
						{
							rc: A3($elm_community$intdict$IntDict$insert, edge.qZ, edge.b2, ctx.rc)
						});
				};
				return A3(
					$elm_community$intdict$IntDict$update,
					edge.Gz,
					$elm$core$Maybe$map(updateIncoming),
					A3(
						$elm_community$intdict$IntDict$update,
						edge.qZ,
						$elm$core$Maybe$map(updateOutgoing),
						rep));
			});
		var addEdgeIfValid = F2(
			function (edge, rep) {
				return (A2($elm_community$intdict$IntDict$member, edge.qZ, rep) && A2($elm_community$intdict$IntDict$member, edge.Gz, rep)) ? A2(addEdge, edge, rep) : rep;
			});
		return A3($elm$core$List$foldl, addEdgeIfValid, nodeRep, edges_);
	});
var $elm_community$graph$Graph$guidedDfs = F5(
	function (selectNeighbors, visitNode, startingSeeds, startingAcc, startingGraph) {
		var go = F3(
			function (seeds, acc, graph) {
				go:
				while (true) {
					if (!seeds.b) {
						return _Utils_Tuple2(acc, graph);
					} else {
						var next = seeds.a;
						var seeds1 = seeds.b;
						var _v1 = A2($elm_community$graph$Graph$get, next, graph);
						if (_v1.$ === 1) {
							var $temp$seeds = seeds1,
								$temp$acc = acc,
								$temp$graph = graph;
							seeds = $temp$seeds;
							acc = $temp$acc;
							graph = $temp$graph;
							continue go;
						} else {
							var ctx = _v1.a;
							var _v2 = A2(visitNode, ctx, acc);
							var accAfterDiscovery = _v2.a;
							var finishNode = _v2.b;
							var _v3 = A3(
								go,
								selectNeighbors(ctx),
								accAfterDiscovery,
								A2($elm_community$graph$Graph$remove, next, graph));
							var accBeforeFinish = _v3.a;
							var graph1 = _v3.b;
							var accAfterFinish = finishNode(accBeforeFinish);
							var $temp$seeds = seeds1,
								$temp$acc = accAfterFinish,
								$temp$graph = graph1;
							seeds = $temp$seeds;
							acc = $temp$acc;
							graph = $temp$graph;
							continue go;
						}
					}
				}
			});
		return A3(go, startingSeeds, startingAcc, startingGraph);
	});
var $author$project$Model$BuildPlanner$Artifact$id = function (a) {
	switch (a.$) {
		case 0:
			var data = a.a;
			return data.rE;
		case 2:
			var data = a.a;
			return data.rE;
		case 1:
			var data = a.a;
			return data.rE;
		default:
			var data = a.a;
			return data.rE;
	}
};
var $author$project$Model$BuildPlanner$MissingSource$id = function (_v0) {
	var data = _v0;
	return data.Ap;
};
var $author$project$Model$BuildPlanner$Source$id = function (_v0) {
	var data = _v0;
	return data.Ao;
};
var $author$project$Model$BuildPlanner$Node$id = function (node) {
	switch (node.$) {
		case 0:
			var a = node.a;
			return $author$project$Model$BuildPlanner$Artifact$id(a);
		case 1:
			var s = node.a;
			return $author$project$Model$BuildPlanner$Source$id(s);
		default:
			var s = node.a;
			return $author$project$Model$BuildPlanner$MissingSource$id(s);
	}
};
var $author$project$Model$BuildPlanner$Artifact$idStr = A2($elm$core$Basics$composeR, $author$project$Model$BuildPlanner$Artifact$id, $danyx23$elm_uuid$Uuid$toString);
var $author$project$Model$BuildPlanner$Node$idStr = A2($elm$core$Basics$composeR, $author$project$Model$BuildPlanner$Node$id, $danyx23$elm_uuid$Uuid$toString);
var $author$project$Model$BuildPlanner$Step$inputs = function (_v0) {
	var data = _v0;
	return data.yH;
};
var $author$project$Model$BuildPlanner$Artifact$mimetype = function (a) {
	switch (a.$) {
		case 0:
			var data = a.a;
			return data.je;
		case 2:
			var data = a.a;
			return data.je;
		case 1:
			var data = a.a;
			return data.je;
		default:
			var data = a.a;
			return data.je;
	}
};
var $author$project$Model$BuildPlanner$Artifact$isBuilder = A2(
	$elm$core$Basics$composeR,
	$author$project$Model$BuildPlanner$Artifact$mimetype,
	$elm$core$Basics$eq('application/x-activestate-builder'));
var $author$project$Model$BuildPlanner$Artifact$isWheel = A2(
	$elm$core$Basics$composeR,
	$author$project$Model$BuildPlanner$Artifact$mimetype,
	$elm$core$Basics$eq('application/x-python-wheel+zip'));
var $elm_community$graph$Graph$onDiscovery = F3(
	function (visitor, ctx, acc) {
		return _Utils_Tuple2(
			A2(visitor, ctx, acc),
			$elm$core$Basics$identity);
	});
var $author$project$Model$BuildPlanner$Node$source = function (node) {
	if (node.$ === 1) {
		var s = node.a;
		return $elm$core$Maybe$Just(s);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$BuildPlanner$Source$vulnerabilityKey = function (source) {
	return {
		w: $author$project$Model$BuildPlanner$Source$name(source),
		aE: $author$project$Model$BuildPlanner$Source$namespace(source),
		aI: $author$project$Model$BuildPlanner$Source$version(source)
	};
};
var $author$project$Model$BuildDataSource$makeArtifactIdVulnerabilityKeyPair = F2(
	function (graph, artifactId) {
		var alongSrcEdges = function (ctx) {
			return $elm_community$intdict$IntDict$keys(
				A2(
					$elm_community$intdict$IntDict$filter,
					function (_v0) {
						return $elm$core$Basics$eq(0);
					},
					ctx.rM));
		};
		var sources = A5(
			$elm_community$graph$Graph$guidedDfs,
			alongSrcEdges,
			$elm_community$graph$Graph$onDiscovery(
				F2(
					function (ctx, acc) {
						return _Utils_ap(
							$elm_community$maybe_extra$Maybe$Extra$toList(
								$author$project$Model$BuildPlanner$Node$source(ctx.mL.b2)),
							acc);
					})),
			_List_fromArray(
				[artifactId]),
			_List_Nil,
			graph).a;
		return A2(
			$elm$core$List$map,
			function (source) {
				return _Utils_Tuple2(
					artifactId,
					$author$project$Model$BuildPlanner$Source$vulnerabilityKey(source));
			},
			sources);
	});
var $elm_community$intdict$IntDict$map = F2(
	function (f, dict) {
		switch (dict.$) {
			case 0:
				return $elm_community$intdict$IntDict$empty;
			case 1:
				var l = dict.a;
				return A2(
					$elm_community$intdict$IntDict$leaf,
					l.Y,
					A2(f, l.Y, l.kH));
			default:
				var i = dict.a;
				return A3(
					$elm_community$intdict$IntDict$inner,
					i.cc,
					A2($elm_community$intdict$IntDict$map, f, i.uv),
					A2($elm_community$intdict$IntDict$map, f, i.v0));
		}
	});
var $elm$core$Maybe$map3 = F4(
	function (func, ma, mb, mc) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				if (mc.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var c = mc.a;
					return $elm$core$Maybe$Just(
						A3(func, a, b, c));
				}
			}
		}
	});
var $elm_community$graph$Graph$empty = $elm_community$intdict$IntDict$empty;
var $elm_community$graph$Graph$insert = F2(
	function (nodeContext, graph) {
		return A3(
			$elm_community$graph$Graph$update,
			nodeContext.mL.l6,
			$elm$core$Basics$always(
				$elm$core$Maybe$Just(nodeContext)),
			graph);
	});
var $elm_community$graph$Graph$mapContexts = function (f) {
	return A2(
		$elm_community$graph$Graph$fold,
		function (ctx) {
			return $elm_community$graph$Graph$insert(
				f(ctx));
		},
		$elm_community$graph$Graph$empty);
};
var $author$project$Model$BuildPlanner$Step$outputs = function (_v0) {
	var data = _v0;
	return data.zz;
};
var $author$project$Model$BuildPlanner$Artifact$runtimeDependencies = function (a) {
	switch (a.$) {
		case 0:
			var data = a.a;
			return data.jv;
		case 2:
			var data = a.a;
			return data.jv;
		case 1:
			var data = a.a;
			return data.jv;
		default:
			var data = a.a;
			return data.jv;
	}
};
var $author$project$Model$BuildPlanner$Node$runtimeDependencies = function (node) {
	switch (node.$) {
		case 0:
			var a = node.a;
			return $author$project$Model$BuildPlanner$Artifact$runtimeDependencies(a);
		case 1:
			return _List_Nil;
		default:
			return _List_Nil;
	}
};
var $author$project$Model$BuildDataSource$extractGraphAndVulnerabiltyKeys = function (buildPlan) {
	var makeUuidToGraphId = function () {
		var helper = function (_v5) {
			var id = _v5.l6;
			var label = _v5.b2;
			return A2(
				$elm$core$Dict$insert,
				$author$project$Model$BuildPlanner$Node$idStr(label),
				id);
		};
		return A2($elm$core$List$foldl, helper, $elm$core$Dict$empty);
	}();
	var indexedNodes = A2($elm$core$List$indexedMap, $elm_community$graph$Graph$Node, buildPlan.g9);
	var nodeUuidToGraphId = makeUuidToGraphId(indexedNodes);
	var getByUuid = F2(
		function (dict, id) {
			return A2(
				$elm$core$Dict$get,
				$danyx23$elm_uuid$Uuid$toString(id),
				dict);
		});
	var makeEdge = F4(
		function (dict, label, from, to) {
			return A4(
				$elm$core$Maybe$map3,
				$elm_community$graph$Graph$Edge,
				A2(getByUuid, dict, from),
				A2(getByUuid, dict, to),
				$elm$core$Maybe$Just(label));
		});
	var makeRuntimeEdges = F2(
		function (dict, node) {
			return A2(
				$elm$core$List$filterMap,
				A3(
					makeEdge,
					dict,
					2,
					$author$project$Model$BuildPlanner$Node$id(node)),
				$author$project$Model$BuildPlanner$Node$runtimeDependencies(node));
		});
	var makeStepEdgesForOutputAndInput = F3(
		function (dict, output, input) {
			switch (input.$) {
				case 0:
					var ids = input.a;
					return A2(
						$elm$core$List$filterMap,
						A3(makeEdge, dict, 0, output),
						ids);
				case 3:
					var ids = input.a;
					return A2(
						$elm$core$List$filterMap,
						A3(makeEdge, dict, 1, output),
						ids);
				default:
					return _List_Nil;
			}
		});
	var makeStepEdges = F2(
		function (dict, step) {
			return A2(
				$elm$core$List$concatMap,
				function (output) {
					return A2(
						$elm$core$List$concatMap,
						A2(makeStepEdgesForOutputAndInput, dict, output),
						$author$project$Model$BuildPlanner$Step$inputs(step));
				},
				$author$project$Model$BuildPlanner$Step$outputs(step));
		});
	var edgeToUnit = F2(
		function (_v2, _v3) {
			return 0;
		});
	var createGraph = function (graphNodes) {
		var graphEdges = _Utils_ap(
			A2(
				$elm$core$List$concatMap,
				makeStepEdges(nodeUuidToGraphId),
				buildPlan.Gi),
			A2(
				$elm$core$List$concatMap,
				makeRuntimeEdges(nodeUuidToGraphId),
				A2(
					$elm$core$List$map,
					function ($) {
						return $.b2;
					},
					graphNodes)));
		return A2($elm_community$graph$Graph$fromNodesAndEdges, graphNodes, graphEdges);
	};
	var detailedGraph = createGraph(indexedNodes);
	var connectionRelevantArtifact = function (graphNode) {
		return A2(
			$elm_community$maybe_extra$Maybe$Extra$filter,
			function (artifact) {
				return !($author$project$Model$BuildPlanner$Artifact$isBuilder(artifact) || $author$project$Model$BuildPlanner$Artifact$isWheel(artifact));
			},
			$author$project$Model$BuildPlanner$Node$artifact(graphNode.b2));
	};
	var connectionGraph = A2(
		$elm_community$graph$Graph$mapContexts,
		function (_v1) {
			var node = _v1.mL;
			var incoming = _v1.rc;
			var outgoing = _v1.rM;
			return {
				rc: A2($elm_community$intdict$IntDict$map, edgeToUnit, incoming),
				mL: {l6: node.l6, b2: 0},
				rM: A2($elm_community$intdict$IntDict$map, edgeToUnit, outgoing)
			};
		},
		createGraph(
			A2(
				$elm$core$List$filter,
				A2($elm$core$Basics$composeR, connectionRelevantArtifact, $elm_community$maybe_extra$Maybe$Extra$isJust),
				indexedNodes)));
	var accumConnectionRelevantArtifactIds = F2(
		function (ctx, acc) {
			var graphNode = ctx.mL;
			var _v0 = connectionRelevantArtifact(graphNode);
			if (!_v0.$) {
				var artifact = _v0.a;
				return A3(
					$elm$core$Dict$insert,
					$author$project$Model$BuildPlanner$Artifact$idStr(artifact),
					graphNode.l6,
					acc);
			} else {
				return acc;
			}
		});
	var makeVulnerabiltyKeys = function (graph) {
		return $elm$core$Dict$fromList(
			A2(
				$elm$core$List$filterMap,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Model$BuildDataSource$makeArtifactIdVulnerabilityKeyPair(graph),
					$author$project$Misc$getSingle),
				$elm$core$Dict$values(
					A5(
						$elm_community$graph$Graph$guidedDfs,
						$elm_community$graph$Graph$alongOutgoingEdges,
						$elm_community$graph$Graph$onDiscovery(accumConnectionRelevantArtifactIds),
						$author$project$Model$BuildDataSource$findRootIDs(graph),
						$elm$core$Dict$empty,
						graph).a)));
	};
	return _Utils_Tuple2(
		connectionGraph,
		makeVulnerabiltyKeys(detailedGraph));
};
var $author$project$Model$BuildDataSource$computeDepsAndReqBys = function (buildPlan) {
	var _v0 = $author$project$Model$BuildDataSource$extractGraphAndVulnerabiltyKeys(buildPlan);
	var graph = _v0.a;
	var vulnerabiltyKeys = _v0.b;
	var getVulnerabiltyKey = function (id) {
		return A2($elm$core$Dict$get, id, vulnerabiltyKeys);
	};
	var foldStep = F2(
		function (ctx, acc) {
			var _v1 = getVulnerabiltyKey(ctx.mL.l6);
			if (_v1.$ === 1) {
				return acc;
			} else {
				var vulnerabiltyKey = _v1.a;
				var requiredBys = A2(
					$elm$core$List$filterMap,
					getVulnerabiltyKey,
					$elm_community$intdict$IntDict$keys(ctx.rc));
				var key = $author$project$Model$Namespace$key(vulnerabiltyKey);
				var dependencies = A2(
					$elm$core$List$filterMap,
					getVulnerabiltyKey,
					$elm_community$intdict$IntDict$keys(ctx.rM));
				return {
					lt: A3($elm$core$Dict$insert, key, dependencies, acc.lt),
					jt: A3($elm$core$Dict$insert, key, requiredBys, acc.jt)
				};
			}
		});
	return A3(
		$elm_community$graph$Graph$fold,
		foldStep,
		{lt: $elm$core$Dict$empty, jt: $elm$core$Dict$empty},
		graph);
};
var $author$project$Model$BuildDataSource$computeNodeKeys = A2(
	$elm$core$List$foldl,
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.j9;
		},
		$elm$core$Set$insert),
	$elm$core$Set$empty);
var $author$project$Model$BuildDataSource$computeNodesByKey = $elm_community$dict_extra$Dict$Extra$fromListBy(
	function ($) {
		return $.j9;
	});
var $mgold$elm_nonempty_list$List$Nonempty$tail = function (_v0) {
	var x = _v0.a;
	var xs = _v0.b;
	return xs;
};
var $author$project$Model$BuildDataSource$computeVulnerabilityKeys = function (components) {
	var componentVersionHelper = F3(
		function (namespaceKey, componentVersion, acc) {
			return A2(
				$elm$core$List$cons,
				A2($author$project$Model$Vulnerability$fromNamespaceKey, namespaceKey, componentVersion.sL),
				acc);
		});
	var componentHelper = F2(
		function (component, acc) {
			var others = $mgold$elm_nonempty_list$List$Nonempty$tail(component.e$);
			var namespaceKey = component.j9;
			var first = $mgold$elm_nonempty_list$List$Nonempty$head(component.e$);
			return A3(
				componentVersionHelper,
				namespaceKey,
				first,
				A3(
					$elm$core$List$foldr,
					componentVersionHelper(namespaceKey),
					acc,
					others));
		});
	return A3($elm$core$List$foldr, componentHelper, _List_Nil, components);
};
var $author$project$Model$Analytics$Fact$Dependencies$stripPurl = function (purl) {
	return A2(
		$elm$core$Maybe$withDefault,
		purl,
		A2(
			$elm$core$Maybe$andThen,
			$elm$core$List$head,
			A2(
				$elm$core$Maybe$map,
				$elm$core$String$split('#'),
				A2(
					$elm$core$Maybe$andThen,
					$elm$core$List$head,
					A2(
						$elm$core$Maybe$map,
						$elm$core$String$split('@'),
						$elm$core$List$head(
							A2($elm$core$String$split, '?', purl)))))));
};
var $author$project$Model$Analytics$Fact$Dependencies$cveKeyFromArbys = function (data) {
	return _Utils_Tuple2(
		$author$project$Model$Analytics$Fact$Dependencies$stripPurl(data.k),
		data.aI);
};
var $author$project$Model$BuildPlanner$Component$getAnalyticsCVEKey = function (_v0) {
	var data = _v0;
	return $author$project$Model$Analytics$Fact$Dependencies$cveKeyFromArbys(data);
};
var $author$project$Model$BuildPlanner$Component$id = function (_v0) {
	var data = _v0;
	return data.xJ;
};
var $author$project$Model$BuildPlanner$Component$idStr = A2($elm$core$Basics$composeR, $author$project$Model$BuildPlanner$Component$id, $danyx23$elm_uuid$Uuid$toString);
var $author$project$Model$BuildPlanner$Source$idStr = A2($elm$core$Basics$composeR, $author$project$Model$BuildPlanner$Source$id, $danyx23$elm_uuid$Uuid$toString);
var $author$project$Model$BuildPlanner$Source$isIndemnified = function (_v0) {
	var data = _v0;
	return data.Dm;
};
var $author$project$Model$BuildPlanner$Component$key = function (_v0) {
	var data = _v0;
	return $author$project$Model$Namespace$key(data);
};
var $author$project$Model$BuildPlanner$Source$licenses = function (_v0) {
	var data = _v0;
	return data.go;
};
var $author$project$Model$BuildPlanner$Node$missingSource = function (node) {
	if (node.$ === 2) {
		var ms = node.a;
		return $elm$core$Maybe$Just(ms);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$BuildPlanner$Component$name = function (_v0) {
	var data = _v0;
	return data.w;
};
var $author$project$Model$BuildPlanner$Component$namespace = function (_v0) {
	var data = _v0;
	return data.aE;
};
var $author$project$Model$ResolvedRequirements$ResolvedRequirements = $elm$core$Basics$identity;
var $elm_community$basics_extra$Basics$Extra$swap = function (_v0) {
	var a = _v0.a;
	var b = _v0.b;
	return _Utils_Tuple2(b, a);
};
var $author$project$Model$ResolvedRequirements$new = function (resolvedRequirements) {
	var pairing = A2(
		$elm$core$List$map,
		function (_v0) {
			var requirement = _v0.ci;
			var resolvedSource = _v0.FI;
			return _Utils_Tuple2(
				$author$project$Model$Namespace$key(requirement),
				$danyx23$elm_uuid$Uuid$toString(resolvedSource));
		},
		resolvedRequirements);
	return {
		qv: $elm$core$Dict$fromList(pairing),
		qw: $elm$core$Dict$fromList(
			A2($elm$core$List$map, $elm_community$basics_extra$Basics$Extra$swap, pairing))
	};
};
var $author$project$Model$BuildPlanner$BuildRelationship$nodeId = function (_v0) {
	var data = _v0;
	return data.rE;
};
var $author$project$Model$BuildPlanner$Component$purl = function (_v0) {
	var data = _v0;
	return data.k;
};
var $author$project$Model$BuildPlanner$Component$relatesTo = function (_v0) {
	var data = _v0;
	return data.FA;
};
var $author$project$Model$BuildPlanner$Source$revision = function (_v0) {
	var data = _v0;
	return data.ac;
};
var $author$project$Model$BuildPlanner$BuildRelationship$type_ = function (_v0) {
	var data = _v0;
	return data.gR;
};
var $author$project$Model$BuildPlanner$Component$version = function (_v0) {
	var data = _v0;
	return data.aI;
};
var $author$project$Model$BuildDataSource$init = function (buildPlan) {
	var scannedImages = A2($elm$core$List$filterMap, $author$project$Model$BuildPlanner$Node$sourceImage, buildPlan.g9);
	var missingSources = A2($elm$core$List$filterMap, $author$project$Model$BuildPlanner$Node$missingSource, buildPlan.g9);
	var missingSourceNodeIds = $elm$core$Set$fromList(
		A2(
			$elm$core$List$map,
			A2($elm$core$Basics$composeR, $author$project$Model$BuildPlanner$MissingSource$id, $danyx23$elm_uuid$Uuid$toString),
			missingSources));
	var initAcc = {i7: true, aM: _List_Nil, g9: $elm$core$Dict$empty};
	var componentsByDirectNodeId = $elm$core$Dict$fromList(
		A2(
			$elm$core$List$concatMap,
			function (component) {
				return A2(
					$elm$core$List$filterMap,
					function (relationship) {
						return (!$author$project$Model$BuildPlanner$BuildRelationship$type_(relationship)) ? $elm$core$Maybe$Just(
							_Utils_Tuple2(
								$danyx23$elm_uuid$Uuid$toString(
									$author$project$Model$BuildPlanner$BuildRelationship$nodeId(relationship)),
								component)) : $elm$core$Maybe$Nothing;
					},
					$author$project$Model$BuildPlanner$Component$relatesTo(component));
			},
			buildPlan.hr));
	var componentVulnerabilityKeys = A2(
		$elm$core$List$map,
		function (c) {
			return {
				w: $author$project$Model$BuildPlanner$Component$name(c),
				aE: $author$project$Model$BuildPlanner$Component$namespace(c),
				aI: $author$project$Model$BuildPlanner$Component$version(c)
			};
		},
		buildPlan.hr);
	var componentPurlVulnKeys = A2($elm$core$List$map, $author$project$Model$BuildPlanner$Component$getAnalyticsCVEKey, buildPlan.hr);
	var componentKeys = A3(
		$elm$core$List$foldl,
		function (_v5) {
			var namespace = _v5.aE;
			var name = _v5.w;
			return $elm$core$Set$insert(
				_Utils_Tuple2(namespace, name));
		},
		$elm$core$Set$empty,
		componentVulnerabilityKeys);
	var accumTarget = F2(
		function (target, acc) {
			var _v3 = $author$project$Model$BuildPlanner$Node$source(target);
			if (_v3.$ === 1) {
				return acc;
			} else {
				var source = _v3.a;
				if ($author$project$Model$BuildPlanner$Source$namespace(source) === 'image') {
					return acc;
				} else {
					var versionStr = $author$project$Model$BuildPlanner$Source$version(source);
					var versionData = {
						oL: $author$project$Model$BuildPlanner$Source$revision(source),
						Dm: $author$project$Model$BuildPlanner$Source$isIndemnified(source),
						go: $author$project$Model$BuildPlanner$Source$licenses(source)
					};
					var namespace = $author$project$Model$BuildPlanner$Source$namespace(source);
					var name = $author$project$Model$BuildPlanner$Source$name(source);
					var maybeLanguage = function () {
						var _v4 = $author$project$Model$Namespace$kindFromString(namespace);
						if (_v4 === 4) {
							return $author$project$Model$Language$fromString(name);
						} else {
							return $elm$core$Maybe$Nothing;
						}
					}();
					var maybeBuildLanguage = A3(
						$elm$core$Maybe$map2,
						$author$project$Model$BuildDataSource$BuildLanguage,
						maybeLanguage,
						$elm$core$Maybe$Just(versionStr));
					return _Utils_update(
						acc,
						{
							i7: acc.i7 && $author$project$Model$BuildPlanner$Source$isIndemnified(source),
							aM: _Utils_ap(
								acc.aM,
								$elm_community$maybe_extra$Maybe$Extra$toList(maybeBuildLanguage)),
							g9: A3(
								$elm$core$Dict$update,
								_Utils_Tuple3(
									namespace,
									$author$project$Model$BuildPlanner$Source$name(source),
									$author$project$Model$BuildPlanner$Source$idStr(source)),
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Maybe$withDefault($elm$core$Dict$empty),
									A2(
										$elm$core$Basics$composeR,
										A2($elm$core$Dict$insert, versionStr, versionData),
										$elm$core$Maybe$Just)),
								acc.g9)
						});
				}
			}
		});
	var finalAcc = A3($elm$core$List$foldl, accumTarget, initAcc, buildPlan.g9);
	var accumComponentVersion = F3(
		function (versionStr, versionAccum, acc) {
			return A2(
				$elm$core$List$cons,
				{oL: versionAccum.oL, Dm: versionAccum.Dm, go: versionAccum.go, sL: versionStr},
				acc);
		});
	var accumComponent = F3(
		function (_v2, versionsAccum, acc) {
			var namespace = _v2.a;
			var name = _v2.b;
			var id = _v2.c;
			var _v1 = A3($elm$core$Dict$foldr, accumComponentVersion, _List_Nil, versionsAccum);
			if (!_v1.b) {
				return acc;
			} else {
				var v = _v1.a;
				var vs = _v1.b;
				return A2(
					$elm$core$List$cons,
					{
						j9: _Utils_Tuple2(namespace, name),
						rE: id,
						e$: A2($mgold$elm_nonempty_list$List$Nonempty$Nonempty, v, vs)
					},
					acc);
			}
		});
	var nodes = A3($elm$core$Dict$foldr, accumComponent, _List_Nil, finalAcc.g9);
	var _v0 = $author$project$Model$BuildDataSource$computeDepsAndReqBys(buildPlan);
	var dependencies = _v0.lt;
	var requiredBys = _v0.jt;
	return {
		xt: buildPlan,
		df: {
			th: componentKeys,
			ti: componentPurlVulnKeys,
			tj: componentVulnerabilityKeys,
			hr: buildPlan.hr,
			tk: componentsByDirectNodeId,
			tl: A2($elm_community$dict_extra$Dict$Extra$fromListBy, $author$project$Model$BuildPlanner$Component$idStr, buildPlan.hr),
			tm: A2($elm_community$dict_extra$Dict$Extra$fromListBy, $author$project$Model$BuildPlanner$Component$key, buildPlan.hr),
			tn: A2($elm_community$dict_extra$Dict$Extra$fromListBy, $author$project$Model$BuildPlanner$Component$purl, buildPlan.hr),
			lt: dependencies,
			i7: finalAcc.i7,
			aM: finalAcc.aM,
			rA: missingSourceNodeIds,
			uF: missingSources,
			uP: $author$project$Model$BuildDataSource$computeNodeKeys(nodes),
			g9: nodes,
			pa: $author$project$Model$BuildDataSource$computeNodesByKey(nodes),
			jt: requiredBys,
			pD: $author$project$Model$ResolvedRequirements$new(buildPlan.pD),
			v3: scannedImages,
			v4: A2(
				$elm_community$dict_extra$Dict$Extra$fromListBy,
				function ($) {
					return $.Y;
				},
				scannedImages),
			w2: $author$project$Model$BuildDataSource$computeVulnerabilityKeys(nodes)
		}
	};
};
var $author$project$Views$AddPackagesModal$Packages = 0;
var $author$project$Model$Language$all = A2(
	$elm$core$Maybe$withDefault,
	$mgold$elm_nonempty_list$List$Nonempty$singleton(0),
	$mgold$elm_nonempty_list$List$Nonempty$fromList(
		A2(
			$elm$core$List$sortWith,
			$author$project$Model$Language$compare,
			_List_fromArray(
				[0, 1, 2, 3]))));
var $author$project$Views$NamespaceExpand$init = {oy: $elm$core$Set$empty};
var $author$project$Views$CVEs$init = $author$project$Views$NamespaceExpand$init;
var $author$project$Views$Licenses$init = {ra: $elm$core$Maybe$Nothing};
var $author$project$Views$PackageSummaryDisplay$DisplayCVEs = 0;
var $author$project$Views$PackageSummaryDisplay$init = {jn: 0};
var $author$project$Views$AddPackagesModal$init = F2(
	function (currentLanguage, editor) {
		var lang = A2(
			$elm$core$Maybe$withDefault,
			$mgold$elm_nonempty_list$List$Nonempty$head($author$project$Model$Language$all),
			currentLanguage);
		var allOrderLanguages = $author$project$Model$BuildPlanner$SolveLegacyEditor$getAllLanguages(editor);
		return {
			jF: A2(
				$elm$core$Maybe$withDefault,
				$author$project$Model$Language$all,
				$mgold$elm_nonempty_list$List$Nonempty$fromList(allOrderLanguages)),
			ip: lang,
			jO: $author$project$Views$CVEs$init,
			qR: editor,
			mq: '',
			rn: $author$project$Views$Licenses$init,
			uy: $elm$core$Set$empty,
			rO: $author$project$Views$PackageSummaryDisplay$init,
			he: 0,
			iD: $krisajenkins$remotedata$RemoteData$NotAsked,
			iE: '',
			fF: $elm$core$Dict$empty,
			pQ: $elm$core$Set$empty,
			kB: 0,
			hY: $elm$core$Dict$empty
		};
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$getImportableLanguages = A2(
	$elm$core$Basics$composeR,
	$author$project$Model$BuildPlanner$SolveLegacyEditor$getLanguages,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Dict$keys,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$filter($author$project$Model$Language$supportsImporting),
			$elm$core$List$filterMap($author$project$Model$Language$fromString))));
var $author$project$Views$ImportPackagesModal$ImportPackages = {$: 0};
var $author$project$Views$ImportPackagesModal$tabStateInit = {mb: _List_Nil, ja: '', CV: _List_Nil, no: $author$project$Views$ImportPackagesModal$ImportPackages};
var $author$project$Views$ImportPackagesModal$init = function (editor) {
	return {
		pE: false,
		iG: $elm$core$List$head(
			$author$project$Model$BuildPlanner$SolveLegacyEditor$getImportableLanguages(editor)),
		eP: $author$project$Views$ImportPackagesModal$tabStateInit
	};
};
var $author$project$Views$LanguageSelectionModal$init = function (editor) {
	return {qR: editor};
};
var $author$project$Model$Platform$osName = function (_v0) {
	var platform = _v0;
	return platform.ha;
};
var $author$project$Views$PlatformSelectionModal$init = F2(
	function (availablePlatforms, editor) {
		var displayPlatform = A2(
			$elm$core$Maybe$map,
			$author$project$Model$Platform$osName,
			A2(
				$elm$core$Maybe$andThen,
				function (id) {
					return A2($elm$core$Dict$get, id, availablePlatforms);
				},
				$elm$core$List$head(
					$elm$core$Set$toList(
						$author$project$Model$BuildPlanner$SolveLegacyEditor$getPlatforms(editor)))));
		return {or: displayPlatform, qR: editor};
	});
var $author$project$Views$UpdateForkModal$OnMergePreview = function (a) {
	return {$: 3, a: a};
};
var $author$project$Views$UpdateForkModal$OverwriteChangesTab = 1;
var $krisajenkins$remotedata$RemoteData$fromTask = A2(
	$elm$core$Basics$composeR,
	$elm$core$Task$map($krisajenkins$remotedata$RemoteData$Success),
	$elm$core$Task$onError(
		A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$Failure, $elm$core$Task$succeed)));
var $author$project$Request$Branch$MergePreview = F3(
	function (keepChanges, overwriteChanges, conflicts) {
		return {BW: conflicts, DO: keepChanges, E1: overwriteChanges};
	});
var $author$project$Request$Branch$decodeMergePreview = function () {
	var decodeKey = A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'requirement',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'namespace',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($elm$core$Tuple$pair)));
	return A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'conflicts',
		$elm$json$Json$Decode$list(decodeKey),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'overwrite-changes',
			$elm$json$Json$Decode$list($author$project$Model$Change$decode),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'keep-changes',
				$elm$json$Json$Decode$list($author$project$Model$Change$decode),
				$elm$json$Json$Decode$succeed($author$project$Request$Branch$MergePreview))));
}();
var $author$project$Request$Branch$getMergePreview = F2(
	function (creds, branchID) {
		var url = A2(
			$elm$url$Url$Builder$absolute,
			_List_fromArray(
				[
					'vcs',
					'branch',
					$danyx23$elm_uuid$Uuid$toString(branchID),
					'merge'
				]),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'strategy', 'preview')
				]));
		return $author$project$Http$Extra$post(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$emptyBody,
				qN: $author$project$Request$Branch$decodeMergePreview,
				CN: _List_Nil,
				GT: url
			});
	});
var $author$project$Views$UpdateForkModal$init = F6(
	function (creds, branch, project, orgUrlName, platforms, updateType) {
		return A2(
			$author$project$Misc$with,
			A2(
				$elm$core$Task$attempt,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Result$withDefault($krisajenkins$remotedata$RemoteData$NotAsked),
					$author$project$Views$UpdateForkModal$OnMergePreview),
				$krisajenkins$remotedata$RemoteData$fromTask(
					A2(
						$author$project$Request$Branch$getMergePreview,
						creds,
						$author$project$Model$Branch$getID(branch)))),
			{h4: branch, tu: creds, ye: $elm$core$Maybe$Nothing, E_: orgUrlName, Fh: platforms, c5: project, FX: 1, su: $krisajenkins$remotedata$RemoteData$NotAsked, wT: updateType});
	});
var $author$project$Views$AddPackagesModal$initialFocusID = 'add-package-search';
var $author$project$Views$ImportPackagesModal$initialFocusID = 'import-packages-input';
var $author$project$Model$BuildPlanner$SolveLegacyEditor$isPlatformSelected = F2(
	function (platform, editor) {
		return A2(
			$elm$core$Set$member,
			$author$project$Model$Platform$id(platform),
			$author$project$Model$BuildPlanner$SolveLegacyEditor$getPlatforms(editor));
	});
var $krisajenkins$remotedata$RemoteData$isNotAsked = function (data) {
	if (!data.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Model$BuildDataSource$latest = function (_v0) {
	var existingBuildData = _v0.Cu;
	var newBuildData = _v0.Ep;
	return $krisajenkins$remotedata$RemoteData$isNotAsked(newBuildData) ? existingBuildData : newBuildData;
};
var $author$project$Model$PopularPackages$OnPopularPackages = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Inventory$Enum$Ingredient_select_column$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'creation_timestamp';
		case 1:
			return 'description';
		case 2:
			return 'ingredient_id';
		case 3:
			return 'name';
		case 4:
			return 'normalized_name';
		case 5:
			return 'primary_namespace_id';
		default:
			return 'website';
	}
};
var $author$project$Inventory$Query$ingredient = F2(
	function (fillInOptionals____, object____) {
		var filledInOptionals____ = fillInOptionals____(
			{tE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ux: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, uR: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, vE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ao: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs____ = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'distinct_on',
					filledInOptionals____.tE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Ingredient_select_column$toString))),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'limit', filledInOptionals____.ux, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'offset', filledInOptionals____.uR, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'order_by',
					filledInOptionals____.vE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeIngredient_order_by)),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'where', filledInOptionals____.ao, $author$project$Inventory$InputObject$encodeIngredient_bool_exp)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'ingredient',
			optionalArgs____,
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
	});
var $author$project$Model$HasuraIngredient$HasuraIngredient = $elm$core$Basics$identity;
var $author$project$Inventory$Object$Ingredient$description = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'InventoryScalarCodecs.Citext',
	'description',
	_List_Nil,
	$author$project$Inventory$Scalar$unwrapCodecs($author$project$InventoryScalarCodecs$codecs).cL.qN);
var $author$project$Inventory$Object$Ingredient$ingredient_id = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'InventoryScalarCodecs.Uuid',
	'ingredient_id',
	_List_Nil,
	$author$project$Inventory$Scalar$unwrapCodecs($author$project$InventoryScalarCodecs$codecs).aq.qN);
var $author$project$Model$HasuraIngredient$PopularPackageVersion = $elm$core$Basics$identity;
var $author$project$Inventory$Object$Ingredient_version$license_expression = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'InventoryScalarCodecs.Citext',
	'license_expression',
	_List_Nil,
	$author$project$Inventory$Scalar$unwrapCodecs($author$project$InventoryScalarCodecs$codecs).cL.qN);
var $author$project$Model$HasuraIngredient$Revision = F5(
	function (scannerLicenseExpression, activestateLicenseExpression, isIndemnified, checksum, features) {
		return {w8: activestateLicenseExpression, dE: checksum, lT: features, Dm: isIndemnified, zY: scannerLicenseExpression};
	});
var $author$project$Inventory$Object$Ingredient_version_revision$activestate_license_expression = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'InventoryScalarCodecs.Citext',
	'activestate_license_expression',
	_List_Nil,
	$author$project$Inventory$Scalar$unwrapCodecs($author$project$InventoryScalarCodecs$codecs).cL.qN);
var $author$project$Inventory$Object$Feature$feature = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'feature', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Inventory$Object$Ingredient_version_revision_feature$feature = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'feature', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Inventory$InputObject$encodeFeature_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'feature',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.d,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'feature_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.e,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'namespace',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aE, $author$project$Inventory$InputObject$encodeNamespace_order_by)),
				_Utils_Tuple2(
				'namespace_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.i,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'provided_by_aggregate',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.na, $author$project$Inventory$InputObject$encodeIngredient_version_revision_feature_aggregate_order_by)),
				_Utils_Tuple2(
				'sortable_version',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.gE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'version',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aI,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString)))
			]));
};
var $author$project$Inventory$InputObject$encodeIngredient_version_revision_feature_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'feature',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d, $author$project$Inventory$InputObject$encodeFeature_order_by)),
				_Utils_Tuple2(
				'feature_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.e,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_version_revision_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b$,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'revision',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ac, $author$project$Inventory$InputObject$encodeIngredient_version_revision_order_by))
			]));
};
var $author$project$Inventory$Enum$Ingredient_version_revision_feature_select_column$toString = function (enum____) {
	if (!enum____) {
		return 'feature_id';
	} else {
		return 'ingredient_version_revision_id';
	}
};
var $author$project$Inventory$Object$Ingredient_version_revision$provided_features = F2(
	function (fillInOptionals____, object____) {
		var filledInOptionals____ = fillInOptionals____(
			{tE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ux: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, uR: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, vE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ao: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs____ = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'distinct_on',
					filledInOptionals____.tE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Ingredient_version_revision_feature_select_column$toString))),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'limit', filledInOptionals____.ux, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'offset', filledInOptionals____.uR, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'order_by',
					filledInOptionals____.vE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeIngredient_version_revision_feature_order_by)),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'where', filledInOptionals____.ao, $author$project$Inventory$InputObject$encodeIngredient_version_revision_feature_bool_exp)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'provided_features',
			optionalArgs____,
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
	});
var $author$project$Inventory$Object$Ingredient_version_revision$scanner_license_expression = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'InventoryScalarCodecs.Citext',
	'scanner_license_expression',
	_List_Nil,
	$author$project$Inventory$Scalar$unwrapCodecs($author$project$InventoryScalarCodecs$codecs).cL.qN);
var $author$project$Model$HasuraIngredient$selectionSetRevision = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2(
		$author$project$Inventory$Object$Ingredient_version_revision$provided_features,
		$elm$core$Basics$identity,
		$author$project$Inventory$Object$Ingredient_version_revision_feature$feature($author$project$Inventory$Object$Feature$feature)),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$Inventory$Object$Ingredient_version_revision$source_checksum),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Inventory$Object$Ingredient_version_revision$is_indemnified,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Inventory$Object$Ingredient_version_revision$activestate_license_expression,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Inventory$Object$Ingredient_version_revision$scanner_license_expression,
					$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$HasuraIngredient$Revision))))));
var $author$project$Model$HasuraIngredient$setOrderRevisionsByAndLimit = function (args) {
	return _Utils_update(
		args,
		{
			ux: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(1),
			vE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
				_List_fromArray(
					[
						$author$project$Inventory$InputObject$buildIngredient_version_revision_order_by(
						function (args_) {
							return _Utils_update(
								args_,
								{
									ac: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(3)
								});
						})
					]))
		});
};
var $author$project$Model$HasuraIngredient$selectionSetVersion = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($author$project$Inventory$Object$Ingredient_version$revisions, $author$project$Model$HasuraIngredient$setOrderRevisionsByAndLimit, $author$project$Model$HasuraIngredient$selectionSetRevision),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Inventory$Object$Ingredient_version$license_expression,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Inventory$Object$Ingredient_version$version,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(
				F3(
					function (version_, licenseExpression_, revisions_) {
						return A2(
							$elm$core$Maybe$map,
							function (revision) {
								return {
									dE: revision.dE,
									lT: revision.lT,
									Dm: revision.Dm,
									go: $author$project$Model$IngredientVersion$parseLicenses(
										_List_fromArray(
											[revision.w8, licenseExpression_, revision.zY])),
									aI: version_
								};
							},
							$elm$core$List$head(revisions_));
					})))));
var $author$project$Model$HasuraIngredient$setVersionsOrderBy = function (args) {
	return _Utils_update(
		args,
		{
			vE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
				_List_fromArray(
					[
						$author$project$Inventory$InputObject$buildIngredient_version_order_by(
						function (args_) {
							return _Utils_update(
								args_,
								{
									gE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(3)
								});
						})
					]))
		});
};
var $author$project$Model$HasuraIngredient$version = function (_v0) {
	var fields = _v0;
	return fields.aI;
};
var $author$project$Inventory$Object$Ingredient$versions = F2(
	function (fillInOptionals____, object____) {
		var filledInOptionals____ = fillInOptionals____(
			{tE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ux: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, uR: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, vE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ao: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs____ = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'distinct_on',
					filledInOptionals____.tE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Ingredient_version_select_column$toString))),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'limit', filledInOptionals____.ux, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'offset', filledInOptionals____.uR, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'order_by',
					filledInOptionals____.vE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeIngredient_version_order_by)),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'where', filledInOptionals____.ao, $author$project$Inventory$InputObject$encodeIngredient_version_bool_exp)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'versions',
			optionalArgs____,
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
	});
var $author$project$Inventory$Object$Ingredient$website = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe InventoryScalarCodecs.Citext)',
	'website',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$Inventory$Scalar$unwrapCodecs($author$project$InventoryScalarCodecs$codecs).cL.qN));
var $author$project$Model$HasuraIngredient$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($author$project$Inventory$Object$Ingredient$versions, $author$project$Model$HasuraIngredient$setVersionsOrderBy, $author$project$Model$HasuraIngredient$selectionSetVersion),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$Inventory$Object$Ingredient$website),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Inventory$Object$Ingredient$description,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Inventory$Object$Ingredient$ingredient_id,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(
					F4(
						function (_v0, description_, website_, versions_) {
							var ingredientId_ = _v0;
							var versions = $elm_community$maybe_extra$Maybe$Extra$values(versions_);
							if (!versions.b) {
								return $elm$core$Maybe$Nothing;
							} else {
								var allVersions_ = versions;
								var firstVersion_ = allVersions_.a;
								return $elm$core$Maybe$Just(
									{
										sR: A2($elm_community$dict_extra$Dict$Extra$fromListBy, $author$project$Model$HasuraIngredient$version, allVersions_),
										qj: A2($elm$core$List$map, $author$project$Model$HasuraIngredient$version, versions),
										bP: description_,
										tQ: firstVersion_,
										uf: ingredientId_,
										bk: website_
									});
							}
						}))))));
var $author$project$Request$HasuraIngredients$setEq = F2(
	function (value, args) {
		return _Utils_update(
			args,
			{
				aW: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(value)
			});
	});
var $author$project$Request$HasuraIngredients$setNamespaceEq = F2(
	function (namespace, args) {
		return _Utils_update(
			args,
			{
				aE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					$author$project$Inventory$InputObject$buildCitext_comparison_exp(
						$author$project$Request$HasuraIngredients$setEq(namespace)))
			});
	});
var $author$project$Request$HasuraIngredients$setNamespace = F2(
	function (namespace, args) {
		return _Utils_update(
			args,
			{
				aE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					$author$project$Inventory$InputObject$buildNamespace_bool_exp(
						$author$project$Request$HasuraIngredients$setNamespaceEq(namespace)))
			});
	});
var $author$project$Request$HasuraIngredients$setNormalizedNameEq = F2(
	function (name, args) {
		return _Utils_update(
			args,
			{
				b7: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					$author$project$Inventory$InputObject$buildString_comparison_exp(
						$author$project$Request$HasuraIngredients$setEq(name)))
			});
	});
var $author$project$Request$HasuraIngredients$setWhere = F2(
	function (key, args) {
		var namespace = $author$project$Model$Namespace$getNamespace(key);
		var name = $author$project$Model$Namespace$getName(key);
		return _Utils_update(
			args,
			{
				ao: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					$author$project$Inventory$InputObject$buildIngredient_bool_exp(
						A2(
							$elm$core$Basics$composeL,
							$author$project$Request$HasuraIngredients$setNamespace(namespace),
							$author$project$Request$HasuraIngredients$setNormalizedNameEq(name))))
			});
	});
var $author$project$Request$HasuraIngredients$getPopularPackage = function (key) {
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
		A2($elm$core$Basics$composeR, $elm_community$maybe_extra$Maybe$Extra$values, $elm$core$List$head),
		A2(
			$author$project$Inventory$Query$ingredient,
			$author$project$Request$HasuraIngredients$setWhere(key),
			$author$project$Model$HasuraIngredient$selectionSet));
};
var $author$project$Request$HasuraIngredients$getPopularPackages = F3(
	function (session, languageName, packageNames) {
		var namespace = $author$project$Model$Namespace$addLanguagePrefix(languageName);
		var toPair = function (name) {
			var key = _Utils_Tuple2(namespace, name);
			return A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
				$elm$core$Maybe$map(
					$elm$core$Tuple$pair(key)),
				$author$project$Request$HasuraIngredients$getPopularPackage(key));
		};
		var creds = $author$project$Model$Session$getCreds(session);
		var combine = F2(
			function (mpair, acc) {
				if (mpair.$ === 1) {
					return acc;
				} else {
					var _v1 = mpair.a;
					var key = _v1.a;
					var popularPackage = _v1.b;
					return A3($elm$core$Dict$insert, key, popularPackage, acc);
				}
			});
		return A5(
			$author$project$GraphQL$Utils$queryRequest,
			creds,
			1,
			_List_Nil,
			'GetPopularPackages_' + languageName,
			A3(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$foldl,
				combine,
				$elm$core$Dict$empty,
				A2($elm$core$List$map, toPair, packageNames)));
	});
var $author$project$Model$PopularPackages$perlPackages = _List_fromArray(
	['DBI', 'DBIx-Class', 'DateTime', 'Devel-NYTProf', 'JSON', 'Mojolicious', 'Moose', 'Path-Tiny', 'Text-CSV', 'Try-Tiny']);
var $author$project$Model$PopularPackages$pythonPackages = _List_fromArray(
	['django', 'flask', 'matplotlib', 'numpy', 'pandas', 'requests', 'scikit-learn', 'scipy', 'tensorflow', 'torch']);
var $author$project$Model$PopularPackages$rubyPackages = _List_fromArray(
	['aws-sdk-core', 'bundler', 'nokogiri', 'rack', 'rails', 'rake', 'rspec', 'thor']);
var $author$project$Model$PopularPackages$listForLanguage = function (language) {
	switch (language) {
		case 1:
			return $author$project$Model$PopularPackages$pythonPackages;
		case 0:
			return $author$project$Model$PopularPackages$perlPackages;
		case 3:
			return $author$project$Model$PopularPackages$rubyPackages;
		default:
			return _List_Nil;
	}
};
var $author$project$Model$PopularPackages$loadPopularPackages = F2(
	function (session, model) {
		var _v0 = A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$batch,
			A3(
				$elm$core$List$foldl,
				F2(
					function (language, _v1) {
						var m = _v1.a;
						var cmds = _v1.b;
						var _v2 = A2(
							$elm$core$Dict$get,
							$author$project$Model$Language$toString(language),
							m.hy);
						if (!_v2.$) {
							return _Utils_Tuple2(m, cmds);
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									m,
									{
										hy: A3(
											$elm$core$Dict$insert,
											$author$project$Model$Language$toString(language),
											$krisajenkins$remotedata$RemoteData$Loading,
											m.hy)
									}),
								A2(
									$elm$core$List$cons,
									A2(
										$elm$core$Task$attempt,
										$author$project$Model$PopularPackages$OnPopularPackages(
											$author$project$Model$Language$toString(language)),
										A3(
											$author$project$Request$HasuraIngredients$getPopularPackages,
											session,
											$author$project$Model$Language$toString(language),
											$author$project$Model$PopularPackages$listForLanguage(language))),
									cmds));
						}
					}),
				_Utils_Tuple2(model, _List_Nil),
				$mgold$elm_nonempty_list$List$Nonempty$toList($author$project$Model$Language$all)));
		var newModel = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(newModel, cmd);
	});
var $author$project$Pages$ProjectConfig$maximumCommentLength = 100;
var $author$project$Model$BuildPlanner$SolveLegacyEditor$getRequirements = $author$project$Model$BuildPlanner$SolveLegacyEditor$getBuildExprSolveEditor(
	$author$project$Model$Editor$getField(
		function ($) {
			return $.FF;
		}));
var $author$project$Model$NormsAndVulns$OnNormalizations = F4(
	function (a, b, c, d) {
		return {$: 1, a: a, b: b, c: c, d: d};
	});
var $author$project$Model$NormsAndVulns$RemoteNormLoading = {$: 0};
var $author$project$Request$NormsAndVulns$Normalization = F2(
	function (requestedAs, normalized) {
		return {ED: normalized, FD: requestedAs};
	});
var $author$project$Request$NormsAndVulns$decodeNormalization = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'normalized',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'requested_as',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Request$NormsAndVulns$Normalization)));
var $author$project$Request$NormsAndVulns$decodeNormalizations = $elm$json$Json$Decode$list($author$project$Request$NormsAndVulns$decodeNormalization);
var $author$project$Request$NormsAndVulns$getNormalizations = F3(
	function (creds, namespace, names) {
		var queryParams = _List_fromArray(
			[
				A2($elm$url$Url$Builder$string, 'namespace', namespace)
			]);
		var url = A2(
			$elm$url$Url$Builder$absolute,
			_List_fromArray(
				[$author$project$Request$Ingredient$baseUrl, 'namespaces', 'normalized-names']),
			queryParams);
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'names',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, names))
				]));
		return $author$project$Http$Extra$post(
			{
				iO: $author$project$Http$Extra$HeaderOnly(creds),
				sY: $author$project$Http$Extra$jsonBody(body),
				qN: A2($elm$json$Json$Decode$field, 'normalized_names', $author$project$Request$NormsAndVulns$decodeNormalizations),
				CN: _List_Nil,
				GT: url
			});
	});
var $author$project$Model$NormsAndVulns$insertKeyInternal = F3(
	function (key, norm, fields) {
		return _Utils_update(
			fields,
			{
				mo: A3($elm$core$Dict$insert, key, norm, fields.mo)
			});
	});
var $author$project$Model$Namespace$prePlatformInstaller = 'pre-platform-installer';
var $author$project$Model$NormsAndVulns$recordKeysInternal = F4(
	function (creds, keys, pendingVulnerabilityKeys, model) {
		var fields = model;
		var newKeys = A2(
			$elm$core$List$filter,
			function (key) {
				return (!_Utils_eq(
					$author$project$Model$Namespace$getNamespace(key),
					$author$project$Model$Namespace$prePlatformInstaller)) && (!A2($elm$core$Dict$member, key, fields.mo));
			},
			keys);
		if ($elm$core$List$isEmpty(newKeys)) {
			return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
		} else {
			var normalizeNamespace = F2(
				function (namespace, keysInNamespace) {
					var names = $elm_community$list_extra$List$Extra$unique(
						A2($elm$core$List$map, $author$project$Model$Namespace$getName, keysInNamespace));
					return A2(
						$elm$core$Task$attempt,
						A3($author$project$Model$NormsAndVulns$OnNormalizations, namespace, names, pendingVulnerabilityKeys),
						A3($author$project$Request$NormsAndVulns$getNormalizations, creds, namespace, names));
				});
			var newFields = A3(
				$elm$core$List$foldl,
				function (key) {
					return A2($author$project$Model$NormsAndVulns$insertKeyInternal, key, $author$project$Model$NormsAndVulns$RemoteNormLoading);
				},
				fields,
				newKeys);
			var cmd = $elm$core$Platform$Cmd$batch(
				$elm$core$Dict$values(
					A2(
						$elm$core$Dict$map,
						normalizeNamespace,
						A2($elm_community$dict_extra$Dict$Extra$groupBy, $author$project$Model$Namespace$getNamespace, newKeys))));
			return A2($author$project$Misc$with, cmd, newFields);
		}
	});
var $author$project$Model$NormsAndVulns$recordKeys = F3(
	function (creds, keys, model) {
		return A4($author$project$Model$NormsAndVulns$recordKeysInternal, creds, keys, _List_Nil, model);
	});
var $author$project$Pages$ProjectConfig$normalizeBundlesAndPackages = F3(
	function (creds, model, editor) {
		var requirements = $author$project$Model$BuildPlanner$SolveLegacyEditor$getRequirements(editor);
		var keys = _Utils_ap(
			$elm$core$Dict$keys(requirements.k5),
			$elm$core$Dict$keys(requirements.mY));
		var _v0 = A3($author$project$Model$NormsAndVulns$recordKeys, creds, keys, model.rF);
		var newNormsAndVulns = _v0.a;
		var cmd = _v0.b;
		return A2(
			$author$project$Misc$with,
			A2($elm$core$Platform$Cmd$map, $author$project$Pages$ProjectConfig$NormsAndVulnsMsg, cmd),
			_Utils_update(
				model,
				{rF: newNormsAndVulns}));
	});
var $author$project$Model$Route$projectDownloads = function (_v0) {
	var orgName = _v0.ix;
	var projectName = _v0.vT;
	var maybeCommitID = _v0.gr;
	var maybePlatformID = _v0.Ef;
	var isNewProject = _v0.uk;
	var maybeBranchName = _v0.fO;
	return $author$project$Model$Route$Protected(
		$author$project$Model$Route$Org(
			A2(
				$author$project$Model$Route$OrgParams,
				orgName,
				$author$project$Model$Route$OrgProject(
					A2(
						$author$project$Model$Route$OrgProjectParams,
						projectName,
						A4($author$project$Model$Route$ProjectDownloads, maybeCommitID, maybePlatformID, isNewProject, maybeBranchName))))));
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$timestampSetter = F3(
	function (explicit, timestamp, fields) {
		return _Utils_update(
			fields,
			{wG: timestamp, Gx: explicit});
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$setTimestamp = function (explicit) {
	return A2(
		$elm$core$Basics$composeL,
		$author$project$Model$BuildPlanner$SolveLegacyEditor$setBuildExprSolveEditor,
		$author$project$Model$Editor$setField(
			$author$project$Model$BuildPlanner$SolveLegacyEditor$timestampSetter(explicit)));
};
var $author$project$Pages$ProjectConfig$pushCommitTask = F2(
	function (session, model) {
		return A2(
			$author$project$Request$BuildPlanner$pushCommit,
			$author$project$Model$Session$getCreds(session),
			{
				jE: function () {
					var _v0 = model.iK;
					if (!_v0.$) {
						return $elm$core$Maybe$Just(
							$author$project$Model$AtTime$Timestamp(
								$author$project$Pages$ProjectConfig$getPushCommitAtTime(model)));
					} else {
						return $elm$core$Maybe$Just($author$project$Model$AtTime$Now);
					}
				}(),
				xq: $elm$core$Maybe$Just(
					$author$project$Model$Branch$getID(
						$author$project$Pages$ProjectConfig$getCurrentBranch(model))),
				k$: $author$project$Model$BuildPlanner$BuildExprEditor$Simple$toBuildExpr(
					A3($author$project$Model$BuildPlanner$SolveLegacyEditor$setTimestamp, false, $elm$core$Maybe$Nothing, model.qR)),
				c: model.hq,
				BR: $author$project$Model$Commit$getCommitID(model.f0),
				ix: $author$project$Model$Organization$getUrlName(model.c3),
				vT: $author$project$Model$Project$getName(model.c5)
			});
	});
var $author$project$Model$NormsAndVulns$RemoteNormOk = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$NormsAndVulns$entryInsertKeyInternal = F2(
	function (key, entry) {
		return _Utils_update(
			entry,
			{
				oU: A2($elm$core$Set$insert, key, entry.oU)
			});
	});
var $author$project$Model$NormsAndVulns$initEntry = {oU: $elm$core$Set$empty, nQ: $elm$core$Dict$empty};
var $author$project$Model$NormsAndVulns$updateEntryInternal = F3(
	function (normalizedKey, func, fields) {
		return _Utils_update(
			fields,
			{
				mM: A3(
					$elm$core$Dict$update,
					normalizedKey,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$withDefault($author$project$Model$NormsAndVulns$initEntry),
						A2($elm$core$Basics$composeR, func, $elm$core$Maybe$Just)),
					fields.mM)
			});
	});
var $author$project$Model$NormsAndVulns$insertKeyOkInternal = F2(
	function (key, normalizedKey) {
		return A2(
			$elm$core$Basics$composeR,
			A2(
				$author$project$Model$NormsAndVulns$insertKeyInternal,
				key,
				$author$project$Model$NormsAndVulns$RemoteNormOk(normalizedKey)),
			A2(
				$author$project$Model$NormsAndVulns$updateEntryInternal,
				normalizedKey,
				$author$project$Model$NormsAndVulns$entryInsertKeyInternal(key)));
	});
var $author$project$Model$NormsAndVulns$recordNormalizedKeys = F2(
	function (keys, _v0) {
		var fields = _v0;
		return A3(
			$elm$core$List$foldl,
			function (key) {
				var k = key;
				return A2($author$project$Model$NormsAndVulns$insertKeyOkInternal, k, k);
			},
			fields,
			keys);
	});
var $author$project$Model$Permissions$orgCanSeeCVEData = $author$project$Model$Organization$addOnEnabled('cve_config');
var $author$project$Model$Permissions$orgHasCvesEnabledAndVisible = F2(
	function (organization, user) {
		return $author$project$Model$Permissions$orgCanSeeCVEData(organization) && A2($author$project$Model$Permissions$canViewOrgPrivateInfo, organization.AC, user);
	});
var $author$project$Model$NormsAndVulns$OnVulnerabilities = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Model$NormsAndVulns$RemoteVulnsLoading = {$: 0};
var $author$project$Model$NormsAndVulns$getRemoteVulnsInternal = F2(
	function (key, fields) {
		if (!key.$) {
			var namespacedKey = key.a;
			return A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.nQ;
					},
					$elm$core$Dict$get(namespacedKey.aI)),
				A2(
					$elm$core$Dict$get,
					$author$project$Model$Namespace$key(namespacedKey),
					fields.mM));
		} else {
			var _v1 = key.a;
			var purl = _v1.a;
			var version = _v1.b;
			return A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.nQ;
					},
					$elm$core$Dict$get(version)),
				A2($elm$core$Dict$get, purl, fields.pw));
		}
	});
var $author$project$GraphQL$Utils$CVE = 3;
var $author$project$Request$NormsAndVulns$PurlInput = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$Vulnerability$fromAnalyticsVulnerability = function (_v0) {
	var cveID = _v0.B9;
	var severity = _v0.ck;
	var source = _v0.o;
	return {B9: cveID, ck: severity, o: source};
};
var $author$project$Analytics$InputObject$encodeGet_cves_args = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'args',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.kO,
					A2(
						$author$project$Analytics$Scalar$unwrapEncoder,
						function ($) {
							return $.BP;
						},
						$author$project$Analytics$ScalarCodecs$codecs)))
			]));
};
var $author$project$Analytics$InputObject$encodeFloat8_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_eq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aW,
					A2(
						$author$project$Analytics$Scalar$unwrapEncoder,
						function ($) {
							return $.fL;
						},
						$author$project$Analytics$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aY,
					A2(
						$author$project$Analytics$Scalar$unwrapEncoder,
						function ($) {
							return $.fL;
						},
						$author$project$Analytics$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aZ,
					A2(
						$author$project$Analytics$Scalar$unwrapEncoder,
						function ($) {
							return $.fL;
						},
						$author$project$Analytics$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Analytics$Scalar$unwrapEncoder,
							function ($) {
								return $.fL;
							},
							$author$project$Analytics$ScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a0,
					A2(
						$author$project$Analytics$Scalar$unwrapEncoder,
						function ($) {
							return $.fL;
						},
						$author$project$Analytics$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_lte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a1,
					A2(
						$author$project$Analytics$Scalar$unwrapEncoder,
						function ($) {
							return $.fL;
						},
						$author$project$Analytics$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_neq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a4,
					A2(
						$author$project$Analytics$Scalar$unwrapEncoder,
						function ($) {
							return $.fL;
						},
						$author$project$Analytics$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Analytics$Scalar$unwrapEncoder,
							function ($) {
								return $.fL;
							},
							$author$project$Analytics$ScalarCodecs$codecs))))
			]));
};
var $author$project$Analytics$InputObject$encodeString_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_eq',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aW, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_gt',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aY, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_gte',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aZ, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_ilike',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.l7, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string))),
				_Utils_Tuple2(
				'_iregex',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mj, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_like',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mt, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_lt',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a0, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_lte',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_neq',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a4, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_nilike',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mI, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string))),
				_Utils_Tuple2(
				'_niregex',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mJ, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_nlike',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mK, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_nregex',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mO, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_nsimilar',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mP, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_regex',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.nd, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_similar',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.nv, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))
			]));
};
var $author$project$Analytics$InputObject$encodeTimestamp_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_eq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aW,
					A2(
						$author$project$Analytics$Scalar$unwrapEncoder,
						function ($) {
							return $.bC;
						},
						$author$project$Analytics$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aY,
					A2(
						$author$project$Analytics$Scalar$unwrapEncoder,
						function ($) {
							return $.bC;
						},
						$author$project$Analytics$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aZ,
					A2(
						$author$project$Analytics$Scalar$unwrapEncoder,
						function ($) {
							return $.bC;
						},
						$author$project$Analytics$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Analytics$Scalar$unwrapEncoder,
							function ($) {
								return $.bC;
							},
							$author$project$Analytics$ScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a0,
					A2(
						$author$project$Analytics$Scalar$unwrapEncoder,
						function ($) {
							return $.bC;
						},
						$author$project$Analytics$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_lte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a1,
					A2(
						$author$project$Analytics$Scalar$unwrapEncoder,
						function ($) {
							return $.bC;
						},
						$author$project$Analytics$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_neq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a4,
					A2(
						$author$project$Analytics$Scalar$unwrapEncoder,
						function ($) {
							return $.bC;
						},
						$author$project$Analytics$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Analytics$Scalar$unwrapEncoder,
							function ($) {
								return $.bC;
							},
							$author$project$Analytics$ScalarCodecs$codecs))))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_purl_vulnerability_match_bool_exp = function (_v2) {
	var input____ = _v2;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Analytics$InputObject$encodeDim_purl_vulnerability_match_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Analytics$InputObject$encodeDim_purl_vulnerability_match_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Analytics$InputObject$encodeDim_purl_vulnerability_match_bool_exp))),
				_Utils_Tuple2(
				'criteria',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aU, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'date',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aV, $author$project$Analytics$InputObject$encodeTimestamp_comparison_exp)),
				_Utils_Tuple2(
				'dim_vulnerability',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cQ, $author$project$Analytics$InputObject$encodeDim_vulnerability_bool_exp)),
				_Utils_Tuple2(
				'match_criteria_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a2, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'part',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a6, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'product',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a8, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'purl',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.k, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'purl_vulnerability_match_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a9, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'vendor',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bf, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'version_end_excluding',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bg, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'version_end_including',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bh, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'version_start_excluding',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bi, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'version_start_including',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bj, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'vulnerability_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ad, $author$project$Analytics$InputObject$encodeString_comparison_exp))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_severities_bool_exp = function (_v1) {
	var input____ = _v1;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Analytics$InputObject$encodeDim_severities_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Analytics$InputObject$encodeDim_severities_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Analytics$InputObject$encodeDim_severities_bool_exp))),
				_Utils_Tuple2(
				'dim_vulnerabilities',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.lE, $author$project$Analytics$InputObject$encodeDim_vulnerability_bool_exp)),
				_Utils_Tuple2(
				'is_critical_severity',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d5, $author$project$Analytics$InputObject$encodeBoolean_comparison_exp)),
				_Utils_Tuple2(
				'is_high_severity',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d7, $author$project$Analytics$InputObject$encodeBoolean_comparison_exp)),
				_Utils_Tuple2(
				'is_low_severity',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ed, $author$project$Analytics$InputObject$encodeBoolean_comparison_exp)),
				_Utils_Tuple2(
				'is_medium_severity',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ef, $author$project$Analytics$InputObject$encodeBoolean_comparison_exp)),
				_Utils_Tuple2(
				'is_moderate_severity',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.eg, $author$project$Analytics$InputObject$encodeBoolean_comparison_exp)),
				_Utils_Tuple2(
				'severities_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bd, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'severities_labels',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.eK, $author$project$Analytics$InputObject$encodeString_comparison_exp))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_vulnerability_bool_exp = function (_v0) {
	var input____ = _v0;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Analytics$InputObject$encodeDim_vulnerability_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Analytics$InputObject$encodeDim_vulnerability_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Analytics$InputObject$encodeDim_vulnerability_bool_exp))),
				_Utils_Tuple2(
				'basescore',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.S, $author$project$Analytics$InputObject$encodeFloat8_comparison_exp)),
				_Utils_Tuple2(
				'cve_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bM, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'description',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bP, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'dim_purl_vulnerability_matches',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.lC, $author$project$Analytics$InputObject$encodeDim_purl_vulnerability_match_bool_exp)),
				_Utils_Tuple2(
				'dim_severity',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f9, $author$project$Analytics$InputObject$encodeDim_severities_bool_exp)),
				_Utils_Tuple2(
				'exploitabilityscore',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.U, $author$project$Analytics$InputObject$encodeFloat8_comparison_exp)),
				_Utils_Tuple2(
				'impactscore',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.V, $author$project$Analytics$InputObject$encodeFloat8_comparison_exp)),
				_Utils_Tuple2(
				'published',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ce, $author$project$Analytics$InputObject$encodeTimestamp_comparison_exp)),
				_Utils_Tuple2(
				'severities_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bd, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'severity',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ck, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'source',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.o, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'summary',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cn, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'vulnerability_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ad, $author$project$Analytics$InputObject$encodeString_comparison_exp))
			]));
};
var $author$project$Analytics$InputObject$encodePurl_vulnerability_specific_match_bool_exp = function (_v0) {
	var input____ = _v0;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Analytics$InputObject$encodePurl_vulnerability_specific_match_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Analytics$InputObject$encodePurl_vulnerability_specific_match_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Analytics$InputObject$encodePurl_vulnerability_specific_match_bool_exp))),
				_Utils_Tuple2(
				'criteria',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aU, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'date',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aV, $author$project$Analytics$InputObject$encodeTimestamp_comparison_exp)),
				_Utils_Tuple2(
				'dim_vulnerability',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cQ, $author$project$Analytics$InputObject$encodeDim_vulnerability_bool_exp)),
				_Utils_Tuple2(
				'input_purl',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d2, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'input_purl_version',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d3, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'match_criteria_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a2, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'part',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a6, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'product',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a8, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'purl',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.k, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'purl_version',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.eF, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'purl_vulnerability_match_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a9, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'vendor',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bf, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'version_end_excluding',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bg, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'version_end_including',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bh, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'version_start_excluding',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bi, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'version_start_including',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bj, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'vulnerability_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ad, $author$project$Analytics$InputObject$encodeString_comparison_exp))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_purl_vulnerability_match_max_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'criteria',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aU,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'date',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aV,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'match_criteria_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a2,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'part',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a6,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'product',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a8,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'purl',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.k,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'purl_vulnerability_match_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a9,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'vendor',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bf,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'version_end_excluding',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bg,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'version_end_including',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bh,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'version_start_excluding',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bi,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'version_start_including',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bj,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'vulnerability_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ad,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString)))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_purl_vulnerability_match_min_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'criteria',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aU,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'date',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aV,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'match_criteria_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a2,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'part',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a6,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'product',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a8,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'purl',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.k,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'purl_vulnerability_match_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a9,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'vendor',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bf,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'version_end_excluding',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bg,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'version_end_including',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bh,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'version_start_excluding',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bi,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'version_start_including',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bj,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'vulnerability_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ad,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString)))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_purl_vulnerability_match_aggregate_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'count',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cO,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'max',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c1, $author$project$Analytics$InputObject$encodeDim_purl_vulnerability_match_max_order_by)),
				_Utils_Tuple2(
				'min',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c2, $author$project$Analytics$InputObject$encodeDim_purl_vulnerability_match_min_order_by))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_vulnerability_avg_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'basescore',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.S,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'exploitabilityscore',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.U,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'impactscore',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.V,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString)))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_vulnerability_max_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'basescore',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.S,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'cve_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bM,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'description',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bP,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'exploitabilityscore',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.U,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'impactscore',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.V,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'published',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ce,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'severities_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bd,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'severity',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ck,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'source',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.o,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'summary',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cn,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'vulnerability_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ad,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString)))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_vulnerability_min_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'basescore',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.S,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'cve_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bM,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'description',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bP,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'exploitabilityscore',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.U,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'impactscore',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.V,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'published',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ce,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'severities_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bd,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'severity',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ck,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'source',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.o,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'summary',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cn,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'vulnerability_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ad,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString)))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_vulnerability_stddev_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'basescore',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.S,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'exploitabilityscore',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.U,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'impactscore',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.V,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString)))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_vulnerability_stddev_pop_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'basescore',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.S,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'exploitabilityscore',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.U,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'impactscore',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.V,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString)))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_vulnerability_stddev_samp_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'basescore',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.S,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'exploitabilityscore',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.U,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'impactscore',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.V,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString)))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_vulnerability_sum_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'basescore',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.S,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'exploitabilityscore',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.U,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'impactscore',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.V,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString)))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_vulnerability_var_pop_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'basescore',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.S,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'exploitabilityscore',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.U,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'impactscore',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.V,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString)))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_vulnerability_var_samp_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'basescore',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.S,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'exploitabilityscore',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.U,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'impactscore',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.V,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString)))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_vulnerability_variance_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'basescore',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.S,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'exploitabilityscore',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.U,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'impactscore',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.V,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString)))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_vulnerability_aggregate_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'avg',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.fX, $author$project$Analytics$InputObject$encodeDim_vulnerability_avg_order_by)),
				_Utils_Tuple2(
				'count',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cO,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'max',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c1, $author$project$Analytics$InputObject$encodeDim_vulnerability_max_order_by)),
				_Utils_Tuple2(
				'min',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c2, $author$project$Analytics$InputObject$encodeDim_vulnerability_min_order_by)),
				_Utils_Tuple2(
				'stddev',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gL, $author$project$Analytics$InputObject$encodeDim_vulnerability_stddev_order_by)),
				_Utils_Tuple2(
				'stddev_pop',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gM, $author$project$Analytics$InputObject$encodeDim_vulnerability_stddev_pop_order_by)),
				_Utils_Tuple2(
				'stddev_samp',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gN, $author$project$Analytics$InputObject$encodeDim_vulnerability_stddev_samp_order_by)),
				_Utils_Tuple2(
				'sum',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gO, $author$project$Analytics$InputObject$encodeDim_vulnerability_sum_order_by)),
				_Utils_Tuple2(
				'var_pop',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gT, $author$project$Analytics$InputObject$encodeDim_vulnerability_var_pop_order_by)),
				_Utils_Tuple2(
				'var_samp',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gU, $author$project$Analytics$InputObject$encodeDim_vulnerability_var_samp_order_by)),
				_Utils_Tuple2(
				'variance',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gV, $author$project$Analytics$InputObject$encodeDim_vulnerability_variance_order_by))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_severities_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'dim_vulnerabilities_aggregate',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.lF, $author$project$Analytics$InputObject$encodeDim_vulnerability_aggregate_order_by)),
				_Utils_Tuple2(
				'is_critical_severity',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.d5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'is_high_severity',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.d7,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'is_low_severity',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ed,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'is_medium_severity',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ef,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'is_moderate_severity',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.eg,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'severities_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bd,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'severities_labels',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.eK,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString)))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_vulnerability_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'basescore',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.S,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'cve_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bM,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'description',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bP,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'dim_purl_vulnerability_matches_aggregate',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.lD, $author$project$Analytics$InputObject$encodeDim_purl_vulnerability_match_aggregate_order_by)),
				_Utils_Tuple2(
				'dim_severity',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f9, $author$project$Analytics$InputObject$encodeDim_severities_order_by)),
				_Utils_Tuple2(
				'exploitabilityscore',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.U,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'impactscore',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.V,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'published',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ce,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'severities_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bd,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'severity',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ck,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'source',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.o,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'summary',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cn,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'vulnerability_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ad,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString)))
			]));
};
var $author$project$Analytics$InputObject$encodePurl_vulnerability_specific_match_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'criteria',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aU,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'date',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aV,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'dim_vulnerability',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cQ, $author$project$Analytics$InputObject$encodeDim_vulnerability_order_by)),
				_Utils_Tuple2(
				'input_purl',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.d2,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'input_purl_version',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.d3,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'match_criteria_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a2,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'part',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a6,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'product',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a8,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'purl',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.k,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'purl_version',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.eF,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'purl_vulnerability_match_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a9,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'vendor',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bf,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'version_end_excluding',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bg,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'version_end_including',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bh,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'version_start_excluding',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bi,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'version_start_including',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bj,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'vulnerability_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ad,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString)))
			]));
};
var $author$project$Analytics$Enum$Purl_vulnerability_specific_match_select_column$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'criteria';
		case 1:
			return 'date';
		case 2:
			return 'input_purl';
		case 3:
			return 'input_purl_version';
		case 4:
			return 'match_criteria_id';
		case 5:
			return 'part';
		case 6:
			return 'product';
		case 7:
			return 'purl';
		case 8:
			return 'purl_version';
		case 9:
			return 'purl_vulnerability_match_id';
		case 10:
			return 'vendor';
		case 11:
			return 'version_end_excluding';
		case 12:
			return 'version_end_including';
		case 13:
			return 'version_start_excluding';
		case 14:
			return 'version_start_including';
		default:
			return 'vulnerability_id';
	}
};
var $author$project$Analytics$Query$get_cves = F3(
	function (fillInOptionals____, requiredArgs____, object____) {
		var filledInOptionals____ = fillInOptionals____(
			{tE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ux: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, uR: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, vE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ao: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs____ = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'distinct_on',
					filledInOptionals____.tE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Purl_vulnerability_specific_match_select_column$toString))),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'limit', filledInOptionals____.ux, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'offset', filledInOptionals____.uR, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'order_by',
					filledInOptionals____.vE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Analytics$InputObject$encodePurl_vulnerability_specific_match_order_by)),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'where', filledInOptionals____.ao, $author$project$Analytics$InputObject$encodePurl_vulnerability_specific_match_bool_exp)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'get_cves',
			_Utils_ap(
				optionalArgs____,
				_List_fromArray(
					[
						A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'args', requiredArgs____.kO, $author$project$Analytics$InputObject$encodeGet_cves_args)
					])),
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
	});
var $author$project$Model$Analytics$DIM$Vulnerability$VulnerabilityMatch = F5(
	function (vulnerability, versionStartIncluding, versionStartExcluding, versionEndIncluding, versionEndExcluding) {
		return {G0: versionEndExcluding, G1: versionEndIncluding, G2: versionStartExcluding, G3: versionStartIncluding, gY: vulnerability};
	});
var $author$project$Analytics$Object$Purl_vulnerability_specific_match$dim_vulnerability = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'dim_vulnerability', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Analytics$Object$Purl_vulnerability_specific_match$input_purl = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'input_purl', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Analytics$Object$Purl_vulnerability_specific_match$input_purl_version = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'input_purl_version', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Model$Analytics$DIM$Vulnerability$Vulnerability = F5(
	function (cveID, severity, description, basescore, source) {
		return {S: basescore, B9: cveID, bP: description, ck: severity, o: source};
	});
var $author$project$Analytics$Scalar$unwrapCodecs = function (_v0) {
	var unwrappedCodecs = _v0;
	return unwrappedCodecs;
};
var $author$project$Analytics$Object$Dim_vulnerability$basescore = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe ScalarCodecs.Float8)',
	'basescore',
	_List_Nil,
	$elm$json$Json$Decode$nullable(
		$author$project$Analytics$Scalar$unwrapCodecs($author$project$Analytics$ScalarCodecs$codecs).fL.qN));
var $author$project$Analytics$Object$Dim_vulnerability$cve_id = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'cve_id', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Analytics$Object$Dim_vulnerability$description = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'description',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Model$VulnerabilitySource$OSV = 0;
var $author$project$Model$VulnerabilitySource$Unknown = 1;
var $author$project$Model$VulnerabilitySource$fromString = function (source) {
	var _v0 = $elm$core$String$toLower(source);
	if (_v0 === 'osv') {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Analytics$Object$Dim_vulnerability$severity = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'severity',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Analytics$Object$Dim_vulnerability$source = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'source', _List_Nil, $elm$json$Json$Decode$string);
var $elm_community$maybe_extra$Maybe$Extra$unwrap = F3(
	function (_default, f, m) {
		if (m.$ === 1) {
			return _default;
		} else {
			var a = m.a;
			return f(a);
		}
	});
var $author$project$Model$Analytics$DIM$Vulnerability$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Model$VulnerabilitySource$fromString, $author$project$Analytics$Object$Dim_vulnerability$source),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Analytics$Object$Dim_vulnerability$basescore,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Analytics$Object$Dim_vulnerability$description,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					A2($elm_community$maybe_extra$Maybe$Extra$unwrap, 0, $author$project$Model$Severity$fromString),
					$author$project$Analytics$Object$Dim_vulnerability$severity),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Analytics$Object$Dim_vulnerability$cve_id,
					$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$Analytics$DIM$Vulnerability$Vulnerability))))));
var $author$project$Analytics$Object$Purl_vulnerability_specific_match$version_end_excluding = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'version_end_excluding',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Analytics$Object$Purl_vulnerability_specific_match$version_end_including = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'version_end_including',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Analytics$Object$Purl_vulnerability_specific_match$version_start_excluding = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'version_start_excluding',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Analytics$Object$Purl_vulnerability_specific_match$version_start_including = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'version_start_including',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Request$Analytics$Vulnerabilities$matchSelectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$Analytics$Object$Purl_vulnerability_specific_match$version_end_excluding),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$Analytics$Object$Purl_vulnerability_specific_match$version_end_including),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$Analytics$Object$Purl_vulnerability_specific_match$version_start_excluding),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					A2($dillonkearns$elm_graphql$Graphql$SelectionSet$withDefault, '', $author$project$Analytics$Object$Purl_vulnerability_specific_match$version_start_including),
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Analytics$Object$Purl_vulnerability_specific_match$dim_vulnerability($author$project$Model$Analytics$DIM$Vulnerability$selectionSet),
						$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$Analytics$DIM$Vulnerability$VulnerabilityMatch)))))),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Analytics$Object$Purl_vulnerability_specific_match$input_purl_version,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Analytics$Object$Purl_vulnerability_specific_match$input_purl,
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Tuple$pair))),
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Tuple$pair)));
var $author$project$Request$Analytics$Vulnerabilities$getCVEMatches = F2(
	function (creds, cveKeys) {
		var encodeKey = function (_v0) {
			var purl = _v0.a;
			var version = _v0.b;
			return ($elm$core$String$isEmpty(purl) || $elm$core$String$isEmpty(version)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				A2(
					$elm$core$String$join,
					'',
					_List_fromArray(
						['{', purl, ',', version, '}'])));
		};
		var encodedKeys = '{' + (A2(
			$elm$core$String$join,
			',',
			A2($elm$core$List$filterMap, encodeKey, cveKeys)) + '}');
		return A5(
			$author$project$GraphQL$Utils$queryRequest,
			creds,
			2,
			_List_Nil,
			'GetCVEs',
			A3(
				$author$project$Analytics$Query$get_cves,
				$elm$core$Basics$identity,
				{
					kO: {
						kO: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(encodedKeys)
					}
				},
				$author$project$Request$Analytics$Vulnerabilities$matchSelectionSet));
	});
var $author$project$Request$NormsAndVulns$possibleInputsToAnalytics = function (input) {
	if (input.$ === 1) {
		var i = input.a;
		return $elm$core$Maybe$Just(i);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Request$NormsAndVulns$possibleInputsToNamespaced = function (input) {
	if (!input.$) {
		var i = input.a;
		return $elm$core$Maybe$Just(i);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Request$NormsAndVulns$NamespacedInput = function (a) {
	return {$: 0, a: a};
};
var $author$project$Request$NormsAndVulns$encodeVulnerabilityInput = function (_v0) {
	var key = _v0.Y;
	var version = _v0.aI;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'namespace',
				$elm$json$Json$Encode$string(
					$author$project$Model$Namespace$getNamespace(key))),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(
					$author$project$Model$Namespace$getName(key))),
				_Utils_Tuple2(
				'version',
				$elm$json$Json$Encode$string(version))
			]));
};
var $author$project$Request$NormsAndVulns$NamespacedVulnInput = F2(
	function (key, version) {
		return {Y: key, aI: version};
	});
var $author$project$BuilderCVE$Object$Hasura_vulnerable_ingredients_filter_return_type$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuilderCVE$Object$Hasura_vulnerable_ingredients_filter_return_type$primary_namespace = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'primary_namespace', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Request$NormsAndVulns$selectKey = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$BuilderCVE$Object$Hasura_vulnerable_ingredients_filter_return_type$name,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuilderCVE$Object$Hasura_vulnerable_ingredients_filter_return_type$primary_namespace,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Tuple$pair)));
var $author$project$BuilderCVE$Object$Hasura_vulnerable_ingredients_filter_return_type$version = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'version', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Request$NormsAndVulns$selectVulnerabilityInput = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$BuilderCVE$Object$Hasura_vulnerable_ingredients_filter_return_type$version,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Request$NormsAndVulns$selectKey,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Request$NormsAndVulns$NamespacedVulnInput)));
var $author$project$Model$Vulnerability$Vulnerability = F3(
	function (cveID, severity, source) {
		return {B9: cveID, ck: severity, o: source};
	});
var $author$project$BuilderCVE$Object$Vulnerabilities$cve_identifier = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'cve_identifier', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$BuilderCVE$Object$Vulnerabilities$severity = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'severity', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Model$Vulnerability$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(1),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $author$project$Model$Severity$fromString, $author$project$BuilderCVE$Object$Vulnerabilities$severity),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$BuilderCVE$Object$Vulnerabilities$cve_identifier,
			$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$Vulnerability$Vulnerability))));
var $author$project$BuilderCVE$Object$Hasura_vulnerable_ingredients_filter_return_type$vulnerability = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'vulnerability', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Request$NormsAndVulns$selectVulnerabilityOutput = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
	$author$project$BuilderCVE$Object$Hasura_vulnerable_ingredients_filter_return_type$vulnerability($author$project$Model$Vulnerability$selectionSet),
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Request$NormsAndVulns$selectVulnerabilityInput,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($elm$core$Tuple$pair)));
var $author$project$Request$NormsAndVulns$fromAccKey = function (acckey) {
	var key = acckey.a;
	var version = acckey.b;
	return (key.b === '') ? $author$project$Request$NormsAndVulns$PurlInput(
		A2($elm$core$Tuple$mapFirst, $elm$core$Tuple$first, acckey)) : $author$project$Request$NormsAndVulns$NamespacedInput(
		{Y: key, aI: version});
};
var $author$project$Request$NormsAndVulns$toAccKey = function (input) {
	if (!input.$) {
		var key = input.a.Y;
		var version = input.a.aI;
		return _Utils_Tuple2(key, version);
	} else {
		var purlKey = input.a;
		return A2(
			$elm$core$Tuple$mapFirst,
			function (purl) {
				return _Utils_Tuple2(purl, '');
			},
			purlKey);
	}
};
var $author$project$Request$NormsAndVulns$toVulnerabilityOutputs = F2(
	function (inputs, pairs) {
		var initAcc = A3(
			$elm$core$List$foldl,
			function (input) {
				return A2(
					$elm$core$Dict$insert,
					$author$project$Request$NormsAndVulns$toAccKey(input),
					_List_Nil);
			},
			$elm$core$Dict$empty,
			inputs);
		var finalAcc = A3(
			$elm$core$List$foldr,
			function (_v0) {
				var input = _v0.a;
				var vulnerability = _v0.b;
				return A2(
					$elm$core$Dict$update,
					$author$project$Request$NormsAndVulns$toAccKey(input),
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$withDefault(_List_Nil),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$cons(vulnerability),
							$elm$core$Maybe$Just)));
			},
			initAcc,
			pairs);
		var accumOutput = F3(
			function (accKey, vulnerabilities, acc) {
				return A2(
					$elm$core$List$cons,
					{
						$7: $author$project$Request$NormsAndVulns$fromAccKey(accKey),
						nS: vulnerabilities
					},
					acc);
			});
		return A3($elm$core$Dict$foldr, accumOutput, _List_Nil, finalAcc);
	});
var $author$project$BuilderCVE$Scalar$Bigint = $elm$core$Basics$identity;
var $author$project$BuilderCVE$Scalar$Citext = $elm$core$Basics$identity;
var $author$project$BuilderCVE$Scalar$Citext_ = $elm$core$Basics$identity;
var $author$project$BuilderCVE$Scalar$Jsonb = $elm$core$Basics$identity;
var $author$project$BuilderCVE$Scalar$Text_ = $elm$core$Basics$identity;
var $author$project$BuilderCVE$Scalar$Timestamp = $elm$core$Basics$identity;
var $author$project$BuilderCVE$Scalar$defaultCodecs = {
	dk: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v0) {
			var raw = _v0;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	cL: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v1) {
			var raw = _v1;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	ib: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v2) {
			var raw = _v2;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	g1: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v3) {
			var raw = _v3;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	BP: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v4) {
			var raw = _v4;
			return $elm$json$Json$Encode$string(raw);
		}
	},
	bC: {
		qN: A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$scalarDecoder),
		lN: function (_v5) {
			var raw = _v5;
			return $elm$json$Json$Encode$string(raw);
		}
	}
};
var $author$project$BuilderCVE$Scalar$Codecs = $elm$core$Basics$identity;
var $author$project$BuilderCVE$Scalar$defineCodecs = function (definitions) {
	return definitions;
};
var $author$project$BuilderCVE$ScalarCodecs$codecs = $author$project$BuilderCVE$Scalar$defineCodecs(
	{dk: $author$project$BuilderCVE$Scalar$defaultCodecs.dk, cL: $author$project$BuilderCVE$Scalar$defaultCodecs.cL, ib: $author$project$BuilderCVE$Scalar$defaultCodecs.ib, g1: $author$project$BuilderCVE$Scalar$defaultCodecs.g1, BP: $author$project$BuilderCVE$Scalar$defaultCodecs.BP, bC: $author$project$BuilderCVE$Scalar$defaultCodecs.bC});
var $author$project$BuilderCVE$Scalar$unwrapEncoder = F2(
	function (getter, _v0) {
		var unwrappedCodecs = _v0;
		return A2(
			$elm$core$Basics$composeR,
			getter(unwrappedCodecs).lN,
			$dillonkearns$elm_graphql$Graphql$Internal$Encode$fromJson);
	});
var $author$project$BuilderCVE$InputObject$encodeBigint_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_eq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aW,
					A2(
						$author$project$BuilderCVE$Scalar$unwrapEncoder,
						function ($) {
							return $.dk;
						},
						$author$project$BuilderCVE$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aY,
					A2(
						$author$project$BuilderCVE$Scalar$unwrapEncoder,
						function ($) {
							return $.dk;
						},
						$author$project$BuilderCVE$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aZ,
					A2(
						$author$project$BuilderCVE$Scalar$unwrapEncoder,
						function ($) {
							return $.dk;
						},
						$author$project$BuilderCVE$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$BuilderCVE$Scalar$unwrapEncoder,
							function ($) {
								return $.dk;
							},
							$author$project$BuilderCVE$ScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a0,
					A2(
						$author$project$BuilderCVE$Scalar$unwrapEncoder,
						function ($) {
							return $.dk;
						},
						$author$project$BuilderCVE$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_lte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a1,
					A2(
						$author$project$BuilderCVE$Scalar$unwrapEncoder,
						function ($) {
							return $.dk;
						},
						$author$project$BuilderCVE$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_neq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a4,
					A2(
						$author$project$BuilderCVE$Scalar$unwrapEncoder,
						function ($) {
							return $.dk;
						},
						$author$project$BuilderCVE$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$BuilderCVE$Scalar$unwrapEncoder,
							function ($) {
								return $.dk;
							},
							$author$project$BuilderCVE$ScalarCodecs$codecs))))
			]));
};
var $author$project$BuilderCVE$InputObject$encodeString_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_eq',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aW, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_gt',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aY, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_gte',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aZ, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_ilike',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.l7, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string))),
				_Utils_Tuple2(
				'_iregex',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mj, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_like',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mt, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_lt',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a0, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_lte',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_neq',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a4, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_nilike',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mI, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string))),
				_Utils_Tuple2(
				'_niregex',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mJ, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_nlike',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mK, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_nregex',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mO, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_nsimilar',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mP, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_regex',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.nd, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_similar',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.nv, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))
			]));
};
var $author$project$BuilderCVE$InputObject$encodeJsonb_cast_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'String',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.nA, $author$project$BuilderCVE$InputObject$encodeString_comparison_exp))
			]));
};
var $author$project$BuilderCVE$InputObject$encodeJsonb_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_cast',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.k6, $author$project$BuilderCVE$InputObject$encodeJsonb_cast_exp)),
				_Utils_Tuple2(
				'_contained_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.le,
					A2(
						$author$project$BuilderCVE$Scalar$unwrapEncoder,
						function ($) {
							return $.g1;
						},
						$author$project$BuilderCVE$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_contains',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.lf,
					A2(
						$author$project$BuilderCVE$Scalar$unwrapEncoder,
						function ($) {
							return $.g1;
						},
						$author$project$BuilderCVE$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_eq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aW,
					A2(
						$author$project$BuilderCVE$Scalar$unwrapEncoder,
						function ($) {
							return $.g1;
						},
						$author$project$BuilderCVE$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aY,
					A2(
						$author$project$BuilderCVE$Scalar$unwrapEncoder,
						function ($) {
							return $.g1;
						},
						$author$project$BuilderCVE$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aZ,
					A2(
						$author$project$BuilderCVE$Scalar$unwrapEncoder,
						function ($) {
							return $.g1;
						},
						$author$project$BuilderCVE$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_has_key',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.l0, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'_has_keys_all',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.l1,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string))),
				_Utils_Tuple2(
				'_has_keys_any',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.l2,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string))),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$BuilderCVE$Scalar$unwrapEncoder,
							function ($) {
								return $.g1;
							},
							$author$project$BuilderCVE$ScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a0,
					A2(
						$author$project$BuilderCVE$Scalar$unwrapEncoder,
						function ($) {
							return $.g1;
						},
						$author$project$BuilderCVE$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_lte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a1,
					A2(
						$author$project$BuilderCVE$Scalar$unwrapEncoder,
						function ($) {
							return $.g1;
						},
						$author$project$BuilderCVE$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_neq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a4,
					A2(
						$author$project$BuilderCVE$Scalar$unwrapEncoder,
						function ($) {
							return $.g1;
						},
						$author$project$BuilderCVE$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$BuilderCVE$Scalar$unwrapEncoder,
							function ($) {
								return $.g1;
							},
							$author$project$BuilderCVE$ScalarCodecs$codecs))))
			]));
};
var $author$project$BuilderCVE$InputObject$encodeCves_bool_exp = function (_v0) {
	var input____ = _v0;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$BuilderCVE$InputObject$encodeCves_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$BuilderCVE$InputObject$encodeCves_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$BuilderCVE$InputObject$encodeCves_bool_exp))),
				_Utils_Tuple2(
				'cve_configurations',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dJ, $author$project$BuilderCVE$InputObject$encodeJsonb_comparison_exp)),
				_Utils_Tuple2(
				'cve_data_format',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dK, $author$project$BuilderCVE$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'cve_data_type',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dL, $author$project$BuilderCVE$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'cve_data_version',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dM, $author$project$BuilderCVE$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'cve_identifier',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.br, $author$project$BuilderCVE$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'cve_impact',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dN, $author$project$BuilderCVE$InputObject$encodeJsonb_comparison_exp)),
				_Utils_Tuple2(
				'cve_problem_type',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dO, $author$project$BuilderCVE$InputObject$encodeJsonb_comparison_exp)),
				_Utils_Tuple2(
				'cve_references',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dP, $author$project$BuilderCVE$InputObject$encodeJsonb_comparison_exp))
			]));
};
var $author$project$BuilderCVE$InputObject$encodeText_comparison_exp_ = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_eq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aW,
					A2(
						$author$project$BuilderCVE$Scalar$unwrapEncoder,
						function ($) {
							return $.BP;
						},
						$author$project$BuilderCVE$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aY,
					A2(
						$author$project$BuilderCVE$Scalar$unwrapEncoder,
						function ($) {
							return $.BP;
						},
						$author$project$BuilderCVE$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aZ,
					A2(
						$author$project$BuilderCVE$Scalar$unwrapEncoder,
						function ($) {
							return $.BP;
						},
						$author$project$BuilderCVE$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$BuilderCVE$Scalar$unwrapEncoder,
							function ($) {
								return $.BP;
							},
							$author$project$BuilderCVE$ScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a0,
					A2(
						$author$project$BuilderCVE$Scalar$unwrapEncoder,
						function ($) {
							return $.BP;
						},
						$author$project$BuilderCVE$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_lte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a1,
					A2(
						$author$project$BuilderCVE$Scalar$unwrapEncoder,
						function ($) {
							return $.BP;
						},
						$author$project$BuilderCVE$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_neq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a4,
					A2(
						$author$project$BuilderCVE$Scalar$unwrapEncoder,
						function ($) {
							return $.BP;
						},
						$author$project$BuilderCVE$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$BuilderCVE$Scalar$unwrapEncoder,
							function ($) {
								return $.BP;
							},
							$author$project$BuilderCVE$ScalarCodecs$codecs))))
			]));
};
var $author$project$BuilderCVE$InputObject$encodeTimestamp_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_eq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aW,
					A2(
						$author$project$BuilderCVE$Scalar$unwrapEncoder,
						function ($) {
							return $.bC;
						},
						$author$project$BuilderCVE$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aY,
					A2(
						$author$project$BuilderCVE$Scalar$unwrapEncoder,
						function ($) {
							return $.bC;
						},
						$author$project$BuilderCVE$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aZ,
					A2(
						$author$project$BuilderCVE$Scalar$unwrapEncoder,
						function ($) {
							return $.bC;
						},
						$author$project$BuilderCVE$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$BuilderCVE$Scalar$unwrapEncoder,
							function ($) {
								return $.bC;
							},
							$author$project$BuilderCVE$ScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a0,
					A2(
						$author$project$BuilderCVE$Scalar$unwrapEncoder,
						function ($) {
							return $.bC;
						},
						$author$project$BuilderCVE$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_lte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a1,
					A2(
						$author$project$BuilderCVE$Scalar$unwrapEncoder,
						function ($) {
							return $.bC;
						},
						$author$project$BuilderCVE$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_neq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a4,
					A2(
						$author$project$BuilderCVE$Scalar$unwrapEncoder,
						function ($) {
							return $.bC;
						},
						$author$project$BuilderCVE$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$BuilderCVE$Scalar$unwrapEncoder,
							function ($) {
								return $.bC;
							},
							$author$project$BuilderCVE$ScalarCodecs$codecs))))
			]));
};
var $author$project$BuilderCVE$InputObject$encodeVulnerabilities_bool_exp = function (_v0) {
	var input____ = _v0;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$BuilderCVE$InputObject$encodeVulnerabilities_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$BuilderCVE$InputObject$encodeVulnerabilities_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$BuilderCVE$InputObject$encodeVulnerabilities_bool_exp))),
				_Utils_Tuple2(
				'alt_identifiers',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dy, $author$project$BuilderCVE$InputObject$encodeText_comparison_exp_)),
				_Utils_Tuple2(
				'cve_identifier',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.br, $author$project$BuilderCVE$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'description',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bP, $author$project$BuilderCVE$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'ingredients_json',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d1, $author$project$BuilderCVE$InputObject$encodeJsonb_comparison_exp)),
				_Utils_Tuple2(
				'published_at',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gz, $author$project$BuilderCVE$InputObject$encodeTimestamp_comparison_exp)),
				_Utils_Tuple2(
				'severity',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ck, $author$project$BuilderCVE$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'source',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.o, $author$project$BuilderCVE$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'summary',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cn, $author$project$BuilderCVE$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'updated_at',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aQ, $author$project$BuilderCVE$InputObject$encodeTimestamp_comparison_exp)),
				_Utils_Tuple2(
				'vulnerabilities_cve',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gX, $author$project$BuilderCVE$InputObject$encodeCves_bool_exp)),
				_Utils_Tuple2(
				'vulnerability_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ad, $author$project$BuilderCVE$InputObject$encodeBigint_comparison_exp))
			]));
};
var $author$project$BuilderCVE$InputObject$encodeHasura_vulnerable_ingredients_filter_return_type_bool_exp = function (_v0) {
	var input____ = _v0;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$BuilderCVE$InputObject$encodeHasura_vulnerable_ingredients_filter_return_type_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$BuilderCVE$InputObject$encodeHasura_vulnerable_ingredients_filter_return_type_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$BuilderCVE$InputObject$encodeHasura_vulnerable_ingredients_filter_return_type_bool_exp))),
				_Utils_Tuple2(
				'name',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.w, $author$project$BuilderCVE$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'primary_namespace',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.eD, $author$project$BuilderCVE$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'version',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aI, $author$project$BuilderCVE$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'vulnerability',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gY, $author$project$BuilderCVE$InputObject$encodeVulnerabilities_bool_exp)),
				_Utils_Tuple2(
				'vulnerability_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ad, $author$project$BuilderCVE$InputObject$encodeBigint_comparison_exp))
			]));
};
var $author$project$BuilderCVE$Enum$Order_by$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'asc';
		case 1:
			return 'asc_nulls_first';
		case 2:
			return 'asc_nulls_last';
		case 3:
			return 'desc';
		case 4:
			return 'desc_nulls_first';
		default:
			return 'desc_nulls_last';
	}
};
var $author$project$BuilderCVE$InputObject$encodeCves_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'cve_configurations',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.dJ,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$BuilderCVE$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'cve_data_format',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.dK,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$BuilderCVE$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'cve_data_type',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.dL,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$BuilderCVE$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'cve_data_version',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.dM,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$BuilderCVE$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'cve_identifier',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.br,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$BuilderCVE$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'cve_impact',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.dN,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$BuilderCVE$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'cve_problem_type',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.dO,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$BuilderCVE$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'cve_references',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.dP,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$BuilderCVE$Enum$Order_by$toString)))
			]));
};
var $author$project$BuilderCVE$InputObject$encodeVulnerabilities_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'alt_identifiers',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.dy,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$BuilderCVE$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'cve_identifier',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.br,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$BuilderCVE$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'description',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bP,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$BuilderCVE$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredients_json',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.d1,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$BuilderCVE$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'published_at',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.gz,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$BuilderCVE$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'severity',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ck,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$BuilderCVE$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'source',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.o,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$BuilderCVE$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'summary',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cn,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$BuilderCVE$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'updated_at',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aQ,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$BuilderCVE$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'vulnerabilities_cve',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gX, $author$project$BuilderCVE$InputObject$encodeCves_order_by)),
				_Utils_Tuple2(
				'vulnerability_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ad,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$BuilderCVE$Enum$Order_by$toString)))
			]));
};
var $author$project$BuilderCVE$InputObject$encodeHasura_vulnerable_ingredients_filter_return_type_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.w,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$BuilderCVE$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'primary_namespace',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.eD,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$BuilderCVE$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'version',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aI,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$BuilderCVE$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'vulnerability',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gY, $author$project$BuilderCVE$InputObject$encodeVulnerabilities_order_by)),
				_Utils_Tuple2(
				'vulnerability_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ad,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$BuilderCVE$Enum$Order_by$toString)))
			]));
};
var $author$project$BuilderCVE$InputObject$encodeVulnerable_ingredients_filter_text_args = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'ingredient_versions_text',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mh, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string))
			]));
};
var $author$project$BuilderCVE$Enum$Hasura_vulnerable_ingredients_filter_return_type_select_column$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'name';
		case 1:
			return 'primary_namespace';
		case 2:
			return 'version';
		default:
			return 'vulnerability_id';
	}
};
var $author$project$BuilderCVE$Query$vulnerable_ingredients_filter_text = F3(
	function (fillInOptionals____, requiredArgs____, object____) {
		var filledInOptionals____ = fillInOptionals____(
			{tE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ux: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, uR: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, vE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ao: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs____ = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'distinct_on',
					filledInOptionals____.tE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$BuilderCVE$Enum$Hasura_vulnerable_ingredients_filter_return_type_select_column$toString))),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'limit', filledInOptionals____.ux, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'offset', filledInOptionals____.uR, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'order_by',
					filledInOptionals____.vE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$BuilderCVE$InputObject$encodeHasura_vulnerable_ingredients_filter_return_type_order_by)),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'where', filledInOptionals____.ao, $author$project$BuilderCVE$InputObject$encodeHasura_vulnerable_ingredients_filter_return_type_bool_exp)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'vulnerable_ingredients_filter_text',
			_Utils_ap(
				optionalArgs____,
				_List_fromArray(
					[
						A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'args', requiredArgs____.kO, $author$project$BuilderCVE$InputObject$encodeVulnerable_ingredients_filter_text_args)
					])),
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
	});
var $author$project$Request$NormsAndVulns$selectVulnerabilities = function (inputs) {
	return A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
		$author$project$Request$NormsAndVulns$toVulnerabilityOutputs(
			A2($elm$core$List$map, $author$project$Request$NormsAndVulns$NamespacedInput, inputs)),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
			$elm$core$List$map(
				$elm$core$Tuple$mapFirst($author$project$Request$NormsAndVulns$NamespacedInput)),
			A3(
				$author$project$BuilderCVE$Query$vulnerable_ingredients_filter_text,
				$elm$core$Basics$identity,
				{
					kO: {
						mh: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
							A2(
								$elm$json$Json$Encode$encode,
								0,
								A2($elm$json$Json$Encode$list, $author$project$Request$NormsAndVulns$encodeVulnerabilityInput, inputs)))
					}
				},
				$author$project$Request$NormsAndVulns$selectVulnerabilityOutput)));
};
var $author$project$Request$NormsAndVulns$getVulnerabilities = F2(
	function (creds, inputs) {
		var purlInputs = A2($elm$core$List$filterMap, $author$project$Request$NormsAndVulns$possibleInputsToAnalytics, inputs);
		var namespacedInputs = A2($elm$core$List$filterMap, $author$project$Request$NormsAndVulns$possibleInputsToNamespaced, inputs);
		return A3(
			$elm$core$Task$map2,
			$elm$core$Basics$append,
			$elm$core$List$isEmpty(namespacedInputs) ? $elm$core$Task$succeed(_List_Nil) : A5(
				$author$project$GraphQL$Utils$queryRequest,
				creds,
				3,
				_List_Nil,
				'GetVulnerabilities',
				$author$project$Request$NormsAndVulns$selectVulnerabilities(namespacedInputs)),
			$elm$core$List$isEmpty(purlInputs) ? $elm$core$Task$succeed(_List_Nil) : A2(
				$elm$core$Task$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$map(
						function (t) {
							return A2(
								$elm$core$Tuple$mapSecond,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.gY;
									},
									$author$project$Model$Vulnerability$fromAnalyticsVulnerability),
								A2($elm$core$Tuple$mapFirst, $author$project$Request$NormsAndVulns$PurlInput, t));
						}),
					$author$project$Request$NormsAndVulns$toVulnerabilityOutputs(inputs)),
				A2($author$project$Request$Analytics$Vulnerabilities$getCVEMatches, creds, purlInputs)));
	});
var $author$project$Model$NormsAndVulns$RemoteVulnsOk = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$NormsAndVulns$entryInsertVersionInternal = F3(
	function (version, remoteVulns, entry) {
		var helper = function (maybeR) {
			var _v0 = _Utils_Tuple2(maybeR, remoteVulns);
			_v0$3:
			while (true) {
				_v0$4:
				while (true) {
					if (_v0.a.$ === 1) {
						var _v1 = _v0.a;
						return $elm$core$Maybe$Just(remoteVulns);
					} else {
						switch (_v0.b.$) {
							case 1:
								return $elm$core$Maybe$Just(remoteVulns);
							case 2:
								switch (_v0.a.a.$) {
									case 2:
										var v1 = _v0.a.a.a;
										var v2 = _v0.b.a;
										return A2($elm$core$Basics$composeR, $author$project$Model$NormsAndVulns$RemoteVulnsOk, $elm$core$Maybe$Just)(
											_Utils_ap(v1, v2));
									case 0:
										break _v0$3;
									default:
										break _v0$4;
								}
							default:
								if (!_v0.a.a.$) {
									break _v0$3;
								} else {
									break _v0$4;
								}
						}
					}
				}
				return maybeR;
			}
			var _v2 = _v0.a.a;
			return $elm$core$Maybe$Just(remoteVulns);
		};
		return _Utils_update(
			entry,
			{
				nQ: A3($elm$core$Dict$update, version, helper, entry.nQ)
			});
	});
var $author$project$Model$NormsAndVulns$updateCubeEntryInternal = F3(
	function (purl, func, fields) {
		return _Utils_update(
			fields,
			{
				pw: A3(
					$elm$core$Dict$update,
					purl,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$withDefault($author$project$Model$NormsAndVulns$initEntry),
						A2($elm$core$Basics$composeR, func, $elm$core$Maybe$Just)),
					fields.pw)
			});
	});
var $author$project$Model$NormsAndVulns$insertVersionInternal = F2(
	function (vulns, vulnKey) {
		if (!vulnKey.$) {
			var key = vulnKey.a.Y;
			var version = vulnKey.a.aI;
			return A2(
				$author$project$Model$NormsAndVulns$updateEntryInternal,
				key,
				A2($author$project$Model$NormsAndVulns$entryInsertVersionInternal, version, vulns));
		} else {
			var _v1 = vulnKey.a;
			var purl = _v1.a;
			var version = _v1.b;
			return A2(
				$author$project$Model$NormsAndVulns$updateCubeEntryInternal,
				purl,
				A2($author$project$Model$NormsAndVulns$entryInsertVersionInternal, version, vulns));
		}
	});
var $author$project$Model$NormsAndVulns$vulnKeyToPossibleVulnInput = function (vulnkey) {
	if (!vulnkey.$) {
		var key = vulnkey.a;
		var version = key.aI;
		return $author$project$Request$NormsAndVulns$NamespacedInput(
			{
				Y: $author$project$Model$Namespace$key(key),
				aI: version
			});
	} else {
		var k = vulnkey.a;
		return $author$project$Request$NormsAndVulns$PurlInput(k);
	}
};
var $author$project$Model$NormsAndVulns$recordNormalizedVulnerabilityKeys = F4(
	function (vulnerabilitiesEnabled, creds, vulnKeys, model) {
		var fields = model;
		if (!vulnerabilitiesEnabled) {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var newInputs = A2(
				$elm$core$List$map,
				$author$project$Model$NormsAndVulns$vulnKeyToPossibleVulnInput,
				A2(
					$elm$core$List$filter,
					function (input) {
						return _Utils_eq(
							A2($author$project$Model$NormsAndVulns$getRemoteVulnsInternal, input, fields),
							$elm$core$Maybe$Nothing);
					},
					vulnKeys));
			if ($elm$core$List$isEmpty(newInputs)) {
				return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
			} else {
				var newFields = A3(
					$elm$core$List$foldl,
					$author$project$Model$NormsAndVulns$insertVersionInternal($author$project$Model$NormsAndVulns$RemoteVulnsLoading),
					fields,
					newInputs);
				var cmd = A2(
					$elm$core$Task$attempt,
					$author$project$Model$NormsAndVulns$OnVulnerabilities(newInputs),
					A2($author$project$Request$NormsAndVulns$getVulnerabilities, creds, newInputs));
				return A2($author$project$Misc$with, cmd, newFields);
			}
		}
	});
var $author$project$Pages$ProjectConfig$recordNormsAndVulnsNormalized = F5(
	function (getNormalizedKeys, getNormalizedVulnerabilityKeys, session, model, result) {
		var creds = $author$project$Model$Session$getCreds(session);
		if (!result.$) {
			var value = result.a;
			return A4(
				$author$project$Model$NormsAndVulns$recordNormalizedVulnerabilityKeys,
				A2(
					$author$project$Model$Permissions$orgHasCvesEnabledAndVisible,
					model.c3,
					$author$project$Model$Session$getUser(session)),
				creds,
				getNormalizedVulnerabilityKeys(value),
				A2(
					$author$project$Model$NormsAndVulns$recordNormalizedKeys,
					getNormalizedKeys(value),
					model.rF));
		} else {
			return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model.rF);
		}
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$buildFlagsSetter = F2(
	function (buildFlags, fields) {
		return _Utils_update(
			fields,
			{xs: buildFlags});
	});
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$getCommunityOrWheel = function (editor) {
	var _v0 = A2(
		$author$project$Model$Editor$getField,
		function ($) {
			return $.Ec;
		},
		editor);
	if (_v0.$ === 2) {
		var communityOrWheel = _v0.a;
		return communityOrWheel;
	} else {
		return 0;
	}
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$setStateToolArtifacts = F3(
	function (func, stateToolArtifactsEditor, editor) {
		return A3(
			$author$project$Model$Editor$setField,
			$author$project$Model$BuildPlanner$BuildExprEditor$Simple$markersSetter,
			A2(
				$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$MarkersStateToolArtifacts,
				func(
					$author$project$Model$BuildPlanner$BuildExprEditor$Simple$getCommunityOrWheel(editor)),
				$author$project$Model$Editor$getFields(stateToolArtifactsEditor)),
			editor);
	});
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$setStateToolArtifactsV1 = function (stateToolArtifactsEditor) {
	return A2(
		$author$project$Model$Editor$setField,
		$author$project$Model$BuildPlanner$BuildExprEditor$Simple$markersSetter,
		$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$MarkersStateToolArtifactsV1(
			$author$project$Model$Editor$getFields(stateToolArtifactsEditor)));
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$setBuildExprStateToolArtifactsEditor = F2(
	function (_v0, editor) {
		var func = _v0.i8;
		var funcV1 = _v0.lZ;
		var _v1 = _Utils_Tuple2(
			$author$project$Model$BuildPlanner$BuildExprEditor$Simple$getStateToolArtifacts(editor),
			$author$project$Model$BuildPlanner$BuildExprEditor$Simple$getStateToolArtifactsV1(editor));
		if (!_v1.a.$) {
			var stateToolArtifactsEditor = _v1.a.a;
			return A3(
				$author$project$Model$BuildPlanner$BuildExprEditor$Simple$setStateToolArtifacts,
				$elm$core$Basics$identity,
				func(stateToolArtifactsEditor),
				editor);
		} else {
			if (!_v1.b.$) {
				var stateToolArtifactsV1Editor = _v1.b.a;
				return A2(
					$author$project$Model$BuildPlanner$BuildExprEditor$Simple$setStateToolArtifactsV1,
					funcV1(stateToolArtifactsV1Editor),
					editor);
			} else {
				return editor;
			}
		}
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$removeBuildFlag = function (buildFlag) {
	return $author$project$Model$BuildPlanner$SolveLegacyEditor$setBuildExprStateToolArtifactsEditor(
		{
			i8: A3(
				$author$project$Model$Editor$removeKeyDict,
				function ($) {
					return $.xs;
				},
				$author$project$Model$BuildPlanner$SolveLegacyEditor$buildFlagsSetter,
				buildFlag.w),
			lZ: A3(
				$author$project$Model$Editor$removeKeyDict,
				function ($) {
					return $.xs;
				},
				$author$project$Model$BuildPlanner$SolveLegacyEditor$buildFlagsSetter,
				buildFlag.w)
		});
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$camelFlagsSetter = F2(
	function (camelFlags, fields) {
		return _Utils_update(
			fields,
			{Bn: camelFlags});
	});
var $author$project$Model$Editor$removeKeySet = F4(
	function (getter, setter, key, editor) {
		var current = A2($author$project$Model$Editor$getField, getter, editor);
		return A3(
			$author$project$Model$Editor$setField,
			setter,
			A2($elm$core$Set$remove, key, current),
			editor);
	});
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$setCamel = function (camelEditor) {
	return A2(
		$author$project$Model$Editor$setField,
		$author$project$Model$BuildPlanner$BuildExprEditor$Simple$markersSetter,
		$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$MarkersCamel(
			$author$project$Model$Editor$getFields(camelEditor)));
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$setBuildExprCamelEditor = F2(
	function (func, editor) {
		var _v0 = $author$project$Model$BuildPlanner$BuildExprEditor$Simple$getCamel(editor);
		if (!_v0.$) {
			var camelEditor = _v0.a;
			return A2(
				$author$project$Model$BuildPlanner$BuildExprEditor$Simple$setCamel,
				func(camelEditor),
				editor);
		} else {
			return editor;
		}
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$removeCamelFlag = A2(
	$elm$core$Basics$composeL,
	$author$project$Model$BuildPlanner$SolveLegacyEditor$setBuildExprCamelEditor,
	A2(
		$author$project$Model$Editor$removeKeySet,
		function ($) {
			return $.Bn;
		},
		$author$project$Model$BuildPlanner$SolveLegacyEditor$camelFlagsSetter));
var $author$project$Model$BuildPlanner$SolveLegacyEditor$removeHidden = A2(
	$elm$core$Basics$composeL,
	$author$project$Model$BuildPlanner$SolveLegacyEditor$setBuildExprSolveEditor,
	A2($author$project$Model$Editor$removeKeyDict, $author$project$Model$BuildPlanner$SolveLegacyEditor$hiddensGetter, $author$project$Model$BuildPlanner$SolveLegacyEditor$hiddensSetter));
var $author$project$Model$BuildPlanner$SolveLegacyEditor$removeLanguage = A2(
	$elm$core$Basics$composeL,
	$author$project$Model$BuildPlanner$SolveLegacyEditor$setBuildExprSolveEditor,
	A2($author$project$Model$Editor$removeKeyDict, $author$project$Model$BuildPlanner$SolveLegacyEditor$languagesGetter, $author$project$Model$BuildPlanner$SolveLegacyEditor$languagesSetter));
var $author$project$Model$BuildPlanner$SolveLegacyEditor$removePackage = A2(
	$elm$core$Basics$composeL,
	$author$project$Model$BuildPlanner$SolveLegacyEditor$setBuildExprSolveEditor,
	A2($author$project$Model$Editor$removeKeyDict, $author$project$Model$BuildPlanner$SolveLegacyEditor$packagesGetter, $author$project$Model$BuildPlanner$SolveLegacyEditor$packagesSetter));
var $author$project$Model$BuildPlanner$SolveLegacyEditor$removePackagersForPlatform = function (platformID) {
	return $author$project$Model$BuildPlanner$SolveLegacyEditor$setBuildExprPlatformPackagersEditor(
		$elm$core$Dict$remove(platformID));
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$removePlatform = A2(
	$elm$core$Basics$composeL,
	$author$project$Model$BuildPlanner$SolveLegacyEditor$setBuildExprSolveEditor,
	A2(
		$author$project$Model$Editor$removeKeySet,
		function ($) {
			return $.Fh;
		},
		$author$project$Model$BuildPlanner$SolveLegacyEditor$platformsSetter));
var $author$project$Ports$removeUrlParameter = _Platform_outgoingPort('removeUrlParameter', $elm$json$Json$Encode$string);
var $author$project$Views$Timestamp$reset = function (model) {
	return _Utils_update(
		model,
		{o7: ''});
};
var $author$project$Model$Editor$revert = function (_v0) {
	var internal = _v0;
	return $author$project$Model$Editor$init(internal.jl);
};
var $author$project$Pages$ProjectConfig$resetOrder = function (model) {
	return _Utils_update(
		model,
		{
			iQ: $author$project$Model$Editor$revert(model.iQ),
			hq: '',
			qR: $author$project$Model$Editor$revert(model.qR),
			Ep: $krisajenkins$remotedata$RemoteData$NotAsked,
			hb: $elm$core$Dict$empty,
			iK: $author$project$Model$AtTime$Standard,
			hX: $author$project$Views$Timestamp$reset(model.hX)
		});
};
var $author$project$Views$AddPackagesModal$resetState = F2(
	function (editor, model) {
		return _Utils_update(
			model,
			{qR: editor, mq: '', he: 0, iD: $krisajenkins$remotedata$RemoteData$NotAsked, iE: '', fF: $elm$core$Dict$empty});
	});
var $author$project$Model$Editor$revertKeyDict = F4(
	function (getter, setter, key, editor) {
		var original = A2($author$project$Model$Editor$getFieldOriginal, getter, editor);
		var current = A2($author$project$Model$Editor$getField, getter, editor);
		var nextCurrent = A3(
			$elm$core$Dict$update,
			key,
			$elm$core$Basics$always(
				A2($elm$core$Dict$get, key, original)),
			current);
		return A3($author$project$Model$Editor$setField, setter, nextCurrent, editor);
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$revertBuildFlag = function (buildFlag) {
	return $author$project$Model$BuildPlanner$SolveLegacyEditor$setBuildExprStateToolArtifactsEditor(
		{
			i8: A3(
				$author$project$Model$Editor$revertKeyDict,
				function ($) {
					return $.xs;
				},
				$author$project$Model$BuildPlanner$SolveLegacyEditor$buildFlagsSetter,
				buildFlag.w),
			lZ: A3(
				$author$project$Model$Editor$revertKeyDict,
				function ($) {
					return $.xs;
				},
				$author$project$Model$BuildPlanner$SolveLegacyEditor$buildFlagsSetter,
				buildFlag.w)
		});
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$revertBundle = A2(
	$elm$core$Basics$composeL,
	$author$project$Model$BuildPlanner$SolveLegacyEditor$setBuildExprSolveEditor,
	A2($author$project$Model$Editor$revertKeyDict, $author$project$Model$BuildPlanner$SolveLegacyEditor$bundlesGetter, $author$project$Model$BuildPlanner$SolveLegacyEditor$bundlesSetter));
var $author$project$Model$Editor$revertKeySet = F4(
	function (getter, setter, key, editor) {
		var original = A2($author$project$Model$Editor$getFieldOriginal, getter, editor);
		var current = A2($author$project$Model$Editor$getField, getter, editor);
		var nextCurrent = A2($elm$core$Set$member, key, original) ? A2($elm$core$Set$insert, key, current) : A2($elm$core$Set$remove, key, current);
		return A3($author$project$Model$Editor$setField, setter, nextCurrent, editor);
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$revertCamelFlag = A2(
	$elm$core$Basics$composeL,
	$author$project$Model$BuildPlanner$SolveLegacyEditor$setBuildExprCamelEditor,
	A2(
		$author$project$Model$Editor$revertKeySet,
		function ($) {
			return $.Bn;
		},
		$author$project$Model$BuildPlanner$SolveLegacyEditor$camelFlagsSetter));
var $author$project$Model$BuildPlanner$SolveLegacyEditor$revertHidden = A2(
	$elm$core$Basics$composeL,
	$author$project$Model$BuildPlanner$SolveLegacyEditor$setBuildExprSolveEditor,
	A2($author$project$Model$Editor$revertKeyDict, $author$project$Model$BuildPlanner$SolveLegacyEditor$hiddensGetter, $author$project$Model$BuildPlanner$SolveLegacyEditor$hiddensSetter));
var $author$project$Model$BuildPlanner$SolveLegacyEditor$revertLanguage = A2(
	$elm$core$Basics$composeL,
	$author$project$Model$BuildPlanner$SolveLegacyEditor$setBuildExprSolveEditor,
	A2($author$project$Model$Editor$revertKeyDict, $author$project$Model$BuildPlanner$SolveLegacyEditor$languagesGetter, $author$project$Model$BuildPlanner$SolveLegacyEditor$languagesSetter));
var $author$project$Model$BuildPlanner$SolveLegacyEditor$revertPackage = A2(
	$elm$core$Basics$composeL,
	$author$project$Model$BuildPlanner$SolveLegacyEditor$setBuildExprSolveEditor,
	A2($author$project$Model$Editor$revertKeyDict, $author$project$Model$BuildPlanner$SolveLegacyEditor$packagesGetter, $author$project$Model$BuildPlanner$SolveLegacyEditor$packagesSetter));
var $author$project$Pages$ProjectConfig$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Pages$ProjectConfig$NoOp, 'Pages/ProjectConfig.elm');
var $author$project$Model$BuildExprEditorUtils$canSetToAuto = F2(
	function (key, constraint) {
		var _v0 = _Utils_Tuple2(
			constraint,
			$author$project$Model$Namespace$kind(key));
		_v0$0:
		while (true) {
			switch (_v0.b) {
				case 0:
					if (!_v0.a.$) {
						break _v0$0;
					} else {
						var _v2 = _v0.b;
						return true;
					}
				case 5:
					if (!_v0.a.$) {
						break _v0$0;
					} else {
						var _v3 = _v0.b;
						return true;
					}
				default:
					if (!_v0.a.$) {
						break _v0$0;
					} else {
						return false;
					}
			}
		}
		var _v1 = _v0.a;
		return false;
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$setPackages = A2(
	$elm$core$Basics$composeL,
	$author$project$Model$BuildPlanner$SolveLegacyEditor$setBuildExprSolveEditor,
	$author$project$Model$Editor$setField($author$project$Model$BuildPlanner$SolveLegacyEditor$packagesSetter));
var $author$project$Model$BuildExprEditorUtils$setAllAuto = function (editor) {
	var setToAutoIfPossible = F2(
		function (key, constraint) {
			return A2($author$project$Model$BuildExprEditorUtils$canSetToAuto, key, constraint) ? $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$Auto : constraint;
		});
	return A2(
		$author$project$Model$BuildPlanner$SolveLegacyEditor$setPackages,
		A2(
			$elm$core$Dict$map,
			setToAutoIfPossible,
			$author$project$Model$BuildPlanner$SolveLegacyEditor$getPackages(editor)),
		A2(
			$author$project$Model$BuildPlanner$SolveLegacyEditor$setBundles,
			A2(
				$elm$core$Dict$map,
				setToAutoIfPossible,
				$author$project$Model$BuildPlanner$SolveLegacyEditor$getBundles(editor)),
			editor));
};
var $author$project$Model$BuildExprEditorUtils$canSetToExact = F2(
	function (key, constraint) {
		var _v0 = _Utils_Tuple2(
			constraint,
			$author$project$Model$Namespace$kind(key));
		switch (_v0.a.$) {
			case 1:
				return false;
			case 3:
				return false;
			default:
				switch (_v0.b) {
					case 0:
						var _v1 = _v0.b;
						return true;
					case 5:
						var _v2 = _v0.b;
						return true;
					default:
						return false;
				}
		}
	});
var $author$project$Model$BuildExprEditorUtils$setAllExact = F2(
	function (keyToVersionString, editor) {
		var accumKeyConstraint = F4(
			function (setter, key, constraint, acc) {
				if (A2($author$project$Model$BuildExprEditorUtils$canSetToExact, key, constraint)) {
					var _v0 = A2($elm$core$Dict$get, key, keyToVersionString);
					if (_v0.$ === 1) {
						return _Utils_update(
							acc,
							{
								rx: A2($elm$core$List$cons, key, acc.rx)
							});
					} else {
						var versionString = _v0.a;
						return _Utils_update(
							acc,
							{
								qR: A3(
									setter,
									key,
									$author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$Exact(versionString),
									acc.qR)
							});
					}
				} else {
					return acc;
				}
			});
		return A3(
			$elm_community$basics_extra$Basics$Extra$flip,
			$elm$core$Dict$foldl(
				accumKeyConstraint($author$project$Model$BuildPlanner$SolveLegacyEditor$addPackage)),
			$author$project$Model$BuildPlanner$SolveLegacyEditor$getPackages(editor),
			A3(
				$elm_community$basics_extra$Basics$Extra$flip,
				$elm$core$Dict$foldl(
					accumKeyConstraint($author$project$Model$BuildPlanner$SolveLegacyEditor$addBundle)),
				$author$project$Model$BuildPlanner$SolveLegacyEditor$getBundles(editor),
				{qR: editor, rx: _List_Nil}));
	});
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$setCommunityArtifacts = function (stateToolArtifactsEditor) {
	return A2(
		$author$project$Model$Editor$setField,
		$author$project$Model$BuildPlanner$BuildExprEditor$Simple$markersSetter,
		A2(
			$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$MarkersStateToolArtifacts,
			1,
			$author$project$Model$Editor$getFields(stateToolArtifactsEditor)));
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$setEditableSBOM = function (editor) {
	var _v0 = $author$project$Model$BuildPlanner$BuildExprEditor$Simple$getMarkers(editor);
	if (_v0.$ === 5) {
		var sbom = _v0.b;
		return A3(
			$author$project$Model$Editor$setField,
			$author$project$Model$BuildPlanner$BuildExprEditor$Simple$markersSetter,
			A3(
				$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$MarkersSBOMEditable,
				sbom,
				0,
				{xs: $author$project$Model$BuildPlanner$BuildExpr$BuildFlagsDict$init}),
			editor);
	} else {
		return editor;
	}
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$requirementsSetter = F2(
	function (requirements, fields) {
		return _Utils_update(
			fields,
			{FF: requirements});
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$setRequirements = function (requirements) {
	return $author$project$Model$BuildPlanner$SolveLegacyEditor$setBuildExprSolveEditor(
		A2($author$project$Model$Editor$setField, $author$project$Model$BuildPlanner$SolveLegacyEditor$requirementsSetter, requirements));
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$solverVersionSetter = F2(
	function (solverVersion, fields) {
		return _Utils_update(
			fields,
			{Ga: solverVersion});
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$setSolverVersion = A2(
	$elm$core$Basics$composeL,
	$author$project$Model$BuildPlanner$SolveLegacyEditor$setBuildExprSolveEditor,
	$author$project$Model$Editor$setField($author$project$Model$BuildPlanner$SolveLegacyEditor$solverVersionSetter));
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$setWheelArtifacts = function (stateToolArtifactsEditor) {
	return A2(
		$author$project$Model$Editor$setField,
		$author$project$Model$BuildPlanner$BuildExprEditor$Simple$markersSetter,
		A2(
			$author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$MarkersStateToolArtifacts,
			2,
			$author$project$Model$Editor$getFields(stateToolArtifactsEditor)));
};
var $author$project$Pages$ProjectConfig$SoftRefreshComplete = function (a) {
	return {$: 42, a: a};
};
var $author$project$Pages$ProjectConfig$selectedBranchLatestCommitID = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		$author$project$Model$Branch$getCommitID,
		A2($elm$core$Maybe$map, $author$project$Views$BranchPicker$getSelectedBranch, model.fJ));
};
var $author$project$Pages$ProjectConfig$softRefreshCmd = F2(
	function (session, model) {
		var projectName = $author$project$Model$Project$getName(model.c5);
		var orgName = model.c3.AC;
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Platform$Cmd$none,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					A3($author$project$Pages$ProjectConfig$getRefreshDataTask, session, orgName, projectName),
					$elm$core$Task$attempt($author$project$Pages$ProjectConfig$SoftRefreshComplete)),
				$author$project$Pages$ProjectConfig$selectedBranchLatestCommitID(model)));
	});
var $author$project$Request$BuildPlanner$convertStageCommitInput = function (input) {
	return {
		jE: A2(
			$elm$core$Maybe$withDefault,
			$dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent,
			A2($elm$core$Maybe$map, $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present, input.jE)),
		bP: $elm$core$String$isEmpty(input.c) ? $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent : $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(input.c),
		cG: $author$project$Model$BuildPlanner$BuildExpr$encode(input.k$),
		c3: input.ix,
		fn: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(input.zD),
		c5: input.vT
	};
};
var $author$project$BuildPlanner$Union$StageCommitResult$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Commit', selections____.u7),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'NotFound', selections____.vp),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ParseError', selections____.vq),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ValidationError', selections____.vC),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Forbidden', selections____.vc),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'HeadOnBranchMoved', selections____.vf),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'NoChangeSinceLastCommit', selections____.vn),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInput', selections____.vj)
			]));
};
var $author$project$BuildPlanner$InputObject$encodeStageCommitInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'organization',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.c3))),
				_Utils_Tuple2(
				'project',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.c5))),
				_Utils_Tuple2(
				'parentCommitId',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.fn,
					A2(
						$author$project$BuildPlanner$Scalar$unwrapEncoder,
						function ($) {
							return $.oc;
						},
						$author$project$BuildPlannerScalarCodecs$codecs))),
				_Utils_Tuple2(
				'description',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bP, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)),
				_Utils_Tuple2(
				'expr',
				$elm$core$Maybe$Just(
					A2(
						$author$project$BuildPlanner$Scalar$unwrapEncoder,
						function ($) {
							return $.k8;
						},
						$author$project$BuildPlannerScalarCodecs$codecs)(input____.cG))),
				_Utils_Tuple2(
				'atTime',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.jE,
					A2(
						$author$project$BuildPlanner$Scalar$unwrapEncoder,
						function ($) {
							return $.qE;
						},
						$author$project$BuildPlannerScalarCodecs$codecs)))
			]));
};
var $author$project$BuildPlanner$Mutation$stageCommit = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'stageCommit',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.$7, $author$project$BuildPlanner$InputObject$encodeStageCommitInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Request$BuildPlanner$stageCommit = F2(
	function (creds, input) {
		var selectionSetOnCommitResult = $author$project$BuildPlanner$Union$StageCommitResult$fragments(
			{
				u7: A2($dillonkearns$elm_graphql$Graphql$SelectionSet$map, $elm$core$Result$Ok, $author$project$Model$Commit$selectionSet),
				vc: A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Model$BuildPlanner$BuildPlannerError$ForbiddenError),
					$author$project$Model$BuildPlanner$Error$ForbiddenError$selectionSet),
				vf: A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Model$BuildPlanner$BuildPlannerError$HeadOnBranchMovedError),
					$author$project$Model$BuildPlanner$Error$HeadOnBranchMovedError$selectionSet),
				vj: A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Model$BuildPlanner$BuildPlannerError$InvalidInputError),
					$author$project$Model$BuildPlanner$Error$InvalidInputError$selectionSet),
				vn: A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Model$BuildPlanner$BuildPlannerError$NoChangesSinceLastCommitError),
					$author$project$Model$BuildPlanner$Error$NoChangesSinceLastCommitError$selectionSet),
				vp: A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Model$BuildPlanner$BuildPlannerError$NotFoundError),
					$author$project$Model$BuildPlanner$Error$NotFoundError$selectionSet),
				vq: A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Model$BuildPlanner$BuildPlannerError$ParseError),
					$author$project$Model$BuildPlanner$Error$ParseError$selectionSet),
				vC: A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Model$BuildPlanner$BuildPlannerError$ValidationError),
					$author$project$Model$BuildPlanner$Error$ValidationError$selectionSet)
			});
		return $author$project$Model$BuildPlanner$BuildPlannerError$simplifyTask(
			A5(
				$author$project$GraphQL$Utils$mutationRequest,
				creds,
				4,
				_List_Nil,
				'StageCommit',
				A2(
					$author$project$BuildPlanner$Mutation$stageCommit,
					{
						$7: $author$project$Request$BuildPlanner$convertStageCommitInput(input)
					},
					selectionSetOnCommitResult)));
	});
var $author$project$Model$Language$supportsBundles = function (language) {
	switch (language) {
		case 0:
			return true;
		case 3:
			return true;
		default:
			return false;
	}
};
var $author$project$Model$NormsAndVulns$NoOp = {$: 0};
var $author$project$Model$RollbarClient$map = F2(
	function (func, rollbar) {
		return {
			FZ: F3(
				function (source, err, session) {
					return A2(
						$elm$core$Platform$Cmd$map,
						func,
						A3(rollbar.FZ, source, err, session));
				}),
			sk: F2(
				function (str, session) {
					return A2(
						$elm$core$Platform$Cmd$map,
						func,
						A2(rollbar.sk, str, session));
				})
		};
	});
var $author$project$Model$NormsAndVulns$toRollbar = $author$project$Model$RollbarClient$map(
	$elm$core$Basics$always($author$project$Model$NormsAndVulns$NoOp));
var $author$project$Model$PopularPackages$NoOp = {$: 0};
var $author$project$Model$PopularPackages$toRollbar = $author$project$Model$RollbarClient$map(
	$elm$core$Basics$always($author$project$Model$PopularPackages$NoOp));
var $author$project$Views$CustomRequirementInput$NoOp = {$: 0};
var $author$project$Views$CustomRequirementInput$toRollbar = $author$project$Model$RollbarClient$map(
	$elm$core$Basics$always($author$project$Views$CustomRequirementInput$NoOp));
var $author$project$Views$PackageVersionSelector$NoOp = {$: 0};
var $author$project$Views$PackageVersionSelector$toRollbar = $author$project$Model$RollbarClient$map(
	$elm$core$Basics$always($author$project$Views$PackageVersionSelector$NoOp));
var $author$project$Views$ScannedImage$toIdentifier = function (image) {
	return _Utils_ap(
		$author$project$Model$Namespace$getNamespace(image.Y),
		_Utils_ap(
			$author$project$Model$Namespace$getName(image.Y),
			image.aI));
};
var $author$project$Views$ScannedImage$toggleOpen = F2(
	function (image, isOpenDict) {
		var identifier = $author$project$Views$ScannedImage$toIdentifier(image);
		var value = !A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Dict$get, identifier, isOpenDict));
		return A3($elm$core$Dict$insert, identifier, value, isOpenDict);
	});
var $author$project$Model$NormsAndVulns$RemoteNormErr = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$NormsAndVulns$RemoteVulnsErr = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$NormsAndVulns$getNormalizedKey = F2(
	function (key, _v0) {
		var fields = _v0;
		var _v1 = A2($elm$core$Dict$get, key, fields.mo);
		if (_v1.$ === 1) {
			return $krisajenkins$remotedata$RemoteData$NotAsked;
		} else {
			switch (_v1.a.$) {
				case 0:
					var _v2 = _v1.a;
					return $krisajenkins$remotedata$RemoteData$Loading;
				case 1:
					var err = _v1.a.a;
					return $krisajenkins$remotedata$RemoteData$Failure(err);
				default:
					var normalizedKey = _v1.a.a;
					return $krisajenkins$remotedata$RemoteData$Success(normalizedKey);
			}
		}
	});
var $author$project$Model$NormsAndVulns$getNormalizedVulnerabilityKey = F2(
	function (vulnerabilityKey, model) {
		return A2(
			$krisajenkins$remotedata$RemoteData$map,
			function (normalizedKey) {
				return A2($author$project$Model$Vulnerability$fromNamespaceKey, normalizedKey, vulnerabilityKey.aI);
			},
			A2(
				$author$project$Model$NormsAndVulns$getNormalizedKey,
				$author$project$Model$Namespace$key(vulnerabilityKey),
				model));
	});
var $author$project$Misc$remoteDataConcat = function () {
	var helper = F2(
		function (revAcc, list) {
			helper:
			while (true) {
				if (!list.b) {
					return $krisajenkins$remotedata$RemoteData$Success(
						$elm$core$List$reverse(revAcc));
				} else {
					var remoteData = list.a;
					var others = list.b;
					switch (remoteData.$) {
						case 3:
							var first = remoteData.a;
							var $temp$revAcc = A2($elm$core$List$cons, first, revAcc),
								$temp$list = others;
							revAcc = $temp$revAcc;
							list = $temp$list;
							continue helper;
						case 0:
							return $krisajenkins$remotedata$RemoteData$NotAsked;
						case 1:
							return $krisajenkins$remotedata$RemoteData$Loading;
						default:
							var err = remoteData.a;
							return $krisajenkins$remotedata$RemoteData$Failure(err);
					}
				}
			}
		});
	return helper(_List_Nil);
}();
var $author$project$Model$NormsAndVulns$recordVulnerabilityKeys = F4(
	function (vulnerabilitiesEnabled, creds, vulnerabilityKeys, model) {
		var normalizedVulnerabilityKeysRemoteData = $author$project$Misc$remoteDataConcat(
			A2(
				$elm$core$List$map,
				function (vulnerabilityKey) {
					return A2($author$project$Model$NormsAndVulns$getNormalizedVulnerabilityKey, vulnerabilityKey, model);
				},
				vulnerabilityKeys));
		if (normalizedVulnerabilityKeysRemoteData.$ === 3) {
			var normalizedVulnerabilityKeys = normalizedVulnerabilityKeysRemoteData.a;
			return A4(
				$author$project$Model$NormsAndVulns$recordNormalizedVulnerabilityKeys,
				vulnerabilitiesEnabled,
				creds,
				A2($elm$core$List$map, $author$project$Model$NormsAndVulns$NamespacedVulnKey, normalizedVulnerabilityKeys),
				model);
		} else {
			return A4(
				$author$project$Model$NormsAndVulns$recordKeysInternal,
				creds,
				$elm_community$list_extra$List$Extra$unique(
					A2($elm$core$List$map, $author$project$Model$Namespace$key, vulnerabilityKeys)),
				vulnerabilityKeys,
				model);
		}
	});
var $author$project$Model$NormsAndVulns$update = F4(
	function (rollbar, session, msg, model) {
		var fields = model;
		var creds = $author$project$Model$Session$getCreds(session);
		switch (msg.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
			case 1:
				var namespace = msg.a;
				var names = msg.b;
				var pendingVulnerabilityKeys = msg.c;
				var res = msg.d;
				var toKey = function (name) {
					return _Utils_Tuple2(namespace, name);
				};
				if (!res.$) {
					var normalizations = res.a;
					var newFields = A3(
						$elm$core$List$foldl,
						function (_v2) {
							var requestedAs = _v2.FD;
							var normalized = _v2.ED;
							return A2(
								$author$project$Model$NormsAndVulns$insertKeyOkInternal,
								toKey(requestedAs),
								toKey(normalized));
						},
						fields,
						normalizations);
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A4($author$project$Model$NormsAndVulns$recordVulnerabilityKeys, true, creds, pendingVulnerabilityKeys, newFields));
				} else {
					var err = res.a;
					var newFields = A3(
						$elm$core$List$foldl,
						function (name) {
							return A2(
								$author$project$Model$NormsAndVulns$insertKeyInternal,
								toKey(name),
								$author$project$Model$NormsAndVulns$RemoteNormErr(err));
						},
						fields,
						names);
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3(rollbar.FZ, 'OnNormalizations namespace names pendingVulnerabilityKeys res', err, session),
							newFields));
				}
			default:
				if (!msg.b.$) {
					var outputs = msg.b.a;
					var newFields = A3(
						$elm$core$List$foldl,
						function (_v3) {
							var input = _v3.$7;
							var vulnerabilities = _v3.nS;
							return A2(
								$author$project$Model$NormsAndVulns$insertVersionInternal,
								$author$project$Model$NormsAndVulns$RemoteVulnsOk(vulnerabilities),
								input);
						},
						fields,
						outputs);
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, newFields));
				} else {
					var inputs = msg.a;
					var err = msg.b.a;
					var newFields = A3(
						$elm$core$List$foldl,
						$author$project$Model$NormsAndVulns$insertVersionInternal(
							$author$project$Model$NormsAndVulns$RemoteVulnsErr(err)),
						fields,
						inputs);
					var anyV13sInputs = A2(
						$elm$core$List$any,
						function (input) {
							if (!input.$) {
								return true;
							} else {
								return false;
							}
						},
						inputs);
					return (anyV13sInputs && A2(
						$elm$core$String$contains,
						'Json.Decode.oneOf failed in the following',
						$author$project$Model$Message$reasonWithCode(err).cg)) ? A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, newFields)) : A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3(rollbar.FZ, 'OnVulnerabilities inputs (Err err)', err, session),
							newFields));
				}
		}
	});
var $author$project$Model$PopularPackages$NormsAndVulnsMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$HasuraIngredient$allVersions = function (_v0) {
	var fields = _v0;
	return fields.sR;
};
var $author$project$Model$NormsAndVulns$recordNormsAndVulnsNormalized = F5(
	function (vulnerabilitiesEnabled, keys, vulnerabilityKeys, session, model) {
		var creds = $author$project$Model$Session$getCreds(session);
		return A4(
			$author$project$Model$NormsAndVulns$recordNormalizedVulnerabilityKeys,
			vulnerabilitiesEnabled,
			creds,
			A2($elm$core$List$map, $author$project$Model$NormsAndVulns$NamespacedVulnKey, vulnerabilityKeys),
			A2($author$project$Model$NormsAndVulns$recordNormalizedKeys, keys, model));
	});
var $author$project$Model$PopularPackages$update = F5(
	function (rollbar, session, msg, model, parentModel) {
		switch (msg.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model)));
			case 1:
				var normsAndVulnsMsg = msg.a;
				var _v1 = A4(
					$author$project$Model$NormsAndVulns$update,
					$author$project$Model$NormsAndVulns$toRollbar(rollbar),
					session,
					normsAndVulnsMsg,
					parentModel.rF);
				var _v2 = _v1.a;
				var newNormsAndVulns = _v2.a;
				var normsAndVulnsCmd = _v2.b;
				var external = _v1.b;
				return A2(
					$author$project$Misc$with,
					_Utils_update(
						parentModel,
						{rF: newNormsAndVulns}),
					A2(
						$author$project$Misc$with,
						external,
						A2(
							$author$project$Misc$with,
							A2($elm$core$Platform$Cmd$map, $author$project$Model$PopularPackages$NormsAndVulnsMsg, normsAndVulnsCmd),
							model)));
			default:
				if (!msg.b.$) {
					var languageName = msg.a;
					var popularPackages = msg.b.a;
					var vulnKeys = A2(
						$elm$core$List$concatMap,
						function (_v4) {
							var key = _v4.a;
							var popularPackage = _v4.b;
							return A2(
								$elm$core$List$map,
								$author$project$Model$Vulnerability$fromNamespaceKey(key),
								$elm$core$Dict$keys(
									$author$project$Model$HasuraIngredient$allVersions(popularPackage)));
						},
						$elm$core$Dict$toList(popularPackages));
					var keys = A2(
						$elm$core$List$map,
						$elm$core$Basics$identity,
						$elm$core$Dict$keys(popularPackages));
					var _v3 = A5(
						$author$project$Model$NormsAndVulns$recordNormsAndVulnsNormalized,
						A2(
							$author$project$Model$Permissions$orgHasCvesEnabledAndVisible,
							parentModel.c3,
							$author$project$Model$Session$getUser(session)),
						keys,
						vulnKeys,
						session,
						parentModel.rF);
					var newNormsAndVulns = _v3.a;
					var normsAndVulnsCmd = _v3.b;
					return A2(
						$author$project$Misc$with,
						_Utils_update(
							parentModel,
							{rF: newNormsAndVulns}),
						A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2(
								$author$project$Misc$with,
								A2($elm$core$Platform$Cmd$map, $author$project$Model$PopularPackages$NormsAndVulnsMsg, normsAndVulnsCmd),
								_Utils_update(
									model,
									{
										hy: A3(
											$elm$core$Dict$insert,
											languageName,
											$krisajenkins$remotedata$RemoteData$Success(popularPackages),
											model.hy)
									}))));
				} else {
					var languageName = msg.a;
					var err = msg.b.a;
					return A2(
						$author$project$Misc$with,
						parentModel,
						A2(
							$author$project$Misc$with,
							$author$project$External$AddNotification(
								$author$project$Model$Notification$fromError(err)),
							A2(
								$author$project$Misc$with,
								A3(rollbar.FZ, 'OnPopularPackages languageName (Err err)', err, session),
								_Utils_update(
									model,
									{
										hy: A3(
											$elm$core$Dict$insert,
											languageName,
											$krisajenkins$remotedata$RemoteData$Failure(err),
											model.hy)
									}))));
				}
		}
	});
var $author$project$Views$AddPackagesModal$Close = 1;
var $author$project$Views$AddPackagesModal$GoToImportPackagesModal = 2;
var $author$project$Views$AddPackagesModal$NoOp = {$: 0};
var $author$project$Views$AddPackagesModal$None = 0;
var $author$project$Views$AddPackagesModal$NormsAndVulnsMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Views$AddPackagesModal$OnSearchResults = function (a) {
	return {$: 5, a: a};
};
var $author$project$Views$AddPackagesModal$PopularPackagesMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Views$PackageVersionSelector$customValueFromConstraint = function (constraint) {
	switch (constraint.$) {
		case 2:
			var first = constraint.a;
			var others = constraint.b;
			return A2($author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$toPythonSyntax, first, others);
		case 1:
			var version = constraint.a;
			return $author$project$Model$BuildPlanner$BuildExpr$Solve$VersionRequirement$toPythonSyntax(
				{h: 'eq', aI: version});
		default:
			return '';
	}
};
var $author$project$Views$PackageVersionSelector$init = F3(
	function (key, maybeCveKey, constraint) {
		return {
			iY: '',
			jN: $author$project$Views$PackageVersionSelector$customValueFromConstraint(constraint),
			iZ: false,
			iq: false,
			Y: key,
			rt: maybeCveKey,
			jw: constraint
		};
	});
var $author$project$Views$PackageVersionSelector$close = function (model) {
	return _Utils_update(
		model,
		{iZ: false, iq: false});
};
var $author$project$Views$PackageVersionSelector$setSelected = F2(
	function (constraint, model) {
		return $author$project$Views$PackageVersionSelector$close(
			_Utils_update(
				model,
				{
					iY: '',
					jN: $author$project$Views$PackageVersionSelector$customValueFromConstraint(constraint),
					jw: constraint
				}));
	});
var $author$project$Views$PackageVersionSelector$addOrSetSelected = F2(
	function (maybeCveKey, _v0) {
		var key = _v0.Y;
		var constraint = _v0.bK;
		return A2(
			$elm$core$Dict$update,
			key,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map(
					$author$project$Views$PackageVersionSelector$setSelected(constraint)),
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Maybe$withDefault(
						A3($author$project$Views$PackageVersionSelector$init, key, maybeCveKey, constraint)),
					$elm$core$Maybe$Just)));
	});
var $author$project$Model$Namespace$bundlesPrefixLength = $elm$core$String$length($author$project$Model$Namespace$bundlesPrefix);
var $author$project$Model$Namespace$removeBundlesPrefix = function (string) {
	return A2($elm$core$String$startsWith, $author$project$Model$Namespace$bundlesPrefix, string) ? A2($elm$core$String$dropLeft, $author$project$Model$Namespace$bundlesPrefixLength, string) : string;
};
var $author$project$Model$Language$fromBundleNamespace = A2($elm$core$Basics$composeR, $author$project$Model$Namespace$removeBundlesPrefix, $author$project$Model$Language$fromString);
var $author$project$Model$Language$fromNamespace = function (ns) {
	return A2(
		$elm_community$maybe_extra$Maybe$Extra$or,
		$author$project$Model$Language$fromPackageNamespace(ns),
		$author$project$Model$Language$fromBundleNamespace(ns));
};
var $author$project$Model$HasuraIngredient$getVulnerabilityKeys = F2(
	function (key, _v0) {
		var fields = _v0;
		return A2(
			$elm$core$List$map,
			$author$project$Model$Vulnerability$fromNamespaceKey(key),
			fields.qj);
	});
var $author$project$Views$AddPackagesModal$makeAddRequirementAnalyticsEvent = function (_v0) {
	var key = _v0.Y;
	var constraint = _v0.bK;
	var label = $author$project$Model$BuildExprEditorUtils$getCategory(key) + (' - ' + ($author$project$Model$Namespace$getName(key) + (' ' + $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$getHumanReadableString(constraint))));
	return A2(
		$author$project$Model$Analytics$withLabel,
		label,
		A2(
			$author$project$Model$Analytics$withAction,
			'Edited order - item added - modal',
			A2(
				$author$project$Model$Analytics$withCategory,
				$author$project$Model$Analytics$categoryConfiguration,
				$author$project$Model$Analytics$newEvent('Edited order - item added - modal'))));
};
var $author$project$Views$AddPackagesModal$makePackageSearchAnalyticsEvent = F2(
	function (model, searchResults) {
		var resultType = function () {
			if (!searchResults.$) {
				var payload = searchResults.a;
				return $elm$core$List$isEmpty(payload) ? 'No Results' : 'Success';
			} else {
				return 'Error';
			}
		}();
		var resultCount = A2(
			$elm$core$Result$withDefault,
			0,
			A2($elm$core$Result$map, $elm$core$List$length, searchResults));
		var languageName = $author$project$Model$Language$toDisplayString(model.ip);
		return A2(
			$author$project$Model$Analytics$withValue,
			resultCount,
			A2(
				$author$project$Model$Analytics$withLabel,
				model.mq,
				A2(
					$author$project$Model$Analytics$withAction,
					languageName,
					A2(
						$author$project$Model$Analytics$withCategory,
						'Package Search - ' + resultType,
						$author$project$Model$Analytics$newEvent(languageName)))));
	});
var $author$project$Views$AddPackagesModal$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Views$AddPackagesModal$NoOp, 'Views/AddPackagesModal.elm');
var $author$project$Inventory$Object$Ingredient$namespace = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'namespace', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$Inventory$Object$Namespace$namespace = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'InventoryScalarCodecs.Citext',
	'namespace',
	_List_Nil,
	$author$project$Inventory$Scalar$unwrapCodecs($author$project$InventoryScalarCodecs$codecs).cL.qN);
var $author$project$Inventory$Object$Ingredient$normalized_name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'normalized_name', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Inventory$InputObject$encodeSearch_ingredients_args = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'exact',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.lQ, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'limit_',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mu, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)),
				_Utils_Tuple2(
				'name_',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.mD,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.hn;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'namespaces',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.mE,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.BN;
						},
						$author$project$InventoryScalarCodecs$codecs))),
				_Utils_Tuple2(
				'offset_',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.mQ, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)),
				_Utils_Tuple2(
				'timestamp_',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.nF,
					A2(
						$author$project$Inventory$Scalar$unwrapEncoder,
						function ($) {
							return $.il;
						},
						$author$project$InventoryScalarCodecs$codecs)))
			]));
};
var $author$project$Inventory$Query$search_ingredients = F3(
	function (fillInOptionals____, requiredArgs____, object____) {
		var filledInOptionals____ = fillInOptionals____(
			{tE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ux: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, uR: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, vE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ao: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs____ = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'distinct_on',
					filledInOptionals____.tE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Inventory$Enum$Ingredient_select_column$toString))),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'limit', filledInOptionals____.ux, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'offset', filledInOptionals____.uR, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'order_by',
					filledInOptionals____.vE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Inventory$InputObject$encodeIngredient_order_by)),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'where', filledInOptionals____.ao, $author$project$Inventory$InputObject$encodeIngredient_bool_exp)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'search_ingredients',
			_Utils_ap(
				optionalArgs____,
				_List_fromArray(
					[
						A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'args', requiredArgs____.kO, $author$project$Inventory$InputObject$encodeSearch_ingredients_args)
					])),
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
	});
var $author$project$Request$HasuraIngredients$searchIngredients = F7(
	function (session, languageName, featureOrIngredientName, atTime, exact, limit, offset) {
		var operationName = 'SearchIngredients_' + languageName;
		var namespace = $author$project$Model$Namespace$addLanguagePrefix(languageName);
		var namespacesStr = '{' + (namespace + '}');
		var keySelectionSet = A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
			$elm$core$Maybe$Just,
			A3(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$map2,
				$elm$core$Tuple$pair,
				$author$project$Inventory$Object$Ingredient$namespace($author$project$Inventory$Object$Namespace$namespace),
				$author$project$Inventory$Object$Ingredient$normalized_name));
		var creds = $author$project$Model$Session$getCreds(session);
		var atTimeStr = $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(atTime);
		var headers = _List_fromArray(
			[
				_Utils_Tuple2('x-namespaces', namespacesStr),
				_Utils_Tuple2('x-search-term', featureOrIngredientName),
				_Utils_Tuple2('x-timestamp', atTimeStr),
				_Utils_Tuple2(
				'x-limit',
				$elm$core$String$fromInt(limit)),
				_Utils_Tuple2(
				'x-offset',
				$elm$core$String$fromInt(offset)),
				_Utils_Tuple2(
				'x-exact-search',
				exact ? 'true' : 'false')
			]);
		return A5(
			$author$project$GraphQL$Utils$queryRequest,
			creds,
			1,
			headers,
			operationName,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
				$elm_community$maybe_extra$Maybe$Extra$values,
				A3(
					$author$project$Inventory$Query$search_ingredients,
					function (opts) {
						return opts;
					},
					{
						kO: {
							lQ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(exact),
							mu: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
								A2($elm$core$Basics$max, 0, limit)),
							mD: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(featureOrIngredientName),
							mE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(namespacesStr),
							mQ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
								A2($elm$core$Basics$max, 0, offset)),
							nF: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(atTimeStr)
						}
					},
					A3(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$map2,
						$elm$core$Maybe$map2($elm$core$Tuple$pair),
						keySelectionSet,
						$author$project$Model$HasuraIngredient$selectionSet))));
	});
var $author$project$Views$AddPackagesModal$searchResultToVersionSelector = function (key) {
	return A3($author$project$Views$PackageVersionSelector$init, key, $elm$core$Maybe$Nothing, $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$Auto);
};
var $author$project$Views$AddPackagesModal$searchResultsPageSize = 50;
var $author$project$Views$NamespaceExpand$update = F2(
	function (msg, model) {
		var key = msg;
		return _Utils_update(
			model,
			{
				oy: A2($author$project$Misc$toggle, key, model.oy)
			});
	});
var $author$project$Views$CVEs$update = $author$project$Views$NamespaceExpand$update;
var $author$project$Views$Licenses$update = F2(
	function (msg, model) {
		var hoverKey = msg;
		return _Utils_update(
			model,
			{ra: hoverKey});
	});
var $author$project$Views$PackageSummaryDisplay$update = F2(
	function (msg, model) {
		var packageDisplay = msg;
		return _Utils_update(
			model,
			{jn: packageDisplay});
	});
var $author$project$Views$PackageVersionSelector$AvailableVersionsMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Views$PackageVersionSelector$None = {$: 1};
var $author$project$Views$PackageVersionSelector$OnCustomConstraintParsed = function (a) {
	return {$: 5, a: a};
};
var $author$project$Views$PackageVersionSelector$SelectedVersion = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$PackageImport$Unformatted = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$AvailableVersions$OnVersionsFetchResult = F4(
	function (a, b, c, d) {
		return {$: 2, a: a, b: b, c: c, d: d};
	});
var $author$project$Model$AvailableVersions$RemoteVersionsLoading = {$: 0};
var $author$project$Model$AvailableVersions$get = F3(
	function (normalizedKey, atTime, _v0) {
		var dict = _v0;
		return A2(
			$elm$core$Maybe$withDefault,
			$krisajenkins$remotedata$RemoteData$NotAsked,
			A2(
				$elm$core$Maybe$map,
				function (remoteVersions) {
					switch (remoteVersions.$) {
						case 0:
							return $krisajenkins$remotedata$RemoteData$Loading;
						case 1:
							var err = remoteVersions.a;
							return $krisajenkins$remotedata$RemoteData$Failure(err);
						default:
							var list = remoteVersions.a;
							return $krisajenkins$remotedata$RemoteData$Success(list);
					}
				},
				A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.oT;
						},
						$elm$core$Dict$get(normalizedKey)),
					A2(
						$elm$core$Dict$get,
						$elm$time$Time$posixToMillis(atTime),
						dict))));
	});
var $author$project$Request$AvailableVersions$getAvailableVersions = F3(
	function (creds, key, atTime) {
		return A5(
			$author$project$GraphQL$Utils$queryRequest,
			creds,
			1,
			_List_Nil,
			'GetAvailableVersions',
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
				$elm$core$List$filterMap(
					$author$project$Request$AvailableVersions$toAvailableVersion(key)),
				A2(
					$author$project$Inventory$Query$ingredient_version,
					$author$project$Request$AvailableVersions$ingredientVersionWhereAndOrderBy(key),
					$author$project$Request$AvailableVersions$ingredientVersionSelectionSet(atTime))));
	});
var $author$project$Model$AvailableVersions$Model = $elm$core$Basics$identity;
var $author$project$Model$AvailableVersions$initEntry = {oT: $elm$core$Dict$empty, px: $elm$core$Dict$empty};
var $author$project$Model$AvailableVersions$insertInternal = F5(
	function (key, maybeCveKey, atTime, remoteVersions, _v0) {
		var dict = _v0;
		var timeMillis = $elm$time$Time$posixToMillis(atTime);
		var oldEntry = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Model$AvailableVersions$initEntry,
			A2($elm$core$Dict$get, timeMillis, dict));
		var maybePurl = A2($elm$core$Maybe$map, $elm$core$Tuple$first, maybeCveKey);
		var entry = {
			oT: A3($elm$core$Dict$insert, key, remoteVersions, oldEntry.oT),
			px: A2(
				$elm$core$Maybe$withDefault,
				oldEntry.px,
				A2(
					$elm$core$Maybe$map,
					function (purl) {
						return A3($elm$core$Dict$insert, purl, remoteVersions, oldEntry.px);
					},
					maybePurl))
		};
		return A3($elm$core$Dict$insert, timeMillis, entry, dict);
	});
var $author$project$Model$AvailableVersions$fetchVersions = F5(
	function (creds, normalizedKey, maybeCveKey, atTime, model) {
		var alreadyFetched = function () {
			var _v0 = A3($author$project$Model$AvailableVersions$get, normalizedKey, atTime, model);
			switch (_v0.$) {
				case 2:
					return true;
				case 3:
					return true;
				default:
					return false;
			}
		}();
		return alreadyFetched ? A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model) : A2(
			$author$project$Misc$with,
			A2(
				$elm$core$Task$attempt,
				A3($author$project$Model$AvailableVersions$OnVersionsFetchResult, normalizedKey, maybeCveKey, atTime),
				A3($author$project$Request$AvailableVersions$getAvailableVersions, creds, normalizedKey, atTime)),
			A5($author$project$Model$AvailableVersions$insertInternal, normalizedKey, maybeCveKey, atTime, $author$project$Model$AvailableVersions$RemoteVersionsLoading, model));
	});
var $author$project$Model$AvailableVersions$NoOp = {$: 0};
var $author$project$Model$AvailableVersions$toRollbar = $author$project$Model$RollbarClient$map(
	$elm$core$Basics$always($author$project$Model$AvailableVersions$NoOp));
var $author$project$Model$AvailableVersions$NormsAndVulnsMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$AvailableVersions$RemoteVersionsErr = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$AvailableVersions$RemoteVersionsOk = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$NormsAndVulns$recordNormsAndVulns = F5(
	function (vulnerabilitiesEnabled, keys, vulnerabilityKeys, session, model) {
		var creds = $author$project$Model$Session$getCreds(session);
		var _v0 = A3($author$project$Model$NormsAndVulns$recordKeys, creds, keys, model);
		var newNormsAndVulns = _v0.a;
		var keysCmd = _v0.b;
		var _v1 = A4($author$project$Model$NormsAndVulns$recordVulnerabilityKeys, vulnerabilitiesEnabled, creds, vulnerabilityKeys, newNormsAndVulns);
		var finalNormsAndVulns = _v1.a;
		var vulnerabilityKeysCmd = _v1.b;
		return A2(
			$author$project$Misc$with,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[keysCmd, vulnerabilityKeysCmd])),
			finalNormsAndVulns);
	});
var $author$project$Model$Analytics$Fact$Dependencies$setCVEKeyVersion = F2(
	function (version, _v0) {
		var purl = _v0.a;
		return _Utils_Tuple2(purl, version);
	});
var $author$project$Model$AvailableVersions$update = F5(
	function (rollbar, session, model, msg, parentModel) {
		switch (msg.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model)));
			case 1:
				var normsAndVulnsMsg = msg.a;
				var _v1 = A4(
					$author$project$Model$NormsAndVulns$update,
					$author$project$Model$NormsAndVulns$toRollbar(rollbar),
					session,
					normsAndVulnsMsg,
					parentModel.rF);
				var _v2 = _v1.a;
				var newNormsAndVulns = _v2.a;
				var normsAndVulnsCmd = _v2.b;
				var external = _v1.b;
				return A2(
					$author$project$Misc$with,
					_Utils_update(
						parentModel,
						{rF: newNormsAndVulns}),
					A2(
						$author$project$Misc$with,
						external,
						A2(
							$author$project$Misc$with,
							A2($elm$core$Platform$Cmd$map, $author$project$Model$AvailableVersions$NormsAndVulnsMsg, normsAndVulnsCmd),
							model)));
			default:
				if (!msg.d.$) {
					var key = msg.a;
					var maybeCveKey = msg.b;
					var atTime = msg.c;
					var versions = msg.d.a;
					var vulnerabilitiesEnabled = A2(
						$author$project$Model$Permissions$orgHasCvesEnabledAndVisible,
						parentModel.c3,
						$author$project$Model$Session$getUser(session));
					var vulnKeys = A2(
						$elm$core$List$filterMap,
						function (version) {
							return A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Model$Analytics$Fact$Dependencies$setCVEKeyVersion(version.G7.aI),
									$author$project$Model$NormsAndVulns$PurlVulnKey),
								maybeCveKey);
						},
						versions);
					var _v3 = A5(
						$author$project$Model$NormsAndVulns$recordNormsAndVulns,
						vulnerabilitiesEnabled,
						_List_fromArray(
							[key]),
						A2(
							$elm$core$List$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.G7;
								},
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.aI;
									},
									$author$project$Model$Vulnerability$fromNamespaceKey(key))),
							versions),
						session,
						parentModel.rF);
					var newNormsAndVulns = _v3.a;
					var normsAndVulnsCmd0 = _v3.b;
					var _v4 = A4(
						$author$project$Model$NormsAndVulns$recordNormalizedVulnerabilityKeys,
						vulnerabilitiesEnabled,
						$author$project$Model$Session$getCreds(session),
						vulnKeys,
						newNormsAndVulns);
					var finalNormsAndVulns = _v4.a;
					var normsAndVulnsCmd1 = _v4.b;
					return A2(
						$author$project$Misc$with,
						_Utils_update(
							parentModel,
							{rF: finalNormsAndVulns}),
						A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2(
								$author$project$Misc$with,
								A2(
									$elm$core$Platform$Cmd$map,
									$author$project$Model$AvailableVersions$NormsAndVulnsMsg,
									$elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[normsAndVulnsCmd0, normsAndVulnsCmd1]))),
								A5(
									$author$project$Model$AvailableVersions$insertInternal,
									key,
									maybeCveKey,
									atTime,
									$author$project$Model$AvailableVersions$RemoteVersionsOk(versions),
									model))));
				} else {
					var key = msg.a;
					var maybeCveKey = msg.b;
					var atTime = msg.c;
					var error = msg.d.a;
					return A2(
						$author$project$Misc$with,
						parentModel,
						A2(
							$author$project$Misc$with,
							$author$project$External$AddNotification(
								$author$project$Model$Notification$fromError(error)),
							A2(
								$author$project$Misc$with,
								A3(rollbar.FZ, 'OnVersionsFetchResult key maybeCveKey atTime (Err error)', error, session),
								A5(
									$author$project$Model$AvailableVersions$insertInternal,
									key,
									maybeCveKey,
									atTime,
									$author$project$Model$AvailableVersions$RemoteVersionsErr(error),
									model))));
				}
		}
	});
var $author$project$Views$PackageVersionSelector$update = F5(
	function (rollbar, session, msg, model, parentModel) {
		var creds = $author$project$Model$Session$getCreds(session);
		switch (msg.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$author$project$Views$PackageVersionSelector$None,
							A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model))));
			case 1:
				var innerMsg = msg.a;
				var _v1 = A5(
					$author$project$Model$AvailableVersions$update,
					$author$project$Model$AvailableVersions$toRollbar(rollbar),
					session,
					parentModel.xj,
					innerMsg,
					parentModel);
				var _v2 = _v1.a;
				var _v3 = _v2.a;
				var newInnerModel = _v3.a;
				var innerCmd = _v3.b;
				var external = _v2.b;
				var newParentModel = _v1.b;
				return A2(
					$author$project$Misc$with,
					_Utils_update(
						newParentModel,
						{xj: newInnerModel}),
					A2(
						$author$project$Misc$with,
						external,
						A2(
							$author$project$Misc$with,
							$author$project$Views$PackageVersionSelector$None,
							A2(
								$author$project$Misc$with,
								A2($elm$core$Platform$Cmd$map, $author$project$Views$PackageVersionSelector$AvailableVersionsMsg, innerCmd),
								model))));
			case 2:
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$author$project$Views$PackageVersionSelector$SelectedVersion($author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$Auto),
							A2(
								$author$project$Misc$with,
								$elm$core$Platform$Cmd$none,
								A2($author$project$Views$PackageVersionSelector$setSelected, $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$Auto, model)))));
			case 3:
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$author$project$Views$PackageVersionSelector$None,
							A2(
								$author$project$Misc$with,
								$elm$core$Platform$Cmd$none,
								_Utils_update(
									model,
									{iZ: !model.iZ})))));
			case 4:
				if ($elm$core$String$isEmpty(model.jN)) {
					return A2(
						$author$project$Misc$with,
						parentModel,
						A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2(
								$author$project$Misc$with,
								$author$project$Views$PackageVersionSelector$None,
								A2(
									$author$project$Misc$with,
									$elm$core$Platform$Cmd$none,
									_Utils_update(
										model,
										{iY: 'Please specify a version'})))));
				} else {
					var cmd = A2(
						$elm$core$Task$attempt,
						$author$project$Views$PackageVersionSelector$OnCustomConstraintParsed,
						A3(
							$author$project$Request$PackageImport$importPackages,
							creds,
							1,
							$author$project$Model$PackageImport$Unformatted(
								$author$project$Model$Namespace$getName(model.Y) + (' ' + model.jN))));
					return A2(
						$author$project$Misc$with,
						parentModel,
						A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2(
								$author$project$Misc$with,
								$author$project$Views$PackageVersionSelector$None,
								A2($author$project$Misc$with, cmd, model))));
				}
			case 5:
				if (!msg.a.$) {
					var changeset = msg.a.a;
					var _v4 = _Utils_Tuple2(changeset.yf, changeset.CV);
					if (_v4.a.b) {
						var _v5 = _v4.a;
						var errorText = _v5.a.ye;
						return A2(
							$author$project$Misc$with,
							parentModel,
							A2(
								$author$project$Misc$with,
								$author$project$External$NoOp,
								A2(
									$author$project$Misc$with,
									$author$project$Views$PackageVersionSelector$None,
									A2(
										$author$project$Misc$with,
										$elm$core$Platform$Cmd$none,
										_Utils_update(
											model,
											{iY: errorText})))));
					} else {
						if (_v4.b.b) {
							var _v6 = _v4.b;
							var constraint = _v6.a.bK;
							return A2(
								$author$project$Misc$with,
								parentModel,
								A2(
									$author$project$Misc$with,
									$author$project$External$NoOp,
									A2(
										$author$project$Misc$with,
										$author$project$Views$PackageVersionSelector$SelectedVersion(constraint),
										A2(
											$author$project$Misc$with,
											$elm$core$Platform$Cmd$none,
											_Utils_update(
												model,
												{iZ: false, iq: false, jw: constraint})))));
						} else {
							return A2(
								$author$project$Misc$with,
								parentModel,
								A2(
									$author$project$Misc$with,
									$author$project$External$NoOp,
									A2(
										$author$project$Misc$with,
										$author$project$Views$PackageVersionSelector$None,
										A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model))));
						}
					}
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$Misc$with,
						parentModel,
						A2(
							$author$project$Misc$with,
							$author$project$External$AddNotification(
								$author$project$Model$Notification$fromError(err)),
							A2(
								$author$project$Misc$with,
								$author$project$Views$PackageVersionSelector$None,
								A2(
									$author$project$Misc$with,
									A3(rollbar.FZ, 'OnCustomConstraintParsed (Err err)', err, session),
									model))));
				}
			case 6:
				var version = msg.a;
				var constraint = $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$Exact(version);
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$author$project$Views$PackageVersionSelector$SelectedVersion(constraint),
							A2(
								$author$project$Misc$with,
								$elm$core$Platform$Cmd$none,
								A2($author$project$Views$PackageVersionSelector$setSelected, constraint, model)))));
			case 7:
				var key = model.Y;
				var normalizedKey = A2(
					$krisajenkins$remotedata$RemoteData$withDefault,
					key,
					A2($author$project$Model$NormsAndVulns$getNormalizedKey, key, parentModel.rF));
				var _v7 = A5(
					$author$project$Model$AvailableVersions$fetchVersions,
					creds,
					normalizedKey,
					model.rt,
					A2($author$project$Model$BuildExprEditorUtils$getNextTimestamp, parentModel.pq, parentModel.qR),
					parentModel.xj);
				var newAvailableVersions = _v7.a;
				var availableVersionsCmd = _v7.b;
				return A2(
					$author$project$Misc$with,
					_Utils_update(
						parentModel,
						{xj: newAvailableVersions}),
					A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$author$project$Views$PackageVersionSelector$None,
							A2(
								$author$project$Misc$with,
								A2($elm$core$Platform$Cmd$map, $author$project$Views$PackageVersionSelector$AvailableVersionsMsg, availableVersionsCmd),
								_Utils_update(
									model,
									{iq: true})))));
			case 8:
				var value = msg.a;
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$author$project$Views$PackageVersionSelector$None,
							A2(
								$author$project$Misc$with,
								$elm$core$Platform$Cmd$none,
								_Utils_update(
									model,
									{iY: '', jN: value})))));
			case 9:
				return model.iq ? A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$author$project$Views$PackageVersionSelector$None,
							A2(
								$author$project$Misc$with,
								$elm$core$Platform$Cmd$none,
								$author$project$Views$PackageVersionSelector$close(model))))) : A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$author$project$Views$PackageVersionSelector$None,
							A2(
								$author$project$Misc$with,
								$elm$core$Platform$Cmd$none,
								_Utils_update(
									model,
									{iq: true})))));
			case 10:
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$author$project$Views$PackageVersionSelector$None,
							A2(
								$author$project$Misc$with,
								$elm$core$Platform$Cmd$none,
								$author$project$Views$PackageVersionSelector$close(model)))));
			default:
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$author$project$Views$PackageVersionSelector$None,
							A2(
								$author$project$Misc$with,
								$elm$core$Platform$Cmd$none,
								$author$project$Views$PackageVersionSelector$close(model)))));
		}
	});
var $author$project$Views$AddPackagesModal$update = F4(
	function (session, msg, model, parentModel) {
		var doSearch = F2(
			function (currentLanguage, newModel) {
				var searchString = $elm$core$String$trim(newModel.iE);
				if (searchString === '') {
					return A2(
						$author$project$Misc$with,
						parentModel,
						A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2(
								$author$project$Misc$with,
								0,
								A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, newModel))));
				} else {
					var cmd = A2(
						$elm$core$Task$attempt,
						$author$project$Views$AddPackagesModal$OnSearchResults,
						A7(
							$author$project$Request$HasuraIngredients$searchIngredients,
							session,
							$author$project$Model$Language$toString(currentLanguage),
							searchString,
							A2($author$project$Model$BuildExprEditorUtils$getNextTimestamp, parentModel.pq, parentModel.qR),
							false,
							$author$project$Views$AddPackagesModal$searchResultsPageSize,
							newModel.he * $author$project$Views$AddPackagesModal$searchResultsPageSize));
					return A2(
						$author$project$Misc$with,
						parentModel,
						A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2(
								$author$project$Misc$with,
								0,
								A2(
									$author$project$Misc$with,
									$elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[cmd])),
									_Utils_update(
										newModel,
										{mq: searchString, iD: $krisajenkins$remotedata$RemoteData$Loading})))));
				}
			});
		var creds = $author$project$Model$Session$getCreds(session);
		switch (msg.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							0,
							A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model))));
			case 1:
				var normsAndVulnsMsg = msg.a;
				var _v1 = A4(
					$author$project$Model$NormsAndVulns$update,
					$author$project$Model$NormsAndVulns$toRollbar($author$project$Views$AddPackagesModal$rollbar),
					session,
					normsAndVulnsMsg,
					parentModel.rF);
				var _v2 = _v1.a;
				var newNormsAndVulns = _v2.a;
				var normsAndVulnsCmd = _v2.b;
				var external = _v1.b;
				return A2(
					$author$project$Misc$with,
					_Utils_update(
						parentModel,
						{rF: newNormsAndVulns}),
					A2(
						$author$project$Misc$with,
						external,
						A2(
							$author$project$Misc$with,
							0,
							A2(
								$author$project$Misc$with,
								A2($elm$core$Platform$Cmd$map, $author$project$Views$AddPackagesModal$NormsAndVulnsMsg, normsAndVulnsCmd),
								model))));
			case 2:
				var popularPackagesMsg = msg.a;
				var _v3 = A5(
					$author$project$Model$PopularPackages$update,
					$author$project$Model$PopularPackages$toRollbar($author$project$Views$AddPackagesModal$rollbar),
					session,
					popularPackagesMsg,
					parentModel.m6,
					parentModel);
				var _v4 = _v3.a;
				var _v5 = _v4.a;
				var newPopularPackagesModel = _v5.a;
				var popularPackagesCmd = _v5.b;
				var external = _v4.b;
				var newParentModel = _v3.b;
				return A2(
					$author$project$Misc$with,
					_Utils_update(
						newParentModel,
						{m6: newPopularPackagesModel}),
					A2(
						$author$project$Misc$with,
						external,
						A2(
							$author$project$Misc$with,
							0,
							A2(
								$author$project$Misc$with,
								A2($elm$core$Platform$Cmd$map, $author$project$Views$AddPackagesModal$PopularPackagesMsg, popularPackagesCmd),
								model))));
			case 16:
				return A2(
					doSearch,
					model.ip,
					_Utils_update(
						model,
						{
							he: A2($elm$core$Basics$max, 0, model.he - 1)
						}));
			case 15:
				return A2(
					doSearch,
					model.ip,
					_Utils_update(
						model,
						{he: model.he + 1}));
			case 3:
				var searchString = msg.a;
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							0,
							A2(
								$author$project$Misc$with,
								$elm$core$Platform$Cmd$none,
								_Utils_update(
									model,
									{iE: searchString})))));
			case 4:
				var currentLanguage = msg.a;
				return A2(
					doSearch,
					currentLanguage,
					_Utils_update(
						model,
						{he: 0}));
			case 5:
				var searchResults = msg.a;
				var versionSelectors = function () {
					if (!searchResults.$) {
						var payload = searchResults.a;
						return A2(
							$elm_community$dict_extra$Dict$Extra$fromListBy,
							function ($) {
								return $.Y;
							},
							A2(
								$elm$core$List$map,
								A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $author$project$Views$AddPackagesModal$searchResultToVersionSelector),
								payload));
					} else {
						return $elm$core$Dict$empty;
					}
				}();
				var cmd = $author$project$Model$User$isSuperReader(
					$author$project$Model$Session$getUser(session)) ? $elm$core$Platform$Cmd$none : $author$project$Ports$sendAnalyticsEvent(
					A2($author$project$Views$AddPackagesModal$makePackageSearchAnalyticsEvent, model, searchResults));
				var _v6 = function () {
					if (searchResults.$ === 1) {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, parentModel.rF);
					} else {
						var payload = searchResults.a;
						return A4(
							$author$project$Model$NormsAndVulns$recordNormalizedVulnerabilityKeys,
							A2(
								$author$project$Model$Permissions$orgHasCvesEnabledAndVisible,
								parentModel.c3,
								$author$project$Model$Session$getUser(session)),
							creds,
							A2(
								$elm$core$List$map,
								$author$project$Model$NormsAndVulns$NamespacedVulnKey,
								A2(
									$elm$core$List$concatMap,
									$elm_community$basics_extra$Basics$Extra$uncurry($author$project$Model$HasuraIngredient$getVulnerabilityKeys),
									payload)),
							A2(
								$author$project$Model$NormsAndVulns$recordNormalizedKeys,
								A2(
									$elm$core$List$map,
									A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $elm$core$Basics$identity),
									payload),
								parentModel.rF));
					}
				}();
				var newNormsAndVulns = _v6.a;
				var normsAndVulnsCmd = _v6.b;
				return A2(
					$author$project$Misc$with,
					_Utils_update(
						parentModel,
						{rF: newNormsAndVulns}),
					A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							0,
							A2(
								$author$project$Misc$with,
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											cmd,
											A2($elm$core$Platform$Cmd$map, $author$project$Views$AddPackagesModal$NormsAndVulnsMsg, normsAndVulnsCmd)
										])),
								_Utils_update(
									model,
									{
										iD: $krisajenkins$remotedata$RemoteData$fromResult(searchResults),
										hY: versionSelectors
									})))));
			case 6:
				var language = msg.a;
				var newModel = _Utils_update(
					model,
					{ip: language});
				var _v9 = model.iD;
				if (!_v9.$) {
					var _v10 = A2($author$project$Model$PopularPackages$loadPopularPackages, session, parentModel.m6);
					var newPopularPackagesModel = _v10.a;
					var popularPackagesCmd = _v10.b;
					return A2(
						$author$project$Misc$with,
						_Utils_update(
							parentModel,
							{m6: newPopularPackagesModel}),
						A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2(
								$author$project$Misc$with,
								0,
								A2(
									$author$project$Misc$with,
									A2($elm$core$Platform$Cmd$map, $author$project$Views$AddPackagesModal$PopularPackagesMsg, popularPackagesCmd),
									newModel))));
				} else {
					return A2(doSearch, language, newModel);
				}
			case 7:
				var key = msg.a;
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							0,
							A2(
								$author$project$Misc$with,
								$elm$core$Platform$Cmd$none,
								_Utils_update(
									model,
									{
										pQ: A2($author$project$Misc$toggle, key, model.pQ)
									})))));
			case 8:
				var defaultInnerModel = msg.a;
				var innerMsg = msg.b;
				var key = $author$project$Views$PackageVersionSelector$getKey(defaultInnerModel);
				var innerModel = A2(
					$elm$core$Maybe$withDefault,
					defaultInnerModel,
					A2($elm$core$Dict$get, key, model.hY));
				var _v11 = A5(
					$author$project$Views$PackageVersionSelector$update,
					$author$project$Views$PackageVersionSelector$toRollbar($author$project$Views$AddPackagesModal$rollbar),
					session,
					innerMsg,
					innerModel,
					parentModel);
				var _v12 = _v11.a;
				var _v13 = _v12.a;
				var _v14 = _v13.a;
				var newInnerModel = _v14.a;
				var innerCmd = _v14.b;
				var external = _v12.b;
				var newParentModel = _v11.b;
				var newModel = _Utils_update(
					model,
					{
						hY: A3($elm$core$Dict$insert, key, newInnerModel, model.hY)
					});
				return A2(
					$author$project$Misc$with,
					newParentModel,
					A2(
						$author$project$Misc$with,
						external,
						A2(
							$author$project$Misc$with,
							0,
							A2(
								$author$project$Misc$with,
								A2(
									$elm$core$Platform$Cmd$map,
									$author$project$Views$AddPackagesModal$PackageVersionSelectorMsg(newInnerModel),
									innerCmd),
								newModel))));
			case 9:
				var subMsg = msg.a;
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							0,
							A2(
								$author$project$Misc$with,
								$elm$core$Platform$Cmd$none,
								_Utils_update(
									model,
									{
										rO: A2($author$project$Views$PackageSummaryDisplay$update, subMsg, model.rO)
									})))));
			case 10:
				var subMsg = msg.a;
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							0,
							A2(
								$author$project$Misc$with,
								$elm$core$Platform$Cmd$none,
								_Utils_update(
									model,
									{
										jO: A2($author$project$Views$CVEs$update, subMsg, model.jO)
									})))));
			case 11:
				var subMsg = msg.a;
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							0,
							A2(
								$author$project$Misc$with,
								$elm$core$Platform$Cmd$none,
								_Utils_update(
									model,
									{
										rn: A2($author$project$Views$Licenses$update, subMsg, model.rn)
									})))));
			case 12:
				var tab = msg.a;
				var cmd = function () {
					if (!tab) {
						return A2(
							$elm$core$Task$attempt,
							$elm$core$Basics$always($author$project$Views$AddPackagesModal$NoOp),
							$elm$browser$Browser$Dom$focus($author$project$Views$AddPackagesModal$initialFocusID));
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							0,
							A2(
								$author$project$Misc$with,
								cmd,
								_Utils_update(
									model,
									{kB: tab})))));
			case 13:
				var requirement = msg.a;
				var key = requirement.Y;
				var updateShoppingCart = F2(
					function (newConstraint, maybeKeyAndCons) {
						if (maybeKeyAndCons.$ === 1) {
							return $elm$core$Maybe$Just(
								_List_fromArray(
									[newConstraint]));
						} else {
							var list = maybeKeyAndCons.a;
							return $elm$core$Maybe$Just(
								A2($elm$core$List$cons, newConstraint, list));
						}
					});
				var newShoppingCart = function () {
					var _v17 = $author$project$Model$Language$fromNamespace(
						$author$project$Model$Namespace$getNamespace(key));
					if (!_v17.$) {
						var language = _v17.a;
						return A3(
							$elm$core$Dict$update,
							$author$project$Model$Language$toDisplayString(language),
							updateShoppingCart(requirement),
							model.fF);
					} else {
						return model.fF;
					}
				}();
				var newEditor = function () {
					var _v16 = $author$project$Model$Namespace$kind(key);
					switch (_v16) {
						case 0:
							return A3($author$project$Model$BuildPlanner$SolveLegacyEditor$addBundle, requirement.Y, requirement.bK, model.qR);
						case 5:
							return A3($author$project$Model$BuildPlanner$SolveLegacyEditor$addPackage, requirement.Y, requirement.bK, model.qR);
						default:
							return model.qR;
					}
				}();
				var cmd = $author$project$Ports$sendAnalyticsEvent(
					$author$project$Views$AddPackagesModal$makeAddRequirementAnalyticsEvent(requirement));
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							0,
							A2(
								$author$project$Misc$with,
								cmd,
								_Utils_update(
									model,
									{qR: newEditor, fF: newShoppingCart})))));
			case 14:
				var key = msg.a;
				var updateShoppingCart = function (maybeKeyAndCons) {
					return A2(
						$elm$core$Maybe$map,
						$elm$core$List$filter(
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Y;
								},
								$elm$core$Basics$neq(key))),
						maybeKeyAndCons);
				};
				var newShoppingCart = function () {
					var _v20 = $author$project$Model$Language$fromNamespace(
						$author$project$Model$Namespace$getNamespace(key));
					if (!_v20.$) {
						var language = _v20.a;
						return A2(
							$elm$core$Dict$filter,
							F2(
								function (_v21, list) {
									return A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not)(list);
								}),
							A3(
								$elm$core$Dict$update,
								$author$project$Model$Language$toDisplayString(language),
								updateShoppingCart,
								model.fF));
					} else {
						return model.fF;
					}
				}();
				var newEditor = function () {
					var _v19 = $author$project$Model$Namespace$kind(key);
					switch (_v19) {
						case 0:
							return A2($author$project$Model$BuildPlanner$SolveLegacyEditor$revertBundle, key, model.qR);
						case 5:
							return A2($author$project$Model$BuildPlanner$SolveLegacyEditor$revertPackage, key, model.qR);
						default:
							return model.qR;
					}
				}();
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							0,
							A2(
								$author$project$Misc$with,
								$elm$core$Platform$Cmd$none,
								_Utils_update(
									model,
									{qR: newEditor, fF: newShoppingCart})))));
			case 17:
				var withUpdatedEditor = msg.a;
				var newPackageVersionSelectorModels = A3(
					$elm$core$List$foldl,
					$author$project$Views$PackageVersionSelector$addOrSetSelected($elm$core$Maybe$Nothing),
					parentModel.hb,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Dict$toList,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map($elm$core$Tuple$second),
							$elm$core$List$concat))(model.fF));
				var newParentModel = withUpdatedEditor ? _Utils_update(
					parentModel,
					{qR: model.qR, hb: newPackageVersionSelectorModels}) : parentModel;
				return A2(
					$author$project$Misc$with,
					newParentModel,
					A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							1,
							A2(
								$author$project$Misc$with,
								$elm$core$Platform$Cmd$none,
								_Utils_update(
									model,
									{fF: $elm$core$Dict$empty})))));
			default:
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							2,
							A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model))));
		}
	});
var $author$project$Views$BranchPicker$BranchChanged = 0;
var $author$project$Views$BranchPicker$None = 1;
var $author$project$Views$BranchPicker$setBranch = F2(
	function (branch, model) {
		return _Utils_update(
			model,
			{fR: branch});
	});
var $author$project$Views$BranchPicker$toggleMenu = function (model) {
	return _Utils_update(
		model,
		{Du: !model.Du});
};
var $author$project$Routing$removeQueryParam = function (key) {
	return $author$project$Ports$removeUrlParameter(key);
};
var $author$project$Views$BranchPicker$updateUrlCmd = function (model) {
	return $elm$core$Platform$Cmd$batch(
		_List_fromArray(
			[
				A2(
				$author$project$Routing$setQueryParam,
				'branch',
				$author$project$Model$Branch$getName(
					$author$project$Views$BranchPicker$getSelectedBranch(model))),
				$author$project$Routing$removeQueryParam('commitID')
			]));
};
var $author$project$Views$BranchPicker$update = function (msg) {
	switch (msg.$) {
		case 1:
			var model = msg.a;
			return A2(
				$author$project$Misc$with,
				1,
				A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					$author$project$Views$BranchPicker$toggleMenu(model)));
		case 0:
			var model = msg.a;
			var branch = msg.b;
			if (!_Utils_eq(model.fR, branch)) {
				var newModel = $author$project$Views$BranchPicker$toggleMenu(
					A2($author$project$Views$BranchPicker$setBranch, branch, model));
				return A2(
					$author$project$Misc$with,
					0,
					A2(
						$author$project$Misc$with,
						$author$project$Views$BranchPicker$updateUrlCmd(newModel),
						newModel));
			} else {
				return _Utils_Tuple2(
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
					1);
			}
		default:
			var model = msg.a;
			var newModel = _Utils_update(
				model,
				{Du: false});
			return _Utils_Tuple2(
				_Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none),
				1);
	}
};
var $author$project$Views$CustomRequirementInput$NormsAndVulnsMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$addBuildFlag = function (buildFlag) {
	return $author$project$Model$BuildPlanner$SolveLegacyEditor$setBuildExprStateToolArtifactsEditor(
		{
			i8: A3(
				$elm$core$Basics$composeR,
				$author$project$Model$BuildPlanner$BuildExpr$BuildFlagsDict$buildFlagToNameAndValue,
				$elm_community$basics_extra$Basics$Extra$uncurry(
					A2(
						$author$project$Model$Editor$addKeyDict,
						function ($) {
							return $.xs;
						},
						$author$project$Model$BuildPlanner$SolveLegacyEditor$buildFlagsSetter)),
				buildFlag),
			lZ: A3(
				$elm$core$Basics$composeR,
				$author$project$Model$BuildPlanner$BuildExpr$BuildFlagsDict$buildFlagToNameAndValue,
				$elm_community$basics_extra$Basics$Extra$uncurry(
					A2(
						$author$project$Model$Editor$addKeyDict,
						function ($) {
							return $.xs;
						},
						$author$project$Model$BuildPlanner$SolveLegacyEditor$buildFlagsSetter)),
				buildFlag)
		});
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$addCamelFlag = A2(
	$elm$core$Basics$composeL,
	$author$project$Model$BuildPlanner$SolveLegacyEditor$setBuildExprCamelEditor,
	A2(
		$author$project$Model$Editor$addKeySet,
		function ($) {
			return $.Bn;
		},
		$author$project$Model$BuildPlanner$SolveLegacyEditor$camelFlagsSetter));
var $author$project$Views$CustomRequirementInput$initCustomRequirement = _Utils_Tuple2('', '');
var $author$project$Views$CustomRequirementInput$isValid = function (_v0) {
	var namespace = _v0.a;
	var name = _v0.b;
	return !($elm$core$String$isEmpty(namespace) || $elm$core$String$isEmpty(name));
};
var $author$project$Views$CustomRequirementInput$update = F5(
	function (rollbar, session, msg, model, parentModel) {
		switch (msg.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model)));
			case 1:
				var normsAndVulnsMsg = msg.a;
				var _v1 = A4(
					$author$project$Model$NormsAndVulns$update,
					$author$project$Model$NormsAndVulns$toRollbar(rollbar),
					session,
					normsAndVulnsMsg,
					parentModel.rF);
				var _v2 = _v1.a;
				var newNormsAndVulns = _v2.a;
				var normsAndVulnsCmd = _v2.b;
				var external = _v1.b;
				return A2(
					$author$project$Misc$with,
					_Utils_update(
						parentModel,
						{rF: newNormsAndVulns}),
					A2(
						$author$project$Misc$with,
						external,
						A2(
							$author$project$Misc$with,
							A2($elm$core$Platform$Cmd$map, $author$project$Views$CustomRequirementInput$NormsAndVulnsMsg, normsAndVulnsCmd),
							model)));
			case 2:
				var newCustomRequirement = msg.a;
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{ht: newCustomRequirement}))));
			case 3:
				if (!$author$project$Views$CustomRequirementInput$isValid(model.ht)) {
					return A2(
						$author$project$Misc$with,
						parentModel,
						A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model)));
				} else {
					var customRequirement = model.ht;
					var name = $author$project$Model$Namespace$getName(customRequirement);
					var newEditor = function () {
						var _v5 = $author$project$Model$Namespace$kind(customRequirement);
						switch (_v5) {
							case 0:
								return A3($author$project$Model$BuildPlanner$SolveLegacyEditor$addBundle, customRequirement, $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$Auto, parentModel.qR);
							case 1:
								var buildFlag = function () {
									var _v6 = A2($elm$core$String$split, '=', name);
									if (_v6.b) {
										if (!_v6.b.b) {
											var flagName = _v6.a;
											return {w: flagName, kH: $elm$core$Maybe$Nothing};
										} else {
											var flagName = _v6.a;
											var _v7 = _v6.b;
											var flagValue = _v7.a;
											var others = _v7.b;
											return {
												w: flagName,
												kH: $elm$core$Maybe$Just(
													A2(
														$elm$core$String$join,
														'=',
														A2($elm$core$List$cons, flagValue, others)))
											};
										}
									} else {
										return {w: name, kH: $elm$core$Maybe$Nothing};
									}
								}();
								return A2($author$project$Model$BuildPlanner$SolveLegacyEditor$addBuildFlag, buildFlag, parentModel.qR);
							case 2:
								return A2($author$project$Model$BuildPlanner$SolveLegacyEditor$addCamelFlag, name, parentModel.qR);
							case 3:
								return A3($author$project$Model$BuildPlanner$SolveLegacyEditor$addHidden, customRequirement, $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$Auto, parentModel.qR);
							case 4:
								var version = A2(
									$elm$core$Maybe$withDefault,
									$author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$Auto,
									A2(
										$elm$core$Maybe$map,
										A2($elm$core$Basics$composeR, $author$project$Model$LanguageVersions$getSelected, $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$Exact),
										A2($elm$core$Dict$get, name, parentModel.jF)));
								return A3($author$project$Model$BuildPlanner$SolveLegacyEditor$addLanguage, name, version, parentModel.qR);
							case 5:
								return A3($author$project$Model$BuildPlanner$SolveLegacyEditor$addPackage, customRequirement, $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$Auto, parentModel.qR);
							default:
								return A2($author$project$Model$BuildPlanner$SolveLegacyEditor$addPlatform, name, parentModel.qR);
						}
					}();
					var creds = $author$project$Model$Session$getCreds(session);
					var _v3 = function () {
						var _v4 = $author$project$Model$Namespace$kind(customRequirement);
						switch (_v4) {
							case 3:
								return A3(
									$author$project$Model$NormsAndVulns$recordKeys,
									creds,
									$elm$core$List$singleton(model.ht),
									parentModel.rF);
							case 5:
								return A3(
									$author$project$Model$NormsAndVulns$recordKeys,
									creds,
									$elm$core$List$singleton(model.ht),
									parentModel.rF);
							default:
								return _Utils_Tuple2(parentModel.rF, $elm$core$Platform$Cmd$none);
						}
					}();
					var newNormsAndVulns = _v3.a;
					var normsAndVulnsCmd = _v3.b;
					return A2(
						$author$project$Misc$with,
						_Utils_update(
							parentModel,
							{qR: newEditor, rF: newNormsAndVulns}),
						A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2(
								$author$project$Misc$with,
								A2($elm$core$Platform$Cmd$map, $author$project$Views$CustomRequirementInput$NormsAndVulnsMsg, normsAndVulnsCmd),
								_Utils_update(
									model,
									{ht: $author$project$Views$CustomRequirementInput$initCustomRequirement}))));
				}
			default:
				if (!msg.a.$) {
					var namespaces = msg.a.a;
					return A2(
						$author$project$Misc$with,
						parentModel,
						A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2(
								$author$project$Misc$with,
								$elm$core$Platform$Cmd$none,
								_Utils_update(
									model,
									{mE: namespaces}))));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$Misc$with,
						parentModel,
						A2(
							$author$project$Misc$with,
							$author$project$External$AddNotification(
								$author$project$Model$Notification$fromError(err)),
							A2(
								$author$project$Misc$with,
								A3(rollbar.FZ, 'OnNamespacesReceived (Err err)', err, session),
								model)));
				}
		}
	});
var $author$project$Views$Dependencies$NoOp = {$: 0};
var $author$project$Views$Dependencies$update = F4(
	function (msg, model, parentModel, generatePackageIdFromKey) {
		switch (msg.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
			case 1:
				var innerMsg = msg.a;
				return A2(
					$author$project$Misc$with,
					_Utils_update(
						parentModel,
						{
							x$: A2($author$project$Views$NamespaceExpand$update, innerMsg, parentModel.x$)
						}),
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
			case 2:
				var innerMsg = msg.a;
				return A2(
					$author$project$Misc$with,
					_Utils_update(
						parentModel,
						{
							rn: A2($author$project$Views$Licenses$update, innerMsg, parentModel.rn)
						}),
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
			case 3:
				var key = msg.a;
				var tab = msg.b;
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								nY: A3($elm$core$Dict$insert, key, tab, model.nY)
							})));
			case 4:
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{lG: !model.lG})));
			case 5:
				var key = msg.a.Y;
				var constraint = msg.a.bK;
				var scrollCmd = $author$project$Ports$scrollIntoView(
					{
						fD: $elm$core$Maybe$Just('center'),
						z0: '#' + generatePackageIdFromKey(key)
					});
				var func = function () {
					var _v1 = $author$project$Model$Namespace$kind(key);
					switch (_v1) {
						case 0:
							return $author$project$Model$BuildPlanner$SolveLegacyEditor$addBundle;
						case 5:
							return $author$project$Model$BuildPlanner$SolveLegacyEditor$addPackage;
						case 3:
							return $author$project$Model$BuildPlanner$SolveLegacyEditor$addHidden;
						case 4:
							return function (_v2) {
								var langname = _v2.b;
								return $author$project$Model$BuildPlanner$SolveLegacyEditor$addLanguage(langname);
							};
						default:
							return F2(
								function (_v3, _v4) {
									return $elm$core$Basics$identity;
								});
					}
				}();
				var newEditor = A3(func, key, constraint, parentModel.qR);
				var eventArgs = A2(
					$author$project$Model$Analytics$withLabel,
					A2($author$project$Model$BuildExprEditorUtils$getAnalyticsLabel, key, constraint),
					A2(
						$author$project$Model$Analytics$withAction,
						'Edited order - pinned dependency',
						A2(
							$author$project$Model$Analytics$withCategory,
							$author$project$Model$Analytics$categoryConfiguration,
							$author$project$Model$Analytics$newEvent('Edited order - pinned dependency'))));
				return A2(
					$author$project$Misc$with,
					_Utils_update(
						parentModel,
						{qR: newEditor}),
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Ports$sendAnalyticsEvent(eventArgs),
									scrollCmd
								])),
						model));
			default:
				var requirements = msg.a;
				var func = function (key) {
					var _v6 = $author$project$Model$Namespace$kind(key);
					switch (_v6) {
						case 0:
							return $author$project$Model$BuildPlanner$SolveLegacyEditor$addBundle(key);
						case 5:
							return $author$project$Model$BuildPlanner$SolveLegacyEditor$addPackage(key);
						case 3:
							return $author$project$Model$BuildPlanner$SolveLegacyEditor$addHidden(key);
						default:
							return function (_v7) {
								return $elm$core$Basics$identity;
							};
					}
				};
				var newEditor = A3(
					$elm$core$List$foldr,
					function (_v5) {
						var key = _v5.Y;
						var constraint = _v5.bK;
						return A2(func, key, constraint);
					},
					parentModel.qR,
					requirements);
				var eventArgs = A2(
					$author$project$Model$Analytics$withValue,
					$elm$core$List$length(requirements),
					A2(
						$author$project$Model$Analytics$withAction,
						'Edited order - pinned dependencies (bulk)',
						A2(
							$author$project$Model$Analytics$withCategory,
							$author$project$Model$Analytics$categoryConfiguration,
							$author$project$Model$Analytics$newEvent('Edited order - pinned dependencies (bulk)'))));
				return A2(
					$author$project$Misc$with,
					_Utils_update(
						parentModel,
						{qR: newEditor}),
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Ports$sendAnalyticsEvent(eventArgs),
									$author$project$Misc$scrollToTop($author$project$Views$Dependencies$NoOp)
								])),
						model));
		}
	});
var $author$project$Views$GenericSBOM$Ascending = 0;
var $author$project$Views$GenericSBOM$Descending = 1;
var $author$project$Views$GenericSBOM$defaultSortDirection = 0;
var $author$project$Views$GenericSBOM$update = F2(
	function (model, msg) {
		if (!msg.$) {
			var searchTerm = msg.a;
			return A2(
				$author$project$Misc$with,
				$elm$core$Platform$Cmd$none,
				_Utils_update(
					model,
					{nq: searchTerm}));
		} else {
			var sortBy = msg.a;
			var sortDirection = function () {
				var _v1 = _Utils_Tuple2(
					_Utils_eq(sortBy, model.nx),
					model.ny);
				if (!_v1.a) {
					return $author$project$Views$GenericSBOM$defaultSortDirection;
				} else {
					if (!_v1.b) {
						var _v2 = _v1.b;
						return 1;
					} else {
						var _v3 = _v1.b;
						return 0;
					}
				}
			}();
			return A2(
				$author$project$Misc$with,
				$elm$core$Platform$Cmd$none,
				_Utils_update(
					model,
					{nx: sortBy, ny: sortDirection}));
		}
	});
var $author$project$Views$ImportPackagesModal$Close = 1;
var $author$project$Views$ImportPackagesModal$None = 0;
var $author$project$Views$ImportPackagesModal$NormsAndVulnsMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Views$ImportPackagesModal$OnImport = function (a) {
	return {$: 4, a: a};
};
var $author$project$Views$ImportPackagesModal$SelectFile = function (a) {
	return {$: 9, a: a};
};
var $author$project$Views$ImportPackagesModal$UpdateImportText = function (a) {
	return {$: 2, a: a};
};
var $author$project$Views$ImportPackagesModal$commitMessage = function (mLanguage) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (lang) {
				return 'Importing packages from ' + ($author$project$Model$Language$toDisplayString(lang) + ' project file');
			},
			mLanguage));
};
var $elm_community$dict_extra$Dict$Extra$insertDedupe = F4(
	function (combine, key, value, dict) {
		var _with = function (mbValue) {
			if (!mbValue.$) {
				var oldValue = mbValue.a;
				return $elm$core$Maybe$Just(
					A2(combine, oldValue, value));
			} else {
				return $elm$core$Maybe$Just(value);
			}
		};
		return A3($elm$core$Dict$update, key, _with, dict);
	});
var $elm_community$dict_extra$Dict$Extra$fromListDedupeBy = F3(
	function (combine, keyfn, xs) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (x, acc) {
					return A4(
						$elm_community$dict_extra$Dict$Extra$insertDedupe,
						combine,
						keyfn(x),
						x,
						acc);
				}),
			$elm$core$Dict$empty,
			xs);
	});
var $author$project$Model$BuildExprEditorUtils$getMaxVersionList = function (constraints) {
	var minNotEmpty = F2(
		function (a, b) {
			return (a === '') ? b : ((b === '') ? a : A2($elm$core$Basics$min, a, b));
		});
	var maxNotEmpty = F2(
		function (a, b) {
			return (a === '') ? b : ((b === '') ? a : A2($elm$core$Basics$max, a, b));
		});
	return A3(
		$elm$core$List$foldl,
		F2(
			function (requirement, curMax) {
				return A2(
					$elm$core$List$member,
					requirement.h,
					_List_fromArray(
						['lt', 'lte', 'eq'])) ? A2(minNotEmpty, curMax, requirement.aI) : (A2(
					$elm$core$List$member,
					requirement.h,
					_List_fromArray(
						['gt', 'gte'])) ? A2(maxNotEmpty, curMax, requirement.aI) : curMax);
			}),
		'',
		constraints);
};
var $author$project$Model$BuildExprEditorUtils$getMaxVersion = function (constraint) {
	switch (constraint.$) {
		case 1:
			var version = constraint.a;
			return version;
		case 2:
			var first = constraint.a;
			var others = constraint.b;
			return $author$project$Model$BuildExprEditorUtils$getMaxVersionList(
				A2($elm$core$List$cons, first, others));
		default:
			return '';
	}
};
var $author$project$Views$ImportPackagesModal$keepHighestVersion = F2(
	function (a, b) {
		return (_Utils_cmp(
			$author$project$Model$BuildExprEditorUtils$getMaxVersion(a.bK),
			$author$project$Model$BuildExprEditorUtils$getMaxVersion(b.bK)) > -1) ? a : b;
	});
var $author$project$Views$ImportPackagesModal$dedupeRequirementsByVersion = A2(
	$elm$core$Basics$composeR,
	A2(
		$elm_community$dict_extra$Dict$Extra$fromListDedupeBy,
		$author$project$Views$ImportPackagesModal$keepHighestVersion,
		function ($) {
			return $.Y;
		}),
	$elm$core$Dict$values);
var $author$project$Views$ImportPackagesModal$addSelectedPackages = F4(
	function (creds, importedPackages, mLanguage, parentModel) {
		var requirements = $author$project$Views$ImportPackagesModal$dedupeRequirementsByVersion(importedPackages);
		var newPackageVersionSelectorModels = A3(
			$elm$core$List$foldl,
			$author$project$Views$PackageVersionSelector$addOrSetSelected($elm$core$Maybe$Nothing),
			parentModel.hb,
			requirements);
		var newEditor = A3(
			$elm$core$List$foldl,
			function (req) {
				return A2($author$project$Model$BuildPlanner$SolveLegacyEditor$addPackage, req.Y, req.bK);
			},
			parentModel.qR,
			requirements);
		var newCommentString = $elm$core$String$isEmpty(parentModel.hq) ? $author$project$Views$ImportPackagesModal$commitMessage(mLanguage) : parentModel.hq;
		var _v0 = A3(
			$author$project$Model$NormsAndVulns$recordKeys,
			creds,
			A2(
				$elm$core$List$map,
				function ($) {
					return $.Y;
				},
				requirements),
			parentModel.rF);
		var newNormsAndVulns = _v0.a;
		var normsAndVulnsCmd = _v0.b;
		return A2(
			$author$project$Misc$with,
			_Utils_update(
				parentModel,
				{hq: newCommentString, qR: newEditor, rF: newNormsAndVulns, hb: newPackageVersionSelectorModels}),
			A2($elm$core$Platform$Cmd$map, $author$project$Views$ImportPackagesModal$NormsAndVulnsMsg, normsAndVulnsCmd));
	});
var $author$project$Model$PackageImport$errorSummary = function (errorList) {
	return A2(
		$elm$core$String$join,
		', ',
		A2(
			$elm$core$List$map,
			function (error) {
				return error.zB + (' : ' + error.ye);
			},
			errorList));
};
var $author$project$Misc$memberOfSet = F2(
	function (set, element) {
		return A2($elm$core$Set$member, element, set);
	});
var $author$project$Misc$getDuplicateBy = F2(
	function (fn, list) {
		var getDuplicateHelper = F3(
			function (existing, seen, acc) {
				getDuplicateHelper:
				while (true) {
					if (!existing.b) {
						return acc;
					} else {
						var head = existing.a;
						var tail = existing.b;
						var headKey = fn(head);
						var newSeen = A2($elm$core$Set$insert, headKey, seen);
						if (A2($author$project$Misc$memberOfSet, seen, headKey)) {
							var $temp$existing = tail,
								$temp$seen = newSeen,
								$temp$acc = A2($elm$core$List$cons, head, acc);
							existing = $temp$existing;
							seen = $temp$seen;
							acc = $temp$acc;
							continue getDuplicateHelper;
						} else {
							var $temp$existing = tail,
								$temp$seen = newSeen,
								$temp$acc = acc;
							existing = $temp$existing;
							seen = $temp$seen;
							acc = $temp$acc;
							continue getDuplicateHelper;
						}
					}
				}
			});
		return A2(
			$elm_community$list_extra$List$Extra$uniqueBy,
			fn,
			A3(getDuplicateHelper, list, $elm$core$Set$empty, _List_Nil));
	});
var $author$project$Views$ImportPackagesModal$NoOp = {$: 0};
var $author$project$Views$ImportPackagesModal$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Views$ImportPackagesModal$NoOp, 'Views/ImportPackagesModal.elm');
var $author$project$Views$ImportPackagesModal$ReviewResults = function (a) {
	return {$: 1, a: a};
};
var $author$project$Views$ImportPackagesModal$updateTabState = F2(
	function (updateFn, model) {
		var tabState = model.eP;
		return _Utils_update(
			model,
			{
				eP: updateFn(tabState)
			});
	});
var $author$project$Views$ImportPackagesModal$setErrorResults = F3(
	function (importedPackages, errors, model) {
		return A2(
			$author$project$Views$ImportPackagesModal$updateTabState,
			function (tabState) {
				return _Utils_update(
					tabState,
					{
						mb: errors,
						CV: importedPackages,
						no: function () {
							var _v0 = tabState.no;
							if (!_v0.$) {
								return $author$project$Views$ImportPackagesModal$ReviewResults(
									{ow: true, ox: false});
							} else {
								var screen = _v0;
								return screen;
							}
						}()
					});
			},
			_Utils_update(
				model,
				{pE: false}));
	});
var $author$project$Views$ImportPackagesModal$update = F4(
	function (session, msg, model, parentModel) {
		var creds = $author$project$Model$Session$getCreds(session);
		switch (msg.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							0,
							A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model))));
			case 1:
				var normsAndVulnsMsg = msg.a;
				var _v1 = A4(
					$author$project$Model$NormsAndVulns$update,
					$author$project$Model$NormsAndVulns$toRollbar($author$project$Views$ImportPackagesModal$rollbar),
					session,
					normsAndVulnsMsg,
					parentModel.rF);
				var _v2 = _v1.a;
				var newNormsAndVulns = _v2.a;
				var normsAndVulnsCmd = _v2.b;
				var external = _v1.b;
				return A2(
					$author$project$Misc$with,
					_Utils_update(
						parentModel,
						{rF: newNormsAndVulns}),
					A2(
						$author$project$Misc$with,
						external,
						A2(
							$author$project$Misc$with,
							0,
							A2(
								$author$project$Misc$with,
								A2($elm$core$Platform$Cmd$map, $author$project$Views$ImportPackagesModal$NormsAndVulnsMsg, normsAndVulnsCmd),
								model))));
			case 2:
				var importText = msg.a;
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							0,
							A2(
								$author$project$Misc$with,
								$elm$core$Platform$Cmd$none,
								A2(
									$author$project$Views$ImportPackagesModal$updateTabState,
									function (tabState) {
										return _Utils_update(
											tabState,
											{ja: importText});
									},
									model)))));
			case 3:
				var cmd = function () {
					var _v3 = model.iG;
					if (!_v3.$) {
						var language = _v3.a;
						return A2(
							$elm$core$Task$attempt,
							$author$project$Views$ImportPackagesModal$OnImport,
							A3(
								$author$project$Request$PackageImport$importPackages,
								creds,
								language,
								$author$project$Model$PackageImport$Formatted(model.eP.ja)));
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							0,
							A2(
								$author$project$Misc$with,
								cmd,
								_Utils_update(
									model,
									{pE: true})))));
			case 4:
				if (!msg.a.$) {
					var changeset = msg.a.a;
					var duplicateErrors = A2(
						$elm$core$List$map,
						function (req) {
							return {
								ye: 'Warning: duplicate packages detected. Continuing with the import will select a package with the highest maximum version.',
								zB: $author$project$Model$Namespace$getName(req.Y)
							};
						},
						A2(
							$author$project$Misc$getDuplicateBy,
							function ($) {
								return $.Y;
							},
							changeset.CV));
					var errors = _Utils_ap(duplicateErrors, changeset.yf);
					if (!$elm$core$List$isEmpty(errors)) {
						var errorSummary = $author$project$Model$PackageImport$errorSummary(errors);
						var event = A2(
							$author$project$Model$Analytics$withLabel,
							errorSummary,
							A2(
								$author$project$Model$Analytics$withAction,
								'Imported from file - error',
								A2(
									$author$project$Model$Analytics$withCategory,
									$author$project$Model$Analytics$categoryConfiguration,
									$author$project$Model$Analytics$newEvent('Imported from file - error'))));
						return A2(
							$author$project$Misc$with,
							parentModel,
							A2(
								$author$project$Misc$with,
								$author$project$External$NoOp,
								A2(
									$author$project$Misc$with,
									0,
									A2(
										$author$project$Misc$with,
										$author$project$Ports$sendAnalyticsEvent(event),
										A3($author$project$Views$ImportPackagesModal$setErrorResults, changeset.CV, errors, model)))));
					} else {
						if ($elm$core$List$isEmpty(changeset.CV)) {
							var event = A2(
								$author$project$Model$Analytics$withAction,
								'Imported from file - no packages',
								A2(
									$author$project$Model$Analytics$withCategory,
									$author$project$Model$Analytics$categoryConfiguration,
									$author$project$Model$Analytics$newEvent('Imported from file - no packages')));
							return A2(
								$author$project$Misc$with,
								parentModel,
								A2(
									$author$project$Misc$with,
									$author$project$External$NoOp,
									A2(
										$author$project$Misc$with,
										0,
										A2(
											$author$project$Misc$with,
											$author$project$Ports$sendAnalyticsEvent(event),
											A3($author$project$Views$ImportPackagesModal$setErrorResults, changeset.CV, errors, model)))));
						} else {
							var importedPackageCount = $elm$core$String$fromInt(
								$elm$core$List$length(changeset.CV));
							var event = A2(
								$author$project$Model$Analytics$withLabel,
								importedPackageCount + ' packages',
								A2(
									$author$project$Model$Analytics$withAction,
									'Imported from file - success',
									A2(
										$author$project$Model$Analytics$withCategory,
										$author$project$Model$Analytics$categoryConfiguration,
										$author$project$Model$Analytics$newEvent('Imported from file - success'))));
							var _v4 = A4($author$project$Views$ImportPackagesModal$addSelectedPackages, creds, changeset.CV, model.iG, parentModel);
							var cmd = _v4.a;
							var newParentModel = _v4.b;
							return A2(
								$author$project$Misc$with,
								newParentModel,
								A2(
									$author$project$Misc$with,
									$author$project$External$NoOp,
									A2(
										$author$project$Misc$with,
										1,
										A2(
											$author$project$Misc$with,
											$elm$core$Platform$Cmd$batch(
												_List_fromArray(
													[
														cmd,
														$author$project$Ports$sendAnalyticsEvent(event)
													])),
											$author$project$Views$ImportPackagesModal$init(newParentModel.qR)))));
						}
					}
				} else {
					var err = msg.a.a;
					var somethingWentWrong = 'Something went wrong! Please try again.';
					var errorText = function () {
						var _v5 = err.mp;
						if (_v5.$ === 3) {
							var resp = _v5.a;
							return ((resp.wp === 400) && A2($elm$core$String$contains, 'Unrecognized format', resp.sY)) ? 'We could not detect any of the supported file formats (see above).' : somethingWentWrong;
						} else {
							return somethingWentWrong;
						}
					}();
					return A2(
						$author$project$Misc$with,
						parentModel,
						A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2(
								$author$project$Misc$with,
								0,
								A2(
									$author$project$Misc$with,
									$elm$core$Platform$Cmd$none,
									A3(
										$author$project$Views$ImportPackagesModal$setErrorResults,
										_List_Nil,
										_List_fromArray(
											[
												{ye: errorText, zB: ''}
											]),
										model)))));
				}
			case 5:
				var _v6 = A4($author$project$Views$ImportPackagesModal$addSelectedPackages, creds, model.eP.CV, model.iG, parentModel);
				var cmd = _v6.a;
				var newParentModel = _v6.b;
				return A2(
					$author$project$Misc$with,
					newParentModel,
					A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							1,
							A2(
								$author$project$Misc$with,
								cmd,
								$author$project$Views$ImportPackagesModal$init(newParentModel.qR)))));
			case 6:
				var newScreen = msg.a;
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							0,
							A2(
								$author$project$Misc$with,
								$elm$core$Platform$Cmd$none,
								A2(
									$author$project$Views$ImportPackagesModal$updateTabState,
									function (tabState) {
										return _Utils_update(
											tabState,
											{no: newScreen});
									},
									model)))));
			case 7:
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							1,
							A2(
								$author$project$Misc$with,
								$elm$core$Platform$Cmd$none,
								$author$project$Views$ImportPackagesModal$init(parentModel.qR)))));
			case 8:
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							0,
							A2(
								$author$project$Misc$with,
								A2($elm$file$File$Select$file, _List_Nil, $author$project$Views$ImportPackagesModal$SelectFile),
								model))));
			case 9:
				var file = msg.a;
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							0,
							A2(
								$author$project$Misc$with,
								A2(
									$elm$core$Task$perform,
									$author$project$Views$ImportPackagesModal$UpdateImportText,
									$elm$file$File$toString(file)),
								model))));
			default:
				var language = msg.a;
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							0,
							A2(
								$author$project$Misc$with,
								$elm$core$Platform$Cmd$none,
								_Utils_update(
									model,
									{
										iG: $elm$core$Maybe$Just(language),
										eP: $author$project$Views$ImportPackagesModal$tabStateInit
									})))));
		}
	});
var $author$project$Views$LanguageSelectionModal$Close = 1;
var $author$project$Views$LanguageSelectionModal$None = 0;
var $author$project$Views$LanguageSelectionModal$update = F3(
	function (msg, model, parentModel) {
		switch (msg.$) {
			case 0:
				var languageName = msg.a;
				var version = msg.b;
				var newEditor = A3(
					$author$project$Model$BuildPlanner$SolveLegacyEditor$addLanguage,
					languageName,
					$author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$Exact(version),
					model.qR);
				var event = A2(
					$author$project$Model$Analytics$withLabel,
					languageName + (' - ' + version),
					A2(
						$author$project$Model$Analytics$withAction,
						'Edited order - language added',
						A2(
							$author$project$Model$Analytics$withCategory,
							$author$project$Model$Analytics$categoryConfiguration,
							$author$project$Model$Analytics$newEvent('Edited order - language added'))));
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						0,
						A2(
							$author$project$Misc$with,
							$author$project$Ports$sendAnalyticsEvent(event),
							_Utils_update(
								model,
								{qR: newEditor}))));
			case 1:
				var languageName = msg.a;
				var version = msg.b;
				var newEditor = A3(
					$author$project$Model$BuildPlanner$SolveLegacyEditor$addLanguage,
					languageName,
					$author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$Exact(version),
					model.qR);
				var event = A2(
					$author$project$Model$Analytics$withLabel,
					languageName + (' - ' + version),
					A2(
						$author$project$Model$Analytics$withAction,
						'Edited order - language version changed',
						A2(
							$author$project$Model$Analytics$withCategory,
							$author$project$Model$Analytics$categoryConfiguration,
							$author$project$Model$Analytics$newEvent('Edited order - language version changed'))));
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						0,
						A2(
							$author$project$Misc$with,
							$author$project$Ports$sendAnalyticsEvent(event),
							_Utils_update(
								model,
								{qR: newEditor}))));
			case 2:
				var languageName = msg.a;
				var version = msg.b;
				var newEditor = A2($author$project$Model$BuildPlanner$SolveLegacyEditor$removeLanguage, languageName, model.qR);
				var event = A2(
					$author$project$Model$Analytics$withLabel,
					languageName + (' - ' + version),
					A2(
						$author$project$Model$Analytics$withAction,
						'Edited order - language removed',
						A2(
							$author$project$Model$Analytics$withCategory,
							$author$project$Model$Analytics$categoryConfiguration,
							$author$project$Model$Analytics$newEvent('Edited order - language removed'))));
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						0,
						A2(
							$author$project$Misc$with,
							$author$project$Ports$sendAnalyticsEvent(event),
							_Utils_update(
								model,
								{qR: newEditor}))));
			default:
				return A2(
					$author$project$Misc$with,
					_Utils_update(
						parentModel,
						{qR: model.qR}),
					A2(
						$author$project$Misc$with,
						1,
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model)));
		}
	});
var $author$project$Views$PlanningErrorNotice$None = {$: 1};
var $author$project$Views$PlanningErrorNotice$PerformRemediation = function (a) {
	return {$: 0, a: a};
};
var $author$project$Views$PlanningErrorNotice$update = F2(
	function (msg, model) {
		if (!msg.$) {
			return A2(
				$author$project$Misc$with,
				$author$project$Views$PlanningErrorNotice$None,
				_Utils_update(
					model,
					{ov: !model.ov}));
		} else {
			var param = msg.a;
			return A2(
				$author$project$Misc$with,
				$author$project$Views$PlanningErrorNotice$PerformRemediation(param),
				model);
		}
	});
var $author$project$Views$PlatformSelectionModal$Close = 1;
var $author$project$Views$PlatformSelectionModal$None = 0;
var $author$project$Model$BuildPlanner$SolveLegacyEditor$removePackager = F2(
	function (platformID, packager) {
		var remove = function (packagers) {
			switch (packager) {
				case 0:
					return _Utils_update(
						packagers,
						{Cj: _List_Nil});
				case 1:
					return _Utils_update(
						packagers,
						{D4: _List_Nil});
				case 2:
					return _Utils_update(
						packagers,
						{w4: _List_Nil});
				case 3:
					return _Utils_update(
						packagers,
						{vX: _List_Nil});
				default:
					return _Utils_update(
						packagers,
						{A8: _List_Nil});
			}
		};
		return $author$project$Model$BuildPlanner$SolveLegacyEditor$setBuildExprPlatformPackagersEditor(
			A2(
				$elm$core$Dict$update,
				platformID,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Maybe$withDefault($author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$packagersInit),
					A2($elm$core$Basics$composeR, remove, $elm$core$Maybe$Just))));
	});
var $author$project$Views$PlatformSelectionModal$update = F3(
	function (msg, model, parentModel) {
		switch (msg.$) {
			case 0:
				var platformName = msg.a;
				return _Utils_eq(
					platformName,
					A2($elm$core$Maybe$withDefault, '', model.or)) ? A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						0,
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model))) : A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						0,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{
									or: $elm$core$Maybe$Just(platformName)
								}))));
			case 1:
				var platformID = msg.a;
				var event = A2(
					$author$project$Model$Analytics$withLabel,
					platformID,
					A2(
						$author$project$Model$Analytics$withAction,
						'Edited order - platform added',
						A2(
							$author$project$Model$Analytics$withCategory,
							$author$project$Model$Analytics$categoryConfiguration,
							$author$project$Model$Analytics$newEvent('Edited order - platform added'))));
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						0,
						A2(
							$author$project$Misc$with,
							$author$project$Ports$sendAnalyticsEvent(event),
							_Utils_update(
								model,
								{
									qR: A2($author$project$Model$BuildPlanner$SolveLegacyEditor$addPlatform, platformID, model.qR)
								}))));
			case 2:
				var platformID = msg.a;
				var event = A2(
					$author$project$Model$Analytics$withLabel,
					platformID,
					A2(
						$author$project$Model$Analytics$withAction,
						'Edited order - platform removed',
						A2(
							$author$project$Model$Analytics$withCategory,
							$author$project$Model$Analytics$categoryConfiguration,
							$author$project$Model$Analytics$newEvent('Edited order - platform removed'))));
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						0,
						A2(
							$author$project$Misc$with,
							$author$project$Ports$sendAnalyticsEvent(event),
							_Utils_update(
								model,
								{
									qR: A2(
										$author$project$Model$BuildPlanner$SolveLegacyEditor$removePackagersForPlatform,
										platformID,
										A2($author$project$Model$BuildPlanner$SolveLegacyEditor$removePlatform, platformID, model.qR))
								}))));
			case 3:
				var platformID = msg.a;
				var packager = msg.b;
				var newEditor = function () {
					switch (packager) {
						case 0:
							return A2($author$project$Model$BuildPlanner$SolveLegacyEditor$addPackagerDocker, platformID, model.qR);
						case 1:
							return A2($author$project$Model$BuildPlanner$SolveLegacyEditor$addPackagerLinuxInstaller, platformID, model.qR);
						case 2:
							return A2($author$project$Model$BuildPlanner$SolveLegacyEditor$addPackagerWindowsInstaller, platformID, model.qR);
						case 3:
							return A2($author$project$Model$BuildPlanner$SolveLegacyEditor$addPackagerRelocateAndZip, platformID, model.qR);
						default:
							return A2($author$project$Model$BuildPlanner$SolveLegacyEditor$addPackagerAuthenticodeSignature, platformID, model.qR);
					}
				}();
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						0,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{qR: newEditor}))));
			case 4:
				var platformID = msg.a;
				var packager = msg.b;
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						0,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{
									qR: A3($author$project$Model$BuildPlanner$SolveLegacyEditor$removePackager, platformID, packager, model.qR)
								}))));
			default:
				return A2(
					$author$project$Misc$with,
					_Utils_update(
						parentModel,
						{qR: model.qR}),
					A2(
						$author$project$Misc$with,
						1,
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model)));
		}
	});
var $author$project$Views$Timestamp$SetNextCommitTimestamp = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$getOriginalTimestamp = $author$project$Model$BuildPlanner$SolveLegacyEditor$getBuildExprSolveEditor(
	$author$project$Model$Editor$getFieldOriginal(
		function ($) {
			return $.wG;
		}));
var $author$project$Views$Timestamp$timestampChangedPrefix = 'Timestamp changed from ';
var $author$project$Views$Timestamp$update = F3(
	function (msg, model, parentModel) {
		switch (msg.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						A2($elm$core$Task$perform, $author$project$Views$Timestamp$SetNextCommitTimestamp, $elm$time$Time$now),
						model));
			case 1:
				var timestamp = msg.a;
				var originalTimestamp = A2(
					$elm$core$Maybe$withDefault,
					parentModel.pq,
					$author$project$Model$BuildPlanner$SolveLegacyEditor$getOriginalTimestamp(parentModel.qR));
				var nextCommentString = _Utils_eq(timestamp, originalTimestamp) ? (A2($elm$core$String$startsWith, $author$project$Views$Timestamp$timestampChangedPrefix, parentModel.hq) ? '' : parentModel.hq) : (($elm$core$String$isEmpty(parentModel.hq) || A2($elm$core$String$startsWith, $author$project$Views$Timestamp$timestampChangedPrefix, parentModel.hq)) ? ($author$project$Views$Timestamp$timestampChangedPrefix + ($rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(originalTimestamp) + (' to ' + $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(timestamp)))) : parentModel.hq);
				return A2(
					$author$project$Misc$with,
					_Utils_update(
						parentModel,
						{
							hq: nextCommentString,
							qR: A3(
								$author$project$Model$BuildPlanner$SolveLegacyEditor$setTimestamp,
								true,
								$elm$core$Maybe$Just(timestamp),
								parentModel.qR)
						}),
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
			case 2:
				var value = msg.a;
				return A2(
					$author$project$Misc$with,
					parentModel,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{o7: value})));
			default:
				return A2(
					$author$project$Misc$with,
					_Utils_update(
						parentModel,
						{
							iK: $author$project$Model$AtTime$DynamicImports(2)
						}),
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
		}
	});
var $author$project$Views$UpdateForkModal$CloseModal = 1;
var $author$project$Views$UpdateForkModal$MergeSuccessful = 2;
var $author$project$Views$UpdateForkModal$NoOp = 0;
var $author$project$Views$UpdateForkModal$OnMerge = function (a) {
	return {$: 4, a: a};
};
var $author$project$BuildPlanner$Enum$MergeStrategy$RecursiveKeepOnConflict = 2;
var $author$project$BuildPlanner$Enum$MergeStrategy$RecursiveOverwriteOnConflict = 1;
var $author$project$Model$BuildPlanner$BuildPlannerError$FastForwardError = function (a) {
	return {$: 11, a: a};
};
var $author$project$Model$BuildPlanner$BuildPlannerError$MergeConflictError = function (a) {
	return {$: 10, a: a};
};
var $author$project$Model$BuildPlanner$BuildPlannerError$NoUpstreamBranchError = function (a) {
	return {$: 12, a: a};
};
var $author$project$BuildPlanner$Union$MergeUpstreamBranchResult$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'MergedCommit', selections____.vl),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'MergeConflict', selections____.vk),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'FastForwardError', selections____.va),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'NoUpstreamBranch', selections____.vo),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'NotFound', selections____.vp),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ParseError', selections____.vq),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'ValidationError', selections____.vC),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'Forbidden', selections____.vc),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'HeadOnBranchMoved', selections____.vf),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'NoChangeSinceLastCommit', selections____.vn),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'InvalidInput', selections____.vj)
			]));
};
var $author$project$BuildPlanner$Enum$MergeStrategy$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'Recursive';
		case 1:
			return 'RecursiveOverwriteOnConflict';
		case 2:
			return 'RecursiveKeepOnConflict';
		default:
			return 'FastForward';
	}
};
var $author$project$BuildPlanner$InputObject$encodeMergeUpstreamBranchInput = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'organization',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.c3))),
				_Utils_Tuple2(
				'project',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.c5))),
				_Utils_Tuple2(
				'targetBranch',
				$elm$core$Maybe$Just(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$string(input____.pU))),
				_Utils_Tuple2(
				'strategy',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.eO,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$BuildPlanner$Enum$MergeStrategy$toString)))
			]));
};
var $author$project$BuildPlanner$Mutation$mergeUpstreamBranch = F2(
	function (requiredArgs____, object____) {
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'mergeUpstreamBranch',
			_List_fromArray(
				[
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'input', requiredArgs____.$7, $author$project$BuildPlanner$InputObject$encodeMergeUpstreamBranchInput)
				]),
			object____,
			$elm$core$Basics$identity);
	});
var $author$project$Model$BuildPlanner$Error$FastForwardError$Data = function (message) {
	return {Eh: message};
};
var $author$project$Model$BuildPlanner$Error$FastForwardError$FastForwardError = $elm$core$Basics$identity;
var $author$project$BuildPlanner$Object$FastForwardError$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Model$BuildPlanner$Error$FastForwardError$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$elm$core$Basics$identity,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$FastForwardError$message,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$Error$FastForwardError$Data)));
var $author$project$Model$BuildPlanner$Error$MergeConflictError$Data = function (message) {
	return {Eh: message};
};
var $author$project$Model$BuildPlanner$Error$MergeConflictError$MergeConflictError = $elm$core$Basics$identity;
var $author$project$BuildPlanner$Object$MergeConflict$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Model$BuildPlanner$Error$MergeConflictError$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$elm$core$Basics$identity,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$MergeConflict$message,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$Error$MergeConflictError$Data)));
var $author$project$Model$BuildPlanner$Error$NoUpstreamBranchError$Data = function (message) {
	return {Eh: message};
};
var $author$project$Model$BuildPlanner$Error$NoUpstreamBranchError$NoUpstreamBranchError = $elm$core$Basics$identity;
var $author$project$BuildPlanner$Object$NoUpstreamBranch$message = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'message', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Model$BuildPlanner$Error$NoUpstreamBranchError$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$elm$core$Basics$identity,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$BuildPlanner$Object$NoUpstreamBranch$message,
		$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$BuildPlanner$Error$NoUpstreamBranchError$Data)));
var $author$project$Request$BuildPlanner$mergeUpstreamBranch = F2(
	function (creds, input) {
		var selectionSet = $author$project$BuildPlanner$Union$MergeUpstreamBranchResult$fragments(
			{
				va: A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Model$BuildPlanner$BuildPlannerError$FastForwardError),
					$author$project$Model$BuildPlanner$Error$FastForwardError$selectionSet),
				vc: A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Model$BuildPlanner$BuildPlannerError$ForbiddenError),
					$author$project$Model$BuildPlanner$Error$ForbiddenError$selectionSet),
				vf: A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Model$BuildPlanner$BuildPlannerError$HeadOnBranchMovedError),
					$author$project$Model$BuildPlanner$Error$HeadOnBranchMovedError$selectionSet),
				vj: A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Model$BuildPlanner$BuildPlannerError$InvalidInputError),
					$author$project$Model$BuildPlanner$Error$InvalidInputError$selectionSet),
				vk: A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Model$BuildPlanner$BuildPlannerError$MergeConflictError),
					$author$project$Model$BuildPlanner$Error$MergeConflictError$selectionSet),
				vl: $dillonkearns$elm_graphql$Graphql$SelectionSet$succeed(
					$elm$core$Result$Ok(0)),
				vn: A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Model$BuildPlanner$BuildPlannerError$NoChangesSinceLastCommitError),
					$author$project$Model$BuildPlanner$Error$NoChangesSinceLastCommitError$selectionSet),
				vo: A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Model$BuildPlanner$BuildPlannerError$NoUpstreamBranchError),
					$author$project$Model$BuildPlanner$Error$NoUpstreamBranchError$selectionSet),
				vp: A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Model$BuildPlanner$BuildPlannerError$NotFoundError),
					$author$project$Model$BuildPlanner$Error$NotFoundError$selectionSet),
				vq: A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Model$BuildPlanner$BuildPlannerError$ParseError),
					$author$project$Model$BuildPlanner$Error$ParseError$selectionSet),
				vC: A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					A2($elm$core$Basics$composeL, $elm$core$Result$Err, $author$project$Model$BuildPlanner$BuildPlannerError$ValidationError),
					$author$project$Model$BuildPlanner$Error$ValidationError$selectionSet)
			});
		return $author$project$Model$BuildPlanner$BuildPlannerError$simplifyTask(
			A5(
				$author$project$GraphQL$Utils$mutationRequest,
				creds,
				4,
				_List_Nil,
				'MergeUpstreamBranch',
				A2(
					$author$project$BuildPlanner$Mutation$mergeUpstreamBranch,
					{$7: input},
					selectionSet)));
	});
var $author$project$Views$UpdateForkModal$update = F2(
	function (model, event) {
		switch (event.$) {
			case 0:
				var tab = event.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						0,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{FX: tab}))));
			case 2:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						1,
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model)));
			case 3:
				var previewResult = event.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						0,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{su: previewResult}))));
			case 1:
				var strategy = function () {
					var _v1 = model.FX;
					if (!_v1) {
						return 2;
					} else {
						return 1;
					}
				}();
				var cmd = A2(
					$elm$core$Task$attempt,
					$author$project$Views$UpdateForkModal$OnMerge,
					A2(
						$author$project$Request$BuildPlanner$mergeUpstreamBranch,
						model.tu,
						{
							c3: model.E_,
							c5: $author$project$Model$Project$getName(model.c5),
							eO: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(strategy),
							pU: $author$project$Model$Branch$getName(model.h4)
						}));
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						0,
						A2($author$project$Misc$with, cmd, model)));
			default:
				var previewResult = event.a;
				if (!previewResult.$) {
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$textSuccess('Your project has been updated!')),
						A2(
							$author$project$Misc$with,
							2,
							A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model)));
				} else {
					var err = previewResult.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							0,
							A2(
								$author$project$Misc$with,
								$elm$core$Platform$Cmd$none,
								_Utils_update(
									model,
									{
										ye: $elm$core$Maybe$Just(
											$author$project$Model$BuildPlanner$BuildPlannerError$message(err))
									}))));
				}
		}
	});
var $elm_community$dict_extra$Dict$Extra$filterGroupBy = F2(
	function (keyfn, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					var _v0 = keyfn(x);
					if (!_v0.$) {
						var key = _v0.a;
						return A3(
							$elm$core$Dict$update,
							key,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$map(
									$elm$core$List$cons(x)),
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Maybe$withDefault(
										_List_fromArray(
											[x])),
									$elm$core$Maybe$Just)),
							acc);
					} else {
						return acc;
					}
				}),
			$elm$core$Dict$empty,
			list);
	});
var $author$project$Model$Branch$getTracks = function (_v0) {
	var branch = _v0;
	return branch.cq;
};
var $author$project$Model$BranchTree$fromBranches = function (branches) {
	var branchesByParent = A2(
		$elm_community$dict_extra$Dict$Extra$filterGroupBy,
		A2(
			$elm$core$Basics$composeR,
			$author$project$Model$Branch$getTracks,
			$elm$core$Maybe$map($danyx23$elm_uuid$Uuid$toString)),
		A2($elm$core$List$sortBy, $author$project$Model$Branch$getName, branches));
	var getChildrenOf = function (branch) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Dict$get,
				$danyx23$elm_uuid$Uuid$toString(
					$author$project$Model$Branch$getID(branch)),
				branchesByParent));
	};
	var buildTree = function (branch) {
		return A2(
			$zwilias$elm_rosetree$Tree$tree,
			branch,
			A2(
				$elm$core$List$map,
				buildTree,
				getChildrenOf(branch)));
	};
	return A2(
		$elm$core$Maybe$map,
		buildTree,
		A2($elm_community$list_extra$List$Extra$find, $author$project$Model$Branch$isDefault, branches));
};
var $author$project$Views$BranchPicker$updateFromProject = F2(
	function (project, model) {
		var branches = $author$project$Model$Project$getBranches(project);
		var selectedBranch = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Model$Project$getDefaultBranch(project),
			A2(
				$elm_community$list_extra$List$Extra$find,
				function (b) {
					return _Utils_eq(
						$author$project$Model$Branch$getName(b),
						$author$project$Model$Branch$getName(model.fR));
				},
				branches));
		return A2(
			$elm$core$Maybe$withDefault,
			model,
			A2(
				$elm$core$Maybe$map,
				function (tree) {
					return _Utils_update(
						model,
						{fR: selectedBranch, jA: tree});
				},
				$author$project$Model$BranchTree$fromBranches(branches)));
	});
var $author$project$Model$LanguageVersionTrustLevel$compare = F2(
	function (a, b) {
		var _v0 = _Utils_Tuple2(a, b);
		_v0$3:
		while (true) {
			_v0$4:
			while (true) {
				switch (_v0.a.$) {
					case 0:
						switch (_v0.b.$) {
							case 2:
								var _v1 = _v0.a;
								return 2;
							case 3:
								break _v0$3;
							default:
								break _v0$4;
						}
					case 2:
						switch (_v0.b.$) {
							case 0:
								var _v2 = _v0.b;
								return 0;
							case 3:
								break _v0$3;
							default:
								break _v0$4;
						}
					case 3:
						return 0;
					default:
						if (_v0.b.$ === 3) {
							break _v0$3;
						} else {
							break _v0$4;
						}
				}
			}
			return 1;
		}
		return 2;
	});
var $author$project$Views$LanguageVersionWarning$EndOfLife = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Views$LanguageVersionWarning$NewerRecommendedVersion = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Views$LanguageVersionWarning$NotRecommended = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Views$LanguageVersionWarning$NotSupported = {$: 4};
var $author$project$Views$LanguageVersionWarning$fromTrustLevel = F3(
	function (msg, language, trustLevel) {
		switch (trustLevel.$) {
			case 0:
				return $elm$core$Maybe$Nothing;
			case 2:
				var recommendedVersion = trustLevel.a;
				return $elm$core$Maybe$Just(
					A3($author$project$Views$LanguageVersionWarning$NotRecommended, language, recommendedVersion, msg));
			case 3:
				var version = trustLevel.a;
				return $elm$core$Maybe$Just(
					A3($author$project$Views$LanguageVersionWarning$EndOfLife, language, version, msg));
			case 1:
				var recommendedVersion = trustLevel.a;
				return $elm$core$Maybe$Just(
					A3($author$project$Views$LanguageVersionWarning$NewerRecommendedVersion, language, recommendedVersion, msg));
			default:
				return $elm$core$Maybe$Just($author$project$Views$LanguageVersionWarning$NotSupported);
		}
	});
var $author$project$Model$LanguageVersionTrustLevel$NotSupported = {$: 4};
var $author$project$Model$LanguageVersionTrustLevel$EndOfLife = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$LanguageVersionTrustLevel$NewerVersionAvailable = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$LanguageVersionTrustLevel$NotRecommended = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$LanguageVersionTrustLevel$Trusted = {$: 0};
var $author$project$Model$VersionString$compare = F2(
	function (versionA, versionB) {
		var compareIfEQ = F2(
			function (order, comparison) {
				if (order === 1) {
					return comparison(0);
				} else {
					return order;
				}
			});
		return A3(
			$elm$core$List$foldl,
			F2(
				function (b, a) {
					return A2(compareIfEQ, a, b);
				}),
			1,
			_List_fromArray(
				[
					function (_v0) {
					return A2($elm$core$Basics$compare, versionA.y5, versionB.y5);
				},
					function (_v1) {
					return A2($elm$core$Basics$compare, versionA.Ej, versionB.Ej);
				},
					function (_v2) {
					return A2($elm$core$Basics$compare, versionA.gw, versionB.gw);
				},
					function (_v3) {
					return A2(
						$elm$core$Maybe$withDefault,
						1,
						A3($elm$core$Maybe$map2, $elm$core$Basics$compare, versionA.A_, versionB.A_));
				}
				]));
	});
var $author$project$Model$VersionString$between = F2(
	function (_v0, version) {
		var upperLimit = _v0.a;
		var lowerLimit = _v0.b;
		var _v1 = _Utils_Tuple2(
			A2($author$project$Model$VersionString$compare, version, upperLimit),
			A2($author$project$Model$VersionString$compare, version, lowerLimit));
		_v1$1:
		while (true) {
			_v1$3:
			while (true) {
				switch (_v1.a) {
					case 1:
						var _v2 = _v1.a;
						return true;
					case 0:
						switch (_v1.b) {
							case 1:
								break _v1$1;
							case 2:
								var _v4 = _v1.a;
								var _v5 = _v1.b;
								return true;
							default:
								break _v1$3;
						}
					default:
						if (_v1.b === 1) {
							break _v1$1;
						} else {
							break _v1$3;
						}
				}
			}
			return false;
		}
		var _v3 = _v1.b;
		return true;
	});
var $author$project$Model$VersionString$eq = F2(
	function (a, b) {
		return A2($author$project$Model$VersionString$compare, a, b) === 1;
	});
var $author$project$Model$VersionString$lt = F2(
	function (a, b) {
		return !A2($author$project$Model$VersionString$compare, a, b);
	});
var $author$project$Model$LanguageVersionTrustLevel$getTrustLevel = F2(
	function (_v0, version) {
		var recommended = _v0.hO;
		var endOfLife = _v0.lO;
		return $author$project$Model$VersionString$isASPatched(
			$author$project$Model$VersionString$toString(version)) ? $author$project$Model$LanguageVersionTrustLevel$Trusted : (A2($author$project$Model$VersionString$between, endOfLife, version) ? $author$project$Model$LanguageVersionTrustLevel$EndOfLife(version) : (A2($author$project$Model$VersionString$lt, version, recommended) ? $author$project$Model$LanguageVersionTrustLevel$NewerVersionAvailable(recommended) : (A2(
			$elm$core$Basics$composeR,
			$author$project$Model$VersionString$eq(version),
			$elm$core$Basics$not)(recommended) ? $author$project$Model$LanguageVersionTrustLevel$NotRecommended(recommended) : $author$project$Model$LanguageVersionTrustLevel$Trusted)));
	});
var $author$project$Model$LanguageVersionTrustLevel$perl = $author$project$Model$LanguageVersionTrustLevel$getTrustLevel(
	{
		lO: _Utils_Tuple2(
			A3($author$project$Model$VersionString$new, 5, 32, 1),
			A3($author$project$Model$VersionString$new, 5, 8, 9)),
		hO: $author$project$Model$LanguageVersions$Perl$supportDict.hO
	});
var $author$project$Model$LanguageVersionTrustLevel$python = $author$project$Model$LanguageVersionTrustLevel$getTrustLevel(
	{
		lO: _Utils_Tuple2(
			A3($author$project$Model$VersionString$new, 3, 7, 17),
			A3($author$project$Model$VersionString$new, 3, 3, 0)),
		hO: $author$project$Model$LanguageVersions$Python$supportDict.hO
	});
var $author$project$Model$LanguageVersionTrustLevel$ruby = $author$project$Model$LanguageVersionTrustLevel$getTrustLevel(
	{
		lO: _Utils_Tuple2(
			A3($author$project$Model$VersionString$new, 2, 7, 8),
			A3($author$project$Model$VersionString$new, 2, 7, 5)),
		hO: $author$project$Model$LanguageVersions$Ruby$supportDict.hO
	});
var $author$project$Model$LanguageVersionTrustLevel$tcl = $author$project$Model$LanguageVersionTrustLevel$getTrustLevel(
	{
		lO: _Utils_Tuple2(
			A3($author$project$Model$VersionString$new, 8, 6, 11),
			A3($author$project$Model$VersionString$new, 8, 6, 10)),
		hO: $author$project$Model$LanguageVersions$Tcl$supportDict.hO
	});
var $author$project$Model$LanguageVersionTrustLevel$languageTrustLevelFn = function (language) {
	switch (language) {
		case 1:
			return $author$project$Model$LanguageVersionTrustLevel$python;
		case 3:
			return $author$project$Model$LanguageVersionTrustLevel$ruby;
		case 0:
			return $author$project$Model$LanguageVersionTrustLevel$perl;
		case 2:
			return $author$project$Model$LanguageVersionTrustLevel$tcl;
		default:
			return $elm$core$Basics$always($author$project$Model$LanguageVersionTrustLevel$NotSupported);
	}
};
var $author$project$Model$LanguageVersionTrustLevel$get = F2(
	function (selectedVersion, language) {
		return function (fn) {
			return fn(selectedVersion);
		}(
			$author$project$Model$LanguageVersionTrustLevel$languageTrustLevelFn(language));
	});
var $elm_community$list_extra$List$Extra$foldl1 = F2(
	function (func, list) {
		if (!list.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var x = list.a;
			var xs = list.b;
			return $elm$core$Maybe$Just(
				A3($elm$core$List$foldl, func, x, xs));
		}
	});
var $elm_community$list_extra$List$Extra$minimumWith = F2(
	function (comparator, list) {
		return A2(
			$elm_community$list_extra$List$Extra$foldl1,
			F2(
				function (x, y) {
					var _v0 = A2(comparator, x, y);
					if (!_v0) {
						return x;
					} else {
						return y;
					}
				}),
			list);
	});
var $author$project$Views$LanguageVersionWarning$warningKind = F2(
	function (msg, languages) {
		return A2(
			$elm$core$Maybe$andThen,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Maybe$map,
				$elm_community$basics_extra$Basics$Extra$uncurry(
					$author$project$Views$LanguageVersionWarning$fromTrustLevel(msg)),
				A2(
					$elm_community$list_extra$List$Extra$minimumWith,
					F2(
						function (_v1, _v2) {
							var v1 = _v1.b;
							var v2 = _v2.b;
							return A2($author$project$Model$LanguageVersionTrustLevel$compare, v1, v2);
						}),
					A2(
						$elm$core$List$map,
						function (_v0) {
							var language = _v0.a;
							var version = _v0.b;
							return _Utils_Tuple2(
								language,
								A2($author$project$Model$LanguageVersionTrustLevel$get, version, language));
						},
						languages))));
	});
var $author$project$Pages$ProjectConfig$innerUpdate = F3(
	function (session, msg, model) {
		var setEditorAndSyncPackageVersionSelectorModels = F2(
			function (newModel, editor) {
				var accumPackageVersionSelectorModels = F2(
					function (item, acc) {
						var updateConstraint = function (selectorModel) {
							return _Utils_update(
								selectorModel,
								{jw: item.kH.bK});
						};
						return A3(
							$elm$core$Dict$update,
							item.kH.Y,
							$elm$core$Maybe$map(updateConstraint),
							acc);
					});
				var newSelectorModels = A3(
					$elm$core$List$foldl,
					accumPackageVersionSelectorModels,
					model.hb,
					_Utils_ap(
						$author$project$Model$BuildPlanner$SolveLegacyEditor$getBundleItems(editor),
						_Utils_ap(
							$author$project$Model$BuildPlanner$SolveLegacyEditor$getPackageItems(editor),
							$author$project$Model$BuildPlanner$SolveLegacyEditor$getHiddenItems(editor))));
				return _Utils_update(
					newModel,
					{qR: editor, hb: newSelectorModels});
			});
		var setAllAuto = function (newModel) {
			return A2(
				setEditorAndSyncPackageVersionSelectorModels,
				newModel,
				$author$project$Model$BuildExprEditorUtils$setAllAuto(newModel.qR));
		};
		var removeVersionSelectorModel = F2(
			function (key, newModel) {
				return _Utils_update(
					newModel,
					{
						hb: A2($elm$core$Dict$remove, key, newModel.hb)
					});
			});
		var insertSelectorModel = F2(
			function (selectorModel, newModel) {
				return _Utils_update(
					newModel,
					{
						hb: A3(
							$elm$core$Dict$insert,
							$author$project$Views$PackageVersionSelector$getKey(selectorModel),
							selectorModel,
							newModel.hb)
					});
			});
		var doUpsert = F3(
			function (description, requirement, newModel) {
				var key = requirement.Y;
				var func = function () {
					var _v90 = $author$project$Model$Namespace$kind(key);
					switch (_v90) {
						case 0:
							return $author$project$Model$BuildPlanner$SolveLegacyEditor$addBundle;
						case 5:
							return $author$project$Model$BuildPlanner$SolveLegacyEditor$addPackage;
						case 3:
							return $author$project$Model$BuildPlanner$SolveLegacyEditor$addHidden;
						default:
							return F2(
								function (_v91, _v92) {
									return $elm$core$Basics$identity;
								});
					}
				}();
				var eventArgs = A2(
					$author$project$Model$Analytics$withLabel,
					A2($author$project$Model$BuildExprEditorUtils$getAnalyticsLabel, key, requirement.bK),
					A2(
						$author$project$Model$Analytics$withAction,
						description,
						A2(
							$author$project$Model$Analytics$withCategory,
							$author$project$Model$Analytics$categoryConfiguration,
							$author$project$Model$Analytics$newEvent(description))));
				return A2(
					$author$project$Misc$with,
					$author$project$Ports$sendAnalyticsEvent(eventArgs),
					_Utils_update(
						newModel,
						{
							qR: A3(func, key, requirement.bK, newModel.qR)
						}));
			});
		var creds = $author$project$Model$Session$getCreds(session);
		switch (msg.$) {
			case 17:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
			case 10:
				var innerMsg = msg.a;
				var _v1 = A4($author$project$Views$Dependencies$update, innerMsg, model.qO, model, $author$project$Pages$ProjectConfig$generatePackageIdFromKey);
				var _v2 = _v1.a;
				var newInnerModel = _v2.a;
				var innerCmd = _v2.b;
				var newModel = _v1.b;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$ProjectConfig$DependenciesMsg, innerCmd),
						_Utils_update(
							newModel,
							{qO: newInnerModel})));
			case 43:
				var solveErrorNoticeMsg = msg.a;
				var _v3 = A2($author$project$Views$PlanningErrorNotice$update, solveErrorNoticeMsg, model.ss);
				var newSolveErrorNoticeModel = _v3.a;
				var newMsg = _v3.b;
				var _v4 = function () {
					if (newMsg.$ === 1) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						switch (newMsg.a.$) {
							case 0:
								var platformID = newMsg.a.a;
								var eventArgs = A2(
									$author$project$Model$Analytics$withLabel,
									platformID,
									A2(
										$author$project$Model$Analytics$withAction,
										'Remediated order - platform removed',
										A2(
											$author$project$Model$Analytics$withCategory,
											$author$project$Model$Analytics$categoryConfiguration,
											$author$project$Model$Analytics$newEvent('Remediated order - platform removed'))));
								return A2(
									$author$project$Misc$with,
									$author$project$Ports$sendAnalyticsEvent(eventArgs),
									_Utils_update(
										model,
										{
											qR: A2(
												$author$project$Model$BuildPlanner$SolveLegacyEditor$removePackagersForPlatform,
												platformID,
												A2($author$project$Model$BuildPlanner$SolveLegacyEditor$removePlatform, platformID, model.qR))
										}));
							case 1:
								var namespaceKey = newMsg.a.a;
								var func = function () {
									var _v6 = $author$project$Model$Namespace$kind(namespaceKey);
									switch (_v6) {
										case 0:
											return $author$project$Model$BuildPlanner$SolveLegacyEditor$removeBundle;
										case 5:
											return $author$project$Model$BuildPlanner$SolveLegacyEditor$removePackage;
										case 3:
											return $author$project$Model$BuildPlanner$SolveLegacyEditor$removeHidden;
										default:
											return function (_v7) {
												return $elm$core$Basics$identity;
											};
									}
								}();
								var eventArgs = A2(
									$author$project$Model$Analytics$withLabel,
									A2($author$project$Model$BuildExprEditorUtils$getAnalyticsLabel, namespaceKey, $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$Auto),
									A2(
										$author$project$Model$Analytics$withAction,
										'Remediated order - item removed',
										A2(
											$author$project$Model$Analytics$withCategory,
											$author$project$Model$Analytics$categoryConfiguration,
											$author$project$Model$Analytics$newEvent('Remediated order - item removed'))));
								return A2(
									$author$project$Misc$with,
									$author$project$Ports$sendAnalyticsEvent(eventArgs),
									_Utils_update(
										model,
										{
											qR: A2(func, namespaceKey, model.qR)
										}));
							case 2:
								var _v8 = newMsg.a;
								var eventArgs = A2(
									$author$project$Model$Analytics$withAction,
									'Remediated order - set all packages to auto',
									A2(
										$author$project$Model$Analytics$withCategory,
										$author$project$Model$Analytics$categoryConfiguration,
										$author$project$Model$Analytics$newEvent('Remediated order - set all packages to auto')));
								return A2(
									$author$project$Misc$with,
									$author$project$Ports$sendAnalyticsEvent(eventArgs),
									setAllAuto(model));
							default:
								var _v9 = newMsg.a;
								return A2(
									$author$project$Misc$with,
									$elm$core$Platform$Cmd$none,
									_Utils_update(
										model,
										{
											qR: A3(
												$author$project$Model$BuildPlanner$SolveLegacyEditor$setTimestamp,
												true,
												$elm$core$Maybe$Just(model.pq),
												model.qR)
										}));
						}
					}
				}();
				var newModel = _v4.a;
				var newCmd = _v4.b;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						newCmd,
						_Utils_update(
							newModel,
							{ss: newSolveErrorNoticeModel})));
			case 26:
				var defaultInnerModel = msg.a;
				var innerMsg = msg.b;
				var key = $author$project$Views$PackageVersionSelector$getKey(defaultInnerModel);
				var innerModel = A2(
					$elm$core$Maybe$withDefault,
					defaultInnerModel,
					A2($elm$core$Dict$get, key, model.hb));
				var _v10 = A5(
					$author$project$Views$PackageVersionSelector$update,
					$author$project$Views$PackageVersionSelector$toRollbar($author$project$Pages$ProjectConfig$rollbar),
					session,
					innerMsg,
					innerModel,
					model);
				var _v11 = _v10.a;
				var _v12 = _v11.a;
				var _v13 = _v12.a;
				var newInnerModel = _v13.a;
				var innerCmd = _v13.b;
				var innerExternalMsg = _v12.b;
				var external = _v11.b;
				var newInnerParentModel = _v10.b;
				var newModel = A2(insertSelectorModel, newInnerModel, newInnerParentModel);
				if (!innerExternalMsg.$) {
					var newConstraint = innerExternalMsg.a;
					var _v15 = A3(
						doUpsert,
						'version changed ',
						A2($author$project$Model$BuildPlanner$BuildExpr$Solve$Requirement$KeyAndConstraint, key, newConstraint),
						newModel);
					var finalModel = _v15.a;
					var finalCmd = _v15.b;
					return A2(
						$author$project$Misc$with,
						external,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										finalCmd,
										A2(
										$elm$core$Platform$Cmd$map,
										$author$project$Pages$ProjectConfig$PackageVersionSelectorMsg(newInnerModel),
										innerCmd)
									])),
							finalModel));
				} else {
					return A2(
						$author$project$Misc$with,
						external,
						A2(
							$author$project$Misc$with,
							A2(
								$elm$core$Platform$Cmd$map,
								$author$project$Pages$ProjectConfig$PackageVersionSelectorMsg(newInnerModel),
								innerCmd),
							newModel));
				}
			case 12:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{ul: true})));
			case 39:
				var markerKindString = msg.a;
				var _v16 = $author$project$Model$BuildPlanner$BuildExpr$MarkerKind$fromString(markerKindString);
				if (_v16.$ === 1) {
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
				} else {
					var markerKind = _v16.a;
					var func = function (editor) {
						switch (markerKind) {
							case 0:
								return A2(
									$author$project$Model$BuildPlanner$BuildExprEditor$Simple$setCamel,
									$author$project$Model$Editor$init(
										{Bn: $elm$core$Set$empty}),
									editor);
							case 1:
								return A2(
									$author$project$Model$BuildPlanner$BuildExprEditor$Simple$setStateToolArtifactsV1,
									$author$project$Model$Editor$init(
										{
											xs: $author$project$Model$BuildPlanner$BuildExprEditor$Simple$getBuildFlagsDict(editor)
										}),
									editor);
							case 2:
								return A3(
									$author$project$Model$BuildPlanner$BuildExprEditor$Simple$setStateToolArtifacts,
									$elm$core$Basics$always(0),
									$author$project$Model$Editor$init(
										{
											xs: $author$project$Model$BuildPlanner$BuildExprEditor$Simple$getBuildFlagsDict(editor)
										}),
									editor);
							case 3:
								return A2(
									$author$project$Model$BuildPlanner$BuildExprEditor$Simple$setCommunityArtifacts,
									$author$project$Model$Editor$init(
										{
											xs: $author$project$Model$BuildPlanner$BuildExprEditor$Simple$getBuildFlagsDict(editor)
										}),
									editor);
							default:
								return A2(
									$author$project$Model$BuildPlanner$BuildExprEditor$Simple$setWheelArtifacts,
									$author$project$Model$Editor$init(
										{
											xs: $author$project$Model$BuildPlanner$BuildExprEditor$Simple$getBuildFlagsDict(editor)
										}),
									editor);
						}
					};
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{
									qR: func(model.qR)
								})));
				}
			case 40:
				var versionStr = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								qR: A2(
									$author$project$Model$BuildPlanner$SolveLegacyEditor$setSolverVersion,
									$elm$core$String$toInt(versionStr),
									model.qR)
							})));
			case 34:
				var camelFlag = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								qR: A2($author$project$Model$BuildPlanner$SolveLegacyEditor$revertCamelFlag, camelFlag, model.qR)
							})));
			case 30:
				var camelFlag = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								qR: A2($author$project$Model$BuildPlanner$SolveLegacyEditor$removeCamelFlag, camelFlag, model.qR)
							})));
			case 33:
				var buildFlag = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								qR: A2($author$project$Model$BuildPlanner$SolveLegacyEditor$revertBuildFlag, buildFlag, model.qR)
							})));
			case 29:
				var buildFlag = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								qR: A2($author$project$Model$BuildPlanner$SolveLegacyEditor$removeBuildFlag, buildFlag, model.qR)
							})));
			case 28:
				var key = msg.a;
				var constraint = msg.b;
				var func = function () {
					var _v18 = $author$project$Model$Namespace$kindFromString(
						$author$project$Model$Namespace$getNamespace(key));
					switch (_v18) {
						case 0:
							return $author$project$Model$BuildPlanner$SolveLegacyEditor$removeBundle(key);
						case 5:
							return $author$project$Model$BuildPlanner$SolveLegacyEditor$removePackage(key);
						case 4:
							return $author$project$Model$BuildPlanner$SolveLegacyEditor$removeLanguage(
								$author$project$Model$Namespace$getName(key));
						case 3:
							return $author$project$Model$BuildPlanner$SolveLegacyEditor$removeHidden(key);
						default:
							return $elm$core$Basics$identity;
					}
				}();
				var eventArgs = A2(
					$author$project$Model$Analytics$withLabel,
					A2($author$project$Model$BuildExprEditorUtils$getAnalyticsLabel, key, constraint),
					A2(
						$author$project$Model$Analytics$withAction,
						'Edited order - item removed',
						A2(
							$author$project$Model$Analytics$withCategory,
							$author$project$Model$Analytics$categoryConfiguration,
							$author$project$Model$Analytics$newEvent('Edited order - item removed'))));
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$author$project$Ports$sendAnalyticsEvent(eventArgs),
						_Utils_update(
							model,
							{
								qR: func(model.qR)
							})));
			case 45:
				var key = msg.a;
				var namespace = key.a;
				var name = key.b;
				var func = function () {
					var _v19 = $author$project$Model$Namespace$kindFromString(namespace);
					switch (_v19) {
						case 0:
							return $author$project$Model$BuildPlanner$SolveLegacyEditor$revertBundle(key);
						case 5:
							return $author$project$Model$BuildPlanner$SolveLegacyEditor$revertPackage(key);
						case 4:
							return $author$project$Model$BuildPlanner$SolveLegacyEditor$revertLanguage(name);
						case 3:
							return $author$project$Model$BuildPlanner$SolveLegacyEditor$revertHidden(key);
						default:
							return $elm$core$Basics$identity;
					}
				}();
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						A2(
							removeVersionSelectorModel,
							key,
							_Utils_update(
								model,
								{
									qR: func(model.qR)
								}))));
			case 16:
				var modal = msg.a;
				var _v20 = function () {
					switch (modal) {
						case 0:
							var selectedLanguage = $elm$core$List$head(
								$author$project$Model$BuildPlanner$SolveLegacyEditor$getAllLanguages(model.qR));
							var addPackagesModel = A2($author$project$Views$AddPackagesModal$init, selectedLanguage, model.qR);
							var nModel = _Utils_update(
								model,
								{iM: addPackagesModel});
							var _v22 = A2($author$project$Model$PopularPackages$loadPopularPackages, session, nModel.m6);
							var newPopularPackagesModel = _v22.a;
							var popularPackagesCmd = _v22.b;
							return A2(
								$author$project$Misc$with,
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2(
											$elm$core$Task$attempt,
											$elm$core$Basics$always($author$project$Pages$ProjectConfig$NoOp),
											$elm$browser$Browser$Dom$focus($author$project$Views$AddPackagesModal$initialFocusID)),
											A2($elm$core$Platform$Cmd$map, $author$project$Pages$ProjectConfig$PopularPackagesMsg, popularPackagesCmd)
										])),
								_Utils_update(
									nModel,
									{
										iM: A2($author$project$Views$AddPackagesModal$resetState, nModel.qR, nModel.iM),
										m6: newPopularPackagesModel
									}));
						case 1:
							return A2(
								$author$project$Misc$with,
								A2(
									$elm$core$Task$attempt,
									$elm$core$Basics$always($author$project$Pages$ProjectConfig$NoOp),
									$elm$browser$Browser$Dom$focus($author$project$Views$ImportPackagesModal$initialFocusID)),
								_Utils_update(
									model,
									{
										oJ: $author$project$Views$ImportPackagesModal$init(model.qR)
									}));
						case 2:
							return A2(
								$author$project$Misc$with,
								$elm$core$Platform$Cmd$none,
								_Utils_update(
									model,
									{
										oX: $author$project$Views$LanguageSelectionModal$init(model.qR)
									}));
						default:
							return A2(
								$author$project$Misc$with,
								$elm$core$Platform$Cmd$none,
								_Utils_update(
									model,
									{
										pp: A2($author$project$Views$PlatformSelectionModal$init, model.n4, model.qR)
									}));
					}
				}();
				var newModel = _v20.a;
				var cmd = _v20.b;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						cmd,
						_Utils_update(
							newModel,
							{
								yo: false,
								hj: $author$project$Pages$ProjectConfig$Open(modal)
							})));
			case 32:
				var newModel = _Utils_update(
					model,
					{sl: false});
				var eventArgs = A2(
					$author$project$Model$Analytics$withValue,
					$author$project$Pages$ProjectConfig$getChangeCount(model),
					A2(
						$author$project$Model$Analytics$withAction,
						'Commit discarded',
						A2(
							$author$project$Model$Analytics$withCategory,
							$author$project$Model$Analytics$categoryConfiguration,
							$author$project$Model$Analytics$newEvent('Commit discarded'))));
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$author$project$Ports$sendAnalyticsEvent(eventArgs),
						$author$project$Pages$ProjectConfig$resetOrder(newModel)));
			case 35:
				var key = msg.a;
				var tab = msg.b;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								qb: A3($elm$core$Dict$insert, key, tab, model.qb)
							})));
			case 36:
				var eventArgs = A2(
					$author$project$Model$Analytics$withAction,
					'Edited order - set all packages to auto',
					A2(
						$author$project$Model$Analytics$withCategory,
						$author$project$Model$Analytics$categoryConfiguration,
						$author$project$Model$Analytics$newEvent('Edited order - set all packages to auto')));
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$author$project$Ports$sendAnalyticsEvent(eventArgs),
						setAllAuto(model)));
			case 37:
				var versionStringsByKey = msg.a;
				var outcome = A2($author$project$Model$BuildExprEditorUtils$setAllExact, versionStringsByKey, model.qR);
				var external = function () {
					if ($elm$core$List$isEmpty(outcome.rx)) {
						return $author$project$External$NoOp;
					} else {
						var packages = A2(
							$elm$core$String$join,
							', ',
							A2($elm$core$List$map, $author$project$Model$Namespace$getName, outcome.rx));
						return $author$project$External$AddNotification(
							$author$project$Model$Notification$textWarning('Could not pin the following packages: ' + packages));
					}
				}();
				var eventArgs = A2(
					$author$project$Model$Analytics$withAction,
					'Edited order - set all packages to pinned',
					A2(
						$author$project$Model$Analytics$withCategory,
						$author$project$Model$Analytics$categoryConfiguration,
						$author$project$Model$Analytics$newEvent('Edited order - set all packages to pinned')));
				return A2(
					$author$project$Misc$with,
					external,
					A2(
						$author$project$Misc$with,
						$author$project$Ports$sendAnalyticsEvent(eventArgs),
						A2(setEditorAndSyncPackageVersionSelectorModels, model, outcome.qR)));
			case 38:
				var warningKind = A2(
					$author$project$Views$LanguageVersionWarning$warningKind,
					$elm$core$Maybe$Nothing,
					$elm_community$maybe_extra$Maybe$Extra$values(
						A2(
							$elm$core$List$map,
							$author$project$Views$LanguageVersionWarning$fromLanguageItem(
								$author$project$Model$BuildDataSource$latest(model)),
							$author$project$Model$BuildPlanner$SolveLegacyEditor$getLanguageItems(model.qR))));
				var newData = function () {
					if ((!warningKind.$) && (warningKind.a.$ === 2)) {
						var _v24 = warningKind.a;
						var language = _v24.a;
						var version = _v24.b;
						var newVersion = $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$Exact(
							$author$project$Model$VersionString$toString(version));
						var languageStr = $author$project$Model$Language$toString(language);
						var oldLanguageConstraint = A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								$author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$getHumanReadableString,
								A2(
									$elm$core$Dict$get,
									languageStr,
									$author$project$Model$BuildPlanner$SolveLegacyEditor$getLanguages(model.qR))));
						var languageDisplayStr = $author$project$Model$Language$toDisplayString(language);
						return _Utils_Tuple2(
							A3($author$project$Model$BuildPlanner$SolveLegacyEditor$addLanguage, languageStr, newVersion, model.qR),
							'Upgrading from ' + (languageDisplayStr + (' ' + (oldLanguageConstraint + (' to ' + (languageDisplayStr + (' ' + $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$getHumanReadableString(newVersion))))))));
					} else {
						return _Utils_Tuple2(model.qR, '');
					}
				}();
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{hq: newData.b, qR: newData.a})));
			case 3:
				var gotoBuildTabAfterCommitSuccess = msg.a;
				var cmd = A2(
					$elm$core$Task$attempt,
					$author$project$Pages$ProjectConfig$OnCommitSaved(gotoBuildTabAfterCommitSuccess),
					A3(
						$elm$core$Task$map2,
						$elm$core$Tuple$pair,
						A2($author$project$Pages$ProjectConfig$pushCommitTask, session, model),
						A2(
							$elm$core$Task$mapError,
							$author$project$Model$BuildPlanner$BuildPlannerError$HttpError,
							A3(
								$author$project$Request$Project$get,
								creds,
								$author$project$Model$Organization$getUrlName(model.c3),
								$author$project$Model$Project$getName(model.c5)))));
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						cmd,
						_Utils_update(
							model,
							{hQ: true})));
			case 22:
				if (!msg.b.$) {
					var gotoBuildTabAfterCommitSuccess = msg.a;
					var _v25 = msg.b.a;
					var commit = _v25.a;
					var project = _v25.b;
					var newTimestampKind = $author$project$Model$AtTime$Standard;
					var commitDescriptionIndicator = $elm$core$String$isEmpty(model.hq) ? 'Description not provided' : 'Description provided';
					var sendAnalyticsEventCmd = $author$project$Ports$sendAnalyticsEvent(
						A2(
							$author$project$Model$Analytics$withValue,
							$author$project$Pages$ProjectConfig$getChangeCount(model),
							A2(
								$author$project$Model$Analytics$withLabel,
								commitDescriptionIndicator,
								A2(
									$author$project$Model$Analytics$withAction,
									'Commit saved',
									A2(
										$author$project$Model$Analytics$withCategory,
										$author$project$Model$Analytics$categoryConfiguration,
										$author$project$Model$Analytics$newEvent('Commit saved'))))));
					var bothSolvesSucceed = function () {
						var _v26 = _Utils_Tuple2(model.Cu, model.Ep);
						if ((_v26.a.$ === 3) && (_v26.b.$ === 3)) {
							return true;
						} else {
							return false;
						}
					}();
					if (gotoBuildTabAfterCommitSuccess) {
						var branch = $author$project$Pages$ProjectConfig$getCurrentBranch(model);
						var gotoCmd = A2(
							$author$project$Routing$replaceUrl,
							model.Y,
							$author$project$Model$Route$projectDownloads(
								{
									uk: false,
									fO: (!$author$project$Model$Branch$isDefault(branch)) ? $elm$core$Maybe$Just(
										$author$project$Model$Branch$getName(branch)) : $elm$core$Maybe$Nothing,
									gr: $elm$core$Maybe$Nothing,
									Ef: $elm$core$Maybe$Nothing,
									ix: model.c3.AC,
									vT: $author$project$Model$Project$getName(model.c5)
								}));
						return A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2(
								$author$project$Misc$with,
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[gotoCmd, sendAnalyticsEventCmd])),
								_Utils_update(
									model,
									{hQ: gotoBuildTabAfterCommitSuccess, iK: newTimestampKind})));
					} else {
						var nextEditor = $author$project$Model$Editor$commit(model.qR);
						var nextBranchMenuModel = A2(
							$elm$core$Maybe$map,
							$author$project$Views$BranchPicker$updateFromProject(project),
							model.fJ);
						var nextModel = _Utils_update(
							model,
							{
								fJ: nextBranchMenuModel,
								f0: commit,
								qR: nextEditor,
								Cu: $krisajenkins$remotedata$RemoteData$Loading,
								Ep: $krisajenkins$remotedata$RemoteData$NotAsked,
								c5: project,
								hQ: false,
								hX: $author$project$Views$Timestamp$reset(model.hX)
							});
						var cmd = $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Ports$removeUrlParameter('commitID'),
									sendAnalyticsEventCmd,
									A2($author$project$Pages$ProjectConfig$softRefreshCmd, session, nextModel)
								]));
						return A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2(
								$author$project$Misc$with,
								cmd,
								_Utils_update(
									nextModel,
									{sl: bothSolvesSucceed, iK: newTimestampKind})));
					}
				} else {
					if (!msg.b.a.$) {
						var err = msg.b.a.a;
						return A2(
							$author$project$Misc$with,
							$author$project$External$AddNotification(
								$author$project$Model$Notification$fromError(err)),
							A2(
								$author$project$Misc$with,
								A3($author$project$Pages$ProjectConfig$rollbar.FZ, 'OnCommitSaved _ (Err (HttpError err))', err, session),
								_Utils_update(
									model,
									{hQ: false})));
					} else {
						var err = msg.b.a;
						var message = $author$project$Pages$ProjectConfig$getSimplifiedErrorMessage(err);
						return A2(
							$author$project$Misc$with,
							$author$project$External$AddNotification(
								$author$project$Model$Notification$textWarning(message)),
							A2(
								$author$project$Misc$with,
								A2($author$project$Pages$ProjectConfig$rollbar.sk, message, session),
								_Utils_update(
									model,
									{hQ: false})));
					}
				}
			case 13:
				var innerMsg = msg.a;
				var _v27 = A4($author$project$Views$ImportPackagesModal$update, session, innerMsg, model.oJ, model);
				var _v28 = _v27.a;
				var _v29 = _v28.a;
				var _v30 = _v29.a;
				var newInnerModel = _v30.a;
				var innerCmd = _v30.b;
				var innerExternalMsg = _v29.b;
				var external = _v28.b;
				var newInnerParentModel = _v27.b;
				var newModel = _Utils_update(
					newInnerParentModel,
					{oJ: newInnerModel});
				var finalModel = function () {
					if (!innerExternalMsg) {
						return newModel;
					} else {
						return _Utils_update(
							newModel,
							{hj: $author$project$Pages$ProjectConfig$None});
					}
				}();
				return A2(
					$author$project$Misc$with,
					external,
					A2(
						$author$project$Misc$with,
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$ProjectConfig$ImportPackagesModalMsg, innerCmd),
						finalModel));
			case 6:
				var commentString = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								hq: A2($elm$core$String$left, $author$project$Pages$ProjectConfig$maximumCommentLength, commentString)
							})));
			case 0:
				var innerMsg = msg.a;
				var _v32 = A4($author$project$Views$AddPackagesModal$update, session, innerMsg, model.iM, model);
				var _v33 = _v32.a;
				var _v34 = _v33.a;
				var _v35 = _v34.a;
				var newInnerModel = _v35.a;
				var innerCmd = _v35.b;
				var innerExternalMsg = _v34.b;
				var external = _v33.b;
				var newInnerParentModel = _v32.b;
				var newModel = _Utils_update(
					newInnerParentModel,
					{iM: newInnerModel});
				var finalModel = function () {
					switch (innerExternalMsg) {
						case 0:
							return newModel;
						case 1:
							return _Utils_update(
								newModel,
								{hj: $author$project$Pages$ProjectConfig$None});
						default:
							return _Utils_update(
								newModel,
								{
									hj: $author$project$Pages$ProjectConfig$Open(1)
								});
					}
				}();
				return A2(
					$author$project$Misc$with,
					external,
					A2(
						$author$project$Misc$with,
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$ProjectConfig$AddPackagesModalMsg, innerCmd),
						finalModel));
			case 1:
				var innerMsg = msg.a;
				var _v37 = A3($author$project$Views$LanguageSelectionModal$update, innerMsg, model.oX, model);
				var _v38 = _v37.a;
				var _v39 = _v38.a;
				var newInnerModel = _v39.a;
				var innerCmd = _v39.b;
				var innerExternalMsg = _v38.b;
				var newInnerParentModel = _v37.b;
				var newModel = _Utils_update(
					newInnerParentModel,
					{oX: newInnerModel});
				var finalModel = function () {
					if (!innerExternalMsg) {
						return newModel;
					} else {
						return _Utils_update(
							newModel,
							{hj: $author$project$Pages$ProjectConfig$None});
					}
				}();
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$ProjectConfig$LanguageSelectionModalMsg, innerCmd),
						finalModel));
			case 2:
				var innerMsg = msg.a;
				var _v41 = A3($author$project$Views$PlatformSelectionModal$update, innerMsg, model.pp, model);
				var _v42 = _v41.a;
				var _v43 = _v42.a;
				var newInnerModel = _v43.a;
				var innerCmd = _v43.b;
				var innerExternalMsg = _v42.b;
				var newInnerParentModel = _v41.b;
				var newModel = _Utils_update(
					newInnerParentModel,
					{pp: newInnerModel});
				var finalModel = function () {
					if (!innerExternalMsg) {
						return newModel;
					} else {
						return _Utils_update(
							newModel,
							{hj: $author$project$Pages$ProjectConfig$None});
					}
				}();
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$ProjectConfig$PlatformSelectionModalMsg, innerCmd),
						finalModel));
			case 9:
				var innerMsg = msg.a;
				var _v45 = A5(
					$author$project$Views$CustomRequirementInput$update,
					$author$project$Views$CustomRequirementInput$toRollbar($author$project$Pages$ProjectConfig$rollbar),
					session,
					innerMsg,
					model.on,
					model);
				var _v46 = _v45.a;
				var _v47 = _v46.a;
				var newInnerModel = _v47.a;
				var innerCmd = _v47.b;
				var external = _v46.b;
				var newModel = _v45.b;
				return A2(
					$author$project$Misc$with,
					external,
					A2(
						$author$project$Misc$with,
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$ProjectConfig$CustomRequirementInputMsg, innerCmd),
						_Utils_update(
							newModel,
							{on: newInnerModel})));
			case 27:
				var popularPackagesMsg = msg.a;
				var _v48 = A5(
					$author$project$Model$PopularPackages$update,
					$author$project$Model$PopularPackages$toRollbar($author$project$Pages$ProjectConfig$rollbar),
					session,
					popularPackagesMsg,
					model.m6,
					model);
				var _v49 = _v48.a;
				var _v50 = _v49.a;
				var newPopularPackagesModel = _v50.a;
				var popularPackagesCmd = _v50.b;
				var external = _v49.b;
				var newModel = _v48.b;
				return A2(
					$author$project$Misc$with,
					external,
					A2(
						$author$project$Misc$with,
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$ProjectConfig$PopularPackagesMsg, popularPackagesCmd),
						_Utils_update(
							newModel,
							{m6: newPopularPackagesModel})));
			case 44:
				var timestampMsg = msg.a;
				var _v51 = A3($author$project$Views$Timestamp$update, timestampMsg, model.hX, model);
				var _v52 = _v51.a;
				var newTimestampModel = _v52.a;
				var timestampCmd = _v52.b;
				var newModel = _v51.b;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$ProjectConfig$TimestampMsg, timestampCmd),
						_Utils_update(
							newModel,
							{hX: newTimestampModel})));
			case 20:
				var type_ = msg.a;
				var oldEditor = msg.b;
				var result = msg.c;
				var resultDataSource = A2($elm$core$Result$map, $author$project$Model$BuildDataSource$init, result);
				var editorChanges = $author$project$Model$BuildPlanner$SolveLegacyEditor$getChangesComparedTo(
					{rC: model.qR, zu: oldEditor});
				var buildData = $krisajenkins$remotedata$RemoteData$fromResult(resultDataSource);
				var externalMsg = function () {
					var _v62 = _Utils_Tuple2(type_, buildData);
					if ((_v62.a === 1) && (_v62.b.$ === 3)) {
						var _v63 = _v62.a;
						var buildDataSource = _v62.b.a;
						return A2(
							$author$project$External$AddBuildPlan,
							{
								BR: $author$project$Model$Commit$getCommitID(model.f0),
								ix: $author$project$Model$Organization$getUrlName(model.c3),
								vT: $author$project$Model$Project$getName(model.c5)
							},
							$author$project$Model$BuildDataSource$getBuildPlan(buildDataSource));
					} else {
						return $author$project$External$NoOp;
					}
				}();
				var newModel = function () {
					switch (type_) {
						case 0:
							return (editorChanges === 1) ? $author$project$Pages$ProjectConfig$resetOrder(model) : _Utils_update(
								model,
								{
									iQ: A2($author$project$Model$BuildDataSource$getBuildDataSourceEditor, model.Cu, buildData),
									Ep: buildData
								});
						case 1:
							var isImageComponentsOpen = function () {
								if (buildData.$ === 3) {
									var data = buildData.a;
									var _v61 = $author$project$Model$BuildDataSource$getScannedImages(data);
									if (_v61.b && (!_v61.b.b)) {
										var image = _v61.a;
										return $author$project$Views$ScannedImage$toggleOpen(image);
									} else {
										return $elm$core$Basics$identity;
									}
								} else {
									return $elm$core$Basics$identity;
								}
							}();
							return _Utils_update(
								model,
								{
									iQ: A2($author$project$Model$BuildDataSource$getBuildDataSourceEditor, buildData, model.Ep),
									Cu: buildData,
									mk: isImageComponentsOpen(model.mk)
								});
						case 2:
							return (editorChanges === 1) ? $author$project$Pages$ProjectConfig$resetOrder(model) : _Utils_update(
								model,
								{
									iQ: A2($author$project$Model$BuildDataSource$getBuildDataSourceEditor, model.Cu, buildData),
									Ep: buildData,
									iK: $author$project$Model$AtTime$DynamicImports(3)
								});
						default:
							return (editorChanges === 1) ? $author$project$Pages$ProjectConfig$resetOrder(model) : _Utils_update(
								model,
								{
									iQ: A2($author$project$Model$BuildDataSource$getBuildDataSourceEditor, model.Cu, buildData),
									Ep: buildData
								});
					}
				}();
				var rollbarCmd = function () {
					if ((buildData.$ === 2) && (!buildData.a.$)) {
						var httpError = buildData.a.a;
						return A3($author$project$Pages$ProjectConfig$rollbar.FZ, 'OnBuildData type_ oldEditor result', httpError, session);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				var _v53 = function () {
					switch (editorChanges) {
						case 1:
							return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
						case 0:
							var pkgCount = $elm$core$Dict$size(
								$author$project$Model$BuildPlanner$SolveLegacyEditor$getBundles(oldEditor)) + $elm$core$Dict$size(
								$author$project$Model$BuildPlanner$SolveLegacyEditor$getPackages(oldEditor));
							var maybeTimestamp = $elm$core$Maybe$Just(
								A2($author$project$Model$BuildExprEditorUtils$getNextTimestamp, model.pq, model.qR));
							var languagesWeExposeBundlesFor = function (editor) {
								return A2(
									$elm$core$List$filter,
									$author$project$Model$Language$supportsBundles,
									$author$project$Model$BuildPlanner$SolveLegacyEditor$getAllLanguages(editor));
							};
							var metadataCmd = function () {
								var _v57 = newModel.iS;
								if (!_v57.$) {
									return A2(
										$elm$core$Task$attempt,
										$author$project$Pages$ProjectConfig$OnBundlesMetadata,
										$elm$core$Task$sequence(
											A2(
												$elm$core$List$map,
												$author$project$Request$Ingredient$bundles(maybeTimestamp),
												languagesWeExposeBundlesFor(model.qR))));
								} else {
									return $elm$core$Platform$Cmd$none;
								}
							}();
							var getVulnerabilityKeys = function (dataSource) {
								return A2(
									$elm$core$List$map,
									$author$project$Model$NormsAndVulns$NamespacedVulnKey,
									_Utils_ap(
										$author$project$Model$BuildDataSource$getAllVulnerabilityKeys(dataSource),
										$author$project$Model$BuildDataSource$getComponentVulnerabilityKeys(dataSource)));
							};
							var getPurlVulnKeys = function (dataSource) {
								return A2(
									$elm$core$List$map,
									$author$project$Model$NormsAndVulns$PurlVulnKey,
									$author$project$Model$BuildDataSource$getComponentPurlVulnKeys(dataSource));
							};
							var getNamespaceKeys = function (dataSource) {
								return A2(
									$elm$core$List$map,
									$elm$core$Basics$identity,
									$elm$core$Set$toList(
										$author$project$Model$BuildDataSource$getNodeKeys(dataSource)));
							};
							var analyticsEventBase = function (action) {
								return A2(
									$author$project$Model$Analytics$withValue,
									pkgCount,
									A2(
										$author$project$Model$Analytics$withAction,
										action,
										A2(
											$author$project$Model$Analytics$withCategory,
											'Project configuration',
											$author$project$Model$Analytics$newEvent(action))));
							};
							var analyticsEventCmd = function () {
								switch (buildData.$) {
									case 3:
										var buildDataSource = buildData.a;
										var depCount = $elm$core$List$length(
											$author$project$Views$Dependencies$getDependencies(
												{
													Cu: $krisajenkins$remotedata$RemoteData$Success(buildDataSource),
													Ep: $krisajenkins$remotedata$RemoteData$NotAsked
												}));
										return $author$project$Ports$sendAnalyticsEvent(
											A2(
												$author$project$Model$Analytics$withValue2,
												depCount,
												analyticsEventBase('Dependencies resolved')));
									case 2:
										var err = buildData.a;
										return $author$project$Ports$sendAnalyticsEvent(
											A2(
												$author$project$Model$Analytics$withLabel,
												$author$project$Pages$ProjectConfig$errorToAnalyticsMessage(err),
												analyticsEventBase('Unable to resolve dependencies')));
									default:
										return $elm$core$Platform$Cmd$none;
								}
							}();
							var allVulnKeys = function (dataSource) {
								return _Utils_ap(
									getVulnerabilityKeys(dataSource),
									getPurlVulnKeys(dataSource));
							};
							var _v55 = A5($author$project$Pages$ProjectConfig$recordNormsAndVulnsNormalized, getNamespaceKeys, allVulnKeys, session, newModel, resultDataSource);
							var normsAndVulnsModel = _v55.a;
							var normsAndVulnsCmd = _v55.b;
							return A2(
								$author$project$Misc$with,
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2($elm$core$Platform$Cmd$map, $author$project$Pages$ProjectConfig$NormsAndVulnsMsg, normsAndVulnsCmd),
											metadataCmd,
											rollbarCmd,
											analyticsEventCmd
										])),
								_Utils_update(
									newModel,
									{rF: normsAndVulnsModel}));
						default:
							var loadingModel = _Utils_update(
								newModel,
								{Ep: $krisajenkins$remotedata$RemoteData$Loading});
							var cmd = A3($author$project$Pages$ProjectConfig$fetchBuildDataCmd, newModel, session, 0);
							return A2(
								$author$project$Misc$with,
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[cmd, rollbarCmd])),
								loadingModel);
					}
				}();
				var finalModel = _v53.a;
				var finalCmd = _v53.b;
				return A2(
					$author$project$Misc$with,
					externalMsg,
					A2($author$project$Misc$with, finalCmd, finalModel));
			case 18:
				var normsAndVulnsMsg = msg.a;
				var _v64 = A4(
					$author$project$Model$NormsAndVulns$update,
					$author$project$Model$NormsAndVulns$toRollbar($author$project$Pages$ProjectConfig$rollbar),
					session,
					normsAndVulnsMsg,
					model.rF);
				var _v65 = _v64.a;
				var newNormsAndVulns = _v65.a;
				var normsAndVulnsCmd = _v65.b;
				var external = _v64.b;
				return A2(
					$author$project$Misc$with,
					external,
					A2(
						$author$project$Misc$with,
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$ProjectConfig$NormsAndVulnsMsg, normsAndVulnsCmd),
						_Utils_update(
							model,
							{rF: newNormsAndVulns})));
			case 21:
				if (!msg.a.$) {
					var metadata = msg.a.a;
					var mergedDicts = A3(
						$elm$core$List$foldl,
						F2(
							function (dict, acc) {
								return A2($elm$core$Dict$union, dict, acc);
							}),
						$elm$core$Dict$empty,
						metadata);
					var newNormsAndVulns = A2(
						$author$project$Model$NormsAndVulns$recordNormalizedKeys,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Dict$keys,
							$elm$core$List$map($elm$core$Basics$identity))(mergedDicts),
						model.rF);
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{
									iS: function () {
										if (!metadata.b) {
											return $krisajenkins$remotedata$RemoteData$NotAsked;
										} else {
											return $krisajenkins$remotedata$RemoteData$Success(mergedDicts);
										}
									}(),
									rF: newNormsAndVulns
								})));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$textWarning(
								'Unable to fetch information about bundles : ' + $author$project$Model$Message$reason(err))),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$ProjectConfig$rollbar.FZ, 'OnBundlesMetadata (Err err)', err, session),
							_Utils_update(
								model,
								{
									iS: $krisajenkins$remotedata$RemoteData$Failure(err)
								})));
				}
			case 5:
				var branchMsg = msg.a;
				var _v67 = $author$project$Views$BranchPicker$update(branchMsg);
				var _v68 = _v67.a;
				var newbranchModel = _v68.a;
				var branchCmd = _v68.b;
				var branchPickerExternalMsg = _v67.b;
				var newModel = function () {
					var m = _Utils_update(
						model,
						{
							fJ: $elm$core$Maybe$Just(newbranchModel)
						});
					if (!branchPickerExternalMsg) {
						return _Utils_update(
							m,
							{kq: true});
					} else {
						return m;
					}
				}();
				var cmd = function () {
					if (!branchPickerExternalMsg) {
						return A2($author$project$Pages$ProjectConfig$softRefreshCmd, session, newModel);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[branchCmd, cmd])),
						newModel));
			case 19:
				if (!msg.a.$) {
					var project = msg.a.a;
					var newBranchMenuModel = A2(
						$elm$core$Maybe$map,
						$author$project$Views$BranchPicker$updateFromProject(project),
						model.fJ);
					var newModel = _Utils_update(
						model,
						{fJ: newBranchMenuModel, c5: project});
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							A2($author$project$Pages$ProjectConfig$softRefreshCmd, session, newModel),
							newModel));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$ProjectConfig$rollbar.FZ, 'OnBranchReloaded (Err err)', err, session),
							_Utils_update(
								model,
								{kq: false})));
				}
			case 42:
				if (!msg.a.$) {
					var _v71 = msg.a.a;
					var commit = _v71.a;
					var buildExpr = _v71.b;
					var editor = $author$project$Model$BuildPlanner$SolveLegacyEditor$fromBuildExprWithFallback(buildExpr);
					var _v72 = A3($author$project$Pages$ProjectConfig$normalizeBundlesAndPackages, creds, model, editor);
					var newModel = _v72.a;
					var normsAndVulnsCmd = _v72.b;
					var loadingModel = _Utils_update(
						newModel,
						{hq: '', ok: buildExpr, f0: commit, qR: editor, Cu: $krisajenkins$remotedata$RemoteData$Loading, Ep: $krisajenkins$remotedata$RemoteData$NotAsked, kq: false});
					var cmd = A3($author$project$Pages$ProjectConfig$fetchBuildDataCmd, loadingModel, session, 1);
					return A2(
						$author$project$Misc$with,
						A3(
							$author$project$External$AddCommitAndBuildExpr,
							{
								BR: $author$project$Model$Commit$getCommitID(commit),
								ix: $author$project$Model$Organization$getUrlName(model.c3),
								vT: $author$project$Model$Project$getName(model.c5)
							},
							commit,
							buildExpr),
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[cmd, normsAndVulnsCmd])),
							loadingModel));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$ProjectConfig$rollbar.FZ, 'SoftRefreshComplete (Err err)', err, session),
							_Utils_update(
								model,
								{kq: false})));
				}
			case 41:
				var branch = $author$project$Pages$ProjectConfig$getCurrentBranch(model);
				var _v73 = A6(
					$author$project$Views$UpdateForkModal$init,
					$author$project$Model$Session$getCreds(session),
					branch,
					model.c5,
					$author$project$Model$Organization$getUrlName(model.c3),
					model.n4,
					1);
				var updatedModalModel = _v73.a;
				var cmd = _v73.b;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$ProjectConfig$UpdateForkModalMsg, cmd),
						_Utils_update(
							model,
							{
								kE: $elm$core$Maybe$Just(updatedModalModel)
							})));
			case 46:
				var innerMsg = msg.a;
				var _v74 = model.kE;
				if (_v74.$ === 1) {
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
				} else {
					var innerModel = _v74.a;
					var _v75 = A2($author$project$Views$UpdateForkModal$update, innerModel, innerMsg);
					var _v76 = _v75.a;
					var _v77 = _v76.a;
					var newInnerModel = _v77.a;
					var innerCmd = _v77.b;
					var innerExternal = _v76.b;
					var external = _v75.b;
					var _v78 = function () {
						switch (innerExternal) {
							case 0:
								return A2(
									$author$project$Misc$with,
									$elm$core$Platform$Cmd$none,
									_Utils_update(
										model,
										{
											kE: $elm$core$Maybe$Just(newInnerModel)
										}));
							case 1:
								return A2(
									$author$project$Misc$with,
									$elm$core$Platform$Cmd$none,
									_Utils_update(
										model,
										{kE: $elm$core$Maybe$Nothing}));
							default:
								return A2(
									$author$project$Misc$with,
									A2(
										$elm$core$Task$attempt,
										$author$project$Pages$ProjectConfig$OnBranchReloaded,
										A3(
											$author$project$Request$Project$get,
											creds,
											model.c3.AC,
											$author$project$Model$Project$getName(model.c5))),
									_Utils_update(
										model,
										{kq: true, kE: $elm$core$Maybe$Nothing}));
						}
					}();
					var newModel = _v78.a;
					var cmd = _v78.b;
					return A2(
						$author$project$Misc$with,
						external,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										cmd,
										A2($elm$core$Platform$Cmd$map, $author$project$Pages$ProjectConfig$UpdateForkModalMsg, innerCmd)
									])),
							newModel));
				}
			case 31:
				var stageCommit = A2(
					$author$project$Request$BuildPlanner$stageCommit,
					$author$project$Model$Session$getCreds(session),
					{
						jE: $elm$core$Maybe$Just(
							$author$project$Pages$ProjectConfig$getPushCommitAtTime(model)),
						k$: $author$project$Model$BuildPlanner$BuildExprEditor$Simple$toBuildExpr(
							A3($author$project$Model$BuildPlanner$SolveLegacyEditor$setTimestamp, false, $elm$core$Maybe$Nothing, model.qR)),
						c: model.hq,
						ix: $author$project$Model$Organization$getUrlName(model.c3),
						zD: $author$project$Model$Commit$getCommitID(model.f0),
						vT: $author$project$Model$Project$getName(model.c5)
					});
				var addTag = F2(
					function (commit, currentTime) {
						return A2(
							$elm$core$Task$mapError,
							$author$project$Model$BuildPlanner$BuildPlannerError$HttpError,
							A4(
								$author$project$Request$Project$addTag,
								creds,
								$author$project$Model$Organization$getUrlName(model.c3),
								$author$project$Model$Project$getName(model.c5),
								{
									BR: $elm$core$Maybe$Just(
										$author$project$Model$Commit$getCommitID(commit)),
									b2: A3(
										$elm$core$String$replace,
										':',
										'-',
										$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(currentTime))
								}));
					});
				var cmd = A2(
					$elm$core$Task$attempt,
					$author$project$Pages$ProjectConfig$OnTaggedCommit,
					A2(
						$elm$core$Task$andThen,
						$elm$core$Basics$identity,
						A3($elm$core$Task$map2, addTag, stageCommit, $elm$time$Time$now)));
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						cmd,
						_Utils_update(
							model,
							{j_: $krisajenkins$remotedata$RemoteData$Loading})));
			case 23:
				if (!msg.a.$) {
					var tag = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{
									j_: $krisajenkins$remotedata$RemoteData$Success(tag)
								})));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$textWarning(
								$author$project$Pages$ProjectConfig$getSimplifiedErrorMessage(err))),
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{
									j_: $krisajenkins$remotedata$RemoteData$Failure(err)
								})));
				}
			case 7:
				var input = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$author$project$Ports$copyToClipboard(input),
						_Utils_update(
							model,
							{oi: $author$project$Model$CopyStatus$empty})));
			case 8:
				var portCopyStatus = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{oi: portCopyStatus})));
			case 14:
				var visibleModal = function () {
					var _v80 = model.hj;
					if ((_v80.$ === 1) && (_v80.a === 3)) {
						var _v81 = _v80.a;
						var anySelected = A2(
							$elm_community$dict_extra$Dict$Extra$any,
							F2(
								function (_v82, platform) {
									return A2($author$project$Model$BuildPlanner$SolveLegacyEditor$isPlatformSelected, platform, model.qR);
								}),
							model.n4);
						return (!anySelected) ? model.hj : $author$project$Pages$ProjectConfig$None;
					} else {
						return $author$project$Pages$ProjectConfig$None;
					}
				}();
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{yo: false, hj: visibleModal})));
			case 25:
				var subMsg = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								rO: A2($author$project$Views$PackageSummaryDisplay$update, subMsg, model.rO)
							})));
			case 24:
				var subMsg = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								rQ: A2($author$project$Views$NamespaceExpand$update, subMsg, model.rQ)
							})));
			case 15:
				var subMsg = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								rn: A2($author$project$Views$Licenses$update, subMsg, model.rn)
							})));
			case 11:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{yo: false})));
			case 47:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{oP: !model.oP})));
			case 48:
				var image = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								mk: A2($author$project$Views$ScannedImage$toggleOpen, image, model.mk)
							})));
			case 49:
				var maybeArgs = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								kZ: A2($elm$core$Maybe$andThen, $author$project$Components$BreakingChanges$init, maybeArgs)
							})));
			case 4:
				var innerMsg = msg.a;
				var _v83 = model.kZ;
				if (!_v83.$) {
					var modal = _v83.a;
					var _v84 = A2($author$project$Components$BreakingChanges$update, innerMsg, modal);
					var breakingChangesModal = _v84.a;
					var cmd = _v84.b;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$ProjectConfig$BreakingChangesMsg, cmd),
							_Utils_update(
								model,
								{
									kZ: $elm$core$Maybe$Just(breakingChangesModal)
								})));
				} else {
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
				}
			case 50:
				var _v85 = _Utils_Tuple2(
					$author$project$Model$BuildDataSource$latest(model),
					$author$project$Model$BuildPlanner$SolveLegacyEditor$getMarkers(model.qR));
				if ((_v85.a.$ === 3) && (_v85.b.$ === 5)) {
					var buildData = _v85.a.a;
					var _v86 = _v85.b;
					var sbom = _v86.b;
					var requirementsList = A2(
						$elm$core$List$map,
						function ($) {
							return $.ci;
						},
						$author$project$Model$BuildDataSource$getBuildPlan(buildData).pD);
					var requirements = $author$project$Model$BuildPlanner$BuildExpr$SolveEditor$requirementsFromList(requirementsList);
					var newEditor = $author$project$Model$BuildPlanner$BuildExprEditor$Simple$setEditableSBOM(
						A2(
							$author$project$Model$BuildPlanner$SolveLegacyEditor$addPlatform,
							'7c998ec2-7491-4e75-be4d-8885800ef5f2',
							A2(
								$author$project$Model$BuildPlanner$SolveLegacyEditor$setRequirements,
								requirements,
								A3(
									$author$project$Model$BuildPlanner$SolveLegacyEditor$setTimestamp,
									false,
									$elm$core$Maybe$Just(model.pq),
									model.qR))));
					var cmd = A2(
						$elm$core$Task$attempt,
						A2(
							$author$project$Pages$ProjectConfig$OnConvertedToRuntime,
							$elm$core$List$length(requirementsList),
							$elm$core$List$length(sbom.xM)),
						A3(
							$elm$core$Task$map2,
							$elm$core$Tuple$pair,
							A2(
								$author$project$Pages$ProjectConfig$pushCommitTask,
								session,
								_Utils_update(
									model,
									{hq: 'Convert SBOM \'' + (sbom.w + '\' to runtime'), qR: newEditor})),
							A2(
								$elm$core$Task$mapError,
								$author$project$Model$BuildPlanner$BuildPlannerError$HttpError,
								A3(
									$author$project$Request$Project$get,
									creds,
									$author$project$Model$Organization$getUrlName(model.c3),
									$author$project$Model$Project$getName(model.c5)))));
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							cmd,
							_Utils_update(
								model,
								{hQ: true})));
				} else {
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
				}
			case 52:
				if (msg.c.$ === 1) {
					var nbrRequirements = msg.a;
					var nbrPurls = msg.b;
					var err = msg.c.a;
					var sendAnalyticsEventCmd = $author$project$Ports$sendAnalyticsEvent(
						A2(
							$author$project$Model$Analytics$withValue2,
							nbrPurls,
							A2(
								$author$project$Model$Analytics$withValue,
								nbrRequirements,
								A2(
									$author$project$Model$Analytics$withAction,
									'SBOM conversion Failed',
									A2(
										$author$project$Model$Analytics$withCategory,
										$author$project$Model$Analytics$categoryConfiguration,
										$author$project$Model$Analytics$newEvent('SBOM conversion Failed'))))));
					var message = $author$project$Pages$ProjectConfig$getSimplifiedErrorMessage(err);
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$textWarning(message)),
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($author$project$Pages$ProjectConfig$rollbar.sk, message, session),
										sendAnalyticsEventCmd
									])),
							_Utils_update(
								model,
								{hQ: false})));
				} else {
					var nbrRequirements = msg.a;
					var nbrPurls = msg.b;
					var _v87 = msg.c.a;
					var commit = _v87.a;
					var project = _v87.b;
					var sendAnalyticsEventCmd = $author$project$Ports$sendAnalyticsEvent(
						A2(
							$author$project$Model$Analytics$withValue2,
							nbrPurls,
							A2(
								$author$project$Model$Analytics$withValue,
								nbrRequirements,
								A2(
									$author$project$Model$Analytics$withAction,
									'SBOM converted',
									A2(
										$author$project$Model$Analytics$withCategory,
										$author$project$Model$Analytics$categoryConfiguration,
										$author$project$Model$Analytics$newEvent('SBOM converted'))))));
					var nextEditor = $author$project$Model$Editor$commit(model.qR);
					var nextBranchMenuModel = A2(
						$elm$core$Maybe$map,
						$author$project$Views$BranchPicker$updateFromProject(project),
						model.fJ);
					var nextModel = _Utils_update(
						model,
						{
							fJ: nextBranchMenuModel,
							f0: commit,
							qR: nextEditor,
							Cu: $krisajenkins$remotedata$RemoteData$Loading,
							Ep: $krisajenkins$remotedata$RemoteData$NotAsked,
							c5: project,
							hQ: false,
							hX: $author$project$Views$Timestamp$reset(model.hX)
						});
					var cmd = $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Ports$removeUrlParameter('commitID'),
								sendAnalyticsEventCmd,
								A2($author$project$Pages$ProjectConfig$softRefreshCmd, session, nextModel)
							]));
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2($author$project$Misc$with, cmd, nextModel));
				}
			case 51:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{rf: !model.rf})));
			default:
				var name = msg.a;
				var innerMsg = msg.b;
				var _v88 = A2($elm$core$Dict$get, name, model.oE);
				if (_v88.$ === 1) {
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
				} else {
					var innerModel = _v88.a;
					var _v89 = A2($author$project$Views$GenericSBOM$update, innerModel, innerMsg);
					var newInnerModel = _v89.a;
					var cmd = _v89.b;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							A2(
								$elm$core$Platform$Cmd$map,
								$author$project$Pages$ProjectConfig$GenericSBOM(name),
								cmd),
							_Utils_update(
								model,
								{
									oE: A3($elm$core$Dict$insert, name, newInnerModel, model.oE)
								})));
				}
		}
	});
var $author$project$Model$BuildExprEditorUtils$anyNonSuperuserChanges = function (editor) {
	var noValues = $elm$core$List$map(
		$author$project$Model$Editor$itemMapValue(
			$elm$core$Basics$always(0)));
	return A3(
		$elm$core$Basics$composeL,
		$elm$core$Basics$not,
		$elm$core$List$isEmpty,
		$author$project$Model$Editor$itemsToChanges(
			_Utils_ap(
				noValues(
					$author$project$Model$BuildPlanner$SolveLegacyEditor$getPlatformItems(editor)),
				_Utils_ap(
					noValues(
						$author$project$Model$BuildPlanner$SolveLegacyEditor$getPackagerItems(editor)),
					_Utils_ap(
						noValues(
							$author$project$Model$BuildPlanner$SolveLegacyEditor$getLanguageItems(editor)),
						_Utils_ap(
							noValues(
								$author$project$Model$BuildPlanner$SolveLegacyEditor$getBundleItems(editor)),
							noValues(
								$author$project$Model$BuildPlanner$SolveLegacyEditor$getPackageItems(editor))))))));
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$getSolverVersion = $author$project$Model$BuildPlanner$SolveLegacyEditor$getBuildExprSolveEditor(
	$author$project$Model$Editor$getField(
		function ($) {
			return $.Ga;
		}));
var $author$project$Model$BuildExprEditorUtils$updateSolverV0 = function (editor) {
	return (!_Utils_eq(
		$author$project$Model$BuildPlanner$SolveLegacyEditor$getSolverVersion(editor),
		$elm$core$Maybe$Just(0))) ? editor : ($author$project$Model$BuildExprEditorUtils$anyNonSuperuserChanges(editor) ? A2($author$project$Model$BuildPlanner$SolveLegacyEditor$setSolverVersion, $elm$core$Maybe$Nothing, editor) : editor);
};
var $author$project$Model$BuildExprEditorUtils$updateTimestamp = F2(
	function (platformPresent, editor) {
		return $author$project$Model$BuildExprEditorUtils$anyNonSuperuserChanges(editor) ? A3(
			$author$project$Model$BuildPlanner$SolveLegacyEditor$setTimestamp,
			false,
			$elm$core$Maybe$Just(
				A2($author$project$Model$BuildExprEditorUtils$getNextTimestamp, platformPresent, editor)),
			editor) : editor;
	});
var $author$project$Pages$ProjectConfig$update = F3(
	function (session, msg, model) {
		var _v0 = A3($author$project$Pages$ProjectConfig$innerUpdate, session, msg, model);
		var _v1 = _v0.a;
		var innerUpdateModel = _v1.a;
		var innerUpdateCmd = _v1.b;
		var innerUpdateNewSession = _v0.b;
		var editorChanges = $author$project$Model$BuildPlanner$SolveLegacyEditor$getChangesComparedTo(
			{rC: innerUpdateModel.qR, zu: model.qR});
		var isLoading = _Utils_eq(innerUpdateModel.Cu, $krisajenkins$remotedata$RemoteData$Loading) || _Utils_eq(innerUpdateModel.Ep, $krisajenkins$remotedata$RemoteData$Loading);
		var newModel = (editorChanges === 1) ? $author$project$Pages$ProjectConfig$resetOrder(innerUpdateModel) : innerUpdateModel;
		var _v2 = newModel.iK;
		if (!_v2.$) {
			if (isLoading || (editorChanges !== 2)) {
				return A2(
					$author$project$Misc$with,
					innerUpdateNewSession,
					A2($author$project$Misc$with, innerUpdateCmd, newModel));
			} else {
				var loadingModel = _Utils_update(
					newModel,
					{
						qR: $author$project$Model$BuildExprEditorUtils$updateSolverV0(
							A2($author$project$Model$BuildExprEditorUtils$updateTimestamp, model.pq, newModel.qR)),
						j_: $krisajenkins$remotedata$RemoteData$NotAsked,
						Ep: $krisajenkins$remotedata$RemoteData$Loading
					});
				var cmd = A3($author$project$Pages$ProjectConfig$fetchBuildDataCmd, loadingModel, session, 0);
				return A2(
					$author$project$Misc$with,
					innerUpdateNewSession,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[cmd, innerUpdateCmd])),
						loadingModel));
			}
		} else {
			var type_ = _v2.a;
			if ((type_ !== 2) && (isLoading || (editorChanges !== 2))) {
				return A2(
					$author$project$Misc$with,
					innerUpdateNewSession,
					A2($author$project$Misc$with, innerUpdateCmd, newModel));
			} else {
				var loadingModel = _Utils_update(
					newModel,
					{
						qR: $author$project$Model$BuildExprEditorUtils$updateSolverV0(
							A2($author$project$Model$BuildExprEditorUtils$updateTimestamp, model.pq, newModel.qR)),
						j_: $krisajenkins$remotedata$RemoteData$NotAsked,
						Ep: $krisajenkins$remotedata$RemoteData$Loading
					});
				var cmd = A3($author$project$Pages$ProjectConfig$fetchBuildDataCmd, loadingModel, session, type_);
				return A2(
					$author$project$Misc$with,
					innerUpdateNewSession,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[cmd, innerUpdateCmd])),
						loadingModel));
			}
		}
	});
var $author$project$Pages$ProjectConfigAdvanced$NotValidated = {$: 0};
var $author$project$Pages$ProjectConfigAdvanced$OnCommitSaved = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$ProjectConfigAdvanced$SoftRefreshComplete = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$ProjectConfigAdvanced$isStillPushable = F2(
	function (model, pushable) {
		return _Utils_eq(model.iL, pushable.w_) && _Utils_eq(model.iR, pushable.wZ);
	});
var $author$project$Pages$ProjectConfigAdvanced$getPushable = function (model) {
	var _v0 = model.k0;
	switch (_v0.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Nothing;
		case 2:
			var pushable = _v0.b;
			return A2($author$project$Pages$ProjectConfigAdvanced$isStillPushable, model, pushable) ? $elm$core$Maybe$Just(pushable) : $elm$core$Maybe$Nothing;
		default:
			var pushable = _v0.a;
			return A2($author$project$Pages$ProjectConfigAdvanced$isStillPushable, model, pushable) ? $elm$core$Maybe$Just(pushable) : $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$ProjectConfigAdvanced$getSimplifiedErrorMessage = function (error) {
	switch (error.$) {
		case 5:
			return 'Not found';
		case 2:
			return 'Forbidden';
		case 3:
			return 'Head on branch moved';
		case 4:
			return 'No change since last commit';
		default:
			return $author$project$Model$BuildPlanner$BuildPlannerError$message(error);
	}
};
var $author$project$Pages$ProjectConfigAdvanced$getCurrentBranch = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Model$Project$getDefaultBranch(model.c5),
		A2($elm$core$Maybe$map, $author$project$Views$BranchPicker$getSelectedBranch, model.fJ));
};
var $author$project$Pages$ProjectConfigAdvanced$pushCommitTask = F3(
	function (session, model, pushable) {
		var input = {
			jE: A2($elm$core$Maybe$map, $author$project$Model$AtTime$Timestamp, pushable.wG),
			xq: $elm$core$Maybe$Just(
				$author$project$Model$Branch$getID(
					$author$project$Pages$ProjectConfigAdvanced$getCurrentBranch(model))),
			k$: pushable.k$,
			c: model.k9,
			BR: $author$project$Model$Commit$getCommitID(model.f0),
			ix: $author$project$Model$Organization$getUrlName(model.c3),
			vT: $author$project$Model$Project$getName(model.c5)
		};
		return A2(
			$author$project$Request$BuildPlanner$pushCommit,
			$author$project$Model$Session$getCreds(session),
			input);
	});
var $author$project$Pages$ProjectConfigAdvanced$NoOp = {$: 0};
var $author$project$Pages$ProjectConfigAdvanced$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Pages$ProjectConfigAdvanced$NoOp, 'Pages/ProjectConfigAdvanced.elm');
var $author$project$Pages$ProjectConfigAdvanced$selectedBranchLatestCommitID = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		$author$project$Model$Branch$getCommitID,
		A2($elm$core$Maybe$map, $author$project$Views$BranchPicker$getSelectedBranch, model.fJ));
};
var $author$project$Pages$ProjectConfigAdvanced$toBuildExprText = function (buildExpr) {
	return A2(
		$elm$json$Json$Encode$encode,
		4,
		$author$project$Model$BuildPlanner$BuildExpr$encode(buildExpr));
};
var $author$project$Pages$ProjectConfigAdvanced$Error = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$ProjectConfigAdvanced$Valid = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$ProjectConfigAdvanced$Warning = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$ProjectConfigAdvanced$validateOffline = function (model) {
	var _v0 = A2($elm$json$Json$Decode$decodeString, $elm$json$Json$Decode$value, model.iR);
	if (_v0.$ === 1) {
		var err = _v0.a;
		return $author$project$Pages$ProjectConfigAdvanced$Error(
			'Invalid JSON: ' + $elm$json$Json$Decode$errorToString(err));
	} else {
		var value = _v0.a;
		var _v1 = A2($elm$json$Json$Decode$decodeValue, $author$project$Model$BuildPlanner$BuildExpr$decode, value);
		if (_v1.$ === 1) {
			var err = _v1.a;
			return $author$project$Pages$ProjectConfigAdvanced$Error(
				'Invalid BuildExpr: ' + $elm$json$Json$Decode$errorToString(err));
		} else {
			var buildExpr = _v1.a;
			var timestampRes = function () {
				var _v4 = _Utils_Tuple2(
					model.iL,
					$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(model.iL));
				_v4$0:
				while (true) {
					if (_v4.b.$ === 1) {
						if (_v4.a === '') {
							break _v4$0;
						} else {
							return $elm$core$Result$Err('Invalid timestamp format');
						}
					} else {
						if (_v4.a === '') {
							break _v4$0;
						} else {
							var timestamp = _v4.b.a;
							return $elm$core$Result$Ok(
								$elm$core$Maybe$Just(timestamp));
						}
					}
				}
				return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
			}();
			if (timestampRes.$ === 1) {
				var err = timestampRes.a;
				return $author$project$Pages$ProjectConfigAdvanced$Error(err);
			} else {
				var timestamp = timestampRes.a;
				var pushable = {k$: buildExpr, wG: timestamp, wZ: model.iR, w_: model.iL};
				var _v3 = $author$project$Model$BuildPlanner$BuildExprEditor$Simple$fromBuildExpr(buildExpr);
				if (_v3.$ === 1) {
					if (!_v3.a.$) {
						var err = _v3.a.a;
						return A2($author$project$Pages$ProjectConfigAdvanced$Warning, 'Too complex: ' + err, pushable);
					} else {
						var kind = _v3.a.a;
						return A2(
							$author$project$Pages$ProjectConfigAdvanced$Warning,
							'Unknown Ap: ' + $author$project$Model$BuildPlanner$BuildExpr$UnknownAp$toString(kind),
							pushable);
					}
				} else {
					return $author$project$Pages$ProjectConfigAdvanced$Valid(pushable);
				}
			}
		}
	}
};
var $author$project$Pages$ProjectConfigAdvanced$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
			case 1:
				var branchMsg = msg.a;
				var _v1 = $author$project$Views$BranchPicker$update(branchMsg);
				var _v2 = _v1.a;
				var newBranchModel = _v2.a;
				var branchCmd = _v2.b;
				var branchPickerExternalMsg = _v1.b;
				var newModel = function () {
					var m = _Utils_update(
						model,
						{
							fJ: $elm$core$Maybe$Just(newBranchModel)
						});
					if (!branchPickerExternalMsg) {
						return _Utils_update(
							m,
							{kq: true});
					} else {
						return m;
					}
				}();
				var cmd = function () {
					if (!branchPickerExternalMsg) {
						return A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									A3(
										$author$project$Pages$ProjectConfigAdvanced$getRefreshDataTask,
										session,
										$author$project$Model$Organization$getUrlName(newModel.c3),
										$author$project$Model$Project$getName(newModel.c5)),
									$elm$core$Task$attempt($author$project$Pages$ProjectConfigAdvanced$SoftRefreshComplete)),
								$author$project$Pages$ProjectConfigAdvanced$selectedBranchLatestCommitID(newModel)));
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[branchCmd, cmd])),
						newModel));
			case 2:
				if (!msg.a.$) {
					var _v5 = msg.a.a;
					var commit = _v5.a;
					var buildExpr = _v5.b;
					return A2(
						$author$project$Misc$with,
						A3(
							$author$project$External$AddCommitAndBuildExpr,
							{
								BR: $author$project$Model$Commit$getCommitID(commit),
								ix: $author$project$Model$Organization$getUrlName(model.c3),
								vT: $author$project$Model$Project$getName(model.c5)
							},
							commit,
							buildExpr),
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{
									iR: $author$project$Pages$ProjectConfigAdvanced$toBuildExprText(buildExpr),
									k0: $author$project$Pages$ProjectConfigAdvanced$NotValidated,
									k9: '',
									ok: buildExpr,
									f0: commit,
									iL: ''
								})));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$ProjectConfigAdvanced$rollbar.FZ, 'SoftRefreshComplete (Err err)', err, session),
							model));
				}
			case 3:
				var commentText = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{k9: commentText})));
			case 4:
				var timestampText = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{iL: timestampText})));
			case 5:
				var buildExprText = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{iR: buildExprText})));
			case 6:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								k0: $author$project$Pages$ProjectConfigAdvanced$validateOffline(model),
								iA: $krisajenkins$remotedata$RemoteData$NotAsked
							})));
			case 7:
				var _v6 = $author$project$Pages$ProjectConfigAdvanced$getPushable(model);
				if (_v6.$ === 1) {
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
				} else {
					var pushable = _v6.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							A2(
								$elm$core$Task$attempt,
								$author$project$Pages$ProjectConfigAdvanced$OnCommitSaved,
								A3($author$project$Pages$ProjectConfigAdvanced$pushCommitTask, session, model, pushable)),
							_Utils_update(
								model,
								{iA: $krisajenkins$remotedata$RemoteData$Loading})));
				}
			default:
				if (msg.a.$ === 1) {
					if (!msg.a.a.$) {
						var err = msg.a.a.a;
						return A2(
							$author$project$Misc$with,
							$author$project$External$AddNotification(
								$author$project$Model$Notification$fromError(err)),
							A2(
								$author$project$Misc$with,
								A3($author$project$Pages$ProjectConfigAdvanced$rollbar.FZ, 'OnCommitSaved _ (Err (HttpError err))', err, session),
								_Utils_update(
									model,
									{
										iA: $krisajenkins$remotedata$RemoteData$Failure('Error while saving commit')
									})));
					} else {
						var err = msg.a.a;
						var message = $author$project$Pages$ProjectConfigAdvanced$getSimplifiedErrorMessage(err);
						return A2(
							$author$project$Misc$with,
							$author$project$External$AddNotification(
								$author$project$Model$Notification$textWarning(message)),
							A2(
								$author$project$Misc$with,
								A2($author$project$Pages$ProjectConfigAdvanced$rollbar.sk, message, session),
								_Utils_update(
									model,
									{
										iA: $krisajenkins$remotedata$RemoteData$Failure(message)
									})));
					}
				} else {
					var commit = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							A2(
								$elm$core$Task$attempt,
								$author$project$Pages$ProjectConfigAdvanced$SoftRefreshComplete,
								A4(
									$author$project$Pages$ProjectConfigAdvanced$getRefreshDataTask,
									session,
									$author$project$Model$Organization$getUrlName(model.c3),
									$author$project$Model$Project$getName(model.c5),
									$author$project$Model$Commit$getCommitID(commit))),
							_Utils_update(
								model,
								{
									iA: $krisajenkins$remotedata$RemoteData$Success(0)
								})));
				}
		}
	});
var $author$project$Pages$ProjectDownloads$KickCompleted = function (a) {
	return {$: 22, a: a};
};
var $author$project$Pages$ProjectDownloads$KickConfirming = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$ProjectDownloads$KickIdle = {$: 0};
var $author$project$Pages$ProjectDownloads$KickRunning = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$ProjectDownloads$OnReceivedBuildPlan = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Pages$ProjectDownloads$OnReceivedBuildPlanPollable = F3(
	function (a, b, c) {
		return {$: 17, a: a, b: b, c: c};
	});
var $author$project$Pages$ProjectDownloads$ReloadBuildPlanForCache = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$ProjectDownloads$ReloadBuildPlanForCacheComplete = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$External$RemoveBuildPlanAndComponents = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$ProjectDownloads$SoftRefreshComplete = function (a) {
	return {$: 16, a: a};
};
var $author$project$Model$ProgressTracker$StatusFailed = 2;
var $author$project$Model$ProgressTracker$StatusSuccess = 1;
var $author$project$Pages$ProjectDownloads$plural = F2(
	function (n, word) {
		return (n === 1) ? word : (word + 's');
	});
var $author$project$Pages$ProjectDownloads$artifactCount = function (n) {
	return $elm$core$String$fromInt(n) + (' ' + A2($author$project$Pages$ProjectDownloads$plural, n, 'artifact'));
};
var $author$project$Model$BuildPlanner$BuildPlan$buildLogIds = function (buildPlan) {
	var _v0 = buildPlan.bB;
	switch (_v0.$) {
		case 0:
			return _List_Nil;
		case 1:
			return _List_Nil;
		case 2:
			var data = _v0.a;
			return data.s_;
		default:
			var data = _v0.a;
			return data.s_;
	}
};
var $author$project$Model$ProgressTracker$buildLogPartitionKey = function (buildLogId) {
	var _v0 = buildLogId.gR;
	if (!_v0) {
		return _Utils_Tuple2('buildRequestID', buildLogId.l6);
	} else {
		return _Utils_Tuple2('recipeID', buildLogId.l6);
	}
};
var $author$project$Model$ProgressTracker$StatusInProgress = 0;
var $author$project$Model$ProgressTracker$Building = 1;
var $author$project$Model$ProgressTracker$Errored = 3;
var $author$project$Model$ProgressTracker$NotAttempted = 4;
var $author$project$Model$ProgressTracker$Queued = 0;
var $author$project$Model$ProgressTracker$Successful = 2;
var $author$project$Model$ProgressTracker$artifactStatusToPackageState = function (status) {
	switch (status) {
		case 0:
			return 0;
		case 1:
			return 0;
		case 2:
			return 3;
		case 3:
			return 3;
		case 4:
			return 0;
		case 6:
			return 1;
		case 5:
			return 4;
		default:
			return 2;
	}
};
var $author$project$Model$BuildPlanner$Artifact$buildDurationMillis = function (a) {
	if (!a.$) {
		var data = a.a;
		return $elm$core$Maybe$Just(data.sZ);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$BuildPlanner$Artifact$displayName = function (a) {
	switch (a.$) {
		case 0:
			var data = a.a;
			return data.i$;
		case 2:
			var data = a.a;
			return data.i$;
		case 1:
			var data = a.a;
			return data.i$;
		default:
			var data = a.a;
			return data.i$;
	}
};
var $author$project$Model$Platform$brandName = function (_v0) {
	var platform = _v0;
	var _v1 = platform.ml;
	switch (_v1) {
		case 'Darwin':
			return 'Mac';
		case 'NO KERNEL':
			return '';
		default:
			return platform.ml;
	}
};
var $author$project$Model$BuildPlanner$Artifact$isDocker = A2(
	$elm$core$Basics$composeR,
	$author$project$Model$BuildPlanner$Artifact$mimetype,
	$elm$core$Basics$eq('application/vnd.docker.image.rootfs.diff.tar.gzip'));
var $author$project$Model$BuildPlanner$Artifact$isCamelInstaller = A2(
	$elm$core$Basics$composeR,
	$author$project$Model$BuildPlanner$Artifact$mimetype,
	$elm$core$Basics$eq('application/x-camel-installer'));
var $author$project$Model$BuildPlanner$Artifact$isMacInstaller = A2(
	$elm$core$Basics$composeR,
	$author$project$Model$BuildPlanner$Artifact$mimetype,
	$elm$core$Basics$eq('application/x-xar'));
var $author$project$Model$BuildPlanner$Artifact$isWindowsInstaller = A2(
	$elm$core$Basics$composeR,
	$author$project$Model$BuildPlanner$Artifact$mimetype,
	$elm$core$Basics$eq('application/x-msi'));
var $author$project$Model$BuildPlanner$Artifact$isInstaller = function (a) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Model$BuildPlanner$Artifact$mimetype,
		$elm$core$String$contains('application/x-gozip-installer'))(a) || ($author$project$Model$BuildPlanner$Artifact$isCamelInstaller(a) || ($author$project$Model$BuildPlanner$Artifact$isWindowsInstaller(a) || $author$project$Model$BuildPlanner$Artifact$isMacInstaller(a)));
};
var $author$project$Model$BuildPlanner$Artifact$isSignedInstaller = A2(
	$elm$core$Basics$composeR,
	$author$project$Model$BuildPlanner$Artifact$displayName,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$String$toLower,
		$elm$core$String$contains('signed')));
var $author$project$Model$BuildPlanner$Artifact$displayNameForPlatform = F2(
	function (platform, artifact) {
		if ($author$project$Model$BuildPlanner$Artifact$isDocker(artifact)) {
			return $elm$core$Maybe$Just('Docker Image');
		} else {
			if ($author$project$Model$BuildPlanner$Artifact$isInstaller(artifact)) {
				return $author$project$Model$BuildPlanner$Artifact$isSignedInstaller(artifact) ? $elm$core$Maybe$Just(
					$author$project$Model$Platform$brandName(platform) + ' Installer (Signed)') : $elm$core$Maybe$Just(
					$author$project$Model$Platform$brandName(platform) + ' Installer');
			} else {
				var _v0 = $author$project$Model$BuildPlanner$Artifact$mimetype(artifact);
				switch (_v0) {
					case 'text/plain':
						return $elm$core$Maybe$Just('Text File');
					case 'application/zip':
						return $elm$core$Maybe$Just('ZIP File');
					case 'application/gzip':
						return $elm$core$Maybe$Just('GZIP File');
					default:
						return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $author$project$Model$BuildPlanner$Artifact$errors = function (a) {
	switch (a.$) {
		case 0:
			return _List_Nil;
		case 2:
			return _List_Nil;
		case 1:
			return _List_Nil;
		default:
			var data = a.a;
			return data.yf;
	}
};
var $author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$getArtifactBuilderMappingsForPlatform = F2(
	function (platformID, _v0) {
		var fields = _v0;
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.sT;
				},
				A2($elm$core$Dict$get, platformID, fields.Fh)));
	});
var $author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$getDownloadsForPlatform = F2(
	function (platformID, _v0) {
		var fields = _v0;
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.tH;
				},
				A2($elm$core$Dict$get, platformID, fields.Fh)));
	});
var $author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$getFinishedAt = function (_v0) {
	var fields = _v0;
	return fields.yl;
};
var $author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$getSourceArtifactBuilderMappingsForPlatform = F2(
	function (platformID, _v0) {
		var fields = _v0;
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.wl;
				},
				A2($elm$core$Dict$get, platformID, fields.Fh)));
	});
var $author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$getStartedAt = function (_v0) {
	var fields = _v0;
	return fields.Ae;
};
var $author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$getTerminalArtifactsForPlatform = F2(
	function (platformID, _v0) {
		var fields = _v0;
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.wD;
				},
				A2($elm$core$Dict$get, platformID, fields.Fh)));
	});
var $author$project$Model$BuildPlanner$Artifact$inProgress = function (a) {
	switch (a.$) {
		case 1:
			return true;
		case 2:
			return true;
		default:
			return false;
	}
};
var $author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$isIndemnified = function (_v0) {
	var fields = _v0;
	return fields.Dm;
};
var $author$project$Model$ProgressTracker$isSuccessfulPackage = function (_v0) {
	var state = _v0.bB;
	if (state === 2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Model$BuildPlanner$Artifact$knownProvenanceBuilder = function (a) {
	return !($author$project$Model$BuildPlanner$Artifact$isBuilder(a) && (A2(
		$elm$core$Basics$composeR,
		$author$project$Model$BuildPlanner$Artifact$displayName,
		$elm$core$String$startsWith('substitute-'))(a) || A2(
		$elm$core$Basics$composeR,
		$author$project$Model$BuildPlanner$Artifact$displayName,
		$elm$core$Basics$eq('pypi-builder'))(a)));
};
var $author$project$Model$BuildPlanner$Artifact$startedAt = function (a) {
	if (a.$ === 2) {
		var data = a.a;
		return $elm$core$Maybe$Just(data.Ae);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$BuildPlanner$Artifact$status = function (a) {
	switch (a.$) {
		case 0:
			var data = a.a;
			return data.L;
		case 2:
			var data = a.a;
			return data.L;
		case 1:
			var data = a.a;
			return data.L;
		default:
			var data = a.a;
			return data.L;
	}
};
var $author$project$Model$BuildPlanner$Artifact$url = function (a) {
	if (!a.$) {
		var data = a.a;
		return $elm$core$Maybe$Just(data.GT);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$ProgressTracker$altBuildGraphInit = function (_v0) {
	var org = _v0.pd;
	var project = _v0.c5;
	var branch = _v0.h4;
	var platform = _v0.po;
	var languages = _v0.aM;
	var commitID = _v0.BR;
	var altBuildGraph = _v0.xd;
	var platformID = $author$project$Model$Platform$id(platform);
	var sourceArtifactBuilderMappings = A2($author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$getSourceArtifactBuilderMappingsForPlatform, platformID, altBuildGraph);
	var makePackageProgressWithSource = function (_v2) {
		var source = _v2.o;
		var artifactBuilderMapping = _v2.ql;
		var knownProvenance = $author$project$Model$BuildPlanner$Artifact$knownProvenanceBuilder(artifactBuilderMapping.xu);
		var artifact = artifactBuilderMapping.xe;
		var displayName = $author$project$Model$BuildPlanner$Artifact$isWheel(artifact) ? ($author$project$Model$BuildPlanner$Source$name(source) + ' (Wheel)') : $author$project$Model$BuildPlanner$Source$name(source);
		var endTime = A3(
			$elm$core$Maybe$map2,
			$author$project$TimeUtils$add,
			$author$project$Model$BuildPlanner$Artifact$startedAt(artifact),
			$author$project$Model$BuildPlanner$Artifact$buildDurationMillis(artifact));
		return _Utils_Tuple2(
			$danyx23$elm_uuid$Uuid$toString(
				$author$project$Model$BuildPlanner$Artifact$id(artifact)),
			{
				oq: 1,
				x8: $author$project$Model$BuildPlanner$Artifact$url(artifact),
				yc: endTime,
				oB: '',
				l6: A2($elm$core$Basics$composeR, $author$project$Model$BuildPlanner$Artifact$id, $danyx23$elm_uuid$Uuid$toString)(artifact),
				oV: knownProvenance,
				je: $elm$core$Maybe$Just(
					$author$project$Model$BuildPlanner$Artifact$mimetype(artifact)),
				w: displayName,
				aE: $author$project$Model$BuildPlanner$Source$namespace(source),
				du: $author$project$Model$BuildPlanner$Artifact$startedAt(artifact),
				bB: $author$project$Model$ProgressTracker$artifactStatusToPackageState(
					$author$project$Model$BuildPlanner$Artifact$status(artifact)),
				aI: $author$project$Model$BuildPlanner$Source$version(source)
			});
	};
	var makePackageProgress = function (artifactBuilderMapping) {
		var knownProvenance = $author$project$Model$BuildPlanner$Artifact$knownProvenanceBuilder(artifactBuilderMapping.xu);
		var artifact = artifactBuilderMapping.xe;
		var displayName = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Model$BuildPlanner$Artifact$displayName(artifact),
			A2($author$project$Model$BuildPlanner$Artifact$displayNameForPlatform, platform, artifact));
		var endTime = A3(
			$elm$core$Maybe$map2,
			$author$project$TimeUtils$add,
			$author$project$Model$BuildPlanner$Artifact$startedAt(artifact),
			$author$project$Model$BuildPlanner$Artifact$buildDurationMillis(artifact));
		return _Utils_Tuple2(
			$danyx23$elm_uuid$Uuid$toString(
				$author$project$Model$BuildPlanner$Artifact$id(artifact)),
			{
				oq: 1,
				x8: $author$project$Model$BuildPlanner$Artifact$url(artifact),
				yc: endTime,
				oB: '',
				l6: A2($elm$core$Basics$composeR, $author$project$Model$BuildPlanner$Artifact$id, $danyx23$elm_uuid$Uuid$toString)(artifact),
				oV: knownProvenance,
				je: $elm$core$Maybe$Just(
					$author$project$Model$BuildPlanner$Artifact$mimetype(artifact)),
				w: displayName,
				aE: '',
				du: $author$project$Model$BuildPlanner$Artifact$startedAt(artifact),
				bB: $author$project$Model$ProgressTracker$artifactStatusToPackageState(
					$author$project$Model$BuildPlanner$Artifact$status(artifact)),
				aI: ''
			});
	};
	var artifactBuilderMappings = A2($author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$getArtifactBuilderMappingsForPlatform, platformID, altBuildGraph);
	var artifacts = _Utils_ap(
		A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.ql;
				},
				function ($) {
					return $.xe;
				}),
			sourceArtifactBuilderMappings),
		A2(
			$elm$core$List$map,
			function ($) {
				return $.xe;
			},
			artifactBuilderMappings));
	var failedArtifacts = A2($elm$core$List$filter, $author$project$Model$BuildPlanner$Artifact$isFailed, artifacts);
	var status = A2($elm$core$List$any, $author$project$Model$BuildPlanner$Artifact$isFailed, artifacts) ? 2 : (A2($elm$core$List$any, $author$project$Model$BuildPlanner$Artifact$inProgress, artifacts) ? 0 : 1);
	var packageProgress = $elm$core$Dict$fromList(
		_Utils_ap(
			A2($elm$core$List$map, makePackageProgress, artifactBuilderMappings),
			A2($elm$core$List$map, makePackageProgressWithSource, sourceArtifactBuilderMappings)));
	var nonInstallerPackageInfo = A2(
		$elm$core$List$filter,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.w;
			},
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Basics$eq(''),
				$elm$core$Basics$not)),
		$elm$core$Dict$values(packageProgress));
	var completedArtifactsCount = $elm$core$List$length(
		A2($elm$core$List$filter, $author$project$Model$ProgressTracker$isSuccessfulPackage, nonInstallerPackageInfo));
	var buildProgress = function () {
		var _v1 = A2(
			$elm$core$Tuple$pair,
			$elm$core$Maybe$Just('One or More packages failed to build'),
			$elm$core$List$concat(
				A2($elm$core$List$map, $author$project$Model$BuildPlanner$Artifact$errors, failedArtifacts)));
		var reason = _v1.a;
		var errors = _v1.b;
		return {
			yc: $author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$getFinishedAt(altBuildGraph),
			yf: errors,
			cg: reason,
			du: $author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$getStartedAt(altBuildGraph),
			kz: completedArtifactsCount,
			nH: $elm$core$List$length(nonInstallerPackageInfo)
		};
	}();
	return {
		h4: branch,
		h6: buildProgress,
		qt: 1,
		s0: $elm$core$Maybe$Nothing,
		BR: commitID,
		tr: platformID,
		tH: A2($author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$getDownloadsForPlatform, platformID, altBuildGraph),
		ud: $author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$isIndemnified(altBuildGraph),
		aM: languages,
		c3: {sP: org.sP, AC: org.AC},
		hI: packageProgress,
		po: platform,
		c5: project,
		kw: false,
		L: status,
		wC: A2(
			$elm$core$List$map,
			$author$project$Model$BuildPlanner$Artifact$idStr,
			A2($author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$getTerminalArtifactsForPlatform, platformID, altBuildGraph))
	};
};
var $author$project$Model$BuildPlanner$BuildGraph$CamelBuildGraph$getArtifactsForPlatform = F2(
	function (platformID, _v0) {
		var fields = _v0;
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.sU;
				},
				A2($elm$core$Dict$get, platformID, fields.Fh)));
	});
var $author$project$Model$BuildPlanner$BuildGraph$CamelBuildGraph$getDownloadsForPlatform = F2(
	function (platformID, _v0) {
		var fields = _v0;
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.tH;
				},
				A2($elm$core$Dict$get, platformID, fields.Fh)));
	});
var $author$project$Model$BuildPlanner$BuildGraph$CamelBuildGraph$getFinishedAt = function (_v0) {
	var fields = _v0;
	return fields.yl;
};
var $author$project$Model$BuildPlanner$BuildGraph$CamelBuildGraph$getSourcesForPlatform = F2(
	function (platformID, _v0) {
		var fields = _v0;
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.wm;
				},
				A2($elm$core$Dict$get, platformID, fields.Fh)));
	});
var $author$project$Model$BuildPlanner$BuildGraph$CamelBuildGraph$getStartedAt = function (_v0) {
	var fields = _v0;
	return fields.Ae;
};
var $author$project$Model$BuildPlanner$BuildGraph$CamelBuildGraph$isIndemnified = function (_v0) {
	var fields = _v0;
	return fields.Dm;
};
var $author$project$Model$BuildPlanner$Artifact$logURL = function (a) {
	switch (a.$) {
		case 0:
			var data = a.a;
			return data.rq;
		case 3:
			var data = a.a;
			return data.rq;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$BuildPlanner$Source$mimetype = function (_v0) {
	var data = _v0;
	return data.je;
};
var $author$project$Model$BuildPlanner$Artifact$successful = function (a) {
	if (!a.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Model$ProgressTracker$camelBuildGraphInit = function (_v0) {
	var org = _v0.pd;
	var project = _v0.c5;
	var branch = _v0.h4;
	var platform = _v0.po;
	var languages = _v0.aM;
	var commitID = _v0.BR;
	var camelBuildGraph = _v0.xx;
	var platformID = $author$project$Model$Platform$id(platform);
	var sources = A2($author$project$Model$BuildPlanner$BuildGraph$CamelBuildGraph$getSourcesForPlatform, platformID, camelBuildGraph);
	var getPackageInfoFromSource = function (source) {
		var id = $author$project$Model$BuildPlanner$Source$idStr(source);
		return _Utils_Tuple2(
			id,
			{
				oq: 1,
				x8: $elm$core$Maybe$Nothing,
				yc: $elm$core$Maybe$Nothing,
				oB: '',
				l6: id,
				oV: true,
				je: $elm$core$Maybe$Just(
					$author$project$Model$BuildPlanner$Source$mimetype(source)),
				w: $author$project$Model$BuildPlanner$Source$name(source),
				aE: $author$project$Model$BuildPlanner$Source$namespace(source),
				du: $elm$core$Maybe$Nothing,
				bB: 0,
				aI: $author$project$Model$BuildPlanner$Source$version(source)
			});
	};
	var getPackageInfoFromArtifact = function (artifact) {
		var endTime = A3(
			$elm$core$Maybe$map2,
			$author$project$TimeUtils$add,
			$author$project$Model$BuildPlanner$Artifact$startedAt(artifact),
			$author$project$Model$BuildPlanner$Artifact$buildDurationMillis(artifact));
		var displayName = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($author$project$Model$BuildPlanner$Artifact$displayNameForPlatform, platform, artifact));
		return (!$elm$core$String$isEmpty(displayName)) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(
				$author$project$Model$BuildPlanner$Artifact$idStr(artifact),
				{
					oq: 1,
					x8: $author$project$Model$BuildPlanner$Artifact$url(artifact),
					yc: endTime,
					oB: '',
					l6: $author$project$Model$BuildPlanner$Artifact$idStr(artifact),
					oV: true,
					je: $elm$core$Maybe$Just(
						$author$project$Model$BuildPlanner$Artifact$mimetype(artifact)),
					w: displayName,
					aE: '',
					du: $author$project$Model$BuildPlanner$Artifact$startedAt(artifact),
					bB: $author$project$Model$ProgressTracker$artifactStatusToPackageState(
						$author$project$Model$BuildPlanner$Artifact$status(artifact)),
					aI: ''
				})) : $elm$core$Maybe$Nothing;
	};
	var artifacts = A2($author$project$Model$BuildPlanner$BuildGraph$CamelBuildGraph$getArtifactsForPlatform, platformID, camelBuildGraph);
	var buildSuccessful = A2($elm$core$List$all, $author$project$Model$BuildPlanner$Artifact$successful, artifacts);
	var status = A2($elm$core$List$any, $author$project$Model$BuildPlanner$Artifact$isFailed, artifacts) ? 2 : (A2($elm$core$List$any, $author$project$Model$BuildPlanner$Artifact$inProgress, artifacts) ? 0 : 1);
	var buildFailed = status === 2;
	var flipCamelPackagesIfBuildComplete = function () {
		var transformSuccessful = $elm$core$Tuple$mapSecond(
			function (packageInfo) {
				return _Utils_update(
					packageInfo,
					{bB: 2});
			});
		var transformFailed = $elm$core$Tuple$mapSecond(
			function (packageInfo) {
				return (!packageInfo.bB) ? _Utils_update(
					packageInfo,
					{bB: 4}) : packageInfo;
			});
		return buildSuccessful ? $elm$core$List$map(transformSuccessful) : (buildFailed ? $elm$core$List$map(transformFailed) : $elm$core$Basics$identity);
	}();
	var packageProgress = $elm$core$Dict$fromList(
		flipCamelPackagesIfBuildComplete(
			_Utils_ap(
				A2($elm$core$List$map, getPackageInfoFromSource, sources),
				A2($elm$core$List$filterMap, getPackageInfoFromArtifact, artifacts))));
	var completedArtifactsCount = $elm$core$Dict$size(
		A2(
			$elm$core$Dict$filter,
			$elm$core$Basics$always($author$project$Model$ProgressTracker$isSuccessfulPackage),
			packageProgress));
	var buildProgress = function () {
		var failedArtifacts = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$singleton,
				A2(
					$elm_community$list_extra$List$Extra$find,
					function (artifact) {
						return $author$project$Model$BuildPlanner$Artifact$isFailed(artifact) && $author$project$Model$BuildPlanner$Artifact$isCamelInstaller(artifact);
					},
					artifacts)));
		var _v1 = A2(
			$elm$core$Tuple$pair,
			$elm$core$Maybe$Just('One or More packages failed to build'),
			$elm$core$List$concat(
				A2($elm$core$List$map, $author$project$Model$BuildPlanner$Artifact$errors, failedArtifacts)));
		var reason = _v1.a;
		var errors = _v1.b;
		return {
			yc: $author$project$Model$BuildPlanner$BuildGraph$CamelBuildGraph$getFinishedAt(camelBuildGraph),
			yf: errors,
			cg: reason,
			du: $author$project$Model$BuildPlanner$BuildGraph$CamelBuildGraph$getStartedAt(camelBuildGraph),
			kz: completedArtifactsCount,
			nH: $elm$core$Dict$size(packageProgress)
		};
	}();
	return {
		h4: branch,
		h6: buildProgress,
		qt: 0,
		s0: A2(
			$elm$core$Maybe$andThen,
			$author$project$Model$BuildPlanner$Artifact$logURL,
			A2($elm_community$list_extra$List$Extra$find, $author$project$Model$BuildPlanner$Artifact$isInstaller, artifacts)),
		BR: commitID,
		tr: '',
		tH: A2($author$project$Model$BuildPlanner$BuildGraph$CamelBuildGraph$getDownloadsForPlatform, platformID, camelBuildGraph),
		ud: $author$project$Model$BuildPlanner$BuildGraph$CamelBuildGraph$isIndemnified(camelBuildGraph),
		aM: languages,
		c3: org,
		hI: packageProgress,
		po: platform,
		c5: project,
		kw: false,
		L: status,
		wC: A2($elm$core$List$map, $author$project$Model$BuildPlanner$Artifact$idStr, artifacts)
	};
};
var $author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$BuildPlanner$BuildGraph$CamelBuildGraph = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$BuildPlanner$BuildGraph$PrePlatformBuildGraph = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$AltBuildGraph = $elm$core$Basics$identity;
var $author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$RuntimeDep = 2;
var $author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$getByUuid = F2(
	function (dict, id) {
		return A2(
			$elm$core$Dict$get,
			$danyx23$elm_uuid$Uuid$toString(id),
			dict);
	});
var $author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$makeEdge = F4(
	function (dict, label, from, to) {
		return A4(
			$elm$core$Maybe$map3,
			$elm_community$graph$Graph$Edge,
			A2($author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$getByUuid, dict, from),
			A2($author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$getByUuid, dict, to),
			$elm$core$Maybe$Just(label));
	});
var $author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$makeRuntimeEdges = F2(
	function (dict, node) {
		return A2(
			$elm$core$List$filterMap,
			A3(
				$author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$makeEdge,
				dict,
				2,
				$author$project$Model$BuildPlanner$Node$id(node)),
			$author$project$Model$BuildPlanner$Node$runtimeDependencies(node));
	});
var $author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$BuildDep = 1;
var $author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$Builder = 3;
var $author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$Src = 0;
var $author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$makeStepEdgesForOutputAndInput = F3(
	function (dict, output, input) {
		switch (input.$) {
			case 0:
				var ids = input.a;
				return A2(
					$elm$core$List$filterMap,
					A3($author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$makeEdge, dict, 0, output),
					ids);
			case 3:
				var ids = input.a;
				return A2(
					$elm$core$List$filterMap,
					A3($author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$makeEdge, dict, 1, output),
					ids);
			case 2:
				var ids = input.a;
				return A2(
					$elm$core$List$filterMap,
					A3($author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$makeEdge, dict, 3, output),
					ids);
			default:
				return _List_Nil;
		}
	});
var $author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$makeStepEdges = F2(
	function (dict, step) {
		return A2(
			$elm$core$List$concatMap,
			function (output) {
				return A2(
					$elm$core$List$concatMap,
					A2($author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$makeStepEdgesForOutputAndInput, dict, output),
					$author$project$Model$BuildPlanner$Step$inputs(step));
			},
			$author$project$Model$BuildPlanner$Step$outputs(step));
	});
var $author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$makeUuidToGraphId = function () {
	var helper = function (_v0) {
		var id = _v0.l6;
		var label = _v0.b2;
		return A2(
			$elm$core$Dict$insert,
			$author$project$Model$BuildPlanner$Node$idStr(label),
			id);
	};
	return A2($elm$core$List$foldl, helper, $elm$core$Dict$empty);
}();
var $author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$createGraph = F2(
	function (nodes, steps) {
		var graphNodes = A2($elm$core$List$indexedMap, $elm_community$graph$Graph$Node, nodes);
		var nodeUuidToGraphId = $author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$makeUuidToGraphId(graphNodes);
		var graphEdges = _Utils_ap(
			A2(
				$elm$core$List$concatMap,
				$author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$makeStepEdges(nodeUuidToGraphId),
				steps),
			A2(
				$elm$core$List$concatMap,
				$author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$makeRuntimeEdges(nodeUuidToGraphId),
				nodes));
		return _Utils_Tuple2(
			A2($elm_community$graph$Graph$fromNodesAndEdges, graphNodes, graphEdges),
			nodeUuidToGraphId);
	});
var $author$project$Model$BuildPlanner$BuildPlan$finishedAt = function (buildPlan) {
	var _v0 = buildPlan.bB;
	switch (_v0.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Nothing;
		case 2:
			return $elm$core$Maybe$Nothing;
		default:
			var data = _v0.a;
			return $elm$core$Maybe$Just(data.yl);
	}
};
var $author$project$Model$BuildPlanner$Node$isIndemnified = function (node) {
	if (node.$ === 1) {
		var s = node.a;
		return $author$project$Model$BuildPlanner$Source$isIndemnified(s);
	} else {
		return true;
	}
};
var $author$project$Model$BuildPlanner$BuildPlan$isIndemnified = function (buildPlan) {
	return A2($elm$core$List$all, $author$project$Model$BuildPlanner$Node$isIndemnified, buildPlan.g9);
};
var $author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$ArtifactBuilderMapping = F2(
	function (artifact, builder) {
		return {xe: artifact, xu: builder};
	});
var $author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$getArtifactBuilder = F2(
	function (graph, artifactGraphId) {
		var helper = F3(
			function (graphId, edgeLabel, acc) {
				if (!acc.$) {
					var builder = acc.a;
					return $elm$core$Maybe$Just(builder);
				} else {
					if (edgeLabel === 3) {
						return A2(
							$elm$core$Maybe$andThen,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.mL;
								},
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.b2;
									},
									$author$project$Model$BuildPlanner$Node$artifact)),
							A2($elm_community$graph$Graph$get, graphId, graph));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}
			});
		var directEdges = A2(
			$elm$core$Maybe$withDefault,
			$elm_community$intdict$IntDict$empty,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.rM;
				},
				A2($elm_community$graph$Graph$get, artifactGraphId, graph)));
		return A3($elm_community$intdict$IntDict$foldl, helper, $elm$core$Maybe$Nothing, directEdges);
	});
var $author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$accumArtifactsBuilderMappings = F3(
	function (graph, ctx, acc) {
		var graphNode = ctx.mL;
		var _v0 = $author$project$Model$BuildPlanner$Node$artifact(graphNode.b2);
		if (_v0.$ === 1) {
			return acc;
		} else {
			var artifact = _v0.a;
			if ($author$project$Model$BuildPlanner$Artifact$isBuilder(artifact)) {
				return acc;
			} else {
				var _v1 = A2($author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$getArtifactBuilder, graph, graphNode.l6);
				if (_v1.$ === 1) {
					return acc;
				} else {
					var builder = _v1.a;
					return A3(
						$elm$core$Dict$insert,
						$author$project$Model$BuildPlanner$Artifact$idStr(artifact),
						_Utils_Tuple2(
							graphNode.l6,
							A2($author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$ArtifactBuilderMapping, artifact, builder)),
						acc);
				}
			}
		}
	});
var $elm$regex$Regex$findAtMost = _Regex_findAtMost;
var $elm_community$string_extra$String$Extra$firstResultHelp = F2(
	function (_default, list) {
		firstResultHelp:
		while (true) {
			if (!list.b) {
				return _default;
			} else {
				if (!list.a.$) {
					var a = list.a.a;
					return a;
				} else {
					var _v1 = list.a;
					var rest = list.b;
					var $temp$default = _default,
						$temp$list = rest;
					_default = $temp$default;
					list = $temp$list;
					continue firstResultHelp;
				}
			}
		}
	});
var $elm_community$string_extra$String$Extra$firstResult = function (list) {
	return A2($elm_community$string_extra$String$Extra$firstResultHelp, '', list);
};
var $elm_community$string_extra$String$Extra$regexEscape = A2(
	$elm$regex$Regex$replace,
	$elm_community$string_extra$String$Extra$regexFromString('[-/\\^$*+?.()|[\\]{}]'),
	function (_v0) {
		var match = _v0.o0;
		return '\\' + match;
	});
var $elm_community$string_extra$String$Extra$leftOf = F2(
	function (pattern, string) {
		return A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.wu;
					},
					$elm_community$string_extra$String$Extra$firstResult),
				A3(
					$elm$regex$Regex$findAtMost,
					1,
					$elm_community$string_extra$String$Extra$regexFromString(
						'^(.*?)' + $elm_community$string_extra$String$Extra$regexEscape(pattern)),
					string)));
	});
var $elm_community$string_extra$String$Extra$rightOfBack = F2(
	function (pattern, string) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Basics$add(
						$elm$core$String$length(pattern)),
					function (a) {
						return A2($elm$core$String$dropLeft, a, string);
					}),
				$elm$core$List$head(
					$elm$core$List$reverse(
						A2($elm$core$String$indexes, pattern, string)))));
	});
var $author$project$Model$DownloadURI$fileName = function (uri) {
	return A2(
		$elm_community$string_extra$String$Extra$leftOf,
		'?',
		A2($elm_community$string_extra$String$Extra$rightOfBack, '/', '/' + (uri + '?')));
};
var $author$project$Model$DownloadURI$isPrimaryDownload = function (uri) {
	return !A2(
		$elm$core$List$any,
		$elm$core$Basics$apR(uri),
		_List_fromArray(
			[
				$elm$core$String$endsWith('.json'),
				$elm$core$String$endsWith('.txt'),
				$elm$core$String$endsWith('-tests.zip'),
				$elm$core$String$endsWith('-tests.tar.gz'),
				$elm$core$String$endsWith('.log'),
				$elm$core$String$contains('-source-'),
				$elm$core$String$contains('.zip'),
				$elm$core$String$contains('-configs'),
				A2(
				$author$project$Misc$isBoth,
				$elm$core$String$endsWith('.tar.gz'),
				$elm$core$String$contains('macosx'))
			]));
};
var $author$project$Model$BuildPlanner$Artifact$isSigner = A2(
	$elm$core$Basics$composeR,
	$author$project$Model$BuildPlanner$Artifact$displayName,
	A2(
		$elm_community$basics_extra$Basics$Extra$flip,
		$elm$core$List$member,
		_List_fromArray(
			['installer-authenticode-signer'])));
var $author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$getDownload = function (_v0) {
	var artifact = _v0.xe;
	var builder = _v0.xu;
	return A2(
		$elm$core$Maybe$map,
		function (url) {
			return {
				Dd: $author$project$Model$BuildPlanner$Artifact$isDocker(artifact),
				yL: $author$project$Model$BuildPlanner$Artifact$isInstaller(artifact),
				Dx: $author$project$Model$DownloadURI$isPrimaryDownload(url),
				yO: $author$project$Model$BuildPlanner$Artifact$isSigner(builder),
				GT: url
			};
		},
		$author$project$Model$BuildPlanner$Artifact$url(artifact));
};
var $author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$getDownloads = function (artifactBuilderMapping) {
	var filteredDownloads = A2($elm$core$List$filterMap, $author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$getDownload, artifactBuilderMapping);
	var _v0 = A2(
		$elm$core$List$partition,
		function ($) {
			return $.yL;
		},
		filteredDownloads);
	var installers = _v0.a;
	var nonInstallers = _v0.b;
	var _v1 = A2(
		$elm$core$List$partition,
		function ($) {
			return $.yO;
		},
		installers);
	var signedInstallers = _v1.a;
	var unsignedInstallers = _v1.b;
	var effectiveInstallers = $elm$core$List$isEmpty(signedInstallers) ? unsignedInstallers : signedInstallers;
	return A2(
		$elm$core$List$sortBy,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.GT;
			},
			$author$project$Model$DownloadURI$fileName),
		_Utils_ap(effectiveInstallers, nonInstallers));
};
var $author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$makeSourcesArtifactBuilderMapping = F2(
	function (graph, _v0) {
		var graphId = _v0.a;
		var artifactBuilderMapping = _v0.b;
		var alongSrcEdges = function (ctx) {
			return $elm_community$intdict$IntDict$keys(
				A2(
					$elm_community$intdict$IntDict$filter,
					function (_v1) {
						return $elm$core$Basics$eq(0);
					},
					ctx.rM));
		};
		var sources = A5(
			$elm_community$graph$Graph$guidedDfs,
			alongSrcEdges,
			$elm_community$graph$Graph$onDiscovery(
				F2(
					function (ctx, acc) {
						return _Utils_ap(
							$elm_community$maybe_extra$Maybe$Extra$toList(
								$author$project$Model$BuildPlanner$Node$source(ctx.mL.b2)),
							acc);
					})),
			_List_fromArray(
				[graphId]),
			_List_Nil,
			graph).a;
		return {ql: artifactBuilderMapping, wm: sources};
	});
var $author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$makeTerminalArtifacts = F3(
	function (graph, dict, terminalNodeIds) {
		var helper = function (terminalNodeId) {
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Basics$identity,
				A2(
					$elm$core$Maybe$andThen,
					function (graphId) {
						return A2(
							$elm$core$Maybe$map,
							$elm_community$intdict$IntDict$insert(graphId),
							A2(
								$elm$core$Maybe$andThen,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.mL;
									},
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.b2;
										},
										$author$project$Model$BuildPlanner$Node$artifact)),
								A2($elm_community$graph$Graph$get, graphId, graph)));
					},
					A2($author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$getByUuid, dict, terminalNodeId)));
		};
		return A3($elm$core$List$foldl, helper, $elm_community$intdict$IntDict$empty, terminalNodeIds);
	});
var $author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$SourceArtifactBuilderMapping = F2(
	function (source, artifactBuilderMapping) {
		return {ql: artifactBuilderMapping, o: source};
	});
var $author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$partitionSingleVsMultiSourceArtifactBuilderMappings = function () {
	var helper = F2(
		function (_v1, _v2) {
			var sources = _v1.wm;
			var artifactBuilderMapping = _v1.ql;
			var singleSourceAcc = _v2.a;
			var multiSourceAcc = _v2.b;
			if (sources.b && (!sources.b.b)) {
				var source = sources.a;
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						A2($author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$SourceArtifactBuilderMapping, source, artifactBuilderMapping),
						singleSourceAcc),
					multiSourceAcc);
			} else {
				return _Utils_Tuple2(
					singleSourceAcc,
					A2($elm$core$List$cons, artifactBuilderMapping, multiSourceAcc));
			}
		});
	return A2(
		$elm$core$Basics$composeR,
		A2(
			$elm$core$List$foldl,
			helper,
			_Utils_Tuple2(_List_Nil, _List_Nil)),
		A2($elm$core$Tuple$mapBoth, $elm$core$List$reverse, $elm$core$List$reverse));
}();
var $elm_community$intdict$IntDict$values = function (dict) {
	return A3(
		$elm_community$intdict$IntDict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$makePlatform = F3(
	function (graph, dict, terminalNodeIds) {
		var terminalArtifacts = A3($author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$makeTerminalArtifacts, graph, dict, terminalNodeIds);
		var artifactBuilderMappings = $elm$core$Dict$values(
			A5(
				$elm_community$graph$Graph$guidedDfs,
				$elm_community$graph$Graph$alongOutgoingEdges,
				$elm_community$graph$Graph$onDiscovery(
					$author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$accumArtifactsBuilderMappings(graph)),
				$elm_community$intdict$IntDict$keys(terminalArtifacts),
				$elm$core$Dict$empty,
				graph).a);
		var sourcesArtifactBuilderMappings = A2(
			$elm$core$List$map,
			$author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$makeSourcesArtifactBuilderMapping(graph),
			artifactBuilderMappings);
		var _v0 = $author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$partitionSingleVsMultiSourceArtifactBuilderMappings(sourcesArtifactBuilderMappings);
		var singleSourceArtifactBuilderMappings = _v0.a;
		var otherArtifactBuilderMappings = _v0.b;
		return {
			sT: otherArtifactBuilderMappings,
			tH: $author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$getDownloads(otherArtifactBuilderMappings),
			wl: singleSourceArtifactBuilderMappings,
			wD: $elm_community$intdict$IntDict$values(terminalArtifacts)
		};
	});
var $author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$makePlatforms = F2(
	function (graph, dict) {
		var helper = F2(
			function (terminal, acc) {
				if (terminal.$ === 1) {
					var platformID = terminal.a;
					var terminalNodeIds = terminal.b;
					return A3(
						$elm$core$Dict$insert,
						platformID,
						A3($author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$makePlatform, graph, dict, terminalNodeIds),
						acc);
				} else {
					return acc;
				}
			});
		return A2($elm$core$List$foldl, helper, $elm$core$Dict$empty);
	});
var $author$project$Model$BuildPlanner$BuildPlan$startedAt = function (_v0) {
	return $elm$core$Maybe$Nothing;
};
var $author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$fromBuildPlan = function (buildPlan) {
	var _v0 = A2($author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$createGraph, buildPlan.g9, buildPlan.Gi);
	var graph = _v0.a;
	var nodeUuidToGraphId = _v0.b;
	return {
		yl: $author$project$Model$BuildPlanner$BuildPlan$finishedAt(buildPlan),
		Dm: $author$project$Model$BuildPlanner$BuildPlan$isIndemnified(buildPlan),
		Fh: A3($author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$makePlatforms, graph, nodeUuidToGraphId, buildPlan.Gu),
		Ae: $author$project$Model$BuildPlanner$BuildPlan$startedAt(buildPlan)
	};
};
var $author$project$Model$BuildPlanner$BuildGraph$CamelBuildGraph$CamelBuildGraph = $elm$core$Basics$identity;
var $author$project$Model$BuildPlanner$BuildGraph$CamelBuildGraph$getByUuid = F2(
	function (dict, id) {
		return A2(
			$elm$core$Dict$get,
			$danyx23$elm_uuid$Uuid$toString(id),
			dict);
	});
var $author$project$Model$DownloadURI$isWorkingDownload = function (uri) {
	return !A2(
		$elm$core$List$any,
		$elm$core$Basics$apR(uri),
		_List_fromArray(
			[
				A2(
				$author$project$Misc$isBoth,
				$elm$core$String$contains('ActiveTcl'),
				$elm$core$String$endsWith('.zip'))
			]));
};
var $author$project$Model$BuildPlanner$BuildGraph$CamelBuildGraph$getDownload = function (artifact) {
	return A2(
		$elm$core$Maybe$andThen,
		function (url) {
			return $author$project$Model$DownloadURI$isWorkingDownload(url) ? $elm$core$Maybe$Just(
				{
					Dd: false,
					yL: $author$project$Model$BuildPlanner$Artifact$isInstaller(artifact),
					Dx: $author$project$Model$DownloadURI$isPrimaryDownload(url),
					yO: false,
					GT: url
				}) : $elm$core$Maybe$Nothing;
		},
		$author$project$Model$BuildPlanner$Artifact$url(artifact));
};
var $author$project$Model$BuildPlanner$BuildGraph$CamelBuildGraph$getDownloads = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$filterMap($author$project$Model$BuildPlanner$BuildGraph$CamelBuildGraph$getDownload),
	$elm$core$List$sortBy(
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.GT;
			},
			$author$project$Model$DownloadURI$fileName)));
var $author$project$Model$BuildPlanner$BuildGraph$CamelBuildGraph$computePlatforms = F5(
	function (sources, artifacts, steps, terminals, buildLogIds) {
		var uuidToSource = A2($elm_community$dict_extra$Dict$Extra$fromListBy, $author$project$Model$BuildPlanner$Source$idStr, sources);
		var uuidToArtifact = A2($elm_community$dict_extra$Dict$Extra$fromListBy, $author$project$Model$BuildPlanner$Artifact$idStr, artifacts);
		var getSrcNodeIds = function (input) {
			if (!input.$) {
				var inputNodeIds = input.a;
				return inputNodeIds;
			} else {
				return _List_Nil;
			}
		};
		var outputNodeIdsToInputNodeIds = A2(
			$elm$core$List$map,
			function (step) {
				return _Utils_Tuple2(
					$author$project$Model$BuildPlanner$Step$outputs(step),
					A2(
						$elm$core$List$concatMap,
						getSrcNodeIds,
						$author$project$Model$BuildPlanner$Step$inputs(step)));
			},
			steps);
		var getInputNodeIdsForOutputNodeIds = function (outputNodeIds) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$second,
					A2(
						$elm_community$list_extra$List$Extra$find,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$first,
							$elm$core$Basics$eq(outputNodeIds)),
						outputNodeIdsToInputNodeIds)));
		};
		var getBuildLogIds = function (platformID) {
			return A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.Fe;
					},
					$elm$core$Basics$eq(platformID)),
				buildLogIds);
		};
		var getPlatformData = function (terminal) {
			if (terminal.$ === 1) {
				var platformID = terminal.a;
				var outputNodeIds = terminal.b;
				var inputNodeIds = getInputNodeIdsForOutputNodeIds(outputNodeIds);
				var filteredSources = A2(
					$elm$core$List$filterMap,
					$author$project$Model$BuildPlanner$BuildGraph$CamelBuildGraph$getByUuid(uuidToSource),
					inputNodeIds);
				var filteredArtifacts = A2(
					$elm$core$List$filterMap,
					$author$project$Model$BuildPlanner$BuildGraph$CamelBuildGraph$getByUuid(uuidToArtifact),
					outputNodeIds);
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(
						platformID,
						{
							sU: filteredArtifacts,
							s_: getBuildLogIds(platformID),
							tH: $author$project$Model$BuildPlanner$BuildGraph$CamelBuildGraph$getDownloads(filteredArtifacts),
							wm: filteredSources
						}));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		return $elm$core$Dict$fromList(
			A2($elm$core$List$filterMap, getPlatformData, terminals));
	});
var $author$project$Model$BuildPlanner$MissingSource$isCamel = function (_v0) {
	var data = _v0;
	return data.w === 'camel';
};
var $author$project$Model$BuildPlanner$Source$isCamel = function (_v0) {
	var data = _v0;
	return data.w === 'camel';
};
var $author$project$Model$BuildPlanner$Node$isCamel = function (node) {
	switch (node.$) {
		case 1:
			var s = node.a;
			return $author$project$Model$BuildPlanner$Source$isCamel(s);
		case 0:
			var a = node.a;
			return $author$project$Model$BuildPlanner$Artifact$isCamelInstaller(a);
		default:
			var s = node.a;
			return $author$project$Model$BuildPlanner$MissingSource$isCamel(s);
	}
};
var $author$project$Model$BuildPlanner$BuildPlan$isCamel = function (buildPlan) {
	return A2($elm$core$List$any, $author$project$Model$BuildPlanner$Node$isCamel, buildPlan.g9);
};
var $author$project$Model$BuildPlanner$BuildGraph$CamelBuildGraph$fromBuildPlan = function (buildPlan) {
	if ($author$project$Model$BuildPlanner$BuildPlan$isCamel(buildPlan)) {
		var sources = A2($elm$core$List$filterMap, $author$project$Model$BuildPlanner$Node$source, buildPlan.g9);
		var artifacts = A2($elm$core$List$filterMap, $author$project$Model$BuildPlanner$Node$artifact, buildPlan.g9);
		return $elm$core$Maybe$Just(
			{
				yl: $author$project$Model$BuildPlanner$BuildPlan$finishedAt(buildPlan),
				Dm: A2($elm$core$List$all, $author$project$Model$BuildPlanner$Source$isIndemnified, sources),
				Fh: A5(
					$author$project$Model$BuildPlanner$BuildGraph$CamelBuildGraph$computePlatforms,
					sources,
					artifacts,
					buildPlan.Gi,
					buildPlan.Gu,
					$author$project$Model$BuildPlanner$BuildPlan$buildLogIds(buildPlan)),
				Ae: $author$project$Model$BuildPlanner$BuildPlan$startedAt(buildPlan)
			});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$BuildPlanner$BuildGraph$PrePlatformBuildGraph$PrePlatformBuildGraph = $elm$core$Basics$identity;
var $author$project$Model$BuildPlanner$Source$url = function (_v0) {
	var data = _v0;
	return data.GT;
};
var $author$project$Model$BuildPlanner$BuildGraph$PrePlatformBuildGraph$getDownload = function (source) {
	var url = $author$project$Model$BuildPlanner$Source$url(source);
	return $author$project$Model$DownloadURI$isWorkingDownload(url) ? $elm$core$Maybe$Just(
		{
			Dd: false,
			yL: false,
			Dx: $author$project$Model$DownloadURI$isPrimaryDownload(url),
			yO: false,
			GT: url
		}) : $elm$core$Maybe$Nothing;
};
var $author$project$Model$BuildPlanner$BuildGraph$PrePlatformBuildGraph$getDownloads = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$filterMap($author$project$Model$BuildPlanner$BuildGraph$PrePlatformBuildGraph$getDownload),
	$elm$core$List$sortBy(
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.GT;
			},
			$author$project$Model$DownloadURI$fileName)));
var $author$project$Model$BuildPlanner$BuildGraph$PrePlatformBuildGraph$computePlatforms = F2(
	function (sources, terminals) {
		var findSourceById = function (id) {
			return A2(
				$elm_community$list_extra$List$Extra$find,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Model$BuildPlanner$Source$id,
					$elm$core$Basics$eq(id)),
				sources);
		};
		var getPlatformData = function (terminal) {
			if (terminal.$ === 1) {
				var platformID = terminal.a;
				var nodeIds = terminal.b;
				var filteredSources = A2($elm$core$List$filterMap, findSourceById, nodeIds);
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(
						platformID,
						{
							tH: $author$project$Model$BuildPlanner$BuildGraph$PrePlatformBuildGraph$getDownloads(filteredSources),
							wm: filteredSources
						}));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		return $elm$core$Dict$fromList(
			A2($elm$core$List$filterMap, getPlatformData, terminals));
	});
var $author$project$Model$BuildPlanner$Source$isPrePlatformInstaller = function (_v0) {
	var data = _v0;
	return _Utils_eq(data.aE, $author$project$Model$Namespace$prePlatformInstaller);
};
var $author$project$Model$BuildPlanner$Node$isPrePlatformInstaller = function (node) {
	if (node.$ === 1) {
		var s = node.a;
		return $author$project$Model$BuildPlanner$Source$isPrePlatformInstaller(s);
	} else {
		return false;
	}
};
var $author$project$Model$BuildPlanner$BuildPlan$isPrePlatform = function (buildPlan) {
	return A2($elm$core$List$any, $author$project$Model$BuildPlanner$Node$isPrePlatformInstaller, buildPlan.g9);
};
var $author$project$Model$BuildPlanner$BuildGraph$PrePlatformBuildGraph$fromBuildPlan = function (buildPlan) {
	if ($author$project$Model$BuildPlanner$BuildPlan$isPrePlatform(buildPlan)) {
		var sources = A2($elm$core$List$filterMap, $author$project$Model$BuildPlanner$Node$source, buildPlan.g9);
		return $elm$core$Maybe$Just(
			{
				Fh: A2($author$project$Model$BuildPlanner$BuildGraph$PrePlatformBuildGraph$computePlatforms, sources, buildPlan.Gu)
			});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$BuildPlanner$BuildGraph$fromBuildPlan = function (buildPlan) {
	var _v0 = $author$project$Model$BuildPlanner$BuildGraph$PrePlatformBuildGraph$fromBuildPlan(buildPlan);
	if (!_v0.$) {
		var prePlatformBuildGraph = _v0.a;
		return $author$project$Model$BuildPlanner$BuildGraph$PrePlatformBuildGraph(prePlatformBuildGraph);
	} else {
		var _v1 = $author$project$Model$BuildPlanner$BuildGraph$CamelBuildGraph$fromBuildPlan(buildPlan);
		if (!_v1.$) {
			var camelBuildGraph = _v1.a;
			return $author$project$Model$BuildPlanner$BuildGraph$CamelBuildGraph(camelBuildGraph);
		} else {
			return $author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph(
				$author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$fromBuildPlan(buildPlan));
		}
	}
};
var $author$project$Model$ProgressTracker$buildPlanInit = function (_v0) {
	var org = _v0.pd;
	var project = _v0.c5;
	var branch = _v0.h4;
	var platforms = _v0.Fh;
	var languages = _v0.aM;
	var commitID = _v0.BR;
	var buildPlan = _v0.xt;
	var orgSubset = {sP: org.sP, AC: org.AC};
	var makeCamelProgressTracker = F2(
		function (camelBuildGraph, platform) {
			return $author$project$Model$ProgressTracker$camelBuildGraphInit(
				{h4: branch, xx: camelBuildGraph, BR: commitID, aM: languages, pd: orgSubset, po: platform, c5: project});
		});
	var makeAltProgressTracker = F2(
		function (altBuildGraph, platform) {
			return $author$project$Model$ProgressTracker$altBuildGraphInit(
				{xd: altBuildGraph, h4: branch, BR: commitID, aM: languages, pd: orgSubset, po: platform, c5: project});
		});
	var _v1 = $author$project$Model$BuildPlanner$BuildGraph$fromBuildPlan(buildPlan);
	switch (_v1.$) {
		case 0:
			var prePlatformBuildGraph = _v1.a;
			return $elm$core$Result$Err(prePlatformBuildGraph);
		case 1:
			var camelBuildGraph = _v1.a;
			return $elm$core$Result$Ok(
				A2(
					$elm$core$List$map,
					makeCamelProgressTracker(camelBuildGraph),
					platforms));
		default:
			var altBuildGraph = _v1.a;
			return $elm$core$Result$Ok(
				A2(
					$elm$core$List$map,
					makeAltProgressTracker(altBuildGraph),
					platforms));
	}
};
var $author$project$Pages$ProjectDownloads$buildPlanTask = F3(
	function (session, model, commitID) {
		return A3(
			$author$project$Request$BuildPlanner$getBuildPlan,
			session,
			false,
			{
				BR: commitID,
				ix: $author$project$Model$Organization$getUrlName(model.c3),
				vT: $author$project$Model$Project$getName(model.c5)
			});
	});
var $author$project$Ports$downloadFileWithText = _Platform_outgoingPort(
	'downloadFileWithText',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'content',
					$elm$json$Json$Encode$string($.dH)),
					_Utils_Tuple2(
					'filename',
					$elm$json$Json$Encode$string($.CG))
				]));
	});
var $author$project$Model$Platform$isPlatformType = F2(
	function (platformType, platform) {
		return _Utils_eq(
			platformType,
			$author$project$Model$Platform$getPlatformType(platform));
	});
var $author$project$Pages$ProjectDownloads$findSelectedPlatformID = F2(
	function (session, _v0) {
		var selectedPlatformID = _v0.fE;
		var platforms = _v0.Fh;
		var validatedSelectedPlatform = A2(
			$elm$core$Maybe$andThen,
			function (platformID) {
				return A2(
					$elm_community$list_extra$List$Extra$find,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Model$Platform$id,
						$elm$core$Basics$eq(platformID)),
					platforms);
			},
			selectedPlatformID);
		var userPlatformType = A2(
			$elm$core$Maybe$withDefault,
			0,
			$author$project$Model$Platform$detectPlatformType(
				$author$project$Model$Session$getPlatform(session)));
		var defaultPlatform = A2(
			$elm_community$maybe_extra$Maybe$Extra$or,
			A2(
				$elm_community$list_extra$List$Extra$find,
				$author$project$Model$Platform$isPlatformType(userPlatformType),
				platforms),
			$elm$core$List$head(platforms));
		return A2(
			$elm$core$Maybe$map,
			$author$project$Model$Platform$id,
			A2($elm_community$maybe_extra$Maybe$Extra$or, validatedSelectedPlatform, defaultPlatform));
	});
var $author$project$Model$BuildPlanner$BuildGraph$PrePlatformBuildGraph$getDownloadsForPlatform = F2(
	function (platformID, _v0) {
		var fields = _v0;
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.tH;
				},
				A2($elm$core$Dict$get, platformID, fields.Fh)));
	});
var $author$project$Model$BuildPlanner$BuildGraph$getDownloadsForPlatform = F2(
	function (platformID, buildGraph) {
		switch (buildGraph.$) {
			case 0:
				var prePlatformBuildGraph = buildGraph.a;
				return A2($author$project$Model$BuildPlanner$BuildGraph$PrePlatformBuildGraph$getDownloadsForPlatform, platformID, prePlatformBuildGraph);
			case 1:
				var camelBuildGraph = buildGraph.a;
				return A2($author$project$Model$BuildPlanner$BuildGraph$CamelBuildGraph$getDownloadsForPlatform, platformID, camelBuildGraph);
			default:
				var altBuildGraph = buildGraph.a;
				return A2($author$project$Model$BuildPlanner$BuildGraph$AltBuildGraph$getDownloadsForPlatform, platformID, altBuildGraph);
		}
	});
var $author$project$Model$BuildDataSource$getLanguages = function (_v0) {
	var cached = _v0.df;
	return cached.aM;
};
var $author$project$Pages$ProjectDownloads$getPlatformIdsThatNeedUpdate = F2(
	function (model, buildLogId) {
		var _v0 = buildLogId.gR;
		if (!_v0) {
			return $elm_community$maybe_extra$Maybe$Extra$toList(
				A2($elm$core$Dict$get, buildLogId.l6, model.qs));
		} else {
			return $elm$core$Dict$keys(model.ff);
		}
	});
var $author$project$Ports$openHubSpotChat = _Platform_outgoingPort(
	'openHubSpotChat',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$openPopupWithContent = _Platform_outgoingPort('openPopupWithContent', $elm$json$Json$Encode$string);
var $author$project$Model$BuildPlanner$BuildPlan$platformIDs = function (buildPlan) {
	var parsePlatformID = function (nt) {
		if (nt.$ === 1) {
			var platformID = nt.a;
			return $elm$core$Maybe$Just(platformID);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	};
	return A2($elm$core$List$filterMap, parsePlatformID, buildPlan.Gu);
};
var $author$project$Request$HeadChef$rescheduleArtifact = F2(
	function (creds, artifactID) {
		return $author$project$Http$Extra$post(
			{
				iO: $author$project$Http$Extra$None,
				sY: $author$project$Http$Extra$emptyBody,
				qN: $elm$json$Json$Decode$succeed(0),
				CN: _List_fromArray(
					[
						_Utils_Tuple2(
						'Authorization',
						$author$project$Protected$getToken(creds))
					]),
				GT: '/sv/head-chef/artifacts/' + (artifactID + '/reschedule')
			});
	});
var $author$project$Pages$ProjectDownloads$NoOp = {$: 0};
var $author$project$Pages$ProjectDownloads$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Pages$ProjectDownloads$NoOp, 'Pages/ProjectDownloads.elm');
var $author$project$Pages$ProjectDownloads$setPlatformIdInUrlCmd = function (platformID) {
	return A2($author$project$Routing$setQueryParam, 'platformID', platformID);
};
var $author$project$Ports$startArtifactProgress = _Platform_outgoingPort(
	'startArtifactProgress',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'artifactID',
					$elm$json$Json$Encode$string($.xf)),
					_Utils_Tuple2(
					'authToken',
					$elm$json$Json$Encode$string($.qn)),
					_Utils_Tuple2(
					'platformID',
					$elm$json$Json$Encode$string($.m0)),
					_Utils_Tuple2(
					'url',
					$elm$json$Json$Encode$string($.GT))
				]));
	});
var $author$project$Pages$ProjectDownloads$startArtifactProgress = function (_v0) {
	var url = _v0.GT;
	var artifactID = _v0.xf;
	var platformID = _v0.m0;
	var authToken = _v0.qn;
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Platform$Cmd$none,
		A3(
			$elm$core$Maybe$map2,
			F2(
				function (artifact, platform) {
					return $author$project$Ports$startArtifactProgress(
						{xf: artifact, qn: authToken, m0: platform, GT: url});
				}),
			artifactID,
			platformID));
};
var $author$project$Ports$startBuildProgress = _Platform_outgoingPort(
	'startBuildProgress',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'authToken',
					$elm$json$Json$Encode$string($.qn)),
					_Utils_Tuple2(
					'partitionKey',
					$elm$json$Json$Encode$string($.E8)),
					_Utils_Tuple2(
					'partitionKeyValue',
					$elm$json$Json$Encode$string($.E9)),
					_Utils_Tuple2(
					'url',
					$elm$json$Json$Encode$string($.GT))
				]));
	});
var $author$project$Ports$stopArtifactProgress = _Platform_outgoingPort(
	'stopArtifactProgress',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'artifactID',
					$elm$json$Json$Encode$string($.xf)),
					_Utils_Tuple2(
					'platformID',
					$elm$json$Json$Encode$string($.m0))
				]));
	});
var $author$project$Pages$ProjectDownloads$stopArtifactProgress = function (_v0) {
	var artifactID = _v0.xf;
	var platformID = _v0.m0;
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Platform$Cmd$none,
		A3(
			$elm$core$Maybe$map2,
			F2(
				function (artifact, platform) {
					return $author$project$Ports$stopArtifactProgress(
						{xf: artifact, m0: platform});
				}),
			artifactID,
			platformID));
};
var $author$project$Model$ProgressTracker$togglePackages = function (tracker) {
	return _Utils_update(
		tracker,
		{kw: !tracker.kw});
};
var $author$project$Misc$updateDictExisting = F2(
	function (platformID, mapFn) {
		return A2(
			$elm$core$Dict$update,
			platformID,
			$elm$core$Maybe$map(mapFn));
	});
var $author$project$Pages$ProjectDownloads$updateLogs = F4(
	function (updateFn, platformID, artifactID, platformIdToArtifactIdToLogs) {
		var artifactIdToLogs = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Dict$empty,
			A2($elm$core$Dict$get, platformID, platformIdToArtifactIdToLogs));
		var logs = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2($elm$core$Dict$get, artifactID, artifactIdToLogs));
		return A3(
			$elm$core$Dict$insert,
			platformID,
			A3(
				$elm$core$Dict$insert,
				artifactID,
				updateFn(logs),
				artifactIdToLogs),
			platformIdToArtifactIdToLogs);
	});
var $author$project$Model$ProgressTracker$incrementSuccessfulPackages = function (info) {
	return _Utils_update(
		info,
		{
			kz: A2($elm$core$Basics$min, info.nH, info.kz + 1)
		});
};
var $author$project$TimeUtils$max = F2(
	function (a, b) {
		var _v0 = A2($author$project$TimeUtils$compare, a, b);
		if (_v0 === 2) {
			return a;
		} else {
			return b;
		}
	});
var $author$project$TimeUtils$min = F2(
	function (a, b) {
		var _v0 = A2($author$project$TimeUtils$compare, a, b);
		if (!_v0) {
			return a;
		} else {
			return b;
		}
	});
var $author$project$Model$ProgressTracker$computeBuildStateFromArtifacts = function (tracker) {
	var mergeMaybe = F3(
		function (func, mx, my) {
			var _v0 = _Utils_Tuple2(mx, my);
			if (_v0.a.$ === 1) {
				var _v1 = _v0.a;
				return my;
			} else {
				if (_v0.b.$ === 1) {
					var _v2 = _v0.b;
					return mx;
				} else {
					var x = _v0.a.a;
					var y = _v0.b.a;
					return $elm$core$Maybe$Just(
						A2(func, x, y));
				}
			}
		});
	var initAcc = {n8: 0, yc: $elm$core$Maybe$Nothing, qT: 0, pb: 0, py: 0, du: $elm$core$Maybe$Nothing, nB: 0};
	var incrementIfState = F3(
		function (expectedState, value, state) {
			return _Utils_eq(state, expectedState) ? (value + 1) : value;
		});
	var buildProgress = tracker.h6;
	var accumArtifact = F2(
		function (info, acc) {
			return _Utils_update(
				acc,
				{
					n8: A3(incrementIfState, 1, acc.n8, info.bB),
					yc: A3(mergeMaybe, $author$project$TimeUtils$max, acc.yc, info.yc),
					qT: A3(incrementIfState, 3, acc.qT, info.bB),
					pb: A3(incrementIfState, 4, acc.pb, info.bB),
					py: A3(incrementIfState, 0, acc.py, info.bB),
					du: A3(mergeMaybe, $author$project$TimeUtils$min, acc.du, info.du),
					nB: A3(incrementIfState, 2, acc.nB, info.bB)
				});
		});
	var finalAcc = A3(
		$elm$core$Dict$foldl,
		$elm$core$Basics$always(accumArtifact),
		initAcc,
		tracker.hI);
	var status = (_Utils_cmp(finalAcc.nB + finalAcc.pb, buildProgress.nH) > -1) ? 1 : (((finalAcc.n8 > 0) || (finalAcc.py > 0)) ? 0 : 2);
	return _Utils_update(
		tracker,
		{
			h6: _Utils_update(
				buildProgress,
				{yc: finalAcc.yc, du: finalAcc.du, kz: finalAcc.nB}),
			L: status
		});
};
var $author$project$Model$ProgressTracker$monotonicState = F2(
	function (func, oldInfo) {
		var newInfo = func(oldInfo);
		return ((oldInfo.bB === 2) || (oldInfo.bB === 3)) ? _Utils_update(
			newInfo,
			{bB: oldInfo.bB}) : newInfo;
	});
var $author$project$Model$ProgressTracker$updateAlternativePackageAndBuildProgress = F4(
	function (artifactID, packageFunc, buildFunc, tracker) {
		var _v0 = A2($elm$core$Dict$get, artifactID, tracker.hI);
		if (_v0.$ === 1) {
			return tracker;
		} else {
			var info = _v0.a;
			return $author$project$Model$ProgressTracker$computeBuildStateFromArtifacts(
				_Utils_update(
					tracker,
					{
						h6: buildFunc(tracker.h6),
						hI: A3(
							$elm$core$Dict$insert,
							artifactID,
							A2($author$project$Model$ProgressTracker$monotonicState, packageFunc, info),
							tracker.hI)
					}));
		}
	});
var $author$project$Model$ProgressTracker$alternativeUpdate = F2(
	function (event, tracker) {
		switch (event.$) {
			case 0:
				var artifactID = event.a;
				var time = event.b;
				return A4(
					$author$project$Model$ProgressTracker$updateAlternativePackageAndBuildProgress,
					artifactID,
					function (info) {
						return _Utils_update(
							info,
							{
								du: $elm$core$Maybe$Just(time),
								bB: 1
							});
					},
					$elm$core$Basics$identity,
					tracker);
			case 1:
				var artifactID = event.a.xf;
				var downloadURL = event.a.x8;
				var endTime = event.a.yc;
				return A4(
					$author$project$Model$ProgressTracker$updateAlternativePackageAndBuildProgress,
					artifactID,
					function (info) {
						return _Utils_update(
							info,
							{
								x8: $elm$core$Maybe$Just(downloadURL),
								yc: $elm$core$Maybe$Just(endTime),
								bB: 2
							});
					},
					function (info) {
						return $author$project$Model$ProgressTracker$incrementSuccessfulPackages(info);
					},
					tracker);
			case 3:
				var artifactID = event.a;
				var maybeError = event.b;
				var time = event.c;
				return A4(
					$author$project$Model$ProgressTracker$updateAlternativePackageAndBuildProgress,
					artifactID,
					function (info) {
						return _Utils_update(
							info,
							{
								yc: $elm$core$Maybe$Just(time),
								bB: 3
							});
					},
					function (info) {
						return _Utils_update(
							info,
							{
								yf: _Utils_ap(
									$elm_community$maybe_extra$Maybe$Extra$toList(maybeError),
									info.yf),
								cg: A2($elm_community$maybe_extra$Maybe$Extra$or, maybeError, info.cg)
							});
					},
					tracker);
			default:
				var artifactID = event.a;
				var time = event.b;
				return A4(
					$author$project$Model$ProgressTracker$updateAlternativePackageAndBuildProgress,
					artifactID,
					function (info) {
						return _Utils_update(
							info,
							{
								yc: $elm$core$Maybe$Just(time),
								bB: 4
							});
					},
					$elm$core$Basics$identity,
					tracker);
		}
	});
var $author$project$Model$ProgressTracker$mapBuildProgress = F2(
	function (updateFn, tracker) {
		return _Utils_update(
			tracker,
			{
				h6: updateFn(tracker.h6)
			});
	});
var $author$project$Model$ProgressTracker$mapPackageProgress = F2(
	function (updateFn, tracker) {
		return _Utils_update(
			tracker,
			{
				hI: updateFn(tracker.hI)
			});
	});
var $author$project$Model$ProgressTracker$switchPackageStates = function (_v0) {
	var from = _v0.qZ;
	var to = _v0.Gz;
	return $elm$core$Dict$map(
		F2(
			function (_v1, info) {
				return _Utils_update(
					info,
					{
						bB: _Utils_eq(info.bB, from) ? to : info.bB
					});
			}));
};
var $author$project$Model$ProgressTracker$camelUpdate = F2(
	function (event, tracker) {
		switch (event.$) {
			case 3:
				var id = event.a;
				var time = event.b;
				return A2(
					$author$project$Model$ProgressTracker$mapPackageProgress,
					A2(
						$author$project$Misc$updateDictExisting,
						id,
						$author$project$Model$ProgressTracker$monotonicState(
							function (info) {
								return _Utils_update(
									info,
									{
										du: $elm$core$Maybe$Just(time),
										bB: 1
									});
							})),
					tracker);
			case 4:
				var id = event.a;
				var time = event.b;
				return A2(
					$author$project$Model$ProgressTracker$mapBuildProgress,
					$author$project$Model$ProgressTracker$incrementSuccessfulPackages,
					A2(
						$author$project$Model$ProgressTracker$mapPackageProgress,
						A2(
							$author$project$Misc$updateDictExisting,
							id,
							$author$project$Model$ProgressTracker$monotonicState(
								function (info) {
									return _Utils_update(
										info,
										{
											yc: $elm$core$Maybe$Just(time),
											bB: 2
										});
								})),
						tracker));
			case 5:
				var id = event.a;
				return A2(
					$author$project$Model$ProgressTracker$mapPackageProgress,
					A2(
						$author$project$Misc$updateDictExisting,
						id,
						$author$project$Model$ProgressTracker$monotonicState(
							function (info) {
								return _Utils_update(
									info,
									{bB: 3});
							})),
					tracker);
			case 0:
				var time = event.a;
				return A2(
					$author$project$Model$ProgressTracker$mapBuildProgress,
					function (info) {
						return _Utils_update(
							info,
							{
								du: $elm$core$Maybe$Just(time)
							});
					},
					tracker);
			case 2:
				var time = event.a;
				var newTracker = function () {
					var _v1 = tracker.L;
					if (!_v1) {
						return A2(
							$author$project$Model$ProgressTracker$mapPackageProgress,
							$author$project$Model$ProgressTracker$switchPackageStates(
								{qZ: 0, Gz: 2}),
							A2(
								$author$project$Model$ProgressTracker$mapBuildProgress,
								function (bp) {
									return _Utils_update(
										bp,
										{kz: bp.nH});
								},
								_Utils_update(
									tracker,
									{kw: false, L: 1})));
					} else {
						return tracker;
					}
				}();
				return A2(
					$author$project$Model$ProgressTracker$mapBuildProgress,
					function (info) {
						return _Utils_update(
							info,
							{
								yc: $elm$core$Maybe$Just(time)
							});
					},
					newTracker);
			default:
				var reason = event.a;
				var errors = event.b;
				var _v2 = tracker.L;
				if (!_v2) {
					return A2(
						$author$project$Model$ProgressTracker$mapPackageProgress,
						$author$project$Model$ProgressTracker$switchPackageStates(
							{qZ: 1, Gz: 3}),
						A2(
							$author$project$Model$ProgressTracker$mapPackageProgress,
							$author$project$Model$ProgressTracker$switchPackageStates(
								{qZ: 0, Gz: 4}),
							A2(
								$author$project$Model$ProgressTracker$mapBuildProgress,
								function (bp) {
									return _Utils_update(
										bp,
										{
											yf: errors,
											cg: $elm$core$Maybe$Just(reason)
										});
								},
								_Utils_update(
									tracker,
									{kw: true, L: 2}))));
				} else {
					return tracker;
				}
		}
	});
var $author$project$Model$ProgressTracker$updateProgress = F2(
	function (event, progressTracker) {
		var newProgressTracker = function () {
			if (!event.$) {
				var camelProgress = event.a;
				return A2($author$project$Model$ProgressTracker$camelUpdate, camelProgress, progressTracker);
			} else {
				var altProgress = event.a;
				return A2($author$project$Model$ProgressTracker$alternativeUpdate, altProgress, progressTracker);
			}
		}();
		return (!(!progressTracker.L)) ? _Utils_update(
			newProgressTracker,
			{L: progressTracker.L}) : newProgressTracker;
	});
var $author$project$Pages$ProjectDownloads$withCmdIf = F3(
	function (conditional, cmd, model) {
		return _Utils_Tuple2(
			model,
			conditional ? cmd : $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$ProjectDownloads$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
			case 19:
				var platformID = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								j3: $author$project$Pages$ProjectDownloads$KickConfirming(platformID)
							})));
			case 20:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{j3: $author$project$Pages$ProjectDownloads$KickIdle})));
			case 21:
				var platformID = msg.a;
				var candidates = msg.b;
				var reschedule = function (info) {
					return A2(
						$elm$core$Task$map,
						$elm$core$Tuple$pair(info),
						A2(
							$elm$core$Task$onError,
							A2($elm$core$Basics$composeR, $elm$core$Result$Err, $elm$core$Task$succeed),
							A2(
								$elm$core$Task$map,
								$elm$core$Result$Ok,
								A2(
									$author$project$Request$HeadChef$rescheduleArtifact,
									$author$project$Model$Session$getCreds(session),
									info.l6))));
				};
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$perform,
							$author$project$Pages$ProjectDownloads$KickCompleted,
							$elm$core$Task$sequence(
								A2($elm$core$List$map, reschedule, candidates))),
						_Utils_update(
							model,
							{
								j3: $author$project$Pages$ProjectDownloads$KickRunning(platformID)
							})));
			case 22:
				var results = msg.a;
				var failures = A2(
					$elm$core$List$filterMap,
					function (_v1) {
						var info = _v1.a;
						var result = _v1.b;
						if (!result.$) {
							return $elm$core$Maybe$Nothing;
						} else {
							var err = result.a;
							return $elm$core$Maybe$Just(
								info.w + (' (' + ($author$project$Http$Extra$reason(err) + ')')));
						}
					},
					results);
				var refresh = (_Utils_cmp(
					$elm$core$List$length(failures),
					$elm$core$List$length(results)) < 0) ? A2(
					$elm$core$Task$attempt,
					$author$project$Pages$ProjectDownloads$SoftRefreshComplete,
					$elm$core$Task$succeed(model.f0)) : $elm$core$Platform$Cmd$none;
				var summary = 'Rescheduled ' + ($elm$core$String$fromInt(
					$elm$core$List$length(results) - $elm$core$List$length(failures)) + ('/' + ($author$project$Pages$ProjectDownloads$artifactCount(
					$elm$core$List$length(results)) + '.')));
				var notification = $elm$core$List$isEmpty(failures) ? $author$project$Model$Notification$textSuccess(summary) : $author$project$Model$Notification$textWarning(
					summary + (' Failed: ' + A2($elm$core$String$join, ', ', failures)));
				return A2(
					$author$project$Misc$with,
					$author$project$External$AddNotification(notification),
					A2(
						$author$project$Misc$with,
						refresh,
						_Utils_update(
							model,
							{j3: $author$project$Pages$ProjectDownloads$KickIdle})));
			case 1:
				var platformID = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Pages$ProjectDownloads$setPlatformIdInUrlCmd(platformID)
								])),
						_Utils_update(
							model,
							{
								hs: $elm$core$Maybe$Nothing,
								j1: 0,
								fE: $elm$core$Maybe$Just(platformID)
							})));
			case 4:
				var kind = msg.a;
				var input = msg.b;
				var analyticsEvent = function () {
					if (kind === 1) {
						return $author$project$Ports$sendAnalyticsEvent(
							A2(
								$author$project$Model$Analytics$withLabel,
								'Download Builds tab',
								A2(
									$author$project$Model$Analytics$withAction,
									'Copied CLI install script to clipboard',
									A2(
										$author$project$Model$Analytics$withCategory,
										'Project installation',
										$author$project$Model$Analytics$newEvent('Copied CLI install script to clipboard')))));
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									analyticsEvent,
									$author$project$Ports$copyToClipboard(input)
								])),
						_Utils_update(
							model,
							{oi: $author$project$Model$CopyStatus$empty})));
			case 7:
				var portCopyStatus = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{oi: portCopyStatus})));
			case 8:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{ul: true})));
			case 9:
				if (msg.a.$ === 1) {
					var err = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							A2($author$project$Pages$ProjectDownloads$rollbar.sk, err, session),
							model));
				} else {
					switch (msg.a.a.$) {
						case 2:
							var _v4 = msg.a.a;
							return A2(
								$author$project$Misc$with,
								$author$project$External$NoOp,
								A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
						case 3:
							var _v5 = msg.a.a;
							return A2(
								$author$project$Misc$with,
								$author$project$External$NoOp,
								A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
						case 1:
							var _v6 = msg.a.a;
							var artifactID = _v6.a;
							var log = _v6.b;
							var newPlatformIdToArtifactIdToLogs = A2(
								$elm$core$Maybe$withDefault,
								model.iz,
								A2(
									$elm$core$Maybe$map,
									function (platformID) {
										return A4(
											$author$project$Pages$ProjectDownloads$updateLogs,
											function (logs) {
												return _Utils_ap(
													logs,
													_List_fromArray(
														[log]));
											},
											platformID,
											artifactID,
											model.iz);
									},
									model.fE));
							return A2(
								$author$project$Misc$with,
								$author$project$External$NoOp,
								A2(
									$author$project$Misc$with,
									$elm$core$Platform$Cmd$none,
									_Utils_update(
										model,
										{iz: newPlatformIdToArtifactIdToLogs})));
						default:
							var _v7 = msg.a.a;
							var buildLogId = _v7.a;
							var event = _v7.b;
							var platformIdsThatNeedUpdate = A2($author$project$Pages$ProjectDownloads$getPlatformIdsThatNeedUpdate, model, buildLogId);
							var mapForEvent = F2(
								function (platformID, progressTracker) {
									return (!A2($elm$core$List$member, platformID, platformIdsThatNeedUpdate)) ? progressTracker : A2($author$project$Model$ProgressTracker$updateProgress, event, progressTracker);
								});
							var postEventPlatformIdToProgress = A2($elm$core$Dict$map, mapForEvent, model.ff);
							var newModel = _Utils_update(
								model,
								{ff: postEventPlatformIdToProgress});
							var isStatusCompleted = function (status) {
								return (status === 1) || (status === 2);
							};
							var isRecentlyCompleted = F2(
								function (platformID, tracker) {
									var _v9 = A2($elm$core$Dict$get, platformID, newModel.ff);
									if (_v9.$ === 1) {
										return false;
									} else {
										var newTracker = _v9.a;
										return (!isStatusCompleted(tracker.L)) && isStatusCompleted(newTracker.L);
									}
								});
							var isAnyRecentlyCompleted = A3(
								$elm$core$Dict$foldl,
								F3(
									function (platformID, tracker, anyAcc) {
										return anyAcc || A2(isRecentlyCompleted, platformID, tracker);
									}),
								false,
								model.ff);
							var commitID = $author$project$Model$Commit$getCommitID(model.f0);
							var _v8 = isAnyRecentlyCompleted ? A2(
								$author$project$Misc$with,
								$author$project$External$RemoveBuildPlanAndComponents(
									{
										BR: commitID,
										ix: $author$project$Model$Organization$getUrlName(model.c3),
										vT: $author$project$Model$Project$getName(model.c5)
									}),
								A2(
									$elm$core$Task$perform,
									$author$project$Pages$ProjectDownloads$ReloadBuildPlanForCache,
									$elm$core$Task$succeed(commitID))) : A2($author$project$Misc$with, $author$project$External$NoOp, $elm$core$Platform$Cmd$none);
							var loadBuildPlanCmd = _v8.a;
							var externalMsg = _v8.b;
							return A2(
								$author$project$Misc$with,
								externalMsg,
								A2($author$project$Misc$with, loadBuildPlanCmd, newModel));
					}
				}
			case 10:
				var time = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{cF: time})));
			case 3:
				var platformID = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								ff: A3($author$project$Misc$updateDictExisting, platformID, $author$project$Model$ProgressTracker$togglePackages, model.ff)
							})));
			case 2:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A3(
						$author$project$Pages$ProjectDownloads$withCmdIf,
						$author$project$Model$User$isPaidUser(model.gS),
						$author$project$Ports$openHubSpotChat(0),
						model));
			case 11:
				var artifactID = msg.a;
				var newPlatformIdToArtifactIdToLogs = A2(
					$elm$core$Maybe$withDefault,
					model.iz,
					A3(
						$elm$core$Maybe$map2,
						F2(
							function (platformID, oldArtifactID) {
								return A4(
									$author$project$Pages$ProjectDownloads$updateLogs,
									function (_v11) {
										return _List_Nil;
									},
									platformID,
									oldArtifactID,
									model.iz);
							}),
						model.fE,
						model.hs));
				var _v10 = _Utils_eq(
					$elm$core$Maybe$Just(artifactID),
					model.hs) ? _Utils_Tuple3(
					$elm$core$Maybe$Nothing,
					$elm$core$Platform$Cmd$none,
					$author$project$Pages$ProjectDownloads$stopArtifactProgress(
						{
							xf: $elm$core$Maybe$Just(artifactID),
							m0: model.fE
						})) : _Utils_Tuple3(
					$elm$core$Maybe$Just(artifactID),
					$author$project$Pages$ProjectDownloads$startArtifactProgress(
						{
							xf: $elm$core$Maybe$Just(artifactID),
							qn: $author$project$Protected$getToken(
								$author$project$Model$Session$getCreds(session)),
							m0: model.fE,
							GT: model.jH
						}),
					$author$project$Pages$ProjectDownloads$stopArtifactProgress(
						{xf: model.hs, m0: model.fE}));
				var newArtifactID = _v10.a;
				var streamNewArtifactLogsCmd = _v10.b;
				var closeOldArtifactSocketCmd = _v10.c;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[streamNewArtifactLogsCmd, closeOldArtifactSocketCmd])),
						_Utils_update(
							model,
							{hs: newArtifactID, iz: newPlatformIdToArtifactIdToLogs})));
			case 12:
				var branchMsg = msg.a;
				var _v12 = $author$project$Views$BranchPicker$update(branchMsg);
				var _v13 = _v12.a;
				var newbranchModel = _v13.a;
				var branchCmd = _v13.b;
				var branchPickerExternalMsg = _v12.b;
				var newModel = _Utils_update(
					model,
					{
						fJ: $elm$core$Maybe$Just(newbranchModel)
					});
				if (!branchPickerExternalMsg) {
					var reloadCmd = function (commitID) {
						return A2(
							$elm$core$Task$attempt,
							$author$project$Pages$ProjectDownloads$SoftRefreshComplete,
							A2(
								$author$project$Pages$ProjectDownloads$refreshTask,
								session,
								{
									BR: commitID,
									ix: $author$project$Model$Organization$getUrlName(model.c3),
									vT: $author$project$Model$Project$getName(model.c5)
								}));
					};
					var maybeCommitID = $author$project$Model$Branch$getCommitID(
						$author$project$Views$BranchPicker$getSelectedBranch(newbranchModel));
					if (maybeCommitID.$ === 1) {
						return A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, newModel));
					} else {
						var commitID = maybeCommitID.a;
						return A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2(
								$author$project$Misc$with,
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											reloadCmd(commitID),
											branchCmd
										])),
								_Utils_update(
									newModel,
									{ff: $elm$core$Dict$empty, kq: true})));
					}
				} else {
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, newModel));
				}
			case 13:
				var tab = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{j1: tab})));
			case 14:
				var commitID = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$ProjectDownloads$ReloadBuildPlanForCacheComplete(commitID),
							A3($author$project$Pages$ProjectDownloads$buildPlanTask, session, model, commitID)),
						model));
			case 15:
				var commitID = msg.a;
				var result = msg.b;
				var _v16 = function () {
					if (!result.$) {
						var buildPlan = result.a;
						var buildGraph = $author$project$Model$BuildPlanner$BuildGraph$fromBuildPlan(buildPlan);
						var newPlatformIdToProgress = A2(
							$elm$core$Dict$map,
							F2(
								function (platformID, progressTracker) {
									return _Utils_update(
										progressTracker,
										{
											tH: A2($author$project$Model$BuildPlanner$BuildGraph$getDownloadsForPlatform, platformID, buildGraph)
										});
								}),
							model.ff);
						return A2(
							$author$project$Misc$with,
							A2(
								$author$project$External$AddBuildPlan,
								{
									BR: commitID,
									ix: $author$project$Model$Organization$getUrlName(model.c3),
									vT: $author$project$Model$Project$getName(model.c5)
								},
								buildPlan),
							_Utils_update(
								model,
								{ff: newPlatformIdToProgress}));
					} else {
						return A2($author$project$Misc$with, $author$project$External$NoOp, model);
					}
				}();
				var newModel = _v16.a;
				var external = _v16.b;
				return A2(
					$author$project$Misc$with,
					external,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, newModel));
			case 16:
				if (!msg.a.$) {
					var commit = msg.a.a;
					var loadingModel = _Utils_update(
						model,
						{n6: $krisajenkins$remotedata$RemoteData$Loading, f0: commit});
					var commitID = $author$project$Model$Commit$getCommitID(commit);
					var cmd = A2(
						$elm$core$Task$attempt,
						A2($author$project$Pages$ProjectDownloads$OnReceivedBuildPlanPollable, 0, commitID),
						A3($author$project$Pages$ProjectDownloads$buildPlanTask, session, model, commitID));
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2($author$project$Misc$with, cmd, loadingModel));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$ProjectDownloads$rollbar.FZ, 'SoftRefreshComplete (Err err)', err, session),
							_Utils_update(
								model,
								{kq: false})));
				}
			case 17:
				if (!msg.c.$) {
					var commitID = msg.b;
					var buildPlan = msg.c.a;
					if ($author$project$Model$BuildPlanner$BuildPlan$isPlanningState(buildPlan.bB)) {
						var cmd = A2(
							$elm$core$Task$attempt,
							A2($author$project$Pages$ProjectDownloads$OnReceivedBuildPlanPollable, 0, commitID),
							A3($author$project$Pages$ProjectDownloads$buildPlanTask, session, model, commitID));
						return A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2($author$project$Misc$with, cmd, model));
					} else {
						return A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2(
								$author$project$Misc$with,
								A2(
									$elm$core$Task$attempt,
									$author$project$Pages$ProjectDownloads$OnReceivedBuildPlan(commitID),
									$elm$core$Task$succeed(buildPlan)),
								model));
					}
				} else {
					var nbrAttempts = msg.a;
					var commitID = msg.b;
					var err = msg.c.a;
					var maxNbrAttempts = 3;
					var attemptDelaySecs = 3;
					if ((_Utils_cmp(nbrAttempts, maxNbrAttempts) < 0) && $author$project$Model$BuildPlanner$BuildPlannerError$isPossiblyTransient(err)) {
						var cmd = A2(
							$elm$core$Task$attempt,
							A2($author$project$Pages$ProjectDownloads$OnReceivedBuildPlanPollable, nbrAttempts + 1, commitID),
							A3(
								$elm$core$Task$map2,
								$elm$core$Basics$always($elm$core$Basics$identity),
								$elm$core$Process$sleep(attemptDelaySecs * 1000),
								A3($author$project$Pages$ProjectDownloads$buildPlanTask, session, model, commitID)));
						return A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2($author$project$Misc$with, cmd, model));
					} else {
						return A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2(
								$author$project$Misc$with,
								A2(
									$elm$core$Task$attempt,
									$author$project$Pages$ProjectDownloads$OnReceivedBuildPlan(commitID),
									$elm$core$Task$fail(err)),
								model));
					}
				}
			case 18:
				var commitID = msg.a;
				var result = msg.b;
				var remoteData = $krisajenkins$remotedata$RemoteData$fromResult(result);
				var maybeBuildPlan = $elm$core$Result$toMaybe(result);
				var platforms = A2(
					$elm$core$List$filterMap,
					A2($elm_community$basics_extra$Basics$Extra$flip, $elm$core$Dict$get, model.n4),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2($elm$core$Maybe$map, $author$project$Model$BuildPlanner$BuildPlan$platformIDs, maybeBuildPlan)));
				var selectedPlatformID = A2(
					$author$project$Pages$ProjectDownloads$findSelectedPlatformID,
					session,
					{Fh: platforms, fE: model.fE});
				var buildRequestIdToPlatformId = $elm$core$Dict$fromList(
					A2(
						$elm$core$List$filterMap,
						function (buildLogId) {
							var _v23 = buildLogId.gR;
							if (!_v23) {
								return $elm$core$Maybe$Just(
									_Utils_Tuple2(buildLogId.l6, buildLogId.Fe));
							} else {
								return $elm$core$Maybe$Nothing;
							}
						},
						A2(
							$elm$core$List$concatMap,
							$author$project$Model$BuildPlanner$BuildPlan$buildLogIds,
							$elm_community$maybe_extra$Maybe$Extra$toList(maybeBuildPlan))));
				var buildLogIds = A2(
					$elm$core$List$concatMap,
					$author$project$Model$BuildPlanner$BuildPlan$buildLogIds,
					$elm_community$maybe_extra$Maybe$Extra$toList(maybeBuildPlan));
				var listenToBuildProgressCmds = A2(
					$elm$core$List$map,
					function (buildLogId) {
						var buildLogPartitionKey = $author$project$Model$ProgressTracker$buildLogPartitionKey(buildLogId);
						var _v22 = buildLogPartitionKey;
						var partitionKey = _v22.a;
						var partitionKeyValue = _v22.b;
						return $author$project$Ports$startBuildProgress(
							{
								qn: $author$project$Protected$getToken(
									$author$project$Model$Session$getCreds(session)),
								E8: partitionKey,
								E9: partitionKeyValue,
								GT: model.jH
							});
					},
					buildLogIds);
				var buildDataSource = A2($krisajenkins$remotedata$RemoteData$map, $author$project$Model$BuildDataSource$init, remoteData);
				var externalMsg = function () {
					if (buildDataSource.$ === 3) {
						var buildData = buildDataSource.a;
						return A2(
							$author$project$External$AddBuildPlan,
							{
								BR: commitID,
								ix: $author$project$Model$Organization$getUrlName(model.c3),
								vT: $author$project$Model$Project$getName(model.c5)
							},
							$author$project$Model$BuildDataSource$getBuildPlan(buildData));
					} else {
						return $author$project$External$NoOp;
					}
				}();
				var languages = A2(
					$krisajenkins$remotedata$RemoteData$withDefault,
					_List_Nil,
					A2($krisajenkins$remotedata$RemoteData$map, $author$project$Model$BuildDataSource$getLanguages, buildDataSource));
				var _v18 = function () {
					if (maybeBuildPlan.$ === 1) {
						return _Utils_Tuple2(model.ff, model.kn);
					} else {
						var buildPlan = maybeBuildPlan.a;
						var _v20 = $author$project$Model$ProgressTracker$buildPlanInit(
							{h4: model.h4, xt: buildPlan, BR: commitID, aM: languages, pd: model.c3, Fh: platforms, c5: model.c5});
						if (_v20.$ === 1) {
							var buildGraph = _v20.a;
							return _Utils_Tuple2(
								$elm$core$Dict$empty,
								$elm$core$Maybe$Just(buildGraph));
						} else {
							var progressTrackers = _v20.a;
							return _Utils_Tuple2(
								A2(
									$elm_community$dict_extra$Dict$Extra$fromListBy,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.po;
										},
										$author$project$Model$Platform$id),
									progressTrackers),
								$elm$core$Maybe$Nothing);
						}
					}
				}();
				var platformIdToProgress = _v18.a;
				var prePlatformBuildGraph = _v18.b;
				var newModel = _Utils_update(
					model,
					{n6: buildDataSource, qs: buildRequestIdToPlatformId, hs: $elm$core$Maybe$Nothing, ff: platformIdToProgress, kn: prePlatformBuildGraph, kq: false, fE: selectedPlatformID});
				return A2(
					$author$project$Misc$with,
					externalMsg,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$batch(listenToBuildProgressCmds),
						newModel));
			case 5:
				var text = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$author$project$Ports$openPopupWithContent(text),
						model));
			default:
				var filename = msg.a;
				var content = msg.b;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$author$project$Ports$downloadFileWithText(
							{dH: content, CG: filename}),
						model));
		}
	});
var $author$project$Views$CreateSBOM$Loaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Views$CreateSBOM$Loading = {$: 1};
var $author$project$Pages$ProjectHistory$NewCommits = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Pages$ProjectHistory$OnCommitFetch = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$ProjectHistory$OnCommitOverwritten = function (a) {
	return {$: 22, a: a};
};
var $author$project$Pages$ProjectHistory$OnCommitSaved = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$ProjectHistory$OnRevertChangesetReceived = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Pages$ProjectHistory$OnViewChangesetReceived = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Pages$ProjectHistory$ReceiveSBOM = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Pages$ProjectHistory$ReceiveSBOMWithDSSE = F2(
	function (a, b) {
		return {$: 19, a: a, b: b};
	});
var $author$project$Pages$ProjectHistory$getCurrentBranch = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Model$Project$getDefaultBranch(model.c5),
		A2($elm$core$Maybe$map, $author$project$Views$BranchPicker$getSelectedBranch, model.fJ));
};
var $author$project$Model$CommitRevertable$CommitRevertable = F2(
	function (atTime, changes) {
		return {jE: atTime, xB: changes};
	});
var $author$project$Model$CommitRevertable$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'changeset',
	A2(
		$elm$json$Json$Decode$map,
		$elm_community$dict_extra$Dict$Extra$fromListBy($author$project$Model$Namespace$key),
		$elm$json$Json$Decode$list($author$project$Model$Change$decode)),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'atTime',
		$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
		$elm$json$Json$Decode$succeed($author$project$Model$CommitRevertable$CommitRevertable)));
var $author$project$Request$VCS$getRevertCommit = F3(
	function (creds, revertFromCommitID, revertToCommitID) {
		return $author$project$Http$Extra$get(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$emptyBody,
				qN: $author$project$Model$CommitRevertable$decode,
				CN: _List_Nil,
				GT: '/vcs/commits/' + ($danyx23$elm_uuid$Uuid$toString(revertFromCommitID) + ('/revert/' + $danyx23$elm_uuid$Uuid$toString(revertToCommitID)))
			});
	});
var $author$project$Model$DSSE$nonEmptyEnvelopeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (_v0) {
		var payload = _v0.a;
		var payloadType = _v0.b;
		return ($elm$core$String$isEmpty(payload) || $elm$core$String$isEmpty(payloadType)) ? $elm$json$Json$Decode$fail('DSSE envelope missing payload/payloadType') : $elm$json$Json$Decode$value;
	},
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$Tuple$pair,
		A2($elm$json$Json$Decode$field, 'payload', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'payloadType', $elm$json$Json$Decode$string)));
var $author$project$Model$DSSE$envelopeValueDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2($elm$json$Json$Decode$field, 'envelope', $author$project$Model$DSSE$nonEmptyEnvelopeDecoder),
			$author$project$Model$DSSE$nonEmptyEnvelopeDecoder
		]));
var $author$project$Model$DSSE$withSignatures = function (value) {
	var _v0 = A2(
		$elm$json$Json$Decode$decodeValue,
		A2($elm$json$Json$Decode$field, 'signatures', $elm$json$Json$Decode$value),
		value);
	if (!_v0.$) {
		return value;
	} else {
		var _v1 = A2(
			$elm$json$Json$Decode$decodeValue,
			$elm$json$Json$Decode$dict($elm$json$Json$Decode$value),
			value);
		if (!_v1.$) {
			var fields = _v1.a;
			return A3(
				$elm$json$Json$Encode$dict,
				$elm$core$Basics$identity,
				$elm$core$Basics$identity,
				A3(
					$elm$core$Dict$insert,
					'signatures',
					A2($elm$json$Json$Encode$list, $elm$core$Basics$identity, _List_Nil),
					fields));
		} else {
			return value;
		}
	}
};
var $author$project$Model$DSSE$attestationEnvelope = function (body) {
	var _v0 = A2($elm$json$Json$Decode$decodeString, $author$project$Model$DSSE$envelopeValueDecoder, body);
	if (!_v0.$) {
		var value = _v0.a;
		return $elm$core$Maybe$Just(
			A2(
				$elm$json$Json$Encode$encode,
				2,
				$author$project$Model$DSSE$withSignatures(value)));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$BuildPlanner$Object$Commit$attestations = function (object____) {
	return A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField, 'attestations', _List_Nil, object____, $elm$core$Basics$identity);
};
var $author$project$BuildPlanner$Union$CommitAttestationsResult$fragments = function (selections____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$exhaustiveFragmentSelection(
		_List_fromArray(
			[
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'CommitAttestations', selections____.u8),
				A2($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$buildFragment, 'FeatureNotEnabled', selections____.vb)
			]));
};
var $author$project$BuildPlanner$Object$CommitAttestations$json = function (requiredArgs____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
		'BuildPlannerScalarCodecs.Uri',
		'json',
		_List_fromArray(
			[
				A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'version', requiredArgs____.aI, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)
			]),
		$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).BQ.qN);
};
var $author$project$Request$BuildPlanner$getJSONURL = F3(
	function (session, input, args) {
		var creds = $author$project$Model$Session$getCreds(session);
		return A5(
			$author$project$GraphQL$Utils$queryRequest,
			creds,
			4,
			_List_Nil,
			'GetJSONURL',
			A2(
				$author$project$Request$BuildPlanner$selectionSetProjectCommit,
				input,
				$author$project$BuildPlanner$Object$Commit$attestations(
					$author$project$BuildPlanner$Union$CommitAttestationsResult$fragments(
						{
							u8: $author$project$BuildPlanner$Object$CommitAttestations$json(args),
							vb: $author$project$BuildPlannerScalarCodecs$selectionSetFail('Feature not enabled: Commit Attestations')
						}))));
	});
var $author$project$Http$Extra$getRaw = function (_v0) {
	var url = _v0.GT;
	var body = _v0.sY;
	var auth = _v0.iO;
	var headers = _v0.CN;
	return $elm$http$Http$task(
		{
			sY: body,
			CN: _Utils_ap(
				$author$project$Http$Extra$authToHeaders(auth),
				A2(
					$elm$core$List$map,
					$elm_community$basics_extra$Basics$Extra$uncurry($elm$http$Http$header),
					headers)),
			my: 'GET',
			nj: $elm$http$Http$stringResolver(
				$author$project$Http$Extra$responseToResultRaw(url)),
			nE: $elm$core$Maybe$Nothing,
			GT: _Utils_ap(
				$author$project$Http$Extra$authToUrlBase(auth),
				url)
		});
};
var $author$project$Request$BuildPlanner$getJSONFile = F3(
	function (session, input, args) {
		return A2(
			$elm$core$Task$andThen,
			function (url) {
				return $author$project$Http$Extra$getRaw(
					{
						iO: $author$project$Http$Extra$HeaderOnly(
							$author$project$Model$Session$getCreds(session)),
						sY: $author$project$Http$Extra$emptyBody,
						CN: _List_Nil,
						GT: url
					});
			},
			A3($author$project$Request$BuildPlanner$getJSONURL, session, input, args));
	});
var $author$project$BuildPlanner$Object$CommitAttestations$spdx = function (requiredArgs____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
		'BuildPlannerScalarCodecs.Uri',
		'spdx',
		_List_fromArray(
			[
				A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$required, 'version', requiredArgs____.aI, $dillonkearns$elm_graphql$Graphql$Internal$Encode$string)
			]),
		$author$project$BuildPlanner$Scalar$unwrapCodecs($author$project$BuildPlannerScalarCodecs$codecs).BQ.qN);
};
var $author$project$Request$BuildPlanner$getSPDXURL = F3(
	function (session, input, spdxArgs) {
		var creds = $author$project$Model$Session$getCreds(session);
		return A5(
			$author$project$GraphQL$Utils$queryRequest,
			creds,
			4,
			_List_Nil,
			'GetSPDXURL',
			A2(
				$author$project$Request$BuildPlanner$selectionSetProjectCommit,
				input,
				$author$project$BuildPlanner$Object$Commit$attestations(
					$author$project$BuildPlanner$Union$CommitAttestationsResult$fragments(
						{
							u8: $author$project$BuildPlanner$Object$CommitAttestations$spdx(spdxArgs),
							vb: $author$project$BuildPlannerScalarCodecs$selectionSetFail('Feature not enabled: Commit Attestations')
						}))));
	});
var $author$project$Request$BuildPlanner$getSPDXFile = F3(
	function (session, input, spdxArgs) {
		return A2(
			$elm$core$Task$andThen,
			function (url) {
				return $author$project$Http$Extra$getRaw(
					{
						iO: $author$project$Http$Extra$HeaderOnly(
							$author$project$Model$Session$getCreds(session)),
						sY: $author$project$Http$Extra$emptyBody,
						CN: _List_Nil,
						GT: url
					});
			},
			A3($author$project$Request$BuildPlanner$getSPDXURL, session, input, spdxArgs));
	});
var $author$project$Model$DSSE$encodeSignature = function (signature) {
	var fields = function () {
		var _v0 = signature.yT;
		if (!_v0.$) {
			var keyid = _v0.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'sig',
					$elm$json$Json$Encode$string(signature.wc)),
					_Utils_Tuple2(
					'keyid',
					$elm$json$Json$Encode$string(keyid))
				]);
		} else {
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'sig',
					$elm$json$Json$Encode$string(signature.wc))
				]);
		}
	}();
	return $elm$json$Json$Encode$object(fields);
};
var $author$project$Model$DSSE$encodeValue = function (env) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'payload',
				$elm$json$Json$Encode$string(env.vQ)),
				_Utils_Tuple2(
				'payloadType',
				$elm$json$Json$Encode$string(env.rU)),
				_Utils_Tuple2(
				'signatures',
				A2($elm$json$Json$Encode$list, $author$project$Model$DSSE$encodeSignature, env.sp))
			]));
};
var $author$project$Model$DSSE$encode = function (env) {
	return A2(
		$elm$json$Json$Encode$encode,
		2,
		$author$project$Model$DSSE$encodeValue(env));
};
var $author$project$Model$DSSE$base64Encode = function (input) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		$danfishgold$base64_bytes$Base64$fromBytes(
			$elm$bytes$Bytes$Encode$encode(
				$elm$bytes$Bytes$Encode$string(input))));
};
var $author$project$Model$DSSE$envelope = function (config) {
	return {
		vQ: $author$project$Model$DSSE$base64Encode(config.sY),
		rU: config.rU,
		sp: config.sp
	};
};
var $author$project$Request$BuildPlanner$wrapSPDXAsDSSE = function (spdx) {
	return $author$project$Model$DSSE$encode(
		$author$project$Model$DSSE$envelope(
			{sY: spdx, rU: 'text/spdx', sp: _List_Nil}));
};
var $author$project$Request$BuildPlanner$getSBOMWithDSSE = F3(
	function (session, input, args) {
		var spdxFallback = A2(
			$elm$core$Task$map,
			$author$project$Request$BuildPlanner$wrapSPDXAsDSSE,
			A3($author$project$Request$BuildPlanner$getSPDXFile, session, input, args));
		return A2(
			$elm$core$Task$onError,
			function (_v1) {
				return spdxFallback;
			},
			A2(
				$elm$core$Task$andThen,
				function (jsonBody) {
					var _v0 = $author$project$Model$DSSE$attestationEnvelope(jsonBody);
					if (!_v0.$) {
						var signedEnvelope = _v0.a;
						return $elm$core$Task$succeed(signedEnvelope);
					} else {
						return spdxFallback;
					}
				},
				A3($author$project$Request$BuildPlanner$getJSONFile, session, input, args)));
	});
var $author$project$Views$BranchPicker$selectedBranchIsDefault = function (model) {
	return $author$project$Model$Branch$isDefault(model.fR);
};
var $author$project$Views$BranchPicker$getSelectedIfNotDefault = function (model) {
	return (!$author$project$Views$BranchPicker$selectedBranchIsDefault(model)) ? $elm$core$Maybe$Just(model.fR) : $elm$core$Maybe$Nothing;
};
var $author$project$Views$BranchPicker$getSelectedNameIfNotDefault = function (model) {
	return A2(
		$elm$core$Maybe$map,
		$author$project$Model$Branch$getName,
		$author$project$Views$BranchPicker$getSelectedIfNotDefault(model));
};
var $author$project$Pages$ProjectHistory$getSimplifiedErrorMessage = function (error) {
	switch (error.$) {
		case 5:
			return 'Not found';
		case 2:
			return 'Forbidden';
		case 3:
			return 'Head on branch moved';
		case 4:
			return 'No change since last commit';
		default:
			return $author$project$Model$BuildPlanner$BuildPlannerError$message(error);
	}
};
var $author$project$Model$Route$projectHistory = function (_v0) {
	var orgName = _v0.ix;
	var projectName = _v0.vT;
	var maybeCommitID = _v0.gr;
	var maybeBranchName = _v0.fO;
	return $author$project$Model$Route$Protected(
		$author$project$Model$Route$Org(
			A2(
				$author$project$Model$Route$OrgParams,
				orgName,
				$author$project$Model$Route$OrgProject(
					A2(
						$author$project$Model$Route$OrgProjectParams,
						projectName,
						A2($author$project$Model$Route$ProjectHistory, maybeCommitID, maybeBranchName))))));
};
var $author$project$Pages$ProjectHistory$NoOp = {$: 0};
var $author$project$Pages$ProjectHistory$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Pages$ProjectHistory$NoOp, 'Pages/ProjectHistory.elm');
var $author$project$Model$PromptToDownload$sbomDsse = 'application/vnd.dsse+json';
var $author$project$Model$PromptToDownload$sbomDsseModel = F2(
	function (project, payload) {
		return {
			rw: $author$project$Model$PromptToDownload$sbomDsse,
			vQ: payload,
			sx: $elm$core$Maybe$Just(
				$author$project$Model$Project$getName(project) + '.sbom.dsse.json')
		};
	});
var $author$project$Model$PromptToDownload$spdx = 'text/spdx';
var $author$project$Model$PromptToDownload$spdxModel = F2(
	function (project, payload) {
		return {
			rw: $author$project$Model$PromptToDownload$spdx,
			vQ: payload,
			sx: $elm$core$Maybe$Just(
				$author$project$Model$Project$getName(project) + '.spdx')
		};
	});
var $author$project$Pages$ProjectHistory$totalCommitsToPages = function (numberOfCommits) {
	return $elm$core$Basics$ceiling(numberOfCommits / $author$project$Pages$ProjectHistory$commitsPerPage);
};
var $krisajenkins$remotedata$RemoteData$unwrap = F3(
	function (_default, _function, remoteData) {
		if (remoteData.$ === 3) {
			var data = remoteData.a;
			return _function(data);
		} else {
			return _default;
		}
	});
var $author$project$Model$Route$withBranchName = F2(
	function (maybeBranchName, args) {
		return _Utils_update(
			args,
			{fO: maybeBranchName});
	});
var $author$project$Pages$ProjectHistory$update = F3(
	function (session, msg, model) {
		var creds = $author$project$Model$Session$getCreds(session);
		var cancelViewChanges = function (updatedModel) {
			return _Utils_update(
				updatedModel,
				{p7: $elm$core$Maybe$Nothing});
		};
		var cancelRevert = function (updatedModel) {
			return _Utils_update(
				updatedModel,
				{pF: $elm$core$Maybe$Nothing, ju: $elm$core$Maybe$Nothing});
		};
		switch (msg.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
			case 8:
				var oldCommitID = msg.a;
				var _v1 = $author$project$Model$Branch$getCommitID(model.lm);
				if (!_v1.$) {
					var latestCommitID = _v1.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							A2(
								$elm$core$Task$attempt,
								$author$project$Pages$ProjectHistory$OnViewChangesetReceived(latestCommitID),
								A3(
									$elm$core$Task$map2,
									$elm$core$Tuple$pair,
									A2(
										$author$project$Request$BuildPlanner$getCommit,
										session,
										{
											BR: oldCommitID,
											ix: $author$project$Model$Organization$getUrlName(model.c3),
											vT: $author$project$Model$Project$getName(model.c5)
										}),
									A3($author$project$Request$VCS$getRevertCommit, creds, oldCommitID, latestCommitID))),
							model));
				} else {
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
				}
			case 9:
				var oldCommitID = msg.a;
				var _v2 = $author$project$Model$Branch$getCommitID(model.lm);
				if (!_v2.$) {
					var latestCommitID = _v2.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							A2(
								$elm$core$Task$attempt,
								$author$project$Pages$ProjectHistory$OnRevertChangesetReceived(oldCommitID),
								A3($author$project$Request$VCS$getRevertCommit, creds, latestCommitID, oldCommitID)),
							model));
				} else {
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
				}
			case 12:
				if (!msg.b.$) {
					var commitID = msg.a;
					var _v3 = msg.b.a;
					var oldCommit = _v3.a;
					var revertCommit = _v3.b;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{
									p7: $elm$core$Maybe$Just(
										_Utils_Tuple3(oldCommit, revertCommit, commitID))
								})));
				} else {
					var err = msg.b.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$ProjectHistory$rollbar.FZ, 'OnViewChangesetReceived _ (Err err)', err, session),
							model));
				}
			case 13:
				if (!msg.b.$) {
					var commitID = msg.a;
					var revertCommit = msg.b.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{
									pF: $elm$core$Maybe$Just(
										_Utils_Tuple2(revertCommit, commitID))
								})));
				} else {
					var err = msg.b.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$ProjectHistory$rollbar.FZ, 'OnRevertChangesetReceived _ (Err err)', err, session),
							model));
				}
			case 4:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						cancelViewChanges(model)));
			case 5:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						cancelRevert(model)));
			case 6:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						cancelRevert(
							cancelViewChanges(model))));
			case 1:
				var revertCommit = msg.a;
				var revertCommitID = msg.b;
				var cmd = A2(
					$elm$core$Task$attempt,
					$author$project$Pages$ProjectHistory$OnCommitSaved,
					A2(
						$elm$core$Task$andThen,
						function (buildExpr) {
							return A3(
								$elm$core$Task$map2,
								$elm$core$Tuple$pair,
								A2(
									$author$project$Request$BuildPlanner$pushCommit,
									$author$project$Model$Session$getCreds(session),
									{
										jE: A2(
											$elm$core$Maybe$map,
											$author$project$Model$AtTime$Timestamp,
											$elm$core$Maybe$Just(revertCommit.jE)),
										xq: $elm$core$Maybe$Just(
											$author$project$Model$Branch$getID(
												$author$project$Pages$ProjectHistory$getCurrentBranch(model))),
										k$: buildExpr,
										c: 'Reverting to commit ' + $danyx23$elm_uuid$Uuid$toString(revertCommitID),
										BR: $author$project$Model$Commit$getCommitID(model.f0),
										ix: $author$project$Model$Organization$getUrlName(model.c3),
										vT: $author$project$Model$Project$getName(model.c5)
									}),
								A2(
									$elm$core$Task$mapError,
									$author$project$Model$BuildPlanner$BuildPlannerError$HttpError,
									A3(
										$author$project$Request$Project$get,
										creds,
										$author$project$Model$Organization$getUrlName(model.c3),
										$author$project$Model$Project$getName(model.c5))));
						},
						A2(
							$author$project$Request$BuildPlanner$getBuildExpr,
							session,
							{
								BR: revertCommitID,
								ix: $author$project$Model$Organization$getUrlName(model.c3),
								vT: $author$project$Model$Project$getName(model.c5)
							})));
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						cmd,
						_Utils_update(
							model,
							{ju: $elm$core$Maybe$Nothing})));
			case 2:
				if (!msg.a.$) {
					var _v4 = msg.a.a;
					var commit = _v4.a;
					var project = _v4.b;
					var maybeBranchName = A2($elm$core$Maybe$andThen, $author$project$Views$BranchPicker$getSelectedNameIfNotDefault, model.fJ);
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							A2(
								$elm$browser$Browser$Navigation$pushUrl,
								model.Y,
								$author$project$Model$Route$routeToString(
									A2(
										$author$project$Model$Route$projectConfig,
										{
											ix: model.c3.AC,
											vT: $author$project$Model$Project$getName(model.c5)
										},
										A2($author$project$Model$Route$withBranchName, maybeBranchName, $author$project$Model$Route$projectConfigParams)))),
							_Utils_update(
								model,
								{f0: commit, c5: project})));
				} else {
					if (!msg.a.a.$) {
						var err = msg.a.a.a;
						return A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2(
								$author$project$Misc$with,
								A3($author$project$Pages$ProjectHistory$rollbar.FZ, 'OnCommitSaved (Err (HttpError err))', err, session),
								_Utils_update(
									model,
									{
										ju: $elm$core$Maybe$Just(
											$author$project$Model$Message$reason(err))
									})));
					} else {
						var err = msg.a.a;
						var message = $author$project$Pages$ProjectHistory$getSimplifiedErrorMessage(err);
						return A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2(
								$author$project$Misc$with,
								A2($author$project$Pages$ProjectHistory$rollbar.sk, message, session),
								_Utils_update(
									model,
									{
										ju: $elm$core$Maybe$Just(message)
									})));
					}
				}
			case 10:
				var input = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$author$project$Ports$copyToClipboard(input),
						_Utils_update(
							model,
							{oi: $author$project$Model$CopyStatus$empty})));
			case 11:
				var portCopyStatus = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{oi: portCopyStatus})));
			case 3:
				var pageNumber = msg.a;
				var offset = (pageNumber - 1) * $author$project$Pages$ProjectHistory$commitsPerPage;
				var getCommitHistory = function (id) {
					return A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeR,
							$krisajenkins$remotedata$RemoteData$fromResult,
							$author$project$Pages$ProjectHistory$NewCommits(pageNumber)),
						A4($author$project$Request$VCS$getCommitHistory, creds, id, offset, $author$project$Pages$ProjectHistory$commitsPerPage));
				};
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2($elm$core$Basics$composeR, $author$project$Model$Commit$getCommitID, getCommitHistory)(model.f0),
						model));
			case 7:
				var pageNumber = msg.a;
				var results = msg.b;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						A3(
							$krisajenkins$remotedata$RemoteData$unwrap,
							model,
							function (history) {
								return _Utils_update(
									model,
									{
										BS: history.BS,
										jK: pageNumber,
										kq: false,
										pY: $author$project$Pages$ProjectHistory$totalCommitsToPages(history.GJ)
									});
							},
							results)));
			case 14:
				var branchMsg = msg.a;
				var _v5 = $author$project$Views$BranchPicker$update(branchMsg);
				var _v6 = _v5.a;
				var newbranchModel = _v6.a;
				var branchCmd = _v6.b;
				var branchPickerExternalMsg = _v5.b;
				var newModel = _Utils_update(
					model,
					{
						fJ: $elm$core$Maybe$Just(newbranchModel)
					});
				if (!branchPickerExternalMsg) {
					var projectName = $author$project$Model$Project$getName(model.c5);
					var orgName = $author$project$Model$Organization$getUrlName(model.c3);
					var getCommitCmd = function (commitID) {
						return A2(
							$elm$core$Task$attempt,
							$author$project$Pages$ProjectHistory$OnCommitFetch,
							A4($author$project$Pages$ProjectHistory$getCommitTask, session, orgName, projectName, commitID));
					};
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$elm$core$Maybe$withDefault,
							A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, newModel),
							A2(
								$elm$core$Maybe$map,
								function (commitID) {
									return A2(
										$author$project$Misc$with,
										$elm$core$Platform$Cmd$batch(
											_List_fromArray(
												[
													getCommitCmd(commitID),
													branchCmd
												])),
										_Utils_update(
											newModel,
											{
												lm: $author$project$Views$BranchPicker$getSelectedBranch(newbranchModel),
												kq: true,
												pY: 0
											}));
								},
								$author$project$Model$Branch$getCommitID(
									$author$project$Views$BranchPicker$getSelectedBranch(newbranchModel)))));
				} else {
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, newModel));
				}
			case 15:
				if (!msg.a.$) {
					var commit = msg.a.a;
					var commitHistoryCmd = A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeR,
							$krisajenkins$remotedata$RemoteData$fromResult,
							$author$project$Pages$ProjectHistory$NewCommits(0)),
						A4(
							$author$project$Request$VCS$getCommitHistory,
							creds,
							$author$project$Model$Commit$getCommitID(commit),
							0,
							$author$project$Pages$ProjectHistory$commitsPerPage));
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							commitHistoryCmd,
							_Utils_update(
								model,
								{f0: commit})));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$ProjectHistory$rollbar.FZ, 'OnCommitFetch (Err err)', err, session),
							model));
				}
			case 16:
				var commitID = msg.a;
				var getSPDXFile = A3(
					$author$project$Request$BuildPlanner$getSPDXFile,
					session,
					{
						BR: commitID,
						ix: $author$project$Model$Organization$getUrlName(model.c3),
						vT: $author$project$Model$Project$getName(model.c5)
					},
					{aI: '0.1'});
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$ProjectHistory$ReceiveSBOM(commitID),
							getSPDXFile),
						_Utils_update(
							model,
							{
								iB: A3($author$project$Uuid$Dict$insert, commitID, $author$project$Views$CreateSBOM$Loading, model.iB)
							})));
			case 17:
				if (!msg.b.$) {
					var commitID = msg.a;
					var sbom = msg.b.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$author$project$Ports$promptToDownload(
								A2($author$project$Model$PromptToDownload$spdxModel, model.c5, sbom)),
							_Utils_update(
								model,
								{
									iB: A3(
										$author$project$Uuid$Dict$insert,
										commitID,
										$author$project$Views$CreateSBOM$Loaded(sbom),
										model.iB)
								})));
				} else {
					var commitID = msg.a;
					var err = msg.b.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$ProjectHistory$rollbar.FZ, 'ReceiveSBOM commitID (Err err)', err, session),
							A2(
								$author$project$Views$NotificationsInline$setErrorText,
								'An error occurred while fetching the SBOM.',
								_Utils_update(
									model,
									{
										iB: A3($author$project$Uuid$Dict$insert, commitID, $author$project$Views$CreateSBOM$NotLoaded, model.iB)
									}))));
				}
			case 18:
				var commitID = msg.a;
				var getSBOM = A3(
					$author$project$Request$BuildPlanner$getSBOMWithDSSE,
					session,
					{
						BR: commitID,
						ix: $author$project$Model$Organization$getUrlName(model.c3),
						vT: $author$project$Model$Project$getName(model.c5)
					},
					{aI: '0.1'});
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$ProjectHistory$ReceiveSBOMWithDSSE(commitID),
							getSBOM),
						_Utils_update(
							model,
							{
								iC: A3($author$project$Uuid$Dict$insert, commitID, $author$project$Views$CreateSBOM$Loading, model.iC)
							})));
			case 19:
				if (!msg.b.$) {
					var commitID = msg.a;
					var sbom = msg.b.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$author$project$Ports$promptToDownload(
								A2($author$project$Model$PromptToDownload$sbomDsseModel, model.c5, sbom)),
							_Utils_update(
								model,
								{
									iC: A3(
										$author$project$Uuid$Dict$insert,
										commitID,
										$author$project$Views$CreateSBOM$Loaded(sbom),
										model.iC)
								})));
				} else {
					var commitID = msg.a;
					var err = msg.b.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$ProjectHistory$rollbar.FZ, 'ReceiveSBOMWithDSSE commitID (Err err)', err, session),
							A2(
								$author$project$Views$NotificationsInline$setErrorText,
								'An error occurred while fetching the SBOM.',
								_Utils_update(
									model,
									{
										iC: A3($author$project$Uuid$Dict$insert, commitID, $author$project$Views$CreateSBOM$NotLoaded, model.iC)
									}))));
				}
			case 20:
				var input = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{ph: input})));
			case 21:
				var commitID = msg.a;
				var cmd = A2(
					$elm$core$Task$attempt,
					$author$project$Pages$ProjectHistory$OnCommitOverwritten,
					A2(
						$elm$core$Task$andThen,
						function (buildExpr) {
							return A3(
								$elm$core$Task$map2,
								$elm$core$Tuple$pair,
								A2(
									$author$project$Request$BuildPlanner$pushCommit,
									$author$project$Model$Session$getCreds(session),
									{
										jE: $elm$core$Maybe$Nothing,
										xq: $elm$core$Maybe$Just(
											$author$project$Model$Branch$getID(
												$author$project$Pages$ProjectHistory$getCurrentBranch(model))),
										k$: buildExpr,
										c: 'Overwriting to commit ' + $danyx23$elm_uuid$Uuid$toString(commitID),
										BR: $author$project$Model$Commit$getCommitID(model.f0),
										ix: $author$project$Model$Organization$getUrlName(model.c3),
										vT: $author$project$Model$Project$getName(model.c5)
									}),
								A2(
									$elm$core$Task$mapError,
									$author$project$Model$BuildPlanner$BuildPlannerError$HttpError,
									A3(
										$author$project$Request$Project$get,
										creds,
										$author$project$Model$Organization$getUrlName(model.c3),
										$author$project$Model$Project$getName(model.c5))));
						},
						A2(
							$author$project$Request$BuildPlanner$getBuildExpr,
							session,
							{
								BR: commitID,
								ix: $author$project$Model$Organization$getUrlName(model.c3),
								vT: $author$project$Model$Project$getName(model.c5)
							})));
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						cmd,
						_Utils_update(
							model,
							{iy: true, ju: $elm$core$Maybe$Nothing})));
			default:
				if (!msg.a.$) {
					var _v8 = msg.a.a;
					var commit = _v8.a;
					var project = _v8.b;
					var maybeBranchName = A2($elm$core$Maybe$andThen, $author$project$Views$BranchPicker$getSelectedNameIfNotDefault, model.fJ);
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							A2(
								$elm$browser$Browser$Navigation$pushUrl,
								model.Y,
								$author$project$Model$Route$routeToString(
									$author$project$Model$Route$projectHistory(
										{
											fO: maybeBranchName,
											gr: $elm$core$Maybe$Nothing,
											ix: model.c3.AC,
											vT: $author$project$Model$Project$getName(model.c5)
										}))),
							_Utils_update(
								model,
								{f0: commit, iy: false, c5: project})));
				} else {
					if (!msg.a.a.$) {
						var err = msg.a.a.a;
						return A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2(
								$author$project$Misc$with,
								A3($author$project$Pages$ProjectHistory$rollbar.FZ, 'OnCommitOverwritten (Err (HttpError err))', err, session),
								_Utils_update(
									model,
									{iy: false})));
					} else {
						var err = msg.a.a;
						var message = $author$project$Pages$ProjectHistory$getSimplifiedErrorMessage(err);
						return A2(
							$author$project$Misc$with,
							$author$project$External$AddNotification(
								$author$project$Model$Notification$textWarning(message)),
							A2(
								$author$project$Misc$with,
								A2($author$project$Pages$ProjectHistory$rollbar.sk, message, session),
								_Utils_update(
									model,
									{iy: false})));
					}
				}
		}
	});
var $author$project$Pages$ProjectImpactReport$Diff = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$ProjectImpactReport$ImpactReportMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Views$ImpactReport$Saved = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Views$ImpactReport$Staged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Views$ImpactReport$getComparisonType = function (params) {
	_v0$2:
	while (true) {
		if ((!params.$) && (!params.a.a.$)) {
			switch (params.a.b.$) {
				case 0:
					var _v1 = params.a;
					var firstCommit = _v1.a.a;
					var secondCommit = _v1.b.a;
					return $elm$core$Maybe$Just(
						A2($author$project$Views$ImpactReport$Saved, firstCommit, secondCommit));
				case 2:
					var _v2 = params.a;
					var firstCommit = _v2.a.a;
					return $elm$core$Maybe$Just(
						$author$project$Views$ImpactReport$Staged(firstCommit));
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Pages$ProjectImpactReport$update = F3(
	function (_v0, action, model) {
		switch (action.$) {
			case 0:
				if (!action.a.$) {
					var diff = action.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{
									hi: $krisajenkins$remotedata$RemoteData$Success(
										$author$project$Views$ImpactReport$init(
											{
												BT: $author$project$Views$ImpactReport$getComparisonType(model.E5),
												t0: model.t0,
												ma: diff,
												c3: model.c3,
												vT: $author$project$Model$Project$getName(model.c5),
												FQ: model.t6,
												F7: true
											}))
								})));
				} else {
					var err = action.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{
									hi: $krisajenkins$remotedata$RemoteData$Failure(
										$author$project$Pages$ProjectImpactReport$Diff(err))
								})));
				}
			case 2:
				var portCopyStatus = action.a;
				var _v2 = model.hi;
				if (_v2.$ === 3) {
					var innerModel = _v2.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{
									hi: $krisajenkins$remotedata$RemoteData$Success(
										_Utils_update(
											innerModel,
											{oi: portCopyStatus}))
								})));
				} else {
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
				}
			default:
				var innerMsg = action.a;
				var _v3 = model.hi;
				if (_v3.$ === 3) {
					var innerModel = _v3.a;
					var _v4 = A2($author$project$Views$ImpactReport$update, innerMsg, innerModel);
					var _v5 = _v4.a;
					var newInnerModel = _v5.a;
					var cmd = _v5.b;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$ProjectImpactReport$ImpactReportMsg, cmd),
							_Utils_update(
								model,
								{
									hi: $krisajenkins$remotedata$RemoteData$Success(newInnerModel)
								})));
				} else {
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
				}
		}
	});
var $author$project$Pages$ProjectOverview$NormsAndVulnsMsg = function (a) {
	return {$: 23, a: a};
};
var $author$project$Pages$ProjectOverview$OnReceivedBuildPlan = F3(
	function (a, b, c) {
		return {$: 6, a: a, b: b, c: c};
	});
var $author$project$Pages$ProjectOverview$OnReceivedBuildPlanPollable = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$Pages$ProjectOverview$ReceiveSBOM = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$ProjectOverview$ReceiveSBOMWithDSSE = function (a) {
	return {$: 21, a: a};
};
var $author$project$Views$UpdateForkModal$UpdateFork = 0;
var $author$project$Pages$ProjectOverview$UpdateForkModalMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$ProjectOverview$buildPlanTask = F3(
	function (session, model, data) {
		return A3(
			$author$project$Request$BuildPlanner$getBuildPlan,
			session,
			false,
			{
				BR: data.BR,
				ix: $author$project$Model$Organization$getUrlName(model.c3),
				vT: $author$project$Model$Project$getName(model.c5)
			});
	});
var $author$project$Pages$ProjectOverview$CVESummaryMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Views$CVESummary$Available = 0;
var $author$project$Views$CVESummary$OnCVEReportData = $elm$core$Basics$identity;
var $author$project$Views$CVESummary$Unavailable = 1;
var $author$project$Model$Permissions$orgCanSeeDependenciesDashboard = $author$project$Model$Organization$addOnEnabled('dependencies_dashboard');
var $author$project$Model$Permissions$canViewOrgDependencies = function (org) {
	return A2(
		$author$project$Misc$isBoth,
		$author$project$Model$Permissions$canViewOrgPrivateInfo(org.AC),
		$elm$core$Basics$always(
			$author$project$Model$Permissions$orgCanSeeDependenciesDashboard(org)));
};
var $author$project$Request$CVEReport$CVEReport = function (link) {
	return {D1: link};
};
var $author$project$Request$CVEReport$decodeCVEReport = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'link',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Request$CVEReport$CVEReport));
var $author$project$Model$Route$withCommitID = F2(
	function (maybeCommitID, args) {
		return _Utils_update(
			args,
			{gr: maybeCommitID});
	});
var $author$project$Request$CVEReport$getCVEReport = F2(
	function (creds, info) {
		var url = 'https://platform.activestate.com/prod/report';
		var projectLink = 'https://platform.activestate.com' + $author$project$Model$Route$routeToString(
			A2(
				$author$project$Model$Route$projectConfig,
				{ix: info.ix, vT: info.vT},
				A2($author$project$Model$Route$withCommitID, info.BR, $author$project$Model$Route$projectConfigParams)));
		var ingredientsJSON = A2(
			$elm$json$Json$Encode$list,
			$elm$json$Json$Encode$object,
			A2(
				$elm$core$List$map,
				function (ingredient) {
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'ingredient',
							$elm$json$Json$Encode$string(ingredient.w)),
							_Utils_Tuple2(
							'version',
							$elm$json$Json$Encode$string(ingredient.aI)),
							_Utils_Tuple2(
							'namespace',
							$elm$json$Json$Encode$string(ingredient.aE))
						]);
				},
				info.w2));
		var body = $author$project$Http$Extra$jsonBody(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2('namespace_ingredient_versions', ingredientsJSON),
						_Utils_Tuple2(
						'organization_name',
						$elm$json$Json$Encode$string(info.ix)),
						_Utils_Tuple2(
						'project_name',
						$elm$json$Json$Encode$string(info.vT)),
						_Utils_Tuple2(
						'project_link',
						$elm$json$Json$Encode$string(projectLink)),
						_Utils_Tuple2(
						'commit_id',
						A2(
							$author$project$Json$Encode$Extra$maybe,
							$elm$json$Json$Encode$string,
							A2($elm$core$Maybe$map, $danyx23$elm_uuid$Uuid$toString, info.BR)))
					])));
		return $author$project$Http$Extra$post(
			{
				iO: $author$project$Http$Extra$HeaderOnly(creds),
				sY: body,
				qN: $author$project$Request$CVEReport$decodeCVEReport,
				CN: _List_Nil,
				GT: url
			});
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$isPanorama1 = function (editor) {
	var _v0 = $author$project$Model$BuildPlanner$BuildExprEditor$Simple$getMarkers(editor);
	if (_v0.$ === 4) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$isPanorama2 = function (editor) {
	var _v0 = $author$project$Model$BuildPlanner$BuildExprEditor$Simple$getMarkers(editor);
	if (_v0.$ === 5) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Model$Permissions$orgCanSeePDFReport = $author$project$Model$Organization$addOnEnabled('enhanced_cve_data');
var $author$project$Views$CVESummary$init = function (_v0) {
	var session = _v0.l;
	var organization = _v0.c3;
	var project = _v0.c5;
	var buildDataSources = _v0.k_;
	var editor = _v0.qR;
	var vulnerabilityKeys = A2(
		$elm_community$list_extra$List$Extra$uniqueBy,
		function (info) {
			return _Utils_Tuple3(info.w, info.aE, info.aI);
		},
		A2($elm$core$List$concatMap, $author$project$Model$BuildDataSource$getAllVulnerabilityKeys, buildDataSources));
	var isPanoramaAndShouldNotCallForNow = A2(
		$author$project$Model$Permissions$canViewOrgDependencies,
		organization,
		$author$project$Model$Session$getUser(session)) || ($author$project$Model$BuildPlanner$SolveLegacyEditor$isPanorama1(editor) || $author$project$Model$BuildPlanner$SolveLegacyEditor$isPanorama2(editor));
	var cveCoverage = $elm$core$List$isEmpty(buildDataSources) ? 1 : 0;
	var creds = $author$project$Model$Session$getCreds(session);
	var getReportCmd = A2(
		$elm$core$Task$attempt,
		$elm$core$Basics$identity,
		A2(
			$author$project$Request$CVEReport$getCVEReport,
			creds,
			{
				BR: $author$project$Model$Branch$getCommitID(
					$author$project$Model$Project$getDefaultBranch(project)),
				ix: organization.AC,
				vT: $author$project$Model$Project$getName(project),
				w2: vulnerabilityKeys
			}));
	var _v1 = ($author$project$Model$Permissions$orgCanSeePDFReport(organization) && (!isPanoramaAndShouldNotCallForNow)) ? _Utils_Tuple2(
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[getReportCmd])),
		$krisajenkins$remotedata$RemoteData$Loading) : _Utils_Tuple2($elm$core$Platform$Cmd$none, $krisajenkins$remotedata$RemoteData$NotAsked);
	var initCmds = _v1.a;
	var report = _v1.b;
	return A2(
		$author$project$Misc$with,
		initCmds,
		{
			qM: $elm$core$Maybe$Just(cveCoverage),
			ng: report
		});
};
var $author$project$Views$CVESummary$isEmpty = function (model) {
	var _v0 = model.ng;
	if (!_v0.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Model$Permissions$orgCanSeeCVEOverview = $author$project$Model$Organization$addOnEnabled('CVE');
var $author$project$Pages$ProjectOverview$showCVEs = F2(
	function (session, model) {
		var isSuperReader = $author$project$Model$User$isSuperReader(
			$author$project$Model$Session$getUser(session));
		var isMember = A2($author$project$Model$Session$isMember, model.c3.AC, session);
		var isDistribtionOnly = $author$project$Model$Project$getIsDistributionOnly(model.c5);
		var cveAddOnEnabled = $author$project$Model$Permissions$orgCanSeeCVEOverview(model.c3);
		return (!$author$project$Model$BuildPlanner$SolveLegacyEditor$isPanorama1(model.dj.hA.qR)) && (cveAddOnEnabled && ((isMember || isSuperReader) && (!isDistribtionOnly)));
	});
var $author$project$Pages$ProjectOverview$maybeInitCVESummary = F2(
	function (session, model) {
		var allBuildsLoaded = A2(
			$elm$core$List$all,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.n6;
				},
				$elm$core$Basics$neq($krisajenkins$remotedata$RemoteData$Loading)),
			$elm$core$Dict$values(model.dj.qq));
		var _v0 = (A2($author$project$Pages$ProjectOverview$showCVEs, session, model) && ($author$project$Views$CVESummary$isEmpty(model.i_) && allBuildsLoaded)) ? A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map($author$project$Pages$ProjectOverview$CVESummaryMsg),
			$author$project$Views$CVESummary$init(
				{k_: model.k_, qR: model.dj.hA.qR, c3: model.c3, c5: model.c5, l: session})) : _Utils_Tuple2(model.i_, $elm$core$Platform$Cmd$none);
		var cveSummary = _v0.a;
		var cveCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{i_: cveSummary}),
			cveCmd);
	});
var $author$project$Pages$ProjectOverview$recordNormsAndVulnsNormalized = F5(
	function (getNormalizedKeys, getNormalizedVulnerabilityKeys, session, model, result) {
		var creds = $author$project$Model$Session$getCreds(session);
		if (!result.$) {
			var value = result.a;
			return A4(
				$author$project$Model$NormsAndVulns$recordNormalizedVulnerabilityKeys,
				A2(
					$author$project$Model$Permissions$orgHasCvesEnabledAndVisible,
					model.c3,
					$author$project$Model$Session$getUser(session)),
				creds,
				getNormalizedVulnerabilityKeys(value),
				A2(
					$author$project$Model$NormsAndVulns$recordNormalizedKeys,
					getNormalizedKeys(value),
					model.rF));
		} else {
			return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model.rF);
		}
	});
var $author$project$Pages$ProjectOverview$NoOp = {$: 0};
var $author$project$Pages$ProjectOverview$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Pages$ProjectOverview$NoOp, 'Pages/ProjectOverview.elm');
var $author$project$Views$BranchDownloadsView$CopyChmod = function (a) {
	return {$: 1, a: a};
};
var $author$project$Views$BranchDownloadsView$ShowDownloadInstructionsModal = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $author$project$Views$BranchDownloadsView$update = F2(
	function (model, msg) {
		if (!msg.$) {
			var branch = msg.a;
			var commitID = msg.b;
			var downloads = msg.c;
			var platform = msg.d;
			return A2(
				$author$project$Misc$with,
				A4($author$project$Views$BranchDownloadsView$ShowDownloadInstructionsModal, branch, commitID, downloads, platform),
				model);
		} else {
			var input = msg.a;
			return A2(
				$author$project$Misc$with,
				$author$project$Views$BranchDownloadsView$CopyChmod(input),
				model);
		}
	});
var $author$project$Views$CVESummary$update = F2(
	function (model, event) {
		var result = event;
		return _Utils_update(
			model,
			{
				ng: $krisajenkins$remotedata$RemoteData$fromResult(result)
			});
	});
var $author$project$Views$BranchDownloadsView$updateBuildData = F3(
	function (branch, func, model) {
		var branchName = $author$project$Model$Branch$getName(branch);
		var newBranchNameToBuildData = A3($elm$core$Dict$update, branchName, func, model.qq);
		var newMainBranchBuildData = $author$project$Model$Branch$isDefault(branch) ? A2(
			$elm$core$Maybe$withDefault,
			model.hA,
			A2($elm$core$Dict$get, branchName, newBranchNameToBuildData)) : model.hA;
		return _Utils_update(
			model,
			{qq: newBranchNameToBuildData, hA: newMainBranchBuildData});
	});
var $author$project$Pages$ProjectOverview$update = F3(
	function (session, msg, model) {
		var dismissModals = function (updatedModel) {
			return _Utils_update(
				updatedModel,
				{oi: $author$project$Model$CopyStatus$empty, fM: $elm$core$Maybe$Nothing, ul: true, DD: false, kE: $elm$core$Maybe$Nothing});
		};
		switch (msg.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
			case 1:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{ul: true})));
			case 10:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{fM: $elm$core$Maybe$Nothing})));
			case 4:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						dismissModals(model)));
			case 5:
				if (!msg.c.$) {
					var buildData = msg.b;
					var buildPlan = msg.c.a;
					if ($author$project$Model$BuildPlanner$BuildPlan$isPlanningState(buildPlan.bB)) {
						var cmd = A2(
							$elm$core$Task$attempt,
							A2($author$project$Pages$ProjectOverview$OnReceivedBuildPlanPollable, 0, buildData),
							A3($author$project$Pages$ProjectOverview$buildPlanTask, session, model, buildData));
						return A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2($author$project$Misc$with, cmd, model));
					} else {
						var cmd = A2(
							$elm$core$Task$attempt,
							A2($author$project$Pages$ProjectOverview$OnReceivedBuildPlan, buildData.BR, buildData.h4),
							$elm$core$Task$succeed(
								{xt: buildPlan, qR: buildData.qR}));
						return A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2($author$project$Misc$with, cmd, model));
					}
				} else {
					var nbrAttempts = msg.a;
					var buildData = msg.b;
					var err = msg.c.a;
					var maxNbrAttempts = 3;
					var attemptDelaySecs = 3;
					if ((_Utils_cmp(nbrAttempts, maxNbrAttempts) < 0) && $author$project$Model$BuildPlanner$BuildPlannerError$isPossiblyTransient(err)) {
						var cmd = A2(
							$elm$core$Task$attempt,
							A2($author$project$Pages$ProjectOverview$OnReceivedBuildPlanPollable, nbrAttempts + 1, buildData),
							A3(
								$elm$core$Task$map2,
								$elm$core$Basics$always($elm$core$Basics$identity),
								$elm$core$Process$sleep(attemptDelaySecs * 1000),
								A3($author$project$Pages$ProjectOverview$buildPlanTask, session, model, buildData)));
						return A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2($author$project$Misc$with, cmd, model));
					} else {
						return A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2(
								$author$project$Misc$with,
								A2(
									$elm$core$Task$attempt,
									A2($author$project$Pages$ProjectOverview$OnReceivedBuildPlan, buildData.BR, buildData.h4),
									$elm$core$Task$fail(err)),
								model));
					}
				}
			case 6:
				if (!msg.c.$) {
					var commitID = msg.a;
					var branch = msg.b;
					var editor = msg.c.a.qR;
					var buildPlan = msg.c.a.xt;
					var platforms = A2(
						$elm$core$List$filterMap,
						A2($elm_community$basics_extra$Basics$Extra$flip, $elm$core$Dict$get, model.qg),
						$elm$core$Set$toList(
							$author$project$Model$BuildPlanner$SolveLegacyEditor$getPlatforms(editor)));
					var languages = A2(
						$elm$core$List$filterMap,
						function (l) {
							return $author$project$Model$Language$fromString(l.a);
						},
						$elm$core$Dict$toList(
							$author$project$Model$BuildPlanner$SolveLegacyEditor$getLanguages(editor)));
					var getVulnerabilityKeys = function (dataSource) {
						return A2(
							$elm$core$List$map,
							$author$project$Model$NormsAndVulns$NamespacedVulnKey,
							_Utils_ap(
								$author$project$Model$BuildDataSource$getAllVulnerabilityKeys(dataSource),
								$author$project$Model$BuildDataSource$getComponentVulnerabilityKeys(dataSource)));
					};
					var getPurlVulnKeys = function (dataSource) {
						return A2(
							$elm$core$List$map,
							$author$project$Model$NormsAndVulns$PurlVulnKey,
							$author$project$Model$BuildDataSource$getComponentPurlVulnKeys(dataSource));
					};
					var getNamespaceKeys = function (dataSource) {
						return A2(
							$elm$core$List$map,
							$elm$core$Basics$identity,
							$elm$core$Set$toList(
								$author$project$Model$BuildDataSource$getNodeKeys(dataSource)));
					};
					var buildDataSource = $author$project$Model$BuildDataSource$init(buildPlan);
					var progressTrackers = A2(
						$elm$core$Result$withDefault,
						_List_Nil,
						$author$project$Model$ProgressTracker$buildPlanInit(
							{
								h4: branch,
								xt: buildPlan,
								BR: commitID,
								aM: $author$project$Model$BuildDataSource$getLanguages(buildDataSource),
								pd: model.c3,
								Fh: platforms,
								c5: model.c5
							}));
					var allVulnKeys = function (dataSource) {
						return _Utils_ap(
							getVulnerabilityKeys(dataSource),
							getPurlVulnKeys(dataSource));
					};
					var accumProgressTracker = F2(
						function (progressTracker, platformIdToProgress) {
							return A3(
								$elm$core$Dict$insert,
								$author$project$Model$Platform$id(progressTracker.po),
								progressTracker,
								platformIdToProgress);
						});
					var updateBuildData = function (branchBuildData) {
						return _Utils_update(
							branchBuildData,
							{
								n6: $krisajenkins$remotedata$RemoteData$Success(buildDataSource),
								ff: A3($elm$core$List$foldl, accumProgressTracker, branchBuildData.ff, progressTrackers)
							});
					};
					var modelWithUpdatedBuildData = _Utils_update(
						model,
						{
							dj: A3(
								$author$project$Views$BranchDownloadsView$updateBuildData,
								branch,
								$elm$core$Maybe$map(updateBuildData),
								model.dj),
							k_: A2($elm$core$List$cons, buildDataSource, model.k_)
						});
					var _v1 = A2($author$project$Pages$ProjectOverview$maybeInitCVESummary, session, modelWithUpdatedBuildData);
					var newModel = _v1.a;
					var cveCmd = _v1.b;
					var _v2 = A5(
						$author$project$Pages$ProjectOverview$recordNormsAndVulnsNormalized,
						getNamespaceKeys,
						allVulnKeys,
						session,
						newModel,
						$elm$core$Result$Ok(buildDataSource));
					var normsAndVulnsModel = _v2.a;
					var normsAndVulnsCmd = _v2.b;
					return A2(
						$author$project$Misc$with,
						A2(
							$author$project$External$AddBuildPlan,
							{
								BR: commitID,
								ix: $author$project$Model$Organization$getUrlName(model.c3),
								vT: $author$project$Model$Project$getName(model.c5)
							},
							$author$project$Model$BuildDataSource$getBuildPlan(buildDataSource)),
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										cveCmd,
										A2($elm$core$Platform$Cmd$map, $author$project$Pages$ProjectOverview$NormsAndVulnsMsg, normsAndVulnsCmd)
									])),
							_Utils_update(
								newModel,
								{qf: languages, rF: normsAndVulnsModel})));
				} else {
					var branch = msg.b;
					var err = msg.c.a;
					var updateFailed = function (data) {
						return A2(
							$elm$core$Maybe$map,
							function (d) {
								return _Utils_update(
									d,
									{
										n6: $krisajenkins$remotedata$RemoteData$Failure(err)
									});
							},
							data);
					};
					var branchesModel = model.dj;
					var branchName = $author$project$Model$Branch$getName(branch);
					var erroredBuildDatas = A3($elm$core$Dict$update, branchName, updateFailed, branchesModel.qq);
					var modelWithBuilds = _Utils_update(
						model,
						{
							dj: _Utils_update(
								branchesModel,
								{qq: erroredBuildDatas})
						});
					var _v3 = A2($author$project$Pages$ProjectOverview$maybeInitCVESummary, session, modelWithBuilds);
					var newModel = _v3.a;
					var cveCmd = _v3.b;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2($author$project$Misc$with, cveCmd, newModel));
				}
			case 2:
				var input = msg.a;
				var eventArgs = A2(
					$author$project$Model$Analytics$withLabel,
					'Project Overview tab',
					A2(
						$author$project$Model$Analytics$withAction,
						'Copied CLI install script to clipboard',
						A2(
							$author$project$Model$Analytics$withCategory,
							'Project installation',
							$author$project$Model$Analytics$newEvent('Copied CLI install script to clipboard'))));
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Ports$copyToClipboard(input),
									$author$project$Ports$sendAnalyticsEvent(eventArgs)
								])),
						_Utils_update(
							model,
							{oi: $author$project$Model$CopyStatus$empty})));
			case 3:
				var portCopyStatus = msg.a;
				var branchesModel = model.dj;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								dj: _Utils_update(
									branchesModel,
									{oi: portCopyStatus}),
								oi: portCopyStatus,
								fM: A2(
									$elm$core$Maybe$map,
									function (x) {
										return _Utils_update(
											x,
											{wa: true});
									},
									model.fM)
							})));
			case 13:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								fM: A2(
									$elm$core$Maybe$map,
									function (x) {
										return _Utils_update(
											x,
											{wa: !x.wa});
									},
									model.fM)
							})));
			case 8:
				var msgToModal = msg.a;
				var updatedModel = A2($author$project$Views$CVESummary$update, model.i_, msgToModal);
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{i_: updatedModel})));
			case 7:
				var innerMsg = msg.a;
				var _v4 = model.kE;
				if (_v4.$ === 1) {
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
				} else {
					var innerModel = _v4.a;
					var _v5 = A2($author$project$Views$UpdateForkModal$update, innerModel, innerMsg);
					var _v6 = _v5.a;
					var _v7 = _v6.a;
					var newInnerModel = _v7.a;
					var innerCmd = _v7.b;
					var innerExternal = _v6.b;
					var external = _v5.b;
					var _v8 = function () {
						switch (innerExternal) {
							case 0:
								return A2(
									$author$project$Misc$with,
									$elm$core$Platform$Cmd$none,
									_Utils_update(
										model,
										{
											kE: $elm$core$Maybe$Just(newInnerModel)
										}));
							case 1:
								return A2(
									$author$project$Misc$with,
									$elm$core$Platform$Cmd$none,
									_Utils_update(
										model,
										{kE: $elm$core$Maybe$Nothing}));
							default:
								return A2(
									$author$project$Misc$with,
									A2(
										$elm$core$Task$attempt,
										$author$project$Pages$ProjectOverview$SoftRefreshComplete,
										A8(
											$author$project$Pages$ProjectOverview$init,
											session,
											model.Y,
											model.c3.AC,
											$author$project$Model$Project$getName(model.c5),
											$elm$core$Maybe$Nothing,
											false,
											model.Bi,
											model.DD)),
									_Utils_update(
										model,
										{kE: $elm$core$Maybe$Nothing}));
						}
					}();
					var newModel = _v8.a;
					var cmd = _v8.b;
					return A2(
						$author$project$Misc$with,
						external,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										cmd,
										A2($elm$core$Platform$Cmd$map, $author$project$Pages$ProjectOverview$UpdateForkModalMsg, innerCmd)
									])),
							newModel));
				}
			case 11:
				if (!msg.a.$) {
					var freshModel = msg.a.a;
					var mainBranchName = $author$project$Model$Branch$getName(freshModel.dj.hA.h4);
					var branchNameToBuildData = A3(
						$elm$core$Dict$insert,
						mainBranchName,
						freshModel.dj.hA,
						A2($elm$core$Dict$remove, mainBranchName, freshModel.dj.qq));
					var branchCmds = A2(
						$elm$core$List$map,
						function (buildData) {
							return A2(
								$elm$core$Task$attempt,
								A2($author$project$Pages$ProjectOverview$OnReceivedBuildPlanPollable, 0, buildData),
								A3($author$project$Pages$ProjectOverview$buildPlanTask, session, model, buildData));
						},
						$elm$core$Dict$values(branchNameToBuildData));
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$batch(branchCmds),
							freshModel));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$textWarning('An error occured while reloading the project information.')),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$ProjectOverview$rollbar.FZ, 'SoftRefreshComplete (Err err)', err, session),
							model));
				}
			case 9:
				var defaultBranch = $author$project$Model$Project$getDefaultBranch(model.c5);
				var _v10 = A6(
					$author$project$Views$UpdateForkModal$init,
					$author$project$Model$Session$getCreds(session),
					defaultBranch,
					model.c5,
					$author$project$Model$Organization$getUrlName(model.c3),
					model.qg,
					0);
				var innerModel = _v10.a;
				var innerCmd = _v10.b;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$ProjectOverview$UpdateForkModalMsg, innerCmd),
						_Utils_update(
							model,
							{
								kE: $elm$core$Maybe$Just(innerModel)
							})));
			case 12:
				var branchMsg = msg.a;
				var _v11 = A2($author$project$Views$BranchDownloadsView$update, model.dj, branchMsg);
				var branchModel = _v11.a;
				var branchExtMsg = _v11.b;
				var _v12 = function () {
					if (!branchExtMsg.$) {
						var branch = branchExtMsg.a;
						var commitID = branchExtMsg.b;
						var downloads = branchExtMsg.c;
						var platform = branchExtMsg.d;
						var eventArgs = A2(
							$author$project$Model$Analytics$withLabel,
							'Project Overview tab',
							A2(
								$author$project$Model$Analytics$withAction,
								'Viewed CLI instructions modal',
								A2(
									$author$project$Model$Analytics$withCategory,
									'Project installation',
									$author$project$Model$Analytics$newEvent('Viewed CLI instructions modal'))));
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									fM: $elm$core$Maybe$Just(
										{
											h4: branch,
											ln: 0,
											rW: platform,
											pr: $elm$core$Maybe$Just(
												{BR: commitID, tH: downloads}),
											wa: false
										})
								}),
							$author$project$Ports$sendAnalyticsEvent(eventArgs));
					} else {
						var input = branchExtMsg.a;
						return _Utils_Tuple2(
							model,
							$author$project$Ports$copyToClipboard(input));
					}
				}();
				var newModel = _v12.a;
				var analyticsCmd = _v12.b;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						analyticsCmd,
						_Utils_update(
							newModel,
							{dj: branchModel})));
			case 14:
				var tab = msg.a;
				var newDIM = function (oldDim) {
					return A2(
						$elm$core$Maybe$map,
						function (newDim) {
							return _Utils_update(
								newDim,
								{ln: tab});
						},
						oldDim);
				};
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								fM: newDIM(model.fM)
							})));
			case 15:
				return model.DD ? A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$browser$Browser$Navigation$replaceUrl,
							model.Y,
							$author$project$Model$Project$getName(model.c5)),
						_Utils_update(
							model,
							{DD: false}))) : A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
			case 16:
				var input = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$author$project$Ports$copyToClipboard(input),
						model));
			case 17:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{oQ: false})));
			case 18:
				var getSPDXFile = A3(
					$author$project$Request$BuildPlanner$getSPDXFile,
					session,
					{
						BR: model.dj.hA.BR,
						ix: $author$project$Model$Organization$getUrlName(model.c3),
						vT: $author$project$Model$Project$getName(model.c5)
					},
					{aI: '0.1'});
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2($elm$core$Task$attempt, $author$project$Pages$ProjectOverview$ReceiveSBOM, getSPDXFile),
						_Utils_update(
							model,
							{nm: $author$project$Views$CreateSBOM$Loading})));
			case 19:
				if (!msg.a.$) {
					var sbom = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$author$project$Ports$promptToDownload(
								A2($author$project$Model$PromptToDownload$spdxModel, model.c5, sbom)),
							_Utils_update(
								model,
								{
									nm: $author$project$Views$CreateSBOM$Loaded(sbom)
								})));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$textWarning('An error occurred while fetching the SBOM.')),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$ProjectOverview$rollbar.FZ, 'ReceiveSBOM (Err err)', err, session),
							_Utils_update(
								model,
								{nm: $author$project$Views$CreateSBOM$NotLoaded})));
				}
			case 20:
				var getSBOM = A3(
					$author$project$Request$BuildPlanner$getSBOMWithDSSE,
					session,
					{
						BR: model.dj.hA.BR,
						ix: $author$project$Model$Organization$getUrlName(model.c3),
						vT: $author$project$Model$Project$getName(model.c5)
					},
					{aI: '0.1'});
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2($elm$core$Task$attempt, $author$project$Pages$ProjectOverview$ReceiveSBOMWithDSSE, getSBOM),
						_Utils_update(
							model,
							{nn: $author$project$Views$CreateSBOM$Loading})));
			case 21:
				if (!msg.a.$) {
					var sbom = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							$author$project$Ports$promptToDownload(
								A2($author$project$Model$PromptToDownload$sbomDsseModel, model.c5, sbom)),
							_Utils_update(
								model,
								{
									nn: $author$project$Views$CreateSBOM$Loaded(sbom)
								})));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$textWarning('An error occurred while fetching the SBOM.')),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$ProjectOverview$rollbar.FZ, 'ReceiveSBOMWithDSSE (Err err)', err, session),
							_Utils_update(
								model,
								{nn: $author$project$Views$CreateSBOM$NotLoaded})));
				}
			case 22:
				var platformType = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{q$: platformType})));
			default:
				var normsAndVulnsMsg = msg.a;
				var _v14 = A4(
					$author$project$Model$NormsAndVulns$update,
					$author$project$Model$NormsAndVulns$toRollbar($author$project$Pages$ProjectOverview$rollbar),
					session,
					normsAndVulnsMsg,
					model.rF);
				var _v15 = _v14.a;
				var newNormsAndVulns = _v15.a;
				var normsAndVulnsCmd = _v15.b;
				var external = _v14.b;
				return A2(
					$author$project$Misc$with,
					external,
					A2(
						$author$project$Misc$with,
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$ProjectOverview$NormsAndVulnsMsg, normsAndVulnsCmd),
						_Utils_update(
							model,
							{rF: newNormsAndVulns})));
		}
	});
var $author$project$Pages$ProjectSettings$ConfirmOrCancel = 1;
var $author$project$Pages$ProjectSettings$NoOp = {$: 0};
var $author$project$Pages$ProjectSettings$OnUpdateProject = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$ProjectSettings$ProjectDeleted = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$ProjectSettings$ProjectMoved = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$ProjectSettings$RedirectToNewProject = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Request$Project$delete = F3(
	function (creds, orgName, projectName) {
		return $author$project$Http$Extra$delete(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$emptyJsonBody,
				qN: $author$project$Model$Message$decode,
				CN: _List_Nil,
				GT: A2($author$project$Request$Project$urlPathOrgProject, orgName, projectName)
			});
	});
var $author$project$Model$ProjectEditable$encode = function (_v0) {
	var name = _v0.w;
	var description = _v0.bP;
	var repoUrl = _v0.zP;
	var _private = _v0.cd;
	var managed = _v0.b4;
	var distributionOnly = _v0.x5;
	var forkedFrom = _v0.yp;
	var forkedFromPairs = function () {
		if (!forkedFrom.$) {
			var organization = forkedFrom.a.c3;
			var project = forkedFrom.a.c5;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'forkedFrom',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'organization',
								$elm$json$Json$Encode$string(organization)),
								_Utils_Tuple2(
								'project',
								$elm$json$Json$Encode$string(project))
							])))
				]);
		} else {
			return _List_Nil;
		}
	}();
	return $elm$json$Json$Encode$object(
		_Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'name',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, name))),
					_Utils_Tuple2(
					'description',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, description))),
					_Utils_Tuple2(
					'repoUrl',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, repoUrl))),
					_Utils_Tuple2(
					'private',
					$elm$json$Json$Encode$bool(_private)),
					_Utils_Tuple2(
					'managed',
					$elm$json$Json$Encode$bool(managed)),
					_Utils_Tuple2(
					'distributionOnly',
					$elm$json$Json$Encode$bool(distributionOnly))
				]),
			forkedFromPairs));
};
var $author$project$Request$Project$edit = F4(
	function (creds, orgName, projectName, projectEditable) {
		return $author$project$Http$Extra$post(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$jsonBody(
					$author$project$Model$ProjectEditable$encode(projectEditable)),
				qN: $author$project$Model$Project$decode,
				CN: _List_Nil,
				GT: A2($author$project$Request$Project$urlPathOrgProject, orgName, projectName)
			});
	});
var $author$project$Model$ProjectEditable$empty = {bP: $elm$core$Maybe$Nothing, x5: false, yp: $elm$core$Maybe$Nothing, b4: false, w: $elm$core$Maybe$Nothing, cd: false, zP: $elm$core$Maybe$Nothing};
var $author$project$Pages$ProjectSettings$forkedFromChanged = F2(
	function (project, formFields) {
		var _v0 = $author$project$Pages$ProjectSettings$getForkedFromOrgAndProject(project);
		var forkedFromOrganization = _v0.a;
		var forkedFromProject = _v0.b;
		return (!_Utils_eq(
			$elm$core$String$toLower(forkedFromOrganization),
			$elm$core$String$toLower(
				$author$project$Validation$formatUsername(formFields.is)))) || (!_Utils_eq(
			$elm$core$String$toLower(forkedFromProject),
			$elm$core$String$toLower(
				$author$project$Validation$formatProjectName(formFields.it))));
	});
var $author$project$Request$Project$move = F4(
	function (creds, originOrg, originProject, destination) {
		return $author$project$Http$Extra$post(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'destination',
								$elm$json$Json$Encode$string(destination))
							]))),
				qN: $author$project$Model$Project$decode,
				CN: _List_Nil,
				GT: A2(
					$elm$url$Url$Builder$relative,
					_List_fromArray(
						[
							A2($author$project$Request$Project$urlPathOrgProject, originOrg, originProject),
							'move'
						]),
					_List_Nil)
			});
	});
var $author$project$Pages$ProjectSettings$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Pages$ProjectSettings$NoOp, 'Pages/ProjectSettings.elm');
var $author$project$Pages$ProjectSettings$update = F3(
	function (session, msg, model) {
		var creds = $author$project$Model$Session$getCreds(session);
		switch (msg.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
			case 1:
				var field = msg.a;
				var fields = model.bD;
				var newFields = function () {
					switch (field.$) {
						case 0:
							var name = field.a;
							return _Utils_update(
								fields,
								{w: name});
						case 1:
							var description = field.a;
							return _Utils_update(
								fields,
								{bP: description});
						case 2:
							var repoURL = field.a;
							return _Utils_update(
								fields,
								{nf: repoURL});
						case 4:
							var isManaged = field.a;
							return _Utils_update(
								fields,
								{j2: isManaged});
						case 3:
							var isPrivate = field.a;
							return _Utils_update(
								fields,
								{Dy: isPrivate});
						case 5:
							var isDistributionOnly = field.a;
							return _Utils_update(
								fields,
								{iu: isDistributionOnly});
						case 6:
							var forkedFromOrganization = field.a;
							return _Utils_update(
								fields,
								{is: forkedFromOrganization});
						default:
							var forkedFromProject = field.a;
							return _Utils_update(
								fields,
								{it: forkedFromProject});
					}
				}();
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{bD: newFields})));
			case 2:
				var projectEditable = $author$project$Model$ProjectEditable$empty;
				var newName = $author$project$Validation$formatProjectName(model.bD.w);
				var edits = _Utils_update(
					projectEditable,
					{
						bP: $elm$core$Maybe$Just(model.bD.bP),
						x5: model.bD.iu,
						yp: A2($author$project$Pages$ProjectSettings$forkedFromChanged, model.c5, model.bD) ? $elm$core$Maybe$Just(
							{
								c3: model.bD.is,
								c5: $author$project$Validation$formatProjectName(model.bD.it)
							}) : $elm$core$Maybe$Nothing,
						b4: model.bD.j2,
						w: $elm$core$Maybe$Just(newName),
						cd: model.bD.Dy,
						zP: $elm$core$Maybe$Just(model.bD.nf)
					});
				var saveCmds = _List_fromArray(
					[
						$author$project$Misc$scrollToTop($author$project$Pages$ProjectSettings$NoOp),
						A2(
						$elm$core$Task$attempt,
						$author$project$Pages$ProjectSettings$OnUpdateProject(newName),
						A4(
							$author$project$Request$Project$edit,
							creds,
							model.c3.AC,
							$author$project$Model$Project$getName(model.c5),
							edits))
					]);
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$batch(saveCmds),
						model));
			case 3:
				if (!msg.b.$) {
					var newName = msg.a;
					var project = msg.b.a;
					var reloadRoute = $author$project$Model$Route$Protected(
						$author$project$Model$Route$Org(
							{
								ix: model.c3.AC,
								vI: $author$project$Model$Route$OrgProject(
									{
										vT: newName,
										zL: A2($author$project$Model$Route$ProjectSettings, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)
									})
							}));
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$textSuccess('Project settings saved.')),
						A2(
							$author$project$Misc$with,
							A2($author$project$Routing$replaceUrl, model.Y, reloadRoute),
							_Utils_update(
								model,
								{c5: project})));
				} else {
					var err = msg.b.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$ProjectSettings$rollbar.FZ, 'OnUpdateProject _ (Err err)', err, session),
							model));
				}
			case 4:
				var fields = model.bD;
				var newFields = _Utils_update(
					fields,
					{
						is: $author$project$Validation$formatUsername(fields.is),
						it: $author$project$Validation$formatProjectName(fields.it)
					});
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{bD: newFields})));
			case 5:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{oo: 1})));
			case 6:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{oo: 0})));
			case 7:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$ProjectSettings$ProjectDeleted,
							A3(
								$author$project$Request$Project$delete,
								creds,
								model.c3.AC,
								$author$project$Model$Project$getName(model.c5))),
						model));
			case 8:
				if (!msg.a.$) {
					var message = 'The \"' + ($author$project$Model$Project$getName(model.c5) + '\" project was successfully deleted.');
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$textSuccess(message)),
						A2(
							$author$project$Misc$with,
							A2(
								$author$project$Routing$replaceUrl,
								model.Y,
								$author$project$Model$Route$Protected(
									$author$project$Model$Route$Home(
										{wd: $elm$core$Maybe$Nothing}))),
							model));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$ProjectSettings$rollbar.FZ, 'ProjectDeleted (Err err)', err, session),
							model));
				}
			case 9:
				var destination = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$ProjectSettings$ProjectMoved,
							A4(
								$author$project$Request$Project$move,
								creds,
								model.c3.AC,
								$author$project$Model$Project$getName(model.c5),
								destination)),
						_Utils_update(
							model,
							{oO: true})));
			case 10:
				if (!msg.a.$) {
					var project = msg.a.a;
					var destinationOrgName = A2($elm$core$Maybe$withDefault, 'Impossible', model.o3);
					var redirectCmd = A2(
						$elm$core$Task$perform,
						function (_v2) {
							return A2($author$project$Pages$ProjectSettings$RedirectToNewProject, destinationOrgName, project);
						},
						$elm$core$Process$sleep(2000));
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$textSuccess(
								'The \"' + ($author$project$Model$Project$getName(project) + '\" project was successfully moved. Redirecting...'))),
						A2($author$project$Misc$with, redirectCmd, model));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$ProjectSettings$rollbar.FZ, 'ProjectMoved (Err err)', err, session),
							_Utils_update(
								model,
								{oO: false})));
				}
			case 11:
				var orgUrlName = msg.a;
				var project = msg.b;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$author$project$Routing$pushUrl,
							model.Y,
							$author$project$Model$Route$ProjectOverview(
								{
									g$: $elm$core$Maybe$Nothing,
									uk: false,
									DD: false,
									fO: $elm$core$Maybe$Nothing,
									gr: $elm$core$Maybe$Nothing,
									ix: orgUrlName,
									vT: $author$project$Model$Project$getName(project)
								})),
						model));
			default:
				var destination = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{o3: destination})));
		}
	});
var $author$project$Pages$ProjectSettingsBranches$ConfigDeleted = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$ProjectSettingsBranches$ConfigSaved = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$ProjectSettingsBranches$NoOp = {$: 0};
var $author$project$Pages$ProjectSettingsBranches$OnUpdateProject = function (a) {
	return {$: 1, a: a};
};
var $author$project$Request$Project$addBranch = F2(
	function (creds, _v0) {
		var projectID = _v0.zK;
		var name = _v0.w;
		return $author$project$Http$Extra$post(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'label',
								$elm$json$Json$Encode$string(name))
							]))),
				qN: $author$project$Model$Branch$decode,
				CN: _List_Nil,
				GT: '/projects/' + ($danyx23$elm_uuid$Uuid$toString(projectID) + '/branches/')
			});
	});
var $author$project$Request$VCS$deleteBranch = F2(
	function (creds, branchID) {
		return $author$project$Http$Extra$delete(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$emptyJsonBody,
				qN: $author$project$Model$Message$decode,
				CN: _List_Nil,
				GT: '/vcs/branch/' + $danyx23$elm_uuid$Uuid$toString(branchID)
			});
	});
var $author$project$Model$BranchEditable$encode = function (branch) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'commitID',
				A2($author$project$Json$Encode$Extra$maybe, $danyx23$elm_uuid$Uuid$encode, branch.BR)),
				_Utils_Tuple2(
				'label',
				A2($author$project$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, branch.w)),
				_Utils_Tuple2(
				'tracks',
				A2($author$project$Json$Encode$Extra$maybe, $danyx23$elm_uuid$Uuid$encode, branch.cq)),
				_Utils_Tuple2(
				'tracking_type',
				A2($author$project$Json$Encode$Extra$maybe, $author$project$Model$Branch$encodeTrackingType, branch.GM))
			]));
};
var $author$project$Request$VCS$editBranch = F2(
	function (creds, branch) {
		return A3(
			$author$project$Request$VCS$putBranch,
			creds,
			branch.xq,
			$author$project$Model$BranchEditable$encode(branch));
	});
var $author$project$Model$BranchEditable$empty = function (branchID) {
	return {xq: branchID, BR: $elm$core$Maybe$Nothing, w: $elm$core$Maybe$Nothing, GM: $elm$core$Maybe$Nothing, cq: $elm$core$Maybe$Nothing};
};
var $author$project$Views$ProjectBranchModal$initialFocusID = 'project-branch-name-input';
var $author$project$Validation$formatVcsRefsName = function (name) {
	return $elm$core$String$toLower(
		A3($elm$core$List$foldl, $author$project$Validation$applyRegex, name, $author$project$Validation$alphaNumericAndDotsHyphens));
};
var $author$project$Views$ProjectBranchModal$new = F2(
	function (mode, branch) {
		var name = function () {
			if (!mode) {
				return '';
			} else {
				return $author$project$Model$Branch$getName(branch);
			}
		}();
		return {
			h4: branch,
			El: mode,
			w: name,
			o4: $elm$core$Maybe$Nothing,
			jf: $author$project$Validation$formatVcsRefsName(name)
		};
	});
var $author$project$Pages$ProjectSettingsBranches$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Pages$ProjectSettingsBranches$NoOp, 'Pages/ProjectSettingsBranches.elm');
var $author$project$Views$ProjectBranchModal$Close = {$: 2};
var $author$project$Views$ProjectBranchModal$Create = function (a) {
	return {$: 0, a: a};
};
var $author$project$Views$ProjectBranchModal$None = {$: 3};
var $author$project$Views$ProjectBranchModal$Update = function (a) {
	return {$: 1, a: a};
};
var $author$project$Validation$minBranchNameLength = 3;
var $author$project$Validation$validateVcsRefName = $author$project$Validation$runValidations(
	_List_fromArray(
		[
			_Utils_Tuple2($elm$core$String$isEmpty, 'Please provide a name'),
			_Utils_Tuple2(
			$author$project$Validation$isShorterThan($author$project$Validation$minBranchNameLength),
			'Must be at least ' + ($elm$core$String$fromInt($author$project$Validation$minBranchNameLength) + ' characters long'))
		]));
var $author$project$Views$ProjectBranchModal$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var name = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$Views$ProjectBranchModal$None,
					_Utils_update(
						model,
						{
							w: name,
							jf: $author$project$Validation$formatVcsRefsName(name)
						}));
			case 1:
				var nameError = $author$project$Validation$validateVcsRefName(model.jf);
				var cmd = function () {
					var _v1 = _Utils_Tuple2(nameError, model.El);
					_v1$0:
					while (true) {
						if (!_v1.b) {
							if (!_v1.a.$) {
								break _v1$0;
							} else {
								var _v2 = _v1.b;
								return $author$project$Views$ProjectBranchModal$Create(
									{w: model.jf, E6: model.h4});
							}
						} else {
							if (!_v1.a.$) {
								break _v1$0;
							} else {
								var _v3 = _v1.b;
								return $author$project$Views$ProjectBranchModal$Update(
									{h4: model.h4, w: model.jf});
							}
						}
					}
					return $author$project$Views$ProjectBranchModal$None;
				}();
				return A2(
					$author$project$Misc$with,
					cmd,
					_Utils_update(
						model,
						{o4: nameError}));
			default:
				return A2($author$project$Misc$with, $author$project$Views$ProjectBranchModal$Close, model);
		}
	});
var $author$project$Pages$ProjectSettingsBranches$update = F3(
	function (session, msg, model) {
		var creds = $author$project$Model$Session$getCreds(session);
		switch (msg.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
			case 1:
				if (!msg.a.$) {
					var project = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$textSuccess('Branches successfully updated.')),
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{c5: project})));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$ProjectSettingsBranches$rollbar.FZ, 'OnUpdateProject (Err err)', err, session),
							model));
				}
			case 2:
				var mode = msg.a;
				var branch = msg.b;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$elm$core$Basics$always($author$project$Pages$ProjectSettingsBranches$NoOp),
							$elm$browser$Browser$Dom$focus($author$project$Views$ProjectBranchModal$initialFocusID)),
						_Utils_update(
							model,
							{
								h5: $elm$core$Maybe$Just(
									A2($author$project$Views$ProjectBranchModal$new, mode, branch))
							})));
			case 3:
				var branchModal = msg.a;
				var branchModalMsg = msg.b;
				var _v1 = A2($author$project$Views$ProjectBranchModal$update, branchModalMsg, branchModal);
				var newConfigModal = _v1.a;
				var extMsg = _v1.b;
				var newModel = _Utils_update(
					model,
					{
						h5: $elm$core$Maybe$Just(newConfigModal)
					});
				switch (extMsg.$) {
					case 1:
						var name = extMsg.a.w;
						var branch = extMsg.a.h4;
						var branchEditable = $author$project$Model$BranchEditable$empty(
							$author$project$Model$Branch$getID(branch));
						return A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2(
								$author$project$Misc$with,
								A2(
									$elm$core$Task$attempt,
									$author$project$Pages$ProjectSettingsBranches$ConfigSaved(newConfigModal),
									A2(
										$author$project$Request$VCS$editBranch,
										creds,
										_Utils_update(
											branchEditable,
											{
												w: $elm$core$Maybe$Just(name)
											}))),
								newModel));
					case 0:
						var name = extMsg.a.w;
						var parent = extMsg.a.E6;
						var editBranch = function (branch) {
							var branchEditable = $author$project$Model$BranchEditable$empty(
								$author$project$Model$Branch$getID(branch));
							return A2(
								$author$project$Request$VCS$editBranch,
								creds,
								_Utils_update(
									branchEditable,
									{
										GM: $elm$core$Maybe$Just(2),
										cq: $elm$core$Maybe$Just(
											$author$project$Model$Branch$getID(parent))
									}));
						};
						var createBranch = A2(
							$author$project$Request$Project$addBranch,
							creds,
							{
								w: name,
								zK: $author$project$Model$Project$id(model.c5)
							});
						var cmd = A2(
							$elm$core$Task$attempt,
							$author$project$Pages$ProjectSettingsBranches$ConfigSaved(newConfigModal),
							A2($elm$core$Task$andThen, editBranch, createBranch));
						return A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2($author$project$Misc$with, cmd, newModel));
					case 2:
						return A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2(
								$author$project$Misc$with,
								$elm$core$Platform$Cmd$none,
								_Utils_update(
									newModel,
									{h5: $elm$core$Maybe$Nothing})));
					default:
						return A2(
							$author$project$Misc$with,
							$author$project$External$NoOp,
							A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, newModel));
				}
			case 4:
				if (!msg.b.$) {
					var branch = msg.b.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							A2(
								$elm$core$Task$attempt,
								$author$project$Pages$ProjectSettingsBranches$OnUpdateProject,
								A3(
									$author$project$Request$Project$get,
									creds,
									model.c3.AC,
									$author$project$Model$Project$getName(model.c5))),
							_Utils_update(
								model,
								{
									h5: $elm$core$Maybe$Nothing,
									oY: $elm$core$Maybe$Just(branch)
								})));
				} else {
					var branchModal = msg.a;
					var err = msg.b.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$ProjectSettingsBranches$rollbar.FZ, 'ConfigSaved branchModal (Err err)', err, session),
							_Utils_update(
								model,
								{
									h5: $elm$core$Maybe$Just(branchModal)
								})));
				}
			case 5:
				var branch = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								kW: $elm$core$Maybe$Just(branch),
								oY: $elm$core$Maybe$Nothing
							})));
			case 6:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{kW: $elm$core$Maybe$Nothing})));
			case 7:
				var id = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$ProjectSettingsBranches$ConfigDeleted,
							A2($author$project$Request$VCS$deleteBranch, creds, id)),
						model));
			case 8:
				if (!msg.a.$) {
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							A2(
								$elm$core$Task$attempt,
								$author$project$Pages$ProjectSettingsBranches$OnUpdateProject,
								A3(
									$author$project$Request$Project$get,
									creds,
									model.c3.AC,
									$author$project$Model$Project$getName(model.c5))),
							_Utils_update(
								model,
								{kW: $elm$core$Maybe$Nothing})));
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$fromError(err)),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$ProjectSettingsBranches$rollbar.FZ, 'ConfigDeleted (Err err)', err, session),
							model));
				}
			default:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{h5: $elm$core$Maybe$Nothing})));
		}
	});
var $author$project$Views$Modal$CancelButton = $elm$core$Basics$identity;
var $author$project$Pages$ProjectSettingsHAR$CommitIDErr = function (a) {
	return {$: 0, a: a};
};
var $author$project$Views$Modal$ConfirmButton = $elm$core$Basics$identity;
var $author$project$Pages$ProjectSettingsHAR$DeleteTag = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Pages$ProjectSettingsHAR$Editing = 1;
var $author$project$Pages$ProjectSettingsHAR$FailedToStart = {$: 1};
var $author$project$Pages$ProjectSettingsHAR$General = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$ProjectSettingsHAR$LabelErr = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$ProjectSettingsHAR$ModalCancelled = {$: 10};
var $author$project$Pages$ProjectSettingsHAR$SaveField = F3(
	function (a, b, c) {
		return {$: 11, a: a, b: b, c: c};
	});
var $author$project$Pages$ProjectSettingsHAR$Started = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$ProjectSettingsHAR$TagDeleted = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Pages$ProjectSettingsHAR$getBuildResult = function (b) {
	if (b.$ === 2) {
		var buildResult = b.a;
		return $elm$core$Maybe$Just(buildResult);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$ProjectSettingsHAR$isNotStartedBuild = function (b) {
	if (!b.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pages$ProjectSettingsHAR$canCheckTagBuildStatus = function (t) {
	var buildStatus = $author$project$Pages$ProjectSettingsHAR$getTagFormFromState(t).h7;
	var isStillBuilding = _Utils_eq(
		$author$project$Pages$ProjectSettingsHAR$getBuildResult(buildStatus),
		$elm$core$Maybe$Just(2));
	return isStillBuilding || $author$project$Pages$ProjectSettingsHAR$isNotStartedBuild(buildStatus);
};
var $author$project$Pages$ProjectSettingsHAR$clearTagFormValidations = function (tf) {
	return _Utils_update(
		tf,
		{dv: _List_Nil});
};
var $author$project$Request$Project$deleteTag = F4(
	function (creds, orgName, projectName, tag) {
		return $author$project$Http$Extra$delete(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$emptyJsonBody,
				qN: $author$project$Model$Message$decode,
				CN: _List_Nil,
				GT: A2(
					$elm$url$Url$Builder$relative,
					_List_fromArray(
						[
							A2($author$project$Request$Project$urlPathOrgProject, orgName, projectName),
							'tags',
							tag.b2
						]),
					_List_Nil)
			});
	});
var $elm$html$Html$div = _VirtualDom_node('div');
var $author$project$Pages$ProjectSettingsHAR$mapFMState = F2(
	function (fn, fm) {
		var state = fm.bB;
		return _Utils_update(
			fm,
			{
				bB: fn(state)
			});
	});
var $author$project$Pages$ProjectSettingsHAR$mapFieldMeta = F2(
	function (fn, field) {
		if (!field.$) {
			var f = field.a;
			return $author$project$Pages$ProjectSettingsHAR$CommitIDField(
				fn(f));
		} else {
			var f = field.a;
			return $author$project$Pages$ProjectSettingsHAR$LabelField(
				fn(f));
		}
	});
var $author$project$Pages$ProjectSettingsHAR$stateToEdit = $elm$core$Basics$always(1);
var $author$project$Pages$ProjectSettingsHAR$editField = $author$project$Pages$ProjectSettingsHAR$mapFieldMeta(
	$author$project$Pages$ProjectSettingsHAR$mapFMState($author$project$Pages$ProjectSettingsHAR$stateToEdit));
var $author$project$Pages$ProjectSettingsHAR$fixField = $author$project$Pages$ProjectSettingsHAR$mapFieldMeta(
	function (f) {
		return _Utils_update(
			f,
			{jm: f.kH});
	});
var $author$project$Pages$ProjectSettingsHAR$flipTagToSaved = function (ts) {
	if (ts.$ === 1) {
		var tf = ts.a;
		return $author$project$Pages$ProjectSettingsHAR$Saved(tf);
	} else {
		var tf = ts.a;
		return $author$project$Pages$ProjectSettingsHAR$Saved(tf);
	}
};
var $author$project$Pages$ProjectSettingsHAR$getFieldFormattedValue = A2(
	$elm$core$Basics$composeR,
	$author$project$Pages$ProjectSettingsHAR$fieldMeta,
	function ($) {
		return $.lY;
	});
var $author$project$Pages$ProjectSettingsHAR$getFieldOriginalValue = A2(
	$elm$core$Basics$composeR,
	$author$project$Pages$ProjectSettingsHAR$fieldMeta,
	function ($) {
		return $.jm;
	});
var $author$project$Pages$ProjectSettingsHAR$getLabelFromTagState = A2(
	$elm$core$Basics$composeR,
	$author$project$Pages$ProjectSettingsHAR$getTagFormFromState,
	function ($) {
		return $.b2;
	});
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $author$project$Pages$ProjectSettingsHAR$isCommitIDErr = function (e) {
	if (!e.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pages$ProjectSettingsHAR$isLabelErr = function (e) {
	if (e.$ === 2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pages$ProjectSettingsHAR$mapTagState = F2(
	function (fn, ts) {
		if (ts.$ === 1) {
			var tf = ts.a;
			return $author$project$Pages$ProjectSettingsHAR$Saved(
				fn(tf));
		} else {
			var tf = ts.a;
			return $author$project$Pages$ProjectSettingsHAR$New(
				fn(tf));
		}
	});
var $author$project$Pages$ProjectSettingsHAR$replaceTagState = F2(
	function (ts, tf) {
		return A2(
			$author$project$Pages$ProjectSettingsHAR$mapTagState,
			$elm$core$Basics$always(tf),
			ts);
	});
var $author$project$Pages$ProjectSettingsHAR$resetField = $author$project$Pages$ProjectSettingsHAR$mapFieldMeta(
	function (f) {
		return _Utils_update(
			f,
			{kH: f.jm});
	});
var $author$project$Pages$ProjectSettingsHAR$NoOp = {$: 0};
var $author$project$Pages$ProjectSettingsHAR$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Pages$ProjectSettingsHAR$NoOp, 'Pages/ProjectSettingsHAR.elm');
var $author$project$Model$Tag$TagEditable = F2(
	function (label, commitID) {
		return {BR: commitID, b2: label};
	});
var $author$project$Pages$ProjectSettingsHAR$tagFormToTagEditable = A2(
	$elm$core$Basics$composeR,
	$author$project$Misc$duple,
	A2(
		$elm$core$Basics$composeR,
		A2(
			$elm$core$Tuple$mapBoth,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.b2;
				},
				$author$project$Pages$ProjectSettingsHAR$getFieldFormattedValue),
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.BR;
				},
				A2($elm$core$Basics$composeR, $author$project$Pages$ProjectSettingsHAR$getFieldValue, $danyx23$elm_uuid$Uuid$fromString))),
		$elm_community$basics_extra$Basics$Extra$uncurry($author$project$Model$Tag$TagEditable)));
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$Pages$ProjectSettingsHAR$mapFMFormattedValue = F2(
	function (fn, fm) {
		var formattedValue = fm.lY;
		return _Utils_update(
			fm,
			{
				lY: fn(formattedValue)
			});
	});
var $author$project$Pages$ProjectSettingsHAR$mapFMValue = F2(
	function (fn, fm) {
		var value = fm.kH;
		return _Utils_update(
			fm,
			{
				kH: fn(value)
			});
	});
var $author$project$Pages$ProjectSettingsHAR$updateFieldValue = F2(
	function (formattedValue, v) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Pages$ProjectSettingsHAR$mapFieldMeta(
				$author$project$Pages$ProjectSettingsHAR$mapFMValue(
					$elm$core$Basics$always(v))),
			$author$project$Pages$ProjectSettingsHAR$mapFieldMeta(
				$author$project$Pages$ProjectSettingsHAR$mapFMFormattedValue(
					$elm$core$Basics$always(formattedValue))));
	});
var $author$project$Pages$ProjectSettingsHAR$updateTagFormField = F2(
	function (f, t) {
		if (!f.$) {
			return _Utils_update(
				t,
				{BR: f});
		} else {
			return _Utils_update(
				t,
				{b2: f});
		}
	});
var $author$project$Pages$ProjectSettingsHAR$validateUniqueLabel = F3(
	function (tags, currentTagEx, newLabel) {
		var matchesLabelButIsNotSelf = function (foundTagEx) {
			return A3(
				$author$project$Misc$isBoth,
				$elm$core$Basics$neq(currentTagEx),
				A2(
					$elm$core$Basics$composeR,
					A2($elm$core$Basics$composeR, $author$project$Pages$ProjectSettingsHAR$getLabelFromTagState, $author$project$Pages$ProjectSettingsHAR$getFieldOriginalValue),
					$elm$core$Basics$eq(newLabel)),
				foundTagEx);
		};
		return A2($elm$core$List$any, matchesLabelButIsNotSelf, tags) ? $elm$core$Maybe$Just('Label must be unique') : $elm$core$Maybe$Nothing;
	});
var $author$project$Pages$ProjectSettingsHAR$ApiError = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$ProjectSettingsHAR$BuildPlannerError = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$ProjectSettingsHAR$TagSaved = F3(
	function (a, b, c) {
		return {$: 14, a: a, b: b, c: c};
	});
var $author$project$Pages$ProjectSettingsHAR$Validation = function (a) {
	return {$: 2, a: a};
};
var $author$project$Request$Project$editTag = F5(
	function (creds, orgName, projectName, originalLabel, tag) {
		return $author$project$Http$Extra$put(
			{
				iO: $author$project$Http$Extra$Creds(creds),
				sY: $author$project$Http$Extra$jsonBody(
					$author$project$Model$Tag$encodeTagEditable(tag)),
				qN: $author$project$Model$Tag$decode,
				CN: _List_Nil,
				GT: A2(
					$elm$url$Url$Builder$relative,
					_List_fromArray(
						[
							A2($author$project$Request$Project$urlPathOrgProject, orgName, projectName),
							'tags',
							originalLabel
						]),
					_List_Nil)
			});
	});
var $author$project$Model$Editor$getItemDict = F4(
	function (getter, toItemValue, key, editor) {
		var original = A2($author$project$Model$Editor$getFieldOriginal, getter, editor);
		var originalValue = A2(
			$elm$core$Maybe$map,
			toItemValue(key),
			A2($elm$core$Dict$get, key, original));
		var current = A2($author$project$Model$Editor$getField, getter, editor);
		var currentValue = A2(
			$elm$core$Maybe$map,
			toItemValue(key),
			A2($elm$core$Dict$get, key, current));
		return A2(
			$elm$core$Maybe$map,
			function (value) {
				return {
					L: A2($author$project$Model$Editor$maybesToStatus, originalValue, currentValue),
					kH: value
				};
			},
			A2($elm_community$maybe_extra$Maybe$Extra$orElse, originalValue, currentValue));
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$getLanguageItem = A2(
	$elm$core$Basics$composeL,
	$author$project$Model$BuildPlanner$SolveLegacyEditor$getBuildExprSolveEditor,
	A2($author$project$Model$Editor$getItemDict, $author$project$Model$BuildPlanner$SolveLegacyEditor$languagesGetter, $author$project$Model$BuildPlanner$BuildExpr$SolveEditor$LanguageNameAndVersion));
var $author$project$Validation$isClearlyBelowPython3Point8 = function (versionString) {
	var _v0 = $elm$regex$Regex$fromString('((^[012]\\.)|(^3\\.[0-7]\\.)).*');
	if (!_v0.$) {
		var regex = _v0.a;
		return A2($elm$regex$Regex$contains, regex, versionString);
	} else {
		return false;
	}
};
var $author$project$Validation$validatePythonVersionIs3Point8OrBetter = $author$project$Validation$runValidations(
	_List_fromArray(
		[
			_Utils_Tuple2($author$project$Validation$isClearlyBelowPython3Point8, 'Version is not Python >= 3.8')
		]));
var $author$project$Pages$ProjectSettingsHAR$validateBuildExpr = function (buildExpr) {
	var notPython3Point8Error = 'This project commit must be using PIP and Python 3.8 or later to enable this feature.';
	var editor = $author$project$Model$BuildPlanner$SolveLegacyEditor$fromBuildExprWithFallback(buildExpr);
	var _v0 = A2(
		$author$project$Model$BuildPlanner$SolveLegacyEditor$getLanguageItem,
		$author$project$Model$Language$toString(1),
		editor);
	if (!_v0.$) {
		var languageItem = _v0.a;
		var _v1 = languageItem.kH.aI;
		switch (_v1.$) {
			case 0:
				return $elm$core$Maybe$Nothing;
			case 1:
				var version = _v1.a;
				return A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(notPython3Point8Error),
					$author$project$Validation$validatePythonVersionIs3Point8OrBetter(version));
			case 2:
				return $elm$core$Maybe$Nothing;
			default:
				return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Just(notPython3Point8Error);
	}
};
var $author$project$Pages$ProjectSettingsHAR$validiateThenSaveTagCmd = F5(
	function (session, orgName, projectName, tagState, field) {
		var maybeCommitID = $danyx23$elm_uuid$Uuid$fromString(
			$author$project$Pages$ProjectSettingsHAR$getFieldFormattedValue(
				$author$project$Pages$ProjectSettingsHAR$getTagFormFromState(tagState).BR));
		var creds = $author$project$Model$Session$getCreds(session);
		var onBuildExpr = function (buildExpr) {
			var _v0 = $author$project$Pages$ProjectSettingsHAR$validateBuildExpr(buildExpr);
			if (_v0.$ === 1) {
				if (tagState.$ === 1) {
					var t = tagState.a;
					return A2(
						$elm$core$Task$mapError,
						$author$project$Pages$ProjectSettingsHAR$ApiError,
						A5(
							$author$project$Request$Project$editTag,
							creds,
							orgName,
							projectName,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.b2;
								},
								$author$project$Pages$ProjectSettingsHAR$getFieldOriginalValue)(t),
							$author$project$Pages$ProjectSettingsHAR$tagFormToTagEditable(t)));
				} else {
					var t = tagState.a;
					return A2(
						$elm$core$Task$mapError,
						$author$project$Pages$ProjectSettingsHAR$ApiError,
						A4(
							$author$project$Request$Project$addTag,
							creds,
							orgName,
							projectName,
							$author$project$Pages$ProjectSettingsHAR$tagFormToTagEditable(t)));
				}
			} else {
				var err = _v0.a;
				return $elm$core$Task$fail(
					$author$project$Pages$ProjectSettingsHAR$Validation(err));
			}
		};
		var getCmd = function (commitID) {
			return A2(
				$elm$core$Task$attempt,
				A2($author$project$Pages$ProjectSettingsHAR$TagSaved, tagState, field),
				A2(
					$elm$core$Task$andThen,
					onBuildExpr,
					A2(
						$elm$core$Task$mapError,
						$author$project$Pages$ProjectSettingsHAR$BuildPlannerError,
						A2(
							$author$project$Request$BuildPlanner$getBuildExpr,
							session,
							{BR: commitID, ix: orgName, vT: projectName}))));
		};
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Platform$Cmd$none,
			A2($elm$core$Maybe$map, getCmd, maybeCommitID));
	});
var $author$project$Pages$ProjectSettingsHAR$stateToViewing = function (_v0) {
	return 0;
};
var $author$project$Pages$ProjectSettingsHAR$viewField = $author$project$Pages$ProjectSettingsHAR$mapFieldMeta(
	$author$project$Pages$ProjectSettingsHAR$mapFMState($author$project$Pages$ProjectSettingsHAR$stateToViewing));
var $author$project$Pages$ProjectSettingsHAR$update = F3(
	function (session, msg, model) {
		var updateTagIfMatch = F4(
			function (f, activeTag, fn, foundTag) {
				return _Utils_eq(activeTag, foundTag) ? A2(
					$author$project$Pages$ProjectSettingsHAR$mapTagState,
					fn(f),
					foundTag) : foundTag;
			});
		var projectName = $author$project$Model$Project$getName(model.c5);
		var orgName = $author$project$Model$Organization$getUrlName(model.c3);
		var creds = $author$project$Model$Session$getCreds(session);
		switch (msg.$) {
			case 0:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model));
			case 6:
				var newModel = A2(
					$elm$core$Maybe$withDefault,
					model,
					A2(
						$elm$core$Maybe$map,
						function (commitID) {
							return _Utils_update(
								model,
								{
									Gt: A2(
										$elm$core$List$sortWith,
										$author$project$Pages$ProjectSettingsHAR$sortTags,
										A2(
											$elm$core$List$append,
											model.Gt,
											$elm$core$List$singleton(
												A4($author$project$Pages$ProjectSettingsHAR$createTagState, true, 1, commitID, ''))))
								});
						},
						model.uA));
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, newModel));
			case 9:
				var activeTagEx = msg.a;
				var fieldChanged = msg.b;
				var newValue = msg.c;
				var updatedTagForm = F3(
					function (field, v, tagForm) {
						if (!field.$) {
							return _Utils_update(
								tagForm,
								{
									BR: A3($author$project$Pages$ProjectSettingsHAR$updateFieldValue, v, v, tagForm.BR),
									dv: A2(
										$elm$core$List$filter,
										A2($elm$core$Basics$composeR, $author$project$Pages$ProjectSettingsHAR$isCommitIDErr, $elm$core$Basics$not),
										tagForm.dv)
								});
						} else {
							var formattedValue = $author$project$Validation$formatVcsRefsName(v);
							return _Utils_update(
								tagForm,
								{
									b2: A3($author$project$Pages$ProjectSettingsHAR$updateFieldValue, formattedValue, v, tagForm.b2),
									dv: A2(
										$elm$core$List$filter,
										A2($elm$core$Basics$composeR, $author$project$Pages$ProjectSettingsHAR$isLabelErr, $elm$core$Basics$not),
										tagForm.dv)
								});
						}
					});
				var labelValidators = function (label) {
					return _List_fromArray(
						[
							A3($author$project$Pages$ProjectSettingsHAR$validateUniqueLabel, model.Gt, activeTagEx, label),
							$author$project$Validation$validateVcsRefName(label)
						]);
				};
				var validatedFieldTagForm = F2(
					function (field, tagForm) {
						if (!field.$) {
							return $elm_community$maybe_extra$Maybe$Extra$isNothing(
								$danyx23$elm_uuid$Uuid$fromString(
									$author$project$Pages$ProjectSettingsHAR$getFieldFormattedValue(tagForm.BR))) ? _Utils_update(
								tagForm,
								{
									dv: _List_fromArray(
										[
											$author$project$Pages$ProjectSettingsHAR$CommitIDErr('Invalid UUID')
										])
								}) : tagForm;
						} else {
							return function (validations) {
								return _Utils_update(
									tagForm,
									{dv: validations});
							}(
								A2(
									$elm$core$List$map,
									$author$project$Pages$ProjectSettingsHAR$LabelErr,
									A2(
										$elm$core$List$filterMap,
										$elm$core$Basics$identity,
										labelValidators(
											$author$project$Pages$ProjectSettingsHAR$getFieldFormattedValue(tagForm.b2)))));
						}
					});
				var updateIfMatch = F4(
					function (matchingTag, field, value, foundTag) {
						return _Utils_eq(matchingTag, foundTag) ? A2(
							$author$project$Pages$ProjectSettingsHAR$replaceTagState,
							foundTag,
							A2(
								validatedFieldTagForm,
								field,
								A3(
									updatedTagForm,
									field,
									value,
									$author$project$Pages$ProjectSettingsHAR$getTagFormFromState(foundTag)))) : foundTag;
					});
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								Gt: A2(
									$elm$core$List$map,
									A3(updateIfMatch, activeTagEx, fieldChanged, newValue),
									model.Gt)
							})));
			case 2:
				var tagState = msg.a;
				var updateTagForm = function (tf) {
					return _Utils_update(
						tf,
						{
							BR: $author$project$Pages$ProjectSettingsHAR$viewField(tf.BR),
							b2: $author$project$Pages$ProjectSettingsHAR$viewField(tf.b2)
						});
				};
				var updateIfMatch = function (ts) {
					return _Utils_eq(tagState, ts) ? A2($author$project$Pages$ProjectSettingsHAR$mapTagState, updateTagForm, ts) : ts;
				};
				var tags = function () {
					if (tagState.$ === 1) {
						return A2($elm$core$List$map, updateIfMatch, model.Gt);
					} else {
						return A2(
							$elm$core$List$filter,
							A2($elm$core$Basics$composeR, $author$project$Pages$ProjectSettingsHAR$isNewTag, $elm$core$Basics$not),
							model.Gt);
					}
				}();
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{Gt: tags})));
			case 11:
				var tagState = msg.a;
				var field = msg.b;
				var force = msg.c;
				var modalConfig = F2(
					function (t, f) {
						return {
							Bq: $elm$core$Maybe$Just(
								{
									BE: _List_fromArray(
										['']),
									Dc: false,
									En: $author$project$Pages$ProjectSettingsHAR$ModalCancelled,
									Gv: 'Cancel'
								}),
							BD: 'har-modal',
							BU: $elm$core$Maybe$Just(
								{
									BE: _List_fromArray(
										['']),
									Dc: false,
									En: A3($author$project$Pages$ProjectSettingsHAR$SaveField, t, f, true),
									Gv: 'Update'
								}),
							dH: A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h2,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Warning')
											])),
										$elm$html$Html$text('Updating the URL will cause any existing connections to cease functioning.')
									])),
							l6: $elm$core$Maybe$Nothing
						};
					});
				var _v4 = function () {
					if (field.$ === 1) {
						return force ? _Utils_Tuple2(
							_Utils_update(
								model,
								{iw: $elm$core$Maybe$Nothing}),
							A5($author$project$Pages$ProjectSettingsHAR$validiateThenSaveTagCmd, session, orgName, projectName, tagState, field)) : _Utils_Tuple2(
							_Utils_update(
								model,
								{
									iw: $elm$core$Maybe$Just(
										A2(modalConfig, tagState, field))
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{iw: $elm$core$Maybe$Nothing}),
							A5($author$project$Pages$ProjectSettingsHAR$validiateThenSaveTagCmd, session, orgName, projectName, tagState, field));
					}
				}();
				var newModel = _v4.a;
				var cmd = _v4.b;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, cmd, newModel));
			case 12:
				var tagState = msg.a;
				var field = msg.b;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						A5($author$project$Pages$ProjectSettingsHAR$validiateThenSaveTagCmd, session, orgName, projectName, tagState, field),
						model));
			case 14:
				if (!msg.c.$) {
					var tagState = msg.a;
					var field = msg.b;
					var respTag = msg.c.a;
					var updateFields = F2(
						function (tagForm, _v8) {
							var label = _v8.a;
							var commitID = _v8.b;
							return A2(
								$author$project$Pages$ProjectSettingsHAR$updateTagFormField,
								commitID,
								A2($author$project$Pages$ProjectSettingsHAR$updateTagFormField, label, tagForm));
						});
					var updateTagForm = function (tagForm) {
						return function (tf) {
							return _Utils_update(
								tf,
								{
									h7: function () {
										if (!field.$) {
											return $author$project$Pages$ProjectSettingsHAR$NotStarted;
										} else {
											return tagForm.h7;
										}
									}()
								});
						}(
							$author$project$Pages$ProjectSettingsHAR$clearTagFormValidations(
								A2(
									updateFields,
									tagForm,
									A3(
										$elm$core$Tuple$mapBoth,
										$author$project$Pages$ProjectSettingsHAR$viewField,
										$author$project$Pages$ProjectSettingsHAR$viewField,
										A3(
											$elm$core$Tuple$mapBoth,
											$author$project$Pages$ProjectSettingsHAR$fixField,
											$author$project$Pages$ProjectSettingsHAR$fixField,
											A3(
												$elm$core$Tuple$mapBoth,
												function ($) {
													return $.b2;
												},
												function ($) {
													return $.BR;
												},
												$author$project$Misc$duple(tagForm)))))));
					};
					var updateIfMatch = F2(
						function (activeTag, existingTag) {
							return _Utils_eq(activeTag, existingTag) ? A2(
								$author$project$Pages$ProjectSettingsHAR$mapTagState,
								updateTagForm,
								$author$project$Pages$ProjectSettingsHAR$flipTagToSaved(activeTag)) : existingTag;
						});
					var cmd = function () {
						if (!field.$) {
							var key = {
								BR: $author$project$Model$Tag$commitID(respTag),
								ix: $author$project$Model$Organization$getUrlName(model.c3),
								vT: $author$project$Model$Project$getName(model.c5)
							};
							return A2(
								$elm$core$Task$attempt,
								$author$project$Pages$ProjectSettingsHAR$BuildStarted(tagState),
								A2($author$project$Request$BuildPlanner$getBuildResult, session, key));
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							cmd,
							_Utils_update(
								model,
								{
									Gt: A2(
										$elm$core$List$map,
										updateIfMatch(tagState),
										model.Gt)
								})));
				} else {
					var originalTagExistance = msg.a;
					var err = msg.c.a;
					var maybeErrMsg = function () {
						switch (err.$) {
							case 2:
								var message = err.a;
								return $elm$core$Maybe$Just(message);
							case 1:
								var error = err.a;
								return $elm$core$Maybe$Just(
									$author$project$Model$BuildPlanner$BuildPlannerError$message(error));
							default:
								var e = err.a;
								var userCannotFixErrorMsg = $elm$core$Maybe$Just('Request to save tag failed. Reload the page and try again. If the issue persists, please contact support.');
								var _v11 = e.mp;
								switch (_v11.$) {
									case 3:
										return $elm$core$Maybe$Just(
											$author$project$Model$Message$reason(e));
									case 1:
										return $elm$core$Maybe$Just('Request to save tag timed out. Please try again.');
									case 0:
										return userCannotFixErrorMsg;
									case 4:
										return userCannotFixErrorMsg;
									default:
										return userCannotFixErrorMsg;
								}
						}
					}();
					var updateTag = function (tagToBeEdited) {
						return _Utils_update(
							tagToBeEdited,
							{
								dv: A2(
									$elm$core$List$append,
									tagToBeEdited.dv,
									A2(
										$elm$core$List$map,
										$author$project$Pages$ProjectSettingsHAR$General,
										A2(
											$elm$core$List$filterMap,
											$elm$core$Basics$identity,
											_List_fromArray(
												[maybeErrMsg]))))
							});
					};
					var updateIfMatch = F2(
						function (activeTag, existingTag) {
							return _Utils_eq(activeTag, existingTag) ? A2($author$project$Pages$ProjectSettingsHAR$mapTagState, updateTag, activeTag) : existingTag;
						});
					var cmd = function () {
						switch (err.$) {
							case 2:
								return $elm$core$Platform$Cmd$none;
							case 0:
								var e = err.a;
								return A3($author$project$Pages$ProjectSettingsHAR$rollbar.FZ, 'TagSaved originalTagExistance _ (Err (ApiError e))', e, session);
							default:
								var error = err.a;
								return A2(
									$author$project$Pages$ProjectSettingsHAR$rollbar.sk,
									$author$project$Model$BuildPlanner$BuildPlannerError$message(error),
									session);
						}
					}();
					return A2(
						$author$project$Misc$with,
						$author$project$External$NoOp,
						A2(
							$author$project$Misc$with,
							cmd,
							_Utils_update(
								model,
								{
									Gt: A2(
										$elm$core$List$map,
										updateIfMatch(originalTagExistance),
										model.Gt)
								})));
				}
			case 1:
				var tagState = msg.a;
				var res = msg.b;
				var updateTagForm = function (tagForm) {
					if (!res.$) {
						var buildResult = res.a;
						return _Utils_update(
							tagForm,
							{
								h7: $author$project$Pages$ProjectSettingsHAR$Started(buildResult)
							});
					} else {
						return _Utils_update(
							tagForm,
							{h7: $author$project$Pages$ProjectSettingsHAR$FailedToStart});
					}
				};
				var updateIfMatch = F2(
					function (activeTag, existingTag) {
						return _Utils_eq(activeTag, existingTag) ? A2($author$project$Pages$ProjectSettingsHAR$mapTagState, updateTagForm, activeTag) : existingTag;
					});
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								Gt: A2(
									$elm$core$List$map,
									updateIfMatch(tagState),
									model.Gt)
							})));
			case 7:
				var tagState = msg.a;
				var confirmed = msg.b;
				var modalConfig = function (t) {
					return {
						Bq: $elm$core$Maybe$Just(
							{
								BE: _List_fromArray(
									['']),
								Dc: false,
								En: $author$project$Pages$ProjectSettingsHAR$ModalCancelled,
								Gv: 'Cancel'
							}),
						BD: 'har-modal',
						BU: $elm$core$Maybe$Just(
							{
								BE: _List_fromArray(
									['red-button']),
								Dc: false,
								En: A2($author$project$Pages$ProjectSettingsHAR$DeleteTag, t, true),
								Gv: 'Delete'
							}),
						dH: A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h2,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Warning')
										])),
									$elm$html$Html$text('This action will disable and remove this service. Any existing connections will no longer function. You must create a new service and update the connection details for functionality to resume.')
								])),
						l6: $elm$core$Maybe$Nothing
					};
				};
				var newModelCmd = function (f) {
					return f ? _Utils_Tuple2(
						_Utils_update(
							model,
							{iw: $elm$core$Maybe$Nothing}),
						A2(
							$elm$core$Task$attempt,
							$author$project$Pages$ProjectSettingsHAR$TagDeleted(tagState),
							A4(
								$author$project$Request$Project$deleteTag,
								creds,
								orgName,
								projectName,
								A3($elm$core$Basics$composeR, $author$project$Pages$ProjectSettingsHAR$getTagFormFromState, $author$project$Pages$ProjectSettingsHAR$tagFormToTagEditable, tagState)))) : _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iw: $elm$core$Maybe$Just(
									modalConfig(tagState))
							}),
						$elm$core$Platform$Cmd$none);
				};
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					newModelCmd(confirmed));
			case 13:
				if (!msg.b.$) {
					var deletedTagExistance = msg.a;
					var deletedLabel = A2($elm$core$Basics$composeR, $author$project$Pages$ProjectSettingsHAR$getLabelFromTagState, $author$project$Pages$ProjectSettingsHAR$getFieldOriginalValue)(deletedTagExistance);
					var filteredTags = A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							A2($elm$core$Basics$composeR, $author$project$Pages$ProjectSettingsHAR$getLabelFromTagState, $author$project$Pages$ProjectSettingsHAR$getFieldOriginalValue),
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Basics$eq(deletedLabel),
								$elm$core$Basics$not)),
						model.Gt);
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$textSuccess('ActiveState Artifact Repository tag deleted successfully')),
						A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{Gt: filteredTags})));
				} else {
					var err = msg.b.a;
					return A2(
						$author$project$Misc$with,
						$author$project$External$AddNotification(
							$author$project$Model$Notification$textWarning('Failed to delete ActiveState Artifact Repository tag')),
						A2(
							$author$project$Misc$with,
							A3($author$project$Pages$ProjectSettingsHAR$rollbar.FZ, 'TagDeleted _ (Err err)', err, session),
							model));
				}
			case 8:
				var activeTagExistance = msg.a;
				var field = msg.b;
				var updateTag = F2(
					function (f, tagForm) {
						return A2(
							$author$project$Pages$ProjectSettingsHAR$updateTagFormField,
							$author$project$Pages$ProjectSettingsHAR$editField(f),
							tagForm);
					});
				var updateMap = A3(updateTagIfMatch, field, activeTagExistance, updateTag);
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								Gt: A2($elm$core$List$map, updateMap, model.Gt)
							})));
			case 3:
				var activeTagExistance = msg.a;
				var field = msg.b;
				var updateTag = F2(
					function (f, tagToChange) {
						return A2(
							$author$project$Pages$ProjectSettingsHAR$updateTagFormField,
							A2($elm$core$Basics$composeR, $author$project$Pages$ProjectSettingsHAR$viewField, $author$project$Pages$ProjectSettingsHAR$resetField)(f),
							_Utils_update(
								tagToChange,
								{dv: _List_Nil}));
					});
				var updateMap = A3(updateTagIfMatch, field, activeTagExistance, updateTag);
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								Gt: A2($elm$core$List$map, updateMap, model.Gt)
							})));
			case 4:
				var input = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$author$project$Ports$copyToClipboard(input),
						_Utils_update(
							model,
							{oi: $author$project$Model$CopyStatus$empty})));
			case 5:
				var copyStatus = msg.a;
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{oi: copyStatus})));
			case 10:
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{iw: $elm$core$Maybe$Nothing})));
			default:
				var cmd = $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						A2($author$project$Pages$ProjectSettingsHAR$buildStatusCmdFromTagEx, session, model),
						A2($elm$core$List$filter, $author$project$Pages$ProjectSettingsHAR$canCheckTagBuildStatus, model.Gt)));
				return A2(
					$author$project$Misc$with,
					$author$project$External$NoOp,
					A2($author$project$Misc$with, cmd, model));
		}
	});
var $author$project$Pages$ResetPassword$OnResetPassword = function (a) {
	return {$: 4, a: a};
};
var $author$project$Model$Route$loginWithReset = $author$project$Model$Route$Login(
	_Utils_update(
		$author$project$Model$Route$emptyLoginParams,
		{pC: true}));
var $author$project$Request$User$postResetPassword = F2(
	function (password, code) {
		return $author$project$Http$Extra$post(
			{
				iO: $author$project$Http$Extra$None,
				sY: $author$project$Http$Extra$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'code',
								$elm$json$Json$Encode$string(code)),
								_Utils_Tuple2(
								'password',
								$elm$json$Json$Encode$string(password))
							]))),
				qN: $author$project$Model$Message$decode,
				CN: _List_Nil,
				GT: $author$project$Http$Extra$urlBase + '/reset-password/'
			});
	});
var $author$project$Pages$ResetPassword$NoOp = {$: 0};
var $author$project$Pages$ResetPassword$rollbar = A2($author$project$Model$RollbarClient$create, $author$project$Pages$ResetPassword$NoOp, 'Pages/ResetPassword.elm');
var $author$project$Pages$ResetPassword$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 0:
				return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
			case 2:
				var password = msg.a;
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					_Utils_update(
						model,
						{ey: password, mZ: $elm$core$Maybe$Nothing, pk: $elm$core$Maybe$Nothing}));
			case 3:
				var passwordConfirmation = msg.a;
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					_Utils_update(
						model,
						{km: passwordConfirmation, mZ: $elm$core$Maybe$Nothing}));
			case 1:
				var passwordError = $author$project$Validation$validatePassword(model.ey);
				var passwordConfirmationError = A2($author$project$Validation$validatePasswordConfirmation, model.ey, model.km);
				var validations = _List_fromArray(
					[passwordError, passwordConfirmationError]);
				return A2(
					$elm$core$List$all,
					function (x) {
						return _Utils_eq(x, $elm$core$Maybe$Nothing);
					},
					validations) ? A2(
					$author$project$Misc$with,
					A2(
						$elm$core$Task$attempt,
						$author$project$Pages$ResetPassword$OnResetPassword,
						A2($author$project$Request$User$postResetPassword, model.ey, model.xD)),
					model) : A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					_Utils_update(
						model,
						{mZ: passwordConfirmationError, pk: passwordError}));
			default:
				if (!msg.a.$) {
					return A2(
						$author$project$Misc$with,
						A2($author$project$Routing$replaceUrl, model.Y, $author$project$Model$Route$loginWithReset),
						model);
				} else {
					var err = msg.a.a;
					return A2(
						$author$project$Misc$with,
						A3($author$project$Pages$ResetPassword$rollbar.FZ, 'OnResetPassword (Err err)', err, session),
						A2($author$project$Views$NotificationsInline$setError, err, model));
				}
		}
	});
var $author$project$Pages$StateToolCheatSheet$generateClipboardEvent = function (label) {
	var eventArgs = A2(
		$author$project$Model$Analytics$withLabel,
		label,
		A2(
			$author$project$Model$Analytics$withAction,
			'Command Copied',
			A2(
				$author$project$Model$Analytics$withCategory,
				'State Tool Cheat Sheet',
				$author$project$Model$Analytics$newEvent('Command Copied'))));
	return $author$project$Ports$sendAnalyticsEvent(eventArgs);
};
var $author$project$Pages$StateToolCheatSheet$update = F2(
	function (action, model) {
		if (!action.$) {
			var input = action.a;
			return A2(
				$author$project$Misc$with,
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							$author$project$Pages$StateToolCheatSheet$generateClipboardEvent(input.xN),
							$author$project$Ports$copyToClipboard(input)
						])),
				_Utils_update(
					model,
					{oi: $author$project$Model$CopyStatus$empty}));
		} else {
			var portCopyStatus = action.a;
			return A2(
				$author$project$Misc$with,
				$elm$core$Platform$Cmd$none,
				_Utils_update(
					model,
					{oi: portCopyStatus}));
		}
	});
var $author$project$Pages$Support$update = F2(
	function (action, model) {
		return A2(
			$author$project$Misc$with,
			$author$project$Ports$openHubSpotChat(0),
			model);
	});
var $author$project$Model$BuildPlannerCache$addBuildPlan = F3(
	function (key, buildPlan, _v0) {
		var fields = _v0;
		return _Utils_update(
			fields,
			{
				jI: A3(
					$elm$core$Dict$insert,
					$author$project$Model$BuildPlannerCache$toComparableKey(key),
					buildPlan,
					fields.jI)
			});
	});
var $author$project$Model$BuildPlannerCache$addCommitAndBuildExpr = F4(
	function (key, commit, buildExpr, _v0) {
		var fields = _v0;
		return _Utils_update(
			fields,
			{
				od: A3(
					$elm$core$Dict$insert,
					$author$project$Model$BuildPlannerCache$toComparableKey(key),
					_Utils_Tuple2(commit, buildExpr),
					fields.od)
			});
	});
var $author$project$Model$BuildPlannerCache$removeBuildPlanAndComponents = F2(
	function (key, _v0) {
		var fields = _v0;
		return _Utils_update(
			fields,
			{
				jI: A2(
					$elm$core$Dict$remove,
					$author$project$Model$BuildPlannerCache$toComparableKey(key),
					fields.jI)
			});
	});
var $author$project$Model$Session$removeMembership = F2(
	function (orgUrlName, session) {
		var userFn = function (user) {
			var organizations = A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.AC;
					},
					$elm$core$Basics$neq(orgUrlName)),
				user.mX);
			return _Utils_update(
				user,
				{mX: organizations});
		};
		return A2(
			$author$project$Model$Session$setUser,
			A2(
				$elm$core$Maybe$map,
				userFn,
				$author$project$Model$Session$getUser(session)),
			session);
	});
var $author$project$Model$Session$renameOrg = F2(
	function (_v0, session) {
		var oldUrlName = _v0.EG;
		var newUrlName = _v0.Er;
		var updateIfUrlMatches = function (org) {
			return _Utils_eq(org.AC, oldUrlName) ? _Utils_update(
				org,
				{AC: newUrlName}) : org;
		};
		var userFn = function (user) {
			return _Utils_update(
				user,
				{
					mX: A2($elm$core$List$map, updateIfUrlMatches, user.mX)
				});
		};
		return A2(
			$author$project$Model$Session$setUser,
			A2(
				$elm$core$Maybe$map,
				userFn,
				$author$project$Model$Session$getUser(session)),
			session);
	});
var $author$project$Model$Session$renameUser = F2(
	function (newUsername, session) {
		var userFn = function (user) {
			return _Utils_update(
				user,
				{AE: newUsername});
		};
		return A2(
			$author$project$Model$Session$setUser,
			A2(
				$elm$core$Maybe$map,
				userFn,
				$author$project$Model$Session$getUser(session)),
			session);
	});
var $author$project$Model$Session$setBuildPlannerCache = F2(
	function (buildPlannerCache, _v0) {
		var session = _v0;
		return _Utils_update(
			session,
			{s$: buildPlannerCache});
	});
var $author$project$Main$updateFromExternalMsg = F2(
	function (msg, session) {
		switch (msg.$) {
			case 0:
				return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, session);
			case 1:
				var msgs = msg.a;
				var helper = F2(
					function (subMsg, _v1) {
						var sessionAcc = _v1.a;
						var cmdsAcc = _v1.b;
						return A2(
							$elm$core$Tuple$mapSecond,
							function (cmd) {
								return A2($elm$core$List$cons, cmd, cmdsAcc);
							},
							A2($author$project$Main$updateFromExternalMsg, subMsg, sessionAcc));
					});
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$batch,
					A3(
						$elm$core$List$foldl,
						helper,
						_Utils_Tuple2(session, _List_Nil),
						msgs));
			case 2:
				var jwt = msg.a;
				var _v2 = A2($author$project$Model$Session$setJWT, jwt, session);
				var newSession = _v2.a;
				var sessionCmd = _v2.b;
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Msg$SessionMsg, sessionCmd),
								$author$project$Main$invitationsCmd(newSession)
							])),
					newSession);
			case 3:
				var maybeRoute = msg.a;
				return A2(
					$author$project$Misc$with,
					A2(
						$elm$core$Task$attempt,
						$author$project$Msg$OnRenew(maybeRoute),
						$author$project$Request$User$renew),
					session);
			case 4:
				var user = msg.a;
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					A2($author$project$Model$Session$setUser, user, session));
			case 5:
				var membership = msg.a;
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					A2($author$project$Model$Session$addMembership, membership, session));
			case 6:
				var orgUrlName = msg.a;
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					A2($author$project$Model$Session$removeMembership, orgUrlName, session));
			case 7:
				var orgUrlName = msg.a;
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					A2($author$project$Model$Session$removeInvitesForOrg, orgUrlName, session));
			case 8:
				var notification = msg.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Msg$SessionMsg),
					A2($author$project$Model$Session$addNotification, notification, session));
			case 9:
				var username = msg.a;
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					A2($author$project$Model$Session$renameUser, username, session));
			case 10:
				var fields = msg.a;
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					A2($author$project$Model$Session$renameOrg, fields, session));
			case 11:
				var fields = msg.a;
				return A2($author$project$Model$Session$setLocalStorage, fields, session);
			case 12:
				var key = msg.a;
				var buildPlan = msg.b;
				var newBuildPlannerCache = A3(
					$author$project$Model$BuildPlannerCache$addBuildPlan,
					key,
					buildPlan,
					$author$project$Model$Session$getBuildPlannerCache(session));
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					A2($author$project$Model$Session$setBuildPlannerCache, newBuildPlannerCache, session));
			case 13:
				var key = msg.a;
				var newBuildPlannerCache = A2(
					$author$project$Model$BuildPlannerCache$removeBuildPlanAndComponents,
					key,
					$author$project$Model$Session$getBuildPlannerCache(session));
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					A2($author$project$Model$Session$setBuildPlannerCache, newBuildPlannerCache, session));
			case 14:
				var key = msg.a;
				var commit = msg.b;
				var buildExpr = msg.c;
				var newBuildPlannerCache = A4(
					$author$project$Model$BuildPlannerCache$addCommitAndBuildExpr,
					key,
					commit,
					buildExpr,
					$author$project$Model$Session$getBuildPlannerCache(session));
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					A2($author$project$Model$Session$setBuildPlannerCache, newBuildPlannerCache, session));
			case 15:
				var orgNameString = msg.a;
				var maybeRoute = msg.b;
				var _v3 = A2(
					$author$project$Model$Session$setLocalStorage,
					{Y: $author$project$Model$LocalStorage$lastOrganizationKey, kH: orgNameString},
					session);
				var newSession = _v3.a;
				var sessionCmd = _v3.b;
				var cmds = function () {
					if (!maybeRoute.$) {
						var route = maybeRoute.a;
						return $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									sessionCmd,
									A2(
									$elm$core$Task$perform,
									$author$project$Msg$SetRoute,
									$elm$core$Task$succeed(route))
								]));
					} else {
						return sessionCmd;
					}
				}();
				return A2($author$project$Misc$with, cmds, newSession);
			default:
				return A2(
					$author$project$Misc$with,
					$elm$core$Platform$Cmd$none,
					A2(
						$author$project$Model$Session$setOrgDropdownOpen,
						!$author$project$Model$Session$getOrgDropdownOpen(session),
						session));
		}
	});
var $author$project$Page$ProjectPreview = function (a) {
	return {$: 51, a: a};
};
var $author$project$Model$Permissions$orgCanAccessImpactReport = $author$project$Model$Organization$addOnEnabled('impact_report');
var $author$project$Model$Permissions$canViewImpactReport = F2(
	function (org, user) {
		return $author$project$Model$User$isSuperReader(user) || (A2($author$project$Model$Permissions$canViewOrgPrivateInfo, org.AC, user) && $author$project$Model$Permissions$orgCanAccessImpactReport(org));
	});
var $author$project$Model$Permissions$orgPolicyManagementEnabled = $author$project$Model$Organization$addOnEnabled('policy_management');
var $author$project$Model$Permissions$canViewOrgPolicy = function (org) {
	return A2(
		$author$project$Misc$isBoth,
		$author$project$Model$Permissions$canViewOrgPrivateInfo(org.AC),
		$elm$core$Basics$always(
			$author$project$Model$Permissions$orgPolicyManagementEnabled(org)));
};
var $author$project$Model$Permissions$orgCanSeeCVEDashboard = $author$project$Model$Organization$addOnEnabled('cve_dashboard');
var $author$project$Model$Permissions$canViewOrgSecurity = function (org) {
	return A2(
		$author$project$Misc$isBoth,
		$author$project$Model$Permissions$canViewOrgPrivateInfo(org.AC),
		$elm$core$Basics$always(
			$author$project$Model$Permissions$orgCanSeeCVEDashboard(org)));
};
var $author$project$Pages$OrgDependencies$OnPanoramaData = function (a) {
	return {$: 8, a: a};
};
var $author$project$Request$Panorama$PanoramaData = F3(
	function (images, deps, vulns) {
		return {qP: deps, l8: images, G8: vulns};
	});
var $author$project$Analytics$InputObject$encodeInt_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_eq',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aW, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)),
				_Utils_Tuple2(
				'_gt',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aY, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)),
				_Utils_Tuple2(
				'_gte',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aZ, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$int))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lt',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a0, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)),
				_Utils_Tuple2(
				'_lte',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a1, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)),
				_Utils_Tuple2(
				'_neq',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a4, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int)),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$int)))
			]));
};
var $author$project$Analytics$InputObject$encodeUuid_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_eq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aW,
					A2(
						$author$project$Analytics$Scalar$unwrapEncoder,
						function ($) {
							return $.aq;
						},
						$author$project$Analytics$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aY,
					A2(
						$author$project$Analytics$Scalar$unwrapEncoder,
						function ($) {
							return $.aq;
						},
						$author$project$Analytics$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aZ,
					A2(
						$author$project$Analytics$Scalar$unwrapEncoder,
						function ($) {
							return $.aq;
						},
						$author$project$Analytics$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Analytics$Scalar$unwrapEncoder,
							function ($) {
								return $.aq;
							},
							$author$project$Analytics$ScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a0,
					A2(
						$author$project$Analytics$Scalar$unwrapEncoder,
						function ($) {
							return $.aq;
						},
						$author$project$Analytics$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_lte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a1,
					A2(
						$author$project$Analytics$Scalar$unwrapEncoder,
						function ($) {
							return $.aq;
						},
						$author$project$Analytics$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_neq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a4,
					A2(
						$author$project$Analytics$Scalar$unwrapEncoder,
						function ($) {
							return $.aq;
						},
						$author$project$Analytics$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Analytics$Scalar$unwrapEncoder,
							function ($) {
								return $.aq;
							},
							$author$project$Analytics$ScalarCodecs$codecs))))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_ingredient_version_revision_bool_exp = function (_v0) {
	var input____ = _v0;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Analytics$InputObject$encodeDim_ingredient_version_revision_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Analytics$InputObject$encodeDim_ingredient_version_revision_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Analytics$InputObject$encodeDim_ingredient_version_revision_bool_exp))),
				_Utils_Tuple2(
				'id_ingredient_version_revision',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.av, $author$project$Analytics$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'ingredient_creation_date',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bS, $author$project$Analytics$InputObject$encodeTimestamp_comparison_exp)),
				_Utils_Tuple2(
				'ingredient_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bT, $author$project$Analytics$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'ingredient_version_creation_date',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bX, $author$project$Analytics$InputObject$encodeTimestamp_comparison_exp)),
				_Utils_Tuple2(
				'ingredient_version_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bY, $author$project$Analytics$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'ingredient_version_revision_creation_date',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b_, $author$project$Analytics$InputObject$encodeTimestamp_comparison_exp)),
				_Utils_Tuple2(
				'ingredient_version_revision_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b$, $author$project$Analytics$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'is_ingredient',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d9, $author$project$Analytics$InputObject$encodeBoolean_comparison_exp)),
				_Utils_Tuple2(
				'is_ingredient_version',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ea, $author$project$Analytics$InputObject$encodeBoolean_comparison_exp)),
				_Utils_Tuple2(
				'is_ingredient_version_revision',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.eb, $author$project$Analytics$InputObject$encodeBoolean_comparison_exp)),
				_Utils_Tuple2(
				'is_namespace_public',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ej, $author$project$Analytics$InputObject$encodeBoolean_comparison_exp)),
				_Utils_Tuple2(
				'language',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aC, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'name',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.w, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'namespace',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aE, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'namespace_for_language',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b5, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'namespace_type',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b6, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'normalized_name',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b7, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'purl',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.k, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'revision',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ac, $author$project$Analytics$InputObject$encodeInt_comparison_exp)),
				_Utils_Tuple2(
				'version',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aI, $author$project$Analytics$InputObject$encodeString_comparison_exp))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_organization_bool_exp = function (_v1) {
	var input____ = _v1;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Analytics$InputObject$encodeDim_organization_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Analytics$InputObject$encodeDim_organization_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Analytics$InputObject$encodeDim_organization_bool_exp))),
				_Utils_Tuple2(
				'added',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ak, $author$project$Analytics$InputObject$encodeTimestamp_comparison_exp)),
				_Utils_Tuple2(
				'deleted',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.z, $author$project$Analytics$InputObject$encodeTimestamp_comparison_exp)),
				_Utils_Tuple2(
				'dim_projects',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.f8, $author$project$Analytics$InputObject$encodeDim_project_bool_exp)),
				_Utils_Tuple2(
				'is_deleted',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aA, $author$project$Analytics$InputObject$encodeBoolean_comparison_exp)),
				_Utils_Tuple2(
				'organization_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.E, $author$project$Analytics$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'url_name',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ct, $author$project$Analytics$InputObject$encodeString_comparison_exp))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_project_bool_exp = function (_v0) {
	var input____ = _v0;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Analytics$InputObject$encodeDim_project_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Analytics$InputObject$encodeDim_project_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Analytics$InputObject$encodeDim_project_bool_exp))),
				_Utils_Tuple2(
				'added',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ak, $author$project$Analytics$InputObject$encodeTimestamp_comparison_exp)),
				_Utils_Tuple2(
				'deleted',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.z, $author$project$Analytics$InputObject$encodeTimestamp_comparison_exp)),
				_Utils_Tuple2(
				'dim_organization',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dR, $author$project$Analytics$InputObject$encodeDim_organization_bool_exp)),
				_Utils_Tuple2(
				'is_deleted',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aA, $author$project$Analytics$InputObject$encodeBoolean_comparison_exp)),
				_Utils_Tuple2(
				'name',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.w, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'organization_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.E, $author$project$Analytics$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'private',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cd, $author$project$Analytics$InputObject$encodeBoolean_comparison_exp)),
				_Utils_Tuple2(
				'project_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.s, $author$project$Analytics$InputObject$encodeUuid_comparison_exp))
			]));
};
var $author$project$Analytics$InputObject$encodeLicense_restriction_types_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_eq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aW,
					A2(
						$author$project$Analytics$Scalar$unwrapEncoder,
						function ($) {
							return $.ih;
						},
						$author$project$Analytics$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aY,
					A2(
						$author$project$Analytics$Scalar$unwrapEncoder,
						function ($) {
							return $.ih;
						},
						$author$project$Analytics$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aZ,
					A2(
						$author$project$Analytics$Scalar$unwrapEncoder,
						function ($) {
							return $.ih;
						},
						$author$project$Analytics$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Analytics$Scalar$unwrapEncoder,
							function ($) {
								return $.ih;
							},
							$author$project$Analytics$ScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a0,
					A2(
						$author$project$Analytics$Scalar$unwrapEncoder,
						function ($) {
							return $.ih;
						},
						$author$project$Analytics$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_lte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a1,
					A2(
						$author$project$Analytics$Scalar$unwrapEncoder,
						function ($) {
							return $.ih;
						},
						$author$project$Analytics$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_neq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a4,
					A2(
						$author$project$Analytics$Scalar$unwrapEncoder,
						function ($) {
							return $.ih;
						},
						$author$project$Analytics$ScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Analytics$Scalar$unwrapEncoder,
							function ($) {
								return $.ih;
							},
							$author$project$Analytics$ScalarCodecs$codecs))))
			]));
};
var $author$project$Analytics$InputObject$encodeString_array_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_contained_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.le,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string))),
				_Utils_Tuple2(
				'_contains',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.lf,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string))),
				_Utils_Tuple2(
				'_eq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aW,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string))),
				_Utils_Tuple2(
				'_gt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aY,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string))),
				_Utils_Tuple2(
				'_gte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aZ,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string))),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string)))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a0,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string))),
				_Utils_Tuple2(
				'_lte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a1,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string))),
				_Utils_Tuple2(
				'_neq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a4,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string))),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($dillonkearns$elm_graphql$Graphql$Internal$Encode$string))))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_licenses_bool_exp = function (_v0) {
	var input____ = _v0;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Analytics$InputObject$encodeDim_licenses_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Analytics$InputObject$encodeDim_licenses_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Analytics$InputObject$encodeDim_licenses_bool_exp))),
				_Utils_Tuple2(
				'distribution',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dS, $author$project$Analytics$InputObject$encodeLicense_restriction_types_comparison_exp)),
				_Utils_Tuple2(
				'fsf_free',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dY, $author$project$Analytics$InputObject$encodeBoolean_comparison_exp)),
				_Utils_Tuple2(
				'is_deprecated',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.d6, $author$project$Analytics$InputObject$encodeBoolean_comparison_exp)),
				_Utils_Tuple2(
				'is_dummy',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.b0, $author$project$Analytics$InputObject$encodeBoolean_comparison_exp)),
				_Utils_Tuple2(
				'is_multi_license',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.eh, $author$project$Analytics$InputObject$encodeBoolean_comparison_exp)),
				_Utils_Tuple2(
				'license_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.eq, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'license_id_array',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.er, $author$project$Analytics$InputObject$encodeString_array_comparison_exp)),
				_Utils_Tuple2(
				'licenses_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.es, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'osi_approved',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ew, $author$project$Analytics$InputObject$encodeBoolean_comparison_exp)),
				_Utils_Tuple2(
				'source',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.o, $author$project$Analytics$InputObject$encodeString_comparison_exp))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_purl_bool_exp = function (_v0) {
	var input____ = _v0;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Analytics$InputObject$encodeDim_purl_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Analytics$InputObject$encodeDim_purl_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Analytics$InputObject$encodeDim_purl_bool_exp))),
				_Utils_Tuple2(
				'dim_ingredient_version_revisions',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.lz, $author$project$Analytics$InputObject$encodeDim_ingredient_version_revision_bool_exp)),
				_Utils_Tuple2(
				'ingredient_purl',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bW, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'ingredient_version_purl',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.bZ, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'language',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aC, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'licenses',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.go, $author$project$Analytics$InputObject$encodeDim_licenses_bool_exp)),
				_Utils_Tuple2(
				'name',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.w, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'namespace',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aE, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'purl',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.k, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'qualifiers',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cf, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'subpath',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cm, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'version',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aI, $author$project$Analytics$InputObject$encodeString_comparison_exp))
			]));
};
var $author$project$Analytics$InputObject$encodePanorama_bool_exp = function (_v0) {
	var input____ = _v0;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Analytics$InputObject$encodePanorama_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Analytics$InputObject$encodePanorama_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Analytics$InputObject$encodePanorama_bool_exp))),
				_Utils_Tuple2(
				'branch_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.t, $author$project$Analytics$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'commit_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.P, $author$project$Analytics$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'dependency_timestamp',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aK, $author$project$Analytics$InputObject$encodeTimestamp_comparison_exp)),
				_Utils_Tuple2(
				'etl_processed_timestamp',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cS, $author$project$Analytics$InputObject$encodeTimestamp_comparison_exp)),
				_Utils_Tuple2(
				'ingredient',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cW, $author$project$Analytics$InputObject$encodeDim_ingredient_version_revision_bool_exp)),
				_Utils_Tuple2(
				'organization',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c3, $author$project$Analytics$InputObject$encodeDim_organization_bool_exp)),
				_Utils_Tuple2(
				'project',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c5, $author$project$Analytics$InputObject$encodeDim_project_bool_exp)),
				_Utils_Tuple2(
				'project_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.s, $author$project$Analytics$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'purl',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.k, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'purl_object',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c6, $author$project$Analytics$InputObject$encodeDim_purl_bool_exp)),
				_Utils_Tuple2(
				'source',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.o, $author$project$Analytics$InputObject$encodeString_comparison_exp)),
				_Utils_Tuple2(
				'update_timestamp',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dd, $author$project$Analytics$InputObject$encodeTimestamp_comparison_exp)),
				_Utils_Tuple2(
				'vulnerability_match_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aR, $author$project$Analytics$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'vulnerability_timestamp',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.aS, $author$project$Analytics$InputObject$encodeTimestamp_comparison_exp))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_ingredient_version_revision_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id_ingredient_version_revision',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.av,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_creation_date',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bS,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bT,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_version_creation_date',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bX,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_version_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bY,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_version_revision_creation_date',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_version_revision_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b$,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'is_ingredient',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.d9,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'is_ingredient_version',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ea,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'is_ingredient_version_revision',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.eb,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'is_namespace_public',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ej,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'language',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aC,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'name',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.w,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'namespace',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'namespace_for_language',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'namespace_type',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b6,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'normalized_name',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b7,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'purl',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.k,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'revision',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ac,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'version',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aI,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString)))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_project_max_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'added',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ak,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'deleted',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.z,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'name',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.w,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'organization_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.E,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'project_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.s,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString)))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_project_min_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'added',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ak,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'deleted',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.z,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'name',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.w,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'organization_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.E,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'project_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.s,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString)))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_project_aggregate_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'count',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cO,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'max',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c1, $author$project$Analytics$InputObject$encodeDim_project_max_order_by)),
				_Utils_Tuple2(
				'min',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c2, $author$project$Analytics$InputObject$encodeDim_project_min_order_by))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_organization_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'added',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ak,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'deleted',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.z,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'dim_projects_aggregate',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.lB, $author$project$Analytics$InputObject$encodeDim_project_aggregate_order_by)),
				_Utils_Tuple2(
				'is_deleted',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aA,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'organization_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.E,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'url_name',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ct,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString)))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_project_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'added',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ak,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'deleted',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.z,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'dim_organization',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dR, $author$project$Analytics$InputObject$encodeDim_organization_order_by)),
				_Utils_Tuple2(
				'is_deleted',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aA,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'name',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.w,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'organization_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.E,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'private',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cd,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'project_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.s,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString)))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_ingredient_version_revision_avg_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'revision',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ac,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString)))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_ingredient_version_revision_max_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id_ingredient_version_revision',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.av,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_creation_date',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bS,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bT,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_version_creation_date',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bX,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_version_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bY,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_version_revision_creation_date',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_version_revision_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b$,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'language',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aC,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'name',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.w,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'namespace',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'namespace_for_language',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'namespace_type',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b6,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'normalized_name',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b7,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'purl',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.k,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'revision',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ac,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'version',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aI,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString)))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_ingredient_version_revision_min_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id_ingredient_version_revision',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.av,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_creation_date',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bS,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bT,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_version_creation_date',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bX,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_version_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bY,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_version_revision_creation_date',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_version_revision_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b$,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'language',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aC,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'name',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.w,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'namespace',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'namespace_for_language',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'namespace_type',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b6,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'normalized_name',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b7,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'purl',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.k,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'revision',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ac,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'version',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aI,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString)))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_ingredient_version_revision_stddev_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'revision',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ac,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString)))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_ingredient_version_revision_stddev_pop_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'revision',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ac,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString)))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_ingredient_version_revision_stddev_samp_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'revision',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ac,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString)))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_ingredient_version_revision_sum_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'revision',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ac,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString)))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_ingredient_version_revision_var_pop_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'revision',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ac,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString)))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_ingredient_version_revision_var_samp_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'revision',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ac,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString)))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_ingredient_version_revision_variance_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'revision',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ac,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString)))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_ingredient_version_revision_aggregate_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'avg',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.fX, $author$project$Analytics$InputObject$encodeDim_ingredient_version_revision_avg_order_by)),
				_Utils_Tuple2(
				'count',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cO,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'max',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c1, $author$project$Analytics$InputObject$encodeDim_ingredient_version_revision_max_order_by)),
				_Utils_Tuple2(
				'min',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c2, $author$project$Analytics$InputObject$encodeDim_ingredient_version_revision_min_order_by)),
				_Utils_Tuple2(
				'stddev',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gL, $author$project$Analytics$InputObject$encodeDim_ingredient_version_revision_stddev_order_by)),
				_Utils_Tuple2(
				'stddev_pop',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gM, $author$project$Analytics$InputObject$encodeDim_ingredient_version_revision_stddev_pop_order_by)),
				_Utils_Tuple2(
				'stddev_samp',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gN, $author$project$Analytics$InputObject$encodeDim_ingredient_version_revision_stddev_samp_order_by)),
				_Utils_Tuple2(
				'sum',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gO, $author$project$Analytics$InputObject$encodeDim_ingredient_version_revision_sum_order_by)),
				_Utils_Tuple2(
				'var_pop',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gT, $author$project$Analytics$InputObject$encodeDim_ingredient_version_revision_var_pop_order_by)),
				_Utils_Tuple2(
				'var_samp',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gU, $author$project$Analytics$InputObject$encodeDim_ingredient_version_revision_var_samp_order_by)),
				_Utils_Tuple2(
				'variance',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.gV, $author$project$Analytics$InputObject$encodeDim_ingredient_version_revision_variance_order_by))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_licenses_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'distribution',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.dS,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'fsf_free',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.dY,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'is_deprecated',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.d6,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'is_dummy',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.b0,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'is_multi_license',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.eh,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'license_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.eq,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'license_id_array',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.er,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'licenses_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.es,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'osi_approved',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ew,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'source',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.o,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString)))
			]));
};
var $author$project$Analytics$InputObject$encodeDim_purl_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'dim_ingredient_version_revisions_aggregate',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.lA, $author$project$Analytics$InputObject$encodeDim_ingredient_version_revision_aggregate_order_by)),
				_Utils_Tuple2(
				'ingredient_purl',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bW,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient_version_purl',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.bZ,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'language',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aC,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'licenses',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.go, $author$project$Analytics$InputObject$encodeDim_licenses_order_by)),
				_Utils_Tuple2(
				'name',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.w,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'namespace',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'purl',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.k,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'qualifiers',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cf,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'subpath',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cm,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'version',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aI,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString)))
			]));
};
var $author$project$Analytics$InputObject$encodePanorama_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'branch_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.t,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'commit_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.P,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'dependency_timestamp',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aK,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'etl_processed_timestamp',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.cS,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'ingredient',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.cW, $author$project$Analytics$InputObject$encodeDim_ingredient_version_revision_order_by)),
				_Utils_Tuple2(
				'organization',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c3, $author$project$Analytics$InputObject$encodeDim_organization_order_by)),
				_Utils_Tuple2(
				'project',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c5, $author$project$Analytics$InputObject$encodeDim_project_order_by)),
				_Utils_Tuple2(
				'project_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.s,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'purl',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.k,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'purl_object',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c6, $author$project$Analytics$InputObject$encodeDim_purl_order_by)),
				_Utils_Tuple2(
				'source',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.o,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'update_timestamp',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.dd,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'vulnerability_match_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aR,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'vulnerability_timestamp',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aS,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Order_by$toString)))
			]));
};
var $author$project$Analytics$Enum$Panorama_select_column$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'branch_id';
		case 1:
			return 'commit_id';
		case 2:
			return 'dependency_timestamp';
		case 3:
			return 'etl_processed_timestamp';
		case 4:
			return 'project_id';
		case 5:
			return 'purl';
		case 6:
			return 'source';
		case 7:
			return 'update_timestamp';
		case 8:
			return 'vulnerability_match_id';
		default:
			return 'vulnerability_timestamp';
	}
};
var $author$project$Analytics$Query$panorama = F2(
	function (fillInOptionals____, object____) {
		var filledInOptionals____ = fillInOptionals____(
			{tE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ux: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, uR: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, vE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ao: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs____ = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'distinct_on',
					filledInOptionals____.tE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Analytics$Enum$Panorama_select_column$toString))),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'limit', filledInOptionals____.ux, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'offset', filledInOptionals____.uR, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'order_by',
					filledInOptionals____.vE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Analytics$InputObject$encodePanorama_order_by)),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'where', filledInOptionals____.ao, $author$project$Analytics$InputObject$encodePanorama_bool_exp)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'panorama',
			optionalArgs____,
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
	});
var $author$project$Model$Analytics$Fact$Dependencies$Data = F3(
	function (ingredient, project, projectID) {
		return {cW: ingredient, c5: project, zK: projectID};
	});
var $author$project$Model$Analytics$Fact$Dependencies$Dependency = $elm$core$Basics$identity;
var $author$project$Analytics$Object$Dim_project$name = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'String', 'name', _List_Nil, $elm$json$Json$Decode$string);
var $author$project$Analytics$Object$Panorama$project = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'project',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Analytics$Object$Dim_project$project_id = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'ScalarCodecs.Uuid',
	'project_id',
	_List_Nil,
	$author$project$Analytics$Scalar$unwrapCodecs($author$project$Analytics$ScalarCodecs$codecs).aq.qN);
var $author$project$Analytics$Object$Panorama$purl_object = function (object____) {
	return A4(
		$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
		'purl_object',
		_List_Nil,
		object____,
		A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$nullable));
};
var $author$project$Model$Analytics$DIM$Purl$Component = $elm$core$Basics$identity;
var $author$project$Model$Analytics$DIM$Purl$Data = F5(
	function (name, version, language, namespace, purl) {
		return {aC: language, w: name, aE: namespace, k: purl, aI: version};
	});
var $author$project$Model$Analytics$DIM$Purl$Other = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$Analytics$DIM$Purl$SupportedLanguage = function (a) {
	return {$: 0, a: a};
};
var $author$project$Analytics$Object$Dim_purl$ingredient_purl = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'ingredient_purl',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Analytics$Object$Dim_purl$language = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'language',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Analytics$Object$Dim_purl$name = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'name',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Analytics$Object$Dim_purl$namespace = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'namespace',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Analytics$Object$Dim_purl$version = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'(Maybe String)',
	'version',
	_List_Nil,
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Model$Analytics$DIM$Purl$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$elm$core$Basics$identity,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Analytics$Object$Dim_purl$ingredient_purl,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Analytics$Object$Dim_purl$namespace,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
					function (maybeLangName) {
						if (!maybeLangName.$) {
							var langName = maybeLangName.a;
							return A2(
								$elm$core$Maybe$withDefault,
								$author$project$Model$Analytics$DIM$Purl$Other(langName),
								A2(
									$elm$core$Maybe$map,
									$author$project$Model$Analytics$DIM$Purl$SupportedLanguage,
									$author$project$Model$Language$fromString(langName)));
						} else {
							return $author$project$Model$Analytics$DIM$Purl$Other('unknown');
						}
					},
					$author$project$Analytics$Object$Dim_purl$language),
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Analytics$Object$Dim_purl$version,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
							$elm$core$Maybe$withDefault('Purl is missing name'),
							$author$project$Analytics$Object$Dim_purl$name),
						$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$Analytics$DIM$Purl$Data)))))));
var $author$project$Model$Analytics$Fact$Dependencies$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$elm$core$Basics$identity,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$mapOrFail,
			$elm$core$Result$fromMaybe('Project ID is not a valid UUID'),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
				$elm$core$Maybe$andThen(
					function (_v0) {
						var uuid = _v0;
						return $danyx23$elm_uuid$Uuid$fromString(uuid);
					}),
				$author$project$Analytics$Object$Panorama$project($author$project$Analytics$Object$Dim_project$project_id))),
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$mapOrFail,
				$elm$core$Result$fromMaybe('Project is null and should not be'),
				$author$project$Analytics$Object$Panorama$project($author$project$Analytics$Object$Dim_project$name)),
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$mapOrFail,
					$elm$core$Result$fromMaybe('Missing Ingredient in Dependency'),
					$author$project$Analytics$Object$Panorama$purl_object($author$project$Model$Analytics$DIM$Purl$selectionSet)),
				$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$Analytics$Fact$Dependencies$Data)))));
var $author$project$Analytics$InputObject$Panorama_bool_exp = $elm$core$Basics$identity;
var $author$project$Analytics$InputObject$buildPanorama_bool_exp = function (fillOptionals____) {
	var optionals____ = fillOptionals____(
		{y: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, t: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, P: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aK: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, cS: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, cW: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, B: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, D: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, c3: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, c5: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, s: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, k: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, c6: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, o: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, dd: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aR: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aS: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
	return {y: optionals____.y, t: optionals____.t, P: optionals____.P, aK: optionals____.aK, cS: optionals____.cS, cW: optionals____.cW, B: optionals____.B, D: optionals____.D, c3: optionals____.c3, c5: optionals____.c5, s: optionals____.s, k: optionals____.k, c6: optionals____.c6, o: optionals____.o, dd: optionals____.dd, aR: optionals____.aR, aS: optionals____.aS};
};
var $author$project$Analytics$InputObject$Dim_organization_bool_exp = $elm$core$Basics$identity;
var $author$project$Analytics$InputObject$buildDim_organization_bool_exp = function (fillOptionals____) {
	var optionals____ = fillOptionals____(
		{ak: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, y: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, z: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, f8: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aA: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, B: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, D: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, E: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ct: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
	return {ak: optionals____.ak, y: optionals____.y, z: optionals____.z, f8: optionals____.f8, aA: optionals____.aA, B: optionals____.B, D: optionals____.D, E: optionals____.E, ct: optionals____.ct};
};
var $author$project$Analytics$InputObject$buildUuid_comparison_exp = function (fillOptionals____) {
	var optionals____ = fillOptionals____(
		{aW: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aY: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aZ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a_: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a0: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a4: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a5: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
	return {aW: optionals____.aW, aY: optionals____.aY, aZ: optionals____.aZ, a_: optionals____.a_, a$: optionals____.a$, a0: optionals____.a0, a1: optionals____.a1, a4: optionals____.a4, a5: optionals____.a5};
};
var $author$project$Model$Analytics$DIM$Organization$whereOrdID = function (orgID) {
	return $author$project$Analytics$InputObject$buildDim_organization_bool_exp(
		function (args) {
			return _Utils_update(
				args,
				{
					E: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
						$author$project$Analytics$InputObject$buildUuid_comparison_exp(
							function (a) {
								return _Utils_update(
									a,
									{
										aW: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
											$danyx23$elm_uuid$Uuid$toString(orgID))
									});
							}))
				});
		});
};
var $author$project$Model$Analytics$DIM$Organization$whereOrg = function (orgID) {
	return function (args) {
		return _Utils_update(
			args,
			{
				c3: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					$author$project$Model$Analytics$DIM$Organization$whereOrdID(orgID))
			});
	};
};
var $author$project$Analytics$InputObject$Dim_project_bool_exp = $elm$core$Basics$identity;
var $author$project$Analytics$InputObject$buildDim_project_bool_exp = function (fillOptionals____) {
	var optionals____ = fillOptionals____(
		{ak: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, y: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, z: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, dR: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aA: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, w: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, B: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, D: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, E: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, cd: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, s: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
	return {ak: optionals____.ak, y: optionals____.y, z: optionals____.z, dR: optionals____.dR, aA: optionals____.aA, w: optionals____.w, B: optionals____.B, D: optionals____.D, E: optionals____.E, cd: optionals____.cd, s: optionals____.s};
};
var $author$project$Model$Analytics$DIM$Project$whereProjectID = function (projectId) {
	return $author$project$Analytics$InputObject$buildDim_project_bool_exp(
		function (args) {
			return _Utils_update(
				args,
				{
					s: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
						$author$project$Analytics$InputObject$buildUuid_comparison_exp(
							function (a) {
								return _Utils_update(
									a,
									{
										aW: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
											$danyx23$elm_uuid$Uuid$toString(projectId))
									});
							}))
				});
		});
};
var $author$project$Model$Analytics$DIM$Project$whereProject = function (pId) {
	return function (args) {
		return _Utils_update(
			args,
			{
				c5: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
					$author$project$Model$Analytics$DIM$Project$whereProjectID(pId))
			});
	};
};
var $author$project$Analytics$InputObject$Dim_purl_bool_exp = $elm$core$Basics$identity;
var $author$project$Analytics$InputObject$buildDim_purl_bool_exp = function (fillOptionals____) {
	var optionals____ = fillOptionals____(
		{y: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, lz: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, bW: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, bZ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aC: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, go: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, w: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, B: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, D: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, k: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, cf: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, cm: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aI: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
	return {y: optionals____.y, lz: optionals____.lz, bW: optionals____.bW, bZ: optionals____.bZ, aC: optionals____.aC, go: optionals____.go, w: optionals____.w, aE: optionals____.aE, B: optionals____.B, D: optionals____.D, k: optionals____.k, cf: optionals____.cf, cm: optionals____.cm, aI: optionals____.aI};
};
var $author$project$Analytics$InputObject$buildString_comparison_exp = function (fillOptionals____) {
	var optionals____ = fillOptionals____(
		{aW: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aY: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aZ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, l7: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a_: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, mj: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, mt: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a0: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a4: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, mI: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a5: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, mJ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, mK: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, mO: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, mP: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, nd: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, nv: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
	return {aW: optionals____.aW, aY: optionals____.aY, aZ: optionals____.aZ, l7: optionals____.l7, a_: optionals____.a_, mj: optionals____.mj, a$: optionals____.a$, mt: optionals____.mt, a0: optionals____.a0, a1: optionals____.a1, a4: optionals____.a4, mI: optionals____.mI, a5: optionals____.a5, mJ: optionals____.mJ, mK: optionals____.mK, mO: optionals____.mO, mP: optionals____.mP, nd: optionals____.nd, nv: optionals____.nv};
};
var $author$project$Model$Analytics$DIM$Purl$notIn = function (args) {
	return _Utils_update(
		args,
		{
			a5: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Model$Namespace$internalNamespaces)
		});
};
var $author$project$Model$Analytics$DIM$Purl$notNull = function (args) {
	return _Utils_update(
		args,
		{
			a$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(true)
		});
};
var $author$project$Model$Analytics$DIM$Purl$or = _List_fromArray(
	[
		$author$project$Analytics$InputObject$buildDim_purl_bool_exp(
		function (args) {
			return _Utils_update(
				args,
				{
					aE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
						$author$project$Analytics$InputObject$buildString_comparison_exp($author$project$Model$Analytics$DIM$Purl$notNull))
				});
		}),
		$author$project$Analytics$InputObject$buildDim_purl_bool_exp(
		function (args) {
			return _Utils_update(
				args,
				{
					aE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
						$author$project$Analytics$InputObject$buildString_comparison_exp($author$project$Model$Analytics$DIM$Purl$notIn))
				});
		})
	]);
var $author$project$Model$Analytics$DIM$Purl$whereNamespace = $author$project$Analytics$InputObject$buildDim_purl_bool_exp(
	function (args) {
		return _Utils_update(
			args,
			{
				D: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Model$Analytics$DIM$Purl$or)
			});
	});
var $author$project$Model$Analytics$DIM$Purl$wherePurl = function (args) {
	return _Utils_update(
		args,
		{
			c6: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present($author$project$Model$Analytics$DIM$Purl$whereNamespace)
		});
};
var $author$project$Model$Analytics$Fact$Dependencies$whereArgs = F2(
	function (maybeOrgID, maybeProjectID) {
		return function (args) {
			return _Utils_update(
				args,
				{
					ao: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
						$author$project$Analytics$InputObject$buildPanorama_bool_exp(
							A2(
								$elm$core$Basics$composeR,
								A2(
									$elm$core$Maybe$withDefault,
									$elm$core$Basics$identity,
									A2($elm$core$Maybe$map, $author$project$Model$Analytics$DIM$Organization$whereOrg, maybeOrgID)),
								A2(
									$elm$core$Basics$composeR,
									A2(
										$elm$core$Maybe$withDefault,
										$elm$core$Basics$identity,
										A2($elm$core$Maybe$map, $author$project$Model$Analytics$DIM$Project$whereProject, maybeProjectID)),
									$author$project$Model$Analytics$DIM$Purl$wherePurl))))
				});
		};
	});
var $author$project$Model$Analytics$Fact$Dependencies$get = F2(
	function (orgID, maybeProjectID) {
		return A2(
			$author$project$Analytics$Query$panorama,
			A2($author$project$Model$Analytics$Fact$Dependencies$whereArgs, orgID, maybeProjectID),
			$author$project$Model$Analytics$Fact$Dependencies$selectionSet);
	});
var $author$project$Request$Analytics$Dependencies$getInOrganization = F2(
	function (creds, orgId) {
		return A5(
			$author$project$GraphQL$Utils$queryRequest,
			creds,
			2,
			_List_Nil,
			'HasuraAnalyticsOrgDeps',
			A2(
				$author$project$Model$Analytics$Fact$Dependencies$get,
				$elm$core$Maybe$Just(orgId),
				$elm$core$Maybe$Nothing));
	});
var $author$project$Misc$groupByOn = F2(
	function (keyFn, elFn) {
		return A2(
			$elm$core$List$foldr,
			F2(
				function (v, acc) {
					return A4(
						$elm_community$dict_extra$Dict$Extra$insertDedupe,
						$elm_community$basics_extra$Basics$Extra$flip($elm$core$Basics$append),
						keyFn(v),
						$elm$core$List$singleton(
							elFn(v)),
						acc);
				}),
			$elm$core$Dict$empty);
	});
var $author$project$Model$Analytics$DIM$Purl$isImage = function (_v0) {
	var data = _v0;
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$elm$core$String$startsWith('pkg:docker/'),
			data.k));
};
var $author$project$Request$Panorama$getOrgDepsAndVulns = F2(
	function (session, organization) {
		var creds = $author$project$Model$Session$getCreds(session);
		return A2(
			$elm$core$Task$andThen,
			function (deps) {
				var _v0 = A2(
					$elm$core$List$partition,
					A2($elm$core$Basics$composeR, $author$project$Model$Analytics$Fact$Dependencies$component, $author$project$Model$Analytics$DIM$Purl$isImage),
					deps);
				var images = _v0.a;
				var components = _v0.b;
				return A2(
					$elm$core$Task$map,
					A2($author$project$Request$Panorama$PanoramaData, images, components),
					A2(
						$elm$core$Task$map,
						A2($author$project$Misc$groupByOn, $elm$core$Tuple$first, $elm$core$Tuple$second),
						A2(
							$author$project$Request$Analytics$Vulnerabilities$getCVEMatches,
							creds,
							A2($elm$core$List$filterMap, $author$project$Model$Analytics$Fact$Dependencies$cveKeyFromDep, components))));
			},
			A2($author$project$Request$Analytics$Dependencies$getInOrganization, creds, organization.zw));
	});
var $author$project$Pages$OrgDependencies$cmds = F2(
	function (session, model) {
		return A2(
			$elm$core$Task$attempt,
			$author$project$Pages$OrgDependencies$OnPanoramaData,
			A2($author$project$Request$Panorama$getOrgDepsAndVulns, session, model.c3));
	});
var $author$project$Pages$OrgRemediation$OnBuildPlans = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$OrgRemediation$cmds = F2(
	function (session, model) {
		var buildPlansTask = $elm$core$Task$sequence(
			A2(
				$elm$core$List$map,
				function (_v0) {
					var project = _v0.a;
					var commitID = _v0.b;
					return A2(
						$elm$core$Task$map,
						$elm$core$Tuple$pair(
							$author$project$Model$Project$getName(project)),
						A3(
							$author$project$Request$BuildPlanner$getBuildPlan,
							session,
							true,
							{
								BR: commitID,
								ix: $author$project$Model$Organization$getUrlName(model.c3),
								vT: $author$project$Model$Project$getName(project)
							}));
				},
				model.qi));
		return A2($elm$core$Task$attempt, $author$project$Pages$OrgRemediation$OnBuildPlans, buildPlansTask);
	});
var $author$project$Pages$OrgSecurity$OnPanoramaData = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$OrgSecurity$cmds = F2(
	function (session, model) {
		return A2(
			$elm$core$Task$attempt,
			$author$project$Pages$OrgSecurity$OnPanoramaData,
			A3(
				$elm$core$Task$map2,
				$elm$core$Tuple$pair,
				A2(
					$author$project$Request$Project$getProjectsByOrgs,
					$author$project$Model$Session$getCreds(session),
					model.c3.zw),
				A2($author$project$Request$Panorama$getOrgDepsAndVulns, session, model.c3)));
	});
var $author$project$Pages$ProjectConfig$AddPackage = 0;
var $author$project$Pages$ProjectConfig$ModalOpen = function (a) {
	return {$: 16, a: a};
};
var $author$project$Views$CustomRequirementInput$OnNamespacesReceived = function (a) {
	return {$: 4, a: a};
};
var $author$project$Request$Ingredient$getNamespaces = function (creds) {
	return $author$project$Http$Extra$get(
		{
			iO: $author$project$Http$Extra$HeaderOnly(creds),
			sY: $author$project$Http$Extra$emptyBody,
			qN: A2(
				$elm$json$Json$Decode$field,
				'namespaces',
				$elm$json$Json$Decode$list(
					A2($elm$json$Json$Decode$field, 'namespace', $elm$json$Json$Decode$string))),
			CN: _List_Nil,
			GT: A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					[$author$project$Request$Ingredient$baseUrl, 'namespaces']),
				_List_fromArray(
					[
						A2($elm$url$Url$Builder$string, 'limit', '10000')
					]))
		});
};
var $author$project$Views$CustomRequirementInput$cmds = F2(
	function (session, _v0) {
		return A2(
			$elm$core$Task$attempt,
			$author$project$Views$CustomRequirementInput$OnNamespacesReceived,
			$author$project$Request$Ingredient$getNamespaces(
				$author$project$Model$Session$getCreds(session)));
	});
var $author$project$Pages$ProjectConfig$cmds = F4(
	function (session, showAddPackagesModal, showImportPackagesModal, model) {
		var triggerSoftRefreshComplete = A2(
			$elm$core$Task$attempt,
			$author$project$Pages$ProjectConfig$SoftRefreshComplete,
			$elm$core$Task$succeed(
				_Utils_Tuple2(model.f0, model.ok)));
		var modalCmd = showAddPackagesModal ? A2(
			$elm$core$Task$perform,
			$author$project$Pages$ProjectConfig$ModalOpen,
			$elm$core$Task$succeed(0)) : (showImportPackagesModal ? A2(
			$elm$core$Task$perform,
			$author$project$Pages$ProjectConfig$ModalOpen,
			$elm$core$Task$succeed(1)) : $elm$core$Platform$Cmd$none);
		var editor = $author$project$Model$BuildPlanner$SolveLegacyEditor$fromBuildExprWithFallback(model.ok);
		var customRequirementInputCmd = $author$project$Model$Session$isSuperUser(session) ? A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Pages$ProjectConfig$CustomRequirementInputMsg,
			A2($author$project$Views$CustomRequirementInput$cmds, session, model.on)) : $elm$core$Platform$Cmd$none;
		var _v0 = A3(
			$author$project$Pages$ProjectConfig$normalizeBundlesAndPackages,
			$author$project$Model$Session$getCreds(session),
			model,
			editor);
		var newModel = _v0.a;
		var normsAndVulnsCmd = _v0.b;
		return A2(
			$author$project$Misc$with,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[modalCmd, customRequirementInputCmd, normsAndVulnsCmd, triggerSoftRefreshComplete])),
			newModel);
	});
var $author$project$Pages$ProjectConfigAdvanced$cmds = function (model) {
	return A2(
		$author$project$Misc$with,
		A2(
			$elm$core$Task$attempt,
			$author$project$Pages$ProjectConfigAdvanced$SoftRefreshComplete,
			$elm$core$Task$succeed(
				_Utils_Tuple2(model.f0, model.ok))),
		model);
};
var $author$project$Model$Experiments$Experiments$forkVsCLIExperimentName = 'u8s73fQ_SPya0Q0nvWcqBw';
var $author$project$Ports$requestExperimentValue = _Platform_outgoingPort('requestExperimentValue', $elm$json$Json$Encode$string);
var $author$project$Pages$ProjectDownloads$cmds = function (model) {
	var triggerSoftRefreshComplete = A2(
		$elm$core$Task$attempt,
		$author$project$Pages$ProjectDownloads$SoftRefreshComplete,
		$elm$core$Task$succeed(model.f0));
	var experimentCmd = $author$project$Ports$requestExperimentValue($author$project$Model$Experiments$Experiments$forkVsCLIExperimentName);
	return $elm$core$Platform$Cmd$batch(
		_List_fromArray(
			[experimentCmd, triggerSoftRefreshComplete]));
};
var $author$project$Pages$ProjectHistory$cmds = F2(
	function (_v0, _v1) {
		return $elm$core$Platform$Cmd$none;
	});
var $author$project$Pages$ProjectImpactReport$OnDiff = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$ProjectImpactReport$Validation = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$ProjectImpactReport$cmds = F2(
	function (session, model) {
		var input = function (spec) {
			return {
				c3: $author$project$Model$Organization$getUrlName(model.c3),
				c5: $author$project$Model$Project$getName(model.c5),
				Gc: spec
			};
		};
		var creds = $author$project$Model$Session$getCreds(session);
		var _v0 = model.E5;
		if (!_v0.$) {
			var _v1 = _v0.a;
			var before = _v1.a;
			var after = _v1.b;
			return A2(
				$author$project$Misc$with,
				A2(
					$elm$core$Task$attempt,
					$author$project$Pages$ProjectImpactReport$OnDiff,
					A3(
						$author$project$Request$BuildPlanner$getImpactReport,
						creds,
						input(before),
						input(after))),
				_Utils_update(
					model,
					{hi: $krisajenkins$remotedata$RemoteData$Loading}));
		} else {
			var error = _v0.a;
			return A2(
				$author$project$Misc$with,
				$elm$core$Platform$Cmd$none,
				_Utils_update(
					model,
					{
						hi: $krisajenkins$remotedata$RemoteData$Failure(
							$author$project$Pages$ProjectImpactReport$Validation(error))
					}));
		}
	});
var $author$project$Pages$OrgDependencies$Loading = {$: 0};
var $author$project$Pages$OrgDependencies$Vulnerabilities = 3;
var $author$project$Pages$OrgDependencies$createModel = F2(
	function (_v0, _v1) {
		var loadedOrg = _v1.a;
		var loadedMembers = _v1.b;
		return {lx: $author$project$Pages$OrgDependencies$Loading, i2: true, lW: false, i3: true, hw: $elm$core$Set$empty, i4: true, i5: true, i6: true, jS: true, hB: loadedMembers, c3: loadedOrg, kt: '', nx: 3, ny: 1, jy: $author$project$Pages$OrgDependencies$takeIncrement};
	});
var $author$project$Views$ProjectList$Ascending = 0;
var $author$project$Views$ProjectList$Created = 1;
var $author$project$Pages$OrgIndex$Loading = 0;
var $author$project$Pages$OrgIndex$ProjectListArrived = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$OrgIndex$UsageDataReceived = function (a) {
	return {$: 7, a: a};
};
var $author$project$Views$OrgOverview$OnPanoramaData = $elm$core$Basics$identity;
var $author$project$Views$OrgOverview$loadingMetadata = {
	us: _List_fromArray(
		[
			_Utils_Tuple2('Loading', 50),
			_Utils_Tuple2('Loading', 30),
			_Utils_Tuple2('Loading', 10),
			_Utils_Tuple2('Loading', 5),
			_Utils_Tuple2('Loading', 5)
		]),
	Av: 100
};
var $author$project$Views$OrgOverview$init = function (_v0) {
	var session = _v0.l;
	var organization = _v0.c3;
	return _Utils_Tuple2(
		{lt: $krisajenkins$remotedata$RemoteData$Loading, j7: $author$project$Views$OrgOverview$loadingMetadata, c3: organization, E4: $krisajenkins$remotedata$RemoteData$Loading, F2: $krisajenkins$remotedata$RemoteData$Loading},
		A2(
			$elm$core$Task$attempt,
			$elm$core$Basics$identity,
			A2($author$project$Request$Panorama$getOrgDepsAndVulns, session, organization)));
};
var $author$project$Model$Permissions$orgCanSeeOrgSummary = $author$project$Model$Organization$addOnEnabled('org_summary');
var $author$project$Pages$OrgIndex$orgOverview = F2(
	function (session, organization) {
		return $author$project$Model$Permissions$orgCanSeeOrgSummary(organization) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Platform$Cmd$map($author$project$Pages$OrgIndex$OrgOverviewMsg),
				$author$project$Views$OrgOverview$init(
					{c3: organization, l: session}))) : $elm$core$Maybe$Nothing;
	});
var $author$project$Builder$Enum$Order_by$Desc = 3;
var $author$project$Builder$InputObject$buildDate_comparison_exp = function (fillOptionals____) {
	var optionals____ = fillOptionals____(
		{aW: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aY: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, aZ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a_: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a$: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a0: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a1: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a4: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, a5: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
	return {aW: optionals____.aW, aY: optionals____.aY, aZ: optionals____.aZ, a_: optionals____.a_, a$: optionals____.a$, a0: optionals____.a0, a1: optionals____.a1, a4: optionals____.a4, a5: optionals____.a5};
};
var $author$project$Builder$InputObject$Organizations_runtime_usage_bool_exp = $elm$core$Basics$identity;
var $author$project$Builder$InputObject$buildOrganizations_runtime_usage_bool_exp = function (fillOptionals____) {
	var optionals____ = fillOptionals____(
		{dx: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ak: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, y: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, et: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, B: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, D: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, c3: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, E: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, eM: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, eN: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, eT: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, e9: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
	return {dx: optionals____.dx, ak: optionals____.ak, y: optionals____.y, et: optionals____.et, B: optionals____.B, D: optionals____.D, c3: optionals____.c3, E: optionals____.E, eM: optionals____.eM, eN: optionals____.eN, eT: optionals____.eT, e9: optionals____.e9};
};
var $author$project$Builder$InputObject$buildOrganizations_runtime_usage_order_by = function (fillOptionals____) {
	var optionals____ = fillOptionals____(
		{dx: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ak: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, et: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, c3: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, E: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, eM: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, eN: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, eT: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, e9: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
	return {dx: optionals____.dx, ak: optionals____.ak, et: optionals____.et, c3: optionals____.c3, E: optionals____.E, eM: optionals____.eM, eN: optionals____.eN, eT: optionals____.eT, e9: optionals____.e9};
};
var $author$project$Builder$InputObject$encodeDate_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_eq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aW,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.ic;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aY,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.ic;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aZ,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.ic;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Builder$Scalar$unwrapEncoder,
							function ($) {
								return $.ic;
							},
							$author$project$CustomScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a0,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.ic;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_lte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a1,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.ic;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_neq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a4,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.ic;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Builder$Scalar$unwrapEncoder,
							function ($) {
								return $.ic;
							},
							$author$project$CustomScalarCodecs$codecs))))
			]));
};
var $author$project$Builder$InputObject$encodeNumeric_comparison_exp = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_eq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aW,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.ho;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aY,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.ho;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_gte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.aZ,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.ho;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_in',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a_,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Builder$Scalar$unwrapEncoder,
							function ($) {
								return $.ho;
							},
							$author$project$CustomScalarCodecs$codecs)))),
				_Utils_Tuple2(
				'_is_null',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.a$, $dillonkearns$elm_graphql$Graphql$Internal$Encode$bool)),
				_Utils_Tuple2(
				'_lt',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a0,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.ho;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_lte',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a1,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.ho;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_neq',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a4,
					A2(
						$author$project$Builder$Scalar$unwrapEncoder,
						function ($) {
							return $.ho;
						},
						$author$project$CustomScalarCodecs$codecs))),
				_Utils_Tuple2(
				'_nin',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.a5,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						A2(
							$author$project$Builder$Scalar$unwrapEncoder,
							function ($) {
								return $.ho;
							},
							$author$project$CustomScalarCodecs$codecs))))
			]));
};
var $author$project$Builder$InputObject$encodeOrganizations_runtime_usage_bool_exp = function (_v0) {
	var input____ = _v0;
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'_and',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.y,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Builder$InputObject$encodeOrganizations_runtime_usage_bool_exp))),
				_Utils_Tuple2(
				'_not',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.B, $author$project$Builder$InputObject$encodeOrganizations_runtime_usage_bool_exp)),
				_Utils_Tuple2(
				'_or',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.D,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Builder$InputObject$encodeOrganizations_runtime_usage_bool_exp))),
				_Utils_Tuple2(
				'active_runtimes',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.dx, $author$project$Builder$InputObject$encodeNumeric_comparison_exp)),
				_Utils_Tuple2(
				'added',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.ak, $author$project$Builder$InputObject$encodeTimestamp_comparison_exp)),
				_Utils_Tuple2(
				'limit_runtimes',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.et, $author$project$Builder$InputObject$encodeInt_comparison_exp)),
				_Utils_Tuple2(
				'organization',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c3, $author$project$Builder$InputObject$encodeOrganizations_bool_exp)),
				_Utils_Tuple2(
				'organization_id',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.E, $author$project$Builder$InputObject$encodeUuid_comparison_exp)),
				_Utils_Tuple2(
				'static_runtimes_next_gen_installer',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.eM, $author$project$Builder$InputObject$encodeInt_comparison_exp)),
				_Utils_Tuple2(
				'static_runtimes_state_deploy',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.eN, $author$project$Builder$InputObject$encodeInt_comparison_exp)),
				_Utils_Tuple2(
				'total_runtimes',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.eT, $author$project$Builder$InputObject$encodeNumeric_comparison_exp)),
				_Utils_Tuple2(
				'week_of',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.e9, $author$project$Builder$InputObject$encodeDate_comparison_exp))
			]));
};
var $author$project$Builder$InputObject$encodeOrganizations_runtime_usage_order_by = function (input____) {
	return $dillonkearns$elm_graphql$Graphql$Internal$Encode$maybeObject(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'active_runtimes',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.dx,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'added',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.ak,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'limit_runtimes',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.et,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'organization',
				A2($dillonkearns$elm_graphql$Graphql$Internal$Encode$optional, input____.c3, $author$project$Builder$InputObject$encodeOrganizations_order_by)),
				_Utils_Tuple2(
				'organization_id',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.E,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'static_runtimes_next_gen_installer',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.eM,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'static_runtimes_state_deploy',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.eN,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'total_runtimes',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.eT,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString))),
				_Utils_Tuple2(
				'week_of',
				A2(
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$optional,
					input____.e9,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Order_by$toString)))
			]));
};
var $author$project$Builder$Enum$Organizations_runtime_usage_select_column$toString = function (enum____) {
	switch (enum____) {
		case 0:
			return 'active_runtimes';
		case 1:
			return 'added';
		case 2:
			return 'limit_runtimes';
		case 3:
			return 'organization_id';
		case 4:
			return 'static_runtimes_next_gen_installer';
		case 5:
			return 'static_runtimes_state_deploy';
		case 6:
			return 'total_runtimes';
		default:
			return 'week_of';
	}
};
var $author$project$Builder$Query$organizations_runtime_usage = F2(
	function (fillInOptionals____, object____) {
		var filledInOptionals____ = fillInOptionals____(
			{tE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ux: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, uR: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, vE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent, ao: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Absent});
		var optionalArgs____ = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'distinct_on',
					filledInOptionals____.tE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list(
						$dillonkearns$elm_graphql$Graphql$Internal$Encode$enum($author$project$Builder$Enum$Organizations_runtime_usage_select_column$toString))),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'limit', filledInOptionals____.ux, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'offset', filledInOptionals____.uR, $dillonkearns$elm_graphql$Graphql$Internal$Encode$int),
					A3(
					$dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional,
					'order_by',
					filledInOptionals____.vE,
					$dillonkearns$elm_graphql$Graphql$Internal$Encode$list($author$project$Builder$InputObject$encodeOrganizations_runtime_usage_order_by)),
					A3($dillonkearns$elm_graphql$Graphql$Internal$Builder$Argument$optional, 'where', filledInOptionals____.ao, $author$project$Builder$InputObject$encodeOrganizations_runtime_usage_bool_exp)
				]));
		return A4(
			$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForCompositeField,
			'organizations_runtime_usage',
			optionalArgs____,
			object____,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$json$Json$Decode$list));
	});
var $author$project$Model$RuntimeUsageData$Data = F7(
	function (activeRuntimes, activeRuntimesLimit, organizationId, staticRuntimesNextGenInstaller, staticRuntimesStateDeploy, totalRuntimes, weekOf) {
		return {w7: activeRuntimes, A0: activeRuntimesLimit, zx: organizationId, Ge: staticRuntimesNextGenInstaller, Gg: staticRuntimesStateDeploy, GK: totalRuntimes, Ha: weekOf};
	});
var $author$project$Model$RuntimeUsageData$RuntimeUsageData = $elm$core$Basics$identity;
var $author$project$Builder$Object$Organizations_runtime_usage$active_runtimes = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'CustomScalarCodecs.Numeric',
	'active_runtimes',
	_List_Nil,
	$author$project$Builder$Scalar$unwrapCodecs($author$project$CustomScalarCodecs$codecs).ho.qN);
var $author$project$Builder$Object$Organizations_runtime_usage$limit_runtimes = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'limit_runtimes', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Builder$Object$Organizations_runtime_usage$organization_id = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'CustomScalarCodecs.Uuid',
	'organization_id',
	_List_Nil,
	$author$project$Builder$Scalar$unwrapCodecs($author$project$CustomScalarCodecs$codecs).aq.qN);
var $author$project$Builder$Object$Organizations_runtime_usage$static_runtimes_next_gen_installer = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'static_runtimes_next_gen_installer', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Builder$Object$Organizations_runtime_usage$static_runtimes_state_deploy = A4($dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField, 'Int', 'static_runtimes_state_deploy', _List_Nil, $elm$json$Json$Decode$int);
var $author$project$Builder$Object$Organizations_runtime_usage$total_runtimes = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'CustomScalarCodecs.Numeric',
	'total_runtimes',
	_List_Nil,
	$author$project$Builder$Scalar$unwrapCodecs($author$project$CustomScalarCodecs$codecs).ho.qN);
var $author$project$Builder$Object$Organizations_runtime_usage$week_of = A4(
	$dillonkearns$elm_graphql$Graphql$Internal$Builder$Object$selectionForField,
	'CustomScalarCodecs.Date',
	'week_of',
	_List_Nil,
	$author$project$Builder$Scalar$unwrapCodecs($author$project$CustomScalarCodecs$codecs).ic.qN);
var $author$project$Model$RuntimeUsageData$selectionSet = A2(
	$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
	$elm$core$Basics$identity,
	A2(
		$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
		$author$project$Builder$Object$Organizations_runtime_usage$week_of,
		A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
			$author$project$Builder$Object$Organizations_runtime_usage$total_runtimes,
			A2(
				$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
				$author$project$Builder$Object$Organizations_runtime_usage$static_runtimes_state_deploy,
				A2(
					$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
					$author$project$Builder$Object$Organizations_runtime_usage$static_runtimes_next_gen_installer,
					A2(
						$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
						$author$project$Builder$Object$Organizations_runtime_usage$organization_id,
						A2(
							$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
							$author$project$Builder$Object$Organizations_runtime_usage$limit_runtimes,
							A2(
								$dillonkearns$elm_graphql$Graphql$SelectionSet$with,
								$author$project$Builder$Object$Organizations_runtime_usage$active_runtimes,
								$dillonkearns$elm_graphql$Graphql$SelectionSet$succeed($author$project$Model$RuntimeUsageData$Data)))))))));
var $author$project$Request$Organization$runTimeUsage = F2(
	function (now, orgID) {
		var oneWeekInMilliS = (((1000 * 60) * 60) * 24) * 7;
		var lastWeekPosix = $elm$time$Time$millisToPosix(
			$elm$time$Time$posixToMillis(now) - oneWeekInMilliS);
		var runtimeUsageOptionalArgs = function (optionalArgs) {
			return _Utils_update(
				optionalArgs,
				{
					ux: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(1),
					vE: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
						_List_fromArray(
							[
								$author$project$Builder$InputObject$buildOrganizations_runtime_usage_order_by(
								function (orderByArgs) {
									return _Utils_update(
										orderByArgs,
										{
											e9: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(3)
										});
								})
							])),
					ao: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
						$author$project$Builder$InputObject$buildOrganizations_runtime_usage_bool_exp(
							function (optionalBoolAndArgs) {
								return _Utils_update(
									optionalBoolAndArgs,
									{
										y: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
											_List_fromArray(
												[
													$author$project$Builder$InputObject$buildOrganizations_runtime_usage_bool_exp(
													function (optionalBoolExp) {
														return _Utils_update(
															optionalBoolExp,
															{
																E: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
																	$author$project$Builder$InputObject$buildUuid_comparison_exp(
																		function (comparisonArgs) {
																			return _Utils_update(
																				comparisonArgs,
																				{
																					aW: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(orgID)
																				});
																		}))
															});
													}),
													$author$project$Builder$InputObject$buildOrganizations_runtime_usage_bool_exp(
													function (optionalBoolExp) {
														return _Utils_update(
															optionalBoolExp,
															{
																e9: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(
																	$author$project$Builder$InputObject$buildDate_comparison_exp(
																		function (comparisonArgs) {
																			return _Utils_update(
																				comparisonArgs,
																				{
																					aZ: $dillonkearns$elm_graphql$Graphql$OptionalArgument$Present(lastWeekPosix)
																				});
																		}))
															});
													})
												]))
									});
							}))
				});
		};
		return A2(
			$dillonkearns$elm_graphql$Graphql$SelectionSet$map,
			$elm$core$List$head,
			A2($author$project$Builder$Query$organizations_runtime_usage, runtimeUsageOptionalArgs, $author$project$Model$RuntimeUsageData$selectionSet));
	});
var $author$project$Pages$OrgIndex$createModel = F5(
	function (session, key, host, signupSource, _v0) {
		var currentTimezone = _v0.a;
		var organization = _v0.b;
		var members = _v0.c;
		var now = _v0.d;
		var fetchRuntimeUsage = A2(
			$elm$core$Task$attempt,
			A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Pages$OrgIndex$UsageDataReceived),
			A5(
				$author$project$GraphQL$Utils$queryRequest,
				$author$project$Model$Session$getCreds(session),
				0,
				_List_Nil,
				'GetRuntimeUsage',
				A2($author$project$Request$Organization$runTimeUsage, now, organization.zw)));
		var fetchAllProjects = A2(
			$elm$core$Task$attempt,
			$author$project$Pages$OrgIndex$ProjectListArrived,
			A2(
				$author$project$Request$Project$getProjectsByOrgs,
				$author$project$Model$Session$getCreds(session),
				organization.zw));
		return _Utils_Tuple2(
			{
				tx: currentTimezone,
				t0: host,
				i9: $elm$core$Maybe$Nothing,
				Y: key,
				hB: members,
				mN: $author$project$Views$NotificationsInline$init,
				mU: A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$first,
					A2($author$project$Pages$OrgIndex$orgOverview, session, organization)),
				c3: organization,
				vO: '',
				gx: _List_Nil,
				pu: 0,
				js: $elm$core$Maybe$Nothing,
				pH: $krisajenkins$remotedata$RemoteData$NotAsked,
				si: false,
				iF: _List_Nil,
				nq: '',
				nr: '',
				pN: A2($elm$core$Maybe$withDefault, '', signupSource) === 'github',
				nx: 1,
				ny: 0,
				ky: false,
				nR: $elm$core$Dict$empty
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						fetchRuntimeUsage,
						fetchAllProjects,
						A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Cmd$none,
						A2(
							$elm$core$Maybe$map,
							$elm$core$Tuple$second,
							A2($author$project$Pages$OrgIndex$orgOverview, session, organization)))
					])));
	});
var $author$project$Pages$OrgPolicy$createModel = F2(
	function (_v0, _v1) {
		var loadedOrgBundle = _v1.a;
		var loadedMembers = _v1.b;
		var maybeOrgPolicy = _v1.c;
		var policies = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Model$Policy$Policies$default,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.cG;
				},
				maybeOrgPolicy));
		return {
			ls: $elm$core$Maybe$Nothing,
			iv: A2($author$project$Pages$OrgPolicy$mainPolicyEditorInit, loadedOrgBundle.gx, policies),
			hB: loadedMembers,
			hC: $elm$core$Maybe$Nothing,
			c3: loadedOrgBundle.c3,
			m2: policies,
			hc: maybeOrgPolicy,
			gx: loadedOrgBundle.gx,
			hN: false
		};
	});
var $author$project$Pages$OrgRemediation$BuildPlans = 0;
var $author$project$Pages$OrgRemediation$createModel = F2(
	function (_v0, _v1) {
		var organization = _v1.a.c3;
		var projects = _v1.a.gx;
		var members = _v1.b;
		var timestamp = _v1.c;
		var projectsAndCommits = $elm$core$List$filterMap(
			function (project) {
				return A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair(project),
					$author$project$Model$Branch$getCommitID(
						$author$project$Model$Project$getDefaultBranch(project)));
			});
		return {
			h_: $elm$core$Maybe$Nothing,
			qi: projectsAndCommits(projects),
			fI: $elm$core$Dict$empty,
			jI: $elm$core$Dict$empty,
			ug: $elm$core$Dict$empty,
			fC: 0,
			hB: members,
			c3: organization,
			pq: timestamp,
			ne: _List_Nil
		};
	});
var $author$project$Pages$OrgSecurity$Loading = {$: 0};
var $author$project$Pages$OrgSecurity$Severity = 0;
var $author$project$Pages$OrgSecurity$createModel = F2(
	function (_v0, _v1) {
		var loadedOrg = _v1.a;
		var loadedMembers = _v1.b;
		return {lo: $author$project$Pages$OrgSecurity$Loading, cT: $author$project$Pages$OrgSecurity$allFilters, lW: false, hB: loadedMembers, c3: loadedOrg, kt: '', sj: $elm$core$Maybe$Nothing, nx: 0, ny: $author$project$Pages$OrgSecurity$defaultSortDireciton};
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$getFirstLanguage = function (editor) {
	return $elm$core$List$head(
		$author$project$Model$BuildPlanner$SolveLegacyEditor$getAllLanguages(editor));
};
var $author$project$Model$BuildPlanner$BuildExprEditor$Simple$getSBOMs = function (editor) {
	var _v0 = $author$project$Model$BuildPlanner$BuildExprEditor$Simple$getMarkers(editor);
	if (_v0.$ === 5) {
		var genericSBOMFields = _v0.b;
		return _List_fromArray(
			[genericSBOMFields]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$getSBOMs = $author$project$Model$BuildPlanner$BuildExprEditor$Simple$getSBOMs;
var $author$project$Model$AvailableVersions$init = $elm$core$Dict$empty;
var $author$project$Model$PopularPackages$init = {hy: $elm$core$Dict$empty};
var $author$project$Views$CustomRequirementInput$init = {ht: $author$project$Views$CustomRequirementInput$initCustomRequirement, mE: _List_Nil};
var $author$project$Views$Dependencies$init = {nY: $elm$core$Dict$empty, lG: false};
var $author$project$Views$GenericSBOM$Component = 0;
var $author$project$Views$GenericSBOM$init = function (fields) {
	return {CF: fields, nq: '', nx: 0, ny: $author$project$Views$GenericSBOM$defaultSortDirection};
};
var $author$project$Views$PlanningErrorNotice$init = {ov: false};
var $author$project$Views$Timestamp$init = {o7: ''};
var $author$project$Views$BranchPicker$new = F3(
	function (org, project, maybeBranchName) {
		return A2(
			$elm$core$Maybe$map,
			function (tree) {
				return {
					Du: false,
					ix: org.AC,
					vT: $author$project$Model$Project$getName(project),
					fR: A2(
						$elm$core$Maybe$withDefault,
						$author$project$Model$Project$getDefaultBranch(project),
						A2(
							$elm$core$Maybe$andThen,
							$author$project$Model$Project$getBranchByName(project),
							maybeBranchName)),
					jA: tree
				};
			},
			$author$project$Model$BranchTree$fromBranches(
				$author$project$Model$Project$getBranches(project)));
	});
var $author$project$Pages$ProjectConfig$createModel = F6(
	function (key, environment, isNewProject, isFromCommit, focusOnAddPackages, _v0) {
		var platformTimestamp = _v0.a;
		var org = _v0.b;
		var project = _v0.c.c5;
		var maybeBranchName = _v0.c.fO;
		var commit = _v0.c.cM;
		var buildExpr = _v0.c.k$;
		var languages = _v0.d;
		var availablePlatforms = _v0.e;
		var maybebranchModel = A3($author$project$Views$BranchPicker$new, org, project, maybeBranchName);
		var editor = $author$project$Model$BuildPlanner$SolveLegacyEditor$fromBuildExprWithFallback(buildExpr);
		var genericSBOMs = A2(
			$elm_community$dict_extra$Dict$Extra$fromListBy,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.CF;
				},
				function ($) {
					return $.w;
				}),
			A2(
				$elm$core$List$map,
				$author$project$Views$GenericSBOM$init,
				$author$project$Model$BuildPlanner$SolveLegacyEditor$getSBOMs(editor)));
		var currentLanguage = $author$project$Model$BuildPlanner$SolveLegacyEditor$getFirstLanguage(editor);
		return {
			qb: $elm$core$Dict$empty,
			iM: A2($author$project$Views$AddPackagesModal$init, currentLanguage, editor),
			jF: languages,
			n4: availablePlatforms,
			xj: $author$project$Model$AvailableVersions$init,
			fJ: maybebranchModel,
			kZ: $elm$core$Maybe$Nothing,
			iQ: $author$project$Model$Editor$init($elm$core$Dict$empty),
			iS: $krisajenkins$remotedata$RemoteData$NotAsked,
			hq: '',
			oi: $author$project$Model$CopyStatus$empty,
			ok: buildExpr,
			f0: commit,
			on: $author$project$Views$CustomRequirementInput$init,
			x$: $author$project$Views$NamespaceExpand$init,
			qO: $author$project$Views$Dependencies$init,
			qR: editor,
			ot: environment,
			Cu: $krisajenkins$remotedata$RemoteData$NotAsked,
			yo: focusOnAddPackages,
			oE: genericSBOMs,
			j_: $krisajenkins$remotedata$RemoteData$NotAsked,
			oJ: $author$project$Views$ImportPackagesModal$init(editor),
			rf: false,
			yJ: isFromCommit,
			mk: $elm$core$Dict$empty,
			uk: isNewProject,
			ul: false,
			oP: false,
			Y: key,
			oX: $author$project$Views$LanguageSelectionModal$init(editor),
			rn: $author$project$Views$Licenses$init,
			Ep: $krisajenkins$remotedata$RemoteData$NotAsked,
			rF: $author$project$Model$NormsAndVulns$init,
			c3: org,
			rO: $author$project$Views$PackageSummaryDisplay$init,
			hb: $elm$core$Dict$empty,
			rQ: $author$project$Views$NamespaceExpand$init,
			pp: A2($author$project$Views$PlatformSelectionModal$init, availablePlatforms, editor),
			pq: platformTimestamp,
			m6: $author$project$Model$PopularPackages$init,
			c5: project,
			kq: false,
			hQ: false,
			sl: false,
			ss: $author$project$Views$PlanningErrorNotice$init,
			iK: $author$project$Model$AtTime$Standard,
			hX: $author$project$Views$Timestamp$init,
			AA: $author$project$Model$BuildPlanner$SolveLegacyEditor$getUnsupportedReason(buildExpr),
			kE: $elm$core$Maybe$Nothing,
			hj: $author$project$Pages$ProjectConfig$None
		};
	});
var $author$project$Pages$ProjectConfigAdvanced$createModel = F2(
	function (key, _v0) {
		var platformTimestamp = _v0.a;
		var org = _v0.b;
		var project = _v0.c.c5;
		var maybeBranchName = _v0.c.fO;
		var commit = _v0.c.cM;
		var buildExpr = _v0.c.k$;
		var availablePlatforms = _v0.d;
		return {
			n4: availablePlatforms,
			fJ: A3($author$project$Views$BranchPicker$new, org, project, maybeBranchName),
			iR: $author$project$Pages$ProjectConfigAdvanced$toBuildExprText(buildExpr),
			k0: $author$project$Pages$ProjectConfigAdvanced$NotValidated,
			k9: '',
			ok: buildExpr,
			f0: commit,
			Y: key,
			c3: org,
			pq: platformTimestamp,
			c5: project,
			kq: false,
			iA: $krisajenkins$remotedata$RemoteData$NotAsked,
			iL: ''
		};
	});
var $author$project$Pages$ProjectDownloads$createModel = F4(
	function (session, key, _v0, _v1) {
		var maybePlatformID = _v0.Ef;
		var maybeBranchName = _v0.fO;
		var isNewProject = _v0.uk;
		var buildLogSocket = _v0.jH;
		var currentTime = _v1.a;
		var org = _v1.b;
		var project = _v1.c.c5;
		var commit = _v1.c.cM;
		var languages = _v1.d;
		var platforms = _v1.e;
		var workingBranch = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Model$Project$getDefaultBranch(project),
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Model$Project$getBranchByName(project),
				maybeBranchName));
		var maybebranchModel = A3($author$project$Views$BranchPicker$new, org, project, maybeBranchName);
		return {
			jF: A2($elm_community$dict_extra$Dict$Extra$fromListBy, $author$project$Model$LanguageVersions$getId, languages),
			n4: platforms,
			h4: workingBranch,
			fJ: maybebranchModel,
			n6: $krisajenkins$remotedata$RemoteData$NotAsked,
			jH: buildLogSocket,
			qs: $elm$core$Dict$empty,
			oi: $author$project$Model$CopyStatus$empty,
			f0: commit,
			hs: $elm$core$Maybe$Nothing,
			cF: currentTime,
			j1: 0,
			uk: isNewProject,
			ul: false,
			Y: key,
			j3: $author$project$Pages$ProjectDownloads$KickIdle,
			c3: org,
			iz: $elm$core$Dict$empty,
			ff: $elm$core$Dict$empty,
			kn: $elm$core$Maybe$Nothing,
			c5: project,
			kq: false,
			fE: maybePlatformID,
			gS: $author$project$Model$Session$getUser(session)
		};
	});
var $author$project$Pages$ProjectHistory$createModel = F2(
	function (key, _v0) {
		var currentTimezone = _v0.a;
		var org = _v0.b;
		var project = _v0.c.c5;
		var maybeBranchName = _v0.c.fO;
		var commit = _v0.c.cM;
		var history = _v0.c.q9;
		var platforms = _v0.d;
		var currentBranch = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Model$Project$getDefaultBranch(project),
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Model$Project$getBranchByName(project),
				maybeBranchName));
		var maybebranchModel = A3(
			$author$project$Views$BranchPicker$new,
			org,
			project,
			$elm$core$Maybe$Just(
				$author$project$Model$Branch$getName(currentBranch)));
		return {
			fJ: maybebranchModel,
			BS: history.BS,
			oi: $author$project$Model$CopyStatus$empty,
			lm: currentBranch,
			f0: commit,
			jK: 1,
			tx: currentTimezone,
			Y: key,
			mN: $author$project$Views$NotificationsInline$init,
			c3: org,
			ph: '',
			iy: false,
			Fh: platforms,
			c5: project,
			kq: false,
			pF: $elm$core$Maybe$Nothing,
			ju: $elm$core$Maybe$Nothing,
			iB: $author$project$Uuid$Dict$empty,
			iC: $author$project$Uuid$Dict$empty,
			pY: $author$project$Pages$ProjectHistory$totalCommitsToPages(history.GJ),
			p7: $elm$core$Maybe$Nothing
		};
	});
var $author$project$Pages$ProjectImpactReport$BothError = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$ProjectImpactReport$NewError = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$ProjectImpactReport$OldError = function (a) {
	return {$: 0, a: a};
};
var $author$project$Request$BuildPlanner$VcsRef = function (a) {
	return {$: 2, a: a};
};
var $folkertdev$elm_flate$Inflate$BitReader$decode = F2(
	function (bytes, _v0) {
		var reader = _v0;
		var initialState = {ds: 0, fK: bytes, fy: 0, eH: 0, wB: 0};
		var _v1 = reader(initialState);
		if (!_v1.$) {
			var _v2 = _v1.a;
			var value = _v2.a;
			return $elm$core$Result$Ok(value);
		} else {
			var e = _v1.a;
			return $elm$core$Result$Err(e);
		}
	});
var $folkertdev$elm_flate$Inflate$BitReader$BitReader = $elm$core$Basics$identity;
var $folkertdev$elm_flate$Inflate$BitReader$loopHelp = F3(
	function (accum, callback, state) {
		loopHelp:
		while (true) {
			var _v0 = callback(accum);
			var decoder = _v0;
			var _v1 = decoder(state);
			if (_v1.$ === 1) {
				var e = _v1.a;
				return $elm$core$Result$Err(e);
			} else {
				if (!_v1.a.a.$) {
					var _v2 = _v1.a;
					var newAccum = _v2.a.a;
					var newState = _v2.b;
					var $temp$accum = newAccum,
						$temp$callback = callback,
						$temp$state = newState;
					accum = $temp$accum;
					callback = $temp$callback;
					state = $temp$state;
					continue loopHelp;
				} else {
					var _v3 = _v1.a;
					var result = _v3.a.a;
					var newState = _v3.b;
					return $elm$core$Result$Ok(
						_Utils_Tuple2(result, newState));
				}
			}
		}
	});
var $folkertdev$elm_flate$Inflate$BitReader$loop = F2(
	function (state, callback) {
		return A2($folkertdev$elm_flate$Inflate$BitReader$loopHelp, state, callback);
	});
var $folkertdev$elm_flate$Inflate$BitReader$map = F2(
	function (f, _v0) {
		var g = _v0;
		return function (s) {
			var _v1 = g(s);
			if (!_v1.$) {
				var _v2 = _v1.a;
				var value = _v2.a;
				var newState = _v2.b;
				return $elm$core$Result$Ok(
					_Utils_Tuple2(
						f(value),
						newState));
			} else {
				var e = _v1.a;
				return $elm$core$Result$Err(e);
			}
		};
	});
var $folkertdev$elm_flate$Experimental$ByteArray$toBytes = function (_v0) {
	var array = _v0.a;
	var finalSize = _v0.b;
	var finalBytes = _v0.c;
	var initial = function () {
		var finalInt32 = finalBytes >>> ((4 - finalSize) * 8);
		switch (finalSize) {
			case 4:
				return _List_fromArray(
					[
						A2($elm$bytes$Bytes$Encode$unsignedInt32, 1, finalBytes)
					]);
			case 1:
				return _List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(finalInt32)
					]);
			case 2:
				return _List_fromArray(
					[
						A2($elm$bytes$Bytes$Encode$unsignedInt16, 1, finalInt32)
					]);
			case 3:
				return _List_fromArray(
					[
						A2($elm$bytes$Bytes$Encode$unsignedInt16, 1, finalInt32 >> 8),
						$elm$bytes$Bytes$Encode$unsignedInt8(255 & finalInt32)
					]);
			default:
				return _List_Nil;
		}
	}();
	var folder = F2(
		function (element, accum) {
			return A2(
				$elm$core$List$cons,
				A2($elm$bytes$Bytes$Encode$unsignedInt32, 1, element),
				accum);
		});
	return $elm$bytes$Bytes$Encode$encode(
		$elm$bytes$Bytes$Encode$sequence(
			A3($elm$core$Array$foldr, folder, initial, array)));
};
var $folkertdev$elm_flate$Inflate$BitReader$andThen = F2(
	function (f, _v0) {
		var g = _v0;
		return function (s) {
			var _v1 = g(s);
			if (!_v1.$) {
				var _v2 = _v1.a;
				var value = _v2.a;
				var newState = _v2.b;
				var _v3 = f(value);
				var h = _v3;
				return h(newState);
			} else {
				var e = _v1.a;
				return $elm$core$Result$Err(e);
			}
		};
	});
var $folkertdev$elm_flate$Experimental$ByteArray$push = F2(
	function (value, input) {
		var array = input.a;
		var finalSize = input.b;
		var finalBytes = input.c;
		if (finalSize === 4) {
			return A3(
				$folkertdev$elm_flate$Experimental$ByteArray$ByteArray,
				A2($elm$core$Array$push, finalBytes, array),
				1,
				value << 24);
		} else {
			if (!finalSize) {
				return A3($folkertdev$elm_flate$Experimental$ByteArray$ByteArray, array, 1, value << 24);
			} else {
				var offset = finalSize;
				var internalIndex = $elm$core$Array$length(array) - 1;
				var _new = ((255 & value) << ((3 - offset) * 8)) | finalBytes;
				var mask = 4278190080 >>> (offset * 8);
				return A3($folkertdev$elm_flate$Experimental$ByteArray$ByteArray, array, finalSize + 1, _new);
			}
		}
	});
var $folkertdev$elm_flate$Experimental$ByteArray$pushMany = F3(
	function (nbytes, value_, input) {
		var array = input.a;
		var finalSize = input.b;
		var finalBytes = input.c;
		var value = (nbytes === 4) ? value_ : (((1 << (nbytes * 8)) - 1) & value_);
		if (!nbytes) {
			return input;
		} else {
			if (finalSize === 4) {
				return A3(
					$folkertdev$elm_flate$Experimental$ByteArray$ByteArray,
					A2($elm$core$Array$push, finalBytes, array),
					nbytes,
					value << ((4 - nbytes) * 8));
			} else {
				if (!finalSize) {
					return A3($folkertdev$elm_flate$Experimental$ByteArray$ByteArray, array, nbytes, value << ((4 - nbytes) * 8));
				} else {
					var freeSpace = 4 - finalSize;
					if (_Utils_cmp(nbytes, freeSpace) > 0) {
						var bytesLeftOver = (finalSize + nbytes) - 4;
						var forFinal = value >>> (bytesLeftOver * 8);
						var newFinal = finalBytes | forFinal;
						var amount = ((8 - finalSize) - nbytes) * 8;
						var forNextFinal = (((1 << (bytesLeftOver * 8)) - 1) & value) << amount;
						return A3(
							$folkertdev$elm_flate$Experimental$ByteArray$ByteArray,
							A2($elm$core$Array$push, newFinal, array),
							nbytes - freeSpace,
							forNextFinal);
					} else {
						var amount = (4 - (finalSize + nbytes)) * 8;
						var forFinal = value << amount;
						var newFinal = finalBytes | forFinal;
						return A3($folkertdev$elm_flate$Experimental$ByteArray$ByteArray, array, finalSize + nbytes, newFinal);
					}
				}
			}
		}
	});
var $folkertdev$elm_flate$Experimental$ByteArray$appendBytesHelp = function (_v0) {
	var remaining = _v0.a;
	var bytearray = _v0.b;
	var array = bytearray.a;
	var finalSize = bytearray.b;
	var finalBytes = bytearray.c;
	return (remaining >= 4) ? A2(
		$elm$bytes$Bytes$Decode$map,
		function (_new) {
			return $elm$bytes$Bytes$Decode$Loop(
				_Utils_Tuple2(
					remaining - 4,
					A3($folkertdev$elm_flate$Experimental$ByteArray$pushMany, 4, _new, bytearray)));
		},
		$elm$bytes$Bytes$Decode$unsignedInt32(1)) : ((remaining >= 1) ? A2(
		$elm$bytes$Bytes$Decode$map,
		function (_new) {
			return $elm$bytes$Bytes$Decode$Loop(
				_Utils_Tuple2(
					remaining - 1,
					A2($folkertdev$elm_flate$Experimental$ByteArray$push, _new, bytearray)));
		},
		$elm$bytes$Bytes$Decode$unsignedInt8) : $elm$bytes$Bytes$Decode$succeed(
		$elm$bytes$Bytes$Decode$Done(bytearray)));
};
var $folkertdev$elm_flate$Experimental$ByteArray$appendBytes = F2(
	function (bytes, barray) {
		var array = barray.a;
		var finalSize = barray.b;
		var finalBytes = barray.c;
		var decoder = A2(
			$elm$bytes$Bytes$Decode$loop,
			_Utils_Tuple2(
				$elm$bytes$Bytes$width(bytes),
				barray),
			$folkertdev$elm_flate$Experimental$ByteArray$appendBytesHelp);
		var _v0 = A2($elm$bytes$Bytes$Decode$decode, decoder, bytes);
		if (!_v0.$) {
			var v = _v0.a;
			return v;
		} else {
			return barray;
		}
	});
var $folkertdev$elm_flate$Inflate$Internal$buildTree = F3(
	function (lengths, offset, num) {
		var tableDict = function () {
			var updater = function (maybeValue) {
				if (maybeValue.$ === 1) {
					return $elm$core$Maybe$Just(1);
				} else {
					var v = maybeValue.a;
					return $elm$core$Maybe$Just(v + 1);
				}
			};
			var folder = F3(
				function (key, value, accum) {
					return ((_Utils_cmp(key, offset) > -1) && (_Utils_cmp(key, num + offset) < 0)) ? A3($elm$core$Dict$update, value, updater, accum) : accum;
				});
			return A3($elm$core$Dict$foldl, folder, $elm$core$Dict$empty, lengths);
		}();
		var offsetsDict = A3(
			$elm$core$Dict$foldl,
			F3(
				function (key, value, _v4) {
					var sum = _v4.a;
					var dict = _v4.b;
					return _Utils_Tuple2(
						sum + value,
						A3($elm$core$Dict$insert, key, sum, dict));
				}),
			_Utils_Tuple2(0, $elm$core$Dict$empty),
			tableDict);
		var newTable = function () {
			var helper = F4(
				function (key, value, i, array) {
					helper:
					while (true) {
						if (_Utils_cmp(i, key) > 0) {
							var $temp$key = key,
								$temp$value = value,
								$temp$i = i - 1,
								$temp$array = A2($elm$core$List$cons, 0, array);
							key = $temp$key;
							value = $temp$value;
							i = $temp$i;
							array = $temp$array;
							continue helper;
						} else {
							return A2($elm$core$List$cons, value, array);
						}
					}
				});
			var foldHelp = F3(
				function (key, value, _v3) {
					var i = _v3.a;
					var array = _v3.b;
					return _Utils_Tuple2(
						key - 1,
						A4(helper, key, value, i, array));
				});
			var anotherGo = F2(
				function (i, array) {
					anotherGo:
					while (true) {
						if (i >= 0) {
							var $temp$i = i - 1,
								$temp$array = A2($elm$core$List$cons, 0, array);
							i = $temp$i;
							array = $temp$array;
							continue anotherGo;
						} else {
							return array;
						}
					}
				});
			return function (_v2) {
				var a = _v2.a;
				var b = _v2.b;
				return A2(anotherGo, a, b);
			}(
				A3(
					$elm$core$Dict$foldr,
					foldHelp,
					_Utils_Tuple2(15, _List_Nil),
					tableDict));
		}();
		var go2 = F3(
			function (i, currentTranslation, currentOffsets) {
				go2:
				while (true) {
					if ((i - num) < 0) {
						var _v0 = A2($elm$core$Dict$get, offset + i, lengths);
						if (_v0.$ === 1) {
							var $temp$i = i + 1,
								$temp$currentTranslation = currentTranslation,
								$temp$currentOffsets = currentOffsets;
							i = $temp$i;
							currentTranslation = $temp$currentTranslation;
							currentOffsets = $temp$currentOffsets;
							continue go2;
						} else {
							var v = _v0.a;
							if (!(!v)) {
								var _v1 = A2($elm$core$Dict$get, v, currentOffsets);
								if (_v1.$ === 1) {
									return currentTranslation;
								} else {
									var w = _v1.a;
									var $temp$i = i + 1,
										$temp$currentTranslation = A3($elm$core$Array$set, w, i, currentTranslation),
										$temp$currentOffsets = A3($elm$core$Dict$insert, v, w + 1, currentOffsets);
									i = $temp$i;
									currentTranslation = $temp$currentTranslation;
									currentOffsets = $temp$currentOffsets;
									continue go2;
								}
							} else {
								var $temp$i = i + 1,
									$temp$currentTranslation = currentTranslation,
									$temp$currentOffsets = currentOffsets;
								i = $temp$i;
								currentTranslation = $temp$currentTranslation;
								currentOffsets = $temp$currentOffsets;
								continue go2;
							}
						}
					} else {
						return currentTranslation;
					}
				}
			});
		var translation2 = A3(
			go2,
			0,
			A2($elm$core$Array$repeat, num, 0),
			offsetsDict.b);
		return {ww: newTable, pZ: translation2};
	});
var $folkertdev$elm_flate$Inflate$Internal$clcIndices = _List_fromArray(
	[16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
var $folkertdev$elm_flate$Inflate$BitSet$BitSet320 = function (a) {
	return function (b) {
		return function (c) {
			return function (d) {
				return function (e) {
					return function (f) {
						return function (g) {
							return function (h) {
								return function (i) {
									return function (j) {
										return {$: 0, a: a, b: b, c: c, d: d, e: e, f: f, g: g, h: h, i: i, j: j};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $folkertdev$elm_flate$Inflate$BitSet$insert = F2(
	function (n, input) {
		var b1 = input.a;
		var b2 = input.b;
		var b3 = input.c;
		var b4 = input.d;
		var b5 = input.e;
		var b6 = input.f;
		var b7 = input.g;
		var b8 = input.h;
		var b9 = input.i;
		var b10 = input.j;
		if (n >= 320) {
			return input;
		} else {
			var bit = 1 << (n % 32);
			var _v0 = (n / 32) | 0;
			switch (_v0) {
				case 0:
					return $folkertdev$elm_flate$Inflate$BitSet$BitSet320(bit | b1)(b2)(b3)(b4)(b5)(b6)(b7)(b8)(b9)(b10);
				case 1:
					return $folkertdev$elm_flate$Inflate$BitSet$BitSet320(b1)(bit | b2)(b3)(b4)(b5)(b6)(b7)(b8)(b9)(b10);
				case 2:
					return $folkertdev$elm_flate$Inflate$BitSet$BitSet320(b1)(b2)(bit | b3)(b4)(b5)(b6)(b7)(b8)(b9)(b10);
				case 3:
					return $folkertdev$elm_flate$Inflate$BitSet$BitSet320(b1)(b2)(b3)(bit | b4)(b5)(b6)(b7)(b8)(b9)(b10);
				case 4:
					return $folkertdev$elm_flate$Inflate$BitSet$BitSet320(b1)(b2)(b3)(b4)(bit | b5)(b6)(b7)(b8)(b9)(b10);
				case 5:
					return $folkertdev$elm_flate$Inflate$BitSet$BitSet320(b1)(b2)(b3)(b4)(b5)(bit | b6)(b7)(b8)(b9)(b10);
				case 6:
					return $folkertdev$elm_flate$Inflate$BitSet$BitSet320(b1)(b2)(b3)(b4)(b5)(b6)(bit | b7)(b8)(b9)(b10);
				case 7:
					return $folkertdev$elm_flate$Inflate$BitSet$BitSet320(b1)(b2)(b3)(b4)(b5)(b6)(b7)(bit | b8)(b9)(b10);
				case 8:
					return $folkertdev$elm_flate$Inflate$BitSet$BitSet320(b1)(b2)(b3)(b4)(b5)(b6)(b7)(b8)(bit | b9)(b10);
				case 9:
					return $folkertdev$elm_flate$Inflate$BitSet$BitSet320(b1)(b2)(b3)(b4)(b5)(b6)(b7)(b8)(b9)(bit | b10);
				default:
					return input;
			}
		}
	});
var $folkertdev$elm_flate$Inflate$BitSet$member = F2(
	function (n, input) {
		var b1 = input.a;
		var b2 = input.b;
		var b3 = input.c;
		var b4 = input.d;
		var b5 = input.e;
		var b6 = input.f;
		var b7 = input.g;
		var b8 = input.h;
		var b9 = input.i;
		var b10 = input.j;
		if (n >= 320) {
			return false;
		} else {
			var bit = 1 << (n % 32);
			var _v0 = (n / 32) | 0;
			switch (_v0) {
				case 0:
					return (bit & b1) > 0;
				case 1:
					return (bit & b2) > 0;
				case 2:
					return (bit & b3) > 0;
				case 3:
					return (bit & b4) > 0;
				case 4:
					return (bit & b5) > 0;
				case 5:
					return (bit & b6) > 0;
				case 6:
					return (bit & b7) > 0;
				case 7:
					return (bit & b8) > 0;
				case 8:
					return (bit & b9) > 0;
				case 9:
					return (bit & b10) > 0;
				default:
					return false;
			}
		}
	});
var $folkertdev$elm_flate$Inflate$BitSet$remove = F2(
	function (n, input) {
		var b1 = input.a;
		var b2 = input.b;
		var b3 = input.c;
		var b4 = input.d;
		var b5 = input.e;
		var b6 = input.f;
		var b7 = input.g;
		var b8 = input.h;
		var b9 = input.i;
		var b10 = input.j;
		if (n >= 320) {
			return input;
		} else {
			var bit = ~(1 << (n % 32));
			var _v0 = (n / 32) | 0;
			switch (_v0) {
				case 0:
					return $folkertdev$elm_flate$Inflate$BitSet$BitSet320(bit & b1)(b2)(b3)(b4)(b5)(b6)(b7)(b8)(b9)(b10);
				case 1:
					return $folkertdev$elm_flate$Inflate$BitSet$BitSet320(b1)(bit & b2)(b3)(b4)(b5)(b6)(b7)(b8)(b9)(b10);
				case 2:
					return $folkertdev$elm_flate$Inflate$BitSet$BitSet320(b1)(b2)(bit & b3)(b4)(b5)(b6)(b7)(b8)(b9)(b10);
				case 3:
					return $folkertdev$elm_flate$Inflate$BitSet$BitSet320(b1)(b2)(b3)(bit & b4)(b5)(b6)(b7)(b8)(b9)(b10);
				case 4:
					return $folkertdev$elm_flate$Inflate$BitSet$BitSet320(b1)(b2)(b3)(b4)(bit & b5)(b6)(b7)(b8)(b9)(b10);
				case 5:
					return $folkertdev$elm_flate$Inflate$BitSet$BitSet320(b1)(b2)(b3)(b4)(b5)(bit & b6)(b7)(b8)(b9)(b10);
				case 6:
					return $folkertdev$elm_flate$Inflate$BitSet$BitSet320(b1)(b2)(b3)(b4)(b5)(b6)(bit & b7)(b8)(b9)(b10);
				case 7:
					return $folkertdev$elm_flate$Inflate$BitSet$BitSet320(b1)(b2)(b3)(b4)(b5)(b6)(b7)(bit & b8)(b9)(b10);
				case 8:
					return $folkertdev$elm_flate$Inflate$BitSet$BitSet320(b1)(b2)(b3)(b4)(b5)(b6)(b7)(b8)(bit & b9)(b10);
				case 9:
					return $folkertdev$elm_flate$Inflate$BitSet$BitSet320(b1)(b2)(b3)(b4)(b5)(b6)(b7)(b8)(b9)(bit & b10);
				default:
					return input;
			}
		}
	});
var $folkertdev$elm_flate$Inflate$Internal$copySegment = F5(
	function (i, value, bitset, lengths, length) {
		var end = i + length;
		var go = F3(
			function (j, currentBitSet, accum) {
				go:
				while (true) {
					if ((j - end) < 0) {
						if (!(!value)) {
							var $temp$j = j + 1,
								$temp$currentBitSet = A2($folkertdev$elm_flate$Inflate$BitSet$insert, j, currentBitSet),
								$temp$accum = A3($elm$core$Dict$insert, j, value, accum);
							j = $temp$j;
							currentBitSet = $temp$currentBitSet;
							accum = $temp$accum;
							continue go;
						} else {
							if (A2($folkertdev$elm_flate$Inflate$BitSet$member, j, currentBitSet)) {
								var $temp$j = j + 1,
									$temp$currentBitSet = A2($folkertdev$elm_flate$Inflate$BitSet$remove, j, currentBitSet),
									$temp$accum = A2($elm$core$Dict$remove, j, accum);
								j = $temp$j;
								currentBitSet = $temp$currentBitSet;
								accum = $temp$accum;
								continue go;
							} else {
								var $temp$j = j + 1,
									$temp$currentBitSet = currentBitSet,
									$temp$accum = accum;
								j = $temp$j;
								currentBitSet = $temp$currentBitSet;
								accum = $temp$accum;
								continue go;
							}
						}
					} else {
						return _Utils_Tuple2(currentBitSet, accum);
					}
				}
			});
		var _v0 = A3(go, i, bitset, lengths);
		var newBitSet = _v0.a;
		var newLengths = _v0.b;
		return _Utils_Tuple3(i + length, newBitSet, newLengths);
	});
var $folkertdev$elm_flate$Inflate$Internal$decodeSymbolInnerLoop = F5(
	function (table, cur, tag, bitsAvailable, sum) {
		decodeSymbolInnerLoop:
		while (true) {
			var newTag = tag >>> 1;
			if (!table.b) {
				return {ds: bitsAvailable, tv: cur, gO: sum, wB: tag};
			} else {
				var value = table.a;
				var rest = table.b;
				var newerCur = ((cur << 1) + (tag & 1)) - value;
				var newSum = sum + value;
				if (newerCur >= 0) {
					var $temp$table = rest,
						$temp$cur = newerCur,
						$temp$tag = newTag,
						$temp$bitsAvailable = bitsAvailable - 1,
						$temp$sum = newSum;
					table = $temp$table;
					cur = $temp$cur;
					tag = $temp$tag;
					bitsAvailable = $temp$bitsAvailable;
					sum = $temp$sum;
					continue decodeSymbolInnerLoop;
				} else {
					return {ds: bitsAvailable - 1, tv: newerCur, gO: newSum, wB: newTag};
				}
			}
		}
	});
var $folkertdev$elm_flate$Inflate$BitReader$moveFromReserve = F2(
	function (nbits, state) {
		var masked = (nbits === 32) ? (state.fy << state.ds) : ((((1 << nbits) - 1) & state.fy) << state.ds);
		return {ds: state.ds + nbits, fK: state.fK, fy: state.fy >>> nbits, eH: state.eH - nbits, wB: masked | state.wB};
	});
var $folkertdev$elm_flate$Inflate$BitReader$runDecoder = F3(
	function (width, valueDecoder, state) {
		var decoder = A3(
			$elm$bytes$Bytes$Decode$map2,
			$elm$core$Tuple$pair,
			valueDecoder,
			$elm$bytes$Bytes$Decode$bytes(
				$elm$bytes$Bytes$width(state.fK) - width));
		var _v0 = A2($elm$bytes$Bytes$Decode$decode, decoder, state.fK);
		if (!_v0.$) {
			var value = _v0.a;
			return $elm$core$Result$Ok(value);
		} else {
			return $elm$core$Result$Err('BitReader.runDecoder: Unexpected end of Bytes');
		}
	});
var $folkertdev$elm_flate$Inflate$BitReader$unsignedInt24 = function (endianness) {
	if (!endianness) {
		return A3(
			$elm$bytes$Bytes$Decode$map2,
			F2(
				function (b2, b1) {
					return (b1 << 16) | b2;
				}),
			$elm$bytes$Bytes$Decode$unsignedInt16(endianness),
			$elm$bytes$Bytes$Decode$unsignedInt8);
	} else {
		return A3(
			$elm$bytes$Bytes$Decode$map2,
			F2(
				function (b1, b2) {
					return (b1 << 16) | b2;
				}),
			$elm$bytes$Bytes$Decode$unsignedInt16(endianness),
			$elm$bytes$Bytes$Decode$unsignedInt8);
	}
};
var $folkertdev$elm_flate$Inflate$BitReader$readMoreBits = function (state) {
	readMoreBits:
	while (true) {
		var freeSpaceOnTag = 32 - state.ds;
		if ((_Utils_cmp(freeSpaceOnTag, state.eH) < 1) && (state.eH > 0)) {
			return $elm$core$Result$Ok(
				A2($folkertdev$elm_flate$Inflate$BitReader$moveFromReserve, freeSpaceOnTag, state));
		} else {
			if (!$elm$bytes$Bytes$width(state.fK)) {
				return $elm$core$Result$Ok(
					A2($folkertdev$elm_flate$Inflate$BitReader$moveFromReserve, state.eH, state));
			} else {
				var state1 = A2($folkertdev$elm_flate$Inflate$BitReader$moveFromReserve, state.eH, state);
				var _v0 = function () {
					var _v1 = $elm$bytes$Bytes$width(state.fK);
					switch (_v1) {
						case 0:
							return _Utils_Tuple3(
								0,
								0,
								$elm$bytes$Bytes$Decode$succeed(0));
						case 1:
							return _Utils_Tuple3(1, 8, $elm$bytes$Bytes$Decode$unsignedInt8);
						case 2:
							return _Utils_Tuple3(
								2,
								16,
								$elm$bytes$Bytes$Decode$unsignedInt16(0));
						case 3:
							return _Utils_Tuple3(
								3,
								24,
								$folkertdev$elm_flate$Inflate$BitReader$unsignedInt24(0));
						default:
							return _Utils_Tuple3(
								4,
								32,
								$elm$bytes$Bytes$Decode$unsignedInt32(0));
					}
				}();
				var width = _v0.a;
				var additionallyAvailable = _v0.b;
				var decoder = _v0.c;
				var _v2 = A3($folkertdev$elm_flate$Inflate$BitReader$runDecoder, width, decoder, state1);
				if (_v2.$ === 1) {
					var e = _v2.a;
					return $elm$core$Result$Err(e);
				} else {
					var _v3 = _v2.a;
					var newReserve = _v3.a;
					var newBuffer = _v3.b;
					var $temp$state = {ds: state1.ds, fK: newBuffer, fy: newReserve, eH: additionallyAvailable, wB: state1.wB};
					state = $temp$state;
					continue readMoreBits;
				}
			}
		}
	}
};
var $folkertdev$elm_flate$Inflate$Internal$decodeSymbol = F2(
	function (table, tree) {
		return function (state) {
			var _v0 = (state.ds < 16) ? $folkertdev$elm_flate$Inflate$BitReader$readMoreBits(state) : $elm$core$Result$Ok(state);
			if (_v0.$ === 1) {
				var e = _v0.a;
				return $elm$core$Result$Err(e);
			} else {
				var d = _v0.a;
				var _v1 = A5($folkertdev$elm_flate$Inflate$Internal$decodeSymbolInnerLoop, table, 0, d.wB, d.ds, 0);
				var cur = _v1.tv;
				var tag = _v1.wB;
				var bitsAvailable = _v1.ds;
				var sum = _v1.gO;
				var _v2 = A2($elm$core$Array$get, sum + cur, tree.pZ);
				if (_v2.$ === 1) {
					return $elm$core$Result$Err('Index into trans tree out of bounds');
				} else {
					var result = _v2.a;
					return $elm$core$Result$Ok(
						_Utils_Tuple2(
							result,
							{ds: bitsAvailable, fK: d.fK, fy: d.fy, eH: d.eH, wB: tag}));
				}
			}
		};
	});
var $folkertdev$elm_flate$Inflate$BitReader$readBits = F2(
	function (numberOfBits, base) {
		return function (state) {
			if (!numberOfBits) {
				return $elm$core$Result$Ok(
					_Utils_Tuple2(base, state));
			} else {
				var _v0 = (_Utils_cmp(state.ds, numberOfBits) < 0) ? $folkertdev$elm_flate$Inflate$BitReader$readMoreBits(state) : $elm$core$Result$Ok(state);
				if (_v0.$ === 1) {
					var e = _v0.a;
					return $elm$core$Result$Err(e);
				} else {
					var d = _v0.a;
					var val = d.wB & (65535 >>> (16 - numberOfBits));
					var newTag = d.wB >>> numberOfBits;
					return $elm$core$Result$Ok(
						_Utils_Tuple2(
							val + base,
							{ds: d.ds - numberOfBits, fK: d.fK, fy: d.fy, eH: d.eH, wB: newTag}));
				}
			}
		};
	});
var $folkertdev$elm_flate$Inflate$BitReader$succeed = function (x) {
	return function (s) {
		return $elm$core$Result$Ok(
			_Utils_Tuple2(x, s));
	};
};
var $folkertdev$elm_flate$Inflate$Internal$decodeDynamicTreeLength = F4(
	function (codeTree, hlit, hdist, _v0) {
		var i = _v0.a;
		var bitset = _v0.b;
		var lengths = _v0.c;
		if (_Utils_cmp(i, hlit + hdist) < 0) {
			var table = A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$elm$core$List$tail(codeTree.ww));
			return A2(
				$folkertdev$elm_flate$Inflate$BitReader$andThen,
				function (sym) {
					switch (sym) {
						case 16:
							var prev = A2(
								$elm$core$Maybe$withDefault,
								0,
								A2($elm$core$Dict$get, i - 1, lengths));
							return A2(
								$folkertdev$elm_flate$Inflate$BitReader$map,
								A2(
									$elm$core$Basics$composeR,
									A4($folkertdev$elm_flate$Inflate$Internal$copySegment, i, prev, bitset, lengths),
									$elm$bytes$Bytes$Decode$Loop),
								A2($folkertdev$elm_flate$Inflate$BitReader$readBits, 2, 3));
						case 17:
							return A2(
								$folkertdev$elm_flate$Inflate$BitReader$map,
								A2(
									$elm$core$Basics$composeR,
									A4($folkertdev$elm_flate$Inflate$Internal$copySegment, i, 0, bitset, lengths),
									$elm$bytes$Bytes$Decode$Loop),
								A2($folkertdev$elm_flate$Inflate$BitReader$readBits, 3, 3));
						case 18:
							return A2(
								$folkertdev$elm_flate$Inflate$BitReader$map,
								A2(
									$elm$core$Basics$composeR,
									A4($folkertdev$elm_flate$Inflate$Internal$copySegment, i, 0, bitset, lengths),
									$elm$bytes$Bytes$Decode$Loop),
								A2($folkertdev$elm_flate$Inflate$BitReader$readBits, 7, 11));
						case 0:
							return A2($folkertdev$elm_flate$Inflate$BitSet$member, i, bitset) ? $folkertdev$elm_flate$Inflate$BitReader$succeed(
								$elm$bytes$Bytes$Decode$Loop(
									_Utils_Tuple3(
										i + 1,
										bitset,
										A2($elm$core$Dict$remove, i, lengths)))) : $folkertdev$elm_flate$Inflate$BitReader$succeed(
								$elm$bytes$Bytes$Decode$Loop(
									_Utils_Tuple3(i + 1, bitset, lengths)));
						default:
							return $folkertdev$elm_flate$Inflate$BitReader$succeed(
								$elm$bytes$Bytes$Decode$Loop(
									_Utils_Tuple3(
										i + 1,
										A2($folkertdev$elm_flate$Inflate$BitSet$insert, i, bitset),
										A3($elm$core$Dict$insert, i, sym, lengths))));
					}
				},
				A2($folkertdev$elm_flate$Inflate$Internal$decodeSymbol, table, codeTree));
		} else {
			return $folkertdev$elm_flate$Inflate$BitReader$succeed(
				$elm$bytes$Bytes$Decode$Done(lengths));
		}
	});
var $folkertdev$elm_flate$Inflate$BitSet$empty = $folkertdev$elm_flate$Inflate$BitSet$BitSet320(0)(0)(0)(0)(0)(0)(0)(0)(0)(0);
var $folkertdev$elm_flate$Inflate$Internal$decodeTreeLengths = F4(
	function (hlit, hdist, hclen, codeLengths) {
		var clcs = A2($elm$core$List$take, hclen, $folkertdev$elm_flate$Inflate$Internal$clcIndices);
		var initialLengths = function () {
			var go = F3(
				function (xs, ys, accum) {
					go:
					while (true) {
						if (!xs.b) {
							return accum;
						} else {
							var index = xs.a;
							var restIndex = xs.b;
							if (!ys.b) {
								return accum;
							} else {
								var codeLength = ys.a;
								var restCodeLength = ys.b;
								if (!(!codeLength)) {
									var $temp$xs = restIndex,
										$temp$ys = restCodeLength,
										$temp$accum = A3($elm$core$Dict$insert, index, codeLength, accum);
									xs = $temp$xs;
									ys = $temp$ys;
									accum = $temp$accum;
									continue go;
								} else {
									var $temp$xs = restIndex,
										$temp$ys = restCodeLength,
										$temp$accum = accum;
									xs = $temp$xs;
									ys = $temp$ys;
									accum = $temp$accum;
									continue go;
								}
							}
						}
					}
				});
			return A3(go, clcs, codeLengths, $elm$core$Dict$empty);
		}();
		var codeTree = A3($folkertdev$elm_flate$Inflate$Internal$buildTree, initialLengths, 0, 19);
		var initialBitSet = A3(
			$elm$core$Dict$foldl,
			F2(
				function (i, _v0) {
					return $folkertdev$elm_flate$Inflate$BitSet$insert(i);
				}),
			$folkertdev$elm_flate$Inflate$BitSet$empty,
			initialLengths);
		return A2(
			$folkertdev$elm_flate$Inflate$BitReader$loop,
			_Utils_Tuple3(0, initialBitSet, initialLengths),
			A3($folkertdev$elm_flate$Inflate$Internal$decodeDynamicTreeLength, codeTree, hlit, hdist));
	});
var $folkertdev$elm_flate$Inflate$BitReader$exactly = F2(
	function (tableCount, decoder) {
		var helper = function (_v0) {
			var n = _v0.a;
			var xs = _v0.b;
			return (n <= 0) ? $folkertdev$elm_flate$Inflate$BitReader$succeed(
				$elm$bytes$Bytes$Decode$Done(
					$elm$core$List$reverse(xs))) : A2(
				$folkertdev$elm_flate$Inflate$BitReader$map,
				function (x) {
					return $elm$bytes$Bytes$Decode$Loop(
						_Utils_Tuple2(
							n - 1,
							A2($elm$core$List$cons, x, xs)));
				},
				decoder);
		};
		return A2(
			$folkertdev$elm_flate$Inflate$BitReader$loop,
			_Utils_Tuple2(tableCount, _List_Nil),
			helper);
	});
var $folkertdev$elm_flate$Inflate$Internal$cont = F3(
	function (hlit, hdist, hclen) {
		var buildTrees = function (lengths) {
			return _Utils_Tuple2(
				A3($folkertdev$elm_flate$Inflate$Internal$buildTree, lengths, 0, hlit),
				A3($folkertdev$elm_flate$Inflate$Internal$buildTree, lengths, hlit, hdist));
		};
		return A2(
			$folkertdev$elm_flate$Inflate$BitReader$map,
			buildTrees,
			A2(
				$folkertdev$elm_flate$Inflate$BitReader$andThen,
				A3($folkertdev$elm_flate$Inflate$Internal$decodeTreeLengths, hlit, hdist, hclen),
				A2(
					$folkertdev$elm_flate$Inflate$BitReader$exactly,
					hclen,
					A2($folkertdev$elm_flate$Inflate$BitReader$readBits, 3, 0))));
	});
var $folkertdev$elm_flate$Inflate$BitReader$map2 = F3(
	function (f, _v0, _v1) {
		var fa = _v0;
		var fb = _v1;
		return function (state) {
			var _v2 = fa(state);
			if (_v2.$ === 1) {
				var e = _v2.a;
				return $elm$core$Result$Err(e);
			} else {
				var _v3 = _v2.a;
				var a = _v3.a;
				var newState = _v3.b;
				var _v4 = fb(newState);
				if (_v4.$ === 1) {
					var e = _v4.a;
					return $elm$core$Result$Err(e);
				} else {
					var _v5 = _v4.a;
					var b = _v5.a;
					var newerState = _v5.b;
					return $elm$core$Result$Ok(
						_Utils_Tuple2(
							A2(f, a, b),
							newerState));
				}
			}
		};
	});
var $folkertdev$elm_flate$Inflate$BitReader$andMap = F2(
	function (a, f) {
		return A3($folkertdev$elm_flate$Inflate$BitReader$map2, $elm$core$Basics$apL, f, a);
	});
var $folkertdev$elm_flate$Inflate$BitReader$map3 = F4(
	function (f, a, b, c) {
		return A2(
			$folkertdev$elm_flate$Inflate$BitReader$andMap,
			c,
			A2(
				$folkertdev$elm_flate$Inflate$BitReader$andMap,
				b,
				A2(
					$folkertdev$elm_flate$Inflate$BitReader$andMap,
					a,
					$folkertdev$elm_flate$Inflate$BitReader$succeed(f))));
	});
var $folkertdev$elm_flate$Inflate$Internal$decodeTrees = A2(
	$folkertdev$elm_flate$Inflate$BitReader$andThen,
	$elm$core$Basics$identity,
	A4(
		$folkertdev$elm_flate$Inflate$BitReader$map3,
		$folkertdev$elm_flate$Inflate$Internal$cont,
		A2($folkertdev$elm_flate$Inflate$BitReader$readBits, 5, 257),
		A2($folkertdev$elm_flate$Inflate$BitReader$readBits, 5, 1),
		A2($folkertdev$elm_flate$Inflate$BitReader$readBits, 4, 4)));
var $folkertdev$elm_flate$Inflate$BitReader$error = function (e) {
	return function (s) {
		return $elm$core$Result$Err(e);
	};
};
var $folkertdev$elm_flate$Inflate$BitReader$getBit = A2($folkertdev$elm_flate$Inflate$BitReader$readBits, 1, 0);
var $folkertdev$elm_flate$Experimental$ByteArray$copyToBackInternal = F5(
	function (startIndex, size, array, finalSize, finalBytes) {
		copyToBackInternal:
		while (true) {
			var offset = startIndex % 4;
			var internalIndex = (startIndex / 4) | 0;
			if (size <= 0) {
				return A3($folkertdev$elm_flate$Experimental$ByteArray$ByteArray, array, finalSize, finalBytes);
			} else {
				if (_Utils_cmp(
					startIndex + 4,
					(($elm$core$Array$length(array) - 1) * 4) + finalSize) > -1) {
					var _v0 = A2(
						$folkertdev$elm_flate$Experimental$ByteArray$get,
						startIndex,
						A3($folkertdev$elm_flate$Experimental$ByteArray$ByteArray, array, finalSize, finalBytes));
					if (_v0.$ === 1) {
						return A3($folkertdev$elm_flate$Experimental$ByteArray$ByteArray, array, finalSize, finalBytes);
					} else {
						var value = _v0.a;
						var _v1 = A2(
							$folkertdev$elm_flate$Experimental$ByteArray$push,
							value,
							A3($folkertdev$elm_flate$Experimental$ByteArray$ByteArray, array, finalSize, finalBytes));
						var newArray = _v1.a;
						var newFinalSize = _v1.b;
						var newFinalBytes = _v1.c;
						var $temp$startIndex = startIndex + 1,
							$temp$size = size - 1,
							$temp$array = newArray,
							$temp$finalSize = newFinalSize,
							$temp$finalBytes = newFinalBytes;
						startIndex = $temp$startIndex;
						size = $temp$size;
						array = $temp$array;
						finalSize = $temp$finalSize;
						finalBytes = $temp$finalBytes;
						continue copyToBackInternal;
					}
				} else {
					var _v2 = A2($elm$core$Array$get, internalIndex, array);
					if (_v2.$ === 1) {
						return A3($folkertdev$elm_flate$Experimental$ByteArray$ByteArray, array, finalSize, finalBytes);
					} else {
						var value = _v2.a;
						var written = A2($elm$core$Basics$min, 4 - offset, size);
						var maskedFront = value << (8 * offset);
						var maskedBack = function () {
							if (_Utils_cmp(4 - offset, size) > 0) {
								var bytesWeNeedToRemove = 4 - size;
								var bytesWeHave = (3 - offset) + 1;
								return maskedFront >> (bytesWeNeedToRemove * 8);
							} else {
								return maskedFront >> (offset * 8);
							}
						}();
						var _v3 = A3(
							$folkertdev$elm_flate$Experimental$ByteArray$pushMany,
							written,
							maskedBack,
							A3($folkertdev$elm_flate$Experimental$ByteArray$ByteArray, array, finalSize, finalBytes));
						var x = _v3.a;
						var y = _v3.b;
						var z = _v3.c;
						var $temp$startIndex = startIndex + written,
							$temp$size = size - written,
							$temp$array = x,
							$temp$finalSize = y,
							$temp$finalBytes = z;
						startIndex = $temp$startIndex;
						size = $temp$size;
						array = $temp$array;
						finalSize = $temp$finalSize;
						finalBytes = $temp$finalBytes;
						continue copyToBackInternal;
					}
				}
			}
		}
	});
var $folkertdev$elm_flate$Experimental$ByteArray$copyToBack = F3(
	function (startIndex, size, _v0) {
		var array = _v0.a;
		var finalSize = _v0.b;
		var finalBytes = _v0.c;
		return A5($folkertdev$elm_flate$Experimental$ByteArray$copyToBackInternal, startIndex, size, array, finalSize, finalBytes);
	});
var $folkertdev$elm_flate$Inflate$Internal$HuffmanTable = $elm$core$Basics$identity;
var $folkertdev$elm_flate$Inflate$Internal$buildBitsBase = F2(
	function (delta, first) {
		var initializer = function (i) {
			return (_Utils_cmp(i, delta) < 0) ? 0 : (((i - delta) / delta) | 0);
		};
		var folder = F2(
			function (bit, _v0) {
				var sum = _v0.a;
				var accum = _v0.b;
				return _Utils_Tuple2(
					sum + (1 << bit),
					A2(
						$elm$core$Array$push,
						{sV: sum, jG: bit},
						accum));
			});
		var bits = A2($elm$core$Array$initialize, 30, initializer);
		var base = A3(
			$elm$core$Array$foldl,
			folder,
			_Utils_Tuple2(first, $elm$core$Array$empty),
			bits).b;
		return base;
	});
var $folkertdev$elm_flate$Inflate$Internal$hardcodedDistanceTable = A2($folkertdev$elm_flate$Inflate$Internal$buildBitsBase, 2, 1);
var $folkertdev$elm_flate$Inflate$Internal$hardcodedLengthTable = function (_v0) {
	var array = _v0;
	return A3(
		$elm$core$Array$set,
		28,
		{sV: 258, jG: 0},
		array);
}(
	A2($folkertdev$elm_flate$Inflate$Internal$buildBitsBase, 4, 3));
var $folkertdev$elm_flate$Inflate$Internal$readHuffmanTable = F2(
	function (index, _v0) {
		var table = _v0;
		return A2($elm$core$Array$get, index, table);
	});
var $folkertdev$elm_flate$Inflate$Internal$decodeLength = function (symbol) {
	var _v0 = A2($folkertdev$elm_flate$Inflate$Internal$readHuffmanTable, symbol - 257, $folkertdev$elm_flate$Inflate$Internal$hardcodedLengthTable);
	if (_v0.$ === 1) {
		return $folkertdev$elm_flate$Inflate$BitReader$error(
			function () {
				var _v1 = $folkertdev$elm_flate$Inflate$Internal$hardcodedDistanceTable;
				var internal = _v1;
				return 'index out of bounds in hardcodedLengthTable: requested index ' + ($elm$core$String$fromInt(symbol - 257) + ('but hardcodedLengthTable has length ' + $elm$core$String$fromInt(
					$elm$core$Array$length(internal))));
			}());
	} else {
		var entry = _v0.a;
		return A2($folkertdev$elm_flate$Inflate$BitReader$readBits, entry.jG, entry.sV);
	}
};
var $folkertdev$elm_flate$Inflate$Internal$decodeOffset = F2(
	function (outputLength, dt) {
		var table_ = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			$elm$core$List$tail(dt.ww));
		return A2(
			$folkertdev$elm_flate$Inflate$BitReader$andThen,
			function (distance) {
				var _v0 = A2($folkertdev$elm_flate$Inflate$Internal$readHuffmanTable, distance, $folkertdev$elm_flate$Inflate$Internal$hardcodedDistanceTable);
				if (_v0.$ === 1) {
					return $folkertdev$elm_flate$Inflate$BitReader$error(
						function () {
							var _v1 = $folkertdev$elm_flate$Inflate$Internal$hardcodedDistanceTable;
							var internal = _v1;
							return 'index out of bounds in hardcodedDistanceTable: requested index ' + ($elm$core$String$fromInt(distance) + ('but hardcodedLengthTable has length ' + $elm$core$String$fromInt(
								$elm$core$Array$length(internal))));
						}());
				} else {
					var entry = _v0.a;
					return A2(
						$folkertdev$elm_flate$Inflate$BitReader$map,
						function (v) {
							return outputLength - v;
						},
						A2($folkertdev$elm_flate$Inflate$BitReader$readBits, entry.jG, entry.sV));
				}
			},
			A2($folkertdev$elm_flate$Inflate$Internal$decodeSymbol, table_, dt));
	});
var $folkertdev$elm_flate$Inflate$Internal$inflateBlockDataHelp = F2(
	function (trees, _v0) {
		var outputLength = _v0.a;
		var output = _v0.b;
		var table = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			$elm$core$List$tail(trees.j4.ww));
		return A2(
			$folkertdev$elm_flate$Inflate$BitReader$andThen,
			function (symbol) {
				return (symbol === 256) ? $folkertdev$elm_flate$Inflate$BitReader$succeed(
					$elm$bytes$Bytes$Decode$Done(output)) : ((symbol < 256) ? $folkertdev$elm_flate$Inflate$BitReader$succeed(
					$elm$bytes$Bytes$Decode$Loop(
						_Utils_Tuple2(
							outputLength + 1,
							A2($folkertdev$elm_flate$Experimental$ByteArray$push, symbol, output)))) : A3(
					$folkertdev$elm_flate$Inflate$BitReader$map2,
					F2(
						function (length, offset) {
							return $elm$bytes$Bytes$Decode$Loop(
								_Utils_Tuple2(
									outputLength + length,
									A3($folkertdev$elm_flate$Experimental$ByteArray$copyToBack, offset, length, output)));
						}),
					$folkertdev$elm_flate$Inflate$Internal$decodeLength(symbol),
					A2($folkertdev$elm_flate$Inflate$Internal$decodeOffset, outputLength, trees.jR)));
			},
			A2($folkertdev$elm_flate$Inflate$Internal$decodeSymbol, table, trees.j4));
	});
var $folkertdev$elm_flate$Inflate$Internal$inflateBlockData = F3(
	function (trees, outputLength, output) {
		return A2(
			$folkertdev$elm_flate$Inflate$BitReader$loop,
			_Utils_Tuple2(outputLength, output),
			$folkertdev$elm_flate$Inflate$Internal$inflateBlockDataHelp(trees));
	});
var $elm$bytes$Bytes$Decode$fail = _Bytes_decodeFailure;
var $folkertdev$elm_flate$Inflate$Internal$uncompressedBlockDecoder = function (bufferWidth) {
	var decodeLengths = A3(
		$elm$bytes$Bytes$Decode$map2,
		$elm$core$Tuple$pair,
		$elm$bytes$Bytes$Decode$unsignedInt16(0),
		$elm$bytes$Bytes$Decode$unsignedInt16(0));
	return A2(
		$elm$bytes$Bytes$Decode$andThen,
		function (_v0) {
			var length = _v0.a;
			var invlength = _v0.b;
			if (!_Utils_eq(length, (~invlength) & 65535)) {
				return $elm$bytes$Bytes$Decode$fail;
			} else {
				var remainingSize = (bufferWidth - 4) - length;
				return A3(
					$elm$bytes$Bytes$Decode$map2,
					$elm$core$Tuple$pair,
					$elm$bytes$Bytes$Decode$bytes(length),
					$elm$bytes$Bytes$Decode$bytes(remainingSize));
			}
		},
		decodeLengths);
};
var $folkertdev$elm_flate$Inflate$Internal$inflateUncompressedBlock = function (state) {
	var _v0 = A2(
		$elm$bytes$Bytes$Decode$decode,
		$folkertdev$elm_flate$Inflate$Internal$uncompressedBlockDecoder(
			$elm$bytes$Bytes$width(state.fK)),
		state.fK);
	if (_v0.$ === 1) {
		return $elm$core$Result$Err('inflateUncompressedBlock: ran out of bounds');
	} else {
		var _v1 = _v0.a;
		var block = _v1.a;
		var newBuffer = _v1.b;
		return $elm$core$Result$Ok(
			_Utils_Tuple2(
				block,
				_Utils_update(
					state,
					{fK: newBuffer})));
	}
};
var $folkertdev$elm_flate$Inflate$Internal$sdtree = {
	ww: _List_fromArray(
		[0, 0, 0, 0, 0, 32, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]),
	pZ: A2(
		$elm$core$Array$append,
		$elm$core$Array$fromList(
			_List_fromArray(
				[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31])),
		A2($elm$core$Array$repeat, 288 - 32, 0))
};
var $folkertdev$elm_flate$Inflate$BitReader$flushHelp = function (state0) {
	var availableSpace = 32 - state0.ds;
	var state = A2(
		$folkertdev$elm_flate$Inflate$BitReader$moveFromReserve,
		A2($elm$core$Basics$min, availableSpace, state0.eH),
		state0);
	var reserveEncoder = (state.eH > 24) ? _List_fromArray(
		[
			A2($elm$bytes$Bytes$Encode$unsignedInt32, 0, state.fy)
		]) : ((state.eH > 16) ? _List_fromArray(
		[
			A2($elm$bytes$Bytes$Encode$unsignedInt16, 0, state.fy),
			$elm$bytes$Bytes$Encode$unsignedInt8(state.fy >> 16)
		]) : ((state.eH > 8) ? _List_fromArray(
		[
			A2($elm$bytes$Bytes$Encode$unsignedInt16, 0, state.fy)
		]) : ((state.eH > 1) ? _List_fromArray(
		[
			$elm$bytes$Bytes$Encode$unsignedInt8(state.fy)
		]) : _List_Nil)));
	var tagEncoder = (state.ds > 24) ? _List_fromArray(
		[
			A2($elm$bytes$Bytes$Encode$unsignedInt32, 0, state.wB)
		]) : ((state.ds > 16) ? _List_fromArray(
		[
			A2($elm$bytes$Bytes$Encode$unsignedInt16, 0, state.wB),
			$elm$bytes$Bytes$Encode$unsignedInt8(state.wB >> 16)
		]) : ((state.ds > 8) ? _List_fromArray(
		[
			A2($elm$bytes$Bytes$Encode$unsignedInt16, 0, state.wB)
		]) : ((state.ds > 1) ? _List_fromArray(
		[
			$elm$bytes$Bytes$Encode$unsignedInt8(state.wB)
		]) : _List_Nil)));
	return $elm$bytes$Bytes$Encode$encode(
		$elm$bytes$Bytes$Encode$sequence(
			_Utils_ap(
				tagEncoder,
				_Utils_ap(
					reserveEncoder,
					_List_fromArray(
						[
							$elm$bytes$Bytes$Encode$bytes(state.fK)
						])))));
};
var $folkertdev$elm_flate$Inflate$BitReader$flush = function (state) {
	return {
		ds: 0,
		fK: $folkertdev$elm_flate$Inflate$BitReader$flushHelp(state),
		fy: 0,
		eH: 0,
		wB: 0
	};
};
var $folkertdev$elm_flate$Inflate$BitReader$skipToByteBoundary = function (s) {
	var available = s.ds + s.eH;
	var untilBoundary = A2($elm$core$Basics$modBy, 8, available);
	var _v0 = A2($folkertdev$elm_flate$Inflate$BitReader$readBits, untilBoundary, 0);
	var step = _v0;
	var _v1 = step(s);
	if (_v1.$ === 1) {
		var e = _v1.a;
		return $elm$core$Result$Err(e);
	} else {
		var _v2 = _v1.a;
		var newState = _v2.b;
		var _v3 = $folkertdev$elm_flate$Inflate$BitReader$readMoreBits(newState);
		if (_v3.$ === 1) {
			var e = _v3.a;
			return $elm$core$Result$Err(e);
		} else {
			var newerState = _v3.a;
			return $elm$core$Result$Ok(
				_Utils_Tuple2(
					0,
					$folkertdev$elm_flate$Inflate$BitReader$flush(newerState)));
		}
	}
};
var $folkertdev$elm_flate$Inflate$Internal$sltree = {
	ww: _List_fromArray(
		[0, 0, 0, 0, 0, 0, 0, 24, 152, 112, 0, 0, 0, 0, 0, 0]),
	pZ: $elm$core$Array$fromList(
		_List_fromArray(
			[256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 280, 281, 282, 283, 284, 285, 286, 287, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255]))
};
var $folkertdev$elm_flate$Inflate$Internal$uncompressHelp = function (output) {
	var uncompressBlock = function (btype) {
		switch (btype) {
			case 0:
				return A2(
					$folkertdev$elm_flate$Inflate$BitReader$map,
					function (bytes) {
						return A2($folkertdev$elm_flate$Experimental$ByteArray$appendBytes, bytes, output);
					},
					A2(
						$folkertdev$elm_flate$Inflate$BitReader$andThen,
						function (_v1) {
							return $folkertdev$elm_flate$Inflate$Internal$inflateUncompressedBlock;
						},
						$folkertdev$elm_flate$Inflate$BitReader$skipToByteBoundary));
			case 1:
				return A3(
					$folkertdev$elm_flate$Inflate$Internal$inflateBlockData,
					{jR: $folkertdev$elm_flate$Inflate$Internal$sdtree, j4: $folkertdev$elm_flate$Inflate$Internal$sltree},
					$folkertdev$elm_flate$Experimental$ByteArray$length(output),
					output);
			case 2:
				return A2(
					$folkertdev$elm_flate$Inflate$BitReader$andThen,
					function (_v2) {
						var ltree = _v2.a;
						var dtree = _v2.b;
						return A3(
							$folkertdev$elm_flate$Inflate$Internal$inflateBlockData,
							{jR: dtree, j4: ltree},
							$folkertdev$elm_flate$Experimental$ByteArray$length(output),
							output);
					},
					$folkertdev$elm_flate$Inflate$Internal$decodeTrees);
			default:
				return $folkertdev$elm_flate$Inflate$BitReader$error(
					'invalid block type: ' + ($elm$core$String$fromInt(btype) + ' (only 0, 1 and 2 are valid block types)'));
		}
	};
	var readTwoBits = A3(
		$folkertdev$elm_flate$Inflate$BitReader$map2,
		F2(
			function (b1, b2) {
				return b1 + (2 * b2);
			}),
		$folkertdev$elm_flate$Inflate$BitReader$getBit,
		$folkertdev$elm_flate$Inflate$BitReader$getBit);
	var go = F2(
		function (isFinal, blockType) {
			return (!(!isFinal)) ? A2(
				$folkertdev$elm_flate$Inflate$BitReader$map,
				$elm$bytes$Bytes$Decode$Done,
				uncompressBlock(blockType)) : A2(
				$folkertdev$elm_flate$Inflate$BitReader$map,
				$elm$bytes$Bytes$Decode$Loop,
				uncompressBlock(blockType));
		});
	return A2(
		$folkertdev$elm_flate$Inflate$BitReader$andThen,
		$elm$core$Basics$identity,
		A3($folkertdev$elm_flate$Inflate$BitReader$map2, go, $folkertdev$elm_flate$Inflate$BitReader$getBit, readTwoBits));
};
var $folkertdev$elm_flate$Inflate$Internal$uncompress = A2(
	$folkertdev$elm_flate$Inflate$BitReader$map,
	A2($elm$core$Basics$composeR, $folkertdev$elm_flate$Experimental$ByteArray$toBytes, $elm$core$List$singleton),
	A2($folkertdev$elm_flate$Inflate$BitReader$loop, $folkertdev$elm_flate$Experimental$ByteArray$empty, $folkertdev$elm_flate$Inflate$Internal$uncompressHelp));
var $folkertdev$elm_flate$Inflate$Internal$inflate = function (buffer) {
	var _v0 = A2($folkertdev$elm_flate$Inflate$BitReader$decode, buffer, $folkertdev$elm_flate$Inflate$Internal$uncompress);
	if (_v0.$ === 1) {
		var e = _v0.a;
		return $elm$core$Result$Err(e);
	} else {
		var values = _v0.a;
		return $elm$core$Result$Ok(
			$elm$bytes$Bytes$Encode$encode(
				$elm$bytes$Bytes$Encode$sequence(
					A2($elm$core$List$map, $elm$bytes$Bytes$Encode$bytes, values))));
	}
};
var $folkertdev$elm_flate$Inflate$Inflate$inflate = function (buffer) {
	var _v0 = $folkertdev$elm_flate$Inflate$Internal$inflate(buffer);
	if (_v0.$ === 1) {
		return $elm$core$Maybe$Nothing;
	} else {
		var newBuffer = _v0.a;
		return $elm$core$Maybe$Just(newBuffer);
	}
};
var $folkertdev$elm_flate$Flate$inflate = $folkertdev$elm_flate$Inflate$Inflate$inflate;
var $elm$bytes$Bytes$Decode$string = function (n) {
	return _Bytes_read_string(n);
};
var $danfishgold$base64_bytes$Encode$isValidChar = function (c) {
	if ($elm$core$Char$isAlphaNum(c)) {
		return true;
	} else {
		switch (c) {
			case '+':
				return true;
			case '/':
				return true;
			default:
				return false;
		}
	}
};
var $danfishgold$base64_bytes$Encode$unsafeConvertChar = function (_char) {
	var key = $elm$core$Char$toCode(_char);
	if ((key >= 65) && (key <= 90)) {
		return key - 65;
	} else {
		if ((key >= 97) && (key <= 122)) {
			return (key - 97) + 26;
		} else {
			if ((key >= 48) && (key <= 57)) {
				return ((key - 48) + 26) + 26;
			} else {
				switch (_char) {
					case '+':
						return 62;
					case '/':
						return 63;
					default:
						return -1;
				}
			}
		}
	}
};
var $danfishgold$base64_bytes$Encode$encodeCharacters = F4(
	function (a, b, c, d) {
		if ($danfishgold$base64_bytes$Encode$isValidChar(a) && $danfishgold$base64_bytes$Encode$isValidChar(b)) {
			var n2 = $danfishgold$base64_bytes$Encode$unsafeConvertChar(b);
			var n1 = $danfishgold$base64_bytes$Encode$unsafeConvertChar(a);
			if ('=' === d) {
				if ('=' === c) {
					var n = (n1 << 18) | (n2 << 12);
					var b1 = n >> 16;
					return $elm$core$Maybe$Just(
						$elm$bytes$Bytes$Encode$unsignedInt8(b1));
				} else {
					if ($danfishgold$base64_bytes$Encode$isValidChar(c)) {
						var n3 = $danfishgold$base64_bytes$Encode$unsafeConvertChar(c);
						var n = ((n1 << 18) | (n2 << 12)) | (n3 << 6);
						var combined = n >> 8;
						return $elm$core$Maybe$Just(
							A2($elm$bytes$Bytes$Encode$unsignedInt16, 1, combined));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}
			} else {
				if ($danfishgold$base64_bytes$Encode$isValidChar(c) && $danfishgold$base64_bytes$Encode$isValidChar(d)) {
					var n4 = $danfishgold$base64_bytes$Encode$unsafeConvertChar(d);
					var n3 = $danfishgold$base64_bytes$Encode$unsafeConvertChar(c);
					var n = ((n1 << 18) | (n2 << 12)) | ((n3 << 6) | n4);
					var combined = n >> 8;
					var b3 = n;
					return $elm$core$Maybe$Just(
						$elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									A2($elm$bytes$Bytes$Encode$unsignedInt16, 1, combined),
									$elm$bytes$Bytes$Encode$unsignedInt8(b3)
								])));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $danfishgold$base64_bytes$Encode$encodeChunks = F2(
	function (input, accum) {
		encodeChunks:
		while (true) {
			var _v0 = $elm$core$String$toList(
				A2($elm$core$String$left, 4, input));
			_v0$4:
			while (true) {
				if (!_v0.b) {
					return $elm$core$Maybe$Just(accum);
				} else {
					if (_v0.b.b) {
						if (_v0.b.b.b) {
							if (_v0.b.b.b.b) {
								if (!_v0.b.b.b.b.b) {
									var a = _v0.a;
									var _v1 = _v0.b;
									var b = _v1.a;
									var _v2 = _v1.b;
									var c = _v2.a;
									var _v3 = _v2.b;
									var d = _v3.a;
									var _v4 = A4($danfishgold$base64_bytes$Encode$encodeCharacters, a, b, c, d);
									if (!_v4.$) {
										var enc = _v4.a;
										var $temp$input = A2($elm$core$String$dropLeft, 4, input),
											$temp$accum = A2($elm$core$List$cons, enc, accum);
										input = $temp$input;
										accum = $temp$accum;
										continue encodeChunks;
									} else {
										return $elm$core$Maybe$Nothing;
									}
								} else {
									break _v0$4;
								}
							} else {
								var a = _v0.a;
								var _v5 = _v0.b;
								var b = _v5.a;
								var _v6 = _v5.b;
								var c = _v6.a;
								var _v7 = A4($danfishgold$base64_bytes$Encode$encodeCharacters, a, b, c, '=');
								if (_v7.$ === 1) {
									return $elm$core$Maybe$Nothing;
								} else {
									var enc = _v7.a;
									return $elm$core$Maybe$Just(
										A2($elm$core$List$cons, enc, accum));
								}
							}
						} else {
							var a = _v0.a;
							var _v8 = _v0.b;
							var b = _v8.a;
							var _v9 = A4($danfishgold$base64_bytes$Encode$encodeCharacters, a, b, '=', '=');
							if (_v9.$ === 1) {
								return $elm$core$Maybe$Nothing;
							} else {
								var enc = _v9.a;
								return $elm$core$Maybe$Just(
									A2($elm$core$List$cons, enc, accum));
							}
						}
					} else {
						break _v0$4;
					}
				}
			}
			return $elm$core$Maybe$Nothing;
		}
	});
var $danfishgold$base64_bytes$Encode$encoder = function (string) {
	return A2(
		$elm$core$Maybe$map,
		A2($elm$core$Basics$composeR, $elm$core$List$reverse, $elm$bytes$Bytes$Encode$sequence),
		A2($danfishgold$base64_bytes$Encode$encodeChunks, string, _List_Nil));
};
var $danfishgold$base64_bytes$Encode$toBytes = function (string) {
	return A2(
		$elm$core$Maybe$map,
		$elm$bytes$Bytes$Encode$encode,
		$danfishgold$base64_bytes$Encode$encoder(string));
};
var $danfishgold$base64_bytes$Base64$toBytes = $danfishgold$base64_bytes$Encode$toBytes;
var $author$project$Model$BuildPlanner$BuildExpr$fromUrlString = function (buildExprUrlString) {
	return A2(
		$elm$core$Result$andThen,
		A2(
			$elm$core$Basics$composeR,
			$elm$json$Json$Decode$decodeString($author$project$Model$BuildPlanner$BuildExpr$decode),
			$elm$core$Result$mapError($elm$json$Json$Decode$errorToString)),
		A2(
			$elm$core$Result$andThen,
			function (b) {
				return A2(
					$elm$core$Result$fromMaybe,
					'Couldn\'t decode inflated bytes into a string',
					A2(
						$elm$bytes$Bytes$Decode$decode,
						$elm$bytes$Bytes$Decode$string(
							$elm$bytes$Bytes$width(b)),
						b));
			},
			A2(
				$elm$core$Result$andThen,
				A2(
					$elm$core$Basics$composeR,
					$folkertdev$elm_flate$Flate$inflate,
					$elm$core$Result$fromMaybe('Couldn\'t inflate')),
				A2(
					$elm$core$Result$fromMaybe,
					'Invalid base64',
					$danfishgold$base64_bytes$Base64$toBytes(buildExprUrlString)))));
};
var $author$project$Model$Route$projectImpactReport = function (_v0) {
	var orgName = _v0.ix;
	var projectName = _v0.vT;
	var params = _v0.E5;
	return $author$project$Model$Route$Protected(
		$author$project$Model$Route$Org(
			A2(
				$author$project$Model$Route$OrgParams,
				orgName,
				$author$project$Model$Route$OrgProject(
					A2(
						$author$project$Model$Route$OrgProjectParams,
						projectName,
						$author$project$Model$Route$ProjectImpactReport(params))))));
};
var $author$project$Pages$ProjectImpactReport$createModel = F3(
	function (_v0, _v1, _v2) {
		var params = _v1.E5;
		var host = _v1.t0;
		var organization = _v2.a;
		var project = _v2.b;
		var validateBuildPlanSpec = function (param) {
			var _v4 = _Utils_Tuple3(param.BR, param.k$, param.nL);
			if (!_v4.a.$) {
				var commitID = _v4.a.a;
				return $elm$core$Result$Ok(
					$author$project$Request$BuildPlanner$CommitID(commitID));
			} else {
				if (!_v4.b.$) {
					var _v5 = _v4.a;
					var buildExprUrlString = _v4.b.a;
					return A3(
						$elm$core$Result$map2,
						F2(
							function (atTime, buildExpr) {
								return $author$project$Request$BuildPlanner$BuildExpr(
									{jE: atTime, k$: buildExpr});
							}),
						A2(
							$elm$core$Result$fromMaybe,
							'atTime invalid or not provided',
							A2(
								$elm$core$Maybe$map,
								$elm$time$Time$millisToPosix,
								A2($elm$core$Maybe$andThen, $elm$core$String$toInt, param.jE))),
						$author$project$Model$BuildPlanner$BuildExpr$fromUrlString(buildExprUrlString));
				} else {
					if (!_v4.c.$) {
						var _v6 = _v4.a;
						var _v7 = _v4.b;
						var vcsRef = _v4.c.a;
						return $elm$core$Result$Ok(
							$author$project$Request$BuildPlanner$VcsRef(vcsRef));
					} else {
						var _v8 = _v4.a;
						var _v9 = _v4.b;
						var _v10 = _v4.c;
						return $elm$core$Result$Err('No commit ID, vcsRef, or buildExpr + atTime provided');
					}
				}
			}
		};
		var validatedParams = function () {
			var old = {jE: params.uS, k$: params.uT, BR: params.uU, nL: params.uW};
			var _new = {jE: params.uJ, k$: params.uK, BR: params.uL, nL: params.uN};
			var _v3 = _Utils_Tuple2(
				validateBuildPlanSpec(old),
				validateBuildPlanSpec(_new));
			if (_v3.a.$ === 1) {
				if (_v3.b.$ === 1) {
					var e1 = _v3.a.a;
					var e2 = _v3.b.a;
					return $elm$core$Result$Err(
						A2($author$project$Pages$ProjectImpactReport$BothError, e1, e2));
				} else {
					var e = _v3.a.a;
					return $elm$core$Result$Err(
						$author$project$Pages$ProjectImpactReport$OldError(e));
				}
			} else {
				if (_v3.b.$ === 1) {
					var e = _v3.b.a;
					return $elm$core$Result$Err(
						$author$project$Pages$ProjectImpactReport$NewError(e));
				} else {
					var oldSpec = _v3.a.a;
					var newSpec = _v3.b.a;
					return $elm$core$Result$Ok(
						_Utils_Tuple2(oldSpec, newSpec));
				}
			}
		}();
		var impactReportRoute = $author$project$Model$Route$projectImpactReport(
			{
				ix: organization.AC,
				E5: params,
				vT: $author$project$Model$Project$getName(project)
			});
		return {
			t0: host,
			t6: $elm$core$Maybe$Just(impactReportRoute),
			c3: organization,
			E5: validatedParams,
			c5: project,
			hi: $krisajenkins$remotedata$RemoteData$NotAsked
		};
	});
var $author$project$Model$Platform$displayName = function (platform_) {
	var platform = platform_;
	var platformType = $author$project$Model$Platform$getPlatformType(platform_);
	return (platformType === 1) ? (platform.uq ? ('Linux ' + platform.ha) : 'Linux') : ((platformType === 2) ? 'Mac' : platform.ha);
};
var $author$project$Pages$ProjectPreview$generateProjectTitle = F2(
	function (availablePlatforms, editor) {
		var platformsString = A2(
			$elm$core$String$join,
			'-',
			A2(
				$elm$core$List$map,
				$author$project$Model$Platform$displayName,
				A2(
					$elm$core$List$filterMap,
					function (id) {
						return A2($elm$core$Dict$get, id, availablePlatforms);
					},
					$elm$core$Set$toList(
						$author$project$Model$BuildPlanner$SolveLegacyEditor$getPlatforms(editor)))));
		var constraintSuffix = function (constraint) {
			if (constraint.$ === 1) {
				var version = constraint.a;
				return '-' + version;
			} else {
				return '';
			}
		};
		var languagesString = A2(
			$elm$core$String$join,
			'-',
			A2(
				$elm$core$List$map,
				function (_v0) {
					var name = _v0.a;
					var constraint = _v0.b;
					return _Utils_ap(
						$elm_community$string_extra$String$Extra$toSentenceCase(name),
						constraintSuffix(constraint));
				},
				$elm$core$Dict$toList(
					$author$project$Model$BuildPlanner$SolveLegacyEditor$getLanguages(editor))));
		var projectName = A2(
			$elm$core$String$join,
			'-',
			_List_fromArray(
				[languagesString, platformsString]));
		var title = A2(
			$elm$core$String$left,
			$author$project$Validation$maxProjectNameLength,
			$author$project$Validation$formatProjectName(projectName));
		return (title === '') ? 'New-Project' : title;
	});
var $author$project$Pages$ProjectPreview$createModel = F2(
	function (key, _v0) {
		var commitID = _v0.a;
		var buildExpr = _v0.b;
		var platforms = _v0.c;
		var editor = $author$project$Model$BuildPlanner$SolveLegacyEditor$fromBuildExprWithFallback(buildExpr);
		var availablePlatforms = $author$project$Model$Platform$userVisiblePlatforms(platforms);
		return {
			n4: availablePlatforms,
			BR: commitID,
			qR: editor,
			Y: key,
			Fs: $author$project$Validation$formatProjectName(
				A2($author$project$Pages$ProjectPreview$generateProjectTitle, availablePlatforms, editor))
		};
	});
var $author$project$Pages$ProjectImpactReport$getOrganization = function (model) {
	return model.c3;
};
var $author$project$Task$Parallel$Extra$DownloadFinished2 = function (a) {
	return {$: 1, a: a};
};
var $author$project$Task$Parallel$Extra$LoadedResources2 = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $0ui$elm_task_parallel$Task$Parallel$FailedState2 = {$: 0};
var $0ui$elm_task_parallel$Task$Parallel$toCmd = A2(
	$elm$core$Basics$composeR,
	$elm$core$Task$succeed,
	$elm$core$Task$perform($elm$core$Basics$identity));
var $0ui$elm_task_parallel$Task$Parallel$nextCmd2 = F3(
	function (a, b, successMsg) {
		return function (cmd) {
			return _Utils_Tuple2(
				A2($0ui$elm_task_parallel$Task$Parallel$State2, a, b),
				cmd);
		}(
			A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Cmd$none,
				A2(
					$elm$core$Maybe$map,
					$0ui$elm_task_parallel$Task$Parallel$toCmd,
					A3($elm$core$Maybe$map2, successMsg, a, b))));
	});
var $0ui$elm_task_parallel$Task$Parallel$update2 = F4(
	function (prevData, msg, successMsg, failureMsg) {
		if (!prevData.$) {
			return _Utils_Tuple2(prevData, $elm$core$Platform$Cmd$none);
		} else {
			var a = prevData.a;
			var b = prevData.b;
			switch (msg.$) {
				case 0:
					var data = msg.a;
					return A3(
						$0ui$elm_task_parallel$Task$Parallel$nextCmd2,
						$elm$core$Maybe$Just(data),
						b,
						successMsg);
				case 1:
					var data = msg.a;
					return A3(
						$0ui$elm_task_parallel$Task$Parallel$nextCmd2,
						a,
						$elm$core$Maybe$Just(data),
						successMsg);
				default:
					var err = msg.a;
					return _Utils_Tuple2(
						$0ui$elm_task_parallel$Task$Parallel$FailedState2,
						$0ui$elm_task_parallel$Task$Parallel$toCmd(
							failureMsg(err)));
			}
		}
	});
var $author$project$Task$Parallel$Extra$parallelUpdate2 = function (_v0) {
	var loadingModel = _v0.g7;
	var downloadMsg = _v0.g6;
	var toMainMsg = _v0.hh;
	var onSuccess = F2(
		function (a, b) {
			return toMainMsg(
				$author$project$Task$Parallel$Extra$DownloadFinished2(
					$elm$core$Result$Ok(
						A2($author$project$Task$Parallel$Extra$LoadedResources2, a, b))));
		});
	var onError = function (error) {
		return toMainMsg(
			$author$project$Task$Parallel$Extra$DownloadFinished2(
				$elm$core$Result$Err(error)));
	};
	var _v1 = A4($0ui$elm_task_parallel$Task$Parallel$update2, loadingModel.x7, downloadMsg, onSuccess, onError);
	var nextDownloadState = _v1.a;
	var nextCmd = _v1.b;
	return _Utils_Tuple2(
		_Utils_update(
			loadingModel,
			{x7: nextDownloadState}),
		nextCmd);
};
var $author$project$Task$Parallel$Extra$DownloadFinished3 = function (a) {
	return {$: 1, a: a};
};
var $author$project$Task$Parallel$Extra$LoadedResources3 = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $0ui$elm_task_parallel$Task$Parallel$FailedState3 = {$: 0};
var $0ui$elm_task_parallel$Task$Parallel$nextCmd3 = F4(
	function (a, b, c, successMsg) {
		return function (cmd) {
			return _Utils_Tuple2(
				A3($0ui$elm_task_parallel$Task$Parallel$State3, a, b, c),
				cmd);
		}(
			A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Cmd$none,
				A2(
					$elm$core$Maybe$map,
					$0ui$elm_task_parallel$Task$Parallel$toCmd,
					A4($elm$core$Maybe$map3, successMsg, a, b, c))));
	});
var $0ui$elm_task_parallel$Task$Parallel$update3 = F4(
	function (prevData, msg, successMsg, failureMsg) {
		if (!prevData.$) {
			return _Utils_Tuple2(prevData, $elm$core$Platform$Cmd$none);
		} else {
			var a = prevData.a;
			var b = prevData.b;
			var c = prevData.c;
			switch (msg.$) {
				case 0:
					var data = msg.a;
					return A4(
						$0ui$elm_task_parallel$Task$Parallel$nextCmd3,
						$elm$core$Maybe$Just(data),
						b,
						c,
						successMsg);
				case 1:
					var data = msg.a;
					return A4(
						$0ui$elm_task_parallel$Task$Parallel$nextCmd3,
						a,
						$elm$core$Maybe$Just(data),
						c,
						successMsg);
				case 2:
					var data = msg.a;
					return A4(
						$0ui$elm_task_parallel$Task$Parallel$nextCmd3,
						a,
						b,
						$elm$core$Maybe$Just(data),
						successMsg);
				default:
					var err = msg.a;
					return _Utils_Tuple2(
						$0ui$elm_task_parallel$Task$Parallel$FailedState3,
						$0ui$elm_task_parallel$Task$Parallel$toCmd(
							failureMsg(err)));
			}
		}
	});
var $author$project$Task$Parallel$Extra$parallelUpdate3 = function (_v0) {
	var loadingModel = _v0.g7;
	var downloadMsg = _v0.g6;
	var toMainMsg = _v0.hh;
	var onSuccess = F3(
		function (a, b, c) {
			return toMainMsg(
				$author$project$Task$Parallel$Extra$DownloadFinished3(
					$elm$core$Result$Ok(
						A3($author$project$Task$Parallel$Extra$LoadedResources3, a, b, c))));
		});
	var onError = function (error) {
		return toMainMsg(
			$author$project$Task$Parallel$Extra$DownloadFinished3(
				$elm$core$Result$Err(error)));
	};
	var _v1 = A4($0ui$elm_task_parallel$Task$Parallel$update3, loadingModel.x7, downloadMsg, onSuccess, onError);
	var nextDownloadState = _v1.a;
	var nextCmd = _v1.b;
	return _Utils_Tuple2(
		_Utils_update(
			loadingModel,
			{x7: nextDownloadState}),
		nextCmd);
};
var $author$project$Task$Parallel$Extra$DownloadFinished4 = function (a) {
	return {$: 1, a: a};
};
var $author$project$Task$Parallel$Extra$LoadedResources4 = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $0ui$elm_task_parallel$Task$Parallel$FailedState4 = {$: 0};
var $0ui$elm_task_parallel$Task$Parallel$nextCmd4 = F5(
	function (a, b, c, d, successMsg) {
		return function (cmd) {
			return _Utils_Tuple2(
				A4($0ui$elm_task_parallel$Task$Parallel$State4, a, b, c, d),
				cmd);
		}(
			A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Cmd$none,
				A2(
					$elm$core$Maybe$map,
					$0ui$elm_task_parallel$Task$Parallel$toCmd,
					A5($elm$core$Maybe$map4, successMsg, a, b, c, d))));
	});
var $0ui$elm_task_parallel$Task$Parallel$update4 = F4(
	function (prevData, msg, successMsg, failureMsg) {
		if (!prevData.$) {
			return _Utils_Tuple2(prevData, $elm$core$Platform$Cmd$none);
		} else {
			var a = prevData.a;
			var b = prevData.b;
			var c = prevData.c;
			var d = prevData.d;
			switch (msg.$) {
				case 0:
					var data = msg.a;
					return A5(
						$0ui$elm_task_parallel$Task$Parallel$nextCmd4,
						$elm$core$Maybe$Just(data),
						b,
						c,
						d,
						successMsg);
				case 1:
					var data = msg.a;
					return A5(
						$0ui$elm_task_parallel$Task$Parallel$nextCmd4,
						a,
						$elm$core$Maybe$Just(data),
						c,
						d,
						successMsg);
				case 2:
					var data = msg.a;
					return A5(
						$0ui$elm_task_parallel$Task$Parallel$nextCmd4,
						a,
						b,
						$elm$core$Maybe$Just(data),
						d,
						successMsg);
				case 3:
					var data = msg.a;
					return A5(
						$0ui$elm_task_parallel$Task$Parallel$nextCmd4,
						a,
						b,
						c,
						$elm$core$Maybe$Just(data),
						successMsg);
				default:
					var err = msg.a;
					return _Utils_Tuple2(
						$0ui$elm_task_parallel$Task$Parallel$FailedState4,
						$0ui$elm_task_parallel$Task$Parallel$toCmd(
							failureMsg(err)));
			}
		}
	});
var $author$project$Task$Parallel$Extra$parallelUpdate4 = function (_v0) {
	var loadingModel = _v0.g7;
	var downloadMsg = _v0.g6;
	var toMainMsg = _v0.hh;
	var onSuccess = F4(
		function (a, b, c, d) {
			return toMainMsg(
				$author$project$Task$Parallel$Extra$DownloadFinished4(
					$elm$core$Result$Ok(
						A4($author$project$Task$Parallel$Extra$LoadedResources4, a, b, c, d))));
		});
	var onError = function (error) {
		return toMainMsg(
			$author$project$Task$Parallel$Extra$DownloadFinished4(
				$elm$core$Result$Err(error)));
	};
	var _v1 = A4($0ui$elm_task_parallel$Task$Parallel$update4, loadingModel.x7, downloadMsg, onSuccess, onError);
	var nextDownloadState = _v1.a;
	var nextCmd = _v1.b;
	return _Utils_Tuple2(
		_Utils_update(
			loadingModel,
			{x7: nextDownloadState}),
		nextCmd);
};
var $author$project$Task$Parallel$Extra$DownloadFinished5 = function (a) {
	return {$: 1, a: a};
};
var $author$project$Task$Parallel$Extra$LoadedResources5 = F5(
	function (a, b, c, d, e) {
		return {$: 0, a: a, b: b, c: c, d: d, e: e};
	});
var $0ui$elm_task_parallel$Task$Parallel$FailedState5 = {$: 0};
var $elm$core$Maybe$map5 = F6(
	function (func, ma, mb, mc, md, me) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				if (mc.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var c = mc.a;
					if (md.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var d = md.a;
						if (me.$ === 1) {
							return $elm$core$Maybe$Nothing;
						} else {
							var e = me.a;
							return $elm$core$Maybe$Just(
								A5(func, a, b, c, d, e));
						}
					}
				}
			}
		}
	});
var $0ui$elm_task_parallel$Task$Parallel$nextCmd5 = F6(
	function (a, b, c, d, e, successMsg) {
		return function (cmd) {
			return _Utils_Tuple2(
				A5($0ui$elm_task_parallel$Task$Parallel$State5, a, b, c, d, e),
				cmd);
		}(
			A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Cmd$none,
				A2(
					$elm$core$Maybe$map,
					$0ui$elm_task_parallel$Task$Parallel$toCmd,
					A6($elm$core$Maybe$map5, successMsg, a, b, c, d, e))));
	});
var $0ui$elm_task_parallel$Task$Parallel$update5 = F4(
	function (prevData, msg, successMsg, failureMsg) {
		if (!prevData.$) {
			return _Utils_Tuple2(prevData, $elm$core$Platform$Cmd$none);
		} else {
			var a = prevData.a;
			var b = prevData.b;
			var c = prevData.c;
			var d = prevData.d;
			var e = prevData.e;
			switch (msg.$) {
				case 0:
					var data = msg.a;
					return A6(
						$0ui$elm_task_parallel$Task$Parallel$nextCmd5,
						$elm$core$Maybe$Just(data),
						b,
						c,
						d,
						e,
						successMsg);
				case 1:
					var data = msg.a;
					return A6(
						$0ui$elm_task_parallel$Task$Parallel$nextCmd5,
						a,
						$elm$core$Maybe$Just(data),
						c,
						d,
						e,
						successMsg);
				case 2:
					var data = msg.a;
					return A6(
						$0ui$elm_task_parallel$Task$Parallel$nextCmd5,
						a,
						b,
						$elm$core$Maybe$Just(data),
						d,
						e,
						successMsg);
				case 3:
					var data = msg.a;
					return A6(
						$0ui$elm_task_parallel$Task$Parallel$nextCmd5,
						a,
						b,
						c,
						$elm$core$Maybe$Just(data),
						e,
						successMsg);
				case 4:
					var data = msg.a;
					return A6(
						$0ui$elm_task_parallel$Task$Parallel$nextCmd5,
						a,
						b,
						c,
						d,
						$elm$core$Maybe$Just(data),
						successMsg);
				default:
					var err = msg.a;
					return _Utils_Tuple2(
						$0ui$elm_task_parallel$Task$Parallel$FailedState5,
						$0ui$elm_task_parallel$Task$Parallel$toCmd(
							failureMsg(err)));
			}
		}
	});
var $author$project$Task$Parallel$Extra$parallelUpdate5 = function (_v0) {
	var loadingModel = _v0.g7;
	var downloadMsg = _v0.g6;
	var toMainMsg = _v0.hh;
	var onSuccess = F5(
		function (a, b, c, d, e) {
			return toMainMsg(
				$author$project$Task$Parallel$Extra$DownloadFinished5(
					$elm$core$Result$Ok(
						A5($author$project$Task$Parallel$Extra$LoadedResources5, a, b, c, d, e))));
		});
	var onError = function (error) {
		return toMainMsg(
			$author$project$Task$Parallel$Extra$DownloadFinished5(
				$elm$core$Result$Err(error)));
	};
	var _v1 = A4($0ui$elm_task_parallel$Task$Parallel$update5, loadingModel.x7, downloadMsg, onSuccess, onError);
	var nextDownloadState = _v1.a;
	var nextCmd = _v1.b;
	return _Utils_Tuple2(
		_Utils_update(
			loadingModel,
			{x7: nextDownloadState}),
		nextCmd);
};
var $author$project$Main$updateLoading = F2(
	function (msg, model) {
		var _v0 = _Utils_Tuple2(model.cz, msg);
		_v0$22:
		while (true) {
			switch (_v0.b.$) {
				case 0:
					if (_v0.a.$ === 1) {
						if (!_v0.b.a.$) {
							var loadingModel = _v0.a.a;
							var downloadMsg = _v0.b.a.a;
							var _v1 = $author$project$Task$Parallel$Extra$parallelUpdate4(
								{g6: downloadMsg, g7: loadingModel, hh: $author$project$Msg$OrgIndexLoadingMsg});
							var nextLoadingModel = _v1.a;
							var nextCmd = _v1.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										cz: $author$project$Main$LoadingOrgIndex(nextLoadingModel)
									}),
								A2($elm$core$Platform$Cmd$map, $author$project$Msg$LoadingMsg, nextCmd));
						} else {
							var loadingModel = _v0.a.a;
							var result = _v0.b.a.a;
							var finishModelAndCmd = A4(
								$author$project$Pages$OrgIndex$createModel,
								model.l,
								model.Y,
								$author$project$Url$Extra$hostWithPort(model.fD),
								loadingModel.wd);
							var modelAndCmd = A2($elm$core$Result$map, finishModelAndCmd, result);
							var orgIndexCommand = A2(
								$elm$core$Result$withDefault,
								$elm$core$Platform$Cmd$none,
								A2(
									$elm$core$Result$map,
									$elm$core$Platform$Cmd$map($author$project$Msg$OrgIndexMsg),
									A2($elm$core$Result$map, $elm$core$Tuple$second, modelAndCmd)));
							var orgIndexModel = A2($elm$core$Result$map, $elm$core$Tuple$first, modelAndCmd);
							return A2(
								$elm$core$Tuple$mapSecond,
								function (cmds) {
									return $elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[cmds, orgIndexCommand]));
								},
								A3($author$project$Main$setPage, model, $author$project$Page$OrgIndex, orgIndexModel));
						}
					} else {
						break _v0$22;
					}
				case 1:
					if (_v0.a.$ === 2) {
						if (!_v0.b.a.$) {
							var loadingModel = _v0.a.a;
							var downloadMsg = _v0.b.a.a;
							var _v2 = $author$project$Task$Parallel$Extra$parallelUpdate5(
								{g6: downloadMsg, g7: loadingModel, hh: $author$project$Msg$ProjectConfigLoadingMsg});
							var nextLoadingModel = _v2.a;
							var nextCmd = _v2.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										cz: $author$project$Main$LoadingProjectConfig(nextLoadingModel)
									}),
								A2($elm$core$Platform$Cmd$map, $author$project$Msg$LoadingMsg, nextCmd));
						} else {
							var loadingModel = _v0.a.a;
							var result = _v0.b.a.a;
							var finishModel = A5($author$project$Pages$ProjectConfig$createModel, model.Y, model.ot, loadingModel.uk, loadingModel.yJ, loadingModel.yo);
							return A5(
								$author$project$Main$setPageWithCmd,
								model,
								$author$project$Page$ProjectConfig,
								A2($elm$core$Result$map, finishModel, result),
								A3($author$project$Pages$ProjectConfig$cmds, model.l, loadingModel.z6, loadingModel.z7),
								$author$project$Msg$ProjectConfigMsg);
						}
					} else {
						break _v0$22;
					}
				case 2:
					if (_v0.a.$ === 3) {
						if (!_v0.b.a.$) {
							var loadingModel = _v0.a.a;
							var downloadMsg = _v0.b.a.a;
							var _v3 = $author$project$Task$Parallel$Extra$parallelUpdate4(
								{g6: downloadMsg, g7: loadingModel, hh: $author$project$Msg$ProjectConfigAdvancedLoadingMsg});
							var nextLoadingModel = _v3.a;
							var nextCmd = _v3.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										cz: $author$project$Main$LoadingProjectConfigAdvanced(nextLoadingModel)
									}),
								A2($elm$core$Platform$Cmd$map, $author$project$Msg$LoadingMsg, nextCmd));
						} else {
							var result = _v0.b.a.a;
							var finishModel = $author$project$Pages$ProjectConfigAdvanced$createModel(model.Y);
							return A5(
								$author$project$Main$setPageWithCmd,
								model,
								$author$project$Page$ProjectConfigAdvanced,
								A2($elm$core$Result$map, finishModel, result),
								$author$project$Pages$ProjectConfigAdvanced$cmds,
								$author$project$Msg$ProjectConfigAdvancedMsg);
						}
					} else {
						break _v0$22;
					}
				case 3:
					if (_v0.a.$ === 4) {
						if (!_v0.b.a.$) {
							var loadingModel = _v0.a.a;
							var downloadMsg = _v0.b.a.a;
							var _v4 = $author$project$Task$Parallel$Extra$parallelUpdate5(
								{g6: downloadMsg, g7: loadingModel, hh: $author$project$Msg$ProjectDownloadsLoadingMsg});
							var nextLoadingModel = _v4.a;
							var nextCmd = _v4.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										cz: $author$project$Main$LoadingProjectDownloads(nextLoadingModel)
									}),
								A2($elm$core$Platform$Cmd$map, $author$project$Msg$LoadingMsg, nextCmd));
						} else {
							var loadingModel = _v0.a.a;
							var result = _v0.b.a.a;
							var finishModel = A3($author$project$Pages$ProjectDownloads$createModel, model.l, model.Y, loadingModel.CZ);
							var resultModel = A2($elm$core$Result$map, finishModel, result);
							return A5($author$project$Main$setPageWithCmdOnly, model, $author$project$Page$ProjectDownloads, resultModel, $author$project$Pages$ProjectDownloads$cmds, $author$project$Msg$ProjectDownloadsMsg);
						}
					} else {
						break _v0$22;
					}
				case 4:
					if (_v0.a.$ === 5) {
						if (!_v0.b.a.$) {
							var loadingModel = _v0.a.a;
							var downloadMsg = _v0.b.a.a;
							var _v5 = $author$project$Task$Parallel$Extra$parallelUpdate4(
								{g6: downloadMsg, g7: loadingModel, hh: $author$project$Msg$ProjectHistoryLoadingMsg});
							var nextLoadingModel = _v5.a;
							var nextCmd = _v5.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										cz: $author$project$Main$LoadingProjectHistory(nextLoadingModel)
									}),
								A2($elm$core$Platform$Cmd$map, $author$project$Msg$LoadingMsg, nextCmd));
						} else {
							var result = _v0.b.a.a;
							var finishModel = $author$project$Pages$ProjectHistory$createModel(model.Y);
							var resultModel = A2($elm$core$Result$map, finishModel, result);
							return A5(
								$author$project$Main$setPageWithCmdOnly,
								model,
								$author$project$Page$ProjectHistory,
								resultModel,
								$author$project$Pages$ProjectHistory$cmds(model.l),
								$author$project$Msg$ProjectHistoryMsg);
						}
					} else {
						break _v0$22;
					}
				case 5:
					if (_v0.a.$ === 6) {
						if (!_v0.b.a.$) {
							var loadingModel = _v0.a.a;
							var downloadMsg = _v0.b.a.a;
							var _v6 = $author$project$Task$Parallel$Extra$parallelUpdate2(
								{g6: downloadMsg, g7: loadingModel, hh: $author$project$Msg$ProjectImpactReportLoadingMsg});
							var nextLoadingModel = _v6.a;
							var nextCmd = _v6.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										cz: $author$project$Main$LoadingProjectImpactReport(nextLoadingModel)
									}),
								A2($elm$core$Platform$Cmd$map, $author$project$Msg$LoadingMsg, nextCmd));
						} else {
							var loadingModel = _v0.a.a;
							var result = _v0.b.a.a;
							var finishModel = A2($author$project$Pages$ProjectImpactReport$createModel, model.Y, loadingModel);
							var resultModel = A2($elm$core$Result$map, finishModel, result);
							var isAllowed = function () {
								if (!resultModel.$) {
									var m = resultModel.a;
									return A2(
										$author$project$Model$Permissions$canViewImpactReport,
										$author$project$Pages$ProjectImpactReport$getOrganization(m),
										$author$project$Model$Session$getUser(model.l));
								} else {
									return true;
								}
							}();
							return isAllowed ? A5(
								$author$project$Main$setPageWithCmd,
								model,
								$author$project$Page$ProjectImpactReport,
								resultModel,
								$author$project$Pages$ProjectImpactReport$cmds(model.l),
								$author$project$Msg$ProjectImpactReportMsg) : A3(
								$author$project$Main$setPage,
								model,
								$author$project$Page$NotFound,
								$elm$core$Result$Ok(
									$author$project$Pages$NotFound$init(model.Y)));
						}
					} else {
						break _v0$22;
					}
				case 6:
					if (_v0.a.$ === 7) {
						if (!_v0.b.a.$) {
							var loadingModel = _v0.a.a;
							var downloadMsg = _v0.b.a.a;
							var _v8 = $author$project$Task$Parallel$Extra$parallelUpdate3(
								{g6: downloadMsg, g7: loadingModel, hh: $author$project$Msg$ProjectPreviewLoadingMsg});
							var nextLoadingModel = _v8.a;
							var nextCmd = _v8.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										cz: $author$project$Main$LoadingProjectPreview(nextLoadingModel)
									}),
								A2($elm$core$Platform$Cmd$map, $author$project$Msg$LoadingMsg, nextCmd));
						} else {
							var result = _v0.b.a.a;
							var finishModel = $author$project$Pages$ProjectPreview$createModel(model.Y);
							var resultModel = A2($elm$core$Result$map, finishModel, result);
							return A3($author$project$Main$setPage, model, $author$project$Page$ProjectPreview, resultModel);
						}
					} else {
						break _v0$22;
					}
				case 7:
					if (_v0.a.$ === 10) {
						if (!_v0.b.a.$) {
							var loadingModel = _v0.a.a;
							var downloadMsg = _v0.b.a.a;
							var _v9 = $author$project$Task$Parallel$Extra$parallelUpdate3(
								{g6: downloadMsg, g7: loadingModel, hh: $author$project$Msg$OrgPolicyLoadingMsg});
							var nextLoadingModel = _v9.a;
							var nextCmd = _v9.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										cz: $author$project$Main$LoadingOrgPolicy(nextLoadingModel)
									}),
								A2($elm$core$Platform$Cmd$map, $author$project$Msg$LoadingMsg, nextCmd));
						} else {
							var result = _v0.b.a.a;
							if (!result.$) {
								var _v11 = result.a;
								var organization = _v11.a.c3;
								var user = $author$project$Model$Session$getUser(model.l);
								if (A2($author$project$Model$Permissions$canViewOrgPolicy, organization, user)) {
									var finishModel = $author$project$Pages$OrgPolicy$createModel(model.l);
									var resultModel = A2($elm$core$Result$map, finishModel, result);
									return A3($author$project$Main$setPage, model, $author$project$Page$OrgPolicy, resultModel);
								} else {
									return A2(
										$author$project$Misc$with,
										$elm$core$Platform$Cmd$none,
										_Utils_update(
											model,
											{
												u: A2(
													$author$project$PageState$load,
													model.u,
													$author$project$Page$NotFound(
														$author$project$Pages$NotFound$init(model.Y)))
											}));
								}
							} else {
								var err = result.a;
								return A2(
									$author$project$Misc$with,
									$elm$core$Platform$Cmd$none,
									_Utils_update(
										model,
										{
											u: A2(
												$author$project$PageState$load,
												model.u,
												A2($author$project$Main$loadPageFromErr, model, err))
										}));
							}
						}
					} else {
						break _v0$22;
					}
				case 8:
					if (_v0.a.$ === 11) {
						if (!_v0.b.a.$) {
							var loadingModel = _v0.a.a;
							var downloadMsg = _v0.b.a.a;
							var _v12 = $author$project$Task$Parallel$Extra$parallelUpdate3(
								{g6: downloadMsg, g7: loadingModel, hh: $author$project$Msg$OrgRemediationLoadingMsg});
							var nextLoadingModel = _v12.a;
							var nextCmd = _v12.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										cz: $author$project$Main$LoadingOrgRemediation(nextLoadingModel)
									}),
								A2($elm$core$Platform$Cmd$map, $author$project$Msg$LoadingMsg, nextCmd));
						} else {
							var result = _v0.b.a.a;
							if (!result.$) {
								var _v14 = result.a;
								var organization = _v14.a.c3;
								var user = $author$project$Model$Session$getUser(model.l);
								if (A2($author$project$Model$Permissions$canViewOrgDependencies, organization, user)) {
									var finishModel = $author$project$Pages$OrgRemediation$createModel(model.l);
									var resultModel = A2($elm$core$Result$map, finishModel, result);
									return A5(
										$author$project$Main$setPageWithCmdOnly,
										model,
										$author$project$Page$OrgRemediation,
										resultModel,
										$author$project$Pages$OrgRemediation$cmds(model.l),
										$author$project$Msg$OrgRemediationMsg);
								} else {
									return A2(
										$author$project$Misc$with,
										$elm$core$Platform$Cmd$none,
										_Utils_update(
											model,
											{
												u: A2(
													$author$project$PageState$load,
													model.u,
													$author$project$Page$NotFound(
														$author$project$Pages$NotFound$init(model.Y)))
											}));
								}
							} else {
								var err = result.a;
								return A2(
									$author$project$Misc$with,
									$elm$core$Platform$Cmd$none,
									_Utils_update(
										model,
										{
											u: A2(
												$author$project$PageState$load,
												model.u,
												A2($author$project$Main$loadPageFromErr, model, err))
										}));
							}
						}
					} else {
						break _v0$22;
					}
				case 9:
					if (_v0.a.$ === 8) {
						if (!_v0.b.a.$) {
							var loadingModel = _v0.a.a;
							var downloadMsg = _v0.b.a.a;
							var _v15 = $author$project$Task$Parallel$Extra$parallelUpdate2(
								{g6: downloadMsg, g7: loadingModel, hh: $author$project$Msg$OrgSecurityLoadingMsg});
							var nextLoadingModel = _v15.a;
							var nextCmd = _v15.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										cz: $author$project$Main$LoadingOrgSecurity(nextLoadingModel)
									}),
								A2($elm$core$Platform$Cmd$map, $author$project$Msg$LoadingMsg, nextCmd));
						} else {
							var result = _v0.b.a.a;
							if (!result.$) {
								var _v17 = result.a;
								var organization = _v17.a;
								var user = $author$project$Model$Session$getUser(model.l);
								if (A2($author$project$Model$Permissions$canViewOrgSecurity, organization, user)) {
									var finishModel = $author$project$Pages$OrgSecurity$createModel(model.l);
									var resultModel = A2($elm$core$Result$map, finishModel, result);
									return A5(
										$author$project$Main$setPageWithCmdOnly,
										model,
										$author$project$Page$OrgSecurity,
										resultModel,
										$author$project$Pages$OrgSecurity$cmds(model.l),
										$author$project$Msg$OrgSecurityMsg);
								} else {
									return A2(
										$author$project$Misc$with,
										$elm$core$Platform$Cmd$none,
										_Utils_update(
											model,
											{
												u: A2(
													$author$project$PageState$load,
													model.u,
													$author$project$Page$NotFound(
														$author$project$Pages$NotFound$init(model.Y)))
											}));
								}
							} else {
								var err = result.a;
								return A2(
									$author$project$Misc$with,
									$elm$core$Platform$Cmd$none,
									_Utils_update(
										model,
										{
											u: A2(
												$author$project$PageState$load,
												model.u,
												A2($author$project$Main$loadPageFromErr, model, err))
										}));
							}
						}
					} else {
						break _v0$22;
					}
				default:
					if (_v0.a.$ === 9) {
						if (!_v0.b.a.$) {
							var loadingModel = _v0.a.a;
							var downloadMsg = _v0.b.a.a;
							var _v18 = $author$project$Task$Parallel$Extra$parallelUpdate2(
								{g6: downloadMsg, g7: loadingModel, hh: $author$project$Msg$OrgDependenciesLoadingMsg});
							var nextLoadingModel = _v18.a;
							var nextCmd = _v18.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										cz: $author$project$Main$LoadingOrgDependencies(nextLoadingModel)
									}),
								A2($elm$core$Platform$Cmd$map, $author$project$Msg$LoadingMsg, nextCmd));
						} else {
							var result = _v0.b.a.a;
							if (!result.$) {
								var _v20 = result.a;
								var organization = _v20.a;
								var user = $author$project$Model$Session$getUser(model.l);
								if (A2($author$project$Model$Permissions$canViewOrgDependencies, organization, user)) {
									var finishModel = $author$project$Pages$OrgDependencies$createModel(model.l);
									var resultModel = A2($elm$core$Result$map, finishModel, result);
									return A5(
										$author$project$Main$setPageWithCmdOnly,
										model,
										$author$project$Page$OrgDependencies,
										resultModel,
										$author$project$Pages$OrgDependencies$cmds(model.l),
										$author$project$Msg$OrgDependenciesMsg);
								} else {
									return A2(
										$author$project$Misc$with,
										$elm$core$Platform$Cmd$none,
										_Utils_update(
											model,
											{
												u: A2(
													$author$project$PageState$load,
													model.u,
													$author$project$Page$NotFound(
														$author$project$Pages$NotFound$init(model.Y)))
											}));
								}
							} else {
								var err = result.a;
								return A2(
									$author$project$Misc$with,
									$elm$core$Platform$Cmd$none,
									_Utils_update(
										model,
										{
											u: A2(
												$author$project$PageState$load,
												model.u,
												A2($author$project$Main$loadPageFromErr, model, err))
										}));
							}
						}
					} else {
						break _v0$22;
					}
			}
		}
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Main$update = F2(
	function (action, model) {
		var toPage = F5(
			function (toModel, toMsg, subUpdate, subMsg, subModel) {
				if ($author$project$PageState$isPageLoading(model.u)) {
					return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
				} else {
					var _v71 = A2(subUpdate, subMsg, subModel);
					var newModel = _v71.a;
					var newCmd = _v71.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								u: A2(
									$author$project$PageState$load,
									model.u,
									toModel(newModel))
							}),
						A2($elm$core$Platform$Cmd$map, toMsg, newCmd));
				}
			});
		var session = model.l;
		var toPageWithExternalMsg = F5(
			function (toModel, toMsg, subUpdate, subMsg, subModel) {
				if ($author$project$PageState$isPageLoading(model.u)) {
					return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
				} else {
					var _v68 = A2(subUpdate, subMsg, subModel);
					var _v69 = _v68.a;
					var pageModel = _v69.a;
					var newCmd = _v69.b;
					var externalMsg = _v68.b;
					var _v70 = A2($author$project$Main$updateFromExternalMsg, externalMsg, session);
					var newSession = _v70.a;
					var sessionCmd = _v70.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								u: A2(
									$author$project$PageState$load,
									model.u,
									toModel(pageModel)),
								l: newSession
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, toMsg, newCmd),
									sessionCmd
								])));
				}
			});
		var page = $author$project$PageState$getPage(model.u);
		var blockMsg = function () {
			switch (action.$) {
				case 97:
					return false;
				case 98:
					return false;
				case 9:
					return false;
				case 62:
					return false;
				case 64:
					return false;
				case 61:
					return false;
				default:
					return true;
			}
		}();
		var _v0 = A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2('', false),
			A2(
				$elm$core$Maybe$andThen,
				function (user) {
					return A2(
						$elm$core$Maybe$map,
						function (compliance) {
							return _Utils_Tuple2(
								$author$project$Model$Compliance$companyName(compliance),
								$author$project$Model$Compliance$block(compliance));
						},
						user.EC);
				},
				$author$project$Model$Session$getUser(session)));
		var companyName = _v0.a;
		var notCompliant = _v0.b;
		if (notCompliant && blockMsg) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						u: A2(
							$author$project$PageState$load,
							model.u,
							$author$project$Page$OutOfCompliance(
								$author$project$Pages$OutOfCompliance$init(companyName)))
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			switch (action.$) {
				case 0:
					return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
				case 107:
					if (!action.a.$) {
						var invitations = action.a.a;
						return A2(
							$author$project$Misc$with,
							$elm$core$Platform$Cmd$none,
							_Utils_update(
								model,
								{
									l: A2($author$project$Model$Session$setInviations, model.l, invitations)
								}));
					} else {
						var err = action.a.a;
						return _Utils_Tuple2(
							model,
							A3($author$project$Main$rollbar.FZ, 'ReceivedInvitations (Err err)', err, session));
					}
				case 1:
					var sessionMsg = action.a;
					var _v2 = A2($author$project$Model$Session$update, sessionMsg, model.l);
					var newSession = _v2.a;
					var cmd = _v2.b;
					return A2(
						$author$project$Misc$with,
						A2($elm$core$Platform$Cmd$map, $author$project$Msg$SessionMsg, cmd),
						_Utils_update(
							model,
							{l: newSession}));
				case 8:
					var currentTime = action.a;
					return A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								cF: $elm$core$Maybe$Just(currentTime)
							}));
				case 9:
					var urlRequest = action.a;
					if (!urlRequest.$) {
						var url = urlRequest.a;
						return A2(
							$author$project$Misc$with,
							A2(
								$elm$browser$Browser$Navigation$pushUrl,
								model.Y,
								$elm$url$Url$toString(url)),
							model);
					} else {
						var url = urlRequest.a;
						return A2(
							$author$project$Misc$with,
							$elm$browser$Browser$Navigation$load(url),
							model);
					}
				case 2:
					return A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								l: A2(
									$author$project$Model$Session$setDropdownOpen,
									!$author$project$Model$Session$getDropdownOpen(model.l),
									model.l)
							}));
				case 3:
					var newTheme = action.a;
					var _v4 = A2($author$project$Model$Session$setTheme, newTheme, model.l);
					var newSession = _v4.a;
					var sessionCmd = _v4.b;
					return A2(
						$author$project$Misc$with,
						sessionCmd,
						_Utils_update(
							model,
							{l: newSession}));
				case 4:
					return A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								l: A2(
									$author$project$Model$Session$setOrgDropdownOpen,
									!$author$project$Model$Session$getOrgDropdownOpen(model.l),
									model.l)
							}));
				case 5:
					var newSuperUserFeaturesVisible = !$author$project$Model$Session$getSuperUserFeaturesVisible(session);
					var _v5 = A2($author$project$Model$Session$setSuperUserFeaturesVisible, newSuperUserFeaturesVisible, model.l);
					var newSession = _v5.a;
					var sessionCmd = _v5.b;
					return A2(
						$author$project$Misc$with,
						sessionCmd,
						_Utils_update(
							model,
							{l: newSession}));
				case 6:
					var authToken = $author$project$Protected$getToken(
						$author$project$Model$Session$getCreds(session));
					var authHeader = $elm$core$String$isEmpty(authToken) ? authToken : ('Bearer ' + authToken);
					var copyToClipboardCmd = $author$project$Ports$copyToClipboard(
						{xN: $author$project$Main$authTokenCopyID, Gv: authHeader});
					return A2($author$project$Misc$with, copyToClipboardCmd, model);
				case 7:
					var status = action.a;
					if (_Utils_eq(status.xN, $author$project$Main$authTokenCopyID) && status.L) {
						var _v6 = A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Msg$SessionMsg),
							A2(
								$author$project$Model$Session$addNotification,
								$author$project$Model$Notification$textSuccess('Auth Header Copied!'),
								session));
						var notifSession = _v6.a;
						var cmd = _v6.b;
						return A2(
							$author$project$Misc$with,
							cmd,
							_Utils_update(
								model,
								{l: notifSession}));
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 62:
					var route = action.a;
					return A2($author$project$Main$setRoute, route, model);
				case 63:
					return A2(
						$author$project$Misc$with,
						A2(
							$elm$core$Task$attempt,
							$author$project$Msg$OnRenew($elm$core$Maybe$Nothing),
							$author$project$Request$User$renew),
						model);
				case 64:
					if (!action.b.$) {
						var maybeRoute = action.a;
						var jwt = action.b.a;
						var maybeHubspotChat = $author$project$Model$User$isPaidUser(
							$elm$core$Maybe$Just(jwt.gS)) ? $author$project$Ports$loadHubSpotChat(0) : $author$project$Ports$removeHubSpotChat(0);
						var _v7 = A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Msg$SessionMsg),
							A2($author$project$Model$Session$setJWT, jwt, model.l));
						var jwtSession = _v7.a;
						var sessionCmd = _v7.b;
						var jwtModel = _Utils_update(
							model,
							{l: jwtSession});
						var _v8 = function () {
							if (!maybeRoute.$) {
								var route = maybeRoute.a;
								return A2(
									$author$project$Misc$with,
									A2($author$project$Routing$pushUrl, model.Y, route),
									jwtModel);
							} else {
								return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, jwtModel);
							}
						}();
						var newModel = _v8.a;
						var newCmd = _v8.b;
						return _Utils_Tuple2(
							newModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										newCmd,
										sessionCmd,
										maybeHubspotChat,
										$author$project$Main$invitationsCmd(jwtSession)
									])));
					} else {
						var maybeRoute = action.a;
						var newModel = _Utils_update(
							model,
							{
								l: A2($author$project$Model$Session$setCreds, $author$project$Protected$empty, model.l)
							});
						if (!maybeRoute.$) {
							var route = maybeRoute.a;
							return A2(
								$author$project$Misc$with,
								A2($author$project$Routing$pushUrl, model.Y, route),
								newModel);
						} else {
							return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, newModel);
						}
					}
				case 100:
					var url = action.a;
					return A2(
						$author$project$Misc$with,
						$elm$browser$Browser$Navigation$load(url),
						model);
				case 61:
					var revertSession = $author$project$Model$Session$isImpersonating(session);
					var routeCmd = revertSession ? A2(
						$elm$core$Task$attempt,
						$elm$core$Basics$always(
							$author$project$Msg$LoadUrl('/')),
						$author$project$Request$User$logout) : $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Task$attempt,
								$elm$core$Basics$always($author$project$Msg$NoOp),
								$author$project$Request$User$logout),
								A2($author$project$Routing$replaceUrl, model.Y, $author$project$Model$Route$login)
							]));
					var _v11 = $author$project$Model$Session$reset(session);
					var newSession = _v11.a;
					var sessionCmd = _v11.b;
					return A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Ports$stopRecordingUser(0),
									routeCmd,
									sessionCmd
								])),
						{
							cF: model.cF,
							ot: model.ot,
							Y: model.Y,
							cz: $author$project$Main$NotLoading,
							fD: model.fD,
							u: A2($author$project$PageState$init, $author$project$Page$Blank, $author$project$Model$Route$login),
							l: newSession,
							hS: $elm$core$Maybe$Nothing,
							hT: $elm$core$Maybe$Nothing
						});
				case 16:
					var subMsg = action.a;
					if (page.$ === 16) {
						var subModel = page.a;
						return A5(
							toPageWithExternalMsg,
							$author$project$Page$OrgIndex,
							$author$project$Msg$OrgIndexMsg,
							$author$project$Pages$OrgIndex$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 17:
					var subMsg = action.a;
					if (page.$ === 17) {
						var subModel = page.a;
						return A5(
							toPageWithExternalMsg,
							$author$project$Page$Orgs,
							$author$project$Msg$OrgsMsg,
							$author$project$Pages$Orgs$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 21:
					var result = action.a;
					return A3($author$project$Main$setPage, model, $author$project$Page$OrgMembers, result);
				case 26:
					var result = action.a;
					return A3($author$project$Main$setPage, model, $author$project$Page$OrgSettings, result);
				case 27:
					var result = action.a;
					return A3($author$project$Main$setPage, model, $author$project$Page$OrgScan, result);
				case 15:
					var result = action.a;
					return A5(
						$author$project$Main$setPageWithCmdOnly,
						model,
						$author$project$Page$ActivateMembership,
						result,
						$author$project$Pages$ActivateMembership$cmds(session),
						$author$project$Msg$ActivateMembershipMsg);
				case 11:
					var result = action.a;
					return A5(
						$author$project$Main$setPageWithCmdOnly,
						model,
						$author$project$Page$CheckEmail,
						result,
						$author$project$Pages$CheckEmail$cmds(session),
						$author$project$Msg$CheckEmailMsg);
				case 66:
					var result = action.a;
					return A3($author$project$Main$setPage, model, $author$project$Page$AdminFeatures, result);
				case 69:
					var result = action.a;
					return A3($author$project$Main$setPage, model, $author$project$Page$AdminOrganizations, result);
				case 68:
					var result = action.a;
					return A3($author$project$Main$setPage, model, $author$project$Page$AdminIconomicon, result);
				case 75:
					var result = action.a;
					return A3($author$project$Main$setPage, model, $author$project$Page$AdminOrganization, result);
				case 71:
					var result = action.a;
					return A3($author$project$Main$setPage, model, $author$project$Page$AdminUsers, result);
				case 72:
					var result = action.a;
					return A3($author$project$Main$setPage, model, $author$project$Page$AdminUser, result);
				case 78:
					var result = action.a;
					return A3($author$project$Main$setPage, model, $author$project$Page$AdminCreateOrganization, result);
				case 85:
					var result = action.a;
					return A3($author$project$Main$setPage, model, $author$project$Page$PublicProjects, result);
				case 87:
					var result = action.a;
					return A3($author$project$Main$setPage, model, $author$project$Page$Support, result);
				case 89:
					var result = action.a;
					return A3($author$project$Main$setPage, model, $author$project$Page$StateToolCheatSheet, result);
				case 57:
					var result = action.a;
					return A3($author$project$Main$setPage, model, $author$project$Page$ForgotPassword, result);
				case 60:
					var result = action.a;
					return A3($author$project$Main$setPage, model, $author$project$Page$ResetPassword, result);
				case 36:
					var result = action.a;
					return A3($author$project$Main$setPage, model, $author$project$Page$PreferenceEmail, result);
				case 37:
					var result = action.a;
					return A3($author$project$Main$setPage, model, $author$project$Page$PreferencePassword, result);
				case 80:
					var result = action.a;
					return A5(
						$author$project$Main$setPageWithCmdOnly,
						model,
						$author$project$Page$CreateOrganization,
						result,
						$author$project$Pages$CreateOrganization$cmds(session),
						$author$project$Msg$CreateOrganizationMsg);
				case 38:
					var result = action.a;
					return A3($author$project$Main$setPage, model, $author$project$Page$PreferenceTwoFactor, result);
				case 31:
					var result = action.a;
					return A3($author$project$Main$setPage, model, $author$project$Page$PreferenceLinkedAccounts, result);
				case 39:
					var result = action.a;
					return A3($author$project$Main$setPage, model, $author$project$Page$PreferenceDeleteAccount, result);
				case 43:
					var result = action.a;
					return A5($author$project$Main$setPageWithCmdOnly, model, $author$project$Page$ProjectOverview, result, $author$project$Pages$ProjectOverview$cmds, $author$project$Msg$ProjectOverviewMsg);
				case 47:
					var result = action.a;
					return A5($author$project$Main$setPageWithCmdOnly, model, $author$project$Page$ProjectSettings, result, $author$project$Pages$ProjectSettings$cmds, $author$project$Msg$ProjectSettingsMsg);
				case 49:
					var result = action.a;
					return A5(
						$author$project$Main$setPageWithCmdOnly,
						model,
						$author$project$Page$ProjectSettingsHAR,
						result,
						$author$project$Pages$ProjectSettingsHAR$cmds(session),
						$author$project$Msg$ProjectSettingsHARMsg);
				case 51:
					var result = action.a;
					return A3($author$project$Main$setPage, model, $author$project$Page$ProjectSettingsBranches, result);
				case 53:
					var result = action.a;
					return A3($author$project$Main$setPage, model, $author$project$Page$SupplementalLicenseTerms, result);
				case 13:
					var subMsg = action.a;
					if (page.$ === 6) {
						var subModel = page.a;
						return A5(
							toPageWithExternalMsg,
							$author$project$Page$ActivateMembership,
							$author$project$Msg$ActivateMembershipMsg,
							$author$project$Pages$ActivateMembership$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 18:
					var result = action.a;
					return A5($author$project$Main$setPageWithCmdOnly, model, $author$project$Page$Orgs, result, $author$project$Pages$Orgs$cmds, $author$project$Msg$OrgsMsg);
				case 20:
					var subMsg = action.a;
					if (page.$ === 19) {
						var subModel = page.a;
						return A5(
							toPageWithExternalMsg,
							$author$project$Page$OrgMembers,
							$author$project$Msg$OrgMembersMsg,
							$author$project$Pages$OrgMembers$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 32:
					var subMsg = action.a;
					if (page.$ === 12) {
						var subModel = page.a;
						return A5(
							toPageWithExternalMsg,
							$author$project$Page$PreferenceEmail,
							$author$project$Msg$PreferenceEmailMsg,
							$author$project$Pages$PreferenceEmail$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 33:
					var subMsg = action.a;
					if (page.$ === 13) {
						var subModel = page.a;
						return A5(
							toPageWithExternalMsg,
							$author$project$Page$PreferencePassword,
							$author$project$Msg$PreferencePasswordMsg,
							$author$project$Pages$PreferencePassword$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 30:
					var subMsg = action.a;
					if (page.$ === 14) {
						var subModel = page.a;
						return A5(
							toPageWithExternalMsg,
							$author$project$Page$PreferenceLinkedAccounts,
							$author$project$Msg$PreferenceLinkedAccountsMsg,
							$author$project$Pages$PreferenceLinkedAccounts$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 35:
					var subMsg = action.a;
					if (page.$ === 15) {
						var subModel = page.a;
						return A5(
							toPageWithExternalMsg,
							$author$project$Page$PreferenceDeleteAccount,
							$author$project$Msg$PreferenceDeleteAccountMsg,
							$author$project$Pages$PreferenceDeleteAccount$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 10:
					var subMsg = action.a;
					if (page.$ === 7) {
						var subModel = page.a;
						return A5(
							toPageWithExternalMsg,
							$author$project$Page$CheckEmail,
							$author$project$Msg$CheckEmailMsg,
							$author$project$Pages$CheckEmail$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 34:
					var subMsg = action.a;
					if (page.$ === 11) {
						var subModel = page.a;
						return A5(
							toPageWithExternalMsg,
							$author$project$Page$PreferenceTwoFactor,
							$author$project$Msg$PreferenceTwoFactorMsg,
							$author$project$Pages$PreferenceTwoFactor$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 70:
					var subMsg = action.a;
					if (page.$ === 36) {
						var subModel = page.a;
						return A5(
							toPageWithExternalMsg,
							$author$project$Page$AdminOrganizations,
							$author$project$Msg$AdminOrganizationsMsg,
							$author$project$Pages$AdminOrganizations$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 76:
					var subMsg = action.a;
					if (page.$ === 37) {
						var subModel = page.a;
						return A5(
							toPageWithExternalMsg,
							$author$project$Page$AdminOrganization,
							$author$project$Msg$AdminOrganizationMsg,
							$author$project$Pages$AdminOrganization$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 65:
					var subMsg = action.a;
					if (page.$ === 40) {
						var subModel = page.a;
						return A5(
							toPageWithExternalMsg,
							$author$project$Page$AdminFeatures,
							$author$project$Msg$AdminFeaturesMsg,
							$author$project$Pages$AdminFeatures$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 73:
					var subMsg = action.a;
					if (page.$ === 38) {
						var subModel = page.a;
						return A5(
							toPageWithExternalMsg,
							$author$project$Page$AdminUsers,
							$author$project$Msg$AdminUsersMsg,
							$author$project$Pages$AdminUsers$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 74:
					var subMsg = action.a;
					if (page.$ === 39) {
						var subModel = page.a;
						return A5(
							toPageWithExternalMsg,
							$author$project$Page$AdminUser,
							$author$project$Msg$AdminUserMsg,
							$author$project$Pages$AdminUser$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 67:
					var subMsg = action.a;
					if (page.$ === 35) {
						var subModel = page.a;
						return A5(toPageWithExternalMsg, $author$project$Page$AdminIconomicon, $author$project$Msg$AdminIconomiconMsg, $author$project$Pages$AdminIconomicon$update, subMsg, subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 77:
					var subMsg = action.a;
					if (page.$ === 41) {
						var subModel = page.a;
						return A5(
							toPageWithExternalMsg,
							$author$project$Page$AdminCreateOrganization,
							$author$project$Msg$AdminCreateOrganizationMsg,
							$author$project$Pages$AdminCreateOrganization$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 86:
					var subMsg = action.a;
					if (page.$ === 43) {
						var subModel = page.a;
						return A5(toPage, $author$project$Page$Support, $author$project$Msg$SupportMsg, $author$project$Pages$Support$update, subMsg, subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 88:
					var subMsg = action.a;
					if (page.$ === 44) {
						var subModel = page.a;
						return A5(toPage, $author$project$Page$StateToolCheatSheet, $author$project$Msg$StateToolCheatSheetMsg, $author$project$Pages$StateToolCheatSheet$update, subMsg, subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 12:
					var subMsg = action.a;
					if (page.$ === 3) {
						var subModel = page.a;
						return A5(
							toPageWithExternalMsg,
							$author$project$Page$CreateAccount,
							$author$project$Msg$CreateAccountMsg,
							$author$project$Pages$CreateAccount$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 79:
					var subMsg = action.a;
					if (page.$ === 4) {
						var subModel = page.a;
						return A5(
							toPageWithExternalMsg,
							$author$project$Page$CreateOrganization,
							$author$project$Msg$CreateOrganizationMsg,
							$author$project$Pages$CreateOrganization$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 56:
					var subMsg = action.a;
					if (page.$ === 8) {
						var subModel = page.a;
						return A5(
							toPage,
							$author$project$Page$ForgotPassword,
							$author$project$Msg$ForgotPasswordMsg,
							$author$project$Pages$ForgotPassword$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 58:
					var subMsg = action.a;
					if (page.$ === 9) {
						var subModel = page.a;
						return A5(
							toPageWithExternalMsg,
							$author$project$Page$ConnectAccount,
							$author$project$Msg$ConnectAccountMsg,
							$author$project$Pages$ConnectAccount$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 59:
					var subMsg = action.a;
					if (page.$ === 10) {
						var subModel = page.a;
						return A5(
							toPage,
							$author$project$Page$ResetPassword,
							$author$project$Msg$ResetPasswordMsg,
							$author$project$Pages$ResetPassword$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 22:
					var subMsg = action.a;
					if (page.$ === 23) {
						var subModel = page.a;
						return A5(
							toPageWithExternalMsg,
							$author$project$Page$OrgPolicy,
							$author$project$Msg$OrgPolicyMsg,
							$author$project$Pages$OrgPolicy$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 23:
					var subMsg = action.a;
					if (page.$ === 24) {
						var subModel = page.a;
						return A5(
							toPageWithExternalMsg,
							$author$project$Page$OrgRemediation,
							$author$project$Msg$OrgRemediationMsg,
							$author$project$Pages$OrgRemediation$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 24:
					var subMsg = action.a;
					if (page.$ === 20) {
						var subModel = page.a;
						return A5(
							toPageWithExternalMsg,
							$author$project$Page$OrgSettings,
							$author$project$Msg$OrgSettingsMsg,
							$author$project$Pages$OrgSettings$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 25:
					var subMsg = action.a;
					if (page.$ === 21) {
						var subModel = page.a;
						return A5(
							toPageWithExternalMsg,
							$author$project$Page$OrgScan,
							$author$project$Msg$OrgScanMsg,
							$author$project$Pages$OrgScan$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 29:
					var subMsg = action.a;
					if (page.$ === 22) {
						var subModel = page.a;
						return A5(toPage, $author$project$Page$OrgDependencies, $author$project$Msg$OrgDependenciesMsg, $author$project$Pages$OrgDependencies$update, subMsg, subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 28:
					var subMsg = action.a;
					if (page.$ === 18) {
						var subModel = page.a;
						return A5(toPage, $author$project$Page$OrgSecurity, $author$project$Msg$OrgSecurityMsg, $author$project$Pages$OrgSecurity$update, subMsg, subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 55:
					var subMsg = action.a;
					if (page.$ === 2) {
						var subModel = page.a;
						return A5(
							toPageWithExternalMsg,
							$author$project$Page$Login,
							$author$project$Msg$LoginMsg,
							$author$project$Pages$Login$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 40:
					var subMsg = action.a;
					if (page.$ === 25) {
						var subModel = page.a;
						return A5(
							toPageWithExternalMsg,
							$author$project$Page$ProjectConfig,
							$author$project$Msg$ProjectConfigMsg,
							$author$project$Pages$ProjectConfig$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 41:
					var subMsg = action.a;
					if (page.$ === 26) {
						var subModel = page.a;
						return A5(
							toPageWithExternalMsg,
							$author$project$Page$ProjectConfigAdvanced,
							$author$project$Msg$ProjectConfigAdvancedMsg,
							$author$project$Pages$ProjectConfigAdvanced$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 42:
					var subMsg = action.a;
					if (page.$ === 27) {
						var subModel = page.a;
						return A5(
							toPageWithExternalMsg,
							$author$project$Page$ProjectOverview,
							$author$project$Msg$ProjectOverviewMsg,
							$author$project$Pages$ProjectOverview$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 44:
					var subMsg = action.a;
					if (page.$ === 28) {
						var subModel = page.a;
						return A5(
							toPageWithExternalMsg,
							$author$project$Page$ProjectDownloads,
							$author$project$Msg$ProjectDownloadsMsg,
							$author$project$Pages$ProjectDownloads$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 45:
					var subMsg = action.a;
					if (page.$ === 29) {
						var subModel = page.a;
						return A5(
							toPageWithExternalMsg,
							$author$project$Page$ProjectHistory,
							$author$project$Msg$ProjectHistoryMsg,
							$author$project$Pages$ProjectHistory$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 46:
					var subMsg = action.a;
					if (page.$ === 30) {
						var subModel = page.a;
						return A5(
							toPageWithExternalMsg,
							$author$project$Page$ProjectImpactReport,
							$author$project$Msg$ProjectImpactReportMsg,
							$author$project$Pages$ProjectImpactReport$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 48:
					var subMsg = action.a;
					if (page.$ === 31) {
						var subModel = page.a;
						return A5(
							toPageWithExternalMsg,
							$author$project$Page$ProjectSettings,
							$author$project$Msg$ProjectSettingsMsg,
							$author$project$Pages$ProjectSettings$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 50:
					var subMsg = action.a;
					if (page.$ === 32) {
						var subModel = page.a;
						return A5(
							toPageWithExternalMsg,
							$author$project$Page$ProjectSettingsHAR,
							$author$project$Msg$ProjectSettingsHARMsg,
							$author$project$Pages$ProjectSettingsHAR$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 52:
					var subMsg = action.a;
					if (page.$ === 33) {
						var subModel = page.a;
						return A5(
							toPageWithExternalMsg,
							$author$project$Page$ProjectSettingsBranches,
							$author$project$Msg$ProjectSettingsBranchesMsg,
							$author$project$Pages$ProjectSettingsBranches$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 54:
					var subMsg = action.a;
					if (page.$ === 34) {
						var subModel = page.a;
						return A5(
							toPage,
							$author$project$Page$SupplementalLicenseTerms,
							$author$project$Msg$SupplementalLicenseTermsMsg,
							F2(
								function (_v53, m) {
									return _Utils_Tuple2(m, $elm$core$Platform$Cmd$none);
								}),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 82:
					var subMsg = action.a;
					if (page.$ === 45) {
						var subModel = page.a;
						return A5(
							toPageWithExternalMsg,
							$author$project$Page$CreateProject,
							$author$project$Msg$CreateProjectMsg,
							$author$project$Pages$CreateProject$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 84:
					var subMsg = action.a;
					if (page.$ === 46) {
						var subModel = page.a;
						return A5(
							toPage,
							$author$project$Page$ImportProject,
							$author$project$Msg$ImportProjectMsg,
							$author$project$Pages$ImportProject$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 81:
					var result = action.a;
					return A5($author$project$Main$setPageWithCmdOnly, model, $author$project$Page$CreateProject, result, $author$project$Pages$CreateProject$cmds, $author$project$Msg$CreateProjectMsg);
				case 83:
					var result = action.a;
					return A5($author$project$Main$setPageWithCmdOnly, model, $author$project$Page$ImportProject, result, $author$project$Pages$ImportProject$cmds, $author$project$Msg$ImportProjectMsg);
				case 90:
					var subMsg = action.a;
					if (page.$ === 1) {
						var subModel = page.a;
						return A5(
							toPage,
							$author$project$Page$NotFound,
							$author$project$Msg$NotFoundMsg,
							$author$project$Pages$NotFound$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 92:
					var subMsg = action.a;
					if (page.$ === 47) {
						var subModel = page.a;
						return A5(
							toPage,
							$author$project$Page$ForkProject,
							$author$project$Msg$ForkProjectMsg,
							$author$project$Pages$ForkProject$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 91:
					var result = action.a;
					return A3($author$project$Main$setPage, model, $author$project$Page$ForkProject, result);
				case 94:
					var subMsg = action.a;
					if (page.$ === 48) {
						var subModel = page.a;
						return A5(toPageWithExternalMsg, $author$project$Page$AutoFork, $author$project$Msg$AutoForkMsg, $author$project$Pages$AutoFork$update, subMsg, subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 93:
					var result = action.a;
					return A5(
						$author$project$Main$setPageWithCmdOnly,
						model,
						$author$project$Page$AutoFork,
						result,
						$author$project$Pages$AutoFork$cmds(session),
						$author$project$Msg$AutoForkMsg);
				case 96:
					var subMsg = action.a;
					if (page.$ === 49) {
						var subModel = page.a;
						return A5(
							toPageWithExternalMsg,
							$author$project$Page$AdminFork,
							$author$project$Msg$AdminForkMsg,
							$author$project$Pages$AdminFork$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 95:
					var result = action.a;
					return A3($author$project$Main$setPage, model, $author$project$Page$AdminFork, result);
				case 97:
					var subMsg = action.a;
					if (page.$ === 50) {
						var subModel = page.a;
						return A5(
							toPageWithExternalMsg,
							$author$project$Page$Checkout,
							$author$project$Msg$CheckoutMsg,
							$author$project$Pages$Checkout$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 98:
					var result = action.a;
					return A3($author$project$Main$setPage, model, $author$project$Page$Checkout, result);
				case 19:
					var loadingMsg = action.a;
					return A2($author$project$Main$updateLoading, loadingMsg, model);
				case 99:
					var result = action.a;
					return A5(
						$author$project$Main$setPageWithCmdOnly,
						model,
						$elm$core$Basics$always($author$project$Page$CreateProjectFromCommit),
						result,
						$author$project$Pages$CreateProjectFromCommit$cmds(session),
						$elm$core$Basics$always($author$project$Msg$NoOp));
				case 101:
					var subMsg = action.a;
					if (page.$ === 53) {
						var subModel = page.a;
						return A5(
							toPage,
							$author$project$Page$AuthorizeDevice,
							$author$project$Msg$AuthorizeDeviceMsg,
							$author$project$Pages$AuthorizeDevice$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
				case 102:
					var oocModel = action.a;
					return A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								hS: $elm$core$Maybe$Just(oocModel)
							}));
				case 103:
					return A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{hS: $elm$core$Maybe$Nothing}));
				case 104:
					var id = action.a;
					return A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{
								hT: $elm$core$Maybe$Just(id)
							}));
				case 105:
					return A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$none,
						_Utils_update(
							model,
							{hT: $elm$core$Maybe$Nothing}));
				case 14:
					var orgNameString = action.a;
					var route = A2($author$project$Model$Route$orgIndex, orgNameString, $elm$core$Maybe$Nothing);
					var _v62 = A2(
						$author$project$Model$Session$setLocalStorage,
						{Y: $author$project$Model$LocalStorage$lastOrganizationKey, kH: orgNameString},
						A2($author$project$Model$Session$setOrgDropdownOpen, false, model.l));
					var newSession = _v62.a;
					var sessionCmd = _v62.b;
					var cmds = $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								sessionCmd,
								A2($author$project$Routing$pushUrl, model.Y, route)
							]));
					return A2(
						$author$project$Misc$with,
						cmds,
						_Utils_update(
							model,
							{l: newSession}));
				case 106:
					var invitationMsg = action.a;
					var _v63 = A2($author$project$Views$Invitations$update, session, invitationMsg);
					var inviteViewCmd = _v63.a;
					var invitationExtMsg = _v63.b;
					var _v64 = function () {
						switch (invitationExtMsg.$) {
							case 1:
								var newMembership = invitationExtMsg.a;
								var newOrg = invitationExtMsg.b;
								return A2(
									$author$project$Model$Session$addNotification,
									$author$project$Model$Notification$textSuccess('You have successfully joined ' + newOrg.AC),
									A2(
										$author$project$Model$Session$addMembership,
										newMembership,
										A2(
											$author$project$Model$Session$setOrgDropdownOpen,
											true,
											A2($author$project$Model$Session$removeInvitesForOrg, newOrg.AC, session))));
							case 2:
								var orgName = invitationExtMsg.a;
								return A2(
									$author$project$Model$Session$addNotification,
									$author$project$Model$Notification$textSuccess('You declined invite to ' + orgName),
									A2($author$project$Model$Session$removeInvitesForOrg, orgName, session));
							case 3:
								var err = invitationExtMsg.a;
								return A2(
									$author$project$Model$Session$addNotification,
									$author$project$Model$Notification$fromError(err),
									session);
							default:
								return _Utils_Tuple2(session, $elm$core$Platform$Cmd$none);
						}
					}();
					var newSession = _v64.a;
					var notificationCmd = _v64.b;
					return A2(
						$author$project$Misc$with,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Msg$OnInvitationEvent, inviteViewCmd),
									A2($elm$core$Platform$Cmd$map, $author$project$Msg$SessionMsg, notificationCmd)
								])),
						_Utils_update(
							model,
							{l: newSession}));
				case 108:
					var result = action.a;
					return A5(
						$author$project$Main$setPageWithCmdOnly,
						model,
						$author$project$Page$FinishSetup,
						result,
						$author$project$Pages$FinishSetup$cmds(session),
						$author$project$Msg$FinishSetupMsg);
				default:
					var subMsg = action.a;
					if (page.$ === 55) {
						var subModel = page.a;
						return A5(
							toPageWithExternalMsg,
							$author$project$Page$FinishSetup,
							$author$project$Msg$FinishSetupMsg,
							$author$project$Pages$FinishSetup$update(model.l),
							subMsg,
							subModel);
					} else {
						return A2($author$project$Misc$with, $elm$core$Platform$Cmd$none, model);
					}
			}
		}
	});
var $author$project$PageState$getNextRoute = function (pageState) {
	if (!pageState.$) {
		var currentRoute = pageState.a.jL;
		return currentRoute;
	} else {
		var nextRoute = pageState.a.dg;
		return nextRoute;
	}
};
var $author$project$Model$Route$pageHeading = function (route) {
	var routeBase = function () {
		switch (route.$) {
			case 0:
				return 'Log Out';
			case 1:
				return 'Sign In';
			case 2:
				return 'Create an Account';
			case 3:
				return 'There was a problem creating your account';
			case 8:
				return 'Support';
			case 9:
				return 'State Tool Cheat Sheet';
			case 4:
				return 'Forgot Password';
			case 5:
				return 'Reset Password';
			case 6:
				return '404 - Page Not Found';
			case 10:
				return 'Featured Projects';
			case 11:
				return 'Review Your New Project';
			case 12:
				var args = route.a;
				return args.vT + (' - ' + args.ix);
			case 13:
				if (!route.a.$) {
					var _v1 = route.a;
					return 'Supplemental License Terms (Sample)';
				} else {
					return 'Supplemental License Terms';
				}
			default:
				var _protected = route.a;
				switch (_protected.$) {
					case 2:
						return 'Check your Email';
					case 3:
						return 'Account Settings';
					case 4:
						return 'Two-factor Authentication - Account Settings';
					case 5:
						return 'Email Addresses - Account Settings';
					case 7:
						return 'Password - Account Settings';
					case 8:
						return 'Organizations - Account Settings';
					case 10:
						return 'Create an Organization';
					case 11:
						return 'Activate Membership';
					case 12:
						return 'Verify Email';
					case 13:
						return 'Verify Email';
					case 21:
						return 'Checkout';
					case 22:
						var commitID = _protected.a.BR;
						return 'Convert \'' + ($danyx23$elm_uuid$Uuid$toString(commitID) + '\'');
					case 16:
						var adminRoute = _protected.a;
						switch (adminRoute.$) {
							case 7:
								return 'Admin - Iconomicon';
							case 0:
								return 'Admin - Organizations';
							case 1:
								var orgKey = adminRoute.a;
								return 'Admin - ' + orgKey;
							case 2:
								return 'Admin - Users';
							case 3:
								var username = adminRoute.a;
								return 'Admin - ' + username;
							case 4:
								return 'Admin - Create Organization';
							case 5:
								return 'Admin - Fork Project';
							default:
								return 'Admin - Features';
						}
					case 14:
						var orgName = _protected.a.ix;
						var orgRoute = _protected.a.vI;
						switch (orgRoute.$) {
							case 0:
								return orgName;
							case 1:
								return orgName + ' - Members';
							case 2:
								return orgName + ' - Policies';
							case 3:
								return orgName + ' - Remediation Plan';
							case 4:
								return orgName + ' - Settings';
							case 5:
								return orgName + ' - Scan';
							case 6:
								return orgName + ' - Security';
							case 7:
								var projectName = orgRoute.a.vT;
								var projectRoute = orgRoute.a.zL;
								switch (projectRoute.$) {
									case 0:
										return projectName + (' - ' + (orgName + ' - Configuration'));
									case 2:
										return projectName + (' - ' + (orgName + ' - Settings'));
									case 3:
										return projectName + (' - ' + (orgName + ' - Settings - Branches'));
									case 4:
										return projectName + (' - ' + (orgName + ' - Settings - AAR Servers'));
									case 5:
										return projectName + (' - ' + (orgName + ' - Deploy'));
									case 6:
										return projectName + (' - ' + (orgName + ' - History'));
									case 8:
										return 'Fork the ' + (projectName + ' project');
									default:
										return '';
								}
							default:
								return orgName + ' - Analytics';
						}
					case 15:
						return 'Organizations';
					default:
						return '';
				}
		}
	}();
	return $elm$core$String$isEmpty(routeBase) ? 'ActiveState Platform' : (routeBase + ' - ActiveState Platform');
};
var $author$project$Views$SiteWrapper$ActiveStateHeader = function (a) {
	return {$: 4, a: a};
};
var $author$project$Views$SiteWrapper$PageClass = function (a) {
	return {$: 2, a: a};
};
var $author$project$Views$SiteWrapper$PageContent = function (a) {
	return {$: 7, a: a};
};
var $author$project$Views$SiteWrapper$PageFooter = function (a) {
	return {$: 6, a: a};
};
var $author$project$Views$SiteWrapper$PageHeader = function (a) {
	return {$: 5, a: a};
};
var $author$project$Views$SiteWrapper$PageStateData = function (a) {
	return {$: 1, a: a};
};
var $author$project$Views$SiteWrapper$SessionData = function (a) {
	return {$: 0, a: a};
};
var $author$project$Views$Columns$Columns = F5(
	function (container, containerAttrs, columnContainer, columnContainerAttrs, columns) {
		return {td: columnContainer, qF: columnContainerAttrs, iX: columns, tp: container, tq: containerAttrs};
	});
var $author$project$Views$Columns$newColumns = A5($author$project$Views$Columns$Columns, $elm$core$Maybe$Nothing, _List_Nil, $elm$core$Maybe$Nothing, _List_Nil, _List_Nil);
var $author$project$Views$Columns$withColumnsAs = F2(
	function (element, columns) {
		return _Utils_update(
			columns,
			{
				tp: $elm$core$Maybe$Just(element)
			});
	});
var $author$project$Views$Columns$asColumns = function (element) {
	return A2($author$project$Views$Columns$withColumnsAs, element, $author$project$Views$Columns$newColumns);
};
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $author$project$Views$Columns$asHtml = function (columns) {
	var container = function () {
		var _v0 = columns.tp;
		if (_v0.$ === 1) {
			return $elm$html$Html$ul;
		} else {
			var el = _v0.a;
			return el;
		}
	}();
	var attrs = A2(
		$elm$core$List$cons,
		$elm$html$Html$Attributes$class('columns'),
		columns.tq);
	return A2(container, attrs, columns.iX);
};
var $elm$html$Html$footer = _VirtualDom_node('footer');
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$html$Html$h4 = _VirtualDom_node('h4');
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $elm$html$Html$li = _VirtualDom_node('li');
var $author$project$Url$Extra$docsDomain = 'https://docs.activestate.com';
var $author$project$Url$Extra$platformDocs = function (queryParams) {
	return A3(
		$author$project$Url$Extra$createUrl,
		$author$project$Url$Extra$docsDomain,
		_List_fromArray(
			['platform']),
		queryParams);
};
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $author$project$Views$Layout$footerHelpAndFeedback = _List_fromArray(
	[
		A2(
		$elm$html$Html$h4,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Help & feedback')
			])),
		A2(
		$elm$html$Html$ul,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$li,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href(
								$author$project$Url$Extra$platformDocs(_List_Nil)),
								$elm$html$Html$Attributes$target('_blank')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Platform Documentation')
							]))
					]))
			]))
	]);
var $elm$html$Html$Attributes$alt = $elm$html$Html$Attributes$stringProperty('alt');
var $elm$html$Html$img = _VirtualDom_node('img');
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $author$project$Views$Layout$footerImage = _List_fromArray(
	[
		A2(
		$elm$html$Html$img,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$src('/img/SOC2Logo.png'),
				$elm$html$Html$Attributes$alt('SOC2 compliance badge'),
				$elm$html$Html$Attributes$class('footer-image')
			]),
		_List_Nil)
	]);
var $author$project$Model$Legal$privacyPolicy = 'https://www.activestate.com/company/privacy-policy';
var $author$project$Url$Extra$softwareLicenses = A3(
	$author$project$Url$Extra$createUrl,
	$author$project$Url$Extra$docsDomain,
	_List_fromArray(
		['platform', 'additional-resources', 'community-edition-languages']),
	_List_Nil);
var $author$project$Views$Layout$footerLegal = _List_fromArray(
	[
		A2(
		$elm$html$Html$h4,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Legal')
			])),
		A2(
		$elm$html$Html$ul,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$li,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href($author$project$Model$Legal$privacyPolicy),
								$elm$html$Html$Attributes$target('_blank')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Privacy Policy')
							]))
					])),
				A2(
				$elm$html$Html$li,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href($author$project$Url$Extra$softwareLicenses),
								$elm$html$Html$Attributes$target('_blank')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Software Licenses')
							]))
					]))
			]))
	]);
var $author$project$Url$Extra$statusPage = 'https://status.activestate.com';
var $author$project$Views$Layout$footerUptime = _List_fromArray(
	[
		A2(
		$elm$html$Html$h4,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Uptime')
			])),
		A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$href($author$project$Url$Extra$statusPage),
				$elm$html$Html$Attributes$target('_blank')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Platform Status')
			]))
	]);
var $elm$html$Html$nav = _VirtualDom_node('nav');
var $elm$html$Html$p = _VirtualDom_node('p');
var $elm$html$Html$section = _VirtualDom_node('section');
var $author$project$Views$Columns$withColumnAs = F2(
	function (element, columns) {
		return _Utils_update(
			columns,
			{
				td: $elm$core$Maybe$Just(element)
			});
	});
var $author$project$Views$Columns$withColumn = F2(
	function (content, columns) {
		var container = function () {
			var _v0 = columns.td;
			if (_v0.$ === 1) {
				return $elm$html$Html$div;
			} else {
				var el = _v0.a;
				return el;
			}
		}();
		var attrs = A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class('column'),
			columns.qF);
		return _Utils_update(
			columns,
			{
				iX: _Utils_ap(
					columns.iX,
					$elm$core$List$singleton(
						A2(container, attrs, content)))
			});
	});
var $author$project$Views$Columns$withColumns = F2(
	function (cols, columns) {
		return A3($elm$core$List$foldl, $author$project$Views$Columns$withColumn, columns, cols);
	});
var $author$project$Views$Layout$footer = A2(
	$elm$html$Html$footer,
	_List_Nil,
	_List_fromArray(
		[
			$author$project$Views$Columns$asHtml(
			A2(
				$author$project$Views$Columns$withColumns,
				_List_fromArray(
					[$author$project$Views$Layout$footerHelpAndFeedback, $author$project$Views$Layout$footerUptime, $author$project$Views$Layout$footerLegal, $author$project$Views$Layout$footerImage]),
				A2(
					$author$project$Views$Columns$withColumnAs,
					$elm$html$Html$section,
					$author$project$Views$Columns$asColumns($elm$html$Html$nav)))),
			A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('copyright')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('© ActiveState Software, Inc. 2026')
				]))
		]));
var $author$project$PageState$getCurrentRoute = function (pageState) {
	if (!pageState.$) {
		var currentRoute = pageState.a.jL;
		return currentRoute;
	} else {
		var currentRoute = pageState.a.jL;
		return currentRoute;
	}
};
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $author$project$Views$Layout$heading = function (str) {
	return A2(
		$elm$html$Html$h1,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(str)
			]));
};
var $elm$html$Html$main_ = _VirtualDom_node('main');
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $author$project$Views$Link$link = F3(
	function (route, attributes, children) {
		return A2(
			$elm$html$Html$a,
			_Utils_ap(
				attributes,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href(
						$author$project$Model$Route$routeToString(route))
					])),
			children);
	});
var $author$project$Views$Layout$navLink = F4(
	function (isActive, currentRoute, route, content) {
		return A3(
			$author$project$Views$Link$link,
			route,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'active',
							A2(isActive, currentRoute, route))
						]))
				]),
			_List_fromArray(
				[content]));
	});
var $author$project$Views$SiteWrapper$Yes = $elm$core$Basics$identity;
var $author$project$Views$SiteWrapper$newSiteWrapper = {
	pj: _List_Nil,
	vO: '',
	rR: $elm$core$Maybe$Nothing,
	rS: $elm$core$Maybe$Nothing,
	u: $elm$core$Maybe$Nothing,
	l: $elm$core$Maybe$Nothing,
	v9: {z9: true, hT: $elm$core$Maybe$Nothing},
	hS: $elm$core$Maybe$Nothing,
	so: true
};
var $elm$html$Html$header = _VirtualDom_node('header');
var $author$project$Views$Layout$pageHeader = F2(
	function (classes, content) {
		return A2(
			$elm$html$Html$header,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('page-box'),
					$elm$html$Html$Attributes$classList(classes)
				]),
			content);
	});
var $author$project$Views$OutOfComplianceModal$OocModel = F2(
	function (company, username) {
		return {qG: company, AE: username};
	});
var $author$project$Msg$OutOfComplianceBannerClicked = function (a) {
	return {$: 102, a: a};
};
var $author$project$Msg$OutOfComplianceModalDismissed = {$: 103};
var $elm_community$maybe_extra$Maybe$Extra$andMap = $elm$core$Maybe$map2($elm$core$Basics$apR);
var $author$project$Model$Theme$Dark = 0;
var $author$project$Model$Theme$Light = 1;
var $author$project$Msg$MouseEnterTeamTierTag = function (a) {
	return {$: 104, a: a};
};
var $author$project$Msg$MouseExitTeamTierTag = {$: 105};
var $author$project$Msg$SetTheme = function (a) {
	return {$: 3, a: a};
};
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $elm$html$Html$button = _VirtualDom_node('button');
var $author$project$Misc$consIf = F3(
	function (yes, b, bs) {
		return yes ? A2($elm$core$List$cons, b, bs) : bs;
	});
var $author$project$Views$SiteWrapper$dropdownName = A2(
	$elm$core$Basics$composeR,
	$author$project$Model$Session$getUser,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(
			function ($) {
				return $.AE;
			}),
		$elm$core$Maybe$withDefault('')));
var $author$project$Views$Icon$Icon = $elm$core$Basics$identity;
var $author$project$Views$Icon$Unset = 0;
var $author$project$Views$Icon$icon = function (kind) {
	return {tc: $elm$core$Maybe$Nothing, cV: kind, we: $elm$core$Maybe$Nothing, wY: 0};
};
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $author$project$Msg$AuthHeaderCopyToClipboard = {$: 6};
var $author$project$Msg$ToggleSuperUserFeaturesVisible = {$: 5};
var $author$project$Misc$displayIf = F2(
	function (condition, content) {
		return condition ? content : $elm$html$Html$text('');
	});
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$span = _VirtualDom_node('span');
var $author$project$Views$Icon$Normal = {$: 1};
var $elm$svg$Svg$Attributes$style = _VirtualDom_attribute('style');
var $author$project$Views$Icon$alignToAttribute = function (vAlign) {
	return $elm$svg$Svg$Attributes$style(
		'vertical-align: ' + function () {
			if (!vAlign) {
				return '';
			} else {
				return 'middle';
			}
		}());
};
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $avh4$elm_color$Color$toCssString = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	var roundTo = function (x) {
		return $elm$core$Basics$round(x * 1000) / 1000;
	};
	var pct = function (x) {
		return $elm$core$Basics$round(x * 10000) / 100;
	};
	return $elm$core$String$concat(
		_List_fromArray(
			[
				'rgba(',
				$elm$core$String$fromFloat(
				pct(r)),
				'%,',
				$elm$core$String$fromFloat(
				pct(g)),
				'%,',
				$elm$core$String$fromFloat(
				pct(b)),
				'%,',
				$elm$core$String$fromFloat(
				roundTo(a)),
				')'
			]));
};
var $author$project$Views$Icon$colorAttributes = A2(
	$elm$core$Basics$composeR,
	$avh4$elm_color$Color$toCssString,
	A2($elm$core$Basics$composeR, $elm$svg$Svg$Attributes$fill, $elm$core$List$singleton));
var $elm$svg$Svg$Attributes$name = _VirtualDom_attribute('name');
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $author$project$Views$Icon$sizeToInt = function (size) {
	switch (size.$) {
		case 0:
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(16, 16));
		case 1:
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(32, 32));
		case 2:
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(50, 50));
		case 3:
			var width = size.a;
			var height = size.b;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(width, height));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $author$project$Views$Icon$sizeAttributes = function (size) {
	var intToPx = A2(
		$elm$core$Basics$composeR,
		$elm$core$String$fromInt,
		A2($elm_community$basics_extra$Basics$Extra$flip, $elm$core$Basics$append, 'px'));
	var dimensions = A2(
		$elm$core$Maybe$map,
		A2(
			$elm$core$Tuple$mapBoth,
			A2($elm$core$Basics$composeR, intToPx, $elm$svg$Svg$Attributes$width),
			A2($elm$core$Basics$composeR, intToPx, $elm$svg$Svg$Attributes$height)),
		$author$project$Views$Icon$sizeToInt(size));
	if (!dimensions.$) {
		var _v1 = dimensions.a;
		var width = _v1.a;
		var height = _v1.b;
		return _List_fromArray(
			[width, height]);
	} else {
		return _List_Nil;
	}
};
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$virtual_dom$VirtualDom$nodeNS = F2(
	function (namespace, tag) {
		return A2(
			_VirtualDom_nodeNS,
			namespace,
			_VirtualDom_noScript(tag));
	});
var $elm$svg$Svg$node = $elm$virtual_dom$VirtualDom$nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$Icon$viewData = function (kind) {
	switch (kind) {
		case 0:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 42.6 42.6')
					]),
				N: _List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'defs',
						_List_Nil,
						_List_fromArray(
							[
								A3(
								$elm$svg$Svg$node,
								'style',
								_List_Nil,
								_List_fromArray(
									[
										$elm$svg$Svg$text('.cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        font-family: MyriadPro-Regular, \'Myriad Pro\';\n        font-size: 12px;\n      }\n    ')
									]))
							])),
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'g',
						_List_Nil,
						_List_fromArray(
							[
								A3(
								$elm$svg$Svg$node,
								'g',
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1')
									]),
								_List_fromArray(
									[
										A3(
										$elm$svg$Svg$node,
										'g',
										_List_Nil,
										_List_fromArray(
											[
												A3(
												$elm$svg$Svg$node,
												'circle',
												_List_fromArray(
													[
														A2($elm$html$Html$Attributes$attribute, 'class', 'cls-1'),
														A2($elm$html$Html$Attributes$attribute, 'cx', '21.3'),
														A2($elm$html$Html$Attributes$attribute, 'cy', '21.3'),
														A2($elm$html$Html$Attributes$attribute, 'r', '32')
													]),
												_List_Nil),
												A3(
												$elm$svg$Svg$node,
												'path',
												_List_fromArray(
													[
														A2($elm$html$Html$Attributes$attribute, 'd', 'M12.6,16.3v2.8h0v5.1c0,1.3.7,2.5,1.8,3.2l1.9,1.1,2.5-1.4-3.2-1.8c-.4-.2-.6-.6-.6-1.1V4.5c0-.3.1-.6.4-.9.2-.2.5-.4.9-.4h10c.7,0,1.2.5,1.2,1.2v7.5l2.5,1.4V4.5c0-2-1.7-3.7-3.7-3.7h-10c-1,0-1.9.4-2.6,1.1s-1.1,1.6-1.1,2.6v11.8h0Z')
													]),
												_List_Nil),
												A3(
												$elm$svg$Svg$node,
												'path',
												_List_fromArray(
													[
														A2($elm$html$Html$Attributes$attribute, 'd', 'M23.8,29.9l4.4-2.5c1.1-.7,1.8-1.9,1.8-3.2v-2.2l-2.5-1.4v3.6c0,.4-.2.8-.6,1.1l-4.2,2.4h0l-5.5,3.2h0l-7.4,4.3c-.3.2-.6.2-.9.1s-.6-.3-.7-.6l-5-8.7c-.3-.6-.1-1.3.4-1.7l6.5-3.8v-2.8l-7.7,4.5c-1.8,1-2.4,3.3-1.3,5l5,8.7c.5.9,1.3,1.5,2.2,1.7.3,0,.6.1,1,.1.6,0,1.3-.2,1.8-.5l10.2-5.9,2.5-1.4h0Z')
													]),
												_List_Nil),
												A3(
												$elm$svg$Svg$node,
												'path',
												_List_fromArray(
													[
														A2($elm$html$Html$Attributes$attribute, 'd', 'M40.2,22.2l-10.2-5.9h0l-2.5-1.4h0l-4.4-2.5c-.6-.3-1.2-.5-1.8-.5s-1.3.2-1.8.5l-1.9,1.1v2.8l3.2-1.8c.4-.2.8-.2,1.2,0l5.6,3.2,5,2.9h0l6.5,3.7c.6.3.8,1.1.4,1.7l-5,8.7c-.2.3-.4.5-.7.6s-.6,0-.9-.1l-6.5-3.8-2.5,1.4,7.7,4.5c.9.5,1.8.6,2.8.4s1.7-.9,2.2-1.7l5-8.7c1-1.8.4-4-1.3-5h0Z')
													]),
												_List_Nil)
											])),
										A3(
										$elm$svg$Svg$node,
										'text',
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$attribute, 'class', 'cls-2'),
												A2($elm$html$Html$Attributes$attribute, 'transform', 'translate(17.3 -59.7)')
											]),
										_List_fromArray(
											[
												A3(
												$elm$svg$Svg$node,
												'tspan',
												_List_fromArray(
													[
														A2($elm$html$Html$Attributes$attribute, 'x', '0'),
														A2($elm$html$Html$Attributes$attribute, 'y', '0')
													]),
												_List_Nil)
											]))
									]))
							]))
					])
			};
		case 1:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'g',
						_List_Nil,
						_List_fromArray(
							[
								A3(
								$elm$svg$Svg$node,
								'polygon',
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'points', '18.6 34.9 24.7 34.9 21.7 26.4 18.6 34.9')
									]),
								_List_Nil),
								A3(
								$elm$svg$Svg$node,
								'path',
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'd', 'M32,7.5c-13.6,0-24.5,11-24.5,24.5s11,24.5,24.5,24.5,24.5-11,24.5-24.5S45.6,7.5,32,7.5ZM26.7,40.4l-1.4-3.7h-7.3l-1.4,3.7h-2.3l6.1-16.7h2.5l6.1,16.7h-2.3ZM33.9,40.4h-2.2v-16.8h2.2v16.8ZM47.2,40.4l-4-6.6-3.8,6.6h-2.4l5.1-8.4-5.2-8.4h2.5l4.1,6.6,3.9-6.6h2.5l-5.2,8.4,5.2,8.4h-2.5Z')
									]),
								_List_Nil)
							])),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M32,61.3c-16.1,0-29.3-13.1-29.3-29.3S15.9,2.7,32,2.7s29.3,13.1,29.3,29.3-13.1,29.3-29.3,29.3ZM32,4.7c-15,0-27.3,12.2-27.3,27.3s12.2,27.3,27.3,27.3,27.3-12.2,27.3-27.3S47,4.7,32,4.7Z')
							]),
						_List_Nil)
					])
			};
		case 2:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M61.4,29.5H8L35.6,5.2c1-.9,1.1-2.5.2-3.5s-2.5-1.1-3.5-.2L2,28.2c-1,.9-1.6,2-1.7,3.3,0,0,0,0,0,0,0,0,0,.1,0,.2,0,0,0,0,0,0,0,0,0,.2,0,.2,0,.2,0,.3,0,.5.1,1.1.5,2.1,1.2,2.9.1.2.3.3.5.4l30.4,26.7c.5.4,1.1.6,1.7.6s1.4-.3,1.9-.8c.9-1,.8-2.6-.2-3.5l-27.6-24.3h53.3c1.4,0,2.5-1.1,2.5-2.5s-1.1-2.5-2.5-2.5Z')
							]),
						_List_Nil)
					])
			};
		case 3:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M2.7,34.5h53.4l-27.6,24.3c-1,.9-1.1,2.5-.2,3.5s2.5,1.1,3.5.2l30.4-26.7c1-.9,1.6-2,1.7-3.3,0,0,0,0,0,0,0,0,0-.1,0-.2,0,0,0,0,0,0,0,0,0-.2,0-.2,0-.2,0-.3,0-.5-.1-1.1-.5-2.1-1.2-2.9-.1-.2-.3-.3-.5-.4L31.7,1.4c-.5-.4-1.1-.6-1.7-.6s-1.4.3-1.9.8c-.9,1-.8,2.6.2,3.5l27.6,24.3H2.7c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5Z')
							]),
						_List_Nil)
					])
			};
		case 4:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M55.9,5.8l-7.5-5c-.2-.1-.4-.2-.6-.3,0,0,0,0-.1,0-.2,0-.4,0-.6,0s0,0,0,0,0,0,0,0c-.2,0-.4,0-.6,0,0,0-.1,0-.2,0-.2,0-.4.2-.6.3,0,0,0,0,0,0l-7.6,5c-1.1.8-1.5,2.3-.7,3.5.8,1.1,2.3,1.5,3.5.7l3.7-2.4v9.2c0,5-2.8,6.9-6.4,9.3-2.1,1.4-4.4,3-6.2,5.3-1.7-2.4-4.1-3.9-6.2-5.3-3.6-2.4-6.4-4.3-6.4-9.3V7.5l3.7,2.4c.4.3.9.4,1.4.4.8,0,1.6-.4,2.1-1.1.8-1.1.5-2.7-.7-3.5L18.1.8c-.2-.1-.4-.2-.6-.3,0,0,0,0-.1,0-.2,0-.4,0-.6,0s0,0,0,0h0c-.2,0-.4,0-.6,0,0,0-.1,0-.2,0-.2,0-.4.2-.6.3,0,0,0,0,0,0l-7.6,5c-1.1.8-1.5,2.3-.7,3.5.8,1.1,2.3,1.5,3.5.7l3.7-2.4v9.2c0,7.6,4.8,10.8,8.7,13.4,3.6,2.4,6.4,4.3,6.4,9.3v21.4c0,1.4,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5v-21.4s0,0,0,0c0-5,2.8-6.8,6.4-9.2,3.9-2.6,8.7-5.8,8.7-13.4V7.5l3.7,2.4c.4.3.9.4,1.4.4.8,0,1.6-.4,2.1-1.1.8-1.1.5-2.7-.7-3.5Z')
							]),
						_List_Nil)
					])
			};
		case 5:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'width', '36'),
						A2($elm$html$Html$Attributes$attribute, 'height', '36'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 36 36'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1')
					]),
				N: _List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M10.33002 1.0961999999999998C9.911916 1.250244 9.595476 1.5311519999999998 9.417924 1.905768L9.306 2.142 9.295523999999999 3.6430919999999998L9.285048 5.144184 6.631524 5.158187999999999C3.7976039999999998 5.173128 3.8508839999999993 5.169924 3.3118559999999997 5.357196C2.20626 5.741279999999999 1.370736 6.742043999999999 1.11726 7.985735999999999C1.043604 8.347211999999999 1.0433519999999998 8.388036 1.043712 20.118456C1.044036 30.655151999999998 1.050012 31.919687999999997 1.10052 32.186016C1.3716719999999998 33.615324 2.5193159999999994 34.68492 4.032 34.918091999999994C4.233744 34.949196 7.819488 34.956972 18.215999999999998 34.948872L32.129999999999995 34.937999999999995 32.418 34.85664C33.704568 34.493148 34.58538 33.526151999999996 34.891991999999995 32.140584L34.974 31.769999999999996 34.974 20.016C34.974 8.771616 34.971156 8.247959999999999 34.908192 7.938C34.774632 7.280747999999999 34.503947999999994 6.75468 34.06014 6.289992C33.489431999999994 5.692428 32.839776 5.355575999999999 31.969692 5.2061399999999995C31.680755999999995 5.156495999999999 31.272012 5.148 29.17278 5.148L26.714267999999997 5.148 26.704152 3.6449999999999996L26.694 2.142 26.582795999999995 1.907352C26.456112 1.6400159999999997 26.194176 1.3535639999999998 25.954704 1.220436C25.699679999999997 1.0787039999999999 25.492608 1.035216 25.140455999999997 1.049472C24.875496 1.0601999999999998 24.782363999999998 1.081116 24.586163999999997 1.173924C24.282792 1.3174559999999997 24.000516 1.60038 23.853671999999996 1.908L23.741999999999997 2.142 23.731523999999997 3.6449999999999996L23.721011999999998 5.148 17.99964 5.148L12.278267999999999 5.148 12.268151999999999 3.6449999999999996L12.258 2.142 12.146075999999999 1.905768C11.964852 1.523376 11.614464 1.216872 11.213999999999999 1.090512C11.028383999999999 1.0319399999999999 10.495152 1.035396 10.33002 1.0961999999999998M4.284 8.218511999999999C4.2345 8.243495999999999 4.161599999999999 8.328312 4.122 8.406972C4.052448 8.54514 4.049639999999999 8.632512 4.0398119999999995 10.970999999999998L4.0295879999999995 13.392 17.999747999999997 13.392L31.969907999999997 13.392 31.959972 10.904868L31.95 8.417736 31.850928 8.332559999999999C31.79646 8.285687999999999 31.691159999999996 8.2305 31.616927999999998 8.209871999999999C31.529736 8.185644 30.63852 8.172324 29.096999999999998 8.172215999999999L26.712 8.171999999999999 26.71146 9.099C26.710884 10.073772 26.699399999999997 10.163375999999998 26.535384 10.474631999999998C26.420688 10.692324 26.109863999999998 10.988387999999999 25.877195999999998 11.101571999999999C25.492608 11.288699999999999 24.932304 11.286971999999999 24.556859999999997 11.097503999999999C24.280991999999998 10.958291999999998 23.990184 10.6578 23.854823999999997 10.37214L23.741999999999997 10.133999999999999 23.730876 9.152999999999999L23.719751999999996 8.171999999999999 17.999495999999997 8.171999999999999L12.279239999999998 8.171999999999999 12.26862 9.152999999999999L12.258 10.133999999999999 12.141791999999999 10.37934C11.853467999999998 10.988135999999999 11.228364 11.320631999999998 10.548 11.227103999999999C10.077372 11.162447999999998 9.634319999999999 10.826927999999999 9.418752 10.37196L9.306 10.133999999999999 9.294875999999999 9.152999999999999L9.283752 8.171999999999999 6.828875999999999 8.17254C4.924475999999999 8.172936 4.353803999999999 8.183267999999998 4.284 8.218511999999999M4.032216 23.967C4.032324 29.095667999999996 4.044455999999999 31.561343999999995 4.069944 31.653143999999998C4.099031999999999 31.757939999999998 4.141476 31.806468 4.258728 31.869144L4.409999999999999 31.95 17.959284 31.959251999999996C27.29484 31.965587999999997 31.55202 31.956767999999997 31.648248 31.930847999999997C31.758696 31.901112 31.80492 31.861511999999998 31.868964 31.741631999999996L31.95 31.589999999999996 31.959324 24.002999999999997L31.968647999999998 16.416 18.000324 16.416L4.032 16.416 4.032216 23.967'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', 'none'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'currentColor'),
								A2($elm$html$Html$Attributes$attribute, 'fill-rule', 'evenodd'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-width', '0.036')
							]),
						_List_Nil)
					])
			};
		case 6:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M48.8,63.2c-2.2,0-4.4-.6-6.3-1.9C26.8,50.8,13.5,37.5,3,21.7,0,17.2.6,11.1,4.4,7.3l3.5-3.5c3.3-3.3,8.7-3.3,12,0l6.3,6.3c3.3,3.3,3.3,8.7,0,12l-.5.5c4.8,5.7,10.2,11,15.9,15.9l.5-.5s0,0,0,0c3.3-3.3,8.7-3.3,12,0l6.3,6.3s0,0,0,0c1.6,1.6,2.4,3.7,2.4,5.9,0,2.3-.9,4.4-2.5,6l-3.5,3.5c-2.2,2.2-5.2,3.3-8.1,3.3ZM13.9,6.4c-.9,0-1.8.3-2.5,1l-3.5,3.5c-2.2,2.2-2.5,5.6-.8,8.1,10.1,15.2,22.9,28,38.1,38.1,2.5,1.7,6,1.3,8.1-.8l3.5-3.5c1.4-1.4,1.4-3.6,0-4.9s0,0,0,0l-6.3-6.3c-1.3-1.3-3.5-1.4-4.9,0,0,0,0,0,0,0l-2.1,2.1c-.9.9-2.4,1-3.4.2-7.2-5.9-13.8-12.6-19.7-19.8-.8-1-.7-2.4.2-3.4l2.1-2.1s0,0,0,0c1.4-1.4,1.4-3.6,0-4.9l-6.3-6.3c-.7-.7-1.6-1-2.5-1Z')
							]),
						_List_Nil)
					])
			};
		case 7:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M28.1,29.4c-1,0-1.9-.6-2.3-1.5,0-.1-3.3-7.4-9.2-7.4H2.6c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5h14.1c9.2,0,13.6,10,13.8,10.5.5,1.3,0,2.7-1.3,3.3-.3.1-.7.2-1,.2Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'g',
						_List_Nil,
						_List_fromArray(
							[
								A3(
								$elm$svg$Svg$node,
								'path',
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'd', 'M47.3,20.5h9.4l-2.5,3.8c-.8,1.1-.5,2.7.7,3.5.4.3.9.4,1.4.4.8,0,1.6-.4,2.1-1.1l5.1-7.6c.1-.2.2-.4.3-.6,0,0,0,0,0-.1,0-.2,0-.4,0-.6s0,0,0,0,0,0,0,0c0-.2,0-.4,0-.6,0,0,0-.1,0-.2,0-.2-.2-.4-.3-.6,0,0,0,0,0,0l-5.1-7.7c-.8-1.1-2.3-1.5-3.5-.7-1.1.8-1.5,2.3-.7,3.5l2.5,3.8h-9.4c-7.8,0-12.7,7.7-17.4,15.2-4,6.3-8.2,12.9-13.2,12.9H2.6c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5h14.1c7.8,0,12.7-7.7,17.4-15.2,4-6.3,8.2-12.9,13.2-12.9Z')
									]),
								_List_Nil),
								A3(
								$elm$svg$Svg$node,
								'path',
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'd', 'M63.7,46.7c0-.2,0-.4,0-.6s0-.4,0-.6c0,0,0-.1,0-.2,0-.2-.2-.4-.3-.6,0,0,0,0,0,0l-5.1-7.7c-.8-1.1-2.3-1.5-3.5-.7-1.1.8-1.5,2.3-.7,3.5l2.5,3.8h-9.4c-6.2,0-10.7-6.5-10.7-6.6-.8-1.1-2.3-1.5-3.5-.7-1.1.8-1.5,2.3-.7,3.5.2.4,6,8.8,14.9,8.8h9.4l-2.5,3.8c-.8,1.1-.5,2.7.7,3.5.4.3.9.4,1.4.4.8,0,1.6-.4,2.1-1.1l5.1-7.6c.1-.2.2-.4.3-.6,0,0,0,0,0-.1Z')
									]),
								_List_Nil)
							]))
					])
			};
		case 8:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M15.5,48.5c-.3,0-.7,0-1-.2-.9-.4-1.5-1.3-1.5-2.3v-7.6c-7,0-12.7-5.7-12.7-12.6v-12.7C.3,6.1,6,.4,13,.4h25.3c7,0,12.6,5.7,12.6,12.6v12.7c0,7-5.7,12.6-12.6,12.6h-10.4l-10.7,9.5c-.5.4-1.1.6-1.7.6ZM13,5.4c-4.2,0-7.6,3.4-7.6,7.6v12.7c0,4.2,3.4,7.6,7.6,7.6h2.5c1.4,0,2.5,1.1,2.5,2.5v4.6l7.2-6.4c.5-.4,1-.6,1.7-.6h11.4c4.2,0,7.6-3.4,7.6-7.6v-12.7c0-4.2-3.4-7.6-7.6-7.6H13Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M51,63.7c-.7,0-1.3-.3-1.8-.7l-6.9-6.9h-5.3c-4.9,0-8.8-4-8.8-8.8v-3.3c0-1.4,1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5v3.3c0,2.1,1.7,3.8,3.8,3.8h6.3c.7,0,1.3.3,1.8.7l3.3,3.3v-1.6c0-1.4,1.1-2.5,2.5-2.5h3.8c2.1,0,3.8-1.7,3.8-3.8v-7.6c0-2.1-1.7-3.8-3.8-3.8s-2.5-1.1-2.5-2.5,1.1-2.5,2.5-2.5c4.9,0,8.8,4,8.8,8.8v7.6c0,4.9-4,8.8-8.8,8.8h-1.3v5.1c0,1-.6,1.9-1.5,2.3-.3.1-.6.2-1,.2Z')
							]),
						_List_Nil)
					])
			};
		case 9:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M53.7,64H10.3c-2.8,0-5.1-2.3-5.1-5.1V5.3C5.2,2.5,7.5.2,10.3.2h34c1.3,0,2.6.5,3.6,1.5l9.5,9.5c1,1,1.5,2.2,1.5,3.6v44.2c0,2.8-2.3,5.1-5.1,5.1ZM10.3,5.2v53.7c0,0,43.4,0,43.4,0V14.7c0,0,0,0,0,0l-9.5-9.5H10.3Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M20.3,26.9h0c-1,0-2-.4-2.7-1.1l-2.8-2.8c-1-1-1-2.6,0-3.5s2.6-1,3.5,0l1.7,1.7,4.7-6.5c.8-1.1,2.4-1.4,3.5-.6,1.1.8,1.4,2.4.6,3.5l-5.5,7.7c-.1.2-.3.3-.4.5-.7.7-1.7,1.1-2.7,1.1ZM21.2,22.3h0s0,0,0,0Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M46.1,23.1h-10.2c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5h10.2c1.4,0,2.5,1.1,2.5,2.5s-1.1,2.5-2.5,2.5Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M20.3,39.7c-1,0-2-.4-2.7-1.1l-2.8-2.8c-1-1-1-2.6,0-3.5,1-1,2.6-1,3.5,0l1.7,1.7,4.7-6.5c.8-1.1,2.4-1.4,3.5-.6,1.1.8,1.4,2.4.6,3.5l-5.5,7.7c-.1.2-.3.3-.4.5-.7.7-1.7,1.1-2.7,1.1ZM21.2,35h0s0,0,0,0Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M46.1,35.9h-10.2c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5h10.2c1.4,0,2.5,1.1,2.5,2.5s-1.1,2.5-2.5,2.5Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M20.3,52.5h0c-1,0-2-.4-2.7-1.1l-2.8-2.8c-1-1-1-2.6,0-3.5,1-1,2.6-1,3.5,0l1.7,1.7,4.7-6.5c.8-1.1,2.4-1.4,3.5-.6,1.1.8,1.4,2.4.6,3.5l-5.5,7.7c-.1.2-.3.3-.4.5-.7.7-1.7,1.1-2.7,1.1ZM21.2,47.8h0s0,0,0,0Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M46.1,48.6h-10.2c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5h10.2c1.4,0,2.5,1.1,2.5,2.5s-1.1,2.5-2.5,2.5Z')
							]),
						_List_Nil)
					])
			};
		case 10:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M19.3,63.8c-.7,0-1.3-.3-1.8-.7L.9,46.5c-1-1-1-2.6,0-3.5,1-1,2.6-1,3.5,0l14.5,14.5L59.3,1.2c.8-1.1,2.4-1.4,3.5-.6,1.1.8,1.4,2.4.6,3.5L21.3,62.8c-.4.6-1.1,1-1.8,1,0,0-.1,0-.2,0Z')
							]),
						_List_Nil)
					])
			};
		case 11:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M31.9.4C14.5.4.3,14.5.3,32s14.2,31.6,31.6,31.6,31.6-14.2,31.6-31.6S49.4.4,31.9.4ZM47.6,19.8l-19.6,27.4c-.4.6-1.1,1-1.8,1,0,0-.1,0-.2,0-.7,0-1.3-.3-1.8-.7l-7.7-7.7c-1-1-1-2.6,0-3.5,1-1,2.6-1,3.5,0l5.6,5.6,17.9-25c.8-1.1,2.4-1.4,3.5-.6,1.1.8,1.4,2.4.6,3.5Z')
							]),
						_List_Nil)
					])
			};
		case 12:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M32,50.8c-1,0-2.1-.4-2.8-1.3L.8,17.4c-.9-1-.8-2.6.2-3.5,1-.9,2.6-.8,3.5.2l27.5,31.1,27.5-31.1c.9-1,2.5-1.1,3.5-.2,1,.9,1.1,2.5.2,3.5l-28.4,32.1c-.1.1-.2.2-.3.3-.7.6-1.6,1-2.5,1Z')
							]),
						_List_Nil)
					])
			};
		case 13:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M15.7,63.8c-.7,0-1.4-.3-1.9-.8-.9-1-.8-2.6.2-3.5l31-27.5L14.1,4.5c-1-.9-1.1-2.5-.2-3.5.9-1,2.5-1.1,3.5-.2l32.1,28.4c.1,0,.2.2.3.3,1.4,1.6,1.3,4-.3,5.4l-32.1,28.4c-.5.4-1.1.6-1.7.6Z')
							]),
						_List_Nil)
					])
			};
		case 14:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M61.3,50.7c-.7,0-1.4-.3-1.9-.8l-27.4-31L4.6,49.9c-.9,1-2.5,1.1-3.5.2s-1.1-2.5-.2-3.5L29.2,14.5c.1-.1.2-.2.3-.3,1.6-1.4,4-1.2,5.3.3l28.4,32.1c.9,1,.8,2.6-.2,3.5-.5.4-1.1.6-1.7.6Z')
							]),
						_List_Nil)
					])
			};
		case 15:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M11.7,30.6c-4.9,0-8.9-4-8.9-8.9s4-8.9,8.9-8.9,8.9,4,8.9,8.9-4,8.9-8.9,8.9ZM11.7,17.9c-2.1,0-3.9,1.7-3.9,3.9s1.7,3.9,3.9,3.9,3.9-1.7,3.9-3.9-1.7-3.9-3.9-3.9Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M52.3,30.6c-4.9,0-8.9-4-8.9-8.9s4-8.9,8.9-8.9,8.9,4,8.9,8.9-4,8.9-8.9,8.9ZM52.3,17.9c-2.1,0-3.9,1.7-3.9,3.9s1.7,3.9,3.9,3.9,3.9-1.7,3.9-3.9-1.7-3.9-3.9-3.9Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M56.1,30.7h-11.2c-2.8,0-5.2-1.8-6.1-4.4l-2.1-6.3c-.9-3-3.9-4.9-7-4.5-.4,0-.7.1-1,.3-1.6.5-2.9,1.7-3.6,3.2-.8,1.5-.9,3.2-.3,4.8l.6,1.8-.2.7c-.9,2.6-3.3,4.4-6.1,4.4H7.9c-4.2,0-7.6,3.4-7.6,7.6v22.9c0,1.4,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5v-22.9c0-1.4,1.2-2.6,2.6-2.6h11.2c3.3,0,6.4-1.4,8.5-3.8.4.8.8,1.7,1.3,2.4-2.3,2.2-5.3,3.6-8.5,3.9-1.3.1-2.3,1.2-2.3,2.5v20.4c0,1.4,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5v-18.3c3.3-.7,6.4-2.4,8.9-4.7,2.5,2.3,5.6,4,8.9,4.7v18.3c0,1.4,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5v-20.4c0-1.3-1-2.4-2.3-2.5-5.5-.5-10.2-4.2-12-9.5l-2.2-6.6c-.1-.3,0-.7,0-1,.2-.3.4-.5.8-.7,0,0,.1,0,.1,0,.7,0,1.4.3,1.6,1.1l2.1,6.4c1.6,4.7,5.9,7.8,10.8,7.8h11.2c1.4,0,2.6,1.2,2.6,2.6v22.9c0,1.4,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5v-22.9c0-4.2-3.4-7.6-7.6-7.6Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M30.7,10.3c-1.4,0-2.5-1.1-2.5-2.5V2.7c0-1.4,1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5v5.1c0,1.4-1.1,2.5-2.5,2.5Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M37.1,14.1c-.6,0-1.3-.2-1.8-.7-1-1-1-2.6,0-3.5l3.6-3.6c1-1,2.6-1,3.5,0,1,1,1,2.6,0,3.5l-3.6,3.6c-.5.5-1.1.7-1.8.7Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M24.4,14.1c-.6,0-1.3-.2-1.8-.7l-3.6-3.6c-1-1-1-2.6,0-3.5,1-1,2.6-1,3.5,0l3.6,3.6c1,1,1,2.6,0,3.5-.5.5-1.1.7-1.8.7Z')
							]),
						_List_Nil)
					])
			};
		case 16:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M28.5,15.1c-4.9,1.3-8.7,5.1-10,10-.2.6,0,1.2.4,1.7.4.5,1,.8,1.6.8h23.2c.6,0,1.2-.3,1.6-.8.4-.5.5-1.1.4-1.7-.9-3.6-3.2-6.7-6.5-8.6-1.1-.7-2.3-1.1-3.5-1.5,2.5-1.3,4.2-3.9,4.2-6.9,0-4.3-3.5-7.8-7.8-7.8s-7.8,3.5-7.8,7.8,1.7,5.6,4.2,6.9ZM40.7,23.6h-17.3c1.3-2.3,3.5-4,6.1-4.7,2.6-.7,5.3-.3,7.6,1.1,1.5.9,2.7,2.1,3.6,3.6ZM32.1,4.3c2.1,0,3.8,1.7,3.8,3.8s-1.7,3.8-3.8,3.8-3.8-1.7-3.8-3.8,1.7-3.8,3.8-3.8Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M21.1,52.7c-1.1-.6-2.3-1.1-3.5-1.4.7-.4,1.3-.8,1.9-1.4,1.5-1.5,2.3-3.4,2.3-5.5,0-4.3-3.5-7.8-7.8-7.8s-7.8,3.5-7.8,7.8h0c0,2.1.8,4,2.3,5.5.6.6,1.2,1,1.9,1.4-4.9,1.3-8.7,5.1-9.9,10-.2.6,0,1.2.4,1.7.4.5,1,.8,1.6.8h23.2c.6,0,1.2-.3,1.6-.8.4-.5.5-1.1.4-1.7-.9-3.6-3.2-6.7-6.5-8.6ZM10.2,44.3c0-2.1,1.7-3.8,3.8-3.8s3.8,1.7,3.8,3.8c0,1-.4,2-1.1,2.7s-1.7,1.1-2.7,1.1h0c-1,0-2-.4-2.7-1.1-.7-.7-1.1-1.7-1.1-2.7h0ZM5.3,59.8c1.3-2.3,3.5-4,6.1-4.7,2.6-.7,5.3-.3,7.6,1.1,1.5.9,2.7,2.1,3.6,3.6H5.3Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M63.7,61.3c-.9-3.6-3.2-6.7-6.5-8.6-1.1-.7-2.3-1.1-3.5-1.5,2.5-1.3,4.2-3.9,4.2-6.9,0-4.3-3.5-7.8-7.8-7.8s-7.8,3.5-7.8,7.8,1.7,5.6,4.2,6.9c-4.9,1.3-8.7,5.1-10,10-.2.6,0,1.2.4,1.7.4.5,1,.8,1.6.8h23.2c.6,0,1.2-.3,1.6-.8.4-.5.5-1.1.4-1.7ZM50.1,40.5c2.1,0,3.8,1.7,3.8,3.8s-1.7,3.8-3.8,3.8-3.8-1.7-3.8-3.8,1.7-3.8,3.8-3.8ZM41.5,59.8c1.3-2.3,3.5-4,6.1-4.7,2.6-.7,5.3-.3,7.6,1.1,1.5.9,2.7,2.1,3.6,3.6h-17.3Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M41.7,49.2c-.4-1-1.6-1.5-2.6-1.1-4.5,1.8-9.5,1.8-14,0-1-.4-2.2,0-2.6,1.1-.4,1,0,2.2,1.1,2.6,2.7,1.1,5.6,1.7,8.5,1.7s5.8-.6,8.5-1.7c1-.4,1.5-1.6,1.1-2.6Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M42.6,15.3c5.8,4,8.9,10.8,8,17.8-.1,1.1.6,2.1,1.7,2.2,0,0,.2,0,.3,0,1,0,1.9-.7,2-1.8,1.1-8.5-2.7-16.8-9.7-21.6-.9-.6-2.2-.4-2.8.5-.6.9-.4,2.2.5,2.8Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M11.5,35.3c0,0,.2,0,.3,0,1.1-.1,1.9-1.1,1.7-2.2-.9-7,2.2-13.8,8-17.8.9-.6,1.2-1.9.5-2.8-.6-.9-1.9-1.2-2.8-.5-7.1,4.8-10.8,13.1-9.7,21.6.1,1,1,1.8,2,1.8Z')
							]),
						_List_Nil)
					])
			};
		case 17:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M11.1,45.7h-6.2c-2.5,0-4.6-2.1-4.6-4.6V4.9C.3,2.4,2.4.3,4.9.3h36.2c2.5,0,4.6,2.1,4.6,4.6v6.3c0,1.1-.9,2-2,2s-2-.9-2-2v-6.3c0-.3-.3-.6-.6-.6H4.9c-.3,0-.6.3-.6.6v36.2c0,.3.3.6.6.6h6.2c1.1,0,2,.9,2,2s-.9,2-2,2Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M59.2,63.8H23c-2.5,0-4.6-2.1-4.6-4.6V23c0-2.5,2.1-4.6,4.6-4.6h36.2c2.5,0,4.6,2.1,4.6,4.6v36.2c0,2.5-2.1,4.6-4.6,4.6ZM23,22.4c-.3,0-.6.3-.6.6v36.2c0,.3.3.6.6.6h36.2c.3,0,.6-.3.6-.6V23c0-.3-.3-.6-.6-.6H23Z')
							]),
						_List_Nil)
					])
			};
		case 18:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M61.4,18.2H2.7c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5h58.7c1.4,0,2.5,1.1,2.5,2.5s-1.1,2.5-2.5,2.5Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M61.4,34.5H2.7c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5h58.7c1.4,0,2.5,1.1,2.5,2.5s-1.1,2.5-2.5,2.5Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M61.4,50.8H2.7c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5h58.7c1.4,0,2.5,1.1,2.5,2.5s-1.1,2.5-2.5,2.5Z')
							]),
						_List_Nil)
					])
			};
		case 19:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M35.5,31.9L62.8,4.6c1-1,1-2.6,0-3.5-1-1-2.6-1-3.5,0l-27.3,27.3L4.7,1.1C3.7.1,2.2.1,1.2,1.1c-1,1-1,2.6,0,3.5l27.3,27.3L1.2,59.2c-1,1-1,2.6,0,3.5.5.5,1.1.7,1.8.7s1.3-.2,1.8-.7l27.3-27.3,27.3,27.3c.5.5,1.1.7,1.8.7s1.3-.2,1.8-.7c1-1,1-2.6,0-3.5l-27.3-27.3Z')
							]),
						_List_Nil)
					])
			};
		case 20:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M4.4,18.9h7.9s1.3,0,1.3,1.3v7.9s0,1.3-1.3,1.3h-7.9s-1.3,0-1.3-1.3v-7.9s0-1.3,1.3-1.3')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M17.5,18.9h7.9s1.3,0,1.3,1.3v7.9s0,1.3-1.3,1.3h-7.9s-1.3,0-1.3-1.3v-7.9s0-1.3,1.3-1.3')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M30.6,18.9h7.9s1.3,0,1.3,1.3v7.9s0,1.3-1.3,1.3h-7.9s-1.3,0-1.3-1.3v-7.9s0-1.3,1.3-1.3')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M17.5,4.5h7.9s1.3,0,1.3,1.3v7.9s0,1.3-1.3,1.3h-7.9s-1.3,0-1.3-1.3v-7.9s0-1.3,1.3-1.3')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M63.4,28.8c-1.7-3.2-5.5-4.9-9-3.9-.2-3.9-2.6-7.2-6.2-8.6-.5-.2-1.2,0-1.5.4-2.7,3.5-2.8,8.2-.3,11.8.3,1.3,0,2.7-.7,3.9-.5.6-1.3.9-2,.8H3.1c-.7,0-1.4.3-1.9.8-.5.5-.8,1.2-.7,1.9.6,14,10.1,23.6,23.6,23.6s28.8-10.5,30.1-24.5c3.9.7,7.8-1.5,9.1-5.2.2-.3.2-.7,0-1ZM18.9,46.4c-1.4,0-2.6-1.2-2.6-2.6,0-1.4,1.2-2.6,2.6-2.6s2.6,1.2,2.6,2.6-1.2,2.6-2.6,2.6h0Z')
							]),
						_List_Nil)
					])
			};
		case 21:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M10.6,63.5c-5.5,0-10.1-4.5-10.1-10.1v-5c0-1.4,1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5v5c0,2.8,2.3,5.1,5.1,5.1h42.8c2.8,0,5.1-2.3,5.1-5.1v-5c0-1.4,1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5v5c0,5.5-4.5,10.1-10.1,10.1H10.6Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M52.2,27.9c-1-1-2.6-1-3.5,0l-14.2,14.2V3.1c0-1.4-1.1-2.5-2.5-2.5s-2.5,1.1-2.5,2.5v39l-14.2-14.2c-1-1-2.6-1-3.5,0-1,1-1,2.6,0,3.5l18.4,18.4c.1.1.2.2.4.3,0,0,.1,0,.2.1,0,0,.2,0,.2.1,0,0,.2,0,.2,0,0,0,.1,0,.2,0,.2,0,.3,0,.5,0s.3,0,.5,0c0,0,.1,0,.2,0,0,0,.2,0,.2,0,0,0,.2,0,.3-.1,0,0,.1,0,.2,0,.1,0,.3-.2.4-.3l18.4-18.4c1-1,1-2.6,0-3.5Z')
							]),
						_List_Nil)
					])
			};
		case 22:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M30.7,63.8c-.7,0-1.3-.3-1.8-.7-.6-.6-.8-1.4-.7-2.3l1.9-9.6c0-.5.3-.9.7-1.3l19.4-19.4c1.5-1.5,3.5-2.3,5.6-2.3h0c2.1,0,4.1.8,5.6,2.3,1.5,1.5,2.3,3.5,2.3,5.6,0,2.1-.8,4.1-2.3,5.6,0,0,0,0,0,0l-19.4,19.4c-.3.3-.8.6-1.3.7l-9.6,1.9c-.2,0-.3,0-.5,0ZM40.3,59.4h0,0ZM34.9,53l-1,5.1,5.1-1,18.9-18.9c.5-.5.8-1.3.8-2,0-.8-.3-1.5-.8-2-.6-.6-1.3-.9-2.1-.9h0c-.8,0-1.5.3-2,.8l-18.9,18.9Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M23.1,63.8H5.2c-2.8,0-5-2.3-5-5V5.2C.2,2.5,2.5.2,5.2.2h33.9c1.3,0,2.6.5,3.6,1.5l9.4,9.4c1,1,1.5,2.2,1.5,3.6v8.4c0,1.4-1.1,2.5-2.5,2.5s-2.5-1.1-2.5-2.5v-8.4l-9.5-9.5H5.2s0,53.6,0,53.6h17.9c1.4,0,2.5,1.2,2.5,2.5s-1.1,2.5-2.5,2.5Z')
							]),
						_List_Nil)
					])
			};
		case 23:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M61.4,9.1H2.8c-1.4,0-2.5,1.1-2.5,2.5v40.8c0,1.4,1.1,2.5,2.5,2.5h58.6c1.4,0,2.5-1.1,2.5-2.5V11.6c0-1.4-1.1-2.5-2.5-2.5ZM54.7,14.1l-22.6,18.5L9.5,14.1h45.2ZM5.3,49.9V17.1l25.2,20.6c.5.4,1,.6,1.6.6s1.1-.2,1.6-.6l25.2-20.6v32.7H5.3Z')
							]),
						_List_Nil)
					])
			};
		case 24:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M45.8,63.3c-9.7,0-17.5-7.9-17.5-17.5s7.9-17.5,17.5-17.5,17.5,7.9,17.5,17.5-7.9,17.5-17.5,17.5ZM45.8,33.3c-6.9,0-12.5,5.6-12.5,12.5s5.6,12.5,12.5,12.5,12.5-5.6,12.5-12.5-5.6-12.5-12.5-12.5Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M43.7,54.4c-.9,0-1.8-.3-2.6-.9-.2-.1-.3-.3-.5-.4l-3.7-3.7c-1-1-1-2.6,0-3.5s2.6-1,3.5,0l3.2,3.2,6.8-9.1c.8-1.1,2.4-1.3,3.5-.5,1.1.8,1.3,2.4.5,3.5l-7.3,9.7c-.7.9-1.7,1.5-2.9,1.7-.2,0-.4,0-.6,0ZM44.2,49.6h0s0,0,0,0Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M56.9,2.8s0,0,0,0c0,0,0,0,0,0,0-.1-.2-.2-.3-.3,0,0,0,0,0,0-1.1-1-2.6-1.7-4.3-1.7H7.3c-1.6,0-3.1.6-4.2,1.7,0,0,0,0,0,0,0,0-.2.2-.2.3,0,0,0,0,0,0,0,0,0,0,0,0-1,1.1-1.6,2.6-1.6,4.2v27.5c0,3.4,2.8,6.3,6.3,6.3h18.8c1.4,0,2.5-1.1,2.5-2.5s-1.1-2.5-2.5-2.5H7.3c-.7,0-1.3-.6-1.3-1.3V8.7l22.2,17.8c.5.4,1,.5,1.6.5s1.1-.2,1.6-.5l22.2-17.8v17.1c0,1.4,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5V7c0-1.6-.6-3.1-1.6-4.2ZM29.8,21.3L10.3,5.7h38.9l-19.5,15.6Z')
							]),
						_List_Nil)
					])
			};
		case 25:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'width', '24'),
						A2($elm$html$Html$Attributes$attribute, 'height', '24'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 24 24'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1')
					]),
				N: _List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M3.966168 1.058352C2.601432 1.179936 1.44492 2.1866879999999997 1.129176 3.528C1.102776 3.6402000000000005 1.070184 3.8562000000000003 1.056792 4.008C1.02324 4.387824 1.02324 19.612176 1.056792 19.992C1.187784 21.475368 2.24472 22.634567999999998 3.72 22.912968C3.9363599999999996 22.953792 4.359096 22.956 12 22.956C19.640904 22.956 20.06364 22.953792 20.28 22.912968C21.476304 22.687224 22.410168 21.882624 22.788312 20.75184C22.961952 20.232648 22.951416 20.482872 22.961472 16.644000000000002C22.967592 14.30964 22.962336 13.126392000000001 22.945272 12.998136000000002C22.913088000000002 12.756456 22.834488 12.5856 22.680648 12.422927999999999C22.19352 11.907864 21.368304000000002 12.031512 21.054384 12.666623999999999L20.964000000000002 12.84948 20.952 16.402728L20.94 19.956 20.88852 20.105952000000002C20.75976 20.48112 20.450352 20.782008 20.076 20.896104C19.937736 20.938248 19.615776 20.94 12 20.94C4.384224 20.94 4.062264 20.938248 3.924 20.896104C3.536016 20.777856 3.208944 20.448287999999998 3.104856 20.070696C3.0614640000000004 19.913328 3.06 19.648704000000002 3.06 11.988C3.06 4.38384 3.061752 4.062264 3.103896 3.924C3.217992 3.549648 3.5188800000000002 3.24024 3.894048 3.1114800000000002L4.0440000000000005 3.06 7.597272 3.048L11.15052 3.036 11.333376 2.945616C11.968488 2.631696 12.092136 1.8064799999999999 11.577072 1.319352C11.424336 1.174896 11.254007999999999 1.091856 11.040000000000001 1.0574400000000002C10.851936 1.0272 4.30632 1.028064 3.966168 1.058352M15.156648 1.058424C14.742144 1.119696 14.39484 1.469376 14.326416 1.894344C14.256096000000001 2.330928 14.488871999999999 2.765496 14.896439999999998 2.9585280000000003L15.06 3.036 17.2914 3.04236L19.5228 3.048744 15.344472 7.23036C10.776792 11.801664 11.069568 11.490192 11.009328 11.841912C10.895904 12.504024 11.495976 13.104096 12.158088 12.990672C12.509808 12.930432000000001 12.198336000000001 13.223208 16.76964 8.655528L20.951256 4.477200000000001 20.95764 6.7086L20.964000000000002 8.94 21.041472 9.10356C21.341736 9.73752 22.161192 9.883632 22.65264 9.390816C22.828104000000003 9.214872 22.912248 9.043632 22.944864 8.796C22.961904 8.666712 22.96764 7.502424 22.962408000000003 5.232C22.955351999999998 2.170008 22.950984000000002 1.8496799999999998 22.91496 1.74768C22.809048 1.4477520000000001 22.552536 1.190688 22.25436 1.08564C22.149552 1.048704 21.854112 1.0450080000000002 18.72 1.041288C16.839 1.039056 15.235488 1.0467600000000001 15.156648 1.058424'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', 'none'),
								A2($elm$html$Html$Attributes$attribute, 'fill-rule', 'evenodd'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-width', '0.024')
							]),
						_List_Nil)
					])
			};
		case 26:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M29.5,63.6c-2.8,0-5-2.3-5-5v-24.3L5.1,8.3c-.6-.9-1-1.9-1-3C4.1,2.5,6.4.2,9.1.2h45.7c1.1,0,2.2.4,3,1,2.2,1.7,2.7,4.8,1,7.1l-19.3,26v20.5c0,1.6-.8,3.1-2,4l-5.1,3.8c-.9.6-1.9,1-3,1ZM9.1,5.2l19.8,26.7c.3.4.5,1,.5,1.5v25.1l5.1-3.8v-21.4c0-.5.2-1.1.5-1.5L54.9,5.3s0,0,0,0c0,0,0,0,0,0H9.1Z')
							]),
						_List_Nil)
					])
			};
		case 27:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M58.3,7.5h0c-.5,0-1,0-1.5.2l-6.2,1.8c-6.1,1.7-12.6.8-18-2.5-6.7-4.1-14.9-5.2-22.5-2.9l-5,1.5v-2.9C5.2,1.4,4.1.3,2.7.3S.2,1.4.2,2.8v58.5c0,1.4,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5v-10.8l6.4-2c6.2-1.9,12.9-1,18.4,2.3,4.4,2.7,9.4,4.1,14.4,4.1s5.1-.3,7.5-1.1l7.8-2.2c2.3-.7,3.9-2.8,3.9-5.2V12.9c0-3-2.4-5.4-5.4-5.4ZM58.7,46.3c0,.2-.1.4-.3.4l-7.8,2.2c-6.1,1.7-12.6.8-18-2.5-4.4-2.7-9.4-4.1-14.4-4.1s-5.4.4-8.1,1.2l-5,1.5V10.9l6.4-2c6.2-1.9,12.9-1,18.4,2.3,6.6,4,14.6,5.1,22,3l6.2-1.8s.1,0,.1,0c.2,0,.4.2.4.4v33.5Z')
							]),
						_List_Nil)
					])
			};
		case 28:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_2'),
						A2($elm$html$Html$Attributes$attribute, 'data-name', 'Layer 2'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 62.77 62.77')
					]),
				N: _List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'g',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1-2'),
								A2($elm$html$Html$Attributes$attribute, 'data-name', 'Layer 1')
							]),
						_List_fromArray(
							[
								A3(
								$elm$svg$Svg$node,
								'path',
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'd', 'M53.7,53.43c5.6-5.67,9.07-13.46,9.07-22.04C62.77,14.08,48.69,0,31.39,0,22.8,0,15.02,3.47,9.35,9.07c-.05.04-.11.08-.15.13-.05.05-.08.1-.13.15C3.47,15.02,0,22.8,0,31.39c0,17.31,14.08,31.39,31.39,31.39,8.58,0,16.37-3.47,22.04-9.07.05-.04.1-.08.15-.12s.08-.1.12-.15ZM57.77,31.39c0,6.38-2.27,12.23-6.05,16.8L14.59,11.05c4.57-3.78,10.42-6.05,16.8-6.05,14.55,0,26.39,11.84,26.39,26.39ZM5,31.39c0-6.38,2.27-12.23,6.05-16.8l37.13,37.13c-4.57,3.78-10.42,6.05-16.8,6.05-14.55,0-26.39-11.84-26.39-26.39Z')
									]),
								_List_Nil)
							]))
					])
			};
		case 29:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M55.9,10.5c0-2.7-1.1-5.3-3-7.3-1.9-1.9-4.5-3-7.3-3h0c-2.7,0-5.3,1.1-7.3,3-1.9,1.9-3,4.5-3,7.3h0c0,4.7,3.2,8.7,7.6,9.9-1,6.2-6.4,10.9-12.9,10.9h-9.2v-10.9c1.8-.4,3.4-1.4,4.8-2.7,1.9-1.9,3-4.5,3-7.3,0-2.7-1.1-5.3-3-7.3-1.9-1.9-4.5-3-7.3-3h0c-2.7,0-5.3,1.1-7.3,3-1.9,1.9-3,4.5-3,7.3,0,4.8,3.3,8.8,7.8,10v22.8c-1.8.4-3.4,1.4-4.8,2.7-1.9,1.9-3,4.5-3,7.3,0,2.7,1.1,5.3,3,7.3,1.9,1.9,4.5,3,7.3,3h0c2.7,0,5.3-1.1,7.3-3s3-4.5,3-7.3c0-4.8-3.3-8.8-7.8-10v-7h9.2c9.2,0,16.8-6.9,17.9-15.8,4.5-1.1,7.9-5.1,7.9-10ZM13.1,10.5h-2.5s2.5,0,2.5,0c0-1.4.5-2.7,1.5-3.7,1-1,2.3-1.5,3.7-1.5h0c1.4,0,2.7.5,3.7,1.5s1.5,2.3,1.5,3.7-.5,2.7-1.5,3.7c-1,1-2.3,1.5-3.7,1.5,0,0,0,0,0,0s0,0,0,0c-2.9,0-5.3-2.4-5.3-5.3ZM23.7,53.2c0,1.4-.5,2.7-1.5,3.7-1,1-2.3,1.5-3.7,1.5h0c-1.4,0-2.7-.5-3.7-1.5-1-1-1.5-2.3-1.5-3.7h0c0-1.4.5-2.7,1.5-3.7,1-1,2.3-1.5,3.7-1.5,0,0,0,0,0,0s0,0,0,0c2.9,0,5.3,2.4,5.3,5.3ZM45.6,15.8s0,0,0,0,0,0,0,0c-2.9,0-5.3-2.4-5.3-5.3h-2.5,2.5c0-1.4.5-2.7,1.5-3.7,1-1,2.3-1.5,3.7-1.5h0c2.9,0,5.3,2.4,5.3,5.3,0,2.9-2.4,5.3-5.3,5.3Z')
							]),
						_List_Nil)
					])
			};
		case 30:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M32,63.6c-.8,0-1.5-.1-2.3-.4-1.9-.7-3.5-2.2-4.2-4.2l-1.2-3.3c-.3-.7-.8-1.3-1.5-1.6-.7-.3-1.5-.4-2.2-.1,0,0-.2,0-.3.1l-3.1,1.5c-3.4,1.6-7.5.2-9.1-3.2-.9-1.9-.9-4,0-5.9l1.5-3.1c.7-1.4,0-3.1-1.3-3.8,0,0-.2,0-.3-.1l-3.3-1.2c-1.7-.6-3.1-1.9-3.9-3.5-.8-1.7-.9-3.5-.3-5.2.7-2,2.2-3.5,4.2-4.2l3.3-1.2c.7-.3,1.3-.8,1.6-1.5.3-.7.4-1.5.1-2.2,0,0,0-.2-.1-.3l-1.5-3.1c-.8-1.6-.9-3.5-.3-5.2.6-1.7,1.8-3.1,3.5-3.9,1.9-.9,4-.9,5.9,0l3.1,1.5c1.4.7,3.1,0,3.8-1.3,0,0,0-.2.1-.3l1.2-3.3c.6-1.7,1.9-3.1,3.5-3.9,1.7-.8,3.5-.9,5.2-.3,1.9.7,3.5,2.2,4.2,4.2l1.2,3.3c.3.7.8,1.3,1.5,1.6.7.3,1.5.4,2.2.1,0,0,.2,0,.3-.1l3.1-1.5c3.4-1.6,7.5-.2,9.1,3.2.9,1.9.9,4,0,5.9l-1.5,3.1c-.7,1.4,0,3.1,1.3,3.8,0,0,.2,0,.3.1l3.3,1.2c3.6,1.3,5.4,5.2,4.2,8.7-.7,2-2.2,3.5-4.2,4.2l-3.3,1.2c-1.5.5-2.3,2.2-1.7,3.6,0,0,0,.2.1.3l1.5,3.1c.8,1.6.9,3.5.3,5.2s-1.9,3.1-3.5,3.9c-1.9.9-4,.9-5.9,0l-3.1-1.5c-.7-.3-1.5-.4-2.2-.1-.7.3-1.3.8-1.6,1.5,0,0,0,.2-.1.3l-1.2,3.3c-1,2.8-3.6,4.5-6.5,4.5ZM21.7,49.9c2.8,0,5.5,1.8,6.5,4.6l1.2,3.3c.3.8.9,1.4,1.7,1.7,1.5.5,3.1-.2,3.6-1.7l1.2-3.3c0-.2.2-.4.3-.6.8-1.6,2.2-2.9,3.9-3.5,1.7-.6,3.6-.5,5.2.3l3.1,1.5c.8.4,1.7.4,2.5,0,.7-.3,1.2-.9,1.5-1.6.3-.7.2-1.5-.1-2.2l-1.5-3.1c-.1-.2-.2-.4-.3-.7-1.3-3.6.6-7.5,4.2-8.7l3.3-1.2c.8-.3,1.4-.9,1.7-1.7.5-1.5-.3-3.1-1.7-3.6l-3.3-1.2c-.2,0-.4-.2-.7-.3-3.4-1.6-4.9-5.7-3.2-9.1h0s1.5-3.1,1.5-3.1c.4-.8.4-1.7,0-2.5-.7-1.4-2.4-2-3.8-1.3l-3.1,1.5c-.2.1-.4.2-.6.3-1.7.6-3.6.5-5.2-.3-1.7-.8-2.9-2.2-3.5-3.9l-1.2-3.3c-.3-.8-.9-1.4-1.7-1.7-.7-.3-1.5-.2-2.2.1-.7.3-1.2.9-1.5,1.6l-1.2,3.3c0,.2-.2.4-.3.6-1.6,3.4-5.7,4.9-9.1,3.2l-3.1-1.5c-.8-.4-1.7-.4-2.5,0-.7.3-1.2.9-1.5,1.6s-.2,1.5.1,2.2l1.5,3.1c0,.2.2.4.3.6.6,1.7.5,3.6-.3,5.2s-2.2,2.9-3.9,3.5l-3.3,1.2c-.8.3-1.4.9-1.7,1.7-.3.7-.2,1.5.1,2.2.3.7.9,1.2,1.6,1.5l3.3,1.2c.2,0,.4.2.7.3,3.4,1.6,4.9,5.7,3.2,9.1l-1.5,3.1c-.4.8-.4,1.7,0,2.5.7,1.4,2.4,2,3.8,1.3l3.1-1.5c.2-.1.4-.2.7-.3.8-.3,1.5-.4,2.3-.4Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M32,45.5c-7.5,0-13.6-6.1-13.6-13.6s6.1-13.6,13.6-13.6,13.6,6.1,13.6,13.6-6.1,13.6-13.6,13.6ZM32,22.3c-5.3,0-9.6,4.3-9.6,9.6s4.3,9.6,9.6,9.6,9.6-4.3,9.6-9.6-4.3-9.6-9.6-9.6Z')
							]),
						_List_Nil)
					])
			};
		case 31:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M32,3c-16.4,0-29.8,13.3-29.8,29.7,0,12.8,8.2,24.2,20.4,28.3,1.5.3,2-.6,2-1.4s0-2.7,0-5.2c-8.3,1.8-10-3.9-10-3.9-.5-1.8-1.7-3.3-3.3-4.4-2.7-1.8.2-1.8.2-1.8,1.9.3,3.6,1.4,4.6,3.1,1.7,3.1,5.5,4.2,8.6,2.5,0,0,0,0,0,0,.1-1.5.8-2.9,1.9-4-6.6-.8-13.5-3.3-13.5-14.7,0-3,1.1-5.8,3.1-8-.9-2.6-.8-5.4.3-7.9,0,0,2.5-.8,8.2,3.1,4.9-1.3,10-1.3,14.9,0,5.7-3.8,8.2-3.1,8.2-3.1,1.1,2.5,1.2,5.3.3,7.9,2,2.2,3.1,5,3.1,8,0,11.4-7,13.9-13.6,14.7,1.4,1.4,2.2,3.4,2,5.5v8.2c0,.8.5,1.7,2,1.4,15.6-5.2,24-22,18.9-37.6C56.2,11.2,44.8,3,32,3Z')
							]),
						_List_Nil)
					])
			};
		case 32:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_2'),
						A2($elm$html$Html$Attributes$attribute, 'data-name', 'Layer 2'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 62.28 54.47')
					]),
				N: _List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'g',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_2-2'),
								A2($elm$html$Html$Attributes$attribute, 'data-name', 'Layer 2')
							]),
						_List_fromArray(
							[
								A3(
								$elm$svg$Svg$node,
								'g',
								_List_Nil,
								_List_fromArray(
									[
										A3(
										$elm$svg$Svg$node,
										'path',
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$attribute, 'd', 'M48.06,31.03h-13.02c-1.38,0-2.5-1.12-2.5-2.5v-14.32c0-1.38,1.12-2.5,2.5-2.5s2.5,1.12,2.5,2.5v11.82h10.52c1.38,0,2.5,1.12,2.5,2.5s-1.12,2.5-2.5,2.5Z')
											]),
										_List_Nil),
										A3(
										$elm$svg$Svg$node,
										'path',
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$attribute, 'd', 'M35.04,0C21.37,0,10.01,10.14,8.1,23.29l-3.52-5.28c-.77-1.15-2.32-1.46-3.47-.69-1.15.77-1.46,2.32-.69,3.47l7.8,11.7c.11.16.23.31.37.44.02.02.03.03.05.04.12.11.24.2.38.28.03.02.06.03.1.05.13.07.26.13.4.17.04.01.08.02.11.04.14.04.28.06.43.08.03,0,.05.01.08.01.03,0,.06,0,.09,0,.02,0,.05,0,.07,0,.37,0,.71-.08,1.03-.23,0,0,0,0,.01,0,.15-.07.29-.15.42-.25.03-.02.05-.04.08-.07.11-.08.21-.17.3-.28.01-.01.03-.02.04-.04l9.11-10.42c.91-1.04.8-2.62-.24-3.53-1.04-.91-2.62-.8-3.53.24l-4.52,5.17c1.47-10.84,10.79-19.23,22.02-19.23,12.26,0,22.23,9.97,22.23,22.23s-9.97,22.23-22.23,22.23c-1.38,0-2.5,1.12-2.5,2.5s1.12,2.5,2.5,2.5c15.02,0,27.23-12.22,27.23-27.23S50.06,0,35.04,0Z')
											]),
										_List_Nil)
									]))
							]))
					])
			};
		case 33:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M17.3,10.6h-4.6c-.9,0-1.6.7-1.6,1.6v7.2c0,.9.7,1.6,1.6,1.6h4.6c.9,0,1.6-.7,1.6-1.6v-7.2c0-.9-.7-1.6-1.6-1.6Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M34.2,10.6h-4.6c-.9,0-1.6.7-1.6,1.6v7.2c0,.9.7,1.6,1.6,1.6h4.6c.9,0,1.6-.7,1.6-1.6v-7.2c0-.9-.7-1.6-1.6-1.6Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M17.3,30.1h-4.6c-.9,0-1.6.7-1.6,1.6v7.2c0,.9.7,1.6,1.6,1.6h4.6c.9,0,1.6-.7,1.6-1.6v-7.2c0-.9-.7-1.6-1.6-1.6Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M34.2,30.1h-4.6c-.9,0-1.6.7-1.6,1.6v7.2c0,.9.7,1.6,1.6,1.6h4.6c.9,0,1.6-.7,1.6-1.6v-7.2c0-.9-.7-1.6-1.6-1.6Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M58.4,26h-12.7V5.5c0-2.4-1.7-4.1-4.1-4.1H5.3C2.9,1.4,1.2,3.1,1.2,5.5v55.7c0,.8.7,1.5,1.5,1.5h58.3c.8,0,1.5-.7,1.5-1.5v-31.1c0-2.4-1.7-4.1-4.1-4.1ZM58.4,29c.7,0,1.1.4,1.1,1.1v29.6h-13.8v-30.7h12.7ZM5.3,4.4h36.3c.7,0,1.1.4,1.1,1.1v54.2h-13.1v-7c0-3.4-2.8-6.2-6.2-6.2s-6.2,2.8-6.2,6.2v7H4.2V5.5c0-.7.4-1.1,1.1-1.1ZM26.6,59.7h-6.3v-7c0-1.8,1.4-3.2,3.2-3.2s3.2,1.4,3.2,3.2v7Z')
							]),
						_List_Nil)
					])
			};
		case 34:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 26.72 20'),
						A2($elm$html$Html$Attributes$attribute, 'style', 'vertical-align: '),
						A2($elm$html$Html$Attributes$attribute, 'width', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'height', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'fill', 'rgba(0%,0%,0%,1)')
					]),
				N: _List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M5.91 2.69l-2.56 7.2c-.32.9-.64 1.8-1 2.69-.07.2 0 .26.17.25H3.6c.36 0 .3-.07.37-.27.5-1.43 1-2.85 1.51-4.29.11-.32.25-.43.56-.38a3.07 3.07 0 00.43 0l-.93 2.64c-.24.69-.48 1.37-.74 2.06-.08.2 0 .24.18.24h1.1a.31.31 0 00.34-.23c.49-1.41 1-2.82 1.49-4.23A.9.9 0 007 7H6c.3-.83.58-1.63.86-2.43.23-.63.46-1.25.67-1.88a.3.3 0 01.31-.26 6.43 6.43 0 012.6.57 7.25 7.25 0 014.65 6.36 7.48 7.48 0 01-7.4 8.18c-.45 0-.45 0-.3-.42.45-1.28.91-2.55 1.35-3.83a.33.33 0 01.38-.29h1.38a.9.9 0 001-.68c.48-1.33.95-2.67 1.42-4C13.17 7.54 12.83 7 12 7H9.6c-.24 0-.26.15-.31.3L6 16.46l-.11.29c-.2.57-.2.57-.79.37a7.56 7.56 0 01.54-14.41.4.4 0 01.27-.02zM17.39 7c.49 0 .49 0 .4.48-.19 1-.39 2.05-.58 3.08a3.87 3.87 0 00-.05.49.94.94 0 00.5 1 1.21 1.21 0 001.34-.23 2.07 2.07 0 00.57-1.14c.22-1.14.45-2.29.65-3.44 0-.21.13-.27.32-.25h.56c.18 0 .2.06.17.21-.24 1.22-.47 2.44-.72 3.65a3.4 3.4 0 01-.24.7 2.41 2.41 0 01-3 1.35 1.69 1.69 0 01-1.17-1.9c.06-.76.25-1.5.38-2.24.08-.48.2-.95.26-1.42 0-.31.17-.41.45-.36zM26.46 7a1 1 0 01-.22.36c-.59.78-1.17 1.56-1.77 2.33a.44.44 0 00-.07.49c.33.82.63 1.65 1 2.47.08.19.09.28-.17.28-.82 0-.82 0-1.09-.77-.18-.5-.36-1-.53-1.51-.12 0-.13.12-.17.19-.41.63-.82 1.25-1.22 1.89a.35.35 0 01-.35.18h-.94c0-.13.07-.19.12-.26.63-.85 1.26-1.7 1.9-2.54a.43.43 0 00.05-.48c-.33-.86-.64-1.72-1-2.64h1c.17 0 .16.14.2.23.22.65.43 1.3.65 2 .06 0 .08 0 .1-.08.37-.66.82-1.27 1.24-1.91a.4.4 0 01.4-.2z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M11.51 7.88c-.22.62-.43 1.21-.63 1.79-.26.73-.53 1.44-.77 2.18a.42.42 0 01-.49.36c-.48 0-.49 0-.33-.46.43-1.19.86-2.37 1.26-3.56.09-.25.21-.34.46-.31a4.16 4.16 0 00.5 0z')
							]),
						_List_Nil)
					])
			};
		case 35:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M31.6,62.9c-7.8,0-15.2-3-20.9-8.5-5.8-5.6-9-13.1-9.1-21.1v-.4C1.5,16.2,15.2,2.4,32,2.1c.2,0,.3,0,.5,0,16.3,0,29.7,13.2,30,29.5v.4s0,0,0,0c0,16.8-13.6,30.7-30.4,30.9-.2,0-.3,0-.5,0ZM32.4,6.1c-.1,0-.3,0-.4,0-14.6.2-26.5,12.3-26.4,26.9v.3c.1,6.9,2.9,13.4,7.9,18.3,5,4.8,11.6,7.4,18.5,7.3,14.6-.2,26.5-12.3,26.4-26.9v-.3c-.1-6.9-2.9-13.4-7.9-18.3-4.9-4.7-11.3-7.3-18.1-7.3Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M32,39.7c-1.1,0-2-.9-2-2v-18.1c0-1.1.9-2,2-2s2,.9,2,2v18.1c0,1.1-.9,2-2,2Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M32,47.2c-1.5,0-2.6-1.1-2.7-2.6h0s0,0,0,0c0-.7.3-1.4.7-1.9.5-.5,1.1-.8,1.9-.8h0s0,0,0,0c.1,0,.2,0,.4,0,1.3.2,2.2,1.2,2.3,2.5,0,0,0,0,0,0,0,.7-.2,1.4-.7,1.9-.5.5-1.1.8-1.8.8ZM31.9,45.9h0,0Z')
							]),
						_List_Nil)
					])
			};
		case 36:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_2'),
						A2($elm$html$Html$Attributes$attribute, 'data-name', 'Layer 2'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 63.42 63.42')
					]),
				N: _List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'g',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1-2'),
								A2($elm$html$Html$Attributes$attribute, 'data-name', 'Layer 1')
							]),
						_List_fromArray(
							[
								A3(
								$elm$svg$Svg$node,
								'path',
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'd', 'M45.92,35c-9.65,0-17.5-7.85-17.5-17.5S36.27,0,45.92,0s17.5,7.85,17.5,17.5-7.85,17.5-17.5,17.5ZM45.92,4c-7.44,0-13.5,6.06-13.5,13.5s6.06,13.5,13.5,13.5,13.5-6.06,13.5-13.5-6.06-13.5-13.5-13.5Z')
									]),
								_List_Nil),
								A3(
								$elm$svg$Svg$node,
								'path',
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'd', 'M53.14,18.02c-.78-.78-2.05-.78-2.83,0l-2.4,2.4v-10.67c0-1.1-.9-2-2-2s-2,.9-2,2v10.67l-2.4-2.4c-.78-.78-2.05-.78-2.83,0-.78.78-.78,2.05,0,2.83l5.81,5.81c.09.09.2.18.31.25.05.03.1.05.15.08.06.04.13.07.2.1.07.03.13.04.2.06.06.02.11.04.17.05.13.03.26.04.39.04s.26-.01.39-.04c.06-.01.12-.03.17-.05.07-.02.13-.04.2-.06.07-.03.13-.07.2-.1.05-.03.1-.05.15-.08.11-.07.21-.16.31-.25l5.81-5.81c.78-.78.78-2.05,0-2.83Z')
									]),
								_List_Nil),
								A3(
								$elm$svg$Svg$node,
								'path',
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'd', 'M56.25,36.52c-1.1,0-2,.9-2,2v2.81H4V14.92c0-.32.26-.58.58-.58h18.73c1.1,0,2-.9,2-2s-.9-2-2-2H4.58c-2.53,0-4.58,2.06-4.58,4.58v33.58c0,2.53,2.06,4.58,4.58,4.58h18.42c-.41,2.28-1.3,4.43-2.64,6.33h-2.86c-1.1,0-2,.9-2,2s.9,2,2,2h23.25c1.1,0,2-.9,2-2s-.9-2-2-2h-2.86c-1.34-1.91-2.23-4.06-2.64-6.33h18.42c2.53,0,4.58-2.06,4.58-4.58v-9.98c0-1.1-.9-2-2-2ZM33.23,59.42h-8.2c1.03-1.98,1.71-4.11,2.03-6.33h4.14c.32,2.22,1.01,4.35,2.03,6.33ZM53.67,49.08H4.58c-.32,0-.58-.26-.58-.58v-3.17h50.25v3.17c0,.32-.26.58-.58.58Z')
									]),
								_List_Nil)
							]))
					])
			};
		case 37:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 45 45'),
						A2($elm$html$Html$Attributes$attribute, 'style', 'vertical-align: '),
						A2($elm$html$Html$Attributes$attribute, 'width', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'height', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'fill', 'rgba(0%,0%,0%,1)')
					]),
				N: _List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'g',
						_List_Nil,
						_List_fromArray(
							[
								A3(
								$elm$svg$Svg$node,
								'path',
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'd', 'm19.1325 26.90625 0.013125 0.01875 -1.873125 4.524375a9.695625 9.695625 0 0 1 -3.8906250000000004 -4.869375l4.833749999999999 -0.819375 0.0075 0.009375a0.825 0.825 0 0 1 0.9075 1.13625zm-1.561875 -3.991875a0.825 0.825 0 0 0 0.32437499999999997 -1.4175l0.00375 -0.020624999999999998L14.221875 18.1875a9.643125 9.643125 0 0 0 -1.36875 6.1031249999999995l4.713749999999999 -1.359375 0.00375 -0.016874999999999998zm2.146875 -3.7125a0.825 0.825 0 0 0 1.310625 -0.6318750000000001l0.01875 -0.009375 0.28125 -4.9125000000000005a9.645 9.645 0 0 0 -5.64375 2.70375l4.025625 2.855625 0.0075 -0.00375zm1.425 5.15625 1.3556249999999999 0.6543749999999999 1.35375 -0.650625 0.33749999999999997 -1.4625000000000001 -0.9375 -1.168125h-1.5075l-0.9375 1.168125 0.335625 1.460625zm2.8125 -5.8031250000000005a0.825 0.825 0 0 0 1.3125 0.63l0.015 0.005625 4.00125 -2.836875a9.7275 9.7275 0 0 0 -5.61 -2.70375l0.27749999999999997 4.903125 0.00375 0.001875zm20.3925 11.19375 -10.824375 13.464375a3 3 0 0 1 -2.34 1.11375l-17.364375 0.005625a3 3 0 0 1 -2.3381250000000002 -1.1175l-10.83 -13.462499999999999a2.968125 2.968125 0 0 1 -0.5756249999999999 -2.5125L3.9375 10.449375c0.20249999999999999 -0.88125 0.796875 -1.6199999999999999 1.618125 -2.011875L21.196875 0.961875a3.01125 3.01125 0 0 1 2.596875 0l15.646875000000001 7.471875c0.82125 0.391875 1.415625 1.1325 1.618125 2.011875l3.8662499999999995 16.790625c0.20249999999999999 0.88125 -0.009375 1.805625 -0.5775 2.5125zm-6.166875 -3.856875c-0.07875 -0.01875 -0.193125 -0.048749999999999995 -0.271875 -0.06375 -0.32625 -0.061875 -0.590625 -0.046875 -0.898125 -0.07125 -0.65625 -0.06937499999999999 -1.19625 -0.12562500000000001 -1.678125 -0.27749999999999997 -0.196875 -0.075 -0.33749999999999997 -0.309375 -0.40499999999999997 -0.40499999999999997l-0.376875 -0.110625a12.09375 12.09375 0 0 0 -0.196875 -4.3725 12.121875 12.121875 0 0 0 -1.7550000000000001 -4.055625c0.09749999999999999 -0.088125 0.28125 -0.249375 0.331875 -0.29812500000000003 0.015 -0.16874999999999998 0.001875 -0.343125 0.17625 -0.5287499999999999 0.369375 -0.346875 0.8325 -0.63375 1.393125 -0.97875 0.26625 -0.1575 0.5118750000000001 -0.256875 0.778125 -0.45375 0.06 -0.045 0.1425 -0.11624999999999999 0.20625 -0.166875 0.44999999999999996 -0.358125 0.553125 -0.9750000000000001 0.230625 -1.38 -0.32249999999999995 -0.40499999999999997 -0.94875 -0.4425 -1.396875 -0.08437499999999999 -0.06375 0.050624999999999996 -0.15 0.11624999999999999 -0.208125 0.16499999999999998 -0.25125000000000003 0.2175 -0.406875 0.43125 -0.61875 0.65625 -0.46125 0.46875 -0.84375 0.85875 -1.261875 1.141875 -0.181875 0.105 -0.448125 0.06937499999999999 -0.568125 0.061875l-0.35625 0.25312500000000004a12.271875 12.271875 0 0 0 -7.77375 -3.755625l-0.0225 -0.418125c-0.12187500000000001 -0.11624999999999999 -0.268125 -0.215625 -0.30562500000000004 -0.46875 -0.041249999999999995 -0.5025000000000001 0.028124999999999997 -1.044375 0.106875 -1.6968750000000001 0.043125 -0.30562500000000004 0.114375 -0.55875 0.1275 -0.890625 0.001875 -0.075 -0.001875 -0.185625 -0.001875 -0.26625 0 -0.57375 -0.42 -1.0406250000000001 -0.9375 -1.0406250000000001 -0.515625 0 -0.935625 0.466875 -0.935625 1.0406250000000001l0.001875 0.02625c0 0.076875 -0.00375 0.1725 0 0.24 0.01125 0.331875 0.08249999999999999 0.585 0.12562500000000001 0.890625 0.07875 0.6525 0.14625 1.194375 0.105 1.69875a1.021875 1.021875 0 0 1 -0.30375 0.48375l-0.0225 0.395625a12.045 12.045 0 0 0 -7.811250000000001 3.755625 15.699374999999998 15.699374999999998 0 0 1 -0.33749999999999997 -0.24c-0.16874999999999998 0.0225 -0.33749999999999997 0.075 -0.556875 -0.054375 -0.418125 -0.28125 -0.800625 -0.67125 -1.261875 -1.14 -0.211875 -0.22499999999999998 -0.36562500000000003 -0.43875000000000003 -0.6168750000000001 -0.6543749999999999 -0.056249999999999994 -0.048749999999999995 -0.144375 -0.11624999999999999 -0.208125 -0.16499999999999998a1.11375 1.11375 0 0 0 -0.6525 -0.2475 0.901875 0.901875 0 0 0 -0.7462500000000001 0.32999999999999996c-0.32249999999999995 0.40499999999999997 -0.21937500000000001 1.0237500000000002 0.230625 1.381875l0.013125 0.009375 0.19499999999999998 0.155625c0.26625 0.196875 0.51 0.29812500000000003 0.77625 0.45375 0.5606249999999999 0.346875 1.0237500000000002 0.63375 1.393125 0.97875 0.1425 0.15375 0.16874999999999998 0.42375 0.1875 0.5399999999999999l0.3 0.268125a12.116249999999999 12.116249999999999 0 0 0 -1.9125 8.44875l-0.38999999999999996 0.11249999999999999c-0.103125 0.13499999999999998 -0.249375 0.345 -0.403125 0.406875 -0.481875 0.151875 -1.0237500000000002 0.20625 -1.678125 0.275625 -0.3075 0.02625 -0.571875 0.01125 -0.8999999999999999 0.073125 -0.06937499999999999 0.013125 -0.16874999999999998 0.0375 -0.249375 0.056249999999999994l-0.0075 0.00375 -0.013125 0.00375c-0.553125 0.133125 -0.9075 0.6412500000000001 -0.793125 1.14 0.114375 0.500625 0.6543749999999999 0.804375 1.209375 0.684375l0.013125 -0.001875 0.01875 -0.005625 0.241875 -0.054375c0.31875000000000003 -0.08625 0.55125 -0.211875 0.84 -0.32249999999999995 0.61875 -0.22125 1.1325 -0.406875 1.63125 -0.48 0.21 -0.016874999999999998 0.43125 0.12937500000000002 0.5399999999999999 0.18937500000000002l0.406875 -0.06937499999999999a12.1875 12.1875 0 0 0 5.3999999999999995 6.7425l-0.16874999999999998 0.40875c0.061875 0.1575 0.12937500000000002 0.37312500000000004 0.08249999999999999 0.5287499999999999 -0.181875 0.47250000000000003 -0.49312500000000004 0.969375 -0.8475 1.5243749999999998 -0.170625 0.255 -0.346875 0.45375 -0.5025000000000001 0.748125 -0.0375 0.06937499999999999 -0.08437499999999999 0.178125 -0.12 0.25125000000000003 -0.24 0.515625 -0.06375 1.108125 0.399375 1.3312499999999998 0.46499999999999997 0.22499999999999998 1.0425 -0.013125 1.29375 -0.5287499999999999v-0.00375c0.0375 -0.073125 0.08625 -0.16874999999999998 0.11624999999999999 -0.238125 0.13125 -0.30375 0.17625 -0.564375 0.26999999999999996 -0.85875 0.2475 -0.6225 0.38437499999999997 -1.2750000000000001 0.725625 -1.681875 0.09375 -0.11249999999999999 0.24375000000000002 -0.15375 0.403125 -0.196875l0.211875 -0.38437499999999997a12.099375 12.099375 0 0 0 8.641875 0.0225l0.19874999999999998 0.36c0.16124999999999998 0.0525 0.33749999999999997 0.07875 0.48 0.290625 0.255 0.435 0.429375 0.950625 0.6412500000000001 1.575 0.09375 0.2925 0.13874999999999998 0.553125 0.271875 0.856875 0.03 0.06937499999999999 0.08062499999999999 0.16874999999999998 0.11624999999999999 0.241875 0.249375 0.5175000000000001 0.82875 0.75375 1.29375 0.5287499999999999 0.463125 -0.22125 0.639375 -0.815625 0.399375 -1.3312499999999998 -0.0375 -0.073125 -0.08437499999999999 -0.18 -0.12187500000000001 -0.25125000000000003 -0.155625 -0.2925 -0.331875 -0.489375 -0.5025000000000001 -0.7462500000000001 -0.35625 -0.5549999999999999 -0.6487499999999999 -1.014375 -0.8306250000000001 -1.4868750000000002 -0.075 -0.24375000000000002 0.013125 -0.39375 0.07125 -0.55125 -0.033749999999999995 -0.041249999999999995 -0.110625 -0.26999999999999996 -0.155625 -0.37875000000000003a12.185625 12.185625 0 0 0 5.3999999999999995 -6.79125c0.12 0.01875 0.32999999999999996 0.056249999999999994 0.399375 0.07125 0.140625 -0.09375 0.26999999999999996 -0.21375 0.525 -0.19499999999999998 0.49875 0.073125 1.0125000000000002 0.25875000000000004 1.63125 0.48 0.28875 0.11249999999999999 0.519375 0.24 0.84 0.32437499999999997 0.06749999999999999 0.01875 0.16499999999999998 0.035625 0.24375000000000002 0.0525l0.016874999999999998 0.005625 0.013125 0.001875c0.556875 0.12 1.095 -0.18375 1.209375 -0.684375 0.11249999999999999 -0.49875 -0.24 -1.006875 -0.793125 -1.14zM30.749999999999996 18.189375000000002l-3.65625 3.27375v0.009375a0.825 0.825 0 0 0 0.32437499999999997 1.419375l0.005625 0.01875 4.73625 1.365a9.748125 9.748125 0 0 0 -0.20249999999999999 -3.13875A9.765 9.765 0 0 0 30.749999999999996 18.1875zm-7.524375 9.984375a0.819375 0.819375 0 0 0 -0.7575000000000001 -0.435 0.825 0.825 0 0 0 -0.6975 0.436875h-0.00375l-2.3775 4.297499999999999a9.6825 9.6825 0 0 0 6.23625 0.005625l-2.38125 -4.305h-0.01875zm3.54 -2.424375a0.825 0.825 0 0 0 -0.5062500000000001 0.06749999999999999 0.825 0.825 0 0 0 -0.40125 1.0725l-0.005625 0.0075 1.89375 4.57125a9.65625 9.65625 0 0 0 3.901875 -4.903125l-4.875 -0.825 -0.0075 0.009375z')
									]),
								_List_Nil)
							]))
					])
			};
		case 38:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M60.9,7.3C53.7,3,43.9.8,32,.8S10.3,3,3,7.3c-1.6,1.1-2.6,3.1-2.6,5.1v8.5c0,19,11.8,35.9,29.4,42.4h4.2c17.7-6.5,29.5-23.2,29.5-42.1v-8.8c0-2-1-4-2.6-5.2ZM4.9,12.5c0-.6.3-1.2.5-1.3,6.1-3.7,14.4-5.7,24.7-5.9h0c0,0,1.8,0,1.8,0,11.2,0,20.1,2,26.6,5.8.3.1.6.7.6,1.3v8.8c0,17.1-10.9,32.3-27.1,38.1C15.8,53.7,4.9,38.3,4.9,21v-8.5Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M19,44.3c.7,0,1.4,0,2-.6l9.1-9.1,3.5,3.3c1.1,1.1,2.3,1.6,4,1.6s2.9-.5,4-1.6l4.5-4.5c2.1-2,2.1-5.5,0-7.9l-10.7-10.5c-1.1-1.1-2.3-1.6-4-1.6s-2.9.5-4,1.6l-4.5,4.5c-1.1,1.1-1.7,2.6-1.7,4.1,0,1.4.6,2.8,1.6,3.8l3.3,3.5-9,9c-.5.5-.8,1.1-.9,1.8,0,.7.3,1.4.8,2s1.3.6,2,.6Z')
							]),
						_List_Nil)
					])
			};
		case 39:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M60.3,7.1c-3.9-2.3-12.7-6.2-28.3-6.2S6,5.3,3.3,7.2c-1.6,1.2-2.6,3.2-2.6,5.2v8.2c0,19.3,11.9,35.9,30.4,42.2l.8.4h.6c18.2-6.2,30.4-23.2,30.4-42.2v-8.5c0-2-1-4-2.6-5.2ZM5.5,12.4c0-.8,0-1.1.4-1.3,3.4-2.1,11.4-5.7,26.1-5.7s24.2,4.4,26.1,5.8c.3.1.4.6.4,1.3v8.5c0,17.2-10.4,32-26.5,37.8-15.9-5.8-26.5-21-26.5-37.8v-8.5Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M20.4,43.8l9.9-9.9,4.1,4.1c1.1,1.1,2.2,1.5,3.8,1.5s2.7-.5,3.8-1.5l4.8-4.8h0c1.5-2.8,1.4-6.1-.4-8.2l-11.3-11c-1.1-1.1-2.2-1.5-3.8-1.5s-2.7.5-3.8,1.5l-4.8,5.1c-1.9,2.2-1.9,5.2,0,7.5l4.1,4.1-9.9,9.9c-.4.4-.7,1-.7,1.6s.2,1.1.7,1.5c.5.5,1,.5,1.7.5s1.2,0,1.7-.5ZM25.9,22.3l4.8-4.8c.2-.2.3-.2.7-.2s.5,0,.7.2l11.3,10.9c.1.2.1.8,0,1l-4.8,5.1c-.2.2-.3.2-.7.2s-.5,0-.7-.2l-11.3-11.3c-.1-.2-.1-.8,0-1Z')
							]),
						_List_Nil)
					])
			};
		case 40:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 26 31'),
						A2($elm$html$Html$Attributes$attribute, 'style', 'vertical-align: '),
						A2($elm$html$Html$Attributes$attribute, 'width', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'height', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'fill', 'rgba(0%,0%,0%,1)')
					]),
				N: _List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'g',
						_List_Nil,
						_List_fromArray(
							[
								A3(
								$elm$svg$Svg$node,
								'path',
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'd', 'M25.47,14.59c-.14-.41-.52-.68-.95-.68H4L17.71,3.61l-2.46,8.29h2.09l3.15-10.63c.12-.41-.03-.86-.39-1.11-.36-.25-.83-.24-1.17.02L.4,14.11c-.34.26-.48.71-.35,1.12s.52.68.95.68h20.58l-14.82,11.4,2.98-9.4h-2.1l-3.76,11.84c-.13.42.02.87.38,1.12.17.12.37.18.57.18.22,0,.43-.07.61-.21l19.68-15.14c.34-.26.48-.71.34-1.11Z')
									]),
								_List_Nil)
							]))
					])
			};
		case 41:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 48 48'),
						A2($elm$html$Html$Attributes$attribute, 'style', 'vertical-align: '),
						A2($elm$html$Html$Attributes$attribute, 'width', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'height', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'fill', 'rgba(0%,0%,0%,1)')
					]),
				N: _List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'g',
						_List_Nil,
						_List_fromArray(
							[
								A3(
								$elm$svg$Svg$node,
								'path',
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'd', 'M24.82 29.82a2 2 0 0 0 -1.1 2.6 2 2 0 0 1 -0.42 2.18l-5.66 5.66a4 4 0 0 1 -5.66 0L7.74 36a4 4 0 0 1 0 -5.66l5.66 -5.64a2 2 0 0 1 2.18 -0.42 2 2 0 0 0 1.52 -3.7 6 6 0 0 0 -6.54 1.3l-5.66 5.66a8 8 0 0 0 0 11.3l4.26 4.26a8 8 0 0 0 11.3 0l5.66 -5.66a6 6 0 0 0 1.3 -6.54 2 2 0 0 0 -2.6 -1.08Z'),
										A2($elm$html$Html$Attributes$attribute, 'stroke-width', '1')
									]),
								_List_Nil),
								A3(
								$elm$svg$Svg$node,
								'path',
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'd', 'M15.52 32.48a2 2 0 0 0 2.82 0L34 16.92a2 2 0 0 0 -2.82 -2.82l-15.66 15.56a2 2 0 0 0 0 2.82Z'),
										A2($elm$html$Html$Attributes$attribute, 'stroke-width', '1')
									]),
								_List_Nil),
								A3(
								$elm$svg$Svg$node,
								'path',
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'd', 'm43.1 9.14 -4.26 -4.24a8 8 0 0 0 -11.3 0l-5.66 5.66a6 6 0 0 0 -1.76 4.24 6 6 0 0 0 0.46 2.3 2 2 0 0 0 3.7 -1.52 2 2 0 0 1 -0.16 -0.78 2 2 0 0 1 0.58 -1.4l5.66 -5.66a4 4 0 0 1 5.66 0L40.26 12a4 4 0 0 1 0 5.66l-5.66 5.62a2 2 0 0 1 -2.18 0.44 2 2 0 0 0 -2.6 1.08 2 2 0 0 0 1.08 2.62 6 6 0 0 0 6.54 -1.3l5.66 -5.66a8 8 0 0 0 0 -11.32Z'),
										A2($elm$html$Html$Attributes$attribute, 'stroke-width', '1')
									]),
								_List_Nil)
							]))
					])
			};
		case 42:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 20 20'),
						A2($elm$html$Html$Attributes$attribute, 'style', 'vertical-align: '),
						A2($elm$html$Html$Attributes$attribute, 'width', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'height', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'fill', 'rgba(0%,0%,0%,1)')
					]),
				N: _List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'class', 'a'),
								A2($elm$html$Html$Attributes$attribute, 'd', 'M8.3,5.9c0.2,0.1,0.3,0.3,0.5,0.4C9,6.4,9.2,6.4,9.3,6.4l0,0c0.2,0,0.4,0,0.6,0c0.2-0.1,0.4-0.2,0.6-0.3 c0.2-0.1,0.4-0.2,0.6-0.3c0.3-0.2,0.4-0.4,0.3-0.4c-0.1,0-0.1,0-0.1,0.1c-0.1,0.1-0.2,0.2-0.3,0.2c-0.2,0.2-0.4,0.3-0.6,0.4 C10.2,6.2,10,6.3,9.8,6.4H9.2C8.9,6.3,8.6,6.1,8.4,5.9C8.3,5.8,8.2,5.8,8.1,5.7c0-0.1-0.1-0.1-0.1-0.1s0,0,0,0.1S8.1,5.7,8.3,5.9z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M10,4.8c0,0,0.1,0,0.2,0c0,0,0-0.1,0-0.1c-0.1,0-0.2,0-0.3,0l0,0C9.9,4.6,9.9,4.6,10,4.8C10,4.7,10,4.8,10,4.8z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M9.2,4.8h0.1c0,0,0.1,0,0.1,0S9.4,4.8,9.2,4.8C9.2,4.8,9.2,4.8,9.2,4.8H9c0,0,0,0.1,0,0.1C9.1,4.9,9.2,4.9,9.2,4.8 C9.2,4.8,9.2,4.8,9.2,4.8z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M9.6,7.1H9.4C9.1,7,8.8,6.9,8.6,6.7L8.3,6.4C8.1,6.3,7.9,6.1,7.8,5.8c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0.1-0.3 C7.9,5.2,8.1,5.1,8.2,5l0.4-0.3C8.8,4.6,9,4.4,9.2,4.3c0.1,0,0.3-0.1,0.4-0.1c0.4,0,0.7,0.1,1,0.3c0.2,0.1,0.4,0.2,0.7,0.3 c0.4,0.2,0.6,0.3,0.7,0.5c0,0.1,0,0.3,0,0.4c0,0.1-0.1,0.2-0.2,0.3c-0.2,0.2-0.4,0.3-0.7,0.4c-0.2,0.1-0.3,0.1-0.5,0.2 C10.4,6.8,10.2,6.9,10,7C9.8,7,9.7,7.1,9.6,7.1z M9.5,7c0.2,0,0.3,0,0.5,0c0.2-0.1,0.4-0.2,0.6-0.3c0.1-0.1,0.3-0.2,0.5-0.2 c0.2-0.1,0.5-0.2,0.7-0.4c0.1-0.1,0.1-0.2,0.2-0.3c0-0.1,0-0.2,0-0.3c-0.1-0.2-0.2-0.3-0.6-0.4c-0.2-0.1-0.5-0.2-0.7-0.3 c-0.3-0.2-0.6-0.3-0.9-0.3c-0.1,0-0.3,0-0.4,0C9,4.5,8.8,4.6,8.6,4.8C8.5,4.9,8.3,5,8.2,5.1L7.9,5.4C7.8,5.4,7.8,5.5,7.8,5.6 c0,0.1,0,0.1,0,0.2C7.9,6,8.1,6.2,8.3,6.3l0.3,0.2C8.8,6.8,9.1,6.9,9.5,7L9.5,7z M9.5,6.5c-0.1,0-0.2,0-0.3,0 C8.8,6.4,8.5,6.2,8.2,5.9C8,5.8,8,5.7,8,5.6s0-0.1,0-0.1s0.1,0,0.2,0.1c0.2,0.3,0.5,0.5,0.8,0.6c0.2,0.1,0.3,0.1,0.5,0.1 c0.1,0,0.2,0,0.3,0c0.3-0.1,0.6-0.2,0.9-0.4c0.2-0.1,0.4-0.2,0.5-0.4l0.2-0.2c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0 c0,0.1-0.1,0.2-0.4,0.4C11,6,10.8,6.1,10.5,6.2C10.3,6.3,10,6.4,9.7,6.5H9.5L9.5,6.5z M8.1,5.5L8.1,5.5c0,0,0,0.1,0.2,0.3 C8.5,6,8.8,6.2,9.2,6.3c0.2,0,0.3,0,0.5,0l0,0c0.3,0,0.6-0.1,0.9-0.3c0.2-0.1,0.4-0.2,0.6-0.4c0.3-0.2,0.3-0.3,0.4-0.3l0,0l0,0 l-0.1,0.1c-0.2,0.2-0.4,0.3-0.6,0.4C10.5,6,10.3,6.1,10,6.2c-0.1,0-0.2,0-0.4,0c-0.2,0-0.4,0-0.5-0.1C8.7,6,8.5,5.7,8.2,5.5 c0,0-0.1-0.1-0.1-0.1L8.1,5.5z M9.1,4.9L9.1,4.9C9.1,4.9,9.1,4.9,9.1,4.9C9.1,4.8,9.1,4.8,9.1,4.9c0-0.2,0.1-0.2,0.3-0.2 c0,0,0.1,0,0.1,0l0,0c0,0-0.1,0-0.1,0H9.3H9.2L9.1,4.9z M9.3,4.7c-0.1,0-0.2,0-0.2,0.1l0,0c0,0,0,0,0.1,0l0,0L9.3,4.7L9.3,4.7 L9.3,4.7L9.3,4.7z M10.1,4.9H10H9.9c0,0-0.1,0-0.1-0.1c0,0,0,0,0.1,0c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.1,0.1c0,0.1,0,0,0,0.1l0,0 L10.1,4.9L10.1,4.9z M9.9,4.7L9.9,4.7L9.9,4.7c0.1,0,0.2,0,0.2,0l0,0c0,0,0,0-0.1,0C10,4.7,9.9,4.7,9.9,4.7L9.9,4.7z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M17.8,15.8l-0.1-0.1c-0.1-0.2-0.2-0.4-0.2-0.6l-0.1-0.3c0-0.3-0.2-0.5-0.3-0.7C17,14,16.9,14,16.8,13.9l0,0v-0.1 c0.3-0.9,0.2-1.9-0.1-2.7c-0.4-1.1-1-2.1-1.8-3c-0.2-0.2-0.5-0.6-0.6-0.8c-0.3-0.4-0.6-0.9-0.7-1.4c-0.1-0.4-0.1-0.8-0.1-1.3 c0-0.7,0-0.9,0-1.3c0-1-0.3-1.9-1-2.6c-0.2-0.2-0.4-0.3-0.6-0.4C11.5,0.1,11.1,0,10.6,0c-0.5,0-1.1,0.1-1.6,0.2 c-1,0.4-1.6,1.3-1.6,2.4c0,0.2,0,0.5,0,0.7c0,0.3,0,0.5,0,1.1c0,0.3,0,0.6,0,0.8c0,0.6-0.2,1.3-0.5,1.8C6.8,7.4,6.6,7.7,6.4,7.9 C5.7,8.8,5,9.8,4.5,10.8c-0.3,0.6-0.5,1.3-0.5,2c0,0.2,0,0.4,0,0.7v0.1l-0.1,0.1c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.1-0.2,0.2-0.3,0.3 c-0.2,0.1-0.4,0.3-0.6,0.3l-0.3,0.2C2.2,15,2,15.3,1.9,15.6c0,0.3,0,0.5,0,0.8c0,0.1,0,0.3,0,0.4c0,0.1,0,0.3,0,0.4 c-0.1,0.2-0.1,0.5-0.1,0.7c0,0.3,0.2,0.6,0.5,0.8c0.3,0.1,0.7,0.2,1.1,0.2c0.3,0,0.6,0.1,0.9,0.2c0.3,0.1,0.5,0.1,0.8,0.3 c0.4,0.2,0.9,0.4,1.4,0.4c0.2,0,0.5,0,0.7,0c0.4-0.1,0.8-0.4,1-0.7l0,0h0.2c0.2,0,0.4,0,0.6-0.1c0.5-0.1,0.9-0.2,1.4-0.2 c0.2,0,0.5,0,0.7,0l0.6,0.1c0.2,0,0.4,0,0.6,0h0.1v0.1c0.1,0.2,0.2,0.4,0.3,0.5c0.1,0.1,0.2,0.2,0.3,0.3c0.2,0.1,0.4,0.2,0.7,0.3 h0.5c0.7-0.2,1.2-0.5,1.7-1c0.3-0.3,0.6-0.5,0.9-0.7l0.5-0.2c0.3-0.1,0.6-0.3,0.8-0.5C18.5,17.1,18.5,16.5,17.8,15.8z M10,3.7 c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.3-0.1,0.4-0.1c0.1,0,0.2,0,0.3,0c0.2,0.1,0.4,0.3,0.5,0.5 c0.1,0.2,0.1,0.4,0.2,0.6c0,0.3-0.1,0.7-0.2,1l0,0l0,0h-0.1h-0.2h-0.2l0,0h0.1c0.1-0.2,0.1-0.3,0.1-0.5C11.4,4,11.3,3.7,11,3.5 c-0.1,0-0.2,0-0.2,0c-0.1,0-0.2,0.1-0.3,0.3c0,0.1-0.1,0.2-0.1,0.2c0,0.1,0,0.2,0,0.3l0,0h-0.1c-0.1-0.1-0.3-0.1-0.4-0.1l0,0 c0-0.1,0-0.2,0-0.3C10,3.8,10,3.8,10,3.7z M8,3.2C8.1,3,8.2,2.9,8.4,2.9c0.1,0,0.2,0,0.3,0C8.9,3,9.1,3.3,9.2,3.6c0,0.1,0,0.3,0,0.4 v0.2H9.1C9,4.2,8.9,4.3,8.8,4.3l0,0V4.2c0-0.1,0-0.2-0.1-0.3C8.6,3.5,8.2,3.6,8.2,4.1c0,0.2,0,0.4,0.2,0.6l0,0L8.3,4.8l0,0L8.1,4.9 l0,0l0,0C8,4.7,7.9,4.5,7.8,4.3c0-0.2,0-0.4,0-0.6C7.9,3.5,7.9,3.3,8,3.2z M7.8,5.4C8,5.3,8.1,5.2,8.2,5.1l0.4-0.3 c0.1-0.2,0.3-0.3,0.5-0.4c0.2-0.1,0.3-0.1,0.5-0.1c0.3,0,0.7,0.1,0.9,0.3c0.2,0.1,0.3,0.2,0.5,0.2c0.2,0.1,0.4,0.1,0.6,0.2 c0.1,0.1,0.2,0.2,0.3,0.4c0,0.2-0.1,0.4-0.2,0.5l-0.1,0.1C11,6.4,10.4,6.7,9.8,7C9.5,7,9.2,7,8.7,6.6L8,6l0,0 C7.8,5.9,7.7,5.6,7.8,5.4z M7.7,18.7c-0.2,0.4-0.7,0.6-1.4,0.5C6,19.1,5.7,19,5.4,18.8c-0.8-0.3-1.6-0.5-2.4-0.5 c-0.6-0.1-0.6-0.2-0.6-0.4c0-0.2,0-0.4,0.1-0.6c0.1-0.3,0.1-0.7,0-1.1c-0.1-0.2-0.1-0.5,0-0.7c0-0.1,0.2-0.2,0.5-0.3 C3.5,15,4,14.7,4.3,14.2c0.3-0.3,0.3-0.3,0.5-0.3c0.4,0,0.6,0,1.2,1.3c0.3,0.6,0.7,1.1,1,1.6c0.8,1,0.9,1.4,0.9,1.5 C7.8,18.4,7.8,18.6,7.7,18.7z M12.6,15.3c0,0.4-0.1,0.8-0.2,1.2c-0.1,0.4-0.2,0.5-1.1,0.8c-0.4,0.2-0.8,0.2-1.2,0.2 c-0.4,0-0.7,0-1.1-0.1l0,0c-0.4-0.1-0.8-0.3-1-0.7c0-0.1,0-0.2,0.1-0.3c0.5-0.5,0.2-1.4-1-2.3l-0.9-0.7l-0.3-0.3l0.1-0.2 c0.1-0.2,0.2-0.4,0.2-0.7c0.2-0.9,0.4-1.8,0.9-2.6c0.4-0.9,0.7-1.8,1-2.7l0.1-0.5l0.2,0.2c0.3,0.3,0.7,0.4,1.2,0.5 c0.5,0,0.9-0.2,1.3-0.5c0.5-0.2,0.9-0.4,0.9-0.4s0,0,0,0c0.3,1,0.7,2,1.2,3c0.3,0.7,0.7,1.6,0.8,2l0.2,0.8l-0.3,0.3 c-0.5,0.4-0.9,1-1.1,1.6C12.6,14.6,12.6,15,12.6,15.3z M17,17.5c-0.6,0.3-1.1,0.6-1.5,1c-0.3,0.3-0.6,0.5-0.9,0.7 c-0.4,0.2-0.8,0.2-1.1,0.1c-0.3-0.1-0.5-0.4-0.6-0.7c0-0.6,0-1.2,0.3-1.7c0.1-0.5,0.2-1,0.3-1.6c0.1-0.9,0.2-1.2,0.3-1.4 c0.1,0.3,0.3,0.5,0.5,0.7c0.6,0.3,1.3,0.2,1.8-0.3c0.1-0.1,0.3-0.2,0.4-0.1c0.3,0,0.4,0,0.7,0.8c0.1,0.4,0.3,0.8,0.5,1.1 c0.2,0.2,0.4,0.5,0.3,0.6C17.8,16.9,17.4,17.2,17,17.5z')
							]),
						_List_Nil)
					])
			};
		case 43:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M48,23.1h0v-6.4C48,7.6,40.6.2,31.5.2S15,7.6,15,16.7v6.4h0c-4.2,0-7.6,3.4-7.6,7.6v25.4c0,4.2,3.4,7.6,7.6,7.6h33c4.2,0,7.6-3.4,7.6-7.6v-25.4c0-4.2-3.4-7.6-7.6-7.6ZM20,16.7c0-6.3,5.1-11.5,11.5-11.5s11.5,5.1,11.5,11.5v6.4h-23v-6.4ZM50.6,56.1c0,1.4-1.2,2.6-2.6,2.6H15c-1.4,0-2.6-1.2-2.6-2.6v-25.4c0-1.4,1.2-2.6,2.6-2.6h33c1.4,0,2.6,1.2,2.6,2.6v25.4Z')
							]),
						_List_Nil)
					])
			};
		case 44:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'width', '36'),
						A2($elm$html$Html$Attributes$attribute, 'height', '36'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 36 36'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1')
					]),
				N: _List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M16.866 1.100304C15.367067999999998 1.303884 13.944816 1.8899279999999998 12.72744 2.805588C11.221559999999998 3.9382199999999994 10.048751999999999 5.6854439999999995 9.573587999999999 7.504019999999999C9.314028 8.497404 9.314568 8.490528 9.298188 11.0556L9.28332 13.381199999999998 8.77266 13.402152C8.157528 13.427387999999999 7.811028 13.49478 7.369992 13.674959999999999C6.332579999999999 14.098715999999998 5.5701719999999995 14.968943999999999 5.264028 16.078608L5.1659999999999995 16.433999999999997 5.1659999999999995 24.156C5.1659999999999995 31.521707999999997 5.16906 31.891284 5.232131999999999 32.166C5.5273319999999995 33.451271999999996 6.518699999999999 34.49217599999999 7.794 34.855883999999996L8.081999999999999 34.937999999999995 18 34.937999999999995C27.340595999999998 34.937999999999995 27.930887999999996 34.934328 28.1394 34.874964C29.364012 34.526196 30.249612 33.703847999999994 30.659292 32.535036C30.861791999999998 31.957307999999998 30.85542 32.251751999999996 30.843539999999997 24.011999999999997L30.832631999999997 16.433999999999997 30.754115999999996 16.145999999999997C30.427487999999997 14.947668 29.693987999999997 14.103252 28.594727999999996 13.660091999999999C28.180836 13.493231999999999 27.828899999999997 13.426811999999998 27.22734 13.402152L26.716715999999998 13.381199999999998 26.703288 11.0736C26.690435999999995 8.85942 26.686583999999996 8.747964 26.608068 8.320607999999998C26.254583999999998 6.39666 25.413803999999995 4.8024 24.061463999999997 3.4917119999999997C22.700232 2.17242 20.988215999999998 1.346148 19.105164 1.09962C18.57996 1.0308599999999999 17.374644 1.0312199999999998 16.866 1.100304M17.408592 4.072608C16.145712 4.194 14.911776 4.781267999999999 13.989419999999999 5.69988C13.272443999999998 6.413975999999999 12.787488 7.23042 12.510899999999998 8.18892C12.310596 8.883251999999999 12.302352 8.995968 12.285396 11.277L12.269627999999999 13.392 18 13.392L23.730372 13.392 23.714603999999998 11.277C23.697648 8.995968 23.689403999999996 8.883251999999999 23.4891 8.18892C23.213196 7.232759999999999 22.727411999999998 6.413831999999999 22.015188 5.704488C21.066588 4.759631999999999 19.857851999999998 4.193712 18.522 4.069008C18.076392 4.027428 17.871912 4.0280759999999995 17.408592 4.072608M8.460612 16.482636C8.392247999999999 16.51932 8.3034 16.593408 8.263152 16.647299999999998C8.19018 16.74504 8.19 16.76214 8.19 24.185627999999998C8.19 31.569191999999997 8.190539999999999 31.626755999999997 8.261999999999999 31.724459999999997C8.301599999999999 31.77864 8.39988 31.855571999999995 8.480376 31.895459999999996C8.62596 31.967603999999998 8.676611999999999 31.967999999999996 18 31.967999999999996C27.323387999999998 31.967999999999996 27.374039999999997 31.967603999999998 27.519623999999997 31.895459999999996C27.600119999999997 31.855571999999995 27.698399999999996 31.77864 27.738 31.724459999999997C27.809459999999998 31.626755999999997 27.81 31.569191999999997 27.81 24.191999999999997L27.81 16.758 27.729719999999997 16.645428C27.685547999999997 16.583544 27.593999999999998 16.506576 27.526284 16.474428C27.413604 16.420968 26.600687999999998 16.416 17.993987999999998 16.416C8.905284 16.416 8.580636 16.418267999999998 8.460612 16.482636M17.704151999999997 21.676679999999998C17.249291999999997 21.734495999999996 16.860239999999997 21.943583999999998 16.516655999999998 22.31478C16.0596 22.808628 15.88248 23.486939999999997 16.038216 24.14736C16.19154 24.797736 16.746588 25.396487999999998 17.385407999999998 25.600679999999997C17.716068 25.706376 18.283932 25.706376 18.614592 25.600679999999997C19.253411999999997 25.396487999999998 19.80846 24.797736 19.961783999999998 24.14736C20.071583999999998 23.681663999999998 20.007179999999998 23.149332 19.791179999999997 22.737347999999997C19.65006 22.46814 19.241495999999998 22.049819999999997 18.969012 21.895452C18.627947999999996 21.70224 18.151307999999997 21.619799999999998 17.704151999999997 21.676679999999998'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', 'none'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'currentColor'),
								A2($elm$html$Html$Attributes$attribute, 'fill-rule', 'evenodd'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-width', '0.036')
							]),
						_List_Nil)
					])
			};
		case 45:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'width', '36'),
						A2($elm$html$Html$Attributes$attribute, 'height', '36'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 36 36'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1')
					]),
				N: _List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M8.604 1.1026799999999999C7.039439999999999 1.3149 5.48532 1.9842119999999999 4.266 2.9709C3.852 3.305916 3.305916 3.852 2.9709 4.266C2.162268 5.265288 1.521432 6.584796 1.2456 7.818587999999999C1.0467 8.708364 1.041588 8.823924 1.052208 12.205763999999999L1.0619999999999998 15.319583999999999 1.178424 15.555995999999999C1.543572 16.297667999999998 2.456712 16.612379999999998 3.1951799999999997 16.251084C3.4268039999999993 16.137756 3.7468079999999997 15.830063999999998 3.8568239999999996 15.614892C4.031136 15.273971999999999 4.0310999999999995 15.274008 4.031604 12.366C4.032144 9.094392 4.051764 8.802216 4.3261199999999995 7.9769879999999995C4.904388 6.2376119999999995 6.239771999999999 4.902119999999999 7.9769879999999995 4.325868C9.610236 3.7841039999999997 11.457576 4.036067999999999 12.905999999999999 4.998131999999999C14.083307999999999 5.780124 14.936256 6.982991999999999 15.284195999999998 8.351999999999999C15.441443999999997 8.970732 15.449112 9.091728 15.468767999999999 11.277L15.487848 13.392 14.142923999999999 13.392287999999999C13.403195999999998 13.392467999999997 12.652199999999999 13.409063999999999 12.473999999999998 13.429151999999998C10.976975999999999 13.598135999999998 9.818532 14.5926 9.388224 16.078176L9.306 16.362 9.306 24.174L9.306 31.985999999999997 9.387467999999998 32.291999999999994C9.4896 32.675472 9.766511999999999 33.245855999999996 9.999252 33.552C10.458324 34.155936 11.099844 34.597332 11.869344 34.838676L12.186 34.937999999999995 21.996 34.9479C32.812991999999994 34.958808 32.010048 34.97472 32.66784 34.736688C33.568847999999996 34.410672 34.410672 33.568847999999996 34.736688 32.66784C34.973424 32.01357599999999 34.959132 32.600268 34.946604 24.048L34.935227999999995 16.29 34.858836 16.055999999999997C34.668611999999996 15.473484 34.526807999999996 15.187823999999999 34.243523999999994 14.816519999999999C33.640848 14.026679999999999 32.778431999999995 13.542263999999998 31.775976 13.430484C31.543775999999998 13.4046 29.310696 13.392 24.951815999999997 13.392L18.472788 13.392 18.45864 11.114999999999998C18.44334 8.65602 18.437112 8.56368 18.22896 7.708392C17.371907999999998 4.18644 14.455115999999999 1.5701399999999999 10.861164 1.09962C10.32786 1.029816 9.129312 1.031436 8.604 1.1026799999999999M12.617999999999999 16.466831999999997C12.472703999999998 16.531416 12.353795999999999 16.666344 12.311136 16.814988C12.28878 16.892927999999998 12.276288 19.58544 12.276791999999999 24.209748C12.277548 31.223879999999998 12.279959999999999 31.487219999999997 12.344579999999999 31.629564C12.381443999999998 31.710707999999997 12.466152 31.816008 12.532787999999998 31.863564L12.654 31.95 22.128372 31.95L31.602707999999996 31.95 31.702139999999996 31.875767999999997C31.756823999999998 31.834943999999997 31.834943999999997 31.756823999999998 31.875767999999997 31.702139999999996L31.95 31.602707999999996 31.95 24.191999999999997L31.95 16.781291999999997 31.874688 16.679627999999997C31.833251999999995 16.62372 31.745807999999997 16.541567999999998 31.680359999999997 16.497L31.561343999999995 16.416 22.143672 16.417403999999998C14.375843999999999 16.418556 12.707063999999999 16.427232 12.617999999999999 16.466831999999997M21.851999999999997 21.674951999999998C21.094307999999998 21.758831999999998 20.403288 22.352724 20.179979999999997 23.112C20.094407999999998 23.402952 20.101319999999998 23.967864 20.194128 24.264359999999996C20.545271999999997 25.386371999999998 21.773808 25.976843999999996 22.871592 25.551251999999995C23.325479999999995 25.375284 23.818248 24.885251999999998 24.003719999999998 24.425387999999995C24.301043999999997 23.688251999999995 24.118523999999997 22.818275999999997 23.547276 22.250052C23.087556 21.792744 22.52178 21.600792 21.851999999999997 21.674951999999998'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', 'none'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'currentColor'),
								A2($elm$html$Html$Attributes$attribute, 'fill-rule', 'evenodd'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-width', '0.036')
							]),
						_List_Nil)
					])
			};
		case 46:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M-42.1,53.2h-18.7c-.7-4.5-4.5-8-9.2-8s-9.3,4.1-9.3,9.3,4.1,9.3,9.3,9.3,8.5-3.5,9.2-8h9.3v2.7c0,.8.5,1.3,1.3,1.3s1.3-.5,1.3-1.3v-2.7h5.3v4.7c0,.8.5,1.3,1.3,1.3s1.3-.5,1.3-1.3v-6c0-.7-.5-1.3-1.3-1.3ZM-70.1,61.2c-3.7,0-6.7-2.9-6.7-6.7s2.9-6.7,6.7-6.7,6.7,2.9,6.7,6.7-2.9,6.7-6.7,6.7Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M17.1,61c-8.3,0-15.1-6.7-15.1-15,0-4,1.5-7.8,4.4-10.7,2.8-2.9,6.6-4.5,10.7-4.5h0c6.1,0,11.6,3.7,13.9,9.2h15.9c.6,0,1.3.2,1.7.7l3.5,3.3c.5.5.8,1.1.8,1.8,0,.7-.2,1.3-.7,1.8l-3.4,3.6c-.5.5-1.1.8-1.8.8h-2.4s-1.6,1.5-1.6,1.5c-1,.9-2.5.9-3.5,0l-1.6-1.5h-.3l-1.6,1.5c-1,.9-2.5.9-3.5,0l-1.6-1.5c-2.3,5.4-7.8,9.1-13.8,9.2h0ZM17.1,35.7c-2.7,0-5.2,1.1-7.1,3-1.9,1.9-2.9,4.5-2.9,7.2,0,5.6,4.6,10.1,10.2,10.1,4.5,0,8.5-3,9.7-7.4.3-1.1,1.3-1.8,2.4-1.8h2.8c.6,0,1.3.3,1.7.7l.6.5.6-.5c.5-.4,1.1-.7,1.7-.7h2.3c.6,0,1.3.2,1.7.7l.6.5.6-.5c.5-.4,1.1-.7,1.7-.7h2.4s1-1,1-1l-.9-.9h-16.7c-1.1,0-2.1-.7-2.4-1.8-1.2-4.3-5.3-7.4-9.8-7.4Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M9.4,45.9c0,2,1.7,3.7,3.7,3.7s3.7-1.7,3.7-3.7-1.7-3.7-3.7-3.7-3.7,1.7-3.7,3.7Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M58.7,17.6v-3.7c0-3.6-1.5-7-4-9.6-2.6-2.5-5.9-3.9-9.5-3.9h0c-3.6,0-7,1.4-9.6,4-2.6,2.6-3.9,6-3.9,9.6v3.6c-2.7,0-4.9,2.2-4.9,5v7.5c0,1.4,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5v-7.4s2.3,0,2.3,0c0,0,0,0,.1,0h0s0,0,.1,0h21.6c.1,0,.2,0,.4,0h0c.1,0,.2,0,.4,0h2s0,19.6,0,19.6c-1.4,0-2.4,1.2-2.4,2.5,0,1.4,1.1,2.5,2.5,2.5,2.7,0,5-2.2,5-5v-19.6c0-2.7-2.2-4.9-4.9-4.9ZM39,7.9c1.6-1.6,3.8-2.5,6-2.5,2.3,0,4.4.9,6.1,2.5,1.6,1.6,2.5,3.8,2.5,6v3.7s-17.1,0-17.1,0v-3.6c0-2.3.9-4.4,2.5-6.1Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M41.4,31.1c0,2,1.7,3.7,3.7,3.7s3.7-1.7,3.7-3.7-1.7-3.7-3.7-3.7-3.7,1.7-3.7,3.7Z')
							]),
						_List_Nil)
					])
			};
		case 47:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M49.1,23.1h0v-6.4C49,7.6,41.6.2,32.5.2s-10.2,2.5-13.3,6.8c-.8,1.1-.6,2.7.5,3.5,1.1.8,2.7.6,3.5-.5,2.2-3,5.6-4.7,9.3-4.7,6.4,0,11.5,5.2,11.5,11.5v6.4H16c-4.2,0-7.6,3.4-7.6,7.6v25.5c0,4.2,3.4,7.6,7.6,7.6h33.1c4.2,0,7.6-3.4,7.6-7.6v-25.5c0-4.2-3.4-7.6-7.6-7.6ZM51.7,56.2c0,1.4-1.2,2.6-2.6,2.6H16c-1.4,0-2.6-1.2-2.6-2.6v-25.5c0-1.4,1.2-2.6,2.6-2.6h33.1c1.4,0,2.6,1.2,2.6,2.6v25.5Z')
							]),
						_List_Nil)
					])
			};
		case 48:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 30 35.62'),
						A2($elm$html$Html$Attributes$attribute, 'style', 'vertical-align: '),
						A2($elm$html$Html$Attributes$attribute, 'width', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'height', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'fill', 'rgba(0%,0%,0%,1)')
					]),
				N: _List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M29.37,27.74a18.76,18.76,0,0,1-1.91,3.44,17.28,17.28,0,0,1-2.46,3,4.83,4.83,0,0,1-3.17,1.4,7.93,7.93,0,0,1-2.93-.7,8.48,8.48,0,0,0-3.15-.69,8.66,8.66,0,0,0-3.24.7,8.82,8.82,0,0,1-2.8.74,4.5,4.5,0,0,1-3.24-1.43,18.43,18.43,0,0,1-2.58-3.08,21.52,21.52,0,0,1-2.74-5.42A19.89,19.89,0,0,1,0,19.24a11.8,11.8,0,0,1,1.54-6.17A9.13,9.13,0,0,1,4.78,9.78,8.78,8.78,0,0,1,9.16,8.54a10.33,10.33,0,0,1,3.39.78,10.62,10.62,0,0,0,2.7.79,16.15,16.15,0,0,0,3-.93,9.83,9.83,0,0,1,4.05-.73A8.63,8.63,0,0,1,29,12a7.51,7.51,0,0,0-4,6.82,7.5,7.5,0,0,0,2.47,5.66A8.13,8.13,0,0,0,30,26.09q-.3.86-.63,1.65Zm-6.9-27a7.64,7.64,0,0,1-1.94,5C19,7.53,17.08,8.59,15,8.42c0-.21,0-.44,0-.67a7.82,7.82,0,0,1,2.06-5A7.94,7.94,0,0,1,19.55.82,7.52,7.52,0,0,1,22.43,0a5.74,5.74,0,0,1,0,.71Z'),
								A2($elm$html$Html$Attributes$attribute, 'class', 'a')
							]),
						_List_Nil)
					])
			};
		case 49:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_2'),
						A2($elm$html$Html$Attributes$attribute, 'data-name', 'Layer 2'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 62.4 47.39')
					]),
				N: _List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'g',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1-2'),
								A2($elm$html$Html$Attributes$attribute, 'data-name', 'Layer 1')
							]),
						_List_fromArray(
							[
								A3(
								$elm$svg$Svg$node,
								'g',
								_List_Nil,
								_List_fromArray(
									[
										A3(
										$elm$svg$Svg$node,
										'path',
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$attribute, 'd', 'M24.03,25.45c5.2-1.72,8.97-6.62,8.97-12.39,0-7.2-5.86-13.06-13.06-13.06S6.88,5.86,6.88,13.06c0,5.77,3.77,10.67,8.97,12.39C6.81,27.34,0,35.37,0,44.96c0,1.34,1.08,2.42,2.42,2.42h35.03c1.34,0,2.42-1.08,2.42-2.42,0-9.59-6.81-17.62-15.85-19.51ZM11.73,13.06c0-4.53,3.68-8.21,8.21-8.21s8.21,3.68,8.21,8.21-3.68,8.21-8.21,8.21-8.21-3.68-8.21-8.21ZM5.04,42.54c1.16-7.18,7.4-12.67,14.9-12.67s13.74,5.5,14.9,12.67H5.04Z')
											]),
										_List_Nil),
										A3(
										$elm$svg$Svg$node,
										'path',
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$attribute, 'd', 'M46.53,25.44c2.24-.73,4.29-2.06,5.88-3.94,4.66-5.49,3.98-13.75-1.51-18.4-4.41-3.74-10.85-4.13-15.67-.93-1.11.74-1.42,2.24-.68,3.36.74,1.12,2.24,1.42,3.36.68,3.03-2.01,7.08-1.77,9.86.59,3.45,2.93,3.88,8.12.95,11.58-2.49,2.93-6.75,3.74-10.13,1.94-1.18-.63-2.65-.19-3.28.99-.63,1.18-.19,2.65.99,3.28.68.36,1.38.63,2.09.87-.55.11-1.1.25-1.65.41-1.28.38-2.01,1.73-1.62,3.01.38,1.28,1.73,2.01,3.01,1.62,1.39-.42,2.86-.64,4.31-.62,7.5,0,13.74,5.5,14.9,12.67h-13.65c-1.34,0-2.42,1.08-2.42,2.42s1.08,2.42,2.42,2.42h16.27c1.34,0,2.42-1.08,2.42-2.42,0-9.6-6.82-17.64-15.87-19.52Z')
											]),
										_List_Nil)
									]))
							]))
					])
			};
		case 50:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 16 16'),
						A2($elm$html$Html$Attributes$attribute, 'style', 'vertical-align: '),
						A2($elm$html$Html$Attributes$attribute, 'width', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'height', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'fill', 'rgba(0%,0%,0%,1)')
					]),
				N: _List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M12.9 9H3.1c-.6 0-1-.4-1-1s.4-1 1-1h9.8c.6 0 1 .4 1 1s-.4 1-1 1z')
							]),
						_List_Nil)
					])
			};
		case 51:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M33.3,63.6c-.9,0-1.8,0-2.7-.1C14.7,62.4,1.4,49.1.3,33.2-.8,20,6.2,7.6,18,1.5c0,0,0,0,.1,0,2.1-.9,4.4-.4,5.9,1.2,1.5,1.6,1.7,3.9.6,5.9-2.5,4.5-3.4,9.3-2.8,14.4,1.4,9.7,9.4,17.8,19.2,19.2,4.9.7,10-.4,14-3,0,0,0,0,.1,0,2.1-1.2,4.6-.8,6.2.8,1.6,1.6,1.9,3.9.8,5.9-5.4,11.1-16.6,17.9-29,17.9ZM20.2,6c-10,5.2-15.9,15.7-15,26.8.9,13.5,12.2,24.7,25.7,25.7,11.4.9,21.9-5,26.8-15,0,0,0,0,0-.1,0,0,0,0-.1,0-4.9,3.1-11.2,4.5-17.3,3.7,0,0,0,0,0,0-12.1-1.7-21.7-11.4-23.4-23.4-.8-6.1.4-12.1,3.4-17.5,0,0,0-.1,0-.1,0,0,0,0,0,0,0,0,0,0-.1,0Z')
							]),
						_List_Nil)
					])
			};
		case 52:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M32,63.9C14.4,63.9.1,49.6.1,32S14.4.1,32,.1s31.9,14.3,31.9,31.9-14.3,31.9-31.9,31.9ZM32,5.1c-14.8,0-26.9,12.1-26.9,26.9s12.1,26.9,26.9,26.9,26.9-12.1,26.9-26.9S46.8,5.1,32,5.1Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'g',
						_List_Nil,
						_List_fromArray(
							[
								A3(
								$elm$svg$Svg$node,
								'path',
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'd', 'M34.3,18.3c0-1.9-1.4-3.4-3.2-3.6-.1,0-.2,0-.3,0,0,0-.1,0-.2,0h0s0,0-.1,0c-.1,0-.2,0-.4,0-1.8.2-3.2,1.8-3.2,3.6s1.4,3.4,3.2,3.6c.1,0,.2,0,.4,0,0,0,0,0,.1,0h0c0,0,.1,0,.2,0,.1,0,.2,0,.3,0,1.8-.2,3.2-1.8,3.2-3.6Z')
									]),
								_List_Nil),
								A3(
								$elm$svg$Svg$node,
								'path',
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'd', 'M36.8,44.4h-2.5v-13.9c0-1.3-.5-2.5-1.4-3.4-.9-.9-2.1-1.4-3.4-1.4h-2.3c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5h2.2v13.7h-2.2c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5h9.7c1.4,0,2.5-1.1,2.5-2.5s-1.1-2.5-2.5-2.5Z')
									]),
								_List_Nil)
							]))
					])
			};
		case 53:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M18.4,63.9C8.4,63.9.2,55.7.2,45.8s8.1-18.1,18.1-18.1,18.1,8.1,18.1,18.1-8.1,18.1-18.1,18.1ZM18.4,32.7c-7.2,0-13.1,5.9-13.1,13.1s5.9,13.1,13.1,13.1,13.1-5.9,13.1-13.1-5.9-13.1-13.1-13.1Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M28.3,46.9c0,0,0-.2.1-.2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.1,0,0,0-.1,0-.2,0,0,0,0,0,0,0,0,0-.1,0-.2,0,0,0-.2,0-.3s0-.2,0-.3c0,0,0-.1,0-.2,0,0,0,0,0,0,0,0,0-.1,0-.2,0,0,0,0,0-.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.2-.1-.2,0,0,0-.1-.1-.2,0-.1-.2-.3-.3-.4,0,0,0,0,0,0h0s0,0,0,0l-5.8-5.8c-1-1-2.6-1-3.5,0-1,1-1,2.6,0,3.5l1.6,1.6h-9.6c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5h9.6l-1.6,1.6c-1,1-1,2.6,0,3.5.5.5,1.1.7,1.8.7s1.3-.2,1.8-.7l5.8-5.8s0,0,0,0h0s0,0,0,0c.1-.1.2-.2.3-.4,0,0,0-.1.1-.2Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M57.3,56.1h-15.6c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5h15.6c.8,0,1.4-.6,1.4-1.4V14.2c0-.4-.1-.7-.4-1l-7.5-7.5c-.3-.3-.6-.4-1-.4h-27.6c-.4,0-.7.1-1,.4s-.4.6-.4,1v15.4c0,1.4-1.1,2.5-2.5,2.5s-2.5-1.1-2.5-2.5V6.8c0-1.7.7-3.3,1.9-4.5,1.2-1.2,2.8-1.9,4.5-1.9h27.6c1.7,0,3.3.7,4.5,1.9l7.5,7.5c1.2,1.2,1.9,2.8,1.9,4.5v35.4c0,3.5-2.9,6.4-6.4,6.4Z')
							]),
						_List_Nil)
					])
			};
		case 54:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M46.1,48.3c2,0,3.7-1.6,3.7-3.7s-1.6-3.7-3.7-3.7-3.7,1.6-3.7,3.7,1.6,3.7,3.7,3.7Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M46.1,63.6c-1.2,0-2.4-.4-3.4-1.1-1-.7-1.7-1.8-2.1-3l-1.1-3.5-3.5.8c-1.2.3-2.5.2-3.6-.3-1.1-.5-2.1-1.3-2.7-2.4-.6-1.1-.9-2.3-.7-3.5.1-1.2.7-2.4,1.5-3.3l2.5-2.7-2.5-2.6c-.8-.9-1.4-2-1.5-3.3s.1-2.5.7-3.5c.6-1.1,1.6-1.9,2.7-2.4,1.1-.5,2.4-.6,3.6-.3l3.5.8,1.1-3.5c.4-1.2,1.1-2.2,2.1-2.9,2-1.5,4.8-1.5,6.8,0,1,.7,1.7,1.8,2.1,2.9l1.1,3.5,3.5-.8c1.2-.3,2.5-.2,3.6.3,1.1.5,2.1,1.3,2.7,2.4.6,1.1.9,2.3.7,3.5-.1,1.2-.7,2.4-1.5,3.3l-2.5,2.7,2.5,2.6c.8.9,1.4,2.1,1.5,3.3.1,1.2-.1,2.5-.7,3.5-.6,1.1-1.6,1.9-2.7,2.4-1.1.5-2.4.6-3.6.3l-3.5-.8-1.1,3.5c-.3,1.2-1.1,2.2-2.1,2.9-1,.7-2.2,1.1-3.4,1.1ZM39.6,51c.9,0,1.7.2,2.5.7,1.1.6,1.9,1.6,2.2,2.8l1.1,3.5c0,.2.1.3.3.4.2.2.6.2.9,0s.2-.2.3-.4l1.1-3.6c.4-1.2,1.2-2.2,2.2-2.8,1.1-.6,2.3-.8,3.6-.5l3.6.8c.1,0,.3,0,.5,0,.2,0,.3-.2.4-.3s.1-.3,0-.5c0-.2,0-.3-.2-.4l-2.5-2.7c-.9-.9-1.3-2.1-1.3-3.4s.5-2.4,1.3-3.4l2.5-2.7c.1-.1.2-.3.2-.4,0-.2,0-.3,0-.5,0-.1-.2-.3-.4-.3-.1,0-.3,0-.5,0l-3.6.8c-1.2.3-2.5,0-3.6-.5s-1.9-1.6-2.2-2.8l-1.1-3.5h0c0-.2-.1-.3-.3-.4-.3-.2-.6-.2-.9,0-.1,0-.2.2-.3.4l-1.1,3.5c-.4,1.2-1.2,2.2-2.2,2.8-1.1.6-2.4.8-3.6.5l-3.6-.8c-.2,0-.3,0-.5,0-.2,0-.3.2-.4.3,0,.1-.1.3,0,.5s0,.3.2.4l2.5,2.7c.8.9,1.3,2.1,1.3,3.4s-.5,2.4-1.3,3.4l-2.5,2.7c-.1.1-.2.3-.2.4,0,.2,0,.3,0,.5,0,.1.2.3.4.3.2,0,.3,0,.5,0l3.6-.8c.4,0,.7-.1,1.1-.1ZM52.6,56h0,0ZM39.5,56h0ZM39.6,33.3h0Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M54,2.6c-1.4-1.4-3.3-2.2-5.4-2.2H8c-2,0-3.9.8-5.4,2.2C1.2,4,.4,5.9.4,7.9v30.5c0,2,.8,3.9,2.2,5.4,1.4,1.4,3.3,2.2,5.4,2.2h15.2c1.4,0,2.5-1.1,2.5-2.5s-1.1-2.5-2.5-2.5H8c-.7,0-1.3-.3-1.8-.8-.5-.5-.8-1.1-.8-1.8V15.5h45.8v8.4c0,1.4,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5V7.9c0-2-.8-3.9-2.2-5.4ZM5.4,10.5v-2.6c0-.7.3-1.3.8-1.8.5-.5,1.1-.8,1.8-.8h40.6c.7,0,1.3.3,1.8.8.5.5.8,1.1.8,1.8v2.6H5.4Z')
							]),
						_List_Nil)
					])
			};
		case 55:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_2'),
						A2($elm$html$Html$Attributes$attribute, 'data-name', 'Layer 2'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 63.52 63.46')
					]),
				N: _List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'g',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1-2'),
								A2($elm$html$Html$Attributes$attribute, 'data-name', 'Layer 1')
							]),
						_List_fromArray(
							[
								A3(
								$elm$svg$Svg$node,
								'path',
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'd', 'M62.93,60.04l-14.04-14.04c4.22-4.88,6.78-11.23,6.78-18.17,0-7.43-2.89-14.42-8.15-19.68S35.27,0,27.83,0h0c-7.43,0-14.42,2.9-19.68,8.15C2.9,13.41,0,20.4,0,27.83c0,15.35,12.49,27.83,27.83,27.83,6.97,0,13.35-2.58,18.23-6.83l14.04,14.03c.39.39.9.59,1.41.59s1.02-.2,1.41-.59c.78-.78.78-2.05,0-2.83ZM4,27.83h0c0-6.37,2.48-12.35,6.98-16.85,4.5-4.5,10.49-6.98,16.85-6.98h0c6.37,0,12.35,2.48,16.85,6.98,4.5,4.5,6.98,10.49,6.98,16.85,0,13.14-10.69,23.83-23.83,23.83S4,40.98,4,27.83Z')
									]),
								_List_Nil),
								A3(
								$elm$svg$Svg$node,
								'path',
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'd', 'M36.87,37.62c-.51,0-1.02-.2-1.41-.59-.78-.78-.78-2.05,0-2.83l6.34-6.34-6.34-6.34c-.78-.78-.78-2.05,0-2.83.78-.78,2.05-.78,2.83,0l7.75,7.75c.78.78.78,2.05,0,2.83l-7.75,7.75c-.39.39-.9.59-1.41.59Z')
									]),
								_List_Nil),
								A3(
								$elm$svg$Svg$node,
								'path',
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'd', 'M18.79,37.62c-.51,0-1.02-.2-1.41-.59l-7.75-7.75c-.78-.78-.78-2.05,0-2.83l7.75-7.75c.78-.78,2.05-.78,2.83,0,.78.78.78,2.05,0,2.83l-6.34,6.34,6.34,6.34c.78.78.78,2.05,0,2.83-.39.39-.9.59-1.41.59Z')
									]),
								_List_Nil),
								A3(
								$elm$svg$Svg$node,
								'path',
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'd', 'M23.96,40.21c-.23,0-.47-.04-.7-.13-1.03-.39-1.56-1.54-1.17-2.58l7.75-20.67c.39-1.03,1.54-1.56,2.57-1.17,1.03.39,1.56,1.54,1.17,2.57l-7.75,20.67c-.3.8-1.06,1.3-1.87,1.3Z')
									]),
								_List_Nil)
							]))
					])
			};
		case 56:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M18.8,17.2c-1.4,0-2.5-1.1-2.5-2.5v-2.6c0-1.4,1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5v2.6c0,1.4-1.1,2.5-2.5,2.5Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M18.8,30.1c-1.4,0-2.5-1.1-2.5-2.5v-2.6c0-1.4,1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5v2.6c0,1.4-1.1,2.5-2.5,2.5Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M18.8,43c-1.4,0-2.5-1.1-2.5-2.5v-2.6c0-1.4,1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5v2.6c0,1.4-1.1,2.5-2.5,2.5Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M32.4,17.2c-1.4,0-2.5-1.1-2.5-2.5v-2.6c0-1.4,1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5v2.6c0,1.4-1.1,2.5-2.5,2.5Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M32.4,30.1c-1.4,0-2.5-1.1-2.5-2.5v-2.6c0-1.4,1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5v2.6c0,1.4-1.1,2.5-2.5,2.5Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M32.4,43c-1.4,0-2.5-1.1-2.5-2.5v-2.6c0-1.4,1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5v2.6c0,1.4-1.1,2.5-2.5,2.5Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M45.9,17.2c-1.4,0-2.5-1.1-2.5-2.5v-2.6c0-1.4,1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5v2.6c0,1.4-1.1,2.5-2.5,2.5Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M45.9,30.1c-1.4,0-2.5-1.1-2.5-2.5v-2.6c0-1.4,1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5v2.6c0,1.4-1.1,2.5-2.5,2.5Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M45.9,43c-1.4,0-2.5-1.1-2.5-2.5v-2.6c0-1.4,1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5v2.6c0,1.4-1.1,2.5-2.5,2.5Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M61.4,58.7h-3.3V5.6c0-2.9-2.1-5.1-5.1-5.1H11.7c-2.9,0-5.1,2.1-5.1,5.1v53h-3.3c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5h58.1c1.4,0,2.5-1.1,2.5-2.5s-1.1-2.5-2.5-2.5ZM35,58.7h-5.3v-4c0-1.5,1.2-2.7,2.7-2.7s2.7,1.2,2.7,2.7v4ZM40,58.7v-4c0-4.2-3.4-7.7-7.7-7.7s-7.7,3.4-7.7,7.7v4h-13.1V5.6s0,0,0,0c0,0,0,0,0,0h41.3s0,0,0,0c0,0,0,0,0,0v53h-13.1Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M18.8,55.9c-1.4,0-2.5-1.1-2.5-2.5v-2.6c0-1.4,1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5v2.6c0,1.4-1.1,2.5-2.5,2.5Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M45.9,55.9c-1.4,0-2.5-1.1-2.5-2.5v-2.6c0-1.4,1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5v2.6c0,1.4-1.1,2.5-2.5,2.5Z')
							]),
						_List_Nil)
					])
			};
		case 57:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M64,15.1c0-2.3-1.4-4.4-3.7-5L33.6.6c0,0-.2,0-.2,0-.8-.2-1.6-.2-2.5,0,0,0-.2,0-.2,0L4,10C1.7,10.7.2,12.7.3,15v34.6c0,2.1,1.3,4,3.3,4.8l26.9,9.6c.5.2,1.1.3,1.7.3s1.1,0,1.7-.3l26.7-9.6c2.1-.7,3.4-2.6,3.4-4.8V15.1ZM32.2,5.4l21.6,7.6-21.6,7.6-21.7-7.6,21.7-7.6ZM5.3,16.5l24.4,8.5v33.2l-24.4-8.7V16.5ZM58.9,49.6l-24.3,8.7V25l24.4-8.5v33s0,0,0,0Z')
							]),
						_List_Nil)
					])
			};
		case 58:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M23.1,48.6H6.6c-.4,0-.7-.3-.7-.7v-28.8c0-.4.3-.7.7-.7h38.3c.4,0,.7.3.7.7v4.6c0,1.4,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5v-4.6c0-1-.3-1.9-.7-2.7l-5.1-12.4c-.9-2-3-3.4-5.2-3.4H11.9c-2.3,0-4.3,1.3-5.2,3.5L1.6,16.4c-.4.8-.7,1.7-.7,2.7v28.8c0,3.1,2.6,5.7,5.7,5.7h16.5c1.4,0,2.5-1.1,2.5-2.5s-1.1-2.5-2.5-2.5ZM40.3,6l3,7.4h-15.1v-7.8h11.4c.3,0,.5.2.6.3ZM11.9,5.6h11.4v7.8h-15.1l3-7.4c.1-.2.4-.4.6-.4Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M51.2,42.7h-3.8v-3.8c0-1.4-1.1-2.5-2.5-2.5s-2.5,1.1-2.5,2.5v3.8h-3.8c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5h3.8v3.8c0,1.4,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5v-3.8h3.8c1.4,0,2.5-1.1,2.5-2.5s-1.1-2.5-2.5-2.5Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M44.9,27c-10,0-18.2,8.2-18.2,18.2s8.2,18.2,18.2,18.2,18.2-8.2,18.2-18.2-8.2-18.2-18.2-18.2ZM44.9,58.4c-7.3,0-13.2-5.9-13.2-13.2s5.9-13.2,13.2-13.2,13.2,5.9,13.2,13.2-5.9,13.2-13.2,13.2Z')
							]),
						_List_Nil)
					])
			};
		case 59:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M61.6,7.9l-5.4-5.4c-3-3-7.8-3-10.7,0l-5.4,5.4s0,0,0,0,0,0,0,0L5.4,42.5s0,0,0,0,0,0,0,0l-.6.6c-.3.3-.6.7-.7,1.2L.3,60.8c-.2.8,0,1.7.7,2.3.5.5,1.1.7,1.8.7s.4,0,.6,0l16.5-3.9c.5-.1.9-.3,1.2-.7l.6-.6s0,0,0,0,0,0,0,0L56.1,24.1s0,0,0,0c0,0,0,0,0,0l5.4-5.4c3-3,3-7.8,0-10.7ZM19.8,53.3l-9.1-9.1,31.1-31.1,9.1,9.1-31,31ZM8.2,48.8l7.1,7.1-9.2,2.2,2.2-9.2ZM58.1,15.1l-3.7,3.7-9.1-9.1,3.6-3.6c1-1,2.7-1,3.7,0l5.4,5.4c1,1,1,2.7,0,3.7Z')
							]),
						_List_Nil)
					])
			};
		case 60:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 60 60'),
						A2($elm$html$Html$Attributes$attribute, 'style', 'vertical-align: '),
						A2($elm$html$Html$Attributes$attribute, 'width', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'height', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'fill', 'rgba(0%,0%,0%,1)')
					]),
				N: _List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'class', 'a'),
								A2($elm$html$Html$Attributes$attribute, 'd', 'M52.1,26.3c-0.5-1.5-0.3-3.3-1.4-4.6c-1.6-1.7-3-3.6-4-5.7c-1.1-3.4-4.2-5.7-5.2-9.1c-0.4-2-1.6-3.8-3.3-4.9 c-0.8-0.4-1.5-0.7-2.4-0.9c-0.7,0.1-1.4,0.2-2.1,0.3l0,0c-1.1-0.1-2,0.6-2.9,1.1c-0.8,0.3-1.6,0.5-2.4,0.7c-0.6,1.2-1.9,1.9-2.7,3 c-0.7,2.2-2.1,4.2-4,5.6c-2.7,1.4-4,4.4-4.8,7.1c-0.3,0.6-0.2,1.6-0.6,2.1c-1.1,0.3-0.5-1.1-0.6-1.7c-0.2-1,0.7-1.6,0.8-2.6 c0.3-0.7,0.5-1.4,0.4-2.2c-0.1-1.7,0.4-3.8-0.8-5.2c-0.7-0.4-0.5-1.3-0.8-2c-0.7-1-1.6-1.7-2.7-2.3c-0.9-0.1-1.6-1.2-2.5-0.7 C9.6,5,8.6,4.9,8.3,5.8c-0.2,1.1-1.4,0.8-2.2,1c-1,0.4-2.3,0-3.1,0.8s-2.2,2-1.8,3.3c0.9,1.9,3.4,0.9,4.7,2 c-0.4,1.2-0.9,2.4-1.4,3.6c-0.2,1.6-0.3,3.2-0.1,4.9c0.2,1.6-0.2,3.7,1.2,4.8c0.8,0.3,0.7,1.2,1,1.9s0.8-0.2,1.1,0.4 c0.7,0.4,0.1,1.2,0.5,1.7c0.6,0.1,1.2,0.4,1.7,0.9c0.7,0.5,1.4,1.1,2.1,1.7c0.5,1,1.1-1,1.6-0.2c0.2,0.6,0.9,0.9,1.5,0.7 c0,0,0,0,0,0l0,0l0.1-0.1c1-0.2,1.9-0.6,2.7-1.1c0.5,1.8,0.1,3.8,0.3,5.7c0.3,1.4,0.5,2.8,0.6,4.2c0.4,1.4,0.6,2.8,0.6,4.2 c0.4,3,0,6-1.4,8.8c-0.2,0.8-0.8,1.5-1.7,1.7c-0.6,0.3-1.8,0.8-1.4,1.6c1.4,1.2,3.6,1,5.2,0.4c1-0.5,0.1-1.8,0.7-2.5 c0.7-2.7,0.4-5.6,1.2-8.3c0.6-1.4,0.9-2.9,0.7-4.4c0.2-0.9-0.2-2,0.4-2.8c0-0.9,0.4-1.8,1-2.5c0.2-1.4,0.3-2.8,0.3-4.2 c0.8-0.3,1.7-0.3,2.6-0.3c0,0.8-0.6,1.7-0.4,2.6c0.2,1,0,2.1-0.5,3c-0.4,1.6-0.6,3.4,0.4,4.7c1.6,1.8,3.7,3,5.2,4.9 c0.5,0.4,0.6,1,0.2,1.5l0,0l-0.1,0.1c-0.3,1-1,1.8-2,2.1c-0.6,0.2-1.6,1.2-0.9,1.8c1.5,0.3,3,0.2,4.4-0.3c1-0.4,0.6-1.5,1-2.3 c0.5,0.7,1,1.5,1.5,2.3c0.6,0.9,1.7,0.2,2.4-0.1c0.1-1.3-0.2-2.7-0.8-3.9c-0.3-0.8-1.6-0.8-1.6-1.8c0.6-2.4,2.2-4.2,3.5-6.2 c1-1,0.3-2.5,0.3-3.8C39,35,39.8,31.7,41.6,29c0.4,1.5,0.8,3,1.4,4.4c0.4,1.7,1.2,3.3,2.2,4.7c0.5,1.7,0.4,3.6,0.7,5.3 c0.5,3,0.3,6.1-0.5,9.1c0.1,1.1-0.9,1.9-0.8,2.9c0.3,1,1.4,0.2,2,0.6c1.1,0.4,2.3-0.2,2.7-1.2c-0.3-0.8-0.4-1.7-0.5-2.5 c-0.8-2.5-1-5.2-0.5-7.8c0.1-1.4,0.9-3.1-0.2-4.3c-0.3-1.3,0.2-2.7-0.1-4c-0.7-3.4-0.8-6.9-0.2-10.2c0.2-0.5,0-1.4,0.5-1.6 c0.5,0.8,0.7,1.7,0.6,2.6c0.5,1.4,0.5,2.9,0.2,4.3c-0.9,1.1-0.3,2.6-0.2,3.9c0.1,0.9,1.1,0.2,1.2-0.3c0.8-1.5,1.5-3.1,1.9-4.7 c0.5-0.7,0-1.6,0-2.4C52.8,27.7,52.5,26.8,52.1,26.3z M33.1,46.8c0,0-3.8-4.5-4-5.1c0.6-0.5,2.1-4.7,2.1-4.7 c0.4-1.6,0.7-3.2,0.9-4.8c0.8-0.2,1.5-0.4,2.3-0.8c-0.5,2.6,0.9,7.6,1.7,8.7C35.5,41.3,33.1,46.8,33.1,46.8L33.1,46.8z')
							]),
						_List_Nil)
					])
			};
		case 61:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 16 16'),
						A2($elm$html$Html$Attributes$attribute, 'style', 'vertical-align: '),
						A2($elm$html$Html$Attributes$attribute, 'width', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'height', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'fill', 'rgba(0%,0%,0%,1)')
					]),
				N: _List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M12.9,7H9V3.1c0-0.6-0.4-1-1-1s-1,0.4-1,1V7H3.1c-0.6,0-1,0.4-1,1s0.4,1,1,1H7v3.9c0,0.6,0.4,1,1,1s1-0.4,1-1V9 h3.9c0.6,0,1-0.4,1-1S13.5,7,12.9,7z'),
								A2($elm$html$Html$Attributes$attribute, 'class', 'a')
							]),
						_List_Nil)
					])
			};
		case 62:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 18.94 19.15'),
						A2($elm$html$Html$Attributes$attribute, 'style', 'vertical-align: '),
						A2($elm$html$Html$Attributes$attribute, 'width', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'height', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'fill', 'rgba(0%,0%,0%,1)')
					]),
				N: _List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M9.36,0A12.4,12.4,0,0,0,7.17.19C5.24.53,4.89,1.24,4.89,2.56V4.3H9.46v.58H3.18A2.86,2.86,0,0,0,.32,7.2a8.5,8.5,0,0,0,0,4.64c.33,1.35,1.1,2.32,2.43,2.32H4.32V12.07A2.9,2.9,0,0,1,7.17,9.23h4.57A2.29,2.29,0,0,0,14,6.91V2.56A2.53,2.53,0,0,0,11.74.19,14.78,14.78,0,0,0,9.36,0ZM6.89,1.4A.87.87,0,1,1,6,2.27.86.86,0,0,1,6.89,1.4Z'),
								A2($elm$html$Html$Attributes$attribute, 'class', 'a')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M14.59,4.88v2a2.93,2.93,0,0,1-2.85,2.9H7.17a2.33,2.33,0,0,0-2.28,2.32v4.35c0,1.24,1.08,2,2.28,2.32a7.72,7.72,0,0,0,4.57,0c1.15-.33,2.28-1,2.28-2.32V14.74H9.46v-.58H16.3c1.33,0,1.83-.93,2.29-2.32a7.78,7.78,0,0,0,0-4.64c-.33-1.32-1-2.32-2.29-2.32ZM12,15.9a.87.87,0,1,1-.85.87A.86.86,0,0,1,12,15.9Z'),
								A2($elm$html$Html$Attributes$attribute, 'class', 'a')
							]),
						_List_Nil)
					])
			};
		case 63:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 48 48'),
						A2($elm$html$Html$Attributes$attribute, 'style', 'vertical-align: '),
						A2($elm$html$Html$Attributes$attribute, 'width', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'height', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'fill', 'rgba(0%,0%,0%,1)')
					]),
				N: _List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M1,29.7c0,0-0.1,0-0.1,0C0.4,29.6,0,29.1,0,28.6c0.4-3.2,1.9-6.1,4.3-8.2s5.5-3.2,8.7-3.2c3.2,0,6.3,1.1,8.7,3.3 c0.4,0.4,0.5,1,0.1,1.4c-0.4,0.4-1,0.5-1.4,0.1c-2-1.8-4.7-2.8-7.4-2.8c0,0-0.1,0-0.1,0c-2.7,0-5.2,1-7.3,2.7 c-2,1.8-3.3,4.2-3.7,6.9C2,29.3,1.5,29.7,1,29.7z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M13,16.2c-4.3,0-7.8-3.5-7.8-7.8S8.8,0.7,13,0.7s7.8,3.5,7.8,7.8S17.3,16.2,13,16.2z M13,2.7c-3.2,0-5.8,2.6-5.8,5.8 c0,3.2,2.6,5.8,5.8,5.8s5.8-2.6,5.8-5.8C18.8,5.3,16.2,2.7,13,2.7z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M41.2,17.7c-0.8-1.4-1.9-2.5-3.2-3.4c-1.1-0.7-2.3-1.2-3.5-1.4c2.5-0.8,4.3-3.2,4.3-5.9c0-3.4-2.8-6.2-6.2-6.2 s-6.2,2.8-6.2,6.2c0,2.8,1.8,5.2,4.4,6c-0.6,0.1-1.2,0.3-1.8,0.5c-1.5,0.6-2.8,1.5-3.8,2.7c-0.4,0.4-0.3,1,0.1,1.4 c0.4,0.4,1,0.3,1.4-0.1c0.8-1,1.9-1.7,3.1-2.2c1.2-0.5,2.5-0.6,3.7-0.5c1.3,0.1,2.5,0.6,3.6,1.2c1.1,0.7,2,1.6,2.6,2.7 c0.2,0.3,0.5,0.5,0.9,0.5c0.2,0,0.3,0,0.5-0.1C41.3,18.8,41.5,18.2,41.2,17.7z M28.3,6.9c0-2.3,1.9-4.2,4.2-4.2s4.2,1.9,4.2,4.2 c0,2.3-1.9,4.3-4.2,4.3S28.3,9.3,28.3,6.9z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'circle',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'cx', '30.1'),
								A2($elm$html$Html$Attributes$attribute, 'cy', '38.6'),
								A2($elm$html$Html$Attributes$attribute, 'r', '1.8')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M30.1,47.7c-0.3,0-0.6,0-0.9,0c-2.1-0.2-4-1.1-5.5-2.6c-1.5-1.5-2.4-3.4-2.6-5.5c-0.2-2.1,0.3-4.2,1.4-5.9 c1.1-1.7,2.9-3.1,4.9-3.7c1.8-0.6,3.7-0.6,5.5,0l6.9-6.9c0.4-0.4,0.9-0.7,1.4-0.9c1-0.4,2.2-0.4,3.3,0c0.5,0.2,1,0.5,1.4,0.9 s0.7,0.9,0.9,1.4c0.2,0.5,0.3,1.1,0.3,1.6c0,0.6-0.1,1.1-0.3,1.6c-0.2,0.5-0.5,1-0.9,1.4l-6.9,6.9c0.6,1.8,0.5,3.7,0,5.5 c-0.6,2-1.9,3.7-3.7,4.9C33.7,47.2,31.9,47.7,30.1,47.7z M30.1,31.4c-0.7,0-1.5,0.1-2.2,0.3c-1.6,0.5-2.9,1.5-3.8,2.9 c-0.9,1.4-1.3,3-1.1,4.6c0.2,1.6,0.9,3.2,2,4.3c1.2,1.2,2.7,1.9,4.3,2c1.6,0.2,3.3-0.2,4.6-1.1c1.4-0.9,2.4-2.2,2.9-3.8 c0.5-1.5,0.4-3.2-0.1-4.7c0-0.1-0.1-0.2-0.1-0.3c0-0.3,0.1-0.6,0.3-0.8l7.4-7.4c0.2-0.2,0.4-0.5,0.5-0.7c0.1-0.3,0.2-0.6,0.2-0.9 c0-0.3-0.1-0.6-0.2-0.9c-0.1-0.3-0.3-0.5-0.5-0.7c-0.2-0.2-0.5-0.4-0.7-0.5c-0.5-0.2-1.2-0.2-1.7,0c-0.3,0.1-0.5,0.3-0.7,0.5 l-7.4,7.4c-0.3,0.3-0.7,0.4-1.1,0.2C31.9,31.6,31,31.4,30.1,31.4z')
							]),
						_List_Nil)
					])
			};
		case 64:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M32,63.7c-.8,0-1.5-.1-2.3-.4-1.9-.7-3.5-2.2-4.2-4.2l-1.2-3.3c-.3-.7-.8-1.3-1.5-1.6-.7-.3-1.5-.4-2.2-.1,0,0-.2,0-.3.1l-3.1,1.5c-3.4,1.6-7.5.2-9.1-3.2-.9-1.9-.9-4,0-5.9l1.5-3.1c.7-1.4,0-3.1-1.3-3.8,0,0-.2,0-.3-.1l-3.3-1.2c-1.7-.6-3.1-1.9-3.9-3.5-.8-1.7-.9-3.5-.3-5.2.7-2,2.2-3.5,4.2-4.2l3.3-1.2c.7-.3,1.3-.8,1.6-1.5.3-.7.4-1.5.1-2.2,0,0,0-.2-.1-.3l-1.5-3.1c-.8-1.6-.9-3.5-.3-5.2.6-1.7,1.8-3.1,3.5-3.9,1.9-.9,4-.9,5.9,0l3.1,1.5c1.4.7,3.1,0,3.8-1.3,0,0,0-.2.1-.3l1.2-3.3c.6-1.7,1.9-3.1,3.5-3.9,1.7-.8,3.5-.9,5.2-.3,1.9.7,3.5,2.2,4.2,4.2l1.2,3.3c.3.7.8,1.3,1.5,1.6.7.3,1.5.4,2.2.1,0,0,.2,0,.3-.1l3.1-1.5c3.4-1.6,7.5-.2,9.1,3.2.9,1.9.9,4,0,5.9l-1.5,3.1c-.7,1.4,0,3.1,1.3,3.8,0,0,.2,0,.3.1l3.3,1.2c3.6,1.3,5.4,5.2,4.2,8.7-.7,2-2.2,3.5-4.2,4.2l-3.3,1.2c-1.5.5-2.3,2.2-1.7,3.6,0,0,0,.2.1.3l1.5,3.1c.8,1.6.9,3.5.3,5.2s-1.9,3.1-3.5,3.9c-1.9.9-4,.9-5.9,0l-3.1-1.5c-.7-.3-1.5-.4-2.2-.1-.7.3-1.3.8-1.6,1.5,0,0,0,.2-.1.3l-1.2,3.3c-1,2.8-3.6,4.5-6.5,4.5ZM21.7,50c2.8,0,5.5,1.8,6.5,4.6l1.2,3.3c.3.8.9,1.4,1.7,1.7,1.5.5,3.1-.2,3.6-1.7l1.2-3.3c0-.2.2-.4.3-.6.8-1.6,2.2-2.9,3.9-3.5,1.7-.6,3.6-.5,5.2.3l3.1,1.5c.8.4,1.7.4,2.5,0,.7-.3,1.2-.9,1.5-1.6.3-.7.2-1.5-.1-2.2l-1.5-3.1c-.1-.2-.2-.4-.3-.7-1.3-3.6.6-7.5,4.2-8.7l3.3-1.2c.8-.3,1.4-.9,1.7-1.7.5-1.5-.3-3.1-1.7-3.6l-3.3-1.2c-.2,0-.4-.2-.7-.3-3.4-1.6-4.9-5.7-3.2-9.1h0s1.5-3.1,1.5-3.1c.4-.8.4-1.7,0-2.5-.7-1.4-2.4-2-3.8-1.3l-3.1,1.5c-.2.1-.4.2-.6.3-1.7.6-3.6.5-5.2-.3-1.7-.8-2.9-2.2-3.5-3.9l-1.2-3.3c-.3-.8-.9-1.4-1.7-1.7-.7-.3-1.5-.2-2.2.1-.7.3-1.2.9-1.5,1.6l-1.2,3.3c0,.2-.2.4-.3.6-1.6,3.4-5.7,4.9-9.1,3.2l-3.1-1.5c-.8-.4-1.7-.4-2.5,0-.7.3-1.2.9-1.5,1.6s-.2,1.5.1,2.2l1.5,3.1c0,.2.2.4.3.6.6,1.7.5,3.6-.3,5.2s-2.2,2.9-3.9,3.5l-3.3,1.2c-.8.3-1.4.9-1.7,1.7-.3.7-.2,1.5.1,2.2.3.7.9,1.2,1.6,1.5l3.3,1.2c.2,0,.4.2.7.3,3.4,1.6,4.9,5.7,3.2,9.1l-1.5,3.1c-.4.8-.4,1.7,0,2.5.7,1.4,2.4,2,3.8,1.3l3.1-1.5c.2-.1.4-.2.7-.3.8-.3,1.5-.4,2.3-.4Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M32,45.6c-7.5,0-13.6-6.1-13.6-13.6s6.1-13.6,13.6-13.6,13.6,6.1,13.6,13.6-6.1,13.6-13.6,13.6ZM32,22.4c-5.3,0-9.6,4.3-9.6,9.6s4.3,9.6,9.6,9.6,9.6-4.3,9.6-9.6-4.3-9.6-9.6-9.6Z')
							]),
						_List_Nil)
					])
			};
		case 65:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 128 128'),
						A2($elm$html$Html$Attributes$attribute, 'style', 'vertical-align: '),
						A2($elm$html$Html$Attributes$attribute, 'width', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'height', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'fill', 'rgba(0%,0%,0%,1)')
					]),
				N: _List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M35.971 111.33l81.958 11.188c-9.374-15.606-18.507-30.813-27.713-46.144L35.971 111.33zm89.71-86.383c-2.421 3.636-4.847 7.269-7.265 10.907a67619.72 67619.72 0 00-24.903 37.485c-.462.696-1.061 1.248-.41 2.321 8.016 13.237 15.969 26.513 23.942 39.777 1.258 2.095 2.53 4.182 4.157 6.192l4.834-96.58-.355-.102zM16.252 66.22c.375.355 1.311.562 1.747.347 7.689-3.779 15.427-7.474 22.948-11.564 2.453-1.333 4.339-3.723 6.452-5.661 6.997-6.417 13.983-12.847 20.966-19.278.427-.395.933-.777 1.188-1.275 2.508-4.902 4.973-9.829 7.525-14.898-3.043-1.144-5.928-2.263-8.849-3.281-.396-.138-1.02.136-1.449.375-6.761 3.777-13.649 7.353-20.195 11.472-3.275 2.061-5.943 5.098-8.843 7.743-4.674 4.266-9.342 8.542-13.948 12.882a24.011 24.011 0 00-3.288 3.854c-3.15 4.587-6.206 9.24-9.402 14.025 1.786 1.847 3.41 3.613 5.148 5.259zm28.102-6.271l-11.556 48.823 54.3-34.987-42.744-13.836zm76.631-34.846l-46.15 7.71 15.662 38.096c10.221-15.359 20.24-30.41 30.488-45.806zM44.996 56.644l41.892 13.6c-5.25-12.79-10.32-25.133-15.495-37.737L44.996 56.644zM16.831 75.643L2.169 110.691l27.925-.825-13.263-34.223zm13.593 26.096l.346-.076c3.353-13.941 6.754-27.786 10.177-42.272L18.544 71.035c3.819 9.926 7.891 20.397 11.88 30.704zm84.927-78.897c-4.459-1.181-8.918-2.366-13.379-3.539-6.412-1.686-12.829-3.351-19.237-5.052-.801-.213-1.38-.352-1.851.613-2.265 4.64-4.6 9.245-6.901 13.868-.071.143-.056.328-.111.687l41.47-6.285.009-.292zM89.482 12.288l36.343 10.054-6.005-17.11-30.285 6.715-.053.341zM33.505 114.007c-4.501-.519-9.122-.042-13.687.037-3.75.063-7.5.206-11.25.323-.386.012-.771.09-1.156.506 31.003 2.866 62.005 5.732 93.007 8.6l.063-.414-29.815-4.07c-12.384-1.691-24.747-3.551-37.162-4.982zM2.782 99.994c3.995-9.27 7.973-18.546 11.984-27.809.401-.929.37-1.56-.415-2.308-1.678-1.597-3.237-3.318-5.071-5.226-2.479 12.24-4.897 24.177-7.317 36.113l.271.127c.185-.297.411-.578.548-.897zm78.74-90.153c6.737-1.738 13.572-3.097 20.367-4.613.44-.099.87-.244 1.303-.368l-.067-.332-29.194 3.928c2.741 1.197 4.853 2.091 7.591 1.385z'),
								A2($elm$html$Html$Attributes$attribute, 'fill-rule', 'evenodd'),
								A2($elm$html$Html$Attributes$attribute, 'clip-rule', 'evenodd'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#D91404')
							]),
						_List_Nil)
					])
			};
		case 66:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 377 247'),
						A2($elm$html$Html$Attributes$attribute, 'style', 'vertical-align: '),
						A2($elm$html$Html$Attributes$attribute, 'width', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'height', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'fill', 'rgba(0%,0%,0%,1)')
					]),
				N: _List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M90.8698 42.9787C134.441 29.6593 164.174 44.18 193.576 46.2084C222.821 48.228 248.023 39.5922 264.624 33.8553C346.268 5.62349 377.483 117.271 303.411 143.544C270.027 155.401 257.565 155.732 229.418 175.119C213.523 186.044 196.069 215.573 157.726 223.87C86.7305 239.217 45.172 201.636 36.266 165.317C24.6586 118.011 42.4357 57.7779 90.8698 42.9787Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#CCDDFF')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'g',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'style', 'mix-blend-mode:multiply')
							]),
						_List_fromArray(
							[
								A3(
								$elm$svg$Svg$node,
								'path',
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'd', 'M111.584 181.544H36.5453C34.6202 181.544 33.0596 183.103 33.0596 185.026V232.027C33.0596 233.95 34.6202 235.509 36.5453 235.509H111.584C113.509 235.509 115.07 233.95 115.07 232.027V185.026C115.07 183.103 113.509 181.544 111.584 181.544Z'),
										A2($elm$html$Html$Attributes$attribute, 'fill', '#CCDDFF')
									]),
								_List_Nil)
							])),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M105.764 175.293H30.7251C28.5594 175.293 26.8037 177.047 26.8037 179.211V226.212C26.8037 228.375 28.5594 230.129 30.7251 230.129H105.764C107.93 230.129 109.685 228.375 109.685 226.212V179.211C109.685 177.047 107.93 175.293 105.764 175.293Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'white')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M105.764 175.728C106.689 175.728 107.575 176.095 108.229 176.748C108.883 177.401 109.25 178.287 109.25 179.211V226.22C109.25 227.144 108.883 228.029 108.229 228.682C107.575 229.335 106.689 229.702 105.764 229.702H30.7253C29.8008 229.702 28.9142 229.335 28.2605 228.682C27.6068 228.029 27.2396 227.144 27.2396 226.22V179.211C27.2396 178.287 27.6068 177.401 28.2605 176.748C28.9142 176.095 29.8008 175.728 30.7253 175.728H105.764ZM105.764 174.858H30.7253C29.5697 174.858 28.4615 175.316 27.6443 176.133C26.8272 176.949 26.3682 178.056 26.3682 179.211V226.22C26.3682 227.375 26.8272 228.482 27.6443 229.298C28.4615 230.114 29.5697 230.573 30.7253 230.573H105.764C106.92 230.573 108.028 230.114 108.845 229.298C109.662 228.482 110.121 227.375 110.121 226.22V179.211C110.121 178.056 109.662 176.949 108.845 176.133C108.028 175.316 106.92 174.858 105.764 174.858Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M27.2383 186.923H109.248'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', '#3F5BE8'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-miterlimit', '10')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M90.8273 182.841C90.5601 182.841 90.299 182.762 90.0769 182.613C89.8547 182.465 89.6816 182.254 89.5794 182.008C89.4771 181.761 89.4504 181.49 89.5025 181.228C89.5546 180.966 89.6833 180.726 89.8722 180.537C90.0611 180.349 90.3018 180.22 90.5638 180.168C90.8258 180.116 91.0974 180.143 91.3442 180.245C91.591 180.347 91.8019 180.52 91.9504 180.742C92.0988 180.964 92.178 181.225 92.178 181.491C92.178 181.849 92.0357 182.193 91.7824 182.446C91.5291 182.699 91.1855 182.841 90.8273 182.841Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'white')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M90.828 180.578C91.0106 180.569 91.1916 180.615 91.3477 180.71C91.5038 180.805 91.6278 180.945 91.7038 181.111C91.7798 181.277 91.8042 181.462 91.774 181.642C91.7438 181.822 91.6603 181.989 91.5342 182.121C91.4081 182.253 91.2453 182.345 91.0668 182.384C90.8882 182.423 90.702 182.407 90.5323 182.34C90.3625 182.272 90.217 182.155 90.1144 182.004C90.0118 181.853 89.9568 181.674 89.9566 181.492C89.9507 181.374 89.9689 181.256 90.01 181.145C90.0512 181.034 90.1144 180.933 90.1959 180.848C90.2774 180.762 90.3755 180.694 90.4842 180.648C90.5929 180.601 90.7098 180.577 90.828 180.578ZM90.828 179.707C90.473 179.698 90.1234 179.796 89.824 179.986C89.5245 180.177 89.2888 180.453 89.1469 180.778C89.005 181.103 88.9633 181.463 89.0272 181.812C89.0912 182.161 89.2578 182.483 89.5058 182.737C89.7538 182.991 90.072 183.166 90.4196 183.238C90.7673 183.311 91.1287 183.278 91.4577 183.144C91.7866 183.011 92.0683 182.782 92.2665 182.488C92.4648 182.193 92.5708 181.846 92.5709 181.492C92.571 181.026 92.3888 180.578 92.0632 180.245C91.7375 179.911 91.2942 179.718 90.828 179.707Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M96.8048 182.841C96.5377 182.841 96.2765 182.762 96.0544 182.613C95.8323 182.465 95.6592 182.254 95.5569 182.008C95.4547 181.761 95.4279 181.49 95.4801 181.228C95.5322 180.966 95.6608 180.726 95.8497 180.537C96.0386 180.349 96.2793 180.22 96.5413 180.168C96.8033 180.116 97.0749 180.143 97.3217 180.245C97.5685 180.347 97.7795 180.52 97.9279 180.742C98.0763 180.964 98.1555 181.225 98.1555 181.491C98.1567 181.669 98.1225 181.845 98.0551 182.009C97.9876 182.173 97.8882 182.323 97.7625 182.448C97.6368 182.574 97.4875 182.673 97.3231 182.74C97.1587 182.808 96.9825 182.842 96.8048 182.841Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'white')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M96.8056 180.578C96.9882 180.569 97.1692 180.615 97.3253 180.71C97.4813 180.805 97.6054 180.945 97.6813 181.111C97.7573 181.277 97.7818 181.462 97.7516 181.642C97.7213 181.822 97.6378 181.989 97.5117 182.121C97.3857 182.253 97.2229 182.345 97.0443 182.384C96.8657 182.423 96.6796 182.407 96.5098 182.34C96.3401 182.272 96.1945 182.155 96.0919 182.004C95.9893 181.853 95.9344 181.674 95.9342 181.492C95.9282 181.374 95.9464 181.256 95.9876 181.145C96.0287 181.034 96.0919 180.933 96.1735 180.848C96.255 180.762 96.353 180.694 96.4617 180.648C96.5704 180.601 96.6874 180.577 96.8056 180.578ZM96.8056 179.707C96.4505 179.698 96.101 179.796 95.8015 179.986C95.5021 180.177 95.2663 180.453 95.1244 180.778C94.9825 181.103 94.9408 181.463 95.0048 181.812C95.0687 182.161 95.2353 182.483 95.4833 182.737C95.7313 182.991 96.0495 183.166 96.3972 183.238C96.7448 183.311 97.1062 183.278 97.4352 183.144C97.7642 183.011 98.0458 182.782 98.2441 182.488C98.4424 182.193 98.5483 181.846 98.5484 181.492C98.5543 181.259 98.5135 181.028 98.4285 180.812C98.3435 180.596 98.2161 180.399 98.0536 180.232C97.8912 180.066 97.6971 179.934 97.4828 179.844C97.2684 179.753 97.0382 179.707 96.8056 179.707Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#3F5BE8')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M102.774 182.841C102.506 182.841 102.245 182.762 102.023 182.613C101.801 182.465 101.628 182.254 101.526 182.008C101.423 181.761 101.397 181.49 101.449 181.228C101.501 180.966 101.63 180.726 101.818 180.537C102.007 180.349 102.248 180.22 102.51 180.168C102.772 180.116 103.044 180.143 103.29 180.245C103.537 180.347 103.748 180.52 103.897 180.742C104.045 180.964 104.124 181.225 104.124 181.491C104.124 181.849 103.982 182.193 103.729 182.446C103.475 182.699 103.132 182.841 102.774 182.841Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'white')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M102.774 180.578C102.956 180.569 103.137 180.615 103.293 180.71C103.449 180.805 103.574 180.945 103.649 181.111C103.725 181.277 103.75 181.462 103.72 181.642C103.689 181.822 103.606 181.989 103.48 182.121C103.354 182.253 103.191 182.345 103.012 182.384C102.834 182.423 102.648 182.407 102.478 182.34C102.308 182.272 102.163 182.155 102.06 182.004C101.957 181.853 101.903 181.674 101.902 181.492C101.896 181.374 101.915 181.256 101.956 181.145C101.997 181.034 102.06 180.933 102.142 180.848C102.223 180.762 102.321 180.694 102.43 180.648C102.539 180.601 102.656 180.577 102.774 180.578ZM102.774 179.707C102.42 179.707 102.075 179.812 101.781 180.008C101.487 180.204 101.259 180.483 101.123 180.809C100.988 181.135 100.953 181.494 101.022 181.84C101.091 182.186 101.261 182.504 101.511 182.754C101.76 183.003 102.079 183.173 102.425 183.242C102.772 183.311 103.131 183.276 103.457 183.14C103.784 183.005 104.063 182.777 104.259 182.483C104.455 182.19 104.56 181.845 104.56 181.492C104.56 181.018 104.372 180.564 104.037 180.23C103.702 179.895 103.248 179.707 102.774 179.707Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#3F5BE8')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M67.1586 202.707C67.7602 202.707 68.2479 202.22 68.2479 201.619C68.2479 201.018 67.7602 200.531 67.1586 200.531C66.557 200.531 66.0693 201.018 66.0693 201.619C66.0693 202.22 66.557 202.707 67.1586 202.707Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'white')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M34.6992 214.468L38.7514 218.516L34.6992 222.564'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'white')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M34.6992 214.468L38.7514 218.516L34.6992 222.564'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', '#3F5BE8'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-linecap', 'round'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-linejoin', 'round')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M42.0361 222.564H47.7004'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', '#3F5BE8'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-linecap', 'round'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-linejoin', 'round')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'fill-rule', 'evenodd'),
								A2($elm$html$Html$Attributes$attribute, 'clip-rule', 'evenodd'),
								A2($elm$html$Html$Attributes$attribute, 'd', 'M79.7604 199.407L68.2488 196.169L56.7285 199.407V212.979L68.2052 216.192V216.209L68.2488 216.2L68.2837 216.209V216.192L79.7604 212.979V199.407Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'white'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', '#3F5BE8'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-linejoin', 'round')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'fill-rule', 'evenodd'),
								A2($elm$html$Html$Attributes$attribute, 'clip-rule', 'evenodd'),
								A2($elm$html$Html$Attributes$attribute, 'd', 'M79.7604 199.407L68.2488 202.628L56.7285 199.407V212.979L68.2052 216.191V216.209L68.2488 216.2L68.2837 216.209V216.191L79.7604 212.979V199.407Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'white'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', '#3F5BE8'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-linejoin', 'round')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M68.249 202.628V216.208'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', '#3F5BE8'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-linejoin', 'round')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'g',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'style', 'mix-blend-mode:multiply')
							]),
						_List_fromArray(
							[
								A3(
								$elm$svg$Svg$node,
								'path',
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'd', 'M104.194 247C114.267 247 122.433 238.843 122.433 228.78C122.433 218.717 114.267 210.559 104.194 210.559C94.121 210.559 85.9551 218.717 85.9551 228.78C85.9551 238.843 94.121 247 104.194 247Z'),
										A2($elm$html$Html$Attributes$attribute, 'fill', '#CCDDFF')
									]),
								_List_Nil)
							])),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M100.586 242.961C97.065 242.961 93.6225 241.917 90.6946 239.963C87.7667 238.008 85.4848 235.23 84.1376 231.98C82.7903 228.729 82.4383 225.153 83.1259 221.702C83.8136 218.252 85.51 215.083 88.0008 212.596C90.4915 210.109 93.6645 208.416 97.1186 207.731C100.573 207.046 104.153 207.399 107.406 208.746C110.659 210.094 113.438 212.375 115.394 215.301C117.349 218.227 118.392 221.666 118.39 225.184C118.385 229.899 116.508 234.419 113.17 237.752C109.832 241.085 105.306 242.958 100.586 242.961Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'white')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M100.588 207.834C104.023 207.832 107.382 208.849 110.24 210.754C113.097 212.66 115.325 215.37 116.64 218.54C117.956 221.711 118.301 225.2 117.631 228.567C116.961 231.933 115.307 235.025 112.877 237.452C110.448 239.879 107.352 241.532 103.983 242.201C100.613 242.87 97.12 242.526 93.9461 241.212C90.7723 239.897 88.0599 237.672 86.1522 234.818C84.2445 231.963 83.2271 228.607 83.2289 225.175C83.2358 220.578 85.0669 216.171 88.3208 212.921C91.5747 209.67 95.986 207.841 100.588 207.834ZM100.588 206.963C96.9804 206.965 93.4546 208.035 90.4561 210.039C87.4577 212.042 85.1213 214.889 83.7425 218.219C82.3636 221.549 82.0041 225.213 82.7096 228.747C83.415 232.281 85.1537 235.527 87.7057 238.074C90.2577 240.621 93.5084 242.355 97.0467 243.056C100.585 243.757 104.252 243.395 107.584 242.014C110.916 240.634 113.764 238.297 115.766 235.299C117.769 232.302 118.837 228.779 118.835 225.175C118.835 222.783 118.364 220.414 117.447 218.204C116.53 215.994 115.187 213.986 113.493 212.294C111.799 210.603 109.788 209.262 107.576 208.347C105.363 207.432 102.991 206.962 100.596 206.963H100.588Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#3F5BE8')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M88.6143 238.913C89.8668 236.861 91.6264 235.166 93.7239 233.99C95.8215 232.813 98.1866 232.195 100.592 232.195C102.998 232.195 105.363 232.813 107.46 233.99C109.558 235.166 111.317 236.861 112.57 238.913'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', '#3F5BE8'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-miterlimit', '10')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M100.586 214.373C100.869 214.372 101.148 214.445 101.394 214.586C101.641 214.726 101.846 214.929 101.989 215.173L107.557 224.671C107.702 224.917 107.778 225.197 107.78 225.483C107.781 225.768 107.706 226.049 107.564 226.297C107.421 226.544 107.216 226.749 106.969 226.892C106.721 227.035 106.44 227.109 106.154 227.109H95.0262C94.7405 227.109 94.4596 227.035 94.2121 226.892C93.9646 226.749 93.7592 226.544 93.6167 226.297C93.4743 226.049 93.3999 225.768 93.401 225.483C93.4022 225.197 93.4788 224.917 93.6232 224.671L99.1917 215.173C99.3335 214.93 99.537 214.727 99.7817 214.587C100.026 214.446 100.304 214.372 100.586 214.373ZM100.586 213.502C100.15 213.503 99.7229 213.618 99.3453 213.834C98.9678 214.051 98.6535 214.363 98.4335 214.738L92.8738 224.236C92.6503 224.614 92.5311 225.044 92.5284 225.483C92.5256 225.922 92.6395 226.353 92.8583 226.734C93.0771 227.115 93.3931 227.43 93.7739 227.649C94.1548 227.868 94.5869 227.982 95.0262 227.979H106.154C106.593 227.979 107.023 227.863 107.402 227.644C107.782 227.425 108.096 227.109 108.315 226.73C108.533 226.35 108.647 225.919 108.646 225.482C108.644 225.044 108.527 224.614 108.307 224.236L102.738 214.738C102.52 214.361 102.207 214.048 101.829 213.831C101.451 213.614 101.022 213.5 100.586 213.502Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#3F5BE8')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'g',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'style', 'mix-blend-mode:multiply')
							]),
						_List_fromArray(
							[
								A3(
								$elm$svg$Svg$node,
								'path',
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'd', 'M85.5469 95.8564H10.5082C8.58307 95.8564 7.02246 97.4155 7.02246 99.3386V146.339C7.02246 148.263 8.58307 149.822 10.5082 149.822H85.5469C87.472 149.822 89.0326 148.263 89.0326 146.339V99.3386C89.0326 97.4155 87.472 95.8564 85.5469 95.8564Z'),
										A2($elm$html$Html$Attributes$attribute, 'fill', '#CCDDFF')
									]),
								_List_Nil)
							])),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M79.7345 89.6055H4.68705C2.52131 89.6055 0.765625 91.3594 0.765625 93.5229V140.524C0.765625 142.687 2.52131 144.441 4.68705 144.441H79.7345C81.9002 144.441 83.6559 142.687 83.6559 140.524V93.5229C83.6559 91.3594 81.9002 89.6055 79.7345 89.6055Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'white')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M79.7249 90.0405C80.6494 90.0405 81.536 90.4073 82.1897 91.0604C82.8434 91.7134 83.2106 92.5991 83.2106 93.5227V140.532C83.2106 141.456 82.8434 142.341 82.1897 142.994C81.536 143.648 80.6494 144.014 79.7249 144.014H4.67746C3.75299 144.014 2.86638 143.648 2.21268 142.994C1.55898 142.341 1.19174 141.456 1.19174 140.532V93.5227C1.19174 92.5991 1.55898 91.7134 2.21268 91.0604C2.86638 90.4073 3.75299 90.0405 4.67746 90.0405H79.7249ZM79.7249 89.1699H4.67746C3.52187 89.1699 2.41361 89.6285 1.59649 90.4448C0.779367 91.2611 0.320313 92.3682 0.320312 93.5227V140.532C0.320312 141.687 0.779367 142.794 1.59649 143.61C2.41361 144.426 3.52187 144.885 4.67746 144.885H79.7249C80.8805 144.885 81.9887 144.426 82.8059 143.61C83.623 142.794 84.082 141.687 84.082 140.532V93.5227C84.082 92.3682 83.623 91.2611 82.8059 90.4448C81.9887 89.6285 80.8805 89.1699 79.7249 89.1699Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#3F5BE8')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M1.2002 101.236H83.2103'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', '#3F5BE8'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-miterlimit', '10')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M64.8058 97.1533C64.5386 97.1533 64.2775 97.0742 64.0554 96.9259C63.8333 96.7776 63.6601 96.5669 63.5579 96.3203C63.4557 96.0738 63.4289 95.8024 63.481 95.5407C63.5332 95.2789 63.6618 95.0385 63.8507 94.8498C64.0396 94.6611 64.2803 94.5326 64.5423 94.4805C64.8043 94.4285 65.0759 94.4552 65.3227 94.5573C65.5695 94.6594 65.7805 94.8324 65.9289 95.0543C66.0773 95.2762 66.1565 95.5371 66.1565 95.8039C66.1577 95.9815 66.1235 96.1575 66.0561 96.3217C65.9886 96.4859 65.8891 96.6351 65.7635 96.7606C65.6378 96.8862 65.4885 96.9855 65.3241 97.0529C65.1597 97.1203 64.9835 97.1544 64.8058 97.1533Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'white')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M64.8048 94.8896C64.9753 94.8898 65.1419 94.94 65.2841 95.0338C65.4263 95.1277 65.5379 95.2612 65.6049 95.4177C65.672 95.5743 65.6916 95.747 65.6613 95.9146C65.6311 96.0822 65.5523 96.2372 65.4348 96.3605C65.3172 96.4838 65.166 96.57 65 96.6083C64.8339 96.6467 64.6602 96.6355 64.5004 96.5763C64.3406 96.517 64.2017 96.4122 64.101 96.2749C64.0002 96.1376 63.9419 95.9737 63.9334 95.8037C63.9275 95.6857 63.9456 95.5678 63.9868 95.4571C64.0279 95.3464 64.0912 95.2453 64.1727 95.1598C64.2542 95.0743 64.3523 95.0062 64.461 94.9598C64.5696 94.9133 64.6866 94.8894 64.8048 94.8896ZM64.8048 94.019C64.462 94.0192 64.1268 94.1203 63.8412 94.3097C63.5556 94.4992 63.3323 94.7686 63.1992 95.0842C63.0661 95.3998 63.0291 95.7476 63.0929 96.0841C63.1567 96.4206 63.3185 96.7308 63.5579 96.976C63.7973 97.2211 64.1037 97.3903 64.4389 97.4623C64.774 97.5343 65.123 97.506 65.4421 97.3809C65.7613 97.2557 66.0364 97.0394 66.233 96.7588C66.4296 96.4783 66.5391 96.146 66.5477 95.8037C66.5535 95.5714 66.5127 95.3403 66.4277 95.124C66.3427 94.9077 66.2153 94.7106 66.0529 94.5443C65.8904 94.378 65.6963 94.2458 65.482 94.1556C65.2677 94.0654 65.0374 94.019 64.8048 94.019Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#3F5BE8')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M70.7579 97.1533C70.4908 97.1533 70.2296 97.0742 70.0075 96.9259C69.7854 96.7776 69.6123 96.5669 69.51 96.3203C69.4078 96.0738 69.3811 95.8024 69.4332 95.5407C69.4853 95.2789 69.6139 95.0385 69.8028 94.8498C69.9917 94.6611 70.2324 94.5326 70.4944 94.4805C70.7564 94.4285 71.028 94.4552 71.2748 94.5573C71.5216 94.6594 71.7326 94.8324 71.881 95.0543C72.0294 95.2762 72.1087 95.5371 72.1087 95.8039C72.1087 96.1618 71.9664 96.505 71.713 96.7581C71.4597 97.0111 71.1162 97.1533 70.7579 97.1533Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'white')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M70.7589 94.8896C70.9294 94.8898 71.096 94.94 71.2382 95.0338C71.3804 95.1277 71.492 95.2612 71.559 95.4177C71.6261 95.5743 71.6457 95.747 71.6154 95.9146C71.5852 96.0822 71.5064 96.2372 71.3889 96.3605C71.2713 96.4838 71.1201 96.57 70.9541 96.6083C70.788 96.6467 70.6143 96.6355 70.4545 96.5763C70.2947 96.517 70.1558 96.4122 70.0551 96.2749C69.9543 96.1376 69.896 95.9737 69.8875 95.8037C69.8816 95.6857 69.8997 95.5678 69.9409 95.4571C69.982 95.3464 70.0453 95.2453 70.1268 95.1598C70.2083 95.0743 70.3064 95.0062 70.4151 94.9598C70.5237 94.9133 70.6407 94.8894 70.7589 94.8896ZM70.7589 94.019C70.4161 94.0192 70.0809 94.1203 69.7953 94.3097C69.5097 94.4992 69.2864 94.7686 69.1533 95.0842C69.0202 95.3998 68.9832 95.7476 69.047 96.0841C69.1108 96.4206 69.2726 96.7308 69.512 96.976C69.7514 97.2211 70.0578 97.3903 70.393 97.4623C70.7281 97.5343 71.0771 97.506 71.3962 97.3809C71.7154 97.2557 71.9905 97.0394 72.1871 96.7588C72.3837 96.4783 72.4932 96.146 72.5018 95.8037C72.5019 95.3378 72.3197 94.8903 71.994 94.5569C71.6684 94.2234 71.2251 94.0304 70.7589 94.019Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#3F5BE8')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M76.7355 97.1533C76.4683 97.1533 76.2072 97.0742 75.9851 96.9259C75.7629 96.7776 75.5898 96.5669 75.4876 96.3203C75.3854 96.0738 75.3586 95.8024 75.4107 95.5407C75.4628 95.2789 75.5915 95.0385 75.7804 94.8498C75.9693 94.6611 76.21 94.5326 76.472 94.4805C76.734 94.4285 77.0056 94.4552 77.2524 94.5573C77.4992 94.6594 77.7101 94.8324 77.8586 95.0543C78.007 95.2762 78.0862 95.5371 78.0862 95.8039C78.0873 95.9815 78.0532 96.1575 77.9857 96.3217C77.9183 96.4859 77.8188 96.6351 77.6932 96.7606C77.5675 96.8862 77.4181 96.9855 77.2537 97.0529C77.0893 97.1203 76.9132 97.1544 76.7355 97.1533Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'white')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M76.7365 94.8896C76.9069 94.8898 77.0735 94.94 77.2158 95.0338C77.358 95.1277 77.4695 95.2612 77.5365 95.4177C77.6036 95.5743 77.6232 95.747 77.593 95.9146C77.5627 96.0822 77.484 96.2372 77.3664 96.3605C77.2488 96.4838 77.0977 96.57 76.9316 96.6083C76.7655 96.6467 76.5918 96.6355 76.4321 96.5763C76.2723 96.517 76.1334 96.4122 76.0326 96.2749C75.9318 96.1376 75.8736 95.9737 75.865 95.8037C75.8591 95.6857 75.8773 95.5678 75.9184 95.4571C75.9596 95.3464 76.0228 95.2453 76.1043 95.1598C76.1858 95.0743 76.2839 95.0062 76.3926 94.9598C76.5013 94.9133 76.6183 94.8894 76.7365 94.8896ZM76.7365 94.019C76.3936 94.0192 76.0584 94.1203 75.7729 94.3097C75.4873 94.4992 75.2639 94.7686 75.1308 95.0842C74.9978 95.3998 74.9608 95.7476 75.0246 96.0841C75.0884 96.4206 75.2501 96.7308 75.4895 96.976C75.7289 97.2211 76.0354 97.3903 76.3705 97.4623C76.7057 97.5343 77.0547 97.506 77.3738 97.3809C77.6929 97.2557 77.968 97.0394 78.1646 96.7588C78.3613 96.4783 78.4707 96.146 78.4793 95.8037C78.4795 95.3378 78.2972 94.8903 77.9716 94.5569C77.6459 94.2234 77.2027 94.0304 76.7365 94.019Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#3F5BE8')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M41.1117 117.019C41.7133 117.019 42.201 116.531 42.201 115.93C42.201 115.329 41.7133 114.842 41.1117 114.842C40.5102 114.842 40.0225 115.329 40.0225 115.93C40.0225 116.531 40.5102 117.019 41.1117 117.019Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'white')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M8.65137 128.781L12.7035 132.829L8.65137 136.868'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'white')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M8.65137 128.781L12.7035 132.829L8.65137 136.868'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', '#3F5BE8'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-linecap', 'round'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-linejoin', 'round')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M15.9893 136.867H21.6623'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', '#3F5BE8'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-linecap', 'round'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-linejoin', 'round')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'fill-rule', 'evenodd'),
								A2($elm$html$Html$Attributes$attribute, 'clip-rule', 'evenodd'),
								A2($elm$html$Html$Attributes$attribute, 'd', 'M53.7223 113.719L42.202 110.481L30.6904 113.719V127.291L42.1671 130.504V130.521L42.202 130.512L42.2456 130.521V130.504L53.7223 127.291V113.719Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'white'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', '#3F5BE8'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-linejoin', 'round')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'fill-rule', 'evenodd'),
								A2($elm$html$Html$Attributes$attribute, 'clip-rule', 'evenodd'),
								A2($elm$html$Html$Attributes$attribute, 'd', 'M53.7223 113.719L42.202 116.94L30.6904 113.719V127.291L42.1671 130.503V130.521L42.202 130.512L42.2456 130.521V130.503L53.7223 127.291V113.719Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'white'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', '#3F5BE8'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-linejoin', 'round')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M42.2012 116.94V130.52'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', '#3F5BE8'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-linejoin', 'round')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'g',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'style', 'mix-blend-mode:multiply'),
								A2($elm$html$Html$Attributes$attribute, 'opacity', '0.2')
							]),
						_List_fromArray(
							[
								A3(
								$elm$svg$Svg$node,
								'path',
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'd', 'M78.157 161.312C88.2301 161.312 96.396 153.154 96.396 143.091C96.396 133.028 88.2301 124.871 78.157 124.871C68.0838 124.871 59.918 133.028 59.918 143.091C59.918 153.154 68.0838 161.312 78.157 161.312Z'),
										A2($elm$html$Html$Attributes$attribute, 'fill', '#3D65E9')
									]),
								_List_Nil)
							])),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M74.5474 157.274C71.0263 157.274 67.5842 156.231 64.6565 154.276C61.7287 152.322 59.4468 149.544 58.0993 146.295C56.7519 143.045 56.3993 139.469 57.0862 136.019C57.7732 132.569 59.4688 129.4 61.9586 126.912C64.4484 124.425 67.6207 122.731 71.0742 122.045C74.5277 121.359 78.1073 121.711 81.3605 123.057C84.6136 124.403 87.3941 126.683 89.3503 129.607C91.3066 132.532 92.3507 135.971 92.3507 139.488C92.3461 144.204 90.4689 148.725 87.1312 152.059C83.7934 155.394 79.2677 157.269 74.5474 157.274Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'white')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M74.5496 122.146C77.9849 122.146 81.3431 123.164 84.1994 125.071C87.0556 126.977 89.2817 129.688 90.5959 132.858C91.9102 136.029 92.2536 139.518 91.5828 142.884C90.9119 146.25 89.257 149.341 86.8272 151.767C84.3974 154.193 81.302 155.845 77.9325 156.514C74.5629 157.182 71.0706 156.837 67.8972 155.523C64.7239 154.208 62.012 151.983 60.1047 149.129C58.1974 146.274 57.1803 142.919 57.182 139.487C57.1889 134.889 59.0212 130.481 62.277 127.23C65.5328 123.979 69.9463 122.151 74.5496 122.146ZM74.5496 121.275C70.9419 121.275 67.4152 122.344 64.4156 124.347C61.416 126.349 59.0783 129.195 57.6981 132.525C56.3179 135.855 55.9572 139.519 56.6617 143.054C57.3661 146.588 59.1041 149.835 61.6557 152.383C64.2074 154.931 67.4581 156.665 70.9966 157.367C74.5352 158.069 78.2028 157.707 81.5354 156.327C84.868 154.947 87.7159 152.61 89.719 149.612C91.7221 146.615 92.7903 143.091 92.7886 139.487C92.7862 134.656 90.8636 130.024 87.4434 126.609C84.0232 123.194 79.3853 121.275 74.5496 121.275Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#3F5BE8')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M74.5486 129.163C75.7532 129.171 76.9282 129.536 77.9256 130.211C78.923 130.885 79.6981 131.84 80.1531 132.954C80.6081 134.069 80.7227 135.292 80.4824 136.472C80.2422 137.651 79.6578 138.733 78.803 139.581C77.9482 140.428 76.8612 141.004 75.6791 141.236C74.4971 141.468 73.2728 141.345 72.1607 140.882C71.0486 140.42 70.0985 139.639 69.4301 138.637C68.7617 137.636 68.405 136.46 68.405 135.256C68.4165 133.636 69.0689 132.086 70.2198 130.945C71.3707 129.803 72.9267 129.162 74.5486 129.163ZM74.5486 128.292C73.1698 128.292 71.8219 128.7 70.6755 129.466C69.529 130.231 68.6355 131.319 68.1078 132.591C67.5802 133.864 67.4421 135.264 67.7111 136.615C67.9801 137.966 68.6441 139.207 69.619 140.181C70.594 141.155 71.8362 141.818 73.1885 142.087C74.5408 142.356 75.9426 142.218 77.2164 141.691C78.4903 141.163 79.5791 140.271 80.3451 139.126C81.1111 137.98 81.52 136.634 81.52 135.256C81.52 133.409 80.7855 131.638 79.4781 130.332C78.1707 129.026 76.3975 128.292 74.5486 128.292Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#3F5BE8')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M62.5674 153.225C63.8195 151.171 65.5793 149.474 67.6778 148.296C69.7762 147.119 72.1426 146.5 74.5495 146.5C76.9564 146.5 79.3228 147.119 81.4213 148.296C83.5197 149.474 85.2796 151.171 86.5317 153.225'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', '#3F5BE8'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-miterlimit', '10')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'g',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'style', 'mix-blend-mode:multiply')
							]),
						_List_fromArray(
							[
								A3(
								$elm$svg$Svg$node,
								'path',
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'd', 'M112.028 6.68652H36.9896C35.0645 6.68652 33.5039 8.24555 33.5039 10.1687V57.1695C33.5039 59.0927 35.0645 60.6517 36.9896 60.6517H112.028C113.953 60.6517 115.514 59.0927 115.514 57.1695V10.1687C115.514 8.24555 113.953 6.68652 112.028 6.68652Z'),
										A2($elm$html$Html$Attributes$attribute, 'fill', '#CCDDFF')
									]),
								_List_Nil)
							])),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M106.209 0.435059H31.1705C29.0047 0.435059 27.249 2.18897 27.249 4.35252V51.3533C27.249 53.5169 29.0047 55.2708 31.1705 55.2708H106.209C108.375 55.2708 110.131 53.5169 110.131 51.3533V4.35252C110.131 2.18897 108.375 0.435059 106.209 0.435059Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'white')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M106.208 0.870547C107.133 0.870547 108.019 1.23742 108.673 1.89046C109.327 2.54349 109.694 3.4292 109.694 4.35273V51.3623C109.694 52.2858 109.327 53.1715 108.673 53.8245C108.019 54.4776 107.133 54.8444 106.208 54.8444H31.1696C30.2452 54.8444 29.3586 54.4776 28.7049 53.8245C28.0512 53.1715 27.6839 52.2858 27.6839 51.3623V4.35273C27.6839 3.4292 28.0512 2.54349 28.7049 1.89046C29.3586 1.23742 30.2452 0.870547 31.1696 0.870547H106.208ZM106.208 0H31.1696C30.0141 0 28.9058 0.45859 28.0887 1.27489C27.2716 2.09118 26.8125 3.19832 26.8125 4.35273V51.3623C26.8125 52.5167 27.2716 53.6238 28.0887 54.4401C28.9058 55.2564 30.0141 55.715 31.1696 55.715H106.208C107.364 55.715 108.472 55.2564 109.289 54.4401C110.106 53.6238 110.566 52.5167 110.566 51.3623V4.35273C110.566 3.19832 110.106 2.09118 109.289 1.27489C108.472 0.45859 107.364 0 106.208 0Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#3F5BE8')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M27.6836 12.0659H109.694'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', '#3F5BE8'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-miterlimit', '10')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M91.2716 7.98336C91.0045 7.98336 90.7433 7.90423 90.5212 7.75596C90.2991 7.60769 90.1259 7.39695 90.0237 7.15039C89.9215 6.90383 89.8947 6.63252 89.9469 6.37077C89.999 6.10902 90.1276 5.86859 90.3165 5.67988C90.5054 5.49117 90.7461 5.36266 91.0081 5.3106C91.2701 5.25853 91.5417 5.28525 91.7885 5.38738C92.0353 5.48951 92.2463 5.66246 92.3947 5.88436C92.5431 6.10626 92.6223 6.36714 92.6223 6.63402C92.6223 6.99189 92.48 7.3351 92.2267 7.58815C91.9734 7.8412 91.6298 7.98336 91.2716 7.98336Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'white')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M91.2714 5.71971C91.4524 5.71971 91.6293 5.77332 91.7798 5.87376C91.9302 5.9742 92.0475 6.11696 92.1168 6.28398C92.186 6.45101 92.2041 6.6348 92.1688 6.81211C92.1335 6.98942 92.0464 7.1523 91.9184 7.28013C91.7905 7.40797 91.6274 7.49503 91.4499 7.5303C91.2724 7.56557 91.0885 7.54746 90.9213 7.47828C90.7541 7.40909 90.6112 7.29194 90.5106 7.14162C90.4101 6.9913 90.3564 6.81457 90.3564 6.63378C90.3502 6.5121 90.3695 6.39045 90.4133 6.27672C90.4571 6.16299 90.5242 6.0597 90.6105 5.97354C90.6967 5.88738 90.8001 5.82027 90.914 5.77654C91.0278 5.73282 91.1496 5.71346 91.2714 5.71971ZM91.2714 4.84916C90.9164 4.84051 90.5668 4.93778 90.2673 5.12854C89.9679 5.3193 89.7321 5.5949 89.5902 5.92014C89.4483 6.24538 89.4067 6.6055 89.4706 6.9545C89.5345 7.3035 89.7011 7.62554 89.9491 7.8795C90.1972 8.13345 90.5153 8.3078 90.863 8.38026C91.2107 8.45272 91.5721 8.42001 91.901 8.28631C92.23 8.15261 92.5116 7.92399 92.7099 7.62964C92.9082 7.33529 93.0142 6.98858 93.0143 6.63378C93.0144 6.16792 92.8322 5.72047 92.5065 5.38701C92.1809 5.05355 91.7376 4.86053 91.2714 4.84916Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#3F5BE8')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M97.2404 7.98334C96.9737 7.98162 96.7134 7.90102 96.4924 7.75171C96.2714 7.6024 96.0997 7.39107 95.9988 7.14436C95.8979 6.89765 95.8724 6.62662 95.9255 6.36545C95.9786 6.10428 96.1079 5.86466 96.2971 5.67682C96.4864 5.48898 96.7271 5.36133 96.9888 5.30997C97.2506 5.2586 97.5217 5.28583 97.768 5.38821C98.0143 5.49059 98.2248 5.66354 98.3728 5.88524C98.5209 6.10695 98.5999 6.36748 98.5999 6.63399C98.5976 6.99266 98.4533 7.33585 98.1986 7.58865C97.9439 7.84146 97.5995 7.98334 97.2404 7.98334Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'white')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M97.2406 5.71969C97.4232 5.71099 97.6042 5.75712 97.7603 5.85213C97.9164 5.94714 98.0404 6.08667 98.1164 6.25275C98.1924 6.41882 98.2168 6.60382 98.1866 6.7839C98.1563 6.96399 98.0728 7.1309 97.9468 7.26312C97.8207 7.39535 97.6579 7.48683 97.4793 7.52577C97.3007 7.56471 97.1146 7.54933 96.9448 7.48161C96.7751 7.4139 96.6295 7.29694 96.5269 7.14583C96.4243 6.99471 96.3694 6.81636 96.3692 6.63376C96.371 6.39932 96.4621 6.17436 96.624 6.00459C96.7858 5.83482 97.0063 5.73295 97.2406 5.71969ZM97.2406 4.84914C96.8877 4.85086 96.5431 4.95699 96.2505 5.15413C95.9579 5.35127 95.7303 5.63058 95.5964 5.95683C95.4625 6.28307 95.4284 6.64162 95.4983 6.98723C95.5682 7.33284 95.739 7.65001 95.9892 7.89873C96.2394 8.14744 96.5577 8.31655 96.904 8.3847C97.2503 8.45286 97.609 8.41701 97.935 8.28169C98.2609 8.14636 98.5394 7.91762 98.7353 7.62433C98.9312 7.33105 99.0357 6.98636 99.0357 6.63376C99.0357 6.39867 98.9893 6.16589 98.8989 5.9488C98.8086 5.73171 98.6762 5.53459 98.5094 5.36876C98.3426 5.20293 98.1447 5.07165 97.9269 4.98248C97.7092 4.89331 97.4759 4.848 97.2406 4.84914Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#3F5BE8')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M103.219 7.98336C102.952 7.98336 102.691 7.90423 102.468 7.75596C102.246 7.60769 102.073 7.39695 101.971 7.15039C101.869 6.90383 101.842 6.63252 101.894 6.37077C101.946 6.10902 102.075 5.86859 102.264 5.67988C102.453 5.49117 102.693 5.36266 102.955 5.3106C103.217 5.25853 103.489 5.28525 103.736 5.38738C103.983 5.48951 104.194 5.66246 104.342 5.88436C104.49 6.10626 104.57 6.36714 104.57 6.63402C104.57 6.99189 104.427 7.3351 104.174 7.58815C103.921 7.8412 103.577 7.98336 103.219 7.98336Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'white')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M103.219 5.71971C103.401 5.71102 103.582 5.75714 103.738 5.85215C103.894 5.94716 104.018 6.0867 104.094 6.25277C104.17 6.41884 104.195 6.60384 104.165 6.78392C104.134 6.96401 104.051 7.13092 103.925 7.26314C103.799 7.39537 103.636 7.48685 103.457 7.52579C103.279 7.56473 103.093 7.54936 102.923 7.48164C102.753 7.41392 102.608 7.29696 102.505 7.14585C102.402 6.99473 102.347 6.81638 102.347 6.63378C102.341 6.51585 102.359 6.39795 102.401 6.28726C102.442 6.17656 102.505 6.07538 102.587 5.98988C102.668 5.90437 102.766 5.83633 102.875 5.78988C102.983 5.74344 103.1 5.71956 103.219 5.71971ZM103.219 4.84916C102.864 4.84051 102.514 4.93778 102.215 5.12854C101.915 5.3193 101.679 5.5949 101.537 5.92014C101.396 6.24538 101.354 6.6055 101.418 6.9545C101.482 7.3035 101.648 7.62554 101.896 7.8795C102.144 8.13345 102.463 8.3078 102.81 8.38026C103.158 8.45272 103.519 8.42001 103.848 8.28631C104.177 8.15261 104.459 7.92399 104.657 7.62964C104.855 7.33529 104.961 6.98858 104.962 6.63378C104.962 6.16792 104.779 5.72047 104.454 5.38701C104.128 5.05355 103.685 4.86053 103.219 4.84916Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#3F5BE8')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M67.5951 27.8487C68.1967 27.8487 68.6844 27.3615 68.6844 26.7605C68.6844 26.1596 68.1967 25.6724 67.5951 25.6724C66.9935 25.6724 66.5059 26.1596 66.5059 26.7605C66.5059 27.3615 66.9935 27.8487 67.5951 27.8487Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'white')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M35.1328 39.6094L39.185 43.6574L35.1328 47.6968'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'white')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M35.1328 39.6094L39.185 43.6574L35.1328 47.6968'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', '#3F5BE8'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-linecap', 'round'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-linejoin', 'round')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M42.4707 47.6973H48.1437'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', '#3F5BE8'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-linecap', 'round'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-linejoin', 'round')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'fill-rule', 'evenodd'),
								A2($elm$html$Html$Attributes$attribute, 'clip-rule', 'evenodd'),
								A2($elm$html$Html$Attributes$attribute, 'd', 'M80.2037 24.5495L68.6834 21.311L57.1719 24.5495V38.1213L68.6486 41.3336V41.351L68.6834 41.3423L68.727 41.351V41.3336L80.2037 38.1213V24.5495Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'white'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', '#3F5BE8'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-linejoin', 'round')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'fill-rule', 'evenodd'),
								A2($elm$html$Html$Attributes$attribute, 'clip-rule', 'evenodd'),
								A2($elm$html$Html$Attributes$attribute, 'd', 'M80.2037 24.5493L68.6834 27.7703L57.1719 24.5493V38.1211L68.6486 41.3335V41.3509L68.6834 41.3422L68.727 41.3509V41.3335L80.2037 38.1211V24.5493Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'white'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', '#3F5BE8'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-linejoin', 'round')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M68.6836 27.77V41.3505'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', '#3F5BE8'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-linejoin', 'round')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'g',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'style', 'mix-blend-mode:multiply')
							]),
						_List_fromArray(
							[
								A3(
								$elm$svg$Svg$node,
								'path',
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'd', 'M104.639 72.1418C114.713 72.1418 122.878 63.9842 122.878 53.9212C122.878 43.8583 114.713 35.7007 104.639 35.7007C94.5663 35.7007 86.4004 43.8583 86.4004 53.9212C86.4004 63.9842 94.5663 72.1418 104.639 72.1418Z'),
										A2($elm$html$Html$Attributes$attribute, 'fill', '#CCDDFF')
									]),
								_List_Nil)
							])),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M101.032 68.1028C97.5107 68.1028 94.0686 67.0597 91.1408 65.1054C88.2131 63.1511 85.9312 60.3735 84.5837 57.1236C83.2362 53.8738 82.8837 50.2978 83.5706 46.8478C84.2576 43.3978 85.9532 40.2287 88.443 37.7414C90.9328 35.2541 94.1051 33.5602 97.5586 32.874C101.012 32.1877 104.592 32.5399 107.845 33.8861C111.098 35.2322 113.878 37.5118 115.835 40.4365C117.791 43.3613 118.835 46.7999 118.835 50.3175C118.83 55.033 116.953 59.5541 113.616 62.8885C110.278 66.2229 105.752 68.0982 101.032 68.1028Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'white')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M101.031 32.976C104.466 32.976 107.825 33.9938 110.681 35.9006C113.537 37.8075 115.763 40.5177 117.077 43.6885C118.392 46.8593 118.735 50.3482 118.064 53.714C117.393 57.0798 115.738 60.1713 113.309 62.5974C110.879 65.0235 107.783 66.6752 104.414 67.3437C101.044 68.0122 97.552 67.6673 94.3787 66.3528C91.2053 65.0383 88.4935 62.8132 86.5862 59.9588C84.6788 57.1045 83.6617 53.7492 83.6634 50.3173C83.6703 45.7187 85.5026 41.3106 88.7584 38.0597C92.0142 34.8088 96.4278 32.9806 101.031 32.976ZM101.031 32.1055C97.4233 32.1055 93.8966 33.1743 90.8971 35.1768C87.8975 37.1793 85.5597 40.0254 84.1795 43.3553C82.7993 46.6852 82.4386 50.3492 83.1431 53.8839C83.8476 57.4185 85.5855 60.6651 88.1372 63.213C90.6888 65.7608 93.9395 67.4955 97.4781 68.1975C101.017 68.8996 104.684 68.5375 108.017 67.1571C111.349 65.7767 114.197 63.44 116.2 60.4425C118.203 57.445 119.272 53.9214 119.27 50.3173C119.268 45.4864 117.345 40.8542 113.925 37.4391C110.505 34.0239 105.867 32.1055 101.031 32.1055Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#3F5BE8')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M89.0498 64.0547C90.3019 62.0012 92.0618 60.304 94.1602 59.1263C96.2586 57.9487 98.6251 57.3301 101.032 57.3301C103.439 57.3301 105.805 57.9487 107.904 59.1263C110.002 60.304 111.762 62.0012 113.014 64.0547'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', '#3F5BE8'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-miterlimit', '10')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M105.554 39.9404H96.4995C95.585 39.9404 94.8438 40.681 94.8438 41.5945V50.6395C94.8438 51.553 95.585 52.2935 96.4995 52.2935H105.554C106.468 52.2935 107.209 51.553 107.209 50.6395V41.5945C107.209 40.681 106.468 39.9404 105.554 39.9404Z'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', '#3F5BE8'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-miterlimit', '10')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M209.507 32.4885C217.549 32.4885 224.068 26.0497 224.068 18.107C224.068 10.1644 217.549 3.72559 209.507 3.72559C201.465 3.72559 194.945 10.1644 194.945 18.107C194.945 26.0497 201.465 32.4885 209.507 32.4885Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#CCDDFF')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M271.404 111.604H73.25'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', '#3F5BE8'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-miterlimit', '10'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-dasharray', '3 4')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M100.16 21.311H135.505C145.814 21.311 154.163 30.5998 154.163 42.0649V76.7736C154.163 88.6827 162.877 98.337 173.552 98.337H271.405'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', '#3F5BE8'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-miterlimit', '10'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-dasharray', '3 4')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M102.346 198.354H135.504C145.813 198.354 154.161 189.422 154.161 178.418V145.163C154.161 133.724 162.875 124.453 173.55 124.453H271.403'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', '#3F5BE8'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-miterlimit', '10'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-dasharray', '3 4')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'g',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'style', 'mix-blend-mode:multiply')
							]),
						_List_fromArray(
							[
								A3(
								$elm$svg$Svg$node,
								'path',
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'd', 'M354.208 63.106H209.507C207.582 63.106 206.021 64.665 206.021 66.5881V168.12C206.021 170.043 207.582 171.602 209.507 171.602H354.208C356.133 171.602 357.694 170.043 357.694 168.12V66.5881C357.694 64.665 356.133 63.106 354.208 63.106Z'),
										A2($elm$html$Html$Attributes$attribute, 'fill', '#CCDDFF')
									]),
								_List_Nil)
							])),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M346.922 55.3931H202.221C200.055 55.3931 198.3 57.147 198.3 59.3105V160.842C198.3 163.006 200.055 164.76 202.221 164.76H346.922C349.088 164.76 350.843 163.006 350.843 160.842V59.3105C350.843 57.147 349.088 55.3931 346.922 55.3931Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'white')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M346.922 55.8286C347.846 55.8286 348.733 56.1954 349.386 56.8485C350.04 57.5015 350.407 58.3872 350.407 59.3107V160.843C350.407 161.766 350.04 162.652 349.386 163.305C348.733 163.958 347.846 164.325 346.922 164.325H202.264C201.34 164.325 200.453 163.958 199.8 163.305C199.146 162.652 198.779 161.766 198.779 160.843V59.3107C198.779 58.3872 199.146 57.5015 199.8 56.8485C200.453 56.1954 201.34 55.8286 202.264 55.8286H346.922ZM346.922 54.958H202.264C201.109 54.958 200.001 55.4166 199.183 56.2329C198.366 57.0492 197.907 58.1563 197.907 59.3107V160.843C197.907 161.997 198.366 163.104 199.183 163.92C200.001 164.737 201.109 165.195 202.264 165.195H346.922C348.077 165.195 349.185 164.737 350.002 163.92C350.82 163.104 351.279 161.997 351.279 160.843V59.3107C351.279 58.1563 350.82 57.0492 350.002 56.2329C349.185 55.4166 348.077 54.958 346.922 54.958Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#3F5BE8')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M198.736 76.5298H350.408'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', '#3F5BE8'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-miterlimit', '10')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M316.335 69.3564C315.766 69.3582 315.209 69.1911 314.735 68.8765C314.261 68.5619 313.891 68.1138 313.672 67.5891C313.453 67.0643 313.394 66.4864 313.504 65.9285C313.614 65.3707 313.888 64.858 314.289 64.4553C314.691 64.0527 315.204 63.7782 315.762 63.6667C316.32 63.5551 316.898 63.6115 317.424 63.8287C317.95 64.0459 318.4 64.4141 318.716 64.8867C319.033 65.3593 319.202 65.9151 319.202 66.4836C319.202 67.244 318.9 67.9734 318.362 68.5119C317.825 69.0504 317.096 69.3541 316.335 69.3564Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'white')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M316.334 64.0546C316.817 64.0546 317.289 64.1978 317.69 64.466C318.092 64.7343 318.404 65.1155 318.589 65.5614C318.773 66.0073 318.821 66.4979 318.726 66.9709C318.631 67.444 318.398 67.8783 318.056 68.2188C317.714 68.5594 317.278 68.7909 316.804 68.8839C316.331 68.977 315.84 68.9275 315.394 68.7416C314.948 68.5558 314.568 68.242 314.301 67.84C314.034 67.4381 313.892 66.9659 313.894 66.4835C313.894 66.1638 313.957 65.8472 314.08 65.552C314.202 65.2567 314.382 64.9886 314.609 64.7629C314.836 64.5373 315.105 64.3586 315.401 64.237C315.697 64.1155 316.014 64.0535 316.334 64.0546ZM316.334 63.1841C315.678 63.1824 315.037 63.3751 314.491 63.738C313.945 64.1008 313.519 64.6174 313.267 65.2222C313.016 65.827 312.949 66.4929 313.077 67.1354C313.204 67.7779 313.52 68.3682 313.984 68.8313C314.447 69.2945 315.038 69.6097 315.681 69.7371C316.324 69.8645 316.991 69.7982 317.596 69.5468C318.202 69.2953 318.719 68.8699 319.082 68.3246C319.445 67.7793 319.638 67.1385 319.637 66.4835C319.634 65.6091 319.286 64.7713 318.667 64.153C318.048 63.5347 317.209 63.1864 316.334 63.1841Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#3F5BE8')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M327.376 69.3565C326.807 69.3565 326.25 69.1877 325.777 68.8717C325.304 68.5556 324.935 68.1064 324.718 67.581C324.501 67.0556 324.444 66.4775 324.556 65.92C324.668 65.3625 324.942 64.8506 325.345 64.4492C325.748 64.0478 326.262 63.7748 326.82 63.665C327.378 63.5551 327.957 63.6133 328.482 63.832C329.008 64.0508 329.456 64.4204 329.771 64.8939C330.086 65.3675 330.253 65.9238 330.251 66.4924C330.249 67.2528 329.945 67.9812 329.406 68.5181C328.867 69.055 328.137 69.3565 327.376 69.3565Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'white')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M327.377 64.0546C327.86 64.0529 328.333 64.1946 328.736 64.4618C329.138 64.729 329.452 65.1096 329.638 65.5553C329.824 66.0011 329.873 66.4919 329.779 66.9656C329.685 67.4392 329.453 67.8743 329.111 68.2158C328.769 68.5572 328.334 68.7895 327.859 68.8833C327.385 68.9771 326.894 68.928 326.448 68.7425C326.002 68.5569 325.621 68.2431 325.353 67.841C325.086 67.4388 324.944 66.9663 324.946 66.4835C324.948 65.84 325.205 65.2236 325.66 64.7686C326.116 64.3136 326.733 64.0569 327.377 64.0546ZM327.377 63.1841C326.722 63.1841 326.081 63.3783 325.536 63.7422C324.991 64.1061 324.567 64.6233 324.317 65.2282C324.066 65.8332 324.001 66.4988 324.13 67.1408C324.258 67.7827 324.574 68.3721 325.038 68.8344C325.502 69.2967 326.093 69.6111 326.736 69.7377C327.379 69.8644 328.045 69.7976 328.65 69.5459C329.255 69.2942 329.772 68.8689 330.134 68.3237C330.497 67.7785 330.69 67.1381 330.688 66.4835C330.688 66.0495 330.603 65.6197 330.436 65.2188C330.27 64.818 330.025 64.4539 329.718 64.1474C329.41 63.8409 329.045 63.598 328.643 63.4327C328.242 63.2674 327.811 63.1829 327.377 63.1841Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#3F5BE8')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M338.435 69.3565C337.866 69.3565 337.31 69.1877 336.837 68.8717C336.364 68.5556 335.995 68.1064 335.778 67.581C335.56 67.0556 335.504 66.4775 335.615 65.92C335.727 65.3625 336.002 64.8506 336.405 64.4492C336.808 64.0478 337.321 63.7748 337.88 63.665C338.438 63.5551 339.017 63.6133 339.542 63.832C340.067 64.0508 340.516 64.4204 340.831 64.8939C341.146 65.3675 341.313 65.9238 341.311 66.4924C341.309 67.2528 341.005 67.9812 340.466 68.5181C339.927 69.055 339.196 69.3565 338.435 69.3565Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'white')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M338.434 64.0546C338.917 64.0546 339.39 64.1978 339.791 64.466C340.192 64.7343 340.505 65.1155 340.69 65.5614C340.874 66.0073 340.922 66.4979 340.827 66.9709C340.732 67.444 340.499 67.8783 340.157 68.2188C339.815 68.5594 339.379 68.7909 338.905 68.8839C338.431 68.977 337.94 68.9275 337.495 68.7416C337.049 68.5558 336.668 68.242 336.401 67.84C336.134 67.4381 335.993 66.9659 335.994 66.4835C335.997 65.8385 336.255 65.2207 336.712 64.7655C337.17 64.3103 337.789 64.0546 338.434 64.0546ZM338.434 63.1841C337.779 63.1841 337.139 63.3783 336.594 63.7422C336.049 64.1061 335.625 64.6233 335.374 65.2282C335.124 65.8332 335.059 66.4988 335.187 67.1408C335.316 67.7827 335.632 68.3721 336.096 68.8344C336.56 69.2967 337.151 69.6111 337.794 69.7377C338.437 69.8644 339.103 69.7976 339.708 69.5459C340.313 69.2942 340.829 68.8689 341.192 68.3237C341.555 67.7785 341.748 67.1381 341.746 66.4835C341.746 66.0495 341.66 65.6197 341.494 65.2188C341.327 64.818 341.083 64.4539 340.775 64.1474C340.468 63.8409 340.103 63.598 339.701 63.4327C339.299 63.2674 338.869 63.1829 338.434 63.1841Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#3F5BE8')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M272.553 105.719C273.665 105.719 274.566 104.819 274.566 103.708C274.566 102.598 273.665 101.697 272.553 101.697C271.441 101.697 270.54 102.598 270.54 103.708C270.54 104.819 271.441 105.719 272.553 105.719Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'white')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'fill-rule', 'evenodd'),
								A2($elm$html$Html$Attributes$attribute, 'clip-rule', 'evenodd'),
								A2($elm$html$Html$Attributes$attribute, 'd', 'M229.968 88.4907L220.199 85.7397L210.422 88.4907V99.9993L220.164 102.724V102.742L220.199 102.733L220.225 102.742V102.724L229.968 99.9993V88.4907Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'white'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', '#3F5BE8'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-linejoin', 'round')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'fill-rule', 'evenodd'),
								A2($elm$html$Html$Attributes$attribute, 'clip-rule', 'evenodd'),
								A2($elm$html$Html$Attributes$attribute, 'd', 'M229.968 88.4912L220.199 91.216L210.422 88.4912V99.9998L220.164 102.725V102.742L220.199 102.733L220.225 102.742V102.725L229.968 99.9998V88.4912Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'white'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', '#3F5BE8'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-linejoin', 'round')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M220.199 91.2158V102.742'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', '#3F5BE8'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-linejoin', 'round')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M242.98 88.2475C241.811 88.3054 240.686 88.7045 239.742 89.3953C238.799 90.0861 238.079 91.0382 237.672 92.1338C237.264 93.2293 237.188 94.4201 237.452 95.5586C237.716 96.6971 238.308 97.7333 239.155 98.5388C240.003 99.3443 241.068 99.8837 242.22 100.09C243.371 100.297 244.558 100.161 245.633 99.7003C246.708 99.2396 247.624 98.4739 248.268 97.4981C248.911 96.5223 249.254 95.3793 249.254 94.2108C249.256 93.401 249.093 92.5992 248.775 91.8546C248.456 91.1099 247.989 90.4379 247.402 89.8798C246.815 89.3216 246.119 88.889 245.359 88.6083C244.599 88.3277 243.789 88.2049 242.98 88.2475ZM246.465 92.7744L242.814 96.4219L242.221 97.0052C242.194 97.0339 242.161 97.0568 242.124 97.0723C242.087 97.0879 242.048 97.096 242.008 97.096C241.968 97.096 241.929 97.0879 241.892 97.0723C241.855 97.0568 241.822 97.0339 241.794 97.0052L239.877 94.9594C239.823 94.9015 239.793 94.8253 239.793 94.7461C239.793 94.667 239.823 94.5908 239.877 94.5329L240.435 93.9409C240.462 93.9124 240.494 93.8898 240.53 93.8743C240.566 93.8588 240.605 93.8508 240.644 93.8508C240.683 93.8508 240.722 93.8588 240.758 93.8743C240.794 93.8898 240.826 93.9124 240.853 93.9409L242.004 95.1422L245.359 91.721C245.422 91.6603 245.506 91.6265 245.594 91.6265C245.682 91.6265 245.766 91.6603 245.829 91.721L246.465 92.3391C246.494 92.3708 246.517 92.4081 246.532 92.4486C246.546 92.4892 246.552 92.5323 246.55 92.5753C246.547 92.6183 246.536 92.6604 246.517 92.6991C246.498 92.7378 246.472 92.7722 246.439 92.8005L246.465 92.7744Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#3D65E9')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'fill-rule', 'evenodd'),
								A2($elm$html$Html$Attributes$attribute, 'clip-rule', 'evenodd'),
								A2($elm$html$Html$Attributes$attribute, 'd', 'M229.968 113.989L220.199 111.238L210.422 113.989V125.507L220.164 128.231V128.249L220.199 128.24L220.225 128.249V128.231L229.968 125.507V113.989Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'white'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', '#3F5BE8'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-linejoin', 'round')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'fill-rule', 'evenodd'),
								A2($elm$html$Html$Attributes$attribute, 'clip-rule', 'evenodd'),
								A2($elm$html$Html$Attributes$attribute, 'd', 'M229.968 113.989L220.199 116.723L210.422 113.989V125.507L220.164 128.231V128.249L220.199 128.24L220.225 128.249V128.231L229.968 125.507V113.989Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'white'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', '#3F5BE8'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-linejoin', 'round')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M220.199 116.723V128.249'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', '#3F5BE8'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-linejoin', 'round')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M242.978 113.771C241.808 113.828 240.68 114.226 239.734 114.917C238.787 115.607 238.065 116.56 237.656 117.658C237.247 118.755 237.169 119.947 237.432 121.088C237.695 122.229 238.288 123.268 239.136 124.075C239.985 124.883 241.052 125.424 242.205 125.631C243.359 125.839 244.547 125.703 245.625 125.242C246.702 124.781 247.62 124.014 248.265 123.037C248.91 122.059 249.253 120.914 249.253 119.743C249.255 118.933 249.092 118.131 248.774 117.386C248.455 116.641 247.988 115.968 247.401 115.41C246.814 114.851 246.119 114.417 245.359 114.136C244.598 113.854 243.788 113.73 242.978 113.771ZM246.464 118.307L242.813 121.946L242.22 122.538C242.193 122.568 242.16 122.592 242.124 122.608C242.087 122.624 242.047 122.633 242.007 122.633C241.967 122.633 241.927 122.624 241.89 122.608C241.853 122.592 241.82 122.568 241.793 122.538L239.876 120.501C239.822 120.443 239.792 120.367 239.792 120.287C239.792 120.208 239.822 120.132 239.876 120.074L240.434 119.482C240.461 119.454 240.493 119.431 240.529 119.416C240.565 119.4 240.604 119.392 240.643 119.392C240.682 119.392 240.721 119.4 240.757 119.416C240.793 119.431 240.825 119.454 240.852 119.482L242.002 120.684L245.357 117.254C245.422 117.195 245.506 117.162 245.593 117.162C245.68 117.162 245.764 117.195 245.828 117.254L246.464 117.872C246.515 117.934 246.541 118.014 246.536 118.094C246.531 118.175 246.496 118.251 246.438 118.307H246.464Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#3D65E9')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'fill-rule', 'evenodd'),
								A2($elm$html$Html$Attributes$attribute, 'clip-rule', 'evenodd'),
								A2($elm$html$Html$Attributes$attribute, 'd', 'M229.968 139.48L220.199 136.737L210.422 139.48V150.997L220.164 153.722V153.739L220.199 153.73L220.225 153.739V153.722L229.968 150.997V139.48Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'white'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', '#3F5BE8'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-linejoin', 'round')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'fill-rule', 'evenodd'),
								A2($elm$html$Html$Attributes$attribute, 'clip-rule', 'evenodd'),
								A2($elm$html$Html$Attributes$attribute, 'd', 'M229.968 139.479L220.199 142.213L210.422 139.479V150.996L220.164 153.721V153.739L220.199 153.73L220.225 153.739V153.721L229.968 150.996V139.479Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'white'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', '#3F5BE8'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-linejoin', 'round')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M220.199 142.212V153.738'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', '#3F5BE8'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-linejoin', 'round')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'opacity', '0.2'),
								A2($elm$html$Html$Attributes$attribute, 'd', 'M243.065 139.27C241.897 139.328 240.771 139.727 239.828 140.418C238.884 141.109 238.165 142.061 237.757 143.156C237.35 144.252 237.274 145.443 237.538 146.581C237.801 147.72 238.394 148.756 239.241 149.561C240.089 150.367 241.154 150.906 242.306 151.113C243.457 151.319 244.644 151.184 245.719 150.723C246.794 150.262 247.71 149.496 248.353 148.521C248.997 147.545 249.34 146.402 249.34 145.233C249.343 144.423 249.181 143.621 248.863 142.875C248.545 142.13 248.078 141.458 247.49 140.899C246.903 140.341 246.207 139.908 245.446 139.628C244.685 139.348 243.875 139.226 243.065 139.27ZM246.508 147.053C246.54 147.084 246.566 147.122 246.584 147.164C246.602 147.206 246.611 147.251 246.611 147.296C246.611 147.342 246.602 147.387 246.584 147.429C246.566 147.471 246.54 147.509 246.508 147.54L245.767 148.28C245.702 148.344 245.614 148.38 245.523 148.38C245.432 148.38 245.344 148.344 245.279 148.28L243.449 146.461L241.645 148.315C241.58 148.379 241.492 148.414 241.401 148.414C241.31 148.414 241.222 148.379 241.157 148.315L240.416 147.575C240.384 147.543 240.358 147.505 240.34 147.464C240.322 147.422 240.313 147.377 240.313 147.331C240.313 147.286 240.322 147.241 240.34 147.199C240.358 147.157 240.384 147.119 240.416 147.087L242.238 145.268L240.416 143.457C240.384 143.426 240.358 143.388 240.34 143.346C240.322 143.304 240.313 143.259 240.313 143.214C240.313 143.168 240.322 143.123 240.34 143.081C240.358 143.039 240.384 143.001 240.416 142.97L241.157 142.23C241.189 142.197 241.227 142.171 241.269 142.154C241.311 142.136 241.356 142.127 241.401 142.127C241.447 142.127 241.492 142.136 241.534 142.154C241.575 142.171 241.613 142.197 241.645 142.23L243.466 144.041L245.279 142.221C245.311 142.188 245.349 142.163 245.39 142.145C245.432 142.127 245.477 142.118 245.523 142.118C245.568 142.118 245.613 142.127 245.655 142.145C245.697 142.163 245.735 142.188 245.767 142.221L246.508 142.961C246.54 142.993 246.566 143.031 246.584 143.072C246.602 143.114 246.611 143.159 246.611 143.205C246.611 143.25 246.602 143.295 246.584 143.337C246.566 143.379 246.54 143.417 246.508 143.449L244.686 145.259L246.508 147.053Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#3D65E9')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M260.912 88.4819V151.214'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', '#3F5BE8'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-miterlimit', '10')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'opacity', '0.2'),
								A2($elm$html$Html$Attributes$attribute, 'd', 'M339.418 93.1392H275.804C275.12 93.1392 274.566 93.6926 274.566 94.3753V94.384C274.566 95.0668 275.12 95.6202 275.804 95.6202H339.418C340.102 95.6202 340.656 95.0668 340.656 94.384V94.3753C340.656 93.6926 340.102 93.1392 339.418 93.1392Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#3D65E9')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M309.162 93.1392H275.804C275.12 93.1392 274.566 93.6926 274.566 94.3753V94.384C274.566 95.0668 275.12 95.6202 275.804 95.6202H309.162C309.846 95.6202 310.4 95.0668 310.4 94.384V94.3753C310.4 93.6926 309.846 93.1392 309.162 93.1392Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#3D65E9')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M309.651 97.0315C311.119 97.0315 312.309 95.8428 312.309 94.3764C312.309 92.91 311.119 91.7212 309.651 91.7212C308.183 91.7212 306.993 92.91 306.993 94.3764C306.993 95.8428 308.183 97.0315 309.651 97.0315Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#3D65E9')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'opacity', '0.2'),
								A2($elm$html$Html$Attributes$attribute, 'd', 'M339.418 105.85H275.804C275.12 105.85 274.566 106.404 274.566 107.086V107.095C274.566 107.778 275.12 108.331 275.804 108.331H339.418C340.102 108.331 340.656 107.778 340.656 107.095V107.086C340.656 106.404 340.102 105.85 339.418 105.85Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#3D65E9')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M315.088 105.85H275.804C275.12 105.85 274.566 106.404 274.566 107.086V107.095C274.566 107.778 275.12 108.331 275.804 108.331H315.088C315.771 108.331 316.325 107.778 316.325 107.095V107.086C316.325 106.404 315.771 105.85 315.088 105.85Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#3D65E9')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M316.064 109.75C317.532 109.75 318.722 108.562 318.722 107.095C318.722 105.629 317.532 104.44 316.064 104.44C314.596 104.44 313.406 105.629 313.406 107.095C313.406 108.562 314.596 109.75 316.064 109.75Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#3D65E9')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'opacity', '0.2'),
								A2($elm$html$Html$Attributes$attribute, 'd', 'M339.418 118.568H275.804C275.12 118.568 274.566 119.122 274.566 119.805V119.813C274.566 120.496 275.12 121.049 275.804 121.049H339.418C340.102 121.049 340.656 120.496 340.656 119.813V119.805C340.656 119.122 340.102 118.568 339.418 118.568Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#3D65E9')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M326.138 118.568H275.804C275.12 118.568 274.566 119.122 274.566 119.805V119.813C274.566 120.496 275.12 121.049 275.804 121.049H326.138C326.821 121.049 327.375 120.496 327.375 119.813V119.805C327.375 119.122 326.821 118.568 326.138 118.568Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#3D65E9')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M326.896 122.46C328.364 122.46 329.554 121.271 329.554 119.805C329.554 118.338 328.364 117.149 326.896 117.149C325.428 117.149 324.238 118.338 324.238 119.805C324.238 121.271 325.428 122.46 326.896 122.46Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#3D65E9')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'opacity', '0.2'),
								A2($elm$html$Html$Attributes$attribute, 'd', 'M339.418 131.279H275.804C275.12 131.279 274.566 131.832 274.566 132.515V132.524C274.566 133.206 275.12 133.76 275.804 133.76H339.418C340.102 133.76 340.656 133.206 340.656 132.524V132.515C340.656 131.832 340.102 131.279 339.418 131.279Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#3D65E9')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M305.441 131.279H275.804C275.12 131.279 274.566 131.832 274.566 132.515V132.524C274.566 133.206 275.12 133.76 275.804 133.76H305.441C306.125 133.76 306.679 133.206 306.679 132.524V132.515C306.679 131.832 306.125 131.279 305.441 131.279Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#3D65E9')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M306.149 135.179C307.617 135.179 308.807 133.99 308.807 132.523C308.807 131.057 307.617 129.868 306.149 129.868C304.681 129.868 303.491 131.057 303.491 132.523C303.491 133.99 304.681 135.179 306.149 135.179Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#3D65E9')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'opacity', '0.2'),
								A2($elm$html$Html$Attributes$attribute, 'd', 'M339.418 143.997H275.804C275.12 143.997 274.566 144.551 274.566 145.233V145.242C274.566 145.925 275.12 146.478 275.804 146.478H339.418C340.102 146.478 340.656 145.925 340.656 145.242V145.233C340.656 144.551 340.102 143.997 339.418 143.997Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#3D65E9')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M294.208 143.997H275.804C275.12 143.997 274.566 144.551 274.566 145.233V145.242C274.566 145.925 275.12 146.478 275.804 146.478H294.208C294.892 146.478 295.446 145.925 295.446 145.242V145.233C295.446 144.551 294.892 143.997 294.208 143.997Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#3D65E9')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M294.68 147.888C296.148 147.888 297.338 146.7 297.338 145.233C297.338 143.767 296.148 142.578 294.68 142.578C293.212 142.578 292.022 143.767 292.022 145.233C292.022 146.7 293.212 147.888 294.68 147.888Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#3D65E9')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M351.262 190.65C364.945 190.65 376.037 179.569 376.037 165.901C376.037 152.232 364.945 141.151 351.262 141.151C337.579 141.151 326.487 152.232 326.487 165.901C326.487 179.569 337.579 190.65 351.262 190.65Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#CCDDFF')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M346.365 185.322C341.548 185.329 336.836 183.908 332.828 181.24C328.819 178.571 325.693 174.774 323.845 170.33C321.997 165.885 321.51 160.993 322.447 156.272C323.383 151.552 325.7 147.214 329.104 143.81C332.509 140.405 336.848 138.085 341.573 137.145C346.297 136.205 351.195 136.686 355.646 138.527C360.096 140.368 363.9 143.487 366.576 147.489C369.252 151.491 370.68 156.196 370.678 161.008C370.662 167.447 368.096 173.618 363.541 178.174C358.985 182.73 352.811 185.299 346.365 185.322Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'white')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M346.364 137.12C351.094 137.118 355.718 138.518 359.652 141.142C363.585 143.765 366.651 147.496 368.462 151.86C370.274 156.225 370.748 161.028 369.827 165.663C368.905 170.297 366.628 174.554 363.285 177.896C359.941 181.238 355.68 183.514 351.041 184.436C346.403 185.358 341.594 184.886 337.224 183.078C332.855 181.27 329.12 178.209 326.492 174.28C323.864 170.352 322.461 165.733 322.461 161.008C322.466 154.675 324.985 148.603 329.467 144.125C333.948 139.646 340.025 137.127 346.364 137.12ZM346.364 136.25C341.462 136.248 336.67 137.698 332.593 140.418C328.516 143.137 325.338 147.003 323.461 151.527C321.584 156.051 321.092 161.029 322.047 165.833C323.003 170.636 325.362 175.048 328.828 178.512C332.294 181.975 336.71 184.334 341.518 185.29C346.325 186.246 351.309 185.756 355.838 183.882C360.367 182.009 364.238 178.835 366.962 174.764C369.685 170.692 371.139 165.905 371.139 161.008C371.14 157.757 370.5 154.538 369.256 151.534C368.011 148.53 366.187 145.801 363.886 143.502C361.585 141.202 358.854 139.379 355.847 138.134C352.841 136.89 349.619 136.25 346.364 136.25Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#3F5BE8')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M346.365 146.644C348.078 146.644 349.753 147.151 351.178 148.102C352.602 149.053 353.712 150.404 354.368 151.986C355.023 153.567 355.195 155.307 354.861 156.985C354.526 158.664 353.702 160.206 352.49 161.416C351.279 162.626 349.735 163.45 348.055 163.784C346.375 164.118 344.633 163.947 343.05 163.292C341.468 162.637 340.115 161.528 339.163 160.105C338.211 158.682 337.703 157.009 337.703 155.297C337.703 153.002 338.616 150.801 340.24 149.178C341.865 147.556 344.068 146.644 346.365 146.644ZM346.365 145.773C344.477 145.766 342.63 146.32 341.057 147.363C339.485 148.406 338.257 149.892 337.531 151.632C336.805 153.373 336.612 155.29 336.977 157.14C337.342 158.99 338.249 160.69 339.583 162.025C340.917 163.36 342.617 164.269 344.468 164.637C346.32 165.006 348.239 164.817 349.983 164.094C351.726 163.372 353.216 162.148 354.263 160.579C355.31 159.01 355.867 157.165 355.864 155.28C355.864 152.755 354.861 150.334 353.075 148.548C351.289 146.763 348.866 145.758 346.339 145.756L346.365 145.773Z'),
								A2($elm$html$Html$Attributes$attribute, 'fill', '#3F5BE8')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M330.087 179.655C331.788 176.865 334.178 174.558 337.029 172.958C339.88 171.358 343.095 170.517 346.365 170.517C349.635 170.517 352.85 171.358 355.701 172.958C358.552 174.558 360.943 176.865 362.643 179.655'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', '#3F5BE8'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-miterlimit', '10')
							]),
						_List_Nil)
					])
			};
		case 67:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M56,.5H7.9C2.3.5.3,5,.3,8.1v45.6c0,4.1,2.5,6.3,5.1,7.2v.4c0,1.4,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5h0s43.1,0,43.1,0h0c0,1.4,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5v-.4c3.7-1.1,5.1-4.7,5.1-7.2V8.1c0-5.5-4.5-7.6-7.6-7.6ZM58.6,53.6c0,1.2-.5,2.6-2.6,2.6H7.9c-1.2,0-2.6-.5-2.6-2.6V8.1c0-1.2.5-2.6,2.6-2.6h48.1c1.2,0,2.6.5,2.6,2.6v45.6Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M48.4,8.1H15.5c-4.2,0-7.6,3.4-7.6,7.6v30.4c0,4.2,3.4,7.6,7.6,7.6h32.9c4.2,0,7.6-3.4,7.6-7.6V15.7c0-4.2-3.4-7.6-7.6-7.6ZM51,46c0,1.4-1.2,2.6-2.6,2.6H15.5c-1.4,0-2.6-1.2-2.6-2.6v-2.5h.8c.9,0,1.6-.7,1.6-1.6v-4.4c0-.9-.7-1.6-1.6-1.6h-.8v-10.1h.8c.9,0,1.6-.7,1.6-1.6v-4.4c0-.9-.7-1.6-1.6-1.6h-.8v-2.5c0-1.4,1.2-2.6,2.6-2.6h32.9c1.4,0,2.6,1.2,2.6,2.6v30.4Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M44.6,28.4h-2.9c-.2-.6-.4-1.2-.7-1.7l2.1-2.1c1-1,1-2.6,0-3.5-1-1-2.6-1-3.5,0l-2.1,2.1c-.5-.3-1.1-.5-1.7-.7v-2.9c0-1.4-1.1-2.5-2.5-2.5s-2.5,1.1-2.5,2.5v2.9c-.6.2-1.2.4-1.7.7l-2.1-2.1c-1-1-2.6-1-3.5,0-1,1-1,2.6,0,3.5l2.1,2.1c-.3.5-.5,1.1-.7,1.7h-2.9c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5h2.9c.2.6.4,1.2.7,1.7l-2.1,2.1c-1,1-1,2.6,0,3.5.5.5,1.1.7,1.8.7s1.3-.2,1.8-.7l2.1-2.1c.5.3,1.1.5,1.7.7v2.9c0,1.4,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5v-2.9c.6-.2,1.2-.4,1.7-.7l2.1,2.1c.5.5,1.1.7,1.8.7s1.3-.2,1.8-.7c1-1,1-2.6,0-3.5l-2.1-2.1c.3-.5.5-1.1.7-1.7h2.9c1.4,0,2.5-1.1,2.5-2.5s-1.1-2.5-2.5-2.5ZM29.4,30.9c0-2.1,1.7-3.8,3.8-3.8s3.8,1.7,3.8,3.8-1.7,3.8-3.8,3.8-3.8-1.7-3.8-3.8Z')
							]),
						_List_Nil)
					])
			};
		case 68:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_2'),
						A2($elm$html$Html$Attributes$attribute, 'data-name', 'Layer 2'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 62.94 52.04')
					]),
				N: _List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'g',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1-2'),
								A2($elm$html$Html$Attributes$attribute, 'data-name', 'Layer 1')
							]),
						_List_fromArray(
							[
								A3(
								$elm$svg$Svg$node,
								'path',
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'd', 'M62.9,25.71s-.01-.03-.01-.05c-.02-.08-.04-.16-.07-.23,0,0,0,0,0-.01l-8.61-19.69h1.79c.83,0,1.5-.67,1.5-1.5s-.67-1.5-1.5-1.5h-19.73c-.98-1.63-2.76-2.72-4.79-2.72s-3.81,1.1-4.79,2.72H6.95c-.83,0-1.5.67-1.5,1.5s.67,1.5,1.5,1.5h1.79L.13,25.41s0,0,0,0c-.08.18-.13.39-.13.6,0,6.09,4.95,11.04,11.04,11.04s11.04-4.95,11.04-11.04c0-.32-.1-.61-.27-.85L13.33,5.72h12.56c.06,2.5,1.77,4.59,4.08,5.24v38.08h-6.45c-.83,0-1.5.67-1.5,1.5s.67,1.5,1.5,1.5h15.83c.83,0,1.5-.67,1.5-1.5s-.67-1.5-1.5-1.5h-6.38V10.96c2.31-.65,4.02-2.74,4.08-5.24h12.56l-8.48,19.44c-.17.25-.27.54-.27.85,0,2.95,1.15,5.72,3.24,7.8,2.08,2.08,4.85,3.23,7.8,3.23h0c6.08,0,11.03-4.95,11.03-11.03,0-.11-.01-.21-.04-.31ZM11.03,7.97l7.21,16.55H3.79L11.03,7.97ZM11.04,34.05c-3.92,0-7.19-2.82-7.9-6.54h15.79c-.7,3.72-3.98,6.54-7.9,6.54ZM31.47,8.17c-1.43,0-2.59-1.16-2.59-2.59s1.16-2.59,2.59-2.59,2.59,1.16,2.59,2.59-1.16,2.59-2.59,2.59ZM59.14,24.52h-14.45l7.21-16.55,7.24,16.55ZM51.9,34.05h0c-2.14,0-4.16-.83-5.68-2.35-1.16-1.16-1.92-2.61-2.22-4.18h15.79c-.71,3.71-3.98,6.53-7.89,6.53Z')
									]),
								_List_Nil)
							]))
					])
			};
		case 69:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 20 20'),
						A2($elm$html$Html$Attributes$attribute, 'style', 'vertical-align: '),
						A2($elm$html$Html$Attributes$attribute, 'width', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'height', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'fill', 'rgba(0%,0%,0%,1)')
					]),
				N: _List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M10 5a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7 7 7 0 00-7-7zM15.85 15.85l2.44 2.44z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M14.88 13.66a.51.51 0 00-.34.14l-.74.74a.46.46 0 000 .67l4.2 4.16a.47.47 0 00.33.14.49.49 0 00.34-.14l.74-.74a.46.46 0 000-.67l-4.2-4.16a.47.47 0 00-.33-.14z')
							]),
						_List_Nil)
					])
			};
		case 70:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M56.6,39.8c-1.7-.9-3.7-1.3-5.7-1.3h0c-4,0-7.6,1.8-10,4.9l-15.9-8c.6-2.2.6-4.5,0-6.6l15.9-8c2.4,3.1,6,4.9,10,4.9,0,0,0,0,0,0h0c3.4,0,6.6-1.3,8.9-3.7,2.4-2.4,3.7-5.6,3.7-9,0-7-5.7-12.7-12.7-12.7h0c-7,0-12.7,5.7-12.7,12.7,0,1.1.2,2.3.5,3.4l-15.9,8c-1.5-2-3.6-3.4-6-4.2-3.2-1.1-6.6-.8-9.7.7C1,23.8-1.6,31.4,1.5,37.7c1.5,3,4.1,5.3,7.3,6.4,1.3.4,2.7.7,4,.7,1.9,0,3.9-.5,5.6-1.3,1.7-.8,3.2-2.1,4.3-3.5l15.9,8c-1.5,5.7,1.1,11.9,6.6,14.6,1.8.9,3.7,1.3,5.6,1.3s2.7-.2,4-.7c3.2-1.1,5.8-3.3,7.3-6.4,1.5-3,1.8-6.5.7-9.7-1.1-3.2-3.3-5.8-6.4-7.3ZM51,5.3h0c4.2,0,7.7,3.5,7.7,7.7,0,2.1-.8,4-2.3,5.4-1.5,1.4-3.4,2.2-5.4,2.2s0,0,0,0c-2.9,0-5.5-1.6-6.8-4.2,0,0,0,0,0,0-.5-1.1-.8-2.3-.8-3.5,0-4.2,3.5-7.7,7.7-7.7ZM16.3,38.9c-1.8.9-3.9,1.1-5.8.4-1.9-.6-3.5-2-4.4-3.8-1.9-3.8-.3-8.4,3.4-10.3,1.8-.9,3.9-1.1,5.8-.4,1.9.6,3.5,2,4.4,3.8,0,0,0,0,0,0,0,0,0,0,0,0,1.1,2.1,1.1,4.7,0,6.8,0,0,0,0,0,0,0,0,0,0,0,0-.7,1.5-2,2.7-3.4,3.4ZM57.8,54.5c-.9,1.8-2.5,3.2-4.4,3.8-1.9.6-4,.5-5.8-.4-3.8-1.9-5.3-6.5-3.4-10.3,0,0,0,0,0,0,1.3-2.6,3.9-4.2,6.8-4.2h0c1.2,0,2.4.3,3.4.8,1.8.9,3.2,2.5,3.8,4.4s.5,4-.4,5.8Z')
							]),
						_List_Nil)
					])
			};
		case 71:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M30.6,43.9c-.7,0-1.3-.3-1.8-.7l-11.6-11.6c-1-1-1-2.6,0-3.5,1-1,2.6-1,3.5,0l9.5,9.5,13.6-19.7c.8-1.1,2.3-1.4,3.5-.6,1.1.8,1.4,2.3.6,3.5l-15.3,22.2c-.4.6-1.1,1-1.8,1.1,0,0-.2,0-.2,0Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M32,63.7c-1.3,0-2.5-.2-3.7-.7l-2.7-1.1c-12.9-5-21.5-17.7-21.5-31.5V11.1c0-2.5,1.4-4.8,3.7-5.8C15.5,1.8,23.6.2,32,.2c8.4,0,16.5,1.6,24.1,5,2.3,1.1,3.8,3.4,3.8,5.9v19.4c0,13.8-8.6,26.5-21.5,31.5l-2.7,1.1c-1.2.5-2.5.7-3.7.7ZM31.5,5.2c-7.5,0-14.8,1.5-21.7,4.5-.5.2-.8.7-.8,1.3h0v19.4c0,11.8,7.3,22.5,18.3,26.8l2.7,1.1c1.2.5,2.6.5,3.8,0l2.7-1.1c11-4.3,18.3-15,18.3-26.8V11.1c0-.6-.3-1.1-.8-1.3-7-3.1-14.4-4.6-22.1-4.5-.2,0-.3,0-.5,0Z')
							]),
						_List_Nil)
					])
			};
		case 72:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'width', '36'),
						A2($elm$html$Html$Attributes$attribute, 'height', '36'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 36 36'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1')
					]),
				N: _List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M4.523148 1.0830959999999998C3.5614079999999997 1.1856959999999999 2.7488159999999997 1.5644879999999999 2.103624 2.21094C1.580328 2.735244 1.316808 3.2182199999999996 1.139544 3.9779999999999998L1.0639439999999998 4.302 1.052208 17.639999999999997C1.044108 26.863235999999997 1.052316 31.102307999999997 1.0787399999999998 31.380947999999997C1.1780279999999999 32.426928 1.5359399999999999 33.222311999999995 2.21094 33.896843999999994C2.750256 34.435836 3.27744 34.7148 4.056264 34.873307999999994C4.358663999999999 34.934867999999994 5.026859999999999 34.937999999999995 17.91 34.937999999999995C30.528575999999997 34.937999999999995 31.467995999999996 34.933824 31.770575999999995 34.876476C32.672232 34.705476 33.392303999999996 34.3287 33.962543999999994 33.729479999999995C34.44714 33.220259999999996 34.72398 32.677416 34.873307999999994 31.943735999999998C34.934867999999994 31.641336 34.937999999999995 30.973139999999997 34.937999999999995 18.09C34.937999999999995 5.471424 34.933824 4.532004 34.876476 4.229424C34.705692 3.328848 34.328627999999995 2.6076239999999995 33.73146 2.039328C33.23628 1.568088 32.740668 1.3072319999999997 32.022 1.139544L31.697999999999997 1.0639079999999999 18.252 1.058436C10.856699999999998 1.055412 4.678704 1.0665 4.523148 1.0830959999999998M4.5 3.127572C3.7662479999999996 3.2942159999999996 3.3386759999999995 3.662352 3.135996 4.302C3.084444 4.464684 3.078 5.765508 3.069036 17.82C3.057984 32.695848 3.0367079999999995 31.438943999999996 3.30966 32.022C3.5105039999999996 32.450976 3.8206799999999994 32.71374 4.302 32.862671999999996C4.4555039999999995 32.910156 4.856832 32.9202 7.028999999999999 32.930748L9.575999999999999 32.94316799999999 9.575999999999999 18.001583999999998L9.575999999999999 3.0599999999999996 7.172999999999999 3.063132C5.046696 3.0659039999999997 4.7388959999999996 3.07332 4.5 3.127572M11.556 17.999568L11.556 32.94 21.375 32.939064C30.773556 32.9382 31.206527999999995 32.93532 31.486463999999998 32.871995999999996C32.240232 32.701464 32.659164 32.344415999999995 32.864004 31.697999999999997C32.915555999999995 31.535351999999996 32.92218 30.233231999999997 32.932511999999996 18.198C32.945364 3.3013439999999994 32.96721599999999 4.577436 32.689116 3.9779999999999998C32.490612 3.5501399999999994 32.184216 3.28986 31.697999999999997 3.136104C31.535999999999998 3.084876 30.519108 3.0781799999999997 21.537 3.069144L11.556 3.0591359999999996 11.556 17.999568M24.059952 10.724435999999999C23.997239999999998 10.740528 23.87574 10.795464 23.789952 10.846476C23.551704 10.98828 17.1981 17.368344 17.096328 17.567999999999998C16.979723999999997 17.796852 16.979723999999997 18.203148 17.096328 18.432C17.21592 18.666684 23.594112 25.048872 23.847588 25.187507999999998C23.998355999999998 25.269947999999996 24.073704 25.287119999999998 24.281999999999996 25.286579999999997C24.692867999999997 25.285428 25.015643999999998 25.088435999999998 25.206875999999998 24.722027999999998C25.32024 24.504803999999996 25.318763999999998 24.094008 25.203815999999996 23.868C25.145856 23.75406 24.27588 22.85946 22.271904 20.853108L19.422396 18.000215999999998 22.271724 15.147107999999998C24.271236 13.144967999999999 25.145675999999998 12.245688 25.203636 12.132C25.318799999999996 11.9061 25.320347999999996 11.495375999999998 25.206875999999998 11.277971999999998C25.106652 11.085947999999998 24.915419999999997 10.893564 24.731495999999996 10.799748C24.571476 10.7181 24.232644 10.68012 24.059952 10.724435999999999'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', 'none'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'currentColor'),
								A2($elm$html$Html$Attributes$attribute, 'fill-rule', 'evenodd'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-width', '0.036')
							]),
						_List_Nil)
					])
			};
		case 73:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M35.8,47.3c-1.4,0-2.5,1.1-2.5,2.5v8.9s-28,0-28,0V5.3s28,0,28,0v8.9c0,1.4,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5V5.3c0-2.8-2.3-5-5-5H5.3C2.5.3.2,2.5.2,5.3v53.4c0,2.8,2.3,5,5,5h28c2.8,0,5-2.3,5-5v-8.9c0-1.4-1.1-2.5-2.5-2.5Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M63.5,33c0,0,0-.2,0-.2,0,0,0-.1,0-.2,0-.2,0-.3,0-.5,0,0,0,0,0,0h0c0-.2,0-.3,0-.5,0,0,0-.1,0-.2,0,0,0-.2,0-.2,0,0,0-.2-.1-.2,0,0,0-.1,0-.2,0-.1-.2-.3-.3-.4l-12.7-12.7c-1-1-2.6-1-3.5,0-1,1-1,2.6,0,3.5l8.4,8.4H12.9c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5h42.3l-8.4,8.4c-1,1-1,2.6,0,3.5s1.1.7,1.8.7,1.3-.2,1.8-.7l12.7-12.7c.1-.1.2-.2.3-.4,0,0,0-.1,0-.2,0,0,0-.2.1-.3Z')
							]),
						_List_Nil)
					])
			};
		case 74:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 71 71'),
						A2($elm$html$Html$Attributes$attribute, 'style', 'vertical-align: '),
						A2($elm$html$Html$Attributes$attribute, 'width', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'height', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'fill', 'rgba(0%,0%,0%,1)')
					]),
				N: _List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M22.4,56.4c-2.2-7.3-8.8-8.1-8.8-8.1l0,0c-0.2,0-0.3-0.1-0.5-0.1C11,48.4,9,49.3,7.5,50.8c-3.1,3.1-6.9,16.5-7.3,18 c-0.1,0.5,0,1.1,0.4,1.5c0.3,0.3,0.7,0.4,1.1,0.4c0.1,0,0.3,0,0.4-0.1c1.5-0.4,14.9-4.3,18-7.3c0.8-0.8,1.5-1.8,1.9-2.9 c0.4-1.1,0.7-2.2,0.7-3.4C22.6,56.8,22.5,56.6,22.4,56.4z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M70.4,0.4C70,0.1,69.6-0.1,69.1,0l-7.1,0.8c-5.9,0.7-11.4,3.3-15.5,7.5L27.2,27.6L24,26.5c-3.7-1.2-7.7-1.4-11.5-0.5 c-3.8,0.9-7.3,2.9-10.1,5.6l-0.8,0.8c-0.5,0.5-0.8,1.1-1,1.7s-0.2,1.3,0,2c0.2,0.7,0.5,1.3,0.9,1.8c0.5,0.5,1,0.9,1.7,1.1l11.5,3.8 L28,56.1l3.8,11.5c0.2,0.6,0.6,1.2,1.1,1.7c0.5,0.5,1.1,0.8,1.8,0.9c0.3,0.1,0.6,0.1,0.9,0.1c0.4,0,0.7,0,1.1-0.2 c0.6-0.2,1.2-0.5,1.7-1l0.8-0.8c2.8-2.8,4.7-6.3,5.6-10.1c0.9-3.8,0.7-7.8-0.5-11.5l-1.1-3.2l19.3-19.3c4.2-4.2,6.8-9.7,7.5-15.6 l0.8-7.1C70.9,1.2,70.7,0.7,70.4,0.4z M56.1,20.8c-3.4,0-6.1-2.7-6.1-6.1s2.7-6.1,6.1-6.1s6.1,2.7,6.1,6.1S59.5,20.8,56.1,20.8z')
							]),
						_List_Nil)
					])
			};
		case 75:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 512 512'),
						A2($elm$html$Html$Attributes$attribute, 'style', 'vertical-align: '),
						A2($elm$html$Html$Attributes$attribute, 'width', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'height', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'fill', 'rgba(0%,0%,0%,1)')
					]),
				N: _List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z')
							]),
						_List_Nil)
					])
			};
		case 76:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M31.9,53.2c-11.7,0-21.2-9.5-21.2-21.2S20.2,10.7,31.9,10.7s21.2,9.5,21.2,21.2-9.5,21.2-21.2,21.2ZM31.9,15.7c-9,0-16.2,7.3-16.2,16.2s7.3,16.2,16.2,16.2,16.2-7.3,16.2-16.2-7.3-16.2-16.2-16.2Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M31.9,63.9c-1.4,0-2.5-1.1-2.5-2.5v-5.4c0-1.4,1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5v5.4c0,1.4-1.1,2.5-2.5,2.5Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M61.4,34.5h-5.4c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5h5.4c1.4,0,2.5,1.1,2.5,2.5s-1.1,2.5-2.5,2.5Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M31.9,10.4c-1.4,0-2.5-1.1-2.5-2.5V2.5C29.4,1.1,30.5,0,31.9,0s2.5,1.1,2.5,2.5v5.4c0,1.4-1.1,2.5-2.5,2.5Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M7.8,34.5H2.4c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5h5.4c1.4,0,2.5,1.1,2.5,2.5s-1.1,2.5-2.5,2.5Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M11.1,55.3c-.6,0-1.3-.2-1.8-.7-1-1-1-2.6,0-3.5l3.8-3.8c1-1,2.6-1,3.5,0,1,1,1,2.6,0,3.5l-3.8,3.8c-.5.5-1.1.7-1.8.7Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M52.7,55.3c-.6,0-1.3-.2-1.8-.7l-3.8-3.8c-1-1-1-2.6,0-3.5,1-1,2.6-1,3.5,0l3.8,3.8c1,1,1,2.6,0,3.5-.5.5-1.1.7-1.8.7Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M48.9,17.4c-.6,0-1.3-.2-1.8-.7-1-1-1-2.6,0-3.5l3.8-3.8c1-1,2.6-1,3.5,0,1,1,1,2.6,0,3.5l-3.8,3.8c-.5.5-1.1.7-1.8.7Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M14.9,17.4c-.6,0-1.3-.2-1.8-.7l-3.8-3.8c-1-1-1-2.6,0-3.5,1-1,2.6-1,3.5,0l3.8,3.8c1,1,1,2.6,0,3.5-.5.5-1.1.7-1.8.7Z')
							]),
						_List_Nil)
					])
			};
		case 77:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 20 20'),
						A2($elm$html$Html$Attributes$attribute, 'style', 'vertical-align: '),
						A2($elm$html$Html$Attributes$attribute, 'width', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'height', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'fill', 'rgba(0%,0%,0%,1)')
					]),
				N: _List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M11 7H9a25.14 25.14 0 00-6-1H.69a.69.69 0 00-.69.69v.62A.69.69 0 00.69 8H1s0 3 1 4 3 1 4 1a3.19 3.19 0 003-3 1 1 0 011-1 1 1 0 011 1 3.19 3.19 0 003 3c1 0 3 0 4-1s1-4 1-4h.48a.52.52 0 00.52-.52v-1a.52.52 0 00-.52-.48H17a21.8 21.8 0 00-6 1z')
							]),
						_List_Nil)
					])
			};
		case 78:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M32.5,62.9c-16.8,0-30.4-13.6-30.4-30.4S15.8,2.1,32.5,2.1s30.4,13.6,30.4,30.4-13.6,30.4-30.4,30.4ZM32.5,6.1c-14.6,0-26.4,11.9-26.4,26.4s11.9,26.4,26.4,26.4,26.4-11.9,26.4-26.4S47.1,6.1,32.5,6.1Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M32.5,42.3c-1.1,0-2-.9-2-2v-1.1c0-1.4.4-2.8,1.2-3.9.8-1.2,1.8-2.1,3.1-2.6.9-.4,1.8-1.1,2.4-1.9.6-.8,1-1.8,1.1-2.9,0-1-.1-2.1-.6-3-.5-.9-1.2-1.7-2-2.3-.9-.6-1.9-.9-2.9-.9-1,0-2.1.2-3,.7-.9.5-1.7,1.2-2.2,2.1s-.8,1.9-.8,2.9-.9,2-2,2-2-.9-2-2c0-1.8.5-3.5,1.4-5,.9-1.5,2.2-2.7,3.7-3.6,1.5-.8,3.3-1.2,5-1.2,1.8,0,3.5.6,4.9,1.6,1.5,1,2.7,2.3,3.4,3.9.8,1.6,1.1,3.3,1,5.1-.1,1.8-.8,3.4-1.8,4.9-1,1.4-2.4,2.6-4,3.3-.6.2-1,.7-1.4,1.2-.3.5-.5,1.1-.5,1.7v1.1c0,1.1-.9,2-2,2Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M32.5,43.4c-1.5,0-2.6,1.2-2.6,2.6s1.2,2.6,2.6,2.6,2.6-1.2,2.6-2.6-1.2-2.6-2.6-2.6Z')
							]),
						_List_Nil)
					])
			};
		case 79:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 54.3 57.8'),
						A2($elm$html$Html$Attributes$attribute, 'style', 'vertical-align: '),
						A2($elm$html$Html$Attributes$attribute, 'width', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'height', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'fill', 'rgba(0%,0%,0%,1)')
					]),
				N: _List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M54.3 1.3h-.2C48.8-.3 43-.9 38.8 2.5l-.1-2V.3l-.2.1c-3.9 1.2-7.6 2.9-11.1 4.9-3.2 1.9-5.7 4.1-6.6 6.2l-.5-2.2v-.2l-.2.1c-3.4 2.8-6.6 5.9-9.5 9.2C8 21.5 6 24.6 5.9 27.1l-1.5-2.2-.1-.2-.1.2C.9 30.7 2 34.7 3.4 38.8l-2.6-.5-.5-.1.4.3c1.1.9 2 1.9 2.8 3.1.6 1.2.5 2.6-.3 3.7L0 51.7l.9 5.6.1.4.2-.4L6 47.5c.8-1.2 1.9-2.1 3.2-2.8 1.1-.4 2.3-.4 3.3 0l.5.2-.3-.4-1.2-1.4c4.7-.4 11.4-3.8 15-8.4l.1-.2h-.2l-2.1-.4c2.5-.8 5.7-3.1 9-5.9 3.6-3 7.3-6.6 10.3-9.5l.2-.2-.2-.1-1.6-.5c2.7-1 5.3-3.7 7.4-6.8 2-3 3.7-6.3 4.9-9.8zm-2.4 1.4c-2.8 5.9-5.8 11.6-13.5 14.7l-.3.1.3.1 2.1 1C33.6 24.1 28 30 19.8 34.6l-.3.2.3.1 2.8.8c-4.1 3.7-8.7 5.3-12.5 4.7C15.5 27 27.6 18.6 38.6 9.9l-.1-.2C24.6 15.2 13.6 27.5 6.3 38.5c-2.2-3.2-2.1-6-1.7-9.6l1.7 1.9.3.2.1-.3c1.9-8 6.9-11.9 12.7-17.6l1.2 2 .1.2.1-.2c2.5-5.6 9-9.3 16.3-11.9l-.2 2.2v.3l.2-.2 2.7-1.8c4.2-2.1 7.3-1.9 12.1-1z')
							]),
						_List_Nil)
					])
			};
		case 80:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_2'),
						A2($elm$html$Html$Attributes$attribute, 'data-name', 'Layer 2'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 63.01 63.01')
					]),
				N: _List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'g',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1-2'),
								A2($elm$html$Html$Attributes$attribute, 'data-name', 'Layer 1')
							]),
						_List_fromArray(
							[
								A3(
								$elm$svg$Svg$node,
								'path',
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'd', 'M17.74,63.01C7.96,63.01,0,55.06,0,45.28s7.96-17.74,17.74-17.74,17.74,7.96,17.74,17.74-7.96,17.74-17.74,17.74ZM17.74,31.54c-7.57,0-13.74,6.16-13.74,13.74s6.16,13.74,13.74,13.74,13.74-6.16,13.74-13.74-6.16-13.74-13.74-13.74Z')
									]),
								_List_Nil),
								A3(
								$elm$svg$Svg$node,
								'path',
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'd', 'M26.99,45.85s0-.02,0-.02c.07-.17.11-.35.11-.55s-.04-.38-.11-.55c0,0,0-.02,0-.02-.08-.19-.19-.35-.33-.49l-5.9-5.9c-.59-.59-1.54-.59-2.12,0s-.59,1.54,0,2.12l3.34,3.34h-12.12c-.83,0-1.5.67-1.5,1.5s.67,1.5,1.5,1.5h12.12l-3.34,3.34c-.59.59-.59,1.54,0,2.12.29.29.68.44,1.06.44s.77-.15,1.06-.44l5.9-5.9c.14-.14.25-.31.33-.49Z')
									]),
								_List_Nil),
								A3(
								$elm$svg$Svg$node,
								'path',
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'd', 'M57.08,55.15h-15.74c-1.1,0-2-.9-2-2s.9-2,2-2h15.74c1.07,0,1.93-.87,1.93-1.93V13.46c0-.52-.2-1-.57-1.37l-7.53-7.53c-.37-.36-.85-.57-1.37-.57h-27.88c-.52,0-1,.2-1.37.57-.36.36-.57.86-.57,1.37v15.53c0,1.1-.9,2-2,2s-2-.9-2-2V5.93c0-1.59.62-3.08,1.74-4.2,1.12-1.12,2.61-1.74,4.2-1.74h27.88c1.58,0,3.07.62,4.19,1.74l7.53,7.53c1.12,1.12,1.74,2.61,1.74,4.19v35.75c0,3.27-2.66,5.93-5.93,5.93Z')
									]),
								_List_Nil)
							]))
					])
			};
		case 81:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M61.2,10.4h-15.3v-5.1c0-2.8-2.3-5-5-5h-17.8c-2.8,0-5,2.3-5,5v5.1H2.8c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5h4.1l4.4,41.4c.4,3.9,3.6,6.8,7.5,6.8h26.4c3.9,0,7.1-2.9,7.5-6.8l4.4-41.4h4.1c1.4,0,2.5-1.1,2.5-2.5s-1.1-2.5-2.5-2.5ZM23.1,5.2h17.8v5.2h-17.8v-5.2ZM47.8,56.3c-.1,1.3-1.2,2.3-2.6,2.3h-26.4c-1.3,0-2.4-1-2.6-2.3L11.9,15.4h40.1l-4.3,40.9Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M32,53.4c-1.4,0-2.5-1.1-2.5-2.5v-26.6c0-1.4,1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5v26.6c0,1.4-1.1,2.5-2.5,2.5Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M42.2,53.4s0,0-.1,0c-1.4,0-2.4-1.2-2.4-2.6l1.3-26.6c0-1.4,1.2-2.4,2.6-2.4,1.4,0,2.4,1.2,2.4,2.6l-1.3,26.6c0,1.3-1.2,2.4-2.5,2.4Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M21.8,53.4c-1.3,0-2.4-1-2.5-2.4l-1.3-26.6c0-1.4,1-2.6,2.4-2.6,1.4,0,2.6,1,2.6,2.4l1.3,26.6c0,1.4-1,2.6-2.4,2.6,0,0,0,0-.1,0Z')
							]),
						_List_Nil)
					])
			};
		case 82:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '-1 -1 32 32'),
						A2($elm$html$Html$Attributes$attribute, 'style', 'vertical-align: '),
						A2($elm$html$Html$Attributes$attribute, 'width', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'height', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'fill', 'rgba(0%,0%,0%,1)')
					]),
				N: _List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M0.625 15a14.375 14.375 0 1 0 28.75 0 14.375 14.375 0 1 0 -28.75 0Z'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-linecap', 'round'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-linejoin', 'round'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-width', '2'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'none'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', '#000000')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M4.94875 25.27625a31.9875 31.9875 0 0 1 6.76625 -2.94c1.04625 -0.38625 1.1600000000000001 -2.78625 0.41000000000000003 -3.6112499999999996 -1.0825 -1.19125 -2 -2.5875 -2 -5.9575A4.765 4.765 0 0 1 15 7.55875a4.765 4.765 0 0 1 4.875 5.20875c0 3.375 -0.9175 4.76625 -2 5.9575 -0.75 0.8250000000000001 -0.63625 3.225 0.41000000000000003 3.6112499999999996a31.9875 31.9875 0 0 1 6.76625 2.94'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-linecap', 'round'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-linejoin', 'round'),
								A2($elm$html$Html$Attributes$attribute, 'stroke-width', '2'),
								A2($elm$html$Html$Attributes$attribute, 'fill', 'none'),
								A2($elm$html$Html$Attributes$attribute, 'stroke', '#000000')
							]),
						_List_Nil)
					])
			};
		case 83:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M59.3,63.9c-.1,0-.3,0-.4,0H5.1c-2.1.2-4-1.3-4.4-3.4-.2-1,0-2,.6-2.8L28.6,3.1c.8-1.5,2-2.4,3.4-2.4h0c1.4,0,2.7.9,3.4,2.4l27.3,54.5c.5.8.7,1.8.6,2.8-.2,1.1-.8,2-1.6,2.6-.7.5-1.5.8-2.4.8ZM58.5,60.4h0,0ZM6.3,58.8h51.4L32,7.4,6.3,58.8Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M32,45.1c-1.4,0-2.5-1.1-2.5-2.5v-18.9c0-1.4,1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5v18.9c0,1.4-1.1,2.5-2.5,2.5Z')
							]),
						_List_Nil),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M32.1,53c-1.8,0-3.2-1.3-3.3-3.1,0,0,0,0,0-.1,0-.8.3-1.6.9-2.2.6-.6,1.4-1,2.2-1,0,0,0,0,0,0h0c0,0,.2,0,.3,0,1.6.2,2.9,1.5,2.9,3,0,0,0,0,0,.1,0,1.7-1.4,3.2-3.1,3.2ZM32,51.7h0,0ZM32,51.7s0,0,0,0c0,0,0,0,0,0Z')
							]),
						_List_Nil)
					])
			};
		case 84:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 30 30.09'),
						A2($elm$html$Html$Attributes$attribute, 'style', 'vertical-align: '),
						A2($elm$html$Html$Attributes$attribute, 'width', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'height', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'fill', 'rgba(0%,0%,0%,1)')
					]),
				N: _List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M0,4.26,12.26,2.59V14.42L0,14.49ZM12.25,15.78V27.62L0,25.93V15.7ZM13.74,2.37,30,0V14.27l-16.26.13ZM30,15.89v14.2L13.74,27.8l0-11.94Z'),
								A2($elm$html$Html$Attributes$attribute, 'class', 'a')
							]),
						_List_Nil)
					])
			};
		case 85:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'id', 'Layer_1'),
						A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
						A2($elm$html$Html$Attributes$attribute, 'version', '1.1'),
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 64 64')
					]),
				N: _List_fromArray(
					[
						$elm$svg$Svg$text(''),
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M12.6,63.3c-.6,0-1.3-.2-1.8-.7-1-1-1-2.6,0-3.5l19.7-19.7c.7-.8,1.9-.9,2.8-.5,4.8,2.3,10.3,2.3,15,0,7.5-3.6,11.3-11.9,9.4-19.7l-3.4,3.4c-3.6,3.4-9.1,3.4-12.7,0-3.6-3.5-3.8-9.3-.3-12.9l3.5-3.5c-3.8-.9-7.9-.5-11.6,1.2-4.2,2-7.4,5.5-8.9,9.9-1.5,4.4-1.3,9.1.7,13.3.5,1,.3,2.1-.5,2.8L5,53.2c-1,1-2.6,1-3.5,0-1-1-1-2.6,0-3.5l18.5-18.5c-1.9-5-2-10.4-.2-15.5,2-5.6,6.1-10.2,11.5-12.8C37.3,0,44.4,0,50.5,2.9c.7.4,1.2,1,1.4,1.8.1.8-.1,1.6-.7,2.2l-6.2,6.2c-1.5,1.6-1.5,4.2.2,5.8,1.6,1.5,4.1,1.5,5.7,0l6.2-6.2c.6-.6,1.4-.8,2.2-.7.8.1,1.5.7,1.8,1.4,5.3,11.1.6,24.5-10.5,29.9-5.6,2.7-12,2.9-17.7.7l-18.5,18.5c-.5.5-1.1.7-1.8.7Z')
							]),
						_List_Nil)
					])
			};
		default:
			return {
				M: _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'viewBox', '0 0 16 16'),
						A2($elm$html$Html$Attributes$attribute, 'style', 'vertical-align: '),
						A2($elm$html$Html$Attributes$attribute, 'width', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'height', '64px'),
						A2($elm$html$Html$Attributes$attribute, 'fill', 'rgba(0%,0%,0%,1)')
					]),
				N: _List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'd', 'M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm3.5 10.1c.2.2.2.4 0 .6l-.8.8c-.2.2-.4.2-.6 0L8 9.4l-2.1 2.1c-.2.2-.4.2-.6 0l-.8-.8c-.2-.2-.2-.4 0-.6L6.6 8 4.5 5.9c-.2-.2-.2-.4 0-.6l.8-.8c.2-.2.4-.2.6 0L8 6.6l2.1-2.1c.2-.2.4-.2.6 0l.8.8c.2.2.2.4 0 .6L9.4 8l2.1 2.1z')
							]),
						_List_Nil)
					])
			};
	}
};
var $author$project$Views$Icon$viewInternal = F4(
	function (mbSize, mbColor, key, vAlign) {
		var size = $author$project$Views$Icon$sizeAttributes(
			A2($elm$core$Maybe$withDefault, $author$project$Views$Icon$Normal, mbSize));
		var color = $author$project$Views$Icon$colorAttributes(
			A2($elm$core$Maybe$withDefault, $author$project$Style$defaultColor, mbColor));
		var attrs = _Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('icon'),
					$elm$svg$Svg$Attributes$name(
					$author$project$Icon$name(key)),
					$author$project$Views$Icon$alignToAttribute(vAlign)
				]),
			_Utils_ap(size, color));
		return function (_v0) {
			var attributes = _v0.M;
			var elements = _v0.N;
			return A2(
				$elm$svg$Svg$svg,
				_Utils_ap(attributes, attrs),
				elements);
		}(
			$author$project$Icon$viewData(key));
	});
var $author$project$Views$Icon$view = function (_v0) {
	var fields = _v0;
	return A4($author$project$Views$Icon$viewInternal, fields.we, fields.tc, fields.cV, fields.wY);
};
var $author$project$Views$Link$view = F3(
	function (attributes, content, route) {
		return A3($author$project$Views$Link$link, route, attributes, content);
	});
var $author$project$Views$SiteWrapper$dropdownLinks = function (session) {
	var superUserLinks = function () {
		var superUserFeaturesVisible = $author$project$Model$Session$getSuperUserFeaturesVisible(session);
		return _List_fromArray(
			[
				A3(
				$author$project$Views$Link$view,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('admin dropdown-item')
					]),
				_List_fromArray(
					[
						$author$project$Views$Icon$view(
						$author$project$Views$Icon$icon(77)),
						$elm$html$Html$text('Admin')
					]),
				$author$project$Model$Route$Protected(
					$author$project$Model$Route$Admin($author$project$Model$Route$AdminOrganizations))),
				A2(
				$author$project$Misc$displayIf,
				superUserFeaturesVisible,
				A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('dropdown-item superuser-only'),
							$elm$html$Html$Events$onClick($author$project$Msg$AuthHeaderCopyToClipboard)
						]),
					_List_fromArray(
						[
							$author$project$Views$Icon$view(
							$author$project$Views$Icon$icon(17)),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('label')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Copy Auth Header')
								]))
						]))),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('features dropdown-item slide-toggle-wrapper'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('superuser-only enabled', superUserFeaturesVisible),
								_Utils_Tuple2('disabled', !superUserFeaturesVisible)
							])),
						$elm$html$Html$Events$onClick($author$project$Msg$ToggleSuperUserFeaturesVisible)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('slide-toggle')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('nub')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('label')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Superuser features')
							]))
					]))
			]);
	}();
	var links = _List_fromArray(
		[
			A3(
			$author$project$Views$Link$view,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('settings dropdown-item')
				]),
			_List_fromArray(
				[
					$author$project$Views$Icon$view(
					$author$project$Views$Icon$icon(30)),
					$elm$html$Html$text('Account Settings')
				]),
			$author$project$Model$Route$Protected($author$project$Model$Route$PreferenceIndex))
		]);
	var includeSuperUser = $author$project$Model$User$isSuperReader(
		$author$project$Model$Session$getUser(session));
	return includeSuperUser ? _Utils_ap(links, superUserLinks) : links;
};
var $author$project$Views$SiteWrapper$mkLinks = F2(
	function (session, isOpen) {
		var signoutText = $author$project$Model$Session$isImpersonating(session) ? ('Sign Out \'' + ($author$project$Views$SiteWrapper$dropdownName(session) + '\'')) : 'Sign Out';
		var defaultLinks = _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dropdown-item sign-out'),
						$elm$html$Html$Attributes$id('sign-out-menu-item'),
						$elm$html$Html$Events$onClick($author$project$Msg$OnLogout)
					]),
				_List_fromArray(
					[
						$author$project$Views$Icon$view(
						$author$project$Views$Icon$icon(73)),
						$elm$html$Html$text(signoutText)
					]))
			]);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('dropdown-menu', true),
							_Utils_Tuple2('visible', isOpen),
							_Utils_Tuple2('hidden', !isOpen)
						]))
				]),
			_Utils_ap(
				$author$project$Views$SiteWrapper$dropdownLinks(session),
				defaultLinks));
	});
var $author$project$Views$SiteWrapper$dropdown = function (session) {
	var isOpen = $author$project$Model$Session$getDropdownOpen(session);
	var className = $author$project$Model$User$isSuperUser(
		$author$project$Model$Session$getUser(session)) ? 'isSuperUser' : '';
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('dropdown'),
				$elm$html$Html$Attributes$class(className)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick($author$project$Msg$ToggleDropDown),
						$elm$html$Html$Attributes$class($author$project$Views$SiteWrapper$dropdownToggleId),
						$elm$html$Html$Attributes$id($author$project$Views$SiteWrapper$dropdownToggleId),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('active', isOpen)
							]))
					]),
				_List_fromArray(
					[
						$author$project$Views$Icon$view(
						$author$project$Views$Icon$icon(82)),
						$elm$html$Html$text(
						$author$project$Views$SiteWrapper$dropdownName(session)),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('super-user-indicator')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('S')
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('toggle-icon')
							]),
						_List_fromArray(
							[
								$author$project$Views$Icon$view(
								$author$project$Views$Icon$icon(13))
							]))
					])),
				A2($author$project$Views$SiteWrapper$mkLinks, session, isOpen)
			]));
};
var $author$project$Model$Theme$Unset = 2;
var $author$project$Model$Theme$valueToTheme = function (key) {
	switch (key) {
		case 'dark':
			return 0;
		case 'light':
			return 1;
		default:
			return 2;
	}
};
var $author$project$Model$Session$getTheme = function (_v0) {
	var session = _v0;
	var _v1 = A2($author$project$Model$LocalStorage$get, $author$project$Model$LocalStorage$themeKey, session.fu);
	if (!_v1.$) {
		var value = _v1.a;
		return $author$project$Model$Theme$valueToTheme(value);
	} else {
		return 2;
	}
};
var $author$project$Views$Nav$headerBranding = _List_fromArray(
	[
		A3(
		$author$project$Views$Link$link,
		$author$project$Model$Route$Protected(
			$author$project$Model$Route$Home(
				{wd: $elm$core$Maybe$Nothing})),
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('logo-wrapper')
			]),
		_List_Nil)
	]);
var $author$project$Url$Extra$pricing = function (queryParams) {
	return A3(
		$author$project$Url$Extra$createUrl,
		$author$project$Url$Extra$corporateSiteDomain,
		_List_fromArray(
			['company', 'contact-us-pricing']),
		queryParams);
};
var $author$project$Views$Nav$headerNav = F2(
	function (route, _v0) {
		return _List_fromArray(
			[
				A3(
				$author$project$Views$Link$link,
				$author$project$Model$Route$Support,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'selected',
								_Utils_eq(route, $author$project$Model$Route$Support))
							]))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Support')
					])),
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href(
						$author$project$Url$Extra$pricing(_List_Nil)),
						$elm$html$Html$Attributes$target('_blank')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Plans & Pricing'),
						$author$project$Views$Icon$view(
						$author$project$Views$Icon$icon(25))
					]))
			]);
	});
var $author$project$Model$Route$loginWithNextRoute = function (nextRoute) {
	return $author$project$Model$Route$Login(
		_Utils_update(
			$author$project$Model$Route$emptyLoginParams,
			{
				dg: $elm$core$Maybe$Just(nextRoute)
			}));
};
var $author$project$Views$Nav$signIn = function (currentRoute) {
	return A3(
		$author$project$Views$Link$link,
		$author$project$Model$Route$loginWithNextRoute(currentRoute),
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('white-button-on-black')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Sign In')
			]));
};
var $author$project$Views$Columns$withAttrs = F2(
	function (attrs, columns) {
		return _Utils_update(
			columns,
			{tq: attrs});
	});
var $author$project$Views$Nav$navHeader = F5(
	function (maybeRoute, user, leftContent, rightContent, showNav) {
		var route = function () {
			if (!maybeRoute.$) {
				var r = maybeRoute.a;
				return r;
			} else {
				return $author$project$Model$Route$Protected(
					$author$project$Model$Route$Home(
						{wd: $elm$core$Maybe$Nothing}));
			}
		}();
		var rightColumn = (!$elm$core$List$length(rightContent)) ? _List_fromArray(
			[
				$author$project$Views$Nav$signIn(route)
			]) : rightContent;
		var leftColumn = (!$elm$core$List$length(leftContent)) ? $author$project$Views$Nav$headerBranding : leftContent;
		return $author$project$Views$Columns$asHtml(
			A2(
				$author$project$Views$Columns$withColumns,
				_List_fromArray(
					[
						leftColumn,
						showNav ? A2($author$project$Views$Nav$headerNav, route, user) : _List_Nil,
						rightColumn
					]),
				A2(
					$author$project$Views$Columns$withColumnAs,
					$elm$html$Html$section,
					A2(
						$author$project$Views$Columns$withAttrs,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('header')
							]),
						$author$project$Views$Columns$asColumns($elm$html$Html$nav)))));
	});
var $elm$html$Html$aside = _VirtualDom_node('aside');
var $elm$html$Html$Events$onMouseOut = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseout',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onMouseOver = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseover',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Views$TeamTier$secureBinaryBenefitList = _List_fromArray(
	['Reduced open source risk', 'Increased regulatory compliance', 'Fully auditable build process', 'Vulnerability insights']);
var $author$project$Views$TeamTier$teamTierRequestUpgradeButton = A2(
	$elm$html$Html$a,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$href(
			$author$project$Url$Extra$pricing(_List_Nil)),
			$elm$html$Html$Attributes$target('blank'),
			$elm$html$Html$Attributes$class('primary-button')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('View Plans')
		]));
var $author$project$Views$TeamTier$teamTierTag = function (_v0) {
	var showCard = _v0.F4;
	var id = _v0.l6;
	var onMouseOverMsg = _v0.rI;
	var onMouseOutMsg = _v0.rH;
	var memberLimitPopup = A2(
		$elm$html$Html$aside,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('upgrade-cta')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h4,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Upgrade to access Secure Binaries')
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Secure Binaries are built from source and give you the following benefits...')
					])),
				A2(
				$elm$html$Html$ul,
				_List_Nil,
				A2(
					$elm$core$List$map,
					function (t) {
						return A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(t)
								]));
					},
					$author$project$Views$TeamTier$secureBinaryBenefitList)),
				$author$project$Views$TeamTier$teamTierRequestUpgradeButton
			]));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Events$onMouseOver(
				onMouseOverMsg(id)),
				$elm$html$Html$Events$onMouseOut(onMouseOutMsg),
				$elm$html$Html$Attributes$class('upgrade-button-wrapper')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href(
						$author$project$Url$Extra$pricing(_List_Nil)),
						$elm$html$Html$Attributes$class('primary-button small heap-header-button upgrade-button'),
						$elm$html$Html$Attributes$target('_blank')
					]),
				_List_fromArray(
					[
						$author$project$Views$Icon$view(
						$author$project$Views$Icon$icon(71)),
						$elm$html$Html$text('Upgrade')
					])),
				A2($author$project$Misc$displayIf, showCard, memberLimitPopup)
			]));
};
var $author$project$Views$SiteWrapper$authorizedHeader = F3(
	function (_v0, session, pageState) {
		var showNav = _v0.z9;
		var showTeamTierPopup = _v0.hT;
		var user = $author$project$Model$Session$getUser(session);
		var themeToggle = function () {
			var currentTheme = $author$project$Model$Session$getTheme(session);
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('theme-toggle'),
						A2(
						$elm$html$Html$Attributes$attribute,
						'data-theme',
						$author$project$Model$Theme$themeToValue(currentTheme))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('icon-wrapper'),
								$elm$html$Html$Events$onClick(
								$author$project$Msg$SetTheme(1))
							]),
						_List_fromArray(
							[
								$author$project$Views$Icon$view(
								$author$project$Views$Icon$icon(76))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('icon-wrapper'),
								$elm$html$Html$Events$onClick(
								$author$project$Msg$SetTheme(0))
							]),
						_List_fromArray(
							[
								$author$project$Views$Icon$view(
								$author$project$Views$Icon$icon(51))
							]))
					]));
		}();
		var route = $elm$core$Maybe$Just(
			$author$project$PageState$getCurrentRoute(pageState));
		var isUserSignedIn = $elm_community$maybe_extra$Maybe$Extra$isJust(user);
		var displayUpgradeCta = false;
		var rightContent = isUserSignedIn ? A3(
			$author$project$Misc$consIf,
			displayUpgradeCta,
			$author$project$Views$TeamTier$teamTierTag(
				{
					l6: 'authed-area',
					rH: $author$project$Msg$MouseExitTeamTierTag,
					rI: $author$project$Msg$MouseEnterTeamTierTag,
					F4: _Utils_eq(
						showTeamTierPopup,
						$elm$core$Maybe$Just('authed-area'))
				}),
			_List_fromArray(
				[
					themeToggle,
					$author$project$Views$SiteWrapper$dropdown(session)
				])) : _List_Nil;
		return A5($author$project$Views$Nav$navHeader, route, user, _List_Nil, rightContent, showNav);
	});
var $author$project$Misc$displayMaybe = F2(
	function (f, m) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$html$Html$text(''),
			A2($elm$core$Maybe$map, f, m));
	});
var $author$project$Views$GenericBanner$genericBanner = F3(
	function (maybeIconClass, action, content) {
		return A2(
			$elm$html$Html$aside,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('site-wide-banner')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Misc$displayMaybe,
					function (iconClass) {
						return A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class(iconClass)
								]),
							_List_Nil);
					},
					maybeIconClass),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('content')
						]),
					_List_fromArray(
						[content])),
					A2(
					$elm$core$Maybe$withDefault,
					$elm$html$Html$text(''),
					action)
				]));
	});
var $author$project$Views$CheckEmailBanner$checkEmailBanner = function (emailAddress) {
	var content = A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h4,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Verify your email address!')
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('We sent a verification email to \"'),
						$elm$html$Html$text(emailAddress),
						$elm$html$Html$text('\" — click the link inside to finish setting up your account.')
					]))
			]));
	var action = A3(
		$author$project$Views$Link$link,
		$author$project$Model$Route$Protected($author$project$Model$Route$PreferenceEmail),
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('white-button-on-black confirm-button')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Manage Email')
			]));
	return A3(
		$author$project$Views$GenericBanner$genericBanner,
		$elm$core$Maybe$Just('email-icon'),
		$elm$core$Maybe$Just(action),
		content);
};
var $author$project$Model$Session$getNotifications = function (_v0) {
	var session = _v0;
	return session.mN;
};
var $author$project$Views$Loading$dots = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('loading-dots')
		]),
	_List_fromArray(
		[
			A2($elm$html$Html$span, _List_Nil, _List_Nil),
			A2($elm$html$Html$span, _List_Nil, _List_Nil),
			A2($elm$html$Html$span, _List_Nil, _List_Nil)
		]));
var $author$project$Views$Loading$view = function (isLoading) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('loading-bar'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('visible', isLoading)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('wrapper')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('loading-label')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('LOADING')
							])),
						$author$project$Views$Loading$dots
					]))
			]));
};
var $author$project$Views$NotificationsGlobal$elementClass = 'notifications-global';
var $author$project$Model$Notification$type_ = function (notification) {
	if (!notification.$) {
		return 'success';
	} else {
		return 'warning';
	}
};
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $elm$html$Html$Keyed$ul = $elm$html$Html$Keyed$node('ul');
var $elm$html$Html$br = _VirtualDom_node('br');
var $author$project$Model$Notification$markupView = function (markup) {
	switch (markup.$) {
		case 1:
			var content = markup.a;
			return $elm$html$Html$text(content);
		case 0:
			var to = markup.a.Gz;
			var text = markup.a.Gv;
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href(to)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(text)
					]));
		default:
			return A2($elm$html$Html$br, _List_Nil, _List_Nil);
	}
};
var $author$project$Model$Notification$view = function (notification) {
	if (!notification.$) {
		var s = notification.a;
		return A2($elm$core$List$map, $author$project$Model$Notification$markupView, s);
	} else {
		var s = notification.a;
		return A2($elm$core$List$map, $author$project$Model$Notification$markupView, s);
	}
};
var $author$project$Views$NotificationsGlobal$view = function (_v0) {
	var internal = _v0;
	var wrapNotification = function (_v1) {
		var incr = _v1.b;
		var notification = _v1.c;
		return _Utils_Tuple2(
			$elm$core$String$fromInt(incr),
			A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(
						$author$project$Model$Notification$type_(notification))
					]),
				$author$project$Model$Notification$view(notification)));
	};
	var reversed = $elm$core$List$reverse(internal.mN);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class($author$project$Views$NotificationsGlobal$elementClass)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$Keyed$ul,
				_List_Nil,
				A2($elm$core$List$map, wrapNotification, reversed))
			]));
};
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $author$project$Views$OutOfComplianceModal$viewBanner = F2(
	function (learnMoreClicked, _v0) {
		var company = _v0.qG;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('exceeding-usage-banner')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('icon')
						]),
					_List_fromArray(
						[
							$author$project$Views$Icon$view(
							$author$project$Views$Icon$icon(35))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(company + (' is exceeding ActiveState\'s usage limits. ' + 'Please upgrade to a paid tier.'))
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('secondary-button clear'),
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Events$onClick(learnMoreClicked)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Learn more')
						]))
				]));
	});
var $author$project$Views$Modal$DismissButtonInvisible = {$: 0};
var $elm$html$Html$abbr = _VirtualDom_node('abbr');
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $author$project$Views$Modal$dismissButtonView = F2(
	function (config, dismissButtonType) {
		var _v0 = function () {
			if (!dismissButtonType) {
				return _Utils_Tuple2('secondary-button', 'Close');
			} else {
				return _Utils_Tuple2('dismiss-x', '');
			}
		}();
		var buttonClass = _v0.a;
		var buttonText = _v0.b;
		var classes = A2(
			$elm$core$List$map,
			$elm$html$Html$Attributes$class,
			_List_fromArray(
				['small', 'dismiss-popup', buttonClass]));
		var attrs = _Utils_ap(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('button'),
					$elm$html$Html$Attributes$disabled(config.Dc),
					$elm$html$Html$Events$onClick(config.BI)
				]),
			classes);
		return A2(
			$elm$html$Html$button,
			attrs,
			_List_fromArray(
				[
					$author$project$Views$Icon$view(
					$author$project$Views$Icon$icon(19)),
					$elm$html$Html$text(buttonText)
				]));
	});
var $author$project$Views$Modal$viewWithModalId = F2(
	function (maybeID, config) {
		var dismissButton = function () {
			var _v0 = config.x4;
			if (_v0.$ === 1) {
				var type_ = _v0.a;
				var enabled = _v0.b;
				return A2(
					$author$project$Views$Modal$dismissButtonView,
					{BI: config.BI, Dc: !enabled},
					type_);
			} else {
				return A2($elm$html$Html$span, _List_Nil, _List_Nil);
			}
		}();
		var classes = A2(
			$elm$core$List$map,
			$elm$html$Html$Attributes$class,
			_List_fromArray(
				['modal-view', config.BD]));
		var attrs = A2(
			$elm$core$List$append,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('modal')
				]),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (i) {
						return _List_fromArray(
							[
								$elm$html$Html$Attributes$id(i)
							]);
					},
					maybeID)));
		return A2(
			$elm$html$Html$div,
			classes,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					attrs,
					_List_fromArray(
						[
							A2(
							$author$project$Misc$displayIf,
							!_Utils_eq(config.x4, $author$project$Views$Modal$DismissButtonInvisible),
							dismissButton),
							config.dH
						]))
				]));
	});
var $author$project$Views$Modal$view = $author$project$Views$Modal$viewWithModalId($elm$core$Maybe$Nothing);
var $author$project$Views$OutOfComplianceModal$viewModal = F2(
	function (closeMessage, model) {
		return $author$project$Views$Modal$view(
			{
				BD: 'compliance-modal',
				BI: closeMessage,
				dH: A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Hello ' + (model.AE + ','))
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Multiple employees from ' + (model.qG + (' are using ActiveState\'s language distributions. ' + 'Per our '))),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(
											$author$project$Url$Extra$eula(
												_List_fromArray(
													[
														_Utils_Tuple2('platform', 'compliance')
													]))),
											$elm$html$Html$Attributes$target('_blank')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('terms of service')
										])),
									$elm$html$Html$text(' please upgrade to a '),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(
											$author$project$Url$Extra$pricing(
												_List_fromArray(
													[
														_Utils_Tuple2('platform', 'compliance')
													]))),
											$elm$html$Html$Attributes$target('_blank')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('paid account')
										])),
									$elm$html$Html$text('.')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Please '),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(
											$author$project$Url$Extra$contactSales(
												_List_fromArray(
													[
														_Utils_Tuple2('platform', 'compliance')
													]))),
											$elm$html$Html$Attributes$target('_blank')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('contact Sales')
										])),
									$elm$html$Html$text(' to discuss your upgrade. During this discussion, we\'ll share detailed information about how ' + (model.qG + (' uses the ActiveState Platform, and we can also share more about the benefits of our paid tiers' + ' including custom builds, hosted artifacts, and '))),
									A2(
									$elm$html$Html$abbr,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$title('Software bill of materials'),
											A2($elm$html$Html$Attributes$style, 'text-decoration', 'none')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('SBOM')
										])),
									$elm$html$Html$text('s.')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Sincerely,')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('The ActiveState Team')
								])),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('primary-button external'),
									$elm$html$Html$Attributes$href(
									$author$project$Url$Extra$contactSales(
										_List_fromArray(
											[
												_Utils_Tuple2('platform', 'compliance')
											]))),
									$elm$html$Html$Attributes$target('_blank')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Contact Sales'),
									$author$project$Views$Icon$view(
									$author$project$Views$Icon$icon(25))
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('button'),
									$elm$html$Html$Attributes$class('secondary-button'),
									$elm$html$Html$Events$onClick(closeMessage)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('I\'ll Do It Later')
								]))
						])),
				x4: $author$project$Views$Modal$DismissButtonInvisible
			});
	});
var $author$project$Views$SiteWrapper$toHtml = function (sw) {
	var siteWideBanner = $elm$core$Maybe$Nothing;
	var ponyUpModal = A2(
		$elm$core$Maybe$map,
		$author$project$Views$OutOfComplianceModal$viewModal($author$project$Msg$OutOfComplianceModalDismissed),
		sw.hS);
	var maybeUser = A2($elm$core$Maybe$andThen, $author$project$Model$Session$getUser, sw.l);
	var ponyUpBanner = function () {
		var _v2 = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.EC;
			},
			maybeUser);
		if ((!_v2.$) && (_v2.a.$ === 1)) {
			var companyName = _v2.a.a;
			return A2(
				$elm$core$Maybe$map,
				function (m) {
					return A2(
						$author$project$Views$OutOfComplianceModal$viewBanner,
						$author$project$Msg$OutOfComplianceBannerClicked(m),
						m);
				},
				A2(
					$elm_community$maybe_extra$Maybe$Extra$andMap,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.AE;
						},
						maybeUser),
					$elm$core$Maybe$Just(
						$author$project$Views$OutOfComplianceModal$OocModel(companyName))));
		} else {
			return $elm$core$Maybe$Just(
				$elm$html$Html$text(''));
		}
	}();
	var loadingView = A2(
		$elm$core$Maybe$map,
		A2($elm$core$Basics$composeR, $author$project$PageState$isPageLoading, $author$project$Views$Loading$view),
		sw.u);
	var isUserSignedIn = $elm_community$maybe_extra$Maybe$Extra$isJust(maybeUser);
	var header = function () {
		var _v1 = _Utils_Tuple3(sw.v9, sw.l, sw.u);
		if ((!_v1.b.$) && (!_v1.c.$)) {
			var options = _v1.a;
			var session = _v1.b.a;
			var pageState = _v1.c.a;
			return $elm$core$Maybe$Just(
				A3($author$project$Views$SiteWrapper$authorizedHeader, options, session, pageState));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	var errorView = A2(
		$elm$core$Maybe$map,
		A2($elm$core$Basics$composeR, $author$project$Model$Session$getNotifications, $author$project$Views$NotificationsGlobal$view),
		sw.l);
	var emailNotVerified = A2(
		$elm$core$Maybe$withDefault,
		true,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.w1;
				},
				$elm$core$Basics$not),
			maybeUser));
	var emailBanner = function () {
		if (!siteWideBanner.$) {
			return $elm$core$Maybe$Nothing;
		} else {
			return (isUserSignedIn && (emailNotVerified && sw.so)) ? A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.lJ;
					},
					$author$project$Views$CheckEmailBanner$checkEmailBanner),
				maybeUser) : $elm$core$Maybe$Nothing;
		}
	}();
	var pageElements = $elm_community$maybe_extra$Maybe$Extra$values(
		_Utils_ap(
			_List_fromArray(
				[loadingView, emailBanner, siteWideBanner, errorView, header, sw.rS, ponyUpBanner, ponyUpModal]),
			_Utils_ap(
				A2($elm$core$List$map, $elm$core$Maybe$Just, sw.pj),
				_List_fromArray(
					[sw.rR]))));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('site-wrapper', true),
						_Utils_Tuple2(sw.vO, true)
					]))
			]),
		pageElements);
};
var $author$project$Views$SiteWrapper$having = F2(
	function (component, sw) {
		switch (component.$) {
			case 7:
				var elements = component.a;
				return _Utils_update(
					sw,
					{pj: elements});
			case 2:
				var _class = component.a;
				return _Utils_update(
					sw,
					{vO: _class});
			case 0:
				var session = component.a;
				return _Utils_update(
					sw,
					{
						l: $elm$core$Maybe$Just(session)
					});
			case 1:
				var pageState = component.a;
				return _Utils_update(
					sw,
					{
						u: $elm$core$Maybe$Just(pageState)
					});
			case 3:
				var showIt = component.a;
				return _Utils_update(
					sw,
					{so: showIt});
			case 4:
				var options = component.a;
				return _Utils_update(
					sw,
					{v9: options});
			case 5:
				var element = component.a;
				return _Utils_update(
					sw,
					{
						rS: $elm$core$Maybe$Just(element)
					});
			case 6:
				var element = component.a;
				return _Utils_update(
					sw,
					{
						rR: $elm$core$Maybe$Just(element)
					});
			case 8:
				var showIt = component.a;
				return _Utils_update(
					sw,
					{hS: showIt});
			default:
				return sw;
		}
	});
var $author$project$Views$SiteWrapper$with = F2(
	function (component, sw) {
		switch (component.$) {
			case 7:
				var elements = component.a;
				return A3(
					$elm_community$basics_extra$Basics$Extra$flip,
					$author$project$Views$SiteWrapper$having,
					sw,
					$author$project$Views$SiteWrapper$PageContent(
						_Utils_ap(sw.pj, elements)));
			case 2:
				var _class = component.a;
				return A3(
					$elm_community$basics_extra$Basics$Extra$flip,
					$author$project$Views$SiteWrapper$having,
					sw,
					$author$project$Views$SiteWrapper$PageClass(
						A2(
							$elm$core$String$join,
							' ',
							_List_fromArray(
								[sw.vO, _class]))));
			default:
				return A2($author$project$Views$SiteWrapper$having, component, sw);
		}
	});
var $author$project$Views$Columns$withSideNav = F3(
	function (pageLink, routes, columns) {
		return _Utils_update(
			columns,
			{
				iX: _Utils_ap(
					columns.iX,
					$elm$core$List$singleton(
						A2(
							$elm$html$Html$nav,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('side-nav column')
								]),
							A2(
								$elm$core$List$map,
								function (_v0) {
									var route = _v0.a;
									var name = _v0.b;
									return A2(pageLink, route, name);
								},
								routes))))
			});
	});
var $author$project$Views$Layout$adminLayout = F3(
	function (content, session, pageState) {
		var orgRouteMatch = F2(
			function (currentRoute, linkRoute) {
				var _v0 = _Utils_Tuple2(currentRoute, linkRoute);
				_v0$4:
				while (true) {
					if ((((_v0.a.$ === 7) && (_v0.a.a.$ === 16)) && (_v0.b.$ === 7)) && (_v0.b.a.$ === 16)) {
						switch (_v0.b.a.a.$) {
							case 0:
								switch (_v0.a.a.a.$) {
									case 1:
										var _v1 = _v0.b.a.a;
										return true;
									case 4:
										var _v2 = _v0.a.a.a;
										var _v3 = _v0.b.a.a;
										return true;
									default:
										break _v0$4;
								}
							case 2:
								switch (_v0.a.a.a.$) {
									case 2:
										return true;
									case 3:
										return true;
									default:
										break _v0$4;
								}
							default:
								break _v0$4;
						}
					} else {
						break _v0$4;
					}
				}
				return false;
			});
		var pageLink = A2(
			$author$project$Views$Layout$navLink,
			F2(
				function (r1, r2) {
					return _Utils_eq(r1, r2) || A2(orgRouteMatch, r1, r2);
				}),
			$author$project$PageState$getCurrentRoute(pageState));
		var adminLinks = _List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Model$Route$Protected(
					$author$project$Model$Route$Admin($author$project$Model$Route$AdminOrganizations)),
				$elm$html$Html$text('Organizations')),
				_Utils_Tuple2(
				$author$project$Model$Route$adminUsers($elm$core$Maybe$Nothing),
				$elm$html$Html$text('Users')),
				_Utils_Tuple2(
				$author$project$Model$Route$Protected(
					$author$project$Model$Route$Admin($author$project$Model$Route$AdminFeatures)),
				$elm$html$Html$text('Tier Features')),
				_Utils_Tuple2(
				$author$project$Model$Route$Protected(
					$author$project$Model$Route$Admin($author$project$Model$Route$AdminIconomicon)),
				$elm$html$Html$text('Iconomicon'))
			]);
		return $author$project$Views$SiteWrapper$toHtml(
			A2(
				$author$project$Views$SiteWrapper$with,
				$author$project$Views$SiteWrapper$ActiveStateHeader(
					{z9: true, hT: $elm$core$Maybe$Nothing}),
				A2(
					$author$project$Views$SiteWrapper$with,
					$author$project$Views$SiteWrapper$PageClass('admin-page'),
					A2(
						$author$project$Views$SiteWrapper$with,
						$author$project$Views$SiteWrapper$PageStateData(pageState),
						A2(
							$author$project$Views$SiteWrapper$with,
							$author$project$Views$SiteWrapper$SessionData(session),
							A2(
								$author$project$Views$SiteWrapper$with,
								$author$project$Views$SiteWrapper$PageFooter($author$project$Views$Layout$footer),
								A2(
									$author$project$Views$SiteWrapper$with,
									$author$project$Views$SiteWrapper$PageContent(
										_List_fromArray(
											[
												$author$project$Views$Columns$asHtml(
												A2(
													$author$project$Views$Columns$withColumn,
													_List_fromArray(
														[content]),
													A2(
														$author$project$Views$Columns$withColumnAs,
														$elm$html$Html$section,
														A3(
															$author$project$Views$Columns$withSideNav,
															pageLink,
															adminLinks,
															$author$project$Views$Columns$asColumns($elm$html$Html$main_)))))
											])),
									A2(
										$author$project$Views$SiteWrapper$with,
										$author$project$Views$SiteWrapper$PageHeader(
											A2(
												$author$project$Views$Layout$pageHeader,
												_List_Nil,
												$elm$core$List$singleton(
													$author$project$Views$Layout$heading('Platform Administration')))),
										$author$project$Views$SiteWrapper$newSiteWrapper))))))));
	});
var $author$project$Pages$Checkout$getBillingDetailsHeading = function (model) {
	var _v0 = model.iU;
	if (_v0.$ === 1) {
		var billingDetailsModel = _v0.a;
		return $elm$core$Maybe$Just(
			function () {
				var tierName = $author$project$Model$Tier$tierNameAsSimpleTierString(
					$author$project$Model$Tier$name(model.sC.dc));
				return model.up ? ('Start Your ' + (tierName + ' Subscription Trial')) : ('Upgrade ' + (billingDetailsModel.FV.AC + (' to a ' + (tierName + ' Subscription'))));
			}());
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$ProjectHistory$getCommitID = function (model) {
	return $author$project$Model$Commit$getCommitID(model.f0);
};
var $author$project$Model$Route$getMaybeBranchName = function (route) {
	_v0$2:
	while (true) {
		switch (route.$) {
			case 12:
				var args = route.a;
				return args.fO;
			case 7:
				if (route.a.$ === 14) {
					var orgRoute = route.a.a.vI;
					if (orgRoute.$ === 7) {
						var projectRoute = orgRoute.a.zL;
						switch (projectRoute.$) {
							case 0:
								var args = projectRoute.a;
								return args.fO;
							case 5:
								var maybeBranchName = projectRoute.d;
								return maybeBranchName;
							case 2:
								var maybeBranchName = projectRoute.a;
								return maybeBranchName;
							case 3:
								var maybeBranchName = projectRoute.a;
								return maybeBranchName;
							case 4:
								var maybeBranchName = projectRoute.a.fO;
								return maybeBranchName;
							default:
								return $elm$core$Maybe$Nothing;
						}
					} else {
						return $elm$core$Maybe$Nothing;
					}
				} else {
					break _v0$2;
				}
			default:
				break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Pages$ProjectConfig$getMaybeBranchName = function (model) {
	return A2($elm$core$Maybe$andThen, $author$project$Views$BranchPicker$getSelectedNameIfNotDefault, model.fJ);
};
var $author$project$Pages$ProjectConfigAdvanced$getMaybeBranchName = function (model) {
	return A2($elm$core$Maybe$andThen, $author$project$Views$BranchPicker$getSelectedNameIfNotDefault, model.fJ);
};
var $author$project$Pages$ProjectDownloads$getMaybeBranchName = function (model) {
	return A2($elm$core$Maybe$andThen, $author$project$Views$BranchPicker$getSelectedNameIfNotDefault, model.fJ);
};
var $author$project$Pages$ProjectHistory$getMaybeBranchName = function (model) {
	return A2($elm$core$Maybe$andThen, $author$project$Views$BranchPicker$getSelectedNameIfNotDefault, model.fJ);
};
var $author$project$Pages$ProjectConfig$getMaybeCommitID = function (model) {
	return $elm$core$Maybe$Just(
		$author$project$Model$Commit$getCommitID(model.f0));
};
var $author$project$Pages$ProjectConfigAdvanced$getMaybeCommitID = function (model) {
	return $elm$core$Maybe$Just(
		$author$project$Model$Commit$getCommitID(model.f0));
};
var $author$project$Pages$ProjectDownloads$getMaybeCommitID = function (model) {
	return $elm$core$Maybe$Just(
		$author$project$Model$Commit$getCommitID(model.f0));
};
var $author$project$Pages$ProjectSettingsHAR$getMaybeCommitID = function ($) {
	return $.uB;
};
var $author$project$Pages$ProjectImpactReport$getMaybeOldCommitID = function (model) {
	var _v0 = model.E5;
	if ((!_v0.$) && (!_v0.a.a.$)) {
		var _v1 = _v0.a;
		var id = _v1.a.a;
		return $elm$core$Maybe$Just(id);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$OrgIndex$getMembers = function (model) {
	return model.hB;
};
var $author$project$Pages$OrgMembers$getMembers = function (model) {
	return model.hB;
};
var $author$project$Pages$OrgRemediation$getMembers = function ($) {
	return $.hB;
};
var $author$project$Pages$OrgIndex$getOrganization = function (model) {
	return model.c3;
};
var $author$project$Pages$OrgMembers$getOrganization = function (model) {
	return model.c3;
};
var $author$project$Pages$OrgRemediation$getOrganization = function ($) {
	return $.c3;
};
var $author$project$Pages$ProjectConfig$getOrganization = function (model) {
	return model.c3;
};
var $author$project$Pages$ProjectConfigAdvanced$getOrganization = function (model) {
	return model.c3;
};
var $author$project$Pages$ProjectSettingsBranches$getOrganization = function (model) {
	return model.c3;
};
var $author$project$Pages$ProjectSettingsHAR$getOrganization = function ($) {
	return $.c3;
};
var $author$project$Pages$CreateProject$getPageClass = F2(
	function (model, _v0) {
		return model.jc ? 'new-user' : '';
	});
var $author$project$Pages$OrgIndex$getPageClass = function (model) {
	return model.vO;
};
var $author$project$Pages$Orgs$getPageClass = function (model) {
	return model.vO;
};
var $author$project$Pages$ProjectConfig$getProject = function (model) {
	return model.c5;
};
var $author$project$Pages$ProjectConfigAdvanced$getProject = function (model) {
	return model.c5;
};
var $author$project$Pages$ProjectSettings$getProject = function (model) {
	return model.c5;
};
var $author$project$Pages$ProjectSettingsBranches$getProject = function (model) {
	return model.c5;
};
var $author$project$Pages$ProjectSettingsHAR$getProject = function ($) {
	return $.c5;
};
var $author$project$Pages$CreateProject$headerContent = F2(
	function (session, model) {
		var content = function () {
			var _v0 = _Utils_Tuple2(model.A9, model.jc);
			if (!_v0.a.$) {
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('auto-create-message')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Creating project...')
							]))
					]);
			} else {
				if (_v0.b) {
					var _v1 = _v0.a;
					return _List_fromArray(
						[
							$elm$html$Html$text(
							'Welcome, ' + ($author$project$Model$Session$getUsername(session) + '!'))
						]);
				} else {
					var _v2 = _v0.a;
					return _List_fromArray(
						[
							$elm$html$Html$text('Create a New Project')
						]);
				}
			}
		}();
		return _List_fromArray(
			[
				A2($elm$html$Html$h1, _List_Nil, content)
			]);
	});
var $author$project$Pages$ImportProject$headerContent = _List_fromArray(
	[
		A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('import-wizard-header')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('header-icon')
					]),
				_List_fromArray(
					[
						$author$project$Views$Icon$view(
						$author$project$Views$Icon$icon(31))
					])),
				A2(
				$elm$html$Html$h1,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Scan a GitHub Project')
					])),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('header-subtitle')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Create a Platform runtime to support a GitHub project')
					]))
			]))
	]);
var $author$project$Views$SiteWrapper$VerifyEmailHeader = function (a) {
	return {$: 3, a: a};
};
var $author$project$Views$Layout$leanLayout = F4(
	function (pageClass, content, session, pageState) {
		return $author$project$Views$SiteWrapper$toHtml(
			A2(
				$author$project$Views$SiteWrapper$with,
				$author$project$Views$SiteWrapper$ActiveStateHeader(
					{z9: false, hT: $elm$core$Maybe$Nothing}),
				A2(
					$author$project$Views$SiteWrapper$with,
					$author$project$Views$SiteWrapper$VerifyEmailHeader(false),
					A2(
						$author$project$Views$SiteWrapper$with,
						$author$project$Views$SiteWrapper$PageClass(pageClass),
						A2(
							$author$project$Views$SiteWrapper$with,
							$author$project$Views$SiteWrapper$PageStateData(pageState),
							A2(
								$author$project$Views$SiteWrapper$with,
								$author$project$Views$SiteWrapper$SessionData(session),
								A2(
									$author$project$Views$SiteWrapper$with,
									$author$project$Views$SiteWrapper$PageFooter($author$project$Views$Layout$footer),
									A2(
										$author$project$Views$SiteWrapper$with,
										$author$project$Views$SiteWrapper$PageContent(
											_List_fromArray(
												[content])),
										$author$project$Views$SiteWrapper$newSiteWrapper))))))));
	});
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $author$project$Pages$OrgPolicy$members = function (model) {
	return model.hB;
};
var $author$project$Pages$OrgScan$members = function (model) {
	return model.hB;
};
var $author$project$Pages$OrgSettings$members = function (model) {
	return model.hB;
};
var $author$project$Msg$NavigateOrgDropdown = function (a) {
	return {$: 14, a: a};
};
var $author$project$Model$Session$isSuperReader = A2($elm$core$Basics$composeR, $author$project$Model$Session$getUser, $author$project$Model$User$isSuperReader);
var $elm_community$list_extra$List$Extra$maximumBy = F2(
	function (f, ls) {
		var maxBy = F2(
			function (x, _v1) {
				var y = _v1.a;
				var fy = _v1.b;
				var fx = f(x);
				return (_Utils_cmp(fx, fy) > 0) ? _Utils_Tuple2(x, fx) : _Utils_Tuple2(y, fy);
			});
		if (ls.b) {
			if (!ls.b.b) {
				var l_ = ls.a;
				return $elm$core$Maybe$Just(l_);
			} else {
				var l_ = ls.a;
				var ls_ = ls.b;
				return $elm$core$Maybe$Just(
					A3(
						$elm$core$List$foldl,
						maxBy,
						_Utils_Tuple2(
							l_,
							f(l_)),
						ls_).a);
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Model$Route$orgDependencies = function (orgName) {
	return $author$project$Model$Route$Protected(
		$author$project$Model$Route$Org(
			A2($author$project$Model$Route$OrgParams, orgName, $author$project$Model$Route$OrgDependencies)));
};
var $author$project$Model$Route$orgPolicy = function (orgName) {
	return $author$project$Model$Route$Protected(
		$author$project$Model$Route$Org(
			A2($author$project$Model$Route$OrgParams, orgName, $author$project$Model$Route$OrgPolicy)));
};
var $author$project$Model$Route$orgSecurity = function (orgName) {
	return $author$project$Model$Route$Protected(
		$author$project$Model$Route$Org(
			A2($author$project$Model$Route$OrgParams, orgName, $author$project$Model$Route$OrgSecurity)));
};
var $author$project$Views$OrgSelector$orgSelector = function (_v0) {
	var isOpen = _v0.Du;
	var openListMsg = _v0.EW;
	var orgToHighlight = _v0.EZ;
	var orgs = _v0.rJ;
	var isMemberOfActiveOrg = _v0.Dq;
	var currentOrg = _v0.B5;
	var onOrgSelectMsg = _v0.EO;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('org-dropdown-wrapper')
			]),
		_List_fromArray(
			[
				isMemberOfActiveOrg ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(openListMsg),
						$elm$html$Html$Attributes$class('org-dropdown'),
						$elm$html$Html$Attributes$id('org-dropdown'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('expanded', isOpen)
							]))
					]),
				_List_fromArray(
					[
						$author$project$Views$Icon$view(
						$author$project$Views$Icon$icon(33)),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('organization-label')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Organization')
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('organization-name')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(currentOrg)
							])),
						$author$project$Views$Icon$view(
						$author$project$Views$Icon$icon(12))
					])) : A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('org-indicator-not-member')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Views$Link$link,
						$author$project$Model$Route$Protected(
							$author$project$Model$Route$Home(
								{wd: $elm$core$Maybe$Nothing})),
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('back-to-my-org')
							]),
						_List_fromArray(
							[
								$author$project$Views$Icon$view(
								$author$project$Views$Icon$icon(33))
							])),
						A2(
						$elm$html$Html$h1,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(currentOrg)
							]))
					])),
				A2(
				$author$project$Misc$displayIf,
				isOpen,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('org-list')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Your organizations')
								])),
							A2(
							$author$project$Misc$displayIf,
							$elm$core$List$isEmpty(orgs),
							A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('You do not belong to any organizations.')
									]))),
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (o) {
									var tierName = $author$project$Model$Tier$simpleTierDisplayString(
										$author$project$Model$Tier$stringToSimpleTier(o.dc));
									return A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('organization-link'),
														$elm$html$Html$Attributes$classList(
														_List_fromArray(
															[
																_Utils_Tuple2(
																'highlight highlight-animation',
																_Utils_eq(o.AC, orgToHighlight))
															])),
														$elm$html$Html$Events$onClick(
														onOrgSelectMsg(o.AC)),
														$elm$html$Html$Attributes$classList(
														_List_fromArray(
															[
																_Utils_Tuple2(
																'selected',
																_Utils_eq(o.AC, currentOrg))
															]))
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('organization-name')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(o.AC)
															])),
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('organization-tier badge'),
																$elm$html$Html$Attributes$class(tierName)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(tierName)
															]))
													]))
											]));
								},
								orgs)),
							A2(
							$author$project$Misc$displayIf,
							$elm$core$List$length(orgs) === 1,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('organization-explanation')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h4,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('What are organizations?')
											])),
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Organizations in the ActiveState platform let you group and organize all of the open source you are using in one place, making observability and remediation seamless and collaborative.')
											]))
									]))),
							A3(
							$author$project$Views$Link$link,
							$author$project$Model$Route$Protected(
								$author$project$Model$Route$CreateOrganization(
									{h3: $elm$core$Maybe$Nothing, dg: $elm$core$Maybe$Nothing})),
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('primary-button small')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Create Organization')
								])),
							A2(
							$author$project$Misc$displayIf,
							$elm$core$List$length(orgs) > 1,
							A3(
								$author$project$Views$Link$link,
								$author$project$Model$Route$Protected($author$project$Model$Route$Orgs),
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('manage-orgs-link')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Manage Organizations')
									])))
						])))
			]));
};
var $author$project$Model$Route$orgSettings = function (orgName) {
	return $author$project$Model$Route$Protected(
		$author$project$Model$Route$Org(
			A2($author$project$Model$Route$OrgParams, orgName, $author$project$Model$Route$OrgSettings)));
};
var $author$project$Views$Layout$isOrgTabActive = F3(
	function (tabClass, orgName, pagePath) {
		return ((tabClass === 'dashboard') && _Utils_eq(
			$elm$core$String$toLower(pagePath),
			$elm$core$String$toLower(orgName))) || _Utils_eq(tabClass, pagePath);
	});
var $author$project$Views$Layout$orgTabs = F3(
	function (currentRouteString, orgName, items) {
		var pagePath = A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm_community$list_extra$List$Extra$last(
				A2($elm$core$String$split, '/', currentRouteString)));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tabs'),
					$elm$html$Html$Attributes$class(pagePath)
				]),
			A2(
				$elm$core$List$map,
				function (_v0) {
					var route = _v0.fo;
					var className = _v0.BD;
					var label = _v0.b2;
					var icon = _v0.cV;
					return A3(
						$author$project$Views$Link$link,
						route,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2(className, true),
										_Utils_Tuple2(
										'active',
										A3($author$project$Views$Layout$isOrgTabActive, className, orgName, pagePath))
									]))
							]),
						_List_fromArray(
							[
								$author$project$Views$Icon$view(
								$author$project$Views$Icon$icon(icon)),
								$elm$html$Html$text(label)
							]));
				},
				items));
	});
var $elm$html$Html$strong = _VirtualDom_node('strong');
var $author$project$Views$Badge$view = function (_v0) {
	var content = _v0.dH;
	var icon = _v0.cV;
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('badge')
			]),
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$html$Html$text(''),
				A2($elm$core$Maybe$map, $author$project$Views$Icon$view, icon)),
				$elm$html$Html$text(content)
			]));
};
var $author$project$Model$Tier$tierBadge = function (tier) {
	var simpleTier = $author$project$Model$Tier$stringToSimpleTier(tier);
	var tierName = $author$project$Model$Tier$simpleTierDisplayString(simpleTier);
	return $author$project$Views$Badge$view(
		{
			dH: function () {
				_v0$2:
				while (true) {
					switch (simpleTier.$) {
						case 2:
							return tierName + ' Account';
						case 3:
							if (simpleTier.a) {
								return tierName;
							} else {
								break _v0$2;
							}
						default:
							break _v0$2;
					}
				}
				return tierName + ' Tier';
			}(),
			cV: $elm$core$Maybe$Nothing
		});
};
var $author$project$Model$Role$toDisplayString = function (role) {
	switch (role) {
		case 2:
			return 'Admin';
		case 1:
			return 'Editor';
		default:
			return 'Read-only';
	}
};
var $author$project$Views$Invitations$AcceptInvite = function (a) {
	return {$: 1, a: a};
};
var $author$project$Views$Invitations$DeclineInvite = function (a) {
	return {$: 3, a: a};
};
var $ryan_haskell$date_format$DateFormat$DayOfMonthSuffix = {$: 6};
var $ryan_haskell$date_format$DateFormat$dayOfMonthSuffix = $ryan_haskell$date_format$DateFormat$DayOfMonthSuffix;
var $ryan_haskell$date_format$DateFormat$Language$Language = F6(
	function (toMonthName, toMonthAbbreviation, toWeekdayName, toWeekdayAbbreviation, toAmPm, toOrdinalSuffix) {
		return {GA: toAmPm, GB: toMonthAbbreviation, GC: toMonthName, nG: toOrdinalSuffix, GD: toWeekdayAbbreviation, GE: toWeekdayName};
	});
var $ryan_haskell$date_format$DateFormat$Language$toEnglishAmPm = function (hour) {
	return (hour > 11) ? 'pm' : 'am';
};
var $ryan_haskell$date_format$DateFormat$Language$toEnglishMonthName = function (month) {
	switch (month) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $ryan_haskell$date_format$DateFormat$Language$toEnglishSuffix = function (num) {
	var _v0 = A2($elm$core$Basics$modBy, 100, num);
	switch (_v0) {
		case 11:
			return 'th';
		case 12:
			return 'th';
		case 13:
			return 'th';
		default:
			var _v1 = A2($elm$core$Basics$modBy, 10, num);
			switch (_v1) {
				case 1:
					return 'st';
				case 2:
					return 'nd';
				case 3:
					return 'rd';
				default:
					return 'th';
			}
	}
};
var $ryan_haskell$date_format$DateFormat$Language$toEnglishWeekdayName = function (weekday) {
	switch (weekday) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $ryan_haskell$date_format$DateFormat$Language$english = A6(
	$ryan_haskell$date_format$DateFormat$Language$Language,
	$ryan_haskell$date_format$DateFormat$Language$toEnglishMonthName,
	A2(
		$elm$core$Basics$composeR,
		$ryan_haskell$date_format$DateFormat$Language$toEnglishMonthName,
		$elm$core$String$left(3)),
	$ryan_haskell$date_format$DateFormat$Language$toEnglishWeekdayName,
	A2(
		$elm$core$Basics$composeR,
		$ryan_haskell$date_format$DateFormat$Language$toEnglishWeekdayName,
		$elm$core$String$left(3)),
	$ryan_haskell$date_format$DateFormat$Language$toEnglishAmPm,
	$ryan_haskell$date_format$DateFormat$Language$toEnglishSuffix);
var $ryan_haskell$date_format$DateFormat$amPm = F3(
	function (language, zone, posix) {
		return language.GA(
			A2($elm$time$Time$toHour, zone, posix));
	});
var $ryan_haskell$date_format$DateFormat$dayOfMonth = $elm$time$Time$toDay;
var $elm$time$Time$Sun = 6;
var $elm$time$Time$Fri = 4;
var $elm$time$Time$Mon = 0;
var $elm$time$Time$Sat = 5;
var $elm$time$Time$Thu = 3;
var $elm$time$Time$Tue = 1;
var $elm$time$Time$Wed = 2;
var $ryan_haskell$date_format$DateFormat$days = _List_fromArray(
	[6, 0, 1, 2, 3, 4, 5]);
var $elm$time$Time$toWeekday = F2(
	function (zone, time) {
		var _v0 = A2(
			$elm$core$Basics$modBy,
			7,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60 * 24));
		switch (_v0) {
			case 0:
				return 3;
			case 1:
				return 4;
			case 2:
				return 5;
			case 3:
				return 6;
			case 4:
				return 0;
			case 5:
				return 1;
			default:
				return 2;
		}
	});
var $ryan_haskell$date_format$DateFormat$dayOfWeek = F2(
	function (zone, posix) {
		return function (_v1) {
			var i = _v1.a;
			return i;
		}(
			A2(
				$elm$core$Maybe$withDefault,
				_Utils_Tuple2(0, 6),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v0) {
							var day = _v0.b;
							return _Utils_eq(
								day,
								A2($elm$time$Time$toWeekday, zone, posix));
						},
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (i, day) {
									return _Utils_Tuple2(i, day);
								}),
							$ryan_haskell$date_format$DateFormat$days)))));
	});
var $ryan_haskell$date_format$DateFormat$isLeapYear = function (year_) {
	return (!(!A2($elm$core$Basics$modBy, 4, year_))) ? false : ((!(!A2($elm$core$Basics$modBy, 100, year_))) ? true : ((!(!A2($elm$core$Basics$modBy, 400, year_))) ? false : true));
};
var $ryan_haskell$date_format$DateFormat$daysInMonth = F2(
	function (year_, month) {
		switch (month) {
			case 0:
				return 31;
			case 1:
				return $ryan_haskell$date_format$DateFormat$isLeapYear(year_) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $ryan_haskell$date_format$DateFormat$months = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]);
var $ryan_haskell$date_format$DateFormat$monthPair = F2(
	function (zone, posix) {
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(0, 0),
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var i = _v0.a;
						var m = _v0.b;
						return _Utils_eq(
							m,
							A2($elm$time$Time$toMonth, zone, posix));
					},
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (a, b) {
								return _Utils_Tuple2(a, b);
							}),
						$ryan_haskell$date_format$DateFormat$months))));
	});
var $ryan_haskell$date_format$DateFormat$monthNumber_ = F2(
	function (zone, posix) {
		return 1 + function (_v0) {
			var i = _v0.a;
			var m = _v0.b;
			return i;
		}(
			A2($ryan_haskell$date_format$DateFormat$monthPair, zone, posix));
	});
var $ryan_haskell$date_format$DateFormat$dayOfYear = F2(
	function (zone, posix) {
		var monthsBeforeThisOne = A2(
			$elm$core$List$take,
			A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix) - 1,
			$ryan_haskell$date_format$DateFormat$months);
		var daysBeforeThisMonth = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				$ryan_haskell$date_format$DateFormat$daysInMonth(
					A2($elm$time$Time$toYear, zone, posix)),
				monthsBeforeThisOne));
		return daysBeforeThisMonth + A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix);
	});
var $ryan_haskell$date_format$DateFormat$quarter = F2(
	function (zone, posix) {
		return (A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix) / 4) | 0;
	});
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $ryan_haskell$date_format$DateFormat$toFixedLength = F2(
	function (totalChars, num) {
		var numStr = $elm$core$String$fromInt(num);
		var numZerosNeeded = totalChars - $elm$core$String$length(numStr);
		var zeros = A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				function (_v0) {
					return '0';
				},
				A2($elm$core$List$range, 1, numZerosNeeded)));
		return _Utils_ap(zeros, numStr);
	});
var $ryan_haskell$date_format$DateFormat$toNonMilitary = function (num) {
	return (!num) ? 12 : ((num <= 12) ? num : (num - 12));
};
var $elm$core$String$toUpper = _String_toUpper;
var $ryan_haskell$date_format$DateFormat$millisecondsPerYear = $elm$core$Basics$round((((1000 * 60) * 60) * 24) * 365.25);
var $ryan_haskell$date_format$DateFormat$firstDayOfYear = F2(
	function (zone, time) {
		return $elm$time$Time$millisToPosix(
			$ryan_haskell$date_format$DateFormat$millisecondsPerYear * A2($elm$time$Time$toYear, zone, time));
	});
var $ryan_haskell$date_format$DateFormat$weekOfYear = F2(
	function (zone, posix) {
		var firstDay = A2($ryan_haskell$date_format$DateFormat$firstDayOfYear, zone, posix);
		var firstDayOffset = A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, firstDay);
		var daysSoFar = A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix);
		return (((daysSoFar + firstDayOffset) / 7) | 0) + 1;
	});
var $ryan_haskell$date_format$DateFormat$year = F2(
	function (zone, time) {
		return $elm$core$String$fromInt(
			A2($elm$time$Time$toYear, zone, time));
	});
var $ryan_haskell$date_format$DateFormat$piece = F4(
	function (language, zone, posix, token) {
		switch (token.$) {
			case 0:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 1:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.nG(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 2:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 3:
				return language.GB(
					A2($elm$time$Time$toMonth, zone, posix));
			case 4:
				return language.GC(
					A2($elm$time$Time$toMonth, zone, posix));
			case 17:
				return $elm$core$String$fromInt(
					1 + A2($ryan_haskell$date_format$DateFormat$quarter, zone, posix));
			case 18:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.nG(num));
				}(
					1 + A2($ryan_haskell$date_format$DateFormat$quarter, zone, posix));
			case 5:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 6:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.nG(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 7:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 8:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 9:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.nG(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 10:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					3,
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 11:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, posix));
			case 12:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.nG(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, posix));
			case 13:
				return language.GD(
					A2($elm$time$Time$toWeekday, zone, posix));
			case 14:
				return language.GE(
					A2($elm$time$Time$toWeekday, zone, posix));
			case 19:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 20:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.nG(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 21:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 15:
				return A2(
					$elm$core$String$right,
					2,
					A2($ryan_haskell$date_format$DateFormat$year, zone, posix));
			case 16:
				return A2($ryan_haskell$date_format$DateFormat$year, zone, posix);
			case 22:
				return $elm$core$String$toUpper(
					A3($ryan_haskell$date_format$DateFormat$amPm, language, zone, posix));
			case 23:
				return $elm$core$String$toLower(
					A3($ryan_haskell$date_format$DateFormat$amPm, language, zone, posix));
			case 24:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toHour, zone, posix));
			case 25:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toHour, zone, posix));
			case 26:
				return $elm$core$String$fromInt(
					$ryan_haskell$date_format$DateFormat$toNonMilitary(
						A2($elm$time$Time$toHour, zone, posix)));
			case 27:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					$ryan_haskell$date_format$DateFormat$toNonMilitary(
						A2($elm$time$Time$toHour, zone, posix)));
			case 28:
				return $elm$core$String$fromInt(
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 29:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 30:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMinute, zone, posix));
			case 31:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toMinute, zone, posix));
			case 32:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toSecond, zone, posix));
			case 33:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toSecond, zone, posix));
			case 34:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMillis, zone, posix));
			case 35:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					3,
					A2($elm$time$Time$toMillis, zone, posix));
			default:
				var string = token.a;
				return string;
		}
	});
var $ryan_haskell$date_format$DateFormat$formatWithLanguage = F4(
	function (language, tokens, zone, time) {
		return A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				A3($ryan_haskell$date_format$DateFormat$piece, language, zone, time),
				tokens));
	});
var $ryan_haskell$date_format$DateFormat$format = $ryan_haskell$date_format$DateFormat$formatWithLanguage($ryan_haskell$date_format$DateFormat$Language$english);
var $ryan_haskell$date_format$DateFormat$MonthNameAbbreviated = {$: 3};
var $ryan_haskell$date_format$DateFormat$monthNameAbbreviated = $ryan_haskell$date_format$DateFormat$MonthNameAbbreviated;
var $ryan_haskell$date_format$DateFormat$Text = function (a) {
	return {$: 36, a: a};
};
var $ryan_haskell$date_format$DateFormat$text = $ryan_haskell$date_format$DateFormat$Text;
var $ryan_haskell$date_format$DateFormat$YearNumber = {$: 16};
var $ryan_haskell$date_format$DateFormat$yearNumber = $ryan_haskell$date_format$DateFormat$YearNumber;
var $author$project$Views$Invitations$formatDate = F2(
	function (localTimezone, date) {
		return A3(
			$ryan_haskell$date_format$DateFormat$format,
			_List_fromArray(
				[
					$ryan_haskell$date_format$DateFormat$monthNameAbbreviated,
					$ryan_haskell$date_format$DateFormat$text(' '),
					$ryan_haskell$date_format$DateFormat$dayOfMonthSuffix,
					$ryan_haskell$date_format$DateFormat$text(', '),
					$ryan_haskell$date_format$DateFormat$yearNumber
				]),
			localTimezone,
			date);
	});
var $author$project$Model$Session$getLocalTimezone = function (_v0) {
	var session = _v0;
	return session.rp;
};
var $author$project$Views$Invitations$invitationView = F2(
	function (session, _v0) {
		var email = _v0.lJ;
		var inviteCode = _v0.fs;
		var changed = _v0.g;
		var organization = _v0.c3;
		var orgName = organization.AC;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('org-member pending-member')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('username')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(organization.AC),
									$elm$html$Html$Attributes$class('org-name')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(orgName)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('timestamp')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Invited on '),
									$elm$html$Html$text(
									A2(
										$author$project$Views$Invitations$formatDate,
										$author$project$Model$Session$getLocalTimezone(session),
										changed))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row-actions')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('primary-button small'),
									$elm$html$Html$Events$onClick(
									$author$project$Views$Invitations$AcceptInvite(
										{lJ: email, fs: inviteCode, ix: orgName}))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Accept')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('red-button small'),
									$elm$html$Html$Events$onClick(
									$author$project$Views$Invitations$DeclineInvite(
										{lJ: email, ix: orgName}))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Decline')
								]))
						]))
				]));
	});
var $author$project$Views$Invitations$view = F2(
	function (showEmpty, session) {
		var viewInvitations = A2(
			$elm$core$List$map,
			$author$project$Views$Invitations$invitationView(session),
			$author$project$Model$Session$getInvitations(session));
		var show = showEmpty ? true : ((!showEmpty) && (!(!$elm$core$List$length(
			$author$project$Model$Session$getInvitations(session)))));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pending-member-list-wrapper new-box'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('hide', !show)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Pending Invites'),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('item-count')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(
										$elm$core$List$length(viewInvitations)))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pending-member-list')
						]),
					viewInvitations)
				]));
	});
var $author$project$Views$Columns$withColumnAttrs = F2(
	function (attrs, columns) {
		return _Utils_update(
			columns,
			{qF: attrs});
	});
var $author$project$Views$Layout$orgHeader = F3(
	function (model, pageState, session) {
		var routeString = $author$project$Model$Route$routeToString(
			$author$project$PageState$getCurrentRoute(pageState));
		var orgs = function () {
			var _v0 = $author$project$Model$Session$getUser(session);
			if (!_v0.$) {
				var user = _v0.a;
				return A2(
					$elm$core$List$sortBy,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.AC;
						},
						$elm$core$String$toLower),
					user.mX);
			} else {
				return _List_Nil;
			}
		}();
		var orgJoinedInLast10Seconsds = A2(
			$elm$core$Maybe$withDefault,
			'',
			A3(
				$elm$core$Maybe$map2,
				F2(
					function (ct, membership) {
						return (($elm$time$Time$posixToMillis(ct) - $elm$time$Time$posixToMillis(membership.DM)) <= 10000) ? membership.AC : '';
					}),
				model.cF,
				A2(
					$elm$core$Maybe$andThen,
					$elm_community$list_extra$List$Extra$maximumBy(
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.DM;
							},
							$elm$time$Time$posixToMillis)),
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.mX;
						},
						$author$project$Model$Session$getUser(session)))));
		var org = model.c3;
		var memberCountString = $elm$core$String$fromInt(
			$elm$core$List$length(model.hB));
		var maybeUser = $author$project$Model$Session$getUser(session);
		var userRoleName = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				A2($elm$core$Basics$composeR, $author$project$Model$Role$toDisplayString, $elm_community$string_extra$String$Extra$toTitleCase),
				A2(
					$elm$core$Maybe$andThen,
					$author$project$Model$User$role(org.AC),
					maybeUser)));
		var isSuperReader = $author$project$Model$Session$isSuperReader(session);
		var isMember = A2($author$project$Model$Session$isMember, model.c3.AC, session);
		var canViewOrgPrivateInfo = A2($author$project$Model$Permissions$canViewOrgPrivateInfo, org.AC, maybeUser);
		var dashTabs = function (memberCount) {
			var vulnerabilitiesTab = A2($author$project$Model$Permissions$canViewOrgSecurity, org, maybeUser) ? _List_fromArray(
				[
					{
					BD: 'security',
					cV: 83,
					b2: 'Vulnerabilities (CVEs)',
					fo: $author$project$Model$Route$orgSecurity(org.AC)
				}
				]) : _List_Nil;
			var settingsTab = A2($author$project$Model$Permissions$canChangeOrgSettings, org.AC, maybeUser) ? _List_fromArray(
				[
					{
					BD: 'settings',
					cV: 30,
					b2: 'Settings',
					fo: $author$project$Model$Route$orgSettings(org.AC)
				}
				]) : _List_Nil;
			var policyTab = A2($author$project$Model$Permissions$canViewOrgPolicy, org, maybeUser) ? _List_fromArray(
				[
					{
					BD: 'policy',
					cV: 30,
					b2: 'Policies',
					fo: $author$project$Model$Route$orgPolicy(org.AC)
				}
				]) : _List_Nil;
			var membersTab = canViewOrgPrivateInfo ? _List_fromArray(
				[
					{
					BD: 'members',
					cV: 49,
					b2: 'Members (' + (memberCount + ')'),
					fo: $author$project$Model$Route$orgMembers(org.AC)
				}
				]) : _List_Nil;
			var dependenciesTab = A2($author$project$Model$Permissions$canViewOrgDependencies, org, maybeUser) ? _List_fromArray(
				[
					{
					BD: 'dependencies',
					cV: 57,
					b2: 'Dependencies',
					fo: $author$project$Model$Route$orgDependencies(org.AC)
				}
				]) : _List_Nil;
			var dashboardTab = _List_fromArray(
				[
					{
					BD: 'dashboard',
					cV: 18,
					b2: 'Dashboard',
					fo: A2($author$project$Model$Route$orgIndex, org.AC, $elm$core$Maybe$Nothing)
				}
				]);
			return _Utils_ap(
				dashboardTab,
				_Utils_ap(
					vulnerabilitiesTab,
					_Utils_ap(
						dependenciesTab,
						_Utils_ap(
							membersTab,
							_Utils_ap(policyTab, settingsTab)))));
		};
		return A2(
			$author$project$Views$Layout$pageHeader,
			_List_fromArray(
				[
					_Utils_Tuple2('page-header', true),
					_Utils_Tuple2('type-organization', true)
				]),
			_List_fromArray(
				[
					$author$project$Views$Columns$asHtml(
					A2(
						$author$project$Views$Columns$withColumnAttrs,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('narrow')
							]),
						A2(
							$author$project$Views$Columns$withColumn,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('isNotMember', !isMember)
												]))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('column')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$map,
													$author$project$Msg$OnInvitationEvent,
													A2($author$project$Views$Invitations$view, false, session)),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('org-meta')
														]),
													_List_fromArray(
														[
															$author$project$Views$OrgSelector$orgSelector(
															{
																B5: org.AC,
																Dq: isMember,
																Du: $author$project$Model$Session$getOrgDropdownOpen(session),
																EO: $author$project$Msg$NavigateOrgDropdown,
																EW: $author$project$Msg$ToggleOrgDropDown,
																EZ: orgJoinedInLast10Seconsds,
																rJ: orgs
															}),
															A2(
															$author$project$Misc$displayIf,
															$author$project$Model$Session$isSuperUserWithFeaturesVisible(session),
															A3(
																$author$project$Views$Link$link,
																$author$project$Model$Route$Protected(
																	$author$project$Model$Route$Admin(
																		$author$project$Model$Route$AdminOrganization(org.AC))),
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('superuser-only')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Manage')
																	]))),
															isMember ? A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('badge')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$strong,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Your Role')
																		])),
																	$elm$html$Html$text(' - '),
																	$elm$html$Html$text(userRoleName)
																])) : A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('badge')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('You are not a member')
																])),
															A2(
															$author$project$Misc$displayIf,
															isSuperReader || isMember,
															$author$project$Model$Tier$tierBadge(org.dc))
														]))
												]))
										]))
								]),
							$author$project$Views$Columns$asColumns($elm$html$Html$section)))),
					A2(
					$author$project$Misc$displayIf,
					isSuperReader || isMember,
					A3(
						$author$project$Views$Layout$orgTabs,
						routeString,
						org.AC,
						dashTabs(memberCountString)))
				]));
	});
var $author$project$Views$SiteWrapper$NothingMore = {$: 9};
var $author$project$Views$SiteWrapper$OutOfComplianceModal = function (a) {
	return {$: 8, a: a};
};
var $author$project$Views$SiteWrapper$withModals = function (modals) {
	var withASHeader = modals.v9 ? $author$project$Views$SiteWrapper$with(
		$author$project$Views$SiteWrapper$ActiveStateHeader(
			{z9: true, hT: modals.hT})) : $author$project$Views$SiteWrapper$with($author$project$Views$SiteWrapper$NothingMore);
	return A2(
		$elm$core$Basics$composeR,
		withASHeader,
		$author$project$Views$SiteWrapper$having(
			$author$project$Views$SiteWrapper$OutOfComplianceModal(modals.hS)));
};
var $author$project$Views$Layout$orgLayout = F5(
	function (model, pageClass, content, session, pageState) {
		var withHeader = $author$project$Views$SiteWrapper$with(
			$author$project$Views$SiteWrapper$PageHeader(
				A3($author$project$Views$Layout$orgHeader, model, pageState, session)));
		return $author$project$Views$SiteWrapper$toHtml(
			A2(
				$author$project$Views$SiteWrapper$withModals,
				model.fd,
				A2(
					$author$project$Views$SiteWrapper$with,
					$author$project$Views$SiteWrapper$PageClass(pageClass),
					A2(
						$author$project$Views$SiteWrapper$with,
						$author$project$Views$SiteWrapper$PageStateData(pageState),
						A2(
							$author$project$Views$SiteWrapper$with,
							$author$project$Views$SiteWrapper$SessionData(session),
							A2(
								$author$project$Views$SiteWrapper$with,
								$author$project$Views$SiteWrapper$PageFooter($author$project$Views$Layout$footer),
								A2(
									$author$project$Views$SiteWrapper$with,
									$author$project$Views$SiteWrapper$PageContent(
										_List_fromArray(
											[content])),
									withHeader($author$project$Views$SiteWrapper$newSiteWrapper))))))));
	});
var $author$project$Pages$OrgPolicy$organization = function (model) {
	return model.c3;
};
var $author$project$Pages$OrgScan$organization = function (model) {
	return model.c3;
};
var $author$project$Pages$ProjectSettings$organization = function (model) {
	return model.c3;
};
var $author$project$Views$Layout$orgsLayout = F5(
	function (modals, pageClass, content, session, pageState) {
		return $author$project$Views$SiteWrapper$toHtml(
			A2(
				$author$project$Views$SiteWrapper$withModals,
				modals,
				A2(
					$author$project$Views$SiteWrapper$with,
					$author$project$Views$SiteWrapper$PageClass(pageClass),
					A2(
						$author$project$Views$SiteWrapper$with,
						$author$project$Views$SiteWrapper$PageStateData(pageState),
						A2(
							$author$project$Views$SiteWrapper$with,
							$author$project$Views$SiteWrapper$SessionData(session),
							A2(
								$author$project$Views$SiteWrapper$with,
								$author$project$Views$SiteWrapper$PageFooter($author$project$Views$Layout$footer),
								A2(
									$author$project$Views$SiteWrapper$with,
									$author$project$Views$SiteWrapper$PageContent(
										_List_fromArray(
											[content])),
									$author$project$Views$SiteWrapper$newSiteWrapper)))))));
	});
var $author$project$Pages$Checkout$pageClass = 'checkout-process';
var $author$project$Pages$AdminFork$pageHeading = function (model) {
	return 'Fork the \"' + ($author$project$Model$Project$getName(model.hU) + '\" Project');
};
var $author$project$Pages$CreateOrganization$pageHeading = 'Create a New Organization';
var $author$project$Pages$ForkProject$pageHeading = function (model) {
	var projectName = $author$project$Model$Project$getName(model.hU);
	return 'Fork the \"' + (projectName + '\" Project');
};
var $author$project$Pages$NotFound$pageHeading = 'Oops—we can\'t find this page!';
var $author$project$Pages$PublicProjects$pageHeading = 'Featured Projects';
var $author$project$Pages$StateToolCheatSheet$pageHeading = 'State Tool Command Cheat Sheet';
var $author$project$Pages$Support$pageHeading = 'Support';
var $author$project$Pages$AdminFork$pageSubHeading = '';
var $author$project$Pages$ForkProject$pageSubHeading = '';
var $author$project$Pages$NotFound$pageSubHeading = '';
var $author$project$Pages$PublicProjects$pageSubHeading = '';
var $author$project$Pages$StateToolCheatSheet$pageSubHeading = 'Common commands to manage your Python, Perl or Ruby runtime with our CLI utility.';
var $author$project$Pages$Support$pageSubHeading = '';
var $author$project$Views$Layout$headingWithSub = F2(
	function (heading_, subHeading_) {
		return _List_fromArray(
			[
				$author$project$Views$Layout$heading(heading_),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('header-subtitle')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(subHeading_)
					]))
			]);
	});
var $author$project$Views$Layout$plainLayoutCustomHeader = F7(
	function (modals, pageClass, headerContent, showVerifyEmailHeader, content, session, pageState) {
		return $author$project$Views$SiteWrapper$toHtml(
			A2(
				$author$project$Views$SiteWrapper$withModals,
				modals,
				A2(
					$author$project$Views$SiteWrapper$with,
					$author$project$Views$SiteWrapper$VerifyEmailHeader(showVerifyEmailHeader),
					A2(
						$author$project$Views$SiteWrapper$with,
						$author$project$Views$SiteWrapper$PageClass(pageClass),
						A2(
							$author$project$Views$SiteWrapper$with,
							$author$project$Views$SiteWrapper$PageStateData(pageState),
							A2(
								$author$project$Views$SiteWrapper$with,
								$author$project$Views$SiteWrapper$SessionData(session),
								A2(
									$author$project$Views$SiteWrapper$with,
									$author$project$Views$SiteWrapper$PageFooter($author$project$Views$Layout$footer),
									A2(
										$author$project$Views$SiteWrapper$with,
										$author$project$Views$SiteWrapper$PageContent(
											_List_fromArray(
												[content])),
										A2(
											$author$project$Views$SiteWrapper$with,
											$author$project$Views$SiteWrapper$PageHeader(
												A2($author$project$Views$Layout$pageHeader, _List_Nil, headerContent)),
											$author$project$Views$SiteWrapper$newSiteWrapper)))))))));
	});
var $author$project$Views$Layout$plainLayout = F8(
	function (modals, pageClass, pageHeading, pageSubHeading, showVerifyEmailHeader, content, session, pageState) {
		return A7(
			$author$project$Views$Layout$plainLayoutCustomHeader,
			modals,
			pageClass,
			A2($author$project$Views$Layout$headingWithSub, pageHeading, pageSubHeading),
			showVerifyEmailHeader,
			content,
			session,
			pageState);
	});
var $author$project$Views$Layout$plainLayoutNoHeader = F6(
	function (modals, pageClass, showVerifyEmailHeader, content, session, pageState) {
		return $author$project$Views$SiteWrapper$toHtml(
			A2(
				$author$project$Views$SiteWrapper$withModals,
				modals,
				A2(
					$author$project$Views$SiteWrapper$with,
					$author$project$Views$SiteWrapper$VerifyEmailHeader(showVerifyEmailHeader),
					A2(
						$author$project$Views$SiteWrapper$with,
						$author$project$Views$SiteWrapper$PageClass(pageClass),
						A2(
							$author$project$Views$SiteWrapper$with,
							$author$project$Views$SiteWrapper$PageStateData(pageState),
							A2(
								$author$project$Views$SiteWrapper$with,
								$author$project$Views$SiteWrapper$SessionData(session),
								A2(
									$author$project$Views$SiteWrapper$with,
									$author$project$Views$SiteWrapper$PageFooter($author$project$Views$Layout$footer),
									A2(
										$author$project$Views$SiteWrapper$with,
										$author$project$Views$SiteWrapper$PageContent(
											_List_fromArray(
												[content])),
										$author$project$Views$SiteWrapper$newSiteWrapper))))))));
	});
var $author$project$Utils$DomainUtils$isKSADomain = function (domain) {
	return A2($elm$core$String$contains, 'ksa.activestate.build', domain);
};
var $author$project$Views$Layout$preferenceLayout = F4(
	function (modals, content, session, pageState) {
		var preferencesLinks = function () {
			var linkedAccountsLink = _Utils_Tuple2(
				$author$project$Model$Route$Protected(
					$author$project$Model$Route$PreferenceLinkedAccounts(
						{D3: $elm$core$Maybe$Nothing, F$: $elm$core$Maybe$Nothing})),
				$elm$html$Html$text('Linked Accounts'));
			var isKSADomain = $author$project$Utils$DomainUtils$isKSADomain(
				$author$project$Model$Session$getFlags(session).B3);
			var baseLinks = _List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Model$Route$Protected($author$project$Model$Route$PreferenceEmail),
					$elm$html$Html$text('Email Addresses')),
					_Utils_Tuple2(
					$author$project$Model$Route$Protected(
						$author$project$Model$Route$PreferencePassword(
							{El: $elm$core$Maybe$Nothing})),
					$elm$html$Html$text('Change Password')),
					_Utils_Tuple2(
					$author$project$Model$Route$Protected($author$project$Model$Route$PreferenceTwoFactor),
					$elm$html$Html$text('Two-Factor Authentication')),
					_Utils_Tuple2(
					$author$project$Model$Route$Protected($author$project$Model$Route$PreferenceDeleteAccount),
					$elm$html$Html$text('Delete Account'))
				]);
			return isKSADomain ? baseLinks : _Utils_ap(
				baseLinks,
				_List_fromArray(
					[linkedAccountsLink]));
		}();
		var pageLink = A2(
			$author$project$Views$Layout$navLink,
			$elm$core$Basics$eq,
			$author$project$PageState$getCurrentRoute(pageState));
		return $author$project$Views$SiteWrapper$toHtml(
			A2(
				$author$project$Views$SiteWrapper$withModals,
				modals,
				A2(
					$author$project$Views$SiteWrapper$with,
					$author$project$Views$SiteWrapper$PageClass('user-preferences'),
					A2(
						$author$project$Views$SiteWrapper$with,
						$author$project$Views$SiteWrapper$PageStateData(pageState),
						A2(
							$author$project$Views$SiteWrapper$with,
							$author$project$Views$SiteWrapper$SessionData(session),
							A2(
								$author$project$Views$SiteWrapper$with,
								$author$project$Views$SiteWrapper$PageFooter($author$project$Views$Layout$footer),
								A2(
									$author$project$Views$SiteWrapper$with,
									$author$project$Views$SiteWrapper$PageContent(
										_List_fromArray(
											[
												$author$project$Views$Columns$asHtml(
												A2(
													$author$project$Views$Columns$withColumn,
													_List_fromArray(
														[content]),
													A2(
														$author$project$Views$Columns$withColumnAs,
														$elm$html$Html$section,
														A3(
															$author$project$Views$Columns$withSideNav,
															pageLink,
															preferencesLinks,
															$author$project$Views$Columns$asColumns($elm$html$Html$main_)))))
											])),
									A2(
										$author$project$Views$SiteWrapper$with,
										$author$project$Views$SiteWrapper$PageHeader(
											A2(
												$author$project$Views$Layout$pageHeader,
												_List_Nil,
												$elm$core$List$singleton(
													$author$project$Views$Layout$heading('Account Settings')))),
										$author$project$Views$SiteWrapper$newSiteWrapper))))))));
	});
var $author$project$Model$Route$forkProject = F3(
	function (orgName, projectName, actions) {
		return $author$project$Model$Route$Protected(
			$author$project$Model$Route$Org(
				A2(
					$author$project$Model$Route$OrgParams,
					orgName,
					$author$project$Model$Route$OrgProject(
						A2(
							$author$project$Model$Route$OrgProjectParams,
							projectName,
							$author$project$Model$Route$ProjectFork(actions))))));
	});
var $author$project$Model$Route$getMaybeCommitID = function (route) {
	_v0$2:
	while (true) {
		switch (route.$) {
			case 12:
				var args = route.a;
				return args.gr;
			case 7:
				if (route.a.$ === 14) {
					var orgRoute = route.a.a.vI;
					if (orgRoute.$ === 7) {
						var projectRoute = orgRoute.a.zL;
						switch (projectRoute.$) {
							case 0:
								var args = projectRoute.a;
								return args.gr;
							case 5:
								var commitID = projectRoute.a;
								return commitID;
							case 6:
								var commitID = projectRoute.a;
								return commitID;
							default:
								return $elm$core$Maybe$Nothing;
						}
					} else {
						return $elm$core$Maybe$Nothing;
					}
				} else {
					break _v0$2;
				}
			default:
				break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Views$Icon$Small = {$: 0};
var $author$project$Views$Icon$setSize = F2(
	function (s, _v0) {
		var ikon = _v0;
		return _Utils_update(
			ikon,
			{
				we: $elm$core$Maybe$Just(s)
			});
	});
var $author$project$Views$Icon$small = $author$project$Views$Icon$setSize($author$project$Views$Icon$Small);
var $author$project$Model$Route$withIsShareModalOpen = F2(
	function (isShareModalOpen, args) {
		return _Utils_update(
			args,
			{DD: isShareModalOpen});
	});
var $author$project$Views$Layout$projectHeader = F3(
	function (_v0, model, pageState) {
		var project = model.c5;
		var projectName = $author$project$Model$Project$getName(project);
		var org = model.c3;
		var shareButton = A3(
			$author$project$Views$Link$link,
			$author$project$Model$Route$projectOverview(
				A2(
					$author$project$Model$Route$withIsShareModalOpen,
					true,
					$author$project$Model$Route$projectOverviewParams(
						{ix: org.AC, vT: projectName}))),
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('secondary-button small')
				]),
			_List_fromArray(
				[
					$author$project$Views$Icon$view(
					$author$project$Views$Icon$small(
						$author$project$Views$Icon$icon(70))),
					$elm$html$Html$text('Share')
				]));
		var maybeURLCommitID = $author$project$Model$Route$getMaybeCommitID(
			$author$project$PageState$getCurrentRoute(pageState));
		var managedBanner = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('managed-project-banner')
				]),
			_List_fromArray(
				[
					$author$project$Views$Icon$view(
					$author$project$Views$Icon$icon(0)),
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Managed by ActiveState')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('This project is automatically updated')
						]))
				]));
		var indicator = $author$project$Model$Project$getIsPrivate(project) ? 'Private Project' : 'Public Project';
		return A2(
			$author$project$Views$Layout$pageHeader,
			_List_fromArray(
				[
					_Utils_Tuple2('project-header', true),
					_Utils_Tuple2('page-header', true)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('project-title-wrapper')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('project-title')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Views$Link$link,
									A2($author$project$Model$Route$orgIndex, org.AC, $elm$core$Maybe$Nothing),
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('organization-name')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(org.AC)
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('divider')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('/')
										])),
									A3(
									$author$project$Views$Link$link,
									$author$project$Model$Route$projectOverview(
										A2(
											$author$project$Model$Route$withCommitID,
											maybeURLCommitID,
											A2(
												$author$project$Model$Route$withBranchName,
												model.fO,
												$author$project$Model$Route$projectOverviewParams(
													{ix: org.AC, vT: projectName})))),
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('project-name')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(projectName)
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('project-privacy-indicator badge'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'private-project',
													$author$project$Model$Project$getIsPrivate(project))
												]))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('private-project-icon')
												]),
											_List_fromArray(
												[
													$author$project$Model$Project$getIsPrivate(project) ? $author$project$Views$Icon$view(
													$author$project$Views$Icon$icon(44)) : $author$project$Views$Icon$view(
													$author$project$Views$Icon$icon(45))
												])),
											$elm$html$Html$text(indicator)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('project-header-buttons')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Misc$displayIf,
									!$author$project$Model$Project$getIsDistributionOnly(project),
									A3(
										$author$project$Views$Link$link,
										A3($author$project$Model$Route$forkProject, org.AC, projectName, _List_Nil),
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('secondary-button small')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Fork')
											]))),
									shareButton
								]))
						])),
					A2(
					$author$project$Misc$displayIf,
					$author$project$Model$Project$getIsManaged(project),
					managedBanner)
				]));
	});
var $author$project$Model$Route$adminFork = F2(
	function (orgName, projectName) {
		return $author$project$Model$Route$Protected(
			$author$project$Model$Route$Admin(
				A2($author$project$Model$Route$AdminFork, orgName, projectName)));
	});
var $author$project$Model$Route$projectConfigAdvanced = F2(
	function (_v0, params) {
		var orgName = _v0.ix;
		var projectName = _v0.vT;
		return $author$project$Model$Route$Protected(
			$author$project$Model$Route$Org(
				A2(
					$author$project$Model$Route$OrgParams,
					orgName,
					$author$project$Model$Route$OrgProject(
						A2(
							$author$project$Model$Route$OrgProjectParams,
							projectName,
							$author$project$Model$Route$ProjectConfigAdvanced(params))))));
	});
var $author$project$Model$Route$projectConfigAdvancedParams = {fO: $elm$core$Maybe$Nothing, gr: $elm$core$Maybe$Nothing};
var $author$project$Model$Route$projectSettings = function (_v0) {
	var orgName = _v0.ix;
	var projectName = _v0.vT;
	var maybeBranchName = _v0.fO;
	return $author$project$Model$Route$Protected(
		$author$project$Model$Route$Org(
			A2(
				$author$project$Model$Route$OrgParams,
				orgName,
				$author$project$Model$Route$OrgProject(
					A2(
						$author$project$Model$Route$OrgProjectParams,
						projectName,
						A2($author$project$Model$Route$ProjectSettings, maybeBranchName, $elm$core$Maybe$Nothing))))));
};
var $author$project$Views$Layout$isProjectTabActive = F2(
	function (tabClass, pagePath) {
		var settingsTabCondition = A2($elm$core$String$startsWith, 'settings', pagePath) || (A2($elm$core$String$startsWith, 'branches', pagePath) || A2($elm$core$String$startsWith, 'har', pagePath));
		var scriptsTabCondition = A2($elm$core$String$startsWith, 'scripts', pagePath);
		var historyTabCondition = A2($elm$core$String$startsWith, 'releases', pagePath);
		var deployTabCondition = A2($elm$core$String$startsWith, 'distributions', pagePath);
		var customizeTabCondition = A2($elm$core$String$startsWith, 'customize', pagePath);
		var dashboardTabCondition = (!customizeTabCondition) && ((!scriptsTabCondition) && ((!deployTabCondition) && ((!historyTabCondition) && (!settingsTabCondition))));
		return ((tabClass === 'deploy') && deployTabCondition) ? true : (((tabClass === 'history') && historyTabCondition) ? true : (((tabClass === 'dashboard') && dashboardTabCondition) ? true : (((tabClass === 'customize') && customizeTabCondition) ? true : (((tabClass === 'scripts') && scriptsTabCondition) ? true : (((tabClass === 'settings') && settingsTabCondition) ? true : false)))));
	});
var $author$project$Views$Layout$tab = function (_v0) {
	var path = _v0.pm;
	var route = _v0.fo;
	var tabName = _v0.jx;
	var label = _v0.b2;
	var icon = _v0.cV;
	return A3(
		$author$project$Views$Link$link,
		route,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'active',
						A2($author$project$Views$Layout$isProjectTabActive, tabName, path))
					]))
			]),
		_List_fromArray(
			[
				$author$project$Views$Icon$view(
				$author$project$Views$Icon$icon(icon)),
				$elm$html$Html$text(label)
			]));
};
var $author$project$Views$Layout$projectNavTabs = F3(
	function (model, pageState, session) {
		var routeString = $author$project$Model$Route$routeToString(
			$author$project$PageState$getCurrentRoute(pageState));
		var projectName = $author$project$Model$Project$getName(model.c5);
		var pagePath = A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm_community$list_extra$List$Extra$last(
				A2($elm$core$String$split, '/', routeString)));
		var org = model.c3;
		var maybeURLCommitID = $author$project$Model$Route$getMaybeCommitID(
			$author$project$PageState$getCurrentRoute(pageState));
		var canEditProjects = A2(
			$author$project$Model$Permissions$canEditProjects,
			model.c3.AC,
			$author$project$Model$Session$getUser(session));
		return A2(
			$elm$html$Html$nav,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tabs')
				]),
			_List_fromArray(
				[
					$author$project$Views$Layout$tab(
					{
						cV: 18,
						b2: 'Overview',
						pm: pagePath,
						fo: $author$project$Model$Route$projectOverview(
							A2(
								$author$project$Model$Route$withBranchName,
								model.fO,
								A2(
									$author$project$Model$Route$withCommitID,
									maybeURLCommitID,
									$author$project$Model$Route$projectOverviewParams(
										{ix: org.AC, vT: projectName})))),
						jx: 'dashboard'
					}),
					$author$project$Views$Layout$tab(
					{
						cV: 57,
						b2: 'Configuration',
						pm: pagePath,
						fo: A2(
							$author$project$Model$Route$projectConfig,
							{ix: org.AC, vT: projectName},
							A2(
								$author$project$Model$Route$withBranchName,
								model.fO,
								A2($author$project$Model$Route$withCommitID, maybeURLCommitID, $author$project$Model$Route$projectConfigParams))),
						jx: 'customize'
					}),
					$author$project$Views$Layout$tab(
					{
						cV: 21,
						b2: 'Deploy',
						pm: pagePath,
						fo: $author$project$Model$Route$projectDownloads(
							{uk: false, fO: model.fO, gr: maybeURLCommitID, Ef: $elm$core$Maybe$Nothing, ix: org.AC, vT: projectName}),
						jx: 'deploy'
					}),
					$author$project$Views$Layout$tab(
					{
						cV: 32,
						b2: 'History',
						pm: pagePath,
						fo: $author$project$Model$Route$projectHistory(
							{fO: model.fO, gr: maybeURLCommitID, ix: org.AC, vT: projectName}),
						jx: 'history'
					}),
					A2(
					$author$project$Misc$displayIf,
					canEditProjects,
					$author$project$Views$Layout$tab(
						{
							cV: 30,
							b2: 'Project Settings',
							pm: pagePath,
							fo: $author$project$Model$Route$projectSettings(
								{
									fO: model.fO,
									ix: $author$project$Model$Organization$getUrlName(org),
									vT: projectName
								}),
							jx: 'settings'
						})),
					A2(
					$author$project$Misc$displayIf,
					$author$project$Model$Session$isSuperUserWithFeaturesVisible(session),
					$author$project$Views$Layout$tab(
						{
							cV: 29,
							b2: 'Superuser™ Fork',
							pm: pagePath,
							fo: A2($author$project$Model$Route$adminFork, org.AC, projectName),
							jx: 'fork'
						})),
					A2(
					$author$project$Misc$displayIf,
					$author$project$Model$Session$isSuperUserWithFeaturesVisible(session),
					$author$project$Views$Layout$tab(
						{
							cV: 85,
							b2: 'Advanced',
							pm: pagePath,
							fo: A2(
								$author$project$Model$Route$projectConfigAdvanced,
								{ix: org.AC, vT: projectName},
								A2(
									$author$project$Model$Route$withBranchName,
									model.fO,
									A2($author$project$Model$Route$withCommitID, maybeURLCommitID, $author$project$Model$Route$projectConfigAdvancedParams))),
							jx: 'advanced'
						}))
				]));
	});
var $author$project$Model$Route$projectSettingsBranches = function (_v0) {
	var orgName = _v0.ix;
	var projectName = _v0.vT;
	var maybeBranchName = _v0.fO;
	return $author$project$Model$Route$Protected(
		$author$project$Model$Route$Org(
			A2(
				$author$project$Model$Route$OrgParams,
				orgName,
				$author$project$Model$Route$OrgProject(
					A2(
						$author$project$Model$Route$OrgProjectParams,
						projectName,
						$author$project$Model$Route$ProjectSettingsBranches(maybeBranchName))))));
};
var $author$project$Model$Route$projectSettingsHAR = F2(
	function (_v0, params) {
		var orgName = _v0.ix;
		var projectName = _v0.vT;
		return $author$project$Model$Route$Protected(
			$author$project$Model$Route$Org(
				A2(
					$author$project$Model$Route$OrgParams,
					orgName,
					$author$project$Model$Route$OrgProject(
						A2(
							$author$project$Model$Route$OrgProjectParams,
							projectName,
							$author$project$Model$Route$ProjectSettingsHAR(params))))));
	});
var $author$project$Model$Route$projectSettingsParams = {fO: $elm$core$Maybe$Nothing, gr: $elm$core$Maybe$Nothing};
var $author$project$Views$Layout$projectLayout = F4(
	function (model, content, session, pageState) {
		var topClass = function () {
			var _v4 = $author$project$PageState$getCurrentRoute(pageState);
			_v4$2:
			while (true) {
				switch (_v4.$) {
					case 12:
						return 'project-overview';
					case 7:
						if (_v4.a.$ === 14) {
							var orgRoute = _v4.a.a.vI;
							if (orgRoute.$ === 7) {
								var projectRoute = orgRoute.a.zL;
								switch (projectRoute.$) {
									case 2:
										return 'project-settings';
									case 3:
										return 'project-settings';
									case 4:
										return 'project-settings';
									case 5:
										return 'project-downloads';
									case 6:
										return 'project-history';
									case 0:
										return 'project-configuration';
									default:
										return 'project';
								}
							} else {
								return 'project';
							}
						} else {
							break _v4$2;
						}
					default:
						break _v4$2;
				}
			}
			return 'project';
		}();
		var showSideBar = function () {
			var _v1 = $author$project$PageState$getCurrentRoute(pageState);
			if ((_v1.$ === 7) && (_v1.a.$ === 14)) {
				var orgRoute = _v1.a.a.vI;
				if (orgRoute.$ === 7) {
					var projectRoute = orgRoute.a.zL;
					switch (projectRoute.$) {
						case 2:
							return true;
						case 3:
							return true;
						case 4:
							return true;
						default:
							return false;
					}
				} else {
					return false;
				}
			} else {
				return false;
			}
		}();
		var pageLink = A2(
			$author$project$Views$Layout$navLink,
			$elm$core$Basics$eq,
			$author$project$PageState$getCurrentRoute(pageState));
		var _v0 = _Utils_Tuple2(
			model.c3.AC,
			$author$project$Model$Project$getName(model.c5));
		var orgName = _v0.a;
		var projectName = _v0.b;
		var harRoute = A2(
			$author$project$Model$Route$projectSettingsHAR,
			{ix: orgName, vT: projectName},
			A2(
				$author$project$Model$Route$withCommitID,
				model.gr,
				A2($author$project$Model$Route$withBranchName, model.fO, $author$project$Model$Route$projectSettingsParams)));
		var projectSettings = {fO: model.fO, ix: orgName, vT: projectName};
		var settingsRoutes = _List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Model$Route$projectSettings(projectSettings),
				$elm$html$Html$text('Project Details')),
				_Utils_Tuple2(
				$author$project$Model$Route$projectSettingsBranches(projectSettings),
				$elm$html$Html$text('Branches')),
				_Utils_Tuple2(
				harRoute,
				$elm$html$Html$text('ActiveState Artifact Repository'))
			]);
		var mainView = showSideBar ? $author$project$Views$Columns$asHtml(
			A2(
				$author$project$Views$Columns$withColumn,
				_List_fromArray(
					[content]),
				A2(
					$author$project$Views$Columns$withColumnAs,
					$elm$html$Html$section,
					A3(
						$author$project$Views$Columns$withSideNav,
						pageLink,
						settingsRoutes,
						$author$project$Views$Columns$asColumns($elm$html$Html$main_))))) : content;
		return $author$project$Views$SiteWrapper$toHtml(
			A2(
				$author$project$Views$SiteWrapper$withModals,
				model.fd,
				A2(
					$author$project$Views$SiteWrapper$with,
					$author$project$Views$SiteWrapper$PageClass(topClass),
					A2(
						$author$project$Views$SiteWrapper$with,
						$author$project$Views$SiteWrapper$PageStateData(pageState),
						A2(
							$author$project$Views$SiteWrapper$with,
							$author$project$Views$SiteWrapper$SessionData(session),
							A2(
								$author$project$Views$SiteWrapper$with,
								$author$project$Views$SiteWrapper$PageFooter($author$project$Views$Layout$footer),
								A2(
									$author$project$Views$SiteWrapper$with,
									$author$project$Views$SiteWrapper$PageContent(
										_List_fromArray(
											[
												A3($author$project$Views$Layout$projectNavTabs, model, pageState, session),
												mainView
											])),
									A2(
										$author$project$Views$SiteWrapper$with,
										$author$project$Views$SiteWrapper$PageHeader(
											A3($author$project$Views$Layout$projectHeader, session, model, pageState)),
										$author$project$Views$SiteWrapper$newSiteWrapper))))))));
	});
var $author$project$Pages$Checkout$showVerifyEmailBanner = function (model) {
	return !model.jc;
};
var $author$project$Pages$ActivateMembership$Activate = {$: 1};
var $author$project$Pages$ActivateMembership$viewInviteOnly = function (model) {
	return A2(
		$elm$html$Html$main_,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('page-invitation')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('larger')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Good news, you\'ve been invited to join the '),
						A2(
						$elm$html$Html$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(model.ix)
							])),
						$elm$html$Html$text(' organization.')
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('primary-button large'),
								$elm$html$Html$Events$onClick($author$project$Pages$ActivateMembership$Activate)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Accept Invitation')
							])),
						A3(
						$author$project$Views$Link$link,
						$author$project$Model$Route$Protected(
							$author$project$Model$Route$Home(
								{wd: $elm$core$Maybe$Nothing})),
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('larger secondary-button')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Decline')
							]))
					]))
			]));
};
var $author$project$Pages$ActivateMembership$viewLoading = A2(
	$elm$html$Html$main_,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('page-header-blocker')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('')
		]));
var $author$project$Pages$ActivateMembership$view = F2(
	function (session, model) {
		return A2($author$project$Model$Session$isMember, model.ix, session) ? $author$project$Pages$ActivateMembership$viewLoading : $author$project$Pages$ActivateMembership$viewInviteOnly(model);
	});
var $author$project$Views$CreateOrgForm$CreateOrg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Views$CreateOrgForm$NewOrgUrlName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Views$CreateOrgForm$OnBlurUrlName = {$: 4};
var $avh4$elm_color$Color$rgba = F4(
	function (r, g, b, a) {
		return A4($avh4$elm_color$Color$RgbaSpace, r, g, b, a);
	});
var $author$project$Style$colors = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'black',
			A3($avh4$elm_color$Color$rgb255, 26, 25, 52)),
			_Utils_Tuple2(
			'gray',
			A3($avh4$elm_color$Color$rgb255, 140, 140, 154)),
			_Utils_Tuple2(
			'light-gray',
			A3($avh4$elm_color$Color$rgb255, 186, 186, 194)),
			_Utils_Tuple2(
			'dark-grey',
			A3($avh4$elm_color$Color$rgb255, 9, 15, 22)),
			_Utils_Tuple2(
			'grey',
			A3($avh4$elm_color$Color$rgb255, 43, 57, 72)),
			_Utils_Tuple2(
			'lighter-grey',
			A3($avh4$elm_color$Color$rgb255, 76, 93, 99)),
			_Utils_Tuple2(
			'mid-grey',
			A3($avh4$elm_color$Color$rgb255, 172, 183, 190)),
			_Utils_Tuple2(
			'mid-light-grey',
			A3($avh4$elm_color$Color$rgb255, 221, 221, 221)),
			_Utils_Tuple2(
			'light-grey',
			A3($avh4$elm_color$Color$rgb255, 238, 238, 238)),
			_Utils_Tuple2(
			'light-grey-text',
			A4($avh4$elm_color$Color$rgba, 0, 0, 0, 0.55)),
			_Utils_Tuple2(
			'white',
			A3($avh4$elm_color$Color$rgb255, 255, 255, 255)),
			_Utils_Tuple2(
			'offwhite',
			A3($avh4$elm_color$Color$rgb255, 240, 240, 254)),
			_Utils_Tuple2(
			'purple',
			A3($avh4$elm_color$Color$rgb255, 138, 97, 255)),
			_Utils_Tuple2(
			'mid-purple',
			A3($avh4$elm_color$Color$rgb255, 187, 164, 255)),
			_Utils_Tuple2(
			'light-purple',
			A4($avh4$elm_color$Color$rgba, 0.5411764705882353, 0.3803921568627451, 1, 0.2)),
			_Utils_Tuple2(
			'blue',
			A3($avh4$elm_color$Color$rgb255, 73, 124, 255)),
			_Utils_Tuple2(
			'light-blue',
			A3($avh4$elm_color$Color$rgb255, 201, 216, 255)),
			_Utils_Tuple2(
			'highlight-blue',
			A3($avh4$elm_color$Color$rgb255, 226, 232, 252)),
			_Utils_Tuple2(
			'green',
			A3($avh4$elm_color$Color$rgb255, 0, 189, 166)),
			_Utils_Tuple2(
			'yellow',
			A3($avh4$elm_color$Color$rgb255, 251, 195, 50)),
			_Utils_Tuple2(
			'beta-yellow',
			A3($avh4$elm_color$Color$rgb255, 249, 195, 62)),
			_Utils_Tuple2(
			'light-yellow',
			A3($avh4$elm_color$Color$rgb255, 255, 237, 171)),
			_Utils_Tuple2(
			'orange',
			A3($avh4$elm_color$Color$rgb255, 255, 134, 47)),
			_Utils_Tuple2(
			'light-orange',
			A4($avh4$elm_color$Color$rgba, 1, 0.5450980392156862, 0.17647058823529413, 0.2)),
			_Utils_Tuple2(
			'red',
			A3($avh4$elm_color$Color$rgb255, 255, 70, 126)),
			_Utils_Tuple2(
			'light-red',
			A3($avh4$elm_color$Color$rgb255, 255, 200, 216)),
			_Utils_Tuple2(
			'no-fill',
			A4($avh4$elm_color$Color$rgba, 0, 0, 0, 0))
		]));
var $author$project$Style$color = function (key) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Style$defaultColor,
		A2($elm$core$Dict$get, key, $author$project$Style$colors));
};
var $author$project$Views$Icon$setColor = F2(
	function (c, _v0) {
		var ikon = _v0;
		return _Utils_update(
			ikon,
			{
				tc: $elm$core$Maybe$Just(c)
			});
	});
var $author$project$Views$Icon$colored = function (c) {
	return $author$project$Views$Icon$setColor(c);
};
var $author$project$Views$CreateOrgForm$disableUserSubmitAction = function (model) {
	return (!_Utils_eq(model.gv, $elm$core$Maybe$Nothing)) || (model.g8 !== 2);
};
var $elm$virtual_dom$VirtualDom$Custom = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$Events$custom = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Custom(decoder));
	});
var $author$project$Misc$onClickNoBubble = function (msg) {
	return A2(
		$elm$html$Html$Events$custom,
		'click',
		$elm$json$Json$Decode$succeed(
			{Eh: msg, Fo: true, Gj: true}));
};
var $author$project$Views$CreateOrgForm$createOrgButton = F3(
	function (model, msg, canStartTrial) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$disabled(
					$author$project$Views$CreateOrgForm$disableUserSubmitAction(model)),
					$elm$html$Html$Attributes$class('primary-button submit-button'),
					$author$project$Misc$onClickNoBubble(msg),
					A2($elm$html$Html$Attributes$attribute, 'data-cy', 'create-org')
				]),
			_List_fromArray(
				[
					canStartTrial ? $elm$html$Html$text('Create Organization & Start Trial') : $elm$html$Html$text('Create Organization')
				]));
	});
var $elm$html$Html$Attributes$for = $elm$html$Html$Attributes$stringProperty('htmlFor');
var $elm$html$Html$form = _VirtualDom_node('form');
var $elm_community$string_extra$String$Extra$surround = F2(
	function (wrapper, string) {
		return _Utils_ap(
			wrapper,
			_Utils_ap(string, wrapper));
	});
var $author$project$Views$ViewUtils$formattedNameEl = function (name) {
	return $elm$core$String$isEmpty(name) ? $elm$html$Html$text('') : A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('formatted-name')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Replacing special characters. Will be saved as '),
				A2(
				$elm$html$Html$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($elm_community$string_extra$String$Extra$surround, '\"', name))
					]))
			]));
};
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$html$Html$label = _VirtualDom_node('label');
var $elm$html$Html$Attributes$maxlength = function (n) {
	return A2(
		_VirtualDom_attribute,
		'maxlength',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$Events$onBlur = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'blur',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$article = _VirtualDom_node('article');
var $author$project$Views$CreateOrgForm$orgInformationView = A2(
	$elm$html$Html$article,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('org-info')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$h4,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('What are organizations?')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Organizations in the ActiveState platform let you group and organize all of the open source you are using in one place, making observability and remediation seamless and collaborative.')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('https://docs.activestate.com/platform/organizations/'),
							$elm$html$Html$Attributes$target('_blank')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Learn more')
						]))
				]))
		]));
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $author$project$Views$CreateOrgForm$trialInformationView = A2(
	$elm$html$Html$article,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('trial-info-banner')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$h1,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Enjoy Enterprise Features for 7 days for Free!')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Create your organization and gain access to powerful features that make working with open source easier and safer.')
				])),
			A2(
			$elm$html$Html$ul,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Views$Icon$view(
							$author$project$Views$Icon$icon(55)),
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Universal Observability')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('See what open source is running and where.')
								]))
						])),
					A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Views$Icon$view(
							$author$project$Views$Icon$icon(64)),
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Intelligent Remediation')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Upgrade to safer, newer versions of whatever you\'re using.')
								]))
						])),
					A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Views$Icon$view(
							$author$project$Views$Icon$icon(16)),
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Frictionless Collaboration')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Streamline collaboration between your Dev, Ops, and Security teams.')
								]))
						]))
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('https://www.activestate.com/company/contact-us-pricing'),
							$elm$html$Html$Attributes$target('_blank')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('See all plans & pricing'),
							$author$project$Views$Icon$view(
							$author$project$Views$Icon$icon(25))
						]))
				]))
		]));
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$Views$CreateOrgForm$view = function (model) {
	var orgUrlNameError = A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('field-error')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				A2($elm$core$Maybe$withDefault, '', model.gv))
			]));
	var isUrlNameReformatted = (!_Utils_eq(model.jk, model.p3)) && (model.jk !== '');
	var canStartTrial = model.De;
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$form,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('create-org-form admin')
				]),
			_List_fromArray(
				[
					$author$project$Views$CreateOrgForm$orgInformationView,
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('org-url')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$for('org-urlname')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Name your organization')
										]))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('field-info')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('This will act as the URL to your organization on the Platform.')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('org-url-ui', true),
											_Utils_Tuple2(
											'error',
											(!_Utils_eq(model.gv, $elm$core$Maybe$Nothing)) && model.iI)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$for('org-urlname')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(model.wU)
										])),
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('text'),
											$elm$html$Html$Attributes$value(model.p3),
											$elm$html$Html$Attributes$placeholder('eg. my-company-name'),
											$elm$html$Html$Attributes$id('org-urlname'),
											$elm$html$Html$Attributes$class('org-url-input'),
											$elm$html$Html$Attributes$maxlength(40),
											$elm$html$Html$Events$onInput($author$project$Views$CreateOrgForm$NewOrgUrlName),
											$elm$html$Html$Events$onBlur($author$project$Views$CreateOrgForm$OnBlurUrlName),
											A2($elm$html$Html$Attributes$attribute, 'data-cy', 'org-name')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('org-urlname-check'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('friendly-error', !model.iI)
												]))
										]),
									_List_fromArray(
										[
											function () {
											var _v0 = model.g8;
											switch (_v0) {
												case 0:
													return $elm$html$Html$text('');
												case 1:
													return A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('availability loading')
															]),
														_List_fromArray(
															[
																$author$project$Views$Icon$view(
																A2(
																	$author$project$Views$Icon$colored,
																	$author$project$Style$color('blue'),
																	$author$project$Views$Icon$small(
																		$author$project$Views$Icon$icon(75))))
															]));
												case 2:
													return A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('availability available')
															]),
														_List_fromArray(
															[
																$author$project$Views$Icon$view(
																A2(
																	$author$project$Views$Icon$colored,
																	$author$project$Style$color('green'),
																	$author$project$Views$Icon$small(
																		$author$project$Views$Icon$icon(11)))),
																$elm$html$Html$text('Available')
															]));
												default:
													return A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('availability unavailable')
															]),
														_List_fromArray(
															[
																$author$project$Views$Icon$view(
																A2(
																	$author$project$Views$Icon$colored,
																	$author$project$Style$color('red'),
																	$author$project$Views$Icon$small(
																		$author$project$Views$Icon$icon(86))))
															]));
											}
										}(),
											orgUrlNameError
										]))
								])),
							A2(
							$author$project$Misc$displayIf,
							isUrlNameReformatted,
							$author$project$Views$ViewUtils$formattedNameEl(model.jk))
						])),
					A3(
					$author$project$Views$CreateOrgForm$createOrgButton,
					model,
					$author$project$Views$CreateOrgForm$CreateOrg($author$project$Model$Tier$Free),
					canStartTrial)
				])),
			A2($author$project$Misc$displayIf, canStartTrial, $author$project$Views$CreateOrgForm$trialInformationView)
		]);
};
var $author$project$Pages$AdminCreateOrganization$view = F2(
	function (model, _v0) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('page')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('page-heading')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Create a new Organization')
								]))
						])),
				A2(
					$elm$core$List$map,
					$elm$html$Html$map($author$project$Pages$AdminCreateOrganization$CreateOrgFormMsg),
					$author$project$Views$CreateOrgForm$view(model.jT))));
	});
var $author$project$Pages$AdminFeatures$Acknowledged = 2;
var $author$project$Pages$AdminFeatures$SelectTier = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$AdminFeatures$SetAcknowledgement = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$AdminFeatures$WarningShown = 1;
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $author$project$Views$Modal$Cancel = function (a) {
	return {$: 0, a: a};
};
var $author$project$Views$Modal$Confirm = function (a) {
	return {$: 1, a: a};
};
var $author$project$Views$Modal$buttonView = function (config) {
	var classes = A2($elm$core$List$map, $elm$html$Html$Attributes$class, config.BE);
	var attrs = A2(
		$elm$core$List$append,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$type_('button'),
				$elm$html$Html$Events$onClick(config.En),
				$elm$html$Html$Attributes$disabled(config.Dc)
			]),
		classes);
	return A2(
		$elm$html$Html$button,
		attrs,
		_List_fromArray(
			[
				$elm$html$Html$text(config.Gv)
			]));
};
var $author$project$Views$Modal$getButtonConfig = function (buttonType) {
	if (buttonType.$ === 1) {
		var c = buttonType.a;
		return _Utils_update(
			c,
			{
				BE: A2(
					$elm$core$List$append,
					c.BE,
					_List_fromArray(
						['primary-button']))
			});
	} else {
		var c = buttonType.a;
		return _Utils_update(
			c,
			{
				BE: A2(
					$elm$core$List$append,
					c.BE,
					_List_fromArray(
						['secondary-button']))
			});
	}
};
var $author$project$Views$Modal$modalId = 'modal';
var $author$project$Views$Modal$confirmCancelView = function (config) {
	var classes = A2(
		$elm$core$List$map,
		$elm$html$Html$Attributes$class,
		_List_fromArray(
			['modal', config.BD]));
	var attrs = A2(
		$elm$core$List$append,
		classes,
		$elm$core$List$singleton(
			A2(
				$elm$core$Maybe$withDefault,
				$elm$html$Html$Attributes$id($author$project$Views$Modal$modalId),
				A2($elm$core$Maybe$map, $elm$html$Html$Attributes$id, config.l6))));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal-view')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				attrs,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$section,
						_List_Nil,
						_List_fromArray(
							[config.dH])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('buttons')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Misc$displayMaybe,
								$author$project$Views$Modal$buttonView,
								A2(
									$elm$core$Maybe$map,
									A2($elm$core$Basics$composeR, $author$project$Views$Modal$Confirm, $author$project$Views$Modal$getButtonConfig),
									config.BU)),
								A2(
								$author$project$Misc$displayMaybe,
								$author$project$Views$Modal$buttonView,
								A2(
									$elm$core$Maybe$map,
									A2($elm$core$Basics$composeR, $author$project$Views$Modal$Cancel, $author$project$Views$Modal$getButtonConfig),
									config.Bq))
							]))
					]))
			]));
};
var $elm$html$Html$Events$targetChecked = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'checked']),
	$elm$json$Json$Decode$bool);
var $elm$html$Html$Events$onCheck = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetChecked));
};
var $author$project$Pages$AdminFeatures$confirmationView = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Misc$displayIf,
				model.kL === 1,
				$author$project$Views$Modal$confirmCancelView(
					{
						Bq: $elm$core$Maybe$Just(
							{
								BE: _List_Nil,
								Dc: false,
								En: $author$project$Pages$AdminFeatures$SetAcknowledgement(0),
								Gv: 'Cancel'
							}),
						BD: '',
						BU: $elm$core$Maybe$Nothing,
						dH: A2(
							$elm$html$Html$article,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h1,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Views$Icon$view(
											$author$project$Views$Icon$icon(83)),
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Watch out!')
												]))
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Changes made here are applied immediately to all existing customers. Do not change these settings unless you know what you\'re doing!')
										])),
									A2(
									$elm$html$Html$section,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$id('confirmation')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$label,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$for('confirmation-text')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Please type \"I know what I\'m doing\" below to continue')
												])),
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$id('confirmation-text'),
													$elm$html$Html$Events$onInput(
													function (text) {
														return ('iknowwhatimdoing' === $elm$core$String$toLower(
															A3(
																$elm$core$String$replace,
																' ',
																'',
																A3($elm$core$String$replace, '\'', '', text)))) ? $author$project$Pages$AdminFeatures$SetAcknowledgement(2) : $author$project$Pages$AdminFeatures$NoOp;
													})
												]),
											_List_Nil)
										]))
								])),
						l6: $elm$core$Maybe$Just('confirmation-modal')
					})),
				A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('read-only')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('checkbox'),
								$elm$html$Html$Attributes$id('read-only-checkbox'),
								$elm$html$Html$Attributes$checked(model.kL !== 2),
								$elm$html$Html$Events$onCheck(
								function (x) {
									return (!x) ? $author$project$Pages$AdminFeatures$SetAcknowledgement(1) : $author$project$Pages$AdminFeatures$SetAcknowledgement(0);
								})
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Read only')
							])),
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$for('read-only-checkbox')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Read-only')
							]))
					]))
			]));
};
var $author$project$Pages$AdminFeatures$pageDescription = A2(
	$elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Determines which features are enabled by default for each tier. You should probably search a specific '),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('/admin/organizations')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('organization')
						])),
					$elm$html$Html$text(' or '),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('/admin/users')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('user')
						])),
					$elm$html$Html$text(' instead first.')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('CHANGES MADE HERE ARE APPLIED IMMEDIATELY TO ALL EXISTING CUSTOMERS. '),
							$elm$html$Html$text('DO NOT CHANGE THESE SETTINGS UNLESS YOU KNOW WHAT YOU\'RE DOING!')
						]))
				]))
		]));
var $author$project$Pages$AdminFeatures$pageHeading = 'Tier Features';
var $author$project$Pages$AdminFeatures$SetAddOn = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Views$AddOnToggle$addOnToggle = F5(
	function (canEdit, el, msg, addOn, isOverRidden) {
		return A2(
			el,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('add-on'),
					$elm$html$Html$Attributes$title(addOn.bP)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('slide-toggle-wrapper', true),
									_Utils_Tuple2('enabled', addOn.Cp),
									_Utils_Tuple2('disabled', !canEdit)
								])),
						canEdit ? _List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								msg(!addOn.Cp))
							]) : _List_Nil),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('slide-toggle')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('nub')
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('label')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(addOn.bP)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('label')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('(' + (addOn.w + ')'))
								])),
							A2(
							$author$project$Misc$displayIf,
							isOverRidden,
							A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('sub-label')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('override'),
												$elm$html$Html$Attributes$title('This feature has been changed from the organization\'s default state.')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Override')
											]))
									])))
						]))
				]));
	});
var $author$project$Pages$AdminFeatures$categoryView = F4(
	function (model, canEdit, category, addOns) {
		var addOnsList = A2(
			$elm$core$List$map,
			function (a) {
				return A5(
					$author$project$Views$AddOnToggle$addOnToggle,
					canEdit,
					$elm$html$Html$div,
					A2($author$project$Pages$AdminFeatures$SetAddOn, model.jM, a.w),
					a,
					false);
			},
			A2(
				$elm$core$List$sortBy,
				function ($) {
					return $.bP;
				},
				addOns));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(category)
						])),
				addOnsList));
	});
var $author$project$Pages$AdminFeatures$tierView = F2(
	function (model, canEdit) {
		var currentAddOns = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2($elm$core$Dict$get, model.jM, model.jD));
		var currentCategories = $elm_community$list_extra$List$Extra$unique(
			$elm$core$List$sort(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.xA;
					},
					currentAddOns)));
		return A2(
			$elm$core$List$map,
			function (c) {
				return A4(
					$author$project$Pages$AdminFeatures$categoryView,
					model,
					canEdit,
					c,
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.xA;
							},
							$elm$core$Basics$eq(c)),
						currentAddOns));
			},
			currentCategories);
	});
var $elm$html$Html$select = _VirtualDom_node('select');
var $elm$html$Html$optgroup = _VirtualDom_node('optgroup');
var $elm$html$Html$option = _VirtualDom_node('option');
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlJson(value));
	});
var $elm$html$Html$Attributes$property = $elm$virtual_dom$VirtualDom$property;
var $elm$html$Html$Attributes$selected = $elm$html$Html$Attributes$boolProperty('selected');
var $author$project$Views$AdminTierSelect$tiersOptionView = function (_v0) {
	var currentTier = _v0.jM;
	var availableTiers = _v0.Ba;
	var containsLegacy = $elm$core$String$contains('legacy');
	var tierDisplayText = function (tier) {
		return $elm$html$Html$text(
			containsLegacy(tier) ? A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					[
						$author$project$Model$Tier$tierNameAsSimpleTierString(tier),
						$elm$core$String$fromChar(
						$elm$core$Char$fromCode(8212)),
						'Legacy'
					])) : $author$project$Model$Tier$tierNameAsSimpleTierString(tier));
	};
	var htmlOpt = $elm$core$List$map(
		function (t) {
			return A2(
				$elm$html$Html$option,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$value(t),
						$elm$html$Html$Attributes$selected(
						_Utils_eq(t, currentTier))
					]),
				_List_fromArray(
					[
						tierDisplayText(t)
					]));
		});
	var htmlGroup = F2(
		function (label, val) {
			return A2(
				$elm$html$Html$optgroup,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$Attributes$property,
						'label',
						$elm$json$Json$Encode$string(label))
					]),
				htmlOpt(val));
		});
	var top = A3(
		$elm$core$Tuple$mapBoth,
		htmlGroup('Legacy'),
		htmlGroup('Standard'),
		A2(
			$elm$core$List$partition,
			containsLegacy,
			$elm$core$List$reverse(
				A2(
					$elm$core$List$sortBy,
					A2($elm$core$Basics$composeR, $author$project$Model$Tier$stringToSimpleTier, $author$project$Model$Tier$tierToRank),
					availableTiers))));
	return _List_fromArray(
		[top.b, top.a]);
};
var $author$project$Views$AdminTierSelect$view = function (input) {
	return A2(
		$elm$html$Html$select,
		_List_fromArray(
			[
				$elm$html$Html$Events$onInput(input.Em)
			]),
		$author$project$Views$AdminTierSelect$tiersOptionView(input));
};
var $author$project$Pages$AdminFeatures$view = F2(
	function (model, session) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('page admin-features')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('page-body')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text($author$project$Pages$AdminFeatures$pageHeading)
								])),
							$author$project$Pages$AdminFeatures$pageDescription,
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Tier')
								])),
							$author$project$Views$AdminTierSelect$view(
							{
								Ba: $elm$core$Dict$keys(model.jD),
								jM: model.jM,
								Em: $author$project$Pages$AdminFeatures$SelectTier
							}),
							$author$project$Pages$AdminFeatures$confirmationView(model),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('add-ons')
								]),
							A2(
								$author$project$Pages$AdminFeatures$tierView,
								model,
								$author$project$Model$Session$isSuperUser(session) && (model.kL === 2)))
						]))
				]));
	});
var $author$project$Pages$AdminFork$AllBranchesAutoUpdate = {$: 0};
var $author$project$Pages$AdminFork$ChangeMode = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$AdminFork$ForkProject = {$: 0};
var $author$project$Pages$AdminFork$GoBack = {$: 4};
var $author$project$Pages$AdminFork$SetOrganizationName = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$AdminFork$SetProjectName = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Attributes$autofocus = $elm$html$Html$Attributes$boolProperty('autofocus');
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $author$project$Model$Branch$getTrackingTypeOption = function (trackingType) {
	switch (trackingType) {
		case 2:
			return {bP: 'I\'ll decide if I want to update the fork', r0: 'Notify me', sE: 2};
		case 1:
			return {bP: '', r0: 'Auto-update the fork', sE: 1};
		default:
			return {bP: '', r0: 'Do nothing', sE: 0};
	}
};
var $author$project$Pages$AdminFork$trackingTypePrompt = function (trackingType) {
	return $author$project$Model$Branch$getTrackingTypeOption(trackingType).r0;
};
var $author$project$Pages$AdminFork$modeDisplayString = function (mode) {
	if (!mode.$) {
		return 'Fork all branches. Tracking: ' + $author$project$Pages$AdminFork$trackingTypePrompt(1);
	} else {
		var trackingType = mode.a;
		return 'Fork just the default branch. Tracking: ' + $author$project$Pages$AdminFork$trackingTypePrompt(trackingType);
	}
};
var $elm$html$Html$Events$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $elm$html$Html$Events$onSubmit = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'submit',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysPreventDefault,
			$elm$json$Json$Decode$succeed(msg)));
};
var $author$project$Pages$AdminFork$view = function (model) {
	var hasSingleBranch = $elm$core$List$length(
		$author$project$Model$Project$getBranches(model.hU)) === 1;
	var description = $author$project$Model$Project$getDescription(model.hU);
	return A2(
		$elm$html$Html$main_,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('column')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$form,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('single-column-form'),
								$elm$html$Html$Events$onSubmit($author$project$Pages$AdminFork$ForkProject)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('superuser-only')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('This page is only for '),
										A2(
										$elm$html$Html$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Superusers™')
											])),
										$elm$html$Html$text('. It will create a fork of this project in the '),
										A2(
										$elm$html$Html$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Organization')
											])),
										$elm$html$Html$text(' you specify below and set it to be a '),
										A2(
										$elm$html$Html$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Managed Project')
											])),
										$elm$html$Html$text(' that auto-tracks the original.')
									])),
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Source Project')
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										model.pR + ('/' + $author$project$Model$Project$getName(model.hU)))
									])),
								A2(
								$author$project$Misc$displayIf,
								description !== '',
								A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('field-info')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(description)
										]))),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('field-section columns')
									]),
								function () {
									var _v0 = model.uu;
									if (_v0.$ === 1) {
										return _List_fromArray(
											[
												$elm$html$Html$text('No latest commit found!')
											]);
									} else {
										var commitID = _v0.a.BR;
										var branchName = _v0.a.Bi;
										var added = _v0.a.ak;
										return _List_fromArray(
											[
												A2(
												$elm$html$Html$h3,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Latest commit was on the \'' + (branchName + '\' branch'))
													])),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('column')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$h4,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Commit ID')
															])),
														$elm$html$Html$text(
														$danyx23$elm_uuid$Uuid$toString(commitID))
													])),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('column')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$h4,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Timestamp')
															])),
														$elm$html$Html$text(
														A2(
															$elm$core$Maybe$withDefault,
															'No added timestamp available',
															A2($elm$core$Maybe$map, $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime, added)))
													]))
											]);
									}
								}()),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('field-section')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h4,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Forking Mode')
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('radio-group')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$label,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('visibility-label')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$input,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$checked(
																_Utils_eq(model.El, $author$project$Pages$AdminFork$AllBranchesAutoUpdate)),
																$elm$html$Html$Attributes$type_('radio'),
																$elm$html$Html$Attributes$disabled(hasSingleBranch),
																$elm$html$Html$Events$onCheck(
																$elm$core$Basics$always(
																	$author$project$Pages$AdminFork$ChangeMode($author$project$Pages$AdminFork$AllBranchesAutoUpdate)))
															]),
														_List_Nil),
														$elm$html$Html$text(
														$author$project$Pages$AdminFork$modeDisplayString($author$project$Pages$AdminFork$AllBranchesAutoUpdate)),
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('field-info radio-info')
															]),
														_List_fromArray(
															[
																hasSingleBranch ? $elm$html$Html$text('There\'s only one branch so this option is irrelevant.') : $elm$html$Html$text('Tracking only applies to the default branch.')
															]))
													])),
												A2(
												$elm$html$Html$label,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('visibility-label')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$input,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$checked(
																_Utils_eq(
																	model.El,
																	$author$project$Pages$AdminFork$SingleBranch(0))),
																$elm$html$Html$Attributes$type_('radio'),
																$elm$html$Html$Events$onCheck(
																$elm$core$Basics$always(
																	$author$project$Pages$AdminFork$ChangeMode(
																		$author$project$Pages$AdminFork$SingleBranch(0))))
															]),
														_List_Nil),
														$elm$html$Html$text(
														$author$project$Pages$AdminFork$modeDisplayString(
															$author$project$Pages$AdminFork$SingleBranch(0)))
													])),
												A2(
												$elm$html$Html$label,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('visibility-label')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$input,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$checked(
																_Utils_eq(
																	model.El,
																	$author$project$Pages$AdminFork$SingleBranch(1))),
																$elm$html$Html$Attributes$type_('radio'),
																$elm$html$Html$Events$onCheck(
																$elm$core$Basics$always(
																	$author$project$Pages$AdminFork$ChangeMode(
																		$author$project$Pages$AdminFork$SingleBranch(1))))
															]),
														_List_Nil),
														$elm$html$Html$text(
														$author$project$Pages$AdminFork$modeDisplayString(
															$author$project$Pages$AdminFork$SingleBranch(1)))
													])),
												A2(
												$elm$html$Html$label,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('visibility-label')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$input,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$checked(
																_Utils_eq(
																	model.El,
																	$author$project$Pages$AdminFork$SingleBranch(2))),
																$elm$html$Html$Attributes$type_('radio'),
																$elm$html$Html$Events$onCheck(
																$elm$core$Basics$always(
																	$author$project$Pages$AdminFork$ChangeMode(
																		$author$project$Pages$AdminFork$SingleBranch(2))))
															]),
														_List_Nil),
														$elm$html$Html$text(
														$author$project$Pages$AdminFork$modeDisplayString(
															$author$project$Pages$AdminFork$SingleBranch(2)))
													]))
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('field-section')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$h4,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Target Organization')
													])),
												A2(
												$elm$html$Html$p,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('field-info')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('The forked project will be added to this organization.')
													])),
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$type_('text'),
														$elm$html$Html$Events$onInput($author$project$Pages$AdminFork$SetOrganizationName),
														$elm$html$Html$Attributes$autofocus(true)
													]),
												_List_Nil)
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('field-section')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$h4,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Project name')
													])),
												A2(
												$elm$html$Html$p,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('field-info')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('The forked project will be given this name.')
													])),
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$type_('text'),
														$elm$html$Html$Events$onInput($author$project$Pages$AdminFork$SetProjectName),
														$elm$html$Html$Attributes$value(model.kC)
													]),
												_List_Nil)
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('primary-button')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Fork Project')
											])),
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Events$onClick($author$project$Pages$AdminFork$GoBack),
												$elm$html$Html$Attributes$class('cancel-button'),
												$elm$html$Html$Attributes$type_('button')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$AdminIconomicon$filtered = function (query) {
	return $elm$core$List$filter(
		A2(
			$elm$core$Basics$composeR,
			$author$project$Icon$name,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$String$toLower,
				$elm$core$String$contains(
					$elm$core$String$toLower(query)))));
};
var $author$project$Pages$AdminIconomicon$CopyClipboard = function (a) {
	return {$: 3, a: a};
};
var $author$project$Views$Icon$Exactly = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Views$Icon$square = function (size) {
	return $author$project$Views$Icon$setSize(
		A2($author$project$Views$Icon$Exactly, size, size));
};
var $author$project$Pages$AdminIconomicon$iconPreview = F3(
	function (size, color, icon) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$Pages$AdminIconomicon$CopyClipboard(icon)),
					$elm$html$Html$Attributes$title(
					$author$project$Icon$name(icon))
				]),
			_List_fromArray(
				[
					$author$project$Views$Icon$view(
					A2(
						$author$project$Views$Icon$colored,
						color,
						A2(
							$author$project$Views$Icon$square,
							size,
							$author$project$Views$Icon$icon(icon))))
				]));
	});
var $author$project$Pages$AdminIconomicon$iconListView = F2(
	function (size, color) {
		return $elm$core$List$map(
			A2($author$project$Pages$AdminIconomicon$iconPreview, size, color));
	});
var $author$project$Views$Icon$Large = {$: 2};
var $author$project$Pages$AdminIconomicon$SetColor = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$AdminIconomicon$SetQuery = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$AdminIconomicon$SetSize = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$datalist = _VirtualDom_node('datalist');
var $elm$html$Html$Attributes$list = _VirtualDom_attribute('list');
var $elm$html$Html$Attributes$max = $elm$html$Html$Attributes$stringProperty('max');
var $elm$html$Html$Attributes$min = $elm$html$Html$Attributes$stringProperty('min');
var $elm$html$Html$Attributes$step = function (n) {
	return A2($elm$html$Html$Attributes$stringProperty, 'step', n);
};
var $author$project$Pages$AdminIconomicon$searchView = function (model) {
	var sizeID = 'size-picker';
	var queryID = 'query-text';
	var colorID = 'color-picker';
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$id('icon-filters')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$for(queryID)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Filter')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id(queryID),
								$elm$html$Html$Events$onInput($author$project$Pages$AdminIconomicon$SetQuery)
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$for(colorID)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Fill')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id(colorID),
								$elm$html$Html$Attributes$type_('color'),
								$elm$html$Html$Events$onInput($author$project$Pages$AdminIconomicon$SetColor)
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$for(sizeID)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(model.jr) + 'px ')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id(sizeID),
								$elm$html$Html$Attributes$type_('range'),
								$elm$html$Html$Attributes$min('8'),
								$elm$html$Html$Attributes$max('128'),
								$elm$html$Html$Attributes$step('2'),
								$elm$html$Html$Attributes$value(
								$elm$core$String$fromInt(model.jr)),
								$elm$html$Html$Attributes$list('tickmarks'),
								$elm$html$Html$Events$onInput($author$project$Pages$AdminIconomicon$SetSize)
							]),
						_List_Nil),
						A2(
						$elm$html$Html$datalist,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('tickmarks')
							]),
						A2(
							$elm$core$List$map,
							function (_v0) {
								var n = _v0.a;
								var s = _v0.b;
								return A2(
									$elm$html$Html$option,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value(
											A2(
												$elm$core$Maybe$withDefault,
												'',
												A2(
													$elm$core$Maybe$map,
													A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $elm$core$String$fromInt),
													$author$project$Views$Icon$sizeToInt(s)))),
											A2(
											$elm$html$Html$Attributes$property,
											'label',
											$elm$json$Json$Encode$string(n))
										]),
									_List_Nil);
							},
							_List_fromArray(
								[
									_Utils_Tuple2('Small', $author$project$Views$Icon$Small),
									_Utils_Tuple2('Normal', $author$project$Views$Icon$Normal),
									_Utils_Tuple2('Large', $author$project$Views$Icon$Large)
								])))
					]))
			]));
};
var $author$project$Pages$AdminIconomicon$view = F2(
	function (model, _v0) {
		var spacing = 14;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('iconomicon')
				]),
			_List_fromArray(
				[
					$author$project$Pages$AdminIconomicon$searchView(model),
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('icon-list'),
							A2(
							$elm$html$Html$Attributes$style,
							'grid-template-columns',
							'repeat(auto-fill, ' + ($elm$core$String$fromInt(model.jr + spacing) + 'px)'))
						]),
					A3(
						$author$project$Pages$AdminIconomicon$iconListView,
						model.jr,
						model.rZ,
						A2($author$project$Pages$AdminIconomicon$filtered, model.r1, model.t4)))
				]));
	});
var $author$project$Pages$AdminOrganization$ChangeTab = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$Route$adminOrganizations = $author$project$Model$Route$Protected(
	$author$project$Model$Route$Admin($author$project$Model$Route$AdminOrganizations));
var $author$project$Pages$AdminOrganization$ChangeCategory = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$AdminOrganization$CopyClipboard = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$AdminOrganization$ResetAddOns = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$AdminOrganization$SetAddOn = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Model$AddOns$getFromAddOns = function (key) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Dict$get(key),
		$elm$core$Maybe$withDefault($author$project$Model$AddOns$empty));
};
var $author$project$Pages$AdminOrganization$addOnsWithDescriptions = function (model) {
	var addOns = $author$project$Pages$AdminOrganization$modelAddOns(model);
	var addOnDefaultsByTier = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2($elm$core$Dict$get, model.dp.c3.dc, model.jD));
	var findAddOnBy = function (name) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Model$AddOns$empty,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.w;
						},
						$elm$core$Basics$eq(name)),
					addOnDefaultsByTier)));
	};
	return A2(
		$elm$core$List$map,
		function (k) {
			return function (a) {
				return _Utils_update(
					a,
					{
						xA: findAddOnBy(k).xA,
						bP: findAddOnBy(k).bP
					});
			}(
				A2($author$project$Model$AddOns$getFromAddOns, k, addOns));
		},
		$elm$core$Dict$keys(addOns));
};
var $author$project$Views$Card$footerElement = function (data) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$html$Html$text(''),
		data.tS);
};
var $author$project$Views$Card$headerElement = function (data) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$html$Html$text(''),
		data.q6);
};
var $author$project$Views$Card$cardElements = function (data) {
	return A2(
		$elm$core$List$cons,
		$author$project$Views$Card$headerElement(data),
		_Utils_ap(
			data.dH,
			_List_fromArray(
				[
					$author$project$Views$Card$footerElement(data)
				])));
};
var $author$project$Views$Card$cardModifierAttributes = function (modifier) {
	if (!modifier) {
		return _List_fromArray(
			[
				$elm$html$Html$Attributes$class('highlighted')
			]);
	} else {
		return _List_fromArray(
			[
				$elm$html$Html$Attributes$class('lean')
			]);
	}
};
var $author$project$Views$Card$asHtmlCard = function (data) {
	return A2(
		$elm$html$Html$article,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class('card'),
			_Utils_ap(
				A2($elm$core$List$concatMap, $author$project$Views$Card$cardModifierAttributes, data.uG),
				data.M)),
		$author$project$Views$Card$cardElements(data));
};
var $author$project$Pages$AdminOrganization$ChangeAutoInviteRole = function (a) {
	return {$: 24, a: a};
};
var $author$project$Pages$AdminOrganization$ModifyAutoInvite = {$: 25};
var $author$project$Pages$AdminOrganization$NewAutoInviteActionValue = function (a) {
	return {$: 23, a: a};
};
var $author$project$Pages$AdminOrganization$NewAutoInviteDomainValue = function (a) {
	return {$: 22, a: a};
};
var $author$project$Pages$AdminOrganization$Remove = 1;
var $author$project$Pages$AdminOrganization$actionToDisplayString = function (action) {
	if (!action) {
		return 'Add/Update';
	} else {
		return 'Remove';
	}
};
var $author$project$Views$Card$CardData = F5(
	function (header, content, footer, attributes, modifiers) {
		return {M: attributes, dH: content, tS: footer, q6: header, uG: modifiers};
	});
var $author$project$Views$Card$newCard = A5($author$project$Views$Card$CardData, $elm$core$Maybe$Nothing, _List_Nil, $elm$core$Maybe$Nothing, _List_Nil, _List_Nil);
var $author$project$Model$Permissions$orgCanAutoInviteMembers = $author$project$Model$Organization$addOnEnabled('auto_invite');
var $author$project$Views$RoleSelector$view = F2(
	function (changeMessage, selectedRole) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('role-selector')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Role')
						])),
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('radio'),
									$elm$html$Html$Events$onCheck(
									$elm$core$Basics$always(
										changeMessage(2))),
									$elm$html$Html$Attributes$checked(selectedRole === 2)
								]),
							_List_Nil),
							$elm$html$Html$text(
							$author$project$Model$Role$toDisplayString(2)),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('meta')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(' - All permissions including inviting and removing members')
								]))
						])),
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('radio'),
									$elm$html$Html$Events$onCheck(
									$elm$core$Basics$always(
										changeMessage(1))),
									$elm$html$Html$Attributes$checked(selectedRole === 1)
								]),
							_List_Nil),
							$elm$html$Html$text(
							$author$project$Model$Role$toDisplayString(1)),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('meta')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(' - Create and modify runtimes')
								]))
						])),
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('radio'),
									$elm$html$Html$Events$onCheck(
									$elm$core$Basics$always(
										changeMessage(0))),
									$elm$html$Html$Attributes$checked(!selectedRole)
								]),
							_List_Nil),
							$elm$html$Html$text(
							$author$project$Model$Role$toDisplayString(0)),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('meta')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(' - Install and use runtimes')
								]))
						]))
				]));
	});
var $author$project$Views$Card$withContent = F2(
	function (content, card) {
		return _Utils_update(
			card,
			{dH: content});
	});
var $author$project$Views$Card$withH2HeaderText = F2(
	function (title, card) {
		return _Utils_update(
			card,
			{
				q6: $elm$core$Maybe$Just(
					A2(
						$elm$html$Html$header,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h2,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(title)
									]))
							])))
			});
	});
var $author$project$Pages$AdminOrganization$autoInviteView = F2(
	function (model, session) {
		return A2(
			$author$project$Misc$displayIf,
			$author$project$Model$Permissions$orgCanAutoInviteMembers(model.dp.c3),
			function () {
				var hasWriteAccess = $author$project$Model$Session$isSuperUser(session);
				var actionSelector = A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('auto-invite-action-selector')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Action')
								])),
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('radio'),
											$elm$html$Html$Events$onCheck(
											$elm$core$Basics$always(
												$author$project$Pages$AdminOrganization$NewAutoInviteActionValue(0))),
											$elm$html$Html$Attributes$checked(!model.h$)
										]),
									_List_Nil),
									$elm$html$Html$text(
									$author$project$Pages$AdminOrganization$actionToDisplayString(0)),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('meta')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(' - Add a new auto-invite or update an existing one')
										]))
								])),
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('radio'),
											$elm$html$Html$Events$onCheck(
											$elm$core$Basics$always(
												$author$project$Pages$AdminOrganization$NewAutoInviteActionValue(1))),
											$elm$html$Html$Attributes$checked(model.h$ === 1)
										]),
									_List_Nil),
									$elm$html$Html$text(
									$author$project$Pages$AdminOrganization$actionToDisplayString(1)),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('meta')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(' - Remove an existing auto update with this domain, if any')
										]))
								]))
						]));
				return $author$project$Views$Card$asHtmlCard(
					A2(
						$author$project$Views$Card$withContent,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Automatically invite users to this organization if they have a verified email address with a specific domain.')
											])),
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$type_('text'),
												$elm$html$Html$Attributes$disabled(!hasWriteAccess),
												$elm$html$Html$Attributes$value(model.h0),
												$elm$html$Html$Events$onInput($author$project$Pages$AdminOrganization$NewAutoInviteDomainValue),
												$elm$html$Html$Attributes$placeholder('An entire email address with the desired domain, or just the email domain.')
											]),
										_List_Nil),
										actionSelector,
										A2(
										$author$project$Misc$displayIf,
										!model.h$,
										A2($author$project$Views$RoleSelector$view, $author$project$Pages$AdminOrganization$ChangeAutoInviteRole, model.n3)),
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$disabled((model.h0 === '') || (!hasWriteAccess)),
												$elm$html$Html$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2('primary-button', true),
														_Utils_Tuple2('enabled', model.h0 !== '')
													])),
												$elm$html$Html$Events$onClick($author$project$Pages$AdminOrganization$ModifyAutoInvite)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Pages$AdminOrganization$actionToDisplayString(model.h$) + ' Auto-invite')
											]))
									]))
							]),
						A2($author$project$Views$Card$withH2HeaderText, 'Auto-invite', $author$project$Views$Card$newCard)));
			}());
	});
var $author$project$Pages$AdminOrganization$NewNameValue = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$AdminOrganization$SaveNewName = {$: 6};
var $author$project$Pages$AdminOrganization$invalidNameChange = F2(
	function (existing, _new) {
		return _Utils_eq(existing, _new) || $elm$core$String$isEmpty(_new);
	});
var $author$project$Views$Card$withAttributes = F2(
	function (attrs, card) {
		return _Utils_update(
			card,
			{M: attrs});
	});
var $author$project$Pages$AdminOrganization$displayNameView = F3(
	function (session, currentName, newName) {
		var hasWriteAccess = $author$project$Model$Session$isSuperUser(session);
		return $author$project$Views$Card$asHtmlCard(
			A2(
				$author$project$Views$Card$withContent,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$form,
						_List_fromArray(
							[
								$elm$html$Html$Events$onSubmit($author$project$Pages$AdminOrganization$SaveNewName)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Used just for display, links not affected.')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('text'),
										$elm$html$Html$Attributes$disabled(!hasWriteAccess),
										$elm$html$Html$Attributes$value(newName),
										$elm$html$Html$Events$onInput($author$project$Pages$AdminOrganization$NewNameValue)
									]),
								_List_Nil),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('submit'),
										$elm$html$Html$Attributes$disabled(!hasWriteAccess),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('primary-button', true),
												_Utils_Tuple2(
												'invalid',
												A2($author$project$Pages$AdminOrganization$invalidNameChange, currentName, newName))
											]))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Rename')
									]))
							]))
					]),
				A2(
					$author$project$Views$Card$withH2HeaderText,
					'Display Name',
					A2(
						$author$project$Views$Card$withAttributes,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('display-name')
							]),
						$author$project$Views$Card$newCard))));
	});
var $ryan_haskell$date_format$DateFormat$DayOfMonthFixed = {$: 7};
var $ryan_haskell$date_format$DateFormat$dayOfMonthFixed = $ryan_haskell$date_format$DateFormat$DayOfMonthFixed;
var $author$project$Pages$AdminOrganization$formatDate = F2(
	function (localTimezone, date) {
		var format = _List_fromArray(
			[
				$ryan_haskell$date_format$DateFormat$monthNameAbbreviated,
				$ryan_haskell$date_format$DateFormat$text(' '),
				$ryan_haskell$date_format$DateFormat$dayOfMonthFixed,
				$ryan_haskell$date_format$DateFormat$text(', '),
				$ryan_haskell$date_format$DateFormat$yearNumber
			]);
		return A3($ryan_haskell$date_format$DateFormat$format, format, localTimezone, date);
	});
var $author$project$Pages$AdminOrganization$NewTierValue = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$AdminOrganization$SaveNewTier = {$: 20};
var $author$project$Pages$AdminOrganization$tierView = F2(
	function (model, session) {
		var hasWriteAccess = $author$project$Model$Session$isSuperUser(session);
		return $author$project$Views$Card$asHtmlCard(
			A2(
				$author$project$Views$Card$withContent,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$form,
						_List_fromArray(
							[
								$elm$html$Html$Events$onSubmit($author$project$Pages$AdminOrganization$SaveNewTier)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('The tier of this organization on the platform.')
									])),
								$author$project$Views$AdminTierSelect$view(
								{
									Ba: $elm$core$Dict$keys(model.jD),
									jM: model.kv,
									Em: $author$project$Pages$AdminOrganization$NewTierValue
								}),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('submit'),
										$elm$html$Html$Attributes$disabled(!hasWriteAccess),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('primary-button', true),
												_Utils_Tuple2(
												'enabled',
												!_Utils_eq(model.kv, model.dp.c3.dc))
											]))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Change Tier')
									]))
							]))
					]),
				A2(
					$author$project$Views$Card$withH2HeaderText,
					'Tier',
					A2(
						$author$project$Views$Card$withAttributes,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('url-settings')
							]),
						$author$project$Views$Card$newCard))));
	});
var $author$project$Pages$AdminOrganization$NewUrlNameValue = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$AdminOrganization$SaveNewUrlName = {$: 10};
var $author$project$Pages$AdminOrganization$urlNameView = F3(
	function (session, currentName, newName) {
		var hasWriteAccess = $author$project$Model$Session$isSuperUser(session);
		return $author$project$Views$Card$asHtmlCard(
			A2(
				$author$project$Views$Card$withContent,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$form,
						_List_fromArray(
							[
								$elm$html$Html$Events$onSubmit($author$project$Pages$AdminOrganization$SaveNewUrlName)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('The link to this organization on the platform.')
									])),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('url-prefix')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('platform.activestate.com/...')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('text'),
										$elm$html$Html$Attributes$disabled(!hasWriteAccess),
										$elm$html$Html$Attributes$value(newName),
										$elm$html$Html$Events$onInput($author$project$Pages$AdminOrganization$NewUrlNameValue)
									]),
								_List_Nil),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('submit'),
										$elm$html$Html$Attributes$disabled(!hasWriteAccess),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('primary-button', true),
												_Utils_Tuple2(
												'invalid',
												A2($author$project$Pages$AdminOrganization$invalidNameChange, currentName, newName))
											]))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Change URL')
									])),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('warning'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'invalid',
												A2($author$project$Pages$AdminOrganization$invalidNameChange, currentName, newName))
											]))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Old URL will no longer work!')
									]))
							]))
					]),
				A2(
					$author$project$Views$Card$withH2HeaderText,
					'URL',
					A2(
						$author$project$Views$Card$withAttributes,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('url-settings')
							]),
						$author$project$Views$Card$newCard))));
	});
var $elm$html$Html$Attributes$readonly = $elm$html$Html$Attributes$boolProperty('readOnly');
var $elm$html$Html$Attributes$spellcheck = $elm$html$Html$Attributes$boolProperty('spellcheck');
var $author$project$Model$CopyStatus$wasCopied = F2(
	function (copyStatus, copyID) {
		return _Utils_eq(copyStatus.xN, copyID) && copyStatus.L;
	});
var $author$project$Views$CliText$view = function (data) {
	var copyButton = function (copyData) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Copy state tool installer code snippet to clipboard'),
					$elm$html$Html$Attributes$id(data.l6 + '-button'),
					A2($elm$html$Html$Attributes$attribute, 'data-cy', data.l6 + '-button'),
					$elm$html$Html$Events$onClick(
					copyData.Em(
						{xN: data.l6, Gv: data.Gv})),
					$elm$html$Html$Attributes$class('clipboard-button-with-message'),
					$elm$html$Html$Attributes$title('Copy command to clipboard'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'copied',
							A2($author$project$Model$CopyStatus$wasCopied, copyData.L, data.l6))
						]))
				]),
			_List_fromArray(
				[
					$author$project$Views$Icon$view(
					$author$project$Views$Icon$icon(17)),
					$elm$html$Html$text(''),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('copied-indicator')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Copied!')
						]))
				]));
	};
	var _v0 = (($elm$core$String$length(data.Gv) > 50) || A2($elm$core$String$contains, '\n', data.Gv)) ? _Utils_Tuple2($elm$html$Html$div, _List_Nil) : _Utils_Tuple2(
		$elm$html$Html$input,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$type_('text')
			]));
	var snippetElementType = _v0.a;
	var optionalTypeAttribute = _v0.b;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('cli-wrapper')
			]),
		_List_fromArray(
			[
				A2(
				snippetElementType,
				A2(
					$elm$core$List$append,
					optionalTypeAttribute,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('cli-text'),
							$elm$html$Html$Attributes$id(data.l6),
							$elm$html$Html$Attributes$spellcheck(false),
							A2($elm$html$Html$Attributes$attribute, 'aria-label', 'State Tool installer code snippet'),
							$elm$html$Html$Attributes$readonly(true),
							$elm$html$Html$Attributes$value(data.Gv)
						])),
				_List_fromArray(
					[
						$elm$html$Html$text(data.Gv)
					])),
				A2($author$project$Misc$displayMaybe, copyButton, data.B$)
			]));
};
var $ryan_haskell$date_format$DateFormat$MonthFixed = {$: 2};
var $ryan_haskell$date_format$DateFormat$monthFixed = $ryan_haskell$date_format$DateFormat$MonthFixed;
var $author$project$Views$PlanInfoForm$formatDate = function (date) {
	var format = _List_fromArray(
		[
			$ryan_haskell$date_format$DateFormat$yearNumber,
			$ryan_haskell$date_format$DateFormat$text('-'),
			$ryan_haskell$date_format$DateFormat$monthFixed,
			$ryan_haskell$date_format$DateFormat$text('-'),
			$ryan_haskell$date_format$DateFormat$dayOfMonthFixed
		]);
	return A3($ryan_haskell$date_format$DateFormat$format, format, $elm$time$Time$utc, date);
};
var $author$project$Views$PlanInfoForm$viewLimit = F2(
	function (item, limitString) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Included ' + item)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('member-count included-count')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('count-value')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(limitString)
								]))
						]))
				]));
	});
var $author$project$Views$PlanInfoForm$view = function (model) {
	var usersLimit = model.D$.GZ;
	var userLimitString = (usersLimit > 0) ? $elm$core$String$fromInt(usersLimit) : '∞';
	var planCard = A2(
		$author$project$Views$Card$withH2HeaderText,
		'Plan',
		A2(
			$author$project$Views$Card$withAttributes,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('plan-info')
				]),
			$author$project$Views$Card$newCard));
	var memberCountStr = A2(
		$elm$core$Maybe$withDefault,
		'(Unknown)',
		A2($elm$core$Maybe$map, $elm$core$String$fromInt, model.c3.Eg));
	var viewPlanView = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('plan-details')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Tier')
							])),
						$elm$html$Html$text(
						$elm_community$string_extra$String$Extra$toTitleCase(model.c3.dc))
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Renewal Date')
							])),
						$elm$html$Html$text(
						A2(
							$elm$core$Maybe$withDefault,
							'Not set',
							A2($elm$core$Maybe$map, $author$project$Views$PlanInfoForm$formatDate, model.c3.xn)))
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Current Members '),
								A3(
								$author$project$Views$Link$link,
								$author$project$Model$Route$adminUsers(
									$elm$core$Maybe$Just(model.c3.AC)),
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('(View)')
									]))
							])),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('count-value')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(memberCountStr)
									]))
							]))
					])),
				A2($author$project$Views$PlanInfoForm$viewLimit, 'Members', userLimitString),
				A2(
				$author$project$Views$PlanInfoForm$viewLimit,
				'Nodes',
				$elm$core$String$fromInt(model.D$.EB)),
				A2(
				$author$project$Views$PlanInfoForm$viewLimit,
				'Active Runtimes',
				$elm$core$String$fromInt(model.D$.A0))
			]));
	return $author$project$Views$Card$asHtmlCard(
		A2(
			$author$project$Views$Card$withContent,
			_List_fromArray(
				[viewPlanView]),
			planCard));
};
var $author$project$Pages$AdminOrganization$ToggleBelongsToActivator = {$: 27};
var $author$project$Pages$AdminOrganization$UpdateAdminMetadata = {$: 28};
var $author$project$Pages$AdminOrganization$viewAdminMetadata = F2(
	function (adminMetadata, session) {
		var hasWriteAccess = $author$project$Model$Session$isSuperUser(session);
		return $author$project$Views$Card$asHtmlCard(
			A2(
				$author$project$Views$Card$withContent,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('admin-metadata-form')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$type_('checkbox'),
												$elm$html$Html$Attributes$id('belongs-to-activator'),
												$elm$html$Html$Attributes$disabled(!hasWriteAccess),
												$elm$html$Html$Attributes$checked(adminMetadata.Bg),
												$elm$html$Html$Events$onClick($author$project$Pages$AdminOrganization$ToggleBelongsToActivator)
											]),
										_List_Nil),
										A2(
										$elm$html$Html$label,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$for('belongs-to-activator')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('For Reporting'),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('meta')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(' - Activator Only')
													]))
											]))
									])),
								A2(
								$author$project$Misc$displayIf,
								hasWriteAccess,
								A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('primary-button', true)
												])),
											$elm$html$Html$Events$onClick($author$project$Pages$AdminOrganization$UpdateAdminMetadata)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Update Metadata')
										])))
							]))
					]),
				A2($author$project$Views$Card$withH2HeaderText, 'Metadata', $author$project$Views$Card$newCard)));
	});
var $author$project$Pages$AdminOrganization$AskForConfirmation = {$: 12};
var $author$project$Pages$AdminOrganization$CancelDelete = {$: 13};
var $author$project$Pages$AdminOrganization$DeleteOrg = {$: 14};
var $author$project$Pages$AdminOrganization$viewDeleteUI = F2(
	function (session, model) {
		var hasWriteAccess = $author$project$Model$Session$isSuperUser(session);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('delete-ui delete-user')
				]),
			_List_fromArray(
				[
					function () {
					var _v0 = model.jP;
					switch (_v0) {
						case 0:
							return A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick($author$project$Pages$AdminOrganization$AskForConfirmation),
										$elm$html$Html$Attributes$class('delete-button'),
										$elm$html$Html$Attributes$disabled(
										$author$project$Pages$AdminOrganization$cannotDelete(model) || (!hasWriteAccess))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Delete this '),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('user-or-org')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('organization')
											]))
									]));
						case 1:
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('confirm')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('confirm-text')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Are you sure?')
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('confirm-buttons')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Events$onClick($author$project$Pages$AdminOrganization$DeleteOrg),
														$elm$html$Html$Attributes$class('red-button')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Yes!')
													])),
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Events$onClick($author$project$Pages$AdminOrganization$CancelDelete),
														$elm$html$Html$Attributes$class('cancel-button')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Cancel')
													]))
											]))
									]));
						default:
							return $elm$html$Html$text('');
					}
				}(),
					A2(
					$author$project$Misc$displayIf,
					$author$project$Pages$AdminOrganization$cannotDelete(model),
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('disabled-note')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('This organization is on a paid tier and can only be deleted manually from the database.')
							])))
				]));
	});
var $author$project$Views$Card$withFooter = F3(
	function (attrs, content, card) {
		return _Utils_update(
			card,
			{
				tS: $elm$core$Maybe$Just(
					A2($elm$html$Html$footer, attrs, content))
			});
	});
var $author$project$Pages$AdminOrganization$currentDetailsView = F2(
	function (model, session) {
		var organization = model.dp.c3;
		var hasWriteAccess = $author$project$Model$Session$isSuperUser(session);
		var detailItem = F2(
			function (field, value) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('detail-item')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(field)
								])),
							$elm$html$Html$text(value)
						]));
			});
		var detailView = $author$project$Views$Card$asHtmlCard(
			A2(
				$author$project$Views$Card$withContent,
				_List_fromArray(
					[
						A2(
						detailItem,
						'Created',
						A2(
							$author$project$Pages$AdminOrganization$formatDate,
							$author$project$Model$Session$getLocalTimezone(session),
							organization.ak)),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('detail-item')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Org ID')
									])),
								function () {
								var copyID = 'organization-id';
								return $author$project$Views$CliText$view(
									{
										B$: $elm$core$Maybe$Just(
											{Em: $author$project$Pages$AdminOrganization$CopyClipboard, L: model.oi}),
										l6: copyID,
										Gv: $author$project$Model$Organization$idString(organization)
									});
							}()
							]))
					]),
				A2(
					$author$project$Views$Card$withH2HeaderText,
					'Details',
					A2(
						$author$project$Views$Card$withAttributes,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('details')
							]),
						$author$project$Views$Card$newCard))));
		var categoryView = F2(
			function (selected, cat) {
				return A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('selected', selected)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$Pages$AdminOrganization$ChangeCategory(cat))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(cat)
								]))
						]));
			});
		var addOnView = function (addOn) {
			var isOverridden = !A2(
				$elm$core$Maybe$withDefault,
				addOn.yQ,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.Cp;
						},
						$elm$core$Basics$eq(addOn.Cp)),
					A2(
						$elm$core$Maybe$andThen,
						$elm_community$list_extra$List$Extra$find(
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.w;
								},
								$elm$core$Basics$eq(addOn.w))),
						A2($elm$core$Dict$get, model.dp.c3.dc, model.jD))));
			return hasWriteAccess ? A5(
				$author$project$Views$AddOnToggle$addOnToggle,
				hasWriteAccess,
				$elm$html$Html$li,
				$author$project$Pages$AdminOrganization$SetAddOn(addOn.w),
				addOn,
				isOverridden) : A5(
				$author$project$Views$AddOnToggle$addOnToggle,
				hasWriteAccess,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$cons(
						$elm$html$Html$Attributes$class('disabled')),
					$elm$html$Html$li),
				$elm$core$Basics$always($author$project$Pages$AdminOrganization$NoOp),
				addOn,
				isOverridden);
		};
		var addOnsView = function () {
			var withAddOnsFooter = (hasWriteAccess && (!$elm$core$List$isEmpty(
				$author$project$Pages$AdminOrganization$overriddenAddOns(model)))) ? A2(
				$author$project$Views$Card$withFooter,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('delete-button'),
								$elm$html$Html$Events$onClick(
								$author$project$Pages$AdminOrganization$ResetAddOns($elm$core$Maybe$Nothing))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Clear Overrides')
							]))
					])) : $elm$core$Basics$identity;
			var addOnsBody = _List_fromArray(
				[
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('categories')
						]),
					A2(
						$elm$core$List$map,
						function (c) {
							return A2(
								categoryView,
								_Utils_eq(c, model.ol),
								c);
						},
						$author$project$Pages$AdminOrganization$categoriesForAddOnDefaultsByTier(model.jD))),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('add-ons-list')
						]),
					A2(
						$elm$core$List$map,
						addOnView,
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.xA;
								},
								$elm$core$Basics$eq(model.ol)),
							$author$project$Pages$AdminOrganization$addOnsWithDescriptions(model))))
				]);
			return $author$project$Views$Card$asHtmlCard(
				A2(
					$author$project$Views$Card$withContent,
					addOnsBody,
					withAddOnsFooter(
						A2(
							$author$project$Views$Card$withH2HeaderText,
							'Add-ons',
							A2(
								$author$project$Views$Card$withAttributes,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id('add-ons')
									]),
								$author$project$Views$Card$newCard)))));
		}();
		return _List_fromArray(
			[
				A3($author$project$Pages$AdminOrganization$displayNameView, session, organization.i$, model.o5),
				A3($author$project$Pages$AdminOrganization$urlNameView, session, organization.AC, model.Er),
				A2($author$project$Pages$AdminOrganization$tierView, model, session),
				detailView,
				addOnsView,
				A2($author$project$Pages$AdminOrganization$autoInviteView, model, session),
				$author$project$Views$PlanInfoForm$view(model.dp),
				A2($author$project$Pages$AdminOrganization$viewAdminMetadata, model.iN, session),
				A2($author$project$Pages$AdminOrganization$viewDeleteUI, session, model)
			]);
	});
var $justinmimbs$time_extra$Time$Extra$Day = 11;
var $justinmimbs$date$Date$Days = 3;
var $justinmimbs$time_extra$Time$Extra$Millisecond = 15;
var $justinmimbs$time_extra$Time$Extra$Month = 2;
var $justinmimbs$date$Date$Months = 1;
var $justinmimbs$date$Date$RD = $elm$core$Basics$identity;
var $justinmimbs$date$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$date$Date$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
		switch (m) {
			case 0:
				return 0;
			case 1:
				return 31;
			case 2:
				return 59 + leapDays;
			case 3:
				return 90 + leapDays;
			case 4:
				return 120 + leapDays;
			case 5:
				return 151 + leapDays;
			case 6:
				return 181 + leapDays;
			case 7:
				return 212 + leapDays;
			case 8:
				return 243 + leapDays;
			case 9:
				return 273 + leapDays;
			case 10:
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$date$Date$floorDiv = F2(
	function (a, b) {
		return $elm$core$Basics$floor(a / b);
	});
var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100)) + A2($justinmimbs$date$Date$floorDiv, y, 400);
	return (365 * y) + leapYears;
};
var $justinmimbs$date$Date$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$date$Date$monthToNumber = function (m) {
	switch (m) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $justinmimbs$date$Date$numberToMonth = function (mn) {
	var _v0 = A2($elm$core$Basics$max, 1, mn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		case 11:
			return 10;
		default:
			return 11;
	}
};
var $justinmimbs$date$Date$toCalendarDateHelp = F3(
	function (y, m, d) {
		toCalendarDateHelp:
		while (true) {
			var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
			var mn = $justinmimbs$date$Date$monthToNumber(m);
			if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
				var $temp$y = y,
					$temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
					$temp$d = d - monthDays;
				y = $temp$y;
				m = $temp$m;
				d = $temp$d;
				continue toCalendarDateHelp;
			} else {
				return {xT: d, zg: m, AU: y};
			}
		}
	});
var $justinmimbs$date$Date$divWithRemainder = F2(
	function (a, b) {
		return _Utils_Tuple2(
			A2($justinmimbs$date$Date$floorDiv, a, b),
			A2($elm$core$Basics$modBy, b, a));
	});
var $justinmimbs$date$Date$year = function (_v0) {
	var rd = _v0;
	var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);
	var n400 = _v1.a;
	var r400 = _v1.b;
	var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);
	var n100 = _v2.a;
	var r100 = _v2.b;
	var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);
	var n4 = _v3.a;
	var r4 = _v3.b;
	var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);
	var n1 = _v4.a;
	var r1 = _v4.b;
	var n = (!r1) ? 0 : 1;
	return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
};
var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
	var rd = _v0;
	var y = $justinmimbs$date$Date$year(rd);
	return {
		vG: rd - $justinmimbs$date$Date$daysBeforeYear(y),
		AU: y
	};
};
var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
	var rd = _v0;
	var date = $justinmimbs$date$Date$toOrdinalDate(rd);
	return A3($justinmimbs$date$Date$toCalendarDateHelp, date.AU, 0, date.vG);
};
var $justinmimbs$date$Date$add = F3(
	function (unit, n, _v0) {
		var rd = _v0;
		switch (unit) {
			case 0:
				return A3($justinmimbs$date$Date$add, 1, 12 * n, rd);
			case 1:
				var date = $justinmimbs$date$Date$toCalendarDate(rd);
				var wholeMonths = ((12 * (date.AU - 1)) + ($justinmimbs$date$Date$monthToNumber(date.zg) - 1)) + n;
				var m = $justinmimbs$date$Date$numberToMonth(
					A2($elm$core$Basics$modBy, 12, wholeMonths) + 1);
				var y = A2($justinmimbs$date$Date$floorDiv, wholeMonths, 12) + 1;
				return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A2(
					$elm$core$Basics$min,
					date.xT,
					A2($justinmimbs$date$Date$daysInMonth, y, m));
			case 2:
				return rd + (7 * n);
			default:
				return rd + n;
		}
	});
var $justinmimbs$date$Date$fromCalendarDate = F3(
	function (y, m, d) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A3(
			$elm$core$Basics$clamp,
			1,
			A2($justinmimbs$date$Date$daysInMonth, y, m),
			d);
	});
var $justinmimbs$date$Date$fromPosix = F2(
	function (zone, posix) {
		return A3(
			$justinmimbs$date$Date$fromCalendarDate,
			A2($elm$time$Time$toYear, zone, posix),
			A2($elm$time$Time$toMonth, zone, posix),
			A2($elm$time$Time$toDay, zone, posix));
	});
var $justinmimbs$date$Date$toRataDie = function (_v0) {
	var rd = _v0;
	return rd;
};
var $justinmimbs$time_extra$Time$Extra$dateToMillis = function (date) {
	var daysSinceEpoch = $justinmimbs$date$Date$toRataDie(date) - 719163;
	return daysSinceEpoch * 86400000;
};
var $justinmimbs$time_extra$Time$Extra$timeFromClock = F4(
	function (hour, minute, second, millisecond) {
		return (((hour * 3600000) + (minute * 60000)) + (second * 1000)) + millisecond;
	});
var $justinmimbs$time_extra$Time$Extra$timeFromPosix = F2(
	function (zone, posix) {
		return A4(
			$justinmimbs$time_extra$Time$Extra$timeFromClock,
			A2($elm$time$Time$toHour, zone, posix),
			A2($elm$time$Time$toMinute, zone, posix),
			A2($elm$time$Time$toSecond, zone, posix),
			A2($elm$time$Time$toMillis, zone, posix));
	});
var $justinmimbs$time_extra$Time$Extra$toOffset = F2(
	function (zone, posix) {
		var millis = $elm$time$Time$posixToMillis(posix);
		var localMillis = $justinmimbs$time_extra$Time$Extra$dateToMillis(
			A2($justinmimbs$date$Date$fromPosix, zone, posix)) + A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix);
		return ((localMillis - millis) / 60000) | 0;
	});
var $justinmimbs$time_extra$Time$Extra$posixFromDateTime = F3(
	function (zone, date, time) {
		var millis = $justinmimbs$time_extra$Time$Extra$dateToMillis(date) + time;
		var offset0 = A2(
			$justinmimbs$time_extra$Time$Extra$toOffset,
			zone,
			$elm$time$Time$millisToPosix(millis));
		var posix1 = $elm$time$Time$millisToPosix(millis - (offset0 * 60000));
		var offset1 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix1);
		if (_Utils_eq(offset0, offset1)) {
			return posix1;
		} else {
			var posix2 = $elm$time$Time$millisToPosix(millis - (offset1 * 60000));
			var offset2 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix2);
			return _Utils_eq(offset1, offset2) ? posix2 : posix1;
		}
	});
var $justinmimbs$time_extra$Time$Extra$add = F4(
	function (interval, n, zone, posix) {
		add:
		while (true) {
			switch (interval) {
				case 15:
					return $elm$time$Time$millisToPosix(
						$elm$time$Time$posixToMillis(posix) + n);
				case 14:
					var $temp$interval = 15,
						$temp$n = n * 1000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 13:
					var $temp$interval = 15,
						$temp$n = n * 60000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 12:
					var $temp$interval = 15,
						$temp$n = n * 3600000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 11:
					return A3(
						$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
						zone,
						A3(
							$justinmimbs$date$Date$add,
							3,
							n,
							A2($justinmimbs$date$Date$fromPosix, zone, posix)),
						A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix));
				case 2:
					return A3(
						$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
						zone,
						A3(
							$justinmimbs$date$Date$add,
							1,
							n,
							A2($justinmimbs$date$Date$fromPosix, zone, posix)),
						A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix));
				case 0:
					var $temp$interval = 2,
						$temp$n = n * 12,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 1:
					var $temp$interval = 2,
						$temp$n = n * 3,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 3:
					var $temp$interval = 11,
						$temp$n = n * 7,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				default:
					var weekday = interval;
					var $temp$interval = 11,
						$temp$n = n * 7,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
			}
		}
	});
var $author$project$Views$MutationHistory$addDays = F2(
	function (numberOfDays, time) {
		return A4($justinmimbs$time_extra$Time$Extra$add, 11, numberOfDays, $elm$time$Time$utc, time);
	});
var $author$project$TimeUtils$epoch = $elm$time$Time$millisToPosix(0);
var $author$project$Views$MutationHistory$addOnsChange = function (addOnsDelta) {
	var changeText = function (_v0) {
		var enabled = _v0.Cp;
		var is_default = _v0.yQ;
		return is_default ? ' override removed' : (enabled ? ' enabled' : ' disabled');
	};
	var change = function (addOn) {
		return A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Add-on: ')
						])),
					$elm$html$Html$text(
					'\"' + (addOn.w + ('\"' + changeText(addOn))))
				]));
	};
	return A2(
		$author$project$Misc$displayIf,
		!$elm$core$List$isEmpty(addOnsDelta),
		A2(
			$elm$html$Html$div,
			_List_Nil,
			A2($elm$core$List$map, change, addOnsDelta)));
};
var $author$project$Views$MutationHistory$formatDate = F2(
	function (localTimezone, date) {
		return A3(
			$ryan_haskell$date_format$DateFormat$format,
			_List_fromArray(
				[
					$ryan_haskell$date_format$DateFormat$monthNameAbbreviated,
					$ryan_haskell$date_format$DateFormat$text(' '),
					$ryan_haskell$date_format$DateFormat$dayOfMonthSuffix,
					$ryan_haskell$date_format$DateFormat$text(', '),
					$ryan_haskell$date_format$DateFormat$yearNumber
				]),
			localTimezone,
			date);
	});
var $elm_community$string_extra$String$Extra$pluralize = F3(
	function (singular, plural, count) {
		return (count === 1) ? ('1 ' + singular) : ($elm$core$String$fromInt(count) + (' ' + plural));
	});
var $author$project$Views$MutationHistory$numberChange = F4(
	function (field, value, singularUnitName, pluralUnitName) {
		return (value > 0) ? A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(field + ':  ')
						])),
					$elm$html$Html$text(
					'Increased by ' + A3($elm_community$string_extra$String$Extra$pluralize, singularUnitName, pluralUnitName, value))
				])) : ((value < 0) ? A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(field + ':  ')
						])),
					$elm$html$Html$text(
					'Decreased by ' + A3($elm_community$string_extra$String$Extra$pluralize, singularUnitName, pluralUnitName, -value))
				])) : $elm$html$Html$text(''));
	});
var $author$project$Views$MutationHistory$stringChange = F2(
	function (field, value) {
		return A2(
			$author$project$Misc$displayIf,
			$elm$core$String$length(value) > 0,
			A2(
				$elm$html$Html$li,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(field + ':  ')
							])),
						$elm$html$Html$text('Changed to \"' + (value + '\"'))
					])));
	});
var $author$project$Views$MutationHistory$historyRow = F3(
	function (session, history, prevBillingDate) {
		var trialEndsChange = A4($author$project$Views$MutationHistory$numberChange, 'Trial End Delta', history.GO, 'day', 'days');
		var billingDateChange = function () {
			var delta = history.Bh;
			var newBillingDate = A2($author$project$Views$MutationHistory$addDays, delta, prevBillingDate);
			var preface = _Utils_eq(prevBillingDate, $author$project$TimeUtils$epoch) ? 'Set' : ((delta > 0) ? ('Increased by ' + ($elm$core$String$fromInt(delta) + ' days')) : ('Decreased by ' + ($elm$core$String$fromInt(-delta) + ' days')));
			return A2(
				$author$project$Misc$displayIf,
				!_Utils_eq(prevBillingDate, newBillingDate),
				A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Billing Date: ')
								])),
							$elm$html$Html$text(
							preface + (' to ' + A2(
								$author$project$Views$MutationHistory$formatDate,
								$author$project$Model$Session$getLocalTimezone(session),
								newBillingDate)))
						])));
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mutation')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Views$MutationHistory$stringChange, 'Tier', history.Aq),
									A2($author$project$Views$MutationHistory$stringChange, 'Subscription Status', history.Gk),
									A4($author$project$Views$MutationHistory$numberChange, 'Active Runtimes', history.A$, 'runtime', 'runtimes'),
									A4($author$project$Views$MutationHistory$numberChange, 'Active Runtimes Override', history.A1, 'runtime', 'runtimes'),
									A4($author$project$Views$MutationHistory$numberChange, 'Static Runtimes', history.Gd, 'runtime', 'runtimes'),
									A4($author$project$Views$MutationHistory$numberChange, 'Static Runtimes Override', history.Gf, 'runtime', 'runtimes'),
									A4($author$project$Views$MutationHistory$numberChange, 'Users', history.GY, 'user', 'users'),
									A4($author$project$Views$MutationHistory$numberChange, 'Nodes', history.EA, 'node', 'nodes'),
									billingDateChange,
									$author$project$Views$MutationHistory$addOnsChange(history.A3),
									A2($author$project$Views$MutationHistory$stringChange, 'Reseller ID', history.FG),
									A2($author$project$Views$MutationHistory$stringChange, 'Invoice ID', history.C2),
									A2($author$project$Views$MutationHistory$stringChange, 'PO Number', history.Fi),
									trialEndsChange
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mutation-meta')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('date')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Views$MutationHistory$formatDate,
										$author$project$Model$Session$getLocalTimezone(session),
										history.ak))
								])),
							$elm$html$Html$text(' by '),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(history.GX)
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mutation-message')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('\"' + (history.EE + '\"'))
								]))
						]))
				]));
	});
var $elm_community$list_extra$List$Extra$scanl = F3(
	function (f, b, xs) {
		var scan1 = F2(
			function (x, accAcc) {
				if (accAcc.b) {
					var acc = accAcc.a;
					return A2(
						$elm$core$List$cons,
						A2(f, x, acc),
						accAcc);
				} else {
					return _List_Nil;
				}
			});
		return $elm$core$List$reverse(
			A3(
				$elm$core$List$foldl,
				scan1,
				_List_fromArray(
					[b]),
				xs));
	});
var $author$project$Views$MutationHistory$viewHistory = F2(
	function (session, history) {
		var sortedByDate = $elm$core$List$reverse(
			A2(
				$elm$core$List$sortBy,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.ak;
					},
					$elm$time$Time$posixToMillis),
				history));
		var billingDates = A2(
			$elm$core$List$drop,
			1,
			$elm$core$List$reverse(
				A3(
					$elm_community$list_extra$List$Extra$scanl,
					$author$project$Views$MutationHistory$addDays,
					$author$project$TimeUtils$epoch,
					A2(
						$elm$core$List$map,
						function ($) {
							return $.Bh;
						},
						$elm$core$List$reverse(sortedByDate)))));
		return $elm$core$List$isEmpty(history) ? A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('No changes have been made since we started tracking them in this manner.')
				])) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('org-mutations')
				]),
			A3(
				$elm$core$List$map2,
				$author$project$Views$MutationHistory$historyRow(session),
				sortedByDate,
				billingDates));
	});
var $author$project$Pages$AdminOrganization$view = F2(
	function (model, session) {
		var organization = model.dp.c3;
		var modeView = function () {
			var _v0 = model.El;
			if (!_v0) {
				return A2($author$project$Pages$AdminOrganization$currentDetailsView, model, session);
			} else {
				return _List_fromArray(
					[
						A2($author$project$Views$MutationHistory$viewHistory, session, model.q9)
					]);
			}
		}();
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('page admin-organization')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('crumb-title')
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Views$Link$link,
								$author$project$Model$Route$adminOrganizations,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Organizations')
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('crumb-divider')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('/')
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('organization-name')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(organization.AC)
									]))
							])),
						A3(
						$author$project$Views$Link$link,
						$author$project$Model$Route$Protected(
							$author$project$Model$Route$Org(
								{
									ix: organization.AC,
									vI: $author$project$Model$Route$OrgIndex($elm$core$Maybe$Nothing)
								})),
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('primary-button')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('View Dashboard')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('section-tabs')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('selected', !model.El)
											])),
										$elm$html$Html$Events$onClick(
										$author$project$Pages$AdminOrganization$ChangeTab(0))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Organization Details')
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('selected', model.El === 1)
											])),
										$elm$html$Html$Events$onClick(
										$author$project$Pages$AdminOrganization$ChangeTab(1))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('History of Changes')
									]))
							]))
					]),
				modeView));
	});
var $author$project$Pages$AdminOrganizations$ChangeMode = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$AdminOrganizations$ClearSearchString = {$: 3};
var $author$project$Pages$AdminOrganizations$Name = 1;
var $author$project$Pages$AdminOrganizations$UpdateSearchString = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$AdminOrganizations$CopyClipboard = function (a) {
	return {$: 5, a: a};
};
var $elm$html$Html$td = _VirtualDom_node('td');
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $author$project$Pages$AdminOrganizations$orgRow = F2(
	function (model, org) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('org-name')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Views$Link$link,
							$author$project$Model$Route$Protected(
								$author$project$Model$Route$Org(
									{
										ix: org.AC,
										vI: $author$project$Model$Route$OrgIndex($elm$core$Maybe$Nothing)
									})),
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(org.AC)
								])),
							A2(
							$author$project$Misc$displayIf,
							!_Utils_eq(org.AC, org.i$),
							A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('full-name')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Full name: ' + org.i$)
									])))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('org-tier')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(org.dc)
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('org-id')
						]),
					_List_fromArray(
						[
							function () {
							var copyID = 'org-id-' + org.zw;
							return $author$project$Views$CliText$view(
								{
									B$: $elm$core$Maybe$Just(
										{Em: $author$project$Pages$AdminOrganizations$CopyClipboard, L: model.oi}),
									l6: copyID,
									Gv: org.zw
								});
						}()
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row-actions')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Views$Link$link,
							$author$project$Model$Route$adminOrganization(org.AC),
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('primary-button')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Manage Org')
								]))
						]))
				]));
	});
var $author$project$Pages$AdminOrganizations$keyedOrgRow = F2(
	function (model, org) {
		return _Utils_Tuple2(
			org.zw,
			A2($author$project$Pages$AdminOrganizations$orgRow, model, org));
	});
var $author$project$Pages$AdminOrganizations$listNotEmpty = A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not);
var $author$project$Pages$AdminOrganizations$searchOptionsView = function (model) {
	return A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('search-option')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('show-free-orgs'),
						$elm$html$Html$Attributes$type_('checkbox'),
						$elm$html$Html$Attributes$checked(model.mT.wb),
						$elm$html$Html$Events$onCheck(
						function (value) {
							return $author$project$Pages$AdminOrganizations$DoSearch(
								function (options) {
									return _Utils_update(
										options,
										{wb: value});
								});
						})
					]),
				_List_Nil),
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$for('show-free-orgs')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Include Free Tier organizations')
					]))
			]));
};
var $author$project$Pages$AdminOrganizations$stringNotEmpty = A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not);
var $elm$html$Html$table = _VirtualDom_node('table');
var $elm$html$Html$th = _VirtualDom_node('th');
var $elm$html$Html$thead = _VirtualDom_node('thead');
var $author$project$Pages$AdminOrganizations$view = F2(
	function (model, _v0) {
		var searchTypeStr = function () {
			var _v5 = model.El;
			if (_v5 === 1) {
				return 'URL Name';
			} else {
				return 'ID';
			}
		}();
		var searchStringError = $author$project$Pages$AdminOrganizations$getSearchStringError(model);
		var searchStringValid = function () {
			if (searchStringError.$ === 1) {
				return true;
			} else {
				return false;
			}
		}();
		var orgTable = function () {
			var _v3 = model.mX;
			if (_v3.$ === 3) {
				var orgs = _v3.a;
				return A2(
					$author$project$Misc$displayIf,
					$author$project$Pages$AdminOrganizations$listNotEmpty(orgs) && (_Utils_cmp(
						$elm$core$List$length(orgs),
						$author$project$Request$AdminOrganizations$queryMaxSize) < 0),
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('table-wrapper')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$table,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('item-table orgs-table')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$thead,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$tr,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$th,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('org-name')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('URL & Full Name')
															])),
														A2(
														$elm$html$Html$th,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('org-tier')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Tier')
															])),
														A2(
														$elm$html$Html$th,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('org-tier')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Org ID')
															])),
														A2(
														$elm$html$Html$th,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('row-actions')
															]),
														_List_Nil)
													]))
											])),
										A3(
										$elm$html$Html$Keyed$node,
										'tbody',
										_List_Nil,
										A2(
											$elm$core$List$map,
											$author$project$Pages$AdminOrganizations$keyedOrgRow(model),
											orgs))
									]))
							])));
			} else {
				return $elm$html$Html$text('');
			}
		}();
		var listHeading = function () {
			var _v1 = model.mX;
			switch (_v1.$) {
				case 1:
					return $elm$html$Html$text('Loading...');
				case 3:
					var orgs = _v1.a;
					var _v2 = $elm$core$List$length(orgs);
					switch (_v2) {
						case 0:
							return A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('No organizations found')
									]));
						case 1:
							return A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('1 organization found')
									]));
						default:
							var n = _v2;
							return (_Utils_cmp(n, $author$project$Request$AdminOrganizations$queryMaxSize) > 0) ? A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('field-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Found more than '),
										A2(
										$elm$html$Html$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$elm$core$String$fromInt($author$project$Request$AdminOrganizations$queryMaxSize))
											])),
										$elm$html$Html$text(' organizations - too many to show at once. Use the search form to narrow the list down.')
									])) : A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(n) + ' organizations found')
									]));
					}
				default:
					return $elm$html$Html$text('');
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('page')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('page-heading')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Organizations')
								])),
							A3(
							$author$project$Views$Link$link,
							$author$project$Model$Route$Protected(
								$author$project$Model$Route$Admin($author$project$Model$Route$AdminCreateOrganization)),
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('primary-button')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Create a new Organization')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('section-tabs')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('selected', !model.El)
										])),
									$elm$html$Html$Events$onClick(
									$author$project$Pages$AdminOrganizations$ChangeMode(0))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Org ID')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('selected', model.El === 1)
										])),
									$elm$html$Html$Events$onClick(
									$author$project$Pages$AdminOrganizations$ChangeMode(1))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('URL Name')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('org-search-form')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Search By Organization ' + searchTypeStr)
								])),
							A2(
							$author$project$Misc$displayIf,
							model.El === 1,
							$author$project$Pages$AdminOrganizations$searchOptionsView(model)),
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('text'),
									$elm$html$Html$Attributes$class('search-field'),
									$elm$html$Html$Attributes$spellcheck(false),
									$elm$html$Html$Events$onInput($author$project$Pages$AdminOrganizations$UpdateSearchString),
									$elm$html$Html$Attributes$autofocus(true),
									$elm$html$Html$Attributes$value(model.iE),
									$elm$html$Html$Attributes$placeholder(
									A2($elm$core$Maybe$withDefault, '', searchStringError))
								]),
							_List_Nil),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('secondary-button'),
									$elm$html$Html$Events$onClick(
									$author$project$Pages$AdminOrganizations$DoSearch(
										function (options) {
											return _Utils_update(
												options,
												{lQ: false});
										})),
									$elm$html$Html$Attributes$disabled(!searchStringValid)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Search')
								])),
							A2(
							$author$project$Misc$displayIf,
							model.El === 1,
							A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('secondary-button'),
										$elm$html$Html$Events$onClick(
										$author$project$Pages$AdminOrganizations$DoSearch(
											function (options) {
												return _Utils_update(
													options,
													{lQ: true});
											})),
										$elm$html$Html$Attributes$disabled(!searchStringValid)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Exact Search')
									]))),
							A2(
							$author$project$Misc$displayIf,
							$author$project$Pages$AdminOrganizations$stringNotEmpty(model.iE),
							A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('button'),
										$elm$html$Html$Attributes$class('cancel-button'),
										$elm$html$Html$Events$onClick($author$project$Pages$AdminOrganizations$ClearSearchString)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Reset')
									])))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('page-body')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('table-heading')
								]),
							_List_fromArray(
								[listHeading])),
							orgTable
						]))
				]));
	});
var $author$project$Pages$AdminUser$CopyClipboard = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$AdminUser$formatDate = F2(
	function (localTimezone, date) {
		var format = _List_fromArray(
			[
				$ryan_haskell$date_format$DateFormat$monthNameAbbreviated,
				$ryan_haskell$date_format$DateFormat$text(' '),
				$ryan_haskell$date_format$DateFormat$dayOfMonthFixed,
				$ryan_haskell$date_format$DateFormat$text(', '),
				$ryan_haskell$date_format$DateFormat$yearNumber
			]);
		return A3($ryan_haskell$date_format$DateFormat$format, format, localTimezone, date);
	});
var $author$project$Pages$AdminUser$SetOrgsListSelectedRole = function (a) {
	return {$: 10, a: a};
};
var $elm_community$maybe_extra$Maybe$Extra$join = function (mx) {
	if (!mx.$) {
		var x = mx.a;
		return x;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$AdminUser$orgListView = function (model) {
	var orgRoles = A3(
		$author$project$Misc$groupByOn,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.FO;
			},
			$author$project$Model$Role$toDisplayString),
		function ($) {
			return $.AC;
		},
		model.rJ);
	var selected = function () {
		var _v0 = model.rK;
		if (_v0.$ === 1) {
			return $elm$core$List$head(
				$elm$core$Dict$keys(orgRoles));
		} else {
			var s = _v0;
			return s;
		}
	}();
	var roleLi = function (role) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'selected',
							_Utils_eq(
								selected,
								$elm$core$Maybe$Just(role)))
						])),
					$elm$html$Html$Events$onClick(
					$author$project$Pages$AdminUser$SetOrgsListSelectedRole(role))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(role)
						]))
				]));
	};
	var orgRolesColumn = A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$id('orgs-roles')
			]),
		A2(
			$elm$core$List$map,
			roleLi,
			$elm$core$Dict$keys(orgRoles)));
	var selectedRoleOrgsGetter = A2($elm$core$Maybe$map, $elm$core$Dict$get, selected);
	var rolesList = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		$elm_community$maybe_extra$Maybe$Extra$join(
			A2(
				$elm_community$maybe_extra$Maybe$Extra$andMap,
				$elm$core$Maybe$Just(orgRoles),
				selectedRoleOrgsGetter)));
	var orgLi = function (org) {
		return A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(
							$author$project$Model$Route$urlPiecesToString(
								$author$project$Model$Route$protectedRouteToString(
									$author$project$Model$Route$Org(
										{
											ix: org,
											vI: $author$project$Model$Route$OrgIndex($elm$core$Maybe$Nothing)
										}))))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(org)
						])),
					A3(
					$author$project$Views$Link$link,
					$author$project$Model$Route$adminOrganization(org),
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('primary-button small')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Manage')
						]))
				]));
	};
	var orgsColumn = A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$id('orgs-list-orgs')
			]),
		A2($elm$core$List$map, orgLi, rolesList));
	var orgCard = $author$project$Views$Card$asHtmlCard(
		A2(
			$author$project$Views$Card$withContent,
			_List_fromArray(
				[orgRolesColumn, orgsColumn]),
			A2(
				$author$project$Views$Card$withH2HeaderText,
				'Organizations',
				A2(
					$author$project$Views$Card$withAttributes,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('orgs-list')
						]),
					$author$project$Views$Card$newCard))));
	return $elm$core$List$isEmpty(model.rJ) ? _List_Nil : _List_fromArray(
		[orgCard]);
};
var $author$project$Pages$AdminUser$NewUsernameValue = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$AdminUser$SaveNewUsername = {$: 2};
var $author$project$Pages$AdminUser$invalidNameChange = F2(
	function (existing, _new) {
		return _Utils_eq(existing, _new) || $elm$core$String$isEmpty(_new);
	});
var $author$project$Pages$AdminUser$usernameView = F3(
	function (session, currentName, newName) {
		var hasWriteAccess = $author$project$Model$Session$isSuperUser(session);
		return $author$project$Views$Card$asHtmlCard(
			A2(
				$author$project$Views$Card$withContent,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$form,
						_List_fromArray(
							[
								$elm$html$Html$Events$onSubmit($author$project$Pages$AdminUser$SaveNewUsername)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('The link to this user on the platform.')
									])),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('url-prefix')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('platform.activestate.com/...')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('input-block')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$type_('text'),
												$elm$html$Html$Attributes$disabled(!hasWriteAccess),
												$elm$html$Html$Attributes$value(newName),
												$elm$html$Html$Events$onInput($author$project$Pages$AdminUser$NewUsernameValue)
											]),
										_List_Nil),
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$type_('submit'),
												$elm$html$Html$Attributes$disabled(!hasWriteAccess),
												$elm$html$Html$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2('primary-button', true),
														_Utils_Tuple2(
														'invalid',
														A2($author$project$Pages$AdminUser$invalidNameChange, currentName, newName))
													]))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Change URL')
											]))
									])),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('warning'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'invalid',
												A2($author$project$Pages$AdminUser$invalidNameChange, currentName, newName))
											]))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Old URL will no longer work!')
									]))
							]))
					]),
				A2(
					$author$project$Views$Card$withH2HeaderText,
					'URL',
					A2(
						$author$project$Views$Card$withAttributes,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('url-settings')
							]),
						$author$project$Views$Card$newCard))));
	});
var $author$project$Pages$AdminUser$AskForConfirmation = {$: 4};
var $author$project$Pages$AdminUser$CancelDelete = {$: 5};
var $author$project$Pages$AdminUser$DeleteUser = {$: 6};
var $author$project$Pages$AdminUser$viewDeleteUI = F2(
	function (session, model) {
		var hasWriteAccess = $author$project$Model$Session$isSuperUser(session);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('delete-ui delete-user')
				]),
			_List_fromArray(
				[
					function () {
					var _v0 = model.jP;
					switch (_v0) {
						case 0:
							return A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick($author$project$Pages$AdminUser$AskForConfirmation),
										$elm$html$Html$Attributes$class('delete-button'),
										$elm$html$Html$Attributes$disabled(!hasWriteAccess)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Delete this '),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('user-or-org')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('user')
											]))
									]));
						case 1:
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('confirm')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('confirm-text')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Are you sure?')
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('confirm-buttons')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Events$onClick($author$project$Pages$AdminUser$DeleteUser),
														$elm$html$Html$Attributes$class('red-button')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Yes!')
													])),
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Events$onClick($author$project$Pages$AdminUser$CancelDelete),
														$elm$html$Html$Attributes$class('cancel-button')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Cancel')
													]))
											]))
									]));
						default:
							return $elm$html$Html$text('');
					}
				}()
				]));
	});
var $author$project$Pages$AdminUser$currentDetailsView = F2(
	function (model, session) {
		var user = model.gS;
		var detailItem = F2(
			function (field, value) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('detail-item')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(field)
								])),
							$elm$html$Html$text(value)
						]));
			});
		var detailView = function () {
			var copyID = 'user-id';
			return $author$project$Views$Card$asHtmlCard(
				A2(
					$author$project$Views$Card$withContent,
					_List_fromArray(
						[
							A2(
							detailItem,
							'Created',
							A2(
								$elm$core$Result$withDefault,
								user.ak,
								A2(
									$elm$core$Result$map,
									$author$project$Pages$AdminUser$formatDate(
										$author$project$Model$Session$getLocalTimezone(session)),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(user.ak)))),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('detail-item')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('User ID')
										])),
									$author$project$Views$CliText$view(
									{
										B$: $elm$core$Maybe$Just(
											{Em: $author$project$Pages$AdminUser$CopyClipboard, L: model.oi}),
										l6: copyID,
										Gv: user.wV
									})
								])),
							A2(
							detailItem,
							'Auto Username',
							$Chadtech$elm_bool_extra$Bool$Extra$toString(user.DJ))
						]),
					A2(
						$author$project$Views$Card$withH2HeaderText,
						'Details',
						A2(
							$author$project$Views$Card$withAttributes,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id('details')
								]),
							$author$project$Views$Card$newCard))));
		}();
		return _Utils_ap(
			_List_fromArray(
				[
					A3($author$project$Pages$AdminUser$usernameView, session, user.AE, model.kc),
					detailView
				]),
			_Utils_ap(
				$author$project$Pages$AdminUser$orgListView(model),
				_List_fromArray(
					[
						A2($author$project$Pages$AdminUser$viewDeleteUI, session, model)
					])));
	});
var $author$project$Pages$AdminUser$view = F2(
	function (model, session) {
		var user = model.gS;
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('page admin-organization')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('crumb-header')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h1,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('crumb-title')
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Views$Link$link,
										$author$project$Model$Route$adminUsers($elm$core$Maybe$Nothing),
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Users')
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('crumb-divider')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('/')
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('organization-name')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(user.AE)
											]))
									])),
								A3(
								$author$project$Views$Link$link,
								$author$project$Model$Route$Protected(
									$author$project$Model$Route$Home(
										{wd: $elm$core$Maybe$Nothing})),
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('primary-button')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('View Dashboard')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('section-tabs')
							]),
						_List_Nil)
					]),
				A2($author$project$Pages$AdminUser$currentDetailsView, model, session)));
	});
var $author$project$Pages$AdminUsers$ChangeTab = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$AdminUsers$ClearOrgSearch = {$: 11};
var $author$project$Pages$AdminUsers$ClearUserEmailSearch = {$: 7};
var $author$project$Pages$AdminUsers$ClearUsernameSearch = {$: 3};
var $author$project$Pages$AdminUsers$UpdateOrgQuery = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$AdminUsers$UpdateUserEmailQuery = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$AdminUsers$UpdateUsernameQuery = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$AdminUsers$UsernameSearch = 0;
var $author$project$Pages$AdminUsers$VerifyEmail = 3;
var $author$project$Pages$AdminUsers$CopyClipboard = function (a) {
	return {$: 20, a: a};
};
var $author$project$Pages$AdminUsers$LoginAsUser = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$AdminUsers$userRow = F2(
	function (model, user) {
		var emailHtml = function () {
			var emailVisible = A2($elm$core$String$contains, model.jC, user.lJ);
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('user-email')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(user.lJ),
						A2(
						$author$project$Misc$displayIf,
						(model.El === 1) && (!emailVisible),
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('non-primary-note')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Non-primary email matches')
								])))
					]));
		}();
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('user-name')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(user.AE),
							emailHtml
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('org-id')
						]),
					_List_fromArray(
						[
							function () {
							var copyID = 'user-id-' + user.wV;
							return $author$project$Views$CliText$view(
								{
									B$: $elm$core$Maybe$Just(
										{Em: $author$project$Pages$AdminUsers$CopyClipboard, L: model.oi}),
									l6: copyID,
									Gv: user.wV
								});
						}()
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row-actions')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Views$Link$link,
							$author$project$Model$Route$adminUser(user.AE),
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('primary-button')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Manage User')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('primary-button'),
									$elm$html$Html$Events$onClick(
									$author$project$Pages$AdminUsers$LoginAsUser(user)),
									$elm$html$Html$Attributes$type_('button')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Sign in as User')
								]))
						]))
				]));
	});
var $author$project$Pages$AdminUsers$keyedUserRow = F2(
	function (model, user) {
		return A2(
			$author$project$Misc$with,
			A2($author$project$Pages$AdminUsers$userRow, model, user),
			user.wV);
	});
var $author$project$Pages$AdminUsers$stringNotEmpty = A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not);
var $author$project$Pages$AdminUsers$searchField = F2(
	function (model, _v0) {
		var search = _v0.pK;
		var updateQuery = _v0.p1;
		var clear = _v0.oa;
		var query = _v0.r1;
		var labelText = _v0.oW;
		var users = _v0.p5;
		var searchFinished = _v0.pL;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(labelText)
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('text'),
								$elm$html$Html$Attributes$class('search-field'),
								$elm$html$Html$Events$onInput(updateQuery),
								$elm$html$Html$Attributes$value(query)
							]),
						_List_Nil),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(search),
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Attributes$class('primary-button')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Search')
							])),
						A2(
						$author$project$Misc$displayIf,
						$author$project$Pages$AdminUsers$stringNotEmpty(query),
						A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(clear),
									$elm$html$Html$Attributes$type_('button'),
									$elm$html$Html$Attributes$class('cancel-button')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Reset')
								]))),
						A2(
						$author$project$Misc$displayIf,
						!$elm$core$List$isEmpty(users),
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('page-body')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('table-heading')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromInt(
														$elm$core$List$length(users)) + ' users found')
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('table-wrapper')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$table,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('item-table orgs-table')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$thead,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$th,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('user-name')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Username & Primary Email')
																		])),
																	A2(
																	$elm$html$Html$th,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text('User ID')
																		])),
																	A2(
																	$elm$html$Html$th,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('row-actions')
																		]),
																	_List_Nil)
																]))
														])),
													A3(
													$elm$html$Html$Keyed$node,
													'tbody',
													_List_Nil,
													A2(
														$elm$core$List$map,
														$author$project$Pages$AdminUsers$keyedUserRow(model),
														users))
												]))
										]))
								]))),
						A2(
						$author$project$Misc$displayIf,
						$elm$core$List$isEmpty(users) && searchFinished,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('table-heading')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('No matching users found.')
								])))
					]))
			]);
	});
var $author$project$Pages$AdminUsers$ClearVerifyEmail = {$: 17};
var $author$project$Pages$AdminUsers$VerifyEmailChanged = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$AdminUsers$viewVerifyEmail = function (model) {
	var block = $elm$core$String$isEmpty(model.nM) ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('org-search-form')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h4,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Enter an unverified email address to retrieve the verification link.')
					])),
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('text'),
						$elm$html$Html$Events$onInput($author$project$Pages$AdminUsers$VerifyEmailChanged),
						$elm$html$Html$Attributes$class('search-field'),
						$elm$html$Html$Attributes$placeholder('user@example.com')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('primary-button'),
						$elm$html$Html$Events$onClick($author$project$Pages$AdminUsers$DoVerifyEmail)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Get Verification Link')
					]))
			])) : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('org-search-form')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h4,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Verification link for \"' + (model.nN + '\"'))
					])),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('verification-link')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(model.nM)
					])),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('warning')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Please ')
									])),
								$elm$html$Html$text(' - Only share this link by emailing it to the same email address.')
							]))
					])),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('primary-button'),
						$elm$html$Html$Events$onClick($author$project$Pages$AdminUsers$ClearVerifyEmail)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Search Again')
					]))
			]));
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[block]));
};
var $author$project$Pages$AdminUsers$view = F2(
	function (model, _v0) {
		var usernameSearchConfig = {oa: $author$project$Pages$AdminUsers$ClearUsernameSearch, oW: 'Enter at least three characters of a username', r1: model.kG, pK: $author$project$Pages$AdminUsers$DoUsernameSearch, pL: model.nK, p1: $author$project$Pages$AdminUsers$UpdateUsernameQuery, p5: model.p4};
		var userEmailSearchConfig = {oa: $author$project$Pages$AdminUsers$ClearUserEmailSearch, oW: 'Enter at least three characters of an email', r1: model.jC, pK: $author$project$Pages$AdminUsers$DoUserEmailSearch, pL: model.nJ, p1: $author$project$Pages$AdminUsers$UpdateUserEmailQuery, p5: model.lM};
		var orgSearchConfig = {oa: $author$project$Pages$AdminUsers$ClearOrgSearch, oW: 'Enter an exact organization URL name to see its members.', r1: model.kl, pK: $author$project$Pages$AdminUsers$DoOrgSearch, pL: model.mV, p1: $author$project$Pages$AdminUsers$UpdateOrgQuery, p5: model.mW};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('page')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('page-heading')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Users')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('section-tabs')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('selected', model.El === 1)
										])),
									$elm$html$Html$Events$onClick(
									$author$project$Pages$AdminUsers$ChangeTab(1))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Search by Email')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('selected', !model.El)
										])),
									$elm$html$Html$Events$onClick(
									$author$project$Pages$AdminUsers$ChangeTab(0))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Search by Username')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('selected', model.El === 2)
										])),
									$elm$html$Html$Events$onClick(
									$author$project$Pages$AdminUsers$ChangeTab(2))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('In an Organization')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('selected', model.El === 3)
										])),
									$elm$html$Html$Events$onClick(
									$author$project$Pages$AdminUsers$ChangeTab(3))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Verify Email Address')
								]))
						])),
					A2(
					$author$project$Misc$displayIf,
					model.El === 2,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('org-search-form')
							]),
						A2($author$project$Pages$AdminUsers$searchField, model, orgSearchConfig))),
					A2(
					$author$project$Misc$displayIf,
					!model.El,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('org-search-form')
							]),
						A2($author$project$Pages$AdminUsers$searchField, model, usernameSearchConfig))),
					A2(
					$author$project$Misc$displayIf,
					model.El === 1,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('org-search-form')
							]),
						A2($author$project$Pages$AdminUsers$searchField, model, userEmailSearchConfig))),
					A2(
					$author$project$Misc$displayIf,
					model.El === 3,
					$author$project$Pages$AdminUsers$viewVerifyEmail(model))
				]));
	});
var $author$project$Pages$AuthorizeDevice$DoAuthorize = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$AuthorizeDevice$CopyClipboard = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$AuthorizeDevice$SwitchLanguage = function (a) {
	return {$: 4, a: a};
};
var $elm$html$Html$details = _VirtualDom_node('details');
var $elm$core$List$intersperse = F2(
	function (sep, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var hd = xs.a;
			var tl = xs.b;
			var step = F2(
				function (x, rest) {
					return A2(
						$elm$core$List$cons,
						sep,
						A2($elm$core$List$cons, x, rest));
				});
			var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
			return A2($elm$core$List$cons, hd, spersed);
		}
	});
var $elm$html$Html$summary = _VirtualDom_node('summary');
var $author$project$Pages$AuthorizeDevice$cliInstructions = F2(
	function (model, session) {
		var popularPackages = $author$project$Model$PopularPackages$listForLanguage(model.iG);
		var maybeFirstOrgUrlName = function () {
			var _v3 = $author$project$Model$Session$getUser(session);
			if (!_v3.$) {
				var user = _v3.a;
				return A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.AC;
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$sortBy,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.AC;
								},
								$elm$core$String$toLower),
							user.mX)));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var importFileTypes = $author$project$Model$Language$importFileFormats(model.iG);
		var firstPackage = A2(
			$elm$core$Maybe$withDefault,
			'<package-name>',
			$elm$core$List$head(popularPackages));
		var _v0 = _Utils_Tuple2(
			$author$project$Model$Language$toString(model.iG),
			$author$project$Model$Language$toDisplayString(model.iG));
		var languageName = _v0.a;
		var languageDisplayName = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('cli-onboarding')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Continue your language installation')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Now that you\'re authenticated,  continue installing your language with the commands below.')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('section-tabs')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('selected', model.iG === 1)
										])),
									$elm$html$Html$Events$onClick(
									$author$project$Pages$AuthorizeDevice$SwitchLanguage(1))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Install Python')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('selected', !model.iG)
										])),
									$elm$html$Html$Events$onClick(
									$author$project$Pages$AuthorizeDevice$SwitchLanguage(0))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Install Perl')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('cli-onboarding-steps')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('onboarding-step')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Step 1')
												])),
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Set up a new ' + (languageDisplayName + ' environment'))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('snippet-wrapper')
												]),
											_List_fromArray(
												[
													$author$project$Views$CliText$view(
													{
														B$: $elm$core$Maybe$Just(
															{Em: $author$project$Pages$AuthorizeDevice$CopyClipboard, L: model.oi}),
														l6: 'state-init-command',
														Gv: function () {
															if (!maybeFirstOrgUrlName.$) {
																var urlName = maybeFirstOrgUrlName.a;
																return 'state init ' + (urlName + ('/my-first-' + (languageName + (' --language ' + languageName))));
															} else {
																return '';
															}
														}()
													})
												])),
											A2(
											$elm$html$Html$details,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$summary,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('What exactly does this command do?')
														])),
													A2(
													$elm$html$Html$ul,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('init-command-details')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Creates a ' + (languageDisplayName + ' project called ')),
																	A2(
																	$elm$html$Html$strong,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text('my-first-' + languageName)
																		])),
																	$elm$html$Html$text(' on the ActiveState Platform. ActiveState projects contain just the language & packages you request. Your source code stays on your machine.'),
																	function () {
																	if (!maybeFirstOrgUrlName.$) {
																		var orgUrlName = maybeFirstOrgUrlName.a;
																		return A2(
																			$elm$html$Html$p,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$elm$html$Html$text('You will be able access it at '),
																					A2(
																					$elm$html$Html$a,
																					_List_fromArray(
																						[
																							$elm$html$Html$Attributes$href('https://platform.activestate.com/' + (orgUrlName + ('/my-first-' + languageName)))
																						]),
																					_List_fromArray(
																						[
																							$elm$html$Html$text('platform.activestate.com/' + (orgUrlName + ('/my-first-' + languageName)))
																						])),
																					$elm$html$Html$text(' to view dependencies and make changes.')
																				]));
																	} else {
																		return $elm$html$Html$text('');
																	}
																}()
																])),
															A2(
															$elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Adds an '),
																	A2(
																	$elm$html$Html$strong,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text('activestate.yaml')
																		])),
																	$elm$html$Html$text(' file to directory where you ran this command. This file links your local environment to the ActiveState Platform project.')
																])),
															A2(
															$elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Downloads '),
																	$elm$html$Html$text(languageDisplayName),
																	$elm$html$Html$text(' & all required dependencies to your local machine.')
																]))
														]))
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('onboarding-step')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Step 2')
												])),
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Start using your ' + languageDisplayName)
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('snippet-wrapper')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Option 1 - System-wide')
														])),
													A2(
													$elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Use it as your system-wide ' + (languageDisplayName + '. Run ')),
															A2(
															$elm$html$Html$strong,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('state use reset')
																])),
															$elm$html$Html$text(' to unset it.')
														])),
													$author$project$Views$CliText$view(
													{
														B$: $elm$core$Maybe$Just(
															{Em: $author$project$Pages$AuthorizeDevice$CopyClipboard, L: model.oi}),
														l6: 'state-use-command',
														Gv: 'state use my-first-' + languageName
													}),
													A2(
													$elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Option 2 - Subshell')
														])),
													A2(
													$elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Use you ' + (languageDisplayName + ' in a subshell. Run ')),
															A2(
															$elm$html$Html$strong,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('exit')
																])),
															$elm$html$Html$text(' to stop.')
														])),
													$author$project$Views$CliText$view(
													{
														B$: $elm$core$Maybe$Just(
															{Em: $author$project$Pages$AuthorizeDevice$CopyClipboard, L: model.oi}),
														l6: 'state-shell-command',
														Gv: 'state shell my-first-' + languageName
													})
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('onboarding-step')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Step 3 '),
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('explanation')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(' — Optional')
														]))
												])),
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Install packages from our secure catalog')
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('snippet-wrapper')
												]),
											_List_fromArray(
												[
													$author$project$Views$CliText$view(
													{
														B$: $elm$core$Maybe$Just(
															{Em: $author$project$Pages$AuthorizeDevice$CopyClipboard, L: model.oi}),
														l6: 'state-install-command',
														Gv: 'state install ' + firstPackage
													}),
													A2(
													$author$project$Misc$displayIf,
													!$elm$core$List$isEmpty(
														A2($elm$core$List$drop, 1, popularPackages)),
													A2(
														$elm$html$Html$p,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Try installing other popular ' + (languageDisplayName + ' packages...')),
																A2(
																$elm$html$Html$ul,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('popular-package-list')
																	]),
																A2(
																	$elm$core$List$map,
																	function (p) {
																		return A2(
																			$elm$html$Html$li,
																			_List_Nil,
																			_List_fromArray(
																				[
																					A2(
																					$elm$html$Html$span,
																					_List_fromArray(
																						[
																							$elm$html$Html$Attributes$class('cli-text-inline')
																						]),
																					_List_fromArray(
																						[
																							$elm$html$Html$text(p)
																						]))
																				]));
																	},
																	A2($elm$core$List$drop, 1, popularPackages)))
															]))),
													A2(
													$author$project$Misc$displayMaybe,
													function (types) {
														return A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('import-file-types')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$p,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text('You can also import '),
																			A2(
																			$elm$html$Html$span,
																			_List_Nil,
																			A2(
																				$elm$core$List$intersperse,
																				A2(
																					$elm$html$Html$span,
																					_List_Nil,
																					_List_fromArray(
																						[
																							$elm$html$Html$text(', ')
																						])),
																				A2(
																					$elm$core$List$map,
																					function (p) {
																						return A2(
																							$elm$html$Html$span,
																							_List_fromArray(
																								[
																									$elm$html$Html$Attributes$class('cli-text-inline')
																								]),
																							_List_fromArray(
																								[
																									$elm$html$Html$text(p)
																								]));
																					},
																					$mgold$elm_nonempty_list$List$Nonempty$toList(types)))),
																			$elm$html$Html$text(' files if you\'re working with a codebase that has one — '),
																			A2(
																			$elm$html$Html$a,
																			_List_fromArray(
																				[
																					$elm$html$Html$Attributes$href('https://docs.activestate.com/platform/projects/managing_requirements/'),
																					$elm$html$Html$Attributes$target('blank')
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text('Learn how')
																				])),
																			$elm$html$Html$text('.')
																		]))
																]));
													},
													importFileTypes)
												]))
										]))
								]))
						]))
				]));
	});
var $elm$html$Html$code = _VirtualDom_node('code');
var $author$project$TimeUtils$hoursPerDay = 24;
var $author$project$TimeUtils$secsPerMin = 60;
var $author$project$TimeUtils$millisPerMin = $author$project$TimeUtils$millisPerSec * $author$project$TimeUtils$secsPerMin;
var $author$project$TimeUtils$minsPerHour = 60;
var $author$project$TimeUtils$millisPerHour = $author$project$TimeUtils$millisPerMin * $author$project$TimeUtils$minsPerHour;
var $author$project$TimeUtils$millisPerDay = $author$project$TimeUtils$millisPerHour * $author$project$TimeUtils$hoursPerDay;
var $author$project$TimeUtils$daysBetween = F2(
	function (start, end) {
		var timeDelta = $elm$core$Basics$abs(
			$elm$time$Time$posixToMillis(end) - $elm$time$Time$posixToMillis(start));
		return $elm$core$Basics$round(timeDelta / $author$project$TimeUtils$millisPerDay);
	});
var $elm$html$Html$Attributes$height = function (n) {
	return A2(
		_VirtualDom_attribute,
		'height',
		$elm$core$String$fromInt(n));
};
var $author$project$Pages$AuthorizeDevice$view = F3(
	function (model, session, maybeCurrentTime) {
		var maxUserAgeDays = 5;
		var userIsNew = function () {
			var _v4 = _Utils_Tuple2(
				maybeCurrentTime,
				$author$project$Model$Session$getUser(session));
			if ((!_v4.a.$) && (!_v4.b.$)) {
				var currentTime = _v4.a.a;
				var user = _v4.b.a;
				var userCreatedTime = A2(
					$elm$core$Result$withDefault,
					$elm$time$Time$millisToPosix(0),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(user.ak));
				var userAgeInDays = A2($author$project$TimeUtils$daysBetween, currentTime, userCreatedTime);
				return _Utils_cmp(userAgeInDays, maxUserAgeDays) < 0;
			} else {
				return false;
			}
		}();
		var layout = function (content) {
			return A2(
				$elm$html$Html$main_,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('cli-auth-content')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('title-image')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$img,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$src('/img/authorize-cli.svg'),
												$elm$html$Html$Attributes$height(250)
											]),
										_List_Nil)
									])),
								A2($elm$html$Html$div, _List_Nil, content)
							]))
					]));
		};
		var innerHtml = function () {
			var _v0 = model.pi;
			switch (_v0.$) {
				case 0:
					if (_v0.a.$ === 1) {
						var _v1 = _v0.a;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Looks like we\'re on the Authorize Device page with NO userCode!')
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Add '),
										A2(
										$elm$html$Html$code,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('user-code=foo')
											])),
										$elm$html$Html$text(' to your query string to see the real page.')
									]))
							]);
					} else {
						var userCode = _v0.a.a;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$h1,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Authorize a command line tool')
									])),
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Check that the code below matches the code in your command line terminal to be sure you\'re authorizing the correct tool. If it does, click the button below to authorize the tool to make API calls to the ActiveState platform with your account.')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('cli-wrapper')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('cli-text')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Security Code: ' + userCode)
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('primary-button'),
												$elm$html$Html$Events$onClick(
												$author$project$Pages$AuthorizeDevice$DoAuthorize(userCode))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Authorize')
											]))
									]))
							]);
					}
				case 1:
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Success, your CLI is authorized')
								])),
							A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('You can now close this window and go back to the command line to continue your work.')
								])),
							A2(
							$author$project$Misc$displayIf,
							userIsNew,
							A2($author$project$Pages$AuthorizeDevice$cliInstructions, model, session))
						]);
				default:
					var err = _v0.a;
					var unexpectedFailure = _Utils_Tuple2(
						'Authorization Failed',
						_List_fromArray(
							[
								$elm$html$Html$text('Contact '),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href('mailto:support@activestate.com'),
										$elm$html$Html$Attributes$target('_blank')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('support@activestate.com')
									])),
								$elm$html$Html$text(' for assistance.')
							]));
					var _v2 = function () {
						if (err.$ === 3) {
							var code = err.a;
							return (code === 400) ? _Utils_Tuple2(
								'Invalid User Code',
								_List_fromArray(
									[
										$elm$html$Html$text('The user code provided either doesn\'t exist or has expired.  Please close this window and start the authorization process again.')
									])) : unexpectedFailure;
						} else {
							return unexpectedFailure;
						}
					}();
					var errmsg = _v2.a;
					var details = _v2.b;
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(errmsg)
								])),
							A2($elm$html$Html$h3, _List_Nil, details),
							$elm$html$Html$text('You can now close this window')
						]);
			}
		}();
		return layout(innerHtml);
	});
var $author$project$Pages$Loading$view = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('loading-page')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src('/img/activestate-logo-white.svg'),
							$elm$html$Html$Attributes$alt('ActiveState: The Open Source Languages Company')
						]),
					_List_Nil)
				])),
			$author$project$Views$Loading$dots
		]));
var $author$project$Pages$AutoFork$view = function (_v0) {
	return $author$project$Pages$Loading$view;
};
var $author$project$Pages$CheckEmail$ResendActivationEmail = {$: 2};
var $author$project$Views$NotificationsInline$elementClass = 'notifications-inline';
var $author$project$Views$NotificationsInline$getInternal = function (model) {
	var _v0 = model.mN;
	var mnotification = _v0;
	return mnotification;
};
var $author$project$Views$NotificationsInline$view = function (model) {
	var wrapNotification = function (notification) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					$author$project$Model$Notification$type_(notification))
				]),
			$author$project$Model$Notification$view(notification));
	};
	var notifications = $elm_community$maybe_extra$Maybe$Extra$toList(
		$author$project$Views$NotificationsInline$getInternal(model));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class($author$project$Views$NotificationsInline$elementClass)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$ul,
				_List_Nil,
				A2($elm$core$List$map, wrapNotification, notifications))
			]));
};
var $author$project$Pages$CheckEmail$view = F2(
	function (session, model) {
		var email = $author$project$Pages$CheckEmail$getEmail(session);
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('check-email-page')
				]),
			_List_fromArray(
				[
					$author$project$Views$NotificationsInline$view(model),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('letter-page')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('We just sent an email to '),
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(email)
										])),
									$elm$html$Html$text('.'),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									$elm$html$Html$text('Click the link in the email to confirm your email address and finish creating your account.')
								])),
							A2(
							$elm$html$Html$h2,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Don\'t see the email?')
								])),
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Check your spam folder, maybe it got stuck in there?')
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('If not, you can '),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Events$onClick($author$project$Pages$CheckEmail$ResendActivationEmail),
													$elm$html$Html$Attributes$type_('button'),
													$elm$html$Html$Attributes$class('text-button-simple')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('request another email')
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Checkout$BillingDetails$BillingFormMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Views$BillingForm$ToggleState = {$: 1};
var $author$project$Views$BillingForm$UpdateBillingInfo = {$: 0};
var $author$project$Views$BillingForm$buttonsView = function (model) {
	var _v0 = model.jU;
	if (_v0.$ === 1) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button-wrapper')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick($author$project$Views$BillingForm$ToggleState),
							$elm$html$Html$Attributes$class('primary-button'),
							$elm$html$Html$Attributes$type_('button')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Modify')
						]))
				]));
	} else {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button-wrapper')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick($author$project$Views$BillingForm$UpdateBillingInfo),
							$elm$html$Html$Attributes$class('with-icon-centered primary-button'),
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Attributes$disabled(model.D6 || model.tD)
						]),
					_List_fromArray(
						[
							$author$project$Views$Icon$view(
							$author$project$Views$Icon$icon(74)),
							model.D6 ? $elm$html$Html$text('Processing...') : $elm$html$Html$text(model.oe)
						]))
				]));
	}
};
var $author$project$Views$BillingForm$Autofill = F3(
	function (section, shippingElseBilling, token) {
		return {z_: section, z5: shippingElseBilling, GI: token};
	});
var $author$project$Views$BillingForm$CardAddress = 2;
var $author$project$Views$BillingForm$ToggleCardAddressVisible = {$: 8};
var $author$project$Views$BillingForm$ToggleCardState = {$: 2};
var $author$project$Views$BillingForm$TokenFailed = function (a) {
	return {$: 5, a: a};
};
var $author$project$Views$BillingForm$TokenSucceeded = function (a) {
	return {$: 4, a: a};
};
var $author$project$Views$BillingForm$isCardToggleable = function (formState) {
	_v0$2:
	while (true) {
		if (formState.$ === 2) {
			switch (formState.a) {
				case 1:
					var _v1 = formState.a;
					return true;
				case 2:
					var _v2 = formState.a;
					return true;
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return false;
};
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $author$project$Views$BillingForm$addNewCardForm = function (model) {
	var address = model.iW ? model.Bs : model.xm;
	var prop = F2(
		function (key, valFn) {
			return A2(
				$elm$html$Html$Attributes$property,
				key,
				$elm$json$Json$Encode$string(
					valFn(address)));
		});
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('cc-info-edit')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Misc$displayIf,
				$author$project$Views$BillingForm$isCardToggleable(model.jU),
				A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick($author$project$Views$BillingForm$ToggleCardState),
							$elm$html$Html$Attributes$class('text-button cancel-cc-update'),
							$elm$html$Html$Attributes$type_('button')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Cancel')
						]))),
				A3(
				$elm$html$Html$node,
				'stripe-elements',
				_List_fromArray(
					[
						A2(
						prop,
						'name',
						function ($) {
							return $.w;
						}),
						A2(
						prop,
						'email',
						function ($) {
							return $.lJ;
						}),
						A2(
						prop,
						'address1',
						function ($) {
							return $.qd;
						}),
						A2(
						prop,
						'address2',
						function ($) {
							return $.sQ;
						}),
						A2(
						prop,
						'city',
						function ($) {
							return $.qB;
						}),
						A2(
						prop,
						'state',
						function ($) {
							return $.bB;
						}),
						A2(
						prop,
						'zip',
						function ($) {
							return $.sM;
						}),
						A2(
						prop,
						'country',
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.qK;
							},
							function ($) {
								return $.w;
							})),
						A2(
						$elm$html$Html$Attributes$property,
						'cardReady',
						$elm$json$Json$Encode$bool(model.iT)),
						A2(
						$elm$html$Html$Events$on,
						'tokenSucceeded',
						A2(
							$elm$json$Json$Decode$map,
							$author$project$Views$BillingForm$TokenSucceeded,
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['target', 'token', 'id']),
								$elm$json$Json$Decode$string))),
						A2(
						$elm$html$Html$Events$on,
						'tokenFailed',
						A2(
							$elm$json$Json$Decode$map,
							$author$project$Views$BillingForm$TokenFailed,
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['target', 'error', 'message']),
								$elm$json$Json$Decode$string)))
					]),
				_List_Nil)
			]));
};
var $author$project$Views$BillingForm$ProvinceFieldFailed = function (a) {
	return {$: 7, a: a};
};
var $author$project$Views$BillingForm$SetBillingInfoField = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Views$BillingForm$formLabel = F2(
	function (content, required) {
		var requiredMarker = required ? A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('required-marker')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('*')
				])) : A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('optional-marker')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('(Optional)')
				]));
		return A2(
			$elm$html$Html$label,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(content),
							requiredMarker
						]))
				]));
	});
var $author$project$Views$BillingForm$wrapError = function (error) {
	return A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('field-error')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(error)
			]));
};
var $author$project$Views$BillingForm$addressFormFieldView = F3(
	function (label, errors, elemToWrap) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'error',
							!$elm$core$List$isEmpty(errors)),
							_Utils_Tuple2('form-element', true)
						]))
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2($author$project$Views$BillingForm$formLabel, label, true),
						elemToWrap
					]),
				A2($elm$core$List$map, $author$project$Views$BillingForm$wrapError, errors)));
	});
var $author$project$Views$BillingForm$getAutofillAttrs = function (_v0) {
	var section = _v0.z_;
	var shippingElseBilling = _v0.z5;
	var token = _v0.GI;
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$Attributes$attribute,
			'autocomplete',
			A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					[
						'section-' + section,
						shippingElseBilling ? 'shipping' : 'billing',
						token
					])))
		]);
};
var $author$project$Views$Countries$view = F3(
	function (updateMsg, customAttrs, current) {
		var datalistID = 'address-country-list';
		var inputField = function () {
			var attrs = _Utils_ap(
				customAttrs,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'type', 'text'),
						A2($elm$html$Html$Attributes$attribute, 'list', datalistID),
						$elm$html$Html$Events$onInput(updateMsg)
					]));
			return A2($elm$html$Html$input, attrs, _List_Nil);
		}();
		var dataList = A2(
			$elm$html$Html$datalist,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id(datalistID)
				]),
			A2(
				$elm$core$List$map,
				function (c) {
					return A2(
						$elm$html$Html$option,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$selected(
								_Utils_eq(current, c))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(c.w)
							]));
				},
				$author$project$Model$Countries$countries));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[inputField, dataList]));
	});
var $author$project$Views$BillingForm$billingFormCountrySelector = F3(
	function (value, field, autofill) {
		var attrs = $author$project$Views$BillingForm$getAutofillAttrs(autofill);
		return A3(
			$author$project$Views$Countries$view,
			$author$project$Views$BillingForm$SetBillingInfoField(field),
			attrs,
			value);
	});
var $author$project$Views$BillingForm$getErrors = F2(
	function (errors, field) {
		return A2(
			$elm$core$List$map,
			$elm$core$Tuple$second,
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$first,
					$elm$core$Basics$eq(field)),
				errors));
	});
var $author$project$Views$BillingForm$inputFieldView = F5(
	function (inputType, maybeMaxLength, field, autofill, defaultValue) {
		var maxLengthAttrs = function () {
			if (!maybeMaxLength.$) {
				var maxLength = maybeMaxLength.a;
				return _List_fromArray(
					[
						$elm$html$Html$Attributes$maxlength(maxLength)
					]);
			} else {
				return _List_Nil;
			}
		}();
		var attrs = _List_fromArray(
			[
				$elm$html$Html$Attributes$type_(inputType),
				$elm$html$Html$Attributes$value(defaultValue),
				$elm$html$Html$Events$onInput(
				$author$project$Views$BillingForm$SetBillingInfoField(field))
			]);
		return A2(
			$elm$html$Html$input,
			_Utils_ap(
				attrs,
				_Utils_ap(
					maxLengthAttrs,
					$author$project$Views$BillingForm$getAutofillAttrs(autofill))),
			_List_Nil);
	});
var $author$project$Components$DynamicProvinceField$view = F5(
	function (prefix, countryNameAlpha2, onErrorHandler, attrs, onChangeHandler) {
		var onLoadFailHandler = A2(
			$elm$json$Json$Decode$map,
			onErrorHandler,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['error']),
				$elm$json$Json$Decode$string));
		var onChangeEventHandler = A2(
			$elm$json$Json$Decode$map,
			onChangeHandler,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['detail']),
				$elm$json$Json$Decode$string));
		var attrs_ = _Utils_ap(
			_List_fromArray(
				[
					A2($elm$html$Html$Events$on, 'provinceChanged', onChangeEventHandler),
					A2($elm$html$Html$Events$on, 'provinceLoadFailed', onLoadFailHandler),
					A2($elm$html$Html$Attributes$attribute, 'country', countryNameAlpha2),
					A2($elm$html$Html$Attributes$attribute, 'prefix', prefix)
				]),
			attrs);
		return A3($elm$html$Html$node, 'address-state-selector', attrs_, _List_Nil);
	});
var $author$project$Views$BillingForm$editAddressInfo = function (_v0) {
	var getAutofill = _v0.oF;
	var addressInfo = _v0.n_;
	var errors = _v0.yf;
	var addressType = _v0.n$;
	var fieldToForm = _v0.oA;
	var showEmailField = _v0.pM;
	var _v1 = function () {
		switch (addressType) {
			case 0:
				return _Utils_Tuple2($author$project$Views$BillingForm$BillingField, 'billing');
			case 1:
				return _Utils_Tuple2($author$project$Views$BillingForm$ShippingField, 'shipping');
			default:
				return _Utils_Tuple2($author$project$Views$BillingForm$CardField, 'credit-card');
		}
	}();
	var fieldType = _v1.a;
	var prefix = _v1.b;
	var fieldErrors = A2(
		$elm$core$Basics$composeR,
		fieldType,
		$author$project$Views$BillingForm$getErrors(errors));
	var stateField = function () {
		var attrs = $author$project$Views$BillingForm$getAutofillAttrs(
			getAutofill('address-level1'));
		return A5(
			$author$project$Components$DynamicProvinceField$view,
			prefix,
			addressInfo.qK.xc,
			$author$project$Views$BillingForm$ProvinceFieldFailed,
			attrs,
			$author$project$Views$BillingForm$SetBillingInfoField(
				fieldToForm(5)));
	}();
	var _v3 = function () {
		if (!addressType) {
			return _Utils_Tuple2(
				'Company Name',
				getAutofill('organization'));
		} else {
			return _Utils_Tuple2(
				'Name',
				getAutofill('name'));
		}
	}();
	var nameLabel = _v3.a;
	var nameAutofill = _v3.b;
	return A2(
		$elm$html$Html$form,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('multiple')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Views$BillingForm$addressFormFieldView,
						nameLabel,
						fieldErrors(0),
						A5(
							$author$project$Views$BillingForm$inputFieldView,
							'text',
							$elm$core$Maybe$Nothing,
							fieldType(0),
							nameAutofill,
							addressInfo.w)),
						A2(
						$author$project$Misc$displayIf,
						showEmailField,
						A3(
							$author$project$Views$BillingForm$addressFormFieldView,
							'Email Address',
							fieldErrors(1),
							A5(
								$author$project$Views$BillingForm$inputFieldView,
								'email',
								$elm$core$Maybe$Nothing,
								fieldType(1),
								A3($author$project$Views$BillingForm$Autofill, 'email', false, 'email'),
								addressInfo.lJ)))
					])),
				A3(
				$author$project$Views$BillingForm$addressFormFieldView,
				'Street Address',
				fieldErrors(2),
				A5(
					$author$project$Views$BillingForm$inputFieldView,
					'text',
					$elm$core$Maybe$Just(50),
					fieldType(2),
					getAutofill('address-line1'),
					addressInfo.qd)),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('multiple')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Views$BillingForm$addressFormFieldView,
						'City',
						fieldErrors(3),
						A5(
							$author$project$Views$BillingForm$inputFieldView,
							'text',
							$elm$core$Maybe$Nothing,
							fieldType(3),
							getAutofill('address-level2'),
							addressInfo.qB)),
						A3(
						$author$project$Views$BillingForm$addressFormFieldView,
						'Country',
						fieldErrors(4),
						A3(
							$author$project$Views$BillingForm$billingFormCountrySelector,
							addressInfo.qK,
							fieldType(4),
							getAutofill('country-name')))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('multiple')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Views$BillingForm$addressFormFieldView,
						'State/Province',
						fieldErrors(5),
						stateField),
						A3(
						$author$project$Views$BillingForm$addressFormFieldView,
						'ZIP/Postal Code',
						fieldErrors(6),
						A5(
							$author$project$Views$BillingForm$inputFieldView,
							'text',
							$elm$core$Maybe$Nothing,
							fieldType(6),
							getAutofill('postal-code'),
							addressInfo.sM))
					]))
			]));
};
var $author$project$Views$BillingForm$creditCardView = function (model) {
	var errors = A2($author$project$Views$BillingForm$getErrors, model.yf, $author$project$Views$BillingForm$CreditCard);
	var cardInfo = A2(
		$elm$core$Maybe$andThen,
		function ($) {
			return $.Bt;
		},
		model.qp);
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('cc-address-info')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Credit Card Details')
						])),
					function () {
					var _v0 = $author$project$Views$BillingForm$getCardReadWrite(model.jU);
					if (_v0 === 1) {
						return $author$project$Views$BillingForm$addNewCardForm(model);
					} else {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('cc-info-view')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('card-number')
										]),
									function () {
										if (!cardInfo.$) {
											var card = cardInfo.a;
											return _List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Credit card ending in ' + card.yX)
														])),
													A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Expires: ' + (card.Cw + ('/' + card.Cx)))
														]))
												]);
										} else {
											return _List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('no-info')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('No credit card currently on file.')
														]))
												]);
										}
									}()),
									A2(
									$author$project$Misc$displayIf,
									$author$project$Views$BillingForm$isCardToggleable(model.jU),
									A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Events$onClick($author$project$Views$BillingForm$ToggleCardState),
												$elm$html$Html$Attributes$class('secondary-button small'),
												$elm$html$Html$Attributes$type_('button')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Update Card')
											])))
								]));
					}
				}(),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					A2($elm$core$List$map, $author$project$Views$BillingForm$wrapError, errors)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('credit-card-details')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Events$onInput(
											$elm$core$Basics$always($author$project$Views$BillingForm$ToggleCardAddressVisible)),
											$elm$html$Html$Attributes$type_('checkbox'),
											$elm$html$Html$Attributes$checked(!model.iW)
										]),
									_List_Nil),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(' Credit card address is the same as billing address')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('form-fields')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Misc$displayIf,
									model.iW,
									$author$project$Views$BillingForm$editAddressInfo(
										{
											n_: model.Bs,
											n$: 2,
											yf: model.yf,
											oA: $author$project$Views$BillingForm$CardField,
											oF: A2($author$project$Views$BillingForm$Autofill, 'credit-card', false),
											pM: false
										}))
								]))
						]))
				]))
		]);
};
var $author$project$Views$Card$Highlighted = 0;
var $author$project$Views$Card$Lean = 1;
var $elm$html$Html$b = _VirtualDom_node('b');
var $author$project$Model$Tier$billingPeriodToString = function (period) {
	if (!period) {
		return '/month';
	} else {
		return '/year';
	}
};
var $elm_community$string_extra$String$Extra$breaker = F3(
	function (width, string, acc) {
		breaker:
		while (true) {
			if (string === '') {
				return $elm$core$List$reverse(acc);
			} else {
				var $temp$width = width,
					$temp$string = A2($elm$core$String$dropLeft, width, string),
					$temp$acc = A2(
					$elm$core$List$cons,
					A3($elm$core$String$slice, 0, width, string),
					acc);
				width = $temp$width;
				string = $temp$string;
				acc = $temp$acc;
				continue breaker;
			}
		}
	});
var $elm_community$string_extra$String$Extra$break = F2(
	function (width, string) {
		return ((!width) || (string === '')) ? _List_fromArray(
			[string]) : A3($elm_community$string_extra$String$Extra$breaker, width, string, _List_Nil);
	});
var $elm$core$String$reverse = _String_reverse;
var $author$project$Misc$priceToString = function (priceDollars) {
	var priceCents = $elm$core$Basics$round(100 * priceDollars);
	var dollarsStr = $elm$core$String$reverse(
		A2(
			$elm$core$String$join,
			',',
			A2(
				$elm_community$string_extra$String$Extra$break,
				3,
				$elm$core$String$reverse(
					$elm$core$String$fromInt(
						A3($elm_community$basics_extra$Basics$Extra$flip, $elm$core$Basics$idiv, 100, priceCents))))));
	var centsStr = A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(
			A2($elm$core$Basics$modBy, 100, priceCents)));
	return dollarsStr + ('.' + centsStr);
};
var $author$project$Pages$Checkout$BillingDetails$subscriptionCostView = F3(
	function (taxes, runtimes, tier) {
		var calculatedTax = function () {
			if (taxes.$ === 2) {
				var tax = taxes.a;
				return tax;
			} else {
				return 0;
			}
		}();
		var _v0 = A3(
			$author$project$Model$Tier$costWithTaxes,
			$author$project$Model$Runtimes$runtimesInt(runtimes),
			calculatedTax,
			tier);
		var subtotal = _v0.a;
		var taxTotal = _v0.b;
		var total = subtotal + taxTotal;
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('subscription-pricing')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pricing-item')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pricing-item-label')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Subscription')
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pricing-item-value')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$b,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											'$' + $author$project$Misc$priceToString(subtotal))
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pricing-item-recurrence')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Model$Tier$billingPeriodToString(
												$author$project$Model$Tier$billingPeriod(tier)))
										]))
								]))
						])),
					A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pricing-item')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pricing-item-label')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Taxes')
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pricing-item-value')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									function () {
										if (taxes.$ === 2) {
											return '$' + $author$project$Misc$priceToString(taxTotal);
										} else {
											return '--';
										}
									}())
								]))
						])),
					A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pricing-item')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pricing-item-label')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$b,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Total')
										]))
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pricing-item-value')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$b,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											'$' + $author$project$Misc$priceToString(total))
										]))
								]))
						]))
				]));
	});
var $author$project$Views$Card$withHeader = F3(
	function (attrs, content, card) {
		return _Utils_update(
			card,
			{
				q6: $elm$core$Maybe$Just(
					A2($elm$html$Html$header, attrs, content))
			});
	});
var $author$project$Views$Card$withModifiers = F2(
	function (modifiers, card) {
		return _Utils_update(
			card,
			{uG: modifiers});
	});
var $author$project$Pages$Checkout$BillingDetails$formCard = F2(
	function (_v0, billingModel) {
		var isTrial = _v0.up;
		var taxes = _v0.gP;
		var tier = _v0.dc;
		var runtimes = _v0.v2;
		var formView = _v0.tT;
		var creditCardFormView = _v0.tt;
		var confirmButtonView = _v0.to;
		return $author$project$Views$Card$asHtmlCard(
			A2(
				$author$project$Views$Card$withContent,
				$elm$core$List$concat(
					_List_fromArray(
						[
							formView(billingModel),
							creditCardFormView(billingModel)
						])),
				A3(
					$author$project$Views$Card$withFooter,
					_List_Nil,
					_List_fromArray(
						[
							A3($author$project$Pages$Checkout$BillingDetails$subscriptionCostView, taxes, runtimes, tier),
							confirmButtonView(billingModel),
							A2(
							$author$project$Misc$displayIf,
							isTrial,
							A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('fine-line')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('You can cancel your subscription anytime before the 14-day trial ends to avoid any charges. We\'ll only charge your credit card after the trial period is over, and then on a monthly basis until you decide to cancel.')
									])))
						]),
					A3(
						$author$project$Views$Card$withHeader,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h2,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Billing Information')
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('required-legend')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('* Required fields')
									]))
							]),
						A2(
							$author$project$Views$Card$withModifiers,
							_List_fromArray(
								[1, 0]),
							A2(
								$author$project$Views$Card$withAttributes,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id('billing-shipping-details')
									]),
								$author$project$Views$Card$newCard))))));
	});
var $author$project$Views$BillingForm$BillingAddress = 0;
var $author$project$Views$BillingForm$ShippingAddress = 1;
var $author$project$Views$BillingForm$ToggleShippingAddressVisible = {$: 6};
var $author$project$Views$BillingForm$editBillingInfo = function (model) {
	return A2(
		$elm$html$Html$form,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-fields')
							]),
						_List_fromArray(
							[
								$author$project$Views$BillingForm$editAddressInfo(
								{
									n_: model.xm,
									n$: 0,
									yf: model.yf,
									oA: $author$project$Views$BillingForm$BillingField,
									oF: A2($author$project$Views$BillingForm$Autofill, 'billing', false),
									pM: true
								})
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('shipping-details')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										$elm$core$Basics$always($author$project$Views$BillingForm$ToggleShippingAddressVisible)),
										$elm$html$Html$Attributes$type_('checkbox'),
										$elm$html$Html$Attributes$checked(!model.io)
									]),
								_List_Nil),
								$elm$html$Html$text('Shipping address is the same as billing address')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-fields')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Misc$displayIf,
								model.io,
								$author$project$Views$BillingForm$editAddressInfo(
									{
										n_: model.z4,
										n$: 1,
										yf: model.yf,
										oA: $author$project$Views$BillingForm$ShippingField,
										oF: A2($author$project$Views$BillingForm$Autofill, 'shipping', true),
										pM: false
									}))
							]))
					]))
			]));
};
var $author$project$Views$BillingForm$getReadWrite = function (formState) {
	switch (formState.$) {
		case 1:
			return 0;
		case 0:
			return 1;
		default:
			return 1;
	}
};
var $author$project$Views$Columns$elementsInColumns = function (columns) {
	return $author$project$Views$Columns$asHtml(
		A2(
			$author$project$Views$Columns$withColumns,
			columns,
			A5(
				$author$project$Views$Columns$Columns,
				$elm$core$Maybe$Just($elm$html$Html$ul),
				_List_Nil,
				$elm$core$Maybe$Just($elm$html$Html$li),
				_List_Nil,
				_List_Nil)));
};
var $author$project$Views$BillingForm$isStripeCustomer = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$andThen(
		function ($) {
			return $.DH;
		}),
	$elm$core$Maybe$withDefault(false));
var $elm$html$Html$address = _VirtualDom_node('address');
var $author$project$Views$BillingForm$viewAddressInfo = function (addressInfo) {
	var lineBreak = A2($elm$html$Html$br, _List_Nil, _List_Nil);
	var cityState = F2(
		function (city, state) {
			var _v0 = _Utils_Tuple2(
				$elm$core$String$isEmpty(city),
				$elm$core$String$isEmpty(state));
			if ((!_v0.a) && (!_v0.b)) {
				return city + (', ' + state);
			} else {
				return _Utils_ap(city, state);
			}
		});
	var fields = _List_fromArray(
		[
			addressInfo.w,
			addressInfo.qd,
			addressInfo.sQ,
			A2(cityState, addressInfo.qB, addressInfo.bB),
			addressInfo.sM,
			addressInfo.qK.w
		]);
	return A2(
		$elm$html$Html$address,
		_List_Nil,
		A2(
			$elm$core$List$intersperse,
			lineBreak,
			A2(
				$elm$core$List$map,
				$elm$html$Html$text,
				A2(
					$elm$core$List$filter,
					A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
					fields))));
};
var $author$project$Views$BillingForm$viewBillingInfo = function (model) {
	var twoColumnLayout = F2(
		function (column1, column2) {
			return $author$project$Views$Columns$elementsInColumns(
				_List_fromArray(
					[column1, column2]));
		});
	var stripeCustomer = $author$project$Views$BillingForm$isStripeCustomer(model.qp);
	var noShippingAddress = A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('no-info')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('No shipping address currently on file.')
			]));
	var noEmail = A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('no-info')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('No contact email currently on file.')
			]));
	var viewEmailAddress = function (email) {
		return $elm$core$String$isEmpty(email) ? noEmail : A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href('mailto:' + email),
					$elm$html$Html$Attributes$target('_blank')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(email)
				]));
	};
	var emailHeader = stripeCustomer ? A2(
		$elm$html$Html$h4,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Contact Email')
			])) : A2(
		$elm$html$Html$h4,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Contact Details')
			]));
	var billingHeader = A2(
		$elm$html$Html$h4,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Shipping Address')
			]));
	var _v0 = model.qp;
	if (_v0.$ === 1) {
		return A2(
			twoColumnLayout,
			_List_fromArray(
				[billingHeader, noShippingAddress]),
			_List_fromArray(
				[emailHeader, noEmail]));
	} else {
		var info = _v0.a;
		var billingName = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.w;
				},
				info.xm));
		return A2(
			twoColumnLayout,
			_List_fromArray(
				[
					billingHeader,
					A2(
					$author$project$Misc$displayIf,
					stripeCustomer,
					$elm$html$Html$text(billingName)),
					A2(
					$elm$core$Maybe$withDefault,
					noShippingAddress,
					A2($elm$core$Maybe$map, $author$project$Views$BillingForm$viewAddressInfo, info.xm))
				]),
			_List_fromArray(
				[
					emailHeader,
					A2(
					$author$project$Misc$displayIf,
					!stripeCustomer,
					A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('billing-name')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(billingName)
							]))),
					viewEmailAddress(info.lJ)
				]));
	}
};
var $author$project$Views$BillingForm$infoView = function (model) {
	var _v0 = $author$project$Views$BillingForm$getReadWrite(model.jU);
	if (!_v0) {
		return _List_fromArray(
			[
				$author$project$Views$BillingForm$viewBillingInfo(model)
			]);
	} else {
		return _List_fromArray(
			[
				$author$project$Views$BillingForm$editBillingInfo(model)
			]);
	}
};
var $author$project$Pages$Checkout$BillingDetails$ModifyRuntimeCount = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Checkout$BillingDetails$ToggleExplanation = {$: 1};
var $author$project$Pages$Checkout$BillingDetails$explanationButton = function (displayedExplanation) {
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('extra-info-toggle'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('expanded', displayedExplanation),
						_Utils_Tuple2('for-runtime-explanation', true)
					])),
				$elm$html$Html$Events$onClick($author$project$Pages$Checkout$BillingDetails$ToggleExplanation)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('?')
			]));
};
var $author$project$Pages$Checkout$BillingDetails$onChange = function (message) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, message, $elm$html$Html$Events$targetValue));
};
var $author$project$Pages$Checkout$BillingDetails$orgSubscriptionPlanSizeCard = F2(
	function (model, tierInfo) {
		var tierName = $author$project$Model$Tier$description(tierInfo.dc);
		var stepRuntimes = $elm$core$String$fromInt($author$project$Model$Runtimes$stepRuntimes);
		var runtimeCount = A2($elm$core$Basics$composeR, $author$project$Model$Runtimes$runtimesInt, $elm$core$String$fromInt)(model.iH);
		var perStepRuntimeCost = $author$project$Misc$priceToString(tierInfo.zI * $author$project$Model$Runtimes$stepRuntimes);
		var modifyRuntimeCount = A2(
			$elm$core$Basics$composeR,
			$elm$json$Json$Decode$decodeString($elm$json$Json$Decode$int),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Result$withDefault($author$project$Model$Runtimes$minRuntimes),
				$author$project$Pages$Checkout$BillingDetails$ModifyRuntimeCount));
		var minimumRuntimes = $elm$core$String$fromInt(tierInfo.yC);
		var maximumRuntimes = $elm$core$String$fromInt($author$project$Model$Runtimes$maxRuntimes);
		return $author$project$Views$Card$asHtmlCard(
			A2(
				$author$project$Views$Card$withContent,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('runtime-count-selector')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('runtime-count-label')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Runtimes')
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('runtime-count-value')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(runtimeCount)
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('range'),
										$elm$html$Html$Attributes$min(minimumRuntimes),
										$elm$html$Html$Attributes$max(maximumRuntimes),
										$elm$html$Html$Attributes$step(stepRuntimes),
										$elm$html$Html$Attributes$value(runtimeCount),
										$elm$html$Html$Events$onInput(modifyRuntimeCount),
										$author$project$Pages$Checkout$BillingDetails$onChange(modifyRuntimeCount)
									]),
								_List_Nil),
								$author$project$Pages$Checkout$BillingDetails$explanationButton(model.lH)
							])),
						A2(
						$author$project$Misc$displayIf,
						model.lH,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('extra-info')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('A runtime is the built collection of artifact(s) that you download and install to your workstation. ' + 'It is the environment in which a program or script can be executed.')
								]))),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('tier-detail-meta')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(tierName + (' includes ' + (minimumRuntimes + (' runtimes. Blocks of ' + (stepRuntimes + (' additional runtimes are available for $' + (perStepRuntimeCost + ' (USD) per year.')))))))
							]))
					]),
				A2($author$project$Views$Card$withH2HeaderText, 'Plan Size', $author$project$Views$Card$newCard)));
	});
var $author$project$Pages$Checkout$BillingDetails$showSuperUserWarning = function (session) {
	return ($author$project$Model$Session$isSuperUser(session) || $author$project$Model$Session$isImpersonating(session)) && $author$project$Model$Session$getSuperUserFeaturesVisible(session);
};
var $author$project$Views$Icon$coloredNoFill = $author$project$Views$Icon$colored(
	$author$project$Style$color('no-fill'));
var $author$project$Model$UpgradeBenefit$fromTier = function (tier) {
	switch (tier.$) {
		case 0:
			return _List_fromArray(
				[
					{
					bP: '',
					cV: $author$project$Views$Icon$icon(67),
					Gy: 'Recommended Language Versions'
				},
					{
					bP: '',
					cV: $author$project$Views$Icon$icon(67),
					Gy: 'Community Support'
				}
				]);
		case 2:
			return _List_fromArray(
				[
					{
					bP: 'Add members to your organization & manage projects together',
					cV: $author$project$Views$Icon$icon(15),
					Gy: 'Team-based Collaboration'
				},
					{
					bP: 'Access our additional version catalogue',
					cV: $author$project$Views$Icon$icon(67),
					Gy: 'Extended Language Versions'
				},
					{
					bP: 'Keep your runtimes secure & your packages top secret',
					cV: $author$project$Views$Icon$icon(46),
					Gy: 'Private Projects'
				},
					{
					bP: 'Deploy a single runtime across a variety of operating systems',
					cV: $author$project$Views$Icon$icon(54),
					Gy: 'Multi-OS Projects'
				},
					{
					bP: 'Receive vulnerability reports about your project\'s vulnerabilities',
					cV: $author$project$Views$Icon$coloredNoFill(
						$author$project$Views$Icon$icon(83)),
					Gy: 'Vulnerability Reports'
				},
					{
					bP: 'Create runtimes with variations for development and testing',
					cV: $author$project$Views$Icon$icon(4),
					Gy: 'Branches'
				}
				]);
		case 3:
			return _List_fromArray(
				[
					{
					bP: 'Set permissions for who in your team gets to modify things',
					cV: $author$project$Views$Icon$icon(63),
					Gy: 'Role-based Access Control'
				},
					{
					bP: 'Access our additional version catalogue',
					cV: $author$project$Views$Icon$icon(67),
					Gy: 'Extended Language Versions'
				},
					{
					bP: 'Receive vulnerability reports for projects across your organization',
					cV: $author$project$Views$Icon$coloredNoFill(
						$author$project$Views$Icon$icon(83)),
					Gy: 'Vulnerability Reports'
				},
					{
					bP: 'Install and use additional runtimes in your projects and organizations',
					cV: $author$project$Views$Icon$icon(4),
					Gy: 'Additional Runtimes'
				},
					{
					bP: 'Gain access to older versions of our classic installers',
					cV: $author$project$Views$Icon$coloredNoFill(
						$author$project$Views$Icon$icon(36)),
					Gy: 'Install Options'
				},
					{
					bP: 'Email and chat support from our technical support team',
					cV: $author$project$Views$Icon$coloredNoFill(
						$author$project$Views$Icon$icon(78)),
					Gy: 'Increased Support'
				}
				]);
		default:
			return _List_Nil;
	}
};
var $author$project$Model$UpgradeBenefit$fromTierWithPricing = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.dc;
	},
	A2(
		$elm$core$Basics$composeR,
		$author$project$Model$Tier$name,
		A2($elm$core$Basics$composeR, $author$project$Model$Tier$stringToSimpleTier, $author$project$Model$UpgradeBenefit$fromTier)));
var $author$project$Model$Runtimes$toDisplayString = function (runtimes) {
	return $elm$core$String$fromInt(
		$author$project$Model$Runtimes$runtimesInt(runtimes)) + ' Runtimes';
};
var $author$project$Pages$Checkout$BillingDetails$benefitsView = F2(
	function (runtimes, tier) {
		return A2(
			$elm$html$Html$ul,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Model$Runtimes$toDisplayString(runtimes))
						])),
				A2(
					$elm$core$List$map,
					function (benefit) {
						return A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(benefit.Gy)
								]));
					},
					$author$project$Model$UpgradeBenefit$fromTierWithPricing(tier))));
	});
var $elm$html$Html$hr = _VirtualDom_node('hr');
var $author$project$Pages$Checkout$BillingDetails$sideInfoView = F3(
	function (isTrial, runtimes, tier) {
		var cancellationInfo = A2(
			$elm$html$Html$section,
			_List_Nil,
			_List_fromArray(
				[
					A2($elm$html$Html$hr, _List_Nil, _List_Nil),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Cancel at anytime')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('We\'ll need to collect your billing information to start your trial, but you will not be charged until the trial period is over. You can cancel your trial at any time to avoid the charge.')
						]))
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('side-info-view')
				]),
			_List_fromArray(
				[
					$author$project$Views$Icon$view(
					$author$project$Views$Icon$coloredNoFill(
						A2(
							$author$project$Views$Icon$square,
							375,
							$author$project$Views$Icon$icon(66)))),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Ideal for individuals and small teams to get started. Customize, secure, and collaborate.')
						])),
					A2($author$project$Pages$Checkout$BillingDetails$benefitsView, runtimes, tier),
					A2($author$project$Misc$displayIf, isTrial, cancellationInfo)
				]));
	});
var $author$project$Pages$Checkout$BillingDetails$superUserWarning = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('superuser-only'),
			$elm$html$Html$Attributes$class('superuser-warning')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Warning: Superusers™ like you should NOT handle customer card details here!')
		]));
var $author$project$Pages$Checkout$BillingDetails$view = F3(
	function (session, _v0, model) {
		var tierInfo = _v0.sC;
		var isTrial = _v0.up;
		var displayPlanSize = (!isTrial) && (!A3(
			$elm$core$Basics$composeR,
			$author$project$Model$Tier$name,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Model$Tier$stringToSimpleTier,
				$elm$core$Basics$eq($author$project$Model$Tier$Pro)),
			tierInfo.dc));
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('billing-flow')
				]),
			_List_fromArray(
				[
					$author$project$Views$NotificationsInline$view(model),
					A2(
					$author$project$Misc$displayIf,
					$author$project$Pages$Checkout$BillingDetails$showSuperUserWarning(session),
					$author$project$Pages$Checkout$BillingDetails$superUserWarning),
					$author$project$Views$Columns$asHtml(
					A2(
						$author$project$Views$Columns$withColumn,
						_List_fromArray(
							[
								A2(
								$author$project$Misc$displayIf,
								displayPlanSize,
								A2($author$project$Pages$Checkout$BillingDetails$orgSubscriptionPlanSizeCard, model, tierInfo)),
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Checkout$BillingDetails$BillingFormMsg,
								A2(
									$author$project$Pages$Checkout$BillingDetails$formCard,
									{to: $author$project$Views$BillingForm$buttonsView, tt: $author$project$Views$BillingForm$creditCardView, tT: $author$project$Views$BillingForm$infoView, up: isTrial, v2: model.iH, gP: model.gP, dc: tierInfo},
									model.jT))
							]),
						A2(
							$author$project$Views$Columns$withColumnAttrs,
							_List_Nil,
							A2(
								$author$project$Views$Columns$withColumn,
								_List_fromArray(
									[
										A3($author$project$Pages$Checkout$BillingDetails$sideInfoView, isTrial, model.iH, tierInfo)
									]),
								A2(
									$author$project$Views$Columns$withColumnAttrs,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('side-info')
										]),
									A2(
										$author$project$Views$Columns$withAttrs,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('billing-layout')
											]),
										$author$project$Views$Columns$newColumns))))))
				]));
	});
var $author$project$Pages$Checkout$SpecifyOrg$ProceedToBillingDetails = {$: 6};
var $author$project$Pages$Checkout$SpecifyOrg$OnOrgUrlName = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Checkout$SpecifyOrg$ToggleCreateOrganization = {$: 3};
var $author$project$Pages$Checkout$SpecifyOrg$orgCreationView = F2(
	function (_v0, state) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('org-creation-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('org-creation-form')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('text'),
									$elm$html$Html$Events$onInput($author$project$Pages$Checkout$SpecifyOrg$OnOrgUrlName),
									$elm$html$Html$Attributes$autofocus(true),
									$elm$html$Html$Attributes$id($author$project$Pages$Checkout$SpecifyOrg$orgCreationInputId)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('cancel-button'),
									$elm$html$Html$Events$onClick($author$project$Pages$Checkout$SpecifyOrg$ToggleCreateOrganization)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								]))
						])),
					A2(
					$author$project$Misc$displayMaybe,
					function (err) {
						return A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('org-creation-error')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(err)
								]));
					},
					state.p2)
				]));
	});
var $author$project$Views$Select$Option = function (a) {
	return {$: 0, a: a};
};
var $author$project$Views$Select$Section = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Checkout$SpecifyOrg$SelectOrg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Views$Select$Separator = {$: 2};
var $author$project$Pages$Checkout$SpecifyOrg$ToggleOrgDropdown = function (a) {
	return {$: 4, a: a};
};
var $avh4$elm_color$Color$grey = A4($avh4$elm_color$Color$RgbaSpace, 211 / 255, 215 / 255, 207 / 255, 1.0);
var $author$project$Views$Select$elementValueIs = F2(
	function (value, element) {
		if (!element.$) {
			var config = element.a;
			return _Utils_eq(config.kH, value);
		} else {
			return false;
		}
	});
var $author$project$Misc$attributeMaybe = function (fn) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(fn),
		$elm$core$Maybe$withDefault(
			$elm$html$Html$Attributes$class('')));
};
var $author$project$Views$Select$toAriaBool = A2($elm$core$Basics$composeR, $Chadtech$elm_bool_extra$Bool$Extra$toString, $elm$core$String$toLower);
var $author$project$Views$Select$selectOptionView = F2(
	function (selectConfig, config) {
		var iconElement = function () {
			var _v0 = config.cV;
			if (!_v0.$) {
				var icon = _v0.a;
				return $author$project$Views$Icon$view(
					$author$project$Views$Icon$small(icon));
			} else {
				return $elm$html$Html$text('');
			}
		}();
		var dynamicAttributes = config.Cp ? _List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				selectConfig.EI(
					$elm$core$Maybe$Just(config.kH)))
			]) : _List_fromArray(
			[
				$elm$html$Html$Attributes$class('disabled')
			]);
		var badges = A2($elm$core$List$map, $author$project$Views$Badge$view, config.xk);
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('combo-option'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'with-icon',
								$elm_community$maybe_extra$Maybe$Extra$isJust(config.cV))
							])),
						A2($author$project$Misc$attributeMaybe, $elm$html$Html$Attributes$class, config.BD),
						A2($elm$html$Html$Attributes$attribute, 'role', 'option'),
						A2($elm$html$Html$Attributes$attribute, 'aria-selected', 'false'),
						A2(
						$elm$html$Html$Attributes$attribute,
						'aria-disabled',
						$author$project$Views$Select$toAriaBool(!config.Cp))
					]),
				dynamicAttributes),
			_Utils_ap(
				_List_fromArray(
					[
						iconElement,
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(config.Gv)
							]))
					]),
				badges));
	});
var $author$project$Views$Select$elementView = F2(
	function (selectConfig, element) {
		switch (element.$) {
			case 0:
				var config = element.a;
				return A2($author$project$Views$Select$selectOptionView, selectConfig, config);
			case 1:
				var config = element.a;
				return A2($author$project$Views$Select$optionSectionView, selectConfig, config);
			default:
				return A2(
					$elm$html$Html$hr,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('combo-separator')
						]),
					_List_Nil);
		}
	});
var $author$project$Views$Select$optionSectionView = F2(
	function (selectConfig, _v0) {
		var title = _v0.Gy;
		var elements = _v0.N;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('option-section')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('option-section-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						])),
				A2(
					$elm$core$List$map,
					$author$project$Views$Select$elementView(selectConfig),
					elements)));
	});
var $author$project$Views$Select$mapOption = F2(
	function (f, element) {
		if (!element.$) {
			var config = element.a;
			return $elm$core$Maybe$Just(
				f(config));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $author$project$Views$Select$view = function (config) {
	var selectedElement = function () {
		var _v0 = config.kH;
		if (!_v0.$) {
			var value = _v0.a;
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeR, $elm$html$Html$text, $elm$core$List$singleton),
					A2(
						$elm$core$Maybe$andThen,
						$author$project$Views$Select$mapOption(
							function ($) {
								return $.Gv;
							}),
						A2(
							$elm_community$list_extra$List$Extra$find,
							$author$project$Views$Select$elementValueIs(value),
							config.N))));
		} else {
			return _List_Nil;
		}
	}();
	var backdrop = A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('backdrop'),
				A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'false'),
				$elm$html$Html$Events$onClick(
				config.EP(false))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Close')
			]));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('selector')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('combo-input'),
						$elm$html$Html$Attributes$tabindex(0),
						$elm$html$Html$Events$onClick(
						config.EP(!config.ET)),
						A2($elm$html$Html$Attributes$attribute, 'role', 'combobox'),
						A2($elm$html$Html$Attributes$attribute, 'aria-activedescendant', ''),
						A2($elm$html$Html$Attributes$attribute, 'aria-autocomplete', 'none'),
						A2($elm$html$Html$Attributes$attribute, 'aria-owns', 'listbox'),
						A2(
						$elm$html$Html$Attributes$attribute,
						'aria-expanded',
						$author$project$Views$Select$toAriaBool(config.ET)),
						A2($elm$html$Html$Attributes$attribute, 'aria-haspopup', 'listbox')
					]),
				selectedElement),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('combo-menu', true),
								_Utils_Tuple2('open', config.ET)
							])),
						A2($elm$html$Html$Attributes$attribute, 'role', 'listbox')
					]),
				A2(
					$elm$core$List$cons,
					A2($author$project$Misc$displayIf, config.ET, backdrop),
					A2(
						$elm$core$List$map,
						$author$project$Views$Select$elementView(config),
						config.N)))
			]));
};
var $author$project$Pages$Checkout$SpecifyOrg$orgSelectorView = F4(
	function (maybeUser, isTrial, orgs, _v0) {
		var selectorOpen = _v0.nt;
		var selectedOrg = _v0.FV;
		var orgToOption = F2(
			function (eligible, org) {
				return $author$project$Views$Select$Option(
					{
						xk: (!eligible) ? _List_fromArray(
							[
								{
								dH: $author$project$Model$Tier$tierNameAsSimpleTierString(org.dc),
								cV: $elm$core$Maybe$Nothing
							}
							]) : _List_Nil,
						BD: $elm$core$Maybe$Nothing,
						Cp: eligible,
						cV: (!eligible) ? $elm$core$Maybe$Just(
							A2(
								$author$project$Views$Icon$colored,
								$avh4$elm_color$Color$grey,
								$author$project$Views$Icon$icon(28))) : $elm$core$Maybe$Nothing,
						Gv: $author$project$Model$Organization$getUrlName(org),
						kH: $author$project$Model$Organization$getUrlName(org)
					});
			});
		var onSelectChange = function (value) {
			if (!value.$) {
				if (value.a === '#create') {
					return $author$project$Pages$Checkout$SpecifyOrg$ToggleCreateOrganization;
				} else {
					var urlName = value.a;
					return A2(
						$elm$core$Maybe$withDefault,
						$author$project$Pages$Checkout$SpecifyOrg$NoOp,
						A2(
							$elm$core$Maybe$map,
							$author$project$Pages$Checkout$SpecifyOrg$SelectOrg,
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (org) {
									return _Utils_eq(
										$author$project$Model$Organization$getUrlName(org),
										urlName);
								},
								orgs)));
				}
			} else {
				return $author$project$Pages$Checkout$SpecifyOrg$NoOp;
			}
		};
		var elementViews = function (_v2) {
			var eligible = _v2.a;
			var notEligible = _v2.b;
			return $elm$core$List$concat(
				A2(
					$elm$core$List$cons,
					eligible,
					($elm$core$List$length(notEligible) > 0) ? _List_fromArray(
						[
							_List_fromArray(
							[
								$author$project$Views$Select$Separator,
								$author$project$Views$Select$Section(
								{N: notEligible, Gy: 'Already on a paid tier. Contact support to upgrade.'})
							])
						]) : _List_Nil));
		};
		var elements = elementViews(
			A3(
				$elm$core$List$foldr,
				F2(
					function (org, _v1) {
						var eligible = _v1.a;
						var notEligible = _v1.b;
						return (A2($author$project$Model$Permissions$canUpgradeOrg, org.AC, maybeUser) && A2($author$project$Model$Organization$isEligibleForUpgrade, isTrial, org)) ? _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								A2(orgToOption, true, org),
								eligible),
							notEligible) : _Utils_Tuple2(
							eligible,
							A2(
								$elm$core$List$cons,
								A2(orgToOption, false, org),
								notEligible));
					}),
				_Utils_Tuple2(
					_List_fromArray(
						[
							$author$project$Views$Select$Option(
							{
								xk: _List_Nil,
								BD: $elm$core$Maybe$Just('new-org-option'),
								Cp: true,
								cV: $elm$core$Maybe$Just(
									$author$project$Views$Icon$icon(61)),
								Gv: 'Create a new organization',
								kH: '#create'
							})
						]),
					_List_Nil),
				orgs));
		return $author$project$Views$Select$view(
			{
				N: elements,
				EI: onSelectChange,
				EP: $author$project$Pages$Checkout$SpecifyOrg$ToggleOrgDropdown,
				ET: selectorOpen,
				kH: A2($elm$core$Maybe$map, $author$project$Model$Organization$getUrlName, selectedOrg)
			});
	});
var $author$project$Model$Tier$roundedMonthlyCost = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.wF;
	},
	A2(
		$elm$core$Basics$composeR,
		function (yearlyPrice) {
			return yearlyPrice / 12;
		},
		$elm$core$Basics$ceiling));
var $author$project$Pages$Checkout$SpecifyOrg$showSuperUserWarning = function (session) {
	return ($author$project$Model$Session$isSuperUser(session) || $author$project$Model$Session$isImpersonating(session)) && $author$project$Model$Session$getSuperUserFeaturesVisible(session);
};
var $author$project$Pages$Checkout$SpecifyOrg$superUserWarning = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('superuser-only'),
			$elm$html$Html$Attributes$class('superuser-warning')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Warning: Superusers™ like you should NOT handle customer card details here!')
		]));
var $author$project$Views$Icon$large = $author$project$Views$Icon$setSize($author$project$Views$Icon$Large);
var $author$project$Pages$Checkout$SpecifyOrg$upgradeBenefitsView = function (benefits) {
	var benefitView = function (_v0) {
		var title = _v0.Gy;
		var description = _v0.bP;
		var icon = _v0.cV;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('upgrade-benefit')
				]),
			_List_fromArray(
				[
					$author$project$Views$Icon$view(
					$author$project$Views$Icon$large(icon)),
					A2(
					$elm$html$Html$h3,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('upgrade-benefit-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('upgrade-benefit-description')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(description)
						]))
				]));
	};
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('upgrade-benefits-container')
			]),
		A2($elm$core$List$map, benefitView, benefits));
};
var $author$project$Pages$Checkout$SpecifyOrg$view = F3(
	function (session, parentModel, specifyOrgModel) {
		var tierName = $author$project$Model$Tier$tierNameAsSimpleTierString(
			$author$project$Model$Tier$name(parentModel.sC.dc));
		var maybeUser = $author$project$Model$Session$getUser(session);
		var includeAnnualText = function () {
			var _v1 = $author$project$Model$Tier$billingPeriod(parentModel.sC);
			if (_v1 === 1) {
				return true;
			} else {
				return false;
			}
		}();
		var content = function () {
			var _v0 = specifyOrgModel.gZ;
			if (_v0.$ === 1) {
				var selectionState = _v0.a;
				return A4($author$project$Pages$Checkout$SpecifyOrg$orgSelectorView, maybeUser, parentModel.up, specifyOrgModel.rJ, selectionState);
			} else {
				var creationState = _v0.a;
				return A2($author$project$Pages$Checkout$SpecifyOrg$orgCreationView, specifyOrgModel.rJ, creationState);
			}
		}();
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('billing-flow')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Misc$displayIf,
					$author$project$Pages$Checkout$SpecifyOrg$showSuperUserWarning(session),
					$author$project$Pages$Checkout$SpecifyOrg$superUserWarning),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('org-selector-ui')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Unlock the benefits of a ' + (tierName + ' Subscription'))
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Select or Create an organization to upgrade to a ' + (tierName + ' Subscription'))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('org-selector')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$b,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('platform-url')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('platform.activestate.com/')
										])),
									content
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('primary-button'),
									$elm$html$Html$Events$onClick($author$project$Pages$Checkout$SpecifyOrg$ProceedToBillingDetails)
								]),
							parentModel.up ? _List_fromArray(
								[
									$author$project$Views$Icon$view(
									$author$project$Views$Icon$icon(74)),
									$elm$html$Html$text('Start 14-day Free Trial')
								]) : _List_fromArray(
								[
									$elm$html$Html$text('Continue to Checkout')
								])),
							A2($elm$html$Html$hr, _List_Nil, _List_Nil),
							A2(
							$elm$html$Html$h2,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Get more out of your ActiveState account with a ' + (tierName + ' subscription'))
								])),
							$author$project$Pages$Checkout$SpecifyOrg$upgradeBenefitsView(
							$author$project$Model$UpgradeBenefit$fromTierWithPricing(parentModel.sC)),
							A2(
							$elm$html$Html$section,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('org-selector-ui-footer')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											'These features, and more, are just $' + ($elm$core$String$fromInt(
												$author$project$Model$Tier$roundedMonthlyCost(parentModel.sC)) + ('/month' + ((includeAnnualText ? (' (billed annually at $' + ($elm$core$String$fromFloat(parentModel.sC.wF) + '/year)')) : '') + (parentModel.up ? ' once the free trial period ends.' : '.')))))
										])),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href('https://www.activestate.com/company/contact-us-pricing'),
											$elm$html$Html$Attributes$target('_blank')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Compare pricing plans')
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Checkout$view = F2(
	function (session, model) {
		var _v0 = model.iU;
		if (!_v0.$) {
			var specifyOrgModel = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Pages$Checkout$SpecifyOrgMsg,
				A3($author$project$Pages$Checkout$SpecifyOrg$view, session, model, specifyOrgModel));
		} else {
			var billingDetailsModel = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Pages$Checkout$BillingDetailsMsg,
				A3($author$project$Pages$Checkout$BillingDetails$view, session, model, billingDetailsModel));
		}
	});
var $author$project$Pages$ConnectAccount$GithubConnect = {$: 7};
var $author$project$Pages$ConnectAccount$InputUsername = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$ConnectAccount$InputTwoFactor = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$ConnectAccount$twoFactorField = A2(
	$elm$html$Html$section,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('two-factor-form')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$h2,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Two-factor Authentication')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('This account has two-factor authentication enabled. Please check your Authentication App for the 6-digit code and provide it below.')
				])),
			A2(
			$elm$html$Html$label,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Two-Factor Code')
						])),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id($author$project$Pages$ConnectAccount$twoFactorId),
							$elm$html$Html$Attributes$type_('text'),
							$elm$html$Html$Attributes$spellcheck(false),
							$elm$html$Html$Attributes$placeholder('e.g. 123456'),
							$elm$html$Html$Events$onInput($author$project$Pages$ConnectAccount$InputTwoFactor)
						]),
					_List_Nil)
				]))
		]));
var $author$project$Pages$ConnectAccount$brandNewAccountFormGithubAuth = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('email-heading')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Different email address')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('email'),
								$elm$html$Html$Attributes$autofocus(true),
								$elm$html$Html$Attributes$type_('text'),
								$elm$html$Html$Attributes$spellcheck(false),
								$elm$html$Html$Events$onInput($author$project$Pages$ConnectAccount$InputUsername)
							]),
						_List_Nil)
					])),
				A2($author$project$Misc$displayIf, model.j6 === 1, $author$project$Pages$ConnectAccount$twoFactorField),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('button-wrapper')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('secondary-button'),
								$elm$html$Html$Events$onClick($author$project$Pages$ConnectAccount$GithubConnect)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Continue')
							]))
					]))
			]));
};
var $author$project$Pages$ConnectAccount$InputPassword = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$ConnectAccount$LoginThen = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$ConnectAccount$emailLinkAndSignInForm = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Views$NotificationsInline$view(model),
				A2(
				$elm$html$Html$form,
				_List_fromArray(
					[
						$elm$html$Html$Events$onSubmit(
						$author$project$Pages$ConnectAccount$LoginThen(model.dI))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('email-heading')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Email')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id('email'),
										$elm$html$Html$Attributes$type_('text'),
										$elm$html$Html$Attributes$value(model.dI.AE),
										$elm$html$Html$Attributes$disabled(true)
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Password')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id('password'),
										$elm$html$Html$Attributes$type_('password'),
										$elm$html$Html$Events$onInput($author$project$Pages$ConnectAccount$InputPassword)
									]),
								_List_Nil)
							])),
						A2($author$project$Misc$displayIf, model.j6 === 1, $author$project$Pages$ConnectAccount$twoFactorField),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('button-wrapper')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('primary-button'),
										$elm$html$Html$Attributes$type_('submit'),
										$elm$html$Html$Attributes$disabled(model.lX)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Sign in & link account')
									])),
								A2(
								$elm$core$Maybe$withDefault,
								$elm$html$Html$text(''),
								A2(
									$elm$core$Maybe$map,
									function (error) {
										return A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('inline-error')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(error)
												]));
									},
									model.p_))
							]))
					]))
			]));
};
var $author$project$Pages$ConnectAccount$forgotPasswordLink = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('forgot-password')
		]),
	_List_fromArray(
		[
			A3(
			$author$project$Views$Link$link,
			$author$project$Model$Route$ForgotPassword,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Forgot your password?')
				]))
		]));
var $author$project$Pages$ConnectAccount$helpText = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('login-footer')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Trouble signing in? Let us know at '),
			A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$target('_blank'),
					$elm$html$Html$Attributes$href('mailto:support@activestate.com')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('support@activestate.com')
				])),
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('divider')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(' · ')
				])),
			A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href('https://www.activestate.com/company/privacy-policy/'),
					$elm$html$Html$Attributes$target('_blank')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Privacy Policy')
				]))
		]));
var $author$project$Pages$Login$logoBar = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('logo-bar')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('logo-wrapper'),
					$elm$html$Html$Attributes$href('https://platform.activestate.com/')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src('/img/activestate-logo-white.svg'),
							$elm$html$Html$Attributes$alt('ActiveState: The Open Source Languages Company')
						]),
					_List_Nil)
				]))
		]));
var $author$project$Pages$ConnectAccount$singleColumnLayout_GithubAuth = function (_v0) {
	var model = _v0.zf;
	var sharedAttributes = _v0.z3;
	var heading = _v0.yu;
	var session = _v0.l;
	var showGitHubContent = !$author$project$Utils$DomainUtils$isKSADomain(
		$author$project$Model$Session$getFlags(session).B3);
	return A2(
		$elm$html$Html$div,
		sharedAttributes,
		_List_fromArray(
			[
				$author$project$Pages$Login$logoBar,
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('page-body')
					]),
				_List_fromArray(
					[
						heading,
						A2(
						$author$project$Misc$displayIf,
						showGitHubContent,
						A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('It looks like your GitHub email — ' + (model.dI.AE + ' — has already been used to create an account on the Platform. If that was you, then sign in below using your email and we will link your existing account.'))
								]))),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('email-form-wrapper')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Sign in using your email')
									])),
								$author$project$Pages$ConnectAccount$emailLinkAndSignInForm(model),
								$author$project$Pages$ConnectAccount$forgotPasswordLink
							])),
						A2(
						$author$project$Misc$displayIf,
						showGitHubContent,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('email-form-wrapper')
								]),
							_List_fromArray(
								[
									A2($elm$html$Html$hr, _List_Nil, _List_Nil),
									A2(
									$elm$html$Html$h3,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Create a brand new account')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('If that wasn\'t you, then please provide a different email address to finish creating your account.')
										])),
									$author$project$Pages$ConnectAccount$brandNewAccountFormGithubAuth(model),
									$author$project$Pages$ConnectAccount$helpText
								])))
					]))
			]));
};
var $author$project$Pages$ConnectAccount$emailTakenView = F2(
	function (session, model) {
		var sharedAttributes = _List_fromArray(
			[
				$elm$html$Html$Attributes$id('auth-page'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('form-submitting', model.lX),
						_Utils_Tuple2('connect-account-page', true)
					]))
			]);
		var heading = A2(
			$elm$html$Html$h1,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Oops! Have you already created a Platform account?')
				]));
		return $author$project$Pages$ConnectAccount$singleColumnLayout_GithubAuth(
			{yu: heading, zf: model, l: session, z3: sharedAttributes});
	});
var $author$project$Pages$ConnectAccount$errorView = F2(
	function (model, errorMessage) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('auth-page'),
					$elm$html$Html$Attributes$class('connect-account-page')
				]),
			_List_fromArray(
				[
					$author$project$Pages$Login$logoBar,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('page-body')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('There was a problem creating your account via GitHub!')
								])),
							errorMessage,
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button-wrapper')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Views$Link$link,
									$author$project$Model$Route$CreateAccount(
										{
											h3: $elm$core$Maybe$Nothing,
											g$: $elm$core$Maybe$Nothing,
											dH: 2,
											lJ: $elm$core$Maybe$Nothing,
											hx: $elm$core$Maybe$Nothing,
											fs: model.dI.fs,
											dg: $elm$core$Maybe$Just(model.dg),
											o: $elm$core$Maybe$Just('connect-account')
										}),
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('primary-button')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Sign up using your Email')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('login-footer ')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Need help? '),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href('mailto:support@activestate.com'),
											$elm$html$Html$Attributes$target('_blank')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('support@activestate.com')
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('divider')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(' · ')
										])),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href('https://www.activestate.com/company/privacy-policy/'),
											$elm$html$Html$Attributes$target('_blank')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Privacy Policy')
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$ConnectAccount$errorWithMessage = F2(
	function (heading, body) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('emphasized')
						]),
					heading),
					A2($elm$html$Html$p, _List_Nil, body)
				]));
	});
var $author$project$Pages$ConnectAccount$notVerified = A2(
	$author$project$Pages$ConnectAccount$errorWithMessage,
	_List_fromArray(
		[
			$elm$html$Html$text('No verified email on GitHub.')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('In your GitHub account:'),
			A2(
			$elm$html$Html$ul,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Verify email'),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							$elm$html$Html$text(' - or - ')
						])),
					A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Set primary email')
						]))
				]))
		]));
var $author$project$Pages$ConnectAccount$unknownError = A2(
	$author$project$Pages$ConnectAccount$errorWithMessage,
	_List_fromArray(
		[
			$elm$html$Html$text('Unknown Error')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('We\'re not sure what went wrong, but you can still create a Platform account by signing up with your email.')
		]));
var $author$project$Pages$ConnectAccount$unspecifiedCollisionError = A2(
	$author$project$Pages$ConnectAccount$errorWithMessage,
	_List_fromArray(
		[
			$elm$html$Html$text('Your identifier is already in use on the Platform.')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('You can still create a Platform account, but you\'ll have to sign up by providing a different email and username.')
		]));
var $author$project$Pages$ConnectAccount$useEmailError = function (errorMessage) {
	return A2(
		$author$project$Pages$ConnectAccount$errorWithMessage,
		_List_fromArray(
			[
				$elm$html$Html$text(errorMessage)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('You can still create a Platform account by signing up with your email.')
			]));
};
var $author$project$Pages$ConnectAccount$userDeclined = A2(
	$author$project$Pages$ConnectAccount$errorWithMessage,
	_List_fromArray(
		[
			$elm$html$Html$text('GitHub authorization declined.')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Please accept the authorization or create a Platform account by signing up with your email.')
		]));
var $author$project$Pages$ConnectAccount$usernameCollisionError = A2(
	$author$project$Pages$ConnectAccount$errorWithMessage,
	_List_fromArray(
		[
			$elm$html$Html$text('Your GitHub username is already in use on the Platform.')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('You can still create a Platform account, but you\'ll have to sign up by providing a different email and username.')
		]));
var $author$project$Pages$ConnectAccount$view = F2(
	function (session, model) {
		var _v0 = model.lP;
		if (!_v0.$) {
			switch (_v0.a.$) {
				case 4:
					var takenEmail = _v0.a.a;
					var m = _Utils_update(
						model,
						{
							dI: A2($author$project$Model$Credentials$withUsername, takenEmail, model.dI)
						});
					return A2($author$project$Pages$ConnectAccount$emailTakenView, session, m);
				case 0:
					var _v1 = _v0.a;
					return A2($author$project$Pages$ConnectAccount$errorView, model, $author$project$Pages$ConnectAccount$unspecifiedCollisionError);
				case 1:
					var _v2 = _v0.a;
					return A2($author$project$Pages$ConnectAccount$errorView, model, $author$project$Pages$ConnectAccount$usernameCollisionError);
				case 2:
					var _v3 = _v0.a;
					return A2($author$project$Pages$ConnectAccount$errorView, model, $author$project$Pages$ConnectAccount$notVerified);
				case 3:
					var _v4 = _v0.a;
					return A2($author$project$Pages$ConnectAccount$errorView, model, $author$project$Pages$ConnectAccount$userDeclined);
				default:
					var message = _v0.a.a;
					return A2(
						$author$project$Pages$ConnectAccount$errorView,
						model,
						$author$project$Pages$ConnectAccount$useEmailError(message));
			}
		} else {
			return A2($author$project$Pages$ConnectAccount$errorView, model, $author$project$Pages$ConnectAccount$unknownError);
		}
	});
var $author$project$Pages$CreateAccount$determineLanguageName = function (projectName) {
	return A2(
		$elm$core$String$contains,
		'python',
		$elm$core$String$toLower(projectName)) ? 'python' : (A2(
		$elm$core$String$contains,
		'tcl',
		$elm$core$String$toLower(projectName)) ? 'tcl' : (A2(
		$elm$core$String$contains,
		'perl',
		$elm$core$String$toLower(projectName)) ? 'perl' : ''));
};
var $author$project$Pages$CreateAccount$viewIcon = function (kind) {
	return $author$project$Views$Icon$view(
		A2(
			$author$project$Views$Icon$colored,
			$author$project$Style$color('blue'),
			A2(
				$author$project$Views$Icon$square,
				50,
				$author$project$Views$Icon$icon(kind))));
};
var $author$project$Pages$CreateAccount$featuresView = function (_v0) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('feature-columns')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('col')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('icon')
							]),
						_List_fromArray(
							[
								$author$project$Pages$CreateAccount$viewIcon(55)
							])),
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Universal Observability')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('See what open source is running and where')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('col')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('icon')
							]),
						_List_fromArray(
							[
								$author$project$Pages$CreateAccount$viewIcon(64)
							])),
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Intelligent Remediation')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Quickly discover and fix vulnerabilities')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('col')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('icon')
							]),
						_List_fromArray(
							[
								$author$project$Pages$CreateAccount$viewIcon(16)
							])),
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Seamless Collaboration')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Streamline your Dev, Ops, and Security workflows')
							]))
					]))
			]));
};
var $author$project$Pages$CreateAccount$autoForkCopy = function (projectName) {
	var languageName = $author$project$Pages$CreateAccount$determineLanguageName(projectName);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('benefit-copy')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h1,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('top-line')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Create an account to get')
							])),
						$elm$html$Html$text('your free '),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('project-name')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A3($elm$core$String$replace, '-', ' ', projectName))
							])),
						$elm$html$Html$text(' download')
					])),
				A2(
				$elm$html$Html$h2,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Your '),
						A2(
						$elm$html$Html$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('free')
							])),
						$elm$html$Html$text(' ActiveState account gives you a'),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('language-name')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(' '),
								$elm$html$Html$text(languageName)
							])),
						$elm$html$Html$text(' runtime that is...')
					])),
				$author$project$Pages$CreateAccount$featuresView(
				$elm$core$Maybe$Just(languageName))
			]));
};
var $author$project$Pages$CreateAccount$buildLanguageCopy = F2(
	function (languageName, maybeLanguageVersion) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('benefit-copy')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('top-line')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Create a free ActiveState account to')
								])),
							$elm$html$Html$text('build the ' + (languageName + ' environment you need'))
						])),
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Your account lets you set up a '),
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('free ')
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('language-name')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(languageName)
								])),
							A2(
							$author$project$Misc$displayMaybe,
							function (langver) {
								return A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('language-version')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(' '),
											$elm$html$Html$text(langver)
										]));
							},
							maybeLanguageVersion),
							$elm$html$Html$text(' runtime that is...')
						])),
					$author$project$Pages$CreateAccount$featuresView(
					$elm$core$Maybe$Just(languageName))
				]));
	});
var $author$project$Pages$CreateAccount$createProjectCopy = F2(
	function (languageName, maybeLanguageVersion) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('benefit-copy')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('top-line')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Create an account to get')
								])),
							$elm$html$Html$text('your free ' + (languageName + ' download'))
						])),
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Your '),
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('free')
								])),
							$elm$html$Html$text(' ActiveState account gives you a '),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('language-name')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(languageName)
								])),
							A2(
							$author$project$Misc$displayMaybe,
							function (langVer) {
								return A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('language-name')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(' '),
											$elm$html$Html$text(langVer)
										]));
							},
							maybeLanguageVersion),
							$elm$html$Html$text(' runtime that is...')
						])),
					$author$project$Pages$CreateAccount$featuresView(
					$elm$core$Maybe$Just(languageName))
				]));
	});
var $author$project$Pages$CreateAccount$showTrialContent = false;
var $author$project$Pages$CreateAccount$trialSignUpCopy = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('benefit-copy')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$h1,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Get access to the complete ActiveState Platform for 7 days')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('See for yourself how ActiveState helps you manage open source in your organization with...')
				])),
			$author$project$Pages$CreateAccount$featuresView($elm$core$Maybe$Nothing)
		]));
var $author$project$Pages$CreateAccount$genericSignUpCopy = $author$project$Pages$CreateAccount$showTrialContent ? $author$project$Pages$CreateAccount$trialSignUpCopy : A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('benefit-copy')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$h1,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Create a Free ActiveState Platform account')
				]))
		]));
var $author$project$Pages$CreateAccount$invitedCopy = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('benefit-copy')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$h1,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('emphasized')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Create your free ActiveState Platform account to accept your invitation')
						]))
				]))
		]));
var $author$project$Model$Route$emptyCreateAccountParams = {h3: $elm$core$Maybe$Nothing, g$: $elm$core$Maybe$Nothing, dH: 2, lJ: $elm$core$Maybe$Nothing, hx: $elm$core$Maybe$Nothing, fs: $elm$core$Maybe$Nothing, dg: $elm$core$Maybe$Nothing, o: $elm$core$Maybe$Nothing};
var $author$project$Pages$CreateAccount$invitedNote = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('invited-note')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('The email address you sign up with must match the email address the invitation was sent to. If you sign up with GitHub the email address in your GitHub must match.')
				])),
			A3(
			$author$project$Views$Link$link,
			$author$project$Model$Route$CreateAccount($author$project$Model$Route$emptyCreateAccountParams),
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Sign up with a different email')
				]))
		]));
var $author$project$Pages$CreateAccount$GithubAuth = {$: 12};
var $author$project$Pages$Login$authDivider = function (label) {
	return A2(
		$elm$html$Html$h2,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('auth-divider')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(label)
					]))
			]));
};
var $author$project$Pages$CreateAccount$createAccountDisclaimer = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('login-footer'),
			$elm$html$Html$Attributes$class('section-divider')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Need help? '),
			A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href('mailto:support@activestate.com'),
					$elm$html$Html$Attributes$target('_blank')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('support@activestate.com')
				]))
		]));
var $author$project$Pages$CreateAccount$CreateUser = {$: 1};
var $author$project$Pages$CreateAccount$OnEmailInput = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$CreateAccount$fieldError = function (errorMessage) {
	return A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('field-error')
			]),
		_List_fromArray(
			[
				$author$project$Views$Icon$view(
				$author$project$Views$Icon$small(
					A2(
						$author$project$Views$Icon$colored,
						$author$project$Style$color('red'),
						$author$project$Views$Icon$icon(86)))),
				$elm$html$Html$text(errorMessage)
			]));
};
var $author$project$Pages$CreateAccount$hasVisibleError = function (formField) {
	if ((formField.$ === 3) && (formField.b.$ === 1)) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pages$CreateAccount$emailInput = function (emailField) {
	var statusIndicator = function () {
		if (((emailField.$ === 3) && (emailField.b.$ === 1)) && (!emailField.b.a.$)) {
			var errorText = emailField.b.a.a;
			return $author$project$Pages$CreateAccount$fieldError(errorText);
		} else {
			return $elm$html$Html$text('');
		}
	}();
	var isLocked = function () {
		if (emailField.$ === 2) {
			return true;
		} else {
			return false;
		}
	}();
	var hasError = $author$project$Pages$CreateAccount$hasVisibleError(emailField);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('error', hasError)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Work Email Address')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('email'),
								$elm$html$Html$Attributes$spellcheck(false),
								$elm$html$Html$Events$onInput($author$project$Pages$CreateAccount$OnEmailInput),
								$elm$html$Html$Attributes$value(
								$author$project$Pages$CreateAccount$fieldToText(emailField)),
								A2($elm$html$Html$Attributes$attribute, 'data-cy', 'email'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('locked-field', isLocked)
									])),
								$elm$html$Html$Attributes$disabled(isLocked)
							]),
						_List_Nil)
					])),
				statusIndicator,
				A2(
				$author$project$Misc$displayIf,
				$author$project$Pages$CreateAccount$showTrialContent,
				A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('trial-eligibility-disclaimer')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('To access the Enterprise trial, you must sign up with a valid business email or your GitHub account.')
						])))
			]));
};
var $author$project$Pages$CreateAccount$EulaAcceptedToggle = {$: 11};
var $author$project$Model$Legal$acceptableUsePolicy = 'https://www.activestate.com/legal/acceptable-use-policy';
var $author$project$Pages$CreateAccount$isFormSubmitted = function (f) {
	switch (f) {
		case 2:
			return true;
		case 1:
			return true;
		default:
			return false;
	}
};
var $author$project$Model$Legal$masterTermsOfService = 'https://www.activestate.com/legal/master-terms-of-service';
var $author$project$Pages$CreateAccount$eulaInput = function (model) {
	return A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('opt-in'),
				$elm$html$Html$Attributes$class('section-divider')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('checkbox'),
								$elm$html$Html$Attributes$checked(model.tM),
								$elm$html$Html$Events$onClick($author$project$Pages$CreateAccount$EulaAcceptedToggle),
								$elm$html$Html$Attributes$disabled(
								$author$project$Pages$CreateAccount$isFormSubmitted(model.ge)),
								A2($elm$html$Html$Attributes$attribute, 'data-cy', 'eula-select')
							]),
						_List_Nil),
						$elm$html$Html$text('Yes, I consent and agree to the ActiveState '),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$target('_blank'),
								$elm$html$Html$Attributes$href($author$project$Model$Legal$masterTermsOfService)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Master Terms of Service')
							])),
						$elm$html$Html$text(', '),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$target('_blank'),
								$elm$html$Html$Attributes$href($author$project$Model$Legal$acceptableUsePolicy)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Acceptable Use Policy')
							])),
						$elm$html$Html$text(', and  '),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$target('_blank'),
								$elm$html$Html$Attributes$href($author$project$Model$Legal$privacyPolicy)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Privacy Policy')
							])),
						$elm$html$Html$text('.')
					])),
				A2($author$project$Misc$displayMaybe, $author$project$Pages$CreateAccount$fieldError, model.ou)
			]));
};
var $author$project$Pages$CreateAccount$EmailOptInToggle = {$: 10};
var $author$project$Pages$CreateAccount$marketingOptInInput = function (model) {
	return A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('opt-in')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('checkbox'),
								$elm$html$Html$Attributes$checked(model.lL),
								$elm$html$Html$Events$onClick($author$project$Pages$CreateAccount$EmailOptInToggle)
							]),
						_List_Nil),
						$elm$html$Html$text('Yes, I would like to receive occasional emails on promotions, news and events from ActiveState.')
					]))
			]));
};
var $author$project$Pages$CreateAccount$OnPasswordInput = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$CreateAccount$TogglePasswordVisibility = {$: 7};
var $author$project$Pages$CreateAccount$characterMinimumText = function (minLength) {
	return $elm$html$Html$text(
		'Must be at least ' + ($elm$core$String$fromInt(minLength) + ' characters long'));
};
var $author$project$Pages$CreateAccount$passwordInput = F2(
	function (passwordField, passwordVisible) {
		var statusIndicator = function () {
			_v1$2:
			while (true) {
				switch (passwordField.$) {
					case 3:
						if ((passwordField.b.$ === 1) && (!passwordField.b.a.$)) {
							var errorText = passwordField.b.a.a;
							return $author$project$Pages$CreateAccount$fieldError(errorText);
						} else {
							break _v1$2;
						}
					case 6:
						return A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('field-status-label '),
									$elm$html$Html$Attributes$class('satisfied')
								]),
							_List_fromArray(
								[
									$author$project$Views$Icon$view(
									$author$project$Views$Icon$small(
										$author$project$Views$Icon$icon(11))),
									$author$project$Pages$CreateAccount$characterMinimumText($author$project$Validation$minPasswordLength)
								]));
					default:
						break _v1$2;
				}
			}
			return A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('field-status-label ')
					]),
				_List_fromArray(
					[
						$author$project$Pages$CreateAccount$characterMinimumText($author$project$Validation$minPasswordLength)
					]));
		}();
		var hasError = $author$project$Pages$CreateAccount$hasVisibleError(passwordField);
		var _v0 = passwordVisible ? _Utils_Tuple2(
			$elm$html$Html$Attributes$type_('text'),
			'Hide') : _Utils_Tuple2(
			$elm$html$Html$Attributes$type_('password'),
			'Show');
		var inputFieldType = _v0.a;
		var toggleLabel = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('password-input-wrapper'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('error', hasError)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Choose a Password'),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('more-info-tooltip')
										]),
									_List_fromArray(
										[
											$author$project$Views$Icon$view(
											$author$project$Views$Icon$icon(52)),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('content')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Get information on creating strong passwords from our Documentation. '),
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$href('https://docs.activestate.com/platform/user/prefs/password/#best-practices-when-choosing-a-password'),
															$elm$html$Html$Attributes$target('_Blank')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Learn More')
														]))
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('password-input')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											inputFieldType,
											$elm$html$Html$Events$onInput($author$project$Pages$CreateAccount$OnPasswordInput),
											$elm$html$Html$Attributes$maxlength($author$project$Validation$maxPasswordLength),
											A2($elm$html$Html$Attributes$attribute, 'data-cy', 'password')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('small secondary-button  visibility-toggle'),
											$elm$html$Html$Events$onClick($author$project$Pages$CreateAccount$TogglePasswordVisibility),
											$elm$html$Html$Attributes$type_('button')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(toggleLabel)
										]))
								]))
						])),
					statusIndicator
				]));
	});
var $author$project$Pages$CreateAccount$submitButton = function (formStatus) {
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('primary-button ga-button-create-account'),
				$elm$html$Html$Attributes$type_('submit'),
				$elm$html$Html$Attributes$disabled(
				$author$project$Pages$CreateAccount$isFormSubmitted(formStatus)),
				A2($elm$html$Html$Attributes$attribute, 'data-cy', 'create-account')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Create Account')
			]));
};
var $author$project$Pages$CreateAccount$OnUsernameInput = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$CreateAccount$usernameInput = function (usernameField) {
	var username = A2(
		$elm$core$Maybe$withDefault,
		'',
		$author$project$Pages$CreateAccount$formFieldValue(usernameField));
	var usernameIsFormatted = !_Utils_eq(
		username,
		$author$project$Validation$formatUsername(username));
	var statusIndicator = function () {
		_v0$5:
		while (true) {
			switch (usernameField.$) {
				case 6:
					return A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('field-status-label available')
							]),
						_List_fromArray(
							[
								$author$project$Views$Icon$view(
								$author$project$Views$Icon$small(
									$author$project$Views$Icon$icon(11))),
								$elm$html$Html$text('Available')
							]));
				case 3:
					if (usernameField.b.$ === 1) {
						if (!usernameField.b.a.$) {
							var error = usernameField.b.a.a;
							return $author$project$Pages$CreateAccount$fieldError(error);
						} else {
							var error = usernameField.b.a.a;
							return $author$project$Pages$CreateAccount$fieldError(error);
						}
					} else {
						break _v0$5;
					}
				case 4:
					return A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('field-status-label checking')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cool username!')
							]));
				case 5:
					return A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('field-status-label checking')
							]),
						_List_fromArray(
							[
								$author$project$Views$Loading$dots,
								$elm$html$Html$text('Checking availability')
							]));
				default:
					break _v0$5;
			}
		}
		return $elm$html$Html$text('');
	}();
	var highlightError = $author$project$Pages$CreateAccount$hasVisibleError(usernameField);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('error', highlightError)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Pick a Username')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('username-input-wrapper')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('text'),
										$elm$html$Html$Attributes$spellcheck(false),
										$elm$html$Html$Attributes$maxlength($author$project$Validation$maxUsernameLength),
										$elm$html$Html$Events$onInput($author$project$Pages$CreateAccount$OnUsernameInput),
										A2($elm$html$Html$Attributes$attribute, 'data-cy', 'username')
									]),
								_List_Nil)
							]))
					])),
				A2(
				$author$project$Misc$displayIf,
				usernameIsFormatted,
				$author$project$Views$ViewUtils$formattedNameEl(
					$author$project$Validation$formatUsername(username))),
				statusIndicator
			]));
};
var $author$project$Pages$CreateAccount$emailForm = function (model) {
	var perlProjectRoute = $author$project$Model$Route$ProjectOverview(
		$author$project$Model$Route$projectOverviewParams(
			{ix: 'ActiveState-Projects', vT: 'ActiveState-Perl-5.36.0'}));
	var submitButtonGroup = function () {
		var _v0 = model.qm;
		if (_v0.$ === 6) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('submit_button_div'),
						$elm$html$Html$Attributes$class('row'),
						$elm$html$Html$Attributes$class('vertical-center'),
						$elm$html$Html$Attributes$class('button-wrapper')
					]),
				_List_fromArray(
					[
						$author$project$Pages$CreateAccount$submitButton(model.ge),
						A3(
						$author$project$Views$Link$link,
						perlProjectRoute,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('small-text')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Continue to download Perl without an account')
							]))
					]));
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('button-wrapper')
					]),
				_List_fromArray(
					[
						$author$project$Pages$CreateAccount$submitButton(model.ge)
					]));
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Views$NotificationsInline$view(model),
				A2(
				$elm$html$Html$form,
				_List_fromArray(
					[
						$elm$html$Html$Events$onSubmit($author$project$Pages$CreateAccount$CreateUser)
					]),
				_List_fromArray(
					[
						$author$project$Pages$CreateAccount$emailInput(model.i0),
						$author$project$Pages$CreateAccount$usernameInput(model.fz),
						A2($author$project$Pages$CreateAccount$passwordInput, model.jp, model.pl),
						$author$project$Pages$CreateAccount$eulaInput(model),
						$author$project$Pages$CreateAccount$marketingOptInInput(model),
						submitButtonGroup
					]))
			]));
};
var $author$project$Pages$Login$logoBarWithAuthButton = F2(
	function (route, buttonLabel) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('logo-bar')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('logo-wrapper'),
							$elm$html$Html$Attributes$target('_blank'),
							$elm$html$Html$Attributes$href('https://www.activestate.com/')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src('/img/activestate-logo-white.svg'),
									$elm$html$Html$Attributes$alt('ActiveState: The Open Source Languages Company')
								]),
							_List_Nil)
						])),
					A3(
					$author$project$Views$Link$link,
					route,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('white-button-on-black nav-button')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(buttonLabel)
						]))
				]));
	});
var $author$project$Views$AuthButton$viewTooltip = function (t) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('tooltip')
			]),
		_List_fromArray(
			[t]));
};
var $author$project$Views$AuthButton$viewWithIcon = F4(
	function (icon, buttonLabel, tooltip, onClickMsg) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button-with-tooltip')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('secondary-button'),
							$elm$html$Html$Events$onClick(onClickMsg)
						]),
					_List_fromArray(
						[
							$author$project$Views$Icon$view(
							A2(
								$author$project$Views$Icon$square,
								20,
								$author$project$Views$Icon$icon(icon))),
							$elm$html$Html$text(buttonLabel)
						])),
					A2($author$project$Misc$displayMaybe, $author$project$Views$AuthButton$viewTooltip, tooltip)
				]));
	});
var $author$project$Views$AuthButton$view = F2(
	function (label, msg) {
		return A4($author$project$Views$AuthButton$viewWithIcon, 31, label, $elm$core$Maybe$Nothing, msg);
	});
var $author$project$Pages$CreateAccount$singleColumnLayout = function (_v0) {
	var model = _v0.zf;
	var sharedAttributes = _v0.z3;
	var heading = _v0.yu;
	var note = _v0.kd;
	var signInRoute = _v0.iJ;
	var session = _v0.l;
	var showSocialAuth = function () {
		var isKomodoTraffic = A2($elm$core$Maybe$withDefault, '', model.nI) === 'komodo';
		var isKSADomain = $author$project$Utils$DomainUtils$isKSADomain(
			$author$project$Model$Session$getFlags(session).B3);
		return (!isKomodoTraffic) && (!isKSADomain);
	}();
	return A2(
		$elm$html$Html$div,
		sharedAttributes,
		_List_fromArray(
			[
				A2($author$project$Pages$Login$logoBarWithAuthButton, signInRoute, 'Log In'),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('page-body')
					]),
				_List_fromArray(
					[
						heading,
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('email-form-wrapper')
							]),
						_List_fromArray(
							[
								note,
								A2(
								$author$project$Misc$displayIf,
								showSocialAuth,
								A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('social-auth-wrapper')
										]),
									_List_fromArray(
										[
											A2($author$project$Views$AuthButton$view, 'Sign up with GitHub', $author$project$Pages$CreateAccount$GithubAuth)
										]))),
								A2(
								$author$project$Misc$displayIf,
								showSocialAuth,
								$author$project$Pages$Login$authDivider('Or, sign up with Email')),
								$author$project$Pages$CreateAccount$emailForm(model),
								$author$project$Pages$CreateAccount$createAccountDisclaimer
							]))
					]))
			]));
};
var $author$project$Pages$CreateAccount$ChangeAuthMode = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$CreateAccount$socialAuth = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('social-auth-wrapper')
		]),
	_List_fromArray(
		[
			A2($author$project$Views$AuthButton$view, 'Sign up with GitHub', $author$project$Pages$CreateAccount$GithubAuth),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('If you already have a GitHub account, you can use it to access the ActiveState Platform.')
				]))
		]));
var $author$project$Pages$CreateAccount$Github = 1;
var $author$project$Pages$CreateAccount$socialTabs = F3(
	function (model, session, changeAuthMode) {
		var showSocialAuth = function () {
			var isKomodoTraffic = A2($elm$core$Maybe$withDefault, '', model.nI) === 'komodo';
			var isKSADomain = $author$project$Utils$DomainUtils$isKSADomain(
				$author$project$Model$Session$getFlags(session).B3);
			return (!isKomodoTraffic) && (!isKSADomain);
		}();
		return A2(
			$author$project$Misc$displayIf,
			showSocialAuth,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('section-tabs')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('selected', !model.kP)
									])),
								$elm$html$Html$Events$onClick(
								changeAuthMode(0))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('With your Email')
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('selected', model.kP === 1)
									])),
								$elm$html$Html$Events$onClick(
								changeAuthMode(1))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('With GitHub')
							]))
					])));
	});
var $author$project$Pages$CreateAccount$switchToSignIn = function (signInRoute) {
	return A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('login-switch')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Already have an account?'),
				A3(
				$author$project$Views$Link$link,
				signInRoute,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Sign In')
					]))
			]));
};
var $author$project$Views$AuthContent$CreateProjectFromCommitContent = 0;
var $author$project$Views$AuthContent$DefaultContent = 1;
var $author$project$Views$AuthContent$content = function (contentType) {
	if (!contentType) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('secondary-login-content')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('You\'re just one step away from your runtime')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Create your account to access an editable project that contains all the components necessary to reproduce your local environment.')
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('You\'ll also be able to...')
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('features')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Modify packages & platforms and create new builds on demand')
								])),
							A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Create & manage additional runtimes for all your projects')
								])),
							A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Share your runtimes with your team so everyone\'s on the same page')
								]))
						]))
				]));
	} else {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('secondary-login-content')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Build custom Python & Perl distributions on demand')
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('features')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Pick only the packages you need')
								])),
							A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('We automatically resolve all dependencies')
								])),
							A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('You get an easy-to-deploy runtime environment')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bottom-section')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('builder-image')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('platform-disclaimer')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Custom distributions are available for Linux, Windows, and Mac.')
								]))
						]))
				]));
	}
};
var $author$project$Views$AuthContent$view = function (_v0) {
	var nextRoute = _v0.dg;
	return $author$project$Model$Route$isProjectFromCommit(nextRoute) ? $author$project$Views$AuthContent$content(0) : $author$project$Views$AuthContent$content(1);
};
var $author$project$Pages$CreateAccount$twoColumnLayout = function (_v0) {
	var model = _v0.zf;
	var sharedAttributes = _v0.z3;
	var signInRoute = _v0.iJ;
	var session = _v0.l;
	return A2(
		$elm$html$Html$div,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class('two-column'),
			sharedAttributes),
		_List_fromArray(
			[
				$author$project$Pages$Login$logoBar,
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('login-box')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-wrapper')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h1,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Create an Account')
									])),
								$author$project$Pages$CreateAccount$switchToSignIn(signInRoute),
								A3($author$project$Pages$CreateAccount$socialTabs, model, session, $author$project$Pages$CreateAccount$ChangeAuthMode),
								function () {
								var _v1 = model.kP;
								if (_v1 === 1) {
									return $author$project$Pages$CreateAccount$socialAuth;
								} else {
									return $author$project$Pages$CreateAccount$emailForm(model);
								}
							}()
							])),
						$author$project$Views$AuthContent$view(
						{dg: model.dg, Gb: model.nI})
					])),
				$author$project$Pages$CreateAccount$createAccountDisclaimer
			]));
};
var $author$project$Pages$CreateAccount$view = F2(
	function (model, session) {
		var signInRoute = $author$project$Model$Route$Login(
			{
				g$: model.g$,
				dH: model.dH,
				lJ: $author$project$Pages$CreateAccount$maybeLocked(model.i0),
				lP: $elm$core$Maybe$Nothing,
				hx: model.tW,
				fs: model.fs,
				dg: model.dg,
				pC: false,
				o: model.nI
			});
		var formSubmitting = function () {
			var _v2 = model.ge;
			if (_v2 === 2) {
				return true;
			} else {
				return false;
			}
		}();
		var sharedAttributes = _List_fromArray(
			[
				$elm$html$Html$Attributes$id('auth-page'),
				$elm$html$Html$Attributes$class('create-account-page'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('form-submitting', formSubmitting)
					]))
			]);
		var _v0 = model.qm;
		switch (_v0.$) {
			case 0:
				return $author$project$Pages$CreateAccount$singleColumnLayout(
					{
						yu: $author$project$Pages$CreateAccount$genericSignUpCopy,
						zf: model,
						kd: $elm$html$Html$text(''),
						l: session,
						z3: sharedAttributes,
						iJ: signInRoute
					});
			case 1:
				return $author$project$Pages$CreateAccount$singleColumnLayout(
					{yu: $author$project$Pages$CreateAccount$invitedCopy, zf: model, kd: $author$project$Pages$CreateAccount$invitedNote, l: session, z3: sharedAttributes, iJ: signInRoute});
			case 5:
				return $author$project$Pages$CreateAccount$twoColumnLayout(
					{zf: model, l: session, z3: sharedAttributes, iJ: signInRoute});
			case 2:
				var projectName = _v0.a;
				return $author$project$Pages$CreateAccount$singleColumnLayout(
					{
						yu: $author$project$Pages$CreateAccount$autoForkCopy(projectName),
						zf: model,
						kd: $elm$html$Html$text(''),
						l: session,
						z3: sharedAttributes,
						iJ: signInRoute
					});
			case 3:
				var maybeLanguage = _v0.a;
				var maybeLanguageVersion = _v0.b;
				var heading = function () {
					if (!maybeLanguage.$) {
						var language = maybeLanguage.a;
						var languageName = $elm_community$string_extra$String$Extra$toTitleCase(
							$author$project$Model$Language$toString(language));
						return A2($author$project$Pages$CreateAccount$createProjectCopy, languageName, maybeLanguageVersion);
					} else {
						return $author$project$Pages$CreateAccount$genericSignUpCopy;
					}
				}();
				return $author$project$Pages$CreateAccount$singleColumnLayout(
					{
						yu: heading,
						zf: model,
						kd: $elm$html$Html$text(''),
						l: session,
						z3: sharedAttributes,
						iJ: signInRoute
					});
			case 4:
				return $author$project$Pages$CreateAccount$singleColumnLayout(
					{
						yu: A2(
							$author$project$Pages$CreateAccount$buildLanguageCopy,
							'Python',
							$elm$core$Maybe$Just(
								$author$project$Model$VersionString$toString($author$project$Model$LanguageVersions$Python$supportDict.hO))),
						zf: model,
						kd: $elm$html$Html$text(''),
						l: session,
						z3: sharedAttributes,
						iJ: signInRoute
					});
			default:
				var maybeLanguageVersion = _v0.a;
				return $author$project$Pages$CreateAccount$singleColumnLayout(
					{
						yu: A2($author$project$Pages$CreateAccount$buildLanguageCopy, 'Perl', maybeLanguageVersion),
						zf: model,
						kd: $elm$html$Html$text(''),
						l: session,
						z3: sharedAttributes,
						iJ: signInRoute
					});
		}
	});
var $author$project$Pages$CreateOrganization$view = F2(
	function (model, _v0) {
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('page create-organization')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$elm$html$Html$map($author$project$Pages$CreateOrganization$CreateOrgFormMsg),
						$author$project$Views$CreateOrgForm$view(model.jT)))
				]));
	});
var $author$project$Pages$CreateProject$ChooseVersion = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Pages$CreateProject$CreateProject = function (a) {
	return {$: 1, a: a};
};
var $author$project$Views$TeamTier$MouseOverTag = $elm$core$Basics$identity;
var $author$project$Pages$CreateProject$NewDescription = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$CreateProject$NewProjectName = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$CreateProject$OrgDropdownItemSelected = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$CreateProject$TeamTierTagHoverEnd = {$: 17};
var $author$project$Pages$CreateProject$TeamTierTagHoverStart = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$CreateProject$ToggleOrgDropDown = {$: 18};
var $author$project$Pages$CreateProject$UpdatePlatformChoice = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$CreateProject$SelectAllBundles = {$: 8};
var $author$project$Pages$CreateProject$UnselectAllBundles = {$: 9};
var $author$project$Pages$CreateProject$ToggleBundlePackages = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$CreateProject$ToggleBundleSelection = function (a) {
	return {$: 7, a: a};
};
var $author$project$Model$Ingredient$description = function (_v0) {
	var ingredient = _v0.a;
	return A2($elm$core$String$startsWith, 'The ' + (ingredient.w + ' package'), ingredient.bP) ? '' : ingredient.bP;
};
var $author$project$Model$IngredientVersion$dependencies = function (_v0) {
	var m = _v0;
	return m.lt;
};
var $author$project$Model$IngredientVersion$filteredDependencies = A2(
	$elm$core$Basics$composeR,
	$author$project$Model$IngredientVersion$dependencies,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$filter(
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.aE;
				},
				A2(
					$elm$core$Basics$composeR,
					$author$project$Model$Namespace$kindFromString,
					function (kind) {
						return (kind !== 3) && (kind !== 4);
					}))),
		$elm$core$List$sortBy(
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.d;
				},
				$elm$core$String$toLower))));
var $author$project$Model$Ingredient$filteredDependencies = function (_v0) {
	var version = _v0.b;
	return $author$project$Model$IngredientVersion$filteredDependencies(version);
};
var $author$project$Pages$CreateProject$bundleView = F3(
	function (bundle, expanded, selected) {
		var packageList = A2(
			$elm$core$List$map,
			function (_v0) {
				var feature = _v0.d;
				return A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(feature)
						]));
			},
			$author$project$Model$Ingredient$filteredDependencies(bundle));
		var packageCount = $elm$core$String$fromInt(
			$elm$core$List$length(packageList));
		var key = $author$project$Model$Ingredient$key(bundle);
		return A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bundle-wrapper'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('selected', selected)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('checkbox'),
							$elm$html$Html$Attributes$checked(selected),
							$elm$html$Html$Events$onInput(
							$elm$core$Basics$always(
								$author$project$Pages$CreateProject$ToggleBundleSelection(bundle)))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('item-name bundle-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Model$Ingredient$name(bundle))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bundle-description')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Model$Ingredient$description(bundle))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bundle-dependencies')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('toggle-wrapper'),
									$author$project$Misc$onClickNoBubble(
									$author$project$Pages$CreateProject$ToggleBundlePackages(key))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('toggle-icon'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('expanded', expanded)
												]))
										]),
									_List_fromArray(
										[
											$author$project$Views$Icon$view(
											$author$project$Views$Icon$icon(13))
										])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(packageCount + ' Packages')
										]))
								])),
							A2(
							$author$project$Misc$displayIf,
							expanded,
							A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2($elm$html$Html$ul, _List_Nil, packageList)
									])))
						]))
				]));
	});
var $author$project$Pages$CreateProject$bundlesView = function (model) {
	var _v0 = model.iS;
	switch (_v0.$) {
		case 3:
			var metadata = _v0.a;
			var sortKey = function (bundle) {
				return _Utils_Tuple2(
					A2(
						$elm$core$List$member,
						$author$project$Model$Ingredient$key(bundle),
						$author$project$Pages$CreateProject$defaultSelectedBundleNames) ? 0 : 1,
					$author$project$Model$Ingredient$name(bundle));
			};
			var sortedBundles = A2(
				$elm$core$List$sortBy,
				sortKey,
				$elm$core$Dict$values(metadata));
			var showBundleView = function (bundle) {
				var key = $author$project$Model$Ingredient$key(bundle);
				var selected = A2(
					$elm$core$Dict$member,
					key,
					$author$project$Model$BuildPlanner$SolveLegacyEditor$getBundles(model.qR));
				var toggleState = A2($elm$core$Set$member, key, model.n9);
				return A3($author$project$Pages$CreateProject$bundleView, bundle, toggleState, selected);
			};
			var hasBundles = !$elm$core$List$isEmpty(sortedBundles);
			return A2(
				$author$project$Misc$displayIf,
				hasBundles,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('field-section')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Add package bundles')
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('field-info')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Bundles are groups of packages that work well together to solve common problems. You can also add individual packages later.')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('select-all-bundles')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('button'),
											$elm$html$Html$Events$onClick($author$project$Pages$CreateProject$SelectAllBundles),
											$elm$html$Html$Attributes$class('text-button')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Select all')
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('divider')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('·')
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('button'),
											$elm$html$Html$Events$onClick($author$project$Pages$CreateProject$UnselectAllBundles),
											$elm$html$Html$Attributes$class('text-button')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Unselect all')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bundle-selector')
								]),
							A2($elm$core$List$map, showBundleView, sortedBundles))
						])));
		case 1:
			return $author$project$Views$Loading$dots;
		default:
			return $elm$html$Html$text('');
	}
};
var $author$project$Pages$CreateProject$GoBack = {$: 11};
var $author$project$Pages$CreateProject$cancelButton = A2(
	$elm$html$Html$button,
	_List_fromArray(
		[
			$elm$html$Html$Events$onClick($author$project$Pages$CreateProject$GoBack),
			$elm$html$Html$Attributes$class('secondary-button'),
			$elm$html$Html$Attributes$type_('button')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Cancel')
		]));
var $author$project$Pages$CreateProject$fieldError = function (content) {
	return A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('field-error')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(content)
			]));
};
var $author$project$Views$LanguageSelectorSimple$header = function (name) {
	return A2(
		$elm$html$Html$h3,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Select a '),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('language-name'),
						$elm$html$Html$Attributes$class(name)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(name)
					])),
				$elm$html$Html$text(' version')
			]));
};
var $author$project$Pages$CreateProject$ToggleInstallers = {$: 15};
var $author$project$Pages$CreateProject$installerOption = function (_v0) {
	var isDisabled = _v0.Dc;
	var isChecked = _v0.oN;
	var optionName = _v0.kk;
	var clickMsg = _v0.ob;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('option'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('selected', isChecked),
						_Utils_Tuple2('disabled-option', isDisabled)
					])),
				A2($author$project$Misc$attributeMaybe, $elm$html$Html$Events$onClick, clickMsg)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('checkbox'),
						$elm$html$Html$Attributes$checked(isChecked),
						$elm$html$Html$Attributes$disabled(isDisabled)
					]),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$for(optionName)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('option-name')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(optionName)
									]))
							]))
					]))
			]));
};
var $author$project$Model$Permissions$orgCanPackageCamel = $author$project$Model$Organization$addOnEnabled('installer_downloads');
var $author$project$Pages$CreateProject$installersSelector = function (model) {
	var optionName = 'Downloadable Installer';
	var optionConfig = function () {
		var _v0 = _Utils_Tuple2(
			$author$project$Model$Permissions$orgCanPackageCamel(model.c3),
			$author$project$Model$Permissions$orgCanPackageInstaller(model.c3));
		if (!_v0.b) {
			if (!_v0.a) {
				return {ob: $elm$core$Maybe$Nothing, oN: false, Dc: true, kk: optionName};
			} else {
				return {ob: $elm$core$Maybe$Nothing, oN: true, Dc: true, kk: optionName};
			}
		} else {
			return {
				ob: $elm$core$Maybe$Just($author$project$Pages$CreateProject$ToggleInstallers),
				oN: model.kM,
				Dc: false,
				kk: optionName
			};
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('installers-selector-wrapper')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('installers-selector-new')
					]),
				_List_fromArray(
					[
						$author$project$Pages$CreateProject$installerOption(optionConfig)
					]))
			]));
};
var $author$project$Pages$CreateProject$ChooseLanguage = function (a) {
	return {$: 14, a: a};
};
var $author$project$Model$LanguageVersions$getIconKind = function (languageVersions) {
	var _v0 = $author$project$Model$LanguageVersions$getName(languageVersions);
	switch (_v0) {
		case 'python':
			return $elm$core$Maybe$Just(62);
		case 'perl':
			return $elm$core$Maybe$Just(60);
		case 'ruby':
			return $elm$core$Maybe$Just(65);
		case 'tcl':
			return $elm$core$Maybe$Just(79);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$LanguageVersions$getVersions = function (accessModel) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Model$LanguageVersions$pruneLanguage(accessModel),
		A2(
			$elm$core$Basics$composeR,
			function (_v0) {
				var contents = _v0;
				return contents;
			},
			$author$project$Model$LanguageVersions$getVersionsRaw));
};
var $author$project$Model$LanguageVersions$isShownOnlyToSuperusers = F3(
	function (accessModel, _v0, version) {
		var languageVersions = _v0;
		var showableToSuperusers = A3(
			$author$project$Model$LanguageVersions$isShowable,
			_Utils_update(
				accessModel,
				{rj: true, oS: true}),
			languageVersions,
			version);
		var showableToNonSuperusers = A3(
			$author$project$Model$LanguageVersions$isShowable,
			_Utils_update(
				accessModel,
				{rj: false, oS: false}),
			languageVersions,
			version);
		return showableToSuperusers && (!showableToNonSuperusers);
	});
var $author$project$Pages$CreateProject$languageOption = F3(
	function (accessModel, isChosen, languageVersions) {
		var name = $author$project$Model$LanguageVersions$getName(languageVersions);
		var isShownOnlyToSuperusers = A2(
			$elm$core$List$all,
			A2($author$project$Model$LanguageVersions$isShownOnlyToSuperusers, accessModel, languageVersions),
			A2($author$project$Model$LanguageVersions$getVersions, accessModel, languageVersions));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$Pages$CreateProject$ChooseLanguage(languageVersions)),
					$elm$html$Html$Attributes$class('option'),
					$elm$html$Html$Attributes$class(name),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('selected', isChosen),
							_Utils_Tuple2('superuser-only', isShownOnlyToSuperusers)
						])),
					A2($elm$html$Html$Attributes$attribute, 'data-cy', 'select-language-' + name)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Misc$displayMaybe,
					A2($elm$core$Basics$composeR, $author$project$Views$Icon$icon, $author$project$Views$Icon$view),
					$author$project$Model$LanguageVersions$getIconKind(languageVersions)),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(name)
						]))
				]));
	});
var $author$project$Pages$CreateProject$languageSelector = F3(
	function (accessModel, selectedLanguages, languages) {
		var languageOptionsList = A2(
			$elm$core$List$map,
			function (language) {
				return A3(
					$author$project$Pages$CreateProject$languageOption,
					accessModel,
					A2(
						$elm$core$List$any,
						$author$project$Model$LanguageVersions$matches(language),
						selectedLanguages),
					language);
			},
			languages);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('language-selector-single')
				]),
			languageOptionsList);
	});
var $author$project$Model$ProjectEditableStatus$Editable = 0;
var $author$project$Views$LanguageVersionWarning$learnMoreButton = function (wide) {
	return A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$href('https://www.activestate.com/products/python/python-2-7'),
				$elm$html$Html$Attributes$target('_blank'),
				$elm$html$Html$Attributes$class(
				wide ? 'wider-button' : ''),
				$elm$html$Html$Attributes$class('secondary-button small')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Learn More')
			]));
};
var $author$project$Views$LanguageVersionWarning$changeVersionButton = F5(
	function (projectEditableStatus, wide, maybeOnClick, maybeLabel, fallbackToLearnMore) {
		var _v0 = _Utils_Tuple2(maybeOnClick, fallbackToLearnMore);
		if (!_v0.a.$) {
			var changeVersionMsg = _v0.a.a;
			if (!projectEditableStatus) {
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							wide ? 'wider-button' : ''),
							$elm$html$Html$Attributes$class('secondary-button small'),
							$elm$html$Html$Events$onClick(changeVersionMsg)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($elm$core$Maybe$withDefault, 'Change Version', maybeLabel))
						]));
			} else {
				return $elm$html$Html$text('');
			}
		} else {
			if (_v0.b) {
				var _v2 = _v0.a;
				return $author$project$Views$LanguageVersionWarning$learnMoreButton(wide);
			} else {
				var _v3 = _v0.a;
				return $elm$html$Html$text('');
			}
		}
	});
var $author$project$Model$VersionString$gt = F2(
	function (a, b) {
		return A2($author$project$Model$VersionString$compare, a, b) === 2;
	});
var $author$project$Views$LanguageVersionWarning$actionButton = function (_v0) {
	var projectEditableStatus = _v0.r$;
	var kind = _v0.mp;
	var buttonWide = _v0.qu;
	var fallbackToLearnMore = _v0.qW;
	switch (kind.$) {
		case 3:
			return $author$project$Views$LanguageVersionWarning$learnMoreButton(buttonWide);
		case 0:
			var language = kind.a;
			var version = kind.b;
			var changeVersionMsg = kind.c;
			var is2_7 = A2(
				$author$project$Model$VersionString$lt,
				version,
				A3($author$project$Model$VersionString$new, 3, 0, 0)) && (A2(
				$author$project$Model$VersionString$gt,
				version,
				A3($author$project$Model$VersionString$new, 2, 7, 0)) || A2(
				$author$project$Model$VersionString$eq,
				version,
				A3($author$project$Model$VersionString$new, 2, 7, 0)));
			return A5($author$project$Views$LanguageVersionWarning$changeVersionButton, projectEditableStatus, buttonWide, changeVersionMsg, $elm$core$Maybe$Nothing, fallbackToLearnMore && ((language === 1) && is2_7));
		case 1:
			var changeVersionMsg = kind.c;
			return A5($author$project$Views$LanguageVersionWarning$changeVersionButton, projectEditableStatus, buttonWide, changeVersionMsg, $elm$core$Maybe$Nothing, false);
		case 2:
			var changeVersionMsg = kind.c;
			return A5(
				$author$project$Views$LanguageVersionWarning$changeVersionButton,
				projectEditableStatus,
				buttonWide,
				changeVersionMsg,
				$elm$core$Maybe$Just('Preview Update'),
				false);
		default:
			return $elm$html$Html$text('');
	}
};
var $author$project$Views$LanguageVersionWarning$kindAttributes = function (kind) {
	switch (kind.$) {
		case 0:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('eol'),
					$elm$html$Html$Attributes$class('version-warning ')
				]);
		case 3:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('selected-community-python2'),
					$elm$html$Html$Attributes$class('version-warning ')
				]);
		case 1:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('not-recommended'),
					$elm$html$Html$Attributes$class('version-note')
				]);
		case 2:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('newer-recommended-version'),
					$elm$html$Html$Attributes$class('version-note')
				]);
		default:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('eol'),
					$elm$html$Html$Attributes$class('version-warning ')
				]);
	}
};
var $author$project$Model$LanguageVersionTrustLevel$endOfLifeDatesUrl = function (language) {
	switch (language) {
		case 1:
			return $elm$core$Maybe$Just('https://endoflife.date/python');
		case 3:
			return $elm$core$Maybe$Just('https://endoflife.date/ruby');
		case 0:
			return $elm$core$Maybe$Just('https://endoflife.date/perl');
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Views$LanguageVersionWarning$longMessage = F2(
	function (_v0, kind) {
		var content = function () {
			switch (kind.$) {
				case 3:
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('ActiveState’s extended support offers our '),
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('secure and exclusive Python 2.7.18.x')
										])),
									$elm$html$Html$text(' builds which include security patches addressing vulnerabilities identified in the core Python 2 release. Vulnerabilities have also been addressed in 3rd party packages, reducing the risks to your software and organization from known exploits.')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Contact us to learn more about our secure and exclusive patched versions of Python 2.7.18.x and more!')
								]))
						]);
				case 0:
					var language = kind.a;
					var eolDate = $author$project$Model$LanguageVersionTrustLevel$endOfLifeDatesUrl(language);
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('End of Life versions are vulnerable to exploits which can put your software at risk.'),
									A2(
									$author$project$Misc$displayMaybe,
									function (date) {
										return A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(' For more information see '),
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$href(date)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Model$Language$toDisplayString(language) + ' End of Life Dates')
														])),
													$elm$html$Html$text('.')
												]));
									},
									eolDate)
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									'ActiveState’s support and maintenance are only applicable to languages under community support, managed distributions, or our exclusive extended support offerings. We recommend using a newer version of ' + ($author$project$Model$Language$toDisplayString(language) + ' from our catalog.'))
								])),
							A2(
							$author$project$Misc$displayIf,
							language === 1,
							A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Contact us to learn more about our secure and exclusive patched End of Life Python versions and more!')
									])))
						]);
				case 1:
					var recommendedVersion = kind.b;
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Configure your runtime to use version '),
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Model$VersionString$toString(recommendedVersion))
										])),
									$elm$html$Html$text(' for better build success.')
								]))
						]);
				case 2:
					var language = kind.a;
					var recommendedVersion = kind.b;
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Configure your runtime to use version '),
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Model$VersionString$toString(recommendedVersion))
										])),
									$elm$html$Html$text(' for better performance, build success, and fewer vulnerabilities.')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									'If you need support for this or other extended versions of ' + ($author$project$Model$Language$toDisplayString(language) + ', ')),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href('https://www.activestate.com/solutions/contact-sales/')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('reach out to our team of experts.')
										]))
								]))
						]);
				default:
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('You may experience sub optimal performance with this language as it is not fully supported by ActiveState yet.')
								]))
						]);
			}
		}();
		return A2($elm$html$Html$div, _List_Nil, content);
	});
var $author$project$Views$LanguageVersionWarning$warning = function (kind) {
	return A2(
		$elm$html$Html$h4,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				function () {
					switch (kind.$) {
						case 0:
							var language = kind.a;
							return 'Warning — This version of ' + ($author$project$Model$Language$toDisplayString(language) + ' is no longer maintained by the community.');
						case 1:
							var language = kind.a;
							return 'Warning — This is not our recommended version of ' + ($author$project$Model$Language$toDisplayString(language) + '.');
						case 3:
							return 'Warning — This version of Python is not secure and no longer maintained by the community.';
						case 2:
							var language = kind.a;
							return 'A newer version of ' + ($author$project$Model$Language$toDisplayString(language) + ' is now available!');
						default:
							return 'This language is not currently supported by ActiveState.';
					}
				}())
			]));
};
var $author$project$Views$LanguageVersionWarning$createProjectBoxInternal = F3(
	function (extraClass, tier, kind) {
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('top-stripe shadow extra-padding version-warning ' + extraClass),
				$author$project$Views$LanguageVersionWarning$kindAttributes(kind)),
			_List_fromArray(
				[
					$author$project$Views$LanguageVersionWarning$warning(kind),
					A2($author$project$Views$LanguageVersionWarning$longMessage, tier, kind),
					$author$project$Views$LanguageVersionWarning$actionButton(
					{qu: false, qW: true, mp: kind, r$: 0})
				]));
	});
var $author$project$Views$LanguageVersionWarning$createProjectBoxAlone = function (tier) {
	return A2($author$project$Views$LanguageVersionWarning$createProjectBoxInternal, 'top-margin', tier);
};
var $author$project$Misc$sequenceMaybe = $elm_community$basics_extra$Basics$Extra$uncurry(
	$elm$core$Maybe$map2($elm$core$Tuple$pair));
var $author$project$Views$LanguageVersionWarning$fromLanguageVersions = function (versions) {
	var maybeLanguage = $author$project$Model$LanguageVersions$getMaybeLanguage(versions);
	return $author$project$Misc$sequenceMaybe(
		A2(
			$elm$core$Tuple$pair,
			maybeLanguage,
			$author$project$Model$VersionString$toVersion(
				$author$project$Model$LanguageVersions$getSelected(versions))));
};
var $author$project$Views$LanguageVersionWarning$Python27Upsell = {$: 3};
var $author$project$Views$LanguageVersionWarning$canShowPython2 = function (_v0) {
	var org = _v0.pd;
	var hasCommunityPython2 = _v0.CK;
	return (!$author$project$Model$Permissions$orgCanAccessASPatchedPython27(org)) && (hasCommunityPython2 && function () {
		var _v1 = $author$project$Model$Tier$stringToSimpleTier(org.dc);
		switch (_v1.$) {
			case 5:
				return false;
			case 6:
				return false;
			default:
				return true;
		}
	}());
};
var $author$project$Views$LanguageVersionWarning$init = function (args) {
	return (args.CK && $author$project$Views$LanguageVersionWarning$canShowPython2(args)) ? $elm$core$Maybe$Just($author$project$Views$LanguageVersionWarning$Python27Upsell) : A2($author$project$Views$LanguageVersionWarning$warningKind, args.BB, args.aM);
};
var $author$project$Model$VersionPredicates$Python$isCommunityVersion2 = A2(
	$elm$core$Basics$composeR,
	$author$project$Model$VersionString$parse,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Result$map(
			function (v) {
				return (v.y5 === 2) && _Utils_eq(v.A_, $elm$core$Maybe$Nothing);
			}),
		$elm$core$Result$withDefault(false)));
var $author$project$Model$LanguageVersions$isCommunityPython2xSelected = function (_v0) {
	var contents = _v0;
	return (contents.w === 'python') && $author$project$Model$VersionPredicates$Python$isCommunityVersion2(contents.jw);
};
var $author$project$Pages$CreateProject$languagesCta = function (model) {
	var tier = $author$project$Model$Tier$stringToSimpleTier(model.c3.dc);
	var selectedLanguage = $elm$core$List$head(model.fg);
	var isCommunityVersion = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Model$LanguageVersions$getSelected,
				A2($elm$core$Basics$composeR, $author$project$Model$VersionString$isASPatched, $elm$core$Basics$not)),
			selectedLanguage));
	var isCommunityPython2 = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2($elm$core$Maybe$map, $author$project$Model$LanguageVersions$isCommunityPython2xSelected, selectedLanguage));
	var languageVersionWarningView = A2(
		$author$project$Misc$displayMaybe,
		function (kind) {
			return A2($author$project$Views$LanguageVersionWarning$createProjectBoxAlone, tier, kind);
		},
		$author$project$Views$LanguageVersionWarning$init(
			{
				BB: $elm$core$Maybe$Nothing,
				CK: isCommunityPython2,
				CL: isCommunityVersion,
				aM: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						$elm$core$List$singleton,
						A2($elm$core$Maybe$andThen, $author$project$Views$LanguageVersionWarning$fromLanguageVersions, selectedLanguage))),
				pd: model.c3
			}));
	return _List_fromArray(
		[languageVersionWarningView]);
};
var $author$project$Model$LanguageVersions$sort = $elm$core$List$sortBy(
	function (_v0) {
		var name = _v0.w;
		return ($elm$core$String$toLower(name) === 'python') ? 0 : 1;
	});
var $author$project$Views$TeamTier$tag = function (_v0) {
	var txt = _v0.sF;
	var isActive = _v0.re;
	var idClass = _v0.rb;
	var tagKind = _v0.sA;
	var _v1 = function () {
		var popup = tagKind.rY;
		var onMouseOverMsg = tagKind.rI;
		var onMouseOutMsg = tagKind.rH;
		return _Utils_Tuple3(
			_List_fromArray(
				[
					$elm$html$Html$Events$onMouseOver(
					onMouseOverMsg(idClass)),
					$elm$html$Html$Events$onMouseOut(onMouseOutMsg)
				]),
			popup,
			false);
	}();
	var eventHandlers = _v1.a;
	var popUp = _v1.b;
	var isClickable = _v1.c;
	return A2(
		$elm$html$Html$div,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('upgrade-info'),
					$elm$html$Html$Attributes$class(idClass)
				]),
			eventHandlers),
		A3(
			$author$project$Misc$concatIf,
			isActive,
			popUp,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('upgrade-tooltip-button', true),
									_Utils_Tuple2(idClass, true),
									_Utils_Tuple2('active', isActive),
									_Utils_Tuple2('clickable', isClickable)
								])),
							$elm$html$Html$Attributes$type_('button')
						]),
					_List_fromArray(
						[
							$author$project$Views$Icon$view(
							A2(
								$author$project$Views$Icon$square,
								19,
								$author$project$Views$Icon$icon(35))),
							$elm$html$Html$text(' ' + txt)
						]))
				])));
};
var $author$project$Views$TeamTier$tagPopup = function (_v0) {
	var headerText = _v0.q7;
	var subText = _v0.sv;
	var heapID = _v0.q8;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('upgrade-cta'),
				$elm$html$Html$Attributes$id(heapID)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h4,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(headerText)
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(subText)
					])),
				$author$project$Views$TeamTier$teamTierRequestUpgradeButton
			]));
};
var $author$project$Pages$CreateProject$tclUnavailableNote = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('top-stripe shadow extra-padding version-note ')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$h4,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Note—Configurable Tcl projects are temporarily unavailable!')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('We are performing some system upgrades that make built-on-demand versions of Tcl. In the meantime, you can download the community edition of ActiveTcl 8.6, available below for Windows & Linux.')
				])),
			A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('primary-button'),
					$elm$html$Html$Attributes$href('/ActiveState/ActiveTcl-8.6')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Download ActiveTcl 8.6')
				]))
		]));
var $elm$html$Html$textarea = _VirtualDom_node('textarea');
var $author$project$Model$LanguageVersions$versionFlags = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		$author$project$Misc$with(
			$elm$core$Set$fromList(
				_List_fromArray(
					['recommended']))),
		$elm$core$Dict$toList($author$project$Model$LanguageVersions$recommendedVersions)));
var $author$project$Model$LanguageVersions$checkVersionFlag = F3(
	function (language, version, flagName) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Set$member(flagName),
				A2(
					$elm$core$Dict$get,
					_Utils_Tuple2(language, version),
					$author$project$Model$LanguageVersions$versionFlags)));
	});
var $author$project$Views$LanguageSelectorSimple$languageVersion = F3(
	function (accessModel, chooseVersion, languageVersions) {
		var viewVersion = function (version) {
			var isShownOnlyToSuperusers = A3($author$project$Model$LanguageVersions$isShownOnlyToSuperusers, accessModel, languageVersions, version);
			var isRecommended = A3(
				$author$project$Model$LanguageVersions$checkVersionFlag,
				$author$project$Model$LanguageVersions$getName(languageVersions),
				version,
				'recommended');
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						A2(chooseVersion, languageVersions, version)),
						$elm$html$Html$Attributes$class('option'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'selected',
								_Utils_eq(
									$author$project$Model$LanguageVersions$getSelected(languageVersions),
									version)),
								_Utils_Tuple2('recommended', isRecommended),
								_Utils_Tuple2('superuser-only', isShownOnlyToSuperusers)
							]))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(version),
						A2(
						$author$project$Misc$displayIf,
						isRecommended,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('recommended-version')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Recommended')
								])))
					]));
		};
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$elm$core$List$map,
						viewVersion,
						A2($author$project$Model$LanguageVersions$getVersions, accessModel, languageVersions))),
					A2(
					$author$project$Misc$displayIf,
					accessModel.oS,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('new-box superuser-only additional-versions-info')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Additional versions are accessible to regular users via add-ons.')
									]))
							])))
				]));
	});
var $author$project$Views$LanguageSelectorSimple$view = function (_v0) {
	var accessModel = _v0.AY;
	var chooseVersion = _v0.BC;
	var selectedLanguages = _v0.fg;
	var languages = _v0.aM;
	var languageVersionList = A2(
		$elm$core$List$map,
		A2($author$project$Views$LanguageSelectorSimple$languageVersion, accessModel, chooseVersion),
		A2(
			$elm$core$List$filter,
			function (l) {
				return A2(
					$elm$core$List$any,
					$author$project$Model$LanguageVersions$matches(l),
					languages);
			},
			selectedLanguages));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('language-version-selector'),
				$elm$html$Html$Attributes$class(
				$author$project$Views$LanguageSelectorSimple$languageName(selectedLanguages))
			]),
		languageVersionList);
};
var $author$project$Views$PlatformSelectorSimple$listDistros = F2(
	function (isSuperUserWithFeaturesVisible, name) {
		var superFilterer = isSuperUserWithFeaturesVisible ? $elm$core$Basics$always(true) : function ($) {
			return $.F;
		};
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (distroToVersions) {
					return A2(
						$elm$core$List$filter,
						superFilterer,
						A2(
							$elm$core$List$map,
							function (_v0) {
								var distro = _v0.a;
								var versions = _v0.b;
								return {
									w: distro,
									F: A2(
										$elm$core$List$any,
										function ($) {
											return $.F;
										},
										$elm$core$Dict$values(versions))
								};
							},
							$elm$core$Dict$toList(distroToVersions)));
				},
				A2(
					$elm$core$Dict$get,
					$author$project$Views$PlatformSelectorSimple$platformNameToString(name),
					$author$project$Views$PlatformSelectorSimple$choices)));
	});
var $author$project$Views$PlatformSelectorSimple$listVersions = F3(
	function (isSuperUserWithFeaturesVisible, name, distro) {
		var superFilterer = isSuperUserWithFeaturesVisible ? $elm$core$Basics$always(true) : A2(
			$elm$core$Basics$composeR,
			$elm$core$Tuple$second,
			function ($) {
				return $.F;
			});
		return A2(
			$elm$core$List$map,
			function (_v0) {
				var version = _v0.a;
				var record = _v0.b;
				return {w: version, F: record.F};
			},
			A2(
				$elm$core$List$sortBy,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$second,
					function ($) {
						return $.vD;
					}),
				A2(
					$elm$core$List$filter,
					superFilterer,
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							$elm$core$Dict$toList,
							A2(
								$elm$core$Maybe$andThen,
								$elm$core$Dict$get(distro),
								A2(
									$elm$core$Dict$get,
									$author$project$Views$PlatformSelectorSimple$platformNameToString(name),
									$author$project$Views$PlatformSelectorSimple$choices)))))));
	});
var $author$project$Views$Superuser$suffix = ' 😎';
var $author$project$Views$BetaAlert$view = function (content) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('row')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('beta-notifier')
					]),
				_List_fromArray(
					[
						$author$project$Views$Icon$view(
						A2(
							$author$project$Views$Icon$square,
							20,
							A2(
								$author$project$Views$Icon$colored,
								A3($avh4$elm_color$Color$rgb255, 42, 77, 192),
								$author$project$Views$Icon$icon(27)))),
						$elm$html$Html$text('Beta'),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('more-info-tooltip')
							]),
						_List_fromArray(
							[
								$author$project$Views$Icon$view(
								A2(
									$author$project$Views$Icon$square,
									20,
									A2(
										$author$project$Views$Icon$colored,
										A3($avh4$elm_color$Color$rgb255, 42, 77, 192),
										$author$project$Views$Icon$icon(52)))),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('content')
									]),
								_List_fromArray(
									[content]))
							]))
					]))
			]));
};
var $author$project$Views$PlatformSelectorSimple$platformView = F2(
	function (config, _v0) {
		var name = _v0.a;
		var distribution = _v0.b;
		var version = _v0.c;
		var isSelected = _v0.d;
		var wrapOption = F2(
			function (current, permissioned) {
				var suffix = permissioned.F ? '' : $author$project$Views$Superuser$suffix;
				return A2(
					$elm$html$Html$option,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$selected(
							_Utils_eq(current, permissioned.w)),
							$elm$html$Html$Attributes$value(permissioned.w)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							_Utils_ap(permissioned.w, suffix))
						]));
			});
		var onSelectVersion = function (newVersion) {
			return config.GS(
				A4($author$project$Views$PlatformSelectorSimple$PlatformChoice, name, distribution, newVersion, isSelected));
		};
		var onSelectDistribution = function (distro) {
			var newVersion = A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.w;
					},
					$elm$core$List$head(
						A3($author$project$Views$PlatformSelectorSimple$listVersions, config.oS, name, distro))));
			return config.GS(
				A4($author$project$Views$PlatformSelectorSimple$PlatformChoice, name, distro, newVersion, isSelected));
		};
		var noClickSelect = F2(
			function (attrs, html) {
				return A2(
					$elm$html$Html$select,
					_Utils_ap(
						attrs,
						_List_fromArray(
							[
								$author$project$Misc$onClickNoBubble(config.Ci),
								A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Select operating system version')
							])),
					html);
			});
		var macAvailable = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Model$LanguageVersions$isMacAllowed, config.DR));
		var isNotSelected = !isSelected;
		var disabledPlatform = (name === 2) && (!macAvailable);
		var constraintSuffix = function (constraint) {
			if (constraint.$ === 1) {
				var versionStr = constraint.a;
				return ' ' + versionStr;
			} else {
				return '';
			}
		};
		var _v1 = function () {
			var _v2 = config.DR;
			if (!_v2.$) {
				var _v3 = _v2.a;
				var language = _v3.a;
				var languageVersion = _v3.b;
				var langName = $author$project$Model$Language$toString(language);
				return _Utils_Tuple2(
					langName,
					_Utils_ap(
						langName,
						constraintSuffix(languageVersion)));
			} else {
				return _Utils_Tuple2('', '');
			}
		}();
		var languageName = _v1.a;
		var languageAndVersion = _v1.b;
		var versionSelectionUI = function () {
			var inputType = config.E0 ? 'radio' : 'checkbox';
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_(inputType),
							$elm$html$Html$Attributes$checked(isSelected),
							$elm$html$Html$Attributes$disabled(disabledPlatform)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('name')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Views$PlatformSelectorSimple$platformNameToString(name))
						])),
					A2(
					$author$project$Misc$displayIf,
					name === 1,
					A2(
						noClickSelect,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(onSelectDistribution),
								$elm$html$Html$Attributes$disabled(isNotSelected)
							]),
						A2(
							$elm$core$List$map,
							wrapOption(distribution),
							A2($author$project$Views$PlatformSelectorSimple$listDistros, config.oS, name)))),
					A2(
					noClickSelect,
					_List_fromArray(
						[
							$elm$html$Html$Events$onInput(onSelectVersion),
							$elm$html$Html$Attributes$disabled(isNotSelected)
						]),
					A2(
						$elm$core$List$map,
						wrapOption(version),
						A3($author$project$Views$PlatformSelectorSimple$listVersions, config.oS, name, distribution))),
					A2(
					$author$project$Misc$displayIf,
					((name === 2) && (languageName === 'python')) || ((name === 2) && (languageName === 'perl')),
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Views$BetaAlert$view(
								$elm$html$Html$text('MacOS support is for Intel-based hardware only (M1 macs will run with Rosetta). You may experience lengthy build times. Currently there is limited package support but it is improving daily. If something is not building, contact support!'))
							])))
				]);
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('option'),
							$elm$html$Html$Events$onClick(
							disabledPlatform ? config.Ci : config.GS(
								A4($author$project$Views$PlatformSelectorSimple$PlatformChoice, name, distribution, version, !isSelected))),
							$elm$html$Html$Attributes$class(
							$author$project$Views$PlatformSelectorSimple$platformNameToString(name)),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('selected', isSelected),
									_Utils_Tuple2('disabled-option', disabledPlatform)
								]))
						]),
					versionSelectionUI),
					A2(
					$author$project$Misc$displayIf,
					disabledPlatform,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('disabled-explanation')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('language-name'),
										$elm$html$Html$Attributes$class(languageName)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(languageAndVersion)
									])),
								$elm$html$Html$text(' runtimes are not yet available for MacOS.')
							])))
				]));
	});
var $author$project$Views$PlatformSelectorSimple$view = F2(
	function (config, _v0) {
		var selection = _v0;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('platform-selector-simple')
				]),
			_List_fromArray(
				[
					A2($author$project$Views$PlatformSelectorSimple$platformView, config, selection.hz),
					A2($author$project$Views$PlatformSelectorSimple$platformView, config, selection.hZ),
					A2($author$project$Views$PlatformSelectorSimple$platformView, config, selection.gq)
				]));
	});
var $author$project$Pages$CreateProject$SwitchVisibility = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$CreateProject$visibilityOption = F7(
	function (isDisabled, classString, isChecked, msgOnClick, optionName, optionDescription, optionIcon) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('option ' + classString),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('selected', isChecked)
						])),
					$elm$html$Html$Events$onClick(msgOnClick)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('radio'),
							$elm$html$Html$Attributes$id(optionName),
							$elm$html$Html$Attributes$checked(isChecked),
							$elm$html$Html$Attributes$disabled(isDisabled)
						]),
					_List_Nil),
					$author$project$Views$Icon$view(
					$author$project$Views$Icon$icon(optionIcon)),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$for(optionName)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('option-name')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(optionName)
										]))
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('option-description')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(optionDescription)
								]))
						]))
				]));
	});
var $author$project$Pages$CreateProject$disabledVisibilityOption = function (_v0) {
	var className = _v0.BD;
	var optionName = _v0.kk;
	var description = _v0.bP;
	var icon = _v0.cV;
	return A7($author$project$Pages$CreateProject$visibilityOption, true, className + ' disabled-option', false, $author$project$Pages$CreateProject$NoOp, optionName, description, icon);
};
var $author$project$Pages$CreateProject$visibilitySelector = F2(
	function (privateProjectsEnabled, visibility) {
		var publicCopy = 'Only members of this organization can modify it, but any user of the ActiveState Platform can view and install this runtime.';
		var privateCopy = 'Only members of this organization can modify, view and install this runtime.';
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('visibility-selector-wrapper')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('visibility-selector-new')
						]),
					_List_fromArray(
						[
							A7(
							$author$project$Pages$CreateProject$visibilityOption,
							false,
							'public',
							visibility === 1,
							$author$project$Pages$CreateProject$SwitchVisibility(1),
							'Public',
							publicCopy,
							45),
							privateProjectsEnabled ? A7(
							$author$project$Pages$CreateProject$visibilityOption,
							false,
							'private',
							!visibility,
							$author$project$Pages$CreateProject$SwitchVisibility(0),
							'Private',
							privateCopy,
							44) : $author$project$Pages$CreateProject$disabledVisibilityOption(
							{BD: 'private', bP: privateCopy, cV: 44, kk: 'Private'})
						]))
				]));
	});
var $author$project$Pages$CreateProject$view = F2(
	function (model, session) {
		var projectNameReformatted = A2(
			$elm_community$maybe_extra$Maybe$Extra$filter,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$Just,
				$elm$core$Basics$neq(model.vT)),
			A2($elm$core$Maybe$map, $author$project$Validation$formatProjectName, model.vT));
		var nameError = A2($elm$core$Maybe$withDefault, '', model.pt);
		var languagesWithBundles = _List_fromArray(
			['perl', 'ruby']);
		var languageName = $author$project$Views$LanguageSelectorSimple$languageName(model.fg);
		var isSuperUserWithFeaturesVisible = $author$project$Model$Session$isSuperUserWithFeaturesVisible(session);
		var isNewUserFlow = model.jc;
		var isLanguageWithBundle = A2(
			$elm$core$List$any,
			function (l) {
				return A2(
					$elm$core$List$member,
					$author$project$Model$LanguageVersions$getName(l),
					languagesWithBundles);
			},
			model.fg);
		var isLanguageSelected = !$elm$core$List$isEmpty(model.fg);
		var isGithubLinked = $author$project$Model$Session$isGithubLinked(session);
		var newUserIntro = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('intro', true),
							_Utils_Tuple2('new-user-intro', true),
							_Utils_Tuple2('with-separator', !isGithubLinked)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Create your first Python, Perl, Ruby or Tcl project. Your project only contains the dependencies of your runtime and does not include any first-party code.'),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('more-info-tooltip')
								]),
							_List_fromArray(
								[
									$author$project$Views$Icon$view(
									$author$project$Views$Icon$icon(52)),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('content')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('A runtime is an easy-to-install virtual environment with the language and packages you need.')
										]))
								]))
						]))
				]));
		var regularIntro = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('intro', true),
							_Utils_Tuple2('with-separator', !isGithubLinked)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Creating a project sets up a new language runtime. Once it\'s created, you can install packages via the Web UI or on the command line with the State Tool. Your project only contains the dependencies of your runtime and does not include any first-party code.')
						]))
				]));
		var importProjectBanner = A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('import-project-banner')
						]),
					_List_fromArray(
						[
							$author$project$Views$Icon$view(
							$author$project$Views$Icon$icon(31)),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Do you have a project on GitHub?')
										])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('We can scan the repository and build a project runtime that includes all the required dependencies. Your project only contains the dependencies of your runtime and does not include any first-party code.')
										]))
								])),
							A3(
							$author$project$Views$Link$link,
							$author$project$Model$Route$Protected(
								$author$project$Model$Route$ImportProject(
									{
										ix: $elm$core$Maybe$Just(
											$author$project$Model$Organization$getUrlName(model.c3))
									})),
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('primary-button'),
									$elm$html$Html$Attributes$href('/import-project')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Scan a Repository'),
									$author$project$Views$Icon$view(
									$author$project$Views$Icon$icon(3))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('or-line')
						]),
					_List_fromArray(
						[
							A2($elm$html$Html$hr, _List_Nil, _List_Nil),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('or')
								]))
						]))
				]));
		var hasNameError = nameError !== '';
		var containsTcl = A2(
			$elm$core$List$any,
			function (language) {
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						function (ml) {
							return ml === 2;
						},
						$author$project$Model$LanguageVersions$getMaybeLanguage(language)));
			},
			model.fg);
		var tclBlocked = containsTcl && $author$project$Model$Organization$isFreeTier(model.c3);
		var canCreateProject = A2(
			$author$project$Model$Permissions$canEditProjects,
			$author$project$Model$Organization$getUrlName(model.c3),
			$author$project$Model$Session$getUser(session));
		var accessModel = A2($author$project$Model$LanguageVersions$createAccessModel, session, model.c3);
		var prunedLanguages = A2($author$project$Model$LanguageVersions$prune, accessModel, model.wS);
		var editorLanguages = $author$project$Model$LanguageVersions$sort(prunedLanguages);
		return $elm_community$maybe_extra$Maybe$Extra$isJust(model.A9) ? A2(
			$elm$html$Html$main_,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('')
				])) : A2(
			$elm$html$Html$main_,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Misc$displayIf, isGithubLinked, importProjectBanner),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('create-project-form'),
							$elm$html$Html$Attributes$class('form')
						]),
					_List_fromArray(
						[
							isNewUserFlow ? newUserIntro : regularIntro,
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('field-section')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h3,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Select an Organization')
												])),
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('field-info')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('All members will have access to this project.')
												])),
											$author$project$Views$OrgSelector$orgSelector(
											{
												B5: $author$project$Model$Organization$getUrlName(model.c3),
												Dq: A2(
													$author$project$Model$Session$isMember,
													$author$project$Model$Organization$getUrlName(model.c3),
													session),
												Du: $author$project$Model$Session$getOrgDropdownOpen(session),
												EO: $author$project$Pages$CreateProject$OrgDropdownItemSelected,
												EW: $author$project$Pages$CreateProject$ToggleOrgDropDown,
												EZ: '',
												rJ: function () {
													var _v0 = $author$project$Model$Session$getUser(session);
													if (!_v0.$) {
														var user = _v0.a;
														return A2(
															$elm$core$List$sortBy,
															A2(
																$elm$core$Basics$composeR,
																function ($) {
																	return $.AC;
																},
																$elm$core$String$toLower),
															user.mX);
													} else {
														return _List_Nil;
													}
												}()
											})
										])),
									canCreateProject ? A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('field-section')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h3,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Select a language')
												])),
											A3($author$project$Pages$CreateProject$languageSelector, accessModel, model.fg, editorLanguages)
										])) : A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('permission-note')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Oops—you can\'t create a project here!')
												])),
											$elm$html$Html$text('You don\'t have permission to create projects in this organization. Contact one of the Admins of this organization for more information or select another organization.')
										]))
								])),
							A2(
							$author$project$Misc$displayIf,
							isLanguageSelected && (canCreateProject && (!tclBlocked)),
							A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('field-section')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_Nil,
												_Utils_ap(
													_List_fromArray(
														[
															$author$project$Views$LanguageSelectorSimple$header(languageName),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('language-versions')
																]),
															_List_fromArray(
																[
																	$author$project$Views$LanguageSelectorSimple$view(
																	{AY: accessModel, BC: $author$project$Pages$CreateProject$ChooseVersion, aM: editorLanguages, fg: model.fg}),
																	A2(
																	$author$project$Misc$displayIf,
																	_Utils_eq(
																		$author$project$Model$Tier$stringToSimpleTier(model.c3.dc),
																		$author$project$Model$Tier$Free),
																	$author$project$Views$TeamTier$tag(
																		{
																			rb: 'other-versions',
																			re: _Utils_eq(
																				model.hT,
																				$elm$core$Maybe$Just('other-versions')),
																			sA: {
																				rH: $author$project$Pages$CreateProject$TeamTierTagHoverEnd,
																				rI: $author$project$Pages$CreateProject$TeamTierTagHoverStart,
																				rY: $author$project$Views$TeamTier$tagPopup(
																					{q7: 'Upgrade to access our expanded version catalog', q8: 'heap-other-versions', sv: 'You also gain access our powerful suite of open source management features.'})
																			},
																			sF: 'Need other versions?'
																		}))
																]))
														]),
													$author$project$Pages$CreateProject$languagesCta(model)))
											])),
										A2(
										$author$project$Misc$displayIf,
										isLanguageWithBundle && (!model.jc),
										$author$project$Pages$CreateProject$bundlesView(model)),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('field-section'),
												$elm$html$Html$Attributes$id('platform-selector'),
												$elm$html$Html$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2('error', model.m1)
													]))
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('os-title')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$h3,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('Choose operating systems')
																	])),
																A2(
																$elm$html$Html$p,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('field-info')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('We\'ll build a runtime from source for each selected operating system.')
																	]))
															])),
														A2(
														$author$project$Misc$displayIf,
														!$author$project$Model$Permissions$orgHasUnlimitedOSAddon(model.c3),
														$author$project$Views$TeamTier$tag(
															{
																rb: 'multi-os',
																re: _Utils_eq(
																	model.hT,
																	$elm$core$Maybe$Just('multi-os')),
																sA: {
																	rH: $author$project$Pages$CreateProject$TeamTierTagHoverEnd,
																	rI: $author$project$Pages$CreateProject$TeamTierTagHoverStart,
																	rY: $author$project$Views$TeamTier$tagPopup(
																		{q7: 'Upgrade to build runtimes for multiple operating systems', q8: 'heap-multiOS', sv: 'You also gain access to Secure Binaries which reduce the risks associated with using open source packages.'})
																},
																sF: 'Creating a multi-OS project?'
															}))
													])),
												A2(
												$author$project$Views$PlatformSelectorSimple$view,
												{
													Ci: $author$project$Pages$CreateProject$NoOp,
													oS: isSuperUserWithFeaturesVisible,
													DR: $author$project$Model$LanguageVersions$selectedLanguageAndVersion(model.fg),
													E0: !$author$project$Model$Permissions$orgHasUnlimitedOSAddon(model.c3),
													GS: $author$project$Pages$CreateProject$UpdatePlatformChoice
												},
												model.hK),
												A2(
												$author$project$Misc$displayIf,
												model.m1,
												$author$project$Pages$CreateProject$fieldError('Please select an operating system.'))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('field-section hidden-section')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$label,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$h4,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Description'),
																A2(
																$elm$html$Html$span,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('optional-indicator')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('(Optional)')
																	]))
															])),
														A2(
														$elm$html$Html$p,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('field-info')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('What will this runtime be used for?')
															]))
													])),
												A2(
												$elm$html$Html$textarea,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$maxlength(160),
														$elm$html$Html$Events$onInput($author$project$Pages$CreateProject$NewDescription)
													]),
												_List_Nil)
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('field-section')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('os-title')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$h3,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('single-title')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Project access')
															])),
														A2(
														$author$project$Misc$displayIf,
														!$author$project$Model$Permissions$orgCanCreatePrivateProject(model.c3),
														$author$project$Views$TeamTier$tag(
															{
																rb: 'project-visibility',
																re: _Utils_eq(
																	model.hT,
																	$elm$core$Maybe$Just('project-visibility')),
																sA: {
																	rH: $author$project$Pages$CreateProject$TeamTierTagHoverEnd,
																	rI: $author$project$Pages$CreateProject$TeamTierTagHoverStart,
																	rY: $author$project$Views$TeamTier$tagPopup(
																		{q7: 'Upgrade to create private projects', q8: 'heap-privacy', sv: 'You also gain access our powerful suite of open source management features.'})
																},
																sF: 'Working on something sensitive?'
															}))
													])),
												A2(
												$author$project$Pages$CreateProject$visibilitySelector,
												$author$project$Model$Permissions$orgCanCreatePrivateProject(model.c3),
												model.p9)
											])),
										A2(
										$author$project$Misc$displayIf,
										$author$project$Model$Language$supportsInstaller(languageName),
										A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('field-section')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('os-title')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$h3,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Additional deployment methods')
																		])),
																	A2(
																	$elm$html$Html$p,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('field-info')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('By default, all runtimes can be deployed via CLI using the State Tool.')
																		]))
																])),
															A2(
															$author$project$Misc$displayIf,
															!$author$project$Model$Permissions$orgHasUnlimitedOSAddon(model.c3),
															$author$project$Views$TeamTier$tag(
																{
																	rb: 'additional-installers',
																	re: _Utils_eq(
																		model.hT,
																		$elm$core$Maybe$Just('additional-installers')),
																	sA: {
																		rH: $author$project$Pages$CreateProject$TeamTierTagHoverEnd,
																		rI: $author$project$Pages$CreateProject$TeamTierTagHoverStart,
																		rY: $author$project$Views$TeamTier$tagPopup(
																			{q7: 'Upgrade to access downloadable, offline installers', q8: 'heap-additional-installers', sv: 'You also gain access our powerful suite of open source management features.'})
																	},
																	sF: 'Need downloadable installers?'
																}))
														])),
													$author$project$Pages$CreateProject$installersSelector(model)
												]))),
										A2(
										$author$project$Misc$displayIf,
										model.sn,
										A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('field-section'),
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2('error', hasNameError)
														]))
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$label,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$h3,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Name your project')
																])),
															A2(
															$elm$html$Html$p,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('field-info')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('We picked a name for you, but you can change it. It will also act as the URL.')
																])),
															A2(
															$elm$html$Html$input,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$placeholder('Ex. \"machine-learning-runtime\"'),
																	$elm$html$Html$Attributes$id('project-name'),
																	$elm$html$Html$Attributes$type_('text'),
																	$elm$html$Html$Events$onInput($author$project$Pages$CreateProject$NewProjectName),
																	$elm$html$Html$Attributes$spellcheck(false),
																	$elm$html$Html$Attributes$maxlength($author$project$Validation$maxProjectNameLength),
																	$elm$html$Html$Attributes$value(
																	$author$project$Pages$CreateProject$getProjectNameOrGenerated(model)),
																	A2($elm$html$Html$Attributes$attribute, 'data-cy', 'type-project-name')
																]),
															_List_Nil)
														])),
													hasNameError ? $author$project$Pages$CreateProject$fieldError(nameError) : A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('project-url-indicator')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Will be accessible at '),
															A2(
															$elm$html$Html$strong,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$span,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(model.t0 + '/')
																		])),
																	A2(
																	$elm$html$Html$span,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Model$Organization$getUrlName(model.c3) + '/')
																		])),
																	A2(
																	$elm$html$Html$span,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			A2(
																				$elm$core$Maybe$withDefault,
																				$author$project$Pages$CreateProject$getProjectNameOrGenerated(model),
																				projectNameReformatted))
																		]))
																]))
														]))
												]))),
										$author$project$Views$NotificationsInline$view(model),
										A2(
										$elm$html$Html$h3,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('single-title')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('What would you like to do next?')
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('next-step-cards')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('next-step-card')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[
																$author$project$Views$Icon$view(
																$author$project$Views$Icon$icon(58)),
																A2(
																$elm$html$Html$h4,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('heading')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Add packages before installing '),
																		A2(
																		$elm$html$Html$span,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('language-name')
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text(languageName)
																			]))
																	])),
																A2(
																$elm$html$Html$p,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('We\'ll build the packages from source and they\'ll be included when you install '),
																		A2(
																		$elm$html$Html$span,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('language-name')
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text(languageName)
																			])),
																		$elm$html$Html$text('.')
																	]))
															])),
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('add-packages-options')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('add-packages-option')
																	]),
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$div,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('next-step-buttons')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$elm$html$Html$button,
																				_List_fromArray(
																					[
																						$elm$html$Html$Attributes$disabled(model.jV),
																						$elm$html$Html$Attributes$class('primary-button'),
																						$elm$html$Html$Events$onClick(
																						$author$project$Pages$CreateProject$CreateProject(1))
																					]),
																				_List_fromArray(
																					[
																						$elm$html$Html$text('Add Packages')
																					]))
																			]))
																	]))
															]))
													])),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('next-step-card install-language-card')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$h4,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('heading')
															]),
														_List_fromArray(
															[
																$author$project$Views$Icon$view(
																$author$project$Views$Icon$icon(21)),
																$elm$html$Html$text('Start using '),
																A2(
																$elm$html$Html$span,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('language-name')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(languageName)
																	]))
															])),
														A2(
														$elm$html$Html$p,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Install '),
																A2(
																$elm$html$Html$span,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('language-name')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(languageName)
																	])),
																$elm$html$Html$text(' now and install packages later on the command line using the State Tool.')
															])),
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('next-step-buttons')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$button,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$disabled(model.jV),
																		$elm$html$Html$Attributes$class('secondary-button'),
																		A2($elm$html$Html$Attributes$attribute, 'data-cy', 'create-project'),
																		$elm$html$Html$Events$onClick(
																		$author$project$Pages$CreateProject$CreateProject(0))
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Finish & Install '),
																		A2(
																		$elm$html$Html$span,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('language-name')
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text(languageName)
																			]))
																	]))
															]))
													]))
											])),
										A2(
										$author$project$Misc$displayIf,
										!isNewUserFlow,
										A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('cancel-button-wrapper')
												]),
											_List_fromArray(
												[$author$project$Pages$CreateProject$cancelButton])))
									]))),
							A2($author$project$Misc$displayIf, tclBlocked, $author$project$Pages$CreateProject$tclUnavailableNote)
						]))
				]));
	});
var $author$project$Pages$CreateProjectFromCommit$view = $author$project$Pages$Loading$view;
var $author$project$Pages$Error$view = function (error) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('error-modal')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('content')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Something went wrong!')
							])),
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Here\'s what happened...')
							])),
						A2(
						$elm$html$Html$ul,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(error)
									]))
							])),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href('/'),
								$elm$html$Html$Attributes$class('primary-button reload')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Refresh')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('If this keeps happening, please contact us at '),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href('mailto:support@activestate.com'),
										$elm$html$Html$Attributes$target('_blank')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('support@activestate.com')
									])),
								$elm$html$Html$text('.')
							]))
					]))
			]));
};
var $author$project$Pages$FinishSetup$OnUsernameInput = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$FinishSetup$SubmitNewUsernameForm = function (a) {
	return {$: 7, a: a};
};
var $author$project$Views$Error$fieldError = function (content) {
	return A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('field-error')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(content)
			]));
};
var $author$project$Pages$FinishSetup$changeUsernameView = F2(
	function (model, user) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('change-username-card-wrapper')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('card change-username-card')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h2,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Changing your username')
									])),
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('You can update your username in the field below. Please note that this change is permanent and cannot be undone.')
									])),
								A2(
								$elm$html$Html$form,
								_List_fromArray(
									[
										$elm$html$Html$Events$onSubmit(
										$author$project$Pages$FinishSetup$SubmitNewUsernameForm(user))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$label,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$span,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('New Username')
															])),
														A2(
														$elm$html$Html$input,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$id('username'),
																$elm$html$Html$Attributes$class('username-input-wrapper'),
																$elm$html$Html$Attributes$type_('text'),
																$elm$html$Html$Events$onInput($author$project$Pages$FinishSetup$OnUsernameInput)
															]),
														_List_Nil)
													])),
												function () {
												var _v0 = model.ge;
												switch (_v0.$) {
													case 0:
														return A2(
															$elm$html$Html$p,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('field-status-label available')
																]),
															_List_fromArray(
																[
																	$author$project$Views$Icon$view(
																	$author$project$Views$Icon$small(
																		$author$project$Views$Icon$icon(11))),
																	$elm$html$Html$text('Available')
																]));
													case 1:
														return A2(
															$elm$html$Html$p,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('field-status-label checking')
																]),
															_List_fromArray(
																[
																	$author$project$Views$Loading$dots,
																	$elm$html$Html$text('Checking availability')
																]));
													case 2:
														var err = _v0.a;
														return $author$project$Views$Error$fieldError(err);
													default:
														return $elm$html$Html$text('');
												}
											}()
											])),
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('button primary-button'),
												$elm$html$Html$Attributes$disabled(
												!_Utils_eq(model.ge, $author$project$Pages$FinishSetup$Ready))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Change Username')
											]))
									]))
							]))
					]))
			]);
	});
var $author$project$Pages$FinishSetup$AcceptTermsOfService = {$: 0};
var $author$project$Pages$FinishSetup$ResendEmailVerificationLink = {$: 2};
var $author$project$Views$Icon$exactly = F2(
	function (width, height) {
		return $author$project$Views$Icon$setSize(
			A2($author$project$Views$Icon$Exactly, width, height));
	});
var $author$project$Views$Link$external = F3(
	function (url, attributes, children) {
		return A2(
			$elm$html$Html$a,
			_Utils_ap(
				attributes,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href(url),
						$elm$html$Html$Attributes$target('_blank')
					])),
			_Utils_ap(
				children,
				_List_fromArray(
					[
						$author$project$Views$Icon$view(
						A2(
							$author$project$Views$Icon$colored,
							$author$project$Style$color('blue'),
							A2(
								$author$project$Views$Icon$square,
								20,
								$author$project$Views$Icon$icon(25))))
					])));
	});
var $author$project$Pages$FinishSetup$eulaAndVerificationView = F2(
	function (_v0, user) {
		var needsToAcceptEula = !$author$project$Model$User$hasAcceptedEula(user);
		var needToVerifyEmail = $author$project$Model$User$isForcedToVerifyEmail(user);
		return _List_fromArray(
			[
				A2(
				$author$project$Misc$displayIf,
				needsToAcceptEula,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('new-box')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('content')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h2,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Views$Icon$view(
											A3(
												$author$project$Views$Icon$exactly,
												22,
												24,
												$author$project$Views$Icon$icon(9))),
											$elm$html$Html$text('Accept our Terms of Service')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('You have to accept our '),
											A3(
											$author$project$Views$Link$external,
											$author$project$Url$Extra$eula(_List_Nil),
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Terms of Use and Service Agreement')
												])),
											$elm$html$Html$text(' to access our Platform and CLI tool.')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('secondary-button'),
													$elm$html$Html$Events$onClick($author$project$Pages$FinishSetup$AcceptTermsOfService)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Accept Terms of Service')
												]))
										]))
								]))
						]))),
				A2(
				$author$project$Misc$displayIf,
				needToVerifyEmail,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('new-box')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('content')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h2,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Views$Icon$view(
											A3(
												$author$project$Views$Icon$exactly,
												22,
												24,
												$author$project$Views$Icon$icon(24))),
											$elm$html$Html$text('Verify your email address')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('We sent a verification email to \"'),
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(user.lJ)
												])),
											$elm$html$Html$text('\" — click the link inside to finish setting up your account.')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$href('#'),
													$elm$html$Html$Events$onClick($author$project$Pages$FinishSetup$ResendEmailVerificationLink)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Resend Email Verification Link')
												])),
											A3(
											$author$project$Views$Link$link,
											$author$project$Model$Route$Protected($author$project$Model$Route$PreferenceEmail),
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Manage Email Settings')
												]))
										]))
								]))
						])))
			]);
	});
var $author$project$Pages$FinishSetup$setupSteps = _List_fromArray(
	[
		{
		rh: function (user) {
			return (!$author$project$Model$User$hasAcceptedEula(user)) || $author$project$Model$User$isForcedToVerifyEmail(user);
		},
		G4: $author$project$Pages$FinishSetup$eulaAndVerificationView
	},
		{
		rh: function (user) {
			return user.DJ;
		},
		G4: $author$project$Pages$FinishSetup$changeUsernameView
	}
	]);
var $author$project$Pages$FinishSetup$viewSetup = F2(
	function (model, user) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (v) {
					return A2(v.G4, model, user);
				},
				A2(
					$elm_community$list_extra$List$Extra$find,
					function (step) {
						return step.rh(user);
					},
					$author$project$Pages$FinishSetup$setupSteps)));
	});
var $author$project$Pages$FinishSetup$view = F2(
	function (model, session) {
		var _v0 = $author$project$Model$Session$getUser(session);
		if (!_v0.$) {
			var user = _v0.a;
			return A2(
				$elm$html$Html$main_,
				_List_Nil,
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$h1,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Finish setting up your account')
							])),
					A2($author$project$Pages$FinishSetup$viewSetup, model, user)));
		} else {
			return A2(
				$elm$html$Html$main_,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('No user found in session!')
					]));
		}
	});
var $author$project$Pages$ForgotPassword$ChangeEmail = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$ForgotPassword$RequestPasswordReset = {$: 3};
var $author$project$Pages$ForgotPassword$view = function (model) {
	var errorField = A2(
		$author$project$Misc$displayMaybe,
		function (errorMessage) {
			return A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('field-error')
					]),
				_List_fromArray(
					[
						$author$project$Views$Icon$view(
						$author$project$Views$Icon$small(
							A2(
								$author$project$Views$Icon$colored,
								$author$project$Style$color('red'),
								$author$project$Views$Icon$icon(86)))),
						$elm$html$Html$text(errorMessage)
					]));
		},
		model.yd);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$id('auth-page'),
				$elm$html$Html$Attributes$class('forgot-password-page'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('form-submitting', model.jV)
					]))
			]),
		_List_fromArray(
			[
				$author$project$Pages$Login$logoBar,
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('page-body')
					]),
				_List_fromArray(
					[
						$author$project$Views$NotificationsInline$view(model),
						A2(
						$elm$html$Html$h1,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Forgot your Password?')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('No problem. Let us know the email associated with your account and we will send you instructions on how to reset it.')
							])),
						A2(
						$elm$html$Html$form,
						_List_fromArray(
							[
								$elm$html$Html$Events$onSubmit($author$project$Pages$ForgotPassword$RequestPasswordReset)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'error',
												!_Utils_eq(model.yd, $elm$core$Maybe$Nothing))
											]))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h4,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Your Email')
											])),
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$type_('email'),
												$elm$html$Html$Events$onInput($author$project$Pages$ForgotPassword$ChangeEmail),
												$elm$html$Html$Attributes$value(model.lJ)
											]),
										_List_Nil)
									])),
								errorField,
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button-wrapper')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('primary-button'),
												$elm$html$Html$Attributes$type_('submit')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Send Reset Link')
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$ForkProject$ChangeProjectName = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$ForkProject$ForkProject = {$: 1};
var $author$project$Pages$ForkProject$GoBack = {$: 3};
var $author$project$Pages$ForkProject$fieldError = function (content) {
	return A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('field-error')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(content)
			]));
};
var $elm$html$Html$Attributes$minlength = function (n) {
	return A2(
		_VirtualDom_attribute,
		'minLength',
		$elm$core$String$fromInt(n));
};
var $author$project$Pages$ForkProject$ChangeDestOrgUrlName = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$ForkProject$viewOrgOption = F3(
	function (session, currentlySelectedOrgName, membership) {
		var thisOrgName = membership.AC;
		var isValidForkTarget = A2(
			$author$project$Model$Permissions$canEditProjects,
			thisOrgName,
			$author$project$Model$Session$getUser(session));
		var _v0 = isValidForkTarget ? _Utils_Tuple2(
			$author$project$Pages$ForkProject$ChangeDestOrgUrlName(thisOrgName),
			'') : _Utils_Tuple2($author$project$Pages$ForkProject$NoOp, ' - cannot create projects');
		var clickMsg = _v0.a;
		var permissionWarning = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('option'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'selected',
							_Utils_eq(currentlySelectedOrgName, thisOrgName)),
							_Utils_Tuple2('disabled', !isValidForkTarget)
						])),
					$elm$html$Html$Events$onClick(clickMsg)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('radio'),
							$elm$html$Html$Attributes$checked(
							_Utils_eq(currentlySelectedOrgName, thisOrgName)),
							$elm$html$Html$Attributes$disabled(!isValidForkTarget)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(membership.AC)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('item-label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							_Utils_ap(
								$author$project$Model$Role$toDisplayString(membership.FO),
								permissionWarning))
						]))
				]));
	});
var $author$project$Model$Branch$trackingTypes = _List_fromArray(
	[
		$author$project$Model$Branch$getTrackingTypeOption(2),
		$author$project$Model$Branch$getTrackingTypeOption(1),
		$author$project$Model$Branch$getTrackingTypeOption(0)
	]);
var $author$project$Pages$ForkProject$ChangeTrackingType = function (a) {
	return {$: 7, a: a};
};
var $elm$html$Html$Attributes$name = $elm$html$Html$Attributes$stringProperty('name');
var $author$project$Pages$ForkProject$viewTrackingTypeOption = F2(
	function (selected, option) {
		var isChecked = _Utils_eq(option.sE, selected);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('option'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('selected', isChecked)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('radio'),
									$elm$html$Html$Attributes$name('tracking-type'),
									$elm$html$Html$Attributes$checked(isChecked),
									$elm$html$Html$Events$onClick(
									$author$project$Pages$ForkProject$ChangeTrackingType(option.sE))
								]),
							_List_Nil),
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(option.r0)
								])),
							A2(
							$author$project$Misc$displayIf,
							option.bP !== '',
							A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(' - ' + option.bP)
									])))
						]))
				]));
	});
var $author$project$Pages$ForkProject$viewTrackingTypeSelector = function (currentTrackingType) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('field-section hidden-option')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('What if the original project changes?')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('multi-selector')
							]),
						A2(
							$elm$core$List$map,
							$author$project$Pages$ForkProject$viewTrackingTypeOption(currentTrackingType),
							$author$project$Model$Branch$trackingTypes))
					]))
			]));
};
var $author$project$Pages$ForkProject$TogglePrivate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$ForkProject$viewVisibilitySelector = function (isPrivate) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('field-section hidden-option')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Project Visibility')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('multi-selector')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('option'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('selected', !isPrivate)
											]))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$type_('radio'),
														$elm$html$Html$Attributes$name('visibility'),
														$elm$html$Html$Attributes$checked(true),
														$elm$html$Html$Events$onClick(
														$author$project$Pages$ForkProject$TogglePrivate(false))
													]),
												_List_Nil),
												A2(
												$elm$html$Html$strong,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Public')
													])),
												A2(
												$elm$html$Html$span,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(' - Visible to anyone')
													]))
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('option'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('selected', isPrivate)
											]))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$type_('radio'),
														$elm$html$Html$Attributes$name('visibility'),
														$elm$html$Html$Events$onClick(
														$author$project$Pages$ForkProject$TogglePrivate(true))
													]),
												_List_Nil),
												A2(
												$elm$html$Html$strong,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Private')
													])),
												A2(
												$elm$html$Html$span,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(' - Visible only to me (or members of the orgnaization)')
													]))
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$ForkProject$view = F2(
	function (session, model) {
		var userOrganizations = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.mX;
				},
				$author$project$Model$Session$getUser(session)));
		var requiresOrgChoice = A2($elm$core$List$member, 1, model.r9);
		var requiresNameChange = A2($elm$core$List$member, 0, model.r9);
		var requiresNameChangeView = (requiresOrgChoice && requiresNameChange) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('required-action')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Looks like you already have a project with this name in your organization. Either choose a different organization to fork it into or give it a new name.')
				])) : (requiresNameChange ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('required-action')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Looks like you already have a project with this name. Give it a new name to continue.')
				])) : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('')
				])));
		var isNameReformatted = !_Utils_eq(
			model.j0,
			$author$project$Validation$formatProjectName(model.j0));
		var hasNameError = (!_Utils_eq(model.pt, $elm$core$Maybe$Nothing)) && model.sm;
		return A2(
			$elm$html$Html$main_,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Views$NotificationsInline$view(model),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('column')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Forking creates a copy of the parent project. When updates are made to the original, you can choose to apply them to the forked copy. '),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href('https://docs.activestate.com/platform/projects/fork/'),
											$elm$html$Html$Attributes$target('_blank')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Learn more about forking projects')
										]))
								])),
							A2(
							$elm$html$Html$form,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('single-column-form fork-project-form'),
									$elm$html$Html$Events$onSubmit($author$project$Pages$ForkProject$ForkProject)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('field-section'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('error', hasNameError)
												]))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$label,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Choose a name for the forked project')
														])),
													A2(
													$elm$html$Html$input,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$type_('text'),
															$elm$html$Html$Attributes$minlength($author$project$Validation$minProjectNameLength),
															$elm$html$Html$Attributes$maxlength($author$project$Validation$maxProjectNameLength),
															$elm$html$Html$Attributes$value(model.j0),
															$elm$html$Html$Events$onInput($author$project$Pages$ForkProject$ChangeProjectName),
															$elm$html$Html$Attributes$spellcheck(false),
															$elm$html$Html$Attributes$autofocus(true)
														]),
													_List_Nil)
												])),
											A2(
											$author$project$Misc$displayIf,
											hasNameError,
											$author$project$Pages$ForkProject$fieldError(
												A2($elm$core$Maybe$withDefault, '', model.pt))),
											requiresNameChangeView,
											A2(
											$author$project$Misc$displayIf,
											isNameReformatted,
											$author$project$Views$ViewUtils$formattedNameEl(
												$author$project$Validation$formatProjectName(model.j0)))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('field-section no-margin'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'hidden-option',
													$elm$core$List$isEmpty(userOrganizations))
												]))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Which of your organizations would you add the forked project to?')
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('multi-selector')
												]),
											_List_Nil)
										])),
									A2(
									$author$project$Misc$displayIf,
									$elm$core$List$length(userOrganizations) > 0,
									A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('field-section combo-field')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('multi-selector')
													]),
												A2(
													$elm$core$List$map,
													A2($author$project$Pages$ForkProject$viewOrgOption, session, model.jQ),
													userOrganizations))
											]))),
									$author$project$Pages$ForkProject$viewVisibilitySelector(model.cd),
									$author$project$Pages$ForkProject$viewTrackingTypeSelector(model.GM),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('primary-button'),
													$elm$html$Html$Attributes$disabled(model.jV)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Fork Project')
												])),
											A2(
											$author$project$Misc$displayIf,
											!model.jV,
											A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Events$onClick($author$project$Pages$ForkProject$GoBack),
														$elm$html$Html$Attributes$class('secondary-button'),
														$elm$html$Html$Attributes$type_('button')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Cancel')
													])))
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$ImportProject$CheckNameErrors = {$: 5};
var $author$project$Pages$ImportProject$CreateProject = {$: 1};
var $author$project$Pages$ImportProject$NewDescription = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$ImportProject$NewProjectName = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$ImportProject$ReverseStep = {$: 19};
var $author$project$Pages$ImportProject$TransitionStep = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$ImportProject$UpdatePlatformChoice = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$ImportProject$GoBack = {$: 8};
var $author$project$Pages$ImportProject$cancelButton = A2(
	$elm$html$Html$button,
	_List_fromArray(
		[
			$elm$html$Html$Events$onClick($author$project$Pages$ImportProject$GoBack),
			$elm$html$Html$Attributes$class('secondary-button'),
			$elm$html$Html$Attributes$type_('button')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Cancel')
		]));
var $author$project$Pages$ImportProject$fieldError = function (content) {
	return A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('field-error')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(content)
			]));
};
var $author$project$Pages$ImportProject$ChooseVersion = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Pages$ImportProject$languageVersionSelector = F3(
	function (accessModel, selectedLanguages, languages) {
		var languageName = $author$project$Views$LanguageSelectorSimple$languageName(selectedLanguages);
		var config = {AY: accessModel, BC: $author$project$Pages$ImportProject$ChooseVersion, aM: languages, fg: selectedLanguages};
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Views$LanguageSelectorSimple$header(languageName),
					$author$project$Views$LanguageSelectorSimple$view(config)
				]));
	});
var $author$project$Pages$ImportProject$nameCorrection = function (projectName) {
	var correctedName = $author$project$Validation$formatProjectName(projectName);
	return A2(
		$author$project$Misc$displayIf,
		!_Utils_eq(correctedName, projectName),
		$author$project$Views$ViewUtils$formattedNameEl(correctedName));
};
var $author$project$Pages$ImportProject$Finalize = 2;
var $author$project$Pages$ImportProject$progressTabs = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('progress-tabs')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('progress-tab'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('selected', !model.f1)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Step 1')
							])),
						A2(
						$elm$html$Html$h1,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Choose a repository')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('progress-tab'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('selected', model.f1 === 1)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Step 2')
							])),
						A2(
						$elm$html$Html$h1,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Review packages')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('progress-tab'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('selected', model.f1 === 2)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Step 3')
							])),
						A2(
						$elm$html$Html$h1,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Finalize')
							]))
					]))
			]));
};
var $author$project$Pages$ImportProject$ClearRepoURLFilter = {$: 13};
var $author$project$Pages$ImportProject$OnSelectRepo = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$ImportProject$OnToggleExpandedLogin = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$ImportProject$OnTypedRepo = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$ImportProject$RepoInput = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$ImportProject$RepoSelector = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$ImportProject$UpdateRepoURLFilter = function (a) {
	return {$: 12, a: a};
};
var $author$project$Views$InlineSearchBar$inlineSearchBar = function (_v0) {
	var inputValue = _v0.j0;
	var placeholderValue = _v0.Fd;
	var changeSearchMsg = _v0.Bx;
	var clearSearchMsg = _v0.BG;
	var isSearch = !$elm$core$String$isEmpty(inputValue);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('inline-search-ui')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id($author$project$Views$InlineSearchBar$searchBarId),
						$elm$html$Html$Attributes$value(inputValue),
						$elm$html$Html$Events$onInput(changeSearchMsg),
						$elm$html$Html$Attributes$type_('text'),
						$elm$html$Html$Attributes$class('search-bar'),
						$elm$html$Html$Attributes$placeholder(placeholderValue),
						$elm$html$Html$Attributes$spellcheck(false)
					]),
				_List_Nil),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('search-icon')
					]),
				_List_fromArray(
					[
						$author$project$Views$Icon$view(
						$author$project$Views$Icon$icon(69))
					])),
				function () {
				if (!clearSearchMsg.$) {
					var clearSearch = clearSearchMsg.a;
					return A2(
						$author$project$Misc$displayIf,
						isSearch,
						A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('clear-search'),
									$elm$html$Html$Events$onClick(clearSearch)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Clear')
								])));
				} else {
					return $elm$html$Html$text('');
				}
			}()
			]));
};
var $author$project$Model$MonoGit$Repository$languages = function (_v0) {
	var r = _v0;
	return r.aM;
};
var $author$project$Pages$ImportProject$newRepoInfo = F2(
	function (languages, repoSource) {
		return {yd: $elm$core$Maybe$Nothing, fm: _List_Nil, aM: languages, kr: repoSource};
	});
var $author$project$Pages$ImportProject$repoSelector = F2(
	function (model, _v0) {
		var selectedRepoUrl = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Maybe$map, $author$project$Pages$ImportProject$repoSourceToURL, model.gA));
		var repoView = F2(
			function (login, repo) {
				var selected = A2($author$project$Pages$ImportProject$isSelected, model.gA, repo);
				var repoLanguages = A2(
					$elm$core$List$filter,
					$author$project$Model$Language$supportsImporting,
					$author$project$Model$MonoGit$Repository$languages(repo));
				var loginAndRepo = login + ('_' + $elm$core$String$toLower(
					$author$project$Model$MonoGit$Repository$name(repo)));
				var isDisabledRepo = !$author$project$Model$MonoGit$Repository$isImportable(repo);
				var liAttrs = isDisabledRepo ? _List_fromArray(
					[
						$elm$html$Html$Attributes$class('disabled'),
						$elm$html$Html$Attributes$title('This repository cannot be imported because it does not contain a supported language.')
					]) : _List_Nil;
				return A2(
					$elm$html$Html$li,
					liAttrs,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bubble-radio'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('selected', selected)
										])),
									A2($elm$html$Html$Attributes$attribute, 'data-cy', 'select-login-and-repo-' + loginAndRepo)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Misc$displayIf,
									!isDisabledRepo,
									A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$type_('radio'),
												$elm$html$Html$Attributes$value(
												$author$project$Model$MonoGit$Repository$url(repo)),
												$elm$html$Html$Attributes$checked(selected && (!isDisabledRepo)),
												$elm$html$Html$Events$onInput(
												A2(
													$elm$core$Basics$composeR,
													$author$project$Pages$ImportProject$RepoSelector,
													A2(
														$elm$core$Basics$composeR,
														$author$project$Pages$ImportProject$newRepoInfo(repoLanguages),
														$author$project$Pages$ImportProject$OnSelectRepo)))
											]),
										_List_Nil)),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Model$MonoGit$Repository$name(repo))
										]))
								]))
						]));
			});
		var repoError = A2($elm$core$Maybe$withDefault, '', model.pB);
		var orgView = function (login) {
			var loginName = $author$project$Model$MonoGit$Login$getLogin(login);
			var loginNameLowered = $elm$core$String$toLower(loginName);
			var filteredRepos = A2($author$project$Pages$ImportProject$filterRepos, model.hd, login);
			var expanded = A2($elm$core$Set$member, loginName, model.i1);
			var expandedAttr = expanded ? A2($elm$html$Html$Attributes$attribute, 'open', 'True') : $elm$html$Html$Attributes$class('');
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('repo-group'),
						expandedAttr
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$summary,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$Pages$ImportProject$OnToggleExpandedLogin(loginName)),
								A2($elm$html$Html$Attributes$attribute, 'data-cy', 'select-repo-group-' + loginNameLowered)
							]),
						_List_fromArray(
							[
								$author$project$Views$Icon$view(
								$author$project$Views$Icon$icon(13)),
								A2(
								$elm$html$Html$h4,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('org-name')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Model$MonoGit$Login$getLogin(login))
									]))
							])),
						A2(
						$author$project$Misc$displayIf,
						expanded,
						A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('repo-list')
								]),
							A2(
								$elm$core$List$map,
								repoView(loginNameLowered),
								filteredRepos)))
					]));
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('field-section repo-selector-wrapper')
				]),
			_List_fromArray(
				[
					$elm$core$List$isEmpty(model.kR) ? A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Oops!')
										])),
									$elm$html$Html$text(' We couldn\'t find any repositories associated with your Github account. You can...')
								])),
							A3(
							$author$project$Views$Link$link,
							$author$project$Model$Route$Protected(
								$author$project$Model$Route$CreateProject(
									{B2: $author$project$Model$Route$emptyCreateProjectParams, ix: model.c3.AC})),
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('primary-button')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Create a Runtime from Scratch')
								]))
						])) : A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex-header')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Select from your repositories')
										])),
									$author$project$Views$InlineSearchBar$inlineSearchBar(
									{
										Bx: $author$project$Pages$ImportProject$UpdateRepoURLFilter,
										BG: $elm$core$Maybe$Just($author$project$Pages$ImportProject$ClearRepoURLFilter),
										j0: model.hd,
										Fd: 'Search repository name'
									})
								])),
							A2(
							$author$project$Misc$displayIf,
							!$elm$core$String$isEmpty(model.hd),
							$elm$html$Html$text(
								function () {
									var nbrMatchingRepos = $elm$core$List$length(
										A2(
											$elm$core$List$concatMap,
											$author$project$Pages$ImportProject$filterRepos(model.hd),
											model.kR));
									return $elm$core$String$fromInt(nbrMatchingRepos) + (' repositories match \'' + (model.hd + '\''));
								}())),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('repo-selector')
								]),
							A2($elm$core$List$map, orgView, model.kR))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('repo-selector-divider')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Or provide a repository URL')
						])),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('text'),
							$elm$html$Html$Events$onInput(
							A2(
								$elm$core$Basics$composeR,
								$author$project$Pages$ImportProject$RepoInput,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Pages$ImportProject$newRepoInfo(_List_Nil),
									$author$project$Pages$ImportProject$OnTypedRepo))),
							$elm$html$Html$Attributes$placeholder('Ex. https://github.com/username/repo-name')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(selectedRepoUrl)
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('field-error')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(repoError)
						]))
				]));
	});
var $author$project$Url$Extra$createProjectDocs = function (queryParams) {
	return A3(
		$author$project$Url$Extra$createUrl,
		$author$project$Url$Extra$docsDomain,
		_List_fromArray(
			['platform', 'projects', 'create', '#creating-your-first-project']),
		queryParams);
};
var $author$project$Url$Extra$importRequirementsDocs = function (queryParams) {
	return A3(
		$author$project$Url$Extra$createUrl,
		$author$project$Url$Extra$docsDomain,
		_List_fromArray(
			['platform', 'projects', 'managing_requirements']),
		queryParams);
};
var $mgold$elm_nonempty_list$List$Nonempty$map = F2(
	function (f, _v0) {
		var x = _v0.a;
		var xs = _v0.b;
		return A2(
			$mgold$elm_nonempty_list$List$Nonempty$Nonempty,
			f(x),
			A2($elm$core$List$map, f, xs));
	});
var $author$project$Misc$singletonText = A2($elm$core$Basics$composeR, $elm$html$Html$text, $elm$core$List$singleton);
var $author$project$Model$PackageImport$viewLanguageSupportedFileFormatsWith = function (formatWrapper) {
	var addEnglishSeps = function (words) {
		if (words.b && words.b.b) {
			if (!words.b.b.b) {
				var word = words.a;
				var _v1 = words.b;
				var last = _v1.a;
				return _List_fromArray(
					[
						word,
						$elm$html$Html$text(' or '),
						last
					]);
			} else {
				var word = words.a;
				var _v2 = words.b;
				var notLast = _v2.a;
				var moreWords = _v2.b;
				return _Utils_ap(
					_List_fromArray(
						[
							word,
							$elm$html$Html$text(', ')
						]),
					addEnglishSeps(
						A2($elm$core$List$cons, notLast, moreWords)));
			}
		} else {
			return words;
		}
	};
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Model$Language$importFileFormats,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map(
				$mgold$elm_nonempty_list$List$Nonempty$map(
					A2($elm$core$Basics$composeR, $author$project$Misc$singletonText, formatWrapper))),
			$elm$core$Maybe$andThen(
				A2(
					$elm$core$Basics$composeR,
					$mgold$elm_nonempty_list$List$Nonempty$toList,
					A2($elm$core$Basics$composeR, addEnglishSeps, $mgold$elm_nonempty_list$List$Nonempty$fromList)))));
};
var $author$project$Pages$ImportProject$langRequirementsFileUlView = function () {
	var viewLangBulletPoint = function (lang) {
		return A2(
			$elm$core$Maybe$map,
			function (formats) {
				return A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm_community$string_extra$String$Extra$toSentenceCase(
										$author$project$Model$Language$toString(lang)))
								])),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							A2(
								$elm$core$List$cons,
								$elm$html$Html$text(' — We look for a '),
								$mgold$elm_nonempty_list$List$Nonempty$toList(formats))),
							$elm$html$Html$text('file.')
						]));
			},
			A2(
				$author$project$Model$PackageImport$viewLanguageSupportedFileFormatsWith,
				$elm$html$Html$span(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('file-type')
						])),
				lang));
	};
	return A2(
		$elm$html$Html$ul,
		_List_Nil,
		A2(
			$elm$core$List$filterMap,
			viewLangBulletPoint,
			$mgold$elm_nonempty_list$List$Nonempty$toList($author$project$Model$Language$all)));
}();
var $author$project$Pages$ImportProject$requirementsFilesHelpView = function (isIntro) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('scan-error')
			]),
		_List_fromArray(
			[
				isIntro ? A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Our import process only works with repositories that contain one the following languages... ')
					])) : A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Here\'s how we determine what packages you are using for each supported language...')
					])),
				$author$project$Pages$ImportProject$langRequirementsFileUlView,
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('This file must be at root directory of your repository. If it is not, you can '),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href(
								$author$project$Url$Extra$createProjectDocs(_List_Nil)),
								$elm$html$Html$Attributes$target('_blank')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('create a project')
							])),
						$elm$html$Html$text(' then use the '),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href(
								$author$project$Url$Extra$importRequirementsDocs(_List_Nil)),
								$elm$html$Html$Attributes$target('_blank')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Import From File')
							])),
						$elm$html$Html$text(' feature instead.')
					]))
			]));
};
var $author$project$Model$Language$allNames = $mgold$elm_nonempty_list$List$Nonempty$toList(
	A2($mgold$elm_nonempty_list$List$Nonempty$map, $author$project$Model$Language$toString, $author$project$Model$Language$all));
var $author$project$Pages$ImportProject$enumerateLanguages = function (languages) {
	var _v0 = $elm$core$List$reverse(
		A2($elm$core$List$map, $elm_community$string_extra$String$Extra$toSentenceCase, languages));
	if (!_v0.b) {
		return 'no languages';
	} else {
		if (!_v0.b.b) {
			var language = _v0.a;
			return language;
		} else {
			var lastLanguage = _v0.a;
			var initLanguages = _v0.b;
			return A2(
				$elm$core$String$join,
				', ',
				$elm$core$List$reverse(initLanguages)) + (' and ' + lastLanguage);
		}
	}
};
var $author$project$Pages$ImportProject$requirementsFileString = F2(
	function (languages, join) {
		return A2(
			$elm$core$String$join,
			join,
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					$mgold$elm_nonempty_list$List$Nonempty$toList,
					$elm$core$String$join(' / ')),
				A2(
					$elm$core$List$filterMap,
					$author$project$Model$Language$importFileFormats,
					A2(
						$elm$core$List$filter,
						function (lang) {
							return A2(
								$elm$core$List$member,
								$elm_community$string_extra$String$Extra$toSentenceCase(
									$author$project$Model$Language$toString(lang)),
								languages);
						},
						$mgold$elm_nonempty_list$List$Nonempty$toList($author$project$Model$Language$all)))));
	});
var $author$project$Pages$ImportProject$errorParsingReqsFileView = function (languages) {
	var pluralRequirementsFileString = A3(
		$elm_community$string_extra$String$Extra$pluralize,
		'file',
		'files',
		$elm$core$List$length(languages));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('scan-error')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('We detected ' + (pluralRequirementsFileString + ', a')),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('file-type')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$Pages$ImportProject$requirementsFileString, languages, ' and '))
							])),
						$elm$html$Html$text(
						' in your ' + ($author$project$Pages$ImportProject$enumerateLanguages(languages) + ' repository but when we tried to parse it we ran into a problem with some of the syntax and could not figure out which packages you are using.'))
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('We\'ll add what we can from the file but be sure to check which packages didn\'t make it.')
					]))
			]));
};
var $author$project$Pages$ImportProject$failedPackagesView = function (error) {
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('warning')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(error.zB)
			]));
};
var $author$project$Pages$ImportProject$packageView = function (requirement) {
	return A2(
		$elm$html$Html$li,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Model$Namespace$getName(requirement.Y)),
				$elm$html$Html$text(' '),
				$elm$html$Html$text(
				function () {
					var _v0 = requirement.bK;
					switch (_v0.$) {
						case 0:
							return '';
						case 1:
							var version = _v0.a;
							return version;
						case 2:
							var first = _v0.a;
							var others = _v0.b;
							return A2($author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$toPythonSyntax, first, others);
						default:
							return '';
					}
				}())
			]));
};
var $author$project$Pages$ImportProject$importInfoView = function (importData) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Misc$displayIf,
				!$elm$core$List$isEmpty(importData.CV),
				A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('language-package-list')
						]),
					A2($elm$core$List$map, $author$project$Pages$ImportProject$packageView, importData.CV))),
				A2(
				$author$project$Misc$displayIf,
				!$elm$core$List$isEmpty(importData.yf),
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('package-parsing-errors')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Unrecognized packages')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('We had trouble parsing the following packages, you can add them manually once you create the project.')
								])),
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('language-error-list')
								]),
							A2($elm$core$List$map, $author$project$Pages$ImportProject$failedPackagesView, importData.yf))
						])))
			]));
};
var $author$project$Pages$ImportProject$languageDisplayView = function (languageData) {
	switch (languageData.$) {
		case 3:
			var data = languageData.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('language-option display')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('package-count')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A3(
									$elm_community$string_extra$String$Extra$pluralize,
									'package',
									'packages',
									$elm$core$List$length(data.mY.CV)))
							])),
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(data.aC)
							])),
						$author$project$Pages$ImportProject$importInfoView(data.mY)
					]));
		case 2:
			return $elm$html$Html$text('');
		default:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('language-option display')
					]),
				_List_fromArray(
					[$author$project$Views$Loading$dots]));
	}
};
var $author$project$Pages$ImportProject$ChooseLanguage = function (a) {
	return {$: 11, a: a};
};
var $krisajenkins$remotedata$RemoteData$isSuccess = function (data) {
	if (data.$ === 3) {
		var x = data.a;
		return true;
	} else {
		return false;
	}
};
var $author$project$Pages$ImportProject$languageViewFull = F3(
	function (model, selectedRepo, languageData) {
		var maybeOnClick = function (languageName) {
			var _v2 = A2(
				$elm_community$list_extra$List$Extra$find,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Model$LanguageVersions$getName,
					$elm$core$Basics$eq(
						$elm$core$String$toLower(languageName))),
				model.jF);
			if (!_v2.$) {
				var lang = _v2.a;
				return $elm$html$Html$Events$onClick(
					$author$project$Pages$ImportProject$ChooseLanguage(lang));
			} else {
				return $elm$html$Html$Attributes$class('');
			}
		};
		var isLanguageSelected = function (languageName) {
			return A2(
				$elm$core$List$member,
				$elm$core$String$toLower(languageName),
				A2(
					$elm$core$List$map,
					A2($elm$core$Basics$composeR, $author$project$Model$LanguageVersions$getName, $elm$core$String$toLower),
					model.fg));
		};
		var failedLanguageName = A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(
				A2(
					$elm$core$List$map,
					function (data) {
						if (data.$ === 3) {
							var d = data.a;
							return A2(
								$elm$core$Maybe$withDefault,
								'',
								$elm$core$List$head(
									A2(
										$elm$core$List$filter,
										$elm$core$Basics$neq(d.aC),
										selectedRepo.aM)));
						} else {
							return '';
						}
					},
					A2($elm$core$List$filter, $krisajenkins$remotedata$RemoteData$isSuccess, selectedRepo.fm))));
		switch (languageData.$) {
			case 3:
				var data = languageData.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							maybeOnClick(data.aC),
							$elm$html$Html$Attributes$class('language-option'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'selected',
									isLanguageSelected(data.aC))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('radio'),
									$elm$html$Html$Attributes$checked(
									isLanguageSelected(data.aC))
								]),
							_List_Nil),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('package-count')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A3(
										$elm_community$string_extra$String$Extra$pluralize,
										'package',
										'packages',
										$elm$core$List$length(data.mY.CV)))
								])),
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(data.aC)
								])),
							A2(
							$author$project$Misc$displayIf,
							isLanguageSelected(data.aC),
							$author$project$Pages$ImportProject$importInfoView(data.mY))
						]));
			case 2:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							maybeOnClick(failedLanguageName),
							$elm$html$Html$Attributes$class('language-option'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'selected',
									isLanguageSelected(failedLanguageName))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('radio'),
									$elm$html$Html$Attributes$checked(
									isLanguageSelected(failedLanguageName))
								]),
							_List_Nil),
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(failedLanguageName)
								])),
							A2(
							$author$project$Misc$displayIf,
							isLanguageSelected(failedLanguageName),
							$elm$html$Html$text('Failed to import packages'))
						]));
			default:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('language-option')
						]),
					_List_fromArray(
						[$author$project$Views$Loading$dots]));
		}
	});
var $author$project$Pages$ImportProject$packagesContentView = F2(
	function (model, selectedRepo) {
		var _v0 = selectedRepo.fm;
		if (_v0.b) {
			if (!_v0.b.b) {
				var data = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Detected Language & Packages')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('We\'ve detected the following language & packages in your repository.')
								])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Pages$ImportProject$languageDisplayView(data)
								]))
						]));
			} else {
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Select a language')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('We\'ve detected the following languages & packages in your repository.')
								])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							A2(
								$elm$core$List$map,
								A2($author$project$Pages$ImportProject$languageViewFull, model, selectedRepo),
								selectedRepo.fm))
						]));
			}
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Pages$ImportProject$reviewPackagesView = F2(
	function (model, selectedRepo) {
		var isLoading = (model.hk >= 1) && A2($elm$core$List$all, $krisajenkins$remotedata$RemoteData$isLoading, selectedRepo.fm);
		var importErrors = $author$project$Pages$ImportProject$getImportErrors(selectedRepo);
		var importStatus = function () {
			if (isLoading) {
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('import-status')
						]),
					_List_fromArray(
						[
							$author$project$Views$Loading$dots,
							$elm$html$Html$text('Loading data from GitHub')
						]));
			} else {
				if (importErrors.rz) {
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('import-status warning')
									]),
								_List_fromArray(
									[
										$author$project$Views$Icon$view(
										$author$project$Views$Icon$icon(83)),
										$elm$html$Html$text(
										'We detected ' + ($author$project$Pages$ImportProject$enumerateLanguages(selectedRepo.aM) + ' in your repository, but could not determine what packages you are using.'))
									])),
								$author$project$Pages$ImportProject$requirementsFilesHelpView(false)
							]));
				} else {
					if (importErrors.o9) {
						return A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('import-status warning')
										]),
									_List_fromArray(
										[
											$author$project$Views$Icon$view(
											$author$project$Views$Icon$icon(83)),
											$elm$html$Html$text('We could not detect a supported language in your repository.')
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('scan-error')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('For now, the GitHub scan feature only works with '),
													$elm$html$Html$text(
													$author$project$Pages$ImportProject$enumerateLanguages(
														A2($elm$core$List$filter, $author$project$Model$Language$supportsImporting, $author$project$Model$Language$allNames))),
													$elm$html$Html$text(', and detects your packages by looking in the root of your repository for...')
												])),
											$author$project$Pages$ImportProject$langRequirementsFileUlView
										]))
								]));
					} else {
						if ($elm_community$maybe_extra$Maybe$Extra$isJust(selectedRepo.yd)) {
							return A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('import-status warning')
									]),
								_List_fromArray(
									[
										$author$project$Views$Icon$view(
										$author$project$Views$Icon$icon(83)),
										$elm$html$Html$text('Failed to fetch repository data.')
									]));
						} else {
							if (importErrors.ry) {
								var langs = A2(
									$elm$core$String$join,
									', ',
									A2(
										$elm$core$List$map,
										$elm_community$string_extra$String$Extra$toSentenceCase,
										A2($elm$core$List$filter, $author$project$Model$Language$supportsImporting, $author$project$Model$Language$allNames)));
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('import-status warning')
												]),
											_List_fromArray(
												[
													$author$project$Views$Icon$view(
													$author$project$Views$Icon$icon(83)),
													$elm$html$Html$text('We could not find anything to import. Either your repository has no supported languages (' + (langs + ') or is missing a package description file (see below)'))
												])),
											$author$project$Pages$ImportProject$requirementsFilesHelpView(false)
										]));
							} else {
								if (importErrors.sw) {
									return A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('import-status warning')
													]),
												_List_fromArray(
													[
														$author$project$Views$Icon$view(
														$author$project$Views$Icon$icon(83)),
														$elm$html$Html$text(
														'We detected ' + ($author$project$Pages$ImportProject$enumerateLanguages(selectedRepo.aM) + ' but had problems identifying some of the packages.'))
													])),
												$author$project$Pages$ImportProject$errorParsingReqsFileView(selectedRepo.aM)
											]));
								} else {
									return A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('import-status success')
											]),
										_List_fromArray(
											[
												$author$project$Views$Icon$view(
												$author$project$Views$Icon$icon(10)),
												$elm$html$Html$text('Success')
											]));
								}
							}
						}
					}
				}
			}
		}();
		var proceedButton = function () {
			var attr = (isLoading || importErrors.o9) ? $elm$html$Html$Attributes$disabled(true) : $elm$html$Html$Events$onClick(
				$author$project$Pages$ImportProject$TransitionStep(2));
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						attr,
						$elm$html$Html$Attributes$class('primary-button'),
						A2($elm$html$Html$Attributes$attribute, 'data-cy', 'github-continue')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Continue')
					]));
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('step-review-packages')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Scan Status')
						])),
					importStatus,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('language-list')
						]),
					_List_fromArray(
						[
							A2($author$project$Pages$ImportProject$packagesContentView, model, selectedRepo)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('progress-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button-row')
								]),
							_List_fromArray(
								[
									proceedButton,
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick($author$project$Pages$ImportProject$ReverseStep),
											$elm$html$Html$Attributes$class('secondary-button')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Back')
										])),
									$author$project$Pages$ImportProject$cancelButton
								]))
						]))
				]));
	});
var $author$project$Pages$ImportProject$SwitchVisibility = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$ImportProject$visibilityOption = F6(
	function (isDisabled, classString, isChecked, msgOnClick, optionName, optionDescription) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('option ' + classString),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('selected', isChecked)
								])),
							$elm$html$Html$Events$onClick(msgOnClick)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('radio'),
									$elm$html$Html$Attributes$id(optionName),
									$elm$html$Html$Attributes$checked(isChecked),
									$elm$html$Html$Attributes$disabled(isDisabled)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('primary-icon'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('disabled', isDisabled)
										]))
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$for(optionName)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h4,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('option-name')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(optionName)
												]))
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('option-description')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(optionDescription)
										]))
								]))
						])),
					A2(
					$author$project$Misc$displayIf,
					isDisabled,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('disabled-explanation')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Private projects are not available on free accounts.'),
								$elm$html$Html$text(' To upgrade, view our '),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$target('_blanks'),
										$elm$html$Html$Attributes$href(
										$author$project$Url$Extra$pricing(_List_Nil))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('plans & pricing')
									]))
							])))
				]));
	});
var $author$project$Pages$ImportProject$disabledVisibilityOption = function (_v0) {
	var className = _v0.BD;
	var optionName = _v0.kk;
	var description = _v0.bP;
	return A6($author$project$Pages$ImportProject$visibilityOption, true, className + ' disabled-option', false, $author$project$Pages$ImportProject$NoOp, optionName, description);
};
var $author$project$Pages$ImportProject$visibilitySelector = F2(
	function (org, visibility) {
		var publicCopy = 'Only members of this organization can modify it, but any user of the ActiveState Platform can view and install this runtime.';
		var privateCopy = 'Only members of this organization can modify, view and install this runtime.';
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('visibility-selector-wrapper')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('visibility-selector-new')
						]),
					_List_fromArray(
						[
							A6(
							$author$project$Pages$ImportProject$visibilityOption,
							false,
							'public',
							visibility === 1,
							$author$project$Pages$ImportProject$SwitchVisibility(1),
							'Public Project',
							publicCopy),
							$author$project$Model$Permissions$orgCanCreatePrivateProject(org) ? A6(
							$author$project$Pages$ImportProject$visibilityOption,
							false,
							'private',
							!visibility,
							$author$project$Pages$ImportProject$SwitchVisibility(0),
							'Private Project',
							privateCopy) : $author$project$Pages$ImportProject$disabledVisibilityOption(
							{BD: 'private', bP: privateCopy, kk: 'Private'})
						]))
				]));
	});
var $author$project$Pages$ImportProject$view = F2(
	function (model, session) {
		var projectNameError = A2($elm$core$Maybe$withDefault, '', model.pt);
		var proceedButton = function () {
			var url = A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$map, $author$project$Pages$ImportProject$repoSourceToURL, model.gA));
			var attr = ($elm_community$maybe_extra$Maybe$Extra$isJust(model.gA) && (url !== '')) ? $elm$html$Html$Events$onClick(
				$author$project$Pages$ImportProject$TransitionStep(1)) : $elm$html$Html$Attributes$disabled(true);
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						attr,
						$elm$html$Html$Attributes$class('primary-button'),
						A2($elm$html$Html$Attributes$attribute, 'data-cy', 'github-scan-repo')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Scan Repo')
					]));
		}();
		var hasProjectNameError = projectNameError !== '';
		var editorLanguages = $author$project$Model$LanguageVersions$sort(
			A2(
				$elm$core$List$filter,
				A2($elm$core$Basics$composeR, $author$project$Model$LanguageVersions$getName, $author$project$Model$Language$supportsImporting),
				model.jF));
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('import-project form')
				]),
			_List_fromArray(
				[
					$author$project$Pages$ImportProject$progressTabs(model),
					function () {
					var _v0 = model.f1;
					switch (_v0) {
						case 0:
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('step-choose-repo form')
									]),
								_List_fromArray(
									[
										$author$project$Pages$ImportProject$requirementsFilesHelpView(true),
										A2($author$project$Pages$ImportProject$repoSelector, model, session),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('progress-buttons')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('button-row')
													]),
												_List_fromArray(
													[proceedButton, $author$project$Pages$ImportProject$cancelButton]))
											]))
									]));
						case 1:
							return A2(
								$elm$core$Maybe$withDefault,
								$elm$html$Html$text(''),
								A2(
									$elm$core$Maybe$map,
									$author$project$Pages$ImportProject$reviewPackagesView(model),
									A2(
										$elm$core$Maybe$andThen,
										function (repoSource) {
											return A2(
												$elm$core$Dict$get,
												$author$project$Pages$ImportProject$repoSourceToURL(repoSource),
												model.fx);
										},
										model.gA)));
						default:
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('step-finalize')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('field-section')
											]),
										_List_fromArray(
											[
												A3(
												$author$project$Pages$ImportProject$languageVersionSelector,
												A2($author$project$Model$LanguageVersions$createAccessModel, session, model.c3),
												model.fg,
												editorLanguages)
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('field-section'),
												$elm$html$Html$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2('error', model.m1)
													]))
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$h4,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Choose your operating systems')
													])),
												A2(
												$author$project$Views$PlatformSelectorSimple$view,
												{
													Ci: $author$project$Pages$ImportProject$NoOp,
													oS: $author$project$Model$Session$isSuperUserWithFeaturesVisible(session),
													DR: $author$project$Model$LanguageVersions$selectedLanguageAndVersion(model.fg),
													E0: false,
													GS: $author$project$Pages$ImportProject$UpdatePlatformChoice
												},
												model.hK)
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('field-section')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$h4,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Runtime visibility')
													])),
												A2($author$project$Pages$ImportProject$visibilitySelector, model.c3, model.p9)
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('field-section')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('field-section hidden-section')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$h4,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('Description'),
																		A2(
																		$elm$html$Html$span,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('optional-indicator')
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text('(Optional)')
																			]))
																	])),
																A2(
																$elm$html$Html$p,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('field-info')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('What is this project about?')
																	]))
															])),
														A2(
														$elm$html$Html$textarea,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$maxlength(160),
																$elm$html$Html$Events$onInput($author$project$Pages$ImportProject$NewDescription)
															]),
														_List_Nil)
													]))
											])),
										$author$project$Views$NotificationsInline$view(model),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('field-section'),
												$elm$html$Html$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2('error', hasProjectNameError)
													]))
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$label,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$h4,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Name your runtime')
															])),
														A2(
														$elm$html$Html$p,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('field-info')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('We picked a name for you, but you can change it. It will also act as the URL.')
															])),
														A2(
														$elm$html$Html$input,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$placeholder('Ex. \"machine-learning-runtime\"'),
																$elm$html$Html$Attributes$id('project-name'),
																$elm$html$Html$Attributes$type_('text'),
																$elm$html$Html$Events$onInput($author$project$Pages$ImportProject$NewProjectName),
																$elm$html$Html$Attributes$spellcheck(false),
																$elm$html$Html$Events$onBlur($author$project$Pages$ImportProject$CheckNameErrors),
																$elm$html$Html$Attributes$maxlength($author$project$Validation$maxProjectNameLength),
																$elm$html$Html$Attributes$value(model.vT)
															]),
														_List_Nil)
													])),
												$author$project$Pages$ImportProject$nameCorrection(model.vT),
												A2(
												$author$project$Misc$displayIf,
												hasProjectNameError,
												$author$project$Pages$ImportProject$fieldError(projectNameError))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('progress-buttons')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('button-row')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$button,
														_List_fromArray(
															[
																$elm$html$Html$Events$onClick($author$project$Pages$ImportProject$CreateProject),
																$elm$html$Html$Attributes$class('primary-button'),
																A2($elm$html$Html$Attributes$attribute, 'data-cy', 'github-create-project')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Create Project')
															])),
														A2(
														$elm$html$Html$button,
														_List_fromArray(
															[
																$elm$html$Html$Events$onClick($author$project$Pages$ImportProject$ReverseStep),
																$elm$html$Html$Attributes$class('secondary-button')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Back')
															])),
														$author$project$Pages$ImportProject$cancelButton
													])),
												A2(
												$author$project$Misc$displayIf,
												model.m1,
												$author$project$Pages$ImportProject$fieldError('Please select at least one operating system.'))
											]))
									]));
					}
				}()
				]));
	});
var $author$project$Pages$Login$invitedHeading = A2(
	$elm$html$Html$h1,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('top-line')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Log in to the ActiveState Platform to accept your invitation')
				]))
		]));
var $author$project$Pages$Login$invitedNote = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('invited-note')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('To accept the invitation you must use the account with the email address that the invitation was sent to. If you log in with GitHub the email address in your GitHub must match.')
				])),
			A3(
			$author$project$Views$Link$link,
			$author$project$Model$Route$Login($author$project$Model$Route$emptyLoginParams),
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Log in with a different email')
				]))
		]));
var $author$project$Pages$Login$regularHeading = A2(
	$elm$html$Html$h1,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('top-line')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Log in to the')
				])),
			$elm$html$Html$text('ActiveState Platform')
		]));
var $author$project$Pages$Login$GithubAuth = {$: 7};
var $author$project$Pages$Login$SSOAuth = {$: 8};
var $author$project$Pages$Login$createAccountLink = function (createAccountRoute) {
	return A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('helper-link')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Don\'t have an account yet? '),
				A3(
				$author$project$Views$Link$link,
				createAccountRoute,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Sign Up')
					]))
			]));
};
var $author$project$Pages$Login$InputPassword = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Login$InputUsername = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Login$Login = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Login$InputTwoFactor = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Login$twoFactorField = A2(
	$elm$html$Html$section,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('two-factor-form')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$h2,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Two-factor Authentication')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('This account has two-factor authentication enabled. Please check your Authentication App for the 6-digit code and provide it below.')
				])),
			A2(
			$elm$html$Html$label,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Two-Factor Code')
						])),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id($author$project$Pages$Login$twoFactorId),
							$elm$html$Html$Attributes$type_('text'),
							$elm$html$Html$Attributes$spellcheck(false),
							$elm$html$Html$Attributes$placeholder('e.g. 123456'),
							$elm$html$Html$Events$onInput($author$project$Pages$Login$InputTwoFactor)
						]),
					_List_Nil)
				]))
		]));
var $author$project$Pages$Login$emailForm = function (model) {
	var emailIsLocked = $elm_community$maybe_extra$Maybe$Extra$isJust(model.lJ);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Views$NotificationsInline$view(model),
				A2(
				$elm$html$Html$form,
				_List_fromArray(
					[
						$elm$html$Html$Events$onSubmit(
						$author$project$Pages$Login$Login(model.dI))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('email-heading')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Username or Email')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id('email'),
										$elm$html$Html$Attributes$autofocus(true),
										$elm$html$Html$Attributes$type_('text'),
										$elm$html$Html$Attributes$spellcheck(false),
										$elm$html$Html$Events$onInput($author$project$Pages$Login$InputUsername),
										$elm$html$Html$Attributes$value(model.dI.AE),
										A2($elm$html$Html$Attributes$attribute, 'data-cy', 'email-or-username'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('locked-field', emailIsLocked)
											])),
										$elm$html$Html$Attributes$disabled(emailIsLocked)
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Password')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id('password'),
										$elm$html$Html$Attributes$type_('password'),
										$elm$html$Html$Events$onInput($author$project$Pages$Login$InputPassword),
										A2($elm$html$Html$Attributes$attribute, 'data-cy', 'password')
									]),
								_List_Nil)
							])),
						A2($author$project$Misc$displayIf, model.j6 === 1, $author$project$Pages$Login$twoFactorField),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('button-wrapper')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('primary-button'),
										$elm$html$Html$Attributes$type_('submit'),
										$elm$html$Html$Attributes$disabled(model.lX),
										A2($elm$html$Html$Attributes$attribute, 'data-cy', 'login-button')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Sign In')
									])),
								A2(
								$elm$core$Maybe$withDefault,
								$elm$html$Html$text(''),
								A2(
									$elm$core$Maybe$map,
									function (error) {
										return A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('inline-error')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(error)
												]));
									},
									model.p_))
							]))
					]))
			]));
};
var $author$project$Pages$Login$forgotPasswordLink = A2(
	$elm$html$Html$p,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('helper-link')
		]),
	_List_fromArray(
		[
			A3(
			$author$project$Views$Link$link,
			$author$project$Model$Route$ForgotPassword,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Forgot your password?')
				]))
		]));
var $author$project$Pages$Login$helpText = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('login-footer')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Trouble signing in? Let us know at '),
			A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$target('_blank'),
					$elm$html$Html$Attributes$href('mailto:support@activestate.com')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('support@activestate.com')
				]))
		]));
var $author$project$Pages$Login$tos = A2(
	$elm$html$Html$p,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('helper-link')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('By using the ActiveState Platform I consent and agree to the ActiveState '),
			A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$target('_blank'),
					$elm$html$Html$Attributes$href($author$project$Model$Legal$masterTermsOfService)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Master Terms of Service')
				])),
			$elm$html$Html$text(', '),
			A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$target('_blank'),
					$elm$html$Html$Attributes$href($author$project$Model$Legal$acceptableUsePolicy)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Acceptable Use Policy')
				])),
			$elm$html$Html$text(', and  '),
			A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$target('_blank'),
					$elm$html$Html$Attributes$href($author$project$Model$Legal$privacyPolicy)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Privacy Policy')
				])),
			$elm$html$Html$text('.')
		]));
var $author$project$Pages$Login$singleColumnLayout = function (_v0) {
	var model = _v0.zf;
	var sharedAttributes = _v0.z3;
	var heading = _v0.yu;
	var createAccountRoute = _v0.g4;
	var note = _v0.kd;
	var showSocialAuth = _v0.hf;
	return A2(
		$elm$html$Html$div,
		sharedAttributes,
		_List_fromArray(
			[
				A2($author$project$Pages$Login$logoBarWithAuthButton, createAccountRoute, 'Sign Up'),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('page-body login-page')
					]),
				_List_fromArray(
					[
						heading,
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('email-form-wrapper')
							]),
						_List_fromArray(
							[
								note,
								A2(
								$author$project$Misc$displayIf,
								showSocialAuth,
								A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('social-auth-wrapper')
										]),
									_List_fromArray(
										[
											A2($author$project$Views$AuthButton$view, 'Log in with GitHub', $author$project$Pages$Login$GithubAuth),
											A4(
											$author$project$Views$AuthButton$viewWithIcon,
											46,
											'Log in with SSO',
											$elm$core$Maybe$Just(
												$elm$html$Html$text('Single Sign-On is only available to certain organizations at this time.')),
											$author$project$Pages$Login$SSOAuth)
										]))),
								A2(
								$author$project$Misc$displayIf,
								showSocialAuth,
								$author$project$Pages$Login$authDivider('Or, log in with your Email')),
								$author$project$Pages$Login$emailForm(model),
								$author$project$Pages$Login$forgotPasswordLink,
								$author$project$Pages$Login$createAccountLink(createAccountRoute),
								$author$project$Pages$Login$tos,
								$author$project$Pages$Login$helpText
							]))
					]))
			]));
};
var $author$project$Pages$Login$GithubAuthCreate = {$: 9};
var $author$project$Pages$Login$singleColumnLayout_AccountNotFound = function (_v0) {
	var sharedAttributes = _v0.z3;
	var createAccountRoute = _v0.g4;
	var showSocialAuth = _v0.hf;
	return A2(
		$elm$html$Html$div,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class('account-not-found-page'),
			sharedAttributes),
		_List_fromArray(
			[
				A2($author$project$Pages$Login$logoBarWithAuthButton, createAccountRoute, 'Sign Up'),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('page-body')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('We couldn\'t find your Platform account')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('It looks like we were unable to find a platform account associated with your GitHub account. You can create a platform account with GitHub below or try signing into your platform account with the buttons below.')
							])),
						A2(
						$author$project$Misc$displayIf,
						showSocialAuth,
						A2($author$project$Views$AuthButton$view, 'Sign up via GitHub', $author$project$Pages$Login$GithubAuthCreate)),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('secondary-button'),
								$elm$html$Html$Attributes$href('/sign-in'),
								A2($elm$html$Html$Attributes$attribute, 'data-cy', 'login')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Sign in with existing account')
							])),
						$author$project$Pages$Login$helpText
					]))
			]));
};
var $author$project$Pages$Login$socialAuthSignIn = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('social-auth-wrapper')
		]),
	_List_fromArray(
		[
			A2($author$project$Views$AuthButton$view, 'Sign in with GitHub', $author$project$Pages$Login$GithubAuth)
		]));
var $author$project$Pages$Login$switchToCreateAccount = function (route) {
	return A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('login-switch')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('New user?'),
				A3(
				$author$project$Views$Link$link,
				route,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Create an Account')
					]))
			]));
};
var $author$project$Pages$Login$twoColumnLayout = function (_v0) {
	var model = _v0.zf;
	var sharedAttributes = _v0.z3;
	var createAccountRoute = _v0.g4;
	var showSocialAuth = _v0.hf;
	return A2(
		$elm$html$Html$div,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class('two-column'),
			sharedAttributes),
		_List_fromArray(
			[
				$author$project$Pages$Login$logoBar,
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('login-box')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-wrapper')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h1,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Sign In')
									])),
								$author$project$Pages$Login$switchToCreateAccount(createAccountRoute),
								A2($author$project$Misc$displayIf, showSocialAuth, $author$project$Pages$Login$socialAuthSignIn),
								A2(
								$author$project$Misc$displayIf,
								showSocialAuth,
								$author$project$Pages$Login$authDivider('Or, log in with your Email')),
								$author$project$Pages$Login$emailForm(model),
								$author$project$Pages$Login$forgotPasswordLink
							])),
						$author$project$Views$AuthContent$view(
						{dg: model.dg, Gb: model.nI})
					])),
				$author$project$Pages$Login$helpText
			]));
};
var $author$project$Pages$Login$view = F2(
	function (model, session) {
		var showSocialAuth = function () {
			var isKomodoTraffic = A2($elm$core$Maybe$withDefault, '', model.nI) === 'komodo';
			var isKSADomain = $author$project$Utils$DomainUtils$isKSADomain(
				$author$project$Model$Session$getFlags(session).B3);
			return (!isKomodoTraffic) && (!isKSADomain);
		}();
		var sharedAttributes = _List_fromArray(
			[
				$elm$html$Html$Attributes$id('auth-page'),
				$elm$html$Html$Attributes$class('sign-in-page'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('form-submitting', model.lX)
					]))
			]);
		var createAccountRoute = $author$project$Model$Route$CreateAccount(
			{h3: $elm$core$Maybe$Nothing, g$: model.g$, dH: model.dH, lJ: model.lJ, hx: model.tW, fs: model.dI.fs, dg: model.dg, o: model.nI});
		var _v0 = model.qm;
		switch (_v0.$) {
			case 0:
				var _v1 = model.lP;
				if (_v1.$ === 1) {
					return $author$project$Pages$Login$singleColumnLayout(
						{
							g4: createAccountRoute,
							yu: $author$project$Pages$Login$regularHeading,
							zf: model,
							kd: $elm$html$Html$text(''),
							z3: sharedAttributes,
							hf: showSocialAuth
						});
				} else {
					return $author$project$Pages$Login$singleColumnLayout_AccountNotFound(
						{g4: createAccountRoute, yu: $author$project$Pages$Login$regularHeading, zf: model, z3: sharedAttributes, hf: showSocialAuth});
				}
			case 1:
				return $author$project$Pages$Login$singleColumnLayout(
					{g4: createAccountRoute, yu: $author$project$Pages$Login$invitedHeading, zf: model, kd: $author$project$Pages$Login$invitedNote, z3: sharedAttributes, hf: showSocialAuth});
			case 5:
				return $author$project$Pages$Login$twoColumnLayout(
					{g4: createAccountRoute, zf: model, z3: sharedAttributes, hf: showSocialAuth});
			case 2:
				var projectName = _v0.a;
				var formattedProjectName = $elm_community$string_extra$String$Extra$toTitleCase(
					A3($elm$core$String$replace, '-', ' ', projectName));
				var heading = A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('top-line')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Log in and get your')
								])),
							$elm$html$Html$text('free ' + (formattedProjectName + ' download'))
						]));
				return $author$project$Pages$Login$singleColumnLayout(
					{
						g4: createAccountRoute,
						yu: heading,
						zf: model,
						kd: $elm$html$Html$text(''),
						z3: sharedAttributes,
						hf: showSocialAuth
					});
			case 3:
				var maybeLanguage = _v0.a;
				var maybeLanguageVersion = _v0.b;
				var heading = function () {
					if (!maybeLanguage.$) {
						var language = maybeLanguage.a;
						return A2(
							$elm$html$Html$h1,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('top-line')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Log in and get your')
										])),
									$elm$html$Html$text(
									'free ' + ($elm_community$string_extra$String$Extra$toTitleCase(
										$author$project$Model$Language$toString(language)) + (' ' + (A2($elm$core$Maybe$withDefault, '', maybeLanguageVersion) + ' download'))))
								]));
					} else {
						return $author$project$Pages$Login$regularHeading;
					}
				}();
				return $author$project$Pages$Login$singleColumnLayout(
					{
						g4: createAccountRoute,
						yu: heading,
						zf: model,
						kd: $elm$html$Html$text(''),
						z3: sharedAttributes,
						hf: showSocialAuth
					});
			case 4:
				var heading = A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('top-line')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Log in and build your')
								])),
							$elm$html$Html$text('free Python environment')
						]));
				return $author$project$Pages$Login$singleColumnLayout(
					{
						g4: createAccountRoute,
						yu: heading,
						zf: model,
						kd: $elm$html$Html$text(''),
						z3: sharedAttributes,
						hf: showSocialAuth
					});
			default:
				return $author$project$Pages$Login$singleColumnLayout(
					{
						g4: createAccountRoute,
						yu: $author$project$Pages$Login$regularHeading,
						zf: model,
						kd: $elm$html$Html$text(''),
						z3: sharedAttributes,
						hf: showSocialAuth
					});
		}
	});
var $author$project$Pages$NotFound$Dismiss = 0;
var $author$project$Pages$NotFound$viewModal = F2(
	function (emotion, modalStatus) {
		var modalClass = function () {
			var fakeModal = 'fake-modal';
			return (modalStatus === 2) ? $elm$html$Html$Attributes$class(fakeModal + ' dismissed') : $elm$html$Html$Attributes$class(fakeModal);
		}();
		var emotionClass = function () {
			var computer = 'computer';
			if (!emotion) {
				return $elm$html$Html$Attributes$class(computer + ' happy');
			} else {
				return $elm$html$Html$Attributes$class(computer + ' sad');
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[modalClass]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('The computer is so sorry')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('It is ashamed and it wants to apologize.')
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('secondary-button small'),
							$elm$html$Html$Events$onClick(0)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Hey, it\'s all good.')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[emotionClass]),
					_List_Nil)
				]));
	});
var $author$project$Pages$NotFound$view = function (model) {
	return A2(
		$elm$html$Html$main_,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('page not-found')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('We\'re not sure what went wrong! Maybe you got the wrong URL?')
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Views$Link$link,
						$author$project$Model$Route$Protected(
							$author$project$Model$Route$Home(
								{wd: $elm$core$Maybe$Nothing})),
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('primary-button')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Back to your dashboard')
							]))
					])),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('secondary-info')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('If this keeps happening, please let us know at '),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href('mailto:support@activestate.com')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('support@activestate.com')
							]))
					])),
				A2(
				$author$project$Misc$displayIf,
				!(!model.j8),
				A2($author$project$Pages$NotFound$viewModal, model.qS, model.j8))
			]));
};
var $author$project$Pages$OrgDependencies$depMatches = F2(
	function (search, dep) {
		return (search === '') || function () {
			var lowerSearch = $elm$core$String$trim(
				$elm$core$String$toLower(search));
			var exactMatch = A2($elm$core$String$startsWith, '\"', search) && A2($elm$core$String$endsWith, '\"', search);
			var containsOrMatches = function (haystack) {
				return exactMatch ? _Utils_eq(
					$elm$core$String$toLower(haystack),
					A3($elm$core$String$replace, '\"', '', lowerSearch)) : A2(
					$elm$core$String$contains,
					A3($elm$core$String$replace, '\"', '', lowerSearch),
					$elm$core$String$toLower(haystack));
			};
			return containsOrMatches(dep.w + (' ' + dep.aI)) || (containsOrMatches(dep.aC) || A2($elm$core$List$any, containsOrMatches, dep.gx));
		}();
	});
var $author$project$Pages$OrgDependencies$withLengthFirst = function (list) {
	return _Utils_Tuple2(
		$elm$core$List$length(list),
		list);
};
var $author$project$Pages$OrgDependencies$sortByProjects = function (dep) {
	return $author$project$Pages$OrgDependencies$withLengthFirst(
		A2($elm$core$List$map, $elm$core$String$toLower, dep.gx));
};
var $author$project$Model$Severity$all = _List_fromArray(
	[0, 1, 2, 3, 4]);
var $author$project$Model$Severity$allWithHighestFirst = A2($elm$core$List$sortBy, $author$project$Model$Severity$sortKey, $author$project$Model$Severity$all);
var $author$project$Model$SeverityHistogram$sortKey = function (_v0) {
	var dict = _v0;
	return A2(
		$elm$core$List$map,
		A2(
			$elm$core$Basics$composeR,
			$author$project$Model$Severity$sortKey,
			A2(
				$elm$core$Basics$composeR,
				A2($elm_community$basics_extra$Basics$Extra$flip, $elm$core$Dict$get, dict),
				$elm$core$Maybe$withDefault(0))),
		$author$project$Model$Severity$allWithHighestFirst);
};
var $author$project$Pages$OrgDependencies$filterDeps = F2(
	function (model, deps) {
		var sortBy = function () {
			var _v1 = model.ny;
			if (!_v1) {
				return $elm$core$List$sortBy;
			} else {
				return function (extract) {
					return $elm$core$List$sortWith(
						F2(
							function (a, b) {
								return $author$project$Misc$reverseOrder(
									A2(
										$elm$core$Basics$compare,
										extract(a),
										extract(b)));
							}));
				};
			}
		}();
		var filterBySeverity = function (dep) {
			return (model.i2 && dep.q0) || ((model.i3 && dep.q1) || ((model.i5 && dep.q3) || ((model.i4 && dep.q2) || ((model.jS && dep.q5) || (model.i6 && dep.q4)))));
		};
		var filterByLanguage = function (dep) {
			return A2($elm$core$Set$member, dep.aC, model.hw);
		};
		var filteredRows = A2(
			$elm$core$List$filter,
			$author$project$Pages$OrgDependencies$depMatches(model.kt),
			A2(
				$elm$core$List$filter,
				filterByLanguage,
				A2($elm$core$List$filter, filterBySeverity, deps)));
		var _v0 = model.nx;
		switch (_v0) {
			case 0:
				return A2(
					sortBy,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.w;
						},
						$elm$core$String$toLower),
					filteredRows);
			case 1:
				return A2(
					sortBy,
					function ($) {
						return $.aC;
					},
					filteredRows);
			case 2:
				return A2(sortBy, $author$project$Pages$OrgDependencies$sortByProjects, filteredRows);
			default:
				return A2(
					sortBy,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.F2;
						},
						$author$project$Model$SeverityHistogram$sortKey),
					filteredRows);
		}
	});
var $author$project$Pages$OrgDependencies$loadingDummyDeps = A2(
	$elm$core$List$repeat,
	5,
	{q0: false, q1: false, q2: false, q3: false, q4: false, q5: false, aC: '', w: '', gx: _List_Nil, k: '', F2: $author$project$Model$SeverityHistogram$empty, aI: ''});
var $author$project$Pages$OrgDependencies$ClearSearchInputValue = {$: 2};
var $author$project$Pages$OrgDependencies$IncrTakeCount = {$: 9};
var $author$project$Pages$OrgDependencies$ResetFilter = {$: 4};
var $author$project$Pages$OrgDependencies$ScrollUp = {$: 10};
var $author$project$Pages$OrgDependencies$SetSearchInputValue = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$OrgDependencies$SetSortColumn = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$OrgDependencies$ToggleFilterLanguage = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$OrgDependencies$ToggleFilterSeverity = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$OrgDependencies$ToggleFilterSeverityNone = {$: 6};
var $author$project$Pages$OrgDependencies$Language = 1;
var $author$project$Pages$OrgDependencies$Package = 0;
var $author$project$Pages$OrgDependencies$Projects = 2;
var $author$project$Pages$OrgDependencies$allColumns = _List_fromArray(
	[0, 1, 3, 2]);
var $author$project$Pages$OrgDependencies$allFilterSeverities = _List_fromArray(
	[4, 3, 2, 1, 0]);
var $elm$html$Html$Attributes$colspan = function (n) {
	return A2(
		_VirtualDom_attribute,
		'colspan',
		$elm$core$String$fromInt(n));
};
var $author$project$Pages$OrgDependencies$columnClass = function (column) {
	switch (column) {
		case 0:
			return 'deps-package';
		case 1:
			return 'deps-language';
		case 2:
			return 'deps-projects';
		default:
			return 'deps-vulnerabilities';
	}
};
var $author$project$Pages$OrgDependencies$columnString = function (column) {
	switch (column) {
		case 0:
			return 'Package';
		case 1:
			return 'Language';
		case 2:
			return 'Projects';
		default:
			return 'Vulnerabilities';
	}
};
var $author$project$Pages$OrgDependencies$isCheckedSeverity = F2(
	function (severity, model) {
		switch (severity) {
			case 4:
				return model.i2;
			case 3:
				return model.i3;
			case 2:
				return model.i5;
			case 1:
				return model.i4;
			default:
				return model.jS;
		}
	});
var $author$project$Pages$OrgDependencies$severityWithText = function (severity) {
	var severityClass = 'severity-' + $author$project$Model$Severity$toString(severity);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('severity-with-text level-summary ' + severityClass)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(' severity-dot ' + severityClass)
					]),
				_List_Nil),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('cve-severity')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm_community$string_extra$String$Extra$toTitleCase(
							$author$project$Model$Severity$toString(severity)))
					]))
			]));
};
var $elm$html$Html$tbody = _VirtualDom_node('tbody');
var $author$project$Model$Severity$fromSortKey = function (key) {
	switch (key) {
		case 0:
			return $elm$core$Maybe$Just(4);
		case 1:
			return $elm$core$Maybe$Just(3);
		case 2:
			return $elm$core$Maybe$Just(2);
		case 3:
			return $elm$core$Maybe$Just(1);
		case 4:
			return $elm$core$Maybe$Just(0);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$SeverityHistogram$toList = function (_v0) {
	var dict = _v0;
	return A2(
		$elm$core$List$filterMap,
		function (_v1) {
			var severityIndex = _v1.a;
			var count = _v1.b;
			return A2(
				$elm$core$Maybe$map,
				function (severity) {
					return {cO: count, ck: severity};
				},
				$author$project$Model$Severity$fromSortKey(severityIndex));
		},
		$elm$core$Dict$toList(dict));
};
var $author$project$Model$SeverityHistogram$total = function (_v0) {
	var dict = _v0;
	return A3(
		$elm$core$Dict$foldl,
		F3(
			function (_v1, v, acc) {
				return acc + v;
			}),
		0,
		dict);
};
var $author$project$Pages$OrgDependencies$truncatedListView = F2(
	function (mapper, list) {
		var limit = 5;
		var count = $elm$core$List$length(list);
		var all = A2($elm$core$List$map, mapper, list);
		return (_Utils_cmp(count, limit) < 1) ? _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('project-list')
					]),
				all)
			]) : _List_fromArray(
			[
				A2(
				$elm$html$Html$details,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$summary,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(count) + ' projects')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('project-list')
							]),
						all)
					]))
			]);
	});
var $author$project$Model$SeverityHistogram$addEmptyCategories = function (_v0) {
	var histogram = _v0;
	var updatedSeverityList = A2(
		$elm$core$List$map,
		function (severityIndex) {
			var _v1 = A2($elm$core$Dict$get, severityIndex, histogram);
			if (!_v1.$) {
				var value = _v1.a;
				return _Utils_Tuple2(severityIndex, value);
			} else {
				return _Utils_Tuple2(severityIndex, 0);
			}
		},
		_List_fromArray(
			[0, 1, 2, 3, 4]));
	return $elm$core$Dict$fromList(updatedSeverityList);
};
var $author$project$Views$CVESummary$viewSeverityCount = F3(
	function (expanded, maybeClickHandler, _v0) {
		var severity = _v0.ck;
		var count = _v0.cO;
		var severityStr = $author$project$Model$Severity$toString(severity);
		var severityClass = 'severity-' + severityStr;
		var _v1 = function () {
			if (!maybeClickHandler.$) {
				var clickHandler = maybeClickHandler.a;
				return _Utils_Tuple2(
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							clickHandler(severity))
						]),
					!(!count));
			} else {
				return _Utils_Tuple2(_List_Nil, false);
			}
		}();
		var clickAttribute = _v1.a;
		var hasClickHandler = _v1.b;
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$append,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('level-summary more-info-tooltip'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('severity-empty', !count),
								_Utils_Tuple2('isClickable', hasClickHandler)
							]))
					]),
				clickAttribute),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('severity-dot ' + severityClass)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Misc$displayIf,
							!expanded,
							$elm$html$Html$text(
								$elm$core$String$fromInt(count)))
						])),
					A2(
					$author$project$Misc$displayIf,
					expanded,
					A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('cve-count')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(count))
							]))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('content')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(count)),
							$elm$html$Html$text(' '),
							$elm$html$Html$text(severityStr + ' severity CVEs')
						]))
				]));
	});
var $author$project$Views$CVESummary$viewTotals = function (_v0) {
	var severityHistogram = _v0.F2;
	var compactView = _v0.xI;
	var maybeClickHandler = _v0.y7;
	var maybeSeverityClickHandler = _v0.zd;
	var updatedHistogram = $author$project$Model$SeverityHistogram$addEmptyCategories(severityHistogram);
	var hasVulnerabilities = !$elm$core$List$isEmpty(
		$author$project$Model$SeverityHistogram$toList(severityHistogram));
	var _v1 = function () {
		if (!maybeClickHandler.$) {
			var clickHandler = maybeClickHandler.a;
			return hasVulnerabilities ? _Utils_Tuple2(
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(clickHandler)
					]),
				true) : _Utils_Tuple2(
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(clickHandler)
					]),
				false);
		} else {
			return _Utils_Tuple2(_List_Nil, false);
		}
	}();
	var clickAttribute = _v1.a;
	var hasClickHandler = _v1.b;
	return A2(
		$elm$html$Html$div,
		A2(
			$elm$core$List$append,
			clickAttribute,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('cve-counts'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('compact', compactView),
							_Utils_Tuple2('isClickable', hasClickHandler && hasVulnerabilities)
						]))
				])),
		A2(
			$elm$core$List$map,
			A2($author$project$Views$CVESummary$viewSeverityCount, !compactView, maybeSeverityClickHandler),
			$author$project$Model$SeverityHistogram$toList(updatedHistogram)));
};
var $author$project$Pages$OrgDependencies$viewDeps = F4(
	function (model, loading, deps, languages) {
		var severityHistogram = $author$project$Model$SeverityHistogram$fromSeverityCounts(
			A2(
				$elm$core$List$concatMap,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.F2;
					},
					$author$project$Model$SeverityHistogram$toList),
				deps));
		var severityFilterRow = function (severity) {
			var id_ = 'filter-severity-' + $author$project$Model$Severity$toString(severity);
			return A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('checkbox'),
								$elm$html$Html$Attributes$id(id_),
								$elm$html$Html$Attributes$checked(
								A2($author$project$Pages$OrgDependencies$isCheckedSeverity, severity, model)),
								$elm$html$Html$Events$onInput(
								$elm$core$Basics$always(
									$author$project$Pages$OrgDependencies$ToggleFilterSeverity(severity)))
							]),
						_List_Nil),
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$for(id_)
							]),
						_List_fromArray(
							[
								$author$project$Pages$OrgDependencies$severityWithText(severity)
							]))
					]));
		};
		var severityFilterRows = A2($elm$core$List$map, severityFilterRow, $author$project$Pages$OrgDependencies$allFilterSeverities);
		var safeFilterRow = function () {
			var id_ = 'filter-severity-safe';
			return A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('checkbox'),
								$elm$html$Html$Attributes$id(id_),
								$elm$html$Html$Attributes$checked(model.i6),
								$elm$html$Html$Events$onInput(
								$elm$core$Basics$always($author$project$Pages$OrgDependencies$ToggleFilterSeverityNone))
							]),
						_List_Nil),
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$for(id_)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('severity-with-text level-summary severity-safe')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class(' severity-dot severity-safe')
											]),
										_List_Nil),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('cve-severity')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('None')
											]))
									]))
							]))
					]));
		}();
		var projectLink = function (projectName) {
			return A3(
				$author$project$Views$Link$link,
				A2(
					$author$project$Model$Route$projectConfig,
					{ix: model.c3.AC, vT: projectName},
					$author$project$Model$Route$projectConfigParams),
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(projectName)
					]));
		};
		var percentDecodeOrInput = function (input) {
			return A2(
				$elm$core$Maybe$withDefault,
				input,
				$elm$url$Url$percentDecode(input));
		};
		var nbrActiveFilters = function () {
			var oneIfSeverityActive = ((!model.i2) || ((!model.i3) || ((!model.i5) || ((!model.i4) || (!model.i6))))) ? 1 : 0;
			var oneIfLanguageActive = (!_Utils_eq(
				$elm$core$Set$size(model.hw),
				$elm$core$List$length(languages))) ? 1 : 0;
			return oneIfSeverityActive + oneIfLanguageActive;
		}();
		var languageFilterRow = function (language) {
			var id_ = 'dependency-language-' + language;
			return A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('checkbox'),
								$elm$html$Html$Attributes$id(id_),
								$elm$html$Html$Attributes$checked(
								A2($elm$core$Set$member, language, model.hw)),
								$elm$html$Html$Events$onInput(
								$elm$core$Basics$always(
									$author$project$Pages$OrgDependencies$ToggleFilterLanguage(language)))
							]),
						_List_Nil),
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$for(id_)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(language)
							]))
					]));
		};
		var languageFilterRows = A2($elm$core$List$map, languageFilterRow, languages);
		var isOpen = model.lW;
		var hiddenColumnLabel = function (column) {
			return A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(
						$author$project$Pages$OrgDependencies$columnClass(column))
					]),
				_List_Nil);
		};
		var hasSearchOrFilter = (!$elm$core$String$isEmpty(model.kt)) || (nbrActiveFilters > 0);
		var depView = function (dep) {
			return A2(
				$elm$html$Html$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								percentDecodeOrInput(dep.w)),
								$elm$html$Html$text(' '),
								$elm$html$Html$text(
								percentDecodeOrInput(dep.aI))
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(dep.aC)
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Views$CVESummary$viewTotals(
								{xI: true, y7: $elm$core$Maybe$Nothing, zd: $elm$core$Maybe$Nothing, F2: dep.F2})
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('dependency-projects')
							]),
						A2(
							$author$project$Pages$OrgDependencies$truncatedListView,
							$elm$core$Basics$identity,
							A2(
								$elm$core$List$map,
								projectLink,
								A2($elm$core$List$sortBy, $elm$core$String$toLower, dep.gx))))
					]));
		};
		var columnLabel = function (column) {
			var isTheActiveColumn = _Utils_eq(model.nx, column);
			return A2(
				$elm$html$Html$th,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								$author$project$Pages$OrgDependencies$columnClass(column),
								true),
								_Utils_Tuple2('sorted', isTheActiveColumn && (!loading))
							])),
						$elm$html$Html$Attributes$class('sortable')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('heading'),
								$elm$html$Html$Events$onClick(
								$author$project$Pages$OrgDependencies$SetSortColumn(column))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('heading-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Pages$OrgDependencies$columnString(column))
									])),
								function () {
								var visbleSortDirection = isTheActiveColumn ? model.ny : $author$project$Pages$OrgDependencies$defaultSortDireciton;
								var iconKind = function () {
									if (!visbleSortDirection) {
										return 12;
									} else {
										return 14;
									}
								}();
								return $author$project$Views$Icon$view(
									A2(
										$author$project$Views$Icon$colored,
										$author$project$Style$color('grey'),
										A2(
											$author$project$Views$Icon$square,
											13,
											$author$project$Views$Icon$icon(iconKind))));
							}()
							]))
					]));
		};
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('org-dependencies-page'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('dependencies-loading', loading)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sortable-table-wrapper'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('loading', loading)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Misc$displayIf,
							loading,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('loading-shimmer')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('gradient-wrapper')
											]),
										_List_Nil)
									]))),
							A2(
							$elm$html$Html$table,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$thead,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$tr,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('hidden-row')
												]),
											A2($elm$core$List$map, hiddenColumnLabel, $author$project$Pages$OrgDependencies$allColumns)),
											A2(
											$elm$html$Html$tr,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$td,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$colspan(4)
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('filter-ui')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('filter-row')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$h2,
																			_List_Nil,
																			_List_fromArray(
																				[
																					A2(
																					$elm$html$Html$span,
																					_List_fromArray(
																						[
																							$elm$html$Html$Attributes$class('item-count')
																						]),
																					_List_fromArray(
																						[
																							$elm$html$Html$text(
																							$elm$core$String$fromInt(
																								$elm$core$List$length(deps)))
																						])),
																					$elm$html$Html$text(' Dependencies')
																				])),
																			$author$project$Views$InlineSearchBar$inlineSearchBar(
																			{
																				Bx: $author$project$Pages$OrgDependencies$SetSearchInputValue,
																				BG: $elm$core$Maybe$Just($author$project$Pages$OrgDependencies$ClearSearchInputValue),
																				j0: model.kt,
																				Fd: 'Search by package, project or language'
																			}),
																			A2(
																			$author$project$Misc$displayIf,
																			nbrActiveFilters > 0,
																			A2(
																				$elm$html$Html$button,
																				_List_fromArray(
																					[
																						$elm$html$Html$Events$onClick($author$project$Pages$OrgDependencies$ResetFilter),
																						$elm$html$Html$Attributes$class('secondary-button reset-filter-button')
																					]),
																				_List_fromArray(
																					[
																						$elm$html$Html$text('Reset')
																					]))),
																			A2(
																			$elm$html$Html$div,
																			_List_fromArray(
																				[
																					$elm$html$Html$Attributes$class('dropdown')
																				]),
																			_List_fromArray(
																				[
																					A2(
																					$elm$html$Html$button,
																					_List_fromArray(
																						[
																							$elm$html$Html$Events$onClick($author$project$Pages$OrgDependencies$ToggleFilterDropdown),
																							$elm$html$Html$Attributes$id($author$project$Pages$OrgDependencies$filterButtonId),
																							$elm$html$Html$Attributes$classList(
																							_List_fromArray(
																								[
																									_Utils_Tuple2('active', isOpen),
																									_Utils_Tuple2('secondary-button', !isOpen),
																									_Utils_Tuple2('primary-button', isOpen)
																								]))
																						]),
																					_List_fromArray(
																						[
																							$author$project$Views$Icon$view(
																							$author$project$Views$Icon$small(
																								A2(
																									$author$project$Views$Icon$colored,
																									$author$project$Style$color('blue'),
																									$author$project$Views$Icon$icon(26)))),
																							$elm$html$Html$text(
																							'Filter' + ((nbrActiveFilters > 0) ? (' (' + ($elm$core$String$fromInt(nbrActiveFilters) + ')')) : ''))
																						])),
																					A2(
																					$elm$html$Html$div,
																					_List_fromArray(
																						[
																							$elm$html$Html$Attributes$classList(
																							_List_fromArray(
																								[
																									_Utils_Tuple2('dropdown-menu', true),
																									_Utils_Tuple2('visible', isOpen),
																									_Utils_Tuple2('hidden', !isOpen)
																								])),
																							$elm$html$Html$Attributes$id($author$project$Pages$OrgDependencies$filterDropdownId)
																						]),
																					_List_fromArray(
																						[
																							A2(
																							$elm$html$Html$div,
																							_List_fromArray(
																								[
																									$elm$html$Html$Attributes$class('filter-dropdown-container')
																								]),
																							A2(
																								$elm$core$List$cons,
																								A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$elm$html$Html$Attributes$class('filter-dropdown-heading')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('Severity')
																										])),
																								_Utils_ap(
																									severityFilterRows,
																									A2(
																										$elm$core$List$cons,
																										safeFilterRow,
																										A2(
																											$elm$core$List$cons,
																											A2(
																												$elm$html$Html$span,
																												_List_fromArray(
																													[
																														$elm$html$Html$Attributes$class('filter-dropdown-heading')
																													]),
																												_List_fromArray(
																													[
																														$elm$html$Html$text('Language')
																													])),
																											_Utils_ap(
																												languageFilterRows,
																												_List_fromArray(
																													[
																														A2(
																														$elm$html$Html$button,
																														_List_fromArray(
																															[
																																$elm$html$Html$Events$onClick($author$project$Pages$OrgDependencies$ResetFilter),
																																$elm$html$Html$Attributes$class('secondary-button small reset-filter-button')
																															]),
																														_List_fromArray(
																															[
																																$elm$html$Html$text('Reset Filter')
																															]))
																													])))))))
																						]))
																				]))
																		])),
																	A2(
																	$author$project$Misc$displayIf,
																	!loading,
																	A2(
																		$elm$html$Html$div,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('cve-summary-total')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$elm$html$Html$span,
																				_List_Nil,
																				_List_fromArray(
																					[
																						$elm$html$Html$text(
																						$elm$core$String$fromInt(
																							$author$project$Model$SeverityHistogram$total(severityHistogram))),
																						$elm$html$Html$text(' Vulnerabilities ')
																					])),
																				$author$project$Views$CVESummary$viewTotals(
																				{xI: false, y7: $elm$core$Maybe$Nothing, zd: $elm$core$Maybe$Nothing, F2: severityHistogram})
																			])))
																]))
														]))
												])),
											A2(
											$elm$html$Html$tr,
											_List_Nil,
											A2($elm$core$List$map, columnLabel, $author$project$Pages$OrgDependencies$allColumns)),
											A2(
											$elm$html$Html$tr,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$td,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$colspan(4)
														]),
													_List_fromArray(
														[
															A2($elm$html$Html$hr, _List_Nil, _List_Nil)
														]))
												]))
										])),
									A2(
									$elm$html$Html$tbody,
									_List_Nil,
									A2(
										$elm$core$List$map,
										depView,
										A2($elm$core$List$take, model.jy, deps)))
								])),
							function () {
							var displayingCount = (_Utils_cmp(
								model.jy,
								$elm$core$List$length(deps)) > 0) ? $elm$core$List$length(deps) : model.jy;
							var showLoadMoreButton = (!loading) && (_Utils_cmp(
								$elm$core$List$length(deps),
								displayingCount) > 0);
							return A2(
								$author$project$Misc$displayIf,
								showLoadMoreButton,
								A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('load-more')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											'Showing ' + ($elm$core$String$fromInt(displayingCount) + (' of ' + $elm$core$String$fromInt(
												$elm$core$List$length(deps))))),
											A2(
											$author$project$Misc$displayIf,
											_Utils_cmp(
												model.jy,
												$elm$core$List$length(deps)) < 0,
											A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('text-button'),
														$elm$html$Html$Events$onClick($author$project$Pages$OrgDependencies$IncrTakeCount)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Show more')
													]))),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-button'),
													$elm$html$Html$Events$onClick($author$project$Pages$OrgDependencies$ScrollUp)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Back to top')
												]))
										])));
						}(),
							A2(
							$author$project$Misc$displayIf,
							$elm$core$List$isEmpty(deps) && (!loading),
							A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('no-results')
									]),
								_List_fromArray(
									[
										hasSearchOrFilter ? $elm$html$Html$text('No dependencies match your criteria.') : $elm$html$Html$text('No dependencies detected.')
									])))
						]))
				]));
	});
var $author$project$Pages$OrgDependencies$view = function (model) {
	var _v0 = model.lx;
	switch (_v0.$) {
		case 0:
			return A4($author$project$Pages$OrgDependencies$viewDeps, model, true, $author$project$Pages$OrgDependencies$loadingDummyDeps, _List_Nil);
		case 1:
			var err = _v0.a;
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('cve-loading-error')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Error loading data')
							])),
						$elm$html$Html$text(
						' — \"' + ($author$project$Model$Message$reason(err) + '\"'))
					]));
		default:
			var depsData = _v0.a;
			return A4(
				$author$project$Pages$OrgDependencies$viewDeps,
				model,
				false,
				A2($author$project$Pages$OrgDependencies$filterDeps, model, depsData.qP),
				depsData.aM);
	}
};
var $author$project$Pages$OrgIndex$CreateProjectFromSBOM = {$: 13};
var $author$project$Views$CreateProjectFromSBOM$isFormSubmitting = function (model) {
	return model.jV;
};
var $author$project$Views$CreateProjectFromSBOM$ClearSBOM = {$: 4};
var $author$project$Views$CreateProjectFromSBOM$NewProjectName = function (a) {
	return {$: 1, a: a};
};
var $author$project$Views$CreateProjectFromSBOM$SelectSBOM = {$: 3};
var $author$project$Views$CreateProjectFromSBOM$SwitchVisibility = function (a) {
	return {$: 2, a: a};
};
var $author$project$Views$CreateProjectFromSBOM$NoOp = {$: 0};
var $author$project$Views$CreateProjectFromSBOM$visibilityOption = F6(
	function (isDisabled, classString, isChecked, msgOnClick, optionName, optionDescription) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('option ' + classString),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('selected', isChecked)
						])),
					$elm$html$Html$Events$onClick(msgOnClick)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('radio'),
							$elm$html$Html$Attributes$id(optionName),
							$elm$html$Html$Attributes$checked(isChecked),
							$elm$html$Html$Attributes$disabled(isDisabled)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('primary-icon'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('disabled', isDisabled)
								]))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$for(optionName)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('option-name')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(optionName)
										]))
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('option-description')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(optionDescription)
								]))
						]))
				]));
	});
var $author$project$Views$CreateProjectFromSBOM$disabledVisibilityOption = function (_v0) {
	var className = _v0.BD;
	var optionName = _v0.kk;
	var description = _v0.bP;
	return A6($author$project$Views$CreateProjectFromSBOM$visibilityOption, true, className + ' disabled-option', false, $author$project$Views$CreateProjectFromSBOM$NoOp, optionName, description);
};
var $author$project$Views$CreateProjectFromSBOM$visibilitySelector = F3(
	function (orgName, privateProjectsEnabled, visibility) {
		var publicCopy = 'Only members of \"' + (orgName + '\" can modify this project, but any user of the ActiveState Platform can view it.');
		var privateCopy = 'Only members of \"' + (orgName + '\" can modify and view this project.');
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('visibility-selector-wrapper')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('visibility-selector-new')
						]),
					_List_fromArray(
						[
							A6(
							$author$project$Views$CreateProjectFromSBOM$visibilityOption,
							false,
							'public',
							visibility === 1,
							$author$project$Views$CreateProjectFromSBOM$SwitchVisibility(1),
							'Public',
							publicCopy),
							privateProjectsEnabled ? A6(
							$author$project$Views$CreateProjectFromSBOM$visibilityOption,
							false,
							'private',
							!visibility,
							$author$project$Views$CreateProjectFromSBOM$SwitchVisibility(0),
							'Private',
							privateCopy) : $author$project$Views$CreateProjectFromSBOM$disabledVisibilityOption(
							{BD: 'private', bP: privateCopy, kk: 'Private'})
						]))
				]));
	});
var $author$project$Views$CreateProjectFromSBOM$view = function (model) {
	var projectNameReformatted = function () {
		var formatted = $author$project$Validation$formatProjectName(model.vT);
		return (!_Utils_eq(formatted, model.vT)) ? $elm$core$Maybe$Just(formatted) : $elm$core$Maybe$Nothing;
	}();
	var projectUrl = _Utils_ap(
		model.t0,
		$author$project$Model$Route$routeToString(
			$author$project$Model$Route$projectOverview(
				$author$project$Model$Route$projectOverviewParams(
					{
						ix: $author$project$Model$Organization$getUrlName(model.c3),
						vT: A2($elm$core$Maybe$withDefault, model.vT, projectNameReformatted)
					}))));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('create-project-form upload-sbom-form'),
				$elm$html$Html$Attributes$class('form')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h1,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Upload SBOM')
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Create a new project to inspect your Software Bill of Materials and turn it into an editable set of components that can be remediated and deployed.')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('field-section')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('SBOM file')
									]))
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('field-info')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('We support '),
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('SPDX')
									])),
								$elm$html$Html$text(', '),
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('CycloneDX')
									])),
								$elm$html$Html$text(', and '),
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Syft')
									])),
								$elm$html$Html$text('. For more details, please see our '),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href('https://docs.activestate.com/platform/projects/projects_index/#supported-sbom-formats'),
										$elm$html$Html$Attributes$target('_blank')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('documentation')
									])),
								$elm$html$Html$text('.')
							])),
						function () {
						var _v0 = model.lU;
						if (!_v0.$) {
							var _v1 = _v0.a;
							var file = _v1.a;
							var contents = _v1.b;
							var sizeKB = ($elm$core$String$length(contents) / 1024) | 0;
							var sizeKbStr = (sizeKB <= 0) ? '<1' : $elm$core$String$fromInt(sizeKB);
							return A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('uploaded-file')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										'   ' + ($elm$file$File$name(file) + (' (' + (sizeKbStr + ' KB)')))),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Events$onClick($author$project$Views$CreateProjectFromSBOM$ClearSBOM)
											]),
										_List_fromArray(
											[
												$author$project$Views$Icon$view(
												$author$project$Views$Icon$icon(81))
											]))
									]));
						} else {
							return A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('button'),
										$elm$html$Html$Attributes$class('secondary-button'),
										$elm$html$Html$Events$onClick($author$project$Views$CreateProjectFromSBOM$SelectSBOM)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Choose file...')
									]));
						}
					}()
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('field-section'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'error',
								!_Utils_eq(model.pt, $elm$core$Maybe$Nothing))
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Project name')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$placeholder('Ex. \"machine-learning-runtime\"'),
										$elm$html$Html$Attributes$id('project-name'),
										$elm$html$Html$Attributes$type_('text'),
										$elm$html$Html$Events$onInput($author$project$Views$CreateProjectFromSBOM$NewProjectName),
										$elm$html$Html$Attributes$spellcheck(false),
										$elm$html$Html$Attributes$maxlength($author$project$Validation$maxProjectNameLength),
										$elm$html$Html$Attributes$value(model.vT),
										A2($elm$html$Html$Attributes$attribute, 'data-cy', 'type-project-name')
									]),
								_List_Nil)
							])),
						function () {
						var _v2 = model.pt;
						if (!_v2.$) {
							var projectNameError = _v2.a;
							return A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('field-error')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(projectNameError)
									]));
						} else {
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('project-url-indicator')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Will be accessible at '),
										A2(
										$elm$html$Html$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(projectUrl)
											]))
									]));
						}
					}()
					])),
				$author$project$Views$NotificationsInline$view(model),
				A2(
				$author$project$Misc$displayIf,
				$author$project$Model$Permissions$orgCanCreatePrivateProject(model.c3),
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('field-section')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Project access')
										]))
								])),
							A3(
							$author$project$Views$CreateProjectFromSBOM$visibilitySelector,
							model.c3.AC,
							$author$project$Model$Permissions$orgCanCreatePrivateProject(model.c3),
							model.p9)
						])))
			]));
};
var $author$project$Pages$OrgIndex$ChangeProjectSelection = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$OrgIndex$ChangeSearch = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$OrgIndex$ChangeSort = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$OrgIndex$ChangeTag = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$OrgIndex$ClearFilters = {$: 4};
var $author$project$Pages$OrgIndex$OpenCreateProjectFromSBOM = {$: 12};
var $author$project$Model$SeverityHistogram$insert = F2(
	function (severity, histogram) {
		return A2(
			$author$project$Model$SeverityHistogram$insertCount,
			$author$project$Model$SeverityCount$singleton(severity),
			histogram);
	});
var $author$project$Model$SeverityHistogram$fromVulnerabilities = function (vulnerabilities) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (v, a) {
				return A2($author$project$Model$SeverityHistogram$insert, v.ck, a);
			}),
		$author$project$Model$SeverityHistogram$empty,
		vulnerabilities);
};
var $author$project$Model$Permissions$orgHasUnlimitedProjectAddon = $author$project$Model$Organization$addOnEnabled('unlimited_projects');
var $author$project$Model$Permissions$orgCanCreateMoreProjects = F2(
	function (_v0, org) {
		var currentNumProjects = _v0.B4;
		var freeTierProjectsLimit = 1;
		return $author$project$Model$Permissions$orgHasUnlimitedProjectAddon(org) || (_Utils_cmp(currentNumProjects, freeTierProjectsLimit) < 0);
	});
var $author$project$Misc$pluralizeNoNumber = F3(
	function (singular, plural, count) {
		return (count === 1) ? singular : plural;
	});
var $author$project$Views$ProjectList$AllProjects = 0;
var $author$project$Views$NewProjectButton$contents = _List_fromArray(
	[
		$elm$html$Html$text('New Project')
	]);
var $author$project$Views$NewProjectButton$active = function (orgUrlName) {
	return A3(
		$author$project$Views$Link$link,
		$author$project$Model$Route$Protected(
			$author$project$Model$Route$CreateProject(
				{B2: $author$project$Model$Route$emptyCreateProjectParams, ix: orgUrlName})),
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('secondary-button')
			]),
		$author$project$Views$NewProjectButton$contents);
};
var $author$project$Model$Permissions$orgCanIngestSBOMs = $author$project$Model$Organization$addOnEnabled('sbom_ingestion');
var $author$project$Views$ProjectList$orgFilteredProjects = F2(
	function (orgFilter, projects) {
		if (!orgFilter.$) {
			var org = orgFilter.a;
			return A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.c5;
					},
					A2(
						$elm$core$Basics$composeR,
						$author$project$Model$Project$getOrganizationId,
						A2(
							$elm$core$Basics$composeR,
							$danyx23$elm_uuid$Uuid$toString,
							$elm$core$Basics$eq(
								$author$project$Model$Organization$idString(org))))),
				projects);
		} else {
			return projects;
		}
	});
var $author$project$Views$ProjectList$DistributionOnly = 3;
var $author$project$Views$ProjectList$ManagedProjects = 2;
var $author$project$Views$ProjectList$SelfServiceProjects = 1;
var $author$project$Views$Tooltip$dismissableTooltip = function (_v0) {
	var className = _v0.BD;
	var heading = _v0.yu;
	var copy = _v0.B_;
	var buttonLabel = _v0.Bl;
	var count = _v0.cO;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('sequence-tooltip'),
				$elm$html$Html$Attributes$class(className)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h4,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(heading)
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(copy)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('sequence-footer')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('checkbox')
									]),
								_List_Nil),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('primary-button small')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(buttonLabel)
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('sequence-count')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(count)
							]))
					]))
			]));
};
var $author$project$Views$Icon$Middle = 1;
var $author$project$Views$Loading$boxes = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('loading-boxes')
		]),
	_List_fromArray(
		[
			A2($elm$html$Html$span, _List_Nil, _List_Nil),
			A2($elm$html$Html$span, _List_Nil, _List_Nil),
			A2($elm$html$Html$span, _List_Nil, _List_Nil),
			A2($elm$html$Html$span, _List_Nil, _List_Nil),
			A2($elm$html$Html$span, _List_Nil, _List_Nil)
		]));
var $author$project$Views$ProjectList$canEditProjects = F2(
	function (session, organization) {
		return A2(
			$author$project$Model$Permissions$canEditProjects,
			organization.AC,
			$author$project$Model$Session$getUser(session));
	});
var $author$project$Views$ProjectList$configButtonId = function (projectId) {
	return 'project-config-' + $danyx23$elm_uuid$Uuid$toString(projectId);
};
var $author$project$Views$ProjectList$dateFormat = _List_fromArray(
	[
		$ryan_haskell$date_format$DateFormat$monthNameAbbreviated,
		$ryan_haskell$date_format$DateFormat$text(' '),
		$ryan_haskell$date_format$DateFormat$dayOfMonthFixed,
		$ryan_haskell$date_format$DateFormat$text(', '),
		$ryan_haskell$date_format$DateFormat$yearNumber
	]);
var $author$project$Views$ProjectList$formatDate = F2(
	function (theDate, currentTimeZone) {
		return A3($ryan_haskell$date_format$DateFormat$format, $author$project$Views$ProjectList$dateFormat, currentTimeZone, theDate);
	});
var $author$project$Model$Project$getAdded = function (_v0) {
	var project = _v0;
	return project.ak;
};
var $author$project$Views$ProjectList$installButtonId = function (projectId) {
	return 'project-install-' + $danyx23$elm_uuid$Uuid$toString(projectId);
};
var $author$project$Model$Route$projectSettingsWithFragment = function (_v0) {
	var orgName = _v0.ix;
	var projectName = _v0.vT;
	var fragment = _v0.oD;
	return $author$project$Model$Route$Protected(
		$author$project$Model$Route$Org(
			A2(
				$author$project$Model$Route$OrgParams,
				orgName,
				$author$project$Model$Route$OrgProject(
					A2(
						$author$project$Model$Route$OrgProjectParams,
						projectName,
						A2(
							$author$project$Model$Route$ProjectSettings,
							$elm$core$Maybe$Nothing,
							$elm$core$Maybe$Just(fragment)))))));
};
var $author$project$Views$Icon$setVAlign = F2(
	function (a, _v0) {
		var ikon = _v0;
		return _Utils_update(
			ikon,
			{wY: a});
	});
var $author$project$Views$Icon$verticallyAligned = function (a) {
	return $author$project$Views$Icon$setVAlign(a);
};
var $author$project$Views$ProjectList$projectView = F3(
	function (session, _v0, _v1) {
		var organization = _v0.c3;
		var setOpenedProjectDropdownMsg = _v0.F1;
		var quickMenuOpenedProjectId = _v0.js;
		var currentTimeZone = _v0.B7;
		var project = _v1.c5;
		var vulns = _v1.G8;
		var vulnerabilitySummary = function () {
			switch (vulns.$) {
				case 0:
					return $elm$html$Html$text('');
				case 1:
					return $author$project$Views$Loading$boxes;
				case 2:
					return $elm$html$Html$text('');
				default:
					if (vulns.a.$ === 1) {
						var _v4 = vulns.a;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('no-cve-data-indicator')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('info')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('No CVE Data')
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('more-info-tooltip')
										]),
									_List_fromArray(
										[
											$author$project$Views$Icon$view(
											$author$project$Views$Icon$icon(52)),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('content')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Vulnerability (CVE) summary data for this project has not yet been updated. View the project Configuration for up-to-date Vulnerability info.')
														]))
												]))
										]))
								]));
					} else {
						var vulnerabilities = vulns.a.a;
						return $author$project$Views$CVESummary$viewTotals(
							{xI: true, y7: $elm$core$Maybe$Nothing, zd: $elm$core$Maybe$Nothing, F2: vulnerabilities});
					}
			}
		}();
		var projectName = $author$project$Model$Project$getName(project);
		var projectId = $author$project$Model$Project$id(project);
		var projectCreatedString = A2(
			$author$project$Views$ProjectList$formatDate,
			$author$project$Model$Project$getAdded(project),
			currentTimeZone);
		var privacyStatus = function () {
			var privacyType = $author$project$Model$Project$getIsPrivate(project) ? 'Private' : 'Public';
			var iconKind = $author$project$Model$Project$getIsPrivate(project) ? 44 : 45;
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('project-privacy-status')
					]),
				_List_fromArray(
					[
						$author$project$Views$Icon$view(
						$author$project$Views$Icon$icon(iconKind)),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(privacyType)
							]))
					]));
		}();
		var orgName = organization.AC;
		var maxDescriptionLength = 150;
		var managedIcon = A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('managed-project-indicator')
				]),
			_List_fromArray(
				[
					$author$project$Views$Icon$view(
					$author$project$Views$Icon$icon(0)),
					$elm$html$Html$text('Managed')
				]));
		var isOpen = _Utils_eq(
			quickMenuOpenedProjectId,
			$elm$core$Maybe$Just(projectId));
		var _v2 = (_Utils_cmp(
			$elm$core$String$length(
				$author$project$Model$Project$getDescription(project)),
			maxDescriptionLength) > 0) ? _Utils_Tuple2(
			A2(
				$elm$core$String$left,
				maxDescriptionLength,
				$author$project$Model$Project$getDescription(project)) + '…',
			_List_fromArray(
				[
					$elm$html$Html$Attributes$title(
					$author$project$Model$Project$getDescription(project))
				])) : _Utils_Tuple2(
			$author$project$Model$Project$getDescription(project),
			_List_Nil);
		var trimmedDescription = _v2.a;
		var titleAttr = _v2.b;
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('project-card-wrapper')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Views$Link$link,
					$author$project$Model$Route$projectOverview(
						$author$project$Model$Route$projectOverviewParams(
							{ix: orgName, vT: projectName})),
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('project-card')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('project-card-header')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('project-title')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Model$Project$getName(project))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('date-and-status')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Misc$displayIf,
									$author$project$Model$Project$getIsManaged(project),
									managedIcon),
									privacyStatus,
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('project-date')
										]),
									_List_fromArray(
										[
											$author$project$Views$Icon$view(
											$author$project$Views$Icon$icon(5)),
											$elm$html$Html$text('Created ' + projectCreatedString)
										]))
								])),
							A2(
							$author$project$Misc$displayIf,
							!$elm$core$String$isEmpty(trimmedDescription),
							A2(
								$elm$html$Html$p,
								$elm$core$List$concat(
									_List_fromArray(
										[
											_List_fromArray(
											[
												$elm$html$Html$Attributes$class('project-description')
											]),
											titleAttr
										])),
								_List_fromArray(
									[
										$elm$html$Html$text(trimmedDescription)
									])))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('project-row-actions')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Misc$displayIf,
							A2($author$project$Views$ProjectList$canEditProjects, session, organization),
							A3(
								$author$project$Views$Link$link,
								A2(
									$author$project$Model$Route$projectConfig,
									{ix: orgName, vT: projectName},
									$author$project$Model$Route$projectConfigParams),
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('secondary-button small'),
										$elm$html$Html$Attributes$id(
										$author$project$Views$ProjectList$configButtonId(projectId))
									]),
								_List_fromArray(
									[
										$author$project$Views$Icon$view(
										$author$project$Views$Icon$icon(57)),
										$elm$html$Html$text('Configure')
									]))),
							A3(
							$author$project$Views$Link$link,
							$author$project$Model$Route$projectDownloads(
								{uk: false, fO: $elm$core$Maybe$Nothing, gr: $elm$core$Maybe$Nothing, Ef: $elm$core$Maybe$Nothing, ix: orgName, vT: projectName}),
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('secondary-button small'),
									$elm$html$Html$Attributes$id(
									$author$project$Views$ProjectList$installButtonId(projectId))
								]),
							_List_fromArray(
								[
									$author$project$Views$Icon$view(
									A2(
										$author$project$Views$Icon$colored,
										$author$project$Style$color('blue'),
										$author$project$Views$Icon$icon(21))),
									$elm$html$Html$text('Deploy')
								])),
							vulnerabilitySummary
						])),
					A2(
					$author$project$Misc$displayIf,
					A2($author$project$Views$ProjectList$canEditProjects, session, organization),
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('dropdown'),
								$elm$html$Html$Attributes$id($author$project$Views$ProjectList$sortMenuDropdownId)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick(
										setOpenedProjectDropdownMsg(
											$elm$core$Maybe$Just(projectId))),
										$elm$html$Html$Attributes$id(
										$author$project$Views$ProjectList$quickMenuDropdownId(projectId)),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('active', isOpen)
											])),
										$elm$html$Html$Attributes$class('only-icon project-button-dropdown')
									]),
								_List_fromArray(
									[
										$author$project$Views$Icon$view(
										A2(
											$author$project$Views$Icon$colored,
											$author$project$Style$color('blue'),
											A2(
												$author$project$Views$Icon$verticallyAligned,
												1,
												$author$project$Views$Icon$icon(12))))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('dropdown-menu', true),
												_Utils_Tuple2('visible', isOpen),
												_Utils_Tuple2('hidden', !isOpen)
											]))
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Views$Link$view,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('settings dropdown-item')
											]),
										_List_fromArray(
											[
												$author$project$Views$Icon$view(
												$author$project$Views$Icon$icon(30)),
												$elm$html$Html$text('Project Settings')
											]),
										$author$project$Model$Route$projectSettings(
											{fO: $elm$core$Maybe$Nothing, ix: orgName, vT: projectName})),
										A3(
										$author$project$Views$Link$view,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pencil dropdown-item')
											]),
										_List_fromArray(
											[
												$author$project$Views$Icon$view(
												$author$project$Views$Icon$icon(59)),
												$elm$html$Html$text('Add Description')
											]),
										$author$project$Model$Route$projectSettingsWithFragment(
											{oD: $author$project$Model$Route$addDescriptionFragment, ix: orgName, vT: projectName})),
										A3(
										$author$project$Views$Link$view,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('transfer dropdown-item')
											]),
										_List_fromArray(
											[
												$author$project$Views$Icon$view(
												$author$project$Views$Icon$icon(53)),
												$elm$html$Html$text('Move Project')
											]),
										$author$project$Model$Route$projectSettingsWithFragment(
											{oD: $author$project$Model$Route$moveProjectFragment, ix: orgName, vT: projectName})),
										A3(
										$author$project$Views$Link$view,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('delete dropdown-item')
											]),
										_List_fromArray(
											[
												$author$project$Views$Icon$view(
												$author$project$Views$Icon$icon(81)),
												$elm$html$Html$text('Delete Project')
											]),
										$author$project$Model$Route$projectSettingsWithFragment(
											{oD: $author$project$Model$Route$deleteProjectFragment, ix: orgName, vT: projectName}))
									]))
							])))
				]));
	});
var $author$project$Views$ProjectList$orgProjectsView = F2(
	function (session, _v0) {
		var organization = _v0.c3;
		var projects = _v0.gx;
		var shownSelection = _v0.Aa;
		var setOpenedProjectDropdownMsg = _v0.F1;
		var quickMenuOpenedProjectId = _v0.js;
		var changeProjectSelectionMsg = _v0.Bw;
		var currentTimeZone = _v0.B7;
		var filterBySelection = F2(
			function (selection, _v4) {
				var project = _v4.c5;
				switch (selection) {
					case 0:
						return true;
					case 1:
						return (!$author$project$Model$Project$getIsManaged(project)) && (!$author$project$Model$Project$getIsDistributionOnly(project));
					case 2:
						return $author$project$Model$Project$getIsManaged(project);
					default:
						return $author$project$Model$Project$getIsDistributionOnly(project);
				}
			});
		var filterByShownSelection = filterBySelection(shownSelection);
		var projectsList = A2(
			$elm$core$List$map,
			A2(
				$author$project$Views$ProjectList$projectView,
				session,
				{B7: currentTimeZone, c3: organization, js: quickMenuOpenedProjectId, F1: setOpenedProjectDropdownMsg}),
			A2($elm$core$List$filter, filterByShownSelection, projects));
		var allProjectsCount = $elm$core$List$length(projects);
		var countIsNonTrivial = function (count) {
			return (count > 0) && (_Utils_cmp(count, allProjectsCount) < 0);
		};
		var _v1 = _Utils_Tuple3(
			A2(
				$elm$core$List$filter,
				filterBySelection(1),
				projects),
			A2(
				$elm$core$List$filter,
				filterBySelection(2),
				projects),
			A2(
				$elm$core$List$filter,
				filterBySelection(3),
				projects));
		var selfServiceProjects = _v1.a;
		var managedProjects = _v1.b;
		var distributionOnlyProjects = _v1.c;
		var _v2 = _Utils_Tuple3(
			$elm$core$List$length(managedProjects),
			$elm$core$List$length(selfServiceProjects),
			$elm$core$List$length(distributionOnlyProjects));
		var managedProjectCount = _v2.a;
		var selfServiceProjectCount = _v2.b;
		var distributionOnlyProjectCount = _v2.c;
		var hasProjectTabs = function () {
			var nonTrivialSubCategoriesCount = $elm$core$List$length(
				A2(
					$elm$core$List$filter,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							countIsNonTrivial(managedProjectCount),
							countIsNonTrivial(selfServiceProjectCount),
							countIsNonTrivial(distributionOnlyProjectCount)
						])));
			return nonTrivialSubCategoriesCount > 0;
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('org-project-list project-cards')
				]),
			_List_fromArray(
				[
					$author$project$Views$Tooltip$dismissableTooltip(
					{Bl: 'Continue', BD: 'sequence-one', B_: 'All related open source that you manage on the ActiveState platform is organized into projects.', cO: '1 of 3', yu: 'Manage and track your open source'}),
					A2(
					$author$project$Misc$displayIf,
					hasProjectTabs,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('section-tabs')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick(
										A2(changeProjectSelectionMsg, organization.zw, 0)),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('selected', !shownSelection)
											]))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('All'),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('item-count')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$elm$core$String$fromInt(allProjectsCount))
											]))
									])),
								A2(
								$author$project$Misc$displayIf,
								countIsNonTrivial(selfServiceProjectCount),
								A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											A2(changeProjectSelectionMsg, organization.zw, 1)),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('selected', shownSelection === 1)
												]))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Self-Service'),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('item-count')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromInt(selfServiceProjectCount))
												]))
										]))),
								A2(
								$author$project$Misc$displayIf,
								countIsNonTrivial(managedProjectCount),
								A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											A2(changeProjectSelectionMsg, organization.zw, 2)),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('selected', shownSelection === 2)
												]))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Managed by ActiveState'),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('item-count')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromInt(managedProjectCount))
												]))
										]))),
								A2(
								$author$project$Misc$displayIf,
								countIsNonTrivial(distributionOnlyProjectCount),
								A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											A2(changeProjectSelectionMsg, organization.zw, 3)),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('selected', shownSelection === 3)
												]))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Distribution Only'),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('item-count')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromInt(distributionOnlyProjectCount))
												]))
										])))
							]))),
					($elm$core$List$length(projects) > 0) ? A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('large-list item-list')
						]),
					projectsList) : $elm$html$Html$text('')
				]));
	});
var $author$project$Views$ProjectList$projectTags = function (_v0) {
	var tagsWithCounts = _v0.An;
	var searchTags = _v0.iF;
	var changeTagMsg = _v0.BA;
	return A2(
		$author$project$Misc$displayIf,
		!$elm$core$List$isEmpty(tagsWithCounts),
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('project-tags')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tag-list')
						]),
					A2(
						$elm$core$List$map,
						function (_v1) {
							var t = _v1.a;
							var isPresent = _v1.c;
							var clickable = isPresent || A2($elm$core$List$member, t, searchTags);
							return A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('tag'),
										$elm$html$Html$Attributes$title('Filter by ' + t),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'selected',
												A2($elm$core$List$member, t, searchTags)),
												_Utils_Tuple2('disabled', !isPresent)
											])),
										clickable ? $elm$html$Html$Events$onClick(
										changeTagMsg(t)) : $elm$html$Html$Attributes$class('')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(t)
									]));
						},
						tagsWithCounts))
				])));
};
var $author$project$Views$ProjectList$searchFilteredProjects = F2(
	function (searchTerm, unfilteredProjectList) {
		return A2(
			$elm$core$List$filter,
			function (_v0) {
				var project = _v0.c5;
				return A2(
					$elm$core$String$contains,
					searchTerm,
					$elm$core$String$toLower(
						$author$project$Model$Project$getName(project))) || A2(
					$elm$core$String$contains,
					searchTerm,
					$elm$core$String$toLower(
						$author$project$Model$Project$getDescription(project)));
			},
			unfilteredProjectList);
	});
var $author$project$Views$ProjectList$Descending = 1;
var $author$project$Views$ProjectList$Name = 0;
var $author$project$Views$ProjectList$Vulnerabilities = 2;
var $author$project$Views$ProjectList$sortDropdown = function (_v0) {
	var buttonId = _v0.xv;
	var dropdownId = _v0.x9;
	var toggleSortDropdownMsg = _v0.GH;
	var sortBy = _v0.nx;
	var sortDirection = _v0.ny;
	var sortDropdownIsOpen = _v0.ky;
	var changeSortMsg = _v0.By;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('dropdown sort-dropdown')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id(buttonId),
						$elm$html$Html$Events$onClick(toggleSortDropdownMsg),
						$elm$html$Html$Attributes$class('dropdown-toggle')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Sort'),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('explanation')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								function () {
									var _v1 = _Utils_Tuple2(sortBy, sortDirection);
									if (!_v1.b) {
										switch (_v1.a) {
											case 0:
												var _v2 = _v1.a;
												var _v3 = _v1.b;
												return '(A → Z)';
											case 1:
												var _v6 = _v1.a;
												var _v7 = _v1.b;
												return '(Newest)';
											default:
												var _v10 = _v1.a;
												var _v11 = _v1.b;
												return '(Least Vulnerable)';
										}
									} else {
										switch (_v1.a) {
											case 0:
												var _v4 = _v1.a;
												var _v5 = _v1.b;
												return '(Z → A)';
											case 1:
												var _v8 = _v1.a;
												var _v9 = _v1.b;
												return '(Oldest)';
											default:
												var _v12 = _v1.a;
												var _v13 = _v1.b;
												return '(Most Vulnerable)';
										}
									}
								}())
							])),
						$author$project$Views$Icon$view(
						$author$project$Views$Icon$icon(12))
					])),
				A2(
				$author$project$Misc$displayIf,
				sortDropdownIsOpen,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('dropdown-menu'),
							$elm$html$Html$Attributes$id(dropdownId)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									A2(changeSortMsg, 1, 0)),
									$elm$html$Html$Attributes$class('dropdown-item'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('selected', (sortBy === 1) && (!sortDirection))
										]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Date created'),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('explanation')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('New → Old')
										]))
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									A2(changeSortMsg, 1, 1)),
									$elm$html$Html$Attributes$class('dropdown-item'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('selected', (sortBy === 1) && (sortDirection === 1))
										]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Date created'),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('explanation')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Old → New')
										]))
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									A2(changeSortMsg, 2, 0)),
									$elm$html$Html$Attributes$class('dropdown-item'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('selected', (sortBy === 2) && (!sortDirection))
										]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Vulnerabilities'),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('explanation')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Least → Most')
										]))
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									A2(changeSortMsg, 2, 1)),
									$elm$html$Html$Attributes$class('dropdown-item'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('selected', (sortBy === 2) && (sortDirection === 1))
										]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Vulnerabilities'),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('explanation')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Most → Least')
										]))
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									A2(changeSortMsg, 0, 0)),
									$elm$html$Html$Attributes$class('dropdown-item'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('selected', (!sortBy) && (!sortDirection))
										]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Name'),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('explanation')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('A → Z')
										]))
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									A2(changeSortMsg, 0, 1)),
									$elm$html$Html$Attributes$class('dropdown-item'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('selected', (!sortBy) && (sortDirection === 1))
										]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Name'),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('explanation')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Z → A')
										]))
								]))
						])))
			]));
};
var $author$project$Views$ProjectList$toComparableByCreated = function (project) {
	return -$elm$time$Time$posixToMillis(
		$author$project$Model$Project$getAdded(project));
};
var $author$project$Views$ProjectList$sortedProjects = F3(
	function (sortBy, sortDirection, projects) {
		var projectList = function () {
			switch (sortBy) {
				case 1:
					return A2(
						$elm$core$List$sortBy,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.c5;
							},
							$author$project$Views$ProjectList$toComparableByCreated),
						projects);
				case 0:
					return A2(
						$elm$core$List$sortBy,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.c5;
							},
							A2($elm$core$Basics$composeR, $author$project$Model$Project$getName, $elm$core$String$toLower)),
						projects);
				default:
					return A2(
						$elm$core$List$sortBy,
						function (_v1) {
							var vulns = _v1.G8;
							if ((vulns.$ === 3) && (!vulns.a.$)) {
								var histogram = vulns.a.a;
								return $author$project$Model$SeverityHistogram$sortKey(histogram);
							} else {
								return _List_Nil;
							}
						},
						projects);
			}
		}();
		return (sortDirection === 1) ? $elm$core$List$reverse(projectList) : projectList;
	});
var $author$project$Views$ProjectList$tagFilteredProjects = F2(
	function (searchTags, unfilteredProjectList) {
		return $elm$core$List$isEmpty(searchTags) ? unfilteredProjectList : A2(
			$elm$core$List$filter,
			function (_v0) {
				var project = _v0.c5;
				return A2(
					$elm$core$List$all,
					function (t) {
						return A2(
							$elm$core$String$contains,
							t,
							$author$project$Model$Project$getDescription(project));
					},
					searchTags);
			},
			unfilteredProjectList);
	});
var $elm$core$String$words = _String_words;
var $author$project$Views$ProjectList$tabbedProjectList = function (_v0) {
	var session = _v0.l;
	var projects = _v0.gx;
	var organization = _v0.c3;
	var viewProjectSelection = _v0.nR;
	var changeProjectSelectionMsg = _v0.Bw;
	var searchTerm = _v0.nq;
	var searchTags = _v0.iF;
	var quickMenuOpenedProjectId = _v0.js;
	var setOpenedProjectDropdownMsg = _v0.F1;
	var changeTagMsg = _v0.BA;
	var clearFiltersMsg = _v0.BF;
	var changeSortMsg = _v0.By;
	var sortBy = _v0.nx;
	var sortDirection = _v0.ny;
	var sortDropdownIsOpen = _v0.ky;
	var currentTimeZone = _v0.B7;
	var toggleSortDropdownMsg = _v0.GH;
	var searchTermInputValue = _v0.nr;
	var changeSearchMsg = _v0.Bx;
	var canCreateProject = _v0.Bo;
	var openCreateProjectFromSBOMMsg = _v0.EU;
	var isFiltered = (searchTerm !== '') || (!$elm$core$List$isEmpty(searchTags));
	var getTags = function (projectList) {
		return A2(
			$elm$core$List$sortBy,
			$elm$core$String$toLower,
			A3(
				$elm$core$List$foldl,
				F2(
					function (p, total) {
						var hashtagWords = $elm_community$list_extra$List$Extra$unique(
							A2(
								$elm$core$List$filter,
								function (word) {
									return A2($elm$core$String$startsWith, '#', word);
								},
								$elm$core$String$words(
									$author$project$Model$Project$getDescription(p.c5))));
						return A2($elm$core$List$append, total, hashtagWords);
					}),
				_List_Nil,
				projectList));
	};
	var filteredProjects = A3(
		$author$project$Views$ProjectList$sortedProjects,
		sortBy,
		sortDirection,
		A2(
			$author$project$Views$ProjectList$tagFilteredProjects,
			searchTags,
			A2($author$project$Views$ProjectList$searchFilteredProjects, searchTerm, projects)));
	var filteredProjectsCount = $elm$core$List$length(filteredProjects);
	var selectedTags = getTags(filteredProjects);
	var allTags = getTags(projects);
	var tagsWithCounts = $elm$core$List$reverse(
		A2(
			$elm$core$List$sortBy,
			function (_v1) {
				var count = _v1.b;
				return count;
			},
			$elm_community$list_extra$List$Extra$unique(
				A2(
					$elm$core$List$map,
					function (tag) {
						var count = A3(
							$elm$core$List$foldl,
							F2(
								function (x, i) {
									return _Utils_eq(tag, x) ? (i + 1) : i;
								}),
							0,
							allTags);
						return _Utils_Tuple3(
							tag,
							count,
							A2($elm$core$List$member, tag, selectedTags));
					},
					allTags))));
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('sort-and-search')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Projects'),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('item-count')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(
											$elm$core$List$length(projects)))
									]))
							])),
						$author$project$Views$InlineSearchBar$inlineSearchBar(
						{Bx: changeSearchMsg, BG: $elm$core$Maybe$Nothing, j0: searchTermInputValue, Fd: 'Search by project name or description'}),
						$author$project$Views$ProjectList$sortDropdown(
						{xv: $author$project$Views$ProjectList$sortMenuButtonId, By: changeSortMsg, x9: $author$project$Views$ProjectList$sortMenuDropdownId, nx: sortBy, ny: sortDirection, ky: sortDropdownIsOpen, GH: toggleSortDropdownMsg}),
						A2(
						$author$project$Misc$displayIf,
						canCreateProject,
						$author$project$Views$NewProjectButton$active(organization.AC)),
						A2(
						$author$project$Misc$displayIf,
						$author$project$Model$Permissions$orgCanIngestSBOMs(organization) && canCreateProject,
						A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('primary-button'),
									$elm$html$Html$Events$onClick(openCreateProjectFromSBOMMsg)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Upload SBOM')
								])))
					])),
				$author$project$Views$ProjectList$projectTags(
				{BA: changeTagMsg, iF: searchTags, An: tagsWithCounts}),
				A2(
				$author$project$Misc$displayIf,
				isFiltered,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('search-status')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A3($elm_community$string_extra$String$Extra$pluralize, 'project', 'projects', filteredProjectsCount)),
									$elm$html$Html$text(' '),
									$elm$html$Html$text(
									A3($author$project$Misc$pluralizeNoNumber, 'matches', 'match', filteredProjectsCount))
								])),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('—')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-button'),
									$elm$html$Html$Events$onClick(clearFiltersMsg)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Clear Filters')
								]))
						]))),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Views$ProjectList$orgProjectsView,
						session,
						{
							Bw: changeProjectSelectionMsg,
							B7: currentTimeZone,
							c3: organization,
							gx: A2(
								$author$project$Views$ProjectList$orgFilteredProjects,
								$elm$core$Maybe$Just(organization),
								filteredProjects),
							js: quickMenuOpenedProjectId,
							F1: setOpenedProjectDropdownMsg,
							Aa: A2(
								$elm$core$Maybe$withDefault,
								0,
								A2(
									$elm$core$Dict$get,
									$author$project$Model$Organization$idString(organization),
									viewProjectSelection))
						})
					]))
			]));
};
var $author$project$Model$Organization$trialTierEndDate = function ($) {
	return $.Ay;
};
var $author$project$Model$Organization$trialTierMaxDays = 7;
var $author$project$Model$Organization$trialTierDaysRemaining = F2(
	function (currentDate, org) {
		var daysBetweenDates = F2(
			function (end, current) {
				return (_Utils_cmp(
					$elm$time$Time$posixToMillis(end),
					$elm$time$Time$posixToMillis(current)) < 1) ? 0 : A3(
					$elm$core$Basics$clamp,
					0,
					$author$project$Model$Organization$trialTierMaxDays,
					1 + A2($author$project$TimeUtils$daysBetween, end, current));
			});
		return A2(
			$elm$core$Maybe$map,
			daysBetweenDates(
				$author$project$Model$Organization$trialTierEndDate(org)),
			currentDate);
	});
var $author$project$Views$OrgOverview$dependencySummary = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('dependency-summary summary-card'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'summary-loading',
						$krisajenkins$remotedata$RemoteData$isLoading(model.lt))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('loading-shimmer')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('gradient-wrapper')
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dependency-count')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('count-value')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(model.j7.Av))
									])),
								$elm$html$Html$text(
								A3($author$project$Misc$pluralizeNoNumber, ' Dependency', ' Dependencies', model.j7.Av)),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('more-info-tooltip')
									]),
								_List_fromArray(
									[
										$author$project$Views$Icon$view(
										$author$project$Views$Icon$icon(52)),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('content')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('The total count of third-party packages your organization relies on. Packages are included multiple times in this count if they are used in multiple projects.')
													]))
											]))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('dependency-chart')
							]),
						$elm$core$List$concat(
							A2(
								$elm$core$List$map,
								function (l) {
									var percentString = $elm$core$String$fromInt(l.b) + '%';
									return _List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(percentString)
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('language-name')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(l.a)
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('bar-wrapper')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class(l.a),
															A2($elm$html$Html$Attributes$style, 'width', percentString),
															$elm$html$Html$Attributes$class('bar')
														]),
													_List_Nil)
												]))
										]);
								},
								$elm$core$List$reverse(
									A2($elm$core$List$sortBy, $elm$core$Tuple$second, model.j7.us)))))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('actions')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Views$Link$link,
						$author$project$Model$Route$orgDependencies(
							$author$project$Model$Organization$getUrlName(model.c3)),
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('secondary-button small')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('View All Dependencies')
							]))
					]))
			]));
};
var $author$project$Views$OrgOverview$vulnerabilitySummary = function (model) {
	var viewVulnerabilitiesButton = A3(
		$author$project$Views$Link$link,
		$author$project$Model$Route$orgSecurity(
			$author$project$Model$Organization$getUrlName(model.c3)),
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('secondary-button small')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('View Vulnerabilities')
			]));
	var severityHistogram = A2($krisajenkins$remotedata$RemoteData$withDefault, $author$project$Model$SeverityHistogram$empty, model.F2);
	var totalCount = $author$project$Model$SeverityHistogram$total(severityHistogram);
	var cveSummary = $author$project$Views$CVESummary$viewTotals(
		{xI: true, y7: $elm$core$Maybe$Nothing, zd: $elm$core$Maybe$Nothing, F2: severityHistogram});
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('vulnerability-summary summary-card'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'summary-loading',
						$krisajenkins$remotedata$RemoteData$isLoading(model.F2))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('loading-shimmer')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('gradient-wrapper')
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('vulnerability-details')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('count-value')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(totalCount))
									])),
								$elm$html$Html$text(
								A3($author$project$Misc$pluralizeNoNumber, ' Vulnerability', ' Vulnerabilities', totalCount)),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('more-info-tooltip')
									]),
								_List_fromArray(
									[
										$author$project$Views$Icon$view(
										$author$project$Views$Icon$icon(52)),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('content')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('The total number of security issues found across all dependencies. Issues are included multiple times in this count if they appear in multiple projects or packages.')
													]))
											]))
									]))
							])),
						cveSummary
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('actions')
					]),
				_List_fromArray(
					[viewVulnerabilitiesButton]))
			]));
};
var $author$project$Views$OrgOverview$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('panorama-org-summary')
			]),
		_List_fromArray(
			[
				$author$project$Views$OrgOverview$dependencySummary(model),
				$author$project$Views$OrgOverview$vulnerabilitySummary(model),
				$author$project$Views$Tooltip$dismissableTooltip(
				{Bl: 'Continue', BD: 'sequence-two', B_: 'This is a summary of the dependencies and vulnerabilities that are contained within the projects in this organization.', cO: '2 of 3', yu: 'Get comprehensive insights'})
			]));
};
var $author$project$Model$RuntimeUsageData$isOverLimit = function (_v0) {
	var data = _v0;
	return _Utils_cmp(data.w7, data.A0) > 0;
};
var $author$project$Model$RuntimeUsageData$activeRuntimesLimitString = function (_v0) {
	var data = _v0;
	return $elm$core$String$fromInt(data.A0);
};
var $author$project$Model$RuntimeUsageData$activeRuntimesString = function (_v0) {
	var data = _v0;
	return $elm$core$String$fromInt(
		$elm$core$Basics$round(data.w7));
};
var $avh4$elm_color$Color$orange = A4($avh4$elm_color$Color$RgbaSpace, 245 / 255, 121 / 255, 0 / 255, 1.0);
var $author$project$Views$RunTimeUsage$viewBadge = function () {
	var warningIcon = $author$project$Views$Icon$view(
		A2(
			$author$project$Views$Icon$colored,
			$avh4$elm_color$Color$orange,
			$author$project$Views$Icon$icon(83)));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('badge')
			]),
		_List_fromArray(
			[
				warningIcon,
				$elm$html$Html$text('Over Limit')
			]));
}();
var $author$project$Url$Extra$contactSalesUsage = function (queryParams) {
	return A3(
		$author$project$Url$Extra$createUrl,
		$author$project$Url$Extra$corporateSiteDomain,
		_List_fromArray(
			['solutions', 'contact-sales-usage']),
		queryParams);
};
var $author$project$Views$RunTimeUsage$viewButtons = function (organization) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('primary-button'),
					$elm$html$Html$Attributes$href(
					$author$project$Model$Route$urlPiecesToString(
						$author$project$Model$Route$protectedRouteToString(
							$author$project$Model$Route$Checkout(
								{
									jc: false,
									up: true,
									dg: $elm$core$Maybe$Nothing,
									ix: $elm$core$Maybe$Just(organization.AC),
									Ab: true,
									dc: $elm$core$Maybe$Nothing
								})))),
					$elm$html$Html$Attributes$target('_blank')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Upgrade')
				])),
			A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('secondary-button'),
					$elm$html$Html$Attributes$href(
					$author$project$Url$Extra$contactSalesUsage(_List_Nil)),
					$elm$html$Html$Attributes$target('_blank')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Request Usage Details')
				]))
		]);
};
var $author$project$Views$RunTimeUsage$viewHelpInfo = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('more-info-tooltip')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('arrow')
				]),
			_List_Nil),
			$author$project$Views$Icon$view(
			$author$project$Views$Icon$icon(52)),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('content')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('This number includes runtime activations via the StateTool.  To review installer based usage select Request RuntimeUsageData Details.')
				]))
		]));
var $author$project$Views$RunTimeUsage$viewUsageContent = F3(
	function (organization, simpleTier, usage) {
		var msg = function () {
			var limitString = A2(
				$elm$html$Html$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Model$RuntimeUsageData$activeRuntimesLimitString(usage) + ' concurrent runtimes')
					]));
			return $author$project$Model$RuntimeUsageData$isOverLimit(usage) ? _List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('This organization exceeds the usage limit of '),
							limitString,
							$elm$html$Html$text(' for '),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('tier-name')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Model$Tier$simpleTierDisplayString(simpleTier) + ' tier')
								])),
							$elm$html$Html$text(' subscriptions.')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('https://www.activestate.com/company/contact-us/'),
									$elm$html$Html$Attributes$target('_blank')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Contact us')
								])),
							$elm$html$Html$text(' to upgrade this organization and increase your limit.')
						]))
				]) : _List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('This organization is within the usage limit of '),
							limitString,
							$elm$html$Html$text(' for '),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('tier-name')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Model$Tier$simpleTierDisplayString(simpleTier) + ' tier')
								])),
							$elm$html$Html$text(' subscriptions.')
						]))
				]);
		}();
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('runtime_usage_title'),
								$elm$html$Html$Attributes$class('row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Runtime Usage')
									])),
								$author$project$Views$RunTimeUsage$viewHelpInfo,
								A2(
								$author$project$Misc$displayIf,
								$author$project$Model$RuntimeUsageData$isOverLimit(usage),
								$author$project$Views$RunTimeUsage$viewBadge)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('runtime_usage_count'),
								$elm$html$Html$Attributes$class('row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h1,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Model$RuntimeUsageData$activeRuntimesString(usage))
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id('concurrent_string')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Concurrent Runtimes')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('runtime_usage_msg')
							]),
						msg),
						A2(
						$author$project$Misc$displayIf,
						$author$project$Model$RuntimeUsageData$isOverLimit(usage),
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id('runtime_usage_buttons'),
									$elm$html$Html$Attributes$class('row')
								]),
							$author$project$Views$RunTimeUsage$viewButtons(organization)))
					]))
			]);
	});
var $author$project$Views$RunTimeUsage$view = F2(
	function (organization, usageData) {
		var simpleTier = $author$project$Model$Tier$stringToSimpleTier(organization.dc);
		var attr = _List_fromArray(
			[
				$elm$html$Html$Attributes$id('runtime_usage_container'),
				$elm$html$Html$Attributes$class('floating-card')
			]);
		var _v0 = _Utils_Tuple2(usageData, simpleTier);
		_v0$2:
		while (true) {
			if (!_v0.b.$) {
				switch (_v0.a.$) {
					case 3:
						if (!_v0.a.a.$) {
							var usage = _v0.a.a.a;
							var _v1 = _v0.b;
							return A2(
								$elm$html$Html$div,
								A2(
									$elm$core$List$append,
									attr,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'over-limit',
													$author$project$Model$RuntimeUsageData$isOverLimit(usage))
												])),
											$elm$html$Html$Attributes$class('floating-card')
										])),
								A3($author$project$Views$RunTimeUsage$viewUsageContent, organization, simpleTier, usage));
						} else {
							break _v0$2;
						}
					case 1:
						var _v2 = _v0.a;
						var _v3 = _v0.b;
						return A2(
							$elm$html$Html$div,
							attr,
							_List_fromArray(
								[$author$project$Views$Loading$dots]));
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return $elm$html$Html$text('');
	});
var $author$project$Views$TeamTier$wideTeamTierBenefitsBox = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('team-tier-cta-box')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$h4,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Get the most out of the ActiveState Platform with Secure Binaries')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Upgrade to access '),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('no-wrap')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('built-from-source')
						])),
					$elm$html$Html$text(' binaries for all your runtimes and start benefitting from...')
				])),
			A2(
			$elm$html$Html$ul,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (t) {
					return A2(
						$elm$html$Html$li,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(t)
							]));
				},
				$author$project$Views$TeamTier$secureBinaryBenefitList)),
			$author$project$Views$TeamTier$teamTierRequestUpgradeButton
		]));
var $author$project$Pages$OrgIndex$viewOrgDashboard = F3(
	function (session, model, currentTime) {
		var trialIndicator = F2(
			function (daysRemaining, daysAvailable) {
				var percent = $elm$core$String$fromFloat(100 * (daysRemaining / daysAvailable));
				var isExpired = daysRemaining < 1;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('trial-indicator'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('expired', isExpired)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('trial-indicator-header')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											isExpired ? A2(
											$elm$html$Html$h2,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('day-summary')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Enterprise Trial has Expired!')
												])) : A2(
											$elm$html$Html$h2,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('day-summary')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('day-count')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$elm$core$String$fromInt(daysRemaining))
														])),
													$elm$html$Html$text(
													A3($author$project$Misc$pluralizeNoNumber, ' Day', ' Days', daysRemaining)),
													$elm$html$Html$text(' Left in Enterprise Trial')
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('bar')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															A2($elm$html$Html$Attributes$style, 'width', percent + '%'),
															$elm$html$Html$Attributes$class('value')
														]),
													_List_Nil)
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('icon-wrapper')
										]),
									_List_fromArray(
										[
											$author$project$Views$Icon$view(
											$author$project$Views$Icon$icon(40))
										]))
								])),
							(daysRemaining >= 1) ? A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('You currently have full access to Enterprise features and ActiveState\'s secure sandbox environment.  Ready to test ActiveState in your environment? Talk to our experts today.')
								])) : A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Your ActiveState Enterprise Trial has expired. To regain access to the full suite of  open source management features, get in touch with one of our experts.')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('actions')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('secondary-button small'),
											$elm$html$Html$Attributes$href('https://activestate.com/contact-our-experts/'),
											$elm$html$Html$Attributes$target('_blank')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Talk to our Experts')
										])),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('secondary-button small'),
											$elm$html$Html$Attributes$href('https://www.activestate.com/company/contact-us-pricing'),
											$elm$html$Html$Attributes$target('_blank')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Compare Plans')
										]))
								]))
						]));
			});
		var trialStatusIndicator = function () {
			var isTrialOrFree = A2(
				$author$project$Misc$memberOf,
				_List_fromArray(
					[$author$project$Model$Tier$Free, $author$project$Model$Tier$PlatformTrial]),
				$author$project$Model$Tier$stringToSimpleTier(model.c3.dc));
			var trialIsRelevant = model.c3.Bf && isTrialOrFree;
			var daysRemaining = A2($author$project$Model$Organization$trialTierDaysRemaining, currentTime, model.c3);
			var _v1 = _Utils_Tuple2(trialIsRelevant, daysRemaining);
			if (_v1.a && (!_v1.b.$)) {
				var remaining = _v1.b.a;
				return A2(trialIndicator, remaining, $author$project$Model$Organization$trialTierMaxDays);
			} else {
				return $elm$html$Html$text('');
			}
		}();
		var projectNameToSeverityHistogram = A2(
			$krisajenkins$remotedata$RemoteData$map,
			function (_v0) {
				var deps = _v0.qP;
				var vulns = _v0.G8;
				var helper = function (dep) {
					return A2(
						$elm$core$Dict$update,
						$author$project$Model$Analytics$Fact$Dependencies$projectName(dep),
						function (maybeAcc) {
							return $elm$core$Maybe$Just(
								_Utils_ap(
									A2(
										$elm$core$List$map,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.gY;
											},
											$author$project$Model$Vulnerability$fromAnalyticsVulnerability),
										A2(
											$elm$core$Maybe$withDefault,
											_List_Nil,
											A2(
												$elm$core$Maybe$andThen,
												function (cveKey) {
													return A2($elm$core$Dict$get, cveKey, vulns);
												},
												$author$project$Model$Analytics$Fact$Dependencies$cveKeyFromDep(dep)))),
									A2($elm$core$Maybe$withDefault, _List_Nil, maybeAcc)));
						});
				};
				return A2(
					$elm$core$Dict$map,
					$elm$core$Basics$always($author$project$Model$SeverityHistogram$fromVulnerabilities),
					A3($elm$core$List$foldl, helper, $elm$core$Dict$empty, deps));
			},
			A2(
				$elm$core$Maybe$withDefault,
				$krisajenkins$remotedata$RemoteData$NotAsked,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.E4;
					},
					model.mU)));
		var projects = A2(
			$elm$core$List$map,
			function (project) {
				return {
					c5: project,
					G8: A2(
						$krisajenkins$remotedata$RemoteData$map,
						$elm$core$Dict$get(
							$author$project$Model$Project$getName(project)),
						projectNameToSeverityHistogram)
				};
			},
			model.gx);
		var orgProjects = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.c5;
				},
				A2(
					$elm$core$Basics$composeR,
					$author$project$Model$Project$getOrganizationId,
					A2(
						$elm$core$Basics$composeR,
						$danyx23$elm_uuid$Uuid$toString,
						$elm$core$Basics$eq(
							$author$project$Model$Organization$idString(model.c3))))),
			projects);
		var displayTeamUpsell = false;
		var displayRuntimeUsage = false;
		var canCreateMoreProjects = A2(
			$author$project$Model$Permissions$orgCanCreateMoreProjects,
			{
				B4: $elm$core$List$length(orgProjects)
			},
			model.c3);
		var canCreateProject = A2(
			$author$project$Model$Permissions$canEditProjects,
			model.c3.AC,
			$author$project$Model$Session$getUser(session)) && canCreateMoreProjects;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('columns')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('column')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('panorama-and-trial')
								]),
							_List_fromArray(
								[
									A2($author$project$Misc$displayMaybe, $author$project$Views$OrgOverview$view, model.mU),
									trialStatusIndicator
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('projects-box')
								]),
							_List_fromArray(
								[
									(!model.pu) ? A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Views$Loading$dots,
											$elm$html$Html$text('Loading')
										])) : A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Misc$displayIf,
											!$elm$core$List$length(orgProjects),
											A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('No projects have been created in this organization.')
													]))),
											$author$project$Views$ProjectList$tabbedProjectList(
											{Bo: canCreateProject, Bw: $author$project$Pages$OrgIndex$ChangeProjectSelection, Bx: $author$project$Pages$OrgIndex$ChangeSearch, By: $author$project$Pages$OrgIndex$ChangeSort, BA: $author$project$Pages$OrgIndex$ChangeTag, BF: $author$project$Pages$OrgIndex$ClearFilters, B7: model.tx, EU: $author$project$Pages$OrgIndex$OpenCreateProjectFromSBOM, c3: model.c3, gx: orgProjects, js: model.js, iF: model.iF, nq: model.nq, nr: model.nr, l: session, F1: $author$project$Pages$OrgIndex$SetOpenedProjectQuickMenu, nx: model.nx, ny: model.ny, ky: model.ky, GH: $author$project$Pages$OrgIndex$ToggleSortDropdown, nR: model.nR})
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('column narrow')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Misc$displayIf,
							displayRuntimeUsage,
							A2($author$project$Views$RunTimeUsage$view, model.c3, model.pH)),
							A2($author$project$Misc$displayIf, displayTeamUpsell, $author$project$Views$TeamTier$wideTeamTierBenefitsBox)
						]))
				]));
	});
var $author$project$Pages$OrgIndex$view = F3(
	function (model, session, currentTime) {
		var setPasswordModeQueryParameter = model.pN ? $elm$core$Maybe$Just('setpassword') : $elm$core$Maybe$Nothing;
		var importSBOMView = function (modalModel) {
			return $author$project$Views$Modal$confirmCancelView(
				{
					Bq: $elm$core$Maybe$Just(
						{
							BE: _List_fromArray(
								['']),
							Dc: $author$project$Views$CreateProjectFromSBOM$isFormSubmitting(modalModel),
							En: $author$project$Pages$OrgIndex$DismissModal,
							Gv: 'Cancel'
						}),
					BD: '',
					BU: $elm$core$Maybe$Just(
						{
							BE: _List_fromArray(
								['']),
							Dc: $author$project$Views$CreateProjectFromSBOM$isFormSubmitting(modalModel) || _Utils_eq(
								$author$project$Views$CreateProjectFromSBOM$getSubmittableFile(modalModel),
								$elm$core$Maybe$Nothing),
							En: $author$project$Pages$OrgIndex$CreateProjectFromSBOM,
							Gv: $author$project$Views$CreateProjectFromSBOM$isFormSubmitting(modalModel) ? 'Creating Project...' : 'Create Project'
						}),
					dH: A2(
						$elm$html$Html$map,
						$author$project$Pages$OrgIndex$ImportSBOMMsg(modalModel),
						$author$project$Views$CreateProjectFromSBOM$view(modalModel)),
					l6: $elm$core$Maybe$Nothing
				});
		};
		var githubModal = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('little-modal')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Using Komodo or the State Tool?'),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									$elm$html$Html$text('You\'ll need a Password!')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('For now, Komodo and the State Tool are not able to use your Github credentials. You can still use your Github username, but you will need to set a password to use them.')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button-wrapper')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Views$Link$link,
									$author$project$Model$Route$Protected(
										$author$project$Model$Route$PreferencePassword(
											{El: setPasswordModeQueryParameter})),
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('primary-button')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Set my Password')
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick($author$project$Pages$OrgIndex$DismissModal),
											$elm$html$Html$Attributes$class('secondary-button')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Skip this Step')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('image set-password')
								]),
							_List_Nil)
						]))
				]));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$main_,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('org-dashboard'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('just-scanned', model.si)
								]))
						]),
					_List_fromArray(
						[
							$author$project$Views$NotificationsInline$view(model),
							A2($author$project$Misc$displayIf, model.pN, githubModal),
							A2($author$project$Misc$displayMaybe, importSBOMView, model.i9),
							A3($author$project$Pages$OrgIndex$viewOrgDashboard, session, model, currentTime)
						]))
				]));
	});
var $author$project$Pages$OrgMembers$ChangeNewMemberEmail = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$OrgMembers$ChangeNewMemberRole = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$OrgMembers$ClearSearch = {$: 11};
var $author$project$Pages$OrgMembers$InviteMember = {$: 2};
var $author$project$Pages$OrgMembers$SearchUsers = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$OrgMembers$ChangeAutoInviteDomain = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$OrgMembers$ChangeAutoInviteRole = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$OrgMembers$ToggleAutoInvite = {$: 13};
var $author$project$Pages$OrgMembers$isAutoInviteEnabled = function (autoInviteDomains) {
	return !$elm$core$List$isEmpty(autoInviteDomains);
};
var $author$project$Pages$OrgMembers$autoInviteView = function (model) {
	var optionView = F2(
		function (isSelected, domain) {
			return A2(
				$elm$html$Html$option,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$value(domain),
						$elm$html$Html$Attributes$selected(isSelected)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(domain)
					]));
		});
	var enabledDomainDetails = $elm$core$List$head(model.iP);
	var eligibleDomains = function () {
		if (!enabledDomainDetails.$) {
			var domainDetails = enabledDomainDetails.a;
			return A2(
				$elm$core$List$filter,
				$elm$core$Basics$neq(
					$author$project$Model$Organization$getAutoInviteDomain(domainDetails)),
				model.g_);
		} else {
			return model.g_;
		}
	}();
	var optionSelector = function () {
		var selectedOption = function () {
			if (!enabledDomainDetails.$) {
				var details = enabledDomainDetails.a;
				var isSelectedOption = function () {
					var _v5 = model.h2;
					if (!_v5.$) {
						var domain = _v5.a;
						return _Utils_eq(
							$author$project$Model$Organization$getAutoInviteDomain(details),
							domain);
					} else {
						return false;
					}
				}();
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$option,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$disabled(true)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Selected domain')
							])),
						A2(
						optionView,
						isSelectedOption,
						$author$project$Model$Organization$getAutoInviteDomain(details))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var domainOptions = A2(
			$elm$core$List$append,
			selectedOption,
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$option,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$disabled(true)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Eligible domains')
						])),
				A2(
					$elm$core$List$map,
					optionView(false),
					eligibleDomains)));
		return A2(
			$elm$html$Html$select,
			_List_fromArray(
				[
					$elm$html$Html$Events$onInput($author$project$Pages$OrgMembers$ChangeAutoInviteDomain)
				]),
			domainOptions);
	}();
	var cannotEnableView = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('cannot-enable')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('To enable this feature, add at least one verified email address with an eligible domain to your account.')
					])),
				A3(
				$author$project$Views$Link$view,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Manage your email addresses')
					]),
				$author$project$Model$Route$Protected($author$project$Model$Route$PreferenceIndex))
			]));
	var cannotChangeView = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('cannot-change')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('To enabled for a different domain, add a verified email address with an eligible domain to your account.')
					])),
				A3(
				$author$project$Views$Link$view,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Manage your email addresses')
					]),
				$author$project$Model$Route$Protected($author$project$Model$Route$PreferenceIndex))
			]));
	var blockEnableAutoInvite = $elm_community$maybe_extra$Maybe$Extra$isNothing(model.h2);
	var autoInviteEnabled = $author$project$Pages$OrgMembers$isAutoInviteEnabled(model.iP);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('add-member auto-invite'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('loading', model.h1)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						blockEnableAutoInvite ? $author$project$Pages$OrgMembers$NoOp : $author$project$Pages$OrgMembers$ToggleAutoInvite),
						$elm$html$Html$Attributes$class('slide-toggle-wrapper'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('enabled', autoInviteEnabled),
								_Utils_Tuple2('disabled', blockEnableAutoInvite)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('slide-toggle')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('nub')
									]),
								_List_Nil)
							]))
					])),
				A2(
				$elm$html$Html$h2,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Automatic invites')
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Automatically invite users to this organization when they join and have a verified email address with the selected domain.')
					])),
				A2(
				$elm$html$Html$form,
				_List_fromArray(
					[
						$elm$html$Html$Events$onSubmit($author$project$Pages$OrgMembers$InviteMember),
						$elm$html$Html$Attributes$class('domain-form')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Email Domain'),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('more-info-tooltip')
									]),
								_List_fromArray(
									[
										$author$project$Views$Icon$view(
										$author$project$Views$Icon$icon(52)),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('content')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('For a domain to be eligible...')
													])),
												A2(
												$elm$html$Html$ul,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('eligibility-criteria')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$li,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('You must have a verified email address with that domain.')
															])),
														A2(
														$elm$html$Html$li,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('It cannot already be in use for automatic invites for another organization.')
															])),
														A2(
														$elm$html$Html$li,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('It cannot be for a public email provider (\"gmail.com\", etc.)')
															]))
													]))
											]))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						function () {
							var _v0 = _Utils_Tuple2(enabledDomainDetails, eligibleDomains);
							_v0$3:
							while (true) {
								if (_v0.a.$ === 1) {
									if (!_v0.b.b) {
										var _v1 = _v0.a;
										return _List_fromArray(
											[
												A2(
												$elm$html$Html$p,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('no-domains-available')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('No eligible domains available.')
													])),
												cannotEnableView
											]);
									} else {
										if (!_v0.b.b.b) {
											var _v2 = _v0.a;
											var _v3 = _v0.b;
											var domain = _v3.a;
											return _List_fromArray(
												[
													A2(
													$elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(domain)
														])),
													cannotChangeView
												]);
										} else {
											break _v0$3;
										}
									}
								} else {
									if (!_v0.b.b) {
										var details = _v0.a.a;
										return _List_fromArray(
											[
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Model$Organization$getAutoInviteDomain(details))
													])),
												cannotChangeView
											]);
									} else {
										break _v0$3;
									}
								}
							}
							return _List_fromArray(
								[optionSelector]);
						}()),
						A2($author$project$Views$RoleSelector$view, $author$project$Pages$OrgMembers$ChangeAutoInviteRole, model.n3),
						A2(
						$author$project$Misc$displayIf,
						model.lK,
						A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('form-error')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Please provide a valid email address.')
								])))
					]))
			]));
};
var $author$project$Model$Permissions$canManageMembers = function (org) {
	return A2(
		$author$project$Misc$isEither,
		A2(
			$author$project$Model$Permissions$isOneOf,
			_List_fromArray(
				[2]),
			org),
		$author$project$Model$User$isSuperUser);
};
var $author$project$Pages$OrgMembers$CancelInvitation = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$OrgMembers$ResendInvite = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$OrgMembers$formatDate = F2(
	function (localTimezone, date) {
		return A3(
			$ryan_haskell$date_format$DateFormat$format,
			_List_fromArray(
				[
					$ryan_haskell$date_format$DateFormat$monthNameAbbreviated,
					$ryan_haskell$date_format$DateFormat$text(' '),
					$ryan_haskell$date_format$DateFormat$dayOfMonthSuffix,
					$ryan_haskell$date_format$DateFormat$text(', '),
					$ryan_haskell$date_format$DateFormat$yearNumber
				]),
			localTimezone,
			date);
	});
var $author$project$Pages$OrgMembers$invitationView = F4(
	function (session, pendingMember, currentOrgName, canManageMembers) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('org-member pending-member')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('username')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(pendingMember.lJ),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('timestamp')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Invited on '),
									$elm$html$Html$text(
									A2(
										$author$project$Pages$OrgMembers$formatDate,
										$author$project$Model$Session$getLocalTimezone(session),
										pendingMember.g))
								]))
						])),
					A2(
					$author$project$Misc$displayIf,
					canManageMembers,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row-actions')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick(
										$author$project$Pages$OrgMembers$ResendInvite(
											{CS: pendingMember.lJ, ix: currentOrgName, FO: $elm$core$Maybe$Nothing})),
										$elm$html$Html$Attributes$class('primary-button small')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Resend')
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('red-button small'),
										$elm$html$Html$Events$onClick(
										$author$project$Pages$OrgMembers$CancelInvitation(
											{CS: pendingMember.lJ, ix: currentOrgName, FO: $elm$core$Maybe$Nothing}))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Cancel')
									]))
							])))
				]));
	});
var $author$project$Pages$OrgMembers$lowercaseAndClean = function (searchInput) {
	return $elm_community$string_extra$String$Extra$clean(
		$elm$core$String$toLower(searchInput));
};
var $author$project$Pages$OrgMembers$ChangeMemberRole = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Pages$OrgMembers$RemoveMember = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$User$effectiveRole = F2(
	function (orgUrlName, user) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($author$project$Model$User$role, orgUrlName, user));
	});
var $author$project$Pages$OrgMembers$memberView = F4(
	function (member, currentOrgName, currentUserName, canManageMembers) {
		var user = member.gS;
		var isCurrentUser = _Utils_eq(currentUserName, user.AE);
		var currentRole = A2($author$project$Model$User$effectiveRole, currentOrgName, user);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('org-member'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('current-user', isCurrentUser)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('username')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('username-value')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(user.AE)
								])),
							A2(
							$author$project$Misc$displayIf,
							!canManageMembers,
							A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('item-label')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Model$Role$toDisplayString(currentRole))
									]))),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('email-value')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(user.lJ)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row-actions')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Misc$displayIf,
							canManageMembers,
							A2(
								$elm$html$Html$select,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('role-picker'),
										$elm$html$Html$Attributes$class('enabled'),
										$elm$html$Html$Events$onInput(
										$author$project$Pages$OrgMembers$ChangeMemberRole(member.gS.AE)),
										A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Select member role')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$option,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$selected(currentRole === 2),
												$elm$html$Html$Attributes$value(
												$author$project$Model$Role$toInternalString(2))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Model$Role$toDisplayString(2))
											])),
										A2(
										$elm$html$Html$option,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$selected(currentRole === 1),
												$elm$html$Html$Attributes$value(
												$author$project$Model$Role$toInternalString(1))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Model$Role$toDisplayString(1))
											])),
										A2(
										$elm$html$Html$option,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$selected(!currentRole),
												$elm$html$Html$Attributes$value(
												$author$project$Model$Role$toInternalString(0))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Model$Role$toDisplayString(0))
											]))
									]))),
							A2(
							$author$project$Misc$displayIf,
							isCurrentUser || canManageMembers,
							A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('red-button small'),
										$elm$html$Html$Events$onClick(
										$author$project$Pages$OrgMembers$RemoveMember(
											{CS: user.AE, ix: currentOrgName, FO: $elm$core$Maybe$Nothing}))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										isCurrentUser ? 'Leave' : 'Remove')
									])))
						]))
				]));
	});
var $author$project$Model$Permissions$orgHasUnlimitedMemberAddon = $author$project$Model$Organization$addOnEnabled('unlimited_members');
var $author$project$Pages$OrgMembers$view = F2(
	function (model, session) {
		var managementColumn = _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('add-member')
					]),
				$author$project$Model$Permissions$orgHasUnlimitedMemberAddon(model.c3) ? _List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Invite a new member')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('We will send them an email that lets them join this organization.')
							])),
						A2(
						$elm$html$Html$form,
						_List_fromArray(
							[
								$elm$html$Html$Events$onSubmit($author$project$Pages$OrgMembers$InviteMember)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('email'),
										$elm$html$Html$Attributes$spellcheck(false),
										$elm$html$Html$Attributes$placeholder('example@email.com'),
										$elm$html$Html$Events$onInput($author$project$Pages$OrgMembers$ChangeNewMemberEmail),
										$elm$html$Html$Attributes$value(model.kb)
									]),
								_List_Nil),
								A2($author$project$Views$RoleSelector$view, $author$project$Pages$OrgMembers$ChangeNewMemberRole, model.mF),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('primary-button')
									]),
								_List_fromArray(
									[
										$author$project$Views$Icon$view(
										$author$project$Views$Icon$icon(23)),
										$elm$html$Html$text('Send Invite')
									])),
								A2(
								$author$project$Misc$displayIf,
								model.lK,
								A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('form-error')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Please provide a valid email address.')
										])))
							]))
					]) : _List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Invite a new member')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('This organization is not able to invite additional members. Please see our '),
								A3(
								$author$project$Views$Link$external,
								$author$project$Url$Extra$pricing(_List_Nil),
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Pricing Page')
									]))
							]))
					])),
				A2(
				$author$project$Misc$displayIf,
				$author$project$Model$Permissions$orgCanAutoInviteMembers(model.c3),
				$author$project$Pages$OrgMembers$autoInviteView(model))
			]);
		var itemCount = $elm$core$List$length(model.jb) + $elm$core$List$length(model.hB);
		var currentUserName = $author$project$Model$Session$getUsername(session);
		var sortUsername = F2(
			function (a, b) {
				return _Utils_eq(
					currentUserName,
					function ($) {
						return $.AE;
					}(a.gS)) ? 0 : (_Utils_eq(
					currentUserName,
					function ($) {
						return $.AE;
					}(b.gS)) ? 2 : ((_Utils_cmp(
					function ($) {
						return $.AE;
					}(a.gS),
					function ($) {
						return $.AE;
					}(b.gS)) > 0) ? 2 : 0));
			});
		var currentOrgName = model.c3.AC;
		var canManageMembers = A2(
			$author$project$Model$Permissions$canManageMembers,
			currentOrgName,
			$author$project$Model$Session$getUser(session));
		var invitations = A2(
			$elm$core$List$map,
			function (i) {
				return A4($author$project$Pages$OrgMembers$invitationView, session, i, currentOrgName, canManageMembers);
			},
			A2(
				$elm$core$List$filter,
				function (i) {
					return A2(
						$elm$core$String$contains,
						$author$project$Pages$OrgMembers$lowercaseAndClean(model.hR),
						$elm$core$String$toLower(i.lJ));
				},
				model.jb));
		var membersList = A2(
			$elm$core$List$map,
			function (m) {
				return A4($author$project$Pages$OrgMembers$memberView, m, currentOrgName, currentUserName, canManageMembers);
			},
			A2(
				$elm$core$List$sortWith,
				sortUsername,
				A2(
					$elm$core$List$filter,
					function (m) {
						return A2(
							$elm$core$String$contains,
							$author$project$Pages$OrgMembers$lowercaseAndClean(model.hR),
							$elm$core$String$toLower(m.gS.lJ)) || A2(
							$elm$core$String$contains,
							$author$project$Pages$OrgMembers$lowercaseAndClean(model.hR),
							$elm$core$String$toLower(m.gS.AE));
					},
					model.hB)));
		var pageData = _List_fromArray(
			[
				A2(
				$author$project$Misc$displayIf,
				$elm$core$List$length(model.jb) > 0,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pending-member-list-wrapper new-box')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Pending Invites'),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('item-count')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromInt(
												$elm$core$List$length(invitations)))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pending-member-list')
								]),
							invitations),
							A2(
							$author$project$Misc$displayIf,
							$elm$core$List$isEmpty(invitations),
							A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('no-results')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('No matching invites.')
									])))
						]))),
				A2(
				$author$project$Misc$displayIf,
				$elm$core$List$length(model.hB) > 0,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('member-list-wrapper new-box')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Members'),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('item-count')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromInt(
												$elm$core$List$length(membersList)))
										])),
									A2(
									$author$project$Misc$displayIf,
									itemCount > 0,
									A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('inline-search-ui member-search')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$type_('text'),
														$elm$html$Html$Attributes$placeholder('Username or Email'),
														$elm$html$Html$Events$onInput($author$project$Pages$OrgMembers$SearchUsers),
														$elm$html$Html$Attributes$autofocus(true),
														$elm$html$Html$Attributes$value(model.hR)
													]),
												_List_Nil),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('search-icon')
													]),
												_List_fromArray(
													[
														$author$project$Views$Icon$view(
														$author$project$Views$Icon$icon(69))
													])),
												A2(
												$author$project$Misc$displayIf,
												$elm$core$String$length(model.hR) > 0,
												A2(
													$elm$html$Html$button,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('clear-search'),
															$elm$html$Html$Events$onClick($author$project$Pages$OrgMembers$ClearSearch)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Clear')
														])))
											])))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('member-list')
								]),
							membersList),
							A2(
							$author$project$Misc$displayIf,
							$elm$core$List$isEmpty(membersList),
							A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('no-results')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('No matching members.')
									])))
						])))
			]);
		return canManageMembers ? $author$project$Views$Columns$asHtml(
			A2(
				$author$project$Views$Columns$withColumns,
				_List_fromArray(
					[managementColumn, pageData]),
				A2(
					$author$project$Views$Columns$withColumnAs,
					$elm$html$Html$section,
					A2(
						$author$project$Views$Columns$withAttrs,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('members-tab')
							]),
						$author$project$Views$Columns$asColumns($elm$html$Html$main_))))) : A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('members-tab')
				]),
			pageData);
	});
var $author$project$Pages$OrgPolicy$CancelModal = {$: 4};
var $author$project$Pages$OrgPolicy$ConfirmDeletePolicy = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$OrgPolicy$EditPolicy = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$OrgPolicy$MainEditor = 0;
var $author$project$Pages$OrgPolicy$ModalEditor = 1;
var $author$project$Pages$OrgPolicy$PolicyEditorMsg = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$OrgPolicy$SaveModal = function (a) {
	return {$: 5, a: a};
};
var $author$project$Misc$consErr = F2(
	function (result, list) {
		if (result.$ === 1) {
			var e = result.a;
			return A2($elm$core$List$cons, e, list);
		} else {
			return list;
		}
	});
var $author$project$Views$PolicyEditor$nameAlreadyTaken = function (_v0) {
	var policy = _v0.rX;
	var otherPolicyNames = _v0.pf;
	return A2($elm$core$List$member, policy.w, otherPolicyNames) ? $elm$core$Result$Err('That name is already taken by another policy') : $elm$core$Result$Ok(0);
};
var $author$project$Views$PolicyEditor$nameIsEmpty = function (_v0) {
	var policy = _v0.rX;
	return (policy.w === '') ? $elm$core$Result$Err('Policies must have a unique, non-blank name') : $elm$core$Result$Ok(0);
};
var $author$project$Views$PolicyEditor$anyValidationErrors = function (model) {
	var errors = A2(
		$author$project$Misc$consErr,
		$author$project$Views$PolicyEditor$nameAlreadyTaken(model),
		A2(
			$author$project$Misc$consErr,
			$author$project$Views$PolicyEditor$nameIsEmpty(model),
			_List_Nil));
	var _v0 = $mgold$elm_nonempty_list$List$Nonempty$fromList(errors);
	if (!_v0.$) {
		var nonempty = _v0.a;
		return $elm$core$Result$Err(nonempty);
	} else {
		return $elm$core$Result$Ok(0);
	}
};
var $author$project$Views$PolicyEditor$UpdateCode = function (a) {
	return {$: 18, a: a};
};
var $author$project$Views$PolicyEditor$UpdateDescription = function (a) {
	return {$: 17, a: a};
};
var $author$project$Views$PolicyEditor$UpdateName = function (a) {
	return {$: 16, a: a};
};
var $author$project$Misc$displayErr = F2(
	function (f, result) {
		if (result.$ === 1) {
			var e = result.a;
			return f(e);
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Views$PolicyEditor$firstErrorOrOks = A2(
	$elm$core$List$foldl,
	F2(
		function (element, acc) {
			var _v0 = _Utils_Tuple2(element, acc);
			if (!_v0.b.$) {
				if (!_v0.a.$) {
					var elem = _v0.a.a;
					var list = _v0.b.a;
					return $elm$core$Result$Ok(
						A2($elm$core$List$cons, elem, list));
				} else {
					var e = _v0.a.a;
					return $elm$core$Result$Err(e);
				}
			} else {
				var e = _v0.b.a;
				return $elm$core$Result$Err(e);
			}
		}),
	$elm$core$Result$Ok(_List_Nil));
var $elm$html$Html$Attributes$rows = function (n) {
	return A2(
		_VirtualDom_attribute,
		'rows',
		$elm$core$String$fromInt(n));
};
var $author$project$Model$Policy$Policy$encode = function (policy) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(policy.w)),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(policy.bP)),
				_Utils_Tuple2(
				'expr',
				$author$project$Model$Policy$Policy$encodeExpr(
					$author$project$Model$Policy$Policy$rulesToExpr(policy.ks)))
			]));
};
var $author$project$Model$Policy$Policy$toJson = function (indent) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Model$Policy$Policy$encode,
		$elm$json$Json$Encode$encode(indent));
};
var $author$project$Views$PolicyEditor$AsCode = 0;
var $author$project$Views$PolicyEditor$SetViewMode = function (a) {
	return {$: 19, a: a};
};
var $author$project$Views$PolicyEditor$viewModeToggle = function (viewMode) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('display-pill')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('selected', viewMode === 1)
							])),
						$elm$html$Html$Events$onClick(
						$author$project$Views$PolicyEditor$SetViewMode(1))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('UI')
					])),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('selected', !viewMode)
							])),
						$elm$html$Html$Events$onClick(
						$author$project$Views$PolicyEditor$SetViewMode(0))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Code')
					]))
			]));
};
var $author$project$Views$PolicyEditor$IndexedRule = F2(
	function (index, rule) {
		return {j$: index, pG: rule};
	});
var $author$project$Views$PolicyEditor$AugmentedView = F3(
	function (index, rule, view) {
		return {j$: index, pG: rule, G4: view};
	});
var $author$project$Views$PolicyEditor$AddRule = function (a) {
	return {$: 14, a: a};
};
var $author$project$Views$PolicyEditor$showEditButtons = function (uiMode) {
	switch (uiMode) {
		case 0:
			return true;
		case 1:
			return false;
		default:
			return true;
	}
};
var $author$project$Views$PolicyEditor$addRuleButton = F2(
	function (ruleID, uiMode) {
		return A2(
			$author$project$Misc$displayIf,
			$author$project$Views$PolicyEditor$showEditButtons(uiMode),
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('rule')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$Views$PolicyEditor$AddRule(ruleID)),
								$elm$html$Html$Attributes$class('small secondary-button'),
								$elm$html$Html$Attributes$class('add-button')
							]),
						_List_fromArray(
							[
								$author$project$Views$Icon$view(
								$author$project$Views$Icon$icon(61)),
								$elm$html$Html$text('Add Rule')
							]))
					])));
	});
var $author$project$Views$PolicyEditor$RemoveRule = function (a) {
	return {$: 15, a: a};
};
var $author$project$Views$PolicyEditor$removeRuleButton = F2(
	function (ruleID, uiMode) {
		return A2(
			$author$project$Misc$displayIf,
			$author$project$Views$PolicyEditor$showEditButtons(uiMode),
			A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('remove-rule'),
						$elm$html$Html$Events$onClick(
						$author$project$Views$PolicyEditor$RemoveRule(ruleID))
					]),
				_List_fromArray(
					[
						$author$project$Views$Icon$view(
						$author$project$Views$Icon$icon(81))
					])));
	});
var $author$project$Views$PolicyEditor$toView = F2(
	function (uiMode, augmented) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('rule')
				]),
			_List_fromArray(
				[
					augmented.G4,
					A2($author$project$Views$PolicyEditor$removeRuleButton, augmented.j$, uiMode)
				]));
	});
var $author$project$Views$PolicyEditor$toListItems = F3(
	function (uiMode, augmented, children) {
		var plainView = function () {
			var _v0 = $author$project$Model$Policy$PolicyRules$childrenSupported(augmented.pG);
			switch (_v0) {
				case 0:
					return A2($author$project$Views$PolicyEditor$toView, uiMode, augmented);
				case 1:
					var childrenViews = $elm$core$List$isEmpty(children) ? _List_fromArray(
						[
							A2($author$project$Views$PolicyEditor$addRuleButton, augmented.j$, uiMode)
						]) : A2(
						$elm$core$List$map,
						function ($) {
							return $.G4;
						},
						children);
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Views$PolicyEditor$toView, uiMode, augmented),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('rule-tree-children')
									]),
								childrenViews)
							]));
				default:
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('rule-heading')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Rule Group')
									])),
								A2($author$project$Views$PolicyEditor$toView, uiMode, augmented),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('rule-tree-children')
									]),
								_Utils_ap(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.G4;
										},
										children),
									_List_fromArray(
										[
											A2($author$project$Views$PolicyEditor$addRuleButton, augmented.j$, uiMode)
										])))
							]));
			}
		}();
		return A3($author$project$Views$PolicyEditor$AugmentedView, augmented.j$, augmented.pG, plainView);
	});
var $author$project$Views$PolicyEditor$SetComparator = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Model$Comparator$all = _List_fromArray(
	[0, 1, 2, 3, 4, 5]);
var $author$project$Views$PolicyEditor$selectWithRuleID = F6(
	function (toMsg, elements, toString, selectedElement, ruleID, uiMode) {
		return A2(
			$elm$html$Html$select,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('rule-dropdown'),
					$elm$html$Html$Events$onInput(
					toMsg(ruleID)),
					$elm$html$Html$Attributes$disabled(uiMode === 1)
				]),
			A2(
				$elm$core$List$map,
				function (element) {
					var elementStr = toString(element);
					return A2(
						$elm$html$Html$option,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$selected(
								_Utils_eq(element, selectedElement)),
								$elm$html$Html$Attributes$value(elementStr)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(elementStr)
							]));
				},
				elements));
	});
var $author$project$Views$PolicyEditor$comparatorSelect = A3($author$project$Views$PolicyEditor$selectWithRuleID, $author$project$Views$PolicyEditor$SetComparator, $author$project$Model$Comparator$all, $author$project$Model$Comparator$toString);
var $author$project$Views$PolicyEditor$SetConstraint = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Views$PolicyEditor$ruleInput = F5(
	function (toMsg, attrs, children, ruleID, uiMode) {
		return A2(
			$elm$html$Html$input,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Events$onInput(
						toMsg(ruleID)),
						$elm$html$Html$Attributes$readonly(uiMode === 1),
						$elm$html$Html$Attributes$class('rule-input')
					]),
				attrs),
			children);
	});
var $author$project$Views$PolicyEditor$ruleTextInput = F3(
	function (toMsg, attrs, children) {
		return A3(
			$author$project$Views$PolicyEditor$ruleInput,
			toMsg,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$type_('text'),
				attrs),
			children);
	});
var $author$project$Views$PolicyEditor$constraintInput = function (currentValue) {
	return A3(
		$author$project$Views$PolicyEditor$ruleTextInput,
		$author$project$Views$PolicyEditor$SetConstraint,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$value(currentValue),
				$elm$html$Html$Attributes$placeholder('X.Y.Z')
			]),
		_List_Nil);
};
var $author$project$Views$PolicyEditor$SetCveId = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Views$PolicyEditor$cveIdInput = function (currentValue) {
	return A3(
		$author$project$Views$PolicyEditor$ruleTextInput,
		$author$project$Views$PolicyEditor$SetCveId,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$value(currentValue),
				$elm$html$Html$Attributes$placeholder('CVE-2021-44228')
			]),
		_List_Nil);
};
var $author$project$Views$PolicyEditor$SetDays = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Views$PolicyEditor$ruleNumberInput = F3(
	function (toMsg, attrs, children) {
		return A3(
			$author$project$Views$PolicyEditor$ruleInput,
			toMsg,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$type_('number'),
				attrs),
			children);
	});
var $author$project$Views$PolicyEditor$daysInput = function (currentValue) {
	return A3(
		$author$project$Views$PolicyEditor$ruleNumberInput,
		$author$project$Views$PolicyEditor$SetDays,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$value(currentValue),
				$elm$html$Html$Attributes$placeholder('30')
			]),
		_List_Nil);
};
var $author$project$Views$PolicyEditor$interspersedText = function (s) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('interspersed-text')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(s)
			]));
};
var $author$project$Views$PolicyEditor$SetLanguageName = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Views$PolicyEditor$languageNameInput = function (currentValue) {
	return A3(
		$author$project$Views$PolicyEditor$ruleTextInput,
		$author$project$Views$PolicyEditor$SetLanguageName,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$value(currentValue)
			]),
		_List_Nil);
};
var $author$project$Views$PolicyEditor$SetLicenseCategory = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Model$Policy$LicenseCategory$all = _List_fromArray(
	[0, 1, 2]);
var $author$project$Views$PolicyEditor$licenseCategorySelect = A3($author$project$Views$PolicyEditor$selectWithRuleID, $author$project$Views$PolicyEditor$SetLicenseCategory, $author$project$Model$Policy$LicenseCategory$all, $author$project$Model$Policy$LicenseCategory$toString);
var $author$project$Views$PolicyEditor$SetLicenseInput = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Views$PolicyEditor$licenseInput = function (currentValue) {
	return A3(
		$author$project$Views$PolicyEditor$ruleTextInput,
		$author$project$Views$PolicyEditor$SetLicenseInput,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$value(currentValue),
				$elm$html$Html$Attributes$placeholder('MIT')
			]),
		_List_Nil);
};
var $author$project$Views$PolicyEditor$SetPackageName = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Views$PolicyEditor$packageInput = function (currentValue) {
	return A3(
		$author$project$Views$PolicyEditor$ruleTextInput,
		$author$project$Views$PolicyEditor$SetPackageName,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$value(currentValue),
				$elm$html$Html$Attributes$placeholder('package-name')
			]),
		_List_Nil);
};
var $author$project$Views$PolicyEditor$SetPolicyName = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Views$PolicyEditor$policySelect = function (otherPolicyNames) {
	return A3($author$project$Views$PolicyEditor$selectWithRuleID, $author$project$Views$PolicyEditor$SetPolicyName, otherPolicyNames, $elm$core$Basics$identity);
};
var $author$project$Views$PolicyEditor$SetProjectName = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Views$PolicyEditor$projectSelect = function (projectNames) {
	return A3($author$project$Views$PolicyEditor$selectWithRuleID, $author$project$Views$PolicyEditor$SetProjectName, projectNames, $elm$core$Basics$identity);
};
var $author$project$Views$PolicyEditor$SetRuleKind = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Model$Policy$RuleKind$all = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 14, 15]);
var $author$project$Views$PolicyEditor$disabledRules = _List_fromArray(
	[5, 15]);
var $author$project$Model$Policy$RuleKind$toString = function (ruleKind) {
	switch (ruleKind) {
		case 0:
			return 'And';
		case 1:
			return 'Or';
		case 2:
			return 'Not';
		case 3:
			return 'Language name';
		case 4:
			return 'Language name and version';
		case 5:
			return 'Language status';
		case 6:
			return 'Licenses are';
		case 7:
			return 'Any licenses are named';
		case 8:
			return 'Package name is';
		case 9:
			return 'Package matches';
		case 10:
			return 'Passes policy';
		case 11:
			return 'Project is';
		case 12:
			return 'Project visibility';
		case 13:
			return 'Has CVE';
		case 14:
			return 'Vulnerabilities are all less than';
		default:
			return 'Vulnerabilities are all less than with age in days';
	}
};
var $author$project$Views$PolicyEditor$ruleKindSelect = A3(
	$author$project$Views$PolicyEditor$selectWithRuleID,
	$author$project$Views$PolicyEditor$SetRuleKind,
	A2(
		$elm$core$List$filter,
		A2(
			$elm$core$Basics$composeL,
			$elm$core$Basics$not,
			$author$project$Misc$memberOf($author$project$Views$PolicyEditor$disabledRules)),
		$author$project$Model$Policy$RuleKind$all),
	$author$project$Model$Policy$RuleKind$toString);
var $author$project$Views$PolicyEditor$SetSeverity = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Views$PolicyEditor$severitySelect = A3($author$project$Views$PolicyEditor$selectWithRuleID, $author$project$Views$PolicyEditor$SetSeverity, $author$project$Model$Severity$all, $author$project$Model$Severity$toString);
var $author$project$Views$PolicyEditor$SetLanguageStatus = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Model$Policy$LanguageStatus$all = _List_fromArray(
	[0, 1, 2]);
var $author$project$Views$PolicyEditor$statusSelect = A3($author$project$Views$PolicyEditor$selectWithRuleID, $author$project$Views$PolicyEditor$SetLanguageStatus, $author$project$Model$Policy$LanguageStatus$all, $author$project$Model$Policy$LanguageStatus$toString);
var $author$project$Views$PolicyEditor$SetVisibility = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Model$Visibility$all = _List_fromArray(
	[0, 1]);
var $author$project$Views$PolicyEditor$visibilitySelect = A3($author$project$Views$PolicyEditor$selectWithRuleID, $author$project$Views$PolicyEditor$SetVisibility, $author$project$Model$Visibility$all, $author$project$Model$Visibility$toString);
var $author$project$Views$PolicyEditor$viewRule = F4(
	function (uiMode, projectNames, otherPolicyNames, _v0) {
		var index = _v0.j$;
		var rule = _v0.pG;
		var wrapper = $elm$html$Html$span(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('rule-line')
				]));
		var plainView = function () {
			switch (rule.$) {
				case 0:
					return $elm$html$Html$text('');
				case 1:
					return A3($author$project$Views$PolicyEditor$ruleKindSelect, 0, index, uiMode);
				case 2:
					return A3($author$project$Views$PolicyEditor$ruleKindSelect, 1, index, uiMode);
				case 3:
					return A3($author$project$Views$PolicyEditor$ruleKindSelect, 2, index, uiMode);
				case 4:
					var languageName = rule.a;
					return wrapper(
						_List_fromArray(
							[
								A3($author$project$Views$PolicyEditor$ruleKindSelect, 3, index, uiMode),
								A3($author$project$Views$PolicyEditor$languageNameInput, languageName, index, uiMode)
							]));
				case 5:
					var languageName = rule.a;
					var constraint = rule.b;
					return wrapper(
						_List_fromArray(
							[
								A3($author$project$Views$PolicyEditor$ruleKindSelect, 4, index, uiMode),
								A3($author$project$Views$PolicyEditor$languageNameInput, languageName, index, uiMode),
								A3($author$project$Views$PolicyEditor$constraintInput, constraint, index, uiMode)
							]));
				case 6:
					var status = rule.a;
					return wrapper(
						_List_fromArray(
							[
								A3($author$project$Views$PolicyEditor$ruleKindSelect, 5, index, uiMode),
								A3($author$project$Views$PolicyEditor$statusSelect, status, index, uiMode)
							]));
				case 7:
					var category = rule.a;
					return wrapper(
						_List_fromArray(
							[
								A3($author$project$Views$PolicyEditor$ruleKindSelect, 6, index, uiMode),
								A3($author$project$Views$PolicyEditor$licenseCategorySelect, category, index, uiMode)
							]));
				case 8:
					var licenseName = rule.a;
					return wrapper(
						_List_fromArray(
							[
								A3($author$project$Views$PolicyEditor$ruleKindSelect, 7, index, uiMode),
								A3($author$project$Views$PolicyEditor$licenseInput, licenseName, index, uiMode)
							]));
				case 9:
					var packageName = rule.a;
					return wrapper(
						_List_fromArray(
							[
								A3($author$project$Views$PolicyEditor$ruleKindSelect, 8, index, uiMode),
								A3($author$project$Views$PolicyEditor$packageInput, packageName, index, uiMode)
							]));
				case 10:
					var packageName = rule.a;
					var constraint = rule.b;
					return wrapper(
						_List_fromArray(
							[
								A3($author$project$Views$PolicyEditor$ruleKindSelect, 9, index, uiMode),
								A3($author$project$Views$PolicyEditor$packageInput, packageName, index, uiMode),
								A3($author$project$Views$PolicyEditor$constraintInput, constraint, index, uiMode)
							]));
				case 11:
					var policyName = rule.a;
					return wrapper(
						_List_fromArray(
							[
								A3($author$project$Views$PolicyEditor$ruleKindSelect, 10, index, uiMode),
								A4($author$project$Views$PolicyEditor$policySelect, otherPolicyNames, policyName, index, uiMode)
							]));
				case 12:
					var projectName = rule.a;
					return wrapper(
						_List_fromArray(
							[
								A3($author$project$Views$PolicyEditor$ruleKindSelect, 11, index, uiMode),
								A4($author$project$Views$PolicyEditor$projectSelect, projectNames, projectName, index, uiMode)
							]));
				case 13:
					var visibility = rule.a;
					return wrapper(
						_List_fromArray(
							[
								A3($author$project$Views$PolicyEditor$ruleKindSelect, 12, index, uiMode),
								A3($author$project$Views$PolicyEditor$visibilitySelect, visibility, index, uiMode)
							]));
				case 14:
					var cveId = rule.a;
					return wrapper(
						_List_fromArray(
							[
								A3($author$project$Views$PolicyEditor$ruleKindSelect, 13, index, uiMode),
								A3($author$project$Views$PolicyEditor$cveIdInput, cveId, index, uiMode)
							]));
				case 15:
					var severity = rule.a;
					return wrapper(
						_List_fromArray(
							[
								A3($author$project$Views$PolicyEditor$ruleKindSelect, 14, index, uiMode),
								A3($author$project$Views$PolicyEditor$severitySelect, severity, index, uiMode)
							]));
				case 16:
					var severity = rule.a;
					var comparator = rule.b;
					var days = rule.c;
					return wrapper(
						_List_fromArray(
							[
								A3($author$project$Views$PolicyEditor$ruleKindSelect, 15, index, uiMode),
								A3($author$project$Views$PolicyEditor$comparatorSelect, comparator, index, uiMode),
								A3($author$project$Views$PolicyEditor$daysInput, days, index, uiMode),
								$author$project$Views$PolicyEditor$interspersedText('day old vulnerabilities are less than'),
								A3($author$project$Views$PolicyEditor$severitySelect, severity, index, uiMode),
								$author$project$Views$PolicyEditor$interspersedText('severity')
							]));
				default:
					return wrapper(
						_List_fromArray(
							[
								$elm$html$Html$text('Unrecognized rule, switch to Code view to inspect')
							]));
			}
		}();
		return A3(
			$author$project$Views$PolicyEditor$AugmentedView,
			index,
			rule,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('rule-tree-outer')
					]),
				_List_fromArray(
					[plainView])));
	});
var $author$project$Views$PolicyEditor$viewRules = function (_v0) {
	var uiMode = _v0.wQ;
	var policy = _v0.rX;
	var projectNames = _v0.vU;
	var otherPolicyNames = _v0.pf;
	return A3(
		$zwilias$elm_rosetree$Tree$restructure,
		A3($author$project$Views$PolicyEditor$viewRule, uiMode, projectNames, otherPolicyNames),
		$author$project$Views$PolicyEditor$toListItems(uiMode),
		A2($zwilias$elm_rosetree$Tree$indexedMap, $author$project$Views$PolicyEditor$IndexedRule, policy.ks)).G4;
};
var $author$project$Views$PolicyEditor$view = function (model) {
	var content = function () {
		var _v0 = model.p8;
		if (!_v0) {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$textarea,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('policy-code'),
								$elm$html$Html$Attributes$disabled(model.wQ === 1),
								$elm$html$Html$Events$onInput($author$project$Views$PolicyEditor$UpdateCode)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$Model$Policy$Policy$toJson, 2, model.rX))
							])),
						function () {
						var _v1 = $author$project$Views$PolicyEditor$anyValidationErrors(model);
						if (!_v1.$) {
							return $elm$html$Html$text('');
						} else {
							var errors = _v1.a;
							return A2(
								$elm$html$Html$ul,
								_List_Nil,
								A2(
									$elm$core$List$map,
									function (e) {
										return A2(
											$elm$html$Html$li,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('error-text')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(e)
												]));
									},
									$mgold$elm_nonempty_list$List$Nonempty$toList(errors)));
						}
					}()
					]));
		} else {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Name')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput($author$project$Views$PolicyEditor$UpdateName),
								$elm$html$Html$Attributes$readonly((model.wQ === 1) || (model.wQ === 2)),
								$elm$html$Html$Attributes$value(model.rX.w),
								$elm$html$Html$Attributes$type_('text'),
								$elm$html$Html$Attributes$class('policy-name')
							]),
						_List_Nil),
						A2(
						$author$project$Misc$displayErr,
						function (e) {
							return A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('error-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(e)
									]));
						},
						$author$project$Views$PolicyEditor$firstErrorOrOks(
							_List_fromArray(
								[
									$author$project$Views$PolicyEditor$nameAlreadyTaken(model),
									$author$project$Views$PolicyEditor$nameIsEmpty(model)
								]))),
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Description')
							])),
						A2(
						$elm$html$Html$textarea,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$disabled(model.wQ === 1),
								$elm$html$Html$Events$onInput($author$project$Views$PolicyEditor$UpdateDescription),
								$elm$html$Html$Attributes$rows(5),
								$elm$html$Html$Attributes$value(model.rX.bP)
							]),
						_List_Nil),
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Rules')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('This policy passes if the conditions below evaluate to true.')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('rules')
							]),
						_List_fromArray(
							[
								$author$project$Views$PolicyEditor$viewRules(model)
							]))
					]));
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('policy-editor-wrapper')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Misc$displayIf,
				!model.wQ,
				A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							model.uj ? $elm$html$Html$text('Create Policy') : $elm$html$Html$text('Edit Policy')
						]))),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mode-toggle')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Mode'),
						$author$project$Views$PolicyEditor$viewModeToggle(model.p8)
					])),
				content
			]));
};
var $author$project$Pages$OrgPolicy$mainPolicyView = function (model) {
	var editorModal = function (editor) {
		return {
			Bq: $elm$core$Maybe$Just(
				{
					BE: _List_fromArray(
						['']),
					Dc: model.hN,
					En: $author$project$Pages$OrgPolicy$CancelModal,
					Gv: 'Cancel'
				}),
			BD: 'policy-editor-modal',
			BU: $elm$core$Maybe$Just(
				{
					BE: _List_fromArray(
						['']),
					Dc: function () {
						var _v0 = $author$project$Views$PolicyEditor$anyValidationErrors(editor.ga);
						if (_v0.$ === 1) {
							return true;
						} else {
							return model.hN;
						}
					}(),
					En: $author$project$Pages$OrgPolicy$SaveModal(editor),
					Gv: 'Save'
				}),
			dH: A2(
				$elm$html$Html$map,
				$author$project$Pages$OrgPolicy$PolicyEditorMsg(1),
				$author$project$Views$PolicyEditor$view(editor.ga)),
			l6: $elm$core$Maybe$Nothing
		};
	};
	var confirmDeleteModal = function (policy) {
		return {
			Bq: $elm$core$Maybe$Just(
				{
					BE: _List_fromArray(
						['']),
					Dc: model.hN,
					En: $author$project$Pages$OrgPolicy$CancelModal,
					Gv: 'Cancel'
				}),
			BD: 'confirm-deletion-modal',
			BU: $elm$core$Maybe$Just(
				{
					BE: _List_fromArray(
						['delete-button']),
					Dc: model.hN,
					En: $author$project$Pages$OrgPolicy$ConfirmDeletePolicy(policy),
					Gv: 'Yes, delete the policy'
				}),
			dH: A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Deleting \'' + (policy.w + '\''))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Warning!')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('You are about to permanently delete ' + (policy.w + ' from your organization. This action cannot be undone.'))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Are you sure you want to delete it?')
							]))
					])),
			l6: $elm$core$Maybe$Nothing
		};
	};
	return _List_fromArray(
		[
			A2(
			$author$project$Misc$displayMaybe,
			A2($elm$core$Basics$composeR, editorModal, $author$project$Views$Modal$confirmCancelView),
			model.hC),
			A2(
			$author$project$Misc$displayMaybe,
			A2($elm$core$Basics$composeR, confirmDeleteModal, $author$project$Views$Modal$confirmCancelView),
			model.ls),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('policy-heading')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Organization Policy')
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('secondary-button small'),
							$elm$html$Html$Events$onClick(
							$author$project$Pages$OrgPolicy$EditPolicy(
								$author$project$Model$Policy$Policies$getMain(model.m2)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Edit')
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('editor-wrapper')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Pages$OrgPolicy$PolicyEditorMsg(0),
					$author$project$Views$PolicyEditor$view(model.iv.ga))
				]))
		]);
};
var $author$project$Pages$OrgPolicy$NewPolicy = {$: 2};
var $author$project$Pages$OrgPolicy$DeletePolicy = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$OrgPolicy$policyCard = function (policy) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('policy-card')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h4,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(policy.w)
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(policy.bP)
					])),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('secondary-button small'),
						$elm$html$Html$Events$onClick(
						$author$project$Pages$OrgPolicy$EditPolicy(policy))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Edit')
					])),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('secondary-button small'),
						$elm$html$Html$Events$onClick(
						$author$project$Pages$OrgPolicy$DeletePolicy(policy))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Delete')
					]))
			]));
};
var $author$project$Model$Policy$LetIn$subExprs = function (_v0) {
	var exprs = _v0.lS;
	return $elm$core$Dict$values(exprs);
};
var $author$project$Model$Policy$Policies$subPolicies = $author$project$Model$Policy$LetIn$subExprs;
var $author$project$Pages$OrgPolicy$policiesView = function (model) {
	var policyList = $author$project$Model$Policy$Policies$subPolicies(model.m2);
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('policy-heading')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Policies')
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('primary-button small'),
							$elm$html$Html$Events$onClick($author$project$Pages$OrgPolicy$NewPolicy)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Create Policy')
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('policy-cards')
				]),
			A2($elm$core$List$map, $author$project$Pages$OrgPolicy$policyCard, policyList))
		]);
};
var $author$project$Pages$OrgPolicy$view = F2(
	function (model, _v0) {
		return $author$project$Views$Columns$asHtml(
			A2(
				$author$project$Views$Columns$withColumns,
				_List_fromArray(
					[
						$author$project$Pages$OrgPolicy$mainPolicyView(model),
						$author$project$Pages$OrgPolicy$policiesView(model)
					]),
				A2(
					$author$project$Views$Columns$withColumnAs,
					$elm$html$Html$section,
					A2(
						$author$project$Views$Columns$withAttrs,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('org-policy-page')
							]),
						$author$project$Views$Columns$asColumns($elm$html$Html$main_)))));
	});
var $author$project$Views$Loading$propeller = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('propeller-spinning')
		]),
	_List_fromArray(
		[
			$author$project$Views$Icon$view(
			$author$project$Views$Icon$icon(0))
		]));
var $author$project$Pages$OrgRemediation$ApplyRemediation = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$OrgRemediation$SelectRemediation = function (a) {
	return {$: 4, a: a};
};
var $author$project$Views$ImpactReport$VulnerabilitiesAdded = 2;
var $author$project$Views$ImpactReport$VulnerabilitiesResolved = 1;
var $author$project$Model$BuildPlanner$ImpactReport$cveCounts = function (_v0) {
	var cves = _v0.xQ;
	return A3(
		$elm$core$List$foldr,
		F2(
			function (cve, acc) {
				var pushCVE = $elm$core$List$cons(
					{B9: cve.B9, bP: cve.bP, ck: cve.ck, o: 1});
				var _v1 = cve.L;
				switch (_v1) {
					case 0:
						return _Utils_update(
							acc,
							{
								qc: pushCVE(acc.qc)
							});
					case 1:
						return _Utils_update(
							acc,
							{
								r6: pushCVE(acc.r6)
							});
					default:
						return acc;
				}
			}),
		{qc: _List_Nil, r6: _List_Nil},
		cves);
};
var $author$project$Model$BuildPlanner$ImpactReport$dependencyCounts = function (_v0) {
	var components = _v0.hr;
	return A3(
		$elm$core$List$foldr,
		F2(
			function (ingredient, acc) {
				var _v1 = _Utils_Tuple2(ingredient.xl, ingredient.w9);
				if (!_v1.a.$) {
					if (_v1.b.$ === 1) {
						var _v2 = _v1.b;
						return _Utils_update(
							acc,
							{r5: acc.r5 + 1});
					} else {
						var before = _v1.a.a;
						var after = _v1.b.a;
						return (!_Utils_eq(before.aI, after.aI)) ? _Utils_update(
							acc,
							{qy: acc.qy + 1}) : acc;
					}
				} else {
					if (!_v1.b.$) {
						var _v3 = _v1.a;
						return _Utils_update(
							acc,
							{rC: acc.rC + 1});
					} else {
						var _v4 = _v1.a;
						var _v5 = _v1.b;
						return acc;
					}
				}
			}),
		{qy: 0, rC: 0, r5: 0},
		components);
};
var $author$project$Model$Permissions$orgCanViewBreakingChanges = $author$project$Model$Organization$addOnEnabled('breaking_changes');
var $author$project$Views$ImpactReport$ChangeTab = function (a) {
	return {$: 0, a: a};
};
var $author$project$Views$ImpactReport$tabsView = F4(
	function (cvesResolved, cvesAdded, canViewBreakingChanges, selectedTab) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('section-tabs')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tab'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('selected', !selectedTab)
								])),
							$elm$html$Html$Events$onClick(
							$author$project$Views$ImpactReport$ChangeTab(0))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Dependency Comparison')
						])),
					A2(
					$author$project$Misc$displayIf,
					cvesResolved > 0,
					A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('tab'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('selected', selectedTab === 1)
									])),
								$elm$html$Html$Events$onClick(
								$author$project$Views$ImpactReport$ChangeTab(1))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Vulnerabilities Resolved ('),
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(cvesResolved))
									])),
								$elm$html$Html$text(')')
							]))),
					A2(
					$author$project$Misc$displayIf,
					cvesAdded > 0,
					A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('tab'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('selected', selectedTab === 2)
									])),
								$elm$html$Html$Events$onClick(
								$author$project$Views$ImpactReport$ChangeTab(2))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Vulnerabilities Added ('),
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(cvesAdded))
									])),
								$elm$html$Html$text(')')
							]))),
					A2(
					$author$project$Misc$displayIf,
					canViewBreakingChanges,
					A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('tab'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('selected', selectedTab === 3)
									])),
								$elm$html$Html$Events$onClick(
								$author$project$Views$ImpactReport$ChangeTab(3))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Breaking Changes')
							])))
				]));
	});
var $author$project$Model$VulnerabilitySource$getPrefix = function (source) {
	if (!source) {
		return 'https://osv.dev/vulnerability/';
	} else {
		return 'https://nvd.nist.gov/vuln/detail/';
	}
};
var $author$project$Model$Vulnerability$getURL = function (vuln) {
	return _Utils_ap(
		$author$project$Model$VulnerabilitySource$getPrefix(vuln.o),
		vuln.B9);
};
var $author$project$Views$CVEs$link = function (vuln) {
	return A3(
		$author$project$Views$Link$external,
		$author$project$Model$Vulnerability$getURL(vuln),
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('cve-link')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(vuln.B9)
			]));
};
var $author$project$Views$CVEs$severityDot = function (severity) {
	var severityStr = $author$project$Model$Severity$toString(severity);
	return A2(
		$elm$html$Html$h4,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('severity-dot'),
						$elm$html$Html$Attributes$class('severity-' + severityStr)
					]),
				_List_Nil),
				$elm$html$Html$text(
				$elm_community$string_extra$String$Extra$toTitleCase(severityStr))
			]));
};
var $author$project$Views$ImpactReport$viewCVECard = function (cve) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('resolved-card')
			]),
		_List_fromArray(
			[
				$author$project$Views$CVEs$link(cve),
				$author$project$Views$CVEs$severityDot(cve.ck),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(cve.bP)
					]))
			]));
};
var $author$project$Views$ImpactReport$viewAddedCards = function (cveCounts) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('resolved-cards-section')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('resolved-cards')
					]),
				A2(
					$elm$core$List$map,
					$author$project$Views$ImpactReport$viewCVECard,
					A2(
						$elm$core$List$sortBy,
						function (c) {
							return $author$project$Model$Severity$sortKey(c.ck);
						},
						cveCounts.qc)))
			]));
};
var $author$project$Views$ImpactReport$SelectBreakingChange = function (a) {
	return {$: 1, a: a};
};
var $author$project$Misc$displayListIf = F2(
	function (condition, content) {
		return condition ? content : _List_fromArray(
			[
				$elm$html$Html$text('')
			]);
	});
var $author$project$Components$BreakingChanges$OnMarkdownReceived = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$BreakingChanges$OnStatusUpdate = function (a) {
	return {$: 0, a: a};
};
var $elm$html$Html$Attributes$align = $elm$html$Html$Attributes$stringProperty('align');
var $elm$html$Html$blockquote = _VirtualDom_node('blockquote');
var $elm$html$Html$del = _VirtualDom_node('del');
var $elm$html$Html$em = _VirtualDom_node('em');
var $elm$html$Html$h5 = _VirtualDom_node('h5');
var $elm$html$Html$h6 = _VirtualDom_node('h6');
var $elm$html$Html$ol = _VirtualDom_node('ol');
var $dillonkearns$elm_markdown$Markdown$HtmlRenderer$HtmlRenderer = $elm$core$Basics$identity;
var $dillonkearns$elm_markdown$Markdown$Html$resultOr = F2(
	function (ra, rb) {
		if (ra.$ === 1) {
			var singleError = ra.a;
			if (!rb.$) {
				var okValue = rb.a;
				return $elm$core$Result$Ok(okValue);
			} else {
				var errorsSoFar = rb.a;
				return $elm$core$Result$Err(
					A2($elm$core$List$cons, singleError, errorsSoFar));
			}
		} else {
			var okValue = ra.a;
			return $elm$core$Result$Ok(okValue);
		}
	});
var $dillonkearns$elm_markdown$Markdown$Html$attributesToString = function (attributes) {
	return A2(
		$elm$core$String$join,
		' ',
		A2(
			$elm$core$List$map,
			function (_v0) {
				var name = _v0.w;
				var value = _v0.kH;
				return name + ('=\"' + (value + '\"'));
			},
			attributes));
};
var $dillonkearns$elm_markdown$Markdown$Html$tagToString = F2(
	function (tagName, attributes) {
		return $elm$core$List$isEmpty(attributes) ? ('<' + (tagName + '>')) : ('<' + (tagName + (' ' + ($dillonkearns$elm_markdown$Markdown$Html$attributesToString(attributes) + '>'))));
	});
var $dillonkearns$elm_markdown$Markdown$Html$oneOf = function (decoders) {
	var unwrappedDecoders = A2(
		$elm$core$List$map,
		function (_v4) {
			var rawDecoder = _v4;
			return rawDecoder;
		},
		decoders);
	return function (rawDecoder) {
		return F3(
			function (tagName, attributes, innerBlocks) {
				return A2(
					$elm$core$Result$mapError,
					function (errors) {
						if (!errors.b) {
							return 'Ran into a oneOf with no possibilities!';
						} else {
							if (!errors.b.b) {
								var singleError = errors.a;
								return 'Problem with the given value:\n\n' + (A2($dillonkearns$elm_markdown$Markdown$Html$tagToString, tagName, attributes) + ('\n\n' + (singleError + '\n')));
							} else {
								return 'oneOf failed parsing this value:\n    ' + (A2($dillonkearns$elm_markdown$Markdown$Html$tagToString, tagName, attributes) + ('\n\nParsing failed in the following 2 ways:\n\n\n' + (A2(
									$elm$core$String$join,
									'\n\n',
									A2(
										$elm$core$List$indexedMap,
										F2(
											function (index, error) {
												return '(' + ($elm$core$String$fromInt(index + 1) + (') ' + error));
											}),
										errors)) + '\n')));
							}
						}
					},
					A3(rawDecoder, tagName, attributes, innerBlocks));
			});
	}(
		A3(
			$elm$core$List$foldl,
			F2(
				function (decoder, soFar) {
					return F3(
						function (tagName, attributes, children) {
							return A2(
								$dillonkearns$elm_markdown$Markdown$Html$resultOr,
								A3(decoder, tagName, attributes, children),
								A3(soFar, tagName, attributes, children));
						});
				}),
			F3(
				function (_v0, _v1, _v2) {
					return $elm$core$Result$Err(_List_Nil);
				}),
			unwrappedDecoders));
};
var $elm$html$Html$pre = _VirtualDom_node('pre');
var $elm$html$Html$Attributes$start = function (n) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'start',
		$elm$core$String$fromInt(n));
};
var $dillonkearns$elm_markdown$Markdown$Renderer$defaultHtmlRenderer = {
	sW: $elm$html$Html$blockquote(_List_Nil),
	ta: function (_v0) {
		var body = _v0.sY;
		var language = _v0.aC;
		var classes = function () {
			var _v1 = A2($elm$core$Maybe$map, $elm$core$String$words, language);
			if ((!_v1.$) && _v1.a.b) {
				var _v2 = _v1.a;
				var actualLanguage = _v2.a;
				return _List_fromArray(
					[
						$elm$html$Html$Attributes$class('language-' + actualLanguage)
					]);
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$elm$html$Html$pre,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$code,
					classes,
					_List_fromArray(
						[
							$elm$html$Html$text(body)
						]))
				]));
	},
	tb: function (content) {
		return A2(
			$elm$html$Html$code,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(content)
				]));
	},
	tL: function (children) {
		return A2($elm$html$Html$em, _List_Nil, children);
	},
	t$: A2($elm$html$Html$br, _List_Nil, _List_Nil),
	yu: function (_v3) {
		var level = _v3.y0;
		var children = _v3.aT;
		switch (level) {
			case 0:
				return A2($elm$html$Html$h1, _List_Nil, children);
			case 1:
				return A2($elm$html$Html$h2, _List_Nil, children);
			case 2:
				return A2($elm$html$Html$h3, _List_Nil, children);
			case 3:
				return A2($elm$html$Html$h4, _List_Nil, children);
			case 4:
				return A2($elm$html$Html$h5, _List_Nil, children);
			default:
				return A2($elm$html$Html$h6, _List_Nil, children);
		}
	},
	t2: $dillonkearns$elm_markdown$Markdown$Html$oneOf(_List_Nil),
	t5: function (imageInfo) {
		var _v5 = imageInfo.Gy;
		if (!_v5.$) {
			var title = _v5.a;
			return A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$src(imageInfo.fG),
						$elm$html$Html$Attributes$alt(imageInfo.sS),
						$elm$html$Html$Attributes$title(title)
					]),
				_List_Nil);
		} else {
			return A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$src(imageInfo.fG),
						$elm$html$Html$Attributes$alt(imageInfo.sS)
					]),
				_List_Nil);
		}
	},
	D1: F2(
		function (link, content) {
			var _v6 = link.Gy;
			if (!_v6.$) {
				var title = _v6.a;
				return A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(link.Cg),
							$elm$html$Html$Attributes$title(title)
						]),
					content);
			} else {
				return A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(link.Cg)
						]),
					content);
			}
		}),
	vF: F2(
		function (startingIndex, items) {
			return A2(
				$elm$html$Html$ol,
				function () {
					if (startingIndex === 1) {
						return _List_fromArray(
							[
								$elm$html$Html$Attributes$start(startingIndex)
							]);
					} else {
						return _List_Nil;
					}
				}(),
				A2(
					$elm$core$List$map,
					function (itemBlocks) {
						return A2($elm$html$Html$li, _List_Nil, itemBlocks);
					},
					items));
		}),
	vP: $elm$html$Html$p(_List_Nil),
	wr: function (children) {
		return A2($elm$html$Html$del, _List_Nil, children);
	},
	ws: function (children) {
		return A2($elm$html$Html$strong, _List_Nil, children);
	},
	ww: $elm$html$Html$table(_List_Nil),
	wx: $elm$html$Html$tbody(_List_Nil),
	wy: function (maybeAlignment) {
		var attrs = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$singleton,
				A2(
					$elm$core$Maybe$map,
					$elm$html$Html$Attributes$align,
					A2(
						$elm$core$Maybe$map,
						function (alignment) {
							switch (alignment) {
								case 0:
									return 'left';
								case 2:
									return 'center';
								default:
									return 'right';
							}
						},
						maybeAlignment))));
		return $elm$html$Html$td(attrs);
	},
	wz: $elm$html$Html$thead(_List_Nil),
	wA: function (maybeAlignment) {
		var attrs = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$singleton,
				A2(
					$elm$core$Maybe$map,
					$elm$html$Html$Attributes$align,
					A2(
						$elm$core$Maybe$map,
						function (alignment) {
							switch (alignment) {
								case 0:
									return 'left';
								case 2:
									return 'center';
								default:
									return 'right';
							}
						},
						maybeAlignment))));
		return $elm$html$Html$th(attrs);
	},
	sz: $elm$html$Html$tr(_List_Nil),
	Gv: $elm$html$Html$text,
	wE: A2($elm$html$Html$hr, _List_Nil, _List_Nil),
	wR: function (items) {
		return A2(
			$elm$html$Html$ul,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (item) {
					var task = item.a;
					var children = item.b;
					var checkbox = function () {
						switch (task) {
							case 0:
								return $elm$html$Html$text('');
							case 1:
								return A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$disabled(true),
											$elm$html$Html$Attributes$checked(false),
											$elm$html$Html$Attributes$type_('checkbox')
										]),
									_List_Nil);
							default:
								return A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$disabled(true),
											$elm$html$Html$Attributes$checked(true),
											$elm$html$Html$Attributes$type_('checkbox')
										]),
									_List_Nil);
						}
					}();
					return A2(
						$elm$html$Html$li,
						_List_Nil,
						A2($elm$core$List$cons, checkbox, children));
				},
				items));
	}
};
var $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine = {$: 10};
var $dillonkearns$elm_markdown$Markdown$Block$BlockQuote = function (a) {
	return {$: 3, a: a};
};
var $dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote = function (a) {
	return {$: 11, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Cdata = function (a) {
	return {$: 4, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$CodeBlock = function (a) {
	return {$: 7, a: a};
};
var $dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock = function (a) {
	return {$: 5, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$CodeSpan = function (a) {
	return {$: 6, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$CompletedTask = 2;
var $dillonkearns$elm_markdown$Markdown$Block$Emphasis = function (a) {
	return {$: 3, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Inline$Emphasis = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Parser$EmptyBlock = {$: 0};
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$HardLineBreak = {$: 8};
var $dillonkearns$elm_markdown$Markdown$Block$Heading = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$Heading = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$Html = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$HtmlBlock = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$HtmlComment = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Block$HtmlElement = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Block$HtmlInline = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Image = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Block$IncompleteTask = 1;
var $dillonkearns$elm_markdown$Markdown$RawBlock$IndentedCodeBlock = function (a) {
	return {$: 6, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Parser$InlineProblem = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Link = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Block$ListItem = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Block$NoTask = 0;
var $dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$OrderedList = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock = F6(
	function (a, b, c, d, e, f) {
		return {$: 4, a: a, b: b, c: c, d: d, e: e, f: f};
	});
var $dillonkearns$elm_markdown$Markdown$Block$Paragraph = function (a) {
	return {$: 5, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$Markdown$RawBlock$ParsedBlockQuote = function (a) {
	return {$: 12, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$ProcessingInstruction = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Strikethrough = function (a) {
	return {$: 5, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Strong = function (a) {
	return {$: 4, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Table = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$Table = function (a) {
	return {$: 8, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Table$Table = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Table$TableDelimiterRow = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Block$Text = function (a) {
	return {$: 7, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$ThematicBreak = {$: 8};
var $dillonkearns$elm_markdown$Markdown$RawBlock$ThematicBreak = {$: 7};
var $dillonkearns$elm_markdown$Markdown$Block$UnorderedList = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock = F4(
	function (a, b, c, d) {
		return {$: 3, a: a, b: b, c: c, d: d};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$UnparsedInlines = $elm$core$Basics$identity;
var $dillonkearns$elm_markdown$Markdown$Parser$addReference = F2(
	function (state, linkRef) {
		return {
			x: A2($elm$core$List$cons, linkRef, state.x),
			O: state.O
		};
	});
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $dillonkearns$elm_markdown$Whitespace$isSpaceOrTab = function (_char) {
	switch (_char) {
		case ' ':
			return true;
		case '\t':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Parser$Token$carriageReturn = A2(
	$elm$parser$Parser$Advanced$Token,
	'\u000D',
	$elm$parser$Parser$Expecting('a carriage return'));
var $dillonkearns$elm_markdown$Parser$Token$newline = A2(
	$elm$parser$Parser$Advanced$Token,
	'\n',
	$elm$parser$Parser$Expecting('a newline'));
var $dillonkearns$elm_markdown$Whitespace$lineEnd = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			$elm$parser$Parser$Advanced$token($dillonkearns$elm_markdown$Parser$Token$newline),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$token($dillonkearns$elm_markdown$Parser$Token$carriageReturn),
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$Advanced$token($dillonkearns$elm_markdown$Parser$Token$newline),
						$elm$parser$Parser$Advanced$succeed(0)
					])))
		]));
var $dillonkearns$elm_markdown$Markdown$Parser$blankLine = A2(
	$elm$parser$Parser$Advanced$map,
	function (_v0) {
		return $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine;
	},
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$backtrackable(
			$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)),
		$dillonkearns$elm_markdown$Whitespace$lineEnd));
var $dillonkearns$elm_markdown$Parser$Token$space = A2(
	$elm$parser$Parser$Advanced$Token,
	' ',
	$elm$parser$Parser$Expecting('a space'));
var $dillonkearns$elm_markdown$Markdown$Parser$blockQuoteStarts = _List_fromArray(
	[
		$elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			'>',
			$elm$parser$Parser$Expecting('>'))),
		A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$backtrackable(
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$space)),
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$Advanced$symbol(
					A2(
						$elm$parser$Parser$Advanced$Token,
						'>',
						$elm$parser$Parser$Expecting(' >'))),
					$elm$parser$Parser$Advanced$symbol(
					A2(
						$elm$parser$Parser$Advanced$Token,
						' >',
						$elm$parser$Parser$Expecting('  >'))),
					$elm$parser$Parser$Advanced$symbol(
					A2(
						$elm$parser$Parser$Advanced$Token,
						'  >',
						$elm$parser$Parser$Expecting('   >')))
				])))
	]);
var $dillonkearns$elm_markdown$Whitespace$isLineEnd = function (_char) {
	switch (_char) {
		case '\n':
			return true;
		case '\u000D':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd = $elm$parser$Parser$Advanced$chompWhile(
	A2($elm$core$Basics$composeL, $elm$core$Basics$not, $dillonkearns$elm_markdown$Whitespace$isLineEnd));
var $dillonkearns$elm_markdown$Helpers$endOfFile = $elm$parser$Parser$Advanced$end(
	$elm$parser$Parser$Expecting('the end of the input'));
var $dillonkearns$elm_markdown$Helpers$lineEndOrEnd = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[$dillonkearns$elm_markdown$Whitespace$lineEnd, $dillonkearns$elm_markdown$Helpers$endOfFile]));
var $dillonkearns$elm_markdown$Markdown$Parser$blockQuote = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote),
			$elm$parser$Parser$Advanced$oneOf($dillonkearns$elm_markdown$Markdown$Parser$blockQuoteStarts)),
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$space),
					$elm$parser$Parser$Advanced$succeed(0)
				]))),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
		$dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $dillonkearns$elm_markdown$Markdown$Parser$problemToString = function (problem) {
	switch (problem.$) {
		case 0:
			var string = problem.a;
			return 'Expecting ' + string;
		case 1:
			return 'Expecting int';
		case 2:
			return 'Expecting hex';
		case 3:
			return 'Expecting octal';
		case 4:
			return 'Expecting binary';
		case 5:
			return 'Expecting float';
		case 6:
			return 'Expecting number';
		case 7:
			return 'Expecting variable';
		case 8:
			var string = problem.a;
			return 'Expecting symbol ' + string;
		case 9:
			var string = problem.a;
			return 'Expecting keyword ' + string;
		case 10:
			return 'Expecting keyword end';
		case 11:
			return 'Unexpected char';
		case 12:
			var problemDescription = problem.a;
			return problemDescription;
		default:
			return 'Bad repeat';
	}
};
var $dillonkearns$elm_markdown$Markdown$Parser$deadEndToString = function (deadEnd) {
	return 'Problem at row ' + ($elm$core$String$fromInt(deadEnd.hP) + ('\n' + $dillonkearns$elm_markdown$Markdown$Parser$problemToString(deadEnd.Fp)));
};
var $dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString = function (deadEnds) {
	return A2(
		$elm$core$String$join,
		'\n',
		A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$deadEndToString, deadEnds));
};
var $dillonkearns$elm_markdown$Markdown$Parser$endWithOpenBlockOrParagraph = function (block) {
	endWithOpenBlockOrParagraph:
	while (true) {
		switch (block.$) {
			case 1:
				var str = block.a;
				return !A2($elm$core$String$endsWith, str, '\n');
			case 12:
				var blocks = block.a;
				if (blocks.b) {
					var last = blocks.a;
					var $temp$block = last;
					block = $temp$block;
					continue endWithOpenBlockOrParagraph;
				} else {
					return false;
				}
			case 4:
				var blockslist = block.e;
				if (blockslist.b) {
					var blocks = blockslist.a;
					if (blocks.b) {
						var last = blocks.a;
						var $temp$block = last;
						block = $temp$block;
						continue endWithOpenBlockOrParagraph;
					} else {
						return false;
					}
				} else {
					return false;
				}
			case 0:
				return true;
			default:
				return false;
		}
	}
};
var $dillonkearns$elm_markdown$HtmlParser$Cdata = function (a) {
	return {$: 3, a: a};
};
var $dillonkearns$elm_markdown$HtmlParser$Element = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$HtmlParser$Text = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$HtmlParser$expectTagNameCharacter = $elm$parser$Parser$Expecting('at least 1 tag name character');
var $dillonkearns$elm_markdown$HtmlParser$tagNameCharacter = function (c) {
	switch (c) {
		case ' ':
			return false;
		case '\u000D':
			return false;
		case '\n':
			return false;
		case '\t':
			return false;
		case '/':
			return false;
		case '<':
			return false;
		case '>':
			return false;
		case '\"':
			return false;
		case '\'':
			return false;
		case '=':
			return false;
		default:
			return true;
	}
};
var $dillonkearns$elm_markdown$HtmlParser$tagName = A2(
	$elm$parser$Parser$Advanced$mapChompedString,
	F2(
		function (name, _v0) {
			return $elm$core$String$toLower(name);
		}),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2($elm$parser$Parser$Advanced$chompIf, $dillonkearns$elm_markdown$HtmlParser$tagNameCharacter, $dillonkearns$elm_markdown$HtmlParser$expectTagNameCharacter),
		$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$HtmlParser$tagNameCharacter)));
var $dillonkearns$elm_markdown$HtmlParser$attributeName = $dillonkearns$elm_markdown$HtmlParser$tagName;
var $dillonkearns$elm_markdown$HtmlParser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$token(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $dillonkearns$elm_markdown$HtmlParser$entities = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('amp', '&'),
			_Utils_Tuple2('lt', '<'),
			_Utils_Tuple2('gt', '>'),
			_Utils_Tuple2('apos', '\''),
			_Utils_Tuple2('quot', '\"')
		]));
var $dillonkearns$elm_markdown$HtmlParser$decodeEscape = function (s) {
	return A2($elm$core$String$startsWith, '#x', s) ? A2(
		$elm$core$Result$mapError,
		$elm$parser$Parser$Problem,
		A2(
			$elm$core$Result$map,
			$elm$core$Char$fromCode,
			$rtfeldman$elm_hex$Hex$fromString(
				A2($elm$core$String$dropLeft, 2, s)))) : (A2($elm$core$String$startsWith, '#', s) ? A2(
		$elm$core$Result$fromMaybe,
		$elm$parser$Parser$Problem('Invalid escaped character: ' + s),
		A2(
			$elm$core$Maybe$map,
			$elm$core$Char$fromCode,
			$elm$core$String$toInt(
				A2($elm$core$String$dropLeft, 1, s)))) : A2(
		$elm$core$Result$fromMaybe,
		$elm$parser$Parser$Problem('No entity named \"&' + (s + ';\" found.')),
		A2($elm$core$Dict$get, s, $dillonkearns$elm_markdown$HtmlParser$entities)));
};
var $dillonkearns$elm_markdown$HtmlParser$escapedChar = function (end_) {
	var process = function (entityStr) {
		var _v0 = $dillonkearns$elm_markdown$HtmlParser$decodeEscape(entityStr);
		if (!_v0.$) {
			var c = _v0.a;
			return $elm$parser$Parser$Advanced$succeed(c);
		} else {
			var e = _v0.a;
			return $elm$parser$Parser$Advanced$problem(e);
		}
	};
	var isEntityChar = function (c) {
		return (!_Utils_eq(c, end_)) && (c !== ';');
	};
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
			$dillonkearns$elm_markdown$HtmlParser$symbol('&')),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$andThen,
				process,
				$elm$parser$Parser$Advanced$getChompedString(
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						A2(
							$elm$parser$Parser$Advanced$chompIf,
							isEntityChar,
							$elm$parser$Parser$Expecting('an entity character')),
						$elm$parser$Parser$Advanced$chompWhile(isEntityChar)))),
			$dillonkearns$elm_markdown$HtmlParser$symbol(';')));
};
var $dillonkearns$elm_markdown$HtmlParser$textStringStep = F3(
	function (closingChar, predicate, accum) {
		return A2(
			$elm$parser$Parser$Advanced$andThen,
			function (soFar) {
				return $elm$parser$Parser$Advanced$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$parser$Parser$Advanced$map,
							function (escaped) {
								return $elm$parser$Parser$Advanced$Loop(
									_Utils_ap(
										accum,
										_Utils_ap(
											soFar,
											$elm$core$String$fromChar(escaped))));
							},
							$dillonkearns$elm_markdown$HtmlParser$escapedChar(closingChar)),
							$elm$parser$Parser$Advanced$succeed(
							$elm$parser$Parser$Advanced$Done(
								_Utils_ap(accum, soFar)))
						]));
			},
			$elm$parser$Parser$Advanced$getChompedString(
				$elm$parser$Parser$Advanced$chompWhile(predicate)));
	});
var $dillonkearns$elm_markdown$HtmlParser$textString = function (closingChar) {
	var predicate = function (c) {
		return (!_Utils_eq(c, closingChar)) && (c !== '&');
	};
	return A2(
		$elm$parser$Parser$Advanced$loop,
		'',
		A2($dillonkearns$elm_markdown$HtmlParser$textStringStep, closingChar, predicate));
};
var $dillonkearns$elm_markdown$HtmlParser$attributeValue = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
				$dillonkearns$elm_markdown$HtmlParser$symbol('\"')),
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$dillonkearns$elm_markdown$HtmlParser$textString('\"'),
				$dillonkearns$elm_markdown$HtmlParser$symbol('\"'))),
			A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
				$dillonkearns$elm_markdown$HtmlParser$symbol('\'')),
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$dillonkearns$elm_markdown$HtmlParser$textString('\''),
				$dillonkearns$elm_markdown$HtmlParser$symbol('\'')))
		]));
var $dillonkearns$elm_markdown$HtmlParser$keepOldest = F2(
	function (_new, mValue) {
		if (!mValue.$) {
			var v = mValue.a;
			return $elm$core$Maybe$Just(v);
		} else {
			return $elm$core$Maybe$Just(_new);
		}
	});
var $dillonkearns$elm_markdown$HtmlParser$isWhitespace = function (c) {
	switch (c) {
		case ' ':
			return true;
		case '\u000D':
			return true;
		case '\n':
			return true;
		case '\t':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$HtmlParser$whiteSpace = $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$HtmlParser$isWhitespace);
var $dillonkearns$elm_markdown$HtmlParser$attributesStep = function (attrs) {
	var process = F2(
		function (name, value) {
			return $elm$parser$Parser$Advanced$Loop(
				A3(
					$elm$core$Dict$update,
					$elm$core$String$toLower(name),
					$dillonkearns$elm_markdown$HtmlParser$keepOldest(value),
					attrs));
		});
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$keeper,
					$elm$parser$Parser$Advanced$succeed(process),
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							A2($elm$parser$Parser$Advanced$ignorer, $dillonkearns$elm_markdown$HtmlParser$attributeName, $dillonkearns$elm_markdown$HtmlParser$whiteSpace),
							$dillonkearns$elm_markdown$HtmlParser$symbol('=')),
						$dillonkearns$elm_markdown$HtmlParser$whiteSpace)),
				A2($elm$parser$Parser$Advanced$ignorer, $dillonkearns$elm_markdown$HtmlParser$attributeValue, $dillonkearns$elm_markdown$HtmlParser$whiteSpace)),
				$elm$parser$Parser$Advanced$succeed(
				$elm$parser$Parser$Advanced$Done(attrs))
			]));
};
var $dillonkearns$elm_markdown$HtmlParser$attributes = A2(
	$elm$parser$Parser$Advanced$map,
	A2(
		$elm$core$Dict$foldl,
		F3(
			function (key, value, accum) {
				return A2(
					$elm$core$List$cons,
					{w: key, kH: value},
					accum);
			}),
		_List_Nil),
	A2($elm$parser$Parser$Advanced$loop, $elm$core$Dict$empty, $dillonkearns$elm_markdown$HtmlParser$attributesStep));
var $elm$parser$Parser$Advanced$chompUntilEndOr = function (str) {
	return function (s) {
		var _v0 = A5(_Parser_findSubString, str, s.uR, s.hP, s.xG, s.fG);
		var newOffset = _v0.a;
		var newRow = _v0.b;
		var newCol = _v0.c;
		var adjustedOffset = (newOffset < 0) ? $elm$core$String$length(s.fG) : newOffset;
		return A3(
			$elm$parser$Parser$Advanced$Good,
			_Utils_cmp(s.uR, adjustedOffset) < 0,
			0,
			{xG: newCol, bL: s.bL, cy: s.cy, uR: adjustedOffset, hP: newRow, fG: s.fG});
	};
};
var $dillonkearns$elm_markdown$HtmlParser$cdata = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
		$dillonkearns$elm_markdown$HtmlParser$symbol('<![CDATA[')),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$chompUntilEndOr(']]>')),
		$dillonkearns$elm_markdown$HtmlParser$symbol(']]>')));
var $dillonkearns$elm_markdown$HtmlParser$childrenStep = F2(
	function (options, accum) {
		return A2(
			$elm$parser$Parser$Advanced$map,
			function (f) {
				return f(accum);
			},
			$elm$parser$Parser$Advanced$oneOf(options));
	});
var $dillonkearns$elm_markdown$HtmlParser$fail = function (str) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(str));
};
var $dillonkearns$elm_markdown$HtmlParser$closingTag = function (startTagName) {
	var closingTagName = A2(
		$elm$parser$Parser$Advanced$andThen,
		function (endTagName) {
			return _Utils_eq(startTagName, endTagName) ? $elm$parser$Parser$Advanced$succeed(0) : $dillonkearns$elm_markdown$HtmlParser$fail('tag name mismatch: ' + (startTagName + (' and ' + endTagName)));
		},
		$dillonkearns$elm_markdown$HtmlParser$tagName);
	return A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$dillonkearns$elm_markdown$HtmlParser$symbol('</'),
					$dillonkearns$elm_markdown$HtmlParser$whiteSpace),
				closingTagName),
			$dillonkearns$elm_markdown$HtmlParser$whiteSpace),
		$dillonkearns$elm_markdown$HtmlParser$symbol('>'));
};
var $dillonkearns$elm_markdown$HtmlParser$Comment = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_markdown$HtmlParser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $dillonkearns$elm_markdown$HtmlParser$comment = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$HtmlParser$Comment),
		$elm$parser$Parser$Advanced$token(
			$dillonkearns$elm_markdown$HtmlParser$toToken('<!--'))),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$chompUntilEndOr('-->')),
		$elm$parser$Parser$Advanced$token(
			$dillonkearns$elm_markdown$HtmlParser$toToken('-->'))));
var $dillonkearns$elm_markdown$HtmlParser$Declaration = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $dillonkearns$elm_markdown$HtmlParser$expectUppercaseCharacter = $elm$parser$Parser$Expecting('at least 1 uppercase character');
var $dillonkearns$elm_markdown$HtmlParser$allUppercase = $elm$parser$Parser$Advanced$getChompedString(
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2($elm$parser$Parser$Advanced$chompIf, $elm$core$Char$isUpper, $dillonkearns$elm_markdown$HtmlParser$expectUppercaseCharacter),
		$elm$parser$Parser$Advanced$chompWhile($elm$core$Char$isUpper)));
var $dillonkearns$elm_markdown$HtmlParser$oneOrMoreWhiteSpace = A2(
	$elm$parser$Parser$Advanced$ignorer,
	A2(
		$elm$parser$Parser$Advanced$chompIf,
		$dillonkearns$elm_markdown$HtmlParser$isWhitespace,
		$elm$parser$Parser$Expecting('at least one whitespace')),
	$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$HtmlParser$isWhitespace));
var $dillonkearns$elm_markdown$HtmlParser$docType = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$HtmlParser$Declaration),
			$dillonkearns$elm_markdown$HtmlParser$symbol('<!')),
		A2($elm$parser$Parser$Advanced$ignorer, $dillonkearns$elm_markdown$HtmlParser$allUppercase, $dillonkearns$elm_markdown$HtmlParser$oneOrMoreWhiteSpace)),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$chompUntilEndOr('>')),
		$dillonkearns$elm_markdown$HtmlParser$symbol('>')));
var $dillonkearns$elm_markdown$HtmlParser$ProcessingInstruction = function (a) {
	return {$: 4, a: a};
};
var $dillonkearns$elm_markdown$HtmlParser$processingInstruction = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$HtmlParser$ProcessingInstruction),
		$dillonkearns$elm_markdown$HtmlParser$symbol('<?')),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$chompUntilEndOr('?>')),
		$dillonkearns$elm_markdown$HtmlParser$symbol('?>')));
var $dillonkearns$elm_markdown$HtmlParser$isNotTextNodeIgnoreChar = function (c) {
	switch (c) {
		case '<':
			return false;
		case '&':
			return false;
		default:
			return true;
	}
};
var $dillonkearns$elm_markdown$HtmlParser$textNodeStringStepOptions = _List_fromArray(
	[
		A2(
		$elm$parser$Parser$Advanced$map,
		function (_v0) {
			return $elm$parser$Parser$Advanced$Loop(0);
		},
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$chompIf,
				$dillonkearns$elm_markdown$HtmlParser$isNotTextNodeIgnoreChar,
				$elm$parser$Parser$Expecting('is not & or <')),
			$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$HtmlParser$isNotTextNodeIgnoreChar))),
		A2(
		$elm$parser$Parser$Advanced$map,
		function (_v1) {
			return $elm$parser$Parser$Advanced$Loop(0);
		},
		$dillonkearns$elm_markdown$HtmlParser$escapedChar('<')),
		$elm$parser$Parser$Advanced$succeed(
		$elm$parser$Parser$Advanced$Done(0))
	]);
var $dillonkearns$elm_markdown$HtmlParser$textNodeStringStep = function (_v0) {
	return $elm$parser$Parser$Advanced$oneOf($dillonkearns$elm_markdown$HtmlParser$textNodeStringStepOptions);
};
var $dillonkearns$elm_markdown$HtmlParser$textNodeString = $elm$parser$Parser$Advanced$getChompedString(
	A2($elm$parser$Parser$Advanced$loop, 0, $dillonkearns$elm_markdown$HtmlParser$textNodeStringStep));
var $dillonkearns$elm_markdown$HtmlParser$children = function (startTagName) {
	return A2(
		$elm$parser$Parser$Advanced$loop,
		_List_Nil,
		$dillonkearns$elm_markdown$HtmlParser$childrenStep(
			$dillonkearns$elm_markdown$HtmlParser$childrenStepOptions(startTagName)));
};
var $dillonkearns$elm_markdown$HtmlParser$childrenStepOptions = function (startTagName) {
	return _List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$map,
			F2(
				function (_v1, accum) {
					return $elm$parser$Parser$Advanced$Done(
						$elm$core$List$reverse(accum));
				}),
			$dillonkearns$elm_markdown$HtmlParser$closingTag(startTagName)),
			A2(
			$elm$parser$Parser$Advanced$andThen,
			function (text) {
				return $elm$core$String$isEmpty(text) ? A2(
					$elm$parser$Parser$Advanced$map,
					F2(
						function (_v2, accum) {
							return $elm$parser$Parser$Advanced$Done(
								$elm$core$List$reverse(accum));
						}),
					$dillonkearns$elm_markdown$HtmlParser$closingTag(startTagName)) : $elm$parser$Parser$Advanced$succeed(
					function (accum) {
						return $elm$parser$Parser$Advanced$Loop(
							A2(
								$elm$core$List$cons,
								$dillonkearns$elm_markdown$HtmlParser$Text(text),
								accum));
					});
			},
			$dillonkearns$elm_markdown$HtmlParser$textNodeString),
			A2(
			$elm$parser$Parser$Advanced$map,
			F2(
				function (_new, accum) {
					return $elm$parser$Parser$Advanced$Loop(
						A2($elm$core$List$cons, _new, accum));
				}),
			$dillonkearns$elm_markdown$HtmlParser$cyclic$html())
		]);
};
var $dillonkearns$elm_markdown$HtmlParser$elementContinuation = function (startTagName) {
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed(
					$dillonkearns$elm_markdown$HtmlParser$Element(startTagName)),
				$dillonkearns$elm_markdown$HtmlParser$whiteSpace),
			A2($elm$parser$Parser$Advanced$ignorer, $dillonkearns$elm_markdown$HtmlParser$attributes, $dillonkearns$elm_markdown$HtmlParser$whiteSpace)),
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$Advanced$map,
					function (_v0) {
						return _List_Nil;
					},
					$dillonkearns$elm_markdown$HtmlParser$symbol('/>')),
					A2(
					$elm$parser$Parser$Advanced$keeper,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
						$dillonkearns$elm_markdown$HtmlParser$symbol('>')),
					$dillonkearns$elm_markdown$HtmlParser$children(startTagName))
				])));
};
function $dillonkearns$elm_markdown$HtmlParser$cyclic$html() {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2($elm$parser$Parser$Advanced$map, $dillonkearns$elm_markdown$HtmlParser$Cdata, $dillonkearns$elm_markdown$HtmlParser$cdata),
				$dillonkearns$elm_markdown$HtmlParser$processingInstruction,
				$dillonkearns$elm_markdown$HtmlParser$comment,
				$dillonkearns$elm_markdown$HtmlParser$docType,
				$dillonkearns$elm_markdown$HtmlParser$cyclic$element()
			]));
}
function $dillonkearns$elm_markdown$HtmlParser$cyclic$element() {
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
			$dillonkearns$elm_markdown$HtmlParser$symbol('<')),
		A2($elm$parser$Parser$Advanced$andThen, $dillonkearns$elm_markdown$HtmlParser$elementContinuation, $dillonkearns$elm_markdown$HtmlParser$tagName));
}
var $dillonkearns$elm_markdown$HtmlParser$html = $dillonkearns$elm_markdown$HtmlParser$cyclic$html();
$dillonkearns$elm_markdown$HtmlParser$cyclic$html = function () {
	return $dillonkearns$elm_markdown$HtmlParser$html;
};
var $dillonkearns$elm_markdown$HtmlParser$element = $dillonkearns$elm_markdown$HtmlParser$cyclic$element();
$dillonkearns$elm_markdown$HtmlParser$cyclic$element = function () {
	return $dillonkearns$elm_markdown$HtmlParser$element;
};
var $dillonkearns$elm_markdown$Parser$Token$tab = A2(
	$elm$parser$Parser$Advanced$Token,
	'\t',
	$elm$parser$Parser$Expecting('a tab'));
var $dillonkearns$elm_markdown$Markdown$Parser$exactlyFourSpaces = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$tab),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$backtrackable(
				$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$space)),
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$Advanced$symbol(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'   ',
							$elm$parser$Parser$ExpectingSymbol('Indentation'))),
						$elm$parser$Parser$Advanced$symbol(
						A2(
							$elm$parser$Parser$Advanced$Token,
							' \t',
							$elm$parser$Parser$ExpectingSymbol('Indentation'))),
						$elm$parser$Parser$Advanced$symbol(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'  \t',
							$elm$parser$Parser$ExpectingSymbol('Indentation')))
					])))
		]));
var $dillonkearns$elm_markdown$Markdown$Parser$indentedCodeBlock = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$IndentedCodeBlock),
		$dillonkearns$elm_markdown$Markdown$Parser$exactlyFourSpaces),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
		$dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $dillonkearns$elm_markdown$Markdown$Helpers$isEven = function (_int) {
	return !A2($elm$core$Basics$modBy, 2, _int);
};
var $dillonkearns$elm_markdown$Markdown$Block$Loose = 0;
var $dillonkearns$elm_markdown$Markdown$Block$Tight = 1;
var $dillonkearns$elm_markdown$Markdown$Parser$isTightBoolToListDisplay = function (isTight) {
	return isTight ? 1 : 0;
};
var $dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith = F3(
	function (joinWith, string1, string2) {
		var _v0 = _Utils_Tuple2(string1, string2);
		if (_v0.a === '') {
			return string2;
		} else {
			if (_v0.b === '') {
				return string1;
			} else {
				return _Utils_ap(
					string1,
					_Utils_ap(joinWith, string2));
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll = F2(
	function (string1, string2) {
		return string1 + ('\n' + string2);
	});
var $dillonkearns$elm_markdown$Markdown$Parser$innerParagraphParser = A2(
	$elm$parser$Parser$Advanced$mapChompedString,
	F2(
		function (rawLine, _v0) {
			return $dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(rawLine);
		}),
	$dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd);
var $dillonkearns$elm_markdown$Markdown$Parser$openBlockOrParagraphParser = A2($elm$parser$Parser$Advanced$ignorer, $dillonkearns$elm_markdown$Markdown$Parser$innerParagraphParser, $dillonkearns$elm_markdown$Helpers$lineEndOrEnd);
var $dillonkearns$elm_markdown$Markdown$OrderedList$ListItem = F4(
	function (order, intended, marker, body) {
		return {sY: body, C_: intended, Eb: marker, vD: order};
	});
var $elm$parser$Parser$Advanced$getCol = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.xG, s);
};
var $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListEmptyItemParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	$elm$parser$Parser$Advanced$succeed(
		function (bodyStartPos) {
			return _Utils_Tuple2(bodyStartPos, '');
		}),
	A2($elm$parser$Parser$Advanced$ignorer, $elm$parser$Parser$Advanced$getCol, $dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore = function (condition) {
	return A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2(
			$elm$parser$Parser$Advanced$chompIf,
			condition,
			$elm$parser$Parser$Problem('Expected one or more character')),
		$elm$parser$Parser$Advanced$chompWhile(condition));
};
var $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListItemBodyParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(
				F2(
					function (bodyStartPos, item) {
						return _Utils_Tuple2(bodyStartPos, item);
					})),
			$dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)),
		$elm$parser$Parser$Advanced$getCol),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
		$dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $dillonkearns$elm_markdown$Markdown$OrderedList$Dot = 0;
var $dillonkearns$elm_markdown$Markdown$OrderedList$Paren = 1;
var $dillonkearns$elm_markdown$Parser$Token$closingParen = A2(
	$elm$parser$Parser$Advanced$Token,
	')',
	$elm$parser$Parser$Expecting('a `)`'));
var $dillonkearns$elm_markdown$Parser$Token$dot = A2(
	$elm$parser$Parser$Advanced$Token,
	'.',
	$elm$parser$Parser$Expecting('a `.`'));
var $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListMarkerParser = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(0),
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$dot)),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(1),
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$closingParen))
		]));
var $dillonkearns$elm_markdown$Parser$Extra$positiveInteger = A2(
	$elm$parser$Parser$Advanced$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	$dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore($elm$core$Char$isDigit));
var $dillonkearns$elm_markdown$Markdown$OrderedList$positiveIntegerMaxOf9Digits = A2(
	$elm$parser$Parser$Advanced$andThen,
	function (parsed) {
		return (parsed <= 999999999) ? $elm$parser$Parser$Advanced$succeed(parsed) : $elm$parser$Parser$Advanced$problem(
			$elm$parser$Parser$Problem('Starting numbers must be nine digits or less.'));
	},
	$dillonkearns$elm_markdown$Parser$Extra$positiveInteger);
var $dillonkearns$elm_markdown$Whitespace$space = $elm$parser$Parser$Advanced$token($dillonkearns$elm_markdown$Parser$Token$space);
var $dillonkearns$elm_markdown$Parser$Extra$upTo = F2(
	function (n, parser) {
		var _v0 = A2($elm$core$List$repeat, n, parser);
		if (!_v0.b) {
			return $elm$parser$Parser$Advanced$succeed(0);
		} else {
			var firstParser = _v0.a;
			var remainingParsers = _v0.b;
			return A3(
				$elm$core$List$foldl,
				F2(
					function (p, parsers) {
						return $elm$parser$Parser$Advanced$oneOf(
							_List_fromArray(
								[
									A2($elm$parser$Parser$Advanced$ignorer, p, parsers),
									$elm$parser$Parser$Advanced$succeed(0)
								]));
					}),
				$elm$parser$Parser$Advanced$oneOf(
					_List_fromArray(
						[
							firstParser,
							$elm$parser$Parser$Advanced$succeed(0)
						])),
				remainingParsers);
		}
	});
var $dillonkearns$elm_markdown$Markdown$OrderedList$validateStartsWith1 = function (parsed) {
	if (parsed === 1) {
		return $elm$parser$Parser$Advanced$succeed(parsed);
	} else {
		return $elm$parser$Parser$Advanced$problem(
			$elm$parser$Parser$Problem('Lists inside a paragraph or after a paragraph without a blank line must start with 1'));
	}
};
var $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListOrderParser = function (previousWasBody) {
	return previousWasBody ? A2(
		$elm$parser$Parser$Advanced$andThen,
		$dillonkearns$elm_markdown$Markdown$OrderedList$validateStartsWith1,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
				A2($dillonkearns$elm_markdown$Parser$Extra$upTo, 3, $dillonkearns$elm_markdown$Whitespace$space)),
			$dillonkearns$elm_markdown$Markdown$OrderedList$positiveIntegerMaxOf9Digits)) : A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
			A2($dillonkearns$elm_markdown$Parser$Extra$upTo, 3, $dillonkearns$elm_markdown$Whitespace$space)),
		$dillonkearns$elm_markdown$Markdown$OrderedList$positiveIntegerMaxOf9Digits);
};
var $dillonkearns$elm_markdown$Markdown$OrderedList$parser = function (previousWasBody) {
	var parseSubsequentItem = F5(
		function (start, order, marker, mid, _v0) {
			var end = _v0.a;
			var body = _v0.b;
			return ((end - mid) <= 4) ? A4($dillonkearns$elm_markdown$Markdown$OrderedList$ListItem, order, end - start, marker, body) : A4(
				$dillonkearns$elm_markdown$Markdown$OrderedList$ListItem,
				order,
				(mid - start) + 1,
				marker,
				_Utils_ap(
					A2($elm$core$String$repeat, (end - mid) - 1, ' '),
					body));
		});
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$keeper,
					A2(
						$elm$parser$Parser$Advanced$keeper,
						$elm$parser$Parser$Advanced$succeed(parseSubsequentItem),
						$elm$parser$Parser$Advanced$getCol),
					$elm$parser$Parser$Advanced$backtrackable(
						$dillonkearns$elm_markdown$Markdown$OrderedList$orderedListOrderParser(previousWasBody))),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$OrderedList$orderedListMarkerParser)),
			$elm$parser$Parser$Advanced$getCol),
		previousWasBody ? $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListItemBodyParser : $elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[$dillonkearns$elm_markdown$Markdown$OrderedList$orderedListEmptyItemParser, $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListItemBodyParser])));
};
var $dillonkearns$elm_markdown$Markdown$Parser$orderedListBlock = function (previousWasBody) {
	return A2(
		$elm$parser$Parser$Advanced$map,
		function (item) {
			return A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, true, item.C_, item.Eb, item.vD, _List_Nil, item.sY);
		},
		$dillonkearns$elm_markdown$Markdown$OrderedList$parser(previousWasBody));
};
var $dillonkearns$elm_markdown$Markdown$Inline$CodeInline = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Inline$HardLineBreak = {$: 1};
var $dillonkearns$elm_markdown$Markdown$Inline$HtmlInline = function (a) {
	return {$: 5, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Inline$Image = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Inline$Link = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Inline$Strikethrough = function (a) {
	return {$: 7, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Inline$Text = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$matchToInline = function (_v0) {
	var match = _v0;
	var _v1 = match.gR;
	switch (_v1.$) {
		case 0:
			return $dillonkearns$elm_markdown$Markdown$Inline$Text(match.Gv);
		case 1:
			return $dillonkearns$elm_markdown$Markdown$Inline$HardLineBreak;
		case 2:
			return $dillonkearns$elm_markdown$Markdown$Inline$CodeInline(match.Gv);
		case 3:
			var _v2 = _v1.a;
			var text = _v2.a;
			var url = _v2.b;
			return A3(
				$dillonkearns$elm_markdown$Markdown$Inline$Link,
				url,
				$elm$core$Maybe$Nothing,
				_List_fromArray(
					[
						$dillonkearns$elm_markdown$Markdown$Inline$Text(text)
					]));
		case 4:
			var _v3 = _v1.a;
			var url = _v3.a;
			var maybeTitle = _v3.b;
			return A3(
				$dillonkearns$elm_markdown$Markdown$Inline$Link,
				url,
				maybeTitle,
				$dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(match.fc));
		case 5:
			var _v4 = _v1.a;
			var url = _v4.a;
			var maybeTitle = _v4.b;
			return A3(
				$dillonkearns$elm_markdown$Markdown$Inline$Image,
				url,
				maybeTitle,
				$dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(match.fc));
		case 6:
			var model = _v1.a;
			return $dillonkearns$elm_markdown$Markdown$Inline$HtmlInline(model);
		case 7:
			var length = _v1.a;
			return A2(
				$dillonkearns$elm_markdown$Markdown$Inline$Emphasis,
				length,
				$dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(match.fc));
		default:
			return $dillonkearns$elm_markdown$Markdown$Inline$Strikethrough(
				$dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(match.fc));
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines = function (matches) {
	return A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$InlineParser$matchToInline, matches);
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$Match = $elm$core$Basics$identity;
var $dillonkearns$elm_markdown$Markdown$InlineParser$prepareChildMatch = F2(
	function (parentMatch, childMatch) {
		return {cw: childMatch.cw - parentMatch.fh, fc: childMatch.fc, cH: childMatch.cH - parentMatch.fh, Gv: childMatch.Gv, fT: childMatch.fT - parentMatch.fh, fh: childMatch.fh - parentMatch.fh, gR: childMatch.gR};
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$addChild = F2(
	function (parentMatch, childMatch) {
		return {
			cw: parentMatch.cw,
			fc: A2(
				$elm$core$List$cons,
				A2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareChildMatch, parentMatch, childMatch),
				parentMatch.fc),
			cH: parentMatch.cH,
			Gv: parentMatch.Gv,
			fT: parentMatch.fT,
			fh: parentMatch.fh,
			gR: parentMatch.gR
		};
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$organizeChildren = function (_v4) {
	var match = _v4;
	return {
		cw: match.cw,
		fc: $dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatches(match.fc),
		cH: match.cH,
		Gv: match.Gv,
		fT: match.fT,
		fh: match.fh,
		gR: match.gR
	};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatches = function (matches) {
	var _v2 = A2(
		$elm$core$List$sortBy,
		function (_v3) {
			var match = _v3;
			return match.cH;
		},
		matches);
	if (!_v2.b) {
		return _List_Nil;
	} else {
		var first = _v2.a;
		var rest = _v2.b;
		return A3($dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatchesHelp, rest, first, _List_Nil);
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatchesHelp = F3(
	function (remaining, _v0, matchesTail) {
		organizeMatchesHelp:
		while (true) {
			var prevMatch = _v0;
			if (!remaining.b) {
				return A2(
					$elm$core$List$cons,
					$dillonkearns$elm_markdown$Markdown$InlineParser$organizeChildren(prevMatch),
					matchesTail);
			} else {
				var match = remaining.a;
				var rest = remaining.b;
				if (_Utils_cmp(prevMatch.cw, match.cH) < 1) {
					var $temp$remaining = rest,
						$temp$_v0 = match,
						$temp$matchesTail = A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$InlineParser$organizeChildren(prevMatch),
						matchesTail);
					remaining = $temp$remaining;
					_v0 = $temp$_v0;
					matchesTail = $temp$matchesTail;
					continue organizeMatchesHelp;
				} else {
					if ((_Utils_cmp(prevMatch.cH, match.cH) < 0) && (_Utils_cmp(prevMatch.cw, match.cw) > 0)) {
						var $temp$remaining = rest,
							$temp$_v0 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$addChild, prevMatch, match),
							$temp$matchesTail = matchesTail;
						remaining = $temp$remaining;
						_v0 = $temp$_v0;
						matchesTail = $temp$matchesTail;
						continue organizeMatchesHelp;
					} else {
						var $temp$remaining = rest,
							$temp$_v0 = prevMatch,
							$temp$matchesTail = matchesTail;
						remaining = $temp$remaining;
						_v0 = $temp$_v0;
						matchesTail = $temp$matchesTail;
						continue organizeMatchesHelp;
					}
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$NormalType = {$: 0};
var $dillonkearns$elm_markdown$Markdown$Helpers$containsAmpersand = function (string) {
	return A2($elm$core$String$contains, '&', string);
};
var $dillonkearns$elm_markdown$Markdown$Entity$decimalRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('&#([0-9]{1,8});'));
var $dillonkearns$elm_markdown$Markdown$Entity$isBadEndUnicode = function (_int) {
	var remain_ = A2($elm$core$Basics$modBy, 16, _int);
	var remain = A2($elm$core$Basics$modBy, 131070, _int);
	return (_int >= 131070) && ((((0 <= remain) && (remain <= 15)) || ((65536 <= remain) && (remain <= 65551))) && ((remain_ === 14) || (remain_ === 15)));
};
var $dillonkearns$elm_markdown$Markdown$Entity$isValidUnicode = function (_int) {
	return (_int === 9) || ((_int === 10) || ((_int === 13) || ((_int === 133) || (((32 <= _int) && (_int <= 126)) || (((160 <= _int) && (_int <= 55295)) || (((57344 <= _int) && (_int <= 64975)) || (((65008 <= _int) && (_int <= 65533)) || ((65536 <= _int) && (_int <= 1114109)))))))));
};
var $dillonkearns$elm_markdown$Markdown$Entity$validUnicode = function (_int) {
	return ($dillonkearns$elm_markdown$Markdown$Entity$isValidUnicode(_int) && (!$dillonkearns$elm_markdown$Markdown$Entity$isBadEndUnicode(_int))) ? $elm$core$String$fromChar(
		$elm$core$Char$fromCode(_int)) : $elm$core$String$fromChar(
		$elm$core$Char$fromCode(65533));
};
var $dillonkearns$elm_markdown$Markdown$Entity$replaceDecimal = function (match) {
	var _v0 = match.wu;
	if (_v0.b && (!_v0.a.$)) {
		var first = _v0.a.a;
		var _v1 = $elm$core$String$toInt(first);
		if (!_v1.$) {
			var v = _v1.a;
			return $dillonkearns$elm_markdown$Markdown$Entity$validUnicode(v);
		} else {
			return match.o0;
		}
	} else {
		return match.o0;
	}
};
var $dillonkearns$elm_markdown$Markdown$Entity$replaceDecimals = A2($elm$regex$Regex$replace, $dillonkearns$elm_markdown$Markdown$Entity$decimalRegex, $dillonkearns$elm_markdown$Markdown$Entity$replaceDecimal);
var $dillonkearns$elm_markdown$Markdown$Entity$entitiesRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('&([0-9a-zA-Z]+);'));
var $dillonkearns$elm_markdown$Markdown$Entity$entities = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('quot', 34),
			_Utils_Tuple2('amp', 38),
			_Utils_Tuple2('apos', 39),
			_Utils_Tuple2('lt', 60),
			_Utils_Tuple2('gt', 62),
			_Utils_Tuple2('nbsp', 160),
			_Utils_Tuple2('iexcl', 161),
			_Utils_Tuple2('cent', 162),
			_Utils_Tuple2('pound', 163),
			_Utils_Tuple2('curren', 164),
			_Utils_Tuple2('yen', 165),
			_Utils_Tuple2('brvbar', 166),
			_Utils_Tuple2('sect', 167),
			_Utils_Tuple2('uml', 168),
			_Utils_Tuple2('copy', 169),
			_Utils_Tuple2('ordf', 170),
			_Utils_Tuple2('laquo', 171),
			_Utils_Tuple2('not', 172),
			_Utils_Tuple2('shy', 173),
			_Utils_Tuple2('reg', 174),
			_Utils_Tuple2('macr', 175),
			_Utils_Tuple2('deg', 176),
			_Utils_Tuple2('plusmn', 177),
			_Utils_Tuple2('sup2', 178),
			_Utils_Tuple2('sup3', 179),
			_Utils_Tuple2('acute', 180),
			_Utils_Tuple2('micro', 181),
			_Utils_Tuple2('para', 182),
			_Utils_Tuple2('middot', 183),
			_Utils_Tuple2('cedil', 184),
			_Utils_Tuple2('sup1', 185),
			_Utils_Tuple2('ordm', 186),
			_Utils_Tuple2('raquo', 187),
			_Utils_Tuple2('frac14', 188),
			_Utils_Tuple2('frac12', 189),
			_Utils_Tuple2('frac34', 190),
			_Utils_Tuple2('iquest', 191),
			_Utils_Tuple2('Agrave', 192),
			_Utils_Tuple2('Aacute', 193),
			_Utils_Tuple2('Acirc', 194),
			_Utils_Tuple2('Atilde', 195),
			_Utils_Tuple2('Auml', 196),
			_Utils_Tuple2('Aring', 197),
			_Utils_Tuple2('AElig', 198),
			_Utils_Tuple2('Ccedil', 199),
			_Utils_Tuple2('Egrave', 200),
			_Utils_Tuple2('Eacute', 201),
			_Utils_Tuple2('Ecirc', 202),
			_Utils_Tuple2('Euml', 203),
			_Utils_Tuple2('Igrave', 204),
			_Utils_Tuple2('Iacute', 205),
			_Utils_Tuple2('Icirc', 206),
			_Utils_Tuple2('Iuml', 207),
			_Utils_Tuple2('ETH', 208),
			_Utils_Tuple2('Ntilde', 209),
			_Utils_Tuple2('Ograve', 210),
			_Utils_Tuple2('Oacute', 211),
			_Utils_Tuple2('Ocirc', 212),
			_Utils_Tuple2('Otilde', 213),
			_Utils_Tuple2('Ouml', 214),
			_Utils_Tuple2('times', 215),
			_Utils_Tuple2('Oslash', 216),
			_Utils_Tuple2('Ugrave', 217),
			_Utils_Tuple2('Uacute', 218),
			_Utils_Tuple2('Ucirc', 219),
			_Utils_Tuple2('Uuml', 220),
			_Utils_Tuple2('Yacute', 221),
			_Utils_Tuple2('THORN', 222),
			_Utils_Tuple2('szlig', 223),
			_Utils_Tuple2('agrave', 224),
			_Utils_Tuple2('aacute', 225),
			_Utils_Tuple2('acirc', 226),
			_Utils_Tuple2('atilde', 227),
			_Utils_Tuple2('auml', 228),
			_Utils_Tuple2('aring', 229),
			_Utils_Tuple2('aelig', 230),
			_Utils_Tuple2('ccedil', 231),
			_Utils_Tuple2('egrave', 232),
			_Utils_Tuple2('eacute', 233),
			_Utils_Tuple2('ecirc', 234),
			_Utils_Tuple2('euml', 235),
			_Utils_Tuple2('igrave', 236),
			_Utils_Tuple2('iacute', 237),
			_Utils_Tuple2('icirc', 238),
			_Utils_Tuple2('iuml', 239),
			_Utils_Tuple2('eth', 240),
			_Utils_Tuple2('ntilde', 241),
			_Utils_Tuple2('ograve', 242),
			_Utils_Tuple2('oacute', 243),
			_Utils_Tuple2('ocirc', 244),
			_Utils_Tuple2('otilde', 245),
			_Utils_Tuple2('ouml', 246),
			_Utils_Tuple2('divide', 247),
			_Utils_Tuple2('oslash', 248),
			_Utils_Tuple2('ugrave', 249),
			_Utils_Tuple2('uacute', 250),
			_Utils_Tuple2('ucirc', 251),
			_Utils_Tuple2('uuml', 252),
			_Utils_Tuple2('yacute', 253),
			_Utils_Tuple2('thorn', 254),
			_Utils_Tuple2('yuml', 255),
			_Utils_Tuple2('OElig', 338),
			_Utils_Tuple2('oelig', 339),
			_Utils_Tuple2('Scaron', 352),
			_Utils_Tuple2('scaron', 353),
			_Utils_Tuple2('Yuml', 376),
			_Utils_Tuple2('fnof', 402),
			_Utils_Tuple2('circ', 710),
			_Utils_Tuple2('tilde', 732),
			_Utils_Tuple2('Alpha', 913),
			_Utils_Tuple2('Beta', 914),
			_Utils_Tuple2('Gamma', 915),
			_Utils_Tuple2('Delta', 916),
			_Utils_Tuple2('Epsilon', 917),
			_Utils_Tuple2('Zeta', 918),
			_Utils_Tuple2('Eta', 919),
			_Utils_Tuple2('Theta', 920),
			_Utils_Tuple2('Iota', 921),
			_Utils_Tuple2('Kappa', 922),
			_Utils_Tuple2('Lambda', 923),
			_Utils_Tuple2('Mu', 924),
			_Utils_Tuple2('Nu', 925),
			_Utils_Tuple2('Xi', 926),
			_Utils_Tuple2('Omicron', 927),
			_Utils_Tuple2('Pi', 928),
			_Utils_Tuple2('Rho', 929),
			_Utils_Tuple2('Sigma', 931),
			_Utils_Tuple2('Tau', 932),
			_Utils_Tuple2('Upsilon', 933),
			_Utils_Tuple2('Phi', 934),
			_Utils_Tuple2('Chi', 935),
			_Utils_Tuple2('Psi', 936),
			_Utils_Tuple2('Omega', 937),
			_Utils_Tuple2('alpha', 945),
			_Utils_Tuple2('beta', 946),
			_Utils_Tuple2('gamma', 947),
			_Utils_Tuple2('delta', 948),
			_Utils_Tuple2('epsilon', 949),
			_Utils_Tuple2('zeta', 950),
			_Utils_Tuple2('eta', 951),
			_Utils_Tuple2('theta', 952),
			_Utils_Tuple2('iota', 953),
			_Utils_Tuple2('kappa', 954),
			_Utils_Tuple2('lambda', 955),
			_Utils_Tuple2('mu', 956),
			_Utils_Tuple2('nu', 957),
			_Utils_Tuple2('xi', 958),
			_Utils_Tuple2('omicron', 959),
			_Utils_Tuple2('pi', 960),
			_Utils_Tuple2('rho', 961),
			_Utils_Tuple2('sigmaf', 962),
			_Utils_Tuple2('sigma', 963),
			_Utils_Tuple2('tau', 964),
			_Utils_Tuple2('upsilon', 965),
			_Utils_Tuple2('phi', 966),
			_Utils_Tuple2('chi', 967),
			_Utils_Tuple2('psi', 968),
			_Utils_Tuple2('omega', 969),
			_Utils_Tuple2('thetasym', 977),
			_Utils_Tuple2('upsih', 978),
			_Utils_Tuple2('piv', 982),
			_Utils_Tuple2('ensp', 8194),
			_Utils_Tuple2('emsp', 8195),
			_Utils_Tuple2('thinsp', 8201),
			_Utils_Tuple2('zwnj', 8204),
			_Utils_Tuple2('zwj', 8205),
			_Utils_Tuple2('lrm', 8206),
			_Utils_Tuple2('rlm', 8207),
			_Utils_Tuple2('ndash', 8211),
			_Utils_Tuple2('mdash', 8212),
			_Utils_Tuple2('lsquo', 8216),
			_Utils_Tuple2('rsquo', 8217),
			_Utils_Tuple2('sbquo', 8218),
			_Utils_Tuple2('ldquo', 8220),
			_Utils_Tuple2('rdquo', 8221),
			_Utils_Tuple2('bdquo', 8222),
			_Utils_Tuple2('dagger', 8224),
			_Utils_Tuple2('Dagger', 8225),
			_Utils_Tuple2('bull', 8226),
			_Utils_Tuple2('hellip', 8230),
			_Utils_Tuple2('permil', 8240),
			_Utils_Tuple2('prime', 8242),
			_Utils_Tuple2('Prime', 8243),
			_Utils_Tuple2('lsaquo', 8249),
			_Utils_Tuple2('rsaquo', 8250),
			_Utils_Tuple2('oline', 8254),
			_Utils_Tuple2('frasl', 8260),
			_Utils_Tuple2('euro', 8364),
			_Utils_Tuple2('image', 8465),
			_Utils_Tuple2('weierp', 8472),
			_Utils_Tuple2('real', 8476),
			_Utils_Tuple2('trade', 8482),
			_Utils_Tuple2('alefsym', 8501),
			_Utils_Tuple2('larr', 8592),
			_Utils_Tuple2('uarr', 8593),
			_Utils_Tuple2('rarr', 8594),
			_Utils_Tuple2('darr', 8595),
			_Utils_Tuple2('harr', 8596),
			_Utils_Tuple2('crarr', 8629),
			_Utils_Tuple2('lArr', 8656),
			_Utils_Tuple2('uArr', 8657),
			_Utils_Tuple2('rArr', 8658),
			_Utils_Tuple2('dArr', 8659),
			_Utils_Tuple2('hArr', 8660),
			_Utils_Tuple2('forall', 8704),
			_Utils_Tuple2('part', 8706),
			_Utils_Tuple2('exist', 8707),
			_Utils_Tuple2('empty', 8709),
			_Utils_Tuple2('nabla', 8711),
			_Utils_Tuple2('isin', 8712),
			_Utils_Tuple2('notin', 8713),
			_Utils_Tuple2('ni', 8715),
			_Utils_Tuple2('prod', 8719),
			_Utils_Tuple2('sum', 8721),
			_Utils_Tuple2('minus', 8722),
			_Utils_Tuple2('lowast', 8727),
			_Utils_Tuple2('radic', 8730),
			_Utils_Tuple2('prop', 8733),
			_Utils_Tuple2('infin', 8734),
			_Utils_Tuple2('ang', 8736),
			_Utils_Tuple2('and', 8743),
			_Utils_Tuple2('or', 8744),
			_Utils_Tuple2('cap', 8745),
			_Utils_Tuple2('cup', 8746),
			_Utils_Tuple2('int', 8747),
			_Utils_Tuple2('there4', 8756),
			_Utils_Tuple2('sim', 8764),
			_Utils_Tuple2('cong', 8773),
			_Utils_Tuple2('asymp', 8776),
			_Utils_Tuple2('ne', 8800),
			_Utils_Tuple2('equiv', 8801),
			_Utils_Tuple2('le', 8804),
			_Utils_Tuple2('ge', 8805),
			_Utils_Tuple2('sub', 8834),
			_Utils_Tuple2('sup', 8835),
			_Utils_Tuple2('nsub', 8836),
			_Utils_Tuple2('sube', 8838),
			_Utils_Tuple2('supe', 8839),
			_Utils_Tuple2('oplus', 8853),
			_Utils_Tuple2('otimes', 8855),
			_Utils_Tuple2('perp', 8869),
			_Utils_Tuple2('sdot', 8901),
			_Utils_Tuple2('lceil', 8968),
			_Utils_Tuple2('rceil', 8969),
			_Utils_Tuple2('lfloor', 8970),
			_Utils_Tuple2('rfloor', 8971),
			_Utils_Tuple2('lang', 9001),
			_Utils_Tuple2('rang', 9002),
			_Utils_Tuple2('loz', 9674),
			_Utils_Tuple2('spades', 9824),
			_Utils_Tuple2('clubs', 9827),
			_Utils_Tuple2('hearts', 9829),
			_Utils_Tuple2('diams', 9830)
		]));
var $dillonkearns$elm_markdown$Markdown$Entity$replaceEntity = function (match) {
	var _v0 = match.wu;
	if (_v0.b && (!_v0.a.$)) {
		var first = _v0.a.a;
		var _v1 = A2($elm$core$Dict$get, first, $dillonkearns$elm_markdown$Markdown$Entity$entities);
		if (!_v1.$) {
			var code = _v1.a;
			return $elm$core$String$fromChar(
				$elm$core$Char$fromCode(code));
		} else {
			return match.o0;
		}
	} else {
		return match.o0;
	}
};
var $dillonkearns$elm_markdown$Markdown$Entity$replaceEntities = A2($elm$regex$Regex$replace, $dillonkearns$elm_markdown$Markdown$Entity$entitiesRegex, $dillonkearns$elm_markdown$Markdown$Entity$replaceEntity);
var $dillonkearns$elm_markdown$Markdown$Helpers$escapableRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\+)([!\"#$%&\\\'()*+,./:;<=>?@[\\\\\\]^_`{|}~-])'));
var $dillonkearns$elm_markdown$Markdown$Helpers$replaceEscapable = A2(
	$elm$regex$Regex$replace,
	$dillonkearns$elm_markdown$Markdown$Helpers$escapableRegex,
	function (regexMatch) {
		var _v0 = regexMatch.wu;
		if (((_v0.b && (!_v0.a.$)) && _v0.b.b) && (!_v0.b.a.$)) {
			var backslashes = _v0.a.a;
			var _v1 = _v0.b;
			var escapedStr = _v1.a.a;
			return _Utils_ap(
				A2(
					$elm$core$String$repeat,
					($elm$core$String$length(backslashes) / 2) | 0,
					'\\'),
				escapedStr);
		} else {
			return regexMatch.o0;
		}
	});
var $dillonkearns$elm_markdown$Markdown$Entity$hexadecimalRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('&#[Xx]([0-9a-fA-F]{1,8});'));
var $dillonkearns$elm_markdown$Markdown$Entity$hexToInt = function (string) {
	var folder = F2(
		function (hexDigit, _int) {
			return ((_int * 16) + A2(
				$elm$core$Basics$modBy,
				39,
				$elm$core$Char$toCode(hexDigit))) - 9;
		});
	return A3(
		$elm$core$String$foldl,
		folder,
		0,
		$elm$core$String$toLower(string));
};
var $dillonkearns$elm_markdown$Markdown$Entity$replaceHexadecimal = function (match) {
	var _v0 = match.wu;
	if (_v0.b && (!_v0.a.$)) {
		var first = _v0.a.a;
		return $dillonkearns$elm_markdown$Markdown$Entity$validUnicode(
			$dillonkearns$elm_markdown$Markdown$Entity$hexToInt(first));
	} else {
		return match.o0;
	}
};
var $dillonkearns$elm_markdown$Markdown$Entity$replaceHexadecimals = A2($elm$regex$Regex$replace, $dillonkearns$elm_markdown$Markdown$Entity$hexadecimalRegex, $dillonkearns$elm_markdown$Markdown$Entity$replaceHexadecimal);
var $dillonkearns$elm_markdown$Markdown$Helpers$formatStr = function (str) {
	var withEscapes = $dillonkearns$elm_markdown$Markdown$Helpers$replaceEscapable(str);
	return $dillonkearns$elm_markdown$Markdown$Helpers$containsAmpersand(withEscapes) ? $dillonkearns$elm_markdown$Markdown$Entity$replaceHexadecimals(
		$dillonkearns$elm_markdown$Markdown$Entity$replaceDecimals(
			$dillonkearns$elm_markdown$Markdown$Entity$replaceEntities(withEscapes))) : withEscapes;
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch = function (text) {
	return {
		cw: 0,
		fc: _List_Nil,
		cH: 0,
		Gv: $dillonkearns$elm_markdown$Markdown$Helpers$formatStr(text),
		fT: 0,
		fh: 0,
		gR: $dillonkearns$elm_markdown$Markdown$InlineParser$NormalType
	};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatch = F3(
	function (rawText, _v2, parsedMatches) {
		var matchModel = _v2;
		var updtMatch = {
			cw: matchModel.cw,
			fc: A3($dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatches, matchModel.Gv, _List_Nil, matchModel.fc),
			cH: matchModel.cH,
			Gv: matchModel.Gv,
			fT: matchModel.fT,
			fh: matchModel.fh,
			gR: matchModel.gR
		};
		if (!parsedMatches.b) {
			var finalStr = A2($elm$core$String$dropLeft, matchModel.cw, rawText);
			return $elm$core$String$isEmpty(finalStr) ? _List_fromArray(
				[updtMatch]) : _List_fromArray(
				[
					updtMatch,
					$dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch(finalStr)
				]);
		} else {
			var matchHead = parsedMatches.a;
			var _v4 = matchHead.gR;
			if (!_v4.$) {
				return A2($elm$core$List$cons, updtMatch, parsedMatches);
			} else {
				return _Utils_eq(matchModel.cw, matchHead.cH) ? A2($elm$core$List$cons, updtMatch, parsedMatches) : ((_Utils_cmp(matchModel.cw, matchHead.cH) < 0) ? A2(
					$elm$core$List$cons,
					updtMatch,
					A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch(
							A3($elm$core$String$slice, matchModel.cw, matchHead.cH, rawText)),
						parsedMatches)) : parsedMatches);
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatches = F3(
	function (rawText, parsedMatches, matches) {
		parseTextMatches:
		while (true) {
			if (!matches.b) {
				if (!parsedMatches.b) {
					return $elm$core$String$isEmpty(rawText) ? _List_Nil : _List_fromArray(
						[
							$dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch(rawText)
						]);
				} else {
					var matchModel = parsedMatches.a;
					return (matchModel.cH > 0) ? A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch(
							A2($elm$core$String$left, matchModel.cH, rawText)),
						parsedMatches) : parsedMatches;
				}
			} else {
				var match = matches.a;
				var matchesTail = matches.b;
				var $temp$rawText = rawText,
					$temp$parsedMatches = A3($dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatch, rawText, match, parsedMatches),
					$temp$matches = matchesTail;
				rawText = $temp$rawText;
				parsedMatches = $temp$parsedMatches;
				matches = $temp$matches;
				continue parseTextMatches;
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$cleanAngleBracketTokens = F3(
	function (tokensL, tokensR, countL) {
		cleanAngleBracketTokens:
		while (true) {
			if (!tokensR.b) {
				return _List_Nil;
			} else {
				var hd1 = tokensR.a;
				var rest1 = tokensR.b;
				if (!tokensL.b) {
					if (countL > 1) {
						var $temp$tokensL = tokensL,
							$temp$tokensR = rest1,
							$temp$countL = countL - 1;
						tokensL = $temp$tokensL;
						tokensR = $temp$tokensR;
						countL = $temp$countL;
						continue cleanAngleBracketTokens;
					} else {
						if (countL === 1) {
							return A2(
								$elm$core$List$cons,
								hd1,
								A3($dillonkearns$elm_markdown$Markdown$InlineParser$cleanAngleBracketTokens, tokensL, rest1, countL - 1));
						} else {
							var $temp$tokensL = tokensL,
								$temp$tokensR = rest1,
								$temp$countL = 0;
							tokensL = $temp$tokensL;
							tokensR = $temp$tokensR;
							countL = $temp$countL;
							continue cleanAngleBracketTokens;
						}
					}
				} else {
					var hd = tokensL.a;
					var rest = tokensL.b;
					if (_Utils_cmp(hd.j$, hd1.j$) < 0) {
						if (!countL) {
							return A2(
								$elm$core$List$cons,
								hd,
								A3($dillonkearns$elm_markdown$Markdown$InlineParser$cleanAngleBracketTokens, rest, tokensR, countL + 1));
						} else {
							var $temp$tokensL = rest,
								$temp$tokensR = tokensR,
								$temp$countL = countL + 1;
							tokensL = $temp$tokensL;
							tokensR = $temp$tokensR;
							countL = $temp$countL;
							continue cleanAngleBracketTokens;
						}
					} else {
						if (countL > 1) {
							var $temp$tokensL = tokensL,
								$temp$tokensR = rest1,
								$temp$countL = countL - 1;
							tokensL = $temp$tokensL;
							tokensR = $temp$tokensR;
							countL = $temp$countL;
							continue cleanAngleBracketTokens;
						} else {
							if (countL === 1) {
								return A2(
									$elm$core$List$cons,
									hd1,
									A3($dillonkearns$elm_markdown$Markdown$InlineParser$cleanAngleBracketTokens, tokensL, rest1, countL - 1));
							} else {
								var $temp$tokensL = tokensL,
									$temp$tokensR = rest1,
									$temp$countL = 0;
								tokensL = $temp$tokensL;
								tokensR = $temp$tokensR;
								countL = $temp$countL;
								continue cleanAngleBracketTokens;
							}
						}
					}
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketLTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(\\<)'));
var $elm$regex$Regex$find = _Regex_findAtMost(_Regex_infinity);
var $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketOpen = {$: 4};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketLToken = function (regMatch) {
	var _v0 = regMatch.wu;
	if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		return $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $elm$core$Maybe$Just(
			{j$: regMatch.j$ + backslashesLength, uw: 1, bE: $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketOpen}) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findAngleBracketLTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketLToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketLTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketRTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(\\>)'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketClose = function (a) {
	return {$: 5, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$Escaped = 0;
var $dillonkearns$elm_markdown$Markdown$InlineParser$NotEscaped = 1;
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketRToken = function (regMatch) {
	var _v0 = regMatch.wu;
	if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		return $elm$core$Maybe$Just(
			{
				j$: regMatch.j$ + backslashesLength,
				uw: 1,
				bE: $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketClose(1) : $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketClose(0)
			});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findAngleBracketRTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketRToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketRTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$asteriskEmphasisTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)([^*])?(\\*+)([^*])?'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisToken = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$isPunctuation = function (c) {
	switch (c) {
		case '!':
			return true;
		case '\"':
			return true;
		case '#':
			return true;
		case '%':
			return true;
		case '&':
			return true;
		case '\'':
			return true;
		case '(':
			return true;
		case ')':
			return true;
		case '*':
			return true;
		case ',':
			return true;
		case '-':
			return true;
		case '.':
			return true;
		case '/':
			return true;
		case ':':
			return true;
		case ';':
			return true;
		case '?':
			return true;
		case '@':
			return true;
		case '[':
			return true;
		case ']':
			return true;
		case '_':
			return true;
		case '{':
			return true;
		case '}':
			return true;
		case '~':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$containPunctuation = A2(
	$elm$core$String$foldl,
	F2(
		function (c, accum) {
			return accum || $dillonkearns$elm_markdown$Markdown$InlineParser$isPunctuation(c);
		}),
	false);
var $dillonkearns$elm_markdown$Markdown$InlineParser$isWhitespace = function (c) {
	switch (c) {
		case ' ':
			return true;
		case '\u000C':
			return true;
		case '\n':
			return true;
		case '\u000D':
			return true;
		case '\t':
			return true;
		case '\u000B':
			return true;
		case '\u00A0':
			return true;
		case '\u2028':
			return true;
		case '\u2029':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$containSpace = A2(
	$elm$core$String$foldl,
	F2(
		function (c, accum) {
			return accum || $dillonkearns$elm_markdown$Markdown$InlineParser$isWhitespace(c);
		}),
	false);
var $dillonkearns$elm_markdown$Markdown$InlineParser$getFringeRank = function (mstring) {
	if (!mstring.$) {
		var string = mstring.a;
		return ($elm$core$String$isEmpty(string) || $dillonkearns$elm_markdown$Markdown$InlineParser$containSpace(string)) ? 0 : ($dillonkearns$elm_markdown$Markdown$InlineParser$containPunctuation(string) ? 1 : 2);
	} else {
		return 0;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToEmphasisToken = F3(
	function (_char, rawText, regMatch) {
		var _v0 = regMatch.wu;
		if ((((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.a.$)) && _v0.b.b.b.b) {
			var maybeBackslashes = _v0.a;
			var _v1 = _v0.b;
			var maybeLeftFringe = _v1.a;
			var _v2 = _v1.b;
			var delimiter = _v2.a.a;
			var _v3 = _v2.b;
			var maybeRightFringe = _v3.a;
			var rFringeRank = $dillonkearns$elm_markdown$Markdown$InlineParser$getFringeRank(maybeRightFringe);
			var leftFringeLength = function () {
				if (!maybeLeftFringe.$) {
					var left = maybeLeftFringe.a;
					return $elm$core$String$length(left);
				} else {
					return 0;
				}
			}();
			var mLeftFringe = ((!(!regMatch.j$)) && (!leftFringeLength)) ? $elm$core$Maybe$Just(
				A3($elm$core$String$slice, regMatch.j$ - 1, regMatch.j$, rawText)) : maybeLeftFringe;
			var backslashesLength = function () {
				if (!maybeBackslashes.$) {
					var backslashes = maybeBackslashes.a;
					return $elm$core$String$length(backslashes);
				} else {
					return 0;
				}
			}();
			var isEscaped = ((!$dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength)) && (!leftFringeLength)) || function () {
				if ((!mLeftFringe.$) && (mLeftFringe.a === '\\')) {
					return true;
				} else {
					return false;
				}
			}();
			var delimiterLength = isEscaped ? ($elm$core$String$length(delimiter) - 1) : $elm$core$String$length(delimiter);
			var lFringeRank = isEscaped ? 1 : $dillonkearns$elm_markdown$Markdown$InlineParser$getFringeRank(mLeftFringe);
			if ((delimiterLength <= 0) || ((_char === '_') && ((lFringeRank === 2) && (rFringeRank === 2)))) {
				return $elm$core$Maybe$Nothing;
			} else {
				var index = ((regMatch.j$ + backslashesLength) + leftFringeLength) + (isEscaped ? 1 : 0);
				return $elm$core$Maybe$Just(
					{
						j$: index,
						uw: delimiterLength,
						bE: A2(
							$dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisToken,
							_char,
							{rl: lFringeRank, sa: rFringeRank})
					});
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$findAsteriskEmphasisTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		A2($dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToEmphasisToken, '*', str),
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$asteriskEmphasisTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$codeTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(\\`+)'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$CodeToken = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToCodeToken = function (regMatch) {
	var _v0 = regMatch.wu;
	if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var backtick = _v1.a.a;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		return $elm$core$Maybe$Just(
			{
				j$: regMatch.j$ + backslashesLength,
				uw: $elm$core$String$length(backtick),
				bE: $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $dillonkearns$elm_markdown$Markdown$InlineParser$CodeToken(1) : $dillonkearns$elm_markdown$Markdown$InlineParser$CodeToken(0)
			});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findCodeTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToCodeToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$codeTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$hardBreakTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(?:(\\\\+)|( {2,}))\\n'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken = {$: 8};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToHardBreakToken = function (regMatch) {
	var _v0 = regMatch.wu;
	_v0$2:
	while (true) {
		if (_v0.b) {
			if (!_v0.a.$) {
				var backslashes = _v0.a.a;
				var backslashesLength = $elm$core$String$length(backslashes);
				return (!$dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength)) ? $elm$core$Maybe$Just(
					{j$: (regMatch.j$ + backslashesLength) - 1, uw: 2, bE: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken}) : $elm$core$Maybe$Nothing;
			} else {
				if (_v0.b.b && (!_v0.b.a.$)) {
					var _v1 = _v0.b;
					return $elm$core$Maybe$Just(
						{
							j$: regMatch.j$,
							uw: $elm$core$String$length(regMatch.o0),
							bE: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken
						});
				} else {
					break _v0$2;
				}
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToSoftHardBreakToken = function (regMatch) {
	var _v0 = regMatch.wu;
	_v0$2:
	while (true) {
		if (_v0.b) {
			if (!_v0.a.$) {
				var backslashes = _v0.a.a;
				var backslashesLength = $elm$core$String$length(backslashes);
				return $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $elm$core$Maybe$Just(
					{j$: regMatch.j$ + backslashesLength, uw: 1, bE: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken}) : $elm$core$Maybe$Just(
					{j$: (regMatch.j$ + backslashesLength) - 1, uw: 2, bE: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken});
			} else {
				if (_v0.b.b) {
					var _v1 = _v0.b;
					return $elm$core$Maybe$Just(
						{
							j$: regMatch.j$,
							uw: $elm$core$String$length(regMatch.o0),
							bE: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken
						});
				} else {
					break _v0$2;
				}
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreak = false;
var $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreakTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(?:(\\\\+)|( *))\\n'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$findHardBreakTokens = function (str) {
	return $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreak ? A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToSoftHardBreakToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreakTokenRegex, str)) : A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToHardBreakToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$hardBreakTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageCloseTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(\\])'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$SquareBracketClose = {$: 3};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToLinkImageCloseToken = function (regMatch) {
	var _v0 = regMatch.wu;
	if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		return $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $elm$core$Maybe$Just(
			{j$: regMatch.j$ + backslashesLength, uw: 1, bE: $dillonkearns$elm_markdown$Markdown$InlineParser$SquareBracketClose}) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findLinkImageCloseTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToLinkImageCloseToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageCloseTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageOpenTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(\\!)?(\\[)'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$Active = 0;
var $dillonkearns$elm_markdown$Markdown$InlineParser$ImageOpenToken = {$: 2};
var $dillonkearns$elm_markdown$Markdown$InlineParser$LinkOpenToken = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToLinkImageOpenToken = function (regMatch) {
	var _v0 = regMatch.wu;
	if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var maybeImageOpen = _v1.a;
		var _v2 = _v1.b;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		var isEscaped = !$dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength);
		var index = isEscaped ? ((regMatch.j$ + backslashesLength) + 1) : (regMatch.j$ + backslashesLength);
		if (isEscaped) {
			if (!maybeImageOpen.$) {
				return $elm$core$Maybe$Just(
					{
						j$: index,
						uw: 1,
						bE: $dillonkearns$elm_markdown$Markdown$InlineParser$LinkOpenToken(0)
					});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			if (!maybeImageOpen.$) {
				return $elm$core$Maybe$Just(
					{j$: index, uw: 2, bE: $dillonkearns$elm_markdown$Markdown$InlineParser$ImageOpenToken});
			} else {
				return $elm$core$Maybe$Just(
					{
						j$: index,
						uw: 1,
						bE: $dillonkearns$elm_markdown$Markdown$InlineParser$LinkOpenToken(0)
					});
			}
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findLinkImageOpenTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToLinkImageOpenToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageOpenTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$StrikethroughToken = function (a) {
	return {$: 9, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToStrikethroughToken = function (regMatch) {
	var _v0 = regMatch.wu;
	if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var tilde = _v1.a.a;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		var _v2 = $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? _Utils_Tuple2(
			$elm$core$String$length(tilde),
			$dillonkearns$elm_markdown$Markdown$InlineParser$StrikethroughToken(1)) : _Utils_Tuple2(
			$elm$core$String$length(tilde),
			$dillonkearns$elm_markdown$Markdown$InlineParser$StrikethroughToken(0));
		var length = _v2.a;
		var meaning = _v2.b;
		return $elm$core$Maybe$Just(
			{j$: regMatch.j$ + backslashesLength, uw: length, bE: meaning});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(~{2,})([^~])?'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$findStrikethroughTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToStrikethroughToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$underlineEmphasisTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)([^_])?(\\_+)([^_])?'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$findUnderlineEmphasisTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		A2($dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToEmphasisToken, '_', str),
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$underlineEmphasisTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex = F2(
	function (left, right) {
		if (left.b) {
			var lfirst = left.a;
			var lrest = left.b;
			if (right.b) {
				var rfirst = right.a;
				var rrest = right.b;
				return (_Utils_cmp(lfirst.j$, rfirst.j$) < 0) ? A2(
					$elm$core$List$cons,
					lfirst,
					A2($dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex, lrest, right)) : A2(
					$elm$core$List$cons,
					rfirst,
					A2($dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex, left, rrest));
			} else {
				return left;
			}
		} else {
			return right;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$tokenize = function (rawText) {
	return A2(
		$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
		A3(
			$dillonkearns$elm_markdown$Markdown$InlineParser$cleanAngleBracketTokens,
			A2(
				$elm$core$List$sortBy,
				function ($) {
					return $.j$;
				},
				$dillonkearns$elm_markdown$Markdown$InlineParser$findAngleBracketLTokens(rawText)),
			A2(
				$elm$core$List$sortBy,
				function ($) {
					return $.j$;
				},
				$dillonkearns$elm_markdown$Markdown$InlineParser$findAngleBracketRTokens(rawText)),
			0),
		A2(
			$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
			$dillonkearns$elm_markdown$Markdown$InlineParser$findHardBreakTokens(rawText),
			A2(
				$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
				$dillonkearns$elm_markdown$Markdown$InlineParser$findLinkImageCloseTokens(rawText),
				A2(
					$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
					$dillonkearns$elm_markdown$Markdown$InlineParser$findLinkImageOpenTokens(rawText),
					A2(
						$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
						$dillonkearns$elm_markdown$Markdown$InlineParser$findStrikethroughTokens(rawText),
						A2(
							$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
							$dillonkearns$elm_markdown$Markdown$InlineParser$findUnderlineEmphasisTokens(rawText),
							A2(
								$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
								$dillonkearns$elm_markdown$Markdown$InlineParser$findAsteriskEmphasisTokens(rawText),
								$dillonkearns$elm_markdown$Markdown$InlineParser$findCodeTokens(rawText))))))));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$CodeType = {$: 2};
var $dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisType = function (a) {
	return {$: 7, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$HtmlType = function (a) {
	return {$: 6, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$ImageType = function (a) {
	return {$: 5, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$Inactive = 1;
var $dillonkearns$elm_markdown$Markdown$InlineParser$LinkType = function (a) {
	return {$: 4, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$StrikethroughType = {$: 8};
var $dillonkearns$elm_markdown$Markdown$InlineParser$AutolinkType = function (a) {
	return {$: 3, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$decodeUrlRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('%(?:3B|2C|2F|3F|3A|40|26|3D|2B|24|23|25)'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl = A2(
	$elm$core$Basics$composeR,
	$elm$url$Url$percentEncode,
	A2(
		$elm$regex$Regex$replace,
		$dillonkearns$elm_markdown$Markdown$InlineParser$decodeUrlRegex,
		function (match) {
			return A2(
				$elm$core$Maybe$withDefault,
				match.o0,
				$elm$url$Url$percentDecode(match.o0));
		}));
var $dillonkearns$elm_markdown$Markdown$InlineParser$urlRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^([A-Za-z][A-Za-z0-9.+\\-]{1,31}:[^<>\\x00-\\x20]*)$'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$autolinkToMatch = function (_v0) {
	var match = _v0;
	return A2($elm$regex$Regex$contains, $dillonkearns$elm_markdown$Markdown$InlineParser$urlRegex, match.Gv) ? $elm$core$Result$Ok(
		_Utils_update(
			match,
			{
				gR: $dillonkearns$elm_markdown$Markdown$InlineParser$AutolinkType(
					_Utils_Tuple2(
						match.Gv,
						$dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl(match.Gv)))
			})) : $elm$core$Result$Err(match);
};
var $dillonkearns$elm_markdown$Markdown$Helpers$insideSquareBracketRegex = '[^\\[\\]\\\\]*(?:\\\\.[^\\[\\]\\\\]*)*';
var $dillonkearns$elm_markdown$Markdown$InlineParser$refLabelRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^\\[\\s*(' + ($dillonkearns$elm_markdown$Markdown$Helpers$insideSquareBracketRegex + ')\\s*\\]')));
var $dillonkearns$elm_markdown$Markdown$Helpers$cleanWhitespaces = function (original) {
	return original;
};
var $dillonkearns$elm_markdown$Markdown$Helpers$prepareRefLabel = A2($elm$core$Basics$composeR, $dillonkearns$elm_markdown$Markdown$Helpers$cleanWhitespaces, $elm$core$String$toLower);
var $dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle = F2(
	function (rawUrl, maybeTitle) {
		return _Utils_Tuple2(
			$dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl(
				$dillonkearns$elm_markdown$Markdown$Helpers$formatStr(rawUrl)),
			A2($elm$core$Maybe$map, $dillonkearns$elm_markdown$Markdown$Helpers$formatStr, maybeTitle));
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$refRegexToMatch = F3(
	function (matchModel, references, maybeRegexMatch) {
		var refLabel = function (str) {
			return $elm$core$String$isEmpty(str) ? matchModel.Gv : str;
		}(
			A2(
				$elm$core$Maybe$withDefault,
				matchModel.Gv,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.wu;
							},
							$elm$core$List$head),
						maybeRegexMatch))));
		var _v0 = A2(
			$elm$core$Dict$get,
			$dillonkearns$elm_markdown$Markdown$Helpers$prepareRefLabel(refLabel),
			references);
		if (_v0.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v1 = _v0.a;
			var rawUrl = _v1.a;
			var maybeTitle = _v1.b;
			var type_ = function () {
				var _v3 = matchModel.gR;
				if (_v3.$ === 5) {
					return $dillonkearns$elm_markdown$Markdown$InlineParser$ImageType(
						A2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle, rawUrl, maybeTitle));
				} else {
					return $dillonkearns$elm_markdown$Markdown$InlineParser$LinkType(
						A2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle, rawUrl, maybeTitle));
				}
			}();
			var regexMatchLength = function () {
				if (!maybeRegexMatch.$) {
					var match = maybeRegexMatch.a.o0;
					return $elm$core$String$length(match);
				} else {
					return 0;
				}
			}();
			return $elm$core$Maybe$Just(
				_Utils_update(
					matchModel,
					{cw: matchModel.cw + regexMatchLength, gR: type_}));
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineReferences = F3(
	function (remainText, _v0, references) {
		var tempMatch = _v0;
		var matches = A3($elm$regex$Regex$findAtMost, 1, $dillonkearns$elm_markdown$Markdown$InlineParser$refLabelRegex, remainText);
		return A3(
			$dillonkearns$elm_markdown$Markdown$InlineParser$refRegexToMatch,
			tempMatch,
			references,
			$elm$core$List$head(matches));
	});
var $dillonkearns$elm_markdown$Markdown$Helpers$lineEndChars = '\\f\\v\\r\\n';
var $dillonkearns$elm_markdown$Markdown$Helpers$whiteSpaceChars = ' \\t\\f\\v\\r\\n';
var $dillonkearns$elm_markdown$Markdown$InlineParser$hrefRegex = '(?:<([^<>' + ($dillonkearns$elm_markdown$Markdown$Helpers$lineEndChars + (']*)>|([^' + ($dillonkearns$elm_markdown$Markdown$Helpers$whiteSpaceChars + ('\\(\\)\\\\]*(?:\\\\.[^' + ($dillonkearns$elm_markdown$Markdown$Helpers$whiteSpaceChars + '\\(\\)\\\\]*)*))')))));
var $dillonkearns$elm_markdown$Markdown$Helpers$titleRegex = '(?:[' + ($dillonkearns$elm_markdown$Markdown$Helpers$whiteSpaceChars + (']+' + ('(?:\'([^\'\\\\]*(?:\\\\.[^\'\\\\]*)*)\'|' + ('\"([^\"\\\\]*(?:\\\\.[^\"\\\\]*)*)\"|' + '\\(([^\\)\\\\]*(?:\\\\.[^\\)\\\\]*)*)\\)))?'))));
var $dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^\\(\\s*' + ($dillonkearns$elm_markdown$Markdown$InlineParser$hrefRegex + ($dillonkearns$elm_markdown$Markdown$Helpers$titleRegex + '\\s*\\)'))));
var $dillonkearns$elm_markdown$Markdown$Helpers$returnFirstJust = function (maybes) {
	var process = F2(
		function (a, maybeFound) {
			if (!maybeFound.$) {
				var found = maybeFound.a;
				return $elm$core$Maybe$Just(found);
			} else {
				return a;
			}
		});
	return A3($elm$core$List$foldl, process, $elm$core$Maybe$Nothing, maybes);
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegexToMatch = F2(
	function (matchModel, regexMatch) {
		var _v0 = regexMatch.wu;
		if ((((_v0.b && _v0.b.b) && _v0.b.b.b) && _v0.b.b.b.b) && _v0.b.b.b.b.b) {
			var maybeRawUrlAngleBrackets = _v0.a;
			var _v1 = _v0.b;
			var maybeRawUrlWithoutBrackets = _v1.a;
			var _v2 = _v1.b;
			var maybeTitleSingleQuotes = _v2.a;
			var _v3 = _v2.b;
			var maybeTitleDoubleQuotes = _v3.a;
			var _v4 = _v3.b;
			var maybeTitleParenthesis = _v4.a;
			var maybeTitle = $dillonkearns$elm_markdown$Markdown$Helpers$returnFirstJust(
				_List_fromArray(
					[maybeTitleSingleQuotes, maybeTitleDoubleQuotes, maybeTitleParenthesis]));
			var toMatch = function (rawUrl) {
				return _Utils_update(
					matchModel,
					{
						cw: matchModel.cw + $elm$core$String$length(regexMatch.o0),
						gR: function () {
							var _v5 = matchModel.gR;
							if (_v5.$ === 5) {
								return $dillonkearns$elm_markdown$Markdown$InlineParser$ImageType;
							} else {
								return $dillonkearns$elm_markdown$Markdown$InlineParser$LinkType;
							}
						}()(
							A2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle, rawUrl, maybeTitle))
					});
			};
			var maybeRawUrl = $dillonkearns$elm_markdown$Markdown$Helpers$returnFirstJust(
				_List_fromArray(
					[maybeRawUrlAngleBrackets, maybeRawUrlWithoutBrackets]));
			return $elm$core$Maybe$Just(
				toMatch(
					A2($elm$core$Maybe$withDefault, '', maybeRawUrl)));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineLinkTypeOrImageType = F3(
	function (remainText, _v0, refs) {
		var tempMatch = _v0;
		var _v1 = A3($elm$regex$Regex$findAtMost, 1, $dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegex, remainText);
		if (_v1.b) {
			var first = _v1.a;
			var _v2 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegexToMatch, tempMatch, first);
			if (!_v2.$) {
				var match = _v2.a;
				return $elm$core$Maybe$Just(match);
			} else {
				return A3($dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineReferences, remainText, tempMatch, refs);
			}
		} else {
			return A3($dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineReferences, remainText, tempMatch, refs);
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$checkParsedAheadOverlapping = F2(
	function (_v0, remainMatches) {
		var match = _v0;
		var overlappingMatches = $elm$core$List$filter(
			function (_v1) {
				var testMatch = _v1;
				return (_Utils_cmp(match.cw, testMatch.cH) > 0) && (_Utils_cmp(match.cw, testMatch.cw) < 0);
			});
		return ($elm$core$List$isEmpty(remainMatches) || $elm$core$List$isEmpty(
			overlappingMatches(remainMatches))) ? $elm$core$Maybe$Just(
			A2($elm$core$List$cons, match, remainMatches)) : $elm$core$Maybe$Nothing;
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$emailRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^([a-zA-Z0-9.!#$%&\'*+\\/=?^_`{|}~\\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?)*)$'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$emailAutolinkTypeToMatch = function (_v0) {
	var match = _v0;
	return A2($elm$regex$Regex$contains, $dillonkearns$elm_markdown$Markdown$InlineParser$emailRegex, match.Gv) ? $elm$core$Result$Ok(
		_Utils_update(
			match,
			{
				gR: $dillonkearns$elm_markdown$Markdown$InlineParser$AutolinkType(
					_Utils_Tuple2(
						match.Gv,
						'mailto:' + $dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl(match.Gv)))
			})) : $elm$core$Result$Err(match);
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findTokenHelp = F3(
	function (innerTokens, isToken, tokens) {
		findTokenHelp:
		while (true) {
			if (!tokens.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var nextToken = tokens.a;
				var remainingTokens = tokens.b;
				if (isToken(nextToken)) {
					return $elm$core$Maybe$Just(
						_Utils_Tuple3(
							nextToken,
							$elm$core$List$reverse(innerTokens),
							remainingTokens));
				} else {
					var $temp$innerTokens = A2($elm$core$List$cons, nextToken, innerTokens),
						$temp$isToken = isToken,
						$temp$tokens = remainingTokens;
					innerTokens = $temp$innerTokens;
					isToken = $temp$isToken;
					tokens = $temp$tokens;
					continue findTokenHelp;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$findToken = F2(
	function (isToken, tokens) {
		return A3($dillonkearns$elm_markdown$Markdown$InlineParser$findTokenHelp, _List_Nil, isToken, tokens);
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$HtmlToken = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$NotOpening = 0;
var $elm$parser$Parser$Advanced$getOffset = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.uR, s);
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$htmlToToken = F2(
	function (rawText, _v0) {
		var match = _v0;
		var consumedCharacters = A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$keeper,
					$elm$parser$Parser$Advanced$succeed(
						F3(
							function (startOffset, htmlTag, endOffset) {
								return {yx: htmlTag, uw: endOffset - startOffset};
							})),
					$elm$parser$Parser$Advanced$getOffset),
				$dillonkearns$elm_markdown$HtmlParser$html),
			$elm$parser$Parser$Advanced$getOffset);
		var parsed = A2(
			$elm$parser$Parser$Advanced$run,
			consumedCharacters,
			A2($elm$core$String$dropLeft, match.cH, rawText));
		if (!parsed.$) {
			var htmlTag = parsed.a.yx;
			var length = parsed.a.uw;
			var htmlToken = A2($dillonkearns$elm_markdown$Markdown$InlineParser$HtmlToken, 0, htmlTag);
			return $elm$core$Maybe$Just(
				{j$: match.cH, uw: length, bE: htmlToken});
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $dillonkearns$elm_markdown$Markdown$Helpers$ifError = F2(
	function (_function, result) {
		if (!result.$) {
			return result;
		} else {
			var err = result.a;
			return _function(err);
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$isCodeTokenPair = F2(
	function (closeToken, openToken) {
		var _v0 = openToken.bE;
		if (!_v0.$) {
			if (!_v0.a) {
				var _v1 = _v0.a;
				return _Utils_eq(openToken.uw - 1, closeToken.uw);
			} else {
				var _v2 = _v0.a;
				return _Utils_eq(openToken.uw, closeToken.uw);
			}
		} else {
			return false;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$isLinkTypeOrImageOpenToken = function (token) {
	var _v0 = token.bE;
	switch (_v0.$) {
		case 1:
			return true;
		case 2:
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$isOpenEmphasisToken = F2(
	function (closeToken, openToken) {
		var _v0 = openToken.bE;
		if (_v0.$ === 7) {
			var openChar = _v0.a;
			var open = _v0.b;
			var _v1 = closeToken.bE;
			if (_v1.$ === 7) {
				var closeChar = _v1.a;
				var close = _v1.b;
				return _Utils_eq(openChar, closeChar) ? ((_Utils_eq(open.rl, open.sa) || _Utils_eq(close.rl, close.sa)) ? ((!(!A2($elm$core$Basics$modBy, 3, closeToken.uw + openToken.uw))) || ((!A2($elm$core$Basics$modBy, 3, closeToken.uw)) && (!A2($elm$core$Basics$modBy, 3, openToken.uw)))) : true) : false;
			} else {
				return false;
			}
		} else {
			return false;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$isStrikethroughTokenPair = F2(
	function (closeToken, openToken) {
		var _v0 = function () {
			var _v1 = openToken.bE;
			if (_v1.$ === 9) {
				if (!_v1.a) {
					var _v2 = _v1.a;
					return _Utils_Tuple2(true, openToken.uw - 1);
				} else {
					var _v3 = _v1.a;
					return _Utils_Tuple2(true, openToken.uw);
				}
			} else {
				return _Utils_Tuple2(false, 0);
			}
		}();
		var openTokenIsStrikethrough = _v0.a;
		var openTokenLength = _v0.b;
		var _v4 = function () {
			var _v5 = closeToken.bE;
			if (_v5.$ === 9) {
				if (!_v5.a) {
					var _v6 = _v5.a;
					return _Utils_Tuple2(true, closeToken.uw - 1);
				} else {
					var _v7 = _v5.a;
					return _Utils_Tuple2(true, closeToken.uw);
				}
			} else {
				return _Utils_Tuple2(false, 0);
			}
		}();
		var closeTokenIsStrikethrough = _v4.a;
		var closeTokenLength = _v4.b;
		return closeTokenIsStrikethrough && (openTokenIsStrikethrough && _Utils_eq(closeTokenLength, openTokenLength));
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakType = {$: 1};
var $dillonkearns$elm_markdown$Markdown$InlineParser$tokenToMatch = F2(
	function (token, type_) {
		return {cw: token.j$ + token.uw, fc: _List_Nil, cH: token.j$, Gv: '', fT: 0, fh: 0, gR: type_};
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$lineBreakTTM = F2(
	function (remaining, matches) {
		lineBreakTTM:
		while (true) {
			if (!remaining.b) {
				return matches;
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v1 = token.bE;
				if (_v1.$ === 8) {
					var $temp$remaining = tokensTail,
						$temp$matches = A2(
						$elm$core$List$cons,
						A2($dillonkearns$elm_markdown$Markdown$InlineParser$tokenToMatch, token, $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakType),
						matches);
					remaining = $temp$remaining;
					matches = $temp$matches;
					continue lineBreakTTM;
				} else {
					var $temp$remaining = tokensTail,
						$temp$matches = matches;
					remaining = $temp$remaining;
					matches = $temp$matches;
					continue lineBreakTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$removeParsedAheadTokens = F2(
	function (_v0, tokensTail) {
		var match = _v0;
		return A2(
			$elm$core$List$filter,
			function (token) {
				return _Utils_cmp(token.j$, match.cw) > -1;
			},
			tokensTail);
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketsToMatch = F6(
	function (closeToken, escaped, matches, references, rawText, _v44) {
		var openToken = _v44.a;
		var remainTokens = _v44.c;
		var result = A2(
			$dillonkearns$elm_markdown$Markdown$Helpers$ifError,
			$dillonkearns$elm_markdown$Markdown$InlineParser$emailAutolinkTypeToMatch,
			$dillonkearns$elm_markdown$Markdown$InlineParser$autolinkToMatch(
				A7(
					$dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch,
					references,
					rawText,
					function (s) {
						return s;
					},
					$dillonkearns$elm_markdown$Markdown$InlineParser$CodeType,
					openToken,
					closeToken,
					_List_Nil)));
		if (result.$ === 1) {
			var tempMatch = result.a;
			if (escaped === 1) {
				var _v47 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$htmlToToken, rawText, tempMatch);
				if (!_v47.$) {
					var newToken = _v47.a;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							A2($elm$core$List$cons, newToken, remainTokens),
							matches));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			var newMatch = result.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					remainTokens,
					A2($elm$core$List$cons, newMatch, matches)));
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$codeAutolinkTypeHtmlTagTTM = F5(
	function (remaining, tokens, matches, references, rawText) {
		codeAutolinkTypeHtmlTagTTM:
		while (true) {
			if (!remaining.b) {
				return A5(
					$dillonkearns$elm_markdown$Markdown$InlineParser$htmlElementTTM,
					$elm$core$List$reverse(tokens),
					_List_Nil,
					matches,
					references,
					rawText);
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v36 = token.bE;
				switch (_v36.$) {
					case 0:
						var _v37 = A2(
							$dillonkearns$elm_markdown$Markdown$InlineParser$findToken,
							$dillonkearns$elm_markdown$Markdown$InlineParser$isCodeTokenPair(token),
							tokens);
						if (!_v37.$) {
							var code = _v37.a;
							var _v38 = A5($dillonkearns$elm_markdown$Markdown$InlineParser$codeToMatch, token, matches, references, rawText, code);
							var newTokens = _v38.a;
							var newMatches = _v38.b;
							var $temp$remaining = tokensTail,
								$temp$tokens = newTokens,
								$temp$matches = newMatches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue codeAutolinkTypeHtmlTagTTM;
						} else {
							var $temp$remaining = tokensTail,
								$temp$tokens = A2($elm$core$List$cons, token, tokens),
								$temp$matches = matches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue codeAutolinkTypeHtmlTagTTM;
						}
					case 5:
						var isEscaped = _v36.a;
						var isAngleBracketOpen = function (_v43) {
							var meaning = _v43.bE;
							if (meaning.$ === 4) {
								return true;
							} else {
								return false;
							}
						};
						var _v39 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$findToken, isAngleBracketOpen, tokens);
						if (!_v39.$) {
							var found = _v39.a;
							var _v40 = A6($dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketsToMatch, token, isEscaped, matches, references, rawText, found);
							if (!_v40.$) {
								var _v41 = _v40.a;
								var newTokens = _v41.a;
								var newMatches = _v41.b;
								var $temp$remaining = tokensTail,
									$temp$tokens = A2(
									$elm$core$List$filter,
									A2($elm$core$Basics$composeL, $elm$core$Basics$not, isAngleBracketOpen),
									newTokens),
									$temp$matches = newMatches,
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue codeAutolinkTypeHtmlTagTTM;
							} else {
								var $temp$remaining = tokensTail,
									$temp$tokens = A2(
									$elm$core$List$filter,
									A2($elm$core$Basics$composeL, $elm$core$Basics$not, isAngleBracketOpen),
									tokens),
									$temp$matches = matches,
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue codeAutolinkTypeHtmlTagTTM;
							}
						} else {
							var $temp$remaining = tokensTail,
								$temp$tokens = A2(
								$elm$core$List$filter,
								A2($elm$core$Basics$composeL, $elm$core$Basics$not, isAngleBracketOpen),
								tokens),
								$temp$matches = matches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue codeAutolinkTypeHtmlTagTTM;
						}
					default:
						var $temp$remaining = tokensTail,
							$temp$tokens = A2($elm$core$List$cons, token, tokens),
							$temp$matches = matches,
							$temp$references = references,
							$temp$rawText = rawText;
						remaining = $temp$remaining;
						tokens = $temp$tokens;
						matches = $temp$matches;
						references = $temp$references;
						rawText = $temp$rawText;
						continue codeAutolinkTypeHtmlTagTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$codeToMatch = F5(
	function (closeToken, matches, references, rawText, _v32) {
		var openToken = _v32.a;
		var remainTokens = _v32.c;
		var updatedOpenToken = function () {
			var _v33 = openToken.bE;
			if ((!_v33.$) && (!_v33.a)) {
				var _v34 = _v33.a;
				return _Utils_update(
					openToken,
					{j$: openToken.j$ + 1, uw: openToken.uw - 1});
			} else {
				return openToken;
			}
		}();
		var match = A7($dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch, references, rawText, $dillonkearns$elm_markdown$Markdown$Helpers$cleanWhitespaces, $dillonkearns$elm_markdown$Markdown$InlineParser$CodeType, updatedOpenToken, closeToken, _List_Nil);
		return _Utils_Tuple2(
			remainTokens,
			A2($elm$core$List$cons, match, matches));
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$emphasisTTM = F5(
	function (remaining, tokens, matches, references, rawText) {
		emphasisTTM:
		while (true) {
			if (!remaining.b) {
				return A5(
					$dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughTTM,
					$elm$core$List$reverse(tokens),
					_List_Nil,
					matches,
					references,
					rawText);
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v27 = token.bE;
				if (_v27.$ === 7) {
					var _char = _v27.a;
					var leftFringeRank = _v27.b.rl;
					var rightFringeRank = _v27.b.sa;
					if (_Utils_eq(leftFringeRank, rightFringeRank)) {
						if ((!(!rightFringeRank)) && ((_char !== '_') || (rightFringeRank === 1))) {
							var _v28 = A2(
								$dillonkearns$elm_markdown$Markdown$InlineParser$findToken,
								$dillonkearns$elm_markdown$Markdown$InlineParser$isOpenEmphasisToken(token),
								tokens);
							if (!_v28.$) {
								var found = _v28.a;
								var _v29 = A5($dillonkearns$elm_markdown$Markdown$InlineParser$emphasisToMatch, references, rawText, token, tokensTail, found);
								var newRemaining = _v29.a;
								var match = _v29.b;
								var newTokens = _v29.c;
								var $temp$remaining = newRemaining,
									$temp$tokens = newTokens,
									$temp$matches = A2($elm$core$List$cons, match, matches),
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue emphasisTTM;
							} else {
								var $temp$remaining = tokensTail,
									$temp$tokens = A2($elm$core$List$cons, token, tokens),
									$temp$matches = matches,
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue emphasisTTM;
							}
						} else {
							var $temp$remaining = tokensTail,
								$temp$tokens = tokens,
								$temp$matches = matches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue emphasisTTM;
						}
					} else {
						if (_Utils_cmp(leftFringeRank, rightFringeRank) < 0) {
							var $temp$remaining = tokensTail,
								$temp$tokens = A2($elm$core$List$cons, token, tokens),
								$temp$matches = matches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue emphasisTTM;
						} else {
							var _v30 = A2(
								$dillonkearns$elm_markdown$Markdown$InlineParser$findToken,
								$dillonkearns$elm_markdown$Markdown$InlineParser$isOpenEmphasisToken(token),
								tokens);
							if (!_v30.$) {
								var found = _v30.a;
								var _v31 = A5($dillonkearns$elm_markdown$Markdown$InlineParser$emphasisToMatch, references, rawText, token, tokensTail, found);
								var newRemaining = _v31.a;
								var match = _v31.b;
								var newTokens = _v31.c;
								var $temp$remaining = newRemaining,
									$temp$tokens = newTokens,
									$temp$matches = A2($elm$core$List$cons, match, matches),
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue emphasisTTM;
							} else {
								var $temp$remaining = tokensTail,
									$temp$tokens = tokens,
									$temp$matches = matches,
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue emphasisTTM;
							}
						}
					}
				} else {
					var $temp$remaining = tokensTail,
						$temp$tokens = A2($elm$core$List$cons, token, tokens),
						$temp$matches = matches,
						$temp$references = references,
						$temp$rawText = rawText;
					remaining = $temp$remaining;
					tokens = $temp$tokens;
					matches = $temp$matches;
					references = $temp$references;
					rawText = $temp$rawText;
					continue emphasisTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$emphasisToMatch = F5(
	function (references, rawText, closeToken, tokensTail, _v25) {
		var openToken = _v25.a;
		var innerTokens = _v25.b;
		var remainTokens = _v25.c;
		var remainLength = openToken.uw - closeToken.uw;
		var updt = (!remainLength) ? {qC: closeToken, pc: openToken, r3: remainTokens, sD: tokensTail} : ((remainLength > 0) ? {
			qC: closeToken,
			pc: _Utils_update(
				openToken,
				{j$: openToken.j$ + remainLength, uw: closeToken.uw}),
			r3: A2(
				$elm$core$List$cons,
				_Utils_update(
					openToken,
					{uw: remainLength}),
				remainTokens),
			sD: tokensTail
		} : {
			qC: _Utils_update(
				closeToken,
				{uw: openToken.uw}),
			pc: openToken,
			r3: remainTokens,
			sD: A2(
				$elm$core$List$cons,
				_Utils_update(
					closeToken,
					{j$: closeToken.j$ + openToken.uw, uw: -remainLength}),
				tokensTail)
		});
		var match = A7(
			$dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch,
			references,
			rawText,
			function (s) {
				return s;
			},
			$dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisType(updt.pc.uw),
			updt.pc,
			updt.qC,
			$elm$core$List$reverse(innerTokens));
		return _Utils_Tuple3(updt.sD, match, updt.r3);
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$htmlElementTTM = F5(
	function (remaining, tokens, matches, references, rawText) {
		htmlElementTTM:
		while (true) {
			if (!remaining.b) {
				return A5(
					$dillonkearns$elm_markdown$Markdown$InlineParser$linkImageTypeTTM,
					$elm$core$List$reverse(tokens),
					_List_Nil,
					matches,
					references,
					rawText);
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v23 = token.bE;
				if (_v23.$ === 6) {
					var isOpen = _v23.a;
					var htmlModel = _v23.b;
					var $temp$remaining = tokensTail,
						$temp$tokens = tokens,
						$temp$matches = A2(
						$elm$core$List$cons,
						A2(
							$dillonkearns$elm_markdown$Markdown$InlineParser$tokenToMatch,
							token,
							$dillonkearns$elm_markdown$Markdown$InlineParser$HtmlType(htmlModel)),
						matches),
						$temp$references = references,
						$temp$rawText = rawText;
					remaining = $temp$remaining;
					tokens = $temp$tokens;
					matches = $temp$matches;
					references = $temp$references;
					rawText = $temp$rawText;
					continue htmlElementTTM;
				} else {
					var $temp$remaining = tokensTail,
						$temp$tokens = A2($elm$core$List$cons, token, tokens),
						$temp$matches = matches,
						$temp$references = references,
						$temp$rawText = rawText;
					remaining = $temp$remaining;
					tokens = $temp$tokens;
					matches = $temp$matches;
					references = $temp$references;
					rawText = $temp$rawText;
					continue htmlElementTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageTypeTTM = F5(
	function (remaining, tokens, matches, references, rawText) {
		linkImageTypeTTM:
		while (true) {
			if (!remaining.b) {
				return A5(
					$dillonkearns$elm_markdown$Markdown$InlineParser$emphasisTTM,
					$elm$core$List$reverse(tokens),
					_List_Nil,
					matches,
					references,
					rawText);
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v18 = token.bE;
				if (_v18.$ === 3) {
					var _v19 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$findToken, $dillonkearns$elm_markdown$Markdown$InlineParser$isLinkTypeOrImageOpenToken, tokens);
					if (!_v19.$) {
						var found = _v19.a;
						var _v20 = A6($dillonkearns$elm_markdown$Markdown$InlineParser$linkOrImageTypeToMatch, token, tokensTail, matches, references, rawText, found);
						if (!_v20.$) {
							var _v21 = _v20.a;
							var x = _v21.a;
							var newMatches = _v21.b;
							var newTokens = _v21.c;
							var $temp$remaining = x,
								$temp$tokens = newTokens,
								$temp$matches = newMatches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue linkImageTypeTTM;
						} else {
							var $temp$remaining = tokensTail,
								$temp$tokens = tokens,
								$temp$matches = matches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue linkImageTypeTTM;
						}
					} else {
						var $temp$remaining = tokensTail,
							$temp$tokens = tokens,
							$temp$matches = matches,
							$temp$references = references,
							$temp$rawText = rawText;
						remaining = $temp$remaining;
						tokens = $temp$tokens;
						matches = $temp$matches;
						references = $temp$references;
						rawText = $temp$rawText;
						continue linkImageTypeTTM;
					}
				} else {
					var $temp$remaining = tokensTail,
						$temp$tokens = A2($elm$core$List$cons, token, tokens),
						$temp$matches = matches,
						$temp$references = references,
						$temp$rawText = rawText;
					remaining = $temp$remaining;
					tokens = $temp$tokens;
					matches = $temp$matches;
					references = $temp$references;
					rawText = $temp$rawText;
					continue linkImageTypeTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$linkOrImageTypeToMatch = F6(
	function (closeToken, tokensTail, oldMatches, references, rawText, _v8) {
		var openToken = _v8.a;
		var innerTokens = _v8.b;
		var remainTokens = _v8.c;
		var removeOpenToken = _Utils_Tuple3(
			tokensTail,
			oldMatches,
			_Utils_ap(innerTokens, remainTokens));
		var remainText = A2($elm$core$String$dropLeft, closeToken.j$ + 1, rawText);
		var inactivateLinkOpenToken = function (token) {
			var _v16 = token.bE;
			if (_v16.$ === 1) {
				return _Utils_update(
					token,
					{
						bE: $dillonkearns$elm_markdown$Markdown$InlineParser$LinkOpenToken(1)
					});
			} else {
				return token;
			}
		};
		var findTempMatch = function (isLinkType) {
			return A7(
				$dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch,
				references,
				rawText,
				function (s) {
					return s;
				},
				isLinkType ? $dillonkearns$elm_markdown$Markdown$InlineParser$LinkType(
					_Utils_Tuple2('', $elm$core$Maybe$Nothing)) : $dillonkearns$elm_markdown$Markdown$InlineParser$ImageType(
					_Utils_Tuple2('', $elm$core$Maybe$Nothing)),
				openToken,
				closeToken,
				$elm$core$List$reverse(innerTokens));
		};
		var _v9 = openToken.bE;
		switch (_v9.$) {
			case 2:
				var tempMatch = findTempMatch(false);
				var _v10 = A3($dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineLinkTypeOrImageType, remainText, tempMatch, references);
				if (_v10.$ === 1) {
					return $elm$core$Maybe$Just(removeOpenToken);
				} else {
					var match = _v10.a;
					var _v11 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$checkParsedAheadOverlapping, match, oldMatches);
					if (!_v11.$) {
						var matches = _v11.a;
						return $elm$core$Maybe$Just(
							_Utils_Tuple3(
								A2($dillonkearns$elm_markdown$Markdown$InlineParser$removeParsedAheadTokens, match, tokensTail),
								matches,
								remainTokens));
					} else {
						return $elm$core$Maybe$Just(removeOpenToken);
					}
				}
			case 1:
				if (!_v9.a) {
					var _v12 = _v9.a;
					var tempMatch = findTempMatch(true);
					var _v13 = A3($dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineLinkTypeOrImageType, remainText, tempMatch, references);
					if (_v13.$ === 1) {
						return $elm$core$Maybe$Just(removeOpenToken);
					} else {
						var match = _v13.a;
						var _v14 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$checkParsedAheadOverlapping, match, oldMatches);
						if (!_v14.$) {
							var matches = _v14.a;
							return $elm$core$Maybe$Just(
								_Utils_Tuple3(
									A2($dillonkearns$elm_markdown$Markdown$InlineParser$removeParsedAheadTokens, match, tokensTail),
									matches,
									A2($elm$core$List$map, inactivateLinkOpenToken, remainTokens)));
						} else {
							return $elm$core$Maybe$Just(removeOpenToken);
						}
					}
				} else {
					var _v15 = _v9.a;
					return $elm$core$Maybe$Just(removeOpenToken);
				}
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughTTM = F5(
	function (remaining, tokens, matches, references, rawText) {
		strikethroughTTM:
		while (true) {
			if (!remaining.b) {
				return A2(
					$dillonkearns$elm_markdown$Markdown$InlineParser$lineBreakTTM,
					$elm$core$List$reverse(tokens),
					matches);
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v5 = token.bE;
				if (_v5.$ === 9) {
					var _v6 = A2(
						$dillonkearns$elm_markdown$Markdown$InlineParser$findToken,
						$dillonkearns$elm_markdown$Markdown$InlineParser$isStrikethroughTokenPair(token),
						tokens);
					if (!_v6.$) {
						var content = _v6.a;
						var _v7 = A5($dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughToMatch, token, matches, references, rawText, content);
						var newTokens = _v7.a;
						var newMatches = _v7.b;
						var $temp$remaining = tokensTail,
							$temp$tokens = newTokens,
							$temp$matches = newMatches,
							$temp$references = references,
							$temp$rawText = rawText;
						remaining = $temp$remaining;
						tokens = $temp$tokens;
						matches = $temp$matches;
						references = $temp$references;
						rawText = $temp$rawText;
						continue strikethroughTTM;
					} else {
						var $temp$remaining = tokensTail,
							$temp$tokens = A2($elm$core$List$cons, token, tokens),
							$temp$matches = matches,
							$temp$references = references,
							$temp$rawText = rawText;
						remaining = $temp$remaining;
						tokens = $temp$tokens;
						matches = $temp$matches;
						references = $temp$references;
						rawText = $temp$rawText;
						continue strikethroughTTM;
					}
				} else {
					var $temp$remaining = tokensTail,
						$temp$tokens = A2($elm$core$List$cons, token, tokens),
						$temp$matches = matches,
						$temp$references = references,
						$temp$rawText = rawText;
					remaining = $temp$remaining;
					tokens = $temp$tokens;
					matches = $temp$matches;
					references = $temp$references;
					rawText = $temp$rawText;
					continue strikethroughTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughToMatch = F5(
	function (closeToken, matches, references, rawText, _v1) {
		var openToken = _v1.a;
		var remainTokens = _v1.c;
		var updatedOpenToken = function () {
			var _v2 = openToken.bE;
			if ((_v2.$ === 9) && (!_v2.a)) {
				var _v3 = _v2.a;
				return _Utils_update(
					openToken,
					{j$: openToken.j$ + 1, uw: openToken.uw - 1});
			} else {
				return openToken;
			}
		}();
		var match = A7($dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch, references, rawText, $dillonkearns$elm_markdown$Markdown$Helpers$cleanWhitespaces, $dillonkearns$elm_markdown$Markdown$InlineParser$StrikethroughType, updatedOpenToken, closeToken, _List_Nil);
		return _Utils_Tuple2(
			remainTokens,
			A2($elm$core$List$cons, match, matches));
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch = F7(
	function (references, rawText, processText, type_, openToken, closeToken, innerTokens) {
		var textStart = openToken.j$ + openToken.uw;
		var textEnd = closeToken.j$;
		var text = processText(
			A3($elm$core$String$slice, textStart, textEnd, rawText));
		var start = openToken.j$;
		var end = closeToken.j$ + closeToken.uw;
		var match = {cw: end, fc: _List_Nil, cH: start, Gv: text, fT: textEnd, fh: textStart, gR: type_};
		var matches = A2(
			$elm$core$List$map,
			function (_v0) {
				var matchModel = _v0;
				return A2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareChildMatch, match, matchModel);
			},
			A4($dillonkearns$elm_markdown$Markdown$InlineParser$tokensToMatches, innerTokens, _List_Nil, references, rawText));
		return {cw: end, fc: matches, cH: start, Gv: text, fT: textEnd, fh: textStart, gR: type_};
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$tokensToMatches = F4(
	function (tokens, matches, references, rawText) {
		return A5($dillonkearns$elm_markdown$Markdown$InlineParser$codeAutolinkTypeHtmlTagTTM, tokens, _List_Nil, matches, references, rawText);
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$parse = F2(
	function (refs, rawText_) {
		var rawText = $elm$core$String$trim(rawText_);
		var tokens = $dillonkearns$elm_markdown$Markdown$InlineParser$tokenize(rawText);
		return $dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(
			A3(
				$dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatches,
				rawText,
				_List_Nil,
				$dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatches(
					A4($dillonkearns$elm_markdown$Markdown$InlineParser$tokensToMatches, tokens, _List_Nil, refs, rawText))));
	});
var $dillonkearns$elm_markdown$Markdown$Parser$thisIsDefinitelyNotAnHtmlTag = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			$elm$parser$Parser$Advanced$token(
			A2(
				$elm$parser$Parser$Advanced$Token,
				' ',
				$elm$parser$Parser$Expecting(' '))),
			$elm$parser$Parser$Advanced$token(
			A2(
				$elm$parser$Parser$Advanced$Token,
				'>',
				$elm$parser$Parser$Expecting('>'))),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$chompIf,
					$elm$core$Char$isAlpha,
					$elm$parser$Parser$Expecting('Alpha')),
				$elm$parser$Parser$Advanced$chompWhile(
					function (c) {
						return $elm$core$Char$isAlphaNum(c) || (c === '-');
					})),
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							':',
							$elm$parser$Parser$Expecting(':'))),
						$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'@',
							$elm$parser$Parser$Expecting('@'))),
						$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'\\',
							$elm$parser$Parser$Expecting('\\'))),
						$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'+',
							$elm$parser$Parser$Expecting('+'))),
						$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'.',
							$elm$parser$Parser$Expecting('.')))
					])))
		]));
var $dillonkearns$elm_markdown$Markdown$Parser$parseAsParagraphInsteadOfHtmlBlock = $elm$parser$Parser$Advanced$backtrackable(
	A2(
		$elm$parser$Parser$Advanced$mapChompedString,
		F2(
			function (rawLine, _v0) {
				return $dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(rawLine);
			}),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'<',
							$elm$parser$Parser$Expecting('<'))),
					$dillonkearns$elm_markdown$Markdown$Parser$thisIsDefinitelyNotAnHtmlTag),
				$dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
			$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)));
var $dillonkearns$elm_markdown$Markdown$Table$TableHeader = $elm$core$Basics$identity;
var $dillonkearns$elm_markdown$Parser$Token$parseString = function (str) {
	return $elm$parser$Parser$Advanced$token(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$Expecting(str)));
};
var $dillonkearns$elm_markdown$Markdown$TableParser$parseCellHelper = function (_v0) {
	var curr = _v0.a;
	var acc = _v0.b;
	var _return = A2(
		$elm$core$Maybe$withDefault,
		$elm$parser$Parser$Advanced$Done(acc),
		A2(
			$elm$core$Maybe$map,
			function (cell) {
				return $elm$parser$Parser$Advanced$Done(
					A2($elm$core$List$cons, cell, acc));
			},
			curr));
	var finishCell = A2(
		$elm$core$Maybe$withDefault,
		$elm$parser$Parser$Advanced$Loop(
			_Utils_Tuple2($elm$core$Maybe$Nothing, acc)),
		A2(
			$elm$core$Maybe$map,
			function (cell) {
				return $elm$parser$Parser$Advanced$Loop(
					_Utils_Tuple2(
						$elm$core$Maybe$Nothing,
						A2($elm$core$List$cons, cell, acc)));
			},
			curr));
	var addToCurrent = function (c) {
		return _Utils_ap(
			A2($elm$core$Maybe$withDefault, '', curr),
			c);
	};
	var continueCell = function (c) {
		return $elm$parser$Parser$Advanced$Loop(
			_Utils_Tuple2(
				$elm$core$Maybe$Just(
					addToCurrent(c)),
				acc));
	};
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v1) {
					return _return;
				},
				$dillonkearns$elm_markdown$Parser$Token$parseString('|\n')),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v2) {
					return _return;
				},
				$dillonkearns$elm_markdown$Parser$Token$parseString('\n')),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v3) {
					return _return;
				},
				$elm$parser$Parser$Advanced$end(
					$elm$parser$Parser$Expecting('end'))),
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$backtrackable(
					$elm$parser$Parser$Advanced$succeed(
						continueCell('|'))),
				$dillonkearns$elm_markdown$Parser$Token$parseString('\\\\|')),
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$backtrackable(
					$elm$parser$Parser$Advanced$succeed(
						continueCell('\\'))),
				$dillonkearns$elm_markdown$Parser$Token$parseString('\\\\')),
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$backtrackable(
					$elm$parser$Parser$Advanced$succeed(
						continueCell('|'))),
				$dillonkearns$elm_markdown$Parser$Token$parseString('\\|')),
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$backtrackable(
					$elm$parser$Parser$Advanced$succeed(finishCell)),
				$dillonkearns$elm_markdown$Parser$Token$parseString('|')),
				A2(
				$elm$parser$Parser$Advanced$mapChompedString,
				F2(
					function (_char, _v4) {
						return continueCell(_char);
					}),
				A2(
					$elm$parser$Parser$Advanced$chompIf,
					$elm$core$Basics$always(true),
					$elm$parser$Parser$Problem('No character found')))
			]));
};
var $dillonkearns$elm_markdown$Markdown$TableParser$parseCells = A2(
	$elm$parser$Parser$Advanced$map,
	A2(
		$elm$core$List$foldl,
		F2(
			function (cell, acc) {
				return A2(
					$elm$core$List$cons,
					$elm$core$String$trim(cell),
					acc);
			}),
		_List_Nil),
	A2(
		$elm$parser$Parser$Advanced$loop,
		_Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil),
		$dillonkearns$elm_markdown$Markdown$TableParser$parseCellHelper));
var $dillonkearns$elm_markdown$Markdown$TableParser$rowParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					$dillonkearns$elm_markdown$Parser$Token$parseString('|'),
					$elm$parser$Parser$Advanced$succeed(0)
				]))),
	$dillonkearns$elm_markdown$Markdown$TableParser$parseCells);
var $dillonkearns$elm_markdown$Markdown$TableParser$parseHeader = F2(
	function (_v0, headersRow) {
		var columnAlignments = _v0.b;
		var headersWithAlignment = function (headers) {
			return A3(
				$elm$core$List$map2,
				F2(
					function (headerCell, alignment) {
						return {qe: alignment, b2: headerCell};
					}),
				headers,
				columnAlignments);
		};
		var combineHeaderAndDelimiter = function (headers) {
			return _Utils_eq(
				$elm$core$List$length(headers),
				$elm$core$List$length(columnAlignments)) ? $elm$core$Result$Ok(
				headersWithAlignment(headers)) : $elm$core$Result$Err(
				'Tables must have the same number of header columns (' + ($elm$core$String$fromInt(
					$elm$core$List$length(headers)) + (') as delimiter columns (' + ($elm$core$String$fromInt(
					$elm$core$List$length(columnAlignments)) + ')'))));
		};
		var _v1 = A2($elm$parser$Parser$Advanced$run, $dillonkearns$elm_markdown$Markdown$TableParser$rowParser, headersRow);
		if (!_v1.$) {
			var headers = _v1.a;
			return combineHeaderAndDelimiter(headers);
		} else {
			return $elm$core$Result$Err('Unable to parse previous line as a table header');
		}
	});
var $dillonkearns$elm_markdown$Markdown$CodeBlock$CodeBlock = F2(
	function (language, body) {
		return {sY: body, aC: language};
	});
var $dillonkearns$elm_markdown$Markdown$CodeBlock$infoString = function (fenceCharacter) {
	var toInfoString = F2(
		function (str, _v2) {
			var _v1 = $elm$core$String$trim(str);
			if (_v1 === '') {
				return $elm$core$Maybe$Nothing;
			} else {
				var trimmed = _v1;
				return $elm$core$Maybe$Just(trimmed);
			}
		});
	var _v0 = fenceCharacter.mp;
	if (!_v0) {
		return A2(
			$elm$parser$Parser$Advanced$mapChompedString,
			toInfoString,
			$elm$parser$Parser$Advanced$chompWhile(
				function (c) {
					return (c !== '`') && (!$dillonkearns$elm_markdown$Whitespace$isLineEnd(c));
				}));
	} else {
		return A2(
			$elm$parser$Parser$Advanced$mapChompedString,
			toInfoString,
			$elm$parser$Parser$Advanced$chompWhile(
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, $dillonkearns$elm_markdown$Whitespace$isLineEnd)));
	}
};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$Backtick = 0;
var $dillonkearns$elm_markdown$Parser$Token$backtick = A2(
	$elm$parser$Parser$Advanced$Token,
	'`',
	$elm$parser$Parser$Expecting('a \'`\''));
var $dillonkearns$elm_markdown$Markdown$CodeBlock$backtick = {qz: '`', mp: 0, GI: $dillonkearns$elm_markdown$Parser$Token$backtick};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$colToIndentation = function (_int) {
	switch (_int) {
		case 1:
			return $elm$parser$Parser$Advanced$succeed(0);
		case 2:
			return $elm$parser$Parser$Advanced$succeed(1);
		case 3:
			return $elm$parser$Parser$Advanced$succeed(2);
		case 4:
			return $elm$parser$Parser$Advanced$succeed(3);
		default:
			return $elm$parser$Parser$Advanced$problem(
				$elm$parser$Parser$Expecting('Fenced code blocks should be indented no more than 3 spaces'));
	}
};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$fenceOfAtLeast = F2(
	function (minLength, fenceCharacter) {
		var builtTokens = A3(
			$elm$core$List$foldl,
			F2(
				function (t, p) {
					return A2($elm$parser$Parser$Advanced$ignorer, p, t);
				}),
			$elm$parser$Parser$Advanced$succeed(0),
			A2(
				$elm$core$List$repeat,
				minLength,
				$elm$parser$Parser$Advanced$token(fenceCharacter.GI)));
		return A2(
			$elm$parser$Parser$Advanced$mapChompedString,
			F2(
				function (str, _v0) {
					return _Utils_Tuple2(
						fenceCharacter,
						$elm$core$String$length(str));
				}),
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				builtTokens,
				$elm$parser$Parser$Advanced$chompWhile(
					$elm$core$Basics$eq(fenceCharacter.qz))));
	});
var $dillonkearns$elm_markdown$Markdown$CodeBlock$Tilde = 1;
var $dillonkearns$elm_markdown$Parser$Token$tilde = A2(
	$elm$parser$Parser$Advanced$Token,
	'~',
	$elm$parser$Parser$Expecting('a `~`'));
var $dillonkearns$elm_markdown$Markdown$CodeBlock$tilde = {qz: '~', mp: 1, GI: $dillonkearns$elm_markdown$Parser$Token$tilde};
var $dillonkearns$elm_markdown$Whitespace$upToThreeSpaces = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$dillonkearns$elm_markdown$Whitespace$space,
				$elm$parser$Parser$Advanced$oneOf(
					_List_fromArray(
						[
							$dillonkearns$elm_markdown$Whitespace$space,
							$elm$parser$Parser$Advanced$succeed(0)
						]))),
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						$dillonkearns$elm_markdown$Whitespace$space,
						$elm$parser$Parser$Advanced$succeed(0)
					]))),
			$elm$parser$Parser$Advanced$succeed(0)
		]));
var $dillonkearns$elm_markdown$Markdown$CodeBlock$openingFence = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(
				F2(
					function (indent, _v0) {
						var character = _v0.a;
						var length = _v0.b;
						return {qA: character, ue: indent, uw: length};
					})),
			$dillonkearns$elm_markdown$Whitespace$upToThreeSpaces),
		A2($elm$parser$Parser$Advanced$andThen, $dillonkearns$elm_markdown$Markdown$CodeBlock$colToIndentation, $elm$parser$Parser$Advanced$getCol)),
	$elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2($dillonkearns$elm_markdown$Markdown$CodeBlock$fenceOfAtLeast, 3, $dillonkearns$elm_markdown$Markdown$CodeBlock$backtick),
				A2($dillonkearns$elm_markdown$Markdown$CodeBlock$fenceOfAtLeast, 3, $dillonkearns$elm_markdown$Markdown$CodeBlock$tilde)
			])));
var $dillonkearns$elm_markdown$Whitespace$isSpace = $elm$core$Basics$eq(' ');
var $dillonkearns$elm_markdown$Markdown$CodeBlock$closingFence = F2(
	function (minLength, fenceCharacter) {
		return A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed(0),
						$dillonkearns$elm_markdown$Whitespace$upToThreeSpaces),
					A2($dillonkearns$elm_markdown$Markdown$CodeBlock$fenceOfAtLeast, minLength, fenceCharacter)),
				$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpace)),
			$dillonkearns$elm_markdown$Helpers$lineEndOrEnd);
	});
var $dillonkearns$elm_markdown$Markdown$CodeBlock$codeBlockLine = function (indented) {
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
			A2($dillonkearns$elm_markdown$Parser$Extra$upTo, indented, $dillonkearns$elm_markdown$Whitespace$space)),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2($elm$parser$Parser$Advanced$ignorer, $elm$parser$Parser$Advanced$getOffset, $dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
			$dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
};
var $elm$parser$Parser$Advanced$getSource = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.fG, s);
};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$remainingBlockHelp = function (_v0) {
	var fence = _v0.a;
	var body = _v0.b;
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed(
					$elm$parser$Parser$Advanced$Done(body)),
				$elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd)),
				A2(
				$elm$parser$Parser$Advanced$mapChompedString,
				F2(
					function (lineEnd, _v1) {
						return $elm$parser$Parser$Advanced$Loop(
							_Utils_Tuple2(
								fence,
								_Utils_ap(body, lineEnd)));
					}),
				$dillonkearns$elm_markdown$Whitespace$lineEnd),
				$elm$parser$Parser$Advanced$backtrackable(
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed(
						$elm$parser$Parser$Advanced$Done(body)),
					A2($dillonkearns$elm_markdown$Markdown$CodeBlock$closingFence, fence.uw, fence.qA))),
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$keeper,
					A2(
						$elm$parser$Parser$Advanced$keeper,
						$elm$parser$Parser$Advanced$succeed(
							F3(
								function (start, end, source) {
									return $elm$parser$Parser$Advanced$Loop(
										_Utils_Tuple2(
											fence,
											_Utils_ap(
												body,
												A3($elm$core$String$slice, start, end, source))));
								})),
						$dillonkearns$elm_markdown$Markdown$CodeBlock$codeBlockLine(fence.ue)),
					$elm$parser$Parser$Advanced$getOffset),
				$elm$parser$Parser$Advanced$getSource)
			]));
};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$remainingBlock = function (fence) {
	return A2(
		$elm$parser$Parser$Advanced$loop,
		_Utils_Tuple2(fence, ''),
		$dillonkearns$elm_markdown$Markdown$CodeBlock$remainingBlockHelp);
};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$parser = A2(
	$elm$parser$Parser$Advanced$andThen,
	function (fence) {
		return A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$keeper,
				$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$CodeBlock$CodeBlock),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$dillonkearns$elm_markdown$Markdown$CodeBlock$infoString(fence.qA),
					$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)),
			$dillonkearns$elm_markdown$Markdown$CodeBlock$remainingBlock(fence));
	},
	$dillonkearns$elm_markdown$Markdown$CodeBlock$openingFence);
var $dillonkearns$elm_markdown$Markdown$Heading$dropTrailingHashes = function (headingString) {
	dropTrailingHashes:
	while (true) {
		if (A2($elm$core$String$endsWith, '#', headingString)) {
			var $temp$headingString = A2($elm$core$String$dropRight, 1, headingString);
			headingString = $temp$headingString;
			continue dropTrailingHashes;
		} else {
			return headingString;
		}
	}
};
var $elm$core$String$trimRight = _String_trimRight;
var $dillonkearns$elm_markdown$Markdown$Heading$dropClosingSequence = function (headingString) {
	var droppedTrailingHashesString = $dillonkearns$elm_markdown$Markdown$Heading$dropTrailingHashes(headingString);
	return (A2($elm$core$String$endsWith, ' ', droppedTrailingHashesString) || $elm$core$String$isEmpty(droppedTrailingHashesString)) ? $elm$core$String$trimRight(droppedTrailingHashesString) : headingString;
};
var $dillonkearns$elm_markdown$Parser$Token$hash = A2(
	$elm$parser$Parser$Advanced$Token,
	'#',
	$elm$parser$Parser$Expecting('a `#`'));
var $dillonkearns$elm_markdown$Markdown$Heading$isHash = function (c) {
	if ('#' === c) {
		return true;
	} else {
		return false;
	}
};
var $elm$parser$Parser$Advanced$spaces = $elm$parser$Parser$Advanced$chompWhile(
	function (c) {
		return (c === ' ') || ((c === '\n') || (c === '\r'));
	});
var $dillonkearns$elm_markdown$Markdown$Heading$parser = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$Heading),
				A2(
					$elm$parser$Parser$Advanced$andThen,
					function (startingSpaces) {
						var startSpace = $elm$core$String$length(startingSpaces);
						return (startSpace >= 4) ? $elm$parser$Parser$Advanced$problem(
							$elm$parser$Parser$Expecting('heading with < 4 spaces in front')) : $elm$parser$Parser$Advanced$succeed(startSpace);
					},
					$elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$spaces))),
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$hash)),
		A2(
			$elm$parser$Parser$Advanced$andThen,
			function (additionalHashes) {
				var level = $elm$core$String$length(additionalHashes) + 1;
				return (level >= 7) ? $elm$parser$Parser$Advanced$problem(
					$elm$parser$Parser$Expecting('heading with < 7 #\'s')) : $elm$parser$Parser$Advanced$succeed(level);
			},
			$elm$parser$Parser$Advanced$getChompedString(
				$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Markdown$Heading$isHash)))),
	$elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed(''),
				$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$newline)),
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$Advanced$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$space),
								$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$tab)
							]))),
				A2(
					$elm$parser$Parser$Advanced$mapChompedString,
					F2(
						function (headingText, _v0) {
							return $dillonkearns$elm_markdown$Markdown$Heading$dropClosingSequence(
								$elm$core$String$trim(headingText));
						}),
					$dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd))
			])));
var $elm$parser$Parser$Advanced$findSubString = _Parser_findSubString;
var $elm$parser$Parser$Advanced$chompUntil = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$findSubString, str, s.uR, s.hP, s.xG, s.fG);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A4($elm$parser$Parser$Advanced$fromInfo, newRow, newCol, expecting, s.bL)) : A3(
			$elm$parser$Parser$Advanced$Good,
			_Utils_cmp(s.uR, newOffset) < 0,
			0,
			{xG: newCol, bL: s.bL, cy: s.cy, uR: newOffset, hP: newRow, fG: s.fG});
	};
};
var $dillonkearns$elm_markdown$Parser$Token$greaterThan = A2(
	$elm$parser$Parser$Advanced$Token,
	'>',
	$elm$parser$Parser$Expecting('a `>`'));
var $elm$parser$Parser$Advanced$Located = F3(
	function (row, col, context) {
		return {xG: col, bL: context, hP: row};
	});
var $elm$parser$Parser$Advanced$changeContext = F2(
	function (newContext, s) {
		return {xG: s.xG, bL: newContext, cy: s.cy, uR: s.uR, hP: s.hP, fG: s.fG};
	});
var $elm$parser$Parser$Advanced$inContext = F2(
	function (context, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(
				A2(
					$elm$parser$Parser$Advanced$changeContext,
					A2(
						$elm$core$List$cons,
						A3($elm$parser$Parser$Advanced$Located, s0.hP, s0.xG, context),
						s0.bL),
					s0));
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					a,
					A2($elm$parser$Parser$Advanced$changeContext, s0.bL, s1));
			} else {
				var step = _v1;
				return step;
			}
		};
	});
var $dillonkearns$elm_markdown$Whitespace$isWhitespace = function (_char) {
	switch (_char) {
		case ' ':
			return true;
		case '\n':
			return true;
		case '\t':
			return true;
		case '\u000B':
			return true;
		case '\u000C':
			return true;
		case '\u000D':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Parser$Token$lessThan = A2(
	$elm$parser$Parser$Advanced$Token,
	'<',
	$elm$parser$Parser$Expecting('a `<`'));
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$destinationParser = A2(
	$elm$parser$Parser$Advanced$inContext,
	'link destination',
	$elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed($elm$url$Url$percentEncode),
					$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$lessThan)),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$getChompedString(
						$elm$parser$Parser$Advanced$chompUntil($dillonkearns$elm_markdown$Parser$Token$greaterThan)),
					$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$greaterThan))),
				$elm$parser$Parser$Advanced$getChompedString(
				$dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore(
					A2($elm$core$Basics$composeL, $elm$core$Basics$not, $dillonkearns$elm_markdown$Whitespace$isWhitespace)))
			])));
var $dillonkearns$elm_markdown$Parser$Token$closingSquareBracket = A2(
	$elm$parser$Parser$Advanced$Token,
	']',
	$elm$parser$Parser$Expecting('a `]`'));
var $dillonkearns$elm_markdown$Parser$Token$openingSquareBracket = A2(
	$elm$parser$Parser$Advanced$Token,
	'[',
	$elm$parser$Parser$Expecting('a `[`'));
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$labelParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$Helpers$prepareRefLabel),
		$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$openingSquareBracket)),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$chompUntil($dillonkearns$elm_markdown$Parser$Token$closingSquareBracket)),
		$elm$parser$Parser$Advanced$symbol(
			A2(
				$elm$parser$Parser$Advanced$Token,
				']:',
				$elm$parser$Parser$Expecting(']:')))));
var $dillonkearns$elm_markdown$Parser$Token$doubleQuote = A2(
	$elm$parser$Parser$Advanced$Token,
	'\"',
	$elm$parser$Parser$Expecting('a double quote'));
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$hasNoBlankLine = function (str) {
	return A2($elm$core$String$contains, '\n\n', str) ? $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Expecting('no blank line')) : $elm$parser$Parser$Advanced$succeed(str);
};
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$onlyWhitespaceTillNewline = A2(
	$elm$parser$Parser$Advanced$ignorer,
	$elm$parser$Parser$Advanced$chompWhile(
		function (c) {
			return (!$dillonkearns$elm_markdown$Whitespace$isLineEnd(c)) && $dillonkearns$elm_markdown$Whitespace$isWhitespace(c);
		}),
	$dillonkearns$elm_markdown$Helpers$lineEndOrEnd);
var $dillonkearns$elm_markdown$Whitespace$requiredWhitespace = A2(
	$elm$parser$Parser$Advanced$ignorer,
	A2(
		$elm$parser$Parser$Advanced$chompIf,
		$dillonkearns$elm_markdown$Whitespace$isWhitespace,
		$elm$parser$Parser$Expecting('Required whitespace')),
	$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isWhitespace));
var $dillonkearns$elm_markdown$Parser$Token$singleQuote = A2(
	$elm$parser$Parser$Advanced$Token,
	'\'',
	$elm$parser$Parser$Expecting('a single quote'));
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$titleParser = function () {
	var inSingleQuotes = A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Just),
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$singleQuote)),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$andThen,
					$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$hasNoBlankLine,
					$elm$parser$Parser$Advanced$getChompedString(
						$elm$parser$Parser$Advanced$chompUntil($dillonkearns$elm_markdown$Parser$Token$singleQuote))),
				$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$singleQuote)),
			$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$onlyWhitespaceTillNewline));
	var inDoubleQuotes = A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Just),
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$doubleQuote)),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$andThen,
					$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$hasNoBlankLine,
					$elm$parser$Parser$Advanced$getChompedString(
						$elm$parser$Parser$Advanced$chompUntil($dillonkearns$elm_markdown$Parser$Token$doubleQuote))),
				$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$doubleQuote)),
			$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$onlyWhitespaceTillNewline));
	return A2(
		$elm$parser$Parser$Advanced$inContext,
		'title',
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$Advanced$backtrackable(
					A2(
						$elm$parser$Parser$Advanced$keeper,
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
							$dillonkearns$elm_markdown$Whitespace$requiredWhitespace),
						$elm$parser$Parser$Advanced$oneOf(
							_List_fromArray(
								[
									inDoubleQuotes,
									inSingleQuotes,
									$elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Nothing)
								])))),
					A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Nothing),
					$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$onlyWhitespaceTillNewline)
				])));
}();
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$parser = A2(
	$elm$parser$Parser$Advanced$inContext,
	'link reference definition',
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed(
						F3(
							function (label, destination, title) {
								return _Utils_Tuple2(
									label,
									{Cg: destination, Gy: title});
							})),
					$dillonkearns$elm_markdown$Whitespace$upToThreeSpaces),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$labelParser,
							$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)),
						$elm$parser$Parser$Advanced$oneOf(
							_List_fromArray(
								[
									$dillonkearns$elm_markdown$Whitespace$lineEnd,
									$elm$parser$Parser$Advanced$succeed(0)
								]))),
					$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab))),
			$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$destinationParser),
		$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$titleParser));
var $dillonkearns$elm_markdown$ThematicBreak$ThematicBreak = 0;
var $dillonkearns$elm_markdown$ThematicBreak$whitespace = $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab);
var $dillonkearns$elm_markdown$ThematicBreak$withChar = function (tchar) {
	var token = $dillonkearns$elm_markdown$Parser$Token$parseString(
		$elm$core$String$fromChar(tchar));
	return A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							A2(
								$elm$parser$Parser$Advanced$ignorer,
								$elm$parser$Parser$Advanced$succeed(0),
								token),
							$dillonkearns$elm_markdown$ThematicBreak$whitespace),
						token),
					$dillonkearns$elm_markdown$ThematicBreak$whitespace),
				token),
			$elm$parser$Parser$Advanced$chompWhile(
				function (c) {
					return _Utils_eq(c, tchar) || $dillonkearns$elm_markdown$Whitespace$isSpaceOrTab(c);
				})),
		$dillonkearns$elm_markdown$Helpers$lineEndOrEnd);
};
var $dillonkearns$elm_markdown$ThematicBreak$parseThematicBreak = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			$dillonkearns$elm_markdown$ThematicBreak$withChar('-'),
			$dillonkearns$elm_markdown$ThematicBreak$withChar('*'),
			$dillonkearns$elm_markdown$ThematicBreak$withChar('_')
		]));
var $dillonkearns$elm_markdown$ThematicBreak$parser = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
						$dillonkearns$elm_markdown$Whitespace$space),
					$elm$parser$Parser$Advanced$oneOf(
						_List_fromArray(
							[
								$dillonkearns$elm_markdown$Whitespace$space,
								$elm$parser$Parser$Advanced$succeed(0)
							]))),
				$elm$parser$Parser$Advanced$oneOf(
					_List_fromArray(
						[
							$dillonkearns$elm_markdown$Whitespace$space,
							$elm$parser$Parser$Advanced$succeed(0)
						]))),
			$dillonkearns$elm_markdown$ThematicBreak$parseThematicBreak),
			$dillonkearns$elm_markdown$ThematicBreak$parseThematicBreak
		]));
var $dillonkearns$elm_markdown$Markdown$RawBlock$LevelOne = 0;
var $dillonkearns$elm_markdown$Markdown$RawBlock$LevelTwo = 1;
var $dillonkearns$elm_markdown$Markdown$RawBlock$SetextLine = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Parser$Token$equals = A2(
	$elm$parser$Parser$Advanced$Token,
	'=',
	$elm$parser$Parser$Expecting('a `=`'));
var $dillonkearns$elm_markdown$Parser$Token$minus = A2(
	$elm$parser$Parser$Advanced$Token,
	'-',
	$elm$parser$Parser$Expecting('a `-`'));
var $dillonkearns$elm_markdown$Markdown$Parser$setextLineParser = function () {
	var setextLevel = F3(
		function (level, levelToken, levelChar) {
			return A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed(level),
					$elm$parser$Parser$Advanced$token(levelToken)),
				$elm$parser$Parser$Advanced$chompWhile(
					$elm$core$Basics$eq(levelChar)));
		});
	return A2(
		$elm$parser$Parser$Advanced$mapChompedString,
		F2(
			function (raw, level) {
				return A2($dillonkearns$elm_markdown$Markdown$RawBlock$SetextLine, level, raw);
			}),
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
				$dillonkearns$elm_markdown$Whitespace$upToThreeSpaces),
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$oneOf(
						_List_fromArray(
							[
								A3(setextLevel, 0, $dillonkearns$elm_markdown$Parser$Token$equals, '='),
								A3(setextLevel, 1, $dillonkearns$elm_markdown$Parser$Token$minus, '-')
							])),
					$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)),
				$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)));
}();
var $dillonkearns$elm_markdown$Markdown$RawBlock$TableDelimiter = function (a) {
	return {$: 9, a: a};
};
var $dillonkearns$elm_markdown$Markdown$TableParser$chompSinglelineWhitespace = $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab);
var $dillonkearns$elm_markdown$Parser$Extra$maybeChomp = function (condition) {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$chompIf,
				condition,
				$elm$parser$Parser$Problem('Character not found')),
				$elm$parser$Parser$Advanced$succeed(0)
			]));
};
var $dillonkearns$elm_markdown$Markdown$TableParser$requirePipeIfNotFirst = function (columns) {
	return $elm$core$List$isEmpty(columns) ? $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				$dillonkearns$elm_markdown$Parser$Token$parseString('|'),
				$elm$parser$Parser$Advanced$succeed(0)
			])) : $dillonkearns$elm_markdown$Parser$Token$parseString('|');
};
var $dillonkearns$elm_markdown$Markdown$TableParser$delimiterRowHelp = function (revDelimiterColumns) {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				$elm$parser$Parser$Advanced$backtrackable(
				A2(
					$elm$parser$Parser$Advanced$map,
					function (_v0) {
						return $elm$parser$Parser$Advanced$Done(revDelimiterColumns);
					},
					$dillonkearns$elm_markdown$Parser$Token$parseString('|\n'))),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v1) {
					return $elm$parser$Parser$Advanced$Done(revDelimiterColumns);
				},
				$dillonkearns$elm_markdown$Parser$Token$parseString('\n')),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v2) {
					return $elm$parser$Parser$Advanced$Done(revDelimiterColumns);
				},
				$elm$parser$Parser$Advanced$end(
					$elm$parser$Parser$Expecting('end'))),
				$elm$parser$Parser$Advanced$backtrackable(
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed(
							$elm$parser$Parser$Advanced$Done(revDelimiterColumns)),
						$dillonkearns$elm_markdown$Parser$Token$parseString('|')),
					$elm$parser$Parser$Advanced$end(
						$elm$parser$Parser$Expecting('end')))),
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed(
							function (column) {
								return $elm$parser$Parser$Advanced$Loop(
									A2($elm$core$List$cons, column, revDelimiterColumns));
							}),
						$dillonkearns$elm_markdown$Markdown$TableParser$requirePipeIfNotFirst(revDelimiterColumns)),
					$dillonkearns$elm_markdown$Markdown$TableParser$chompSinglelineWhitespace),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$getChompedString(
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							A2(
								$elm$parser$Parser$Advanced$ignorer,
								A2(
									$elm$parser$Parser$Advanced$ignorer,
									$elm$parser$Parser$Advanced$succeed(0),
									$dillonkearns$elm_markdown$Parser$Extra$maybeChomp(
										function (c) {
											return c === ':';
										})),
								$dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore(
									function (c) {
										return c === '-';
									})),
							$dillonkearns$elm_markdown$Parser$Extra$maybeChomp(
								function (c) {
									return c === ':';
								}))),
					$dillonkearns$elm_markdown$Markdown$TableParser$chompSinglelineWhitespace))
			]));
};
var $dillonkearns$elm_markdown$Markdown$Block$AlignCenter = 2;
var $dillonkearns$elm_markdown$Markdown$Block$AlignLeft = 0;
var $dillonkearns$elm_markdown$Markdown$Block$AlignRight = 1;
var $dillonkearns$elm_markdown$Markdown$TableParser$delimiterToAlignment = function (cell) {
	var _v0 = _Utils_Tuple2(
		A2($elm$core$String$startsWith, ':', cell),
		A2($elm$core$String$endsWith, ':', cell));
	if (_v0.a) {
		if (_v0.b) {
			return $elm$core$Maybe$Just(2);
		} else {
			return $elm$core$Maybe$Just(0);
		}
	} else {
		if (_v0.b) {
			return $elm$core$Maybe$Just(1);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $dillonkearns$elm_markdown$Markdown$TableParser$delimiterRowParser = A2(
	$elm$parser$Parser$Advanced$andThen,
	function (delimiterRow) {
		var trimmed = delimiterRow.a.Az;
		var headers = delimiterRow.b;
		return $elm$core$List$isEmpty(headers) ? $elm$parser$Parser$Advanced$problem(
			$elm$parser$Parser$Expecting('Must have at least one column in delimiter row.')) : ((($elm$core$List$length(headers) === 1) && (!(A2($elm$core$String$startsWith, '|', trimmed) && A2($elm$core$String$endsWith, '|', trimmed)))) ? $elm$parser$Parser$Advanced$problem(
			$elm$parser$Parser$Problem('Tables with a single column must have pipes at the start and end of the delimiter row to avoid ambiguity.')) : $elm$parser$Parser$Advanced$succeed(delimiterRow));
	},
	A2(
		$elm$parser$Parser$Advanced$mapChompedString,
		F2(
			function (delimiterText, revDelimiterColumns) {
				return A2(
					$dillonkearns$elm_markdown$Markdown$Table$TableDelimiterRow,
					{
						zN: delimiterText,
						Az: $elm$core$String$trim(delimiterText)
					},
					A2(
						$elm$core$List$map,
						$dillonkearns$elm_markdown$Markdown$TableParser$delimiterToAlignment,
						$elm$core$List$reverse(revDelimiterColumns)));
			}),
		A2($elm$parser$Parser$Advanced$loop, _List_Nil, $dillonkearns$elm_markdown$Markdown$TableParser$delimiterRowHelp)));
var $dillonkearns$elm_markdown$Markdown$Parser$tableDelimiterInOpenParagraph = A2($elm$parser$Parser$Advanced$map, $dillonkearns$elm_markdown$Markdown$RawBlock$TableDelimiter, $dillonkearns$elm_markdown$Markdown$TableParser$delimiterRowParser);
var $dillonkearns$elm_markdown$Markdown$TableParser$standardizeRowLength = F2(
	function (expectedLength, row) {
		var rowLength = $elm$core$List$length(row);
		var _v0 = A2($elm$core$Basics$compare, expectedLength, rowLength);
		switch (_v0) {
			case 0:
				return A2($elm$core$List$take, expectedLength, row);
			case 1:
				return row;
			default:
				return _Utils_ap(
					row,
					A2($elm$core$List$repeat, expectedLength - rowLength, ''));
		}
	});
var $dillonkearns$elm_markdown$Markdown$TableParser$bodyRowParser = function (expectedRowLength) {
	return A2(
		$elm$parser$Parser$Advanced$andThen,
		function (row) {
			return ($elm$core$List$isEmpty(row) || A2($elm$core$List$all, $elm$core$String$isEmpty, row)) ? $elm$parser$Parser$Advanced$problem(
				$elm$parser$Parser$Problem('A line must have at least one column')) : $elm$parser$Parser$Advanced$succeed(
				A2($dillonkearns$elm_markdown$Markdown$TableParser$standardizeRowLength, expectedRowLength, row));
		},
		$dillonkearns$elm_markdown$Markdown$TableParser$rowParser);
};
var $dillonkearns$elm_markdown$Markdown$Parser$tableRowIfTableStarted = function (_v0) {
	var headers = _v0.a;
	var body = _v0.b;
	return A2(
		$elm$parser$Parser$Advanced$map,
		function (row) {
			return $dillonkearns$elm_markdown$Markdown$RawBlock$Table(
				A2(
					$dillonkearns$elm_markdown$Markdown$Table$Table,
					headers,
					_Utils_ap(
						body,
						_List_fromArray(
							[row]))));
		},
		$dillonkearns$elm_markdown$Markdown$TableParser$bodyRowParser(
			$elm$core$List$length(headers)));
};
var $dillonkearns$elm_markdown$Markdown$Block$H1 = 0;
var $dillonkearns$elm_markdown$Markdown$Block$H2 = 1;
var $dillonkearns$elm_markdown$Markdown$Block$H3 = 2;
var $dillonkearns$elm_markdown$Markdown$Block$H4 = 3;
var $dillonkearns$elm_markdown$Markdown$Block$H5 = 4;
var $dillonkearns$elm_markdown$Markdown$Block$H6 = 5;
var $dillonkearns$elm_markdown$Markdown$Parser$toHeading = function (level) {
	switch (level) {
		case 1:
			return $elm$core$Result$Ok(0);
		case 2:
			return $elm$core$Result$Ok(1);
		case 3:
			return $elm$core$Result$Ok(2);
		case 4:
			return $elm$core$Result$Ok(3);
		case 5:
			return $elm$core$Result$Ok(4);
		case 6:
			return $elm$core$Result$Ok(5);
		default:
			return $elm$core$Result$Err(
				$elm$parser$Parser$Expecting(
					'A heading with 1 to 6 #\'s, but found ' + $elm$core$String$fromInt(level)));
	}
};
var $dillonkearns$elm_markdown$Markdown$ListItem$EmptyItem = {$: 2};
var $dillonkearns$elm_markdown$Markdown$ListItem$PlainItem = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$Markdown$ListItem$TaskItem = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$UnorderedList$getIntendedCodeItem = F4(
	function (markerStartPos, listMarker, markerEndPos, _v0) {
		var bodyStartPos = _v0.a;
		var item = _v0.b;
		var spaceNum = bodyStartPos - markerEndPos;
		if (spaceNum <= 4) {
			return _Utils_Tuple3(listMarker, bodyStartPos - markerStartPos, item);
		} else {
			var intendedCodeItem = function () {
				switch (item.$) {
					case 0:
						var completion = item.a;
						var string = item.b;
						return A2(
							$dillonkearns$elm_markdown$Markdown$ListItem$TaskItem,
							completion,
							_Utils_ap(
								A2($elm$core$String$repeat, spaceNum - 1, ' '),
								string));
					case 1:
						var string = item.a;
						return $dillonkearns$elm_markdown$Markdown$ListItem$PlainItem(
							_Utils_ap(
								A2($elm$core$String$repeat, spaceNum - 1, ' '),
								string));
					default:
						return $dillonkearns$elm_markdown$Markdown$ListItem$EmptyItem;
				}
			}();
			return _Utils_Tuple3(listMarker, (markerEndPos - markerStartPos) + 1, intendedCodeItem);
		}
	});
var $dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListEmptyItemParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	$elm$parser$Parser$Advanced$succeed(
		function (bodyStartPos) {
			return _Utils_Tuple2(bodyStartPos, $dillonkearns$elm_markdown$Markdown$ListItem$EmptyItem);
		}),
	A2($elm$parser$Parser$Advanced$ignorer, $elm$parser$Parser$Advanced$getCol, $dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $dillonkearns$elm_markdown$Markdown$ListItem$Complete = 1;
var $dillonkearns$elm_markdown$Markdown$ListItem$Incomplete = 0;
var $dillonkearns$elm_markdown$Markdown$ListItem$taskItemParser = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(1),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'[x] ',
					$elm$parser$Parser$ExpectingSymbol('[x] ')))),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(1),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'[X] ',
					$elm$parser$Parser$ExpectingSymbol('[X] ')))),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(0),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'[ ] ',
					$elm$parser$Parser$ExpectingSymbol('[ ] '))))
		]));
var $dillonkearns$elm_markdown$Markdown$ListItem$parser = A2(
	$elm$parser$Parser$Advanced$keeper,
	$elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$keeper,
				$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$ListItem$TaskItem),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$dillonkearns$elm_markdown$Markdown$ListItem$taskItemParser,
					$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab))),
				$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$ListItem$PlainItem)
			])),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
		$dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListItemBodyParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(
				F2(
					function (bodyStartPos, item) {
						return _Utils_Tuple2(bodyStartPos, item);
					})),
			$dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)),
		$elm$parser$Parser$Advanced$getCol),
	$dillonkearns$elm_markdown$Markdown$ListItem$parser);
var $dillonkearns$elm_markdown$Markdown$UnorderedList$Asterisk = 2;
var $dillonkearns$elm_markdown$Markdown$UnorderedList$Minus = 0;
var $dillonkearns$elm_markdown$Markdown$UnorderedList$Plus = 1;
var $dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListMarkerParser = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed(0),
				A2($dillonkearns$elm_markdown$Parser$Extra$upTo, 3, $dillonkearns$elm_markdown$Whitespace$space)),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'-',
					$elm$parser$Parser$ExpectingSymbol('-')))),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(1),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'+',
					$elm$parser$Parser$ExpectingSymbol('+')))),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(2),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'*',
					$elm$parser$Parser$ExpectingSymbol('*'))))
		]));
var $dillonkearns$elm_markdown$Markdown$UnorderedList$parser = function (previousWasBody) {
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$keeper,
					$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$UnorderedList$getIntendedCodeItem),
					$elm$parser$Parser$Advanced$getCol),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListMarkerParser)),
			$elm$parser$Parser$Advanced$getCol),
		previousWasBody ? $dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListItemBodyParser : $elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[$dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListEmptyItemParser, $dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListItemBodyParser])));
};
var $dillonkearns$elm_markdown$Markdown$Parser$unorderedListBlock = function (previousWasBody) {
	var parseListItem = F2(
		function (listmarker, unparsedListItem) {
			switch (unparsedListItem.$) {
				case 0:
					var completion = unparsedListItem.a;
					var body = unparsedListItem.b;
					return {
						sY: body,
						Eb: listmarker,
						dr: $elm$core$Maybe$Just(
							function () {
								if (completion === 1) {
									return true;
								} else {
									return false;
								}
							}())
					};
				case 1:
					var body = unparsedListItem.a;
					return {sY: body, Eb: listmarker, dr: $elm$core$Maybe$Nothing};
				default:
					return {sY: '', Eb: listmarker, dr: $elm$core$Maybe$Nothing};
			}
		});
	return A2(
		$elm$parser$Parser$Advanced$map,
		function (_v0) {
			var listmarker = _v0.a;
			var intended = _v0.b;
			var unparsedListItem = _v0.c;
			return A4(
				$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
				true,
				intended,
				_List_Nil,
				A2(parseListItem, listmarker, unparsedListItem));
		},
		$dillonkearns$elm_markdown$Markdown$UnorderedList$parser(previousWasBody));
};
var $dillonkearns$elm_markdown$Markdown$Parser$childToBlocks = F2(
	function (node, blocks) {
		switch (node.$) {
			case 0:
				var tag = node.a;
				var attributes = node.b;
				var children = node.c;
				var _v106 = $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocks(children);
				if (!_v106.$) {
					var childrenAsBlocks = _v106.a;
					var block = $dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
						A3($dillonkearns$elm_markdown$Markdown$Block$HtmlElement, tag, attributes, childrenAsBlocks));
					return $elm$core$Result$Ok(
						A2($elm$core$List$cons, block, blocks));
				} else {
					var err = _v106.a;
					return $elm$core$Result$Err(err);
				}
			case 1:
				var innerText = node.a;
				var _v107 = $dillonkearns$elm_markdown$Markdown$Parser$parse(innerText);
				if (!_v107.$) {
					var value = _v107.a;
					return $elm$core$Result$Ok(
						_Utils_ap(
							$elm$core$List$reverse(value),
							blocks));
				} else {
					var error = _v107.a;
					return $elm$core$Result$Err(
						$elm$parser$Parser$Expecting(
							A2(
								$elm$core$String$join,
								'\n',
								A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$deadEndToString, error))));
				}
			case 2:
				var string = node.a;
				return $elm$core$Result$Ok(
					A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
							$dillonkearns$elm_markdown$Markdown$Block$HtmlComment(string)),
						blocks));
			case 3:
				var string = node.a;
				return $elm$core$Result$Ok(
					A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
							$dillonkearns$elm_markdown$Markdown$Block$Cdata(string)),
						blocks));
			case 4:
				var string = node.a;
				return $elm$core$Result$Ok(
					A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
							$dillonkearns$elm_markdown$Markdown$Block$ProcessingInstruction(string)),
						blocks));
			default:
				var declarationType = node.a;
				var content = node.b;
				return $elm$core$Result$Ok(
					A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
							A2($dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration, declarationType, content)),
						blocks));
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$completeBlocks = function (state) {
	var _v91 = state.O;
	_v91$5:
	while (true) {
		if (_v91.b) {
			switch (_v91.a.$) {
				case 11:
					var body2 = _v91.a.a;
					var rest = _v91.b;
					var _v92 = A2(
						$elm$parser$Parser$Advanced$run,
						$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
						body2);
					if (!_v92.$) {
						var value = _v92.a;
						return $elm$parser$Parser$Advanced$succeed(
							{
								x: _Utils_ap(state.x, value.x),
								O: A2(
									$elm$core$List$cons,
									$dillonkearns$elm_markdown$Markdown$RawBlock$ParsedBlockQuote(value.O),
									rest)
							});
					} else {
						var error = _v92.a;
						return $elm$parser$Parser$Advanced$problem(
							$elm$parser$Parser$Problem(
								$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(error)));
					}
				case 3:
					var _v93 = _v91.a;
					var tight = _v93.a;
					var intended = _v93.b;
					var closeListItems = _v93.c;
					var openListItem = _v93.d;
					var rest = _v91.b;
					var _v94 = A2(
						$elm$parser$Parser$Advanced$run,
						$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
						openListItem.sY);
					if (!_v94.$) {
						var value = _v94.a;
						var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.O) ? false : tight;
						return $elm$parser$Parser$Advanced$succeed(
							{
								x: _Utils_ap(state.x, value.x),
								O: A2(
									$elm$core$List$cons,
									A4(
										$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
										tight2,
										intended,
										A2(
											$elm$core$List$cons,
											{sY: value.O, dr: openListItem.dr},
											closeListItems),
										openListItem),
									rest)
							});
					} else {
						var e = _v94.a;
						return $elm$parser$Parser$Advanced$problem(
							$elm$parser$Parser$Problem(
								$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
					}
				case 4:
					var _v99 = _v91.a;
					var tight = _v99.a;
					var intended = _v99.b;
					var marker = _v99.c;
					var order = _v99.d;
					var closeListItems = _v99.e;
					var openListItem = _v99.f;
					var rest = _v91.b;
					var _v100 = A2(
						$elm$parser$Parser$Advanced$run,
						$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
						openListItem);
					if (!_v100.$) {
						var value = _v100.a;
						var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.O) ? false : tight;
						return $elm$parser$Parser$Advanced$succeed(
							{
								x: _Utils_ap(state.x, value.x),
								O: A2(
									$elm$core$List$cons,
									A6(
										$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
										tight2,
										intended,
										marker,
										order,
										A2($elm$core$List$cons, value.O, closeListItems),
										openListItem),
									rest)
							});
					} else {
						var e = _v100.a;
						return $elm$parser$Parser$Advanced$problem(
							$elm$parser$Parser$Problem(
								$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
					}
				case 10:
					if (_v91.b.b) {
						switch (_v91.b.a.$) {
							case 3:
								var _v95 = _v91.a;
								var _v96 = _v91.b;
								var _v97 = _v96.a;
								var tight = _v97.a;
								var intended = _v97.b;
								var closeListItems = _v97.c;
								var openListItem = _v97.d;
								var rest = _v96.b;
								var _v98 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									openListItem.sY);
								if (!_v98.$) {
									var value = _v98.a;
									var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.O) ? false : tight;
									return $elm$parser$Parser$Advanced$succeed(
										{
											x: _Utils_ap(state.x, value.x),
											O: A2(
												$elm$core$List$cons,
												A4(
													$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
													tight2,
													intended,
													A2(
														$elm$core$List$cons,
														{sY: value.O, dr: openListItem.dr},
														closeListItems),
													openListItem),
												rest)
										});
								} else {
									var e = _v98.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
							case 4:
								var _v101 = _v91.a;
								var _v102 = _v91.b;
								var _v103 = _v102.a;
								var tight = _v103.a;
								var intended = _v103.b;
								var marker = _v103.c;
								var order = _v103.d;
								var closeListItems = _v103.e;
								var openListItem = _v103.f;
								var rest = _v102.b;
								var _v104 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									openListItem);
								if (!_v104.$) {
									var value = _v104.a;
									var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.O) ? false : tight;
									return $elm$parser$Parser$Advanced$succeed(
										{
											x: _Utils_ap(state.x, value.x),
											O: A2(
												$elm$core$List$cons,
												A6(
													$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
													tight2,
													intended,
													marker,
													order,
													A2($elm$core$List$cons, value.O, closeListItems),
													openListItem),
												rest)
										});
								} else {
									var e = _v104.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
							default:
								break _v91$5;
						}
					} else {
						break _v91$5;
					}
				default:
					break _v91$5;
			}
		} else {
			break _v91$5;
		}
	}
	return $elm$parser$Parser$Advanced$succeed(state);
};
var $dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks = F2(
	function (state, newRawBlock) {
		var _v41 = _Utils_Tuple2(newRawBlock, state.O);
		_v41$13:
		while (true) {
			if (_v41.b.b) {
				switch (_v41.b.a.$) {
					case 5:
						if (_v41.a.$ === 5) {
							var block1 = _v41.a.a;
							var _v42 = _v41.b;
							var block2 = _v42.a.a;
							var rest = _v42.b;
							return $elm$parser$Parser$Advanced$succeed(
								{
									x: state.x,
									O: A2(
										$elm$core$List$cons,
										$dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock(
											{
												sY: A2($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll, block2.sY, block1.sY),
												aC: $elm$core$Maybe$Nothing
											}),
										rest)
								});
						} else {
							break _v41$13;
						}
					case 6:
						switch (_v41.a.$) {
							case 6:
								var block1 = _v41.a.a;
								var _v43 = _v41.b;
								var block2 = _v43.a.a;
								var rest = _v43.b;
								return $elm$parser$Parser$Advanced$succeed(
									{
										x: state.x,
										O: A2(
											$elm$core$List$cons,
											$dillonkearns$elm_markdown$Markdown$RawBlock$IndentedCodeBlock(
												A2($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll, block2, block1)),
											rest)
									});
							case 10:
								var _v44 = _v41.a;
								var _v45 = _v41.b;
								var block = _v45.a.a;
								var rest = _v45.b;
								return $elm$parser$Parser$Advanced$succeed(
									{
										x: state.x,
										O: A2(
											$elm$core$List$cons,
											$dillonkearns$elm_markdown$Markdown$RawBlock$IndentedCodeBlock(
												A2($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll, block, '\n')),
											rest)
									});
							default:
								break _v41$13;
						}
					case 11:
						var _v46 = _v41.b;
						var body2 = _v46.a.a;
						var rest = _v46.b;
						switch (newRawBlock.$) {
							case 11:
								var body1 = newRawBlock.a;
								return $elm$parser$Parser$Advanced$succeed(
									{
										x: state.x,
										O: A2(
											$elm$core$List$cons,
											$dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote(
												A2($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll, body2, body1)),
											rest)
									});
							case 1:
								var body1 = newRawBlock.a;
								var _v48 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									body2);
								if (!_v48.$) {
									var value = _v48.a;
									var _v49 = value.O;
									if (_v49.b) {
										var last = _v49.a;
										if ($dillonkearns$elm_markdown$Markdown$Parser$endWithOpenBlockOrParagraph(last) && (!A2($elm$core$String$endsWith, '\n', body2))) {
											return $elm$parser$Parser$Advanced$succeed(
												{
													x: state.x,
													O: A2(
														$elm$core$List$cons,
														$dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote(
															A2($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll, body2, body1)),
														rest)
												});
										} else {
											var _v50 = A2(
												$elm$parser$Parser$Advanced$run,
												$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
												body2);
											if (!_v50.$) {
												var value1 = _v50.a;
												return $elm$parser$Parser$Advanced$succeed(
													{
														x: _Utils_ap(state.x, value.x),
														O: A2(
															$elm$core$List$cons,
															newRawBlock,
															A2(
																$elm$core$List$cons,
																$dillonkearns$elm_markdown$Markdown$RawBlock$ParsedBlockQuote(value1.O),
																rest))
													});
											} else {
												var e1 = _v50.a;
												return $elm$parser$Parser$Advanced$problem(
													$elm$parser$Parser$Problem(
														$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e1)));
											}
										}
									} else {
										var _v51 = A2(
											$elm$parser$Parser$Advanced$run,
											$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
											body2);
										if (!_v51.$) {
											var value1 = _v51.a;
											return $elm$parser$Parser$Advanced$succeed(
												{
													x: _Utils_ap(state.x, value.x),
													O: A2(
														$elm$core$List$cons,
														newRawBlock,
														A2(
															$elm$core$List$cons,
															$dillonkearns$elm_markdown$Markdown$RawBlock$ParsedBlockQuote(value1.O),
															rest))
												});
										} else {
											var e1 = _v51.a;
											return $elm$parser$Parser$Advanced$problem(
												$elm$parser$Parser$Problem(
													$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e1)));
										}
									}
								} else {
									var e = _v48.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
							case 6:
								var body1 = newRawBlock.a;
								var _v52 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									body2);
								if (!_v52.$) {
									var value = _v52.a;
									var _v53 = value.O;
									if (_v53.b && (_v53.a.$ === 1)) {
										return $elm$parser$Parser$Advanced$succeed(
											{
												x: state.x,
												O: A2(
													$elm$core$List$cons,
													$dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote(
														A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, ' ', body2, body1)),
													rest)
											});
									} else {
										var _v54 = A2(
											$elm$parser$Parser$Advanced$run,
											$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
											body2);
										if (!_v54.$) {
											var value1 = _v54.a;
											return $elm$parser$Parser$Advanced$succeed(
												{
													x: _Utils_ap(state.x, value.x),
													O: A2(
														$elm$core$List$cons,
														newRawBlock,
														A2(
															$elm$core$List$cons,
															$dillonkearns$elm_markdown$Markdown$RawBlock$ParsedBlockQuote(value1.O),
															rest))
												});
										} else {
											var e1 = _v54.a;
											return $elm$parser$Parser$Advanced$problem(
												$elm$parser$Parser$Problem(
													$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e1)));
										}
									}
								} else {
									var e = _v52.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
							default:
								var _v55 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									body2);
								if (!_v55.$) {
									var value = _v55.a;
									return $elm$parser$Parser$Advanced$succeed(
										{
											x: _Utils_ap(state.x, value.x),
											O: A2(
												$elm$core$List$cons,
												newRawBlock,
												A2(
													$elm$core$List$cons,
													$dillonkearns$elm_markdown$Markdown$RawBlock$ParsedBlockQuote(value.O),
													rest))
										});
								} else {
									var e = _v55.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
						}
					case 3:
						var _v56 = _v41.b;
						var _v57 = _v56.a;
						var tight = _v57.a;
						var intended1 = _v57.b;
						var closeListItems2 = _v57.c;
						var openListItem2 = _v57.d;
						var rest = _v56.b;
						switch (newRawBlock.$) {
							case 3:
								var intended2 = newRawBlock.b;
								var openListItem1 = newRawBlock.d;
								if (_Utils_eq(openListItem2.Eb, openListItem1.Eb)) {
									var _v59 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2.sY);
									if (!_v59.$) {
										var value = _v59.a;
										return A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.O) ? $elm$parser$Parser$Advanced$succeed(
											{
												x: _Utils_ap(state.x, value.x),
												O: A2(
													$elm$core$List$cons,
													A4(
														$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
														false,
														intended2,
														A2(
															$elm$core$List$cons,
															{sY: value.O, dr: openListItem2.dr},
															closeListItems2),
														openListItem1),
													rest)
											}) : $elm$parser$Parser$Advanced$succeed(
											{
												x: _Utils_ap(state.x, value.x),
												O: A2(
													$elm$core$List$cons,
													A4(
														$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
														tight,
														intended2,
														A2(
															$elm$core$List$cons,
															{sY: value.O, dr: openListItem2.dr},
															closeListItems2),
														openListItem1),
													rest)
											});
									} else {
										var e = _v59.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								} else {
									var _v60 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2.sY);
									if (!_v60.$) {
										var value = _v60.a;
										var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.O) ? false : tight;
										return $elm$parser$Parser$Advanced$succeed(
											{
												x: _Utils_ap(state.x, value.x),
												O: A2(
													$elm$core$List$cons,
													newRawBlock,
													A2(
														$elm$core$List$cons,
														A4(
															$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
															tight2,
															intended1,
															A2(
																$elm$core$List$cons,
																{sY: value.O, dr: openListItem2.dr},
																closeListItems2),
															openListItem1),
														rest))
											});
									} else {
										var e = _v60.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								}
							case 1:
								var body1 = newRawBlock.a;
								return $elm$parser$Parser$Advanced$succeed(
									{
										x: state.x,
										O: A2(
											$elm$core$List$cons,
											A4(
												$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
												tight,
												intended1,
												closeListItems2,
												_Utils_update(
													openListItem2,
													{
														sY: A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\n', openListItem2.sY, body1)
													})),
											rest)
									});
							default:
								var _v61 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									openListItem2.sY);
								if (!_v61.$) {
									var value = _v61.a;
									var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.O) ? false : tight;
									return $elm$parser$Parser$Advanced$succeed(
										{
											x: _Utils_ap(state.x, value.x),
											O: A2(
												$elm$core$List$cons,
												newRawBlock,
												A2(
													$elm$core$List$cons,
													A4(
														$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
														tight2,
														intended1,
														A2(
															$elm$core$List$cons,
															{sY: value.O, dr: openListItem2.dr},
															closeListItems2),
														openListItem2),
													rest))
										});
								} else {
									var e = _v61.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
						}
					case 4:
						var _v62 = _v41.b;
						var _v63 = _v62.a;
						var tight = _v63.a;
						var intended1 = _v63.b;
						var marker = _v63.c;
						var order = _v63.d;
						var closeListItems2 = _v63.e;
						var openListItem2 = _v63.f;
						var rest = _v62.b;
						switch (newRawBlock.$) {
							case 4:
								var intended2 = newRawBlock.b;
								var marker2 = newRawBlock.c;
								var openListItem1 = newRawBlock.f;
								if (_Utils_eq(marker, marker2)) {
									var _v65 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2);
									if (!_v65.$) {
										var value = _v65.a;
										var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.O) ? false : tight;
										return $elm$parser$Parser$Advanced$succeed(
											{
												x: _Utils_ap(state.x, value.x),
												O: A2(
													$elm$core$List$cons,
													A6(
														$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
														tight2,
														intended2,
														marker,
														order,
														A2($elm$core$List$cons, value.O, closeListItems2),
														openListItem1),
													rest)
											});
									} else {
										var e = _v65.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								} else {
									var _v66 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2);
									if (!_v66.$) {
										var value = _v66.a;
										var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.O) ? false : tight;
										return $elm$parser$Parser$Advanced$succeed(
											{
												x: _Utils_ap(state.x, value.x),
												O: A2(
													$elm$core$List$cons,
													newRawBlock,
													A2(
														$elm$core$List$cons,
														A6(
															$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
															tight2,
															intended1,
															marker,
															order,
															A2($elm$core$List$cons, value.O, closeListItems2),
															openListItem2),
														rest))
											});
									} else {
										var e = _v66.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								}
							case 1:
								var body1 = newRawBlock.a;
								return $elm$parser$Parser$Advanced$succeed(
									{
										x: state.x,
										O: A2(
											$elm$core$List$cons,
											A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, tight, intended1, marker, order, closeListItems2, openListItem2 + ('\n' + body1)),
											rest)
									});
							default:
								var _v67 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									openListItem2);
								if (!_v67.$) {
									var value = _v67.a;
									var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.O) ? false : tight;
									return $elm$parser$Parser$Advanced$succeed(
										{
											x: _Utils_ap(state.x, value.x),
											O: A2(
												$elm$core$List$cons,
												newRawBlock,
												A2(
													$elm$core$List$cons,
													A6(
														$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
														tight2,
														intended1,
														marker,
														order,
														A2($elm$core$List$cons, value.O, closeListItems2),
														openListItem2),
													rest))
										});
								} else {
									var e = _v67.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
						}
					case 1:
						switch (_v41.a.$) {
							case 1:
								var body1 = _v41.a.a;
								var _v68 = _v41.b;
								var body2 = _v68.a.a;
								var rest = _v68.b;
								return $elm$parser$Parser$Advanced$succeed(
									{
										x: state.x,
										O: A2(
											$elm$core$List$cons,
											$dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(
												A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\n', body2, body1)),
											rest)
									});
							case 13:
								if (!_v41.a.a) {
									var _v69 = _v41.a;
									var _v70 = _v69.a;
									var _v71 = _v41.b;
									var unparsedInlines = _v71.a.a;
									var rest = _v71.b;
									return $elm$parser$Parser$Advanced$succeed(
										{
											x: state.x,
											O: A2(
												$elm$core$List$cons,
												A2($dillonkearns$elm_markdown$Markdown$RawBlock$Heading, 1, unparsedInlines),
												rest)
										});
								} else {
									var _v72 = _v41.a;
									var _v73 = _v72.a;
									var _v74 = _v41.b;
									var unparsedInlines = _v74.a.a;
									var rest = _v74.b;
									return $elm$parser$Parser$Advanced$succeed(
										{
											x: state.x,
											O: A2(
												$elm$core$List$cons,
												A2($dillonkearns$elm_markdown$Markdown$RawBlock$Heading, 2, unparsedInlines),
												rest)
										});
								}
							case 9:
								var _v75 = _v41.a.a;
								var text = _v75.a;
								var alignments = _v75.b;
								var _v76 = _v41.b;
								var rawHeaders = _v76.a.a;
								var rest = _v76.b;
								var _v77 = A2(
									$dillonkearns$elm_markdown$Markdown$TableParser$parseHeader,
									A2($dillonkearns$elm_markdown$Markdown$Table$TableDelimiterRow, text, alignments),
									rawHeaders);
								if (!_v77.$) {
									var headers = _v77.a;
									return $elm$parser$Parser$Advanced$succeed(
										{
											x: state.x,
											O: A2(
												$elm$core$List$cons,
												$dillonkearns$elm_markdown$Markdown$RawBlock$Table(
													A2($dillonkearns$elm_markdown$Markdown$Table$Table, headers, _List_Nil)),
												rest)
										});
								} else {
									return $elm$parser$Parser$Advanced$succeed(
										{
											x: state.x,
											O: A2(
												$elm$core$List$cons,
												$dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(
													A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\n', rawHeaders, text.zN)),
												rest)
										});
								}
							default:
								break _v41$13;
						}
					case 8:
						if (_v41.a.$ === 8) {
							var updatedTable = _v41.a.a;
							var _v78 = _v41.b;
							var rest = _v78.b;
							return $elm$parser$Parser$Advanced$succeed(
								{
									x: state.x,
									O: A2(
										$elm$core$List$cons,
										$dillonkearns$elm_markdown$Markdown$RawBlock$Table(updatedTable),
										rest)
								});
						} else {
							break _v41$13;
						}
					case 10:
						if (_v41.b.b.b) {
							switch (_v41.b.b.a.$) {
								case 4:
									var _v79 = _v41.b;
									var _v80 = _v79.a;
									var _v81 = _v79.b;
									var _v82 = _v81.a;
									var tight = _v82.a;
									var intended1 = _v82.b;
									var marker = _v82.c;
									var order = _v82.d;
									var closeListItems2 = _v82.e;
									var openListItem2 = _v82.f;
									var rest = _v81.b;
									var _v83 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2);
									if (!_v83.$) {
										var value = _v83.a;
										if (newRawBlock.$ === 4) {
											var intended2 = newRawBlock.b;
											var openListItem = newRawBlock.f;
											return $elm$parser$Parser$Advanced$succeed(
												{
													x: _Utils_ap(state.x, value.x),
													O: A2(
														$elm$core$List$cons,
														A6(
															$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
															false,
															intended2,
															marker,
															order,
															A2($elm$core$List$cons, value.O, closeListItems2),
															openListItem),
														rest)
												});
										} else {
											return $elm$parser$Parser$Advanced$succeed(
												{
													x: _Utils_ap(state.x, value.x),
													O: A2(
														$elm$core$List$cons,
														newRawBlock,
														A2(
															$elm$core$List$cons,
															$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
															A2(
																$elm$core$List$cons,
																A6(
																	$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
																	tight,
																	intended1,
																	marker,
																	order,
																	A2($elm$core$List$cons, value.O, closeListItems2),
																	openListItem2),
																rest)))
												});
										}
									} else {
										var e = _v83.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								case 3:
									var _v85 = _v41.b;
									var _v86 = _v85.a;
									var _v87 = _v85.b;
									var _v88 = _v87.a;
									var tight = _v88.a;
									var intended1 = _v88.b;
									var closeListItems2 = _v88.c;
									var openListItem2 = _v88.d;
									var rest = _v87.b;
									var _v89 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2.sY);
									if (!_v89.$) {
										var value = _v89.a;
										if (newRawBlock.$ === 3) {
											var openListItem = newRawBlock.d;
											return $elm$parser$Parser$Advanced$succeed(
												{
													x: _Utils_ap(state.x, value.x),
													O: A2(
														$elm$core$List$cons,
														A4(
															$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
															false,
															intended1,
															A2(
																$elm$core$List$cons,
																{sY: value.O, dr: openListItem2.dr},
																closeListItems2),
															openListItem),
														rest)
												});
										} else {
											return $elm$parser$Parser$Advanced$succeed(
												{
													x: _Utils_ap(state.x, value.x),
													O: A2(
														$elm$core$List$cons,
														newRawBlock,
														A2(
															$elm$core$List$cons,
															$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
															A2(
																$elm$core$List$cons,
																A4(
																	$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
																	tight,
																	intended1,
																	A2(
																		$elm$core$List$cons,
																		{sY: value.O, dr: openListItem2.dr},
																		closeListItems2),
																	openListItem2),
																rest)))
												});
										}
									} else {
										var e = _v89.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								default:
									break _v41$13;
							}
						} else {
							break _v41$13;
						}
					default:
						break _v41$13;
				}
			} else {
				break _v41$13;
			}
		}
		return $elm$parser$Parser$Advanced$succeed(
			{
				x: state.x,
				O: A2($elm$core$List$cons, newRawBlock, state.O)
			});
	});
var $dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper = F2(
	function (referencesDict, _v36) {
		var unparsedInlines = _v36;
		var mappedReferencesDict = $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$mapSecond(
					function (_v37) {
						var destination = _v37.Cg;
						var title = _v37.Gy;
						return _Utils_Tuple2(destination, title);
					}),
				referencesDict));
		return A2(
			$elm$core$List$map,
			$dillonkearns$elm_markdown$Markdown$Parser$mapInline,
			A2($dillonkearns$elm_markdown$Markdown$InlineParser$parse, mappedReferencesDict, unparsedInlines));
	});
var $dillonkearns$elm_markdown$Markdown$Parser$mapInline = function (inline) {
	switch (inline.$) {
		case 0:
			var string = inline.a;
			return $dillonkearns$elm_markdown$Markdown$Block$Text(string);
		case 1:
			return $dillonkearns$elm_markdown$Markdown$Block$HardLineBreak;
		case 2:
			var string = inline.a;
			return $dillonkearns$elm_markdown$Markdown$Block$CodeSpan(string);
		case 3:
			var string = inline.a;
			var maybeString = inline.b;
			var inlines = inline.c;
			return A3(
				$dillonkearns$elm_markdown$Markdown$Block$Link,
				string,
				maybeString,
				A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
		case 4:
			var string = inline.a;
			var maybeString = inline.b;
			var inlines = inline.c;
			return A3(
				$dillonkearns$elm_markdown$Markdown$Block$Image,
				string,
				maybeString,
				A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
		case 5:
			var node = inline.a;
			return $dillonkearns$elm_markdown$Markdown$Block$HtmlInline(
				$dillonkearns$elm_markdown$Markdown$Parser$nodeToRawBlock(node));
		case 6:
			var level = inline.a;
			var inlines = inline.b;
			switch (level) {
				case 1:
					return $dillonkearns$elm_markdown$Markdown$Block$Emphasis(
						A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
				case 2:
					return $dillonkearns$elm_markdown$Markdown$Block$Strong(
						A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
				default:
					return $dillonkearns$elm_markdown$Markdown$Helpers$isEven(level) ? $dillonkearns$elm_markdown$Markdown$Block$Strong(
						_List_fromArray(
							[
								$dillonkearns$elm_markdown$Markdown$Parser$mapInline(
								A2($dillonkearns$elm_markdown$Markdown$Inline$Emphasis, level - 2, inlines))
							])) : $dillonkearns$elm_markdown$Markdown$Block$Emphasis(
						_List_fromArray(
							[
								$dillonkearns$elm_markdown$Markdown$Parser$mapInline(
								A2($dillonkearns$elm_markdown$Markdown$Inline$Emphasis, level - 1, inlines))
							]));
			}
		default:
			var inlines = inline.a;
			return $dillonkearns$elm_markdown$Markdown$Block$Strikethrough(
				A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
	}
};
var $dillonkearns$elm_markdown$Markdown$Parser$nodeToRawBlock = function (node) {
	switch (node.$) {
		case 1:
			return $dillonkearns$elm_markdown$Markdown$Block$HtmlComment('TODO this never happens, but use types to drop this case.');
		case 0:
			var tag = node.a;
			var attributes = node.b;
			var children = node.c;
			var parseChild = function (child) {
				if (child.$ === 1) {
					var text = child.a;
					return $dillonkearns$elm_markdown$Markdown$Parser$textNodeToBlocks(text);
				} else {
					return _List_fromArray(
						[
							$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
							$dillonkearns$elm_markdown$Markdown$Parser$nodeToRawBlock(child))
						]);
				}
			};
			return A3(
				$dillonkearns$elm_markdown$Markdown$Block$HtmlElement,
				tag,
				attributes,
				A2($elm$core$List$concatMap, parseChild, children));
		case 2:
			var string = node.a;
			return $dillonkearns$elm_markdown$Markdown$Block$HtmlComment(string);
		case 3:
			var string = node.a;
			return $dillonkearns$elm_markdown$Markdown$Block$Cdata(string);
		case 4:
			var string = node.a;
			return $dillonkearns$elm_markdown$Markdown$Block$ProcessingInstruction(string);
		default:
			var declarationType = node.a;
			var content = node.b;
			return A2($dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration, declarationType, content);
	}
};
var $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocks = function (children) {
	return A2($dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocksHelp, children, _List_Nil);
};
var $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocksHelp = F2(
	function (remaining, soFar) {
		nodesToBlocksHelp:
		while (true) {
			if (remaining.b) {
				var node = remaining.a;
				var rest = remaining.b;
				var _v31 = A2($dillonkearns$elm_markdown$Markdown$Parser$childToBlocks, node, soFar);
				if (!_v31.$) {
					var newSoFar = _v31.a;
					var $temp$remaining = rest,
						$temp$soFar = newSoFar;
					remaining = $temp$remaining;
					soFar = $temp$soFar;
					continue nodesToBlocksHelp;
				} else {
					var e = _v31.a;
					return $elm$core$Result$Err(e);
				}
			} else {
				return $elm$core$Result$Ok(
					$elm$core$List$reverse(soFar));
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$parse = function (input) {
	var _v27 = A2(
		$elm$parser$Parser$Advanced$run,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
			$dillonkearns$elm_markdown$Helpers$endOfFile),
		input);
	if (_v27.$ === 1) {
		var e = _v27.a;
		return $elm$core$Result$Err(e);
	} else {
		var v = _v27.a;
		var _v28 = $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines(v);
		if (_v28.$ === 1) {
			var e = _v28.a;
			return A2(
				$elm$parser$Parser$Advanced$run,
				$elm$parser$Parser$Advanced$problem(e),
				'');
		} else {
			var blocks = _v28.a;
			var isNotEmptyParagraph = function (block) {
				if ((block.$ === 5) && (!block.a.b)) {
					return false;
				} else {
					return true;
				}
			};
			return $elm$core$Result$Ok(
				A2($elm$core$List$filter, isNotEmptyParagraph, blocks));
		}
	}
};
var $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines = function (state) {
	return A3($dillonkearns$elm_markdown$Markdown$Parser$parseAllInlinesHelp, state, state.O, _List_Nil);
};
var $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlinesHelp = F3(
	function (state, rawBlocks, parsedBlocks) {
		parseAllInlinesHelp:
		while (true) {
			if (rawBlocks.b) {
				var rawBlock = rawBlocks.a;
				var rest = rawBlocks.b;
				var _v26 = A2($dillonkearns$elm_markdown$Markdown$Parser$parseInlines, state.x, rawBlock);
				switch (_v26.$) {
					case 1:
						var newParsedBlock = _v26.a;
						var $temp$state = state,
							$temp$rawBlocks = rest,
							$temp$parsedBlocks = A2($elm$core$List$cons, newParsedBlock, parsedBlocks);
						state = $temp$state;
						rawBlocks = $temp$rawBlocks;
						parsedBlocks = $temp$parsedBlocks;
						continue parseAllInlinesHelp;
					case 0:
						var $temp$state = state,
							$temp$rawBlocks = rest,
							$temp$parsedBlocks = parsedBlocks;
						state = $temp$state;
						rawBlocks = $temp$rawBlocks;
						parsedBlocks = $temp$parsedBlocks;
						continue parseAllInlinesHelp;
					default:
						var e = _v26.a;
						return $elm$core$Result$Err(e);
				}
			} else {
				return $elm$core$Result$Ok(parsedBlocks);
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$parseHeaderInlines = F2(
	function (linkReferences, header) {
		return A2(
			$elm$core$List$map,
			function (_v24) {
				var label = _v24.b2;
				var alignment = _v24.qe;
				return A3(
					$dillonkearns$elm_markdown$Markdown$Parser$parseRawInline,
					linkReferences,
					function (parsedHeaderLabel) {
						return {qe: alignment, b2: parsedHeaderLabel};
					},
					label);
			},
			header);
	});
var $dillonkearns$elm_markdown$Markdown$Parser$parseInlines = F2(
	function (linkReferences, rawBlock) {
		switch (rawBlock.$) {
			case 0:
				var level = rawBlock.a;
				var unparsedInlines = rawBlock.b;
				var _v17 = $dillonkearns$elm_markdown$Markdown$Parser$toHeading(level);
				if (!_v17.$) {
					var parsedLevel = _v17.a;
					return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
						A2(
							$dillonkearns$elm_markdown$Markdown$Block$Heading,
							parsedLevel,
							A2($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper, linkReferences, unparsedInlines)));
				} else {
					var e = _v17.a;
					return $dillonkearns$elm_markdown$Markdown$Parser$InlineProblem(e);
				}
			case 1:
				var unparsedInlines = rawBlock.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$Paragraph(
						A2($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper, linkReferences, unparsedInlines)));
			case 2:
				var html = rawBlock.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(html));
			case 3:
				var tight = rawBlock.a;
				var unparsedItems = rawBlock.c;
				var parseItem = F2(
					function (rawBlockTask, rawBlocks) {
						var blocksTask = function () {
							if (!rawBlockTask.$) {
								if (!rawBlockTask.a) {
									return 1;
								} else {
									return 2;
								}
							} else {
								return 0;
							}
						}();
						var blocks = function () {
							var _v18 = $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines(
								{x: linkReferences, O: rawBlocks});
							if (!_v18.$) {
								var parsedBlocks = _v18.a;
								return parsedBlocks;
							} else {
								return _List_Nil;
							}
						}();
						return A2($dillonkearns$elm_markdown$Markdown$Block$ListItem, blocksTask, blocks);
					});
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					A2(
						$dillonkearns$elm_markdown$Markdown$Block$UnorderedList,
						$dillonkearns$elm_markdown$Markdown$Parser$isTightBoolToListDisplay(tight),
						$elm$core$List$reverse(
							A2(
								$elm$core$List$map,
								function (item) {
									return A2(parseItem, item.dr, item.sY);
								},
								unparsedItems))));
			case 4:
				var tight = rawBlock.a;
				var startingIndex = rawBlock.d;
				var unparsedItems = rawBlock.e;
				var parseItem = function (rawBlocks) {
					var _v20 = $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines(
						{x: linkReferences, O: rawBlocks});
					if (!_v20.$) {
						var parsedBlocks = _v20.a;
						return parsedBlocks;
					} else {
						return _List_Nil;
					}
				};
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					A3(
						$dillonkearns$elm_markdown$Markdown$Block$OrderedList,
						$dillonkearns$elm_markdown$Markdown$Parser$isTightBoolToListDisplay(tight),
						startingIndex,
						$elm$core$List$reverse(
							A2($elm$core$List$map, parseItem, unparsedItems))));
			case 5:
				var codeBlock = rawBlock.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$CodeBlock(codeBlock));
			case 7:
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock($dillonkearns$elm_markdown$Markdown$Block$ThematicBreak);
			case 10:
				return $dillonkearns$elm_markdown$Markdown$Parser$EmptyBlock;
			case 11:
				return $dillonkearns$elm_markdown$Markdown$Parser$EmptyBlock;
			case 12:
				var rawBlocks = rawBlock.a;
				var _v21 = $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines(
					{x: linkReferences, O: rawBlocks});
				if (!_v21.$) {
					var parsedBlocks = _v21.a;
					return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
						$dillonkearns$elm_markdown$Markdown$Block$BlockQuote(parsedBlocks));
				} else {
					var e = _v21.a;
					return $dillonkearns$elm_markdown$Markdown$Parser$InlineProblem(e);
				}
			case 6:
				var codeBlockBody = rawBlock.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$CodeBlock(
						{sY: codeBlockBody, aC: $elm$core$Maybe$Nothing}));
			case 8:
				var _v22 = rawBlock.a;
				var header = _v22.a;
				var rows = _v22.b;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					A2(
						$dillonkearns$elm_markdown$Markdown$Block$Table,
						A2($dillonkearns$elm_markdown$Markdown$Parser$parseHeaderInlines, linkReferences, header),
						A2($dillonkearns$elm_markdown$Markdown$Parser$parseRowInlines, linkReferences, rows)));
			case 9:
				var _v23 = rawBlock.a;
				var text = _v23.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$Paragraph(
						A2($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper, linkReferences, text.zN)));
			default:
				var raw = rawBlock.b;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$Paragraph(
						A2($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper, linkReferences, raw)));
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$parseRawInline = F3(
	function (linkReferences, wrap, unparsedInlines) {
		return wrap(
			A2($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper, linkReferences, unparsedInlines));
	});
var $dillonkearns$elm_markdown$Markdown$Parser$parseRowInlines = F2(
	function (linkReferences, rows) {
		return A2(
			$elm$core$List$map,
			function (row) {
				return A2(
					$elm$core$List$map,
					function (column) {
						return A3($dillonkearns$elm_markdown$Markdown$Parser$parseRawInline, linkReferences, $elm$core$Basics$identity, column);
					},
					row);
			},
			rows);
	});
var $dillonkearns$elm_markdown$Markdown$Parser$stepRawBlock = function (revStmts) {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v2) {
					return $elm$parser$Parser$Advanced$Done(revStmts);
				},
				$dillonkearns$elm_markdown$Helpers$endOfFile),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (reference) {
					return $elm$parser$Parser$Advanced$Loop(
						A2($dillonkearns$elm_markdown$Markdown$Parser$addReference, revStmts, reference));
				},
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$parser)),
				function () {
				var _v3 = revStmts.O;
				_v3$6:
				while (true) {
					if (_v3.b) {
						switch (_v3.a.$) {
							case 1:
								return A2(
									$elm$parser$Parser$Advanced$map,
									function (block) {
										return $elm$parser$Parser$Advanced$Loop(block);
									},
									A2(
										$elm$parser$Parser$Advanced$andThen,
										$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterOpenBlockOrParagraphParser()));
							case 8:
								var table = _v3.a.a;
								return A2(
									$elm$parser$Parser$Advanced$map,
									function (block) {
										return $elm$parser$Parser$Advanced$Loop(block);
									},
									A2(
										$elm$parser$Parser$Advanced$andThen,
										$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
										$elm$parser$Parser$Advanced$oneOf(
											_List_fromArray(
												[
													$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser(),
													$dillonkearns$elm_markdown$Markdown$Parser$tableRowIfTableStarted(table)
												]))));
							case 3:
								var _v4 = _v3.a;
								var tight = _v4.a;
								var intended = _v4.b;
								var closeListItems = _v4.c;
								var openListItem = _v4.d;
								var rest = _v3.b;
								var completeOrMergeUnorderedListBlockBlankLine = F2(
									function (state, newString) {
										return _Utils_update(
											state,
											{
												O: A2(
													$elm$core$List$cons,
													$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
													A2(
														$elm$core$List$cons,
														A4(
															$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
															tight,
															intended,
															closeListItems,
															_Utils_update(
																openListItem,
																{
																	sY: A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '', openListItem.sY, newString)
																})),
														rest))
											});
									});
								var completeOrMergeUnorderedListBlock = F2(
									function (state, newString) {
										return _Utils_update(
											state,
											{
												O: A2(
													$elm$core$List$cons,
													A4(
														$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
														tight,
														intended,
														closeListItems,
														_Utils_update(
															openListItem,
															{
																sY: A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\n', openListItem.sY, newString)
															})),
													rest)
											});
									});
								return $elm$parser$Parser$Advanced$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$map,
												function (_v5) {
													return A2(completeOrMergeUnorderedListBlockBlankLine, revStmts, '\n');
												},
												$dillonkearns$elm_markdown$Markdown$Parser$blankLine)),
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$map,
												completeOrMergeUnorderedListBlock(revStmts),
												A2(
													$elm$parser$Parser$Advanced$keeper,
													A2(
														$elm$parser$Parser$Advanced$ignorer,
														$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
														$elm$parser$Parser$Advanced$symbol(
															A2(
																$elm$parser$Parser$Advanced$Token,
																A2($elm$core$String$repeat, intended, ' '),
																$elm$parser$Parser$ExpectingSymbol('Indentation')))),
													A2(
														$elm$parser$Parser$Advanced$ignorer,
														$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
														$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)))),
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$andThen,
												$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
												$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterList()))
										]));
							case 4:
								var _v10 = _v3.a;
								var tight = _v10.a;
								var intended = _v10.b;
								var marker = _v10.c;
								var order = _v10.d;
								var closeListItems = _v10.e;
								var openListItem = _v10.f;
								var rest = _v3.b;
								var completeOrMergeUnorderedListBlockBlankLine = F2(
									function (state, newString) {
										return _Utils_update(
											state,
											{
												O: A2(
													$elm$core$List$cons,
													$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
													A2(
														$elm$core$List$cons,
														A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, tight, intended, marker, order, closeListItems, openListItem + ('\n' + newString)),
														rest))
											});
									});
								var completeOrMergeUnorderedListBlock = F2(
									function (state, newString) {
										return _Utils_update(
											state,
											{
												O: A2(
													$elm$core$List$cons,
													A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, tight, intended, marker, order, closeListItems, openListItem + ('\n' + newString)),
													rest)
											});
									});
								return $elm$parser$Parser$Advanced$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$map,
												function (_v11) {
													return A2(completeOrMergeUnorderedListBlockBlankLine, revStmts, '\n');
												},
												$dillonkearns$elm_markdown$Markdown$Parser$blankLine)),
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$map,
												completeOrMergeUnorderedListBlock(revStmts),
												A2(
													$elm$parser$Parser$Advanced$keeper,
													A2(
														$elm$parser$Parser$Advanced$ignorer,
														$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
														$elm$parser$Parser$Advanced$symbol(
															A2(
																$elm$parser$Parser$Advanced$Token,
																A2($elm$core$String$repeat, intended, ' '),
																$elm$parser$Parser$ExpectingSymbol('Indentation')))),
													A2(
														$elm$parser$Parser$Advanced$ignorer,
														$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
														$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)))),
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$andThen,
												$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
												$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterList()))
										]));
							case 10:
								if (_v3.b.b) {
									switch (_v3.b.a.$) {
										case 3:
											var _v6 = _v3.a;
											var _v7 = _v3.b;
											var _v8 = _v7.a;
											var tight = _v8.a;
											var intended = _v8.b;
											var closeListItems = _v8.c;
											var openListItem = _v8.d;
											var rest = _v7.b;
											var completeOrMergeUnorderedListBlockBlankLine = F2(
												function (state, newString) {
													return _Utils_update(
														state,
														{
															O: A2(
																$elm$core$List$cons,
																$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
																A2(
																	$elm$core$List$cons,
																	A4(
																		$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
																		tight,
																		intended,
																		closeListItems,
																		_Utils_update(
																			openListItem,
																			{
																				sY: A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '', openListItem.sY, newString)
																			})),
																	rest))
														});
												});
											var completeOrMergeUnorderedListBlock = F2(
												function (state, newString) {
													return _Utils_update(
														state,
														{
															O: A2(
																$elm$core$List$cons,
																A4(
																	$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
																	tight,
																	intended,
																	closeListItems,
																	_Utils_update(
																		openListItem,
																		{
																			sY: A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\n', openListItem.sY, newString)
																		})),
																rest)
														});
												});
											return ($elm$core$String$trim(openListItem.sY) === '') ? A2(
												$elm$parser$Parser$Advanced$map,
												function (block) {
													return $elm$parser$Parser$Advanced$Loop(block);
												},
												A2(
													$elm$parser$Parser$Advanced$andThen,
													$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
													$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser())) : $elm$parser$Parser$Advanced$oneOf(
												_List_fromArray(
													[
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$map,
															function (_v9) {
																return A2(completeOrMergeUnorderedListBlockBlankLine, revStmts, '\n');
															},
															$dillonkearns$elm_markdown$Markdown$Parser$blankLine)),
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$map,
															completeOrMergeUnorderedListBlock(revStmts),
															A2(
																$elm$parser$Parser$Advanced$keeper,
																A2(
																	$elm$parser$Parser$Advanced$ignorer,
																	$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
																	$elm$parser$Parser$Advanced$symbol(
																		A2(
																			$elm$parser$Parser$Advanced$Token,
																			A2($elm$core$String$repeat, intended, ' '),
																			$elm$parser$Parser$ExpectingSymbol('Indentation')))),
																A2(
																	$elm$parser$Parser$Advanced$ignorer,
																	$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
																	$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)))),
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$andThen,
															$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
															$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser()))
													]));
										case 4:
											var _v12 = _v3.a;
											var _v13 = _v3.b;
											var _v14 = _v13.a;
											var tight = _v14.a;
											var intended = _v14.b;
											var marker = _v14.c;
											var order = _v14.d;
											var closeListItems = _v14.e;
											var openListItem = _v14.f;
											var rest = _v13.b;
											var completeOrMergeUnorderedListBlockBlankLine = F2(
												function (state, newString) {
													return _Utils_update(
														state,
														{
															O: A2(
																$elm$core$List$cons,
																$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
																A2(
																	$elm$core$List$cons,
																	A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, tight, intended, marker, order, closeListItems, openListItem + ('\n' + newString)),
																	rest))
														});
												});
											var completeOrMergeUnorderedListBlock = F2(
												function (state, newString) {
													return _Utils_update(
														state,
														{
															O: A2(
																$elm$core$List$cons,
																A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, tight, intended, marker, order, closeListItems, openListItem + ('\n' + newString)),
																rest)
														});
												});
											return ($elm$core$String$trim(openListItem) === '') ? A2(
												$elm$parser$Parser$Advanced$map,
												function (block) {
													return $elm$parser$Parser$Advanced$Loop(block);
												},
												A2(
													$elm$parser$Parser$Advanced$andThen,
													$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
													$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser())) : $elm$parser$Parser$Advanced$oneOf(
												_List_fromArray(
													[
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$map,
															function (_v15) {
																return A2(completeOrMergeUnorderedListBlockBlankLine, revStmts, '\n');
															},
															$dillonkearns$elm_markdown$Markdown$Parser$blankLine)),
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$map,
															completeOrMergeUnorderedListBlock(revStmts),
															A2(
																$elm$parser$Parser$Advanced$keeper,
																A2(
																	$elm$parser$Parser$Advanced$ignorer,
																	$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
																	$elm$parser$Parser$Advanced$symbol(
																		A2(
																			$elm$parser$Parser$Advanced$Token,
																			A2($elm$core$String$repeat, intended, ' '),
																			$elm$parser$Parser$ExpectingSymbol('Indentation')))),
																A2(
																	$elm$parser$Parser$Advanced$ignorer,
																	$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
																	$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)))),
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$andThen,
															$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
															$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser()))
													]));
										default:
											break _v3$6;
									}
								} else {
									break _v3$6;
								}
							default:
								break _v3$6;
						}
					} else {
						break _v3$6;
					}
				}
				return A2(
					$elm$parser$Parser$Advanced$map,
					function (block) {
						return $elm$parser$Parser$Advanced$Loop(block);
					},
					A2(
						$elm$parser$Parser$Advanced$andThen,
						$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
						$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser()));
			}(),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (block) {
					return $elm$parser$Parser$Advanced$Loop(block);
				},
				A2(
					$elm$parser$Parser$Advanced$andThen,
					$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
					$dillonkearns$elm_markdown$Markdown$Parser$openBlockOrParagraphParser))
			]));
};
var $dillonkearns$elm_markdown$Markdown$Parser$textNodeToBlocks = function (textNodeValue) {
	return A2(
		$elm$core$Result$withDefault,
		_List_Nil,
		$dillonkearns$elm_markdown$Markdown$Parser$parse(textNodeValue));
};
var $dillonkearns$elm_markdown$Markdown$Parser$xmlNodeToHtmlNode = function (xmlNode) {
	switch (xmlNode.$) {
		case 1:
			var innerText = xmlNode.a;
			return $elm$parser$Parser$Advanced$succeed(
				$dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(innerText));
		case 0:
			var tag = xmlNode.a;
			var attributes = xmlNode.b;
			var children = xmlNode.c;
			var _v1 = $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocks(children);
			if (!_v1.$) {
				var parsedChildren = _v1.a;
				return $elm$parser$Parser$Advanced$succeed(
					$dillonkearns$elm_markdown$Markdown$RawBlock$Html(
						A3($dillonkearns$elm_markdown$Markdown$Block$HtmlElement, tag, attributes, parsedChildren)));
			} else {
				var err = _v1.a;
				return $elm$parser$Parser$Advanced$problem(err);
			}
		case 2:
			var string = xmlNode.a;
			return $elm$parser$Parser$Advanced$succeed(
				$dillonkearns$elm_markdown$Markdown$RawBlock$Html(
					$dillonkearns$elm_markdown$Markdown$Block$HtmlComment(string)));
		case 3:
			var string = xmlNode.a;
			return $elm$parser$Parser$Advanced$succeed(
				$dillonkearns$elm_markdown$Markdown$RawBlock$Html(
					$dillonkearns$elm_markdown$Markdown$Block$Cdata(string)));
		case 4:
			var string = xmlNode.a;
			return $elm$parser$Parser$Advanced$succeed(
				$dillonkearns$elm_markdown$Markdown$RawBlock$Html(
					$dillonkearns$elm_markdown$Markdown$Block$ProcessingInstruction(string)));
		default:
			var declarationType = xmlNode.a;
			var content = xmlNode.b;
			return $elm$parser$Parser$Advanced$succeed(
				$dillonkearns$elm_markdown$Markdown$RawBlock$Html(
					A2($dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration, declarationType, content)));
	}
};
function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser() {
	return A2(
		$elm$parser$Parser$Advanced$andThen,
		$dillonkearns$elm_markdown$Markdown$Parser$completeBlocks,
		A2(
			$elm$parser$Parser$Advanced$loop,
			{x: _List_Nil, O: _List_Nil},
			$dillonkearns$elm_markdown$Markdown$Parser$stepRawBlock));
}
function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser() {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				$dillonkearns$elm_markdown$Markdown$Parser$parseAsParagraphInsteadOfHtmlBlock,
				$dillonkearns$elm_markdown$Markdown$Parser$blankLine,
				$dillonkearns$elm_markdown$Markdown$Parser$blockQuote,
				A2(
				$elm$parser$Parser$Advanced$map,
				$dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock,
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$CodeBlock$parser)),
				$dillonkearns$elm_markdown$Markdown$Parser$indentedCodeBlock,
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v40) {
					return $dillonkearns$elm_markdown$Markdown$RawBlock$ThematicBreak;
				},
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$ThematicBreak$parser)),
				$dillonkearns$elm_markdown$Markdown$Parser$unorderedListBlock(false),
				$dillonkearns$elm_markdown$Markdown$Parser$orderedListBlock(false),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Heading$parser),
				$dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser()
			]));
}
function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterOpenBlockOrParagraphParser() {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				$dillonkearns$elm_markdown$Markdown$Parser$parseAsParagraphInsteadOfHtmlBlock,
				$dillonkearns$elm_markdown$Markdown$Parser$blankLine,
				$dillonkearns$elm_markdown$Markdown$Parser$blockQuote,
				A2(
				$elm$parser$Parser$Advanced$map,
				$dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock,
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$CodeBlock$parser)),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Parser$setextLineParser),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v39) {
					return $dillonkearns$elm_markdown$Markdown$RawBlock$ThematicBreak;
				},
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$ThematicBreak$parser)),
				$dillonkearns$elm_markdown$Markdown$Parser$unorderedListBlock(true),
				$dillonkearns$elm_markdown$Markdown$Parser$orderedListBlock(true),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Heading$parser),
				$dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser(),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Parser$tableDelimiterInOpenParagraph)
			]));
}
function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterList() {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				$dillonkearns$elm_markdown$Markdown$Parser$parseAsParagraphInsteadOfHtmlBlock,
				$dillonkearns$elm_markdown$Markdown$Parser$blankLine,
				$dillonkearns$elm_markdown$Markdown$Parser$blockQuote,
				A2(
				$elm$parser$Parser$Advanced$map,
				$dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock,
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$CodeBlock$parser)),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v38) {
					return $dillonkearns$elm_markdown$Markdown$RawBlock$ThematicBreak;
				},
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$ThematicBreak$parser)),
				$dillonkearns$elm_markdown$Markdown$Parser$unorderedListBlock(false),
				$dillonkearns$elm_markdown$Markdown$Parser$orderedListBlock(false),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Heading$parser),
				$dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser()
			]));
}
function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser() {
	return A2($elm$parser$Parser$Advanced$andThen, $dillonkearns$elm_markdown$Markdown$Parser$xmlNodeToHtmlNode, $dillonkearns$elm_markdown$HtmlParser$html);
}
var $dillonkearns$elm_markdown$Markdown$Parser$rawBlockParser = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser();
$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser = function () {
	return $dillonkearns$elm_markdown$Markdown$Parser$rawBlockParser;
};
var $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockNotAfterOpenBlockOrParagraphParser = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser();
$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser = function () {
	return $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockNotAfterOpenBlockOrParagraphParser;
};
var $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockAfterOpenBlockOrParagraphParser = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterOpenBlockOrParagraphParser();
$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterOpenBlockOrParagraphParser = function () {
	return $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockAfterOpenBlockOrParagraphParser;
};
var $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockAfterList = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterList();
$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterList = function () {
	return $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockAfterList;
};
var $dillonkearns$elm_markdown$Markdown$Parser$htmlParser = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser();
$dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser = function () {
	return $dillonkearns$elm_markdown$Markdown$Parser$htmlParser;
};
var $dillonkearns$elm_markdown$Markdown$Renderer$combineResults = A2(
	$elm$core$List$foldr,
	$elm$core$Result$map2($elm$core$List$cons),
	$elm$core$Result$Ok(_List_Nil));
var $dillonkearns$elm_markdown$Markdown$Block$foldl = F3(
	function (_function, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var block = list.a;
				var remainingBlocks = list.b;
				switch (block.$) {
					case 0:
						var html = block.a;
						if (!html.$) {
							var children = html.c;
							var $temp$function = _function,
								$temp$acc = A2(_function, block, acc),
								$temp$list = _Utils_ap(children, remainingBlocks);
							_function = $temp$function;
							acc = $temp$acc;
							list = $temp$list;
							continue foldl;
						} else {
							var $temp$function = _function,
								$temp$acc = A2(_function, block, acc),
								$temp$list = remainingBlocks;
							_function = $temp$function;
							acc = $temp$acc;
							list = $temp$list;
							continue foldl;
						}
					case 1:
						var blocks = block.b;
						var childBlocks = A2(
							$elm$core$List$concatMap,
							function (_v3) {
								var children = _v3.b;
								return children;
							},
							blocks);
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = _Utils_ap(childBlocks, remainingBlocks);
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 2:
						var blocks = block.c;
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = _Utils_ap(
							$elm$core$List$concat(blocks),
							remainingBlocks);
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 3:
						var blocks = block.a;
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = _Utils_ap(blocks, remainingBlocks);
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 4:
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 5:
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 6:
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 7:
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					default:
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText = function (block) {
	switch (block.$) {
		case 5:
			var inlines = block.a;
			return $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines);
		case 0:
			var html = block.a;
			if (!html.$) {
				var blocks = html.c;
				return A3(
					$dillonkearns$elm_markdown$Markdown$Block$foldl,
					F2(
						function (nestedBlock, soFar) {
							return _Utils_ap(
								soFar,
								$dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText(nestedBlock));
						}),
					'',
					blocks);
			} else {
				return '';
			}
		case 1:
			var items = block.b;
			return A2(
				$elm$core$String$join,
				'\n',
				A2(
					$elm$core$List$map,
					function (_v4) {
						var blocks = _v4.b;
						return A2(
							$elm$core$String$join,
							'\n',
							A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText, blocks));
					},
					items));
		case 2:
			var items = block.c;
			return A2(
				$elm$core$String$join,
				'\n',
				A2(
					$elm$core$List$map,
					function (blocks) {
						return A2(
							$elm$core$String$join,
							'\n',
							A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText, blocks));
					},
					items));
		case 3:
			var blocks = block.a;
			return A2(
				$elm$core$String$join,
				'\n',
				A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText, blocks));
		case 4:
			var inlines = block.b;
			return $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines);
		case 6:
			var header = block.a;
			var rows = block.b;
			return A2(
				$elm$core$String$join,
				'\n',
				$elm$core$List$concat(
					_List_fromArray(
						[
							A2(
							$elm$core$List$map,
							$dillonkearns$elm_markdown$Markdown$Block$extractInlineText,
							A2(
								$elm$core$List$map,
								function ($) {
									return $.b2;
								},
								header)),
							$elm$core$List$concat(
							A2(
								$elm$core$List$map,
								$elm$core$List$map($dillonkearns$elm_markdown$Markdown$Block$extractInlineText),
								rows))
						])));
		case 7:
			var body = block.a.sY;
			return body;
		default:
			return '';
	}
};
var $dillonkearns$elm_markdown$Markdown$Block$extractInlineText = function (inlines) {
	return A3($elm$core$List$foldl, $dillonkearns$elm_markdown$Markdown$Block$extractTextHelp, '', inlines);
};
var $dillonkearns$elm_markdown$Markdown$Block$extractTextHelp = F2(
	function (inline, text) {
		switch (inline.$) {
			case 7:
				var str = inline.a;
				return _Utils_ap(text, str);
			case 8:
				return text + ' ';
			case 6:
				var str = inline.a;
				return _Utils_ap(text, str);
			case 1:
				var inlines = inline.c;
				return _Utils_ap(
					text,
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
			case 2:
				var inlines = inline.c;
				return _Utils_ap(
					text,
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
			case 0:
				var html = inline.a;
				if (!html.$) {
					var blocks = html.c;
					return A3(
						$dillonkearns$elm_markdown$Markdown$Block$foldl,
						F2(
							function (block, soFar) {
								return _Utils_ap(
									soFar,
									$dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText(block));
							}),
						text,
						blocks);
				} else {
					return text;
				}
			case 4:
				var inlines = inline.a;
				return _Utils_ap(
					text,
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
			case 3:
				var inlines = inline.a;
				return _Utils_ap(
					text,
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
			default:
				var inlines = inline.a;
				return _Utils_ap(
					text,
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
		}
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$renderHtml = F5(
	function (tagName, attributes, children, _v0, renderedChildren) {
		var htmlRenderer = _v0;
		return A2(
			$elm$core$Result$andThen,
			function (okChildren) {
				return A2(
					$elm$core$Result$map,
					function (myRenderer) {
						return myRenderer(okChildren);
					},
					A3(htmlRenderer, tagName, attributes, children));
			},
			$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(renderedChildren));
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$foldThing = F3(
	function (renderer, topLevelInline, soFar) {
		var _v12 = A2($dillonkearns$elm_markdown$Markdown$Renderer$renderSingleInline, renderer, topLevelInline);
		if (!_v12.$) {
			var inline = _v12.a;
			return A2($elm$core$List$cons, inline, soFar);
		} else {
			return soFar;
		}
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$renderHelper = F2(
	function (renderer, blocks) {
		return A2(
			$elm$core$List$filterMap,
			$dillonkearns$elm_markdown$Markdown$Renderer$renderHelperSingle(renderer),
			blocks);
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$renderHelperSingle = function (renderer) {
	return function (block) {
		switch (block.$) {
			case 4:
				var level = block.a;
				var content = block.b;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						function (children) {
							return renderer.yu(
								{
									aT: children,
									y0: level,
									Fv: $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(content)
								});
						},
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, content)));
			case 5:
				var content = block.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.vP,
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, content)));
			case 0:
				var html = block.a;
				if (!html.$) {
					var tag = html.a;
					var attributes = html.b;
					var children = html.c;
					return $elm$core$Maybe$Just(
						A4($dillonkearns$elm_markdown$Markdown$Renderer$renderHtmlNode, renderer, tag, attributes, children));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 1:
				var tight = block.a;
				var items = block.b;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						function (listItems) {
							return renderer.wR(
								A2(
									$elm$core$List$map,
									function (_v7) {
										var task = _v7.a;
										var children = _v7.b;
										return A2(
											$dillonkearns$elm_markdown$Markdown$Block$ListItem,
											task,
											$elm$core$List$concat(children));
									},
									listItems));
						},
						$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
							A2(
								$elm$core$List$map,
								function (_v4) {
									var task = _v4.a;
									var children = _v4.b;
									return A2(
										$elm$core$Result$map,
										$dillonkearns$elm_markdown$Markdown$Block$ListItem(task),
										$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
											function (blocks) {
												return A2(
													$elm$core$List$filterMap,
													function (listItemBlock) {
														var _v5 = _Utils_Tuple2(tight, listItemBlock);
														if ((_v5.a === 1) && (_v5.b.$ === 5)) {
															var _v6 = _v5.a;
															var content = _v5.b.a;
															return $elm$core$Maybe$Just(
																A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, content));
														} else {
															return A2(
																$elm$core$Maybe$map,
																$elm$core$Result$map($elm$core$List$singleton),
																A2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelperSingle, renderer, listItemBlock));
														}
													},
													blocks);
											}(children)));
								},
								items))));
			case 2:
				var tight = block.a;
				var startingIndex = block.b;
				var items = block.c;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						function (listItems) {
							return A2(
								renderer.vF,
								startingIndex,
								A2(
									$elm$core$List$map,
									function (children) {
										return $elm$core$List$concat(children);
									},
									listItems));
						},
						$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
							A2(
								$elm$core$List$map,
								function (itemsblocks) {
									return $dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
										function (blocks) {
											return A2(
												$elm$core$List$filterMap,
												function (listItemBlock) {
													var _v8 = _Utils_Tuple2(tight, listItemBlock);
													if ((_v8.a === 1) && (_v8.b.$ === 5)) {
														var _v9 = _v8.a;
														var content = _v8.b.a;
														return $elm$core$Maybe$Just(
															A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, content));
													} else {
														return A2(
															$elm$core$Maybe$map,
															$elm$core$Result$map($elm$core$List$singleton),
															A2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelperSingle, renderer, listItemBlock));
													}
												},
												blocks);
										}(itemsblocks));
								},
								items))));
			case 7:
				var codeBlock = block.a;
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(
						renderer.ta(codeBlock)));
			case 8:
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(renderer.wE));
			case 3:
				var nestedBlocks = block.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.sW,
						$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
							A2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelper, renderer, nestedBlocks))));
			default:
				var header = block.a;
				var rows = block.b;
				var renderedHeaderCells = $dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
					A2(
						$elm$core$List$map,
						function (_v11) {
							var label = _v11.b2;
							var alignment = _v11.qe;
							return A2(
								$elm$core$Result$map,
								$elm$core$Tuple$pair(alignment),
								A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, label));
						},
						header));
				var renderedHeader = A2(
					$elm$core$Result$map,
					function (listListView) {
						return renderer.wz(
							$elm$core$List$singleton(
								renderer.sz(
									A2(
										$elm$core$List$map,
										function (_v10) {
											var maybeAlignment = _v10.a;
											var item = _v10.b;
											return A2(renderer.wA, maybeAlignment, item);
										},
										listListView))));
					},
					renderedHeaderCells);
				var renderedBody = function (r) {
					return $elm$core$List$isEmpty(r) ? _List_Nil : _List_fromArray(
						[
							renderer.wx(r)
						]);
				};
				var alignmentForColumn = function (columnIndex) {
					return A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.qe;
						},
						$elm$core$List$head(
							A2($elm$core$List$drop, columnIndex, header)));
				};
				var renderRow = function (cells) {
					return A2(
						$elm$core$Result$map,
						renderer.sz,
						A2(
							$elm$core$Result$map,
							$elm$core$List$indexedMap(
								F2(
									function (index, cell) {
										return A2(
											renderer.wy,
											alignmentForColumn(index),
											cell);
									})),
							$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
								A2(
									$elm$core$List$map,
									$dillonkearns$elm_markdown$Markdown$Renderer$renderStyled(renderer),
									cells))));
				};
				var renderedRows = $dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
					A2($elm$core$List$map, renderRow, rows));
				return $elm$core$Maybe$Just(
					A3(
						$elm$core$Result$map2,
						F2(
							function (h, r) {
								return renderer.ww(
									A2(
										$elm$core$List$cons,
										h,
										renderedBody(r)));
							}),
						renderedHeader,
						renderedRows));
		}
	};
};
var $dillonkearns$elm_markdown$Markdown$Renderer$renderHtmlNode = F4(
	function (renderer, tag, attributes, children) {
		return A5(
			$dillonkearns$elm_markdown$Markdown$Renderer$renderHtml,
			tag,
			attributes,
			children,
			renderer.t2,
			A2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelper, renderer, children));
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$renderSingleInline = F2(
	function (renderer, inline) {
		switch (inline.$) {
			case 4:
				var innerInlines = inline.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.ws,
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, innerInlines)));
			case 3:
				var innerInlines = inline.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.tL,
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, innerInlines)));
			case 5:
				var innerInlines = inline.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.wr,
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, innerInlines)));
			case 2:
				var src = inline.a;
				var title = inline.b;
				var children = inline.c;
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(
						renderer.t5(
							{
								sS: $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(children),
								fG: src,
								Gy: title
							})));
			case 7:
				var string = inline.a;
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(
						renderer.Gv(string)));
			case 6:
				var string = inline.a;
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(
						renderer.tb(string)));
			case 1:
				var destination = inline.a;
				var title = inline.b;
				var inlines = inline.c;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$andThen,
						function (children) {
							return $elm$core$Result$Ok(
								A2(
									renderer.D1,
									{Cg: destination, Gy: title},
									children));
						},
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, inlines)));
			case 8:
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(renderer.t$));
			default:
				var html = inline.a;
				if (!html.$) {
					var tag = html.a;
					var attributes = html.b;
					var children = html.c;
					return $elm$core$Maybe$Just(
						A4($dillonkearns$elm_markdown$Markdown$Renderer$renderHtmlNode, renderer, tag, attributes, children));
				} else {
					return $elm$core$Maybe$Nothing;
				}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$renderStyled = F2(
	function (renderer, styledStrings) {
		return $dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
			A3(
				$elm$core$List$foldr,
				$dillonkearns$elm_markdown$Markdown$Renderer$foldThing(renderer),
				_List_Nil,
				styledStrings));
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$render = F2(
	function (renderer, ast) {
		return $dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
			A2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelper, renderer, ast));
	});
var $author$project$Components$BreakingChanges$view = function (model) {
	var statusUpdateDecoder = A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$BreakingChanges$OnStatusUpdate,
		A2($elm$json$Json$Decode$field, 'detail', $elm$json$Json$Decode$string));
	var markdownReceivedDecoder = A2(
		$elm$json$Json$Decode$map,
		$author$project$Components$BreakingChanges$OnMarkdownReceived,
		A2($elm$json$Json$Decode$field, 'detail', $elm$json$Json$Decode$string));
	var markdown = function () {
		var rendered = $elm$core$Result$toMaybe(
			A2(
				$elm$core$Result$andThen,
				$dillonkearns$elm_markdown$Markdown$Renderer$render($dillonkearns$elm_markdown$Markdown$Renderer$defaultHtmlRenderer),
				A2(
					$elm$core$Result$mapError,
					$elm$core$Basics$always('ignored'),
					$dillonkearns$elm_markdown$Markdown$Parser$parse(model.mw))));
		if (!rendered.$) {
			var content = rendered.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('markdown')
					]),
				content);
		} else {
			return $elm$html$Html$text(model.mw);
		}
	}();
	var key = A2(
		$elm$core$String$join,
		'|',
		_List_fromArray(
			[
				$author$project$Model$Namespace$getNamespace(model.jo),
				$author$project$Model$Namespace$getName(model.jo),
				model.nO,
				model.nP
			]));
	var isLoading = model.mw === '';
	var loadedAttr = isLoading ? _List_fromArray(
		[
			A2($elm$html$Html$Attributes$attribute, 'open', '')
		]) : _List_Nil;
	var attributes = _Utils_ap(
		_List_fromArray(
			[
				A2($elm$html$Html$Events$on, 'statusUpdate', statusUpdateDecoder),
				A2($elm$html$Html$Events$on, 'markdownReceived', markdownReceivedDecoder),
				A2(
				$elm$html$Html$Attributes$attribute,
				'namespace',
				$author$project$Model$Namespace$getNamespace(model.jo)),
				A2(
				$elm$html$Html$Attributes$attribute,
				'library_name',
				$author$project$Model$Namespace$getName(model.jo)),
				A2($elm$html$Html$Attributes$attribute, 'version_current', model.nO),
				A2($elm$html$Html$Attributes$attribute, 'version_new', model.nP),
				A2($elm$html$Html$Attributes$attribute, 'class', 'breaking-changes-wrapper'),
				A2(
				$elm$html$Html$Attributes$attribute,
				'summarize',
				model.pT ? 'true' : 'false')
			]),
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$html$Html$Attributes$attribute('prune_directory'),
					$elm$core$List$singleton),
				model.pv)));
	return A3(
		$elm$html$Html$Keyed$node,
		'div',
		_List_Nil,
		_List_fromArray(
			[
				_Utils_Tuple2(
				key,
				A3(
					$elm$html$Html$node,
					'breaking-changes',
					attributes,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$details,
							A2(
								$elm$core$List$append,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('breaking-changes-status')
									]),
								loadedAttr),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$summary,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Status')
														])),
													isLoading ? A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('breaking-changes-loading-status')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Loading'),
															$author$project$Views$Loading$dots
														])) : A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('breaking-changes-loading-status')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Ready')
														]))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$id(
											$author$project$Components$BreakingChanges$statusDomId(model))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(model.st)
										]))
								])),
							markdown
						])))
			]));
};
var $author$project$Views$ImpactReport$viewBreakingChanges = F2(
	function (session, model) {
		var packageDict = $author$project$Views$ImpactReport$changedRequestedPackages(model);
		var selectedPackage = A2(
			$elm$core$Maybe$andThen,
			function (key) {
				return A2($elm$core$Dict$get, key, packageDict);
			},
			model.ns);
		return ($author$project$Model$Permissions$orgCanViewBreakingChanges(model.c3) || $author$project$Model$Session$isSuperUserWithFeaturesVisible(session)) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('breaking-changes-section columns'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'superuser-only',
							!$author$project$Model$Permissions$orgCanViewBreakingChanges(model.c3))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('changed-package-column column narrow')
						]),
					A2(
						$author$project$Misc$displayListIf,
						!$elm$core$Dict$isEmpty(packageDict),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Changed Packages')
									])),
								A2(
								$elm$html$Html$ul,
								_List_Nil,
								A2(
									$elm$core$List$map,
									function (p) {
										return A2(
											$elm$html$Html$li,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2(
															'selected',
															_Utils_eq(
																model.ns,
																$elm$core$Maybe$Just(p.Y)))
														])),
													$elm$html$Html$Events$onClick(
													$author$project$Views$ImpactReport$SelectBreakingChange(p))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Model$Namespace$getName(p.Y) + (' ' + (p.rG + (' to ' + p.rD))))
												]));
									},
									$author$project$Views$ImpactReport$sortedChangedRequestedPackages(packageDict)))
							]))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('changes column')
						]),
					_List_fromArray(
						[
							function () {
							if (selectedPackage.$ === 1) {
								return $elm$core$Dict$isEmpty(packageDict) ? $elm$html$Html$text('No supported changed packages found') : $elm$html$Html$text('Select a package on the left');
							} else {
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Misc$displayMaybe,
											A2(
												$elm$core$Basics$composeR,
												$author$project$Components$BreakingChanges$view,
												$elm$html$Html$map($author$project$Views$ImpactReport$BreakingChangesMsg)),
											model.kZ)
										]));
							}
						}()
						]))
				])) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('breaking-changes-section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Curious how updates impact your overall application performance?')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Securing your open source means staying up to date with newer versions, but you want to make sure you understand where it might impact first-party code and overall application performance. To learn more about how to identify breaking changes associated with updating open source packages, contact one of our open source experts.')
						])),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('https://www.activestate.com/contact-our-experts/'),
							$elm$html$Html$Attributes$target('blank')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Get in touch now'),
							$author$project$Views$Icon$view(
							$author$project$Views$Icon$icon(25))
						]))
				]));
	});
var $author$project$Views$ImpactReport$ToggleHideUnchanged = function (a) {
	return {$: 5, a: a};
};
var $author$project$Views$ImpactReport$getLanguageVersions = function (ingredients) {
	var _v0 = A3(
		$elm$core$List$foldr,
		F2(
			function (ingredient, acc) {
				if ($author$project$Views$ImpactReport$isLanguage(ingredient)) {
					var name = ingredient.w;
					var _v1 = _Utils_Tuple2(ingredient.xl, ingredient.w9);
					if (!_v1.a.$) {
						if (_v1.b.$ === 1) {
							var version = _v1.a.a.aI;
							var _v3 = _v1.b;
							return _Utils_update(
								acc,
								{
									ji: A2(
										$elm$core$List$cons,
										{w: name, aI: version},
										acc.ji)
								});
						} else {
							var before = _v1.a.a;
							var after = _v1.b.a;
							return _Utils_update(
								acc,
								{
									jg: A2(
										$elm$core$List$cons,
										{w: name, aI: after.aI},
										acc.jg),
									ji: A2(
										$elm$core$List$cons,
										{w: name, aI: before.aI},
										acc.ji)
								});
						}
					} else {
						if (!_v1.b.$) {
							var _v2 = _v1.a;
							var version = _v1.b.a.aI;
							return _Utils_update(
								acc,
								{
									jg: A2(
										$elm$core$List$cons,
										{w: name, aI: version},
										acc.jg)
								});
						} else {
							var _v4 = _v1.a;
							var _v5 = _v1.b;
							return acc;
						}
					}
				} else {
					return acc;
				}
			}),
		{jg: _List_Nil, ji: _List_Nil},
		ingredients);
	var oldLanguageVersions = _v0.ji;
	var newLanguageVersions = _v0.jg;
	return {
		jg: A2(
			$elm$core$List$sortBy,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.w;
				},
				$elm$core$String$toLower),
			newLanguageVersions),
		ji: A2(
			$elm$core$List$sortBy,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.w;
				},
				$elm$core$String$toLower),
			oldLanguageVersions)
	};
};
var $author$project$Views$ImpactReport$getSeverityHistograms = function (cves) {
	var initAcc = {jh: $author$project$Model$SeverityHistogram$empty, jj: $author$project$Model$SeverityHistogram$empty};
	var helper = F2(
		function (cve, acc) {
			var _v0 = cve.L;
			switch (_v0) {
				case 0:
					return _Utils_update(
						acc,
						{
							jh: A2($author$project$Model$SeverityHistogram$insert, cve.ck, acc.jh)
						});
				case 1:
					return _Utils_update(
						acc,
						{
							jj: A2($author$project$Model$SeverityHistogram$insert, cve.ck, acc.jj)
						});
				default:
					return _Utils_update(
						acc,
						{
							jh: A2($author$project$Model$SeverityHistogram$insert, cve.ck, acc.jh),
							jj: A2($author$project$Model$SeverityHistogram$insert, cve.ck, acc.jj)
						});
			}
		});
	var finalAcc = A3($elm$core$List$foldr, helper, initAcc, cves);
	return {jh: finalAcc.jh, jj: finalAcc.jj};
};
var $author$project$Views$ImpactReport$viewIngredient = function (row) {
	var _v0 = function () {
		if (!row.$) {
			return _Utils_Tuple2(
				'ingredient-blank',
				_List_fromArray(
					[
						$elm$html$Html$text('')
					]));
		} else {
			var key = row.a.Y;
			var version = row.a.aI;
			var status = row.a.L;
			var nameAndVersion = $author$project$Model$Namespace$getName(key) + (' ' + version);
			var _v2 = function () {
				switch (status.$) {
					case 0:
						return _Utils_Tuple2(
							'ingredient-added',
							$author$project$Views$Icon$view(
								$author$project$Views$Icon$icon(61)));
					case 1:
						return _Utils_Tuple2(
							'ingredient-removed',
							$author$project$Views$Icon$view(
								$author$project$Views$Icon$icon(50)));
					case 2:
						return _Utils_Tuple2(
							'ingredient-changed',
							$author$project$Views$Icon$view(
								$author$project$Views$Icon$icon(7)));
					default:
						return _Utils_Tuple2(
							'ingredient-unchanged',
							$elm$html$Html$text(''));
				}
			}();
			var subClassName = _v2.a;
			var icon = _v2.b;
			return _Utils_Tuple2(
				subClassName,
				_List_fromArray(
					[
						icon,
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('ingredient-name'),
								$elm$html$Html$Attributes$title(nameAndVersion)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(nameAndVersion)
							]))
					]));
		}
	}();
	var className = _v0.a;
	var content = _v0.b;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('ingredient-row'),
				$elm$html$Html$Attributes$class(className)
			]),
		content);
};
var $author$project$Views$ImpactReport$viewLanguageVersion = function (_v0) {
	var name = _v0.w;
	var version = _v0.aI;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('ingredient-row')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$elm_community$string_extra$String$Extra$toTitleCase(name) + (' ' + version))
			]));
};
var $author$project$Views$ImpactReport$viewDependencyComparison = function (_v0) {
	var depCounts = _v0.x_;
	var diff = _v0.x1;
	var hideUnchanged = _v0.jX;
	var remediationApplied = _v0.pA;
	var comparisonType = _v0.BT;
	var totalDependencyChanges = (depCounts.rC + depCounts.r5) + depCounts.qy;
	var hasDependencyChanges = totalDependencyChanges > 0;
	var _v1 = $author$project$Views$ImpactReport$getSeverityHistograms(diff.xQ);
	var oldSeverityHistogram = _v1.jj;
	var newSeverityHistogram = _v1.jh;
	var newTotalVulns = $author$project$Model$SeverityHistogram$total(newSeverityHistogram);
	var oldTotalVulns = $author$project$Model$SeverityHistogram$total(oldSeverityHistogram);
	var _v2 = $author$project$Views$ImpactReport$getLanguageVersions(diff.hr);
	var oldLanguageVersions = _v2.ji;
	var newLanguageVersions = _v2.jg;
	var hasAnyLanguageVersions = (!$elm$core$List$isEmpty(oldLanguageVersions)) || (!$elm$core$List$isEmpty(newLanguageVersions));
	var _v3 = A2($author$project$Views$ImpactReport$separateIngredients, hideUnchanged, diff.hr);
	var oldPackages = _v3.cE;
	var newPackages = _v3.cx;
	var oldImages = _v3.cD;
	var newImages = _v3.cB;
	var oldDependencies = _v3.cC;
	var newDependencies = _v3.cA;
	var hasAnyDependencies = (!$elm$core$List$isEmpty(oldDependencies)) || (!$elm$core$List$isEmpty(newDependencies));
	var hasAnyImages = (!$elm$core$List$isEmpty(oldImages)) || (!$elm$core$List$isEmpty(newImages));
	var hasAnyPackages = (!$elm$core$List$isEmpty(oldPackages)) || (!$elm$core$List$isEmpty(newPackages));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('dependency-comparison-section')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dependency-comparison-data'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('remediation-applied', remediationApplied),
								_Utils_Tuple2('hide-unchanged', hideUnchanged)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('dependency-comparison-cell')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('section-label')
									]),
								function () {
									if (!comparisonType.$) {
										if (comparisonType.a.$ === 1) {
											var _v5 = comparisonType.a;
											var firstCommit = _v5.a;
											return _List_fromArray(
												[
													A2(
													$elm$html$Html$h3,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Before')
														])),
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('commit-id')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															'Commit ID - ' + $danyx23$elm_uuid$Uuid$toString(firstCommit))
														]))
												]);
										} else {
											var baseCommit = comparisonType.a.a;
											return _List_fromArray(
												[
													A2(
													$elm$html$Html$h3,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Current Commit')
														])),
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('commit-id')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															'Commit ID - ' + $danyx23$elm_uuid$Uuid$toString(baseCommit))
														]))
												]);
										}
									} else {
										return _List_fromArray(
											[
												$elm$html$Html$text('Before')
											]);
									}
								}())
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('dependency-comparison-cell')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('section-label')
									]),
								function () {
									if (!comparisonType.$) {
										if (comparisonType.a.$ === 1) {
											var _v7 = comparisonType.a;
											var secondCommit = _v7.b;
											return _List_fromArray(
												[
													A2(
													$elm$html$Html$h3,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('After')
														])),
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('commit-id')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															'Commit ID - ' + $danyx23$elm_uuid$Uuid$toString(secondCommit))
														]))
												]);
										} else {
											return _List_fromArray(
												[
													A2(
													$elm$html$Html$h3,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Pending Changes')
														])),
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('commit-id')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('These changes have not yet been committed')
														]))
												]);
										}
									} else {
										return _List_fromArray(
											[
												$elm$html$Html$text('After')
											]);
									}
								}())
							])),
						A2(
						$author$project$Misc$displayIf,
						hasAnyLanguageVersions,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('dependency-comparison-cell')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A3(
												$author$project$Misc$pluralizeNoNumber,
												'Language',
												'Languages',
												$elm$core$List$length(oldLanguageVersions)))
										])),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									A2($elm$core$List$map, $author$project$Views$ImpactReport$viewLanguageVersion, oldLanguageVersions))
								]))),
						A2(
						$author$project$Misc$displayIf,
						hasAnyLanguageVersions,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('dependency-comparison-cell')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A3(
												$author$project$Misc$pluralizeNoNumber,
												'Language',
												'Languages',
												$elm$core$List$length(newLanguageVersions)))
										])),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									A2($elm$core$List$map, $author$project$Views$ImpactReport$viewLanguageVersion, newLanguageVersions))
								]))),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('dependency-comparison-cell cve-cell')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(oldTotalVulns) + (' Total ' + A3($author$project$Misc$pluralizeNoNumber, 'Vulnerability', 'Vulnerabilities', oldTotalVulns)))
									])),
								$author$project$Views$CVESummary$viewTotals(
								{xI: false, y7: $elm$core$Maybe$Nothing, zd: $elm$core$Maybe$Nothing, F2: oldSeverityHistogram})
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('dependency-comparison-cell cve-cell')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(newTotalVulns) + (' Total ' + A3($author$project$Misc$pluralizeNoNumber, 'Vulnerability', 'Vulnerabilities', newTotalVulns)))
									])),
								$author$project$Views$CVESummary$viewTotals(
								{xI: false, y7: $elm$core$Maybe$Nothing, zd: $elm$core$Maybe$Nothing, F2: newSeverityHistogram})
							])),
						A2(
						$author$project$Misc$displayIf,
						hasDependencyChanges,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('filter-row')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromInt(totalDependencyChanges) + (' Dependency ' + A3($author$project$Misc$pluralizeNoNumber, 'Change', 'Changes', totalDependencyChanges)))
										])),
									A2(
									$elm$html$Html$label,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('changed-filter')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$checked(hideUnchanged),
													$elm$html$Html$Attributes$name('show-changes'),
													$elm$html$Html$Attributes$type_('checkbox'),
													$elm$html$Html$Events$onCheck($author$project$Views$ImpactReport$ToggleHideUnchanged)
												]),
											_List_Nil),
											$elm$html$Html$text('Show only changes')
										]))
								]))),
						A2(
						$author$project$Misc$displayIf,
						hasAnyPackages,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('dependency-comparison-cell')
								]),
							A2(
								$elm$core$List$cons,
								A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Required Packages'),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('item-count')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromInt(
														$elm$core$List$length(
															A2(
																$elm$core$List$filter,
																function (row) {
																	return !_Utils_eq(row, $author$project$Views$ImpactReport$Blank);
																},
																oldPackages))))
												]))
										])),
								A2($elm$core$List$map, $author$project$Views$ImpactReport$viewIngredient, oldPackages)))),
						A2(
						$author$project$Misc$displayIf,
						hasAnyPackages,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('dependency-comparison-cell')
								]),
							A2(
								$elm$core$List$cons,
								A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Required Packages'),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('item-count')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromInt(
														$elm$core$List$length(
															A2(
																$elm$core$List$filter,
																function (row) {
																	return !_Utils_eq(row, $author$project$Views$ImpactReport$Blank);
																},
																newPackages))))
												]))
										])),
								A2($elm$core$List$map, $author$project$Views$ImpactReport$viewIngredient, newPackages)))),
						A2(
						$author$project$Misc$displayIf,
						hasAnyImages,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('dependency-comparison-cell')
								]),
							A2(
								$elm$core$List$cons,
								A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Images'),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('item-count')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromInt(
														$elm$core$List$length(
															A2(
																$elm$core$List$filter,
																function (row) {
																	return !_Utils_eq(row, $author$project$Views$ImpactReport$Blank);
																},
																oldImages))))
												]))
										])),
								A2($elm$core$List$map, $author$project$Views$ImpactReport$viewIngredient, oldImages)))),
						A2(
						$author$project$Misc$displayIf,
						hasAnyImages,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('dependency-comparison-cell')
								]),
							A2(
								$elm$core$List$cons,
								A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Images'),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('item-count')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromInt(
														$elm$core$List$length(
															A2(
																$elm$core$List$filter,
																function (row) {
																	return !_Utils_eq(row, $author$project$Views$ImpactReport$Blank);
																},
																newImages))))
												]))
										])),
								A2($elm$core$List$map, $author$project$Views$ImpactReport$viewIngredient, newImages)))),
						A2(
						$author$project$Misc$displayIf,
						hasAnyDependencies,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('dependency-comparison-cell')
								]),
							A2(
								$elm$core$List$cons,
								A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Dependencies'),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('item-count')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromInt(
														$elm$core$List$length(
															A2(
																$elm$core$List$filter,
																function (row) {
																	return !_Utils_eq(row, $author$project$Views$ImpactReport$Blank);
																},
																oldDependencies))))
												]))
										])),
								A2($elm$core$List$map, $author$project$Views$ImpactReport$viewIngredient, oldDependencies)))),
						A2(
						$author$project$Misc$displayIf,
						hasAnyDependencies,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('dependency-comparison-cell')
								]),
							A2(
								$elm$core$List$cons,
								A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Dependencies'),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('item-count')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromInt(
														$elm$core$List$length(
															A2(
																$elm$core$List$filter,
																function (row) {
																	return !_Utils_eq(row, $author$project$Views$ImpactReport$Blank);
																},
																newDependencies))))
												]))
										])),
								A2($elm$core$List$map, $author$project$Views$ImpactReport$viewIngredient, newDependencies))))
					]))
			]));
};
var $author$project$Views$ImpactReport$CopyClipboard = function (a) {
	return {$: 4, a: a};
};
var $author$project$Views$Modal$DismissButtonVisible = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Views$ImpactReport$ToggleShareModal = {$: 3};
var $author$project$Views$Modal$X = 1;
var $author$project$Views$ImpactReport$impactSummary = F2(
	function (depCounts, cveCounts) {
		var criticalsRemoved = $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				function (c) {
					return c.ck === 4;
				},
				cveCounts.r6));
		var criticalAdded = $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				function (c) {
					return c.ck === 4;
				},
				cveCounts.qc));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('columns')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('column')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('impact-overview-list')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Dependency Changes')
										])),
									A2(
									$elm$html$Html$ul,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$li,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$elm$core$String$fromInt(depCounts.rC))
														])),
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('New')
														]))
												])),
											A2(
											$elm$html$Html$li,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$elm$core$String$fromInt(depCounts.r5))
														])),
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Removed')
														]))
												])),
											A2(
											$elm$html$Html$li,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$elm$core$String$fromInt(depCounts.qy))
														])),
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Updated')
														]))
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('column')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('impact-exec-summary-list')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Vulnerability Changes')
										])),
									A2(
									$elm$html$Html$ul,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$li,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$elm$core$String$fromInt(
																$elm$core$List$length(cveCounts.r6)))
														])),
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Total Resolved')
														]))
												])),
											A2(
											$elm$html$Html$li,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$elm$core$String$fromInt(criticalsRemoved))
														])),
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Critical Resolved')
														]))
												])),
											A2(
											$elm$html$Html$li,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$elm$core$String$fromInt(criticalAdded))
														])),
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('New Critical')
														]))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Views$ImpactReport$isSavedComparison = function (comparisonType) {
	if ((!comparisonType.$) && (comparisonType.a.$ === 1)) {
		var _v1 = comparisonType.a;
		return true;
	} else {
		return false;
	}
};
var $author$project$Views$ImpactReport$shareModalContent = F3(
	function (model, copyClipboardMsg, _v0) {
		var shareUrl = function () {
			var _v1 = model.FQ;
			if (!_v1.$) {
				var route = _v1.a;
				return _Utils_ap(
					model.t0,
					$author$project$Model$Route$routeToString(route));
			} else {
				return '';
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Share Impact Report')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('This Impact Report can be viewed by other members of the '),
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(model.c3.AC)
								])),
							$elm$html$Html$text(' organization.')
						])),
					$author$project$Views$CliText$view(
					{
						B$: $elm$core$Maybe$Just(
							{Em: copyClipboardMsg, L: model.oi}),
						l6: 'impact-report-url',
						Gv: shareUrl
					})
				]));
	});
var $author$project$Views$ImpactReport$viewExecSummary = F5(
	function (model, _v0, depCounts, cveCounts, showShareModal) {
		var orgName = _v0.a;
		var projectName = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('impact-exec-summary')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('details')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Impact Report')
										])),
									A2(
									$author$project$Misc$displayIf,
									!$author$project$Views$ImpactReport$isSavedComparison(model.BT),
									A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pending-warning')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Pending Changes'),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('more-info-tooltip')
													]),
												_List_fromArray(
													[
														$author$project$Views$Icon$view(
														$author$project$Views$Icon$icon(52)),
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('content')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('The changes in this Impact Report have not yet been saved.')
															]))
													]))
											])))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('project-meta')
								]),
							_List_fromArray(
								[
									$author$project$Views$ImpactReport$isSavedComparison(model.BT) ? $elm$html$Html$text('This is a summary of changes between two commits to the ') : $elm$html$Html$text('This is a summary of pending changes to the '),
									A3(
									$author$project$Views$Link$link,
									A2(
										$author$project$Model$Route$projectConfig,
										{ix: orgName, vT: projectName},
										$author$project$Model$Route$projectConfigParams),
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(orgName + ('/' + projectName))
										])),
									$elm$html$Html$text(' project.')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$Views$ImpactReport$ToggleShareModal),
									$elm$html$Html$Attributes$class('primary-button')
								]),
							_List_fromArray(
								[
									$author$project$Views$Icon$view(
									$author$project$Views$Icon$icon(70)),
									$elm$html$Html$text('Share')
								]))
						])),
					A2($author$project$Views$ImpactReport$impactSummary, depCounts, cveCounts),
					A2(
					$author$project$Misc$displayIf,
					showShareModal,
					A2(
						$author$project$Views$Modal$viewWithModalId,
						$elm$core$Maybe$Just('share-modal'),
						{
							BD: '',
							BI: $author$project$Views$ImpactReport$ToggleShareModal,
							dH: A3($author$project$Views$ImpactReport$shareModalContent, model, $author$project$Views$ImpactReport$CopyClipboard, $author$project$Views$ImpactReport$ToggleShareModal),
							x4: A2($author$project$Views$Modal$DismissButtonVisible, 1, true)
						}))
				]));
	});
var $author$project$Views$ImpactReport$viewResolvedCards = function (cveCounts) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('resolved-cards-section')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('resolved-cards')
					]),
				A2(
					$elm$core$List$map,
					$author$project$Views$ImpactReport$viewCVECard,
					A2(
						$elm$core$List$sortBy,
						function (c) {
							return $author$project$Model$Severity$sortKey(c.ck);
						},
						cveCounts.r6)))
			]));
};
var $author$project$Views$ImpactReport$viewDiff = F2(
	function (session, model) {
		var projectDetails = _Utils_Tuple2(
			$author$project$Model$Organization$getUrlName(model.c3),
			model.vT);
		var depCounts = $author$project$Model$BuildPlanner$ImpactReport$dependencyCounts(model.ma);
		var cveCounts = $author$project$Model$BuildPlanner$ImpactReport$cveCounts(model.ma);
		var canViewBreakingChanges = $author$project$Model$Permissions$orgCanViewBreakingChanges(model.c3);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Misc$displayIf,
					model.F7,
					A5($author$project$Views$ImpactReport$viewExecSummary, model, projectDetails, depCounts, cveCounts, model.pP)),
					A4(
					$author$project$Views$ImpactReport$tabsView,
					$elm$core$List$length(cveCounts.r6),
					$elm$core$List$length(cveCounts.qc),
					canViewBreakingChanges,
					model.kB),
					A2(
					$author$project$Misc$displayIf,
					model.kB === 1,
					$author$project$Views$ImpactReport$viewResolvedCards(cveCounts)),
					A2(
					$author$project$Misc$displayIf,
					model.kB === 2,
					$author$project$Views$ImpactReport$viewAddedCards(cveCounts)),
					A2(
					$author$project$Misc$displayIf,
					!model.kB,
					$author$project$Views$ImpactReport$viewDependencyComparison(
						{BT: model.BT, x_: depCounts, x1: model.ma, jX: model.jX, pA: model.pA})),
					A2(
					$author$project$Misc$displayIf,
					model.kB === 3,
					A2($author$project$Views$ImpactReport$viewBreakingChanges, session, model))
				]));
	});
var $author$project$Pages$OrgRemediation$viewProjects = F4(
	function (session, model, remediations, selected) {
		var projectTab = F2(
			function (remediation, isSelected) {
				return A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('active', isSelected)
								])),
							$elm$html$Html$Events$onClick(
							$author$project$Pages$OrgRemediation$SelectRemediation(remediation))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Model$Project$getName(remediation.c5))
						]));
			});
		var projectInfo = function (remediation) {
			var projectName = $author$project$Model$Project$getName(remediation.c5);
			var viewProjectButton = function (isUpdated) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button-with-dismissable-tooltip')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Views$Link$link,
							$author$project$Model$Route$projectOverview(
								$author$project$Model$Route$projectOverviewParams(
									{
										ix: $author$project$Model$Organization$getUrlName(model.c3),
										vT: projectName
									})),
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('secondary-button'),
									$elm$html$Html$Attributes$target('_blank')
								]),
							_List_fromArray(
								[
									isUpdated ? $elm$html$Html$text('View Updated Project') : $elm$html$Html$text('View Project')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button-tooltip')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Your project is updated!')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('You can explore the updated dependencies and CVE details, as well as see deployment instructions.')
										])),
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$type_('checkbox')
												]),
											_List_Nil),
											$author$project$Views$Icon$view(
											$author$project$Views$Icon$icon(19))
										]))
								]))
						]));
			};
			var appliedRemediation = A2(
				$elm$core$Maybe$withDefault,
				$krisajenkins$remotedata$RemoteData$NotAsked,
				A2($elm$core$Dict$get, projectName, model.fI));
			var remediationWasApplied = function () {
				if (appliedRemediation.$ === 3) {
					return true;
				} else {
					return false;
				}
			}();
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('project-detail-header')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h2,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Project: ' + projectName)
									])),
								function () {
								switch (appliedRemediation.$) {
									case 1:
										return A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('primary-button'),
													$elm$html$Html$Attributes$disabled(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Remediating...')
												]));
									case 3:
										return A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('primary-button remediation-successful'),
													$elm$html$Html$Attributes$disabled(true)
												]),
											_List_fromArray(
												[
													$author$project$Views$Icon$view(
													$author$project$Views$Icon$icon(10)),
													$elm$html$Html$text('Successully Remediated')
												]));
									default:
										return A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('button-with-tooltip')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$button,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('primary-button'),
															$elm$html$Html$Events$onClick(
															$author$project$Pages$OrgRemediation$ApplyRemediation(remediation))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Update Project'),
															$author$project$Views$Icon$view(
															$author$project$Views$Icon$icon(52))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('tooltip')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$p,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('We will apply the proposed changes to this project, updating the image and dependencies.')
																]))
														]))
												]));
								}
							}(),
								viewProjectButton(remediationWasApplied)
							])),
						function () {
						var _v2 = model.h_;
						if (!_v2.$) {
							var rem = _v2.a;
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('project-detail')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Here\'s a summary of the the proposed changes to this project.')
											])),
										A3(
										$elm$html$Html$Keyed$node,
										'div',
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class(
												$author$project$Model$Project$getName(rem.c5))
											]),
										_List_fromArray(
											[
												_Utils_Tuple2(
												$author$project$Model$Project$getName(rem.c5),
												A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('diff-wrapper')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$map,
															$author$project$Pages$OrgRemediation$ImpactReportMsg,
															A2($author$project$Views$ImpactReport$viewDiff, session, rem.ma))
														])))
											]))
									]));
						} else {
							return $elm$html$Html$text('');
						}
					}()
					]));
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('remediation-details')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('remediation-project-menu')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A3(
										$elm_community$string_extra$String$Extra$pluralize,
										'Project',
										'Projects',
										$elm$core$List$length(remediations)))
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('The following projects can be automatically remediated.')
								])),
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('remediation-project-list')
								]),
							A2(
								$elm$core$List$map,
								function (r) {
									var isSelected = function () {
										var _v0 = model.h_;
										if (!_v0.$) {
											var remediation = _v0.a;
											return _Utils_eq(
												$author$project$Model$Project$id(r.c5),
												$author$project$Model$Project$id(remediation.c5));
										} else {
											return false;
										}
									}();
									return A2(projectTab, r, isSelected);
								},
								remediations))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('project-detail')
						]),
					_List_fromArray(
						[
							A2($author$project$Misc$displayMaybe, projectInfo, selected)
						]))
				]));
	});
var $author$project$Pages$OrgRemediation$viewSummary = function (remediations) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('remediation-summary')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('header')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h2,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Available Remediations')
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('We have identified '),
										$elm$html$Html$text(
										A3(
											$elm_community$string_extra$String$Extra$pluralize,
											'project',
											'projects',
											$elm$core$List$length(remediations))),
										$elm$html$Html$text(' that can be updated to reduce your risk profile.')
									]))
							]))
					]))
			]));
};
var $author$project$Pages$OrgRemediation$view = F2(
	function (model, session) {
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('org-remediation')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('breadcrumbs')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Views$Link$link,
							A2(
								$author$project$Model$Route$orgIndex,
								$author$project$Model$Organization$getUrlName(model.c3),
								$elm$core$Maybe$Nothing),
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Dashboard')
								])),
							$elm$html$Html$text(' > Remediation')
						])),
					(model.fC === 4) ? (($elm$core$List$length(model.ne) > 0) ? A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Misc$displayIf,
							model.fC === 4,
							$author$project$Pages$OrgRemediation$viewSummary(model.ne)),
							A2(
							$author$project$Misc$displayIf,
							model.fC === 4,
							A4($author$project$Pages$OrgRemediation$viewProjects, session, model, model.ne, model.h_))
						])) : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('no-remediations')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Currently, no remediations are available for your projects.')
						]))) : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('remediation-loading')
						]),
					_List_fromArray(
						[
							$author$project$Views$Loading$propeller,
							function () {
							var _v0 = model.fC;
							switch (_v0) {
								case 0:
									return $elm$html$Html$text('Loading project data...');
								case 1:
									return $elm$html$Html$text('Loading latest catalog data...');
								case 2:
									return $elm$html$Html$text('Loading requirements data...');
								case 3:
									return $elm$html$Html$text('Calculating remediations...');
								default:
									return $elm$html$Html$text('');
							}
						}()
						]))
				]));
	});
var $author$project$Pages$OrgScan$breadCrumbs = function (model) {
	var orgUrlName = $author$project$Model$Organization$getUrlName(model.c3);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('breadcrumbs')
			]),
		_List_fromArray(
			[
				A3(
				$author$project$Views$Link$link,
				A2($author$project$Model$Route$orgIndex, orgUrlName, $elm$core$Maybe$Nothing),
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(orgUrlName)
							]))
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('divider')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('>')
					])),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Kubernetes Cluster Scan')
					])),
				A3(
				$author$project$Views$Link$link,
				A2($author$project$Model$Route$orgIndex, orgUrlName, $elm$core$Maybe$Nothing),
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Skip this Step')
					]))
			]));
};
var $author$project$Pages$OrgScan$CopyClipboard = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$OrgScan$cliScanInstructions = function (model) {
	var orgUrlName = $author$project$Model$Organization$getUrlName(model.c3);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('scan-instructions')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Scan your Kubernetes Cluster')
							])),
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Discover all the open source components you are running and see what\'s at risk.')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Follow the steps below to get set up and we\'ll provide a detailed report of your dependencies, vulnerabilities & licenses.')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('scan-requirements')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Requirements')
							])),
						A2($elm$html$Html$hr, _List_Nil, _List_Nil),
						A2(
						$elm$html$Html$ul,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('A deployed Kubernetes cluster')
									])),
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Kubectl')
									])),
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Helm CLI (Version 3.1+)')
									]))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href('#')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Read the docs')
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('snippet-wrapper')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('step-number')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('1')
									]))
							])),
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Step 1')
									])),
								$elm$html$Html$text(' - Create a values.yaml file with your info.')
							])),
						$author$project$Views$CliText$view(
						{
							B$: $elm$core$Maybe$Just(
								{Em: $author$project$Pages$OrgScan$CopyClipboard, L: model.oi}),
							l6: 'step-1-scan',
							Gv: 'echo \'activestate:\n  apiKey: <1234>\n  organization: <' + (orgUrlName + '>\' > values.yaml')
						})
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('snippet-wrapper')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('step-number')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('2')
									]))
							])),
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Step 2')
									])),
								$elm$html$Html$text(' - Run the scanning agent')
							])),
						$author$project$Views$CliText$view(
						{
							B$: $elm$core$Maybe$Just(
								{Em: $author$project$Pages$OrgScan$CopyClipboard, L: model.oi}),
							l6: 'step-2-scan',
							Gv: 'helm install activestate https://github.com/ActiveState/panorama-agent/releases/download/v1.0.0/panorama-helm-1.0.0.tar.gz -n <namespace> -f values.yaml'
						})
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('snippet-wrapper')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('step-number')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('3')
									]))
							])),
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Step 3')
									])),
								$elm$html$Html$text(' - Wait for the scan to finish')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Once the scanner has analized your all of the images in your cluster, you can see the results on your organization dashboard.')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								A3(
								$author$project$Views$Link$link,
								A2($author$project$Model$Route$orgIndex, orgUrlName, $elm$core$Maybe$Nothing),
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												_Utils_ap(model.wU, orgUrlName))
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$OrgScan$sandBoxInstructions = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('sandbox-instructions')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h1,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Scan our Kubernetes Demo Cluster')
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Preview our open source obervability features by analyzing our own demo cluster, which contains the six popular images below.')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('cluster-contents')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('cluster-header')
							]),
						_List_fromArray(
							[
								$author$project$Views$Icon$view(
								$author$project$Views$Icon$icon(37)),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('cluster-title')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h3,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('activestate.kubernetes.com')
											])),
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('6 images')
											]))
									])),
								A3(
								$author$project$Views$Link$link,
								A2(
									$author$project$Model$Route$orgIndex,
									$author$project$Model$Organization$getUrlName(model.c3),
									$elm$core$Maybe$Nothing),
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('primary-button')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Start Cluster Scan')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('cluster-images')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('cluster-image')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('image-icon')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$img,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$src('/img/docker-image-icons/postgres.png'),
														$elm$html$Html$Attributes$alt('Postgres docker image icon')
													]),
												_List_Nil)
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('image-meta')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$h4,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('postgres 14')
													])),
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('The PostgreSQL object-relational database system provides reliability and data integrity.')
													]))
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('cluster-image')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('image-icon')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$img,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$src('/img/docker-image-icons/spark.png'),
														$elm$html$Html$Attributes$alt('Postgres docker image icon')
													]),
												_List_Nil)
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('image-meta')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$h4,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('spark 3.4.1')
													])),
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Apache Spark - A unified analytics engine for large-scale data processing.')
													]))
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('cluster-image')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('image-icon')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$img,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$src('/img/docker-image-icons/python.png'),
														$elm$html$Html$Attributes$alt('Postgres docker image icon')
													]),
												_List_Nil)
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('image-meta')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$h4,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('python 3.10.0')
													])),
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Python is an interpreted, interactive, object-oriented, open-source programming language.')
													]))
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('cluster-image')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('image-icon')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$img,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$src('/img/docker-image-icons/nginx.png'),
														$elm$html$Html$Attributes$alt('Postgres docker image icon')
													]),
												_List_Nil)
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('image-meta')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$h4,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('nginx 1.26.0')
													])),
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Official build of Nginx.')
													]))
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('cluster-image')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('image-icon')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$img,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$src('/img/docker-image-icons/prometheus.png'),
														$elm$html$Html$Attributes$alt('Postgres docker image icon')
													]),
												_List_Nil)
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('image-meta')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$h4,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('prometheus 2.48.0')
													])),
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Prometheus is a systems and service monitoring system. Long-term versions maintained by Canonical.\n')
													]))
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('cluster-image')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('image-icon')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$img,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$src('/img/docker-image-icons/elasticsearch.png'),
														$elm$html$Html$Attributes$alt('Postgres docker image icon')
													]),
												_List_Nil)
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('image-meta')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$h4,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('elasticsearch 8.12.1')
													])),
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Elasticsearch is a powerful open source search and analytics engine that makes data easy to explore.\n')
													]))
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$OrgScan$view = F2(
	function (model, _v0) {
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('org-scan-page')
				]),
			_List_fromArray(
				[
					$author$project$Views$Columns$asHtml(
					A2(
						$author$project$Views$Columns$withColumn,
						_List_fromArray(
							[
								$author$project$Pages$OrgScan$breadCrumbs(model),
								$author$project$Pages$OrgScan$cliScanInstructions(model),
								$author$project$Pages$OrgScan$sandBoxInstructions(model)
							]),
						A2(
							$author$project$Views$Columns$withColumnAs,
							$elm$html$Html$section,
							A2(
								$author$project$Views$Columns$withAttrs,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('org-scan')
									]),
								$author$project$Views$Columns$asColumns($elm$html$Html$div)))))
				]));
	});
var $author$project$Pages$OrgSecurity$ClearSearchInputValue = {$: 2};
var $author$project$Pages$OrgSecurity$ProjectsAffected = 2;
var $author$project$Pages$OrgSecurity$PromptToDownloadReport = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$OrgSecurity$ResetFilter = {$: 4};
var $author$project$Pages$OrgSecurity$SetSearchInputValue = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$OrgSecurity$SetSortMode = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$OrgSecurity$SeverityQuickFilterClicked = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$OrgSecurity$ToggleFlag = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$OrgSecurity$Name = 1;
var $author$project$Pages$OrgSecurity$allColumns = _List_fromArray(
	[
		_Utils_Tuple2(0, true),
		_Utils_Tuple2(1, true),
		_Utils_Tuple2(2, true)
	]);
var $author$project$Pages$OrgSecurity$columnClass = function (column) {
	switch (column) {
		case 0:
			return 'cve-severity';
		case 1:
			return 'cve-name';
		default:
			return 'cve-projects-affected';
	}
};
var $author$project$Pages$OrgSecurity$columnString = function (column) {
	switch (column) {
		case 0:
			return 'Severity';
		case 1:
			return 'Name';
		default:
			return 'Project and Package Affected';
	}
};
var $author$project$Pages$OrgSecurity$flagToString = function (flagName) {
	switch (flagName.$) {
		case 0:
			var f = flagName.a;
			return A2($elm$core$Basics$composeR, $author$project$Pages$OrgSecurity$flagToSeverity, $author$project$Model$Severity$toString)(f);
		case 2:
			return 'Private';
		default:
			return 'Public';
	}
};
var $author$project$Views$CVEs$fullLink = function (vuln) {
	return A3(
		$author$project$Views$Link$external,
		$author$project$Model$Vulnerability$getURL(vuln),
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('cve-link')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Model$Vulnerability$getURL(vuln))
			]));
};
var $author$project$Pages$OrgSecurity$opposite = function (dir) {
	if (!dir) {
		return 1;
	} else {
		return 0;
	}
};
var $author$project$Model$Permissions$orgCanSeeCVEDashboardAdvanced = $author$project$Model$Organization$addOnEnabled('cve_dashboard_advanced');
var $author$project$Model$OrgSecurityRow$packageAffectedVersion = function (_package) {
	var versionStr = F2(
		function (operator, v) {
			return (v !== '') ? $elm$core$Maybe$Just(
				_Utils_ap(operator, v)) : $elm$core$Maybe$Nothing;
		});
	var versions = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				A2(versionStr, '>=', _package.G3),
				A2(versionStr, '>', _package.G2),
				A2(versionStr, '<=', _package.G1),
				A2(versionStr, '<', _package.G0)
			]));
	return (!$elm$core$List$isEmpty(versions)) ? A2($elm$core$String$join, ',', versions) : '';
};
var $author$project$Pages$OrgSecurity$renderMarkdownOrPlaintext = function (content) {
	var _v0 = A2(
		$elm$core$Result$andThen,
		function (ast) {
			return A2($dillonkearns$elm_markdown$Markdown$Renderer$render, $dillonkearns$elm_markdown$Markdown$Renderer$defaultHtmlRenderer, ast);
		},
		A2(
			$elm$core$Result$mapError,
			$elm$core$Basics$always('ignored'),
			$dillonkearns$elm_markdown$Markdown$Parser$parse(content)));
	if (!_v0.$) {
		var rendered = _v0.a;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('markdown')
					]),
				rendered)
			]);
	} else {
		return _List_fromArray(
			[
				$elm$html$Html$text(content)
			]);
	}
};
var $author$project$Pages$OrgSecurity$severityWithText = function (flag) {
	var severityClass = 'severity-' + $author$project$Pages$OrgSecurity$flagToString(
		$author$project$Pages$OrgSecurity$SeverityFlag(flag));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('severity-with-text level-summary ' + severityClass)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(' severity-dot ' + severityClass)
					]),
				_List_Nil),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('cve-severity')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Pages$OrgSecurity$flagToString(
							$author$project$Pages$OrgSecurity$SeverityFlag(flag)))
					]))
			]));
};
var $author$project$Model$OrgSecurityRow$toSeverityCount = function (row) {
	return {cO: row.v8, ck: row.ck};
};
var $author$project$Pages$OrgSecurity$visibilityFlagTypes = A2(
	$elm$core$List$filter,
	A2($elm$core$Basics$composeR, $author$project$Pages$OrgSecurity$isSeverityFlag, $elm$core$Basics$not),
	$author$project$Pages$OrgSecurity$allFlagTypes);
var $author$project$Pages$OrgSecurity$view = function (model) {
	var _v0 = model.lo;
	switch (_v0.$) {
		case 0:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('loading-spacer')
					]),
				_List_fromArray(
					[
						$author$project$Views$Loading$view(true)
					]));
		case 1:
			var err = _v0.a;
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('cve-loading-error')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Error loading data')
							])),
						$elm$html$Html$text(
						' — \"' + ($author$project$Model$Message$reason(err) + '\"'))
					]));
		default:
			var cveData = _v0.a;
			var visitbilityFilterRow = function (flag) {
				var id_ = 'project-visibility-' + $author$project$Pages$OrgSecurity$flagToString(flag);
				return A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('checkbox'),
									$elm$html$Html$Attributes$id(id_),
									$elm$html$Html$Attributes$checked(
									A2($author$project$Pages$OrgSecurity$isFlagSet, model.cT, flag)),
									$elm$html$Html$Events$onInput(
									$elm$core$Basics$always(
										$author$project$Pages$OrgSecurity$ToggleFlag(flag)))
								]),
							_List_Nil),
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$for(id_)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Pages$OrgSecurity$flagToString(flag))
								]))
						]));
			};
			var visibilityFilterRows = A2($elm$core$List$map, visitbilityFilterRow, $author$project$Pages$OrgSecurity$visibilityFlagTypes);
			var severityFilterRow = function (flag) {
				var id_ = 'filter-severity-' + $author$project$Pages$OrgSecurity$flagToString(
					$author$project$Pages$OrgSecurity$SeverityFlag(flag));
				return A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('checkbox'),
									$elm$html$Html$Attributes$id(id_),
									$elm$html$Html$Attributes$checked(
									A2(
										$author$project$Pages$OrgSecurity$isFlagSet,
										model.cT,
										$author$project$Pages$OrgSecurity$SeverityFlag(flag))),
									$elm$html$Html$Events$onInput(
									$elm$core$Basics$always(
										$author$project$Pages$OrgSecurity$ToggleFlag(
											$author$project$Pages$OrgSecurity$SeverityFlag(flag))))
								]),
							_List_Nil),
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$for(id_)
								]),
							_List_fromArray(
								[
									$author$project$Pages$OrgSecurity$severityWithText(flag)
								]))
						]));
			};
			var severityFilterRows = A2(
				$elm$core$List$map,
				severityFilterRow,
				A2(
					$elm$core$List$filterMap,
					function (flag) {
						if (!flag.$) {
							var s = flag.a;
							return $elm$core$Maybe$Just(s);
						} else {
							return $elm$core$Maybe$Nothing;
						}
					},
					$author$project$Pages$OrgSecurity$severityFlagTypes));
			var rows = A2($author$project$Pages$OrgSecurity$currentRows, model, cveData);
			var severityHistogram = $author$project$Model$SeverityHistogram$fromSeverityCounts(
				A2($elm$core$List$map, $author$project$Model$OrgSecurityRow$toSeverityCount, rows));
			var projectLink = function (projectName) {
				return A3(
					$author$project$Views$Link$link,
					A2(
						$author$project$Model$Route$projectConfig,
						{ix: model.c3.AC, vT: projectName},
						$author$project$Model$Route$projectConfigParams),
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(projectName)
						]));
			};
			var isOpen = model.lW;
			var descriptionView = A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('page-description')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('description-text')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Unique vulnerabilities (also known as CVEs) detected in this organization’s projects. To view affected components of your project, view the project configuration. '),
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href('https://docs.activestate.com/platform/features/cve/')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Learn more about CVEs')
											])),
										$elm$html$Html$text('.')
									]))
							])),
						A2(
						$author$project$Misc$displayIf,
						$author$project$Model$Permissions$orgCanSeeCVEDashboardAdvanced(model.c3),
						A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$Pages$OrgSecurity$PromptToDownloadReport(cveData)),
									$elm$html$Html$Attributes$class('secondary-button')
								]),
							_List_fromArray(
								[
									$author$project$Views$Icon$view(
									$author$project$Views$Icon$small(
										A2(
											$author$project$Views$Icon$colored,
											$author$project$Style$color('blue'),
											$author$project$Views$Icon$icon(21)))),
									$elm$html$Html$text('Download CVE Report')
								])))
					]));
			var columnLabel = function (_v5) {
				var column = _v5.a;
				var isSortable = _v5.b;
				var isTheActiveColumn = _Utils_eq(model.nx, column);
				var baseAttrs = _List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								$author$project$Pages$OrgSecurity$columnClass(column),
								true),
								_Utils_Tuple2('sorted', isTheActiveColumn),
								_Utils_Tuple2('sortable', isSortable)
							]))
					]);
				var attrs = isSortable ? A2(
					$elm$core$List$cons,
					$elm$html$Html$Events$onClick(
						$author$project$Pages$OrgSecurity$SetSortMode(column)),
					baseAttrs) : baseAttrs;
				return A2(
					$elm$html$Html$th,
					attrs,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('heading')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('heading-text')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Pages$OrgSecurity$columnString(column)),
											(column === 2) ? A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('more-info-tooltip')
												]),
											_List_fromArray(
												[
													$author$project$Views$Icon$view(
													$author$project$Views$Icon$icon(52)),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('content supported-versions')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$p,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('This column is sorted by number of projects affected.')
																]))
														]))
												])) : $elm$html$Html$text('')
										])),
									function () {
									var visbleSortDirection = function () {
										var _v3 = _Utils_Tuple2(column, isTheActiveColumn);
										if (!_v3.b) {
											return $author$project$Pages$OrgSecurity$defaultSortDireciton;
										} else {
											if (!_v3.a) {
												var _v4 = _v3.a;
												return $author$project$Pages$OrgSecurity$opposite(model.ny);
											} else {
												return model.ny;
											}
										}
									}();
									var iconKind = function () {
										if (!visbleSortDirection) {
											return 12;
										} else {
											return 14;
										}
									}();
									return A2(
										$author$project$Misc$displayIf,
										isSortable,
										$author$project$Views$Icon$view(
											A2(
												$author$project$Views$Icon$colored,
												$author$project$Style$color('grey'),
												A2(
													$author$project$Views$Icon$square,
													13,
													$author$project$Views$Icon$icon(iconKind)))));
								}()
								]))
						]));
			};
			var affectedProjectRowView = F2(
				function (row, isSimple) {
					var sortedProjectList = $elm$core$List$reverse(
						A2(
							$elm$core$List$sortBy,
							A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $elm$core$String$toLower),
							A2(
								$elm$core$List$map,
								function (_v1) {
									var a = _v1.a;
									var b = _v1.b;
									var projectName = A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											function ($) {
												return $.w;
											},
											A2($author$project$Uuid$Dict$get, a, cveData.ko)));
									return _Utils_Tuple2(projectName, b);
								},
								row.hJ)));
					return A3(
						$elm$core$List$foldl,
						F2(
							function (affectedProject, acc) {
								var newRows = A2(
									$elm$core$List$map,
									function (affectedPackage) {
										return A2(
											$elm$html$Html$tr,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$td,
													_List_Nil,
													_List_fromArray(
														[
															projectLink(affectedProject.a)
														])),
													A2(
													$elm$html$Html$td,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(affectedPackage.w),
															isSimple ? $elm$html$Html$text(
															' ' + A2($elm$core$Maybe$withDefault, '', affectedPackage.aI)) : $elm$html$Html$text('')
														])),
													A2(
													$author$project$Misc$displayIf,
													!isSimple,
													A2(
														$elm$html$Html$td,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(
																A2($elm$core$Maybe$withDefault, '', affectedPackage.aI))
															]))),
													A2(
													$author$project$Misc$displayIf,
													!isSimple,
													A2(
														$elm$html$Html$td,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(
																$author$project$Model$OrgSecurityRow$packageAffectedVersion(affectedPackage))
															])))
												]));
									},
									affectedProject.b);
								return $elm$core$List$concat(
									_List_fromArray(
										[newRows, acc]));
							}),
						_List_Nil,
						sortedProjectList);
				});
			var cveDetailsTray = function (maybeRow) {
				return A2(
					$author$project$Misc$displayMaybe,
					function (selectedRow) {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sliding-tray')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('sliding-tray-content '),
											$elm$html$Html$Attributes$id($author$project$Pages$OrgSecurity$detailsTrayId)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('cve-details')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h1,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(selectedRow.B9),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('secondary')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(' — Vulnerability Details')
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('cve-meta')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$h4,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Severity')
																])),
															$author$project$Pages$OrgSecurity$severityWithText(
															$author$project$Pages$OrgSecurity$severityToFlag(selectedRow.ck)),
															A2(
															$elm$html$Html$h4,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('ID')
																])),
															A2(
															$elm$html$Html$div,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(selectedRow.B9)
																])),
															A2(
															$elm$html$Html$h4,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Link')
																])),
															$author$project$Views$CVEs$fullLink(selectedRow)
														])),
													A2(
													$elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('In your Organization '),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('item-count')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$elm$core$String$fromInt(
																		$elm$core$List$length(selectedRow.hJ))),
																	A2(
																	$elm$html$Html$span,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			A3(
																				$author$project$Misc$pluralizeNoNumber,
																				' Instance',
																				' Instances',
																				$elm$core$List$length(selectedRow.hJ)))
																		])),
																	$elm$html$Html$text(' found')
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('affected-projects-table-wrapper')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$table,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('affected-projects-table')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$th,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$elm$html$Html$text('Project Name')
																				])),
																			A2(
																			$elm$html$Html$th,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$elm$html$Html$text('Package')
																				])),
																			A2(
																			$elm$html$Html$th,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$elm$html$Html$text('Version')
																				])),
																			A2(
																			$elm$html$Html$th,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$elm$html$Html$text('Affected Versions')
																				]))
																		])),
																	A2(
																	$elm$html$Html$tbody,
																	_List_Nil,
																	A2(affectedProjectRowView, selectedRow, false))
																]))
														])),
													A2(
													$elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Description')
														])),
													A2(
													$elm$html$Html$p,
													_List_Nil,
													$author$project$Pages$OrgSecurity$renderMarkdownOrPlaintext(selectedRow.bP))
												])),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('secondary-button small close-dialog-button'),
													$elm$html$Html$Events$onClick(
													$author$project$Pages$OrgSecurity$ToggleTray($elm$core$Maybe$Nothing))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Close')
												]))
										]))
								]));
					},
					maybeRow);
			};
			var rowView = function (row) {
				return A2(
					$elm$html$Html$tr,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Pages$OrgSecurity$severityWithText(
									$author$project$Pages$OrgSecurity$severityToFlag(row.ck))
								])),
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('cve-id')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(row.B9)
										]))
								])),
							A2(
							$elm$html$Html$td,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$table,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('affected-projects-table')
										]),
									A2(affectedProjectRowView, row, true))
								])),
							A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('row-actions')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('secondary-button'),
											$elm$html$Html$Events$onClick(
											$author$project$Pages$OrgSecurity$ToggleTray(
												$elm$core$Maybe$Just(row)))
										]),
									_List_fromArray(
										[
											$author$project$Views$Icon$view(
											$author$project$Views$Icon$icon(72)),
											$elm$html$Html$text('Details')
										]))
								]))
						]));
			};
			var activeFilters = function () {
				var oneIfVisibllityActive = A2(
					$elm$core$List$any,
					function (flag) {
						return A2(
							$elm$core$Basics$composeR,
							$author$project$Pages$OrgSecurity$isFlagSet(model.cT),
							$elm$core$Basics$not)(flag);
					},
					$author$project$Pages$OrgSecurity$visibilityFlagTypes) ? 1 : 0;
				var oneIfSeverityActive = A2(
					$elm$core$List$any,
					function (flag) {
						return A2(
							$elm$core$Basics$composeR,
							$author$project$Pages$OrgSecurity$isFlagSet(model.cT),
							$elm$core$Basics$not)(flag);
					},
					$author$project$Pages$OrgSecurity$severityFlagTypes) ? 1 : 0;
				return oneIfSeverityActive + oneIfVisibllityActive;
			}();
			var hasSearchOrFilter = $elm$core$String$isEmpty(model.kt) || (activeFilters > 0);
			return A2(
				$elm$html$Html$main_,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('org-security-page')
					]),
				_List_fromArray(
					[
						descriptionView,
						cveDetailsTray(model.sj),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('sortable-table-wrapper')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$table,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$thead,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$tr,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$td,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$colspan(
																$elm$core$List$length($author$project$Pages$OrgSecurity$allColumns) + 1)
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('filter-ui')
																	]),
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$div,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('filter-row')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$elm$html$Html$h2,
																				_List_Nil,
																				_List_fromArray(
																					[
																						A2(
																						$elm$html$Html$span,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class('item-count')
																							]),
																						_List_fromArray(
																							[
																								$elm$html$Html$text(
																								$elm$core$String$fromInt(
																									$author$project$Model$SeverityHistogram$total(severityHistogram)))
																							])),
																						$elm$html$Html$text(' Vulnerabilities')
																					])),
																				$author$project$Views$InlineSearchBar$inlineSearchBar(
																				{
																					Bx: $author$project$Pages$OrgSecurity$SetSearchInputValue,
																					BG: $elm$core$Maybe$Just($author$project$Pages$OrgSecurity$ClearSearchInputValue),
																					j0: model.kt,
																					Fd: 'Search'
																				}),
																				A2(
																				$author$project$Misc$displayIf,
																				activeFilters > 0,
																				A2(
																					$elm$html$Html$button,
																					_List_fromArray(
																						[
																							$elm$html$Html$Events$onClick($author$project$Pages$OrgSecurity$ResetFilter),
																							$elm$html$Html$Attributes$class('secondary-button reset-filter-button')
																						]),
																					_List_fromArray(
																						[
																							$elm$html$Html$text('Reset')
																						]))),
																				A2(
																				$elm$html$Html$div,
																				_List_fromArray(
																					[
																						$elm$html$Html$Attributes$class('dropdown')
																					]),
																				_List_fromArray(
																					[
																						A2(
																						$elm$html$Html$button,
																						_List_fromArray(
																							[
																								$elm$html$Html$Events$onClick($author$project$Pages$OrgSecurity$ToggleFilterDropdown),
																								$elm$html$Html$Attributes$id($author$project$Pages$OrgSecurity$filterButtonId),
																								$elm$html$Html$Attributes$classList(
																								_List_fromArray(
																									[
																										_Utils_Tuple2('active', isOpen),
																										_Utils_Tuple2('secondary-button', !isOpen),
																										_Utils_Tuple2('primary-button', isOpen)
																									]))
																							]),
																						_List_fromArray(
																							[
																								$author$project$Views$Icon$view(
																								$author$project$Views$Icon$small(
																									A2(
																										$author$project$Views$Icon$colored,
																										$author$project$Style$color('blue'),
																										$author$project$Views$Icon$icon(26)))),
																								$elm$html$Html$text(
																								'Filter' + ((activeFilters > 0) ? (' (' + ($elm$core$String$fromInt(activeFilters) + ')')) : ''))
																							])),
																						A2(
																						$elm$html$Html$div,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$classList(
																								_List_fromArray(
																									[
																										_Utils_Tuple2('dropdown-menu', true),
																										_Utils_Tuple2('visible', isOpen),
																										_Utils_Tuple2('hidden', !isOpen)
																									])),
																								$elm$html$Html$Attributes$id($author$project$Pages$OrgSecurity$filterDropdownId)
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$div,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$class('filter-dropdown-container')
																									]),
																								A2(
																									$elm$core$List$cons,
																									A2(
																										$elm$html$Html$span,
																										_List_fromArray(
																											[
																												$elm$html$Html$Attributes$class('filter-dropdown-heading')
																											]),
																										_List_fromArray(
																											[
																												$elm$html$Html$text('Severity')
																											])),
																									_Utils_ap(
																										severityFilterRows,
																										A2(
																											$elm$core$List$cons,
																											A2(
																												$elm$html$Html$span,
																												_List_fromArray(
																													[
																														$elm$html$Html$Attributes$class('filter-dropdown-heading')
																													]),
																												_List_fromArray(
																													[
																														$elm$html$Html$text('Project Visibility')
																													])),
																											_Utils_ap(
																												visibilityFilterRows,
																												_List_fromArray(
																													[
																														A2(
																														$elm$html$Html$button,
																														_List_fromArray(
																															[
																																$elm$html$Html$Events$onClick($author$project$Pages$OrgSecurity$ResetFilter),
																																$elm$html$Html$Attributes$class('secondary-button small reset-filter-button')
																															]),
																														_List_fromArray(
																															[
																																$elm$html$Html$text('Reset Filter')
																															]))
																													]))))))
																							]))
																					]))
																			])),
																		$author$project$Views$CVESummary$viewTotals(
																		{
																			xI: false,
																			y7: $elm$core$Maybe$Nothing,
																			zd: $elm$core$Maybe$Just($author$project$Pages$OrgSecurity$SeverityQuickFilterClicked),
																			F2: severityHistogram
																		})
																	]))
															]))
													])),
												A2(
												$elm$html$Html$tr,
												_List_Nil,
												$elm$core$List$concat(
													_List_fromArray(
														[
															A2($elm$core$List$map, columnLabel, $author$project$Pages$OrgSecurity$allColumns),
															_List_fromArray(
															[
																A2(
																$elm$html$Html$th,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('row-actions')
																	]),
																_List_Nil)
															])
														]))),
												A2(
												$elm$html$Html$tr,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$td,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$colspan(
																$elm$core$List$length($author$project$Pages$OrgSecurity$allColumns) + 1)
															]),
														_List_fromArray(
															[
																A2($elm$html$Html$hr, _List_Nil, _List_Nil)
															]))
													]))
											])),
										A2(
										$elm$html$Html$tbody,
										_List_Nil,
										A2($elm$core$List$map, rowView, rows))
									])),
								A2(
								$author$project$Misc$displayIf,
								$elm$core$List$isEmpty(rows),
								A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('no-results')
										]),
									_List_fromArray(
										[
											hasSearchOrFilter ? $elm$html$Html$text('No vulnerabilities match your criteria.') : $elm$html$Html$text('No vulnerabilities detected.')
										])))
							]))
					]));
	}
};
var $author$project$Pages$OrgSettings$CancelDeleteOrg = {$: 4};
var $author$project$Pages$OrgSettings$CancelEndSubscription = {$: 8};
var $author$project$Pages$OrgSettings$CancelLeaveOrg = {$: 3};
var $author$project$Pages$OrgSettings$DeleteOrg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$OrgSettings$EndSubscription = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$OrgSettings$LeaveOrg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Views$Tooltip$asHtml = function (_v0) {
	var tt = _v0;
	var wrapper = A2($elm$core$Maybe$withDefault, $elm$html$Html$div, tt.w6);
	var trigger = A2($elm$core$Maybe$withDefault, $elm$html$Html$button, tt.wO);
	var tooltipWrapperClasses = $elm$html$Html$Attributes$classList(
		_List_fromArray(
			[
				_Utils_Tuple2('tooltip-wrapper', true),
				_Utils_Tuple2('small', tt.sq),
				_Utils_Tuple2(tt.tO, true)
			]));
	var tooltipClasses = $elm$html$Html$Attributes$classList(
		_List_fromArray(
			[
				_Utils_Tuple2('tooltip', true),
				_Utils_Tuple2('inverted', tt.rd)
			]));
	var tooltip = A2($elm$core$Maybe$withDefault, $elm$html$Html$div, tt.wJ);
	return A2(
		wrapper,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('tooltip-and-trigger')
			]),
		_List_fromArray(
			[
				A2(trigger, _List_Nil, tt.wP),
				A2(
				tooltip,
				_List_fromArray(
					[tooltipWrapperClasses]),
				_List_fromArray(
					[
						$author$project$Views$Card$asHtmlCard(
						A2(
							$author$project$Views$Card$withContent,
							tt.wK,
							A2(
								$author$project$Views$Card$withAttributes,
								_List_fromArray(
									[tooltipClasses]),
								$author$project$Views$Card$newCard)))
					]))
			]));
};
var $author$project$Views$Tooltip$Tooltip = $elm$core$Basics$identity;
var $author$project$Views$Tooltip$newTooltip = {tO: '', rd: false, sq: false, wJ: $elm$core$Maybe$Nothing, wK: _List_Nil, wO: $elm$core$Maybe$Nothing, wP: _List_Nil, w6: $elm$core$Maybe$Nothing};
var $author$project$Views$Tooltip$withTooltipElements = F2(
	function (elements, _v0) {
		var tt = _v0;
		return _Utils_update(
			tt,
			{wK: elements});
	});
var $author$project$Views$Tooltip$withTriggerContainer = F2(
	function (node, _v0) {
		var tt = _v0;
		return _Utils_update(
			tt,
			{
				wO: $elm$core$Maybe$Just(node)
			});
	});
var $author$project$Views$Tooltip$withTriggerElements = F2(
	function (elements, _v0) {
		var tt = _v0;
		return _Utils_update(
			tt,
			{wP: elements});
	});
var $author$project$Views$Tooltip$buttonWithTooltip = F3(
	function (btnAttrs, btnContent, tooltipContent) {
		return A2(
			$author$project$Views$Tooltip$withTooltipElements,
			tooltipContent,
			A2(
				$author$project$Views$Tooltip$withTriggerElements,
				btnContent,
				A2(
					$author$project$Views$Tooltip$withTriggerContainer,
					function (attrs) {
						return $elm$html$Html$button(
							_Utils_ap(btnAttrs, attrs));
					},
					$author$project$Views$Tooltip$newTooltip)));
	});
var $author$project$Views$ConfirmButton$view = function (args) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('delete-ui')
			]),
		(!_Utils_eq(
			args.fB,
			$elm$core$Maybe$Just(args.l6))) ? _List_fromArray(
			[
				$author$project$Views$Tooltip$asHtml(
				A3(
					$author$project$Views$Tooltip$buttonWithTooltip,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Attributes$class(args.xY),
							A2($elm$html$Html$Attributes$attribute, 'data-cy', args.xZ),
							$elm$html$Html$Events$onClick(
							args.x6(false)),
							$elm$html$Html$Attributes$disabled(args.x3)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(args.b2)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(args.Au)
						])))
			]) : _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('confirm')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('confirm-text')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Are you sure?')
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('confirm-buttons')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(args.AW),
										A2($elm$html$Html$Attributes$attribute, 'data-cy', args.AX),
										$elm$html$Html$Events$onClick(
										args.x6(true)),
										$elm$html$Html$Attributes$disabled(args.x3)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Yes')
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(args.zq),
										A2($elm$html$Html$Attributes$attribute, 'data-cy', args.zr),
										$elm$html$Html$Events$onClick(args.xz),
										$elm$html$Html$Attributes$disabled(args.x3)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Cancel')
									]))
							]))
					]))
			]));
};
var $author$project$Views$SubscriptionInfo$freeTierView = _List_fromArray(
	[
		A2(
		$elm$html$Html$p,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('This organization is on the free Community Tier.')
			])),
		A2(
		$elm$html$Html$p,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href(
						$author$project$Url$Extra$pricing(_List_Nil)),
						$elm$html$Html$Attributes$target('_blank')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('View subscription plans and pricing')
					]))
			]))
	]);
var $author$project$Model$Tier$simpleTierIsEnterprise = function (simpleTier) {
	return A2(
		$elm$core$List$member,
		simpleTier,
		_List_fromArray(
			[$author$project$Model$Tier$Enterprise, $author$project$Model$Tier$EnterpriseEval]));
};
var $author$project$Model$Tier$isEnterprise = A2(
	$elm$core$Basics$composeR,
	$author$project$Model$Tier$name,
	A2($elm$core$Basics$composeR, $author$project$Model$Tier$stringToSimpleTier, $author$project$Model$Tier$simpleTierIsEnterprise));
var $author$project$Model$Permissions$orgCanSeeIndemnificationData = $author$project$Model$Organization$addOnEnabled('indemnification');
var $author$project$Model$Organization$trialHasBeenCancelled = function (_v0) {
	var subscription = _v0.wv;
	if ((subscription.$ === 3) && (subscription.a.$ === 1)) {
		var _v2 = subscription.a;
		return true;
	} else {
		return false;
	}
};
var $author$project$Views$SubscriptionInfo$paidTierView = F2(
	function (_v0, session) {
		var organization = _v0.c3;
		var limitsInfo = _v0.D$;
		var confirmingID = _v0.fB;
		var confirmID = _v0.BV;
		var endSubscriptionMsg = _v0.Cq;
		var cancelEndSubscriptionMsg = _v0.Br;
		var processing = _v0.fw;
		var tierName = A2(
			$elm$core$String$join,
			' ',
			A3(
				$author$project$Misc$concatIf,
				$author$project$Model$Organization$trialHasBeenCancelled(organization),
				'(cancelled)',
				A3(
					$author$project$Misc$concatIf,
					$author$project$Model$Organization$isInTrial(organization),
					'Trial',
					function () {
						var _v7 = $author$project$Model$Tier$stringToSimpleTier(organization.dc);
						if (_v7.$ === 2) {
							return _List_fromArray(
								['Pro Account']);
						} else {
							return _List_fromArray(
								[
									$author$project$Model$Tier$tierNameAsSimpleTierString(organization.dc),
									'Tier'
								]);
						}
					}())));
		var infoRow = F2(
			function (name, value) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('info-row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(name)
								])),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(value)
								]))
						]));
			});
		var dateFormat = _List_fromArray(
			[
				$ryan_haskell$date_format$DateFormat$monthNameAbbreviated,
				$ryan_haskell$date_format$DateFormat$text(' '),
				$ryan_haskell$date_format$DateFormat$dayOfMonthFixed,
				$ryan_haskell$date_format$DateFormat$text(', '),
				$ryan_haskell$date_format$DateFormat$yearNumber
			]);
		var changePlan = function () {
			var _v4 = organization.wv;
			_v4$2:
			while (true) {
				if (_v4.$ === 3) {
					switch (_v4.a.$) {
						case 0:
							var _v5 = _v4.a;
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('cancel-subscription-button')
										]),
									_List_fromArray(
										[
											$author$project$Views$ConfirmButton$view(
											{xz: cancelEndSubscriptionMsg, fB: confirmingID, xY: 'primary-button', xZ: '', x3: processing, x6: endSubscriptionMsg, l6: confirmID, b2: 'Cancel ' + tierName, zq: 'secondary-button small', zr: '', Au: 'You will be immediately downgraded to a free account and your credit card will not be charged.', AW: 'primary-button small', AX: ''})
										]))
								]);
						case 1:
							var _v6 = _v4.a;
							return _List_Nil;
						default:
							break _v4$2;
					}
				} else {
					break _v4$2;
				}
			}
			return _List_fromArray(
				[
					$elm$html$Html$text('To change your subscription please contact '),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('mailto:sales@activestate.com'),
							$elm$html$Html$Attributes$target('_blank')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('sales@activestate.com')
						])),
					$elm$html$Html$text('.')
				]);
		}();
		var billingDateView = function () {
			var label = function () {
				var _v1 = organization.wv;
				_v1$2:
				while (true) {
					if (_v1.$ === 3) {
						switch (_v1.a.$) {
							case 0:
								var _v2 = _v1.a;
								return 'First Billing Date';
							case 1:
								var _v3 = _v1.a;
								return 'Trial End Date';
							default:
								break _v1$2;
						}
					} else {
						break _v1$2;
					}
				}
				return 'Next Billing Date';
			}();
			return A2(
				$author$project$Misc$displayMaybe,
				infoRow(label),
				A2(
					$elm$core$Maybe$map,
					A2(
						$ryan_haskell$date_format$DateFormat$format,
						dateFormat,
						$author$project$Model$Session$getLocalTimezone(session)),
					organization.xn));
		}();
		var activeRuntimes = $elm$core$String$fromInt(limitsInfo.A0);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				A3(
					$elm_community$basics_extra$Basics$Extra$flip,
					$elm$core$Basics$append,
					_List_fromArray(
						[billingDateView]),
					A3(
						$elm_community$basics_extra$Basics$Extra$flip,
						$elm$core$Basics$append,
						_List_fromArray(
							[
								A2(infoRow, 'Runtimes', activeRuntimes)
							]),
						_List_fromArray(
							[
								A2(infoRow, 'Plan', tierName)
							])))),
				A2($elm$html$Html$section, _List_Nil, changePlan)
			]);
	});
var $author$project$Views$SubscriptionInfo$view = F2(
	function (model, session) {
		var onPaidTier = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Model$Tier$isEligibleAsSubscription, model.dc));
		var paidOrFreeView = onPaidTier ? A2($author$project$Views$SubscriptionInfo$paidTierView, model, session) : $author$project$Views$SubscriptionInfo$freeTierView;
		var indemnificationEnabled = $author$project$Model$Permissions$orgCanSeeIndemnificationData(model.c3);
		var indemnificationHeader = A2(
			$elm$html$Html$h2,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Indemnification'),
					indemnificationEnabled ? A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('status-enabled')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Enabled')
						])) : A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('status-disabled')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Disabled')
						]))
				]));
		var indemnificationElements = indemnificationEnabled ? _List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Indemnified builds created within this organization are covered by a limited indemnity from ActiveState pursuant to the terms of the ACTIVESTATE® Platform Enterprise Tier Addendum.')
					]))
			]) : _List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Builds created within this organization are not covered by a limited indemnity from ActiveState pursuant to the terms of the ACTIVESTATE® Platform Enterprise Tier Addendum.')
					])),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('change-subscription')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('To enable indemnification please contact '),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href('mailto:sales@activestate.com'),
								$elm$html$Html$Attributes$target('_blank')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('sales@activestate.com')
							])),
						$elm$html$Html$text('.')
					]))
			]);
		var externalLinkElements = function (url) {
			return A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href(url),
								$elm$html$Html$Attributes$target('_blank')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('View & Manage Invoices')
							]))
					]));
		};
		var externalLinkView = A2(
			$author$project$Misc$displayMaybe,
			externalLinkElements,
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.CB;
				},
				model.qp));
		var displayAddons = indemnificationEnabled || A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Model$Tier$isEnterprise, model.dc));
		return _List_fromArray(
			[
				$author$project$Views$Card$asHtmlCard(
				A2(
					$author$project$Views$Card$withContent,
					_Utils_ap(
						paidOrFreeView,
						_List_fromArray(
							[externalLinkView])),
					A3(
						$author$project$Views$Card$withHeader,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h2,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Subscription Plan')
									]))
							]),
						$author$project$Views$Card$newCard))),
				A2(
				$author$project$Misc$displayIf,
				displayAddons,
				$author$project$Views$Card$asHtmlCard(
					A2(
						$author$project$Views$Card$withContent,
						indemnificationElements,
						A3(
							$author$project$Views$Card$withHeader,
							_List_Nil,
							_List_fromArray(
								[indemnificationHeader]),
							$author$project$Views$Card$newCard))))
			]);
	});
var $author$project$Views$Columns$withCardColumns = F2(
	function (cards, columns) {
		var attrs = A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class('column'),
			columns.qF);
		return _Utils_update(
			columns,
			{
				iX: A2(
					$elm$core$List$append,
					columns.iX,
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Views$Card$withAttributes(attrs),
							$author$project$Views$Card$asHtmlCard),
						cards))
			});
	});
var $author$project$Views$Columns$withConditionalColumnData = F3(
	function (evaluatesToTrue, fn, columns) {
		return evaluatesToTrue ? fn(columns) : columns;
	});
var $author$project$Pages$OrgSettings$view = F2(
	function (model, session) {
		var viewParams = {qp: model.qp, Br: $author$project$Pages$OrgSettings$CancelEndSubscription, BV: $author$project$Pages$OrgSettings$confirmIdEndSubscription, fB: model.fB, Cq: $author$project$Pages$OrgSettings$EndSubscription, D$: model.D$, c3: model.c3, fw: model.fw, dc: model.dc};
		var onPaidTier = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Model$Tier$isEligibleAsSubscription, model.dc));
		var canPerformAdminActions = $author$project$Model$Session$isSuperUser(session) || (!onPaidTier);
		var adminActions = A2(
			$author$project$Views$Card$withContent,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('admin-actions')
						]),
					_List_fromArray(
						[
							$author$project$Views$ConfirmButton$view(
							{xz: $author$project$Pages$OrgSettings$CancelDeleteOrg, fB: model.fB, xY: 'delete-button', xZ: 'delete-org', x3: model.fw, x6: $author$project$Pages$OrgSettings$DeleteOrg, l6: $author$project$Pages$OrgSettings$confirmIdDeleteOrg, b2: 'Delete Organization', zq: 'secondary-button cancel-action', zr: '', Au: 'This organization will no longer be accessible.', AW: 'red-button', AX: 'delete-org-confirm'}),
							$author$project$Views$ConfirmButton$view(
							{xz: $author$project$Pages$OrgSettings$CancelLeaveOrg, fB: model.fB, xY: 'red-button', xZ: '', x3: model.fw, x6: $author$project$Pages$OrgSettings$LeaveOrg, l6: $author$project$Pages$OrgSettings$confirmIdLeaveOrg, b2: 'Leave Organization', zq: 'cancel-button', zr: '', Au: 'You will no longer be a member of this organization.', AW: 'red-button', AX: ''})
						]))
				]),
			$author$project$Views$Card$newCard);
		var withAdminCard = A2(
			$elm$core$Basics$composeR,
			$author$project$Views$Columns$withColumnAttrs(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('narrow')
					])),
			A2(
				$author$project$Views$Columns$withConditionalColumnData,
				canPerformAdminActions,
				$author$project$Views$Columns$withCardColumns(
					_List_fromArray(
						[adminActions]))));
		return A2(
			$elm$html$Html$main_,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Views$Columns$asHtml(
					withAdminCard(
						A2(
							$author$project$Views$Columns$withColumn,
							A2($author$project$Views$SubscriptionInfo$view, viewParams, session),
							A2(
								$author$project$Views$Columns$withColumnAs,
								$elm$html$Html$section,
								A2(
									$author$project$Views$Columns$withAttrs,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('org-settings')
										]),
									$author$project$Views$Columns$asColumns($elm$html$Html$div))))))
				]));
	});
var $author$project$Pages$Orgs$ChangeSearch = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Orgs$ClearSearch = {$: 3};
var $author$project$Pages$Orgs$TeamTierTagHoverEnd = {$: 5};
var $author$project$Pages$Orgs$TeamTierTagHoverStart = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Orgs$CancelLeaveOrg = {$: 7};
var $author$project$Pages$Orgs$LeaveOrg = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$Orgs$leaveButton = F2(
	function (confirmOrgUrlName, org) {
		return $author$project$Views$ConfirmButton$view(
			{
				xz: $author$project$Pages$Orgs$CancelLeaveOrg,
				fB: confirmOrgUrlName,
				xY: 'red-button small',
				xZ: '',
				x3: false,
				x6: $author$project$Pages$Orgs$LeaveOrg(org.AC),
				l6: org.AC,
				b2: 'Leave',
				zq: 'cancel-button small',
				zr: '',
				Au: 'You will no longer be a member of this organization',
				AW: 'red-button small',
				AX: ''
			});
	});
var $elm$html$Html$progress = _VirtualDom_node('progress');
var $author$project$Views$InlineSearchBar$searchBarMinimumItems = 10;
var $author$project$Views$Tooltip$toggleSmallSize = function (_v0) {
	var tt = _v0;
	return _Utils_update(
		tt,
		{sq: !tt.sq});
};
var $author$project$Model$Organization$trialEndDate = function (org) {
	return $author$project$Model$Organization$isInTrial(org) ? org.xn : $elm$core$Maybe$Nothing;
};
var $author$project$Model$Organization$trialMaxDays = 14;
var $author$project$Model$Organization$trialDaysRemaining = F2(
	function (currentDate, org) {
		var daysBetweenDates = F2(
			function (end, current) {
				return A3(
					$elm$core$Basics$clamp,
					0,
					$author$project$Model$Organization$trialMaxDays,
					1 + A2($author$project$TimeUtils$daysBetween, end, current));
			});
		return A3(
			$elm$core$Maybe$map2,
			daysBetweenDates,
			$author$project$Model$Organization$trialEndDate(org),
			currentDate);
	});
var $author$project$Pages$Orgs$view = F3(
	function (model, session, currentTime) {
		var trialLabel = function (org) {
			if ($author$project$Model$Organization$isInTrial(org)) {
				var trialName = function () {
					var _v2 = $author$project$Model$Tier$stringToSimpleTier(org.dc);
					if (_v2.$ === 2) {
						return 'Pro Account';
					} else {
						var tier = _v2;
						return $author$project$Model$Tier$simpleTierDisplayString(tier) + ' Tier';
					}
				}();
				return A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (days) {
							return $elm$core$List$singleton(
								$author$project$Views$Tooltip$asHtml(
									$author$project$Views$Tooltip$toggleSmallSize(
										A2(
											$author$project$Views$Tooltip$withTooltipElements,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$progress,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$max(
															$elm$core$String$fromInt($author$project$Model$Organization$trialMaxDays)),
															$elm$html$Html$Attributes$value(
															$elm$core$String$fromInt(days)),
															$elm$html$Html$Attributes$class('full-width')
														]),
													_List_Nil),
													A2(
													$elm$html$Html$strong,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('display-block')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('The ' + (trialName + ' trial for this organization expires ')),
															$elm$html$Html$text(
															(days <= 1) ? 'today' : ('in ' + ($elm$core$String$fromInt(days) + ' days')))
														])),
													$elm$html$Html$text('Once it expires, your subscription will begin and your credit card will be charged for the annual amount'),
													A3(
													$author$project$Views$Link$link,
													$author$project$Model$Route$Protected(
														$author$project$Model$Route$Org(
															{ix: org.AC, vI: $author$project$Model$Route$OrgSettings})),
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Manage subscription')
														]))
												]),
											A2(
												$author$project$Views$Tooltip$withTriggerElements,
												_List_fromArray(
													[
														$author$project$Views$Icon$view(
														$author$project$Views$Icon$icon(35)),
														$elm$html$Html$text(trialName + ' Trial')
													]),
												A2(
													$author$project$Views$Tooltip$withTriggerContainer,
													F2(
														function (a, e) {
															return A2(
																$elm$html$Html$span,
																A2(
																	$elm$core$List$cons,
																	$elm$html$Html$Attributes$class('item-label hover-blue trial-tooltip'),
																	a),
																e);
														}),
													$author$project$Views$Tooltip$newTooltip))))));
						},
						A2($author$project$Model$Organization$trialDaysRemaining, currentTime, org)));
			} else {
				return _List_Nil;
			}
		};
		var sortedOrgs = A2(
			$elm$core$List$sortBy,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.AC;
				},
				$elm$core$String$toLower),
			model.mX);
		var memberCountLabel = function (memberCount) {
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item-label')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A3($elm_community$string_extra$String$Extra$pluralize, 'Member', 'Members', memberCount))
					]));
		};
		var maybeUser = $author$project$Model$Session$getUser(session);
		var userRoleString = function (org) {
			return $author$project$Model$Role$toDisplayString(
				A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$elm$core$Maybe$map,
						$author$project$Model$User$effectiveRole(org.AC),
						maybeUser)));
		};
		var viewOrg = function (org) {
			var isMatch = F2(
				function (maybeId, currentOrg) {
					return A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						false,
						$elm$core$Basics$eq(
							$author$project$Model$Organization$idString(currentOrg)),
						maybeId);
				});
			var isLeaveConfirmationActive = A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				false,
				$elm$core$Basics$eq(org.AC),
				model.jJ);
			var buttons = A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('buttons')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Misc$displayIf,
						A2($author$project$Model$Permissions$canUpgradeOrg, org.AC, maybeUser),
						function () {
							var _v0 = $author$project$Model$Tier$stringToSimpleTier(org.dc);
							if (!_v0.$) {
								var misTrial = A2($author$project$Model$Organization$isEligibleForUpgrade, true, org) ? $elm$core$Maybe$Just(true) : (A2($author$project$Model$Organization$isEligibleForUpgrade, false, org) ? $elm$core$Maybe$Just(false) : $elm$core$Maybe$Nothing);
								if (!misTrial.$) {
									return $author$project$Views$TeamTier$teamTierTag(
										{
											l6: $author$project$Model$Organization$idString(org),
											rH: $author$project$Pages$Orgs$TeamTierTagHoverEnd,
											rI: $author$project$Pages$Orgs$TeamTierTagHoverStart,
											F4: A2(isMatch, model.pO, org)
										});
								} else {
									return A2($elm$html$Html$div, _List_Nil, _List_Nil);
								}
							} else {
								return $elm$html$Html$text('');
							}
						}()),
						A3(
						$author$project$Views$Link$link,
						$author$project$Model$Route$Protected(
							$author$project$Model$Route$Org(
								{ix: org.AC, vI: $author$project$Model$Route$OrgMembers})),
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('secondary-button small')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Manage Members')
							]))
					]));
			return A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('large-item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('item-info')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('item-name-and-tags')
									]),
								_Utils_ap(
									_List_fromArray(
										[
											A3(
											$author$project$Views$Link$link,
											$author$project$Model$Route$Protected(
												$author$project$Model$Route$Org(
													{
														ix: org.AC,
														vI: $author$project$Model$Route$OrgIndex($elm$core$Maybe$Nothing)
													})),
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('item-name')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(org.AC)
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('item-tags')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('item-label')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															userRoleString(org))
														])),
													A2($author$project$Misc$displayMaybe, memberCountLabel, org.Eg),
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('item-label')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Model$Tier$tierNameAsSimpleTierString(org.dc))
														]))
												]))
										]),
									trialLabel(org)))
							])),
						A2($author$project$Misc$displayIf, !isLeaveConfirmationActive, buttons),
						A2($author$project$Pages$Orgs$leaveButton, model.jJ, org)
					]));
		};
		var filterBySearch = function (orgs) {
			var isMatch = function (org) {
				return A2(
					$elm$core$String$contains,
					$elm$core$String$toLower(model.np),
					$elm$core$String$toLower(org.AC));
			};
			return A2($elm$core$List$filter, isMatch, orgs);
		};
		return A2(
			$elm$html$Html$main_,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Views$NotificationsInline$view(model),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Misc$displayIf,
							!$elm$core$List$isEmpty(sortedOrgs),
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('heading-with-cta')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h2,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Organizations'),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('more-info-tooltip')
													]),
												_List_fromArray(
													[
														$author$project$Views$Icon$view(
														$author$project$Views$Icon$icon(52)),
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('content')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$p,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('Organizations allow you to create runtimes that you can manage and share with members of a team.')
																	]))
															]))
													]))
											])),
										A2(
										$author$project$Misc$displayIf,
										_Utils_cmp(
											$elm$core$List$length(model.mX),
											$author$project$Views$InlineSearchBar$searchBarMinimumItems) > 0,
										$author$project$Views$InlineSearchBar$inlineSearchBar(
											{
												Bx: $author$project$Pages$Orgs$ChangeSearch,
												BG: $elm$core$Maybe$Just($author$project$Pages$Orgs$ClearSearch),
												j0: model.np,
												Fd: 'Filter by name'
											})),
										A3(
										$author$project$Views$Link$link,
										$author$project$Model$Route$Protected(
											$author$project$Model$Route$CreateOrganization(
												{h3: $elm$core$Maybe$Nothing, dg: $elm$core$Maybe$Nothing})),
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('primary-button')
											]),
										_List_fromArray(
											[
												$author$project$Views$Icon$view(
												$author$project$Views$Icon$icon(61)),
												$elm$html$Html$text('New Organization')
											]))
									]))),
							A2(
							$elm$html$Html$map,
							$author$project$Pages$Orgs$OnInvitationEvent,
							A2($author$project$Views$Invitations$view, false, session)),
							A2(
							$author$project$Misc$displayIf,
							!$elm$core$List$isEmpty(sortedOrgs),
							A2(
								$elm$html$Html$ul,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('large-list item-list orgs-list')
									]),
								A2(
									$elm$core$List$map,
									viewOrg,
									filterBySearch(sortedOrgs)))),
							A2(
							$author$project$Misc$displayIf,
							$elm$core$List$isEmpty(sortedOrgs),
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('no-organizations-large')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('image')
											]),
										_List_Nil),
										A2(
										$elm$html$Html$h3,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Working with a team?')
											])),
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Create an organization and invite members to manage and use shared language runtimes together.')
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('org-cta')
											]),
										_List_fromArray(
											[
												A3(
												$author$project$Views$Link$link,
												$author$project$Model$Route$Protected(
													$author$project$Model$Route$CreateOrganization(
														{h3: $elm$core$Maybe$Nothing, dg: $elm$core$Maybe$Nothing})),
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('secondary-button')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Create a free Organization')
													]))
											]))
									])))
						]))
				]));
	});
var $author$project$Pages$OutOfCompliance$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'padding', '50px')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h1,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Welcome to the ActiveState Platform.')
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Multiple employees from your organization are using ActiveState’s language distributions and have now exceeded our free tier limit.'),
						A2(
						$elm$html$Html$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(' They are currently in violation of our ')
							])),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$target('_blank'),
								$elm$html$Html$Attributes$href(model.tN)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(' terms of service.')
							]))
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('To regain immediate access to the Platform')
							])),
						$elm$html$Html$text(', please fill out '),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$target('_blank'),
								$elm$html$Html$Attributes$href(model.sh)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('this form')
							])),
						$elm$html$Html$text(' to discuss appropriate licensing. During this discussion, our team can provide more detailed information on your company’s usage and show additional features available to licensed users.')
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Sincerely,')
							]))
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('The ActiveState Team')
							]))
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$strong,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('primary-button'),
										$elm$html$Html$Attributes$target('_blank'),
										$elm$html$Html$Attributes$href(model.sh)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Contact Sales')
									]))
							]))
					]))
			]));
};
var $author$project$Pages$PreferenceDeleteAccount$AskForConfirmation = {$: 1};
var $author$project$Pages$PreferenceDeleteAccount$BackToInitial = {$: 2};
var $author$project$Pages$PreferenceDeleteAccount$DoDeleteAccount = {$: 3};
var $author$project$Pages$PreferenceDeleteAccount$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('delete-account')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h2,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Delete Account')
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Deleting your personal account removes all organizations and projects owned by your account. Commits you\'ve created in projects owned by other users will not be deleted but will display with no author. This action will not affect marketing emails or your ActiveState Community account.')
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('If you\'re the only admin of an organization with more than one user, you must transfer ownership to another user or delete the organization before you can delete your personal account. If you are the admin of any paid organizations, please contact '),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href('mailto:support@activestate.com'),
								$elm$html$Html$Attributes$target('_blank')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('support@activestate.com')
							])),
						$elm$html$Html$text(' to request account deletion. ')
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('If you have started a free trial for an organization, you must cancel the trial from the Organization Settings page before you can delete your account.')
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('For more help, please visit '),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href('https://docs.activestate.com/platform/user/manage-account/#delete-your-account'),
								$elm$html$Html$Attributes$target('_blank')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('https://docs.activestate.com/platform/user/manage-account/#delete-your-account')
							])),
						$elm$html$Html$text('.')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('delete-control')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Warning')
									])),
								$elm$html$Html$text(' — This is permanent. Once the deletion process begins, you won\'t be able to retrieve your account.')
							])),
						function () {
						var _v0 = model.jU;
						switch (_v0) {
							case 0:
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Events$onClick($author$project$Pages$PreferenceDeleteAccount$AskForConfirmation),
													$elm$html$Html$Attributes$class('delete-button'),
													A2($elm$html$Html$Attributes$attribute, 'data-cy', 'delete-account')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Delete Account')
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('delete-after-button')
												]),
											_List_fromArray(
												[
													A3(
													$author$project$Views$Link$link,
													$author$project$Model$Route$Protected($author$project$Model$Route$Orgs),
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('View and manage organizations')
														]))
												]))
										]));
							case 1:
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('delete-before-button')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Are you sure you want to permenantly delete this account?')
												])),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Events$onClick($author$project$Pages$PreferenceDeleteAccount$DoDeleteAccount),
													$elm$html$Html$Attributes$class('delete-button'),
													A2($elm$html$Html$Attributes$attribute, 'data-cy', 'delete-account-confirm')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Yes, delete account')
												])),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Events$onClick($author$project$Pages$PreferenceDeleteAccount$BackToInitial),
													$elm$html$Html$Attributes$class('cancel-button')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Cancel')
												]))
										]));
							default:
								return $author$project$Views$Loading$dots;
						}
					}()
					]))
			]));
};
var $author$project$Pages$PreferenceEmail$AddEmail = {$: 1};
var $author$project$Pages$PreferenceEmail$NewEmailValue = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$PreferenceEmail$formWarning = function (error) {
	var inlineError = function (content) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('inline-error')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(content)
				]));
	};
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$html$Html$text(''),
		A2($elm$core$Maybe$map, inlineError, error));
};
var $author$project$Pages$PreferenceEmail$Promote = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$PreferenceEmail$RemoveEmail = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$PreferenceEmail$ResendActivationEmail = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$PreferenceEmail$rowActions = function (email) {
	return A2(
		$elm$html$Html$td,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('row-actions')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Misc$displayIf,
				!email.AL,
				A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('not-yet-confirmed')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Not yet verified')
						]))),
				A2(
				$author$project$Misc$displayIf,
				email.AL && (!email.Fn),
				A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('primary-button small'),
							$elm$html$Html$Events$onClick(
							$author$project$Pages$PreferenceEmail$Promote(email.lJ))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Set as Primary')
						]))),
				A2(
				$author$project$Misc$displayIf,
				!email.AL,
				A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('primary-button small'),
							$elm$html$Html$Events$onClick(
							$author$project$Pages$PreferenceEmail$ResendActivationEmail(email.lJ))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Send Verification Email')
						]))),
				A2(
				$author$project$Misc$displayIf,
				!email.Fn,
				A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('red-button small'),
							$elm$html$Html$Events$onClick(
							$author$project$Pages$PreferenceEmail$RemoveEmail(email.lJ))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Delete')
						])))
			]));
};
var $author$project$Pages$PreferenceEmail$viewEmail = function (email) {
	return A2(
		$elm$html$Html$tr,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('email-item', true),
						_Utils_Tuple2('primary-email', email.Fn)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('email')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(email.lJ)
							])),
						A2(
						$author$project$Misc$displayIf,
						email.Fn,
						A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('item-label')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Primary Email')
								]))),
						A2(
						$author$project$Misc$displayIf,
						email.AL,
						A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('item-label')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Verified')
								])))
					])),
				$author$project$Pages$PreferenceEmail$rowActions(email)
			]));
};
var $author$project$Pages$PreferenceEmail$view = F2(
	function (model, _v0) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('preferences')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Email Addresses')
						])),
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('email-list item-table')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tbody,
							_List_Nil,
							A2($elm$core$List$map, $author$project$Pages$PreferenceEmail$viewEmail, model.ir))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('single-field-form')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Add a New Email Address')
								])),
							A2(
							$elm$html$Html$form,
							_List_fromArray(
								[
									$elm$html$Html$Events$onSubmit($author$project$Pages$PreferenceEmail$AddEmail)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('email'),
											$elm$html$Html$Attributes$spellcheck(false),
											$elm$html$Html$Attributes$placeholder('Your email'),
											$elm$html$Html$Events$onInput($author$project$Pages$PreferenceEmail$NewEmailValue),
											$elm$html$Html$Attributes$value(model.ka)
										]),
									_List_Nil),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('primary-button'),
											$elm$html$Html$Attributes$type_('submit')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Add')
										])),
									$author$project$Pages$PreferenceEmail$formWarning(model.oC)
								]))
						]))
				]));
	});
var $author$project$Pages$PreferenceLinkedAccounts$heading = 'Linked Accounts';
var $author$project$Pages$PreferenceLinkedAccounts$linkingStatusOf = F2(
	function (service, serviceStatus) {
		var _v0 = A2(
			$elm$core$Dict$get,
			$author$project$Model$OAuth$key(service),
			serviceStatus);
		if (!_v0.$) {
			var status = _v0.a;
			return status;
		} else {
			return $author$project$Pages$PreferenceLinkedAccounts$NotLinked;
		}
	});
var $author$project$Pages$PreferenceLinkedAccounts$LinkAccount = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$PreferenceLinkedAccounts$UnlinkAccount = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$OAuth$iconKind = function (service) {
	if (!service) {
		return $elm$core$Maybe$Just(31);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$PreferenceLinkedAccounts$linkingStatusBadge = function (status) {
	if (!status.$) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('status status-enabled', true)
						]))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Linked')
				]));
	} else {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('status status-disabled', true)
						]))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Not linked')
				]));
	}
};
var $author$project$Pages$PreferenceLinkedAccounts$unlinkInformationText = 'After unlinking here, you may also want to update your GitHub settings in the Application section and de-authorize the Platform.';
var $author$project$Pages$PreferenceLinkedAccounts$serviceStatusView = F3(
	function (service, session, status) {
		var title = $author$project$Model$OAuth$title;
		var unlinkRequestText = _List_fromArray(
			[
				$elm$html$Html$text(
				'Unlink your ' + (title(service) + ' Account'))
			]);
		var primaryButtonAttrs = _List_fromArray(
			[
				$elm$html$Html$Attributes$class('primary-button')
			]);
		var linkRequestText = _List_fromArray(
			[
				$elm$html$Html$text(
				'Link your ' + (title(service) + ' Account'))
			]);
		var disabledButtonAttrs = _List_fromArray(
			[
				$elm$html$Html$Attributes$class('disabled'),
				$elm$html$Html$Attributes$disabled(true)
			]);
		var buttonElements = _List_fromArray(
			[
				A2(
				$author$project$Misc$displayMaybe,
				A2($elm$core$Basics$composeR, $author$project$Views$Icon$icon, $author$project$Views$Icon$view),
				$author$project$Model$OAuth$iconKind(service))
			]);
		var linkButton = function () {
			switch (status.$) {
				case 0:
					return A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$Pages$PreferenceLinkedAccounts$UnlinkAccount(service)),
								$elm$html$Html$Attributes$class('red-button')
							]),
						_Utils_ap(buttonElements, unlinkRequestText));
				case 2:
					return A2(
						$elm$html$Html$button,
						_Utils_ap(disabledButtonAttrs, primaryButtonAttrs),
						_Utils_ap(buttonElements, unlinkRequestText));
				case 1:
					return A2(
						$elm$html$Html$button,
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Events$onClick(
								$author$project$Pages$PreferenceLinkedAccounts$LinkAccount(service)),
							primaryButtonAttrs),
						_Utils_ap(buttonElements, linkRequestText));
				default:
					return A2(
						$elm$html$Html$button,
						primaryButtonAttrs,
						_Utils_ap(buttonElements, linkRequestText));
			}
		}();
		var additionalInfoView = function () {
			switch (status.$) {
				case 1:
					return $elm$html$Html$text('');
				case 3:
					var reason = status.a;
					return A2(
						$elm$html$Html$article,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										'Unable to link your ' + (title(service) + ' account!'))
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(reason)
									]))
							]));
				case 0:
					var isKSADomain = $author$project$Utils$DomainUtils$isKSADomain(
						$author$project$Model$Session$getFlags(session).B3);
					var shouldShowUnlinkInfo = (!isKSADomain) || (!(!service));
					return A2(
						$author$project$Misc$displayIf,
						shouldShowUnlinkInfo,
						A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text($author$project$Pages$PreferenceLinkedAccounts$unlinkInformationText)
								])));
				default:
					var isKSADomain = $author$project$Utils$DomainUtils$isKSADomain(
						$author$project$Model$Session$getFlags(session).B3);
					var shouldShowGitHubInfo = (!isKSADomain) && (!service);
					return A2(
						$author$project$Misc$displayIf,
						shouldShowGitHubInfo,
						A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('To unlink your GitHub account, you first need to set a password for your Platform account. '),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href('/preferences/password')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Set it here')
										]))
								])));
			}
		}();
		return A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							title(service)),
							$author$project$Pages$PreferenceLinkedAccounts$linkingStatusBadge(status)
						])),
					linkButton,
					additionalInfoView
				]));
	});
var $author$project$Request$OAuth$services = _List_fromArray(
	[0]);
var $author$project$Pages$PreferenceLinkedAccounts$subHeading = 'Sign in to the Platform using your accounts from other services.';
var $author$project$Pages$PreferenceLinkedAccounts$view = F2(
	function (model, session) {
		var twoFactorEnabled = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Aw;
				},
				$author$project$Model$Session$getUser(session)));
		var twoFactorWarning = twoFactorEnabled ? A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Note: ')
						])),
					$elm$html$Html$text('The two-factor authentication method you have enabled on your Platform account does not apply when signing in with a linked account.')
				])) : $elm$html$Html$text('');
		var serviceViews = function () {
			var isKSADomain = $author$project$Utils$DomainUtils$isKSADomain(
				$author$project$Model$Session$getFlags(session).B3);
			var filteredServices = isKSADomain ? A2(
				$elm$core$List$filter,
				function (s) {
					return !(!s);
				},
				$author$project$Request$OAuth$services) : $author$project$Request$OAuth$services;
			return A2(
				$elm$core$List$map,
				function (s) {
					return A3(
						$author$project$Pages$PreferenceLinkedAccounts$serviceStatusView,
						s,
						session,
						A2($author$project$Pages$PreferenceLinkedAccounts$linkingStatusOf, s, model.L));
				},
				filteredServices);
		}();
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('linked-accounts')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text($author$project$Pages$PreferenceLinkedAccounts$heading)
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text($author$project$Pages$PreferenceLinkedAccounts$subHeading)
						])),
					twoFactorWarning,
					A2($elm$html$Html$ul, _List_Nil, serviceViews)
				]));
	});
var $author$project$Pages$PreferencePassword$InputCurrentPassword = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$PreferencePassword$SaveChanges = {$: 4};
var $author$project$Pages$PreferencePassword$InputNewPasswordConfirmation = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$PreferencePassword$newPasswordConfirmationInput = F3(
	function (passwordError, confirmationError, passwordConfirmation) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'error',
							(!_Utils_eq(confirmationError, $elm$core$Maybe$Nothing)) && _Utils_eq(passwordError, $elm$core$Maybe$Nothing))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Confirm New Password')
								])),
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('password'),
									$elm$html$Html$Events$onInput($author$project$Pages$PreferencePassword$InputNewPasswordConfirmation),
									$elm$html$Html$Attributes$value(passwordConfirmation)
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('field-error')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($elm$core$Maybe$withDefault, '', confirmationError))
						]))
				]));
	});
var $author$project$Pages$PreferencePassword$InputNewPassword = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$PreferencePassword$characterMinimumText = function (minLength) {
	return $elm$html$Html$text(
		'At least ' + ($elm$core$String$fromInt(minLength) + ' characters, please.'));
};
var $author$project$Pages$PreferencePassword$newPasswordInput = F2(
	function (error, password) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('password-section', true),
							_Utils_Tuple2(
							'error',
							!_Utils_eq(error, $elm$core$Maybe$Nothing))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('label-helper', true),
											_Utils_Tuple2(
											'hidden-section',
											(_Utils_cmp(
												$elm$core$String$length(password),
												$author$project$Validation$minPasswordLength) > -1) || $elm$core$String$isEmpty(password))
										]))
								]),
							_List_fromArray(
								[
									$author$project$Pages$PreferencePassword$characterMinimumText($author$project$Validation$minPasswordLength)
								])),
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('New Password')
								])),
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('password'),
									$elm$html$Html$Events$onInput($author$project$Pages$PreferencePassword$InputNewPassword),
									$elm$html$Html$Attributes$value(password)
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('field-error')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($elm$core$Maybe$withDefault, '', error))
						]))
				]));
	});
var $author$project$Pages$PreferencePassword$newPasswordWrapper = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('password-wrapper')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$PreferencePassword$newPasswordInput, model.mH, model.zk),
				A3($author$project$Pages$PreferencePassword$newPasswordConfirmationInput, model.mH, model.o6, model.mG)
			]));
};
var $author$project$Pages$PreferencePassword$view = F2(
	function (model, _v0) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('inner-content')
				]),
			_List_fromArray(
				[
					function () {
					var _v1 = model.El;
					if (!_v1) {
						return A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h2,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Set your Password')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('You\'ll need this password along with your platform username to use Komodo and the State Tool.')
										]))
								]));
					} else {
						return A2(
							$elm$html$Html$h2,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Change your Password')
								]));
					}
				}(),
					A2(
					$elm$html$Html$form,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('change-password-form'),
							$elm$html$Html$Events$onSubmit($author$project$Pages$PreferencePassword$SaveChanges)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Misc$displayIf,
							model.El === 1,
							A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('current-password')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('label-helper')
											]),
										_List_fromArray(
											[
												A3(
												$author$project$Views$Link$link,
												$author$project$Model$Route$ForgotPassword,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Forgot your password?')
													]))
											])),
										A2(
										$elm$html$Html$h4,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Current Password')
											])),
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$id('password'),
												$elm$html$Html$Attributes$type_('password'),
												$elm$html$Html$Events$onInput($author$project$Pages$PreferencePassword$InputCurrentPassword),
												$elm$html$Html$Attributes$value(model.xP)
											]),
										_List_Nil)
									]))),
							$author$project$Views$NotificationsInline$view(model),
							$author$project$Pages$PreferencePassword$newPasswordWrapper(model),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button-wrapper')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('primary-button'),
											$elm$html$Html$Attributes$type_('submit')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Save Changes')
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$PreferenceTwoFactor$ConfirmTwoFactor = {$: 8};
var $author$project$Pages$PreferenceTwoFactor$DisableTwoFactor = {$: 7};
var $author$project$Pages$PreferenceTwoFactor$FetchTOTP = {$: 1};
var $author$project$Pages$PreferenceTwoFactor$OnCodeInput = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$PreferenceTwoFactor$StartCancelTwoFactor = {$: 5};
var $elm$html$Html$Attributes$rel = _VirtualDom_attribute('rel');
var $mdgriffith$elm_style_animation$Animation$Render$iePrefix = '-ms-';
var $mdgriffith$elm_style_animation$Animation$Render$webkitPrefix = '-webkit-';
var $mdgriffith$elm_style_animation$Animation$Render$prefix = function (stylePair) {
	var propValue = stylePair.b;
	var propName = stylePair.a;
	switch (propName) {
		case 'transform':
			return _List_fromArray(
				[
					stylePair,
					_Utils_Tuple2(
					_Utils_ap($mdgriffith$elm_style_animation$Animation$Render$iePrefix, propName),
					propValue),
					_Utils_Tuple2(
					_Utils_ap($mdgriffith$elm_style_animation$Animation$Render$webkitPrefix, propName),
					propValue)
				]);
		case 'transform-origin':
			return _List_fromArray(
				[
					stylePair,
					_Utils_Tuple2(
					_Utils_ap($mdgriffith$elm_style_animation$Animation$Render$iePrefix, propName),
					propValue),
					_Utils_Tuple2(
					_Utils_ap($mdgriffith$elm_style_animation$Animation$Render$webkitPrefix, propName),
					propValue)
				]);
		case 'filter':
			return _List_fromArray(
				[
					stylePair,
					_Utils_Tuple2(
					_Utils_ap($mdgriffith$elm_style_animation$Animation$Render$iePrefix, propName),
					propValue),
					_Utils_Tuple2(
					_Utils_ap($mdgriffith$elm_style_animation$Animation$Render$webkitPrefix, propName),
					propValue)
				]);
		default:
			return _List_fromArray(
				[stylePair]);
	}
};
var $elm$svg$Svg$Attributes$cx = _VirtualDom_attribute('cx');
var $elm$svg$Svg$Attributes$cy = _VirtualDom_attribute('cy');
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$Attributes$offset = _VirtualDom_attribute('offset');
var $elm$svg$Svg$Attributes$points = _VirtualDom_attribute('points');
var $elm$core$Basics$cos = _Basics_cos;
var $elm$core$Basics$degrees = function (angleInDegrees) {
	return (angleInDegrees * $elm$core$Basics$pi) / 180;
};
var $elm$core$Basics$sin = _Basics_sin;
var $mdgriffith$elm_style_animation$Animation$Render$pathCmdValue = function (cmd) {
	var renderPoints = function (coords) {
		return A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				function (_v11) {
					var x = _v11.a;
					var y = _v11.b;
					return $elm$core$String$fromFloat(x.Fl) + (',' + $elm$core$String$fromFloat(y.Fl));
				},
				coords));
	};
	switch (cmd.$) {
		case 0:
			var x = cmd.a;
			var y = cmd.b;
			return 'm ' + ($elm$core$String$fromFloat(x.Fl) + (',' + $elm$core$String$fromFloat(y.Fl)));
		case 1:
			var x = cmd.a;
			var y = cmd.b;
			return 'M ' + ($elm$core$String$fromFloat(x.Fl) + (',' + $elm$core$String$fromFloat(y.Fl)));
		case 2:
			var x = cmd.a;
			var y = cmd.b;
			return 'l ' + ($elm$core$String$fromFloat(x.Fl) + (',' + $elm$core$String$fromFloat(y.Fl)));
		case 3:
			var x = cmd.a;
			var y = cmd.b;
			return 'L ' + ($elm$core$String$fromFloat(x.Fl) + (',' + $elm$core$String$fromFloat(y.Fl)));
		case 4:
			var a = cmd.a;
			return 'h ' + $elm$core$String$fromFloat(a.Fl);
		case 5:
			var a = cmd.a;
			return 'H ' + $elm$core$String$fromFloat(a.Fl);
		case 6:
			var a = cmd.a;
			return 'v ' + $elm$core$String$fromFloat(a.Fl);
		case 7:
			var a = cmd.a;
			return 'V ' + $elm$core$String$fromFloat(a.Fl);
		case 8:
			var control1 = cmd.a.og;
			var control2 = cmd.a.oh;
			var point = cmd.a.hL;
			var _v1 = point;
			var p1x = _v1.a;
			var p1y = _v1.b;
			var _v2 = control2;
			var c2x = _v2.a;
			var c2y = _v2.b;
			var _v3 = control1;
			var c1x = _v3.a;
			var c1y = _v3.b;
			return 'c ' + ($elm$core$String$fromFloat(c1x.Fl) + (' ' + ($elm$core$String$fromFloat(c1y.Fl) + (', ' + ($elm$core$String$fromFloat(c2x.Fl) + (' ' + ($elm$core$String$fromFloat(c2y.Fl) + (', ' + ($elm$core$String$fromFloat(p1x.Fl) + (' ' + $elm$core$String$fromFloat(p1y.Fl)))))))))));
		case 9:
			var control1 = cmd.a.og;
			var control2 = cmd.a.oh;
			var point = cmd.a.hL;
			var _v4 = point;
			var p1x = _v4.a;
			var p1y = _v4.b;
			var _v5 = control2;
			var c2x = _v5.a;
			var c2y = _v5.b;
			var _v6 = control1;
			var c1x = _v6.a;
			var c1y = _v6.b;
			return 'C ' + ($elm$core$String$fromFloat(c1x.Fl) + (' ' + ($elm$core$String$fromFloat(c1y.Fl) + (', ' + ($elm$core$String$fromFloat(c2x.Fl) + (' ' + ($elm$core$String$fromFloat(c2y.Fl) + (', ' + ($elm$core$String$fromFloat(p1x.Fl) + (' ' + $elm$core$String$fromFloat(p1y.Fl)))))))))));
		case 10:
			var control = cmd.a.of;
			var point = cmd.a.hL;
			var _v7 = point;
			var p1x = _v7.a;
			var p1y = _v7.b;
			var _v8 = control;
			var c1x = _v8.a;
			var c1y = _v8.b;
			return 'q ' + ($elm$core$String$fromFloat(c1x.Fl) + (' ' + ($elm$core$String$fromFloat(c1y.Fl) + (', ' + ($elm$core$String$fromFloat(p1x.Fl) + (' ' + $elm$core$String$fromFloat(p1y.Fl)))))));
		case 11:
			var control = cmd.a.of;
			var point = cmd.a.hL;
			var _v9 = point;
			var p1x = _v9.a;
			var p1y = _v9.b;
			var _v10 = control;
			var c1x = _v10.a;
			var c1y = _v10.b;
			return 'Q ' + ($elm$core$String$fromFloat(c1x.Fl) + (' ' + ($elm$core$String$fromFloat(c1y.Fl) + (', ' + ($elm$core$String$fromFloat(p1x.Fl) + (' ' + $elm$core$String$fromFloat(p1y.Fl)))))));
		case 12:
			var points = cmd.a;
			return 't ' + renderPoints(points);
		case 13:
			var points = cmd.a;
			return 'T ' + renderPoints(points);
		case 14:
			var points = cmd.a;
			return 's ' + renderPoints(points);
		case 15:
			var points = cmd.a;
			return 'S ' + renderPoints(points);
		case 16:
			var arc = cmd.a;
			var deltaAngle = arc.os.Fl - arc.pS.Fl;
			if (_Utils_cmp(deltaAngle, 360 - 1.0e-6) > 0) {
				var dy = arc.pz.Fl * $elm$core$Basics$sin(
					$elm$core$Basics$degrees(arc.pS.Fl));
				var dx = arc.pz.Fl * $elm$core$Basics$cos(
					$elm$core$Basics$degrees(arc.pS.Fl));
				return 'A ' + ($elm$core$String$fromFloat(arc.pz.Fl) + (',' + ($elm$core$String$fromFloat(arc.pz.Fl) + (',0,1,1,' + ($elm$core$String$fromFloat(arc.AS.Fl - dx) + (',' + ($elm$core$String$fromFloat(arc.AT.Fl - dy) + (' A ' + ($elm$core$String$fromFloat(arc.pz.Fl) + (',' + ($elm$core$String$fromFloat(arc.pz.Fl) + (',0,1,1,' + ($elm$core$String$fromFloat(arc.AS.Fl + dx) + (',' + $elm$core$String$fromFloat(arc.AT.Fl + dy)))))))))))))));
			} else {
				return 'A ' + ($elm$core$String$fromFloat(arc.pz.Fl) + (',' + ($elm$core$String$fromFloat(arc.pz.Fl) + (' 0 ' + (((deltaAngle >= 180) ? '1' : '0') + (' ' + ('1' + (' ' + ($elm$core$String$fromFloat(
					arc.AS.Fl + (arc.pz.Fl * $elm$core$Basics$cos(
						$elm$core$Basics$degrees(arc.os.Fl)))) + (',' + $elm$core$String$fromFloat(
					arc.AT.Fl + (arc.pz.Fl * $elm$core$Basics$sin(
						$elm$core$Basics$degrees(arc.os.Fl))))))))))))));
			}
		case 17:
			var arc = cmd.a;
			var deltaAngle = arc.os.Fl - arc.pS.Fl;
			if (_Utils_cmp(deltaAngle, 360 - 1.0e-6) > 0) {
				var dy = arc.pz.Fl * $elm$core$Basics$sin(
					$elm$core$Basics$degrees(arc.pS.Fl));
				var dx = arc.pz.Fl * $elm$core$Basics$cos(
					$elm$core$Basics$degrees(arc.pS.Fl));
				return 'A ' + ($elm$core$String$fromFloat(arc.pz.Fl) + (',' + ($elm$core$String$fromFloat(arc.pz.Fl) + (',0,1,0,' + ($elm$core$String$fromFloat(arc.AS.Fl - dx) + (',' + ($elm$core$String$fromFloat(arc.AT.Fl - dy) + (' A ' + ($elm$core$String$fromFloat(arc.pz.Fl) + (',' + ($elm$core$String$fromFloat(arc.pz.Fl) + (',0,1,1,' + ($elm$core$String$fromFloat(arc.AS.Fl + dx) + (',' + $elm$core$String$fromFloat(arc.AT.Fl + dy)))))))))))))));
			} else {
				return 'A ' + ($elm$core$String$fromFloat(arc.pz.Fl) + (',' + ($elm$core$String$fromFloat(arc.pz.Fl) + (' 0 ' + ((((arc.pS.Fl - arc.os.Fl) >= 180) ? '1' : '0') + (' ' + ('0' + (' ' + ($elm$core$String$fromFloat(
					arc.AS.Fl + (arc.pz.Fl * $elm$core$Basics$cos(arc.os.Fl))) + (',' + $elm$core$String$fromFloat(
					arc.AT.Fl + (arc.pz.Fl * $elm$core$Basics$sin(arc.os.Fl)))))))))))));
			}
		default:
			return 'z';
	}
};
var $mdgriffith$elm_style_animation$Animation$Render$propertyValue = F2(
	function (prop, delim) {
		switch (prop.$) {
			case 0:
				var value = prop.b;
				return value;
			case 1:
				var r = prop.b;
				var g = prop.c;
				var b = prop.d;
				var a = prop.e;
				return 'rgba(' + ($elm$core$String$fromInt(
					$elm$core$Basics$round(r.Fl)) + (',' + ($elm$core$String$fromInt(
					$elm$core$Basics$round(g.Fl)) + (',' + ($elm$core$String$fromInt(
					$elm$core$Basics$round(b.Fl)) + (',' + ($elm$core$String$fromFloat(a.Fl) + ')')))))));
			case 2:
				var name = prop.a;
				var inset = prop.b;
				var shadow = prop.c;
				return (inset ? 'inset ' : '') + ($elm$core$String$fromFloat(shadow.hF.Fl) + ('px' + (' ' + ($elm$core$String$fromFloat(shadow.hG.Fl) + ('px' + (' ' + ($elm$core$String$fromFloat(shadow.hm.Fl) + ('px' + (' ' + ((((name === 'text-shadow') || (name === 'drop-shadow')) ? '' : ($elm$core$String$fromFloat(shadow.we.Fl) + ('px' + ' '))) + ('rgba(' + ($elm$core$String$fromInt(
					$elm$core$Basics$round(shadow.vW.Fl)) + (', ' + ($elm$core$String$fromInt(
					$elm$core$Basics$round(shadow.tZ.Fl)) + (', ' + ($elm$core$String$fromInt(
					$elm$core$Basics$round(shadow.sX.Fl)) + (', ' + ($elm$core$String$fromFloat(shadow.kN.Fl) + ')'))))))))))))))))));
			case 3:
				var x = prop.b;
				return _Utils_ap(
					$elm$core$String$fromFloat(x.Fl),
					x.GQ);
			case 4:
				var x = prop.b;
				var y = prop.c;
				return _Utils_ap(
					$elm$core$String$fromFloat(x.Fl),
					_Utils_ap(
						x.GQ,
						_Utils_ap(
							delim,
							_Utils_ap(
								$elm$core$String$fromFloat(y.Fl),
								y.GQ))));
			case 5:
				var x = prop.b;
				var y = prop.c;
				var z = prop.d;
				return _Utils_ap(
					$elm$core$String$fromFloat(x.Fl),
					_Utils_ap(
						x.GQ,
						_Utils_ap(
							delim,
							_Utils_ap(
								$elm$core$String$fromFloat(y.Fl),
								_Utils_ap(
									y.GQ,
									_Utils_ap(
										delim,
										_Utils_ap(
											$elm$core$String$fromFloat(z.Fl),
											z.GQ)))))));
			case 6:
				var w = prop.b;
				var x = prop.c;
				var y = prop.d;
				var z = prop.e;
				return _Utils_ap(
					$elm$core$String$fromFloat(w.Fl),
					_Utils_ap(
						w.GQ,
						_Utils_ap(
							delim,
							_Utils_ap(
								$elm$core$String$fromFloat(x.Fl),
								_Utils_ap(
									x.GQ,
									_Utils_ap(
										delim,
										_Utils_ap(
											$elm$core$String$fromFloat(y.Fl),
											_Utils_ap(
												y.GQ,
												_Utils_ap(
													delim,
													_Utils_ap(
														$elm$core$String$fromFloat(z.Fl),
														z.GQ))))))))));
			case 7:
				var x = prop.b;
				return _Utils_ap(
					$elm$core$String$fromFloat(x.Fl),
					x.GQ);
			case 8:
				var coords = prop.a;
				return A2(
					$elm$core$String$join,
					' ',
					A2(
						$elm$core$List$map,
						function (_v1) {
							var x = _v1.a;
							var y = _v1.b;
							return $elm$core$String$fromFloat(x.Fl) + (',' + $elm$core$String$fromFloat(y.Fl));
						},
						coords));
			default:
				var cmds = prop.a;
				return A2(
					$elm$core$String$join,
					' ',
					A2($elm$core$List$map, $mdgriffith$elm_style_animation$Animation$Render$pathCmdValue, cmds));
		}
	});
var $elm$svg$Svg$Attributes$r = _VirtualDom_attribute('r');
var $elm$svg$Svg$Attributes$rx = _VirtualDom_attribute('rx');
var $elm$svg$Svg$Attributes$ry = _VirtualDom_attribute('ry');
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $elm$svg$Svg$Attributes$x = _VirtualDom_attribute('x');
var $elm$svg$Svg$Attributes$y = _VirtualDom_attribute('y');
var $mdgriffith$elm_style_animation$Animation$Render$renderAttrs = function (prop) {
	if (A2(
		$elm$core$String$startsWith,
		'attr:',
		$mdgriffith$elm_style_animation$Animation$Model$propertyName(prop))) {
		return $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$Attributes$attribute,
				A2(
					$elm$core$String$dropLeft,
					5,
					$mdgriffith$elm_style_animation$Animation$Model$propertyName(prop)),
				A2($mdgriffith$elm_style_animation$Animation$Render$propertyValue, prop, ' ')));
	} else {
		switch (prop.$) {
			case 8:
				var pts = prop.a;
				return $elm$core$Maybe$Just(
					$elm$svg$Svg$Attributes$points(
						A2($mdgriffith$elm_style_animation$Animation$Render$propertyValue, prop, ' ')));
			case 9:
				var cmds = prop.a;
				return $elm$core$Maybe$Just(
					$elm$svg$Svg$Attributes$d(
						A2($mdgriffith$elm_style_animation$Animation$Render$propertyValue, prop, ' ')));
			case 3:
				var name = prop.a;
				var m1 = prop.b;
				switch (name) {
					case 'x':
						return $elm$core$Maybe$Just(
							$elm$svg$Svg$Attributes$x(
								A2($mdgriffith$elm_style_animation$Animation$Render$propertyValue, prop, ' ')));
					case 'y':
						return $elm$core$Maybe$Just(
							$elm$svg$Svg$Attributes$y(
								A2($mdgriffith$elm_style_animation$Animation$Render$propertyValue, prop, ' ')));
					case 'cx':
						return $elm$core$Maybe$Just(
							$elm$svg$Svg$Attributes$cx(
								A2($mdgriffith$elm_style_animation$Animation$Render$propertyValue, prop, ' ')));
					case 'cy':
						return $elm$core$Maybe$Just(
							$elm$svg$Svg$Attributes$cy(
								A2($mdgriffith$elm_style_animation$Animation$Render$propertyValue, prop, ' ')));
					case 'rx':
						return $elm$core$Maybe$Just(
							$elm$svg$Svg$Attributes$rx(
								A2($mdgriffith$elm_style_animation$Animation$Render$propertyValue, prop, ' ')));
					case 'ry':
						return $elm$core$Maybe$Just(
							$elm$svg$Svg$Attributes$ry(
								A2($mdgriffith$elm_style_animation$Animation$Render$propertyValue, prop, ' ')));
					case 'r':
						return $elm$core$Maybe$Just(
							$elm$svg$Svg$Attributes$r(
								A2($mdgriffith$elm_style_animation$Animation$Render$propertyValue, prop, ' ')));
					case 'offset':
						return $elm$core$Maybe$Just(
							$elm$svg$Svg$Attributes$offset(
								A2($mdgriffith$elm_style_animation$Animation$Render$propertyValue, prop, ' ')));
					default:
						return $elm$core$Maybe$Nothing;
				}
			case 6:
				var name = prop.a;
				var m1 = prop.b;
				var m2 = prop.c;
				var m3 = prop.d;
				var m4 = prop.e;
				return (name === 'viewBox') ? $elm$core$Maybe$Just(
					$elm$svg$Svg$Attributes$viewBox(
						A2($mdgriffith$elm_style_animation$Animation$Render$propertyValue, prop, ' '))) : $elm$core$Maybe$Nothing;
			default:
				return $elm$core$Maybe$Nothing;
		}
	}
};
var $mdgriffith$elm_style_animation$Animation$Render$isAttr = function (prop) {
	return A2(
		$elm$core$String$startsWith,
		'attr:',
		$mdgriffith$elm_style_animation$Animation$Model$propertyName(prop)) || function () {
		switch (prop.$) {
			case 8:
				return true;
			case 9:
				return true;
			case 3:
				var name = prop.a;
				return (name === 'cx') || ((name === 'cy') || ((name === 'x') || ((name === 'y') || ((name === 'rx') || ((name === 'ry') || ((name === 'r') || (name === 'offset')))))));
			case 6:
				var name = prop.a;
				return name === 'viewBox';
			default:
				return false;
		}
	}();
};
var $mdgriffith$elm_style_animation$Animation$Render$isFilter = function (prop) {
	return A2(
		$elm$core$List$member,
		$mdgriffith$elm_style_animation$Animation$Model$propertyName(prop),
		_List_fromArray(
			['filter-url', 'blur', 'brightness', 'contrast', 'grayscale', 'hue-rotate', 'invert', 'saturate', 'sepia', 'drop-shadow']));
};
var $mdgriffith$elm_style_animation$Animation$Render$render3dRotation = function (prop) {
	if (prop.$ === 5) {
		var x = prop.b;
		var y = prop.c;
		var z = prop.d;
		return 'rotateX(' + ($elm$core$String$fromFloat(x.Fl) + (x.GQ + (') rotateY(' + ($elm$core$String$fromFloat(y.Fl) + (y.GQ + (') rotateZ(' + ($elm$core$String$fromFloat(z.Fl) + (z.GQ + ')'))))))));
	} else {
		return '';
	}
};
var $mdgriffith$elm_style_animation$Animation$Render$renderValues = function (_v0) {
	var model = _v0;
	var _v1 = A2($elm$core$List$partition, $mdgriffith$elm_style_animation$Animation$Render$isAttr, model.hW);
	var attrProps = _v1.a;
	var styleProps = _v1.b;
	var _v2 = A3(
		$elm$core$List$foldl,
		F2(
			function (prop, _v3) {
				var myStyle = _v3.a;
				var myTransforms = _v3.b;
				var myFilters = _v3.c;
				return $mdgriffith$elm_style_animation$Animation$Render$isTransformation(prop) ? _Utils_Tuple3(
					myStyle,
					_Utils_ap(
						myTransforms,
						_List_fromArray(
							[prop])),
					myFilters) : ($mdgriffith$elm_style_animation$Animation$Render$isFilter(prop) ? _Utils_Tuple3(
					myStyle,
					myTransforms,
					_Utils_ap(
						myFilters,
						_List_fromArray(
							[prop]))) : _Utils_Tuple3(
					_Utils_ap(
						myStyle,
						_List_fromArray(
							[prop])),
					myTransforms,
					myFilters));
			}),
		_Utils_Tuple3(_List_Nil, _List_Nil, _List_Nil),
		styleProps);
	var style = _v2.a;
	var transforms = _v2.b;
	var filters = _v2.c;
	var renderedFilters = $elm$core$List$isEmpty(filters) ? _List_Nil : _List_fromArray(
		[
			_Utils_Tuple2(
			'filter',
			A2(
				$elm$core$String$join,
				' ',
				A2(
					$elm$core$List$map,
					function (prop) {
						var name = $mdgriffith$elm_style_animation$Animation$Model$propertyName(prop);
						return (name === 'filter-url') ? ('url(\"' + (A2($mdgriffith$elm_style_animation$Animation$Render$propertyValue, prop, ', ') + '\")')) : ($mdgriffith$elm_style_animation$Animation$Model$propertyName(prop) + ('(' + (A2($mdgriffith$elm_style_animation$Animation$Render$propertyValue, prop, ', ') + ')')));
					},
					filters)))
		]);
	var renderedStyle = A2(
		$elm$core$List$map,
		function (prop) {
			return _Utils_Tuple2(
				$mdgriffith$elm_style_animation$Animation$Model$propertyName(prop),
				A2($mdgriffith$elm_style_animation$Animation$Render$propertyValue, prop, ' '));
		},
		style);
	var renderedTransforms = $elm$core$List$isEmpty(transforms) ? _List_Nil : _List_fromArray(
		[
			_Utils_Tuple2(
			'transform',
			A2(
				$elm$core$String$join,
				' ',
				A2(
					$elm$core$List$map,
					function (prop) {
						return ($mdgriffith$elm_style_animation$Animation$Model$propertyName(prop) === 'rotate3d') ? $mdgriffith$elm_style_animation$Animation$Render$render3dRotation(prop) : ($mdgriffith$elm_style_animation$Animation$Model$propertyName(prop) + ('(' + (A2($mdgriffith$elm_style_animation$Animation$Render$propertyValue, prop, ', ') + ')')));
					},
					transforms)))
		]);
	return _Utils_Tuple2(
		_Utils_ap(
			renderedTransforms,
			_Utils_ap(renderedFilters, renderedStyle)),
		attrProps);
};
var $mdgriffith$elm_style_animation$Animation$Render$render = function (animation) {
	var _v0 = $mdgriffith$elm_style_animation$Animation$Render$renderValues(animation);
	var style = _v0.a;
	var attrProps = _v0.b;
	var otherAttrs = A2($elm$core$List$filterMap, $mdgriffith$elm_style_animation$Animation$Render$renderAttrs, attrProps);
	var styleAttr = A2(
		$elm$core$List$map,
		function (_v1) {
			var prop = _v1.a;
			var val = _v1.b;
			return A2($elm$html$Html$Attributes$style, prop, val);
		},
		A2($elm$core$List$concatMap, $mdgriffith$elm_style_animation$Animation$Render$prefix, style));
	return _Utils_ap(styleAttr, otherAttrs);
};
var $mdgriffith$elm_style_animation$Animation$render = $mdgriffith$elm_style_animation$Animation$Render$render;
var $author$project$Pages$PreferenceTwoFactor$rightArrow = '→';
var $author$project$Pages$PreferenceTwoFactor$view = F2(
	function (session, model) {
		var twoFactorEnabled = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Aw;
				},
				$author$project$Model$Session$getUser(session)));
		var statusElement = twoFactorEnabled ? A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('status status-enabled')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Enabled')
				])) : A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('status status-disabled')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Disabled')
				]));
		var qrCodeUI = function (totpKey) {
			return A2(
				$elm$html$Html$div,
				$mdgriffith$elm_style_animation$Animation$render(model.hW),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('qr-code-ui')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('qr-code-wrapper')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$img,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('qr-code'),
												$elm$html$Html$Attributes$alt('Two factor CQ code'),
												$elm$html$Html$Attributes$src('data:image/png;base64,' + totpKey.Fu)
											]),
										_List_Nil)
									])),
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Scan this Code ' + $author$project$Pages$PreferenceTwoFactor$rightArrow)
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Scan this code with the Two-Factor Authentication app of your choice. It will generate a 6-digit code. Enter it below. Once Two-Factor authentication is enabled, you will need to provide a code from your app every time you sign in.')
									])),
								A2(
								$elm$html$Html$form,
								_List_fromArray(
									[
										$elm$html$Html$Events$onSubmit($author$project$Pages$PreferenceTwoFactor$ConfirmTwoFactor)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$type_('text'),
												$elm$html$Html$Attributes$spellcheck(false),
												$elm$html$Html$Events$onInput($author$project$Pages$PreferenceTwoFactor$OnCodeInput),
												$elm$html$Html$Attributes$value(model.kD),
												$elm$html$Html$Attributes$placeholder('Your 6-digit code')
											]),
										_List_Nil),
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('primary-button'),
												$elm$html$Html$Attributes$type_('submit'),
												$elm$html$Html$Attributes$disabled(
												!$author$project$Pages$PreferenceTwoFactor$validateCode(model.kD))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Confirm')
											]))
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-button'),
										$elm$html$Html$Events$onClick($author$project$Pages$PreferenceTwoFactor$StartCancelTwoFactor),
										$elm$html$Html$Attributes$type_('button')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Cancel')
									]))
							]))
					]));
		};
		var linkedAccounts = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.D2;
					},
					A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not)),
				$author$project$Model$Session$getUser(session)));
		var linkedAccountsNotification = linkedAccounts ? A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Note: ')
						])),
					$elm$html$Html$text('This two-factor authentication method only applies when signing in with your Platform username/email and password; not linked accounts.')
				])) : $elm$html$Html$text('');
		var isTotpKeyLoaded = $krisajenkins$remotedata$RemoteData$isSuccess(model.jz);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('two-factor')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Two-factor Authentication '),
							statusElement
						])),
					twoFactorEnabled ? A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('This account requires two-factor authentication on sign in.')
								])),
							linkedAccountsNotification,
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$Pages$PreferenceTwoFactor$DisableTwoFactor),
									$elm$html$Html$Attributes$class('primary-button'),
									$elm$html$Html$Attributes$type_('button')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Disable')
								]))
						])) : A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Secure access to your account by enabling Two-factor Authentication. You will need to use an app like Google Authenticator'),
									$elm$html$Html$text(' ('),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$target('_blank'),
											$elm$html$Html$Attributes$rel('noopener noreferrer'),
											$elm$html$Html$Attributes$href('https://itunes.apple.com/us/app/google-authenticator/id388497605?mt=8')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('iOS')
										])),
									$elm$html$Html$text('/'),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$target('_blank'),
											$elm$html$Html$Attributes$rel('noopener noreferrer'),
											$elm$html$Html$Attributes$href('https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Android')
										])),
									$elm$html$Html$text(') '),
									$elm$html$Html$text('and will be asked for a PIN number in addition to your email and password when you sign in.')
								])),
							A2(
							$author$project$Misc$displayIf,
							!isTotpKeyLoaded,
							A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick($author$project$Pages$PreferenceTwoFactor$FetchTOTP),
										$elm$html$Html$Attributes$type_('button'),
										$elm$html$Html$Attributes$class('primary-button')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Enable')
									]))),
							A2(
							$author$project$Misc$displayMaybe,
							qrCodeUI,
							$krisajenkins$remotedata$RemoteData$toMaybe(model.jz))
						]))
				]));
	});
var $author$project$Pages$ProjectConfigAdvanced$SaveCommit = {$: 7};
var $author$project$Pages$ProjectConfigAdvanced$UpdateBuildExprText = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$ProjectConfigAdvanced$UpdateCommentText = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$ProjectConfigAdvanced$UpdateTimestampText = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$ProjectConfigAdvanced$Validate = {$: 6};
var $elm$html$Html$Attributes$cols = function (n) {
	return A2(
		_VirtualDom_attribute,
		'cols',
		$elm$core$String$fromInt(n));
};
var $author$project$Views$BranchPicker$commitIsLatest = function (_v0) {
	var reloadingBranch = _v0.kq;
	var currentCommit = _v0.f0;
	var model = _v0.zf;
	var viewingCommitID = $author$project$Model$Commit$getCommitID(currentCommit);
	var latestCommitID = A2(
		$elm$core$Maybe$andThen,
		A2($elm$core$Basics$composeR, $author$project$Views$BranchPicker$getSelectedBranch, $author$project$Model$Branch$getCommitID),
		model);
	return reloadingBranch || _Utils_eq(
		$elm$core$Maybe$Just(viewingCommitID),
		latestCommitID);
};
var $author$project$Pages$ProjectConfigAdvanced$distribtionOnlyView = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('legacy-overview-tab-content')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('coming-soon-title')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Distribution Only')
									])),
								A2(
								$elm$html$Html$h2,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('This build cannot be configured.')
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('This project version is not supported for customization from the ActiveState Platform.')
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Any services or builds included in this project version, are not covered under our standard Service Level Agreement (SLA), unless agreed to by ActiveState in a separate and custom agreement. Any deviations from our standard SLA must be documented in writing and mutually agreed upon by all involved parties. This provision shall supersede any conflicting terms or conditions found in our standard SLA.')
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('To access the last available offline build, select the Download Builds tab.')
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('To create a customizable runtime with open source packages, create a new project.')
									])),
								$author$project$Views$NewProjectButton$active(model.c3.AC)
							]))
					]))
			]));
};
var $author$project$Model$Platform$isAllowedForNonSuperUsers = function (_v0) {
	var platform = _v0;
	return A2(
		$elm$core$List$any,
		function (mapping) {
			return _Utils_eq(
				$author$project$PlatformMapping$platformID(mapping),
				platform.m0) && $author$project$PlatformMapping$selfServiceNonSuperuser(mapping);
		},
		$author$project$PlatformMapping$platformChoicesList);
};
var $elm$virtual_dom$VirtualDom$lazy3 = _VirtualDom_lazy3;
var $elm$html$Html$Lazy$lazy3 = $elm$virtual_dom$VirtualDom$lazy3;
var $author$project$Pages$ProjectConfigAdvanced$invalidJsonMessage = 'This is not valid JSON!';
var $author$project$Pages$ProjectConfigAdvanced$prettifyError = function (input) {
	var _v0 = $elm$core$List$reverse(
		A2($elm$core$String$split, $author$project$Pages$ProjectConfigAdvanced$invalidJsonMessage, input));
	if (!_v0.b) {
		return input;
	} else {
		if (!_v0.b.b) {
			var absent = _v0.a;
			return absent;
		} else {
			var message = _v0.a;
			return 'Malformed JSON: ' + message;
		}
	}
};
var $author$project$Views$BranchPicker$ToggleMenu = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$BranchTree$branchAncestors = F2(
	function (branch, tree) {
		var getParents = F2(
			function (parents, zipper) {
				getParents:
				while (true) {
					var _v0 = $zwilias$elm_rosetree$Tree$Zipper$parent(zipper);
					if (_v0.$ === 1) {
						return parents;
					} else {
						var z = _v0.a;
						var b = $zwilias$elm_rosetree$Tree$label(
							$zwilias$elm_rosetree$Tree$Zipper$tree(z));
						var $temp$parents = A2($elm$core$List$cons, b, parents),
							$temp$zipper = z;
						parents = $temp$parents;
						zipper = $temp$zipper;
						continue getParents;
					}
				}
			});
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				getParents(_List_Nil),
				A2(
					$zwilias$elm_rosetree$Tree$Zipper$findFromRoot,
					$elm$core$Basics$eq(branch),
					$zwilias$elm_rosetree$Tree$Zipper$fromTree(tree))));
	});
var $zwilias$elm_rosetree$Tree$foldlHelp = F4(
	function (f, acc, trees, nextSets) {
		foldlHelp:
		while (true) {
			if (!trees.b) {
				if (nextSets.b) {
					var set = nextSets.a;
					var sets = nextSets.b;
					var $temp$f = f,
						$temp$acc = acc,
						$temp$trees = set,
						$temp$nextSets = sets;
					f = $temp$f;
					acc = $temp$acc;
					trees = $temp$trees;
					nextSets = $temp$nextSets;
					continue foldlHelp;
				} else {
					return acc;
				}
			} else {
				if (!trees.a.b.b) {
					var _v2 = trees.a;
					var d = _v2.a;
					var rest = trees.b;
					var $temp$f = f,
						$temp$acc = A2(f, d, acc),
						$temp$trees = rest,
						$temp$nextSets = nextSets;
					f = $temp$f;
					acc = $temp$acc;
					trees = $temp$trees;
					nextSets = $temp$nextSets;
					continue foldlHelp;
				} else {
					var _v3 = trees.a;
					var d = _v3.a;
					var xs = _v3.b;
					var rest = trees.b;
					var $temp$f = f,
						$temp$acc = A2(f, d, acc),
						$temp$trees = xs,
						$temp$nextSets = A2($elm$core$List$cons, rest, nextSets);
					f = $temp$f;
					acc = $temp$acc;
					trees = $temp$trees;
					nextSets = $temp$nextSets;
					continue foldlHelp;
				}
			}
		}
	});
var $zwilias$elm_rosetree$Tree$foldl = F3(
	function (f, acc, t) {
		return A4(
			$zwilias$elm_rosetree$Tree$foldlHelp,
			f,
			acc,
			_List_fromArray(
				[t]),
			_List_Nil);
	});
var $zwilias$elm_rosetree$Tree$count = function (t) {
	return A3(
		$zwilias$elm_rosetree$Tree$foldl,
		F2(
			function (_v0, x) {
				return x + 1;
			}),
		0,
		t);
};
var $author$project$Model$BranchTree$count = function (tree) {
	return $zwilias$elm_rosetree$Tree$count(tree);
};
var $author$project$Views$BranchPicker$BranchSelected = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Model$BranchTree$getParent = F2(
	function (branch, tree) {
		return A2(
			$elm$core$Maybe$map,
			$zwilias$elm_rosetree$Tree$Zipper$label,
			A2(
				$elm$core$Maybe$andThen,
				$zwilias$elm_rosetree$Tree$Zipper$parent,
				A2(
					$zwilias$elm_rosetree$Tree$Zipper$findFromRoot,
					$elm$core$Basics$eq(branch),
					$zwilias$elm_rosetree$Tree$Zipper$fromTree(tree))));
	});
var $author$project$Model$Branch$getUpstreamCommitID = function (_v0) {
	var branch = _v0;
	return branch.AB;
};
var $author$project$Model$BranchTree$parentHasChange = F2(
	function (branch, tree) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$andThen,
				function (commitID) {
					return A2(
						$elm$core$Maybe$map,
						$elm$core$Basics$neq(commitID),
						$author$project$Model$Branch$getUpstreamCommitID(branch));
				},
				A2(
					$elm$core$Maybe$andThen,
					$author$project$Model$Branch$getCommitID,
					A2($author$project$Model$BranchTree$getParent, branch, tree))));
	});
var $author$project$Views$BranchPicker$toHtml = F3(
	function (selectedbranchName, model, branch) {
		var customOnClickEvent = $author$project$Misc$onClickNoBubble(
			A2($author$project$Views$BranchPicker$BranchSelected, model, branch));
		var bareName = $author$project$Model$Branch$getName(branch);
		var isSelected = _Utils_eq(bareName, selectedbranchName);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('branch-wrapper'),
					$elm$html$Html$Attributes$class('dropdown-item'),
					customOnClickEvent
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tree-branch'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'main',
									$author$project$Model$Branch$isDefault(branch))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('branch-highlight-wrapper')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('branch-name'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('selected', isSelected),
													_Utils_Tuple2(
													'update-available',
													A2($author$project$Model$BranchTree$parentHasChange, branch, model.jA))
												]))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$title(bareName)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(bareName)
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Model$BranchTree$view = F2(
	function (branchToHtmlFn, tree) {
		var toHtmlTree = F2(
			function (branchDiv, children) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('branch-outer')
						]),
					A2($elm$core$List$cons, branchDiv, children));
			});
		return A3($zwilias$elm_rosetree$Tree$restructure, branchToHtmlFn, toHtmlTree, tree);
	});
var $author$project$Views$BranchPicker$view = F3(
	function (model, org, maybeUser) {
		var selectedBranchName = $author$project$Model$Branch$getName(model.fR);
		var projectSettingsRoute = $author$project$Model$Route$projectSettingsBranches(
			{
				fO: $elm$core$Maybe$Just(
					$author$project$Model$Branch$getName(model.fR)),
				ix: model.ix,
				vT: model.vT
			});
		var hasMultipleBranches = $author$project$Model$BranchTree$count(model.jA) > 1;
		var ancestorNames = A2(
			$elm$core$List$map,
			$author$project$Model$Branch$getName,
			A2($author$project$Model$BranchTree$branchAncestors, model.fR, model.jA));
		var branchNamesList = A2(
			$elm$core$List$append,
			ancestorNames,
			_List_fromArray(
				[selectedBranchName]));
		var branchNames = A2($elm$core$String$join, ' / ', branchNamesList);
		var viewbranchNames = A2(
			$elm$core$List$intersperse,
			A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('divider')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('/')
					])),
			A2(
				$elm$core$List$map,
				function (b) {
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('branch-name')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(b)
							]));
				},
				branchNamesList));
		return A2(
			$author$project$Misc$displayIf,
			hasMultipleBranches,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('branch-menu-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('branch-menu-title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Branch')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('dropdown'),
								$elm$html$Html$Events$onClick(
								$author$project$Views$BranchPicker$ToggleMenu(model))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('dropdown-toggle branch'),
										$elm$html$Html$Attributes$id($author$project$Views$BranchPicker$dropdownToggleId),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('active', model.Du)
											])),
										$elm$html$Html$Attributes$title(branchNames)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('branch-list')
											]),
										viewbranchNames),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('toggle-icon')
											]),
										_List_fromArray(
											[
												$author$project$Views$Icon$view(
												$author$project$Views$Icon$icon(13))
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('dropdown-menu'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('hidden', !model.Du)
											]))
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Model$BranchTree$view,
										A2($author$project$Views$BranchPicker$toHtml, selectedBranchName, model),
										model.jA)
									]))
							])),
						A2(
						$author$project$Misc$displayIf,
						A2($author$project$Model$Permissions$canEditProjects, org.AC, maybeUser),
						A3(
							$author$project$Views$Link$link,
							projectSettingsRoute,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('secondary-button small')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Manage')
								])))
					])));
	});
var $author$project$Model$Route$emptyProjectImpactReportParams = {uJ: $elm$core$Maybe$Nothing, uK: $elm$core$Maybe$Nothing, uL: $elm$core$Maybe$Nothing, uN: $elm$core$Maybe$Nothing, uS: $elm$core$Maybe$Nothing, uT: $elm$core$Maybe$Nothing, uU: $elm$core$Maybe$Nothing, uW: $elm$core$Maybe$Nothing};
var $ryan_haskell$date_format$DateFormat$DayOfMonthNumber = {$: 5};
var $ryan_haskell$date_format$DateFormat$dayOfMonthNumber = $ryan_haskell$date_format$DateFormat$DayOfMonthNumber;
var $author$project$Model$Commit$getCommitDateReadable = F2(
	function (localTimezone, _v0) {
		var commit = _v0;
		return A2(
			$elm$core$Maybe$withDefault,
			'Unknown Date',
			A2(
				$elm$core$Maybe$map,
				A2(
					$ryan_haskell$date_format$DateFormat$format,
					_List_fromArray(
						[
							$ryan_haskell$date_format$DateFormat$monthNameAbbreviated,
							$ryan_haskell$date_format$DateFormat$text(' '),
							$ryan_haskell$date_format$DateFormat$dayOfMonthNumber,
							$ryan_haskell$date_format$DateFormat$text(', '),
							$ryan_haskell$date_format$DateFormat$yearNumber
						]),
					localTimezone),
				commit.ak));
	});
var $author$project$Model$Commit$getMessage = function (_v0) {
	var commit = _v0;
	return commit.Eh;
};
var $author$project$Model$Commit$getParentCommitID = function (_v0) {
	var commit = _v0;
	return commit.zD;
};
var $author$project$Views$CommitStatusBar$viewLatestCommit = function (_v0) {
	var session = _v0.l;
	var currentCommit = _v0.f0;
	var organization = _v0.c3;
	var projectName = _v0.vT;
	var showTooltip = _v0.F8;
	var commitDate = A2(
		$author$project$Model$Commit$getCommitDateReadable,
		$author$project$Model$Session$getLocalTimezone(session),
		currentCommit);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('commit-information')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('commit-bar')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Latest Commit')
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('release-date')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(commitDate)
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('release-message')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Model$Commit$getMessage(currentCommit))
							])),
						A2(
						$author$project$Misc$displayIf,
						$author$project$Model$Permissions$orgCanAccessImpactReport(organization),
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button-with-dismissable-tooltip')
								]),
							_List_fromArray(
								[
									function () {
									var _v1 = $author$project$Model$Commit$getParentCommitID(currentCommit);
									if (!_v1.$) {
										var pc = _v1.a;
										return A3(
											$author$project$Views$Link$link,
											$author$project$Model$Route$projectImpactReport(
												{
													ix: organization.AC,
													E5: _Utils_update(
														$author$project$Model$Route$emptyProjectImpactReportParams,
														{
															uL: $elm$core$Maybe$Just(
																$author$project$Model$Commit$getCommitID(currentCommit)),
															uU: $elm$core$Maybe$Just(pc)
														}),
													vT: projectName
												}),
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-button'),
													$elm$html$Html$Attributes$target('_blank')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('View Impact Report')
												]));
									} else {
										return $elm$html$Html$text('');
									}
								}(),
									A2(
									$author$project$Misc$displayIf,
									showTooltip,
									A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('button-tooltip bottom-edge')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$h4,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Here\'s your Impact Report')
													])),
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('The impact report for the latest commit is available here and on the History tab.')
													])),
												A2(
												$elm$html$Html$label,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$input,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$type_('checkbox')
															]),
														_List_Nil),
														$author$project$Views$Icon$view(
														$author$project$Views$Icon$icon(19))
													]))
											])))
								])))
					]))
			]));
};
var $author$project$Pages$ProjectConfigAdvanced$view = F2(
	function (model, session) {
		var isSuperUserWithFeaturesVisible = $author$project$Model$Session$isSuperUserWithFeaturesVisible(session);
		var isLatestCommit = $author$project$Views$BranchPicker$commitIsLatest(
			{f0: model.f0, zf: model.fJ, kq: false});
		var isDistribtionOnly = $author$project$Model$Project$getIsDistributionOnly(model.c5);
		var branchPicker = A2(
			$author$project$Misc$displayMaybe,
			function (branchModel) {
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$ProjectConfigAdvanced$BranchPickerViewMsg,
					A4(
						$elm$html$Html$Lazy$lazy3,
						$author$project$Views$BranchPicker$view,
						branchModel,
						model.c3,
						$author$project$Model$Session$getUser(session)));
			},
			model.fJ);
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('project-configuration')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('branch-ui')
						]),
					_List_fromArray(
						[branchPicker])),
					function () {
					if (isDistribtionOnly) {
						return $author$project$Pages$ProjectConfigAdvanced$distribtionOnlyView(model);
					} else {
						var viewTimestamp = $elm$html$Html$text(
							'Platform Timestamp: ' + $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(model.pq));
						var viewAvailablePlatform = function (platform) {
							var canViewPlatform = isSuperUserWithFeaturesVisible || $author$project$Model$Platform$isAllowedForNonSuperUsers(platform);
							return canViewPlatform ? $elm$core$Maybe$Just(
								A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Model$Platform$displayName(platform) + (': ' + $author$project$Model$Platform$id(platform)))
										]))) : $elm$core$Maybe$Nothing;
						};
						var viewAvailablePlatforms = A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('available-platforms')
								]),
							A2(
								$elm$core$List$filterMap,
								viewAvailablePlatform,
								$elm$core$Dict$values(
									$author$project$Model$Platform$userVisiblePlatforms(model.n4))));
						var isSaveDisabled = _Utils_eq(model.iA, $krisajenkins$remotedata$RemoteData$Loading) || _Utils_eq(
							$author$project$Pages$ProjectConfigAdvanced$getPushable(model),
							$elm$core$Maybe$Nothing);
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('columns')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('column narrow')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Misc$displayIf,
											isLatestCommit,
											$author$project$Views$CommitStatusBar$viewLatestCommit(
												{
													f0: model.f0,
													c3: model.c3,
													vT: $author$project$Model$Project$getName(model.c5),
													l: session,
													F8: false
												})),
											viewTimestamp,
											viewAvailablePlatforms
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('column')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('presearch'),
													$elm$html$Html$Attributes$class('flex-fill')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('import-sections')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('import-section file-contents')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$textarea,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('import-textarea'),
																			$elm$html$Html$Attributes$value(model.k9),
																			$elm$html$Html$Events$onInput($author$project$Pages$ProjectConfigAdvanced$UpdateCommentText),
																			$elm$html$Html$Attributes$placeholder('Comment'),
																			$elm$html$Html$Attributes$spellcheck(false),
																			$elm$html$Html$Attributes$rows(1),
																			$elm$html$Html$Attributes$cols(100)
																		]),
																	_List_Nil),
																	A2(
																	$elm$html$Html$textarea,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('import-textarea'),
																			$elm$html$Html$Attributes$value(model.iL),
																			$elm$html$Html$Events$onInput($author$project$Pages$ProjectConfigAdvanced$UpdateTimestampText),
																			$elm$html$Html$Attributes$placeholder(
																			$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(model.pq)),
																			$elm$html$Html$Attributes$spellcheck(false),
																			$elm$html$Html$Attributes$rows(1),
																			$elm$html$Html$Attributes$cols(100)
																		]),
																	_List_Nil),
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('section-cta')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$button,
																			_List_fromArray(
																				[
																					$elm$html$Html$Attributes$type_('submit'),
																					$elm$html$Html$Events$onClick($author$project$Pages$ProjectConfigAdvanced$Validate),
																					$elm$html$Html$Attributes$class('primary-button')
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text('Validate')
																				]))
																		])),
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('section-cta')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$button,
																			_List_fromArray(
																				[
																					$elm$html$Html$Attributes$type_('submit'),
																					$elm$html$Html$Events$onClick($author$project$Pages$ProjectConfigAdvanced$SaveCommit),
																					$elm$html$Html$Attributes$disabled(isSaveDisabled),
																					$elm$html$Html$Attributes$class('primary-button'),
																					$elm$html$Html$Attributes$classList(
																					_List_fromArray(
																						[
																							_Utils_Tuple2('disabled', isSaveDisabled)
																						]))
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text('Save')
																				]))
																		])),
																	function () {
																	var _v0 = model.iA;
																	switch (_v0.$) {
																		case 0:
																			return $elm$html$Html$text('');
																		case 1:
																			return $author$project$Views$Loading$dots;
																		case 2:
																			var err = _v0.a;
																			return A2(
																				$elm$html$Html$div,
																				_List_fromArray(
																					[
																						$elm$html$Html$Attributes$class('build-expression-error')
																					]),
																				_List_fromArray(
																					[
																						$elm$html$Html$text(err)
																					]));
																		default:
																			return A2(
																				$elm$html$Html$div,
																				_List_fromArray(
																					[
																						$elm$html$Html$Attributes$class('build-expression-success')
																					]),
																				_List_fromArray(
																					[
																						$elm$html$Html$text('Success!')
																					]));
																	}
																}(),
																	function () {
																	var _v1 = model.k0;
																	switch (_v1.$) {
																		case 0:
																			return A2(
																				$elm$html$Html$div,
																				_List_Nil,
																				_List_fromArray(
																					[
																						$elm$html$Html$text('')
																					]));
																		case 1:
																			var err = _v1.a;
																			return A2(
																				$elm$html$Html$div,
																				_List_fromArray(
																					[
																						$elm$html$Html$Attributes$class('build-expression-error')
																					]),
																				_List_fromArray(
																					[
																						$elm$html$Html$text(
																						$author$project$Pages$ProjectConfigAdvanced$prettifyError(err))
																					]));
																		case 2:
																			var warn = _v1.a;
																			return A2(
																				$elm$html$Html$div,
																				_List_fromArray(
																					[
																						$elm$html$Html$Attributes$class('build-expression-warning')
																					]),
																				_List_fromArray(
																					[
																						$elm$html$Html$text(warn)
																					]));
																		default:
																			return A2(
																				$elm$html$Html$div,
																				_List_Nil,
																				_List_fromArray(
																					[
																						$elm$html$Html$text('')
																					]));
																	}
																}(),
																	A2(
																	$elm$html$Html$textarea,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('import-textarea'),
																			$elm$html$Html$Attributes$value(model.iR),
																			$elm$html$Html$Events$onInput($author$project$Pages$ProjectConfigAdvanced$UpdateBuildExprText),
																			$elm$html$Html$Attributes$spellcheck(false),
																			$elm$html$Html$Attributes$rows(100),
																			$elm$html$Html$Attributes$cols(100)
																		]),
																	_List_Nil)
																]))
														]))
												]))
										]))
								]));
					}
				}()
				]));
	});
var $author$project$Pages$ProjectConfig$AttemptSaveCommit = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$ProjectConfig$CommentChanged = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$ProjectConfig$CopyClipboard = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$ProjectConfig$DismissWelcomeModal = {$: 12};
var $author$project$Model$ProjectEditableStatus$EditableIfLatestCommit = 1;
var $author$project$Pages$ProjectConfigHtml$Header = 0;
var $author$project$Pages$ProjectConfigHtml$NoPackagesYet = 1;
var $author$project$Model$ProjectEditableStatus$NotEditable = 2;
var $author$project$Pages$ProjectConfig$RequestImpactReport = {$: 31};
var $author$project$Pages$ProjectConfig$Reset = {$: 32};
var $author$project$Pages$ProjectConfig$SetAllPackagesToAuto = {$: 36};
var $author$project$Pages$ProjectConfig$SetAllPackagesToPinned = function (a) {
	return {$: 37, a: a};
};
var $author$project$Pages$ProjectConfig$SetMarkersFromKind = function (a) {
	return {$: 39, a: a};
};
var $author$project$Pages$ProjectConfig$SetSolverVersion = function (a) {
	return {$: 40, a: a};
};
var $author$project$Pages$ProjectConfig$ShowUpdateForkModal = {$: 41};
var $author$project$Pages$ProjectConfig$SolveErrorNoticeMsg = function (a) {
	return {$: 43, a: a};
};
var $author$project$Model$BuildPlanner$BuildExpr$MarkerKind$allKinds = _List_fromArray(
	[0, 1, 2, 3, 4]);
var $krisajenkins$remotedata$RemoteData$andThen = F2(
	function (f, data) {
		switch (data.$) {
			case 3:
				var a = data.a;
				return f(a);
			case 2:
				var e = data.a;
				return $krisajenkins$remotedata$RemoteData$Failure(e);
			case 0:
				return $krisajenkins$remotedata$RemoteData$NotAsked;
			default:
				return $krisajenkins$remotedata$RemoteData$Loading;
		}
	});
var $author$project$Model$BuildExprEditorUtils$areAllAuto = function (editor) {
	var bundlesAndPackages = A2(
		$elm$core$Dict$union,
		$author$project$Model$BuildPlanner$SolveLegacyEditor$getBundles(editor),
		$author$project$Model$BuildPlanner$SolveLegacyEditor$getPackages(editor));
	return !A2($elm_community$dict_extra$Dict$Extra$any, $author$project$Model$BuildExprEditorUtils$canSetToAuto, bundlesAndPackages);
};
var $author$project$Model$BuildExprEditorUtils$areAllExact = function (editor) {
	var bundlesAndPackages = A2(
		$elm$core$Dict$union,
		$author$project$Model$BuildPlanner$SolveLegacyEditor$getBundles(editor),
		$author$project$Model$BuildPlanner$SolveLegacyEditor$getPackages(editor));
	return !A2($elm_community$dict_extra$Dict$Extra$any, $author$project$Model$BuildExprEditorUtils$canSetToExact, bundlesAndPackages);
};
var $author$project$Model$Permissions$orgCanSeeCubeCVEData = $author$project$Model$Organization$addOnEnabled('cube_cve_data');
var $author$project$Model$BuildPlanner$SolveLegacyEditor$canSeeCubeCVEs = function (model) {
	return $author$project$Model$Permissions$orgCanSeeCubeCVEData(model.c3) && (!A2(
		$elm$core$Dict$member,
		$author$project$Model$Language$toString(0),
		$author$project$Model$BuildPlanner$SolveLegacyEditor$getLanguages(model.qR)));
};
var $author$project$Views$Timestamp$isPlatformTimestamp = function (_v0) {
	var platformTimestamp = _v0.pq;
	var editor = _v0.qR;
	var currentCommit = _v0.f0;
	var commitTimestamp = $author$project$Model$Commit$getAtTime(currentCommit);
	var currentTimestamp = A2(
		$elm$core$Maybe$withDefault,
		commitTimestamp,
		$author$project$Model$BuildPlanner$SolveLegacyEditor$getTimestamp(editor));
	return _Utils_eq(currentTimestamp, platformTimestamp);
};
var $author$project$Views$Timestamp$checkForUpdatesButton = F2(
	function (parentModel, viewingLatestCommit) {
		return (viewingLatestCommit && (!$author$project$Views$Timestamp$isPlatformTimestamp(parentModel))) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('check-for-updates-button new-box')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Update Project'),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('more-info-tooltip')
								]),
							_List_fromArray(
								[
									$author$project$Views$Icon$view(
									$author$project$Views$Icon$icon(52)),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('content')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Updating your project will bring your package versions to the latest versions available on the ActiveState platform, within your defined constraints.')
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('primary-button '),
							$elm$html$Html$Events$onClick(
							$author$project$Views$Timestamp$SetNextCommitTimestamp(parentModel.pq))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Check For Updates')
						]))
				])) : $elm$html$Html$text('');
	});
var $author$project$Url$Extra$contactUs = function (queryParams) {
	return A3(
		$author$project$Url$Extra$createUrl,
		$author$project$Url$Extra$corporateSiteDomain,
		_List_fromArray(
			['company', 'contact-us']),
		queryParams);
};
var $author$project$Pages$ProjectConfigHtml$cvesEnabledAndVisible = F2(
	function (organization, session) {
		return $author$project$Model$Permissions$orgCanSeeCVEData(organization) && A2(
			$author$project$Model$Permissions$canViewOrgPrivateInfo,
			organization.AC,
			$author$project$Model$Session$getUser(session));
	});
var $author$project$Pages$ProjectConfigHtml$disabledEditButton = function (label) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('button-with-tooltip')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('primary-button disabled-button small disabled-edit-button')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(label)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('tooltip')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Switch to the latest commit to make changes.')
							]))
					]))
			]));
};
var $author$project$Pages$ProjectConfigHtml$distribtionOnlyView = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('legacy-overview-tab-content')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('coming-soon-title')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Distribution Only')
									])),
								A2(
								$elm$html$Html$h2,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('This build cannot be configured.')
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('This project version is not supported for customization from the ActiveState Platform.')
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Any services or builds included in this project version, are not covered under our standard Service Level Agreement (SLA), unless agreed to by ActiveState in a separate and custom agreement. Any deviations from our standard SLA must be documented in writing and mutually agreed upon by all involved parties. This provision shall supersede any conflicting terms or conditions found in our standard SLA.')
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('To access the last available offline build, select the Download Builds tab.')
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('To create a customizable runtime with open source packages, create a new project.')
									])),
								$author$project$Views$NewProjectButton$active(model.c3.AC)
							]))
					]))
			]));
};
var $author$project$Pages$ProjectConfigHtml$focusTooltipId = 'focus-tooltip';
var $krisajenkins$remotedata$RemoteData$andMap = F2(
	function (wrappedValue, wrappedFunction) {
		var _v0 = _Utils_Tuple2(wrappedFunction, wrappedValue);
		_v0$2:
		while (true) {
			_v0$3:
			while (true) {
				_v0$4:
				while (true) {
					_v0$5:
					while (true) {
						switch (_v0.a.$) {
							case 3:
								switch (_v0.b.$) {
									case 3:
										var f = _v0.a.a;
										var value = _v0.b.a;
										return $krisajenkins$remotedata$RemoteData$Success(
											f(value));
									case 2:
										break _v0$2;
									case 1:
										break _v0$4;
									default:
										var _v4 = _v0.b;
										return $krisajenkins$remotedata$RemoteData$NotAsked;
								}
							case 2:
								var error = _v0.a.a;
								return $krisajenkins$remotedata$RemoteData$Failure(error);
							case 1:
								switch (_v0.b.$) {
									case 2:
										break _v0$2;
									case 1:
										break _v0$3;
									case 0:
										break _v0$3;
									default:
										break _v0$3;
								}
							default:
								switch (_v0.b.$) {
									case 2:
										break _v0$2;
									case 1:
										break _v0$4;
									case 0:
										break _v0$5;
									default:
										break _v0$5;
								}
						}
					}
					var _v3 = _v0.a;
					return $krisajenkins$remotedata$RemoteData$NotAsked;
				}
				var _v2 = _v0.b;
				return $krisajenkins$remotedata$RemoteData$Loading;
			}
			var _v1 = _v0.a;
			return $krisajenkins$remotedata$RemoteData$Loading;
		}
		var error = _v0.b.a;
		return $krisajenkins$remotedata$RemoteData$Failure(error);
	});
var $krisajenkins$remotedata$RemoteData$map2 = F3(
	function (f, a, b) {
		return A2(
			$krisajenkins$remotedata$RemoteData$andMap,
			b,
			A2($krisajenkins$remotedata$RemoteData$map, f, a));
	});
var $krisajenkins$remotedata$RemoteData$fromList = A2(
	$elm$core$List$foldr,
	$krisajenkins$remotedata$RemoteData$map2($elm$core$List$cons),
	$krisajenkins$remotedata$RemoteData$Success(_List_Nil));
var $author$project$Views$ImpactReportButton$generateOrView = function (model) {
	return A2(
		$author$project$Misc$displayIf,
		$author$project$Model$Permissions$orgCanAccessImpactReport(model.c3),
		function () {
			var _v0 = model.Eq;
			switch (_v0.$) {
				case 0:
					return A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('secondary-button'),
								$elm$html$Html$Events$onClick(model.EK),
								$elm$html$Html$Attributes$disabled(model.x3)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Generate Impact Report')
							]));
				case 2:
					return A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('secondary-button'),
								$elm$html$Html$Events$onClick(model.EK),
								$elm$html$Html$Attributes$disabled(model.x3)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Generate Impact Report')
							]));
				case 1:
					return A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('secondary-button'),
								$elm$html$Html$Attributes$disabled(true)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Generating...')
							]));
				default:
					var tag = _v0.a;
					return A3(
						$author$project$Views$Link$link,
						$author$project$Model$Route$projectImpactReport(
							{
								ix: $author$project$Model$Organization$getUrlName(model.c3),
								E5: _Utils_update(
									$author$project$Model$Route$emptyProjectImpactReportParams,
									{
										uN: $elm$core$Maybe$Just(
											$author$project$Model$Tag$label(tag)),
										uU: $elm$core$Maybe$Just(
											$author$project$Model$Commit$getCommitID(model.EF))
									}),
								vT: $author$project$Model$Project$getName(model.c5)
							}),
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('secondary-button'),
								$elm$html$Html$Attributes$target('_blank')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('View Impact Report')
							]));
			}
		}());
};
var $author$project$Model$BuildDataSource$getComponents = function (_v0) {
	var cached = _v0.df;
	return cached.hr;
};
var $author$project$Model$BuildDataSource$getComponentsByDirectNodeId = function (_v0) {
	var cached = _v0.df;
	return cached.tk;
};
var $author$project$Model$BuildDataSource$getVersionForArbitraryPlatform = function (component) {
	return $mgold$elm_nonempty_list$List$Nonempty$head(component.e$);
};
var $author$project$Model$NormsAndVulns$getVulnerabilities = F2(
	function (_v0, vulnKey) {
		var fields = _v0;
		var _v1 = A2($author$project$Model$NormsAndVulns$getRemoteVulnsInternal, vulnKey, fields);
		if (_v1.$ === 1) {
			return $krisajenkins$remotedata$RemoteData$NotAsked;
		} else {
			switch (_v1.a.$) {
				case 0:
					var _v2 = _v1.a;
					return $krisajenkins$remotedata$RemoteData$Loading;
				case 1:
					var err = _v1.a.a;
					return $krisajenkins$remotedata$RemoteData$Failure(err);
				default:
					var vulnerabilities = _v1.a.a;
					return $krisajenkins$remotedata$RemoteData$Success(vulnerabilities);
			}
		}
	});
var $author$project$Pages$ProjectConfig$hasChangesToCommit = function (model) {
	return ($author$project$Pages$ProjectConfig$getChangeCount(model) > 0) || function () {
		var _v0 = model.iK;
		if (!_v0.$) {
			return false;
		} else {
			if (_v0.a === 3) {
				var _v1 = _v0.a;
				return true;
			} else {
				return false;
			}
		}
	}();
};
var $author$project$Views$ImportPackagesModal$importButtonText = function (_v0) {
	return 'Import from File';
};
var $author$project$Views$IndemnificationPopup$indemnificationPopup = function (isIndemnified) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('more-info-tooltip')
			]),
		_List_fromArray(
			[
				$author$project$Views$Icon$view(
				$author$project$Views$Icon$icon(52)),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('content indemnification-explanation'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('indemnified', isIndemnified)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('main-explanation')
							]),
						_List_fromArray(
							[
								isIndemnified ? A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Views$Icon$view(
										$author$project$Views$Icon$icon(38)),
										$elm$html$Html$text('Successful builds containing only indemnified packages are '),
										A2(
										$elm$html$Html$strong,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('indemnification-status-label')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('COVERED')
											])),
										$elm$html$Html$text(' by a limited indemnity from ActiveState pursuant to the terms of the ACTIVESTATE® Platfom Enterprise Tier Addendum.')
									])) : A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Views$Icon$view(
										$author$project$Views$Icon$icon(39)),
										$elm$html$Html$text('Builds containing any packages that are not indemnified are '),
										A2(
										$elm$html$Html$strong,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('indemnification-status-label')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('NOT COVERED')
											])),
										$elm$html$Html$text(' by a limited indemnity from ActiveState pursuant to the terms of the ACTIVESTATE® Platfom Enterprise Tier Addendum.')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('legend')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Look for these icons next to your packages...')
									])),
								A2(
								$elm$html$Html$ul,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('legend-items')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Views$Icon$view(
												$author$project$Views$Icon$icon(38)),
												$elm$html$Html$text('Indemnified')
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Views$Icon$view(
												$author$project$Views$Icon$icon(39)),
												$elm$html$Html$text('Not indemnified')
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Model$BuildDataSource$isFullyIndemnified = function (_v0) {
	var cached = _v0.df;
	return cached.i7;
};
var $author$project$Pages$ProjectConfigHtml$indemnificationStatus = F2(
	function (buildData, isManagedProject) {
		var _v0 = function () {
			switch (buildData.$) {
				case 0:
					return _Utils_Tuple3(false, false, 'Loading indemnification status.');
				case 1:
					return _Utils_Tuple3(false, false, 'Loading indemnification status.');
				case 3:
					var loadedSolution = buildData.a;
					return ($author$project$Model$BuildDataSource$isFullyIndemnified(loadedSolution) || isManagedProject) ? _Utils_Tuple3(true, true, 'All packages in this runtime are indemnified.') : _Utils_Tuple3(true, false, 'Not all packages in this runtime are indemnified.');
				default:
					return _Utils_Tuple3(true, false, 'There was an error requesting the indemnification status.');
			}
		}();
		var loaded = _v0.a;
		var indemnified = _v0.b;
		var statusText = _v0.c;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('recipe-indemnification-indicator')
				]),
			_List_fromArray(
				[
					loaded ? (indemnified ? $author$project$Views$Icon$view(
					$author$project$Views$Icon$icon(38)) : $author$project$Views$Icon$view(
					$author$project$Views$Icon$icon(39))) : $author$project$Views$Loading$dots,
					$elm$html$Html$text(statusText),
					$author$project$Views$IndemnificationPopup$indemnificationPopup(indemnified)
				]));
	});
var $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$isAuto = function (constraint) {
	if (!constraint.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pages$ProjectConfigHtml$isIndemnificationEnabled = function (model) {
	return $author$project$Model$Permissions$orgCanSeeIndemnificationData(model.c3);
};
var $author$project$Model$BuildDataSource$isMissingSourceComponent = F2(
	function (_v0, component) {
		var cached = _v0.df;
		var isDirectMissingSourceNode = function (relationship) {
			return (!$author$project$Model$BuildPlanner$BuildRelationship$type_(relationship)) && A2(
				$elm$core$Set$member,
				$danyx23$elm_uuid$Uuid$toString(
					$author$project$Model$BuildPlanner$BuildRelationship$nodeId(relationship)),
				cached.rA);
		};
		return A2(
			$elm$core$List$any,
			isDirectMissingSourceNode,
			$author$project$Model$BuildPlanner$Component$relatesTo(component));
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$isPrePanorama = function (editor) {
	var _v0 = $author$project$Model$BuildPlanner$BuildExprEditor$Simple$getMarkers(editor);
	switch (_v0.$) {
		case 0:
			return true;
		case 1:
			return true;
		case 2:
			return true;
		case 3:
			return true;
		case 6:
			return true;
		default:
			return false;
	}
};
var $author$project$Model$Permissions$orgCanSeeLicenseData = $author$project$Model$Organization$addOnEnabled('license');
var $author$project$Pages$ProjectConfigHtml$licensesEnabledAndVisible = F2(
	function (organization, session) {
		return $author$project$Model$Permissions$orgCanSeeLicenseData(organization) && A2(
			$author$project$Model$Permissions$canViewOrgPrivateInfo,
			organization.AC,
			$author$project$Model$Session$getUser(session));
	});
var $krisajenkins$remotedata$RemoteData$mapError = F2(
	function (f, data) {
		switch (data.$) {
			case 3:
				var x = data.a;
				return $krisajenkins$remotedata$RemoteData$Success(x);
			case 2:
				var e = data.a;
				return $krisajenkins$remotedata$RemoteData$Failure(
					f(e));
			case 1:
				return $krisajenkins$remotedata$RemoteData$Loading;
			default:
				return $krisajenkins$remotedata$RemoteData$NotAsked;
		}
	});
var $author$project$Model$Permissions$orgCanManageTimestamps = $author$project$Model$Organization$addOnEnabled('timestamp_management');
var $author$project$Model$Permissions$orgCanSetAllToAutoOrPinned = $author$project$Model$Organization$addOnEnabled('set_all_auto_or_all_pinned');
var $author$project$Model$Permissions$orgSupportEnabled = $author$project$Model$Organization$addOnEnabled('support');
var $author$project$Pages$ProjectConfigHtml$packageLimitKindToClass = function (kind) {
	if (!kind) {
		return 'at-limit';
	} else {
		return 'over-limit';
	}
};
var $author$project$Pages$ProjectConfigHtml$packageLimitView = F3(
	function (_v0, kind, limit) {
		var heading = function () {
			if (!kind) {
				return 'You\'ve reached the limit!';
			} else {
				return 'You\'re over the limit!';
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('package-limit'),
					$elm$html$Html$Attributes$class(
					$author$project$Pages$ProjectConfigHtml$packageLimitKindToClass(kind))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$b,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(heading)
								])),
							A3(
							$author$project$Views$Link$external,
							$author$project$Url$Extra$pricing(_List_Nil),
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Upgrade')
								])),
							$elm$html$Html$text(
							'to import more than ' + ($elm$core$String$fromInt(limit) + ' packages.'))
						]))
				]));
	});
var $author$project$Views$BranchPicker$selectedBranchIsOutdated = function (model) {
	return A2($author$project$Model$BranchTree$parentHasChange, model.fR, model.jA);
};
var $author$project$Pages$ProjectConfigHtml$supportedSolverVersions = _List_fromArray(
	[
		$elm$core$Maybe$Nothing,
		$elm$core$Maybe$Just(0),
		$elm$core$Maybe$Just(1),
		$elm$core$Maybe$Just(2),
		$elm$core$Maybe$Just(3),
		$elm$core$Maybe$Just(4)
	]);
var $author$project$Model$BuildPlanner$BuildExpr$MarkerKind$toString = function (kind) {
	switch (kind) {
		case 0:
			return 'camel';
		case 1:
			return 'state tool artifacts (V1)';
		case 2:
			return 'state tool artifacts';
		case 3:
			return 'state tool + community artifacts';
		default:
			return 'state tool + wheel artifacts';
	}
};
var $author$project$Views$AddPackagesModal$OnClose = function (a) {
	return {$: 17, a: a};
};
var $author$project$Views$AddPackagesModal$Bundles = 1;
var $author$project$Views$AddPackagesModal$ToggleTab = function (a) {
	return {$: 12, a: a};
};
var $author$project$Views$AddPackagesModal$changeIndicator = function (itemStatus) {
	switch (itemStatus.$) {
		case 0:
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('change-label added')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Added')
					]));
		case 2:
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('change-label removed')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Removed')
					]));
		case 1:
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('change-label changed')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Updated')
					]));
		default:
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('change-label included')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Included')
					]));
	}
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$getBundleItem = A2(
	$elm$core$Basics$composeL,
	$author$project$Model$BuildPlanner$SolveLegacyEditor$getBuildExprSolveEditor,
	A2($author$project$Model$Editor$getItemDict, $author$project$Model$BuildPlanner$SolveLegacyEditor$bundlesGetter, $author$project$Model$BuildPlanner$BuildExpr$Solve$Requirement$KeyAndConstraint));
var $author$project$Model$NormsAndVulns$getKeys = F2(
	function (normalizedKey, _v0) {
		var fields = _v0;
		return A2(
			$elm$core$List$filterMap,
			function (key) {
				if (key.b === '') {
					return $elm$core$Maybe$Nothing;
				} else {
					return $elm$core$Maybe$Just(key);
				}
			},
			$elm$core$Set$toList(
				A2(
					$elm$core$Maybe$withDefault,
					$author$project$Model$NormsAndVulns$initEntry,
					A2($elm$core$Dict$get, normalizedKey, fields.mM)).oU));
	});
var $author$project$Model$NormsAndVulns$getFirstKeyMap = F3(
	function (normalizedKey, keyToMaybe, model) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				keyToMaybe,
				A2($author$project$Model$NormsAndVulns$getKeys, normalizedKey, model)));
	});
var $author$project$Views$AddPackagesModal$getBundleItemStatus = F3(
	function (model, parentModel, key) {
		return A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.L;
			},
			A3(
				$author$project$Model$NormsAndVulns$getFirstKeyMap,
				key,
				A2($elm_community$basics_extra$Basics$Extra$flip, $author$project$Model$BuildPlanner$SolveLegacyEditor$getBundleItem, model.qR),
				parentModel.rF));
	});
var $author$project$Views$AddPackagesModal$ignoreStatusUpdatedFrom = function (status) {
	if (status.$ === 1) {
		return $author$project$Model$Editor$Unchanged;
	} else {
		return status;
	}
};
var $author$project$Views$AddPackagesModal$statusClassName = function (maybeStatus) {
	if (!maybeStatus.$) {
		var status = maybeStatus.a;
		switch (status.$) {
			case 0:
				return 'package-requested';
			case 2:
				return 'package-removed';
			case 1:
				return 'package-changed';
			default:
				return 'package-included';
		}
	} else {
		return '';
	}
};
var $author$project$Views$AddPackagesModal$viewDescription = function (description) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('package-description package-detail-section')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h4,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Description')
					])),
				($elm$core$String$length(description) > 10) ? A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(description)
					])) : A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('not-available')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Not provided')
					]))
			]));
};
var $author$project$Views$AddPackagesModal$ToggleModules = function (a) {
	return {$: 7, a: a};
};
var $author$project$Views$AddPackagesModal$viewModules = F2(
	function (model, _v0) {
		var key = _v0.Y;
		var modules = _v0.o2;
		var matchingModules = _v0.o1;
		var toggleLabel = _v0.wI;
		var modulesVisible = A2($elm$core$Set$member, key, model.pQ);
		var modulesMatchingSearch = A2($elm$core$Maybe$withDefault, _List_Nil, matchingModules);
		var moduleCount = $elm$core$List$length(modules);
		var maxMatchingDisplayCount = 5;
		var matchCount = $elm$core$List$length(modulesMatchingSearch);
		var allMatching = _Utils_eq(moduleCount, matchCount);
		var modulesHeader = function () {
			var notExpandable = allMatching && (_Utils_cmp(moduleCount, maxMatchingDisplayCount) < 1);
			var matchingText = $elm$html$Html$text(
				_Utils_eq(matchingModules, $elm$core$Maybe$Nothing) ? A3($elm_community$string_extra$String$Extra$pluralize, 'module', 'modules', moduleCount) : ($elm$core$String$fromInt(matchCount) + (' of ' + ($elm$core$String$fromInt(moduleCount) + ' match your search'))));
			var headerAttrs = notExpandable ? _List_fromArray(
				[
					$elm$html$Html$Attributes$class('non-toggle-header')
				]) : _List_fromArray(
				[
					$elm$html$Html$Attributes$class('modules-toggle'),
					$elm$html$Html$Events$onClick(
					$author$project$Views$AddPackagesModal$ToggleModules(key)),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('expanded', modulesVisible)
						]))
				]);
			return A2(
				$elm$html$Html$span,
				headerAttrs,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(toggleLabel + ' ')
							])),
						matchingText
					]));
		}();
		var modulesList = function () {
			var viewModule = function (moduleName) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('module-name'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'module-matched',
									(!allMatching) && A2($elm$core$List$member, moduleName, modulesMatchingSearch))
								]))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(moduleName)
						]));
			};
			var modulesHtml = modulesVisible ? A2($elm$core$List$map, viewModule, modules) : ((_Utils_cmp(
				$elm$core$List$length(modulesMatchingSearch),
				maxMatchingDisplayCount) < 1) ? A2($elm$core$List$map, viewModule, modulesMatchingSearch) : _List_Nil);
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('module-list'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('expanded', modulesVisible)
							]))
					]),
				modulesHtml);
		}();
		return A2(
			$author$project$Misc$displayIf,
			!$elm$core$List$isEmpty(modules),
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modules-wrapper package-detail-section')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Modules')
							])),
						modulesHeader,
						modulesList
					])));
	});
var $author$project$Views$AddPackagesModal$Add = function (a) {
	return {$: 13, a: a};
};
var $author$project$Views$AddPackagesModal$Undo = function (a) {
	return {$: 14, a: a};
};
var $author$project$Views$AddPackagesModal$viewRequirementActionButton = F3(
	function (requirement, isLoadingDetails, itemStatus) {
		var cancelButton = function (status) {
			if (status.$ === 3) {
				return $elm$html$Html$text('');
			} else {
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('secondary-button small'),
							$elm$html$Html$Events$onClick(
							$author$project$Views$AddPackagesModal$Undo(requirement.Y))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Cancel')
						]));
			}
		};
		var addButton = isLoadingDetails ? $author$project$Views$Loading$dots : A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('primary-button small'),
					$elm$html$Html$Events$onClick(
					$author$project$Views$AddPackagesModal$Add(requirement))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Add')
				]));
		return A2(
			$elm$core$Maybe$withDefault,
			addButton,
			A2($elm$core$Maybe$map, cancelButton, itemStatus));
	});
var $author$project$Views$AddPackagesModal$viewBundle = F3(
	function (model, parentModel, bundle) {
		var req = $author$project$Model$BuildExprEditorUtils$fromIngredientVersion(bundle);
		var key = $author$project$Model$Ingredient$key(bundle);
		var maybeItemStatus = A2(
			$elm$core$Maybe$map,
			$author$project$Views$AddPackagesModal$ignoreStatusUpdatedFrom,
			A3($author$project$Views$AddPackagesModal$getBundleItemStatus, model, parentModel, key));
		var dependencies = A2(
			$elm$core$List$map,
			function ($) {
				return $.d;
			},
			$author$project$Model$Ingredient$filteredDependencies(bundle));
		var dependencyCount = $elm$core$String$fromInt(
			$elm$core$List$length(dependencies));
		var className = $author$project$Views$AddPackagesModal$statusClassName(maybeItemStatus);
		return _Utils_Tuple2(
			$author$project$Model$Namespace$cssString(key),
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('package-result bundle-result ' + className)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('package-result-header')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('package-name')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Model$Ingredient$name(bundle))
									])),
								A2($author$project$Misc$displayMaybe, $author$project$Views$AddPackagesModal$changeIndicator, maybeItemStatus),
								A3($author$project$Views$AddPackagesModal$viewRequirementActionButton, req, false, maybeItemStatus)
							])),
						$author$project$Views$AddPackagesModal$viewDescription(
						$author$project$Model$Ingredient$description(bundle)),
						A2(
						$author$project$Views$AddPackagesModal$viewModules,
						model,
						{Y: key, o1: $elm$core$Maybe$Nothing, o2: dependencies, wI: dependencyCount + ' Packages'})
					])));
	});
var $author$project$Views$AddPackagesModal$bundleContent = F3(
	function (model, currentLanguage, parentModel) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bundle-explanation')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Bundles contain a set of related packages for common usecases.')
					])),
				function () {
				var _v0 = parentModel.iS;
				switch (_v0.$) {
					case 1:
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('package-list-wrapper')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('loading-search')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Searching...')
										]))
								]));
					case 0:
						return $elm$html$Html$text('');
					case 2:
						return $elm$html$Html$text('');
					default:
						var bundles = _v0.a;
						var accFunc = F2(
							function (_v2, accDict) {
								var key = _v2.a;
								var ingredient = _v2.b;
								return A3(
									$elm$core$Dict$update,
									$author$project$Model$Namespace$getNamespace(key),
									function (maybeListOfIngredients) {
										if (!maybeListOfIngredients.$) {
											var t = maybeListOfIngredients.a;
											return $elm$core$Maybe$Just(
												A2($elm$core$List$cons, ingredient, t));
										} else {
											return $elm$core$Maybe$Just(
												_List_fromArray(
													[ingredient]));
										}
									},
									accDict);
							});
						var namespaceToIngredientDict = A3(
							$elm$core$List$foldl,
							accFunc,
							$elm$core$Dict$empty,
							$elm$core$Dict$toList(bundles));
						var sortedBundles = A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								$elm$core$List$sortBy($author$project$Model$Ingredient$name),
								A2(
									$elm$core$Dict$get,
									$author$project$Model$Namespace$addBundlesPrefix(
										$author$project$Model$Language$toString(currentLanguage)),
									namespaceToIngredientDict)));
						return A3(
							$elm$html$Html$Keyed$node,
							'div',
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('package-list-wrapper')
								]),
							A2(
								$elm$core$List$map,
								A2($author$project$Views$AddPackagesModal$viewBundle, model, parentModel),
								sortedBundles));
				}
			}()
			]);
	});
var $author$project$Views$AddPackagesModal$OnGotoImportPackagesModal = {$: 18};
var $author$project$Model$PackageImport$viewLanguageSupportedFileFormats = $author$project$Model$PackageImport$viewLanguageSupportedFileFormatsWith(
	$elm$html$Html$strong(_List_Nil));
var $author$project$Views$AddPackagesModal$commandLineInstructions = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('state-tool-commands side-panel')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Misc$displayMaybe,
				function (formats) {
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Need to import multiple packages?')
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								A2(
									$elm$core$List$cons,
									$elm$html$Html$text('You can import the contents of your '),
									_Utils_ap(
										$mgold$elm_nonempty_list$List$Nonempty$toList(formats),
										_List_fromArray(
											[
												$elm$html$Html$text(' with our import packages feature.')
											])))),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('import-link'),
										$elm$html$Html$Events$onClick($author$project$Views$AddPackagesModal$OnGotoImportPackagesModal)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Import Packages from File')
									]))
							]));
				},
				$author$project$Model$PackageImport$viewLanguageSupportedFileFormats(model.ip)),
				A2(
				$elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('You can also manage packages on the command line')
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Your runtime also includes a package manager. Once you\'ve installed your runtime, you can search for packages, install packages, and import packages from a file all within the CLI.')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('state-tool-resources')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('CLI Resources')
							])),
						A2(
						$elm$html$Html$ul,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										A3(
										$author$project$Views$Link$link,
										$author$project$Model$Route$StateToolCheatSheet,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$target('_blank')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cheat Sheet')
											]))
									])),
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$target('_blank'),
												$elm$html$Html$Attributes$href('https://docs.activestate.com/platform/state/')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Full documentation')
											]))
									]))
							]))
					])),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('software-licenses')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Be aware of the '),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href($author$project$Url$Extra$softwareLicenses),
								$elm$html$Html$Attributes$target('_blank')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('software licenses')
							])),
						$elm$html$Html$text(' that apply to your packages and the terms and conditions they may impose.')
					]))
			]));
};
var $elm$virtual_dom$VirtualDom$lazy2 = _VirtualDom_lazy2;
var $elm$html$Html$Lazy$lazy2 = $elm$virtual_dom$VirtualDom$lazy2;
var $mgold$elm_nonempty_list$List$Nonempty$length = function (_v0) {
	var x = _v0.a;
	var xs = _v0.b;
	return $elm$core$List$length(xs) + 1;
};
var $author$project$Views$AddPackagesModal$NextResults = {$: 15};
var $author$project$Views$AddPackagesModal$PackageSummaryDisplayMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Views$AddPackagesModal$PreviousResults = {$: 16};
var $author$project$Views$AddPackagesModal$Search = function (a) {
	return {$: 4, a: a};
};
var $author$project$Views$AddPackagesModal$SearchChanged = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$PopularPackages$getForLanguage = F2(
	function (model, language) {
		return A2(
			$elm$core$Maybe$withDefault,
			$krisajenkins$remotedata$RemoteData$NotAsked,
			A2(
				$elm$core$Dict$get,
				$author$project$Model$Language$toString(language),
				model.hy));
	});
var $author$project$Views$PackageSummaryDisplay$DisplayLicenses = 1;
var $author$project$Views$PackageSummaryDisplay$SetPackageDisplay = $elm$core$Basics$identity;
var $author$project$Views$PackageSummaryDisplay$viewButton = F2(
	function (model, _v0) {
		var label = _v0.b2;
		var featureEnabled = _v0.tP;
		var packageDisplay = _v0.jn;
		return featureEnabled ? ((!_Utils_eq(model.jn, packageDisplay)) ? A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(packageDisplay)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				])) : A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('selected')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]))) : A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('secondary-button small'),
					$elm$html$Html$Attributes$disabled(true)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Views$PackageSummaryDisplay$viewButtons = F2(
	function (flags, model) {
		return A2(
			$author$project$Misc$displayIf,
			flags.Gm,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('display-pill superuser-only')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Views$PackageSummaryDisplay$viewButton,
						model,
						{tP: flags.Ca, b2: 'Vulnerabilities (CVEs)', jn: 0}),
						A2(
						$author$project$Views$PackageSummaryDisplay$viewButton,
						model,
						{tP: flags.DX, b2: 'Licenses', jn: 1})
					])));
	});
var $author$project$Model$HasuraIngredient$allVersionsDesc = function (_v0) {
	var fields = _v0;
	return fields.qj;
};
var $author$project$Model$HasuraIngredient$checksum = function (_v0) {
	var fields = _v0;
	return fields.dE;
};
var $author$project$Model$HasuraIngredient$description = function (_v0) {
	var fields = _v0;
	return fields.bP;
};
var $author$project$Model$HasuraIngredient$features = function (_v0) {
	var fields = _v0;
	return fields.lT;
};
var $author$project$Model$HasuraIngredient$firstVersion = function (_v0) {
	var fields = _v0;
	return fields.tQ;
};
var $author$project$Views$PackageVersionSelector$getSelected = function ($) {
	return $.jw;
};
var $author$project$Model$BuildExprEditorUtils$getVersion = function (constraint) {
	if (constraint.$ === 1) {
		var version = constraint.a;
		return version;
	} else {
		return '';
	}
};
var $author$project$Model$HasuraIngredient$ingredientId = function (_v0) {
	var fields = _v0;
	return fields.uf;
};
var $author$project$Model$HasuraIngredient$isIndemnified = function (_v0) {
	var fields = _v0;
	return fields.Dm;
};
var $author$project$Model$HasuraIngredient$licenses = function (_v0) {
	var fields = _v0;
	return fields.go;
};
var $author$project$Views$AddPackagesModal$CVEsMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Views$AddPackagesModal$LicensesMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Views$NamespaceExpand$Toggle = $elm$core$Basics$identity;
var $author$project$Misc$attributeIf = F2(
	function (condition, attr) {
		return condition ? attr : $elm$html$Html$Attributes$class('');
	});
var $author$project$Views$NamespaceExpand$isExpanded = F2(
	function (key, model) {
		return A2($elm$core$Set$member, key, model.oy);
	});
var $author$project$Views$NamespaceExpand$caret = F4(
	function (model, key, _v0, suffix) {
		var showCaret = _v0.F5;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('toggle-wrapper'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('default-cursor', !showCaret)
						])),
					A2(
					$author$project$Misc$attributeIf,
					showCaret,
					$elm$html$Html$Events$onClick(key))
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Misc$displayIf,
					showCaret,
					A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('toggle-icon'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'expanded',
										A2($author$project$Views$NamespaceExpand$isExpanded, key, model))
									]))
							]),
						_List_fromArray(
							[
								$author$project$Views$Icon$view(
								$author$project$Views$Icon$icon(13))
							]))),
				suffix));
	});
var $author$project$Views$PackageSummaryDisplay$choose = F2(
	function (model, _v0) {
		var onCVEs = _v0.EH;
		var onLicenses = _v0.EM;
		var _v1 = model.jn;
		if (!_v1) {
			return onCVEs(0);
		} else {
			return onLicenses(0);
		}
	});
var $author$project$Views$NamespaceExpand$flagsInit = {F5: true};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$getPackageItem = A2(
	$elm$core$Basics$composeL,
	$author$project$Model$BuildPlanner$SolveLegacyEditor$getBuildExprSolveEditor,
	A2($author$project$Model$Editor$getItemDict, $author$project$Model$BuildPlanner$SolveLegacyEditor$packagesGetter, $author$project$Model$BuildPlanner$BuildExpr$Solve$Requirement$KeyAndConstraint));
var $author$project$Views$AddPackagesModal$getItemStatus = F3(
	function (model, parentModel, key) {
		return A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.L;
			},
			A3(
				$author$project$Model$NormsAndVulns$getFirstKeyMap,
				key,
				A2($elm_community$basics_extra$Basics$Extra$flip, $author$project$Model$BuildPlanner$SolveLegacyEditor$getPackageItem, model.qR),
				parentModel.rF));
	});
var $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$getCustom = function (constraint) {
	if (constraint.$ === 2) {
		var first = constraint.a;
		var others = constraint.b;
		return A2($elm$core$List$cons, first, others);
	} else {
		return _List_Nil;
	}
};
var $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$isCustom = A2(
	$elm$core$Basics$composeR,
	$author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$getCustom,
	$elm$core$Basics$neq(_List_Nil));
var $author$project$Views$CVEs$isExpandedDetails = $author$project$Views$NamespaceExpand$isExpanded;
var $pzp1997$assoc_list$AssocList$D = $elm$core$Basics$identity;
var $pzp1997$assoc_list$AssocList$empty = _List_Nil;
var $pzp1997$assoc_list$AssocList$get = F2(
	function (targetKey, _v0) {
		get:
		while (true) {
			var alist = _v0;
			if (!alist.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var _v2 = alist.a;
				var key = _v2.a;
				var value = _v2.b;
				var rest = alist.b;
				if (_Utils_eq(key, targetKey)) {
					return $elm$core$Maybe$Just(value);
				} else {
					var $temp$targetKey = targetKey,
						$temp$_v0 = rest;
					targetKey = $temp$targetKey;
					_v0 = $temp$_v0;
					continue get;
				}
			}
		}
	});
var $pzp1997$assoc_list$AssocList$remove = F2(
	function (targetKey, _v0) {
		var alist = _v0;
		return A2(
			$elm$core$List$filter,
			function (_v1) {
				var key = _v1.a;
				return !_Utils_eq(key, targetKey);
			},
			alist);
	});
var $pzp1997$assoc_list$AssocList$update = F3(
	function (targetKey, alter, dict) {
		var alist = dict;
		var maybeValue = A2($pzp1997$assoc_list$AssocList$get, targetKey, dict);
		if (!maybeValue.$) {
			var _v1 = alter(maybeValue);
			if (!_v1.$) {
				var alteredValue = _v1.a;
				return A2(
					$elm$core$List$map,
					function (entry) {
						var key = entry.a;
						return _Utils_eq(key, targetKey) ? _Utils_Tuple2(targetKey, alteredValue) : entry;
					},
					alist);
			} else {
				return A2($pzp1997$assoc_list$AssocList$remove, targetKey, dict);
			}
		} else {
			var _v2 = alter($elm$core$Maybe$Nothing);
			if (!_v2.$) {
				var alteredValue = _v2.a;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(targetKey, alteredValue),
					alist);
			} else {
				return dict;
			}
		}
	});
var $author$project$Misc$assocGroupBy = function (keyfn) {
	return A2(
		$elm$core$List$foldr,
		F2(
			function (x, acc) {
				return A3(
					$pzp1997$assoc_list$AssocList$update,
					keyfn(x),
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map(
							$elm$core$List$cons(x)),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$withDefault(
								_List_fromArray(
									[x])),
							$elm$core$Maybe$Just)),
					acc);
			}),
		$pzp1997$assoc_list$AssocList$empty);
};
var $pzp1997$assoc_list$AssocList$toList = function (_v0) {
	var alist = _v0;
	return alist;
};
var $author$project$Misc$groupBy = F2(
	function (keyfn, list) {
		return $pzp1997$assoc_list$AssocList$toList(
			A2($author$project$Misc$assocGroupBy, keyfn, list));
	});
var $author$project$Views$CVEs$listBySeverity = function (vulnerabilities) {
	var viewCVE = function (vuln) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('cve-item')
				]),
			_List_fromArray(
				[
					$author$project$Views$CVEs$link(vuln)
				]));
	};
	var severitySection = function (_v0) {
		var severity = _v0.a;
		var vulns = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('cve-list-section')
				]),
			_List_fromArray(
				[
					$author$project$Views$CVEs$severityDot(severity),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('cve-list')
						]),
					A2($elm$core$List$map, viewCVE, vulns))
				]));
	};
	return A2(
		$elm$core$List$map,
		severitySection,
		A2(
			$elm$core$List$sortBy,
			A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $author$project$Model$Severity$sortKey),
			A2(
				$author$project$Misc$groupBy,
				function ($) {
					return $.ck;
				},
				vulnerabilities)));
};
var $author$project$Views$AddPackagesModal$viewCVEDetails = F2(
	function (vulnerabilities, isLoadingDetails) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('cve-details package-detail-section')
				]),
			function () {
				switch (vulnerabilities.$) {
					case 3:
						var vulns = vulnerabilities.a;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Vulnerabilities (CVEs)')
									])),
								isLoadingDetails ? $author$project$Views$Loading$dots : ($elm$core$List$isEmpty(vulns) ? A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('severity-dot severity-none')
											]),
										_List_Nil),
										$elm$html$Html$text('No vulnerabilities (CVEs) detected')
									])) : A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										A3(
											$elm_community$string_extra$String$Extra$pluralize,
											'Vulnerability (CVE)',
											'Vulnerabilities (CVEs)',
											$elm$core$List$length(vulns)) + ' detected')
									]))),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('cve-categories')
									]),
								isLoadingDetails ? _List_Nil : $author$project$Views$CVEs$listBySeverity(vulns))
							]);
					case 2:
						if (!vulnerabilities.a.$) {
							var err = vulnerabilities.a.a;
							return _List_fromArray(
								[
									$elm$html$Html$text(
									'Error loading CVE data – \"' + ($author$project$Model$Message$reason(err) + '\"'))
								]);
						} else {
							var err = vulnerabilities.a;
							return _List_fromArray(
								[
									$elm$html$Html$text(
									'Error loading CVE data – \"' + ($author$project$Model$BuildPlanner$BuildPlannerError$message(err) + '\"'))
								]);
						}
					default:
						return _List_fromArray(
							[$author$project$Views$Loading$dots]);
				}
			}());
	});
var $author$project$Views$CVEs$viewForPackage = F5(
	function (flags, model, key, withCaret, cves) {
		return A2(
			$author$project$Misc$displayIf,
			flags.Ca,
			function () {
				switch (cves.$) {
					case 0:
						return $author$project$Views$Loading$boxes;
					case 1:
						return $author$project$Views$Loading$boxes;
					case 2:
						return $elm$html$Html$text('');
					default:
						var vulnerabilities = cves.a;
						return A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Misc$displayIf,
									withCaret && (!$elm$core$List$isEmpty(vulnerabilities)),
									A4($author$project$Views$NamespaceExpand$caret, model, key, $author$project$Views$NamespaceExpand$flagsInit, _List_Nil)),
									$author$project$Views$CVESummary$viewTotals(
									{
										xI: true,
										y7: $elm$core$Maybe$Just(key),
										zd: $elm$core$Maybe$Nothing,
										F2: $author$project$Model$SeverityHistogram$fromVulnerabilities(vulnerabilities)
									})
								]));
				}
			}());
	});
var $author$project$Views$Licenses$OnHover = $elm$core$Basics$identity;
var $author$project$Views$Licenses$viewForPackage = F4(
	function (flags, model, key, licenses) {
		var scaleIcon = $author$project$Views$Icon$view(
			$author$project$Views$Icon$small(
				$author$project$Views$Icon$icon(68)));
		return A2(
			$author$project$Misc$displayIf,
			flags.Gm && flags.DX,
			function () {
				switch (licenses.$) {
					case 3:
						var ls = licenses.a;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('license-summary')
								]),
							function () {
								if (!ls.b) {
									return _List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('license-not-found')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('License not found')
												]))
										]);
								} else {
									if (!ls.b.b) {
										var license = ls.a;
										return _List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[scaleIcon])),
												$elm$html$Html$text(license)
											]);
									} else {
										return _List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Events$onMouseOver(
														$elm$core$Maybe$Just(key)),
														$elm$html$Html$Events$onMouseOut($elm$core$Maybe$Nothing),
														$elm$html$Html$Attributes$class('more-info-tooltip')
													]),
												A3(
													$author$project$Misc$concatIf,
													_Utils_eq(
														model.ra,
														$elm$core$Maybe$Just(key)),
													A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('content license-tooltip')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$ul,
																_List_Nil,
																function () {
																	var viewLicense = function (license) {
																		return A2(
																			$elm$html$Html$li,
																			_List_fromArray(
																				[
																					$elm$html$Html$Attributes$class('license-list-item')
																				]),
																			_List_fromArray(
																				[
																					$author$project$Views$Icon$view(
																					$author$project$Views$Icon$icon(68)),
																					$elm$html$Html$text(license)
																				]));
																	};
																	return A2($elm$core$List$map, viewLicense, ls);
																}())
															])),
													_List_fromArray(
														[
															scaleIcon,
															$elm$html$Html$text(
															A3(
																$elm_community$string_extra$String$Extra$pluralize,
																'licence',
																'licenses',
																$elm$core$List$length(ls)))
														])))
											]);
									}
								}
							}());
					case 1:
						return $author$project$Views$Loading$dots;
					default:
						return $elm$html$Html$text('');
				}
			}());
	});
var $author$project$Views$AddPackagesModal$viewLicensesDetails = function (licenses) {
	var scaleIcon = $author$project$Views$Icon$view(
		$author$project$Views$Icon$small(
			$author$project$Views$Icon$icon(68)));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('license-details package-detail-section')
			]),
		function () {
			if (!licenses.b) {
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('License')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('license-display')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('icon')
									]),
								_List_fromArray(
									[scaleIcon])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Not found')
									]))
							]))
					]);
			} else {
				if (!licenses.b.b) {
					var license = licenses.a;
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('License')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('license-display')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('icon')
										]),
									_List_fromArray(
										[scaleIcon])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(license)
										]))
								]))
						]);
				} else {
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Licenses')
								])),
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							function () {
								var viewLicense = function (license) {
									return A2(
										$elm$html$Html$li,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('license-display')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('icon')
													]),
												_List_fromArray(
													[scaleIcon])),
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(license)
													]))
											]));
								};
								return A2($elm$core$List$map, viewLicense, licenses);
							}())
						]);
				}
			}
		}());
};
var $author$project$Views$PackageVersionSelector$CustomConstraintInput = function (a) {
	return {$: 8, a: a};
};
var $author$project$Views$PackageVersionSelector$SelectCustomConstraint = {$: 4};
var $author$project$Views$PackageVersionSelector$ToggleDropdown = {$: 9};
var $author$project$Views$PackageVersionSelector$ToggleDropdownAndFetchVersions = {$: 7};
var $author$project$Views$IndemnificationPopup$packageIndemnificationPopup = function (indemnificationEnabled) {
	return A2(
		$author$project$Misc$displayIf,
		indemnificationEnabled,
		A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('more-info-tooltip')
				]),
			_List_fromArray(
				[
					$author$project$Views$Icon$view(
					$author$project$Views$Icon$icon(52)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('content')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('main-explanation')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('indemnification-info')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Indemnified packages are covered by a limited indemnity from ActiveState pursuant to the terms of the ACTIVESTATE® Platfom Enterprise Tier Addendum.')
												])),
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('To create an indemnified build, select only versions marked with the purple shield icon.'),
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('indemnification-icon indemnified')
														]),
													_List_Nil)
												]))
										]))
								]))
						]))
				])));
};
var $author$project$Views$PackageVersionSelector$SelectAutoVersion = {$: 2};
var $author$project$Views$PackageVersionSelector$viewAutoOption = F2(
	function (flags, model) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick($author$project$Views$PackageVersionSelector$SelectAutoVersion),
					$elm$html$Html$Attributes$type_('button'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'selected',
							_Utils_eq(model.jw, $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$Auto)),
							_Utils_Tuple2('indemnification-enabled', flags.CW)
						])),
					$elm$html$Html$Attributes$class('version-option Auto')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('version')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Auto (Most compatible)')
						]))
				]));
	});
var $author$project$Views$PackageVersionSelector$ToggleCustomExpanded = {$: 3};
var $author$project$Views$PackageVersionSelector$viewCustomOption = F2(
	function (flags, model) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick($author$project$Views$PackageVersionSelector$ToggleCustomExpanded),
					$elm$html$Html$Attributes$type_('button'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'selected',
							$author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$isCustom(model.jw)),
							_Utils_Tuple2('indemnification-enabled', flags.CW),
							_Utils_Tuple2('highlighted', model.iZ)
						])),
					$elm$html$Html$Attributes$class('version-option Custom')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('version')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Custom')
						])),
					$author$project$Views$Icon$view(
					$author$project$Views$Icon$icon(13))
				]));
	});
var $author$project$Views$PackageVersionSelector$SelectExactVersion = function (a) {
	return {$: 6, a: a};
};
var $author$project$Views$PackageVersionSelector$viewExactVersionOption = F4(
	function (flags, model, parentModel, option) {
		var version = option.G7.aI;
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$Views$PackageVersionSelector$SelectExactVersion(version)),
					$elm$html$Html$Attributes$type_('button'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('not-indemnified', !option.Dm),
							_Utils_Tuple2(
							'selected',
							_Utils_eq(
								model.jw,
								$author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$Exact(version))),
							_Utils_Tuple2('indemnification-enabled', flags.CW)
						])),
					$elm$html$Html$Attributes$class('version-option')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Misc$displayIf,
					flags.CW,
					option.Dm ? $author$project$Views$Icon$view(
						$author$project$Views$Icon$icon(38)) : $author$project$Views$Icon$view(
						$author$project$Views$Icon$icon(39))),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('version')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(version)
						])),
					A2(
					$author$project$Misc$displayIf,
					flags.Ca,
					function () {
						var cves = function () {
							var _v1 = _Utils_Tuple2(
								$author$project$Model$BuildPlanner$SolveLegacyEditor$canSeeCubeCVEs(parentModel),
								model.rt);
							if (_v1.a && (!_v1.b.$)) {
								var cveKey = _v1.b.a;
								return A2(
									$author$project$Model$NormsAndVulns$getVulnerabilities,
									parentModel.rF,
									$author$project$Model$NormsAndVulns$PurlVulnKey(
										A2($author$project$Model$Analytics$Fact$Dependencies$setCVEKeyVersion, version, cveKey)));
							} else {
								return A2(
									$krisajenkins$remotedata$RemoteData$andThen,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Model$NormsAndVulns$NamespacedVulnKey,
										$author$project$Model$NormsAndVulns$getVulnerabilities(parentModel.rF)),
									A2($author$project$Model$NormsAndVulns$getNormalizedVulnerabilityKey, option.G7, parentModel.rF));
							}
						}();
						switch (cves.$) {
							case 3:
								var vulnerabilities = cves.a;
								return $author$project$Views$CVESummary$viewTotals(
									{
										xI: true,
										y7: $elm$core$Maybe$Nothing,
										zd: $elm$core$Maybe$Nothing,
										F2: $author$project$Model$SeverityHistogram$fromVulnerabilities(vulnerabilities)
									});
							case 1:
								return $author$project$Views$Loading$boxes;
							default:
								return $elm$html$Html$text('');
						}
					}())
				]));
	});
var $author$project$Views$PackageVersionSelector$view = function (_v0) {
	var flags = _v0.qX;
	var model = _v0.zf;
	var parentModel = _v0.zE;
	var options = _v0.mT;
	var componentVersion = _v0.xK;
	var showCustomUI = $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$isCustom(model.jw) || model.iZ;
	var selectedConstraintVersion = function () {
		var _v7 = model.jw;
		switch (_v7.$) {
			case 0:
				return 'Auto';
			case 1:
				var version = _v7.a;
				return version;
			case 2:
				var first = _v7.a;
				var others = _v7.b;
				return 'Custom (' + (A2($author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$toPythonSyntax, first, others) + ')');
			default:
				return 'Manually Pinned';
		}
	}();
	var isIndemnified = A2(
		$krisajenkins$remotedata$RemoteData$withDefault,
		false,
		A2(
			$krisajenkins$remotedata$RemoteData$map,
			function ($) {
				return $.Dm;
			},
			componentVersion));
	var isAutoOrCustom = $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$isCustom(model.jw) || $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$isAuto(model.jw);
	var resolvedVersionEl = function () {
		var _v5 = _Utils_Tuple2(componentVersion, isAutoOrCustom);
		_v5$2:
		while (true) {
			if (_v5.b) {
				switch (_v5.a.$) {
					case 3:
						var versionStr = _v5.a.a.sL;
						return A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('resolved-constraint')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('(' + (versionStr + ')'))
								]));
					case 1:
						var _v6 = _v5.a;
						return A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[$author$project$Views$Loading$dots]));
					default:
						break _v5$2;
				}
			} else {
				break _v5$2;
			}
		}
		return $elm$html$Html$text('');
	}();
	var selectedValueEl = A2(
		$elm$html$Html$span,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(selectedConstraintVersion),
				resolvedVersionEl
			]));
	var buttonOnClickMsg = function () {
		var _v3 = _Utils_Tuple2(flags.Fw, options);
		_v3$2:
		while (true) {
			if (!_v3.a) {
				switch (_v3.b.$) {
					case 3:
						return $author$project$Views$PackageVersionSelector$ToggleDropdown;
					case 0:
						var _v4 = _v3.b;
						return $author$project$Views$PackageVersionSelector$ToggleDropdownAndFetchVersions;
					default:
						break _v3$2;
				}
			} else {
				break _v3$2;
			}
		}
		return $author$project$Views$PackageVersionSelector$NoOp;
	}();
	var buttonAttrs = function () {
		var attrs = _List_fromArray(
			[
				$elm$html$Html$Attributes$class('version-select-toggle'),
				$elm$html$Html$Attributes$type_('button'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('read-only', flags.Fw)
					])),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('expanded', model.iq)
					]))
			]);
		return flags.Fw ? attrs : A2(
			$elm$core$List$cons,
			$elm$html$Html$Events$onClick(buttonOnClickMsg),
			attrs);
	}();
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('version-dropdown-new'),
				$elm$html$Html$Attributes$id(
				$author$project$Model$Namespace$cssString(model.Y)),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('with-indemnification', flags.CW)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				buttonAttrs,
				_List_fromArray(
					[selectedValueEl])),
				A2(
				$author$project$Misc$displayIf,
				flags.CW,
				isIndemnified ? A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('indemnified-icon'),
							$elm$html$Html$Attributes$title('This package is indemnified.')
						]),
					_List_fromArray(
						[
							$author$project$Views$Icon$view(
							$author$project$Views$Icon$icon(38))
						])) : A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('indemnified-icon'),
							$elm$html$Html$Attributes$title('This package is not indemnified.')
						]),
					_List_fromArray(
						[
							$author$project$Views$Icon$view(
							$author$project$Views$Icon$icon(39))
						]))),
				A2(
				$author$project$Misc$displayIf,
				model.iq,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('constraint-dropdown')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('package-version-dropdown')
								]),
							_Utils_ap(
								_List_fromArray(
									[
										A2($author$project$Views$PackageVersionSelector$viewCustomOption, flags, model),
										A2($author$project$Views$PackageVersionSelector$viewAutoOption, flags, model)
									]),
								function () {
									switch (options.$) {
										case 3:
											var versionList = options.a;
											return A2(
												$elm$core$List$map,
												A3($author$project$Views$PackageVersionSelector$viewExactVersionOption, flags, model, parentModel),
												versionList);
										case 1:
											return _List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('package-versions-loading')
														]),
													_List_fromArray(
														[
															$author$project$Views$Loading$dots,
															$elm$html$Html$text('Loading versions')
														]))
												]);
										default:
											return _List_Nil;
									}
								}())),
							A2(
							$author$project$Misc$displayIf,
							showCustomUI,
							function () {
								var hasError = model.iY !== '';
								var comparators = _List_fromArray(
									[
										_Utils_Tuple2('>', 'Greater than'),
										_Utils_Tuple2('<', 'Less than'),
										_Utils_Tuple2('>=', 'Greater than or equal to'),
										_Utils_Tuple2('<=', 'Less than or equal to'),
										_Utils_Tuple2('==', 'Specific version'),
										_Utils_Tuple2('!=', 'Exclude specific version')
									]);
								var comparatorView = A2(
									$elm$core$List$map,
									function (_v2) {
										var comparator = _v2.a;
										var description = _v2.b;
										return A2(
											$elm$html$Html$li,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('comparator-row')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('comparator')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(comparator)
														])),
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(description)
														]))
												]));
									},
									comparators);
								return A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('custom-constraint-input-wrapper'),
											$elm$html$Html$Attributes$id(
											$author$project$Model$Namespace$cssString(model.Y))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('input-ui')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$input,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('custom-constraint-input'),
															$elm$html$Html$Attributes$classList(
															_List_fromArray(
																[
																	_Utils_Tuple2('has-error', hasError)
																])),
															$elm$html$Html$Events$onInput($author$project$Views$PackageVersionSelector$CustomConstraintInput),
															$elm$html$Html$Attributes$type_('text'),
															$elm$html$Html$Attributes$value(model.jN),
															$elm$html$Html$Attributes$placeholder('Ex. \">2, <4\"'),
															$elm$html$Html$Attributes$spellcheck(false)
														]),
													_List_Nil),
													A2(
													$elm$html$Html$button,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('save-constraint primary-button'),
															$elm$html$Html$Events$onClick($author$project$Views$PackageVersionSelector$SelectCustomConstraint)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Save')
														]))
												])),
											A2(
											$author$project$Misc$displayIf,
											hasError,
											A2(
												$elm$html$Html$p,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('custom-constraint-error')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(model.iY)
													]))),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('constraint-explanation')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Supported syntax ')
														])),
													A2($elm$html$Html$ul, _List_Nil, comparatorView),
													A2(
													$elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Combine multiple comparators with commas.')
														]))
												]))
										]));
							}())
						]))),
				$author$project$Views$IndemnificationPopup$packageIndemnificationPopup(flags.CW)
			]));
};
var $author$project$Views$AddPackagesModal$viewVersionSelector = F6(
	function (flags, model, parentModel, key, availableVersions, currentVersion) {
		var editor = model.qR;
		var canChangeVersion = _Utils_eq(
			A3(
				$author$project$Model$NormsAndVulns$getFirstKeyMap,
				key,
				A2($elm_community$basics_extra$Basics$Extra$flip, $author$project$Model$BuildPlanner$SolveLegacyEditor$getPackageItem, editor),
				parentModel.rF),
			$elm$core$Maybe$Nothing);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('versions-wrapper'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'auto-chosen',
							_Utils_eq(currentVersion, $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$Auto))
						]))
				]),
			canChangeVersion ? _List_fromArray(
				[
					function () {
					var packageVersionSelector = A2(
						$elm$core$Maybe$withDefault,
						A3($author$project$Views$PackageVersionSelector$init, key, $elm$core$Maybe$Nothing, $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$Auto),
						A2($elm$core$Dict$get, key, model.hY));
					return A2(
						$elm$html$Html$map,
						$author$project$Views$AddPackagesModal$PackageVersionSelectorMsg(packageVersionSelector),
						$author$project$Views$PackageVersionSelector$view(
							{
								xK: $krisajenkins$remotedata$RemoteData$NotAsked,
								qX: {Ca: flags.Ca, CW: flags.CW, Fw: false},
								zf: packageVersionSelector,
								mT: $krisajenkins$remotedata$RemoteData$Success(availableVersions),
								zE: parentModel
							}));
				}()
				]) : _List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$getHumanReadableString(currentVersion))
				]));
	});
var $author$project$Views$AddPackagesModal$viewPackage = function (_v0) {
	var flags = _v0.qX;
	var model = _v0.zf;
	var parentModel = _v0.zE;
	var key = _v0.Y;
	var ingredientId = _v0.uf;
	var url = _v0.GT;
	var description = _v0.bP;
	var version = _v0.aI;
	var licenses = _v0.go;
	var modules = _v0.o2;
	var matchingModules = _v0.o1;
	var availableVersions = _v0.xj;
	var vulnerabilities = A2(
		$krisajenkins$remotedata$RemoteData$mapError,
		$author$project$Model$BuildPlanner$BuildPlannerError$HttpError,
		A2(
			$author$project$Model$NormsAndVulns$getVulnerabilities,
			parentModel.rF,
			$author$project$Model$NormsAndVulns$NamespacedVulnKey(
				A2($author$project$Model$Vulnerability$fromNamespaceKey, key, version))));
	var selectedConstraint = A2(
		$elm$core$Maybe$withDefault,
		$author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$Auto,
		A2(
			$elm$core$Maybe$map,
			$author$project$Views$PackageVersionSelector$getSelected,
			A2($elm$core$Dict$get, key, model.hY)));
	var req = {bK: selectedConstraint, Y: key};
	var name = $author$project$Model$Namespace$getName(key);
	var maybeItemStatus = A2(
		$elm$core$Maybe$map,
		$author$project$Views$AddPackagesModal$ignoreStatusUpdatedFrom,
		A3($author$project$Views$AddPackagesModal$getItemStatus, model, parentModel, key));
	var isLoadingDetails = A2($elm$core$Set$member, key, model.uy);
	var expandedDetails = A2($author$project$Views$CVEs$isExpandedDetails, key, model.jO);
	return _Utils_Tuple2(
		ingredientId,
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					'package-result ' + $author$project$Views$AddPackagesModal$statusClassName(maybeItemStatus))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('package-result-header')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Views$AddPackagesModal$CVEsMsg,
							A4(
								$author$project$Views$NamespaceExpand$caret,
								model.jO,
								key,
								$author$project$Views$NamespaceExpand$flagsInit,
								_List_fromArray(
									[
										A2($author$project$Misc$displayMaybe, $author$project$Views$AddPackagesModal$changeIndicator, maybeItemStatus),
										A2(
										$elm$html$Html$h4,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('package-name')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(name)
											]))
									]))),
							A6($author$project$Views$AddPackagesModal$viewVersionSelector, flags, model, parentModel, key, availableVersions, selectedConstraint),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('package-cve-summary')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Views$PackageSummaryDisplay$choose,
									model.rO,
									{
										EH: function (_v1) {
											return A2(
												$elm$html$Html$map,
												$author$project$Views$AddPackagesModal$CVEsMsg,
												A5($author$project$Views$CVEs$viewForPackage, flags, model.jO, key, false, vulnerabilities));
										},
										EM: function (_v2) {
											return A2(
												$elm$html$Html$map,
												$author$project$Views$AddPackagesModal$LicensesMsg,
												A4(
													$author$project$Views$Licenses$viewForPackage,
													flags,
													model.rn,
													key,
													$krisajenkins$remotedata$RemoteData$Success(licenses)));
										}
									})
								])),
							A3($author$project$Views$AddPackagesModal$viewRequirementActionButton, req, isLoadingDetails, maybeItemStatus)
						])),
					A2(
					$author$project$Misc$displayIf,
					expandedDetails,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('package-result-info')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Misc$displayIf,
								$author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$isAuto(selectedConstraint),
								A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('version-indicator')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Displaying details for version ' + (version + ' — the most likely outcome of selecting \"Auto\"'))
										]))),
								A2(
								$author$project$Misc$displayIf,
								$author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$isCustom(selectedConstraint),
								A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('version-indicator')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Displaying details for version ' + (version + ' - the most recent version of this package in our catalog.'))
										]))),
								A2(
								$author$project$Misc$displayIf,
								flags.Ca,
								A2($author$project$Views$AddPackagesModal$viewCVEDetails, vulnerabilities, isLoadingDetails)),
								A2(
								$author$project$Misc$displayIf,
								flags.DX,
								$author$project$Views$AddPackagesModal$viewLicensesDetails(licenses)),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('package-url package-detail-section')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h4,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Project link')
											])),
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												(url !== '') ? A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$href(url),
														$elm$html$Html$Attributes$target('_blank')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(url)
													])) : A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('not-available')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Not provided')
													]))
											]))
									])),
								$author$project$Views$AddPackagesModal$viewDescription(description),
								A2(
								$author$project$Views$AddPackagesModal$viewModules,
								model,
								{Y: key, o1: matchingModules, o2: modules, wI: ''})
							])))
				])));
};
var $author$project$Model$HasuraIngredient$website = function (_v0) {
	var fields = _v0;
	return fields.bk;
};
var $author$project$Views$AddPackagesModal$viewHasuraIngredient = F5(
	function (flags, model, parentModel, key, ingredient) {
		var selectedConstraint = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$Auto,
			A2(
				$elm$core$Maybe$map,
				$author$project$Views$PackageVersionSelector$getSelected,
				A2($elm$core$Dict$get, key, model.hY)));
		var name = $author$project$Model$Namespace$getName(key);
		var firstVersion = $author$project$Model$HasuraIngredient$firstVersion(ingredient);
		var allVersions = $author$project$Model$HasuraIngredient$allVersions(ingredient);
		var availableVersions = A2(
			$elm$core$List$filterMap,
			A2(
				$elm$core$Basics$composeR,
				A2($elm_community$basics_extra$Basics$Extra$flip, $elm$core$Dict$get, allVersions),
				$elm$core$Maybe$map(
					function (hasuraIngredient) {
						return {
							dE: $author$project$Model$HasuraIngredient$checksum(hasuraIngredient),
							Dm: $author$project$Model$HasuraIngredient$isIndemnified(hasuraIngredient),
							G7: A2(
								$author$project$Model$Vulnerability$fromNamespaceKey,
								key,
								$author$project$Model$HasuraIngredient$version(hasuraIngredient))
						};
					})),
			$author$project$Model$HasuraIngredient$allVersionsDesc(ingredient));
		var selectedVersion = A2(
			$elm$core$Maybe$withDefault,
			firstVersion,
			A2(
				$elm$core$Dict$get,
				$author$project$Model$BuildExprEditorUtils$getVersion(selectedConstraint),
				allVersions));
		var licenses = $author$project$Model$HasuraIngredient$licenses(selectedVersion);
		var modules = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$String$toLower,
				$elm$core$Basics$neq(
					$elm$core$String$toLower(name))),
			$author$project$Model$HasuraIngredient$features(selectedVersion));
		var version = $author$project$Model$HasuraIngredient$version(selectedVersion);
		return $author$project$Views$AddPackagesModal$viewPackage(
			{
				xj: availableVersions,
				bP: $author$project$Model$HasuraIngredient$description(ingredient),
				qX: flags,
				uf: $author$project$Model$HasuraIngredient$ingredientId(ingredient),
				Y: key,
				go: licenses,
				o1: $elm$core$Maybe$Nothing,
				zf: model,
				o2: modules,
				zE: parentModel,
				GT: $author$project$Model$HasuraIngredient$website(ingredient),
				aI: version
			});
	});
var $author$project$Views$AddPackagesModal$viewPopularPackages = F4(
	function (flags, model, parentModel, popularPackages) {
		var popularPackagesHeader = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('popular-package-header')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Popular Packages'),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('more-info-tooltip')
								]),
							_List_fromArray(
								[
									$author$project$Views$Icon$view(
									$author$project$Views$Icon$icon(52)),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('content')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('A curated list of most popular packages on the ActiveState platform.')
												]))
										]))
								]))
						]))
				]));
		var popularPackagesBody = function () {
			switch (popularPackages.$) {
				case 1:
					return _List_fromArray(
						[
							_Utils_Tuple2('loadingDots', $author$project$Views$Loading$dots)
						]);
				case 3:
					var list = popularPackages.a;
					return A2(
						$elm$core$List$map,
						$elm_community$basics_extra$Basics$Extra$uncurry(
							A3($author$project$Views$AddPackagesModal$viewHasuraIngredient, flags, model, parentModel)),
						list);
				default:
					return _List_Nil;
			}
		}();
		return A3(
			$elm$html$Html$Keyed$node,
			'div',
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('package-list-wrapper')
				]),
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2('popularPackagesKey', popularPackagesHeader),
				popularPackagesBody));
	});
var $author$project$Views$AddPackagesModal$packageContent = F4(
	function (model, currentLanguage, flags, parentModel) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('find-package-ui')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('single-field-ui')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$form,
								_List_fromArray(
									[
										$elm$html$Html$Events$onSubmit(
										$author$project$Views$AddPackagesModal$Search(currentLanguage))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$type_('text'),
												$elm$html$Html$Attributes$id($author$project$Views$AddPackagesModal$initialFocusID),
												$elm$html$Html$Events$onInput($author$project$Views$AddPackagesModal$SearchChanged),
												$elm$html$Html$Attributes$spellcheck(false),
												$elm$html$Html$Attributes$value(model.iE),
												$elm$html$Html$Attributes$placeholder('Search by package name')
											]),
										_List_Nil),
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$type_('submit'),
												$elm$html$Html$Attributes$class('primary-button'),
												$elm$html$Html$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'disabled',
														_Utils_eq(model.iE, model.mq) || (model.iE === ''))
													]))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Search')
											]))
									])),
								function () {
								var _v0 = model.iD;
								switch (_v0.$) {
									case 1:
										var icon = function (kind) {
											return $author$project$Views$Icon$view(
												A2(
													$author$project$Views$Icon$square,
													12,
													$author$project$Views$Icon$icon(kind)));
										};
										return A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pagination')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$map,
													$author$project$Views$AddPackagesModal$PackageSummaryDisplayMsg,
													A2($author$project$Views$PackageSummaryDisplay$viewButtons, flags, model.rO)),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('pagination-ui')
														]),
													_List_fromArray(
														[
															$author$project$Views$Loading$dots,
															A2(
															$elm$html$Html$button,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('pagination-button'),
																	A2($elm$html$Html$Attributes$attribute, 'disabled', '')
																]),
															_List_fromArray(
																[
																	icon(2)
																])),
															A2(
															$elm$html$Html$button,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('pagination-button'),
																	A2($elm$html$Html$Attributes$attribute, 'disabled', '')
																]),
															_List_fromArray(
																[
																	icon(3)
																]))
														]))
												]));
									case 0:
										return A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pagination')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$map,
													$author$project$Views$AddPackagesModal$PackageSummaryDisplayMsg,
													A2($author$project$Views$PackageSummaryDisplay$viewButtons, flags, model.rO))
												]));
									case 2:
										return A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('search-error')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$strong,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Oh no!')
														])),
													$elm$html$Html$text(' Something went wrong, please try searching again.')
												]));
									default:
										var searchResults = _v0.a;
										var icon = function (kind) {
											return $author$project$Views$Icon$view(
												A2(
													$author$project$Views$Icon$square,
													12,
													$author$project$Views$Icon$icon(kind)));
										};
										return A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pagination')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$map,
													$author$project$Views$AddPackagesModal$PackageSummaryDisplayMsg,
													A2($author$project$Views$PackageSummaryDisplay$viewButtons, flags, model.rO)),
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('pagination-ui')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	' Page ' + $elm$core$String$fromInt(model.he + 1))
																])),
															A2(
															$elm$html$Html$button,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('pagination-button'),
																	(model.he <= 0) ? A2($elm$html$Html$Attributes$attribute, 'disabled', '') : $elm$html$Html$Events$onClick($author$project$Views$AddPackagesModal$PreviousResults)
																]),
															_List_fromArray(
																[
																	icon(2)
																])),
															A2(
															$elm$html$Html$button,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('pagination-button'),
																	(_Utils_cmp(
																	$elm$core$List$length(searchResults),
																	$author$project$Views$AddPackagesModal$searchResultsPageSize) < 0) ? A2($elm$html$Html$Attributes$attribute, 'disabled', '') : $elm$html$Html$Events$onClick($author$project$Views$AddPackagesModal$NextResults)
																]),
															_List_fromArray(
																[
																	icon(3)
																]))
														]))
												]));
								}
							}()
							]))
					])),
				function () {
				var _v1 = model.iD;
				switch (_v1.$) {
					case 1:
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('package-list-wrapper')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('loading-search')
										]),
									_List_fromArray(
										[$author$project$Views$Loading$dots]))
								]));
					case 0:
						var _v2 = $author$project$Model$PopularPackages$listForLanguage(currentLanguage);
						if (!_v2.b) {
							return $elm$html$Html$text('');
						} else {
							return A4(
								$author$project$Views$AddPackagesModal$viewPopularPackages,
								flags,
								model,
								parentModel,
								A2(
									$krisajenkins$remotedata$RemoteData$map,
									$elm$core$Dict$toList,
									A2($author$project$Model$PopularPackages$getForLanguage, parentModel.m6, currentLanguage)));
						}
					case 2:
						return $elm$html$Html$text('');
					default:
						var searchResultsDict = _v1.a;
						return (!$elm$core$List$isEmpty(searchResultsDict)) ? A3(
							$elm$html$Html$Keyed$node,
							'div',
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('package-list-wrapper')
								]),
							A2(
								$elm$core$List$map,
								$elm_community$basics_extra$Basics$Extra$uncurry(
									A3($author$project$Views$AddPackagesModal$viewHasuraIngredient, flags, model, parentModel)),
								searchResultsDict)) : A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('package-list-wrapper')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('forum-box')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('No matches found.'),
													A2($elm$html$Html$br, _List_Nil, _List_Nil),
													$elm$html$Html$text('If you really need this package, let us know!')
												])),
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('We\'re always working to expand our catalog where it counts, so we\'d love to hear which packages you\'d like to see next.')
												])),
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$target('_blank'),
													$elm$html$Html$Attributes$href('mailto:support@activestate.com')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Contact Support')
												]))
										]))
								]));
				}
			}()
			]);
	});
var $author$project$Model$BuildPlanner$BuildExpr$Solve$Requirement$isBundle = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.aE;
	},
	A2(
		$elm$core$Basics$composeR,
		$author$project$Model$Namespace$kindFromString,
		$elm$core$Basics$eq(0)));
var $author$project$Views$AddPackagesModal$viewLanguageGroup = function (_v0) {
	var languageName = _v0.a;
	var items = _v0.b;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('language-group')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h4,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(languageName)
					])),
				A2(
				$elm$html$Html$ul,
				_List_Nil,
				$elm$core$List$reverse(
					A2(
						$elm$core$List$map,
						function (item) {
							var version = $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$getHumanReadableString(item.bK);
							var packageName = $author$project$Model$BuildPlanner$BuildExpr$Solve$Requirement$fromKeyAndConstraint(item).w;
							var isBundle = $author$project$Model$BuildPlanner$BuildExpr$Solve$Requirement$isBundle(
								$author$project$Model$BuildPlanner$BuildExpr$Solve$Requirement$fromKeyAndConstraint(item));
							return A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('item')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(packageName),
										$elm$html$Html$text(' '),
										isBundle ? $elm$html$Html$text('(Bundle)') : $elm$html$Html$text(version),
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('secondary-button small'),
												$elm$html$Html$Events$onClick(
												$author$project$Views$AddPackagesModal$Undo(item.Y))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											]))
									]));
						},
						items)))
			]));
};
var $author$project$Views$AddPackagesModal$shoppingCart = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('shopping-cart side-panel')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h4,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A3(
							$elm_community$string_extra$String$Extra$pluralize,
							'Package',
							'Packages',
							$elm$core$List$length(
								A3(
									$elm$core$Basics$composeR,
									$elm$core$List$map($elm$core$Tuple$second),
									$elm$core$List$concat,
									$elm$core$Dict$toList(model.fF))))),
						$elm$html$Html$text(' Added')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('shopping-list')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						A2(
							$elm$core$List$map,
							$author$project$Views$AddPackagesModal$viewLanguageGroup,
							$elm$core$Dict$toList(model.fF)))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('finish-shopping')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('primary-button'),
								$elm$html$Html$Events$onClick(
								$author$project$Views$AddPackagesModal$OnClose(true))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Finish & Resolve Dependencies')
							]))
					]))
			]));
};
var $author$project$Views$AddPackagesModal$SetLanguage = function (a) {
	return {$: 6, a: a};
};
var $author$project$Views$AddPackagesModal$viewChangeLanguage = F2(
	function (selectedLang, language) {
		var name = $author$project$Model$Language$toString(language);
		var className = _Utils_eq(
			$author$project$Model$Language$toString(selectedLang),
			name) ? 'selected' : '';
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(className),
					$elm$html$Html$Attributes$class('tab'),
					$elm$html$Html$Events$onClick(
					$author$project$Views$AddPackagesModal$SetLanguage(language))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Model$Language$toDisplayString(language))
				]));
	});
var $author$project$Views$AddPackagesModal$viewCurrentLanguage = F2(
	function (selectedLang, languages) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('section-tabs'),
					$elm$html$Html$Attributes$class('language-tabs')
				]),
			$mgold$elm_nonempty_list$List$Nonempty$toList(
				A2(
					$mgold$elm_nonempty_list$List$Nonempty$map,
					$author$project$Views$AddPackagesModal$viewChangeLanguage(selectedLang),
					languages)));
	});
var $author$project$Views$AddPackagesModal$viewContent = F4(
	function (flags, model, parentModel, currentLanguage) {
		var modalClass = function () {
			var results = 'has-results';
			var noResults = 'no-packages-found';
			var _v3 = model.kB;
			if (!_v3) {
				var _v4 = model.iD;
				switch (_v4.$) {
					case 1:
						return 'loading ' + noResults;
					case 0:
						return 'presearch ' + noResults;
					case 2:
						return 'presearch ' + noResults;
					default:
						var payload = _v4.a;
						return 'loaded ' + ($elm$core$List$isEmpty(payload) ? noResults : results);
				}
			} else {
				var _v5 = parentModel.iS;
				switch (_v5.$) {
					case 1:
						return 'loading ' + noResults;
					case 3:
						return 'loaded ' + results;
					default:
						return 'presearch ' + noResults;
				}
			}
		}();
		var hasBundles = $author$project$Model$Language$supportsBundles(model.ip);
		var tabContent = function () {
			var _v0 = _Utils_Tuple2(hasBundles, model.kB);
			if (!_v0.b) {
				var _v1 = _v0.b;
				return A4($author$project$Views$AddPackagesModal$packageContent, model, currentLanguage, flags, parentModel);
			} else {
				if (!_v0.a) {
					return A4($author$project$Views$AddPackagesModal$packageContent, model, currentLanguage, flags, parentModel);
				} else {
					var _v2 = _v0.b;
					return A3($author$project$Views$AddPackagesModal$bundleContent, model, currentLanguage, parentModel);
				}
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(modalClass),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('indemnification-enabled', flags.CW)
						])),
					$elm$html$Html$Attributes$class('modal-wrapper')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal-search')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('filter-ui')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Misc$displayIf,
									$mgold$elm_nonempty_list$List$Nonempty$length(model.jF) > 1,
									A3($elm$html$Html$Lazy$lazy2, $author$project$Views$AddPackagesModal$viewCurrentLanguage, currentLanguage, model.jF)),
									A2(
									$author$project$Misc$displayIf,
									hasBundles,
									A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('display-pill')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$classList(
														_List_fromArray(
															[
																_Utils_Tuple2('selected', !model.kB)
															])),
														$elm$html$Html$Events$onClick(
														$author$project$Views$AddPackagesModal$ToggleTab(0))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Packages')
													])),
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$classList(
														_List_fromArray(
															[
																_Utils_Tuple2('selected', model.kB === 1)
															])),
														$elm$html$Html$Events$onClick(
														$author$project$Views$AddPackagesModal$ToggleTab(1))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Bundles')
													]))
											])))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('results-wrapper')
								]),
							tabContent)
						])),
					(!$elm$core$Dict$isEmpty(model.fF)) ? $author$project$Views$AddPackagesModal$shoppingCart(model) : $author$project$Views$AddPackagesModal$commandLineInstructions(model)
				]));
	});
var $author$project$Views$AddPackagesModal$view = F3(
	function (flags, model, parentModel) {
		return $author$project$Views$Modal$view(
			{
				BD: 'add-packages',
				BI: $author$project$Views$AddPackagesModal$OnClose(false),
				dH: A4($author$project$Views$AddPackagesModal$viewContent, flags, model, parentModel, model.ip),
				x4: A2($author$project$Views$Modal$DismissButtonVisible, 1, true)
			});
	});
var $author$project$Views$CustomRequirementInput$OnAdd = {$: 3};
var $author$project$Views$CustomRequirementInput$OnInput = function (a) {
	return {$: 2, a: a};
};
var $author$project$Views$CustomRequirementInput$view = function (model) {
	var datalistID = 'custom-namespace-list';
	var _v0 = model.ht;
	var namespace = _v0.a;
	var name = _v0.b;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('section-header')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Custom')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('custom-requirement-input superuser-only')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$placeholder('namespace'),
								$elm$html$Html$Attributes$type_('text'),
								A2($elm$html$Html$Attributes$attribute, 'list', datalistID),
								$elm$html$Html$Attributes$value(namespace),
								$elm$html$Html$Events$onInput(
								function (newNamespace) {
									return $author$project$Views$CustomRequirementInput$OnInput(
										_Utils_Tuple2(newNamespace, name));
								})
							]),
						_List_Nil),
						A2(
						$elm$html$Html$datalist,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id(datalistID)
							]),
						A2(
							$elm$core$List$map,
							A2(
								$elm$core$Basics$composeR,
								$elm$html$Html$text,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$List$singleton,
									$elm$html$Html$option(_List_Nil))),
							model.mE)),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$placeholder('name'),
								$elm$html$Html$Attributes$type_('text'),
								$elm$html$Html$Attributes$value(name),
								$elm$html$Html$Events$onInput(
								function (newName) {
									return $author$project$Views$CustomRequirementInput$OnInput(
										_Utils_Tuple2(namespace, newName));
								})
							]),
						_List_Nil),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('secondary-button'),
								$elm$html$Html$Events$onClick($author$project$Views$CustomRequirementInput$OnAdd),
								$elm$html$Html$Attributes$disabled(
								!$author$project$Views$CustomRequirementInput$isValid(model.ht))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Add')
							]))
					]))
			]));
};
var $author$project$Views$Dependencies$AddRequirements = function (a) {
	return {$: 6, a: a};
};
var $author$project$Views$Dependencies$BothLoaded = 2;
var $author$project$Views$Dependencies$LoadingNew = 1;
var $author$project$Views$Dependencies$LoadingOld = 0;
var $author$project$Views$Dependencies$ToggleDisplayOnlyChanges = {$: 4};
var $author$project$Views$Dependencies$categorizedDependencies = function (remoteBuildData) {
	return A2(
		$elm_community$dict_extra$Dict$Extra$groupBy,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.kH;
			},
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.j9;
				},
				$author$project$Model$BuildExprEditorUtils$getCategory)),
		A2(
			$elm$core$List$sortBy,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.kH;
				},
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.j9;
					},
					A2($elm$core$Basics$composeR, $author$project$Model$Namespace$getName, $elm$core$String$toLower))),
			$author$project$Views$Dependencies$getDependencies(remoteBuildData)));
};
var $elm_community$list_extra$List$Extra$count = function (predicate) {
	return A2(
		$elm$core$List$foldl,
		F2(
			function (x, acc) {
				return predicate(x) ? (acc + 1) : acc;
			}),
		0);
};
var $author$project$Views$Dependencies$errorsView = A2(
	$elm$html$Html$p,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('dependencies-not-loaded error-text')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Unable to resolve dependencies.')
		]));
var $author$project$Views$Dependencies$toVersionSet = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.e$;
	},
	A2(
		$elm$core$Basics$composeR,
		$mgold$elm_nonempty_list$List$Nonempty$toList,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$map(
				function ($) {
					return $.sL;
				}),
			$elm$core$Set$fromList)));
var $author$project$Views$Dependencies$isRevisionOnlyChange = F2(
	function (original, current) {
		return _Utils_eq(
			$author$project$Views$Dependencies$toVersionSet(original),
			$author$project$Views$Dependencies$toVersionSet(current));
	});
var $author$project$Views$Dependencies$getEndUserFacingStatus = function (item) {
	var _v0 = item.L;
	if (_v0.$ === 1) {
		var original = _v0.a;
		return A2($author$project$Views$Dependencies$isRevisionOnlyChange, original, item.kH) ? $author$project$Model$Editor$Unchanged : item.L;
	} else {
		return item.L;
	}
};
var $author$project$Views$Dependencies$solutionSectionId = 'solution-section';
var $author$project$Model$BuildExprEditorUtils$categorySorter = F2(
	function (_v0, _v1) {
		var left = _v0.a;
		var right = _v1.a;
		var _v2 = _Utils_Tuple2(left, right);
		_v2$1:
		while (true) {
			_v2$2:
			while (true) {
				switch (_v2.a) {
					case 'Bundles':
						switch (_v2.b) {
							case 'Bundles':
								return 1;
							case 'Other':
								break _v2$1;
							default:
								break _v2$1;
						}
					case 'Other':
						switch (_v2.b) {
							case 'Bundles':
								break _v2$2;
							case 'Other':
								return 1;
							default:
								return 2;
						}
					default:
						switch (_v2.b) {
							case 'Bundles':
								break _v2$2;
							case 'Other':
								return 0;
							default:
								return A2($elm$core$Basics$compare, left, right);
						}
				}
			}
			return 2;
		}
		return 0;
	});
var $author$project$Views$Dependencies$getCategoryTooltip = function (category) {
	var _v0 = $elm$core$String$toLower(category);
	if (_v0 === 'shared') {
		return $elm$core$Maybe$Just('These are low level dependencies which are not associated with a particular language.');
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Views$Dependencies$AddRequirement = function (a) {
	return {$: 5, a: a};
};
var $author$project$Views$Dependencies$Dependencies = 1;
var $author$project$Views$RelatedPackages$Dependencies = 1;
var $author$project$Views$Dependencies$ExpandMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Views$Dependencies$LicensesMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Views$Dependencies$RequiredBy = 2;
var $author$project$Views$RelatedPackages$RequiredBy = 0;
var $author$project$Views$Dependencies$SelectTab = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Views$Dependencies$Vulnerabilities = 0;
var $author$project$Views$RelatedPackages$countView = function (related) {
	return $elm$core$List$isEmpty(related) ? $elm$html$Html$text('') : A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('related-package-count more-info-tooltip')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$elm$core$String$fromInt(
					$elm$core$List$length(related))),
				$author$project$Views$Icon$view(
				$author$project$Views$Icon$icon(57)),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('content')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(
									$elm$core$List$length(related)) + (' ' + A3(
									$author$project$Misc$pluralizeNoNumber,
									'dependency',
									'dependencies',
									$elm$core$List$length(related))))
							]))
					]))
			]));
};
var $author$project$Views$Dependencies$defaultTab = 2;
var $author$project$Model$BuildDataSource$getDependencies = function (_v0) {
	var cached = _v0.df;
	return cached.lt;
};
var $author$project$Model$BuildDataSource$getRequiredBys = function (_v0) {
	var cached = _v0.df;
	return cached.jt;
};
var $author$project$Model$Vulnerability$sortKey = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.ck;
	},
	$author$project$Model$Severity$sortKey);
var $author$project$Views$RelatedPackages$viewPackage = F2(
	function (cvesEnabled, _package) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('related-package')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('item-name')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(_package.G7.w)
						])),
					$elm$html$Html$text(_package.G7.aI),
					A2(
					$author$project$Misc$displayIf,
					cvesEnabled,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('package-cve-summary')
							]),
						_List_fromArray(
							[
								function () {
								var _v0 = _package.F2;
								switch (_v0.$) {
									case 3:
										var severityHistogram = _v0.a;
										return $author$project$Views$CVESummary$viewTotals(
											{xI: true, y7: $elm$core$Maybe$Nothing, zd: $elm$core$Maybe$Nothing, F2: severityHistogram});
									case 2:
										return $elm$html$Html$text('Loading CVE data failed');
									case 1:
										return $author$project$Views$Loading$dots;
									default:
										return $elm$html$Html$text('');
								}
							}()
							])))
				]));
	});
var $author$project$Views$RelatedPackages$view = function (_v0) {
	var kind = _v0.mp;
	var related = _v0.zO;
	var cvesEnabled = _v0.Ca;
	if ($elm$core$List$isEmpty(related)) {
		if (!kind) {
			return $elm$html$Html$text('This package is not required by anything else.');
		} else {
			return $elm$html$Html$text('This package has no dependencies.');
		}
	} else {
		var packages = A2(
			$elm$core$List$map,
			$author$project$Views$RelatedPackages$viewPackage(cvesEnabled),
			A2(
				$elm$core$List$sortBy,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.G7;
					},
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.w;
						},
						$elm$core$String$toLower)),
				related));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('related-packages')
				]),
			packages);
	}
};
var $author$project$Views$Dependencies$viewNamespaceKey = F2(
	function (flags, key) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('item-name')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Misc$displayIf,
					flags.Gm,
					A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('superuser-only')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Model$Namespace$getNamespace(key))
							]))),
					$elm$html$Html$text(
					$author$project$Model$Namespace$getName(key))
				]));
	});
var $author$project$Views$Dependencies$toRevisionStr = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.e$;
	},
	A2(
		$elm$core$Basics$composeR,
		$mgold$elm_nonempty_list$List$Nonempty$head,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.oL;
			},
			$elm$core$String$fromInt)));
var $author$project$Views$Dependencies$viewRevisionOnlyChange = F2(
	function (flags, _v0) {
		var original = _v0.jl;
		var current = _v0.g5;
		return flags.Gm ? A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('old-versions superuser-only')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					'Revision ' + ($author$project$Views$Dependencies$toRevisionStr(original) + ('  -> ' + ($author$project$Views$Dependencies$toRevisionStr(current) + ''))))
				])) : $elm$html$Html$text('');
	});
var $author$project$Views$Dependencies$viewDependency = F4(
	function (flags, model, parentModel, dependency) {
		var vulnKeyToRelatedPackage = function (vulnerabilityKey) {
			return {
				F2: A2(
					$krisajenkins$remotedata$RemoteData$map,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$map(
							function ($) {
								return $.ck;
							}),
						$author$project$Model$SeverityHistogram$fromSeverities),
					A2(
						$author$project$Model$NormsAndVulns$getVulnerabilities,
						parentModel.rF,
						$author$project$Model$NormsAndVulns$NamespacedVulnKey(vulnerabilityKey))),
				G7: vulnerabilityKey
			};
		};
		var versions = A2(
			$elm_community$list_extra$List$Extra$uniqueBy,
			function ($) {
				return $.sL;
			},
			$mgold$elm_nonempty_list$List$Nonempty$toList(dependency.kH.e$));
		var viewVersionVulns = F2(
			function (version, vulns) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('dependency-vulnerability-summary')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Misc$displayIf,
							$elm$core$List$length(versions) > 1,
							A2(
								$elm$html$Html$h3,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('version-heading')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Version ' + version)
									]))),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('severity-groups')
								]),
							$author$project$Views$CVEs$listBySeverity(vulns))
						]));
			});
		var versionEl = function (version) {
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('package-version-value')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(version.sL),
						A2(
						$author$project$Misc$displayIf,
						flags.CW,
						(flags.D8 || version.Dm) ? A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('indemnified-icon'),
									$elm$html$Html$Attributes$title('This package is indemnified.')
								]),
							_List_fromArray(
								[
									$author$project$Views$Icon$view(
									$author$project$Views$Icon$icon(38))
								])) : A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('indemnified-icon'),
									$elm$html$Html$Attributes$title('This package is not indemnified.')
								]),
							_List_fromArray(
								[
									$author$project$Views$Icon$view(
									$author$project$Views$Icon$icon(39))
								])))
					]));
		};
		var versionData = $author$project$Model$BuildDataSource$getVersionForArbitraryPlatform(dependency.kH);
		var oldVersionEl = function () {
			var _v12 = dependency.L;
			if (_v12.$ === 1) {
				var originalComponent = _v12.a;
				return A2($author$project$Views$Dependencies$isRevisionOnlyChange, originalComponent, dependency.kH) ? A2(
					$author$project$Views$Dependencies$viewRevisionOnlyChange,
					flags,
					{g5: dependency.kH, jl: originalComponent}) : A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('old-versions')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('From '),
							$elm$html$Html$text(
							A2(
								$elm$core$String$join,
								' & ',
								$elm_community$list_extra$List$Extra$unique(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.sL;
										},
										$mgold$elm_nonempty_list$List$Nonempty$toList(originalComponent.e$)))))
						]));
			} else {
				return $elm$html$Html$text('');
			}
		}();
		var key = dependency.kH.j9;
		var requirement = A2(
			$author$project$Model$BuildPlanner$BuildExpr$Solve$Requirement$KeyAndConstraint,
			key,
			$author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$Exact(versionData.sL));
		var isExpanded = A2($author$project$Views$NamespaceExpand$isExpanded, key, parentModel.x$);
		var hasAnyItemsToShow = function (list) {
			return A3(
				$krisajenkins$remotedata$RemoteData$unwrap,
				false,
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$List$isEmpty),
				list);
		};
		var getDependenciesPackage = function (vulnerabilityKey) {
			var _v11 = $author$project$Model$Namespace$kind(
				$author$project$Model$Namespace$key(vulnerabilityKey));
			switch (_v11) {
				case 4:
					return $elm$core$Maybe$Nothing;
				case 0:
					return $elm$core$Maybe$Nothing;
				default:
					return $elm$core$Maybe$Just(
						vulnKeyToRelatedPackage(vulnerabilityKey));
			}
		};
		var effectiveStatus = $author$project$Views$Dependencies$getEndUserFacingStatus(dependency);
		var statusLabel = function () {
			switch (effectiveStatus.$) {
				case 0:
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('change-label')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Added')
							]));
				case 2:
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('change-label')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Removed')
							]));
				case 1:
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('change-label')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Updated')
							]));
				default:
					return $elm$html$Html$text('');
			}
		}();
		var defaultPinDependencyText = 'Require';
		var cveKeyToVulns = A2(
			$elm$core$Basics$composeR,
			$author$project$Model$NormsAndVulns$PurlVulnKey,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Model$NormsAndVulns$getVulnerabilities(parentModel.rF),
				$krisajenkins$remotedata$RemoteData$mapError($author$project$Model$BuildPlanner$BuildPlannerError$HttpError)));
		var clickMsg = function () {
			var constraint = function () {
				var _v9 = $author$project$Model$Namespace$kind(key);
				if (_v9 === 4) {
					return $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$Exact(versionData.sL);
				} else {
					return $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$Auto;
				}
			}();
			if (effectiveStatus.$ === 2) {
				return $author$project$Views$Dependencies$AddRequirement(requirement);
			} else {
				return $author$project$Views$Dependencies$AddRequirement(
					_Utils_update(
						requirement,
						{bK: constraint}));
			}
		}();
		var buildData = $author$project$Model$BuildDataSource$latest(parentModel);
		var dependencies = A2(
			$krisajenkins$remotedata$RemoteData$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Model$BuildDataSource$getDependencies,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Dict$get(key),
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map(
							$elm$core$List$filterMap(getDependenciesPackage)),
						$elm$core$Maybe$withDefault(_List_Nil)))),
			buildData);
		var requiredBys = A2(
			$krisajenkins$remotedata$RemoteData$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Model$BuildDataSource$getRequiredBys,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Dict$get(key),
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map(
							$elm$core$List$map(vulnKeyToRelatedPackage)),
						$elm$core$Maybe$withDefault(_List_Nil)))),
			buildData);
		var versionsAndVulnerabilities = function () {
			if ($author$project$Model$BuildPlanner$SolveLegacyEditor$canSeeCubeCVEs(parentModel)) {
				return A2(
					$krisajenkins$remotedata$RemoteData$andThen,
					function (buildDataSource) {
						return A2(
							$elm$core$Maybe$withDefault,
							$krisajenkins$remotedata$RemoteData$NotAsked,
							A2(
								$elm$core$Maybe$map,
								function (component) {
									var cveKey = $author$project$Model$BuildPlanner$Component$getAnalyticsCVEKey(component);
									return A2(
										$krisajenkins$remotedata$RemoteData$map,
										$elm$core$List$filter(
											A2(
												$elm$core$Basics$composeR,
												$elm$core$Tuple$second,
												$elm$core$Basics$neq(_List_Nil))),
										$krisajenkins$remotedata$RemoteData$fromList(
											A2(
												$elm$core$List$map,
												function (version) {
													return A2(
														$krisajenkins$remotedata$RemoteData$map,
														$elm$core$Tuple$pair(version),
														cveKeyToVulns(
															A2($author$project$Model$Analytics$Fact$Dependencies$setCVEKeyVersion, version, cveKey)));
												},
												A2(
													$elm$core$List$map,
													function ($) {
														return $.sL;
													},
													versions))));
								},
								A2(
									$elm$core$Dict$get,
									dependency.kH.rE,
									$author$project$Model$BuildDataSource$getComponentsByDirectNodeId(buildDataSource))));
					},
					buildData);
			} else {
				var toPair = function (version) {
					var vulnKey = A2($author$project$Model$Vulnerability$fromNamespaceKey, key, version.sL);
					var vulns = A2(
						$author$project$Model$NormsAndVulns$getVulnerabilities,
						parentModel.rF,
						$author$project$Model$NormsAndVulns$NamespacedVulnKey(vulnKey));
					return A2(
						$krisajenkins$remotedata$RemoteData$map,
						$elm$core$Tuple$pair(version.sL),
						A2($krisajenkins$remotedata$RemoteData$mapError, $author$project$Model$BuildPlanner$BuildPlannerError$HttpError, vulns));
				};
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$elm$core$List$filter(
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$second,
							$elm$core$Basics$neq(_List_Nil))),
					$krisajenkins$remotedata$RemoteData$fromList(
						A2($elm$core$List$map, toPair, versions)));
			}
		}();
		var cves = A2(
			$krisajenkins$remotedata$RemoteData$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$concatMap($elm$core$Tuple$second),
				A2(
					$elm$core$Basics$composeR,
					$elm_community$list_extra$List$Extra$uniqueBy(
						function ($) {
							return $.B9;
						}),
					$elm$core$List$sortBy($author$project$Model$Vulnerability$sortKey))),
			versionsAndVulnerabilities);
		var activeTab = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Views$Dependencies$defaultTab,
			A2($elm$core$Dict$get, key, model.nY));
		var _v0 = function () {
			switch (effectiveStatus.$) {
				case 0:
					return _Utils_Tuple3('package-requested', 'Added', defaultPinDependencyText);
				case 2:
					return _Utils_Tuple3('package-removed', 'No longer needed', 'Keep');
				case 1:
					return _Utils_Tuple3('package-updated', '', defaultPinDependencyText);
				default:
					return _Utils_Tuple3('package-unchanged', '', defaultPinDependencyText);
			}
		}();
		var statusStyle = _v0.a;
		var statusText = _v0.b;
		var pinDependencyText = _v0.c;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(statusStyle),
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Views$Dependencies$ExpandMsg,
						A4(
							$author$project$Views$NamespaceExpand$caret,
							parentModel.x$,
							key,
							{
								F5: !_Utils_eq(effectiveStatus, $author$project$Model$Editor$Removed)
							},
							_List_fromArray(
								[
									statusLabel,
									A2($author$project$Views$Dependencies$viewNamespaceKey, flags, key),
									A2(
									$author$project$Misc$displayIf,
									$elm$core$List$length(versions) > 1,
									A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('more-info-tooltip')
											]),
										_List_fromArray(
											[
												$author$project$Views$Icon$view(
												$author$project$Views$Icon$icon(52)),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('content')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$h4,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Why are there multiple versions?')
															])),
														A2(
														$elm$html$Html$p,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Sometimes, when you have multiple platforms in your project, a different version is selected for each platform.')
															])),
														A2(
														$elm$html$Html$p,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('To find out which version a platform uses, find this package in the list on the Download Builds tab.')
															]))
													]))
											]))),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('item-version')
										]),
									_Utils_ap(
										A2($elm$core$List$map, versionEl, versions),
										_List_fromArray(
											[oldVersionEl])))
								]))),
						function () {
						switch (dependencies.$) {
							case 3:
								var related = dependencies.a;
								return $author$project$Views$RelatedPackages$countView(related);
							case 2:
								return $elm$html$Html$text('');
							case 1:
								return $author$project$Views$Loading$dots;
							default:
								return $elm$html$Html$text('');
						}
					}(),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('package-cve-summary')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Views$PackageSummaryDisplay$choose,
								parentModel.rO,
								{
									EH: function (_v3) {
										return A2(
											$elm$html$Html$map,
											$author$project$Views$Dependencies$ExpandMsg,
											A5($author$project$Views$CVEs$viewForPackage, flags, parentModel.x$, key, false, cves));
									},
									EM: function (_v4) {
										return A2(
											$elm$html$Html$map,
											$author$project$Views$Dependencies$LicensesMsg,
											A4(
												$author$project$Views$Licenses$viewForPackage,
												flags,
												parentModel.rn,
												key,
												$krisajenkins$remotedata$RemoteData$Success(versionData.go)));
									}
								})
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('item-status')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('change-status')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(statusText)
									])),
								A2(
								$author$project$Misc$displayIf,
								!flags.Fw,
								A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('item-actions')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('button-with-tooltip')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$button,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('add-to-requested secondary-button small'),
															$elm$html$Html$Events$onClick(clickMsg)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(pinDependencyText)
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('tooltip')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Add this dependency to the '),
															A2(
															$elm$html$Html$strong,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Required Packages')
																])),
															$elm$html$Html$text(' list.')
														]))
												]))
										])))
							]))
					])),
				A2(
				$author$project$Misc$displayIf,
				isExpanded && (!_Utils_eq(effectiveStatus, $author$project$Model$Editor$Removed)),
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('item-meta-data')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('tabs')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('active', activeTab === 2)
												])),
											$elm$html$Html$Events$onClick(
											A2($author$project$Views$Dependencies$SelectTab, key, 2))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Required By')
										])),
									A2(
									$author$project$Misc$displayIf,
									hasAnyItemsToShow(cves) && flags.Ca,
									A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2('active', !activeTab)
													])),
												$elm$html$Html$Events$onClick(
												A2($author$project$Views$Dependencies$SelectTab, key, 0))
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Vulnerabilities')
													]))
											]))),
									A2(
									$author$project$Misc$displayIf,
									hasAnyItemsToShow(dependencies),
									A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2('active', activeTab === 1)
													])),
												$elm$html$Html$Events$onClick(
												A2($author$project$Views$Dependencies$SelectTab, key, 1))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Dependencies')
											])))
								])),
							A2(
							$author$project$Misc$displayIf,
							flags.Ca && (isExpanded && (!activeTab)),
							function () {
								if (versionsAndVulnerabilities.$ === 3) {
									var vulnsByVersion = versionsAndVulnerabilities.a;
									return (!$elm$core$List$isEmpty(vulnsByVersion)) ? A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('package-cve-details')
											]),
										A2(
											$elm$core$List$map,
											$elm_community$basics_extra$Basics$Extra$uncurry(viewVersionVulns),
											vulnsByVersion)) : $elm$html$Html$text('');
								} else {
									return $elm$html$Html$text('');
								}
							}()),
							A2(
							$author$project$Misc$displayIf,
							isExpanded && (activeTab === 2),
							function () {
								switch (requiredBys.$) {
									case 3:
										var related = requiredBys.a;
										return $author$project$Views$RelatedPackages$view(
											{Ca: flags.Ca, mp: 0, zO: related});
									case 2:
										var buildPlannerError = requiredBys.a;
										return A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('section-header')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Model$BuildPlanner$BuildPlannerError$message(buildPlannerError))
												]));
									case 1:
										return $author$project$Views$Loading$dots;
									default:
										return $elm$html$Html$text('');
								}
							}()),
							A2(
							$author$project$Misc$displayIf,
							isExpanded && (activeTab === 1),
							function () {
								switch (dependencies.$) {
									case 3:
										var related = dependencies.a;
										return $author$project$Views$RelatedPackages$view(
											{Ca: flags.Ca, mp: 1, zO: related});
									case 2:
										var buildPlannerError = dependencies.a;
										return A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('section-header')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Model$BuildPlanner$BuildPlannerError$message(buildPlannerError))
												]));
									case 1:
										return $author$project$Views$Loading$dots;
									default:
										return $elm$html$Html$text('');
								}
							}())
						])))
			]);
	});
var $author$project$Views$Dependencies$viewMoreInfoTooltip = function (content) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('more-info-tooltip')
			]),
		_List_fromArray(
			[
				$author$project$Views$Icon$view(
				$author$project$Views$Icon$icon(52)),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('content')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(content)
							]))
					]))
			]));
};
var $author$project$Views$Dependencies$viewDependencies = F4(
	function (flags, model, parentModel, dependencies) {
		var viewCategory = function (_v0) {
			var category = _v0.a;
			var deps = _v0.b;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('package-table-header-row'),
								$elm$html$Html$Attributes$class(category)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('section-header')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h3,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('language-name')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(category)
													])),
												A2(
												$author$project$Misc$displayMaybe,
												$author$project$Views$Dependencies$viewMoreInfoTooltip,
												$author$project$Views$Dependencies$getCategoryTooltip(category))
											]))
									]))
							])),
					$elm$core$List$concat(
						A2(
							$elm$core$List$map,
							A3($author$project$Views$Dependencies$viewDependency, flags, model, parentModel),
							deps))));
		};
		var sortedDependencies = A2($elm$core$List$sortWith, $author$project$Model$BuildExprEditorUtils$categorySorter, dependencies);
		return $elm$core$List$isEmpty(dependencies) ? A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('solution-no-dependencies')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('No dependencies are needed for this project.')
				])) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('package-table package-list dependencies-table')
				]),
			A2($elm$core$List$map, viewCategory, sortedDependencies));
	});
var $author$project$Views$Dependencies$view = F3(
	function (flags, model, parentModel) {
		var isRemoved = function (dep) {
			return _Utils_eq(dep.L, $author$project$Model$Editor$Removed);
		};
		var isChanged = function (dep) {
			return _Utils_eq(dep.L, $author$project$Model$Editor$Unchanged) ? false : (_Utils_eq(
				$author$project$Views$Dependencies$getEndUserFacingStatus(dep),
				$author$project$Model$Editor$Unchanged) ? flags.Gm : true);
		};
		var dependencies = $elm$core$Dict$toList(
			$author$project$Views$Dependencies$categorizedDependencies(parentModel));
		var totalDependencyCount = A3(
			$elm$core$List$foldl,
			F2(
				function (_v7, acc) {
					var deps = _v7.b;
					return acc + A2(
						$elm_community$list_extra$List$Extra$count,
						A2($elm$core$Basics$composeR, isRemoved, $elm$core$Basics$not),
						deps);
				}),
			0,
			dependencies);
		var changedDependencies = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Tuple$second,
				A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not)),
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$mapSecond(
					$elm$core$List$filter(isChanged)),
				dependencies));
		var changedCount = A3(
			$elm$core$List$foldl,
			F2(
				function (_v6, acc) {
					var deps = _v6.b;
					return acc + $elm$core$List$length(deps);
				}),
			0,
			changedDependencies);
		var dependenciesToView = (model.lG && (changedCount > 0)) ? changedDependencies : dependencies;
		var dependenciesView = function (depsReadOnly) {
			return A4(
				$author$project$Views$Dependencies$viewDependencies,
				_Utils_update(
					flags,
					{Fw: depsReadOnly}),
				model,
				parentModel,
				dependenciesToView);
		};
		var changeIndicator = function (buildDataState) {
			var loadingElement = function (string) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('solution-loading')
						]),
					_List_fromArray(
						[
							$author$project$Views$Loading$dots,
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(string)
								]))
						]));
			};
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('change-summary')
					]),
				function () {
					switch (buildDataState) {
						case 0:
							return _List_fromArray(
								[
									loadingElement('Loading dependencies')
								]);
						case 1:
							return _List_fromArray(
								[
									loadingElement('Resolving dependencies')
								]);
						default:
							return (changedCount > 0) ? _List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('change-count')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A3($elm_community$string_extra$String$Extra$pluralize, 'Change', 'Changes', changedCount))
										])),
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$type_('checkbox'),
													$elm$html$Html$Attributes$checked(model.lG),
													$elm$html$Html$Events$onClick($author$project$Views$Dependencies$ToggleDisplayOnlyChanges)
												]),
											_List_Nil),
											$elm$html$Html$text('Only show changes')
										]))
								]) : ((!$elm$core$List$isEmpty(dependencies)) ? _List_fromArray(
								[
									$elm$html$Html$text('No changes to dependencies needed')
								]) : _List_fromArray(
								[
									$elm$html$Html$text('')
								]));
					}
				}());
		};
		var addAllToRequestedButton = (flags.Fc && (!$elm$core$List$isEmpty(dependencies))) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button-with-tooltip set-all-as-requested')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('secondary-button small'),
							function () {
							var packages = A2(
								$elm$core$List$map,
								function (_v4) {
									var value = _v4.kH;
									return {
										bK: $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$Exact(
											$mgold$elm_nonempty_list$List$Nonempty$head(value.e$).sL),
										Y: value.j9
									};
								},
								A2($elm$core$List$concatMap, $elm$core$Tuple$second, dependencies));
							return $elm$html$Html$Events$onClick(
								$author$project$Views$Dependencies$AddRequirements(packages));
						}()
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Set all as Required')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tooltip')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('All current dependencies will be set as '),
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Required Packages')
								])),
							$elm$html$Html$text(' instead.')
						]))
				])) : $elm$html$Html$text('');
		var header = F3(
			function (txt, showCount, showPinAll) {
				return A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(txt),
							A2(
							$author$project$Misc$displayIf,
							showCount,
							A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('item-count')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(totalDependencyCount))
									]))),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('more-info-tooltip')
								]),
							_List_fromArray(
								[
									$author$project$Views$Icon$view(
									$author$project$Views$Icon$icon(52)),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('content')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('These packages are automatically added to your build because they are needed by the '),
													A2(
													$elm$html$Html$strong,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Requested Packages')
														])),
													$elm$html$Html$text(' that were specified for this project.')
												]))
										]))
								])),
							A2(
							$author$project$Misc$displayIf,
							showPinAll,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('header-actions')
									]),
								_List_fromArray(
									[addAllToRequestedButton])))
						]));
			});
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('new-box solution-section'),
					$elm$html$Html$Attributes$id($author$project$Views$Dependencies$solutionSectionId)
				]),
			function () {
				var _v0 = parentModel.Cu;
				switch (_v0.$) {
					case 3:
						var _v1 = parentModel.Ep;
						switch (_v1.$) {
							case 0:
								return _List_fromArray(
									[
										A3(header, 'Dependencies', true, true),
										dependenciesView(flags.Fw)
									]);
							case 1:
								return _List_fromArray(
									[
										A3(header, 'Dependencies', false, false),
										changeIndicator(1)
									]);
							case 2:
								return _List_fromArray(
									[
										$author$project$Views$Dependencies$errorsView,
										A3(header, 'Previous Dependencies', true, false),
										dependenciesView(true)
									]);
							default:
								return _List_fromArray(
									[
										A3(header, 'Dependencies', true, true),
										changeIndicator(2),
										dependenciesView(flags.Fw)
									]);
						}
					case 2:
						var _v2 = parentModel.Ep;
						switch (_v2.$) {
							case 0:
								return _List_fromArray(
									[
										A3(header, 'Dependencies', false, true),
										$author$project$Views$Dependencies$errorsView
									]);
							case 1:
								return _List_fromArray(
									[
										A3(header, 'Dependencies', false, true),
										changeIndicator(1)
									]);
							case 2:
								return _List_fromArray(
									[
										A3(header, 'Dependencies', false, true),
										$author$project$Views$Dependencies$errorsView
									]);
							default:
								return _List_fromArray(
									[
										A3(header, 'Dependencies', true, false),
										changeIndicator(2),
										dependenciesView(flags.Fw)
									]);
						}
					default:
						var _v3 = parentModel.Ep;
						switch (_v3.$) {
							case 0:
								return _List_fromArray(
									[
										A3(header, 'Dependencies', false, false),
										changeIndicator(0)
									]);
							case 1:
								return _List_fromArray(
									[
										A3(header, 'Dependencies', false, false),
										changeIndicator(1)
									]);
							case 2:
								return _List_fromArray(
									[
										A3(header, 'Dependencies', false, false),
										$author$project$Views$Dependencies$errorsView
									]);
							default:
								return _List_fromArray(
									[
										A3(header, 'Dependencies', true, true),
										dependenciesView(flags.Fw)
									]);
						}
				}
			}());
	});
var $author$project$Views$StateTool$convertHeadlessInstructions = F2(
	function (orgName, projectName) {
		return 'state pull --set-project ' + (orgName + ('/' + projectName));
	});
var $author$project$Views$FromCommitPopup$view = F5(
	function (dismiss, orgName, projectName, copyStatus, copyClipboardMsg) {
		var inputID = 'replace-command';
		var linkCommand = A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Run in your terminal')
						])),
					$author$project$Views$CliText$view(
					{
						B$: $elm$core$Maybe$Just(
							{Em: copyClipboardMsg, L: copyStatus}),
						l6: inputID,
						Gv: A2($author$project$Views$StateTool$convertHeadlessInstructions, orgName, projectName)
					})
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('little-modal link-project-modal')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('checkbox'),
									$elm$html$Html$Attributes$id('content-toggle')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('step step-1')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h2,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Welcome to your new Runtime!')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('It contains the runtime details like the '),
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(' language, platform & packages ')
												])),
											$elm$html$Html$text('that you may have specified on your command line.')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('First, let\'s link this new project to the one on your command line.')
										])),
									linkCommand
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('step step-2')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h2,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Now, using the Platform UI you can...')
										])),
									A2(
									$elm$html$Html$ul,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$li,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Add and remove packages, platform & languages.')
												])),
											A2(
											$elm$html$Html$li,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Download updated builds from the Download Builds tab.')
												])),
											A2(
											$elm$html$Html$li,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Share your runtime with others to make collaboration easier.')
												])),
											A2(
											$elm$html$Html$li,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Create brand new runtimes for your other projects.')
												]))
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('After making changes, run '),
											A2(
											$elm$html$Html$strong,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('cli-text-inline')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('state pull')
												])),
											$elm$html$Html$text(' in your terminal to update your local environment. '),
											$elm$html$Html$text('Once this project is linked, changes you make on the command line will be automatically synced with the Platform.')
										]))
								])),
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$for('content-toggle'),
									$elm$html$Html$Attributes$class('next-step')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('button'),
											$elm$html$Html$Attributes$class('primary-button')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Next →')
										]))
								])),
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$for('content-toggle'),
									$elm$html$Html$Attributes$class('previous-step')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('button'),
											$elm$html$Html$Attributes$class('secondary-button')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('← Previous')
										]))
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(dismiss),
									$elm$html$Html$Attributes$class('primary-button')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('OK, Got it!')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('image link-project')
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Views$ImportPackagesModal$CloseModal = {$: 7};
var $author$project$Views$Modal$Dismiss = 0;
var $author$project$Views$ImportPackagesModal$Import = {$: 3};
var $author$project$Views$ImportPackagesModal$OpenFileSelector = {$: 8};
var $author$project$Views$ImportPackagesModal$importTextInput = F2(
	function (language, importText) {
		return A2(
			$elm$html$Html$textarea,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('import-textarea'),
					$elm$html$Html$Attributes$id($author$project$Views$ImportPackagesModal$initialFocusID),
					$elm$html$Html$Attributes$value(importText),
					$elm$html$Html$Events$onInput($author$project$Views$ImportPackagesModal$UpdateImportText),
					$elm$html$Html$Attributes$spellcheck(false),
					$elm$html$Html$Attributes$placeholder(
					function () {
						switch (language) {
							case 0:
								return '# Sample content\nrequires \'DateTime\', \'>1.00, <1.52\';\nrequires \'Try::Tiny\', \'>=0.30\';\nrequires \'LWP\', \'>6\';';
							case 1:
								return '# Sample content\nnumpy==1.18.1\nrequests>2\nPillow>=6.5';
							case 3:
								return '# Sample content\nGEM\n  remote: https://rubygems.org/\n  specs:\n    diff-lcs (1.5.1)\n    nokogiri (1.16.6-x86_64-linux)\n      racc (~> 1.4)\n    racc (1.8.0)\n    rack (2.2.9)\n    rspec (3.13.0)\n      rspec-core (~> 3.13.0)\n      rspec-expectations (~> 3.13.0)\n      rspec-mocks (~> 3.13.0)\n    rspec-core (3.13.0)\n      rspec-support (~> 3.13.0)\n    rspec-expectations (3.13.1)\n      diff-lcs (>= 1.2.0, < 2.0)\n      rspec-support (~> 3.13.0)\n    rspec-mocks (3.13.1)\n      diff-lcs (>= 1.2.0, < 2.0)\n      rspec-support (~> 3.13.0)\n    rspec-support (3.13.1)\n\nPLATFORMS\n  x86_64-linux\n\nDEPENDENCIES\n  nokogiri\n  rack (~> 2.2.4)\n  rspec\n\nBUNDLED WITH\n   2.3.5';
							default:
								return '';
						}
					}())
				]),
			_List_Nil);
	});
var $author$project$Views$ImportPackagesModal$viewImportScreen = F2(
	function (language, importText) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('import-sections')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('import-section file-contents')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('section-title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('File Contents')
								])),
							A2($author$project$Views$ImportPackagesModal$importTextInput, language, importText),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('section-cta')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('submit'),
											$elm$html$Html$Events$onClick($author$project$Views$ImportPackagesModal$Import),
											$elm$html$Html$Attributes$disabled(
											$elm$core$String$isEmpty(importText)),
											$elm$html$Html$Attributes$class('primary-button'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'disabled',
													$elm$core$String$isEmpty(importText))
												]))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Import')
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('secondary-button'),
											$elm$html$Html$Events$onClick($author$project$Views$ImportPackagesModal$OpenFileSelector)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Choose File')
										]))
								]))
						]))
				]));
	});
var $author$project$Views$ImportPackagesModal$AddDetectedPackages = {$: 5};
var $author$project$Views$ImportPackagesModal$SetScreen = function (a) {
	return {$: 6, a: a};
};
var $author$project$Views$ImportPackagesModal$viewCollapsible = F5(
	function (nextScreen, title, className, contents, isExpanded) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('expanded', isExpanded)
						])),
					$elm$html$Html$Attributes$class(className)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('toggle-wrapper'),
							$elm$html$Html$Events$onClick(
							$author$project$Views$ImportPackagesModal$SetScreen(nextScreen))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('toggle-icon'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('expanded', isExpanded)
										]))
								]),
							_List_fromArray(
								[
									$author$project$Views$Icon$view(
									$author$project$Views$Icon$icon(13))
								])),
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								]))
						])),
					A2($author$project$Misc$displayIf, isExpanded, contents)
				]));
	});
var $author$project$Views$ImportPackagesModal$viewErrors = F2(
	function (className, errorMessages) {
		return A2(
			$author$project$Misc$displayIf,
			!$elm$core$List$isEmpty(errorMessages),
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('import_packages_errors'),
						$elm$html$Html$Attributes$class(className)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('We ran into the following issues parsing your file. Edit the file contents and try again.')
							])),
						A2(
						$elm$html$Html$ul,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (error) {
								return (error.zB === '') ? A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(error.ye)
										])) : A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$strong,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('error-text')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(error.zB)
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('error-divider')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('-')
												])),
											$elm$html$Html$text(error.ye)
										]));
							},
							errorMessages))
					])));
	});
var $author$project$Views$ImportPackagesModal$viewPackages = function (packages) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('toggle-section')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$ul,
				_List_Nil,
				A2(
					$elm$core$List$map,
					function (requirement) {
						return A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Model$Namespace$getName(requirement.Y)),
									$elm$html$Html$text(' '),
									$elm$html$Html$text(
									function () {
										var _v0 = requirement.bK;
										switch (_v0.$) {
											case 0:
												return '';
											case 1:
												var version = _v0.a;
												return version;
											case 2:
												var first = _v0.a;
												var others = _v0.b;
												return A2($author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$toPythonSyntax, first, others);
											default:
												return '';
										}
									}())
								]));
					},
					packages))
			]));
};
var $author$project$Views$ImportPackagesModal$viewReviewScreen = F3(
	function (options, language, model) {
		var hasErrors = !$elm$core$List$isEmpty(model.eP.mb);
		var foundPackages = !$elm$core$List$isEmpty(model.eP.CV);
		var packages = A2(
			$author$project$Misc$displayIf,
			foundPackages,
			A5(
				$author$project$Views$ImportPackagesModal$viewCollapsible,
				$author$project$Views$ImportPackagesModal$ReviewResults(
					_Utils_update(
						options,
						{ox: !options.ox})),
				A3(
					$elm_community$string_extra$String$Extra$pluralize,
					'package',
					'packages',
					$elm$core$List$length(model.eP.CV)),
				'import-successes',
				$author$project$Views$ImportPackagesModal$viewPackages(model.eP.CV),
				options.ox));
		var errors = A2(
			$author$project$Misc$displayIf,
			hasErrors,
			A5(
				$author$project$Views$ImportPackagesModal$viewCollapsible,
				$author$project$Views$ImportPackagesModal$ReviewResults(
					_Utils_update(
						options,
						{ow: !options.ow})),
				A3(
					$elm_community$string_extra$String$Extra$pluralize,
					'issue',
					'issues',
					$elm$core$List$length(model.eP.mb)),
				'import-errors',
				A2($author$project$Views$ImportPackagesModal$viewErrors, 'toggle-section', model.eP.mb),
				options.ow));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('import-sections')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('import-section file-contents')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('File Contents')
								])),
							A2($author$project$Views$ImportPackagesModal$importTextInput, language, model.eP.ja),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('section-cta')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('submit'),
											$elm$html$Html$Events$onClick($author$project$Views$ImportPackagesModal$Import),
											$elm$html$Html$Attributes$disabled(
											$elm$core$String$isEmpty(model.eP.ja)),
											$elm$html$Html$Attributes$class('secondary-button'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'disabled',
													$elm$core$String$isEmpty(model.eP.ja))
												]))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Retry Import')
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('secondary-button'),
											$elm$html$Html$Events$onClick($author$project$Views$ImportPackagesModal$OpenFileSelector)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Choose File')
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('import-section results-section')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Results')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('scrolling-content')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Misc$displayIf,
									!foundPackages,
									A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('missing-package-message')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Oops! It looks like the file you pasted does not contain any packages!')
											]))),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[packages, errors])),
									A2(
									$author$project$Misc$displayIf,
									foundPackages,
									A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('section-cta')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$type_('submit'),
														$elm$html$Html$Events$onClick($author$project$Views$ImportPackagesModal$AddDetectedPackages),
														$elm$html$Html$Attributes$class('primary-button')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Add detected packages')
													]))
											])))
								]))
						]))
				]));
	});
var $author$project$Views$ImportPackagesModal$screenBody = F2(
	function (language, model) {
		var _v0 = model.eP.no;
		if (!_v0.$) {
			return A2($author$project$Views$ImportPackagesModal$viewImportScreen, language, model.eP.ja);
		} else {
			var options = _v0.a;
			return A3($author$project$Views$ImportPackagesModal$viewReviewScreen, options, language, model);
		}
	});
var $author$project$Views$ImportPackagesModal$tabBody = F2(
	function (language, model) {
		return A2(
			$author$project$Misc$displayMaybe,
			function (formats) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex-fill')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							A2(
								$elm$core$List$cons,
								$elm$html$Html$text('Paste the contents of your '),
								_Utils_ap(
									$mgold$elm_nonempty_list$List$Nonempty$toList(formats),
									_List_fromArray(
										[
											$elm$html$Html$text(' file. To upload a file, click '),
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Choose File')
												])),
											$elm$html$Html$text(' below.')
										])))),
							A2($author$project$Views$ImportPackagesModal$screenBody, language, model)
						]));
			},
			$author$project$Model$PackageImport$viewLanguageSupportedFileFormats(language));
	});
var $author$project$Views$ImportPackagesModal$SelectLanguageTab = function (a) {
	return {$: 10, a: a};
};
var $author$project$Views$ImportPackagesModal$viewTab = F2(
	function (selected, rendering) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'selected',
							_Utils_eq(selected, rendering))
						])),
					$elm$html$Html$Events$onClick(
					$author$project$Views$ImportPackagesModal$SelectLanguageTab(rendering))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Model$Language$toDisplayString(rendering))
				]));
	});
var $author$project$Views$ImportPackagesModal$viewContent = F2(
	function (model, parentModel) {
		var modalClass = model.pE ? 'loading' : 'presearch';
		var _v0 = model.iG;
		if (!_v0.$) {
			var language = _v0.a;
			var importableLanguages = $author$project$Model$BuildPlanner$SolveLegacyEditor$getImportableLanguages(parentModel.qR);
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(modalClass),
						$elm$html$Html$Attributes$class('flex-fill')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Import Packages')
							])),
						A2(
						$author$project$Misc$displayIf,
						$elm$core$List$length(importableLanguages) > 1,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('section-tabs')
								]),
							A2(
								$elm$core$List$map,
								$author$project$Views$ImportPackagesModal$viewTab(language),
								importableLanguages))),
						A2($author$project$Views$ImportPackagesModal$tabBody, language, model)
					]));
		} else {
			return A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Importing packages is not currently supported for any of the languages in your project.')
					]));
		}
	});
var $author$project$Views$ImportPackagesModal$view = F2(
	function (model, parentModel) {
		return $author$project$Views$Modal$view(
			{
				BD: 'import-packages',
				BI: $author$project$Views$ImportPackagesModal$CloseModal,
				dH: A2($author$project$Views$ImportPackagesModal$viewContent, model, parentModel),
				x4: A2($author$project$Views$Modal$DismissButtonVisible, 0, true)
			});
	});
var $author$project$Views$LanguageSelectionModal$CloseModal = {$: 3};
var $author$project$Views$LanguageSelectionModal$AddLanguage = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Views$LanguageSelectionModal$RemoveLanguage = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Views$LanguageSelectionModal$UpdateLanguage = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Views$LanguageSelectionModal$get = F3(
	function (language, editor, accessModel) {
		var currentSelection = A2(
			$elm$core$Dict$get,
			$author$project$Model$LanguageVersions$getName(language),
			$author$project$Model$BuildPlanner$SolveLegacyEditor$getLanguages(editor));
		return {
			uz: currentSelection,
			e$: A2($author$project$Model$LanguageVersions$getVersions, accessModel, language)
		};
	});
var $author$project$Model$BuildPlanner$BuildExpr$SolveEditor$languagesGetter = function (_v0) {
	var requirements = _v0.FF;
	return requirements.aM;
};
var $author$project$Model$BuildPlanner$BuildExpr$SolveEditor$languageConstraintGetter = F2(
	function (languageName, fields) {
		return A2(
			$elm$core$Dict$get,
			languageName,
			$author$project$Model$BuildPlanner$BuildExpr$SolveEditor$languagesGetter(fields));
	});
var $author$project$Model$BuildPlanner$BuildExpr$SolveEditor$getLanguageConstraintOriginal = function (languageName) {
	return $author$project$Model$Editor$getFieldOriginal(
		$author$project$Model$BuildPlanner$BuildExpr$SolveEditor$languageConstraintGetter(languageName));
};
var $author$project$Model$BuildPlanner$SolveLegacyEditor$getLanguageConstraintOriginal = function (language) {
	return $author$project$Model$BuildPlanner$SolveLegacyEditor$getBuildExprSolveEditor(
		$author$project$Model$BuildPlanner$BuildExpr$SolveEditor$getLanguageConstraintOriginal(language));
};
var $author$project$Model$LanguageVersions$recommendedLanguageVersion = function (language) {
	switch (language) {
		case 0:
			return $author$project$Model$VersionString$toString($author$project$Model$LanguageVersions$Perl$supportDict.hO);
		case 1:
			return $author$project$Model$VersionString$toString($author$project$Model$LanguageVersions$Python$supportDict.hO);
		case 2:
			return $author$project$Model$VersionString$toString($author$project$Model$LanguageVersions$Tcl$supportDict.hO);
		case 3:
			return $author$project$Model$VersionString$toString($author$project$Model$LanguageVersions$Ruby$supportDict.hO);
		default:
			return '0.0.0';
	}
};
var $author$project$Views$LanguageSelectionModal$getRecommendedVersion = A2(
	$elm$core$Basics$composeR,
	$author$project$Model$LanguageVersions$getMaybeLanguage,
	$elm$core$Maybe$map($author$project$Model$LanguageVersions$recommendedLanguageVersion));
var $author$project$Model$Language$isPublic = A2($elm$core$Basics$composeR, $author$project$Model$Language$fromString, $elm_community$maybe_extra$Maybe$Extra$isJust);
var $author$project$Views$LanguageSelectionModal$viewDropdownOption = F2(
	function (_v0, version) {
		var accessModel = _v0.AY;
		var isSelectedFn = _v0.uo;
		var languageVersions = _v0.ut;
		var recommendedVersion = _v0.vV;
		var superuserSuffix = A3($author$project$Model$LanguageVersions$isShownOnlyToSuperusers, accessModel, languageVersions, version) ? (accessModel.rj ? $author$project$Views$Superuser$suffix : ' - Unavailable') : '';
		var recommendedSuffix = _Utils_eq(version, recommendedVersion) ? ' - Recommended' : '';
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$selected(
					isSelectedFn(version)),
					$elm$html$Html$Attributes$value(version)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					_Utils_ap(
						version,
						_Utils_ap(recommendedSuffix, superuserSuffix)))
				]));
	});
var $author$project$Views$LanguageSelectionModal$languageOptionSimpleView = F3(
	function (editor, accessModel, language) {
		var languageName = $author$project$Model$LanguageVersions$getName(language);
		var isRowSuperUserOnly = !$author$project$Model$Language$isPublic(languageName);
		var defaultSelection = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Model$LanguageVersions$getSelected(language),
			$author$project$Views$LanguageSelectionModal$getRecommendedVersion(language));
		var _v0 = A3($author$project$Views$LanguageSelectionModal$get, language, editor, accessModel);
		var versions = _v0.e$;
		var maybeCurrentConstraint = _v0.uz;
		var maybeSelectedVersionString = A2($elm$core$Maybe$andThen, $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$getExact, maybeCurrentConstraint);
		var actionBtn = function () {
			if (!maybeSelectedVersionString.$) {
				var version = maybeSelectedVersionString.a;
				return accessModel.oS ? A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Attributes$class('secondary-button'),
							A2(
							$author$project$Misc$attributeIf,
							accessModel.oS && (!isRowSuperUserOnly),
							$elm$html$Html$Attributes$class('superuser-only')),
							$elm$html$Html$Events$onClick(
							A2($author$project$Views$LanguageSelectionModal$RemoveLanguage, languageName, version))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Remove')
						])) : $elm$html$Html$text('');
			} else {
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Attributes$class('secondary-button'),
							A2(
							$author$project$Misc$attributeIf,
							accessModel.oS && (!isRowSuperUserOnly),
							$elm$html$Html$Attributes$class('superuser-only')),
							$elm$html$Html$Events$onClick(
							A2($author$project$Views$LanguageSelectionModal$AddLanguage, languageName, defaultSelection))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Add')
						]));
			}
		}();
		var config = {
			AY: accessModel,
			uo: $elm$core$Basics$eq(
				A2($elm$core$Maybe$withDefault, defaultSelection, maybeSelectedVersionString)),
			ut: language,
			vV: defaultSelection
		};
		var displayVersions = function () {
			if (!maybeSelectedVersionString.$) {
				var version = maybeSelectedVersionString.a;
				return A2($elm$core$List$member, version, versions) ? versions : A2($elm$core$List$cons, version, versions);
			} else {
				return versions;
			}
		}();
		var selectedInaccessibleVersion = function () {
			var _v1 = A2($author$project$Model$BuildPlanner$SolveLegacyEditor$getLanguageConstraintOriginal, languageName, editor);
			if ((!_v1.$) && (_v1.a.$ === 1)) {
				var originalVersion = _v1.a.a;
				return A2(
					$elm$core$List$any,
					$elm$core$Basics$eq(originalVersion),
					versions) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(originalVersion);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('language-option-border')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('language-option'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('superuser-only', isRowSuperUserOnly)
								])),
							$elm$html$Html$Attributes$class(languageName)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(languageName)
								])),
							A2(
							$elm$html$Html$select,
							_List_fromArray(
								[
									$elm$html$Html$Events$onInput(
									$author$project$Views$LanguageSelectionModal$UpdateLanguage(languageName))
								]),
							A2(
								$elm$core$List$map,
								$author$project$Views$LanguageSelectionModal$viewDropdownOption(config),
								displayVersions)),
							actionBtn
						])),
					A2(
					$author$project$Misc$displayMaybe,
					function (version) {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('shadow extra-padding version-warning top-margin')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('This organization no longer has access to create ' + (version + ' projects, so you cannot reselect it if you change the version here. Please upgrade your subscription for continued access to this and other legacy versions.'))
										]))
								]));
					},
					selectedInaccessibleVersion)
				]));
	});
var $author$project$Views$LanguageSelectionModal$viewContent = F3(
	function (editor, accessModel, languages) {
		var languageOptionsList = A2(
			$elm$core$List$map,
			A2($author$project$Views$LanguageSelectionModal$languageOptionSimpleView, editor, accessModel),
			languages);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('language-selector')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Language')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('language-list')
						]),
					languageOptionsList)
				]));
	});
var $author$project$Views$LanguageSelectionModal$view = F3(
	function (session, model, parentModel) {
		var currentLanguages = $elm$core$Dict$keys(
			$author$project$Model$BuildPlanner$SolveLegacyEditor$getLanguages(model.qR));
		var accessModel = A2($author$project$Model$LanguageVersions$createAccessModel, session, parentModel.c3);
		var filteredLanguages = A2(
			$elm$core$List$filter,
			function (lang) {
				return accessModel.oS || A2(
					$elm$core$List$any,
					$elm$core$Basics$eq(
						$author$project$Model$LanguageVersions$getName(lang)),
					currentLanguages);
			},
			$elm$core$Dict$values(parentModel.jF));
		return $author$project$Views$Modal$view(
			{
				BD: 'languages',
				BI: $author$project$Views$LanguageSelectionModal$CloseModal,
				dH: A3($author$project$Views$LanguageSelectionModal$viewContent, model.qR, accessModel, filteredLanguages),
				x4: A2($author$project$Views$Modal$DismissButtonVisible, 0, true)
			});
	});
var $author$project$Views$NewForkPopup$view = F2(
	function (dismiss, forkedFrom) {
		var forkMessage = function () {
			if (forkedFrom.$ === 2) {
				var project = forkedFrom.a.c5;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('We added your very own copy of the '),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('project-name')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(project)
										])),
									$elm$html$Html$text(' project to your account.')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('When the original project changes, we\'ll give you the option to keep your copy up to date.')
								]))
						]));
			} else {
				return A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('We added your very own copy of the project to your account. When the original project changes, we\'ll give you the option to keep your copy up to date.')
						]));
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('little-modal fork-modal')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Your project is ready!')
								])),
							forkMessage,
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(dismiss),
									$elm$html$Html$Attributes$class('primary-button')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('OK, Got it!')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button-wrapper')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('image fork-project')
										]),
									_List_Nil)
								]))
						]))
				]));
	});
var $author$project$Views$PlanningErrorNotice$errorToList = function (error) {
	switch (error.$) {
		case 0:
			return _List_fromArray(
				['There was an error processing your request. Please try again later.']);
		case 7:
			var planningError = error.a;
			return A2(
				$elm$core$List$concatMap,
				$author$project$Model$BuildPlanner$Error$BuildExprError$errorMessages,
				$author$project$Model$BuildPlanner$Error$PlanningError$subErrors(planningError));
		default:
			return _List_Nil;
	}
};
var $author$project$Views$PlanningErrorNotice$errorToMessage = function (error) {
	switch (error.$) {
		case 0:
			return 'There are some problems preventing the builds from running...';
		case 7:
			var planningError = error.a;
			return $author$project$Model$BuildPlanner$Error$PlanningError$message(planningError);
		default:
			return $author$project$Model$BuildPlanner$BuildPlannerError$message(error);
	}
};
var $author$project$Model$BuildPlanner$Error$BuildExprError$getRemediableSolveError = function (buildExprError) {
	if (buildExprError.$ === 3) {
		var err = buildExprError.a;
		return $elm$core$Maybe$Just(err);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Views$PlanningErrorNotice$getFirstRemediableSolveError = function (error) {
	if (error.$ === 7) {
		var planningError = error.a;
		return $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				$author$project$Model$BuildPlanner$Error$BuildExprError$getRemediableSolveError,
				$author$project$Model$BuildPlanner$Error$PlanningError$subErrors(planningError)));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Views$PlanningErrorNotice$AdvanceTimestampCmd = {$: 3};
var $author$project$Views$PlanningErrorNotice$ExpandErrorNotice = {$: 0};
var $author$project$Views$PlanningErrorNotice$Remediate = function (a) {
	return {$: 1, a: a};
};
var $author$project$Views$PlanningErrorNotice$RemovePlatformCmd = function (a) {
	return {$: 0, a: a};
};
var $author$project$Views$PlanningErrorNotice$RemoveRequirementCmd = function (a) {
	return {$: 1, a: a};
};
var $author$project$Views$PlanningErrorNotice$SetAllAutoCmd = {$: 2};
var $author$project$Model$BuildPlanner$Error$SolveErrorRemediation$command = function (_v0) {
	var data = _v0;
	return data.xH;
};
var $author$project$Model$BuildPlanner$Error$SolveErrorRemediation$parameters = function (_v0) {
	var data = _v0;
	return data.zC;
};
var $author$project$Model$BuildPlanner$Error$RemediableSolveError$suggestedRemediations = function (_v0) {
	var data = _v0;
	return data.Ak;
};
var $author$project$Views$PlanningErrorNotice$viewFailureError = function (error) {
	return A2(
		$elm$html$Html$li,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(error)
			]));
};
var $author$project$Model$BuildPlanner$Error$RemediableSolveError$incompatibilities = function (_v0) {
	var data = _v0;
	return data.yD;
};
var $author$project$Views$PlanningErrorNotice$viewRemediationMessage = function (remediableSolveError) {
	var messageFromTwoIncompats = F2(
		function (packageIncompat, platformIncompat) {
			return A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('The '),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('remediation-target')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Model$Namespace$getName(packageIncompat))
							])),
						$elm$html$Html$text(' package is not compatible with '),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('remediation-target')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(platformIncompat.Ff)
							])),
						$elm$html$Html$text('.')
					]));
		});
	var _v0 = $author$project$Model$BuildPlanner$Error$RemediableSolveError$incompatibilities(remediableSolveError);
	_v0$2:
	while (true) {
		if (_v0.b) {
			if (!_v0.a.$) {
				if ((_v0.b.b && (_v0.b.a.$ === 1)) && (!_v0.b.b.b)) {
					var packageIncompat = _v0.a.a;
					var _v1 = _v0.b;
					var platformIncompat = _v1.a.a;
					return A2(messageFromTwoIncompats, packageIncompat, platformIncompat);
				} else {
					break _v0$2;
				}
			} else {
				if ((_v0.b.b && (!_v0.b.a.$)) && (!_v0.b.b.b)) {
					var platformIncompat = _v0.a.a;
					var _v2 = _v0.b;
					var packageIncompat = _v2.a.a;
					return A2(messageFromTwoIncompats, packageIncompat, platformIncompat);
				} else {
					break _v0$2;
				}
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$html$Html$text(
		$author$project$Model$BuildPlanner$Error$RemediableSolveError$message(remediableSolveError));
};
var $author$project$Views$PlanningErrorNotice$viewRemediation = F3(
	function (session, _v0, _v1) {
		var expandErrorNotice = _v0.ov;
		var userCanEditProject = _v1.GU;
		var failureErrors = _v1.yj;
		var maybeRemediableSolveError = _v1.zc;
		var hasAnyConstrainedPackages = _v1.CJ;
		var setToAutoSection = _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('set-all-auto'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'set-all-auto-extra-margin',
								_Utils_eq(maybeRemediableSolveError, $elm$core$Maybe$Nothing))
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('But, there\'s something you can try!')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Your project includes packages set to specific versions which can make resolving dependencies tricky. Removing version constraints can increase the chance of success.')
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('primary-button'),
								$elm$html$Html$Events$onClick(
								$author$project$Views$PlanningErrorNotice$Remediate($author$project$Views$PlanningErrorNotice$SetAllAutoCmd))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Set All Versions to Auto')
							]))
					]))
			]);
		var isSuperUserWithFeaturesVisible = $author$project$Model$Session$isSuperUserWithFeaturesVisible(session);
		var remediationToActionBtn = function (remediation) {
			var command = $author$project$Model$BuildPlanner$Error$SolveErrorRemediation$command(remediation);
			var _v3 = $author$project$Model$BuildPlanner$Error$SolveErrorRemediation$parameters(remediation);
			switch (_v3.$) {
				case 0:
					var namespaceKey = _v3.a;
					return $elm$core$Maybe$Just(
						A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('secondary-button small'),
									$elm$html$Html$Events$onClick(
									$author$project$Views$PlanningErrorNotice$Remediate(
										$author$project$Views$PlanningErrorNotice$RemoveRequirementCmd(namespaceKey)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(command)
								])));
				case 1:
					var platformId = _v3.a;
					return $elm$core$Maybe$Just(
						A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('secondary-button small'),
									$elm$html$Html$Events$onClick(
									$author$project$Views$PlanningErrorNotice$Remediate(
										$author$project$Views$PlanningErrorNotice$RemovePlatformCmd(platformId)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(command)
								])));
				case 2:
					return isSuperUserWithFeaturesVisible ? $elm$core$Maybe$Just(
						A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('secondary-button small superuser-only'),
									$elm$html$Html$Events$onClick(
									$author$project$Views$PlanningErrorNotice$Remediate($author$project$Views$PlanningErrorNotice$AdvanceTimestampCmd))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(command)
								]))) : $elm$core$Maybe$Nothing;
				default:
					return $elm$core$Maybe$Nothing;
			}
		};
		var actionBtnList = A2(
			$elm$core$List$filterMap,
			remediationToActionBtn,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Maybe$map, $author$project$Model$BuildPlanner$Error$RemediableSolveError$suggestedRemediations, maybeRemediableSolveError)));
		var canUserFixIt = (!$elm$core$List$isEmpty(actionBtnList)) || hasAnyConstrainedPackages;
		var remediationActions = function () {
			if (!actionBtnList.b) {
				return setToAutoSection;
			} else {
				return A2(
					$elm$core$List$intersperse,
					A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('or')
							])),
					actionBtnList);
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('solution-error-hint')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Views$Icon$view(
							$author$project$Views$Icon$icon(83)),
							$elm$html$Html$text('Unable to resolve dependencies'),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('more-info-tooltip')
								]),
							_List_fromArray(
								[
									$author$project$Views$Icon$view(
									$author$project$Views$Icon$icon(52)),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('content')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('There was a problem with one of the packages (or their dependencies) in your project. Until it\'s resolved, we can\'t start a new build.')
												])),
											A2(
											$author$project$Misc$displayIf,
											canUserFixIt,
											A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Try one of the suggested actions below to fix the problem.')
													])))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('toggle-wrapper'),
									$elm$html$Html$Events$onClick($author$project$Views$PlanningErrorNotice$ExpandErrorNotice)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('toggle-icon'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('expanded', expandErrorNotice)
												]))
										]),
									_List_fromArray(
										[
											$author$project$Views$Icon$view(
											$author$project$Views$Icon$icon(13))
										])),
									$elm$html$Html$text('View details')
								]))
						])),
					A2(
					$author$project$Misc$displayMaybe,
					function (remediableSolveError) {
						return A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('error-description')
								]),
							_List_fromArray(
								[
									$author$project$Views$PlanningErrorNotice$viewRemediationMessage(remediableSolveError)
								]));
					},
					maybeRemediableSolveError),
					A2(
					$author$project$Misc$displayIf,
					userCanEditProject && canUserFixIt,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('remediation-actions')
							]),
						remediationActions)),
					expandErrorNotice ? A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('full-error-list')
						]),
					A2($elm$core$List$map, $author$project$Views$PlanningErrorNotice$viewFailureError, failureErrors)) : $elm$html$Html$text('')
				]));
	});
var $author$project$Views$PlanningErrorNotice$view = F3(
	function (session, model, _v0) {
		var userCanEditProject = _v0.GU;
		var hasAnyConstrainedPackages = _v0.CJ;
		var dataSource = _v0.Cb;
		if (dataSource.$ === 2) {
			var error = dataSource.a;
			var _v2 = _Utils_Tuple2(
				$author$project$Views$PlanningErrorNotice$getFirstRemediableSolveError(error),
				A2(
					$elm$core$List$cons,
					$author$project$Views$PlanningErrorNotice$errorToMessage(error),
					$author$project$Views$PlanningErrorNotice$errorToList(error)));
			var maybeRemediableSolveError = _v2.a;
			var failureErrors = _v2.b;
			return A3(
				$author$project$Views$PlanningErrorNotice$viewRemediation,
				session,
				model,
				{yj: failureErrors, CJ: hasAnyConstrainedPackages, zc: maybeRemediableSolveError, GU: userCanEditProject});
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Views$PlatformSelectionModal$AvailableBecauseSuperuser = 2;
var $author$project$Views$PlatformSelectionModal$AvailableViaAddon = 1;
var $author$project$Views$PlatformSelectionModal$CloseModal = {$: 5};
var $author$project$Views$PlatformSelectionModal$Unavailable = 0;
var $author$project$Model$Permissions$orgCanPackageAuthenticodeSignature = $author$project$Model$Organization$addOnEnabled('authenticode_signing');
var $author$project$Model$Permissions$orgCanPackageDocker = $author$project$Model$Organization$addOnEnabled('docker_images');
var $author$project$Model$Permissions$orgCanPackageRelocateAndZip = $author$project$Model$Organization$addOnEnabled('relocate_and_zip');
var $author$project$Model$BuildPlanner$BuildExpr$PackagerKind$canUse = F2(
	function (org, kind) {
		switch (kind) {
			case 0:
				return $author$project$Model$Permissions$orgCanPackageDocker(org);
			case 1:
				return $author$project$Model$Permissions$orgCanPackageInstaller(org);
			case 2:
				return $author$project$Model$Permissions$orgCanPackageInstaller(org);
			case 3:
				return $author$project$Model$Permissions$orgCanPackageRelocateAndZip(org);
			default:
				return $author$project$Model$Permissions$orgCanPackageAuthenticodeSignature(org);
		}
	});
var $author$project$Model$Platform$sort = function () {
	var toComparable = function (_v0) {
		var p = _v0;
		return _List_fromArray(
			[
				A2($elm$core$Maybe$withDefault, '', p.rm),
				p.rL,
				p.ha,
				A2($elm$core$Maybe$withDefault, '', p.r_.kT)
			]);
	};
	return $elm$core$List$sortBy(toComparable);
}();
var $author$project$Views$PlatformSelectionModal$getAllowedPlatforms = F3(
	function (session, model, parentModel) {
		var isSuperUserWithFeaturesVisible = $author$project$Model$Session$isSuperUserWithFeaturesVisible(session);
		var checks = _List_fromArray(
			[
				$elm$core$Basics$always(isSuperUserWithFeaturesVisible),
				$author$project$Model$Platform$isAllowedForNonSuperUsers,
				function (platform) {
				return A2($author$project$Model$BuildPlanner$SolveLegacyEditor$isPlatformSelected, platform, model.qR);
			}
			]);
		return $author$project$Model$Platform$sort(
			A2(
				$elm$core$List$filter,
				function (platform) {
					return A2(
						$elm$core$List$any,
						$elm$core$Basics$eq(true),
						A2(
							$elm$core$List$map,
							function (checkF) {
								return checkF(platform);
							},
							checks));
				},
				$elm$core$Dict$values(parentModel.n4)));
	});
var $author$project$Model$BuildPlanner$SolveLegacyEditor$isPackagerSelected = F3(
	function (platformID, packager, editor) {
		var _v0 = A2(
			$elm$core$Dict$get,
			platformID,
			$author$project$Model$BuildPlanner$BuildExprEditor$Simple$getAllPackagers(editor));
		if (_v0.$ === 1) {
			return false;
		} else {
			var packagers = _v0.a;
			switch (packager) {
				case 0:
					return !$elm$core$List$isEmpty(packagers.Cj);
				case 1:
					return !$elm$core$List$isEmpty(packagers.D4);
				case 2:
					return !$elm$core$List$isEmpty(packagers.w4);
				case 3:
					return !$elm$core$List$isEmpty(packagers.vX);
				default:
					return !$elm$core$List$isEmpty(packagers.A8);
			}
		}
	});
var $author$project$Model$Platform$bitWidth = function (_v0) {
	var platform = _v0;
	return platform.r_.kT;
};
var $author$project$Model$Platform$platformTypeToString = function (platformType) {
	switch (platformType) {
		case 0:
			return 'Windows';
		case 1:
			return 'Linux';
		case 2:
			return 'Mac';
		case 3:
			return 'HP-UX';
		case 4:
			return 'AIX';
		default:
			return 'Solaris';
	}
};
var $author$project$Views$PlatformSelectionModal$defaultPlatform = $author$project$Model$Platform$platformTypeToString(0);
var $author$project$Views$PlatformSelectionModal$osPlatformsList = function (currentOSName) {
	return A2(
		$elm$core$Basics$composeL,
		$elm$core$List$reverse,
		$elm$core$List$filter(
			function (p) {
				return _Utils_eq(
					$author$project$Model$Platform$osName(p),
					currentOSName);
			}));
};
var $author$project$Views$PlatformSelectionModal$SetDisplayPlatform = function (a) {
	return {$: 0, a: a};
};
var $author$project$Views$PlatformSelectionModal$osTabs = F2(
	function (selectedPlatform, platformNames) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('platform-tabs')
				]),
			A2(
				$elm$core$List$map,
				function (_v0) {
					var displayName = _v0.a;
					var osName = _v0.b;
					return A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(osName),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'active',
										_Utils_eq(selectedPlatform, osName))
									])),
								$elm$html$Html$Events$onClick(
								$author$project$Views$PlatformSelectionModal$SetDisplayPlatform(osName)),
								$elm$html$Html$Attributes$type_('button')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(displayName)
							]));
				},
				platformNames));
	});
var $author$project$Views$PlatformSelectionModal$AddPlatform = function (a) {
	return {$: 1, a: a};
};
var $author$project$Views$PlatformSelectionModal$RemovePlatform = function (a) {
	return {$: 2, a: a};
};
var $author$project$Model$Platform$cpuType = function (_v0) {
	var platform = _v0;
	return platform.r_.oj;
};
var $author$project$Model$Platform$platformDisplayNameSegments = function (platform_) {
	var platform = platform_;
	var platformType = $author$project$Model$Platform$getPlatformType(platform_);
	var cpuTypeString = $author$project$Model$Platform$cpuType(platform_);
	var bitWidthString = A2(
		$elm$core$Maybe$map,
		function (a) {
			return a + '-bit';
		},
		$author$project$Model$Platform$bitWidth(platform_));
	var _v0 = function () {
		if (platformType === 1) {
			var _v1 = platform.rm;
			if (!_v1.$) {
				var libcVersion = _v1.a;
				return _Utils_Tuple2(
					$author$project$Model$Platform$platformTypeToString(platformType),
					$elm$core$Maybe$Just('Glibc ' + libcVersion));
			} else {
				return _Utils_Tuple2(
					$author$project$Model$Platform$platformTypeToString(platformType),
					$elm$core$Maybe$Nothing);
			}
		} else {
			if (!platformType) {
				var versionString = A2($elm$core$String$contains, 'Windows 10', platform.i$) ? '10' : (A2($elm$core$String$contains, 'Windows 7', platform.i$) ? '7' : '');
				return _Utils_Tuple2(
					$author$project$Model$Platform$platformTypeToString(platformType) + (' ' + versionString),
					$elm$core$Maybe$Nothing);
			} else {
				if (platformType === 2) {
					var versionString = A2($elm$core$String$startsWith, '10', platform.rL) ? '10.*' : '11+';
					return _Utils_Tuple2(
						$author$project$Model$Platform$platformTypeToString(platformType),
						$elm$core$Maybe$Just(versionString));
				} else {
					return _Utils_Tuple2(platform.ha, $elm$core$Maybe$Nothing);
				}
			}
		}
	}();
	var platformName = _v0.a;
	var glibcVersion = _v0.b;
	return {kT: bitWidthString, oj: cpuTypeString, q_: glibcVersion, rV: platformName};
};
var $author$project$Model$Platform$humanReadablePlatformName = function (platform) {
	var segments = $author$project$Model$Platform$platformDisplayNameSegments(platform);
	var glibcText = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$elm$core$String$append(' '),
			segments.q_));
	var bitWidthString = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$elm$core$String$append(' '),
			segments.kT));
	return segments.rV + (glibcText + (' ' + (segments.oj + bitWidthString)));
};
var $author$project$Views$PlatformSelectionModal$AddPackager = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Views$PlatformSelectionModal$RemovePackager = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Model$BuildPlanner$BuildExpr$PackagerKind$displayName = function (packager) {
	switch (packager) {
		case 0:
			return 'Docker';
		case 1:
			return 'Linux Installer';
		case 2:
			return 'Windows Installer';
		case 3:
			return 'Relocate and Zip';
		default:
			return 'Authenticode Signature';
	}
};
var $author$project$Views$PlatformSelectionModal$isAvailable = function (availability) {
	return !(!availability);
};
var $author$project$Views$PlatformSelectionModal$packagerView = F4(
	function (config, platform, platformIsSelected, _v0) {
		var packager = _v0.rP;
		var availability = _v0.qo;
		var platformID = $author$project$Model$Platform$id(platform);
		var isSelected = A2(config.um, platformID, packager);
		var isDisabled = !(platformIsSelected && $author$project$Views$PlatformSelectionModal$isAvailable(availability));
		var clickMsg = isSelected ? A2($author$project$Views$PlatformSelectionModal$RemovePackager, platformID, packager) : A2($author$project$Views$PlatformSelectionModal$AddPackager, platformID, packager);
		var attr = isDisabled ? $elm$html$Html$Attributes$class('disabled') : $elm$html$Html$Events$onClick(clickMsg);
		return A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							attr,
							$elm$html$Html$Attributes$class('deployment-option'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('superuser-only', availability === 2)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$Attributes$attribute,
									'aria-label',
									'Toggle the ' + ($author$project$Model$BuildPlanner$BuildExpr$PackagerKind$displayName(packager) + (' packager for the ' + ($author$project$Model$Platform$humanReadablePlatformName(platform) + ' platform.')))),
									$elm$html$Html$Attributes$type_('checkbox'),
									$elm$html$Html$Attributes$checked(isSelected),
									$elm$html$Html$Attributes$disabled(isDisabled)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Model$BuildPlanner$BuildExpr$PackagerKind$displayName(packager))
								]))
						]))
				]));
	});
var $author$project$Misc$apply = F2(
	function (fns, param) {
		return A2(
			$elm$core$List$map,
			$elm$core$Basics$apR(param),
			fns);
	});
var $author$project$Model$Platform$recommended = function (_v0) {
	var internals = _v0;
	var validations = _List_fromArray(
		[
			A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.rm;
			},
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map(
					$elm$core$Basics$neq('2.12')),
				$elm$core$Maybe$withDefault(true)))
		]);
	return A2(
		$elm$core$List$all,
		$elm$core$Basics$eq(true),
		A2($author$project$Misc$apply, validations, internals));
};
var $author$project$Model$Platform$simpleName = function (platform) {
	var segments = $author$project$Model$Platform$platformDisplayNameSegments(platform);
	var libcVersionEl = A2(
		$author$project$Misc$displayMaybe,
		function (v) {
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('libc-version')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(v)
					]));
		},
		segments.q_);
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('simple-platform-name')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(segments.rV + ' '),
				libcVersionEl
			]));
};
var $author$project$PlatformMapping$supportedPlatforms = function (_v0) {
	var data = _v0;
	return data.G;
};
var $author$project$Model$Platform$supportedVersionsByDistroListForDisplay = function (platform) {
	var platformID = $author$project$Model$Platform$id(platform);
	var supportsThisID = A2(
		$elm$core$List$filter,
		A2(
			$elm$core$Basics$composeR,
			$author$project$PlatformMapping$supportedPlatforms,
			$elm$core$List$member(platformID)),
		$author$project$PlatformMapping$platformChoicesList);
	var versionsForDistro = function (distroName) {
		var versionSpan = function (versionString) {
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('distro-version')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(versionString)
					]));
		};
		var versionList = A2(
			$elm$core$List$map,
			versionSpan,
			$elm_community$list_extra$List$Extra$unique(
				A2(
					$elm$core$List$map,
					$author$project$PlatformMapping$version,
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$author$project$PlatformMapping$distribution,
							$elm$core$Basics$eq(distroName)),
						supportsThisID))));
		return A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$strong,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('distro-name')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(distroName)
						])),
					A2($elm$html$Html$span, _List_Nil, versionList)
				]));
	};
	var supportedVersionsByDistro = A2(
		$elm$core$List$map,
		versionsForDistro,
		$elm_community$list_extra$List$Extra$unique(
			A2($elm$core$List$map, $author$project$PlatformMapping$distribution, supportsThisID)));
	return A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('supported-versions-list')
			]),
		supportedVersionsByDistro);
};
var $author$project$Model$Platform$supportedPlatformsWidget = function (platform) {
	return A3(
		$elm$html$Html$Keyed$node,
		'div',
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('supported-versions-widget')
			]),
		_List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Model$Platform$id(platform),
				A2(
					$elm$html$Html$details,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$summary,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Views$Icon$view(
											$author$project$Views$Icon$icon(13)),
											$elm$html$Html$text('Supported Versions')
										]))
								])),
							$author$project$Model$Platform$supportedVersionsByDistroListForDisplay(platform)
						])))
			]));
};
var $author$project$Model$BuildPlanner$BuildExpr$PackagerKind$supportsLanguage = F2(
	function (language, kind) {
		var _v0 = _Utils_Tuple2(kind, language);
		if (!_v0.a) {
			if (_v0.b === 1) {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				return true;
			} else {
				var _v3 = _v0.a;
				return false;
			}
		} else {
			return true;
		}
	});
var $author$project$Views$PlatformSelectionModal$platformView = F2(
	function (config, platform) {
		var platformType = $author$project$Model$Platform$getPlatformType(platform);
		var platformID = $author$project$Model$Platform$id(platform);
		var packagers = A2(
			$elm$core$List$filterMap,
			function (kind) {
				var _v2 = _Utils_Tuple2(
					config.vN(kind),
					A2($author$project$Model$BuildPlanner$BuildExpr$PackagerKind$supportsLanguage, config.aC, kind));
				_v2$0:
				while (true) {
					if (!_v2.b) {
						if (!_v2.a) {
							break _v2$0;
						} else {
							return $elm$core$Maybe$Nothing;
						}
					} else {
						switch (_v2.a) {
							case 0:
								break _v2$0;
							case 1:
								var _v4 = _v2.a;
								return $elm$core$Maybe$Just(
									{qo: 1, rP: kind});
							default:
								var _v5 = _v2.a;
								return $elm$core$Maybe$Just(
									{qo: 2, rP: kind});
						}
					}
				}
				var _v3 = _v2.a;
				return $elm$core$Maybe$Nothing;
			},
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Dict$get, platformID, $author$project$Model$BuildPlanner$BuildExpr$PackagerKind$optionsByPlatform)));
		var languageVersion = config.DS;
		var versionSuffix = function () {
			if (languageVersion.$ === 1) {
				var version = languageVersion.a;
				return ' ' + version;
			} else {
				return '';
			}
		}();
		var language = config.aC;
		var languageName = $author$project$Model$Language$toString(language);
		var isSelected = config.oR(platform);
		var isNotAllowedBecauseMacOS = (platformType === 2) && (!$author$project$Model$LanguageVersions$isMacAllowed(
			_Utils_Tuple2(language, languageVersion)));
		var hasPackagers = !$elm$core$List$isEmpty(packagers);
		var cpuTypeElement = _List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Model$Platform$cpuType(platform))
			]);
		var clickMsg = isSelected ? $author$project$Views$PlatformSelectionModal$RemovePlatform(
			$author$project$Model$Platform$id(platform)) : $author$project$Views$PlatformSelectionModal$AddPlatform(
			$author$project$Model$Platform$id(platform));
		var clickAttrs = isNotAllowedBecauseMacOS ? _List_Nil : _List_fromArray(
			[
				$elm$html$Html$Events$onClick(clickMsg)
			]);
		var bitWidthElement = function () {
			var _v0 = $author$project$Model$Platform$bitWidth(platform);
			if (!_v0.$) {
				var width = _v0.a;
				return _List_fromArray(
					[
						$elm$html$Html$text(width + '-bit')
					]);
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('platform-option'),
					$elm$html$Html$Attributes$class('id-' + platformID),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('selected', isSelected),
							_Utils_Tuple2('disabled', isNotAllowedBecauseMacOS),
							_Utils_Tuple2(
							'superuser-only',
							!(isSelected || $author$project$Model$Platform$isAllowedForNonSuperUsers(platform)))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_Utils_ap(
								_List_fromArray(
									[
										A2(
										$elm$html$Html$Attributes$attribute,
										'aria-label',
										'Toggle the ' + ($author$project$Model$Platform$humanReadablePlatformName(platform) + ' platform.')),
										$elm$html$Html$Attributes$type_('checkbox'),
										$elm$html$Html$Attributes$checked(isSelected),
										$elm$html$Html$Attributes$disabled(isNotAllowedBecauseMacOS)
									]),
								clickAttrs),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('spaced-row')
								]),
							_List_fromArray(
								[
									$author$project$Model$Platform$simpleName(platform),
									A2(
									$author$project$Misc$displayIf,
									A2($elm$core$Basics$composeR, $author$project$Model$Platform$recommended, $elm$core$Basics$not)(platform),
									A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('badge')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Not Recommended')
											])))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('os-meta')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('os-option')
										]),
									bitWidthElement),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('os-option')
										]),
									cpuTypeElement)
								])),
							A2(
							$author$project$Misc$displayIf,
							isNotAllowedBecauseMacOS,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('disabled-note')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('language-name'),
												$elm$html$Html$Attributes$class(languageName)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												_Utils_ap(languageName, versionSuffix))
											])),
										$elm$html$Html$text(' runtimes are not yet available for MacOS.')
									])))
						])),
					A2(
					$author$project$Misc$displayIf,
					hasPackagers,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('deployment-options'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('packagers-not-selectable', !isSelected)
									]))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Deployment Methods')
									])),
								A2(
								$elm$html$Html$ul,
								_List_Nil,
								A2(
									$elm$core$List$map,
									A3($author$project$Views$PlatformSelectionModal$packagerView, config, platform, isSelected),
									packagers))
							]))),
					$author$project$Model$Platform$supportedPlatformsWidget(platform)
				]));
	});
var $author$project$Views$PlatformSelectionModal$viewContent = F3(
	function (config, platforms, displayPlatform) {
		var uniqueOSNames = $elm_community$list_extra$List$Extra$unique(
			A2(
				$elm$core$List$map,
				function (p) {
					return _Utils_Tuple2(
						$author$project$Model$Platform$brandName(p),
						$author$project$Model$Platform$osName(p));
				},
				platforms));
		var selectedPlatform = A2($elm$core$Maybe$withDefault, $author$project$Views$PlatformSelectionModal$defaultPlatform, displayPlatform);
		var platformList = A2(
			$elm$core$List$map,
			$author$project$Views$PlatformSelectionModal$platformView(config),
			A2($author$project$Views$PlatformSelectionModal$osPlatformsList, selectedPlatform, platforms));
		var noneSelected = A2(
			$elm$core$List$all,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, config.oR),
			platforms);
		var any32BitSelected = A2(
			$elm$core$List$any,
			function (p) {
				return config.oR(p) && _Utils_eq(
					$author$project$Model$Platform$bitWidth(p),
					$elm$core$Maybe$Just('32'));
			},
			platforms);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('platform-selector-modal')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Platforms')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('platform-selector')
						]),
					_List_fromArray(
						[
							A2($author$project$Views$PlatformSelectionModal$osTabs, selectedPlatform, uniqueOSNames),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('platform-list')
								]),
							platformList)
						])),
					A2(
					$author$project$Misc$displayIf,
					any32BitSelected,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('message warning-message')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('32-bit Platforms Require Custom Setup')
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Builds for 32-bit platforms have a very low probability of working successfully unless they have been manually configured for your project by our specialists. '),
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href('mailto:sales@activestate.com'),
												$elm$html$Html$Attributes$target('_blank')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Get in touch')
											])),
										$elm$html$Html$text(' to discuss options if you need 32-bit builds.')
									]))
							]))),
					A2(
					$author$project$Misc$displayIf,
					noneSelected,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('message error-message')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('No platform selected')
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('You must have at least one platform selected.')
									]))
							])))
				]));
	});
var $author$project$Views$PlatformSelectionModal$view = F3(
	function (session, model, parentModel) {
		var isSuperUserWithFeaturesVisible = $author$project$Model$Session$isSuperUserWithFeaturesVisible(session);
		var isSelected = function (platform) {
			return A2($author$project$Model$BuildPlanner$SolveLegacyEditor$isPlatformSelected, platform, model.qR);
		};
		var anySelected = A2(
			$elm_community$dict_extra$Dict$Extra$any,
			$elm$core$Basics$always(isSelected),
			parentModel.n4);
		var _v0 = function () {
			var _v1 = $elm$core$List$head(
				$author$project$Model$BuildPlanner$SolveLegacyEditor$getLanguageItems(model.qR));
			if (_v1.$ === 1) {
				return _Utils_Tuple2(
					1,
					$author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$Exact(''));
			} else {
				var value = _v1.a.kH;
				return _Utils_Tuple2(
					A2(
						$elm$core$Maybe$withDefault,
						1,
						$author$project$Model$Language$fromString(value.w)),
					value.aI);
			}
		}();
		var language = _v0.a;
		var languageVersion = _v0.b;
		var platformSelectorConfig = {
			um: F2(
				function (platformID, packager) {
					return A3($author$project$Model$BuildPlanner$SolveLegacyEditor$isPackagerSelected, platformID, packager, model.qR);
				}),
			oR: isSelected,
			aC: language,
			DS: languageVersion,
			vN: function (kind) {
				var _v2 = _Utils_Tuple2(
					isSuperUserWithFeaturesVisible,
					A2($author$project$Model$BuildPlanner$BuildExpr$PackagerKind$canUse, parentModel.c3, kind));
				if (_v2.b) {
					return 1;
				} else {
					if (!_v2.a) {
						return 0;
					} else {
						return 2;
					}
				}
			}
		};
		return $author$project$Views$Modal$view(
			{
				BD: 'platforms',
				BI: $author$project$Views$PlatformSelectionModal$CloseModal,
				dH: A3(
					$author$project$Views$PlatformSelectionModal$viewContent,
					platformSelectorConfig,
					A3($author$project$Views$PlatformSelectionModal$getAllowedPlatforms, session, model, parentModel),
					model.or),
				x4: A2($author$project$Views$Modal$DismissButtonVisible, 0, anySelected)
			});
	});
var $author$project$Views$Timestamp$GetTimeThenSetNextCommitTimestamp = {$: 0};
var $author$project$Views$Timestamp$SetNextCommitTimestampCustomValue = function (a) {
	return {$: 2, a: a};
};
var $author$project$Views$Timestamp$SetToDynamic = {$: 3};
var $author$project$Views$Timestamp$view = F3(
	function (model, parentModel, _v0) {
		var isSuperuser = _v0.DI;
		var superuserOnlySurface = _v0.Gn;
		var viewingLatestCommit = _v0.G5;
		var showDynamic = isSuperuser && (parentModel.ot === 1);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('new-box timestamps'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('superuser-only', superuserOnlySurface)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Timestamp Settings')
						])),
					A2(
					$author$project$Misc$displayIf,
					viewingLatestCommit,
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Current Timestamp')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('timestamp-value')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(
											A2(
												$elm$core$Maybe$withDefault,
												$author$project$Model$Commit$getAtTime(parentModel.f0),
												$author$project$Model$BuildPlanner$SolveLegacyEditor$getOriginalTimestamp(parentModel.qR))))
									])),
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Platform Present')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('timestamp-value')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(parentModel.pq))
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('secondary-button small'),
										$elm$html$Html$Events$onClick(
										$author$project$Views$Timestamp$SetNextCommitTimestamp(parentModel.pq)),
										$elm$html$Html$Attributes$disabled(
										$author$project$Views$Timestamp$isPlatformTimestamp(parentModel))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Set to Platform Present')
									])),
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Bleeding Edge')
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('This just means the current time.')
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('secondary-button small'),
										$elm$html$Html$Events$onClick($author$project$Views$Timestamp$GetTimeThenSetNextCommitTimestamp)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Set to Current Time')
									])),
								A2(
								$author$project$Misc$displayIf,
								showDynamic,
								A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Dynamic')
										]))),
								A2(
								$author$project$Misc$displayIf,
								showDynamic,
								A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('This enables Dynamic Imports')
										]))),
								A2(
								$author$project$Misc$displayIf,
								showDynamic,
								A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('secondary-button small'),
											$elm$html$Html$Events$onClick($author$project$Views$Timestamp$SetToDynamic)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Set to Dynamic')
										]))),
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Custom Timestamp')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('timestamp-custom')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$type_('text'),
												$elm$html$Html$Attributes$maxlength(27),
												$elm$html$Html$Events$onInput($author$project$Views$Timestamp$SetNextCommitTimestampCustomValue)
											]),
										_List_Nil),
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('secondary-button small'),
												function () {
												var _v1 = $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(model.o7);
												if (_v1.$ === 1) {
													return $elm$html$Html$Attributes$disabled(true);
												} else {
													var timestamp = _v1.a;
													return $elm$html$Html$Events$onClick(
														$author$project$Views$Timestamp$SetNextCommitTimestamp(timestamp));
												}
											}()
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Set')
											]))
									]))
							])))
				]));
	});
var $author$project$Url$Extra$buildExprDocs = function (queryParams) {
	return A3(
		$author$project$Url$Extra$createUrl,
		$author$project$Url$Extra$docsDomain,
		_List_fromArray(
			['platform', 'features', 'build-expressions']),
		queryParams);
};
var $author$project$Model$BuildPlanner$BuildExpr$UnknownAp$mitigationOptions = function (_v0) {
	return _List_fromArray(
		[
			$elm$html$Html$text('Use the state tool')
		]);
};
var $author$project$Views$UnsupportedProjectModal$view = F2(
	function (session, _v0) {
		var projectRoute = _v0.zL;
		var orgRoute = _v0.vI;
		var knownUnknowns = _v0.DP;
		var supportEnabled = _v0.Go;
		var projectConfigAdvancedParams = $author$project$Model$Route$projectConfigAdvancedParams;
		var knownUnknownOptions = function (ap_) {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Model$BuildPlanner$BuildExpr$UnknownAp$toString(ap_))
							])),
						$elm$html$Html$text('Recommended Actions:'),
						A2(
						$elm$html$Html$ul,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (optionElem) {
								return A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[optionElem]));
							},
							$author$project$Model$BuildPlanner$BuildExpr$UnknownAp$mitigationOptions(ap_)))
					]));
		};
		var emailSupportView = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('contact-community')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Get Help from Support')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Contact our support team and we can help you talk through options.')
						])),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$target('_blank'),
							$elm$html$Html$Attributes$class('secondary-button external-button '),
							$elm$html$Html$Attributes$href('mailto:support@activestate.com')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Contact Support')
						]))
				]));
		var contactSupportView = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('contact-specialist')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Get help from a Specialist')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Our expert team helps enterprise customers with complicated builds all the time. Get in touch and we can help you talk through options. Email support at support@activestate.com.')
						]))
				]));
		var message = A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('This project contains advanced elements that will be supported in the web UI soon. For more information about Build Expressions see '),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(
									$author$project$Url$Extra$buildExprDocs(_List_Nil)),
									$elm$html$Html$Attributes$target('blank')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('the Build Expression documentation.')
								]))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('The following rules in the Build Expression are currently unsupported: '),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							A2($elm$core$List$map, knownUnknownOptions, knownUnknowns))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Other Options')
								])),
							A2($author$project$Misc$displayIf, supportEnabled, contactSupportView),
							A2($author$project$Misc$displayIf, !supportEnabled, emailSupportView)
						]))
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('unsupported_project_modal'),
					$elm$html$Html$Attributes$class('little-modal')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('This project is too advanced for the Dashboard!')
								])),
							message,
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button-row'),
									$elm$html$Html$Attributes$class('row')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button-wrapper')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('primary-button'),
													$elm$html$Html$Attributes$href(
													$author$project$Model$Route$routeToString(orgRoute))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Return to Dashboard')
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button-wrapper')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('primary-button'),
													$elm$html$Html$Attributes$href(
													$author$project$Model$Route$routeToString(
														projectRoute(
															A2($author$project$Model$Route$ProjectSettings, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing))))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Go to Settings')
												]))
										])),
									A2(
									$author$project$Misc$displayIf,
									$author$project$Model$Session$isSuperUserWithFeaturesVisible(session),
									A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('button-wrapper superuser-only')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('primary-button'),
														$elm$html$Html$Attributes$href(
														$author$project$Model$Route$routeToString(
															projectRoute(
																$author$project$Model$Route$ProjectConfigAdvanced(projectConfigAdvancedParams))))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Edit Build Expr')
													]))
											])))
								]))
						]))
				]));
	});
var $author$project$Views$UpdateForkModal$DismissModal = {$: 2};
var $author$project$Views$UpdateForkModal$KeepChangesTab = 0;
var $author$project$Views$UpdateForkModal$Merge = {$: 1};
var $author$project$Views$UpdateForkModal$SwitchToTab = function (a) {
	return {$: 0, a: a};
};
var $author$project$Views$ChangeTable$getDescriptionRevert = function (operation) {
	switch (operation) {
		case 0:
			return 'Adding';
		case 2:
			return 'Removing';
		default:
			return 'New version';
	}
};
var $author$project$Views$ChangeTable$sortKey = function (change) {
	var _v0 = change.EX;
	switch (_v0) {
		case 0:
			return 1;
		case 1:
			return 2;
		default:
			return 3;
	}
};
var $author$project$Views$ChangeTable$unknownPlatform = {i$: 'Unknown platform', aI: ''};
var $author$project$Model$Platform$version = function (_v0) {
	var platform = _v0;
	return platform.rL;
};
var $author$project$Views$ChangeTable$viewSingleChange = F4(
	function (isSuperUserWithFeaturesVisible, getDescription, platformMap, change) {
		var platform = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Views$ChangeTable$unknownPlatform,
			A2(
				$elm$core$Maybe$map,
				function (p) {
					return {
						i$: $author$project$Model$Platform$displayName(p),
						aI: $author$project$Model$Platform$version(p)
					};
				},
				A2($elm$core$Dict$get, change.w, platformMap)));
		var key = $author$project$Model$Namespace$key(change);
		var kind = $author$project$Model$Namespace$kind(key);
		var namespace = $author$project$Model$Namespace$getNamespace(key);
		var itemType = A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('item-type')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					function () {
						var _v7 = $author$project$Model$Namespace$kindFromString(namespace);
						switch (_v7) {
							case 6:
								return 'Platform';
							case 4:
								return 'Language';
							case 0:
								return 'Package bundle';
							default:
								var _v8 = $author$project$Model$Language$fromPackageNamespace(namespace);
								if (_v8.$ === 1) {
									return 'Other package';
								} else {
									var language = _v8.a;
									return $elm_community$string_extra$String$Extra$toTitleCase(
										$author$project$Model$Language$toString(language)) + ' package';
								}
						}
					}())
				]));
		var constraintString = function () {
			if (kind === 6) {
				return platform.aI;
			} else {
				var _v6 = $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$fromVersionRequirements(change.gW);
				switch (_v6.$) {
					case 0:
						return 'Auto';
					case 1:
						var versionString = _v6.a;
						return versionString;
					case 2:
						var first = _v6.a;
						var others = _v6.b;
						return A2($author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$toPythonSyntax, first, others);
					default:
						return '';
				}
			}
		}();
		var formattedConstraintString = function () {
			var _v4 = change.EX;
			if (_v4 === 1) {
				return 'Changed to ' + constraintString;
			} else {
				return constraintString;
			}
		}();
		var buildFlagSmellsLikeBuildExprHack = function () {
			if (kind === 1) {
				return A2(
					$elm$core$String$contains,
					'add_installer=',
					$elm$core$String$toLower(change.w));
			} else {
				return false;
			}
		}();
		var itemName = function () {
			switch (kind) {
				case 6:
					return platform.i$;
				case 1:
					return buildFlagSmellsLikeBuildExprHack ? 'Community binaries, docker or installer changed, view at this commit for details' : change.w;
				default:
					return change.w;
			}
		}();
		var _v0 = function () {
			var _v1 = change.EX;
			switch (_v1) {
				case 0:
					return _Utils_Tuple2('added', 61);
				case 2:
					return _Utils_Tuple2('removed', 50);
				default:
					return _Utils_Tuple2('changed', 7);
			}
		}();
		var changeType = _v0.a;
		var iconKind = _v0.b;
		return A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(changeType),
					$elm$html$Html$Attributes$class(change.aE)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('item-change-label')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									getDescription(change.EX))
								]))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('item-details')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('item-name')
								]),
							_List_fromArray(
								[
									$author$project$Views$Icon$view(
									$author$project$Views$Icon$icon(iconKind)),
									A2(
									$author$project$Misc$displayIf,
									isSuperUserWithFeaturesVisible && _Utils_eq(itemName, change.w),
									A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('superuser-only')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(namespace)
											]))),
									$elm$html$Html$text(itemName),
									A2(
									$author$project$Misc$displayIf,
									!buildFlagSmellsLikeBuildExprHack,
									A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('item-version')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(formattedConstraintString)
											])))
								]))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[itemType]))
				]));
	});
var $author$project$Views$UpdateForkModal$view = F2(
	function (session, model) {
		var isSuperUserWithFeaturesVisible = $author$project$Model$Session$isSuperUserWithFeaturesVisible(session);
		var diffView = function (changes) {
			return $elm$core$List$isEmpty(changes) ? A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('no-changes')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('No functional changes will be made to your project.')
									])),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('sub')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Sometimes there are no changes to display because your project will stay the same after updating, or there are some under-the-hood changes that are still required to keep your fork in sync. ')
									]))
							]))
					])) : A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$table,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('changes-table')
							]),
						A2(
							$elm$core$List$map,
							A3($author$project$Views$ChangeTable$viewSingleChange, isSuperUserWithFeaturesVisible, $author$project$Views$ChangeTable$getDescriptionRevert, model.Fh),
							A2($elm$core$List$sortBy, $author$project$Views$ChangeTable$sortKey, changes)))
					]));
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('modal-view update-fork-modal')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal')
						]),
					function () {
						var _v0 = model.su;
						switch (_v0.$) {
							case 2:
								return _List_fromArray(
									[
										A2(
										$elm$html$Html$h2,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Error')
											])),
										$elm$html$Html$text('Error loading changes')
									]);
							case 3:
								var strategies = _v0.a;
								var updateItem = function () {
									var _v2 = model.wT;
									if (!_v2) {
										return 'project';
									} else {
										return 'branch';
									}
								}();
								var tabContents = function () {
									var _v1 = model.FX;
									if (!_v1) {
										return A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('changes-table-wrapper')
												]),
											_List_fromArray(
												[
													diffView(strategies.DO)
												]));
									} else {
										return A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('changes-table-wrapper')
												]),
											_List_fromArray(
												[
													diffView(strategies.E1)
												]));
									}
								}();
								var hasConflicts = !(!$elm$core$List$length(strategies.BW));
								return _List_fromArray(
									[
										A2(
										$elm$html$Html$h2,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Update your ' + updateItem)
											])),
										A2(
										$author$project$Misc$displayMaybe,
										function (error) {
											return A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('error-text')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(error)
													]));
										},
										model.ye),
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('You are about to update your ' + (updateItem + (' with the latest changes made to the upstream ' + (updateItem + '.'))))
											])),
										A2(
										$author$project$Misc$displayIf,
										hasConflicts,
										A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('merge-warning')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Some local changes conflict with changes made in the upstream ' + (updateItem + '. Pick which change to keep.'))
												]))),
										hasConflicts ? A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('section-tabs')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$button,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$classList(
																_List_fromArray(
																	[
																		_Utils_Tuple2('selected', model.FX === 1)
																	])),
																$elm$html$Html$Events$onClick(
																$author$project$Views$UpdateForkModal$SwitchToTab(1))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Accept upstream changes')
															])),
														A2(
														$elm$html$Html$button,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$classList(
																_List_fromArray(
																	[
																		_Utils_Tuple2('selected', !model.FX)
																	])),
																$elm$html$Html$Events$onClick(
																$author$project$Views$UpdateForkModal$SwitchToTab(0))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Keep your changes')
															]))
													]))
											])) : A2(
										$elm$html$Html$h4,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('changes-table-header')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Changes')
											])),
										tabContents,
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('button-wrapper')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Events$onClick($author$project$Views$UpdateForkModal$Merge),
														$elm$html$Html$Attributes$class('primary-button')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Update')
													])),
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Events$onClick($author$project$Views$UpdateForkModal$DismissModal),
														$elm$html$Html$Attributes$class('secondary-button')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Cancel')
													]))
											]))
									]);
							default:
								return _List_fromArray(
									[
										A2(
										$elm$html$Html$h2,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Loading')
											])),
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[$author$project$Views$Loading$dots]))
									]);
						}
					}())
				]));
	});
var $author$project$Model$BuildPlanner$Component$languageFromPurlPkg = function (pkg) {
	switch (pkg) {
		case 'cpan':
			return 'perl';
		case 'pypi':
			return 'python';
		case 'golang':
			return 'go';
		case 'gem':
			return 'ruby';
		case 'maven':
			return 'java';
		case 'generic':
			return 'C';
		case 'apk':
			return 'alpine';
		case 'docker':
			return 'docker';
		case 'npm':
			return 'javascript';
		default:
			return 'C';
	}
};
var $author$project$Model$BuildPlanner$Component$languageFromPurl = function (component) {
	var purl_ = $author$project$Model$BuildPlanner$Component$purl(component);
	var pkgPrefix = 'pkg:';
	var namespace_ = $author$project$Model$BuildPlanner$Component$namespace(component);
	if ($elm$core$String$toLower(namespace_) !== 'unknown') {
		return $author$project$Model$Namespace$removeLanguagePrefix(namespace_);
	} else {
		if (A2($elm$core$String$startsWith, pkgPrefix, purl_)) {
			var _v0 = A2(
				$elm$core$String$split,
				'/',
				A2(
					$elm$core$String$dropLeft,
					$elm$core$String$length(pkgPrefix),
					purl_));
			if (_v0.b) {
				var pkg = _v0.a;
				return $author$project$Model$BuildPlanner$Component$languageFromPurlPkg(pkg);
			} else {
				return namespace_;
			}
		} else {
			return namespace_;
		}
	}
};
var $author$project$Pages$ProjectConfigHtml$viewSeverityHistogram = F2(
	function (normsAndVulns, vulnKey) {
		var _v0 = A2(
			$krisajenkins$remotedata$RemoteData$map,
			$author$project$Model$SeverityHistogram$fromVulnerabilities,
			A2($author$project$Model$NormsAndVulns$getVulnerabilities, normsAndVulns, vulnKey));
		switch (_v0.$) {
			case 0:
				return $author$project$Views$Loading$boxes;
			case 1:
				return $author$project$Views$Loading$boxes;
			case 2:
				return $elm$html$Html$text('');
			default:
				var severityHistogram = _v0.a;
				return $author$project$Views$CVESummary$viewTotals(
					{xI: true, y7: $elm$core$Maybe$Nothing, zd: $elm$core$Maybe$Nothing, F2: severityHistogram});
		}
	});
var $author$project$Pages$ProjectConfigHtml$viewAbsentComponent = F3(
	function (normsAndVulns, buildDataSource, component) {
		var vulnKey = $author$project$Model$NormsAndVulns$PurlVulnKey(
			$author$project$Model$BuildPlanner$Component$getAnalyticsCVEKey(component));
		var isMissingFromCatalog = A2($author$project$Model$BuildDataSource$isMissingSourceComponent, buildDataSource, component);
		return A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('missing-component'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('missing', isMissingFromCatalog)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Model$BuildPlanner$Component$name(component)),
							$elm$html$Html$text(' '),
							$elm$html$Html$text(
							$author$project$Model$BuildPlanner$Component$version(component))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('language-column')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm_community$string_extra$String$Extra$toTitleCase(
								$author$project$Model$BuildPlanner$Component$languageFromPurl(component)))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Pages$ProjectConfigHtml$viewSeverityHistogram, normsAndVulns, vulnKey)
						]))
				]));
	});
var $author$project$Pages$ProjectConfigHtml$viewAbsentComponents = F3(
	function (normsAndVulns, buildDataSource, absentComponents) {
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('missing-components-table')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$tr,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$th,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Name')
								])),
							A2(
							$elm$html$Html$th,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Language')
								])),
							A2(
							$elm$html$Html$th,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Vulnerabilities')
								]))
						])),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					A2(
						$elm$core$List$map,
						A2($author$project$Pages$ProjectConfigHtml$viewAbsentComponent, normsAndVulns, buildDataSource),
						A2($elm$core$List$sortBy, $author$project$Model$BuildPlanner$Component$name, absentComponents)))
				]));
	});
var $author$project$Pages$ProjectConfig$ConvertToRuntime = {$: 50};
var $author$project$Pages$ProjectConfig$ToggleConvertToRuntimeModal = {$: 51};
var $author$project$Views$ConvertProjectModal$contentView = F3(
	function (action, closeAction, converting) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('convert-sbom-modal')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Fix Vulnerabilities')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('The ActiveState platform allows you to fix vulnerabilities that are in your SBOM by converting it to an editable set of packages that can be modified, rebuilt and redeployed in your environment.')
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('side-by-side-steps')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('image-container')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('image'),
													$elm$html$Html$Attributes$src('/SBOM-Import-Step-One.svg'),
													$elm$html$Html$Attributes$alt('Example image')
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Step 1')
										])),
									A2(
									$elm$html$Html$h3,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Convert SBOM')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Your SBOM gets turned into an editable set of packages, which we call a runtime.')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Only those components found in the ActiveState catalog are included.')
										]))
								])),
							A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('image-container')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('image'),
													$elm$html$Html$Attributes$src('/SBOM-Import-Step-Two.svg'),
													$elm$html$Html$Attributes$alt('Example image')
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Step 2')
										])),
									A2(
									$elm$html$Html$h3,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Fix Vulnerabilities')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Choose newer package versions to reduce your Vulnerability count. Our platform automatically resolves all dependencies.')
										]))
								])),
							A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('image-container')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('image'),
													$elm$html$Html$Attributes$src('/SBOM-Import-Step-Three.svg'),
													$elm$html$Html$Attributes$alt('Example image')
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Step 3')
										])),
									A2(
									$elm$html$Html$h3,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Review Impact')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('See a detailed report of the changes to your dependencies including any breaking changes that might be introduced by new package versions.')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Note')
												])),
											$elm$html$Html$text(' - Breaking Changes analysis is only available by request. '),
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$target('_blank'),
													$elm$html$Html$Attributes$href('mailto:support@activestate.com')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Contact us')
												])),
											$elm$html$Html$text(' to request access.')
										]))
								])),
							A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('image-container')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('image'),
													$elm$html$Html$Attributes$src('/SBOM-Import-Step-Four.svg'),
													$elm$html$Html$Attributes$alt('Example image')
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Step 4')
										])),
									A2(
									$elm$html$Html$h3,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Build & Deploy')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('We build your updated packages from source for the platforms and deployment methods you need in your environment.')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('By default, we\'ll attempt a build for Linux, but you can pick your target platforms.')
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('action-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('primary-button'),
									A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Copy project URL to clipboard'),
									converting ? A2($elm$html$Html$Attributes$attribute, 'disabled', '') : $elm$html$Html$Events$onClick(action)
								]),
							_List_fromArray(
								[
									converting ? $elm$html$Html$text('Converting... ') : $elm$html$Html$text('Convert to Runtime')
								])),
							A2(
							$author$project$Misc$displayIf,
							!converting,
							A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('secondary-button'),
										A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Copy project URL to clipboard'),
										$elm$html$Html$Events$onClick(closeAction)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Cancel')
									])))
						]))
				]));
	});
var $author$project$Views$ConvertProjectModal$modalId = 'convert-to-runtime-modal';
var $author$project$Views$ConvertProjectModal$view = function (_v0) {
	var actionMessage = _v0.AZ;
	var closeMessage = _v0.BI;
	var converting = _v0.BZ;
	return A2(
		$author$project$Views$Modal$viewWithModalId,
		$elm$core$Maybe$Just($author$project$Views$ConvertProjectModal$modalId),
		{
			BD: '',
			BI: closeMessage,
			dH: A3($author$project$Views$ConvertProjectModal$contentView, actionMessage, closeMessage, converting),
			x4: A2($author$project$Views$Modal$DismissButtonVisible, 1, true)
		});
};
var $author$project$Views$GenericSBOM$SearchTermChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Views$GenericSBOM$Catalog = 2;
var $author$project$Views$GenericSBOM$Language = 1;
var $author$project$Views$GenericSBOM$Vulnerabilities = 3;
var $author$project$Views$GenericSBOM$allColumns = _List_fromArray(
	[0, 1, 2, 3]);
var $author$project$Views$GenericSBOM$SetSortColumn = function (a) {
	return {$: 1, a: a};
};
var $author$project$Views$GenericSBOM$columnString = function (column) {
	switch (column) {
		case 0:
			return 'Component';
		case 1:
			return 'Language';
		case 2:
			return 'Public Catalog';
		default:
			return 'Vulnerabilities';
	}
};
var $author$project$Views$GenericSBOM$columnHeading = F2(
	function (model, column) {
		var isTheActiveColumn = _Utils_eq(model.nx, column);
		return A2(
			$elm$html$Html$th,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('sorted', isTheActiveColumn)
						])),
					$elm$html$Html$Attributes$class('sortable')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('heading sortable'),
							$elm$html$Html$Events$onClick(
							$author$project$Views$GenericSBOM$SetSortColumn(column))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('heading-text')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Views$GenericSBOM$columnString(column))
								])),
							function () {
							var visbleSortDirection = isTheActiveColumn ? model.ny : $author$project$Views$GenericSBOM$defaultSortDirection;
							var iconKind = function () {
								if (!visbleSortDirection) {
									return 12;
								} else {
									return 14;
								}
							}();
							return $author$project$Views$Icon$view(
								A2(
									$author$project$Views$Icon$square,
									13,
									$author$project$Views$Icon$icon(iconKind)));
						}()
						]))
				]));
	});
var $author$project$Views$GenericSBOM$computeMetadata = function (deps) {
	var languages = A2($elm$core$List$map, $author$project$Model$BuildPlanner$Component$languageFromPurl, deps);
	var languageCounts = A2(
		$elm$core$List$map,
		function (_v0) {
			var head = _v0.a;
			var tail = _v0.b;
			return _Utils_Tuple2(
				$elm_community$string_extra$String$Extra$toSentenceCase(head),
				$elm$core$List$length(tail) + 1);
		},
		A2($elm_community$list_extra$List$Extra$gatherWith, $elm$core$Basics$eq, languages));
	var totalLanguages = A2(
		$elm$core$Basics$max,
		1,
		A3(
			$elm$core$List$foldl,
			A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$Basics$add),
			0,
			languageCounts));
	var ensure100PercentTotal = function (k) {
		ensure100PercentTotal:
		while (true) {
			var denom = totalLanguages + k;
			var languagePercentages = function () {
				var num = function (n) {
					return (100 * n) + k;
				};
				return A2(
					$elm$core$List$map,
					$elm$core$Tuple$mapSecond(
						function (n) {
							return $elm$core$Basics$ceiling(
								num(n) / denom);
						}),
					languageCounts);
			}();
			var totalLanguagePercentage = A3(
				$elm$core$List$foldl,
				A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$Basics$add),
				0,
				languagePercentages);
			if ((k < 1000) && (totalLanguagePercentage > 100)) {
				var $temp$k = k + 1;
				k = $temp$k;
				continue ensure100PercentTotal;
			} else {
				return languagePercentages;
			}
		}
	};
	return {
		us: ensure100PercentTotal(0),
		Av: $elm$core$List$length(deps)
	};
};
var $author$project$Views$GenericSBOM$dependencySummary = function (metadata) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('dependency-summary')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('loading-shimmer')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('gradient-wrapper')
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dependency-count')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('dependency-chart')
							]),
						$elm$core$List$concat(
							A2(
								$elm$core$List$map,
								function (l) {
									var percentString = $elm$core$String$fromInt(l.b) + '%';
									return _List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(percentString)
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('language-name')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(l.a)
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('bar-wrapper')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class(l.a),
															A2($elm$html$Html$Attributes$style, 'width', percentString),
															$elm$html$Html$Attributes$class('bar')
														]),
													_List_Nil)
												]))
										]);
								},
								$elm$core$List$reverse(
									A2($elm$core$List$sortBy, $elm$core$Tuple$second, metadata.us)))))
					]))
			]));
};
var $author$project$Model$BuildDataSource$getComponentsForPurls = function (_v0) {
	var cached = _v0.df;
	return $elm$core$List$filterMap(
		function (purl) {
			return A2($elm$core$Dict$get, purl, cached.tn);
		});
};
var $author$project$Views$GenericSBOM$getSeverityHistogram = F2(
	function (normsAndVulns, vulnKey) {
		var _v0 = A2(
			$krisajenkins$remotedata$RemoteData$map,
			$author$project$Model$SeverityHistogram$fromVulnerabilities,
			A2($author$project$Model$NormsAndVulns$getVulnerabilities, normsAndVulns, vulnKey));
		if (_v0.$ === 3) {
			var severityHistogram = _v0.a;
			return severityHistogram;
		} else {
			return $author$project$Model$SeverityHistogram$empty;
		}
	});
var $author$project$Model$BuildPlanner$Component$sortKey = function (_v0) {
	var data = _v0;
	return _Utils_Tuple2(data.w, data.aI);
};
var $author$project$Model$BuildPlanner$Component$isVersionFromPurl = function (_v0) {
	var component = _v0;
	return (!$elm$core$String$isEmpty(component.aI)) && A2($elm$core$String$contains, '@', component.k);
};
var $author$project$Views$GenericSBOM$viewSeverityHistogram = F2(
	function (normsAndVulns, vulnKey) {
		var _v0 = A2(
			$krisajenkins$remotedata$RemoteData$map,
			$author$project$Model$SeverityHistogram$fromVulnerabilities,
			A2($author$project$Model$NormsAndVulns$getVulnerabilities, normsAndVulns, vulnKey));
		switch (_v0.$) {
			case 0:
				return $author$project$Views$Loading$boxes;
			case 1:
				return $author$project$Views$Loading$boxes;
			case 2:
				return $elm$html$Html$text('');
			default:
				var severityHistogram = _v0.a;
				return $author$project$Views$CVESummary$viewTotals(
					{xI: true, y7: $elm$core$Maybe$Nothing, zd: $elm$core$Maybe$Nothing, F2: severityHistogram});
		}
	});
var $author$project$Views$GenericSBOM$viewComponent = F3(
	function (buildDataSource, normsAndVulns, component) {
		var vulnKey = $author$project$Model$NormsAndVulns$PurlVulnKey(
			$author$project$Model$BuildPlanner$Component$getAnalyticsCVEKey(component));
		var isMissingFromCatalog = A2($author$project$Model$BuildDataSource$isMissingSourceComponent, buildDataSource, component);
		var availableClass = isMissingFromCatalog ? 'missing' : 'available';
		return A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sbom-component'),
					$elm$html$Html$Attributes$class(availableClass)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Model$BuildPlanner$Component$name(component)),
							$elm$html$Html$text(' '),
							$author$project$Model$BuildPlanner$Component$isVersionFromPurl(component) ? $elm$html$Html$text(
							$author$project$Model$BuildPlanner$Component$version(component)) : A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('more-info-tooltip')
								]),
							_List_fromArray(
								[
									$author$project$Views$Icon$view(
									$author$project$Views$Icon$icon(52)),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('content')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('No version was specified in the SBOM, but the latest version in the ActiveState catalog is '),
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Model$BuildPlanner$Component$version(component))
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('language-column')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Model$BuildPlanner$Component$languageFromPurl(component))
						])),
					isMissingFromCatalog ? A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('catalog-column')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('more-info-tooltip')
								]),
							_List_fromArray(
								[
									$author$project$Views$Icon$view(
									$author$project$Views$Icon$icon(44)),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('content')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('This component is not available in the Public ActiveState catalog. Contact our specialists to access our secure extended catalog.')
												])),
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('secondary-button small'),
													$elm$html$Html$Attributes$href(
													$author$project$Url$Extra$contactUs(_List_Nil)),
													$elm$html$Html$Attributes$target('_blank')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Contact Us')
												]))
										]))
								])),
							$elm$html$Html$text('Contact Us')
						])) : A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('catalog-column')
						]),
					_List_fromArray(
						[
							$author$project$Views$Icon$view(
							$author$project$Views$Icon$icon(10)),
							$elm$html$Html$text('Available')
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Views$GenericSBOM$viewSeverityHistogram, normsAndVulns, vulnKey)
						]))
				]));
	});
var $author$project$Views$GenericSBOM$view = F3(
	function (buildDataSource, parentModel, model) {
		var allComponents = ((!model.ny) ? $elm$core$Basics$identity : $elm$core$List$reverse)(
			function () {
				var _v1 = model.nx;
				switch (_v1) {
					case 0:
						return $elm$core$List$sortBy($author$project$Model$BuildPlanner$Component$sortKey);
					case 1:
						return $elm$core$List$sortBy($author$project$Model$BuildPlanner$Component$namespace);
					case 3:
						return $elm$core$List$sortBy(
							function (component) {
								var vulnKey = $author$project$Model$NormsAndVulns$PurlVulnKey(
									$author$project$Model$BuildPlanner$Component$getAnalyticsCVEKey(component));
								return $author$project$Model$SeverityHistogram$sortKey(
									A2($author$project$Views$GenericSBOM$getSeverityHistogram, parentModel.rF, vulnKey));
							});
					default:
						return $elm$core$List$sortBy(
							function (component) {
								return A2($author$project$Model$BuildDataSource$isMissingSourceComponent, buildDataSource, component) ? 1 : 0;
							});
				}
			}()(
				A2($author$project$Model$BuildDataSource$getComponentsForPurls, buildDataSource, model.CF.xM)));
		var catalogCount = A2(
			$elm_community$list_extra$List$Extra$count,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Basics$not,
				$author$project$Model$BuildDataSource$isMissingSourceComponent(buildDataSource)),
			allComponents);
		var filteredComponents = function () {
			if ($elm$core$String$isEmpty(model.nq)) {
				return allComponents;
			} else {
				var lowerSearchTerm = $elm$core$String$toLower(model.nq);
				return A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Model$BuildPlanner$Component$name,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$String$toLower,
							$elm$core$String$contains(lowerSearchTerm))),
					allComponents);
			}
		}();
		var severityHistogram = A2(
			$krisajenkins$remotedata$RemoteData$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$concat,
				A2(
					$elm$core$Basics$composeR,
					$elm_community$list_extra$List$Extra$uniqueBy(
						function ($) {
							return $.B9;
						}),
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$map(
							function ($) {
								return $.ck;
							}),
						$author$project$Model$SeverityHistogram$fromSeverities))),
			$author$project$Misc$remoteDataConcat(
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Model$NormsAndVulns$PurlVulnKey,
						$author$project$Model$NormsAndVulns$getVulnerabilities(parentModel.rF)),
					$elm_community$list_extra$List$Extra$unique(
						A2($elm$core$List$map, $author$project$Model$BuildPlanner$Component$getAnalyticsCVEKey, filteredComponents)))));
		var totalCount = $elm$core$List$length(allComponents);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sbom-header')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h2,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$title(model.CF.w)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(model.CF.w)
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('item-count')
										]),
									_List_fromArray(
										[
											$author$project$Views$Icon$view(
											$author$project$Views$Icon$icon(57)),
											A2(
											$elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromInt(totalCount)),
													$elm$html$Html$text(' Components')
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('divider')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('•')
												])),
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromInt(catalogCount) + ' available in ActiveState catalog')
												]))
										]))
								])),
							$author$project$Views$InlineSearchBar$inlineSearchBar(
							{
								Bx: $author$project$Views$GenericSBOM$SearchTermChanged,
								BG: $elm$core$Maybe$Just(
									$author$project$Views$GenericSBOM$SearchTermChanged('')),
								j0: model.nq,
								Fd: 'Find a component'
							}),
							$author$project$Views$GenericSBOM$dependencySummary(
							$author$project$Views$GenericSBOM$computeMetadata(allComponents)),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('cve-total')
								]),
							function () {
								switch (severityHistogram.$) {
									case 3:
										var histogram = severityHistogram.a;
										return _List_fromArray(
											[
												A2(
												$elm$html$Html$h4,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														$elm$core$String$fromInt(
															$author$project$Model$SeverityHistogram$total(histogram)) + ' Total Vulnerabilities')
													])),
												$author$project$Views$CVESummary$viewTotals(
												{xI: false, y7: $elm$core$Maybe$Nothing, zd: $elm$core$Maybe$Nothing, F2: histogram})
											]);
									case 1:
										return _List_fromArray(
											[
												A2(
												$elm$html$Html$h4,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Total Vulnerabilities')
													])),
												$author$project$Views$Loading$boxes
											]);
									case 2:
										return _List_fromArray(
											[
												A2(
												$elm$html$Html$h4,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Total Vulnerabilities')
													])),
												$elm$html$Html$text('There was a problem fetching Vulnerability data.')
											]);
									default:
										return _List_Nil;
								}
							}())
						])),
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sbom-component-table sortable-table-wrapper')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tbody,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									A2(
										$elm$core$List$map,
										$author$project$Views$GenericSBOM$columnHeading(model),
										$author$project$Views$GenericSBOM$allColumns))
								])),
							A2(
							$elm$html$Html$tbody,
							_List_Nil,
							$elm$core$List$isEmpty(filteredComponents) ? _List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('no-components-found'),
													$elm$html$Html$Attributes$colspan(4)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('No components.')
												]))
										]))
								]) : A2(
								$elm$core$List$map,
								A2($author$project$Views$GenericSBOM$viewComponent, buildDataSource, parentModel.rF),
								filteredComponents))
						]))
				]));
	});
var $author$project$Pages$ProjectConfigHtml$viewGenericSBOM = function (model) {
	var genericSBOMs = function () {
		var _v0 = $author$project$Model$BuildDataSource$latest(model);
		if (_v0.$ === 3) {
			var buildData = _v0.a;
			return $elm$core$Dict$values(
				A2(
					$elm$core$Dict$map,
					F2(
						function (name, innerModel) {
							return A2(
								$elm$html$Html$map,
								$author$project$Pages$ProjectConfig$GenericSBOM(name),
								A3($author$project$Views$GenericSBOM$view, buildData, model, innerModel));
						}),
					model.oE));
		} else {
			return _List_Nil;
		}
	}();
	return A2(
		$author$project$Misc$displayIf,
		!$elm$core$List$isEmpty(genericSBOMs),
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('new-box sbom-section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('analyze-sbom-header')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h2,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('SBOM Analysis')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Here are the components in your SBOM along with the vulnerabilities we have identified.')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('convert-cta-wrapper')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(' Fix Vulnerabilities')
												])),
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Select safer versions of the components in this SBOM and build a remediated runtime.')
												]))
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('primary-button'),
											$elm$html$Html$Events$onClick($author$project$Pages$ProjectConfig$ToggleConvertToRuntimeModal)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Fix Vulnerabilities')
										]))
								])),
							A2(
							$author$project$Misc$displayIf,
							model.rf,
							$author$project$Views$ConvertProjectModal$view(
								{AZ: $author$project$Pages$ProjectConfig$ConvertToRuntime, BI: $author$project$Pages$ProjectConfig$ToggleConvertToRuntimeModal, BZ: model.hQ}))
						])),
					A2($elm$html$Html$div, _List_Nil, genericSBOMs)
				])));
};
var $author$project$Pages$ProjectConfig$SelectLanguage = 2;
var $author$project$Pages$ProjectConfig$SetVersionToRecommended = {$: 38};
var $author$project$Model$LanguageVersions$canUpgradeToRecommended = F2(
	function (language, version) {
		switch (language) {
			case 1:
				return (version.y5 !== 2) && A2(
					$author$project$Model$VersionString$gt,
					version,
					A3($author$project$Model$VersionString$new, 3, 7, 0));
			case 0:
				return A2(
					$author$project$Model$VersionString$gt,
					version,
					A3($author$project$Model$VersionString$new, 5, 26, 0));
			default:
				return true;
		}
	});
var $author$project$Pages$ProjectConfigHtml$get = function (normalizedKey) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Dict$get(normalizedKey),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($krisajenkins$remotedata$RemoteData$Success),
			$elm$core$Maybe$withDefault($krisajenkins$remotedata$RemoteData$NotAsked)));
};
var $author$project$Pages$ProjectConfigHtml$getAllVulnerabilities = function (normsAndVulns) {
	var getVulnerabilityKeys = function (component) {
		return A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.sL;
				},
				$author$project$Model$Vulnerability$fromNamespaceKey(component.j9)),
			$mgold$elm_nonempty_list$List$Nonempty$toList(component.e$));
	};
	var getVulnerabilities = function (vulnKey) {
		return A2(
			$author$project$Model$NormsAndVulns$getVulnerabilities,
			normsAndVulns,
			$author$project$Model$NormsAndVulns$NamespacedVulnKey(vulnKey));
	};
	return $krisajenkins$remotedata$RemoteData$andThen(
		A2(
			$elm$core$Basics$composeR,
			getVulnerabilityKeys,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(getVulnerabilities),
				A2(
					$elm$core$Basics$composeR,
					$author$project$Misc$remoteDataConcat,
					A2(
						$elm$core$Basics$composeR,
						$krisajenkins$remotedata$RemoteData$mapError($author$project$Model$BuildPlanner$BuildPlannerError$HttpError),
						$krisajenkins$remotedata$RemoteData$map(
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$concat,
								$elm_community$list_extra$List$Extra$uniqueBy(
									function ($) {
										return $.B9;
									}))))))));
};
var $author$project$Model$BuildDataSource$getComponentsByKey = function (_v0) {
	var cached = _v0.df;
	return cached.tm;
};
var $author$project$Model$VersionPredicates$Python$hasCommunityPython2 = F2(
	function (editor, buildDataSource) {
		return A2(
			$elm_community$dict_extra$Dict$Extra$any,
			F2(
				function (name, constraint) {
					if (!_Utils_eq(
						$author$project$Model$Language$fromString(name),
						$elm$core$Maybe$Just(1))) {
						return false;
					} else {
						var _v0 = _Utils_Tuple2(
							constraint,
							A2(
								$krisajenkins$remotedata$RemoteData$map,
								$author$project$Model$BuildDataSource$getLanguageResolvedVersion(name),
								buildDataSource));
						if (_v0.a.$ === 1) {
							var versionString = _v0.a.a;
							return $author$project$Model$VersionPredicates$Python$isCommunityVersion2(versionString);
						} else {
							if ((_v0.b.$ === 3) && (!_v0.b.a.$)) {
								var versionString = _v0.b.a.a;
								return $author$project$Model$VersionPredicates$Python$isCommunityVersion2(versionString);
							} else {
								return false;
							}
						}
					}
				}),
			$author$project$Model$BuildPlanner$SolveLegacyEditor$getLanguages(editor));
	});
var $author$project$Model$VersionPredicates$Perl$hasCommunityVersion = F2(
	function (editor, buildDataSource) {
		return A2(
			$elm_community$dict_extra$Dict$Extra$any,
			F2(
				function (name, constraint) {
					if (!_Utils_eq(
						$author$project$Model$Language$fromString(name),
						$elm$core$Maybe$Just(0))) {
						return false;
					} else {
						var _v0 = _Utils_Tuple2(
							constraint,
							A2(
								$krisajenkins$remotedata$RemoteData$map,
								$author$project$Model$BuildDataSource$getLanguageResolvedVersion(name),
								buildDataSource));
						if (_v0.a.$ === 1) {
							var versionString = _v0.a.a;
							return !$author$project$Model$VersionString$isASPatched(versionString);
						} else {
							if ((_v0.b.$ === 3) && (!_v0.b.a.$)) {
								var versionString = _v0.b.a.a;
								return !$author$project$Model$VersionString$isASPatched(versionString);
							} else {
								return false;
							}
						}
					}
				}),
			$author$project$Model$BuildPlanner$SolveLegacyEditor$getLanguages(editor));
	});
var $author$project$Views$LanguageVersionWarning$shortMessage = function (kind) {
	var content = function () {
		switch (kind.$) {
			case 3:
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Contact us to learn more about our secure and exclusive patched versions of Python 2.7.18.x and more!')
							]))
					]);
			case 0:
				var language = kind.a;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								'ActiveState\'s support and maintenance are only applicable to languages under community support, managed distributions, or our exclusive extended support offerings. We recommended you utilize a newer version of ' + ($author$project$Model$Language$toDisplayString(language) + ' from our catalog.'))
							]))
					]);
			case 1:
				var version = kind.b;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Use version '),
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Model$VersionString$toString(version))
									])),
								$elm$html$Html$text(' for better build success.')
							]))
					]);
			case 2:
				var recommendedVersion = kind.b;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('We recommended using version '),
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Model$VersionString$toString(recommendedVersion))
									])),
								$elm$html$Html$text(' for better performance, build success, and fewer vulnerabilities.')
							]))
					]);
			default:
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('You may experience sub optimal performance with this language as it is not fully supported by ActiveState yet.')
							]))
					]);
		}
	}();
	return A2($elm$html$Html$section, _List_Nil, content);
};
var $author$project$Views$LanguageVersionWarning$projectConfigBox = function (kind) {
	return A2(
		$elm$html$Html$div,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class('top-stripe top-margin'),
			$author$project$Views$LanguageVersionWarning$kindAttributes(kind)),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('warning')
					]),
				_List_fromArray(
					[
						$author$project$Views$LanguageVersionWarning$warning(kind)
					])),
				$author$project$Views$LanguageVersionWarning$shortMessage(kind),
				$author$project$Views$LanguageVersionWarning$actionButton(
				{qu: false, qW: true, mp: kind, r$: 0})
			]));
};
var $author$project$Pages$ProjectConfig$PackagesExpandMsg = function (a) {
	return {$: 24, a: a};
};
var $author$project$Pages$ProjectConfig$Remove = F2(
	function (a, b) {
		return {$: 28, a: a, b: b};
	});
var $author$project$Pages$ProjectConfig$Undo = function (a) {
	return {$: 45, a: a};
};
var $author$project$Pages$ProjectConfigHtml$itemStatusLabel = function (status) {
	switch (status.$) {
		case 0:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('change-label'),
						$elm$html$Html$Attributes$title('Package added')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('ADDED')
					]));
		case 1:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('change-label'),
						$elm$html$Html$Attributes$title('Version updated')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('UPDATED')
					]));
		case 2:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('change-label'),
						$elm$html$Html$Attributes$title('Package removed')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('REMOVED')
					]));
		default:
			return $elm$html$Html$text('');
	}
};
var $author$project$Pages$ProjectConfigHtml$removeOrRevertButton = function (_v0) {
	var readOnly = _v0.Fw;
	var status = _v0.L;
	var onRemove = _v0.kg;
	var onRevert = _v0.kh;
	var _v1 = _Utils_Tuple2(readOnly, status);
	if (_v1.a) {
		return $elm$html$Html$text('');
	} else {
		if (_v1.b.$ === 3) {
			var _v2 = _v1.b;
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('remove-package-button'),
						$elm$html$Html$Events$onClick(onRemove)
					]),
				_List_fromArray(
					[
						$author$project$Views$Icon$view(
						$author$project$Views$Icon$icon(81))
					]));
		} else {
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('cancel-change secondary-button small'),
						$elm$html$Html$Events$onClick(onRevert)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Cancel')
					]));
		}
	}
};
var $author$project$Pages$ProjectConfigHtml$statusClassName = function (status) {
	switch (status.$) {
		case 0:
			return 'package-requested';
		case 1:
			return 'package-updated';
		case 2:
			return 'package-removed';
		default:
			return 'package-unchanged';
	}
};
var $author$project$Pages$ProjectConfigHtml$viewLanguage = F2(
	function (model, _v0) {
		var flags = _v0.qX;
		var vulnerabilities = _v0.nS;
		var isExpanded = _v0.rg;
		var cvesEnabled = _v0.Ca;
		var languageItem = _v0.yW;
		var buildData = _v0.qr;
		var versionString = function () {
			var _v2 = _Utils_Tuple2(
				languageItem.kH.aI,
				A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Model$BuildDataSource$getLanguageResolvedVersion(languageItem.kH.w),
					buildData));
			_v2$0:
			while (true) {
				_v2$3:
				while (true) {
					switch (_v2.b.$) {
						case 3:
							if (_v2.a.$ === 1) {
								break _v2$0;
							} else {
								if (!_v2.b.a.$) {
									var version = _v2.b.a.a;
									return version;
								} else {
									break _v2$3;
								}
							}
						case 2:
							if (_v2.a.$ === 1) {
								break _v2$0;
							} else {
								return '';
							}
						default:
							if (_v2.a.$ === 1) {
								break _v2$0;
							} else {
								break _v2$3;
							}
					}
				}
				return '(..)';
			}
			var version = _v2.a.a;
			return version;
		}();
		var key = _Utils_Tuple2($author$project$Model$Namespace$language, languageItem.kH.w);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item'),
						$elm$html$Html$Attributes$class(
						$author$project$Pages$ProjectConfigHtml$statusClassName(languageItem.L))
					]),
				_List_fromArray(
					[
						$author$project$Pages$ProjectConfigHtml$itemStatusLabel(languageItem.L),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('item-name')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(languageItem.kH.w)
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('item-version')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(versionString)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('package-cve-summary')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$ProjectConfig$PackagesExpandMsg,
								A5($author$project$Views$CVEs$viewForPackage, flags, model.rQ, key, true, vulnerabilities))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('item-actions')
							]),
						_List_fromArray(
							[
								$author$project$Pages$ProjectConfigHtml$removeOrRevertButton(
								{
									kg: A2($author$project$Pages$ProjectConfig$Remove, key, languageItem.kH.aI),
									kh: $author$project$Pages$ProjectConfig$Undo(key),
									Fw: flags.Fw,
									L: languageItem.L
								})
							]))
					])),
				A2(
				$author$project$Misc$displayIf,
				cvesEnabled && isExpanded,
				function () {
					if (vulnerabilities.$ === 3) {
						if (!vulnerabilities.a.b) {
							return $elm$html$Html$text('');
						} else {
							var vulns = vulnerabilities.a;
							return A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('package-cve-details')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('severity-groups')
											]),
										$author$project$Views$CVEs$listBySeverity(vulns))
									]));
						}
					} else {
						return $elm$html$Html$text('');
					}
				}())
			]);
	});
var $author$project$Pages$ProjectConfigHtml$viewLanguages = F5(
	function (model, flags, languageItems, buildData, projectEditableStatus) {
		var warningKind = A2(
			$author$project$Views$LanguageVersionWarning$warningKind,
			$elm$core$Maybe$Nothing,
			$elm_community$maybe_extra$Maybe$Extra$values(
				A2(
					$elm$core$List$map,
					$author$project$Views$LanguageVersionWarning$fromLanguageItem(
						$author$project$Model$BuildDataSource$latest(model)),
					$author$project$Model$BuildPlanner$SolveLegacyEditor$getLanguageItems(model.qR))));
		var languageView = function (languageItem) {
			var key = _Utils_Tuple2($author$project$Model$Namespace$language, languageItem.kH.w);
			var langVulnerabilities = function () {
				if ($author$project$Model$BuildPlanner$SolveLegacyEditor$canSeeCubeCVEs(model)) {
					return A2(
						$krisajenkins$remotedata$RemoteData$andThen,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Model$BuildDataSource$getComponentsByKey,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Dict$get(key),
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Maybe$map(
										A2(
											$elm$core$Basics$composeR,
											$author$project$Model$BuildPlanner$Component$getAnalyticsCVEKey,
											A2(
												$elm$core$Basics$composeR,
												$author$project$Model$NormsAndVulns$PurlVulnKey,
												A2(
													$elm$core$Basics$composeR,
													$author$project$Model$NormsAndVulns$getVulnerabilities(model.rF),
													$krisajenkins$remotedata$RemoteData$mapError($author$project$Model$BuildPlanner$BuildPlannerError$HttpError))))),
									$elm$core$Maybe$withDefault($krisajenkins$remotedata$RemoteData$NotAsked)))),
						buildData);
				} else {
					if (buildData.$ === 3) {
						var buildDataSource = buildData.a;
						return A2(
							$author$project$Pages$ProjectConfigHtml$getAllVulnerabilities,
							model.rF,
							A2(
								$author$project$Pages$ProjectConfigHtml$get,
								key,
								$author$project$Model$BuildDataSource$getNodesByKey(buildDataSource)));
					} else {
						return $krisajenkins$remotedata$RemoteData$NotAsked;
					}
				}
			}();
			var isExpanded = A2($author$project$Views$NamespaceExpand$isExpanded, key, model.rQ);
			return A2(
				$author$project$Pages$ProjectConfigHtml$viewLanguage,
				model,
				{qr: buildData, Ca: flags.Ca, qX: flags, rg: isExpanded, yW: languageItem, nS: langVulnerabilities});
		};
		var changeVersionMsg = function () {
			if ((!warningKind.$) && (warningKind.a.$ === 2)) {
				var _v2 = warningKind.a;
				var language = _v2.a;
				var version = _v2.b;
				return A2($author$project$Model$LanguageVersions$canUpgradeToRecommended, language, version) ? $elm$core$Maybe$Just($author$project$Pages$ProjectConfig$SetVersionToRecommended) : $elm$core$Maybe$Nothing;
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var buttonVerb = (!$elm$core$List$isEmpty(languageItems)) ? 'Edit' : 'Add';
		return $elm$core$List$isEmpty(languageItems) ? $elm$html$Html$text('') : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('new-box language-section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Languages'),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('header-actions')
								]),
							_List_fromArray(
								[
									function () {
									switch (projectEditableStatus) {
										case 0:
											return A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('secondary-button small'),
														$elm$html$Html$Events$onClick(
														$author$project$Pages$ProjectConfig$ModalOpen(2))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(buttonVerb)
													]));
										case 1:
											return $author$project$Pages$ProjectConfigHtml$disabledEditButton(buttonVerb);
										default:
											return $elm$html$Html$text('');
									}
								}()
								]))
						])),
					(!$elm$core$List$isEmpty(languageItems)) ? A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('content')
						]),
					A2($elm$core$List$concatMap, languageView, languageItems)) : A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('no-items-added')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('No languages added')
						])),
					A2(
					$author$project$Misc$displayMaybe,
					$author$project$Views$LanguageVersionWarning$projectConfigBox,
					$author$project$Views$LanguageVersionWarning$init(
						{
							BB: changeVersionMsg,
							CK: A2($author$project$Model$VersionPredicates$Python$hasCommunityPython2, model.qR, buildData),
							CL: A2($author$project$Model$VersionPredicates$Perl$hasCommunityVersion, model.qR, buildData),
							aM: $elm_community$maybe_extra$Maybe$Extra$values(
								A2(
									$elm$core$List$map,
									$author$project$Views$LanguageVersionWarning$fromLanguageItem(buildData),
									languageItems)),
							pd: model.c3
						}))
				]));
	});
var $author$project$Views$CommitStatusBar$viewPastCommit = F3(
	function (session, projectURL, commit) {
		var commitDate = A2(
			$author$project$Model$Commit$getCommitDateReadable,
			$author$project$Model$Session$getLocalTimezone(session),
			commit);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('commit-bar'),
					$elm$html$Html$Attributes$class('past-commit')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Viewing Past Commit')
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('release-date')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(commitDate)
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('release-message')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Model$Commit$getMessage(commit))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('switch-to-latest')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('primary-button'),
									$elm$html$Html$Attributes$href(projectURL)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Return to Latest Commit')
								]))
						]))
				]));
	});
var $author$project$Pages$ProjectConfig$SelectPlatform = 3;
var $author$project$Model$Platform$supportedPlatformsPopup = function (platform) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('more-info-tooltip')
			]),
		_List_fromArray(
			[
				$author$project$Views$Icon$view(
				$author$project$Views$Icon$icon(52)),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('content supported-versions')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Supported Versions')
							])),
						$author$project$Model$Platform$supportedVersionsByDistroListForDisplay(platform)
					]))
			]));
};
var $author$project$Pages$ProjectConfigHtml$viewPackager = function (_v0) {
	var packager = _v0.a;
	var status = _v0.b;
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('packager'),
				$elm$html$Html$Attributes$class(
				$author$project$Pages$ProjectConfigHtml$statusClassName(status))
			]),
		_List_fromArray(
			[
				$author$project$Pages$ProjectConfigHtml$itemStatusLabel(status),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item-name'),
						$elm$html$Html$Attributes$class('name')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Model$BuildPlanner$BuildExpr$PackagerKind$displayName(packager))
					]))
			]));
};
var $author$project$Pages$ProjectConfigHtml$viewPlatform = function (_v0) {
	var platform = _v0.po;
	var status = _v0.L;
	var packagers = _v0.E2;
	var _v1 = _Utils_Tuple2(
		A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Basics$composeR,
							$author$project$Model$Platform$bitWidth,
							$elm$core$Maybe$map(
								function (a) {
									return a + '-bit';
								}))(platform)))
				])),
		A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Model$Platform$cpuType(platform))
				])));
	var bitWidthSpan = _v1.a;
	var cpuTypeSpan = _v1.b;
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class(
				$author$project$Pages$ProjectConfigHtml$statusClassName(status)),
				$elm$html$Html$Attributes$class('item')
			]),
		_List_fromArray(
			[
				$author$project$Pages$ProjectConfigHtml$itemStatusLabel(status),
				A2(
				$elm$html$Html$h4,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('item-name')
							]),
						_List_fromArray(
							[
								$author$project$Model$Platform$simpleName(platform)
							])),
						$author$project$Model$Platform$supportedPlatformsPopup(platform)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('platform-meta')
					]),
				_List_fromArray(
					[cpuTypeSpan, bitWidthSpan])),
				A2(
				$author$project$Misc$displayIf,
				!$elm$core$List$isEmpty(packagers),
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('packager-list')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Deployment Methods')
								])),
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							A2($elm$core$List$map, $author$project$Pages$ProjectConfigHtml$viewPackager, packagers))
						])))
			]));
};
var $author$project$Pages$ProjectConfigHtml$viewPlatforms = F2(
	function (model, projectEditableStatus) {
		var makePlatformPackagerStatus = F2(
			function (status, platform) {
				return {
					E2: A2(
						$elm$core$List$sortBy,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$first,
							A2($elm$core$Basics$composeR, $author$project$Model$BuildPlanner$BuildExpr$PackagerKind$displayName, $elm$core$String$toLower)),
						A2(
							$elm$core$List$map,
							function (item) {
								return _Utils_Tuple2(item.kH, item.L);
							},
							A2(
								$author$project$Model$BuildPlanner$SolveLegacyEditor$getPackagerItemsForPlatform,
								$author$project$Model$Platform$id(platform),
								model.qR))),
					po: platform,
					L: status
				};
			});
		var statusAndPlatforms = A2(
			$elm$core$List$sortBy,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.po;
				},
				A2($elm$core$Basics$composeR, $author$project$Model$Platform$displayName, $elm$core$String$toLower)),
			A2(
				$elm$core$List$filterMap,
				function (item) {
					return A2(
						$elm$core$Maybe$map,
						makePlatformPackagerStatus(item.L),
						A2($elm$core$Dict$get, item.kH, model.n4));
				},
				$author$project$Model$BuildPlanner$SolveLegacyEditor$getPlatformItems(model.qR)));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('new-box platform-list')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Platforms'),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('header-actions')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Misc$displayIf,
									!projectEditableStatus,
									A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('secondary-button small'),
												$elm$html$Html$Events$onClick(
												$author$project$Pages$ProjectConfig$ModalOpen(3))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Change')
											]))),
									A2(
									$author$project$Misc$displayIf,
									projectEditableStatus === 1,
									$author$project$Pages$ProjectConfigHtml$disabledEditButton('Change'))
								]))
						])),
					(!$elm$core$List$isEmpty(statusAndPlatforms)) ? A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('content')
						]),
					A2($elm$core$List$map, $author$project$Pages$ProjectConfigHtml$viewPlatform, statusAndPlatforms)) : A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('no-items-added')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('No platforms added.')
						]))
				]));
	});
var $author$project$Model$ResolvedRequirements$getByNamespaceKey = F2(
	function (namespaceKey, _v0) {
		var resolvedRequirements = _v0;
		return A2($elm$core$Dict$get, namespaceKey, resolvedRequirements.qv);
	});
var $author$project$Model$BuildDataSource$getNodeItemByNodeId = F2(
	function (nodeId, editor) {
		return A2(
			$elm_community$list_extra$List$Extra$find,
			function (componentItem) {
				return _Utils_eq(componentItem.kH.rE, nodeId);
			},
			$author$project$Model$BuildDataSource$getNodeItems(editor));
	});
var $author$project$Model$BuildDataSource$getResolvedRequirements = function (_v0) {
	var cached = _v0.df;
	return cached.pD;
};
var $author$project$Pages$ProjectConfigHtml$viewHidden = F2(
	function (model, _v0) {
		var flags = _v0.qX;
		var availableVersions = _v0.xj;
		var versionSelectorModel = _v0.sK;
		var _package = _v0.rN;
		var maybeNode = _v0.y9;
		var remoteDataNode = function () {
			if (maybeNode.$ === 1) {
				return $krisajenkins$remotedata$RemoteData$Loading;
			} else {
				var node = maybeNode.a;
				return $krisajenkins$remotedata$RemoteData$Success(node.kH);
			}
		}();
		var versionUI = A2(
			$elm$html$Html$map,
			$author$project$Pages$ProjectConfig$PackageVersionSelectorMsg(versionSelectorModel),
			$author$project$Views$PackageVersionSelector$view(
				{
					xK: A2(
						$krisajenkins$remotedata$RemoteData$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.e$;
							},
							$mgold$elm_nonempty_list$List$Nonempty$head),
						remoteDataNode),
					qX: {
						Ca: false,
						CW: false,
						Fw: flags.Fw || _Utils_eq(_package.L, $author$project$Model$Editor$Removed)
					},
					zf: versionSelectorModel,
					mT: availableVersions,
					zE: model
				}));
		var key = _package.kH.Y;
		var className = function () {
			var status = flags.Fw ? $author$project$Model$Editor$Unchanged : _package.L;
			return $author$project$Pages$ProjectConfigHtml$statusClassName(status);
		}();
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(className),
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						$author$project$Pages$ProjectConfigHtml$itemStatusLabel(_package.L),
						A2($author$project$Views$Dependencies$viewNamespaceKey, flags, key),
						versionUI,
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('item-actions')
							]),
						_List_fromArray(
							[
								$author$project$Pages$ProjectConfigHtml$removeOrRevertButton(
								{
									kg: A2($author$project$Pages$ProjectConfig$Remove, key, _package.kH.bK),
									kh: $author$project$Pages$ProjectConfig$Undo(key),
									Fw: flags.Fw,
									L: _package.L
								})
							]))
					]))
			]);
	});
var $author$project$Pages$ProjectConfigHtml$hiddenPackageRow = F3(
	function (flags, model, _v0) {
		var _package = _v0.a;
		var maybeNode = _v0.b;
		var nextTimestamp = A2($author$project$Model$BuildExprEditorUtils$getNextTimestamp, model.pq, model.qR);
		var maybeCveKey = A2(
			$elm$core$Maybe$andThen,
			function (_v1) {
				var node = _v1.a;
				var buildDataSource = _v1.b;
				return A2(
					$elm$core$Maybe$map,
					$author$project$Model$BuildPlanner$Component$getAnalyticsCVEKey,
					A2(
						$elm$core$Dict$get,
						node.kH.rE,
						$author$project$Model$BuildDataSource$getComponentsByDirectNodeId(buildDataSource)));
			},
			A3(
				$elm$core$Maybe$map2,
				$elm$core$Tuple$pair,
				maybeNode,
				$krisajenkins$remotedata$RemoteData$toMaybe(
					$author$project$Model$BuildDataSource$latest(model))));
		var key = _package.kH.Y;
		var versionSelectorModel = A2(
			$elm$core$Maybe$withDefault,
			A3($author$project$Views$PackageVersionSelector$init, key, maybeCveKey, _package.kH.bK),
			A2($elm$core$Dict$get, key, model.hb));
		return A2(
			$author$project$Pages$ProjectConfigHtml$viewHidden,
			model,
			{
				xj: A3($author$project$Model$AvailableVersions$get, key, nextTimestamp, model.xj),
				qX: flags,
				y9: maybeNode,
				rN: _package,
				sK: versionSelectorModel
			});
	});
var $author$project$Pages$ProjectConfig$PackageSummaryDisplayMsg = function (a) {
	return {$: 25, a: a};
};
var $author$project$Pages$ProjectConfig$Dependencies = 2;
var $author$project$Pages$ProjectConfig$LicensesMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$ProjectConfig$RequiredBy = 1;
var $author$project$Pages$ProjectConfig$SelectPackageTab = F2(
	function (a, b) {
		return {$: 35, a: a, b: b};
	});
var $author$project$Pages$ProjectConfig$Vulnerabilities = 0;
var $mgold$elm_nonempty_list$List$Nonempty$all = F2(
	function (f, _v0) {
		var x = _v0.a;
		var xs = _v0.b;
		return f(x) && A2($elm$core$List$all, f, xs);
	});
var $author$project$Pages$ProjectConfig$defaultPackageTab = 2;
var $author$project$Model$Editor$getStatusUpdatedFrom = function (status) {
	if (status.$ === 1) {
		var v = status.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$ProjectConfigHtml$versionsToLicenses = $krisajenkins$remotedata$RemoteData$map(
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.e$;
		},
		A2(
			$elm$core$Basics$composeR,
			$mgold$elm_nonempty_list$List$Nonempty$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$concatMap(
					function ($) {
						return $.go;
					}),
				$elm_community$list_extra$List$Extra$unique))));
var $author$project$Views$BundlePackagesList$dependencyView = function (_v0) {
	var feature = _v0.d;
	return A2(
		$elm$html$Html$li,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(feature)
			]));
};
var $author$project$Views$BundlePackagesList$view = F2(
	function (key, metadata) {
		return A2(
			$elm$html$Html$ul,
			_List_Nil,
			function () {
				switch (metadata.$) {
					case 3:
						var bundlesMetadata = metadata.a;
						return A2(
							$elm$core$List$map,
							$author$project$Views$BundlePackagesList$dependencyView,
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									$author$project$Model$Ingredient$filteredDependencies,
									A2($elm$core$Dict$get, key, bundlesMetadata))));
					case 1:
						return _List_fromArray(
							[$author$project$Views$Loading$dots]);
					default:
						return _List_fromArray(
							[
								$elm$html$Html$text('')
							]);
				}
			}());
	});
var $author$project$Pages$ProjectConfigHtml$viewPackage = F2(
	function (model, _v0) {
		var flags = _v0.qX;
		var normsAndVulns = _v0.rF;
		var availableVersions = _v0.xj;
		var isExpanded = _v0.rg;
		var versionSelectorModel = _v0.sK;
		var _package = _v0.rN;
		var bundlesMetadata = _v0.iS;
		var buildData = _v0.qr;
		var maybeNodeItem = _v0.za;
		var vulnKeyToRelatedPackage = function (vulnerabilityKey) {
			return {
				F2: A2(
					$krisajenkins$remotedata$RemoteData$map,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$map(
							function ($) {
								return $.ck;
							}),
						$author$project$Model$SeverityHistogram$fromSeverities),
					A2(
						$author$project$Model$NormsAndVulns$getVulnerabilities,
						normsAndVulns,
						$author$project$Model$NormsAndVulns$NamespacedVulnKey(vulnerabilityKey))),
				G7: vulnerabilityKey
			};
		};
		var remoteDataNode = function () {
			if (maybeNodeItem.$ === 1) {
				return $krisajenkins$remotedata$RemoteData$Loading;
			} else {
				var item = maybeNodeItem.a;
				return $krisajenkins$remotedata$RemoteData$Success(item.kH);
			}
		}();
		var versionUI = A2(
			$elm$html$Html$map,
			$author$project$Pages$ProjectConfig$PackageVersionSelectorMsg(versionSelectorModel),
			$author$project$Views$PackageVersionSelector$view(
				{
					xK: A2(
						$krisajenkins$remotedata$RemoteData$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.e$;
							},
							$mgold$elm_nonempty_list$List$Nonempty$head),
						remoteDataNode),
					qX: {
						Ca: flags.Ca,
						CW: flags.CW,
						Fw: flags.Fw || _Utils_eq(_package.L, $author$project$Model$Editor$Removed)
					},
					zf: versionSelectorModel,
					mT: availableVersions,
					zE: model
				}));
		var licenses = function () {
			if (buildData.$ === 2) {
				return $krisajenkins$remotedata$RemoteData$NotAsked;
			} else {
				return $author$project$Pages$ProjectConfigHtml$versionsToLicenses(remoteDataNode);
			}
		}();
		var labelStatus = flags.Fw ? $author$project$Model$Editor$Unchanged : ((!_Utils_eq(_package.L, $author$project$Model$Editor$Unchanged)) ? A2(
			$author$project$Model$Editor$itemMapStatus,
			$elm$core$Basics$always(0),
			_package.L) : A2(
			$author$project$Model$Editor$itemMapStatus,
			$elm$core$Basics$always(0),
			A2(
				$elm$core$Maybe$withDefault,
				$author$project$Model$Editor$Unchanged,
				A2($elm$core$Maybe$map, $author$project$Views$Dependencies$getEndUserFacingStatus, maybeNodeItem))));
		var indemnifiedClass = function () {
			if (flags.CW) {
				if (remoteDataNode.$ === 3) {
					var versions = remoteDataNode.a.e$;
					return (flags.D8 || A2(
						$mgold$elm_nonempty_list$List$Nonempty$all,
						function ($) {
							return $.Dm;
						},
						versions)) ? 'indemnified' : 'not-indemnified';
				} else {
					return '';
				}
			} else {
				return '';
			}
		}();
		var hasAnyItemsToShow = function (list) {
			if (list.$ === 3) {
				var listItems = list.a;
				return !$elm$core$List$isEmpty(listItems);
			} else {
				return false;
			}
		};
		var getLabelFromVersionDiff = F2(
			function (original, current) {
				return A2($author$project$Views$Dependencies$isRevisionOnlyChange, original, current) ? A2(
					$elm$html$Html$map,
					$author$project$Pages$ProjectConfig$DependenciesMsg,
					A2(
						$author$project$Views$Dependencies$viewRevisionOnlyChange,
						flags,
						{g5: current, jl: original})) : A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('updated-from-version-number')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							'From ' + $mgold$elm_nonempty_list$List$Nonempty$head(original.e$).sL)
						]));
			});
		var cves = $author$project$Model$BuildPlanner$SolveLegacyEditor$canSeeCubeCVEs(model) ? A2(
			$krisajenkins$remotedata$RemoteData$andThen,
			function (_v15) {
				var buildDataSource = _v15.a;
				var node = _v15.b;
				return A2(
					$elm$core$Maybe$withDefault,
					$krisajenkins$remotedata$RemoteData$NotAsked,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Model$BuildPlanner$Component$getAnalyticsCVEKey,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Model$NormsAndVulns$PurlVulnKey,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Model$NormsAndVulns$getVulnerabilities(model.rF),
									$krisajenkins$remotedata$RemoteData$mapError($author$project$Model$BuildPlanner$BuildPlannerError$HttpError)))),
						A2(
							$elm$core$Dict$get,
							node.rE,
							$author$project$Model$BuildDataSource$getComponentsByDirectNodeId(buildDataSource))));
			},
			A3($krisajenkins$remotedata$RemoteData$map2, $elm$core$Tuple$pair, buildData, remoteDataNode)) : A2(
			$krisajenkins$remotedata$RemoteData$andThen,
			function (_v16) {
				return A2($author$project$Pages$ProjectConfigHtml$getAllVulnerabilities, normsAndVulns, remoteDataNode);
			},
			buildData);
		var className = $author$project$Pages$ProjectConfigHtml$statusClassName(labelStatus);
		var _v1 = _Utils_Tuple2(_package.kH.Y, _package.kH.bK);
		var key = _v1.a;
		var currentConstraint = _v1.b;
		var activeTab = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Pages$ProjectConfig$defaultPackageTab,
			A2($elm$core$Dict$get, key, model.qb));
		var dependencies = A2(
			$krisajenkins$remotedata$RemoteData$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Model$BuildDataSource$getDependencies,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Dict$get(key),
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map(
							$elm$core$List$filter(
								A2(
									$elm$core$Basics$composeR,
									$author$project$Model$Namespace$key,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Model$Namespace$kind,
										$elm$core$Basics$neq(4))))),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$map(
								$elm$core$List$filter(
									A2(
										$elm$core$Basics$composeR,
										$author$project$Model$Namespace$key,
										A2(
											$elm$core$Basics$composeR,
											$author$project$Model$Namespace$kind,
											$elm$core$Basics$neq(0))))),
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$map(
									$elm$core$List$map(vulnKeyToRelatedPackage)),
								$elm$core$Maybe$withDefault(_List_Nil)))))),
			buildData);
		var requiredBys = A2(
			$krisajenkins$remotedata$RemoteData$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Model$BuildDataSource$getRequiredBys,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Dict$get(key),
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map(
							$elm$core$List$map(vulnKeyToRelatedPackage)),
						$elm$core$Maybe$withDefault(_List_Nil)))),
			buildData);
		var updatedFromVersionView = function () {
			var _v13 = _Utils_Tuple2(_package.L, maybeNodeItem);
			if (_v13.a.$ === 1) {
				var constraint = _v13.a.a.bK;
				var resolvedVersion = A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function (versionStr) {
							return ' (' + (versionStr + ')');
						},
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.e$;
								},
								A2(
									$elm$core$Basics$composeR,
									$mgold$elm_nonempty_list$List$Nonempty$head,
									function ($) {
										return $.sL;
									})),
							A2(
								$elm$core$Maybe$andThen,
								$author$project$Model$Editor$getStatusUpdatedFrom,
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.L;
									},
									maybeNodeItem)))));
				var changeStr = A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm_community$maybe_extra$Maybe$Extra$orElse,
						$elm$core$Maybe$Just('Previously \'Auto\''),
						A2(
							$elm$core$Maybe$map,
							function (item) {
								return 'Previously \'' + (A2($author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$toPythonSyntax, item, _List_Nil) + '\'');
							},
							$elm$core$List$head(
								$author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$toVersionRequirements(constraint)))));
				var breakingChangesArgs = $elm$core$Maybe$Just(
					{jo: key, pv: $elm$core$Maybe$Nothing, pT: true, nO: constraint, nP: currentConstraint});
				return A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('updated-from-version-number')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									_Utils_ap(changeStr, resolvedVersion))
								])),
							A2(
							$author$project$Misc$displayIf,
							flags.Gm && $author$project$Model$Permissions$orgCanViewBreakingChanges(model.c3),
							A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick(
										$author$project$Pages$ProjectConfig$ToggleBreakingChanges(breakingChangesArgs)),
										$elm$html$Html$Attributes$class('secondary-button small superuser-only')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Breaking Changes')
									])))
						]));
			} else {
				if (!_v13.b.$) {
					var value = _v13.b.a.kH;
					var status = _v13.b.a.L;
					var _v14 = _Utils_Tuple2(value, status);
					if (_v14.b.$ === 1) {
						var current = _v14.a;
						var original = _v14.b.a;
						return A2(getLabelFromVersionDiff, original, current);
					} else {
						return $elm$html$Html$text('');
					}
				} else {
					return $elm$html$Html$text('');
				}
			}
		}();
		if (!$author$project$Model$Namespace$kind(key)) {
			var packageCount = A2(
				$krisajenkins$remotedata$RemoteData$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Dict$get(key),
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map($author$project$Model$Ingredient$filteredDependencies),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$withDefault(_List_Nil),
							$elm$core$List$length))),
				bundlesMetadata);
			var bundleDescription = A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bundle-description')
					]),
				_List_fromArray(
					[
						function () {
						switch (bundlesMetadata.$) {
							case 3:
								var metadata = bundlesMetadata.a;
								var _v5 = A2($elm$core$Dict$get, key, metadata);
								if (!_v5.$) {
									var bundle = _v5.a;
									return $elm$html$Html$text(
										$author$project$Model$Ingredient$description(bundle));
								} else {
									return $elm$html$Html$text('');
								}
							case 2:
								return $elm$html$Html$text('');
							default:
								return $elm$html$Html$text('');
						}
					}()
					]));
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(indemnifiedClass),
							$elm$html$Html$Attributes$class(className),
							$elm$html$Html$Attributes$class('bundle-wrapper')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bundle-title')
								]),
							_List_fromArray(
								[
									$author$project$Pages$ProjectConfigHtml$itemStatusLabel(_package.L),
									A2($author$project$Views$Dependencies$viewNamespaceKey, flags, key),
									versionUI,
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('bundle-manipulation-ui')
										]),
									_List_fromArray(
										[
											$author$project$Pages$ProjectConfigHtml$removeOrRevertButton(
											{
												kg: A2($author$project$Pages$ProjectConfig$Remove, key, currentConstraint),
												kh: $author$project$Pages$ProjectConfig$Undo(key),
												Fw: flags.Fw,
												L: _package.L
											})
										]))
								])),
							bundleDescription,
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bundle-dependencies')
								]),
							_List_fromArray(
								[
									function () {
									switch (packageCount.$) {
										case 3:
											var count = packageCount.a;
											return A2(
												$elm$html$Html$map,
												$author$project$Pages$ProjectConfig$PackagesExpandMsg,
												A4(
													$author$project$Views$NamespaceExpand$caret,
													model.rQ,
													key,
													$author$project$Views$NamespaceExpand$flagsInit,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$elm$core$String$fromInt(count) + ' Packages')
														])));
										case 2:
											var err = packageCount.a;
											return A2(
												$elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														'Couldn\'t load: ' + $author$project$Http$Extra$reason(err))
													]));
										default:
											return A2(
												$elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[$author$project$Views$Loading$dots]));
									}
								}()
								])),
							A2(
							$author$project$Misc$displayIf,
							isExpanded,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('bundle-dependencies-wrapper')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('bundle-dependencies')
											]),
										_List_fromArray(
											[
												A2($author$project$Views$BundlePackagesList$view, key, bundlesMetadata)
											])),
										A2(
										$author$project$Misc$displayIf,
										flags.Ca,
										A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('bundle-cve-info')
												]),
											_List_fromArray(
												[
													function () {
													if (cves.$ === 3) {
														return A2(
															$elm$html$Html$p,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Vulnerabilities associated with packages in this bundle can be found in the Dependencies section below.')
																]));
													} else {
														return $elm$html$Html$text('');
													}
												}()
												])))
									])))
						]))
				]);
		} else {
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(indemnifiedClass),
							$elm$html$Html$Attributes$class(className),
							$elm$html$Html$Attributes$class('package'),
							$elm$html$Html$Attributes$class('item'),
							$elm$html$Html$Attributes$id(
							$author$project$Pages$ProjectConfig$generatePackageIdFromKey(_package.kH.Y))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$ProjectConfig$PackagesExpandMsg,
							A4(
								$author$project$Views$NamespaceExpand$caret,
								model.rQ,
								key,
								{
									F5: !_Utils_eq(_package.L, $author$project$Model$Editor$Removed)
								},
								_List_fromArray(
									[
										$author$project$Pages$ProjectConfigHtml$itemStatusLabel(labelStatus),
										A2($author$project$Views$Dependencies$viewNamespaceKey, flags, key)
									]))),
							versionUI,
							updatedFromVersionView,
							function () {
							if (dependencies.$ === 3) {
								var related = dependencies.a;
								return $author$project$Views$RelatedPackages$countView(related);
							} else {
								return $elm$html$Html$text('');
							}
						}(),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('package-cve-summary')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Views$PackageSummaryDisplay$choose,
									model.rO,
									{
										EH: function (_v7) {
											return A2(
												$elm$html$Html$map,
												$author$project$Pages$ProjectConfig$PackagesExpandMsg,
												A5($author$project$Views$CVEs$viewForPackage, flags, model.rQ, key, false, cves));
										},
										EM: function (_v8) {
											return A2(
												$elm$html$Html$map,
												$author$project$Pages$ProjectConfig$LicensesMsg,
												A4($author$project$Views$Licenses$viewForPackage, flags, model.rn, key, licenses));
										}
									})
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('item-actions')
								]),
							_List_fromArray(
								[
									$author$project$Pages$ProjectConfigHtml$removeOrRevertButton(
									{
										kg: A2($author$project$Pages$ProjectConfig$Remove, key, currentConstraint),
										kh: $author$project$Pages$ProjectConfig$Undo(key),
										Fw: flags.Fw,
										L: _package.L
									})
								]))
						])),
					A2(
					$author$project$Misc$displayIf,
					isExpanded && (!_Utils_eq(_package.L, $author$project$Model$Editor$Removed)),
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('item-meta-data')
							]),
						function () {
							switch (buildData.$) {
								case 2:
									return _List_fromArray(
										[
											$elm$html$Html$text('Package details are only available once dependencies are successfully resolved.')
										]);
								case 3:
									return isExpanded ? _List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('tabs')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$button,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$classList(
															_List_fromArray(
																[
																	_Utils_Tuple2('active', activeTab === 2)
																])),
															$elm$html$Html$Events$onClick(
															A2($author$project$Pages$ProjectConfig$SelectPackageTab, key, 2))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Dependencies')
														])),
													A2(
													$author$project$Misc$displayIf,
													hasAnyItemsToShow(cves) && flags.Ca,
													A2(
														$elm$html$Html$button,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$classList(
																_List_fromArray(
																	[
																		_Utils_Tuple2('active', !activeTab)
																	])),
																$elm$html$Html$Events$onClick(
																A2($author$project$Pages$ProjectConfig$SelectPackageTab, key, 0))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Vulnerabilities')
															]))),
													A2(
													$author$project$Misc$displayIf,
													hasAnyItemsToShow(requiredBys),
													A2(
														$elm$html$Html$button,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$classList(
																_List_fromArray(
																	[
																		_Utils_Tuple2('active', activeTab === 1)
																	])),
																$elm$html$Html$Events$onClick(
																A2($author$project$Pages$ProjectConfig$SelectPackageTab, key, 1))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Required By')
															])))
												])),
											A2(
											$author$project$Misc$displayIf,
											flags.Ca && (isExpanded && ((!activeTab) && (!_Utils_eq(_package.L, $author$project$Model$Editor$Removed)))),
											function () {
												if (cves.$ === 3) {
													if (!cves.a.b) {
														return $elm$html$Html$text('');
													} else {
														var vulns = cves.a;
														return A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('package-cve-details')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('severity-groups')
																		]),
																	$author$project$Views$CVEs$listBySeverity(vulns))
																]));
													}
												} else {
													return $elm$html$Html$text('');
												}
											}()),
											A2(
											$author$project$Misc$displayIf,
											isExpanded && (activeTab === 1),
											function () {
												switch (requiredBys.$) {
													case 3:
														var related = requiredBys.a;
														return $author$project$Views$RelatedPackages$view(
															{Ca: flags.Ca, mp: 0, zO: related});
													case 2:
														var buildPlannerError = requiredBys.a;
														return A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('section-header')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Model$BuildPlanner$BuildPlannerError$message(buildPlannerError))
																]));
													case 1:
														return $author$project$Views$Loading$dots;
													default:
														return $elm$html$Html$text('');
												}
											}()),
											A2(
											$author$project$Misc$displayIf,
											isExpanded && (activeTab === 2),
											function () {
												switch (dependencies.$) {
													case 3:
														var related = dependencies.a;
														return $author$project$Views$RelatedPackages$view(
															{Ca: flags.Ca, mp: 1, zO: related});
													case 2:
														var buildPlannerError = dependencies.a;
														return A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('section-header')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Model$BuildPlanner$BuildPlannerError$message(buildPlannerError))
																]));
													case 1:
														return $author$project$Views$Loading$dots;
													default:
														return $elm$html$Html$text('');
												}
											}())
										]) : _List_fromArray(
										[
											$elm$html$Html$text('')
										]);
								default:
									return _List_fromArray(
										[$author$project$Views$Loading$dots]);
							}
						}()))
				]);
		}
	});
var $author$project$Pages$ProjectConfigHtml$packageRow = F3(
	function (flags, model, _v0) {
		var _package = _v0.a;
		var maybeNode = _v0.b;
		var overrideToReadOnly = function () {
			var _v2 = _package.kH.bK;
			if (_v2.$ === 3) {
				return true;
			} else {
				return false;
			}
		}();
		var nextTimestamp = A2($author$project$Model$BuildExprEditorUtils$getNextTimestamp, model.pq, model.qR);
		var newFlags = overrideToReadOnly ? _Utils_update(
			flags,
			{Fw: true}) : flags;
		var maybeCveKey = A2(
			$elm$core$Maybe$andThen,
			function (_v1) {
				var node = _v1.a;
				var buildDataSource = _v1.b;
				return A2(
					$elm$core$Maybe$map,
					$author$project$Model$BuildPlanner$Component$getAnalyticsCVEKey,
					A2(
						$elm$core$Dict$get,
						node.kH.rE,
						$author$project$Model$BuildDataSource$getComponentsByDirectNodeId(buildDataSource)));
			},
			A3(
				$elm$core$Maybe$map2,
				$elm$core$Tuple$pair,
				maybeNode,
				$krisajenkins$remotedata$RemoteData$toMaybe(
					$author$project$Model$BuildDataSource$latest(model))));
		var key = _package.kH.Y;
		var versionSelectorModel = A2(
			$elm$core$Maybe$withDefault,
			A3($author$project$Views$PackageVersionSelector$init, key, maybeCveKey, _package.kH.bK),
			A2($elm$core$Dict$get, key, model.hb));
		var buildData = $author$project$Model$BuildDataSource$latest(model);
		var availableVersions = A2(
			$krisajenkins$remotedata$RemoteData$andThen,
			function (key_) {
				return A3($author$project$Model$AvailableVersions$get, key_, nextTimestamp, model.xj);
			},
			A2($author$project$Model$NormsAndVulns$getNormalizedKey, key, model.rF));
		return A2(
			$author$project$Pages$ProjectConfigHtml$viewPackage,
			model,
			{
				xj: availableVersions,
				qr: buildData,
				iS: model.iS,
				qX: newFlags,
				rg: A2($author$project$Views$NamespaceExpand$isExpanded, key, model.rQ),
				za: maybeNode,
				rF: model.rF,
				rN: _package,
				sK: versionSelectorModel
			});
	});
var $author$project$Pages$ProjectConfigHtml$languagePackagesTable = F3(
	function (flags, model, _v0) {
		var language = _v0.a;
		var packages = _v0.b;
		var packageRows = $elm$core$List$concat(
			A2(
				$elm$core$List$map,
				A2($author$project$Pages$ProjectConfigHtml$packageRow, flags, model),
				A2(
					$elm$core$List$sortBy,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$first,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.kH;
							},
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Y;
								},
								A2($elm$core$Basics$composeR, $author$project$Model$Namespace$getName, $elm$core$String$toLower)))),
					packages)));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('section-header')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('language-name')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(language)
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('item-count')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													A3(
														$elm_community$string_extra$String$Extra$pluralize,
														'Package',
														'Packages',
														$elm$core$List$length(packages)))
												]))
										]))
								])),
							A2(
							$elm$html$Html$map,
							$author$project$Pages$ProjectConfig$PackageSummaryDisplayMsg,
							A2($author$project$Views$PackageSummaryDisplay$viewButtons, flags, model.rO))
						])),
				packageRows));
	});
var $author$project$Pages$ProjectConfigHtml$superuserItemsTable = function (items) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('superuser-only')
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('package-table-header-row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('section-header')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h3,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Internal Requirements')
											]))
									]))
							]))
					]),
					items
				])));
};
var $author$project$Pages$ProjectConfig$RemoveBuildFlag = function (a) {
	return {$: 29, a: a};
};
var $author$project$Pages$ProjectConfig$RevertBuildFlag = function (a) {
	return {$: 33, a: a};
};
var $author$project$Pages$ProjectConfigHtml$viewBuildFlag = F2(
	function (flags, item) {
		var buildFlag = item.kH;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					$author$project$Pages$ProjectConfigHtml$statusClassName(item.L)),
					$elm$html$Html$Attributes$class('item')
				]),
			_List_fromArray(
				[
					$author$project$Pages$ProjectConfigHtml$itemStatusLabel(item.L),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('item-name')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(buildFlag.w),
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									$elm$core$Basics$append('='),
									buildFlag.kH)))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('item-actions')
						]),
					_List_fromArray(
						[
							$author$project$Pages$ProjectConfigHtml$removeOrRevertButton(
							{
								kg: $author$project$Pages$ProjectConfig$RemoveBuildFlag(buildFlag),
								kh: $author$project$Pages$ProjectConfig$RevertBuildFlag(buildFlag),
								Fw: flags.Fw,
								L: item.L
							})
						]))
				]));
	});
var $author$project$Pages$ProjectConfig$RemoveCamelFlag = function (a) {
	return {$: 30, a: a};
};
var $author$project$Pages$ProjectConfig$RevertCamelFlag = function (a) {
	return {$: 34, a: a};
};
var $author$project$Pages$ProjectConfigHtml$viewCamelFlag = F2(
	function (flags, item) {
		var camelFlag = item.kH;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					$author$project$Pages$ProjectConfigHtml$statusClassName(item.L)),
					$elm$html$Html$Attributes$class('item')
				]),
			_List_fromArray(
				[
					$author$project$Pages$ProjectConfigHtml$itemStatusLabel(item.L),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('item-name')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(camelFlag)
						])),
					$author$project$Pages$ProjectConfigHtml$removeOrRevertButton(
					{
						kg: $author$project$Pages$ProjectConfig$RemoveCamelFlag(camelFlag),
						kh: $author$project$Pages$ProjectConfig$RevertCamelFlag(camelFlag),
						Fw: flags.Fw,
						L: item.L
					})
				]));
	});
var $author$project$Pages$ProjectConfigHtml$viewRequirements = F2(
	function (model, flags) {
		var projectContainsLangWithBundles = A2(
			$elm$core$List$any,
			$author$project$Model$Language$supportsBundles,
			A2(
				$elm$core$List$filterMap,
				$author$project$Model$Language$fromString,
				$elm$core$Dict$keys(
					$author$project$Model$BuildPlanner$SolveLegacyEditor$getLanguages(model.qR))));
		var packageItems = $author$project$Model$BuildPlanner$SolveLegacyEditor$getPackageItems(model.qR);
		var requirementItems = projectContainsLangWithBundles ? _Utils_ap(
			$author$project$Model$BuildPlanner$SolveLegacyEditor$getBundleItems(model.qR),
			packageItems) : packageItems;
		var getReqAndNodePairs = $elm$core$List$map(
			function (item) {
				return A2(
					$elm$core$Tuple$pair,
					item,
					A2(
						$elm$core$Maybe$andThen,
						A2($elm_community$basics_extra$Basics$Extra$flip, $author$project$Model$BuildDataSource$getNodeItemByNodeId, model.iQ),
						A2(
							$elm$core$Maybe$andThen,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Model$BuildDataSource$getResolvedRequirements,
								$author$project$Model$ResolvedRequirements$getByNamespaceKey(item.kH.Y)),
							$krisajenkins$remotedata$RemoteData$toMaybe(
								$author$project$Model$BuildDataSource$latest(model)))));
			});
		var packagesByLanguage = A2(
			$elm$core$List$sortWith,
			$author$project$Model$BuildExprEditorUtils$categorySorter,
			$elm$core$Dict$toList(
				A2(
					$elm_community$dict_extra$Dict$Extra$groupBy,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$first,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.kH;
							},
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Y;
								},
								$author$project$Model$BuildExprEditorUtils$getCategory))),
					getReqAndNodePairs(requirementItems))));
		var editor = model.qR;
		var superuserItems = flags.Gm ? _Utils_ap(
			A2(
				$elm$core$List$map,
				$author$project$Pages$ProjectConfigHtml$viewCamelFlag(flags),
				$author$project$Model$BuildPlanner$SolveLegacyEditor$getCamelFlagItems(editor)),
			_Utils_ap(
				A2(
					$elm$core$List$map,
					$author$project$Pages$ProjectConfigHtml$viewBuildFlag(flags),
					$author$project$Model$BuildPlanner$SolveLegacyEditor$getBuildFlagItems(editor)),
				A2(
					$elm$core$List$concatMap,
					A2($author$project$Pages$ProjectConfigHtml$hiddenPackageRow, flags, model),
					getReqAndNodePairs(
						$author$project$Model$BuildPlanner$SolveLegacyEditor$getHiddenItems(editor))))) : _List_Nil;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('package-table package-list')
				]),
			A3(
				$author$project$Misc$concatIf,
				!$elm$core$List$isEmpty(superuserItems),
				$author$project$Pages$ProjectConfigHtml$superuserItemsTable(superuserItems),
				A2(
					$elm$core$List$cons,
					A2(
						$author$project$Misc$displayIf,
						flags.Gm && (!flags.Fw),
						A2(
							$elm$html$Html$map,
							$author$project$Pages$ProjectConfig$CustomRequirementInputMsg,
							$author$project$Views$CustomRequirementInput$view(model.on))),
					A2(
						$elm$core$List$map,
						A2($author$project$Pages$ProjectConfigHtml$languagePackagesTable, flags, model),
						packagesByLanguage))));
	});
var $author$project$Pages$ProjectConfig$ToggleImageComponents = function (a) {
	return {$: 48, a: a};
};
var $author$project$Model$BuildPlanner$ComponentRelationship$componentId = function (_v0) {
	var data = _v0;
	return data.xJ;
};
var $author$project$Model$BuildDataSource$getComponentsForIds = function (_v0) {
	var cached = _v0.df;
	return $elm$core$List$filterMap(
		function (id) {
			return A2(
				$elm$core$Dict$get,
				$danyx23$elm_uuid$Uuid$toString(id),
				cached.tl);
		});
};
var $author$project$Model$BuildPlanner$ComponentRelationship$type_ = function (_v0) {
	var data = _v0;
	return data.gR;
};
var $author$project$Views$ScannedImage$viewSeverityHistogram = F2(
	function (normsAndVulns, vulnKey) {
		var _v0 = A2(
			$krisajenkins$remotedata$RemoteData$map,
			$author$project$Model$SeverityHistogram$fromVulnerabilities,
			A2(
				$author$project$Model$NormsAndVulns$getVulnerabilities,
				normsAndVulns,
				$author$project$Model$NormsAndVulns$NamespacedVulnKey(vulnKey)));
		switch (_v0.$) {
			case 0:
				return $author$project$Views$Loading$boxes;
			case 1:
				return $author$project$Views$Loading$boxes;
			case 2:
				return $elm$html$Html$text('');
			default:
				var severityHistogram = _v0.a;
				return $author$project$Views$CVESummary$viewTotals(
					{xI: true, y7: $elm$core$Maybe$Nothing, zd: $elm$core$Maybe$Nothing, F2: severityHistogram});
		}
	});
var $author$project$Views$ScannedImage$viewComponent = F2(
	function (normsAndVulns, component) {
		var vulnKey = {
			w: $author$project$Model$BuildPlanner$Component$name(component),
			aE: $author$project$Model$BuildPlanner$Component$namespace(component),
			aI: $author$project$Model$BuildPlanner$Component$version(component)
		};
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('scanned-image-component')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('scanned-image-metadata')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(vulnKey.w),
							$elm$html$Html$text('@'),
							$elm$html$Html$text(vulnKey.aI)
						])),
					A2(
					$author$project$Misc$displayIf,
					false,
					A2($author$project$Views$ScannedImage$viewSeverityHistogram, normsAndVulns, vulnKey))
				]));
	});
var $author$project$Views$ScannedImage$view = F5(
	function (buildDataSource, normsAndVulns, isOpenDict, onToggleList, image) {
		var vulnKey = A2($author$project$Model$Vulnerability$fromNamespaceKey, image.Y, image.aI);
		var isOpen = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Dict$get,
				$author$project$Views$ScannedImage$toIdentifier(image),
				isOpenDict));
		var directComponentIds = A2(
			$elm$core$List$filterMap,
			function (relationship) {
				return ($author$project$Model$BuildPlanner$ComponentRelationship$type_(relationship) === 1) ? $elm$core$Maybe$Just(
					$author$project$Model$BuildPlanner$ComponentRelationship$componentId(relationship)) : $elm$core$Maybe$Nothing;
			},
			image.FA);
		var components = A2(
			$elm$core$List$sortBy,
			$author$project$Model$BuildPlanner$Component$sortKey,
			A2($author$project$Model$BuildDataSource$getComponentsForIds, buildDataSource, directComponentIds));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('scanned-image')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$header,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(vulnKey.w),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('version')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(' ' + vulnKey.aI)
												]))
										])),
									A2(
									$author$project$Misc$displayIf,
									false,
									A2($author$project$Views$ScannedImage$viewSeverityHistogram, normsAndVulns, vulnKey))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('toggle-wrapper'),
							$elm$html$Html$Attributes$class('default-cursor'),
							$elm$html$Html$Events$onClick(
							onToggleList(image))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('toggle-icon'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('expanded', isOpen)
										]))
								]),
							_List_fromArray(
								[
									$author$project$Views$Icon$view(
									$author$project$Views$Icon$icon(13))
								])),
							$elm$html$Html$text(
							$elm$core$String$fromInt(
								$elm$core$List$length(components))),
							$elm$html$Html$text(' Components')
						])),
					A2(
					$author$project$Misc$displayIf,
					isOpen,
					A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('bundle-dependencies')
							]),
						A2(
							$elm$core$List$map,
							$author$project$Views$ScannedImage$viewComponent(normsAndVulns),
							components)))
				]));
	});
var $author$project$Pages$ProjectConfigHtml$viewScannedImages = function (model) {
	var scannedImages = function () {
		var _v0 = $author$project$Model$BuildDataSource$latest(model);
		if (_v0.$ === 3) {
			var buildData = _v0.a;
			return A2(
				$elm$core$List$map,
				A4($author$project$Views$ScannedImage$view, buildData, model.rF, model.mk, $author$project$Pages$ProjectConfig$ToggleImageComponents),
				$author$project$Model$BuildDataSource$getScannedImages(buildData));
		} else {
			return _List_Nil;
		}
	}();
	var display = $elm$core$List$length(scannedImages) > 0;
	return A2(
		$author$project$Misc$displayIf,
		display,
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('new-box')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Scanned Images')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('scanned-images-list')
						]),
					scannedImages)
				])));
};
var $author$project$Pages$ProjectConfigHtml$selectedBranchLatestCommitID = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		$author$project$Model$Branch$getCommitID,
		A2($elm$core$Maybe$map, $author$project$Views$BranchPicker$getSelectedBranch, model.fJ));
};
var $author$project$Pages$ProjectConfigHtml$viewingLatestCommit = function (model) {
	return _Utils_eq(
		$elm$core$Maybe$Just(
			$author$project$Model$Commit$getCommitID(model.f0)),
		$author$project$Pages$ProjectConfigHtml$selectedBranchLatestCommitID(model));
};
var $author$project$Pages$ProjectConfigHtml$view = F2(
	function (model, session) {
		var userHasEditingRights = A2(
			$author$project$Model$Permissions$canEditProjects,
			model.c3.AC,
			$author$project$Model$Session$getUser(session));
		var updateNotification = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('branch-has-updates')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Changes available from upstream branch —\u00A0'),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-button small'),
							$elm$html$Html$Events$onClick($author$project$Pages$ProjectConfig$ShowUpdateForkModal)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Update')
						]))
				]));
		var updateForkModal = function (updateForkModel) {
			return A2(
				$elm$core$Basics$composeR,
				$author$project$Views$UpdateForkModal$view(session),
				$elm$html$Html$map($author$project$Pages$ProjectConfig$UpdateForkModalMsg))(updateForkModel);
		};
		var solverVersionView = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('superuser-only new-box')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Solver Version')
						])),
					A2(
					$elm$html$Html$select,
					_List_fromArray(
						[
							$elm$html$Html$Events$onInput($author$project$Pages$ProjectConfig$SetSolverVersion)
						]),
					A2(
						$elm$core$List$map,
						function (maybeVersion) {
							var versionStr = A2(
								$elm$core$Maybe$withDefault,
								'(Unpinned)',
								A2($elm$core$Maybe$map, $elm$core$String$fromInt, maybeVersion));
							var currentVersion = $author$project$Model$BuildPlanner$SolveLegacyEditor$getSolverVersion(model.qR);
							return A2(
								$elm$html$Html$option,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$selected(
										_Utils_eq(currentVersion, maybeVersion)),
										$elm$html$Html$Attributes$value(versionStr)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(versionStr)
									]));
						},
						$author$project$Pages$ProjectConfigHtml$supportedSolverVersions))
				]));
		var projectRouteFactory = function (projectRoute) {
			return $author$project$Model$Route$Protected(
				$author$project$Model$Route$Org(
					{
						ix: model.c3.AC,
						vI: $author$project$Model$Route$OrgProject(
							{
								vT: $author$project$Model$Project$getName(model.c5),
								zL: projectRoute
							})
					}));
		};
		var projectName = $author$project$Model$Project$getName(model.c5);
		var orgRoute = $author$project$Model$Route$Protected(
			$author$project$Model$Route$Org(
				{
					ix: model.c3.AC,
					vI: $author$project$Model$Route$OrgIndex($elm$core$Maybe$Nothing)
				}));
		var markerView = A2(
			$author$project$Misc$displayMaybe,
			function (currentKind) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('superuser-only new-box')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Build Type')
								])),
							A2(
							$elm$html$Html$select,
							_List_fromArray(
								[
									$elm$html$Html$Events$onInput($author$project$Pages$ProjectConfig$SetMarkersFromKind)
								]),
							A2(
								$elm$core$List$map,
								function (kind) {
									var kindStr = $author$project$Model$BuildPlanner$BuildExpr$MarkerKind$toString(kind);
									return A2(
										$elm$html$Html$option,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$selected(
												_Utils_eq(currentKind, kind)),
												$elm$html$Html$Attributes$value(kindStr)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(kindStr)
											]));
								},
								$author$project$Model$BuildPlanner$BuildExpr$MarkerKind$allKinds))
						]));
			},
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.kH;
				},
				$author$project$Model$BuildPlanner$BuildExprEditor$Simple$getMarkerItem(model.qR)));
		var licensesEnabled = A2($author$project$Pages$ProjectConfigHtml$licensesEnabledAndVisible, model.c3, session);
		var languageItems = $author$project$Model$BuildPlanner$SolveLegacyEditor$getLanguageItems(model.qR);
		var isSuperUserWithFeaturesVisible = $author$project$Model$Session$isSuperUserWithFeaturesVisible(session);
		var packages = _Utils_ap(
			$author$project$Model$BuildPlanner$SolveLegacyEditor$getBundleItems(model.qR),
			_Utils_ap(
				$author$project$Model$BuildPlanner$SolveLegacyEditor$getPackageItems(model.qR),
				isSuperUserWithFeaturesVisible ? $author$project$Model$BuildPlanner$SolveLegacyEditor$getHiddenItems(model.qR) : _List_Nil));
		var pkgCount = $elm$core$List$length(packages);
		var packageLimitReached = A2($author$project$Pages$ProjectConfig$packageLimitReached, pkgCount, model.c3);
		var isPrePanorama = $author$project$Model$BuildPlanner$SolveLegacyEditor$isPrePanorama(model.qR);
		var isPanorama2 = $author$project$Model$BuildPlanner$SolveLegacyEditor$isPanorama2(model.qR);
		var isPanorama1 = $author$project$Model$BuildPlanner$SolveLegacyEditor$isPanorama1(model.qR);
		var isManagedProject = $author$project$Model$Project$getIsManaged(model.c5);
		var isLatestCommit = $author$project$Views$BranchPicker$commitIsLatest(
			{f0: model.f0, zf: model.fJ, kq: model.kq});
		var isDistribtionOnly = $author$project$Model$Project$getIsDistributionOnly(model.c5);
		var projectEditableStatus = ((!isManagedProject) && ((!isDistribtionOnly) && userHasEditingRights)) ? (isLatestCommit ? 0 : 1) : 2;
		var pinAllDependenciesEnabled = (!projectEditableStatus) && (userHasEditingRights && $author$project$Model$Permissions$orgCanSetAllToAutoOrPinned(model.c3));
		var timestampSettingsEnabled = (!projectEditableStatus) && $author$project$Model$Permissions$orgCanManageTimestamps(model.c3);
		var showTimestampSettings = (!isDistribtionOnly) && (isSuperUserWithFeaturesVisible || timestampSettingsEnabled);
		var indemnificationEnabled = $author$project$Pages$ProjectConfigHtml$isIndemnificationEnabled(model);
		var hasAnyConstrainedPackages = A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.kH;
				},
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.bK;
					},
					A2($elm$core$Basics$composeR, $author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$isAuto, $elm$core$Basics$not))),
			packages);
		var displayUpdateNotification = function () {
			var isOutOfDate = A2(
				$elm$core$Maybe$withDefault,
				false,
				A2($elm$core$Maybe$map, $author$project$Views$BranchPicker$selectedBranchIsOutdated, model.fJ));
			return (!projectEditableStatus) && (isOutOfDate && $elm_community$maybe_extra$Maybe$Extra$isNothing(model.kE));
		}();
		var cvesEnabled = A2($author$project$Pages$ProjectConfigHtml$cvesEnabledAndVisible, model.c3, session);
		var flags = {Ca: cvesEnabled, CW: indemnificationEnabled, DX: licensesEnabled, D8: isManagedProject, Fc: pinAllDependenciesEnabled, Fw: !(!projectEditableStatus), Gm: isSuperUserWithFeaturesVisible};
		var displayModal = function (contentType) {
			switch (contentType) {
				case 0:
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$ProjectConfig$AddPackagesModalMsg,
						A3($author$project$Views$AddPackagesModal$view, flags, model.iM, model));
				case 1:
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$ProjectConfig$ImportPackagesModalMsg,
						A2($author$project$Views$ImportPackagesModal$view, model.oJ, model));
				case 2:
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$ProjectConfig$LanguageSelectionModalMsg,
						A3($author$project$Views$LanguageSelectionModal$view, session, model.oX, model));
				default:
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$ProjectConfig$PlatformSelectionModalMsg,
						A3($author$project$Views$PlatformSelectionModal$view, session, model.pp, model));
			}
		};
		var copyModeView = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('superuser-only new-box'),
					$elm$html$Html$Attributes$id('copy-mode-setting')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Formatting')
						])),
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('checkbox')
								]),
							_List_Nil),
							$elm$html$Html$text('Format package list for copy & pasting.')
						]))
				]));
		var buildData = $author$project$Model$BuildDataSource$latest(model);
		var indemnificationFinishedLoading = $krisajenkins$remotedata$RemoteData$isSuccess(buildData);
		var breakingChangesDialog = function (innerModel) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('sliding-tray')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('sliding-tray-content breaking-changes-dialog'),
								$elm$html$Html$Attributes$id($author$project$Pages$ProjectConfig$breakingChangesDialogId)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$ProjectConfig$BreakingChangesMsg,
								$author$project$Components$BreakingChanges$view(innerModel)),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('secondary-button close-dialog-button'),
										$elm$html$Html$Events$onClick(
										$author$project$Pages$ProjectConfig$ToggleBreakingChanges($elm$core$Maybe$Nothing))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Close')
									]))
							]))
					]));
		};
		var branchPicker = A2(
			$author$project$Misc$displayMaybe,
			function (branchModel) {
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$ProjectConfig$BranchPickerViewMsg,
					A4(
						$elm$html$Html$Lazy$lazy3,
						$author$project$Views$BranchPicker$view,
						branchModel,
						model.c3,
						$author$project$Model$Session$getUser(session)));
			},
			model.fJ);
		var bothSolvesSucceed = function () {
			var _v15 = _Utils_Tuple2(model.Cu, model.Ep);
			if ((_v15.a.$ === 3) && (_v15.b.$ === 3)) {
				return true;
			} else {
				return false;
			}
		}();
		var saveCommitView = F2(
			function (savingCommit, newBuildData) {
				var solverStatus = function (bD) {
					switch (bD.$) {
						case 1:
							return A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Loading')
									]));
						case 2:
							return A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('failed')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Solve Failed')
									]));
						case 3:
							return A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('solved')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Solved')
									]));
						default:
							return $elm$html$Html$text('');
					}
				};
				var disabledImpactButton = A2(
					$author$project$Misc$displayIf,
					$author$project$Model$Permissions$orgCanAccessImpactReport(model.c3),
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('button-with-tooltip')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('primary-button disabled'),
										$elm$html$Html$Attributes$disabled(true)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Review Impact')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('tooltip')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h4,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Impact report not available')
											])),
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('An Impact Report is only available when comparing two successfully resolved sets of dependencies.')
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('solve-statuses')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$strong,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Previous Commit')
															])),
														solverStatus(model.Cu)
													])),
												A2(
												$elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$strong,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Current Change')
															])),
														solverStatus(model.Ep)
													]))
											]))
									]))
							])));
				var viewRec = function () {
					var successRec = {
						nX: A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									bothSolvesSucceed ? $author$project$Views$ImpactReportButton$generateOrView(
									{
										x3: !$krisajenkins$remotedata$RemoteData$isSuccess(model.Ep),
										Eq: model.j_,
										EF: model.f0,
										EK: $author$project$Pages$ProjectConfig$RequestImpactReport,
										c3: model.c3,
										c5: model.c5
									}) : disabledImpactButton
								])),
						oz: A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('status-line')
								]),
							_List_fromArray(
								[
									$author$project$Views$Icon$view(
									$author$project$Views$Icon$icon(11)),
									$elm$html$Html$text('Successfully resolved')
								])),
						oG: false,
						oH: 'Dependency Status',
						pn: 'success',
						pI: _List_fromArray(
							[
								$elm$html$Html$Attributes$class('primary-button'),
								$elm$html$Html$Attributes$class('save-build')
							]),
						pJ: 'Save Changes'
					};
					var loadingRec = {
						nX: A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('loading-bouncer')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('bar')
												]),
											_List_Nil)
										])),
									disabledImpactButton
								])),
						oz: A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Resolving dependencies')
								])),
						oG: false,
						oH: 'Dependency Status',
						pn: 'loading',
						pI: _List_fromArray(
							[
								$elm$html$Html$Attributes$class('primary-button')
							]),
						pJ: 'Save Changes'
					};
					var failureRec = {
						nX: A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[disabledImpactButton])),
						oz: A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('status-line')
								]),
							_List_fromArray(
								[
									$author$project$Views$Icon$view(
									$author$project$Views$Icon$icon(86)),
									$elm$html$Html$text('Unable to resolve')
								])),
						oG: false,
						oH: 'Dependency Status',
						pn: 'failure',
						pI: _List_fromArray(
							[
								$elm$html$Html$Attributes$class('secondary-button')
							]),
						pJ: 'Save Changes'
					};
					switch (newBuildData.$) {
						case 3:
							return successRec;
						case 2:
							return failureRec;
						default:
							return loadingRec;
					}
				}();
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('commit-box')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('header'),
									$elm$html$Html$Attributes$class(viewRec.pn)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(viewRec.oH)
										])),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[viewRec.oz])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button-wrapper')
										]),
									_List_fromArray(
										[viewRec.nX]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('commit-message-ui')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('comment')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Editing project configuration'),
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('item-count')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('('),
															$elm$html$Html$text(
															A3(
																$elm_community$string_extra$String$Extra$pluralize,
																'change',
																'changes',
																$author$project$Pages$ProjectConfig$getChangeCount(model))),
															$elm$html$Html$text(' made)')
														]))
												])),
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$placeholder('Indicate the reason for this change (Optional)'),
													$elm$html$Html$Attributes$type_('text'),
													$elm$html$Html$Attributes$disabled(savingCommit),
													$elm$html$Html$Events$onInput($author$project$Pages$ProjectConfig$CommentChanged),
													$elm$html$Html$Attributes$value(model.hq),
													$elm$html$Html$Attributes$maxlength($author$project$Pages$ProjectConfig$maximumCommentLength)
												]),
											_List_Nil),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('letter-count')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromInt(
														$elm$core$String$length(model.hq)) + ('/' + $elm$core$String$fromInt($author$project$Pages$ProjectConfig$maximumCommentLength)))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('buttons')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											A2(
												$elm$core$List$cons,
												$elm$html$Html$Events$onClick(
													$author$project$Pages$ProjectConfig$AttemptSaveCommit(viewRec.oG)),
												A2(
													$elm$core$List$cons,
													$elm$html$Html$Attributes$disabled(savingCommit),
													viewRec.pI)),
											_List_fromArray(
												[
													$elm$html$Html$text(
													savingCommit ? 'Saving...' : viewRec.pJ)
												])),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('secondary-button'),
													$elm$html$Html$Events$onClick($author$project$Pages$ProjectConfig$Reset),
													$elm$html$Html$Attributes$disabled(savingCommit)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Cancel')
												]))
										]))
								]))
						]));
			});
		var anyChangesToCommit = $author$project$Pages$ProjectConfig$hasChangesToCommit(model);
		var commitInfoView = isDistribtionOnly ? $elm$html$Html$text('') : (anyChangesToCommit ? A2(saveCommitView, model.hQ, model.Ep) : ((!model.kq) ? $elm$html$Html$text('') : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('loading-branch-bar')
				]),
			_List_fromArray(
				[
					$author$project$Views$Loading$dots,
					$elm$html$Html$text('Loading')
				]))));
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('project-configuration'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('branch-reloading', model.kq)
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$Misc$displayMaybe, breakingChangesDialog, model.kZ),
					A2(
					$author$project$Misc$displayMaybe,
					function (err) {
						return A2(
							$author$project$Views$UnsupportedProjectModal$view,
							session,
							{
								DP: $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getUnknownAps(err),
								vI: orgRoute,
								zL: projectRouteFactory,
								Go: $author$project$Model$Permissions$orgSupportEnabled(model.c3)
							});
					},
					model.AA),
					A2(
					$author$project$Misc$displayIf,
					model.uk && ((!model.ul) && _Utils_eq(model.AA, $elm$core$Maybe$Nothing)),
					A2(
						$author$project$Views$NewForkPopup$view,
						$author$project$Pages$ProjectConfig$DismissWelcomeModal,
						$author$project$Model$Project$getForkedFrom(model.c5))),
					A2(
					$author$project$Misc$displayIf,
					model.yJ && (!model.ul),
					A5($author$project$Views$FromCommitPopup$view, $author$project$Pages$ProjectConfig$DismissWelcomeModal, model.c3.AC, projectName, model.oi, $author$project$Pages$ProjectConfig$CopyClipboard)),
					A2($author$project$Misc$displayMaybe, updateForkModal, model.kE),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('branch-ui')
						]),
					_List_fromArray(
						[
							branchPicker,
							A2($author$project$Misc$displayIf, displayUpdateNotification, updateNotification)
						])),
					A2(
					$author$project$Misc$displayIf,
					!isLatestCommit,
					A3(
						$author$project$Views$CommitStatusBar$viewPastCommit,
						session,
						$author$project$Model$Route$routeToString(
							A2(
								$author$project$Model$Route$projectConfig,
								{ix: model.c3.AC, vT: projectName},
								A2(
									$author$project$Model$Route$withBranchName,
									A2($elm$core$Maybe$andThen, $author$project$Views$BranchPicker$getSelectedNameIfNotDefault, model.fJ),
									$author$project$Model$Route$projectConfigParams))),
						model.f0)),
					commitInfoView,
					function () {
					if (isDistribtionOnly) {
						return $author$project$Pages$ProjectConfigHtml$distribtionOnlyView(model);
					} else {
						var onFocusTooltip = A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('focus-tooltip'),
									$elm$html$Html$Attributes$id($author$project$Pages$ProjectConfigHtml$focusTooltipId)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Add packages to your project')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Add packages by searching our trusted catalogue or import packages from a requirements file.')
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('secondary-button'),
											$elm$html$Html$Events$onClick($author$project$Pages$ProjectConfig$DismissAddPackageFocus)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('OK, got it!')
										]))
								]));
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('columns')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('column narrow')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Misc$displayIf,
											(!projectEditableStatus) && isPrePanorama,
											A2(
												$elm$html$Html$map,
												$author$project$Pages$ProjectConfig$TimestampMsg,
												A2(
													$author$project$Views$Timestamp$checkForUpdatesButton,
													model,
													$author$project$Pages$ProjectConfigHtml$viewingLatestCommit(model)))),
											A2(
											$author$project$Misc$displayIf,
											showTimestampSettings,
											A2(
												$elm$html$Html$map,
												$author$project$Pages$ProjectConfig$TimestampMsg,
												A3(
													$author$project$Views$Timestamp$view,
													model.hX,
													model,
													{
														DI: isSuperUserWithFeaturesVisible,
														Gn: isSuperUserWithFeaturesVisible && (!timestampSettingsEnabled),
														G5: $author$project$Pages$ProjectConfigHtml$viewingLatestCommit(model)
													}))),
											A2(
											$author$project$Misc$displayIf,
											isPrePanorama,
											A2($author$project$Pages$ProjectConfigHtml$viewPlatforms, model, projectEditableStatus)),
											A2(
											$author$project$Misc$displayIf,
											cvesEnabled && isPrePanorama,
											A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('new-box')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('cve-summary')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$h4,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('Total Vulnerabilities'),
																		A2(
																		$elm$html$Html$span,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('explanation')
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text('(CVEs)')
																			])),
																		A2(
																		$elm$html$Html$span,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('more-info-tooltip')
																			]),
																		_List_fromArray(
																			[
																				$author$project$Views$Icon$view(
																				$author$project$Views$Icon$icon(52)),
																				A2(
																				$elm$html$Html$div,
																				_List_fromArray(
																					[
																						$elm$html$Html$Attributes$class('content')
																					]),
																				_List_fromArray(
																					[
																						A2(
																						$elm$html$Html$p,
																						_List_Nil,
																						_List_fromArray(
																							[
																								$elm$html$Html$text('Total number of CVEs, categorized by severity, in the language core, packages and dependencies in this runtime.')
																							]))
																					]))
																			]))
																	]))
															])),
														function () {
														switch (buildData.$) {
															case 2:
																return $elm$html$Html$text('Not available—this runtime failed to solve');
															case 3:
																var buildDataSource = buildData.a;
																var cveSeverities = A2(
																	$krisajenkins$remotedata$RemoteData$map,
																	A2(
																		$elm$core$Basics$composeR,
																		$elm$core$List$concat,
																		A2(
																			$elm$core$Basics$composeR,
																			$elm_community$list_extra$List$Extra$uniqueBy(
																				function ($) {
																					return $.B9;
																				}),
																			A2(
																				$elm$core$Basics$composeR,
																				$elm$core$List$map(
																					function ($) {
																						return $.ck;
																					}),
																				$author$project$Model$SeverityHistogram$fromSeverities))),
																	$author$project$Misc$remoteDataConcat(
																		$author$project$Model$BuildPlanner$SolveLegacyEditor$canSeeCubeCVEs(model) ? A2(
																			$elm$core$List$map,
																			function (key) {
																				return A2(
																					$author$project$Model$NormsAndVulns$getVulnerabilities,
																					model.rF,
																					$author$project$Model$NormsAndVulns$PurlVulnKey(key));
																			},
																			$elm_community$list_extra$List$Extra$unique(
																				A2(
																					$elm$core$List$map,
																					$author$project$Model$BuildPlanner$Component$getAnalyticsCVEKey,
																					A2(
																						$elm$core$List$filterMap,
																						function (node) {
																							return A2(
																								$elm$core$Dict$get,
																								node.rE,
																								$author$project$Model$BuildDataSource$getComponentsByDirectNodeId(buildDataSource));
																						},
																						A2(
																							$elm$core$List$map,
																							$elm$core$Tuple$second,
																							$elm$core$Dict$toList(
																								$author$project$Model$BuildDataSource$getNodesByKey(buildDataSource))))))) : A2(
																			$elm$core$List$map,
																			function (key) {
																				return A2(
																					$author$project$Model$NormsAndVulns$getVulnerabilities,
																					model.rF,
																					$author$project$Model$NormsAndVulns$NamespacedVulnKey(key));
																			},
																			A2(
																				$elm_community$list_extra$List$Extra$uniqueBy,
																				function (key) {
																					return _Utils_Tuple2(
																						$author$project$Model$Namespace$key(key),
																						key.aI);
																				},
																				$author$project$Model$BuildDataSource$getAllVulnerabilityKeys(buildDataSource)))));
																switch (cveSeverities.$) {
																	case 3:
																		var severityHistogram = cveSeverities.a;
																		return $author$project$Views$CVESummary$viewTotals(
																			{xI: false, y7: $elm$core$Maybe$Nothing, zd: $elm$core$Maybe$Nothing, F2: severityHistogram});
																	case 2:
																		return A2(
																			$elm$html$Html$span,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$elm$html$Html$text('There was an error requesting Vulnerability information.')
																				]));
																	default:
																		return $author$project$Views$Loading$dots;
																}
															default:
																return $author$project$Views$Loading$dots;
														}
													}()
													]))),
											A2($author$project$Misc$displayIf, isSuperUserWithFeaturesVisible, markerView),
											A2($author$project$Misc$displayIf, isSuperUserWithFeaturesVisible, solverVersionView),
											A2($author$project$Misc$displayIf, isSuperUserWithFeaturesVisible, copyModeView),
											A2(
											$author$project$Misc$displayIf,
											isLatestCommit && isPrePanorama,
											$author$project$Views$CommitStatusBar$viewLatestCommit(
												{
													f0: model.f0,
													c3: model.c3,
													vT: $author$project$Model$Project$getName(model.c5),
													l: session,
													F8: model.sl && (!$author$project$Pages$ProjectConfig$hasChangesToCommit(model))
												}))
										])),
									function () {
									var _v2 = model.hj;
									if (_v2.$ === 1) {
										var modal = _v2.a;
										return displayModal(modal);
									} else {
										return $elm$html$Html$text('');
									}
								}(),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('column')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											$author$project$Pages$ProjectConfig$SolveErrorNoticeMsg,
											A3(
												$author$project$Views$PlanningErrorNotice$view,
												session,
												model.ss,
												{Cb: buildData, CJ: hasAnyConstrainedPackages, GU: !projectEditableStatus})),
											A2(
											$author$project$Misc$displayIf,
											isPrePanorama,
											A5($author$project$Pages$ProjectConfigHtml$viewLanguages, model, flags, languageItems, buildData, projectEditableStatus)),
											function () {
											var importPackagesText = $author$project$Views$ImportPackagesModal$importButtonText(model.oJ);
											var allowedToSetAllToAutoOrPinned = $author$project$Model$Permissions$orgCanSetAllToAutoOrPinned(model.c3);
											var allAlreadyExact = $author$project$Model$BuildExprEditorUtils$areAllExact(model.qR);
											var allAlreadyAuto = $author$project$Model$BuildExprEditorUtils$areAllAuto(model.qR);
											var packagesButtons = function (mode) {
												var showSetAllControls = (mode !== 1) && allowedToSetAllToAutoOrPinned;
												var showImportPackagesFeature = A2(
													$elm$core$List$any,
													function (item) {
														return (!_Utils_eq(item.L, $author$project$Model$Editor$Removed)) && $author$project$Model$Language$supportsImporting(item.kH.w);
													},
													languageItems);
												var extraClass = function () {
													if (!mode) {
														return 'small';
													} else {
														return '';
													}
												}();
												var secondaryClass = $elm$html$Html$Attributes$class('secondary-button ' + extraClass);
												var setAllToPinnedButtonSection = function () {
													var setAllToPinnedDescription = A2(
														$elm$html$Html$p,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('All '),
																A2(
																$elm$html$Html$strong,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('Required Packages')
																	])),
																$elm$html$Html$text(' that are currently set to Custom or Auto versions will be set to the exact version they are currently resolved to.')
															]));
													var buildDataToVersionStringsByKey = function (buildDataSource) {
														var versionStringsByNormalizedKey = A2(
															$elm$core$Dict$map,
															F2(
																function (_v10, component) {
																	return $author$project$Model$BuildDataSource$getVersionForArbitraryPlatform(component).sL;
																}),
															$author$project$Model$BuildDataSource$getNodesByKey(buildDataSource));
														var bundlesAndPackages = A2(
															$elm$core$Dict$union,
															$author$project$Model$BuildPlanner$SolveLegacyEditor$getBundles(model.qR),
															$author$project$Model$BuildPlanner$SolveLegacyEditor$getPackages(model.qR));
														var allRawKeys = _Utils_ap(
															$elm$core$Dict$keys(versionStringsByNormalizedKey),
															$elm$core$Dict$keys(bundlesAndPackages));
														var normalizedKeysRemoteData = A2(
															$krisajenkins$remotedata$RemoteData$map,
															$elm$core$Dict$fromList,
															$krisajenkins$remotedata$RemoteData$fromList(
																A2(
																	$elm$core$List$map,
																	function (rawKey) {
																		return A2(
																			$krisajenkins$remotedata$RemoteData$map,
																			function (normalizedKey) {
																				return _Utils_Tuple2(rawKey, normalizedKey);
																			},
																			A2($author$project$Model$NormsAndVulns$getNormalizedKey, rawKey, model.rF));
																	},
																	allRawKeys)));
														return A2(
															$krisajenkins$remotedata$RemoteData$map,
															function (normalizedKeys) {
																return $elm$core$Dict$fromList(
																	A2(
																		$elm$core$List$concatMap,
																		function (_v8) {
																			var rawKey = _v8.a;
																			var normalizedKey = _v8.b;
																			var _v9 = A2($elm$core$Dict$get, normalizedKey, versionStringsByNormalizedKey);
																			if (_v9.$ === 1) {
																				return _List_Nil;
																			} else {
																				var v = _v9.a;
																				return _List_fromArray(
																					[
																						_Utils_Tuple2(rawKey, v),
																						_Utils_Tuple2(normalizedKey, v)
																					]);
																			}
																		},
																		$elm$core$Dict$toList(normalizedKeys)));
															},
															A2($krisajenkins$remotedata$RemoteData$mapError, $author$project$Model$BuildPlanner$BuildPlannerError$HttpError, normalizedKeysRemoteData));
													};
													var _v7 = A2($krisajenkins$remotedata$RemoteData$andThen, buildDataToVersionStringsByKey, buildData);
													switch (_v7.$) {
														case 3:
															var versionStringsByKey = _v7.a;
															return _List_fromArray(
																[
																	A2(
																	$elm$html$Html$button,
																	_List_fromArray(
																		[
																			secondaryClass,
																			$elm$html$Html$Events$onClick(
																			$author$project$Pages$ProjectConfig$SetAllPackagesToPinned(versionStringsByKey)),
																			$elm$html$Html$Attributes$disabled(allAlreadyExact)
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Freeze all package versions')
																		])),
																	setAllToPinnedDescription
																]);
														case 1:
															return _List_fromArray(
																[
																	A2(
																	$elm$html$Html$button,
																	_List_fromArray(
																		[
																			secondaryClass,
																			$elm$html$Html$Attributes$disabled(true)
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Freeze all package versions')
																		])),
																	setAllToPinnedDescription
																]);
														case 0:
															return _List_Nil;
														default:
															return _List_Nil;
													}
												}();
												var setAllControls = A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('dropdown set-all-controls')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$button,
															_List_fromArray(
																[
																	$elm$html$Html$Events$onClick($author$project$Pages$ProjectConfig$ToggleSetAllDropdown),
																	$elm$html$Html$Attributes$id($author$project$Pages$ProjectConfig$packagesDropdownButtonId),
																	$elm$html$Html$Attributes$class('kebab-menu-button'),
																	$elm$html$Html$Attributes$classList(
																	_List_fromArray(
																		[
																			_Utils_Tuple2('active', model.oP)
																		])),
																	A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Open menu')
																]),
															_List_fromArray(
																[
																	A2($elm$html$Html$span, _List_Nil, _List_Nil),
																	A2($elm$html$Html$span, _List_Nil, _List_Nil),
																	A2($elm$html$Html$span, _List_Nil, _List_Nil)
																])),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$classList(
																	_List_fromArray(
																		[
																			_Utils_Tuple2('dropdown-menu', true),
																			_Utils_Tuple2('visible', model.oP),
																			_Utils_Tuple2('hidden', !model.oP)
																		])),
																	$elm$html$Html$Attributes$id($author$project$Pages$ProjectConfig$packagesDropdownId)
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('set-all-dropdown-container')
																		]),
																	_Utils_ap(
																		setAllToPinnedButtonSection,
																		_List_fromArray(
																			[
																				A2(
																				$elm$html$Html$span,
																				_List_Nil,
																				_List_fromArray(
																					[
																						A2(
																						$elm$html$Html$button,
																						_List_fromArray(
																							[
																								secondaryClass,
																								$elm$html$Html$Events$onClick($author$project$Pages$ProjectConfig$SetAllPackagesToAuto),
																								$elm$html$Html$Attributes$disabled(allAlreadyAuto)
																							]),
																						_List_fromArray(
																							[
																								$elm$html$Html$text('Set All to Auto')
																							]))
																					])),
																				A2(
																				$elm$html$Html$p,
																				_List_Nil,
																				_List_fromArray(
																					[
																						$elm$html$Html$text('All '),
																						A2(
																						$elm$html$Html$strong,
																						_List_Nil,
																						_List_fromArray(
																							[
																								$elm$html$Html$text('Required Packages')
																							])),
																						$elm$html$Html$text(' that are currently constrained to exact versions will be set to Auto, which lets the Platform select the most compatible version.')
																					]))
																			])))
																]))
														]));
												return _List_fromArray(
													[
														A2(
														$elm$html$Html$button,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('secondary-button ' + extraClass),
																$elm$html$Html$Events$onClick(
																$author$project$Pages$ProjectConfig$ModalOpen(0)),
																$elm$html$Html$Attributes$disabled(
																$elm_community$maybe_extra$Maybe$Extra$isJust(packageLimitReached))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Add Packages')
															])),
														A2(
														$author$project$Misc$displayIf,
														showImportPackagesFeature,
														A2(
															$elm$html$Html$button,
															_List_fromArray(
																[
																	secondaryClass,
																	$elm$html$Html$Events$onClick(
																	$author$project$Pages$ProjectConfig$ModalOpen(1)),
																	$elm$html$Html$Attributes$disabled(
																	$elm_community$maybe_extra$Maybe$Extra$isJust(packageLimitReached))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(importPackagesText)
																]))),
														A2($author$project$Misc$displayIf, showSetAllControls, setAllControls)
													]);
											};
											return A2(
												$author$project$Misc$displayIf,
												isPrePanorama,
												A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															function () {
															var _v3 = model.Cu;
															if (_v3.$ === 1) {
																return A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('new-box')
																		]),
																	_List_fromArray(
																		[
																			$author$project$Views$Loading$dots,
																			$elm$html$Html$text('Resolving dependencies')
																		]));
															} else {
																return $elm$html$Html$text('');
															}
														}(),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('new-box requested-packages-list'),
																	$elm$html$Html$Attributes$classList(
																	_List_fromArray(
																		[
																			_Utils_Tuple2('solution-indemnification-loading', !indemnificationFinishedLoading)
																		]))
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$h2,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Required Packages'),
																			A2(
																			$elm$html$Html$span,
																			_List_fromArray(
																				[
																					$elm$html$Html$Attributes$class('more-info-tooltip')
																				]),
																			_List_fromArray(
																				[
																					$author$project$Views$Icon$view(
																					$author$project$Views$Icon$icon(52)),
																					A2(
																					$elm$html$Html$div,
																					_List_fromArray(
																						[
																							$elm$html$Html$Attributes$class('content')
																						]),
																					_List_fromArray(
																						[
																							A2(
																							$elm$html$Html$p,
																							_List_Nil,
																							_List_fromArray(
																								[
																									$elm$html$Html$text('These packages are included in the distribution along with the core language interpreter. Their dependencies will be automatically provided.')
																								]))
																						]))
																				])),
																			A2(
																			$elm$html$Html$div,
																			_List_fromArray(
																				[
																					$elm$html$Html$Attributes$class('header-actions'),
																					$elm$html$Html$Attributes$classList(
																					_List_fromArray(
																						[
																							_Utils_Tuple2('focus-attention', model.yo && ((!projectEditableStatus) && (pkgCount > 0)))
																						]))
																				]),
																			((!projectEditableStatus) && (pkgCount > 0)) ? A3(
																				$author$project$Misc$concatIf,
																				model.yo,
																				onFocusTooltip,
																				packagesButtons(0)) : ((projectEditableStatus === 1) ? _List_fromArray(
																				[
																					$author$project$Pages$ProjectConfigHtml$disabledEditButton('Add Packages')
																				]) : _List_fromArray(
																				[
																					$elm$html$Html$text('')
																				])))
																		])),
																	A2(
																	$elm$html$Html$div,
																	_List_Nil,
																	_List_fromArray(
																		[
																			function () {
																			if (packageLimitReached.$ === 1) {
																				return A2($elm$html$Html$div, _List_Nil, _List_Nil);
																			} else {
																				var limitKind = packageLimitReached.a;
																				return A3($author$project$Pages$ProjectConfigHtml$packageLimitView, model.c3, limitKind, $author$project$Pages$ProjectConfig$packageLimit);
																			}
																		}(),
																			function () {
																			if (!pkgCount) {
																				if (!projectEditableStatus) {
																					return A2(
																						$elm$html$Html$div,
																						_List_Nil,
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$div,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$class('no-packages-added'),
																										$elm$html$Html$Attributes$classList(
																										_List_fromArray(
																											[
																												_Utils_Tuple2('open-commit', anyChangesToCommit)
																											]))
																									]),
																								_List_fromArray(
																									[
																										A2(
																										$elm$html$Html$p,
																										_List_Nil,
																										_List_fromArray(
																											[
																												A2(
																												$elm$html$Html$strong,
																												_List_Nil,
																												_List_fromArray(
																													[
																														$elm$html$Html$text('Customize your build')
																													])),
																												$elm$html$Html$text(' — add some packages with one of the methods below.')
																											])),
																										A2(
																										$elm$html$Html$div,
																										_List_fromArray(
																											[
																												$elm$html$Html$Attributes$classList(
																												_List_fromArray(
																													[
																														_Utils_Tuple2('focus-attention', model.yo)
																													]))
																											]),
																										A3(
																											$author$project$Misc$concatIf,
																											model.yo,
																											onFocusTooltip,
																											packagesButtons(1)))
																									])),
																								A2(
																								$author$project$Misc$displayIf,
																								isSuperUserWithFeaturesVisible,
																								A2(
																									$elm$html$Html$div,
																									_List_fromArray(
																										[
																											$elm$html$Html$Attributes$class('package-table package-list')
																										]),
																									_List_fromArray(
																										[
																											A2(
																											$elm$html$Html$map,
																											$author$project$Pages$ProjectConfig$CustomRequirementInputMsg,
																											$author$project$Views$CustomRequirementInput$view(model.on))
																										])))
																							]));
																				} else {
																					return A2(
																						$elm$html$Html$div,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class('content')
																							]),
																						_List_fromArray(
																							[
																								$elm$html$Html$text('No packages have been added.')
																							]));
																				}
																			} else {
																				return A2(
																					$elm$html$Html$div,
																					_List_Nil,
																					_List_fromArray(
																						[
																							A2(
																							$author$project$Misc$displayIf,
																							indemnificationEnabled,
																							A2($author$project$Pages$ProjectConfigHtml$indemnificationStatus, buildData, isManagedProject)),
																							A2($author$project$Pages$ProjectConfigHtml$viewRequirements, model, flags)
																						]));
																			}
																		}()
																		]))
																])),
															function () {
															var _v6 = model.Cu;
															if (_v6.$ === 3) {
																var buildDataSource = _v6.a;
																var absentComponents = A2(
																	$elm$core$List$filter,
																	$author$project$Model$BuildDataSource$isMissingSourceComponent(buildDataSource),
																	$author$project$Model$BuildDataSource$getComponents(buildDataSource));
																return $elm$core$List$isEmpty(absentComponents) ? $elm$html$Html$text('') : A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('new-box missing-components')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$details,
																			_List_Nil,
																			_List_fromArray(
																				[
																					A2(
																					$elm$html$Html$summary,
																					_List_Nil,
																					_List_fromArray(
																						[
																							A2(
																							$elm$html$Html$h2,
																							_List_Nil,
																							_List_fromArray(
																								[
																									$elm$html$Html$text('Unavailable Packages')
																								]))
																						])),
																					A2(
																					$elm$html$Html$div,
																					_List_Nil,
																					_List_fromArray(
																						[
																							A2(
																							$elm$html$Html$div,
																							_List_fromArray(
																								[
																									$elm$html$Html$Attributes$class('missing-components-cta')
																								]),
																							_List_fromArray(
																								[
																									A2(
																									$elm$html$Html$p,
																									_List_Nil,
																									_List_fromArray(
																										[
																											$elm$html$Html$text('These packages are not available in the public ActiveState catalog and will not be included in builds. Contact our specialists to access our secure extended catalog.')
																										])),
																									A2(
																									$elm$html$Html$a,
																									_List_fromArray(
																										[
																											$elm$html$Html$Attributes$class('secondary-button small'),
																											$elm$html$Html$Attributes$href(
																											$author$project$Url$Extra$contactUs(_List_Nil)),
																											$elm$html$Html$Attributes$target('_blank')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('Contact Us')
																										]))
																								])),
																							A3($author$project$Pages$ProjectConfigHtml$viewAbsentComponents, model.rF, buildDataSource, absentComponents)
																						]))
																				]))
																		]));
															} else {
																return $elm$html$Html$text('');
															}
														}()
														])));
										}(),
											A2(
											$elm$html$Html$div,
											_List_Nil,
											function () {
												var _v12 = model.Cu;
												if (_v12.$ === 1) {
													return _List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('new-box buildplan-loading-indicator')
																]),
															_List_fromArray(
																[
																	$author$project$Views$Loading$dots,
																	$elm$html$Html$text('Loading')
																]))
														]);
												} else {
													return _List_fromArray(
														[
															A2(
															$author$project$Misc$displayIf,
															isPanorama1,
															$author$project$Pages$ProjectConfigHtml$viewScannedImages(model)),
															A2(
															$author$project$Misc$displayIf,
															isPanorama2,
															$author$project$Pages$ProjectConfigHtml$viewGenericSBOM(model)),
															A2(
															$author$project$Misc$displayIf,
															isPrePanorama,
															A2(
																$elm$html$Html$map,
																$author$project$Pages$ProjectConfig$DependenciesMsg,
																A3($author$project$Views$Dependencies$view, flags, model.qO, model)))
														]);
												}
											}())
										]))
								]));
					}
				}()
				]));
	});
var $author$project$Pages$ProjectDownloads$DismissWelcomeModal = {$: 8};
var $author$project$Pages$ProjectDownloads$Chmod = 0;
var $author$project$Pages$ProjectDownloads$CopyClipboard = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$ProjectDownloads$DownloadLogs = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Model$ProgressTracker$NormalUser = 0;
var $author$project$Pages$ProjectDownloads$OpenHubSpotChat = {$: 2};
var $author$project$Pages$ProjectDownloads$OpenPopup = function (a) {
	return {$: 5, a: a};
};
var $author$project$Model$ProgressTracker$PayingCustomer = 1;
var $author$project$Model$ProgressTracker$SuperUser = 2;
var $author$project$Pages$ProjectDownloads$TogglePackageLog = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$ProjectDownloads$TogglePackages = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$Platform$isLinux = A2(
	$elm$core$Basics$composeR,
	$author$project$Model$Platform$getPlatformType,
	$elm$core$Basics$eq(1));
var $author$project$Model$Platform$isMac = A2(
	$elm$core$Basics$composeR,
	$author$project$Model$Platform$getPlatformType,
	$elm$core$Basics$eq(2));
var $author$project$Model$ProgressTracker$isSuccessful = function (tracker) {
	var _v0 = tracker.L;
	if (_v0 === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Model$Platform$isWindows = A2(
	$elm$core$Basics$composeR,
	$author$project$Model$Platform$getPlatformType,
	$elm$core$Basics$eq(0));
var $author$project$Pages$ProjectDownloads$platformTypeFromString = function (name) {
	switch (name) {
		case 'CentOS':
			return $elm$core$Maybe$Just(1);
		case 'Linux':
			return $elm$core$Maybe$Just(1);
		case 'Windows':
			return $elm$core$Maybe$Just(0);
		case 'macOS':
			return $elm$core$Maybe$Just(2);
		case 'HP-UX':
			return $elm$core$Maybe$Just(3);
		case 'AIX':
			return $elm$core$Maybe$Just(4);
		case 'Solaris':
			return $elm$core$Maybe$Just(5);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Model$TrackingParameter$TrackingParameter = $elm$core$Basics$identity;
var $author$project$Model$Experiments$Experiments$defaultTrackingParameter = 'pdli02';
var $author$project$Model$Experiments$Experiments$forkVsCLITrackingParameter = function (experiment) {
	if (experiment.$ === 1) {
		var variation = experiment.a.AK;
		return 'AS70' + $elm$core$String$fromInt(variation);
	} else {
		return $author$project$Model$Experiments$Experiments$defaultTrackingParameter;
	}
};
var $author$project$Model$Analytics$getClientId = function (_v0) {
	var gad = _v0;
	return gad.BH;
};
var $author$project$Model$Experiments$Experiments$NotAsked = {$: 0};
var $author$project$Model$Session$getExperiment = F2(
	function (name, _v0) {
		var session = _v0;
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Model$Experiments$Experiments$NotAsked,
			A2($elm$core$Dict$get, name, session.qV));
	});
var $author$project$Model$Session$getGoogleAnalyticsData = function (_v0) {
	var session = _v0;
	return session.tY;
};
var $author$project$Model$TrackingParameter$trackingParameter = function (session) {
	var googleAnalyticsClientId = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$author$project$Model$Analytics$getClientId,
			$author$project$Model$Session$getGoogleAnalyticsData(session)));
	var experimentTrackingParameter = $author$project$Model$Experiments$Experiments$forkVsCLITrackingParameter(
		A2($author$project$Model$Session$getExperiment, $author$project$Model$Experiments$Experiments$forkVsCLIExperimentName, session));
	return googleAnalyticsClientId + ('_' + experimentTrackingParameter);
};
var $author$project$Pages$ProjectDownloads$viewDownloadCamelLogs = F2(
	function (progressTracker, logsURL) {
		var logsUrlReplaced = A3($elm$core$String$replace, 'https://s3.amazonaws.com/', 'https://s3-proxy.activestate.build/', logsURL);
		var _v0 = progressTracker.qt;
		if (!_v0) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('logs-section superuser-only')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('primary-button'),
								$elm$html$Html$Attributes$href(logsUrlReplaced)
							]),
						_List_fromArray(
							[
								$author$project$Views$Icon$view(
								$author$project$Views$Icon$icon(21)),
								$elm$html$Html$text('Download Camel Logs')
							]))
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Model$ProgressTracker$isTcl = function (tracker) {
	return _Utils_eq(
		A2(
			$elm$core$List$map,
			function ($) {
				return $.kH;
			},
			tracker.aM),
		_List_fromArray(
			[2]));
};
var $author$project$Model$Permissions$orgCanDownloadInstallers = A2($author$project$Misc$isEither, $author$project$Model$Permissions$orgCanPackageCamel, $author$project$Model$Permissions$orgCanPackageInstaller);
var $author$project$Model$ProgressTracker$canDownloadInstallers = function (tracker) {
	return $author$project$Model$Permissions$orgCanDownloadInstallers(tracker.c3) || $author$project$Model$ProgressTracker$isTcl(tracker);
};
var $author$project$Model$ProgressTracker$VisibleDownload = F2(
	function (visibleBecauseSuperUser, download) {
		return {Cl: download, G6: visibleBecauseSuperUser};
	});
var $author$project$Model$ProgressTracker$getVisibleDownloads = F2(
	function (requester, downloads) {
		var _v0 = A2(
			$elm$core$List$partition,
			function ($) {
				return $.Dx;
			},
			downloads);
		var primary = _v0.a;
		var secondary = _v0.b;
		var visiblePrimaryDownloads = A2(
			$elm$core$List$map,
			$author$project$Model$ProgressTracker$VisibleDownload(false),
			primary);
		var visibleSecondaryDownloads = function () {
			switch (requester) {
				case 0:
					return _List_Nil;
				case 1:
					return A2(
						$elm$core$List$map,
						$author$project$Model$ProgressTracker$VisibleDownload(false),
						secondary);
				default:
					return A2(
						$elm$core$List$map,
						$author$project$Model$ProgressTracker$VisibleDownload(true),
						secondary);
			}
		}();
		return _Utils_ap(visiblePrimaryDownloads, visibleSecondaryDownloads);
	});
var $author$project$Views$InstallerDocsLink$view = function (shouldDisplay) {
	return A2(
		$author$project$Misc$displayIf,
		shouldDisplay,
		A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href('https://docs.activestate.com/platform/features/offline-installers/'),
					$elm$html$Html$Attributes$target('_blank'),
					$elm$html$Html$Attributes$class('more-info-tooltip')
				]),
			_List_fromArray(
				[
					$author$project$Views$Icon$view(
					$author$project$Views$Icon$icon(52)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('content')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Click to open the installer documentation')
						]))
				])));
};
var $author$project$Model$DownloadURI$fileExtension = F2(
	function (platformType, uri) {
		var file = $author$project$Model$DownloadURI$fileName(uri);
		if (platformType === 1) {
			return A2($elm$core$String$endsWith, '.tar.gz', file) ? '.tar.gz' : (A2($elm$core$String$endsWith, '.tar', file) ? '.tar' : (A2($elm$core$String$endsWith, '.txt', file) ? '.txt' : ''));
		} else {
			var ext = A2($elm_community$string_extra$String$Extra$rightOfBack, '.', file);
			return $elm$core$String$isEmpty(ext) ? '' : ('.' + ext);
		}
	});
var $author$project$Views$ProgressTracker$additionalInstructions = function (_v0) {
	var platformType = _v0.rW;
	var uri = _v0.eW;
	var copyData = _v0.B$;
	var id = _v0.l6;
	var extension = A2($author$project$Model$DownloadURI$fileExtension, platformType, uri);
	var _v1 = _Utils_Tuple2(platformType, extension);
	if ((_v1.a === 1) && (_v1.b === '')) {
		var _v2 = _v1.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('linux-x-bit')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Please run the following command prior to using the runtime.')
						])),
					$author$project$Views$CliText$view(
					{
						B$: $elm$core$Maybe$Just(copyData),
						l6: id,
						Gv: 'chmod +x ' + $author$project$Model$DownloadURI$fileName(uri)
					})
				]));
	} else {
		return A2($elm$html$Html$span, _List_Nil, _List_Nil);
	}
};
var $elm$html$Html$Attributes$download = function (fileName) {
	return A2($elm$html$Html$Attributes$stringProperty, 'download', fileName);
};
var $author$project$Views$ProgressTracker$viewDownloadFormat = F2(
	function (data, visibleDownload) {
		var _v0 = visibleDownload.Cl;
		var isDocker = _v0.Dd;
		var isInstaller = _v0.yL;
		var isPrimary = _v0.Dx;
		var url = _v0.GT;
		var hoverText = isDocker ? 'Docker Image' : (isInstaller ? 'Installer' : '');
		var extension = isDocker ? 'Docker Image' : A2($author$project$Model$DownloadURI$fileExtension, data.rW, url);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('download-wrapper'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('emphasized-download', isPrimary)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('download-ui', true),
									_Utils_Tuple2('superuser-only', visibleDownload.G6)
								])),
							$elm$html$Html$Attributes$title(hoverText)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('primary-button', isPrimary),
											_Utils_Tuple2('secondary-button', !isPrimary)
										])),
									$elm$html$Html$Attributes$href(url),
									$elm$html$Html$Attributes$download('')
								]),
							_List_fromArray(
								[
									isDocker ? $author$project$Views$Icon$view(
									$author$project$Views$Icon$icon(20)) : $author$project$Views$Icon$view(
									$author$project$Views$Icon$icon(21)),
									$elm$html$Html$text('Download'),
									A2(
									$author$project$Misc$displayIf,
									isPrimary,
									A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('extension')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(extension)
											])))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('download-meta')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Model$DownloadURI$fileName(url))
								]))
						])),
					A2(
					$author$project$Misc$displayMaybe,
					function (_v1) {
						var copyData = _v1.a;
						var id = _v1.b;
						return $author$project$Views$ProgressTracker$additionalInstructions(
							{B$: copyData, l6: id, rW: data.rW, eW: url});
					},
					data.A4)
				]));
	});
var $author$project$Pages$ProjectDownloads$viewDownloadsPrePlatform = function (_v0) {
	var organization = _v0.c3;
	var languages = _v0.aM;
	var downloadRequester = _v0.tG;
	var platform = _v0.po;
	var prePlatformBuildGraph = _v0.kn;
	var platformType = $author$project$Model$Platform$getPlatformType(platform);
	var installersAllowed = $author$project$Model$ProgressTracker$canDownloadInstallers(
		{aM: languages, c3: organization});
	var downloads = A2(
		$author$project$Model$BuildPlanner$BuildGraph$PrePlatformBuildGraph$getDownloadsForPlatform,
		$author$project$Model$Platform$id(platform),
		prePlatformBuildGraph);
	var visibleDownloads = A2($author$project$Model$ProgressTracker$getVisibleDownloads, downloadRequester, downloads);
	return A2(
		$author$project$Misc$displayIf,
		$elm$core$List$length(visibleDownloads) >= 1,
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('downloads-wrapper new-box')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							'Download ' + ($author$project$Model$Platform$platformTypeToString(platformType) + ' Installer')),
							$author$project$Views$InstallerDocsLink$view(installersAllowed)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('content')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('downloads-section')
								]),
							A2(
								$elm$core$List$map,
								$author$project$Views$ProgressTracker$viewDownloadFormat(
									{A4: $elm$core$Maybe$Nothing, rW: platformType}),
								visibleDownloads))
						]))
				])));
};
var $elm_community$string_extra$String$Extra$rightOf = F2(
	function (pattern, string) {
		return A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.wu;
					},
					$elm_community$string_extra$String$Extra$firstResult),
				A3(
					$elm$regex$Regex$findAtMost,
					1,
					$elm_community$string_extra$String$Extra$regexFromString(
						$elm_community$string_extra$String$Extra$regexEscape(pattern) + '(.*)$'),
					string)));
	});
var $author$project$Model$Namespace$imageRegistry = $elm_community$string_extra$String$Extra$rightOf($author$project$Model$Namespace$imagePrefix);
var $author$project$Model$BuildPlanner$Node$dockerRef = function (image) {
	var tagOrHash = A2($elm$core$String$startsWith, 'sha256:', image.aI) ? ('@' + image.aI) : (':' + image.aI);
	var registry = function () {
		var reg = $author$project$Model$Namespace$imageRegistry(
			$author$project$Model$Namespace$getNamespace(image.Y));
		return A2(
			$elm$core$List$member,
			reg,
			_List_fromArray(
				['docker.io', 'index.docker.io'])) ? '' : (reg + '/');
	}();
	var imageName = A3(
		$elm$core$String$replace,
		'library/',
		'',
		$author$project$Model$Namespace$getName(image.Y));
	return _Utils_ap(
		registry,
		_Utils_ap(imageName, tagOrHash));
};
var $author$project$Pages$ProjectDownloads$viewScannedImage = F2(
	function (model, image) {
		var imageNameAndVersion = $author$project$Model$BuildPlanner$Node$dockerRef(image);
		var imageName = A3(
			$elm$core$String$replace,
			'library/',
			'',
			$author$project$Model$Namespace$getName(image.Y));
		var idAttr = $author$project$Model$Namespace$getName(image.Y);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Updating the ' + (imageName + ' image in your Environment'))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('General Instructions')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('To use the latest version, update all references to previous container versions in your configuration files, CI/CD pipelines, and deployment manifests to the following.')
						])),
					$author$project$Views$CliText$view(
					{
						B$: $elm$core$Maybe$Just(
							{
								Em: $author$project$Pages$ProjectDownloads$CopyClipboard(0),
								L: model.oi
							}),
						l6: 'general' + idAttr,
						Gv: imageNameAndVersion
					}),
					A2($elm$html$Html$hr, _List_Nil, _List_Nil),
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Direct Docker Usage')
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Pull the latest image')
						])),
					$author$project$Views$CliText$view(
					{
						B$: $elm$core$Maybe$Just(
							{
								Em: $author$project$Pages$ProjectDownloads$CopyClipboard(0),
								L: model.oi
							}),
						l6: 'docker-direct' + idAttr,
						Gv: 'docker pull ' + imageNameAndVersion
					}),
					A2($elm$html$Html$hr, _List_Nil, _List_Nil),
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Docker Compose')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('If you\'re using Docker Compose, you can update your existing configuration by replacing the version in your '),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('inline-snippet')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('docker-compose.yaml')
								])),
							$elm$html$Html$text(' file.')
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('1. Manual Method')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Update the image version in your '),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('inline-snippet')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('docker-compose.yaml')
								])),
							$elm$html$Html$text(' file.')
						])),
					$author$project$Views$CliText$view(
					{
						B$: $elm$core$Maybe$Just(
							{
								Em: $author$project$Pages$ProjectDownloads$CopyClipboard(0),
								L: model.oi
							}),
						l6: 'docker-compose-1-' + idAttr,
						Gv: 'services:\n  myservice:\n    image: ' + imageNameAndVersion
					}),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('2. Automated Method')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('First, use '),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('inline-snippet')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('sed')
								])),
							$elm$html$Html$text(' to replace the the '),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('inline-snippet')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('<PREVIOUS-VERSION>')
								])),
							$elm$html$Html$text(' you were using.')
						])),
					function () {
					var previousVersion = imageName + ':<PREVIOUS-VERSION>';
					return $author$project$Views$CliText$view(
						{
							B$: $elm$core$Maybe$Just(
								{
									Em: $author$project$Pages$ProjectDownloads$CopyClipboard(0),
									L: model.oi
								}),
							l6: 'docker-compose-2-' + idAttr,
							Gv: 'cat docker-compose.yaml | sed \'s/' + (previousVersion + ('/' + (imageNameAndVersion + '/g\' > docker-compose.yaml')))
						});
				}(),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Then, restart your services.')
						])),
					$author$project$Views$CliText$view(
					{
						B$: $elm$core$Maybe$Just(
							{
								Em: $author$project$Pages$ProjectDownloads$CopyClipboard(0),
								L: model.oi
							}),
						l6: 'docker-compose-reststart' + idAttr,
						Gv: 'docker compose pull\ndocker compose restart'
					}),
					A2($elm$html$Html$hr, _List_Nil, _List_Nil),
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Kubernetes Deployments')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Update your deployment with the new image.')
						])),
					$author$project$Views$CliText$view(
					{
						B$: $elm$core$Maybe$Just(
							{
								Em: $author$project$Pages$ProjectDownloads$CopyClipboard(0),
								L: model.oi
							}),
						l6: 'kubernetes' + idAttr,
						Gv: 'kubectl set image deployment/' + (imageName + (' -n=<NAMESPACE> ' + (imageName + ('=' + imageNameAndVersion))))
					}),
					A2($elm$html$Html$hr, _List_Nil, _List_Nil),
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Helm')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('If you\'re using Helm, update the image tag in your '),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('inline-snippet')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('values.yaml')
								])),
							$elm$html$Html$text(' file.')
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('1. Update your values.yaml')
						])),
					$author$project$Views$CliText$view(
					{
						B$: $elm$core$Maybe$Just(
							{
								Em: $author$project$Pages$ProjectDownloads$CopyClipboard(0),
								L: model.oi
							}),
						l6: 'helm-1-' + idAttr,
						Gv: imageName + (':\n  image:\n    tag: ' + image.aI)
					}),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('2. Upgrade your release')
						])),
					$author$project$Views$CliText$view(
					{
						B$: $elm$core$Maybe$Just(
							{
								Em: $author$project$Pages$ProjectDownloads$CopyClipboard(0),
								L: model.oi
							}),
						l6: 'helm-2-' + idAttr,
						Gv: 'helm upgrade <RELEASE_NAME> <CHART> \\\n  --set ' + (imageName + ('.image.tag=' + image.aI))
					})
				]));
	});
var $author$project$Pages$ProjectDownloads$viewImages = F2(
	function (model, buildDataSource) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('deploy-images')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Pages$ProjectDownloads$viewScannedImage(model),
						$author$project$Model$BuildDataSource$getScannedImages(buildDataSource)))
				]));
	});
var $author$project$Pages$ProjectDownloads$KickCancelled = {$: 20};
var $author$project$Pages$ProjectDownloads$KickConfirmed = F2(
	function (a, b) {
		return {$: 21, a: a, b: b};
	});
var $author$project$Pages$ProjectDownloads$KickRequested = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$ProjectDownloads$kickButton = F2(
	function (platformID, candidates) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('secondary-button'),
					$elm$html$Html$Events$onClick(
					$author$project$Pages$ProjectDownloads$KickRequested(platformID))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					'Reschedule ' + ($elm$core$String$fromInt(
						$elm$core$List$length(candidates)) + (' failed or stuck ' + A2(
						$author$project$Pages$ProjectDownloads$plural,
						$elm$core$List$length(candidates),
						'artifact'))))
				]));
	});
var $author$project$Model$ProgressTracker$kickCandidates = F2(
	function (currentTime, _v0) {
		var buildType = _v0.qt;
		var packageProgress = _v0.hI;
		var staleAfterMillis = (15 * 60) * 1000;
		var isKickable = function (_v3) {
			var state = _v3.bB;
			var startTime = _v3.du;
			switch (state) {
				case 3:
					return true;
				case 1:
					return A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							function (started) {
								return _Utils_cmp(
									$elm$time$Time$posixToMillis(currentTime) - $elm$time$Time$posixToMillis(started),
									staleAfterMillis) > 0;
							},
							startTime));
				default:
					return false;
			}
		};
		if (!buildType) {
			return _List_Nil;
		} else {
			return A2(
				$elm$core$List$sortBy,
				function ($) {
					return $.w;
				},
				A2(
					$elm$core$List$filter,
					isKickable,
					$elm$core$Dict$values(packageProgress)));
		}
	});
var $author$project$Pages$ProjectDownloads$viewKickPanel = F4(
	function (currentTime, kick, platformID, progressTracker) {
		var stateName = function (_v2) {
			var state = _v2.bB;
			if (state === 1) {
				return 'stuck';
			} else {
				return 'failed';
			}
		};
		var candidates = A2($author$project$Model$ProgressTracker$kickCandidates, currentTime, progressTracker);
		var candidateList = A2(
			$elm$html$Html$ul,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (info) {
					return A2(
						$elm$html$Html$li,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								info.w + (' ' + (info.aI + (' (' + (stateName(info) + ')')))))
							]));
				},
				candidates));
		return $elm$core$List$isEmpty(candidates) ? $elm$html$Html$text('') : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('kick-section superuser-only')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Reschedule failed or stuck artifacts')
						])),
					function () {
					switch (kick.$) {
						case 1:
							var confirmingID = kick.a;
							return _Utils_eq(confirmingID, platformID) ? A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Reschedule these artifacts? Each one is rebuilt. A stuck build, one started over 15 minutes ago, is restarted without stopping the old one.')
											])),
										candidateList,
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('primary-button'),
												$elm$html$Html$Events$onClick(
												A2($author$project$Pages$ProjectDownloads$KickConfirmed, platformID, candidates))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Reschedule')
											])),
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('secondary-button'),
												$elm$html$Html$Events$onClick($author$project$Pages$ProjectDownloads$KickCancelled)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											]))
									])) : A2($author$project$Pages$ProjectDownloads$kickButton, platformID, candidates);
						case 2:
							var runningID = kick.a;
							return _Utils_eq(runningID, platformID) ? A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										'Rescheduling ' + ($author$project$Pages$ProjectDownloads$artifactCount(
											$elm$core$List$length(candidates)) + '...'))
									])) : A2($author$project$Pages$ProjectDownloads$kickButton, platformID, candidates);
						default:
							return A2($author$project$Pages$ProjectDownloads$kickButton, platformID, candidates);
					}
				}()
				]));
	});
var $author$project$Pages$ProjectDownloads$SelectDistro = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$Platform$platformTypeToIconKind = function (platformType) {
	switch (platformType) {
		case 0:
			return $elm$core$Maybe$Just(84);
		case 1:
			return $elm$core$Maybe$Just(42);
		case 2:
			return $elm$core$Maybe$Just(48);
		case 3:
			return $elm$core$Maybe$Just(34);
		case 4:
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$ProjectDownloads$viewPlatformTab = F2(
	function (selectedPlatformID, platform) {
		var platformTypeIconKind = $author$project$Model$Platform$platformTypeToIconKind(
			$author$project$Model$Platform$getPlatformType(platform));
		var isUserVisible = $author$project$Model$Platform$isUserVisible(platform);
		var bitWidth = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Basics$composeR,
				$author$project$Model$Platform$bitWidth,
				$elm$core$Maybe$map(
					function (a) {
						return a + '-bit';
					}))(platform));
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$Pages$ProjectDownloads$SelectDistro(
						$author$project$Model$Platform$id(platform))),
					$elm$html$Html$Attributes$class('distribution-item'),
					$elm$html$Html$Attributes$class(
					$author$project$Model$Platform$displayName(platform)),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'selected',
							_Utils_eq(
								selectedPlatformID,
								$elm$core$Maybe$Just(
									$author$project$Model$Platform$id(platform))))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Misc$displayMaybe,
					A2($elm$core$Basics$composeR, $author$project$Views$Icon$icon, $author$project$Views$Icon$view),
					platformTypeIconKind),
					A2(
					$elm$html$Html$h4,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('platform-name')
						]),
					_List_fromArray(
						[
							$author$project$Model$Platform$simpleName(platform),
							A2(
							$author$project$Misc$displayIf,
							isUserVisible,
							$author$project$Model$Platform$supportedPlatformsPopup(platform))
						])),
					A2(
					$author$project$Misc$displayIf,
					isUserVisible,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('platform-meta')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Misc$displayIf,
								$author$project$Model$Platform$cpuType(platform) === 'NO ARCHITECTURE',
								A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Model$Platform$cpuType(platform))
										]))),
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(bitWidth)
									]))
							])))
				]));
	});
var $author$project$Model$ProgressTracker$isFailed = function (tracker) {
	var _v0 = tracker.L;
	if (_v0 === 2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Views$ProgressTracker$viewBuildFailedOptions = F3(
	function (openHubSpotChat, projectConfigRoute, supportEnabled) {
		var helpOptions = supportEnabled ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('contact-specialist')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Get help from a Specialist')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Our expert team helps enterprise customers with complicated builds all the time. Get in touch and we can help you talk through options.')
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('primary-button'),
							$elm$html$Html$Events$onClick(openHubSpotChat)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Get in Touch')
						]))
				])) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('contact-community')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Get Help from Support')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Contact our support team and we can help you talk through options.')
						])),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$target('_blank'),
							$elm$html$Html$Attributes$class('secondary-button external-button '),
							$elm$html$Html$Attributes$href('mailto:support@activestate.com')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Contact Support')
						]))
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('build-failed-options')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('So your build failed, now what?')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('columns equal-width')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('column')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Modify or remove failing packages')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Try removing or changing the version of any packages that are failing during this build. When you do, we\'ll try the build again.')
										])),
									A3(
									$author$project$Views$Link$link,
									projectConfigRoute,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('primary-button')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit your Runtime')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('column')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Use our Community Edition')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Not all custom runtimes will build yet. In the meantime you can get our proven Community Edition languages.')
										])),
									A3(
									$author$project$Views$Link$link,
									$author$project$Model$Route$PublicProjects,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('secondary-button')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('View Featured Projects')
										]))
								]))
						])),
					helpOptions
				]));
	});
var $author$project$Views$ProgressTracker$viewDownloads = F3(
	function (downloadRequester, tracker, copyData) {
		var installersAllowed = $author$project$Model$ProgressTracker$canDownloadInstallers(tracker);
		return A2(
			$author$project$Misc$displayIf,
			installersAllowed,
			function () {
				var _v0 = tracker.L;
				if (_v0 === 1) {
					var visibleDownloads = A2(
						$author$project$Model$ProgressTracker$getVisibleDownloads,
						downloadRequester,
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.Dd;
								},
								$elm$core$Basics$not),
							tracker.tH));
					return A2(
						$author$project$Misc$displayIf,
						!$elm$core$List$isEmpty(visibleDownloads),
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('downloads-wrapper new-box')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h2,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Download Installer'),
											$author$project$Views$InstallerDocsLink$view(installersAllowed)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('content')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('downloads-section')
												]),
											A2(
												$elm$core$List$map,
												$author$project$Views$ProgressTracker$viewDownloadFormat(
													{
														A4: $elm$core$Maybe$Just(
															_Utils_Tuple2(copyData, tracker.tr)),
														rW: $author$project$Model$Platform$getPlatformType(tracker.po)
													}),
												visibleDownloads))
										]))
								])));
				} else {
					return $elm$html$Html$text('');
				}
			}());
	});
var $author$project$Views$ProgressTracker$viewFailures = function (tracker) {
	var _v0 = tracker.L;
	if (_v0 === 2) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('build-error-wrapper')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Dang, the build for this platform failed!')
								])),
							A2(
							$elm$html$Html$h4,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('failure-title')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('reason-title')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Reason: ')
										])),
									$elm$html$Html$text(
									A2($elm$core$Maybe$withDefault, 'unknown build failure', tracker.h6.cg))
								])),
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (error) {
									return A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(error)
											]));
								},
								tracker.h6.yf))
						]))
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Views$ProgressTracker$indemnificationStatusEl = function (isIndemnifiedBuild) {
	var _v0 = isIndemnifiedBuild ? _Utils_Tuple3('Indemnified', 'All packages in this runtime are indemnified.', 'indemnified') : _Utils_Tuple3('Not indemnified', 'Not all packages in this runtime are indemnified.', 'not-indemnified');
	var indemnifiedText = _v0.a;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('indemnification-status'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('indemnified', isIndemnifiedBuild)
					]))
			]),
		_List_fromArray(
			[
				isIndemnifiedBuild ? A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('indemnified-icon'),
						$elm$html$Html$Attributes$title('This package is indemnified.')
					]),
				_List_fromArray(
					[
						$author$project$Views$Icon$view(
						$author$project$Views$Icon$icon(38))
					])) : A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('indemnified-icon'),
						$elm$html$Html$Attributes$title('This build is not indemnified.')
					]),
				_List_fromArray(
					[
						$author$project$Views$Icon$view(
						$author$project$Views$Icon$icon(39))
					])),
				$elm$html$Html$text(indemnifiedText),
				$author$project$Views$IndemnificationPopup$indemnificationPopup(isIndemnifiedBuild)
			]));
};
var $author$project$Model$ProgressTracker$isFinished = function (progress) {
	var _v0 = progress.L;
	if (!_v0) {
		return false;
	} else {
		return true;
	}
};
var $author$project$Views$ProgressTracker$viewIndemnificationStatus = F2(
	function (tracker, indemnified) {
		var display = $author$project$Model$Permissions$orgCanSeeIndemnificationData(tracker.c3) && $author$project$Model$ProgressTracker$isFinished(tracker);
		return A2(
			$author$project$Misc$displayIf,
			display,
			$author$project$Views$ProgressTracker$indemnificationStatusEl(indemnified));
	});
var $author$project$Model$ProgressTracker$isUserFacing = A2(
	$elm$core$Basics$composeR,
	$author$project$Model$Namespace$key,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Model$Namespace$kind,
		$elm$core$Basics$neq(3)));
var $author$project$Model$ProgressTracker$packageEndtime = function (_package) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$time$Time$millisToPosix(0),
		function ($) {
			return $.yc;
		}(_package));
};
var $author$project$Views$ProgressTracker$viewArtifactLogs = F4(
	function (artifactID, artifactIdToLogs, onOpenPopup, onDownload) {
		var rawMessages = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2($elm$core$Dict$get, artifactID, artifactIdToLogs));
		var messages = $elm$core$List$isEmpty(rawMessages) ? _List_fromArray(
			['Connecting...']) : rawMessages;
		var messagesJson = A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, messages);
		var logsHtmlStr = '<samp style=\"line-height: 1.3rem;\">' + (A2($elm$core$String$join, '<br />', rawMessages) + '</samp>');
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Misc$displayIf,
					!$elm$core$List$isEmpty(rawMessages),
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('log-actions')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick(
										onOpenPopup(logsHtmlStr)),
										$elm$html$Html$Attributes$class('secondary-button small')
									]),
								_List_fromArray(
									[
										$author$project$Views$Icon$view(
										$author$project$Views$Icon$icon(25)),
										$elm$html$Html$text('Open in new window')
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick(
										A2(
											onDownload,
											artifactID + '.log',
											A2($elm$core$String$join, '\n', rawMessages))),
										$elm$html$Html$Attributes$class('secondary-button small')
									]),
								_List_fromArray(
									[
										$author$project$Views$Icon$view(
										$author$project$Views$Icon$icon(21)),
										$elm$html$Html$text('Download')
									]))
							]))),
					A3(
					$elm$html$Html$node,
					'x-term',
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$property, 'messages', messagesJson)
						]),
					_List_Nil)
				]));
	});
var $author$project$TimeUtils$formatHoursMinutesSeconds = F3(
	function (hours, minutes, seconds) {
		var secondsStr = $elm$core$String$fromInt(
			A2($elm$core$Basics$max, 0, seconds)) + 's';
		var minutesStr = $elm$core$String$fromInt(
			A2($elm$core$Basics$max, 0, minutes)) + 'm ';
		var hoursStr = (hours <= 0) ? '' : ($elm$core$String$fromInt(hours) + 'h ');
		return $elm$core$String$concat(
			_List_fromArray(
				[hoursStr, minutesStr, secondsStr]));
	});
var $author$project$TimeUtils$formatDurationHoursMinutesSeconds = function (durationMillis) {
	var absDurationMillis = $elm$core$Basics$abs(durationMillis);
	var _v0 = _Utils_Tuple2(
		(absDurationMillis / $author$project$TimeUtils$millisPerHour) | 0,
		A2($elm$core$Basics$modBy, $author$project$TimeUtils$millisPerHour, absDurationMillis));
	var hours = _v0.a;
	var millisAfterHours = _v0.b;
	var _v1 = _Utils_Tuple2(
		(millisAfterHours / $author$project$TimeUtils$millisPerMin) | 0,
		A2($elm$core$Basics$modBy, $author$project$TimeUtils$millisPerMin, millisAfterHours));
	var minutes = _v1.a;
	var millisAfterMinutes = _v1.b;
	var seconds = (millisAfterMinutes / $author$project$TimeUtils$millisPerSec) | 0;
	return A3($author$project$TimeUtils$formatHoursMinutesSeconds, hours, minutes, seconds);
};
var $author$project$TimeUtils$subtract = F2(
	function (left, right) {
		return $elm$time$Time$posixToMillis(left) - $elm$time$Time$posixToMillis(right);
	});
var $author$project$TimeUtils$formatDurationBetweenDatesHoursMinutesSeconds = F2(
	function (start, end) {
		return $author$project$TimeUtils$formatDurationHoursMinutesSeconds(
			A2($author$project$TimeUtils$subtract, start, end));
	});
var $author$project$Views$ProgressTracker$viewIngredientBuildTime = F2(
	function (currentTime, _v0) {
		var state = _v0.bB;
		var startTime = _v0.du;
		var endTime = _v0.yc;
		switch (state) {
			case 1:
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function (start) {
							return A2($author$project$TimeUtils$formatDurationBetweenDatesHoursMinutesSeconds, start, currentTime);
						},
						startTime));
			case 2:
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					A3(
						$elm$core$Maybe$map2,
						F2(
							function (start, end) {
								return A2($author$project$TimeUtils$formatDurationBetweenDatesHoursMinutesSeconds, start, end);
							}),
						startTime,
						endTime));
			default:
				return '';
		}
	});
var $author$project$Views$ProgressTracker$viewPackageState = function (status) {
	switch (status) {
		case 0:
			return _Utils_Tuple2(
				A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('status-label queued')
						]),
					_List_fromArray(
						[
							$author$project$Views$Icon$view(
							$author$project$Views$Icon$icon(32))
						])),
				'queued');
		case 1:
			return _Utils_Tuple2(
				A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('status-label building')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('status-icon')
								]),
							_List_Nil)
						])),
				'building');
		case 2:
			return _Utils_Tuple2(
				A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('status-label success')
						]),
					_List_fromArray(
						[
							$author$project$Views$Icon$view(
							$author$project$Views$Icon$icon(11))
						])),
				'success');
		case 3:
			return _Utils_Tuple2(
				A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('status-label failed')
						]),
					_List_fromArray(
						[
							$author$project$Views$Icon$view(
							$author$project$Views$Icon$icon(86))
						])),
				'failed');
		default:
			return _Utils_Tuple2(
				A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('status-label not-attempted')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('status-icon')
								]),
							_List_Nil)
						])),
				'not-attempted');
	}
};
var $author$project$Views$ProgressTracker$viewIngredientLineItem = function (_v0) {
	var isSuperUserWithFeaturesVisible = _v0.oS;
	var currentTime = _v0.cF;
	var packageInfo = _v0.zA;
	var toggleLogMsg = _v0.GF;
	var showLog = _v0.z8;
	var logs = _v0.y4;
	var progressTracker = _v0.vS;
	var isAlternativeBuild = progressTracker.qt === 1;
	var hasBuildTime = !$elm$core$String$isEmpty(
		A2($author$project$Views$ProgressTracker$viewIngredientBuildTime, currentTime, packageInfo));
	var _v1 = ((!packageInfo.oV) && (!isSuperUserWithFeaturesVisible)) ? _Utils_Tuple3(
		_List_Nil,
		$elm$html$Html$text(''),
		'') : (isAlternativeBuild ? _Utils_Tuple3(
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick(toggleLogMsg)
			]),
		A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('toggle-wrapper'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('superuser-only', !packageInfo.oV)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('toggle-icon'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('expanded', showLog)
								]))
						]),
					_List_fromArray(
						[
							$author$project$Views$Icon$view(
							$author$project$Views$Icon$icon(13))
						])),
					$elm$html$Html$text('Logs')
				])),
		'cursor-pointer') : _Utils_Tuple3(
		_List_Nil,
		$elm$html$Html$text(''),
		''));
	var logClickHandler = _v1.a;
	var viewLogsElement = _v1.b;
	var wrapperLogsClass = _v1.c;
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$tr,
			_Utils_ap(
				logClickHandler,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'ingredient-status ' + $author$project$Views$ProgressTracker$viewPackageState(packageInfo.bB).b,
								true),
								_Utils_Tuple2(wrapperLogsClass, true),
								_Utils_Tuple2(
								'superuser-only',
								isSuperUserWithFeaturesVisible && (!$author$project$Model$ProgressTracker$isUserFacing(packageInfo)))
							]))
					])),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('package-info-cell build-status')
						]),
					_List_fromArray(
						[
							$author$project$Views$ProgressTracker$viewPackageState(packageInfo.bB).a
						])),
					A2(
					$author$project$Misc$displayIf,
					isSuperUserWithFeaturesVisible,
					A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('package-info-cell name')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('superuser-only')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(packageInfo.aE)
									]))
							]))),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('package-info-cell name')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(packageInfo.w)
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('package-info-cell version')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(packageInfo.aI)
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('package-info-cell build-type')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Misc$displayIf,
							hasBuildTime,
							A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Build time - '),
										$elm$html$Html$text(
										A2($author$project$Views$ProgressTracker$viewIngredientBuildTime, currentTime, packageInfo))
									])))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('package-info-cell view-logs')
						]),
					_List_fromArray(
						[viewLogsElement]))
				])),
			A2(
			$author$project$Misc$displayIf,
			isAlternativeBuild,
			A2(
				$elm$html$Html$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Misc$displayIf,
						showLog,
						A2(
							$elm$html$Html$td,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('artifact-logs'),
									$elm$html$Html$Attributes$colspan(5)
								]),
							_List_fromArray(
								[logs])))
					])))
		]);
};
var $author$project$Views$ProgressTracker$viewPkgsInProgress = F3(
	function (_v0, sectionTitle, packages) {
		var isSuperUserWithFeaturesVisible = _v0.oS;
		var currentTime = _v0.cF;
		var toggleLogMsg = _v0.GF;
		var currentPackageLogOpen = _v0.hs;
		var artifactIdToLogs = _v0.A7;
		var progressTracker = _v0.vS;
		var onOpenPopup = _v0.EN;
		var onDownload = _v0.EL;
		var packageCount = isSuperUserWithFeaturesVisible ? $elm$core$List$length(packages) : A2(
			$elm_community$list_extra$List$Extra$count,
			A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $author$project$Model$ProgressTracker$isUserFacing),
			packages);
		return A2(
			$author$project$Misc$displayIf,
			packageCount > 0,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('package-build-section')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('list-header-wrapper')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('list-header-txt')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(sectionTitle)
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('list-header-count')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(packageCount))
									]))
							])),
						A2(
						$elm$html$Html$table,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('ingredient-list')
							]),
						A2(
							$elm$core$List$concatMap,
							function (_v1) {
								var pkgID = _v1.a;
								var packageInfo = _v1.b;
								return $author$project$Views$ProgressTracker$viewIngredientLineItem(
									{
										cF: currentTime,
										oS: isSuperUserWithFeaturesVisible,
										y4: A4($author$project$Views$ProgressTracker$viewArtifactLogs, pkgID, artifactIdToLogs, onOpenPopup, onDownload),
										zA: packageInfo,
										vS: progressTracker,
										z8: _Utils_eq(
											currentPackageLogOpen,
											$elm$core$Maybe$Just(pkgID)),
										GF: toggleLogMsg(pkgID)
									});
							},
							packages))
					])));
	});
var $author$project$Views$ProgressTracker$viewIngredientProgress = function (args) {
	var isSuperUserWithFeaturesVisible = args.oS;
	var progressTracker = args.vS;
	var queuedSectionTitle = (progressTracker.L === 2) ? 'Abandoned' : 'Scheduled';
	var notFinished = !$author$project$Model$ProgressTracker$isFinished(progressTracker);
	var successSort = F2(
		function (a, b) {
			var nameB = A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.w;
				},
				$elm$core$String$toLower)(b);
			var nameA = A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.w;
				},
				$elm$core$String$toLower)(a);
			var buildtimeB = A2($elm$core$Basics$composeR, $author$project$Model$ProgressTracker$packageEndtime, $elm$time$Time$posixToMillis)(b);
			var buildtimeA = A2($elm$core$Basics$composeR, $author$project$Model$ProgressTracker$packageEndtime, $elm$time$Time$posixToMillis)(a);
			return notFinished ? $author$project$Misc$reverseOrder(
				A2($elm$core$Basics$compare, buildtimeA, buildtimeB)) : A2($elm$core$Basics$compare, nameA, nameB);
		});
	var filter = F2(
		function (desiredState, currentState) {
			return _Utils_eq(desiredState, currentState.bB);
		});
	var allPackages = A2(
		$elm$core$List$filter,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Tuple$second,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.w;
				},
				$elm$core$Basics$neq(''))),
		$elm$core$Dict$toList(progressTracker.hI));
	var packages = isSuperUserWithFeaturesVisible ? allPackages : A2(
		$elm$core$List$filter,
		A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $author$project$Model$ProgressTracker$isUserFacing),
		allPackages);
	var viewBuilding = A3(
		$author$project$Views$ProgressTracker$viewPkgsInProgress,
		args,
		'Building',
		A2(
			$elm$core$List$sortBy,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Tuple$second,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.w;
					},
					$elm$core$String$toLower)),
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$second,
					filter(1)),
				packages)));
	var viewErrored = A3(
		$author$project$Views$ProgressTracker$viewPkgsInProgress,
		args,
		'Failed',
		A2(
			$elm$core$List$sortBy,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Tuple$second,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.w;
					},
					$elm$core$String$toLower)),
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$second,
					filter(3)),
				packages)));
	var viewNotAttempted = A3(
		$author$project$Views$ProgressTracker$viewPkgsInProgress,
		args,
		'Not Attempted',
		A2(
			$elm$core$List$sortBy,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Tuple$second,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.w;
					},
					$elm$core$String$toLower)),
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$second,
					filter(4)),
				packages)));
	var viewQueued = A3(
		$author$project$Views$ProgressTracker$viewPkgsInProgress,
		args,
		queuedSectionTitle,
		A2(
			$elm$core$List$sortBy,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Tuple$second,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.w;
					},
					$elm$core$String$toLower)),
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$second,
					filter(0)),
				packages)));
	var viewSuccessful = A3(
		$author$project$Views$ProgressTracker$viewPkgsInProgress,
		args,
		'Completed',
		A2(
			$elm$core$List$sortWith,
			F2(
				function (_v0, _v1) {
					var packageInfoA = _v0.b;
					var packageInfoB = _v1.b;
					return A2(successSort, packageInfoA, packageInfoB);
				}),
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$second,
					filter(2)),
				packages)));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('ingredient-list-wrapper')
			]),
		_List_fromArray(
			[viewErrored, viewBuilding, viewSuccessful, viewNotAttempted, viewQueued]));
};
var $author$project$Views$ProgressTracker$viewProgressBar = F2(
	function (buildProgress, statusString) {
		var percentCompleteString = (buildProgress.nH > 0) ? $elm$core$String$fromFloat(100 * (buildProgress.kz / buildProgress.nH)) : '100';
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('order-progress-wrapper'),
					$elm$html$Html$Attributes$class(statusString)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('track')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('value'),
							A2($elm$html$Html$Attributes$style, 'width', percentCompleteString + '%')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bar')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('gradient')
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('glow')
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Views$ProgressTracker$viewElapsedTime = F2(
	function (currentTime, tracker) {
		var progress = tracker.h6;
		var _v0 = tracker.L;
		switch (_v0) {
			case 0:
				return A2(
					$elm$core$Maybe$withDefault,
					A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Added to build queue.'),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('more-info-tooltip')
									]),
								_List_fromArray(
									[
										$author$project$Views$Icon$view(
										$author$project$Views$Icon$icon(52)),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('content')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Your build has been scheduled and will begin as soon as resources are available. ')
													])),
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('You can return here at any time to check the status of this build.')
													]))
											]))
									]))
							])),
					A2(
						$elm$core$Maybe$map,
						function (startTime) {
							return $elm$html$Html$text(
								'Elapsed time - ' + A2($author$project$TimeUtils$formatDurationBetweenDatesHoursMinutesSeconds, startTime, currentTime));
						},
						progress.du));
			case 1:
				return A2(
					$elm$core$Maybe$withDefault,
					$elm$html$Html$text(''),
					A3(
						$elm$core$Maybe$map2,
						F2(
							function (start, end) {
								return $elm$html$Html$text(
									'Build time - ' + A2($author$project$TimeUtils$formatDurationBetweenDatesHoursMinutesSeconds, start, end));
							}),
						progress.du,
						progress.yc));
			default:
				return $elm$html$Html$text('');
		}
	});
var $author$project$Views$ProgressTracker$viewProgressHeader = F2(
	function (currentTime, tracker) {
		var statusIndicator = function () {
			var _v1 = tracker.L;
			switch (_v1) {
				case 0:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('build-status-indicator build-in-progress')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('loader')
									]),
								_List_fromArray(
									[
										A2($elm$html$Html$span, _List_Nil, _List_Nil),
										A2($elm$html$Html$span, _List_Nil, _List_Nil),
										A2($elm$html$Html$span, _List_Nil, _List_Nil)
									])),
								$elm$html$Html$text('In Progress')
							]));
				case 1:
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('build-status-indicator build-successful')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Finished')
							]));
				default:
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('build-status-indicator build-failed')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Failed')
							]));
			}
		}();
		var buildProgress = tracker.h6;
		var aggregateStats = function () {
			var _v0 = tracker.L;
			if (_v0 === 1) {
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('package-count-value')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(buildProgress.nH))
							])),
						$elm$html$Html$text(' Packages Built')
					]);
			} else {
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('package-count-value')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(buildProgress.kz) + (' of ' + $elm$core$String$fromInt(buildProgress.nH)))
							])),
						$elm$html$Html$text(' Packages Built')
					]);
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('order-header')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Build Status')
						])),
					statusIndicator,
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('elapsed-time')
						]),
					_List_fromArray(
						[
							A2($author$project$Views$ProgressTracker$viewElapsedTime, currentTime, tracker)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('package-count')
						]),
					aggregateStats)
				]));
	});
var $author$project$Views$ProgressTracker$viewProgress = function (_v0) {
	var projectConfigRoute = _v0.Fr;
	var togglePackagesMsg = _v0.GG;
	var downloadRequester = _v0.tG;
	var isSuperUserWithFeaturesVisible = _v0.oS;
	var currentTime = _v0.cF;
	var progressTracker = _v0.vS;
	var indemnified = _v0.ud;
	var toggleLogMsg = _v0.GF;
	var currentPackageLogOpen = _v0.hs;
	var artifactIdToLogs = _v0.A7;
	var openHubSpotChat = _v0.EV;
	var emailForNotification = _v0.Co;
	var copyData = _v0.B$;
	var supportEnabled = _v0.Go;
	var onOpenPopup = _v0.EN;
	var onDownload = _v0.EL;
	var statusString = function () {
		var _v3 = progressTracker.L;
		switch (_v3) {
			case 0:
				return 'in-progress';
			case 1:
				return 'successful';
			default:
				return 'failed';
		}
	}();
	var progressEmail = function () {
		var _v1 = _Utils_Tuple2(progressTracker.L, emailForNotification);
		if ((!_v1.a) && (!_v1.b.$)) {
			var _v2 = _v1.a;
			var email = _v1.b.a;
			return email;
		} else {
			return '';
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('order-progress'),
						$elm$html$Html$Attributes$class(statusString)
					]),
				_List_fromArray(
					[
						A2($author$project$Views$ProgressTracker$viewProgressHeader, currentTime, progressTracker),
						A2(
						$author$project$Misc$displayIf,
						!$elm$core$String$isEmpty(progressEmail),
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('build-email-info')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Your build may take 20 minutes or more. We\'ll notify '),
									A2(
									$elm$html$Html$strong,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('email-address')
										]),
									_List_fromArray(
										[
											$author$project$Views$Icon$view(
											$author$project$Views$Icon$icon(23)),
											$elm$html$Html$text(progressEmail)
										])),
									$elm$html$Html$text(' when it\'s ready (or if there\'s an error) - '),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href('https://docs.activestate.com/platform/projects/source/'),
											$elm$html$Html$Attributes$target('_blank')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Learn more about our build process and why we build from source.')
										]))
								]))),
						A2(
						$author$project$Misc$displayMaybe,
						$author$project$Views$ProgressTracker$viewIndemnificationStatus(progressTracker),
						indemnified),
						A2($author$project$Views$ProgressTracker$viewProgressBar, progressTracker.h6, statusString),
						$author$project$Views$ProgressTracker$viewFailures(progressTracker),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(togglePackagesMsg),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('expanded', progressTracker.kw)
									])),
								$elm$html$Html$Attributes$class('toggle-wrapper')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('logs-toggle')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('toggle-icon')
											]),
										_List_fromArray(
											[
												$author$project$Views$Icon$view(
												$author$project$Views$Icon$icon(13))
											])),
										$elm$html$Html$text('Package build status')
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('commit-id')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Commit ID: '),
										$elm$html$Html$text(
										$danyx23$elm_uuid$Uuid$toString(progressTracker.BR))
									]))
							])),
						A2(
						$author$project$Misc$displayIf,
						progressTracker.kw,
						$author$project$Views$ProgressTracker$viewIngredientProgress(
							{A7: artifactIdToLogs, hs: currentPackageLogOpen, cF: currentTime, oS: isSuperUserWithFeaturesVisible, EL: onDownload, EN: onOpenPopup, vS: progressTracker, GF: toggleLogMsg}))
					])),
				A3($author$project$Views$ProgressTracker$viewDownloads, downloadRequester, progressTracker, copyData),
				A2(
				$author$project$Misc$displayIf,
				$author$project$Model$ProgressTracker$isFailed(progressTracker),
				A3($author$project$Views$ProgressTracker$viewBuildFailedOptions, openHubSpotChat, projectConfigRoute, supportEnabled))
			]));
};
var $author$project$Pages$ProjectDownloads$Install = 1;
var $author$project$Pages$ProjectDownloads$SelectTab = function (a) {
	return {$: 13, a: a};
};
var $author$project$Views$StateTool$activationCmd = function (runtime) {
	if (!runtime.$) {
		var orgName = runtime.a.ix;
		var projectName = runtime.a.vT;
		var branch = runtime.a.h4;
		var branchOption = (!$author$project$Model$Branch$isDefault(branch)) ? (' --branch ' + $author$project$Model$Branch$getName(branch)) : '';
		return 'state activate --default ' + (orgName + ('/' + (projectName + branchOption)));
	} else {
		return 'state activate --default <org/project>';
	}
};
var $author$project$Model$TrackingParameter$toString = function (_v0) {
	var str = _v0;
	return str;
};
var $author$project$Views$StateTool$generateInstructions = function (_v0) {
	var progress = _v0.Fq;
	var runtime = _v0.FR;
	var platformType = _v0.rW;
	var platform = _v0.po;
	var copy = _v0.B_;
	var trackingParameter = _v0.wN;
	var showBonus = _v0.wa;
	var switchTabMsg = _v0.Gp;
	var selectedTab = _v0.FX;
	var domain = _v0.tF;
	var parameter = $author$project$Model$TrackingParameter$toString(trackingParameter);
	var isKSADomain = $author$project$Utils$DomainUtils$isKSADomain(domain);
	var installScriptFileName = 'install';
	var stateToolInstallCmd = function () {
		if (!platformType) {
			return isKSADomain ? ('powershell -Command \"& $([scriptblock]::Create((New-Object Net.WebClient).DownloadString(\'https://ksa.activestate.build/dl/cli/' + (installScriptFileName + '.ps1\')))\" --config-set api.host=ksa.activestate.build --config-set report.analytics.endpoint=https://ksa-s3-state-tool.activestate.build/pixel-ksa --config-set update.endpoint=https://ksa-s3-state-tool.activestate.build/update/state --config-set update.info.endpoint=https://ksa.activestate.build/sv/state-update/api/v1 --config-set notifications.endpoint=https://ksa-s3-state-tool.activestate.build/messages.json')) : ('powershell -Command \"& $([scriptblock]::Create((New-Object Net.WebClient).DownloadString(\'https://platform.activestate.com/dl/cli/' + (parameter + ('/' + (installScriptFileName + '.ps1\')))\"'))));
		} else {
			return isKSADomain ? ('sh <(curl -q https://ksa.activestate.build/dl/cli/' + (installScriptFileName + '.sh) --config-set api.host=ksa.activestate.build --config-set report.analytics.endpoint=https://ksa-s3-state-tool.activestate.build/pixel-ksa --config-set update.endpoint=https://ksa-s3-state-tool.activestate.build/update/state --config-set update.info.endpoint=https://ksa.activestate.build/sv/state-update/api/v1 --config-set notifications.endpoint=https://ksa-s3-state-tool.activestate.build/messages.json')) : ('curl -fsSL https://platform.activestate.com/dl/cli/' + (parameter + ('/' + (installScriptFileName + '.sh | sh'))));
		}
	}();
	var installCommand = function () {
		var baseInstallCmd = stateToolInstallCmd + '${activationCmd}';
		var activationOption = ' -c\'' + ($author$project$Views$StateTool$activationCmd(runtime) + '\'');
		return A3($elm$core$String$replace, '${activationCmd}', activationOption, baseInstallCmd);
	}();
	return A2(
		$elm$core$List$member,
		platformType,
		_List_fromArray(
			[0, 2, 1])) ? $elm$core$Maybe$Just(
		{B$: copy, tF: domain, oy: showBonus, oM: installCommand, po: platform, rW: platformType, Fq: progress, FR: runtime, FX: selectedTab, wo: stateToolInstallCmd, Gp: switchTabMsg}) : $elm$core$Maybe$Nothing;
};
var $author$project$Views$StateTool$DockerInstall = 1;
var $author$project$Views$StateTool$dockerInstructions = F2(
	function (instructions, _v0) {
		var orgName = _v0.ix;
		var projectName = _v0.vT;
		var commitID = _v0.BR;
		var uri = _v0.eW;
		var fileName = $author$project$Model$DownloadURI$fileName(uri);
		var dockerLoadText = 'docker load -i ' + fileName;
		var commitIdPrefix = A2(
			$elm$core$String$left,
			8,
			$danyx23$elm_uuid$Uuid$toString(commitID));
		var dockerTaggedPath = $elm$core$String$toLower(orgName + ('-' + (projectName + (':' + commitIdPrefix))));
		var dockerPushText = 'docker push <your-registry-name>/' + dockerTaggedPath;
		var dockerTagText = 'docker tag ' + (dockerTaggedPath + (' <your-registry-name>/' + dockerTaggedPath));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('docker-instructions'),
					$elm$html$Html$Attributes$title('Docker Instructions')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Step 1: Download the Docker Image')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('download-ui')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('primary-button download-button', true)
										])),
									$elm$html$Html$Attributes$href(uri),
									$elm$html$Html$Attributes$download(fileName)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button-label')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Download Docker Image')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('download-meta')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(fileName)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Step 2: Load the Image')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('From the download directory, load the Docker Image from the .TAR archive.')
								])),
							$author$project$Views$CliText$view(
							{
								B$: $elm$core$Maybe$Just(instructions.B$),
								l6: 'docker_load_cmd',
								Gv: dockerLoadText
							}),
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Step 3: Tag the Image')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Once loaded, tag the image with the project name.')
								])),
							$author$project$Views$CliText$view(
							{
								B$: $elm$core$Maybe$Just(instructions.B$),
								l6: 'docker_tag_cmd',
								Gv: dockerTagText
							}),
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Step 4: Publish the Image')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Then push it to a repository you\'re using. Ensure you\'re logged in to the repository before pushing.')
								])),
							$author$project$Views$CliText$view(
							{
								B$: $elm$core$Maybe$Just(instructions.B$),
								l6: 'docker_push_cmd',
								Gv: dockerPushText
							})
						]))
				]));
	});
var $author$project$Views$StateTool$installTarget = function (p) {
	if (!p) {
		return 'Command Prompt (cmd.exe)';
	} else {
		return 'Terminal';
	}
};
var $author$project$Views$Tooltip$withExtraClass = F2(
	function (className, _v0) {
		var tt = _v0;
		return _Utils_update(
			tt,
			{tO: className});
	});
var $author$project$Views$Tooltip$withWrapperContainer = F2(
	function (node, _v0) {
		var tt = _v0;
		return _Utils_update(
			tt,
			{
				w6: $elm$core$Maybe$Just(node)
			});
	});
var $author$project$Views$StateTool$guideInstructions = function (instructions) {
	var isKSADomain = $author$project$Utils$DomainUtils$isKSADomain(instructions.tF);
	var _v0 = function () {
		var _v1 = instructions.FR;
		if (!_v1.$) {
			var runtimeInstructions = _v1.a;
			var branchName = ($author$project$Model$Branch$getName(runtimeInstructions.h4) !== 'main') ? (' --branch ' + $author$project$Model$Branch$getName(runtimeInstructions.h4)) : '';
			return _Utils_Tuple3(runtimeInstructions.vT, runtimeInstructions.ix + ('/' + (runtimeInstructions.vT + branchName)), runtimeInstructions.cd);
		} else {
			return _Utils_Tuple3('', '', false);
		}
	}();
	var projectName = _v0.a;
	var orgAndProject = _v0.b;
	var isPrivateProject = _v0.c;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Run the following commands in your '),
						$elm$html$Html$text(
						$author$project$Views$StateTool$installTarget(instructions.rW))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('install-step')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('step-description')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Step 1')
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Install the ActiveState command line tool.')
									]))
							])),
						((!instructions.rW) && (!isKSADomain)) ? A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('step-command')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('primary-button download-build-button'),
										$elm$html$Html$Attributes$href('https://state-tool.s3.amazonaws.com/remote-installer/release/windows-amd64/state-remote-installer.exe'),
										$elm$html$Html$Attributes$download('state-remote-installer.exe')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Download CLI Tool (30.2 MB)')
											]))
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Run the '),
										A2(
										$elm$html$Html$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('state-remote-installer.exe')
											])),
										$elm$html$Html$text(' file once the download is finished.'),
										$author$project$Views$Tooltip$asHtml(
										A2(
											$author$project$Views$Tooltip$withTooltipElements,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Having trouble?')
														])),
													A2(
													$elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Contact our '),
															A2(
															$elm$html$Html$a,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$href('mailto:support@activestate.com'),
																	$elm$html$Html$Attributes$target('_blank')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('support team')
																])),
															$elm$html$Html$text(' for help.')
														]))
												]),
											A2(
												$author$project$Views$Tooltip$withExtraClass,
												'right-align',
												A2(
													$author$project$Views$Tooltip$withTriggerContainer,
													F2(
														function (_v2, _v3) {
															return $author$project$Views$Icon$view(
																A2(
																	$author$project$Views$Icon$square,
																	20,
																	$author$project$Views$Icon$icon(52)));
														}),
													A2($author$project$Views$Tooltip$withWrapperContainer, $elm$html$Html$span, $author$project$Views$Tooltip$newTooltip)))))
									]))
							])) : A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('step-command')
							]),
						_List_fromArray(
							[
								$author$project$Views$CliText$view(
								{
									B$: $elm$core$Maybe$Just(instructions.B$),
									l6: 'download-step-install-cli',
									Gv: instructions.wo
								})
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('install-step')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('step-description')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Step 2')
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Download your runtime.')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('step-command')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Misc$displayIf,
								isPrivateProject,
								A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Note')
												])),
											$elm$html$Html$text(' - Since this is a Private Project, you\'ll need to run '),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('cli-text-inline')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('state auth')
												])),
											$elm$html$Html$text(' beforehand to authenticate.')
										]))),
								$author$project$Views$CliText$view(
								{
									B$: $elm$core$Maybe$Just(instructions.B$),
									l6: 'download-step-checkout',
									Gv: 'state checkout ' + (orgAndProject + ' .')
								}),
								A2(
								$elm$html$Html$ul,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('This also adds an '),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('cli-text-inline')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('activestate.yaml')
													])),
												$elm$html$Html$text(' file into your working directory. For more information & other checkout options see the '),
												A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$href('https://docs.activestate.com/platform/projects/checkout/'),
														$elm$html$Html$Attributes$target('_blank')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('documentation'),
														$author$project$Views$Icon$view(
														$author$project$Views$Icon$icon(25))
													])),
												$elm$html$Html$text('.')
											]))
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('install-step')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('step-description')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Step 3')
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Start using your runtime.')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('step-command')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$details,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'open', '')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$summary,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$h4,
												_List_Nil,
												_List_fromArray(
													[
														$author$project$Views$Icon$view(
														$author$project$Views$Icon$icon(13)),
														$elm$html$Html$text('System-wide')
													]))
											])),
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Set this runtime as the default on your system. Run '),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('cli-text-inline')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('state use reset')
													])),
												$elm$html$Html$text(' to unset it.')
											])),
										$author$project$Views$CliText$view(
										{
											B$: $elm$core$Maybe$Just(instructions.B$),
											l6: 'download-step-state-use',
											Gv: 'state use ' + projectName
										})
									])),
								A2(
								$elm$html$Html$details,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$summary,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$h4,
												_List_fromArray(
													[
														A2($elm$html$Html$Attributes$attribute, 'data-cy', 'virtual-environment-toggle')
													]),
												_List_fromArray(
													[
														$author$project$Views$Icon$view(
														$author$project$Views$Icon$icon(13)),
														$elm$html$Html$text('In a virtual environment')
													]))
											])),
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Your runtime will start in a subshell. Run '),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('cli-text-inline')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('exit')
													])),
												$elm$html$Html$text(' to stop.')
											])),
										$author$project$Views$CliText$view(
										{
											B$: $elm$core$Maybe$Just(instructions.B$),
											l6: 'download-step-state-shell',
											Gv: 'state shell ' + projectName
										})
									]))
							]))
					]))
			]));
};
var $author$project$Views$StateTool$viewInstallInstructions = F2(
	function (instructions, _v0) {
		var dockerInstructionsData = A2(
			$elm$core$Maybe$andThen,
			function (_v3) {
				var commitID = _v3.a.BR;
				var downloads = _v3.a.tH;
				var orgName = _v3.b.ix;
				var projectName = _v3.b.vT;
				return $elm$core$List$head(
					A2(
						$elm$core$List$filterMap,
						function (_v4) {
							var download = _v4.Cl;
							return download.Dd ? $elm$core$Maybe$Just(
								{BR: commitID, ix: orgName, vT: projectName, eW: download.GT}) : $elm$core$Maybe$Nothing;
						},
						A2($author$project$Model$ProgressTracker$getVisibleDownloads, 1, downloads)));
			},
			A3($elm$core$Maybe$map2, $elm$core$Tuple$pair, instructions.Fq, instructions.FR));
		var tabContent = function () {
			var _v1 = instructions.FX;
			if (!_v1) {
				return $author$project$Views$StateTool$guideInstructions(instructions);
			} else {
				if (!dockerInstructionsData.$) {
					var data = dockerInstructionsData.a;
					return A2($author$project$Views$StateTool$dockerInstructions, instructions, data);
				} else {
					return $elm$html$Html$text('No Docker installation is available for this commit.');
				}
			}
		}();
		var displayTabs = $elm_community$maybe_extra$Maybe$Extra$isJust(dockerInstructionsData);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Misc$displayIf,
					displayTabs,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('section-tabs')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('selected', !instructions.FX)
											])),
										$elm$html$Html$Events$onClick(
										instructions.Gp(0))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Install via CLI')
									])),
								A2(
								$author$project$Misc$displayIf,
								displayTabs,
								A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('selected', instructions.FX === 1)
												])),
											$elm$html$Html$Events$onClick(
											instructions.Gp(1))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Install via Docker')
										])))
							]))),
					tabContent
				]));
	});
var $author$project$Views$StateTool$viewScriptInstallInstructions = function (instructions) {
	var platformString = function () {
		var _v2 = instructions.po;
		if (!_v2.$) {
			var platform = _v2.a;
			return $author$project$Model$Platform$id(platform);
		} else {
			return $author$project$Model$Platform$platformTypeToString(instructions.rW);
		}
	}();
	var installTargetHeading = A2(
		$elm$html$Html$h4,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				'Run the following command in the ' + $author$project$Views$StateTool$installTarget(instructions.rW))
			]));
	var _v0 = function () {
		var _v1 = instructions.FR;
		if (!_v1.$) {
			var runtime = _v1.a;
			return _Utils_Tuple2(
				runtime.vT,
				$author$project$Model$Branch$getName(runtime.h4));
		} else {
			return _Utils_Tuple2('', '');
		}
	}();
	var projectName = _v0.a;
	var branchName = _v0.b;
	var elementID = 'activate-command' + ('-' + (platformString + ('-' + branchName)));
	var explanation = (projectName !== '') ? A2(
		$elm$html$Html$p,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Run this command to install the State Tool, the Platform\'s CLI Utility along with your runtime. The State Tool lets you manage ActiveState runtimes and also acts as a package manager. Find tips on working with the CLI in our '),
				A3(
				$author$project$Views$Link$link,
				$author$project$Model$Route$StateToolCheatSheet,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$target('_blank')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(' State Tool Cheat Sheet')
					])),
				$elm$html$Html$text('.')
			])) : $elm$html$Html$text('');
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				installTargetHeading,
				explanation,
				$author$project$Views$CliText$view(
				{
					B$: $elm$core$Maybe$Just(instructions.B$),
					l6: elementID,
					Gv: instructions.oM
				})
			]));
};
var $author$project$Views$StateTool$viewScriptInstallInstructionsDistributionPage = function (instructions) {
	return A2($author$project$Views$StateTool$viewInstallInstructions, instructions, $author$project$Views$StateTool$viewScriptInstallInstructions);
};
var $author$project$Views$StateTool$viewStatePullInstructions = function (instructions) {
	var statePullCommand = 'state pull';
	var platformString = function () {
		var _v1 = instructions.po;
		if (!_v1.$) {
			var platform = _v1.a;
			return $author$project$Model$Platform$id(platform);
		} else {
			return $author$project$Model$Platform$platformTypeToString(instructions.rW);
		}
	}();
	var installTargetHeading = A2(
		$elm$html$Html$p,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Run the following command in the same folder as you ran the '),
				A2(
				$elm$html$Html$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('checkout')
					])),
				$elm$html$Html$text(' command to update your local installation to use the latest build.')
			]));
	var branchName = function () {
		var _v0 = instructions.FR;
		if (!_v0.$) {
			var branch = _v0.a.h4;
			return $author$project$Model$Branch$getName(branch);
		} else {
			return '';
		}
	}();
	var elementID = 'state-pull-command' + ('-' + (platformString + ('-' + branchName)));
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				installTargetHeading,
				$author$project$Views$CliText$view(
				{
					B$: $elm$core$Maybe$Just(instructions.B$),
					l6: elementID,
					Gv: statePullCommand
				})
			]));
};
var $author$project$Pages$ProjectDownloads$viewStateToolInstructions = function (_v0) {
	var orgName = _v0.ix;
	var projectName = _v0.vT;
	var branch = _v0.h4;
	var _private = _v0.cd;
	var platformType = _v0.rW;
	var progressTracker = _v0.vS;
	var copyStatus = _v0.oi;
	var maybePlatform = _v0.zb;
	var trackingParameter = _v0.wN;
	var showBonus = _v0.wa;
	var installTab = _v0.j1;
	var session = _v0.l;
	var stateToolInstructions = $author$project$Views$StateTool$generateInstructions(
		{
			B_: {
				Em: $author$project$Pages$ProjectDownloads$CopyClipboard(1),
				L: copyStatus
			},
			tF: $author$project$Model$Session$getFlags(session).B3,
			po: maybePlatform,
			rW: platformType,
			Fq: $elm$core$Maybe$Just(
				{BR: progressTracker.BR, tH: progressTracker.tH}),
			FR: $elm$core$Maybe$Just(
				{h4: branch, ix: orgName, cd: _private, vT: projectName}),
			FX: installTab,
			wa: showBonus,
			Gp: $author$project$Pages$ProjectDownloads$SelectTab,
			wN: trackingParameter
		});
	var installUsesStateTool = function () {
		if (!installTab) {
			return true;
		} else {
			return false;
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('install-instructions')
			]),
		_Utils_ap(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Download & Install Runtime')
						])),
					A2($author$project$Misc$displayMaybe, $author$project$Views$StateTool$viewScriptInstallInstructionsDistributionPage, stateToolInstructions)
				]),
			installUsesStateTool ? _List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Installed it Already? Get the Latest Changes')
						])),
					A2($author$project$Misc$displayMaybe, $author$project$Views$StateTool$viewStatePullInstructions, stateToolInstructions)
				]) : _List_Nil));
};
var $author$project$Pages$ProjectDownloads$viewBuildDataSource = F3(
	function (model, session, buildDataSource) {
		var trackingParameter = $author$project$Model$TrackingParameter$trackingParameter(session);
		var projectName = $author$project$Model$Project$getName(model.c5);
		var platforms = A2(
			$elm$core$List$filterMap,
			function (platformID) {
				return A2($elm$core$Dict$get, platformID, model.n4);
			},
			$author$project$Model$BuildPlanner$BuildPlan$platformIDs(
				$author$project$Model$BuildDataSource$getBuildPlan(buildDataSource)));
		var selectedPlatformID = A2(
			$author$project$Pages$ProjectDownloads$findSelectedPlatformID,
			session,
			{Fh: platforms, fE: model.fE});
		var progressTracker = A2(
			$elm$core$Maybe$andThen,
			function (k) {
				return A2($elm$core$Dict$get, k, model.ff);
			},
			selectedPlatformID);
		var platformTabs = A2(
			$elm$html$Html$ul,
			_List_Nil,
			A2(
				$elm$core$List$map,
				$author$project$Pages$ProjectDownloads$viewPlatformTab(selectedPlatformID),
				$author$project$Model$Platform$sort(platforms)));
		var orgName = model.c3.AC;
		var maybeUser = $author$project$Model$Session$getUser(session);
		var maybeSelectedPlatform = A2(
			$elm$core$Maybe$andThen,
			function (id) {
				return A2(
					$elm_community$list_extra$List$Extra$find,
					function (platform) {
						return _Utils_eq(
							$author$project$Model$Platform$id(platform),
							id);
					},
					platforms);
			},
			selectedPlatformID);
		var maybePlatformType = A2(
			$elm$core$Maybe$andThen,
			$author$project$Pages$ProjectDownloads$platformTypeFromString,
			A2($elm$core$Maybe$map, $author$project$Model$Platform$osName, maybeSelectedPlatform));
		var logsURL = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.s0;
			},
			progressTracker);
		var logs = A2(
			$elm$core$Maybe$withDefault,
			$elm$html$Html$text(''),
			A2(
				$elm$core$Maybe$andThen,
				function (platformProgress) {
					return A2(
						$elm$core$Maybe$map,
						$author$project$Pages$ProjectDownloads$viewDownloadCamelLogs(platformProgress),
						logsURL);
				},
				A2(
					$elm$core$Maybe$andThen,
					function (platformID) {
						return A2($elm$core$Dict$get, platformID, model.ff);
					},
					selectedPlatformID)));
		var kickPanel = A2(
			$elm$core$Maybe$withDefault,
			$elm$html$Html$text(''),
			A2(
				$elm$core$Maybe$andThen,
				function (platformID) {
					return A2(
						$elm$core$Maybe$map,
						A3($author$project$Pages$ProjectDownloads$viewKickPanel, model.cF, model.j3, platformID),
						A2($elm$core$Dict$get, platformID, model.ff));
				},
				selectedPlatformID));
		var key = A2($elm$core$Maybe$withDefault, '', selectedPlatformID);
		var isSupportedLang = function (lang) {
			switch (lang) {
				case 1:
					return true;
				case 0:
					return true;
				case 3:
					return true;
				default:
					return false;
			}
		};
		var isSuperUserWithFeaturesVisible = $author$project$Model$Session$isSuperUserWithFeaturesVisible(session);
		var isPrivateProject = $author$project$Model$Project$getIsPrivate(model.c5);
		var isMember = A2($author$project$Model$Session$isMember, model.c3.AC, session);
		var isLinuxWindowsOrMac = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (platform) {
					return $author$project$Model$Platform$isLinux(platform) || ($author$project$Model$Platform$isWindows(platform) || $author$project$Model$Platform$isMac(platform));
				},
				maybeSelectedPlatform));
		var isFreeTier = $author$project$Model$Organization$isFreeTier(model.c3);
		var isPayingCustomer = (!isFreeTier) && isMember;
		var indemnificationEnabled = $author$project$Model$Permissions$orgCanSeeIndemnificationData(model.c3);
		var indemnified = $author$project$Model$Project$getIsManaged(model.c5) ? $elm$core$Maybe$Just(true) : ((!indemnificationEnabled) ? $elm$core$Maybe$Nothing : A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.ud;
			},
			progressTracker));
		var hasScannedImage = !$elm$core$List$isEmpty(
			$author$project$Model$BuildDataSource$getScannedImages(buildDataSource));
		var emailForNotification = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.lJ;
			},
			maybeUser);
		var downloadRequester = isPayingCustomer ? 1 : (isSuperUserWithFeaturesVisible ? 2 : 0);
		var downloads = A3(
			$elm$core$Maybe$map2,
			F2(
				function (progress, platformID) {
					return $author$project$Views$ProgressTracker$viewProgress(
						{
							A7: A2(
								$elm$core$Maybe$withDefault,
								$elm$core$Dict$empty,
								A2($elm$core$Dict$get, platformID, model.iz)),
							B$: {
								Em: $author$project$Pages$ProjectDownloads$CopyClipboard(0),
								L: model.oi
							},
							hs: model.hs,
							cF: model.cF,
							tG: downloadRequester,
							Co: emailForNotification,
							ud: indemnified,
							oS: isSuperUserWithFeaturesVisible,
							EL: $author$project$Pages$ProjectDownloads$DownloadLogs,
							EN: $author$project$Pages$ProjectDownloads$OpenPopup,
							EV: $author$project$Pages$ProjectDownloads$OpenHubSpotChat,
							vS: progress,
							Fr: A2(
								$author$project$Model$Route$projectConfig,
								{ix: orgName, vT: projectName},
								A2(
									$author$project$Model$Route$withBranchName,
									A2($elm$core$Maybe$andThen, $author$project$Views$BranchPicker$getSelectedNameIfNotDefault, model.fJ),
									A2(
										$author$project$Model$Route$withCommitID,
										$elm$core$Maybe$Just(
											$author$project$Model$Commit$getCommitID(model.f0)),
										$author$project$Model$Route$projectConfigParams))),
							Go: $author$project$Model$Permissions$orgSupportEnabled(model.c3),
							GF: $author$project$Pages$ProjectDownloads$TogglePackageLog,
							GG: $author$project$Pages$ProjectDownloads$TogglePackages(platformID)
						});
				}),
			progressTracker,
			selectedPlatformID);
		var buildLanguages = $author$project$Model$BuildDataSource$getLanguages(buildDataSource);
		var isBuildOfUserSupportedLang = A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.kH;
				},
				isSupportedLang),
			buildLanguages);
		var showStateToolInstructions = A2(
			$elm$core$Maybe$andThen,
			function (progress) {
				var isSuccessful = $author$project$Model$ProgressTracker$isSuccessful(progress);
				var shouldShow = isSuccessful && (isLinuxWindowsOrMac && isBuildOfUserSupportedLang);
				return shouldShow ? A2(
					$elm$core$Maybe$map,
					$author$project$Misc$with(progress),
					maybePlatformType) : $elm$core$Maybe$Nothing;
			},
			progressTracker);
		var branch = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Model$Project$getDefaultBranch(model.c5),
			A2($elm$core$Maybe$map, $author$project$Views$BranchPicker$getSelectedBranch, model.fJ));
		var platformContent = function () {
			var _v1 = model.kn;
			if (!_v1.$) {
				var prePlatformBuildGraph = _v1.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('contents')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Misc$displayMaybe,
							function (platform) {
								return $author$project$Pages$ProjectDownloads$viewDownloadsPrePlatform(
									{tG: downloadRequester, aM: buildLanguages, c3: model.c3, po: platform, kn: prePlatformBuildGraph});
							},
							maybeSelectedPlatform)
						]));
			} else {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('contents')
						]),
					_List_fromArray(
						[
							A2($author$project$Misc$displayMaybe, $elm$core$Basics$identity, downloads),
							A2(
							$author$project$Misc$displayMaybe,
							function (_v2) {
								var platformType = _v2.a;
								var progress = _v2.b;
								return $author$project$Pages$ProjectDownloads$viewStateToolInstructions(
									{h4: branch, oi: model.oi, j1: model.j1, zb: maybeSelectedPlatform, ix: orgName, rW: platformType, cd: isPrivateProject, vS: progress, vT: projectName, l: session, wa: false, wN: trackingParameter});
							},
							showStateToolInstructions),
							A2($author$project$Misc$displayIf, isSuperUserWithFeaturesVisible, logs),
							A2($author$project$Misc$displayIf, isSuperUserWithFeaturesVisible, kickPanel),
							A2(
							$author$project$Misc$displayIf,
							hasScannedImage,
							A2($author$project$Pages$ProjectDownloads$viewImages, model, buildDataSource))
						]));
			}
		}();
		if (!platforms.b) {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('No Downloads Available')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('This project does not have any downloads yet.')
							]))
					]));
		} else {
			return A3(
				$elm$html$Html$Keyed$node,
				'div',
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('distribute-section')
					]),
				_List_fromArray(
					[
						_Utils_Tuple2(
						key,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('columns')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('column platform-list')
										]),
									_List_fromArray(
										[platformTabs])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('column deploy-methods')
										]),
									_List_fromArray(
										[platformContent]))
								])))
					]));
		}
	});
var $author$project$Pages$ProjectDownloads$viewHttpError = function (error) {
	var errorText = function () {
		var _v0 = error.mp;
		switch (_v0.$) {
			case 3:
				var resp = _v0.a;
				return resp.sY;
			case 2:
				return 'Could not request build information';
			case 1:
				return 'Connection timed out while trying to get project information';
			default:
				return 'Bad request while loading project information';
		}
	}();
	return A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('error-text')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(errorText)
			]));
};
var $author$project$Pages$ProjectDownloads$errorToList = function (error) {
	switch (error.$) {
		case 0:
			return _List_fromArray(
				['There was an error processing your request. Please try again later.']);
		case 7:
			var planningError = error.a;
			return A2(
				$elm$core$List$concatMap,
				$author$project$Model$BuildPlanner$Error$BuildExprError$errorMessages,
				$author$project$Model$BuildPlanner$Error$PlanningError$subErrors(planningError));
		default:
			return _List_Nil;
	}
};
var $author$project$Pages$ProjectDownloads$errorToMessage = function (error) {
	switch (error.$) {
		case 0:
			return 'There are some problems preventing the builds from running...';
		case 7:
			var planningError = error.a;
			return $author$project$Model$BuildPlanner$Error$PlanningError$message(planningError);
		default:
			return $author$project$Model$BuildPlanner$BuildPlannerError$message(error);
	}
};
var $author$project$Pages$ProjectDownloads$viewBuildDidNotStartOptions = F3(
	function (openHubSpotChat, projectOverviewRoute, isPaidUser) {
		var viewHelpOptions = isPaidUser ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('contact-specialist')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Get help from a Specialist')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Our expert team helps enterprise customers with complicated builds all the time. Get in touch and we can help you talk through options.')
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('primary-button'),
							$elm$html$Html$Events$onClick(openHubSpotChat)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Get in Touch')
						]))
				])) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('contact-community')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Get Help from Support')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Contact our support team and we can help you talk through options.')
						])),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$target('_blank'),
							$elm$html$Html$Attributes$class('secondary-button external-button '),
							$elm$html$Html$Attributes$href('mailto:support@activestate.com')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Contact Support')
						]))
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('build-failed-options solver-error')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('So, what\'s next?')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Most likely, this is a problem with resolving dependencies for your runtime. Here are your options...')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('columns equal-width')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('column')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Try fixing it yourself!')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Can you remove or change the version of any of the packages or platforms that are referenced above? Once the errors in the Dependencies section go away, you can commit your changes and come back here to check on your build.')
										])),
									A3(
									$author$project$Views$Link$link,
									projectOverviewRoute,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('primary-button')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Back to Configuration')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('column')
								]),
							_List_fromArray(
								[viewHelpOptions]))
						]))
				]));
	});
var $author$project$Pages$ProjectDownloads$viewSolutionError = F5(
	function (error, model, orgName, projectName, isFreeTier) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('build-cannot-start')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('We can\'t start the builds yet')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Pages$ProjectDownloads$errorToMessage(error))
								])),
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (e) {
									return A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(e)
											]));
								},
								$author$project$Pages$ProjectDownloads$errorToList(error)))
						])),
					A3(
					$author$project$Pages$ProjectDownloads$viewBuildDidNotStartOptions,
					$author$project$Pages$ProjectDownloads$OpenHubSpotChat,
					A2(
						$author$project$Model$Route$projectConfig,
						{ix: orgName, vT: projectName},
						A2(
							$author$project$Model$Route$withBranchName,
							A2($elm$core$Maybe$andThen, $author$project$Views$BranchPicker$getSelectedNameIfNotDefault, model.fJ),
							$author$project$Model$Route$projectConfigParams)),
					!isFreeTier)
				]));
	});
var $author$project$Pages$ProjectDownloads$view = F2(
	function (model, session) {
		var projectName = $author$project$Model$Project$getName(model.c5);
		var orgUrlName = model.c3.AC;
		var maybeUser = $author$project$Model$Session$getUser(session);
		var isLatestCommit = $author$project$Views$BranchPicker$commitIsLatest(
			{f0: model.f0, zf: model.fJ, kq: model.kq});
		var isFreeTier = $author$project$Model$Organization$isFreeTier(model.c3);
		var branchPicker = A2(
			$author$project$Misc$displayMaybe,
			function (branchModel) {
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$ProjectDownloads$BranchPickerViewMsg,
					A4($elm$html$Html$Lazy$lazy3, $author$project$Views$BranchPicker$view, branchModel, model.c3, maybeUser));
			},
			model.fJ);
		return A2(
			$elm$html$Html$main_,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Misc$displayIf,
					model.uk && (!model.ul),
					A2(
						$author$project$Views$NewForkPopup$view,
						$author$project$Pages$ProjectDownloads$DismissWelcomeModal,
						$author$project$Model$Project$getForkedFrom(model.c5))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('branch-ui')
						]),
					_List_fromArray(
						[branchPicker])),
					A2(
					$author$project$Misc$displayIf,
					!isLatestCommit,
					A3(
						$author$project$Views$CommitStatusBar$viewPastCommit,
						session,
						$author$project$Model$Route$routeToString(
							$author$project$Model$Route$projectDownloads(
								{
									uk: false,
									fO: A2($elm$core$Maybe$andThen, $author$project$Views$BranchPicker$getSelectedNameIfNotDefault, model.fJ),
									gr: $elm$core$Maybe$Nothing,
									Ef: $elm$core$Maybe$Nothing,
									ix: orgUrlName,
									vT: projectName
								})),
						model.f0)),
					function () {
					var _v0 = model.n6;
					_v0$3:
					while (true) {
						switch (_v0.$) {
							case 3:
								var buildDataSource = _v0.a;
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('section-is-loading', model.kq)
												]))
										]),
									_List_fromArray(
										[
											A3($author$project$Pages$ProjectDownloads$viewBuildDataSource, model, session, buildDataSource)
										]));
							case 2:
								switch (_v0.a.$) {
									case 7:
										var planningError = _v0.a.a;
										return A5(
											$author$project$Pages$ProjectDownloads$viewSolutionError,
											$author$project$Model$BuildPlanner$BuildPlannerError$PlanningError(planningError),
											model,
											orgUrlName,
											projectName,
											isFreeTier);
									case 0:
										var httpError = _v0.a.a;
										return $author$project$Pages$ProjectDownloads$viewHttpError(httpError);
									default:
										break _v0$3;
								}
							default:
								break _v0$3;
						}
					}
					return $author$project$Views$Loading$view(true);
				}()
				]));
	});
var $author$project$Pages$ProjectHistory$CancelRevertCommit = {$: 5};
var $author$project$Pages$ProjectHistory$CancelViewCommitChanges = {$: 4};
var $author$project$Pages$ProjectHistory$GetPage = function (a) {
	return {$: 3, a: a};
};
var $author$project$Model$CommitHistorical$getChanges = function (_v0) {
	var commit = _v0;
	return commit.xB;
};
var $author$project$Pages$ProjectHistory$SaveRevertCommit = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Views$ChangeTable$viewRevert = F5(
	function (isSuperUserWithFeaturesVisible, changes, platforms, oldTimestamp, newTimestamp) {
		var timestampChanges = _Utils_eq(newTimestamp, oldTimestamp) ? _List_Nil : _List_fromArray(
			[
				A2(
				$elm$html$Html$tr,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('changed')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('item-change-label')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Updating')
									]))
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('item-details')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('item-name')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										'From ' + ($rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(oldTimestamp) + (' to ' + $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(newTimestamp))))
									]))
							])),
						A2(
						$elm$html$Html$td,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('item-type')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Catalog Revision ID')
									]))
							]))
					]))
			]);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('changes-table')
						]),
					_Utils_ap(
						timestampChanges,
						A2(
							$elm$core$List$map,
							A3($author$project$Views$ChangeTable$viewSingleChange, isSuperUserWithFeaturesVisible, $author$project$Views$ChangeTable$getDescriptionRevert, platforms),
							A2($elm$core$List$sortBy, $author$project$Views$ChangeTable$sortKey, changes))))
				]));
	});
var $author$project$Pages$ProjectHistory$revertModalContent = F6(
	function (isSuperUserWithFeaturesVisible, currentCommit, revertCommit, revertCommitID, platforms, error) {
		var displayError = function (string) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-error')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(string)
					]));
		};
		var changes = $elm$core$Dict$values(revertCommit.xB);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('revert-modal')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Revert to a previous commit')
						])),
					A2($author$project$Misc$displayMaybe, displayError, error),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('You are about to restore all runtime settings including packages, platforms, languages and builds from commit '),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('cli-text-inline')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$danyx23$elm_uuid$Uuid$toString(revertCommitID))
								])),
							$elm$html$Html$text('.')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('The Catalog is automatically updated over time, reverting to this commit will also revert to the Catalog used when this commit was made.')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Editing the build and Saving Changes will update the Catalog Revision ID to current.')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('changes-table-wrapper')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('changes-table-header')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Changes')
								])),
							A5(
							$author$project$Views$ChangeTable$viewRevert,
							isSuperUserWithFeaturesVisible,
							changes,
							platforms,
							$author$project$Model$Commit$getAtTime(currentCommit),
							revertCommit.jE)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button-wrapper')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('primary-button'),
									$elm$html$Html$Events$onClick(
									A2($author$project$Pages$ProjectHistory$SaveRevertCommit, revertCommit, revertCommitID))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Revert')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('cancel-button'),
									$elm$html$Html$Events$onClick($author$project$Pages$ProjectHistory$CancelRevertCommit)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('small')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Don\'t worry, your project\'s history is never lost so you can return to the current commit later.')
								]))
						]))
				]));
	});
var $author$project$Pages$ProjectHistory$viewChangesModalContent = F6(
	function (isSuperUserWithFeaturesVisible, oldCommit, currentCommit, changes, commitID, platforms) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('revert-modal')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Changes compared to latest commit')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('These are all the changes, including packages, platforms, languages and builds, between latest commit and commit '),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('cli-text-inline')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$danyx23$elm_uuid$Uuid$toString(commitID))
								])),
							$elm$html$Html$text('.')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('changes-table-wrapper')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('changes-table-header')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Changes')
								])),
							A5(
							$author$project$Views$ChangeTable$viewRevert,
							isSuperUserWithFeaturesVisible,
							changes,
							platforms,
							$author$project$Model$Commit$getAtTime(oldCommit),
							$author$project$Model$Commit$getAtTime(currentCommit))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button-wrapper')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('cancel-button'),
									$elm$html$Html$Events$onClick($author$project$Pages$ProjectHistory$CancelViewCommitChanges)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Close')
								]))
						]))
				]));
	});
var $author$project$Views$PaginationButtons$viewPaginationButtons = F3(
	function (totalPages, currentPage, onClickMessage) {
		var pagesRemaining = totalPages - currentPage;
		var numberButton = function (number) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pagination-button'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'current-page',
								_Utils_eq(number, currentPage))
							])),
						$elm$html$Html$Events$onClick(
						onClickMessage(number))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromInt(number))
					]));
		};
		return A2(
			$author$project$Misc$displayIf,
			totalPages > 1,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pagination-links')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Misc$displayIf,
						currentPage > 1,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pagination-button'),
									$elm$html$Html$Events$onClick(
									onClickMessage(currentPage - 1))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Previous')
								]))),
						A2(
						$author$project$Misc$displayIf,
						currentPage > 1,
						numberButton(1)),
						A2(
						$author$project$Misc$displayIf,
						currentPage > 2,
						numberButton(2)),
						A2(
						$author$project$Misc$displayIf,
						currentPage > 4,
						A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('...')
								]))),
						A2(
						$author$project$Misc$displayIf,
						currentPage > 3,
						numberButton(currentPage - 1)),
						numberButton(currentPage),
						A2(
						$author$project$Misc$displayIf,
						pagesRemaining > 1,
						numberButton(currentPage + 1)),
						A2(
						$author$project$Misc$displayIf,
						pagesRemaining > 2,
						numberButton(currentPage + 2)),
						A2(
						$author$project$Misc$displayIf,
						pagesRemaining > 3,
						A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('...')
								]))),
						A2(
						$author$project$Misc$displayIf,
						pagesRemaining > 0,
						numberButton(totalPages)),
						A2(
						$author$project$Misc$displayIf,
						pagesRemaining > 0,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pagination-button'),
									$elm$html$Html$Events$onClick(
									onClickMessage(currentPage + 1))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Next')
								])))
					])));
	});
var $author$project$Pages$ProjectHistory$CopyClipboard = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$ProjectHistory$OnOverwriteCommitIdInput = function (a) {
	return {$: 20, a: a};
};
var $author$project$Pages$ProjectHistory$OverwriteCommitID = function (a) {
	return {$: 21, a: a};
};
var $author$project$Pages$ProjectHistory$RequestRevertChangeset = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$ProjectHistory$RequestSBOM = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$ProjectHistory$RequestSBOMWithDSSE = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$ProjectHistory$RequestViewChangeset = function (a) {
	return {$: 8, a: a};
};
var $author$project$Views$CreateSBOM$button = function (model) {
	var maybeMsg = function () {
		var _v1 = model.bB;
		switch (_v1.$) {
			case 0:
				return $elm$core$Maybe$Just(model.y2);
			case 2:
				var sbom = _v1.a;
				return $elm$core$Maybe$Just(
					model.xw(sbom));
			default:
				return $elm$core$Maybe$Nothing;
		}
	}();
	var clickAttr = function () {
		if (!maybeMsg.$) {
			var msg = maybeMsg.a;
			return $elm$html$Html$Events$onClick(msg);
		} else {
			return $elm$html$Html$Attributes$disabled(true);
		}
	}();
	return _Utils_eq(maybeMsg, $elm$core$Maybe$Nothing) ? A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('loading-indicator')
			]),
		_List_fromArray(
			[
				$author$project$Views$Loading$dots,
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(model.y3)
					]))
			])) : A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('text-button-simple download-report'),
				clickAttr
			]),
		_List_fromArray(
			[
				$author$project$Views$Icon$view(
				$author$project$Views$Icon$icon(21)),
				$elm$html$Html$text(model.b2)
			]));
};
var $ryan_haskell$date_format$DateFormat$HourMilitaryFixed = {$: 25};
var $ryan_haskell$date_format$DateFormat$hourMilitaryFixed = $ryan_haskell$date_format$DateFormat$HourMilitaryFixed;
var $ryan_haskell$date_format$DateFormat$MinuteFixed = {$: 31};
var $ryan_haskell$date_format$DateFormat$minuteFixed = $ryan_haskell$date_format$DateFormat$MinuteFixed;
var $ryan_haskell$date_format$DateFormat$SecondFixed = {$: 33};
var $ryan_haskell$date_format$DateFormat$secondFixed = $ryan_haskell$date_format$DateFormat$SecondFixed;
var $author$project$Pages$ProjectHistory$dateFormat = _List_fromArray(
	[
		$ryan_haskell$date_format$DateFormat$monthNameAbbreviated,
		$ryan_haskell$date_format$DateFormat$text(' '),
		$ryan_haskell$date_format$DateFormat$dayOfMonthSuffix,
		$ryan_haskell$date_format$DateFormat$text(', '),
		$ryan_haskell$date_format$DateFormat$yearNumber,
		$ryan_haskell$date_format$DateFormat$text(' '),
		$ryan_haskell$date_format$DateFormat$hourMilitaryFixed,
		$ryan_haskell$date_format$DateFormat$text(':'),
		$ryan_haskell$date_format$DateFormat$minuteFixed,
		$ryan_haskell$date_format$DateFormat$text(':'),
		$ryan_haskell$date_format$DateFormat$secondFixed
	]);
var $author$project$Pages$ProjectHistory$formatDate = F2(
	function (theDate, currentTimezone) {
		return A2(
			$elm$core$Maybe$withDefault,
			'Unknown Date',
			A2(
				$elm$core$Maybe$map,
				A2($ryan_haskell$date_format$DateFormat$format, $author$project$Pages$ProjectHistory$dateFormat, currentTimezone),
				theDate));
	});
var $author$project$Model$CommitHistorical$getAdded = function (_v0) {
	var commit = _v0;
	return commit.ak;
};
var $author$project$Model$CommitHistorical$getAtTime = function (_v0) {
	var commit = _v0;
	return commit.jE;
};
var $author$project$Model$CommitHistorical$getCommitID = function (_v0) {
	var commit = _v0;
	return commit.BR;
};
var $author$project$Model$CommitHistorical$getMessage = function (_v0) {
	var commit = _v0;
	return commit.Eh;
};
var $author$project$Model$CommitHistorical$getParentCommitID = function (_v0) {
	var commit = _v0;
	return commit.zD;
};
var $author$project$Model$CommitHistorical$getUsername = function (_v0) {
	var commit = _v0;
	return commit.AE;
};
var $author$project$Model$Permissions$orgCanDownloadSBOMs = $author$project$Model$Organization$addOnEnabled('sbom');
var $author$project$Model$Permissions$orgCanDownloadSBOMsWithDSSE = function (org) {
	return $author$project$Model$Permissions$orgCanDownloadSBOMs(org) && A2($author$project$Model$Organization$addOnEnabled, 'sbom_dsse', org);
};
var $author$project$Model$Permissions$orgCanHar = $author$project$Model$Organization$addOnEnabled('har');
var $author$project$Views$CreateSBOM$tooltip = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('more-info-tooltip')
		]),
	_List_fromArray(
		[
			$author$project$Views$Icon$view(
			$author$project$Views$Icon$icon(52)),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('content')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('An SBOM is a comprehensive list of the artifacts included in your build(s). This can include any open source libraries, plugins, extensions, and system packages.')
						]))
				]))
		]));
var $author$project$Views$ChangeTable$view = F4(
	function (isSuperUserWithFeaturesVisible, changes, platforms, timestamp) {
		var getDescription = function (operation) {
			switch (operation) {
				case 0:
					return 'Added';
				case 2:
					return 'Removed';
				default:
					return 'New version';
			}
		};
		return $elm$core$List$isEmpty(changes) ? A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('no-changes')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							'The Catalog Revision ID was changed to ' + ($rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(timestamp) + '.'))
						]))
				])) : A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('changes-table')
				]),
			A2(
				$elm$core$List$map,
				A3($author$project$Views$ChangeTable$viewSingleChange, isSuperUserWithFeaturesVisible, getDescription, platforms),
				A2($elm$core$List$sortBy, $author$project$Views$ChangeTable$sortKey, changes)));
	});
var $author$project$Pages$ProjectHistory$viewSingleCommit = F4(
	function (session, model, _v0, commit) {
		var authorizedToEdit = _v0.xh;
		var isPrePlatformCommit = _v0.yN;
		var username = $author$project$Model$CommitHistorical$getUsername(commit);
		var superUserFeaturesVisible = $author$project$Model$Session$isSuperUserWithFeaturesVisible(session);
		var selectedLabel = A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('selected-label')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Currently Viewing')
				]));
		var message = $author$project$Model$CommitHistorical$getMessage(commit);
		var latestCommitID = $author$project$Model$Branch$getCommitID(model.lm);
		var commitID = $author$project$Model$CommitHistorical$getCommitID(commit);
		var commitIDString = $danyx23$elm_uuid$Uuid$toString(commitID);
		var currentlySelected = _Utils_eq(
			commitID,
			$author$project$Model$Commit$getCommitID(model.f0));
		var isLatestCommit = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$eq(commitID),
				latestCommitID));
		var reviewImpactButton = function () {
			var _v2 = $author$project$Model$CommitHistorical$getParentCommitID(commit);
			if (!_v2.$) {
				var previousCommitID = _v2.a;
				return A3(
					$author$project$Views$Link$link,
					$author$project$Model$Route$projectImpactReport(
						{
							ix: $author$project$Model$Organization$getUrlName(model.c3),
							E5: _Utils_update(
								$author$project$Model$Route$emptyProjectImpactReportParams,
								{
									uL: $elm$core$Maybe$Just(commitID),
									uU: $elm$core$Maybe$Just(previousCommitID)
								}),
							vT: $author$project$Model$Project$getName(model.c5)
						}),
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-button-simple'),
							$elm$html$Html$Attributes$target('_blank')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('View Impact Report')
						]));
			} else {
				return $elm$html$Html$text('');
			}
		}();
		var changes = $elm$core$Dict$values(
			$author$project$Model$CommitHistorical$getChanges(commit));
		var changeUsername = (username === '') ? A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('change-username')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('State Tool')
				])) : A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('change-username')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(username)
				]));
		var changeDescriptionEl = $elm$core$String$isEmpty(message) ? A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('change-description not-provided')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Commit description not provided.')
				])) : A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('change-description')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('\"' + (message + '\"'))
				]));
		var canHar = false && ($author$project$Model$Permissions$orgCanHar(model.c3) && authorizedToEdit);
		var branchName = A2($elm$core$Maybe$andThen, $author$project$Views$BranchPicker$getSelectedNameIfNotDefault, model.fJ);
		var harLink = A3(
			$author$project$Views$Link$link,
			A2(
				$author$project$Model$Route$projectSettingsHAR,
				{
					ix: model.c3.AC,
					vT: $author$project$Model$Project$getName(model.c5)
				},
				A2(
					$author$project$Model$Route$withBranchName,
					branchName,
					A2(
						$author$project$Model$Route$withCommitID,
						$elm$core$Maybe$Just(commitID),
						$author$project$Model$Route$projectSettingsParams))),
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('view-commit text-button-simple')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Create ActiveState Artifact Repository')
				]));
		var atTime = $author$project$Model$CommitHistorical$getAtTime(commit);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('history-item')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('content')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('commit-header')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('commit-meta')
										]),
									_List_fromArray(
										[
											A2($author$project$Misc$displayIf, currentlySelected, selectedLabel),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('historytitle')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('title')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Date & Author')
														])),
													$elm$html$Html$text(
													A2(
														$author$project$Pages$ProjectHistory$formatDate,
														$author$project$Model$CommitHistorical$getAdded(commit),
														model.tx)),
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															(username === '') ? $elm$html$Html$text('via') : $elm$html$Html$text('by')
														])),
													changeUsername,
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('as-employee-badge'),
															$elm$html$Html$Attributes$class(username),
															$elm$html$Html$Attributes$title('ActiveState Employee')
														]),
													_List_fromArray(
														[
															$author$project$Views$Icon$view(
															$author$project$Views$Icon$icon(0))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('historytitle')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('title')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Commit ID ')
														])),
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('commit-id')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(commitIDString)
																])),
															function () {
															var copyID = 'commit-' + commitIDString;
															return A2(
																$elm$html$Html$button,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('clipboard-button-blue'),
																		A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Copy commit ID to clipboard'),
																		$elm$html$Html$Events$onClick(
																		$author$project$Pages$ProjectHistory$CopyClipboard(
																			{xN: copyID, Gv: commitIDString})),
																		$elm$html$Html$Attributes$classList(
																		_List_fromArray(
																			[
																				_Utils_Tuple2(
																				'copied',
																				A2($author$project$Model$CopyStatus$wasCopied, model.oi, copyID))
																			]))
																	]),
																_List_Nil);
														}()
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('historytitle')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('title')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Catalog Revision ID')
														])),
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('commit-at-time')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(atTime))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('historytitle')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('title')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Description')
														])),
													changeDescriptionEl
												])),
											A2(
											$author$project$Misc$displayIf,
											isLatestCommit && (authorizedToEdit && (currentlySelected && superUserFeaturesVisible)),
											A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('superuser-only overwrite-commit')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$h4,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Overwrite this commit with')
															])),
														A2(
														$elm$html$Html$input,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$type_('text'),
																$elm$html$Html$Attributes$placeholder('Other existing commit ID'),
																$elm$html$Html$Attributes$disabled(model.iy),
																$elm$html$Html$Attributes$value(model.ph),
																$elm$html$Html$Events$onInput($author$project$Pages$ProjectHistory$OnOverwriteCommitIdInput)
															]),
														_List_Nil),
														A2(
														$elm$html$Html$button,
														_Utils_ap(
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$type_('button'),
																	$elm$html$Html$Attributes$class('primary-button')
																]),
															function () {
																var _v1 = $danyx23$elm_uuid$Uuid$fromString(model.ph);
																if (_v1.$ === 1) {
																	return _List_fromArray(
																		[
																			$elm$html$Html$Attributes$disabled(true)
																		]);
																} else {
																	var uuid = _v1.a;
																	return _List_fromArray(
																		[
																			$elm$html$Html$Events$onClick(
																			$author$project$Pages$ProjectHistory$OverwriteCommitID(uuid)),
																			$elm$html$Html$Attributes$disabled(model.iy)
																		]);
																}
															}()),
														_List_fromArray(
															[
																model.iy ? $author$project$Views$Loading$dots : $elm$html$Html$text('Overwrite')
															]))
													]))),
											A2(
											$elm$html$Html$h4,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('changes-table-header')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Changes made')
												]))
										]))
								])),
							A4($author$project$Views$ChangeTable$view, superUserFeaturesVisible, changes, model.Fh, atTime),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('commit-actions')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Misc$displayIf,
									!isLatestCommit,
									A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-button-simple'),
												$elm$html$Html$Events$onClick(
												$author$project$Pages$ProjectHistory$RequestViewChangeset(commitID))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Diff with Latest')
											]))),
									A2(
									$author$project$Misc$displayIf,
									(!isLatestCommit) && authorizedToEdit,
									A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-button-simple'),
												$elm$html$Html$Events$onClick(
												$author$project$Pages$ProjectHistory$RequestRevertChangeset(commitID))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Revert to this Commit')
											]))),
									A2(
									$author$project$Misc$displayIf,
									!currentlySelected,
									A3(
										$author$project$Views$Link$link,
										A2(
											$author$project$Model$Route$projectConfig,
											{
												ix: model.c3.AC,
												vT: $author$project$Model$Project$getName(model.c5)
											},
											A2(
												$author$project$Model$Route$withBranchName,
												branchName,
												A2(
													$author$project$Model$Route$withCommitID,
													$elm$core$Maybe$Just(commitID),
													$author$project$Model$Route$projectConfigParams))),
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('view-commit text-button-simple')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('View at this Commit')
											]))),
									A2($author$project$Misc$displayIf, canHar, harLink),
									A2(
									$author$project$Misc$displayIf,
									$author$project$Model$Permissions$orgCanAccessImpactReport(model.c3),
									reviewImpactButton),
									A2(
									$author$project$Misc$displayIf,
									$author$project$Model$Permissions$orgCanDownloadSBOMs(model.c3) && (!isPrePlatformCommit),
									A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('commit-create-sbom')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('sbom-download-links')
													]),
												_List_fromArray(
													[
														$author$project$Views$CreateSBOM$button(
														{
															xw: A2(
																$elm$core$Basics$composeR,
																$elm$core$Result$Ok,
																$author$project$Pages$ProjectHistory$ReceiveSBOM(commitID)),
															b2: 'Generate & Download SBOM',
															y2: $author$project$Pages$ProjectHistory$RequestSBOM(commitID),
															y3: 'Generating SBOM',
															bB: A2(
																$elm$core$Maybe$withDefault,
																$author$project$Views$CreateSBOM$NotLoaded,
																A2($author$project$Uuid$Dict$get, commitID, model.iB))
														}),
														A2(
														$author$project$Misc$displayIf,
														$author$project$Model$Permissions$orgCanDownloadSBOMsWithDSSE(model.c3),
														$author$project$Views$CreateSBOM$button(
															{
																xw: A2(
																	$elm$core$Basics$composeR,
																	$elm$core$Result$Ok,
																	$author$project$Pages$ProjectHistory$ReceiveSBOMWithDSSE(commitID)),
																b2: 'Generate & Download SBOM with DSSE',
																y2: $author$project$Pages$ProjectHistory$RequestSBOMWithDSSE(commitID),
																y3: 'Generating SBOM with DSSE',
																bB: A2(
																	$elm$core$Maybe$withDefault,
																	$author$project$Views$CreateSBOM$NotLoaded,
																	A2($author$project$Uuid$Dict$get, commitID, model.iC))
															}))
													])),
												$author$project$Views$CreateSBOM$tooltip
											])))
								]))
						]))
				]));
	});
var $author$project$Pages$ProjectHistory$view = F2(
	function (model, session) {
		var maybeUser = $author$project$Model$Session$getUser(session);
		var isSuperWriter = $author$project$Model$User$isSuperUser(maybeUser);
		var isSuperUserWithFeaturesVisible = $author$project$Model$Session$isSuperUserWithFeaturesVisible(session);
		var isPrePlatformInstaller = F2(
			function (key, _v3) {
				return _Utils_eq(
					$author$project$Model$Namespace$getNamespace(key),
					$author$project$Model$Namespace$prePlatformInstaller);
			});
		var isPrePlatformCommit = A2(
			$elm$core$Basics$composeR,
			$author$project$Model$CommitHistorical$getChanges,
			$elm_community$dict_extra$Dict$Extra$any(isPrePlatformInstaller));
		var isManagedProject = $author$project$Model$Project$getIsManaged(model.c5);
		var isLatestCommit = $author$project$Views$BranchPicker$commitIsLatest(
			{f0: model.f0, zf: model.fJ, kq: model.kq});
		var canEditProjects = A2($author$project$Model$Permissions$canEditProjects, model.c3.AC, maybeUser);
		var branchPicker = A2(
			$author$project$Misc$displayMaybe,
			function (branchModel) {
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$ProjectHistory$BranchPickerViewMsg,
					A4($elm$html$Html$Lazy$lazy3, $author$project$Views$BranchPicker$view, branchModel, model.c3, maybeUser));
			},
			model.fJ);
		var authorizedToEdit = ((!isManagedProject) || isSuperWriter) && canEditProjects;
		var commitHistory = function () {
			var _v2 = model.BS;
			if (!_v2.b) {
				return A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('This project has no history yet.')
						]));
			} else {
				var commits = _v2;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('commit-history')
						]),
					A2(
						$elm$core$List$map,
						function (commit) {
							return A4(
								$author$project$Pages$ProjectHistory$viewSingleCommit,
								session,
								model,
								{
									xh: authorizedToEdit,
									yN: isPrePlatformCommit(commit)
								},
								commit);
						},
						commits));
			}
		}();
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('history-page')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('branch-ui')
						]),
					_List_fromArray(
						[branchPicker])),
					A2(
					$author$project$Misc$displayIf,
					!isLatestCommit,
					A3(
						$author$project$Views$CommitStatusBar$viewPastCommit,
						session,
						$author$project$Model$Route$routeToString(
							$author$project$Model$Route$projectHistory(
								{
									fO: A2($elm$core$Maybe$andThen, $author$project$Views$BranchPicker$getSelectedNameIfNotDefault, model.fJ),
									gr: $elm$core$Maybe$Nothing,
									ix: model.c3.AC,
									vT: $author$project$Model$Project$getName(model.c5)
								})),
						model.f0)),
					A2(
					$author$project$Misc$displayMaybe,
					function (_v0) {
						var oldCommit = _v0.a;
						var commit = _v0.b;
						var commitID = _v0.c;
						return $author$project$Views$Modal$view(
							{
								BD: 'revert-modal-wrapper',
								BI: $author$project$Pages$ProjectHistory$CancelViewCommitChanges,
								dH: A6(
									$author$project$Pages$ProjectHistory$viewChangesModalContent,
									isSuperUserWithFeaturesVisible,
									oldCommit,
									model.f0,
									$elm$core$Dict$values(commit.xB),
									commitID,
									model.Fh),
								x4: $author$project$Views$Modal$DismissButtonInvisible
							});
					},
					model.p7),
					A2(
					$author$project$Misc$displayMaybe,
					function (_v1) {
						var revertCommit = _v1.a;
						var revertCommitID = _v1.b;
						return $author$project$Views$Modal$view(
							{
								BD: 'revert-modal-wrapper',
								BI: $author$project$Pages$ProjectHistory$CancelRevertCommit,
								dH: A6($author$project$Pages$ProjectHistory$revertModalContent, isSuperUserWithFeaturesVisible, model.f0, revertCommit, revertCommitID, model.Fh, model.ju),
								x4: $author$project$Views$Modal$DismissButtonInvisible
							});
					},
					model.pF),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('section-is-loading', model.kq)
										]))
								]),
							_List_fromArray(
								[
									$author$project$Views$NotificationsInline$view(model),
									commitHistory,
									A3($author$project$Views$PaginationButtons$viewPaginationButtons, model.pY, model.jK, $author$project$Pages$ProjectHistory$GetPage)
								]))
						]))
				]));
	});
var $author$project$Model$BuildPlanner$BuildPlan$buildStateToString = function (state) {
	switch (state.$) {
		case 0:
			return 'BuildPlanning';
		case 1:
			return 'BuildPlanned';
		case 2:
			return 'BuildStarted';
		default:
			return 'BuildCompleted';
	}
};
var $author$project$Model$BuildPlanner$Error$ImpactReportError$message = function (_v0) {
	var data = _v0;
	var _v1 = _Utils_Tuple2(data.xl, data.w9);
	_v1$1:
	while (true) {
		_v1$2:
		while (true) {
			_v1$3:
			while (true) {
				switch (_v1.a.$) {
					case 2:
						switch (_v1.b.$) {
							case 2:
								var before = _v1.a.a;
								var after = _v1.b.a;
								return 'Errors resolving both input runtimes. Before: ' + ($author$project$Model$BuildPlanner$BuildPlannerError$message(before) + ('. After: ' + $author$project$Model$BuildPlanner$BuildPlannerError$message(after)));
							case 1:
								break _v1$1;
							default:
								break _v1$1;
						}
					case 1:
						switch (_v1.b.$) {
							case 2:
								break _v1$2;
							case 1:
								break _v1$3;
							default:
								break _v1$3;
						}
					default:
						switch (_v1.b.$) {
							case 2:
								break _v1$2;
							case 1:
								var _v3 = _v1.b;
								return 'Resolving dependencies, please wait or try again';
							default:
								var before = _v1.a.a;
								var after = _v1.b.a;
								return 'Unexpected error, build states are ' + ($author$project$Model$BuildPlanner$BuildPlan$buildStateToString(before.bB) + (' and ' + $author$project$Model$BuildPlanner$BuildPlan$buildStateToString(after.bB)));
						}
				}
			}
			var _v2 = _v1.a;
			return 'Resolving dependencies, please wait or try again';
		}
		var err = _v1.b.a;
		return 'Error resolving the second input runtime: ' + $author$project$Model$BuildPlanner$BuildPlannerError$message(err);
	}
	var err = _v1.a.a;
	return 'Error resolving the first input runtime: ' + $author$project$Model$BuildPlanner$BuildPlannerError$message(err);
};
var $author$project$Pages$ProjectImpactReport$view = F2(
	function (model, session) {
		var content = function () {
			var _v0 = model.hi;
			switch (_v0.$) {
				case 3:
					var viewModel = _v0.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$ProjectImpactReport$ImpactReportMsg,
						A2($author$project$Views$ImpactReport$viewDiff, session, viewModel));
				case 1:
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('impact-report-loading')
							]),
						_List_fromArray(
							[
								$author$project$Views$Loading$propeller,
								$elm$html$Html$text('Loading Impact Report')
							]));
				case 2:
					var loadError = _v0.a;
					var errorContent = function () {
						if (loadError.$ === 1) {
							switch (loadError.a.$) {
								case 0:
									var error = loadError.a.a;
									return _List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('No old build plan specified:')
												])),
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(error)
												])),
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('A commit ID or a BuildExpr must be specified. You can do so by adding either oldCommitID=[enter commit ID] or both oldAtTime=[milliseconds since 1970 January 1 at 00:00:00 UTC] and oldBuildExpr=[url encoded string of BuildExpr] as a query parameter to your URL.')
												]))
										]);
								case 1:
									var error = loadError.a.a;
									return _List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('No new build plan specified:')
												])),
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(error)
												])),
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('A commit ID or a BuildExpr must be specified. You can do so by adding either newCommitID=[enter commit ID] or both newAtTime=[milliseconds since 1970 January 1 at 00:00:00 UTC] and newBuildExpr=[url encoded string of BuildExpr] as a query parameter to your URL.')
												]))
										]);
								default:
									var _v2 = loadError.a;
									var oldError = _v2.a;
									var newError = _v2.b;
									return _List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Neither new nor old build plan specified:')
												])),
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('old: ' + oldError)
												])),
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('new: ' + newError)
												])),
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Both a new and old commit ID or a BuildExpr must be specified. You can do so by adding one of either oldCommitID=[enter commit ID] or both oldAtTime=[milliseconds since 1970 January 1 at 00:00:00 UTC] and oldBuildExpr=[url encoded string of BuildExpr], and also one of either newCommitID=[enter commit ID] or both newAtTime=[milliseconds since 1970 January 1 at 00:00:00 UTC] and newBuildExpr=[url encoded string of BuildExpr] as a query parameter to your URL.')
												]))
										]);
							}
						} else {
							if (!loadError.a.$) {
								var err = loadError.a.a;
								return _List_fromArray(
									[
										$elm$html$Html$text(
										'There was an error processing your request: ' + $author$project$Model$Message$reason(err))
									]);
							} else {
								var err = loadError.a.a;
								return _List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Model$BuildPlanner$Error$ImpactReportError$message(err))
									]);
							}
						}
					}();
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('params-error')
							]),
						errorContent);
				default:
					return $elm$html$Html$text('');
			}
		}();
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('project-impact-report-page')
				]),
			_List_fromArray(
				[content]));
	});
var $author$project$Pages$ProjectOverview$BonusChevronClicked = {$: 13};
var $author$project$Pages$ProjectOverview$BranchDownloadsViewMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$ProjectOverview$ChangeGuidePlatform = function (a) {
	return {$: 22, a: a};
};
var $author$project$Pages$ProjectOverview$CopyClipboard = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$ProjectOverview$DismissNewProjectModal = {$: 1};
var $author$project$Pages$ProjectOverview$OnCopyProjectUrl = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$ProjectOverview$RequestSBOM = {$: 18};
var $author$project$Pages$ProjectOverview$RequestSBOMWithDSSE = {$: 20};
var $author$project$Pages$ProjectOverview$SelectTab = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$ProjectOverview$ShowUpdateForkModal = {$: 9};
var $author$project$Model$Route$createProjectRedirect = A2($elm$core$Basics$composeL, $author$project$Model$Route$Protected, $author$project$Model$Route$CreateProjectRedirect);
var $author$project$Url$Extra$createImportDocs = function (queryParams) {
	return A3(
		$author$project$Url$Extra$createUrl,
		$author$project$Url$Extra$docsDomain,
		_List_fromArray(
			['platform', 'projects', 'managing_requirements']),
		queryParams);
};
var $author$project$Views$PlatformTabs$switchPlatformTypeButton = F3(
	function (currentPlatformType, onChangeTab, newPlatformType) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'selected',
							_Utils_eq(currentPlatformType, newPlatformType))
						])),
					$elm$html$Html$Events$onClick(
					onChangeTab(newPlatformType))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Model$Platform$platformTypeToString(newPlatformType))
				]));
	});
var $author$project$Views$PlatformTabs$view = function (_v0) {
	var platformTypes = _v0.Fg;
	var onChangeTab = _v0.EJ;
	var currentPlatformType = _v0.B6;
	var uniquePlatformTypes = A2($elm_community$list_extra$List$Extra$uniqueBy, $author$project$Model$Platform$platformTypeToString, platformTypes);
	var selectedPlatform = A2($author$project$Misc$getWithFallback, currentPlatformType, uniquePlatformTypes);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('section-tabs')
			]),
		A2(
			$elm$core$List$map,
			A2($author$project$Views$PlatformTabs$switchPlatformTypeButton, selectedPlatform, onChangeTab),
			uniquePlatformTypes));
};
var $author$project$Views$StateTool$guideInstructionsSimple = function (_v0) {
	var projectName = _v0.vT;
	var orgName = _v0.ix;
	var isPrivate = _v0.Dy;
	var allPlatformsInProject = _v0.qh;
	var copyMsg = _v0.B0;
	var changeTabMsg = _v0.Bz;
	var selectedPlatform = _v0.FW;
	var domain = _v0.tF;
	var installCommand = $author$project$Utils$DomainUtils$isKSADomain(domain) ? 'sh <(curl -q https://ksa.activestate.build/dl/cli/install.sh) --config-set api.host=ksa.activestate.build --config-set report.analytics.endpoint=https://ksa-s3-state-tool.activestate.build/pixel-ksa --config-set update.endpoint=https://ksa-s3-state-tool.activestate.build/update/state --config-set update.info.endpoint=https://ksa.activestate.build/sv/state-update/api/v1 --config-set notifications.endpoint=https://ksa-s3-state-tool.activestate.build/messages.json' : 'curl -fsSL https://platform.activestate.com/dl/cli/onb01/install.sh | sh';
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('new-box getting-started-guide-simple')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('header')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$src('/img/getting-started-guide.svg'),
								$elm$html$Html$Attributes$class('getting-started-icon'),
								$elm$html$Html$Attributes$alt('Getting Started Guide Icon')
							]),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h1,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Installing & using this runtime')
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Run the commands below in your '),
										A2(
										$elm$html$Html$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Views$StateTool$installTarget(selectedPlatform))
											])),
										$elm$html$Html$text(' to get your runtime up and running and install packages. For a more detailed list of commands, check out the '),
										A3(
										$author$project$Views$Link$link,
										$author$project$Model$Route$StateToolCheatSheet,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$target('_blank')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('CLI Cheat Sheet')
											])),
										$elm$html$Html$text(' or see the '),
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href($author$project$Url$Extra$docsDomain),
												$elm$html$Html$Attributes$target('_blank')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('full documentation')
											])),
										$elm$html$Html$text('.')
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('install-section')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('install-step')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('step-description')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h4,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Step 1')
											])),
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Install the ActiveState command line tool, it\'s how you\'ll manage your runtime.')
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('step-command')
									]),
								_List_fromArray(
									[
										$author$project$Views$PlatformTabs$view(
										{B6: selectedPlatform, EJ: changeTabMsg, Fg: allPlatformsInProject}),
										(!selectedPlatform) ? ($author$project$Utils$DomainUtils$isKSADomain(domain) ? $author$project$Views$CliText$view(
										{
											B$: $elm$core$Maybe$Just(copyMsg),
											l6: 'guide-step-install-cli',
											Gv: 'powershell -Command \"& $([scriptblock]::Create((New-Object Net.WebClient).DownloadString(\'https://ksa.activestate.build/dl/cli/install.ps1\')))\" --config-set api.host=ksa.activestate.build --config-set report.analytics.endpoint=https://ksa-s3-state-tool.activestate.build/pixel-ksa --config-set update.endpoint=https://ksa-s3-state-tool.activestate.build/update/state --config-set update.info.endpoint=https://ksa.activestate.build/sv/state-update/api/v1 --config-set notifications.endpoint=https://ksa-s3-state-tool.activestate.build/messages.json'
										}) : A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('primary-button download-build-button'),
														$elm$html$Html$Attributes$href('https://state-tool.s3.amazonaws.com/remote-installer/release/windows-amd64/state-remote-installer_onb01.exe'),
														$elm$html$Html$Attributes$download('state-remote-installer.exe')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$span,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Download CLI Tool (30.2 MB)')
															]))
													])),
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Run the '),
														A2(
														$elm$html$Html$strong,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('state-remote-installer.exe')
															])),
														$elm$html$Html$text(' file once the download is finished.'),
														$author$project$Views$Tooltip$asHtml(
														A2(
															$author$project$Views$Tooltip$withTooltipElements,
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$h4,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Having trouble?')
																		])),
																	A2(
																	$elm$html$Html$p,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Contact our '),
																			A2(
																			$elm$html$Html$a,
																			_List_fromArray(
																				[
																					$elm$html$Html$Attributes$href('mailto:support@activestate.com'),
																					$elm$html$Html$Attributes$target('_blank')
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text('support team')
																				])),
																			$elm$html$Html$text(' for help.')
																		]))
																]),
															A2(
																$author$project$Views$Tooltip$withExtraClass,
																'right-align',
																A2(
																	$author$project$Views$Tooltip$withTriggerContainer,
																	F2(
																		function (_v1, _v2) {
																			return $author$project$Views$Icon$view(
																				A2(
																					$author$project$Views$Icon$square,
																					20,
																					$author$project$Views$Icon$icon(52)));
																		}),
																	A2($author$project$Views$Tooltip$withWrapperContainer, $elm$html$Html$span, $author$project$Views$Tooltip$newTooltip)))))
													]))
											]))) : $author$project$Views$CliText$view(
										{
											B$: $elm$core$Maybe$Just(copyMsg),
											l6: 'guide-step-install-cli',
											Gv: installCommand
										})
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('install-step')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('step-description')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h4,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Step 2')
											])),
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Download your runtime.')
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('step-command')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Misc$displayIf,
										isPrivate,
										A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$strong,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Note')
														])),
													$elm$html$Html$text(' - Since this is a Private Project, you\'ll need to run '),
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('cli-text-inline')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('state auth')
														])),
													$elm$html$Html$text(' beforehand to authenticate.')
												]))),
										$author$project$Views$CliText$view(
										{
											B$: $elm$core$Maybe$Just(copyMsg),
											l6: 'guide-step-checkout',
											Gv: 'state checkout ' + (orgName + ('/' + (projectName + ' .')))
										}),
										A2(
										$elm$html$Html$ul,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('This also adds an '),
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('cli-text-inline')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('activestate.yaml')
															])),
														$elm$html$Html$text(' file into your working directory. For more information & other checkout options see the '),
														A2(
														$elm$html$Html$a,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$href('https://docs.activestate.com/platform/projects/checkout/'),
																$elm$html$Html$Attributes$target('_blank')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('documentation'),
																$author$project$Views$Icon$view(
																$author$project$Views$Icon$icon(25))
															])),
														$elm$html$Html$text('.')
													]))
											]))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('install-step')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('step-description')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h4,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Step 3')
											])),
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Start using your runtime.')
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('step-command')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$details,
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$attribute, 'open', '')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$summary,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$h4,
														_List_Nil,
														_List_fromArray(
															[
																$author$project$Views$Icon$view(
																$author$project$Views$Icon$icon(13)),
																$elm$html$Html$text('System-wide')
															]))
													])),
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Set this runtime as the default on your system. Run '),
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('cli-text-inline')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('state use reset')
															])),
														$elm$html$Html$text(' to unset it.')
													])),
												$author$project$Views$CliText$view(
												{
													B$: $elm$core$Maybe$Just(copyMsg),
													l6: 'guide-step-state-use',
													Gv: 'state use ' + projectName
												})
											])),
										A2(
										$elm$html$Html$details,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$summary,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$h4,
														_List_fromArray(
															[
																A2($elm$html$Html$Attributes$attribute, 'data-cy', 'virtual-environment-toggle')
															]),
														_List_fromArray(
															[
																$author$project$Views$Icon$view(
																$author$project$Views$Icon$icon(13)),
																$elm$html$Html$text('In a virtual environment')
															]))
													])),
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Your runtime will start in a subshell. Run '),
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('cli-text-inline')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('exit')
															])),
														$elm$html$Html$text(' to stop.')
													])),
												$author$project$Views$CliText$view(
												{
													B$: $elm$core$Maybe$Just(copyMsg),
													l6: 'guide-step-state-shell',
													Gv: 'state shell ' + projectName
												})
											]))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('install-step')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('step-description')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h4,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Step 4')
											])),
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Install packages from our trusted catalog.')
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('step-command')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h4,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Install a single package')
											])),
										$author$project$Views$CliText$view(
										{
											B$: $elm$core$Maybe$Just(copyMsg),
											l6: 'guide-step-install-package',
											Gv: 'state install <package-name>'
										}),
										A2(
										$elm$html$Html$ul,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('This will install the recommended version of the package, to install a specific version use '),
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('cli-text-inline')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('<package-name@2.1>')
															]))
													]))
											])),
										A2(
										$elm$html$Html$h4,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Install packages from a requirements file')
											])),
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('See a list of supported file formats for each language in our '),
												A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$href(
														$author$project$Url$Extra$createImportDocs(_List_Nil)),
														$elm$html$Html$Attributes$target('_blank')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('documentation')
													])),
												$elm$html$Html$text('.')
											])),
										$author$project$Views$CliText$view(
										{
											B$: $elm$core$Maybe$Just(copyMsg),
											l6: 'guide-step-import',
											Gv: 'state import <path/to/requirements-file>'
										})
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('additional-resources-section')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Need more help? Check out these additional resources')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('additional-resources')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h4,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Support')
											])),
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Get stuck? Our support team can lend a hand.')
											])),
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href('mailto:support@activestate.com'),
												$elm$html$Html$Attributes$target('_blank')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Contact Support')
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h4,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('CLI Command Cheat Sheet')
											])),
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Feeling stuck on the command line? Review these common commands for managing your runtime.')
											])),
										A3(
										$author$project$Views$Link$link,
										$author$project$Model$Route$StateToolCheatSheet,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$target('_blank')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('View Common CLI Commands')
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h4,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Complete Platform Documentation')
											])),
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('It\'s packed with helpful guides to get you started or you can learn all the features and commands that you can run.')
											])),
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href($author$project$Url$Extra$docsDomain),
												$elm$html$Html$Attributes$target('_blank')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Read the Docs')
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Model$Language$supportsStateToolInstallation = function (language) {
	switch (language) {
		case 1:
			return true;
		case 0:
			return true;
		case 3:
			return true;
		default:
			return false;
	}
};
var $author$project$Views$BranchDownloadsView$orderLanguageEl = F3(
	function (buildDataSource, name, constraint) {
		var versionString = function () {
			var _v0 = _Utils_Tuple2(
				constraint,
				A2(
					$krisajenkins$remotedata$RemoteData$map,
					$author$project$Model$BuildDataSource$getLanguageResolvedVersion(name),
					buildDataSource));
			_v0$0:
			while (true) {
				_v0$3:
				while (true) {
					switch (_v0.b.$) {
						case 3:
							if (_v0.a.$ === 1) {
								break _v0$0;
							} else {
								if (!_v0.b.a.$) {
									var version = _v0.b.a.a;
									return version;
								} else {
									break _v0$3;
								}
							}
						case 2:
							if (_v0.a.$ === 1) {
								break _v0$0;
							} else {
								return '';
							}
						default:
							if (_v0.a.$ === 1) {
								break _v0$0;
							} else {
								break _v0$3;
							}
					}
				}
				return '(..)';
			}
			var version = _v0.a.a;
			return version;
		}();
		return A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('item-name')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(name)
						])),
					$elm$html$Html$text(' '),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('item-version')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(versionString)
						]))
				]));
	});
var $author$project$Views$BranchDownloadsView$langsAndPackages = F3(
	function (buildData, branchName, _v0) {
		var viewLanguage = F2(
			function (name, version) {
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A3($author$project$Views$BranchDownloadsView$orderLanguageEl, buildData.n6, name, version)
						]));
			});
		var languages = $author$project$Model$BuildPlanner$SolveLegacyEditor$getLanguages(buildData.qR);
		var langsView = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('language-and-version')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$h4,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(branchName + ' branch')
						])),
				A2(
					$elm$core$List$map,
					$elm_community$basics_extra$Basics$Extra$uncurry(viewLanguage),
					$elm$core$Dict$toList(languages))));
		return langsView;
	});
var $author$project$Views$BranchDownloadsView$projectConfigLink = F4(
	function (model, label, className, branchName) {
		return A3(
			$author$project$Views$Link$link,
			A2(
				$author$project$Model$Route$projectConfig,
				{
					ix: model.c3.AC,
					vT: $author$project$Model$Project$getName(model.c5)
				},
				A2(
					$author$project$Model$Route$withBranchName,
					$elm$core$Maybe$Just(branchName),
					$author$project$Model$Route$projectConfigParams)),
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(className)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Views$BranchDownloadsView$buildDetails = F4(
	function (model, branchName, buildData, hasOnlyOneBranch) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('column branch-details')
				]),
			_List_fromArray(
				[
					A3($author$project$Views$BranchDownloadsView$langsAndPackages, buildData, branchName, hasOnlyOneBranch),
					A4($author$project$Views$BranchDownloadsView$projectConfigLink, model, 'Configure', 'secondary-button small', branchName)
				]));
	});
var $author$project$Views$BranchDownloadsView$CopyChmodMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Views$BranchDownloadsView$ShowDownloadInstructionsModalMsg = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $author$project$Views$Icon$normal = $author$project$Views$Icon$setSize($author$project$Views$Icon$Normal);
var $author$project$Model$ProgressTracker$branchName = function (tracker) {
	return $author$project$Model$Branch$getName(tracker.h4);
};
var $author$project$Model$Route$createAccountWithNextRoute = function (nextRoute) {
	return $author$project$Model$Route$CreateAccount(
		_Utils_update(
			$author$project$Model$Route$emptyCreateAccountParams,
			{dg: nextRoute}));
};
var $author$project$Views$ProgressTracker$viewDownloadButtons = F3(
	function (showInstallerInstructionsMsg, user, tracker) {
		var projectName = $author$project$Model$Project$getName(tracker.c5);
		var platformType = $author$project$Model$Platform$getPlatformType(tracker.po);
		var platform = tracker.po;
		var orgName = tracker.c3.AC;
		var isTcl = _Utils_eq(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.kH;
				},
				tracker.aM),
			_List_fromArray(
				[2]));
		var downloadButtonDiv = $elm$html$Html$div(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('download-buttons')
				]));
		var installButton = downloadButtonDiv(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$author$project$Misc$onClickNoBubble(
							showInstallerInstructionsMsg(platformType)),
							$elm$html$Html$Attributes$class('primary-button cli-toggle'),
							A2(
							$elm$html$Html$Attributes$attribute,
							'data-cy',
							'install-button-' + $author$project$Model$Platform$platformTypeToString(platformType))
						]),
					_List_fromArray(
						[
							$author$project$Views$Icon$view(
							$author$project$Views$Icon$icon(21)),
							$elm$html$Html$text('Install')
						]))
				]));
		var viewInstaller = function (contents) {
			return A2(
				$author$project$Misc$displayIf,
				$author$project$Model$ProgressTracker$canDownloadInstallers(tracker),
				downloadButtonDiv(contents));
		};
		var _v0 = tracker.L;
		if (_v0 === 1) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('build-item-row')
					]),
				_List_fromArray(
					[
						viewInstaller(
						function () {
							if ((!isTcl) && $elm_community$maybe_extra$Maybe$Extra$isNothing(user)) {
								var currentRoute = $author$project$Model$Route$projectOverview(
									A2(
										$author$project$Model$Route$withBranchName,
										$elm$core$Maybe$Just(
											$author$project$Model$ProgressTracker$branchName(tracker)),
										$author$project$Model$Route$projectOverviewParams(
											{ix: orgName, vT: projectName})));
								return _List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('button-with-tooltip')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('primary-button disabled download-build-button')
													]),
												_List_fromArray(
													[
														$author$project$Views$Icon$view(
														$author$project$Views$Icon$icon(21)),
														$elm$html$Html$text('Download')
													])),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('tooltip sign-in-tooltip')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$p,
														_List_Nil,
														_List_fromArray(
															[
																A3(
																$author$project$Views$Link$link,
																$author$project$Model$Route$createAccountWithNextRoute(
																	$elm$core$Maybe$Just(currentRoute)),
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('Create an Account')
																	])),
																$elm$html$Html$text(' or '),
																A3(
																$author$project$Views$Link$link,
																$author$project$Model$Route$loginWithNextRoute(currentRoute),
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('Sign In')
																	])),
																$elm$html$Html$text(' to access downloadable installers.')
															])),
														A2(
														$elm$html$Html$p,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('sub-text')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('You can install via CLI without an account!')
															]))
													]))
											]))
									]);
							} else {
								return A2(
									$elm$core$List$map,
									function (primaryDownload) {
										var url = primaryDownload.GT;
										var isDocker = primaryDownload.Dd;
										var extension = isDocker ? 'Docker Image' : A2($author$project$Model$DownloadURI$fileExtension, platformType, url);
										return A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('primary-button download-build-button'),
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2('docker-build-button', isDocker)
														])),
													$elm$html$Html$Attributes$class(
													'download-' + $elm$core$String$toLower(
														$author$project$Model$Platform$brandName(platform))),
													$elm$html$Html$Attributes$href(url),
													$elm$html$Html$Attributes$download('')
												]),
											_List_fromArray(
												[
													$author$project$Views$Icon$view(
													$author$project$Views$Icon$icon(21)),
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Download')
														])),
													A2(
													$author$project$Misc$displayIf,
													!$elm$core$String$isEmpty(extension),
													A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('filename')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('(' + (extension + ')'))
															])))
												]));
									},
									A2(
										$elm$core$List$filter,
										function ($) {
											return $.Dx;
										},
										tracker.tH));
							}
						}()),
						A2($author$project$Misc$displayIf, !isTcl, installButton)
					]));
		} else {
			var buttonLabel = function () {
				var _v1 = tracker.L;
				switch (_v1) {
					case 0:
						return 'View Build Progress';
					case 2:
						return 'View Build Logs';
					default:
						return 'View Build Status';
				}
			}();
			return downloadButtonDiv(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('secondary-button'),
								$elm$html$Html$Attributes$href(
								$author$project$Model$Route$routeToString(
									$author$project$Model$Route$projectDownloads(
										{
											uk: false,
											fO: $elm$core$Maybe$Just(
												$author$project$Model$ProgressTracker$branchName(tracker)),
											gr: $elm$core$Maybe$Nothing,
											Ef: $elm$core$Maybe$Just(
												$author$project$Model$Platform$id(platform)),
											ix: orgName,
											vT: projectName
										})))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(buttonLabel)
							]))
					]));
		}
	});
var $author$project$Views$ProgressTracker$viewStatus = F2(
	function (_v0, tracker) {
		var indemnified = _v0.ud;
		var showInstallerInstructionsMsg = _v0.F6;
		var user = _v0.gS;
		var copyData = _v0.B$;
		var id = _v0.l6;
		var platform = tracker.po;
		var platformTypeIconKind = $author$project$Model$Platform$platformTypeToIconKind(
			$author$project$Model$Platform$getPlatformType(platform));
		var firstInstallerUrl = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.GT;
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function ($) {
						return $.yL;
					},
					tracker.tH)));
		var _v1 = function () {
			var _v2 = tracker.L;
			switch (_v2) {
				case 0:
					return _Utils_Tuple2('Building', 'Building');
				case 1:
					return _Utils_Tuple2('Build ready', 'Ready');
				default:
					return _Utils_Tuple2('Build failed', '');
			}
		}();
		var statusLabel = _v1.a;
		var statusClass = _v1.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('build-item'),
					$elm$html$Html$Attributes$class(statusClass)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('platform-meta')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('name-and-status')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Misc$displayMaybe,
									A2($elm$core$Basics$composeR, $author$project$Views$Icon$icon, $author$project$Views$Icon$view),
									platformTypeIconKind),
									A2(
									$elm$html$Html$h4,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('platform-name')
										]),
									_List_fromArray(
										[
											$author$project$Model$Platform$simpleName(platform),
											$author$project$Model$Platform$supportedPlatformsPopup(platform)
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class(
											'build-status ' + $elm$core$String$toLower(statusClass))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('build-status-text')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(statusLabel)
												])),
											A2(
											$author$project$Misc$displayIf,
											!$author$project$Model$ProgressTracker$isFinished(tracker),
											$author$project$Views$Loading$dots),
											A2(
											$author$project$Misc$displayMaybe,
											$author$project$Views$ProgressTracker$viewIndemnificationStatus(tracker),
											indemnified)
										]))
								])),
							A3($author$project$Views$ProgressTracker$viewDownloadButtons, showInstallerInstructionsMsg, user, tracker)
						])),
					function () {
					if (!firstInstallerUrl.$) {
						var url = firstInstallerUrl.a;
						return $author$project$Views$ProgressTracker$additionalInstructions(
							{
								B$: copyData,
								l6: id,
								rW: $author$project$Model$Platform$getPlatformType(platform),
								eW: url
							});
					} else {
						return $elm$html$Html$text('');
					}
				}()
				]));
	});
var $author$project$Views$BranchDownloadsView$downloadDetails = F2(
	function (model, buildData) {
		var trackers = A2(
			$elm$core$List$sortBy,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.po;
				},
				A2($elm$core$Basics$composeR, $author$project$Model$Platform$getPlatformType, $author$project$Model$Platform$platformTypeToString)),
			$elm$core$Dict$values(buildData.ff));
		var indemnificationEnabled = $author$project$Model$Permissions$orgCanSeeIndemnificationData(model.c3);
		var viewStatus = function (tracker) {
			var indemnified = $author$project$Model$Project$getIsManaged(model.c5) ? $elm$core$Maybe$Just(true) : ((!indemnificationEnabled) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(tracker.ud));
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('build-item-row')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Views$ProgressTracker$viewStatus,
						{
							B$: {Em: $author$project$Views$BranchDownloadsView$CopyChmodMsg, L: model.oi},
							l6: tracker.tr,
							ud: indemnified,
							F6: A3($author$project$Views$BranchDownloadsView$ShowDownloadInstructionsModalMsg, buildData.h4, tracker.BR, tracker.tH),
							gS: model.gS
						},
						tracker)
					]));
		};
		var configHasPlatforms = !$elm$core$Set$isEmpty(
			$author$project$Model$BuildPlanner$SolveLegacyEditor$getPlatforms(buildData.qR));
		var downloadView = function () {
			if (configHasPlatforms) {
				var _v0 = buildData.n6;
				switch (_v0.$) {
					case 2:
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('solution-error')
								]),
							_List_fromArray(
								[
									$author$project$Views$Icon$view(
									A2(
										$author$project$Views$Icon$colored,
										A4($avh4$elm_color$Color$rgba, 0, 0, 0, 0.3),
										$author$project$Views$Icon$normal(
											$author$project$Views$Icon$icon(35)))),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Unable to start builds')
												])),
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Check the project configuration for more details.')
												]))
										]))
								]));
					case 3:
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('build-item-rows')
								]),
							A2(
								$elm$core$List$cons,
								A2(
									$elm$html$Html$h4,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('title')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Builds'),
											$author$project$Views$InstallerDocsLink$view(
											A2($elm$core$List$any, $author$project$Model$ProgressTracker$canDownloadInstallers, trackers))
										])),
								A2($elm$core$List$map, viewStatus, trackers)));
					case 1:
						return $author$project$Views$Loading$dots;
					default:
						return $elm$html$Html$text('');
				}
			} else {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('branch-no-platforms')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Builds')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Builds are not enabled for this project.')
								]))
						]));
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('column downloads-column')
				]),
			_List_fromArray(
				[downloadView]));
	});
var $author$project$Views$ScannedImage$viewScannedImage = F2(
	function (copyData, image) {
		var idAttr = $author$project$Model$Namespace$getName(image.Y);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							'Updating the ' + ($author$project$Model$Namespace$getName(image.Y) + ' image in your Environment'))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('General Instructions')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('To use the latest version, update all references to previous container versions in your configuration files, CI/CD pipelines, and deployment manifests to the following.')
						])),
					$author$project$Views$CliText$view(
					{
						B$: $elm$core$Maybe$Just(copyData),
						l6: idAttr,
						Gv: $author$project$Model$BuildPlanner$Node$dockerRef(image)
					})
				]));
	});
var $author$project$Views$BranchDownloadsView$imagesView = F3(
	function (model, branch, image) {
		var maybeBuildDataSource = A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.n6;
				},
				$krisajenkins$remotedata$RemoteData$toMaybe),
			A2(
				$elm$core$Dict$get,
				$author$project$Model$Branch$getName(branch),
				model.qq));
		var fields = _List_fromArray(
			[
				_Utils_Tuple2('Registry', image.Fz),
				_Utils_Tuple2('Image name', image.CT),
				_Utils_Tuple2('Based On', image.Be),
				_Utils_Tuple2('OS Arch', image.E$),
				_Utils_Tuple2('Manifest', image.D9),
				_Utils_Tuple2(
				'Tags',
				A2($elm$core$String$join, ', ', image.Gt))
			]);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('branch')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('image')
						]),
					A2(
						$elm$core$List$map,
						function (_v0) {
							var label = _v0.a;
							var value = _v0.b;
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('image-field')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h4,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(label)
											])),
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(value)
											]))
									]));
						},
						fields)),
					A2(
					$author$project$Misc$displayMaybe,
					function (buildDataSource) {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('deploy-images overview-deploy-images')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									A2(
										$elm$core$List$map,
										$author$project$Views$ScannedImage$viewScannedImage(
											{Em: $author$project$Views$BranchDownloadsView$CopyChmodMsg, L: model.oi}),
										$author$project$Model$BuildDataSource$getScannedImages(buildDataSource)))
								]));
					},
					maybeBuildDataSource),
					A3(
					$author$project$Views$Link$link,
					$author$project$Model$Route$projectDownloads(
						{
							uk: false,
							fO: $elm$core$Maybe$Just(
								$author$project$Model$Branch$getName(branch)),
							gr: $author$project$Model$Branch$getCommitID(branch),
							Ef: $elm$core$Maybe$Nothing,
							ix: model.c3.AC,
							vT: $author$project$Model$Project$getName(model.c5)
						}),
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('primary-button full-deploy-instructions')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('View Full Instructions')
						]))
				]));
	});
var $author$project$Views$BranchDownloadsView$buildView = F3(
	function (model, hasOnlyOneBranch, branch) {
		var branchName = $author$project$Model$Branch$getName(branch);
		var data = A2($elm$core$Dict$get, branchName, model.qq);
		var markerView = function (d) {
			var _v0 = A2(
				$elm$core$Maybe$andThen,
				$elm$core$List$head,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$second,
					$author$project$Model$BuildPlanner$BuildExprEditor$Simple$getImages(d.qR)));
			if (!_v0.$) {
				var firstScannedImage = _v0.a;
				return A3($author$project$Views$BranchDownloadsView$imagesView, model, branch, firstScannedImage);
			} else {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('branch columns')
						]),
					_List_fromArray(
						[
							A4($author$project$Views$BranchDownloadsView$buildDetails, model, branchName, d, hasOnlyOneBranch),
							A2($author$project$Views$BranchDownloadsView$downloadDetails, model, d)
						]));
			}
		};
		return A2($author$project$Misc$displayMaybe, markerView, data);
	});
var $author$project$Views$LanguageVersionWarning$projectOverviewBox = F3(
	function (projectEditableStatus, tier, kind) {
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('top-stripe bleed-stripe-into-parent'),
				$author$project$Views$LanguageVersionWarning$kindAttributes(kind)),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('warning')
						]),
					_List_fromArray(
						[
							$author$project$Views$LanguageVersionWarning$warning(kind)
						])),
					A2($author$project$Views$LanguageVersionWarning$longMessage, tier, kind),
					$author$project$Views$LanguageVersionWarning$actionButton(
					{qu: false, qW: true, mp: kind, r$: projectEditableStatus})
				]));
	});
var $author$project$Views$BranchDownloadsView$selectedCommunityPython2BoxIfNeeded = function (model) {
	var tier = $author$project$Model$Tier$stringToSimpleTier(model.c3.dc);
	var org = model.c3;
	var languages = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		$elm$core$List$concat(
			A3(
				$elm$core$Dict$foldl,
				F3(
					function (_v2, branchBuildData, acc) {
						return A2(
							$elm$core$List$cons,
							A2(
								$elm$core$List$map,
								$author$project$Views$LanguageVersionWarning$fromLanguageItem(branchBuildData.n6),
								$author$project$Model$BuildPlanner$SolveLegacyEditor$getLanguageItems(branchBuildData.qR)),
							acc);
					}),
				_List_Nil,
				model.qq)));
	var allHaveCommunityVersion = A3(
		$elm$core$Dict$foldl,
		F3(
			function (_v1, branchBuildData, acc) {
				return acc ? A2($author$project$Model$VersionPredicates$Perl$hasCommunityVersion, branchBuildData.qR, branchBuildData.n6) : acc;
			}),
		true,
		model.qq);
	var allHaveCommunityPython2 = A3(
		$elm$core$Dict$foldl,
		F3(
			function (_v0, branchBuildData, acc) {
				return acc ? A2($author$project$Model$VersionPredicates$Python$hasCommunityPython2, branchBuildData.qR, branchBuildData.n6) : acc;
			}),
		true,
		model.qq);
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$html$Html$text(''),
		A2(
			$elm$core$Maybe$map,
			A2($author$project$Views$LanguageVersionWarning$projectOverviewBox, 2, tier),
			$author$project$Views$LanguageVersionWarning$init(
				{BB: $elm$core$Maybe$Nothing, CK: allHaveCommunityPython2, CL: allHaveCommunityVersion, aM: languages, pd: org})));
};
var $author$project$Model$BranchTree$singleton = function (branch) {
	return $zwilias$elm_rosetree$Tree$singleton(branch);
};
var $author$project$Views$BranchDownloadsView$view = function (model) {
	var mainTree = $author$project$Model$BranchTree$singleton(
		$author$project$Model$Project$getDefaultBranch(model.c5));
	var treeBranches = A2(
		$elm$core$Maybe$withDefault,
		mainTree,
		$author$project$Model$BranchTree$fromBranches(
			$author$project$Model$Project$getBranches(model.c5)));
	var hasOnlyOneBranch = $elm$core$Dict$size(model.qq) === 1;
	var buildViewFn = A2($author$project$Views$BranchDownloadsView$buildView, model, hasOnlyOneBranch);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('project-overview-branches')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Misc$displayIf,
				!hasOnlyOneBranch,
				A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('branches-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Branches'),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('more-info-tooltip')
								]),
							_List_fromArray(
								[
									$author$project$Views$Icon$view(
									$author$project$Views$Icon$icon(52)),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('content')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('This project has multiple branches, each with a separate configuration & builds.')
										]))
								]))
						]))),
				A2($author$project$Model$BranchTree$view, buildViewFn, treeBranches),
				$author$project$Views$BranchDownloadsView$selectedCommunityPython2BoxIfNeeded(model)
			]));
};
var $author$project$Views$CVESummary$view = F2(
	function (model, cveSeverities) {
		var content = function () {
			switch (cveSeverities.$) {
				case 3:
					var vulnerabilities = cveSeverities.a;
					var reportButton = function () {
						var _v3 = model.ng;
						switch (_v3.$) {
							case 0:
								return $elm$html$Html$text('');
							case 1:
								return A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('loading-report')
										]),
									_List_fromArray(
										[
											$author$project$Views$Loading$dots,
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Generating Report')
												]))
										]));
							case 3:
								var report = _v3.a;
								return A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-button-simple download-report'),
											$elm$html$Html$Attributes$href(report.D1),
											$elm$html$Html$Attributes$target('_blank')
										]),
									_List_fromArray(
										[
											$author$project$Views$Icon$view(
											$author$project$Views$Icon$icon(21)),
											$elm$html$Html$text('Download CVE Report')
										]));
							default:
								return A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('report-error')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('icon')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('tooltip')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('There was an error generating the CVE report.')
												]))
										]));
						}
					}();
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('counts-and-download')
							]),
						function () {
							var _v1 = model.qM;
							if (!_v1.$) {
								if (_v1.a === 1) {
									var _v2 = _v1.a;
									return _List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('no-summary')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Unable to report—at least one branch with an attempted build is required.')
												]))
										]);
								} else {
									return _List_fromArray(
										[
											$author$project$Views$CVESummary$viewTotals(
											{xI: false, y7: $elm$core$Maybe$Nothing, zd: $elm$core$Maybe$Nothing, F2: vulnerabilities}),
											reportButton
										]);
								}
							} else {
								return _List_Nil;
							}
						}());
				case 1:
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[$author$project$Views$Loading$dots]));
				case 0:
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[$author$project$Views$Loading$dots]));
				default:
					return A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('There was an error requesting Vulnerability information.')
							]));
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('cve-summary')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Vulnerabilities'),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('explanation')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('(CVEs)')
								]))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('more-info-tooltip')
						]),
					_List_fromArray(
						[
							$author$project$Views$Icon$view(
							$author$project$Views$Icon$icon(52)),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('content')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Total count of unique vulnerabilities (also known as CVEs) detected in your project.')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('To view affected components of your project, view the project configuration.')
										]))
								]))
						])),
					content
				]));
	});
var $elm$html$Html$figure = _VirtualDom_node('figure');
var $author$project$Views$PerlNagModal$view = F2(
	function (nextRoute, closeMessage) {
		return A2(
			$author$project$Views$Modal$viewWithModalId,
			$elm$core$Maybe$Just($author$project$Views$PerlNagModal$modalId),
			{
				BD: 'perl-nag-modal',
				BI: closeMessage,
				dH: A2(
					$elm$html$Html$article,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$aside,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$figure,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$id('illustration')
										]),
									_List_fromArray(
										[
											$author$project$Views$Icon$view(
											$author$project$Views$Icon$icon(60))
										]))
								])),
							A2(
							$elm$html$Html$header,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h1,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Get More From Your Perl Download')
										]))
								])),
							A2(
							$elm$html$Html$section,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('By signing up to the ActiveState Platform, you can do more with your install. Get access to features like package bundles, package management, security reports, and more!')
										]))
								])),
							A2(
							$elm$html$Html$footer,
							_List_Nil,
							_List_fromArray(
								[
									A3(
									$author$project$Views$Link$link,
									$author$project$Model$Route$createAccountWithNextRoute(nextRoute),
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('primary-button small')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Sign Up for Free')
												]))
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(closeMessage),
											$elm$html$Html$Attributes$class('secondary-button small'),
											A2($elm$html$Html$Attributes$attribute, 'data-cy', 'perl-bypass')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Continue to Install')
										]))
								]))
						])),
				x4: $author$project$Views$Modal$DismissButtonInvisible
			});
	});
var $author$project$Views$ShareProjectModal$contentView = F3(
	function (project, organization, copyData) {
		var wasCopied = A2($author$project$Model$CopyStatus$wasCopied, copyData.L, 'project-url');
		var url = A3(
			$elm$url$Url$Builder$crossOrigin,
			'https://platform.activestate.com',
			_List_fromArray(
				[
					$author$project$Model$Organization$getUrlName(organization),
					$author$project$Model$Project$getName(project)
				]),
			_List_Nil);
		var permissionView = _List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Only editors of the '),
						A2(
						$elm$html$Html$b,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Model$Organization$getUrlName(organization))
							])),
						$elm$html$Html$text(' organization can modify this project.')
					]))
			]);
		var description = $author$project$Model$Project$getIsPrivate(project) ? _List_fromArray(
			[
				$elm$html$Html$text('This is a '),
				A2(
				$elm$html$Html$b,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('private project')
					])),
				$elm$html$Html$text(' so only members of the '),
				A2(
				$elm$html$Html$b,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(organization.AC)
					])),
				$elm$html$Html$text(' organization can view and use it. Share the project link below with members of this organization to visit in their browser.')
			]) : _List_fromArray(
			[
				$elm$html$Html$text('This is a '),
				A2(
				$elm$html$Html$b,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('public project')
					])),
				$elm$html$Html$text(' so anyone can view and use it. You can share the project link below with anyone to visit in their browser.')
			]);
		var buttonIcon = wasCopied ? $author$project$Views$Icon$icon(10) : A2(
			$author$project$Views$Icon$colored,
			A4($avh4$elm_color$Color$rgba, 0, 0, 0, 0),
			$author$project$Views$Icon$icon(41));
		return A2(
			$elm$html$Html$article,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Share Project')
						])),
					A2($elm$html$Html$p, _List_Nil, description),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('cli-text')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(url)
										]))
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('primary-button'),
									$elm$html$Html$Events$onClick(
									copyData.Em(
										{xN: 'project-url', Gv: url})),
									A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Copy project URL to clipboard'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('copied', wasCopied)
										]))
								]),
							_List_fromArray(
								[
									$author$project$Views$Icon$view(
									$author$project$Views$Icon$small(buttonIcon)),
									$elm$html$Html$text('Copy Link')
								]))
						])),
					A2($elm$html$Html$hr, _List_Nil, _List_Nil),
					A2(
					$elm$html$Html$footer,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('privacy')
						]),
					_List_fromArray(
						[
							$author$project$Views$Icon$view(
							A2(
								$author$project$Views$Icon$colored,
								A4($avh4$elm_color$Color$rgba, 0, 0, 0, 0),
								$author$project$Views$Icon$icon(22))),
							A3(
							$elm$html$Html$node,
							'hgroup',
							_List_Nil,
							A2(
								$elm$core$List$cons,
								A2(
									$elm$html$Html$h3,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Who can modify it?')
										])),
								permissionView)),
							A3(
							$author$project$Views$Link$link,
							$author$project$Model$Route$orgMembers(organization.AC),
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Manage members & permissions')
								]))
						]))
				]));
	});
var $author$project$Views$ShareProjectModal$view = function (_v0) {
	var closeMessage = _v0.BI;
	var project = _v0.c5;
	var organization = _v0.c3;
	var copyData = _v0.B$;
	return A2(
		$author$project$Views$Modal$viewWithModalId,
		$elm$core$Maybe$Just($author$project$Views$ShareProjectModal$modalId),
		{
			BD: '',
			BI: closeMessage,
			dH: A3($author$project$Views$ShareProjectModal$contentView, project, organization, copyData),
			x4: A2($author$project$Views$Modal$DismissButtonVisible, 1, true)
		});
};
var $author$project$Views$StateTool$recommendLoginView = A2(
	$elm$html$Html$p,
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text('Log in via '),
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('cli-text-inline')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('state auth')
				])),
			$elm$html$Html$text(' before activating the project. This is a one-time requirement, and is essential for private projects.')
		]));
var $author$project$Views$StateTool$stateToolInstructionsOverviewPage = function (instructions) {
	var inputElementID = 'modal-cli-install-command';
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Copy and paste the following command into your '),
						A2(
						$elm$html$Html$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Views$StateTool$installTarget(instructions.rW))
							])),
						$elm$html$Html$text(' to install the State Tool, the Platform\'s CLI Utility along with your runtime.')
					])),
				$author$project$Views$StateTool$recommendLoginView,
				$author$project$Views$CliText$view(
				{B$: $elm$core$Maybe$Nothing, l6: inputElementID, Gv: instructions.oM}),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('primary-button copy-to-clipboard-button'),
						A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Copy code snippet to clipboard'),
						$elm$html$Html$Events$onClick(
						instructions.B$.Em(
							{xN: inputElementID, Gv: instructions.oM})),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'copied',
								A2($author$project$Model$CopyStatus$wasCopied, instructions.B$.L, inputElementID))
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('icon')
							]),
						_List_Nil),
						$elm$html$Html$text('Copy to Clipboard')
					])),
				A2(
				$author$project$Misc$displayIf,
				instructions.oy,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('add-package-install-instructions')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Great!')
										])),
									$elm$html$Html$text(' Now paste the command into your '),
									$elm$html$Html$text(
									$author$project$Views$StateTool$installTarget(instructions.rW)),
									$elm$html$Html$text(' and press'),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('keyboard-key')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Enter')
										])),
									$elm$html$Html$text('.')
								]))
						])))
			]));
};
var $author$project$Views$StateTool$viewInstallInstructionsModal = F2(
	function (instructions, _v0) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Download & Install Runtime')
						])),
					A2($author$project$Views$StateTool$viewInstallInstructions, instructions, $author$project$Views$StateTool$stateToolInstructionsOverviewPage)
				]));
	});
var $author$project$Model$Route$withLanguageName = F2(
	function (languageName, params) {
		return _Utils_update(
			params,
			{
				DQ: $elm$core$Maybe$Just(languageName)
			});
	});
var $author$project$Pages$ProjectOverview$view = F3(
	function (model, session, currentTime) {
		var updateNotification = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('forked-updates')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('secondary-button small'),
							$elm$html$Html$Events$onClick($author$project$Pages$ProjectOverview$ShowUpdateForkModal)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Updates Available')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('The upstream project has some changes that have not yet been merged into this project.')
						]))
				]));
		var trackingParameter = $author$project$Model$TrackingParameter$trackingParameter(session);
		var projectRouteFactory = function (projectRoute) {
			return $author$project$Model$Route$Protected(
				$author$project$Model$Route$Org(
					{
						ix: model.c3.AC,
						vI: $author$project$Model$Route$OrgProject(
							{
								vT: $author$project$Model$Project$getName(model.c5),
								zL: projectRoute
							})
					}));
		};
		var projectLessThanWeekOld = function () {
			if (!currentTime.$) {
				var time = currentTime.a;
				return A2(
					$author$project$TimeUtils$daysBetween,
					$author$project$Model$Project$getAdded(model.c5),
					time) < 7;
			} else {
				return false;
			}
		}();
		var orgRoute = $author$project$Model$Route$Protected(
			$author$project$Model$Route$Org(
				{
					ix: model.c3.AC,
					vI: $author$project$Model$Route$OrgIndex($elm$core$Maybe$Nothing)
				}));
		var maybeUpdateForkModal = function () {
			var _v4 = model.kE;
			if (!_v4.$) {
				var modalModel = _v4.a;
				return A2(
					$elm$core$Basics$composeR,
					$author$project$Views$UpdateForkModal$view(session),
					$elm$html$Html$map($author$project$Pages$ProjectOverview$UpdateForkModalMsg))(modalModel);
			} else {
				return $elm$html$Html$text('');
			}
		}();
		var managedProject = $author$project$Model$Project$getIsManaged(model.c5);
		var projectIsEditable = !managedProject;
		var isPrivateProject = $author$project$Model$Project$getIsPrivate(model.c5);
		var isDistribtionOnly = $author$project$Model$Project$getIsDistributionOnly(model.c5);
		var displayNewForkModal = model.uk && ((!model.ul) && _Utils_eq(model.AA, $elm$core$Maybe$Nothing));
		var displayCreateAccountModal = model.oQ;
		var cliInstructionsModal = function (instructions) {
			var content = A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Views$StateTool$viewInstallInstructionsModal, instructions, $author$project$Pages$ProjectOverview$BonusChevronClicked),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$Pages$ProjectOverview$DismissCLIInstructionsModal),
								$elm$html$Html$Attributes$class('dismiss-x')
							]),
						_List_fromArray(
							[
								$author$project$Views$Icon$view(
								$author$project$Views$Icon$icon(19))
							]))
					]));
			return A2(
				$author$project$Views$Modal$viewWithModalId,
				$elm$core$Maybe$Just($author$project$Views$StateTool$viewInstallInstructionsModalID),
				{BD: 'cli-installer-instructions', BI: $author$project$Pages$ProjectOverview$DismissCLIInstructionsModal, dH: content, x4: $author$project$Views$Modal$DismissButtonInvisible});
		};
		var cliInstructions = A2(
			$elm$core$Maybe$andThen,
			function (_v3) {
				var branch = _v3.h4;
				var platformType = _v3.rW;
				var progressInformation = _v3.pr;
				var showBonus = _v3.wa;
				var currentTab = _v3.ln;
				return $author$project$Views$StateTool$generateInstructions(
					{
						B_: {Em: $author$project$Pages$ProjectOverview$CopyClipboard, L: model.oi},
						tF: $author$project$Model$Session$getFlags(session).B3,
						po: $elm$core$Maybe$Nothing,
						rW: platformType,
						Fq: progressInformation,
						FR: $elm$core$Maybe$Just(
							{
								h4: branch,
								ix: model.c3.AC,
								cd: isPrivateProject,
								vT: $author$project$Model$Project$getName(model.c5)
							}),
						FX: currentTab,
						wa: showBonus,
						Gp: $author$project$Pages$ProjectOverview$SelectTab,
						wN: trackingParameter
					});
			},
			model.fM);
		var cleanDescriptionText = $elm_community$string_extra$String$Extra$clean(
			$author$project$Model$Project$getDescription(model.c5));
		var hasDescription = !$elm$core$String$isEmpty(cleanDescriptionText);
		var markdownDescription = function () {
			var _v2 = A2(
				$elm$core$Result$andThen,
				function (ast) {
					return A2($dillonkearns$elm_markdown$Markdown$Renderer$render, $dillonkearns$elm_markdown$Markdown$Renderer$defaultHtmlRenderer, ast);
				},
				A2(
					$elm$core$Result$mapError,
					$elm$core$Basics$always('ignored'),
					$dillonkearns$elm_markdown$Markdown$Parser$parse(
						$author$project$Model$Project$getDescription(model.c5))));
			if (!_v2.$) {
				var rendered = _v2.a;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('markdown')
							]),
						rendered)
					]);
			} else {
				return _List_fromArray(
					[
						$elm$html$Html$text(cleanDescriptionText)
					]);
			}
		}();
		var canEditProject = A2(
			$author$project$Model$Permissions$canEditProjects,
			model.c3.AC,
			$author$project$Model$Session$getUser(session));
		var descriptionView = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('project-description')
				]),
			_List_fromArray(
				[
					hasDescription ? A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('description-text')
						]),
					markdownDescription) : A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('description-text no-description')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('This project has no description.')
						])),
					A2(
					$author$project$Misc$displayIf,
					canEditProject,
					A3(
						$author$project$Views$Link$link,
						$author$project$Model$Route$projectSettingsWithFragment(
							{
								oD: $author$project$Model$Route$addDescriptionFragment,
								ix: model.c3.AC,
								vT: $author$project$Model$Project$getName(model.c5)
							}),
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('edit-description text-button-simple')
							]),
						_List_fromArray(
							[
								$author$project$Views$Icon$view(
								$author$project$Views$Icon$icon(59)),
								$elm$html$Html$text(
								hasDescription ? 'Edit' : 'Add Description')
							])))
				]));
		var displayDescription = hasDescription ? true : (canEditProject ? true : false);
		var userCanEditProject = projectIsEditable && canEditProject;
		var canBeCLIInstalled = !$elm$core$List$isEmpty(
			A2(
				$elm$core$List$filter,
				function (l) {
					return $author$project$Model$Language$supportsStateToolInstallation(l);
				},
				model.qf));
		var showQuickStartGuide = projectLessThanWeekOld && (canBeCLIInstalled && (!isDistribtionOnly));
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('project-overview-page')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Misc$displayMaybe,
					function (err) {
						return A2(
							$author$project$Views$UnsupportedProjectModal$view,
							session,
							{
								DP: $author$project$Model$BuildPlanner$BuildExprEditor$Simple$Model$getUnknownAps(err),
								vI: orgRoute,
								zL: projectRouteFactory,
								Go: $author$project$Model$Permissions$orgSupportEnabled(model.c3)
							});
					},
					model.AA),
					A2(
					$author$project$Misc$displayIf,
					displayNewForkModal,
					A2(
						$author$project$Views$NewForkPopup$view,
						$author$project$Pages$ProjectOverview$DismissNewProjectModal,
						$author$project$Model$Project$getForkedFrom(model.c5))),
					A2(
					$author$project$Misc$displayIf,
					model.DD,
					$author$project$Views$ShareProjectModal$view(
						{
							BI: $author$project$Pages$ProjectOverview$CloseShareModal,
							B$: {Em: $author$project$Pages$ProjectOverview$OnCopyProjectUrl, L: model.oi},
							c3: model.c3,
							c5: model.c5
						})),
					A2(
					$author$project$Misc$displayIf,
					displayCreateAccountModal,
					A2(
						$author$project$Views$PerlNagModal$view,
						$elm$core$Maybe$Just(
							$author$project$Model$Route$createProjectRedirect(
								$author$project$Model$Route$withNewUser(
									A2($author$project$Model$Route$withLanguageName, 'perl', $author$project$Model$Route$emptyCreateProjectParams)))),
						$author$project$Pages$ProjectOverview$DismissPerlModal)),
					A2($author$project$Misc$displayMaybe, cliInstructionsModal, cliInstructions),
					A2(
					$author$project$Misc$displayIf,
					showQuickStartGuide,
					$author$project$Views$StateTool$guideInstructionsSimple(
						{
							qh: model.qh,
							Bz: $author$project$Pages$ProjectOverview$ChangeGuidePlatform,
							B0: {Em: $author$project$Pages$ProjectOverview$CopyClipboard, L: model.oi},
							tF: $author$project$Model$Session$getFlags(session).B3,
							Dy: $author$project$Model$Project$getIsPrivate(model.c5),
							ix: model.c3.AC,
							vT: $author$project$Model$Project$getName(model.c5),
							FW: model.q$
						})),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('project-details card')
						]),
					_List_fromArray(
						[
							A2($author$project$Misc$displayIf, displayDescription, descriptionView),
							function () {
							var canSeeIfForked = ((!$author$project$Model$Project$getIsDistributionOnly(model.c5)) && (!$author$project$Model$BuildPlanner$SolveLegacyEditor$isPanorama1(model.dj.hA.qR))) || $author$project$Model$Session$isSuperUserWithFeaturesVisible(session);
							var _v0 = _Utils_Tuple2(
								canSeeIfForked,
								$author$project$Model$Project$getForkedFrom(model.c5));
							if (_v0.a && (_v0.b.$ === 2)) {
								var forkedFrom = _v0.b.a;
								var upstreamCommitID = $author$project$Model$Branch$getUpstreamCommitID(
									$author$project$Model$Project$getDefaultBranch(model.c5));
								var showUpdateForkPrompt = function () {
									var _v1 = _Utils_Tuple3(userCanEditProject, forkedFrom.DU, upstreamCommitID);
									if ((_v1.a && (!_v1.b.$)) && (!_v1.c.$)) {
										var forkedCommit = _v1.b.a;
										var upstreamCommit = _v1.c.a;
										return !_Utils_eq(
											forkedCommit,
											$danyx23$elm_uuid$Uuid$toString(upstreamCommit));
									} else {
										return false;
									}
								}();
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('forked-from-wrapper')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('forked-from-details'),
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2('pre-platform', isDistribtionOnly)
														]))
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('fork-icon'),
															$elm$html$Html$Attributes$classList(
															_List_fromArray(
																[
																	_Utils_Tuple2('out-of-date', showUpdateForkPrompt)
																]))
														]),
													_List_Nil),
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('This project is a fork of '),
															A3(
															$author$project$Views$Link$link,
															A2($author$project$Model$Route$orgIndex, forkedFrom.c3, $elm$core$Maybe$Nothing),
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(forkedFrom.c3)
																])),
															$elm$html$Html$text(' / '),
															A3(
															$author$project$Views$Link$link,
															$author$project$Model$Route$projectOverview(
																A2(
																	$author$project$Model$Route$withBranchName,
																	model.Bi,
																	$author$project$Model$Route$projectOverviewParams(
																		{ix: forkedFrom.c3, vT: forkedFrom.c5}))),
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(forkedFrom.c5)
																]))
														]))
												])),
											A2($author$project$Misc$displayIf, showUpdateForkPrompt, updateNotification),
											maybeUpdateForkModal
										]));
							} else {
								return $elm$html$Html$text('');
							}
						}(),
							A2(
							$author$project$Misc$displayIf,
							A2($author$project$Pages$ProjectOverview$showCVEs, session, model),
							function () {
								var mainBranchBuildData = model.dj.hA;
								var vulnerabilities = A2(
									$krisajenkins$remotedata$RemoteData$andThen,
									function (buildDataSource) {
										return A2(
											$krisajenkins$remotedata$RemoteData$mapError,
											$author$project$Model$BuildPlanner$BuildPlannerError$HttpError,
											A2(
												$krisajenkins$remotedata$RemoteData$map,
												A2(
													$elm$core$Basics$composeR,
													$elm$core$List$concat,
													A2(
														$elm$core$Basics$composeR,
														$elm_community$list_extra$List$Extra$uniqueBy(
															function ($) {
																return $.B9;
															}),
														A2(
															$elm$core$Basics$composeR,
															$elm$core$List$map(
																function ($) {
																	return $.ck;
																}),
															$author$project$Model$SeverityHistogram$fromSeverities))),
												$author$project$Misc$remoteDataConcat(
													$author$project$Model$BuildPlanner$SolveLegacyEditor$canSeeCubeCVEs(
														{qR: mainBranchBuildData.qR, c3: model.c3}) ? A2(
														$elm$core$List$map,
														function (key) {
															return A2(
																$author$project$Model$NormsAndVulns$getVulnerabilities,
																model.rF,
																$author$project$Model$NormsAndVulns$PurlVulnKey(key));
														},
														$elm_community$list_extra$List$Extra$unique(
															A2(
																$elm$core$List$map,
																$author$project$Model$BuildPlanner$Component$getAnalyticsCVEKey,
																A2(
																	$elm$core$List$filterMap,
																	function (node) {
																		return A2(
																			$elm$core$Dict$get,
																			node.rE,
																			$author$project$Model$BuildDataSource$getComponentsByDirectNodeId(buildDataSource));
																	},
																	A2(
																		$elm$core$List$map,
																		$elm$core$Tuple$second,
																		$elm$core$Dict$toList(
																			$author$project$Model$BuildDataSource$getNodesByKey(buildDataSource))))))) : A2(
														$elm$core$List$map,
														function (key) {
															return A2(
																$author$project$Model$NormsAndVulns$getVulnerabilities,
																model.rF,
																$author$project$Model$NormsAndVulns$NamespacedVulnKey(key));
														},
														A2(
															$elm_community$list_extra$List$Extra$uniqueBy,
															function (key) {
																return _Utils_Tuple2(
																	$author$project$Model$Namespace$key(key),
																	key.aI);
															},
															$author$project$Model$BuildDataSource$getAllVulnerabilityKeys(buildDataSource))))));
									},
									mainBranchBuildData.n6);
								return A2(
									$elm$html$Html$map,
									$author$project$Pages$ProjectOverview$CVESummaryMsg,
									A2($author$project$Views$CVESummary$view, model.i_, vulnerabilities));
							}()),
							A2(
							$author$project$Misc$displayIf,
							$author$project$Model$Permissions$orgCanDownloadSBOMs(model.c3) && ((!isDistribtionOnly) && (!$author$project$Model$BuildPlanner$SolveLegacyEditor$isPanorama1(model.dj.hA.qR))),
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('create-sbom-row')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h4,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Software Bill of Materials'),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('explanation')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('(SBOM)')
													]))
											])),
										$author$project$Views$CreateSBOM$tooltip,
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('sbom-download-links')
											]),
										_List_fromArray(
											[
												$author$project$Views$CreateSBOM$button(
												{
													xw: A2($elm$core$Basics$composeR, $elm$core$Result$Ok, $author$project$Pages$ProjectOverview$ReceiveSBOM),
													b2: 'Generate & Download SBOM',
													y2: $author$project$Pages$ProjectOverview$RequestSBOM,
													y3: 'Generating SBOM',
													bB: model.nm
												}),
												A2(
												$author$project$Misc$displayIf,
												$author$project$Model$Permissions$orgCanDownloadSBOMsWithDSSE(model.c3),
												$author$project$Views$CreateSBOM$button(
													{
														xw: A2($elm$core$Basics$composeR, $elm$core$Result$Ok, $author$project$Pages$ProjectOverview$ReceiveSBOMWithDSSE),
														b2: 'Generate & Download SBOM with DSSE',
														y2: $author$project$Pages$ProjectOverview$RequestSBOMWithDSSE,
														y3: 'Generating SBOM with DSSE',
														bB: model.nn
													}))
											]))
									])))
						])),
					isDistribtionOnly ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('new-box')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Builds')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('content')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Views$Link$link,
									$author$project$Model$Route$projectDownloads(
										{
											uk: false,
											fO: $elm$core$Maybe$Nothing,
											gr: $elm$core$Maybe$Nothing,
											Ef: $elm$core$Maybe$Nothing,
											ix: model.c3.AC,
											vT: $author$project$Model$Project$getName(model.c5)
										}),
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('primary-button')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('View all Available Builds')
										]))
								]))
						])) : A2(
					$elm$html$Html$map,
					$author$project$Pages$ProjectOverview$BranchDownloadsViewMsg,
					$author$project$Views$BranchDownloadsView$view(model.dj))
				]));
	});
var $author$project$Pages$ProjectPreview$languageRow = F2(
	function (name, version) {
		var constraintSuffix = function () {
			switch (version.$) {
				case 1:
					var str = version.a;
					return '-' + str;
				case 2:
					var first = version.a;
					var others = version.b;
					return '-' + A2($author$project$Model$BuildPlanner$BuildExpr$Solve$Constraint$toPythonSyntax, first, others);
				default:
					return '';
			}
		}();
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('package-unchanged')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('item-name')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('simple-platform-name')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											_Utils_ap(
												$elm_community$string_extra$String$Extra$toSentenceCase(name),
												constraintSuffix))
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$ProjectPreview$platformRow = function (platform) {
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('package-unchanged')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('item-name')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('simple-platform-name')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Model$Platform$displayName(platform))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$ProjectPreview$languageAndPlatformView = function (model) {
	var platforms = A2(
		$elm$core$List$map,
		$author$project$Pages$ProjectPreview$platformRow,
		A2(
			$elm$core$List$filterMap,
			function (id) {
				return A2($elm$core$Dict$get, id, model.n4);
			},
			$elm$core$Set$toList(
				$author$project$Model$BuildPlanner$SolveLegacyEditor$getPlatforms(model.qR))));
	var platformsTitle = A3(
		$author$project$Misc$pluralizeNoNumber,
		'Platform',
		'Platforms',
		$elm$core$List$length(platforms));
	var languages = $elm$core$Dict$values(
		A2(
			$elm$core$Dict$map,
			$author$project$Pages$ProjectPreview$languageRow,
			$author$project$Model$BuildPlanner$SolveLegacyEditor$getLanguages(model.qR)));
	var languagesTitle = A3(
		$author$project$Misc$pluralizeNoNumber,
		'Language',
		'Languages',
		$elm$core$List$length(languages));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('column narrow')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('package-filters new-box')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(languagesTitle)
							])),
						A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('item-list')
							]),
						languages)
					])),
				A2(
				$author$project$Misc$displayIf,
				$elm$core$List$length(platforms) >= 1,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('package-filters new-box')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(platformsTitle)
								])),
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('item-list')
								]),
							platforms)
						])))
			]));
};
var $author$project$Pages$ProjectPreview$packagesView = function (model) {
	var sortedPackages = A2(
		$elm$core$List$sortBy,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.kH;
			},
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Y;
				},
				A2($elm$core$Basics$composeR, $author$project$Model$Namespace$getName, $elm$core$String$toLower))),
		_Utils_ap(
			$author$project$Model$BuildPlanner$SolveLegacyEditor$getBundleItems(model.qR),
			$author$project$Model$BuildPlanner$SolveLegacyEditor$getPackageItems(model.qR)));
	var reqView = function (key) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('item-name')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Model$Namespace$getName(key))
				]));
	};
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('column')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('new-box')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('package-table package-list dependencies-table')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h2,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Packages')
									])),
								$elm$core$List$isEmpty(sortedPackages) ? A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('no-packages')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('You haven\'t added any packages yet.')
											])),
										A2(
										$elm$html$Html$h4,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('To add a package, run...')
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('cli-wrapper')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$type_('text'),
														$elm$html$Html$Attributes$class('cli-input'),
														$elm$html$Html$Attributes$value('state install <packageName>'),
														$elm$html$Html$Attributes$spellcheck(false),
														$elm$html$Html$Attributes$readonly(true)
													]),
												_List_Nil)
											]))
									])) : A2(
								$elm$html$Html$tbody,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('package-unchanged')
									]),
								A2(
									$elm$core$List$map,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.kH;
										},
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.Y;
											},
											reqView)),
									sortedPackages))
							]))
					]))
			]));
};
var $author$project$Pages$ProjectPreview$checkpointView = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('columns')
			]),
		_List_fromArray(
			[
				$author$project$Pages$ProjectPreview$languageAndPlatformView(model),
				$author$project$Pages$ProjectPreview$packagesView(model)
			]));
};
var $author$project$Model$Route$createProjectFromCommit = F2(
	function (commitID, projectName) {
		return $author$project$Model$Route$Protected(
			$author$project$Model$Route$CreateProjectFromCommit(
				{BR: commitID, vT: projectName}));
	});
var $author$project$Pages$ProjectPreview$convertSection = F2(
	function (model, loggedIn) {
		var route = A2(
			$author$project$Model$Route$createProjectFromCommit,
			model.BR,
			$elm$core$Maybe$Just(model.Fs));
		var convertSectionTitle = loggedIn ? 'Create your Runtime' : 'Create your free account';
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('convert-section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('info-content')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Save this runtime on the ActiveState Platform')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Convert your local environment into an easy-to-manage, reproducible and ready-to-deploy anywhere runtime environment.')
								])),
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('feature-list')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('modify-img')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Modify packages & platforms and create new builds on demand')
										])),
									A2(
									$elm$html$Html$li,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('create-img')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Create & manage additional runtimes for all your projects')
										])),
									A2(
									$elm$html$Html$li,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('share-img')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Share your runtimes with your team so everyone\'s on the same page')
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('call-to-action')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('call-to-action-content')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h2,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(convertSectionTitle)
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('We\'ll automatically convert your local environment settings into an ActiveState Runtime and add it to your account.')
										])),
									A3(
									$author$project$Views$Link$link,
									route,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('secondary-button')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Convert my Runtime')
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$ProjectPreview$view = F2(
	function (session, model) {
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('main-content')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Pages$ProjectPreview$convertSection,
					model,
					$elm_community$maybe_extra$Maybe$Extra$isJust(
						$author$project$Model$Session$getUser(session))),
					$author$project$Pages$ProjectPreview$checkpointView(model)
				]));
	});
var $author$project$Pages$ProjectSettings$AskForConfirmation = {$: 5};
var $author$project$Pages$ProjectSettings$CancelDelete = {$: 6};
var $author$project$Pages$ProjectSettings$DeleteProject = {$: 7};
var $author$project$Pages$ProjectSettings$viewDeleteAndCancelBtns = F5(
	function (deleteAction, mainText, subText, deleteMsg, cancelMsg) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('confirm')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('confirm-text')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('confirm-label')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(mainText)
								])),
							function () {
							if (!subText.$) {
								var string = subText.a;
								return A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('confirm-label')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(string)
										]));
							} else {
								return $elm$html$Html$text('');
							}
						}()
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('confirm-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(deleteMsg),
									$elm$html$Html$Attributes$class('red-button'),
									A2($elm$html$Html$Attributes$attribute, 'data-cy', 'delete-project-confirm')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(deleteAction)
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(cancelMsg),
									$elm$html$Html$Attributes$class('cancel-button')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								]))
						]))
				]));
	});
var $author$project$Pages$ProjectSettings$viewDeleteButtons = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('delete-ui')
			]),
		_List_fromArray(
			[
				function () {
				var _v0 = model.oo;
				if (!_v0) {
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick($author$project$Pages$ProjectSettings$AskForConfirmation),
										$elm$html$Html$Attributes$class('delete-button'),
										A2($elm$html$Html$Attributes$attribute, 'data-cy', 'delete-project')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Delete')
									]))
							]));
				} else {
					return A5($author$project$Pages$ProjectSettings$viewDeleteAndCancelBtns, 'Yes', 'Are you sure?', $elm$core$Maybe$Nothing, $author$project$Pages$ProjectSettings$DeleteProject, $author$project$Pages$ProjectSettings$CancelDelete);
				}
			}()
			]));
};
var $author$project$Pages$ProjectSettings$viewDeleteUI = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('new-box', true),
						_Utils_Tuple2('highlight-animation', model.oD === 4)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h2,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id($author$project$Model$Route$deleteProjectFragment)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Delete this Project')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('content')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('warning')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Warning: Deleting this project will remove it from your organization permanently and cannot be undone.')
							])),
						$author$project$Pages$ProjectSettings$viewDeleteButtons(model)
					]))
			]));
};
var $author$project$Pages$ProjectSettings$ChangedMoveDestination = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$ProjectSettings$MoveProject = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$ProjectSettings$viewMoveProject = function (model) {
	var stringToMaybeDestination = function (s) {
		if (s === '') {
			return $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Just(s);
		}
	};
	var organizationOptions = A2(
		$elm$core$List$map,
		function (org) {
			return A2(
				$elm$html$Html$option,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$value(org)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(org)
					]));
		},
		model.vK);
	var noneOption = A2(
		$elm$html$Html$option,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$value('')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Select an organization...')
			]));
	var isFormDisabled = $author$project$Model$Project$getIsDistributionOnly(model.c5);
	var hasAarTags = A2(
		$elm$core$Basics$composeR,
		$author$project$Model$Project$getTags,
		A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not));
	var buttonHandlers = function () {
		var _v0 = _Utils_Tuple3(model.o3, model.oO, isFormDisabled);
		if (((!_v0.a.$) && (!_v0.b)) && (!_v0.c)) {
			var destination = _v0.a.a;
			return _List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$Pages$ProjectSettings$MoveProject(destination))
				]);
		} else {
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$disabled(true)
				]);
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('new-box', true),
						_Utils_Tuple2('highlight-animation', model.oD === 2)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h2,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id($author$project$Model$Route$moveProjectFragment)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Move to Organization')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('content')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$select,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$name('destination'),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeR, stringToMaybeDestination, $author$project$Pages$ProjectSettings$ChangedMoveDestination)),
										$elm$html$Html$Attributes$disabled(isFormDisabled)
									]),
								A2($elm$core$List$cons, noneOption, organizationOptions))
							])),
						A2(
						$author$project$Misc$displayIf,
						hasAarTags(model.c5) && $author$project$Model$Permissions$orgCanHar(model.c3),
						A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('warning')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('warning-label')
										]),
									_List_fromArray(
										[
											$author$project$Views$Icon$view(
											$author$project$Views$Icon$icon(83)),
											$elm$html$Html$text('Warning: ')
										])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											'Project ' + ($author$project$Model$Project$getName(model.c5) + (' has one or more existing ActiveState Artifact Repositories. ' + 'Since its URL is an extension of the organization URL, update any existing links and references to the new path.')))
										]))
								]))),
						A2(
						$elm$html$Html$button,
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class('primary-button'),
							buttonHandlers),
						_List_fromArray(
							[
								$author$project$Views$Icon$view(
								$author$project$Views$Icon$icon(80)),
								$elm$html$Html$text('Move Project')
							]))
					]))
			]));
};
var $author$project$Pages$ProjectSettings$Description = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$ProjectSettings$ForkedFromOrganization = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$ProjectSettings$ForkedFromProject = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$ProjectSettings$FormatForkedFromNames = {$: 4};
var $author$project$Pages$ProjectSettings$IsDistributionOnly = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$ProjectSettings$IsManaged = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$ProjectSettings$IsPrivate = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$ProjectSettings$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$ProjectSettings$RepoURL = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$ProjectSettings$SaveNewProjectDetails = {$: 2};
var $author$project$Pages$ProjectSettings$UpdateField = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$ProjectSettings$anyFormFieldChanged = F3(
	function (formattedProjectName, project, formFields) {
		return (!_Utils_eq(
			$author$project$Model$Project$getName(project),
			formattedProjectName)) || ((!_Utils_eq(
			$author$project$Model$Project$getDescription(project),
			formFields.bP)) || ((!_Utils_eq(
			$author$project$Model$Project$getRepoUrl(project),
			formFields.nf)) || ((!_Utils_eq(
			$author$project$Model$Project$getIsPrivate(project),
			formFields.Dy)) || ((!_Utils_eq(
			$author$project$Model$Project$getIsManaged(project),
			formFields.j2)) || ((!_Utils_eq(
			$author$project$Model$Project$getIsDistributionOnly(project),
			formFields.iu)) || A2($author$project$Pages$ProjectSettings$forkedFromChanged, project, formFields))))));
	});
var $author$project$Pages$ProjectSettings$isValidForkedFrom = function (formFields) {
	return _Utils_eq(formFields.is === '', formFields.it === '');
};
var $author$project$Pages$ProjectSettings$isValidPrivateDistributionOnly = function (formFields) {
	return (!formFields.iu) || (formFields.iu && formFields.Dy);
};
var $author$project$Pages$ProjectSettings$viewProjectDetails = F2(
	function (model, session) {
		var publicMessage = 'Only members of this organization can modify it, but any user of the ActiveState Platform can view and install this runtime.';
		var privacyMessage = 'Only members of this organization can modify, view and install this runtime.';
		var isSuperUserWithFeaturesVisible = $author$project$Model$Session$isSuperUserWithFeaturesVisible(session);
		var isFormDisabled = (!isSuperUserWithFeaturesVisible) && $author$project$Model$Project$getIsDistributionOnly(model.c5);
		var formattedProjectName = $author$project$Validation$formatProjectName(model.bD.w);
		var nameIsFormatted = !_Utils_eq(formattedProjectName, model.bD.w);
		var projectNameError = $author$project$Validation$validateProjectName(formattedProjectName);
		var canSubmit = _Utils_eq(projectNameError, $elm$core$Maybe$Nothing) && ($author$project$Pages$ProjectSettings$isValidForkedFrom(model.bD) && ($author$project$Pages$ProjectSettings$isValidPrivateDistributionOnly(model.bD) && A3($author$project$Pages$ProjectSettings$anyFormFieldChanged, formattedProjectName, model.c5, model.bD)));
		var submitForm = canSubmit ? $author$project$Pages$ProjectSettings$SaveNewProjectDetails : $author$project$Pages$ProjectSettings$NoOp;
		var canHavePrivate = $author$project$Model$Permissions$orgCanCreatePrivateProject(model.c3);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('new-box project-name-form')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$form,
					_List_fromArray(
						[
							$elm$html$Html$Events$onSubmit(submitForm)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Details')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('content')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('section project-name'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'error',
													!_Utils_eq(projectNameError, $elm$core$Maybe$Nothing))
												]))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$label,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$for('project-name')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Name')
														]))
												])),
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$type_('text'),
													$elm$html$Html$Events$onInput(
													A2($elm$core$Basics$composeL, $author$project$Pages$ProjectSettings$UpdateField, $author$project$Pages$ProjectSettings$Name)),
													$elm$html$Html$Attributes$disabled(isFormDisabled),
													$elm$html$Html$Attributes$spellcheck(false),
													$elm$html$Html$Attributes$maxlength(40),
													$elm$html$Html$Attributes$id('project-name'),
													$elm$html$Html$Attributes$value(model.bD.w)
												]),
											_List_Nil),
											A2(
											$author$project$Misc$displayIf,
											nameIsFormatted,
											$author$project$Views$ViewUtils$formattedNameEl(formattedProjectName)),
											A2($author$project$Misc$displayMaybe, $author$project$Views$Error$fieldError, projectNameError)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('section project-description', true),
													_Utils_Tuple2('highlight-animation', model.oD === 1)
												]))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h4,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$id($author$project$Model$Route$addDescriptionFragment)
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$label,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$for('project-description')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Description'),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('optional-label')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('(Optional)')
																]))
														]))
												])),
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('field-info')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Add details about what this project is for or how to use it. Supports markdown syntax.')
												])),
											A2(
											$elm$html$Html$textarea,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$id('project-description'),
													$elm$html$Html$Events$onInput(
													A2($elm$core$Basics$composeL, $author$project$Pages$ProjectSettings$UpdateField, $author$project$Pages$ProjectSettings$Description)),
													$elm$html$Html$Attributes$disabled(isFormDisabled),
													$elm$html$Html$Attributes$spellcheck(false)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(model.bD.bP)
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('section project-git-url')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$label,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$for('git-repo-url')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Git Repo URL'),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('optional-label')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('(Optional)')
																]))
														]))
												])),
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('field-info')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('When activating this runtime via the command line for the first time, this repo will automatically be cloned into the virtual environment.')
												])),
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$type_('text'),
													$elm$html$Html$Attributes$id('git-repo-url'),
													$elm$html$Html$Events$onInput(
													A2($elm$core$Basics$composeL, $author$project$Pages$ProjectSettings$UpdateField, $author$project$Pages$ProjectSettings$RepoURL)),
													$elm$html$Html$Attributes$disabled(isFormDisabled),
													$elm$html$Html$Attributes$spellcheck(false),
													$elm$html$Html$Attributes$value(model.bD.nf)
												]),
											_List_Nil)
										])),
									A2(
									$author$project$Misc$displayIf,
									isSuperUserWithFeaturesVisible,
									A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('section superuser-only')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$h4,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Fork Parent Project')
													])),
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('If you want to unfork this project from its parent, clear both values.')
													])),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('organization-and-project-inputs'),
														$elm$html$Html$Attributes$classList(
														_List_fromArray(
															[
																_Utils_Tuple2(
																'pre-platform',
																$author$project$Model$Project$getIsDistributionOnly(model.c5))
															]))
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$input,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$type_('text'),
																$elm$html$Html$Attributes$value(model.bD.is),
																$elm$html$Html$Events$onInput(
																A2($elm$core$Basics$composeL, $author$project$Pages$ProjectSettings$UpdateField, $author$project$Pages$ProjectSettings$ForkedFromOrganization)),
																$elm$html$Html$Events$onBlur($author$project$Pages$ProjectSettings$FormatForkedFromNames),
																$elm$html$Html$Attributes$placeholder('Organization')
															]),
														_List_Nil),
														$elm$html$Html$text(' / '),
														A2(
														$elm$html$Html$input,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$type_('text'),
																$elm$html$Html$Attributes$value(model.bD.it),
																$elm$html$Html$Events$onInput(
																A2($elm$core$Basics$composeL, $author$project$Pages$ProjectSettings$UpdateField, $author$project$Pages$ProjectSettings$ForkedFromProject)),
																$elm$html$Html$Events$onBlur($author$project$Pages$ProjectSettings$FormatForkedFromNames),
																$elm$html$Html$Attributes$placeholder('Project')
															]),
														_List_Nil)
													])),
												A2(
												$author$project$Misc$displayIf,
												!$author$project$Pages$ProjectSettings$isValidForkedFrom(model.bD),
												A2(
													$elm$html$Html$p,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('field-error')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('The organization and project fields must both have a value or must both be blank.')
														])))
											]))),
									A2(
									$author$project$Misc$displayIf,
									isSuperUserWithFeaturesVisible,
									A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('section superuser-only')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$h4,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Managed Project')
													])),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('radio-group')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('visibility-label')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$input,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$checked(model.bD.j2),
																		$elm$html$Html$Attributes$type_('radio'),
																		$elm$html$Html$Attributes$disabled(isFormDisabled),
																		$elm$html$Html$Events$onCheck(
																		$elm$core$Basics$always(
																			$author$project$Pages$ProjectSettings$UpdateField(
																				$author$project$Pages$ProjectSettings$IsManaged(true))))
																	]),
																_List_Nil),
																$elm$html$Html$text('Yes')
															])),
														A2(
														$elm$html$Html$label,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('visibility-label')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$input,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$checked(!model.bD.j2),
																		$elm$html$Html$Attributes$type_('radio'),
																		$elm$html$Html$Attributes$disabled(isFormDisabled),
																		$elm$html$Html$Events$onCheck(
																		$elm$core$Basics$always(
																			$author$project$Pages$ProjectSettings$UpdateField(
																				$author$project$Pages$ProjectSettings$IsManaged(false))))
																	]),
																_List_Nil),
																$elm$html$Html$text('No')
															]))
													]))
											]))),
									A2(
									$author$project$Misc$displayIf,
									isSuperUserWithFeaturesVisible,
									A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('section superuser-only')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$h4,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Distribution-only Project')
													])),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('radio-group')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('visibility-label')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$input,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$checked(model.bD.iu),
																		$elm$html$Html$Attributes$type_('radio'),
																		$elm$html$Html$Attributes$disabled(isFormDisabled),
																		$elm$html$Html$Events$onCheck(
																		$elm$core$Basics$always(
																			$author$project$Pages$ProjectSettings$UpdateField(
																				$author$project$Pages$ProjectSettings$IsDistributionOnly(true))))
																	]),
																_List_Nil),
																$elm$html$Html$text('Yes')
															])),
														A2(
														$elm$html$Html$label,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('visibility-label')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$input,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$checked(!model.bD.iu),
																		$elm$html$Html$Attributes$type_('radio'),
																		$elm$html$Html$Attributes$disabled(isFormDisabled),
																		$elm$html$Html$Events$onCheck(
																		$elm$core$Basics$always(
																			$author$project$Pages$ProjectSettings$UpdateField(
																				$author$project$Pages$ProjectSettings$IsDistributionOnly(false))))
																	]),
																_List_Nil),
																$elm$html$Html$text('No')
															]))
													])),
												A2(
												$author$project$Misc$displayIf,
												!$author$project$Pages$ProjectSettings$isValidPrivateDistributionOnly(model.bD),
												A2(
													$elm$html$Html$p,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('field-error')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Distribution-only project must be private.')
														])))
											]))),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('section project-visibility', true),
													_Utils_Tuple2('highlight-animation', model.oD === 3)
												]))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h4,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$id($author$project$Model$Route$projectVisibilityFragment)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Visibility')
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('radio-group')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$label,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$input,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$checked(!model.bD.Dy),
																	$elm$html$Html$Attributes$type_('radio'),
																	$elm$html$Html$Attributes$disabled(
																	isFormDisabled || $author$project$Model$Project$getIsDistributionOnly(model.c5)),
																	$elm$html$Html$Events$onCheck(
																	$elm$core$Basics$always(
																		$author$project$Pages$ProjectSettings$UpdateField(
																			$author$project$Pages$ProjectSettings$IsPrivate(false))))
																]),
															_List_Nil),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('visibility-label')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Public')
																])),
															A2(
															$elm$html$Html$span,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(' - ' + publicMessage)
																]))
														])),
													canHavePrivate ? A2(
													$elm$html$Html$label,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$input,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$checked(model.bD.Dy),
																	$elm$html$Html$Attributes$type_('radio'),
																	$elm$html$Html$Attributes$disabled(isFormDisabled),
																	$elm$html$Html$Events$onCheck(
																	$elm$core$Basics$always(
																		$author$project$Pages$ProjectSettings$UpdateField(
																			$author$project$Pages$ProjectSettings$IsPrivate(true))))
																]),
															_List_Nil),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('visibility-label')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Private')
																])),
															A2(
															$elm$html$Html$span,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(' - ' + privacyMessage)
																]))
														])) : A2(
													$elm$html$Html$label,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('disabled')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$input,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$disabled(true),
																	$elm$html$Html$Attributes$checked(model.bD.Dy),
																	$elm$html$Html$Attributes$type_('radio')
																]),
															_List_Nil),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('visibility-label')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Private')
																])),
															A2(
															$elm$html$Html$span,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(' - ' + privacyMessage)
																]))
														]))
												])),
											A2(
											$author$project$Misc$displayIf,
											isFormDisabled,
											A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('disabled-explanation')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Distribution Only projects are only visible to members of the current organization.')
													]))),
											A2(
											$author$project$Misc$displayIf,
											(!canHavePrivate) && (!isFormDisabled),
											A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('disabled-explanation')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Private projects are not available on free accounts.'),
														$elm$html$Html$text(' To upgrade, view our '),
														A2(
														$elm$html$Html$a,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$target('_blanks'),
																$elm$html$Html$Attributes$href(
																$author$project$Url$Extra$pricing(_List_Nil))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('plans & pricing')
															])),
														$elm$html$Html$text('.')
													])))
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('submit'),
											$elm$html$Html$Attributes$class('primary-button'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('disabled', isFormDisabled || (!canSubmit))
												]))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Save Changes')
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$ProjectSettings$view = F2(
	function (model, session) {
		return A2(
			$elm$html$Html$section,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Pages$ProjectSettings$viewProjectDetails, model, session),
					$author$project$Pages$ProjectSettings$viewMoveProject(model),
					$author$project$Pages$ProjectSettings$viewDeleteUI(model)
				]));
	});
var $author$project$Pages$ProjectSettingsBranches$ConfigModalMsg = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$virtual_dom$VirtualDom$lazy4 = _VirtualDom_lazy4;
var $elm$html$Html$Lazy$lazy4 = $elm$virtual_dom$VirtualDom$lazy4;
var $author$project$Views$ProjectBranchModal$Add = 0;
var $author$project$Pages$ProjectSettingsBranches$CancelDeleteConfig = {$: 6};
var $author$project$Pages$ProjectSettingsBranches$DeleteConfig = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$ProjectSettingsBranches$DeleteConfigClicked = function (a) {
	return {$: 5, a: a};
};
var $author$project$Views$ProjectBranchModal$Edit = 1;
var $author$project$Pages$ProjectSettingsBranches$OpenBranchModal = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $zwilias$elm_rosetree$Tree$Zipper$children = function (zipper) {
	return $zwilias$elm_rosetree$Tree$children(
		$zwilias$elm_rosetree$Tree$Zipper$tree(zipper));
};
var $author$project$Model$BranchTree$branchHasChildren = F2(
	function (branch, tree) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$zwilias$elm_rosetree$Tree$Zipper$children,
					A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not)),
				A2(
					$zwilias$elm_rosetree$Tree$Zipper$findFromRoot,
					$elm$core$Basics$eq(branch),
					$zwilias$elm_rosetree$Tree$Zipper$fromTree(tree))));
	});
var $author$project$Model$BranchTree$maxDepth = 3;
var $author$project$Pages$ProjectSettingsBranches$viewDeleteAndCancelBtns = F5(
	function (deleteAction, mainText, subText, deleteMsg, cancelMsg) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('confirm')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('confirm-text')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('confirm-label')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(mainText)
								])),
							function () {
							if (!subText.$) {
								var string = subText.a;
								return A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('confirm-label')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(string)
										]));
							} else {
								return $elm$html$Html$text('');
							}
						}()
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('confirm-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(deleteMsg),
									$elm$html$Html$Attributes$class('red-button')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(deleteAction)
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(cancelMsg),
									$elm$html$Html$Attributes$class('cancel-button')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								]))
						]))
				]));
	});
var $author$project$Pages$ProjectSettingsBranches$branchToHtml = F5(
	function (session, model, _v0, tree, _v1) {
		var toDelete = _v0.wH;
		var lastEdited = _v0.DT;
		var branch = _v1.a;
		var depth = _v1.b;
		var maybeUser = $author$project$Model$Session$getUser(session);
		var harLink = A3(
			$author$project$Views$Link$link,
			A2(
				$author$project$Model$Route$projectSettingsHAR,
				{
					ix: model.c3.AC,
					vT: $author$project$Model$Project$getName(model.c5)
				},
				A2(
					$author$project$Model$Route$withBranchName,
					$elm$core$Maybe$Just(
						$author$project$Model$Branch$getName(branch)),
					$author$project$Model$Route$projectSettingsParams)),
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-button')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('ActiveState Artifact Repository')
				]));
		var deleteSubMsg = A2($author$project$Model$BranchTree$branchHasChildren, branch, tree) ? $elm$core$Maybe$Just('All child branches will also be deleted.') : $elm$core$Maybe$Nothing;
		var deleteMsg = 'Delete this branch?';
		var branchName = $author$project$Model$Branch$getName(branch);
		var branchIs = function (maybeBranch) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$eq(branch),
					maybeBranch));
		};
		var branchButton = F3(
			function (label, class_, msg) {
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(class_),
							$elm$html$Html$Attributes$disabled(
							branchIs(toDelete)),
							$elm$html$Html$Events$onClick(
							msg(branch))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						]));
			});
		var authorizedToEdit = $author$project$Model$User$isSuperUser(maybeUser) || A2($author$project$Model$Permissions$canEditProjects, model.c3.AC, maybeUser);
		var canHar = false && ($author$project$Model$Permissions$orgCanHar(model.c3) && authorizedToEdit);
		var buttons = _List_fromArray(
			[
				A2($author$project$Misc$displayIf, canHar, harLink),
				A2(
				$author$project$Misc$displayIf,
				_Utils_cmp(depth, $author$project$Model$BranchTree$maxDepth) < 0,
				A3(
					branchButton,
					'Add Child',
					'text-button',
					$author$project$Pages$ProjectSettingsBranches$OpenBranchModal(0))),
				A2(
				$author$project$Misc$displayIf,
				!$author$project$Model$Branch$isDefault(branch),
				A3(
					branchButton,
					'Rename',
					'text-button',
					$author$project$Pages$ProjectSettingsBranches$OpenBranchModal(1))),
				A2(
				$author$project$Misc$displayIf,
				!$author$project$Model$Branch$isDefault(branch),
				A3(branchButton, 'Delete', 'secondary-button small', $author$project$Pages$ProjectSettingsBranches$DeleteConfigClicked))
			]);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('branch-wrapper'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'might-be-deleted',
							branchIs(toDelete))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('tree-branch', true),
									_Utils_Tuple2(
									'edited',
									branchIs(lastEdited)),
									_Utils_Tuple2(
									'main',
									$author$project$Model$Branch$isDefault(branch))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('branch-highlight-wrapper')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('branch-name')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$title(branchName)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(branchName)
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('branch-buttons')
										]),
									buttons)
								]))
						])),
					A2(
					$author$project$Misc$displayIf,
					branchIs(toDelete),
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('confirm-delete-bubble')
							]),
						_List_fromArray(
							[
								A5(
								$author$project$Pages$ProjectSettingsBranches$viewDeleteAndCancelBtns,
								'Delete',
								deleteMsg,
								deleteSubMsg,
								$author$project$Pages$ProjectSettingsBranches$DeleteConfig(
									$author$project$Model$Branch$getID(branch)),
								$author$project$Pages$ProjectSettingsBranches$CancelDeleteConfig)
							])))
				]));
	});
var $author$project$Model$Permissions$orgCanMakeBranches = $author$project$Model$Organization$addOnEnabled('branches');
var $jxxcarlson$tree_extra$Tree$Extra$tagWithDepthHelp = F2(
	function (k, t) {
		var c = $zwilias$elm_rosetree$Tree$children(t);
		return A2(
			$zwilias$elm_rosetree$Tree$tree,
			_Utils_Tuple2(
				$zwilias$elm_rosetree$Tree$label(t),
				k),
			A2(
				$elm$core$List$map,
				function (t_) {
					return A2($jxxcarlson$tree_extra$Tree$Extra$tagWithDepthHelp, k + 1, t_);
				},
				c));
	});
var $jxxcarlson$tree_extra$Tree$Extra$tagWithDepth = function (t) {
	return A2($jxxcarlson$tree_extra$Tree$Extra$tagWithDepthHelp, 0, t);
};
var $author$project$Model$BranchTree$withDepth = $jxxcarlson$tree_extra$Tree$Extra$tagWithDepth;
var $author$project$Pages$ProjectSettingsBranches$viewProjectConfigs = F4(
	function (session, model, notableBranches, tree) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('new-box project-branches')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Branches')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('content')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Branches allow you to maintain separate sets of packages to create slightly different builds within your project. Child branches can inherit changes from their parent.')
								])),
							$author$project$Model$Project$getIsDistributionOnly(model.c5) ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('branch-box')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Distribution-only projects cannot have branches added to them.')
										]))
								])) : ($author$project$Model$Permissions$orgCanMakeBranches(model.c3) ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('branch-box')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Model$BranchTree$view,
									A4($author$project$Pages$ProjectSettingsBranches$branchToHtml, session, model, notableBranches, tree),
									$author$project$Model$BranchTree$withDepth(tree))
								])) : A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('You can get access to branches by '),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(
											$author$project$Url$Extra$contactSales(_List_Nil))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('upgrading to Team Tier')
										]))
								])))
						]))
				]));
	});
var $author$project$Pages$ProjectSettingsBranches$maybeViewProjectConfigs = F4(
	function (session, model, branches, notable) {
		return A2(
			$author$project$Misc$displayMaybe,
			A3($author$project$Pages$ProjectSettingsBranches$viewProjectConfigs, session, model, notable),
			$author$project$Model$BranchTree$fromBranches(branches));
	});
var $author$project$Views$ProjectBranchModal$Cancel = {$: 2};
var $author$project$Views$ProjectBranchModal$Submit = {$: 1};
var $author$project$Views$ProjectBranchModal$UpdateName = function (a) {
	return {$: 0, a: a};
};
var $elm$html$Html$Attributes$autocomplete = function (bool) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'autocomplete',
		bool ? 'on' : 'off');
};
var $author$project$Views$ProjectBranchModal$viewContent = function (model) {
	var _v0 = function () {
		var _v1 = model.El;
		if (!_v1) {
			return _Utils_Tuple2('Add a Branch', 'Add');
		} else {
			return _Utils_Tuple2('Edit Branch', 'Save');
		}
	}();
	var title = _v0.a;
	var saveButtonText = _v0.b;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-wrapper')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h2,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(title)
					])),
				A2(
				$elm$html$Html$form,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('add-branch-form'),
						$elm$html$Html$Events$onSubmit($author$project$Views$ProjectBranchModal$Submit)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'error',
										!_Utils_eq(model.o4, $elm$core$Maybe$Nothing))
									]))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('sub-label')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('3 - 40 characters')
									])),
								A2(
								$elm$html$Html$h4,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('branch-label')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Name')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id($author$project$Views$ProjectBranchModal$initialFocusID),
										$elm$html$Html$Attributes$type_('text'),
										$elm$html$Html$Attributes$spellcheck(false),
										$elm$html$Html$Attributes$maxlength(40),
										$elm$html$Html$Attributes$autocomplete(false),
										$elm$html$Html$Events$onInput($author$project$Views$ProjectBranchModal$UpdateName),
										$elm$html$Html$Attributes$value(model.w)
									]),
								_List_Nil)
							])),
						A2($author$project$Misc$displayMaybe, $author$project$Views$Error$fieldError, model.o4),
						A2(
						$author$project$Misc$displayIf,
						!_Utils_eq(model.w, model.jf),
						$author$project$Views$ViewUtils$formattedNameEl(model.jf)),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('button-wrapper')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('primary-button'),
										$elm$html$Html$Attributes$type_('submit')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(saveButtonText)
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('secondary-button'),
										$elm$html$Html$Events$onClick($author$project$Views$ProjectBranchModal$Cancel),
										$elm$html$Html$Attributes$type_('button')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Cancel')
									]))
							]))
					]))
			]));
};
var $author$project$Views$ProjectBranchModal$view = function (model) {
	return $author$project$Views$Modal$view(
		{
			BD: '',
			BI: $author$project$Views$ProjectBranchModal$Cancel,
			dH: $author$project$Views$ProjectBranchModal$viewContent(model),
			x4: $author$project$Views$Modal$DismissButtonInvisible
		});
};
var $author$project$Pages$ProjectSettingsBranches$view = F2(
	function (model, session) {
		var viewModal = function (modal) {
			return A2(
				$elm$html$Html$map,
				$author$project$Pages$ProjectSettingsBranches$ConfigModalMsg(modal),
				$author$project$Views$ProjectBranchModal$view(modal));
		};
		var notableBranches = {DT: model.oY, wH: model.kW};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('page-body project-settings')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('columns')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('column')
								]),
							_List_fromArray(
								[
									A2($author$project$Misc$displayMaybe, viewModal, model.h5),
									A5(
									$elm$html$Html$Lazy$lazy4,
									$author$project$Pages$ProjectSettingsBranches$maybeViewProjectConfigs,
									session,
									model,
									$author$project$Model$Project$getBranches(model.c5),
									notableBranches)
								]))
						]))
				]));
	});
var $author$project$Pages$ProjectSettingsHAR$CreateHarClicked = {$: 6};
var $elm$html$Html$Attributes$hidden = $elm$html$Html$Attributes$boolProperty('hidden');
var $author$project$Pages$ProjectSettingsHAR$CancelCreateClicked = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$ProjectSettingsHAR$ValidateThenSaveTag = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Pages$ProjectSettingsHAR$FieldEdited = F3(
	function (a, b, c) {
		return {$: 9, a: a, b: b, c: c};
	});
var $author$project$Pages$ProjectSettingsHAR$errorView = function (e) {
	return A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('field-error')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(e)
			]));
};
var $author$project$Pages$ProjectSettingsHAR$EditFieldClicked = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Pages$ProjectSettingsHAR$CopyClipboard = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$ProjectSettingsHAR$copyButtonView = F4(
	function (isDisabled, _v0, elementID, copyString) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('secondary-button'),
					$elm$html$Html$Attributes$disabled(isDisabled),
					$elm$html$Html$Attributes$id(elementID),
					$elm$html$Html$Events$onClick(
					$author$project$Pages$ProjectSettingsHAR$CopyClipboard(
						{xN: elementID, Gv: copyString}))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Copy to Clipboard')
				]));
	});
var $author$project$Request$Project$harUrl = F3(
	function (o, p, l) {
		return A3(
			$elm$url$Url$Builder$crossOrigin,
			'https://aar.activestate.com',
			_List_fromArray(
				[o, p, l]),
			_List_Nil);
	});
var $author$project$Pages$ProjectSettingsHAR$editFieldBtn = F3(
	function (model, t, f) {
		var _v0 = function () {
			if (!f.$) {
				var originalValue = f.a.jm;
				var id_ = _Utils_ap(
					originalValue,
					A3($elm$core$Basics$composeR, $author$project$Pages$ProjectSettingsHAR$getLabelFromTagState, $author$project$Pages$ProjectSettingsHAR$getFieldOriginalValue, t));
				return _Utils_Tuple2('copy_commit_' + id_, originalValue);
			} else {
				var originalValue = f.a.jm;
				return _Utils_Tuple2(
					'copy_url_' + originalValue,
					A3(
						$author$project$Request$Project$harUrl,
						$author$project$Model$Organization$getUrlName(model.c3),
						$author$project$Model$Project$getName(model.c5),
						originalValue));
			}
		}();
		var elementID = _v0.a;
		var copyString = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A4($author$project$Pages$ProjectSettingsHAR$copyButtonView, false, model.oi, elementID, copyString),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('secondary-button'),
							$elm$html$Html$Events$onClick(
							A2($author$project$Pages$ProjectSettingsHAR$EditFieldClicked, t, f))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Edit')
						]))
				]));
	});
var $author$project$Pages$ProjectSettingsHAR$isEditing = function (s) {
	if (s === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pages$ProjectSettingsHAR$isFieldEditing = A2(
	$elm$core$Basics$composeR,
	$author$project$Pages$ProjectSettingsHAR$fieldMeta,
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.bB;
		},
		$author$project$Pages$ProjectSettingsHAR$isEditing));
var $author$project$Pages$ProjectSettingsHAR$CancelFieldEditClicked = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$ProjectSettingsHAR$saveCancelEditsBtns = F3(
	function (ts, f, disableSave) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('primary-button'),
							$elm$html$Html$Attributes$disabled(disableSave),
							$elm$html$Html$Events$onClick(
							A3($author$project$Pages$ProjectSettingsHAR$SaveField, ts, f, false))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Update')
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('secondary-button'),
							$elm$html$Html$Events$onClick(
							A2($author$project$Pages$ProjectSettingsHAR$CancelFieldEditClicked, ts, f))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Cancel')
						]))
				]));
	});
var $author$project$Pages$ProjectSettingsHAR$fieldButtonView = F4(
	function (model, ts, f, disableSave) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button-section')
				]),
			_List_fromArray(
				[
					$author$project$Pages$ProjectSettingsHAR$isFieldEditing(f) ? A3($author$project$Pages$ProjectSettingsHAR$saveCancelEditsBtns, ts, f, disableSave) : A3($author$project$Pages$ProjectSettingsHAR$editFieldBtn, model, ts, f)
				]));
	});
var $author$project$Pages$ProjectSettingsHAR$commitView = F5(
	function (model, canEditProject, tagEx, field, maybeError) {
		var shouldShowFieldButtons = canEditProject && (!$author$project$Pages$ProjectSettingsHAR$isNewTag(tagEx));
		var shouldDisableSave = $elm_community$maybe_extra$Maybe$Extra$isJust(maybeError);
		var projectConfigWithCommitLink = function (commitID) {
			return A2(
				$author$project$Model$Route$projectConfig,
				{
					ix: $author$project$Model$Organization$getUrlName(model.c3),
					vT: $author$project$Model$Project$getName(model.c5)
				},
				A2(
					$author$project$Model$Route$withCommitID,
					$danyx23$elm_uuid$Uuid$fromString(commitID),
					$author$project$Model$Route$projectConfigParams));
		};
		var fieldValue = function (f) {
			return $author$project$Pages$ProjectSettingsHAR$getFieldValue(f);
		};
		var valueView = F2(
			function (f, ts) {
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$ProjectSettingsHAR$isFieldEditing(f) ? A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id('commit_input_field'),
									$elm$html$Html$Attributes$type_('text'),
									$elm$html$Html$Attributes$value(
									fieldValue(f)),
									$elm$html$Html$Attributes$placeholder('A commit ID from your project'),
									$elm$html$Html$Attributes$title('Commit ID'),
									$elm$html$Html$Events$onInput(
									A2($author$project$Pages$ProjectSettingsHAR$FieldEdited, ts, f))
								]),
							_List_Nil) : A3(
							$author$project$Views$Link$link,
							projectConfigWithCommitLink(
								fieldValue(f)),
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									fieldValue(f))
								]))
						]));
			});
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(valueView, field, tagEx),
					A2(
					$author$project$Misc$displayIf,
					shouldShowFieldButtons,
					A4($author$project$Pages$ProjectSettingsHAR$fieldButtonView, model, tagEx, field, shouldDisableSave)),
					A2($author$project$Misc$displayMaybe, $author$project$Pages$ProjectSettingsHAR$errorView, maybeError)
				]));
	});
var $author$project$Pages$ProjectSettingsHAR$getFieldValidationErr = function (e) {
	switch (e.$) {
		case 1:
			var s = e.a;
			return s;
		case 0:
			var s = e.a;
			return s;
		default:
			var s = e.a;
			return s;
	}
};
var $author$project$Pages$ProjectSettingsHAR$isGeneralErr = function (e) {
	if (e.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Pages$ProjectSettingsHAR$urlView = F4(
	function (model, canEditProject, tag, maybeError) {
		var tagForm = $author$project$Pages$ProjectSettingsHAR$getTagFormFromState(tag);
		var projectName = $author$project$Model$Project$getName(model.c5);
		var orgName = $author$project$Model$Organization$getUrlName(model.c3);
		var formattedFieldValue = A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.b2;
			},
			$author$project$Pages$ProjectSettingsHAR$getFieldFormattedValue);
		var urlSection = $author$project$Pages$ProjectSettingsHAR$isFieldEditing(tagForm.b2) ? A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('url_text')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A3(
						$author$project$Request$Project$harUrl,
						orgName,
						projectName,
						formattedFieldValue(tagForm)))
				])) : A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href(
					A3(
						$author$project$Request$Project$harUrl,
						orgName,
						projectName,
						formattedFieldValue(tagForm)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A3(
						$author$project$Request$Project$harUrl,
						orgName,
						projectName,
						formattedFieldValue(tagForm)))
				]));
		var fieldValue = A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.b2;
			},
			$author$project$Pages$ProjectSettingsHAR$getFieldValue);
		var inputField = A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('text'),
							$elm$html$Html$Attributes$value(
							fieldValue(tagForm)),
							$elm$html$Html$Attributes$placeholder('eg. latest'),
							$elm$html$Html$Attributes$title('ActiveState Artifact Repository Tag Label. Must be unique to your project. Think of it as a GitHub tag'),
							$elm$html$Html$Events$onInput(
							A2($author$project$Pages$ProjectSettingsHAR$FieldEdited, tag, tagForm.b2))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Only letters, numbers and dashes allowed. Label will appear as:')
						]))
				]));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Misc$displayIf,
					$author$project$Pages$ProjectSettingsHAR$isFieldEditing(tagForm.b2),
					inputField),
					urlSection,
					A2(
					$author$project$Misc$displayIf,
					(!$author$project$Pages$ProjectSettingsHAR$isNewTag(tag)) && canEditProject,
					A4(
						$author$project$Pages$ProjectSettingsHAR$fieldButtonView,
						model,
						tag,
						tagForm.b2,
						$elm_community$maybe_extra$Maybe$Extra$isJust(maybeError))),
					A2($author$project$Misc$displayMaybe, $author$project$Pages$ProjectSettingsHAR$errorView, maybeError)
				]));
	});
var $author$project$Pages$ProjectSettingsHAR$newHarView = F2(
	function (model, tag) {
		var validations = function (t) {
			return $author$project$Pages$ProjectSettingsHAR$getTagFormFromState(t).dv;
		};
		var projectHistoryRoute = $author$project$Model$Route$projectHistory(
			{
				fO: model.fO,
				gr: $elm$core$Maybe$Nothing,
				ix: $author$project$Model$Organization$getUrlName(model.c3),
				vT: $author$project$Model$Project$getName(model.c5)
			});
		var noValidationErrors = function (t) {
			return !$elm$core$List$isEmpty(
				$author$project$Pages$ProjectSettingsHAR$getTagFormFromState(t).dv);
		};
		var labelIsEmpty = function (t) {
			return A3(
				$elm$core$Basics$composeR,
				$author$project$Pages$ProjectSettingsHAR$getFieldValue,
				$elm$core$Basics$eq(''),
				$author$project$Pages$ProjectSettingsHAR$getTagFormFromState(t).b2);
		};
		var generalError = A2(
			$elm$core$Maybe$map,
			$author$project$Pages$ProjectSettingsHAR$getFieldValidationErr,
			A2(
				$elm_community$list_extra$List$Extra$find,
				$author$project$Pages$ProjectSettingsHAR$isGeneralErr,
				validations(tag)));
		var fieldSection = function (_v1) {
			var field = _v1.a;
			var errors = _v1.b;
			if (!field.$) {
				return A5(
					$author$project$Pages$ProjectSettingsHAR$commitView,
					model,
					false,
					tag,
					field,
					A2(
						$elm$core$Maybe$map,
						$author$project$Pages$ProjectSettingsHAR$getFieldValidationErr,
						A2($elm_community$list_extra$List$Extra$find, $author$project$Pages$ProjectSettingsHAR$isCommitIDErr, errors)));
			} else {
				return A4(
					$author$project$Pages$ProjectSettingsHAR$urlView,
					model,
					false,
					tag,
					A2(
						$elm$core$Maybe$map,
						$author$project$Pages$ProjectSettingsHAR$getFieldValidationErr,
						A2($elm_community$list_extra$List$Extra$find, $author$project$Pages$ProjectSettingsHAR$isLabelErr, errors)));
			}
		};
		var disabledAttr = function (t) {
			return $elm$html$Html$Attributes$disabled(
				A3($author$project$Misc$isEither, noValidationErrors, labelIsEmpty, t));
		};
		var finishBtn = function (t) {
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('primary-button'),
						$elm$html$Html$Events$onClick(
						A2(
							$author$project$Pages$ProjectSettingsHAR$ValidateThenSaveTag,
							t,
							$author$project$Pages$ProjectSettingsHAR$getTagFormFromState(t).BR)),
						disabledAttr(tag)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Create')
					]));
		};
		var cancelBtn = function (t) {
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('secondary-button'),
						$elm$html$Html$Events$onClick(
						$author$project$Pages$ProjectSettingsHAR$CancelCreateClicked(t))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Cancel')
					]));
		};
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Commit ID')
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('field-info')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('This project’s latest commit ID is populated by default. You can find other Commit IDs on the '),
							A3(
							$author$project$Views$Link$link,
							projectHistoryRoute,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('history tab')
								])),
							$elm$html$Html$text('.')
						])),
					fieldSection(
					A3(
						$elm$core$Tuple$mapBoth,
						function ($) {
							return $.BR;
						},
						function ($) {
							return $.dv;
						},
						$author$project$Misc$duple(
							$author$project$Pages$ProjectSettingsHAR$getTagFormFromState(tag)))),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('URL')
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('field-info')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Your ActiveState Artifact Repository will be hosted at this URL')
						])),
					fieldSection(
					A3(
						$elm$core$Tuple$mapBoth,
						function ($) {
							return $.b2;
						},
						function ($) {
							return $.dv;
						},
						$author$project$Misc$duple(
							$author$project$Pages$ProjectSettingsHAR$getTagFormFromState(tag)))),
					A2($author$project$Misc$displayMaybe, $author$project$Pages$ProjectSettingsHAR$errorView, generalError),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bottom-buttons')
						]),
					_List_fromArray(
						[
							finishBtn(tag),
							cancelBtn(tag)
						]))
				]));
	});
var $author$project$Pages$ProjectSettingsHAR$newServerSectionView = F2(
	function (model, tags) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('new-server-form form')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('New Server')
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Pages$ProjectSettingsHAR$newHarView(model),
						tags))
				]));
	});
var $author$project$Pages$ProjectSettingsHAR$buildStatusView = F2(
	function (class_, text_) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(class_)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(text_)
				]));
	});
var $author$project$Pages$ProjectSettingsHAR$isInProgressBuild = function (b) {
	switch (b.$) {
		case 0:
			return true;
		case 1:
			return false;
		default:
			var buildResult = b.a;
			return buildResult === 2;
	}
};
var $author$project$Pages$ProjectSettingsHAR$allBuildsSectionView = function (buildStatus) {
	switch (buildStatus.$) {
		case 0:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('loading-status-wrapper')
					]),
				_List_fromArray(
					[
						$author$project$Views$Loading$dots,
						A2($author$project$Pages$ProjectSettingsHAR$buildStatusView, '', 'Provisioning server')
					]));
		case 1:
			return A2($author$project$Pages$ProjectSettingsHAR$buildStatusView, 'error-text', 'Build failed to start.');
		default:
			var buildResult = buildStatus.a;
			return (!buildResult) ? A2($author$project$Pages$ProjectSettingsHAR$buildStatusView, 'success-text', 'Build ready') : ($author$project$Pages$ProjectSettingsHAR$isInProgressBuild(buildStatus) ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('loading-status-wrapper')
					]),
				_List_fromArray(
					[
						$author$project$Views$Loading$dots,
						A2($author$project$Pages$ProjectSettingsHAR$buildStatusView, '', 'Build in progress')
					])) : A2($author$project$Pages$ProjectSettingsHAR$buildStatusView, 'error-text', 'Build failed'));
	}
};
var $author$project$Pages$ProjectSettingsHAR$getBuildResultFromTagState = A2(
	$elm$core$Basics$composeR,
	$author$project$Pages$ProjectSettingsHAR$getTagFormFromState,
	function ($) {
		return $.h7;
	});
var $author$project$Pages$ProjectSettingsHAR$isFailedBuild = function (b) {
	switch (b.$) {
		case 0:
			return false;
		case 1:
			return true;
		default:
			return false;
	}
};
var $author$project$Pages$ProjectSettingsHAR$pipInstallString = F2(
	function (m, tagEx) {
		return 'pip install  --index-url ' + A3(
			$author$project$Request$Project$harUrl,
			$author$project$Model$Organization$getUrlName(m.c3),
			$author$project$Model$Project$getName(m.c5),
			A2($elm$core$Basics$composeR, $author$project$Pages$ProjectSettingsHAR$getLabelFromTagState, $author$project$Pages$ProjectSettingsHAR$getFieldOriginalValue)(tagEx));
	});
var $author$project$Pages$ProjectSettingsHAR$installSection = F2(
	function (model, tag) {
		var labelIsBeingEdited = A2($elm$core$Basics$composeR, $author$project$Pages$ProjectSettingsHAR$getLabelFromTagState, $author$project$Pages$ProjectSettingsHAR$isFieldEditing);
		var labelFormattedValue = A2($elm$core$Basics$composeR, $author$project$Pages$ProjectSettingsHAR$getLabelFromTagState, $author$project$Pages$ProjectSettingsHAR$getFieldFormattedValue);
		var isNotSuccessfulBuild = function (tagEx) {
			return function (build) {
				return $author$project$Pages$ProjectSettingsHAR$isNotStartedBuild(build) || $author$project$Pages$ProjectSettingsHAR$isFailedBuild(build);
			}(
				$author$project$Pages$ProjectSettingsHAR$getTagFormFromState(tagEx).h7);
		};
		var elementID = 'pip_install';
		var disable = A3($author$project$Misc$isEither, isNotSuccessfulBuild, labelIsBeingEdited, tag);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Build Status')
						])),
					$author$project$Pages$ProjectSettingsHAR$allBuildsSectionView(
					$author$project$Pages$ProjectSettingsHAR$getBuildResultFromTagState(tag)),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Install a Package via PIP')
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('field-info')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('To use PIP when adding packages to those runtimes, execute:')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('cli-wrapper')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('cli-input'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('disabled', disable)
										])),
									$elm$html$Html$Attributes$type_('text'),
									$elm$html$Html$Attributes$disabled(disable),
									$elm$html$Html$Attributes$id(elementID),
									$elm$html$Html$Attributes$spellcheck(false),
									$elm$html$Html$Attributes$readonly(true),
									$elm$html$Html$Attributes$value(
									A2($author$project$Pages$ProjectSettingsHAR$pipInstallString, model, tag))
								]),
							_List_Nil),
							A2(
							$author$project$Misc$displayIf,
							!disable,
							A4(
								$author$project$Pages$ProjectSettingsHAR$copyButtonView,
								disable,
								model.oi,
								elementID + ('_copy' + labelFormattedValue(tag)),
								A2($author$project$Pages$ProjectSettingsHAR$pipInstallString, model, tag)))
						]))
				]));
	});
var $author$project$Pages$ProjectSettingsHAR$existingHarView = F3(
	function (model, canEditProject, tagState) {
		var fieldSection = function (_v1) {
			var field = _v1.a;
			var validations = _v1.b;
			if (!field.$) {
				return A5(
					$author$project$Pages$ProjectSettingsHAR$commitView,
					model,
					canEditProject,
					tagState,
					field,
					A2(
						$elm$core$Maybe$map,
						$author$project$Pages$ProjectSettingsHAR$getFieldValidationErr,
						A2($elm_community$list_extra$List$Extra$find, $author$project$Pages$ProjectSettingsHAR$isCommitIDErr, validations)));
			} else {
				return A4(
					$author$project$Pages$ProjectSettingsHAR$urlView,
					model,
					canEditProject,
					tagState,
					A2(
						$elm$core$Maybe$map,
						$author$project$Pages$ProjectSettingsHAR$getFieldValidationErr,
						A2($elm_community$list_extra$List$Extra$find, $author$project$Pages$ProjectSettingsHAR$isLabelErr, validations)));
			}
		};
		var deleteBtn = A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('secondary-button'),
					$elm$html$Html$Events$onClick(
					A2($author$project$Pages$ProjectSettingsHAR$DeleteTag, tagState, false))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Delete')
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('existing-har-block')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('existing-har-section')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Commit ID')
								])),
							fieldSection(
							function (t) {
								return _Utils_Tuple2(t.BR, t.dv);
							}(
								$author$project$Pages$ProjectSettingsHAR$getTagFormFromState(tagState))),
							A2($author$project$Misc$displayIf, canEditProject, deleteBtn)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('existing-har-section')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('URL')
								])),
							fieldSection(
							A3(
								$elm$core$Tuple$mapBoth,
								function ($) {
									return $.b2;
								},
								function ($) {
									return $.dv;
								},
								$author$project$Misc$duple(
									$author$project$Pages$ProjectSettingsHAR$getTagFormFromState(tagState))))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('existing-har-section')
						]),
					_List_fromArray(
						[
							A2($author$project$Pages$ProjectSettingsHAR$installSection, model, tagState),
							A2(
							$author$project$Misc$displayMaybe,
							$author$project$Pages$ProjectSettingsHAR$errorView,
							A2(
								$elm$core$Maybe$map,
								$author$project$Pages$ProjectSettingsHAR$getFieldValidationErr,
								A2(
									$elm_community$list_extra$List$Extra$find,
									$author$project$Pages$ProjectSettingsHAR$isGeneralErr,
									$author$project$Pages$ProjectSettingsHAR$getTagFormFromState(tagState).dv)))
						]))
				]));
	});
var $author$project$Pages$ProjectSettingsHAR$savedServersSection = F3(
	function (model, canEditProject, tags) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('existing-servers')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Existing Servers')
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$elm$core$List$map,
						A2($author$project$Pages$ProjectSettingsHAR$existingHarView, model, canEditProject),
						tags))
				]));
	});
var $author$project$Pages$ProjectSettingsHAR$harsView = F2(
	function (model, session) {
		var newTagFormActive = A2($elm$core$List$any, $author$project$Pages$ProjectSettingsHAR$isNewTag, model.Gt);
		var newServer = A2($elm$core$List$filter, $author$project$Pages$ProjectSettingsHAR$isNewTag, model.Gt);
		var existingServers = A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeR, $author$project$Pages$ProjectSettingsHAR$isNewTag, $elm$core$Basics$not),
			model.Gt);
		var createBtnText = function (tags) {
			return $elm$core$List$isEmpty(tags) ? 'Create ActiveState Artifact Repository' : 'Add ActiveState Artifact Repository';
		};
		var canEditProject = A2(
			$author$project$Model$Permissions$canEditProjects,
			$author$project$Model$Organization$getUrlName(model.c3),
			$author$project$Model$Session$getUser(session));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Misc$displayIf,
					(!newTagFormActive) && canEditProject,
					A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('primary-button'),
								$elm$html$Html$Events$onClick($author$project$Pages$ProjectSettingsHAR$CreateHarClicked),
								$elm$html$Html$Attributes$hidden(newTagFormActive)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								createBtnText(model.Gt))
							]))),
					A2(
					$author$project$Misc$displayIf,
					A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not)(newServer),
					A2($author$project$Pages$ProjectSettingsHAR$newServerSectionView, model, newServer)),
					A2(
					$author$project$Misc$displayIf,
					A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not)(existingServers),
					A3($author$project$Pages$ProjectSettingsHAR$savedServersSection, model, canEditProject, existingServers))
				]));
	});
var $author$project$Pages$ProjectSettingsHAR$view = F2(
	function (model, session) {
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('har-ui-settings')
				]),
			_List_fromArray(
				[
					A2($author$project$Misc$displayMaybe, $author$project$Views$Modal$confirmCancelView, model.iw),
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('ActiveState Artifact Repository')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Enabling an ActiveState Artifact Repository makes the compiled artifacts for your project\'s Python packages available to install with pip in the command line. '),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('https://docs.activestate.com/platform/projects/aar')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Learn more in our platform documentation')
								])),
							$elm$html$Html$text('.')
						])),
					A2(
					$elm$html$Html$ul,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('The existing user environment must be using '),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href('https://packaging.python.org/en/latest/key_projects/#pip')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('PIP')
										])),
									$elm$html$Html$text(' and Python 3.8 or later.')
								]))
						])),
					$author$project$Model$Permissions$orgCanHar(model.c3) ? A2($author$project$Pages$ProjectSettingsHAR$harsView, model, session) : A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$target('_blank'),
									$elm$html$Html$Attributes$href(
									$author$project$Url$Extra$contactSales(_List_Nil))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Contact us')
								])),
							$elm$html$Html$text(' to try out this feature.')
						]))
				]));
	});
var $author$project$Views$ProjectItemView$cardWithPlatformButtons = F2(
	function (project, isRecommended) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('featured-project'),
					$elm$html$Html$Attributes$class(project.aC),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('recommended', isRecommended)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('project-image ' + project.gf)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('project-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(project.i$)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('project-author')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('By '),
							A3(
							$author$project$Views$Link$link,
							A2($author$project$Model$Route$orgIndex, project.fW, $elm$core$Maybe$Nothing),
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(project.fW)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('project-language')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Language: '),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('language-text')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(project.aC)
								]))
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('project-description')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(project.bP)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('details')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('language-list')
								]),
							A2(
								$elm$core$List$map,
								function (lang) {
									return A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('language ')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(lang)
											]));
								},
								project.aM)),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('platform-list')
								]),
							A2(
								$elm$core$List$map,
								function (plat) {
									return A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('platform ' + plat)
											]),
										_List_Nil);
								},
								project.Fh))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('project-links')
						]),
					A2(
						$elm$core$List$map,
						function (platform) {
							return A3(
								$author$project$Views$Link$link,
								$author$project$Model$Route$projectOverview(
									$author$project$Model$Route$projectOverviewParams(
										{ix: project.fW, vT: platform.b})),
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('icon'),
												$elm$html$Html$Attributes$class(platform.a)
											]),
										_List_Nil),
										$elm$html$Html$text(platform.a)
									]));
						},
						project.gp)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('select-os-tooltip')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Select your OS')
						]))
				]));
	});
var $author$project$Pages$PublicProjects$view = F2(
	function (model, _v0) {
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('page featured-projects-section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('ActiveState\'s Community Edition Languages')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Battle-tested by millions of developers. Free to use for development and testing environments.')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('project-feature')
						]),
					_Utils_ap(
						A2(
							$elm$core$List$map,
							function (project) {
								return A2($author$project$Views$ProjectItemView$cardWithPlatformButtons, project, false);
							},
							model.te),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('non-platform-ce')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h3,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Where are the rest of our languages?')
											])),
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('While they\'re not yet on the Platform, you can still access the other Community Languages on the ActiveState website.')
											])),
										A2(
										$elm$html$Html$ul,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('ce-language-list')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$a,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$target('_blank'),
																$elm$html$Html$Attributes$href('https://www.activestate.com/products/activego/')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('ActiveGo')
															]))
													])),
												A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$a,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$target('_blank'),
																$elm$html$Html$Attributes$href('https://www.activestate.com/products/activeruby/')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('ActiveRuby')
															]))
													]))
											]))
									]))
							]))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('page curated-projects-section')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Curated Projects')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Small runtimes that solve big problems. Hand selected by our team to get you to the fun stuff faster.')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('project-feature curated-project')
								]),
							A2(
								$elm$core$List$map,
								function (project) {
									return A2($author$project$Views$ProjectItemView$cardWithPlatformButtons, project, false);
								},
								A2(
									$elm$core$List$sortBy,
									function ($) {
										return $.i$;
									},
									model.tw))),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('submit-runtime')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Do you have a custom, purpose-built runtime? ')
										])),
									$elm$html$Html$text('Submit your project so others can benefit. We\'ll check it out and add it to our curated list, if appropriate. '),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href('mailto:community@activestate.com')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Get in touch!')
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$ResetPassword$OnPasswordConfirmationInput = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$ResetPassword$OnPasswordInput = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$ResetPassword$ResetPassword = {$: 1};
var $author$project$Pages$ResetPassword$view = function (model) {
	var passwordError = A2($elm$core$Maybe$withDefault, '', model.pk);
	var passwordConfirmationError = A2($elm$core$Maybe$withDefault, '', model.mZ);
	var fieldError = function (errorText) {
		return A2(
			$author$project$Misc$displayIf,
			!$elm$core$String$isEmpty(errorText),
			A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('field-error')
					]),
				_List_fromArray(
					[
						$author$project$Views$Icon$view(
						$author$project$Views$Icon$small(
							A2(
								$author$project$Views$Icon$colored,
								$author$project$Style$color('red'),
								$author$project$Views$Icon$icon(86)))),
						$elm$html$Html$text(errorText)
					])));
	};
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$id('auth-page'),
				$elm$html$Html$Attributes$class('forgot-password-page')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Login$logoBar,
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('page-body')
					]),
				_List_fromArray(
					[
						$author$project$Views$NotificationsInline$view(model),
						A2(
						$elm$html$Html$h1,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Reset your Password')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Choose a new password for your account.')
							])),
						A2(
						$elm$html$Html$form,
						_List_fromArray(
							[
								$elm$html$Html$Events$onSubmit($author$project$Pages$ResetPassword$ResetPassword)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'error',
												!$elm$core$String$isEmpty(passwordError))
											]))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2('sub-label', true),
														_Utils_Tuple2(
														'hidden',
														(_Utils_cmp(
															$elm$core$String$length(model.ey),
															$author$project$Validation$minPasswordLength) > -1) || $elm$core$String$isEmpty(model.ey))
													]))
											]),
										_List_fromArray(
											[
												$author$project$Pages$CreateAccount$characterMinimumText($author$project$Validation$minPasswordLength)
											])),
										A2(
										$elm$html$Html$h4,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('New Password')
											])),
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$type_('password'),
												$elm$html$Html$Events$onInput($author$project$Pages$ResetPassword$OnPasswordInput),
												$elm$html$Html$Attributes$value(model.ey)
											]),
										_List_Nil),
										fieldError(passwordError)
									])),
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2('sub-label', true),
														_Utils_Tuple2(
														'hidden',
														(_Utils_cmp(
															$elm$core$String$length(model.km),
															$author$project$Validation$minPasswordLength) > -1) || $elm$core$String$isEmpty(model.km))
													]))
											]),
										_List_fromArray(
											[
												$author$project$Pages$CreateAccount$characterMinimumText($author$project$Validation$minPasswordLength)
											])),
										A2(
										$elm$html$Html$h4,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Confirm New Password')
											])),
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$type_('password'),
												$elm$html$Html$Events$onInput($author$project$Pages$ResetPassword$OnPasswordConfirmationInput),
												$elm$html$Html$Attributes$value(model.km)
											]),
										_List_Nil),
										fieldError(passwordConfirmationError)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button-wrapper')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('primary-button'),
												$elm$html$Html$Attributes$type_('submit')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Reset Password')
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$StateToolCheatSheet$CopyClipboard = function (a) {
	return {$: 0, a: a};
};
var $author$project$Url$Extra$checkoutDocs = function (queryParams) {
	return A3(
		$author$project$Url$Extra$createUrl,
		$author$project$Url$Extra$docsDomain,
		_List_fromArray(
			['platform', 'projects', 'checkout']),
		queryParams);
};
var $author$project$Pages$StateToolCheatSheet$sectionList = _List_fromArray(
	[
		{
		bP: A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('You\'ll need to authenticate to push changes from your CLI or to access your private projects.')
				])),
		kx: _List_fromArray(
			[
				{
				fj: 'state auth',
				fp: A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Follow the prompts to sign in or create an account.')
						])),
				Gy: 'Authenticate'
			}
			]),
		Gy: 'Authenticating'
	},
		{
		bP: A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Install and start a runtime from an existing ActiveState project. Don\'t have a project yet? '),
					A3(
					$author$project$Views$Link$link,
					$author$project$Model$Route$createProjectRedirect($author$project$Model$Route$emptyCreateProjectParams),
					_List_fromArray(
						[
							$elm$html$Html$Attributes$target('_blank')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Create a Project')
						])),
					$elm$html$Html$text(' or use the '),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('cli-text-inline')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('state init')
						])),
					$elm$html$Html$text(' command.')
				])),
		kx: _List_fromArray(
			[
				{
				fj: 'state init <org-name>/<project-name> --language <language@version>',
				fp: A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Create a new ActiveState Platform project that contains a runtime with the specified language. Run '),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('cli-text-inline')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('state info language/<language-name>')
								])),
							$elm$html$Html$text(' to see all available versions for that language.')
						])),
				Gy: 'Create a new project'
			},
				{
				fj: 'state checkout <org-name>/<project-name> .',
				fp: A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('This downloads the language interpreter and all required packages to your system. It also adds the '),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('cli-text-inline')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('activestate.yaml')
								])),
							$elm$html$Html$text(' file to your current directory. For more information refer to the '),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(
									$author$project$Url$Extra$checkoutDocs(_List_Nil)),
									$elm$html$Html$Attributes$target('_blank')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('checkout documentation')
								])),
							$elm$html$Html$text('.')
						])),
				Gy: 'Download & install an existing runtime'
			},
				{
				fj: 'state use <project-name>',
				fp: A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('This runtime will be set as your system default. Run '),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('cli-text-inline')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('state use reset')
								])),
							$elm$html$Html$text(' to unset it.')
						])),
				Gy: 'Option 1 — Start runtime system-wide'
			},
				{
				fj: 'state shell <project-name>',
				fp: A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Your runtime will start in a subshell. Run '),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('cli-text-inline')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('stop')
								])),
							$elm$html$Html$text(' to exit.')
						])),
				Gy: 'Option 2 — Start runtime in a subshell'
			}
			]),
		Gy: 'Runtime Management'
	},
		{
		bP: A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Packages come from our vetted catalog and are all built on-demand.')
				])),
		kx: _List_fromArray(
			[
				{
				fj: 'state install <package-name>',
				fp: A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Replace '),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('cli-text-inline')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('<package-name>')
								])),
							$elm$html$Html$text(' with the name of the package you want to install.')
						])),
				Gy: 'Install a single package'
			},
				{
				fj: 'state import <path/to/file>',
				fp: A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Import multiple packages using one of the '),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(
									$author$project$Url$Extra$createImportDocs(_List_Nil)),
									$elm$html$Html$Attributes$target('_blank')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('supported file formats')
								])),
							$elm$html$Html$text('.')
						])),
				Gy: 'Install packages from a requirements file\n'
			},
				{
				fj: 'state search <search-term>',
				fp: A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('See a list of matching packages, and their avialable versions, that are in our catalog.')
						])),
				Gy: 'Search for a package'
			},
				{
				fj: 'state uninstall <package-name>',
				fp: $elm$html$Html$text(''),
				Gy: 'Uninstall a package'
			}
			]),
		Gy: 'Package Management'
	},
		{
		bP: A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('You can make changes to your local environment, like adding and removing packages, without affecting the remote project on the Platform and only push them when you\'re ready.')
				])),
		kx: _List_fromArray(
			[
				{
				fj: 'state push',
				fp: A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Update the remote project on the Platform with your local changes.')
						])),
				Gy: 'Push your local changes'
			},
				{
				fj: 'state pull',
				fp: A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Bring in the latest changes from the remote project on the Platform.')
						])),
				Gy: 'Pull in remote changes'
			}
			]),
		Gy: 'Change Management'
	},
		{
		bP: A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('You can write your own custom scripts and commands and share them as part of your runtime. Learn more about running scripts '),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$target('_Blank'),
							$elm$html$Html$Attributes$href('https://docs.activestate.com/platform/state/config/#scripts')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('here')
						])),
					$elm$html$Html$text('.')
				])),
		kx: _List_fromArray(
			[
				{
				fj: 'state run hello \"world!\"',
				fp: A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(' This runs the '),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('cli-text-inline')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('hello')
								])),
							$elm$html$Html$text(' script, which accepts '),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('cli-text-inline')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('\"world!\"')
								])),
							$elm$html$Html$text(' as an argument.')
						])),
				Gy: 'Run a script defined in your activestate.yaml file'
			}
			]),
		Gy: 'Running Commands'
	},
		{
		bP: A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Stuck? Try these commands or '),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$target('_blank'),
							$elm$html$Html$Attributes$href('mailto:support@activestate.com')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('contact support')
						])),
					$elm$html$Html$text('.')
				])),
		kx: _List_fromArray(
			[
				{
				fj: 'state --help',
				fp: A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('')
						])),
				Gy: 'Get help about the State Tool'
			},
				{
				fj: 'state activate --help',
				fp: A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('This shows help for the '),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('cli-text-inline')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('activate')
								])),
							$elm$html$Html$text(' command. You can swap it with any of the other State Tool commands.')
						])),
				Gy: 'Get help about a specific command'
			},
				{
				fj: 'state update',
				fp: A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('If updating fails consistently please uninstall and reinstall State Tool.')
						])),
				Gy: 'Update the State Tool'
			}
			]),
		Gy: 'Troubleshooting'
	}
	]);
var $author$project$Pages$StateToolCheatSheet$snippetView = F3(
	function (snippet, copyStatus, copyClipboardMsg) {
		var idAttr = A3($elm$core$String$replace, ' ', '-', snippet.Gy);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('snippet-wrapper')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$for(idAttr)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(snippet.Gy)
								]))
						])),
					$author$project$Views$CliText$view(
					{
						B$: $elm$core$Maybe$Just(
							{Em: copyClipboardMsg, L: copyStatus}),
						l6: idAttr,
						Gv: snippet.fj
					}),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('snippet-subtext')
						]),
					_List_fromArray(
						[snippet.fp]))
				]));
	});
var $author$project$Pages$StateToolCheatSheet$sectionView = F3(
	function (section, copyStatus, copyClipboardMsg) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('cheat-section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('columns')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('column')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h2,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(section.Gy)
										])),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[section.bP]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('column cheat-snippets')
								]),
							A2(
								$elm$core$List$map,
								function (snippet) {
									return A3($author$project$Pages$StateToolCheatSheet$snippetView, snippet, copyStatus, copyClipboardMsg);
								},
								section.kx))
						]))
				]));
	});
var $author$project$Pages$StateToolCheatSheet$view = F2(
	function (model, _v0) {
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('cheat-sheet-page')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('If you have not yet installed the State Tool, please refer follow the '),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$target('_blank'),
									$elm$html$Html$Attributes$href('https://docs.activestate.com/platform/state/')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('install instructions')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (section) {
							return A3($author$project$Pages$StateToolCheatSheet$sectionView, section, model.oi, $author$project$Pages$StateToolCheatSheet$CopyClipboard);
						},
						$author$project$Pages$StateToolCheatSheet$sectionList))
				]));
	});
var $author$project$Pages$SupplementalLicenseTerms$newSupplementalLicenseTermsText = function (model) {
	var cls = function () {
		if (!model.$) {
			return '';
		} else {
			var orgID = model.a.zv;
			var projectID = model.a.zK;
			var commitID = model.a.BR;
			return orgID + ('_' + (projectID + ('_' + commitID)));
		}
	}();
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(cls)
				]),
			_List_Nil),
			A2(
			$elm$html$Html$h2,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('ACTIVESTATE SUPPLEMENTAL TERMS FOR THE RUNTIME INSTALLER LICENSE'),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					$elm$html$Html$text('(Continued)')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('ver. October 15, 2022')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('\nThe ACTIVESTATE RUNTIME INSTALLER LICENSE AGREEMENT and these SUPPLEMENTAL LICENSE\nTERMS (collectively the “Agreement”) are agreed to by:\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('I.')
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$b,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('\"Authorized User\"')
								])),
							$elm$html$Html$text(', '),
							A2(
							$elm$html$Html$b,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('\"You\"')
								])),
							$elm$html$Html$text(', or '),
							A2(
							$elm$html$Html$b,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('\"Your\"')
								])),
							$elm$html$Html$text('\nherein defined as an individual, an entity, a Machine Account, or an\nanonymous user authorized by an ETOS to use the Service for creating or consuming a Runtime or the\nSoftware; and\n')
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('II.')
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$b,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('\"ActiveState\"')
								])),
							$elm$html$Html$text(' herein defined as ActiveState Software Inc.')
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent0')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('1. ')
						])),
					A2(
					$elm$html$Html$b,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('DEFINITIONS')
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('1.1')
						])),
					$elm$html$Html$text(' “ActiveState Platform” refers to ActiveState’s Platform located at www.activestate.com and all content,\nservices, Runtimes, Komodo, and any or all products provided by ActiveState at or through the ActiveState\nPlatform. It also refers to ActiveState-owned subdomains of www.activestate.com. Occasionally, websites\nand or products owned by ActiveState may provide different or additional terms of service. If those\nadditional terms conflict with this Agreement, the more specific terms apply to the relevant page or service\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('1.2')
						])),
					$elm$html$Html$text('\n“Accessible Code” means source code contained within the Software that is licensed under an open-source\nlicense.')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('1.3')
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('“Enterprise Terms of Service Agreement or ETOS” means either the agreement at the '),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('https://www.activestate.com/legal/master-terms-of-service'),
									$elm$html$Html$Attributes$target('_blank')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Weblink')
								])),
							$elm$html$Html$text('\nor the signed\nETOS between the Authorized User and ActiveState, for the avoidance of doubt the signed ETOS will\noverride the Weblink version.\n')
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('1.4')
						])),
					$elm$html$Html$text('\n“Concurrent Runtime Subscriptions” means the total number of Runtimes that are permanently installed or\nbeing used regularly and concurrently on a Node.\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('1.5')
						])),
					$elm$html$Html$text('\n“Confidential Information” means all information designated in writing as confidential by each party, or\nwhich under the circumstances of disclosure reasonably ought to be considered as confidential. Without\nlimiting the foregoing, ActiveState Confidential Information includes the Software, including all source\nand object code, and all associated documentation, but not Accessible Code.\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('1.6')
						])),
					$elm$html$Html$text('\n"Maintenance and Support" means maintenance and support for the Software provided by ActiveState\nunder separate terms.\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('1.7')
						])),
					$elm$html$Html$text('\n “Node” means a single installation of an Operating System running on a machine (virtual or physical) that\nis capable of utilizing a Runtime.\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('1.8')
						])),
					$elm$html$Html$text('\n"OEM Distribution" means any distribution to, and/or use of the Software by, others outside Your\norganization and distribution and/or use of the Software as either a bundled add-on to, or embedded\ncomponent of another application, with such application being made available to its users as, but not limited\nto, an on-premises application, a hosted application, a software-as-a-service offering or a subscription\nservice for which the distributor of the application receives a license fee or any form of direct or indirect\ncompensation and whether for commercial or non-commercial purposes.\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('1.9')
						])),
					$elm$html$Html$text('\n“Person” means any individual, sole proprietorship, partnership, firm, entity, unincorporated association,\nunincorporated syndicate, unincorporated organization, trust, body corporate or governmental or regulatory\nauthority, and where the context requires, any of the foregoing when they are acting as trustee, executor,\nadministrator or other legal representative.\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('1.10')
						])),
					$elm$html$Html$text('\n“Redistribute” means any distribution to, and/or use of the Software by, others inside or outside Your\norganization and distribution and/or use of the Software inside or outside Your organization.\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('1.11')
						])),
					$elm$html$Html$text('\n“Runtime” means a collection of open-source components and or other components provided by\nActiveState in compiled form (if needed) that must be present to perform an activity. Examples of activities\nshall include but are not limited to development, running an application, using a language interpreter,\nlinting, reformatting or compiling source code, executing code, updating dependencies or interpreters via\nActiveState’s or third-party command line interface (“CLI”), installing additional dependencies via CLI\nand or any other deployment methodologies offered by the ActiveState Platform. For customers with\nagreements that include the definition of Active Runtime and Static Runtime; those definitions are included\nunder this definition of Runtime.\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('1.12')
						])),
					$elm$html$Html$text('\n“Service” means the applications, software, products, Runtimes, and services provided by ActiveState and\nthe ActiveState Platform.\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('1.13')
						])),
					$elm$html$Html$text('\n“Software” means the definition provided in the ACTIVESTATE RUNTIME INSTALLER LICENSE\nAGREEMENT.\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('1.14')
						])),
					$elm$html$Html$text('\n“Term” means the definition provided in Section 8 of this Agreement.\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('1.15')
						])),
					$elm$html$Html$text('\n“Trademarks” means the trademarks, whether registered or unregistered, used by ActiveState and/or its\naffiliates or their licensors.\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('1.16')
						])),
					$elm$html$Html$text('\n“Usage Cap” means the maximum number of Concurrent Runtime Subscriptions authorized by the ETOS.\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('1.17')
						])),
					$elm$html$Html$text('\n“Wrapped Application” means a single-file executable in which all binary components are encapsulated in\na single binary without exposing the base programming language as a scripting language within Your own\napplication program to Authorized User.\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent0')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('2. ')
						])),
					A2(
					$elm$html$Html$b,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('LICENSE GRANT')
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('2.1')
						])),
					$elm$html$Html$text('\nSubject to the terms and conditions of this Agreement, ActiveState hereby grants You a limited, worldwide,\npaid up, free-of-charge, non-exclusive, non-transferable, non-assignable, and non-sublicensable license to\ninstall and use the Software on any computing device, in accordance with the limitations and restrictions\nset forth in this Agreement (“License”). You may not use the Software for OEM Distribution.\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('2.2')
						])),
					$elm$html$Html$text('\nThe validity of this License is subject to the terms, conditions, restrictions, and limitations set forth in the\nETOS that govern the Authorized User’s licenses, including the specified term, and Usage Cap. Any usage\nin excess of the Usage Cap by the Authorized User will be subject to additional charges at current applicable\nfees.\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('2.3')
						])),
					$elm$html$Html$text('\nWithout the prior approval of ActiveState, You may not use the Software for OEM Distribution. Any OEM\nDistribution rights granted by ActiveState to the Authorized User will be subject to the terms and conditions\nof their OEM License Agreement, which shall never be deemed as rights granted to You.\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent0')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('3. ')
						])),
					A2(
					$elm$html$Html$b,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('RESTRICTIONS')
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('3.1')
						])),
					$elm$html$Html$text('\nExcept as expressly provided in this Agreement, You may not:\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent2')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('\ni. transfer, assign, sublicense, resell, or rent the Software;\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent2')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('\nii. modify or translate the Software to discover the source code in the Software or create a functional\nequivalent in the Software;\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent2')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('\niii. reverse engineer, decompile, or disassemble (except as and only to the extent this restriction is\nprohibited by applicable law) the Software;\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent2')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('\niv. create derivative works based on the Software;\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent2')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('\nv. merge the Software with another product;\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent2')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('\nvi. copy the Software;\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent2')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('\nvii. remove or obscure any proprietary rights notices or labels on the Software;\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent2')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('\nviii. Redistribute, without entering into a separate agreement with ActiveState:\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent3')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('\na. the Software as a whole, whether as a Wrapped Application or on a standalone basis;\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent3')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('\nb. parts of the Software to create a language distribution; or\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent3')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('\nc. the Software (other than the Accessible Code) with Your Wrapped Application;\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent2')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('\nix. distribute the Software by OEM Distribution without entering into a separate OEM Distribution\nagreement with ActiveState;\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent2')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('\nx. permit others to use the Software; or\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent2')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('\nxi. use the Software:\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent3')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('\na. in excess of the Usage Cap, without paying applicable over usage Service fees, on any\ncomputing device in whatever form or manner, whether physical or virtual and external or\ninternal-facing;\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent3')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('\nb. on any operating systems other than Windows, MacOS and Linux;\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent3')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('\nc. on computing devices used for file and/or application serving;\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent3')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('\nd. on any computing devices used for business continuity and disaster recovery; or\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent3')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('\ne. to provide content or functionality through external-facing servers or internal-facing servers.\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent0')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('4. ')
						])),
					A2(
					$elm$html$Html$b,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('CONFIDENTIALITY')
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('4.1')
						])),
					$elm$html$Html$text('\nExcept as reasonably required to exercise Your rights under this Agreement, You agree to prevent any\nunauthorized copying, use, distribution, installation or transfer of possession of Confidential Information\nreceived from ActiveState (the “ActiveState Confidential Information”). You do not acquire any interest in\nany ActiveState Confidential Information by reason of this Agreement. ActiveState Confidential\nInformation does not include any information which (i) becomes part of the public domain through no act\nor omission on Your part; (ii) is lawfully acquired by You from a third party without any breach of\nconfidentiality; (iii) is independently developed by You without reference to the ActiveState Confidential\nInformation; or (iv) is disclosed in accordance with judicial or other governmental order or timely disclosure\nrequirements imposed by law or stock exchange policies. Notwithstanding the foregoing, either party may\ndisclose the terms and conditions of this Agreement in conjunction with legal proceedings. Without limiting\nthe generality of the foregoing, You must take reasonable steps to prevent any personnel from removing\nany proprietary or other legend or restrictive notice contained or included in any material provided by\nActiveState to You.\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('4.2')
						])),
					$elm$html$Html$text('\nYou acknowledge that any use or disclosure of the ActiveState Confidential Information in a manner\ninconsistent with the provisions of this Agreement may cause ActiveState irreparable damage for which\nremedies other than injunctive relief may be inadequate. You further agree that ActiveState will be entitled\nto attempt to receive from a court of competent jurisdiction injunctive or other equitable relief to restrain\nsuch use or disclosure in addition to other appropriate remedies.\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('5.')
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$b,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('OPEN-SOURCE ACKNOWLEDGEMENT.')
								])),
							$elm$html$Html$text('\nThe Software is comprised of open source software, which is\nsubject to the terms of the open source software license(s) accompanying or otherwise applicable to that open\nsource software included in the Software (the “Open Source Components”). For reference, Tcl/Tk open source\nlicense terms can be found in Exhibit A attached to this Agreement or obtained from this link:\n'),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('https://www.tcl.tk/software/tcltk/license.html'),
									$elm$html$Html$Attributes$target('_blank')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('https://www.tcl.tk/software/tcltk/license.html')
								])),
							$elm$html$Html$text('.\nYou acknowledge that Your own distribution or deployment of\ninstances containing or linking to the Software, including the Open Source Components, or any other open source\nsoftware may trigger open source license requirements for which You are solely responsible. Nothing in this\nAgreement limits Your rights under or grants rights to You that supersede the terms of any applicable open\nsource software license for the applicable Open Source Components.\n')
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('6.')
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$b,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('INTELLECTUAL PROPERTY OWNERSHIP.')
								])),
							$elm$html$Html$text('\nAll right, title and interest in and to the Software and all\nintellectual property rights embodied therein, including copyrights, trade names, Trademarks, service marks,\nproduct names, trade secrets embodied in the Software\'s design and coding methodology and other proprietary\nmaterials in the Software belong exclusively to ActiveState or its third-party licensors. The Software is protected\nby Canada and United States copyright laws and international treaty provisions as implemented locally in\ndifferent jurisdictions. Except as specifically provided under this Agreement, You acknowledge that no other\nright, title or interest in and to the Software or any parts thereof are granted to You. ActiveState grants You the\nlimited right to use the trade names, Trademarks, service marks or product names of ActiveState as required for\nreasonable and customary use in describing the origin of the Software. You may not use the trade names,\nTrademarks, service marks or product names of ActiveState in any way that might state or imply that ActiveState\nendorses Your work or might state or imply that You created the Software.\n')
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('7. ')
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$b,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('USER DATA.')
								])),
							$elm$html$Html$text('\nYou acknowledge, agree, and expressly consent to ActiveState’s collection of Your User Data\nthrough the Software. ActiveState does not claim ownership of any User Data. You hereby grant to ActiveState\nand its sublicensees a royalty-free, perpetual, irrevocable, transferable, worldwide non-exclusive right to\nreproduce, analyze, review, process, diagnose, or otherwise use the User Data (in whole or in part) for the purpose\nof supporting, maintaining, and providing the Software, the Maintenance and Support, if any, and any related\nservices provided by ActiveState relating to the Software (the “User Data License”). ActiveState will not disclose\nthe User Data to any third parties and will only use the User Data in accordance with the User Data License,\nexcept that ActiveState may provide Your User Data to third parties providing services relating to the Software\nto ActiveState (which will protect the User Data on terms and conditions that are commensurate in scope with\nthis Agreement). In addition to the rights granted under the User Data License, You acknowledge and agree that\nActiveState has the right to (i) publicly disclose, in any manner whatsoever, User Data that have been\nanonymized; and (ii) review or analyze the User Data and publicly disclose any results of such review or analysis,\nincluding in the form of reports, blog posts, newsletters, marketing materials, or otherwise, provided You will\nnot be identified in such publicly disclosed materials.\n')
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('8.')
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$b,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('TERM.')
								])),
							$elm$html$Html$text('\nThis Agreement will be effective upon Your agreement to be bound by the terms and conditions of this\nAgreement and will continue in effect subject to the term as specified in the Authorized User’s ETOS. Once the\nAuthorized User’s ETOS and/or OEM distribution agreements terminate or expire so will Your rights to use the\nLicense to the Software herein provided, and ActiveState will have the right to demand an immediate cease and\ndesist of use of the Software.\n')
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('9.')
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$b,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('TERMINATION.')
								])),
							$elm$html$Html$text('\nIf You breach any term or condition of this Agreement, ActiveState may immediately\nterminate this Agreement with respect to the Software that You have licensed under this Agreement by providing\nnotice to You. ActiveState may also terminate this Agreement, without any liability to You, if any law, regulations,\norders, or legal requirements prohibits ActiveState’s provision or licensing of the Software to You. Upon\ntermination of this Agreement by ActiveState, You will immediately cease all use of the Software and return all\ncopies of the Software that are under Your control to ActiveState or to delete all such copies. Furthermore, if You\nentered into this Agreement on behalf of a Person, where such Person has more than 100 employees then, if\nrequested by ActiveState, You will furnish ActiveState with a signed certification confirming that You have\ncomplied with the ActiveState termination pursuant to this Section 9 and ceased all use of the Software and\nreturned or destroyed all copies of the Software that were under Your control.\n')
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('10.')
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$b,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('INFRINGEMENT INDEMNIFICATION.')
								])),
							$elm$html$Html$text('\nYou indemnify, hold harmless, and defend ActiveState, its licensors,\nand their respective employees, agents and distributors against any and all claims, proceedings, demands and costs\nresulting from or in any way connected with Your use of the Software and arising from Your breach of this\nAgreement; provided, however, that ActiveState will notify You in writing of any such claim. ActiveState will not\nenter into any settlement or compromise any such claim without Your prior written consent. You will have sole\ncontrol of any such action and settlement negotiations; and ActiveState will provide You with commercially\nreasonable information and assistance, at Your request and expense, necessary to settle or defend such claim.\n')
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent0')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('11. ')
						])),
					A2(
					$elm$html$Html$b,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('DISCLAIMER OF WARRANTY')
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$b,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('\nNEITHER ACTIVESTATE NOR ANY OF ITS SUPPLIERS, LICENSORS, OR RESELLERS MAKES\nANY WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, UNDER THIS AGREEMENT. TO THE\nMAXIMUM EXTENT PERMITTED UNDER APPLICABLE LAW, ACTIVESTATE AND ITS\nSUPPLIERS, LICENSORS, AND RESELLERS SPECIFICALLY DISCLAIM ALL WARRANTIES AND\nCONDITIONS WITH RESPECT TO THE SOFTWARE, EITHER EXPRESS, IMPLIED OR\nSTATUTORY, INCLUDING, BUT NOT LIMITED TO, ANY WARRANTY OR CONDITION OF TITLE,\nNON-INFRINGEMENT, MERCHANTABILITY, DURABILITY, MERCHANTABLE QUALITY,\nFITNESS FOR A PARTICULAR PURPOSE, UPDATES, UPGRADES, SUPPLEMENTS, PRODUCTS,\nAPPLIANCES, SYSTEM INTEGRATION, DATA ACCURACY AND ANY OTHER ITEMS PROVIDED\nHEREUNDER. ACTIVESTATE MAKES NO WARRANTY OR GUARANTEE THAT THE\nOPERATION OF THE SOFTWARE WILL BE UNINTERRUPTED, ERROR-FREE, OR VIRUS-FREE,\nOR THAT THE SOFTWARE WILL MEET ANY PARTICULAR CRITERIA OF PERFORMANCE,\nQUALITY, ACCURACY, PURPOSE, OR NEED. YOU ASSUME THE ENTIRE RISK OF SELECTION,\nINSTALLATION, AND USE OF THE SOFTWARE. THIS DISCLAIMER OF WARRANTY\nCONSTITUTES AN ESSENTIAL PART OF THIS AGREEMENT. THIS SOFTWARE IS PROVIDED\nBY ACTIVESTATE AND ACCEPTED BY YOU ON AN "AS IS" AND “AS AVAILABLE” BASIS AND\nACTIVESTATE GIVES TO YOU NO OTHER REPRESENTATIONS OR WARRANTIES OF ANY\nKIND, AND DISCLAIMS ALL WARRANTIES, ORAL OR WRITTEN, EXPRESS, IMPLIED OR\nSTATUTORY, WITH RESPECT TO THE SOFTWARE OR THE PERFORMANCE OR RESULTS OF\nUSE THEREOF. YOU ACKNOWLEDGE THAT THE SERVICES MAY BE TEMPORARILY\nUNAVAILABLE DUE TO SCHEDULED MAINTENANCE OR FOR UNSCHEDULED EMERGENCY\nMAINTENANCE, EITHER BY ACTIVESTATE OR BY THIRD-PARTY PROVIDERS.\n')
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('11.1')
						])),
					$elm$html$Html$text('\nTO THE EXTENT ANY IMPLIED WARRANTIES CANNOT BE DISCLAIMED UNDER\nAPPLICABLE LAW, ANY IMPLIED WARRANTIES ARE LIMITED IN DURATION TO THE\nPERIOD REQUIRED BY APPLICABLE LAW.\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('11.2')
						])),
					$elm$html$Html$text('\nSOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF IMPLIED WARRANTIES OR\nLIMITATIONS ON APPLICABLE STATUTORY RIGHTS OF A CONSUMER, AND SO SOME OR\nALL OF THE EXCLUSION OF IMPLIED WARRANTIES OR LIMITATIONS SET OUT IN THIS\nSECTION MAY NOT APPLY TO YOU.\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent0')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('12. ')
						])),
					A2(
					$elm$html$Html$b,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('LIMITATION OF LIABILITY')
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('12.1')
						])),
					$elm$html$Html$text('\nINDEPENDENT OF THE FOREGOING PROVISIONS, TO THE MAXIMUM EXTENT PERMITTED\nUNDER APPLICABLE LAW, IN NO EVENT AND UNDER NO LEGAL THEORY, INCLUDING\nWITHOUT LIMITATION, TORT, CONTRACT, OR STRICT PRODUCTS LIABILITY, WILL\nACTIVESTATE, ITS DIRECTORS, OFFICERS, EMPLOYEES, AFFILIATES, AGENTS,\nCONTRACTORS, PRINCIPALS, SUPPLIERS OR LICENSORS BE LIABLE TO YOU OR ANY\nOTHER PERSON FOR ANY INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL\nDAMAGES OF ANY KIND, INCLUDING WITHOUT LIMITATION, DAMAGES FOR LOSS OF\nGOODWILL, WORK STOPPAGE, COMPUTER MALFUNCTION, OR ANY OTHER KIND OF\nCOMMERCIAL DAMAGE, EVEN IF ACTIVESTATE HAS BEEN ADVISED OF THE POSSIBILITY\nOF SUCH DAMAGES.\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('12.2')
						])),
					$elm$html$Html$text('\nTO THE MAXIMUM EXTENT PERMITTED UNDER APPLICABLE LAW, IN NO EVENT WILL\nACTIVESTATE BE LIABLE TO YOU FOR DAMAGES UNDER THIS AGREEMENT FOR ANY\nCAUSE WHATSOEVER, AND REGARDLESS OF THE FORM OF ACTION.\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('13.')
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$b,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('ENTIRE AGREEMENT.')
								])),
							$elm$html$Html$text('\nThis Agreement constitutes the entire understanding of the parties with respect to the\nsubject matter of this Agreement and merges all prior communications, representations, and agreements.\n')
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('14.')
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$b,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('SEVERABILITY.')
								])),
							$elm$html$Html$text('\nIf any provision of this Agreement is declared invalid or unenforceable, such provision will\nbe deemed modified to the extent necessary and possible to render it valid and enforceable. In any event, the\nunenforceability or invalidity of any provision will not affect any other provision of this Agreement, and this\nAgreement will continue in full force and effect, and be construed and enforced, as if such provision had not been\nincluded, or had been modified as above provided, as the case may be.\n')
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('15.')
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$b,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('ENTIRE AGREEMENT & AMENDMENT.')
								])),
							$elm$html$Html$text('\nThis Agreement constitutes the complete agreement between the\nparties and supersedes all prior or contemporaneous agreements or representations, written or oral, concerning the\nsubject matter of this Agreement, appendices and attachments. ActiveState reserves the right to change this\nAgreement at any time, which change shall be effective as of the effective date for the terms and conditions of this\nAgreement as shown on ActiveState’s Website (the “Change Effective Date”). Your continued use of the Software\nafter the Change Effective Date constitutes Your acceptance of such changes. This Agreement may not be\notherwise amended without ActiveState\'s prior written agreement. You agree to periodically review the terms and\nconditions of this Agreement as updated from time to time on ActiveState’s website.\n')
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('16.')
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$b,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('ARBITRATION.')
								])),
							$elm$html$Html$text('\nExcept for actions to protect intellectual property rights and to enforce an arbitrator\'s decision\nhereunder, all disputes, controversies, or claims arising out of or relating to this Agreement or a breach thereof\nwill be submitted to and be finally resolved by arbitration under the rules of the American Arbitration\nAssociation ("AAA") then in effect. There will be one arbitrator, and such arbitrator will be chosen by\nmutual agreement of the parties in accordance with AAA rules. The arbitration will take place in\nVancouver, BC, Canada, and may be conducted by telephone or online. The arbitrator will apply the\nlaws of the Province of British Columbia, Canada to all issues in dispute. The controversy or claim will\nbe arbitrated on an individual basis and will not be consolidated in any arbitration with any claim or\ncontroversy of any other party. The findings of the arbitrator will be final and binding on the parties and\nmay be entered in any court of competent jurisdiction for enforcement. Enforcements of any award or\njudgment will be governed by the United Nations Convention on the Recognition and Enforcement of\nForeign Arbitral Awards. Should either party file an action contrary to this provision, the other party\nmay recover legal fees and costs up to $1,000.00.\n')
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('17.')
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$b,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('JURISDICTION AND VENUE.')
								])),
							$elm$html$Html$text('\nThe superior courts of Vancouver in the Province of British Columbia, Canada\nwill be the exclusive jurisdiction and venue for all legal proceedings that are not arbitrated under this Agreement.\n')
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('18.')
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$b,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('FORCE MAJEURE.')
								])),
							$elm$html$Html$text('\nNeither party will be liable for damages for any delay or failure of delivery arising out of\ncauses beyond their reasonable control and without their fault or negligence, including, but not limited to, Acts of\nGod, acts of civil or military authority, fires, riots, wars, embargoes, Internet disruptions, hacker attacks, or\ncommunications failures. Notwithstanding anything to the contrary contained herein, if either party is unable to\nperform hereunder for a period of thirty (30) consecutive days, then the other party may terminate this Agreement\nimmediately without liability by ten (10) days’ written notice to the other.\n')
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent0')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('19. ')
						])),
					A2(
					$elm$html$Html$b,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('PUBLICITY AND AUDIT RIGHTS')
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('19.1')
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('\nYou grant ActiveState the right to include Your name, trade name, trademark, service mark or logo in its\nSoftware promotional material. You may retract this grant at any time in writing to\n'),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('mailto:marcom@activestate.com')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('marcom@activestate.com')
								])),
							$elm$html$Html$text(', requesting Your name, trade name, trademark, service mark or logo be excluded\nfrom future releases of ActiveState Software promotional material. Requests cannot be complied with\nretroactively and may require up to thirty (30) days to process.\n')
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('indent1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('19.2')
						])),
					$elm$html$Html$text('\nIf You entered into this Agreement on behalf of a Person, where such Person has more than 100 employees,\nif requested by ActiveState, You will furnish ActiveState with a signed certification (i) verifying that the\nSoftware is being used pursuant to the terms of this Agreement, including any user limitations and (ii)\nlisting the total number of Nodes where the Software is being used (segregated between workstations or\nservers), the version(s) of the Software being used, for how long the Software has been used, and a general\ndescription of the use cases involved. You agree to grant ActiveState reasonable access to Your site(s)\nand/or systems, upon prior notice during normal business hours, to audit the use of the Software. Any such\naudit shall be at ActiveState’s expense.\n')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('20.')
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$b,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('ASSIGNMENT.')
								])),
							$elm$html$Html$text('\nExcept as expressly provided herein, neither this Agreement nor any rights granted hereunder,\nnor the use of any of the Software may be assigned, or otherwise transferred, in whole or in part, by You, without\nthe prior written consent of ActiveState. Any permitted assignment by You under this Section will be conditional\nupon You delivering all copies of the Software to the transferee along with a copy of this Agreement, the transferee\naccepting the terms and conditions of this Agreement, and Your license to the Software terminating upon transfer.\nAny attempted assignment by You will be void and of no effect unless permitted by the foregoing. You\nacknowledge and agree that ActiveState may assign this Agreement to any third party without Your prior consent.\nThis Agreement will be enforceable by the parties’ permitted successors and assigns.\n')
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('21.')
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$b,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('GOVERNING LAW.')
								])),
							$elm$html$Html$text('\nThis Agreement will be construed under the laws of the Province of British Columbia and\nthe federal laws of Canada applicable therein, without regard to the conflict of law rules. The application of the\nUnited Nations Convention of Contracts for the International Sale of Goods and any local implementations thereof\nare expressly excluded. The parties agree that the Uniform Computer Transactions Act or any version thereof,\nadopted by any jurisdiction, in any form ("UCITA"), will not apply to this Agreement, and to the extent that\nUCITA may be applicable, the parties agree to opt out of the applicability of UCITA pursuant to the opt-out\nprovision(s) contained therein.\n')
						]))
				])),
			A2(
			$elm$html$Html$h2,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('exhibit')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('EXHIBIT A'),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					$elm$html$Html$text('TCL/TK LICENSE TERMS')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('\nThis software is copyrighted by the Regents of the University of California, Sun Microsystems, Inc., Scriptics\nCorporation, and other parties. The following terms apply to all files associated with the software unless explicitly\ndisclaimed in individual files.\n')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('\nThe authors hereby grant permission to use, copy, modify, distribute, and license this software and its documentation\nfor any purpose, provided that existing copyright notices are retained in all copies and that this notice is included\nverbatim in any distributions. No written agreement, license, or royalty fee is required for any of the authorized uses.\nModifications to this software may be copyrighted by their authors and need not follow the licensing terms described\nhere, provided that the new terms are clearly indicated on the first page of each file where they apply.\n')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('\nIN NO EVENT SHALL THE AUTHORS OR DISTRIBUTORS BE LIABLE TO ANY PARTY FOR DIRECT,\nINDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE USE OF\nTHIS SOFTWARE, ITS DOCUMENTATION, OR ANY DERIVATIVES THEREOF, EVEN IF THE AUTHORS\nHAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.\n')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('\nTHE AUTHORS AND DISTRIBUTORS SPECIFICALLY DISCLAIM ANY WARRANTIES, INCLUDING, BUT\nNOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR\nPURPOSE, AND NON-INFRINGEMENT. THIS SOFTWARE IS PROVIDED ON AN "AS IS" BASIS, AND THE\nAUTHORS AND DISTRIBUTORS HAVE NO OBLIGATION TO PROVIDE MAINTENANCE, SUPPORT,\nUPDATES, ENHANCEMENTS, OR MODIFICATIONS.\n')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('\nGOVERNMENT USE: If you are acquiring this software on behalf of the U.S. government, the Government shall\nhave only "Restricted Rights" in the software and related documentation as defined in the Federal Acquisition\nRegulations (FARs) in Clause 52.227.19 (c) (2). If you are acquiring the software on behalf of the Department of\nDefense, the software shall be classified as "Commercial Computer Software" and the Government shall have only\n"Restricted Rights" as defined in Clause 252.227-7013 (c) (1) of DFARs. Notwithstanding the foregoing, the authors\ngrant the U.S. Government and others acting in its behalf permission to use and distribute the software in accordance\nwith the terms specified in this license.\n')
				]))
		]);
};
var $author$project$Pages$SupplementalLicenseTerms$view = function (model) {
	return $author$project$Views$Columns$asHtml(
		A2(
			$author$project$Views$Columns$withColumn,
			$author$project$Pages$SupplementalLicenseTerms$newSupplementalLicenseTermsText(model),
			A2(
				$author$project$Views$Columns$withColumnAs,
				$elm$html$Html$section,
				$author$project$Views$Columns$asColumns($elm$html$Html$main_))));
};
var $author$project$Pages$Support$OpenHubSpotChat = 0;
var $author$project$Model$Session$getHubSpotChatLoaded = function (_v0) {
	var session = _v0;
	return session.t3;
};
var $author$project$Pages$Support$genericTooltip = function (content) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('support-tooltip-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('support-tooltip')
					]),
				content)
			]));
};
var $author$project$Pages$Support$viewChatUnavailableTooltip = $author$project$Pages$Support$genericTooltip(
	_List_fromArray(
		[
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Chat is supposed to be enabled for your account, but it doesn\'t seem to have loaded.')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('In case you are using an adblocker, please try disabling it and reload the page.')
				]))
		]));
var $author$project$Pages$Support$plansAndPricingLink = A2(
	$elm$html$Html$a,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$href(
			$author$project$Url$Extra$pricing(_List_Nil)),
			$elm$html$Html$Attributes$target('_blank')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('See Plans & Pricing')
		]));
var $author$project$Pages$Support$viewPaidOnlyToolTip = function (supportName) {
	return $author$project$Pages$Support$genericTooltip(
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(supportName + ' is only available on paid accounts.')
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[$author$project$Pages$Support$plansAndPricingLink]))
			]));
};
var $author$project$Pages$Support$viewContactButton = function (tier) {
	switch (tier.$) {
		case 0:
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('primary-button disabled-button')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Email Us')
						])),
					$author$project$Pages$Support$viewPaidOnlyToolTip('Email support')
				]);
		case 8:
			return _List_fromArray(
				[
					$elm$html$Html$text('')
				]);
		default:
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('mailto:support@activestate.com'),
							$elm$html$Html$Attributes$target('_blank')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('support@activestate.com')
						]))
				]);
	}
};
var $author$project$Pages$Support$viewEnterpriseOnlyToolTip = function (supportName) {
	return $author$project$Pages$Support$genericTooltip(
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(supportName + ' support is only available on the Enterprise tier.')
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[$author$project$Pages$Support$plansAndPricingLink]))
			]));
};
var $author$project$Pages$Support$view = F2(
	function (model, session) {
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('page support-page')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('columns equal-width free-support')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('column')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('support-box')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h2,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('support-documentation')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('CLI Command Cheat Sheet')
												])),
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Reference our handy guide with all the most important State Tool CLI commands to get you started with your ActiveState runtime.')
												])),
											A3(
											$author$project$Views$Link$link,
											$author$project$Model$Route$StateToolCheatSheet,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$target('_blank')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Common CLI Commands')
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('column')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('support-box')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h2,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('support-documentation')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Documentation')
												])),
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Check out our documentation to learn more about our platform and how to use the State Tool to interact with our platform from your terminal.')
												])),
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$href(
													$author$project$Url$Extra$platformDocs(_List_Nil)),
													$elm$html$Html$Attributes$target('_blank')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('docs.activestate.com/platform')
												]))
										]))
								]))
						])),
					A2($elm$html$Html$hr, _List_Nil, _List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('columns equal-width')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('column')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('support-box')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h2,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Commercial Support')
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('column price-message')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('support-box')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Decrease go-to-market risk with enterprise-grade support for your mission-critical applications. With a 20+ year history of supporting organizations of all sizes, ActiveState\'s support options ensure you can address issues with open source security, stability and reliability in a timely manner. Ready to benefit from hundreds of combined years of open source language expertise? '),
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$target('_blank'),
															$elm$html$Html$Attributes$href(
															$author$project$Url$Extra$pricing(_List_Nil))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Subscribe')
														])),
													$elm$html$Html$text(' to gain SLA-backed chat, email and phone support with a two-hour response time during support hours for critical issues.')
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('columns equal-width')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('column')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('support-card chat-support')
										]),
									_List_fromArray(
										[
											$author$project$Views$Icon$view(
											$author$project$Views$Icon$icon(8)),
											A2(
											$elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Chat With Us')
												])),
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Use our live chat feature to ask our support team questions.')
												])),
											function () {
											var _v0 = model.yv;
											if (!_v0.$) {
												return A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('support-container')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('primary-button disabled-button')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Start a Chat')
																])),
															$author$project$Pages$Support$viewPaidOnlyToolTip('Chat support')
														]));
											} else {
												return A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('support-container')
														]),
													_List_fromArray(
														[
															$author$project$Model$Session$getHubSpotChatLoaded(session) ? A2(
															$elm$html$Html$button,
															_List_fromArray(
																[
																	$elm$html$Html$Events$onClick(0),
																	$elm$html$Html$Attributes$class('primary-button')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Open Chat')
																])) : A2(
															$elm$html$Html$div,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$button,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('primary-button disabled-button')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Open Chat')
																		])),
																	$author$project$Pages$Support$viewChatUnavailableTooltip
																]))
														]));
											}
										}()
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('column')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('support-card email-support')
										]),
									_List_fromArray(
										[
											$author$project$Views$Icon$view(
											$author$project$Views$Icon$icon(23)),
											A2(
											$elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Email Us')
												])),
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Send us an email and we\'ll respond within one business day.')
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('support-container')
												]),
											$author$project$Pages$Support$viewContactButton(model.yv))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('column')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('support-card phone-support')
										]),
									_List_fromArray(
										[
											$author$project$Views$Icon$view(
											$author$project$Views$Icon$icon(6)),
											A2(
											$elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Call Us')
												])),
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Call our support team to get your questions answered over the phone.')
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('support-container')
												]),
											function () {
												var _v1 = model.yv;
												switch (_v1.$) {
													case 5:
														return _List_fromArray(
															[
																A2(
																$elm$html$Html$a,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('text-link'),
																		$elm$html$Html$Attributes$href('tel:17787861102'),
																		$elm$html$Html$Attributes$target('_blank')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('1-778-786-1102')
																	])),
																A2(
																$elm$html$Html$p,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('phone-text')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(' 9am-5pm PST')
																	]))
															]);
													case 6:
														return _List_fromArray(
															[
																A2(
																$elm$html$Html$a,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('text-link'),
																		$elm$html$Html$Attributes$href('tel:17787861102'),
																		$elm$html$Html$Attributes$target('_blank')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('1-778-786-1102')
																	])),
																A2(
																$elm$html$Html$p,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('phone-text')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(' 9am-5pm PST')
																	]))
															]);
													default:
														return _List_fromArray(
															[
																A2(
																$elm$html$Html$span,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('primary-button disabled-button')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Call Us')
																	])),
																$author$project$Pages$Support$viewEnterpriseOnlyToolTip('Phone'),
																A2(
																$elm$html$Html$p,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('phone-text')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(' 9am-5pm PST')
																	]))
															]);
												}
											}())
										]))
								]))
						]))
				]));
	});
var $author$project$Main$pageView = F2(
	function (mainModel, page) {
		var session = mainModel.l;
		var pageState = mainModel.u;
		var modals = {v9: true, hS: mainModel.hS, hT: mainModel.hT};
		switch (page.$) {
			case 0:
				return $author$project$Pages$Loading$view;
			case 1:
				var model = page.a;
				return A8(
					$author$project$Views$Layout$plainLayout,
					modals,
					'',
					$author$project$Pages$NotFound$pageHeading,
					$author$project$Pages$NotFound$pageSubHeading,
					true,
					A2(
						$elm$html$Html$map,
						$author$project$Msg$NotFoundMsg,
						$author$project$Pages$NotFound$view(model)),
					session,
					pageState);
			case 2:
				var model = page.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Msg$LoginMsg,
					A2($author$project$Pages$Login$view, model, session));
			case 8:
				var model = page.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Msg$ForgotPasswordMsg,
					$author$project$Pages$ForgotPassword$view(model));
			case 9:
				var model = page.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Msg$ConnectAccountMsg,
					A2($author$project$Pages$ConnectAccount$view, session, model));
			case 10:
				var model = page.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Msg$ResetPasswordMsg,
					$author$project$Pages$ResetPassword$view(model));
			case 7:
				var model = page.a;
				return model.D6 ? $author$project$Pages$Loading$view : A8(
					$author$project$Views$Layout$plainLayout,
					modals,
					'',
					'Check your email!',
					'',
					true,
					A2(
						$elm$html$Html$map,
						$author$project$Msg$CheckEmailMsg,
						A2($author$project$Pages$CheckEmail$view, session, model)),
					session,
					pageState);
			case 5:
				var err = page.a;
				return $author$project$Pages$Error$view(
					$author$project$Model$Message$reason(err));
			case 6:
				var model = page.a;
				return A8(
					$author$project$Views$Layout$plainLayout,
					modals,
					'',
					'You\'ve been invited!',
					'',
					true,
					A2(
						$elm$html$Html$map,
						$author$project$Msg$ActivateMembershipMsg,
						A2($author$project$Pages$ActivateMembership$view, session, model)),
					session,
					pageState);
			case 3:
				var model = page.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Msg$CreateAccountMsg,
					A2($author$project$Pages$CreateAccount$view, model, session));
			case 4:
				var model = page.a;
				return A8(
					$author$project$Views$Layout$plainLayout,
					modals,
					'',
					$author$project$Pages$CreateOrganization$pageHeading,
					'',
					true,
					A2(
						$elm$html$Html$map,
						$author$project$Msg$CreateOrganizationMsg,
						A2($author$project$Pages$CreateOrganization$view, model, session)),
					session,
					pageState);
			case 11:
				var model = page.a;
				return A4(
					$author$project$Views$Layout$preferenceLayout,
					modals,
					A2(
						$elm$html$Html$map,
						$author$project$Msg$PreferenceTwoFactorMsg,
						A2($author$project$Pages$PreferenceTwoFactor$view, session, model)),
					session,
					pageState);
			case 12:
				var model = page.a;
				return A4(
					$author$project$Views$Layout$preferenceLayout,
					modals,
					A2(
						$elm$html$Html$map,
						$author$project$Msg$PreferenceEmailMsg,
						A2($author$project$Pages$PreferenceEmail$view, model, session)),
					session,
					pageState);
			case 13:
				var model = page.a;
				return A4(
					$author$project$Views$Layout$preferenceLayout,
					modals,
					A2(
						$elm$html$Html$map,
						$author$project$Msg$PreferencePasswordMsg,
						A2($author$project$Pages$PreferencePassword$view, model, session)),
					session,
					pageState);
			case 14:
				var model = page.a;
				return A4(
					$author$project$Views$Layout$preferenceLayout,
					modals,
					A2(
						$elm$html$Html$map,
						$author$project$Msg$PreferenceLinkedAccountsMsg,
						A2($author$project$Pages$PreferenceLinkedAccounts$view, model, session)),
					session,
					pageState);
			case 15:
				var model = page.a;
				return A4(
					$author$project$Views$Layout$preferenceLayout,
					modals,
					A2(
						$elm$html$Html$map,
						$author$project$Msg$PreferenceDeleteAccountMsg,
						$author$project$Pages$PreferenceDeleteAccount$view(model)),
					session,
					pageState);
			case 16:
				var model = page.a;
				var members = $author$project$Pages$OrgIndex$getMembers(model);
				return A5(
					$author$project$Views$Layout$orgLayout,
					{
						cF: mainModel.cF,
						jb: $author$project$Model$Session$getInvitations(session),
						hB: members,
						fd: modals,
						c3: $author$project$Pages$OrgIndex$getOrganization(model)
					},
					$author$project$Pages$OrgIndex$getPageClass(model),
					A2(
						$elm$html$Html$map,
						$author$project$Msg$OrgIndexMsg,
						A3($author$project$Pages$OrgIndex$view, model, session, mainModel.cF)),
					session,
					pageState);
			case 17:
				var model = page.a;
				return A5(
					$author$project$Views$Layout$orgsLayout,
					modals,
					$author$project$Pages$Orgs$getPageClass(model),
					A2(
						$elm$html$Html$map,
						$author$project$Msg$OrgsMsg,
						A3($author$project$Pages$Orgs$view, model, session, mainModel.cF)),
					session,
					pageState);
			case 19:
				var model = page.a;
				var organization = $author$project$Pages$OrgMembers$getOrganization(model);
				return A5(
					$author$project$Views$Layout$orgLayout,
					{
						cF: mainModel.cF,
						jb: $author$project$Model$Session$getInvitations(session),
						hB: $author$project$Pages$OrgMembers$getMembers(model),
						fd: modals,
						c3: organization
					},
					'',
					A2(
						$elm$html$Html$map,
						$author$project$Msg$OrgMembersMsg,
						A2($author$project$Pages$OrgMembers$view, model, session)),
					session,
					pageState);
			case 20:
				var model = page.a;
				var organization = $author$project$Pages$OrgSettings$organization(model);
				return A5(
					$author$project$Views$Layout$orgLayout,
					{
						cF: mainModel.cF,
						jb: $author$project$Model$Session$getInvitations(session),
						hB: $author$project$Pages$OrgSettings$members(model),
						fd: modals,
						c3: organization
					},
					'',
					A2(
						$elm$html$Html$map,
						$author$project$Msg$OrgSettingsMsg,
						A2($author$project$Pages$OrgSettings$view, model, session)),
					session,
					pageState);
			case 21:
				var model = page.a;
				var organization = $author$project$Pages$OrgScan$organization(model);
				return A5(
					$author$project$Views$Layout$orgLayout,
					{
						cF: mainModel.cF,
						jb: $author$project$Model$Session$getInvitations(session),
						hB: $author$project$Pages$OrgScan$members(model),
						fd: modals,
						c3: organization
					},
					'',
					A2(
						$elm$html$Html$map,
						$author$project$Msg$OrgScanMsg,
						A2($author$project$Pages$OrgScan$view, model, session)),
					session,
					pageState);
			case 22:
				var model = page.a;
				return A5(
					$author$project$Views$Layout$orgLayout,
					{
						cF: mainModel.cF,
						jb: $author$project$Model$Session$getInvitations(session),
						hB: model.hB,
						fd: modals,
						c3: model.c3
					},
					'',
					A2(
						$elm$html$Html$map,
						$author$project$Msg$OrgDependenciesMsg,
						$author$project$Pages$OrgDependencies$view(model)),
					session,
					pageState);
			case 18:
				var model = page.a;
				return A5(
					$author$project$Views$Layout$orgLayout,
					{
						cF: mainModel.cF,
						jb: $author$project$Model$Session$getInvitations(session),
						hB: model.hB,
						fd: modals,
						c3: model.c3
					},
					'',
					A2(
						$elm$html$Html$map,
						$author$project$Msg$OrgSecurityMsg,
						$author$project$Pages$OrgSecurity$view(model)),
					session,
					pageState);
			case 23:
				var model = page.a;
				return A5(
					$author$project$Views$Layout$orgLayout,
					{
						cF: mainModel.cF,
						jb: $author$project$Model$Session$getInvitations(session),
						hB: $author$project$Pages$OrgPolicy$members(model),
						fd: modals,
						c3: $author$project$Pages$OrgPolicy$organization(model)
					},
					'',
					A2(
						$elm$html$Html$map,
						$author$project$Msg$OrgPolicyMsg,
						A2($author$project$Pages$OrgPolicy$view, model, session)),
					session,
					pageState);
			case 24:
				var model = page.a;
				return A5(
					$author$project$Views$Layout$orgLayout,
					{
						cF: mainModel.cF,
						jb: $author$project$Model$Session$getInvitations(session),
						hB: $author$project$Pages$OrgRemediation$getMembers(model),
						fd: modals,
						c3: $author$project$Pages$OrgRemediation$getOrganization(model)
					},
					'',
					A2(
						$elm$html$Html$map,
						$author$project$Msg$OrgRemediationMsg,
						A2($author$project$Pages$OrgRemediation$view, model, session)),
					session,
					pageState);
			case 25:
				var model = page.a;
				var organization = $author$project$Pages$ProjectConfig$getOrganization(model);
				return A4(
					$author$project$Views$Layout$projectLayout,
					{
						fO: $author$project$Pages$ProjectConfig$getMaybeBranchName(model),
						gr: $author$project$Pages$ProjectConfig$getMaybeCommitID(model),
						fd: modals,
						c3: organization,
						c5: $author$project$Pages$ProjectConfig$getProject(model)
					},
					A2(
						$elm$html$Html$map,
						$author$project$Msg$ProjectConfigMsg,
						A2($author$project$Pages$ProjectConfigHtml$view, model, session)),
					session,
					pageState);
			case 26:
				var model = page.a;
				var organization = $author$project$Pages$ProjectConfigAdvanced$getOrganization(model);
				return A4(
					$author$project$Views$Layout$projectLayout,
					{
						fO: $author$project$Pages$ProjectConfigAdvanced$getMaybeBranchName(model),
						gr: $author$project$Pages$ProjectConfigAdvanced$getMaybeCommitID(model),
						fd: modals,
						c3: organization,
						c5: $author$project$Pages$ProjectConfigAdvanced$getProject(model)
					},
					A2(
						$elm$html$Html$map,
						$author$project$Msg$ProjectConfigAdvancedMsg,
						A2($author$project$Pages$ProjectConfigAdvanced$view, model, session)),
					session,
					pageState);
			case 27:
				var model = page.a;
				return A4(
					$author$project$Views$Layout$projectLayout,
					{fO: model.Bi, gr: $elm$core$Maybe$Nothing, fd: modals, c3: model.c3, c5: model.c5},
					A2(
						$elm$html$Html$map,
						$author$project$Msg$ProjectOverviewMsg,
						A3($author$project$Pages$ProjectOverview$view, model, session, mainModel.cF)),
					session,
					pageState);
			case 28:
				var model = page.a;
				return A4(
					$author$project$Views$Layout$projectLayout,
					{
						fO: $author$project$Pages$ProjectDownloads$getMaybeBranchName(model),
						gr: $author$project$Pages$ProjectDownloads$getMaybeCommitID(model),
						fd: modals,
						c3: model.c3,
						c5: model.c5
					},
					A2(
						$elm$html$Html$map,
						$author$project$Msg$ProjectDownloadsMsg,
						A2($author$project$Pages$ProjectDownloads$view, model, session)),
					session,
					pageState);
			case 29:
				var model = page.a;
				return A4(
					$author$project$Views$Layout$projectLayout,
					{
						fO: $author$project$Pages$ProjectHistory$getMaybeBranchName(model),
						gr: $elm$core$Maybe$Just(
							$author$project$Pages$ProjectHistory$getCommitID(model)),
						fd: modals,
						c3: model.c3,
						c5: model.c5
					},
					A2(
						$elm$html$Html$map,
						$author$project$Msg$ProjectHistoryMsg,
						A2($author$project$Pages$ProjectHistory$view, model, session)),
					session,
					pageState);
			case 30:
				var model = page.a;
				return A4(
					$author$project$Views$Layout$projectLayout,
					{
						fO: $elm$core$Maybe$Nothing,
						gr: $author$project$Pages$ProjectImpactReport$getMaybeOldCommitID(model),
						fd: modals,
						c3: model.c3,
						c5: model.c5
					},
					A2(
						$elm$html$Html$map,
						$author$project$Msg$ProjectImpactReportMsg,
						A2($author$project$Pages$ProjectImpactReport$view, model, session)),
					session,
					pageState);
			case 31:
				var model = page.a;
				var organization = $author$project$Pages$ProjectSettings$organization(model);
				return A4(
					$author$project$Views$Layout$projectLayout,
					{
						fO: $author$project$Model$Route$getMaybeBranchName(
							$author$project$PageState$getCurrentRoute(pageState)),
						gr: $elm$core$Maybe$Nothing,
						fd: modals,
						c3: organization,
						c5: $author$project$Pages$ProjectSettings$getProject(model)
					},
					A2(
						$elm$html$Html$map,
						$author$project$Msg$ProjectSettingsMsg,
						A2($author$project$Pages$ProjectSettings$view, model, session)),
					session,
					pageState);
			case 32:
				var model = page.a;
				var organization = $author$project$Pages$ProjectSettingsHAR$getOrganization(model);
				return A4(
					$author$project$Views$Layout$projectLayout,
					{
						fO: $author$project$Model$Route$getMaybeBranchName(
							$author$project$PageState$getCurrentRoute(pageState)),
						gr: $author$project$Pages$ProjectSettingsHAR$getMaybeCommitID(model),
						fd: modals,
						c3: organization,
						c5: $author$project$Pages$ProjectSettingsHAR$getProject(model)
					},
					A2(
						$elm$html$Html$map,
						$author$project$Msg$ProjectSettingsHARMsg,
						A2($author$project$Pages$ProjectSettingsHAR$view, model, session)),
					session,
					pageState);
			case 33:
				var model = page.a;
				var organization = $author$project$Pages$ProjectSettingsBranches$getOrganization(model);
				return A4(
					$author$project$Views$Layout$projectLayout,
					{
						fO: $author$project$Model$Route$getMaybeBranchName(
							$author$project$PageState$getCurrentRoute(pageState)),
						gr: $elm$core$Maybe$Nothing,
						fd: modals,
						c3: organization,
						c5: $author$project$Pages$ProjectSettingsBranches$getProject(model)
					},
					A2(
						$elm$html$Html$map,
						$author$project$Msg$ProjectSettingsBranchesMsg,
						A2($author$project$Pages$ProjectSettingsBranches$view, model, session)),
					session,
					pageState);
			case 34:
				var model = page.a;
				return A4(
					$author$project$Views$Layout$leanLayout,
					'supplemental-license-terms-page',
					A2(
						$elm$html$Html$map,
						$author$project$Msg$SupplementalLicenseTermsMsg,
						$author$project$Pages$SupplementalLicenseTerms$view(model)),
					session,
					pageState);
			case 35:
				var model = page.a;
				return A3(
					$author$project$Views$Layout$adminLayout,
					A2(
						$elm$html$Html$map,
						$author$project$Msg$AdminIconomiconMsg,
						A2($author$project$Pages$AdminIconomicon$view, model, session)),
					session,
					pageState);
			case 36:
				var model = page.a;
				return A3(
					$author$project$Views$Layout$adminLayout,
					A2(
						$elm$html$Html$map,
						$author$project$Msg$AdminOrganizationsMsg,
						A2($author$project$Pages$AdminOrganizations$view, model, session)),
					session,
					pageState);
			case 37:
				var model = page.a;
				return A3(
					$author$project$Views$Layout$adminLayout,
					A2(
						$elm$html$Html$map,
						$author$project$Msg$AdminOrganizationMsg,
						A2($author$project$Pages$AdminOrganization$view, model, session)),
					session,
					pageState);
			case 38:
				var model = page.a;
				return A3(
					$author$project$Views$Layout$adminLayout,
					A2(
						$elm$html$Html$map,
						$author$project$Msg$AdminUsersMsg,
						A2($author$project$Pages$AdminUsers$view, model, session)),
					session,
					pageState);
			case 39:
				var model = page.a;
				return A3(
					$author$project$Views$Layout$adminLayout,
					A2(
						$elm$html$Html$map,
						$author$project$Msg$AdminUserMsg,
						A2($author$project$Pages$AdminUser$view, model, session)),
					session,
					pageState);
			case 41:
				var model = page.a;
				return A3(
					$author$project$Views$Layout$adminLayout,
					A2(
						$elm$html$Html$map,
						$author$project$Msg$AdminCreateOrganizationMsg,
						A2($author$project$Pages$AdminCreateOrganization$view, model, session)),
					session,
					pageState);
			case 40:
				var model = page.a;
				return A3(
					$author$project$Views$Layout$adminLayout,
					A2(
						$elm$html$Html$map,
						$author$project$Msg$AdminFeaturesMsg,
						A2($author$project$Pages$AdminFeatures$view, model, session)),
					session,
					pageState);
			case 42:
				var model = page.a;
				return A8(
					$author$project$Views$Layout$plainLayout,
					modals,
					'',
					$author$project$Pages$PublicProjects$pageHeading,
					$author$project$Pages$PublicProjects$pageSubHeading,
					true,
					A2($author$project$Pages$PublicProjects$view, model, session),
					session,
					pageState);
			case 43:
				var model = page.a;
				return A8(
					$author$project$Views$Layout$plainLayout,
					modals,
					'',
					$author$project$Pages$Support$pageHeading,
					$author$project$Pages$Support$pageSubHeading,
					true,
					A2(
						$elm$html$Html$map,
						$author$project$Msg$SupportMsg,
						A2($author$project$Pages$Support$view, model, session)),
					session,
					pageState);
			case 44:
				var model = page.a;
				return A8(
					$author$project$Views$Layout$plainLayout,
					modals,
					'',
					$author$project$Pages$StateToolCheatSheet$pageHeading,
					$author$project$Pages$StateToolCheatSheet$pageSubHeading,
					true,
					A2(
						$elm$html$Html$map,
						$author$project$Msg$StateToolCheatSheetMsg,
						A2($author$project$Pages$StateToolCheatSheet$view, model, session)),
					session,
					pageState);
			case 45:
				var model = page.a;
				return A7(
					$author$project$Views$Layout$plainLayoutCustomHeader,
					modals,
					A2($author$project$Pages$CreateProject$getPageClass, model, session),
					A2($author$project$Pages$CreateProject$headerContent, session, model),
					true,
					A2(
						$elm$html$Html$map,
						$author$project$Msg$CreateProjectMsg,
						A2($author$project$Pages$CreateProject$view, model, session)),
					session,
					pageState);
			case 46:
				var model = page.a;
				return A7(
					$author$project$Views$Layout$plainLayoutCustomHeader,
					modals,
					'',
					$author$project$Pages$ImportProject$headerContent,
					true,
					A2(
						$elm$html$Html$map,
						$author$project$Msg$ImportProjectMsg,
						A2($author$project$Pages$ImportProject$view, model, session)),
					session,
					pageState);
			case 47:
				var model = page.a;
				return A8(
					$author$project$Views$Layout$plainLayout,
					modals,
					'',
					$author$project$Pages$ForkProject$pageHeading(model),
					$author$project$Pages$ForkProject$pageSubHeading,
					true,
					A2(
						$elm$html$Html$map,
						$author$project$Msg$ForkProjectMsg,
						A2($author$project$Pages$ForkProject$view, session, model)),
					session,
					pageState);
			case 48:
				var model = page.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Msg$AutoForkMsg,
					$author$project$Pages$AutoFork$view(model));
			case 49:
				var model = page.a;
				return A8(
					$author$project$Views$Layout$plainLayout,
					modals,
					'superuser-fork-page',
					$author$project$Pages$AdminFork$pageHeading(model),
					$author$project$Pages$AdminFork$pageSubHeading,
					true,
					A2(
						$elm$html$Html$map,
						$author$project$Msg$AdminForkMsg,
						$author$project$Pages$AdminFork$view(model)),
					session,
					pageState);
			case 50:
				var model = page.a;
				var layout = function () {
					var _v1 = $author$project$Pages$Checkout$getBillingDetailsHeading(model);
					if (!_v1.$) {
						var heading = _v1.a;
						return A4($author$project$Views$Layout$plainLayout, modals, $author$project$Pages$Checkout$pageClass, heading, '');
					} else {
						return A2($author$project$Views$Layout$plainLayoutNoHeader, modals, $author$project$Pages$Checkout$pageClass);
					}
				}();
				return A4(
					layout,
					$author$project$Pages$Checkout$showVerifyEmailBanner(model),
					A2(
						$elm$html$Html$map,
						$author$project$Msg$CheckoutMsg,
						A2($author$project$Pages$Checkout$view, session, model)),
					session,
					pageState);
			case 51:
				var model = page.a;
				return A8(
					$author$project$Views$Layout$plainLayout,
					{v9: false, hS: mainModel.hS, hT: mainModel.hT},
					'project-preview-page',
					model.Fs,
					'Custom Runtime Preview',
					true,
					A2($author$project$Pages$ProjectPreview$view, session, model),
					session,
					pageState);
			case 52:
				return $author$project$Pages$CreateProjectFromCommit$view;
			case 53:
				var model = page.a;
				return A4(
					$author$project$Views$Layout$leanLayout,
					'auth-page',
					A2(
						$elm$html$Html$map,
						$author$project$Msg$AuthorizeDeviceMsg,
						A3($author$project$Pages$AuthorizeDevice$view, model, session, mainModel.cF)),
					session,
					pageState);
			case 54:
				var model = page.a;
				return $author$project$Pages$OutOfCompliance$view(model);
			default:
				var model = page.a;
				return A6(
					$author$project$Views$Layout$plainLayoutNoHeader,
					{v9: false, hS: $elm$core$Maybe$Nothing, hT: $elm$core$Maybe$Nothing},
					'finish-setup-page',
					false,
					A2(
						$elm$html$Html$map,
						$author$project$Msg$FinishSetupMsg,
						A2($author$project$Pages$FinishSetup$view, model, session)),
					session,
					pageState);
		}
	});
var $author$project$Main$view = function (model) {
	return {
		sY: _List_fromArray(
			[
				A2(
				$author$project$Main$pageView,
				model,
				$author$project$PageState$getPage(model.u))
			]),
		Gy: $author$project$Model$Route$pageHeading(
			$author$project$PageState$getNextRoute(model.u))
	};
};
var $author$project$Main$main = $elm$browser$Browser$application(
	{
		CY: $author$project$Main$init,
		EQ: A2($elm$core$Basics$composeR, $author$project$Routing$parseLocation, $author$project$Msg$SetRoute),
		ER: $author$project$Msg$LinkClicked,
		Gl: $author$project$Main$subscriptions,
		GR: $author$project$Main$update,
		G4: $author$project$Main$view
	});
_Platform_export({'Main':{'init':$author$project$Main$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (rollbarToken) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (rollbarEnv) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (platform) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (currentDomain) {
									return $elm$json$Json$Decode$succeed(
										{B3: currentDomain, po: platform, zU: rollbarEnv, FP: rollbarToken});
								},
								A2($elm$json$Json$Decode$field, 'currentDomain', $elm$json$Json$Decode$string));
						},
						A2($elm$json$Json$Decode$field, 'platform', $elm$json$Json$Decode$string));
				},
				A2($elm$json$Json$Decode$field, 'rollbarEnv', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'rollbarToken', $elm$json$Json$Decode$string)))(0)}});}(this));